var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/uds/glyphs.ts
var glyphs_exports = {};
__export(glyphs_exports, {
  Ai: () => Ai,
  AirplaneTakingOff: () => AirplaneTakingOff,
  AirplaneToRightTop: () => AirplaneToRightTop,
  AirplaneToTop: () => AirplaneToTop,
  AirplaneWithArrowsCirclePath: () => AirplaneWithArrowsCirclePath,
  AppartmentBuilding: () => AppartmentBuilding,
  ArrowUpFromLine: () => ArrowUpFromLine,
  ArrowsCirclePath: () => ArrowsCirclePath,
  ArrowsSquarePath: () => ArrowsSquarePath,
  Baby: () => Baby,
  Bed: () => Bed,
  Bike: () => Bike,
  BusFront: () => BusFront,
  BusRight: () => BusRight,
  Cake: () => Cake,
  Calendar: () => Calendar,
  CarDoor: () => CarDoor,
  CarRight: () => CarRight,
  CheckMark: () => CheckMark,
  CheckMarkExtraSmall: () => CheckMarkExtraSmall,
  CheckMarkInCircle: () => CheckMarkInCircle,
  CheckMarkSmall: () => CheckMarkSmall,
  ChevronDoubleSmall: () => ChevronDoubleSmall,
  ChevronDown: () => ChevronDown,
  ChevronDownExtraSmall: () => ChevronDownExtraSmall,
  ChevronLeft: () => ChevronLeft,
  ChevronLeftExtraSmall: () => ChevronLeftExtraSmall,
  ChevronRight: () => ChevronRight,
  ChevronRightExtraSmall: () => ChevronRightExtraSmall,
  ChevronUp: () => ChevronUp,
  ChevronUpExtraSmall: () => ChevronUpExtraSmall,
  Clock: () => Clock,
  Dismiss: () => Dismiss,
  DismissExtraSmall: () => DismissExtraSmall,
  DismissSmall: () => DismissSmall,
  DocumentPdf: () => DocumentPdf,
  DocumentWithText: () => DocumentWithText,
  Esim: () => Esim,
  ExclamationInCircle: () => ExclamationInCircle,
  ExclamationInTriangle: () => ExclamationInTriangle,
  Eye: () => Eye,
  EyeSlashed: () => EyeSlashed,
  FaceHappy: () => FaceHappy,
  Family: () => Family,
  ForkAndKnive: () => ForkAndKnive,
  GolfClub: () => GolfClub,
  Heart: () => Heart,
  HeartFilled: () => HeartFilled,
  HeartWithSmallerHeart: () => HeartWithSmallerHeart,
  House: () => House,
  Houses: () => Houses,
  ImageSlashed: () => ImageSlashed,
  InformationInCircle: () => InformationInCircle,
  Leaf: () => Leaf,
  List: () => List,
  LogoSunweb: () => LogoSunweb,
  Lotus: () => Lotus,
  Magnifier: () => Magnifier,
  ManualTransmission: () => ManualTransmission,
  Map: () => Map,
  MapPin: () => MapPin,
  Minus: () => Minus,
  MinusExtraSmall: () => MinusExtraSmall,
  ParkingSign: () => ParkingSign,
  PaymentCardWithCoins: () => PaymentCardWithCoins,
  Pencil: () => Pencil,
  Person: () => Person,
  PersonInCircle: () => PersonInCircle,
  PersonRunning: () => PersonRunning,
  PersonSkiing: () => PersonSkiing,
  PersonWithSuitcase: () => PersonWithSuitcase,
  PigBank: () => PigBank,
  Placeholder: () => Placeholder,
  Plus: () => Plus,
  PlusExtraSmall: () => PlusExtraSmall,
  QuestionMarkInCircle: () => QuestionMarkInCircle,
  ShieldWithDismiss: () => ShieldWithDismiss,
  ShieldWithLock: () => ShieldWithLock,
  ShieldWithPlus: () => ShieldWithPlus,
  SkiPass: () => SkiPass,
  Skis: () => Skis,
  Sliders: () => Sliders,
  SmallHouse: () => SmallHouse,
  Snowflake: () => Snowflake,
  SpadeSymbol: () => SpadeSymbol,
  Spinner: () => Spinner,
  StarFilled: () => StarFilled,
  StarHalfFilled: () => StarHalfFilled,
  Suitcase: () => Suitcase,
  SuitcaseOnWheels: () => SuitcaseOnWheels,
  SuitcaseOnWheelsWithCheckMark: () => SuitcaseOnWheelsWithCheckMark,
  Sweater: () => Sweater,
  TShirt: () => TShirt,
  Tag: () => Tag,
  ThreePeople: () => ThreePeople,
  Ticket: () => Ticket,
  TicketFlight: () => TicketFlight,
  TicketWithPercentage: () => TicketWithPercentage,
  TipiTent: () => TipiTent,
  TrashCan: () => TrashCan,
  TwoChildren: () => TwoChildren,
  TwoPeople: () => TwoPeople,
  Villa: () => Villa,
  World: () => World
});
import { Ai } from "@sunwebgroup/uds-icons";
import { AirplaneTakingOff } from "@sunwebgroup/uds-icons";
import { AirplaneToRightTop } from "@sunwebgroup/uds-icons";
import { AirplaneToTop } from "@sunwebgroup/uds-icons";
import { AirplaneWithArrowsCirclePath } from "@sunwebgroup/uds-icons";
import { AppartmentBuilding } from "@sunwebgroup/uds-icons";
import { ArrowUpFromLine } from "@sunwebgroup/uds-icons";
import { ArrowsCirclePath } from "@sunwebgroup/uds-icons";
import { ArrowsSquarePath } from "@sunwebgroup/uds-icons";
import { Baby } from "@sunwebgroup/uds-icons";
import { Bed } from "@sunwebgroup/uds-icons";
import { Bike } from "@sunwebgroup/uds-icons";
import { BusFront } from "@sunwebgroup/uds-icons";
import { BusRight } from "@sunwebgroup/uds-icons";
import { Cake } from "@sunwebgroup/uds-icons";
import { Calendar } from "@sunwebgroup/uds-icons";
import { CarDoor } from "@sunwebgroup/uds-icons";
import { CarRight } from "@sunwebgroup/uds-icons";
import { CheckMark } from "@sunwebgroup/uds-icons";
import { CheckMarkExtraSmall } from "@sunwebgroup/uds-icons";
import { CheckMarkInCircle } from "@sunwebgroup/uds-icons";
import { CheckMarkSmall } from "@sunwebgroup/uds-icons";
import { ChevronDoubleSmall } from "@sunwebgroup/uds-icons";
import { ChevronDown } from "@sunwebgroup/uds-icons";
import { ChevronDownExtraSmall } from "@sunwebgroup/uds-icons";
import { ChevronLeft } from "@sunwebgroup/uds-icons";
import { ChevronLeftExtraSmall } from "@sunwebgroup/uds-icons";
import { ChevronRight } from "@sunwebgroup/uds-icons";
import { ChevronRightExtraSmall } from "@sunwebgroup/uds-icons";
import { ChevronUp } from "@sunwebgroup/uds-icons";
import { ChevronUpExtraSmall } from "@sunwebgroup/uds-icons";
import { Clock } from "@sunwebgroup/uds-icons";
import { Dismiss } from "@sunwebgroup/uds-icons";
import { DismissExtraSmall } from "@sunwebgroup/uds-icons";
import { DismissSmall } from "@sunwebgroup/uds-icons";
import { DocumentPdf } from "@sunwebgroup/uds-icons";
import { DocumentWithText } from "@sunwebgroup/uds-icons";
import { Esim } from "@sunwebgroup/uds-icons";
import { ExclamationInCircle } from "@sunwebgroup/uds-icons";
import { ExclamationInTriangle } from "@sunwebgroup/uds-icons";
import { Eye } from "@sunwebgroup/uds-icons";
import { EyeSlashed } from "@sunwebgroup/uds-icons";
import { FaceHappy } from "@sunwebgroup/uds-icons";
import { Family } from "@sunwebgroup/uds-icons";
import { ForkAndKnive } from "@sunwebgroup/uds-icons";
import { GolfClub } from "@sunwebgroup/uds-icons";
import { Heart } from "@sunwebgroup/uds-icons";
import { HeartFilled } from "@sunwebgroup/uds-icons";
import { HeartWithSmallerHeart } from "@sunwebgroup/uds-icons";
import { House } from "@sunwebgroup/uds-icons";
import { Houses } from "@sunwebgroup/uds-icons";
import { ImageSlashed } from "@sunwebgroup/uds-icons";
import { InformationInCircle } from "@sunwebgroup/uds-icons";
import { Leaf } from "@sunwebgroup/uds-icons";
import { List } from "@sunwebgroup/uds-icons";
import { LogoSunweb } from "@sunwebgroup/uds-icons";
import { Lotus } from "@sunwebgroup/uds-icons";
import { Magnifier } from "@sunwebgroup/uds-icons";
import { ManualTransmission } from "@sunwebgroup/uds-icons";
import { Map } from "@sunwebgroup/uds-icons";
import { MapPin } from "@sunwebgroup/uds-icons";
import { Minus } from "@sunwebgroup/uds-icons";
import { MinusExtraSmall } from "@sunwebgroup/uds-icons";
import { ParkingSign } from "@sunwebgroup/uds-icons";
import { PaymentCardWithCoins } from "@sunwebgroup/uds-icons";
import { Pencil } from "@sunwebgroup/uds-icons";
import { Person } from "@sunwebgroup/uds-icons";
import { PersonInCircle } from "@sunwebgroup/uds-icons";
import { PersonRunning } from "@sunwebgroup/uds-icons";
import { PersonSkiing } from "@sunwebgroup/uds-icons";
import { PersonWithSuitcase } from "@sunwebgroup/uds-icons";
import { PigBank } from "@sunwebgroup/uds-icons";
import { Plus } from "@sunwebgroup/uds-icons";
import { PlusExtraSmall } from "@sunwebgroup/uds-icons";
import { QuestionMarkInCircle } from "@sunwebgroup/uds-icons";
import { ShieldWithDismiss } from "@sunwebgroup/uds-icons";
import { ShieldWithLock } from "@sunwebgroup/uds-icons";
import { ShieldWithPlus } from "@sunwebgroup/uds-icons";
import { SkiPass } from "@sunwebgroup/uds-icons";
import { Skis } from "@sunwebgroup/uds-icons";
import { Sliders } from "@sunwebgroup/uds-icons";
import { SmallHouse } from "@sunwebgroup/uds-icons";
import { Snowflake } from "@sunwebgroup/uds-icons";
import { SpadeSymbol } from "@sunwebgroup/uds-icons";
import { Spinner } from "@sunwebgroup/uds-icons";
import { StarFilled } from "@sunwebgroup/uds-icons";
import { StarHalfFilled } from "@sunwebgroup/uds-icons";
import { Suitcase } from "@sunwebgroup/uds-icons";
import { SuitcaseOnWheels } from "@sunwebgroup/uds-icons";
import { SuitcaseOnWheelsWithCheckMark } from "@sunwebgroup/uds-icons";
import { Sweater } from "@sunwebgroup/uds-icons";
import { Tag } from "@sunwebgroup/uds-icons";
import { ThreePeople } from "@sunwebgroup/uds-icons";
import { Ticket } from "@sunwebgroup/uds-icons";
import { TicketFlight } from "@sunwebgroup/uds-icons";
import { TicketWithPercentage } from "@sunwebgroup/uds-icons";
import { TipiTent } from "@sunwebgroup/uds-icons";
import { TrashCan } from "@sunwebgroup/uds-icons";
import { TShirt } from "@sunwebgroup/uds-icons";
import { TwoChildren } from "@sunwebgroup/uds-icons";
import { TwoPeople } from "@sunwebgroup/uds-icons";
import { Villa } from "@sunwebgroup/uds-icons";
import { World } from "@sunwebgroup/uds-icons";
import { Placeholder } from "@sunwebgroup/uds-icons";

// src/uds/components/Accordion/Accordion.tsx
var Accordion_exports = {};
__export(Accordion_exports, {
  Item: () => Item,
  Root: () => Root2
});
import { styled as styled6 } from "styled-components";

// src/utils/components/Grid/Grid.tsx
import { css, styled } from "styled-components";
import { jsx } from "react/jsx-runtime";
function Grid({
  as,
  children,
  gap,
  cols,
  alignItems,
  autoColumns,
  justifyItems,
  ...attributes
}) {
  return /* @__PURE__ */ jsx(GridStyled, {
    as,
    $gap: gap,
    $cols: cols,
    $alignItems: alignItems,
    $autoColumns: autoColumns,
    $justifyItems: justifyItems,
    ...attributes,
    children
  });
}
Grid.displayName = "Grid";
var GridStyled = styled.div`
  display: grid;
  gap: ${(props) => props.$gap};
  align-items: ${(props) => props.$alignItems};
  justify-items: ${(props) => props.$justifyItems};

  // create equal sized columns
  ${(props) => props.$cols && !props.$autoColumns && css`
      grid-template-columns: repeat(${props.$cols}, 1fr);
    `}

  // create auto sized columns
  grid-auto-columns: ${(props) => props.$autoColumns};
  ${(props) => props.$autoColumns && props.$cols && css`
      grid-template-areas: '${Array(props.$cols).fill("section").join(" ")}'; // create "section section" (based on the amount of columns)
    `}
`;

// src/utils/components/SpaceBetween/SpaceBetween.tsx
import { css as css2, styled as styled2 } from "styled-components";

// src/utils/typescript/with-style-modifiers.ts
function withStyleModifiers(Component, modifiers) {
  return Object.assign(Component, modifiers);
}

// src/utils/components/SpaceBetween/SpaceBetween.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function SpaceBetweenComponent({
  alignItems,
  direction,
  spacing,
  justifyContent,
  padding,
  children,
  ...attributes
}) {
  return /* @__PURE__ */ jsx2(StyledSpaceBetween, {
    $spacing: spacing,
    $direction: direction,
    $alignItems: alignItems,
    $justifyContent: justifyContent,
    $padding: padding,
    ...attributes,
    children
  });
}
SpaceBetweenComponent.displayName = "SpaceBetween";
var StyledSpaceBetween = styled2.div`
  ${(props) => {
  var _a, _b;
  switch (props.$direction) {
    case "x":
      return css2`
          flex-direction: row;
          > * ~ * {
            margin-left: ${(_a = props.$spacing) != null ? _a : "initial"} !important;
          }
        `;
    case "y":
      return css2`
          flex-direction: column;
          > * ~ * {
            margin-top: ${(_b = props.$spacing) != null ? _b : "initial"} !important;
          }
        `;
  }
}}
  display: flex;
  align-items: ${(props) => props.$alignItems};
  justify-content: ${(props) => props.$justifyContent};
  padding: ${(props) => props.$padding};
`;
var modAlignment = (spacing, direction = "x") => css2`
  ${() => {
  return css2`
      > * ~ * {
        ${direction === "x" ? "margin-left" : "margin-top"}: ${spacing} !important;
      }
    `;
}}
`;
var SpaceBetween = withStyleModifiers(styled2(SpaceBetweenComponent)``, {
  modAlignment
});

// src/utils/components/Collapsible/Collapsible.tsx
import * as RadixCollapsible from "@radix-ui/react-collapsible";
import { keyframes, styled as styled3 } from "styled-components";
var slideDown = keyframes`
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
`;
var slideUp = keyframes`
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
`;
var CollapsibleRoot = styled3(RadixCollapsible.Root)``;
var Collapsible = styled3(RadixCollapsible.Content).attrs((props) => ({
  $duration: props.$duration || "200ms"
}))`
  overflow: hidden;
  will-change: height;

  &[data-state='open'] {
    animation: ${slideDown} ease-out;
    animation-duration: ${(props) => props.$duration};

    @media (prefers-reduced-motion) {
      animation: none;
    }
  }

  &[data-state='closed'] {
    animation: ${slideUp} ease-out;
    animation-duration: ${(props) => props.$duration};

    @media (prefers-reduced-motion) {
      animation: none;
    }
  }
`;
var CollapsibleTrigger = styled3(RadixCollapsible.Trigger)``;

// src/utils/dates/dates.ts
import {
  add,
  differenceInCalendarDays,
  differenceInDays,
  differenceInMonths,
  differenceInWeeks,
  format,
  isAfter,
  isBefore,
  isEqual,
  lastDayOfMonth,
  startOfMonth,
  sub
} from "date-fns";
function getLocaleDateString(date) {
  return format(date, "yyyy-MM-dd");
}

// src/utils/styling/gap.ts
import { css as css3 } from "styled-components";

// src/utils/styling/get-token.ts
var tk = (tokenName) => (props) => props.theme.tokens[tokenName];
var tok = (tokenName) => (props) => props.theme.udsTokens[tokenName];
function tokPx(tokenName) {
  return ({ theme }) => theme.udsTokens[tokenName] ? `${theme.udsTokens[tokenName]}px` : "0";
}
var space = (tokenName) => tokPx(tokenName);
var radius = (tokenName) => tokPx(tokenName);
function mqMin(tokenName) {
  return ({ theme }) => theme.udsTokens[tokenName] ? `(min-width: ${theme.udsTokens[tokenName]}px)` : "0";
}
function mqMax(tokenName) {
  return ({ theme }) => theme.udsTokens[tokenName] ? `(max-width: ${theme.udsTokens[tokenName]}px)` : "0";
}
function textColor(tokenName) {
  return tok(tokenName);
}

// src/utils/styling/gap.ts
var horizontalGap = (spacingToken) => css3`
  > * {
    margin-right: ${tk(spacingToken)};

    &:last-child {
      margin-right: initial;
    }
  }
`;
var verticalGap = (spacingToken) => css3`
  > * {
    margin-bottom: ${tk(spacingToken)};

    &:last-child {
      margin-bottom: initial;
    }
  }
`;

// src/utils/styling/use-token.ts
import { useTheme } from "styled-components";

// src/utils/styling/z-index.ts
var zIndex = {
  modalOrMobilePopover: 1500,
  sheet: 1500,
  backdrop: 1499,
  header: 99,
  heroContent: 98,
  popover: 97,
  menuOrDrawer: 96,
  anchorMenu: 50
};

// src/uds/components/Icon/Icon.tsx
import { css as css4, styled as styled4 } from "styled-components";
import { jsx as jsx3 } from "react/jsx-runtime";
function Icon({ className, glyph, size = 24, fullWidth = false, ...attrs }) {
  const GlyphComponent = glyphs_exports[glyph];
  return /* @__PURE__ */ jsx3(IconWrapper, {
    className,
    $size: size,
    $fullWidth: fullWidth,
    children: /* @__PURE__ */ jsx3(GlyphComponent, {
      ...attrs
    })
  });
}
var IconWrapper = styled4.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => $size && modSize($size)}
  ${({ $fullWidth }) => $fullWidth && modFullWidth()}
`;
Icon.displayName = "Icon";
var modSize = (size) => css4`
  & > svg {
    height: ${size}px;
    width: ${size}px;
  }
`;
var modFullWidth = () => css4`
  & > svg {
    height: initial;
    width: 100%;
  }
`;
var Icon_default = withStyleModifiers(styled4(Icon)``, {
  modSize
});

// src/uds/components/Typography/Typography.tsx
import { css as css5, styled as styled5 } from "styled-components";
var Typography = styled5.span`
  margin: 0;

  ${({ $variant }) => modVariant($variant)}
  ${({ $color }) => $color && modColor($color)}
`;
Typography.displayName = "Typography";
function modVariant(variantName = "body-m-regular-snug") {
  return {
    "body-l-regular-loose": css5`
      font-family: ${tok("typography_body_l_regular_loose_font_family")};
      font-size: ${tokPx("typography_body_l_regular_loose_font_size")};
      line-height: ${tok("typography_body_l_regular_loose_line_height")};
      font-weight: ${tok("typography_body_l_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_body_l_regular_loose_letter_spacing")};
    `,
    "body-l-regular-snug": css5`
      font-family: ${tok("typography_body_l_regular_snug_font_family")};
      font-size: ${tokPx("typography_body_l_regular_snug_font_size")};
      line-height: ${tok("typography_body_l_regular_snug_line_height")};
      font-weight: ${tok("typography_body_l_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_body_l_regular_snug_letter_spacing")};
    `,
    "body-l-regular-tight": css5`
      font-family: ${tok("typography_body_l_regular_tight_font_family")};
      font-size: ${tokPx("typography_body_l_regular_tight_font_size")};
      line-height: ${tok("typography_body_l_regular_tight_line_height")};
      font-weight: ${tok("typography_body_l_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_body_l_regular_tight_letter_spacing")};
    `,
    "body-l-regular-flat": css5`
      font-family: ${tok("typography_body_l_regular_flat_font_family")};
      font-size: ${tokPx("typography_body_l_regular_flat_font_size")};
      line-height: ${tok("typography_body_l_regular_flat_line_height")};
      font-weight: ${tok("typography_body_l_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_body_l_regular_flat_letter_spacing")};
    `,
    "body-l-bold-loose": css5`
      font-family: ${tok("typography_body_l_bold_loose_font_family")};
      font-size: ${tokPx("typography_body_l_bold_loose_font_size")};
      line-height: ${tok("typography_body_l_bold_loose_line_height")};
      font-weight: ${tok("typography_body_l_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_body_l_bold_loose_letter_spacing")};
    `,
    "body-l-bold-snug": css5`
      font-family: ${tok("typography_body_l_bold_snug_font_family")};
      font-size: ${tokPx("typography_body_l_bold_snug_font_size")};
      line-height: ${tok("typography_body_l_bold_snug_line_height")};
      font-weight: ${tok("typography_body_l_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_body_l_bold_snug_letter_spacing")};
    `,
    "body-l-bold-tight": css5`
      font-family: ${tok("typography_body_l_bold_tight_font_family")};
      font-size: ${tokPx("typography_body_l_bold_tight_font_size")};
      line-height: ${tok("typography_body_l_bold_tight_line_height")};
      font-weight: ${tok("typography_body_l_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_body_l_bold_tight_letter_spacing")};
    `,
    "body-l-bold-flat": css5`
      font-family: ${tok("typography_body_l_bold_flat_font_family")};
      font-size: ${tokPx("typography_body_l_bold_flat_font_size")};
      line-height: ${tok("typography_body_l_bold_flat_line_height")};
      font-weight: ${tok("typography_body_l_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_body_l_bold_flat_letter_spacing")};
    `,
    "body-m-regular-loose": css5`
      font-family: ${tok("typography_body_m_regular_loose_font_family")};
      font-size: ${tokPx("typography_body_m_regular_loose_font_size")};
      line-height: ${tok("typography_body_m_regular_loose_line_height")};
      font-weight: ${tok("typography_body_m_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_body_m_regular_loose_letter_spacing")};
    `,
    "body-m-regular-snug": css5`
      font-family: ${tok("typography_body_m_regular_snug_font_family")};
      font-size: ${tokPx("typography_body_m_regular_snug_font_size")};
      line-height: ${tok("typography_body_m_regular_snug_line_height")};
      font-weight: ${tok("typography_body_m_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_body_m_regular_snug_letter_spacing")};
    `,
    "body-m-regular-tight": css5`
      font-family: ${tok("typography_body_m_regular_tight_font_family")};
      font-size: ${tokPx("typography_body_m_regular_tight_font_size")};
      line-height: ${tok("typography_body_m_regular_tight_line_height")};
      font-weight: ${tok("typography_body_m_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_body_m_regular_tight_letter_spacing")};
    `,
    "body-m-regular-flat": css5`
      font-family: ${tok("typography_body_m_regular_flat_font_family")};
      font-size: ${tokPx("typography_body_m_regular_flat_font_size")};
      line-height: ${tok("typography_body_m_regular_flat_line_height")};
      font-weight: ${tok("typography_body_m_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_body_m_regular_flat_letter_spacing")};
    `,
    "body-m-bold-loose": css5`
      font-family: ${tok("typography_body_m_bold_loose_font_family")};
      font-size: ${tokPx("typography_body_m_bold_loose_font_size")};
      line-height: ${tok("typography_body_m_bold_loose_line_height")};
      font-weight: ${tok("typography_body_m_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_body_m_bold_loose_letter_spacing")};
    `,
    "body-m-bold-snug": css5`
      font-family: ${tok("typography_body_m_bold_snug_font_family")};
      font-size: ${tokPx("typography_body_m_bold_snug_font_size")};
      line-height: ${tok("typography_body_m_bold_snug_line_height")};
      font-weight: ${tok("typography_body_m_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_body_m_bold_snug_letter_spacing")};
    `,
    "body-m-bold-tight": css5`
      font-family: ${tok("typography_body_m_bold_tight_font_family")};
      font-size: ${tokPx("typography_body_m_bold_tight_font_size")};
      line-height: ${tok("typography_body_m_bold_tight_line_height")};
      font-weight: ${tok("typography_body_m_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_body_m_bold_tight_letter_spacing")};
    `,
    "body-m-bold-flat": css5`
      font-family: ${tok("typography_body_m_bold_flat_font_family")};
      font-size: ${tokPx("typography_body_m_bold_flat_font_size")};
      line-height: ${tok("typography_body_m_bold_flat_line_height")};
      font-weight: ${tok("typography_body_m_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_body_m_bold_flat_letter_spacing")};
    `,
    "body-s-regular-loose": css5`
      font-family: ${tok("typography_body_s_regular_loose_font_family")};
      font-size: ${tokPx("typography_body_s_regular_loose_font_size")};
      line-height: ${tok("typography_body_s_regular_loose_line_height")};
      font-weight: ${tok("typography_body_s_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_body_s_regular_loose_letter_spacing")};
    `,
    "body-s-regular-snug": css5`
      font-family: ${tok("typography_body_s_regular_snug_font_family")};
      font-size: ${tokPx("typography_body_s_regular_snug_font_size")};
      line-height: ${tok("typography_body_s_regular_snug_line_height")};
      font-weight: ${tok("typography_body_s_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_body_s_regular_snug_letter_spacing")};
    `,
    "body-s-regular-tight": css5`
      font-family: ${tok("typography_body_s_regular_tight_font_family")};
      font-size: ${tokPx("typography_body_s_regular_tight_font_size")};
      line-height: ${tok("typography_body_s_regular_tight_line_height")};
      font-weight: ${tok("typography_body_s_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_body_s_regular_tight_letter_spacing")};
    `,
    "body-s-regular-flat": css5`
      font-family: ${tok("typography_body_s_regular_flat_font_family")};
      font-size: ${tokPx("typography_body_s_regular_flat_font_size")};
      line-height: ${tok("typography_body_s_regular_flat_line_height")};
      font-weight: ${tok("typography_body_s_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_body_s_regular_flat_letter_spacing")};
    `,
    "body-s-bold-loose": css5`
      font-family: ${tok("typography_body_s_bold_loose_font_family")};
      font-size: ${tokPx("typography_body_s_bold_loose_font_size")};
      line-height: ${tok("typography_body_s_bold_loose_line_height")};
      font-weight: ${tok("typography_body_s_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_body_s_bold_loose_letter_spacing")};
    `,
    "body-s-bold-snug": css5`
      font-family: ${tok("typography_body_s_bold_snug_font_family")};
      font-size: ${tokPx("typography_body_s_bold_snug_font_size")};
      line-height: ${tok("typography_body_s_bold_snug_line_height")};
      font-weight: ${tok("typography_body_s_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_body_s_bold_snug_letter_spacing")};
    `,
    "body-s-bold-tight": css5`
      font-family: ${tok("typography_body_s_bold_tight_font_family")};
      font-size: ${tokPx("typography_body_s_bold_tight_font_size")};
      line-height: ${tok("typography_body_s_bold_tight_line_height")};
      font-weight: ${tok("typography_body_s_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_body_s_bold_tight_letter_spacing")};
    `,
    "body-s-bold-flat": css5`
      font-family: ${tok("typography_body_s_bold_flat_font_family")};
      font-size: ${tokPx("typography_body_s_bold_flat_font_size")};
      line-height: ${tok("typography_body_s_bold_flat_line_height")};
      font-weight: ${tok("typography_body_s_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_body_s_bold_flat_letter_spacing")};
    `,
    "body-xs-regular-loose": css5`
      font-family: ${tok("typography_body_xs_regular_loose_font_family")};
      font-size: ${tokPx("typography_body_xs_regular_loose_font_size")};
      line-height: ${tok("typography_body_xs_regular_loose_line_height")};
      font-weight: ${tok("typography_body_xs_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_body_xs_regular_loose_letter_spacing")};
    `,
    "body-xs-regular-snug": css5`
      font-family: ${tok("typography_body_xs_regular_snug_font_family")};
      font-size: ${tokPx("typography_body_xs_regular_snug_font_size")};
      line-height: ${tok("typography_body_xs_regular_snug_line_height")};
      font-weight: ${tok("typography_body_xs_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_body_xs_regular_snug_letter_spacing")};
    `,
    "body-xs-regular-tight": css5`
      font-family: ${tok("typography_body_xs_regular_tight_font_family")};
      font-size: ${tokPx("typography_body_xs_regular_tight_font_size")};
      line-height: ${tok("typography_body_xs_regular_tight_line_height")};
      font-weight: ${tok("typography_body_xs_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_body_xs_regular_tight_letter_spacing")};
    `,
    "body-xs-regular-flat": css5`
      font-family: ${tok("typography_body_xs_regular_flat_font_family")};
      font-size: ${tokPx("typography_body_xs_regular_flat_font_size")};
      line-height: ${tok("typography_body_xs_regular_flat_line_height")};
      font-weight: ${tok("typography_body_xs_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_body_xs_regular_flat_letter_spacing")};
    `,
    "body-xs-bold-loose": css5`
      font-family: ${tok("typography_body_xs_bold_loose_font_family")};
      font-size: ${tokPx("typography_body_xs_bold_loose_font_size")};
      line-height: ${tok("typography_body_xs_bold_loose_line_height")};
      font-weight: ${tok("typography_body_xs_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_body_xs_bold_loose_letter_spacing")};
    `,
    "body-xs-bold-snug": css5`
      font-family: ${tok("typography_body_xs_bold_snug_font_family")};
      font-size: ${tokPx("typography_body_xs_bold_snug_font_size")};
      line-height: ${tok("typography_body_xs_bold_snug_line_height")};
      font-weight: ${tok("typography_body_xs_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_body_xs_bold_snug_letter_spacing")};
    `,
    "body-xs-bold-tight": css5`
      font-family: ${tok("typography_body_xs_bold_tight_font_family")};
      font-size: ${tokPx("typography_body_xs_bold_tight_font_size")};
      line-height: ${tok("typography_body_xs_bold_tight_line_height")};
      font-weight: ${tok("typography_body_xs_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_body_xs_bold_tight_letter_spacing")};
    `,
    "body-xs-bold-flat": css5`
      font-family: ${tok("typography_body_xs_bold_flat_font_family")};
      font-size: ${tokPx("typography_body_xs_bold_flat_font_size")};
      line-height: ${tok("typography_body_xs_bold_flat_line_height")};
      font-weight: ${tok("typography_body_xs_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_body_xs_bold_flat_letter_spacing")};
    `,
    "display-a-regular": css5`
      font-family: ${tok("typography_display_a_regular_font_family")};
      font-size: ${tokPx("typography_display_a_regular_font_size")};
      line-height: ${tok("typography_display_a_regular_line_height")};
      font-weight: ${tok("typography_display_a_regular_font_weight")};
      letter-spacing: ${tok("typography_display_a_regular_letter_spacing")};
    `,
    "display-b-regular": css5`
      font-family: ${tok("typography_display_b_regular_font_family")};
      font-size: ${tokPx("typography_display_b_regular_font_size")};
      line-height: ${tok("typography_display_b_regular_line_height")};
      font-weight: ${tok("typography_display_b_regular_font_weight")};
      letter-spacing: ${tok("typography_display_b_regular_letter_spacing")};
    `,
    "display-c-regular": css5`
      font-family: ${tok("typography_display_c_regular_font_family")};
      font-size: ${tokPx("typography_display_c_regular_font_size")};
      line-height: ${tok("typography_display_c_regular_line_height")};
      font-weight: ${tok("typography_display_c_regular_font_weight")};
      letter-spacing: ${tok("typography_display_c_regular_letter_spacing")};
    `,
    "display-d-regular": css5`
      font-family: ${tok("typography_display_d_regular_font_family")};
      font-size: ${tokPx("typography_display_d_regular_font_size")};
      line-height: ${tok("typography_display_d_regular_line_height")};
      font-weight: ${tok("typography_display_d_regular_font_weight")};
      letter-spacing: ${tok("typography_display_d_regular_letter_spacing")};
    `,
    "display-e-regular": css5`
      font-family: ${tok("typography_display_e_regular_font_family")};
      font-size: ${tokPx("typography_display_e_regular_font_size")};
      line-height: ${tok("typography_display_e_regular_line_height")};
      font-weight: ${tok("typography_display_e_regular_font_weight")};
      letter-spacing: ${tok("typography_display_e_regular_letter_spacing")};
    `,
    "display-f-regular": css5`
      font-family: ${tok("typography_display_f_regular_font_family")};
      font-size: ${tokPx("typography_display_f_regular_font_size")};
      line-height: ${tok("typography_display_f_regular_line_height")};
      font-weight: ${tok("typography_display_f_regular_font_weight")};
      letter-spacing: ${tok("typography_display_f_regular_letter_spacing")};
    `,
    "display-g-regular": css5`
      font-family: ${tok("typography_display_g_regular_font_family")};
      font-size: ${tokPx("typography_display_g_regular_font_size")};
      line-height: ${tok("typography_display_g_regular_line_height")};
      font-weight: ${tok("typography_display_g_regular_font_weight")};
      letter-spacing: ${tok("typography_display_g_regular_letter_spacing")};
    `,
    "display-h-regular": css5`
      font-family: ${tok("typography_display_h_regular_font_family")};
      font-size: ${tokPx("typography_display_h_regular_font_size")};
      line-height: ${tok("typography_display_h_regular_line_height")};
      font-weight: ${tok("typography_display_h_regular_font_weight")};
      letter-spacing: ${tok("typography_display_h_regular_letter_spacing")};
    `,
    "display-i-regular": css5`
      font-family: ${tok("typography_display_i_regular_font_family")};
      font-size: ${tokPx("typography_display_i_regular_font_size")};
      line-height: ${tok("typography_display_i_regular_line_height")};
      font-weight: ${tok("typography_display_i_regular_font_weight")};
      letter-spacing: ${tok("typography_display_i_regular_letter_spacing")};
    `,
    "display-j-regular": css5`
      font-family: ${tok("typography_display_j_regular_font_family")};
      font-size: ${tokPx("typography_display_j_regular_font_size")};
      line-height: ${tok("typography_display_j_regular_line_height")};
      font-weight: ${tok("typography_display_j_regular_font_weight")};
      letter-spacing: ${tok("typography_display_j_regular_letter_spacing")};
    `
  }[variantName];
}
function modColor(colorName) {
  return css5`
    color: ${textColor(colorName)};
  `;
}
var TypographyWithModifiers = withStyleModifiers(Typography, {
  modVariant,
  modColor
});
var Typography_default = TypographyWithModifiers;

// src/uds/components/Accordion/Accordion.tsx
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
var Wrapper = styled6.div`
  border-bottom: 2px solid ${tok("semantics_dividers_color")};
  padding: ${tok("primitives_space_8")} 0;

  ${Collapsible} {
    // This is needed to avoid the outline being cut off
    padding: 4px;
    margin: -4px -4px 0 -4px;

    padding-bottom: ${space("primitives_space_16")};
  }
`;
var Header = styled6(CollapsibleTrigger)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  width: 100%;
  text-align: left;
  min-height: ${tokPx("primitives_space_48")};
  padding-top: ${space("primitives_space_8")};
  padding-bottom: ${space("primitives_space_8")};

  ${Icon_default}:last-of-type {
    transition: transform 200ms ease-out;
    margin-left: auto !important;
  }

  &[data-state='open'] {
    ${Icon_default}:last-of-type {
      transform: rotate(180deg);
    }
  }
`;
function Item({
  children,
  title,
  defaultOpen,
  onOpenChange,
  disabled,
  ...rest
}) {
  return /* @__PURE__ */ jsx4(Wrapper, {
    ...rest,
    children: /* @__PURE__ */ jsxs(CollapsibleRoot, {
      defaultOpen,
      onOpenChange,
      disabled,
      children: [
        /* @__PURE__ */ jsxs(Header, {
          children: [
            /* @__PURE__ */ jsx4(Typography_default, {
              $variant: "body-m-bold-tight",
              children: title
            }),
            /* @__PURE__ */ jsx4(Icon_default, {
              glyph: "ChevronDown",
              size: 24,
              "aria-hidden": true
            })
          ]
        }),
        /* @__PURE__ */ jsx4(Collapsible, {
          children: /* @__PURE__ */ jsx4(Typography_default, {
            children
          })
        })
      ]
    })
  });
}
Item.displayName = "Accordion.Item";
var Root2 = styled6.article``;
Root2.displayName = "Accordion.Root";

// src/uds/components/Badge/Badge.tsx
import { styled as styled7 } from "styled-components";
var Badge = styled7(Typography_default).attrs({
  $variant: "body-m-bold-flat",
  as: "span"
})`
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: ${space("primitives_space_28")};
  height: ${space("primitives_space_28")};
  background: ${tok("primitives_color_neutral_150")};
  border-radius: ${radius("primitives_corner_radius_xxl")};
  color: ${tok("primitives_color_neutral_800")};
  display: inline-flex;
  padding: ${space("primitives_space_8")};
`;
Badge.displayName = "Badge";
var Badge_default = Badge;

// src/uds/components/Banner/Banner.tsx
import { css as css6, styled as styled8 } from "styled-components";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var iconMapping = {
  neutral: "InformationInCircle",
  secondary: "InformationInCircle",
  danger: "ExclamationInCircle",
  warning: "ExclamationInTriangle",
  success: "CheckMarkInCircle"
};
var StyledBanner = styled8.div`
  border: 2px solid;
  border-radius: ${radius("primitives_corner_radius_l")};
  padding: ${space("primitives_space_12")};

  ${({ $color }) => modType($color)}

  ${({ display }) => display === "overlay" && css6`
      box-shadow: ${tok("primitives_box_shadows_level_4")};
    `}
`;
var Content2 = styled8.div`
  display: flex;
  align-items: center;
  gap: ${tokPx("primitives_space_8")};
`;
function Banner({ color, hasIcon, display = "inline", text, supportingText, size, className }) {
  const icon = iconMapping[color];
  const textVariant = size === "M" ? "body-m-bold-tight" : "body-s-bold-tight";
  const supportingTextVariant = size === "M" ? "body-s-regular-tight" : "body-xs-regular-tight";
  const isAlert = color === "danger" || color === "warning";
  return /* @__PURE__ */ jsx5(StyledBanner, {
    $color: color,
    display,
    role: isAlert ? "alert" : "status",
    "aria-live": isAlert ? void 0 : "polite",
    className,
    children: /* @__PURE__ */ jsxs2(Content2, {
      children: [
        hasIcon && size === "M" && /* @__PURE__ */ jsx5(Icon_default, {
          size: 32,
          glyph: icon,
          "aria-hidden": "true"
        }),
        /* @__PURE__ */ jsxs2("div", {
          children: [
            /* @__PURE__ */ jsx5(Typography_default, {
              $variant: textVariant,
              as: "strong",
              children: text
            }),
            supportingText && /* @__PURE__ */ jsx5(Typography_default, {
              $variant: supportingTextVariant,
              as: "div",
              children: supportingText
            })
          ]
        })
      ]
    })
  });
}
function modType(color) {
  return {
    neutral: css6`
      background-color: ${tok("primitives_color_neutral_50")};
      border-color: ${tok("primitives_color_neutral_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_neutral_600")};
      }
    `,
    secondary: css6`
      background-color: ${tok("primitives_color_secondary_50")};
      border-color: ${tok("primitives_color_secondary_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_secondary_500")};
      }
    `,
    danger: css6`
      background-color: ${tok("primitives_color_danger_50")};
      border-color: ${tok("primitives_color_danger_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_danger_500")};
      }
    `,
    warning: css6`
      background-color: ${tok("primitives_color_warning_50")};
      border-color: ${tok("primitives_color_warning_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_warning_500")};
      }
    `,
    success: css6`
      background-color: ${tok("primitives_color_success_50")};
      border-color: ${tok("primitives_color_success_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_success_500")};
      }
    `
  }[color];
}
Banner.displayName = "Banner";
var Banner_default = Banner;

// src/uds/components/Benefits/Benefits.tsx
var Benefits_exports = {};
__export(Benefits_exports, {
  Item: () => Item2,
  Root: () => Root3
});
import { css as css7, styled as styled9 } from "styled-components";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var SuportingText = styled9(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
`;
var TextWrapper = styled9.div`
  display: flex;
  padding-top: ${tokPx("primitives_space_2")};
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  flex-direction: column;
  text-wrap: auto;
`;
var ItemWrapper = styled9.div`
  display: flex;
  align-items: flex-start;
  gap: ${tokPx("primitives_space_4")};
  align-self: stretch;
`;
var IconWrapper2 = styled9(Icon_default)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
var Root3 = styled9.ul.attrs(() => ({}))`
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;

  ${({ $type }) => modType2($type)}
  ${({ $align }) => modAlign($align)}
`;
Root3.displayName = "Benefits.Root";
var Item2 = styled9.li.attrs(({ $icon, title, supportingtext }) => ({
  children: /* @__PURE__ */ jsxs3(ItemWrapper, {
    children: [
      /* @__PURE__ */ jsx6(IconWrapper2, {
        glyph: $icon != null ? $icon : "CheckMarkSmall",
        "aria-hidden": true
      }),
      /* @__PURE__ */ jsxs3(TextWrapper, {
        children: [
          /* @__PURE__ */ jsx6(Typography_default, {
            $variant: supportingtext ? "body-m-bold-tight" : "body-m-regular-tight",
            children: title
          }),
          supportingtext && /* @__PURE__ */ jsx6(SuportingText, {
            $variant: "body-s-regular-tight",
            children: supportingtext
          })
        ]
      })
    ]
  })
}))`
  list-style-type: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: list-item;
  list-style-position: inside;

  ${Icon_default} {
    margin-right: ${tokPx("primitives_space_2")};
    vertical-align: text-top;
  }
`;
Item2.displayName = "Benefits.Item";
function modType2(typeName = "vertical") {
  return {
    vertical: css7`
      flex-direction: column;
      ${Item2} {
        &:not(:last-child) {
          margin-bottom: ${tokPx("primitives_space_8")};
          margin-left: ${tokPx("primitives_space_0")};
        }
      }
    `,
    inline: css7`
      gap: ${tokPx("primitives_space_6")} ${tokPx("primitives_space_12")};
      ${Item2} {
        display: flex;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
      }
    `
  }[typeName];
}
function modAlign(alignName = "left") {
  return {
    left: css7`
      align-items: flex-start;
      align-content: flex-start;
    `,
    center: css7`
      justify-content: center;
      align-items: center;
      align-content: center;
    `,
    right: css7`
      align-items: flex-end;
      align-content: flex-end;
    `
  }[alignName];
}

// src/uds/components/Breadcrumbs/Breadcrumbs.tsx
import { styled as styled11 } from "styled-components";

// src/uds/components/IconCell/IconCell.tsx
import { styled as styled10 } from "styled-components";
import { jsx as jsx7 } from "react/jsx-runtime";
var iconCellSize = {
  sm: "20px",
  md: "24px",
  lg: "32px"
};
var Wrapper2 = styled10.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $verticalAlignment }) => $verticalAlignment === "top" ? "flex-start" : "center"};
  width: ${({ $size }) => iconCellSize[$size]};
`;
function IconCell({
  glyph,
  size = "md",
  hidden = false,
  verticalAlignment = "center",
  className
}) {
  return /* @__PURE__ */ jsx7(Wrapper2, {
    className,
    $size: size,
    $verticalAlignment: verticalAlignment,
    children: !hidden && /* @__PURE__ */ jsx7(Icon_default, {
      glyph,
      fullWidth: true
    })
  });
}
var IconCell_default = styled10(IconCell)``;

// src/uds/components/Breadcrumbs/Breadcrumbs.tsx
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var Root4 = styled11.nav`
  width: 100%;
  display: flex;
  align-items: center;
`;
var List2 = styled11.ol`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
`;
var ListItem = styled11.li`
  display: ${({ $isPenultimate }) => $isPenultimate ? "flex" : "none"};
  align-items: center;

  @media ${mqMin("primitives_breakpoint_m_min")} {
    display: flex;
  }
`;
var StyledLink = styled11.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
var Separator = styled11(IconCell_default)`
  display: ${({ showOn }) => showOn === "mobile" ? "flex" : "none"};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    display: ${({ showOn }) => showOn === "desktop" ? "flex" : "none"};
  }
`;
var BreadcrumbSeparator = ({ isLast, showOn }) => {
  if (isLast)
    return null;
  return /* @__PURE__ */ jsx8(Separator, {
    glyph: showOn === "mobile" ? "ChevronLeft" : "ChevronRightExtraSmall",
    size: "sm",
    showOn
  });
};
function renderItems(items) {
  const penultimateIdx = items.length - 2;
  const lastIdx = items.length - 1;
  return items.map((item, idx) => {
    const isPenultimate = idx === penultimateIdx;
    const isLast = idx === lastIdx;
    return /* @__PURE__ */ jsxs4(ListItem, {
      $isPenultimate: isPenultimate,
      "aria-current": isLast ? "page" : void 0,
      children: [
        item.href ? /* @__PURE__ */ jsxs4(StyledLink, {
          href: item.href,
          children: [
            isPenultimate && /* @__PURE__ */ jsx8(BreadcrumbSeparator, {
              isLast: false,
              showOn: "mobile"
            }),
            /* @__PURE__ */ jsx8(Typography_default, {
              $variant: "body-m-regular-tight",
              children: item.label
            })
          ]
        }) : /* @__PURE__ */ jsx8(Typography_default, {
          $variant: "body-m-regular-tight",
          as: "span",
          children: item.label
        }),
        /* @__PURE__ */ jsx8(BreadcrumbSeparator, {
          isLast,
          showOn: "desktop"
        })
      ]
    }, item.id);
  });
}
var Breadcrumbs = ({ items }) => {
  return /* @__PURE__ */ jsx8(Root4, {
    "aria-label": "Breadcrumb",
    children: /* @__PURE__ */ jsx8(List2, {
      children: renderItems(items)
    })
  });
};
var Breadcrumbs_default = Breadcrumbs;

// src/uds/components/Button/Button.tsx
import { css as css10, styled as styled12 } from "styled-components";

// src/uds/utils/focusOutline.tsx
import { css as css8 } from "styled-components";
function outlineStyles(offset = 2) {
  return css8`
    outline: ${tokPx("semantics_focus_outer_ring_width")} solid ${tok("semantics_focus_outer_ring_color")};
    outline-offset: ${offset}px;
  `;
}
function focusOutline(offset) {
  return css8`
  &:focus-visible {
    ${outlineStyles(offset != null ? offset : 2)};
  }
`;
}
function focusWithinOutline(offset) {
  return css8`
  &:focus-within {
    ${outlineStyles(offset != null ? offset : 2)};
  }
`;
}
function resetFocusOutline() {
  return css8`
  &:focus-visible {
    outline: initial;
    outline-offset: initial;
  }
`;
}

// src/uds/utils/modDisabled.tsx
import { css as css9 } from "styled-components";
function modDisabled($disabled) {
  return css9`
    transition: opacity 0.2s 0s;
    ${$disabled && css9`
      opacity: ${tok("primitives_opacity_disabled")}%;
      pointer-events: none;
    `}
  `;
}

// src/uds/components/Typography/wrap-text-children-with-typography.tsx
import { Children, isValidElement } from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var wrapTextChildrenWithTypography = (children) => Children.map(children, (child) => isValidElement(child) ? child : /* @__PURE__ */ jsx9(Typography_default, {
  as: "span",
  children: child
}));

// src/uds/components/Button/Button.tsx
var Button = styled12.button.attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography(children)
}))`
  border: none;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: fit-content;

  ${({ disabled }) => disabled && modDisabled2()}

  > * + * {
    margin-left: ${space("primitives_space_4")};
  }

  ${focusOutline()}

  ${({ $fullWidth }) => $fullWidth && modFullWidth2()};
  ${({ $size }) => modSize2($size)};
  ${({ $type }) => modType3($type)};
`;
function modFullWidth2() {
  return css10`
    width: 100%;
  `;
}
function modSize2(sizeName = "M") {
  return {
    M: css10`
      padding-top: ${tokPx("components_button_m_padding_top")};
      padding-bottom: ${tokPx("components_button_m_padding_bottom")};
      padding-right: ${tokPx("components_button_m_padding_right")};
      padding-left: ${tokPx("components_button_m_padding_left")};
      min-height: ${tokPx("semantics_controls_m_min_height")};
      border-radius: ${tokPx("semantics_buttons_m_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-m-bold-tight")};
        padding-left: ${space("primitives_space_4")};
        padding-right: ${space("primitives_space_4")};
      }

      ${Icon_default} {
        ${Icon_default.modSize(24)}
      }
    `,
    S: css10`
      padding-top: ${tokPx("components_button_s_padding_top")};
      padding-bottom: ${tokPx("components_button_s_padding_bottom")};
      padding-right: ${tokPx("components_button_s_padding_right")};
      padding-left: ${tokPx("components_button_s_padding_left")};
      min-height: ${tokPx("semantics_controls_s_min_height")};
      border-radius: ${tokPx("semantics_buttons_s_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-s-bold-tight")};
        padding-left: ${space("primitives_space_4")};
        padding-right: ${space("primitives_space_4")};
      }

      ${Icon_default} {
        ${Icon_default.modSize(16)}
      }
    `,
    XS: css10`
      padding-top: ${tokPx("components_button_xs_padding_top")};
      padding-bottom: ${tokPx("components_button_xs_padding_bottom")};
      padding-right: ${tokPx("components_button_xs_padding_right")};
      padding-left: ${tokPx("components_button_xs_padding_left")};
      min-height: ${tokPx("semantics_controls_xs_min_height")};
      border-radius: ${tokPx("semantics_buttons_xs_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-s-bold-flat")};
      }

      ${Icon_default} {
        ${Icon_default.modSize(12)}
      }
    `
  }[sizeName];
}
function modType3(type = "primary") {
  return {
    primary: css10`
      background-color: ${tok("semantics_buttons_primary_background_color")};
      color: ${tok("semantics_buttons_primary_content_color")};

      &:hover {
        background-color: ${tok("semantics_buttons_primary_hover_background_color")};
        color: ${tok("semantics_buttons_primary_hover_content_color")};
      }
    `,
    secondary: css10`
      background-color: ${tok("semantics_buttons_secondary_background_color")};
      color: ${tok("semantics_buttons_secondary_content_color")};

      &:hover {
        background-color: ${tok("semantics_buttons_secondary_hover_background_color")};
        color: ${tok("semantics_buttons_secondary_hover_content_color")};
      }
    `,
    transparentPrimary: css10`
      color: ${tok("semantics_buttons_transparent_primary_content_color")};

      &:hover {
        color: ${tok("semantics_buttons_transparent_primary_hover_content_color")};
      }
    `,
    transparentNeutral: css10`
      color: ${tok("semantics_buttons_transparent_neutral_content_color")};

      &:hover {
        color: ${tok("semantics_buttons_transparent_neutral_hover_content_color")};
      }
    `
  }[type];
}
function modDisabled2() {
  return css10`
    pointer-events: none;
    opacity: ${tok("primitives_opacity_disabled")}%;
  `;
}
var Button_default = withStyleModifiers(Button, {
  modSize: modSize2
});

// src/uds/components/Checkbox/Checkbox.tsx
import * as RadixCheckbox from "@radix-ui/react-checkbox";
import { styled as styled13 } from "styled-components";
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var IconCheck = styled13(Icon_default)``;
var IconIndeterminate = styled13(Icon_default)``;
var IndicatorIcon = styled13.div`
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${IconCheck}, ${IconIndeterminate} {
    display: none;
  }

  &[data-state='checked'] {
    ${IconCheck} {
      display: block;
    }
  }

  &[data-state='indeterminate'] {
    ${IconIndeterminate} {
      display: block;
    }
  }
`;
var CheckboxElement = styled13(RadixCheckbox.Root)`
  width: 20px;
  height: 20px;
  background-color: ${tok("semantics_views_background_color")};
  border: 2px solid ${tok("semantics_selectors_shape_color")};
  border-radius: ${radius("primitives_corner_radius_s")};
  box-sizing: border-box;

  &[data-state='checked'],
  &[data-state='indeterminate'] {
    background-color: ${tok("semantics_selectors_selected_background_color")};
    color: ${tok("semantics_selectors_selected_content_color")};
    border: none;
  }

  //Hover State
  &:hover {
    &:not([data-state='checked']):not(:disabled),
    &:not([data-state='indeterminate']):not(:disabled) {
      border-color: ${tok("semantics_selectors_hover_shape_color")};
    }

    &[data-state='checked']:not(:disabled),
    &[data-state='indeterminate']:not(:disabled) {
      background-color: ${tok("semantics_selectors_selected_hover_background_color")};
    }
  }

  //Disabled State
  &:disabled {
    opacity: ${tok("primitives_opacity_disabled")}%;
  }

  //Focus State
  ${focusOutline()}
`;
function CheckboxComponent({ checked, defaultChecked, onCheckedChange, ...rest }) {
  return /* @__PURE__ */ jsx10(CheckboxElement, {
    checked,
    defaultChecked,
    onCheckedChange,
    ...rest,
    children: /* @__PURE__ */ jsx10(RadixCheckbox.Indicator, {
      asChild: true,
      children: /* @__PURE__ */ jsxs5(IndicatorIcon, {
        children: [
          /* @__PURE__ */ jsx10(IconIndeterminate, {
            glyph: "MinusExtraSmall",
            size: 24
          }),
          /* @__PURE__ */ jsx10(IconCheck, {
            glyph: "CheckMarkExtraSmall",
            size: 24
          })
        ]
      })
    })
  });
}
var Checkbox = styled13(CheckboxComponent)``;

// src/uds/components/ContentUnavailable/ContentUnavailable.tsx
import { css as css11, styled as styled14 } from "styled-components";
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var Container = styled14.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: ${tokPx("primitives_area_size_480")};
`;
var Title = styled14(Typography_default)`
  ${Typography_default.modVariant("body-m-bold-snug")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${Typography_default.modVariant("body-l-bold-snug")};
  }
`;
var Subtitle = styled14(Typography_default)`
  ${Typography_default.modVariant("body-s-regular-snug")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${Typography_default.modVariant("body-m-regular-snug")};
  }
`;
var IconStyled = styled14(Icon_default)`
  margin-bottom: ${tokPx("primitives_space_4")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    margin-bottom: ${tokPx("primitives_space_6")};
  }

    & > svg {
    height: ${tokPx("primitives_space_32")};
    width: ${tokPx("primitives_space_32")};

    @media ${mqMin("primitives_breakpoint_m_min")} {
      height: ${tokPx("primitives_space_48")};
      width: ${tokPx("primitives_space_48")};
    }

    ${({ $isAlert }) => $isAlert && css11`
    color: ${tok("primitives_color_warning_400")};
  `}
  }
`;
function ContentUnavailable({ icon, text, supportingText, type }) {
  const isAlert = type === "alert";
  const glyph = isAlert ? "ExclamationInTriangle" : icon;
  return /* @__PURE__ */ jsxs6(Container, {
    role: isAlert ? "alert" : void 0,
    "aria-live": isAlert ? "assertive" : void 0,
    children: [
      glyph && /* @__PURE__ */ jsx11(IconStyled, {
        glyph,
        $isAlert: isAlert,
        "aria-hidden": "true"
      }),
      /* @__PURE__ */ jsx11(Title, {
        children: text
      }),
      supportingText && /* @__PURE__ */ jsx11(Subtitle, {
        children: supportingText
      })
    ]
  });
}
var ContentUnavailable_default = ContentUnavailable;

// src/uds/components/Fields/SelectionField.tsx
import { css as css13, styled as styled16 } from "styled-components";

// src/uds/components/RadioButton/RadioButton.tsx
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { forwardRef } from "react";
import { css as css12, styled as styled15 } from "styled-components";
import { jsx as jsx12 } from "react/jsx-runtime";
function RadioButtonGroup({ value, defaultValue, ...props }) {
  return /* @__PURE__ */ jsx12(RadioGroupPrimitive.Root, {
    value,
    defaultValue,
    ...props
  });
}
var ItemIndicator = styled15(RadioGroupPrimitive.Indicator)`
  width: 12px;
  height: 12px;
  border-radius: ${radius("primitives_corner_radius_full")};
  background: ${tok("semantics_selectors_selected_background_color")};
`;
var ItemRadio = styled15(RadioGroupPrimitive.Item)`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${radius("primitives_corner_radius_full")};
  background: ${tok("semantics_views_background_color")};
  border: 2px solid ${tok("semantics_selectors_shape_color")};

  &:hover {
    border-color: ${tok("semantics_selectors_hover_shape_color")};
  }

  &[data-state='checked'] {
    border-color: ${tok("semantics_selectors_selected_background_color")};
  }

  &[data-state='checked']:hover {
    border-color: ${tok("semantics_selectors_selected_hover_background_color")};

    ${ItemIndicator} {
      background: ${tok("semantics_selectors_selected_hover_background_color")};
    }
  }


  ${({ disabled }) => disabled && modDisabled3()}

  ${focusOutline()}
`;
var RadioButton = forwardRef(({ className, ...rest }, ref) => /* @__PURE__ */ jsx12(ItemRadio, {
  className,
  ref,
  ...rest,
  children: /* @__PURE__ */ jsx12(ItemIndicator, {})
}));
function modDisabled3() {
  return css12`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
var StyledRadioButton = withStyleModifiers(styled15(RadioButton)``, {
  modDisabled: modDisabled3
});
StyledRadioButton.displayName = "RadioButton";
var RadioButton_default = StyledRadioButton;

// src/uds/components/Fields/SelectionField.tsx
import { jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
var Wrapper3 = styled16.label`
  padding: ${space("primitives_space_12")} 0;
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
  user-select: none;
  width: 100%;
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  cursor: pointer;

  ${RadioButton_default},
  ${Checkbox} {
    ${resetFocusOutline()}
    flex-shrink: 0;
  }

  ${({ $variant }) => $variant === "outlined" && css13`
      padding: ${space("primitives_space_12")};
      background-color: ${tok("semantics_views_background_color")};
      border: ${tokPx("semantics_input_fields_border_width")} solid ${tok("semantics_selectors_border_color")};
    `}

  ${({ $disabled }) => modDisabled4($disabled)};

  ${focusWithinOutline()}
`;
function SelectionField({
  label,
  id,
  disabled,
  className,
  select,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsxs7(Wrapper3, {
    $disabled: disabled,
    htmlFor: id,
    className,
    $variant: variant,
    children: [
      select === "checkbox" ? /* @__PURE__ */ jsx13(Checkbox, {
        className,
        disabled,
        id,
        ...rest
      }) : /* @__PURE__ */ jsx13(RadioButton_default, {
        className,
        disabled,
        id,
        ...rest
      }),
      label && /* @__PURE__ */ jsx13(Typography_default, {
        $variant: "body-m-regular-tight",
        children: label
      })
    ]
  });
}
function modDisabled4(disabled) {
  if (!disabled) {
    return "";
  }
  return css13`
    cursor: initial;
    opacity: ${tok("primitives_opacity_disabled")}%;

    ${RadioButton_default} {
      opacity: initial;
    }

    ${Checkbox} {
      opacity: initial;
    }
  `;
}

// src/uds/components/Fields/CheckboxField.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function CheckboxField({
  label,
  id,
  disabled,
  className,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsx14(SelectionField, {
    label,
    disabled,
    className,
    variant,
    select: "checkbox",
    ...rest
  });
}

// src/uds/components/Fields/DateField.tsx
import { forwardRef as forwardRef2, useImperativeHandle, useRef } from "react";
import { styled as styled18 } from "styled-components";

// src/uds/components/Fields/BaseField.tsx
import { css as css14, styled as styled17 } from "styled-components";
import { jsx as jsx15, jsxs as jsxs8 } from "react/jsx-runtime";
function ValidationIcon({ status, className }) {
  if (status === "default") {
    return null;
  }
  return /* @__PURE__ */ jsx15(Icon_default, {
    size: 20,
    className,
    glyph: status === "error" ? "ExclamationInCircle" : "CheckMarkInCircle"
  });
}
var StyledValidationIcon = styled17(ValidationIcon)`
  & > svg {
    width: ${space("primitives_space_20")};
    height: ${space("primitives_space_20")};
  }
`;
var BaseFieldWrapper = styled17.div`
  display: flex;
  align-items: center;
  background: ${tok("semantics_input_fields_background_color")};
  border: solid 2px ${tok("semantics_input_fields_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  height: ${tokPx("semantics_controls_m_min_height")};
  position: relative;
  cursor: pointer;
  margin-bottom: ${space("primitives_space_2")};
  overflow: hidden;

  &:hover {
    border-color: ${tok("semantics_input_fields_hover_border_color")};
  }

  ${StyledValidationIcon} {
    ${({ status }) => status === "error" && css14`
        color: ${tok("semantics_input_fields_invalid_icon_color")};
      `}
    ${({ status }) => status === "success" && css14`
        color: ${tok("semantics_input_fields_valid_icon_color")};
      `}
  }

  ${focusWithinOutline()}
  ${({ disabled }) => disabled && modDisabled5()}
  ${({ status }) => status === "error" && modError()}
  ${({ status }) => status === "success" && modSuccess()}
`;
var Label = styled17(Typography_default)`
  padding-bottom: ${space("primitives_space_4")};
  display: block;
`;
var HelpText = styled17(Typography_default)`
  display: block;
  vertical-align: middle;
`;
var FeedbackText = styled17(Typography_default)`
  display: block;
  color: ${tok("primitives_color_danger_500")};
  :not(:last-child) {
    padding-bottom: ${space("primitives_space_2")};
  }
`;
var WrapperWithLabels = styled17.label`

  ${Label}, ${FeedbackText}, ${HelpText} {
    ${({ $disabled }) => $disabled && css14`opacity: ${tok("primitives_opacity_disabled")}%;`}
  }
`;
function BaseField({
  disabled,
  status,
  className,
  label,
  helpText,
  feedbackText,
  attributes,
  children
}) {
  const wrapper = /* @__PURE__ */ jsx15(BaseFieldWrapper, {
    className,
    disabled,
    status,
    ...attributes,
    children
  });
  if (label || helpText || feedbackText) {
    return /* @__PURE__ */ jsxs8(WrapperWithLabels, {
      $disabled: disabled,
      children: [
        /* @__PURE__ */ jsx15(Label, {
          $variant: "body-m-regular-tight",
          children: label
        }),
        wrapper,
        feedbackText && status === "error" ? /* @__PURE__ */ jsx15(FeedbackText, {
          $variant: "body-s-regular-tight",
          children: feedbackText
        }) : null,
        helpText ? /* @__PURE__ */ jsx15(HelpText, {
          $variant: "body-s-regular-tight",
          children: helpText
        }) : null
      ]
    });
  }
  return wrapper;
}
function modDisabled5() {
  return css14`
  border-color: ${tok("semantics_input_fields_border_color")};
  box-shadow: none;
  pointer-events: none;
  cursor: default;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
function modError() {
  return css14`
  border-color: ${tok("semantics_input_fields_invalid_border_color")};
  &:hover {
    border-color: ${tok("semantics_input_fields_invalid_hover_border_color")};
  }
`;
}
function modSuccess() {
  return css14`
  border-color: ${tok("semantics_input_fields_valid_border_color")};
  &:hover {
    border-color: ${tok("semantics_input_fields_valid_hover_border_color")};
  }
`;
}
function inputStyles() {
  return css14`
    width: 100%;
  cursor: pointer;
  background: transparent;
  ${Typography_default.modVariant("body-m-regular-tight")}
  color: ${tok("semantics_content_color")};
  margin: 0;
  border: none;
  text-overflow: ellipsis;
  padding-left: ${space("primitives_space_16")};
  padding-top: ${space("primitives_space_12")};
  padding-bottom: ${space("primitives_space_12")};

  &:focus {
    border-color: transparent;
    outline: none;
  }

  &::placeholder {
    color: ${tok("semantics_input_fields_placeholder_color")};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 9999s ease-in-out 0s;
    -webkit-text-fill-color: ${tok("semantics_content_color")} !important;
    background-color: transparent !important;
    box-shadow: 0 0 0 1000px transparent inset !important;
  }
  `;
}
var Input = styled17.input`
  ${inputStyles()}
`;

// src/uds/components/Fields/DateField.tsx
import { jsx as jsx16, jsxs as jsxs9 } from "react/jsx-runtime";
var DateFieldIcons = styled18.div`
  position: absolute;
  right: ${space("primitives_space_0")};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 3;
  background: ${tok("semantics_input_fields_background_color")};
  height: 100%;
  padding-right: ${space("primitives_space_16")};
`;
var IconCalendar = styled18.button`
  display: flex;
  align-items: center;
  ${Icon_default} {
    color: ${tok("semantics_content_color")};
  }
`;
var BaseFieldStyled = styled18(BaseField)`
  width: ${tokPx("primitives_area_size_200")};
  &[data-empty='true'] > ${Input} {
    color: ${tok("semantics_input_fields_placeholder_color")};
  }
`;
var DateInput = styled18(Input)`
  cursor: default;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-calendar-picker-indicator {
    display: none;
    pointer-events: none;
  }
  ${IconCalendar} {
    cursor: default;
  }
`;
var StyledValidationDateFieldIcon = styled18(StyledValidationIcon)`
  padding-right: ${space("primitives_space_6")};
}`;
var DateField = forwardRef2(
  (props, ref) => {
    var _a;
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => {
      if (!inputRef.current) {
        throw new Error("DateField inputRef is unexpectedly null");
      }
      return inputRef.current;
    });
    const handleIconClick = () => {
      var _a2, _b, _c;
      (_b = (_a2 = inputRef.current) == null ? void 0 : _a2.showPicker) == null ? void 0 : _b.call(_a2);
      (_c = inputRef.current) == null ? void 0 : _c.focus();
    };
    return /* @__PURE__ */ jsxs9(BaseFieldStyled, {
      ...props,
      children: [
        /* @__PURE__ */ jsx16(DateInput, {
          ref: inputRef,
          name: props.name,
          disabled: props.disabled,
          value: props.value,
          onChange: props.onChange,
          onBlur: props.onBlur,
          type: "date",
          min: props.minDate,
          max: props.maxDate,
          "aria-label": props.label
        }),
        /* @__PURE__ */ jsxs9(DateFieldIcons, {
          children: [
            /* @__PURE__ */ jsx16(StyledValidationDateFieldIcon, {
              status: (_a = props.status) != null ? _a : "default"
            }),
            /* @__PURE__ */ jsx16(IconCalendar, {
              onClick: handleIconClick,
              type: "button",
              "aria-label": `Select ${props.label}`,
              children: /* @__PURE__ */ jsx16(Icon_default, {
                size: 20,
                glyph: "Calendar"
              })
            })
          ]
        })
      ]
    });
  }
);
DateField.displayName = "DateField";
var DateField_default = styled18(DateField)`
  position: relative;
`;

// src/uds/components/Fields/PasswordField.tsx
import { styled as styled19 } from "styled-components";
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
var IconPswdBtn = styled19.button`
  padding: ${space("primitives_space_12")};
  display: flex;
  align-items: center;
`;
function PasswordField(props) {
  var _a;
  return /* @__PURE__ */ jsxs10(BaseField, {
    ...props,
    children: [
      /* @__PURE__ */ jsx17(Input, {
        disabled: props.disabled,
        type: "password",
        value: "1234"
      }),
      /* @__PURE__ */ jsx17(StyledValidationIcon, {
        status: (_a = props.status) != null ? _a : "default"
      }),
      /* @__PURE__ */ jsx17(IconPswdBtn, {
        children: /* @__PURE__ */ jsx17(Icon_default, {
          size: 16,
          glyph: "Eye"
        })
      })
    ]
  });
}
var PasswordField_default = styled19(PasswordField)``;

// src/uds/components/Fields/PhoneField/country-data.ts
var countryData = [
  { name: "Oostenrijk", code: "43", icon: "IconFlagAt", pattern: "^[0-9]{10,11}$", isoCode: "AT" },
  { name: "Belgi\xEB", code: "32", icon: "IconFlagBe", pattern: "^[0-9]{8,9}$", isoCode: "BE" },
  { name: "Bulgarije", code: "359", icon: "IconFlagBg", pattern: "^[0-9]{8,9}$", isoCode: "BG" },
  { name: "Kroati\xEB", code: "385", icon: "IconFlagHr", pattern: "^[0-9]{9,10}$", isoCode: "HR" },
  { name: "Cyprus", code: "357", icon: "IconFlagCy", pattern: "^[0-9]{8}$", isoCode: "CY" },
  { name: "Tsjechi\xEB", code: "420", icon: "IconFlagCz", pattern: "^[0-9]{9}$", isoCode: "CZ" },
  { name: "Denemarken", code: "45", icon: "IconFlagDk", pattern: "^[0-9]{8}$", isoCode: "DK" },
  { name: "Estland", code: "372", icon: "IconFlagEe", pattern: "^[0-9]{7,8}$", isoCode: "EE" },
  { name: "Finland", code: "358", icon: "IconFlagFi", pattern: "^[0-9]{7,12}$", isoCode: "FI" },
  { name: "Frankrijk", code: "33", icon: "IconFlagFr", pattern: "^[0-9]{9}$", isoCode: "FR" },
  { name: "Duitsland", code: "49", icon: "IconFlagDe", pattern: "^[0-9]{10,14}$", isoCode: "DE" },
  { name: "Griekenland", code: "30", icon: "IconFlagGr", pattern: "^[0-9]{10}$", isoCode: "GR" },
  { name: "Hongarije", code: "36", icon: "IconFlagHu", pattern: "^[0-9]{8,9}$", isoCode: "HU" },
  { name: "Ierland", code: "353", icon: "IconFlagIe", pattern: "^[0-9]{9,10}$", isoCode: "IE" },
  { name: "Itali\xEB", code: "39", icon: "IconFlagIt", pattern: "^[0-9]{9,10}$", isoCode: "IT" },
  { name: "Letland", code: "371", icon: "IconFlagLv", pattern: "^[0-9]{8}$", isoCode: "LV" },
  { name: "Litouwen", code: "370", icon: "IconFlagLt", pattern: "^[0-9]{8}$", isoCode: "LT" },
  { name: "Luxemburg", code: "352", icon: "IconFlagLu", pattern: "^[0-9]{9}$", isoCode: "LU" },
  { name: "Malta", code: "356", icon: "IconFlagMt", pattern: "^[0-9]{8}$", isoCode: "MT" },
  { name: "Nederland", code: "31", icon: "IconFlagNl", pattern: "^[0-9]{9}$", isoCode: "NL" },
  { name: "Polen", code: "48", icon: "IconFlagPl", pattern: "^[0-9]{9}$", isoCode: "PL" },
  { name: "Portugal", code: "351", icon: "IconFlagPt", pattern: "^[0-9]{9}$", isoCode: "PT" },
  { name: "Roemeni\xEB", code: "40", icon: "IconFlagRo", pattern: "^[0-9]{9,10}$", isoCode: "RO" },
  { name: "Slowakije", code: "421", icon: "IconFlagSk", pattern: "^[0-9]{9}$", isoCode: "SK" },
  { name: "Sloveni\xEB", code: "386", icon: "IconFlagSi", pattern: "^[0-9]{9}$", isoCode: "SI" },
  { name: "Spanje", code: "34", icon: "IconFlagEs", pattern: "^[0-9]{9}$", isoCode: "ES" },
  { name: "Zweden", code: "46", icon: "IconFlagSe", pattern: "^[0-9]{7,10}$", isoCode: "SE" }
];

// src/uds/components/Fields/PhoneField/PhoneField.tsx
import React4, { forwardRef as forwardRef3 } from "react";
import { styled as styled23 } from "styled-components";

// src/uds/components/IconCountryFlag/IconCountryFlag.tsx
import { css as css15, styled as styled20 } from "styled-components";

// src/country-flag-icons/generated/index.ts
var generated_exports = {};
__export(generated_exports, {
  IconFlagAd: () => Ad_default,
  IconFlagAe: () => Ae_default,
  IconFlagAf: () => Af_default,
  IconFlagAg: () => Ag_default,
  IconFlagAi: () => Ai_default,
  IconFlagAl: () => Al_default,
  IconFlagAm: () => Am_default,
  IconFlagAo: () => Ao_default,
  IconFlagAq: () => Aq_default,
  IconFlagAr: () => Ar_default,
  IconFlagAs: () => As_default,
  IconFlagAt: () => At_default,
  IconFlagAu: () => Au_default,
  IconFlagAw: () => Aw_default,
  IconFlagAx: () => Ax_default,
  IconFlagAz: () => Az_default,
  IconFlagBa: () => Ba_default,
  IconFlagBb: () => Bb_default,
  IconFlagBd: () => Bd_default,
  IconFlagBe: () => Be_default,
  IconFlagBf: () => Bf_default,
  IconFlagBg: () => Bg_default,
  IconFlagBh: () => Bh_default,
  IconFlagBi: () => Bi_default,
  IconFlagBj: () => Bj_default,
  IconFlagBl: () => Bl_default,
  IconFlagBm: () => Bm_default,
  IconFlagBn: () => Bn_default,
  IconFlagBo: () => Bo_default,
  IconFlagBq: () => Bq_default,
  IconFlagBr: () => Br_default,
  IconFlagBs: () => Bs_default,
  IconFlagBt: () => Bt_default,
  IconFlagBv: () => Bv_default,
  IconFlagBw: () => Bw_default,
  IconFlagBy: () => By_default,
  IconFlagBz: () => Bz_default,
  IconFlagCa: () => Ca_default,
  IconFlagCc: () => Cc_default,
  IconFlagCd: () => Cd_default,
  IconFlagCf: () => Cf_default,
  IconFlagCg: () => Cg_default,
  IconFlagCh: () => Ch_default,
  IconFlagCi: () => Ci_default,
  IconFlagCk: () => Ck_default,
  IconFlagCl: () => Cl_default,
  IconFlagCm: () => Cm_default,
  IconFlagCn: () => Cn_default,
  IconFlagCo: () => Co_default,
  IconFlagCp: () => Cp_default,
  IconFlagCr: () => Cr_default,
  IconFlagCu: () => Cu_default,
  IconFlagCv: () => Cv_default,
  IconFlagCw: () => Cw_default,
  IconFlagCx: () => Cx_default,
  IconFlagCy: () => Cy_default,
  IconFlagCz: () => Cz_default,
  IconFlagDe: () => De_default,
  IconFlagDj: () => Dj_default,
  IconFlagDk: () => Dk_default,
  IconFlagDm: () => Dm_default,
  IconFlagDo: () => Do_default,
  IconFlagDz: () => Dz_default,
  IconFlagEc: () => Ec_default,
  IconFlagEe: () => Ee_default,
  IconFlagEg: () => Eg_default,
  IconFlagEh: () => Eh_default,
  IconFlagEr: () => Er_default,
  IconFlagEs: () => Es_default,
  IconFlagEt: () => Et_default,
  IconFlagFi: () => Fi_default,
  IconFlagFj: () => Fj_default,
  IconFlagFk: () => Fk_default,
  IconFlagFm: () => Fm_default,
  IconFlagFo: () => Fo_default,
  IconFlagFr: () => Fr_default,
  IconFlagGa: () => Ga_default,
  IconFlagGb: () => Gb_default,
  IconFlagGd: () => Gd_default,
  IconFlagGe: () => Ge_default,
  IconFlagGf: () => Gf_default,
  IconFlagGg: () => Gg_default,
  IconFlagGh: () => Gh_default,
  IconFlagGi: () => Gi_default,
  IconFlagGl: () => Gl_default,
  IconFlagGm: () => Gm_default,
  IconFlagGn: () => Gn_default,
  IconFlagGp: () => Gp_default,
  IconFlagGq: () => Gq_default,
  IconFlagGr: () => Gr_default,
  IconFlagGs: () => Gs_default,
  IconFlagGt: () => Gt_default,
  IconFlagGu: () => Gu_default,
  IconFlagGw: () => Gw_default,
  IconFlagGy: () => Gy_default,
  IconFlagHk: () => Hk_default,
  IconFlagHm: () => Hm_default,
  IconFlagHn: () => Hn_default,
  IconFlagHr: () => Hr_default,
  IconFlagHt: () => Ht_default,
  IconFlagHu: () => Hu_default,
  IconFlagId: () => Id_default,
  IconFlagIe: () => Ie_default,
  IconFlagIl: () => Il_default,
  IconFlagIm: () => Im_default,
  IconFlagIn: () => In_default,
  IconFlagIo: () => Io_default,
  IconFlagIq: () => Iq_default,
  IconFlagIr: () => Ir_default,
  IconFlagIs: () => Is_default,
  IconFlagIt: () => It_default,
  IconFlagJe: () => Je_default,
  IconFlagJm: () => Jm_default,
  IconFlagJo: () => Jo_default,
  IconFlagJp: () => Jp_default,
  IconFlagKe: () => Ke_default,
  IconFlagKg: () => Kg_default,
  IconFlagKh: () => Kh_default,
  IconFlagKi: () => Ki_default,
  IconFlagKm: () => Km_default,
  IconFlagKn: () => Kn_default,
  IconFlagKp: () => Kp_default,
  IconFlagKr: () => Kr_default,
  IconFlagKw: () => Kw_default,
  IconFlagKy: () => Ky_default,
  IconFlagKz: () => Kz_default,
  IconFlagLa: () => La_default,
  IconFlagLb: () => Lb_default,
  IconFlagLc: () => Lc_default,
  IconFlagLi: () => Li_default,
  IconFlagLk: () => Lk_default,
  IconFlagLr: () => Lr_default,
  IconFlagLs: () => Ls_default,
  IconFlagLt: () => Lt_default,
  IconFlagLu: () => Lu_default,
  IconFlagLv: () => Lv_default,
  IconFlagLy: () => Ly_default,
  IconFlagMa: () => Ma_default,
  IconFlagMc: () => Mc_default,
  IconFlagMd: () => Md_default,
  IconFlagMe: () => Me_default,
  IconFlagMf: () => Mf_default,
  IconFlagMg: () => Mg_default,
  IconFlagMh: () => Mh_default,
  IconFlagMk: () => Mk_default,
  IconFlagMl: () => Ml_default,
  IconFlagMm: () => Mm_default,
  IconFlagMn: () => Mn_default,
  IconFlagMo: () => Mo_default,
  IconFlagMp: () => Mp_default,
  IconFlagMq: () => Mq_default,
  IconFlagMr: () => Mr_default,
  IconFlagMs: () => Ms_default,
  IconFlagMt: () => Mt_default,
  IconFlagMu: () => Mu_default,
  IconFlagMv: () => Mv_default,
  IconFlagMw: () => Mw_default,
  IconFlagMx: () => Mx_default,
  IconFlagMy: () => My_default,
  IconFlagMz: () => Mz_default,
  IconFlagNa: () => Na_default,
  IconFlagNc: () => Nc_default,
  IconFlagNe: () => Ne_default,
  IconFlagNf: () => Nf_default,
  IconFlagNg: () => Ng_default,
  IconFlagNi: () => Ni_default,
  IconFlagNl: () => Nl_default,
  IconFlagNo: () => No_default,
  IconFlagNp: () => Np_default,
  IconFlagNr: () => Nr_default,
  IconFlagNu: () => Nu_default,
  IconFlagNz: () => Nz_default,
  IconFlagOm: () => Om_default,
  IconFlagPa: () => Pa_default,
  IconFlagPe: () => Pe_default,
  IconFlagPf: () => Pf_default,
  IconFlagPg: () => Pg_default,
  IconFlagPh: () => Ph_default,
  IconFlagPk: () => Pk_default,
  IconFlagPl: () => Pl_default,
  IconFlagPm: () => Pm_default,
  IconFlagPn: () => Pn_default,
  IconFlagPr: () => Pr_default,
  IconFlagPs: () => Ps_default,
  IconFlagPt: () => Pt_default,
  IconFlagPw: () => Pw_default,
  IconFlagPy: () => Py_default,
  IconFlagQa: () => Qa_default,
  IconFlagRe: () => Re_default,
  IconFlagRo: () => Ro_default,
  IconFlagRs: () => Rs_default,
  IconFlagRu: () => Ru_default,
  IconFlagRw: () => Rw_default,
  IconFlagSa: () => Sa_default,
  IconFlagSb: () => Sb_default,
  IconFlagSc: () => Sc_default,
  IconFlagSd: () => Sd_default,
  IconFlagSe: () => Se_default,
  IconFlagSg: () => Sg_default,
  IconFlagSh: () => Sh_default,
  IconFlagSi: () => Si_default,
  IconFlagSj: () => Sj_default,
  IconFlagSk: () => Sk_default,
  IconFlagSl: () => Sl_default,
  IconFlagSm: () => Sm_default,
  IconFlagSn: () => Sn_default,
  IconFlagSo: () => So_default,
  IconFlagSr: () => Sr_default,
  IconFlagSs: () => Ss_default,
  IconFlagSt: () => St_default,
  IconFlagSv: () => Sv_default,
  IconFlagSx: () => Sx_default,
  IconFlagSy: () => Sy_default,
  IconFlagSz: () => Sz_default,
  IconFlagTc: () => Tc_default,
  IconFlagTd: () => Td_default,
  IconFlagTf: () => Tf_default,
  IconFlagTg: () => Tg_default,
  IconFlagTh: () => Th_default,
  IconFlagTj: () => Tj_default,
  IconFlagTk: () => Tk_default,
  IconFlagTl: () => Tl_default,
  IconFlagTm: () => Tm_default,
  IconFlagTn: () => Tn_default,
  IconFlagTo: () => To_default,
  IconFlagTr: () => Tr_default,
  IconFlagTt: () => Tt_default,
  IconFlagTv: () => Tv_default,
  IconFlagTw: () => Tw_default,
  IconFlagTz: () => Tz_default,
  IconFlagUa: () => Ua_default,
  IconFlagUg: () => Ug_default,
  IconFlagUm: () => Um_default,
  IconFlagUs: () => Us_default,
  IconFlagUy: () => Uy_default,
  IconFlagUz: () => Uz_default,
  IconFlagVa: () => Va_default,
  IconFlagVc: () => Vc_default,
  IconFlagVe: () => Ve_default,
  IconFlagVg: () => Vg_default,
  IconFlagVi: () => Vi_default,
  IconFlagVn: () => Vn_default,
  IconFlagVu: () => Vu_default,
  IconFlagWf: () => Wf_default,
  IconFlagWs: () => Ws_default,
  IconFlagYe: () => Ye_default,
  IconFlagYt: () => Yt_default,
  IconFlagZa: () => Za_default,
  IconFlagZm: () => Zm_default,
  IconFlagZw: () => Zw_default
});

// src/country-flag-icons/generated/Ad.tsx
import { jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
var SvgAd = (props) => /* @__PURE__ */ jsxs11("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx18("path", {
      fill: "#d0103a",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx18("path", {
      fill: "#fedf00",
      d: "M0 0h435.2v480H0z"
    }),
    /* @__PURE__ */ jsx18("path", {
      fill: "#0018a8",
      d: "M0 0h204.8v480H0z"
    }),
    /* @__PURE__ */ jsx18("path", {
      fill: "#c7b37f",
      d: "M300.4 136.6c7.7 0 10.9 6.6 18.6 6.6 4.7 0 7.5-1.5 11.7-3.9 2.9-1.6 4.7-2.5 8-2.5 3.4 0 5.5 1 7.3 4 1 1.6 1.8 4.9 1.3 6.7a40 40 0 0 1-2.7 8.3c-.7 1.6-1.3 2.5-1.3 4.2 0 4.1 5.6 5.5 9.4 5.6.8 0 7.7 0 12-4.2-2.3-.1-4.9-2-4.9-4.3 0-2.6 1.8-4.3 4.3-5.1.5-.1 1.3.3 1.7 0 .7-.3.4-1 1-1.4 1.2-1 2-1.6 3.6-1.6 1 0 1.6.1 2.5.7.4.4.6.8 1 .8 1.2 0 1.8-.8 3-.8a5 5 0 0 1 2.3.6c.6.3.6 1.5 1.4 1.5.4 0 2.4-.9 3.5-.9 2.2 0 3.4.8 4.8 2.5.4.5.6 1.4 1 1.4a6.2 6.2 0 0 1 4.8 3c.3.4.7 1.4 1.1 1.5.6.3 1 .2 1.7.7a6 6 0 0 1 2.8 4.8c0 .7-.3 1.6-.5 2.2-1.8 6.5-6.3 8.6-10.8 14.3-2 2.4-3.5 4.3-3.5 7.4 0 .7 1 2.1 1.3 2.7-.2-1.4.5-3.2 2-3.3a4 4 0 0 1 4 3.6 4.5 4.5 0 0 1-.3 1.8 9.6 9.6 0 0 1 4-1.4h1.9c3.3 0 7 1.9 9.3 3.8a21 21 0 0 1 7.3 16.8c-.8 5.2-.3 14.8-13.8 18.6 2.5 1 4.2 3 4.2 5.2a4.5 4.5 0 0 1-4.4 4.7 4.4 4.4 0 0 1-3.5-1.4c-2.8 2.8-3.3 5.7-3.3 9.7 0 2.4.4 3.8 1.4 6 1 2.2 1.8 3.5 3.7 5.1 1-1.5 2.1-2.6 4-2.6 1.7 0 3.2.6 3.9 2.2.2.5 0 .9.3 1.4.3.6.8.7 1.1 1.3.5 1 0 1.8.5 2.7.3.7.9.8 1.2 1.4.4 1 .5 1.6.5 2.7 0 3-2.7 5.2-5.7 5.2-1 0-1.4-.4-2.3-.3 1.7 1.7 3 2.5 4.3 4.5a17.7 17.7 0 0 1 3 10.3 22 22 0 0 1-2.8 11.2 20 20 0 0 1-7 8.5 35 35 0 0 1-16 6.4 74.4 74.4 0 0 1-11 1.4l-14.1.8c-7.2.4-12.2 1.5-17.3 6.6 2.4 1.7 4 3.5 4 6.4 0 3-1.8 5.3-4.7 6.2-.7.2-1.2 0-1.9.4s-.7 1.3-1.4 1.7a6.2 6.2 0 0 1-3.8 1 8 8 0 0 1-6.4-2.5c-2.2 1.8-3 3.4-5.5 4.9-.8.4-1.2 1-2.1 1-1.5 0-2.2-1-3.4-1.8a23 23 0 0 1-4.4-4c-2.3 1.3-3.6 2.4-6.3 2.4a7 7 0 0 1-4-1c-.6-.5-.8-1.2-1.5-1.6-.7-.5-1.3-.3-2.1-.7-3-1.3-5-3.5-5-6.8 0-2.9 1.8-4.7 4.4-6-5-5-10-5.8-17-6.2l-14-.8c-4.4-.3-6.8-.7-11-1.4-3.3-.5-5.2-.7-8.2-2.1-10.2-4.8-16.8-11.3-18-22.5-.2-1-.2-1.5-.2-2.5 0-5.8 2.3-9.4 6.4-13.5-1-.3-1.7 0-2.8-.3-2.5-1-4.4-2.7-4.4-5.5 0-1 0-1.7.5-2.6.4-.6 1-.7 1.2-1.4.2-1 0-1.6.4-2.5.3-.5.8-.6 1-1.2 1-1.9 2-3.4 4.1-3.4 1.8 0 3 1 3.8 2.5 1.8-.8 2.2-2.1 3.2-3.7a15.5 15.5 0 0 0 1.4-13.3c-.4-1.5-.6-2.5-1.8-3.7-1 1-2 1.4-3.4 1.4-2.9 0-5-2.5-5-5.3a4.8 4.8 0 0 1 3-4.6c-1.6-1.4-3-1.5-4.7-2.6-2.6-1.6-3.5-3.4-5.2-6-1.2-1.6-1.5-2.8-2-4.7a19 19 0 0 1-1-7.8c.6-5 1.5-8 4.6-11.9 1.8-2.3 3-3.7 5.8-4.9 2.3-1 3.7-1.7 6.2-1.7l2 .1a6.9 6.9 0 0 1 2.8.8c.4.2 1.1.9 1.1.4s-.3-.8-.3-1.3c0-2 1.5-4 3.6-4 1.5 0 2.1 1.4 2.9 2.7.4-.8.7-1.4.7-2.3 0-3.4-1.9-5.2-4-7.9-4.7-5.8-10.5-8.5-10.5-16 0-2.2 1-3.7 3-4.9.5-.3 1.3 0 1.8-.3s.4-1 .7-1.4c.5-.7 1-1 1.6-1.6 1-1 2-.6 3.1-1.5.6-.4.8-1 1.2-1.4 1.3-1.6 2.5-2.4 4.6-2.4 1 0 1.6 0 2.5.4l1 .5c.3-.2.8-.8 1.5-1.1a4 4 0 0 1 2.2-.6c1.1 0 1.8.6 3 .6.3 0 .4-.4.8-.6 1-.7 1.5-1 2.7-1 1.2 0 1.8.3 2.8 1 1 .5 1 1.3 2 1.8.5.3 1 .2 1.5.4 2.6.9 4.5 2.6 4.5 5.3 0 1.5-.3 2.5-1.4 3.5-.9.7-1.7.6-2.8 1a16 16 0 0 0 11.3 3.5c4.2 0 9.3-1.7 9.3-5.9 0-2-1-3-1.8-4.8a18.8 18.8 0 0 1-2.1-8.5c0-2.8.3-4.5 1.9-6.7 1.6-2.3 3.6-2.9 6.5-2.9"
    }),
    /* @__PURE__ */ jsxs11("g", {
      fill: "none",
      stroke: "#703d29",
      children: [
        /* @__PURE__ */ jsx18("path", {
          strokeLinejoin: "round",
          strokeWidth: 0.7,
          d: "M272.4 159a3.6 3.6 0 0 0 2.4 2.4c.8.3 2.7.2 3.8-1.4 1-1.2 1-2.8.6-4a4.7 4.7 0 0 0-1.7-2.2z"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeLinecap: "round",
          strokeWidth: 0.7,
          d: "M401 236.1c-1.2-2.9-4.3-1.6-4.4 0-.5 3.7 2.7 4.8 5 4.2a4 4 0 0 0 2.5-2c.6-1 .8-2.4.4-3.7a4.9 4.9 0 0 0-.8-1.6 5 5 0 0 0-1.3-1.2c-.9-.6-1.9-.6-3.4-.6-5.5 0-10.4 6.5-12 13.4-.6 2.2-1.3 7.3-.3 12a22.4 22.4 0 0 0 5.9 11.3 25.7 25.7 0 0 0 9.9 5.8 7.9 7.9 0 0 0 4 .1c3.2-.7 4.7-3.8 3-7-1.3-2.5-5.3-4-7.2-.6-.1.3-.4.9-.4 1.5 0 .9.4 2 1 2.4 1.5.9 3.8.6 3.7-2"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.8,
          d: "M383.8 274a11.3 11.3 0 0 1 6.6-3.7c3-.4 5.6.5 8.2 2a18.5 18.5 0 0 1 10.8 17c0 3.6-1 7.5-2 9.4-.8 1.7-3 9-15.3 14-7.1 3-18 3.6-25.7 4-10.4.3-20 .7-25.5 7.6"
        }),
        /* @__PURE__ */ jsxs11("g", {
          strokeWidth: 0.7,
          children: [
            /* @__PURE__ */ jsx18("path", {
              d: "M386.4 285.7c-.3-1 0-2.1.8-3.3 1.2-1.6 3.7-2.1 6-1a7.4 7.4 0 0 1 2.5 2.2l1.1 1.6c.7 1.1 1 2 1 2.5 2.5 7-1.4 14.5-6.5 17.6-4 2.4-8.7 3.4-14.4 4-2.5.4-4 .3-6.5.5h-9.6a70.1 70.1 0 0 0-7.2 0c-2.9.3-5 .4-7.6.8-1.6.2-3.4.5-5.4 1-.6 0-1.2.2-1.8.4l-1.2.3c-3.6 1.1-7 2.4-9.8 4.2-.8.5-1.8 1-2.5 1.7l-1.3 1.2c-2 2-3.9 4-4.4 6.7v1.6c0 1.8 1.4 4.3 5.4 5m5.5-170c.8 1.4 1.3 2.3.8 3.9-.6 1.7-1.8 2.8-3.6 2.8-4 0-6.3-4.8-4.5-7.8 3.2-5.3 9.3-2.3 15 .3-.3-1.3-.8-1.8-.7-3.5.1-4.2 3.2-6 4.5-10 .7-2.3 1-4.3-.7-6-1.5-1.3-3.2-1.3-5.1-.6-3.8 1.5-8.5 5.9-16.6 6-8.2-.1-12.8-4.5-16.7-6-2-.7-3.6-.7-5.1.7-1.7 1.6-1.4 3.6-.7 6 1.3 3.8 4.4 5.7 4.5 10 0 1.6-.4 2-.7 3.4 5.7-2.6 12-5.9 15-.3 1.7 3.2-.5 7.7-4.5 7.7-1.8 0-3-1-3.6-2.7-.4-1.5 0-2.8.8-4"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M314.6 159.9a5.3 5.3 0 0 1 2.4 5c-.2 2.5-.8 3.1-2.8 4.5m2.4-3.8c-.1 1.5-.7 2.5-2.3 3.1"
            })
          ]
        }),
        /* @__PURE__ */ jsx18("path", {
          fill: "#c7b37f",
          stroke: "none",
          d: "m276.7 153.3.7.5.8.8.5 1 .2.8v1.9l-.2.8-.5.6-.6.6-.9.5-1 .2-1 .2-1-.5-.9-.6-.5-.8-.4-1v-.4z"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeLinecap: "round",
          strokeWidth: 0.7,
          d: "M275.2 157.2c-.3-1.7-2.2-2-3-1-1.1 1.5-.3 4 2 4.7a4 4 0 0 0 3.9-1.4c1-1.3.9-2.8.5-4a4.5 4.5 0 0 0-1.7-2.2c-2.7-2-7.1-1.6-8.6 2-1.8 4.4 2.2 7.8 6 10.3 4.6 3.2 10 3.8 14 3.8 9.2-.1 16.2-4.5 20.7-7 1-.6 2.1-.5 2.7.2a2 2 0 0 1-.3 2.7"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.7,
          d: "m248 281.2-2 .7-2 1.6-1 1.3-1.1 2-.5 1.5-.4 1.8-.2 1.4m19-10.1-.1 1.8-.3 1.2-1 2.2-1.3 1.8-1.5 1.2-1.1.5-1.6.4"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.8,
          d: "M319.7 329.1c-.3 1.7-1.9 3.6-5.3 4.2l-.6.2"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.9,
          d: "M404.2 276.2a18.3 18.3 0 0 1 5.6 13.5c0 3.6-1 7.5-2 9.4-.8 1.7-3 9-15.3 14a85 85 0 0 1-25.6 4c-10.3.3-19.8.7-25.4 7.3"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.6,
          d: "M387.5 282.9c.8-1 3.5-2.4 5.8-1.1a6.2 6.2 0 0 1 2.3 2"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.9,
          d: "m401.6 273.8 1.4.5a7 7 0 0 0 4 0c2.8-.8 4.6-3.4 3.2-6.9a6 6 0 0 0-1.8-2.1"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeLinecap: "round",
          strokeWidth: 0.7,
          d: "M240.3 199.8c-2 1.1-3.3 1.4-4.8 3.1a28.1 28.1 0 0 0-2.6 6.8m46-51.7c0 1.8-1.2 2.8-3 3.2"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.6,
          d: "M397.1 192a19 19 0 0 1 18.6 19.8c0 16-9.9 18.5-13.8 19.6"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.7,
          d: "M398.4 192c8.1-.3 16.5 5.7 16.9 20.7.3 11.7-8 17-12 18"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.6,
          d: "m393.8 248.4.1-1.6.6-2.5.7-2 .9-1.6 1-1.3m7.8-3.4v1.5l-.5 1-.7 1.1-.8.6-1.2.5h-1.1l-.8-.1m-14.3-52.8.3-1.7.8-1.6 1-1.5 1.6-2.2 1.4-1.4 2-2.2 2-1.9 1.1-1.3 1.5-1.9 1.4-2 .8-1.7.5-2.2.1-2.7-.2-.8m-12.3 128.2 1.6-.4 1.2-.6.7-.7.5-.8.3-1.2v-.9m-158.2-12.1h2.7l1.6-.6m5-36.5-.2 1.4-.4.6-.4.6-.7.5-.7.3-1 .1h-.6m9.9-15.5-.3 2.1-.5 1-.8 1.2-1.2.9-1.2.6-2.3.5m15.3-39.7-.5 1.3-.5 1-.8 1-1 1-1.2.5-1.1.3-.6-.1m.3-6.2v1"
        }),
        /* @__PURE__ */ jsxs11("g", {
          strokeWidth: 0.6,
          children: [
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M254.3 224a6.9 6.9 0 0 1-2.1 1.4m150.5 44.8.5.2c1.4.8 4.2-.2 3.4-2.4"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M397.8 239.6c1 1.3 2.9 1.7 4.4 1.3a4 4 0 0 0 2.5-2c.6-1 .8-2.4.4-3.7a4.9 4.9 0 0 0-.9-1.6 6.8 6.8 0 0 0-1.3-1.5l-.4-.2m6.4 34a4 4 0 0 0 .1-.7 4 4 0 0 0-1.3-3l-.8-.8m.4.5c0-1.8-1.5-3.2-3.4-3.5m-4.2 2.8-1.3-1a15.7 15.7 0 0 1-4.3-10.7c0-4.2 1.6-8.4 3.6-10M341.2 324l1.8-1.6 1.2-1 2.3-1.4 2.2-1 1.6-.5 3-.6 3.6-.6m-29.5 19.4a17 17 0 0 1-7.6 6.1 17.7 17.7 0 0 1-7.6-6.1"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M314.4 332.6a10 10 0 0 1-2.2 4.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "m314.7 330.5-.4 2.2M312 337l-1 1-1.7.9-2 .6m-5.6-177.8c.3-.8.5-1.4.5-2.6-.1-4.2-3.2-6.1-4.5-10-.7-2.3-1-4.3.7-6 1.4-1.4 3.2-1.4 5-.6 4 1.5 8.6 5.8 16.7 6-8.1-.2-12.8-4.5-16.6-6-2-.8-3.8-1-5.3.5-1.7 1.6-1.2 3.8-.5 6.1 1.3 3.9 4.2 5.8 4.3 10 0 1.2-.3 1.8-.5 2.6M320 148c8-.4 14.9-5.8 17.1-6.3 2-.4 3-.2 4.5 1.1-1.4-1.3-3-1.2-5-.5-3.8 1.5-8.4 5.8-16.6 6m79.6 112.9a15.5 15.5 0 0 1-6.2-12.4c0-4.1 1.7-8.4 3.6-10m-70 97.6c-1.3 2-4.3 5-7.6 6.2a17.7 17.7 0 0 1-7.6-6.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "m306.7 163.7 2.3-1.3c1-.6 2.3-.5 2.9.2.6.7.7 2-.2 2.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M294.7 169.3c5.5-1.2 10-3.6 13.4-5.5M340.3 328c.5.3.8 1 .8 1 .1.2.3.5.3.8.3 1.5-.7 2.4-2 2.6-1.7.2-3-.8-3.5-2M294.4 169c5.5-1.1 10-3.6 13.4-5.5m97.6 106.9c-1 .4-1.6.3-3-.2l-1.8-1a20.7 20.7 0 0 1-8.4-9 18.8 18.8 0 0 1-1.7-4.6 12 12 0 0 1-.5-3.3 25.6 25.6 0 0 1 4.7-15.3c1.1-1.6 2.1-2.5 4.2-2.6m-143.7-39.3a7.1 7.1 0 0 1 2.7 5.7c0 3.1-2.6 8.2-9 10a8.3 8.3 0 0 1-6.3-.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M256.3 205.6c1.1.8 1.6 1.7 1.6 3.3 0 1-.7 2.4-1.9 3.7a12.4 12.4 0 0 1-8.8 4c-2 0-4-.4-6-1.7a9 9 0 0 1-3.8-5.4"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M256.2 212.3c1.3 1.2 1.7 2.7 1.7 4.6 0 2.7-1.1 4.8-3.7 7-.6.6-1.2 1-2 1.5m129.5-22.1v3.5m-.3-4.4v5m.3-15.8v6.6m-.3-8v8.9m-1.9 82a18.7 18.7 0 0 1-4.2 5.6 19.6 19.6 0 0 1-5.8 4.1 24.6 24.6 0 0 1-6.6 2.2 33 33 0 0 1-6.8.9c-2.5 0-3.9 0-6.4-.2-2.6-.2-4-.6-6.7-.8-2.2-.2-3.4-.4-5.6-.3a28.3 28.3 0 0 0-11 1.8c-2.6 1-5.7 3-6.3 3.8a22 22 0 0 0-6.4-3.8 22 22 0 0 0-5.1-1.4c-2.3-.4-3.5-.4-5.8-.4-2.2 0-3.4.1-5.6.3-2.6.3-4 .6-6.7.8-2.5.2-3.9.3-6.4.2a33 33 0 0 1-13.4-3 19.5 19.5 0 0 1-6.4-4.8m42.1 53.4 1.8-.2m30.3-2.4 1.8-.1 1.7-.7 1.2-.8 1.7-2 .3-.6.3-1.7v-.8m47-136.7c.7-2.6-.2-5.4-2.8-5.3m-132 46.5a8.2 8.2 0 0 1-3.5 4.7m3.6-46.7a6.5 6.5 0 0 1-3.6 4c-1.9.8-4 0-5.2-.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M243.8 202.4c1.5.8 3.1-.4 2.8-2.4a2.9 2.9 0 0 0-2.5-2.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M250.2 286.6c.3.3.4.7.8.8.7.2 1.2.4 1.9-.5.8-1.1.3-2.8-.5-3.9a5 5 0 0 0-5.8-1c-.8.5-1.7 1-2.6 2.2l-1.1 1.6c-.7 1.1-1 2-1.1 2.4-2 5.9.4 12 4.1 15.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "m340.2 327.8.7.8.2.9c.3 1.5-.7 2.4-2 2.6-1.6.2-2.8-.8-3.3-2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M389.4 154.8a7.4 7.4 0 0 1 6.3 7c0 4.4-1.5 6-3.8 9.2-2.5 3.4-10.7 9.6-10.7 16.7 0 4.3 1.2 7 4.3 8.4 2 1 4.3 0 5.4-1 2.6-2.4 1.5-6.5-1.2-7-3.2-.6-3.9 4.6-.7 4.3m17.9 69a3.7 3.7 0 0 0-3.6-3 3.7 3.7 0 0 0-3.7 3.7c0 1 .4 2 1 2.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M383.9 195.1a7.1 7.1 0 0 0-2.7 5.7c0 3.1 2.6 8.2 9 10 2.4.7 4.8.6 6.2-.3m-156-10.3a9.4 9.4 0 0 0-4.8 3.5 16.9 16.9 0 0 0-2.2 12.7 15.8 15.8 0 0 0 2.3 5.6 8 8 0 0 0 1 1.2l1.2 1m64 92c4.9 2.1 8.4 3.7 11.4 8.5a10 10 0 0 1 1.2 4.9c0 2.7-1 5.7-3.3 7.6a8.3 8.3 0 0 1-6.7 2c-1.9-.2-3.7-1.6-4-2.6M254 224.1c2.7 2.2 3.9 4.2 3.9 7.5a8.4 8.4 0 0 1-4 7.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M251.5 236.4c4 5.1 6.3 8.1 6.4 14.1.1 5.7-1.7 9.6-5 13.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M329.8 169.3a4.1 4.1 0 0 0 1.5-2.2c.5-1.5.5-2.8-.2-4 1 1.4 1 2.5.7 4-.1 1-.8 1.5-1.6 2.3m51.5 86.1v16.2l-.1 2.5a34.4 34.4 0 0 1-.3 1.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M381.4 254v19.9l-.5 2.6m.5-43v14.6m.3-13.4v11.8m0-26.8v8.8m-.3-9.9v11m.3-19v3.5m-.3-4.2v5m-1.8 65.2-.4.7a18.7 18.7 0 0 1-4.1 5.7 19.6 19.6 0 0 1-5.9 4 24.6 24.6 0 0 1-6.5 2.2c-2.7.6-4.2.8-6.9.9-2.5 0-3.9 0-6.3-.2-2.7-.2-4.1-.5-6.8-.8-2.2-.2-3.4-.3-5.6-.3-2.2 0-3.5 0-5.7.4a22 22 0 0 0-5.2 1.4c-2.7 1.1-5.7 3-6.4 3.8-.6-.8-3.7-2.7-6.3-3.8a22 22 0 0 0-5.2-1.4c-2.2-.4-3.5-.4-5.8-.4-2.2 0-3.4.1-5.6.3-2.6.3-4 .6-6.7.8-2.5.2-3.9.3-6.3.2a33 33 0 0 1-13.5-3 19.5 19.5 0 0 1-5.8-4.1 22 22 0 0 1-2.5-2.8m-2-3.2a10.1 10.1 0 0 1-2.3 7.7c-.8.9-2.6 2.6-5 2.6-3.7 0-4.8-2.5-5-3.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M255.6 278.9c.7.7 1.3 1.5 1.9 2.5 1 1.8.6 4.8-.1 6.2a4.4 4.4 0 0 1-.3.4m-20.3 18c2.3 2.4 5.7 5 10.9 7.1 7.1 3 18.1 3.6 25.7 4 10 .3 19.3.7 25 7m17.3-4a12 12 0 0 1 4 5.5m-7.3 11.5a8.2 8.2 0 0 1-.7.7 8.3 8.3 0 0 1-6.6 2c-2-.2-3.8-1.6-4.3-2.6m-5.4-2.9.3.4a7.6 7.6 0 0 0 5.1 2.4m27 0a18 18 0 0 1-7.7 6.1 17.7 17.7 0 0 1-7.6-6.1l-.3-.5m15.6.4.7.7a8.3 8.3 0 0 0 6.7 2 5.5 5.5 0 0 0 4-2.5l.5-.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "m339 336.6-.7 1.2-1.1 1-1.7.7h-1.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M343 325.3a7.7 7.7 0 0 1 2.4 2.9c.3.7.4 1.5.5 2.3a5.8 5.8 0 0 1-1.5 4.2 7.5 7.5 0 0 1-5.4 2.4 5.5 5.5 0 0 1-.4 0m.2-.2a6.8 6.8 0 0 1-5.2-2.2m63.7-67.9a23.8 23.8 0 0 1-4.8-6.4 18.8 18.8 0 0 1-1.7-4.5 12 12 0 0 1-.5-3.3 26 26 0 0 1 4.6-15.3c.7-.8 1.4-1.8 2.1-2.2m-1.3-75.9c2.5.2 4.8 3 4.8 5.7 0 3.8-1.3 5.5-4.4 9.3-2.6 3.2-10.6 9-10.3 14.5 0 1 .5 2 1.1 2.8m-3.2 3.5a7 7 0 0 0 2 1.4 5 5 0 0 0 4.3-.3M369 153a6 6 0 0 1 2.2 2.6c1.8 4.5-2.2 7.9-6 10.4a21.3 21.3 0 0 1-8.3 3.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M364.6 161.6a4.2 4.2 0 0 1-3.1-1.5 3.4 3.4 0 0 1-.7-1m-15 4.9a4.6 4.6 0 0 1-1.2-1c-1-1-1.5-2.3-.8-4.4.6-1.9 3.7-7.2 3.8-10.9.2-5.6-2-9-5.3-10.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "m347.3 146.5-.1 2-.6 2.2-1 3-1 1.9-.8 1.9-.4 1.3-.2 1 .1.9m38 126.3.6.8c.7 1 3.2 3 5.5 3 3.7 0 4.6-2.6 4.7-3.2.5-2.9-.5-3.6-2-4.5 0 0-.8-.4-1.9-.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M237 274.4a6.9 6.9 0 0 1-3.7 0c-2.9-.9-5.2-3.6-4-7m13.4-31.8c.3.3.4.7.4 1 .4 3.8-2.8 4.8-5 4.2a5.6 5.6 0 0 1-3-2.3 4.7 4.7 0 0 1-.7-2.3m22-23.6c.6.5 1 1 1.3 1.7m-1.1-8.5c.5.4.9.9 1.1 1.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M257.9 210.5a8.5 8.5 0 0 1-1.6 2.4 12.4 12.4 0 0 1-8.8 4c-2 0-4-.4-6-1.7a9.5 9.5 0 0 1-4-5.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M255.4 195.3a7.8 7.8 0 0 1 2.4 3.4"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M257.8 203.2c-.9 3-3.5 6.6-8.6 7.9-2.4.6-5.6-.2-6.6-1"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M240 202.6c.3 2.6 2 4.6 5.4 4.6 4.7.1 7.6-6.7 3.4-11.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M229.4 225.5c.7.9 1.5 1.7 2.4 2.4a16.8 16.8 0 0 0 6 3.3m5.2.5c4.2-.5 6.6-3.7 6-7.3-.3-2.8-2.8-5-4.6-5.1"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M249.8 188.1c1.9 0 3 1.6 2.9 3"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M249.4 163a11.5 11.5 0 0 0 5 5.9m144.2 31c1.7 2.3.6 7-4 7a5.2 5.2 0 0 1-4.5-2.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M381.7 169.1V185"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M243.8 202.3c1.4 1 3.3-.7 2.5-2.6-.5-1.2-2.2-2.6-4.7-.9-2.8 1.9-2 7.8 3.2 7.9 4.7 0 7.6-6.8 3.4-11.6-4-4.6-11.3-3.6-16 .2A21.4 21.4 0 0 0 225 207a22.5 22.5 0 0 0 0 9.2 20.9 20.9 0 0 0 3 7.5l1.3 1.7c.8.8 1 1.2 2 2a15 15 0 0 0 10.4 3.7c4.6-.2 7.3-3.4 6.8-7.3-.4-3.8-4.2-5.7-6.7-3.9-1.7 1.2-2.3 4.9.7 5.8 1.6.5 3.1-1.7 2-3M374 150.9c2.7-1.4 4.8-1.2 6.3 1a9.9 9.9 0 0 1 1.6 7.2 9.2 9.2 0 0 1-3.5 5.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M380.5 152c3.1-2 6.5-1.1 8.3 1.6 1.3 2 1.7 3.6 1.6 6.1a11.2 11.2 0 0 1-5.7 9.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M395 159.2c2.6.2 4.6 2.5 4.6 5.1 0 3.8-1 5.5-4 9.3-2.7 3.3-10.6 9-10.4 14.6 0 2.1 1.8 4 3.3 4.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M395.4 202.3c-1.5 1-3.3-.6-2.5-2.4.5-1.2 2.2-2.8 4.7-1.1 2.7 1.9 2 7.8-3.3 7.9-4.7 0-8-6.6-3.4-11.6 4-4.6 11.7-3.7 16.5.1 2 1.6 6.1 6 7 12 1 7 .9 15.6-6.4 21-3 2.1-7 3.1-10.6 3-4.6-.2-7.3-3.5-6.8-7.4.5-3.8 4-5.4 6.7-3.9 2.8 1.5 2.3 5.4-.7 5.8-1.7.2-3.1-1.7-2-3"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M392.9 199.9c.8-3.5 3.7-3.8 6.2-3.8 6.5.1 11.1 8 11.2 15.5 0 9.5-4 15.2-11 15.5-1.9 0-5-.8-5-3"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "square",
              d: "M397 198.3c6.9 1.6 9.3 7.8 9.3 13.8 0 4.9-.5 11.6-10 13.9"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M408.4 265.3a3.9 3.9 0 1 0-6.3 2.4"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M394.4 259.4c1.4 2 3 4.1 6.3 6m-1.3 10.5c-3.2-2.2-9.5-5-15-2.2a7.6 7.6 0 0 0-4.4 4.4 10 10 0 0 0 1.8 9.5c.9 1 2.7 2.6 5 2.7 3.8 0 4.7-2.6 4.8-3.2.4-2.8-1.2-3.9-2-4.1-.7-.3-2.8-.2-3.2 1.3-.2.5-.2 1.3.2 2"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M340.5 328.4c1 2.2-.2 3.2-1.6 3.4-2.2.3-3.3-1.4-3.4-3a4.4 4.4 0 0 1 4.3-4.7c2.3 0 4.1 1.5 5 3.5.3.7.5 1.5.5 2.4a5.8 5.8 0 0 1-1.4 4.1 7.5 7.5 0 0 1-5.4 2.5c-4.2.1-7.5-3.8-7.5-7.8 0-7.7 11.4-12 16-13a84 84 0 0 1 17.9-2.4c3.5-.1 6.2 0 10.1-.5 3.5-.3 5.4-.5 9-1.3a27.2 27.2 0 0 0 12.6-6.4c2.9-2.7 4.5-4.5 5.9-8.2a17 17 0 0 0-1.3-13.9 14.3 14.3 0 0 0-10.3-6.8c-3.7-.5-7 1.1-9 4.8-1 1.8-.6 4.8.1 6.2a6 6 0 0 0 4.8 3c3.8 0 4.7-2.6 4.8-3.2.4-2.8-1.2-3.9-2-4.2-.7-.2-2.8-.1-3.2 1.4-.2.5-.2 1.3.2 2"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M337.2 316.2c-4.8 2.1-8.4 3.7-11.4 8.5a9.9 9.9 0 0 0-1.2 4.9c0 2.7 1.1 5.7 3.3 7.6a8.3 8.3 0 0 0 6.7 2c2-.2 3.7-1.6 4-2.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M385.1 224.1c-2.3.8-3.9 4.2-3.9 7.5a8.4 8.4 0 0 0 4 7.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M387.6 236.4c-4 5.1-6.3 8.1-6.4 14.1 0 5.7 1.7 9.6 5.1 13.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "m365.9 152 .3-.5c1.7-2.4 4.7-3.1 6.9-1.5 2.6 2 3.3 5.4 2.6 9-.5 2.2-2 4.1-4 5.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M265.1 150.8c-2.6-1.2-4.7-1-6.3 1a8.7 8.7 0 0 0-1.6 7.2c.6 2.7 1.4 3.8 3.5 5.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M258.6 152a5.8 5.8 0 0 0-8.3 1.6 9.1 9.1 0 0 0-1.6 6.1c.2 4.2 2.8 7.6 5.8 9.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M249.7 154.8a6.8 6.8 0 0 0-6 6.6c0 4.5 1 6.3 3.5 9.6 2.5 3.4 10.7 9.6 10.7 16.7 0 4.3-1.2 7-4.3 8.4-2 1-4.3 0-5.4-1-2.6-2.4-1.5-6.5 1.2-7 3.3-.6 3.9 4.6.7 4.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M244 159.2c-2.5.2-5 2.3-5 5 0 3.8 1.5 5.6 4.6 9.4 2.6 3.3 10.1 9 9.9 14.5 0 2-1.5 4.6-2.9 4.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M238 236.1c1.3-2.9 4.4-1.6 4.6 0 .4 3.7-2.8 4.8-5.1 4.2a4 4 0 0 1-2.5-2 4.8 4.8 0 0 1-.4-3.7 4.9 4.9 0 0 1 .9-1.6 5 5 0 0 1 1.2-1.2c1-.6 1.9-.6 3.4-.6 5.5 0 10.4 6.5 12 13.4.6 2.2 1.3 7.3.3 12a22.4 22.4 0 0 1-5.8 11.3 25.8 25.8 0 0 1-10 5.8 7 7 0 0 1-3.9.1c-2.8-.9-4.6-3.5-3.2-7 1.2-2.6 5.4-4 7.3-.6.2.3.4.9.4 1.5 0 .9-.4 2-1 2.4-1.4.9-3.7.6-3.6-2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M233.8 270.4c1 .4 1.6.3 2.9-.2l1.8-1c2.6-1.5 5.6-3.8 8.4-9.1a18.8 18.8 0 0 0 1.7-4.5c.3-1 .5-2.2.6-3.3a25.6 25.6 0 0 0-4.8-15.3c-1.1-1.6-2-2.5-4.2-2.6m-9.5 31a3.9 3.9 0 1 1 6.3 2.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M232.2 261.4a3.7 3.7 0 0 1 3.7-3 3.7 3.7 0 0 1 3.6 3.7 3.8 3.8 0 0 1-1 2.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M239.4 261.3a15.5 15.5 0 0 0 6.2-12.4c0-4.1-1.6-8.4-3.6-10"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M244.7 259.4a16.5 16.5 0 0 1-6.3 6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M254.6 273.7c-1-2.2-2.8-3.2-5.8-3.5-3-.3-5.5.5-8.2 1.9a18.6 18.6 0 0 0-10.8 17 25 25 0 0 0 2 9.5c.9 1.6 3 9 15.3 14a86.1 86.1 0 0 0 25.7 3.9c10.4.4 20 .8 25.6 7.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M239.7 275.9c3.3-2.2 9.5-5 15.1-2.2a8 8 0 0 1 4.3 4.4 10 10 0 0 1-1.8 9.5c-.9 1-2.7 2.6-5 2.7-3.8 0-4.7-2.6-4.8-3.2-.4-2.8 1.2-3.9 2-4.2.7-.2 2.8-.1 3.2 1.4.2.5.2 1.3-.2 2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M252.7 285.7c.3-1 .2-2.2-.8-3.3a5.1 5.1 0 0 0-6-1c-.7.5-1.6 1-2.4 2.2-.4.4-1 1.1-1.2 1.6-.7 1.1-1 2-1 2.5-2.5 7 1.5 14.4 6.5 17.6 4.4 2.8 8.8 3.6 14.4 4 2.5.3 4 .3 6.5.5h9.6a70.1 70.1 0 0 1 7.2 0c3 .3 5.1.4 7.6.8 1.6.2 3.5.5 5.4 1 .6 0 1.2.2 1.8.4l1.2.3c3.6 1.1 7 2.4 9.8 4.2.8.5 1.8 1 2.5 1.7l1.3 1.2c2 2 4 4 4.4 6.7v1.6c0 1.8-1.4 4.3-5.3 5"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M298.6 328.4c-1 2.2.2 3.2 1.6 3.4 2.2.3 3.3-1.4 3.5-3a4.4 4.4 0 0 0-4.4-4.7 5.5 5.5 0 0 0-5 3.5 6.9 6.9 0 0 0-.5 2.4 5.8 5.8 0 0 0 1.4 4.1 7.5 7.5 0 0 0 5.4 2.5c4.2.1 7.5-3.8 7.5-7.8 0-7.7-11.4-12-16-13a84 84 0 0 0-17.9-2.4c-3.5-.1-6.2 0-10.1-.5-3.5-.3-5.4-.5-9-1.3a27.2 27.2 0 0 1-12.5-6.4 17 17 0 0 1-4.7-22 14.3 14.3 0 0 1 10.3-6.9c3.8-.5 7 1.1 9 4.8 1 1.8.6 4.8-.1 6.2a6 6 0 0 1-4.8 3c-3.8 0-4.7-2.6-4.8-3.2-.4-2.8 1.2-3.9 2-4.2.7-.2 2.8-.1 3.2 1.4.2.5.2 1.3-.2 2"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "m273.3 152-.4-.5c-1.7-2.4-4.7-3.1-6.9-1.5-2.6 2-3.3 5.4-2.5 9a9 9 0 0 0 4 5.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M366.8 159.6c-4 4.4-8.1 5.8-14.1 6-2 0-5.5-.6-7.6-2.1-1.3-1-2.8-2.6-1.9-5.5.6-1.9 3.7-7.2 3.8-10.9.3-5.6-1.9-8.7-5.3-9.9-6.2-2.2-13 4-17 5.4-2.1.7-3.2.8-5.1.8-2 0-3-.1-5.2-.8-4-1.4-10.7-7.6-17-5.4-3.4 1.2-5.5 4.3-5.3 10 .1 3.6 3.2 9 3.8 10.8 1 2.9-.5 4.5-1.9 5.5-2 1.5-5.7 2.1-7.5 2-6-.1-10.1-1.5-14.1-5.9"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M297.3 314.4c.8.3.2-.2 5.3 2a22 22 0 0 1 11.3 8.9 10.5 10.5 0 0 1 .9 7.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M297.7 336a8 8 0 0 0 3.2.9c4.2.1 7.5-3.8 7.5-7.8 0-2.8-1.5-5.2-3.6-7"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M298.6 328.4c-1 2.3.4 3.5 1.8 3.7 2.2.2 3.4-1.4 3.6-3a4.5 4.5 0 0 0-2.2-4.2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M390.1 154.8c3.2 0 6 3.6 6 7.2 0 4.3-2.2 6.9-3.9 8.8-1.3 1.6-2.7 3-4.4 4.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M386.3 151.4a9 9 0 0 1 2.8 2.4c1.3 2 1.7 3.7 1.6 6.2-.2 4.2-3.2 7.1-6 9m-4.7-17.6.6.7c1.9 2.2 2 5.4 1.6 7.2a8.2 8.2 0 0 1-3.8 5.4m-5-14.4c2.6 2 3.4 5.4 2.5 9-.6 2.5-2.2 4-4.2 5.2m11.1 41.1c.3 1 .9 1.3 1.5 2a13.5 13.5 0 0 0 6.2 3.5c2.4.7 4.6.2 6.3-.9m-163 54c1.2 0 2.5.9 3.3 2.3.1.2.4.8.4 1.5 0 .9-.4 1.8-1 2.2-1.5 1-4 .5-4-2"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M241.5 231.3c5 1 9.7 6.9 11.2 13.3.6 2.3 1.3 7.3.3 12a22.4 22.4 0 0 1-6 11.4 16.5 16.5 0 0 1-2.1 1.9l-1 .7m-8-12.1c2 0 3.8 1.9 3.8 4a3.8 3.8 0 0 1-1 2.6"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M234.6 260.7c2.1 0 4.1 2 4.1 4.2a3.9 3.9 0 0 1-1.4 3"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M254 239.5a18 18 0 0 1 3.8 7.7m0 8.5a17.3 17.3 0 0 1-1.5 4 17.8 17.8 0 0 1-3.6 4.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M254.3 224.3c1.8 1.5 3 3 3.5 4.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M257.9 219.5a10 10 0 0 1-3.4 4.6m-9.2-17.2 2.2-.6 1.3-1 .8-1.1.7-1.8.3-1.5"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M241 199.3c-.7.2-1.6.4-2.5.8a9 9 0 0 0-3.5 3 17 17 0 0 0-2.2 12.7 15.8 15.8 0 0 0 2.3 5.6l1 1.4c1.4 1.3 2.6 2 4.6 1.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M253 189.8c-.3 1.3-1 2.9-3 2.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M245.7 198.5c-2-1.9-6-2.4-10.1.2L234 200a8.8 8.8 0 0 0-1.4 1.6 17.5 17.5 0 0 0-2.4 5c-.7 3-.7 5.6-.6 6.3 0 1 .2 1.9.3 2.7.6 2.8 1.4 4.8 2.3 6.2.9 1.5 3 5 7.7 5.4 1.8.1 4.8-.7 5-3"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M363.8 157c.3-1.6 2.3-1.9 3-1 1.2 1.6.4 4.2-2 4.9a4 4 0 0 1-3.8-1.4c-1-1.3-.9-2.8-.5-4 .2-.8.9-1.5 1.7-2.2 2.7-2 7.1-1.6 8.6 2 1.8 4.4-2.2 7.8-6 10.3-4.6 3.2-10 3.8-14 3.7-9.2 0-16.1-4.4-20.7-7-1-.5-2.1-.4-2.7.3a2 2 0 0 0 .3 2.7"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "round",
              d: "M365.6 155.5c1 0 1.2.4 1.5.8 1.2 1.5.3 4.1-2 4.9m17.8 51.5c-3.5 3.8-.2 10.3 2.4 11.8.9.7 1.3.3 2 .7"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M383.1 205.4c-1.1.8-1.5 1.7-1.6 3.3a5.3 5.3 0 0 0 1.4 4 14 14 0 0 0 9.3 3.7c2 0 4-.4 6-1.7a9 9 0 0 0 3.8-5.4m-20.8 61.8-.2 2.5a18.9 18.9 0 0 1-2 7 18.7 18.7 0 0 1-4.2 5.6 19.6 19.6 0 0 1-5.9 4 24.6 24.6 0 0 1-6.5 2.3 43.8 43.8 0 0 1-13.2.6c-2.7-.2-4.1-.5-6.8-.8-2.2-.1-3.4-.3-5.6-.3a28.3 28.3 0 0 0-10.9 1.9c-2.7 1-5.7 3-6.4 3.8-.6-.9-3.7-2.8-6.3-3.8a22 22 0 0 0-5.2-1.5c-2.2-.4-3.5-.4-5.8-.4-2.2 0-3.4.2-5.6.4-2.6.2-4 .6-6.7.7-2.5.2-3.9.3-6.3.2a33 33 0 0 1-7-.8 24.6 24.6 0 0 1-6.5-2.2 19.6 19.6 0 0 1-5.8-4.1 18.7 18.7 0 0 1-4.2-5.7 19 19 0 0 1-2-6.9c-.2-1-.2-2.5-.2-2.5V169.3h123.2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs11("g", {
          fill: "#c7b37f",
          stroke: "#c7b37f",
          children: [
            /* @__PURE__ */ jsx18("path", {
              strokeWidth: 0.3,
              d: "M248 285.6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM232.5 268c0-1.3.8-2.3 1.8-2.3s1.7 1 1.7 2.3c0 1.2-.8 2.2-1.7 2.2-1 0-1.8-1-1.8-2.2z"
            }),
            /* @__PURE__ */ jsx18("path", {
              stroke: "none",
              d: "M241.3 223.6c0-1 .8-1.8 1.7-1.8 1 0 1.7.8 1.7 1.8s-.7 1.8-1.7 1.8-1.7-.8-1.7-1.8M272 158c0-1 .5-2 1.4-2 .9-.1 1.7.6 1.8 1.6 0 1-.5 2-1.4 2-.9.1-1.6-.6-1.8-1.6"
            })
          ]
        }),
        /* @__PURE__ */ jsxs11("g", {
          stroke: "#c7b37f",
          strokeLinecap: "round",
          strokeWidth: 0.6,
          children: [
            /* @__PURE__ */ jsx18("path", {
              d: "M239.3 234c-.4.1-.6.2-.8.5-.3.3-.4.4-.6.9l-.2 1.2m4.7 26.7 1-1 .6-1 .5-1 .7-1.3m-1.3 14-1.5.7-1.1.6a17.4 17.4 0 0 0-1.3.8l-1.2 1m15-37.9-.8-.8-1-.8-.9-.8"
            }),
            /* @__PURE__ */ jsx18("path", {
              strokeLinecap: "butt",
              d: "m254.2 225-1.2.5a5.1 5.1 0 0 1-1.5.3"
            }),
            /* @__PURE__ */ jsx18("path", {
              d: "M237.4 208.4c.2.6.2 1 .5 1.5.2.7.5 1.1.9 1.7a8.3 8.3 0 0 0 2.6 2.7l1.5.8m-1-5.8 1.3.6a7.4 7.4 0 0 0 3 .6l1.8-.1m7.2-40.7-2-1.2c-.9-.5-1.3-.9-2-1.5a9.3 9.3 0 0 1-1.1-1.3l-.8-1.3m7.5-4.6.6 1.7a7.8 7.8 0 0 0 1.4 2c1 1 1.7 1.3 2.8 2.2m1.4-6c.3.7.3 1 .7 1.6.2.5.4.8.8 1.2l1.3 1.3c.7.6 1.2.7 2 1.1"
            })
          ]
        }),
        /* @__PURE__ */ jsx18("path", {
          fill: "#703d29",
          strokeWidth: 0.2,
          d: "M333.3 151.6c0-1.7-1.7-1.8-2.4-1.8-1.8 0-2.3 1.1-4.6 2.3a11.9 11.9 0 0 1-6.7 2 12 12 0 0 1-6.7-2c-2.3-1.2-2.7-2.3-4.6-2.3a2.3 2.3 0 0 0-2.2 2.4v.9l.3.2c0-.8.1-1.2.5-1.7a2.2 2.2 0 0 1 1.6-.8c1.8 0 2.5 1.2 4.8 2.4 3 1.6 4.2 1.9 6.7 2a12 12 0 0 0 6.8-2c2.3-1.2 3-2.5 4.8-2.5.6 0 1 .4 1.3 1v.9l.2.1c0-.3.2-.4.2-1z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs11("g", {
      fill: "#703d29",
      children: [
        /* @__PURE__ */ jsx18("path", {
          d: "M264.4 294c.5-.5.9-.3 1-.6 0-.2 0-.2-.3-.3l-.9-.2-.8-.4c-.1 0-.4-.2-.5 0-.1.4 1 .4.6 1.4a3.7 3.7 0 0 1-.8 1.2l-2.6 3-.2.1v-4.3l.1-1.8c.2-.4.8 0 .9-.4 0-.1 0-.2-.3-.3-.2 0-.5 0-1.1-.3l-1-.5c-.2 0-.5-.2-.6 0l.1.3c.4.2.5.4.5 1v7.4c0 .5.1.6.2.7.1 0 .2 0 .4-.3z"
        }),
        /* @__PURE__ */ jsx18("path", {
          d: "M267.5 295.2c.3-1.1 1-.4 1-.8.1-.2 0-.2-.2-.3l-1.3-.4c-.4 0-.8-.3-1.2-.4 0 0-.3-.1-.4 0-.1.5 1.1.5.8 1.5l-1.7 5.5c-.3 1-1 .6-1.1 1v.1l1.2.4 1.6.5h.3c.2-.4-1.2-.3-.7-1.7zm3.7 1c.2-.6.5-.5.9-.4 1 .3 1.4 1.3 1 2.5-.2.6-.4 1.2-2 .8-.3-.1-.7-.2-.6-.5l.7-2.3zm-2.8 5c-.5 1.4-1.2.8-1.3 1.2 0 .2.2.2.3.3l1.6.4.8.3h.4c.1-.5-1-.3-.7-1.5l.6-2c.1-.4.1-.5.6-.3.6.1.7.3.8.8l.3 2c.2.9.3 1.7 1 2 .5 0 1.2 0 1.4-.4l-.2-.2h-.3s-.3 0-.3-.3l-.7-3.6c0-.2.4-.2.8-.3a2 2 0 0 0 1-1.3c.1-.5.4-2.2-1.8-2.9l-2.1-.5-1.2-.4h-.3c-.1.5 1.1.4.7 1.7zm8.4 2.5c-.4 1.4-1.4.5-1.5 1 0 .2.1.3.3.3l1.5.3 1.4.4c.3 0 .5.2.6-.1 0-.3-1.3-.3-1-1.8l1.3-5.2c0-.6.2-.6.6-.5l1 .2c1.1.3.5 1.5 1 1.6.2 0 .2-.4.2-.6l.1-1v-.4l-3.3-.7-3.2-.8c-.1 0-.2 0-.2.2l-.5 1.5c-.1.1-.2.4 0 .4.5.1.5-1.5 1.7-1.2l.9.2c.4.1.5.2.4.8zm12.7-3.3c.4-.6.8-.5.9-.7 0-.2-.2-.2-.4-.3h-.9l-.9-.3c-.1 0-.4-.1-.4.1-.1.4 1 .2.8 1.3 0 .2-.1.6-.6 1.3l-2 3.3-.3.2v-.2l-.7-4a5.4 5.4 0 0 1-.1-1.8c0-.5.7-.2.7-.5 0-.2 0-.2-.4-.3l-1.1-.1c-.4 0-.7-.2-1-.3-.2 0-.5-.1-.6.1l.1.2c.5.2.6.4.7.9l1.3 7.3c.1.5.2.7.3.7.1 0 .2 0 .4-.3zm.6 6.8c0 .3 0 .3.2.5.6.2 1 .6 1.7.7 1.4.2 2.6-.7 2.8-2.2.3-1.5-.3-2.1-1.4-2.9-1.3-.9-1.8-1.1-1.7-2 .1-.7.7-1 1.4-1 1.8.3 1.6 2.6 1.8 2.6.3 0 .3-.1.3-.4l.2-1.6v-.4h-.6c-.4 0-.7-.5-1.6-.7-1.2-.2-2.3.7-2.5 2-.2 1.2.4 1.8 1.2 2.4 1.6 1.1 2.2 1.4 2 2.4-.1 1-.9 1.4-1.7 1.3-1.2-.2-1.6-1.4-1.8-2.6 0-.2 0-.3-.2-.3s-.2.3-.2.5v1.7zm15.8-4.5c.3-.7.8-.6.8-.9 0-.2-.1-.1-.4-.2h-.9l-.9-.1c-.1 0-.4 0-.4.2 0 .4 1 0 1 1.1 0 .2-.1.6-.5 1.4l-1.8 3.5-.1.3-.1-.3-1.1-4a5.4 5.4 0 0 1-.3-1.6c0-.5.7-.3.7-.6 0-.2 0-.2-.4-.2h-1.2l-1-.2c-.2 0-.5-.1-.6.1l.2.2c.4.2.6.3.7.8l2.1 7.1.4.7c.1 0 .2 0 .3-.4z"
        }),
        /* @__PURE__ */ jsx18("path", {
          d: "M307.6 308.5c0 1.2-1 1-1 1.5 0 .2.1.1.3.1h2.2l.4-.1c0-.6-1.4.2-1.4-2v-4.2l.1-.1.2.1 5.1 6.3.3.1.2-.3v-6.7c0-1.3 1-1 1-1.3 0 0 0-.2-.3-.2h-2.3c-.2 0-.2.1-.2.2 0 .4 1.3.2 1.3 1.3v4l-.1.4-.4-.3-4.2-5.3c-.2-.3-.1-.3-.4-.3h-1.8l-.2.1c0 .6 1.2-.2 1.2 2.1zM318 303c0-1.1.8-.7.8-1.1 0-.1 0-.2-.4-.2h-2.6s-.3 0-.3.2c0 .4 1.1 0 1.1 1.2v5.7c0 1.1-.8.8-.8 1.2 0 0 0 .2.2.2h2.8c.2 0 .3 0 .3-.2 0-.4-1.2.2-1.2-1.3zm4.5 5.5c0 1.5-1.2 1-1.2 1.4 0 .2.2.2.4.2h3c.3 0 .5 0 .5-.3s-1.4 0-1.4-1.4V303c0-.6 0-.6.5-.6h1c1.2-.1.8 1.2 1.3 1.2.2 0 .1-.4.1-.6l-.1-1c0-.2 0-.4-.2-.4l-3.3.1h-3.3l-.2.3-.1 1.6.1.4c.5 0 .2-1.6 1.4-1.6h.9c.4 0 .5 0 .6.6v5.6zm6.3-2.2h-.4l.1-.5.7-2.2v-.2l.2.1 1 2.1.2.4c0 .2-.2.2-.4.2zm1.8.5c.3 0 .3 0 .8 1l.2.8c0 .7-.7.6-.7 1 0 .1.2.1.4 0h1.2l1.3-.1c.3 0 .4 0 .4-.2 0-.4-.6 0-1-.7l-3.4-7-.3-.4c-.2 0-.2.2-.3.4L327 309c-.2.7-.8.7-.7 1h2.3c.2-.1.5 0 .5-.3s-1.2 0-1.3-.9l.2-1c.2-.8.4-.8.6-.8l2.1-.2zm8.3-5c-.1-.8 0-.8 1.2-1 2-.2 1.4 1.3 2 1.2.2 0 0-.4 0-.6l-.1-1.1c0-.1-.1-.2-.3-.2-1 0-1.7.2-2.4.3l-2.8.4c-.2 0-.3 0-.3.2.1.5 1.3 0 1.4 1l.7 5.5c.2 1.5-.7 1-.6 1.5 0 0 0 .1.2 0l1.4-.1 1.2-.1c.3 0 .5 0 .5-.3s-1.2.1-1.4-1.2l-.2-1.7c-.1-.7-.1-.9.3-1h.8c1.1-.2 1 1.1 1.3 1 .3 0 .2-.4.1-.5l-.3-2.1c0-.3-.2-.3-.2-.3-.3 0-.1 1.1-1 1.2l-.7.1c-.5.1-.5 0-.6-.5zm4 2.8c.4 2.3 2.1 3.7 4.2 3.3 3.4-.7 3.5-3.6 3.2-5.3-.5-2.5-2.3-3.7-4.4-3.3-2.5.5-3.5 2.7-3 5.3m1.1-1c-.3-1.6 0-3.4 1.7-3.7 1.4-.3 3 .8 3.4 3.4.3 2 0 3.6-1.8 4-1.9.4-3-2-3.3-3.6zm8.3-4.1c-.1-.7.2-.8.6-.9 1-.2 1.8.5 2.1 1.6.2.7.3 1.4-1.3 1.8-.3 0-.7.1-.8-.2l-.5-2.3zm0 5.7c.4 1.4-.5 1.3-.5 1.6.1.3.3.2.4.1.6 0 1-.3 1.6-.4l1-.2c.2 0 .2-.1.2-.2 0-.4-1 .3-1.3-1l-.5-2c0-.4-.2-.4.4-.5.5-.2.7-.1 1.1.3l1.3 1.6c.5.6 1 1.3 1.8 1.1.5-.1 1-.5 1-.9l-.2-.1-.3.1s-.3.1-.4 0l-2.4-2.9.5-.6c.2-.4.4-.9.2-1.6-.1-.5-.7-2.1-3-1.6l-2.1.6-1.2.2c-.2 0-.3.1-.2.2 0 .5 1.1-.2 1.4 1zm8.7-2c.3 1.4-1 1.2-.9 1.6 0 .3.3.2.5.2l1.4-.5 1.5-.3c.3 0 .5 0 .4-.4 0-.3-1.3.4-1.7-1l-1.3-5.3c-.2-.5 0-.6.3-.7l1-.2c1.1-.4 1.1 1 1.5.9.3 0 0-.5 0-.7l-.4-1s0-.3-.2-.2l-3.2.9-3.2.7v.3l.1 1.6c0 .2 0 .4.3.4.5-.1-.3-1.6 1-1.9l.8-.2c.4-.1.6 0 .7.5zm5.5-7.3c-.3-1 .6-.9.4-1.3h-.3l-1.4.4-1.2.3s-.3 0-.3.2c.1.4 1.2-.2 1.5.8l1.6 5.6c.2 1-.6 1-.5 1.3 0 .1 0 .2.2.1l1.1-.3 1.6-.4c.3 0 .3-.1.3-.3-.1-.3-1.1.5-1.5-.9zm2.3 2.7c.7 2.3 2.6 3.4 4.7 2.7 3.2-1.1 3-4.1 2.4-5.7-.8-2.4-2.8-3.3-4.8-2.7-2.4.9-3.2 3.2-2.3 5.7m1-1c-.6-1.7-.6-3.5 1.1-4 1.3-.5 3 .4 3.9 2.9.6 1.8.5 3.6-1.2 4.2-1.8.6-3.2-1.5-3.8-3.2zm7.6-5.5c-.2-.7 0-.8.4-1 1-.3 2 .3 2.4 1.4.2.6.4 1.3-1.1 1.9-.3 0-.7.2-.8 0zm.8 5.6c.6 1.4-.4 1.4-.2 1.7 0 .3.2.1.4.1l1.5-.7.9-.2c.2-.1.2-.2.2-.3-.2-.4-1 .4-1.4-.8l-.8-1.9c-.2-.4-.2-.5.3-.7.5-.2.7-.1 1.1.3l1.6 1.4c.5.5 1.1 1.1 2 .8.3-.2.9-.7.7-1l-.2-.1-.2.2h-.5l-2.8-2.5.4-.7a2 2 0 0 0 0-1.6c-.1-.6-1-2-3.1-1.2l-2 .9-1.2.4-.2.2c.2.4 1.1-.4 1.6.8l2 5z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs11("g", {
      fill: "#fedf00",
      transform: "matrix(.64 0 0 .64 0 16)",
      children: [
        /* @__PURE__ */ jsx18("path", {
          fill: "#d52b1e",
          d: "M412.7 249.3h82.1v82h-82.1z"
        }),
        /* @__PURE__ */ jsx18("path", {
          id: "ad_svg__a",
          fill: "#fff",
          d: "M451.2 313.8s0 3-.8 5.3c-1 2.7-1 2.7-1.9 4a13.2 13.2 0 0 1-3.8 4c-2 1.2-4 1.8-6 1.6-5.4-.4-8-6.4-9.2-11.2-1.3-5.1-5-8-7.5-6-1.4 1-1.4 2.8-.3 4.6a9 9 0 0 0 4.1 2.8l-2.9 3.7s-6.3-.8-7.5-7.4c-.5-2.5.7-7.1 4.9-8.5 5.3-1.8 8.6 2 10.3 5.2 2.2 4.4 3.2 12.4 9.4 11.2 3.4-.7 5-5.6 5-7.9l2.4-2.6 3.7 1.2z"
        }),
        /* @__PURE__ */ jsx18("use", {
          xlinkHref: "#ad_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 907.5 0)"
        }),
        /* @__PURE__ */ jsx18("path", {
          d: "m461.1 279 10.8-11.7s1.6-1.3 1.6-3.4l-2.2.4-.5-1.2-.1-1.1 3-.7V260l.3-1.3-3.2.2.3-1.4.5-1 1.9-.4h1.9c1.8-3.4 9.2-6.4 14.4-1 3.8 4 3 11.2-2 13.2a6.3 6.3 0 0 1-6.8-1.1l2-4c2.7 1.7 5-.3 4.8-2.4-.2-2.7-2-4.3-4.3-4.5-2.3-.2-4 1-5 3-.6 1.3-.3 2.2-.5 3.6-.2 1.5 0 2.3-.5 3.8a8.8 8.8 0 0 1-2.4 3.6l-11 12-43 46.4-3.2-3z"
        }),
        /* @__PURE__ */ jsx18("path", {
          fill: "#fff",
          d: "M429.5 283s2.7 13.4 11.9 33.5c4.7-1.7 7.4-2.8 12.4-2.8 4.9 0 7.6 1 12.3 2.8A171 171 0 0 0 478 283l-24.2-31z"
        }),
        /* @__PURE__ */ jsx18("path", {
          d: "m456.1 262.4 16.8 21.7s-2.2 10.5-9 26.3c-2.7-.6-5-1.1-7.8-1.3zm-4.7 0-16.8 21.7s2.2 10.5 9 26.3c2.7-.6 5-1.1 7.8-1.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs11("g", {
      fill: "#d52b1e",
      children: [
        /* @__PURE__ */ jsx18("path", {
          fill: "#fedf00",
          d: "M322.3 175.5h52.6V228h-52.6z"
        }),
        /* @__PURE__ */ jsx18("path", {
          d: "M329.7 175.5h7.8V228h-7.8zm15 0h7.8V228h-7.8zm15 0h7.9V228h-7.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs11("g", {
      fill: "#d52b1e",
      stroke: "#d52b1e",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx18("path", {
          fill: "#fedf00",
          stroke: "none",
          d: "M264.3 273.5c.1 1 .5 2.6 1.4 4.3 1 1.5.6 1.4 2.7 3.8a15.3 15.3 0 0 0 4 2.9 32.7 32.7 0 0 0 15 2.6c2.7-.1 4.8-.4 6.6-.7a71 71 0 0 1 11-.6c1.5 0 3 .3 4.7.6 3.5.7 7 2 7 2v-54.7h-52.6V271l.2 2.4z"
        }),
        /* @__PURE__ */ jsx18("path", {
          strokeWidth: 0.3,
          d: "m270.4 283.1 2.5 1.5 3.4 1.2v-52.2h-5.9zm29.2 2.4v-51.9h-5.8v52.8l5.8-.7zm11.7-51.9h-5.8v52.1c1.9.2 3.8.6 5.8 1zm-23.4 0V287s-3.8.2-5.8 0v-53.4z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs11("g", {
      transform: "matrix(.64 0 0 .64 0 16)",
      children: [
        /* @__PURE__ */ jsx18("path", {
          fill: "#fedf00",
          d: "M585.5 402.4a20.8 20.8 0 0 1-2.2 6.6c-1.5 2.3-1 2.3-4.3 6a26.3 26.3 0 0 1-13 7 51.8 51.8 0 0 1-16.6 1.6c-4.3-.2-7.5-.7-10.3-1-3.8-.6-6.7-.9-11-1a62.9 62.9 0 0 0-6.2 0 83.3 83.3 0 0 0-18.3 4.2V340h82.2v58.5z"
        }),
        /* @__PURE__ */ jsxs11("g", {
          id: "ad_svg__b",
          children: [
            /* @__PURE__ */ jsx18("path", {
              fill: "#d52b1e",
              d: "m524.6 347-.6.2-.8.8c-.4.4-.7.5-1.2.8l-.6.5c-.3.3 0 .6-.3 1-.1.4-.3.6-.6 1-.4.4-.7.5-1 1l-1.2 1-.3.1h-.6c-.4.2-.5.6-.8.8l.3.6.8 1.4c.2.3.2.7.5.8.5.2.9.2 1.3.1.8.2 1.3.2 2 .5l1.5.8c.5.3.8.4 1.3.5h1.8v.3l2 1a1.7 1.7 0 0 0-.1.4c-.1.3-.2.7-.1.8.6 1.9 1.2 3 1.5 3.2.6.2.8.9 1.1 1.5l-.3.3c-.6.6-1.2 1-1.7 1.8-.7 1.2-1.2 1.2-.3 2.8l1.5 2.4c.4.7.6 1.2.8 2 .2.7.3 1.2.3 2l1 .3.7-.6.6-1.2v-1c-.2-.1-.3-.4-.2-.7 0-.4.5-.3.7-.6.3-.5-.4-.8-.7-1.1-.6-.7-1.4-.9-1.6-1.9 0-.2 0-.4.4-.7l2-1.8c.2.1.6.2 1 .1l1.3.4c.6.2.9 0 1.2 0h.4l.1.6c.1 1-.1 3 .2 3.5l.3.6.2.6v2l-.2 1.7c0 .4-.2.7-.5 1-.2.4-.6.4-1 .7v1l1.1.5 1.3.3.7-.3.1-.6.5-.5c.4-.2.8 0 .9-.1.2-.3 0-.4 0-.8 0-.6-.2-1-.3-1.6a11.8 11.8 0 0 1-.1-2.8c0-.6 0-1 .2-1.5.1-1 .4-1.4.6-2.2.3-1 .3-1.6.4-2.5a24.4 24.4 0 0 0 10.1-.6c.8.7 1.7 1.2 2.7 1.6v1c0 .3 0 .4.2.7l.3.3c.3 0 .5 0 .7-.2.2-.2.2-.4.2-.7v-.7h1.8v1.1c.1.3.3.4.5.4a.7.7 0 0 0 .6 0c.3-.2.2-.6.3-1v-.7l1-.4a5.1 5.1 0 0 1 0 .9l-.3.9c-.2.6-.5.8-.8 1.4-.4.6-.5 1-1 1.5l-.6.7-.6.9-.9 1c-.7.6-1.2.2-2 .9l-.3 1 1.4.6 1.3.2.4-.2c0-.3 0-.6.3-.8.2-.3.4-.3.7-.4.4 0 .8 0 1-.2.4-.3.4-1 .7-1.5a12.7 12.7 0 0 1 3-3.9l1.7-1.4c.2-.4.5-.5.5-1l-.2-.6-.2-1c1.5.7 1 .7 1.2 1.4.3.6 0 1 .1 1.7.1.8.5 1.1.5 1.9.1.9-.1 1.4-.3 2.3-.1.8-.1 1.3-.5 2a3.8 3.8 0 0 1-1.1 1.5l-.6.5-.1 1 1.1.4 1.6.4.4-.3c.2-.7 0-1.7.4-1.7.4-.1.7 0 .8-.3v-.7l.7-4.5.4-1.9.4-1.7c.7-2-.2-2.3-1-3.6-.5-.7-.7-1-.7-1.5V362a42.7 42.7 0 0 1 0-2.8l.4-.2c1.2-.7 1.7-.9 2.4-2.5a3.4 3.4 0 0 0 .3-1.5v-1l-.4-1a3.2 3.2 0 0 0-.6-.8c-.7-1-1.7-1.1-2.7-1.5-1.5-.5-2.5-.4-4-.5-1.8-.2-2.7-.2-4.4 0-2 0-3.1.4-5.1.7l-4.9.4c-2.3 0-4.4-.5-5.8-.4-2.4.2-2.5.8-6.2 1.1a67 67 0 0 1-3.8.2l-2.2-.7c.9-.3 1.1-.5 1.5-1 .3-.4.2-.7.6-1.1l.7-1a2.2 2.2 0 0 0-.9-.4h-1a3 3 0 0 0-1.2.3l-.8.6-2.2-1.2a8.8 8.8 0 0 0-3-.9zm2 11.8"
            }),
            /* @__PURE__ */ jsxs11("g", {
              fill: "none",
              stroke: "#fedf00",
              strokeLinecap: "round",
              children: [
                /* @__PURE__ */ jsx18("path", {
                  d: "m568.8 359.5-.8.3c-.9.4-1.6.4-2.6.5-2.6.2-4.3-1.1-7-.9-1.4.1-2 1.2-3.5 1.6a9.3 9.3 0 0 1-1.7.2l.5-1s-1.2.3-2 .3a7.5 7.5 0 0 1-1.6-.2l1-1-1.3-.2a4 4 0 0 1-1-.7 20.5 20.5 0 0 0 1.7-.3c1.5-.4 2-1.2 3.9-1.4 1.1 0 3 0 7.6.8 3 .5 4.4.2 5.5-.3.8-.3 1-1 1.1-1.8.1-.8-.4-1.4-.8-1.8-.1 0-.5-.3-1.1-.4"
                }),
                /* @__PURE__ */ jsx18("path", {
                  fill: "#fcd900",
                  strokeLinecap: "butt",
                  strokeWidth: 0.5,
                  d: "M524.8 350.6c-.5 0-.9 0-1.3.3-.5.3-.6.7-1 1.1.5.1.8.4 1.2.3.4 0 .5-.2.8-.5.3-.4.4-.7.4-1.2z"
                }),
                /* @__PURE__ */ jsx18("path", {
                  d: "M536 363.8a13.6 13.6 0 0 0 1 2.3c.2.8 0 1.2.2 2v1.6m6.8-7-.3 1.3-1 3.5v.7m-11-4c.9.2.6 3.3 1.9 4"
                }),
                /* @__PURE__ */ jsx18("path", {
                  strokeLinecap: "butt",
                  d: "m560.1 369.8.4-.3a8.2 8.2 0 0 0 2.7-1.8"
                }),
                /* @__PURE__ */ jsx18("path", {
                  d: "M552.4 368c3.5-.9 5.9-2.6 7.6-2.9m-4-1.5h.8c1.5-.3 1.7.6 2.7 1.2 1.9 1 2.1 2.3 4.3 3.4l.4.1.8.4"
                }),
                /* @__PURE__ */ jsx18("path", {
                  fill: "#fcd900",
                  strokeLinecap: "butt",
                  strokeWidth: 0.5,
                  d: "M517.7 354.5h.7l.8-.2c.3 0 .5 0 .7.2.2 0 .2.1.3.3 0 .2.2.3.1.5 0 .2-.3.4-.6.4-.2 0-.4 0-.5-.3a.5.5 0 0 1 0-.4 1 1 0 0 1-.9 0 1 1 0 0 1-.6-.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsx18("path", {
              fill: "#0065bd",
              d: "m525.1 364.2-2-.9c.4-.2.7-.2 1-.5.3-.4.3-.8.5-1.3s.2-1 .7-1.4c.3-.2.8-.2 1.1-.1.4 0 .8.4.9.7 0 .6-.2 1-.3 1.5 0 .6-.3.9-.2 1.4 0 .4.2.6.4 1l-2-.4zm-1 1a.6.6 0 1 1 .7.5.6.6 0 0 1-.7-.6zm-1.7-16.6h-.2c-.4-.4-.4-.8-.6-1.2a4 4 0 0 1-.3-1.2v-2c0-.3 0-.6-.2-.9 0-.2-.4-.3-.3-.4 0-.1.3 0 .4 0 .4 0 .6.1 1 .4.3.3.5.6.6 1l.4 1.5.3.8.5.6-.7.8zm3.6 10.6 2.2 1a9.2 9.2 0 0 0 3.5-3.8c.9-1.8 1-2.7 1.4-4.4l-1.8-.5h-.4c-.5 1.8-.7 2.7-1.6 4.2-.8 1.3-1.7 2.3-2.6 3zm5 18.2.8-1.3 1.4-1.1h.4a8.7 8.7 0 0 1-.5 2.8l-.4 1-.5.5c-.5-.8-1.3-1.3-1.3-2zm33 1.8 1.4.6 1.5.9v.5l-1.5.2a8.4 8.4 0 0 1-1.3 0h-1l-.6-.4c.5-.7.8-1.6 1.4-1.8zm-9.8-2 1.4.5 1.5 1c0 .1.1.3 0 .4a9 9 0 0 1-2.7.3l-1-.1-.7-.3c.6-.7.9-1.7 1.5-1.8m-17.4 2.1 1.5.5 1.5 1v.5a9 9 0 0 1-2.8.2h-1l-.6-.4c.5-.7.8-1.6 1.4-1.8m-9-29.8c-.6-.3-1-1-.6-1.6.1-.2.4-.2.6-.4.2-.3.1-.5 0-.8l-.1-1-.2-1c0-.6 0-1 .4-1.6.2-.3.7-.6.8-.6.2.1 0 .5 0 .8 0 .5.1.7.3 1.2l.7 1.3c.2.6.4.8.4 1.4 0 .5 0 .7-.2 1.2a2 2 0 0 1-.6.8 2 2 0 0 1-.8.4 1.1 1.1 0 0 1-.6 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsx18("use", {
          xlinkHref: "#ad_svg__b",
          width: "100%",
          height: "100%",
          y: 36.6
        })
      ]
    }),
    /* @__PURE__ */ jsx18("path", {
      fill: "none",
      stroke: "#703d29",
      strokeWidth: 0.5,
      d: "M264.1 175.5h52.6V228h-52.6zm58.2 0h52.6V228h-52.6zm-58 98c.1 1 .5 2.6 1.4 4.3 1 1.5.6 1.4 2.7 3.8a15.3 15.3 0 0 0 4 2.9 32.7 32.7 0 0 0 15 2.6c2.7-.1 4.8-.4 6.6-.7a71 71 0 0 1 11-.6c1.5 0 3 .3 4.7.6 3.5.7 7 2 7 2v-54.7h-52.6V271l.2 2.4zm110.4 0a13 13 0 0 1-1.4 4.3c-1 1.5-.6 1.4-2.7 3.8a15.4 15.4 0 0 1-4 2.9c-1.3.7-2.3 1-4.4 1.6a32.6 32.6 0 0 1-10.6 1c-2.7-.1-4.8-.5-6.5-.7a71 71 0 0 0-7.2-.6 40.5 40.5 0 0 0-3.9 0c-1.5 0-3 .3-4.7.6-3.5.7-7 2-7 2v-54.8H375v37.5l-.2 2.4z"
    })
  ]
});
var Ad_default = SvgAd;

// src/country-flag-icons/generated/Ae.tsx
import { jsx as jsx19, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgAe = (props) => /* @__PURE__ */ jsxs12("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx19("path", {
      fill: "#00732f",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx19("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx19("path", {
      fill: "#000001",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx19("path", {
      fill: "red",
      d: "M0 0h220v480H0z"
    })
  ]
});
var Ae_default = SvgAe;

// src/country-flag-icons/generated/Af.tsx
import { jsx as jsx20, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgAf = (props) => /* @__PURE__ */ jsxs13("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs13("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx20("path", {
          fill: "#000001",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx20("path", {
          fill: "#090",
          d: "M426.7 0H640v480H426.7z"
        }),
        /* @__PURE__ */ jsx20("path", {
          fill: "#bf0000",
          d: "M213.3 0h213.4v480H213.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs13("g", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#bd6b00",
      strokeWidth: 0.5,
      transform: "translate(1 27.3) scale(1.06346)",
      children: [
        /* @__PURE__ */ jsx20("path", {
          d: "M319.5 225.8h8.3c0 3.2 2 6.6 4.5 8.5h-16c2.5-2.2 3.2-5 3.2-8.5z"
        }),
        /* @__PURE__ */ jsx20("path", {
          stroke: "none",
          d: "m266.7 178.5 4.6 5 57 .2 4.6-5-14.6-.3-7-5h-23l-6.6 5.1z"
        }),
        /* @__PURE__ */ jsx20("path", {
          d: "M290 172.7h19.7c2.6-1.4 3.5-5.9 3.5-8.4 0-7.4-5.3-11-10.5-11.2-.8 0-1.7-.6-1.9-1.3-.5-1.6-.4-2.7-1-2.6-.4 0-.3 1-.7 2.4-.3.8-1.1 1.5-2 1.6-6.4.3-10.6 5-10.5 11.1.1 4 .6 6.4 3.4 8.4z"
        }),
        /* @__PURE__ */ jsx20("path", {
          stroke: "none",
          d: "M257.7 242.8H342l-7.5-6.1h-69.4z"
        }),
        /* @__PURE__ */ jsx20("path", {
          d: "m296.4 219.7 1.5 4.6h3.5l-2.8-4.6zm-2 4.6 1 4.6h4l-1.5-4.6zm7 0 2.8 4.6h5.9l-4.6-4.6zm-34.5 10.4c3.1-2.9 5.1-5.3 5.1-8.8h7.6c0 2 .7 3.1 1.8 3h7.7v-4.5h-5.6v-24.7c-.2-8.8 10.6-13.8 15-13.8h-26.3v-.8h55.3v.8H301c7.9 0 15.5 7.5 15.6 13.8v7h-1l-.1-6.9c0-6.9-8.7-13.3-15.7-13.1-6 .1-15.4 5.9-15.3 13v2.2l14.3.1-.1 2.5 2.2 1.4 4.5 1.4v3.8l3.2.9v3.7l3.8 1.7v3.8l2.5 1.5-.1 3.9 3.3 2.3h-7.8l4.9 5.5h-7.3l-3.6-5.5h-4.7l2.1 5.4h-5l-1.3-5.4h-6.2v5.8H267zm22.2-15v4.6h5.3l-1-4.6H289z"
        }),
        /* @__PURE__ */ jsx20("path", {
          fill: "none",
          d: "M289.4 211.7h3.3v7.6h-3.3z"
        }),
        /* @__PURE__ */ jsx20("path", {
          fill: "none",
          d: "M284.7 219.8h3.2v-5.6c0-2.4 2.2-4.9 3.2-5 1.2 0 2.9 2.3 3 4.8v5.8h3.4v-14.4h-12.8zm25.6 3.3h4v3.2h-4zm-2.4-5.3h4v3.1h-4zm-3.9-5.4h4v3.1h-4zm-3.3-4.5h4v3.1h-4z"
        }),
        /* @__PURE__ */ jsx20("path", {
          fill: "none",
          d: "m298 219.8 4.2.2 7.3 6.4v-3.8l-2.5-1.8v-3l-3.6-2v-3.3l-3.5-1.2V207l-1.7-1.5z"
        }),
        /* @__PURE__ */ jsx20("path", {
          d: "M315.4 210.3h1v7.1h-1z"
        }),
        /* @__PURE__ */ jsxs13("g", {
          id: "af_svg__a",
          children: [
            /* @__PURE__ */ jsx20("path", {
              d: "M257.3 186.5c-1.2-2-2.7 2.8-7.8 6.3-2.3 1.6-4 5.9-4 8.7 0 2 .2 3.9 0 5.8-.1 1.1-1.4 3.8-.5 4.5 2.2 1.6 5.1 5.4 6.4 6.7 1.2 1 2.2-5.3 3-8 1-3 .6-6.7 3.2-9.4 1.8-2 6.4-3.8 6-4.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              fill: "#bf0000",
              d: "M257 201.9a10 10 0 0 0-1.6-2.6 6.1 6.1 0 0 0-2.4-1.8 5.3 5.3 0 0 1-2.4-1.5 3.6 3.6 0 0 1-.8-1.5 5.9 5.9 0 0 1 0-2l-.3.3c-2.3 1.6-4 5.9-4 8.7a28.5 28.5 0 0 0 0 2.3c.2.5.3 1 .6 1.3l1.1.8 2.7.7a7.1 7.1 0 0 1 2.6 2 10.5 10.5 0 0 1 1.8 2.6l.2-.8c.8-2.7.7-5.9 2.6-8.5z"
            }),
            /* @__PURE__ */ jsx20("path", {
              fill: "none",
              d: "M249.8 192.4c-.5 3.3 1.4 4.5 3.2 5.1 1.8.7 3.3 2.6 4 4.4m-11.7 1.5c.8 3 2.8 2.6 4.6 3.2 1.8.7 3.7 3 4.5 4.8"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "m255.6 184.5 1-.6 17.7 29.9-1 .6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M257.5 183.3a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm15.2-24h7.2v1.6h-7.2zm0 3.1h7.2v13.8h-7.2zm-.4-5h8c.2-2.7-2.5-5.6-4-5.6-1.6.1-4.1 3-4 5.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              fill: "#bd6b00",
              stroke: "none",
              d: "M292.6 155.8c-1.5.6-2.7 2.3-3.4 4.3-.7 2-1 4.3-.6 6.1 0 .7.3 1.1.5 1.5.2.3.4.5.6.5.3 0 .6 0 .7-.3l.2-.8c-.1-2-.1-3.8.3-5.4a7.7 7.7 0 0 1 3-4.4c.3-.2.4-.5.5-.7a1 1 0 0 0-.3-.7c-.4-.3-1-.4-1.5-.1m.2.4c.4-.2.8 0 1 .1l.1.2c0 .1 0 .2-.3.4a8.2 8.2 0 0 0-3.1 4.6 16.7 16.7 0 0 0-.3 5.6 1 1 0 0 1-.2.6s0 .1-.2 0c0 0-.2 0-.4-.3a3.9 3.9 0 0 1-.4-1.2c-.3-1.8 0-4 .7-6 .7-1.8 1.8-3.4 3-4z"
            }),
            /* @__PURE__ */ jsx20("path", {
              fill: "#bd6b00",
              stroke: "none",
              d: "M295.2 157.7c-1.5.7-2.5 2.3-3 4.2a13.6 13.6 0 0 0-.3 5.9c.2 1.3 1 2 1.6 2 .3.1.6 0 .8-.3.2-.3.3-.6.2-1-.4-1.6-.5-3.4-.3-5.1.3-1.7 1-3.2 2.2-4.1.3-.3.5-.5.5-.8a.8.8 0 0 0-.2-.6c-.4-.3-1-.4-1.5-.2m.2.5c.4-.2.8-.1 1 0l.1.3-.3.4a6.5 6.5 0 0 0-2.4 4.4c-.3 1.8-.1 3.7.2 5.2.1.4 0 .6 0 .8l-.5.1c-.3 0-1-.5-1.2-1.7-.3-1.7-.2-3.9.3-5.7.5-1.8 1.5-3.3 2.8-3.8"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M272.3 187.4h8v11h-8zm.5 17.4h7.7v2.4h-7.7zm-.2 4.1h8v8.7h-8zm-.6 10.5h8.7v4.9H272zm1.1-16.6h7l1.4-2.4h-9.6zm9.4-8.6.1-6h4.8a17.4 17.4 0 0 0-4.9 6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              fill: "none",
              d: "M273.6 196.7c0 1.3 1.5.8 1.5.1v-5.6c0-1 2.4-.8 2.4-.1v6c0 1 1.7.9 1.6 0v-7c0-2.2-5.5-2.1-5.5-.1zm0 13.3h5.7v7h-5.7z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M277.2 213h2v1h-2zm-3.5 0h2v1h-2zm2-3h1.5v3h-1.5zm0 4h1.5v3.1h-1.5zM244 139c.4 5.5-1.4 8.6-4.3 8.1-.8-3 1-5.1 4.3-8.1zm-6.5 12.3c-2.6-1.3-.7-11.5.3-15.8.7 5.5 2 13.3-.3 15.8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M238.4 151.8c4.4 1.5 8-3.2 9.1-8.7-3.6 5-9.5 5-9 8.7zm-3.3 5.1c-3.4-.9-1.4-11.7-.7-16 .7 4.5 3.1 14.5.7 16zm1.2-.3c.2-3.7 3.9-2.7 6.5-4.7-.5 2-2 5.2-6.5 4.7zm-4.2 5c-3.4-1-1.4-12.6-1.6-17.4 1 4.2 4.2 16.3 1.6 17.4zm1.6-.5c2.8.9 6.5-1 6.8-4.3-2.5 1.7-6.3.4-6.8 4.3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M229.5 166.7c-3.2.3-1.8-9.6-1.8-18.8 1.2 8.6 4.5 16.5 1.8 18.8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M230.7 166.3c2.2 1 6.1-.7 7.2-4.4-4 1.7-6.6 0-7.2 4.4zm25.6-22.2c-.6 4.9-2.6 7.7-5.5 7.2-.8-3 1.6-5 5.5-7.2zm-7.8 12.4c4.9.7 6.6-3 10-7.9-4.7 3.4-10.2 4-10 8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M247 156c-2.6-3.2 0-7.3 2-10.7-.4 5.1 1.3 8-2 10.7zm-1 5.3c-.4-3.2 5-3.9 7.4-5.6-.9 1.8-2 6.7-7.5 5.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M244.8 161.3c-3.7-.4-2.2-6.7.5-10.1-1.1 4.8 2 8.1-.5 10.1z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M242 166.6c-4.2-2-1.5-7.2 0-10.3-.6 4.1 2.8 7.2 0 10.2z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M242.8 166c2.2 3 6.5-.8 7.4-5.2-3.7 3.1-6.5 2.6-7.4 5.3zm-9.6 20.3c-.4-4.3 2.8-12 .5-16.2-.3-.6.7-2.1 1.4-1.2 1 1.5 2 5.7 2.5 4.1.4-1.7.5-4.6 2-5.2 1-.3 2.3-.6 1.9 1-.4 1.4-1.2 3.4-.3 3.5.5 0 2-2 3.3-3 1-.8 2.6.6 1 1.8-4.8 4-9.5 5.9-12.3 15.2zm-8.7 64.5c-.6 0-1.3-.3-.6.6 5.7 7 7.3 9 15.6 8 8.3-1.1 10.3-3.4 16.2-6.7a14.6 14.6 0 0 1 11.2-1c1.6.5 2.6.5 1.4-.7-1.2-1.1-2.5-2.7-4-3.8a17.5 17.5 0 0 0-12.7-2.7c-6 1-11.1 4.9-17.2 6.4a25 25 0 0 1-9.9 0zm47.8 12.5c1 .2 1.7 2.2 2.3.9.8-2.3.2-4-.8-3.9-1.2.3-3.1 3-1.5 3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              stroke: "none",
              d: "M220.6 183c-1.2-1.4-.9-1.8 1-1.9 1.4 0 4.2 1 5.3.1 1-.7.5-3.7 1-5 .2-.9.7-2 2-.2 3.6 5.8 8 12.8 10 19.6 1 3.8 0 9.8-3.4 13.8 0-3.4-1.2-5.7-2.7-8.6-2-3.7-9.1-14-13.2-17.9z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M235.5 213.4c4 0 4.7-5.3 4.7-6.8-2 .4-5.4 3.7-4.7 6.8zm34.5 51.9c2.8.6 2.7-6.2-.2-9.1 1.3 4.4-2 8.4.1 9zm-1.2-.1c.2 3.2-8-.4-10-3 4.8 2.1 9.8.4 10 3zm-3.5-4.6c.3 3.1-7 .3-9.3-2.1 4.9 1.6 9-.5 9.3 2zm1.3.4c2.9.7 2.4-6.4-.4-8.8 1.4 4.7-1.8 8.1.4 8.8zm-3-4.3c2.9.7 1.2-5.4-.9-7.8.4 4.4-1 7.5 1 7.8zm-1.5 0c.3 3.2-5.4.8-7.6-2.3 4.8 1.5 7.3-.3 7.6 2.3zm-1.5-2.5c1.8-1.3-.1-4.8-3.7-4.6.4 2.1 1.6 5.9 3.7 4.6zm14 14.7c.1 3.2-8 1.6-10.6-1.8 5.2 1 10.3-.8 10.5 1.8zm-32.4-5.8c.3 3.2-8.6-.4-10.8-3.4 4.7 1.6 10.5.8 10.8 3.4zm5.4 1.3c1.9-1.3-1.9-4.7-5-5.5.4 2.1 3 6.8 5 5.6zm.6 2.3c.2 2.9-9.5 1.3-12-1.4 8.3 1.5 11.7-1.1 12 1.4z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M252.8 268.6c1 2.7-8.3 2-11.6.5 5.3 0 10.8-2.4 11.6-.5z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M257.1 270.6c1 2.4-7.6 2.4-11.8 1 5.6 0 10.8-3.4 11.8-1zm6.3 1.3c1.6 2.9-7.6 3.1-10.5 1.7 5.2-.7 9.2-4 10.5-1.7zm-10.7-4.9c-2.9 1.8-2.7-3.6-5-7.3 3.6 3.3 7 5.6 5 7.3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M257.9 269c-2.4 2.1-4.4-5.3-6.6-9.5 3.6 4 8.8 7.7 6.6 9.4zm6.8 2c-2 2.4-8-7-10.2-12 3.3 3.9 11.8 10 10.2 12zm-5.8 7.2c-1 3.6-16.2-3.4-18-7.1 8.8 4.6 18.2 3.6 18 7zm-48.7-73.8c-.4-.5-1.4 0-1.2 1.1.3 1.5 2.5 9.2 6.3 11.8 2.7 2 17 5.1 23.4 6.5 3.6.7 6.5 2.5 8.9 5.3a94.4 94.4 0 0 0-3-9.8c-1.2-3-4.4-6.2-7.8-6.3-6.1-.3-14.1-.8-20-3.3a16 16 0 0 1-6.7-5.3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M245.5 234.9c2 1.4 4.1-3.7 1.7-8.6-.1 4.7-3.8 6.3-1.7 8.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M247.4 239.6c2.7.8 3.5-4 1.8-7.8.3 4.1-4.3 6.6-1.8 7.8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M249.5 243.4c2.6 1.3 3.5-3.6 1.7-7.1.2 4.5-3.7 5.9-1.7 7z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M248.4 243.7c-1 3-7-2.7-8-5.8 3.7 3.7 8.7 3.2 8 5.7z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M245.7 239c-1.2 3-8.7-5-10.4-8.7 3.7 3.7 11.2 6.5 10.4 8.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M244.2 234.3c-1.2 3.5-9.3-5.8-11.7-9.1 4 3.6 12.6 6.6 11.7 9.1zm-.3-3.4c3-.6-.1-3-3.7-6.9-.1 4.1.5 7 3.7 6.9z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M239 228.5c1.3-1.3-1.1-1.9-4.1-5.3-.5 2.3 2.8 6.5 4.2 5.3zm14 15.2c1.6 1 2.6-2.3.7-5.2-.5 3.2-2.1 4-.7 5.2zm-34.2-20.3c-3.3 2-8.6-6-10-9.3 2.9 3.8 10.6 7.2 10 9.3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M221.7 228c-1.9 2-7.7-3.5-9.7-6.3 3 2.7 10.5 3 9.7 6.3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M224.8 232.2c-.6 2.8-9-3.5-11-6.5 3.6 3.5 11.6 3.2 11 6.5z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M223.5 235.3c-1.3 2.5-8.2-3.8-9.9-7 4.3 3.6 11 4.5 10 7zM220 223c2.1-2.3 1.2-3.4-.4-7-.8 3.7-2.1 5.2.4 7zm2.9 4.3c4 .2 0-4.6-1-8.7.4 4.6-1 8.3 1 8.7z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M225.4 231.1c2.7-.6 2-4.5-.2-9.2.5 5.1-2.3 8 .2 9.2zm-1 7.7c-1 3-8.8-4-10-6.8 4 3.4 10.7 4.5 10 6.8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M229.1 243.6c-1.1 3-9.3-3.2-11.8-6.6 4.9 4 12.4 3.6 11.8 6.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M233.9 248.5c-1.3 4.3-9.9-2.6-12.4-6 5.4 4.2 13 3 12.4 6zm-8-11c2.3 1.1 3.2-5.4 1.9-10.1 0 5-4.7 8.8-2 10z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M229.8 242.7c2.8.8 2-6.3-.5-11-.3 4.7-2.3 9 .5 11zm5 4.9c3 .1 1-6.1-1.6-9.6.4 4.5-1 9 1.6 9.6zm-5.5 2.6c-1 1.6-3.2-1.3-7-3.5 3.4 1 7.4 2 7 3.5zm-1.8-52.7c3-2.2.7-6.2 0-10-1 3.6-3.4 8.4 0 10zm0 5.3c-4.5-.5-3.8-6.1-4-9.7 1.4 4.9 5 5.7 4 9.8zm.6-.7c3.7-.2 3.5-4.4 3.7-8.6-1.9 3.9-4 4.5-3.7 8.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M228 207.3c-3 .3-4.4-2.6-5-7 2.7 4.1 5.1 2.8 5 7zm1-.3c3.7.5 3-3.8 3-7-1.2 3-4.2 4-3 7z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M223.2 205.2c.3 2.8 2.1 7.6 5 6.5 1.1-3.4-2.6-4.1-5-6.5z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M229 212c-1.2-2.4 3-3.7 3.8-6.9.5 4.6.1 7.6-3.8 7zm-11.9-29.2c2.3-2.4.3-6.4-.4-10.2-1 3.6-2.5 8.4.4 10.2zm0 4.6c-4 .5-5-7.7-5.5-11.3 1.4 4.9 6 7 5.5 11.4zm.8 0c2.8-1.5 2.2-4.7 3-7-1.8 2.9-3.6 3.3-3 7z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M217 192.8c-4.1.3-6.6-8.8-6.8-12.4 1.3 4.9 7.4 7.5 6.9 12.4zm.9-.2c4-.9 3.5-3.5 2.9-7.6-1.3 4.2-3.5 3.3-2.9 7.6z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M217 198c-4.6.8-4.3-6.6-8-11.9 3.2 4 9 9 8 11.9zm1-.3c3.6.2 4-5.1 3.8-7.3-.9 2.2-5 4.2-3.7 7.4z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M209.8 192.3c1.7 5.7 4.2 11.4 7.2 11 1.5-3.3-2.9-3.7-7.2-11z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M218.1 202.4c-1.2-2.5 3-3.7 3.8-6.9.5 4.6.1 7.6-3.8 6.9zm-7.1-3.6c2.5 5.1 3.6 11 7 10.1 1.3-4-3.8-4.8-7-10.1z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M218.7 208c-1.5-2.8 2.7-3.7 3.8-7.4.5 4.8 0 8.3-3.8 7.3zm7.2-34.5c2.4.6 5-2.1 4.1-6.2-2.8.6-4 3.2-4.1 6.2zm-7.9-2.1c.2 1.2 1.7 1.3 1.2-.4a5.3 5.3 0 0 1 0-3.4 7.5 7.5 0 0 0 0-4.6c-.4-1-1.8-.4-1.2.4.6.9.7 2.8.2 3.7-.6 1.3-.4 3-.2 4.3zm22.9 16c-1 1.3-2.9.4-1.4-1.5 1.2-1.5 3-2.8 3-4.4.2-2 1.3-5 2.4-6.1 1.1-1.1 2.4.4 1.2 1.2-1.3.8-2.2 4.4-2.1 5.8-.1 2-2 3.5-3.1 5zm-3-2.3c-1 1.4-2.4.5-1.6-1.7.7-1.5.8-3.5 1.6-4.6 1.2-1.7 3-3.1 4.1-4.2 1.2-1 2 0 1 1a27 27 0 0 0-3.3 4c-1.4 2.2-.8 4-1.8 5.5zm-15.7-7.2c-.1 2 1.5 2.4 1.4-.4 0-3-2.2-5.8-1-10.3.8-2.2.8-6.3.4-8.4-.4-2.2-2-.8-1.3.9.6 2-.1 5.6-.6 7.5-1.5 5.4 1.2 8 1 10.7zm4.3-11c-.2 1.9-1.8 2-1.3-.5.4-2 .4-3.6 0-5.3-.6-2.1-.4-5.7 0-7.2.5-1.6 2-.7 1.4.5a9.9 9.9 0 0 0-.3 5.9c.6 2 .5 4.8.2 6.7zM210.9 204c.8.9 2 .3 1-1-1-1-.7-1.2-1.3-2.4-.6-1.4-.5-2.1-1.2-3-.7-1-1.6 0-1 .7.8 1 .6 1.6 1 2.5 1 1.5.7 2.3 1.5 3.2zm20.4 24.6a8.6 8.6 0 0 1 4.4 6.7 16 16 0 0 0 2 7.1c-2-.5-3-3.7-3.3-6.8-.3-3.2-2-4.5-3-7zm5.1 5.9c1.7 3.1 4 4.3 4.2 6.6.2 2.7.4 2.8 1.1 5.4-2-.5-2.5-.7-3-4.7-.3-2.8-2.6-4.7-2.3-7.3z"
            }),
            /* @__PURE__ */ jsx20("path", {
              stroke: "none",
              d: "M289 263.3c1 1.8 2 4.5 4 4 0-1.3-2.1-2.3-4-4m3 .6c3.7 1.6 7 1.2 7.5 3.6-3.6.4-5-1-7.6-3.6zm-16.1-12.7a14 14 0 0 1 5 7.7 29 29 0 0 0 3.6 7.8 13 13 0 0 1-5.3-7.4c-.7-3-1.6-5.3-3.3-8zm3.1 0c2.8 2.2 5.4 4.8 6.2 7.9.8 2.9 1.3 5.1 3.2 8-3-1.9-4.1-4.7-5-7.8-.7-3-2.5-5.2-4.4-8zm9.2 7.3a1.1 1.1 0 0 1 .7-1.2 33.4 33.4 0 0 1 2.6-.8c1-.3 1.6.4 1.6.9v2c0 .7-.2.8-.7.9-.7.1-1.7.2-2.4.7-.6.4-1.2.1-1.5-.5zm10.6 0c0-.6-.2-1.1-.6-1.2a5.4 5.4 0 0 0-2.4-.4c-1 0-1.1.2-1.1.6v2.1c0 .8 0 .8.4 1 .7 0 1.8 0 2.5.6.5.3 1 0 1.1-.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx20("use", {
          xlinkHref: "#af_svg__a",
          width: "100%",
          height: "100%",
          x: -600,
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsxs13("g", {
          stroke: "none",
          children: [
            /* @__PURE__ */ jsx20("path", {
              d: "M328.5 286.6c0 1.2.2 2.2 1 3.1a19 19 0 0 0-13.8 1.1c-1.8.8-4-1-1.9-2.7 3-2.3 9.7-1 14.7-1.5m-57.5 0a7 7 0 0 1-.4 3c4.4-1.7 9.1-.2 13.6 1.6 3 1.3 3.3-1 2.8-1.7a6.5 6.5 0 0 0-5-2.9zm3.8-21.7c-1.3-.5-2.7 0-4 1.4-4.3 4.2-9.4 8.3-13.5 11.6-1.5 1.3-3 3.7 3.4 6 .3.2 5 2 8 2 1.3 0 1.3 1.8 1 2.3-.5 1-.1 1.4-1.1 2.3-1.1 1 0 2.1 1 1.3 3.6-3.2 9.6-1.1 15.3.7 1.4.4 3.8.3 3.8-1.6 0-2 1.5-3.4 2.4-3.5 2.4.4 14 .5 17.5.1 2-.3 2.2 2.9 3.3 4 .8.9 3.7 1.1 5.8.2 4-1.8 10-1.8 12.5 0 1 .7 1.9 0 1.3-.7-.8-1-.7-1.6-1.1-2.4-1-2-.2-2.4.8-2.5 11-1.5 14.6-5.2 11.2-8.3-4.4-3.8-9.2-7.7-13.4-12.2-1.2-1.2-2-1.7-4.3-.7a66.5 66.5 0 0 1-25.3 5.9 76 76 0 0 1-24.6-5.8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              fill: "#bd6b00",
              d: "m326.6 265.5-1.6.4c-9 3.2-17.2 5.4-25.7 5.4-8.3 0-17-2.4-24.9-5.6a2.3 2.3 0 0 0-1.5 0c-.5.1-1 .4-1.3.7a115.5 115.5 0 0 1-11.8 10.3c-.7.5-.6 1.8.5 2.2 8.3 3 16.4 8.5 39.6 8.3 23.5-.2 31.8-5.6 39.2-8.1.5-.2 1-.5 1.3-1a1 1 0 0 0 .1-.8 2 2 0 0 0-.6-.8c-4.3-3.5-8.8-6.3-11.8-10.4-.3-.5-.9-.6-1.5-.5zm0 .5c.5 0 1 0 1.1.3 3 4.3 7.7 7 11.9 10.5l.4.7a.5.5 0 0 1 0 .4c-.1.3-.6.6-1 .7-7.6 2.6-15.7 8-39 8.2-23.2.2-31.2-5.3-39.5-8.3-.8-.4-.7-1.2-.4-1.4 4.2-3.2 8.2-6.8 11.8-10.4a2.5 2.5 0 0 1 1.1-.6h1.2a68 68 0 0 0 25 5.6c8.7 0 17-2.2 26-5.3a6.7 6.7 0 0 1 1.5-.4z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M269.7 114.6c0-1.4 2-1.5 1.8.4-.3 2.3 4.5 8.3 4.9 12 .3 2.5-1.5 4.6-3.2 6a6.6 6.6 0 0 1-6.8.5c-.9-.8-1.7-3.3-1-4.3.2-.3 1.3 3.7 3.7 3.7 3.3 0 6-2.5 6-4.7.2-3.8-5.3-9.8-5.4-13.6m9.5 9.4c.6-.4 1.4 1.3.8 1.7-.5.3-1.5-1.3-.8-1.8zm1.5-3.5c-.3.2-.8 0-.7-.2a12 12 0 0 1 3.6-3.3c.4-.2 1 .4.8.7a11 11 0 0 1-3.7 2.8m12.6-10c.3-.6 2.1-1.3 2.6-1.7.4-.5.6.4.4.7-.3.7-1.9 1.7-2.6 1.8-.3 0-.6-.4-.4-.7zm4.3.3a8.3 8.3 0 0 1 2.5-3.4c.5-.3 1.3 0 1.1.4a9 9 0 0 1-2.9 3.3c-.3.3-.8 0-.7-.3m-3.7 2.7c-.3.2-.1.7.1.8.6.2 1.5.2 2 0 .6-.4.3-2.9-.5-1.6-.6.8-1 .6-1.6.8m-7.3 5.6c-1.3-1 .4-2.4 1.7-1.4 2.7 2-4 9.8-7.6 13.4-.7.7-1.3-1-.4-1.9a33.7 33.7 0 0 0 6.7-7.6c.4-.5.7-1.6-.4-2.5m15.3-6.6c.1-1-1.6 0-1.6-1.3 0-.7 1.9-1.2 2.7-.4 1.3 1.4.3 3.7-2 3.9-1.8 0-5 2.7-4.5 3.2.5.7 5.4 1.1 8.3.7 1.8-.3 1.4 1.3-.4 1.5-1.8.2-3.2 0-4.8.6-2 .5-2.8 3-3.9 4-.2.2-.8-.8-.6-1.2.8-1.2 2-3 3.4-3.6.8-.3-2.4-.4-3.4-.7-.8-.2-.6-1.3-.3-1.9.4-.8 3.4-3.9 4.7-3.8 1.1 0 2.3-.3 2.4-1m5 .2c.6-.5 1-1.3 1.5-1.8.3-.3.9 0 .8.8-.1.7-1 1.2-1.5 1.7-.5.3-1-.4-.7-.7zm6.5-2.3c.9 0 1 1.6.2 1.8-.6.2-1-1.7-.2-1.8m-2.1 5c0 1.5.7 1.4 2 1.3 1.3 0 2.4 0 2.4-1.2 0-1.3-.7-2.5-1-1.6-.1.8-.3 2.2-.8 1.6-.4-.5-.2-.6-1 .2-.5.5-.5-.2-.8-.6-.2-.3-.8.2-.8.4zm-9.2 7.2c-.3 1.9 0 4.5.9 4.5 1.2 0 3.6-4 4.8-6.2.7-1.2 1.8-1.4 1.3-.1-.7 1.9-.6 6 0 7.2.4.6 3-.6 3.4-1.5.8-1.7.1-4.8.4-6.7.1-1.2 1.3-1.5 1.2-.3a75.6 75.6 0 0 0-.1 7.5c0 1 2.9 2.4 3.3-.6.2-1.8 1.2-3.7 0-5.7-.8-1.3 1.1-1.2 2.1.6.7 1.2-.6 3.2-.5 4.7 0 2.4-1.8 3.8-3.1 3.8-1.2 0-2-1.5-3-1.5s-2.2 1.7-3 1.6c-3.6-.2-1.7-5.3-2.8-5.4-1.2 0-2.5 5-4 4.9-1.4-.2-3-4.2-2.3-5.8.5-1.6 1.5-2 1.4-1m16.9-8c-1.7-1 0-3.7.9-2.8 1.6 2 3.2 6.5 4.4 6.9.7.2.6-3.4 1.1-5 .4-1.3 1.8-.9 1.6.7-.1.5-2 6.4-1.8 6.6a47.1 47.1 0 0 1 3.3 7.8c.3 1.2-1.1.4-1.3.2-.9-1.4-2.4-6.5-2.4-6.2l-1.7 7.7c-.2 1-1.7.8-1.3-1 .3-1.4 2.3-8.3 2.2-8.6a17.2 17.2 0 0 0-5-6.3"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M322 131.2c-.4 0-1.2 1 1.2 1.5 3.1.6 6.6-.5 7.6-3.6 1.3-3.7 2-7.2 2.7-8.5.8-1.5 1.8-1.4 1-3.6-.5-1.7-1.5-1.2-1.7-.3-.5 2.3-2.6 10-3.3 11.3-1.2 2.6-3.7 3.6-7.5 3.2"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M328.4 119c-.4-.7-1.2 0-1 .7a1.2 1.2 0 0 0 1.2 1c.7 0 2.2.1 2.2-1 0-.8-.7-1.5-1.1-.6-.5.8-1 .7-1.3 0zm.7-3c-.2.2 0 1.1.3 1a7 7 0 0 0 3.3-.8c.2-.2.1-.7-.2-.7-1 0-2.6 0-3.4.5m8.8 2.3c.8-1.2 2.8-1.3 2 .4a614.3 614.3 0 0 1-6.3 12.3c-.8 1.4-1.4.7-.8-.4.7-1.4 4.9-12 5.1-12.3"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M330.2 133c-.2-.8-1.5-2-1.3.2.2 3.8 5.5 2.6 7 1.3s.3 4.3 2.2 4.9c1 .3 3-1.1 4-2.4 2.7-3.5 4.5-8.6 7-12 1-1.4-.5-2.4-1-1.3-2.4 3.8-5.2 11.6-8.3 13.6-2.5 1.6-1.7-2-1.8-3.2-.1-.8-1.1-2-2.4-.9a5.5 5.5 0 0 1-3.7 1.2c-.7 0-1.4 0-1.7-1.4"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M339.6 126c0-.3-1.1-.4-1 .7 0 .8 1 1 1.1 1 1.5-1.2-.3-.6-.1-1.8zm-2.3 4.4c-.3 0-.6 1 .2 1.1l3.9-.2c.4 0 .6-.9-.4-.8-1.2 0-2.7-.3-3.7 0zm-62-16.6c.5 0 1.6 1.4 1.5 1.9 0 .2-1.2 0-1.5-.3-.3-.3-.2-1.6 0-1.6m-5.3 10.4c-1 .6.2 1.7 1 1.2 2.8-1.9 7-3.8 8-7.5.3-1.2 1.4-3.1 2.5-3.5 1-.5 2.6 1.9 3.6 0 .6-1 2.7.7 3.2-.4.6-1.3.3-2 .3-3.4 0-.8-.7-1-1.2.3-.2.6 0 1.2-.1 1.6-.2.2-.6.4-1 .2-.2-.2 0-.7-.6-1-.2 0-.6-.1-.8.2-.7 1.3-1 2.5-2.1 1-.9-1-1.4-3.1-2-.3-.2 1-1.7 2.4-2.6 2.4-1.1 0-.8-3-3.2-2.5-1.3.3-1.2 2.7-1 3.5.3 1.3 4 .4 3.7 1.2-.6 2.7-4.4 5.4-7.7 7m-22.7 13.2c-.1.5.5 1.7 1.1 1.8.6 0 1-1.3.8-1.8-.2-.3-1.8-.3-1.9 0m3.3 4.9c-.4-.4-1.6.7-.6 1.5.5.5 2.5 1.1 3 .2.8-1.2-.7-5.5 0-6 .5-.5 2.8 2.8 4 3 2.7.4 2-4.6 5-4.2 1.9.2 2.1-2.2 1.8-3.8-.2-1.5-2.6-3.6-3.7-4.6-1.4-1.2-2.1 1-1.2 1.6 1.2 1 3.3 2.9 3.6 4.1.1.6-1.4 1.8-2 1.5-1.4-.8-2.6-4-3.8-4.7-.4-.2-1.4.3-1 1.3.6 1.1 3 2.7 3.1 3.9.1 1-1 3.2-1.8 3.2-.9 0-3-2.7-3.7-4-.4-.5-1.5-.5-1.7.4a22 22 0 0 0 .5 5.5c.2 1.6-.9 1.7-1.5 1.1m-4-8.6c-.4.4.8 1.2 1 1 .4-.4 2.1-2.3 1.8-3-.3-.6-2.6-2-3-1.3-.7 1.1 2.2 1.7 1.7 2a7 7 0 0 0-1.5 1.3m4.1-8.4s.8 2.5 1.4 1.4c.4-.7-1.4-1.4-1.4-1.4m1.2 4c-.2 0-1 .7-.5 1 .8.4 2.9.8 2.4-.7-.3-.9 3.2 0 2.3-2.4a3.7 3.7 0 0 0-1.7-1.7c-.4 0-1.5.5-.8.9.5.2 2 1.1 1.5 1.7-.7.6-1.1-.3-1.9-.1-.4 0-.1 1.2-.4 1.5 0 .2-.7-.4-.9-.3zm5.5-9.5a3.5 3.5 0 0 0-1.2 2c0 .2.3.6.5.5a3.2 3.2 0 0 0 1.2-1.9c0-.3-.2-.8-.5-.6m2.8-.3c-.8-1 1-2.6 1.7-.5.5 1.3 5.5 7.9 6.5 10.1.8 1.5 0 2.1-.9 1-2.5-3.2-4.6-7.2-7.3-10.6m5.2.1c.9-1 2.7-3 2.2-4-.4-1-1.5-1-1.7-.7-1 1.3.8 1 .5 1.4-.5 1-1 1.6-1.3 2.6-.1.3.1.9.3.7m77.8 3.2c-.7-.5.6-3 1.5-2 2.3 2.7 3.4 11.6 4.1 18.3 0 0-1 .9-1 .7 0-3.5-1.5-14.4-4.6-17m-53.1-8.6c-.8-1.8 1.1-2.4 1.4-1.2 1.3 5.8 4.5 10.2 7 14.1.7 1.2 0 2-1.7.8-1.2-.8-2.5-3.9-3-4-1.2-.2-3.8 5-9.1 3.5-1.4-.4-1.3-4.5-1.4-6.3 0-.9 1-1 1 0 0 1.7 0 5.2 2.1 5.4 1.8 0 5.6-2.4 6.4-4.4.8-2-1.9-5.9-2.7-8z"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M344.6 138.4c.4-1.2 6.1-10.8 6.9-12.9.4-1 2 1.8.4 3.3-1.4 1.2-5.5 8-6.3 10.4-.4 1-1.4.5-1-.8"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M354.3 129.3c1-4 3.6.6 1.3 2.8-3.4 3.4-4.5 9.9-10 10.9-1.4.3-4-.7-4.8-1.3-.3-.2.2-1.6 1.1-.9 1.3 1 4.1 1.3 5.6.1a25.4 25.4 0 0 0 6.8-11.6m-57 12.7c-.3.3-1 .3-1.1.7-.3 1.4 0 2.2-.3 3.6s-1.3 1.4-1.2.3c0-1.4 1.3-3.5.4-3.6-.6-.1-1-.9-.4-1.3 1.1-.7 1.7-.6 2.4-.4.3.1.4.5.2.7"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "M296.5 140c-1.4 1.4-2.8 1.9-4.1 3.5-.6.6-.5 1.5-.9 2.4-.3.9-1.4 1-1.7.9-.5-.4-.4-2-1-1.2-.6.9-.9 2-1.7 2-.7 0-2-1.5-1.3-1.5 2.3-.3 2.2-2 3-2.2 1-.1 1 1.5 1.7 1.2.4-.2.7-2.1 1.2-2.6 1.5-1.6 2.7-2.4 4.3-3.6.7-.6 1.3.5.5 1.2zm5.3 5c-1.2.2-1 1.7-.6 1.8.5.3 1.4.4 1.7-1.3.2-.7.3 3.5 1.8 1.9 1-1 3.1.2 4-1 .7-.9 1-1.5.4-2.7-.2-.3-1-.2-1 .7 0 .8-.5 1.7-1.3 1.6-.4-.1.2-1.9-.2-2.4a.5.5 0 0 0-.7 0c-.3.4.3 2.2-.6 2.4-1.2.2-.6-1.2-1-1.4-1.7-.8-1.8.2-2.5.3zm9-3c.9-.2.6-.2 2-1.3.5-.4.6.8.5 1.3 0 .7-1 .2-1.3.9-.4.9-.2 3-.4 3.8 0 .4-.8.4-.8 0-.2-1 .1-2 0-3.3 0-.4-.5-1.1 0-1.3zm-5-2.5c-.2.9-.2 1.6-.2 2.3 0 .5 1 .2 1 .1 0-.8.2-2 0-2.3-.2-.1-.7-.3-.8-.1"
            }),
            /* @__PURE__ */ jsx20("path", {
              d: "m299.5 130.2-1.4 5.6-2-3.8v3.9l-4.4-5.2 1.5 5.6-4-3.4 2.2 3.8-7-4.5 4.4 5.2-5.6-2.8 4 3.4-9-3.4 8.7 4.3a29 29 0 0 1 12.6-2.6c4.9 0 9.3 1 12.5 2.6l8.8-4.3-9 3.4 4-3.4-5.5 2.8 4.3-5.2-7 4.5 2.2-3.8-4 3.3 1.5-5.5-4.3 5.2V132l-2 3.8z"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#fff",
      d: "m311.3 295-.3 2.6h-.4l-.1-1.8a9.3 9.3 0 0 0-.5-1.6 7.3 7.3 0 0 0-.5-1.3l-1-1.4.8-2.2a6.6 6.6 0 0 1 1.5 2.4 9.4 9.4 0 0 1 .5 3.2m7-4.2c0 .7-.2 1.2-.5 1.5-.2.3-.6.6-1.3.7l.4 1.5a6.7 6.7 0 0 1 0 2 22.5 22.5 0 0 1-.1 1.3h-.4a8.2 8.2 0 0 0-.1-1.3 5.5 5.5 0 0 0-.2-1l-.4-1a10.5 10.5 0 0 0-.7-1.4l-1-1.7.6-2 1 1c.3.2.6.3 1 .3.8 0 1.2-.4 1.2-1.3h.4v1.4m6.4 4.8-.5 2.1c-.4 0-.6-.3-.8-.7l-.4-1.3a12.4 12.4 0 0 1-.1-1.7 4 4 0 0 1-1 .2 2 2 0 0 1-1.3-.4 1.3 1.3 0 0 1-.5-1c0-.9.3-1.7.7-2.3.5-.7 1-1 1.5-1.1.5 0 .8.1 1 .4a2 2 0 0 1 .3.9v2c0 .9.1 1.5.3 1.9 0 .3.3.6.8 1m-2-3.5c0-.6-.3-.8-.8-.8a1 1 0 0 0-.6.1c-.2.1-.2.2-.2.3 0 .3.3.5 1 .5zm8.7 3-.3 2.6c-.5-.4-1-1-1.4-2a25.4 25.4 0 0 1-1.3-4.1 52.8 52.8 0 0 1-1.8 5.5 2.9 2.9 0 0 1-.8.7v-2.5c.6-.7.9-1.1 1-1.5a7.6 7.6 0 0 0 .8-1.7l.5-2.7h.4l.9 2.7c.2.6.5 1.2.9 1.6l1 1.4"
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#bf0000",
      d: "M350.8 319.4c.4.4.6.8.7 1.2l.4 1.6-.8.1a7.8 7.8 0 0 0-1-1.5 18.8 18.8 0 0 0-1.1-1.2 46 46 0 0 0-1.7-1.5 34.4 34.4 0 0 0-2-1.7c-.4-.2-.6-.4-.6-.5a1.9 1.9 0 0 1-.3-.8 11.2 11.2 0 0 1-.2-1.6l2.7 2.2a44.3 44.3 0 0 1 2.5 2.2zm-9.5-5.8-.2 2H338l.3-2zm8.4 8.9-7.6 2.3-1.3-2 6.5-2-.7-.8a2.8 2.8 0 0 0-.9-.6 1.4 1.4 0 0 1-.4 1 2 2 0 0 1-1 .6 3.4 3.4 0 0 1-1.8 0 2 2 0 0 1-1.3-.7 4 4 0 0 1-.7-2.2c0-1 .3-1.6.9-1.8.7-.2 1.8 0 3 .7a8.1 8.1 0 0 1 3 2.4zm-5.8-4a3.8 3.8 0 0 0-.8-.3 1.1 1.1 0 0 0-.6 0 .7.7 0 0 0-.5.3.5.5 0 0 0 0 .6l.5.2h.6l.4-.3zm-8-1.6-.5 2-3.2-.3.5-2zm7.5 7.7-1.7.4a5.3 5.3 0 0 1-1.7 0 3.6 3.6 0 0 1-1.5-.4c-.3.5-.8 1-1.5 1.2a7.4 7.4 0 0 1-1.6.6l-1.2.3-1-2 1.1-.3a9.1 9.1 0 0 0 1.3-.4l.9-.5-1-.5h-.7a.4.4 0 0 0-.2 0 .6.6 0 0 0-.2.3h-.5c-.5-.8-.6-1.5-.3-2s.9-.8 2-1a6.8 6.8 0 0 1 2.6-.2c.8.1 1.3.4 1.5.9.2.2.2.5.2.7l-.4 1.2h.5a2 2 0 0 0 .6 0l1.7-.3zm-8 1.8-1.6.3a3 3 0 0 1-2.2-.4 5.5 5.5 0 0 1-1.7-2.6l-.8-2.2a2 2 0 0 0-.8-1 4.6 4.6 0 0 0-.9-.5l.6-2.1c.6.3 1 .6 1.4 1l1 1.7.5 1.5 1.1 2.2c.3.3.7.4 1 .3l1.7-.2zm-7-7.5-1 1.9-3-.7 1-1.9zm1.8 8.4-7.5.7-.4-2 6.2-.7a2.3 2.3 0 0 0-.6-.8 8.3 8.3 0 0 0-1-.6l.5-2c.7.4 1.2.9 1.6 1.3.3.5.6 1.2.8 2.1zm-6 1a17 17 0 0 1-2.2-.2 10.5 10.5 0 0 1-1.7-.5 5.6 5.6 0 0 1-1.3.4 9.9 9.9 0 0 1-1.7 0h-2a2.5 2.5 0 0 1-1.2-.3c-.3-.2-.5-.5-.8-1a4.1 4.1 0 0 1-1.5 1l-1.7.1h-1.7l.2-2.1h1.7c.8 0 1.5 0 2.1-.4a2 2 0 0 0 1.3-1.8l.7.1a30.2 30.2 0 0 0-.1 1.3c0 .3 0 .5.3.7.3.2.6.3 1 .3h1.5c1 0 1.6 0 2-.2.6-.2.9-.5 1-1.1l.1-.4s.3 0 .5-.2l.5-.2v.4a8.9 8.9 0 0 1 0 .3l-.3 1.1a12.4 12.4 0 0 0 2 .5c.1-.2 0-.4-.1-.7l-.3-.6a.5.5 0 0 1 .1-.3l.3-.2 1-.9.5 1v1zm-11.3-8.7-2 1.3-1.3-.9-1.4 1-1.9-1 1.8-1.3 1.5.8 1.5-1 1.8 1m-3 8.2-7.3-1.2.8-2 6.2 1c0-.4 0-.7-.2-1a5.2 5.2 0 0 0-.5-.8l1.6-1.7c.4.6.6 1 .7 1.6 0 .5-.2 1.2-.5 2.1zm-6.1-1-1.6-.3c-.9-.2-1.4-.6-1.5-1.2-.2-.6.1-1.5.8-2.8l1.2-2c.3-.5.4-.9.3-1.2a2.2 2.2 0 0 0-.3-.7l2.2-1.6c.3.5.3 1 .3 1.4 0 .5-.3 1.1-.7 1.8l-.8 1.4a5.8 5.8 0 0 0-.9 2.2c0 .4.2.6.5.7l1.6.4zm-3.8-8-2.5 1.1-1.8-1.7 2.6-1zm-1 6.6a6.8 6.8 0 0 1-1.6 1.4 4.2 4.2 0 0 1-1.7.6l-2.4-.1a14.8 14.8 0 0 1-2.8-.7 7.7 7.7 0 0 1-3.4-2c-.6-.8-.6-1.5 0-2.2a7 7 0 0 1 2-1.6c.8-.5 2-1 3.8-1.6l.4.5-2.8 1.2c-.5.3-1 .6-1.3 1-.4.4-.3 1 .2 1.6a10.5 10.5 0 0 0 6.3 2.2c1.2 0 2-.3 2.3-.7.3-.3.4-.6.5-1l.2-1.6 2.5-1.5a8 8 0 0 1-.1 1.5 4.4 4.4 0 0 1-1 1.6z"
    })
  ]
});
var Af_default = SvgAf;

// src/country-flag-icons/generated/Ag.tsx
import { jsx as jsx21, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgAg = (props) => /* @__PURE__ */ jsxs14("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx21("defs", {
      children: /* @__PURE__ */ jsx21("clipPath", {
        id: "ag_svg__a",
        children: /* @__PURE__ */ jsx21("path", {
          fillOpacity: 0.7,
          d: "M-79.7 0H603v512H-79.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs14("g", {
      fillRule: "evenodd",
      clipPath: "url(#ag_svg__a)",
      transform: "translate(74.7) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx21("path", {
          fill: "#fff",
          d: "M-79.7 0H603v512H-79.7z"
        }),
        /* @__PURE__ */ jsx21("path", {
          fill: "#000001",
          d: "M-79.6 0H603v204.8H-79.7z"
        }),
        /* @__PURE__ */ jsx21("path", {
          fill: "#0072c6",
          d: "M21.3 203.2h480v112h-480z"
        }),
        /* @__PURE__ */ jsx21("path", {
          fill: "#ce1126",
          d: "M603 .1V512H261.6L603 0zM-79.7.1V512h341.3L-79.7 0z"
        }),
        /* @__PURE__ */ jsx21("path", {
          fill: "#fcd116",
          d: "M440.4 203.3 364 184l64.9-49-79.7 11.4 41-69.5-70.7 41L332.3 37l-47.9 63.8-19.3-74-21.7 76.3-47.8-65 13.7 83.2L138.5 78l41 69.5-77.4-12.5 63.8 47.8L86 203.3z"
        })
      ]
    })
  ]
});
var Ag_default = SvgAg;

// src/country-flag-icons/generated/Ai.tsx
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var SvgAi = (props) => /* @__PURE__ */ jsxs15("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx22("defs", {
      children: /* @__PURE__ */ jsx22("path", {
        id: "ai_svg__b",
        fill: "#f90",
        d: "M271 87c1.5 3.6 6.5 7.6 7.8 9.6-1.7 2-2 1.8-1.8 5.4 3-3.1 3-3.5 5-3 4.2 4.2.8 13.3-2.8 15.3-3.4 2.1-2.8 0-8 2.6 2.3 2 5.1-.3 7.4.3 1.2 1.5-.6 4.1.4 6.7 2-.2 1.8-4.3 2.2-5.8 1.5-5.4 10.4-9.1 10.8-14.1 1.9-.9 3.7-.3 6 1-1.1-4.6-4.9-4.6-5.9-6-2.4-3.7-4.5-7.8-9.6-9-3.8-.7-3.5.3-6-1.4-1.6-1.2-6.3-3.4-5.5-1.6"
      })
    }),
    /* @__PURE__ */ jsx22("clipPath", {
      id: "ai_svg__a",
      children: /* @__PURE__ */ jsx22("path", {
        d: "M0 0v120h373.3v120H320zm320 0H160v280H0v-40z"
      })
    }),
    /* @__PURE__ */ jsx22("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx22("path", {
      stroke: "#fff",
      strokeWidth: 50,
      d: "m0 0 320 240m0-240L0 240"
    }),
    /* @__PURE__ */ jsx22("path", {
      stroke: "#c8102e",
      strokeWidth: 30,
      d: "m0 0 320 240m0-240L0 240",
      clipPath: "url(#ai_svg__a)"
    }),
    /* @__PURE__ */ jsx22("path", {
      stroke: "#fff",
      strokeWidth: 75,
      d: "M160 0v280M0 120h373.3"
    }),
    /* @__PURE__ */ jsx22("path", {
      stroke: "#c8102e",
      strokeWidth: 50,
      d: "M160 0v280M0 120h373.3"
    }),
    /* @__PURE__ */ jsx22("path", {
      fill: "#012169",
      d: "M0 240h320V0h106.7v320H0z"
    }),
    /* @__PURE__ */ jsx22("path", {
      fill: "#fff",
      d: "M424 191.8c0 90.4 9.7 121.5 29.3 142.5a179.4 179.4 0 0 0 35 30 179.7 179.7 0 0 0 35-30c19.5-21 29.3-52.1 29.3-142.5-14.2 6.5-22.3 9.7-34 9.5a78.4 78.4 0 0 1-30.3-9.5 78.4 78.4 0 0 1-30.3 9.5c-11.7.2-19.8-3-34-9.5"
    }),
    /* @__PURE__ */ jsxs15("g", {
      transform: "matrix(1.96 0 0 2.002 -40.8 62.9)",
      children: [
        /* @__PURE__ */ jsx22("use", {
          xlinkHref: "#ai_svg__b"
        }),
        /* @__PURE__ */ jsx22("circle", {
          cx: 281.3,
          cy: 91.1,
          r: 0.8,
          fill: "#fff",
          fillRule: "evenodd"
        })
      ]
    }),
    /* @__PURE__ */ jsxs15("g", {
      transform: "matrix(-.916 -1.77 1.733 -.935 563.4 829)",
      children: [
        /* @__PURE__ */ jsx22("use", {
          xlinkHref: "#ai_svg__b"
        }),
        /* @__PURE__ */ jsx22("circle", {
          cx: 281.3,
          cy: 91.1,
          r: 0.8,
          fill: "#fff",
          fillRule: "evenodd"
        })
      ]
    }),
    /* @__PURE__ */ jsxs15("g", {
      transform: "matrix(-1.01 1.716 -1.68 -1.031 925.4 -103.2)",
      children: [
        /* @__PURE__ */ jsx22("use", {
          xlinkHref: "#ai_svg__b"
        }),
        /* @__PURE__ */ jsx22("circle", {
          cx: 281.3,
          cy: 91.1,
          r: 0.8,
          fill: "#fff",
          fillRule: "evenodd"
        })
      ]
    }),
    /* @__PURE__ */ jsx22("path", {
      fill: "#9cf",
      d: "M440 315.1a78 78 0 0 0 13.3 19.2 179.4 179.4 0 0 0 35 30 180 180 0 0 0 35-30 78 78 0 0 0 13.2-19.2z"
    }),
    /* @__PURE__ */ jsx22("path", {
      fill: "#fdc301",
      d: "M421.2 188.2c0 94.2 10.2 126.6 30.6 148.5a187 187 0 0 0 36.5 31.1 186.3 186.3 0 0 0 36.4-31.1c20.4-21.9 30.6-54.3 30.6-148.5-14.8 6.8-23.3 10.1-35.5 10-11-.3-22.6-5.7-31.5-10-9 4.3-20.6 9.7-31.5 10-12.3.1-20.7-3.2-35.6-10m4 5c14 6.5 22 9.6 33.5 9.4a76.4 76.4 0 0 0 29.6-9.4c8.4 4 19.3 9.2 29.6 9.4 11.5.2 19.4-3 33.4-9.4 0 89-9.6 119.6-28.8 140.2a176 176 0 0 1-34.2 29.4 175.6 175.6 0 0 1-34.3-29.4c-19.2-20.6-28.7-51.3-28.7-140.2z"
    })
  ]
});
var Ai_default = SvgAi;

// src/country-flag-icons/generated/Al.tsx
import { jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var SvgAl = (props) => /* @__PURE__ */ jsxs16("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx23("path", {
      fill: "red",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx23("path", {
      id: "al_svg__a",
      fill: "#000001",
      d: "M272 93.3c-4.6 0-12.3 1.5-12.2 5-13-2.1-14.3 3.2-13.5 8 1.2-1.9 2.7-3 3.9-3.1 1.7-.3 3.5.3 5.4 1.4a21.6 21.6 0 0 1 4.8 4.1c-4.6 1.1-8.2.4-11.8-.2a16.5 16.5 0 0 1-5.7-2.4c-1.5-1-2-2-4.3-4.3-2.7-2.8-5.6-2-4.7 2.3 2.1 4 5.6 5.8 10 6.6 2.1.3 5.3 1 8.9 1 3.6 0 7.6-.5 9.8 0-1.3.8-2.8 2.3-5.8 2.8-3 .6-7.5-1.8-10.3-2.4.3 2.3 3.3 4.5 9.1 5.7 9.6 2 17.5 3.6 22.8 6.5a37.3 37.3 0 0 1 10.9 9.2c4.7 5.5 5 9.8 5.2 10.8 1 8.8-2.1 13.8-7.9 15.4-2.8.7-8-.7-9.8-2.9-2-2.2-3.7-6-3.2-12 .5-2.2 3.1-8.3.9-9.5a273.7 273.7 0 0 0-32.3-15.1c-2.5-1-4.5 2.4-5.3 3.8a50.2 50.2 0 0 1-36-23.7c-4.2-7.6-11.3 0-10.1 7.3 1.9 8 8 13.8 15.4 18 7.5 4.1 17 8.2 26.5 8 5.2 1 5.1 7.6-1 8.9-12.1 0-21.8-.2-30.9-9-6.9-6.3-10.7 1.2-8.8 5.4 3.4 13.1 22.1 16.8 41 12.6 7.4-1.2 3 6.6 1 6.7-8 5.7-22.1 11.2-34.6 0-5.7-4.4-9.6-.8-7.4 5.5 5.5 16.5 26.7 13 41.2 5 3.7-2.1 7.1 2.7 2.6 6.4-18.1 12.6-27.1 12.8-35.3 8-10.2-4.1-11 7.2-5 11 6.7 4 23.8 1 36.4-7 5.4-4 5.6 2.3 2.2 4.8-14.9 12.9-20.8 16.3-36.3 14.2-7.7-.6-7.6 8.9-1.6 12.6 8.3 5.1 24.5-3.3 37-13.8 5.3-2.8 6.2 1.8 3.6 7.3a53.9 53.9 0 0 1-21.8 18c-7 2.7-13.6 2.3-18.3.7-5.8-2-6.5 4-3.3 9.4 1.9 3.3 9.8 4.3 18.4 1.3 8.6-3 17.8-10.2 24.1-18.5 5.5-4.9 4.9 1.6 2.3 6.2-12.6 20-24.2 27.4-39.5 26.2-6.7-1.2-8.3 4-4 9 7.6 6.2 17 6 25.4-.2 7.3-7 21.4-22.4 28.8-30.6 5.2-4.1 6.9 0 5.3 8.4-1.4 4.8-4.8 10-14.3 13.6-6.5 3.7-1.6 8.8 3.2 9 2.7 0 8.1-3.2 12.3-7.8 5.4-6.2 5.8-10.3 8.8-19.9 2.8-4.6 7.9-2.4 7.9 2.4-2.5 9.6-4.5 11.3-9.5 15.2-4.7 4.5 3.3 6 6 4.1 7.8-5.2 10.6-12 13.2-18.2 2-4.4 7.4-2.3 4.8 5-6 17.4-16 24.2-33.3 27.8-1.7.3-2.8 1.3-2.2 3.3l7 7c-10.7 3.2-19.4 5-30.2 8l-14.8-9.8c-1.3-3.2-2-8.2-9.8-4.7-5.2-2.4-7.7-1.5-10.6 1 4.2 0 6 1.2 7.7 3.1 2.2 5.7 7.2 6.3 12.3 4.7 3.3 2.7 5 4.9 8.4 7.7l-16.7-.5c-6-6.3-10.6-6-14.8-1-3.3.5-4.6.5-6.8 4.4 3.4-1.4 5.6-1.8 7.1-.3 6.3 3.7 10.4 2.9 13.5 0l17.5 1.1c-2.2 2-5.2 3-7.5 4.8-9-2.6-13.8 1-15.4 8.3a17 17 0 0 0-1.2 9.3c.8-3 2.3-5.5 4.9-7 8 2 11-1.3 11.5-6.1 4-3.2 9.8-3.9 13.7-7.1 4.6 1.4 6.8 2.3 11.4 3.8 1.6 5 5.3 6.9 11.3 5.6 7 .2 5.8 3.2 6.4 5.5 2-3.3 1.9-6.6-2.5-9.6-1.6-4.3-5.2-6.3-9.8-3.8-4.4-1.2-5.5-3-9.9-4.3 11-3.5 18.8-4.3 29.8-7.8l7.7 6.8c1.5.9 2.9 1.1 3.8 0 6.9-10 10-18.7 16.3-25.3 2.5-2.8 5.6-6.4 9-7.3 1.7-.5 3.8-.2 5.2 1.3 1.3 1.4 2.4 4.1 2 8.2-.7 5.7-2.1 7.6-3.7 11-1.7 3.5-3.6 5.6-5.7 8.3-4 5.3-9.4 8.4-12.6 10.5-6.4 4.1-9 2.3-14 2-6.4.7-8 3.8-2.8 8.1 4.8 2.6 9.2 2.9 12.8 2.2 3-.6 6.6-4.5 9.2-6.6 2.8-3.3 7.6.6 4.3 4.5-5.9 7-11.7 11.6-19 11.5-7.7 1-6.2 5.3-1.2 7.4 9.2 3.7 17.4-3.3 21.6-8 3.2-3.5 5.5-3.6 5 1.9-3.3 9.9-7.6 13.7-14.8 14.2-5.8-.6-5.9 4-1.6 7 9.6 6.6 16.6-4.8 19.9-11.6 2.3-6.2 5.9-3.3 6.3 1.8 0 6.9-3 12.4-11.3 19.4 6.3 10.1 13.7 20.4 20 30.5l19.2-214L320 139c-2-1.8-8.8-9.8-10.5-11-.7-.6-1-1-.1-1.4.9-.4 3-.8 4.5-1-4-4.1-7.6-5.4-15.3-7.6 1.9-.8 3.7-.4 9.3-.6a30.2 30.2 0 0 0-13.5-10.2c4.2-3 5-3.2 9.2-6.7a86.3 86.3 0 0 1-19.5-3.8 37.4 37.4 0 0 0-12-3.4zm.8 8.4c3.8 0 6.1 1.3 6.1 2.9 0 1.6-2.3 2.9-6.1 2.9s-6.2-1.5-6.2-3c0-1.6 2.4-2.8 6.2-2.8"
    }),
    /* @__PURE__ */ jsx23("use", {
      xlinkHref: "#al_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    })
  ]
});
var Al_default = SvgAl;

// src/country-flag-icons/generated/Am.tsx
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
var SvgAm = (props) => /* @__PURE__ */ jsxs17("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx24("path", {
      fill: "#d90012",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx24("path", {
      fill: "#0033a0",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx24("path", {
      fill: "#f2a800",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Am_default = SvgAm;

// src/country-flag-icons/generated/Ao.tsx
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
var SvgAo = (props) => /* @__PURE__ */ jsxs18("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs18("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx25("path", {
          fill: "red",
          d: "M0 0h640v243.6H0z"
        }),
        /* @__PURE__ */ jsx25("path", {
          fill: "#000001",
          d: "M0 236.4h640V480H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#ffec00",
      fillRule: "evenodd",
      d: "M228.7 148.2c165.2 43.3 59 255.6-71.3 167.2l-8.8 13.6c76.7 54.6 152.6 10.6 174-46.4 22.2-58.8-7.6-141.5-92.6-150z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#ffec00",
      fillRule: "evenodd",
      d: "m170 330.8 21.7 10.1-10.2 21.8-21.7-10.2zm149-99.5h24v24h-24zm-11.7-38.9 22.3-8.6 8.7 22.3-22.3 8.7zm-26-29.1 17.1-16.9 16.9 17-17 16.9zm-26.2-39.8 22.4 8.4-8.5 22.4-22.4-8.4zM316 270l22.3 8.9-9 22.2-22.2-8.9zm-69.9 70 22-9.3 9.5 22-22 9.4zm-39.5 2.8h24v24h-24zm41.3-116-20.3-15-20.3 14.6 8-23-20.3-15h24.5l8.5-22.6 7.8 22.7 24.7-.3-19.6 15.3z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#fe0",
      fillRule: "evenodd",
      d: "M336 346.4c-1.2.4-6.2 12.4-9.7 18.2l3.7 1c13.6 4.8 20.4 9.2 26.2 17.5a7.9 7.9 0 0 0 10.2.7s2.8-1 6.4-5c3-4.5 2.2-8-1.4-11.1-11-8-22.9-14-35.4-21.3"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#000001",
      fillRule: "evenodd",
      d: "M365.3 372.8a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.6 0zm-21.4-13.6a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0m10.9 7a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#fe0",
      fillRule: "evenodd",
      d: "M324.5 363.7c-42.6-24.3-87.3-50.5-130-74.8-18.7-11.7-19.6-33.4-7-49.9 1.2-2.3 2.8-1.8 3.4-.5 1.5 8 6 16.3 11.4 21.5A5288 5288 0 0 1 334 345.6c-3.4 5.8-6 12.3-9.5 18z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#ffec00",
      fillRule: "evenodd",
      d: "m297.2 305.5 17.8 16-16 17.8-17.8-16z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 3,
      d: "m331.5 348.8-125-75.5m109.6 58.1L274 304.1m18.2 42.7L249.3 322"
    })
  ]
});
var Ao_default = SvgAo;

// src/country-flag-icons/generated/Aq.tsx
import { jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
var SvgAq = (props) => /* @__PURE__ */ jsxs19("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx26("path", {
      fill: "#3a7dce",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx26("path", {
      fill: "#fff",
      d: "M157.7 230.8c-3.5-7.8-3.5-7.8-3.5-15.6-1.8 0-2 .3-3 0-1.1-.3-1.5 7.2-4.8 5.8-.5-.8 2.4-6.2-.7-8.5-1-.7.2-5.2-.2-7.2 0 0-4 2.4-7-5.8-1.5-2.2-3.5 2-3.5 2s.9 2.4-.7 3c-2.2-1.8-3.9-.8-6.7-3.4-2.8-2.5.6-5.4-4.8-7.5 3.5-9.8 3.5-7.9 12.2-11.8-5.2-4-5.2-4-8.7-9.8-5.2-2-7-4-12.2-7.8-7-9.9-10.5-29.5-10.5-43.2 4.4-4.6 10.5 15.7 19.2 21.6l12.2 5.9c7 3.9 8.7 7.8 14 11.7l15.6 6c7 5.8 10.5 13.6 15.7 15.6 5.7 0 6.8-3.7 8.6-3.9 10.3-.6 15.5-2 17.5-5.5 2.1-2.8 7 1.6 21-4.3l-1.7-7.9s3.7-3.4 8.7-2c-.1-3.5-.5-13 4.5-17.4-3-3.5 1.8-9 2-10.7-1.4-8.6 1.4-8.7 2-11.3.6-2.5-2.4-1.7-1.6-5.2.9-3.5 6-4.3 6.6-7.2.7-2.9-1.1-14.3-1.3-16.8 9.4-2.8 12.4-11.4 15.7-7.8C264 70 265.8 66 276.3 66c1.4-3.6-3.9-6.7-1.8-7.9 3.5-.5 6.1-.2 10.2 5.7 1.3 2 1.6-2.7 2.9-3.2 1.3-.5 4.4-.5 4.9-2.8.5-2.4 1.2-5.6 3-9.5 1.4-3.2 2.5 1.3 3.8 7.5 7.4.3 24 2.1 31 4.3 5.2 1.5 8.7-1.5 13.7-2.2 3.7 4.2 7.2 1 9.2 10 2.7 4.8 7.3.4 8.3 1.8 5.8 18.1 25.8 5.9 27.4 6.2 2.5 0 5.6 8 7.7 7.9 3.2-.6 2.3-3.1 5.2-2.1-.8 6.8 5.6 14.6 5.6 19.7 0 0 1.5.9 3-.6 1.4-1.6 2.7-5.4 4-5.3 3 .5 22 6 25.8 7.9 1.7 3.5 3.3 5.3 6.8 4.7 2.8 2.1.8 5 2.4 5.1 3.5-2 4.7-4 8.2-2.1 3.5 2 7 5.9 8.7 9.8 0 2-1.8 9.8 0 21.6.9 3.9 9.7 32.3 9.7 35.2 0 4-2.7 6-4.5 9.9 7 5.9 0 15.7-3.5 21.6 26.2 5.9 14 17.6 34.9 11.7-5.2 13.8-3.4 12.7 1.8 26.4-10.4 7.8-.2 10.2-7.1 20-.5.7 4.1 8.6 10.5 8.6-1.7 15.6-7 9.8-5.2 33.3-13.7-.3-8.2 17.6-17.4 15.7.5 11.2 5.2 12.2 3.4 23.5-7 2-7 2-10.4 7.9l-5.2-2c-1.8 9.8-5.3 11.8 0 21.6 0 0-6.8.2-8.8 0-.1 3.4 3 4.3 3.5 7.8-.2 1.4-9.9 7.6-17.4 7.9-2 4.8 5.2 10 4.8 12.4-8.2 1.8-11.8 13-11.8 13s4.2 2 3.5 4c-2.2-1.8-3.5-2-7-2-1.7.5-6 0-10 7.7-4.5 1.6-6.6 1-10 6-1.5-4.7-3.7.1-6.3 2-2.7 1.8-6.2 6.5-6.7 6.3.1-1.4 1.6-6.3 1.6-6.3L399 437c-.7.1-.5-5.7-2.2-5.5-1.7.2-6.4 7.3-8 7.5-1.6.2-2.1-2.2-3.5-2-1.4.2-4 7.5-5 7.7-1 .1-5-4.5-8.3-3.8-17.1 6.8-19.9-13.4-22.5-2-3.6-2.2-3-1-6.7.1-2.3.7-2.5-3.4-4.6-3.4-4.1.2-4 4.6-6.2 3.3-1.8-9.2-13-7.6-14-11.5-1-4 4.8-4 6.6-6.8 1.4-4-1.5-5.6 4.3-9.4 7.5-5.7 6.8-19.8 4.9-25.3 0 0-5.9-17.7-7-17.7-3.5-1-3.5 6.5-8.6 8.6-10.5 4-29-9.9-32.2-9.9-2.9 0-16.5 3.6-16-4-2 7.4-9.5 1.7-10 1.7-7 0-4.3 6.1-9 5.9-2.1-.8-23.6-2.3-23.6-2.3v4l-26.1-11.8c-10.5-4-5.3-13.7-22.7-7.8v-11.8h-8.7c3.5-23.6 0-11.8-1.8-33.4l-7 2c-7-10.6 9.8-8.6-5.2-15.7 0 0 .3-11.7-3.5-7.8-.7.5 1.8 5.8 1.8 5.8-14-2-17.4-5.8-17.4-21.5 0 0 11.4 1.8 10.4 0-1.6-3-3.7-22-3.4-23.4-.1-2.6 10.7-9 8.6-15.2 1.4-.6 5.3-.7 5.3-.7"
    }),
    /* @__PURE__ */ jsx26("path", {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: 2.5,
      d: "M595.5 297.6c-.6 1.3-.5 2.6.1 3.6 1.1-1.7.2-2.4 0-3.6zm-476-149.4s-3-.4-2.4 2.3c1-2 2.3-2.2 2.4-2.3zm-.3-6.4c-1.7 0-3.8-.2-3 2.5 1-2.1 3-2.4 3-2.5zm12.7 36.3s2.6-.2 2 2.5c-1-2-2-2.4-2-2.5z",
      transform: "scale(.86021 .96774)"
    })
  ]
});
var Aq_default = SvgAq;

// src/country-flag-icons/generated/Ar.tsx
import { jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgAr = (props) => /* @__PURE__ */ jsxs20("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx27("path", {
      fill: "#74acdf",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx27("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsxs20("g", {
      id: "ar_svg__c",
      transform: "translate(-64) scale(.96)",
      children: [
        /* @__PURE__ */ jsx27("path", {
          id: "ar_svg__a",
          fill: "#f6b40e",
          stroke: "#85340a",
          strokeWidth: 1.1,
          d: "m396.8 251.3 28.5 62s.5 1.2 1.3.9c.8-.4.3-1.6.3-1.6l-23.7-64m-.7 24.2c-.4 9.4 5.4 14.6 4.7 23-.8 8.5 3.8 13.2 5 16.5 1 3.3-1.2 5.2-.3 5.7 1 .5 3-2.1 2.4-6.8-.7-4.6-4.2-6-3.4-16.3.8-10.3-4.2-12.7-3-22"
        }),
        /* @__PURE__ */ jsx27("use", {
          xlinkHref: "#ar_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(22.5 400 250)"
        }),
        /* @__PURE__ */ jsx27("use", {
          xlinkHref: "#ar_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(45 400 250)"
        }),
        /* @__PURE__ */ jsx27("use", {
          xlinkHref: "#ar_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(67.5 400 250)"
        }),
        /* @__PURE__ */ jsx27("path", {
          id: "ar_svg__b",
          fill: "#85340a",
          d: "M404.3 274.4c.5 9 5.6 13 4.6 21.3 2.2-6.5-3.1-11.6-2.8-21.2m-7.7-23.8 19.5 42.6-16.3-43.9"
        }),
        /* @__PURE__ */ jsx27("use", {
          xlinkHref: "#ar_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(22.5 400 250)"
        }),
        /* @__PURE__ */ jsx27("use", {
          xlinkHref: "#ar_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(45 400 250)"
        }),
        /* @__PURE__ */ jsx27("use", {
          xlinkHref: "#ar_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(67.5 400 250)"
        })
      ]
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__c",
      width: "100%",
      height: "100%",
      transform: "rotate(90 320 240)"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__c",
      width: "100%",
      height: "100%",
      transform: "rotate(180 320 240)"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__c",
      width: "100%",
      height: "100%",
      transform: "rotate(-90 320 240)"
    }),
    /* @__PURE__ */ jsx27("circle", {
      cx: 320,
      cy: 240,
      r: 26.7,
      fill: "#f6b40e",
      stroke: "#85340a",
      strokeWidth: 1.4
    }),
    /* @__PURE__ */ jsx27("path", {
      id: "ar_svg__h",
      fill: "#843511",
      strokeWidth: 1,
      d: "M329 234.3c-1.7 0-3.5.8-4.5 2.4 2 1.9 6.6 2 9.7-.2a7 7 0 0 0-5.1-2.2zm0 .4c1.8 0 3.5.8 3.7 1.6-2 2.3-5.3 2-7.4.4 1-1.4 2.4-2 3.8-2z"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__d",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640.2 0)"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__e",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640.2 0)"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__f",
      width: "100%",
      height: "100%",
      transform: "translate(18.1)"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__g",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640.2 0)"
    }),
    /* @__PURE__ */ jsx27("path", {
      fill: "#85340a",
      d: "M316 243.7a1.8 1.8 0 1 0 1.8 2.9 4 4 0 0 0 2.2.6h.2c.6 0 1.6-.1 2.3-.6.3.5.9.7 1.5.7a1.8 1.8 0 0 0 .3-3.6c.5.2.8.6.8 1.2a1.2 1.2 0 0 1-2.4 0 3 3 0 0 1-2.6 1.7 3 3 0 0 1-2.5-1.7c0 .7-.6 1.2-1.3 1.2-.6 0-1.2-.6-1.2-1.2s.3-1 .8-1.2zm2 5.4c-2.1 0-3 2-4.8 3.1 1-.4 1.8-1.2 3.3-2 1.4-.8 2.6.2 3.5.2.8 0 2-1 3.5-.2 1.4.8 2.3 1.6 3.3 2-1.9-1.2-2.7-3-4.8-3-.4 0-1.2.2-2 .6z"
    }),
    /* @__PURE__ */ jsx27("path", {
      fill: "#85340a",
      d: "M317.2 251.6c-.8 0-1.8.2-3.4.6 3.7-.8 4.5.5 6.2.5 1.6 0 2.5-1.3 6.1-.5-4-1.2-4.9-.4-6.1-.4-.8 0-1.4-.3-2.8-.2"
    }),
    /* @__PURE__ */ jsx27("path", {
      fill: "#85340a",
      d: "M314 252.2h-.8c4.3.5 2.3 3 6.8 3s2.5-2.5 6.8-3c-4.5-.4-3.1 2.3-6.8 2.3-3.5 0-2.4-2.3-6-2.3"
    }),
    /* @__PURE__ */ jsx27("path", {
      fill: "#85340a",
      d: "M323.7 258.9a3.7 3.7 0 0 0-7.4 0 3.8 3.8 0 0 1 7.4 0"
    }),
    /* @__PURE__ */ jsx27("path", {
      id: "ar_svg__e",
      fill: "#85340a",
      strokeWidth: 1,
      d: "M303.4 234.3c4.7-4.1 10.7-4.8 14-1.7a8 8 0 0 1 1.5 3.4c.4 2.4-.3 4.9-2.1 7.5l.8.4c1.6-3.1 2.2-6.3 1.6-9.4l-.6-2.3c-4.5-3.7-10.7-4-15.2 2z"
    }),
    /* @__PURE__ */ jsx27("path", {
      id: "ar_svg__d",
      fill: "#85340a",
      strokeWidth: 1,
      d: "M310.8 233c2.7 0 3.3.6 4.5 1.7 1.2 1 1.9.8 2 1 .3.2 0 .8-.3.6-.5-.2-1.3-.6-2.5-1.6s-2.5-1-3.7-1c-3.7 0-5.7 3-6.1 2.8-.5-.2 2-3.5 6.1-3.5"
    }),
    /* @__PURE__ */ jsx27("use", {
      xlinkHref: "#ar_svg__h",
      width: "100%",
      height: "100%",
      transform: "translate(-18.4)"
    }),
    /* @__PURE__ */ jsx27("circle", {
      id: "ar_svg__f",
      cx: 310.9,
      cy: 236.3,
      r: 1.8,
      fill: "#85340a",
      strokeWidth: 1
    }),
    /* @__PURE__ */ jsx27("path", {
      id: "ar_svg__g",
      fill: "#85340a",
      strokeWidth: 1,
      d: "M305.9 237.5c3.5 2.7 7 2.5 9 1.3 2-1.3 2-1.7 1.6-1.7-.4 0-.8.4-2.4 1.3-1.7.8-4.1.8-8.2-.9"
    })
  ]
});
var Ar_default = SvgAr;

// src/country-flag-icons/generated/As.tsx
import { jsx as jsx28, jsxs as jsxs21 } from "react/jsx-runtime";
var SvgAs = (props) => /* @__PURE__ */ jsxs21("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx28("path", {
      fill: "#006",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#bd1021",
      d: "m-.6 240 640-240v480Z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#fff",
      d: "m59.7 240 580-214.3v428.6"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M474 270.4c5.1.3 5 5.4 5 5.4l18 .4c2.3-6.3 4.8-5.6 9.2-2.4a32.9 32.9 0 0 0 8.7 4.2c1.7-9 14.5-7.2 14.5-7.2 5.6-13 6-12.9 2.7-14.5a10.7 10.7 0 0 1-4.6-4.5c-3-3.7-4.6-9.1-5-12.4-.4-3.3-4.2 1.6-5 .6-.6-1-6.3-.4-6.3-.4 1.4 1.5-3.4.6-3.4.6.5.4 0 1.7 0 1.7-.4-.6-4.1-1.2-4.1-1.2a6.1 6.1 0 0 1-1.1 1.6c-2-.8-6-.7-6-.7a20 20 0 0 0-10.9 2.8c-1.6.9-7.4 3.8-12.3 8.5-4.7 4.6-7.4 4-7.4 4-1.4 5.2-12.8 11.5-12.8 11.5-1.8 1.6-7.6 2.4-10.5 0-2.9-2.4 0-6.9 0-6.9 1.2-2 2.2-1.9 2.3-9 .1-4.7 5-8.5 10-14 6.3-6.8 15-18 15-18 0 3.4 1.8 4 1.8 4 1.7-3.5 4.2-6.3 4.2-6.3.1.3.5.4.5.4 2-2.6 3-3.6 3-3.6-.5-.3-6 0-11 4.4s-8.4 3-8.4 3c-3.5-1.2-3.8-4-3.8-4-2.5-10.9 7.4-18.7 7.4-18.7-13.4-3.2-3.7-20.3 13-27.5 16.6-7.2 16.4-10.5 16.4-10.5a13 13 0 0 1 1.8 3c.1 0 1.4-1.9 11-6.1 9.6-4.3 14.2-8 14.2-8 1.2 2.4 1 4 1 4 26.3-9.1 52-30.2 52-30.2.8 1.7.5 4.4.5 4.4 4.2-4 19.7-13.2 19.7-13.2a8.6 8.6 0 0 1-4.6 8.2 7.7 7.7 0 0 1 .8 2.3 360 360 0 0 0 14.4-9.5c4.3 3.7.4 9.8.4 9.8 1.6-.3 2.6-1.6 2.6-1.6 1.2 6.4-5.9 12-5.9 12 1.3 0 3.3-1.3 3.3-1.3-1.3 7-14.4 14.6-14.4 14.6 1.9 1.8 0 4-1.6 5-1.5 1-4.3 3.3-3.4 4.2.8 1 6.7-3.2 6.7-3.2 1 2.9-6.5 8.6-6.5 8.6 5.2.7 19.6-5.9 19.6-5.9-1.1 5.6-6.6 10-13.3 12.5-6.7 2.5-6.4 3-6.4 3 1.2.8 10.5-1.8 10.5-1.8-2.8 6.2-12.5 10.5-12.5 10.5 2.7 2.3 6.3-.4 10-2.9a58.2 58.2 0 0 1 14-6.4c5.3-1.9 9.2-.5 9.2-.5a12 12 0 0 1 8.4.6c8.7.7 9.6 3.9 9.6 3.9 1 .2 1.7.6 4 2.3 2.1 1.6 2 6.6 2 9.2-.2 2.4-.9 2.4-1.3 3-.4.8-.5 1.6-.5 2.5 0 1-2.2 6.9-15.7 6.9h-20.3c-1.2 0-2.5.7-2.5.7-5.7 2.8-2.7-2-9.4 3.6-6.8 5.5-10.2 4.6-10.2 4.6A90.1 90.1 0 0 1 568 221c-4 2.6-3.3 2.3.3 3.8s8.8 0 8.8 0c-3.4 2.3-1 3.4-1 3.4 4.4-2.7 7.2-1.7 7.2-1.7 1.4 3.9-3.8 10-3.8 10 2 .3 5.8 0 5.8 0-1 2.7-4.6 5.6-7.4 6.4-2.7 1-2.3 1.3-1.4 3 .7 1.6.1 3.3.1 3.3-4.8-3.3-5-.4-5-.4-.5 4-.4 9.6-.4 9.6-3.4-1.7-3.5.5-3.5.5-1 3.6-5.1 7.7-5.1 7.7-.2-2.2-2.2-2.8-2.2-2.8-2.2 4.2-6.1 6.7-6.1 6.7-.5 3.5.5 8.6.5 8.6-2.6-.6-3.5-.6-4 0-.3.7.6 1 .6 1l33.4.8c.5 0 2.5.3 2.5 3.8 0 3.7-3 3.9-3 3.9l-36.4-.9s.1 1-1.8 2-1.2-1.1-1.7 3.4c-.6 4.4-7.8-.4-7.8-.4-1.2 1.8-4 4-4 4-1.7-5-3.4-6.4-6-2.2-2.6 4.3 4.8 3.6 4.8 3.6s42.8-6.3 45.1-6.5c2.3-.3 4.9-.1 6 3.1 1 3.3-5.3 3.8-5.3 3.8l-44 4.8c-.9 2.6-4.5 2.4-4.5 2.4.3 2.5-2.3 4-3.6 5-1.4.8-5.6.5-5.6.5-5 3.4-7.6.7-7.6.7-3.3 1.4-5.4.8-8.1-.4-2.8-1.2-2.5-4.5-2.5-4.5l-27.8 3a6.7 6.7 0 0 0-2.2 1.2c1 1.3-2 4.3-2 4.3.9.5 2.5 2.1 2.7 5.5.2 3.7-4.5 4.3-2.2 7 2.3 2.5 6.7.3 11.5-2s9.5-2 11.5-2 7.8 1.6 11.4 2.8c3.6 1.2 4.8.4 5-1.4.2-1.7 1.9-2.3 1.9-2.3-.5 1.8.5 2.6.5 2.6a11 11 0 0 0 3.7-1.3c-.2 1.4-2 2.2-2 2.2-3.4 2.3 1.4 1.5 1.4 1.5a44 44 0 0 1 15.4-1.5 122.5 122.5 0 0 1 14.3 5.2c.4-1.2.1-4 .1-4 3 .8 4.2 2.5 4.2 2.5 1.2-1.2.4-3.4.4-3.4 9.7 5.5-2 8-5.1 9-3 1-3 2.3-3 2.3a28 28 0 0 1 6.4-1.3c2.2-.2 1.4 0 6.5-1 5.2-1 7.8 1.2 7.8 1.2-4.3.2-5.5 1.5-5.5 1.5 2.6 1.7 0 3.4 0 3.4-3.8-5-7.2.1-7.2.1a15.3 15.3 0 0 1 6.4 1.4l5.4 2.7c3.6 1.6 2.9.6 5.6 1.6 2.8 1 1.7 3.7 1.7 3.7a6.8 6.8 0 0 0-3.7-3c-.2 3-3.1 3.5-3.1 3.5 3.6-4-4.1-5.8-7.8-5.7-3.6 0-6.3 2.4-6.3 2.4 7.3 6.9 12.3 4.6 12.3 4.6-.9 2.5-6.9 1.5-6.9 1.5 2.8 2.2 2.5 3.6 2.5 3.6-1.5-1.4-4-.7-9.2-4-5.2-3.5-9.9-2.3-9.9-2.3 5.2 5.3-1.8 8.6-1.8 8.6-2.6 1.6 1 3.5 1 3.5-3.2.6-3.6-2.6-3.6-2.6-1.7-.4-4.2 1.6-4.2 1.6.2-3.2 4.6-1.6 4.6-5 .2-3.5-4-6.2-16.3-4.5-12.4 1.7-16-2.2-16-2.2-1 0-1.2 1-1.2 1 2 2 2.9 2.8 2.6 4.2-.4 1.3.6 1.8.6 1.8-2.3-.2-2.4-2.8-2.4-2.8 0 1.1-.5 1.2-1.3 2.3s0 2.7 0 2.7c-1-.8-2.7-1.8-1-4.3 1.2-1.8-2.7-4.2-2.7-4.2-1.5-1.5-5.6 0-5.6 0a14.9 14.9 0 0 1-13.3-3.7c-1 0-2.9-.6-2.9-.6-8.9 4-16.7-4.6-16.7-4.6-6.7 1.3-9.8-2-11.8-5.2a11.5 11.5 0 0 0-5.2-5c-2.6-1.6-5.2-6.2-2.6-8.7 2-2.1 1.5-2.6 1.5-2.6-3.5-5.9 6.1-7.7 6.3-9.2.3-2 2.3-3.3 4.5-3.4 2.2-.2 2.2 0 3.7-1.4 1.3-1.5 4 .3 4 .3.7-.4 5.5-4.1 9.7-2.2 4.3 1.9 7.9.6 7.9.6 3-.7 28-4 28-4 1.5-2.5 2.7-5.4 9.6-7s12-6 12-6c-1.2-1.2-3.2-1.2-4.2-1.3-1.1 0-3.2-2-3.2-2-1.3.6-2 .3-11 5.8-8.1 5-8.3-4.8-8.3-4.8H479c-.3 3.7-3 5.2-3 5.2l-6.5.3c-3.6-1.8-3.6-8.2-3.6-8.2-19.4.3-30.1 7.2-30.1 7.2-22-11.2-39.2-13.8-39.2-13.8a122.4 122.4 0 0 0 40.8-10.2 63.3 63.3 0 0 0 28.5 9c.5-5.4 4.1-6.7 4.1-6.7z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M442.3 314.6c-5.5 3.2-4.5 5-4 6s.5 2-1 3.6c-1.5 1.5-1.4 2-1.4 2 .3 5.4 4 6.6 5.7 8 1.4 1 3.6 4.5 3.6 4.5 2.9 4.1 5.9 4.2 8.1 4.2 2.3 0 2-.3 1-1.3l-3.4-2.7a17.6 17.6 0 0 1 5.9 4.1c5.6 6.2 10.8 5.4 13.1 5.2 2.3-.3 2-1.7 2-1.7a9 9 0 0 0-2.4-.4c-8.5-.8-11-6.4-11-6.4a24.1 24.1 0 0 0 15.6 6c2.4-.1 2.3.6 1.7.8l-2.4-.2c-1.1 0-1.1.3-.9.8.3.4 1.4.4 2.7.4 1.4 0 .3.1 3.8 2.8 3.6 2.8 12.3.5 12.3.5-5.7-1.3-6.4-4-6.4-4-7.7 1-10.8-3.6-10.8-3.6a32.5 32.5 0 0 0-5.6-3.5 8.9 8.9 0 0 1-5-5.8c1.3 1.8 3.7 3.8 6.7 4.6 3 .8 3.8 1.2 3.8 1.2a3.8 3.8 0 0 1-2.3-.2c-3-1-1.3.3-1.3.3 3.4 2.7 4.3 2.5 4.3 2.5 8.6.9 4.3-2.6 4.3-2.6 6.2 1.5 7.2-.8 7.2-.8 1.3 2.7 6 1.7 6 1.7-6.2 3-1.5 2.1-1.5 2.1 6.3-1.1 7.6.5 7.6.5 1.6 1.5 3.4 1.4 3.4 1.4s1.2 0 3.5.4c2.4.5 6.2 2.5 9.6 2.2 3.5-.5 4 .6 4 .6-.6-.3-2.2-.5-4.8.7-2.7 1.3-7.4 1.6-14.2 0s-7.4-1.3-7.4-1.3a8.7 8.7 0 0 1 3.4 4c.3 1.2 1.5 1.2 1.5 1.2.5-1.5 2.5-2.1 2.5-2.1a27 27 0 0 0 5 2.8c.4-.7 0-1.3 0-1.3 2.6 2.5 5.6 1.7 5.6 1.7.8-.5.6-2 .6-2 1 0 1.2.6 2 1.2.7.4 3 .1 3 .1-.8-.4-1.5-1.7-1.5-1.7 3.5-2.3 11-1.3 11-1.3 5.3 1 4.7 4.5 4.7 4.5a10 10 0 0 1 2.5 2.1c.5-1.2 0-2.5 0-2.5 2.6 1.2 3 4 3 4 3-3.2-2.7-6.8-2.7-6.8 2.7-.4 5.7-.2 7.5 0a13.8 13.8 0 0 1 6.6 3.1c2.1 1.7 5.9 2.5 5.9 2.5-.1-.7-2.2-2-2.7-2.2-.4-.2-.6-.9-.6-.9 1.9.4 3.1.2 3.1.2-6.4-4-8.1-5.9-8.1-5.9 2.4.3 3.8-1.2 3.8-1.2-5.1 0-5.4-1.2-5.4-1.2.7.1 3.1.7 6.2.1s7.2 0 7.2 0c-2.2-3.6-10.7-3-13.5-2.8-2.8.2-3.8-.2-3.8-.2.4-.2.9-.6 3-.7 2.2 0 4.3.2 6.8-1.6 2.3-1.6 5.7-1 5.7-1-.8-1.6-4.7-2.2-8 0-3.5 2.1-6.5 1.5-6.5 1.5 5.3-.8 6.9-2.7 6.9-2.7-1.6-.4-2.5.1-5.8.8-3.2.6-4-.5-4-.5 3.5-2.1 6-3 6-3-3-.6-5.8-2-5.8-2-3.2 3-5.6 4.6-11.7 1.6-6-3.2-9.2-2.8-9.2-2.8a14.2 14.2 0 0 1 14.8.6c4 2.3 5 .4 5 .4-1.2-.7-1-1.5-1-1.5 9.6 4.9 13.8 2 15.9.5 2.1-1.5-1-3.4-1-3.4-.2 3-4 4.6-7.2 3.5-3-1-6-2.4-10.4-4.3-4.4-1.8-10-.8-15.1.2-5.2 1.1-5.9.6-6.4.2-.5-.4-.7-1.7-3.4-.6-2.6 1.1-8.8-1.8-12.6-2.7-3.8-1-10.1-.5-15.5 2.5-5.4 3.1-8.2 2.3-9.8 1.6-1.6-.8-2.7-2.8-.9-4.6s2-2.3 1.8-5c-.2-2.6-2.8-4.2-2.8-4.2 2.4-2.5 3-3 2.2-4-.8-1.2.4-1.2 1.8-1.8 1.4-.6.8-.7.5-1.5-.4-.8-1.2-.6-1.2-.6-3.1.1-4.9-.8-4.9-.8-5.2-2.4-10.1 2.3-10.1 2.3-3-2.3-3.7-.7-4.2-.2-.5.5-1.6 1-3 1-1.2.2-3.1.7-3.8 1.9 0 0-.6 1 .1 2 0 0 .8 1.2-.6 2.7-1.5 1.5-2 1.8-1.5 3.3.4 1.3.3 2.4-.3 3.3 0 0-.7-.7-.5-1.7.2-1 .2-1.6 0-2 0 0-1.5 1.4-1.8 2.4 0 0-.6-1.6 1.6-3.7 2-2 3-3.2 2.4-4-.4-.6-2 .4-2.3.6z"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M448.4 338s-2.7-2-2.4-4.9c.3-2.7.3-3 0-3.7 0 0-.5.3-.4 1.4 0 1-.2 2.1-.3 2.3 0 0-1.3-2.3-2-2.8 0 0 .6-2.4-.2-3.4-.7-1.1-1.5-1.2-2.4-.8-1.2.4-2.1 1.5 2 4.8 0 0 1.5 1.3 2.5 3.9 1 2.6 2.8 3 3.1 3.2zm13-7.8s-.1-1.5 1.3-4.3a6.1 6.1 0 0 0 .3-5.6c-.3-.8-.6-.5.9-1.7 1.7-1.5-.7-3.4 2.3-6 0 0 1.8-1.6 2.3-2.3 0 0-3 1.6-5.2 2.5-2 .8-9.6 4.6-8 7.1 1.8 2.5 1.6 2.7 1.3 3.8 0 0-4.6-2.5-3-6.4 0 0 .8-1.5 2.7-3.4 1.8-1.6.8.4 4.3-1.7 0 0 2.7-1.6 4.3-3.9 0 0-2 1.2-2.6 1.4 0 0-4 .8-5.8 2.5-1.6 1.7-5.1 4.7-4 8 0 0-4-.4-5-4.7 0 0-7.6 9.4 8.4 13.8 0 0 3 .8 5.6 1z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M531.6 299c6-1 40.4-6.2 43.6-6.5 3.4-.3 4.7-.8 5.9 2 1.3 3-4.8 3.1-4.8 3.1l-41.1 4.7c-2 .2-2.5-.6-2.5-.6l-1.5-2s-.5-.6.4-.8z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M447.3 317.7s-4.4 9.3 13 11.6c0 0 .1-1 .8-2.5.8-1.5 2.3-4.5.8-6.4-1.4-1.9 1.2-.9 1.5-3.4.5-2.5-.2-2.2 1-3.8 0 0-5.4 2-7.6 4.5-2 2.4 2.9 4.2 0 6.9 0 0-2.5-1-4-3.6 0 0-3.3 0-5.5-3.3"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M464.5 329.2s4.3 3.7 9.4 3.6c5.1-.3 7.4-1.6 8.7-3.6 0 0 1 1.5 1 2.6 0 0 4.4-3.7 12-.5s5.4 2.3 7.1 2.5c0 0-3.3-.5-10.7 2.9-7.7 3.5-27.7 2.3-27.6-7.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M457.3 312.6s1.9.3 3.8-1.9c0 0-2.6.5-3.8 2zM442.6 330s-3.6-2.8-1.3-3.4c0 0 1.7-.3 1.3 3.4"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M521.2 347.8s2-3.5 7.5-3.5 6.1 2.6 13.1 3c0 0-8.4 2.4-14.2.3-3-1.1-5.8-.2-6.4.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M466.3 331.7s8.4 5 15.7-.5c0 0 .6.6 1.2 2 0 0 5.6-5.4 15.5.4 0 0-1.2-.1-5.9 1.8-6.1 2.7-21.4 4.5-26.5-3.8z"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M498.3 336.7s8 1 14.7.6c4.1-.2 8.6-1 6.4.4-2.3 1.3-1.1 1.5 8.4.7 9.4-1-.1 1.7 6.4 2.6 0 0-15.9 8-35.9-4.3"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M519.2 331.7s4.6-1.7 9 .3c4.3 2 3.6 2.2 6.5 2.5 0 0-2 2.9-6.7.6-4.8-2.3-6-2.8-8.8-3.4m5.2 14.3s4.6-2.3 9.6 0c.6.4 2 1 3.3 1.2 0 0-3.8 1.3-7.8 0-1.7-.5-3-.9-5.1-1.2m-22.7-8.2s10.3 1 15.8-.1c0 0-6.4 3 9.7 1.7 0 0 3.5-.4 3 .1-.3.5-.6 1 1.2 1.5 0 0-12 5.4-29.7-3.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M450.7 329.2s.2.7 2.4 1.7a8.7 8.7 0 0 1 4 3.9 5.6 5.6 0 0 0 3.5 2.9s-8 1.7-11.6-2.6c0 0-2.7-3 1.6-6"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M513.7 347.6s-3.1-.2-7.5-1.7c-4.3-1.5-5.4-.2-7.9-2-2.4-1.9-7.3-.7-8.2-.6-1 .1-3.6 0-.3-2.1 0 0-2.6 0-3.6-1.4 0 0-1.2 1.2-5.6.8 0 0 2 3-6 2.1a10.3 10.3 0 0 0 11.1 3c0 .2-.5 2.5 3 3.5 3.8.9 4.5 1.6 6.4 2.3 0 0 .3-1.5-4.6-5 0 0 2.6-.2 6.4.7s12.2 3.1 16.8.4m2 3.7s.8 1.8 3.2 1.4a17 17 0 0 1 10.2.8s.7-3.2-7-3.4c0 0-4.8.2-6.4 1.2m-65.2-21s-3 2.5-.3 5c2.4 2.3 6.2 2.1 8 2 0 0-1-.6-2-2-1-1.5-1-2.5-3-3.4-2.1-.9-2.3-1.1-2.7-1.6m-3-12.6s-4.6 9.3 13 11.6c0 0 0-1 .7-2.5.6-1.5 2.1-4.5.8-6.4-1.6-1.9 1.1-.9 1.5-3.4.4-2.5-.3-2.2 1-3.8 0 0-5.5 2-7.7 4.5-2 2.4 2.9 4.2 0 6.9 0 0-2.5-1-4-3.6 0 0-3.3 0-5.5-3.3z"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M493.3 339.3s3.7-.6 13 2.9c9.4 3.4 13.3 2.6 14.6 2.5 0 0-5.2 2.8-13.4-.8-7.2-3.2-7.6-2-14.2-4.6"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M551.8 337.2s2 0 3.4.5c0 0 .7-.7 2.7-1 0 0-1.3-1.2-6.1.5m-6.4-5.2s2.1 0 2.8-1.2c0 0-1.1-1.3-2.8-2 0 0 .4 1.6 0 3.2m-71.7-23.8s-.5-1 1.8-1.4l31.3-4.5s1.5 0 1.7 1c.3 1.1-.1 1.9-7.2 2.7l-25.6 3.2s-1.9.3-2-1"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M502 306.9s0 4.1 4.2 4.7c4 .6 5.5-.2 6.5-2.3.3-.7 1.6-5-.2-5.3-.8-.1-2 0-2.9.3-1.4.7-2.7 1.4-2.3 2 1 1.6 1.2 2 1 2-1.2.3-1.8-.6-2-1.2-.3-.8.5-1.2-2.2-.8-1.2.1-2 .1-2 .6zm17.5-3.2c2 .3 1.9 4.8-.6 6.9-2.8 2.2-5.4 1.3-5.4 1.3-1.4-.5-1.2-.4-.1-2 1-1.5 1.5-3.6.9-5-.2-.5.3-.9 1-1 0 0 2-.4 4.2-.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M521.3 304.1s1.6 2-.4 5.5c0 0-.8 1 1.1.9 1.8-.2 6.1-2.2 5.7-4.8 0 0-.2-.6-1.3-.6s-.2-.5.3-.8c.4 0 1.9-.6-1.9-3 0 0-.6-.6-1.3-.3-.6.2-2.6 1-2.6 2.2 0 .5.4 1 .4 1z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M525.4 300.9s3 2.1 3 2.8c0 .6-.3 1.5.5 1.3.8 0 4-.7 3-2.8-.8-2.1-1.7-3-3.2-3.4-1.5-.6-1.9.1-3.2 1.1 0 0-.9.6-.1 1m-16.1 3s.5-1.5-2.2-2.2c0 0 1.1-1 3.4-.4 2.2.4 2 2 2 2.1 0 0-1.8 0-3.2.5m5.8-.4s3-.5 4.5-.4c0 0-1.6-3.3-5.7-2.3 0 0 1.5 1.8 1.2 2.7m5.3-.8s0-1.1 2.6-2.1c0 0-1.2-1.2-3-1-2 0-2.5.7-2.5.7s2.3.8 2.9 2.4m1-3.6s1.7.4 2.7 1.3c0 0 1.5-1.7 2.8-2 0 0-2.5-1.4-5.5.7"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M435.8 290.9s7.2-6.2 11.2-5.4c4 .8 2 .2 6.4-.5 4.4-.6 9-1.1 10.8-.9 0 0-5.4-3.8-14.9-3.7 0 0-6.6 2.3-11.3 5.3 0 0-8.9-4.9-18-2 0 0 9.9 3.7 15.8 7.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "m512.2 301.4 1.2-.2s2 2.5.6 2.5c-1.2 0-.8-.3-1-1a2.3 2.3 0 0 0-.8-1.3m-9 .2s-.8 1 .6.8c1.7-.3 1.4 0 3.1-1.3 0 0 1.2-1.1 3.2-.4 0 0 1.8.6 3.2-.1 1.4-.8 1.7-.7 2.5-.6.8 0 .8.2 1.7-.6 1-.7 2.8-.1 3.9-1 1.1-1 2.5-.2 0-2 0 0-.5-.5-.5-1 0 0 1 .4 1.8 1 .8.8 2 .5 2.2.4 0 0 .2-2.3 2.3-4.3 2.3-2 2.3-2.2 1-2.2s-3.5-.6-4.3 0-7.2 4.8-11 5.5c-3.8.7-7.3 1.8-9.7 5.8m-101.3-23.4s11.7 3 14.3 4.2c0 0 .6-1.9-4.7-3.4 0 0 12.9-.4 26.4 5.8 0 0 6.6-5.6 27.7-3.9 0 0 0-1.8.2-3.3 0 0-14.8-.4-28.4-8.7 0 0-12.3 6-35.5 9.3m64.7 5.6c-.7-11.8 3.8-13 3.8-13s2.1 0 4.4.5c0 0-3.6 4.3-2.6 12.8 0 0 .4 1.3-2.7 1.3s-2.9-1.5-2.9-1.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M469.8 291.7s-2.3-2.3-2.5-4.9c0 0 0-.6 2.2-.6 2.3 0 2.5-.2 3 1.1.6 1.3 2 4 2.3 4.3z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M474.5 285.7a28.3 28.3 0 0 1-.2-4.5c.1-6.6 1.2-6 1.7-5.2h2.3s-1.7-7.4-3.7-3a19 19 0 0 0-1.5 10.4c.1 2 .3 3.3.6 4z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M500.2 285.7s4.3.8-2.3 2.3c0 0 .3 8.2 8.2 2.5 0 0 4.7-3 8-4.2 0 0 1.6-.6 1.4-1.8 0 0 .2-1.5-1.5-1.1 0 0-1.4 0-2.3-.3 0 0-1-1.2-1.6-.8-.6.5-2.1.2-.9 1.7 1.2 1.4 1.5 1 2 .6.6-.4 3.1-1.4.9.7s-4.2-1.2-5-1.8zm-22 1h-2s-1 1.6-1.7-1l-.7 1.6s2.3 8.8 4.4-.6"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M475.4 276.6s-1 5.8.3 9.2l21.1.5s-.2-4 0-9.7H494s-.5 4.6 0 7.5h-.5s-.4-4 0-7.5H491s-.4 4.3 0 7.5h-.5s-.4-3.7 0-7.5H488s-.5 3.9 0 7.5h-.6s-.5-3.9 0-7.5h-2.7s-.6 3.6 0 7.5h-.5s-.6-3.6 0-7.5h-2.7s-.6 4.2 0 7.5h-.6s-.4-4 .1-7.5h-2.5s-.7 3.5 0 7.5h-.7s-.4-3 .2-7.5zm22.3 10.4s-.5-10.2 1.4-13c2-2.6 2.5-2 5.8 0 3.4 2.2 7.7 4.5 8.5 4.8.6.3 1.6.5 1.6 2.4s.3 2.4-2.6 0a9 9 0 0 0-2.7-1.8c-2.6-.9.6.5 1.5 1.9.8 1 1.5 1-.6 1.5a219 219 0 0 0-12.9 4.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M505 279.6s-1.5-1.8.5-2.3c2-.4 2.1 3 2.5 5.1.3 2.2-2.5-2.1-2.8-2.7zm-2.7 9s-2.3.9-.7 1.6c1.4.7 5.5-2.7 4.2-2.5-1.6.3-3.5 1-3.5 1zm3-3s2-.3 1.6.5c-.3 1-1 .4-1.4.2-.3-.2-1.6-.7-.1-.8z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M516 282.8s.6 4 4 5c0 0 2 .4 1.5-1.3 0 0-.3-1.5-.6-2-.3-.7-1.6-1-1.8-1.1-.2 0-.3-.5.6-.2 1 .3 1 .4 1-.3s-.6-.4-1.4-.8c-.4-.2 0-.4.3-.3.4 0 1.3.3 1.3-1 0 0 .1-.8-.9-.8-1.1 0-1-.6-.7-.7.3 0 1.5.8 1.9-.6.3-1.3-1.6-.5-1.4-1.2.3-.8 1.7.3 1.7-.5.2-.8 1.3-1.1-.6-1.4-.9-.1 0-.6 1-.4 1 .1 1.6-1.2 2.3-1.6.6-.5 4.2-2.6-.6-1.9-4.7.7-6.1 3-6.3 3.5a13 13 0 0 0-1.3 7.6"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M527 285.8c.7 0 1.2 0 1.4.5.8 1.6-1 1-2 2.2s-1 1-2.4.5c-1.4-.4-2-2.5-2-2.5 0-.7.5-.8 1.2-.6 0 0 2.3.2 3.9 0zm-5-.8s0 .4.9.5c.7 0 3 .3 4.5-.1 0 0 .4-.1.2-1 0 0 0-.7-1.2-.4-1.3.2-3 0-3.7-.1-.6-.2-1 0-.8 1zm-.2-2.9s-.1 1.3 1.1 1.4c1.3.2 2.9.2 3.5 0 .5 0 1.4-.2 1.5-1 0-.7.2-1.2-1.3-.8s-3.4 0-3.6 0c-.1 0-1.2-.3-1.2.4m.5-2.5s-.3.6-.2 1.2c0 .5.9.7 2.5.7s3-.2 3.2-.7c.1-.7.5-1.3-.7-1-1.3.1-3 .2-3.6 0-.6-.3-1.1-.4-1.2-.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M582.1 286s0 1 .9 2.2l-45.2-1.3s.6-.4.8-2.2z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M522.7 277.8s-.4 1.1.4 1.4c.7.2 2.2.4 4 .1 0 0 1 0 1.3-1 .3-1 .3-.4-2.3-.8 0 0-.8-.3 1.5-.3 0 0 1.4 0 1.5-.2.3-.2 2-1.7-.3-1.5-2.3 0-1.1-.5 0-.5 1.2 0 1.6.3 2 0s0-.2-.7-.8-.1-.5.3-.1c.5.3.8.5 1.3 0s-.4-1.2 0-1c.3 0 .6.8 2 0 1.6-.7 3.5-.3 4 0 .6.5 2.2 1 3.1 0 1-.8-1.1-1.7-.3-1.8 1-.1 1.6.2 1.9-.5.4-.8-1.4-1.4.3-1.8 1.6-.5.2-5-.3-5.5 0 0-1.9 1.1-3.8 4.3-2.1 3.3-3.3 5.2-6 4.2-3.9-1.5-6 .6-6.5 1-1 .6 2 .8.2.9-1.7 0-1.7.2-1.8.4-.2.3 0 .5.3.6.3 0 .9.6-.1.6s-1.8-.3-1.5.9c0 0 0 .2.6.3.6 0 .8.8-.3.8-.8 0-.8.2-.8.3m4.1 11.3s-.7.5.3.6c1.2 0 1.7.3 2.1-.3s1.8-.4.8-1.2c-1-.8-1.6-.3-3.2 1z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M531.5 275.5s3.8-3.5 6.9-1.2c3.2 2.5 3.4 2.8 3.5 2.9 0 0 .4.3-.4 1-.9.8 0 .8.9.3s1 0 1.4.5c.5.5 1.1.8-.3.8h-4.6s-2.1.2-1-.7c1-.9.8-1.9.3-2-.6 0 0 .6-.3 1-.4.4-1.1.7-1.9.7s-1.4.6-.2 1c1.1.4-.2.7-.8.7s-3.5.2-.5.6c3 .3-.3.3 2 1.5 2.4 1.4.6 4.3-.3 4.6 0 0-1 .5.2.4 1.3-.2 2-.3 1 .4-.8.6-2.6 2.9-5 1.2 0 0-1.2-.6.8-.7 2 0-1.6-.5-2.3-1-.5-.3-3-2.7-1.5-2.5 1.6.4 1-.5.1-.8-.8-.3-1-1.6 0-1.4 1 .3 2 .9 3 .8.7 0 .5-.3-1.2-.8-1.7-.6-2.4-.7-2-2 .4-1.5 2.3.5 1.8-.6-.4-1-2-.5-1.2-1.9s1-.8 1.5-.6c.3.1 1 0-.1-.8-.8-.5 0-1.3.2-1.4"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M534.2 276.5s0-.5.8-.4c.6 0 .4-.2.6-.4.2 0 1.9.5.3 1-.6.3-1.6.2-1.6-.2z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M537.9 280.5s-1.3.6-.2 2c1 1 1 1.5 1 2.2-.1.8 43.4 1.3 43.4 1.3s0-2.9 1.8-4.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M582.8 285.2s.2-2.4 1.6-3.1c.7-.5 1.6-.3 2 1.6.6 2.7-1.7 5.1-2.7 4-1-1-.8-2.5-.8-2.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#7b3c20",
      d: "M532.9 295.4s2.9-2.5 3.4-3.6c0 0 7.8 5.6 7.3.4l.2-2.6s2.9.3 3.3-2l-7.3-.3s-.8-.1-2 1.1c-1 1.2-3.4 2.5-5.5 1.4 0 0-1-.8-1.9 0-1 .5-1 .7-.2 1.5s2.4 2.9 2.7 4zm16.8-15.4-4.3-.2s-1.5-2.2-4.6-4.6c0 0-.9-.4.8-1.8 1.8-1.4 2.3-2.8 2.3-3.5 0-.6 0-1.7.6-1 .6.8 5 4.9 5.8 3.7.6-1.2.7-1.7.7-2.1.2-.4.3-1.5 1-.3.6 1.1 1 .8 1.1 3.8 0 0 0 3 .5 4 0 0-5.6-1.7-3.8 2zm-18.6-9.2s3.3 2 5-.6c1.5-2.5 2.6-2.8 1.4-5.3-1.2-2.3 0-3.4.9-4.4 1-1 1.8-.8 1.8-4.6.2-3.9 2.8-5 4-6.3 1.2-1.2 4.2-3-.4-3.7-4.4-.8-13.4-3-15.7-6.5-2.3-3.5-3.3-1.5-3.3-1.3 0 .2-.8 2.7 1.5 7.3s4.2 7.6 6.5 9c2.2 1.5 4.2 2.3 3 5.4s-3 8.6-4.7 11"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M543.2 261s.6 8 6.3 10.8c0 0 1.3-3 .8-6.1 0 0 1.9.1 2.4 1 0 0 0-2.3-2.6-3.2-2.7-.7-1.4-6-.4-6.5.9-.6.6-1.7 0-2.6-.7-1-.8-2.3 1.4-1.7 2.3.6 2-.6.5-1.7-1.3-1.1-1.3-2.5.7-2.5s5-1.9 3.2-2.4c-2-.6-2.5-1.3 0-2 2.7-.8 4-1.7 2-2-2-.2-3.3-.9-1.4-1.2 1.9-.3-.3-2.3-2.5-2.3-2.3-.2-7 .7-3.3-2.3 3.8-3-5.4-.8-1.6-2.8 3.8-2-1.3-1.1-2-1.1s-.7 0-.4-1c.2-1-.5-1.6-1.7-.9-1 .6-1 .6-1-.7 0-1.5-1.3-.4-2.1 0-.9.3-3 1.9-3.9 1-.7-.9-1.2-1.7-3.8-.2-2.6 1.5-2 .2-2-.5s1-3.4-2.4-.5-.7-3-3.5-1c-2.7 2-3 2.4-3.5 1.5-.5-1-1-1.7-4 .3-3.1 1.9-.8-1.3-.5-2 .5-.6 1.8-5-.9-1.6 0 0-1.3 2.4-4.2-1.9 0 0-3 4.3-3.9 2.4-.8-2-1.5-2-2.6-.8-1 1.2-.2-.1-.7-1.2-.4-1-.7-2.9-5.8.8-5.1 3.8 1.8 1-2.1 2.7s-13.5 7-4.8 5.9c8.7-1.3-4.2 3.3-1.2 4.2 3 .8 2 3.5 13.4.3 11.2-3 9.4-.4 15.2-3 5.8-2.4-1.4.9 6.4.8 7.7-.2 1.3 0 2.8 1.6 1.5 1.6 8 5.3 14.1 6 6.1.6 7.7-1.7 5.9 1-1.8 2.6-2.4 3.6-3.4 4.6-1 .8-4 3-4 6.6 0 3.7-4.8 4.3-3 8.3l4.1-4z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M553.3 269.9s-1.4-1-1.4-2.8c0 0 1 .2 1.4.8 0 0 3.5-4-.8-5.4-4.1-1.4-2-5.3-.6-5.3s1.7-.3.4-2c-1.2-1.5-1-1.6 1.3-2 2.3-.4 2.1-1 1-1.5a7.7 7.7 0 0 1-1.9-1.6s6.8-2.9 4.6-4.3c-2.2-1.3 0-1 2-2.3 2-1.4 2.2-1.7 2.5-2.3 0 0-2 .3-3.4 0 0 0 1.7-.9 0-2.3s-2.3-2.6-5-2c-2.7.7-1.8-.2-.8-1.3s.6-1.7-1.3-2c0 0 .2-1.2 1.7-2.5 0 0-3.7.2-5-.4 0 0 1.6-1 1.6-2.3 0 0-2 .7-4.5.5 0 0 1.5-1.3 1.5-2.4 0 0-4.4 1-6.4 2.5 0 0-.5 0-.8-.6-.4-.4-.6-1-5.5.6 0 0 .5-2.2 1.7-3 1.2-.8 1-2.6-6.5 2.1 0 0-1-.6-1.9-2.9 0 0-1.7 2.3-2.9 3.1 0 0-1 .5-1-1 .2-1.5-.7-.5-1.4 0-.8.4-1.3 1.5-1-1.5s-1-3.6-1-3.6-2.3 3.3-3.7 3.7c0 0-2.5-2.4-3.4-4-.8-1.6-.8-2.2-1.7.6-.9 2.7-2 3-2 3s-1.5-1.3-1.6-2c0 0-.3.7-.8 1 0 0-1.3-1.5-1.2-3.7 0 0-8.2 4.5-9.2 7.2 0 0-7.7-.5-10.8.1 0 0 .7-2.4 2.7-3.7 0 0-2-.2-2-2.3 0 0 1.6.2 2.6 0s-1.4-3.1 1.1-3.2c2.5-.1 4.2 1.2 3-2.2-1-3.3-.6-3.3-.6-3.3s4.4 2.6 5.1 1.9c.8-.6-.5-2 3.4-1.4 3.9.7 2.8-1.5 4.4-1.7 1.5 0 2.3 1 1.3-6.1s4.8 3.5.9-7.2c0 0-1-3.3-3.3-4.7 0 0-.6 2.3-3.2.3-2.6-2-7.8-2.8-5.6-4.4 2.2-1.7 3.2-3.9 2.6-5.2 0 0-2.6 2.6-7 .7-3.6-1.5-4.4 1.3-8 .5 0 0 0-1 3.1-3.4 3-2.3-1.8.8-3.6 1.3-1.9.4-2.4 0 1.5-3.1 4-3 12-8.5 11-13 0 0 1.8 2.3 6.7.6 5-1.7 8.6-2.3 10-5a23 23 0 0 1 6.4-5.6c1.1-.5 2.4-1 .9 1.5-1.6 2.4-4 6.6-10.8 9.4-6.8 2.8-9.5 4.8-10.7 6.3-1.2 1.5-7.4 4.8-3.3 4.3 4-.7 10.9 0 7.6-1-3.2-.9-6.9.6-3.9-2.1 3-2.7 3.5-3.6 7.9-5.4 4.4-1.9 9.2-6.1 8.7-1.6-.5 4.4-8.6 9.1-10.6 10.6-2 1.4-1.2 1.2-1.2 1.8 0 .6-.4 1.8-1.2 2.3-.8.6-.5 1.2-.3 2.4.2 1.3-.2 1.8.4 2 .6.1 1.2.2 1.4 1.1.2 1 .6 1 1.8 1 1.1-.2 2 0 2 .6 0 .7 1.2 1.7 1.3-.4.1-2.2 1-2.5-1.2-1.5-2.2.9-2.6.6-2.6-.4s-.2-.8-1-.9c-1 0-1.3-1.3.3-2.2 1.6-.8 1.6 0 3.6-1.6 2-1.7 2-2 2.3-3 .3-.7-2.9 2.4-4.4 3-1.5.8-1-.5-.8-2.1.3-1.7 4-4 5.7-4 1.8 0 5.6 1 4 3.3-1.7 2.3-6.4 5.2-4.5 5.4 2.1.2 2.4-.6 3.6.4 1.2 1 0 3.2-.4 4.4a8.4 8.4 0 0 1-2.2 2.7s-2.2-3.8-2.1-.8c0 3.1-.5 4.2 0 4.3.5.1 2.8 1.7 3.6 1.7s-4.1 2.3-2 2.5c2 .1 5.3-1 6.4-3 0 0-4.2-1-5.9-2.6 0 0 4.9-1.2 3.5-5.8 0 0 4.9 1.3 2.7 3.5-2 2.1-3.3 1.8-1.5 2.4 1.9.6 2.7 1.2 2.7 1.2s1.3.6.5 1.6c-.7 1-.7 2.6 0 2.5.5 0 2.6-1 .9-2-1.8-1 1.9-.8.4-1.7-1.6-1-2-1.1-2.4-1.6-.5-.3 19.7-12.2 9.5-7.8 0 0 2.1-4.6 5.1-4.6 3 0 3.2 2.3 1.5 4.2-1.7 1.7-2.8 4.6-6.7 5.2 0 0 5.6 2.7-1 7.2 0 0-1.5.7-1 1.2s4.5-1.7 5-3a5.5 5.5 0 0 1 3-3 38 38 0 0 0 11.2-9.6c2.3-3.9 2.8-4 7.2-7.5s3.6-2.8 4.2-3.6c.5-.9.7-2.3 2.7-3.4 2-1.2 9.8-5.4 12.3-7.2 2.4-1.8 7.4-5 9.6-7.8 2.1-2.7 8-6.2 9.4-5.6 1.4.7-.2 2.8-3.5 5.4-3.5 2.5-12 9.3-13.3 10.4a44.7 44.7 0 0 1-11.2 6.6c-2.7.3-2.4 1.3-4 3s-5.3 5.4-6.5 6.4c-1.3 1-4.3 3-4.4 4.5-.2 1.5.5 1.6-1.9 3.8a50 50 0 0 1-11.9 8.1s4.5 1.6 1.8 4.6c-2.6 3-2.5 2.6-2.6 2.8 0 0 6.7-1 2 4.3 0 0-1 1.5 1.1 0 2.3-1.9 1.4-4.1 1-4.5 0 0 3.7-2.3 7.9-2.3 4.1 0 4-.3.2-1.4 0 0 2.7-3.2 5-1.6 2.2 1.5 1.4 2.5-.9 3.8-2.4 1.2-5.8 1.7-8.5 3.2 0 0 5 1 7.6-1.1 2.6-2 2.8-1 3-.6.5.4.8 1-.4 2.6-1.2 1.7-1.3 1.8-1.2 2.2 0 .4-.1 1.5-2.5 2-2.3.3-3.5 1.3-2.6 2.4.7 1.2.7 4-1.2 3.7-2-.3-1.6-1.9-2.3-2.5-.8-.6-1.9-1.5-5.4.2-3.6 1.9-3.8-.3-3.7-1.5 0 0-2.3 2-4.2.2-2-1.9-.2-2.6 1-3.5 1-1 5.5-3 2.8-2.5-2.7.3-6.7.4-7.6-1.6-1-2.1 2-1.9 2.4-1.7.5.2 2.3 1.7 2.5-.3 0-2 3-2.3 2-2.6-1-.4-2.5.9-2.9 1.3 0 0-2-2.9-5.4-2-3.4 1 1 .7 2 .8.8.2.3 1.8-2.7 4.6-3 2.7-1.7 1.8.5 1.8 2.3 0 7.9 0 4.6 2.6-3.2 2.7-4.5 4-6 3.6-1.8-.5 0-1.6.8-2.1s1.2-1.2-.4-.6c-1.6.5-2.1.7-3.4-1.5-1.2-2.3-.8-1.6-.2-3.1.6-1.5 1.8-3 .4-2.5-1.6.6-1.4.7-1.3-1 .1-1.7-1.7-2.1-1.7-2.1s.8 1.7.1 2.8c-.6 1-.7 1.4.4 1.6 1 .4 2 1.3.6 2.3-1.4.9-1.2.7-.4 1.3 1 .7 2.3 1.3.9 2.7-1.4 1.4-.3 1 .4 1 .8 0 2.3.6 2.3 2 0 1.2 0 1.5 2.3.3 2.3-1.3 6.7-1.1 6.7.6 0 1.8-.6 2.3 1.8.8 2.4-1.5 3.5 1.4 5.2 0 1.6-1.5 2.6-2.8 4.6-.4 1.9 2.4 1.3 3-1 4.8-2.3 1.7 1.1.4 2.9-.5s6.7-1.5 9.5-.2c2.9 1.2 3.7 1 5.8 0 2.1-.8 3.2-1 6.3 1.1 3.3 2.2 5.7 2.6 7.4 2.5 0 0-3.5 1.4-7.5 1.6-4 .3-6 1-6.7 1.6 0 0 2.3 1.5 2.8 3.2 0 0 2.6-.3 3.8.2 0 0-.6 1.9 1 2.9s2.7 1.4 1.5 2.7c-1.2 1.4 1.9.8.1 2.7-1.7 2-2.1 3-2.2 4.5 0 1.6.4 1.8-1.1 2-1.6.1.2 1.9-.5 4-.7 2-5 1.7-4.8 7.2 0 0 1.2-2.7 3.8-5 2.5-2.4 2.6-2.6 2.5-4 0-1.4-.1-1.1 1.2-2.2 1.4-1-.6-2 .8-3.6 1.3-1.5.2-1.2 1.8-2.7 1.5-1.6-1.5-1.7.2-3.3 1.5-1.6-4-3.5-2.3-4.5 1.5-1 4.3-2.4-5-2.3 0 0 2.3-3.6 10-2.9 0 0-2 1.6-2.2 3l1.6.5s-.4 1.1-1.9 2.3c0 0 4.2 2.3 4.9 3.8 0 0-2.6.8-3.3 1.8 0 0 1.2 1.3 1.6 3 0 0-2.9-.4-3.2 1.7-.4 2.1-1.3.7-1.3 2s.1 1.7-.9 2c-1 0-.1 1.1 0 1.8.2.7.6 2.3.4 2.8 0 0-1.5 0-2.1.2 0 0 .4 3-1.3 3.5-1.7.4 1 1-.9 1.3-1.8.3-1.5.5-3.7 4.5 0 0 1.9-1 3.8-2.4 2-1.3-.2-1 3-4 3.3-3.3 2.7-3.5 2.4-5.1-.2-1.6-.3-3 .9-4.5s1.5-3.2 5.7-3c0 0-1.2-2.8-2.7-3.5 0 0 2-1.3 4-1.5 0 0-1.8-2.3-5.6-4.4 0 0 3-2.6 3.9-3.9 0 0-1.5.3-2.7 0 0 0 .6-1.3 3.4-3.1 0 0 1.5 1.4 1.4 2.9 0 0 4.8-2.7 7.5-2.4 0 0 1.4 3.4-5.3 10 0 0 4.2.3 6 0 0 0-1 3.2-6 5-5 2 1 4.2-4.1 3.8-5-.4-3.5 1.3-3.4 3.9.2 2.6.3 5.3.2 6 0 0-4-1.3-4 2.6.1 4-2 4.8-2.5 5.1 0 0-1.2-1-3-1.7 0 0-2.5 4.9-6.5 7.7"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#7b3c20",
      d: "M547.4 220.5s1.4-.2 3.8 1.2c2.3 1.5 4.6-1.5 2-2.3-2.6-.8 0-1.8 2.4.2 2.4 1.9 3.3.9 4.2.3.8-.7 1.9-1.1.3-2.2-1.6-1.1 1-.6 2.3.3 1.2.7.7 1.5.6 1.7-.2.2-.3 2.9 2 .5 2.4-2.5 3.7-4.8 3.6-6 0 0 1.3.8 1.5 2.3.2 1.5 2-.8 2.6-1.6.6-.8 1.6-3 1.5-4.4 0 0 1.6 2.5 4 0s1.4-1 4.2-1.7a17.6 17.6 0 0 0 8.5-5.2c2-2.5 2.1-.8 4.6-1.4s7.7-4.2 8.2-6.1c.4-1.9.3-3.1-.4-2.4-.7.6-.4 0-1.5-.6-1.1-.7-2.7.9-2.7.9s1.6 1.2.3 1.7c-1.2.6-2.3 2.3-4.6 1.6-2.3-.6-4.8 2.2-4.8 2.2s2 1.6-.7 2.7c-2.7 1-2.3 1.4-3.9.2 0 0-2.9 3.7-4.6 4.5 0 0-.7 0-1.2-.8 0 0-2 2.1-2.8 2.5 0 0-1.3-1-2.3-1.5 0 0-2.3 2.9-4.2 3.7 0 0-.6-1-1.8-1.7 0 0-.6 3.6-4.6 5.8 0 0 .2-1-1.8-2.3 0 0-5 4.3-6.9 4.7-2 .4-.2-.9 0-1.5.4-.5 1.6-2.3-.8-3s-2 .5-2.5.7c-.6.2-.6-.4-2.2-.2s-1.3.9-2 1.2c-.8.2-3.6-.5-3.4 1.4.1 1.8 1.5 3.1-1 4.2-2.5 1 1 .8 4.1.4"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M557.5 215.3s.6-2.5-1.5-3.5c0 0 13.2-2.1 3.2-7.2 0 0 11.9-2.3 9-6.1-2.7-3.8-5.4-3-5.8-3-.4 0 2.5-2.1 3.3-1.8.7.3 10.2 3.9 7.8.7-2.4-3-2.2-2.9-2.6-3.8 0 0 3.1 0 7.9 4.6 0 0 1-1 .9-2.9 0 0 3.3 1 4.4 2 0 0 .6-1.2.3-1.8 0 0 3 1.5 4 3.2 0 0 1.3-1.2 1.5-2.6 0 0 3 1.3 3.7 2.2 0 0 1-1.3.6-3 0 0 4.9 1.3 5.5-1.6 0 0 4.9 1 1.7 2.9-4 2.5-.4-.6-4.6 2.3-3.2 2.3-5 4.9-6.6 4.4-1.1-.5-2.5 2.9-4 1.3-1.5-1.7-1.5-1-2.7.7a24.5 24.5 0 0 1-2.8 3.5s-.8-.5-1.6-1.2c0 0-.8 1.6-2 2.8 0 0-1-1.3-2.6-2 0 0-2.3 2.7-3.8 3.7 0 0-1.4-1.4-2.9-1.9 0 0-.2 3.8-3.1 5.7 0 0-.6-1.2-2.6-2 0 0-1.4 2.3-4.6 4.3z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M550.6 209.5s-1.6 1.2-.6 2.5c1 1.4 1.1-.2 2.4-.3 1.3-.2 17.5-3 2.8-7.3 0 0 .7-.6 3.1-.8 2.6-.3 11.8-2.7 7.5-6-4.3-3.2-7.9 1.1-4.3-2.8 3-3.1.6-4.6.6-4.6s-8.5 5.6-10.4 6.7c-1.8 1-4.6 3-1.4 4 3.3 1 5.4-3.4 5.7-2.4.3 1-6.4 4.8-5.4 6.4.9 1.8.7 3.3 2.4 2.9 1.6-.3 6 .8 2.5.7-3.7-.1-5 1-5 1z"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M556.4 201.3s-1.5 1.1.5.6 5.9-1.4 5.2-2.4c-.8-1-3.4.2-5.7 1.8"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#7b3c20",
      d: "M582.4 184.5s7.5-.2 10.5 1.9c3 2 4.6 3.4 5.5 3.8 0 0-.1 2.8-5 .7 0 0 .4 1.4-.2 2.8 0 0-1.7-1.2-3.8-1.7 0 0-.4 1-1 1.7 0 0-2.1-2.2-4.6-2.9 0 0-.4 1.1-.8 1.6 0 0-2.6-1.6-4.6-1.6 0 0 .4 1.7 0 2.3 0 0-5.4-4.3-10.3-3.8 0 0 2.3 3.5 3.8 5.1 0 0-9.8-.7-8-6 1.5-5.3-.2-4 6.2-4z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M536.3 199.1s-1.1 1 0 1.7c1.1.8 5-2 5.5-2.4.6-.4 2-.4 0 1.1s-3.8 3-5 4.6c0 0 6.4-1.8 10.6-5.4 4.3-3.7-.1-1.3 7-4.8 7.3-3.5 11.1-9.1 7.2-8.5-3.8.6-7.3 5-10.4 6.7-3 1.7-4.7 2-4.2 1 .4-1 2.7-.6 6.9-4 4.1-3.3 3.2-3 3.2-4.2 0-1.2-1.5-4 4.7-7.4 6.2-3.3 25.6-14.5 27.3-18.5 0 0-5.7.6-13.2 6.1a69.7 69.7 0 0 1-13.4 8.8c-2 .8-1.8.2-3.1 1.9a171.8 171.8 0 0 1-10.1 9.8c-1.3 1-1.8 1.6-1.9 3.8 0 1-8.4 7.3-11 9.7z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M562 184.3s-1.5.6-3 0c-1.3-.7-.8-3.6 2.5-5.5a50 50 0 0 1 12.6-4.8s-.5 3.8-10.1 7.1c0 0 .6 2-2 3.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#aa5323",
      d: "M565.4 181.8s.3 1 0 1.8c0 0 17.9 1.7 27.1-9.2 0 0-12.7 1.2-17.7 4.3 0 0 3.2-4 12.7-7.3s13.4-7.4 14.2-9.7c0 0-12 4.3-17.7 4.3 0 0-1.2 0-2.3.5-1.1.7-8.8 6.2-10.8 7.2 0 0 4.3-.4 5.9-1.8 0 0-3 8-11.4 10z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M531 192s-2.3 1.7-1.3 2.4c1 .9 2.6 1 6-1.9 3.6-3 12.1-10.2 6.8-10.5 0 0-7-.4-6.7 3.8.2 4.2-4.4 6-4.8 6.2m-15.9-2.5s4.6 2.7 2.8 4.9c0 0 14-11.8 10-14.4-3.8-2.6-6.9 2.3-6 2.7 1 .6 3-.4 2.3.6a77.4 77.4 0 0 1-9 6.2zm-3.6-3.8s3 1 3.2 2.3c.1 1.2 9.2-6.4 6.8-9.7-1.1-1.5-6-2-6.4.8-.2 3 4.6-.3 3 1.8-2.2 2.7-5.9 4.4-6.6 4.8m32.6-6.4s-1.9 1.4-.1 2.3c1.8.7 2.8-.6 3.7-1.3.9-.8 5.3-4 6.2-6 1-2 2.5-2.7 4.1-3.7 1.5-1 12.6-6.6 19.5-12.7 6.8-6.1 4-4.5 11-8.4s11.7-7.5 13.2-11.8c0 0-3.3 1-6.2 3a243 243 0 0 1-10.7 6.5c-1.3.5-3 .6-4 1.6s-1 2.3-4.3 5c-3.5 2.9-21 15.3-23.2 17a334.7 334.7 0 0 0-9.2 8.5"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#aa5323",
      d: "M530 183.4s2-1 5.6-.8c3.6.2 17.8-13.6 22-16.3a341.6 341.6 0 0 0 18.7-13.8c1.8-1.8 2-3.6 3.6-4.6 1.5-1 3-.9 6.4-2.9 3.5-2 20.3-12 19.3-17.8 0 0-25 15-30.7 19.8a375 375 0 0 1-24.7 17.7c-2.8 1.9-5 5-9.9 8.8-4.7 3.9-9.5 7.2-10.3 10z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#aa5323",
      d: "M524.8 178s4.6-.4 5.2 1.9c0 0 10-6.8 12.2-9.6 2.2-2.8-.8-1.2 4.9-4.9a594.3 594.3 0 0 0 27-19.1c2.7-2.3 7.8-5.5 11.9-8.2 4-2.8 19.9-10.6 18.1-17l-14.2 9.5c-2.7 1.8-3.9.8-6.5 2.9-2.6 2.1-8.5 6.3-9.5 7.6a161.3 161.3 0 0 1-14.4 11c-4.4 3-14.1 8.6-18.9 12.8a602.8 602.8 0 0 1-15.8 13.2z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#aa5323",
      d: "M510.4 176.8s2.3 0 3.1.9c0 0 4.3-3.9 8.9 0 0 0 16.8-11.5 18.5-14.4 1.7-2.8 4.5-2.9 11-7.6 6.6-4.8 10.7-6.9 15-10.2 4.4-3.4 8.1-7.3 11.2-9.3 3.1-2 11-7.2 9.8-11.7 0 0-6.5 3.6-10.6 8.2-4.2 4.6-3.8.7-8.1 4.5a82.7 82.7 0 0 1-16.3 11.7c-5.5 2.7-2.2 2.4-6.2 5-3.9 2.5-3.6 2-5 2.5a10 10 0 0 0-5.1 3c-1.6 1.7-5.4 4-9.6 6.5a106.5 106.5 0 0 0-16.6 10.9"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#aa5323",
      d: "M515.5 168s-1-1.9.7-3.3c1.6-1.3 4.6-4.8 5-7 .5-2.3.1-1.9 4.8-3.8a188.2 188.2 0 0 0 38.2-21.6c1.8-1.5 6.4-4.6 8.3-6.2 0 0 .8 2.5-1.2 4.2a222.1 222.1 0 0 1-21.5 14.9 76.6 76.6 0 0 0-9.6 5.5c-1.9 1.6-1.6 2-10.2 6.3-8.5 4.1-9 4.6-8.7 4.9.3.4 4.2-1.3 6-2.4 1.8-1 8.8-4.3 11-6a69 69 0 0 1 7-5 296 296 0 0 0 18-11.2c3.5-2.7 4.5-3.5 5.3-3 .7.4 2 .4.4 2s-6.7 6-8.7 7.3c-2 1.3-8.1 5-9.8 5.8-1.7 1-2.4 2.5-3.4 3.2-.9.8-3.7 2.7-7 3.5s-4 3.3-6.3 4.8c-2.3 1.4-18 10-18.5 10.3 0 0 .9-1 .2-3.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#aa5323",
      d: "M570.3 132.4s-.9.8-.4 1.2c.6.6 2.8 2.2 5.6-.6a106.5 106.5 0 0 1 12.5-10c2.3-1.5 3.6-2.8 3.5-4.7 0 0-11.4 6-21.2 14.1m15.6-1s1.7-2.9 6-5.7c4.3-2.7 10.8-6.7 11.5-7.6 0 0 1.6 1.7-1.7 3.8a311.7 311.7 0 0 0-10.8 7c-.7.7-2 1.6-5 2.5"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#7b3c20",
      d: "M499 163s-4.8 2.6-3.1 4.2c1.7 1.5 4.2 1 5.4.6l3.2-1c.4 0 4.5-1.3 5.6-3.2 1-2 3.8-4.2 6-5.8 2.2-1.5 3-3.2 2.7-4.3zm-28.4 22s3.4-2 8-.7c0 0-.2-1.1-1-1.7 0 0 5.7-1.5 6.9-4 1.2-2.5 1.5-2 2.5-2.6 1.2-.8 8.7-6.8 7.8-8.1-.9-1.3-1-3.1-1.7-3.7 0 0-1.5 2.1-9 5.7-7.2 3.6-15.4 6.2-21.4 14.2-5.9 8-5.3 12.6 2 14.7 0 0 5-3.2 17.6-2.1 12.4 1.1 16.6 5.8 17.4 6.6.8.9 3.3 4 .9 9.1 0 0 2.5 1.1 2.6-1.3.3-2.3.4-1.8 1-1.5.6.4 1.3.5 1-1.4a18 18 0 0 0-2.3-7.2c-1.1-1.5.2-.8.9-.6.7.3 3.3 2.5 1.8-1.5-1.5-3.8-2-2-2-1.8 0 .3-.4 1.2-3.8-1.4a26.8 26.8 0 0 0-8.8-4.4c-2.3-.6-.7-.6.7-1 1.4-.6 3.1-.8 3.8-2.4 0 0-1.4.3-3.8-.6a13.2 13.2 0 0 0-11.5 2s1.2-4.5-2.5-4.3c-3.6.3-6.2.2-10 3.2 0 0-.3-4.6 3.4-7 3.7-2.5 3.2-1 5.2-1.6 2-.6 2.3-2.7 1.4-3.4 0 0 4.8.9 12.8-5.8 0 0-4.3 5.7-9.5 6.8 0 0-.9 3-5.7 3.7-4.8.7-4.6 3.4-4.6 4.1z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M457 212.7s2.2-14.1 15.5-15.1c11.4-1 15.1.5 17.4 1.3s8 2.4 5.8 4.2c-2.2 1.8-3.5 1.5-3.5 1.5s2.5-2.9.2-3.3c-2.3-.5-2.4.9-2.7 2-.4 1.3-.5 2.6-1.6 3.6 0 0-1.2-1.4-2.9-.2s-.2 1.2.5 1c.6-.2 1.5-.5 1.3.5-.1 1-1 2.8-3.8 4.2-2.7 1.4-2.6 1.3-5.8 1.9-3.3.5-6.3 1.8-10.5 5.3-4.2 3.6-8.7 2.4-9.6-1.5-.8-3.4-.4-5.4-.4-5.4z"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M472 212.2s1.2-2.7-1-4c0 0-6.9 1.2-9-.9 0 0 7.5-.4 12.2-2.3 4.6-1.7 3.3-3 1.7-3.4-1.6-.3-4.6.5-4.9 2 0 0-1-1.6.2-2.6a5 5 0 0 1 4.7-.8c1.7.4 3.1 1.2 8.6-1.6 0 0 3.1.7 3.3 2.8 0 2.2-.3 3-.6 3.3-.2.4-.6 1-1.3 1-.6-.2-1.5-.3-2.3 1.2a8.9 8.9 0 0 1-2.6 3.7s1.5-4.6-2.5-5.7c0 0-3.3 2-5.8 2.1 0 0 3.2 3-.8 5.2z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M479.3 203.8s-1.6-1.6.4-1.9c2-.1 4.6 1.4 4.2 2.7-.6 1.2-3 1.1-4.6-.8"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#fff",
      d: "M592.6 181.6s-3.7 1-.2 3.3c3.4 2.3 5 4.2 7.5 4.8 2.5.7 5 1.5 5 4s-.5 3.5-1.9 5.2c-1.3 1.7.8 2.4 2.6 1.5 1.8-1 3.3-1.5 4.5-2.2 1.1-.7 3-.6 1.4.3-1.9 1-3.7 1.5-1.4 1.5 2.3.1 16.2.4 19.1-.6 3-.9 6.8-1.2 7-5 0 0 .2-1.6 1.3-2.4 1-.7 1.8-2.3.2-1.2-1.5 1.1-2.7 1.7-3 1.3-.3-.3-.5-.6.7-1.1 1.2-.5 1.8 0 2.9-1.5 1-1.6 1-1.4.4-2-.6-.6-1.8-1-1.2-1.8.6-.8 1.2-3-1.4-1.7-2.5 1.3-7.6 4.8-10 5.3-2.2.5-4 1.2-7.1 1.8-3 .7-5 1.4-8.5 3.3-3.3 1.8-3-1.1-2.5-1.5 0 0 1.3 2.3 4.7-.7 3.4-2.9 2.3-.1 10.6-2.9 8.3-2.7 6.3-3.1 9.5-4.8 3.3-1.7 6.4-1.8 4-4-2.2-2.4-2.4-2.5-5.3 0a34.5 34.5 0 0 1-16 6.4s18.8-8 16.9-9.2a20.8 20.8 0 0 0-5.3-2.5c-1.3-.3-1.7-.6-4.7.8-3 1.3-3.5 1.6-4.3 1.7-1 0-3.5.6-7 2.4-3.6 1.9-5.5 2.6-8 4 0 0 1.7-3.3 9.1-5.5 7.4-2.2 11.1-4.2 10.4-4.6s-2.7-.8-4-.5c-1.5.3-1-.1-5.6 1.7-4.5 1.8-2.6 1.4-6.2 2.2-3.7.7-5.1 1.5-6.9 2.3 0 0 .8-1 3.1-1.9 1.3-.4-1.3-.9 2.2-1h1a32.2 32.2 0 0 0 8.6-3.3c-.7-.1-5.1-.6-9.5 1.6-4.5 2-2.5 1.3-4 1.5-1.6.4-5 2.4-6 3.4-1.1.9-2.7 1.5-2.7 1.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#5a3719",
      d: "M482.7 201.8s1.8.5 2.2 1.8c.5 1.2 1.6-.6 1.6-1.1-.1-.6-1.2-3-3-1.9-2 1.1-1 1.1-.8 1.2"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#7b3c20",
      d: "M477.9 226s3.7-1.8 6.9-1.5c0 0-1.3-4.4.9-3.7 2.1.8 1.5.4 2 .4 0 0 .1-2.9-.5-4 0 0 2.3.5 4.6.5 0 0-2.2-4.1.2-7a6.9 6.9 0 0 0 4.2 3.4v-2.3s1.7-.3 3 .4c1.4.8 2.5-7.6-1.5-9.3 0 0-1 1.5-4.7 2.3s-3.7 1.5-5.2 4.3-3 2.9-6.2 5c-3 2-5 6-5 6.4 0 0 1.5 2 1.3 5.1"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#999",
      d: "M603.1 177.8c1.3-.2-1.4-.9 2-1h1a32.2 32.2 0 0 0 8.7-3.3c-.7-.1-5.1-.6-9.5 1.5s-2.5 1.4-4 1.7c-1.6.3-5 2.3-6 3.3-1.1.9-2.7 1.5-2.7 1.5s-3.7 1-.2 3.4c3.4 2.3 5 4.2 7.5 4.8 2.5.7 5 1.5 5 4a7 7 0 0 1-1.9 5.2c-1.3 1.7.8 2.4 2.6 1.5 1.8-1 3.3-1.5 4.5-2.2 1.1-.7 3-.6 1.3.3-1.8 1-3.6 1.5-1.3 1.5 2.3.1 16.2.4 19.1-.6 3-.9 6.8-1.2 7-5 0 0 .2-1.6 1.3-2.4 1-.7 1.8-2.3.2-1.2-1.5 1.1-2.8 1.7-3 1.3-.3-.3-.5-.6.7-1.1 1.2-.5 1.8 0 2.9-1.5 1-1.6 1-1.4.4-2l-1-.9s-.9-.7-1.9-.1a27.6 27.6 0 0 1-7 2.7c-1.6.1-3.5.9-6.5 2.4s-8.2 4.6-9 1.7l-2.8 1c-3.4 1.8-3-.7-2.5-1.4 0 0-1.8 2-1.7.2 0-1.8 1.2-1.5 3.3-2.1 2-.6 5-2 3.8-3-1.3-1-2.7 1-4.2 1.8-1.4.7-4.3 1.2-4.8-.9-.4-2.1-.4-3.6-4.3-3.8-4-.2-3.9-2.7-2.8-3.8 1.1-1 2-2.8 5.7-3.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M615.6 196.9s6.1-2.8 11.7-4.1c5.7-1.3 1.2.2.3.4-1 .3-9.7 3.2-11.8 4.2-2 1-1.7.2-.2-.4zm1.4 1.3s6.9-2.3 8.2-1.4c1.3 1 .2.6-1.3.8-1.6.1-5.7.8-6.8.8-1.1 0-.1-.2-.1-.2m11-2.5s1.4-.2 1.5.4c.1.4-.6.5-1.3.4-.7-.1-1.3-.5-.1-.8z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#fff",
      d: "M446 255.9s-.3-6.2 2.8-9.2 17.8-18.5 20.1-22.8c0 0 2 1.3 2 3.8 0 0 2.5-4.3 4.5-6 0 0 1.7 1.8 1.5 5.4 0 0 3.5-1.9 9-1.9 0 0-2 2.4-2.1 3.9 0 0 7.6-1 11.7-.3 0 0-10.6 6-7.7 6.5 3.1.5 6.2 0 6.2 0s-3.4 3.3-8.8 4c0 0 6.9 0 8.2 1.5 0 0-6.6 1-12 5 0 0-.4-.2-.4-1.7 0 0-.3 1.4-1.8 2.7-1.5 1.2-5.1 4-6.5 5.3-1.4 1.3-3.8 4-6.6 4 0 0 .6-2.1-1.4-2.8a5.7 5.7 0 0 0-6 1.5s-7 .1-9.4.5c0 0 1.6-2.6 3-2.6 1.6 0 7.6 1 8.1-3.2.6-4-3.8-3-2.2-5.4 1.7-2.4 1.3-2.2 1.4-2.6 0 0-1.4.8-2.2 3a10.7 10.7 0 0 1-4.2 6 15 15 0 0 0-4.8 5s-1.3 0-2.4.4"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#fff",
      d: "M452.8 252.2s.3-.8 2.3-1.2c2.2-.3 2.3-1.3 2-1.8-.3-.4-1.5-.4.5-2.8 0 0 .8.3 1.2.8.6.6 2.9 5.5-6 5"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#999",
      d: "M447.9 247.9c0 4 5.3 2.5 5.3 2.5a21.4 21.4 0 0 0-3.8 3.6c.4-2-3-2.5-3-2.5a12.3 12.3 0 0 1 1.5-3.6m19.3-21.5 1.7-2.5s2 1.3 2 3.8c0 0 2.5-4.3 4.5-6 0 0 1.7 1.8 1.5 5.4 0 0 3.5-1.9 9-1.9 0 0-2 2.4-2.1 3.9 0 0 7.6-1 11.7-.3 0 0-10.6 6-7.7 6.5 3.1.5 6.2 0 6.2 0s-3.4 3.3-8.8 4c0 0 6.9 0 8.2 1.5 0 0-2 .3-4.6 1.2 0 0-1.9-1.8-7.6-1.5 0 0 4.4-2.6 8-3.4 0 0-1.6-2-4-.1 0 0-4.9-3.3-.8-6.2 0 0-2.8-.5-4.7.8 0 0 0-2.3 2.1-3.3 0 0-5.4-1-6.7 3 0 0-1-1.5-.5-3.4 0 0-3.3 1.9-4.8 4 0 0-.5-4-2.6-5.5M456.8 252c-.9.2-2.3.3-4 .2 0 0 .2-.5 1.3-1 0 0 .4.8 2.7.8"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M466.6 236.7s2.5 2 3.3 3c0 0 2.3-1.4 3-2.7 0 0 1.9 1.1 2.4 2.8 0 0 1.3-.8 1.5-2 0 0 3 .6 4.2 1.6 0 0 .4-3 0-4.8 0 0 2.1.2 3.4.7 0 0-1.2-2 5-4.5 0 0-4.7 1.1-6.5 3 0 0-2 .2-2.9-.4v4.5s-1.2-.6-3.5-1.1c0 0-.6 1-1 1.2 0 0-1.5-1.2-2.1-2.7 0 0-2.3 2.1-3 3 0 0-2.3-1.6-3.8-1.6"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M452.5 267.3s1 .4 3.3-1.4 8.7-5.9 9.2-9.2c.7-3.3-2-3.4-4-2.5-2.2 1-1.3 2.7-1.2 3.4 0 .6.2 2.9-3.3 6z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#ffc221",
      d: "M451.9 268.3s-5.2-2.2-.6-4.5 6.7-2.9 7.2-4.9c.6-1.9.2-1.5-1.5-.7-1.7.7-8.2 3.8-9.2 1 0 0 2.7 1 6-.6 3.4-1.7 6.2-2.1 4-2.8a37 37 0 0 0-11 .5c-1.4.4-1 .3-1.3 1.6-.2 1.3-1.6 4-2.2 4.7-.5.8-1.8 4 .6 5.5a8.6 8.6 0 0 0 8 .2"
    }),
    /* @__PURE__ */ jsx28("path", {
      d: "M449.9 257s-1.3.2-1 .7c.2.5.5.4 1 .4.3 0 1-.2 1.1-.5 0-.3-.8-.7-1.1-.5z"
    }),
    /* @__PURE__ */ jsx28("path", {
      fill: "#fff",
      d: "M451.5 267.1s-2.4-1.1.4-2.6c2.7-1.5 5.6-3 6-3.6 0 0-1.3 1.9-6.4 6.2"
    })
  ]
});
var As_default = SvgAs;

// src/country-flag-icons/generated/At.tsx
import { jsx as jsx29, jsxs as jsxs22 } from "react/jsx-runtime";
var SvgAt = (props) => /* @__PURE__ */ jsxs22("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx29("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx29("path", {
      fill: "#c8102e",
      d: "M0 0h640v160H0zm0 320h640v160H0z"
    })
  ]
});
var At_default = SvgAt;

// src/country-flag-icons/generated/Au.tsx
import { jsx as jsx30, jsxs as jsxs23 } from "react/jsx-runtime";
var SvgAu = (props) => /* @__PURE__ */ jsxs23("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx30("path", {
      fill: "#00008B",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx30("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx30("path", {
      fill: "red",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx30("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx30("path", {
      fill: "red",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsx30("path", {
      fill: "#fff",
      d: "m527 396.7-20.5 2.6 2.2 20.5-14.8-14.4-14.7 14.5 2-20.5-20.5-2.4 17.3-11.2-10.9-17.5 19.6 6.5 6.9-19.5 7.1 19.4 19.5-6.7-10.7 17.6zm-3.7-117.2 2.7-13-9.8-9 13.2-1.5 5.5-12.1 5.5 12.1 13.2 1.5-9.8 9 2.7 13-11.6-6.6zm-104.1-60-20.3 2.2 1.8 20.3-14.4-14.5-14.8 14.1 2.4-20.3-20.2-2.7 17.3-10.8-10.5-17.5 19.3 6.8L387 178l6.7 19.3 19.4-6.3-10.9 17.3 17.1 11.2ZM623 186.7l-20.9 2.7 2.3 20.9-15.1-14.7-15 14.8 2.1-21-20.9-2.4 17.7-11.5-11.1-17.9 20 6.7 7-19.8 7.2 19.8 19.9-6.9-11 18zm-96.1-83.5-20.7 2.3 1.9 20.8-14.7-14.8-15.1 14.4 2.4-20.7-20.7-2.8 17.7-11L467 73.5l19.7 6.9 7.3-19.5 6.8 19.7 19.8-6.5-11.1 17.6zM234 385.7l-45.8 5.4 4.6 45.9-32.8-32.4-33 32.2 4.9-45.9-45.8-5.8 38.9-24.8-24-39.4 43.6 15 15.8-43.4 15.5 43.5 43.7-14.7-24.3 39.2 38.8 25.1Z"
    })
  ]
});
var Au_default = SvgAu;

// src/country-flag-icons/generated/Aw.tsx
import { jsx as jsx31, jsxs as jsxs24 } from "react/jsx-runtime";
var SvgAw = (props) => /* @__PURE__ */ jsxs24("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx31("defs", {
      children: /* @__PURE__ */ jsx31("clipPath", {
        id: "aw_svg__a",
        children: /* @__PURE__ */ jsx31("path", {
          fillOpacity: 0.7,
          d: "M0 0h288v216H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs24("g", {
      clipPath: "url(#aw_svg__a)",
      transform: "scale(2.2222)",
      children: [
        /* @__PURE__ */ jsx31("path", {
          fill: "#39c",
          d: "M0 0v216h324V0z"
        }),
        /* @__PURE__ */ jsx31("path", {
          fill: "#ff0",
          d: "M0 144v12h324v-12zm0 24v12h324v-12z"
        })
      ]
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m142.7 28 2.9 3zm-3 6 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m139.7 37 3 2.9-3-3m5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m136.7 42.8 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c66",
      d: "m142.7 42.8 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m148.6 42.8 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m136.7 45.8 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m139.7 48.7 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m133.8 51.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c00",
      stroke: "#fff",
      strokeWidth: 3.7,
      d: "m142.2 34-20.7 78.5L42.8 134l78.4 20.5 21 78.4 20.9-78.4 78.4-21-78.4-20.9-21-78.4z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m151.5 51.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m133.8 54.6 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m136.7 57.6 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m130.8 60.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m137.7 62.5 1 2zm11.8 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m154.5 60.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m130.8 63.5 3 3zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m133.8 66.4 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m127.9 69.4 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m127.9 72.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m127.9 75.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m125 78.3 2.9 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m130.8 78.3 3 2.9zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m160.4 78.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m125 81.2 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m131.8 83.2 1 2zm23.6 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m160.4 81.2 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m125 84.2 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m127.9 87.1 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m122 90 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m128.9 92 1 2zm29.5 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m163.3 90 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m122 93 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m125 96 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m119 99 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m126 100.9.9 2zm35.4 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m166.3 99 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m119 101.9 3 3zm47.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m122 104.8 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m116 107.8 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m122 107.8 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m169.2 107.8 3 3zm-62 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m110.2 110.7 3 3zm65 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m178 110.7 3 3zm-79.6 3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m101.3 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m113.1 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m116 113.7 3 3zm53.2 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m172.2 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m184 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m187 113.7 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m86.6 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m89.5 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m92.5 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m104.3 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m109.2 117.6 2 1zm67.9 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m181 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m192.8 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m195.8 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m198.7 116.6 3 3zm-121 3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m80.7 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m83.6 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m95.4 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m100.3 120.6 2 1zm85.6 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m189.9 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m201.7 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m204.6 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m207.6 119.6 3 3zm-138.8 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m71.8 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m86.6 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m91.5 123.5 2 1zm103.3 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m198.7 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m213.5 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m216.4 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m60 125.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m63 125.5 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m74.8 125.5 2.9 3zm135.8 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m222.3 125.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m225.3 125.5 3 3zm-174.2 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m54 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m65.9 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m70.8 129.4 2 1zm144.7 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m219.4 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m231.2 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m234.2 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m42.3 131.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m45.2 131.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m57 131.4 3 3zm171.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m240 131.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m243 131.4 3 3zm-206.6 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c66",
      d: "m51.1 134.3 3 3zm183 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m249 134.3 2.9 3zm-206.6 3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m45.2 137.3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m57 137.3 3 3zm171.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m240 137.3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m243 137.3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m51.1 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m54 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m65.9 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m70.8 141.2 2 1zm144.7 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m219.4 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m231.2 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m234.2 140.3 3 2.9zm-174.2 3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m63 143.2 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m74.8 143.2 2.9 3zm135.8 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m222.3 143.2 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m225.3 143.2 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m68.8 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m71.8 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m86.6 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m91.5 147.1 2 1zm103.3 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m198.7 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m213.5 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m216.4 146.2 3 2.9zm-138.7 3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m80.7 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m83.6 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m95.4 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m100.3 150 2 1zm85.6 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m189.9 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m201.7 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m204.6 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m207.6 149.1 3 3zm-121 3 2.9 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m89.5 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m92.5 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m104.3 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m109.2 153 2 1zm67.9 0 2 1z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m181 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m192.8 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m195.8 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m198.7 152 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m98.4 155 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m101.3 155 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m113.1 155 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m116 155 3 3zm53.2 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m172.2 155 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m184 155 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m187 155 2.9 3zm-79.7 3 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m110.2 158 3 3zm65 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m178 158 3 3zm-62 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m122 161 3 2.9zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m169.2 161 3 2.9z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m122 163.9 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m119 166.8 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m126 168.8.9 2zm35.4 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m166.3 166.8 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m119 169.8 3 3zm47.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m125 172.7 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m122 175.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m128.9 177.6 1 2zm29.5 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m163.3 175.7 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m122 178.6 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m127.9 181.6 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m125 184.5 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m131.8 186.5 1 2zm23.6 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m160.4 184.5 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m125 187.5 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m125 190.4 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m130.8 190.4 3 3zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m160.4 190.4 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#cff",
      d: "m127.9 193.4 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m127.9 196.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m127.9 199.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m133.8 202.2 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m130.8 205.2 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c33",
      d: "m137.7 207.2 1 2zm11.8 0 1 2z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m154.5 205.2 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#69c",
      d: "m130.8 208.2 3 2.9zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m136.7 211.1 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cf",
      d: "m133.8 214 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m133.8 217 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#fcc",
      d: "m139.7 220 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m136.7 222.9 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m136.7 225.9 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#c66",
      d: "m142.7 225.9 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#6cc",
      d: "m148.6 225.9 2.9 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#ccf",
      d: "m139.7 231.8 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx31("path", {
      fill: "#9cc",
      d: "m139.7 234.7 3 3zm5.9 0 3 3zm-3 6 3 2.9z"
    })
  ]
});
var Aw_default = SvgAw;

// src/country-flag-icons/generated/Ax.tsx
import { jsx as jsx32, jsxs as jsxs25 } from "react/jsx-runtime";
var SvgAx = (props) => /* @__PURE__ */ jsxs25("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx32("defs", {
      children: /* @__PURE__ */ jsx32("clipPath", {
        id: "ax_svg__a",
        children: /* @__PURE__ */ jsx32("path", {
          fillOpacity: 0.7,
          d: "M106.3 0h1133.3v850H106.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs25("g", {
      clipPath: "url(#ax_svg__a)",
      transform: "matrix(.56472 0 0 .56482 -60 -.1)",
      children: [
        /* @__PURE__ */ jsx32("path", {
          fill: "#0053a5",
          d: "M0 0h1300v850H0z"
        }),
        /* @__PURE__ */ jsxs25("g", {
          fill: "#ffce00",
          children: [
            /* @__PURE__ */ jsx32("path", {
              d: "M400 0h250v850H400z"
            }),
            /* @__PURE__ */ jsx32("path", {
              d: "M0 300h1300v250H0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs25("g", {
          fill: "#d21034",
          children: [
            /* @__PURE__ */ jsx32("path", {
              d: "M475 0h100v850H475z"
            }),
            /* @__PURE__ */ jsx32("path", {
              d: "M0 375h1300v100H0z"
            })
          ]
        })
      ]
    })
  ]
});
var Ax_default = SvgAx;

// src/country-flag-icons/generated/Az.tsx
import { jsx as jsx33, jsxs as jsxs26 } from "react/jsx-runtime";
var SvgAz = (props) => /* @__PURE__ */ jsxs26("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx33("path", {
      fill: "#3f9c35",
      d: "M.1 0h640v480H.1z"
    }),
    /* @__PURE__ */ jsx33("path", {
      fill: "#ed2939",
      d: "M.1 0h640v320H.1z"
    }),
    /* @__PURE__ */ jsx33("path", {
      fill: "#00b9e4",
      d: "M.1 0h640v160H.1z"
    }),
    /* @__PURE__ */ jsx33("circle", {
      cx: 304,
      cy: 240,
      r: 72,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx33("circle", {
      cx: 320,
      cy: 240,
      r: 60,
      fill: "#ed2939"
    }),
    /* @__PURE__ */ jsx33("path", {
      fill: "#fff",
      d: "m384 200 7.7 21.5 20.6-9.8-9.8 20.7L424 240l-21.5 7.7 9.8 20.6-20.6-9.8L384 280l-7.7-21.5-20.6 9.8 9.8-20.6L344 240l21.5-7.7-9.8-20.6 20.6 9.8z"
    })
  ]
});
var Az_default = SvgAz;

// src/country-flag-icons/generated/Ba.tsx
import { jsx as jsx34, jsxs as jsxs27 } from "react/jsx-runtime";
var SvgBa = (props) => /* @__PURE__ */ jsxs27("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx34("defs", {
      children: /* @__PURE__ */ jsx34("clipPath", {
        id: "ba_svg__a",
        children: /* @__PURE__ */ jsx34("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs27("g", {
      fillRule: "evenodd",
      clipPath: "url(#ba_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx34("path", {
          fill: "#009",
          d: "M-85.3 0h682.6v512H-85.3z"
        }),
        /* @__PURE__ */ jsx34("path", {
          fill: "#FC0",
          d: "m56.5 0 511 512.3V.3z"
        }),
        /* @__PURE__ */ jsx34("path", {
          fill: "#FFF",
          d: "M439.9 481.5 412 461.2l-28.6 20.2 10.8-33.2-28.2-20.5h35l10.8-33.2 10.7 33.3h35l-28 20.7zm81.3 10.4-35-.1-10.7-33.3-10.8 33.2h-35l28.2 20.5-10.8 33.2 28.6-20.2 28 20.3-10.5-33zM365.6 384.7l28-20.7-35-.1-10.7-33.2-10.8 33.2-35-.1 28.2 20.5-10.8 33.3 28.6-20.3 28 20.4zm-64.3-64.5 28-20.6-35-.1-10.7-33.3-10.9 33.2h-34.9l28.2 20.5-10.8 33.2 28.6-20.2 27.9 20.3zm-63.7-63.6 28-20.7h-35L220 202.5l-10.8 33.2h-35l28.2 20.4-10.8 33.3 28.6-20.3 28 20.4-10.5-33zm-64.4-64.3 28-20.6-35-.1-10.7-33.3-10.9 33.2h-34.9L138 192l-10.8 33.2 28.6-20.2 27.9 20.3-10.4-33zm-63.6-63.9 27.9-20.7h-35L91.9 74.3 81 107.6H46L74.4 128l-10.9 33.2L92.1 141l27.8 20.4zm-64-64 27.9-20.7h-35L27.9 10.3 17 43.6h-35L10.4 64l-11 33.3L28.1 77l27.8 20.4zm-64-64L9.4-20.3h-35l-10.7-33.3L-47-20.4h-35L-53.7 0l-10.8 33.2L-35.9 13l27.8 20.4z"
        })
      ]
    })
  ]
});
var Ba_default = SvgBa;

// src/country-flag-icons/generated/Bb.tsx
import { jsx as jsx35, jsxs as jsxs28 } from "react/jsx-runtime";
var SvgBb = (props) => /* @__PURE__ */ jsxs28("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx35("path", {
      fill: "#00267f",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx35("path", {
      fill: "#ffc726",
      d: "M213.3 0h213.4v480H213.3z"
    }),
    /* @__PURE__ */ jsx35("path", {
      id: "bb_svg__a",
      fill: "#000001",
      d: "M319.8 135.5c-7 19-14 38.6-29.2 53.7 4.7-1.6 13-3 18.2-2.8v79.5l-22.4 3.3c-.8 0-1-1.3-1-3-2.2-24.7-8-45.5-14.8-67-.5-2.9-9-14-2.4-12 .8 0 9.5 3.6 8.2 1.9a85 85 0 0 0-46.4-24c-1.5-.3-2.4.5-1 2.2 22.4 34.6 41.3 75.5 41.1 124 8.8 0 30-5.2 38.7-5.2v56.1H320l2.5-156.7z"
    }),
    /* @__PURE__ */ jsx35("use", {
      xlinkHref: "#bb_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 639.5 0)"
    })
  ]
});
var Bb_default = SvgBb;

// src/country-flag-icons/generated/Bd.tsx
import { jsx as jsx36, jsxs as jsxs29 } from "react/jsx-runtime";
var SvgBd = (props) => /* @__PURE__ */ jsxs29("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx36("path", {
      fill: "#006a4e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx36("circle", {
      cx: 280,
      cy: 240,
      r: 160,
      fill: "#f42a41"
    })
  ]
});
var Bd_default = SvgBd;

// src/country-flag-icons/generated/Be.tsx
import { jsx as jsx37, jsxs as jsxs30 } from "react/jsx-runtime";
var SvgBe = (props) => /* @__PURE__ */ jsx37("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs30("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx37("path", {
        fill: "#000001",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx37("path", {
        fill: "#ffd90c",
        d: "M213.3 0h213.4v480H213.3z"
      }),
      /* @__PURE__ */ jsx37("path", {
        fill: "#f31830",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Be_default = SvgBe;

// src/country-flag-icons/generated/Bf.tsx
import { jsx as jsx38, jsxs as jsxs31 } from "react/jsx-runtime";
var SvgBf = (props) => /* @__PURE__ */ jsx38("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs31("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx38("path", {
        fill: "#de0000",
        d: "M640 479.6H.4V0H640z"
      }),
      /* @__PURE__ */ jsx38("path", {
        fill: "#35a100",
        d: "M639.6 480H0V240.2h639.6z"
      }),
      /* @__PURE__ */ jsx38("path", {
        fill: "#fff300",
        d: "m254.6 276.2-106-72.4h131L320 86.6 360.4 204l131-.1-106 72.4 40.5 117.3-106-72.6L214 393.4"
      })
    ]
  })
});
var Bf_default = SvgBf;

// src/country-flag-icons/generated/Bg.tsx
import { jsx as jsx39, jsxs as jsxs32 } from "react/jsx-runtime";
var SvgBg = (props) => /* @__PURE__ */ jsxs32("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx39("path", {
      fill: "#fff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx39("path", {
      fill: "#00966e",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx39("path", {
      fill: "#d62612",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Bg_default = SvgBg;

// src/country-flag-icons/generated/Bh.tsx
import { jsx as jsx40, jsxs as jsxs33 } from "react/jsx-runtime";
var SvgBh = (props) => /* @__PURE__ */ jsxs33("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx40("path", {
      fill: "#fff",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx40("path", {
      fill: "#ce1126",
      d: "M640 0H96l110.7 48L96 96l110.7 48L96 192l110.7 48L96 288l110.7 48L96 384l110.7 48L96 480h544"
    })
  ]
});
var Bh_default = SvgBh;

// src/country-flag-icons/generated/Bi.tsx
import { jsx as jsx41, jsxs as jsxs34 } from "react/jsx-runtime";
var SvgBi = (props) => /* @__PURE__ */ jsxs34("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx41("defs", {
      children: /* @__PURE__ */ jsx41("clipPath", {
        id: "bi_svg__a",
        children: /* @__PURE__ */ jsx41("path", {
          fillOpacity: 0.7,
          d: "M-90.5 0H592v512H-90.5z"
        })
      })
    }),
    /* @__PURE__ */ jsxs34("g", {
      fillRule: "evenodd",
      clipPath: "url(#bi_svg__a)",
      transform: "translate(84.9) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx41("path", {
          fill: "#18b637",
          d: "m-178 0 428.8 256L-178 512zm857.6 0L250.8 256l428.8 256z"
        }),
        /* @__PURE__ */ jsx41("path", {
          fill: "#cf0921",
          d: "m-178 0 428.8 256L679.6 0zm0 512 428.8-256 428.8 256z"
        }),
        /* @__PURE__ */ jsx41("path", {
          fill: "#fff",
          d: "M679.6 0h-79.9L-178 464.3V512h79.9L679.6 47.7z"
        }),
        /* @__PURE__ */ jsx41("path", {
          fill: "#fff",
          d: "M398.9 256a148 148 0 1 1-296.1 0 148 148 0 0 1 296 0z"
        }),
        /* @__PURE__ */ jsx41("path", {
          fill: "#fff",
          d: "M-178 0v47.7L599.7 512h79.9v-47.7L-98.1 0z"
        }),
        /* @__PURE__ */ jsx41("path", {
          fill: "#cf0921",
          stroke: "#18b637",
          strokeWidth: 3.9,
          d: "m280 200.2-19.3.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm-64.6 111.6-19.2.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm130.6 0-19.2.3-10 16.4-10-16.4-19.1-.4 9.3-16.9-9.3-16.8 19.2-.4 10-16.4 10 16.5 19.2.4-9.4 16.8z"
        })
      ]
    })
  ]
});
var Bi_default = SvgBi;

// src/country-flag-icons/generated/Bj.tsx
import { jsx as jsx42, jsxs as jsxs35 } from "react/jsx-runtime";
var SvgBj = (props) => /* @__PURE__ */ jsxs35("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx42("defs", {
      children: /* @__PURE__ */ jsx42("clipPath", {
        id: "bj_svg__a",
        children: /* @__PURE__ */ jsx42("path", {
          fill: "gray",
          d: "M67.6-154h666v666h-666z"
        })
      })
    }),
    /* @__PURE__ */ jsx42("g", {
      clipPath: "url(#bj_svg__a)",
      transform: "matrix(.961 0 0 .7207 -65 111)",
      children: /* @__PURE__ */ jsxs35("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx42("path", {
            fill: "#319400",
            d: "M0-154h333v666H0z"
          }),
          /* @__PURE__ */ jsx42("path", {
            fill: "#ffd600",
            d: "M333-154h666v333H333z"
          }),
          /* @__PURE__ */ jsx42("path", {
            fill: "#de2110",
            d: "M333 179h666v333H333z"
          })
        ]
      })
    })
  ]
});
var Bj_default = SvgBj;

// src/country-flag-icons/generated/Bl.tsx
import { jsx as jsx43, jsxs as jsxs36 } from "react/jsx-runtime";
var SvgBl = (props) => /* @__PURE__ */ jsxs36("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx43("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx43("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx43("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Bl_default = SvgBl;

// src/country-flag-icons/generated/Bm.tsx
import { jsx as jsx44, jsxs as jsxs37 } from "react/jsx-runtime";
var SvgBm = (props) => /* @__PURE__ */ jsxs37("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx44("path", {
      fill: "#cf142b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M559.7 130.6v161.6c0 43.1-86.2 57.2-86.2 57.2s-86.4-14-86.4-57.4V130.6h172.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#2f8f22",
      d: "M559.7 292.2c0 43.1-86.2 57.2-86.2 57.2s-86.4-14-86.4-57.4c0 0 0-3.5 1.8-5.4 0 0-1 7.1 4.5 12.6 0 0-4.3-7.8 0-15.3 0 0-1.7 9.8 4.4 15.3 0 0-3.3-7.9.4-16.7 0 0-1.8 14.3 4.7 17.3 0 0 1.8-8.4-.8-13.6 0 0 4.5 1.8 4.3 13.8 0 0 1.4-1.8 1.8-10.5 0 0 .2 10 3.5 12.3 0 0 1.2-1-.3-5.5-1.6-4.4.6-6 1-6 0 0-.8 5 3.4 8.8 0 0-1.8-7.9.7-9 0 0-.6 6.7 4.8 8.1 0 0 .3-1.9-.8-4 0 0-1-2.5-.3-4.5 0 0 1.7 6 4 7 0 0-1.4-3.6 0-7 0 0 .2 5 4.7 7.1 0 0-3-4-1.9-8.2l28.7 1.4 15 .7 44.7-3 7.6-6.7s3.1 4.1-1.8 10.8c0 0 4.8-.8 6.3-8.3 0 0 2 4.1-.7 8.8 0 0 5.3-5.4 6-11.3 0 0 2.1 5.8-2.9 12 0 0 4.4-1.6 6.3-8.1 0 0 1.6 4-2.7 9.5 0 0 8.1-4.1 7.9-13 0 0 3.3 4.8-.5 11.6 0 0 4-3.7 4.5-9.3 0 0 2.3 2.5-.2 9.4 0 0 5-4.8 5.8-9.9 0 0 1 4.8-3.2 10.8 0 0 2.9-.8 5.7-6.6 0 0 .7 2.4-1.8 6.6 0 0 2.8-.5 4.6-5.9 0 0 .3 3.2-.5 6 0 0 2.1-1.3 2.6-7.3a9 9 0 0 0 1.2 4.4v.8z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M515.4 198.7s-3 .6-7-.6c-3.8-1.2-5.3-.7-6.5 0 0 0 1.5-3.1-2.3-5.6 0 0 1.2 3.2-.5 4.6 0 0-.7.7-1.6-.3 0 0-1.3-1.5-2.8-2.4 0 0 3.3-1.2 2.7-4.5-.6-3.3-2.4-3.6-3.3-4.1a6 6 0 0 0 0 2.4s-3.5-2 1.2-4.7c4.8-2.7 4-4.4 3.1-5.8a13.1 13.1 0 0 0-3.5-3.6s1 1.6.7 2.9c-.1 1.2-2.4 2-2-.1.5-2.4 0-2 0-4.3 0 0 4.2 1.4 6-2.8 0 0 1.6-4.3-3.8-6.4 0 0 1.3 1.8.7 3 0 0-1.2 2.2-2.5.6-1.3-1.7-2.2-2.2-2.1-4.2 0 0 4.9.7 3.6-4.7 0 0-.9 3.6-7.2-1.2 0 0 4.2-4.2 2.5-7.6 0 0-.5-1.5-4.9-.7 0 0 3.8-2.4 2.3-4.5 0 0-.9-1.3-4.6.4 0 0 1.5-2.3-2.1-5 0 0-2.4 1.2-3.6 2.4 0 0-2.4-3-4-4.3 0 0-2.8 1.1-3.5 4.3 0 0-1.3-1.5-4.3-2.4 0 0-1.4 2.8.5 5 0 0-1.4 0-4-1.1 0 0-2.8-1.2-2.3 1.1.3 2.4.6 3 1.2 4.2 0 0-6.5-1.5-6.2 2a8.8 8.8 0 0 0 3 6.2s-3.5 4.8-6.6 1.2c0 0-1.2 1.2 1.2 4.2 0 0 2.4 2.5.3 4.2 0 0-2.5 2-3.7-2 0 0-4.1 4.1.8 7.2 0 0 3 1.8 6.3-1 0 0-1 8-4 6.4 0 0-1.9-1.2 1.4-2.9 0 0-4.8-.6-5.5 4 0 0-.6 3.5 3.5 5 0 0 3.1 1.2 0 3.6 0 0-2.5 1.7-.9 4.4 0 0 1.8 2.8-2.9 3.2 0 0-2.4 0-3.3-.4 0 0-1 2-.4 4 0 0-2.3-1.7-7.5.2-5.2 2-4.9.6-5.2 1.2l-1.6 2.4s2.8 3.6 2.9 3.3l-.6 4 1.4.6 10.8-4.8 11-5.7 8.9.4 5.6 1.3 7.2.6 5.4-2.8h7.6l8.4 4.2 9.5 5.7 5 1 3.9-.3v-7.8z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M428.2 207.7s4.2 2.2 6-.3c0 0 2.2-4.4-2.8-6 0 0 2.8-3.2-.2-6.2 0 0-1.6-1.6-4.2-.5 0 0-1.2-2.3-3.7-2.2 0 0-2.4 0-3 2.5 0 0-3.2-1.2-4.9.6 0 0-3 3.2 1.1 5.8l2.9.3 2.8-1.4 3.3.9s-.9 3.2 2.7 6.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M521.6 200.1a6.7 6.7 0 0 1 6.9 3.8c2.6 6.2-3 9.6-3 9.6.4 1.3.5 3.2.5 3.2 7.8 1 6.4 9.8 6.4 9.8l-2.6-2.2c-4.5-1.8-9.3 2.2-12.6 8.6-3.4 6.6-1.8 9.5-1.2 17.3.6 7.7 13 12.4 13 12.4l-9.7 25c-3.8 10-12 5.9-14.3 3.7-2.3-2-2.9-.8-4 0-1.1 1 5.3 6-6.5 10.8-11.7 4.7-13.7 8.3-15.7 9.5-2 1.2-10 .5-10.8-.6-1-1-.4-1-3.5-2.9-3-1.7-8.2-3.5-13.8-6.2-5.6-2.7-5.4-6.2-5.3-6.9 0-.7 1.9-6.5-4.7-1.9-6.5 4.7-12.1-2.2-12.1-2.2-1.2-1.7-6.8-16.4-6.8-16.4a92.4 92.4 0 0 0-4.3-12s-.4.8 4.5-2c4.8-2.7 7-7.3 8.7-11.9 1.7-4.6 0-12.5-.6-14-.6-1.6-4.2-8.9-8.7-10.4-4.4-1.6-7.5 2.4-7.5 2.4s-1.3-9 6.6-10c0 0 0-1.8.4-3.1 0 0-5.6-3.4-3-9.6 0 0 1.8-4.3 6.8-3.8l-1.1 2.4s-1.2 12.6 17.2 4.2c18.5-8.6 18-10.2 28.7-4.8l7.6-.1s11-5.3 14.7-3c3.5 2.3 16.3 9.4 16.3 9.4s12.4 4.7 14.9-4z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M465.8 255s-.6-3.9-1.2-6.4c0 0-1.5-3.9 1-6.8l2.8-3.3s1.8-2.4 4-2.7c0 0 2.3 0 2.4-.5.3-.5 2.8-4.5 8.6 0 0 0 1.8-3 4.8-3.6 0 0 3-.8 4.5 1.4 0 0 3.5-2.6 6.4 1.7 0 0 4.1-2.4 7.2 2.3 0 0 4-2 6.4 2.1 2.5 4.3 2 6 2 6l2 6.8 6.5 8-15.2 5.8h-7l-13.7 3.6-24.3 1.9-6.7-8 9.6-8.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M445.3 295.5s-3.6.1-5.5 1.2c-1.8.8-3.3 1.8-5.4 3.2 0 0-1 1.3-5.2.5 0 0-7.2-1.7-7.2 4 0 0-8.8.6-5.2 8.3 0 0 2.3 6 7.3 1.8 0 0-3.2 4.5 3 6.3 0 0 4.4 1.2 5.8-3.5 0 0 .7-1.8-1-4 0 0 2.1-.4 3.6-2.7 0 0-4.6 5.8.5 8 0 0 6.3 1.5 6.6-5 0 0-.6-3.2 2-4.3 0 0 5-1.2 7-6.6 0 0-7-3.9-6.3-7.2zM430.6 238s-5.6-2.5-8.4 0c0 0-3.5-2.2-7.5 0 0 0-3.7 2.4-6.3 5.2 0 0-1.8 1.5-1.2 6.4 0 0 1 3.5.5 5.1 0 0-1.2-.2-3.7 2.8 0 0-3.1 3.5-6 .3 0 0 1 4.6 6.1 3.8 0 0-2.5 2-.3 7 0 0 1.6 3.6-1 8.2 0 0 4.5-1.8 4.4-7.2 0 0-.5-3.6 1-6 0 0-1.5 2.2 1.6 7.1 0 0 2.4 3.6.5 7.2 0 0 4.4-1.6 4-7-.4-5.4-3-3.2-1.4-8.2 0 0 .5 2.6 1.8 4a7.2 7.2 0 0 1 2.4 7s2.6-3.4 2-6.8a13.1 13.1 0 0 0-1.3-4.4l8.4-4.8 4.3-7.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M417.8 259.5s-3.5-.2-4-3m-6.1-1.8s1.2 0 2.4 1.2c0 0 .7 1.2 1.9 1"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M423 249.2s-1.8 0-3-.8c0 0-.9-.7-1.5.4 0 0-1 1.6.8 2.3 0 0 2.2 1.2-1.2 3.4 0 0 4-1.6 2.4-3.6 0 0-1.8-1.2-1.2-1.7 0 0 .2-.4 1 0 .6.6 2 .4 2.7 0"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m477.6 259 2.1-.6-14-48h-.4z"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M431.2 312.3s-3.2-1.9-6 .3c0 0 .4-1.2 2.4-1.7 0 0 1.2-3.2 4.3-2.9 0 0-1.3 1.6-3 2.8 0 0 1.8.2 2.4 1.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M419.7 319.8s-5.2-3.2-2.3-8.7c0 0 .8-1.5 2.3-1.2 0 0 3.3 1 .8 5.5 0 0-1.4 2.9-.8 4.5zm10.5 5.3s-7.4-3.4-5.1-9.2c0 0 .7-2 2.4-1.8 0 0 2.8.2 2.3 4 0 0-.9 3.6.4 7z"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M428.7 303.6s-2.3 1.7-3.1 2.8c0 0-1-1.2-2.2-1.8 0 0 1.5-.3 2.2.3 0 0 1.2-1 3-1.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M435.2 323.6s6-1.4 4.8-7.5c0 0-.6-2.6-3-2.2 0 0-3 .8-1 4.6 0 0 1.1 2.6-.8 5.1z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "m461.6 196.7 5.7 1.9s5.4 2.3 12.3 0l5.2-2-3.5 5.4v2.9l2.1 3.2s-1.3.6-5.4-2c0 0-4.4-3.4-9.6 0 0 0-3 2-5.4 2l3.5-3.8-1.3-3.5-3.6-4.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M437.5 316.5s.2-.4 0-.5l-.5.2s-.6 1 0 2.4c0 0 .5.9.3 1.8v.4s.3-.1.3-.4c0 0 .4-.8-.2-1.8 0 0-.6-1.4.1-2.1"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M518 207.7s-4.2 2.2-6-.3c0 0-2.1-4.4 2.9-6 0 0-2.8-3.2.1-6.2 0 0 1.6-1.6 4.2-.5 0 0 1.2-2.3 3.7-2.2 0 0 2.4 0 3 2.5 0 0 3.3-1.2 5 .6 0 0 2.8 3.2-1.2 5.8l-2.9.3-2.9-1.4-3 .9s.8 3.2-3 6.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M484.8 204.4s0 .8-.8 1c0 0-1 .3-1.5-.9v-.3c0-.5-.3-2 1.4-3.3 0 0 2.6-2.1 7.6.5a192 192 0 0 0 14.8 7.5s3.1 1.6 7.9 1.8c0 0 6.5.5 9.3-4.1 0 0 2.1-3.5 0-5.8 0 0-.9-1-2.3-.8a3 3 0 0 0-1.8 1.2s-1 1.4.1 2.5c0 0 1.6 1 2.2-1 0 .2.5 1.7-.4 2.9 0 0-4 6-14.9-.1l-14.3-8.1s-7.1-3.7-11.6 2.1c0 0-3.4 4.8 1.1 7.9 0 0 3.4 2 5.4-1.2 0 0 1.8-3.1-1-4.4 0 0-2.4-1.2-3.3 1.2-1 2.4 1.8 3 2 1.3 0 0 0-.4.3 0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#e4cb5e",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M428 229.2v-9c0-.8 0-1.2 1.2-2.2 1-.8 2.1-2.3 3.7 1.7 0 0 3.2-3.5 4.2-4 0 0 2-1.5 3.3.7 0 0 1.6-2.6 3-3.2 0 0 3.2-2 3.3 4.2l2.5-2.4s2-1.5 4.2.7c0 0 3.5 3.6 4 4.6 0 0 .8 1 1 2.7 0 0 0 2 1 3 0 0 1.1 1 2.2 1.2 0 0 2.5.1 3.6 2.6 0 0 .3-.5 1.6 11.2v21.5l-14.4 17.1-23.1-6.6-9.2-3.9-2.2-6.6 9-5.9 4.8-13-1.5-9.3-2.2-5.2z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m491.6 240.4 1.2-1.5 2.5-2s4 10.4 4.2 12.7v3.2s6 1.6 7.2 10.7l-5 9.2-7.8-4.4-2.3-1.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M418.3 312.4s.2-.3 0-.6l-.5.4s-1.5 1.7-.2 4.4c0 0 0 .4.3.2 0 0 .3 0 0-.3 0 0-1.1-2.4.4-4z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M441.7 310.6s.1-.8-.4-1.6c0 0-.3-.6-.2-1.5m5.6-90.1s0 2.3.7 4c.6 1.6 2.9 4.5 3 5.9"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M501 295.5s3.6.1 5.5 1.2c2 .8 3.4 1.8 5.5 3.2 0 0 1 1.3 5.2.5 0 0 7.2-1.7 7.2 4 0 0 8.7.6 5.2 8.3 0 0-2.4 6-7.4 1.8 0 0 3.2 4.5-3 6.3 0 0-4.4 1.2-5.7-3.5 0 0-.8-1.8 1-4 0 0-2.1-.4-3.5-2.7 0 0 4.5 5.8-.5 8 0 0-6.3 1.5-6.7-5 0 0 .5-3.2-2-4.3 0 0-5-1.2-7.2-6.6 0 0 7.2-3.9 6.5-7.2z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m443.8 227.4 6 47.8m-4.5-47.9 6.6 44.6m-5.5-44.8 7.8 44.2"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m458.6 267.5 2.2-.7-14-48h-.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m450.7 225.3 14.1 35.5m-15-35 13.6 37"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M427.6 321.6s-1.7-1.5-1.4-4.3c0 0 0-.6-.3-.7 0 0-.3-.1-.3.6 0 0-.5 2.9 1.5 4.5 0 0 .1.3.4.2 0 0 .2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m451.5 224.8 14.3 32.4m-18.3-30.4 9 43.7"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M520 259c-6.3-3.6-7.7-11.4-7.7-11.4a24.6 24.6 0 0 1 1.6-14.3c4-8.6 11.1-10.3 11.1-10.3s-6.9 4.8-8.8 11.2c0 0-1.4 5.5-.6 10.7.8 5.5.5 4.1 1.8 8.3l2.6 6z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m492.7 238.7-26.6 8.5-1.4 12c-6.3 9.1-19.2 10.7-19.2 10.7l10 10.7 19 4 10.2-7.8 9.2-8.4c-1-4.5-.5-11.2-.5-11.2 0-1.2.5-3.8.5-3.8s-1.5-10.7-1.2-14.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M465 256.2s17.6-5.5 28-10m-36.4 20s22-4 37.3-12.8l5.6-3.8"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m499.5 252.8-6 4.4s-24.5 11.2-43.2 11.6m43.1-3.6S474.6 275 464 275"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M515.8 238s5.6-2.5 8.4 0c0 0 3.6-2.2 7.6 0 0 0 3.6 2.4 6.2 5.2 0 0 1.8 1.5 1.2 6.4 0 0-1 3.5-.3 5.1 0 0 1.1-.2 3.5 2.8 0 0 3.3 3.5 6 .3 0 0-.8 4.6-6 3.8 0 0 2.4 2 .3 7 0 0-1.6 3.6 1 8.2 0 0-4.6-1.8-4.4-7.2 0 0 .4-3.6-1-6 0 0 1.4 2.2-1.7 7.1 0 0-2.4 3.6-.4 7.2 0 0-4.5-1.6-4-7 .3-5.4 3-3.2 1.3-8.2 0 0-.4 2.6-1.7 4a7.2 7.2 0 0 0-2.4 7s-2.6-3.4-2-6.8c.6-3.5 1.2-4.4 1.2-4.4l-8.3-4.8-4.2-7.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M420.6 268.4s.8-3.7 4.3-2.4c0 0 1.2-6 7.7-6.2 6.5-.2 6.8 6.4 6.8 6.8 0 0 2-2.8 5.1-2.5 0 0 5.5-.3 3.6 8.5l1 1.2s4.1-9.9 12.7-7.4c0 0 8.4 2.6 3 10.7 0 0 4.2 5.5 7.6 5 3.6-.5 6.7-1.6 10.2-7.8 3.6-6.2 11.7-7.2 13.7-6.8 2 .3 3.7 1.8 4 3.2 0 0 4.3-14.3 19.8-12.2l6.2 3.3 2.4 1-3.6 10-8.4 19.2-6.6 2-6.8-3.9-2.4 1.2v5.9l-9 6.4-6.2 2.5-6.8 4.8-1.7 4.2s-3.7-1.7-8 0l-1.4-3.6-4-3.7-15.6-7.4-2.7-9-2.9-1.3-3.2 3.6-4.5.6-7-4.8-7.4-21z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M488.2 198s-6-.2-5.7 6"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M527 263.3c-10.2-3.2-13-14.3-13-14.3a25.5 25.5 0 0 1 1.2-15.5c4.8-11 12.7-11 12.7-11a4 4 0 0 1 4.5 3.2c.4 2.4-1.3 3.3-1.3 3.3-2.7 1.5-4.5-.5-4.5-.5-1.2-1.6-.3-2.9-.3-2.9.7-1 2-.4 2-.4 1.3.2 1 1.6 1 1.6s.4-1.6-1.2-1.8c0 0-3.2-.7-6.8 3.8 0 0-4.7 6.1-4.7 14.1 0 0-.6 14.8 14.7 18.6 0 0-1.6 2.4-4.6 11.1 0 0-3.3 11.2-6.4 17.3 0 0-4.3 8.6-13.9 5.1 0 0-5.6-2.5-5.6-6.5 0 0-.3-3.8 3-4 0 0 3.3-.3 3.3 2.5 0 0 0 3-3.5 2.4 0 0-1.2-.3-1.1-1.5 0 0 .2-1.2 1.8-.6 1.5.6 0 0 0-.1 0 0-.6-.3-1.2 0 0 0-.6 0-.6 1 0 0 0 .6.7 1.1l1.7.2s1 2 3 2.7a8 8 0 0 0 7.1-1.2 10.7 10.7 0 0 0 3-4.3 113.3 113.3 0 0 0 5.2-13.5s1.8-5.7 3.4-8.7z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M498 291.4s2-.2 2 1.5c0 0-.1 2.4-3.2 1.9 0 0-3-.6-2-4 0 0 .8-2.3 3.6-2 0 0 2.8 0 4 3.8 0 0 1 3.3-.7 6-1.8 3-6.2 5-8.4 6 0 0-8.7 3.3-11.3 5.3 0 0-4 2.9-2.2 5.6 0 0 .7 1.1 1.7 1.1 0 0 1.2 0 1.3-1.2 0 0 0 .7-.7 1 0 0-.8.4-1.7-.3 0 0-1-1-.2-2.4 0 0 1-1.6 3.6-.6 0 0 2 1.1 1.2 3.3 0 0-.9 2.1-3.4 2 0 0-1.9 0-3.2-1.2-2-2.1-2-6-.2-8 0 0 1.5-2.1 4.7-3.6l9-3.5c2.6-1.1 4.9-2.3 6.4-4.1 0 0 1.3-1.4 1.8-4 0 0 .4-2-.8-2.4l-1.2-.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M498.2 291.4s2.1-.4 3.5 2.2c0 0 .7 1.5.8 2.5m.7-9s-2.1.3-1 3.4c1.1 2.9 3 3.7 3.5 4.2"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M461.6 204.4s0 .8 1 1c0 0 .8.2 1.3-.9v-.3c0-.5.3-2-1.2-3.3 0 0-2.8-2.1-7.8.5 0 0-4 2-6.7 3.6 0 0-7.1 3.8-8 4 0 0-3.2 1.6-8 1.8 0 0-6.5.5-9.2-4.1 0 0-2.2-3.5 0-5.8 0 0 .8-1 2.2-.8.6.1 1.2.4 1.8 1.2 0 0 1 1.4-.1 2.5 0 0-1.6 1-2.2-1 0 .2-.3 1.6.5 3 0 0 4 5.9 14.8-.3l14.3-8s7.2-3.7 11.6 2c0 0 3.4 4.8-1 8 0 0-3.3 2-5.5-1.2 0 0-1.6-3 1-4.4 0 0 2.4-1.2 3.5 1.2 1 2.4-2 3-2.2 1.3 0 0 0-.4-.1 0zm-35.2 54.7c6.3-3.5 7.8-11.5 7.8-11.5 1.4-8-1.7-14.3-1.7-14.3-4-8.6-11-10.3-11-10.3s6.8 4.8 8.7 11.2c0 0 1.6 5.5.6 10.7-.8 5.5-.5 4.1-1.8 8.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M458.4 198s6-.2 5.6 6"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M419.3 263.3c10.3-3.2 13-14.3 13-14.3a25.5 25.5 0 0 0-1.1-15.5c-4.8-11-12.7-11-12.7-11a4 4 0 0 0-4.5 3.2c-.3 2.4 1.3 3.3 1.3 3.3 2.8 1.5 4.6-.5 4.6-.5 1.1-1.6.2-2.9.2-2.9-.7-1-2-.4-2-.4-1.2.2-1 1.6-1 1.6s-.3-1.6 1.2-1.8c0 0 3.2-.7 6.8 3.8 0 0 4.8 6.1 4.8 14.1 0 0 .6 14.8-14.8 18.6 0 0 1.7 2.4 4.6 11.1 0 0 3.4 11.2 6.6 17.3 0 0 4.2 8.6 13.7 5.1 0 0 5.6-2.5 5.6-6.5 0 0 .4-3.8-3-4 0 0-3.3-.3-3.3 2.5 0 0 0 3 3.6 2.4 0 0 1.2-.3 1-1.5 0 0-.2-1.2-1.7-.6-1.6.6 0 0 0-.1 0 0 .5-.3 1.1 0 0 0 .6 0 .6 1 0 0 0 .6-.7 1.1l-1.5.2s-1 2-3.2 2.7a7.5 7.5 0 0 1-7-1.2 10.7 10.7 0 0 1-3-4.3 113.5 113.5 0 0 1-5.3-13.5s-1.8-5.7-3.2-8.7l-.6-1.2z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M448.5 291.4s-2-.2-2 1.5c0 0 0 2.4 3.2 1.9 0 0 3-.6 1.9-4 0 0-.7-2.3-3.6-2 0 0-2.7 0-4 3.8 0 0-.9 3.3.8 6 1.8 3 6.2 5 8.3 6 0 0 8.7 3.3 11.4 5.3 0 0 3.9 2.9 2.1 5.6 0 0-.6 1.1-1.7 1.1 0 0-1.2 0-1.3-1.2 0 0 0 .7.7 1 0 0 .9.4 1.7-.3 0 0 1-1 .2-2.4 0 0-1-1.6-3.4-.6 0 0-2.2 1.1-1.2 3.3 0 0 .7 2.1 3.2 2 0 0 2 0 3.2-1.2 2-2.1 2-6 .4-8 0 0-1.7-2.1-4.8-3.6-1.9-.6-5.5-2.1-9-3.5-2.7-1.1-5-2.3-6.5-4.1 0 0-1.3-1.4-1.8-4 0 0-.3-2 .9-2.4l1.2-.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M448.2 291.4s-2.1-.4-3.4 2.2c0 0-.7 1.5-.9 2.5m-.7-9s2.2.3 1.1 3.4c-1.2 2.9-3 3.7-3.6 4.2m27.4-91.1s5.2-3.3 10.4.3m-39.7 31.3s.7-3-2.6-8c0 0-2.2-4.7-3.2-7.5m7.4-3.3 2.3 6.6 3 6.8"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M441.2 238.3s2 2.1 1.8 5.6m-8.1-7.9s2.1 1 1.9 6.8c0 0-.1 4 3 6.2m-5.3 1.4s6.7-.7 7.2 3.5c0 0 0 4 2.4 4.3 0 0 3.3.3 4 3.6m-11.4-6.8s1.2 1.7 2.4 2.6m6.2-7s1.6 2.7 2 4.1m5.3-35s1.6 2.1 3.1 3m3.1 9.6s3.4 1.6 3 10c0 0-.6 5 .9 7.7"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m443.1 226.6.4.8s6 .3 9.1-3.8l-.3-.8s-5.3-.3-9 3.8z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M464.7 258.5s20.6-6 28.6-9.6"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m462.5 220.5-.2-.6 10.1-4 .3.8z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m463.4 220.1 6.8 33.3m-5.6-33.6 7.7 33m-6.4-33.6 8.4 32.9m-5-34.1 11.5 24.6m-10-25 12.3 24.2M471.8 217l13.4 24.3m-15.5 12.4 5.2-1.6m-9.1-1.6s15.2-4.5 27-9.2M465.4 252s19.5-5 27.2-8.8m-21.2 24.6 1 3.3 2.8-1-1-3.1m5-1.3 1 3 2.8-.9-1-3m-16-17.6-.2-4.2 25.5-7.7 1.3 3.6m-16 .8 1.3 3.8m7.6-6.4 1.6 3.6m.5-4.3 1.6 3.3m.4-4 1.6 3.6m0-4 2.8-1.6 1.2 3.1m-2.6-2.3 1.4 3.3"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M429.5 283.1s-5-5.1 0-10c0 0-5.5-2.6-4.6-7m13.6 21s-5.3.7-3.7-9.4c0 0-2.2 4-2.9 6a4.7 4.7 0 0 0 2 5.4c.9.6 5.5 1.8 7-1.2m-8.3-16.2s-2.1 1.9-.6 5.4m2.8-5s.2 3.5 2 5.4m-.5-6.7s0 4 2.9 6.6m-1.5-8s0 4.5 3.4 7.4m13.5-.7s1.6-3.9 5.2-3.6c0 0-1.7.8-1.7 2.5 0 0-.2 3 2.9 3.2 0 0 2.5.4 3.8-1"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M463.1 293.1s-8.9-4.2-8-10.1c0 0 .4-3.6 4-5.4m-2 3.8s-.8 2.5 1 4.3m1.1-6s-1.2 2.8.7 4.8m1.5-6.3s-1.4 2.4.2 4.5m-8.4 11s4.8 4.3 8.6 4.3m-10.1-2.9s4.5 3.6 7.4 4.2m-9-3.2s5.5 4.9 9 5.2m13.7 4.6s-5.5 3-1.2 6.2m-2.4-9.4 9-4.6m-6.7 6.2s9-5.5 11.7-6.7m-7 7.2s7.7-5.2 11.9-7.5m-6.8 7.1s5.3-4 10.5-7.1m1.7-5.1s-2.6-3.9-11.2 0c0 0 3.3-2.9 9.5-5.2m8.5-16.3s.8 3.1 0 5"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M486.5 285.7s1.8-2.6 6.3-4c0 0 1.2 3 4.8 2.5 0 0 5.2-1.1 3.6-7 0 0-1.1-4.2-7.2-4.7m18.1-7.3s6.1 1.2 6 6.1c0 0 .6 7.6-7.4 9m6.6-12s1.6-3.7 5.5-5.2m-4.6-2.2s1.7 2.8 2.8 3.1m-3.6-1s1.5 2.1 2 2.5m-2.6-.5a8 8 0 0 0 1.5 1.6M485 235.8s1.2-2 4.3-1.2m12.1 15.8s2-7.8 8.5-5m-2.6-.6s.6-3.6-1-5.5m-3.6 5.2s.9 1.5.1 2.7"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M516.2 325s7.4-3.3 5.1-9.1c0 0-.7-2-2.4-1.8 0 0-2.8.1-2.3 4 0 0 1 3.8-.5 7z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M518.8 321.6s1.7-1.5 1.5-4.3c0 0-.2-.6 0-.7 0 0 .4-.1.4.6 0 0 .5 2.9-1.4 4.5 0 0-.1.3-.4.2 0 0-.2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M526.7 319.8s5.2-3.2 2.4-8.7c0 0-.9-1.5-2.4-1.2 0 0-3.2 1-.7 5.5 0 0 1.2 2.9.7 4.5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M528 312.4s-.2-.3 0-.6l.4.4s1.5 1.7.3 4.4c0 0-.1.4-.5.2v-.3s1.2-2.4-.2-4z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M511 323.6s-5.8-1.4-4.7-7.5c0 0 .6-2.6 3.1-2.2 0 0 3 .8 1 4.6 0 0-1.1 2.6.7 5.1z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M508.8 316.5v-.5s.4 0 .5.2c0 0 .6 1 .1 2.4 0 0-.5.9-.2 1.8 0 0 0 .3-.3.4l-.2-.4s-.3-.8.2-1.8c0 0 .6-1.4 0-2.1z"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M515.2 312.3s3.4-1.9 6 .3c0 0-.2-1.2-2.4-1.7 0 0-1-3.2-4.2-2.9 0 0 1.2 1.6 3 2.8 0 0-1.8.2-2.4 1.5m2.4-8.7s2.4 1.7 3.2 2.8c0 0 .9-1.2 2-1.8 0 0-1.2-.3-2 .3 0 0-1.1-1-3-1.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M504.8 310.6s-.3-.8.3-1.6c0 0 .4-.6.2-1.5m23.4-48s3.5-.2 4-3m6-1.8s-1.2 0-2.2 1.2c0 0-.9 1.2-2 1"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M523.6 249.2s1.8 0 2.7-.8c0 0 1.1-.7 1.7.4 0 0 1 1.6-.8 2.3 0 0-2.2 1.2 1.3 3.4 0 0-4.2-1.6-2.4-3.6 0 0 1.8-1.2 1-1.7 0 0-.2-.4-.9 0-.7.6-2.1.4-2.6 0"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M526 205.6s.8-1.2.5-4.4c-.4-3.2 2.6-3.7 3.6-2.8 0 0 1.2 1 0 3.1a8.3 8.3 0 0 1-4.1 4.1z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M527 203s1.2-1.1.6-3.6l.2-.2h.3s.6 2.8-.6 4.2c0 0-.2.3-.5 0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M525.1 204.4s0-1.4-2.3-3.6c-2.4-2.4-.5-4.4 1-4.4 0 0 1.3 0 2 2.3a8.3 8.3 0 0 1-.7 5.7z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M524.8 201.4s0-1.6-2.2-3.3v-.4h.4s2.3 1.8 2.3 3.8c0 0 0 .3-.3.3 0 0-.2 0-.2-.4"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M522 203.3s-.7-1-3.5-2.1c-2.9-1-2.2-3.5-1-4 0 0 1.3-.5 2.6 1.1a7.6 7.6 0 0 1 1.8 5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M520.6 201.3s-.6-1.4-3.2-2.1c0 0-.2 0-.2-.3 0 0 0-.2.3-.1 0 0 2.9.6 3.7 2.4l-.1.3s-.3 0-.4-.2z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M523.7 204.4s-1.3.5-4.4-1c-3.1-1.5-4.4 1.1-3.8 2.3 0 0 .5 1.6 2.8 1.2a8.3 8.3 0 0 0 5.4-2.4z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M516.6 205.4s1.4 1 3.9 0h.3s0 .2-.2.3c0 0-2.6 1.2-4.4.1 0 0-.2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M519.3 194.7s1.4.8 1.2 2.5"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M526 195s.6 1.9 0 3"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M420.2 205.6s-.8-1.2-.5-4.4c.4-3.4-2.5-3.7-3.5-2.8 0 0-1.2 1-.2 3.1a8.3 8.3 0 0 0 4.2 4.1z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M419.1 203s-1-1.1-.6-3.6v-.2h-.4s-.5 2.8.7 4.2c0 0 .2.3.3 0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M421.2 204.4s0-1.4 2.4-3.6c2.3-2.4.4-4.4-1-4.4 0 0-1.6 0-2 2.3a8.3 8.3 0 0 0 .6 5.7z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M421.5 201.4s0-1.6 2-3.3c0 0 .3-.3 0-.4h-.2s-2.4 1.8-2.4 3.8c0 0 0 .3.4.3 0 0 .2 0 .2-.4"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M424.3 203.3s.6-1 3.5-2.1c2.8-1 2-3.5.9-4 0 0-1.2-.5-2.6 1.1a7.6 7.6 0 0 0-1.8 5z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M425.6 201.3s.6-1.4 3.2-2.1c0 0 .2 0 .2-.3 0 0 0-.2-.2-.1 0 0-2.9.6-3.7 2.4v.3s.4 0 .5-.2"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M422.5 204.4s1.4.5 4.4-1c3-1.5 4.4 1.1 4 2.3 0 0-.7 1.6-3 1.2a8.3 8.3 0 0 1-5.4-2.4z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M429.6 205.4s-1.3 1-3.9 0h-.2v.3s2.8 1.2 4.5.1c0 0 .2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M427 194.7s-1.5.8-1.2 2.5"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M420.2 195s-.6 1.9 0 3"
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M486.7 177.6s1 2.7.6 5.2c-.3 2.4.2 2.9 1 3.4.7.3 2.4-.4 2.5-2.2 0 0 2 3.8-1.8 6.3 0 0-2.7 1.7-5-.4-.8-.9-1.2-3-.7-5 0 0 .6-2.7-.5-5.5 0 0 1.6 1.6 1.2 4.9 0 0-.8 6 3.6 5.6 0 0 3 0 3-3.6 0 0-1.1 1.2-2.4.8a2.4 2.4 0 0 1-1.8-2.8c.1-1.6.6-4.3.3-6.7M482 187s-.4 4.8-4.6 5.9c0 0 .6-.9-.3-3.3 0 0-1-1.2-1-3.3 0 0-1.2 1 .3 3.8 1 1.7 0 3.6-.1 3.7-.4.1 6.9-1 5.6-6.7zm-5.6-4.5s-1.1-1.2-1.2-3.8c0-2.7-.5-3.4-.9-3.6 0 0 .5 2.3.4 3.6a7 7 0 0 0 .4 3s-2.4.3-3.9-3c-1.3-3.3-2.7-3-3.4-3 0 0 .8.1 2.4 3 1.6 3 2.1 3.7 6.2 3.7zm-10.8-7s1.2 3.2 1.4 4.8c0 0-3.1-1-4-3.5 0 0-3.2 1-2 4.7 0 0-2.9-1-4.2-3.2 0 0 1.6 1.2 3.1 1.7 0 0-.2-3.1 3.6-4.2 0 0 .6 2.7 2.6 3.3zm5-5.4s1.2 1.5 3.4 1.5a3.6 3.6 0 0 0 3.2-1.5s-.1 2.6-3.2 2.7c0 0-3.3 0-3.3-2.7zm-13.4 18.5 2 1.9s1.2 1.2 2-.3c0 0 1.3-2.4 2.9-2.2 0 0-1.2.7-2.4 3 0 0-.2.7-1.2.8-.5 0-1 .2-1.8-.7 0 0-.7-.9-1.5-2.4zm16.7-29.4c-3.2 0-.5 2.4-.5 2.4 0 4-3.1 5.4-5.3 4.2-2.2-1.2-.4-4-.4-4s-2.4 1.5-1 3.9c1.6 2.4 5.7 1.2 7.2-.9 1.5 2.2 5.7 3.3 7.1.9 1.7-2.4-.8-4-.8-4s1.8 2.9-.5 4c-2.1 1.3-5.4 0-5.2-4 0 0 2.7-2.5-.5-2.5zm2-4.4s1.2 2 1 5c0 0 .9-3-1-4.9zm-10 4.7s-.3-2.2-2.4-2.4c0 0 1.9 1.3 2.4 2.4m16 0s.3-2.2 2.5-2.4c0 0-1.8 1.3-2.4 2.4zm-19.2 3.2s1.6.5 2.6-.7zm-5.4-13.1s1.9-.1 3.8 2.7c0 0-1.9 1-2.4 1.6 0 0 0-1 1-1.7 0 0-.4-1.4-2.4-2.5zm32 0s-2-.1-3.9 2.7c0 0 2 1 2.4 1.6 0 0 0-1-1-1.7 0 0 .4-1.4 2.5-2.5zm-14.7 2.2s1.7.5 3.8-.7c0 0 2.6-1.4 4.3 0 0 0-1.4-.7-4.3.7 0 0-2.7 1.6-3.8 0"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M476.4 153.6s1.4-2.5 6-2c0 0-1.3 3.6-6 2"
    }),
    /* @__PURE__ */ jsx44("ellipse", {
      cx: 479.4,
      cy: 152.8,
      fill: "#784421",
      rx: 0.8,
      ry: 1.1
    }),
    /* @__PURE__ */ jsx44("ellipse", {
      cx: 479.4,
      cy: 152.8,
      rx: 0.5,
      ry: 0.7
    }),
    /* @__PURE__ */ jsx44("path", {
      d: "M466.8 148.1s2.8.3 4.6 1.2c0 0 1.8 1.2 3.8-.3 0 0 2.2-1.4 3.7-3.1 0 0-3.5 2.3-4.8 2.7 0 0-1.2-1-1.5-2.3 0 0 0-1 2-2.7 0 0-2.5.8-3 2.9a7.2 7.2 0 0 0 1.4 2.3s-.4.3-1.6-.6c0 0-2.8-.8-4.6 0zm7.2 17c-2.4 2.1 0 1.9 0 1.9s2.4.2 0-2zm-1.4-13.2s-1.8.5-4-.7c0 0-2.6-1.4-4.3 0 0 0 1.5-.7 4.3.7 0 0 2.9 1.6 4 0"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M470.8 153.6s-1.5-2.5-6-2c0 0 1.2 3.6 6 2"
    }),
    /* @__PURE__ */ jsx44("ellipse", {
      cx: 467.7,
      cy: 152.8,
      fill: "#784421",
      rx: 0.8,
      ry: 1.1
    }),
    /* @__PURE__ */ jsx44("ellipse", {
      cx: 467.7,
      cy: 152.8,
      rx: 0.5,
      ry: 0.7
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M560 130.6v161.6c0 43.1-86.2 57.2-86.2 57.2s-86.4-14-86.4-57.2V130.6z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#006",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Bm_default = SvgBm;

// src/country-flag-icons/generated/Bn.tsx
import { jsx as jsx45, jsxs as jsxs38 } from "react/jsx-runtime";
var SvgBn = (props) => /* @__PURE__ */ jsxs38("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx45("path", {
      fill: "#f7e017",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx45("path", {
      fill: "#fff",
      d: "M0 33.3v213.4l640 100V233.3z"
    }),
    /* @__PURE__ */ jsx45("path", {
      fill: "#000001",
      d: "M0 146.7v100l640 200v-100z"
    }),
    /* @__PURE__ */ jsxs38("g", {
      fill: "#cf1126",
      transform: "translate(-160) scale(.66667)",
      children: [
        /* @__PURE__ */ jsx45("path", {
          d: "M695.7 569.7a117.2 117.2 0 0 1-49.4-17.2c-2.4-1.6-4.6-3-5-3-.4 0-.6 1.9-.6 4.1 0 6.4-2.6 9.6-9 11.3-6.2 1.6-15.6-1.6-23.2-8a68.3 68.3 0 0 0-24.7-13.5 39.9 39.9 0 0 0-28 3.6 8.7 8.7 0 0 1-2.8 1.3c-1.1 0-1-6.9.2-9 1.5-3 5.1-5.8 9.4-7.3 2.2-.8 4-1.8 4-2.3 0-.4-.8-2-1.7-3.6-2.9-5.1-1.7-10 3.4-13.9 5.2-4 14-4.6 21.7-1.7a32 32 0 0 0 4 1.4c1 0 .4-1.5-2.4-5.6-3.2-4.7-3.9-7-3.5-12.7a14.7 14.7 0 0 1 13.5-13.5c5.8-.4 9.4 1.6 18 9.7a144 144 0 0 0 86 41.6c8.3 1 24.8.5 34.5-1a156 156 0 0 0 81.8-40.8c6.4-6 9.4-7.6 14.7-7.6 4.5 0 7.7 1.4 11 5 3 3.3 4 6.4 3.6 11.5-.2 3.2-.7 4.7-2.6 7.9-2.8 4.5-2.3 5 3.2 2.8 7.6-3 16.9-1.6 21.9 3.2 4.4 4.2 4.8 8.4 1.4 14-1.3 2.1-2.3 4-2.3 4.4 0 .6 1 .8 5.5 1.6 6 1 9.5 5.4 9.5 12.2 0 2-.3 3.7-.6 3.7s-2.6-.9-5-1.9c-7-2.9-11-3.6-19.2-3.5-6.2 0-8.3.3-12.6 1.7a57.5 57.5 0 0 0-19.5 11.5c-6.4 5.7-10.4 7.5-16.6 7.4-5.8 0-9.7-1.7-11.8-5-1.1-1.8-1.3-2.8-1-6.8.2-2.6.1-4.7 0-4.7-.3 0-2.5 1.4-5 3.1A80.5 80.5 0 0 1 778 560a181.6 181.6 0 0 1-82.3 9.7"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M706.3 525.2a136.4 136.4 0 0 1-97.9-55.7c-24.4-33.2-32-77.1-24.6-117.2 4-18.3 12-36.6 25.5-49.6a114.6 114.6 0 0 0-8.7 74.3c9 49.8 51 91.9 101.3 99.2 20 5.7 40.5-.4 59.5-6.5 42-14.8 74-54.6 77.8-99.1 3.3-24-.3-49.1-11.2-71 6.2 3.3 14 16.2 18.6 24.8 16 31 16.7 68.1 7.3 101.2-12.8 42.1-45 79-87.5 92.4a165.7 165.7 0 0 1-60 7.2z"
        }),
        /* @__PURE__ */ jsxs38("g", {
          id: "bn_svg__a",
          children: [
            /* @__PURE__ */ jsx45("path", {
              d: "M512 469.9c-2.5-.4-5.3 2.1-4.3 4.7 1.8 2.6 5 4 7.8 5.2a54.2 54.2 0 0 0 23.2 3.6 49.6 49.6 0 0 0 17-3c3-1 6.8-2 8-5.4 1.3-2.1-1-4.3-3.1-3.9-3 .7-6 2-9 2.9a57.7 57.7 0 0 1-20.3 2 54 54 0 0 1-14.4-4.2c-1.6-.7-3.1-1.7-4.9-1.9"
            }),
            /* @__PURE__ */ jsx45("path", {
              d: "M514.8 459.5c-2.5-.4-4.7 2.6-3.7 5 2 2.8 5.3 4.3 8.4 5.6a42.4 42.4 0 0 0 17 2.9h1.5a37.6 37.6 0 0 0 14.4-2.8c2.7-1.1 6.1-2.2 7.3-5.2.9-1.7.2-4.1-2-4.3-1.8 0-3.5 1.2-5.3 1.7a44.3 44.3 0 0 1-20.6 3.2c-4.4-.5-8.5-2.1-12.5-4-1.5-.7-2.8-1.8-4.5-2z"
            }),
            /* @__PURE__ */ jsx45("path", {
              d: "M518.3 449.6c-2.2-.3-3.7 2.2-3.3 4.1.3 1.8 1.8 3 3.1 4a30 30 0 0 0 18.6 5.3h1.6a28 28 0 0 0 12-2.8c2.5-1 5.4-2.3 6.3-5.2.4-1.3.6-3.2-.9-4-1.6-.8-3.1.5-4.5 1a34 34 0 0 1-15.5 3.9 27 27 0 0 1-13.1-4c-1.5-.7-2.7-2-4.3-2.3"
            }),
            /* @__PURE__ */ jsx45("path", {
              d: "M481.5 302.7c-3.2 3.3-.7 9.3-1 13.5 1.8 13.2 3.9 26.5 8.8 39 6 12 18.8 18.5 26.5 29.2 2.8 5.1 1.8 11.3 2.4 17 .4 15.3.3 30.7 0 46 7 3.6 14.5 7 22.5 5.7 4.7-1.1 13.5-1.8 14.5-6.5l-1-79.5c-2.7-8.1-11-12.3-17.1-17.5a155.5 155.5 0 0 1-14.2-16.1c-2.6-4.5-12.9-6-9.2 1.6 2.2 6.7 7.7 11.6 9.1 18.6.3 3.9 5 11 1 13.2a24.5 24.5 0 0 0-10.7-10c-4.4-3.3-11.7-4.7-13.3-10.5a42.9 42.9 0 0 0-11-22c1.5-7.4 0-16.7-6.4-21.5z"
            }),
            /* @__PURE__ */ jsx45("path", {
              d: "M491.4 304.2c-3 .5-2.8 4.2-1.5 6.2a27.2 27.2 0 0 1 1.1 13.4 44.1 44.1 0 0 1 10.6 21.7c0 3 3.2 4 5.3 5.5 4.9 3.1 10.3 5.4 14.7 9.3.9 1 1.6 2 1 0-.7-2.6-1-5.4-3-7.3-2.8-3-6.2-5.6-10.2-6.4-.3-4.2-2.3-8-4.1-11.6-2-3.5-4.1-7.2-7.5-9.4 0-6.1 0-12.5-2.6-18.2-.8-1.4-2-3.1-3.8-3.2"
            }),
            /* @__PURE__ */ jsx45("path", {
              d: "M499.7 306.6c-2 .6-1.6 3.2-1 4.7a54 54 0 0 1 1 13.2c3.9 3 6.2 7.4 8.4 11.6 1.4 2.8 2.6 5.8 3.1 8.9 3.1 1 5.8 3 8.2 5-1-2.8-3-5-4.5-7.7s-3-5.6-3.7-8.7c-3-3.1-4.6-7.6-4-12 .2-4.7-1.3-9.6-4.5-13.2-.8-.8-1.8-1.7-3-1.8"
            }),
            /* @__PURE__ */ jsx45("path", {
              d: "M509.2 308c-1.2.2-1.8 1.2-2.4 2.1-.3.9.8 1.8 1 2.8a21.8 21.8 0 0 1 1.4 10.4c-.1 2.5.8 5 2 7a3.9 3.9 0 0 1 3.5-2.8c.5 0 1.4.2 1-.7-.4-4.8-1.1-9.6-2.8-14a9.6 9.6 0 0 0-2.8-4.5c-.2-.2-.6-.4-1-.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx45("use", {
          xlinkHref: "#bn_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1440 0)"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M715.7 476a35.6 35.6 0 0 1-29.9-24c.3-2.2 3 1.2 4.3 1.5a19 19 0 0 0 8 2.6c3.5 1.5 5.7 5 9.1 6.9 1.6 1.2 7.2 3.6 6.1-.3-1.3-2-2.2-4.6-1-7 1.8-4.1 4.7-7.7 7.7-11.2 2.1-.7 3.6 3.6 5.1 5 2.1 3.3 4.7 7.3 3.4 11.3-1.2 1.5-2 6 1.3 4.6 4-1.8 7.3-4.8 10.6-7.6 3-2 6.7-2.1 9.7-4 1.5-.3 4.4-3.1 5-1.6a44.9 44.9 0 0 1-7.4 12.3 32.1 32.1 0 0 1-18.8 10.9c-4.4.8-8.8 1-13.2.6"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M731.5 460.2c.3-2.7-.3-5.4-1.7-8-2.1-4.2-5-8-8-11.9-2.8-1.6-4.3 3.7-6.1 5.2-2.9 4.3-6.5 8.7-6.7 14-1.6 2.5-4.6-2-5.9-3.5a19 19 0 0 1-4-12 50.8 50.8 0 0 1 3.6-20.6c2-5.6 5.1-11 4.8-17 .2-4.7-.7-9.7-4.4-12.8-3.6-2.8 2.3-3.4 4.1-2 3.2.3 4.9 5.5 7.8 4.2 1.1-2.7 1.4-6 3.8-8.1 2.3-3.2 4.7 1.3 5.5 3.5 1.7 1.8 0 6.5 2.6 6.6 3.2-2.3 5.5-6 9.6-6.9 1.7-1 4.5 0 2.3 1.8-3 2.9-5.6 6.4-6.2 10.7-.9 5.3.4 10.7 2.7 15.4 4.5 9.4 8 20 5.7 30.5-1 4.6-4.2 8.6-8 11.3-.5.3-1.3.3-1.5-.4"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M726.7 389.6a21.2 21.2 0 0 0-5.6-7c-2.4 0-3.9 3-5.5 4.6-1.1 2.1-2.5 5.6-5.3 2.9-4.5-2.6-5.2-8.3-5.2-13-.3-7.6 2.8-14.7 5.5-21.6 1.7-4.3 1.3-9.2.2-13.6-1.3-5-5.4-8.6-8.5-12.6.2-1.5 4.2-.7 5.7-.4 3.4.9 5.4 3.8 7.9 6 1.8-.6 1-4.2 1.9-5.9 0-2.4 3.2-5.5 4.5-2.1 2 2.2 0 6.5 2.5 7.8 2.4-.9 3.6-3.5 5.8-4.7a8 8 0 0 1 7.8-.5c.9 2.2-2.6 4-3.6 6a20.4 20.4 0 0 0-3.8 18c1.4 5 3.8 9.5 4.7 14.5a40.1 40.1 0 0 1-.5 17.2c-.9 3.4-3.8 5.6-6.8 7-.8-.7-1.2-1.7-1.7-2.6"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M711.6 326.9c-3.4-2.5-4.5-4.8-4.5-9.5 0-2.3.5-3.6 2-5.8 2.4-3.2 2-4.2-1.3-3.3-5.3 1.5-7.8.2-8-4.3 0-2.2.4-3.1 3.3-6.7 2.4-2.8 3.3-4.3 2.8-4.8-.5-.4-3.3 2-9 7.8a124 124 0 0 1-11.4 10.6c-9.8 6.6-19.2 7.6-23.5 2.5-2.2-2.6-2.1-4 .4-5.6a27.4 27.4 0 0 0 4.4-3.7 86 86 0 0 1 16.1-11.6c3.6-1.8 4.4-3 2.1-3-3 0-12.5 6.2-19.8 12.8-2.1 2-5.2 4.2-6.8 5a25.4 25.4 0 0 1-13.9 1c-2.2-.7-6.3-4.5-6.3-5.9 0-.3 1-1.1 2-1.8a30 30 0 0 0 4.6-3.2c5.8-5 16.8-10.3 25.5-12.2 2.8-.5 1.7-2-1.4-1.8a56 56 0 0 0-25 11.7c-8.3 6.9-20.8 6.2-24.8-1.3-.7-1.3-1.2-2.5-1-2.7a92.8 92.8 0 0 0 20.4-7.8 51.5 51.5 0 0 1 18.1-6.5c2.8-.5 3-1.9.3-2.2-3.6-.4-9 1.4-18.5 6-12.3 6.1-15.8 7.2-22.2 6.8-6-.4-9.3-1.9-14-6.4-3.2-3-7.6-10.5-6.8-11.4a63.5 63.5 0 0 0 15.8 1.3c8.3 0 10.6-.2 15-1.5a84.3 84.3 0 0 0 24-12.1 57.5 57.5 0 0 1 36.8-13.6c12.4 0 20.2 2.8 27.2 9.9 2.4 2.4 4.4 3.9 4.7 3.6.3-.3.6-4.5.7-9.3 0 0 3.7-.4 4.5.7 0 7.7 0 8.4 1.2 8.4.7 0 1.5-.8 2-2 1-2.5 5-6 9.2-8.2 9-4.5 24.7-4.7 37.3-.3a62.4 62.4 0 0 1 16.7 9.5 90.2 90.2 0 0 0 24 12c6.8 2 19 2.5 25.1 1a61.9 61.9 0 0 1 5.4-1c2.3 0-1.6 7.6-6.2 12.1-8.4 8.2-19.3 8.1-34.6-.1-9.6-5.2-21-8-21-5.2 0 .6.6 1 1.5 1 3.3 0 9.7 2.2 18.7 6.5a53.7 53.7 0 0 0 18.3 6.5c2.3 0 2.4 1.5.2 4.7-2.3 3.4-6.2 5-11.7 5-5.3 0-8.3-1.1-13-5-8-6.6-27.6-14-26.9-10 .2.7 1.1 1.2 3.2 1.5a56 56 0 0 1 23.1 11l5.9 4.3c1.1.6 1.1.8.2 2.5-1.4 2.8-5.2 4.9-9.2 5.3-5.2.6-9.8-1-14.5-5-10-8.3-19.3-14.3-22.3-14.3-2.5 0-1.4 1.4 3 3.7a79.7 79.7 0 0 1 15.8 11c2 1.9 4.3 3.7 5 4.1 1.9 1 1.8 2.4-.2 5s-5.4 3.8-9.7 3.3c-8.6-.9-15.4-5-26-16a70.7 70.7 0 0 0-8.2-7.8c-1.4 0-.5 1.9 2.2 5 3.4 3.7 4 5.8 2.7 9-1.1 2.6-3 3.3-6.8 2.2-4-1-4.6 0-2 3.1 3.8 4.9 3.3 10.7-1.5 14.8a12 12 0 0 1-3.4 2.3c-.4 0-1.4-1-2.3-2.4-3-4.6-5.7-4.6-8.7 0a53.6 53.6 0 0 1-2 3 113.1 113.1 0 0 1-3-2.2"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "m726.7 233-5.2 4-4.6-3.4v27.8h9.8z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M694.9 204.3a88.3 88.3 0 0 1-9 32.3l11.1-10.3 7.7 9.2 8.4-9.4 8.5 8 8.2-8.3 8.5 10 7.4-8.2 12.6 9c-4.6-10-10.7-18.6-10-32.8-12.1 9-41 10.6-53.4.4z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M717 197.6c-4.5 0-9.2.1-13.4 1a20.1 20.1 0 0 0-7.8 3c.3 8.6 41 12.1 51.9.2a20 20 0 0 0-8.2-3.3c-4-.8-8.6-.8-12.9-1v7.1H717z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M724.9 154h-6.3v49.4h6.4z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "m724.9 155.2-2.4 23.7 24.3 11.9-12.3-16.5 16.8-5.5zm-2.7-6.1c-3.7 0-6.4 1.4-6.4 3s2.7 3 6.4 3 6.4-1.4 6.4-3-2.7-3-6.4-3"
        })
      ]
    }),
    /* @__PURE__ */ jsxs38("g", {
      fill: "#f7e017",
      children: [
        /* @__PURE__ */ jsx45("path", {
          d: "M314 375.9c2.7-.9 4.2-2.5 5.3-5.6.5-1.6.9-3.2.8-3.6-.2-1-1.4-1-2.6.1-.9.7-1 1.1-.8 2.6.7 3.7-.7 4.7-7.7 5.4-.7 0-2.8 0-4.5-.3-3.4-.4-4.6 0-3.4 1a7 7 0 0 0 2.1.9c1.9.5 8.8.2 10.8-.5m14.7-.6c.4-.4 1.7-1 3-1.5 1.7-.5 2.6-1 3.3-2.2 2.1-3 1.7-5.7-1.3-9.3-1.7-2-2.4-1.9-3.7.3-1.2 1.8-1.1 2 .5 2.4.9.2 1.7.8 2.1 1.6 1.8 3.1 1.3 5-1.4 5-2.4 0-3 .4-3.7 2l-.6 1.9c0 .6 1 .5 1.8-.2m-4.8-3.5c.4-1.3.6-3.5.5-8a33 33 0 0 0-.3-6.4c-.4-.4-2.3.8-2.6 1.7a3 3 0 0 0 .5 2.1c.6 1.2.7 2.4.5 7-.3 6 .1 7 1.4 3.6"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "m312.6 369 .7-5c.1-1.7.5-3.8.7-4.7.7-2.3 0-2.9-1.8-1.6l-1.3 1 .2 3.3c.3 3-.2 8.5-.9 10.7-.2.6.1.4.9-.5.6-.7 1.3-2.2 1.5-3.3zm-10 1.6c2.4-2 2.1-5.6 2.7-8.4 0-1.9 1.2-4.1.4-5.8-2.3.4-3.7 2.6-2.5 4.7 0 2.5 0 5.2-1.3 7.4-1 1.5-4.4 1.1-4.2-1 .8-3-2.9-1.5-4.3-.7-1.1.8-3.5.9-2.6-1-.6-2.7-3.9-1-5.7-1-1.7 0-.1-3.5-2.6-3-4.5-.3-9.5.1-13.5-2.6-2.3-1.1-2-3.9-.7-5.7 1.4-2.4 1.8-5.5 4-7.4 2.3-2.1-2-1.2-3-.5-2.2 1.2-.2 4.3-2 6-1 1.8-2.4 4.2-4.8 3.9-3.5-.7-5.5-4-8-6-2.2-.5-1 3.4.2 4.2a21.9 21.9 0 0 0 7.4 3.6c2.6-.5 2.7 3 5 3.5 4 2 8.6 2.5 13.1 2.8 1.8.1.8 3.3 3.1 2.6 1.3.4 4.3-.5 4.4 1-2 2.4 1.9 2.3 3.3 2 1.9-.4 4.2-1 4.7 1.4 1.5 1.7 4.3 1.4 6.2.5z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M262.8 350.4a23.9 23.9 0 0 0 2.4-4.2 16 16 0 0 1 2-3.6c1.2-1.2.5-2-1.4-1.6-1 .2-1.4.6-1.5 1.5a23 23 0 0 1-2.5 7c-1.7 2.5-1.7 2.6-1 2.6.3 0 1.2-.8 2-1.7m-25-15.7c-1.9 0-2 1.2-.2 1.8 1 .3 1.7 1 2.3 2.3 1.7 3.5 2.8 4.2 7.5 4.6l3 .2.2 1.9c0 1 .3 1.8.5 1.8l2.6-1c2.2-1.2 4.3-3.8 4.3-5.5 0-1-1.8-2.2-3.4-2.2-.7 0-2 .6-3.1 1.4-3.4 2.4-7 2-9-1.2-1.5-2.6-3.2-4-4.7-4zm16.3 6.5c.9 0 1 .7.6 2a.9.9 0 0 1-1.7 0c-.4-1 .1-2 1-2zm126.5-4c-1.3 0-1.6.2-2.4 1.4-1.3 1.9-1.4 6-.2 7.4.7.9.8.9 2.3.2 2.2-.9 2.6-.8 2.5.3 0 3-4.2 8.7-8.6 11.7a9.7 9.7 0 0 0-2.4 2c-.3.8 1.3.7 3.3-.4a21 21 0 0 0 7.9-8c1.1-2.3 1.3-3 1.5-7 0-3.8 0-5-.6-6.2-.8-1.4-1-1.5-2.8-1.5h-.5zm.1 2.5c1 0 1 .2 1.2 1.6 0 1-.1 1.7-.7 2.3-.8.7-1 .7-1.6-.4-1-1.6-.4-3.5 1.1-3.5m-20.2 28.5c3.9-2 6.2-4.1 7.6-7.2a20 20 0 0 0 1.3-3.1c0-.6-1.9-1.5-3-1.5s-1.4-.8-1-3c.5-2.1 0-4.8-1-4.8-.3 0-1 .5-1.3 1.1-.6 1-.7 1.4-.2 2.7.7 2 .1 3.6-1.7 4.9-.9.6-1.3 1.3-1.3 2l.1 1 2.1-1 2-1.2 1.1 1c.7.4 1.2 1.2 1.2 1.7 0 2.4-6.8 6.4-11.4 6.8-2.5.2-3 0-3.8-.8-.7-.7-.9-1.3-.7-2l.5-2.6c.4-2.1-.4-1.8-2 .6-1.2 2-1.6 4.1-.9 5.2.6 1 4.4 1.8 7.2 1.6 1.7 0 3.4-.5 5.2-1.4m26-14.5c2.4-2.5 3.5-5.5 3.5-10v-3.5l2-1c2.7-1.2 5.2-3.7 5.2-5.1 0-1.4-.7-1.4-1.8.2-.9 1.1-2 1.8-6 3.7-1 .4-1.1.7-1.4 5-.2 5-1 6.8-3.7 10.2-1.7 2-1.8 2.4-.6 2.4.5 0 1.8-.9 2.8-2zm-26.7-2.8c.2-.7-1.2-1.2-1.7-.6-.3.2-.4.6-.2.9.4.6 1.6.4 1.9-.3m36.8-9.5c.3-.8-1.1-1.3-1.7-.7-.2.3-.3.7-.1 1 .4.6 1.6.4 1.8-.3m-44.3-25.9c-1 .5-1.5 1.5-2.1 2.3-.5.3-.1.6.1 1 1.7 1.7 2.4 4.2 3.2 6.5.8 2.7 1.8 5.6 1 8.4-.3 1-1.2 2.1-2.4 1.8-2-.1-4-.7-6-.7-1.9.1-3.3 1.8-5.1 1.6-1.2 0-1.2-2.4-2.2-1.7-.6 1.3-.3 2.7-.4 4 .2.3.8.1 1.1.2h3.7c.2 1.2.2 2.7 1 3.7 1.3.4 2.8 0 4-.5 1.2-.6 1.4-2.1 1.8-3.3.4-1.3 2-1 3-1.5a5.7 5.7 0 0 0 4-5.7c-.2-3.9-1.6-7.4-2.8-11-.5-1.6-.9-3.3-1.5-4.9zm-6 21.8c1.3 0 1.9 1.6 1.6 2.7-.5 1.5-2.4.6-2.7-.5-.7-1-.3-2.3 1-2.2z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M296 324.8c-.6 0-1.3.2-2 .7-3.5 2.5-4.5 5.4-2 6.6 1.7.8 1.3 1.8-1.5 3.2-4 2-7.5 1.7-14.2-1-1.6-.7-2-.4-1.7 1 .4 1.5 1.8 2.3 5.1 3 3.6 1 8 .7 10.8-.5a14 14 0 0 0 4.3-3.4l2.2-2.3 2.5.3c3.1.4 3.2.4 3.2 1.9 0 1.2 0 1.2 2.9 1.5l4.7.2c1.3 0 2 .3 2.4.9.6.7.9.8 5.6.4 4.4-.4 5.2-.4 7.2.3 1.4.4 3 .6 4.1.5 3.4-.4 8-3.1 8.7-5.1 0-.3 1.3-.7 2.7-1 3.4-.7 3.5-1.4.4-1.8a22.9 22.9 0 0 1-4.6-1.1 12.2 12.2 0 0 0-3.5-.9c-1.7 0-3.3 1-3.3 2.2 0 .7.2.8 2.3.6 1.8-.2 2.4-.1 3.4.7.7.5 1.1 1.1 1 1.3-.5.8-4.5 2.6-6.2 2.9a4.7 4.7 0 0 1-3-.5c-1.6-.8-3.8-.9-4.3-.2-.2.3-.6.1-1.3-.5l-1-1-2.4 1c-2.4 1-3.3 1-3.3-.2 0-.5-.7-.6-4.2-.3-3.9.2-4.3.1-5-.7-.7-.7-.7-1-.2-1.7.4-.8.4-1 0-1.5-.4-.4-1-.4-2.5 0-3.9 1-5 .5-5-2.5 0-1.9-1-3-2.3-3m-1 2.8c.2 0 .4.1.7.4.3.3.5 1 .3 1.3-.3.9-2 .9-2.3 0-.2-.5 0-1 .5-1.3z"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M288 330.4c2.4-1.5 2.4-1.4 2.7-5.5.2-3 .2-3.2-.6-3.2-1.2 0-1.8 1.3-1.8 3.7 0 1.6-.2 2.3-1 3-2 2-6.8 1.1-7.5-1.3-.2-.8.1-1.6 1.1-3 2.1-3 1.7-3.8-1-1.5-1.7 1.6-2 1.6-1.7.3.3-1.3-.3-1.8-1.8-1.4-.7.2-1.2.6-1.3 1.6-.2.8-.6 1.3-1.3 1.5-1.2.3-3.2-.8-3.2-1.8 0-.7 3-4.4 6.9-8.4 1.4-1.5 2.6-3 2.6-3.1 0-.2-.8-.4-1.7-.4-1.4 0-1.8.2-1.8.8 0 .4-1.9 3-4.3 5.7-5 5.6-5.4 6.7-3 8.2a6 6 0 0 0 6.6-.2l1.6-1.1v2c0 2.5.5 3.5 2.5 4.5a8 8 0 0 0 8-.4m104.4-34.6c-1.8 1.1-.4 3.4 0 5-.8 2-3.5 2.6-5.5 3-2.8.5-4.8 2.8-5.8 5.3-.6 1.6-2 4-3.5 1.6-1.3-1.3-3.7-2.4-5.2-.8-1.2 1.1-1.5 2.7-2 4.2-.7-1.1-1-2.8-2.4-3.2-2.4.3-1.5 3.3-.4 4.5 1 1.5 2 3.3 1 5-1 2-4 3.4-5.7 1.7-1.6-.9-.5-4-2.2-4.2-.8.6-.8 3.9-2.1 2.1-1-1.5-.4-3.6-1.6-4.9-1.3.2-2.4 2.5-2 3.7 1.8 2.4 2.6 5.4 3.3 8.3.4 1.2-.1 3.5 1 4 .7-1.9 0-4 .6-5.9 1.8-.2 3.7.6 5.5.2 2.7-.3 4.7-2.6 5.6-4.9.3-1.8 0-3.6-.1-5.4 2 .4 4.2.4 6.2 1 1 1.5-.3 3.7-.6 5.3-1 3.4-3.7 5.8-6.2 8-1.1.7-1.2 2.4.3 1.5a15 15 0 0 0 7.5-8c1.1-2.6.2-5.5 1-8.1 1-2 3.5-1.6 5.4-1.6 1.9 0 3.5-2.3 2.9-4.2-.6-2.2 1.7-3.2 3.2-4 2.1-1 3.7-3.1 3.5-5.5 0-1.3 0-3.6-1.7-3.7m-7.3 12.5c2.2.6-.4 4.8-1.6 2.1-.4-1 .5-2.1 1.6-2.1m-10.3 3c2.9-.1 1.8 4-.6 2.2-1.3-.7-.9-2.2.6-2.2M270 327.6c0-.4-.2-.7-.6-.7-.7 0-1.2.7-.9 1.3.4.7 1.3.3 1.5-.6m34-3.6c0-.7-.3-.9-.8-.8-1.1.2-1.3 1.7-.1 1.7.6 0 .9-.3.9-1zm-42-20.4c-1.3-.3-2.2.9-2.7 2-1 1.7-2.2 3.4-4 4.3-1.3.4-2.7-.1-3.9-.8-1.3-.7-1-2.3-1.6-3.4-1-.8-2.7.3-2.6 1.5-.1 1.6 1.3 2.5 2.6 3.1 1 .7 2.6 1 3 2.3 0 1.1.4 2.4 1.7 2 1.5 0 2 1.8 1.3 2.9a6.3 6.3 0 0 0-.7 4c.7.7 1.4-1 2-1.4l1-1.4c2.7.1 5.3.5 8 .4 2 0 3.5-1.2 4.7-2.6 1.8-1.8 3.2-3.9 5.1-5.4 1.4-.4.7-3-.8-2.2-1.3.5-1.7 2-2.6 2.9a31 31 0 0 1-5 5.2c-1.5.6-3.1.3-4.6 0-.6-.5 1.2-1 1.5-1.6.8-.8 1.8-1.6 2.3-2.7-.5-1-1.9-1-2.9-1-2.4.2-4.3 2.3-6.8 2.5-1.9 0-.9-2 0-2.7 1.6-2 3.4-3.8 5.1-5.7.5-.6 2.3-1.2 1.2-2-.4-.2-.9-.2-1.3-.2m1.2 10c1.3.7-.8 1.8-1.6 1.7-1.1.3-1.2-.8-.2-1 .6-.4 1.2-.7 1.8-.7m-3.8 2.6c.7 0 2.2.7.8 1.1-1 .8-2-.8-.8-1.1"
        }),
        /* @__PURE__ */ jsx45("path", {
          d: "M289.4 317.8c0-1-1.6-.8-1.8.2-.2.6 0 .7.8.6.6 0 1-.4 1-.8m74.7-6.6c.2-.9-1-1.5-1.7-.8-.7.6 0 1.9.8 1.7.4 0 .8-.5 1-.9zM248 302.1c1.1-1 1.2-1.1.7-3.3-.8-3.1-.7-3.5.5-3.8 1.5-.3 5.3 1.7 6 3.3.8 1.3.7 1.4-.4 2.4-1.2 1.1-1.2 2.4 0 2.4 1 0 3.7-2.6 3.7-3.5 0-1.3-3-4.4-5.4-5.5a10.7 10.7 0 0 0-4.6-1c-3.1 0-3.5.7-2.7 4.2 1 4.2-.3 4.8-3.7 1.6a10.4 10.4 0 0 1-3.5-8.6c0-4 1.6-6.1 5.1-6.6 2.4-.3 2.3-.9 0-1.2-3.6-.6-6.6 1.8-7.7 6-1.3 4.7 1.6 10.4 6.7 13.3 2.7 1.5 3.7 1.6 5.3.3m139.2-5.2c.3-.2.5-.9.5-1.4s.5-1.6 1.1-2.4c.6-.8 1-1.6 1-1.8 0-.8-1.3-.8-2.3 0-1.1.9-2 1-2 0l1.2-.9c1.6-.7 1.7-1.5.4-2.1-1.7-.8-3.5.6-3.6 3-.1 1.6 0 1.8 1.2 2.5 1.1.7 1.3 1 1.1 2-.3 1.6.4 2.2 1.4 1.1m13-1.4c1-1 1.8-1.9 1.8-2.2 0-.3.9-1.2 1.9-2 2.8-2 3.5-4 2.2-7.3-.5-1.3-2-3-5.5-6a26 26 0 0 0-5.4-4.4c-.9 0-.7 3.4.2 3.7 1.7.6 2.8 1.3 5.4 3.7 3.2 2.8 4.6 5.5 3.8 7-.7 1.4-1.7 1-4.5-2a13.8 13.8 0 0 0-3.2-2.9c-.3 0-.5.6-.5 1.4 0 1 .5 2 2 3.5 2.3 2.6 2.5 4.1.7 5.5a5 5 0 0 1-1.4 1 33.2 33.2 0 0 0-9-10c-.3 0-.5.4-.5 1.4 0 1.3.2 1.7 1.2 2.2a38 38 0 0 1 7 7l1.8 2a9 9 0 0 0 2-1.7zm6-16.8c-.5-1.2-8.4-9.4-9.3-9.4-.4 0-.5.5-.4 1.8 0 1.6.3 1.8 1.4 2.1a20 20 0 0 1 4.6 3.7 17 17 0 0 0 3.7 3zm-47.8 92.6a1.2 1 0 1 1-2.3 0 1.2 1 0 1 1 2.3 0m4.2-1.4a1.2 1 0 1 1-2.4 0 1.2 1 0 1 1 2.4 0"
        })
      ]
    })
  ]
});
var Bn_default = SvgBn;

// src/country-flag-icons/generated/Bo.tsx
import { jsx as jsx46, jsxs as jsxs39 } from "react/jsx-runtime";
var SvgBo = (props) => /* @__PURE__ */ jsxs39("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m368.6 210.7-98 97.9a91.8 91.8 0 0 0-1.3-1l98-97.8a6.3 6.3 0 0 1 1.3 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M374.7 204.5c-.4.7-1.4 2.5-1 3.8l-2-1.5c.5 1 .4 1.4-.1 1.8-.3.4-1.4.3-2.1.2.7.4 1.5.8 2.4 1h2c-.7.3-2.2.8-3.3 1-.5.1-1.6.2-2 0-.6.5-1.9-.4-1.3-1-.3-.3-.3-.8-.4-1.4 0-.7.1-1.9.7-3l.5 1.7c.2.5.7 1 1.1 1.4-.2-.5-.4-1.2.1-1.8.5-.5 1.3-.5 2-.2l-1.9-1.3c.8 0 3.3-1 4.1-1.5a62.3 62.3 0 0 0 4.9-3.8 57 57 0 0 0-3.7 4.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m387 222.8-125.7 70.9a85 85 0 0 0-.9-1.2l125.7-71a5.6 5.6 0 0 1 1 1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M394.9 218.3c-.6.6-2.2 2-2.2 3.4l-1.4-2c.2 1-.1 1.5-.7 1.7-.4.4-1.4 0-2-.3a5.1 5.1 0 0 0 2 1.5l1.7.6c-.6.1-2.3.3-3.4.2-.5 0-1.5-.2-1.9-.6-.7.4-1.6-.8-1-1.2 0-.4 0-.8.2-1.4.2-.7.7-1.8 1.6-2.8a7.8 7.8 0 0 0 0 1.8c0 .5.3 1 .5 1.6 0-.5 0-1.3.7-1.7.7-.4 1.4-.2 2 .3l-1.4-1.7c.8.1 3.5-.2 4.4-.5 1-.2 4.1-1.6 6-2.5-1.7 1-4.6 3-5.1 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m376.3 217.5-113 85.2-1-1.1 112.9-85.2a6 6 0 0 1 1.1 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M383.4 212.1c-.5.6-1.8 2.3-1.6 3.6L380 214c.3 1 .1 1.5-.4 1.7-.4.4-1.5.2-2.1 0 .6.5 1.3 1 2.2 1.2l1.9.3c-.7.3-2.3.6-3.4.6-.5 0-1.6 0-2-.3-.6.5-1.7-.6-1.1-1.1-.2-.3-.1-.8-.1-1.4a6 6 0 0 1 1.1-3 7.8 7.8 0 0 0 .2 1.8c.2.6.5 1 .9 1.6-.2-.5-.2-1.3.4-1.8.6-.4 1.3-.3 2 0l-1.6-1.5c.7 0 3.3-.6 4.2-1 1-.4 3.8-2 5.5-3.1-1.4 1.2-4 3.5-4.4 4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m271.4 210.7 98 97.9 1.3-1-98-97.8a6.3 6.3 0 0 0-1.3 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M265.3 204.5c.4.7 1.4 2.5 1 3.8l2-1.5c-.5 1-.4 1.4.1 1.8.3.4 1.4.3 2.1.2-.7.4-1.5.8-2.4 1h-2c.7.3 2.2.8 3.3 1 .5.1 1.6.2 2 0 .6.5 1.9-.4 1.3-1 .3-.3.3-.8.4-1.4 0-.7-.1-1.9-.7-3a8 8 0 0 1-.5 1.7c-.2.5-.7 1-1.1 1.4.2-.5.4-1.2-.1-1.8-.5-.5-1.3-.5-2-.2l1.9-1.3c-.8 0-3.3-1-4.1-1.5a62.3 62.3 0 0 1-4.9-3.8 57 57 0 0 1 3.7 4.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m253 222.8 125.7 70.9c.2-.3.6-1 .9-1.2l-125.7-71a5.6 5.6 0 0 0-1 1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M245.1 218.3c.6.6 2.2 2 2.2 3.4l1.4-2c-.2 1 .1 1.5.7 1.7.4.4 1.4 0 2-.3a5.1 5.1 0 0 1-2 1.5l-1.8.6c.7.1 2.3.3 3.4.2.6 0 1.6-.2 2-.6.7.4 1.6-.8 1-1.2 0-.4 0-.8-.2-1.4a6.3 6.3 0 0 0-1.6-2.8v1.8c0 .5-.3 1-.5 1.6 0-.5 0-1.3-.7-1.7-.7-.4-1.4-.2-2 .3l1.4-1.7a17 17 0 0 1-4.4-.5 70.5 70.5 0 0 1-6-2.5c1.7 1 4.6 3 5.1 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m263.7 217.5 113 85.2 1-1.1-112.9-85.2a6 6 0 0 0-1.1 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M256.6 212.1c.5.6 1.8 2.3 1.6 3.6l1.7-1.7c-.3 1-.1 1.5.4 1.7.4.4 1.5.2 2.1 0a5.4 5.4 0 0 1-2.2 1.2l-1.9.3c.7.3 2.3.6 3.4.6.5 0 1.6 0 2-.3.6.5 1.7-.6 1.1-1.1.2-.3.1-.8.1-1.4a6 6 0 0 0-1.1-3 7.8 7.8 0 0 1-.2 1.8c-.2.6-.5 1-.9 1.6.2-.5.2-1.3-.4-1.8-.6-.4-1.3-.3-2 0l1.6-1.5a15 15 0 0 1-4.2-1c-1-.4-3.8-2-5.5-3.1 1.4 1.2 4 3.5 4.4 4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.1 283.4c4-2.6 15.1-4 16.7-3.6-8 6-16 6.3-16.7 3.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.2 283.5c.7 2.6 8.7 2.4 16.6-3.6a69 69 0 0 1-16.6 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M300.2 283.5c.7 2.6 8.7 2.4 16.6-3.6a69 69 0 0 1-16.6 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.1 283.4a40.6 40.6 0 0 1 16.7-3.6c-8 6-16 6.3-16.7 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M347.6 220.2 322 272.5c-1.3 1-2.3-.3-2.7-.2-1.5 1.7-3.6 2-4 2.5-1.8 2.4-.8 4.3-.7 4.5 1.3 1.8-1.6 3.5-1.5 4-.6 1-2.7.9-3.1 2l-4.8 9.3c-.6.5-3.7 6.1-3.7 6.1-2 0-10.2-5.2-10.4-5.1 4.6-7.3 15.6-18.5 15.3-19.2 3.1-5.2 8-10.9 10.1-10.8 3-1.6 4.5-5.7 4-6.6 2.2 0 3.5-1.4 3.6-1.5l18.8-37.6c1.6-.5 1.4.1 1.9 1 0 0 1-1.2.9-1.3.9-.4 1.8.2 1.8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.6 208.8c-.6 1 .2 1 .5 1.1l1 .3c1.3 0 2 .7 2 1l-30 61.3c-1.3 1-2.5-.3-2.9-.1l20.6-41.8 10-18.8-2.8-1.2c-.8-.2-1-.8-.7-1.6l12.6-21.6-10.2 21-.1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.6 208.8c-.6 1 .2 1 .5 1.1l1 .3c1.3 0 2 .7 2 1l-30 61.3c-1.3 1-2.5-.3-2.9-.1l20.6-41.8 10-18.8-2.8-1.2c-.8-.2-1-.8-.7-1.6l12.6-21.6-10.2 21-.1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.8 272.4c-3 0-4.6 2-2.7 4.7m1.4-2.4c-1 .6-1.7-.3-1.7-.3m15.2-13c-1.5 5.6-4.3 9.3-5 10.4-2 2.2-3.9 7.2-3.5 8.1l-8.1 13.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M322 272.7c-1.4-.5-5.7-4.5-10-3.8-3.3 3.8-5.3 7.7-5.9 8.2 4 3.3 6.7 5 7.6 5.4.7-.4 1-1.5 1-1.5.9-1-.2-1.7-.2-1.7.2-2.5 2-4.2 3.8-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.8-1.9 1.8-1.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M322 272.7c-1.4-.5-5.7-4.5-10-3.8-3.3 3.8-5.3 7.7-5.9 8.2 4 3.3 6.7 5 7.6 5.4.7-.4 1-1.5 1-1.5.9-1-.2-1.7-.2-1.7.2-2.5 2-4.2 3.8-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.8-1.9 1.8-1.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.6 272.8c-2 0-4 .9-4.8 2.6l4.8-2.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.6 272.8c-2 0-4 .9-4.8 2.6m-3.5.7c.1.4.7.6 1.1.5.6-.2.8-.7.6-1-.2-.5-.7-.7-1.2-.5-.5.1-.7.6-.5 1zm2.5-3.4c.1.4.7.6 1.2.4.5-.1.7-.6.5-1-.2-.4-.7-.6-1.2-.5-.5.2-.7.7-.5 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.3 226.1c.8-.2 1.2-1.1.8-2l-4.7-1.7s-.6 0-1 .7c-.5.7.1 1.2.1 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.3 226.1c.8-.2 1.2-1.1.8-2l-4.7-1.7s-.6 0-1 .7c-.5.7.1 1.2.1 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.5 286c3.9-2.7 15-4.2 16.6-3.8-7.8 6.2-15.8 6.5-16.6 3.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.6 286c.7 2.7 8.7 2.3 16.5-3.8a62.4 62.4 0 0 1-16.5 3.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M294.6 286c.7 2.7 8.7 2.3 16.5-3.8a62.4 62.4 0 0 1-16.5 3.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.6 286a40 40 0 0 1 16.6-3.9c-7.9 6.2-16 6.6-16.6 4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m340.7 222-24.4 52.8c-1.3 1-2.4-.3-2.7-.2-1.5 1.7-3.6 2.1-4 2.5-1.8 2.5-.7 4.4-.6 4.6 1.3 1.8-1.5 3.5-1.4 4-.6 1-2.7.9-3.1 2.1-.1-.1-4.2 8.4-4.6 9.3-.6.5-3.5 6.2-3.5 6.2-2.1 0-10.3-5-10.5-5 4.4-7.3 15.1-18.7 14.9-19.4 3-5.3 7.7-11 9.9-11 3-1.6 4.3-5.7 3.7-6.6 2.3-.1 3.5-1.5 3.7-1.6l18-37.8c1.6-.6 1.3 0 1.9 1 0 0 1-1.2.9-1.4.9-.4 1.7.2 1.8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m340.7 222-24.4 52.8c-1.3 1-2.4-.3-2.7-.2-1.5 1.7-3.6 2.1-4 2.5-1.8 2.5-.7 4.4-.6 4.6 1.3 1.8-1.5 3.5-1.4 4-.6 1-2.7.9-3.1 2.1-.1-.1-4.2 8.4-4.6 9.3-.6.5-3.5 6.2-3.5 6.2-2.1 0-10.3-5-10.5-5 4.4-7.3 15.1-18.7 14.9-19.4 3-5.3 7.7-11 9.9-11 3-1.6 4.3-5.7 3.7-6.6 2.3-.1 3.5-1.5 3.7-1.6l18-37.8c1.6-.6 1.3 0 1.9 1 0 0 1-1.2.9-1.4.9-.4 1.7.2 1.8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.4 210.6c-.5 1 .3 1 .6 1.2l1 .3c1.3 0 2 .6 2 1l-28.7 61.7c-1.3 1-2.5-.3-2.9 0l19.7-42.2 9.6-19-2.8-1c-.8-.3-1-.8-.7-1.7l12-21.8-9.6 21.1-.2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.4 210.6c-.5 1 .3 1 .6 1.2l1 .3c1.3 0 2 .6 2 1l-28.7 61.7c-1.3 1-2.5-.3-2.9 0l19.7-42.2 9.6-19-2.8-1c-.8-.3-1-.8-.7-1.7l12-21.8-9.6 21.1-.2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303 275c-3-.2-4.6 2-2.6 4.6m1.3-2.4c-1 .6-1.7-.3-1.7-.3m15-13.3c-1.5 5.7-4.2 9.4-4.7 10.6-2.2 2.2-3.9 7.3-3.5 8.1l-7.8 13.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.1 275c-1.3-.5-5.8-4.5-10-3.7-3.3 3.9-5.1 7.8-5.7 8.3a50 50 0 0 0 7.7 5.3c.7-.4 1-1.5 1-1.5.8-1-.2-1.8-.2-1.8 0-2.4 1.8-4.2 3.6-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.7-2 1.7-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.1 275c-1.3-.5-5.8-4.5-10-3.7-3.3 3.9-5.1 7.8-5.7 8.3a50 50 0 0 0 7.7 5.3c.7-.4 1-1.5 1-1.5.8-1-.2-1.8-.2-1.8 0-2.4 1.8-4.2 3.6-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.7-2 1.7-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.8 275.1c-2 0-4 1-4.7 2.7l4.7-2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.8 275.1c-2 0-4 1-4.7 2.7m-3.6.8c.2.4.7.6 1.2.4.5-.2.7-.6.5-1-.2-.5-.7-.6-1.2-.5-.5.2-.7.6-.5 1zm2.4-3.5c.2.4.8.6 1.3.5.5-.2.7-.7.5-1-.2-.5-.7-.7-1.2-.5-.5.1-.8.6-.6 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 228c.8-.2 1.1-1.1.7-2l-4.7-1.6s-.5 0-1 .7c-.4.7.2 1.2.2 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 228c.8-.2 1.1-1.1.7-2l-4.7-1.6s-.5 0-1 .7c-.4.7.2 1.2.2 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.6 283.3a39 39 0 0 0-16.8-3.7c8 6.1 16.1 6.3 16.8 3.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.6 283.3c-.7 2.7-8.8 2.4-16.8-3.6a63.4 63.4 0 0 0 16.8 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M340.6 283.3c-.7 2.7-8.8 2.4-16.8-3.6a63.4 63.4 0 0 0 16.8 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.6 283.3c-4.2-3-15.8-4-16.9-3.7 8 6 16.2 6.3 16.9 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m292.7 219.3 25.7 52.9c1.3 1 2.4-.3 2.7-.2 1.6 1.7 3.7 2.1 4.2 2.5 1.8 2.4.8 4.4.7 4.6-1.4 1.8 1.5 3.5 1.4 4.1.6 1 2.7.8 3.2 2l4.8 9.3c.7.5 3.7 6.2 3.7 6.2 2.1 0 10.3-5.3 10.5-5.2-4.6-7.3-15.7-18.7-15.4-19.4-3.1-5.2-8.1-11-10.2-10.9-3-1.6-4.5-5.7-4-6.6-2.3 0-3.6-1.5-3.7-1.6l-19-37.9c-1.6-.5-1.3.1-1.9 1 0 0-1-1.2-.9-1.3-.9-.5-1.8.2-1.8.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.7 207.8c.5 1-.2 1-.5 1.2l-1.1.3c-1.2 0-1.9.7-1.9 1l30.2 61.9c1.3 1 2.5-.3 3-.1l-20.8-42.3-10-19 2.7-1.1c.8-.2 1-.8.7-1.6l-12.7-21.9 10.2 21.2.2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.7 207.8c.5 1-.2 1-.5 1.2l-1.1.3c-1.2 0-1.9.7-1.9 1l30.2 61.9c1.3 1 2.5-.3 3-.1l-20.8-42.3-10-19 2.7-1.1c.8-.2 1-.8.7-1.6l-12.7-21.9 10.2 21.2.2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.9 272.1c3 0 4.6 2.1 2.7 4.7m-1.4-2.3c1 .6 1.7-.4 1.7-.4M319.5 261c1.6 5.7 4.4 9.5 5 10.6 2.2 2.2 4 7.3 3.7 8.2l8.1 13.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M318.6 272.4c1.3-.4 5.7-4.6 10-3.8 3.4 3.8 5.4 7.7 6 8.2-4 3.4-6.7 5-7.7 5.5-.7-.4-1-1.5-1-1.5-.9-1 .2-1.8.2-1.8-.1-2.4-2-4.2-3.8-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-1.9-1.7-1.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M318.6 272.4c1.3-.4 5.7-4.6 10-3.8 3.4 3.8 5.4 7.7 6 8.2-4 3.4-6.7 5-7.7 5.5-.7-.4-1-1.5-1-1.5-.9-1 .2-1.8.2-1.8-.1-2.4-2-4.2-3.8-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-1.9-1.7-1.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323 272.5c2 0 4 1 4.8 2.7l-4.8-2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323 272.5c2 0 4 1 4.8 2.7m3.6.6a1 1 0 0 1-1.2.5.7.7 0 0 1-.5-1c.1-.5.7-.6 1.2-.5.5.2.7.6.5 1zm-2.5-3.4c-.2.4-.8.6-1.3.5-.4-.2-.7-.7-.5-1 .2-.5.7-.7 1.2-.5.5.1.8.6.6 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 225.4a1.4 1.4 0 0 1-.8-2l4.8-1.8s.5.1 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 225.4a1.4 1.4 0 0 1-.8-2l4.8-1.8s.5.1 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.6 286a38 38 0 0 0-16.6-3.8c7.9 6.2 15.9 6.5 16.6 3.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.6 286c-.8 2.7-8.7 2.3-16.5-3.8a62.4 62.4 0 0 0 16.5 3.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M345.6 286c-.8 2.7-8.7 2.3-16.5-3.8a62.4 62.4 0 0 0 16.5 3.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.6 286a40.1 40.1 0 0 0-16.6-3.9c7.8 6.2 15.9 6.6 16.6 4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m299.5 222 24.4 52.8c1.3 1 2.3-.3 2.7-.2 1.5 1.7 3.6 2.1 4 2.5 1.7 2.5.7 4.4.6 4.6-1.4 1.7 1.5 3.5 1.4 4 .5 1 2.6.9 3 2.1.2-.1 4.2 8.4 4.7 9.3.6.5 3.5 6.2 3.5 6.2 2 0 10.3-5 10.5-5-4.4-7.4-15.2-18.7-15-19.4-2.9-5.3-7.7-11-9.8-11-3-1.6-4.3-5.7-3.7-6.6-2.3-.1-3.6-1.5-3.7-1.6L304 222c-1.6-.6-1.4 0-2 1 0 0-.9-1.2-.8-1.4-.9-.4-1.8.2-1.8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m299.5 222 24.4 52.8c1.3 1 2.3-.3 2.7-.2 1.5 1.7 3.6 2.1 4 2.5 1.7 2.5.7 4.4.6 4.6-1.4 1.7 1.5 3.5 1.4 4 .5 1 2.6.9 3 2.1.2-.1 4.2 8.4 4.7 9.3.6.5 3.5 6.2 3.5 6.2 2 0 10.3-5 10.5-5-4.4-7.4-15.2-18.7-15-19.4-2.9-5.3-7.7-11-9.8-11-3-1.6-4.3-5.7-3.7-6.6-2.3-.1-3.6-1.5-3.7-1.6L304 222c-1.6-.6-1.4 0-2 1 0 0-.9-1.2-.8-1.4-.9-.4-1.8.2-1.8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.8 210.6c.4 1-.3 1-.6 1.2l-1 .3c-1.3 0-2 .6-2 1l28.7 61.7c1.3 1 2.5-.3 2.9 0L307 232.5l-9.6-19 2.7-1c.9-.3 1.2-.8.8-1.7L288.8 189l9.7 21.1.2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.8 210.6c.4 1-.3 1-.6 1.2l-1 .3c-1.3 0-2 .6-2 1l28.7 61.7c1.3 1 2.5-.3 2.9 0L307 232.5l-9.6-19 2.7-1c.9-.3 1.2-.8.8-1.7L288.8 189l9.7 21.1.2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M337.2 275c3-.2 4.5 2 2.6 4.6m-1.4-2.4c1 .6 1.8-.3 1.8-.3m-15-13.3c1.4 5.7 4.2 9.4 4.7 10.6 2.1 2.2 3.8 7.3 3.5 8.1l7.8 13.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324 275c1.4-.5 5.8-4.5 10.1-3.7 3.2 3.9 5.1 7.8 5.7 8.3a54.1 54.1 0 0 1-7.8 5.3c-.6-.4-1-1.5-1-1.5-.7-1 .3-1.8.3-1.8 0-2.4-1.8-4.2-3.6-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-2-1.7-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324 275c1.4-.5 5.8-4.5 10.1-3.7 3.2 3.9 5.1 7.8 5.7 8.3a54.1 54.1 0 0 1-7.8 5.3c-.6-.4-1-1.5-1-1.5-.7-1 .3-1.8.3-1.8 0-2.4-1.8-4.2-3.6-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-2-1.7-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.4 275.1c2 0 4 1 4.7 2.7l-4.7-2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.4 275.1c2 0 4 1 4.7 2.7m3.6.8a1 1 0 0 1-1.2.4c-.5-.2-.8-.6-.6-1 .2-.5.8-.6 1.3-.5.4.2.7.6.5 1zm-2.5-3.5c-.2.4-.7.6-1.2.5-.5-.2-.7-.7-.5-1 .2-.5.7-.7 1.2-.5.5.1.7.6.5 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.6 228c-.8-.2-1-1.1-.7-2l4.7-1.6s.6 0 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.6 228c-.8-.2-1-1.1-.7-2l4.7-1.6s.6 0 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m315.3 250.7 35.5-38a97.4 97.4 0 0 1-1.4-.9l-35.6 38a7.5 7.5 0 0 0 1.5.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M349.8 212.2c-1.2-1-3.4-2.2-5-1.8-.5-2.2 2.5-4.4 3.8-4-.3 2.3 3.2 3.8 3.1 3.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M352.1 210.4c1 .8 1.4.8 2.8 1.6 1.4.7 3.2-1.1 4.1-1.7 0 0 1 3.4-1.1 5.6-2 2.3-4.6 2.8-6.5 2.1 0 0 2.6-2.5 1.5-3.6-1-1.1-1.4-1.2-2.5-1.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M-27.7-406.5h4.1v2.2h-4.1z",
      transform: "matrix(-.67726 .73575 -.82314 -.56784 0 0)"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m308.2 290.3-1 9 1.8-2.2c.3-.6 1.5-2.1 1.8-7.4 0 0-1-2.9-1.4-2.9-.7-.4-1.2 3.5-1.2 3.5zm2.2-20.1-2.7 15.8c0 .5 1.3 1.6 2.1-1.2l1.5-10.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.9 284.6a8.7 8.7 0 0 1-1.4-2l-.4 3.1s2 1.5 1.7 4.3l.4-.6.2-1s.5-2 .5-3.1c0 0-.5-.2-1-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M307.3 299.4s3.3-3 3.5-9.7l.4-1.9s0 1.5.8.4c.6-1.5.6-2.8.6-2.8s1.2-1.6 1.6.3l-1.2 9.6a51.4 51.4 0 0 1-.3 2s-.7-1-1.4.1c-.7 1.2-1.8 2.7-4 2zm4-25.1-1.5 10.5s1.2.6 1.4 3c.1 1.2.6.6.8.4.2-.8 0-2.3 0-2.3l.6-7.3s-1.2-3.4-1.3-4.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m310.1 298.8-.2 2.6s1 0 1.7-1.2c.8-1.1 1-2.8 1-2.8s-.7-1.1-1.3 0c-.5 1-1.2 1.4-1.2 1.4zm1.8-10.6c.6-1 .8-2.6.7-2.8l-.7.5c.2 1.2 0 2.3 0 2.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.3 287.1a4.4 4.4 0 0 0-1.3-1.5l-1.5 12s-.4 3-2.3 3.7c0 0 1.1 10.3 4.5 7.5.4-.4 1-3.6.9-5.5l-.9-6a26.8 26.8 0 0 1 .5-4.7l.6-2.6c.2-.2 0-1.8-.5-2.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m316.9 285.3 1 1c.3 0-2.3 19.3-2.3 19.3s0-2-.7-6c-.6-3.2.2-7.5.9-9.6 0 0 .8-.5 1-4.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m312.6 278.8-.7 7.1s1.8-2.4 2.2-.2l.4-3.2s-1.5-2.4-2-3.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.3 287.8s-.6-6.1-3.6-1.8a10 10 0 0 0 0 3c0 .8.9 1.8 1.2 2.3.7 1 1.3-.2 1.3-.2s.7-1 1-3.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M287.8 237c-.1-3.5-1.2-9.3-1.3-13.3l-12-12.2s-1.4 9.9-5.8 15.5l19 10"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M288.7 237.3c.5-2.4 1-5 1.5-10.2l-7.7-7.6c0 3.2-3.6 8.1-3.9 14"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.3 244.7c1-4.3-1.3-4.8 2-10.8l-7.2-6.8c-1.3 4-2.2 6.6-2 10l6 4.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M267.6 270c-1.5-4.2.5-12.7.2-18-.1-3.5 2.5-16.7 2.4-20.6l-14.1-8.8s-.6 14.3-2.3 29.9c-1.4 8-1.4 15.3-.4 21.5 1.5 8.7 3 12.2 6.5 15.9 6.3 6.5 19.7 2.7 19.7 2.7 11.3-2.3 17.8-9.4 17.8-9.4s-3.7.8-9.6 1.4c-13-.9-18.2 2.4-18.6-11"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m305.4 278.8.2-.1-5.9 1.9-8 .6c-17.2.4-15-10.3-14.3-27.5.1-6.6 1.4-14.8 1-17.7l-11.5-6.6c-3.8 10.6-2.6 18-3.3 23.5-.4 6-1.7 17.4.2 22.4 2.7 11.6 11.8 11.2 24.2 10.1 6.1-.5 9.4-2 9.4-2l8-4.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007a3d",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.6 278.5a34.4 34.4 0 0 1-6 2.2l-8 .8c-12.5 1-19.8-7.7-18.2-27.6 0-7 .2-10.2 2.6-19.5l7 4v.7c-.5 2-1.5 7-1.5 9.2 0 16 10.1 28.2 23.9 30.3h.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M260 230.6c1 2 8 12.5 12 14.5m-11-7.6c1.3 2 9.8 14 13.6 14.6m-15.5 3.6c2 2.4 4 7 9.7 10m-7 3.3c4 3.7 13.6 11.6 23 12m-23-6c2 2.3 6.2 13.3 24 8.3m-26.7-6.3c1.2 2.6 10.1 17.3 26 11.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M277.8 264.8c-1.5-4.3.5-12.7.2-18.1-.1-3.5 1.5-15.5 1.5-19.5l-13.2-9.9s-.6 14.3-2.3 30a84 84 0 0 0-1.5 23.9c1.8 10 6.6 12.8 7.5 13.6 6.7 6 22 5.4 23.5 4.9 10.8-4 15.6-10.8 15.6-10.8s-5.2-.1-11.1.5c-13-1-19.7-.4-20.1-13.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.6 273.5h.2l-5.9 1.8-8 .6c-17.2.5-15-10.2-14.3-27.5.1-6.5.3-12.4 0-15.3l-10.3-7.6c-3.8 10.7-2.8 16.7-3.5 22.2-.4 5.8-1.7 17.3.2 22.3 2.7 11.7 11.8 11.2 24.2 10.2 6.1-.5 9.4-2.1 9.4-2.1l8-4.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.9 273.4c-2.4 1.2-6 2.1-6 2.1l-8 .8c-12.5 1-19.8-7.7-18.2-27.6 0-7-.3-7.5 2.2-16.9 3.8 2.5 11.1 8.8 11.1 8.8s-2 2.8-1.5 6.7c0 16 6.4 24 20.2 26.1l1.5-13"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M270.1 225.3c1.2 2 8.1 12.6 12 14.6m-10.8-7.7c1.2 2 9.7 14 13.5 14.7m-15.5 3.6c2 2.3 4 7 9.7 10m-7 3.3c4 3.6 13.6 11.6 23 12m-23-6c2 2.3 6.2 13.2 24 8.3m-26.7-6.4c1.2 2.7 10.1 17.3 26 11.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m256.2 224-.7 6c-.2 4.4-.1 7.7.1 9.8 0 .2.9 5.5.6 5.8-1 1.1-1.1 1.2-2.2.4-.1-.2.5-5.6.5-6.3l.4-9.9c0-1 1-6.4 1-6.4s0-1.2.3.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m256.2 224-.7 6c-.2 4.4-.1 7.7.1 9.8l.7 5.8c-1 1.1-1.2 1.6-2.3.7-.1-.2.5-5.9.5-6.6l.4-9.9c0-1 1-6.4 1-6.4s0-1.2.3.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M256 222.2s-1 6-1.2 9.6l-.3 7.9-.5 4.5c-.1.7.1.2 0 .2-.9.5-1.5.1-2-.3-.2-.1 1.4-3.8 1.4-4.5.9-10.8 2.4-17 2.4-17s-.6 3.7.3-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M256 222.2s-1 6-1.2 9.6l-.3 7.9-.5 4.5c-.1.7.1.2 0 .2-.9.5-1.5.1-2-.3-.1-.1 1.4-3.8 1.5-4.5.8-10.8 2.3-17.1 2.3-17.1s-.6 3.8.3-.3zm-.4 17.3s-1 .4-1 .2m0-1.3s.7 0 .8-.2m0-1s-.6.3-.8 0m.8-1.6h-.6m.6-1.5h-.6m.5-2.1s-.3.1-.4-.1m.5-1.7h-.5m-.5 9.5s-.9.2-1-.1m1.1-2s-.9.1-1-.1m1-1.3h-.7m.9-1.5h-.7m.7-1.7h-.5m.7-1.5h-.6m.6-1.7s-.4.3-.4 0m0 9s-.9 0-.9-.3m12.8-19.8-.7 6a63.4 63.4 0 0 0 0 9.8c0 .3 1 5.5.7 5.8-1 1.2-1.1 1.3-2.2.4-.1-.1.5-5.5.5-6.3l.4-9.8c0-1.1 1-6.5 1-6.5s0-1.1.3.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m266.4 218.7-.7 6a73 73 0 0 0 .1 9.8l.7 5.8c-1 1.2-1.2 1.6-2.3.7-.1-.1.5-5.8.5-6.6l.4-9.8c0-1.1 1-6.5 1-6.5s0-1.1.3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M266.3 217s-1.2 6-1.3 9.5l-.3 8-.5 4.4v.3c-.9.5-1.5 0-2-.4-.2 0 1.4-3.7 1.4-4.5a127 127 0 0 1 2.4-17l.3-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M266.3 217s-1.2 6-1.3 9.5l-.3 8-.5 4.4v.3c-.9.5-1.5 0-2-.4-.2 0 1.4-3.7 1.4-4.5.9-10.8 2.4-17 2.4-17zm-.5 17.2s-1 .5-1 .2m0-1.2s.7 0 .8-.3m0-1s-.6.4-.8.1m.7-1.7h-.5m.6-1.5h-.6m.5-2s-.4 0-.4-.2m.5-1.7h-.5m-.5 9.6s-.9.1-1-.2m1.1-1.9s-.9 0-1-.2m1-1.3h-.7m.9-1.4h-.7m.7-1.7-.5-.1m.7-1.4-.6-.1m.6-1.6s-.4.2-.4 0m0 9s-.9 0-.9-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M274.3 211.3s.5 5.1.2 8c-.3 3.5-.3 4.5-.6 6.6v3.9c.8.5 1.5.2 2 0 .3-.1-1-3.3-1-4 .5-8.9-.4-14.3-.4-14.3l-.2-.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M274.3 211.3s.5 5.1.2 8c-.3 3.5-.3 4.5-.6 6.6v3.8c0 .5-.1 0 0 .1.8.5 1.4.2 2 0 .2-.1-1-3.3-1-4 .5-9-.4-14.3-.4-14.3zm-.3 14.6s.9.2 1 0m-.8-1.7s.9.2 1 0m-1-1.2h.9m-.8-1.2h.7m-.5-1.4h.5m-.5-1.3h.5m-.4-1.4s.4.2.4 0m-1 7.4s1 .1 1-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#005000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306 221.7h.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.7 256.4s-.3-.2-.4 0l.1.2zm-1 1.1 2.1-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M292.2 284.2c-.2 3-7.4 6.6-12.7.1-5.7-4.5-4.5-11.4 0-12.3l54.7-53.3c2.2-1.2 2.4-2.3 3.5-3.5 2.3 2.5 7 6.8 9.6 9-1.6 1.2-2.9 2.5-3.2 3.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M337.8 215c2.6-3.5 12.8 5.8 10 8.7-2.6 2.8-12.4-5-10-8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cccccf",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M347 223c-2 1.4-9.3-4.8-8.1-7.2 2-2.2 10.1 5.7 8 7.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344 227.9a15.8 15.8 0 0 1-9.9-9m-23 44.8a16.3 16.3 0 0 1-11.4-11.6m9.1 14.3a16.3 16.3 0 0 1-11.4-11.6m-2.1 25.8c-5.8-1.8-10.4-6-12.2-12.1m9.8 14.8a18 18 0 0 1-12.3-12.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M279.4 285c-.3 1.4-1 1.8-2.1 1.4m13.7-2c-2.1 3.5-4.5 2.4-6.5 2.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M276.4 285.2c0 1 .8 1.6 1.7 1.6a1.7 1.7 0 0 0 1.7-1.6c0-1-.7-1.6-1.7-1.6s-1.7 1-1.7 1.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M279.5 284.9c-.3 1.3-1 1.7-2 1.3m13.5-1.7c-2.1 3.4-4.5 2.3-6.5 2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m331.8 290.3 1 9-1.8-2.2c-.3-.6-1.5-2.1-1.8-7.4 0 0 1-2.9 1.4-2.9.7-.4 1.2 3.5 1.2 3.5zm-2.2-20.1 2.7 15.8c0 .5-1.3 1.6-2.1-1.2l-1.5-10.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m324.1 284.6 1.4-2 .4 3.1s-2 1.5-1.7 4.3l-.4-.6-.2-1s-.5-2-.5-3.1c0 0 .5-.2 1-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332.8 299.4s-3.4-3-3.6-9.7l-.4-1.9s0 1.5-.8.4c-.6-1.5-.6-2.8-.6-2.8s-1.2-1.6-1.6.3l1.2 9.6.3 2s.7-1 1.4.1c.7 1.2 1.8 2.7 4 2zm-4.1-25.1 1.5 10.5s-1.2.6-1.4 3c-.1 1.2-.6.6-.8.4-.2-.8 0-2.3 0-2.3l-.6-7.3s1.2-3.4 1.3-4.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m329.9 298.8.2 2.6s-1 0-1.7-1.2c-.8-1.1-1-2.8-1-2.8s.7-1.1 1.3 0c.5 1 1.2 1.4 1.2 1.4zm-1.8-10.6a6 6 0 0 1-.7-2.8l.7.5c-.2 1.2 0 2.3 0 2.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324.8 287.1a4.4 4.4 0 0 1 1.2-1.5l1.5 12s.4 3 2.3 3.7c0 0-1.1 10.3-4.5 7.5-.4-.4-1-3.6-.9-5.5l.9-6a26.8 26.8 0 0 0-.5-4.7 31 31 0 0 0-.6-2.6c-.2-.2 0-1.8.5-2.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m323.1 285.3-1 1c-.3 0 2.3 19.3 2.3 19.3s0-2 .7-6c.6-3.2-.2-7.5-.9-9.6 0 0-.8-.5-1-4.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m327.4 278.8.7 7.1s-1.8-2.4-2.2-.2l-.4-3.2s1.5-2.4 2-3.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.7 287.8s.6-6.1 3.6-1.8c0 0 .2 2.4 0 3 0 .8-.9 1.8-1.2 2.3-.7 1-1.3-.2-1.3-.2s-.7-1-1-3.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M352.2 237c.1-3.5 1.2-9.3 1.3-13.3l12-12.2s1.4 9.9 5.8 15.5l-19 10"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M351.3 237.3c-.5-2.4-1-5-1.5-10.2l7.7-7.6c0 3.2 3.6 8.1 3.9 14"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.7 244.7c-1-4.3 1.3-4.8-2-10.8l7.2-6.8c1.3 4 2.2 6.6 2 10l-6 4.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M372.4 270c1.5-4.2-.5-12.7-.2-18 .1-3.5-2.5-16.7-2.4-20.6l14.1-8.8s.6 14.3 2.3 29.9c1.4 8 1.4 15.3.4 21.5-1.5 8.7-3 12.2-6.5 15.9-6.3 6.5-19.7 2.7-19.7 2.7-11.3-2.3-17.8-9.4-17.8-9.4s3.7.8 9.6 1.4c13-.9 18.2 2.4 18.6-11"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m334.6 278.8-.2-.1 5.9 1.9 8 .6c17.2.4 15-10.3 14.3-27.5-.1-6.6-1.4-14.8-1-17.7l11.5-6.6c3.8 10.6 2.6 18 3.3 23.5.4 6 1.7 17.4-.2 22.4-2.7 11.6-11.8 11.2-24.2 10.1-6.1-.5-9.4-2-9.4-2l-8-4.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007a3d",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334.4 278.5a34.4 34.4 0 0 0 6 2.2l8 .8c12.5 1 19.8-7.7 18.2-27.6 0-7-.2-10.2-2.6-19.5l-7 4v.7c.5 2 1.5 7 1.5 9.2 0 16-10.1 28.2-23.9 30.3h-.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M380 230.6c-1 2-8 12.5-12 14.5m11-7.6c-1.3 2-9.8 14-13.6 14.6m15.5 3.6c-2 2.4-4 7-9.7 10m7 3.3c-4 3.7-13.6 11.6-23 12m23-6c-2 2.3-6.2 13.3-24 8.3m26.7-6.3c-1.2 2.6-10.1 17.3-26 11.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M362.3 264.8c1.4-4.3-.6-12.7-.4-18.1.2-3.5-1.4-15.5-1.4-19.5l13.2-9.9s.6 14.3 2.3 30a84 84 0 0 1 1.5 23.9c-1.8 10-6.6 12.8-7.5 13.6-6.7 6-22 5.4-23.5 4.9-10.8-4-15.6-10.8-15.6-10.8s5.2-.1 11.1.5c13-1 19.7-.4 20.1-13.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324.4 273.5h-.2l5.9 1.8 8 .6c17.2.5 15-10.2 14.3-27.5-.1-6.5-.3-12.4 0-15.3l10.3-7.6c3.8 10.7 2.8 16.7 3.5 22.2.4 5.8 1.7 17.3-.2 22.3-2.7 11.7-11.8 11.2-24.2 10.2-6.1-.5-9.4-2.1-9.4-2.1l-8-4.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324.1 273.4a34.4 34.4 0 0 0 6 2.1l8 .8c12.5 1 19.8-7.7 18.2-27.6 0-7 .3-7.5-2.2-16.9-3.8 2.5-11.1 8.8-11.1 8.8s2 2.8 1.5 6.7c0 16-6.4 24-20.2 26.1l-1.5-13"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M369.9 225.3c-1.2 2-8.1 12.6-12 14.6m10.8-7.7c-1.2 2-9.7 14-13.5 14.7m15.5 3.6c-2 2.3-4 7-9.7 10m7 3.3c-4 3.6-13.6 11.6-23 12m23-6c-2 2.3-6.2 13.2-24 8.3m26.7-6.4c-1.2 2.7-10.1 17.3-26 11.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m383.8 224 .7 6c.2 4.4.1 7.7-.1 9.8 0 .2-.8 5.5-.6 5.8 1 1.1 1.1 1.2 2.2.4.1-.2-.5-5.6-.5-6.3l-.4-9.9c0-1-1-6.4-1-6.4s0-1.2-.3.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m383.8 224 .7 6c.2 4.4.1 7.7-.1 9.8l-.7 5.8c1 1.1 1.2 1.6 2.3.7.1-.2-.5-5.9-.5-6.6l-.4-9.9c0-1-1-6.4-1-6.4s0-1.2-.3.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M384 222.2s1 6 1.2 9.6l.3 7.9.5 4.5c.1.7 0 .2 0 .2.9.5 1.5.1 2-.3.2-.1-1.4-3.8-1.4-4.5-.9-10.8-2.4-17-2.4-17s.6 3.7-.3-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M384 222.2s1 6 1.2 9.6l.3 7.9.5 4.5c.1.7-.1.2 0 .2.9.5 1.5.1 2-.3.2-.1-1.4-3.8-1.4-4.5-.9-10.8-2.4-17.1-2.4-17.1s.6 3.8-.3-.3zm.4 17.3s1 .4 1 .2m0-1.3s-.7 0-.8-.2m0-1s.6.3.8 0m-.7-1.6h.5m-.6-1.5h.6m-.5-2.1s.4.1.4-.1m-.5-1.7h.5m.5 9.5s.9.2 1-.1m-1.1-2s.9.1 1-.1m-1-1.3h.7m-.9-1.5h.7m-.7-1.7h.5m-.7-1.5h.6m-.6-1.7s.4.3.4 0m0 9s.9 0 .9-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m373.6 218.7.7 6a73 73 0 0 1-.1 9.8c0 .3-.8 5.5-.6 5.8 1 1.2 1.1 1.3 2.2.4.1-.1-.5-5.5-.5-6.3l-.4-9.8c0-1.1-1-6.5-1-6.5s0-1.1-.3.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m373.6 218.7.7 6a73 73 0 0 1-.1 9.8l-.7 5.8c1 1.2 1.2 1.6 2.3.7.1-.1-.5-5.8-.5-6.6l-.4-9.8c0-1.1-1-6.5-1-6.5s0-1.1-.3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M373.7 217s1.2 6 1.3 9.5l.3 8 .5 4.4v.3c.9.5 1.5 0 2-.4.2 0-1.4-3.7-1.4-4.5a127 127 0 0 0-2.4-17l-.3-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M373.7 217s1.2 6 1.3 9.5l.3 8 .5 4.4v.3c.9.5 1.5 0 2-.4.2 0-1.4-3.7-1.4-4.5-.9-10.8-2.4-17-2.4-17zm.5 17.2s1 .5 1 .2m0-1.2s-.7 0-.8-.3m0-1s.6.4.8.1m-.7-1.7h.5m-.6-1.5h.6m-.5-2s.4 0 .4-.2m-.5-1.7h.5m.5 9.6s.9.1 1-.2m-1.1-1.9s.9 0 1-.2m-1-1.3h.7m-.9-1.4h.7m-.7-1.7.5-.1m-.7-1.4.6-.1m-.6-1.6s.4.2.4 0m0 9s.9 0 .9-.4m-10.5-22s-.5 5.2-.2 8.1c.3 3.5.3 4.5.6 6.6v3.9c-.8.5-1.4.2-2 0-.2-.1 1-3.3 1-4-.5-8.9.4-14.3.4-14.3l.2-.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M365.7 211.3s-.5 5.1-.2 8c.3 3.5.3 4.5.6 6.6v3.8c0 .5.1 0 0 .1-.8.5-1.4.2-2 0-.2-.1 1-3.3 1-4-.5-9 .4-14.3.4-14.3zm.3 14.6s-.9.2-1 0m.8-1.7s-.9.2-1 0m1-1.2h-.9m.8-1.2h-.7m.5-1.4h-.5m.5-1.3h-.5m.4-1.4s-.4.2-.4 0m1 7.4s-1 .1-1-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#005000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334 221.7h-.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323.3 256.4s.3-.2.4 0l-.1.2zm1 1.1-2.1-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.7 215.5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5l.2.9c0 .3-.5 1.6-2 2.7a11.5 11.5 0 0 1-4.1 1.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#a05a2c",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m291.6 214.7 29.7 38.4 1.4-1.3-30.2-39.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.2 207.2s3.2-.4 2.8-2.2c-.5-1.8-2.6-1.8-3.5-1.9-1 0-4 .7-4.8 1.5-.9 1-2.7 2.5-2.1 5s1.3 4.4 2.3 6c.9 1.6.7 3.2.4 3.9 0 .3-.4 1.3.4 1.6 1.2.5 1.5.5 2.5-.6s2.5-3 2.5-5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5 0 0-.7-1.2-1.8-1-1.1 0-3.4-1-4.6-2.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.2 207.2s3.2-.4 2.8-2.2c-.5-1.8-2.6-1.8-3.5-1.9-1 0-4 .7-4.8 1.5-.9 1-2.7 2.5-2.1 5s1.3 4.4 2.3 6c.9 1.6.7 3.2.4 3.9 0 .3-.4 1.3.4 1.6 1.2.5 1.5.5 2.5-.6s2.5-3 2.5-5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5 0 0-.7-1.2-1.8-1-1.1 0-3.4-1-4.6-2.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.2 207.2c-.4 0-1.7-.6-2.6-.3-.9.4-2.7 1.4-2.4 3m10.4-.3s-1.8.8-3.1 1.7c-.6.3-2.4 2-3.5 3.2-1 1-1.3 2.4-3.5 3.9m9-9-1.4 1c-.7.3-.9.9-1.2 1.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M347.8 284.2c.2 3 7.4 6.6 12.7.1 5.7-4.5 4.5-11.4 0-12.3l-54.7-53.3c-2.2-1.2-2.4-2.3-3.5-3.5a133 133 0 0 1-9.6 9 9.9 9.9 0 0 1 3.2 3.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M302.2 215c-2.6-3.5-12.8 5.8-10 8.7 2.6 2.8 12.4-5 10-8.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#cccccf",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293 223c2 1.4 9.3-4.8 8.1-7.2-2-2.2-10.1 5.7-8 7.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296 227.9a16 16 0 0 0 9.9-9m23 44.8c5.7-1.7 9.6-5.5 11.4-11.6m-9.1 14.3c5.7-1.8 9.7-5.5 11.4-11.6m2.1 25.8c5.8-1.8 10.4-6 12.2-12.1m-9.8 14.8a18 18 0 0 0 12.3-12.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M360.6 285c.3 1.4 1 1.8 2.1 1.4m-13.7-2c2.1 3.5 4.5 2.4 6.5 2.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M363.6 285.2c0 1-.8 1.6-1.7 1.6a1.7 1.7 0 0 1-1.7-1.6c0-1 .7-1.6 1.7-1.6s1.7 1 1.7 1.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M360.5 284.9c.3 1.3 1 1.7 2 1.3m-13.5-1.7c2.1 3.4 4.5 2.3 6.5 2.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.6 175.5c1.8 2.9 4.4 8 5.2 12a22.5 22.5 0 0 1-7 20.8c-5.2 4.7-13.3 6-16.7 6.8-3.3.7-5.7 1.8-6.3 2.5 0-.5 0-1 .5-1.6 1.6-.7 4.1-1 7.8-1.8 7.2-1.5 14.8-4.2 19-12.2 5.4-10.3 2.2-18.4-2.5-26.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.6 206.2a.4.6 49.9 0 1-.6-.6.4.6 49.9 1 1 .6.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346.6 205c-1.1.6-2.2.7-3 1a65.7 65.7 0 0 0-3.7 1.4c-.8.3-1.6 1.3-1.6 1.3s1.2 1.3 2.6 1.1c1.2-.1 1.7-.4 2.3-.7.6-.3.6-.6 1.4-1.2 1-.7 1.6-2 2-3zm-5.7 1.1c-.3.6-1.1.5-1.6.5l-.2.2c.6 0 1.5 0 2-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346.6 205c-1 1-2.8 2-4.7 2.8a14 14 0 0 1-5 1l-.2.3c1.4-.1 3.4-.4 5-1.1a14.9 14.9 0 0 0 4.9-3zm-2.4 4.6c-2-.1-3 .5-4.8.9-1.7.4-3.7-.5-4.8 1.1 4.4 2.9 7.6 1 9.6-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.2 213.6c-.8-.8-8-3.2-9.2-.5 1.7 2 6.8 2.4 9.2.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m338.5 215.5-2.5-.4c-1-.1-1.3-.3-1.9-.4-1-.1-2.3-1.6-6-.5 1.4 3.4 6.4 4 10.4 1.3zm1.6-1.9c-3.8.8-8.3 0-10.1-1l-.3.2a16.3 16.3 0 0 0 10.4.8zm4-4c-2.2 1.5-5.2 2.6-11.4 1.8v.2c8.5.7 9.3-.8 11.4-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 215.5c-3 .1-4.7 1.4-10.3-1.3l-1.4-.6-.5.2 1.4.4c7 3 6.8 1.6 10.8 1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.3 211.6a.4.6 66.2 1 0 .4.7.4.6 66.2 0 0-.4-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.1 212.3c-.6.1-.8.9-.8 1.3l-.4.2c.2-.6.4-1.4 1.2-1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346 186.8a.4.6 15.8 1 1-1-.2.4.6 15.8 0 1 1 .2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.6 203.2c-.1-2.1-1.1.8-3.2-3.9-.6-1.4-.6-2.2-1-4.3 1.2 1.8 3 2.3 3.8 3.6.7 1.4.5 3.5.4 4.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M337.5 195.2s1 2.4 2.4 4a7.9 7.9 0 0 1 1.8 3.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 197.2c1.3 1.7 3 3.8 3 6h.3c-.3-2.8-2-4.1-3-5.6zm10.8 2.7c-1 .7-2 1-2.7 1.4l-1.4.9c-.4.2-1 .2-1.4.5-.7.5-2 2-2 2s1.3 1.1 2 1c2.4-.5 3.1-1.4 4.3-2.3 1-.8 1-2.5 1.2-3.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m340.7 204.8-.2.4c1.3-.2 3.5-1.5 5-2.2 1.8-1 3-1.7 3.7-3a8.9 8.9 0 0 1-3.9 3c-1.5.7-3.7 2-4.6 1.8zm9.4-9.5c-.8.9-1.7 1.3-2.4 1.8l-1.3 1.1-1.2.8c-.6.6-1.5 2.2-1.5 2.2s.7.7 1.4.4c2.4-.3 3.1-1.4 4-3.5.5-1 1-1.8 1-2.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.5 199.4a.6.4 62 1 0 .8-.3.6.4 62 0 0-.8.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m342.5 201.6-.2.3c2.9-1.3 6.6-3.9 7.8-6.5a17.2 17.2 0 0 1-7.6 6.2zm8.3-10.7c-.7 1-1.6 1.4-2.2 2l-1 1.1-1.2.9c-.5.6-1.2 2.2-1.2 2.2s.8.9 1.5.5a12 12 0 0 0 2.1-1.6c.5-.4.6-1.4 1.2-2.2.7-1 .8-1.9.8-2.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.7 193.8c-1.4 1.6-3 3.1-4.6 3.8l-.2.4c2.6-1.5 3.7-2.8 4.9-4.1zm1-5.6c-.4 1-1 1.5-1.6 2l-.8 1.2-1 .9-.7 2.1s.6.6 1.2.2a12 12 0 0 0 1.8-1.6c.4-.5.6-1.4 1-2.2a4 4 0 0 0 .2-2.6zm-4.3-1.1-.5 1.6v-.4c0-.4.2-.9.4-1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.4 191a13 13 0 0 1-3.8 4v.3c2.2-1.6 3-3 3.8-4.2zm-5.6 10c-.2-.6-.3-1-.6-1.4.2.5.4 1 .4 1.6l.1-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.9 181.3a.4.3 39.5 0 1-.5.5.4.3 39.5 0 1 .5-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m343.1 182.5-1.2-.8 1.3 1v-.2zm5.6.4c-1.2 2.4-3.9 4-2.8 7.5 2.8 2.6 3-4.5 2.8-7.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346.1 177.7c-.5 2.4-2.6 4.4-1.2 7.6 4 1 2-4.3 1.2-7.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.7 174c2 3.7 2.5 5.9.2 8.3 0 0-1.3-1.1-1.6-3.3-.2-1.8 1.2-4 1.4-5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.4 171.8c.5 2.4-1.5 3.5 1.4 6.5 2.1-2.4 1.1-3-1.4-6.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.6 176c-3.3.3-2-2.6-3-5.3 2 1.5 4.7 2.1 3 5.3zm2.2 4.4c-1-4.4-4-2.6-5.6-4.6.9 2.9 2.1 4.8 5.6 4.6zm1.4 4.1c-2.6-.1-4.8-1.4-6.2-4.4 2.7 1.2 5.7 1.4 6.2 4.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.6 188.3c-1-1.2-1-2-1.5-2.7a9 9 0 0 0-3-3.7c0 3 .4 6.5 4.5 6.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.2 191.6a20 20 0 0 0-5.6-5.7c1 2.2.6 6.3 5.6 5.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.7 196c-5-.1-4.5-4.8-4.5-7 .9 1.4 2 2.5 2.8 3.5.9 1 1.8 2.2 1.7 3.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.1 198.8c-.4-1 0-1.4-1-2.3-1-1-2.8-2.7-3.7-4.6-.1 1.7-.2 4.4 1.2 5.3 1 .7 2 .9 3.5 1.6zm-4.3 7.3c-3.9-3-1.6-5.6-1.2-7.9 1 2.6 3.7 4.8 1.2 7.9zm1.6-29.2c-1.3-2.3-2-3.6-3.7-6 2 2.7 2.8 4.5 3.9 6.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.9 206.8c.1-3-.7-5.7-1.3-8.5.5 3 1.3 6 1 8.8zm4.6-7.4c-.4-1.8-4.1-3-5-7.5.7 4.4 4.5 5.5 4.8 8zm.8-2.5-.1.5c-.6-3-4-4.4-5-8.4 1.5 4.3 4.3 4.9 5.1 7.9zm.7-4.4c-1.7-2.6-4.1-3.6-6.4-6.7 2.1 3 4.8 4.4 6.4 7zm0-3.5c-2-.8-3.9-3-6-7.1 1.4 3 3 5.8 6 7.6zm-1-4c-2.1-1.7-5-2.8-7-4.9 1.7 2 5 3.3 7.1 5.2v-.3zm-1.6-4.3c-2.2-1.5-4.4-2-6.2-4.8 1.5 2.8 3.8 3.5 6.3 5zm6.3 2.2c-.8 3.1-1.5 6.3-3.6 8.4v-.4c1-.5 2.5-3.7 3.6-8zm-2.6-5.1c-.1 3.2 0 6.5-1.7 8.3l-.1-.3c1.6-1.4 1.5-5 1.8-8zm-2.2-3.6c.5 2.8.6 5.3-.2 9.5l-.1-.3c.4-2.4 1-5 .3-9.2zm-3.4-2.3c1.1 2.4 2 4.8 1.2 7.4l-.2-.3c.9-2.4-.1-4.7-1-7zm-4.4 31.2c1.4 3.2-.4 5.6-2.5 7-1.6-4.7 1.8-4.2 2.5-7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M336.2 203.1c.2 2-2 4.2-2.6 7.6l-.3.2c1-4 3-5.6 2.9-7.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.7 181.2a.3.4 1.9 1 1-.6-.1.3.4 1.9 0 1 .6.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.5 183v-1.6h-.2v1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M342.8 180.9a.3.4 2 0 1-.5.2.3.4 2 0 1 .5-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m343.2 182.3-.5-1.1.4 1.4v-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.7 186.9a.4.3 80.5 1 1-.7 0 .4.3 80.5 0 1 .7 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.9 188.6a9.3 9.3 0 0 0-.4-1.4h-.1l.4 1.6v-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.6 187.2a.4.3 57 1 1-.5.5.4.3 57 0 1 .5-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.8 188.6a8.8 8.8 0 0 0-1.2-1v.1l1.3 1.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.4 199.1a.3.4 12.7 1 1-.7-.2.3.4 12.7 0 1 .7.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M342.8 200.8c.2-.5.2-1 .2-1.5a9 9 0 0 1-.4 1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344 199.9a.3.4 50.5 1 0 .5.4.3.4 50.5 1 0-.5-.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m342.7 201 1.3-.8v.1a8.7 8.7 0 0 0-1.3 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.7 205a.3.4 40.4 1 1-.4-.6.3.4 40.4 0 1 .4.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m339.5 206.2.9-1.3h-.1l-1 1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.8 204.5a.5.6 10 0 0 1 .1.5.6 10 1 0-1 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.4 205c-.3.7 0 1 0 1.2l-.1.3c-.2-.4-.3-.8-.1-1.5zm-12.1 9.5c-.7 0-1-.4-1.3-.8h-.3c.4.5.8 1 1.5 1v-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.3 215.2a.6.4 9.5 0 1 .2-.9.6.4 9.5 1 1-.2.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332.7 206a5.5 5.5 0 0 1-4 6.4c-.9-4 2.8-4 4-6.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332.7 206.1a21 21 0 0 1-4.8 7.2h-.5c2.7-2.1 4.2-4.9 5.3-7.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.8 213.3a.5.4 9.8 1 1-.4-.7.5.4 9.8 0 1 .4.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M326 213.8a8 8 0 0 0 1.4-.7h-.1l-1.7.6h.3zm2.5-5c0 1.2-1 2.4-2 3.2-.9.9-1 1.2-2.2 1.6-1.2-2.8 2.8-3.3 4.2-4.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.5 208.8c-1.3 2.5-3.5 3.8-4.7 5.4h-.1c1.6-2.2 3-2.7 4.8-5.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.4 175.5c-1.7 2.9-4.4 8-5.1 12a22.5 22.5 0 0 0 7 20.8c5.2 4.7 13.3 6 16.6 6.8 3.4.7 5.8 1.8 6.4 2.5 0-.5 0-1-.5-1.6-1.6-.7-4.2-1-7.8-1.8-7.2-1.5-14.9-4.2-19-12.2-5.4-10.3-2.2-18.4 2.5-26.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.1 213.6c-.2.4-4 3.7-7.5 3.5-2.5-.2-2.9-.8-2.9-.8s-.2-.7 2-1.1c2.3-.5 6.2-2 8.4-1.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.8 216.3c2.7.3 5.5-.8 7.7-1.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.2 208.7a11 11 0 0 1 4.6 3.7c.9 1.5.7 1.9.7 1.9s-.2.3-1.3-1c-1-1.2-3.4-3.3-4-4.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.5 214.2c-.9-1.7-2.5-3-3.7-4.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.3 175.8c-.1-.3.3-3.4 2-4.4 1.3-.7 1.8-.5 1.8-.5s.3.3-.5 1.3c-1 1-2.1 3.2-3.3 3.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304 171c-1.4.7-2.3 2.2-3 3.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.4 177.4c-.2-.2-1-3-.2-4.7.5-1.3.9-1.4.9-1.4s.3 0 .1 1.3c-.2 1.3-.2 3.8-.8 4.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300 171.4c-.6 1.3-.6 3-.6 4.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.4 177.5c.2 0 2.7-.8 3.9-2.1.8-1 .8-1.3.8-1.3s-.2-.2-1.1.5c-1 .8-3 2-3.6 2.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304 174.1c-.9 1.1-2.2 2-3.3 2.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.2 179.6a10 10 0 0 1-.9-5.2c.3-1.6.6-1.7.6-1.7s.4 0 .4 1.4c0 1.5.3 4.2-.1 5.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298 172.7c-.5 1.7-.2 3.6 0 5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.3 181.6c-.3-.2-2.3-3-2-5.2 0-1.7.5-2 .5-2s.3-.1.6 1.4c.3 1.6 1.2 4.3.9 5.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.7 174.5c-.2 1.8.5 3.7 1 5.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.2 184.1a9.9 9.9 0 0 1-2.4-4.7c-.2-1.5 0-1.8 0-1.8s.4-.1.8 1.3c.4 1.4 1.6 3.9 1.6 5.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293.9 177.7c.1 1.7 1 3.4 1.5 4.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.2 179.6c.3 0 3.2-.2 4.6-1.7 1-1 1-1.5 1-1.5s-.2-.3-1.4.4c-1.1.8-3.4 1.8-4.2 2.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.7 176.5c-1 1.2-2.7 1.9-4 2.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.3 181.6c.2 0 3.2 0 4.6-1.4 1.1-1 1-1.4 1-1.4s0-.3-1.2.3c-1.2.7-3.6 1.5-4.4 2.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303 178.9c-1.2 1-2.8 1.7-4.1 2.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.4 184.2c.2 0 3.4-.2 4.9-1.7 1-1.1 1-1.5 1-1.5s-.1-.4-1.4.3c-1.2.8-3.7 1.8-4.5 2.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.3 181c-1.2 1.3-2.9 2-4.3 2.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.8 183s-.3-.5-.3-1c0-.6.2-.8.2-.8l-.2-.2-.1.9v.3l-.5-.5a10.8 10.8 0 0 1-.1-.4h-.2l.3.7c.5.4.8 1.1.8 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.6 180.3a.5.4 83.5 1 1 .1 1 .5.4 83.5 1 1-.1-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.8 180.3a.4.5 19.3 1 1-.3 1 .4.5 19.3 1 1 .3-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m296.7 183 1-.7c.3-.4.3-.7.3-.7h.2l-.4.8-.2.2.6-.1.4-.2.1.1-.6.4c-.6 0-1.3.3-1.3.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.4 181.6a.4.5 45.6 1 0-.8.8.4.5 45.6 1 0 .8-.8z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.4 180.8a.4.5 19.8 1 0-.3 1 .4.5 19.8 1 0 .3-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.4 186.9c-.2-.2-2.4-2.6-2.8-4.8-.3-1.6 0-1.9 0-1.9s.3-.1.8 1.3c.6 1.5 2 4 2 5.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M292.6 180.3c.2 1.8 1.2 3.5 2 4.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.6 186.9c.3 0 3.5-.4 5-2 1-1.3 1-1.7 1-1.7s-.2-.4-1.4.5-3.8 2-4.6 3.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.5 183.2c-1 1.4-2.8 2.2-4.2 3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.2 189.6c.3 0 3.5-.9 5-2.6 1.1-1.3 1-1.7 1-1.7s-.1-.2-1.4.7c-1.2 1-3.8 2.5-4.6 3.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.2 185.4c-1.1 1.4-3 2.4-4.3 3.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 189.6c-.3 0-3.3-2.2-3.8-4.5-.3-1.7 0-2 0-2s.5-.3 1.2 1.2c.7 1.4 2.5 3.8 2.7 5.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.3 183.2c.3 1.8 1.5 3.5 2.5 4.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.2 193a11 11 0 0 0 4.6-3.6c.9-1.5.7-1.8.7-1.8s-.2-.3-1.3 1c-1 1.2-3.4 3.1-4 4.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.5 187.7c-1 1.6-2.5 3-3.8 4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 193.2c-.3 0-3.6-1.7-4.4-4-.7-1.6-.4-2-.4-2s.4-.4 1.3 1c1 1.3 3.1 3.5 3.5 5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M290.3 187.2c.5 1.8 2 3.4 3.2 4.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 191.6s-.4-.5-.5-1c-.2-.6 0-.9 0-.9h-.3v.8l.2.4-.6-.4-.3-.5-.2.2.5.6c.6.2 1.1 1 1.1 1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293 189a.6.4 69.4 1 1 .4 1.2.6.4 69.4 1 1-.4-1.1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.3 188.7a.4.6 5.2 1 1 0 1.2.4.6 5.2 1 1 0-1.2z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 191.6s.6-.5.8-1c.3-.5.2-.8.2-.8h.3l-.3.8-.1.4.6-.3.4-.4.1.2-.6.5c-.6.1-1.2.7-1.2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.5 189.4a.4.6 31.5 1 0-.6 1 .4.6 31.5 1 0 .6-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.3 188.9a.4.6 5.7 1 0-.1 1.1.4.6 5.7 1 0 0-1.1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.4 196.2a12 12 0 0 1-5.1-4c-1-1.7-.8-2.1-.8-2.1s.2-.3 1.4 1c1.3 1.4 3.8 3.6 4.5 5.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M289.5 190.2c1 1.8 2.8 3.3 4.2 4.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.6 196.2c.4 0 4-1.9 5-4.4.6-1.8.3-2.3.3-2.3s-.4-.3-1.4 1.2c-1 1.4-3.4 3.8-3.9 5.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.9 189.6c-.7 2-2.3 3.7-3.6 5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.6 199.3c.3-.1 3.7-2.3 4.5-4.8.7-1.9.4-2.3.4-2.3s-.4-.3-1.3 1.3c-1 1.5-3.2 4-3.6 5.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.5 192.3c-.7 2-2.2 3.8-3.4 5.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.3 199.3c-.4 0-4.7-1.3-6.2-3.8-1-2-.9-2.5-.9-2.5s.4-.4 1.8 1c1.5 1.4 4.5 3.5 5.3 5.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M289.3 193.1c1.1 2 3.3 3.6 5 4.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.1 205.7c.3-.2 2.6-3 2.8-5.6.2-1.8-.2-2-.2-2s-.3-.2-.8 1.4c-.5 1.7-1.8 4.6-1.8 6.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.8 198.1c-.1 2-1 4-1.8 5.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300 205.6c-.5.2-5.4 0-7.7-2.1-1.6-1.6-1.5-2.2-1.5-2.2s.2-.5 2.1.5c2 1 5.7 2.3 7 3.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M290.9 201.4c1.7 1.7 4.4 2.6 6.5 3.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.2 203c-.4.1-4.8-1-6.8-3.1-1.6-1.6-1.5-2.1-1.5-2.1s.2-.4 2 .8c1.6 1.2 5 3 6.3 4.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M290 197.9c1.6 1.7 4 3 5.8 4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.4 203c.4-.2 3.6-2.9 4-5.6.2-2-.2-2.5-.2-2.5s-.5-.2-1.2 1.5c-.7 1.8-2.6 4.7-2.6 6.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.2 195c-.2 2.2-1.5 4.3-2.5 6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m297.4 201.5-1-.8c-.4-.5-.5-.9-.5-.9h-.3a8 8 0 0 0 .8 1.2l-.8-.1-.5-.3v.2l.7.4c.7 0 1.6.5 1.6.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.2 199.8a.7.5 45.9 1 1 1 1 .7.5 45.9 1 1-1-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.4 198.8a.7.5 71.6 1 1 .4 1.3.7.5 71.6 1 1-.4-1.3z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.5 201.4s.4-.6.4-1.3l-.1-1h.2a7.8 7.8 0 0 0 .1 1.3l.6-.5.2-.6.2.1-.4.8c-.6.5-1 1.4-1 1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.1 198.2a.5.7 8 1 0-.2 1.3.5.7 8 1 0 .2-1.3z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.6 198.1a.7.5 72.2 1 0 .4 1.3.7.5 72.2 1 0-.4-1.3z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.8 207.6c-.3.2-4.3 1-6.8-.3-1.8-.9-2-1.4-2-1.4s0-.5 2 0c1.8.4 5.2.7 6.8 1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293.1 206c2 1 4.4 1.2 6.3 1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302 207.5c.2-.1 2-2.5 1.9-4.8 0-1.7-.4-2-.4-2s-.3-.2-.6 1.3c-.2 1.5-1 4-.9 5.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.5 200.8c.2 1.8-.4 3.6-.9 5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.5 210.3c-.3.3-5 1.5-8 .3-2-1-2.1-1.5-2.1-1.5s0-.5 2.2-.1c2.1.3 6.2.4 8 1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.5 209.2c2.2 1 5 1 7.3 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.8 210.3c.2-.3 1.2-3.8 0-5.6-1-1.4-1.5-1.3-1.5-1.3s-.4 0 0 1.5c.3 1.5.5 4.3 1.5 5.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304.4 203.4c1 1.4 1.1 3.4 1.3 5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.3 208.7s-.5.4-1.2 0c-.6-.3-.8-.7-.8-.7l-.3.2 1 .7.3.2-.9.2-.6-.1v.3h1a13.6 13.6 0 0 0 1.5-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.5 208.7a.8.5 24.1 1 1 1.4.7.8.5 24.1 1 1-1.4-.7z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.3 207.2a.8.5 49.9 1 1 1 1.2.8.5 49.9 1 1-1-1.2z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.4 209s.6-.5.2-1.2l-.6-.9.1-.2.7 1 .2.3.2-.9v-.6h.2v1l-.5 1.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.7 205.1a.8.5 69.5 1 0 .6 1.5.8.5 69.5 1 0-.6-1.5zm-1.5.8a.8.5 43.7 1 0 1 1 .8.5 43.7 1 0-1-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.3 211.8c-.3.4-4.2 3-7.4 2.3-2.3-.4-2.6-1-2.6-1s-.1-.6 2-.8c2.2-.1 6-1 8-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.4 213.1c2.5.6 5.2 0 7.3-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.8 212.6s-.5.7-1.3.5a3 3 0 0 1-1.2-.5l-.3.3 1.3.4.5.1-.9.6-.7.1v.3l1.2-.3c.2 0 1.4-1 1.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306.6 214a.9.6 5.4 1 1 1.7.2.9.6 5.4 1 1-1.7-.1zm.4-2a.9.6 31.2 1 1 1.5 1 .9.6 31.2 1 1-1.5-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.5 212.2c.2-.3.7-4-1-5.6-1.1-1.2-1.7-1-1.7-1s-.5.1.1 1.5c.7 1.4 1.4 4.2 2.6 5.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306.8 205.6c1.4 1.2 1.9 3.2 2.3 4.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.4 213s.2-.7-.5-1.2c-.6-.5-1.1-.6-1.1-.6v-.4l1.2.7.4.3c.4.3 0-.8-.2-1l-.4-.7.3-.2.5 1 .2 2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.7 209a.9.6 42.7 1 0 1.3 1.1.9.6 42.7 1 0-1.3-1.2zm-1.2 1.5a.9.6 17 1 0 1.7.6.9.6 17 1 0-1.7-.6z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M319.1 209s-2.3 5.4-1.5 6c0 0 2.4-4.3 4.4-5.8 1.1-1 1.8 0 2-1 0-.8-3-2.1-3-2.1l-1.8 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M319.1 209s-2.3 5.4-1.5 6c0 0 2.4-4.3 4.4-5.8 1.1-1 1.8 0 2-1 0-.8-3-2.1-3-2.1l-1.8 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M310.6 213.1s-3.4 6-2.5 6c.8 0 4.5-7.5 4.5-7.5l-1.3.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.6 213.1s-3.4 6-2.5 6c.8 0 4.5-7.5 4.5-7.5l-1.3.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M311.6 211.5s-3.6 5.8-2.7 5.9c1 .1 4.8-7.4 4.8-7.4l-1.3.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.6 211.5s-3.6 5.8-2.7 5.9c1 .1 4.8-7.4 4.8-7.4l-1.3.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M312.3 210.5s-4 5.4-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.3 210.5s-4 5.4-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M313.4 209.5s-4.8 4.9-3.9 5.2c.8.3 6.2-6.2 6.2-6.2l-1.2-.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.4 209.5s-4.8 4.9-3.9 5.2c.8.3 6.2-6.2 6.2-6.2l-1.2-.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M313.6 207.7s-4.2 5.4-3.3 5.6c.9.2 5.5-6.9 5.5-6.9l-1.3.1-1 1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.6 207.7s-4.2 5.4-3.3 5.6c.9.2 5.5-6.9 5.5-6.9l-1.3.1-1 1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M312.5 212.4s-4 5.5-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.5 212.4s-4 5.5-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.8 211.3s-2.4 4.5-2.1 4.6c.3.2 3.1-2.5 4.6-5.2 1.4-2.6-2.6.5-2.6.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.8 211.3s-2.4 4.5-2.1 4.6c.3.2 3.1-2.5 4.6-5.2 1.4-2.6-2.6.5-2.6.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M315 210.8s-2.3 5.5-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.1 0-.1l-.2-2.9-2 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M315 210.8s-2.3 5.5-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.1 0-.1l-.2-2.9-2 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M313.8 210.4s-4.7 4.8-3.9 5.1c.9.3 6.3-6.1 6.3-6.1l-1.3-.1-1 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.8 210.4s-4.7 4.8-3.9 5.1c.9.3 6.3-6.1 6.3-6.1l-1.3-.1-1 1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.2 211s-4.7 5-3.9 5.2c.8.3 6.2-6.2 6.2-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.2 211s-4.7 5-3.9 5.2c.8.3 6.2-6.2 6.2-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.6 211.8s-4.8 4.9-4 5.2c1 .3 6.3-6.2 6.3-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.6 211.8s-4.8 4.9-4 5.2c1 .3 6.3-6.2 6.3-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M315 205.1s-3.6 4.5-3 5.3c.4.8 3.6-2 4.7-4 1-2-1.7-1.4-1.7-1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315 205.1s-3.6 4.5-3 5.3c.4.8 3.6-2 4.7-4 1-2-1.7-1.4-1.7-1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.8 209.9s-3 5.8-2.2 5.5c.8-.4 3.8-4.7 4.2-5.7.3-1 .2-2 .2-2l-2.3 1.5.2 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.8 209.9s-3 5.8-2.2 5.5c.8-.4 3.8-4.7 4.2-5.7.3-1 .2-2 .2-2l-2.3 1.5.2 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.8 208s2.5-4.6 0 .9-3.4 4.5-3.4 4.5c-.2-.3 2.2-4 2.2-4s1.7-2.8 2.1-3.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.8 208s2.5-4.6 0 .9-3.4 4.5-3.4 4.5c-.2-.3 2.2-4 2.2-4s1.7-2.8 2.1-3.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M317.5 207.4s2.8-4.6 0 .9c-2.8 5.4-3.9 4.5-3.9 4.5-.2-.3 2.5-4 2.5-4s2-2.8 2.4-3.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.5 207.4s2.8-4.6 0 .9c-2.8 5.4-3.9 4.5-3.9 4.5-.2-.3 2.5-4 2.5-4s2-2.8 2.4-3.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.5 205.5s-3.5 4.5-3 5.2c.5.8 3.7-2 4.7-4s-1.7-1.4-1.7-1.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M352.8 251a32.8 37 0 1 1-65.6 0 32.8 37 0 1 1 65.6 0"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#390",
      strokeWidth: 0.8,
      d: "M293.7 251c0-17 12-30.2 26.3-30.2s26.3 13.1 26.3 30.3",
      color: "#000",
      fontFamily: "Sans",
      fontWeight: 400,
      overflow: "visible",
      style: {
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#eee",
      strokeWidth: 0.1,
      d: "M287.2 253c1 19.5 15.3 35 32.8 35s31.9-15.5 32.8-35z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M352.8 251a32.8 37 0 1 1-65.6 0 32.8 37 0 1 1 65.6 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.5 225.4c-.3 1.4 0 2.5.7 3.6.6.9 1 1.8.9 2.7a7.9 7.9 0 0 0-.7.5l-5.5-3.7 3.7 5.5a8 8 0 0 0-.2.2 4.9 4.9 0 0 0-3-.3 5 5 0 0 1-3.7-.8 4.5 4.5 0 0 0 3.1 2.1 5 5 0 0 1 2.6 1.3 8 8 0 0 0-.2.8l-6.6 1.3 6.6 1.3v.3a4.9 4.9 0 0 0-2.4 1.9 5 5 0 0 1-3 2c1.3.4 2.5 0 3.6-.7a5 5 0 0 1 2.7-.9l.4.7-3.6 5.6 5.4-3.7.3.2a4.9 4.9 0 0 0-.4 3 5 5 0 0 1-.7 3.6 4.5 4.5 0 0 0 2-3.1 4.9 4.9 0 0 1 1.4-2.5l.8.2 1.3 6.5 1.3-6.5h.3a4.9 4.9 0 0 0 1.8 2.3 5 5 0 0 1 2.1 3.1 4.4 4.4 0 0 0-.7-3.6 4.9 4.9 0 0 1-.9-2.8l.7-.4 5.5 3.7-3.7-5.5.2-.3c1 .5 2 .6 3 .4a5 5 0 0 1 3.7.7 4.5 4.5 0 0 0-3.1-2 4.9 4.9 0 0 1-2.6-1.4l.2-.8 6.6-1.3-6.6-1.2a7.9 7.9 0 0 0 0-.4 4.9 4.9 0 0 0 2.4-1.8 5 5 0 0 1 3-2 4.5 4.5 0 0 0-3.6.7 4.9 4.9 0 0 1-2.7.8 7.9 7.9 0 0 0-.4-.7l3.7-5.5-5.5 3.7a8 8 0 0 0-.3-.2c.5-1 .6-2 .4-3a5 5 0 0 1 .7-3.6 4.5 4.5 0 0 0-2 3 5 5 0 0 1-1.4 2.6 8 8 0 0 0-.8-.2l-1.3-6.5-1.2 6.5h-.4a4.9 4.9 0 0 0-1.8-2.3 5 5 0 0 1-2-3.1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M325.9 236.7c-1.7-1.4-3.8-1.6-4.9-.6-.8 1.1-.8 2.4.2 3.8a.5.5 0 0 0-.3.2 4.9 4.9 0 0 1-.3-4.1c1.5-1.3 3.7-1.4 5.2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M323.3 236.3c-1 0-1.2.2-1.6.5-.4.4-.6.3-.7.4 0 0 0 .3.1.2.2 0 .5-.2.9-.6.4-.3.8-.3 1.3-.3 1.3 0 2 1 2.1 1 .2 0-.7-1.2-2.1-1.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M325 237.5c-1-1-2.7-1-3.4 0h.2c.8-1 2.5-.6 2.6 0"
    }),
    /* @__PURE__ */ jsx46("circle", {
      cx: 323.1,
      cy: 237.4,
      r: 0.6
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M321.6 237.6c.7.6 2.2.7 3.3-.1h-.5c-.7.7-1.8.6-2.5 0"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M325 237.8c-1.2 1-2.4.9-3.1.5-.7-.5-.7-.6-.6-.6l.8.4c.6.3 1.5.3 2.9-.2m-3.5 2a.4.4 0 1 1-.6.5c0 .1-.3.6-.9.6h-.1l.1.2c.1 0 .6 0 .9-.2a.6.6 0 1 0 .6-1m.9 3c-.7-.5-1-1-1.7-1a2 2 0 0 0-.7.1h-.1l.1.2c.3 0 .7-.3 1.2 0zm-.3 0c-1.4-.5-1.7-.2-2.1-.2h-.1l.1.3c.6 0 .9-.4 2.1-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M322.4 243c-1.6-.2-1.1.8-2.4.8h-.1l.1.2c1.6 0 .9-.9 2.4-1m-8.2-6.3c1.6-1.4 3.7-1.6 4.8-.6.8 1.1.8 2.4-.2 3.8a.5.5 0 0 1 .3.2 5 5 0 0 0 .3-4.1c-1.5-1.3-3.7-1.4-5.2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M316.7 236.3c1 0 1.2.2 1.6.5.4.4.6.3.7.4 0 0 0 .3-.1.2a4.1 4.1 0 0 1-.9-.6c-.4-.3-.8-.3-1.3-.3-1.3 0-2 1-2.1 1-.2 0 .7-1.2 2.1-1.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M315 237.5c1-1 2.7-1 3.4 0h-.2c-.8-1-2.5-.6-2.6 0"
    }),
    /* @__PURE__ */ jsx46("circle", {
      cx: -316.9,
      cy: 237.4,
      r: 0.6,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M318.4 237.6c-.7.6-2.2.7-3.3-.1h.5c.7.7 1.8.6 2.5 0"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M315 237.8c1.2 1 2.4.9 3.1.5.8-.5.8-.6.6-.6l-.8.4c-.5.2-1.5.3-2.9-.2m3.5 2a.4.4 0 1 0 .6.5c0 .1.3.6.9.6h.1l-.1.2c-.1 0-.6 0-.9-.2a.6.6 0 1 1-.6-1m-.9 3c.7-.5 1-1 1.7-1l.7.1h.1l-.1.2c-.3 0-.7-.3-1.2 0zm.3 0c1.4-.5 1.7-.2 2.1-.2h.1l-.1.3c-.6 0-.9-.4-2.1-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M317.6 243c1.6-.2 1.1.8 2.4.8h.1l-.1.2c-1.6 0-.9-.9-2.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M323.2 258.4c1.6.2 3.3.2 4.7-.3a9.9 9.9 0 0 1 4.2-.6c0-.2.5-.3.2-.5-.5-.3-1.2-.3-1.8-.6-1-.5-1.7-1.3-2.7-2-.1 0-.6-.3-.6-.5 2.2 3.2 7.5 1.5 12 1.2.4.1 1.5-.2 2.4-.5 1-.4 3.6 0 4.3-.5l-1.3-1c-.6-.8-2.3-.7-3-1.5-1.3-1.5-3.3-1.9-4.9-3-.3-.3-1-.2-1.6-.3-.6-.6 0-.5-5-4.7-4.5-1.8-4.2-3.2-7-4.3-1-.5-1.9-1.4-2.7-1.1a30 30 0 0 0-6.3 3c-1.2.6-2.7 2-3.8 2.8-.2.2-3.4 2.9-7 4.8a115 115 0 0 1-9.2 4.8c8-.4-7.3 2.3 29.1 4.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.3 249c2-1 10-5.3 12.4-8.4-.4 0 .6 1 .5 1.4.8 0 .4-1 1-1 .5 0 .9-.1 1.3-.3.5 0 .2.2.2.4-.7 1.2-2 2-3.2 2.9l.2.4c.4 0 .9 0 1.1-.2l.1-.3c.4.1.3.5.1.7-.3.6-1.4.5-1.8 1a6.2 6.2 0 0 1-1.5 1.7c.5-.4 1-1 1.7-1 1 0 1.3-.7 2.2-.9.9-.1 1.5-.9 2.2-1.4-.3.4-.9.7-.7 1.2a.6.6 0 0 0 .6.2c-.7.8-2 1.4-2.4 2.4-.4-.2-.7.2-1 .2-.4.1-.3.8-.6 1-1.2.7-1.8 1.8-2.3 2.7l-1.3.7c-.7.3-4.6 3.4-4.7 3-.3-2.1-4.3 1.6-13.3-1.6m30.6-.1-.2-.2c.1-.3-.5-.4-.5-.7 1 0 1.8 1.2 2.5.5.1-.1-.3-.4.4-.6 0 0-.2-.1-.1-.2h-.8l-.8-.3c-.3-.1-.5-.5 0-.6 1-.1 1.9.5 2.6.2.6-.3 1.1-.3 1.7-.5.3-.1 1.2 0 .9.2-.2.2-.7.1-1 .2-.5.1-1 .4-1.4.6.3 0 .2.3.7.2a6 6 0 0 1 2-.4v-.5h.3c-.3-.5.6-.2 1-.6l.1.1c-.5.2-.3.5-.4.8 0 0-.3 0-.2.2.2.2.2-.2.5 0h.6c.3 0 .7-.1.5-.4-.3-.2-.6-.5-.6-.8l-.1-.1c.5 0 1 .2 1.1.4.3.3.3.6.8.7.8.2.7-.2.7-.6.7 0 1.6.3 1.4.6 0 .3-.6.5-1 .5s-.2.3-.4.3c-.4 0-.9 0-1 .2-.2.2 0 .7.3.9.4.2 1.2 0 1.8 0 .1-.3.5-.4.9-.6.4-.3-.2-.5-.5-.7-.3 0 0-.1 0-.3.3-.3.9 0 1-.2.1-.3-.1-.6.1-.8.2-.1.5.1.4.3l.7-.2c.3 0 .5.3.4.4-.5.2-.8.4-.7.8 0 .2-.5.3-.3.5.4.3.4.5.5.9.2.3 1 .4 1.6.3-.2-.7 1.4-.4 2-.5.1 0 .1-.1 0-.2-.3-.2-.3-.3-.3-.6l-.1-.1c1 .3 2.8.8 3.6 1.4-1 .2-2.8-.2-3.8 0a15 15 0 0 1-3.7.6c-.5 0-1-.3-1.6-.3m-11.3-.7-.4-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M321.2 259.1c2 0 2.2 1.4 3.5.1 1.1.2 2.2-.2 2.2-.3 2.7.6 11.1-.2 10.6-.8-.9-1-2.3-1.4-3.4-2.2l-1.1-.4c-.7-.2-1.5 0-2-.3l-2.6-1.5c-.5-.4-.7-1-1.2-1.4-.6-.4-1.4-.5-2-.7-.9-.4-1.4-1.2-2.2-1.9l-1.1-.4c-.7-.3-1.2-1.1-1.9-1-1 .2-1.7 1-2.8 1.6-1 .4-1.4 1.1-2.2 1.6-.2.2-2.6 1.8-5.3 2.9a72.6 72.6 0 0 1-6.6 2.5s2.4 1.7 8 1.5l3.4 1 1.9-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.8 254.8c1.2-.6 6-2.9 7.4-4.5-.1 0 .5.5.4.7.5 0 .2-.4.6-.5l.8-.1c.3 0 .1 0 .1.2-.4.6-1.3 1-2 1.5l.2.2h.7v-.3c.3.1.2.3.1.4-.2.4-.9.3-1.1.6a3 3 0 0 1-1 .9c.4-.2.7-.5 1.1-.5.6 0 .8-.4 1.3-.5.6-.1 1-.5 1.4-.8-.2.2-.5.4-.4.7l.4.1c-.4.4-1.2.7-1.5 1.2l-.6.1c-.3.1-.2.5-.4.6-.7.3-1 1-1.4 1.4l-.8.4c-.4.2-2.8 1.8-2.8 1.6-.2-1.1-2.6.5-8-1.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#00a6de",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M320 214.2c-18.1 0-32.8 16.5-32.8 36.9S301.9 288 320 288s32.8-16.5 32.8-37c0-20.3-14.7-36.9-32.8-36.9zm0 8.2c13.2 0 24.7 12.3 24.7 28.7s-11.5 28.6-24.7 28.6-24.7-12.2-24.7-28.6c0-16.4 11.5-28.7 24.7-28.7z",
      color: "#000",
      fontFamily: "Sans",
      fontWeight: 400,
      overflow: "visible",
      style: {
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.7 266.8c0 .2 0 .2-.4.3-.4 0-.5 0-.5-.2s.1-.2.5-.2c.3-.1.4-.1.4 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "m324.8 266.8-.5.2h-.5c0-.2.2-.2.5-.3h.5zm-2.8 9c.8-2.2 1-3.8-.2-6 2-1.9 3.3-1.2 4.6 0-1.2 2.3-1 4-.2 6a4 4 0 0 1-4.2 0"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324 268.6v7.7h.1v-7.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.4 268.6a44.6 44.6 0 0 0-.3 7.7c0-2.9.2-5.3.4-7.6zm.7-2.4c-.4.4-.6.4-.4 1 .4-.3.4-.5.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.3 266.4c.2.3.6.4.3 1-.4-.3-.3-.4-.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.3 267c.2.3.5.3.3.9-.3-.3-.4-.3-.4-.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.2 267.4c.2.2.5.4.3 1-.4-.4-.3-.4-.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324 267.9c.3.2.7.3.4 1-.4-.4-.2-.5-.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324 268.4c.2.2.6.3.4 1-.3-.4-.4-.4-.4-1m1.3-1.7c-.2.1-.6.1-.6.8.5-.3.5-.3.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.3 267.1c-.2.2-.7.2-.7.7.6-.2.5-.2.7-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.2 267.6c-.2.1-.6 0-.7.7.6-.3.6-.2.7-.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.2 268.1c-.2 0-.7 0-.7.7.4-.1.4-.3.7-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325 268.6c-.4.1-.5 0-.6.7.5-.3.4-.2.5-.7zm.2.3c-.7 2.1-.8 4-.7 7.4h.1c0-3.4.1-5.2.8-7.3a2.8 2.8 0 0 0-.1 0zm1.2-2.2c-.4.3-.6.2-.5.8.4-.1.4-.3.5-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.6 266.8c.2.2.5.4.1 1-.3-.4-.2-.5 0-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.4 267.4c.3.3.5.3.2.8-.2-.3-.3-.3-.2-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.3 267.7c.1.3.4.4.1 1-.3-.4-.3-.4-.1-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325 268.1c.3.3.6.5.3 1-.4-.4-.2-.5-.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.9 268.6c.2.3.5.5.2 1-.3-.4-.3-.4-.2-1m1.6-1.4c-.2.2-.6 0-.7.7.5-.2.5-.2.7-.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.4 267.7c-.2 0-.6 0-.8.5.6-.1.6 0 .8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.3 268c-.3.2-.7 0-.9.7.7-.2.6-.2.9-.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.1 268.6c-.2 0-.6-.2-.8.5.4 0 .4-.2.8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.8 269c-.3 0-.5 0-.7.6.5-.2.5-.1.7-.6m.1.4c-1 1.9-1.1 3.6-.7 6.8l.2-.1c-.4-3-.2-4.7.6-6.6zm1.6-2.2c-.5.2-.7.2-.7.8.4-.2.5-.4.7-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.7 267.2c.1.3.4.5 0 1-.3-.5-.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.4 267.8c.2.2.4.4 0 .8 0-.4-.2-.4 0-.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.2 268c.1.3.4.5 0 1-.3-.4-.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326 268.5c0 .3.4.5 0 1-.3-.5 0-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.7 268.9c.2.3.5.5 0 1-.1-.4-.2-.5 0-1m1.8-1.1c-.2 0-.6-.1-.8.5.6-.1.5 0 .8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327.3 268.2c-.2 0-.6-.1-.8.4.6 0 .6 0 .8-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327.1 268.5c-.2 0-.6 0-.8.5.6 0 .5 0 .8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327 269c-.3 0-.7-.3-1 .4.5 0 .5-.1 1-.4m-.5.4c-.3 0-.4 0-.7.5.5-.1.5 0 .7-.5m-3-.7c.2 2.4.4 4.8.4 7.6h.1c.1-2.9 0-5.3-.4-7.6zm-.6-2.6c.4.4.5.4.4 1-.4-.3-.4-.5-.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.7 266.4c-.3.2-.6.4-.4 1 .4-.3.4-.4.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.7 267c-.3.3-.5.3-.3.8.2-.3.3-.2.3-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.8 267.4c-.2.2-.5.3-.3 1 .4-.4.3-.4.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324 267.9c-.3.2-.7.3-.5 1 .5-.4.2-.5.4-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324 268.4c-.3.2-.6.3-.4.9.3-.3.4-.4.4-.9m-1.3-1.8c.2.2.6.2.6.8-.5-.3-.5-.2-.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.7 267.1c.2.1.6.1.6.7-.5-.3-.5-.2-.6-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.8 267.5c.2.1.6.1.6.8-.5-.3-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.8 268c.2.1.7 0 .7.8-.4-.1-.4-.4-.7-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323 268.5c.3.2.5.1.5.8-.4-.3-.4-.3-.5-.8m-.2.5a3.8 3.8 0 0 0-.2.1c.7 2 1 3.9.9 7.2h.1a19 19 0 0 0-.8-7.3m-1.2-2.4c.4.3.5.3.5.8-.4-.1-.4-.3-.5-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.4 266.7c-.2.3-.5.4-.2 1 .3-.4.3-.4.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.6 267.3c-.3.3-.6.4-.2.9.2-.4.3-.4.2-.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.7 267.6c-.2.3-.5.5-.1 1 .3-.4.2-.4.1-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323 268.1c-.3.3-.6.4-.3 1 .4-.5.1-.5.2-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323 268.6c-.1.2-.5.4-.1 1 .2-.4.3-.5.2-1zm-1.5-1.5c.2.1.6 0 .7.7-.6-.2-.5-.2-.7-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.6 267.6c.2 0 .6 0 .7.5-.5-.1-.5 0-.7-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.7 268c.2 0 .7 0 .8.6-.6-.2-.6-.2-.8-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.9 268.5c.2 0 .6-.2.8.6-.4 0-.5-.3-.8-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.2 269c.3 0 .4 0 .6.5-.5-.2-.4-.1-.6-.6zm0 .5a4.1 4.1 0 0 0-.2 0c.9 2 1 3.6.7 6.6h.2c.3-3 .2-4.6-.8-6.6zm-1.7-2.5c.4.3.6.2.6.8-.4-.1-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.3 267c-.1.3-.4.6 0 1 .3-.4.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.6 267.6c-.2.3-.5.4-.1.9.1-.4.3-.4 0-.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.8 268c-.2.2-.4.4 0 1 .2-.5.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322 268.4c-.1.3-.4.5 0 1 .3-.5 0-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.3 268.8c-.2.3-.5.5-.1 1 .2-.4.2-.5 0-1zm-1.8-1.2c.2 0 .6 0 .8.5-.6 0-.6 0-.8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M320.6 268c.3 0 .7 0 .9.5-.6-.1-.6 0-.9-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M320.8 268.4c.3 0 .7 0 1 .5-.7-.1-.7 0-1-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321 268.9c.3 0 .7-.3 1 .5-.5 0-.5-.3-1-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.4 269.3c.3 0 .5 0 .7.5-.5-.1-.4 0-.7-.5m2.2-3.2c.3.4.5.4.3 1-.4-.3-.3-.5-.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.3 266.4c-.2.2-.5.3-.4 1 .5-.3.4-.4.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.4 267c-.3.2-.6.3-.4.8.2-.3.3-.2.4-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.4 267.4c-.2.2-.5.3-.4 1 .4-.4.4-.4.4-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.5 268c-.3.1-.6.2-.5.8.5-.3.3-.4.5-.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.5 268.4c-.2.2-.6.3-.4.9.3-.3.4-.3.4-.9m-1.2-1.8c.2.2.6.2.6.8-.5-.3-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.3 267c.2.2.6.2.6.8-.5-.3-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.4 267.4c.2.2.6.2.6.9-.5-.4-.5-.3-.6-.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.4 268c.2.1.7 0 .6.8-.4-.2-.3-.4-.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.6 268.5c.2.1.4.1.4.8-.4-.4-.4-.3-.4-.8m-.4.3a2.7 2.7 0 0 0-.1 0c.5 2.5.7 4.7.6 7.5h.2c0-2.5 0-5-.7-7.5m-1-2.4c.4.4.6.3.5 1-.4-.3-.4-.5-.5-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323 266.6c-.2.2-.5.4-.2 1 .3-.4.3-.4.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.1 267.2c-.2.2-.5.3-.2.8.2-.3.3-.3.2-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.3 267.5c-.2.3-.5.4-.2 1 .3-.3.3-.4.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.5 268c-.3.3-.6.4-.3 1 .4-.4.2-.5.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M323.6 268.5c-.2.3-.6.4-.3 1 .3-.4.3-.5.3-1M322 267c.3 0 .7 0 .8.6-.6-.2-.6-.1-.8-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.1 267.4c.2.1.7 0 .8.6-.6-.2-.6-.1-.8-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.3 267.8c.2.1.6 0 .7.7-.6-.2-.6-.2-.7-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.4 268.3c.2 0 .6-.1.8.7-.5-.1-.5-.3-.8-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.7 268.8c.3 0 .4 0 .6.6-.5-.2-.5-.1-.6-.6m-.8.9c.6 1.4.8 2.6.7 3.7l-.3 2.5h.1c.6-2.5.5-4.4-.5-6.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "m322.5 269.2-.1.1c.8 2.1.9 4 .7 7h.1c.2-3 .1-5-.7-7zm-1.4-2.4c.4.3.5.2.5.8-.4-.1-.4-.3-.5-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.8 266.9c-.1.2-.4.4 0 1 .3-.4.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322 267.4c-.1.3-.4.4 0 1 .1-.4.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.3 267.8c-.2.2-.5.4 0 1 .2-.5.1-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.5 268.2c-.2.3-.5.5 0 1 .2-.5 0-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322.7 268.7c-.1.2-.5.5-.1 1 .2-.4.3-.5.1-1m-1.7-1.3c.2 0 .6 0 .8.5-.6-.1-.6 0-.8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.1 267.8c.3 0 .7 0 .8.5-.5-.1-.5 0-.8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.3 268.1c.2.1.7 0 .9.6-.6-.1-.6 0-.9-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.5 268.7c.2 0 .6-.3.9.5-.5 0-.5-.2-.9-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.9 269c.3.1.4 0 .6.6-.4-.1-.4 0-.6-.5zm-2-1.6c.5.2.7.2.8.7-.4 0-.5-.2-.7-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M320.7 267.4c0 .3-.3.5.2 1 .2-.5.1-.5-.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321 267.9c0 .3-.3.5.1.9.1-.4.2-.4 0-.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.3 268.2c0 .3-.3.5.1 1 .2-.5.2-.5 0-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.6 268.6c0 .3-.4.5.1 1 .2-.6 0-.5 0-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M322 269c-.2.3-.5.6 0 1 .1-.4.2-.5 0-1m-2-1c.2 0 .6-.1.9.4-.6 0-.6 0-1-.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M320.2 268.4c.2 0 .6-.2.9.4-.6 0-.6 0-.9-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M320.4 268.7c.3 0 .7-.1 1 .4-.6 0-.6 0-1-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M320.7 269.2c.2 0 .6-.3 1 .4-.5 0-.5-.2-1-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M321.1 269.5c.3 0 .5 0 .8.5-.5 0-.5 0-.8-.5m3.8-.7a25.9 25.9 0 0 0-.7 7.5 2.5 2.5 0 0 0 .2 0c0-2.8 0-5 .7-7.4a2.8 2.8 0 0 0-.2-.1m1-2.3c-.4.3-.5.3-.5.9.4-.2.5-.4.5-.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.1 266.6c.2.3.5.5.2 1-.3-.4-.3-.4-.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325 267.3c.3.2.5.3.2.8-.2-.3-.3-.3-.2-.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.9 267.6c.2.2.5.4.2 1-.4-.4-.3-.5-.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.7 268c.2.3.5.5.2 1-.4-.4-.1-.5-.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M324.5 268.5c.2.3.6.5.3 1-.3-.4-.3-.4-.3-1m1.6-1.5c-.2.2-.6 0-.7.7.5-.2.5-.2.7-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326 267.5c-.2 0-.6 0-.7.6.5-.2.5-.1.7-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.9 267.9c-.2 0-.7 0-.8.6.6-.2.6-.1.8-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.7 268.4c-.2 0-.6-.2-.7.6.4 0 .4-.3.7-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.4 268.8c-.2.1-.4 0-.5.7.4-.2.4-.2.5-.7m.2.4c-.9 2.1-1 4.1-.8 7h.2c-.2-3-.1-4.9.7-7zm1.5-2.3c-.5.3-.6.2-.6.8.4-.1.4-.3.6-.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.3 267c.1.2.4.5 0 1-.3-.5-.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326 267.5c.3.3.5.5.1 1-.1-.5-.2-.5 0-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.9 267.8c.1.3.4.5 0 1-.3-.4-.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.6 268.3c.2.3.5.5.1 1-.3-.5 0-.5-.1-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M325.4 268.7c.2.3.5.5.1 1-.2-.4-.3-.4-.1-1m1.7-1.2c-.2.1-.6 0-.8.5.6 0 .6 0 .8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327 268c-.2 0-.6-.1-.8.4.6-.1.5 0 .8-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.8 268.3c-.2 0-.7 0-.8.5.6-.1.5 0 .8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.6 268.8c-.2 0-.6-.3-.8.5.4 0 .4-.3.8-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.3 269.2c-.4 0-.5 0-.7.5.4-.1.4 0 .6-.5zm0 .5c-1.1 2-1 4-.6 6.3h.2l-.3-2.9a6 6 0 0 1 .8-3.3h-.1zm1.9-2c-.5.1-.7 0-.8.6.5 0 .5-.2.8-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327.4 267.5c0 .3.3.6-.2 1-.2-.5-.1-.5.2-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327 268c.2.3.4.5 0 .9-.1-.4-.2-.4 0-.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.8 268.3c.1.3.3.5-.1 1-.2-.5-.2-.5.1-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.5 268.7c0 .3.4.6-.1 1-.2-.6 0-.5 0-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M326.2 269c.1.4.4.7 0 1-.2-.4-.2-.4 0-1m2-.8c-.3 0-.6-.2-1 .4.6 0 .6 0 1-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327.9 268.6c-.2 0-.6-.2-.9.3.6 0 .6 0 .9-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327.7 268.9c-.3 0-.7-.2-1 .4.7 0 .6 0 1-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327.4 269.4c-.2 0-.6-.4-1 .3.5 0 .6-.2 1-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "M327 269.7c-.3 0-.5-.1-.8.4.5 0 .5 0 .8-.4m-3.5 2.7h1.1c.7 0 1.2.2 1.2.4s-.5.3-1.2.3h-1.1c-.7 0-1.3-.2-1.3-.4s.6-.3 1.3-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      d: "m322.7 272.4-.4.6a.3.3 0 0 0 .2 0h.2l.4-.6zm.9 0-.4.6h.4l.4-.6zm.9 0-.4.7h.4l.4-.7zm.8 0-.3.7h.4l.3-.6a.3.3 0 0 0-.2 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m316.5 268.8.5 2.7.2.2v1.1c.3.5.3 1.1.5 1.6l.3.6h.4l.1.2-.2.2h-.6l-.3-.1v-.3h-.2l-.1-.6-.8-1c0-.1 0-.4-.2-.5l-.3-.3c-.5-1-1-3-1-3m-6.4-1 1.8.4-.5 2.6c-.3.8-.3.9-.2 1 .2.5.4 1.2 1.1 2.3l.6.4.5.3h.5l.1-.2c0-.1-.3 0-.5-.2 0-.3-.5-.8-.5-1.2-.3-.7-.2-.7-.2-1.5l.5-1.6c.2-.5.5-1.4.5-2l-.8-1.7-.5-.7m-1.6-1.1c-2.9 1-1.7 3.5-.9 3.6m9.2-8.1.4-1v-.4l-.7.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M319.2 262.4c.2 0 .4.1.4 0v-.6c-.6-.4-1-.4-1-.7v-.2c0-.2-.8-.3-1-.4l-.4-.2h-.2c-.8 0-1.1.7-1.2 1.2 0 0-.2 2.1-.5 3a.7.7 0 0 1-.2.3l-.2.2c-2-.2-3.4-.2-4.2-.2-.8 0-1.8.7-1.8.7s-1 .6-1.1 1.6c-.1.3 0 .7.1 1 1 2.7 1.8 0 2.1.1h.4c.5 0 1.4 1.5 2.7 1.8 4 .9 5-1.2 5-5.8v-.2l.2-.4v-.8l1-.2.2-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m317.3 261 .4-1v-.4l-.9 1m-8.9 7.6c.3.8.7 1.5.7 1.8 0 .4-.3.6-.3.7h-.2l-.2.6a1.3 1.3 0 0 0 0 .6c0 .7.4 2.2.4 2.3 0 0 .3 0 .3.2v1.2c0 .2.3.3.3.3h.6l-.4-.4a.4.4 0 0 1 0-.2c0-.2.2-.4.3-.5v-.3l-.1-.2a8.3 8.3 0 0 1-.1-.9v-1.1l.2-.2.1-.2 1-.6.8-1 .2-.5a.5.5 0 0 0 0-.2 3.8 3.8 0 0 0-.3-.9 3.2 3.2 0 0 0-.6-.8m5.9 1.8c-.5.4-1.8.7-1.8 1 0 0 0 1.6-.2 2.2l-.3.6-.2.7-.3 1v.3l.4.3h-.4l-.6-.2V274l-.2-1.4.1-1-.1-3.6m4.7-5.4c.2.2.6.4 1.3.1.2.1.3.2.6-.2m-.3-.5h.2s.1 0 0 0c0 0 0-.1 0 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M317.8 261.4c.2.3.4.3.6.1-.2-.3-.4-.1-.5-.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M329.1 272.9a2 2 0 0 0 0 .7v.8a2 2 0 0 0 0 .7 2 2 0 0 0 0 .7c.2.2 1 .2 1.2 0a2.2 2.2 0 0 0 0-.7v-.7a2 2 0 0 0 0-.7v-.8a2.3 2.3 0 0 0 0-.8v-.7a2.2 2.2 0 0 0 0-.8v-.8a2.4 2.4 0 0 0 0-.8v-.7a2.2 2.2 0 0 0 0-.8 1.9 1.9 0 0 0 0-.8 2.5 2.5 0 0 0 0-.8 2.3 2.3 0 0 0 0-.8 3.3 3.3 0 0 0 0-.8 2.9 2.9 0 0 0 0-.7v-.8a2.6 2.6 0 0 0 0-.8 2.7 2.7 0 0 0 0-.8v-.8a2.3 2.3 0 0 0 0-.8v-.7a2 2 0 0 0 0-.3h-.9v1a2.3 2.3 0 0 0 0 .8v.8a2.7 2.7 0 0 0 0 .8 2.6 2.6 0 0 0 0 .8 3 3 0 0 0 0 .7l-.1.8v.8a2.4 2.4 0 0 0 0 .8 2.5 2.5 0 0 0 0 .8 1.9 1.9 0 0 0 0 .8c-.1.3-.1.5 0 .8v.7a2.4 2.4 0 0 0-.1.8 2.6 2.6 0 0 0 0 .8 2.2 2.2 0 0 0 0 .8 2 2 0 0 0 0 .7 2.3 2.3 0 0 0 0 .8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M329.1 273.6c.3.2 1 .1 1.2 0m-1.2-.7h1.2m-1.2-.8h1.2m-1.1-.7h1.1m-1.1-.8h1.1m-1.1-.8h1.1m-1-.8h1m-1-.7h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.7h1m-1-.8h1m-1-.8h1m-.9-.8h.8m-.8-.8h.8m-.8-.8h.8m-.8-.7h.8m-1 15.5h1.1m-1.2.7h1.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#e7e7e7",
      strokeWidth: 0.1,
      d: "M331.5 257a13 13 0 0 1 2.1 0 13.7 13.7 0 0 0-.8-.3h2.2a5 5 0 0 0-1-.5 8 8 0 0 1 2.2.1l-1-.5c.9 0 1.2 0 2 .2a2.6 2.6 0 0 0-.9-.5 8 8 0 0 1 2.5-.2 8.6 8.6 0 0 0-8 .8 6 6 0 0 1 1-1.1 2.5 2.5 0 0 0-.7 0c.3-.3.8-.8 1.2-1l-.7.1 1.4-1a3.1 3.1 0 0 0-.9.1 5.2 5.2 0 0 1 1.6-1.1 4 4 0 0 0-1 0 8.7 8.7 0 0 1 2-1.3c-3.3.4-5.1 2.8-5.3 4.8a7 7 0 0 0-6.6-3.6c1 .3 1.8.7 2.4 1a4.4 4.4 0 0 0-1 .1c.7.2 1.5.6 2 1a3.4 3.4 0 0 0-1 0l1.8.8-.8.1a5 5 0 0 1 1.5.8h-.8c1 .4 1.1.6 1.3.7a8 8 0 0 0-7.3 3 10 10 0 0 1 2.2-1l-.5.8c.5-.4 1.3-.8 2-1a4.8 4.8 0 0 0-.4.7l1.8-1-.4.8 1.7-.7-.5.7 1-.4a6.2 6.2 0 0 0-2.9 5.8l.9-2v1a8.5 8.5 0 0 1 1-2v1l1-2v1l1.1-1.9v.8l.3-.6.7-.9.2.3c.3.4.4 1.1.5 1.8a3.2 3.2 0 0 0 .2-.9c.3.7.7 1.8.7 2.4a3.6 3.6 0 0 0 .2-1c.3.5.6 1.8.7 2.3l.3-.9c.3.8.4 1.7.5 2.3.8-3-.4-4.9-1.8-6.3.4.1.8.5 1.3 1a4.9 4.9 0 0 0-.3-.9l1.5 1.4-.2-.8c.6.4 1.1 1.2 1.5 1.6a5.4 5.4 0 0 0-.2-1 6 6 0 0 1 1.3 1.8l-.1-1c.7.6 1 1.3 1.3 1.7 0-2.7-3.1-5-6-5.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M330.3 257.1c3.1-.5 7.2 2.3 7.2 5.3-.3-.4-.6-1.1-1.3-1.8l.1 1a6 6 0 0 0-1.3-1.7l.2 1c-.4-.4-.9-1.2-1.5-1.6l.2.8-1.5-1.4.3 1c-.5-.6-1-1-1.3-1.1m-1.8-1.5c-1.9-1.2-5.8-1-8.7 2.3a10 10 0 0 1 2.2-.9l-.5.8c.5-.4 1.3-.8 2-1a4.8 4.8 0 0 0-.4.7l1.8-1-.4.8 1.7-.7-.5.7 1-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M329.7 256.6c-.4-2.2-3-4.8-6.9-4.6 1 .3 1.8.7 2.4 1a4.3 4.3 0 0 0-1 .1c.7.2 1.5.6 2 1a3.4 3.4 0 0 0-1 0l1.8.8a3.2 3.2 0 0 0-.8.1 5 5 0 0 1 1.5.7l-.7.1c1 .4 1 .6 1.2.7m1.5 1c-2.6.8-5.1 3.3-4.7 6.7 0-.4.5-1.5.8-2v1l1-2v1l1-2v1a13.3 13.3 0 0 1 1.1-1.9v.8a5 5 0 0 1 1-1.5m-1.6.2a8.7 8.7 0 0 0-.5 1.4m-.5-.8a9.7 9.7 0 0 0-.5 1.9m-.5-1a9 9 0 0 0-.5 2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M329.9 258.6v-.6",
      className: "bo_svg__bo-fil1 bo_svg__bo-str2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M332.6 261.3v1.3m-1-3 .1 1.6m-1-2.7.1 1.3m4.8-.4.6 1.2m-2-2.1.8 1.4m-2-1.8c.3.3.5.7.7 1.2m-10.6-.8a4.7 4.7 0 0 1 1.7-1.2m-.2 1c.4-.6.6-.9 1.6-1.3m-.2 1c.4-.4.9-.8 1.7-1.1m-.4 1.2c.5-.5 1-.7 1.6-1m-3.7-4c.7 0 1.6.2 2.2.6m-1.2.4c.6 0 1.4.2 1.8.4m-1 .4c.6 0 1.3.3 2 .6m-1.3.2a4 4 0 0 1 1.7.6m.9.2a8.6 8.6 0 0 1 8.5-1.2 8 8 0 0 0-2.4.2c.4 0 .7.3.8.4h-2c.4 0 .7.2 1 .4a7.3 7.3 0 0 0-2.2 0l1 .3h-2.2l.8.3c-1 0-1.6 0-2 .2m4.8-1.6a6 6 0 0 0-2.2-.4m1 .7a5.8 5.8 0 0 0-2.5-.2m1.3.6a6.8 6.8 0 0 0-2.5-.2m1.3.7a5 5 0 0 0-2-.1m.8 1c.4.3.6.7.8 1.1m-3-3.1c.2-2 2-4.4 5.3-4.8a9 9 0 0 0-2 1.3h1c-.5.2-1.2.7-1.6 1.1a3.1 3.1 0 0 1 .9 0 6.7 6.7 0 0 0-1.4 1l.7-.1a4.1 4.1 0 0 0-1.2.9h.7l-1 1.1m2-4c-.5.1-1.1.4-1.6.7m1 .4a4.5 4.5 0 0 0-1.5.5m.9.4c-.5.1-1 .4-1.5.7m1 .2a3.2 3.2 0 0 0-1.4.8m-.5 2.4a6 6 0 0 0-.3 1.1m1.2-2c1.8 1.6 4.1 3.7 3 7.6a6 6 0 0 0-.4-2.2l-.3.9a6.8 6.8 0 0 0-.7-2.4 3.5 3.5 0 0 1-.2 1 8.3 8.3 0 0 0-.7-2.4c0 .2 0 .6-.2.9 0-.9-.3-1.7-.7-2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m293.3 233.5 1.3.7.3-.6c.1-.3.2-.5.1-.6 0-.2-.2-.4-.5-.5-.3-.2-.6-.3-.7-.2-.2 0-.4.2-.5.4l-.2.5c0 .1 0 .2.2.3m1.6 1 1.7.8h.3l.3-.5.3-.6a.6.6 0 0 0 0-.4.7.7 0 0 0-.2-.2 1.9 1.9 0 0 0-.3-.2c-.8-.4-1.3-.3-1.7.3l-.4.7m-2.6-.8a33 33 0 0 0 .6-1.2 3.3 3.3 0 0 1 .6-.7l.6-.4h.9c.2.1.3.3.4.6.1.2.2.5.1.7a2 2 0 0 1 1-.6l1 .1c.3.2.5.6.6 1 .1.5 0 1-.4 1.7a32.4 32.4 0 0 1-.7 1.3l-.3.7-1.4-.9-1.8-1-1.5-.7.3-.6m9-10.8c-.8.6-.7 1.5.3 2.6.5.6 1 1 1.5 1 .4.2.9 0 1.3-.3.3-.3.5-.6.4-1a3.1 3.1 0 0 0-.8-1.5c-.5-.7-1-1-1.4-1.2-.5 0-1 0-1.4.4m3.8-.2c.5.6.7 1.3.7 2a2.8 2.8 0 0 1-1.2 2 2.9 2.9 0 0 1-2 .7 2.4 2.4 0 0 1-1.8-1 2.8 2.8 0 0 1-.7-2c0-.7.4-1.4 1-2a2.9 2.9 0 0 1 2-.7c.8 0 1.4.4 2 1m8-2.6.3 1a14.4 14.4 0 0 0 1.9-.7h.3a4.5 4.5 0 0 0 .3.7l-.5.1-2.4.7-.7.2-.4-1.6-.5-2a12 12 0 0 0-.5-1.5l.6-.2.7-.2.3 1.6.6 2m9.2-3a12.2 12.2 0 0 0 0-1.6h.8l.7.1c-.2.5-.2 1-.3 1.7l-.2 2a11.9 11.9 0 0 0-.1 1.6h-.7l-.7-.1.3-1.7.2-2m9.9 5.3c1.6-1.3 2.7-2.2 3.1-2.7l.4.2.4.2a230 230 0 0 0-4.7 3.6l-.5-.3a316.2 316.2 0 0 1 .2-2 362.5 362.5 0 0 0 .4-3.8 7.7 7.7 0 0 0 1.2.7 34.8 34.8 0 0 0-.5 4m8.4 4 1.2-1.3.4.6.5.4a11.1 11.1 0 0 0-1.3 1.1l-1.5 1.4a12 12 0 0 0-1.1 1.1l-.5-.5-.5-.5 1.3-1 1.5-1.4m5 10 1.3-1.4h-2a18 18 0 0 0 .7 1.4m-1.1-1.3-2 .1a1.9 1.9 0 0 0-.1-.3 2.6 2.6 0 0 0-.2-.4h5.9l.3.6a82.5 82.5 0 0 0-4 4.3l-.2-.7a5.4 5.4 0 0 0-.3-.6 23.9 23.9 0 0 0 1.4-1.3 35 35 0 0 0-.4-.8 39.5 39.5 0 0 0-.4-1",
      fontFamily: "Linux Biolinum",
      fontSize: 100,
      fontWeight: 700,
      letterSpacing: 60,
      style: {
        lineHeight: "125%",
        textAlign: "center"
      },
      textAnchor: "middle",
      wordSpacing: 0
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "m325 280.6-.8 2.2h-2.4l1.9 1.5-.7 2.2 2-1.3 1.8 1.3-.6-2.2 1.8-1.4h-2.3zm9-3.9-.7 2.2H331l1.8 1.5-.7 2.2 2-1.3 1.9 1.3-.7-2.2 1.9-1.4h-2.4zm14.2-25-.8 2.3h-2.3l1.8 1.4-.6 2.3 1.9-1.4 1.9 1.4-.7-2.3 1.9-1.4h-2.4zm-6.7 17.9.7 2.2h2.4l-1.9 1.4.7 2.3-2-1.4-1.9 1.4.7-2.3-1.8-1.4h2.3zm4.7-8.2.8 2.2h2.3l-1.9 1.5.7 2.2-1.9-1.3-2 1.3.8-2.2-1.9-1.4h2.3zm-31.1 19.2.8 2.2h2.3l-1.9 1.5.7 2.2-2-1.3-1.8 1.3.6-2.2-1.8-1.4h2.3zm-9.2-3.9.8 2.2h2.4l-2 1.5.8 2.2-2-1.3-1.9 1.3.7-2.2-1.9-1.4h2.4zm-14-25 .7 2.3h2.3l-1.8 1.4.6 2.3-1.9-1.4-1.9 1.4.7-2.3-1.9-1.4h2.4zm6.6 17.9-.7 2.2h-2.4l1.9 1.4-.7 2.3 2-1.4 1.9 1.4-.7-2.3 1.8-1.4h-2.3zm-4.7-8.2-.8 2.2h-2.3l1.9 1.5-.7 2.2 1.9-1.3 2 1.3-.8-2.2 1.9-1.4h-2.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M321 248.1v-.5h.1l-.8-.5h-.7l-.8.5v.5h2.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M321 248.1v-.5h.1l-.8-.5v-.7h-.6v.7l-.9.5v.5h2.3zm.3.6v.2h-2.6v-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M321.3 248.7v.2h-2.6v-.2zm-2.5 0v-.5h.1v.5-.5h-.1v-.1h2.4v.1h-.2v.5-.5h.1v.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M318.9 248.7v-.5zv-.5h-.1v-.1h2.4v.1h-.2v.5-.5h.1v.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M319.4 248.6v-.4h-.4v.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M319.1 248.3v.2h.2v-.2zm1.8.3v-.4h-.3v.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M320.7 248.3v.2h.1v-.2zm.2-.3v-.3h-.3v.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M320.7 247.7v.2h.1v-.2zm-1.3.3v-.3h-.4v.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M319.1 247.7v.2h.2v-.2zm.8.3v-.3h-.3v.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M319.7 247.7v.2h.1v-.2zm.7.3v-.3h-.3v.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M320.1 247.7v.2h.2v-.2zm.4.2v.8h-1v-.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      d: "M320.5 247.9v.8h-1v-.8zm-1 .2h1m-.9.6v-.6m.7.6v-.6m.5-.5-.5-.4h-.6l-.5.4zm-1-.5h.4m-.3-.1h.2zm.1 1h.1zm.3 0h.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      d: "M319.8 246h.4v.4h-.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M320 245.6v.4m-.2-.2h.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M317.1 210.3s-2.3 5.4-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.2 0-.2l-.2-2.8-2 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M317.1 210.3s-2.3 5.4-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.2 0-.2l-.2-2.8-2 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M317.6 207.7s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.1 0-.1 0-.1l.7-3.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.6 207.7s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.1 0-.1 0-.1l.7-3.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M320.5 206.4s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.2 0-.2 0-.2l.7-3.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M320.5 206.4s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.2 0-.2 0-.2l.7-3.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "m356.8 195.6 3.4 1.9s.8.7-1 .3a42 42 0 0 1-12.8-6.4c-3.3-2-4.3-2-4.3-2l4.5.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m356.8 195.6 3.4 1.9s.8.7-1 .3a42 42 0 0 1-12.8-6.4c-3.3-2-4.3-2-4.3-2l4.5.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "m358 194.8 3.3 1.9s.8.7-1 .3a45 45 0 0 1-12.8-6.4c-3.3-2.1-.6 1.7-.6 1.7l.5-2.5 10.5 5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m358 194.8 3.3 1.9s.8.7-1 .3a45 45 0 0 1-12.8-6.4c-3.3-2.1-.6 1.7-.6 1.7l.5-2.5 10.5 5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M363.5 196.6s-4-.7-5.4-1.8c0 0 .2.5-1.7-.4 0 0 .7 1.7-4.8-2-5.5-3.8-3.6-2-3.6-2l1.6-.3 9.3 3.7a53 53 0 0 1 4.6 2.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M363.5 196.6s-4-.7-5.4-1.8c0 0 .2.5-1.7-.4 0 0 .7 1.7-4.8-2-5.5-3.8-3.6-2-3.6-2l1.6-.3 9.3 3.7a53 53 0 0 1 4.6 2.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "m342.6 198.1 1.4 1.9s-.5 1.8-5.1-1.7-4.4-3.2-4.4-3.2l2.6-.3 5.6 3.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m342.6 198.1 1.4 1.9s-.5 1.8-5.1-1.7-4.4-3.2-4.4-3.2l2.6-.3 5.6 3.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M336.6 199s2.2 2.9 1.7 3.2c-.5.4-3 .2-4.8-2.5-1.9-2.8 0-.2 0-.2v-4.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M336.6 199s2.2 2.9 1.7 3.2c-.5.4-3 .2-4.8-2.5-1.9-2.8 0-.2 0-.2v-4.4l3.2 3.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M338.8 197.8s2.1 2.6 1.9 3c-.2.4-3.2.2-5.5-2.5-2.3-2.6-.3-3.4-.3-3.4l3.9 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.8 197.7s2.1 2.7 1.9 3.1c-.2.4-3.2.2-5.5-2.5-2.3-2.6-.3-3.4-.3-3.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M350.6 196.2s6 2.5 1.6 2.4c0 0-8.6-2.3-13-6.2l1.2-1.6 10.2 5.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M350.6 196.2s6 2.5 1.6 2.4c0 0-8.6-2.3-13-6.2l1.2-1.6 10.2 5.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M353.8 195.4s3.1 2 3.4 2.7c.2.8-10-1.9-15.3-6.3l2.4-1.2 9.4 4.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M353.8 195.4s3.1 2 3.4 2.7c.2.8-10-1.9-15.3-6.3l2.4-1.2 9.4 4.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M344.5 197.2s2.3 1.9 2 2.1c-.3.2-5-.5-8.6-3.3l.4-1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.5 197.2s2.3 1.9 2 2.1c-.3.2-5-.5-8.6-3.3l.4-1.7 6.2 2.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M348.4 197s2.3 1.6 1.8 1.8c-.4.1-2.2 1.6-10.7-3.4l-1-.6 1.3-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.4 197s2.3 1.6 1.8 1.8c-.4.1-2.2 1.6-10.7-3.4l-1-.6 1.3-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M339.7 192.4s2.8 2.4 2.4 2.8c-.4.4-3.6-.4-5-1.5-1.5-1-2.6-2.4-2.6-2.4l3-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.7 192.4s2.8 2.4 2.4 2.8c-.4.4-3.6-.4-5-1.5-1.5-1-2.6-2.4-2.6-2.4l3-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "m336.4 188.3 5 3s4.1 2.8 3.7 3.1c-.4.3-3.7-.8-6-2-2.2-1.3-5-4-5-4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m336.4 188.3 5 3s4.1 2.8 3.7 3.1c-.4.3-3.7-.8-6-2-2.2-1.3-5-4-5-4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M333.2 202.4s1 2.4.4 2.6c-.6.3-2-.2-3-2.3-1.2-2.2 1-1.3 1-1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M333.2 202.4s1 2.4.4 2.6c-.6.3-2-.2-3-2.3-1.2-2.2.7-1.3.7-1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M334.9 200.9s1.4 2.3 1.1 2.6c-.3.2-2.2 1-4.2-2s2.1-2.3 2.1-2.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334.9 200.9s1.4 2.3 1.1 2.6c-.3.2-2.2 1-4.2-2s2.1-2.3 2.1-2.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M330.7 190.4s4.8 9.3 4.4 9.8c-.4.5-2.3 0-3.4-2.5s-1.9-5.6-1.9-5.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M330.7 190.4s4.8 9.3 4.4 9.8c-.4.5-2.3 0-3.4-2.5s-1.9-5.6-1.9-5.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M336.3 192.8s4 3.3 3.2 3.8c-.8.4-2.4-.2-4.8-2.5-2.3-2.3 1.6-1.5 1.6-1.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M336.3 192.7s4 3.5 3.2 3.9c-.9.4-2.5-.2-4.8-2.5s1.6-1.4 1.6-1.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M334.4 192.8s2.8 5.3 2.5 5.8c-.4.5-2.5-1.3-3.6-2.7-1-1.3-1.9-3.3-1.9-3.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334.4 192.8s2.8 5.3 2.5 5.8c-.4.5-2.5-1.3-3.6-2.7-1-1.3-1.9-3.3-1.9-3.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M312.9 203.6s-.2 3.1 0 3.3c.2.3 1.7.3 1.8-2 .1-2.4-.3-2.5-.3-2.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.9 203.6s-.2 3.1 0 3.3c.2.3 1.7.3 1.8-2 .1-2.4-.3-2.5-.3-2.5l-1.5 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M313.8 199.9s-1 3.4 0 4.1c1 .7 1.9-3.4 2-4.3 0-1-2 .2-2 .2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.8 199.9s-1 3.4 0 4.1c1 .7 1.9-3.4 2-4.3 0-1-2 .2-2 .2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.6 204.3s.2 3.2.8 3.4c.6.1 1.6-1 1.6-1.8s-1-2.8-1-2.8l-1.4 1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.6 204.3s.2 3.2.8 3.4c.6.1 1.6-1 1.6-1.8s-1-2.8-1-2.8l-1.4 1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.6 200.4s-1 3.5 0 4.2c1 .7 1.9-3.4 2-4.4 0-.9-2 .2-2 .2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.7 194.8s-1.6 1.7-1.6 2.6c0 1 2.4-1.2 2.6-1.6.2-.4-1-1-1-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.7 194.8s-1.6 1.7-1.6 2.6c0 1 2.4-1.2 2.6-1.6.2-.4-1-1-1-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M313.6 194s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.4.6-.8-1.2-1.7-1.2-1.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.6 194s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.4.6-.8-1.2-1.7-1.2-1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M331.5 190.8s2 3.8 1.5 4c-.6.2-1.4-.7-2.3-1.9-.8-1.1.8-2.1.8-2.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.5 190.8s2 3.8 1.5 4c-.6.2-1.4-.7-2.3-1.9-.8-1.1.8-2.1.8-2.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.6 198.6s.7 3.3 0 3.6c-1.2.5-2-2.3-2-3.4 0-1.2 2-.2 2-.2zm-2.6 5.1s.2 2.5-.2 2.7c-.3.2-1.2.2-2.1-1.8-1-2-.5-1.2-.5-1.2l2.3-1.2.5 1.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.4 203.2s.2 2.5-.3 2.6c-.5 0-1.9-.8-2.5-2.3-.6-1.8 2.4-1.3 2.4-1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M329 195.3s2.6 6 2.1 6.7c-.8 1.7-3.2-3.5-3.9-5.6-.8-2.2 1.7-1 1.7-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.7 196.3s3.6 6.5 2.1 6.6c-1.5.2-4.3-4.6-4.7-5.8-.5-1 2.6-.8 2.6-.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.5 197.7s1.8 6.2.6 5.6c-1-.5-2.5-5.2-2.6-6.2-.2-1 2 .6 2 .6zm6.2-8.8s2.7 4.1 1.8 4.2c-.8.2-4-2.7-4-3.2-.1-.5 2.2-1 2.2-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332 189s3.5 4.8 2.4 5c-1 .2-1.1-.5-1.1-.5s-2.8-2.5-3-3.1c-.1-.6 1.6-1.4 1.6-1.4m3.5.1s2.4 2.5 1.8 3.3c-.6.8-4-3.1-4.4-3.6-.4-.5 2.9.2 2.9.2m-6 3.5s3.8 7.5 3 8.2c-.6.8-4.9-5.6-5-6.5-.2-.9 2-1.8 2-1.8"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.5 193.2s1.5 2.3 1.4 3.6c0 1.2-2.3-1.8-2.5-2.4-.2-.6 1-1.2 1-1.2zm3.1-1.2s1.2 2.4.8 3.1c-.3.8-2-1.4-2.5-2.3-.6-.8 1.7-.8 1.7-.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M325 194.4s2 2 1.9 3.1c-.1 1.1-2.8-1.6-3-2-.3-.6 1.2-1.1 1.2-1.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M337.2 188.4s2.8 2.5 2.4 3c-.5.3-4.3-2.4-4.9-3-.6-.5 2.5 0 2.5 0z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m334.8 188.2 2.2 1.9s2 1.3 1.7 1.7c-.3.3-3.6-1.1-4.1-1.8-.6-.7-.6-1.4-.6-1.4zm7.3.6s8.4 3.4 8 4.2c-.3.8-8.8-2.7-10-3.7-1.4-.9 1.8-.6 1.8-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M342.4 189.8s6.3 3.6 5.5 4c-.7.3-5.2-1-7.5-2.5a36.6 36.6 0 0 1-3.3-2.5l2.8-.6zm-15.5 4.4s1.2 2.4.8 3c-.4.8-1.5-.5-2.1-1.4-.6-.8 1.3-1.6 1.3-1.6zm.3 5.4s1 3.5-.1 4.2c-1.1.6-1.8-3.6-1.8-4.5 0-.9 1.9.3 1.9.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M322.3 193.8s3.5-1.5 4.1-1.4c0 0 .8-.2 1.1-.5l1.3-1s-.6-4.3 3.9-3.8l11.5 1.1a45 45 0 0 1 6.5 2l9 3.9a30 30 0 0 1 4 2.3c.8.5-.1.1-.1.1s-10.7-5.7-14.5-6.4c-1-.2 0 1 0 1l-3.4-1.3a6 6 0 0 0-2.9-.6 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.3.4-1.6-.2-.5.6s-1.5.3-1.6-.2c-.1-.4-1 2.3-1.3 3-.4.9-1.9.9-2.3 1.4l-1 .9c-.2.1-1.3.8-1.7.8l-2.9.2-.6-1zm4.6 10-.1 3.3c-.2.2-1.8.1-1.8-2.2s.5-2.4.5-2.4l1.5 1.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.3 201.4s-.3-1.4-.5-1.6c-.3-.2 0-.3 0-.3s-.5-1.4-.9-1.6c-.3-.2.1-.4.1-.4s-.6-1-1-1.2c-.4-.3 0-.4 0-.4s-.5-1.2-1.5-1.8c0 0-.7-.7-1.4-.9-.7-.2-2.4-.4-4.5-.3-2.2 0-3.2 1.5-3.2 1.5l-.1 1.8.3-.2-.5 2.2c0 .5.5 1.4.5 2.5v1c.1 1 .4 2 .8 2.9v.2c.2-.2.5.6.7 1 0 0 0 1 .2.6l.6 1.1c0 .2.5 1.4.5.9 0-.6.4 1.3.4 1.5l.5-.7.2.8h.5l-.2.8s1.2-1 1.3-1.4v-.6l.4-.4.6-1s1.5 1.2 1.7 1.7l.3.7.4-.3.3.8.3-.4.2.6.1.3c.1.1.4.2.8-.6.6-1 .6-1.9.6-2 0-.3.3.2.3.2s.6-1 .5-1.6c0-.7.3-.4.3-.4v-2.2c0-.4.3-.3.3-.3l-.2-2.3c-.2-.2.3-.2.3-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M324.3 196.7c.3 0 .4.4.6.6-.1-.4-.3-.7-.6-.8zm.3 1.2c.5.5.6 1.1.5 1.8v.1c0-.7 0-1.5-.5-2zm1.1.7a3 3 0 0 1 .4 1.6c0-.6 0-1.2-.4-1.7m.4 2.5c0 .4 0 .7-.2 1a.4.4 0 0 0 0 .2 11 11 0 0 0 .2-1.2m-.4 1.9v.7a3.8 3.8 0 0 0 0-.8m.7 0c.2.1.3.3.3.6a.4.4 0 0 0 0-.1 1.2 1.2 0 0 0-.3-.7zm0-2.6.4.5v-.2a3.1 3.1 0 0 0-.5-.5zm-1.4 2a5.9 5.9 0 0 1 0 1 6.6 6.6 0 0 0 0-1m-.7.7a5.2 5.2 0 0 1 0 1 6.2 6.2 0 0 0 0-1.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M310.7 194.3s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.7 194.3s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M312.6 194.3s-1.6 1.7-1.6 2.6c0 1 2.4-1.3 2.6-1.7.2-.4-1-.9-1-.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.6 194.3s-1.6 1.7-1.6 2.6c0 1 2.4-1.3 2.6-1.7.2-.4-1-.9-1-.9z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M285 194.5s-3.3 1.7-3.6 2.4c-.3.7 10-1 15.8-5l-2.3-1.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M285 194.5s-3.3 1.7-3.6 2.4c-.3.7 10-1 15.8-5l-2.3-1.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M289 195.2s-6 2.2-1.7 2.3c0 0 8.7-1.8 13.3-5.4l-1.1-1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M289 195.1s-6 2.3-1.7 2.4c0 0 8.7-1.8 13.3-5.4l-1.1-1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M298 189s-6.5 3.4-5.8 3.7c.7.4 5.3-.6 7.7-2l3.4-2.4-2.9-.8-2.5 1.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298 189s-6.5 3.4-5.8 3.7c.7.4 5.3-.6 7.7-2l3.4-2.4-2.9-.8-2.5 1.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M295.5 196.3s-2.3 1.9-2 2.1c.2.2 5-.5 8.6-3.4l-.5-1.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.5 196.3s-2.3 1.9-2 2.1c.2.2 5-.5 8.6-3.4l-.5-1.7-6.2 2.9"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M291.5 196s-2.2 1.7-1.7 1.8c.5.1 2.3 1.5 10.6-3.9l1-.6-1.5-2-8.4 4.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.5 196s-2.2 1.7-1.7 1.8c.5.1 2.3 1.5 10.6-3.9l1-.6-1.5-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M289.8 189.6a66 66 0 0 0-13.9 7.2l17.9-7m11.2 10.6s-1.5 2.3-1.2 2.5c.3.3 2.1 1.2 4.3-1.7 2-3-2-2.5-2-2.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305 200.4s-1.5 2.3-1.2 2.5c.3.3 2.1 1.2 4.3-1.7 2-3-2-2.5-2-2.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M306.6 202s-1 2.4-.5 2.6c.6.3 2-.1 3.2-2.2 1.2-2.2-.6-1.1-.6-1.1zm-3.3-3.5s-2.2 2.7-1.7 3.1c.4.4 3 .3 4.9-2.4 1.9-2.6 0 0 0 0l-.5-2.5-2.7 1.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306.6 202s-1 2.4-.5 2.6c.6.3 2-.1 3.2-2.2 1.2-2.2-.6-1.1-.6-1.1zm-3.3-3.5s-2.2 2.7-1.7 3.1c.4.4 3 .3 4.9-2.4 1.9-2.6 0 0 0 0l-.5-2.5-2.7 1.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M301.2 197.1s-2.2 2.6-2 3c.2.5 3.2.3 5.6-2.2s.5-3.5.5-3.5l-4 2.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.2 197.1s-2.2 2.6-2 3c.2.5 3.2.3 5.6-2.2s.5-3.5.5-3.5l-4 2.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "m297.4 197.3-1.4 1.9s.3 1.8 5.1-1.5l4.5-3-2.5-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m297.3 197.2-1.3 2s.3 1.8 5.1-1.5l4.5-3-2.6-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "m282.2 194.5-3 1.3s-.7.6 1 .7c1.8 0 5.5-.5 11.9-4 2.8-1.7 4.7-3.3 4.7-3.3l-2.4-.8-12.2 6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m282.2 194.5-3 1.3s-.7.6 1 .7c1.8 0 5.5-.5 11.9-4 2.8-1.7 4.7-3.3 4.7-3.3l-2.4-.8-12.2 6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M277 196.4s4.4-.5 6-1.6c0 0-.3.5 2-.4 0 0-1.2 2 5.3-2 6.5-3.8 0 0 0 0l7.2-4.1-.4-.8-14.7 6.2c-1 .3-5.4 2.7-5.4 2.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m290.3 192.4 7.2-4.1-.4-.8-14.7 6.2c-1 .3-5.4 2.7-5.4 2.7s4.4-.5 6-1.6c0 0-.3.5 2-.4 0 0-1.1 2 5.3-2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M308.5 202s-.4 3.4.1 3.5c.5.1 2-1 2.6-3 .6-2.2-2.4-2-2.4-2l-.4 1.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M308.5 202s-.4 3.4.1 3.5c.5.1 2-1 2.6-3 .6-2.2-2.4-2-2.4-2l-.4 1.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M310.8 203.5s-.3 2.4 0 2.6c.4.3 1.3.4 2.3-1.6 1-2 .5-1.3.5-1.3l-2.3-1.2-.5 1.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.8 203.4s-.3 2.5 0 2.7c.4.3 1.3.4 2.3-1.6 1-2 .5-1.3.5-1.3l-2.3-1.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M311.4 199s-1.9 4-.8 4c1 0 2.5-3 2.7-3.7.2-.7-1.9-.3-1.9-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.4 199s-1.9 4-.8 4c1 0 2.5-3 2.7-3.7.2-.7-1.9-.3-1.9-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M311.3 199s-.8 4.5.2 4c1-.3 1.6-3.7 1.7-4.4 0-.7-2 .4-2 .4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.3 199s-.8 4.5.2 4c1-.3 1.6-3.7 1.7-4.4 0-.7-2 .4-2 .4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M312.8 199.4s-1.1 3.5 0 4.2c1 .7 1.8-3.4 1.9-4.3 0-1-2 .1-2 .1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.8 199.4s-1.1 3.5 0 4.2c1 .7 1.8-3.4 1.9-4.3 0-1-2 .1-2 .1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.4 198.3s-1 3.2-.4 3.5c1.2.6 2.3-2.2 2.4-3.3.1-1.2-2-.2-2-.2zm-7.9-6.6s-2.8 2.4-2.5 2.7c.3.4 3.6-.2 5.1-1.3l2.1-1.5-2.5-1.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303 189.3s-1.8 1.5-1.5 1.9c.4.3 3.6-1 4.2-1.7.6-.6.6-1.3.6-1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304.9 189s-2.5 2.1-1.9 2.9c.6.7 4-2.6 4.5-3 .5-.4-2.9 0-2.9 0"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m303.8 188.2-5 2.3s-4.2 2.7-3.8 3c.4.3 3.7-.6 6-1.7a37.9 37.9 0 0 0 5-3.1m-.9 2.1s-5.3 4.7-4.5 5.1c.8.5 4.4-1.4 6.8-3.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.8 192.4s-3 5-2.7 5.6c.4.5 2.6-1.2 3.7-2.5s2-3.2 2-3.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M307.6 192.8s-3.3 6.1-3 6.6c.4.5 2.4.1 3.5-2.3 1.2-2.4 1-4 1-4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.5 193.1s-3.7 7.6-3 8.3c.8.8 4.8-5.7 5-6.6.3-1.6-2-1.8-2-1.8m-7.7-4.9s-3.3 1.6-2.7 2c.7.2 3.8-1.2 4.2-1.3.5-.1-1.5-.7-1.5-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.3 188.6s-2 1.6-1.6 2c.4.5 3.5-1.2 4-1.7.7-.5-2.4-.3-2.4-.3zm4.3.2s-2.8 3.7-2 3.8c.9.2 4.1-2.4 4.2-2.8 0-.5-2.2-1-2.2-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M307.8 189.6s-3 3.7-2.1 4c.8.2 1-.4 1-.4s2.3-2 2.4-2.5c.2-.5-1.2-1.2-1.2-1.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.7 190.5s-2.1 3.7-1.6 4c.6.2 1.5-.8 2.4-1.9.9-1-.8-2.1-.8-2.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.3 192.2s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.3.6-.8-1.2-1.7-1.2-1.7zm.5 6.5s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.7 194.4s-.9-.3-1.5-.3c0 0-1.9-1.4-3-1.6-1-.1 0-.2 0-.2s-.2-2.4-.5-2.6c0 0-.1-2.5-1.7-2.6-1.6-.2-5.1.1-5.7-.1-.7-.3-2.6-1-6.3 0-3.8 1-11.2 4.3-11.6 4.4-.4 0 8.5-2 11-3l3.3-.5s-2.8 1.4-.2.8c2.6-.6 2 0 2 0s-.2.6 1.3.3c1.4-.4 1.4 0 1.4 0s1.7.6 3-.2c0 0 .7 2.3 1.6 2.6 0 0 1 2.2 3.1 2.6l1.2.9 1.2.4 1.3-1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.3 188s-8.6 3-8.3 3.9c.4.8 9-2.4 10.3-3.2 1.4-1-2-.7-2-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "m321.8 194.6.5.2a1.5 1.5 0 0 0-.3-.3l-.7-.3.1.2zM315 201c.2.2.2.5.3.8v-.2c-.1-.2-.1-.5-.3-.7zm1.2-6.5.9-.2v-.1l-.9.1zm1.7-.2.8-.1a.3.3 0 0 0 0-.1 2 2 0 0 0-.8.1zm-3 1.5a.3.3 0 0 0 0 .2zm-.1 4.6a4.8 4.8 0 0 0 0 .7.4.4 0 0 0 0-.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#bd8759",
      d: "M316.6 213.9s-1 .7-1 1a3.8 3.8 0 0 0-.2.8s.8-.1.7.3c0 0 .3.2.8-.8.4-1 .8-1.5 1.1-1.5.4 0 .8.4 1 .6.2.2.4.4.8.3 0 0-.4-.6-.2-.7l.6-.1s-.3-.7-.9-.8c-.6-.1-1-.3-1-.6.2-.2 1-2.4 1-2.4l-1-1.5-.5 1.3.2 1-1 2.1c0 .1-2.4 1-2.7 1l-.8.9v.5s.3-.4.4-.2c0 0 .3-.3.6-.2.2.1.1.2.1.2l.5-.4.1-.1.6-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.6 213.9s-1 .7-1 1a3.8 3.8 0 0 0-.2.8s.8-.1.7.3c0 0 .3.2.8-.8.4-1 .8-1.5 1.1-1.5.4 0 .8.4 1 .6.2.2.4.4.8.3 0 0-.4-.6-.2-.7l.6-.1s-.3-.7-.9-.8c-.6-.1-1-.3-1-.6.2-.2 1-2.4 1-2.4l-1-1.5-.5 1.3.2 1-1 2.1c0 .1-2.4 1-2.7 1l-.8.9v.5s.3-.4.4-.2c0 0 .3-.3.6-.2.2.1.1.2.1.2l.5-.4.1-.1.6-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#bd8759",
      d: "M323.1 209.2v2.1c0 .3 0 .8-.2 1.1-.2.3-.4.5-.7.5-.3 0-1 0-1.2.3l-.3.4s.5-.3.6 0l-.2.6.9-.2.8-.3.4.2v1c0 .4 0 1.2.3 1.2l.4-.5.5.5-.1-1.2a6.7 6.7 0 0 1-.3-1l1.5.6c0 .2.4.5.5.5.1 0 0-.5.2-.5.3-.1.4 0 .4 0s-.4-.8-1-1c-.5-.4-1-.4-1.2-.6l-.3-.9v-2.8l-1-.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323.1 209v2.3c0 .3 0 .8-.2 1.1-.2.3-.4.5-.7.5-.3 0-1 0-1.2.3l-.3.4s.5-.3.6 0l-.2.6.9-.2.8-.3.4.2v1c0 .4 0 1.2.3 1.2l.4-.5.5.5-.1-1.2-.3-1s1.4.5 1.5.7l.5.4c.1 0 0-.5.2-.5.3-.1.4 0 .4 0s-.4-.8-1-1c-.5-.4-1-.4-1.2-.6l-.3-.9v-2.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#dcddde",
      d: "M315 197.3s0-1.3.3-1.4c0 0 .1-1.2 1.7-1 0 0 .5-.9 1.4-.4 0 0 .8-.4 1.3-.2l1 .7s.7-.1 1 .1c.3.3.2 1.1.2 1.1s.8.6.8 1.1v.9s.3.3.2.7c0 .4-.4 1-.4 1-.1 0 0 1-.3 1.3l-.8.5c-.2 0-.6.6-1 .6-.3 0-.8-.5-.8-.7 0-.2-.6-.4-.6-.4s-1 1.2-1.8 1c-.8-.2-1.1-.8-1.2-1l-.3-1s-.8-.4-.7-.9c0-.4.4-1 .4-1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m317.8 212-.2-.1m.6-.9a.8.8 0 0 1-.3-.1m0 .6h.2m5.5.5.5.2m-.2-.6h-.3m.4-.5a.9.9 0 0 1-.5 0m0 1.8.4.1m-.4.5a.2.2 0 0 1 .2 0m-.1 1.6a.4.4 0 0 1 .3 0m-5.1-2a.3.3 0 0 0-.3.1m1-.1c-.1.1-.3.2-.3.4m-4.5.5.4.3m10-1a.3.3 0 0 0-.3.3m.7-.1a.2.2 0 0 0 0 .2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "M313.4 215h.6s-.3.7-.2.8c0 .2-.5-.3-.3-.7"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.4 215h.6s-.3.7-.2.8c0 .2-.5-.3-.3-.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "M315.6 215.5s-.7 1 .1 1.5c0 0 0-1 .6-1.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.6 215.5s-.7 1 .1 1.5c0 0 0-1 .6-1.1z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "m319.6 214.5-.2-.5.2-.3h.6s.4.9 0 1.3c0 0 0-.5-.2-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m319.6 214.5-.2-.5.2-.3h.6s.4.9 0 1.3c0 0 0-.5-.2-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "M321 213.4h.3l.1.3v.3l-.3.2s-.5-.2-.4.5c0 0-.3-1.2.2-1.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M321 213.4h.3l.1.3v.3l-.3.2s-.5-.2-.4.5c0 0-.3-1.2.2-1.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "m323.5 215.9.4-.4.4.2-.3 1.2-.2-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m323.5 215.9.4-.4.4.2-.3 1.2-.2-.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "m326 214.8.5 1s.6-.6-.2-1.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m326 214.8.5 1s.6-.6-.2-1.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "m323.3 195.9.2.2v-.1zm.1 2.2.4.7v-.2a1.7 1.7 0 0 0-.4-.7zm-.4-1.6.5.6v-.2zm.5 3.5c0 .3 0 .6-.2.8v.2c.2-.4.2-.7.2-1.1a.5.5 0 0 0 0 .1m.5 1v.5a.4.4 0 0 0 0 .1 2.2 2.2 0 0 0 0-.6m1.8 3.9a4.8 4.8 0 0 1 .1 1.3l-.1-1.5zm-.3.8-.4 1 .4-.8zm-10.3-2.9.7 1.2v-.1zm1.8 0c-.2 0-.3-.3-.5-.4v.2c.2 0 .3.4.5.4zm-1 1.8.5 1v-.2l-.5-1zm1.2.4.5.8v-.1c0-.3-.3-.6-.5-.8m0 1.3.2.7v-.1zm1.1.3a2.8 2.8 0 0 1 .1.7 3.3 3.3 0 0 0 0-.9v.2m-.5 1c0 .3.1.7.3 1v-.2a3.2 3.2 0 0 1-.3-.9.4.4 0 0 0 0 .1m.2-4.4.8.3v-.1a8 8 0 0 1-.8-.3zm.2 1.2 1 .4c-.3-.3-.7-.4-1-.6zm.3 1.2.6.6v-.1a4.5 4.5 0 0 1-.6-.6zm.4 1.6.2.7a1.8 1.8 0 0 0-.2-.8zm1-4v.5a10 10 0 0 1 0-.5m2.3-.9a3.6 3.6 0 0 1-.2.5v.1l.2-.4zm1 0v.8a.4.4 0 0 0 0 .1 4.2 4.2 0 0 0 0-1m.2 1.6v.7a3.7 3.7 0 0 0 0-.8m.7 1.5c0 .3-.2.6-.5.8v.1c.3-.2.5-.4.5-.8m-2.4-1.5-.2.4v.1zm.3 1.8a1.9 1.9 0 0 1-.4.4v.1c.2 0 .3-.2.4-.3zm-.9 1c-.3-.4-.4-.8-.3-1.3v-.1c-.2.5 0 1 .3 1.5v-.2m-1-1-.1.5v-.6m2.6 1.3c0 .3-.2.5-.3.7v.1l.3-.6zm1.7.7a9.2 9.2 0 0 1-.5.7v.2zm.8.8a17 17 0 0 0-.2 1.3v.1za.6.6 0 0 0 0-.1m1-1.6v.5zM315 202l.1 1.3v-.2a2.2 2.2 0 0 1-.1-1 .6.6 0 0 0 0-.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M318.8 196.3c.7-.6 1.7-1.3 2.7-1v-.2c-1-.2-2 .5-2.7 1.1zm3.5.8c-.8-.5-2-.6-2.7 0 .7-.5 2-.3 2.7.2zm-2.8 1.1c.3 1 .7 2 .5 3 .2-1-.2-2-.5-3m-1.1.6v3c0-1 .2-2 0-3.1a.4.4 0 0 0 0 .1m1.5-.7c1 .2 1.9.9 2.4 1.7v-.1a3.9 3.9 0 0 0-2.4-1.7zm-.8 1.3c0 .6 0 1.2-.2 1.8.2-.5.2-1.2.2-1.8m1.4-.1a3.1 3.1 0 0 1 1.2 2v-.1a3.2 3.2 0 0 0-1.2-2m-4.3 1.7c.2-.3.4-.6.8-.7v-.1c-.4 0-.6.4-.8.7zm1.4-5c-.1-.6-.5-1-1-1.2v.1c.5.3.9.6 1 1.2zm-.8 0c-.5-.2-1-.2-1.5-.2a.3.3 0 0 0 0 .1c.5 0 1 0 1.5.3zm1.5 0c0-.6 0-1-.4-1.3.3.3.5.7.4 1.2m1.8.7c.5-.3 1-.2 1.5-.2v-.2c-.5 0-1 0-1.5.2zm.9 1.2a2.6 2.6 0 0 1 1.7 1v-.3a2.6 2.6 0 0 0-1.7-1zm-3.1 2c-.2.6 0 1.5-.9 1.8v.2c.8-.3.7-1.1.9-1.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M319.5 199c.3.7.7 1.4.5 2.2a.9.9 0 0 0 0 .3c.2-1-.1-1.8-.5-2.7zm1-.1c.7 0 1.3.7 1.4 1.4a1 1 0 0 0 0-.2 1.7 1.7 0 0 0-1.4-1.5zm0 1c.1.6.3 1.2.1 1.8v.2c.3-.7 0-1.5 0-2.2a1 1 0 0 0 0 .2m-.4-2.6c.7-.1 1.5-.2 2.2.3v-.3c-.7-.5-1.5-.4-2.2-.2zm-1.4-1.5c0-.6.6-1 1.2-1.3v-.2c-.6.2-1.2.6-1.3 1.3a1 1 0 0 0 0 .2m-.6.4c0-.7-.4-1.3-.7-1.9v.2c.3.6.6 1.1.6 1.8zm-.6.4a2 2 0 0 0-1-1.4v.3c.5.3.9.7 1 1.3a.8.8 0 0 0 0-.2m-1-.3a2.9 2.9 0 0 0-1.2-.5v.2c.5 0 .8.3 1.2.5zm2.2 3c0 .6.2 1.3-.2 1.9v.2c.4-.7.3-1.6.2-2.3z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M319.4 198.9c.2.6.5 1.3.4 2a5.8 5.8 0 0 0-.4-2.3zm.5-1c.6.3 1.3.5 1.7 1v-.3a3.6 3.6 0 0 0-1.7-.9zm-1.7-1.4a14.8 14.8 0 0 0 0-1.7 11.8 11.8 0 0 1 0 1.7m-1.2-.4a5.6 5.6 0 0 1-1.2-.8v.2l1.2.9zm-.2 3.3c-.3.2-.5.5-.6.8v.2a1.6 1.6 0 0 1 .6-.7zm.9.5c0 .5-.3.9-.6 1.2v.2c.4-.4.6-.8.6-1.3 0 0 0-.3 0 0m2.1-3.6c.4-.6 1.3-.7 1.9-.9v-.2c-.6.2-1.5.2-2 .8v.3m-4 0a2 2 0 0 1-.5-.3v.2l.4.2v-.2m.1 3-.4.3v.1a.7.7 0 0 0 0 .1.8.8 0 0 1 .4-.2.7.7 0 0 0 0-.2m.5.1-.6.6v.2l.6-.6zm1 .3c-.1.6-.8 1.2-.3 1.8v-.2c-.3-.5.2-1 .4-1.4zm.7 0c0 .6 0 1.1-.2 1.7a.9.9 0 0 0 0 .2 9.8 9.8 0 0 0 .2-2m1.9-.6c.4.5.8 1.1 1 1.8v-.2a5 5 0 0 0-1-1.9zm.2-.5c.7.6 1.5 1 2 1.8v-.2c-.5-.8-1.3-1.3-2-1.8z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M320.5 197.8h.8l.6.5.6.4c.2.2.2.6.3.9a.7.7 0 0 0 0-.2l-.2-.7c0-.2-.3-.4-.5-.5l-.7-.4a1.4 1.4 0 0 0-.9-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "m322.3 199.3.2.6v-.1l-.2-.7zm-2-3.6 1.5-.4v-.3l-1.5.4zm-2 .2c0-.2.1-.5.3-.7l.4-.8v-.3l-.4.7c0 .3-.3.5-.4.9zm-1.7 4.6.1 1.3v-.2a1.4 1.4 0 0 1 0-.8.7.7 0 0 0 0-.2s0-.1 0 0m1 .7c-.2.3-.2.6-.1 1a.3.3 0 0 0 0-.2zm.8-.5-.2.7v.2zs0-.2 0 0m0-1.5v.4zm-.3.2a.7.7 0 0 0 0 .3v-.7zm-.5-.2-.1.5a.8.8 0 0 0 0 .2 3.3 3.3 0 0 1 .1-.4zm-.4 0-.8.6v.3l.8-.7zm-.6 0a1.6 1.6 0 0 1-.5.3v.3c.2 0 .3-.2.5-.3v-.2m-1-.3-.4.2v.2c.2 0 .3 0 .4-.2zm2.9 0v.4a.8.8 0 0 0 0-.2v-.4zm.4-.2.1.6v-.3a1 1 0 0 1 0-.3v-.1.1m.3 0v.3h.1a.8.8 0 0 0-.1-.6zm.4-.2.4.2v-.2a.8.8 0 0 0-.4-.2zm.2-.3.6.3v-.3a1.2 1.2 0 0 1-.6-.3zm.5-1h.4v-.2a2.3 2.3 0 0 0-.4-.1zm-.3-.6.4-.3v-.3l-.4.4zm-.4-.5a1 1 0 0 1 .2-.5v-.2a1 1 0 0 0-.2.7m-.3-.2.4-.8v-.2l-.4.7z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M318.6 195.3v.9a.7.7 0 0 0 0-.3 3.7 3.7 0 0 1 0-.7zm-1.3.2.2.3v.6l.1-.5-.3-.6zm-.2.5a4.5 4.5 0 0 0-.6-.4v.2l.6.5zm.8.2c0-.6 0-1.2-.2-1.7v.3c.2.4.3.7.2 1.2a.8.8 0 0 0 0 .1m1.2-.7v-.2z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "m317.7 196.3.2-1v-.2l-.2 1zm3.5 2c.3 0 .6.3.7.6v-.4c-.1-.3-.4-.5-.7-.6zm-1 2a1 1 0 0 1 0 .4 1.2 1.2 0 0 0 0 .3h.1v-1 .3m-.8-.5v1.2s0 .2 0 0v-1.4zm-.4.4-.3 1.2a1 1 0 0 0 0 .3s0 .1 0 0l.3-1.2zm.5.2v1.1a1.3 1.3 0 0 0 0 .3v-1.6zm-2.6.2a.6.6 0 0 1 0 .1v.4c.1-.2.1-.6 0-.8 0-.1 0 0 0 0zm1.2-.8v.4c0-.3.1-.6 0-.8zm.3 0a.4.4 0 0 1 .1 0v.1a.8.8 0 0 0 0 .1v-.2l-.1-.5a1.3 1.3 0 0 0 0 .2zm.4-.3.1.3v-.3l-.1-.4a.9.9 0 0 0 0 .1v.2m.8-.2.5.6v-.4a9.3 9.3 0 0 1-.5-.6zm.5-.8.3.6v-.4a4.1 4.1 0 0 1-.3-.5zm-4.3-2a1.7 1.7 0 0 0-.4-.2 1.1 1.1 0 0 0 0 .2v.2l.4.3zm1.3-.5a.5.5 0 0 1 0 .1.8.8 0 0 0 0 .2za1 1 0 0 0 0-.4.8.8 0 0 0 0 .2zm1-1v.8c-.1 0-.1.1 0 .2v.1l.1-1.2a.6.6 0 0 0 0-.1v.2m.2 1.5.5-.7v-.3l-.5.6zm.7 0 .2-.3v-.4l-.2.2a1.3 1.3 0 0 0 0 .2v.2m1 .2a7.6 7.6 0 0 1-.8 0v.4h.8zm-.3.9 1 .6v-.4l-1-.6z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "m320 198 .8.5v-.4l-.8-.5a2 2 0 0 0 0 .2zm-2-1.4.1-.5v-.2.6m-2.3-1c.2.3.5.6.9.8l.6.7s.1-.4 0-.4l-.6-.6-1-.9c.1 0 0 .3 0 .4m.6 1a7.7 7.7 0 0 1-.4-.4 1.6 1.6 0 0 0 0 .2v.1l.4.5zm-.3 2.5-.3.6v.4l.3-.6zm.3.4-.1.6a1.3 1.3 0 0 0 0 .3zv-.2a.6.6 0 0 0 0 .1m1 1.8c.2-.6.2-1.3.2-2v.2c0 .5 0 1-.2 1.4zm.6-1.5v.6a1.3 1.3 0 0 0 0 .3v-1.3a.6.6 0 0 0 0 .2zm.6-.2c.2.2.3.6.2 1v.1c.1-.5.1-1-.2-1.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M318.6 199.3a12.6 12.6 0 0 1 .3 1.7v-.3l-.2-1.7v.3m.5-.1.6 1v-.3l-.6-1zm1.1-1c0-.1-.3-.2-.5-.1v.3c.2 0 .4 0 .5.2v-.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#fff",
      d: "M319.7 198.1a7.5 7.5 0 0 1 1.1 0v-.4a7.5 7.5 0 0 0-1 0c-.1 0 0 .4 0 .4m.6-3c-.3.4-.4.9-.5 1.3v.3s0 .1 0 0c0-.4.2-.8.5-1.1zm-1.5.4.2 1a.7.7 0 0 0 0-.2v-.2l-.2-1zm-.3.5a1.6 1.6 0 0 1-.3-.5.8.8 0 0 0 0 .2v.2l.2.5v-.3m-.5.2a4 4 0 0 1-1.2-.6v.4l1.2.6s.1-.4 0-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#dba05f",
      d: "m318.5 196.2-2.2.4-1.8.2-1.3-.4c-.3 0-1.6-.2-2 .3l-.9.8c-.1.1-.7.6-.7.9 0 .2.1.5.4.5.3 0 .9.6.9.7 0 .3.8.5 1.5.5 1.3 0 2-.7 4-.5 1 .2 3-.7 3.4-1.2.4-.5.6-1 .2-1.7-.3-.6-1.4-.5-1.5-.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m318.5 196.2-2.2.4-1.8.2-1.3-.4c-.3 0-1.6-.2-2 .3l-.9.8c-.1.1-.7.6-.7.9 0 .2.1.5.4.5.3 0 .9.6.9.7 0 .3.8.5 1.5.5 1.3 0 2-.7 4-.5 1 .2 3-.7 3.4-1.2.4-.5.6-1 .2-1.7-.3-.6-1.4-.5-1.5-.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "m311.4 198.1.1-.1.1-.2a.8.8 0 0 1 .4-.3h.5-.2.2-.2l-.3.1c-.3 0-.3.4-.6.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      d: "m311.3 198 .4-.4.6-.3h.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      d: "m312 197.4-.4.3c0 .2-.3.3-.3.3m.7-.5h.5m-.6 0h.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "m312.4 197.9-.2.1-.1.1-.3.2-.3.1.4-.2-.4.2.4-.1-.3.1h.1s.3 0 .7-.4"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      d: "m312.3 197.8-.3.2-.3.2-.2.1m.4-.1.2-.2.2-.2m-.4.4-.3.1m.4-.1-.3.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#c6262c",
      d: "M312.9 196.5s0-.6-.6-.8c-.5-.2-1-.2-1.3-.2l-.5.2a2.5 2.5 0 0 0-.6.2l-.1.2c-.1.2-.4.4-.3.6.2.3 0 .3.2.3s-1 .3-.8.8c.3.6.5.4.6.3l.5-.2.7-.7 1-.4h.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.9 196.5s0-.6-.6-.8c-.5-.2-1-.2-1.3-.2l-.5.2a2.5 2.5 0 0 0-.6.2l-.1.2c-.1.2-.4.4-.3.6.2.3 0 .3.2.3s-1 .3-.8.8c.3.6.5.4.6.3l.5-.2.7-.7 1-.4h.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      d: "M312.2 197.8c0 .1-.1.3-.3.3h-.3s.1-.4.3-.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "M308.6 200.2s-.7-1.2 1.2-1.8c0 0 .6.3.8.6 0 0-.4.5-1.5.7 0 0-.5.1-.5.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.6 200.2s-.7-1.2 1.2-1.8c0 0 .6.3.8.6 0 0-.4.5-1.5.7 0 0-.5.1-.5.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#d9c0b9",
      d: "M308.8 200s.8.2 1.3-.2c.5-.3.6-.2.7-.1 0 0 0-.4-.2-.7l-1 .5c-.4.2-.7.1-.8.5"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.8 200s.8.2 1.3-.2c.5-.3.6-.2.7-.1 0 0 0-.4-.2-.7l-1 .5c-.4.2-.7.1-.8.5z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#7a2e26",
      d: "M311 199.6h.5v-.1za.3.3 0 0 0 0 .1m-.3-2-.1.2v.1zm.5.2.3-.2v-.1c-.2 0-.3 0-.3.2zm.5.8a.3.3 0 0 0 .2-.2.3.3 0 0 1-.2 0zm.4-.2a.8.8 0 0 0 .4-.3v-.1a.7.7 0 0 1-.4.3zm-.7-.7c0 .2-.2.2-.3.4v.1c0-.1.3-.2.3-.4m.3 2c.4 0 .7 0 1-.2a3.1 3.1 0 0 1-1 0zm1.6 0c.4-.4.8-.7 1-1.3a2 2 0 0 1-1 1v.2m.3-.8c.3-.2.5-.4.6-.8v-.1a1.6 1.6 0 0 1-.6.8zm-.2-2 .7.4v-.1l-.7-.4zm6.3 1c.2-.5 0-1-.2-1.4.2.4.4.8.2 1.2zm-4.8-.7c.3.2 1 .7.8 1.2.3-.5-.4-1-.8-1.3zm2.1 2a1.4 1.4 0 0 0 .1-.3 1.3 1.3 0 0 1 0 .3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#5e3f17",
      d: "m317.9 199.2.5-.2m-8.5-.3c-.3.2-.8.2-1 .7.2-.5.7-.5 1-.6"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#842116",
      d: "M309.7 197.3c.1 0 .3 0 .3.2a.4.4 0 0 0 0 .1.7.7 0 0 0 0-.3l-.3-.1m.7.4a.7.7 0 0 0-.1-.6v.5m.6-.5c0-.3-.1-.5-.3-.6v.1c.2.1.3.4.3.6a.4.4 0 0 0 0-.1m.5-.1c0-.3 0-.5-.2-.6v.1l.2.3a.4.4 0 0 0 0 .1m-.8-.7c.4-.2 1.4-.3 1.8.2v-.2c-.4-.4-1.4-.3-1.8 0"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#7a2e26",
      d: "M309.5 198.1v-.5s-.1 0 0 .1zm4.7 1.4a.6.6 0 0 0 .3-.5.6.6 0 0 1-.3.3zm.7 0a.4.4 0 0 0 .1-.3v-.1.3m4.3-2.4a1 1 0 0 1 0 .7.4.4 0 0 0 0 .1v-.9zm-.5.5v.7c.1-.3.2-.6 0-.9zm-.4.3"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M324.3 210.5v.2l.1.1-.1-.4z"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#dcddde",
      d: "M314.4 195c-1.7 0-3.3-1-3.3-1a2.7 2.7 0 0 1-2.3-2.4c-.8-.4-1.6-2.5-1.6-2.5-1.3.7-3 0-3 0s0-.4-1.4 0c-1.5.3-1.3-.3-1.3-.3s.6-.6-2 0 .2-.8.2-.8c-.8.2-3.3.4-3.3.4-.9 0-1.8.5-2.8.8l-2.3.6-6.8 3-5.5 2.1c.2 0 3.4-2.1 7.5-4a87.8 87.8 0 0 1 10.3-3.9 9.9 9.9 0 0 1 6.5 0c.6.2 4.2 0 5.7 0 1.6.3 1.8 2.9 1.8 2.9.3.1.4 2.6.4 2.6s-1 0 .1.1c1 .2 2.9 1.7 2.9 1.7h.7s.4-.5.9-.7l1.5-.5a11.6 11.6 0 0 1 2 0l2 .3 1.2.3h.5c1-.5 3-1.2 3.4-1.1 0 0 .7-.2 1.1-.5a105 105 0 0 0 1.3-1s-.6-4.5 3.9-4l11.5 1.2a43.9 43.9 0 0 1 6.5 1.8l5.2 2.4 4 1.7c2.3 1 4 2.4 4 2.4-1.5-.6-2.6-1.3-3.7-1.8-.9-.4-1.8-.5-2.6-.9l-3.6-1.7c-3.5-1.6-3.5-1.7-4.9-1.8-1 0 .7 1.2.7 1.2l-4.1-1.7a6 6 0 0 0-2.9-.5 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.2.4-1.5-.3-.5.7s-1.5.3-1.6-.2c-.1-.5-1 2.2-1.3 3-.4.8-2.2.6-2.7 1-.4.5-1.4.9-1.6 1h-1.3c-.6 0-.1 0-1 .3 0 0-.9 0-1.2-.2l-1.4-.4a27.5 27.5 0 0 0-3.5-.2 5.4 5.4 0 0 0-2.7 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.4 195c-1.7 0-3.3-1-3.3-1a2.7 2.7 0 0 1-2.3-2.4c-.8-.4-1.6-2.5-1.6-2.5-1.3.7-3 0-3 0s0-.4-1.4 0c-1.5.3-1.3-.3-1.3-.3s.6-.6-2 0 .2-.8.2-.8c-.8.2-3.3.4-3.3.4-.9 0-1.8.5-2.8.8l-2.3.6-6.8 3-5.5 2.1c.2 0 3.4-2.1 7.5-4a87.8 87.8 0 0 1 10.3-3.9 9.9 9.9 0 0 1 6.5 0c.6.2 4.2 0 5.7 0 1.6.3 1.8 2.9 1.8 2.9.3.1.4 2.6.4 2.6s-1 0 .1.1c1 .2 2.9 1.7 2.9 1.7h.7s.4-.5.9-.7l1.5-.5a11.6 11.6 0 0 1 2 0l2 .3 1.2.3h.5c1-.5 3-1.2 3.4-1.1 0 0 .7-.2 1.1-.5l1.3-1s-.6-4.5 3.9-4l11.5 1.2a43.9 43.9 0 0 1 6.5 1.8l5.2 2.4 4 1.7c2.3 1 4 2.4 4 2.4-1.5-.6-2.6-1.3-3.7-1.8-.9-.4-1.8-.5-2.6-.9l-3.6-1.7c-3.5-1.6-3.5-1.7-4.9-1.8-1 0 .7 1.2.7 1.2l-4.1-1.7a6 6 0 0 0-2.9-.5 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.2.4-1.5-.3-.5.7s-1.5.3-1.6-.2c-.1-.5-1 2.2-1.3 3-.4.8-2.2.6-2.7 1-.4.5-1.4.9-1.6 1h-1.3c-.6 0-.1 0-1 .3 0 0-.9 0-1.2-.2a17.9 17.9 0 0 0-1.4-.4c-.5-.2-3.1-.2-3.5-.2a5.4 5.4 0 0 0-2.7 1.1"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#452c25",
      d: "M314.6 194.4s-.2.2-.2.5v.2"
    }),
    /* @__PURE__ */ jsx46("path", {
      fill: "#574f4c",
      d: "m323.3 194 .7.5a.5.5 0 0 0-.1-.1 6.5 6.5 0 0 0-.7-.6.6.6 0 0 0 0 .1"
    })
  ]
});
var Bo_default = SvgBo;

// src/country-flag-icons/generated/Bq.tsx
import { jsx as jsx47, jsxs as jsxs40 } from "react/jsx-runtime";
var SvgBq = (props) => /* @__PURE__ */ jsxs40("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx47("path", {
      fill: "#21468b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx47("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx47("path", {
      fill: "#ae1c28",
      d: "M0 0h640v160H0z"
    })
  ]
});
var Bq_default = SvgBq;

// src/country-flag-icons/generated/Br.tsx
import { jsx as jsx48, jsxs as jsxs41 } from "react/jsx-runtime";
var SvgBr = (props) => /* @__PURE__ */ jsx48("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs41("g", {
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx48("path", {
        fill: "#229e45",
        fillRule: "evenodd",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#f8e509",
        fillRule: "evenodd",
        d: "m321.4 436 301.5-195.7L319.6 44 17.1 240.7z"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#2b49a3",
        fillRule: "evenodd",
        d: "M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#ffffef",
        fillRule: "evenodd",
        d: "m283.3 316.3-4-2.3-4 2 .9-4.5-3.2-3.4 4.5-.5 2.2-4 1.9 4.2 4.4.8-3.3 3m86 26.3-3.9-2.3-4 2 .8-4.5-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.1m-36.2-30-3.4-2-3.5 1.8.8-3.9-2.8-2.9 4-.4 1.8-3.6 1.6 3.7 3.9.7-3 2.7m87-8.5-3.4-2-3.5 1.8.8-3.9-2.7-2.8 3.9-.4 1.8-3.5 1.6 3.6 3.8.7-2.9 2.6m-87.3-22-4-2.2-4 2 .8-4.6-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.2m-104.6-35-4-2.2-4 2 1-4.6-3.3-3.3 4.6-.5 2-4.1 2 4.2 4.4.8-3.3 3.1m13.3 57.2-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.1-4 2 4.2 4.4.8-3.3 3.1m132-67.3-3.6-2-3.6 1.8.8-4-2.8-3 4-.5 1.9-3.6 1.7 3.8 4 .7-3 2.7m-6.7 38.3-2.7-1.6-2.9 1.4.6-3.2-2.2-2.3 3.2-.4 1.5-2.8 1.3 3 3 .5-2.2 2.2m-142.2 50.4-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2M419 299.8l-2.2-1.1-2.2 1 .5-2.3-1.7-1.6 2.4-.3 1.2-2 1 2 2.5.5-1.9 1.5"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#ffffef",
        fillRule: "evenodd",
        d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#ffffef",
        fillRule: "evenodd",
        d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m42.3 3-2.6-1.4-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .5-2.3 2.1m-4.8 17-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m87.4-22.2-2.6-1.6-2.8 1.4.6-3-2-2.3 3-.3 1.4-2.7 1.2 2.8 3 .5-2.2 2.1m-25.1 3-2.7-1.5-2.7 1.4.6-3-2-2.3 3-.3 1.4-2.8 1.2 2.9 3 .5-2.2 2.1m-68.8-5.8-1.7-1-1.7.8.4-1.9-1.3-1.4 1.9-.2.8-1.7.8 1.8 1.9.3-1.4 1.3m167.8 45.4-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m-20.8 6-2.2-1.4-2.3 1.2.5-2.6-1.7-1.8 2.5-.3 1.2-2.3 1 2.4 2.5.4-1.9 1.8m10.4 2.3-2-1.2-2.1 1 .4-2.3-1.6-1.7 2.3-.3 1.1-2 1 2 2.3.5-1.7 1.6m29.1-22.8-2-1-2 1 .5-2.3-1.6-1.7 2.3-.3 1-2 1 2.1 2.1.4-1.6 1.6m-38.8 41.8-2.5-1.4-2.7 1.2.6-2.8-2-2 3-.3 1.3-2.5 1.2 2.6 3 .5-2.3 1.9m.6 14.2-2.4-1.4-2.4 1.3.6-2.8-1.9-2 2.7-.4 1.2-2.5 1.1 2.6 2.7.5-2 2m-19-23.1-1.9-1.2-2 1 .4-2.2-1.5-1.7 2.2-.2 1-2 1 2 2.2.4-1.6 1.6m-17.8 2.3-2-1.2-2 1 .5-2.2-1.6-1.7 2.3-.2 1-2 1 2 2.1.4-1.6 1.6m-30.4-24.6-2-1.1-2 1 .5-2.3-1.6-1.6 2.2-.3 1-2 1 2 2.2.5-1.6 1.5m3.7 57-1.6-.9-1.8.9.4-2-1.3-1.4 1.9-.2.9-1.7.8 1.8 1.9.3-1.4 1.3m-46.2-86.6-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.2-4 1.9 4.2 4.4.8-3.3 3.1"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M444.4 285.8a124.6 124.6 0 0 0 5.8-19.8c-67.8-59.5-143.3-90-238.7-83.7a124.5 124.5 0 0 0-8.5 20.9c113-10.8 196 39.2 241.4 82.6"
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#309e3a",
        d: "m414 252.4 2.3 1.3a3.4 3.4 0 0 0-.3 2.2 3 3 0 0 0 1.4 1.7c.7.5 1.4.8 2 .7.6 0 1-.3 1.3-.7a1.3 1.3 0 0 0 .2-.9 2.3 2.3 0 0 0-.5-1c-.2-.3-.7-1-1.5-1.8a7.7 7.7 0 0 1-1.8-3 3.7 3.7 0 0 1 2-4.4 3.8 3.8 0 0 1 2.3-.2 7 7 0 0 1 2.6 1.2c1.4 1 2.3 2 2.6 3.2a4.1 4.1 0 0 1-.6 3.3l-2.4-1.5c.3-.6.4-1.2.2-1.7-.1-.5-.5-1-1.2-1.4a3.2 3.2 0 0 0-1.8-.7 1 1 0 0 0-.9.5c-.2.3-.2.6-.1 1s.6 1.2 1.6 2.2c1 1 1.6 1.9 2 2.5a3.9 3.9 0 0 1-.3 4.2 4.1 4.1 0 0 1-1.9 1.5 4 4 0 0 1-2.4.3c-.9-.2-1.8-.6-2.8-1.3-1.5-1-2.4-2.1-2.7-3.3a5.4 5.4 0 0 1 .6-4zm-11.6-7.6 2.5 1.3a3.4 3.4 0 0 0-.2 2.2 3 3 0 0 0 1.4 1.6c.8.5 1.4.7 2 .6.6 0 1-.3 1.3-.8a1.3 1.3 0 0 0 .2-.8c0-.3-.2-.7-.5-1a34.6 34.6 0 0 0-1.6-1.8c-1.1-1.1-1.8-2-2-2.8a3.7 3.7 0 0 1 .4-3.1 3.6 3.6 0 0 1 1.6-1.4 3.8 3.8 0 0 1 2.2-.3 7 7 0 0 1 2.6 1c1.5 1 2.4 2 2.7 3.1a4.1 4.1 0 0 1-.4 3.4l-2.5-1.4c.3-.7.4-1.2.2-1.7s-.6-1-1.3-1.4a3.2 3.2 0 0 0-1.9-.6 1 1 0 0 0-.8.5c-.2.3-.2.6-.1 1s.7 1.2 1.7 2.2c1 1 1.7 1.8 2 2.4a3.9 3.9 0 0 1 0 4.2 4.2 4.2 0 0 1-1.8 1.6 4 4 0 0 1-2.4.3 8 8 0 0 1-2.9-1.1 6 6 0 0 1-2.8-3.2 5.4 5.4 0 0 1 .4-4m-14.2-3.8 7.3-12 8.8 5.5-1.2 2-6.4-4-1.6 2.7 6 3.7-1.3 2-6-3.7-2 3.3 6.7 4-1.2 2zm-20.7-17 1.1-2 5.4 2.7-2.5 5c-.8.2-1.8.3-3 .2a9.4 9.4 0 0 1-3.3-1 7.7 7.7 0 0 1-3-2.6 6 6 0 0 1-1-3.5 8.6 8.6 0 0 1 1-3.7 8 8 0 0 1 2.6-3 6.2 6.2 0 0 1 3.6-1.1c1 0 2 .3 3.2 1 1.6.7 2.6 1.7 3.1 2.8a5 5 0 0 1 .3 3.5l-2.7-.8a3 3 0 0 0-.2-2c-.3-.6-.8-1-1.6-1.4a3.8 3.8 0 0 0-3.1-.3c-1 .3-1.9 1.2-2.6 2.6-.7 1.4-1 2.7-.7 3.8a3.7 3.7 0 0 0 2 2.4c.5.3 1.1.5 1.7.5a6 6 0 0 0 1.8 0l.8-1.6zm-90.2-22.3 2-14 4.2.7 1.1 9.8 3.9-9 4.2.6-2 13.8-2.7-.4 1.7-10.9-4.4 10.5-2.7-.4-1.1-11.3-1.6 11zm-14.1-1.7 1.3-14 10.3 1-.2 2.4-7.5-.7-.3 3 7 .7-.3 2.4-7-.7-.3 3.8 7.8.7-.2 2.4z"
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "M216.5 191.3c0-1.5.3-2.6.7-3.6a6.7 6.7 0 0 1 1.4-1.9 5.4 5.4 0 0 1 1.8-1.2c1-.3 2-.5 3-.5 2.1 0 3.7.8 5 2a7.4 7.4 0 0 1 1.6 5.5c0 2.2-.7 4-2 5.3a6.5 6.5 0 0 1-5 1.7 6.6 6.6 0 0 1-4.8-2 7.3 7.3 0 0 1-1.7-5.3"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#f7ffff",
            d: "M219.4 191.3c0 1.5.3 2.7 1 3.6.7.8 1.6 1.3 2.8 1.3a3.5 3.5 0 0 0 2.8-1.1c.7-.8 1-2 1.1-3.7 0-1.6-.2-2.8-1-3.6a3.5 3.5 0 0 0-2.7-1.3 3.6 3.6 0 0 0-2.8 1.2c-.8.8-1.1 2-1.2 3.6"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "m233 198.5.2-14h6c1.5 0 2.5.2 3.2.5.7.2 1.2.7 1.6 1.3s.6 1.4.6 2.3a3.8 3.8 0 0 1-1 2.6 4.5 4.5 0 0 1-2.7 1.2l1.5 1.2c.4.4.9 1.2 1.5 2.3l1.7 2.8h-3.4l-2-3.2-1.4-2a2.1 2.1 0 0 0-.9-.6 5 5 0 0 0-1.4-.2h-.6v5.8z"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "M236 190.5h2c1.4 0 2.3 0 2.6-.2.3 0 .6-.3.8-.5s.3-.7.3-1c0-.6-.1-1-.4-1.2-.2-.3-.6-.5-1-.6h-2l-2.3-.1z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "m249 185.2 5.2.3c1.1 0 2 .1 2.6.3a4.7 4.7 0 0 1 2 1.4 6 6 0 0 1 1.2 2.4c.3.9.4 2 .3 3.3a9.3 9.3 0 0 1-.5 3c-.4 1-1 1.8-1.7 2.4a5 5 0 0 1-2 1c-.6.2-1.5.2-2.5.2l-5.3-.3z"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "m251.7 187.7-.5 9.3h3.8c.5 0 .9-.2 1.2-.5.3-.3.6-.7.8-1.3.2-.6.4-1.5.4-2.6l-.1-2.5a3.2 3.2 0 0 0-.8-1.4 2.7 2.7 0 0 0-1.2-.7 13 13 0 0 0-2.3-.3z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "m317.6 210.2 3.3-13.6 4.4 1 3.2 1c.7.4 1.3 1 1.6 1.9.4.8.4 1.7.2 2.8-.2.8-.5 1.5-1 2a3.9 3.9 0 0 1-3 1.4c-.7 0-1.7-.2-3-.5l-1.7-.5-1.2 5.2z"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "m323 199.6-.8 3.8 1.5.4c1 .2 1.8.4 2.2.3a1.9 1.9 0 0 0 1.6-1.5c0-.5 0-.9-.2-1.3a2 2 0 0 0-1-.9l-1.9-.5-1.3-.3z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "m330.6 214.1 4.7-13.2 5.5 2c1.5.5 2.4 1 3 1.4.5.5.9 1 1 1.8s.2 1.5 0 2.3c-.4 1-1 1.7-1.8 2.2-.8.4-1.8.5-3 .3.4.5.8 1 1 1.6l.8 2.7.6 3.1-3.1-1.1-1-3.6a19.5 19.5 0 0 0-.7-2.4 2.1 2.1 0 0 0-.6-.8c-.2-.3-.6-.5-1.3-.7l-.5-.2-2 5.6z"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "m336 207.4 1.9.7c1.3.5 2.1.7 2.5.7.3 0 .6 0 .9-.3.3-.2.5-.5.6-.9.2-.4.2-.8 0-1.2a1.7 1.7 0 0 0-.8-.9l-2-.7-2-.7-1.2 3.3z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "M347 213.6a9 9 0 0 1 1.7-3.2 6.6 6.6 0 0 1 1.8-1.5 6 6 0 0 1 2-.7c1 0 2 0 3.1.4a6.5 6.5 0 0 1 4.2 3.3c.8 1.6.8 3.5.2 5.7a7.4 7.4 0 0 1-3.4 4.5c-1.5.9-3.3 1-5.2.4a6.6 6.6 0 0 1-4.2-3.3 7.3 7.3 0 0 1-.2-5.6"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "M349.8 214.4c-.4 1.5-.5 2.8 0 3.8s1.2 1.6 2.3 2c1 .3 2 .2 3-.4 1-.5 1.6-1.6 2.1-3.2.5-1.5.5-2.7 0-3.7a3.5 3.5 0 0 0-2.2-2 3.6 3.6 0 0 0-3 .3c-1 .6-1.7 1.6-2.2 3.2"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "m374.3 233.1 6.4-12.4 5.3 2.7a10 10 0 0 1 2.7 1.9c.5.5.8 1.1.8 1.9s0 1.5-.4 2.2a3.8 3.8 0 0 1-2 2c-1 .2-2 .2-3.1-.2.4.6.6 1.2.8 1.7.2.6.3 1.5.4 2.8l.2 3.2-3-1.5-.4-3.7a20 20 0 0 0-.3-2.5 2 2 0 0 0-.5-1l-1.2-.7-.5-.3-2.7 5.2z"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "m380.5 227.2 1.9 1c1.2.6 2 1 2.3 1 .3 0 .7 0 1-.2.3-.1.5-.4.7-.8.2-.4.3-.8.2-1.2a2 2 0 0 0-.7-1 23.7 23.7 0 0 0-1.8-1l-2-1z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs41("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx48("path", {
            fill: "#309e3a",
            d: "M426.1 258.7a8.9 8.9 0 0 1 2.5-2.6 6.6 6.6 0 0 1 2.2-.9 5.5 5.5 0 0 1 2.2 0c1 .2 1.9.6 2.8 1.2a6.6 6.6 0 0 1 3 4.4c.3 1.7-.2 3.6-1.4 5.5a7.3 7.3 0 0 1-4.5 3.3 6.5 6.5 0 0 1-5.2-1.1 6.6 6.6 0 0 1-3-4.4c-.3-1.8.2-3.6 1.4-5.4"
          }),
          /* @__PURE__ */ jsx48("path", {
            fill: "#fff",
            d: "M428.6 260.3c-1 1.3-1.3 2.5-1.1 3.6a3.6 3.6 0 0 0 1.6 2.5c1 .7 2 .9 3 .6 1-.3 2-1 2.9-2.4.9-1.4 1.3-2.6 1.1-3.6-.1-1-.7-1.9-1.6-2.6s-2-.8-3-.5c-1 .2-2 1-3 2.4z"
          })
        ]
      }),
      /* @__PURE__ */ jsx48("path", {
        fill: "#309e3a",
        d: "m301.8 204.5 2.3-9.8 7.2 1.7-.3 1.6-5.3-1.2-.5 2.2 4.9 1.1-.4 1.7-4.9-1.2-.6 2.7 5.5 1.3-.4 1.6z"
      })
    ]
  })
});
var Br_default = SvgBr;

// src/country-flag-icons/generated/Bs.tsx
import { jsx as jsx49, jsxs as jsxs42 } from "react/jsx-runtime";
var SvgBs = (props) => /* @__PURE__ */ jsxs42("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx49("defs", {
      children: /* @__PURE__ */ jsx49("clipPath", {
        id: "bs_svg__a",
        children: /* @__PURE__ */ jsx49("path", {
          fillOpacity: 0.7,
          d: "M-12 0h640v480H-12z"
        })
      })
    }),
    /* @__PURE__ */ jsxs42("g", {
      fillRule: "evenodd",
      clipPath: "url(#bs_svg__a)",
      transform: "translate(12)",
      children: [
        /* @__PURE__ */ jsx49("path", {
          fill: "#fff",
          d: "M968.5 480h-979V1.8h979z"
        }),
        /* @__PURE__ */ jsx49("path", {
          fill: "#ffe900",
          d: "M968.5 344.5h-979V143.3h979z"
        }),
        /* @__PURE__ */ jsx49("path", {
          fill: "#08ced6",
          d: "M968.5 480h-979V320.6h979zm0-318.7h-979V2h979z"
        }),
        /* @__PURE__ */ jsx49("path", {
          fill: "#000001",
          d: "M-11 0c2.3 0 391.8 236.8 391.8 236.8L-12 479.2z"
        })
      ]
    })
  ]
});
var Bs_default = SvgBs;

// src/country-flag-icons/generated/Bt.tsx
import { jsx as jsx50, jsxs as jsxs43 } from "react/jsx-runtime";
var SvgBt = (props) => /* @__PURE__ */ jsxs43("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx50("path", {
      fill: "#ffd520",
      d: "M.1 0h640.1v480H.1z"
    }),
    /* @__PURE__ */ jsx50("path", {
      fill: "#ff4e12",
      d: "M.1 480h640.1V0z"
    }),
    /* @__PURE__ */ jsxs43("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsxs43("g", {
          fill: "#fff",
          strokeWidth: 0.4,
          children: [
            /* @__PURE__ */ jsx50("path", {
              d: "M345.4 150c-4-1.3-6.6.7-6.4 5.9 0 5.1 2.8 8 6.8 6.1z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M348.9 140.4c-3.3-2.6-6.4-1.5-8 3.4-1.5 5 .1 8.6 4.5 8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M354.4 131c-2.8-3-6-2.4-8.4 2.2-2.3 4.6-1.3 8.5 3.2 8.7zm-3.6 45.5c-4.9 1.8-5.4 8.5-2.3 12.6 3 4.1 8.7 4.9 11.8 0z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M345.1 162.3c-4.6-1.5-8.8 4.7-9.5 10.3-.9 7-11 9.4-5.4 20.1 1.2-6.8 5.7-10.6 9.3-10.8 3.6-.3 9-1 11.3-5.4zm14.7 27.6c-5.4 1.3-6.2 8.5-2.3 13.6 3.3 4.4 13.7 3.4 13.4-1zm15.3 43.4c.3-4.7-7.2-6.5-10.8-5.6-3.6 1-10.5-.1-12-4-1.4 3.1.5 6.5 5.7 8.2 4 1.2 3.9 4 2.7 5.4 3 .5 11.7.5 14.4-4z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M370.9 203.7c-5.3-2.4-8.4 1.2-10.4 4.6-3 5-12.1-1.4-15.2 5.3 4.2-1.8 8.4 2 10.4 3.3 5.7 3.7 16.6 2.6 18.2-6.2z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M374 209.8c-5.3 4-7.4 8.8-7.2 12 .1 3.2 4.6 10.3 9.5 10.7 2.8-5.8 4.3-18-2.3-22.7zm-22 24.9c0-2 2.8-2.7 4.8-2 1.9.6 4.9 2.5 3.8 4.6zM323 224c-.5-2.3 3.2-6.3 8.2-4.1 5 2.2 5.7 6.4 3.6 8.1z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M335.2 228.4c-.4-1.3 3.3-3.9 9.4-2.4 6.2 1.6 7.7 5.6 7.5 8.7zm-12.9-4.3c3.3-2.4 2-7-.9-8.5-5.2-2.6-3.3-9.2-6.7-10.5-3.3-1.3-6.5-3.6-6.7-6-1.6 3.3-.6 6.2 1.7 8.3 2.3 2-1.8 10.4 1.2 12.6zm-69-1.8c-2.7-4.2-9.1-3.5-11.8-.5-2.7 3-2.3 7.3.2 9.3zm15.5-6.3c-1-5.7-7.9-6.3-11.6-4.9-3.8 1.4-6.3 7.1-3.9 11.2z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M279 215.2c2.5-4.7-2.3-11.8-7.7-12.8-4.5-1-9.8-.9-11.6-5.3-1 3.8 1.8 6.3 5.2 8.5 3.3 2.2-.6 7.8 4.8 11z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M278.6 215.4c-1.2-3.4 1.1-8 5.7-7.6 4.7.3 7.3 3.6 5.3 7.9z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M288.9 215.7c-.7-3.6 2.2-7.8 6.8-6.8 4.5 1 6.6 4.7 4 8.5l-10.8-1.8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M299 217.3c-.4-3.6 2.7-7.6 7.2-6.4 4.5 1.2 6.4 5 3.6 8.7l-10.7-2.3zm-77.6 59c-8.7 0-10.8 2-12 11-1.6 11 13.5 12.3 12-11z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M225.2 264.7c-13.2-5-20.4 16-33.6 12.2 4.7 7.5 16.1 0 20.4.8 7.2 1.3 22.8-1.4 13.2-13zm-8.6 28.7c-6.6-3-13.6 7-12.4 11.5 1.7 5.5 16.7 1 12.4-11.5zM186 336.7c3.6 1 8 3 7.2 10-.8 7-14 21.1-25.8 22-11.8.7-16 15-26.3 11 9.6-1.8 9.6-12.6 17-16-5.4-2-8.2 10.3-15.2 10.3s-10.3 11.1-18.8 10.3c-8.5-.7-9.3 13.5-26.4 13.7-13 .1-29 15.3-34.9 8.7 12.7-1.8 17.8-8.8 25.3-16.5 12-12.3 25.7-6.8 30.4-17.7a31.6 31.6 0 0 1-18.3 5.4c-8-.2-16.6 12.6-25.5 7 5.1-.7 8.5-2.9 13.9-8.6 5.5-5.8 13.7-2 20.1-8 10-9.2 18.7-1.5 28.3-13-2.7-1.4-8.5-.5-13.9 2.4-5.4 2.8-12.3-2-18.5 1.4.7-7.6 15.2-3.3 24.2-8.5 10.2-6 18.6-4.2 26.6-3.5-11.2 0-15.5-10.7-31-7.6-6.7 1.4-12.1-9.3-18.8-3.9.2-4 7.2-7.2 14.4-3.3 7.2 3.9 10.1-3.4 24.5 5.7 6 3.7 16.1-2.4 22.5 1.6-.8-2.4-4.5-4-8.8-3.6 2.7-5.6 20.2-4.9 27.8.7z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M197.4 328.3c-5.6-4.4-13.5.9-19-1.2 0 3.6 1.9 9 7.8 11.1 1.8-1.3 10-8.4 11.2-9.9z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M206.3 315.8c-8.9-4.5-10.4 6.7-17.4 4.4.3 3.2 2.9 7.2 8.5 8.1z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M211.6 305.6c-13.1-5.1-14.8 7.5-22.5 5 1.8 4.4 12.8 6.8 18.5 5.2zm18-55.2c-3.5-5-10.8-1-12 4.9-1.1 5.8 1.7 13.9 6.6 12z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M238.5 235c-6-1.5-13-.8-12.2 5-2.4 1.1-3 8.7 3.3 10.4z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M242.5 231c-6-7-12.5-6.9-16.2-4-6.9 5.5-13.5 2.4-13.7 7.8 4.1-3.2 7.8.6 11-.5 3.4-1.2 5.9 5.3 15.2 2.6zm-14.3 103.9c.9 1.7 6.4 2.4 9.1-.4 3.6-3.8-.3-14.2-6-15-5.7-.7-6.2 11.8-3.1 15.4z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M221.8 335.1c8 3 11.5-3.7 7.2-8a80 80 0 0 1-7.2 8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M191.4 346.2c-1.6 4.7-9.6 5.4-18.6 19.8-9 14.5-17.6 8.4-19.8 18.3 10.8-8.7 19.3-3 25.8-11.6 9.7-13.1 17.8-11.2 21.6-20 5.4-12.7 29-12.4 30.4-32.3-8-1.5-33.3 19.9-39.4 25.8zm203.2-194.7c10.3 3.4 10.5 16.7 22.4 21.1 11.8 4.4 13 15 22.7 12.4-9-2.5-8.4-12.9-17.8-15.5-11-3-15.2-19.8-24-22.4m44 74.3c1.8 4.2 1.5 11.5-5 13.4 3.5 2.2 8.7.2 11.5-4.6-4.2 9.4-1.4 17.9 5.3 19.6-3.2-6.6 4-9.7 1.7-14 4.2 1.9 8 7.7 7.8 11.3 5.6-6.2-4-14.5-2.3-20.3zM375 287.6c-6.3-5.5-9 1.5-12-1-3-2.2-6.8-2.5-8.3-.3 5.4.2 2.8 4.4 13.3 5.4-10.5.7-8.6 12.5-15.6 11.9 7.4 7 11.3-6.3 17.4-4.1-1.8.5 2.8 4.7-.4 10.4 5.2-.1 7.3-7.3 8-11zm-139 60.2c-2.2-2-9-2.9-11.5-1.3-2.6 1.5-1.7 2 1.4 2.2 3.1.2 7 5.2.4 5.5-3.1.1-2 7.6-8.5 8.1 2.6 3.2 10.2 1.1 12.9-2.4-.5 2.9 3.3 5.5 1.8 9 4.7.5 2-9.7 9.5-9.2-3 .4-1.8 7.4 3.6 5.6-3.2 1.5-1.5 5.3 2 4.4-2.2.7-3 3.7.2 5.4 3.1-4.3-.4-19.5-11.7-27.3zm280.6-142.1a17.9 17.9 0 1 0 0-35.7 17.9 17.9 0 0 0 0 35.7z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M423.4 227.2c5.5-5.1 13.7-7.7 19.4-3.8 5.6 3.8 24.4 8.4 33.7 2 9.3-6.4 13.7-9.8 17.8-9 3 4.6 6.8 6.8 11.4 7.2 1.4 1.6 6.5 2.8 9.3 2.5 4.1 1 9.1-.3 13.1-4.7 6.2 1 12-3.7 14.2-10.7 6.6-.7 7-8 2.8-13-3.8-.7-.9-13.8-14.9-11.2 6 3.6 1.4 10.8 6.3 14.2-3.3 0-7.7 1.4-8.7 6.4 1.3-3.4-.2-5.8-1-6.5 0-3-6.5-10.3-12.7-7.6 4.4 1 2 8 5.2 10.8a8.1 8.1 0 0 0-6.2 3.3c-1.7-3-7.6-6-11.2-6.3 0-1-.2-3-.7-4.1-1.6-3.1-3-6.8-2.3-11.5a48 48 0 0 0-7.2 11.4c-4.9-3.4-17 1.5-22.7 2.8-5.6 1.3-24.7-1.8-29-6.4a49.2 49.2 0 0 0-21-9.8c-11-3.2-11-15.2-23.1-23.5-.3 15 22.4 62.4 27.5 67.5zM297.2 341.1a17.3 17.3 0 1 0 0-34.6 17.3 17.3 0 0 0 0 34.6z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M256 327.8c3.5 4.5 9.4 4.2 11.9 3.9 2 5.4 8.6 5.2 11.4 8.2 2.9 3 12.5 2.7 15.3 1-2.5-.2-5.9-1.8-9-4.5-4-3.2-2.2-9.8-5.2-12a11 11 0 0 0 2.2-8.6c2.4-1.4 4.2-3.7 4.4-4.9a15 15 0 0 0 9.6-4.1c2.2 2 7.7-.6 10.7 2.8.6-8.5-7.5-13-13-10.1-2.1-1.2-7.9-.4-9 1.1-1.7-.8-6.8 1.8-9 3.5 2.5-1.4 2.9-5.7 1.9-7.2 2.2-1 4.6-3.9 4.9-6 3 .5 7.7-1.6 9.7-1.1-3.3-4.4-8.8-6-14.5-5.5-5.9.3-8.4 4.4-9.2 8.8-3.4 2.1-4.6 9-3.3 11.5-2 0-3.9 1.9-4.6 3a26.7 26.7 0 0 0-9.4-2m1.3-7c-1.2-3.4.3-6.4 1.1-9 2-6.8.8-8.6-5.3-7.7a47 47 0 0 0 4.2 16.7z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M248.6 282.3c1.6 1.6 7 2.3 7.6-2.6.7-5.6-1.6-7.8-6.5-5.6-.4 1.3-.8 6.5-1 8.2z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M249.8 273.9c2 .8 6.5 2.5 9-2.3 2-4-.7-7-5-6.8-1 1.2-3 5.3-4 9.1z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M253.6 264.4c.5 1.6 5.8 6.7 9.6 3 3.9-3.7 3.9-9.3-1.9-11.3-1.5.2-6.2 5.6-7.7 8.3z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M261.3 256c1.1 3.3 4.8 8.8 11.5 6.3 6.7-2.6 3.8-11 .7-12.7a33 33 0 0 0-12.2 6.5z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M273.5 249.6c-.5 2.9 0 10.6 9.2 10.5 9.1-.2 6.6-10.9 4.2-12.4-3.7 0-10 .1-13.4 2z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M287.3 248c-1 2.3-3.3 16.7 14.6 12.7 2.3-.5 8.3-13.8-14.6-12.6z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M297.1 249.4c-1.8 1.8 2.8 16.3 15 13.9 12-2.5 1.9-16.3-15-14z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M307.4 251.6c-2 4 1 15.8 15.9 15.8 13.5 0-.7-15.6-15.9-15.8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M319.1 255c-1 2.3-2.1 14.8 15.5 15.9 12.7.8 9.6-17.3-15.5-15.9z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M338 260.3c-2.1 3.9-4.4 13.5 14.9 14.3 12.3.5 4.7-14-14.8-14.3z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M354.1 263.3c-2.8 3.8-.7 11.4 6.5 12.8 9 1.8 10.3-6.7 4.1-10.8-6.2-4-10.6-2-10.6-2z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M363 265c-2.1 3.7-.9 12.4 12.8 12.4 2.8 0 13.6-11-12.9-12.3zM257.1 433a20 20 0 1 0 0-40 20 20 0 0 0 0 40z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M404.1 141.7a35.2 35.2 0 0 0-5.4 8c-6.7 20 11.2 35 21.6 56.7a63 63 0 0 1-5.6 60.7c-4.4 5.8-3.1 7.5-8.8 13.4-2.2 2.3-4.6 5.2-3.8 13.4 3.6-1.3 8.7 2 9.7 5 2.6-1.4 6.2-.9 7.5.7 4.4-2 8-1 11.9 3 3.3-.4 7 0 10.3 3.7 1.8-3.6 5.4-5 8-4.1-.3-4.7 4.3-8 8.4-6.2a7.6 7.6 0 0 1 9.8-9c4.7-3.6 14-3.9 18.6 1.5-8.3-2.3-8 6.5-15 5.7 1.8 5.1-2.8 8.1-7.4 9.8 3-1.4 6.2-3.1 7.2-1.3 2.6-2.3 7.7-1.4 9-.3 3.4-1 6.7-.2 8.2 3.9 4.7 2.8 7.8 10 4.4 15.4-1-5.6-4.9-5.4-6.4-7.7-3.6 1.3-7.2 1.3-8.3-1-2 2-9 3.9-12 .8-1.2 4.6-5.2 8.5-9.9 8.5 1.3 3.6-2.3 9.7-5.1 12.8 4.4 2.3 3 7.5 2 10.6 6.8 1 1 7 12.7 10.8-5.7 1.8-16.8 0-18.3-7-5.7-.2-9.5-5.9-9.3-11.8-4.4-4.1-5-10 1-14.2-5.1 1.6-8-6.7-15.4-3.3-3.7 1.7-13.5-1.2-13.4-4.6-1.5 2.5-11 1.5-12.2-2.9-3.1 1.7-10.3-1.1-10.2-5.4-4 1.8-9.4-1.4-9.1-5.5-3.8-.5-4.2-3.9-4-6.7-3.3-1.6-2.4-4.8-1-8.6-2.4-2.6-1.4-6.2.4-9.6-2.5-2.6-2-5.6-1.3-9.3-12.3-1-27.8-4-63.3-14.9-53.6-16.5-68 22.2-56.2 46.4 13.7 28-1.5 34 3.1 54.8 5 1 7.5 5.2 7.2 9.6 3 .1 5 2.8 4 8a9 9 0 0 1 7.6 2.3c1.8-3.4 7.8-4.2 10.8-.3 6.7-.5 10.1 5 9.8 11.6a18 18 0 0 1-1.5 19.3c.4-2.7 0-6.5-.1-8.9-.3-4.2-6.2-5.1-5.6-8.6-3 .3-6-1.4-7-3.7a6.8 6.8 0 0 1-6.6 1.3c3.4 1.5 6.2 7.7 5.1 11.8 1.8 3.1 1.4 8.8-.7 11.2-1 5-5 6.8-10 4.6 2.9-1.8 3.9-5 3.8-7.7a10 10 0 0 1-2.9-6.3c-5 .8-12-3.5-13.2-5.2a20 20 0 0 0-20 20.1c-.6-4.1-5.8-8.2-5.1-11.7-3.1-9.5 1.3-18.4 13.9-20.2-1.6-3.6 3.8-7.3 1.8-11.4a97 97 0 0 0-14.7-20.1c4.4-7.5 3-17.5.5-23.7-3.7-8.9-7.2-6.7-20.3 7.7-21.4 23.5-50 17-75.2 32.5-6.7 4-13.4 5.6-6.2-1.6s26.2-14.4 38.6-20.6c23.2-11.6 42.8-30.9 50.5-68.5 18.1-88.4 85-59.2 127.2-42.8 39.7 15.5 32.5-19.5 12.4-40.7-24.2-25.3-19.3-45.3-8-61.3 20.3-2.8 59.4 4.3 51.5 11.1z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M475.9 358.8a22 22 0 1 0 0-44.1 22 22 0 0 0 0 44z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs43("g", {
          fill: "none",
          strokeWidth: 0.4,
          children: [
            /* @__PURE__ */ jsx50("path", {
              d: "M391.8 142.7c-5 21.7-.8 31.5 6.4 41 14.9 19.7 26.8 64.6 9.8 94"
            }),
            /* @__PURE__ */ jsxs43("g", {
              strokeLinecap: "round",
              children: [
                /* @__PURE__ */ jsx50("path", {
                  d: "M417.5 252.3c2-.7 6-3.2 6.8-7.4m-5.2-2c.6-3.7 6.4-5.3 6.5-9.3m-6.4-5.2c-.4-3.9 5.8-7.4 4.9-11.2m-8.3-2.7c-.5-2.2 5.2-6.3 3.6-9.8m-7.8-3.8c-1.2-2.4 2.7-5.2 1-7.8m-7.2-3c-.4-1.6 2-5.3.7-7.5m-6.9-5.2c.5-.7 2.6-2.2 1.8-4.1m-6-5.3c.8-.4 3.3-1.2 3-3"
                }),
                /* @__PURE__ */ jsx50("path", {
                  strokeLinejoin: "round",
                  d: "M266 410.9c-5-1.8-11.5.7-12.8 5.1m3.9 4c.6-4.4 7.3-6.3 9.3-4.3-4.2-2.3-6.3 6-2.5 6.2m34.6-103.8c-3 1.6-4 7.2 0 11.5m4.6-10.2c-2.1 1.8-2 7.2 1.2 8.5-2.7-2 0-5.3 2-5.4 1.9-.1 3.2 2.2.8 4.5m177 5.2c-7.2-2-13 6.4-6.4 13.9-.2-7.2 5-12 11.3-10.7m-3 5a2.7 2.7 0 0 0-2.7 2.7c0 1.4 1.2 2.8 3.2 2.8 1.3 0 2.4-1.5 2.4-2.7m22.6-161c1.2 4.4 7.2 6.3 12 5.2m0-2.8c-3.7.1-6.8-3.4-6.6-6.3 0 2.2 5 3.2 6.6 1.8"
                }),
                /* @__PURE__ */ jsx50("path", {
                  d: "M267.9 331.7c-1-2.6 3-5.2 3.2-7.6.1-2.5 4.6-4.4 9.3.2m-2.2-27.4-2.5 1.2m11.4 12.8c-1.1 0-3.4 0-4.6-.9m0 5.8c-.8.5-2.8 1.2-4 1.5m-40.1 76.3c-.2 2.3 2.2 5.7 3.4 6.7m6.6-12.2a10 10 0 0 0-1.3 7.6m20.5 0c-2.3-1.5-.8-5.4-1-8-.3-2.6 2.7-6.7 8.5-3.2M246 381c2.3-.4 4.7-.3 6.3.4m23-7.7a8.3 8.3 0 0 0-1.4 4m12.3-4.3c-1.8 0-3.4 1.3-4.2 2.6m-20.8-68.5c2 .7 7.4 4 7.6 7.4m14.3-24.2c-6.3-.1-8.8-6.5-4-6.5m15.3 15.2c-2.4 1-1.3 5.2 2.2 7.3m-17.3 33.1c-1.2-1.6.4-6 4.4-4.7m5 51.7c.3-4 5.2-6.2 7.2-1.8m-25.5 13c-.3-4.3 2-5.7 3.8-6 2-.2 4.7 1.4 6 4.2m-48.1 5c.2-2.6 2.4-5.3 4.7-4.9m231-109.4c-1.7 1.2-2.8 6.7 3.5 7.2M458 296c0 .6.8 1.5 1.3 2m29 8.3c-1.6-1.3-6 4-2 7.7m-39 35.6c-.9-3.7 2.5-4.7 5.8-3.9m-14-22.2c2-1.2 4-2.7 6.4-3.3m-7.4 17.5c0-3 1.6-5.7 3-6.4m8.4-29.1a16 16 0 0 0 2.4 9.2m28.2-9c-1.9.6-3.5 1.3-4.2 2.9m2.1 7.7c1-.8 2-1.7 2.4-2.3m46.3-110.2c0 3.6-4.5 5.6-7.5 3.3m17.3-3.1c2 1.5 8.9 0 7.3-4M528 221.4a11 11 0 0 1-4.9-3m19.1-7.7c-2.3.5-3.9 0-5-.5m-31.6 13.4a17 17 0 0 0 6.5-1.6M502 200.8c-1.7-.2-3 .1-3.9.8m29.8 5.5a11 11 0 0 1-3 5.2"
                }),
                /* @__PURE__ */ jsx50("path", {
                  strokeLinejoin: "round",
                  d: "M497.5 212.8c3.2-1.4 7.2 9.5 15 5.7m.6-11.4a11.3 11.3 0 0 0-1.8 5.6"
                })
              ]
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M359 190.4c1-.2 2.9-.5 3.3-1.8M226.5 310.3c3.9 2.2 6.6 5.9 5 11.4m172.1-143.2c1.2.8 5.5.8 8 0m3 2.6c0 1.8.5 8.6-3 10m1.3-.8c3.2 1 9.6.6 11.7-5.3m-4.5 5c1.7 2.6 2.2 7.6-2.8 10.3m4-6c3.8 1.2 12.4 1.4 11.5-6m-3 6c2.7 3.5 14 7.8 12.2.3m-22.5 10c4.3 1.1 10.5-1.9 8-9.6m12.3 3.9c.6 3 15 6 13.1-.7m-2.7 3.9c2.7 6.2 17 5.7 12.5-2.6m-2.3 6.5c2.8 3.4 15.5 1.4 10.4-7m-.1 6.8c7.9 6 17-2.5 7-8.7m4.6 6.8c7 5.5 15.5-4.5 9.4-7.3m-64.4 5c2.2.6 6.8.4 7.9-3.6m-1.8 2.7c-.2 5.8 9.6 8 12.1 1.3m-3.3 3.7c1.8 3.9 10.5 5.4 11.9-.1m-1.4 2.6c1.4 3.8 8.9 3.4 11-.6m-2.8 2.6c2.3 5 11.9 5 14-2.3m-1.6 3.2c3.7 2.3 11.7 1.4 11-5.8m-1.5 5.2c5.6 4.5 13.4.1 9.5-7.5m-.3 13.4c3-.5 4.5-6.4 1.4-8m-70 9c6-3.3 7.3-9 3-14.5m2.2 8.9c3.9 2.3 11.2-.2 12.5-5.8m-7.2 6.4c2.2 2.8 2.6 6.3-.3 9.5m2-5.9c6.9-4.2 15.4 3.6 9 8.4m-1-8.8c1.5-.4 4.2-3.2 4.4-6.4m-1.4 9.4c2.9-3 22.2 3 10 9.3m-1-17.4c3.8 1.4 5.7 6.7 0 8.5m5 4.4c4-4.3 17-1.6 12.3 3.8m-3.1-5.5c2.3-7.9 16.1-3 11.6.2m-14.4-8c.4 1.5.5 5.3-2 7.4m13.6-9a6.1 6.1 0 0 1-.8 5.3m9.5-5.2c.8 1.4 2 4.1-.8 6.3m-109.4-65.5c.1 7.3 2.7 12.2 12.6 7.6m-9.5 1.1c-5 6.6.6 13.7 10.3 6.6M365 165c6.7 7.2 18.7 2 11-9m8 15.2c-1.2 7.1 4.6 8.5 9.3 5.3m-34.2-10.3c1.2 7.1 8.5 12.7 15.6 8.4m-6.9 1.4c0 10.2 14 11.3 17.3.8m-5 6.4c4.5 9.3 14.3 5.5 17.5-.1m-27.4-14.7c1.8 4.5 5.4 9.5 13.7 5.8m-39.5-8c1.2 3.7 7.9 8.2 15.6 3m-10.8 1.8c-4.2 6 4 11.7 14 2.7m-9.1 4.7c1.6 8.5 5 15.4 17 4.4m-6 4.4c4.4 5.4 11.1 8.7 17.4-.4"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M387.3 188.8c-.4 6.5.8 9.7 5.9 9.4 4-.2 7.7-3.3 9.9-6.7m-10.8 6.7c-.2 7.4 5.6 13.2 16.5 5.7m-12 3c-2 5.5 4.1 14.5 16.2 9.9m-41.9-24.6c-.7 7 5.8 11.8 16.4 2.7m-11.2 5.1c.4 5.8 7 12.8 16.6 2.7m-12 4.7c-.7 9.9 8.4 12.7 16.1 5.1M367.2 200c2 .2 3.7-1.6 4.7-3m-.4 10.2c1.8.4 5-1.2 6-3.3m-1.4 15c2 2.3 9 .7 9.9-2.3m-2.2 2.2c3.8 9 14.1 8.7 18.4-1.5m-2 3.6c2 5.3 6.9 8.6 14.9 6.8m-11-1.4c-4.5 7.3 1.4 16 11.5 7.5m-9 3.5c-.5 4.6 3.7 9.9 9.5 10.5m-28.6-24c-1.5 10.4 6 15.4 15.3 9.8m-26.2-4.8c2.4 1.9 6.8 2.1 11 .6m5 6c-2.4 8.8 6.6 15.1 14.3 5.3M380 230.2c.2 4.5 4.5 9.4 12.1 8m21.3 9c-5.2 3.4-6.2 9.6 1 13.6m-13.6-15.4c.2 5.2 2.7 8.2 8.5 8.7m-16.1-11.4c-7.8 7-.2 15.3 9 8.3m-3.6 2.2c-2.6 8.1 7 13 12.2 4.8m-28.2-22c-2.8 8 .8 13.2 7.4 12.7m-17.6-14.3c.4 4.8 4.5 6.5 9.2 5.4m-6.2-.4c-3.5 6.7 1.8 10.3 8.8 7.8m21 15c-1 4.2-.4 7.2 5.9 8.7m-5.4-2.7c-7.6 3.4-8.3 10.8-2.4 15.5m-3.8-23.7a7.6 7.6 0 0 0 1.2 12.3m-35-35.8c-4.3 4.3-.2 16.2 9.5 9.7m15.7 5.3c-6 5-3.3 13.8 6.5 11.4m-16.3-15c-3.1 8.7-.2 11.8 6.8 11.9"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M359.3 236.1a8.2 8.2 0 0 0-1.5 12.2c2.3 2.6 6.7 1.4 8-1.9m-17.6-13.8c-5.9 7.6 0 16.6 8.4 14m23.3 8.6c-6 2.1-10.7 7.6-7 12.5 2.3 2.8 11.8 3.2 14.5-7.8M369 248.1c-3.5 5-2.4 9.8 4 12.2m-4.4-2.8c-3.8 2-6.2 4.5-5.3 9m-3.1-16.9c-1.4 6 .3 9.8 4 11.6m-4.1-4.4c-5.8-.4-8.8 2-6.8 7.8m.5-6.4c-5.7-2-6.6-7-4.1-12m-.8 7.6c-6.2.2-9 3.3-9 7.5"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M340.5 229.7c-4.5 1.9-6 8-4.3 11.3 1.7 3.3 7 3.6 10.2 1.4M328 224.9c-4.1 4.6.6 13.7 8 11.5m-18.6-15.1c-3.8 5.4.4 14.4 10.3 11.8m.5 25.1c-1-6.4 5.7-10.6 14-2.3m-4-13a10.1 10.1 0 0 0-3.3 8.5m-28-33.2c-4.3 7.2.9 13.8 10 11.2m13.8 6.7c-6 6-4 12.1.5 15.6m-4.4-8.5c-9.1.1-9.6 10.7-2.2 14m-4.7-24.6c-3.8 2.6-5 9.7 1.5 12.5m-1.8 3.4c-3.9-1.8-8.5.4-8.1 4.9m2.3-4.8c-3.5-8.2-13.6-6.8-12.7 1.7m15.5-11.9c-2.1.4-6.5 1.7-8.2 5m.6-14.3a7 7 0 0 0 2.5 11.4M296.7 216c-.8 5.6 1.4 8.3 8.4 7.8m-6-.7c-2.6 6.7 1 9.7 8 9.3m-6.4-1c-4.1 4.9-1.3 10.1 2.7 12.3m-4.6-6.1c-7.4-1-8.5 7.6-6 11.5"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M292.9 215.5c-4.5 2-7.1 7.6-4.7 11 2.5 3.5 7.4 2.4 10 .6m-8.4 1c-3.8 5.7-.4 10 3.6 11.6"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M275.3 214.8c-3 3.1-1.1 9.4 6 9.6 5.9 0 8.8-5.4 7-9.3m-8 9.3c-2.3 5.1-.8 10.7 8 9.8m3.6 8c-5.3-2.4-12.6 0-9.5 6.5m-.7-15.6c-2.2 3.1-1.5 7.5 1 10.2m-1.4-2c-3.6.7-7.1 2.6-5 8.3m-.5-4.6c-4.6-1.4-10.5 2-7 6.7m-.7-4.5c-4-.7-8.7 3.6-4.9 7.8m-1.5-3.5c-3.6 1-7.9 5-4.1 8.3m22.3-28.5c-5.2 2.3-5.7 8.1-3.3 12.4m-2.2-23c-7.7 3-7.6 13.2 1 16.4m-3.7-2.3c-4.6 2.7-5.5 7.9-2.4 11.2m-5.7-29.2c-3 1-2.8 10.5 5.4 10.3m-13.9-7.1c-6.2 4.1 1.3 14.5 11.3 7m-5.5 2.7c-.9 4.2.3 8.8 7.1 9.4m-6.7-3.8c-4.9 1.8-5.8 11.9 3 12.7m-18.6-21.8c-6.3 5.8 5.2 10.8 9.4 2.4m-18.1 7.2c-3.1 3.8 7.7 13.6 12.5-2.8m1.1-.3c.3 4 2.6 6.2 7.3 6.5m0 3.7c-7.7 1.2-10.1 10.7-1.6 12.8m-12.5-14c-.3 3.5 3.5 6.5 7.7 5.9m3.9 7.8c-7 1.6-7.9 10.6-1.7 10m-3.2 8.4c-5.8-1.7-6-8.6-.8-11.2"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M245.7 267.8c-4.9 3-3 10-.4 11s4.7-.2 5-2.4m-.5 10c.6 3.3-11.9 2-5.5-8.4m0 8.9c-4.2 6.6 2.6 12 6.9 6.3m-6.4 1.6c-1.7 5.3 4.7 9.1 8.8 5M231 245.4c-2.3 4.7 9.3 6.5 10-3.3m-13.2 10.3c-2.3 9.3 15.2 7.4 10.7-4.6m.4 6.2a8.2 8.2 0 0 0 11.6-6.3m-5.3 6.6a10 10 0 0 0 4.7 6.3m-13.1-3.9c-.8 5 4.3 9.2 10 8.8m-9.1-3.9c-2.8 3.9-3.7 11.3 5.2 11.8M224 263c-1.4 4 7 8.1 11.8 1.5m-14.4 8.7c-.7 3 6.8 7 11-5.8m-3.3 6.5c1.8 3.2 7.9 5.8 11.6-.5m-6 3.9c-1.6 4.5 2.7 8.7 7.8 7.5m-17.5-8.5c-1 6.4 6.5 10.1 11 6.8m-15.9-4c-2.2 8.2 8.4 11.3 12.4 5.1m-2.7 2.5c.4 4.6 7.6 8.6 13.2 4.8m-26.1-1c-.5 2.1 8.1 4.2 9.4-3m-4.4 4.9c2 5.2 9 6.5 13 0m-2.3 2.6c1 5 7.2 7.7 12.8 4.3m2.3 2c-1.4 6.5 5.4 11.8 9.6 8.2m-20.6-9.4c-2 7.2 7 11.3 12 7.3m-22.8-11c-.5 6.8 4.8 10.8 10.8 7.8m-22.3-7c-1.8 4.3 7.8 7.9 12.3 4.2m-18.2 7.7c2.5 2.8 11 0 11.7-6.3m-2.3 4.6c3.1 3.6 10.5 5.6 13.4-2.2m-2.6 4c0 5.6 9.8 9.6 13-.6m11.7 2c-1 2.7 1.2 7 5.7 7.5m-13.9-9.2c-.6 3 3.9 7.4 8.7 5.7m.9 1.3c-1.3 3.3-.2 8.1 4.3 8m-3.9-1.8c-3.4 2.8-2 7.9 2.9 8m-4.6-3.2c-4.8 3.2-3.1 10.3 3.2 9.9M239 313c0 7 8.7 8 10.3 1.6m-3.3 4c-1.3 4.2 2 8.2 7.3 7m-6.3 42.8c1.2 1.7 6-1.2 4.7-4-1.3-2.8-6.4-1.3-5.8 1.7m4.6-2.9c.6-5.6-6-6.5-7.7-1.6m2.4-2.9c1.7-2.8-4-6.7-6.3-2.5m2-1.7c1.6-4.1-4.8-6-5.3-2.2m-1.5-5.4c.8-2 8-.8 5 3.5m5.5 5.1c2.8-2.6-2-7.8-5-6m24 13.9c-2.2.2-4.5 1.7-2.9 6.5 1.2 3.3 6.1 3.4 6.9 1.5"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M260.5 365.9c-2.2-1.5-7 1-4.8 5.6 1.6 3.5 5.8 2 6.4.2m-14 .8c1.2 2 6.6 1 7.6-1m-3.8-5.4c1.2-.8 3.3.2 3.7 1.2m-4-33c-3.8 2.5-1.5 10 4.3 8m-5.6-1.9c-3 2.3-.2 9.6 5.3 6.8m-4.3 0c-2.1 2.1-.1 7.8 5.2 6.7m-6-3.8c-1.2-.5-4.2-.2-5.5 1.8m2.1-28c-2.8 2.8-1.4 8.3 3.8 8.8m-4.8-3c-4 2-4 10 4 10.3m-4.3-1.3c-2.3 1.8-1.2 8.8 4.6 7.9m-2.8-.3c-.8.9-1 3-.2 3.9m-2.3-6.5c-2 0-4.8 1.5-5.5 3.7m-3.7-7.5c.7-2 7.1-2 7.6 4.1m.6-7.2c-.9.2-2.6 1-3 2.8m.2-21.7c-2.7 2.6-4 10.5 4.3 12m-9.9 4.4c0-2.1 5.8-4 7.8-.8M232 322.8c.8 1.6 4.8 3.8 7.2 2m-28-14.6a6.3 6.3 0 0 0 7.2 6.5c4.3-.5 5.2-4.2 3.9-6.7m-3.2 6.9c-2.9 3.4.6 8.3 3.8 6.9m-.6-9.4c1.7-.6 7.2-1.4 8.9 1.2m-26.8-.2c-1.3 2 6.7 3.9 9.4.2m-2.7 1.9c-.3 2.6 1 7 7.6 5.1"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M219.8 326.6c1-2.2-3.8-5.8-7.6-1.8-3.7 4 .6 8.5 2.9 7M202.7 318c-2 3.4 5.5 9.5 9.8 3.8"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M197.7 323.8c-2.7 2.8.7 7.9 4.7 6.3 4.1-1.5 3.7-5.8 2.7-6.9"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M192.5 329c-2.2 2 0 6.6 3 6.6s4.9-2.3 4.3-5.4m5-1.6c-.4 3 4 5 6.9 2.2m0-5.4c.5-.6.2-1.7-.5-2.3m-23.4 9.8c-2.5 2 3 7.6 6.3 2.5m13.1-3.5c-1.6 1.5 1 5.5 3.6 4.3m-12.4-1.5c.4 2.7 5.8 4.8 9.2.6m-6.3 2.1c-.8 1.8.9 4.5 3 4.2m48.3 11.8c-2 3.9 4.4 8.5 9 3.7m-4.4 2.1c-1 2.1.2 5.1 2 6.2m-8-1.7c.4-2 3.2-3.8 5.7-2.9m-9-2.2c.3-1.8 2.6-3.5 4.4-3m147.2-77.4c-9.2.1-5.3 14.8 2.6 11.9m-5.6-1c-1.8 2.9 1.7 7.6 5.6 4.8m-1 .6c-2.8 4.5 6.9 11.4 10.8 4.3m-3.1 2.7c0 4.3 12.5 7 10.7-1.5m-1.2 4.6c3 5 14 5.5 12.9-2m-2.5 5.2c2.3 3.4 13.2 5.4 12.8-1.5m-56.7-40.8c1.5 4 6.8 5.4 12.6 3m-16-.2c3.7 2.3-1.6 12.9-7.1 8.6m7.2-2c4 1.9 8.9.5 10.3-5.2m-2.5 4.4c.4 3 4.7 5.3 10.2 4.1m-20.1-1c5.2 4.4-2.3 13.4-5.7 9.3m7.6-6c2.5 1.8 8.8.8 9.4-4m-2.8 4c.5 3.1 3 4.3 6.4 4.4m-14.4-.1c2.6 3.6 9 4.6 11.9-.1m-2.9 2.7c-.2 3.4 3.6 6.3 7.6 5.5M375 295c3.3 1.7 7-4.7 4.1-9m-.2 15.7c4 .2 4.5-5.8.7-9.2m8.4 14.7c3.4-.8 2.3-8.1-5.8-8.7m16 14.1c3.2-.9.6-9-8.3-8.5m20.5 11.4c2.2-3.4-5-9-11-6m17 10.6c4 1.2 6.8-9.4-5.9-7.7m13.3 7.7c3.5-1 6-7.2-4.2-5.2m12 5.7c3 1.6 4.4-7.5-5-5m-47-23c3.9 2.1 10-.4 9.4-5.3m-1.5 4.2c1.3 2.3.8 6.8-1.7 8m2-2.6c2.6 1 6.1.1 8.2-4m-3.6 4c.7 1.8 1 5.4-.7 7.2m1.3-4.1c2.9 1.6 6.2-.5 7.6-3.5m-1.8 2.6c2 1.3 3.9 7.3.4 9.8m2-2.8c2.4 0 6 0 8.3-3m-1.7 1.7c2.2.6 4.8 4.2 3.9 7.4m.1-1.1c2.5-.3 6.7-2 7.9-5m-1.2 2a6.6 6.6 0 0 1 3.2 6.5m0-2.1c2.5-.1 4.7-1.4 5.3-4.1m-.6 1.8c1.8.6 4 2.7 4.1 5.1m-.3-1.5c1.8-.3 3.1-1.4 4.3-3.2m4.9-.3c2.3 2.3-.8 10-5.6 8.6m-43.9-164.7c-4.7 2.9-18.3 2-11.6-9.2m13 1.6c-9.5 3.8-21-3.5-9-11.3m-3.2-2.6c-7.8 0-13.1 12.6-2.6 17M348.6 138c-2 4 5.3 8.4 10.3 4.4 3.9-3.1 3.6-11.5 1.3-14.7m-15.6 19.8c-2.6 8.5 16.4 9 13.4-4.5m-14.4 17.2c.6 6.4 18.1 4.3 12.5-8.7m2-3.6c1.4 2 5.3 5.3 11.9 4.6m-9-13.5c.6 2.3 4.5 4 9.5 2.3M185.4 334.8c-4.5 3.1 2.4 8.1 4.9 2.6m-8.4-.2c-4.4 3.2 2.4 8.2 4.9 2.7m-8.6-.3c-4.4 3.2 2.4 8.1 5 2.7m-8.8-.5c-4.3 2.3.7 7.8 5 3m-9.2-.9c-4.3 2.3.7 7.8 5 3m16.6-9.6c-.1 3.3 6.1 4.6 8.4-.3m-4.5 3.3c-2 2.5 1.6 5.5 3.5 4.4m-11.8-4.8c-.2 2.8 5.2 4.4 7.8 1.3m-4.9 1.6c-1.7 2.2 1.7 5.3 4 4.4m-10.5-4.8c.2 2.2 3.3 4.7 6.6 3.3m-4.6-.3c-1.3 1.1-.7 3.8 1.1 4.7m-7.8-5c-.5 2 2.9 5.6 6.4 3.3m-5.7-1c-2 1.7-1.8 4.1.8 4.5m-5.8-4.7c-.2 1.4 1.5 3.6 3.7 3.3m-14.7-3.4c-2 1.1 3.2 6.7 6.5 1.5m-11.6.8c-2.6 1.2 3.8 7.4 6.7 1.1m10-1.3c-2 .4-3.3 3.3-1.6 4.5m-5-3.5c-.2 1.2 2.3 3 4.3 2.4m-5.9-1.9c-2 1.2-.9 4.6 1.4 4.1m-8.3-1.8c-1.8 1.3-.5 4 2 3.4m1.3-3.6c0 .7 1.7 1.8 3 1.3m-12.5-2.5c-2.3 1-2.1 6.6 5.5 3.6m-10.6-1.3c-3.2 1.5-2.1 5.8 4.8 1.7m.5.3c-.8.7-1.7 3.5 1.5 2.4m-7.2-1c-1.3 1.1-.5 3.5 2.3 2.6m-9-2.2c-2.3 1.3 2.8 3.1 6.2-.5m-4.6 2.1c-1 1-1 4.1 1.6 3m-8.2-1.7c-1.5 1.1 1 2.7 6 .5m-4 1.1c-1.9 1.5-1.7 3.4 1 2.8m-6.4-2c-2 1.9.9 3.1 4.4 1.6m-4.4.5c-3.4 1.5-1.9 4.4.2 3.3m113.8 6.5c-.8 1.7 1.8 3.1 4.3 2.7 2.3-.3 4.6-2.3 2.8-5m.1 3.4c2.4 1.8 6.5-.3 6.5-3"
            })
          ]
        }),
        /* @__PURE__ */ jsxs43("g", {
          fill: "#fff",
          strokeWidth: 0.4,
          children: [
            /* @__PURE__ */ jsx50("path", {
              d: "M396.8 103c-10.3-5-31.7-14.6-37.8-6.9 5.6-2.3 21.8.1 35.2 12.5z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M403 102.5c-11.9-13.9-19-10.8-27.5-15.5-8-4.5-20.8-5.4-23.3 1.7 11.7-5.7 22.5 3 29.2 4.2 9 1.4 14.2 8.5 16.9 11.7l4.7-2zm44.9-1.8c-6.2-14.1-19.4-10.4-25.2-16.4-8.5-8.8-30-17-39-10.9 19.6-1 28 13.5 38.4 18.6 7.5 3.6 15.5 11.3 25.8 8.7z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M424.7 99.2c-10.5-13.1-26.8-24.7-34.2-20.4 9.8.6 12.9 7.4 19.8 11.8 7 4.3 3.9 10.7 14.4 8.6zm-50.2 23.2c-11-4.1-32.7-6.2-42.8 6.4 16.8 2.9 42 1.3 42.8-6.4z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M372.4 127.3c-11-5.2-19.7 2-30.1 1-19.8-2-34-.8-35.8 8.8 11.3-10.2 30.4-1.8 38.1-3.9 7.7-2 36.3-.3 45.3 3.6-4.6-5.7-11.8-7.2-17.5-9.5zm34.8-29.5c-2.6-8.5-2.4-17.5 10.3-16.9-3.2-4-15-6-17 8.9-14-10.3-29.4-12.1-32.2-3.2 7.2-6.2 18.4-1.7 31.8 13.5a23.8 23.8 0 0 1 7.1-2.3z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M387.9 109.5c-8-5.2-18.8-13.5.1-16.9-8-4.3-20-2.4-18.7 12.5-21.6-8.7-37.1-5.8-40.4 2.9-3.6 9.5 9.8 14.8 12.1 8.7-2.4 1-10.8-1.8-6.4-7.2s26.8-1.3 48.1 9.8c6 3 26.3 2.6 5.2-9.8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M382.2 123.7c-6.1-12.6-26.1-1.2-30.1-13.4-5.6 17.9 28.4 8 30.1 13.4zm127.1 13.6c4.2 2.1 7.8-1.2 1.4-3.7 4.2 2 7.9-1.1 1.5-3.7 4.2 2 7.8-1.1 1.4-3.7-1.7 1.7-4.1 8-4.3 11.1zm2.2-24.2c9.3-9.8-.7-13.1 10.6-23.2 9.3-8.2 1.8-13.7 10.5-20 2.9-2.1 9-6.2 9.6-10.4 3.7 9.3-11.6 10.6-10.6 25.5.7 9.5-5.8 8.7-8.2 24.8-.5 3.3-2.9 10.8-11.9 3.3z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M515.6 117.5c5.2-11 11.1-10.9 14-15.2 5.4-8.3 16.8 1.4 26.5-6-1.7 10.5-14.7 6.8-20.4 13.5-5.6 6.7-10.3 9.7-20 7.7z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M517 121.1c9-7.2 15.6-2.4 21.8-6.2 15.7-9.5 22 2 36-2.6-3.6 9-24.4 1.3-33.4 8s-40.7 13.2-24.5.8zm-26.3 51.4c-.2-4.1-4-9.4-9.4-10-5.4-.7-7.8-6.4-11.9-6.6-4.1-.3-6.8-8.5-12.5-8.4-5.6.1-8 7.5 5.3 14.2 13.3 6.7 28 14.4 28.5 10.8zm-16.8 3.5c-5.6.2-6.4 8.5-11.8 8.7 7.4 4 12.9-1.8 16.7-7L474 176z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M478.6 177c-5 4.1-6.4 12.7.7 15.2-4.2-5.9 7.5-8.5 3.9-14z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M483.4 177.3c-3.8 7.4 6.1 8.3 3.5 14 5.7-1.3 6.6-12 1.4-14.8l-4.9.7z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M445.6 161.3c9.3-.5 17.7 4.5 23.4 12.6 3.6 5.1 15.7 7.2 19.9 3 4-4 1.8-12.8-8.5-10-2.6-4.3-10-2.8-13.7-6.4-3.6-3.6-17.5-13.9-21.1.8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              strokeLinecap: "round",
              d: "M480.4 167c-2.5.5-3.3 4.7-1.7 6.9m7-4.4c.7 1.3.2 3.1-.2 4m-25.2-11.8c4.7.2 5.6 3.7 10.8 5"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M457.1 150a161 161 0 0 1 37.6 12.3c8.1 4.6 20.7 6 31.6 2.8 11-3 32.2-5.9 31.1 7.8 5.8-6.9-1.5-14.2-16.2-15.5.3-6.7-6.9-12.7-12-8.7 4.7-.7 8.8 8.2-.6 11.8a8.4 8.4 0 0 0-11.7-9.8c4.4 1.3 9 8.8-1 11.6-6.3 1.8-15.4-.5-22.2-4.6-6.8-4.1-45-19-36.6-7.8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M498.6 143.3c-5.1 2.3-1.8 7.7-9.7 10.8-8 3-13.6 10.1-11.8 16.2 5.4-11.9 15-11.3 18.3-16 3.4-4.6 8.3-11.4 3.2-11z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M500 144c-.2 9.4-7.6 6-4.7 19.2.9 4.1 2.6 10.8-.3 17.5 8.3-6 3-18.7 6.7-23.5 1.8-2.4 4.2-6 5-9-1.9 5.3-1.7 15.4 3.5 18-4.2-10 11.5-18.3.7-30-1.6 3-6.5 8-10.8 7.8zm-26.2-9.4c1.3 2 2.6 6.8 1.4 9.6 2.6-1.6 6.3-5.6 7.5-8.3 5.3.8 7.3 7.3 2.3 10.2 3 0 8.4 0 11.3-3.5-3.6-4-14.8-10.2-22.5-8z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M393.7 116.1a10 10 0 0 0-4.8-2c-7.8-1.6-3.7-8.6 2.9-8.5 14.2-15.5 22.1-3.6 39.4-8.4 6-1.8 10.2-1.3 13.4.2 7.8-5.2 16.8-3.8 23.4 2.3a5.3 5.3 0 0 1 3-2.4c6.1-1.7 11 3.4 12.7 10.1 4.7-.8 10.1 1.5 13.7 4.7 4.9-2.5 8.2-2.6 9.5 0 4.4-2 10-3.4 12.9 3.6s-6.7 4.9-8.3 19.6c-1 9-11 12.6-19 7.2-12.8-8.7-25.3-10-31.5 3-6.1 13.2-11 20.8-26 16.5a16 16 0 0 0-16.7 6.5c-4.4 6-11 .4-19 1 10-1.5 6.1-4 14.9-4.6 8-.5 5.9-8 11-9-20 5.1-19.3-2.4-35.8 2.8 7.2-9.3 18.6-4.1 24.2-9.5-14.9-.3-21.6-10-28.3-6-10.5 6.5-6 24.8-33.5 23.2-13.4-.7-21.9 1-29.8 9 13.9-28.8 32.8-13 42-22.1a68 68 0 0 0 12.3-14.7 6.1 6.1 0 0 1 4-3.2c-22.9-7.2-9-18.5 13.4-19.3z"
            }),
            /* @__PURE__ */ jsx50("path", {
              strokeLinecap: "round",
              d: "M506.9 112c.3.8.5 1.8.5 3 0 5.6-8.5 5.8-9 14.2-.3 4.4-.8 6.8-3.7 6.3-3-.5-5.6-5.1-2.8-10.5"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M398 107.7a10.9 10.9 0 0 0-6.2-2.1m52.8-8.3c6.8 3 10.1 10 20 10.4 9.6.3 15.5 14.2 31.5 5.1a38 38 0 0 1 1.2-.6M468 99.7a12.7 12.7 0 0 0-1.4 8.2m-29.8 21c-12 0-15.2 6.1-15.2 12 0 6 5.7 13.7 15.7 13.7s15.5-6.2 15.5-12.9-6.2-12.9-16-12.9z"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M439 154.3c-.2-3.3-6.3-2.8-6-5.4.2-2.6 3.3-3.6 3.3-7.2s5.4-3.9 7.2-1c1.8 2.8 7.2 8.3 8.4 5.5m-8.4-5.5a9.9 9.9 0 0 0-.4 13.1m4.3-8.8c-1 2-1.2 5-.1 6.8"
            }),
            /* @__PURE__ */ jsx50("path", {
              fill: "none",
              d: "M495.5 135.6c9.5.8 11-9.7 4-10.3m-15.7-17.8c-3.2-4.2-10.8-5.6-11 3.2"
            }),
            /* @__PURE__ */ jsx50("path", {
              d: "M472 120.8c-3.2-8-11.5-9.1-15.8-5.1-3.7 3.3-3.8 12 4 13.8 2.8-3.3 8-7.5 11.8-8.7zm-3.5-5c-4.7-4.1-11.5 3.7-5.3 10.8m-83 8.7c3.2-.7 7.7.8 14.7 4 4.3 2.1 17.5 6.5 25.7 2.1-8.5 3.1-15-9.7-21.4-8.2-6.4 1.6-18.2 4-23.1-.8 12 .8 18.5-8.8 32.4-.5a24 24 0 0 0 13.1 3.6c-11.3-13.6-26.2-4.9-27.8-16 6.8 7.4 23.5-1.6 32 12.1m-29.5-10c-1.6-2-1-4-2.6-5.5"
            })
          ]
        }),
        /* @__PURE__ */ jsx50("path", {
          stroke: "none",
          d: "M483.8 107.5c-2.8-3-9-.7-7.2 5.4a9.6 9.6 0 0 1 7.2-5.5zM466.3 124a21.1 21.1 0 0 1 5.7-3.2 12.4 12.4 0 0 0-3.8-5.2c-1.5-1-5.7 4.7-1.9 8.3z"
        }),
        /* @__PURE__ */ jsx50("path", {
          fill: "none",
          strokeLinecap: "round",
          strokeWidth: 0.4,
          d: "M458.7 113.5c-4.6-3.1-8.9-2.8-10.3-.3-3.3 0-6.1 2.4-6.2 7.2m7.1 2.1c-5.5-3.8-13.1-2.4-12.6 6.1m-3.4 4.9c2.7-2.2 6.6-3.8 9.6 0m31.8-8.4c-1 1.4-1.8 3.6-.1 7-2-2.8-7.2-2.8-12.8 4.4m25.1-11.8c-6.7.8-6.5 5.2-1.1 7m-46.5-23.4c-5.7-1.1-9.8 2.2-2 5m12.8-8.8c-8-2-11.2.1-7.6 2m-15.5 30c-.2 2.9 1.3 6.6 6 2.4m-4.4 6.1c0 .8-.1 1.7-.7 2.4m-17.9-40c-4.9-1.5-5.8-6 0-5.6m-1.6 16c-5.4-1.9-5.4-7.1-1-6.6m11 3.8c-6.3-1.5-6.5-5.9-1.8-5.2m2.6-8.2c-3.4-.2-8.5 3.5.1 5.7m9.3 1.8c-7.9-1.1-7.7 2-3.1 4.1m9-11.6c-6-1.1-8.1 2.5-4 4m-15 18.3c-1.5-1.2-2.7-7 4.3-5.3m10.3 3.5c-4.7-1.3-9.2 3.4-4.9 6m11.2-11.5c-5-1-9.2.5-6.5 2.3"
        }),
        /* @__PURE__ */ jsx50("path", {
          fill: "#fff",
          strokeWidth: 0.4,
          d: "M483.6 107.5a9.6 9.6 0 0 0-7 5.4"
        })
      ]
    })
  ]
});
var Bt_default = SvgBt;

// src/country-flag-icons/generated/Bv.tsx
import { jsx as jsx51, jsxs as jsxs44 } from "react/jsx-runtime";
var SvgBv = (props) => /* @__PURE__ */ jsxs44("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx51("defs", {
      children: /* @__PURE__ */ jsx51("clipPath", {
        id: "bv_svg__a",
        children: /* @__PURE__ */ jsx51("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs44("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#bv_svg__a)",
      children: [
        /* @__PURE__ */ jsx51("path", {
          fill: "#fff",
          d: "M-28 0h699.7v512H-28z"
        }),
        /* @__PURE__ */ jsx51("path", {
          fill: "#d72828",
          d: "M-53-77.8h218.7v276.2H-53zM289.4-.6h381v199h-381zM-27.6 320h190.4v190.3H-27.6zm319.6 2.1h378.3v188.2H292z"
        }),
        /* @__PURE__ */ jsx51("path", {
          fill: "#003897",
          d: "M196.7-25.4H261v535.7h-64.5z"
        }),
        /* @__PURE__ */ jsx51("path", {
          fill: "#003897",
          d: "M-27.6 224.8h698v63.5h-698z"
        })
      ]
    })
  ]
});
var Bv_default = SvgBv;

// src/country-flag-icons/generated/Bw.tsx
import { jsx as jsx52, jsxs as jsxs45 } from "react/jsx-runtime";
var SvgBw = (props) => /* @__PURE__ */ jsx52("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs45("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx52("path", {
        fill: "#00cbff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx52("path", {
        fill: "#fff",
        d: "M0 160h640v160H0z"
      }),
      /* @__PURE__ */ jsx52("path", {
        fill: "#000001",
        d: "M0 186h640v108H0z"
      })
    ]
  })
});
var Bw_default = SvgBw;

// src/country-flag-icons/generated/By.tsx
import { jsx as jsx53, jsxs as jsxs46 } from "react/jsx-runtime";
var SvgBy = (props) => /* @__PURE__ */ jsxs46("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx53("defs", {
      children: /* @__PURE__ */ jsx53("clipPath", {
        id: "by_svg__a",
        children: /* @__PURE__ */ jsx53("path", {
          d: "M0 0h200v608h8v284l-8 8H0z"
        })
      })
    }),
    /* @__PURE__ */ jsx53("path", {
      fill: "#ce1720",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsxs46("g", {
      fill: "#fff",
      clipPath: "url(#by_svg__a)",
      transform: "matrix(.52885 0 0 .53333 5 0)",
      children: [
        /* @__PURE__ */ jsxs46("g", {
          id: "by_svg__c",
          children: [
            /* @__PURE__ */ jsx53("path", {
              id: "by_svg__b",
              d: "M36 0v14h-9v14H16v16H8v13H-8V24H8V6H-8V0Zm26 77v15h-8v12h-8V92h-8V77h-8V57h8V42h8V30h8v12h8v15h8v20Zm-17-1h10V58H45ZM19 183h8v-18h-8zm54 0h8v-18h-8ZM-8 305H6v13h6v16h9v15h12v-15h9v-16h8v-13H38v-15h21v10h13v17h11v19h-8v14h-7v13h-6v14h-9v12h-7v11h-9v14H24v-15h-9v-14H8v-9H-8v-23H8v-20H-8Z"
            }),
            /* @__PURE__ */ jsx53("use", {
              xlinkHref: "#by_svg__b",
              transform: "matrix(-1 0 0 1 200 0)"
            }),
            /* @__PURE__ */ jsx53("path", {
              d: "M96 0v32h8V0h32v14h-8v14h-12v16h-8v13H92V44h-8V28H72V14h-8V0Zm-2 274v-11h-6v-13h-7v-14h-8v-14h-8v-10h-9v-14H44v14h-9v10h-7v14h-8v14h-6v13H8v17H-8v-44H8v-20H-8v-33H8v14h10v14h10v-14h10v-14h8v-18h-8v-14H28v-14H18v14H8v14H-8v-41H8v-19H-8V77H8v13h8v16h11v13h9v15h7v12h14v-12h7v-15h9v-13h11V90h8V77h16v13h8v16h11v13h9v15h7v12h14v-12h7v-15h9v-13h11V90h8V77h16v28h-16v19h16v41h-16v-14h-10v-14h-10v14h-10v14h-8v18h8v14h10v14h10v-14h10v-14h16v33h-16v20h16v44h-16v-17h-6v-13h-6v-14h-8v-14h-7v-10h-9v-14h-12v14h-9v10h-8v14h-8v14h-7v13h-6v11zm2-167v27h8v-27zm-4 58v-14H82v-14H72v14H62v14h-8v18h8v14h10v14h10v-14h10v-14h16v14h10v14h10v-14h10v-14h8v-18h-8v-14h-10v-14h-10v14h-10v14zm4 46v27h8v-27z"
            })
          ]
        }),
        /* @__PURE__ */ jsx53("use", {
          xlinkHref: "#by_svg__c",
          transform: "matrix(1 0 0 -1 0 900)"
        }),
        /* @__PURE__ */ jsx53("path", {
          d: "M-8 408H8v14h7v8h8v14h7v12h-7v14h-8v8H8v14H-8Zm216 0v84h-16v-14h-7v-8h-8v-14h-7v-12h7v-14h8v-8h7v-14ZM62 459h8v-18h-8zm76 0v-18h-8v18zm-42-59h8v-18h-8zm0 100v18h8v-18Zm-50-75h14v-11h10v-10h5v-10h6v-14h8v-14h4v-13h14v13h4v14h8v14h6v10h5v10h10v11h14v50h-14v11h-10v10h-5v10h-6v14h-8v14h-4v13H93v-13h-4v-14h-8v-14h-6v-10h-5v-10H60v-11H46Zm50 9v-15h-8v-10h-8v25h8v9h5v14h-5v9h-8v25h8v-10h8v-15h8v15h8v10h8v-25h-8v-9h-5v-14h5v-9h8v-25h-8v10h-8v15z"
        })
      ]
    }),
    /* @__PURE__ */ jsx53("path", {
      fill: "#007c30",
      d: "M110 320h530v160H110Z"
    })
  ]
});
var By_default = SvgBy;

// src/country-flag-icons/generated/Bz.tsx
import { jsx as jsx54, jsxs as jsxs47 } from "react/jsx-runtime";
var SvgBz = (props) => /* @__PURE__ */ jsxs47("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs47("defs", {
      children: [
        /* @__PURE__ */ jsxs47("radialGradient", {
          id: "bz_svg__a",
          children: [
            /* @__PURE__ */ jsx54("stop", {
              offset: 0,
              stopColor: "#ffef5d"
            }),
            /* @__PURE__ */ jsx54("stop", {
              offset: 1,
              stopColor: "#ea5700"
            })
          ]
        }),
        /* @__PURE__ */ jsxs47("radialGradient", {
          id: "bz_svg__b",
          children: [
            /* @__PURE__ */ jsx54("stop", {
              offset: 0,
              stopColor: "#952d1a"
            }),
            /* @__PURE__ */ jsx54("stop", {
              offset: 1,
              stopColor: "#570a00"
            })
          ]
        }),
        /* @__PURE__ */ jsx54("radialGradient", {
          xlinkHref: "#bz_svg__a",
          id: "bz_svg__c",
          cx: 247.1,
          cy: 238.3,
          r: 36,
          fx: 247.1,
          fy: 238.3,
          gradientTransform: "scale(1.22624 .8155)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx54("radialGradient", {
          xlinkHref: "#bz_svg__a",
          id: "bz_svg__d",
          cx: 322,
          cy: 152.9,
          r: 10.6,
          fx: 322,
          fy: 152.9,
          gradientTransform: "scale(.93615 1.06821)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx54("radialGradient", {
          xlinkHref: "#bz_svg__b",
          id: "bz_svg__e",
          cx: 364.2,
          cy: 237.8,
          r: 36,
          fx: 364.2,
          fy: 237.8,
          gradientTransform: "scale(1.2242 .81686)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx54("radialGradient", {
          xlinkHref: "#bz_svg__b",
          id: "bz_svg__f",
          cx: 468.1,
          cy: 156.1,
          r: 10.7,
          fx: 468.1,
          fy: 156.1,
          gradientTransform: "scale(.95596 1.04607)",
          gradientUnits: "userSpaceOnUse"
        })
      ]
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#ce1126",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#003f87",
      d: "M0 34.3h640v411.4H0z"
    }),
    /* @__PURE__ */ jsx54("circle", {
      cx: 320,
      cy: 240,
      r: 188.6,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx54("circle", {
      cx: 320,
      cy: 239,
      r: 156.3,
      fill: "none",
      stroke: "#552300",
      strokeWidth: 3.9
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#007f00",
      d: "M302 73.2c14-15.2 26.9 2.3 26.5 10.6C328.2 92 314 110 301 95.5c13.4 3.4 17.4-11.5 24.1-11.7-6.7.2-9.5-14.6-23.2-10.6zm-147.2 119c-7.4-19.4 14-23 21.3-19 7.3 3.9 17.3 24.6-1.6 29.6 9-10.4-2.7-20.5.2-26.6-2.9 6-17.5 2-19.9 16M471.9 173c19.4 7.6 7.6 25.8-.2 28.4-7.9 2.7-30-4-21-21.2 1.6 13.6 17 12 19.7 18.1-2.6-6.2 10.3-14 1.5-25.3M218.8 377.4c-20.7-2-14.3-22.7-7.5-27.4 6.8-4.7 30-4.3 26 14.7-5.3-12.6-19.7-6.8-24-12 4.3 5.2-6 16.3 5.5 24.7m209.3-15c.3 20.7-21.1 16.8-26.6 10.6-5.4-6.2-7.7-29 11.8-27.3-12 6.6-4.6 20.2-9.4 25 4.8-4.8 17.1 4 24.2-8.2zM170 153c-1.9-20.6 19.8-18.3 25.7-12.6 6 5.8 10 28.4-9.6 28.2 11.5-7.6 3-20.5 7.4-25.6-4.4 5-17.3-2.8-23.5 10m22.2 193c-20.5-3.5-12.7-23.7-5.6-27.9 7-4.2 30.1-2.3 25 16.4-4.5-13-19.3-8-23.1-13.6 3.8 5.5-7.2 16 3.7 25zM354.3 74c18.6-9.2 24.3 11.7 21 19.3-3.2 7.5-23 19.4-29.8 1.3 11.2 7.9 20.3-4.7 26.7-2.4-6.4-2.3-3.7-17-17.9-18.2M394 388.3c-9.3 18.5-26.5 5.3-28.5-2.7s6.5-29.3 23-19c-13.8.5-13.4 16-19.8 18 6.4-2 13.3 11.4 25.3 3.7m90.5-178.7c15.6 13.7-1.7 26.8-10 26.7-8.2-.1-26.8-13.8-12.5-27-3 13.4 12 17 12.4 23.6-.3-6.7 14.5-9.8 10-23.3zm-263-108.8c4.7-20 24.5-11.2 28.4-3.9 3.8 7.3.5 30-18 23.8 13.3-3.7 9.3-18.6 15-22-5.7 3.4-15.5-8-25.4 2.1m-61.6 172.5c-18.2-10-4.2-26.5 4-28.1 8-1.7 29.2 7.7 18 23.7.2-13.7-15.4-14-17.2-20.5 1.8 6.5-12 12.7-4.8 25zm263.6-159.6c20.6-3 19.4 18.7 14 24.8-5.5 6.2-28 11.4-28.9-8 8.2 11 20.8 1.9 26.2 6-5.4-4.1 1.9-17.3-11.3-22.8M306.3 408.1c-19 8.4-23.8-12.7-20.3-20 3.6-7.5 23.9-18.6 30-.1-11-8.4-20.5 3.8-26.8 1.3 6.3 2.5 3 17.2 17.1 18.8M476.8 293c8.6 18.8-12.6 23.7-20.1 20.2-7.5-3.5-18.8-23.6-.2-29.7-8.4 10.9 4 20.3 1.4 26.6 2.5-6.3 17.3-3 19-17.1zm-325.1-60.6c-12-17 8-25.7 16-23.6 8 2 22.8 19.8 5.7 29.2 6.2-12.3-7.6-19.3-6.3-25.9-1.3 6.6-16.5 6.1-15.4 20.2zM264 395.6c-19.6 7.1-23-14.2-18.9-21.4 4-7.2 25-16.9 29.9 2-10.3-9.1-20.7 2.4-26.8-.5 6 2.9 1.8 17.3 15.8 19.9m-5.7-314c11.6-17.2 27-2 28 6.3.9 8.1-10.3 28.2-25.4 15.8 13.8 1.3 15.4-14 22-15.2-6.6 1.2-11.7-13-24.6-7zm200.2 252.1c1.3 20.6-20.3 17.7-26 11.7-5.8-5.9-9.1-28.6 10.4-27.8-11.7 7.2-3.6 20.4-8.2 25.4 4.6-5 17.3 3.3 23.8-9.3m-5.3-194.4c20.4 4 12 24 4.7 28-7.2 4-30.2 1.3-24.4-17.2 4 13.1 19 8.7 22.6 14.4-3.6-5.7 7.7-15.7-3-25.2zm-258.4-14.6c.2-20.6 21.5-16.2 26.8-9.9 5.3 6.3 7 29.3-12.4 27 12.2-6.3 5-20 10-24.7-5 4.7-17-4.5-24.4 7.6M169 311c-18.6-9.4-5.1-26.4 2.9-28.3 8-2 29.5 6.7 19 23-.4-13.7-16-13.4-18-19.8 2 6.4-11.6 13.1-4 25zM392 91c19.5-7.3 23 14 19 21.2-4 7.2-24.9 17.1-29.9-1.7 10.4 9 20.7-2.6 26.9.3-6.2-2.9-2-17.3-16-19.8m-41.3 314.8c-15.2 14.2-26.7-4.1-25.8-12.3.9-8.2 16.3-25.3 28.2-9.9-13-4.3-18 10.4-24.9 10 6.8.4 8.5 15.3 22.5 12.2m132.7-158c14.2 15.1-4.4 26.5-12.6 25.5-8.2-.9-25.4-16.3-9.8-28-4.4 13 10.3 18 10 24.7.3-6.7 15.4-8.4 12.4-22.2"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#005800",
      d: "M301 95.5c13.4 3.4 16.7-11.3 23.5-11.5-4 4.7-14.2 16.7-23.5 11.5m1-22.3c14-15.2 26.9 2.3 26.5 10.6-11.5-20-15-17-26.6-10.6zM174.4 202.8c9-10.4-2.8-19.9 0-26 2.6 5.6 8.9 20.1 0 26m-19.7-10.7c-7.4-19.3 14-22.9 21.3-19-23.1 1.4-22 6-21.3 19m295.9-11.8c1.6 13.5 16.7 11.3 19.3 17.5-5.9-2-21-7.1-19.3-17.6zm21.2-7.3c19.4 7.6 7.6 25.8-.3 28.4 14.7-17.8 10.5-20 .3-28.4M237.3 364.7c-5.3-12.6-19.2-6.4-23.4-11.7 6.2.3 22 1.2 23.4 11.7m-18.5 12.7c-20.7-2-14.3-22.7-7.5-27.4-9.2 21.1-4.6 22.1 7.5 27.4m194.5-31.7c-12 6.6-4.2 19.6-9 24.3-.4-6-1.3-21.8 9-24.3m14.8 16.7c.3 20.7-21.1 16.8-26.6 10.6 22.3 6.6 22.7 2 26.6-10.6M186 168.4c11.5-7.5 2.7-19.8 7-25 1 6.1 3 21.8-7 25M169.9 153c-1.9-20.6 19.8-18.3 25.7-12.6-22.7-4.9-22.8-.2-25.7 12.6m41.5 181.5c-4.4-13-18.7-7.6-22.5-13.2 6.1.7 21.9 2.7 22.5 13.2M192.1 346c-20.5-3.5-12.7-23.7-5.6-27.9-10.6 20.5-6 21.8 5.6 27.9M345.4 94.6c11.3 7.9 19.7-4.7 26.1-2.5-5.4 3-19.3 10.6-26 2.5zm8.9-20.6c18.6-9.2 24.3 11.7 21 19.3-3.5-22.8-8-21.1-21-19.3m34.2 292.6c-13.8.5-12.8 15.6-19.3 17.6 2.5-5.6 9-20 19.3-17.5zm5.5 21.7c-9.3 18.5-26.5 5.3-28.5-2.7 16.7 16 19.2 12 28.5 2.7m68-179c-3.1 13.4 11.9 16.3 12.2 23-4.9-3.8-17.2-13.7-12.2-23m22.5.3c15.6 13.7-1.7 26.8-10 26.7 19.9-12 16.7-15.4 10-26.7m-252.6-89c13.3-3.6 8.8-18 14.6-21.5-1 6-4 21.5-14.6 21.6zm-10.4-19.8c4.7-20 24.5-11.2 28.4-3.9-20-11.7-21.6-7.2-28.4 4zm-39.5 168c.1-13.6-15.2-13.3-17-19.8 5.6 2.7 19.9 9.7 17 19.9zm-22 4.5c-18.3-10-4.3-26.5 3.9-28.1-16.8 15.9-13 18.6-4 28.1zm248.6-142.8c8.2 11 20.2 1.6 25.6 5.7-6.1 1.2-21.7 4.1-25.6-5.7m14.9-16.8c20.6-3 19.4 18.7 14 24.8 3.7-22.7-1-22.5-14-24.8M316 388c-11-8.4-19.9 3.9-26.1 1.4 5.5-2.8 19.7-9.8 26-1.4zm-9.7 20.1c-19 8.4-23.8-12.7-20.3-20 2.7 22.8 7.2 21.4 20.3 20m150.2-124.7c-8.4 10.9 4 19.7 1.5 25.9-2.8-5.4-10-19.5-1.5-26zm20.3 9.5c8.6 18.8-12.6 23.7-20.1 20.2 23-2.8 21.6-7.2 20.1-20.2m-303.3-55c6.2-12.3-7.7-18.6-6.4-25.2 3.8 4.8 13.5 17.3 6.4 25.2m-21.8-5.7c-12-16.9 8-25.5 16-23.5-22.1 7-19.8 11-16 23.6zm123.3 144c-10.3-9.1-20 2.5-26.2-.4 5.7-2.4 20.4-8.5 26.2.3zm-11 19.4c-19.6 7.1-23-14.2-18.9-21.4 1.1 23 5.7 21.9 18.9 21.4m-3-291.9c13.7 1.3 14.7-13.8 21.3-15-3.1 5.3-11.4 18.8-21.4 15zm-2.7-22.2c11.6-17.1 27-1.8 28 6.3-14.5-18-17.6-14.3-28-6.3M443 317.6c-11.7 7.2-3.3 19.8-7.9 24.8-.7-6.1-2.3-21.8 8-24.8zm15.6 16.1c1.3 20.6-20.3 17.7-26 11.7 22.4 5.7 22.7 1 26-11.7m-25-183.6c4 13.1 18.5 8.3 22.1 14-6-1-21.8-3.5-22-14zm19.7-10.8c20.4 4 12 24 4.7 28 11.3-20.1 6.8-21.6-4.7-28m-244 2.6c12.2-6.4 4.7-19.6 9.6-24.2.3 6.1.8 21.9-9.6 24.2m-14.4-17.2c.2-20.6 21.5-16.2 26.8-9.9-22-7.1-22.6-2.4-26.8 10zm-4 181c-.3-13.7-15.6-12.8-17.6-19.2 5.7 2.4 20.2 9 17.6 19.2M169 311c-18.5-9.4-5-26.4 3-28.3-16.2 16.4-12.3 19-3 28.3m212.2-200.4c10.4 9 20-2.8 26.2 0-5.7 2.6-20.3 8.7-26.2 0M392 91c19.5-7.3 23 14 19 21.3-1.2-23-5.8-21.9-19-21.3m-38.9 292.6c-13-4.3-17.4 10.2-24.2 10 4.3-4.5 15.4-15.8 24.2-10m-2.4 22.2c-15.2 14.2-26.7-4.1-25.8-12.3 10 20.7 13.8 17.9 25.8 12.3M461 245.3c-4.4 13 10.2 17.3 9.9 24-4.5-4.2-15.8-15.3-9.9-24m22.4 2.5c14.2 15.1-4.4 26.5-12.6 25.5 21-9.9 18.1-13.6 12.6-25.5"
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#730000",
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx54("path", {
          d: "M349 120.3s.6-1.3 1.7-.6c1 .8 1.3 4.2 1.3 4.2l-1.6.8s.9-1.3-1.3-4.4zm-8.8 30.7s.8-1-.3-3.4l1.5-.5s.6 1.8-.2 3.9h-1m27-5.4-3.7 2.3 1.9.8 4.5-2.6-2.7-.5m-49.7 14.6c-1 .8-1 2.1-1.7 3-.4.7-2 1.8-2 3-.2 1.1-.3 1.9.2 3.5.6 1.5 3 8.5 2 13.7-1 5.3-.6 7.5-.3 8.3.4.8 1.6 3 2.3 3 1.6-.2.9-.7 1.5-1.7 1.4-2.5 0-22.2-.7-27.6-.5-4.2-2.5-8-2.7-8.4l-.8-2.6c-1.5-3.5-3.3-6.5-3.3-13.9 0 0-4.7 1.1-8.8-8.2-2.2-4.7-5.3-4.2-9-5.7l1.6-1.1s3.2 1.6 4.7 1.6c1.6 0 1-3.2 1-3.2l1.7-1.5v6.8c0 3.1 4.3 7.4 6.8 8.7 1.6.8 3.6-2.4 3.1-5.6-.5-3 0-7.3 0-7.3l2.2 1.3s-.8 1.3-.6 2.1c.3.8 1.3-.7 2.1-1.5 0 0 .2.2 1 .2l-2.3 4c-.8 1.2-.8 6.2-.8 8 0 2 .7 6.2.7 7.6 0 1 1.8 5 3.3 7.4l1.6 3.5c1.2 1.9 1.3 3.2 2 4.7.4.8 1 3 1.6 7l.7 7c.2 2.4 2.2.6 4.5-1 2.4-1.8 2.4-6 2.4-6s1.8-1.6 1.5-.7c-.2 1 1 2 1 2-1.4 3.3-.6 2.9.9 2.8 1.5-.2 6.5-4 6.5-4 .7-.2 3.8-.2 3.3 0-.6.3-1.4 1.7-1.4 1.7l3.3-.4c-1.1.9-5.5 3.4-6.5 4a90.6 90.6 0 0 1-8.6 4.1c-2.3 1-6.7 3.2-6.9 5.4 0 2.3.3 8.3 0 10.3l-1 10.6h-10.4s2-7.6 0-9.7c-2.1-2.1-7-8.4-10-10.5-3.2-2 2-.5 2-.5v-2.1l4.8 5.7s8.3-7.3 0-17.3c-2.6-3.1-5.3-7.9-7.3-8.4-2.2-.6-3.3-1-6.9 0-3.7 1.1-12.6 1.1-16.3-4.8l3.1-.5 2.7-1s-1.1 3.7 6.3 3.7 8.4 0 7.8-6.8l2.2-1.1 1.6 1.5s-1.1 3.8-.5 5.3c.5 1.6 3 2.7 5.1 4.2 1 .7 1.6.8 2.2.8.9-.1 1-.1 2.2-1.3 1.8-2 1.4-1.8 3.2-3.4l1-1.6z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M319 155c.5-.4 1.2-1.9 2-3.1 1.1-2 2.5-3.2 4-5.6 1.5-2.2 2-5.6 1.5-7.9l1.4.8v3.7l2.7-2 .8.4s-5.9 6-11.3 15.9zm-51.3-20.3c.8 1.4 1.6 4 3.9 6l1.6-.4s-3.6-4.2-3.6-6l-1.9.4m9.2-2.4s.5 5-.8 6.9l1.6-.8s1-3.4.7-5.3zm51.4-15.7s-.3 7 1.1 11.3l1.9-.5s-.3-1.3 1.2-1.9c1.6-.5 5.3-2 7.2-3.6l-.6-1.6s-2.8 2.3-4.2 2.9c-1.3.5-2 1-3.1.7-1.1-.3-2.4-2-1.6-6l-1.9-1.3m20.7 32.8s-.4 5-.2 7.2l1.7.4s-.4-6 .7-6.5l-2.2-1m7.5 3.7s-1.9 3.2-4 3.5l3.4-.7s1-.5 2.4-2l-1.8-.8"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#289400",
      stroke: "#030",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx54("path", {
          d: "m326.6 138.4 1.3.8 1.3.2 3.2 2.6c1.2 1 1.2-.2 1.2-.2l.8 3.1h1l-.2 3.2 1.8-1.6 2.2 1.9s1.5-1.4 2.3-1.4c.8 0 1.1-.8 1.1-.8h.1c-5.2-2.4-7.4-5-5.9-7.6 2.6-4.4 6.8-1.6 8.1-1l19 10.2s1.3-.8.4-1.6c-1-.8-1.4-2.7-1-3.5.2-.8 2.4 2.4 3.4 2.7l3.5.7v-1s3 2.2 3 3.3c0 0 2.3-1.2 1.5-1.9-.7-.7 3.5 1.7 3.7 3l1-1c-.2 0 .2-3.2 1.3-4.6a4.8 4.8 0 0 1 2-1.9s1-1.7 2-1.7c0 0-1-.6-1.4-1.4-.5-.8-1.6-1.2-1.6-1.2s1.4-1 1.8-1.5c.4-.6.8-.7.8-.7s-2.2-1.9-3.8-2.2c0 0-.1-2.5-2-2.7h.8s-1.4-2.8-2.8-2.8c0 0 .9-1 1.6-1.1 0 0-1.6-2.2-3.9-1.4l1.5-.6s-1-1.1-4.4-.6c0 0 .3-1.3-1.2-2.4 0 0-1.2 0-1.2 1 0 0-1.2-1-2.7-1-1.4 0 .5 1.6.5 1.6s-2-1.3-3.1-1c0 0 .5-2.2-.8-3.3 0 0-1.4.7-1.8 1.7l-.4-1s-2 2.4-2.4 1.7c-.3-.4-.6-2-.6-2l-1.1 1.7.2-2.4s-1.4.8-2.5 3.3c0 0-1.3 1.3-1.3 2.4 0 0-1.1-1.2-2 0-1 1.4 0 1.1 0 1.1s-.5.5-1.5.7l.2.8s-1.2-.7-2.2-.4l.5 1.2s-2.6.2-2.7-2c0 0-2.1-1-2.4.2l-1.6 1s-.5-1-1.3-1.2c-1-.3-.2 1.3-.2 1.3s-.3-1.2-1.5-1.8c-1.2-.5-.2 1-.2 1s-1.5-1.2-.8-2.2c0 0-1.4 1.4-.7 2.7l-1 .7s-.5-.5-.4-1c0-.3-1.7 1.3-1.7 1.3s-1-2.6 0-2.6c.1 0-1.8 0-2.1 2.2 0 0-1.3 0-2.5.4s1 1.3 1 1.3-2-.4-3 .2l.7.9s-.7-.7-2.4-.1c-1.7.5.4.8.4.8s-1.7-.4-2.6 0c-.9.4.3 1 .3 1s-3.2-1-3.7-.6c-.5.3 1 1.8 1 1.8s-2 .5-2.3 2l1.8.7s-.8.4-1.2 1.1c-.4.8 1.2.4 1.2.4s-2.2 1.6-2.2 2.8c0 0 1.6.5 2.7-.7 1.2-1.2.4-.8.4-.8l.1.8s2.3-1 2.3-1.6c0-.5-.4.8-.4.8l2.2-1.2z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "m324.7 108-.5-2.2 5 .6.9-2s2.4 1 3.1 1.8c0 0 4.6-1.2 6-.7l-.6 2.1s4.2.3 5.6.8c1.2.5-.6 1.6-.6 1.6s4.8.6 6.8 1.8c2.2 1.3 2.2 2.4 1.1 2.7l2.6 4.2s-4.2.5-5 1.5c-.7 1.1-1.5-1-1.5-1l-.8 2.9s-2.6-1.4-3.7-2.4c0 0-1.3 1.6-.5 2.4l-4.8-3.1s-2-.3-2 1.5l-3-3.4-2.6.8s-.8-1-1.7-1.4c-1.1-.2-.3 1.4-.3 1.4l-1.6-1.9-1.6-1.8s-1.3 1.8-2.4 1.8c-1 0-1-1.2-.8-2.1.3-.8-3.1-1-3.4 0 0 0-1-4 2.6-5l3.7-1zm-19 13.3-1.6 1.6-1-.5-1.9 2.1-.4-1.1-1 1.7-1.7-.6-.8 1.3-1.5-.3s-1.2 1.2-2 1.5c-.8.2 0-1.8 0-1.8s-1.2 2-2 2c-.9 0-.6-1-.6-1s-.5 1.4-1.4 1.6c-.9 0-.5-1-.5-1l-1.6 1.2v-1l-.7-.3s.4-1.8 1.1-2.2c.7-.4-.7-1.5-.7-1.5l.7-.8s-2-.5-2-.1c0 0 1-2.6 2.4-3.1l.1-3s1.4-1.1 2.6-1.2c1.4-.2-.4-2.3-.4-2.3l3.2-1.8.4-2.3 4.7.4 1-2 3.8 1 3.3-1.7 2.3 2.7 3.5.3v3.1s4.1 1.3 4.6 1.7c0 0-.8 2.5-.8 3 0 0 3-.8 3.8-.6l.4 3.4s5 1.6 5.3 2.5c0 0-1 .7-1.7 1.6 0 0 .6 3 .6 4l-.4.5s-1.4-1.3-2.6-1.5l-1 2.1-1.7-1.1h-1.1s-.9-1-1.6-1v-1l-1.4.9s-2.2-1.1-2.2-1.8l.1-1.5-2.2 1.5s-.5-1.1-.4-1.6c0-.5-.9 1.1-.9 1.1s-1.2-2-1-2.4l-.4 1.7s-2.3-.8-2.6-2.4z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M274.5 130.9s4.1 2 4.1 3c0 0 1.1-2.1.5-3l1.6 1.1s.5-1.9-.1-2.5c-.5-.5 3.5-2.1 4.4.5 0 0 2.4-2.5-2.3-4.7 0 0-.4-1.6 2.5-1.2 0 0-.2-1-.9-1.3h2.7s-1.6-1.4-4-1.8c-2.4-.4-1-.7-1-1.2-.2-.5 0-2.2 0-2.2s-1.4-.5-2.5 0l.4-.4s-2.5-.7-3.5-.1c0 0-1.5-.6-1.3-2.1 0 0-1.5-.1-2.1 1.4 0 0-1.4 1.6-3.3 1.6-.3 0-1.7-.8-1.7-.8l-1.2 2.7H265l.5 1s-2.8-.8-3.7 0c0 0 1.1 1.7.8 2.8 0 0-2.2.4-2.7.8-.6.4.8.7.8.7s-2.6.8-3.2 1.6l1 .7-1.2 1.6 1 .2-2.5.8c-.9.3 1.5.5 1.5.5l-1.1 1 1.8.3s-1.4 4-1.5 5.8c0 0 2.2-2.7 2.8-3l-1.8 3s3.4-1 3.7-1.6l.5-1 .1 1.6s1.3-1.7 1.5-2.4c.1-.7 2 .7 2 .7v-1l2.4.7c.7 0 .8-.3.8-.3l1.6-.2-.3 1.4s1.2-.8 1.5-1.6c.2-.8.8 0 .8 0l.8-3.1zm-13.4 13.8 1.6 3.3c-1.3 0-3.1 1.5-3.1 1.5.3 5.4-1 5.1-1 5.1.3 1-.3 2.8-.3 2.8l7.7-4.6.1-.5 9.2-4.3.3.5 2.6-1.5 1.9 4.9-1.9 1c.1 1.7 2.1 4.6 2.1 4.6l2.4-.6 2.7-1v1c0-.3 2.9-1.3 2.9-1.3l1.3 1.3c1-.1 2.7-2.5 2.7-2.5l2 .8s.7-1.2.7-2 2.6-.8 2.6-.8l1.7 1.2 2.3-1.8s.7 1.3 1.6 1.5c1 .1 3.4 2 3.4 1.6 0-.4 1-2.5 1-2.5l4.1 1.6c-.5-1.8-2-4-2-4s2-1.6 1.7-2c-.4-.4-1.6 0-1.6 0l1.2-2.4h-1.6l.5-.6-2.5-1 1.3-2.8c-.6-.7-7.3-2-7.3-2l1.6-1.5s-.8-1.2-1.6-1.2-4.9.1-5-.3l-1.8-1.8-2.6 1.9-1.3-.4-2.2.8s0 1.3-.3.4c-.3-.8-2.3-2.8-2.3-2.8-.4.7-3 3.8-3 3.8s-.5 1.7-1.3.5c-1-1.2-3-2.4-3.4-1.5-.2 1.1-2.1 2-2.5 1.8-.4-.3-2.5-.1-2.7.5-.1.7-2.5 2.4-2.5 2.4-1.4-.7-3.8-.3-3.8-.3s-.7 1.1-.8 2zm44.2 39.6v-2l2.3 1.5 1.4-1.5 1.8 1.7 1-1.7v2.8l2.7-2.3 1.5.6v-2.2s1.9-3.1 1.1-3.7l1.6-.5s-2.7-2.6-3.4-3.1c-.8-.6-1.9-.6-1.9-.6s-2-2-3.4-2.7c-1.3-.5-2 .6-2 .6s-.8-1.5-2.2-1.8c-1.3-.3-1.3 1-1.3 1s-1-1-2.2-1.4c-1.3-.6-.4 1.2-.4 1.2l-4.5-1.4.6 1.4-4.2-1.1.5 1.5-3-.5-.2 1.3-4.2.8.8 1.4-2.6-1.1v1.9l-3 1 1.1 1-4.7 2.4c-.7.5 1.6 1.6 1.6 1.6l-4.2-.6 1.6 1.4-3.7 3.4 2.6 1.9-1.6 2.3 4 .8 1.5 2.6 3.2-.6v3l4.7-3.7s3.4 3 3.7 2.1c.2-.8.2-3.4.2-3.4h1.7V187l1.2 1 2.2-3.1 2.8 3.9 2.2-5zm19.1-11.8-.4-4.5-1.4 1.4.6-4.2-2.2-.4.8-4.1-1.6-.8.4-2 1.6-1.1 2.8-2.8 6.6.1.7-2.1 4.7.8c.8.8 3.3-1.8 3.3-1.8h1l1 2s3.4-.4 5 .6l-1.9 2.6 3.5.3 2.3.5 2.4-.8 3.2-.2.7 1.3h3l-1 1.1 3.8 1.8-.8.8s2.2.8 3.7.8h.8s.8 1.8-.3 2.6c0 0 1.1 2.6 3.4 3.1 2.4.5 2.4.5 2.7 1 .3.6 0 3.2-2.7 3.2v2.7s-2 1.8-2.3 2.6l-1.6-1s-1.3 1.5-1.3 2.5c0 0-3.5-4.5-4.7-4.7-1.4-.2-1 2.6-1 2.6l-3.8-3.1-.5 2.1-3.1-2.6-1.9 1.3-3.3-3.5-3.2.4 1.2-1.6h-3.9l-.7-3.4-.6 2.8-2.4-1.6-3 3.3s-.4-.4-.9-2c-.5-1.5-1.8 2-1.8 2l-1.1-2.5-1.3 2.4s-1-1.8-2.1-2.4c-1-.5-2 3-2.4 4.5zm.6 10.3.2-1.6 5.6-2.2 4.7-1.7 2.3-1.1 1.1 1.9 1.4-2.7 2.1 2.8 1.2-1.5 1.8 1.4h1.6l.3 2s3.9.3 4.2-.5c.3-.8.8 2.7.8 2.7l3.7.5.8 4.2s1.8 3.9 1.2 5.4c-.5 1.7-2-2-2-2s-.3 2.9-.6 3.7c-.2.8-5-.8-5-.8l-2 3.9s-2.2-3.1-3.2-3.1-1 3.1-1 3.1l-4.5-5.3c-1.3-1.5-1.6 1.6-1.6 1.6s-2-3.4-2-4.4c0-1-1.9-2.2-1.9-2.2s-3.2 3.7-5.6 4.7c0 0 .3-2.3-.5-3-.7-.9-3 1.5-3 1.5s-1.7-3.6 0-7.4z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "none",
      stroke: "#004b00",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx54("path", {
          d: "m350.8 124.5.5 2s1.8-.4 3-.3l-.7 2.2s2.3-.4 3.4.3l-.5 1.2 2.7 1.2-2.5 2s4 1.5 4.9 2.7c0 0-2.7 1.8-3 1.7-.5-.2-.2.8.5 1.7l-2.2-.1s.9 2 .8 2.8c-.2.8-3.8.6-3.8.6m14.1-5.3s.7-3.9-.4-4.9c0 0 2.5 2.2 4.2 2.3 1.8 0 0-3.2 0-3.2s2.3 1.2 3.5 1.5c1.2.2-.9-2.4-.9-2.4s.7-1.3 2.7-.1m-45.4-15.5s0-1-.3-1.4c-2.4-3.2 2.4 2.4 3.4 2.6m4.5 0s1.6 1.2 2.3 1.2c.8 0-.5-3.1-.9-3.5-.3-.4 2.9 1.3 4 1.4 1.2.3 1.4-2 1.4-2s3.6.7 4.4 1.2m-25-.7-.5-3m-24.2 12.7c-.2-.3 1-2 .5-2.9 0 0 .7.6 1.4.7.6.1.4-2.2.4-2.2l.7.3s2-1 1.7-1.8c-.4-.8 1.4 1.2 1.4 1.2s1.1-1.2 1.1-1.7 1.4 1.2 1.4 1.2 1.5-.3 1.5-1.2c0-.9 1.8.3 1.8.3s.8-1 .7-1.8m-19.7 9.8s.9-2-.1-3.4m-23.6 9.8c0-1 .5-3.6 0-4-.4-.4 1 .4 2.2.7m9.3-.4c-1.2-1.1-1.9-1.7-3.7-1.7m-16.2 8.3c.3-.7.8-2.4.5-3.3m25 51.7 1.3-2.6 1.6 3.7 1-2.3.4.7 2.4-2.5 2.5 3.8m40.7-16.5 1.7-3.3 2.3 1.2 1-3.3 2.4 1.5 1.3-3 2.7.7.2-2.2s1.8 1 2.3 1.9c.6.7 0-2.7 0-2.7l2.2 1s1.5-1.6-.6-2.4"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "m343.6 163.1 2.3 3.4 2-2.2 1.7 3.8 2.3-1.4 3.2 1.9 1.5-1.2 3.5 2.5 1.4-3 3.2 1 2-3.5m-84.4-9.2s1.4-2.3 1-3.4c-.7-1 2.8 1.8 2.8 1.8s.7-2.3.3-3.4c-.6-1 3.9 3.2 3.9 3.2s.7-3.7 0-4.4c-.8-.8 4.3 1 4.3 1s2-.6 1.2-1.6c-.8-1.1 3.4 1.5 3.4 1.5s1-2.6 0-3.6 3.2 1.3 3.2 1.3l-1.6-2.8 3.4.2-.3-3.2m30.3 45.1 2.2-1 2 2 2.2-3.5 2.6 2.5.4-2.5 2.8 1.2.6-1.6 3.1 1.7.3-2.4 1.6.5.3-1.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#9dd7ff",
      d: "M283.1 298.1a69.8 69.8 0 0 1-6-13l42.4-37.2 42.3 37.1a64.7 64.7 0 0 1-6.2 13.3l-.3.5-3.2-1.2s-1.4 1.3-2.5 1.4c-1.4.2-2.7-1.3-2.7-1.3s-1.8 1.6-3.7 1.3c-1.9-.2-2.6-1.4-2.6-1.4s-2 1.6-3.4 1.3c-1.2-.3-2.1-1.2-2.1-1.2s-1.2 1.5-2.8 1.2c-1.6-.3-3-1.2-3-1.2s-2.5 1-4 1.3c-1.6.3-3-1.4-3-1.4s-2 1.4-2.8 1.4c-.8 0-3.7-1.4-3.7-1.4s-3 1-4.1 1c-1 0-4-1.3-4-1.3s-2.9.8-4.1.8c-1.4 0-3.4-.8-3.4-.8s-2.3 1.1-3.6.8c-1.4-.3-2.4-.8-2.4-.8s-2.6 1.1-4.2.8c-1.6-.3-3.4-1.4-3.4-1.4s-.3.8-3.4 1.4"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M319.5 205.1V248l-42.3 37.4a84.2 84.2 0 0 1-4.4-27.1V205h46.7"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#ffd83c",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M319.5 205.1V248l42.2 37.4a84.2 84.2 0 0 0 4.3-27.1V205h-46.5"
    }),
    /* @__PURE__ */ jsxs47("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx54("path", {
          fill: "#730000",
          d: "M292.2 289.2c3.2 1.7 2 1.2 8.7 3.5a61.8 61.8 0 0 0 20.7 2.8c8 0 12.4-.7 15-1.4 2.5-.7 3.1-1.8 3.1-1.8l-6.5 6.7s-26.3 1.4-31-1.7c-2-1-6-4.2-10-8z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "none",
          d: "M330.8 276.8s8.4 4.8 0 14m-37.8-1 12-11.6-1.3 15.4m6.3 1.4v-25.8m20.8 25.8v-27.4m-10.5 27.9V266"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#ff0018",
          d: "m310 270.6-5.4 1.7 5.4.6v-2.3m10.3-4-5.8 2.1 5.8.2v-2.4m10.5 1.6-5.8 2.2 5.8.3V268zm3.4 12.4c-.3-1.1 3.4-1 3.4-1s1 3.9 0 6.3l-3.1-.6s.3-2.6-.3-4.7z"
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx54("path", {
              d: "m294.8 288.1 10.3-10-.5 6s-5.3 3.5-5.3 5.9l-4.5-1.9m5.5 2.1s1-3.1 4-4.7l-.3 6.3zm14.7-17.3s4.2-.6 7.4 0c0 0-.5 4.2 0 5 0 0-5.8-1.4-8.1.8 0 0-.8-4 .7-5.8zm-8.9 1s4.2-.5 7.4 0c0 0-.8 4.8-.3 5.5 0 0-4.7-2.6-7-.4 0 0-1.6-3.3 0-5z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M305.9 279.4s4.2-.4 7.3 0c0 0-.5 4.3 0 5 0 0-5.5-1.2-7.8.8 0 0-1.1-3.9.5-5.8zm8.4-.7s6-.8 9.1-.3c0 0-1.2 3.4.3 5.7 0 0-6.5-1.7-9 .3 0 0-2-3.9-.4-5.7zm-9 6.5 8.2.6s-.8 6-.3 6.7c0 0-6.6-1.5-7.8.6 0 0-2.2-5.4 0-7.9zm9.2 0s7-.5 10.3 0c0 0-1.9 4.5.2 8.4 0 0-9.2-2.6-10.5-.5 0 0-2.1-5.4 0-7.9zm10.8-12.3s4.2-.6 7.3 0c0 0-.5 4.2 0 5 0 0-5.8-1.4-8 .8 0 0-.9-4 .7-5.8zm0 5.8s4.2-.5 7.3 0c0 0-.5 4.2 0 5 0 0-5.8-1.3-8 .7 0 0-.9-3.9.7-5.7zm.5 6s4.2-.6 7.4 0c0 0-1 6.6-.6 7.4 0 0-4.8-2.3-7-.3 0 0-1.4-5.2.2-7z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M334.5 285.2s1.3 5 3 5.6l-2.2 2.8s-2.9-2-3.2-4.4c0 0 1.9-2.1 2.4-4z"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      stroke: "#000",
      strokeWidth: 0.6,
      children: [
        /* @__PURE__ */ jsx54("path", {
          fill: "#006ac8",
          stroke: "none",
          d: "M355.4 298.7a66.2 66.2 0 0 1-36 28.3 67.3 67.3 0 0 1-36.3-28.8h.1c3-.7 3.4-1.5 3.4-1.5s1.8 1.1 3.4 1.4c1.6.3 4.2-.8 4.2-.8s1 .5 2.4.8c1.3.3 3.6-.8 3.6-.8s2 .8 3.3.8c1.3 0 4.1-.8 4.1-.8s3 1.3 4 1.3c1.1 0 4.2-1 4.2-1s2.9 1.4 3.7 1.4c.7 0 2.8-1.4 2.8-1.4s1.4 1.7 3 1.4c1.5-.2 4-1.3 4-1.3s1.4.9 3 1.2c1.6.3 2.8-1.2 2.8-1.2s.9.9 2.1 1.2c1.4.3 3.3-1.3 3.3-1.3s.8 1.2 2.7 1.4c1.8.3 3.7-1.3 3.7-1.3s1.3 1.5 2.7 1.3c1.1-.1 2.5-1.4 2.5-1.4l3.3 1"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "none",
          strokeWidth: 0.5,
          d: "M353.7 301.2c-1.4.1-1.6-.8-1.6-.8s-2 1.6-3.8 1.3c-2-.3-2.9-1.5-2.9-1.5s-2 1.6-3.4 1.3a5 5 0 0 1-2.3-1.1s-1.3 1.4-3 1.1c-1.6-.2-3-1.1-3-1.1s-2.7 1-4.4 1.3c-1.6.3-3-1.5-3-1.5s-3.8 1.2-4.6 1.2c-.9 0-3.6-1.2-3.6-1.2s-1.9 1.1-3 1.1-4.2-1.3-4.2-1.3-3 .8-4.3.8c-1.4 0-3.5-.8-3.5-.8s-2.5 1-3.9.8l-2.4-.8s-2.7 1-4.4.8c-1.6-.4-3.6-1.4-3.6-1.4s-.3.7-3.5 1.4h-.1"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#5ac800",
          d: "M293.1 305.2s-.3.7-2.8 1.2l-.7.2.6-.2-.7.3a44 44 0 0 0 11.7 11c4.5 3 9.6 6.6 18.4 9.2a71 71 0 0 0 17.8-9c6-4.5 9.2-7.2 12.6-11.7-2.7 1.5-2.3 1.5-3.7 1.3-1.3-.3-2.3-1.3-2.3-1.3s-1.3 1.5-3 1.3c-1.6-.3-3-1.3-3-1.3s-2.2 1.5-4.4 1.4c-1.6-.1-3-1.6-3-1.6s-3.8 1.3-4.6 1.3c-.9 0-3.6-1.3-3.6-1.3s-1.9 1.2-3 1.2-4.2-1.4-4.2-1.4-3 .8-4.3.8-3.4-.8-3.4-.8-2.5 1-4 .8c-1.3-.3-2.4-.8-2.4-.8s-2.7 1-4.4.8c-1.6-.3-3.6-1.4-3.6-1.4z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#ffd800",
          d: "M319.6 326.9a89 89 0 0 0 17.1-8.6c-1 0-4-1-2.9-1.2 0 0-1.2 1-2.3 1-1.1 0-4.2-1.3-4.2-1.3s-3 .7-4.3.7c-1.4 0-3.4-.7-3.4-.7s-2.6 1-4 .7l-2.4-.7s-2.8 1-4.4.7c-1.6-.3-3.6-1.3-3.6-1.3s-2.4 1.3-4 1.4a55 55 0 0 0 18.4 9.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx54("path", {
          fill: "#b34b00",
          d: "M313.2 249c1.9-1.6 3-3 2.3-4.2-.7-1-1.8.6-3 .2 0 0-2-1.1-2.5-2-1-1.2-2.5-2.3-3.3-3.4-.9-1-4.2-5.3-9.1-10.3-1.5-.9-1.1-4.4-2.2-5.5 0-.8-10-10.6-13.4-14-1.5-1.1-2.2-1.8-4.7.5-2 1.7-2.7 3.6-.1 5.8l12.8 11.7c1.9 1.8 4.5 2.1 5.6 3l13 13.4c1.7 1.4 2.5 2.4 1.5 3.6-1 2 .1 2.3.3 2.3.2.1 1.1.1 1.7-.4z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "none",
          d: "m280.7 214 13.4 13.2"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#fff",
          strokeWidth: 0.6,
          d: "m298.8 220 1.1-2.5c.2-.4 3.8-6.2 5.6-6.3l11.3 8.2c0 .5-5 7.8-5.3 7.2 0 0-13.2-5.5-12.7-6.6z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#ccb8c8",
          stroke: "none",
          d: "M306 222c-1.6-1.2-4.1-2.4-6.2-3.8l-.9 2c.7.8 10 5.1 11.6 6 0 0-1.8-2-4.6-4.2z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "none",
          strokeWidth: 0.4,
          d: "M299.8 218a73 73 0 0 0 5 3.1c2.7 2 4.4 4 6.4 5.2"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#782121",
          d: "m277.1 253 25.5-31.7c.5-.4 2.9-.4 3.2 2l-24.2 33s-2.7-.3-4.5-3.4z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#730000",
          d: "M362.7 253.3c-1 .7-2.4.8-2.4.8-1.7-1.9-3-4-5.4-6.5l-25.5-31.3 2.7-2.6 23 26.9c.6.7 4.6 4.9 8.4 9.8 0 0 .3 2-.8 2.9z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#fff",
          d: "m338.1 220.3-4-5s-3.2.5-3.8 2.1c0 0-2.2 3.7-8.2 4.1 0 0 1.7 7 8.6 10.7 0 0 2.5-7.2 5-8.4 0 0 2.5-1.9 2.4-3.6z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#730000",
          d: "M327.9 242c-.6-.3-1.2 0-2 .4-.9.5-1.8.3-1.7-.7 0-.8 0-.7 1-1.4a6.3 6.3 0 0 1 5-.5l-2.3 2.1m27.8-27.7c-.2-.7-.4-1.4.3-2.2.7-.8.7-2.2-1-1.5-1.7.7-2.2 2.5-.9 5.4z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#fff",
          d: "m327.3 242.5 28.9-28.7 7.1 7.6s-1.5-.6-2-.2c-.5.4.5 1.9.5 1.9s-1.3-.5-1.9-.1c-.7.4 0 2 0 2s-1.2-.8-1.8-.5c-.5.4 0 2.3 0 2.3s-1.5-.5-2-.1c-.3.4 0 2 0 2s-1.5-.7-2.3 0 .4 1.9.4 1.9-2-.8-2.7.4c-.8 1.2.1 2.2.1 2.2s-1.6-.7-2-.4c-.4.4 0 2.3 0 2.3s-1.3-.8-2.2.2c-.9 1 .1 2 .1 2s-1.3-.8-2-.4c-.6.4.2 2.2.2 2.2s-1.2-.9-2.1 0c-.9 1 0 2 0 2s-1-1-2.2 0c-1 1 0 2.1 0 2.1s-1.5-.8-2.1 0c-.7.8.2 1.9.2 1.9s-1.2-.7-2-.3c-.7.4 0 2.1 0 2.1s-1.1-1.3-1.6-.6c-.6.7 0 2.4 0 2.4s-1-1.3-1.6-.6c-.7.6.4 2 .4 2s-2-.8-1.5-.8z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "#7e4b7e",
          stroke: "none",
          d: "m354.5 216.2-2.2 2.2.5 7.7s.5-2.2 1.1-.7c0 0 .2-1.8.7-1.5-.4-.2 0-7.8 0-7.8m-4.3 4.3-1.6 1.5.6 7.7s.4-2.9 1.1-.6v-8.6m-17.6 17.2-1.5 1.7.4 4.7s.5-3 1.1-.7l-.2-2.6z"
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "none",
          stroke: "#7e4b7e",
          strokeWidth: 0.9,
          children: [
            /* @__PURE__ */ jsx54("path", {
              d: "M330.9 218.3c1 1 4 5 4 5m-2.6-2.9c-.2.6-.6 2.3-1.5 3.2m2-2.8c-.2.4-.2 1.7-1.5 3m2-2.4c-.3.7-.4 1.2-.8 1.7m1-1c0 .4-.3.5-.4.8m-3.2-2.7a29 29 0 0 1-4.8 2.8m4-1.8a14 14 0 0 1-3.1 2.2m2.8-1c-.5.4-1.5 1.4-2.3 1.7m1.8-.5c-.4.5-1 .8-1.5 1.1"
            }),
            /* @__PURE__ */ jsx54("path", {
              strokeLinecap: "square",
              d: "M311.3 224.7c.3-.6.9-1.8 1.6-2.8 1-1.4 1.3-1.6 1.8-2"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#289400",
      stroke: "#060",
      strokeWidth: 0.5,
      d: "M217 303.4c1.5.7 0-4.8.5-6.8.6-2.2 4.8 5.2 6.8 6.2 2.2 1 15.3-5.2 15.3-5.2l3.1-5.8 1.7 4.8s3.6-4.2 4.6-5.8c1.1-1.6 0 3.1-1 4.7-1.1 1.5 3.1 2.1 2.6 5.3-.5 3 4.2-2.2 4.2-2.2l12.1 1s2-7.3 5.3-11.5l1 4.8 5-5.1a65.9 65.9 0 0 0 41.3 39.2 66.6 66.6 0 0 0 40.2-36.6l6.7 7s5.3-1.6 6.3-2.2a70.3 70.3 0 0 1 15.5 5.6c1 .7.3-3.5.3-3.5s5.8 1.1 5.3 4.2c0 0 1.2-2.9 2.3-3.4 1.1-.5 3.6 2.7 4.2 3.7.5 1 13 2.6 14.7 3.6 0 0 1.3 1.6 1.3 2.7 0 0 2.7-.3 4.7-.3 0 0-1.5.8-1.5 2.4 0 1.6-.8 2.9-2.4 3.6-1.5.8 0 1.4 2 1.6 2.2.3 0 3-4.1 4.5 0 0-1 2.3.8 3.1 0 0-3.7.3-4.2-.8 0 0-1.3 2.5-1.3 3.8 0 0-4-1.3-5-1.9 0 0-1.6 1.6-.5 2.3 0 0-7.1-.7-8.5-3.4 0 0-2.5.8-2 1.7 0 0-5-3.4-6.6-3.4l-1 1.7s-3.5-2-4.5-2-.2 1.5-.2 1.5l-4.8-2.9-1.9 3-5-2.7c-1-.8-1.2 1.6-2 1.9 0 0-1.6-2.2-3.7-1.9 0 0-.8 2.6-.5 3.4l-7.1-1.5c-1.1-.3-.5 1.2 0 2.3 0 0-4.5-1.3-5.5-2l-.3 2s-3.7-.3-4.5-1l-2.3 3.1h-3.5l-.7 2.9s-6.6-1.9-7.2-.8c-.5 1 .3 2.6.3 2.6l-5.7-.7-.5 2.3s-6.7-2-8.2-1c0 0-2 2-3.4 2.6-1.3.5 0-.8 0-.8l-2-2.9s-2.4 1.3-3.8.8c-1.3-.6-5.5 2-6.8 1.3 0 0 0-1.9-1.1-2.4-1-.4-2.8-.4-3.6.8l-2.2-3c-1.2-2.2-3.1.1-3.1.1l-.3-2.5-3.6-.3c-2.2-.3-2.6-2.2-2.6-2.2s-5.6.6-6.4.3l1.4-1.3s-7.6 1.6-9.2 1c-1.7-.5 1.8-2.6 1.8-2.6l-8.4-2c-1.3-.4-9 1.2-10 1.2s-1.6-1.8-1.6-1.8-1.8 1.6-3.4 2.1c0 0-1.3-3.1-.5-3.4 0 0-5 1.3-5.3 2.6 0 0-1.2-2-1-3 0 0-2.4 3.8-3.5 4.6-1 .8-.2-1.9-.2-1.9s-2.9 3.7-4 4v-2.6s-8.4 4.5-10.7 3.9c0 0 0-1.9.8-2.4l-5.3-.2c-1.3-.2-2.8-.8-4.2-1.1-1.3-.2 1.9-1.6 4-1 0 0-5.8-2.1-7.6-1 0 0-.8-2.2 2.3-3 0 0-4-3.9-6.3-3.6 0 0 2.6-1.6 4.8-.8 0 0-2.5-6.6-4-7.4 0 0 5.5-1 7.1-.2z"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#730000",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M208.9 188.8 280 152c.3-2-.7-3.4-1.9-5-20.3 10-38.8 22.2-61.4 29.5-1.3.5-12.5 5.2-18.3 12.1a7.7 7.7 0 0 0-2 4.5s.2 3.1.9 4c0 0 .1.8 1.2 1.5 0 0 .7.3 1.1.2.5 0 1.4 0 2.6-2a52.4 52.4 0 0 1 6.7-8z"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "m266.1 152.4 9.2-4.4s3.1 2.3 2.8 5c0 0 .7 6 8.2 10.2 0 0-6.3 8-17.4 8.6 0 0 1.2-10.4-1.1-13.5 0 0-.4.4-.2-.1.3-1-.2-4.5-1.7-5.3z"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "none",
      stroke: "#7e4b7e",
      strokeWidth: 0.8,
      d: "M276.9 153.6c-2 .8-8.3 4.1-8.3 4.1m5.2-2.1c0 1-.6 3.3 0 5m-.8-4.7c0 .5-.8 2.2 0 4.6m-1-4.1c-.2 1-.4 1.5 0 2.6m-.8-2c-.2.5 0 .8 0 1.2m5.8-1.5c.3.7 2.9 4.8 4.5 6.5m-4.1-4.7c.3.8 1.7 3.6 2.8 4.7m-3-3c.4 1 1.1 2.7 2 3.7m-2-1.8a8 8 0 0 0 1.1 2.5"
    }),
    /* @__PURE__ */ jsxs47("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx54("path", {
          fill: "#b34b00",
          d: "m342.3 148.3 26.1 12.8c5.2 2.5 7.1.2 10 1.5l51.6 26.2c4.5 2 7 2.5 6.3 4.8-.1 3.7 1.7 3.7 2.2 3.8.4 0 2.1-.2 2.8-1.2l.6-.6c.6-.6.5-.7.7-1 2.1-3 3.3-5.8 1-7.5-2.5-1.3-2.8 1.5-5.6 1.2 0 0-4.8-1.8-6.6-3.1-3.2-1.8-7.8-3.9-8.8-5-3.3-.6-28-14.6-42.1-21.6-1.5-1.2-2.3-5.9-5.3-7.4-.8-1.3-19.8-10-29.8-15-3.6-1.3-5.7-2.2-8.3 2.3-2.3 4.4-1.8 6.8 5.2 9.8z"
        }),
        /* @__PURE__ */ jsx54("path", {
          fill: "none",
          d: "m344.5 142.8 29.2 14.6"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#ffa54b",
      stroke: "#000",
      strokeWidth: 0.5,
      transform: "translate(-40) scale(.96)",
      children: [
        /* @__PURE__ */ jsx54("path", {
          fill: "url(#bz_svg__c)",
          d: "M309.7 165.1c-.2.6-.7.2-.7.4-.4 2.2-.3 3.3-.8 4.5a7.1 7.1 0 0 1-3.1 2.6c-2 .7-4.5 3.1-8.5.9l-.6-.5s1.1 4.1-3 6.2l-15.7 8.2s-1.5 2.8-.5 6.5c0 .6.3 1.1-.3 1.5-1 .7-2.7 2.8-3.7 6 0 0-3-1.3-3-3.2 0-2 1.2-3 1.5-4.4.3-1.3 1-4.7.7-5.7-.4-1.1-2.3-1.5-3-2-.6-.3-1.4.5-1.3 1.4.1 1 .8.8 1.6 1 0 0-.9 2-.8 3.4l-9.2 4.8 1.6 2.3c.4.7 1.3 10.2 4 14.7s3.7 3.2 4.3 3.8l2 2c.8.5 4 .8 4.5-1a9 9 0 0 1 3.2-4.1c2-1.6 6-5.4 6-7.2 0 0 2.3 6.8 2 12.4 0 0 8.5 1.7 16.1 1.9 7.6 0 11.5-1.5 11.5-1.5s1-6.4.6-7.7c0 0 1.2 4.2 2.2 5.6 1 1.8 2.1 5.3 4.3 5.5 2.2.1 4-2.1 4.2-3v-6.8h8.7s3.8 1.5 5 1.3c1.3-.1 2-1.3.8-1.7l-.4-.3c1.2 0 2.6.7 2.6.7h4.3l-.1-.5c-.3-1.2-2.6-2.2-4.2-3-1.6-.5-3.5-1.2-4.7-1.3a20 20 0 0 0-6.2.4c-.8 0-3.9.4-5.8 1.3-.5.3-1 .4-.8-1 .3-1.3.2-7.8-1.3-10.5-1.2-2-1-3.6-.9-5.2a87 87 0 0 0 0-8.8c-.3-1.7-2.5-4-6.6-4.4-3.8-.5-7-3.7-7.3-6.2-.3-2.6.4-7.2.8-9.3"
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx54("path", {
              fill: "url(#bz_svg__d)",
              d: "M292.4 153.6c-.7 3.3-.7 6.1-.6 9.3.1 2.1 1.1 4.6 2 6.7a10 10 0 0 0 2.8 3.9c3.6 2.3 7-.2 8.9-1a6.4 6.4 0 0 0 2.7-2.5c.5-1.2.3-2.1.8-4.5l.7-.4c1-1.5.7-2 1.2-3 .6-1-.5-2.2-1.8-2 .6-1.9 1-4 .4-5.9-.2-.6.5-2.2-.6-1.8-4.6 1.8-10 1.4-14.8 1.4-.4 0-.8-.8-1.4-.7l-.3.5"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#000001",
              d: "M292 155.3c-.5-.4-.6-1.3 0-3.2.7-2 0-2 1.1-3.2s.9-1.6 1.6-1.9c.7-.2 2.8-.2 3.5-.5a11 11 0 0 1 9-.3c1.5.8 2.5 2.8 3.4 3.6 1 .7 1.7 3.6 1.5 7.9-.3 4.3-1.2 3.5-1.2 3.5s-1.2-2-2.2-.3c0 0 0-1.7.2-3 .1-1.1-.6-3.4.1-4.9 0 0-5.8 1.8-8.7 1.7-3-.2-7.4-.9-7.6-1.6l-.7 2.2"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#fff",
              stroke: "#fff",
              d: "M295 151.8c-.3-.6-1.8-2.9-.6-3.6 1-.6.4 2.8 2 3.5 0 0-.6 1.5-1.4.1z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "m298.3 160.1-.9 3.2m10.6 1.6c.2.6.4.3 1 .4m.3-4c.5-.5 1.2-.2.8 1.3m-17.7-4.9 2.8 1c1.5.6.6 2.9.2 4.3-.2.7-1 2-.6 2.5.5.8 1.1.3 2 .4 0-.3.6-.5.8-.5.7 0 1.1.5 1.7.3.6-.3.5-1.2.3-1.7m-.1-4.5c0-.4 1-.8 1.5-.9 2.1-.4 3.6-.7 5.4.5m-5.7 11.1c-1.8.4-3.6.7-5.2-.2m0-.8c.8-.4 1.1-.8 2.1-.3a5 5 0 0 1 1.1-.4c.8 0 1.4.3 2.2.8m-5.5.3c1-.3 3.3-.3 5.4.1"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#fff",
              strokeWidth: 0.3,
              d: "M292.3 160.1c.7 0 1.6-.9 3.2.3 1.1.8-1.8 1.5-1.3 1.4-1.4.2-1.8-.5-1.9-1.2 0-.1-.2-.5 0-.5zm8.4.8c.7-1.4 1.8-1 2.8-.8 1 .3.7.1 1.7.7-1.2.1-.9.2-1.7.6-.9.5-1.7.7-2.3.3-.2-.2-.7-.5-.7-1 0 .2 0 .3.2.3z"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#000001",
              strokeWidth: 0.3,
              d: "M293.8 161.4c.4 0 .7-.4.7-.8 0-.6-.3-1-.7-1-.5 0-.9.4-.9 1 0 .4.4.8.9.8zm8.6.2c.4 0 .7-.4.7-1a.8.8 0 0 0-.8-.8c-.4 0-.7.3-.7.8 0 .6.4 1 .8 1z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs47("g", {
          id: "bz_svg__g",
          children: [
            /* @__PURE__ */ jsxs47("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx54("path", {
                  d: "M345.9 213.7a3.9 3.9 0 0 0-1.9-1.4l-2-1c-.7-.4-1.7-.5-2.4-.9m.5 2.6-.9-.5c-.3 0-.7 0-1-.2 0 0 0-.2-.2-.2a3.5 3.5 0 0 1-2.4-1.3m-62.8-9.3c1 .7 3.2 2.2 3.4 5.1a10.5 10.5 0 0 0 1 3M264 202c.5 1.7.6 7.4 6 13.4m-5-21.4c-.4 1.1-1 2.2.2 3m14.4 10.7c1.1-2.6 4.6-2.4 4.6-4.8"
                }),
                /* @__PURE__ */ jsx54("path", {
                  d: "M284.8 207.3c-.3-2.9-1-4.5-.4-8.7.2-1.2.4-5.9 0-8.1 0 0 1.6 7.8-3.7 9.3m34.4 12.5c0-4 1-6.2 1-6.2 1.2-5.6-1.2-7.7-.3-9.1.9-1.2 2-3.8.5-8.9 0 0 2.8 10.5-4.5 10.5-7.5 0-7.2-2.7-7.2-2.7"
                }),
                /* @__PURE__ */ jsx54("path", {
                  d: "M284.4 190.5c0 2 0 8.4 9 8.4 2.8 0 5.8-2 7.4-3.3m2.2-2.7c-.3-2-.3-4.4-.3-7m-13.6-3.4c2.4-.3 4.4-.6 9-.6m.2-6.3c.5 2.2-.3 5.8 4 6.3m4.3-7.1c-.6 1.6-.6 3.3-.8 4.4m.2 2.7c1.7 0 5-1.1 9-.3m1.4 22.8c.9 1.6 1 3.8 3.6 6.2m-31.7-11.4c.2 1.3-1.8 5.7-.3 9.3a12.3 12.3 0 0 1-1.2 11m6.7-19c-.9 1.7-2.3 3.3-2.6 4.7m6.6-1.6c0 1-2.7 8.7-4.7 10.9 0 0 3.6 1.4 3 6.6m7.4-21c0 1.2-.2 1.6 1 2.4m2.4 0c1.3 1.6 5.5 6.5 4.6 9.2m-7.4-6.5c.3 1 .3 6.3-.6 9m-2.1-.2c-1.1 0-2.8.8-3 2.7m8.7-3c1.1-.3 3.3 1.6 3.3 7m15.7-10.2c-2.1.6-3 1.7-2.4 1.1-1.1 1-2.2 1.6-2.2 1.6"
                })
              ]
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#000001",
              strokeWidth: 0.3,
              d: "M289.8 198c.6 0 1.1-.4 1.1-1 0-.3-.5-.7-1.1-.7-.5 0-1 .4-1 .8 0 .5.5.9 1 .9zm23 .3c.6 0 1.1-.4 1.1-1 0-.4-.5-.7-1-.7-.6 0-1.1.3-1.1.8s.5.9 1 .9z"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#fff",
              d: "M280.5 239.8c1.3-8 5-14.5 5.1-15.2 0 0 3.9.9 10.6 1.5 6.6.7 8.4.4 11.5.2l6.8-.8s1.2 2.4 1.3 4.8c.3 5.2 2.3 27.7 2.5 33.7 0 0 .8 3.6.8 12.3 0 9.6 2.6 29 2.6 39.4l-2.6.5s-14.5 1.1-14.5-.8c0-2.1-.8-27 1.4-42.1 0 0-.5-3-1.4-5.5-.8-2.5-4.3-10-4.3-11.7 0 0-5.7 16-6 18.8-.3 2.6-1.2 38.4-1.7 41.3 0 0-8.2 6.3-9.3 7-1.1.4-9-3.4-9.3-4.4a211 211 0 0 1 4.6-33.2c1.4-7.1.6-8.4.6-10.4s.1-27.5 1.3-35.4z"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "none",
              d: "M294.3 275c-.6 2.2-1.7 4.3-3.6 5.7m-2.7-53.6c-.3 1.3-2.3 7.3-7.2 10.9m14.3-9.8c-1.1 3.6-5.5 22.7-6.3 45.4m-.3 7.1-1.7 20.8m-.8 3a71.3 71.3 0 0 0-2.7 18.7m32.2-36c-.2 2-1 15.7 3.6 28m-18.5-86c-.3 2.3-.8 16.7-.8 17.8 0 1.2 1.6 2.8 2.4 3 0 0-1.6.6-2 6m-4-12.8c-.3 1.7-2 8.5-3 11.3m13-25.5s5 1 5.3 0c0 0 1.6 29.5 3.8 46m-11.2-42.2-.6 16.5m2.5 2.1s1.9 2.8 1.4 4m-17.8-28 3 .8m5.2 1.6c-.3.9-.6 4.6-.6 4.6m8.8 38.9c.6.8 1.4 2 .8 4.4"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#9b5f00",
              d: "M285 224.4s0-3.2 1.1-4.8c0 0 3.5.7 8.4 1.2 5 .5 9 .9 12.6.5 3.7-.4 7.4-1.3 7.4-1.3s1 4.8.5 5.5c0 0-4 .8-8.3 1a86 86 0 0 1-14.5-.8 57 57 0 0 1-7.3-1.3z"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#fff",
              d: "m288 224.8.7-4.8h1l-.2 5.1-1.4-.2m22-4.1.1 5.5 1.3-.2-.1-5.6-1.3.3m-15.6 0-.4 5.3h.7l.7-5.3h-1"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M276.8 320.8c-.3 1.3-.8 3.2-1 5.5 0 .5-.6 3.3 1 3.4 1 0 1.4-2.9 1.4-2.9s-1 3.3.3 3.7c1.8.4 2-3.6 2-3.6-.2 1.1-1.4 4 .3 4.3 1.9.3 2.4-3.9 2.4-3.9s-1.6 4.2.3 4.3c1.7 0 1.7-4 1.7-4s-.9 5 1.5 4.5c1.4-.2 1.7-2 2-3 .4-1.5 1.3-3.4.2-6.6-.8-2.3-.5-3-.5-3s-2.9 2.2-5.1 3.6c-1 .6-6.5-2.3-6.5-2.3zm29.7-4.4c-.5-.3-.4 1.9-.6 2.9-.1 1 .2 3.2 3.6 3 3.4-.3 6.7-1 8.9-.5 2.1.6 5.3.7 7 .7 1.7 0 2.8-.2 3.7-.5.7-.3 2.2.4 3 .4s1.7-1 1.6-1.8c0-1.3-1.3-1.3-3-1.4a22 22 0 0 1-5-1c-1.1-.3-3.1-1.5-5.7-2l-5.9.2c-1 0-7 .3-7.6 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx54("path", {
              fill: "#ffb366",
              d: "M255.7 189.8c-.5.3-1.1-2 .4-2.9 0 0 .4-2 2-2.1 0 0 1.4-1.9 3.3-1.7 0 0 2.2-1.5 3-1.3.9.1 3 2.1 3 2.9.2.7 0 1.9-.5 2.4-.6.6-1-.1-1.1-1 0 0 .4 1.6-.8 2.2-1.2.7-1.1.2-1.2-.6 0 0-.4 1.6-1.2 1.9-.8.3-1.3-.5-2-.5 0 0 1.1.9.4 1.5-.7.5-1.5.3-2-.1-.5-.5-1.2-1.9-3.3-.6z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M265.7 186c-.5-1.5-2.2-3-4-2.8m2.2 4.4c-.3-.4-.4-.8-.8-1.2-.9-1.5-2.8-1.4-4.4-1.8m2.4 4.5c-.6-.4-.8-1.2-1.4-1.5-1-.4-2-.9-3.3-.7"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      transform: "translate(-40) scale(.96)",
      children: [
        /* @__PURE__ */ jsx54("path", {
          fill: "url(#bz_svg__e)",
          d: "M439.1 165.1c.7-.3.5.6.6 1 .4 1.3.4 2.7.9 3.9.6 1.1.8 1.5 1.8 2 1.6 1 6.4 3.6 9.8 1.5a3.1 3.1 0 0 0 .7-.5s-1.3 4.1 3 6.2l15.6 8.2s1.5 2.7.6 6.5c-.2.6-.4 1.1.2 1.5 1 .7 2.6 2.8 3.8 6 0 0 3-1.3 3-3.2 0-2-1.3-3-1.6-4.4-.2-1.3-1-4.7-.6-5.7.4-1.1 2.1-1.5 2.8-2 .7-.3 1.6.5 1.3 1.4 0 1-.8.8-1.6 1 0 0 1 2 .8 3.4l9.4 4.8-1.6 2.3c-.5.7-1.5 10.2-4.2 14.6-2.8 4.5-3.7 3.3-4.2 4l-2.1 1.8c-.6.5-3.8.9-4.5-.9a9 9 0 0 0-3.1-4.1c-2-1.6-6-5.4-6-7.2 0 0-2.3 6.8-2 12.4 0 0-8.4 1.7-16.2 1.9-7.6 0-11.5-1.5-11.5-1.5s-1-6.4-.6-7.7c0 0-1.2 4.2-2 5.6-1.1 1.8-2.2 5.3-4.4 5.5-2.2.1-4-2.1-4.2-3v-6.8h-8.7s-3.8 1.5-5 1.3c-1.3-.1-1.9-1.3-.9-1.7l.4-.3a7 7 0 0 0-2.5.7H402l.1-.5c.3-1.2 2.6-2.2 4.3-3 1.6-.5 3.3-1.2 4.6-1.3 1.9-.2 3.2-.1 6.2.4.8 0 4 .4 5.8 1.3.5.3 1 .4.8-1-.3-1.3-1.2-5.5.3-8.3 1-1.9.9-3.5.8-5.2-.2-1.7-1.1-5.6-1.1-7.3 0-5.7 4.4-8 8.2-9.2 4.3-1.4 7.1-2.8 7-5.3-.2-2.7.5-7 .1-9"
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx54("path", {
              fill: "url(#bz_svg__f)",
              d: "M456.3 153.6a20 20 0 0 1 1.2 5.3c0 1.2-.5 1.4-.1 2.8.7 2.4-.8 5-2.5 8-.8 1.2-1.4 3-2.7 3.8-3.4 2.1-7.5-.4-9.6-1.3a3.7 3.7 0 0 1-2-2.2c-.4-1.2-.5-2.3-.8-4 0-.3 0-1.2-.6-.9-1.3-1.4-1-2-1.6-3-.5-1 1-2.2 2-2a10 10 0 0 1-.2-5.9c.2-.6-.6-2.2.5-1.8 4.5 1.8 10 1.4 14.8 1.4.4 0 .7-.8 1.3-.7l.3.5"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#000001",
              d: "M456.8 155.3c.4-.4.1-2.3-.4-4.3-.1-1-1-1.5-2-2.6s-1.6-1-2.3-1.4c-.6-.2-2-.2-2.8-.5-.6-.3-2.2-.1-3.7.1-2 .3-3.2.2-4.7 1s-2.8 1.8-3.3 3.3c-.4 1-1 2.5-.8 6.8.2 4.3 1 3.5 1 3.5s1.1-1.7 1.9-.6l-.3-3.6c-.1-1.2 0-2.8.5-4.6 0 0 4.6 1.7 9 1.7 3 0 7-.3 7.1-1l.7 2.2z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M450.4 160.1c.7 1.8.1 1.3.4 2.4m-10.2 2c0 .8-.6.6-1 .6"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M456.9 158.8c-1-.7-2.7-.2-3.5.1-1.5.7-.7 2.3-.2 3.7.2.7 1 1.7.5 2.4-.4.8-.7.4-1.6.5 0-.3-.8 0-1.1 0-.6 0-1 .4-1.5.2-.6-.3-.5-1.2-.3-1.7m.1-4.5c0-.4-1.3-.8-2.7-.9-2.3 0-2.5.1-4.2 1.3m11.5 9c-.4-.6-1-1-2.1-.4 0-.2-1.6-.4-1.6-.4-.8 0-1.3.3-2.1.7m5.6.6c-1-.6-3.3-.2-5.6-.2m.2.8c1.7.5 3.5.8 5.2 0"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#fff",
              strokeWidth: 0.3,
              d: "M456.4 160.1c-.7 0-1-.9-3.1.3-1.1.7 1.8 1.5 1.4 1.4 1.2.2 1.6-.5 1.7-1.2 0-.1.2-.5 0-.5zm-8.3.8c0-.8-1.8-1-2.9-.8-1 .3-.5.1-1.5.7 1 .1.7.2 1.6.6.9.5 1 .9 2.3.3.3-.1.7-.5.8-1 0 .2-.2.3-.3.3z"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#000001",
              strokeWidth: 0.3,
              d: "M455.1 161.4a.8.8 0 0 1-.8-.8c0-.6.3-1 .8-1 .4 0 .7.4.7 1 0 .4-.3.8-.7.8zm-8.7.2c-.4 0-.7-.4-.7-1 0-.5.4-.8.8-.8s.7.3.7.8c0 .6-.3 1-.8 1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx54("use", {
          xlinkHref: "#bz_svg__g",
          width: "100%",
          height: "100%",
          fill: "#730000",
          transform: "matrix(-1 0 0 1 748.8 0)"
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx54("path", {
              fill: "#730000",
              d: "M491.6 193.5c.5.2 2-2 .5-3 0 0-.5-2-2-2 0 0-1.4-2-3.4-1.7 0 0-2-1.5-2.9-1.4-1 .2-3 2.2-3 3-.2.5 0 1.8.5 2.4.6.5 1-.1 1-1 0 0-.3 1.5.9 2.2 1.2.7 1.1 0 1.2-.7 0 0 .3 1.6 1.1 2 .9.2 1.4-.5 2-.5 0 0-1 .8-.3 1.3.7.6 1.5.3 2 0 .6-.5.3-1.8 2.4-.6z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M482.5 189.8c.5-1.8 2.2-3.2 4-2.9m-2 4.4c.1-.4.2-.8.5-1.2 1-1.6 3-1.6 4.6-1.9m-2.5 4.5c.6-.4.8-1.1 1.4-1.4a5.3 5.3 0 0 1 3.2-.7"
            }),
            /* @__PURE__ */ jsx54("path", {
              fill: "#730000",
              stroke: "none",
              d: "M482.3 186.8c-.9.7-1.8 1.8-1.9 2.2 0 .7 0 1.9.5 2.5.6.5 1 0 1.1-.8 0 .5 0 1.5.8 2 1.3.7 1.2.1 1.3-.7 0 0 .3 1.6 1 2 .9.2 1.4-.5 2-.5 0 0-1 .8-.3 1.3.7.6 1.5.3 2 0 .6-.5.3-1.8 2.5-.6.2.2.8-.4 1-1.1l-7.7-5.5z"
            }),
            /* @__PURE__ */ jsx54("path", {
              d: "M480.7 188.2c-1.5 2.6.5 4.1 1.1 2.6-.1 2.4 1.7 2.3 2.3 1.5.7 2.5 1.9 1.4 3 1.2-1.3 2.3 1.4 1.6 2 1 1-1.3 1.4-.2 2-.3l1.3-1.3m-8-5.7c-1.7 1-2.5 2.2-2.6 3.7m5-2.2c-1.8 1-2.6 2.2-2.6 3.7m5.4-1.7c-1.7.9-1.8 1.7-2.5 2.8"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#5ac800",
      d: "m238.5 310.7-.2-4.5 1.9 1.6.4-3.4c.8-.2 2.1 1.3 2.1 1.3l-.2-3.4 2.8 3.1s-.2-2.6.8-4.2c0 0 2.2 1.9 2.2 4 0 1.9 1.8-2.6 1.8-2.6a3116.2 3116.2 0 0 0 1.6 5l1.3-1.9 1 4 2.4-3.5 1.8 4 4.2-.3.5 2.4 1.9-2 2.4 1.5s2-.6 3.1-.6 2.4 1.4 2.4 1.4.8-1.4 1.5-1.9 1.9.8 2.2 1.6l1.6-2.9s2 2 2.3 2.9c0 0 .3-2.4.8-3.2.5-.7 1.2.3 1.8 1.3l1.3-4.2s1.4.3 2.3 1.9c1.1 1.5 1.1-2.4 1.1-2.4s2.4 3.2 3 5.3c0 0-16.2 5.6-27.6 4a306 306 0 0 1-24.5-4.3m110.9-.5s.7-2.1 1.8-3.2c0 0 2 2.4 2 3.2l1.7-1 1.6 1.5 1.8-1.3 1.8 1.6 3.2-1.4 1.3 1.4 5-.6 1.8.8 1.8-2.3 1.6 1.8 2.7-2.6s1.3 1 1.5 1.8c0 0 2.2-1 2.7-1.8 0 0 2-.8 2.3.5 0 0 1.3-1 1.2-2-.1-1.2 1.5-.4 2 1 0 0 .5-2.2 2-2.4 0 0 1.2 1.3.9 3.7 0 0 2.3-1.9 3.4-2.1 0 0 .5 2.6-.3 5 0 0 2.4-4 3-2.7.1.8.7 3.5.1 5.3l2.2-1.3.8 2.6 2.3-.5s-13.9 2.1-27 .9c-13-1.3-25.3-5.9-25.3-5.9m-9.6 9.7c.6-.4-4.4 10.3-16.5 10.9-16.9.8-31.3-7.7-31.3-7.7s1.8-2.9 2.9-3.7c0 0 2.3 1.9 3 4.2 0 0 .4-1.5 1.2-2.9 0 0 2.9 1.4 3.4 3.2 0 0 1-1.8 1.8-2.3.8-.6 1.6 2 1.6 3.6 0 0 1.9-2 3-2 0 0 2 1 2.6 4.3 0 0 2-1.8 2.6-1.5 0 0 2.3 1.5 1.8 3.7-.3 1.2 2.3-1.4 5.5-2.2l2.9 2.2 3.4-4.7s2.1.8 2.1 2c0 0 1-3.7 1.8-4 .8-.5 1.8 1.1 1.8 2.2 0 0 .3-2.8 1.9-3.4 0 0 1.6 1 1.6 2.1 0 0 1.6-3.2 2.9-4"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "none",
      stroke: "#060",
      strokeWidth: 0.5,
      d: "m238.5 310.7-.2-4.5 1.9 1.6.4-3.4c.8-.2 2.1 1.3 2.1 1.3l-.2-3.4 2.8 3.1s-.2-2.6.8-4.2c0 0 2.2 1.9 2.2 4 0 1.9 1.8-2.6 1.8-2.6l1.6 5 1.3-1.9 1 4 2.4-3.5 1.8 4 4.2-.3.5 2.4 1.9-2 2.4 1.5s2-.6 3.1-.6 2.4 1.4 2.4 1.4.8-1.4 1.5-1.9c.8-.5 1.9.8 2.2 1.6l1.6-2.9s2 2.1 2.3 2.9c0 0 .3-2.4.8-3.2.5-.7 1.2.3 1.8 1.3l1.3-4.2s1.4.3 2.3 1.9c1.1 1.5 1.1-2.4 1.1-2.4s2.4 3.2 3 5.3m58.7-.8s.8-2.1 1.9-3.2c0 0 2 2.4 2 3.2l1.7-1 1.6 1.5 1.8-1.3 1.8 1.6 3.2-1.4 1.3 1.4 5-.6 1.8.8 1.8-2.2 1.6 1.7 2.7-2.6s1.2 1 1.5 1.8c0 0 2.2-1 2.7-1.8 0 0 2-.8 2.3.5 0 0 1.3-1 1.2-2-.1-1.2 1.5-.4 2 1 0 0 .5-2.2 2-2.4 0 0 1.2 1.3.9 3.7 0 0 2.3-1.9 3.4-2 0 0 .5 2.5-.3 4.9 0 0 2.4-4 3-2.7.1.8.7 3.5.1 5.3l2.2-1.3.8 2.6 2.3-.5m-109.8 8s1.8-3 2.9-3.7c0 0 2.3 1.8 3.1 4.2 0 0 .3-1.6 1-3 0 0 3 1.4 3.5 3.2 0 0 1-1.8 1.9-2.3.7-.6 1.5 2 1.5 3.6 0 0 1.9-2 3-2 0 0 2 1 2.6 4.4 0 0 2-1.9 2.6-1.6 0 0 2.4 1.6 1.8 3.7-.3 1.2 2.3-1.4 5.5-2.1l2.9 2.1 3.4-4.7s2.1.8 2.1 2c0 0 1-3.6 1.8-4 .8-.5 1.9 1.1 1.9 2.2 0 0 .3-2.8 1.8-3.4 0 0 1.6 1 1.6 2.1 0 0 1.6-3.2 3-4"
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#fff",
      children: [
        /* @__PURE__ */ jsx54("path", {
          d: "M319.5 361.9c22 .2 35-7.8 42-12.6 16.8-11.2 20.3-11.6 23-11.4 3.1.3 7.7 1.3 8 4 .2 4.3-6.6 6.1-10.5 6.1-4 0-14.5-2.6-14.5-2.6l-2.7 1.9c1.8.8 23.2 8 27.3 1.2 4.2-6.8 8.4-17.9 8.4-17.9s-4.7-8.4-15.1-8.4c-10.6 0-20.8 6.7-27.6 11.7-6.9 5-15.5 11.8-38.3 11.8-22.9 0-31.6-6.8-38.4-11.8-6.9-5-17.1-11.7-27.6-11.7a18 18 0 0 0-15.2 8.4s4.2 11 8.4 18c4.1 6.7 25.5-.5 27.3-1.4l-2.6-1.8S261 348 257 348s-10.9-1.8-10.6-6c.2-2.8 4.8-3.8 8-4.1 2.7-.2 6.2.2 22.9 11.4a72 72 0 0 0 42.2 12.6"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M284.1 336s0-1.9-.3-4.6c-.4-3.5-2.4-4.4-4-3.9-1.2.4-3.3 3-3.3 3v.1a31 31 0 0 0-3-1.8 18 18 0 0 1 6.3-3.6c1 0 14.5 5.4 18.8 9.1 1 1 1.8 7 1.2 9a46.5 46.5 0 0 1-15.7-7.2m-6.5 13.6s-2.9 3-3 8.3c0 6.3 4.5 6.6 7.5 6.5 3.7 0 6.6-2.1 6.5-8.9 0 0-6-2.5-11-6m77.1-13.6.4-4.6c.4-3.5 2.4-4.4 4-3.9 1 .4 3.2 3 3.2 3v.1l3-1.8c-.7-1-5.2-3.6-6.2-3.6s-14.5 5.4-18.8 9.1c-1 1-1.8 7-1.3 9a45.5 45.5 0 0 0 15.7-7.2zm6.5 13.7s2.9 3 3 8.3c.2 6.3-4.5 6.6-7.5 6.5-3.6 0-6.5-2.1-6.5-8.9 0 0 6-2.5 11-6"
        })
      ]
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "#69f",
      d: "M271.3 345.4S260.9 348 257 348c-4 0-10.9-1.8-10.6-6 .2-2.8 4.8-3.8 8-4.1 2.3-.2 5.3 0 17 7.5m96.1 0S378 348 382 348c3.9 0 10.7-1.8 10.4-6-.2-2.8-4.8-3.8-7.9-4.1-2.3-.2-5.4 0-17 7.5m-83.4-9.3a93.7 93.7 0 0 1-3.1-2.3c-1.5-1.1-3-2-4.5-3.2 0 0 2.1-2.7 3.2-3 1.7-.6 3.7.3 4.1 3.8.3 2.7.3 4.7.3 4.7m-7.1 27.6c1.8 1 3.9 1 5.1.8 3.7 0 6.6-2.1 6.5-8.9 0 0 4.5 2.3 11.8 4 0 0 1.2 1.5 1.4 4.4.3 2.5-1.4 5.1-3.3 5 0 0-10.3-2-16.5-3-3.7-.7-5-2.3-5-2.3m77.7-27.6 3.2-2.3 4.4-3.2s-2.1-2.7-3.2-3c-1.6-.6-3.6.3-4 3.8zm7.1 27.6c-1.8 1-3.9 1-5.1.8-3.6 0-6.5-2.1-6.5-8.9 0 0-4.5 2.3-11.7 4 0 0-1.3 1.5-1.5 4.4-.2 2.5 1.5 5.1 3.4 5 0 0 10.3-2 16.5-3 3.6-.7 5-2.3 5-2.3"
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.7,
      children: [
        /* @__PURE__ */ jsx54("path", {
          d: "M319.5 361.9c22 .2 35-7.8 42-12.6 16.8-11.2 20.3-11.6 23-11.4 3.1.3 7.7 1.3 8 4 .2 4.3-6.6 6.1-10.5 6.1-4 0-14.5-2.6-14.5-2.6l-2.7 1.9c1.8.8 23.2 8 27.3 1.2 4.2-6.8 8.4-17.9 8.4-17.9s-4.7-8.4-15.1-8.4c-10.6 0-20.8 6.7-27.7 11.7-6.8 5-15.4 11.8-38.2 11.8s-31.6-6.8-38.4-11.8c-6.9-5-17.1-11.7-27.6-11.7s-15.2 8.4-15.2 8.4 4.2 11 8.4 18c4.1 6.7 25.5-.5 27.4-1.4l-2.7-1.8S261 348 257 348s-10.9-1.8-10.6-6c.2-2.8 4.8-3.8 8-4.1 2.7-.2 6.2.2 22.9 11.4a72 72 0 0 0 42.2 12.6z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M271.3 345.4S260.9 348 257 348c-4 0-10.9-1.8-10.6-6 .2-2.8 4.8-3.8 8-4.1 2.3-.2 5.3 0 17 7.5zm96.2 0S378 348 382 348c3.9 0 10.7-1.8 10.4-6-.2-2.8-4.8-3.8-7.9-4.1-2.3-.2-5.4 0-17 7.5zm-83.4-9.3a92.6 92.6 0 0 1-3.1-2.3c-1.5-1.1-3-2-4.5-3.2 0 0 2.1-2.7 3.2-3 1.7-.6 3.7.3 4.1 3.8.3 2.8.3 4.7.3 4.7z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M284.1 336s0-1.9-.3-4.6c-.4-3.5-2.4-4.4-4-3.9-1.2.4-3.3 3-3.3 3v.1a31.9 31.9 0 0 0-3-1.8 18 18 0 0 1 6.3-3.6c1 0 14.5 5.4 18.8 9.1 1 1 1.8 7 1.2 9a46.6 46.6 0 0 1-15.7-7.2m-6.5 13.6s-2.9 3-3 8.3c0 6.3 4.5 6.6 7.5 6.5 3.7 0 6.6-2.1 6.5-8.9 0 0-6-2.5-11-6z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M280.1 351.1s-2.3 2.5-2.7 6.5c-.2 3.1 1.8 4.9 4.5 4.7 3.7-.2 5.1-5.3 3.4-8.1l-5.2-3"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M277 363.7c1.8 1 3.9 1 5.2.8 3.6 0 6.5-2.1 6.4-8.9 0 0 4.5 2.3 11.8 4 0 0 1.2 1.5 1.4 4.5.3 2.4-1.4 5-3.3 4.8L282 366c-3.7-.7-5-2.3-5-2.3zm77.7-27.6 3.3-2.3c1.3-1.1 2.8-2 4.4-3.2 0 0-2.2-2.7-3.3-3-1.6-.6-3.6.3-4 3.8z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "m354.7 336 .4-4.6c.4-3.5 2.4-4.4 4-3.9 1 .4 3.2 3 3.2 3v.1a31.9 31.9 0 0 1 3-1.8c-.7-.9-5.2-3.6-6.2-3.6s-14.5 5.4-18.8 9.1c-1 1-1.8 7-1.3 9a45.7 45.7 0 0 0 15.7-7.2m6.5 13.6s2.9 3 3 8.3c.2 6.3-4.5 6.6-7.5 6.5-3.6 0-6.5-2.1-6.5-8.9 0 0 6-2.5 11-6z"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M358.7 351.1s2.4 2.5 2.8 6.5c.3 3.1-1.9 4.9-4.5 4.7-3.7-.2-5.1-5.3-3.4-8.1l5.1-3"
        }),
        /* @__PURE__ */ jsx54("path", {
          d: "M361.9 363.7c-2 1-4 1-5.2.8-3.6 0-6.5-2.1-6.5-8.9 0 0-4.5 2.3-11.7 4 0 0-1.3 1.5-1.5 4.5-.2 2.4 1.5 5 3.4 4.8l16.5-2.9c3.6-.7 5-2.3 5-2.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7,
      d: "M299.6 361.4s3.3 2.4-.7 5.3m-9-6.8 10 4.3m-8.3-2.1 7.2 3.1m-4.6-5 5.4 2.5m39.7-1.3s-3.3 2.4.6 5.3m9-6.8-10 4.3m8.4-2.1-7.2 3.1m4.6-5-5.4 2.5"
    }),
    /* @__PURE__ */ jsx54("path", {
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M261 331.4c.2.2.2.4.3.7a2.5 2.5 0 0 1 0 .8 2.4 2.4 0 0 1-1.2 1.6 3 3 0 0 1-2.2.4 3.7 3.7 0 0 1-1-.4 4.3 4.3 0 0 1-1-.6l-.3.4-.4-.1.4-2.9.5.1c0 .4 0 .7.2 1l.3 1 .7.6c.2.2.5.3.9.4h.7a1.2 1.2 0 0 0 .9-.6 1.8 1.8 0 0 0 .2-.6 1.7 1.7 0 0 0-.1-1 1.8 1.8 0 0 0-.7-.7 48.3 48.3 0 0 0-.8-.5l-.8-.6c-.5-.3-.8-.6-1-1-.2-.4-.2-.8-.1-1.4 0-.3.2-.6.4-.8a2.5 2.5 0 0 1 1.5-1 2.9 2.9 0 0 1 1 0l1 .4.8.6.3-.4.5.1-.5 2.8-.5-.1a11.2 11.2 0 0 0 0-1 3.6 3.6 0 0 0-.4-.8 2 2 0 0 0-.5-.7 2 2 0 0 0-.8-.4 1.4 1.4 0 0 0-1 .2c-.4.2-.6.5-.6.8v1l.7.7.8.5a14.1 14.1 0 0 1 1.3 1c.2 0 .4.3.5.5m12 1.6-.5-.1a1.4 1.4 0 0 0-.5-.1c-.2 0-.4.1-.5.3a5.7 5.7 0 0 0-.6 1l-1.8 3.1a2.4 2.4 0 0 1-1.9 1.3h-1.1a4.2 4.2 0 0 1-1-.5 4.3 4.3 0 0 1-1-.8 3 3 0 0 1-.7-1 2.2 2.2 0 0 1-.1-1 2 2 0 0 1 .2-.8l2.4-4.3a.9.9 0 0 0 .1-.4v-.3a1.5 1.5 0 0 0-.3-.3l-.4-.3.2-.3 3.1 1.7-.2.3-.3-.1a2 2 0 0 0-.4-.1h-.4a.9.9 0 0 0-.2.3l-2.2 4a3.3 3.3 0 0 0-.3.7 1.8 1.8 0 0 0 0 .8c0 .2 0 .5.2.7l.9.8 1 .3a1.9 1.9 0 0 0 1.5-.5l.5-.6 1.6-3 .5-1v-.6c0-.2-.2-.3-.4-.5a3.6 3.6 0 0 0-.4-.3l.2-.4 3 1.7a19.2 19.2 0 0 1-.2.3m4.3 7.5a1.9 1.9 0 0 1 0 1.8 2 2 0 0 1-.8.8 2.2 2.2 0 0 1-1 .3l-1-.1a4 4 0 0 1-.9-.4l-3.5-2 .2-.4a5 5 0 0 0 .8.3.5.5 0 0 0 .3 0 .7.7 0 0 0 .3-.3l3-5.3a1 1 0 0 0 .1-.3.6.6 0 0 0-.1-.4 1.7 1.7 0 0 0-.3-.3l-.3-.2.2-.4 3.4 2 .7.5.6.7a1.6 1.6 0 0 1 0 1.6 1.8 1.8 0 0 1-.6.6l-.7.3a2.5 2.5 0 0 1-.7 0 3.3 3.3 0 0 1-.8-.2v.1a5 5 0 0 1 .6.6zm-.6-1.8c.2 0 .4-.2.5-.3a2.7 2.7 0 0 0 .5-.6c.2-.4.3-.8.2-1.2-.1-.3-.4-.6-.9-.9l-.4-.2-.4-.3-1.6 2.8.6.4.8.3zm-.6 2.7c.2-.4.3-.8.1-1.3 0-.4-.4-.8-1-1.1a29 29 0 0 0-.5-.4l-.4-.1-1.5 2.5a.6.6 0 0 0 0 .7c.1.2.4.4.7.5.5.3 1 .4 1.4.3.5-.2.8-.5 1.2-1zm18.9 4.3a3.5 3.5 0 0 0-.5 0 1.4 1.4 0 0 0-.6-.1c-.1 0-.3.1-.4.4a5.9 5.9 0 0 0-.5 1l-1.5 3.3c-.1.4-.4.7-.7 1a2.6 2.6 0 0 1-1 .4 3.2 3.2 0 0 1-1.1 0 4.3 4.3 0 0 1-2.2-1 3.1 3.1 0 0 1-.7-.8 2.2 2.2 0 0 1-.3-1 2 2 0 0 1 .2-.9l2-4.5a.9.9 0 0 0 0-.4.7.7 0 0 0-.1-.3 1.6 1.6 0 0 0-.3-.3l-.4-.2.2-.4 3.3 1.4-.2.4a3.5 3.5 0 0 0-.4-.1 2.3 2.3 0 0 0-.4 0h-.3a1 1 0 0 0-.2.3l-1.9 4.3-.2.7a1.7 1.7 0 0 0 .4 1.4c.2.3.5.5 1 .7l1 .2a1.9 1.9 0 0 0 1.5-.7 2.5 2.5 0 0 0 .4-.6l1.3-3.1.3-1v-.7l-.4-.4a3.7 3.7 0 0 0-.5-.3l.2-.4 3.1 1.4-.1.3m9.2 10.8-3.6-1v-.4a9 9 0 0 0 .6 0l.4.1a.8.8 0 0 0 .4-.2.7.7 0 0 0 .2-.3l1.7-5.8a1.4 1.4 0 0 0-.1 0l-4.8 6h-.3l-.6-7.9-1.5 4.8-.2 1.1.1.6.5.4a3.2 3.2 0 0 0 .5.3l-.2.4-3.2-1v-.4h.6a1 1 0 0 0 .5 0c.2 0 .3-.2.5-.4l.3-1 1.2-4.2a1.7 1.7 0 0 0 .1-.6 1 1 0 0 0-.1-.4 1.2 1.2 0 0 0-.4-.4 2 2 0 0 0-.5-.2l.1-.4 2.8.8.6 6.7 3.5-4.5.3-.5a2.8 2.8 0 0 0 .2-.4l2.7.8-.1.4a3.9 3.9 0 0 0-.5 0 2.4 2.4 0 0 0-.4-.1.4.4 0 0 0-.3.1 1 1 0 0 0-.1.4l-1.7 5.8a.8.8 0 0 0 0 .3l.1.3a3.4 3.4 0 0 0 .8.4l-.1.4m8.7-2.6a1.9 1.9 0 0 1 .7 1.7l-.4 1c-.2.3-.5.4-.8.6-.3.2-.6.2-1 .3h-1l-4-.5v-.4h.5a1.7 1.7 0 0 0 .4 0 .5.5 0 0 0 .3-.2.7.7 0 0 0 .1-.4l.8-6a1 1 0 0 0 0-.3.6.6 0 0 0-.3-.3 1.7 1.7 0 0 0-.4-.2h-.3v-.5l3.9.5c.3 0 .6 0 .9.2l.7.4a1.6 1.6 0 0 1 .6 1.5l-.2.8a1.7 1.7 0 0 1-.6.5 2.6 2.6 0 0 1-.6.3 3.4 3.4 0 0 1-.8.2l.8.3zm-1.3-1.5.4-.5.2-.7a1.5 1.5 0 0 0-.3-1.1c-.2-.3-.6-.5-1.1-.5a27.3 27.3 0 0 0-1-.1l-.4 3.2h.8c.3.1.6 0 .8 0a1.3 1.3 0 0 0 .6-.3zm.5 2.8c0-.5 0-1-.3-1.3-.3-.3-.8-.5-1.4-.6l-.7-.1h-.4l-.3 2.9a.6.6 0 0 0 .2.6l.8.3c.6 0 1 0 1.5-.4.3-.3.5-.7.6-1.4zm11.4 2.6h-2.2a44 44 0 0 0-1.4-2l-1.3-1.8h-1v2.7l.1.4.3.2h.4l.5.1v.4h-3.6v-.4h.4l.4-.1a.5.5 0 0 0 .2-.2.7.7 0 0 0 .1-.4v-6.4l-.3-.3a2.2 2.2 0 0 0-.4 0l-.4-.1v-.4h4.9a2.8 2.8 0 0 1 .9.4l.6.6a2.3 2.3 0 0 1 0 1.8 2 2 0 0 1-.4.7 2.5 2.5 0 0 1-.7.4 5.3 5.3 0 0 1-.8.3l1 1.4c.3.4.7.8 1 1.4a2.5 2.5 0 0 0 1 .8 3 3 0 0 0 .8.1zm-3.1-6.2c0-.5-.2-1-.4-1.2-.3-.3-.8-.5-1.3-.5h-1v3.6h.8c.5 0 1-.1 1.3-.5.4-.3.6-.8.6-1.4zm13 5.6-3.6.3v-.4l.7-.2c.2 0 .3-.2.3-.2v-.2a.5.5 0 0 0 0-.1l-.9-1.8-3 .2a9.6 9.6 0 0 0-.2.7l-.1.6a3.4 3.4 0 0 0-.1.4v.3c0 .2.1.3.4.3l.9.1v.4l-3.2.3v-.4a2 2 0 0 0 .4-.1 1.3 1.3 0 0 0 .7-.6l.2-.5 1.1-3.6 1.1-3.6h.5l3.4 7 .2.3a1.2 1.2 0 0 0 .7.4h.4v.4zm-3.7-3.1-1.6-3.2-1 3.4zm15.7-6.7a27.9 27.9 0 0 0-.4.2 3.1 3.1 0 0 0-.8-.9c-.4-.2-.7-.4-1-.3a6.3 6.3 0 0 0-.3 0l-.6.2-1.4.4.9 3.2 1-.2.6-.3.3-.4.1-.4v-.6l.4-.2.9 3.2-.4.1a2.9 2.9 0 0 0-.3-.5l-.4-.4a.9.9 0 0 0-.5-.2 2.3 2.3 0 0 0-.6.1l-1 .3.8 2.8s0 .2.2.3a.6.6 0 0 0 .3.2h.4l.4-.1.1.4-3.5 1-.1-.4a9.5 9.5 0 0 0 .4-.2l.4-.2a.5.5 0 0 0 .2-.3.8.8 0 0 0 0-.3l-1.6-5.9a1.1 1.1 0 0 0-.2-.3l-.3-.2a2.4 2.4 0 0 0-.4 0 2.4 2.4 0 0 0-.5 0l-.1-.3 6.4-1.8.6 2m9.4-.7 1 2.4-6 2.8-.2-.3.4-.3a1.4 1.4 0 0 0 .3-.2.5.5 0 0 0 .1-.3.8.8 0 0 0 0-.4l-2.7-5.4a1 1 0 0 0-.2-.3.5.5 0 0 0-.4 0h-.4a2 2 0 0 0-.4 0l-.2-.3 3.3-1.6.2.4a2.8 2.8 0 0 0-.4.2 2.2 2.2 0 0 0-.3.3.4.4 0 0 0-.2.3.8.8 0 0 0 .1.4l2.5 5c0 .3.2.5.3.6l.3.2h.4l.7-.3.4-.2.4-.3.3-.2a.6.6 0 0 0 .2-.3 6.3 6.3 0 0 0 .2-2l.3-.2m4.5-8.3a4.2 4.2 0 0 1 1.5.8l1.2 1.4a5 5 0 0 1 .6 1.7 4.1 4.1 0 0 1 0 1.6 4 4 0 0 1-.7 1.5 4 4 0 0 1-1.2 1 4 4 0 0 1-3.2.4 4 4 0 0 1-1.4-.7 5 5 0 0 1-1.2-1.4 5 5 0 0 1-.6-1.7 4.3 4.3 0 0 1 0-1.7 4 4 0 0 1 2-2.4 4 4 0 0 1 1.5-.6 3.9 3.9 0 0 1 1.5.1zm2.3 5.6a4 4 0 0 0-.2-1.3 7 7 0 0 0-.7-1.4 7.2 7.2 0 0 0-1-1.3 4 4 0 0 0-1-.8 2.4 2.4 0 0 0-1-.2c-.5 0-.8.1-1.2.3-.4.3-.7.6-.9 1a2.6 2.6 0 0 0-.3 1c0 .5.1.9.3 1.3a7.2 7.2 0 0 0 1.5 2.6c.3.4.7.6 1 .8a2.4 2.4 0 0 0 1.2.3c.3 0 .7 0 1.1-.3a2.3 2.3 0 0 0 1.2-2zm10.5-5.7-1.9 1.3-2.3-.9-2-.6-.8.5 1.6 2.1.2.3h.4a1.8 1.8 0 0 0 .3-.1l.4-.3.3.4-3 2-.2-.3a8.6 8.6 0 0 0 .6-.5.5.5 0 0 0 0-.4.7.7 0 0 0 0-.3l-3.6-5a1 1 0 0 0-.2-.2.3.3 0 0 0-.4 0 3 3 0 0 0-.7.3l-.3-.4 3.2-2.2a4.6 4.6 0 0 1 .9-.5 2.7 2.7 0 0 1 .9-.2l.8.1a2.2 2.2 0 0 1 1.1 1.4v.8a2.5 2.5 0 0 1-.2.7 4.9 4.9 0 0 1-.5.8l1.6.5 1.6.5a2.5 2.5 0 0 0 1.2.1h.4a2.6 2.6 0 0 0 .4-.3zm-6.2-3.3c-.3-.4-.6-.6-1-.7-.4-.1-.9 0-1.3.3l-.8.6 2 3 .7-.5c.4-.3.7-.7.8-1.2 0-.5 0-1-.4-1.5zm13.2-2 .7 2.4-6.6 2.4-.2-.4a4.3 4.3 0 0 0 .8-.4.6.6 0 0 0 .2-.3.7.7 0 0 0 0-.4l-2.2-5.6a1 1 0 0 0-.1-.3l-.4-.1h-.4a2.2 2.2 0 0 0-.5 0l-.1-.3 6.1-2.3.7 1.9-.4.1a2.7 2.7 0 0 0-.8-.7l-.9-.3a4.3 4.3 0 0 0-.4.2l-.6.2-1.2.4 1.1 3.1 1-.3c.2 0 .4-.2.5-.3a.9.9 0 0 0 .3-.4v-1.1l.4-.1 1.1 3-.4.2a3.2 3.2 0 0 0-.3-.5 1.5 1.5 0 0 0-.4-.3.9.9 0 0 0-.5-.2c-.2 0-.4 0-.6.2l-.9.3.9 2.4.2.5a.5.5 0 0 0 .3.3h.5l.7-.3.5-.2a3.9 3.9 0 0 0 1-.4l.2-.3.2-1v-1l.5-.1m7.1-5.8c.4.3.8.7 1 1.3.3.5.5 1 .6 1.7a4.9 4.9 0 0 1 0 1.8 4.1 4.1 0 0 1-.8 1.5 3.9 3.9 0 0 1-2.7 1.6 3.9 3.9 0 0 1-3-.9 4.1 4.1 0 0 1-1-1.2 4.9 4.9 0 0 1-.6-1.7 5 5 0 0 1 0-1.9l.8-1.5a4 4 0 0 1 2.7-1.5 4 4 0 0 1 1.6 0zm-.1 6c.2-.4.3-.8.3-1.3v-1.5a7 7 0 0 0-.4-1.5 3.9 3.9 0 0 0-.7-1.2 2.4 2.4 0 0 0-.9-.7 2.3 2.3 0 0 0-1.1-.1c-.5 0-1 .2-1.2.5-.3.2-.6.6-.7 1a4 4 0 0 0-.3 1.2 7 7 0 0 0 .4 3l.7 1.1c.2.4.5.6.9.7.3.2.7.2 1.2.2a2.3 2.3 0 0 0 1-.5 2.4 2.4 0 0 0 .8-1z"
    }),
    /* @__PURE__ */ jsx54("path", {
      fill: "none",
      stroke: "#000",
      d: "M366 205.1v53c0 10.6-1.4 52.6-46.5 69-45.3-16.4-46.7-58.4-46.7-69v-53H366"
    })
  ]
});
var Bz_default = SvgBz;

// src/country-flag-icons/generated/Ca.tsx
import { jsx as jsx55, jsxs as jsxs48 } from "react/jsx-runtime";
var SvgCa = (props) => /* @__PURE__ */ jsxs48("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx55("path", {
      fill: "#fff",
      d: "M150.1 0h339.7v480H150z"
    }),
    /* @__PURE__ */ jsx55("path", {
      fill: "#d52b1e",
      d: "M-19.7 0h169.8v480H-19.7zm509.5 0h169.8v480H489.9zM201 232l-13.3 4.4 61.4 54c4.7 13.7-1.6 17.8-5.6 25l66.6-8.4-1.6 67 13.9-.3-3.1-66.6 66.7 8c-4.1-8.7-7.8-13.3-4-27.2l61.3-51-10.7-4c-8.8-6.8 3.8-32.6 5.6-48.9 0 0-35.7 12.3-38 5.8l-9.2-17.5-32.6 35.8c-3.5.9-5-.5-5.9-3.5l15-74.8-23.8 13.4c-2 .9-4 .1-5.2-2.2l-23-46-23.6 47.8c-1.8 1.7-3.6 1.9-5 .7L264 130.8l13.7 74.1c-1.1 3-3.7 3.8-6.7 2.2l-31.2-35.3c-4 6.5-6.8 17.1-12.2 19.5-5.4 2.3-23.5-4.5-35.6-7 4.2 14.8 17 39.6 9 47.7"
    })
  ]
});
var Ca_default = SvgCa;

// src/country-flag-icons/generated/Cc.tsx
import { jsx as jsx56, jsxs as jsxs49 } from "react/jsx-runtime";
var SvgCc = (props) => /* @__PURE__ */ jsxs49("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs49("defs", {
      children: [
        /* @__PURE__ */ jsx56("path", {
          id: "cc_svg__a",
          d: "m0-360 69.4 215.8 212-80.3L156-35.6 351 80.1 125 99.8l31.1 224.6L0 160l-156.2 164.3 31.1-224.5L-351 80l195-115.7-125.5-188.9 212 80.3z"
        }),
        /* @__PURE__ */ jsx56("path", {
          id: "cc_svg__b",
          d: "M0-210 54.9-75.5l144.8 10.6-111 93.8 34.7 141L0 93.3-123.4 170l34.6-141-111-93.8 145-10.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx56("path", {
      fill: "green",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx56("circle", {
      cx: 320,
      cy: 240,
      r: 66.7,
      fill: "#ffe000"
    }),
    /* @__PURE__ */ jsx56("circle", {
      cx: 340.8,
      cy: 240,
      r: 54.9,
      fill: "green"
    }),
    /* @__PURE__ */ jsx56("circle", {
      cx: 109.8,
      cy: 173.3,
      r: 69.8,
      fill: "#ffe000"
    }),
    /* @__PURE__ */ jsx56("path", {
      fill: "#802000",
      stroke: "#7b3100",
      strokeWidth: 1.5,
      d: "M105 226h17.5s.7-1.6-.2-2.4c-1-.8-4.7-1-3.7-3.8 2-5.8 2.4-4 3.7-17.8a739 739 0 0 0 2-35.5h-2.6s.5 6.7-1 15.5c-1.4 8.8-1.9 9.5-3.5 16.3a63.5 63.5 0 0 1-3.3 11.2c-1.4 4-1.6 4.1-3.8 7.8-2.3 3.6-1.5 2.2-2.7 4.4-.7 1.1-1.4.8-1.9 1.6-.4.8-.5 2.7-.5 2.7z"
    }),
    /* @__PURE__ */ jsx56("path", {
      fill: "green",
      d: "M118.3 122.5a23 23 0 0 1-1.2 9.2 26.5 26.5 0 0 0-2.3 9.8c-1.8.6-3.7-3.9-5.5-1.2 1.3 3.7 4.4 6.6 6.4 9.9.4 1 3.4 3.7 1.6 4.3-4.3-1.5-5.4-7-8-10.3a19 19 0 0 0-15.5-10c-2.5.1-10.4-.5-8.4 3.7 3 2 6.8 3.4 9.8 5.7 2.3.2 6.3 4 6.1 5.4-4-1.6-5.8-3.5-10-5.2-5.8-2.2-13.7-.9-17 4.8-.5 1.5-1.4 5.8.5 6.3 2.2-3.4 5.3-7.3 9.9-6.2 3.6.3-4 6.7-1.1 5.4 1-.4 3-1.8 4.6-2 1.5 0 2.3 1 3.4 1.2 2.3.3 3 1.2 2.7 1.8-.2.6-1 0-3.3.8-1.1.4-1.7 1.4-3 1.9-1.4.4-4.2.5-5.2 0-3.7-1.5-9.7-1.3-10.8 3.3 0 2-1.8-.2-2.6.7-.7 2.2-.8 4.4-4 4.2-2 2-4 4.2-6.6 5.7 1.5 3.4 7.3-3.4 7-.5-2.5 3.5 1.4 4.2 3 1.5 2.9-3 6.5-6.7 10.7-3.6 2 1.9 3.2-1 4.7-1 1 2.5 2.1.2 3.2-.5 1.7-.2 1.2 2.2 3.2.7 4.1-2.7 9.1-.4 13.1-3 4.3-2 .6 1.5-.5 2.9-1.9 3.6-.3 8.4-4.3 10.6-1.7 4.3 1.9 10-1.7 13.2-.5 2 4.6 1.8 6 2.6 2.6 0 0-5.8 2.5-6.6 3.4 2 3.2-3.8 2.5-5.6.4-4 .6-8.6 2.6-12.3 2.2-4.5 4.2 1.9 1.8 3.7-1.4 4.1-3.4 9.4-.3 13.3 1 .2 1.7 2.4 2.8 3 1.2.7 2.8-.1 3-2.1 1.6-6 .8-12.4 3-18.3 1.5-1.8 3.6-.3 4.5 1.4 3 3.5 5.1 7.8 8.7 10.7a15 15 0 0 1 7.8 7.3c0 2.6 7.4 3 5.2 0-2.1-2.7-.7-5.6 1.4-7.5 1.2.3.9-1.8 0-1-1.5-.3-1.6-3 .4-1.7 3.5 1.1-.2-2.5-1.5-2.6-2.9-1.8-6.2-3.8-7.6-7 3.8 0 7.7 2.1 11.5.9 3.1-1.6 6.2 0 7.3 2.8 2.4-.4 1.4-2.8 0-3.6 1.7-.7 3-2.2.8-3.5-1-1.4 1.5-4-1.7-3.8.1-2.5-.8-4.7-3.5-5.6-2.7-2.2-10.6 3.4-10.3-1.7-.8-2.8 3.2-.4 4.3-1.8 1.1-3-5.5-2.6-3.3-5 1.4-.8 8.1-2.1 2.9-3.1a8.3 8.3 0 0 1-7-1.1c-1.9 3.1-7.2-1.8-6.3 3.8-.7 2.1-5.5 7.6-6.8 3.4 1-3.3 6.8-4.3 5-8.8-.3-2.7-2.6.5-3.6.3-.6-1.7 1.6-3.8 3.2-4.2 3 2.4 3-3 6-2.5 2.1-.5-.7-1.4-1.3-1.8.6-1.5 3.9-2.3.7-3.7-2.9-2-5 2.1-7.3 2.3-2.2-2.5 2-3.7 3.2-5 .1-1-2.4-.3-1.7-1.2.7-1.1 5.2-1.2 3-3a14.7 14.7 0 0 0-10.2.6c-2 .6-2.5 5-4.2 4.8-.7-2 .3-5.8-2.4-6.3m15 42.3c2.4-.4 0 3.7-1 3.6 0-1.4-3.6-1.3-1.3-2.6a7.3 7.3 0 0 1 2.3-1"
    }),
    /* @__PURE__ */ jsxs49("g", {
      fill: "#ffe000",
      transform: "translate(0 80) scale(.0635)",
      children: [
        /* @__PURE__ */ jsx56("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 7560,
          y: 4200
        }),
        /* @__PURE__ */ jsx56("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 6300,
          y: 2205
        }),
        /* @__PURE__ */ jsx56("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 7560,
          y: 840
        }),
        /* @__PURE__ */ jsx56("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 8680,
          y: 1869
        }),
        /* @__PURE__ */ jsx56("use", {
          xlinkHref: "#cc_svg__b",
          width: "100%",
          height: "100%",
          x: 8064,
          y: 2730
        })
      ]
    })
  ]
});
var Cc_default = SvgCc;

// src/country-flag-icons/generated/Cd.tsx
import { jsx as jsx57, jsxs as jsxs50 } from "react/jsx-runtime";
var SvgCd = (props) => /* @__PURE__ */ jsxs50("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx57("path", {
      fill: "#007fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx57("path", {
      fill: "#f7d618",
      d: "M28.8 96H96l20.8-67.2L137.6 96h67.2l-54.4 41.6 20.8 67.2-54.4-41.6-54.4 41.6 20.8-67.2zM600 0 0 360v120h40l600-360V0z"
    }),
    /* @__PURE__ */ jsx57("path", {
      fill: "#ce1021",
      d: "M640 0 0 384v96L640 96z"
    })
  ]
});
var Cd_default = SvgCd;

// src/country-flag-icons/generated/Cf.tsx
import { jsx as jsx58, jsxs as jsxs51 } from "react/jsx-runtime";
var SvgCf = (props) => /* @__PURE__ */ jsxs51("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx58("defs", {
      children: /* @__PURE__ */ jsx58("clipPath", {
        id: "cf_svg__a",
        children: /* @__PURE__ */ jsx58("path", {
          fillOpacity: 0.7,
          d: "M-12.4 32h640v480h-640z"
        })
      })
    }),
    /* @__PURE__ */ jsxs51("g", {
      fillRule: "evenodd",
      clipPath: "url(#cf_svg__a)",
      transform: "translate(12.4 -32)",
      children: [
        /* @__PURE__ */ jsx58("path", {
          fill: "#00f",
          d: "M-52 32h719.3v119H-52z"
        }),
        /* @__PURE__ */ jsx58("path", {
          fill: "#ff0",
          d: "M-52 391.6h719.3V512H-52z"
        }),
        /* @__PURE__ */ jsx58("path", {
          fill: "#009a00",
          d: "M-52 271.3h719.3v120.3H-52z"
        }),
        /* @__PURE__ */ jsx58("path", {
          fill: "#fff",
          d: "M-52 151h719.3v120.3H-52z"
        }),
        /* @__PURE__ */ jsx58("path", {
          fill: "red",
          d: "M247.7 32.5h119.9V512H247.7z"
        }),
        /* @__PURE__ */ jsx58("path", {
          fill: "#ff0",
          d: "m99.3 137.7-31.5-21.8-31.3 22L47.4 101 16.9 78l38.2-1 12.5-36.3L80.3 77l38.1.7L88.2 101"
        })
      ]
    })
  ]
});
var Cf_default = SvgCf;

// src/country-flag-icons/generated/Cg.tsx
import { jsx as jsx59, jsxs as jsxs52 } from "react/jsx-runtime";
var SvgCg = (props) => /* @__PURE__ */ jsxs52("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx59("defs", {
      children: /* @__PURE__ */ jsx59("clipPath", {
        id: "cg_svg__a",
        children: /* @__PURE__ */ jsx59("path", {
          fillOpacity: 0.7,
          d: "M-79.5 32h640v480h-640z"
        })
      })
    }),
    /* @__PURE__ */ jsxs52("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#cg_svg__a)",
      transform: "translate(79.5 -32)",
      children: [
        /* @__PURE__ */ jsx59("path", {
          fill: "#ff0",
          d: "M-119.5 32h720v480h-720z"
        }),
        /* @__PURE__ */ jsx59("path", {
          fill: "#00ca00",
          d: "M-119.5 32v480l480-480z"
        }),
        /* @__PURE__ */ jsx59("path", {
          fill: "red",
          d: "M120.5 512h480V32z"
        })
      ]
    })
  ]
});
var Cg_default = SvgCg;

// src/country-flag-icons/generated/Ch.tsx
import { jsx as jsx60, jsxs as jsxs53 } from "react/jsx-runtime";
var SvgCh = (props) => /* @__PURE__ */ jsx60("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs53("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx60("path", {
        fill: "red",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsxs53("g", {
        fill: "#fff",
        children: [
          /* @__PURE__ */ jsx60("path", {
            d: "M170 195h300v90H170z"
          }),
          /* @__PURE__ */ jsx60("path", {
            d: "M275 90h90v300h-90z"
          })
        ]
      })
    ]
  })
});
var Ch_default = SvgCh;

// src/country-flag-icons/generated/Ci.tsx
import { jsx as jsx61, jsxs as jsxs54 } from "react/jsx-runtime";
var SvgCi = (props) => /* @__PURE__ */ jsx61("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs54("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx61("path", {
        fill: "#00cd00",
        d: "M426.8 0H640v480H426.8z"
      }),
      /* @__PURE__ */ jsx61("path", {
        fill: "#ff9a00",
        d: "M0 0h212.9v480H0z"
      }),
      /* @__PURE__ */ jsx61("path", {
        fill: "#fff",
        d: "M212.9 0h214v480h-214z"
      })
    ]
  })
});
var Ci_default = SvgCi;

// src/country-flag-icons/generated/Ck.tsx
import { jsx as jsx62, jsxs as jsxs55 } from "react/jsx-runtime";
var SvgCk = (props) => /* @__PURE__ */ jsxs55("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx62("path", {
      fill: "#006",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx62("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m471.6 213 5.2-16.7-14-10.6 17.6-.2 6-16.5 5.6 16.5 17.7.5-14.1 10.5 5 16.7-14.5-10m27.1 13 10.4-13.9-9.7-14.8 16.7 5.8 11-13.5v17.6l16.4 6.4-16.8 5-.8 17.5-10.2-14.4m-98.4 15-.7-17.5-16.8-5.2L431 198v-17.4l10.9 13.5 16.8-5.6-9.8 14.7 10.3 14-17-4.5m-39.6 40.9-7.4-15.8-17.4 1.8 12.8-12.3L384 211l15.2 8.2 13.3-11.8-3.4 17.4 14.9 8.9-17.3 2.5M389 291.8l-13.3-11.1-15 9.2 6.4-16.7-12.9-11.6 17.3.7 7-16.4 4.3 17.2 17.2 1.5-14.6 9.8m3.2 60.4-16.5-4.8-10.1 14.5-.7-17.9-16.4-5.5 16.1-6.2v-18l10.7 14.1 16.4-5.6-9.6 15m29.5 50.8-17 2.4-3.5 17.4-7.8-16-17.1 1.6 12.2-12.3-7.1-16.4 15.3 8.5 12.8-11.8L393 362m45 38-15.1 8.2 2.6 17.6-12.7-12.4-15.6 7.6 7.3-15.9-12.3-12.9 17.3 2.6 8-15.5 3.4 17.4m53.8 9-8.3 15.3 11.7 13.2-17.4-3.3-8.9 15-2.4-17.3-17.2-4 15.8-7.4-1.7-17.5 12.2 12.8m57.4-13.1-.5 17.4 16.3 6.4-17 5-1.2 17.5-10-14.3-17 4.4 10.8-13.9-9.4-14.7 16.6 5.7M559 209.8l12 12.6 15.9-7.4-8.3 15.8 11.5 13.1-17-2.8-9 15.5L562 239l-17-3.5 15.7-8m34.2 21 5.5 16.6 17.5.3-14.2 10.7 4.7 16.8-14.1-10-14.6 10.1 5.4-16.8-13.8-10.6 17.6-.4m19.5 33.2-2 17.4 15.7 7.7-17.3 3.6-2.7 17.3-8.7-15.1-17.4 2.9 12-13-8.1-15.5 16 7.2m3 39.8-7.8 15.6L603 379l-17.4-2.7-8.4 15.3-3-17.3-17.4-3.3 15.6-8-2.3-17.4 12.6 12.3m-9.8 39.1-14.7 9.2 3.8 17.3-13.5-11.5-15 8.6 6.3-16.3-13.1-12.1 17.4 1.5 7-16 4.4 17.2"
    }),
    /* @__PURE__ */ jsx62("path", {
      fill: "#006",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx62("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx62("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx62("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx62("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Ck_default = SvgCk;

// src/country-flag-icons/generated/Cl.tsx
import { jsx as jsx63, jsxs as jsxs56 } from "react/jsx-runtime";
var SvgCl = (props) => /* @__PURE__ */ jsxs56("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx63("defs", {
      children: /* @__PURE__ */ jsx63("clipPath", {
        id: "cl_svg__a",
        children: /* @__PURE__ */ jsx63("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs56("g", {
      fillRule: "evenodd",
      clipPath: "url(#cl_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx63("path", {
          fill: "#fff",
          d: "M256 0h512v256H256z"
        }),
        /* @__PURE__ */ jsx63("path", {
          fill: "#0039a6",
          d: "M0 0h256v256H0z"
        }),
        /* @__PURE__ */ jsx63("path", {
          fill: "#fff",
          d: "M167.8 191.7 128.2 162l-39.5 30 14.7-48.8L64 113.1l48.7-.5L127.8 64l15.5 48.5 48.7.1-39.2 30.4z"
        }),
        /* @__PURE__ */ jsx63("path", {
          fill: "#d52b1e",
          d: "M0 256h768v256H0z"
        })
      ]
    })
  ]
});
var Cl_default = SvgCl;

// src/country-flag-icons/generated/Cm.tsx
import { jsx as jsx64, jsxs as jsxs57 } from "react/jsx-runtime";
var SvgCm = (props) => /* @__PURE__ */ jsxs57("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx64("path", {
      fill: "#007a5e",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx64("path", {
      fill: "#ce1126",
      d: "M213.3 0h213.4v480H213.3z"
    }),
    /* @__PURE__ */ jsx64("path", {
      fill: "#fcd116",
      d: "M426.7 0H640v480H426.7z"
    }),
    /* @__PURE__ */ jsxs57("g", {
      fill: "#fcd116",
      transform: "translate(320 240) scale(7.1111)",
      children: [
        /* @__PURE__ */ jsxs57("g", {
          id: "cm_svg__b",
          children: [
            /* @__PURE__ */ jsx64("path", {
              id: "cm_svg__a",
              d: "M0-8-2.5-.4 1.3.9z"
            }),
            /* @__PURE__ */ jsx64("use", {
              xlinkHref: "#cm_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx64("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx64("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        }),
        /* @__PURE__ */ jsx64("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        }),
        /* @__PURE__ */ jsx64("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        })
      ]
    })
  ]
});
var Cm_default = SvgCm;

// src/country-flag-icons/generated/Cn.tsx
import { jsx as jsx65, jsxs as jsxs58 } from "react/jsx-runtime";
var SvgCn = (props) => /* @__PURE__ */ jsxs58("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx65("defs", {
      children: /* @__PURE__ */ jsx65("path", {
        id: "cn_svg__a",
        fill: "#ff0",
        d: "M-.6.8 0-1 .6.8-1-.3h2z"
      })
    }),
    /* @__PURE__ */ jsx65("path", {
      fill: "#ee1c25",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx65("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(71.9991 0 0 72 120 120)"
    }),
    /* @__PURE__ */ jsx65("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
    }),
    /* @__PURE__ */ jsx65("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
    }),
    /* @__PURE__ */ jsx65("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
    }),
    /* @__PURE__ */ jsx65("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
    })
  ]
});
var Cn_default = SvgCn;

// src/country-flag-icons/generated/Co.tsx
import { jsx as jsx66, jsxs as jsxs59 } from "react/jsx-runtime";
var SvgCo = (props) => /* @__PURE__ */ jsx66("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs59("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx66("path", {
        fill: "#ffe800",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx66("path", {
        fill: "#00148e",
        d: "M0 240h640v240H0z"
      }),
      /* @__PURE__ */ jsx66("path", {
        fill: "#da0010",
        d: "M0 360h640v120H0z"
      })
    ]
  })
});
var Co_default = SvgCo;

// src/country-flag-icons/generated/Cp.tsx
import { jsx as jsx67, jsxs as jsxs60 } from "react/jsx-runtime";
var SvgCp = (props) => /* @__PURE__ */ jsx67("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs60("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx67("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx67("path", {
        fill: "#000091",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx67("path", {
        fill: "#e1000f",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Cp_default = SvgCp;

// src/country-flag-icons/generated/Cr.tsx
import { jsx as jsx68, jsxs as jsxs61 } from "react/jsx-runtime";
var SvgCr = (props) => /* @__PURE__ */ jsx68("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs61("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx68("path", {
        fill: "#0000b4",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx68("path", {
        fill: "#fff",
        d: "M0 75.4h640v322.3H0z"
      }),
      /* @__PURE__ */ jsx68("path", {
        fill: "#d90000",
        d: "M0 157.7h640v157.7H0z"
      })
    ]
  })
});
var Cr_default = SvgCr;

// src/country-flag-icons/generated/Cu.tsx
import { jsx as jsx69, jsxs as jsxs62 } from "react/jsx-runtime";
var SvgCu = (props) => /* @__PURE__ */ jsxs62("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx69("defs", {
      children: /* @__PURE__ */ jsx69("clipPath", {
        id: "cu_svg__a",
        children: /* @__PURE__ */ jsx69("path", {
          fillOpacity: 0.7,
          d: "M-32 0h682.7v512H-32z"
        })
      })
    }),
    /* @__PURE__ */ jsxs62("g", {
      fillRule: "evenodd",
      clipPath: "url(#cu_svg__a)",
      transform: "translate(30) scale(.94)",
      children: [
        /* @__PURE__ */ jsx69("path", {
          fill: "#002a8f",
          d: "M-32 0h768v512H-32z"
        }),
        /* @__PURE__ */ jsx69("path", {
          fill: "#fff",
          d: "M-32 102.4h768v102.4H-32zm0 204.8h768v102.4H-32z"
        }),
        /* @__PURE__ */ jsx69("path", {
          fill: "#cb1515",
          d: "m-32 0 440.7 255.7L-32 511z"
        }),
        /* @__PURE__ */ jsx69("path", {
          fill: "#fff",
          d: "M161.8 325.5 114.3 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3z"
        })
      ]
    })
  ]
});
var Cu_default = SvgCu;

// src/country-flag-icons/generated/Cv.tsx
import { jsx as jsx70, jsxs as jsxs63 } from "react/jsx-runtime";
var SvgCv = (props) => /* @__PURE__ */ jsxs63("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx70("defs", {
      children: /* @__PURE__ */ jsx70("clipPath", {
        id: "cv_svg__a",
        children: /* @__PURE__ */ jsx70("path", {
          fillOpacity: 0.7,
          d: "M-123.4 0h682.6v512h-682.6z"
        })
      })
    }),
    /* @__PURE__ */ jsxs63("g", {
      fillRule: "evenodd",
      clipPath: "url(#cv_svg__a)",
      transform: "translate(115.7) scale(.94)",
      children: [
        /* @__PURE__ */ jsx70("path", {
          fill: "#fff",
          d: "M-123.4 233H723v206h-846.5z"
        }),
        /* @__PURE__ */ jsx70("path", {
          fill: "#081873",
          d: "M-122.8 0h846v256.6h-846zm.3 385.9h852.1V512h-852.1z"
        }),
        /* @__PURE__ */ jsx70("path", {
          fill: "#de3929",
          d: "M-122.5 302.6h846v39.6h-846z"
        }),
        /* @__PURE__ */ jsx70("path", {
          fill: "#ffce08",
          d: "m131 399.2 6.6 20.4H159l-17.4 12.7 6.6 20.5L131 440l-17.4 12.7 6.7-20.5-17.4-12.7h21.5M317 250.4l6.7 20.5H345l-17.4 12.6 6.6 20.5-17.4-12.7-17.4 12.7 6.6-20.5-17.4-12.6h21.6m-222 64.4 6.6 20.5h21.5L99 368.6l6.7 20.4-17.4-12.6L70.9 389l6.6-20.4-17.4-12.7h21.5M317 329.5l6.7 20.4H345l-17.4 12.7 6.6 20.4-17.4-12.6-17.4 12.7 6.6-20.5-17.4-12.7h21.6m-40.5-161.7 6.7 20.4H298l-17.4 12.7 6.6 20.5-17.4-12.7-17.4 12.7 6.7-20.5-17.5-12.7h21.6m-64.5-45.2 6.7 20.5h21.5l-17.4 12.6 6.6 20.5-17.4-12.6-17.4 12.6 6.7-20.5-17.4-12.6H192m-64.5 2.9 6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H121m-34.8 43.2 6.6 20.5h21.6l-17.5 12.6 6.7 20.5-17.4-12.7-17.4 12.7 6.6-20.5L58 271h21.5m119.2 149.4 6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H192m82.2-41.7 6.6 20.4h21.5L285 432.3l6.7 20.5-17.4-12.7-17.5 12.7 6.7-20.5-17.4-12.7h21.5"
        })
      ]
    })
  ]
});
var Cv_default = SvgCv;

// src/country-flag-icons/generated/Cw.tsx
import { jsx as jsx71, jsxs as jsxs64 } from "react/jsx-runtime";
var SvgCw = (props) => /* @__PURE__ */ jsxs64("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs64("defs", {
      children: [
        /* @__PURE__ */ jsx71("clipPath", {
          id: "cw_svg__a",
          children: /* @__PURE__ */ jsx71("path", {
            fillOpacity: 0.7,
            d: "M0 0h682.7v512H0z"
          })
        }),
        /* @__PURE__ */ jsx71("path", {
          id: "cw_svg__b",
          d: "m0-1 .2.7H1L.3 0l.2.7L0 .4l-.6.4.2-.7-.5-.4h.7z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs64("g", {
      clipPath: "url(#cw_svg__a)",
      transform: "scale(.94)",
      children: [
        /* @__PURE__ */ jsx71("path", {
          fill: "#002b7f",
          d: "M0 0h768v512H0z"
        }),
        /* @__PURE__ */ jsx71("path", {
          fill: "#f9e814",
          d: "M0 320h768v64H0z"
        }),
        /* @__PURE__ */ jsx71("use", {
          xlinkHref: "#cw_svg__b",
          width: 13500,
          height: 9e3,
          x: 2,
          y: 2,
          fill: "#fff",
          transform: "scale(42.67)"
        }),
        /* @__PURE__ */ jsx71("use", {
          xlinkHref: "#cw_svg__b",
          width: 13500,
          height: 9e3,
          x: 3,
          y: 3,
          fill: "#fff",
          transform: "scale(56.9)"
        })
      ]
    })
  ]
});
var Cw_default = SvgCw;

// src/country-flag-icons/generated/Cx.tsx
import { jsx as jsx72, jsxs as jsxs65 } from "react/jsx-runtime";
var SvgCx = (props) => /* @__PURE__ */ jsxs65("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx72("path", {
      fill: "#0021ad",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#1c8a42",
      d: "M0 0h640v480z"
    }),
    /* @__PURE__ */ jsx72("circle", {
      cx: 320,
      cy: 240,
      r: 57.8,
      fill: "#ffc639"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#1c8a42",
      d: "M284.7 214c4 5.5 10 14.6 14.8 12.2 3.7 0 5.7.3 6.2 2.8a37 37 0 0 0 33-14.3s.8 0 .5-4.5c0-2 2.8-1.6 2.8-1 .4 1 .4 1.7.9 1.8 1-.4 2.7-3 4-4.6.3-.7.1-1.5.2-2.4.7-1.7 2.4-1.3 2.8-.4l.6 1.6c1.8 1.2 5 0 5.2 0 .3-1.4 1.2-1.2 1.2-1.2 1.2-.3.7-.2 1.5.2-.7 7.7 1.5 8 1.3 12 .1 4.4-1.3 5.6-1.3 7.3.4 2 7 2.1 4.6 3.9-2 1 0 3-3 3.8-8.8 4.5-10.4 8.3-10.4 8.3s-2.2 4.2-2.5 4.2c-1.5 2.8-3.3 1.2-4.4 2.6-.5 1.7-1 5.5 0 7.4.5 2.7 0 4.2-.7 6.9-.6 5.6-2.8 6.5-3.1 8.4-1 2.2.2 12-.8 12-6.5.2-11.5-1.2-14.1-1.7 2.5-10.9 1.5-20.4 1.5-21.4-.6-7.8-11.6-5.9-13.3-7-1.4-.2-2.3-1.3-2.7-1.8-1.6-.2-2.2-.6-3.7-.7-.8.4-.3.8-2 1.3-4.5.5-6.4-3.8-6.4-3.8.2-1.5-9.9.3-15.3-1-2.3 1.3-3.3 5-5.1 5.4 0 1.1-3-1-3.6-2-.2-3.4 2.8-4.8 2.8-4.8 2.4-1.7 3.8-2 5-3.1.5-2.9.2-5 1.5-7.1 1-1.7 2.5-1 3.5-1.6 1.1-.8 1.6-5.6.6-7l-4.7-4.2c-1.4-4.1 1.7-6.8 2.6-6.5"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#ffc639",
      d: "M561.9 142.4c-2.6-10.3-26-32.7-43.7-46.9-4.2-2.8-7-1.1-6.4 3 2.2 3.6 3.8 7.6 6 11.3.6 2.5 1.8 4.2 2.4 6.6 0 0 .2 4.2.6 4.6 5.4 6 6.2 11.1 6.2 11.1a49 49 0 0 0 11.5 15.6c6.2 3.9 1.6 16 1.8 22.5 0 4-2.9 3.6-5.5 3-20.1-18.5-40.1-18.5-57.8-23.9-6.8-.7-7 2.6-4.7 4.4a129 129 0 0 0 39.1 29.6l7.7 4.8 8.8 7.3c6.8 4.4 7.3 8.4 7.3 8.8.2 8.2-4.2 14.6-5.5 17.2-2.3 8.7-7 10.2-7 10.2-37.6 25.4-57.4 32-118.4 24.1-1-.4-6.8.5 0 3 15.5 5.2 53.7 13.5 90.6-4 9-6.2 14.8-4.2 21.3-8a287.3 287.3 0 0 1 28.3-15.4c8.3-4.5 31.3-9.4 36.6-13.8 6.1-.5 12.4-1.3 12.8-6.5 2-1.3 5-.3 7.2-4.6 4.8-.9 4-2.6 4-2.6-1.2-3.4-5.8-4.8-9-7.3-4.8-1.6-8-2-11.5-.4l-3.3 1.5s-5.1-.7-5.1-1.1c-11.4-.6-10.3-38.3-14.3-54z"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#1c8a42",
      d: "M588.6 204.2a2.8 1.8 16 1 1-5.4-1.7 2.8 1.8 16 0 1 5.4 1.7"
    }),
    /* @__PURE__ */ jsxs65("g", {
      fill: "#fff",
      transform: "matrix(.64 0 0 .64 0 80)",
      children: [
        /* @__PURE__ */ jsx72("path", {
          id: "cx_svg__a",
          d: "m188.2 191-12.8-12-12.9 11.8 1.4-17.4-17.3-2.8 14.5-9.8-8.6-15.2 16.7 5.3 6.5-16.2L182 151l16.7-5-8.8 15 14.4 10-17.3 2.5z"
        }),
        /* @__PURE__ */ jsx72("path", {
          d: "m233.4 335.5-13.8-9.1-13.4 9.6 4.8-15.5-13.6-9.5 16.6-.4 5-15.5 5.6 15.3 16.7-.1L228 320l5.3 15.4z"
        }),
        /* @__PURE__ */ jsx72("use", {
          xlinkHref: "#cx_svg__a",
          width: "100%",
          height: "100%",
          x: 2.5,
          y: 269.1
        }),
        /* @__PURE__ */ jsx72("use", {
          xlinkHref: "#cx_svg__a",
          width: "100%",
          height: "100%",
          x: -112.1,
          y: 123.2
        }),
        /* @__PURE__ */ jsx72("use", {
          xlinkHref: "#cx_svg__a",
          width: "100%",
          height: "100%",
          x: 108.4,
          y: 85
        })
      ]
    })
  ]
});
var Cx_default = SvgCx;

// src/country-flag-icons/generated/Cy.tsx
import { jsx as jsx73, jsxs as jsxs66 } from "react/jsx-runtime";
var SvgCy = (props) => /* @__PURE__ */ jsxs66("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx73("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx73("path", {
      id: "cy_svg__a",
      fill: "#435125",
      d: "M307.8 398.6a.8.8 0 0 1-.2-.2h-.1l-1.3-1.4-3.8-4.5-4.9-6.3-.6-.9-6.2-1.9-4.6-2.1 2.4-2.7 8.4 3.5 6.2 1.3 11.5 8.5-3.3 2.9a37.2 37.2 0 0 0-3.3 3.5l.7-.5.8.6zm-42.6-12.8a31.7 31.7 0 0 1-16-4.5s.7-1.3 2.3-2.4c1.6-1.2 4.4-2.5 9-2.6 5.4 0 12 1.9 19.5 5.4a28.8 28.8 0 0 1-14.8 4zm-23.5-5.2c-1 0-2-.4-2.6-1a5.2 5.2 0 0 1-1.1-2.4 11.7 11.7 0 0 1-.3-3.4 3.5 3.5 0 0 1 1.3-.2c2 0 3.6 1.7 4.3 3.4.4 1 .5 1.8.2 2.5-.2.6-1 1-1.8 1zm41.3-4.8c-13.9-2-19.8-7-22.3-10.9-2.6-4.1-2-8-2-8s.8-.2 2-.2c3.8 0 13.2 1.9 22.3 19zm-28.5-2.8c-5.9 0-10.4-1-13.4-3a8.3 8.3 0 0 1-3-3.3 5.4 5.4 0 0 1-.4-1.6 18.2 18.2 0 0 1 7.2-1.4 27 27 0 0 1 18.9 8.7c-3.4.4-6.5.6-9.3.6m-28.7-1c-6.2 0-14.8-2-20.2-7.3 0 0 5.9-1.5 12.4-1.7h1.2c5.9 0 10.4 1.1 13.4 3.4 1 .8 1.6 1.5 1.7 2.2.1.6-.2 1.2-.8 1.7-1.4 1-3.8 1.6-7.2 1.6h-.5zm-20.3-10.5a2.6 2.6 0 0 1-2-1 4.7 4.7 0 0 1-.8-2c-.3-1.4-.2-2.8-.2-2.9a2.4 2.4 0 0 1 1-.2c.9 0 1.6.5 2 1a5.6 5.6 0 0 1 1.4 2c.2.9.3 1.6 0 2.2 0 .4-.6 1-1.3 1zm46.9-1c-1 0-2-.4-2.6-1a5.2 5.2 0 0 1-1.1-2.4 11.7 11.7 0 0 1-.3-3.4 3.5 3.5 0 0 1 1.3-.2c2 0 3.7 1.7 4.3 3.4.4 1 .5 1.8.3 2.5-.3.6-1 1-2 1zm-22.8-1c-12.6-.4-19.2-4-22.4-7a14.6 14.6 0 0 1-3.4-4.3c-.5-1-.7-1.8-.7-2s1.2-.4 3-.4h.4c4.2 0 12.9 1.8 23 13.7zm13.6-1.2a30.8 30.8 0 0 1-18.9-9.3 19.4 19.4 0 0 1-4.1-7s1.2-.3 3-.4a14.2 14.2 0 0 1 1 0c5 .1 14.3 2.4 19 16.7m-52-5a42 42 0 0 1-9.5-1c-5.3-1.4-7.6-3.4-8.6-4.9a5 5 0 0 1-.8-2 3.4 3.4 0 0 1 0-.8s3.5-1 8.4-1.1a35 35 0 0 1 7.4.6 21.7 21.7 0 0 1 12.8 8.1s-4 1.2-9.7 1.2zm23.5-8.4a3.4 3.4 0 0 1-2.5-1 5.2 5.2 0 0 1-1.1-2.4c-.4-1.6-.3-3.2-.3-3.4a3.5 3.5 0 0 1 1.2-.3h.1c2 0 3.6 1.8 4.3 3.5.4 1 .4 1.8.2 2.4-.3.7-1 1.1-1.9 1.1zm-17.6-2.5a38.6 38.6 0 0 1-9.6-4.2c-4.4-2.7-9.9-7.5-10.5-15l1-.1h.3c1.3 0 4 .3 7.3 2.8 4.2 3.2 8 8.8 11.5 16.5m11.5-.4a31.2 31.2 0 0 1-7.6-4.9 48.5 48.5 0 0 1-13.3-18.6s.9-.5 2.3-.6a3.3 3.3 0 0 1 .2 0h.4c2 0 4.9.9 8.1 4.4 3.8 4 7.1 10.6 10 19.7zm-29.9-.9c-3.9 0-5.2-2-5.6-3a6 6 0 0 1-.4-3 8.5 8.5 0 0 1 2-.2 8 8 0 0 1 6.5 3c.2.4.8 1.4.3 2.3-.4.6-1.3 1-2.8 1zm-8.5-10.8a51.1 51.1 0 0 1-9-.7c-3.4-.6-5.3-3.5-6.4-5.9-1-2.5-1.4-5-1.4-5 10.6.3 15.7 3.4 18 6a9.4 9.4 0 0 1 2.6 5.5s-1.6.2-3.8.2zm11-11a42.7 42.7 0 0 1-2.4-3.4c-1.3-2-2.4-4-2.4-5.6 0-1.7-.4-5-.6-7l-.6-4.5c.3 0 6.6 2.4 6.6 8.4s-.6 12-.6 12zm-8.2-.6h-.2a43.7 43.7 0 0 1-18.2-10.8c-1.7-2-2.8-5.2-3.1-9.4-.2-3 0-5.5 0-5.8a3.3 3.3 0 0 1 1.1-.1c1.4 0 3 .6 5 2a39.6 39.6 0 0 1 5.2 4.4c3.2 3.2 5.7 6.4 5.7 6.4.3.4 2 3.7 3.5 6.9a22 22 0 0 1 1.6 4.6c.1.6.2 1 0 1.4a.7.7 0 0 1-.3.4.9.9 0 0 1-.4 0z"
    }),
    /* @__PURE__ */ jsx73("use", {
      xlinkHref: "#cy_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 593.7 0)"
    }),
    /* @__PURE__ */ jsx73("path", {
      fill: "#d47600",
      d: "m519 76.4-1.8.7-.8.3-2.2-.1-2.2 1-3.8 2.6-.1.1-1.5.4-1.3-.6-.7.4-.3 1.5-.7 1.1-.9.6-3 .3-2.5 1.4-3.4-1-1.5.7-3.3 3-1.7.7h-.5l-2.3-.1-.9.3-1.4 1.3-2.6.2-.9.6-1.3 2.6L476 96l-.8.1-.8-.3-.7.1-.3 1.7-.6.7-1.8.6-1.4 1.2-1.3.6h-2l-1.7 1-3.1.2-1.3 1.2-.3.3-.6.3-1 .6-.2.2-1.2-.2-1.4.5-.6-.8-1 .5-1.2.1-1.6-.7-1.3-.6-.9.2-.3 1.5v.2l-1 1.2-1.7 1.1-.2.3-2 2.6-3.8 4-3.2 1.6-3.3 1-2.3 1.9-6 3-9.7 4.8-2 .6-2.8.4-5 1.9-4.4 1.3-.3.1-.8.3-6.3 1.9-2.9-.4-1.7.7-4.5-.5h-3.1l-2 .4-3.7 1.8-6.3 3-2 2-3.2 1.6-3.8 1.2v-1.6l-1.3.4-1 .3-3 .4h-1.7l-1.1-.3h-.2l-6.2 2.1-7 .7-3.5 1.1H333l-1.6.5-3.2.4-1.2-.3-.2-.1-9.4.4-4.3-.5-2 .5-3.5-1.2-5-.6-1.2-.3-2.6-.8-1.2.7-1 .1-2-.8h-.8l-1.8.6-1-.2-1-.8-2.1-.3-1.4-1.1-7.5 1-2-.6-6.9-2h-1l-1.4 1-2 .8-1.9.4-2.4.1-2.8-.7-2.8-1.4-1.1-.3-2.4.3h-.7l-4.4-2.3-5.6-3.5-3.8-1.9-1.5-.2-.2.7.7 2.2.3 2.3v2l-.1 1.3.3 1.1 1.4 1.6.6 1.5.4 4.2v4.3l-.7 6.8-.2 1-.8 3.6-.7 3.3-2.9 8.7-.7 1-2 1.3-4.3 3-3.2 1.8-1 .4-2.6.2H219l-2-1.1-2-.5-2.6-1.9-2.8-.6-3.2-1.8-.8-1-1.7-.2-2.4-.7-.9-.3-.6-.1-3-.1-2.9-1.3-1.5-.4h-2l-2.1 1-1.1.4-1.4-.5h-1l-1 1.7-.2.3-.8.4h-1.7l-.8.3-1.1.5-1 .4-.5.2h-.3l-.5.2h-.6l-1.2-.6-.6-.3-1-.2-.5.3-.1 1.9-.5 1.1-1.6 1.4-1.6 1.4-1 1.6-3 6.7-1.9 2.7-.5.7-2 2.1-1.7 1.3-3.9 3-3.7 1.5-3.2.6h-1.6l-3-.4-2.6-.8-3-1.8-3.1-2.6-4.7-4.5-.6-.4-.2-.1-1.4-1h-1.1l-.4.8-.3 1-.2.9-.5 5v.3l.3 2.1 3.6 5 1 2.6.2.3.7 1.2.6 1 1.3 3.6-.9 2 .4 1.4-1 .8-.2 1.2 3.1 4 .7 1.7-.7 2.4-1.3 1.4-.3.3.2 1 1.4 1.4 2.5 2.2 1.3 3.2 1 1 1.2-.3.6.5h1l1 1 .6.2 1 .5.8 1 .1 3.2 1.5 3.8v2.5l1 1.5.2 1.2-.5 3.3 1.2 1 1.2-.2.8.1 1.3 1.1 1.6 2.4 1.6-.2 1 .4 4.7 4.3 1 .6.9.4 1 1 1.4-1h.2l1.6-.2.7.5 1.4.9h1.7l4 1.2 1.6.4 3.4 2.1 1.5.9.8.7 1.2 1 2.2 1 2 .4 1 .2.9.3 4.2 1.7 2.3.5 2 .8 1.6.5h1.2l1.6-1.3h1.5l1.3.2 1.3-.2 2-1.2.3-.6 1.4-.6 4.8-.6 1.4.4 3.6-1.5 2.4.6 2-.7 4.7 1 1.2.9 1.4 1.5h1.7l-.7 1.1 2 2.2 1.9 2.7.1.4 1.3 3.9 1 1.4.7 1.9v1.2l-1 .9-.2.4v.2l.2.5.4-.2.7-.4 1-.2 1.6.2 1.1.1 1.7-.8 1.2-.6 1.8.8h2l.9.3 2.4 1.1 1.2.1.4-.3.3-.6-.1-.8-1-1.1-2-2.4-.8-1.2-.6-1.7-.2-2.2-.2-1.5.3-2 .5-.7.4-1.6.1-.4 1.2-1.5 3-2 3.2-2.8 2.5-1.7 2.6-1.1v-.3l.4.1 6.6-2.3 3-.5 20 1.4.7-.2.7-1.9.3-.3.3-.2 2.2-1 1-.2 2.8.7 1.2.3 1.9-1h1.3l2.7-1.5h1.7l.7-.2 3.3-2.4 3.1-.9.8-.4.3-.2 3.3-1.7 2-1.6 1.8-1 2-.4 5-.4 1.1-1.7 2.2-.3 1.3-1.5 1.5-.6 1.1-1.6 1-1.3 1.2-.7 4.1-.3 4.8.6.7-.4 1-3.9 1.2-.7 3-4.5v-1.6l.1-1.4.5-2-.3-3.4.4-3.6 1.9-4.5 1.7-1.8 2.7-1.9 1.4-.6 2-.3h.2l.5-.2h9.2l2.3-.1 5.7 1h.4l1.9.7 2.2 1.7 2.4 2.3.4.4 1.5.7.5.2 1.2-.2 1.8-1 1.4-1 1.8-1v-.2l1.1-1.5.4-.7 3.6-1.4 4.2-.2.5-.3h.2l1.1-1.4h1l2.6 1 1.7-.4 1.4.5 1.1-.1 2-.3 2.3 1.6 1.3.2 4.5 2.6h.4l.2.1.5-.2.8-.2h.1l.1.1.6.7.7.1.8-1-.3-.6-.1-.2-1.7-.3-1.4-2.5 1.4-1.5-2.2-2.6-.4-.5v-.1l-.8-1.2-3.8-5.8-5-4-1.7-1.3-.6-.5-2.7-2.7-1.9-2.5-.2-.5-.4-.9-1.1-2.4-2-1.5-1.6-1.8-3.4-4.6-.5-.7-.8-.5h-1.7l-.1-.2h-.1v-.1l.8-.8 1-.2.3-.9-1.7-4.9v-.2l-.1-1.5 1.3-7.1.2-.9 2.4-4.7 1.4-1.2 1.6-3.1 1.4-2 1.3-1.3.2-.1 2.3-1.4 2-.3 1.9-.3 3.3 1h3l.7-.1 1.4-.2 2.3-.7 1.1-.7.6-.8 1.2-4 .4-1.3.7-1.4 4.3-4.9 3.2-3 7.2-5.2 3.5-2.1 1.8-1.1 16.1-7.2 4.2-4.2 2.2-2.2 3.8-2.6 4.5-1.9 4-3 .8-1.1 1-3.5 1-.2.7-1.7.3-.5 3.1-2.2.4-.2 12.3-6.2 1.8.3 1-1.5 3.5-.6h.7l.9-.5.7-1.3v-.3l.1-3.4.8-.9.4-2.2.4-.6.4-.5 1-.7z"
    })
  ]
});
var Cy_default = SvgCy;

// src/country-flag-icons/generated/Cz.tsx
import { jsx as jsx74, jsxs as jsxs67 } from "react/jsx-runtime";
var SvgCz = (props) => /* @__PURE__ */ jsxs67("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx74("path", {
      fill: "#fff",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx74("path", {
      fill: "#d7141a",
      d: "M0 240h640v240H0z"
    }),
    /* @__PURE__ */ jsx74("path", {
      fill: "#11457e",
      d: "M360 240 0 0v480z"
    })
  ]
});
var Cz_default = SvgCz;

// src/country-flag-icons/generated/De.tsx
import { jsx as jsx75, jsxs as jsxs68 } from "react/jsx-runtime";
var SvgDe = (props) => /* @__PURE__ */ jsxs68("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx75("path", {
      fill: "#fc0",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx75("path", {
      fill: "#000001",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx75("path", {
      fill: "red",
      d: "M0 160h640v160H0z"
    })
  ]
});
var De_default = SvgDe;

// src/country-flag-icons/generated/Dj.tsx
import { jsx as jsx76, jsxs as jsxs69 } from "react/jsx-runtime";
var SvgDj = (props) => /* @__PURE__ */ jsxs69("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx76("defs", {
      children: /* @__PURE__ */ jsx76("clipPath", {
        id: "dj_svg__a",
        children: /* @__PURE__ */ jsx76("path", {
          fillOpacity: 0.7,
          d: "M-40 0h682.7v512H-40z"
        })
      })
    }),
    /* @__PURE__ */ jsxs69("g", {
      fillRule: "evenodd",
      clipPath: "url(#dj_svg__a)",
      transform: "translate(37.5) scale(.94)",
      children: [
        /* @__PURE__ */ jsx76("path", {
          fill: "#0c0",
          d: "M-40 0h768v512H-40z"
        }),
        /* @__PURE__ */ jsx76("path", {
          fill: "#69f",
          d: "M-40 0h768v256H-40z"
        }),
        /* @__PURE__ */ jsx76("path", {
          fill: "#fffefe",
          d: "m-40 0 382.7 255.7L-40 511z"
        }),
        /* @__PURE__ */ jsx76("path", {
          fill: "red",
          d: "M119.8 292 89 270l-30.7 22.4L69.7 256l-30.6-22.5 37.9-.3 11.7-36.3 12 36.2h37.9l-30.5 22.7 11.7 36.4z"
        })
      ]
    })
  ]
});
var Dj_default = SvgDj;

// src/country-flag-icons/generated/Dk.tsx
import { jsx as jsx77, jsxs as jsxs70 } from "react/jsx-runtime";
var SvgDk = (props) => /* @__PURE__ */ jsxs70("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx77("path", {
      fill: "#c8102e",
      d: "M0 0h640.1v480H0z"
    }),
    /* @__PURE__ */ jsx77("path", {
      fill: "#fff",
      d: "M205.7 0h68.6v480h-68.6z"
    }),
    /* @__PURE__ */ jsx77("path", {
      fill: "#fff",
      d: "M0 205.7h640.1v68.6H0z"
    })
  ]
});
var Dk_default = SvgDk;

// src/country-flag-icons/generated/Dm.tsx
import { jsx as jsx78, jsxs as jsxs71 } from "react/jsx-runtime";
var SvgDm = (props) => /* @__PURE__ */ jsxs71("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx78("defs", {
      children: /* @__PURE__ */ jsx78("clipPath", {
        id: "dm_svg__a",
        children: /* @__PURE__ */ jsx78("path", {
          fillOpacity: 0.7,
          d: "M-85 0h682.7v512H-85z"
        })
      })
    }),
    /* @__PURE__ */ jsxs71("g", {
      fillRule: "evenodd",
      clipPath: "url(#dm_svg__a)",
      transform: "translate(79.7) scale(.94)",
      children: [
        /* @__PURE__ */ jsx78("path", {
          fill: "#108c00",
          d: "M-258.3 0H769.2v512H-258.3z"
        }),
        /* @__PURE__ */ jsx78("path", {
          fill: "#ffd600",
          d: "M-260 178.2H772.6v50.1H-260z"
        }),
        /* @__PURE__ */ jsx78("path", {
          fill: "#ffd600",
          d: "M181 0h48.5v512h-48.4z"
        }),
        /* @__PURE__ */ jsx78("path", {
          fill: "#000001",
          d: "M227.8 0h48.4v512h-48.4z"
        }),
        /* @__PURE__ */ jsx78("path", {
          fill: "#000001",
          d: "M-260 226.6H772.6v50.2H-260z"
        }),
        /* @__PURE__ */ jsx78("path", {
          fill: "#fff",
          d: "M-260 276.8H772.6v50.1H-260z"
        }),
        /* @__PURE__ */ jsx78("path", {
          fill: "#fff",
          d: "M276.2 0h48.5v512h-48.5z"
        }),
        /* @__PURE__ */ jsx78("rect", {
          width: 273.8,
          height: 275,
          x: -394.6,
          y: -393.9,
          fill: "#e72910",
          ry: 137.5,
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m250.5 137 5.6-16 5.1 15.7s17.1.5 17.1.2-13.5 10.3-13.5 10.3l6.1 17.6c-.2-.5-14.8-10.9-14.8-10.9s-14.8 10.4-14.5 10.4 5.6-17 5.6-17l-13.3-10.1 16.6-.3z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "M251.3 137.7 256 124l4.4 13.6s14.9.4 14.9.2-11.7 9-11.7 9l5.2 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 5-14.8 5-14.8l-11.6-8.8 14.4-.2z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m253.3 140 2.8-8 2.6 7.9s8.5.2 8.5 0-6.7 5.2-6.7 5.2l3 8.8c-.1-.3-7.4-5.4-7.4-5.4l-7.2 5.2c.2 0 2.8-8.5 2.8-8.5l-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m356.9 211.8 5.6-16 5 15.7s17.2.6 17.2.3-13.5 10.3-13.5 10.3l6 17.6c-.2-.5-14.7-10.9-14.7-10.9s-14.8 10.4-14.5 10.4 5.6-17 5.6-17L340.3 212l16.6-.3z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m357.6 212.6 4.9-13.9 4.4 13.7s14.8.4 14.8.2-11.7 9-11.7 9l5.3 15.1c-.2-.4-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m359.7 214.9 2.8-8 2.5 7.8 8.6.2-6.8 5.1s3.2 9 3 8.8c0-.3-7.3-5.4-7.3-5.4l-7.3 5.1 2.8-8.5-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m325.9 330.6 5.6-16 5 15.8s17.2.5 17.2.3-13.5 10.3-13.5 10.3l6 17.5c-.2-.5-14.7-10.8-14.7-10.8S316.7 358 316.9 358s5.7-17 5.7-17l-13.3-10z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m326.6 331.4 4.9-13.8 4.4 13.6s14.8.5 14.8.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m328.7 333.7 2.8-8 2.5 7.9s8.6.3 8.6.1-6.8 5.2-6.8 5.2l3 8.7c0-.2-7.3-5.4-7.3-5.4l-7.3 5.2 2.8-8.5-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m177.2 330.6 5.6-16 5 15.8s17.1.5 17.1.3-13.5 10.3-13.5 10.3l6.2 17.5c-.3-.5-14.8-10.8-14.8-10.8S168 358 168.2 358s5.7-17 5.7-17l-13.3-10z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m178 331.4 4.8-13.8 4.4 13.6s14.8.5 14.8.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m180 333.7 2.8-8 2.5 7.9s8.6.3 8.6.1-6.8 5.2-6.8 5.2l3 8.7c0-.2-7.3-5.4-7.3-5.4l-7.3 5.2 2.8-8.5-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m150 208.7 5.6-16 5.1 15.8s17.1.5 17.1.2-13.5 10.4-13.5 10.4l6.1 17.5c-.3-.5-14.8-10.8-14.8-10.8S140.8 236 141.1 236s5.6-17 5.6-17l-13.3-10z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m150.8 209.5 4.8-13.8 4.5 13.6s14.7.5 14.7.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.5 9 4.8-14.8 4.8-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m152.8 211.8 2.8-8 2.6 7.9 8.5.1-6.7 5.2 3 8.7c-.1-.2-7.4-5.4-7.4-5.4l-7.2 5.2c.2 0 2.8-8.5 2.8-8.5l-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m324.6 174.1-5.6 16-5-15.7s-17.2-.5-17.2-.3 13.5-10.3 13.5-10.3l-6-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17l13.3 10z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "M323.9 173.3c0 .3-5 13.9-5 13.9l-4.3-13.6s-14.8-.5-14.8-.3 11.7-8.9 11.7-8.9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.7z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m321.8 171-2.8 8-2.5-7.8s-8.6-.3-8.6-.1 6.8-5.2 6.8-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2c-.2 0-2.9 8.5-2.9 8.5l6.7 5-8.3.2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m367.3 290.3-5.6 16-5-15.8s-17.2-.5-17.2-.2S353 280 353 280l-6-17.6c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17L384 290z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m366.6 289.5-4.9 13.8-4.4-13.6s-14.8-.4-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.8z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m364.5 287.2-2.8 8-2.5-7.9s-8.6-.2-8.6 0 6.8-5.2 6.8-5.2l-3-8.8c0 .3 7.3 5.4 7.3 5.4l7.3-5.2c-.2 0-2.9 8.6-2.9 8.6l6.7 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m261.4 375.3-5.6 16-5-15.8s-17.2-.5-17.2-.3 13.5-10.3 13.5-10.3l-6-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17L278 375z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m260.7 374.4-4.9 14-4.4-13.7s-14.8-.5-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.7-14.3.3z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m258.6 372.2-2.8 8-2.5-7.9s-8.6-.3-8.6-.1 6.8-5.2 6.8-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.5 6.6 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m162 290.3-5.7 16-5-15.8s-17.2-.5-17.2-.2 13.5-10.3 13.5-10.3l-6-17.6c.2.5 14.7 10.8 14.7 10.8L171 263l-5.7 17 13.3 10.1-16.6.3z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m161.2 289.5-4.9 13.8-4.4-13.6s-14.8-.4-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.8z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m159.1 287.2-2.8 8-2.5-7.9s-8.6-.2-8.6 0 6.8-5.2 6.8-5.2l-3-8.8c0 .3 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.6 6.6 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx78("path", {
              d: "m198.7 175.8-5.6 16-5.2-15.7s-17-.5-17-.3 13.5-10.3 13.5-10.3l-6.1-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.6-10.3-5.6 17-5.6 17l13.2 10z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#ffe700",
              d: "m197.9 175-4.9 14-4.4-13.7s-14.8-.5-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.8 14.8-4.8 14.8l11.4 8.7-14.3.3z"
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#108c00",
              d: "m195.8 172.8-2.8 8-2.5-7.9s-8.5-.3-8.5-.1 6.7-5.2 6.7-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.5 6.6 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs71("g", {
          transform: "matrix(1.04 0 0 1.04 -250.6 359.4)",
          children: [
            /* @__PURE__ */ jsxs71("g", {
              fill: "#009200",
              stroke: "#000",
              strokeWidth: 2.5,
              transform: "matrix(.16 -.02 0 .18 429.8 -215.6)",
              children: [
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 680.2,
                  cy: 586.1,
                  rx: 30.8,
                  ry: 189.8,
                  transform: "matrix(1.4 0 0 1 -534.3 263.7)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 680.2,
                  cy: 586.1,
                  rx: 30.8,
                  ry: 189.8,
                  transform: "matrix(1.5 0 0 1 -547.2 267)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 680.2,
                  cy: 586.1,
                  rx: 30.8,
                  ry: 189.8,
                  transform: "matrix(1.2 0 0 1.1 -365 214.1)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs71("g", {
              stroke: "#000",
              transform: "translate(72.9 -9.8)",
              children: [
                /* @__PURE__ */ jsx78("path", {
                  fill: "#a95600",
                  strokeWidth: 0.5,
                  d: "M388.5-53c6-.3 3.4-3.3 6.4-5 3-1.6 7.3-.6 8.6 1.4 1.3 2 .3 4 2 4s47-2.5 48.6-.9c1.6 1.7 2 5 .3 6.3-1.6 1.4-58.9 3-60.9 1.6s-5-7-5-7.4z"
                }),
                /* @__PURE__ */ jsx78("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 340.4 -81.7)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 344.4 -81.6)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 348.7 -81.8)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 352.7 -81.8)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 478.4,
                  cy: -41.1,
                  fill: "#a95600",
                  strokeWidth: 0.4,
                  rx: 3.5,
                  ry: 3.4,
                  transform: "matrix(1.1 .02 -.02 1.15 -75.6 4.7)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs71("g", {
              fill: "#009200",
              stroke: "#000",
              strokeWidth: 2.5,
              transform: "rotate(-5.8 688.4 -625.2)",
              children: [
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 369.8 -361.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 364 -362.7)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 360.6 -370.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .35 369.3 -399.4)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 377.4 -379)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 373.2 -382.2)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 368 -386.7)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 363 -389.5)"
                })
              ]
            }),
            /* @__PURE__ */ jsx78("path", {
              fill: "#804bff",
              stroke: "#000",
              strokeWidth: 0.5,
              d: "M482.6-141s-11.7 10-10.1 36.9c1.8 27 26.5 39.5 26.5 39.5s6.2-7.7 5.2-29.5c-2-31.8-13.8-45.7-13.8-45.7l-7.8-1.3z"
            }),
            /* @__PURE__ */ jsxs71("g", {
              fill: "#009200",
              stroke: "#000",
              strokeWidth: 2.5,
              transform: "rotate(4.5 181 769.9)",
              children: [
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 369.8 -361.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 364 -362.7)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 360.6 -370.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .35 369.3 -399.4)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 377.4 -379)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 373.2 -382.2)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 368 -386.7)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 363 -389.5)"
                })
              ]
            }),
            /* @__PURE__ */ jsx78("ellipse", {
              cx: 624.4,
              cy: 606.1,
              fill: "#c90000",
              stroke: "#000",
              strokeWidth: "1pt",
              rx: 58.3,
              ry: 186.5,
              transform: "matrix(.16 -.06 .06 .15 369.6 -145)"
            }),
            /* @__PURE__ */ jsxs71("g", {
              fill: "#009200",
              stroke: "#000",
              transform: "rotate(1 242.4 -1957.8)",
              children: [
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.5,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.4 0 0 .3 445 -230.5)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 457.2 -236)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 452 -236)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.37 0 0 .27 449.5 -233.5)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.37 0 0 .27 449 -238)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 447 -238.8)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 448 -241.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.5,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.4 0 0 .3 432.8 -243.5)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.37 0 0 .27 446 -243.5)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 444.2 -247)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 436.1 -243.2)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 437.4 -243.9)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 439 -247)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs71("g", {
              fill: "#009200",
              stroke: "#000",
              transform: "matrix(.18 0 0 .2 421 -216.8)",
              children: [
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 564.5,
                  strokeWidth: 2.5,
                  rx: 67.4,
                  ry: 205.6,
                  transform: "matrix(.98 -.3 .36 .87 -245.8 324.4)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.5,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "rotate(-23.4 630.5 660.9)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 1.5,
                  d: "M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z",
                  transform: "matrix(1.88 -.46 .95 1.18 -352.3 -10)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 1.5,
                  d: "M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z",
                  transform: "matrix(1.88 -.46 .95 1.18 -348.4 44)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 1.5,
                  d: "M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z",
                  transform: "matrix(1.87 -.5 .98 1.16 -362 105.8)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 1.4,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.8 -.4 .7 1.64 -915.6 -221)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 1.6,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.63 -.23 .54 1.35 -739.5 -91.8)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 1.6,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.63 -.2 .5 1.36 -750.6 -91.8)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.3 -.2 .47 1 -531 47.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.33 -.13 .4 1.03 -517.9 12.2)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 2.1,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(1.03 -.5 .46 1.18 12.8 -14.5)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.33 -.13 .4 1.03 -519.5 -34.4)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.33 -.1 .38 1.04 -534 -40.1)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 2.9,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.67 -.47 .46 .8 39.5 143.3)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 2.9,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.67 -.47 .46 .8 51.1 125.8)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 2.1,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.94 -.64 .64 1.1 -40.2 -10.7)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  strokeWidth: 2.7,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.67 -.52 .46 .88 68.6 71.2)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs71("g", {
              fill: "#804bff",
              stroke: "#000",
              strokeWidth: 2.5,
              children: [
                /* @__PURE__ */ jsx78("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 458 -214.3)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 456.6 -220.2)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 454.8 -225.8)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 450.9 -232.2)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs71("g", {
              transform: "rotate(1 -589.6 681.6)",
              children: [
                /* @__PURE__ */ jsx78("path", {
                  fill: "#804bff",
                  stroke: "#000",
                  strokeWidth: 2.5,
                  d: "M211.2 247.3c21.7-12 56.6-9.8 79.7 11.2 19.4 17 45.3 75.2 70.3 92.8a57.7 57.7 0 0 1-42.2-15.2c-28.8 15.5-38.1 16.7-64 15.7-35.8-1.4-62.4-17.7-68-40.6-6.3-21.8 4.8-52.5 24.2-63.9z",
                  transform: "matrix(.2 -.04 .05 .18 407.8 -213.6)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 287.2,
                  cy: 323,
                  fill: "red",
                  stroke: "#000",
                  strokeWidth: 2.5,
                  rx: 14.2,
                  ry: 15,
                  transform: "matrix(.25 0 0 .13 401.8 -215.2)"
                }),
                /* @__PURE__ */ jsx78("ellipse", {
                  cx: 204.6,
                  cy: 348.3,
                  fill: "#ff0",
                  stroke: "#000",
                  strokeWidth: 2.5,
                  rx: 23.3,
                  ry: 15.9,
                  transform: "matrix(.2 -.08 .07 .17 398.7 -208)"
                }),
                /* @__PURE__ */ jsx78("circle", {
                  cx: 283.9,
                  cy: 333.9,
                  r: 5.8,
                  transform: "matrix(.2 0 0 .2 411.3 -233.7)"
                }),
                /* @__PURE__ */ jsx78("path", {
                  fill: "#ff0",
                  stroke: "#000",
                  strokeWidth: 6.6,
                  d: "M516.8 260.3c4.4 18-6.7 43-33.1 52.6-26.8 13.2-46.1 41.8-55.7 88-47.2-103.2-23-148.3 20.6-160.3 37.4-14.4 60.4-13.4 68.2 19.7z",
                  transform: "matrix(.1 0 0 .08 417.9 -191.5)"
                }),
                /* @__PURE__ */ jsx78("circle", {
                  cx: 199,
                  cy: 362.4,
                  r: 4.7,
                  transform: "matrix(.2 0 0 .2 418.7 -235)"
                })
              ]
            })
          ]
        })
      ]
    })
  ]
});
var Dm_default = SvgDm;

// src/country-flag-icons/generated/Do.tsx
import { jsx as jsx79, jsxs as jsxs72 } from "react/jsx-runtime";
var SvgDo = (props) => /* @__PURE__ */ jsxs72("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx79("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#002d62",
      d: "M0 0h272v192H0Zm368 288h272v192H368Z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#ce1126",
      d: "M0 288h272v192H0ZM368 0h272v192H368Z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#201b18",
      d: "M307.4 196.6a34.9 34.9 0 0 0-19 4.9c-2.6 1.6-3.2 2.1-1.8 4.7l-3.3 1.1a38 38 0 0 0-6 2.7c-1.2.7-1.6 1.2-2.5 2.1l5.3-.4-.7 1.2c-1 1.3-1.5 2.3-2.3 3.7 1.5-1 2.9-2 4.6-2.8 3.8-2 10.7-2 13.5-5.4.7-.9.3-1.4-.3-2.8 2-.6 2.9-1.1 5.4-1.7 6.1-1.4 10.3.3 13.3-.5 1-.2 1.8-.7 1.9-1.7l-.5-3h10c0 1.7-1.7 4 1.4 4.7 2.8.8 8.4-.8 13.3.5l5.4 1.8-.5 1.3c-.3.6-.2 1 .2 1.4.5.6 1.2 1.2 2 1.6a22.3 22.3 0 0 0 5.6 2c5.7 1.3 6.2 1.7 10.5 4.6-.3-.9-2.3-3.9-3-5l5.3.5c-1-1.4-3.7-2.9-5.3-3.5l-6.5-2.4c.6-1 1-2 .5-3a24 24 0 0 0-7.7-4.3 68.4 68.4 0 0 0-7-1.6l-6.8-.7c-.3-.3.6-2-.8-3.3-.8-.6-2-.9-3.3-1-5-.5-11.6-.3-16.6 0-1.5.1-2.5.3-3.3 1-1 1-1.1 1.5-1 3.3"
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "#002d62",
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "M308.7 200.1c.8-.6.9-.8 2-1.2 2.6-.9 6.6-.8 9.3-.8 2.2 0 4.3 0 6.5.2s3.4.5 4.9 1.7c.3-1.5.6-2.8.6-4.5.1-1.8-1-2.3-2.5-2.6-2.6-.6-7-.5-10-.5a63 63 0 0 0-9.7.6c-1.2.4-2.2 1.4-2 3 0 .9.6 3.6 1 4.1z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M289.4 208.7c.4-.4.1-.8 2.2-2a34.8 34.8 0 0 1 9.3-3.4c2.6-.5 5.3-.5 8-.3 1.2.1 2.8.3 4 .1 0 0 1.3-.3 1.7-.6.4-.4.4-1.4.4-1.4-.9-.7-3.4 1.8-5.6 1-.7-.2-1-1.4-1.2-2.3l-.8-2.7a35.1 35.1 0 0 0-15 2.8c-1.8.8-4.6 2.2-5.7 3.3-1 1 0 2.4.6 3.1.6.9 1.6 2 2 2.4zm35.6-7.6c-.2 1.4.8 1.8 2.1 2 2.7.4 6.7-.8 12 .2a35.2 35.2 0 0 1 6.4 2c.8.4 3.6 1.6 4.1 2.2l1 1.2c.3-.1 1.8-2 2.1-2.4.7-.7 1.5-2 .6-3.1a25 25 0 0 0-5.7-3.3 38.8 38.8 0 0 0-7.8-2.1c-2.5-.4-7.6-.8-7.6-.8s-.3 4.7-1.6 5.1c-2.5.8-3.8-1.4-5.6-1"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M345 207c-.2.6-.5.7.9 1.8 3 2.6 8.4 2.7 11.6 4.1 1.7.8 2.6 1.4 4.1 2.3-.1-.5-2-3.2-2.5-4l4.9.2-.2-.2c-2.2-1.9-7.9-3.7-10.7-4.6l-2.5 2.8c-.3.3-.6.6-1.3.4-.8-.3-1.5-1-2-1.5-.6-.5-1.6-1.3-2.3-1.4zm-20-6.4c1.7.1 1.9.4 3 1l1.8.2c.9 0 1-.2 1.2-.9.3-1-1.3-1.6-2-1.7l-3.5-.6zm-10 0-.4-2c-1 0-6 .8-5.6 2.3.2.7.3.8 1 1 2.2.1 2.6-1.2 5-1.3m-25.2 8.4c.7 1.3 2.6-1 3.7-1.8.6-.5.7-.4 1.4-.7l-.4-.7-2.7 1.3c-.8.5-1.8 1-2 2z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M345.1 206.5c.3 0 .5.1.8.3 1.6.9 3.5 3.3 4.3 2.4.4-.5-1.3-1.7-1.8-2l-2.8-1.3a1.6 1.6 0 0 0-.5.6m-50.2.5c.2.7.5.8-.8 1.9-3.2 2.5-8.4 2.7-11.7 4.1-1.7.7-2.6 1.3-4 2.2 0-.4 2-3.2 2.5-4l-5 .3.3-.2c2.2-2 7.8-3.7 10.6-4.7l.9 1a37 37 0 0 0 1.6 1.9c.4.3.6.5 1.3.3.9-.2 1.6-1 2-1.4.6-.5 1.6-1.4 2.3-1.4"
        })
      ]
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#eac102",
      d: "M295.7 199.8c-.5 0-.9.2-1.3.3-.1 0-.5.2-.2.3.2.1.2.4.3.6l.3.9.5 1.4c0 .1 0 .4.2.3l.8-.3c.3-.1.6-.3.8-.7l.2-.5a.8.8 0 0 0 0-.4c0-.2 0-.4-.2-.6a1.8 1.8 0 0 0-.4-.8c-.2-.2-.4-.4-.7-.4a.8.8 0 0 0-.3-.1m-.2.3c.2 0 .5.2.6.5l.4.7.2 1.3c0 .2-.3.3-.5.5-.2 0-.4-.1-.4-.3l-.2-.6-.4-1a4.7 4.7 0 0 1-.2-.8c0-.2.2-.3.4-.3zm1.7-.9.3.3.2.6.1.5.2.7.2.6v.6s0 .2.1 0h.5c.1 0 .3 0 .3-.2l-.2-.3-.2-.8-.2-.5-.1-.4-.3-.9v-.3c0-.2-.2 0-.3 0zm3-.8c-.3 0-.6.1-.8.3l-.3.9v.8l.6 1.2.7.4h.6c.3-.1.6-.4.7-.7l.1-.8v-.7a2.6 2.6 0 0 0-.4-.7l-.5-.5a1.1 1.1 0 0 0-.7-.2m0 .2c.2 0 .4.3.5.6l.4 1.2.1.5v.7c-.2.2-.5.3-.7.1l-.4-.5-.2-.8-.1-.6c0-.3-.2-.6 0-1zm2.3-.5-.3.5.1.7a.8.8 0 0 0 .4.4l.9.5c.2 0 .4.2.4.4v.5c0 .1-.2.3-.4.2a.7.7 0 0 1-.4-.2 1.2 1.2 0 0 1-.4-.6l-.2.1v.6l.4.2.5.2c.2 0 .4 0 .6-.2.2 0 .3-.2.4-.4a1 1 0 0 0 0-.7 1.1 1.1 0 0 0-.6-.8 4 4 0 0 0-.6-.3l-.6-.5c0-.2 0-.5.2-.5h.6l.3.5c0 .2.2.1.1 0 0-.2.2-.5 0-.6a1.4 1.4 0 0 0-.6-.2 1 1 0 0 0-.6.1zm11.2-4.4-.9.2-.4.1a.7.7 0 0 1 .2.4v1.5l.1.8v.6c-.2.1 0 .2.2.1h.6c.2 0 0-.2 0-.3l-.1-.6v-.6l.6-.1c.4-.1.8-.4.9-.8a1.1 1.1 0 0 0-.4-1 1.4 1.4 0 0 0-.8-.3m0 .3c.2 0 .4.2.4.5v.5c0 .3-.2.5-.5.6-.1 0-.3 0-.3-.2v-.6c0-.3-.2-.5 0-.7h.3zm2.6-.4c-.2 0-.4.1-.3.3l-.2.7a9.9 9.9 0 0 1-.2 1l-.3 1.2c0 .1-.2.3 0 .3h.5c.2 0 0-.2 0-.3v-.5s0-.2.1-.1h.8v.6c0 .1 0 .3.2.3h.7c.2-.1 0-.3-.1-.4l-.2-.7-.3-.9-.1-.5a9.3 9.3 0 0 1-.3-1zm-.2.8.4 1.3c.1.1 0 .2-.2.2-.1 0-.5.1-.5-.1l.1-.5a6.9 6.9 0 0 0 .2-.7zm3-1h-1.3a.8.8 0 0 1 0 .5l-.1.4.3-.3c.1 0 .2-.3.4-.2h.3v2.9l-.1.2h.9c.1 0 .1-.1 0-.1v-3c0-.1.1-.2.3 0h.2l.2.4h.2l-.1-.5c0-.1 0-.3-.2-.3zm2.8 0h-.8s-.2 0-.1.1c.2.1.1.3.1.5v2.5c0 .1 0 .3-.2.4h1c0-.1-.2-.2-.1-.3v-1.2c.2 0 .3.1.3.3l.2.5c0 .2.2.3.3.5.2 0 .3.2.5.3l.3.1-.2-.3-.3-.8a2 2 0 0 1-.2-.5c0-.2.1-.1.2-.2a1 1 0 0 0 .5-.4v-.6l-.2-.5c-.1-.2-.3-.2-.4-.3a3.3 3.3 0 0 0-.6-.1zm.3.2c.2 0 .3.1.4.3a.8.8 0 0 1 .2.4v.4c-.1.2-.3.4-.5.4h-.5v-1.3c0-.2.2-.2.4-.2m2.2.4v1.2l-.1 1.4a.8.8 0 0 1-.2.4s0 .1 0 0l.4.1h.5c.2 0 0 0 0-.2v-2.7c.1-.1 0-.3.2-.4v-.2h-1zm2.5-.2-.3.9-.1.5-.3.8c-.1.4-.2.8-.4 1-.2 0-.1.3 0 .2h.5c.1.1.2 0 0 0v-.6c0-.2.1-.3.3-.2h.6l.1.6c0 .2-.2.4 0 .4h.7s.2 0 0 0l-.1-1-.2-1-.1-.9a1.9 1.9 0 0 0-.1-.5s0-.2-.2-.1h-.4zm0 .8c.2.2.1.4.2.6v.8c.2.3-.2.1-.3.1-.2 0-.4 0-.3-.2l.1-.4.2-.5zm6.5 3.5c0 .2.2.3.1.4v2.9a.3.3 0 0 1 0 .3h1.9v-.8c0-.1 0 0 0 0-.2.3-.4.5-.7.5h-.5v-.5a31.7 31.7 0 0 1 0-2.4l.1-.4zm2.3 3.6h1l-.2-.4v-2.9l.2-.3h-1c0 .2.2 0 .2.3v2.9zm1.5-3.7c0 .2.2.3.1.4v1.2a26.1 26.1 0 0 1-.1 1.4l-.1.5s-.2.1 0 .1l1.1.2c.3 0 .6 0 .8-.2.4-.2.5-.7.4-1 0-.2-.2-.3-.3-.5a13 13 0 0 0-.4-.3.8.8 0 0 0 .7-.5c0-.3 0-.6-.2-.8l-.2-.2-.5-.1zm.8.4.6.1c.2.3.2.6 0 1l-.2.1h-.5v-.8zm-.2 1.5c.3 0 .6 0 .8.3.2.2 0 .5.1.7 0 .4-.3.6-.6.6-.2 0-.3-.1-.3-.3a9 9 0 0 1 0-1.3m1.8 2 .3.2.9.2.8.1.2-.5c0-.2-.1-.3-.2-.1a1 1 0 0 1-.9.1c-.2 0-.3-.2-.3-.4l.2-1.2.4.1c.2 0 .3.2.4.4l.1-.3v-.7c-.1 0-.2.4-.4.2-.2 0-.5 0-.4-.2l.1-.8c.3-.1.7 0 .9.3l.3.3v-.7l-.5-.2-1.3-.3c-.3 0 0 .2 0 .3l-.2 1.7-.2 1.2a.5.5 0 0 1-.2.3m3-2.8v.6l-.3 1.6-.2 1c0 .1-.4.2-.1.3l.7.2c.2 0 0-.2 0-.3l.2-.7.1-.4c.2 0 .1.3.2.4 0 .4.2.8.3 1.1l.6.5-.2-.5v-1.4c.1 0 .3 0 .5-.2.2-.3.3-.7.2-1a1.3 1.3 0 0 0-.6-.8l-1.2-.4a1.2 1.2 0 0 0-.2 0m.8.4a.7.7 0 0 1 .6.4c.1.4 0 .8-.1 1.1-.2.2-.4.2-.6.1-.2 0-.4 0-.3-.2l.2-1a.7.7 0 0 1 .2-.4m1.5 1.2.5-.2s.3-.1.4 0c.1.1 0 .3 0 .4l-.1.7-.4 1.6-.3.4c0 .2.2.2.3.2l.6.2c0-.1-.1-.2 0-.4l.2-1.2a31.3 31.3 0 0 1 .4-1.6c.2 0 .4.2.5.3l.2.5c.1 0 0-.2 0-.4l.1-.4-.8-.3-.6-.3-.7-.2za.3.3 0 0 0 0 .1m3.4.7c-.2 0-.2.2-.3.4 0 .2-.2.3-.3.5l-.9 1.4a1.1 1.1 0 0 1-.4.4c-.2.2.1.2.2.3.1 0 .3.2.4.1 0-.2-.2-.3 0-.5 0-.1 0-.4.3-.3l.6.4v.5c0 .1-.3.2-.2.4l.5.3s.3.2.2 0v-.8l.1-.5v-.8l.2-1.2c0-.2.1-.4 0-.4zm-.3.7s.1.1 0 .2v1.3c0 .2-.3 0-.4 0-.1-.1-.4-.2-.2-.4l.4-.6zm2.2.5-.1.6-.4.6-.4.7-.5 1h-.2l.5.5.6.6c.3.2.8.3 1.1.1l.5-.5a3.4 3.4 0 0 0 .3-.6v-1c0-.4-.2-.9-.5-1.2l-.6-.6zm.6.9c.3.2.5.5.4.8 0 .5-.2 1-.5 1.4-.2.3-.4.6-.7.6-.2.1-.5 0-.6-.3l.2-.6.8-1.4c0-.2.2-.4.3-.5z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#006300",
      d: "m308.8 279.2 2.5 1 1.8 3.4c.7.5.6.4 1.3.6l-4.3 1.8c-1.2.4-.7 1.5-.1 1.7.6.2 2-.3 2.4-.5 2.1-1 4-2 6-3.3.3-.2 1.7-1.1 2-1l7.6 4.2c.6.3 1.7 1 2.3.6.3-.2.6-.6.5-1-.1-.5-.4-.6-.8-.7l-4.1-1.8.9-.3c.3-.2-.2-.7.2-.6l1.9-3.1 2.3-.9c0-2.1-17.8-3.5-22.4-.1"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#ff0",
      d: "M310 286.5c-.6.2-.5 1.4.8 1 .9-.3.2-1.3-.8-1m19 0c-.3.5-.3.7.2 1 .5.1.7.1 1-.2.5-.4.1-.6-.2-.8-.4-.2-.1-.2-.4 0z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#006300",
      stroke: "olive",
      strokeWidth: 0.2,
      d: "M345.8 216v.3c1.7 3.2 1 1.7 2.4 5.9l-.8-1.1a30.2 30.2 0 0 1-2-3 1.3 1.3 0 0 0-.4-.6c-.2.3.4 2 .6 2.5.5 2 2.1 4.4 3.3 6.3l-.9-.7c-1-.8-.7-.6-1.3-1.7a20.3 20.3 0 0 1-1.4-3 51.6 51.6 0 0 0-.8-2.2l-.2.2v.9l.6 3.6c-.8-.3-.6-.4-1.3-1-.2 0-.4-.6-.6-.6l-.7-.8c-.1.4 1 2.4 1.2 2.6.4.6 1.8 1.6 2 2a14 14 0 0 0 2.1 3.7l.9 1.1-1.9-1.8a33 33 0 0 0-3.4-3c0 .4.6.8.9 1l2.3 2.6c.7 1 1.6 1.8 2.2 2.8l1.5 2.5a13.8 13.8 0 0 0-.8-1.1l-2.3-2.8c-.8-1-1.6-1.6-2.6-2.4a25.6 25.6 0 0 0-2-1.4c0 .3 1.9 2.7 3.2 3.4l1.2 1.3 1.2 1.3a36.3 36.3 0 0 1 1.9 3l.9 1.5c-.7-.2-4-4-4.7-4.7-.7-.7-1-1-1.8-1.5 0 .4 2.3 3 2.8 3.5l.5.6 1 1.1c.6.8 1.8 2.2 2.2 3l.7 1.4a20 20 0 0 0-1.5-2 7.8 7.8 0 0 0-.9-1c-.7-.8-1.9-2.2-2.8-2.8l-2.2-1.3c-.1.2.4.6.6.8l.9.8a21.7 21.7 0 0 1 3.1 3.4c.6.6 1 1.2 1.4 2a3.1 3.1 0 0 1-.7-.7l-.7-.7-1.6-1.2-3.6-1.8c0 .3 1.3 1 1.6 1.2.7.5 2 1.2 2.5 1.9l.7.7c.5.5 1 1 1.3 1.6l1.2 1.7 1 2 1.3 4.5c-.4-1.5-1.2-3-1.7-4.6-.4-1-1.4-3.8-2.8-3.3-.5.2-.8.8-1 1.2-.3.7-.8-.2-2 2a18.1 18.1 0 0 0-1.2 4.3v.7c.3-.1.5-.9.6-1.2.5-1.4 1-2.3 1.9-3.6l-1.1 4.9c.4-.1.5-.7.6-1l1.4-3.7c1.6 1.1 2 7.2 2.3 9.3a21.4 21.4 0 0 0-1.1-3l-1.7-2.8c-1 .1-1 1.4-1.2 2.1-.3-.4-.6-1-1.3-1-.5 0-.8.8-.9 1.4a7.7 7.7 0 0 0 0 2.2l.4 1.6.2.2.3-4.1c.6.3 1.8 3 1.6 4-.6 4-1 5.3-3.1 8.6l-1.2 1.7a10 10 0 0 1-.6.8l-.7.8c1.1-2 1.6-2.7 2.4-4.9a24 24 0 0 0 1.2-5v-.9c-.3 0-.3.4-.4.7-1.8 5.7-2.1 6-5.1 11l.5-3.3c-.2 0-.2.2-.3.6l-.2.6a17.8 17.8 0 0 1-1.6 3.6c0-.3.3-.8.4-1.1a26 26 0 0 0 .7-3.4v-.7c-.3 0-.4.6-.5 1-.4 1.2-1 2.2-1.4 3.3v-.3c0-.7.3-1.8.1-2.5v-.3c-.3.1-.4.7-.5 1l-.3 1c-.7 1.9-1.5 3.1-2.5 5-.6-.1-.2 0 0 0a209.5 209.5 0 0 0 5.7 1.1c2.8-.1 4.6-.3 7.4 0 .4 0 2.1.3 2.4 0-.8-.4-1.6-.6-2.5-.9l-2.7-.6 7.5-.2-.6-.4c-1.3-.5-4.6-.7-6-.8 2.5-.2 4.4-.4 6.8-.4.7-.2 2.9.5 2-.5-1-.6-3.8-.7-4.7-.6l4.4-.2c.7-.2 5.3.8 3.7-.2-1.3-.7-4-1.2-5.4-1.4.8-.5 1.5-1 2.3-1.3a40.7 40.7 0 0 1 5.3-1.7c2-.3 3.5-1.3.9-.9-1.6.2-3.5.7-5 .8l1.3-.7c1.3-.6 2.7-.9 4-1.3.3-.1.2 0 .3-.2l-.2-.1h-.8a65.1 65.1 0 0 0 7-2c.3 0 .7 0 .9-.2l-.2-.1a86 86 0 0 0-6.4.8l-2 .3 5-2c.4 0 1.6-.2 1.8-.5-.3-.2-.6-.1-1.1 0a36 36 0 0 0-4.7 1.2l-1.8.5c5.6-2.1 3.4-1.5 8.6-2.5.6-.1 1 0 1.1-.4l-3-.2c-1 0-2 .2-2.7.3l2.2-1.9c.6-.5.3-.7 1.4-.7h2c-.8-.9-1-.5-1.8-.9l1-1 .5-1c.1-.1.1-.1 0-.2h-.3l-2.3 2c-.4.2-.3.2-.9.2l-3 .6a24.7 24.7 0 0 1 3-2.1l1.7-1c.5-.2 1.6-.6 1.7-.8l-3.6.9a19.2 19.2 0 0 0-3 1.5 45.8 45.8 0 0 1 5.8-5.2c.2-.1.8-.4.9-.7h-.3c-1 .2-3.2 1.7-4 2.1a36.3 36.3 0 0 0-3.8 2.8 27.9 27.9 0 0 1 2.7-2.6l.5-.5 1.1-1c.8-.6 1.5-1.2 2.2-2l1.1-.9c.3-.2 1-.7 1-1a55.3 55.3 0 0 0-4.4 2.7l-2.1 1.5-2.1 1.6c.9-1.4 1.8-2.9 2.9-4.1a45.6 45.6 0 0 1 4.7-4.4c.4-.3.8-.8 1.2-1v-.2c-.4 0-1.6.9-1.9 1.1a38.5 38.5 0 0 0-4.7 4l-.7.8a15 15 0 0 0-2 2.4 62 62 0 0 0-2.4 3.6c.5-2.2 2-4 3.2-5.2l2.7-3 .4-.5a10 10 0 0 0 3-5.8l-1.3 1.8-.7.7-5.4 6.3c.2-.9 1.3-2.8 1.8-3.5a63.3 63.3 0 0 1 5.6-7.5l.3-.3c0-.3.4-.5.8-.9l1-.8c-.5-.5-2.4.6-2.7.9-2.4 1.6-4.1 3.9-5.9 6.1a26.1 26.1 0 0 1 2.4-5.7c.5-.8 1-1.8 1.6-2.5l1.6-2.4c-.4 0-.8.5-1 .8l-.5.4c-2 2.3-3.3 4.8-4.8 7.5.1-1.3 1.3-3.7 2-4.8l2.8-4.2c-.5-.1-2 1.6-2.3 2-.6.8-1.3 1.6-1.8 2.6a31 31 0 0 0-2.7 5.5l-.2.4c.1-1.8 2-6.1 2.7-7.6l1.6-2.2.5-.7 1.1-1.4 1.1-1.5c-.7-.2-3.2 2.6-3.7 3.2l-1.7 2.5c.3-1.4 1.3-3.3 2.1-4.5l2.1-2.7.7-1c-.8 0-4 3.7-4.7 4.5l-.7 1.1-1.1 1.7-.2.3-.2.3a37 37 0 0 1 1.4-5.3l2-4.5c-.5 0-1.6 1.4-1.9 1.8l-1.2 2.5c.1-1.2 1.8-5 2.4-6.5-.3 0-.5.6-.8 1l-2.3 3.8c.1-1.3 1-2.6 1.5-3.7-1 .4-2.8 4.2-3.2 5.3l-.5 1.6-.2.6c0-2.8.5-5.7 1-8.5-.3 0-.4.3-.5.6l-.3.7-.6 1.6-.8 3.4c-1.2-1.7-1.5-4.8-3.9-8.4-.7-1.1-1-1.2-2-2zm1.3 33.8c1 2.8 1.3 3.7 2 6.6a.7.7 0 0 0-.2.3l-.4 1.2-.8-2.5c-.2-1 .2-2.8-.2-3.1-.2.5-.2.5-.2 1.4l-.5-1c-.5-1.6-.6-1.1-.2-2 0-.3.2-.7.5-.9z"
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "#008f4c",
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "M354.4 245.1c.4-3.8 5-12.8 6.5-13 .2 0-1.6 2.5-2.8 5a56.7 56.7 0 0 0-3 7.3 17 17 0 0 1-.7 2.6zm10.2-2.3s-.8.9-1.9 1.8a44.3 44.3 0 0 0-9.6 13.8c-2 5-1.5 3.7-.9 1.3a35.3 35.3 0 0 1 9.7-15.1c1.4-1.2 2.8-2.1 2.7-1.8m-11.8-8.6c0-3.4.4-4.6 2.4-8.8 1.2-2.7 1.7-3.5 1.9-3.3 0 .1 0 .6-.3 1a50 50 0 0 0-3.4 11.7 5.5 5.5 0 0 1-.4 1.7 7 7 0 0 1-.2-2.3m-5.6 19.4a20.2 20.2 0 0 1-1.4 8.8c-.7 1.8-3.5 6-4.2 6.4-.3 0-.2 0 .5-1a22.1 22.1 0 0 0 5-13.4c-.2-2.6 0-3 .1-.9z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M355.8 250.3c.4 1.2.5 4 0 5.5a11 11 0 0 1-7.2 7.5 5.7 5.7 0 0 1-1.3.3 5.4 5.4 0 0 1 1.2-.7 12.4 12.4 0 0 0 7.3-11c0-1-.1-1.4-.2-1.6 0-.4-.1-.7 0-.8z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "m365.7 257.9-4.4.8a194.8 194.8 0 0 0-9.3 1.6.9.9 0 0 1-.1-.3 168.7 168.7 0 0 1 13.8-2.1m-18.5-39.7c1.5 1.8 1.8 2.6 2.6 5.7.5 2 .6 2.6.5 2.6l-.4-.7a34.4 34.4 0 0 0-3.2-7.7 3.8 3.8 0 0 1-.6-1 5 5 0 0 1 1 1zm-1.6 2.2c.6 2.2 1.1 3 3.3 5.3 1.4 1.4 1.9 1.9 1.9 1.7 0 0-.1-.4-.4-.6a34 34 0 0 1-4.6-6.9 3.8 3.8 0 0 0-.6-1s0 .7.4 1.5m13.4 7c-2.4 2.2-6.3 9.2-5.7 10.3.1.1 1.1-1.5 2.2-3.6a48.4 48.4 0 0 1 3.4-5.8l1.4-2zm1 1.8c-2.6 2.4-6.9 10.2-6.3 11.4.1.2 1.2-1.6 2.4-4a54.3 54.3 0 0 1 3.9-6.4 15.7 15.7 0 0 0 1.5-2.1zm-15.2-7.1c.4 2.3.8 3 2.6 5.6 1.2 1.7 1.7 2.2 1.7 2 0 0 0-.4-.3-.6a34.3 34.3 0 0 1-3.7-7.5 3.8 3.8 0 0 0-.5-1.1z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "m348.4 226.7 2.6.7c0-.2-.4-.3-.7-.4-1.7-.5-6.4-2.6-6.5-3.4l-1-1.5s4 4 5.6 4.6m16.2 8.3c-3.6 2.5-10 11.2-9.5 12.8 0 .3 1.7-1.7 3.6-4.4a65.8 65.8 0 0 1 5.7-7.3 19 19 0 0 0 2.1-2.3s-1 .5-1.9 1.2m-.5 5.3c-1.6 3.2-7.7 9.3-9 9a15 15 0 0 1 3.1-3.3 51.8 51.8 0 0 0 5-5.4 15.6 15.6 0 0 1 1.6-2c0 .2-.3 1-.7 1.7m-21.4 22c-.6 3.1-4.5 9.8-5.7 9.9-.1 0 .7-1.7 2-3.7a47.3 47.3 0 0 0 3-5.8l1-2zm10-18.9c-.7-2-2.5-4.4-5-6.6-2.4-2.2-3.2-2.5-1-.5a29 29 0 0 1 6.3 8.8s0-.8-.3-1.7m1.8 25.5c-2.8-.8-10-.7-10.5.1 0 .2 1.6.2 3.8.1a47.3 47.3 0 0 1 8 .3zm-3 1.2c-2.9-.7-10-.3-10.5.6h3.7a47 47 0 0 1 8.2-.1zm-3.2 1.6c-2.8-.7-10 0-10.5.8l3.8-.2a47.8 47.8 0 0 1 8.1-.2z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M346.4 273.5c-2.3-1-8.6-1-9-.3-.2.2 1.3.3 3.2.2a36.1 36.1 0 0 1 5.2.3l1.8.3a9 9 0 0 0-1.2-.5m11.2-8.9c-6 1.7-13 2.7-13.4 4.1 0 .2 2.6-.2 5.2-1.2a56.4 56.4 0 0 1 7.5-2.4c1.5-.3 2.7-.6 2.7-.8 0 0-1 .4-2 .3m7.6-3.7-5.2 1a213 213 0 0 0-8 1.5c-2.4.5-2.9.6-3 .3a1 1 0 0 1-.2-.3 197.6 197.6 0 0 1 16.4-2.5m-1.8-1.5-4.3 1.2a174.5 174.5 0 0 0-9 2.5.9.9 0 0 1-.2-.2 168.8 168.8 0 0 1 13.5-3.5"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M362 252.4c-4.1 1.7-12.2 8.8-12 10.5 0 .3 2-1.3 4.4-3.6a64.4 64.4 0 0 1 7-5.8 18.7 18.7 0 0 0 2.6-1.8z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M365 254.4c-4 .3-13.3 4.4-13.5 6 0 .3 2.1-.5 4.9-2a56 56 0 0 1 7.8-3.2l2.8-.8z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M364.8 254.8c-10.3 8.7-16.1 13-18.2 12-.3 0 3.8-2.4 7.3-4.7a78 78 0 0 0 9.4-7l3-2.7a18 18 0 0 1-1.5 2.4m-11 2.8c2-3.4 3-4.4 7.5-7.2 2.9-1.8 3.9-2.4 4-2l-1 .8a56.1 56.1 0 0 0-11.8 10.7zm1.1-9.8c.4-3.8 6.8-16.5 8.2-16.7.2 0-1.5 2.5-2.7 5a57 57 0 0 0-3 7.3 74 74 0 0 1-2.8 7zm-2.7-14.6c-1.1-2.6-1.2-3.6-.4-7.2.5-2.3.8-3.1 1-3v.9a28.7 28.7 0 0 0 .2 11s-.5-.8-.8-1.7m2 13.9a15 15 0 0 0-4.5-6c-2.2-2-2.9-2.3-.9-.4a26 26 0 0 1 4.9 6.6l.7 1.3zm-10 2.9c2-7.4 3.7-6.1 3.7-6.1 4.4 4.2 2.2 18.7 2.2 18.7 0-29.6-5.9-12.6-5.9-12.6"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M345.9 249.5c2-7.4 2.5-7 2.5-7 3.7.7 3.5 17 3.5 17-1.6-28-6-10-6-10m-2 5.7c0-5.3 1-4.5 1-4.5 3 2.7 4 13 4 13-4.6-20.8-5-8.5-5-8.5m9-15.5c-.8-2.9-3.6-5.8-6.4-9.5-3.5-3.2-4.6-3.7-1.5-.7 2 1.2 6 7 7.2 10.5.6 1.2 1.1 2.1 1.2 2 .2 0 0-1.1-.4-2.3z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M352.7 237.2a18 18 0 0 0-5.2-7.4l-1.6-1.5A60 60 0 0 1 353 239c.1 0 0-.9-.3-1.8m-15 29.3c-.1 1.5-1.8 5.1-2.4 5.2l.8-2a24 24 0 0 0 1.7-4v.8zm-1.4.9c-.2 1.6-1.9 5.1-2.5 5.2l.8-1.9a24.1 24.1 0 0 0 1.8-4.1v.8zm2.2.1c-.2 1.6-1.9 5.2-2.5 5.2l.9-1.9a24 24 0 0 0 1.7-4.1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#00873f",
      d: "M284 227c0 .8.2 1 .6 1.5V227c-.2-.2-.3 0-.6 0"
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "none",
      stroke: "#006300",
      strokeWidth: 0.6,
      transform: "translate(-106.1 -20.4) scale(.85227)",
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "m455.2 304-.9-.8m1.8-4.6-.8-1m-1.7 13.5c-.3-2.1-1.5-2.8-1.5-2.8m11.3 30c-5.4-6-7.1-16.7-7.1-16.7 1.7-4.6 4-5.6 4-5.6m-4 5.5c-1.8-7-1.3-14.2-1.3-14.2a70.8 70.8 0 0 1 3.4-16.8m-3.5 19.3c1.4-6.6 6.9-5.8 6.9-5.8"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M454.8 311c5-2 4.3-6.3 5.2-8 1.3-2.7 2.3-3.5 2.3-3.5m-2.6 32.9c-1.7-4.2.3-5 .3-5m-1 3.6c-2.1-2.7-4.8-2.5-4.8-2.5m3.9-10.3c1.3-2.4 0-4.8 0-4.8m.6 16.3-3.8-4.9m2.3-30.4c.5-2-1-2.9-1-2.9"
        }),
        /* @__PURE__ */ jsx79("g", {
          transform: "translate(442 224.2) scale(.1567)",
          children: /* @__PURE__ */ jsx79("path", {
            id: "do_svg__a",
            fill: "red",
            strokeWidth: 2,
            d: "M91.4 426a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
          })
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(.1567 0 0 .18128 444.6 235.3)"
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(443.7 248.3) scale(.1567)"
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(440 252) scale(.16899)"
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(438.7 256.2) scale(.16899)"
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(440.3 257.8) scale(.16899)"
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(463.2 286) scale(.12289)"
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(464.3 287.3) scale(.12289)"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M458.8 316.6a1.8 1.8 0 0 0-1.1-1.2m14.7 24.1c1.6 1.2 2 .5 2 .5"
        })
      ]
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "#006300",
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "M298.2 271.8c-.9-3-.7-3.6-.7-3.6m-6.5-1.7s-.5-1.2.4-1.9c.4-.4 2.5.8 3.6-3.9 0 0-.7 0-2.1.7v-.4s-.4-1-.2-2.3c0 0 .7-1.1.7-1.6 0 0-1.3-.5-4 2.9 0 0-.2-.7-2.1-2 0 0-1 3-.5 4.6.4 1.3.4 1.8 1.8 2.7 0 0 1 .5 1.2 2l1.2-.1zm-2 3.4c-.3.2-.5.5-1.3.6-3.3.4-5.2-4-5.2-4-.1-1 .3-.5 1-.2.9.3 1.2 0 2.2 0 1.4-.2 2.9 1.1 2.9 1.1.8.8 1 2.3 1 2.3-.2.2-.5.2-.5.2zm-4-8c-3.4-1.5-5.5.2-5.5.2-.2.2.2.3.2.3 2.2.3 1.5.1 2.4 1.4 1.6 2.2 4.4 1.7 4.4 1.7.5.2 1.1.8 1.1.8-.2-1.9-2.5-4.4-2.5-4.4zm-6-14c-.7-.5-.6.4-.6.4-1.4-2.5-5.3-2.7-5.3-2.7a.7.7 0 0 1-.5-.3c-.6 0 .2 1.3.2 1.3 1.1 3.1 2.2 3.5 2.2 3.5-1.3.7-3.4-.9-3 .3 2.1 2.1 3.5 2.4 3.5 2.4 2.6.7 3.7 0 3.7 0 .6 1.1 1 1.3 1 1.3 2.4.7 2.9 2 2.9 2 0-2.6-1-5.7-1-5.7a12 12 0 0 0-3.1-2.5"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M297.2 272.7c-1.3.4-1.4 1.3-1.4 1.3-1.2 1.7-5.6 0-5.6 0-1.4-.3-1-.7-1-.7a5.6 5.6 0 0 0 1.6-1 8.6 8.6 0 0 1-2.7-5c3.6-.7 4.7 0 4.7 0-.2-1.4-1.4-1.4-1.4-1.4-.3-.5.3-.5.3-.5a7.8 7.8 0 0 1 5 2.3c1.2 1.7.8 3.4.8 3.4.3 1.7-.3 1.6-.3 1.6M282.3 258c-1.8-.5-2.8 0-2.8 0-1 .4-2.6-.6-2.6-.6-2.2-1.9-2.6-3-2.6-3 0-.3 1.9-.3 1.9-.3 2.6 0 3.2.5 3.2.5 1.3.7 1.2 1.4 1.6 1.7a5 5 0 0 1 1.4 1c.3.5.4.9-.1.7m3.4 1c1.3-1.5 3-.5 3-.5 2.5.3 3.3-2.6 3.3-2.6l1-1.7c.1-.7-1.1-.1-1.1-.1-2.2.5-2.3.7-2.3.7l.4-3.4c0-.6-.6-.2-.6-.2-3.1 1.8-3.5 3.1-3.5 3.1l-1.3-2.4c-.4-1-.7.1-.7.1-.6 3-.3 3.2-.3 3.2.4 1.6.8 2 .8 2 .7 1 .7 1.4.7 1.4z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M304.2 267c-.5.1-1.8 2.2-1.8 2.2-1.6-3-3.7-3.4-3.7-3.4-.4.1 0 .8 0 .8.7 1.6 0 2.8 0 2.8-.2 1.2 0 1.4 0 1.4-2.5-1.3-2.6-1.1-2.6-1.1 0 1.6 1.8 4.5 1.8 4.5l4.5-1 1.5-.2c1.2-3.6.3-6 .3-6M284 250.8c1.6.7 1.7 1.8 1.7 1.8.4 1.3 4.1 1.7 4.1 1.7 3-.3 2.7-1 2.7-1-1.7-1.4-1.2-1.3-2-2-1.3-1.3-3-1.4-3-1.4-2.3.4-2.8 0-2.8 0-.9.4-.7.9-.7.9m-3.6-5.4c-.7-2.7 1.7-6 1.7-6 2 3.8 1.7 4.8 1.7 4.8a24.6 24.6 0 0 1-1.7 4.5c-.4-2-1.4-2.3-1.7-3.3"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M279 246.5c-2.5 0-5-2.9-5-2.9 3.9-1 4.7-.4 4.7-.4a22.7 22.7 0 0 1 3.6 2.5c-1.8 0-2.3.8-3.2.8z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M277 242.8c-1.6.3-3-1.3-3-1.3-2.2-3-1.5-4-1.5-4 .2 0 .4.3.4.3.7.6 2 .8 2 .8-3.6-2.2-1.2-7.1-1.2-7.1.4-.5.6.7.6.7a4.6 4.6 0 0 0 1.8 2c.8 1 .8 1.4.8 1.4.3-1.6.8-1.2.8-1.2.4 1.3 1.9 2.3 2 3.2.6 2.5.2 2.8.2 2.8-.3 1.4-.3 2.5-.3 2.5-1.4-.5-2.5 0-2.5 0zm8.4 6c.8-1.2 0-3.3 0-3.3-.3-2.3 3.1-4.5 3.1-4.5 1 1.9.9 3 .9 3l3.2-.8c.1 1.4-1.3 3.6-1.3 3.6 2.1.6 2.9-.4 2.9-.4-1 4.7-5.6 3.8-5.6 3.8a8.8 8.8 0 0 0-3.2-1.4"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M278.3 234.9c.3-2.9.8-3 .8-3 .3.1.4 1.4.8 1.6 1.8.8 1.8 2.8 1.8 2.8 0 2.3-.4 2-.4 2-2.5 0-3-3.4-3-3.4m8.3.6c.9-3.3.3-3.6.3-3.6-.3 0-1 1.3-1.6 1.4-2.3.1-3 2.3-3 2.3-1 2.5-.5 2.4-.5 2.4 2.8 1 4.5-1.4 4.8-2.5"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M278.4 229.5c.3-3.3 1-3.5 1-3.5.3.2.5 1.7 1 1.9 2 1 2 3.2 2 3.2 0 2.7-.4 2.5-.4 2.5-3 0-3.7-2.9-3.6-4zm9.4.8c1-3.2.4-3.5.4-3.5-.4 0-1.1 1.3-1.6 1.3a3.7 3.7 0 0 0-3.2 2.2c-.9 2.5-.4 2.5-.4 2.5 2.7 1 4.4-1.3 4.8-2.5m3.8 9c2.7-2 2.5-2.6 2.5-2.6-.3-.2-1.7.4-2.1.2-2-1.3-3.9 0-3.9 0-2.2 1.4-1.8 1.6-1.8 1.6 1.6 2.5 4.4 1.6 5.3.9z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M291.5 241.1c2.6-1.1 2.5-1.6 2.5-1.6-.2-.3-1.5 0-1.8-.3-1.4-1.2-3.1-.6-3.1-.6-2.1.8-1.8 1-1.8 1 .9 2.2 3.3 2 4.2 1.5m-8.7-15.4c-1-3 2-7 2-7a40.5 40.5 0 0 1 1 3.4c2.4-2.5 4.6-2.9 4.6-2.9l-.1 2a6.8 6.8 0 0 0 2.3-.6c-.4 2.4-3.4 4.9-3.4 4.9-1.2.7-2.6.4-2.6.4-2.2.7-2.7 2.1-2.7 2.1-.2-1.3-.4 0-1.1-2.3m4.4 10c1.4-1.7 3.5-1 3.5-1 2 .2 3.7-1.8 3.7-1.8a5.6 5.6 0 0 1 1.4-1.8c0-.5-.6-.4-.6-.4l-1.1.3c.9-3.3.4-3.4.4-3.4-.3 0-.5.2-.5.2-.5 1.5-2.6 1.4-2.6 1.4-.1-2.2-.6-1.9-.6-1.9-.3.6-1 1-1 1-2.1 2-2.1 2.9-2.1 2.9.1 2.4-.5 4.6-.5 4.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "#00863d",
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "m286.8 247.7 1.4-1c.5-.3.3-.2.5-.7l.5-.7-.3.9 1.4-.8c0 .3-.5.5-.9.8a22.6 22.6 0 0 1-1 .6l-1.9 1.6c1.8-.4 1.4-.1 2.3-.2 1.9-.3 2.8-3 3.4-4.5a9.9 9.9 0 0 0-3.5 1.1c-1.2.8-1.2 1.6-1.9 3zm-4.8 6.7c0-.3-.4-.8-.6-1-.5-1-.5-1.2-1.2-2.3l-.5-1c.2 0 .6.8.9 1v-1c.3 0 .2.3.2.6 0 1 0 .9.6 2l1.3 2.2c0-.4-.2-.7-.3-1-.4-1.4.5-3.1-3-5.2l-.9-.5c0 1.7.3 4.5 1.8 5.4l1 .4zm-.8-21.5c0-.4-.3-.8-.4-1.3-.2-.4 0-.3-.4-.5l-.4-.5.5.2a3.3 3.3 0 0 0-.4-.8c-.3-.4-.2-.1-.5-.7.6-.1 1.2 1.7 1.3 2.1.5 1.4.4 1.2 1.3 2.3 0-.2-.4-.5-.4-.8-.2-.7.6-1.7-.2-3.4-.5-1-1.5-1-2-1.9l-.4-.8a7.6 7.6 0 0 0-.4 1.8c0 1.2.2 2.7 1 3.5.3.3 1 .7 1.4.8m4.5-8.5c.2 0 .5-.5.8-.8l.8-.7-.1-.8c.2 0 0 0 .3.5l1-1.4c0 .3-.4 1-.6 1.2-.2.4-.4.7-.8 1l-1.6 2 1-.3c1-.2 1.4-.3 2.1-1.5a10 10 0 0 0 1.2-3.8c-1.5.6-3.1 1.3-3.9 2.7-.3.5-.2 1-.2 2zm-9.5 14.3c-.5-1-1.7-2.4-1.8-3l-.2-1.3c.3 0 .2 0 .2.2l.2 1 .5 1c0-.7 0-.4.2-1 .3.4-.1 1 .2 1.6l.8 1.2c0-1 .6-2.4-.4-3.7-.4-.5-.8-.7-1.3-1l-.9-1.4c-.7 1.5-.5 4.5.9 5.5l.8.5.4.2zm6.8-6c.6-.4.4-.6 1.8-1.7l.9-.9.9-.9c.1.3-.8 1.2-1.1 1.6h.6c-.1.4-.5.1-1 .3-.3 0-1.4 1.3-1.7 1.6l.8-.2c.9-.2 1.5 0 2.4-1.2.8-1 1-2.3 1.5-3.5-1.2.3-2.7 1-3.4 1.6-1 1-.9 1.7-1.2 2.6zm-4.8 9.3a4.9 4.9 0 0 0-.8-.8c-.5-.3-.6-.3-1.2-.4l-2-1.1c.2-.2.3.1.8.4l1 .4-.2-.5c.2 0 .2 0 .3.2v.3c1 .1.8.1 1.7.7 0-.4-.1-.4-.4-.6l-.5-.5-.4-.6c-.8-1.2-1.7-.7-2.2-.8l-1.5-.6a5.6 5.6 0 0 0 1.7 3.1c.4.4.9.8 1.6.9zm-.8 7.5a8.1 8.1 0 0 0-1-.7c-.2-.2-.3-.2-.6-.2l-.7-.2h.7l-.3-.3-1-1c.2-.1.3 0 .5.2l2.3 1.8 1.1.6c0-.6-1-2.4-1.8-2.8l-3.7-1a15 15 0 0 0 1.5 2.8c1 1.5 1.2 1 2 .9zm1.8-8.1-1.4-4.6c.2.1.2.4.3 1l.4.9.3-.7c.2.2 0 .6 0 .9-.2.4-.2.3 0 .8l.6 1.6v-1c.3-1 .5-1.6 0-2.8-.5-1-1.3-1.7-2-2.5l-.3 1.8c-.2 1.2-.1 2.8.8 3.5.8.6.3.1 1.3 1zm2.7 5.8v-4.7c.2.1.2.3.2.4v1.5l.4-.7c.3.1 0 .4-.1.6l-.4.8.1 2.1.4-.8c.5-.7 1-1.8.8-2.8l-1.2-3.4-.8 1.6a7.3 7.3 0 0 0-.5 1.9c-.3 1.6.2 1.9.7 2.7zm1.9-20.3c0-.4.2-2.5.1-2.7l-.2-.4-.2-.9c.3 0 .2.3.4.6v.1l.1-.6c0-.4 0-.2.2-.6.2.1 0 0 .1.2a3 3 0 0 1 0 .3c-.2 1.4-.2 3-.3 4.3l.4-.8c.3-.7 1-2 .9-2.8l-.8-4.1-.8 1.6c-.5 1.1-1 2.8-.7 4l.7 1.6zm-11 23.6 1.1 1c.7.5 2.3 1.2 3.1 1.2l1.8-.4-.2-.8-1 .1a6.7 6.7 0 0 1-1.2 0 14.8 14.8 0 0 1-1-.2c-.6-.2-.4 0-.9-.4l2 .3c-.6-.4-.4-.2-.8-.7.3 0 .9.5 1.2.7l1.6-.1-.1-1c-.8-.3-2-.3-2.9 0-1.7.6-1 .4-2.7.3m2.2 4.3c0 .3 1.8 2.3 2.2 2.5l3.9.1a16.1 16.1 0 0 0-1.7-.7c-.8-.3-.8-.2-2 0 0-.3.3-.3 1-.4l-1.5-.5-.2-.2h.5l4 1.5a4.5 4.5 0 0 1-1.1-1c-1.6-2-3.2-1.4-5.1-1.3m13.3-21.3.5-1c.3-.7-.1-.7 0-1.5.3 0 .2 0 .3.7l.7-1.6c.2.6-.9 2.6-1.1 3.2l-.4 1c1-1 2-1.5 2.2-2.4l.1-4c-.6.5-1.5 1.4-2 2.1-.6 1-.6 2-.4 3.5zm-1.8 24.2 1-.5c1.5-.4.9.3 1.8-1l-.2.7c.7-.3.8-.7 1.3-1.2.2.3-.2.7-.4.9-.9.8-1.7.5-2.2.7l-1 .5c1.1-.2 1 0 2 .2 1.8.3 2.4-1.6 3-2.8l.5-.8a9.6 9.6 0 0 0-4.5 2.2l-.6.6c-.3.2-.5.2-.7.5"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M286.4 247.5c.6-.6.5-2.1 1-3 0-.2.2-.3.3-.4.1-.2 0-.2.3-.2.1.2-.3.4-.4.7l-.3 1 .1-.1a.9.9 0 0 0 .1-.2c.5-.6.9-.8 1.6-1.2l-.7-2.4-1.2 1a5.6 5.6 0 0 0-1 1.2c-.8 1.5.1 2.2.2 3.6m-.4 10 1.6-2.6v-1.2c.2 0 .1-.1.3.7.5-.8.2-.7.8-1a6 6 0 0 1-.8 1.4l-1.5 2.5c.4 0 .9-.6 1.1-.9l.6-.5.7-.4.7-3.6a10 10 0 0 0-2.7 2c-1 1.2-1 1.6-.8 3.6m3.5-9 2-.3c0 .3-.3.3-.9.4l-3.6.1.9.5.8.4c.7.4 1.4.3 2.1 0l2.7-2.4c-1.4.3-.6.4-2.5 0l-1 1zm-14.5-5c.6 1.2 2.3 2.6 3.8 2.4.7 0 .8-.3 1.2-.7h-.1a.7.7 0 0 0-.2-.1c-1.2-.3-1.3-.2-2.5 0l.5-.3-.9-.2-.8-.4c.2-.1.1-.1.4 0 1.5.5 1.9.4 3.6.7-.2-.5-1.5-1.2-2.2-1.3-1.2-.1-1.6.5-2.8-.1m10 13.6-.5-3.3c.3 0 .2.2.3.9l.6 3c0-1.2.4-2 .1-3.2l-1.2-2.2a9 9 0 0 0-.3 2.7c0 1 .3 1.3.8 1.9zm4.5-33.7.4-.5.5-.4c0 .3-.4.6-.6 1-.4.5-.7.6-.9.8-.7 1-.6.8-1.8 1.3 2.4.2 3.8-2.4 4.8-4.2-2.3.3-1.9.5-2.1 1.2zm.8 10.4.7-1.1c.4-.6.6-.2 1.3-.8-.2-.2-.2-.1-.9.1l1.2-1.5c-.7.1-2 2.3-2.3 2.8l-.8.9c.5-1.4.3-2.7 1-3.3l3.7-2.3c-.1.9-.5 2.1-.9 3-.6 1.1-1.5 1.6-3 2.2m-9.2 4.4-1.1-1.6-.5-2.2c.3 0 .3.6.3.9l.3 1c.2-.8-.1-.3.3-1 .2.5-.3 1.1 0 1.5l.7 1c.3-1 .3-2.3-.3-3l-1.7-1.8c-.4.6-.4 2.4 0 3.3.3 1 .7 1.2 1.3 1.5zm1.4-.3c.5-.5 1.5-1 1.7-1.3l1.4-2c-.3-.1-.5.5-.7.7l-.6.9c0-.8.2-.2 0-1-.4.4-.2 1.2-.6 1.5l-1.1.8c0-1.1.5-2.5 1.4-3l2.5-1.4c.2.9-.5 2.8-1.1 3.6-.8 1-1.2 1-2 1zm4.6.3c.6 0 2.5 0 3-.4l.8-.3c0 .2 0 0-.3.4h1.1c0 .1.2.1-.6.2l-2 .2-2.7.3c1.8.6 2 1.6 4 .8 1.6-.6 2-1.2 3-2.4-2.6.6-2.8-1.5-5.2 0z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M290.4 239.7c.6 0 .3 0 .9.2-.3.2-1.4 0-1.8 0h-1.8c.6.8 1.6 1.2 2.9 1 1.3-.1 1.7-.4 2.7-1l-2-.7zm-.8 11.5a3.2 3.2 0 0 0-.9-.5c-1-.5-2 0-2.5 0l-1.3-.2a6 6 0 0 0 2.4 1c1.7.3.5.7 2.3-.3m.2 1.2.5.5c-.1 0-.3 0-.5-.2l-.1 1.2 2.3-.3a17 17 0 0 0-2-2.2zm-3 .7 1.4-1c-.3-.4-1-.3-1.5-.5l-1.3-.5.7 1zm6.7-20.6c-.6.4-1 .9-1.7 1.2-.9.4-1.8 0-2.4.6 1.5-.1 2.5.5 3.7-.6.8-.7 1.4-1.7 2-2.6a2.7 2.7 0 0 0-1.2.4l-.3.5c-.3.4 0 0 0 .5zm-5 35 1 2.2 1.6 2 1-.7 1.3-.4c-.7-.3-.7-.6-1.1-.7h-1.7c.1-.3 0-.2.8-.2h.8c-.5-.5-1.1-.8-1.6-1.2l1.6.9v-1.1c.4 0 .1.7.3 1.3.1.2.6.6 1 .7.5.3.7.2 1.2.4l1.3.4c-.5-.8-.2.1-1.1-1.8a3.4 3.4 0 0 0-1.4-1.6c-1.5-.9-3.3-.3-5-.2m1.9-2.3v-2.7l-.3-2.1c.2 0 .2.1.3.4l.1.6c.2-1 .3-1 .8-1.6 0 .2-.5 1-.6 2l-.1 2.7.2-.3.3-.3.5-.6c1.3-2 .5-3.2.5-3.8l.4-2a9.5 9.5 0 0 0-1.8 1.3c-1 1-2 2.8-1.3 4.3l.5 1 .4 1.1z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "m289.7 273 1.8.6c1.1.4 3 .5 3.8-.6.5-.6.8-.7 1.3-1.2-.8 0-1.5.4-2.2.5-.6.2-.6.6-1.1 1l-.4.3c0-.3.5-.8.8-1.1h-1.8c0-.3.6-.2 1.3-.2 1.5-.2 1.8-.6 3.4-.8a.7.7 0 0 0 .3 0c-2.4 0-3-1.7-5.9.4zm11-1.5v-1.2c-.5-.4-.5-.6-.8-1.2.3 0 .4.5.9.8 0-.6-.3-1.6-.5-2.2.3 0 .4.8.5 1.1.4 1.4 0 2.5.3 3l.7 1c.2-1 1.3-1.7 0-4.1-.7-1.5-1.3-1.8-2.5-2.7.1.7.3 1 .2 1.8l-.4 1.6c-.2 1.3.3 1.2.5 1.3zm-12-2.3-.3-.8c-1 0-1.3.4-2.8-.6-.3-.2-.3-.2-.5-.6l1.6 1-.6-1c0-.1 0-.2.1 0h.2l.7 1h1l-.2-.7c-.1-.4 0-.4-.3-.6a2.8 2.8 0 0 0-1.4-.6l-1.6.2-1.6-.3c0 .3.7 1.3.8 1.6.7 1 2.5 2.3 4 1.7zm-8.4-7.5h.1l.2.1a3 3 0 0 1 1.1.8c.5.4.5.7 1.1 1.2 1 .9 2.1.8 3.5 1a7.2 7.2 0 0 0-.6-.7c-1.1-1.2-1-1.1-1.6-1H283c0-.2.7-.2 1.2-.3a3.1 3.1 0 0 0-.7-.3c-.6 0-.2 0-.9-.2.3-.4 1.8.2 2.5.8l1.6 1.8-.8-1.7c-.8-1.5-3-2-4.5-1.7a4 4 0 0 0-1 .2zm9.5 3.9c-.5-1.8-1.5-2.6-1.7-3.7-.2-.7-.1-.7 0-1.4.4.5-.3.8.8 2.6 0-.6-.2-.8-.1-1.5l.4-1.4c-.1-.3-1.4-1.5-1.7-1.9-.2 1.6-.6 3-.1 4.6.5 1.6 1.4 1.3 2.4 2.7m8.6 8 1.1-.2a6.3 6.3 0 0 1-.7-1c-.5-.7-.4-.7-.2-1l.1.6.4.4c.2.4.4.6.8.9 0-.6-.2-.8 0-1.2.2.1 0 0 .1.2l.1 1 1.3-.4c-.9-1.5-2.5-2-4-2.6l.4 1.8zm-2-3.2-.5-1c-.4-1-.4-1.3-1.2-2.2l-.4-.4-.3-.3v-.1c.2 0 .8.6 1 .8.5.4 1.6 2.8 2 3.5-.1-.3-.3-.7-.2-1 .4-1-.5-2.4-1-2.7l-3.5-1.5c.4.4.7.6 1 1.2.2.6.3.1 1.2 1 1 1.1 1 2.4 2 2.7z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "m302.9 270.4.1-.5c.2-.3 0-.2.3-.4.2.2 0 .3-.1.7l-.7 2.5c.8-.1.7-.1 1-.7.3-.4.4-.9.5-1.3l-.1-3.3-1 1.3c-.5.7-.2.3 0 1.7m-10.6-7.5c.3-.1.8-.8 1.1-1 .1.2-.5.9-.7 1-.6.6-.2 0-1 1 1.6.2 2.2-1.8 2.7-2.8l-1.5.4c-.2.1-.1 0-.2.3l-.1.4c0 .3-.2.5-.3.8z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "#ce1126",
      stroke: "#000",
      strokeWidth: 0.2,
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "m307.6 281.8 1.9 1-1.1 2.1c.8-.1 3.6-1.1 4.6-1.4-.3-.7-.4-.7-.3-1.6l-.3-1.5-2.3.8a19.2 19.2 0 0 1-2.5.6zm24.8-.3-1.9 1 1.1 2c-.8 0-3.6-1-4.6-1.3.3-.7.4-.8.3-1.6l.3-1.5 2.3.8z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M314.4 284.8a12.4 12.4 0 0 0 4-1.4c.4.3 2.1 0 2.1 0a8.8 8.8 0 0 0 1.1-.2 10.1 10.1 0 0 0 3.8 1.6c1.9-.1 2-1.6 2-1.6l-.3-1.3c1-1.6 0-2.8 0-2.8-.6-.6-3.5.3-3.5.3-2 1-2 .5-2 .5-.6-.8-2.6-.7-3.5 0l-2.5-.6c-2.2-.9-2.5-.4-2.5-.4-.8 1-.5 2-.5 2l.1 1c-.4 2.8 1.8 3 1.8 3z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M321.6 282.4c4.7 1.1 4.4 1.8 4.4 1.8-.3.5-1.7-.2-1.7-.2-3.6-1.2-2.7-1.6-2.7-1.6zm-2.9 0c-4.7 1.1-4.3 1.8-4.3 1.8.3.5 1.6-.2 1.6-.2 3.7-1.2 2.7-1.5 2.7-1.5z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "#aa241e",
          d: "M319 279.3c-2 .3-.5 1.8-.4 2.8 0 .5-.5 1.3 0 1.5.5.3 1.5 0 2.1 0 .8 0 1.3 0 1.2-1 0-.7-.3-1-.3-2 0-.6.1-1.4-.6-1.4a12.5 12.5 0 0 0-2 0z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "none",
          d: "M321.7 280.4c5.3 0 5-.9 5-.9m-5 2.5c5.4.7 4.7 1.5 4.7 1.5m-7.9-1.6c-5 1-4.5 1.9-4.5 1.9m4-3.5c-5.1.3-4.6-.5-4.6-.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx79("path", {
      d: "M298.1 274c-2.7 1-4.5 1.6-7 3.1l-3.3-5a7 7 0 0 0-2.2-1.8c-1.5-.7-2-.5-3 .3l-.6-1.3c-1.3-2.3-2.7-3.3-4.1-5.2l-1.4-1.5-.4-.5c.5 1.9 1 3.6 1.3 5.7-.8-.5-1.6-1-2.4-1.3a9 9 0 0 0-3-.5l1 .9a11.8 11.8 0 0 1 3.3 5.5 16.7 16.7 0 0 0 4.2 6.5 7.9 7.9 0 0 0 2 1.5c2 .8 1.9 0 2.6-.3a31.2 31.2 0 0 0 4.2 5.8 8 8 0 0 0 7.5 1.9c1.2-.3 2-.7 3-1.2 3.4-2 1.7-3.6 1.3-5.2a109 109 0 0 1 7.2-2c5.6-1 16-1.2 22.7-.2.6.1 7.3 1.9 8 2.3a5.4 5.4 0 0 0-.6 2.9c0 1.1 1 1.7 2 2.2a10 10 0 0 0 6.4 1.3 7.7 7.7 0 0 0 4.9-3.2c1.8-2 2.3-3.2 3.2-4.7 0 0 .5.5.9.6.3.1 1.5 0 1.8-.2.8-.3 1.4-1 2-1.5a15.5 15.5 0 0 0 4.1-6.6 12 12 0 0 1 4.3-6.3c-2.8.1-3.8.9-5.4 1.8l.6-3 .7-2.7-3.5 4c-.5.8-1.1 1.4-1.7 2.1-1.1 1.8-.9 1.8-1.3 2.4-4-2.2-5.8 3.1-8.4 6.4-5-2.8-9.3-3.6-15.2-4.7l-3.5-.4a88.7 88.7 0 0 0-22.7.2c-3.8.5-6.1 1.2-9.5 2z"
    }),
    /* @__PURE__ */ jsxs72("g", {
      fill: "#ce1126",
      children: [
        /* @__PURE__ */ jsx79("path", {
          d: "M293 285.5c.5-1.3 1-1.6 2.2-2.1 3.6-1.7 5.4-2.4 9.5-3.5a53.1 53.1 0 0 1 7.2-1.3 67.4 67.4 0 0 1 12.3-.4 54.5 54.5 0 0 1 20.6 5.1c1.5.7 1.3.8 2.2 2.2 1-.8 1.9-2.4 2.5-3.4l1-2c.4-1.1-.3-1.5-.8-1.9-1.8-1.6-5.3-3-8.3-3.8a86.5 86.5 0 0 0-42.7 0 24.8 24.8 0 0 0-9 4.4c-.8.9.4 2.5.8 3.2l1 2z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M280.5 274.2c1.4.3 2 .7 2.9 2 2 2.8 2.1 4.8 5.6 8.6a6 6 0 0 0 2.6 2.1 7.5 7.5 0 0 0 4.2.6 9 9 0 0 0 3.5-1.2s1.3-.7 1.7-1.2c.3-.4.4-1.5.4-1.5-1-.3-3 1.7-4.2 2.5-2.2 1.5-3 1-4.7-.5-1.3-1.1-1.8-2.4-2.7-4-.4-.6-1-1.5-.8-2.5l1.7-1.7-2.1-3.2c-.8-1.3-1.3-2.2-2.4-3-.6-.5-1.9-1.2-2.8-.7l-2 2c-.3.5-.7 1-.9 1.7"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "m278.1 268.8-2.1-1.3-2.7-1 1.5 1.7c1.6 2 1.6 3.8 3 6.4a16.3 16.3 0 0 0 4.2 5c1 .8 1.9 1 2.4.3.1-.5-1.1-1.3-1.7-1.6a11 11 0 0 1-2.1-1.4c-1.6-1.6-.4-3.5.8-4.9l.8-1c.2-.6-1.1-2.4-1.8-3.3-.7-.9-2.5-3-3.4-3.8l.5 2.5zm23.2 14.3-.6-1.5c-.9.1-5.1 2-6.1 2.6-.3.2-1.5 1.1-1 1.7 1.7 1.8 4.2-.8 5.6-2a3.1 3.1 0 0 1 2-.8z"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M285 279.7c-.3-.1-.3-.6-1.2-1.3-.4-.3-2.6-1.5-3-1.9 0 0-.6-.5-.6-1.2.1-.6.6-.7.6-.7 2 0 4.2 4.8 4.1 5zm74.6-5.4c-1.5.3-2 .7-2.9 2-2 2.8-2.1 4.8-5.6 8.6-.8.9-1.4 1.6-2.7 2.1a7.5 7.5 0 0 1-4.1.6 9 9 0 0 1-3.6-1.2s-1.3-.7-1.6-1.2a3.8 3.8 0 0 1-.4-1.5c1-.4 3 1.7 4.1 2.5 2.3 1.5 3.1 1 4.7-.5 1.4-1.1 1.9-2.4 2.8-4 .4-.6 1-1.5.8-2.5l-1.7-1.7 2-3.2c1-1.3 1.4-2.2 2.5-3 .6-.5 1.9-1.2 2.8-.7l1.9 2c.3.5.8 1 1 1.7"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "m362 268.9 2.1-1.3 2.6-1-1.4 1.7c-1.7 2-1.7 3.8-3 6.4a16.5 16.5 0 0 1-4.2 5c-1 .8-2.1.8-2.4.3-.1-.5 1-1.3 1.7-1.6.8-.4 1.5-1 2.1-1.4 1.6-1.6.4-3.5-.8-4.9l-.8-1a9 9 0 0 1 1.8-3.3l3.3-3.8c0 .7-.3 1.7-.5 2.5zm-23.2 14.3.6-1.5c.9.1 5.1 2 6.1 2.6.3.2 1.5 1.1 1 1.7-1.7 1.8-4.2-.8-5.7-2-.5-.3-1.1-.8-2-.8"
        }),
        /* @__PURE__ */ jsx79("path", {
          d: "M355.2 279.8c.2-.1.2-.7 1.1-1.4.4-.3 2.6-1.4 3-1.8 0 0 .6-.5.5-1.2 0-.6-.5-.7-.5-.7-2 0-4.2 4.8-4.1 5z"
        })
      ]
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#eac102",
      d: "M297.4 277h-.6l-.9.4v.3c.2 0 .1.3.2.5l.2.6.2.8.2.8c0 .1-.2.4 0 .3l.7-.2c.1 0 .3-.2 0-.2-.1-.1 0-.4-.2-.6l-.1-.6c0-.2.3 0 .3.1l.5.5.6.3a.8.8 0 0 0 .6 0c-.3-.2-.6-.4-.7-.7l-.5-.6c.2-.2.5-.5.5-.8a1 1 0 0 0-.4-.9 1.3 1.3 0 0 0-.6 0m-.2.2c.2 0 .3.2.4.3.1.2.2.4.1.7a.6.6 0 0 1-.3.4c-.1.1-.4.3-.5 0l-.2-1c0-.2.1-.3.3-.3a1 1 0 0 1 .2 0zm1.4-.7c0 .1.3.2.2.4l.2.7.2.7v.5l.2.6c0 .1-.2.3 0 .3l1.8-.5c.2 0 .2 0 .2-.2v-.6c-.2 0-.2.3-.3.4l-.9.4c-.1 0-.2-.1-.2-.3l-.1-.4-.2-.7h.7c.1 0 .2.2.3 0v-.5c-.1 0-.1-.4-.3-.3 0 .1 0 .3-.2.4a1.5 1.5 0 0 1-.5.1l-.1-.5c0-.2-.1-.5.1-.5a.8.8 0 0 1 .8 0c.1 0 .3.3.3 0 0-.1 0-.4-.2-.5h-.5zm4.1-1.1h-.7l-.8.3c-.2.1.2.2.2.4v.5l.2.5.1.8.1.7v.4c.2 0 .5 0 .7-.2.2 0 .2-.1 0-.2v-.5l-.2-.6a2 2 0 0 0 1-.5.9.9 0 0 0 .4-.7 1.1 1.1 0 0 0-.2-.7 1 1 0 0 0-.4-.2zm-.3.2a.5.5 0 0 1 .5.4l.1.7c0 .1-.1.3-.3.3l-.4.2-.1-.4-.2-.8c0-.2 0-.3.2-.3a.8.8 0 0 1 .2 0zm3.3-.9.3.3v.5l.2.6v.5l.1.7a.6.6 0 0 1-.7.5.4.4 0 0 1-.3-.2 1 1 0 0 1-.2-.5l-.1-.7a7.9 7.9 0 0 0-.1-.7l-.1-.5c0-.1.2-.3 0-.3l-.8.1c-.2.2.1.2.1.4l.1.5.2 1v.5c0 .2.2.3.3.5.1.1.3.3.5.3.4 0 .8 0 1.1-.3l.3-.5-.1-.8-.1-.8-.1-.6a.5.5 0 0 1 0-.3c0-.1.2-.3 0-.3h-.4a.2.2 0 0 0-.2.1m2.6-.5-1 .2-.5.1.2.4c0 .4 0 .8.2 1.1v.7l.1.8c0 .1-.2.3 0 .3l.5-.1a4.2 4.2 0 0 1 .6 0 3.8 3.8 0 0 0 .7-.3l.3-.3a.6.6 0 0 0 .2-.4c0-.2 0-.5-.3-.7l-.4-.2c-.1 0-.3-.1 0-.2a.8.8 0 0 0 .3-.5.6.6 0 0 0-.1-.5c0-.2-.3-.3-.5-.3a2 2 0 0 0-.3 0zm-.5.3c.3 0 .5 0 .7.2v.6c0 .2-.2.3-.4.4-.1 0-.4.1-.4-.1v-.5a4 4 0 0 1 0-.5zm.3 1.5.5.1c.2.1.2.4.2.6l-.1.5-.6.2c-.2-.1-.2-.4-.2-.5v-.9a.5.5 0 0 1 .2 0m1.7-2s.2 0 .1.2l.1.6v.5l.1.7v1.2c-.1.1.1 0 .2 0h1.2l.6-.1v-.9c0 .2-.2.3-.3.4a.7.7 0 0 1-.3.2h-.3l-.4-.1v-.7l-.1-1.2v-.7c0-.1.2-.3 0-.3h-.4l-.4.1a.8.8 0 0 0-.1 0zm2.5-.3.1.2.1.4v.4l.2 1.6v.4s-.2.2-.1.3a4 4 0 0 0 1-.1l-.1-.2-.1-.4-.1-.7v-.6l-.1-.8v-.5s.2-.2 0-.2a5.5 5.5 0 0 0-.9.1zm4 2c-.2 0-.3.2-.4.3 0 .2-.3.2-.4.3-.3 0-.4-.1-.6-.3a1.6 1.6 0 0 1-.3-.5v-.5a3.4 3.4 0 0 1 0-.9c0-.2 0-.4.2-.5.2-.1.5 0 .7.1l.2.5c.2.2.2-.1.2-.2l.1-.4a1 1 0 0 0-.5-.2 1.2 1.2 0 0 0-1.1.2 1 1 0 0 0-.3.3 1 1 0 0 0-.1.4l-.2.6.3 1.2c0 .2.2.3.4.5l.5.2a1 1 0 0 0 .7-.2c.2 0 .3-.3.4-.4a1 1 0 0 0 .2-.4zm1.3-2.5h-.4l-.1.8-.2.5-.2 1.3-.3.7v.1h.7l-.2-.3v-.5c0-.2.3 0 .4 0l.5-.1.2.6s-.2.3 0 .3h.7c.2-.1 0-.3 0-.4l-.3-.8-.3-1-.3-1zm-.3.8.4 1.3-.2.1h-.4c-.1-.1 0-.3 0-.4l.1-.6zm4.3-1-1 .1.2.3v2.9c0 .1-.4.3-.1.3h1.4a1 1 0 0 0 .4-.3l.4-.5.1-.7a2.7 2.7 0 0 0 0-.7l-.2-.6-.3-.4a1.7 1.7 0 0 0-.4-.2l-.5-.1zm0 .3c.3 0 .5.1.6.3a1 1 0 0 1 .1.5v1.4a1.4 1.4 0 0 1-.2.6l-.3.2-.5-.1v-2.6c0-.2.2-.3.4-.3zm3-.1a.8.8 0 0 0-.5.1l-.5.6-.2.8v.8l.2.5a1.1 1.1 0 0 0 1 .8c.3 0 .6-.2.8-.4l.4-.7v-1.2a2 2 0 0 0-.2-.6l-.4-.6a.9.9 0 0 0-.5-.1zm0 .2c.3 0 .5.3.5.5l.1.6v.9l-.1.6a1 1 0 0 1-.3.5c-.1.1-.3.2-.4 0-.2 0-.2-.3-.3-.4v-1.9c0-.2 0-.4.2-.6a.4.4 0 0 1 .4-.2zm1.4 3.5h.6c.1-.1-.2-.2-.1-.4a2 2 0 0 1 0-.6l.1-.6.1-.6.1-.5.1.5v.7l.2.6v.6c.1.2 0 .5.3.4.2 0 .1-.2.2-.3l.2-1 .2-.5.3-.9v2.5c0 .1-.3.3 0 .3h.6c.2.1.1 0 0-.1v-3.1s.2-.2 0-.2h-.7l-.2.5a9 9 0 0 1-.2.7l-.1.7s-.1.2-.1 0v-.6c0-.1-.2-.3-.1-.4l-.2-1c0-.2-.2 0-.4-.2h-.4v1.2l-.2 1.3-.1.5c0 .2-.1.3-.3.4zm3.3.3.6.1h.3l-.2-.4v-.6l.2-.5a22 22 0 0 1 0-1.1 1.3 1.3 0 0 1 0-.5l.2-.2c.1-.2-.1-.1-.2-.1l-.7-.1s.2.2.1.3v1.7l-.1.5a2.5 2.5 0 0 1 0 .5zm1.1.3h.5c.1 0 .3.1.2 0a.8.8 0 0 1-.1-.5v-.9a2 2 0 0 1 .1-.6v-.6c.2.1.2.3.3.5l.8 2c0 .2 0 .4.2.4s.2-.1.2-.3v-.5l.1-.5v-.6l.2-.6v-.6s.4-.2.2-.3h-.6l.2.4-.1 1.1-.1.6-.2-.5-.3-.6-.2-.6-.3-.7a3.5 3.5 0 0 1-.6-.1c-.2 0 0 .2 0 .4.1.3 0 .6 0 .8a4.2 4.2 0 0 1 0 .6l-.1.6-.1.6c0 .2-.2.3-.3.4zm3-3c.1.2.3.3.2.4v.5a3.1 3.1 0 0 1-.1.5l-.1.7v.5l-.1.3v.3l-.2.2c-.1.1.2 0 .3.1l.5.1s.1 0 0-.1v-1l.1-.5v-.4c.1-.2 0-.4.2-.6v-.4c0-.1 0-.3.2-.4a1.2 1.2 0 0 0-.4 0l-.4-.2a.2.2 0 0 0-.1 0zm1.1 2.4a2 2 0 0 0 .4 1.3c0 .2.3.2.4.3h.6c.1 0 .3 0 .4-.2l.3-.5c0-.2-.2.1-.3.2-.2.1-.5.2-.7 0a.8.8 0 0 1-.3-.4v-.5a7 7 0 0 1 0-.7v-.5l.3-.5a.5.5 0 0 1 .3-.2c.2 0 .3.2.4.3a.8.8 0 0 1 .1.5c0 .1.1.3.2.1l.2-.5c0-.2-.2-.3-.3-.4l-.3-.2h-.8a1.2 1.2 0 0 0-.3.4c-.2.1-.3.4-.4.6a2.6 2.6 0 0 0-.1.7zm3.5-1.3-.6 1.4c0 .1 0 .3-.2.5l-.3.7-.3.4c-.1 0-.1.2 0 .2l.5.1c.2 0 0-.2 0-.3v-.4c.2-.2.4 0 .5 0h.4v.8c-.1 0 0 .2 0 .2l.5.2c.1 0 .3 0 .2-.1-.1-.3 0-.5 0-.8l-.1-.6v-2.1zm0 .8v1.5l-.6-.1c-.1-.2.1-.3.1-.5l.4-.7zm1.5 3.3v-1.4l.2-.5v-.6c.2-.2.2 0 .2.1l.3 1 .2.6.2.9c0 .1.1.4.3.3l.2-.6.1-.6.2-1 .2-.8s.4-.2.1-.3c-.1 0-.3-.2-.5-.1l.1.4v.6a4.6 4.6 0 0 0-.2.5l-.1.6c-.2-.1-.1-.3-.2-.5l-.2-.7a6 6 0 0 1-.2-.7 2.1 2.1 0 0 1-.1-.5c-.1-.2-.4-.2-.5-.3-.2 0-.3 0-.2.2v1l-.3 1-.1.6-.3.4c-.2.2.2.2.3.3a.7.7 0 0 0 .3 0zm3.4-2.3-.3.7-.4.7-.8 1.3s-.2.2 0 .2l.5.2v-.8l.5.1c.1.1.4 0 .4.3l-.1.6c-.1 0-.2.1 0 .2l.3.1c.2 0 .3.2.4.1v-3.6zm0 .7v1.6l-.5-.2s-.3 0-.2-.2l.3-.7z"
    }),
    /* @__PURE__ */ jsxs72("g", {
      transform: "matrix(.89273 0 0 .89274 -125.5 -33.3)",
      children: [
        /* @__PURE__ */ jsx79("path", {
          fill: "#fff",
          d: "M474.5 281v40.6c0 3.6 0 5.9 1.8 8.1a11 11 0 0 0 6 4.2c1.7.3 7.7.2 9.8.2 4.6-.3 5.2.8 7 3 2-3.1 4.1-3.2 8.2-3 2 0 6.6.1 8.4-.3a9.4 9.4 0 0 0 5.4-3.3c2.4-2.7 2.2-6 2.2-9.6v-38.3c0-1.8-.2-1.3.7-2.2l5.8-6H468l6.4 6.7z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "#002d62",
          d: "M493.8 299v-24.7h-25.5l6.3 6.7v18z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "#ce1126",
          d: "M504 299v-24.7h26l-6.7 7.1v17.7zm-10.2 10.3h-19.3l-.1 15.6c.9 6.8 6 9.2 10.4 9.1h9z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "#002d62",
          d: "M504 309.3h19.4V325c-.5 6.8-6 9.2-10.5 9.1h-9z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M474.6 281v40.6c0 3.6 0 5.8 1.8 8.3a9.2 9.2 0 0 0 6 4c1.7.3 7.7.2 9.8.2 2.7 0 3.9-.2 5.7 1.6.6.6.7.8 1.1 1.5a8.1 8.1 0 0 1 3-2.8c1.4-.5 3.8-.3 5.4-.3 2.1 0 6.6.1 8.4-.3a10.6 10.6 0 0 0 5.4-3.3c2.4-2.7 2.2-6 2.2-9.6v-38.3c0-1.8-.2-1.3.7-2.2l5.8-6h-61.7z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "#eac102",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M498 280.4v2.8h-3v2.3h2.8v10h2.3v-10h2.9v-2.3h-2.9v-2.8z"
        }),
        /* @__PURE__ */ jsxs72("g", {
          id: "do_svg__b",
          children: [
            /* @__PURE__ */ jsx79("path", {
              fill: "#fff",
              d: "M481.9 284v4.6l-1.9-2 .3 32c0 4.7 3.4 8.6 7.6 8.6 4.2 0 7.6-3.8 7.7-8.5l-.3-16.4-2-2.2-.1-1.7z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#002d62",
              d: "M481.9 284.2v4.6l-1.9-2 .2 18.2 8.2 7.9v-17.4l-.2-.4v-3z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#ce1126",
              d: "m490.8 295.5 2.4 3v1.1l-2.4-2.5zm4.5 7 .2 11.4c-1.2 2.2-3.6 1-3.6 1l.1-15.8z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#002d62",
              d: "M495.6 319.6c-3.2 2.4-4-1-4-1a4.4 4.4 0 0 0 4-3z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#ce1126",
              d: "M480.2 309.7a54 54 0 0 0 8 7.5c1 7.7 5.5 5.1 7.1 4-1 3.6-3.9 6.2-7.4 6.2-4.2 0-7.6-3.9-7.6-8.6z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "none",
              stroke: "#000",
              strokeWidth: 0.3,
              d: "M493.2 299.6v-1.1L481.9 284v4zM480 286.7l.3 31.9c0 4.7 3.4 8.6 7.7 8.6 4.1 0 7.5-3.8 7.6-8.5l-.3-16.4z"
            }),
            /* @__PURE__ */ jsxs72("g", {
              fill: "#eac102",
              stroke: "#000",
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx79("path", {
                  d: "M486.2 281.2c-.8-1.4-.6-2-.1-2.6l-3-3 .9 4.2c.8-.2 1.4 0 2.2 1.4zm-3-5.6 3 5.6"
                }),
                /* @__PURE__ */ jsx79("path", {
                  d: "m498 300.7-.7.3-12-20.4.8-.4z"
                }),
                /* @__PURE__ */ jsx79("path", {
                  d: "M485 280.6c-.1-.2 0-.5.5-.7.3-.2.7-.2.8 0 0 .2-.1.5-.5.7-.3.2-.7.2-.8 0zm-4 1.6c-1-1.3-.9-2-.4-2.6l-3.3-2.6 1.4 4c.8-.3 1.4-.1 2.3 1.2zm-3.7-5.2 3.7 5.2"
                }),
                /* @__PURE__ */ jsx79("path", {
                  d: "m495.3 300-.7.4-14.4-18.7.6-.5z"
                }),
                /* @__PURE__ */ jsx79("path", {
                  d: "M479.8 281.8c-.2-.2 0-.6.3-.8.4-.3.7-.3.9-.1 0 .1 0 .5-.4.7s-.7.3-.8.1zm.4 4.6c-1.1-1.3-1.1-2-.7-2.6l-3.6-2.2 1.8 3.9c.8-.4 1.4-.4 2.5.9zm-4.3-4.8 4.3 4.7"
                }),
                /* @__PURE__ */ jsx79("path", {
                  d: "m495.7 302.9-16.4-17 .6-.5 16.4 17z"
                }),
                /* @__PURE__ */ jsx79("path", {
                  d: "M478.9 286c-.2-.1 0-.5.3-.8.3-.3.6-.4.8-.2.1.2 0 .5-.3.8-.3.3-.7.4-.8.2z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx79("use", {
          xlinkHref: "#do_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 998.3 0)"
        }),
        /* @__PURE__ */ jsxs72("g", {
          stroke: "#000",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx79("path", {
              fill: "#ce1126",
              d: "m496.7 314.5-.6 10.1c-.6 0-1.9-.1-2-1 0-.4 1.3-8.7 1.3-9.5z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#002d62",
              d: "m495.8 314.1-.3 3.1c.2 1 1.4.8 2 .9l.2-5.2a16.5 16.5 0 0 1-2 1.2z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#002d62",
              d: "M495.9 327c1.6-2 4.8-.5 4.8-.5 3.4.8 2.5-3.1 2.5-3.1-.7-7.8-1.5-13.2-1.5-13.2l-5 3.4z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#002d62",
              d: "M495.9 327.2c-.4 2.3 2 2 2 2 2.7 0 1.9-3 1.9-3-3-.9-4 1-4 1z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#ce1126",
              d: "m497.8 312.7-.2 9c.1 2.1 2.5 1 2.5 1 .6-.3 1.2-.1 1.2-.1v-2.8c4-.3 3-2.6 3-2.6-1.6-7.6-1.8-7.3-1.8-7.3z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "none",
              d: "M501.3 319.8c-2.5 0-3.6 1-3.6 1v.2"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#fff",
              d: "m501 326.4-.9-15.1 1.8-1.2 1.5 14.2v.1c0 2.7-2.4 2-2.4 2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs72("g", {
          fill: "#fff",
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx79("path", {
              fill: "#000001",
              stroke: "none",
              d: "m488.2 302.2 6.8 12.4 14.7-9.7-7.7-11.2z"
            }),
            /* @__PURE__ */ jsx79("path", {
              strokeWidth: 0.3,
              d: "m488.5 302.1 13.7-8 7.6 10.8-14.6 9.4z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#000001",
              stroke: "none",
              d: "m495.4 313.5 13.7-8.8-1-1.7-6.9-9.3-5 4-6.3 3.5-1.1-.7.2 1.5z"
            }),
            /* @__PURE__ */ jsx79("path", {
              strokeWidth: 0.1,
              d: "M496.2 297.8c-2-1-4.4 2-5 2.6-.8.6-2.1.3-2.1.3l6.2 11c1.8.8 3-1.5 3.8-2.3 1.6-1.3 3.4-1.2 3.4-1.2z"
            }),
            /* @__PURE__ */ jsx79("path", {
              strokeWidth: 0.1,
              d: "M496.4 297.9c0-2.4 3-3.1 3.7-3.6.8-.4 1-1.9 1-1.9l7 10.6c-.2 2-2.6 2.3-3.6 2.8-1.8 1-2 2.5-2 2.5zm-1.4 13.9a595.6 595.6 0 0 0-6.1-11v1.2c4.6 7.5 6.5 11.5 6.5 11.5z"
            }),
            /* @__PURE__ */ jsx79("path", {
              fill: "#000001",
              stroke: "none",
              d: "M490.9 302.2v.2l.1-.1.2.1h-.2l.1.2.2-.2-.3.3-.2-.4h-.1l.4-.3v.2zm.4-.3.2.4v.2c-.1 0 0 0 0-.1l-.1-.1-.2-.3zm.5-.3h-.2v.1h.4v.3a.2.2 0 0 1-.2 0v.1l-.1-.1h.2c.1 0 .1-.1 0-.1h-.1l-.2-.1v-.2a.2.2 0 0 1 .1 0v-.1zm.5.2h-.2v-.1l.1-.1v-.1h-.1v.1c-.1 0 0 0 0 0a.2.2 0 0 1 0-.2l.2.1zm0 0v-.1l-.1.1zm.1-.4.1-.1h.1l.2.2-.1.2v-.1l-.1-.1v-.1zv.2h.1l-.1.2v-.2zh-.1zm.3-.4.1.1h.1v.3h.1-.1l-.2-.2a.5.5 0 0 0 0-.2m.3 0a.2.2 0 0 1 .2 0 .2.2 0 0 1 .1.1.2.2 0 0 1 0 .2.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.3m0 0v.1l.2.2v-.3zm-1.6 2 .1.2v-.1l.2.2h-.2l.1.1h.1l.1-.1v-.1.2l-.3.2v-.1l-.2-.3.3-.3v.1h-.1zm.7.2-.3-.2.1-.1v.1h.2c0-.1 0-.2-.1-.1v-.1.2zm.3-.3v.2h-.2v-.2zc0-.1-.1 0-.1 0a.2.2 0 0 1 .1-.2l.1.1.1.2zm.2-.4c.1-.1.2 0 .2 0l.1.1v.2c-.1 0 0 0 0 0l-.2-.2zv.4l-.1-.2-.1-.1v-.1zm.4-.3v.3h.2v.2a.4.4 0 0 1-.2 0l-.1-.1v-.1a.1.1 0 0 1-.1 0v-.2a.2.2 0 0 1 .1 0zm0 0v.2c.1 0 .1 0 0 0a.3.3 0 0 0 0-.1zm.2.4s-.1 0 0 .1zm.3-.5h-.2l.1.2za.2.2 0 0 1 0 .1h-.2a.3.3 0 0 1 0-.1c-.1 0 0-.2 0-.2a.1.1 0 0 1 .1 0 .3.3 0 0 1 .1 0zm-.1 0h-.1zm0-.4.3.4h.1l-.2.1v-.1zm.4 0 .1.3v.1c-.1 0 0 0 0 0l-.1-.1-.1-.2zm.2-.1a.2.2 0 0 1 .1 0l.1.2a.2.2 0 0 1 0 .1.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.3m0 0v.3h.2v-.2zc0-.1 0-.1 0 0m-2 2.2.1.2c0-.1-.2-.1-.2 0h.2l.2.1v.2a.2.2 0 0 1-.2.1l-.2-.1h.3v-.1h-.4a.2.2 0 0 1 0-.3.2.2 0 0 1 .2 0zm.6 0-.2.2h.2a.2.2 0 0 1 0 .1h-.2a.2.2 0 0 1-.1 0v-.3a.1.1 0 0 1 .2 0zm-.1.1h-.1zm.2-.3a.2.2 0 0 1 0 .1v.1h.2v.1a.4.4 0 0 1-.2.1l-.1-.1a.2.2 0 0 1 0-.1.1.1 0 0 1-.1 0v-.3a.2.2 0 0 1 .1 0m0 0v.2s.1 0 0 0a.3.3 0 0 0 0-.2m.2.4s-.1 0 0 0c0 0 .1 0 0 0m.2-.7.2.3-.2.2-.2-.3.2.2h.1v-.1zm.3-.1v-.1h.2l.1.2-.1.2v-.2zs-.1 0 0 0v.4c-.1 0 0 0 0 0l-.2-.2v-.2zm.6-.6h-.2v.1h.4v.3a.2.2 0 0 1-.2 0v.1l-.1-.1h.2v-.1h-.3a.2.2 0 0 1 0-.3.2.2 0 0 1 .1 0v-.1zm.5.2-.1.1h-.1a.2.2 0 0 1 0-.2v-.1.1c-.1 0 0 0 0 0a.2.2 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0-.1-.1v.1zm.1-.4.1-.1h.1l.2.2-.1.2-.1-.2v-.1zv.2h.1l-.1.2v-.2l-.2-.1zm.4-.5.3-.1.1.3v.2a.2.2 0 0 1-.1.1h-.1v-.1h.1v-.2zm.7-.2.1.3h.1-.1l-.1.2a.1.1 0 0 1-.1 0l-.2-.3h.1l.1.2h.1zh-.1zm.4.1h-.2v-.3.1c-.1 0 0 0 0-.1h.2v.1h.1zm0 0-.1.1zm.1-.4zl.2.2-.1.1-.1-.1v-.1zv.2h.1l-.1.2zh-.2zm-2.7 4.7a.2.2 0 0 0-.2 0 .2.2 0 0 0-.1.2l.1.2h.3v-.2.1a.2.2 0 0 1 0 .2.2.2 0 0 1-.3 0 .3.3 0 0 1-.1-.4.3.3 0 0 1 .2-.1zm.6 0-.2.2v.1c.1 0 0 0 0 0v.1-.2l-.1-.4.4.3a.1.1 0 0 0 .1 0l-.2.1v-.1zm0 0h-.3v.2l.2-.1zm.2-.2.1.2h.1l-.2.1v-.1zh-.1l.2-.2h.1c.1 0 .1.1 0 .2a.3.3 0 0 1 0 .1zm0 0 .1-.1a.1.1 0 0 0 0-.2l-.2.1zm.6 0h-.2l-.1-.4h-.1l.1-.1v.1l.2.3zm.1-.8h-.2l.2.4h.1l-.2.2c.1 0 0-.1 0-.2l-.1-.3h-.1v.2l-.1-.1zm.4-.2h.2v.3l.1.1a.3.3 0 0 1-.2.2.2.2 0 0 1-.2-.1v-.2h-.2l.2-.2v.1l.1.2.1.1a.2.2 0 0 0 .2 0 .1.1 0 0 0 0-.2l-.2-.2c0-.1 0 0 0 0zm.7 0 .1.1-.4.2c.1 0 0 0 0 0l-.1-.4h-.1l.2-.1v.1l.1.3h.1l.1-.1zm.1-.5h.3a.3.3 0 0 1 .1.3.3.3 0 0 1-.3.2.3.3 0 0 1-.2-.1.3.3 0 0 1 0-.3.3.3 0 0 1 .1-.1m0 0a.1.1 0 0 0 0 .2.4.4 0 0 0 0 .2h.2a.2.2 0 0 0 .2-.1.4.4 0 0 0-.1-.2.2.2 0 0 0-.2-.1zm1-.6v.7l-.4-.3h.1l.3.2v-.3s0-.1-.1 0zm.4.3-.2.2v-.2l-.2-.3.1-.1v.1zm.2-.1-.1.1zl-.2-.3h-.1l.2-.2v.2zm.3-.2-.2.2v-.1l-.2-.4h-.1l.2-.1v.1zm-4 4.2v-.2h.2v.1a.1.1 0 0 1 .2.1.2.2 0 0 1 0 .2.3.3 0 0 1-.1.1c.1-.1.1-.2 0-.2h-.1a.1.1 0 0 0 0-.2zm.4-.3v-.2l.3.4h.1l-.1.2v-.2zm.7-.5.2-.1v.4c0 .1 0 .1.1 0v.1l-.2.1v-.2l-.3-.1zl.2.1zm.8 0h-.2a.2.2 0 0 1 0-.3v-.2l.3.3zm0 0v-.2h-.2v.1zm.1-.3.2.1v-.1h.1v.2a.1.1 0 0 1-.2 0 .3.3 0 0 1-.1-.2.2.2 0 0 1 0-.1.1.1 0 0 1 .2 0zm0 0h.2l-.1-.1s-.1 0 0 .1zm.6-.2a.2.2 0 0 1 0 .2.1.1 0 0 1-.2 0l-.1-.1v-.2a.1.1 0 0 1 .2 0h-.1v.1a.2.2 0 0 0 0 .1.1.1 0 0 0 .2 0zm.1-.2.2.3c-.1 0 0 0 0 0h-.1l-.1-.2zm.4.1v.1h-.2v-.1a1 1 0 0 1 .1-.1.1.1 0 0 0 0-.1h-.1v.1-.1h.1zm0 0v-.1za.2.2 0 0 0 .1 0m.1-.6.2-.1.1.3v.2s-.1 0 0 0v-.1zm.4 0 .2.2.1-.1v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.1.2.2 0 0 1 0-.2h.2zm0 0h.2s0-.1-.1 0zm.4-.3c-.1.1 0 .2 0 .1za.1.1 0 0 1 .1.1v.1h-.2.1zh-.2v-.1a.2.2 0 0 1 0-.1zm.4-.2.1.2v.1c-.1.1-.2.1-.2 0l-.2-.1v-.1l.2.2h.1zm.2-.2c0 .1 0 0 0 0-.1.1 0 .2 0 .2h.1a.1.1 0 0 1 .1 0v.2h-.2c0-.1 0 0 0 0h.2v-.2h-.3zm.6 0v.1h-.2v-.1l.1-.1a.1.1 0 0 0 0-.1h-.1v.1-.1h.1c.1 0 0 0 0 0zm0 0v-.1h-.2za.2.2 0 0 0 0-.1zm-4.5 3.5.2.4h.1-.1zs-.1 0 0 0v-.2zm.3 0a.2.2 0 0 1 .2 0 .2.2 0 0 1 0 .1.2.2 0 0 1 0 .2.1.1 0 0 1-.1 0 .2.2 0 0 1-.2-.2.2.2 0 0 1 .1-.1m0 0a.3.3 0 0 0 .1.3h.1v-.2zm.4-.3v.1h-.1s0 .1 0 0h.2a.1.1 0 0 1 0 .2v.1h-.2.2v-.2h-.2zm.2-.3s.1 0 0 0m.1.1.2.3v.2c-.1 0 0 0 0 0v-.3zm.4-.2.2.2v.1l-.2.1-.2-.1v-.2l.2.2s.1 0 0 0v-.2zm.5 0-.1.2h-.2a.2.2 0 0 1 0-.3h.1v-.2h-.1zv.1zm0 0h-.2v-.1c-.1 0-.1 0 0 .1v.1h.1zm-.1-.5c0 .1 0 0 0 0m.1.2.2.2v.1c-.1 0 0 0 0 0h-.1l-.1-.2zm.2-.2a.2.2 0 0 1 .2 0 .2.2 0 0 1 .1.2.2.2 0 0 1 0 .1.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.2.2.2 0 0 1 0-.1m0 0v.1a.3.3 0 0 0 .1.2h.2v-.2h-.2zm.4-.2v.1h.2v.2h-.1s0 .1 0 0h-.1.2v-.1h-.3a.1.1 0 0 1 0-.2zm.5-.4.3.4v.2c-.1 0 0 0 0 0v-.2h-.4a.2.2 0 0 1 0-.2v-.1h.1zm.1.3h-.2l.1.2a.1.1 0 0 0 .1 0zm.3-.5.1.3v.1h-.2l-.1-.2h-.1.1l.1.2h.1v-.3h-.1zm.2 0 .1.2.1-.1v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.1.2.2 0 0 1 0-.2.1.1 0 0 1 .1 0l-.1.2zm.3-.5.3.4v.1c-.1 0 0 0 0 0l-.1-.1-.2-.3zm.3.2h.2v-.1h.1v.2a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.1.2.2 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0 .2-.2h-.1s-.1 0 0 .1zm-3.7 3.1.1.3.1-.2a.1.1 0 0 1 .1 0l.1.2h.1l-.1.2v-.2l-.1-.1h-.1v.3h.1-.1v-.1l-.2-.3zm.7.2c-.1.1-.2.1-.2 0a1 1 0 0 1 0-.2c0 .1-.1.1-.1 0 .1 0 .1-.1.2 0zc.1 0 0 0 0 0 0 .1 0 .1 0 0m0 0-.1-.2zm0-.4h.2a.2.2 0 0 1 0 .3c-.1 0-.1.1-.2 0l-.2-.3zm0 0 .2.2h.1v-.2zm.4-.3.2.3-.1.1v-.1l-.1-.1zm.4.2h-.2v-.1a1 1 0 0 1 .1-.1h-.1l.1-.1zs0 .1 0 0m0 0v-.2l-.1.1v.1zm.1-.4h.2l.1.2v.1zv.2h.1l-.1.1-.1-.2h-.1a.2.2 0 0 1 0-.1zm.8-.3a.2.2 0 0 1 0 .2.1.1 0 0 1-.2 0h-.1v-.3a.1.1 0 0 1 .2 0h-.1l-.1.1a.2.2 0 0 0 .1.2.1.1 0 0 0 .2 0zm0-.3v.1zv.4h.1l-.1.1-.1-.2s-.1 0 0 0v-.2zm.2 0 .2.1v-.1h.1v.2a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.2.2.2 0 0 1 0-.1.1.1 0 0 1 .2 0zm0 0h.2zs-.1 0 0 0a.1.1 0 0 0 0 .1zm.2-.5v.1zm.1.2.2.2v.2c-.1 0 0 0 0 0l-.1-.2zm.5 0-.1.2h-.2a.2.2 0 0 1 0-.3h.1v-.2h-.1zs.1 0 0 0v.1zm0 0h-.1l-.1-.1v.2zm0-.4a.2.2 0 0 1 .3 0 .2.2 0 0 1 0 .2.2.2 0 0 1 0 .2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.3zm0 0v.2a.3.3 0 0 0 .2.1h.1v-.1l-.1-.1zm-1-9.2.2.1a.1.1 0 0 0-.3 0v.1h.3a.1.1 0 0 1 .1.2h-.1l-.1.1v-.1h.1v-.1h-.2c-.1-.1-.1-.2 0-.2zm.2-.1.2.3h.1l-.1.1-.1-.2v-.1zm.3 0 .2.2v-.3.4zm.4-.3a.1.1 0 0 1 .2 0v.3a.2.2 0 0 1-.2-.1.1.1 0 0 1 0-.2m0 0v.2h.2v-.1s-.1-.1-.1 0zm.4-.2h-.1v.1h.2v.2h-.1c.1 0 0-.1 0-.1h-.1v-.2zm.2-.1a.1.1 0 0 1 .1 0l.1.2s-.1.1-.2 0a.2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2zm0 0v.2h.2v-.1zm.1-.3h.2v.2c.1 0 0 0 0 0 0 .1 0 0 0 0zc-.1 0 0 0 0 0zm.3 0s.1 0 0 0v.2h.2l-.2.1zh-.1zm.2-.1a.1.1 0 0 1 .1 0l.1.2h-.1a.2.2 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0m0 0 .1.1h.1v-.1zm.3-.2h.1s.1 0 0 .1v.1a45 45 0 0 1-.1 0h.2l-.1-.1h-.1zm-2 2.4c0-.1.1-.1.1 0l.1.1a.1.1 0 0 1-.1.1v.1h.1l-.1.1zm0 0h.2c0 .1 0 .1 0 0v-.1zm.3-.2h.2v.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1-.1.1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0 .2-.1zm.3-.3s.1 0 0 0v.2h.2l-.2.1zm.2 0v-.2h.2c0-.1.1 0 .1 0l.1.1v.1-.1l-.1-.1h-.1v.2h.1l-.1.1v-.2zl.1.2a54.8 54.8 0 0 1 0 .1v-.1zm.6-.2c-.1.1-.2 0-.1 0v-.1c0-.1 0-.1 0 0h-.1v-.1h.1zm0 0a.3.3 0 0 0-.1 0za.2.2 0 0 0 .1 0m.1-.3h.2v.2h.1-.1v-.1zl.1.2zm.3-.1h.2a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0 0 .1-.1h-.1zm.5-.2a.1.1 0 0 1-.2 0h-.1a.1.1 0 0 1 0-.2h.2-.2a.2.2 0 0 0 0 .2zm0-.2.1.1h.1v-.1.2a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm0 0c0-.1 0-.1-.1 0m.2-.2v.4h.1c-.1 0 0 0 0 0l-.2-.2zm.3 0h.2a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0-.5c.1 0 .2 0 .1.1zm.2.2.1.2h.1-.1zm.2-.2c0 .1 0 0 0 0h.1s.1.1 0 .2h-.1.2s0-.1-.1 0h-.1zm-2.7 3h.2v-.1.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0-.1c0-.1 0-.1-.1 0m.3-.2.1.1v.1zv.2h.1v.1zm.4-.3v-.1h.2v-.1h.1l.1.2-.1-.2h-.1v.4h.1a51.1 51.1 0 0 1-.1 0v-.1zl.1.2h-.1zm.3-.5s.1 0 0 0c0 .1 0 0 0 0m.1.1.2.3c-.1 0 0 0 0 0h-.1v-.2zm.2 0v-.1h.2s.1.2 0 .2a.1.1 0 0 1 0 .1v.2zm.2 0c0 .1.1.1.1 0zm.4-.1c-.1.1-.1 0-.1 0v-.2.1h-.1v-.1h.2zs0 .1 0 0m0 0v-.1h-.1c0 .1 0 .2.1.1m0-.5.2.3v.1zm.5.2zv-.2s-.1 0 0 0v-.1zm0 0-.1-.1za.2.2 0 0 0 0-.1zm0-.3v-.1h.2a.2.2 0 0 1 0 .2.1.1 0 0 1 0 .1h-.1l-.2-.3zm0 0 .1.2h.1v-.2zm.3-.2c.1 0 .1 0 0 0l.1.2v.1zm.4 0h-.2l.1-.2h-.1c0 .1 0 0 0 0h.1zm0 0s0 .1 0 0m-2.6 2.4c-.1.1 0 .1 0 .1h.1v.2a45 45 0 0 1-.1 0h.1v-.1h-.2zm.2 0h.2v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.1.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm0 0v-.1zm.2-.3v.2h.1a67.3 67.3 0 0 0-.1.1l-.1-.2zm.2 0 .1.1h.1v-.1.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0c0-.1 0-.1 0 0m.4-.4.2.3zs-.1 0 0 0zm.3-.1c-.1.1 0 .1 0 .1h.1v.2h-.1.1v-.1h-.2zm.2-.1.1-.1.2.2v-.2h-.1v-.1l.1.3zm.4-.2zh.1v-.1.2a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm0 0c0-.1 0-.1-.1 0m.2-.3zv.4h.1c-.1 0 0 0 0 0l-.2-.2zm.5 0a.1.1 0 0 1-.1.2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.3h.1v-.2zm0 0h-.1c0-.1-.1-.1-.1 0v.1zm.2 0h-.1v-.2h-.1.2c0 .1.1 0 .1 0zm0 0v-.2l-.1.1s0 .1.1 0zm.3-.3a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zm0 0v-.1h-.2l.1.2zm0-.2.2.1h.1v-.1.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0 0h.2c0-.1 0-.1-.1 0zm.3-.3v.2h.1l-.1.2v-.1zm.4 0v.2l-.1-.1v-.2.1h-.1v-.1h.2zm0 0h-.1c0 .1 0 .2.1.1zm.1-.2v-.1h.2v-.1h.1l.1.2c.1 0 0 0 0 0l-.1-.2h-.1v.4h.1c-.1 0 0 0 0 0h-.1v-.1zl.1.2zm.5-.2h.2v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.1.1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0v-.1zm.2-.2v-.2h.2v.2h.1v.1l-.1-.2zv.4l-.1-.2zm.2-.4zv.2h.2-.2v-.1h-.1a.2.2 0 0 0 0-.2m.3.1zh.2v-.1.2a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.2.1.1 0 0 1 0-.1zm0 0c0-.1 0-.1 0 0m-4.5 3.8h.2v-.1h.1l.1.2-.1-.1h-.1v.2h.1a51.1 51.1 0 0 1-.1 0v-.1zl.1.2zh-.1zm.3-.5s.1 0 0 .1zm.1.2.2.2c-.1 0 0 0 0 0h-.1zm.3-.2c0 .1 0 0 0 0l-.1.1h.2v.2h-.1c.1 0 0-.1 0 0h-.1v-.3zm.5 0a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zs.1 0 0 0m0 0c-.1 0-.2-.1-.2 0l.1.2zm0-.5c0 .1 0 0 0 0m0 .1.2.3-.1-.2h-.1zm.3-.1h-.1v.1h.2v.2h-.1.1v-.1h-.2v-.2zm.4 0v.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2zh-.2a.2.2 0 0 0 .1.2h.1zm0-.3.2.3h.1-.1zm.2 0h.2v.2a.1.1 0 0 1 0 .1h-.1v.1h.1-.1zm0 0 .2.2c.1 0 0-.1 0-.2zm.2-.4s.1 0 0 0c0 .1 0 0 0 0m.1.1.2.3-.2-.2zm.1-.2.2.4h.1-.1zm.3 0a.1.1 0 0 1 .1 0l.1.2-.1.1a.2.2 0 0 1-.2-.1.1.1 0 0 1 0-.2.1.1 0 0 1 .1 0m0 0v.2h.2v-.1zm.3-.2c0 .1 0 0 0 0v.1h.1s.1.1 0 .2a45 45 0 0 1-.1 0h.2s0-.1-.1 0h-.1zm-1.7 4.3v-.2a.1.1 0 0 1 .1 0za.1.1 0 0 1 .2.1.2.2 0 0 1 0 .2h-.1c.1 0 0-.1 0-.2zm.6-.1-.2.2v-.4h-.1v.1-.1a.1.1 0 0 1 .1 0h.1v.3h.1zm.4-.7.2-.1v.6-.1l-.1-.1-.3-.1zv.1l.2.1zm.7 0a.1.1 0 0 1-.1.1l-.1-.1a.1.1 0 0 1 0-.2h.2s0 .1-.1 0c0 0-.1 0 0 .1a.2.2 0 0 0 0 .1zm.1-.3a.1.1 0 0 1 .1 0l.1.1-.1.2a.2.2 0 0 1-.2-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0m0 0v.1l.1.1h.1v-.2zm.3-.1v-.2h.1l.1.2v.1zv.2h.1v.1l-.2-.2zm.3-.3a.1.1 0 0 1 .1 0l.1.2s0 .1-.1 0a.2.2 0 0 1-.2 0 .1.1 0 0 1 0-.2zm0 0v.3l.2-.1v-.1c-.1 0-.2-.1-.2 0zm.5 0a.1.1 0 0 1-.2.1v-.1a.1.1 0 0 1 0-.2h.1l-.2.1a.2.2 0 0 0 .1.1zm0-.2h.2v.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1-.1.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm.2-.3v.2h.1v.1c-.1 0 0 0 0 0l-.2-.2zm.3 0v.1h.2v-.1.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2zm0 0c0-.1 0-.1 0 0m.1-.2.1.2h.1l-.1.1-.1-.2zm.2-.1v.1h.1s.1.1 0 .1v.1h-.1.2l-.1-.1h-.1zm.2-.4.3.4h-.1zm.5.3c-.1.1-.2 0-.2 0zh-.1v-.1h.2zm0 0v.1zm-4 3.3.2.2v-.3.4zm.3-.2.1.1h.1v-.1.2a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .2 0zm0 0c0-.1 0-.1 0 0m.3-.3v.1zv.4h.2-.2v-.2h-.1zm.4.1a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zs.1 0 0 0m0 0c-.1 0-.2-.1-.2 0l.1.2zm.3-.2-.1.1h-.1v-.2s-.1 0 0 0zc0 .1 0 0 0 0v.2zm0 0s0 .1 0 0m.3-.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2h.1v-.2h-.1zm0 0-.1-.2h-.2v.1zm.2 0c.1 0 .1 0 0 0v.1zm0-.5.2.2v-.2zl.1.3v.2s-.1 0 0 0v-.2zm.4-.5.3.4h-.1l-.2-.3zm.5.2-.1.1s-.1 0 0 0zh-.1v-.1h.1zm0 0-.1.1s0 .1 0 0zm0-.3.2-.1.2.2v-.2h-.1v-.1l.1.3-.2-.1zm.5-.2h.2v.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0 0a.1.1 0 0 0 0 .1m.2-.3v.2h.1l-.1.2v-.1l-.1-.2zm.5 0a.1.1 0 0 1-.1.2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.3h.1v-.2zv.1zm0 0c0-.1-.1-.1-.1 0v.1h.2zm.2 0v-.2s-.1 0 0 0h-.1v-.1h.2zm0-.1v.2a.2.2 0 0 0 .1-.1m.3-.2a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zm0 0h-.2l.1.2h.1zm.3-.5c.2 0 .2.1.2.2 0 0-.1.2-.2.1a.2.2 0 0 1-.1-.1.1.1 0 0 1 0-.1zm0 0v.4h.2l-.1-.2h-.1zm.3-.2v.1h-.1.2v.2l-.1.1c0-.1 0 0 0 0l.1-.1h-.2v-.2zm-4.6 3.8v.2l.2-.1.2.2h-.1l-.1-.2zv.1l.1.2h-.1zm.6.1-.1.1h-.1v-.2c0 .1 0 0 0 0zm0 0s0 .1 0 0m0-.3v.2h.1l-.1.1-.1-.2zm.4 0v.2l-.2-.1zs-.1 0 0 0c-.1.1-.1 0-.1 0zs0 .1 0 0m0 0a.3.3 0 0 0-.1 0v.1a.2.2 0 0 0 .1 0zm.1-.5.2.3h.1l-.1.1-.2-.3zm.2-.1.2.3v.1-.1l-.1-.1s-.1 0 0 0zm.3 0h.2a.2.2 0 0 1 0 .2.1.1 0 0 1-.1 0l-.3-.2v-.1zm0 0v.2h.2v-.2zm.2-.2v.2h.1a67.3 67.3 0 0 0-.1.1l-.1-.2zm.2 0 .1.1h.2v-.1.1a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0c0-.1 0-.1 0 0m.4-.3v.1h.2v.2h-.1v-.1h-.1zm.2.1"
            })
          ]
        })
      ]
    })
  ]
});
var Do_default = SvgDo;

// src/country-flag-icons/generated/Dz.tsx
import { jsx as jsx80, jsxs as jsxs73 } from "react/jsx-runtime";
var SvgDz = (props) => /* @__PURE__ */ jsxs73("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx80("path", {
      fill: "#fff",
      d: "M320 0h320v480H320z"
    }),
    /* @__PURE__ */ jsx80("path", {
      fill: "#006233",
      d: "M0 0h320v480H0z"
    }),
    /* @__PURE__ */ jsx80("path", {
      fill: "#d21034",
      d: "M424 180a120 120 0 1 0 0 120 96 96 0 1 1 0-120m4 60-108-35.2 67.2 92V183.2l-67.2 92z"
    })
  ]
});
var Dz_default = SvgDz;

// src/country-flag-icons/generated/Ec.tsx
import { jsx as jsx81, jsxs as jsxs74 } from "react/jsx-runtime";
var SvgEc = (props) => /* @__PURE__ */ jsxs74("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs74("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffe800",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#00148e",
          d: "M0 240h640v240H0z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#da0010",
          d: "M0 360h640v120H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs74("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx81("path", {
          d: "M269.6 290.8 197 367.3l-1.2-1.6 72.4-76.5 1.2 1.6zm50.4 12.5-94.8 100-1.6-1.6 94.7-100z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(-.07 -.07 -.1 .1 265 429.6)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(-.07 -.07 -.1 .1 240.6 390.5)"
        })
      ]
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185z",
      transform: "matrix(.45 0 0 .64 72.4 -59.8)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3z",
      transform: "matrix(.45 0 0 .64 72.4 -59.8)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6z",
      transform: "matrix(.45 0 0 .64 72.4 -59.8)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      d: "m206.2 116 72.4 76.5 1.3-1.6-72.4-76.5z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsxs74("g", {
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx81("path", {
          fill: "none",
          strokeWidth: 2.3,
          d: "M269.6 155.2c1.1 0 28.3-94 119-147.2",
          transform: "matrix(.4 -.03 -.05 .35 135.1 147.4)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.14 -.22 .3 .14 175.9 257.4)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.18 -.1 .1 .17 177.6 256.7)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.18 .12 -.13 .33 181 96.4)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.17 -.03 -.03 .33 179.3 159.3)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.06 .25 -.17 .2 228 45.5)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.2 -.2 .2 .24 150.3 241)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.22 -.22 .25 .2 135.6 282.1)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.26 .1 -.2 .32 130.8 147.7)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.15 .2 -.32 .22 178.5 103.3)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.08 .1 -.14 .16 250.7 102.6)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.1 0 -.08 .17 238 136.4)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(0 .14 -.14 .08 287.4 81.1)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.07 .1 -.25 .15 220.7 115.6)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.13 .22 -.33 .2 207 70.1)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "none",
          strokeWidth: 2.4,
          d: "M269.6 155.2c1.1 0 28.3-94 119-147.2",
          transform: "matrix(.35 -.2 .14 .28 111.8 227.8)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.18 -.1 .1 .17 200.3 224.6)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.18 -.1 .1 .17 211.1 218.3)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.2 -.1 .07 .13 166.8 232.7)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.2 -.1 .07 .13 170 231.3)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.2 -.1 .07 .13 168.1 234.3)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: 0.3,
          d: "M252.7 167.3c.4.8 0 1.8-1 2.3s-2 .2-2.4-.7 0-1.8 1-2.3 2-.2 2.3.7z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: 0.3,
          d: "M255 164.9c.3.8 0 1.8-1 2.3s-2 .2-2.5-.6 0-1.9 1-2.4 2-.1 2.4.7z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: 0.3,
          d: "M255.5 166c.4.8 0 1.9-1 2.3s-2 .2-2.4-.6 0-1.8 1-2.3 2-.2 2.4.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      d: "m183.8 158 94.8 100 1.7-1.6-94.8-99.9z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#cececc",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m460.6 184.3 17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z",
      transform: "matrix(.14 -.14 .1 .1 86.3 192.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#cececc",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m557.8 95.7-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z",
      transform: "matrix(.1 -.16 .14 .1 114 183.8)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
      transform: "matrix(.4 0 0 .3 43.8 69.8)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
      transform: "matrix(.38 .1 -.15 .3 76 38.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M186.7 151.5c0 1-1 2-2.2 2-1.2 0-2.2-1-2.2-2s1-1.8 2.2-1.8c1.2 0 2.1.8 2.1 1.8zm-3.2 4c0 17.9 10.5 93.9 11.3 95.8 0 2.2-2.3 3.2-3.5.4-3.3-8.7-10.4-80-10.7-96.6-.1-6.9 1.9-7.4 4.2-7.3 1.9.1 4.1 1.9 4.1 4 0 2.4-2.9 4.3-5.4 3.7z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
      transform: "matrix(.48 .15 -.2 .48 16.7 31.6)"
    }),
    /* @__PURE__ */ jsxs74("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx81("path", {
          d: "m370.4 290.8 72.5 76.5 1.3-1.6-72.5-76.5zM320 303.3l94.8 100 1.6-1.6-94.7-100z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(.07 -.07 .1 .1 375 429.6)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(.07 -.07 .1 .1 399.4 390.5)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs74("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffdf00",
          stroke: "#000",
          d: "M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185z",
          transform: "matrix(-.45 0 0 .64 567.6 -59.8)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3z",
          transform: "matrix(-.45 0 0 .64 567.6 -59.8)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#e10000",
          stroke: "#000",
          d: "M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6z",
          transform: "matrix(-.45 0 0 .64 567.6 -59.8)"
        }),
        /* @__PURE__ */ jsx81("path", {
          d: "m433.8 116-72.4 76.5-1.3-1.6 72.4-76.5z"
        }),
        /* @__PURE__ */ jsxs74("g", {
          fill: "#005b00",
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.16 -.07 .08 .35 309.5 211)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.2 -.05 .07 .4 291.5 182.6)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.23 .14 -.03 .4 296.5 69.4)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.25 .03 .02 .44 274.4 115)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.18 .17 -.04 .35 330 67)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.23 0 .03 .4 280.6 141.9)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.2 -.07 .07 .38 290.1 196.8)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.2 -.03 .05 .4 292.7 166.8)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.22 .15 -.05 .38 305 65.5)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.24 .05 0 .44 278.9 97.7)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.17 .17 -.06 .33 339 70)"
            }),
            /* @__PURE__ */ jsx81("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.24 .02 0 .4 276.4 128)"
            })
          ]
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffdf00",
          stroke: "#000",
          d: "M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#e10000",
          stroke: "#000",
          d: "M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          d: "m456.2 158-94.8 100-1.7-1.6 94.8-99.9z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#cececc",
          stroke: "#000",
          d: "m460.6 184.3 17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z",
          transform: "matrix(-.14 -.14 -.1 .1 553.7 192.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#cececc",
          stroke: "#000",
          d: "m557.8 95.7-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z",
          transform: "matrix(-.1 -.16 -.14 .1 526 183.8)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#e10000",
          stroke: "#000",
          d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
          transform: "matrix(-.4 0 0 .3 596.3 69.8)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
          transform: "matrix(-.38 .1 .15 .3 564 38.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#e10000",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M453.4 151.5c0 1 1 2 2.1 2 1.2 0 2.2-1 2.2-2s-1-1.8-2.2-1.8c-1.2 0-2.1.8-2.1 1.8zm3 4a1152 1152 0 0 1-11.2 95.8c0 2.2 2.3 3.2 3.5.4 3.3-8.7 10.4-80 10.7-96.6.1-6.9-1.9-7.4-4.2-7.3-1.9.1-4.1 1.9-4.1 4 0 2.4 2.9 4.3 5.4 3.7z"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
          transform: "matrix(-.48 .15 .2 .48 623.3 31.6)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs74("g", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx81("path", {
          fill: "#e10000",
          d: "M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z",
          transform: "matrix(.58 0 0 .62 9.6 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          d: "M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(.35 0 0 .7 123.5 -90)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          d: "M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3z",
          transform: "matrix(.35 0 0 .7 123.5 -90)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffdf00",
          d: "M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(.35 0 0 .46 112.5 51)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffdf00",
          d: "M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(.35 0 0 .46 112.5 51)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#e10000",
          d: "M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          d: "M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(-.35 0 0 .7 516.5 -90)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#0000c4",
          d: "M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3z",
          transform: "matrix(-.35 0 0 .7 516.5 -90)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffdf00",
          d: "M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(-.35 0 0 .46 527.5 51)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#ffdf00",
          d: "M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(-.35 0 0 .46 527.5 51)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs74("g", {
      fillRule: "evenodd",
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 4.5,
          d: "m198.6 78-89.7 35.4 89.7 35.4 44.8-17.7 22.4 17.7 22.4 35.4 22.5-35.4 22.4-17.7H1535V95.7H333l-22.4-17.8c0-17.7 4.7-35.4 22.5-35.4h89.6c0-17.7-44.8-53.1-134.5-53.1-89.6 0-134.5 35.4-134.5 53.1h89.7c17.7 0 22.4 17.7 22.4 35.5l-22.4 17.7z",
          transform: "matrix(.12 0 0 .22 217.8 324.4)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#b74d00",
          strokeWidth: 1.8,
          d: "M204.3 95.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.7H541V78H204.4zm0-17.7H541v17.7H204.4zm0-17.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.6H541V7H204.4z",
          transform: "matrix(.28 0 0 .27 216 334.6)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 .27 171.9 315.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 -.27 171.9 382.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 159.6 315.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 .27 216.2 315.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 -.27 216.2 382.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 238.4 315.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 204 315.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 194 315.2)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs74("g", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx81("path", {
          d: "M655.5 396.9c0 88-55.6 159.4-124 159.4s-124-71.4-124-159.4 55.5-159.5 124-159.5 124 71.4 124 159.4zm-17.7 0c0 78.2-47.6 141.7-106.3 141.7-58.7 0-106.3-63.5-106.3-141.7 0-78.3 47.6-141.8 106.3-141.8 58.7 0 106.3 63.5 106.3 141.8z",
          transform: "matrix(.58 0 0 .62 9.6 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          d: "M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0z",
          transform: "matrix(.58 0 0 .62 9.6 -10.2)"
        }),
        /* @__PURE__ */ jsx81("path", {
          d: "M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0z",
          transform: "matrix(.58 0 0 -.62 9.8 479.3)"
        })
      ]
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#a7cfff",
      fillRule: "evenodd",
      d: "M379.6 235.9c0 48.5-27.7 87.8-61.7 87.8s-61.6-39.3-61.6-87.8 27.6-88 61.6-88 61.7 39.4 61.7 88"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#afff7b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M637.8 396.9c1.1 26.6-4.6 39.6-11.9 67.3-1.9 3-11-6.5-16.4-11.2s-7.8 4.2-14.6-3c-6.7-7.4-11 2-16-4.2s-51.3-7-51.3-7.6c4.6-2.2 28.2.2 24.4-11.1-4.3-11.8-31-.4-34.6-15.4-2.5-15-53.6-15.6-57.3-19.2 1.5 5.6 39.8 8 38.9 22.5-.9 6-37.7 7.7-41.3 12.7-3 6.3 29-1.7 30.1 6 0 3.2-4.7 0-21.3 5-8.4 2.5 15.4 10.3 6.4 14.6-9 4.3-28.3 6.2-27.5 8 3 9 44.7 19.6 40.6 21.1-14.8 6.6-22.6 10.9-29.7 14.7a167.9 167.9 0 0 1-31.1-100.2c31.7-11.4 25-13.8 83.6-13.8s78 2.3 129 13.8z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M637.8 396.9c-8 0-16.4 3.4-25 3.4-8.7 0-17.5-3.5-26.5-3.5s-19.3 4.6-28.5 4.6c-9.3 0-17.4-4.5-26.7-4.5s-18.6 3.4-27.8 3.4-18.3-3.5-27.2-3.5-17.7 3.5-26.2 3.5-16.8-3.5-24.7-3.5c0-19.5 3-38.1 8.4-55.1 27 2 11-15.7 27-15.7a33 33 0 0 1 25.3 9.8c2.4 0 14.4-11.4 27.9-9.8 13.4 1.6 8.5 27.3 26.4 28.6 9 6.8 14.3 11.1 26.7 13.9 17.7 1.6 68.4-2.5 68.7-.2a188.2 188.2 0 0 1 2.2 28.6z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-.2-3.5 10.3-7 14.9-7.4s8.5 7.4 8.5 9.1-4.7-4.2-8.6-4.3-12.3.6-12.3 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z",
      transform: "matrix(.2 0 0 .48 217.2 59.5)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-1-4 11.8-6.6 16.4-6.9s10 8 10 9.6-5.4-5.2-9.3-5.3-14.6.6-14.6 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z",
      transform: "matrix(-.2 0 0 .48 445.8 59.1)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      d: "M333 264.9c0 1.3-.7 2.4-1.5 2.4s-1.4-1.1-1.4-2.5.6-2.4 1.4-2.4c.8 0 1.5 1.1 1.5 2.5m17 9h.4v19.5h-.5zm4.1-1.6h.5V292h-.5z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      d: "M352.6 281.2v-.5l4 .7v.5z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#b74d00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M497.3 478s26 11.4 31.7 18.2c5.6 6.8 3.4 6.8 3.4 6.8l57.7 2.3c0-3.4 10.2-3.4 12.5-11.4 2.3-7.9 2.3-10.2 2.3-10.2l-18.1 5.7 1-10.2H572l-2.3 10.2-34-1.1L538 461l-6.8 1.1-1 26c-1.2 0-31.8-7.9-33-10.1z",
      transform: "matrix(.58 0 0 .62 7 -9.5)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#fede00",
      fillRule: "evenodd",
      stroke: "#fede00",
      strokeWidth: "1pt",
      d: "M440.5 316.3s37.7-11.2 92.1-10.4 92.1 12.8 91.3 12.8-10.4-18.4-10.4-18.4-38.4-10.5-81.7-11.3c-43.2-.8-80.9 8-80 8.8z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#38a9f9",
      fillRule: "evenodd",
      d: "m306 169.8 13.6-.2.2 7.9-13.6.3zm-31.2 4.3L270 182l16.2-2-1.3-7.7-10.1 2zm13.7-3 13.6-1.1.6 7.8-13.5 1.2zm48.9-.7-13.5-1-.5 8 13.5.8zm29.2 5 4.9 9.6-14.6-3.6 1.6-7.7 8 1.6zm-11.8-3-13.4-1.7-1 7.8 13.5 1.8z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m532.6 323.5-2.5-13.5-7.6 11.5 2.8-13.5-11.3 7.7 7.6-11.3-13.4 2.8 11.5-7.6-13.5-2.5 13.5-2.6-11.5-7.6 13.4 2.8-7.7-11.3 11.4 7.7-2.8-13.5 7.6 11.5 2.5-13.5 2.6 13.5 7.5-11.5-2.7 13.5 11.3-7.7-7.7 11.3 13.5-2.8-11.5 7.6 13.5 2.6-13.5 2.5 11.5 7.6-13.5-2.8 7.7 11.3L540 308l2.8 13.5-7.6-11.5z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M547 293.9c0 9.3-6.6 16.8-14.8 16.8s-14.8-7.5-14.8-16.8S524 277 532.2 277s14.8 7.6 14.8 17z",
      transform: "matrix(.57 0 0 .5 18.3 21.8)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fillRule: "evenodd",
      d: "M320.7 170.6c0 .5-1.3 1-2.8 1s-2.8-.5-2.8-1 1.2-1 2.8-1 2.8.4 2.8 1m6 0c0 .5-.9 1-2 1s-2.2-.5-2.2-1c0-.6 1-1 2.1-1s2.1.4 2.1 1"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m529.4 297.9.8.8c-1.9-2-1-1.2 1.6 3.2 2.4-.5 3.1-1.4 4.8-2.4",
      transform: "matrix(.56 -.18 .17 .6 -26.7 90.6)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m527.8 304.3.8.8c-1.9-2-1-1 3.2 1.6 4 .5 8.1-1.2 10.5-4",
      transform: "matrix(.58 0 0 .62 8.7 -10.2)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#b7e1ff",
      fillRule: "evenodd",
      d: "M281.4 194.8s1 8-5.1 18c-6 9.9-5.1 6.4-5.1 6.4s2.8 5.5 2.3 5.5-4.7-5-4.7-5l-5 5.5s4.6-8.5 4.1-8.5-1.4-3-1.4-3l3.7-1.5s5.6-10.4 5.6-9.9-16.7 11.4-16.7 11.4zm3.7 3c-.5 0 2.3 8 4.7 12 2.3 4 2.3 8.9 2.3 8.9l7.9 4-10.2-15.4 6.5 2.4zm0 20.9s5.6 6 6 8 .5 6.4.5 6.4l-2.3-5-3.3 4.5s2.4-7 1.9-7.5-3.7 2.5-3.7 2.5 1.4-4 1.4-4.4 0-3-.5-4.5m-27.9 13.9c1.9-1.5 5.6-2.5 5.6-2.5s-2.3 4-2.8 4-1.8 0-2.8-1.5m64.1-21.8s12.1 7.4 12.1 7.9-7.9-3.5-7.9-3.5zm-21.8-15.5c1 .5 17.7 14.4 17.2 14.4s-7.4-4-7.4-3.4v3.4l-3.8-7.9-.9 3zm4.2 22.4 4.6 9.4 4.7-1s-8.8-8.4-9.3-8.4m14.4-6 .5 9s2.7 2.5 2.7 2-2.7-10.5-3.2-11"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#984000",
      fillRule: "evenodd",
      d: "M182.6 89.5s21-11.6 44.9-20.2a303.8 303.8 0 0 1 54.2-14.4c7 0 19.2 17.8 21.2 17.8s10.1-5 20.3-5 16.1 8 18.2 8h18.2c2 0-6.1-19.8 0-18.8 3 .5 28.8 4.5 52.8 12.2 24 7.8 58 21.6 58 21.6S414.9 98 400 95.9c-2 1 0 13-3 7.7-4.6-1-21.7-3.7-24.7-3.7s-8.7 3.4-16.8 5.4c-8 2-18.2 5-18.2 5l13.2 20.7-16.2 8s-10.1-23.8-14.2-23.8-6 16.8-11.1 15.8c-5-1-7-15.8-11.1-19.8-4-3.9-25.4-5.4-33.5-7.3-8-2-21.1-3.5-28.2-5.5-7-2-14.2 5-17.2 5s4-6 1-7-5 3-7 3-23.3-4-25.3-5 5-4.9 3-4.9z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "gray",
      fillRule: "evenodd",
      stroke: "#772600",
      strokeWidth: 3.7,
      d: "M463-65c0 21.2-20.6 38.4-45.9 38.4S371.3-43.8 371.3-65s20.5-38.3 45.8-38.3S463-86.1 463-65z",
      transform: "matrix(.22 0 0 .26 231.6 96.5)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#984000",
      fillRule: "evenodd",
      stroke: "#772600",
      strokeWidth: 5.3,
      d: "M284.7-60c6.7-6.6 15-16.6 36.7-16.6 5-1.7 5-11.7 16.6-11.7 11.7 0 8.3 10 16.7 13.4 8.3 3.3 76.6-3.4 76.6-3.4s6.6 5 6.6 11.7-5 11.6-6.6 11.6-68.3-5-73.3-3.3c-5 1.7-8.3 3.3-20 3.3-11.6 0-15-11.6-23.3-11.6s-16.6-1.7-30 6.7z",
      transform: "matrix(.27 0 0 .32 205.4 100.7)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "none",
      stroke: "#772600",
      strokeWidth: 3.5,
      d: "M487.9-76.6h26.6c9.6.1 12.9 3 21.7 3.3h23.3c8.5-.3 13-2.3 21.6-3.3 14.5-.2 9.6-1.3 6.7-10-2.6-6.5-3-9.6-6.7-13.3-1.4-8-4.6-10.8-5-20-1.5-7-4.3-11.7-1.6-20 3.8 5.7 5.3 8 15 8.4 10 0 13.9-.3 20 3.3 4.6 4.9 10.8 3.3 20 3.3 7.6 1.4 8.9 5.3 14.9 8.3 7.1 4 11.7 5 21.6 5 8 1.5 15 2.6 20 5 4.3 5.1 11 6.4 20 6.7 5 0 9-.5 13.3-1.7 7.7.4 15.5 0 25 0 6.2 7.2 7.6 9.9 18.3 10 7.4 5.2 13.6 6 20 8.3h25c9 .7 11.8 4.4 20 6.7a200.9 200.9 0 0 0 21.6 8.3 108 108 0 0 0 21.7 1.7c6.1 3.2 13.6 3.4 18.3 6.6 6.9 1.5 16.3 3.3 21.6 5 8.8 1.2 12.2 4 20 5 6.7 2-2.2 3.6-6.7 5-9.8-.3-10.5-4-20-5-5-2.9-12.6-2.5-20-5h-1.6c6.6 4 13 6.5 10 13.4-8.5 0-15.4-1.1-23.3-1.7-8.4-1.6-12.2-3.3-21.6-3.3 9.4-2.3 11.8.2 18.3 3.3 2.4 8-2.8 5-11.7 5-7.6-2.7-12.2-6-21.6-6.7h-20c9.9.4 12 4.1 18.3 8.4.5 2.6-.1 2.4-5 3.3-5.2-4.5-11.9-6-20-8.3-7.9-.3-16.2-1-23.3-3.4-4.9-.3-4.1-6.1 6.7 3.4 6.5 3.8 8.8 7 8.3 10-8.6-2.2-12.8-5.6-18.3-8.4a61.3 61.3 0 0 0-23.3-3.3c-8.6-2.3.9-3.6 6.6 5 12.4 8.8-1.6 5-6.6 3.3-7.5-2.1-15.3-5.2-21.7-6.6-5-1.5-9.4-2.9-15-3.4 8.7.8 11.6 3.9 15 10 8.8 6-.4 3.1-8.3 1.7-5-4.4-11.5-6.7-15-11.7-8.3-4.1-8.6-9-3.3 1.7 1.3 3.4 1 10.8 1.6 11.7-6.1-6.7-4.8-8.4-11.6-8.4-4.7-3.2-11.5-5.7-15-10-6.4-.6-6.8-2.9-13.3-5 5.3 6.3 12.4 12.5 16.6 18.4 7.6 4.2 9.7 8 15 11.6 2.1 3.7 8 6.7 1.7 1.7-7.2-7-12.5-8.7-23.3-13.3-6.2-5-8.4-7-15-11.7-9-2.9-5.5-4.5 0 5 6.3 5.8 11.1 12.2 16.6 16.7a67.8 67.8 0 0 0 15 13.3c1.5 2.2 6 2.6 0 3.3-5-4.6-12.4-7.5-18.3-11.7-8.3-2.3-12.2-6.6-18.3-11.6-4-5.9-10.4-10.4-15-15-9.6-3.8 1.9 3.6 5 8.3 2.1 6.1 4.8 11 6.6 16.7 2.8 5.5-8.4-1.3-11.6-3.3a57 57 0 0 0-21.7-8.4 298 298 0 0 0-20-3.3c-7.5-2 4.1 4.8 8.4 11.7 8.4 7.9-8.3 1.4-13.3 0a125 125 0 0 0-25-1.7c-10.7.6-3 2 0 6.6 3.3 2.6 5.6 8 5 10-7-1-13-3-21.7-3.3-7 2.3-15.3 1.7-23.3 1.7-.3 4.2 1.5.6 5 5 5.8 2.3 9.6 5.1 8.4 8.3h-48.3c-5.3 1.4 1.1.7 5 6.7-2.2 5.4-5 3.3-11.7 3.3-4.5-1.8-13.6-2.6-18.3-5-4.7 0-4.3-1.2-8.3-1.7 14 10 7 7.5 15 15 1.3.5 4.5 1.7 1.6 1.7M371.3 73.3c-1 0-3.2-5.4-6.6-10-2.4-6-5.4-2.6-8.4-11.7.4-9.4.7-11 0-20-6.8-4.8-9.7-6.2-15-15-8.4-7 1.3-19 2.9-27.8-7.4-1.6-11 11.5-22.3 16.2-8.2 5.5-1-11.4-5-21.2-2.7-13.9-10.8 7-13.8 12.9-5.5 3.7-7.2 8.5-15 1.6 0-5.1 4.9-19.5 2.8-22.3-7.8 3.9-18 15.5-26.1 17.3-8.2-1.7 1.7-14.8 1.7-24.5-3-1-14.7 25.8-19.5 26s-2.7-26-5-25.4c-3.5 5-10.6 15.4-15.5 19-9.5-1.3 1.4-17.5 2.8-23.5 1.6-7.2-8.9 13.8-14.5 15.1-4.1 3.6-12.2 6-15 6.7 3.2-6.2 19-18.7 18-22.3-9.3.3-23.4 12.5-31.3 14-5.2 0-12.4 1.7-13.3 1.6.4-8 19.4-14.6 22.4-19.5-9.3 1.5-27.2 9.7-32.4 16.2-6.2 1.3-14 3-20 0 .9-7.5 14.9-22 18-26.8-8.5 3.7-12.7 6.6-21.7 8.3-1.7 1.7-6.5 5.3-5 1.7 2.7-7 6.7-10 10-15-7.5 1.4-10.3 5.7-18.3 10-5.1.2-19.7 14.9-24.6 15.1a69.1 69.1 0 0 1-28.3 13.3c-7.6 1.4-11.3 3-15 6.7 3.8-6.7 9.6-13 15-16.6a29.8 29.8 0 0 1 15-13.4c1.9-2.3 7.1-2.9 1.6-3.3-4.7 4.2-12.7 9-16.6 11.7-5.1 3.2-11 6.4-13.4 5 2.7-7.2 7.5-9 11.7-15 8.8-5.6 0-2-6.7 0-4.3 3.8-12 6.7-18.3 10-7 1.8-11.7 6-20 8.3 0 2.4 2.4-4.3 3.4-6.7 6.8-7.4 8.6-9.5 16.6-11.6 2-2.9 4.4-1.7-1.6-1.7-4.6 4-10.8 6.2-16.7 10-5.9 1.3-13.6 1.7-21.6 1.7-10.4 1.2-9.5 2 0-3.4 5.3-5 9.7-3.7 10-10-6.3 4.6-14 8-21.7 11.7-6.4.2-8.1 1.7-15 1.7 3.3-3.4 5.3-7.7 10-10 7-7.7-4.4-1.5-6.7 0h-25c-4.4 5.6-.2 0 3.4-3.4 4.3-2.2 8.8-5.1 8.3-6.6-5 4.3-10.7 6.3-15 10-4.6 1.4-10 2-10 3.3 3.7-5.3 9.6-8.6 13.4-13.3 5.6-1.2 10.4-3 11.6-5h-23.3 16.6c8.5 0 15.7-.8 23.4-1.7 13.2-2.2-1.2-3.3-8.4-3.3-1.3-2.6 4.2-4 10-5C-6.7-69-.4-71.1 5-73.3a45.2 45.2 0 0 0 13.3-6.6c-5 .2-5 1.4-10 1.6 7.5-.5 12.8-1.6 21.7-1.6a239 239 0 0 0 21.6-8.3c3-3.6 4.2-3.4-3.3-3.4 6.7-2.1 16.2-3.2 21.6-5a94 94 0 0 0 20-6.6c4.9-3.3 7.7-7.2 13.3-10 6.5 4.4 6.6 5 18.3 5 9.4-.1 15.2-2.4 20-6.7 7.2-2 8.5-5.4 16.7-6.6a134 134 0 0 0 23.3 1.6c8-2.1 15.7-6 21.6-10 5.1-2.5 11.2-6.1 16.7-8.3 6 3.1 10.8 5.6 18.3 6.7 7.7-1.2 11.8-5 18.3-6.7a28 28 0 0 1 15-8.3c9.7-4.8 9 1.5 13.3 6.6 5 5.2 11.4 2.7 18.3 5 3.9 6 6.7 10 11.7 13.3 3.9 4.8 8.5 6 16.7 6.7 3 4 .6 6.8 6.6 8.3 2.4 2.6 6.5 3.6 10 5",
      transform: "matrix(.27 0 0 .32 205.4 104.9)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "none",
      stroke: "#782600",
      strokeWidth: 3.1,
      d: "M468.7 30.8v.8c0-2.3 0-1 1.7 3.4.6 3.6-.8 3.2-2.5 5.8-.3 3.7-.8 6.4-.8 10.8-.6 3.6-2.6 7-4.2 10-1.6 3.1-8.5 4.9-8.3 9.2-4 1.1-4.1-1.5-4.2-5.9-2.4-2.7-3.2-6.4-5-10-1-3.4-3.4-6-5-10-2.4-3.7-4.5-4.8-6.6-9.1-.9-2-.7-4.6-2.5-5.8-2.7-3.5-4.5-4-9.2-4.2-3.6.8-5 2.4-8.3 3.3-2.6.9-7.6.6-10.8 1.7-.8 1.3 1.6 2 2.5 5-2.2 1.8-3 4.9-4.2 7.5-2 2.5-3.3 3.7-4.2 7.5 1.4 2.3.2 5.4-1.6 7.5-.6 3.8-2.5 5.9-3.4 9.1-2.6 1.9-3.6 3.6-5.8 6.7-1.9 2.7-3.6 2.5-8.3 2.5-3.7-1-4.2-3-7.5-4.2-.3-1-.6-1.3-1.7-1.6",
      transform: "matrix(.27 0 0 .32 205.4 104.9)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#812e00",
      fillRule: "evenodd",
      d: "M307.6 125.5s-.4 5-3.6 8.3-9.8 7.1-9.8 7.1 8.9-4.2 9.8-3.3c1 1-5.7 8.3-5.7 8.3s8.7-7.7 9.8-7.7 3.6 7.5 4.6 7.3c.9-.2-2-9.5-1.6-11 .4-1.4 0-9.3 0-9.3l-3.4.3zm20.5-.6s-.4 5.3-3.6 8.8-9.8 7.6-9.8 7.6 8.9-4.5 9.8-3.5c1 1-5.7 8.8-5.7 8.8s8.7-8.2 9.8-8.2 3.6 8 4.6 7.8c.9-.2-2-10.2-1.6-11.7.4-1.6 0-10 0-10zm-28.7-48c0 .9-1 1.7-2.1 1.7s-2.2-.8-2.2-1.8 1-1.8 2.2-1.8 2.1.8 2.1 1.8z"
    })
  ]
});
var Ec_default = SvgEc;

// src/country-flag-icons/generated/Ee.tsx
import { jsx as jsx82, jsxs as jsxs75 } from "react/jsx-runtime";
var SvgEe = (props) => /* @__PURE__ */ jsxs75("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx82("path", {
      fill: "#1791ff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#000001",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#fff",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Ee_default = SvgEe;

// src/country-flag-icons/generated/Eg.tsx
import { jsx as jsx83, jsxs as jsxs76 } from "react/jsx-runtime";
var SvgEg = (props) => /* @__PURE__ */ jsxs76("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx83("path", {
      fill: "#000001",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx83("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx83("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsxs76("g", {
      fill: "#fff",
      stroke: "#c09300",
      transform: "matrix(.8 0 0 .8 -40 0)",
      children: [
        /* @__PURE__ */ jsx83("path", {
          strokeLinejoin: "round",
          strokeWidth: 1.3,
          d: "m450.8 302.4 68.5 63.6-4.9-115.5c-.7-17.5-15.9-13.5-27-7.2-11.1 7.2-24 7.2-37.4 2.5-13.5 4.7-26.3 4.7-37.4-2.5-11-6.3-26.3-10.3-27 7.2L380.7 366z"
        }),
        /* @__PURE__ */ jsx83("path", {
          id: "eg_svg__a",
          fill: "#c09300",
          stroke: "none",
          d: "m393.5 246.5-4.8 112.3-8 7.2 4.9-115.5a24 24 0 0 1 7.9-4m9.6 8-4 94-8 8.2 4.8-108.5c1.6 1.6 6.3 5.5 7.2 6.3m8.7 7.2-3.1 78.4-6.5 6.3 4-89.4c1.6 1.5 4.8 3.8 5.6 4.7m9.5 4-3.1 66.8-6.3 5.1 3.1-74.3c1.6.7 4.7 2.4 6.3 2.4m8.8 0-2.3 55.7-6.5 6.3 2.5-61.3c1.5 0 5.6 0 6.3-.7"
        }),
        /* @__PURE__ */ jsx83("use", {
          xlinkHref: "#eg_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 900 0)"
        }),
        /* @__PURE__ */ jsx83("path", {
          fill: "#c09300",
          strokeWidth: 1.1,
          d: "m453.2 315 9.6 43.8-3.2 3.2-3.3-2.5-5.4-39 2.3 39-3.2 4-3.1-4 2.3-39-5.5 39-3.3 2.5-3.2-3.2 9.6-43.7h6.4z"
        }),
        /* @__PURE__ */ jsxs76("g", {
          id: "eg_svg__b",
          fill: "none",
          strokeLinejoin: "round",
          strokeWidth: 1.3,
          children: [
            /* @__PURE__ */ jsx83("path", {
              fill: "#fff",
              strokeWidth: 1.2,
              d: "m428.5 295.8-19.1 67.7 26.3 4 11.1-50.9z"
            }),
            /* @__PURE__ */ jsx83("path", {
              d: "m422.2 319 2.3 5.5 12.4-11.8"
            }),
            /* @__PURE__ */ jsx83("path", {
              d: "m430.8 305 2.6 24.3 7.9-10.4m-3.2 4 4.3 15m1.7-5.5-8.7 13.2m2.7 13.2-2.8-13.2-2.4-13.4-5.9 7.9-2.5-9.1-8.2 8.4 4.1 15.2 5.8-9.4 3.1 9.6 6-9.2"
            }),
            /* @__PURE__ */ jsx83("path", {
              d: "m415 362 5.3-7.5 3.4 11.5 4.8-8 3.1 9.6"
            })
          ]
        }),
        /* @__PURE__ */ jsx83("use", {
          xlinkHref: "#eg_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 900 0)"
        }),
        /* @__PURE__ */ jsxs76("g", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.3,
          children: [
            /* @__PURE__ */ jsx83("path", {
              strokeWidth: 2.4,
              d: "M450 393.8c20 0 39-1.6 50.2-4.7 4.7-.9 4.7-3.3 4.7-6.5 4.8-1.6 2.4-7.2 5.7-7.2-3.4 1-4-5.5-8-4.7 0-5.6-5.7-6.3-10.4-4.7-9.5 3.1-26.3 3.9-42.2 3.9-16-.8-32.6-.8-42.2-4-4.7-1.5-10.3-.8-10.3 4.8-4-.8-4.7 5.6-8 4.7 3.3 0 .8 5.7 5.6 7.2 0 3.2 0 5.6 4.8 6.5 11 3.1 30.2 4.7 50.1 4.7"
            }),
            /* @__PURE__ */ jsx83("path", {
              d: "M422.9 363.5c6.4.9 13.6 1.6 19.2.9 3.2 0 5.5 5.5-.9 6.3-5.5.7-14.3 0-19-.8a231 231 0 0 1-18.4-4c-5.6-2.4-1.6-7 1.6-6.4a105.3 105.3 0 0 0 17.5 4m54.2 0c-6.4.9-13.6 1.6-19 .9-3.4 0-5.7 5.5.7 6.3 5.6.7 14.3 0 19-.8 4-.8 12.8-2.3 18.4-4 5.6-2.4 1.6-7-1.6-6.4a105.2 105.2 0 0 1-17.5 4"
            }),
            /* @__PURE__ */ jsx83("path", {
              d: "M403 360.4c-4.8-.9-7 4.7-5.5 7.9.7-1.6 4-1.6 4.7-3.2.9-2.4-.7-2.4.9-4.7zm19.2 14.7c0-3.2 3.1-2.8 3.1-6 0-1.5-.8-4-2.4-4a3.4 3.4 0 0 0-3.2 3.2c-.7 3.1 2.5 3.6 2.5 6.8m22.7-9.1c4.7 0 4.2 6.3 2 9.5 0-2.3-4-3.2-4-4.8 0-2.4 3.6-2.4 2-4.7m52-5.6c4.9-.9 7.2 4.7 5.6 7.9-.7-1.6-4-1.6-4.7-3.2-.9-2.4.7-2.4-.9-4.7M478 375c0-3.2-3.2-2.8-3.2-6 0-1.5.8-4 2.4-4a3.4 3.4 0 0 1 3.2 3.2c.7 3.1-2.5 3.6-2.5 6.8zm-23-9c-4.7 0-4.2 6.3-2 9.5 0-2.3 4-3.2 4-4.8 0-2.4-3.6-2.4-2-4.7"
            }),
            /* @__PURE__ */ jsx83("path", {
              strokeWidth: 0.9,
              d: "M404.7 362c1.6 0 4 .7 4.7 1.6zm7.9 2.4c.8 0 4 .7 5.5 1.6zm28.6 3.2c-1.5 0-4.7 0-5.5.7l5.5-.8zm-8.7 0c-.9-.9-4-.9-5.6 0zm62.8-5.6a8 8 0 0 0-4.7 1.6zm-7.8 2.4c-1 0-4 .7-5.6 1.6zm-28.7 3.2c1.5 0 4.7 0 5.6.7l-5.6-.8zm8.7 0c.9-.9 4-.9 5.6 0z"
            }),
            /* @__PURE__ */ jsxs76("g", {
              fill: "#c09300",
              stroke: "none",
              children: [
                /* @__PURE__ */ jsx83("path", {
                  d: "M403.3 374.6c-.5-.1-.8-.6-.6-1 .1-.7.6-1 1-.8.4 0 .9.6.9.8l-.4.7-.2.1c0 .2-.4.2-.7.2m55 3.9c-.2 0-.6-.5-.6-.7 0-.4.6-1 1-1l.8.4c.3.3.3.9-.1 1.2-.2.2-.8.2-1.1 0zm.3 2.5c-.4-.2-.5-.4-.6-.8 0-.5 0-.6.5-.9l.4-.2.4.2c.4.2.7.4.7.8 0 .3-.3.6-.7.8-.3.2-.4.2-.7 0z"
                }),
                /* @__PURE__ */ jsx83("path", {
                  d: "M407.8 370c-.4 0-.9.4-1.2.6-.6.1-1.4.5-2 0-.6-.1-1.4 0-1.5.8.1.7 1 1 1.6.6.4-.5 1.5-.9 1.7 0-.5.8-.4 1.7-.8 2.4 0 .5-.3.9-.5 1.3-.5 0-1 0-1.4.3a2 2 0 0 0-1.6.8c-.4.6-.8 1.2-.9 2 .1.6 1 .8 1.6.9l2 .6 3.2.9c1.6.5 3.2.7 4.8 1.1l.5.1c.7.2 1-.5 1-1l1-3.6c.2-.5.5-1.5-.4-1.3-.5.3-1 .8-1.6.8-.9 0-.4 1 0 1.3 0 .6-.2 1.3-.5 1.8-.6.3-1.2 0-1.8-.2-.5 0-1.7-.3-1.2-1l.5-1.8c.3-.6.3-1.3.5-2-.4-.7-1 .3-1.5.4-.4.2-1.6.3-1 1 .6.4.2 1.1 0 1.7 0 .7-.8 1-1.4.7-.6 0-1.5-.5-1-1.1l.5-1.8.7-2c0-.7.3-1.2.6-1.8 0-.7.5-1.3.5-2 0-.3-.2-.4-.4-.4zm-3.7 7.3a.3.3 0 0 1 .3 0c.2.2.2.4 0 .6l-.3.2c-.5 0-.6-.1-.6-.3 0-.1 0-.2.3-.3a1.4 1.4 0 0 1 .4-.2zm-1 5c-.5-.4-.4-.7.3-1.3.4-.2.5-.2.9.1.6.5.6.8 0 1.3-.2.2-.3.2-.5.2-.3 0-.4 0-.7-.2zm3 1a.9.9 0 0 1-.6-1.1c.2-.4.3-.5.9-.5.7 0 .8.1.9.7 0 .4 0 .5-.3.7a1 1 0 0 1-.8.2zm89.2 0c-.2-.1-.3-.2-.3-.5 0-.4.2-.7.8-.9.6-.3 1-.3 1.2.2.3.6.3.8-.1 1.2-.2.3-.3.3-.8.3s-.6 0-.8-.2zm-85 1.2c-.4 0-.6-.4-.6-.8 0-.3 0-.4.2-.6l.6-.2.6.1c.5.4.6.8.3 1.2-.3.4-.6.4-1.2.3zm21.8 1-.2-.3c0-.6 0-1.1.2-1.7.1-.5 0-1 .2-1.5l.4-2.8c0-.5 0-1 .2-1.4.1-.8 0-1.5.2-2.2 0-.3.3-1 .6-.6.4.6.9 1 1.4 1.5.4.3 0 .7-.3.8-.4.1-.5.6-.5 1l-.2 1.2c0 .7 0 1.3-.2 2l-.1 1.8-.2 1.2c0 .4 0 .9-.4 1.1-.3.2-.8.2-1-.1zm29.7-9.8-1.3 1.2c-.6.5.5.7.6 1.1.2.6.2 1.2.2 1.8.2.6.3 1.1.2 1.7 0 .7-.8.5-1.2.9-.5.2-.7.7-1 1a4.2 4.2 0 0 0-.4 1.6c0 .5-.3 1 0 1.4l.1.2h.5l1.5-.1c1.2-.2 2.5-.2 3.7-.3l2.2-.2c.6.1.9-.5.9-1-.4-.7-.1-1.4-.4-2-.2-.8-.1-1.5-.2-2.2 0-.6-.7-.8-1-.4-.4.4-1 .5-1.2.9-.3.6.6.6.8 1l.1 1.5c.1.6-.5.6-1 .7-.5.2-1.2.3-1.5-.3-.2-.5-.2-1-.2-1.5 0-1-.3-1.8-.3-2.7 0-1-.3-2.1-.3-3.2 0-.5-.1-1.2-.8-1.1m-.6 8.2h.3v.8l-.3.1a3.3 3.3 0 0 1-.4.1 2.5 2.5 0 0 1-.2 0c-.2-.2-.2-.5.1-.8zm-30-9.2c-.3 0-.8.7-1.2.6-.9.1-.8 1-.1 1.3v.8c.1.8-.4 1.5-.3 2.3 0 .8-.3 1.7-.3 2.6-.3.9-.3 1.8-.4 2.7-.1.8-.7.5-1.2.3v-1c.1-.9-.5-1.1-1.2-1.2-.7 0-1-.5-.8-1.1.3-.4 1-.3 1.5-.3 1 .2.9-1.1.4-1.6-.4-.6-1.2-1-1.4-1.6 0-.8-.5-1.7-1.2-2.1-1.1-.1-2 .8-2.3 1.8-.5 0-1 .2-1.4.4-.7.2-1.7 1.4-.7 1.9.5.1 2.2.5 1.4 1.2-.4.8-1.2.8-1.9.6-.7 0-1.5-.4-1.5-1.2-.1-.8-.1-1.6-.4-2.3-.2-.8-1.1-.6-1.2.2-.7.5-.6 1.4-.1 2 .3.7 0 1.6-.3 2.2-.2 1-1.2 1-1.9 1.2-.3.2-1.6 0-1.1.7a4 4 0 0 0 2.4.3c.8 0 1.5-.7 2-1.4.5-.5 1.4-.2 2.2-.2.7 0 1.5.5 2.3.1.2-.5 1.2-1.5 1.5-.5 0 .9.7 1.3 1.5 1.2.9 0 .5.6.5 1.2 0 .9.7 1.4 1.5 1.8h.8c.7-.3 1.5-.6 1.8-1.4.3-.7.3-1.5.5-2.2.2-1.1.4-2.3.4-3.4.3-1 .2-2.1.4-3.2l.3-2.3c0-.5-.2-.5-.5-.4m-6.7 4.1c.1 0 .2.2.2.5 0 .4.2.7.5.8v.3l-.8.2c-.5 0-.9-.2-1.2-.5l-.2-.2.3-.2.5-.5c.3-.3.5-.4.7-.4m66-7.9a8.4 8.4 0 0 0-1.7.3c-1 0-1.5 1-.5 1.6.6 1.5 1.5-.4 2.5-.2 1.4.2 1.5 1.8 1.8 3 0 1.1.4 2.2.7 3.3 1 1.1-.7 1.8-1.4 1-.6-.7-2-1.5-2.7-.6-.9.4-1 1.6-1.7 2-1.2.3-1.3-1.2-2-1.8-.6-.9-1.7-1-2.6-1.2-.4-.9-.2-2.4-1-3-.8.3-2.2 1.7-1 2.4 1 1-.5 1.4-1 2-.8.9-1 2-1 3-1.3.7-1.5-.8-1.7-1.7 0-1.1-1-.8-1.7-.4-1 .4-1.4 1.3-2 2v2c.2.9 1.2.5 1.8.4 1-.4 1.4.7.6 1.3-.6.6-2.2.3-2 1.4h1.6c1-.3 2.2-1.1 2.3-2.3.2-1 1.7-.9 2.5-1.1 1-.3 2.3-.4 2.6 1 .7.7 2.2 1.5 3 .5a2.4 2.4 0 0 0 1.1-2.3c-.1-.8 1.3-.8 1.7-.3.5.8 2.1.6 2.9 0 .8-.5 1-1.6 2.2-1.6l5.4-1.5c1.4-.3-.2-1.2-.6-1.8-1-.5-2 1.7-3.2.6-1-.7-.9-2-1.2-3.1-.3-1.4-.2-3-1.2-4-.6-.7-1.6-.9-2.5-.9m-6.8 9.5c.1 0 .3 0 .5.2.4.2.7.6.7 1 0 .2 0 .2-.3.3l-.5.2c-.2 0-.7-.3-.7-.5v-.4c-.2-.4-.2-.4 0-.6zm6.5.4c.4 0 .6 0 .8.3.1.4 0 .6-.4.8l-.5.2-.4-.3c-.2-.1-.3-.2-.3-.4 0-.3.4-.6.8-.7zm-9 0c.2 0 .3 0 .4.2.2.2.3.3.3.6v.6c0 .3 0 .2-.6.2s-.7 0-.7-.6c0-.4 0-.5.3-.7.1-.2.3-.2.4-.2zm-5.4 1.5a.6.6 0 0 1 .4.4c0 .3 0 .5-.2.6-.3.1-.8.2-1 0a.6.6 0 0 1 0-.1c-.2-.1-.2-.2 0-.3v-.1l.2-.3a.5.5 0 0 1 .6-.2m9.2 1.2.5.1v.6h-1.2l-.1-.2c0-.2 0-.3.2-.4zm-17.1 4.8c-.1 0-.3-.1-.1-.2.1-.3.5-.4.8-.6a3.4 3.4 0 0 0 1.4-1c0-.4.4-.6.4-1l-.1-1.4a1.8 1.8 0 0 0-.8-1c-.3-.1-.7-.2-.8-.6 0-.3.3-.6.4-.9l.6-1.2c.3-.3.7 0 .8.2l.5 1c.3.3.5.6.6 1 .2.4.4.7.4 1l.2 1.3c0 .5 0 1.1-.2 1.6l-.6.8c-.3.3-.6.6-1 .7-.3.1-.5.4-.9.4H468zm-6.9.4c-.2-.2-.3-.3-.3-.6s0-.3.3-.6c.4-.4.6-.4 1.4 0 .7.4 1 .4 1 .1.1-.2.5-.5 1-.5a.8.8 0 0 1 .5.2c.2.2.3.3.3.7 0 .5 0 .5-.3.8-.3.2-.3.2-.7.2a.9.9 0 0 1-.8-.6c0-.2 0-.3-.2-.1l-.2.1c-.2 0-.6.3-.8.5l-.5.1c-.4 0-.4 0-.7-.3m-19.8-8.9c-.7 0-1.4.6-1.5 1.3.2.7.8 1.5.4 2.2.3 1-.8 1.4-1.5.9-.4-1-.6-2-1.3-3-.8-.2-1.1 1.1-1.7 1.6.3.7 1.1 1.4 1.2 2.3.2 1-.4 2-1.1 2.4-.7.7-1.7.5-2.5.6-1 .6.7.8 1.2.8 1 .1 2.1 0 3-.8.7-.3.6-1.7 1.5-1.8l4.8.3c.8.2 2.1-.1 2.7.5 0 1 1 1.8 1.9 2.2.5.2 1-.5 1.5-.6 1-.3.7-1.5 1.3-2h5c.2 0 .3-.5.6-.7l-.2-1.9c-.3-.8 0-1.8-.5-2.5-.9-.2-1.6.5-2.4.6-1 .4-1.7 1.3-1.8 2.3-.5.9-1.4-.2-1-1l-.1-1c-.5-.5-1.4-.3-2.1-.4l-3-.2c-1 0-1.9.1-2.7-.1-1 0-1-1-1-1.8a1 1 0 0 0-.7-.2m2 3.7 1 .1h1.3c1 .2 2 .2 3 .2.2 0 .4.2.6.4v2c0 .3 0 .7-.2.8a.7.7 0 0 1-.2.2 1 1 0 0 1-.7-.5v-1.4a1.3 1.3 0 0 0-.7-.3l-2.6-.1-2-.1c-.3-.1-.7 0-.9-.4-.2-.2.1-.6.4-.7a2.3 2.3 0 0 1 1-.2m11.3.3c.1 0 .2 0 .2.3l.2.5c0 .1 0 .2-.2.2-.5.2-1 .2-1.2 0 0-.1 0-.5.2-.6z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx83("path", {
          strokeWidth: 1.1,
          d: "M450 327.2c32.6-25 29.8-61.8 29.8-61.8l-2.5.2c-6.9 0-23.2-4-27-8.9-4 4.5-20.8 9-27.6 9l-2.5-.3s-2.9 36.7 29.8 61.8z"
        }),
        /* @__PURE__ */ jsx83("path", {
          strokeWidth: 0.9,
          d: "M477.2 268h-.8c-6.2 0-20.6-3.1-26.2-7.9-5.8 4.4-20.5 8-26.6 8a4.7 4.7 0 0 1-.8-.1 73.1 73.1 0 0 0 2.6 18.7 71 71 0 0 0 24.6 37.1 71.2 71.2 0 0 0 24.6-37.2 73.1 73.1 0 0 0 2.6-18.6z"
        }),
        /* @__PURE__ */ jsx83("path", {
          fill: "#c09300",
          stroke: "none",
          d: "M439.4 265a62.2 62.2 0 0 1-16.6 3l.1 4.1a72.8 72.8 0 0 0 2.5 14.5 71 71 0 0 0 14 26.8zm20.6 0v49.2a71.1 71.1 0 0 0 14.6-27.6 73 73 0 0 0 2.5-14.5l.1-4h-.8c-3.8 0-10.4-1.2-16.4-3.2z"
        }),
        /* @__PURE__ */ jsxs76("g", {
          strokeWidth: 1.3,
          children: [
            /* @__PURE__ */ jsx83("path", {
              strokeWidth: 1.2,
              d: "M462.3 253c.7.1-.9-3.5-.9-3.5 1.8 1.8 8.4 2.3 8.4 2.3-4-1.8-8-15.1-7.5-25.8.4-10.6-1.5-14.8-3-16.4-2-2-8.5-3.8-12.7-4-2.5-.1-2 1.8-2 1.8-4.5-1.1-9-1.6-11-.2-1.8 1.2-2.2 7.5-.8 6.4 3.3-2.7 6.2-.2 8.2 2.7 1.8 2.5 1.7 9.7-.9 18.2a60 60 0 0 1-10 17.7c4 0 9.6-3.5 9.6-3.5l-1.3 5.5c4.2-2 7.5-5.1 7.5-5.1l4 4.2c1.3-1.8 4-4.2 4-4.2s3.3 3.5 8.4 4z"
            }),
            /* @__PURE__ */ jsx83("path", {
              fill: "none",
              d: "M446.1 227.6s-2.2 16.4-6.4 21m10-21.5s-1 16.7-3.8 22m6.9-21.3s0 18.2 1 21.3m3-20.4s.8 15.3 4.6 20.8"
            }),
            /* @__PURE__ */ jsx83("path", {
              fill: "#c09300",
              strokeWidth: 0.3,
              d: "M442 219.6a8 8 0 0 0-1-3.3c-2-3-4.9-5.4-8.2-2.7 0 0 1.1-3.5 3.6-3.6 1.8-.1 6.1 1.4 9.9 7.8 0 0-2.8-.6-3.5 0-1.2 1-.7 1.8-.7 1.8z"
            }),
            /* @__PURE__ */ jsx83("path", {
              fill: "#c09300",
              strokeWidth: 0.3,
              d: "M432.4 209.3c.3-1 .7-1.8 1.3-2.1 2-1.4 6.4-1 10.9.2 0 0-.4-1.9 2-1.8 4.2.2 10.6 2 12.6 4a7.9 7.9 0 0 1 1.5 2.4c-1-1.4-3.8-1.3-4.5-1.2-1 .1-1.7 0-3.1.4-.7.2-1.7.4-2.3.8-.4.4-.8 1.6-1.4 1.6-1 0-1-.2-1.3-.5-.3-.5-.5-1.1-.9-1-1 .1-2.8-.7-5-2.5-2.3-1.8-3.2-2.2-6-2-3 .2-3.8 1.9-3.8 1.9z"
            }),
            /* @__PURE__ */ jsx83("circle", {
              cx: 448.8,
              cy: 210.7,
              r: 1.2,
              stroke: "none"
            })
          ]
        })
      ]
    })
  ]
});
var Eg_default = SvgEg;

// src/country-flag-icons/generated/Eh.tsx
import { jsx as jsx84, jsxs as jsxs77 } from "react/jsx-runtime";
var SvgEh = (props) => /* @__PURE__ */ jsxs77("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx84("defs", {
      children: /* @__PURE__ */ jsx84("clipPath", {
        id: "eh_svg__a",
        children: /* @__PURE__ */ jsx84("path", {
          fillOpacity: 0.7,
          d: "M-158.7 0H524v512h-682.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs77("g", {
      fillRule: "evenodd",
      clipPath: "url(#eh_svg__a)",
      transform: "translate(148.8) scale(.94)",
      children: [
        /* @__PURE__ */ jsx84("path", {
          fill: "#000001",
          d: "M-158.3 0h680.9v255.3h-680.9z"
        }),
        /* @__PURE__ */ jsx84("path", {
          fill: "#007a3d",
          d: "M-158.3 255.3h680.9v255.3h-680.9z"
        }),
        /* @__PURE__ */ jsx84("path", {
          fill: "#fff",
          d: "M-158.3 148.9h680.9v212.8h-680.9z"
        }),
        /* @__PURE__ */ jsx84("path", {
          fill: "#c4111b",
          d: "m-158.3 0 340.4 255.3-340.4 255.3Z"
        }),
        /* @__PURE__ */ jsx84("circle", {
          cx: 352.3,
          cy: 255.3,
          r: 68.1,
          fill: "#c4111b"
        }),
        /* @__PURE__ */ jsx84("circle", {
          cx: 377.9,
          cy: 255.3,
          r: 68.1,
          fill: "#fff"
        }),
        /* @__PURE__ */ jsx84("path", {
          fill: "#c4111b",
          d: "m334 296.5 29.1-20.7 28.8 21-10.8-34 29-20.9-35.7-.2-11-34-11.2 33.9-35.7-.2 28.7 21.2-11.1 34z"
        })
      ]
    })
  ]
});
var Eh_default = SvgEh;

// src/country-flag-icons/generated/Er.tsx
import { jsx as jsx85, jsxs as jsxs78 } from "react/jsx-runtime";
var SvgEr = (props) => /* @__PURE__ */ jsx85("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs78("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx85("path", {
        fill: "#be0027",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx85("path", {
        fill: "#b4d7f4",
        d: "m0 480 640-.3V240z"
      }),
      /* @__PURE__ */ jsx85("path", {
        fill: "#239e46",
        d: "m0 0 640 .3V240z"
      }),
      /* @__PURE__ */ jsx85("path", {
        fill: "#f3e295",
        d: "M186.2 360.4c-10.7 3-16.8 11.3-16.7 19.1l52.8-.2c.4-8.4-6.5-16.2-17-19.3 51.6-1 96.4-20.4 104.6-32.8-8-3.5-17.4 2.1-24 .8 15.7-7.3 63-37.9 55.3-70.7-6 18.2-24 33.3-31.8 37.4 17.7-26.8 41.8-54.8 20.9-76.4 1 12.5-8 26.3-12 27.4 10.3-28.4 20-64-2.1-87.4 2.9 8.5 1.7 32.4-2.3 33.5-1.2-19.3-4.5-59.8-24.8-59.3 6.4 5.8 9.2 21.4 9.4 37.2a57.5 57.5 0 0 0-21.1-27 118.3 118.3 0 0 0-41.5-42.2c1.8 12.7 3.3 22.7 21 35.9-9.2-.6-18.4-18.1-28.3-18.6-7.9-.4-14 7.1-26.9 2.8 1.4 4.2 7.4 6.1 8.7 9.2-2.8 2-9.3-.3-14.7-3 7.5 10 19 16 28.8 14 11.7-2.2 24.2-1 36.2 5.8a63 63 0 0 1-22.5.6c6.9 7 11.5 11.7 23.6 11.6 10.7 0 16.4-5.8 19.1-2.2 6.8 8 11.3 16 17 25.4-12.5 1.3-8.7-14.1-22.6-22-7.9 16 9 35.2 20.3 43.2a65 65 0 0 0 7.1 31.5c3.5 6.5 8 13.2 6.3 27.9-6.9-5-13.5-21.8-11-35.1-8.6 2.3-12 17.4-8 25 3 5.7 5 16.8 1.6 21.7-3.4 4.6-3.7 4-3.7 14 .1 5.8-3.2 12.8-8.5 17.7a35.5 35.5 0 0 0 1.1-15.8c-4.2 7.2-14.9 14.6-18.2 22.4-3.3 7.7-4.1 21.2-20 24.3-20.6 4-27.7 7.6-40.8 13-1.5-10 2.9-31 11.3-29.7 8.1 1.4 33-8.6 24-29.5-1.7 6.6-7.5 13-13.9 13.3 6.9-8.8 19-18 13.1-32.8a42.6 42.6 0 0 1-16.3 18c8.4-16 1-21-9-7.6-3.8 5.1-6.1 15.4-8.5 28.5-4-10.6-3.7-24.6-8.4-36-4.8-12.3 6.5-15.5 11.8-14.5 13 3.5 34.9 3.5 33.3-18.1-5.7 7.3-15.5 9.5-26.2 7 12-8.8 21.4-25.3 8-34a31 31 0 0 1-16.9 24.1 50.8 50.8 0 0 1-.3-24.8c-5.2 5.6-9 17-12.1 30.2-.3-13 2.2-22.3 4-29.3 2.8-10.1 9.6-3.5 20-2.8 10.2.6 24-5 21.4-18.7-3.4 5.5-10.5 7.6-17.7 7 8.7-5.3 23.8-14.6 15.5-29-3.5 5.4-4.6 10-14.7 11.7 2.6-6 3-14.7 11-18-14-2.9-22 6.3-26.2 20.7-1.6-10-3.6-13.6-4-21 7.6-8.3 8.4-24.8-8-28.4a35 35 0 0 0 1.2 17.4c-7.7-4.6-18.5-7.1-25.8-.7 5 5.3 12.5 10 24.2 4.2-2.8 9-10 7.5-19.8 4 6 11.3 13.6 13.3 22 12 4.4 11.6 4.6 20.4-8.3 37.2.6-10.4-.1-18.2-8.4-26.7-7.2-7-13 .3-1.8 15.8-6.8-5-14.4-15-16.7-25.1-2.2 12.4-.2 27.1 6.7 35.4-3.3 3.5-7-.4-12.5-9 2 27.4 13.7 32.7 29.4 26.6.4 15 .4 28.9 1.3 47-9.1-13.2-20.7-23-27.1-25.4-2 7.3 5.5 17 9.8 22.3-6.5-1.4-20.5-12-20.5-12-1.4 12.1 14.3 23.4 24.5 28.4-12-.5-17.3-5-25-12.4.2 33.8 36.6 27.9 43.5 22.7l3 52.5c-10.3-1.8-9.5-5-18.3-5.7-24.5-1-43.9-29.4-50.3-50.3-1.9 3.4-.4 7-2.1 11.3-4-10.3-9-23.6-15.9-29.8 1.8 6 2 12.1 1.4 23.3-2.4-7.2-4.5-9.5-4.7-18 .1-6.5 6.3-11.3 6-20.5-.3-6.7-6.4-21.3-7.3-32.5-3 11.6-4.8 23.8-9.4 31 2.3-12.4 1.6-21 5.4-29.3 4.4-8.7 8.1-16.6 5.2-25.4-2.8 3.4-1.9 6.5-9 14.8-1.5-9 9.2-23.5 19.6-29.3 7.3-3.8 16.5-17.6 10.5-27-6.9 5-10 11.6-19.7 23 7-27 25-34.2 46.5-34.3 4.7 0 14.3-1.7 17-8-6 2.3-13.2 2.6-19.6 1.4 4.7-6.9 14.4-6 23.6-6 7.1 0 18.3-1 22.8-11.2a50.8 50.8 0 0 1-31 1.9c13.7-7 35-7.8 46-17.1-12.5-9.3-43.7 2.2-63.4 15.7 5.5-5 14.2-14 19-21.2-10.8-5.2-38 25-47.4 43-9 5-12.5 13-16 18.5 4.7-16.1 5.2-27.8 9.2-41C80 138 92.6 194.6 86 208.2c.8-15 .1-34.1-6-44-9.4 7.2-10.2 49.5-1.4 84.7-3.2-9.4-9.2-18.2-11.1-29.7-14 25.4 8.2 55.5 26.7 79.2-14-7.3-27.7-22.9-36.8-36 2.5 45.6 50 55 57.4 66.2-10-4.7-29.1-13.9-37.3-4.2a99 99 0 0 1 32.3 12.1c12.4 15.4 35.7 22.2 76.4 23.9"
      })
    ]
  })
});
var Er_default = SvgEr;

// src/country-flag-icons/generated/Es.tsx
import { jsx as jsx86, jsxs as jsxs79 } from "react/jsx-runtime";
var SvgEs = (props) => /* @__PURE__ */ jsxs79("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx86("path", {
      fill: "#AA151B",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#F1BF00",
      d: "M0 120h640v240H0z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "m127.3 213.3-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "m127.3 213.3-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M133.8 204.5c0-.4.4-.8.8-.8s1 .4 1 .8c0 .5-.5.9-1 .9s-.8-.4-.8-.9"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.9 203.7c.4.1.6.4.6.8 0 .5-.4.9-.8.9s-1-.4-1-.9c0-.4.3-.7.7-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M126.8 206.8c1-.5 3 1.1 4.6 3.6m11-3.6c-.8-.5-2.8 1.1-4.5 3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m127.8 215.3-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.5.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m127.8 215.3-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.5.8l-.3-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m142.1 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142.1 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1-1.2-.6 1.6 1.6 0 0 1-1 .4 1.6 1.6 0 0 1-1.3-.6 1.6 1.6 0 0 1-2.4.2 1.6 1.6 0 0 1-1.2.6 1.5 1.5 0 0 1-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1-1.2-.6 1.6 1.6 0 0 1-1 .4 1.6 1.6 0 0 1-1.3-.6 1.6 1.6 0 0 1-2.4.2 1.6 1.6 0 0 1-1.2.6 1.5 1.5 0 0 1-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0-7.4-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0-7.4-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      d: "M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "m127.3 215.3.3-.4h.7l-.4.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m127.3 215.3.3-.4h.7l-.4.6-.6-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      d: "M139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "m142 215.4-.3-.5h-.7l.3.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142 215.4-.3-.5h-.7l.3.6.6-.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M134.6 217.1a25 25 0 0 1-6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M134.6 217.1a25 25 0 0 1-6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m142 212-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142 212-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m132 211.2.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m132 211.2.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m127.3 212 .1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m127.3 212 .1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m134.6 208.5-.8.5.6 1.3.2.1.2-.1.7-1.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m134.6 208.5-.8.5.6 1.3.2.1.2-.1.7-1.3-.9-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m132.8 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m132.8 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m136.4 210.5-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m136.4 210.5-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3.3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m129.3 209-.7.7.9 1 .2.1.1-.1.3-1.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m129.3 209-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m128 211.2.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m128 211.2.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m131.5 210.5-.3.6H130l-.2-.2.1-.3 1.2-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m131.5 210.5-.3.6H130l-.2-.2.1-.3 1.2-.6.5.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m140 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m140 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m141.4 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m141.4 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m137.8 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m137.8 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m142.5 211.4.1.6 1.3.2.2-.1v-.2l-1-.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142.5 211.4.1.6 1.3.2.2-.1v-.2l-1-.9-.6.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1-.5.5.5.5 0 0 1-.4-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1-.5.5.5.5 0 0 1-.4-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m124.8 212.2-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m124.8 212.2-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m144.3 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m144.3 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M124 223h21.4v-5.5H124z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M124 223h21.4v-5.5H124z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1-.4 0h-16a1.4 1.4 0 0 1-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1-1 1.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1-.4 0h-16a1.4 1.4 0 0 1-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1-1 1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8 8.3 8.3 0 0 1-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8 8.3 8.3 0 0 1-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M149.6 319.8a8 8 0 0 1-3.7-.9 8.3 8.3 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8.2 8.2 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 319.8a8 8 0 0 1-3.7-.9 8.3 8.3 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8.2 8.2 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8v-2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M149.6 322a7 7 0 0 1-3.7-.8 8.3 8.3 0 0 0-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 322a7 7 0 0 1-3.7-.8 8.3 8.3 0 0 0-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8V322"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M149.6 326.7a8 8 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 326.7a8 8 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8v2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M149.6 329a8.1 8.1 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 329a8.1 8.1 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m126.2 308 .2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1-2.7-2.6v-.5a1.3 1.3 0 0 1-.3 0h-16a1.4 1.4 0 0 1-.5 0"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "m126.2 308 .2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1-2.7-2.6v-.5a1.3 1.3 0 0 1-.3 0h-16a1.4 1.4 0 0 1-.5 0z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M123.7 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M123.7 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0-.1-8.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0-.1-8.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M126.8 305.6h15.6V229h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M138 229.2v76.3m1.7-76.3v76.3m-12.9 0h15.6v-76.4h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M158.4 257.7a49.6 49.6 0 0 0-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M158.4 257.7a49.6 49.6 0 0 0-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3v7.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M125.8 254c1.9-.6 3.1-1.5 2.5-3-.4-1-1.4-1-2.8-.6l-2.6 1 2.3 5.8.8-.3.8-.3zm-1.2-2.7.7-.3c.5-.2 1.2.1 1.4.8.2.5.2 1-.5 1.5a4.4 4.4 0 0 1-.6.3zm7.3-2.5-.9.3h-.8l1.3 6.1 4.3-.8-.2-.4v-.4l-2.5.6zm8.4 5.2c.8-2.2 1.7-4.3 2.7-6.4a5.3 5.3 0 0 1-1 0 54.8 54.8 0 0 1-1.8 4.6l-2.4-4.3-1 .1h-1a131.4 131.4 0 0 1 3.5 6zm8.8-4.7.4-.9a3.4 3.4 0 0 0-1.7-.6c-1.7-.1-2.7.6-2.8 1.7-.2 2.1 3.2 2 3 3.4 0 .6-.7.9-1.4.8-.8 0-1.4-.5-1.4-1.2h-.3a7.3 7.3 0 0 1-.4 1.1 4 4 0 0 0 1.8.6c1.7.2 3-.5 3.2-1.7.2-2-3.3-2.1-3.1-3.4 0-.5.4-.8 1.3-.7.7 0 1 .4 1.2.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M271 215.3a4.5 4.5 0 0 0-.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.6.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M271 215.3a4.5 4.5 0 0 0-.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.6.8l-.2-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4zm-.2-1.4a.4.4 0 0 1 .4-.4c.2 0 .4.1.4.4s-.2.4-.4.4a.4.4 0 0 1-.4-.4zm-1.1-1c0-.2.2-.3.4-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.4-.5zm-1.4-.4c0-.2.2-.4.4-.4.3 0 .5.2.5.4s-.2.4-.4.4-.5-.2-.5-.4zm-1.4 0c0-.2.2-.3.5-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.3,
      d: "m287.8 211.2.2-1a2.7 2.7 0 0 0-2.7-2.8c-.5 0-1 .1-1.3.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m283 209.2.2-.8c0-1.1-1.1-2-2.5-2-.6 0-1.2.2-1.6.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M288.2 210c0-.3.2-.5.4-.5s.4.2.4.4c0 .3-.2.4-.4.4s-.4-.1-.4-.4zm-.2-1.6c0-.2.2-.4.4-.4a.4.4 0 0 1 .5.4c0 .2-.2.4-.4.4-.3 0-.5-.2-.5-.4zm-1-1.1a.4.4 0 0 1 .5-.4c.2 0 .4.1.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.5-.4zm-1.3-.7c0-.2.2-.4.5-.4s.4.2.4.4c0 .3-.2.5-.4.5a.4.4 0 0 1-.5-.5zm-1.4.1c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m285.3 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m285.3 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4zm.2-1.4c0-.3.2-.4.4-.4s.5.1.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4zm1-1c0-.2.3-.3.5-.3s.5.1.5.4c0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.5zm1.4-.4c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4zm1.4 0c0-.2.2-.3.5-.3.2 0 .4.1.4.4 0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.3,
      d: "M267.8 211.2a2.8 2.8 0 0 1-.2-1 2.7 2.7 0 0 1 2.7-2.8c.5 0 1 .1 1.4.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M272.7 209.2a1.7 1.7 0 0 1-.3-.8c0-1 1.2-2 2.6-2a3 3 0 0 1 1.5.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M266.6 210c0-.3.2-.5.4-.5.3 0 .4.2.4.4a.4.4 0 0 1-.4.4c-.2 0-.4-.1-.4-.4zm.1-1.6c0-.2.3-.4.5-.4s.4.2.4.4-.2.4-.4.4-.4-.2-.4-.4zm1-1.1c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4.4.4 0 0 1-.5-.4zm1.3-.7c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.4.4 0 0 1-.5-.5zm1.4.1c0-.2.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 0 1-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 0 1-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0-7.4-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0-7.4-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      d: "M273.2 214.9h-.6a.3.3 0 0 1-.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M273.2 214.9h-.6a.3.3 0 0 1-.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "m270.5 215.3.3-.4h.7l-.4.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m270.5 215.3.3-.4h.7l-.4.6-.6-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      d: "M282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "m285.1 215.4-.2-.5h-.7l.3.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m285.1 215.4-.2-.5h-.7l.3.6.6-.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M277.8 217.1a25 25 0 0 1-6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M277.8 217.1a25 25 0 0 1-6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m285.2 212-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m285.2 212-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m270.5 212 .1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m270.5 212 .1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m277.8 208.5-.8.5.6 1.3.2.1.3-.1.6-1.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m277.8 208.5-.8.5.6 1.3.2.1.3-.1.6-1.3-.9-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m276 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m276 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m279.6 210.5-.3.5-1.3-.4-.1-.2v-.2l1.4-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m279.6 210.5-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m272.5 209-.7.7.9 1 .2.1.2-.1.2-1.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m272.5 209-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m271.1 211.2.5.5 1.2-.6v-.2l-.1-.2-1.3-.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m271.1 211.2.5.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m274.7 210.5-.3.6h-1.3l-.2-.2.1-.3 1.2-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m274.7 210.5-.3.6h-1.3l-.2-.2.1-.3 1.2-.6.5.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m283.2 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m283.2 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m284.6 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m284.6 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m281 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m281 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9-.6.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1-.5-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1-.5-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M277 205.4c0-.5.4-.8.8-.8s1 .3 1 .8-.5.8-1 .8a.9.9 0 0 1-.8-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M279 205.1v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M278.1 204.6c.4 0 .6.4.6.8 0 .5-.4.8-.9.8a.9.9 0 0 1-.8-.8c0-.4.2-.7.6-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m268 212.2-.6-.7a2.3 2.3 0 0 0-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m268 212.2-.6-.7a2.3 2.3 0 0 0-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m287.5 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m287.5 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M267.2 223h21.4v-5.5h-21.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M267.2 223h21.4v-5.5h-21.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M286.3 226.8a1 1 0 0 0-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M286.3 226.8a1 1 0 0 0-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v-2.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v-2.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.1 8.1 0 0 0-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0-3.7.7 8.1 8.1 0 0 1-3.8.9v-2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.1 8.1 0 0 0-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0-3.7.7 8.1 8.1 0 0 1-3.8.9v-2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8V322"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8V322"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.8 8.2 8.2 0 0 0-3.7-.8 8.4 8.4 0 0 0-3.6.7 8.2 8.2 0 0 1-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.8 8.2 8.2 0 0 0-3.7-.8 8.4 8.4 0 0 0-3.6.7 8.2 8.2 0 0 1-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m286.3 308-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "m286.3 308-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M266.9 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M266.9 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M270.1 305.6h15.6V229h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M281.4 229.1v76.3m1.8-76.3v76.3m-13 .2h15.5V229h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0-9.2-.7c-6.7 0-12.4.8-15.9 2.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0-9.2-.7c-6.7 0-12.4.8-15.9 2.1v9.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3v7.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M270 261.5a13 13 0 0 0-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M270 261.5a13 13 0 0 0-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M263.9 254.4c.6-2.3 1.4-4.4 2.1-6.6h-.5a5.2 5.2 0 0 1-.5.1 52.8 52.8 0 0 1-1.4 4.8c-1-1.4-2-2.7-2.7-4.1l-1 .2h-1a131.3 131.3 0 0 1 4 5.7h.5zm6-6.6h-1a8 8 0 0 1-.8 0v6.2h4.2v-.7h-2.6zm6.8 1 2 .3v-.7l-5.8-.5v.8a19.3 19.3 0 0 1 2 0l-.4 5.6h1.6l.5-5.4m2.4 6c.3 0 .5 0 .8.2l.8.2.7-2.9.6 1.2.8 2.1 1 .2c.4 0 .7.2 1 .3l-.3-.7c-.4-1-1-1.9-1.3-2.9 1 0 1.9-.3 2.1-1.2.1-.6 0-1-.7-1.5-.4-.3-1.2-.4-1.7-.5l-2.4-.5zm3-5.2c.7.2 1.5.3 1.5 1v.5c-.3.9-1 1.2-2 .9zm8 7-.2 2 .8.5.9.5.5-7a3.4 3.4 0 0 1-.7-.3l-6.1 3.8.5.3.4.2 1.7-1.2 2.3 1.3zm-1.7-1.5 2-1.4-.2 2.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1-2.1-2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M205.7 175.4c6.3 0 12 1 15.7 2.4a31.7 31.7 0 0 0 14.6 2.3c2.7 0 6.5.8 10.3 2.4a27.3 27.3 0 0 1 7.4 4.7l-1.5 1.4-.4 3.8-4.1 4.7-2 1.8-5 3.9-2.5.2-.7 2.1-31.6-3.7-31.7 3.7-.8-2.1-2.5-.2-4.9-4-2-1.7-4.1-4.7-.5-3.8-1.5-1.4a27.6 27.6 0 0 1 7.5-4.7 26 26 0 0 1 10.2-2.4c2 .2 4.2.1 6.6-.2a30 30 0 0 0 8-2c3.7-1.5 9-2.5 15.5-2.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.2 217.1c-11.8 0-22.4-1.4-29.9-3.6a1.1 1.1 0 0 1-.8-1.2c0-.5.3-1 .8-1.2a109 109 0 0 1 29.9-3.6c11.7 0 22.3 1.4 29.8 3.6a1.3 1.3 0 0 1 0 2.4c-7.5 2.2-18 3.6-29.8 3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M206.9 215.7v-6.3m-1.7 6.3v-6.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M203.6 215.7v-6.3m-1.6 6.3v-6.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M200.6 215.7v-6.3m-2.8 5.9v-5.7m1.3 5.8v-6m-3.8 5.6v-5.2m1.3 5.4v-5.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M192 214.8V210m1 4.7V210m1.2 5v-5m-3.4 4.7v-4.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M189.7 214.5v-4.2m-1.2 4.1v-4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.6,
      d: "M186 214v-3m1.3 3.2v-3.5m-2.5 3.1V211"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M183.7 213.6v-2.3m-1.3 2v-1.8m-1.2 1.6v-1.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.9,
      d: "M179.8 212.8v-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M213.7 215.3v-5.8m-2.9 6v-6.1m-2.1 6.2v-6.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206 207.4a108 108 0 0 0-30 3.9c.6-.3.5-1-.3-3-1-2.5-2.4-2.4-2.4-2.4 8.3-2.5 20-4 32.8-4a123 123 0 0 1 33 4s-1.5-.1-2.5 2.3c-.8 2-.8 2.8-.2 3-7.5-2.2-18.4-3.7-30.3-3.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.1 201.9c-12.9 0-24.5 1.5-32.8 4a1 1 0 0 1-1.3-.6 1 1 0 0 1 .7-1.3 121 121 0 0 1 33.4-4.2c13.2 0 25.2 1.7 33.5 4.2.6.2.9.8.7 1.3-.2.5-.8.8-1.3.6-8.4-2.5-20-4-32.9-4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M197 204.8c0-.5.4-1 1-1 .5 0 1 .5 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.1 205.6H203a1 1 0 0 1 0-2h6.4c.5 0 1 .5 1 1s-.5 1-1 1h-3.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m190.3 206.5-2.3.2c-.6.1-1-.3-1.2-.8a1 1 0 0 1 1-1.1l2.2-.3 2.4-.3c.5 0 1 .3 1.1.9.1.5-.3 1-.9 1l-2.3.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M181 206.7c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m174 208.5 1.2-1.6 3.3.4-2.6 2-1.8-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m222 206.5 2.3.2c.5.1 1-.3 1.1-.8a1 1 0 0 0-.9-1.1l-2.2-.3-2.4-.3a1 1 0 0 0-1.1.9c-.1.5.3 1 .9 1l2.3.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M213.3 204.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1m15.8 1.9c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m238.2 208.5-1.1-1.6-3.3.4 2.6 2 1.8-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M177.3 212.8c7.4-2.1 17.6-3.4 28.8-3.4 11.3 0 21.4 1.3 28.9 3.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m182.3 183.8 1.4 1 2-3.2a7.4 7.4 0 0 1-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m182.3 183.8 1.4 1 2-3.2a7.4 7.4 0 0 1-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6l-1 1.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M182.4 183.8a9.3 9.3 0 0 1-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0-3.4 6.8 8.9 8.9 0 0 0 3 6.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.4 183.8a9.3 9.3 0 0 1-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0-3.4 6.8 8.9 8.9 0 0 0 3 6.7l-.9 1.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M160.1 187.1a8.8 8.8 0 0 1-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0-.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M160.1 187.1a8.8 8.8 0 0 1-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0-.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M162.7 173.3a10.5 10.5 0 0 0-4 4.1 8.6 8.6 0 0 0-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1-2.3-6.5c0-4 2.5-7.5 6.4-9.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M162.7 173.3a10.5 10.5 0 0 0-4 4.1 8.6 8.6 0 0 0-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1-2.3-6.5c0-4 2.5-7.5 6.4-9.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m229.7 183.8-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0-8.5 2.4 23 23 0 0 0-.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1-3 7.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m229.7 183.8-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0-8.5 2.4 23 23 0 0 0-.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1-3 7.6l1 1.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1-3.2 6.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1-3.2 6.7l1 1.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0-6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1-2.6 5.6l2.5 4.1 1.3-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0-6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1-2.6 5.6l2.5 4.1 1.3-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1-2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1-2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M204.2 178c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7m.4-3.7c0-.7.6-1.3 1.4-1.3.8 0 1.5.6 1.5 1.3 0 .8-.7 1.4-1.5 1.4s-1.4-.6-1.4-1.4m.4-3.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1m.2-2.8c0-.5.4-.8.8-.8.5 0 .9.3.9.8 0 .4-.4.8-.9.8a.8.8 0 0 1-.8-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m206.2 191.8 1.2.2a4.6 4.6 0 0 0 4.5 6 4.7 4.7 0 0 0 4.4-3c.1 0 .5-1.7.7-1.7.2 0 .1 1.8.2 1.7.3 2.3 2.4 3.8 4.7 3.8a4.6 4.6 0 0 0 4.7-5l1.5-1.5.7 2a4 4 0 0 0-.4 1.9 4.4 4.4 0 0 0 4.5 4.2c1.6 0 3-.7 3.8-1.9l.9-1.2v1.5c0 1.5.6 2.8 2 3 0 0 1.7.1 4-1.6 2.1-1.7 3.3-3.1 3.3-3.1l.2 1.7s-1.8 2.8-3.8 4c-1 .6-2.7 1.3-4 1-1.4-.2-2.4-1.3-3-2.6a6.7 6.7 0 0 1-3.3 1 6.5 6.5 0 0 1-6.1-3.7 7 7 0 0 1-10.4-.3 7 7 0 0 1-4.6 1.8 6.9 6.9 0 0 1-5.7-3 6.9 6.9 0 0 1-5.7 3 7 7 0 0 1-4.7-1.8 7 7 0 0 1-10.4.3 6.5 6.5 0 0 1-6 3.7 6.7 6.7 0 0 1-3.4-1c-.6 1.3-1.5 2.4-3 2.7-1.2.2-2.9-.5-4-1.1-2-1.2-3.8-4-3.8-4l.2-1.7s1.2 1.4 3.4 3.1c2.2 1.8 3.9 1.6 3.9 1.6 1.4-.2 2-1.5 2-3v-1.5l1 1.2a4.6 4.6 0 0 0 3.7 2c2.5 0 4.5-2 4.5-4.3a4 4 0 0 0-.4-2l.8-1.9 1.5 1.5a4.4 4.4 0 0 0 0 .6c0 2.4 2 4.4 4.6 4.4 2.4 0 4.4-1.5 4.7-3.8 0 0 0-1.6.2-1.7.2 0 .6 1.7.7 1.6a4.7 4.7 0 0 0 4.5 3.1 4.6 4.6 0 0 0 4.5-6l1.2-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M238.6 197.7c.3-.8 0-1.6-.6-1.8-.5-.2-1.2.3-1.5 1.1-.3.8 0 1.6.6 1.8.5.2 1.2-.3 1.5-1.1m-20.5-4c0-.8-.3-1.6-1-1.6-.5-.1-1 .5-1.2 1.4-.1.8.3 1.5.9 1.6.6 0 1.2-.6 1.3-1.4m-23.9 0c0-.8.4-1.6 1-1.6.6-.1 1.1.5 1.2 1.4.1.8-.3 1.5-.9 1.6-.6 0-1.1-.6-1.2-1.4m-20.6 4c-.2-.8 0-1.6.6-1.8.6-.2 1.2.3 1.5 1.1.3.8 0 1.6-.5 1.8-.6.2-1.3-.3-1.6-1.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.7 184a5.1 5.1 0 0 1 2.2 2.9s0-.3.6-.6 1-.3 1-.3l-.1 1.3-.3 2.2a7.4 7.4 0 0 1-.7 1.6 1.9 1.9 0 0 0-1.5-.4 1.8 1.8 0 0 0-1.2.9s-.7-.6-1.2-1.3l-1.1-2-.7-1.1s.5-.2 1.1 0c.6 0 .8.2.8.2a4.9 4.9 0 0 1 1-3.4m.4 9.8a1.8 1.8 0 0 1-.6-1c0-.5 0-.9.3-1.2 0 0-.9-.5-1.8-.7-.7-.2-2-.2-2.3-.2h-1l.2.5c.2.5.5.7.5.7a5 5 0 0 0-3 2 5.3 5.3 0 0 0 3.5 1l-.2.8v.6l1-.4c.3-.1 1.5-.5 2-1 .8-.4 1.5-1.1 1.5-1.1m2.7-.5a1.6 1.6 0 0 0 .2-1.1 1.7 1.7 0 0 0-.6-1l1.4-1.3a10 10 0 0 1 2-.9l1.1-.4v.6a5.7 5.7 0 0 1-.2.8 5 5 0 0 1 3.4 1 5 5 0 0 1-2.9 2 6.4 6.4 0 0 0 .7 1.2h-1c-.4 0-1.6 0-2.3-.2a11 11 0 0 1-1.8-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1-2.1-2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.1 180.8a5.7 5.7 0 0 1 1.9 3.7s.2-.3.9-.5c.7-.3 1.2-.2 1.2-.2l-.5 1.4-.8 2.4a8.2 8.2 0 0 1-1 1.7 2.1 2.1 0 0 0-1.7-.7c-.6 0-1.2.3-1.6.7 0 0-.6-.7-1-1.7l-.8-2.4-.5-1.4 1.2.2c.7.2.9.5.9.5 0-1.4.8-2.8 1.8-3.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M204.6 191.8a2 2 0 0 1-.5-1.2c0-.5.1-1 .4-1.3 0 0-.8-.7-1.8-1-.7-.4-2-.7-2.5-.7l-1.2-.2.2.6.4.9a5.9 5.9 0 0 0-3.7 1.7c1 .9 2.3 1.6 3.7 1.6l-.4 1-.2.6 1.2-.2c.4-.1 1.8-.4 2.5-.7 1-.4 1.9-1 1.9-1m3 0a1.9 1.9 0 0 0 .1-2.6s.9-.7 1.8-1a8 8 0 0 1 2.5-.7l1.2-.3-.1.7-.4.9c1.4 0 2.7.8 3.6 1.7a5.9 5.9 0 0 1-3.6 1.6 6.9 6.9 0 0 0 .5 1.6l-1.2-.2-2.5-.7c-1-.4-1.8-1-1.8-1m22-8a5.2 5.2 0 0 0-2.2 3l-.7-.6c-.6-.3-1-.3-1-.3l.2 1.3c0 .3 0 1.3.3 2.2.2 1 .6 1.6.6 1.6a2 2 0 0 1 1.5-.4c.6.1 1 .5 1.3.9l1.1-1.3c.6-.8 1-1.7 1.1-2l.7-1.1s-.4-.2-1 0c-.7 0-1 .2-1 .2a4.9 4.9 0 0 0-1-3.4m-.3 9.8c.3-.3.5-.6.6-1a1.6 1.6 0 0 0-.2-1.2s.8-.5 1.7-.7c.7-.2 2-.2 2.3-.2h1.1l-.3.5a6.2 6.2 0 0 1-.4.7 5 5 0 0 1 2.9 2 5.3 5.3 0 0 1-3.5 1l.2.8v.6l-1-.4c-.3-.1-1.4-.5-2-1-.8-.4-1.4-1.1-1.4-1.1m-2.8-.5a1.7 1.7 0 0 1-.2-1.1c0-.5.3-.8.6-1 0 0-.6-.8-1.4-1.3-.6-.4-1.7-.8-2-.9a171.4 171.4 0 0 1-1-.4v.6c0 .5.2.8.2.8a5.2 5.2 0 0 0-3.5 1c.7.9 1.7 1.7 3 2 0 0-.3.2-.5.7l-.3.5h1c.4 0 1.7 0 2.3-.2a11.1 11.1 0 0 0 1.8-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M226 192.4c0-1 1-2 2-2s2.1 1 2.1 2a2 2 0 0 1-2 2 2 2 0 0 1-2.1-2m23.2 4.4c-.4-.5-1.4-.4-2.2.2-.8.7-1 1.6-.5 2.2.5.5 1.5.4 2.3-.3.7-.6 1-1.6.5-2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m246.3 198 .7-1c.7-.6 1.8-.7 2.3-.2l.1.2s1-2 2.3-2.6c1.3-.7 3.4-.5 3.4-.5a2.8 2.8 0 0 0-2.9-2.8 3 3 0 0 0-2.4 1l-.2-1s-1.3.3-1.9 1.8c-.6 1.5 0 3.6 0 3.6s-.3-.9-.7-1.5a8 8 0 0 0-2.4-1.6l-1.3-.7-.1.5a5 5 0 0 0 0 .8 7.9 7.9 0 0 0-3.7.5 4.7 4.7 0 0 0 2.5 2.2l-.8.7a4 4 0 0 0-.4.5l1.3.2 2.5.2a14.5 14.5 0 0 0 1.7-.2m-80.3 0c0-.4-.3-.7-.7-1-.7-.7-1.7-.8-2.2-.3l-.2.3s-1-2-2.3-2.7c-1.2-.7-3.3-.5-3.3-.5a2.8 2.8 0 0 1 2.8-2.8c1 0 1.9.4 2.4 1l.2-1s1.3.3 2 1.8c.5 1.5-.1 3.6-.1 3.6s.3-.9.8-1.5a8 8 0 0 1 2.4-1.6l1.3-.7v1.3a7.9 7.9 0 0 1 3.7.5 4.7 4.7 0 0 1-2.5 2.2l.8.7.4.5-1.2.2-2.6.2a14.7 14.7 0 0 1-1.7-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M163 196.8c.6-.5 1.6-.4 2.4.3.7.6 1 1.5.4 2-.5.6-1.5.5-2.2-.2-.8-.6-1-1.6-.5-2m41-6.3c0-1.1.9-2 2-2s2.1.9 2.1 2c0 1-1 2-2 2a2 2 0 0 1-2.1-2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M201.8 160.6c0-2.2 1.9-4 4.3-4s4.2 1.8 4.2 4-1.9 4-4.3 4a4.1 4.1 0 0 1-4.2-4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M205 149.3v2.2h-2.4v2.2h2.3v6.3H202l-.2.6c0 .6.1 1.1.3 1.6h7.9c.2-.5.3-1 .3-1.6l-.2-.6h-2.8v-6.3h2.3v-2.2h-2.3v-2.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M206.5 330.6a82 82 0 0 1-35.5-8.2 22.7 22.7 0 0 1-12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1-12.8 20.4 81 81 0 0 1-35.3 8.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.5 330.6a82 82 0 0 1-35.5-8.2 22.7 22.7 0 0 1-12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1-12.8 20.4 81 81 0 0 1-35.3 8.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ccc",
      d: "M206.3 270h48.3v-53.5h-48.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.3 270h48.3v-53.5h-48.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M168.6 320.9c1.5.8 3.6 2 5.8 2.6l-.1-54.7h-5.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M158 301.6a24.4 24.4 0 0 0 5.5 15v-47.5h-5.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c7b500",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M179.4 324.7a26.6 26.6 0 0 0 5.6 0v-55.9h-5.6v56z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M190 323.5a19 19 0 0 0 5.8-2.5v-52.2H190z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M158.1 270h48.2v-53.5H158z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M158.1 270h48.2v-53.5H158z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M201 316c2.4-2 4.6-6.8 5.4-12.2l.1-35H201l.1 47.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m215.1 294.1.1.5c0 .6-.5 1-1.1 1a1 1 0 0 1-1.1-1v-.5h-1.5a2.5 2.5 0 0 0 1.8 2.9v3.9h1.6V297a2.6 2.6 0 0 0 1.7-1.6h4.4v-1.2zm21.8 0v1.2h-4a2.5 2.5 0 0 1-.3.6l4.6 5.2-1.2 1-4.6-5.3-.2.1v8.7h-1.6V297h-.2l-4.8 5.2-1.2-1 4.7-5.3a2.1 2.1 0 0 1-.2-.4h-4V294h13zm2.6 0v1.2h4.4c.3.8.9 1.4 1.7 1.6v3.9h1.6V297a2.5 2.5 0 0 0 1.8-2.4 2 2 0 0 0 0-.5h-1.6l.1.5c0 .6-.5 1-1 1-.7 0-1.2-.4-1.2-1a1 1 0 0 1 .1-.5zm-6.7 22.1a15.6 15.6 0 0 0 3.7-1l.8 1.4a17.6 17.6 0 0 1-4.3 1.2 2.6 2.6 0 0 1-2.6 2 2.6 2.6 0 0 1-2.5-2 17.5 17.5 0 0 1-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-11-2.2-.8 1.4a16.6 16.6 0 0 1-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1-.3-3.5l.1-.1a15.3 15.3 0 0 1-1.3-4.8h1.7a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.5.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6m-6-4.8c.3-.4 1-.5 1.5 0s.5 1 .1 1.4a1.2 1.2 0 0 1-1.6.1 1 1 0 0 1 0-1.5m-2.2-4.5-1.6-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.2 2.7m1.4-5.3 1.7.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6a14 14 0 0 1-.3-2.7zm5.6 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1-4-2zm-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1-4-2zm2.2-9.4 1.6.7 3-3.3-1-1.4zm-1.3-1-1-1.4 3-3.3 1.6.7zm18.1 9.9.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.5-.5a2.4 2.4 0 0 0 .3-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1-1 4 3 3 0 0 0-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1-3.1 2.6m6-4.8a1.2 1.2 0 0 0-1.5 0 1 1 0 0 0-.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5m2.2-4.5 1.6-.3.3-4.3-1.7-.6v2.5c0 1 0 1.9-.2 2.8zm-1.4-5.3-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7zm-5.6 13.7a15.7 15.7 0 0 1-4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2zm.8 1.4a17.4 17.4 0 0 1-4.8 2.6l1.2 1.1a18.6 18.6 0 0 0 4-2zm-2.2-9.4-1.6.7-2.9-3.3 1-1.4zm1.3-1 1-1.4-3-3.3-1.6.7zm-20.1-8.7.5 1.6h4.5l.5-1.6zm21.1 0-.5 1.6h-4.5l-.5-1.6zm-11.6 21.9c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1m1.9-7.8 1.7-.4v-4.3l-1.7-.5zm-1.6 0-1.7-.4v-4.3l1.7-.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M211.5 294.2c.2-1 1-1.6 1.8-2V287h1.6v5.3c.8.3 1.5.9 1.7 1.6h4.4v.3h-6a1.2 1.2 0 0 0-1-.6c-.4 0-.7.3-1 .6zm12.2 0v-.3h4.1a2.4 2.4 0 0 1 .2-.3l-5-5.7 1.2-1 5 5.6.2-.1V285h1.6v7.3h.3l4.9-5.5 1.2 1-4.9 5.5.3.6h4v.3zm21.6 0a1.1 1.1 0 0 1 1-.6c.5 0 .8.3 1 .6h1.6c-.2-1-.9-1.6-1.8-2V287h-1.6v5.3c-.8.3-1.4.8-1.7 1.6h-4.4v.3zm-30.2-15 6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 0 0-2.5-1.7 2.6 2.6 0 0 0-2.7 2.5 2.5 2.5 0 0 0 1.8 2.4v5.2h1.6v-5.2zm32 0v5.3h-1.7v-5.2a2.5 2.5 0 0 1-.4-.2l-6 6.8-1.3-1 6.2-6.9-.1-.3h-4.5V276h4.5a2.6 2.6 0 0 1 2.4-1.7 2.6 2.6 0 0 1 2.7 2.5 2.5 2.5 0 0 1-1.9 2.4zm-16.1 0v3.3h-1.7v-3.2a2.6 2.6 0 0 1-1.7-1.6h-4V276h4a2.6 2.6 0 0 1 2.5-1.7c1.2 0 2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1-1.6 1.6m-17.8 4-1.7.4v4.3l1.7.5zm1.6 0 1.7.4v4.3l-1.7.5zm30.6 0-1.7.4v4.3l1.7.5zm1.6 0 1.7.4v4.3l-1.7.5zm-25.5.8 1.6-.7 2.9 3.3-1 1.4zm-1.3 1-1 1.4 3 3.3 1.6-.7zm18.5-1.1-1.6-.7-3 3.3 1 1.4zm1.2 1 1 1.4-3 3.3-1.5-.7zm-20.3 9 .5-1.6h4.5l.5 1.6zm-6.7-17c0-.6.5-1 1.2-1a1 1 0 0 1 1 1c0 .6-.4 1-1 1a1.1 1.1 0 0 1-1.2-1m12.1.8-.5 1.6H220l-.5-1.6zm0-1.6-.5-1.6H220l-.5 1.6zm15.7 17.8-.5-1.6h-4.5l-.5 1.6zm4.4-17c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1m-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1.1 1a1.1 1.1 0 0 1-1.1-1m6.2.8.5 1.6h4.6l.5-1.6zm0-1.6.5-1.6h4.6l.5 1.6zm-5.9 5-1.7.5v4.3l1.7.5V281m1.7 0 1.6.5v4.3l-1.6.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: 0.3,
      d: "M232.7 316.3a15.6 15.6 0 0 0 3.7-1.1l.8 1.4a17.6 17.6 0 0 1-4.3 1.2 2.6 2.6 0 0 1-2.6 2 2.6 2.6 0 0 1-2.5-2 17.5 17.5 0 0 1-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-4.7-20.4a2.3 2.3 0 0 1-.2-.5h-4V294h4a2.6 2.6 0 0 1 .2-.4l-5-5.6 1.2-1 5 5.5a2.2 2.2 0 0 1 .2 0V285h1.7v7.3h.2l4.9-5.5 1.2 1-4.9 5.5.3.6h4v1.5h-4c0 .2-.2.4-.3.5l4.7 5.3-1.3 1-4.6-5.3-.2.1v8.7h-1.6V297l-.2-.1-4.8 5.3-1.2-1 4.7-5.3m-12.8-16.7 6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 0 0-2.5-1.7 2.6 2.6 0 0 0-2.6 2.5 2.5 2.5 0 0 0 1.7 2.4v5.2h1.6v-5.2zm6.5 34.8-.8 1.4a16.6 16.6 0 0 1-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1-.3-3.5l.1-.1a15.3 15.3 0 0 1-1.2-4.8h1.6a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.6.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6zm-8.4-13.1V297a2.5 2.5 0 0 1-1.8-2.4c0-1 .8-2 1.8-2.4V287h1.6v5.3c.8.2 1.5.8 1.7 1.6h4.4v1.5h-4.4a2.6 2.6 0 0 1-1.6 1.6v3.9h-1.7m2.3 8.3c.4-.4 1.1-.5 1.6 0s.5 1 .1 1.4a1.2 1.2 0 0 1-1.6.1 1 1 0 0 1 0-1.5zm-2-4.5-1.7-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.3 2.7zm1.4-5.3 1.6.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6-.3-2.7v-2.6zm5.5 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1-4-2l-1.2 1m-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1-4-2l.4-1.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: 0.3,
      d: "m221.9 305.1 1.6.7 3-3.3-1-1.4-3.6 4m-1.3-1-1-1.4 3-3.3 1.6.7-3.6 4m-7.6-9.5c0-.6.5-1 1-1 .7 0 1.2.5 1.2 1 0 .6-.5 1.1-1.1 1.1a1 1 0 0 1-1.1-1zm25.7 19.4.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.6-.5a2.4 2.4 0 0 0 .2-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1-1 4 3 3 0 0 0-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1-3 2.6zm8.4-13.1V297a2.5 2.5 0 0 0 1.8-2.4c0-1-.7-2-1.8-2.4V287h-1.6v5.3c-.8.2-1.4.8-1.7 1.6h-4.4v1.5h4.4c.3.8.9 1.3 1.7 1.6v3.9zm-2.3 8.3a1.2 1.2 0 0 0-1.6 0 1 1 0 0 0-.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5zm2-4.5 1.7-.3.3-4.3-1.7-.6v2.5c0 1 0 1.8-.2 2.7zm-1.3-5.3-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7v-2.6m1.6-20.1v5.2h-1.6v-5.2a2.3 2.3 0 0 1-.4-.2l-6 6.8-1.2-1 6-7v-.2h-4.5V276h4.4a2.6 2.6 0 0 1 2.5-1.7 2.6 2.6 0 0 1 2.6 2.5 2.5 2.5 0 0 1-1.8 2.4zm-16 0v3.2h-1.7v-3.2a2.6 2.6 0 0 1-1.7-1.6h-4V276h4c.4-1 1.3-1.7 2.5-1.7s2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1-1.6 1.6zm8.8 33.8a15.7 15.7 0 0 1-4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2l1.2 1m.8 1.4a17.4 17.4 0 0 1-4.8 2.6l1.2 1.1a18.7 18.7 0 0 0 4-2l-.4-1.7m-27.4-31.4-1.7.5v4.3l1.7.5v-5.2m1.7 0 1.6.4v4.3l-1.6.5V283m30.5 0-1.7.5v4.3l1.7.5V283"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: 0.3,
      d: "m247.1 283.1 1.7.5v4.3l-1.7.5V283m-8.6 22-1.6.7-2.9-3.3 1-1.4 3.5 4m1.3-1 1-1.4-3-3.3-1.6.7 3.6 4m-18.2-20 1.6-.7 3 3.3-1 1.4-3.6-4m-1.3 1-1 1.4 3 3.3 1.6-.7-3.6-4m18.5-1.1-1.6-.7-3 3.3 1 1.4 3.6-4m1.2 1 1 1.4-3 3.2-1.5-.6 3.5-4m-20.3 9 .5-1.6h4.5l.5 1.6h-5.5m0 1.5.5 1.6h4.5l.5-1.6h-5.5M213 277c0-.6.5-1 1.2-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1.2-1zm12.1.8-.5 1.6h-4.5l-.5-1.6h5.5m0-1.6-.5-1.6h-4.5l-.5 1.6h5.5m20.1 18.5c0-.5.5-1 1.1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1.1-1 1.1a1 1 0 0 1-1.2-1zm-4.4-.7-.5-1.6h-4.5l-.5 1.6h5.5m0 1.5-.5 1.6h-4.5l-.5-1.6h5.5m-11.6 21.9c0-.6.5-1 1.1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm1.9-7.8 1.7-.4v-4.3l-1.7-.5v5.2m-1.6 0-1.7-.4v-4.3l1.7-.5v5.2m15.7-32.6c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm6.2.8.5 1.6h4.6l.5-1.6h-5.5m0-1.6.4-1.6h4.6l.5 1.6h-5.5m-6 5-1.6.5v4.3l1.6.5V281m1.7 0 1.6.5v4.3l-1.6.5V281"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      d: "M227.7 294.7a2.6 2.6 0 0 1 2.6-2.5 2.6 2.6 0 0 1 2.6 2.5 2.6 2.6 0 0 1-2.6 2.4c-1.4 0-2.6-1-2.6-2.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ed72aa",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M238.1 227.5v1.4c.2.6-.1 1.2 0 1.5 0 .4.1.6.3.9l.2.9-.7-.5-.6-.4v1c.1.2.3.8.6 1.1l1 1.3c.2.5.1 1.4.1 1.4s-.4-.7-.8-.8l-1.2-.7s.7.8.7 1.5c0 .8-.3 1.6-.3 1.6s-.3-.7-.8-1.1l-1-.9s.4 1.2.4 2v2.3l-.9-1-1-.7c0-.2.5.6.6 1.1 0 .5.3 2.3 1.8 4.5 1 1.3 2.3 3.6 5.3 2.9 3-.8 1.9-4.8 1.3-6.7a16.8 16.8 0 0 1-1-4.6c0-.8.6-2.9.5-3.3a8 8 0 0 1 .2-3.1c.4-1.3.7-1.8.9-2.3.2-.6.4-.9.4-1.3l.1-1.3.7 1.3.1 1.5s.1-1 1-1.6c.8-.6 1.8-1.1 2-1.4.3-.3.3-.5.3-.5s0 1.8-.6 2.6l-1.7 2s.7-.3 1.2-.3h.9s-.6.4-1.4 1.6c-.8 1-.5 1.2-1 2.1-.6 1-1 1-1.7 1.5-1 .8-.5 4.2-.4 4.7.2.5 2 4.5 2 5.5s.2 3.2-1.5 4.6c-1.1 1-3 1-3.4 1.2-.4.3-1.2 1.1-1.2 2.8 0 1.7.6 2 1 2.4.6.5 1.2.2 1.3.6.2.3.2.5.5.7.2.2.3.4.2.8 0 .3-.8 1.1-1.1 1.7l-.8 2.4c0 .2-.1 1 .1 1.3 0 0 .9 1 .3 1.2-.4.2-.8-.2-1-.2l-.9.5c-.3-.1-.3-.3-.4-.8l-.1-.7c-.2 0-.3.2-.4.5 0 .2 0 .8-.3.8-.2 0-.5-.4-.8-.5-.2 0-.8-.2-.8-.4 0-.3.4-.9.7-1 .4 0 .8-.3.5-.5s-.5-.2-.7 0-.8 0-.7-.2v-.8c0-.2-.4-.5.1-.8.6-.3.8.2 1.4.1.6 0 .8-.3 1-.6.2-.3.2-1-.2-1.4-.4-.5-.7-.5-.9-.8l-.3-.9v2.2l-.7-.8c-.3-.3-.6-1.3-.6-1.3v1.3c0 .4.3.7.2.8-.1.1-.8-.7-1-.8a3.7 3.7 0 0 1-1-1l-.4-1.4a4.2 4.2 0 0 1 0-1.5l.4-1h-1.4c-.7 0-1.2-.3-1.5.2-.3.5-.2 1.5.2 2.8.3 1.2.5 1.9.4 2.1a3 3 0 0 1-.7.8h-.9a2.5 2.5 0 0 0-1.2-.3h-1.3l-1.1-.3c-.3.1-.8.3-.6.7.2.6-.2.7-.5.7l-.9-.2c-.4-.1-.9 0-.8-.4 0-.4.2-.4.4-.7.2-.3.2-.5 0-.5h-.6c-.2.2-.5.5-.8.4-.2-.1-.4-.4-.4-1s-.7-1.2 0-1.1c.5 0 1.3.4 1.4 0 .2-.3 0-.4-.2-.7s-.8-.4-.3-.7l.7-.5c.1-.2.4-.8.7-.6.6.2 0 .7.6 1.3.6.7 1 1 2 .8 1 0 1.3-.2 1.3-.5l-.1-1v-1s-.4.3-.5.6l-.4.8v-2a8 8 0 0 0-.2-.8l-.3.9-.1 1s-.7-.5-.5-1.5c.1-.7-.1-1.6.1-2 .2-.3.7-1.5 2-1.6h2.6l2-.3s-2.8-1.4-3.5-1.9a9.5 9.5 0 0 1-2-2l-.6-1.6s-.5 0-1 .3a5 5 0 0 0-1.2 1l-.7 1 .1-1.2v-.8s-.4 1.2-1 1.7l-1.4 1v-.8l.2-1s-.4.8-1.1 1c-.7 0-1.8 0-1.9.4 0 .5.2 1 0 1.4 0 .3-.4.5-.4.5l-.8-.4c-.4 0-.7.2-.7.2s-.3-.4-.2-.7c.1-.2.7-.6.5-.8l-.8.2c-.3.1-.8.3-.8-.2 0-.4.2-.7 0-1 0-.3 0-.5.2-.6l1.2-.1c0-.2-.2-.5-.8-.6-.6-.1-.8-.5-.5-.8.3-.2.3-.3.5-.6.1-.2.2-.7.7-.5.5.3.4.8 1 1a4 4 0 0 0 2-.2l1.5-1 1.5-1-1-.8c-.3-.3-.7-.9-1-1a8.3 8.3 0 0 0-1.8-.6 9 9 0 0 1-1.7-.5l.8-.3c.2-.2.6-.6.8-.6h.3-1.4c-.3-.1-1-.6-1.3-.6l-.8.1s.8-.4 1.4-.5l1-.1s-.9-.3-1.1-.6l-.6-1c-.2-.1-.3-.5-.6-.5l-1 .3c-.4 0-.6-.2-.6-.6l-.1-.5c-.2-.3-.6-.8-.2-1h1.4c0-.2-.5-.6-.8-.8-.4-.2-1-.5-.7-.8l.8-.5c.2-.3.3-1 .7-.7.4.2.8 1.2 1.1 1.1.3 0 .3-.8.3-1 0-.4 0-1 .2-.9.3 0 .5.4 1 .5.4 0 1-.1 1 .2 0 .3-.3.7-.6 1-.3.3-.4 1-.3 1.4.2.5.7 1.2 1.2 1.4.4.3 1.2.5 1.7.9.5.3 1.7 1.2 2.1 1.3l.8.4s.5-.2 1.1-.2c.7 0 2.1 0 2.6-.2.6-.2 1.3-.6 1-1-.1-.6-1.3-1-1.2-1.4 0-.4.5-.4 1.2-.4.8 0 1.8.1 2-1 .2-1 .2-1.5-.8-1.8-1-.2-1.8-.2-2-1-.2-.7-.4-.9-.2-1.1.3-.2.6-.3 1.4-.4.8 0 1.6 0 1.9-.2.2-.2.3-.7.6-.9.3-.2 1.4-.4 1.4-.4s1.4.7 2.7 1.7a15 15 0 0 1 2.2 2.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m228.1 226.8-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m228.1 226.8-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m237.3 231.3-.4-.7a8 8 0 0 1-.3-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1-.6.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1-.6.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m228.2 230.5.3-.5.3.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m228.2 230.5.3-.5.3.5h-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m229 230.5.3-.5.4.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m229 230.5.3-.5.4.5h-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m228.6 227.3.8.3-.7.4-.1-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m228.6 227.3.8.3-.7.4-.1-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m229.5 227.6.7.2-.5.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m229.5 227.6.7.2-.5.4-.2-.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224.2 233.7s-.7.2-1 .6c-.4.5-.3 1-.3 1s.6-.5 1.5-.3l1.2.3 1.3-.3s-.7.8-.7 1.3l.2 1.1c0 .7-.6 1.6-.6 1.6l1-.3a4.6 4.6 0 0 0 1.7-.8l.9-1s-.2 1 0 1.4l.2 1.6.8-.6c.2-.1.7-.4.9-.7l.3-1s0 .8.4 1.3l.6 1.6s.3-.8.6-1.1c.3-.4.7-.8.7-1a4.3 4.3 0 0 0-.1-.9l.4.8m-11 .6s.5-.8 1-1l1.1-.8.9-.4m1 5 1.3-.8a4 4 0 0 0 1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3zm16 1.3s2 1.2 1.9 2.2c0 1-1 2.3-1 2.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1-.7-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1-.7-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#db4446",
      d: "M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ffd691",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M208.8 316.4c2 .6 3 2 3 3.8 0 2.3-2.2 4-5 4-3 0-5.3-1.7-5.3-4 0-1.7 1-3.6 3-3.8l-.2-.4-.7-.7h1.2l.8.5.5-.7c.3-.4.6-.5.6-.5l.6.6.3.5.7-.4.8-.3s0 .4-.2.7l-.1.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.3 326.7s-3.8-2.6-5.5-3c-2-.4-4.5 0-5.5 0 0 0 1.2.8 1.8 1.4.5.5 2.3 1.5 3.3 1.8 3 .8 6-.2 6-.2m1 .2s2.4-2.5 5-2.9c3-.4 5 .3 6.2.6l-1.5.8c-.5.3-2 1.5-4 1.6-2 0-4.4-.3-4.8-.2l-.9.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.7 323.8a4.8 4.8 0 0 1 0-7.1 4.8 4.8 0 0 1 1.5 3.5 4.9 4.9 0 0 1-1.5 3.6"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M205.7 329s.6-1.5.6-2.7l-.1-2.1h.8s.3 1.1.3 2l-.1 2.4-.7.1-.8.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M231.7 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m.6 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1m0 3c0-.5.6-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1m-1 2.8c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1 0 .6-.4 1-1 1a1 1 0 0 1-1-1m-1.9 2.6c0-.5.5-1 1-1 .7 0 1.2.5 1.2 1s-.5 1-1.1 1c-.6 0-1-.4-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M178.2 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m-.7 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1m-.2 3c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m.9 2.8c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1.1-1m1.8 2.6c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#fff",
      d: "M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M174.7 228.9h-1v-1h-1.5v3.6h1.6v2.5h-3.4v7h1.8v14.3h-3.5v7.3h27.2v-7.3h-3.5V241h1.8v-7h-3.4v-2.5h1.6V228h-1.6v.9h-.8v-1h-1.6v1h-1.1v-1h-1.6v3.6h1.6v2.5H184v-7.8h1.7v-3.5H184v.9h-1v-1h-1.5v1h-.9v-1H179v3.6h1.7v7.8h-3.3v-2.5h1.6V228h-1.6v.9h-.9v-1h-1.8zm-6 33.7H196m-27.3-1.8H196m-27.3-1.8H196m-27.3-1.7H196m-27.3-2H196m-23.8-1.6h20.2m-20.2-1.8h20.2m-20.2-2h20.2m-20.2-1.7h20.2m-20.2-1.8h20.2m-20.2-1.8h20.2m-20.2-1.7h20.2m-22-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-20.4-1.7h17m-10.2-1.8h3.4m-3.4-1.8h3.4m-3.4-1.8h3.4m-3.4-1.7h3.4m-5.1-2.2h6.8m-12 7.5h3.6m-5-2.2h6.6m-6.7 32.6v-1.8m0-1.8v-1.7m-1.8 1.7v1.8m3.4 0V259m1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m-1.7 7.4v-2m-3.4 2v-2m7 0v2m1.5-2v-1.6m-5.1-1.8v1.8m3.5-1.8v1.8m3.3-1.8v1.8M179 252v-2m1.7-1.7v1.7m0-5.3v1.8m-1.7-3.6v1.8m1.7-3.5v1.7m-3.3-1.7v1.7m-3.5-1.7v1.7m-1.6-3.5v1.8m3.3-1.8v1.8m3.4-1.8v1.8m1.7-3.6v1.8m-3.3-1.8v1.8m-3.5-1.8v1.8m-1.6-3.6v1.8m6.7-1.8v1.8m-3.4-5.3v1.8m15.3-1.8h-3.5m5-2.2h-6.6m6.7 32.6v-1.8m0-1.8v-1.7m1.8 1.7v1.8m-3.4 0V259m-1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m1.7 7.4v-2m3.4 2v-2m-7 0v2m-1.5-2v-1.6m5.1-1.8v1.8m-3.5-1.8v1.8m-3.3-1.8v1.8m1.7-1.8v-2m-1.7-1.7v1.7m0-5.3v1.8m1.7-3.6v1.8m-1.7-3.5v1.7m3.3-1.7v1.7m3.5-1.7v1.7m1.6-3.5v1.8m-3.3-1.8v1.8m-3.4-1.8v1.8m-1.7-3.6v1.8m3.3-1.8v1.8m3.5-1.8v1.8m1.6-3.6v1.8m-6.7-1.8v1.8m3.4-5.3v1.8m-7 18v-2m0-5.4v-1.8m0 5.4v-1.8m0-5.3v-1.8m0-1.8v-1.7m0-3.6v-1.8m0-1.7v-1.8m-8.3 4.6h3.5m3.3-5.3h3.4m3.3 5.3h3.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M186.8 262.6v-4.7c0-.8-.4-3.5-4.6-3.5-4 0-4.4 2.7-4.4 3.5v4.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m179.3 258.2-2.2-.3c0-.9.2-2.2.9-2.6l2 1.5c-.3.2-.7 1-.7 1.4zm6 0 2.2-.3c0-.9-.2-2.2-.9-2.6l-2 1.5c.3.2.7 1 .7 1.4zm-2.2-2.3 1-2a5.3 5.3 0 0 0-2-.4l-1.7.4 1.1 2zm-4.2-5.5v-4.9c0-1.3-1-2.4-2.5-2.4s-2.4 1-2.4 2.4v4.9zm6.8 0v-4.9c0-1.3 1-2.4 2.5-2.4s2.4 1 2.4 2.4v4.9zm-1.7-12 .4-4.4h-4.2l.2 4.4zm3.3 0-.4-4.4h4.4l-.5 4.4zm-10 0 .2-4.4h-4.2l.5 4.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#0039f0",
      d: "M185.3 262.6v-4c0-.7-.5-2.7-3.1-2.7-2.4 0-2.9 2-2.9 2.7v4zm-6.9-12.7v-4.2c0-1-.6-2.2-2-2.2s-2 1.1-2 2.2v4.3h4zm7.8 0v-4.2c0-1 .7-2.2 2-2.2s2 1.1 2 2.2v4.3h-4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#ad1519",
      d: "M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.6,
      d: "M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#005bbf",
      d: "M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.6,
      d: "M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M199.2 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M199.2 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M209.4 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M209.4 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M204.3 278.6h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M204.3 278.6h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M237.6 223.4h-.3a1.5 1.5 0 0 1-.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1-.1-.4.5.5 0 0 1-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1-.1-.4.6.6 0 0 1-.5 0c-.2-.2-.3-.5 0-.8l.2-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M237.6 223.4h-.3a1.5 1.5 0 0 1-.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1-.1-.4.5.5 0 0 1-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1-.1-.4.6.6 0 0 1-.5 0c-.2-.2-.3-.5 0-.8l.2-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m236.3 224.8-.3-.2v-.2h.1l.4.3.3.2v.2h-.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m236.3 224.8-.3-.2v-.2h.1l.4.3.3.2v.2h-.2l-.3-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m234.6 223.7-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m234.6 223.7-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1l-.3-.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "M233.7 223h.2v.2h-.2s-.1-.1 0-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M233.7 223h.2v.2h-.2s-.1-.1 0-.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "M237.3 225.5v-.2h-.3l.1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M237.3 225.5v-.2h-.3l.1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "m237.9 226.2.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m237.9 226.2.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2l.2.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      d: "M238.8 227v-.3h-.3v.2h.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M238.8 227v-.3h-.3v.2h.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7-.5.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m236.4 222.6-.4.3-.6-.7v-.1h1.1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m236.4 222.6-.4.3-.6-.7v-.1h1.1v.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1-.3 0 .3.3 0 0 1-.1-.3"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1-.3 0 .3.3 0 0 1-.1-.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m233.2 221.1-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m233.2 221.1-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m234.2 221.4-.4.4-.6-.6v-.2h1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m234.2 221.4-.4.4-.6-.6v-.2h1v.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m233.1 221 .3-.1v.3c0 .2-.1.2-.2.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m233.1 221 .3-.1v.3c0 .2-.1.2-.2.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4-.2-.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7-.5.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m238.4 224-.5.2-.4-.7v-.2h.1l.9.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m238.4 224-.5.2-.4-.7v-.2h.1l.9.2-.1.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1-.3 0 .3.3 0 0 1 0-.4"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1-.3 0 .3.3 0 0 1 0-.4z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m240.2 224.3.1.5-.8.3h-.2v-.2l.4-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m240.2 224.3.1.5-.8.3h-.2v-.2l.4-.8.5.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m240 225.8-.5.1-.3-.8v-.1h.2l.8.3z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m240 225.8-.5.1-.3-.8v-.1h.2l.8.3-.1.5"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m238.6 224.3-.2.5.9.3h.1v-.1l-.3-.8z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m238.6 224.3-.2.5.9.3h.1v-.1l-.3-.8-.5.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0-.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0-.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "m240.3 226.1-.3.5.8.5v-.1h.2l-.1-1z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m240.3 226.1-.3.5.8.5v-.1h.2l-.1-1-.6.1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "#c8b100",
      d: "M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2z"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2zm38-21.9v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      d: "M134.4 217.1v-1.2m-.4 1.2v-1.2m-.2 1.2v-1.2m-.3 1.2v-1.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M133.2 217.1v-1.2m-.5 1.1v-1m.2 1v-1m-.7 1v-1m.2 1v-1m-.9 1v-1m.2 1v-1m.3 1v-1m-.7 1v-1m-.3.9v-.8m-.1.8v-.8m-.5.7v-.6m.2.6v-.6m-.4.5v-.5m-.2.5v-.4m-.3.3v-.3m-.3.3v-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M129.2 216.6v-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      d: "M135.7 217v-1m-.5 1v-1m-.4 1.2V216m143 1.1V216m-.4 1.1V216m-.3 1.1V216m-.3 1.2V216"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M276.6 217.1V216m-.6 1v-1m.3 1v-1m-.8 1v-1m.3 1v-1m-.9 1v-1m.2 1v-1m.2 1v-1m-.6 1v-1m-.3.9v-.8m-.2.8v-.8m-.4.7v-.6m.2.6v-.6m-.5.6v-.6m-.2.5v-.4m-.3.4v-.4m-.2.3v-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M272.6 216.6v-.2"
    }),
    /* @__PURE__ */ jsx86("path", {
      fill: "none",
      d: "M279.1 217v-1m-.6 1v-1m-.4 1.1V216"
    })
  ]
});
var Es_default = SvgEs;

// src/country-flag-icons/generated/Et.tsx
import { jsx as jsx87, jsxs as jsxs80 } from "react/jsx-runtime";
var SvgEt = (props) => /* @__PURE__ */ jsxs80("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx87("defs", {
      children: /* @__PURE__ */ jsx87("clipPath", {
        id: "et_svg__a",
        children: /* @__PURE__ */ jsx87("path", {
          fillOpacity: 0.7,
          d: "M-61.3 0h682.7v512H-61.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs80("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#et_svg__a)",
      transform: "translate(57.5) scale(.94)",
      children: [
        /* @__PURE__ */ jsx87("path", {
          fill: "#ffc621",
          d: "M-238 3.5H800v498H-238z"
        }),
        /* @__PURE__ */ jsx87("path", {
          fill: "#ef2118",
          d: "M-240 342.5H799.3V512H-240z"
        }),
        /* @__PURE__ */ jsx87("path", {
          fill: "#298c08",
          d: "M-238 0H800v180H-238z"
        }),
        /* @__PURE__ */ jsx87("circle", {
          cx: 534.2,
          cy: 353,
          r: 199.7,
          fill: "#006bc6",
          transform: "matrix(.54 0 0 .54 -25.8 74)"
        }),
        /* @__PURE__ */ jsx87("path", {
          fill: "#ffc621",
          d: "m214.3 188.2-6.5 4.5 23.5 33 6.3-4zm29.4 78-9.7-6.8 4-12.7-48.1.7-14-10.7 65.7-.7 12.2-36.9 6.6 15zm76.5-70.7-6.3-4.8-24.3 32.4 5.6 4.7zM254.8 247l3.5-11.2h13.3L256.4 190l6-16.5 20.5 62.4 38.8.5-12.2 10.7zm90.6 51.2 2.7-7.4-38.3-13.3-2.8 7zm-69.1-46.4 11.7-.1 4.1 12.6 38.8-28.5 17.6.6-53.1 38.7 11.5 37.2-14-8.4zm-19.8 102 7.9.2.3-40.5-7.4-.5zm22-80.3 3.8 11.1-10.7 8 39.4 27.7 5 16.8-53.6-38-31.5 22.7 3.5-16 44-32.3zm-103.3 13 2.3 7.5 38.7-12.2-2-7.2zm83.2-4-9.4 7.1-10.8-7.7-14.2 46-14.4 10 19.5-62.7-31.4-23 16.3-1.6z"
        })
      ]
    })
  ]
});
var Et_default = SvgEt;

// src/country-flag-icons/generated/Fi.tsx
import { jsx as jsx88, jsxs as jsxs81 } from "react/jsx-runtime";
var SvgFi = (props) => /* @__PURE__ */ jsxs81("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx88("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx88("path", {
      fill: "#002f6c",
      d: "M0 174.5h640v131H0z"
    }),
    /* @__PURE__ */ jsx88("path", {
      fill: "#002f6c",
      d: "M175.5 0h130.9v480h-131z"
    })
  ]
});
var Fi_default = SvgFi;

// src/country-flag-icons/generated/Fj.tsx
import { jsx as jsx89, jsxs as jsxs82 } from "react/jsx-runtime";
var SvgFj = (props) => /* @__PURE__ */ jsxs82("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx89("path", {
      fill: "#68bfe5",
      d: "M0 0v480h640V0z"
    }),
    /* @__PURE__ */ jsxs82("g", {
      strokeMiterlimit: 4.8,
      children: [
        /* @__PURE__ */ jsx89("path", {
          fill: "#fff",
          d: "M420.9 193.2v136.4c0 44.6 80.6 71 80.6 71s80.5-26.4 80.5-71V193.2z"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#d21034",
          d: "M490.3 241.2v61.4h-69.4v22.3h69.4v71.5l11.2 4.3 11.1-4.3V325H582v-22.4h-69.4v-61.4z"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#d21034",
          d: "M420.9 193.2H582V246H420.8z"
        }),
        /* @__PURE__ */ jsxs82("g", {
          strokeMiterlimit: 3,
          children: [
            /* @__PURE__ */ jsxs82("g", {
              fill: "#fff",
              stroke: "#000",
              strokeWidth: 0.8,
              transform: "translate(-96.9 97.5) scale(.66486)",
              children: [
                /* @__PURE__ */ jsx89("ellipse", {
                  cx: 798.2,
                  cy: 192.2,
                  rx: 13.6,
                  ry: 11
                }),
                /* @__PURE__ */ jsx89("ellipse", {
                  cx: 798.2,
                  cy: 186.5,
                  rx: 12.1,
                  ry: 6.1
                }),
                /* @__PURE__ */ jsx89("ellipse", {
                  cx: 798.2,
                  cy: 198.8,
                  rx: 12.1,
                  ry: 6.1
                }),
                /* @__PURE__ */ jsx89("ellipse", {
                  cx: 798.2,
                  cy: 192.2,
                  rx: 12.1,
                  ry: 6.1
                })
              ]
            }),
            /* @__PURE__ */ jsx89("path", {
              fill: "#ffd100",
              stroke: "#000",
              strokeWidth: 0.8,
              d: "m578 235.4-1.3-3.6s-3.6-1.5-3.9-3.4c-.6-5.1-2.4-7-5.2-7.8a6 6 0 0 0-4.5.5c-.8 1.2-5 1.2-7.2 1.3-2.3 0-2.4-1-2.4-1-1.7 0-2.5-1.3-2.5-1.3-1.1-2.3-2-3.2-2.6-3.5 3 0 5.2-1.3 8.6-4.8 3.6-3.8 6.2-2.4 6.2-2.4-1.8 3.6.6 3.3.6 3.3 4.8-2.5.6-8.7-.8-8.4-1.5.3-1.9-.7-1.9-.7 0 1.1-1.6 1.6-1.6 1.6 1.2-7.1-3-9-3-9-.6.6-1 1.9-1 1.9-1.2 4.3-5.1 3.6-9.5 1.5-4.4-2-16 2.2-19.7 3.7-3.7 1.5-10.4 3.7-16.4.4-6-3.4-7.5-2.8-9.9-2.1-2.3.6-6.5 1.6-8 .8a8.5 8.5 0 0 0-3.4-.9c.4-.2-.2-1.2-.2-1.2-1.9-2.5.2-4 .2-4s-3.4 1-2 6.8l.6.8s.4 1.9 1.4 2.4v.4s.9-.4 1.1.8c.3 1.2 1.6 0 2.1-1 0 0-.9 5.4 5.7 6.7 0 0-.7-.9-.5-1.4.3-.6-.8-1-.7-1.8.1-.9-1.6-1.2-.3-1.9 1.4-.6 2-1.9 5-.1 2.9 1.7 5.2 1.3 5.2 1.3s-1.8-3.6-.8-3.6 5.4 5.4 7.5 5.2c2.2-.3 6.4-2.8 8.5-1.9 0 0 .2-1 8.2-2.4 8-1.4 18-5.4 21.7-1.9 0 0 .4 2.8 2 3.5 0 0-.3 5.8-10.2 2.6l-3.6-1s-.6-1.7-19.5 3.2c0 0-1.1.4-1.9.9-.7.5-1.7-.3-5.5 1-3.7 1.5-17.7 6-26.3 4.4-1.9-.6-3.6-.3-3.7-.6 0-.3 1 .1 1 .1-.6-.7-.9-.8-.9-.8-7.2-.8-6-4-6-4l.4 1c1.2-1.6-.4-5.2-.4-5.2h-.1a3.8 3.8 0 0 0 0-.3l.5-.4c3.5-3 7.5-3.5 7.5-3.5-2.4-3-7.4-1.4-7.4-1.4.1-3.5-1.4-7.7-1.4-7.7a12 12 0 0 0-7.7 4.7c-.2-3.7-4.9-5.8-4.9-5.8 1.8 2.1.7 7.2.7 7.2h.2-.5l-.1 1.1h-.2s-1.7.6-3.7 5.2c0 0-.2 1-1 2v-.4s-2.3 3-7.4 0c0 0-7-4.1-9.6-4-2.4.2-4 1.3-3.9 2 0 0-5.7-.4-7.6 2.8 0 0-4.3 1.6-.6 5 0 0 .5 1.6 1.5 2.4 0 0-.1-3.2.7-2.3l.5.6c.1.4.5 1.6 1.2 2.3l.6-.2c0-.8.2-1.8.4-2.2h.2l1 1.6 1-.6c.6 0 1.3.5 1.3.5l1.3-1.1c1.3.2 1.7-2.4 1.7-2.4a4 4 0 0 0 3.1-.5c.6 2 5.2 4.3 5.2 4.3h.2l-.6.4c2.1 1.5 6 1.1 6 1.1-1.6.6-1.4 3.7-1.4 3.7-1 .4-1 1.3-1 1.3 3.2 1.3 5.3.2 5.3.2.2 1 0 1.2 0 1.2-1.3 2.7-1.9 5.4-1.9 5.4h.1v.2s-5.7 2-8.1 4.7c0 0-.3-.8-1-.8s-2.8-1.8-3.8-2.1c-1-.3-2.5.3-3-.2-.3-.4-.1-3.6-.8-4l-.7-2c-.4 1-2.4.8-2.4.8l-.8.6-.8-.1c-.2 0-.4.5-.5 1l-.3.3v-.6c-.3.3-1.1-.1-1.4-.1-.2 0-.4.4-.5.9l-1.9.1c-.3.2 0 2.6 0 2.6-2.3 1.2-1.2 3.1-1.2 3.1 1.2 6 11.5 3.3 12.3 4.1.8.8 2.6 1 3.5 1 1 0 2.1 2.2 3.4 2.4 1.3.2 0-1.8 6.1-3.2 6.1-1.5 8.2-4 8.2-4 1.9-.4 2.4-2.7 2.5-3.6l.2 1.4c.3 2.1-1.2 3-1.2 3l5.3-1.7c2.1-.5 1.8-2.4 1.8-2.4 2 5.8 5.7 6.2 5.7 6.2.7-2.2.6-2.9.6-2.9h1.7c0-1.3-1-2.2-1.7-2.6l2.6 1.5 1-.1c0 .9 1.3 1.7 1.3 1.7l.2-1.2c1.2 1.6 3.4 1 3.4 1a7.3 7.3 0 0 0-.2-.8c4.7 2.9 12.2-.8 12.2-.8 2 .4 2.3-.8 2.3-.8 2.2.3 2.8-1.3 2.8-1.3 5.3-.4 9.1-4.2 9.1-4.2 2.7-.2 2.8-2.1 2.8-2.1s2.6.5 5.2-2.7c6-8.5 14.8-4 14.8-4l-5.1.3c-13.5-.1-7.9 9-7.9 9h.8c1.3.2 5.7 3.7 4 6.2v.2c-2.8 3.7-7.8.2-9.3-3-1.4-3.2-4.4-2.5-4.4-2.5s-7.5 1.3-4.4 7.3c.1 1.5 1 3.2 3.8 4.8 1.5 2.2 6.5 2.4 10.1 1.6C524 244 533 240 533 240c.7-2 3-1.5 5-4.4 2-2.8-2.9-3.8-4-5.4-1-1.5.3-1.2.3-1.2 4.4 2.3 4.8-5.2 4.8-5.2a6.6 6.6 0 0 0 4.3 5.5c2.3-2.3.6-7.2.6-7.2 5.7 10.2 9.1 8.5 9.1 8.5-3-1.8-1.5-4.4-1.5-4.4 2.7 10.8 14 1.4 14 1.4-.6 1.6 0 2.5 1 3.5s2.2 1.4 1.6 3.3c-.5 1.8-5.8 1.4-5.8 1.4s-5-.2-4.6 4c.3 1 3.6 1.4 5 1.1 0 0-.6.2 1.3.4h2.2c2.1 0 4.5-.4 4.5-.4 2.9-.6 2.4-1.6 2.4-1.6 4.5-.8 5-3.8 5-3.8z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M429.6 216.7s.3-.5.7-.6c.4 0 .8.2 1.2.8l.3-.2s-1.2-1.8-.8-3c.3-.6.8-1 1.6-1.1v-.3c-1 .2-1.6.6-1.8 1.3a2 2 0 0 0-.2.7c0 .6.2 1.2.5 1.7a1.1 1.1 0 0 0-.8-.2 1 1 0 0 0-.8.6zm141 24c-3 .5-7.5.7-7.9-.2 0-.2 0-.8 2.4-2.4l-.2-.5c-2.1 1.4-3 2.3-2.7 3 .7 1.8 7.2.8 8.5.6zm-58.4 1.7c-.7-1-.3-2.5 1-4.3l-.5-.3c-1.4 2-1.7 3.6-1 5z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M508.1 237.8c0 1.9 1.4 3.6 3.9 5.1l.3-.5c-2.4-1.4-3.6-3-3.6-4.6-.2-2.5 2.5-4.5 2.6-4.5l-.3-.4c-.2 0-3 2.1-2.9 5zm52 .7c-.8 1.3-.5 2.8-.5 2.8h.5c0-.1-.2-1.4.5-2.5a3 3 0 0 1 2-1.2v-.5c-1.1.2-2 .7-2.4 1.4zM441 215.1h-.2v.2s-.2 1.6-1 2a.8.8 0 0 1-.6 0l-1.3-.7c-.2-.2-.4-.3-.8-.2a1.8 1.8 0 0 1-.4-1.4c.1-.7.6-1.4 1.6-2l-.2-.3c-1 .7-1.6 1.5-1.7 2.3 0 1 .5 1.6.5 1.6v.1h.2c.3-.1.3 0 .6.2l1.4.8h1c.7-.5 1-1.9 1-2.2 3.2.7 5.8-3.3 6-3.4l-.3-.2s-2.7 4-5.8 3.2"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M433.1 214.5a3 3 0 0 0 .4 2c.3.5.7.8 1 .9.5 0 .8-.3 1.2-.6.2-.2.4-.4.6-.4l.3.2.2-.2-.5-.3c-.3 0-.6.2-.8.5s-.6.5-1 .5c-.2 0-.5-.3-.8-.8a2.2 2.2 0 0 1-.3-1.7c.4-1.4 2.1-2.5 2.1-2.5l-.1-.3c-.1 0-1.9 1.2-2.3 2.7m-4.4 20.7c.1-.6.6-1 1.3-1.4-.2 0 .6.6 1.3.6l.5-.3c.2.2 1.4 1.3 1.4 2.7 0 .3 0 .6-.2.9l.3.1c.9-2.1-1.4-4-1.4-4h-.2l-.4.3c-.6 0-1.3-.6-1.3-.6-1 .4-1.4 1-1.6 1.6zm10.3-5.4c-.7.1-2.5.4-3.1 1.4-.2.4-.3.8-.1 1.2l.2.6c.6 1.6 1.2 3.2 1.9 3.6l.1-.3c-.6-.3-1.2-2-1.7-3.4l-.2-.6a1 1 0 0 1 0-1c.5-.7 2.2-1 3-1.1.4 0 .5 1.5.6 2.4h.3c-.1-1.4-.3-2.8-1-2.8"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M433.9 231.4c-.4.3-.3.8-.3.9 0 .1.2 4 2 4.8l.1-.3c-1.6-.7-1.8-4.5-1.8-4.6 0 0 0-.4.2-.6.3-.2.8-.3 1.6 0l.1-.3c-.9-.3-1.5-.2-1.9 0z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M432.4 231.7c-.8.6-.7 2.2-.7 2.3h.3s0-1.6.6-2c.3-.2.6-.2 1 0l.1-.4c-.5-.2-1-.2-1.3 0z"
            }),
            /* @__PURE__ */ jsxs82("g", {
              transform: "translate(-96.9 97.5) scale(.66486)",
              children: [
                /* @__PURE__ */ jsx89("path", {
                  d: "M862.3 169.5s1.3 3 1.3 5.3c0 .4-.2.7-.3 1l-.5-1.3-.3 1s-.6 1.4.3 2.9c1.2 2 4.2 3.2 9 3.7v.1a.8.8 0 0 0-.4.1l-.2.2v.4c.2.5.7.5 1.8.5l.7.1.6.2-.1-.1c1 0 2.3.3 3.6.8l-1 .2 1.1.5c.1 0 8.7 3.5 12.2 6.3-1 .9-5.3 4-12.7 2.2l-1.2-.3.8 1s4.9 5.6 5.9 9c-1.7 0-8.2 0-10.5-2l-.5.5s3 4.6 3.8 8.1c-1 .2-3 .3-4.3-1.4l-.6-.7-.3 2c-.6-.5-1.4-1.1-1.4-1.9v-.4l-1.8.3-3.8-2.3a8 8 0 0 0-.6-.4l-.4.7.6.3c.8.6 2.2 1.7 2.3 3.3H863v.5c0 .3 0 1.4-.9 3.7-1.1-.2-5.3-1.7-7.8-8.8l-.8.2v.2c0 .7-.2 2.3-2.4 2.9l-6.5 2a4.5 4.5 0 0 0 .8-2.8v-.8a20.3 20.3 0 0 1-.2-2.6c0-1.5.3-2.4 1.4-3l-.4-.8c-.1 0-9.6 3.9-14.3 2.3.2-1 1-4.2 2.6-7.6l-.2.2c.3-.2.6-.6.3-2.2v-.5l-.5.2s-3 1.4-7.4-.2c0-.4.3-1 1.2-1.4l.3-.1v-.8c0-1.2.1-4 1.8-4.6l-.2-.8s-5.1.4-8.2-1.3a11 11 0 0 1 4.5-1.9h.3v-.4a6 6 0 0 0-.5-2.3c1.2.4 2.6.7 3.1.3l.2-.1-.2-3.1h-.8l.1 2.6-3-.7-1.2-.4.8 1a4 4 0 0 1 .7 2.4 12.7 12.7 0 0 0-5 2.3l-.5.4.5.3c2.4 1.6 6.1 1.8 8 1.7a8.4 8.4 0 0 0-1.3 4.5v.4a3.1 3.1 0 0 0-1.5 2.2v.3l.2.1a11 11 0 0 0 7.9.5v.9c-2 4.2-3 8.3-3 8.3v.4h.3c3.9 1.6 10.7-.5 13.8-1.6-.4.7-.7 1.5-.7 2.5a22.1 22.1 0 0 0 .3 3.4c0 2.3-1.5 3.2-1.6 3.2l.3.8 8-2.4c1.8-.5 2.5-1.6 2.8-2.5 3.1 7.4 8 8 8.3 8.1h.3l.1-.3a14 14 0 0 0 1-4 439.6 439.6 0 0 0 2.4-.1v-.5c0-.7-.1-1.3-.4-1.8l1.4.8 1.3-.2c.3 1.3 1.9 2.4 2.1 2.5l.5.3.3-1.7c2 1.7 4.7 1.2 4.9 1.2l.3-.1v-.4c-.4-2.7-2.2-5.9-3.3-7.6 3.5 1.6 9.9 1.5 10.2 1.5h.4v-.5a30 30 0 0 0-5.6-9c8.2 1.5 12.6-2.8 12.8-3l.3-.3-.4-.2a53.8 53.8 0 0 0-11.6-6.3l.9-.2-1-.5a12.8 12.8 0 0 0-5.8-1.4c-1-1.2-1.5-1.3-1.6-1.4-5.6-.6-7.6-2.1-8.4-3.3v-.3l.2-.3c.5-.7.7-1.6.7-2.6 0-2.6-1.3-5.5-1.3-5.6z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M836.8 167.9s-.6 3-3.2 4.5c-2 1-4.5 1-7.6-.3l-.4-.1v.4a5 5 0 0 0 2 3.2c1.3 1 3.3 1.4 5.9 1.2-.9 1-3.6 4.4-3.6 7.8v.5c.4.2 4.6 1.4 6.6-1.1 0 1 .4 4.5 1.7 5.8.8.8 1 1.8 1 2.7 0 .8-.2 1.4-.2 1.4l-.2.6.5-.4c.2-.1 4.1-3 5.3-6.7 0 0 .7-1 1.9-1.3v.5c0 1.5.6 4.1 4.8 5.7l.3.1v-.3a7.1 7.1 0 0 1 0-.7c0-1.1 0-3 1.1-4a2.8 2.8 0 0 0 .6-3.3c.9.2 2.9.9 3.7 2.4 1.2 2.2 5.3.4 5.5.4l-.1-.5s-1.8.4-2.9-.3a2.1 2.1 0 0 1-.8-1.5l-.2-2.4c0-1-.2-1.7-.7-2.2.5 0 1.6 0 2 1 .8 1.6 3.3 1.7 3.4 1.7l.9.1-.7-.5s-2.2-1.4-1.8-3.3l.3-1.4c.6-2.5 1.6-6.6.7-9.2l-.4.2c.2.6.3 1.4.3 2.2 0 2.2-.7 5-1 6.7l-.4 1.4a2.6 2.6 0 0 0 0 .5c0 1.3.7 2.2 1.3 2.7-.7-.1-1.7-.5-2-1.3-.7-1.4-2.3-1.4-3-1.3l-.6.1.4.4c.7.4.8 1 .8 2.3l.2 2.3c.1.8.5 1.4 1 1.8.6.4 1.2.4 1.7.5-1.2.3-2.9.5-3.5-.6-1.1-2.2-4.3-2.7-4.4-2.8h-.5l.2.4s.4.6.4 1.4c0 .5-.2 1.2-.7 1.7-1.1 1.1-1.3 3.2-1.3 4.3v.4c-3.6-1.5-4.2-3.7-4.2-5v-1l.2-.3h-.4a3.5 3.5 0 0 0-2.5 1.8 15 15 0 0 1-4.7 6.2 6.9 6.9 0 0 0 .1-1c0-.9-.2-2-1-2.9-1.5-1.4-1.7-6-1.7-6v-.8l-.4.7c-1.6 2.8-6.2 1.4-6.3 1.4-.2-3.5 4-8.1 4-8.2l.4-.4h-.6c-2.7.4-4.8 0-6.2-1a4.6 4.6 0 0 1-1.6-2.5c3 1.1 5.6 1.2 7.6.1a7.4 7.4 0 0 0 3.4-4.8c3-6.6 5.5-7.7 5.5-7.7l-.1-.4c-.2 0-2.8 1-5.8 8"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M843.5 158h-.2l-2.4 3.3h.7a31 31 0 0 1 19.7 9.2l.3.3 2.3-2.5-.2-.3c-6.5-10.2-20.1-10-20.3-10zm.2.9c1.6 0 13.2.3 19.2 9.3l-1.3 1.4a33 33 0 0 0-19.3-8.9 631.2 631.2 0 0 1 1.4-1.8"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M841.6 164.8a11 11 0 0 0-2.1 4.8l.1.4a7.3 7.3 0 0 0-2 5.5c0 1.3.2 2.6.6 3.8l.3.7c1.2 3.4 2.3 6.4 7.8 4.6 5.2-1.6 5.4-2 6.7-4.2l.4-.5c.7-1.2 1.5-1.4 2.3-1.7 1-.3 2-.6 3-2.4l.8-1.3c1-1.3 2.2-3 2.3-5h-.4a9.8 9.8 0 0 1-2.2 4.7l-1 1.4a3.6 3.6 0 0 1-2.6 2.2 3.9 3.9 0 0 0-2.6 1.8l-.4.6c-1.2 2.1-1.4 2.4-6.5 4-5 1.6-6-.9-7.2-4.4l-.3-.7c-1.4-3.8-.3-7.6 1.6-9l.6-.5-.9.1v-.1c0-.7.7-2.6 2-4.5 1.2-1.6 4-3.1 4-3.2l-.2-.4c-.2.1-2.9 1.7-4.1 3.3"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M839.2 178.7c.9.6 2.1.5 3.7 0 0 .5 0 1.7 1 2.5 1.2 1 3 1.2 5.5.6v-.5c-2.4.6-4.2.4-5.2-.5a3 3 0 0 1-.9-2.4v-.4l-.3.2c-1.5.6-2.7.7-3.6 0-1.5-1-1.4-3.7-1.4-3.7h-.4s-.2 3 1.6 4.2"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M842 175c-.6.2-.8.7-.8 1.1v.3c.2 1.2 1.5 2 2.6 2.3 1.2.3 2.6.4 3.1-.3.2-.3.4-.8 0-1.7a3.7 3.7 0 0 0-4.8-1.7zm2 3.3c-1-.3-2.2-1-2.3-2 0 0-.1-.7.5-.9a3.3 3.3 0 0 1 4.2 1.6c.3.4.3.8.1 1-.3.5-1.4.6-2.5.3m-.4 2.7c-.3 2.5 0 2.6.1 2.6h.2l.2-.1 1.4-2-1.8-.8v.3zm.5.4.7.3-.8 1.1zm-4.2-2.4-.1 2.3 2-2.4-2-.2zm.4.2h.6l-.6.8z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M838.5 178.2s1.5 2.9 1.8 4c.1.6 1 1.4 2 1.7 1 .4 2 .4 2.7-.1l1.3-1.1c.4-.5.6-.6 1-.5v-.5c-.6 0-.9.2-1.3.6l-1.3 1c-.8.6-1.7.4-2.2.2-1-.3-1.7-1-1.8-1.5-.3-1-1.7-3.9-1.8-4zm2-8.6a5 5 0 0 0-2.4 2.8l.4.1s.7-1.8 2.1-2.5a2.9 2.9 0 0 1 2.4 0l.1-.4c-1-.4-1.8-.4-2.7 0zm10.8 5.2c.2 0 3.2 2.4 1.5 5.2l.3.3c2-3.3-1.5-5.9-1.5-6zm-9.2.4s-.5 1.7 2 2.3c0 0-2.3 0-2.5-.6-.1-.6 0-1.9.5-1.7m7.5 2c0 .2-.2.3-.3.3a.3.3 0 0 1-.3-.2c0-.2.1-.3.3-.3.1 0 .3.1.3.3zm.2 1.2c0 .1 0 .2-.2.2a.3.3 0 0 1-.3-.2.3.3 0 0 1 .3-.3c.1 0 .2.1.2.3"
                }),
                /* @__PURE__ */ jsx89("circle", {
                  cx: 848,
                  cy: 177.8,
                  r: 0.3
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M848.8 179.4a.3.3 0 1 1-.6 0c0-.1.1-.2.3-.2zm-7.1-7.3a.3.3 0 0 1-.6 0 .3.3 0 0 1 .5 0z"
                }),
                /* @__PURE__ */ jsx89("circle", {
                  cx: 841.6,
                  cy: 173.2,
                  r: 0.3
                }),
                /* @__PURE__ */ jsx89("circle", {
                  cx: 840.1,
                  cy: 172.7,
                  r: 0.3
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M840.8 174.3a.3.3 0 0 1-.2.3.3.3 0 0 1 0-.6.3.3 0 0 1 .2.3m4.8-9.6s3.5 2.2.1 6.3c0 0 1.7-1.3 1.8-3.4.2-2.1-1.2-3.8-2-2.9zm13.5 5.9c-1.2.6-2.8-.5-3.6-1.5-.8-1-2.5-1.3-3.6.6-1 1.8-2.5 2.5-2.5 2.5s1.5-.8 3-2.5c1.5-1.6 2.4-.3 3.9.5 1.4.8 1.7 1 2.7.5v-.1z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M858.8 170.9a1.7 1.7 0 0 1-2.2-.1c-1-.8-1.7-1.8-2.8-1.2-1.2.6-3.3 2.2-3.3 2.2s3.5-2.4 4.2-1.8c.6.5 2.2 1.8 3.1 1.4z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M856.1 172.3c-1.1-.8-2.2 1-3.1.8-1-.2-1.7-1.8-1.7-1.8s.8 1.6 2 1.3c1.3-.4 2.1-1.2 2.9-.6.7.6-.1.3-.1.3"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M854.4 172.6a2 2 0 0 1-2.4-1.9s.7 1.8 2.6 1.5z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M854.3 171.2c.1.5.1.8-.5.8s-1-.2-1-.8c0-.5 1.4-.4 1.5 0m-7.8-3a.7.7 0 0 1-.7.6c-.4 0-.5-.2-.5-.6s0-.7.5-.7.7.3.7.7"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M844 165.7s3.8 0 2 4.7c0 0 1.4-2.3.5-4-1-1.6-2.3-1.2-2.3-1.2s-.4.3-.2.5"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M844 167.6c0 1 .6 1.9 1.8 2.9l.3-.4c-1.1-.9-1.7-1.7-1.7-2.5s.6-1.3.6-1.3l-.3-.3s-.7.6-.8 1.6z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M844.8 168.4c.1.5.6 1 1.2 1.2l.2-.4c-.5-.2-.9-.6-1-1-.2-.8.4-1.7.4-1.7l-.4-.3s-.7 1.2-.4 2.2m5.1 2.6s.7 1.5-.3 3.1l-1 1.6s1.2-2.3.7-3.2c-.4-1 .6-1.5.6-1.5m14.6 15.8c3.8.7 12.5 7.5 12.5 7.5l.5-.6c-.3-.3-8.9-7-12.9-7.7zm3.4 9.5c.2 3.5 4 5.6 4 5.7l.5-.7s-3.5-2-3.7-5zm-9.3.8c0 3.8 3.6 8.4 3.8 8.6l.6-.5s-3.6-4.6-3.6-8.1zm-12.1.4c.6 1.3.6 1.9.4 2.2-.2.4-.6.4-.6.4l.1.8c.3 0 .9-.2 1.2-.8.4-.7.3-1.7-.4-3z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs82("g", {
              fill: "#fff",
              stroke: "#000",
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx89("path", {
                  d: "M429.6 216.3s.1 1.7 1.4 2.7c0 0-.1-1.8.3-2.6 0 0-.7-.8-1.7-.1zm2.6 1s.3 1.6 1.2 2.3l.6-.1s.2-2 .5-2.2c.3-.2-1.3.7-2.3 0z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "m434.5 217.3 1 1.6 1.2-.7-.2-1.8s-.7-.2-2 .9zm4.7.3-1.3 1.1s-.7-.5-1.2-.5l.2-1.7s1-.7 2.3 1.1zm-9.3 16s-.2-2.4 0-2.5c0 0 1 .3 1.4 0 0 0 .5 1.8.4 2.6-.2.8-1.1.5-1.8 0zm6-2.4s-.1-2 .2-2.3c0 0 2 .3 2.4-.8l.7 2s-2.1-.3-3.4 1z"
                }),
                /* @__PURE__ */ jsx89("path", {
                  d: "M433.8 231.6s.3-2.1.7-2.2c0 0 1 .3 1.3-.1v2.6s0-1.1-2-.3zm-2.3.3s.5-1.9.8-1.9 1 .5 1.4.2v1.4s-1.6-.4-1.9 1.9z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs82("g", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.8,
          children: [
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M461.7 270.4s5.2 4.9 3.9 9.2c0 0 3.3-7.3-.3-9.5-3.6-2-3.7-.5-3.6.3z"
            }),
            /* @__PURE__ */ jsx89("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M455 275.1s-1.3 2 .2 3.3c0 0-1.7 2.4-.4 4.4 0 0-1 2.1-.8 4.4 0 0-.8 3.5 1 5.1 0 0 2 1 3 .1 0 0 1.7-2.6.6-5.3 0 0 1.2-2.3-.2-5.2 0 0 .4-1.6-.7-3.5 0 0 .7-1.2.1-2.2 0 0-2.5-2.7-2.8-1z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M456.5 269s-6.2-12-10.6-12.5c-4.4-.5-4.6-4.8-4.6-4.8s.5 2 4 2 10.2 5 11 8.7c.7 3.7 1.5 3.2 1.5 3.2z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M456.5 268.1s2.3-15.1 12.2-15.4c9.9-.2 6.6.8 9-.8 0 0-6.6 3.4-10.7 4-4.2.4-7.6 8.5-7.4 10 0 1.5-2.3 4.4-3.4 3.4-1.2-1 .3-1.2.3-1.2z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M458.8 273.8s2.3-6 6.1-4c0 0-3-5.8-8.4-.8 0 0 2.4 3.3 2.3 4.8zm-7.5-6s3.2 13.4-1.8 17.5c0 0 .2-6.9-2.9-11-3-4.2 3-8.7 4.7-6.5z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M451.7 270.1s5.9 5.7 6.2 7.6c.4 1.8 1.8-5.7-1-7.8s-5.7-2.5-5.7-2.5l.5 2.8z"
            }),
            /* @__PURE__ */ jsx89("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M440.8 285s.5 2.3 2 2.8c0 0 0 1.7 1.4 2.2 0 0-.7 1.5.4 2.4 0 0-.2 3 .8 3.5 0 0 2.7-.1 3.6-.9 0 0 .5-1.9-1-3.8 0 0 .3-1.8-1.2-2.8 0 0 .5-2.5-1.4-3.4 0 0-.3-2-1.4-3 0 0-2.2 3.1-3.2 3z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M443.7 282s-7.7-2.8-12 1.2c0 0 6.6 1 7.4 2.3.8 1.3 4.9-2.2 4.6-3.5z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "m441.3 286.8-1.4-1c-.7-.6-7.2-2.3-8.1 4 0 0-2.4-6.3 1-7 3.5-1 6.2 1 8.5 4m-5-12.8s2.3 5.2 3.2 5.4c.9.3 1.5-.6 1.5-.6s-3.1-4.6-4.8-4.8zm-1.8-7.9s-2-6.6-4.4-4.8c-2.4 1.7-1.8 6.5-1.8 6.5s-4.7-5-2-8.8c2.8-3.9 8.2.4 8.2 7.1z"
            }),
            /* @__PURE__ */ jsx89("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M439.9 279.8s0 1.3.9 1.6c.8.4 2.5 1 2.5.3s-1.3-3.7-1.8-3.3c-.5.4-1.4.4-1.6 1.4z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M438.4 272s-.3-5.7 3.5-7.9c0 0 .7.2 1.1-1 0 0-3 7.3-2.1 11l-.1.4"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M439.1 265s6.8-14 15-9.1c0 0-8.6 1.7-11.7 7.9l-3.1 4.6z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M435.5 270.1s-2-9.4-3.3-10.6c-1.2-1.3-3.3-2.6-5.9-.5 0 0 4.4-3.9 9-.6 4.7 3.2 3.7 8.4 3.7 8.4l-.5 6.5-3.1-2.9"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M442.8 281.3s-8.3-15.7-13.7-4.5c0 0-1 2.9.1 4 0 0-3-2.3-1.6-7.8s10.5-3 13.2 1.5c2.6 4.5 3.3 6.8 3 7-.4.3-1-.2-1-.2zm23.3 4.5s6-12.4 9.5-6.8c0 0 1 2.8-.5 4 0 0-2.4-3-4.5.6-2.2 3.5-1.3 3.2-1.3 3.2s-2.2.6-3.2-1z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M475 283s3.3 1.7 2.2 5.2c0 0 4.4-8.4-1.6-9.2 0 0 1.1 2.7-.5 4zm.5-8.6s7.9 2.3 8.1 5.7c0 0 1.4-6.6-3.1-8.6 0 0-5.4 1-5 3z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M479 264c3.4-6.6 7.6 2.1 7.6 2.1s1.5-6.9-2.7-8.1c-4.3-1.3-7 14.7-7 14.7l-5 1s1.3-13.8 8.8-15h1"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.5,
              d: "M473 268s-4.8-9.8-8-10.8 1.7-2.5 3.7-.6 5.8 4.3 5.4 9.3zm-5 13.4s1.4-6.6 5.2-8.6c3.8-2 7.3-1.3 7.3-1.3s-4.5 1-5.3 3.3c-.7 2.2-2 2.4-2 2.4z"
            }),
            /* @__PURE__ */ jsx89("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M466 285.8s-2 4-1.6 4.6c0 0-2.2 3.3-1.3 5 0 0 2.2 1.7 3.2 1 0 0 2.6-3.7 1.9-5.7 0 0 1.8-2.4 1.1-3.9 0 0-2.6.1-3.2-1z"
            }),
            /* @__PURE__ */ jsx89("path", {
              fill: "#000001",
              stroke: "none",
              d: "M455 278.6c.2.1 1.5.7 2.3.4l.6-.5-.5-.2c-.3.6-1.7.1-2.1-.1l-.2.4zm-.1 4-.2.5c.1 0 2.7.5 3.9-.6l-.4-.4c-1 .9-3.3.4-3.4.4zm-.7 4.4-.3.4s3 2.1 4.9-.2l-.5-.3c-1.5 1.9-4 .2-4.1 0zm-11.5.6.1.3c.1 0 2.6-1 2.8-2.9h-.3c-.1 1.6-2.5 2.6-2.6 2.6m1.4 2.3v.3c.2 0 2.5-.2 2.9-1.8h-.3c-.4 1.3-2.5 1.5-2.6 1.5m.5 2.4v.3c.1 0 2.7.1 3.6-1.3l-.3-.2c-.8 1.3-3.3 1.2-3.3 1.2m19.7-1.7s1.1 1.2 2.4 1.1a2.3 2.3 0 0 0 1.7-.8l-.4-.4c-.4.5-.8.7-1.3.7-1 0-2-1-2-1z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs82("g", {
          fill: "#964b36",
          stroke: "#000",
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx89("path", {
              d: "M542 299.8a1.1 1.1 0 0 0-.3.3l.4-.3zm9.3-2.3c-.1-.2-.2-.1-.3-.2l-.4-.8h-.3l-.7-1.4a.4.4 0 0 0 0-.3 7.6 7.6 0 0 0 0-.4s-.2 0-.3-.2v-1.6l-.1-.5a2 2 0 0 1-.3-1.1v-1c.1-.4-.1-.6-.1-1l.1-.9v-5.4l-.1-1-.1-.4v-1.6 2.6l-.2-4.3-3.4-1.6s-.3 6.2-.2 7c0 .9.4 6.7.2 7.4l-.5 4.3s-1.6 1.2-2.2 2.4c-.7 1.3-.5 1.7-.7 1.7l1.5-.2-1.1.8a.7.7 0 0 1 .7.1l.2.2.2-.2c.3 0 .5.4.7.3l.4-.2.2-.4c.1-.1.3 0 .4 0h.7c.3 0 .6-.5.9-.7.2-.2.4-.3.7-.3.3 0 .6.3 1 .3.2 0 .3 0 .5-.2l.4-.6.8-.1.4.1h.6l.3.2.2-.4z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M544.5 299.7h.6v.2a.2.2 0 0 0 .2 0l.3.2h.3l.4.1c.2.1.4 0 .6-.1.2-.2.3 0 .6.2.1.1.1.1.2 0l.1-.1.3-.1.3-.1.4-.2.4.2a.8.8 0 0 1 .2 0l.7-.5c.3-.2.5 0 .7 0h.3c.1-.1.2 0 .4 0 0-.1 0-.2.2-.3l.7.4c.1.1.7.2.6-.2 0-.4-.4-.1-.5-.4v-.6a.7.7 0 0 0-.3-.4c-.2 0-.2.1-.4 0l-.2-.6-.3.2c-.2 0-.2-.1-.3-.3-.3-.3-.4.2-.7.1-.2 0-.4-.5-.5-.7-.1-.1-.3-.5-.5-.4-.2.1 0 .5 0 .7h-.5c-.2 0-.2 0-.3.2-.2.4-.3.7-.7.6-.1 0-.3-.1-.4 0l-.5.2a1 1 0 0 1-.4 0l-.4-.4a.1.1 0 0 0-.2 0 8.7 8.7 0 0 0-.1-.2c-.2 0-.2 0-.3.3l-.1.5-.3.4-.4.1c-.2 0-.4.3-.4 0-.2-.4.3-1.1-.2-1-.1 0-.2 0-.3.2v.7c-.1.3-.7.8-.6 1 0 .3.4 0 .4 0l.2.4c.2.3.7-.4.7 0m-2.1-2.7v-.2l-.4-.1c-.2 0-.4.3-.5.4-.2.4-.2 1-.6 1h-.5v1s-.2 0-.2.2c-.1.4.2.2.4.2h1l.5-.1c.2 0 .4 0 .5-.2a2.2 2.2 0 0 0 .2-.4v-.4c0-.2.3-.1.3-.4.1-.7-.6-.2-.5-.9"
            })
          ]
        }),
        /* @__PURE__ */ jsxs82("g", {
          stroke: "#000",
          strokeWidth: 0.5,
          children: [
            /* @__PURE__ */ jsx89("path", {
              d: "M550.8 277.9c0 .9-.6 1.6-1.4 1.6-.7 0-1.4-.7-1.4-1.6 0-.9.7-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6zm-4.5-2c0 .9-.6 1.6-1.4 1.6s-1.4-.7-1.4-1.6c0-1 .7-1.6 1.4-1.6s1.4.7 1.4 1.6z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M548.7 276.5c0 1-.6 1.6-1.4 1.6-.8 0-1.4-.7-1.4-1.6 0-.9.6-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M546.4 278c0 .9-.6 1.6-1.4 1.6-.8 0-1.4-.7-1.4-1.6 0-.9.6-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M548.5 279.3c0 .8-.6 1.6-1.4 1.6-.7 0-1.4-.7-1.4-1.6 0-1 .7-1.7 1.4-1.7.8 0 1.4.7 1.4 1.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M549.2 261.5s13.9-19.4 28.8.7c0 0 .1 2-1.3 4.2l-.3-1.7-1 .3-.2-1-1.6-.1.5-2.2-1.7 1.4.2-1.5-2 2 .3-4.3-2.2 3.7.3-2.5-.8 1.1-.4-1.5-.7 1.5-1-.7v1l-1.8-1.5-.6 2-.9-2.2-.2 1.5-.9-1.7-.1 1.9-2.9-1.3.6 1.8-1.3-1 .2 1-1.9-.4.2 1.1-2-.4.3 1-2.7-.3 1 1-.3.6s15-5 16 13.8l-2.7 1.3.8-1.5-.8-.5-2.3-1.7.7-2.4-.8.3-.1-1.4-.4.2-.9-1.3-.2.5-.6-1.7-.7 1.2-.3-2.8-1 1.8-.2-1-.3.6-1.3-1.5-.4 1-.5-.8-.3 1-1.4-1.4v1l-1-.7-.3.5-2.1-1.1-.1 1-1.2-1-.3 1s13.6 7.8 9.4 20.4l-.8 1.6-.2-4.2-1.3 2.2.9-4.9-.9 1-.1-2-1.1 2-.4-2.2-.5.6-.8-3.2-.6 1.3-1-3.6-.8 1.5-.5-3.1-.5 1.9-1.5-2.8-.2 1.1-.9-2.2-.5.7s-2.5-.1-3.3-.7c-.7-.7-2.8 3.7-2.8 3.7l.2-2.6-.9 1.8v-1.8l-1.6 5.3-.4-3.8-.8 3.3-.4-1-.3 1.3-.5-.5-.4 1.5-.8-.6v2l-.8-1-.6 3-.4-1.2v1.3l-.6-.7-.6 3-1-1.3v2.2l.3 1.6-1-.5.4 2.6s-3.9-7.2.8-14.2c4.6-7 10.9-9 10.9-9l-.7-.6v-.6l-3.8 1.9v-1.1l-1 .8-.2-1.2-.6 1.1-.1-.5-1 1.4-.4-2-.6 2.4-.6-1.7-1.3 3.5V270l-1 2.8-.4-3-.7 3.4v-3l-1.2 3-.7-3-.5 3-.8-2.3-.7 3.4-1.2-3-.6 4.5-.7-1.8-.2 3.3-.8-2 .8 4.2-1-1.6.3 2.6-1.6-2.9v3.4l-.8-1.1-.4 1.3s-.3-13 8.6-15.6c8.9-2.5 14.6.8 14.6.8l-3.4-2.8.4-.9h-1.2l.5-1-2.7.1.8-1-2 .3v-.6l-1.3 1 .5-1.2-1.7 1.2-.1-1.7-1 1.4-.4-1.5-4 4 1-4.1-.7.9-.1-1-1.1 1.8-.3-1.2-.5 1.5-.4-1.8-.8 1.8-1-1.6-.3 2.1-.6-1.1-.8 1.6-1-1v1l-2-.9.4 1.5-1.5-1.2-.4 2-.8-1-.7 2.5-.6-2.4-.6 1.9s7.8-20.2 27.6-7c0 0 2.2 2.1 2.7 3.6s.1.2.1.2l-.4-13.9.8 6 .5-2-.1 3 2-4.3s-2.4 7.2-1.5 9.9c0 0 .9-8.4 3.9-9.4l-2.8 6 .9-.1-.6 1.2h.7l-.9 2-.5 1 .5 1z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m547.1 269.6.4.4s1.3-1.4 3.4.4l.3-.4c-2.5-2.1-4-.4-4-.4zm-.6-6.8v.5l.9-.4-.7 1.2 1.5-.5-1.8 2.3.4.3 2.9-3.7-1.8.6.8-1.3-1.6.6.3-1.9h-.5z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m543.9 263 .6 1.3-1-.4 2.9 5.2.4-.5-.6 1.5.5.2 1.2-3.2-.4-.3-1 1.3-1.8-3.1.8.3-.8-1.7 1.1.6v-1.9h-.5v1l-1.8-1.1zm-1.9 6.4.2.5c.8-.3 1.5-.4 2-.2.5.3.7.9.7 1l.5-.2s-.2-.9-1-1.2c-.6-.3-1.4-.3-2.4.1m2.3 5.4-.5-2.8h.6l.4 2.7zm3.8-.4-.7-2.2.5-.1.7 2zm1.4 1.5-.5-2.1.5-.1.6 2.1z"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M442.6 340.2s-2.4-1-3.5-.2c-1 .7-.9 1.9-1.8 1.8 0 0 3.6.8 4.3-.1l1-1.2m.4.7s-1.6 2-1 3.3c.5 1.2 1.7 1.3 1.4 2.2 0 0 1.5-3.3.8-4.3s-1-1.1-1-1.1m-2.8-5.8s-2.5.8-2.8 2c-.2 1.4.6 2.1-.1 2.7 0 0 3.2-1.8 3.1-3v-1.5m1.2.7s1.2-2.3.5-3.4c-.8-1.2-2-1-1.8-2 0 0-1 3.5 0 4.4l1.1 1m-2.2-.9s0-2.6-1-3.2c-1.2-.7-2.2-.1-2.5-1 0 0 .7 3.6 1.8 4l1.5.3m4.4 4.2s2.7-1 3 2c.2 3-.2 2-.2 2s-1.4-3.2-3-3.7z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m443 341.3.2 2.2h.4l-.3-2.2 1-4.9h-.4l-1 4.9z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m440.5 340.6-.1.3c1.3.5 3-1 3.1-1l-.2-.3s-1.7 1.3-2.8 1m3.4-2.9-6-3 .2-.5 6 3z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m439.5 337-.4-.4 1.2-1.2.4.4zm2.1-.6-1.3-2.8.5-.2 1.3 2.8zm1.8 3.4v.6c1.7-.1 2 1 2 1l.6-.2c0-.3-.7-1.5-2.6-1.4"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M471.2 341c2-1 2.4-5 2.4-5-.5 1.4-4.2 2.9-4.2 2.9 2.7-1.7 6-9.4 6-9.4-.8 2.7-8 5-12.6 7.6-4.6 2.6-2.2 10-2.2 10-1.3-.9-3.8-4.8-4.3-8.3-.5-3.5-1.8-4.9-5-5.3-3.1-.4-5 3.2-5 3.2l-4.7 2.4 4.8.2s3.4 1.1 3.4 3.8c0 2.6-3 13.3 2 19.3 3.3 4.1 16 6.5 16 6.5"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M461.9 349.3s1-4.8 4.1-4.6c3.1.2 4-3.6 5.9-4.1 1.9-.6 11.5-3.2 12.5-7.8 0 0-.9 7.6-9.7 11.4 0 0 7.1-2.3 8-3.9 0 0-3.2 6.8-10.9 7.9 0 0 7.2-.6 8.2-2.5 0 0-3.2 4.2-8.5 4.8 0 0 5 2 6.2.3 0 0-2.7 3.2-6 3.4l1 .2s-3.2 3.8-6.7 1.3-3.6.6-3.6.6"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M469 356.5s4.1 6.8 4.5 10.4c0 0 7.8 8.5 10.7 9 0 0-1.4.6-4-1.5 0 0 2.2 2.2 2.6 2.3.4 0-1.7-.2-2-.8a6 6 0 0 0 1.4 1.5l-.5-.2s-1-.1-1.6-.5c-.5-.4-.1 1-.1 1s-1.2-.3-1.6-.7c-.4-.4.1.9.1.9l-1-.3-.8.5s0 .5-.5 0c-.5-.3-1.4 0-1.4 0s-.6.6-1 .2c-.3-.4-1.5 1.6-1.5 1.6l-5-12.3"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m473.9 378.7-6.4-12.2.6-.4 6.4 12.3zm5.6-.8-11-12.3.6-.5 11 12.3zm2.5-1L469.5 365l.5-.5 12.5 11.7z"
        }),
        /* @__PURE__ */ jsxs82("g", {
          transform: "translate(-96.9 97.5) scale(.66486)",
          children: [
            /* @__PURE__ */ jsx89("path", {
              d: "M823.4 360.8s-1.2-2.2-2.3-1.3c-1 .8-1.6 1-1.8.9 0 0 1 0 1.7-.5.6-.6 1.6-.3 2.4 1zm-6.6-1 .7 1.4-.8 2.3.6.2.7-2.5-.7-1.6z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M823.2 360.5s-1 1-2.2.8l-1.3-.3h1.8c.7 0 1.6-.3 1.7-.5"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M822.9 360.7s-1.2-1.2-2-.8c0 0 1.4-.5 2.2.7z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M822.7 360.5s-1.3.9-2.7 0l-.1-.2h.2s1.7.7 2.6.2"
            }),
            /* @__PURE__ */ jsx89("circle", {
              cx: 821.6,
              cy: 360.3,
              r: 0.4
            })
          ]
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "M450 359.6s-.7 1.2-.3 2c.3.7 2 1 2.1 2 .2 1 .8 1 1.5 1l.9-.3s-3.1-1.6-4-4.3z"
        }),
        /* @__PURE__ */ jsxs82("g", {
          fill: "#964b36",
          stroke: "#000",
          strokeWidth: 0.5,
          children: [
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.3,
              d: "M549.4 334.8s5.6-7.4 10.6-5.5c5 2 8.1 3 8.1 3s.1 4.9-2.5 4.9-5.2-5-7.6-3.5a13 13 0 0 0-4.5 4.2c-.1.7-6.3.8-4.1-3.1z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M528.2 370.4s-1.6 1.6-.9 2c.7.4 2.1 0 2.1-.6s-1-1.6-1.2-1.4z"
            }),
            /* @__PURE__ */ jsx89("path", {
              d: "M527 372s-3-1.7-5.2 2.2c-2.3 3.8-4.1 10.1-5.4 11-1.3.8 12.8-6.2 13-9.2 0 0 .9-3.8-.6-3.7-1.5 0-1.6.2-1.9-.4z"
            }),
            /* @__PURE__ */ jsx89("path", {
              strokeWidth: 0.3,
              d: "M527.3 372.4s-3 .7-3.6 4.9c-.6 4.2-4.7 6.3-5 6.5m49.4-51.6s-4.4 1.6-3.7 4.7"
            })
          ]
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#fff200",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M533.7 341.3s.2-10.6 8.9-10.2c1.6.2.8 2.1.8 2.1s2-1.3 2.8.8c0 0 2.7-1.2 3 1.5 0 0 3-.4 2.6 2 0 0 2-.5 2 1.2 0 0 2.3-.9 2 1.5 0 0 2.6-1.7 2.3 1.4 0 0 2.6-1.9 3.5 1.2 1 3.2-2.6 9.8-6.1 11.5"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "M557.9 342s1.1 8.2-3.5 11.3l.1.2c4.9-3 3.7-11.5 3.7-11.6h-.3zm-5.7 9 .2.2c3-2.9 3.7-10.6 3.7-11h-.3s-.7 8-3.6 10.8m-2.7-1.9h.3a26 26 0 0 1 4.1-10.3l-.2-.1s-3.8 5.5-4.2 10.4m-2.2-1.4h.3c.5-5.7 4.4-10 4.4-10.1l-.2-.2s-4 4.5-4.5 10.3m-3-2h.3c.3-6.7 4.8-10 4.8-10l-.2-.3s-4.6 3.4-5 10.4zm-2.8-1.6h.3c-.2-6.2 4.5-10 4.6-10l-.2-.2s-5 3.8-4.7 10.2m-5-2.3h.3a10.2 10.2 0 0 1 6.8-8.4v-.3a10.5 10.5 0 0 0-7.1 8.7"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M528.6 354.2s-1.5-9.9 4.4-13c0 0 1.1-.2 1.7 1.2 0 0 3.1-1.3 3.2 1.3 0 0 1.6-1.2 2 .5 0 0 3.3-.7 2.7 1.8 0 0 2.8-.8 2.5 1.6 0 0 2.8-1 2.4 1 0 0 3-.6 2.2 1.8 0 0 3.7-.4 2.6 2.1 0 0 2.7-.7 2 1.4 0 0 3.6.7 2 3a24.1 24.1 0 0 1-9.8 7"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M525.4 364.1s-2.4-8.2 2.2-10.3c0 0 .9-.2 1 .6 0 0 1-1.3 1.8-.1 0 0 2.3-1.1 2.9.6 0 0 1.5-1.3 2.3.6 0 0 1.5-.6 1.5 1 0 0 2-1 2 1 0 0 2-.8 1.5 1.2 0 0 3 .5 2.1 1.9 0 0 2.7.7 1.7 1.8 0 0 2.8-.3 1.3 1.6 0 0 2.2-.7 1 1.7-1.3 2.4-5.2 5-8 5.4"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M528.3 370.6s-5.1-5-2.7-6.4c0 0 1 .3 1.5 1.4 0 0 1.2-1.8 2 0 0 0 1.8-.6 1.8.7l1.4 1s1.7-.1 1.4 1c0 0 1.9-.3 1.8.7 0 0 1.6.1 1.5 1.2 0 0 2.8.5 1.5 1.9 0 0-4.8 1-8.3-.4 0 0-1.7-.6-1.9-1.1z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "M545.9 362.4v.3a36 36 0 0 0 8.6-8.7l-.3-.2c0 .1-5.4 7.5-8.3 8.6m-1.8-1.3.2.3c2.6-1.5 7.9-8.5 8-8.8l-.1-.2c-.1.1-5.5 7.2-8 8.7zm-1.5-.6.2.2a48 48 0 0 0 7-10.3l-.2-.1s-4.2 7.9-7 10.2m-1.3-1.8h.3c.5-3.8 6-9.9 6-10l-.3-.1c-.2.2-5.5 6.2-6 10.1m-10.9-4.7h.3c-.4-5.5 4.1-11.5 4.2-11.5l-.3-.2s-4.7 6.2-4.2 11.7m2.9.5h.3c-.8-4.4 4.4-10.6 4.4-10.7l-.2-.2c-.2.3-5.3 6.4-4.5 10.9m4.4 1.6h.3c-.2-5 4.6-10 4.7-10l-.2-.3c0 .1-5 5.2-4.8 10.3m-10.5 9h.3c-1.8-4.7 1.2-10.6 1.3-10.6l-.3-.2s-3.1 6.1-1.3 10.9zm2 .4.3-.1c-1.6-4.7 1-11 1-11l-.2-.2s-2.7 6.5-1.1 11.3m8.3 4.7v.2c5-1.7 8.3-6.3 8.3-6.3l-.3-.2s-3.2 4.5-8 6.3m-1-1.1v.3c4-1.8 7.7-6.8 7.7-6.8l-.2-.2s-3.7 5-7.5 6.7m-1-.4.2.3c3-2.3 7-8 7-8l-.2-.2s-4 5.7-7 7.9m-5-2.9h.4a21 21 0 0 1 2.5-10.9l-.3-.1s-3.2 6-2.5 11zm2.2 1.4.2.2c3.2-2.9 4.3-10.6 4.3-11h-.3s-1 8-4.2 10.8m2.2.8.2.3a17 17 0 0 0 5.7-9.5h-.3s-1.2 6-5.6 9.3zm.5-13.4v.9l-3.4 11 .3.1 3.4-11c-.5-5.4 4.2-11.3 4.3-11.3l-.3-.2s-4.3 5.3-4.3 10.5"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "M539 357.3c0 .2-1.1 7.7-5.2 10.5l.2.3c4.2-2.9 5.2-10.3 5.2-10.7 1.8-2.1 6-9.7 6-9.7l-.2-.2s-4.2 7.6-6 9.8m-12 8.3c0 .1.6 4 1.4 5.2l.3-.1c-.8-1.3-1.5-5.1-1.5-5.2l-.3.1zm1.9 0-.1 5.3h.3v-5.3z"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "m529 371 .3.1c1.3-2.8 1.7-4.8 1.7-4.8h-.3s-.4 1.9-1.7 4.7m.3.1.2.3a6.6 6.6 0 0 0 3-4h-.3s-.6 2.4-2.9 3.7m.5.2v.3c2.4-.2 4-3.1 4-3.3h-.2s-1.6 2.8-3.8 3"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "M530 371.5v.3c3.9-.3 5.6-2.6 5.6-2.7l-.2-.1s-1.7 2.2-5.4 2.5"
        }),
        /* @__PURE__ */ jsx89("path", {
          d: "M530.3 371.5v.3c.1 0 5 1.1 6.7-1.4l-.3-.2c-1.5 2.4-6.4 1.4-6.4 1.3"
        }),
        /* @__PURE__ */ jsx89("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.8,
          d: "M420.9 193.2v136.4c0 44.6 80.6 71 80.6 71s80.5-26.4 80.5-71V193.2z"
        })
      ]
    }),
    /* @__PURE__ */ jsx89("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx89("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx89("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx89("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx89("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Fj_default = SvgFj;

// src/country-flag-icons/generated/Fk.tsx
import { jsx as jsx90, jsxs as jsxs83 } from "react/jsx-runtime";
var SvgFk = (props) => /* @__PURE__ */ jsxs83("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs83("defs", {
      children: [
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__c",
          x1: 444.4,
          x2: 470.9,
          y1: 592.2,
          y2: 577.1,
          gradientTransform: "matrix(-1.08448 0 0 1.26674 909.5 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__g",
          x1: 851.8,
          x2: 646.2,
          y1: 369.9,
          y2: 369.9,
          gradientTransform: "matrix(.85733 0 0 .9624 -161.5 .3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__d",
          x1: 458.2,
          x2: 520.5,
          y1: 562.5,
          y2: 552.8,
          gradientTransform: "matrix(-1.01941 0 0 1.3554 909.5 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__e",
          x1: 472.4,
          x2: 445.3,
          y1: 578.7,
          y2: 580.2,
          gradientTransform: "matrix(1.08448 0 0 1.26674 49.7 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__f",
          x1: 518,
          x2: 456.4,
          y1: 553.7,
          y2: 558.1,
          gradientTransform: "matrix(1.01941 0 0 1.3554 49.7 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs83("linearGradient", {
          id: "fk_svg__a",
          children: [
            /* @__PURE__ */ jsx90("stop", {
              offset: 0,
              stopColor: "#a43907"
            }),
            /* @__PURE__ */ jsx90("stop", {
              offset: 1,
              stopColor: "#fff"
            })
          ]
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__h",
          x1: 388.5,
          x2: 677.4,
          y1: 507.2,
          y2: 508.8,
          gradientTransform: "matrix(.88927 0 0 1.54542 50.4 -413.6)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__i",
          x1: 579.8,
          x2: 556.8,
          y1: 504.9,
          y2: 505.9,
          gradientTransform: "matrix(.91096 0 0 1.52008 49.7 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__j",
          x1: 581.4,
          x2: 558.9,
          y1: 512,
          y2: 514.3,
          gradientTransform: "matrix(-.88927 0 0 1.54542 908.8 -413.6)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__k",
          x1: 552,
          x2: 589.8,
          y1: 517.9,
          y2: 503.9,
          gradientTransform: "matrix(-.91096 0 0 1.52008 909.5 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx90("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__b",
          x1: 444.4,
          x2: 470.9,
          y1: 592.2,
          y2: 577.1,
          gradientTransform: "matrix(.85733 0 0 .9624 -162.4 -.6)",
          gradientUnits: "userSpaceOnUse"
        })
      ]
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#012169",
      fillRule: "evenodd",
      d: "M0 0h400v200H0z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__b)",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 10,
      d: "M412.9 308.9a11.3 12.7 0 0 0-1.7 0c-3 .6-7.6 11.3-10 17.6-4.1 5.4-6.2 9.6-7.8 12.7-.7 1.2-1.7 2.6-1.4 4.2-6 1.6-6.3 7.4-6.3 9.6 0 2.5.7 3.7.7 3.7l3.6 7.5v.1c3.8 9 9.4 20.9 12.7 21.8 4.4 1.5 16-3.3 24.8-11.7a140.6 157.8 0 0 0 53.2 12.1c20.4 0 38.7-5.5 53-12.1 8.8 8.4 20.4 13.2 25 11.7 3-1 8.7-13 12.6-21.8l3.5-7.6s.7-1.2.7-3.6c0-2.2-.3-8-6.3-9.6.3-1.6-.6-3-1.3-4.3-1.7-3.2-3.8-7.4-7.7-13-2.6-6.2-7.2-16.7-10-17.2-4.2-.8-13 1.5-13 2.4v.4l-17.7 18.6c0 .5.9 14 4.3 26a126 141.5 0 0 1-43.3 8.2c-17 0-31.5-3.4-43.2-8.3a116.6 130.9 0 0 0 4.3-26L424 311.8v-.4c0-.7-6.8-2.5-11.1-2.5zm4.4 23c2.3 0 4.6 2.2 6.5 4.4l-.1 1.3a67.5 75.7 0 0 1-2.8 10.2 73.6 82.6 0 0 1-12.2-9.9c1.9-2.3 5-5.4 8.2-5.8h.4zm126.6 0h.4c3.3.6 6.3 3.7 8.3 6a73.4 82.4 0 0 1-12.3 10 67.1 75.4 0 0 1-2.8-10.3 14.6 16.4 0 0 1-.2-1.3c2-2.3 4.3-4.3 6.6-4.3zm-142.4 26.4c2.4 2 5.4 4.4 9.1 6.8a10.5 11.8 0 0 1-3.2 1.6c-1.6.4-3.1.3-4.7 0a15 16.8 0 0 1-1-5.6 60.3 67.7 0 0 1-.2-2.8zm158.2 0-.1 2.8a15 17 0 0 1-1 5.5 10.3 11.5 0 0 1-8-1.5c3.7-2.4 6.8-4.8 9.1-6.8z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__c)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M426.2 339.6s-6.1-11.1-11.1-10.2c-5.1.7-10 7.8-10.2 8.2a44.5 52 0 0 1-7.5-9.5c.3-.4 7.8-20.9 12-21.8 4-.9 12.7 1.5 12.7 2.3z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__d)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M439.8 327.7c0 .8-2.2 30.2-10.9 40.4-8.6 10.3-23 16.6-28.2 15.1-5-1.6-16.5-31.3-16.5-31.3s12.2 14.2 21.3 11.8c9.1-2.3 14.6-20.1 16.3-28.9 1.7-8.6.3-25.7.3-25.7l17.8 18.6z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__e)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M532.9 339.6s6.2-11.1 11.2-10.2c5 .7 9.8 7.8 10.2 8.2a44.5 52 0 0 0 7.5-9.5c-.4-.4-7.9-20.9-12-21.8-4.1-.9-12.8 1.5-12.8 2.3z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__f)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M519.3 327.7c0 .8 2.2 30.2 10.9 40.4 8.7 10.3 23 16.6 28.2 15.1 5-1.6 16.6-31.3 16.6-31.3s-12.3 14.2-21.4 11.8c-9-2.3-14.5-20.1-16.2-28.9-1.8-8.6-.4-25.7-.4-25.7z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__g)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.5,
      d: "M401.2 326.2c-4 5.5-6.1 9.8-7.9 13-1.7 3.2-.6 7.7 3.2 14 4.3 6.7 39 33.4 84.1 33.4 45.2 0 79.8-26.6 84-33.4 4-6.4 5-10.8 3.3-14-1.7-3.2-3.9-7.5-7.9-13 0 8.3-28.7 38.5-79.4 38.5s-79.4-30.2-79.4-38.5z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__h)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m557.7 378.8 7.8-15.1-3.9-3.2c-1 3.8-5.5 5.1-6.3 10-.7 4.7 3 9.4 2.4 8.3z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__i)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M564.8 374.5s1.4-6.8-3-7.6c-4.4-.8-6.8 3.8-6.1 2 .6-2 3.2-4 3.7-10.7.3-6.7-.4-10.3-.4-10.3s1.8-8.7 8.8-7.5c7.2 1.3 7.5 7.6 7.5 9.9a9 9 0 0 1-.6 3.5z"
    }),
    /* @__PURE__ */ jsx90("path", {
      d: "m539.2 351.7 1.5 2.8 1-.6-.7-2 .1-.3 1.7-1.2 4.4 8.7v.5l-1 .7.5.8 4.2-3-.4-.8-1 .6h-.3l-4.4-8.8 1.6-1.2h.4l1 1.6 1-.7-1.5-2.8-8 5.7zm-10.5 6.7.4.8.9-.4.3.1 3.9 8.9-.1.4-.8.6.3.8 4.1-2.5-.3-.8-.9.4h-.4l-1.8-4.3 4.3-2.4 1.8 4v.5l-1 .6.4.9 4.2-2.5-.4-.8-.9.4-.3-.2-3.8-8.8v-.4l.8-.6-.3-.8-4.1 2.5.3.8 1-.5.3.2 1.5 3.6-4.2 2.5-1.6-3.7.2-.4.8-.5-.4-.9zm-2.4 7.6.2.8 1.2-.3.4.1.9 3.7-.8.4c-2.5.8-4.4-.5-5.3-3.7-.8-3.2.2-5.6 2.5-6.4a3.5 4 0 0 1 1.4-.1l.3.2.8 1.7 1.2-.4-.7-3c-1.3 0-2.5.2-3.5.6-3.6 1.3-5.2 4.5-4.3 8.2 1 3.7 3.9 5.4 7.2 4.3a11.3 12.7 0 0 0 3.4-2L530 366l.2-.4.9-.4-.3-.9zm-9.7 10.3 4.7-1.7-.3-.9-1 .2-.3-.1-2.6-9.6.1-.3 1-.5-.2-.8-4.7 1.6.3.9 1-.3.4.2 2.5 9.5-.2.4-1 .4.3.9zm-25.5 4.6 8.3-.8-.3-3.4-1 .1-.2 2-.2.3-3.5.4-.4-4.9 2-.2.3.3.2 1.3h1l-.4-4.4h-1v1.4l-.2.4-2 .1-.4-4.4 3.1-.3.2.2.4 1.7 1.1-.1-.2-3-7.8.8v.9h1l.3.3.7 9.9-.1.3-1 .2v1zm-12.4-12.3v1h1l.2.3.1 9.9-.2.3-.9.2v.8h4.4v-.9h-1l-.2-.4V375h4.4v4.6l-.2.3-.9.1v1h4.4v-1h-1l-.1-.4-.2-10 .2-.3h1v-1h-4.5v1l1 .1.2.3v4l-4.3.1-.2-4 .3-.3h.9v-1zm-9.4-.3v3.3h1l.3-2 .2-.3h1.9v10.2l-.3.4h-1v1h4.6v-.9l-1-.1-.3-.4.1-10h1.8l.3.2.3 2h1v-3.3zM455 378.9l8 .4.2-3.3h-1l-.3 1.9-.2.2-3.5-.1.2-5 1.9.2.2.3.2 1.4h.8l.2-4.3h-.9l-.2 1.2-.2.3h-2l.2-4.6 3 .2.2.2.1 1.7h1.1v-2.9l-7.5-.4v.9l1 .2.1.3-.4 9.9-.2.3h-1v.9zm-18.6-5.4 4.4 1.6.2-.8-1-.5v-.4l2.5-9.5.3-.2 1 .3.2-.8-4.3-1.7-.2.9.9.4.2.4-2.7 9.4-.2.3-1-.3zm-7.6-3.3a8.4 9.4 0 0 0 2.6 1.6c2.4.8 4.3-.2 4.8-2.2a3 3.5 0 0 0-.5-3.2l-1.8-2c-.6-.9-.8-1.6-.6-2.5.3-.9 1.1-1.4 2.2-1 .4.2.8.4 1 .7v.3l-.2 2 1 .3.8-2.8a8 9 0 0 0-2.5-1.7c-2-.8-3.8.3-4.4 2.2a3.2 3.5 0 0 0 .4 2.8c.4 1 1 1.5 1.5 2 .9 1 1.2 2 1 2.9-.3 1-1.2 1.5-2.4 1a4 4.5 0 0 1-1.2-.8l-.1-.3.4-2.2-1.1-.4zm-9.8-4.6 7.4 4 1.2-3-1-.5-.9 1.7-.3.1-3.1-1.8 1.8-4.3 1.8 1v.3l-.3 1.3.8.5 1.6-4-.8-.4-.7 1.1-.3.2-1.7-1 1.6-4 2.7 1.5.1.3-.4 1.6 1 .5 1-2.6-6.8-3.9-.4.8.8.6.1.4-3.6 9h-.3l-.9-.3zm-1.1-15-3.7-2.9-.5.8.7.7.1.4-4.6 8.2-.4.1-.7-.5-.5.8 3.6 2.8c1.4 1 2.5 1.5 3.6 1.4 1.6-.2 3-1.2 4-3 1.8-3.4 1.3-6.6-1.6-8.8m-1.6 0 .8.6c2 1.5 2.2 3.7.5 6.6-1.7 3-3.5 3.6-5.4 2l-.8-.4 5-8.7zm29.3 13-.1.8.9.3.1.4-1.7 9.7-.3.2h-1v.8l4.1 1 .2-.8-1-.4-.1-.3.7-4.1h.3c1.5.4 1.8 1.3 1.8 3.2.1.9.1 1.7.8 2.7.3.4.7.8 1.4.9a10.1 11.4 0 0 0 1.5.2l.1-.8h-.1c-1-.3-1.5-.7-1.5-1.8-.2-1 0-2-.4-3a2.6 2.9 0 0 0-1.3-1.4c1.7 0 2.7-.9 3-2.5.4-2-.5-3.5-2.9-4zm3 1.7.6.2c1.4.4 2 1.4 1.7 2.9-.3 1.7-1.2 2.3-2.8 1.8l-.5-.1.9-4.8zm54.2 1 .1 1h1l.3.2 1.4 9.8-.2.3-1 .3.2.8 4.5-.8v-1l-1.1.2-.3-.3-.6-4h.3c1.6-.5 2.2.2 3 1.9.3.8.5 1.6 1.5 2.2.4.3 1 .4 1.8.3a12 13.6 0 0 0 1.6-.5l-.1-.9h-.2c-1.1.3-1.7 0-2.2-.9-.4-.8-.7-1.8-1.3-2.5-.4-.5-1-.8-1.8-.8 1.7-.8 2.5-2 2.3-3.7-.3-2-1.7-3-4.2-2.5zm3.5.5h.7c1.6-.4 2.5.2 2.8 1.8.2 1.6-.5 2.6-2.2 3h-.6l-.8-4.8z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__j)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m401.5 378.8-7.8-15.1 3.9-3.2c1 3.8 5.5 5.1 6.3 10 .7 4.7-3 9.4-2.4 8.3z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "url(#fk_svg__k)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M394.3 374.5s-1.4-6.8 3-7.6c4.4-.8 6.8 3.8 6.2 2-.7-2-3.3-4-3.7-10.7-.4-6.7.3-10.3.3-10.3s-1.7-8.7-8.8-7.5c-7.1 1.3-7.5 7.6-7.5 9.9 0 2.2.7 3.5.7 3.5z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#0072c4",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 3.9,
      d: "M480.5 356.1s-82-27-81.4-129.4l.6-135.6H561l.6 134.8c.5 102.4-81.4 130.1-81.4 130.1z"
    }),
    /* @__PURE__ */ jsxs83("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx90("path", {
          fill: "#bcbcbc",
          d: "m410.3 123.6 2-2c1.3-.8 2.4-1.7 3.7-2.4 1-.6 3-1.1 3.7-1.6a9.2 10.3 0 0 0 3-2.8c.2-1.7.5-3 .5-5a12 12 0 0 1 3.6-2c1.7-.6 2-1.4 3.8-1.7 1-.4 2.8-.4 4.4-.4 1.6 0 2.7 1.4 4.2 1.6 1.8.8 2.6 1.4 4.1 2.8a7.5 7.5 0 0 0 2.6 3c1.1.6 2.2 1.6 3.4 2 1.5.9 2.7 1.4 3.8 2.8 1 .8 1.4 2 2.3 2.7a26.5 29.7 0 0 0 3.4 2.8c1.5 1.1 3 2 5.2 1.7 1.3 0 2.6-.3 4 0 1.8 0 3.4 0 4.8.5 1.8 0 3.2.2 4.8.4 1.5.2 3 .3 4.7.3 1.5.5 3 .4 4.8.4h9.5c1.7 0 3.4.1 4.7.4a37.4 42 0 0 0 4.7-.4c1.9 0 3.3-.3 5-.4h5.8c1.5.5 3.4.8 4.4 1.7 1.4.4 2 1.1 3.4 1.5a11 11 0 0 1 3.4 2.8 18.1 20.3 0 0 1 2.7 4.4c1 1.5 1.3 3.3 2 5.2.4 1.8.7 3.5.7 5.5.4 1.7.3 3.6.3 5.6-.3 1.8-.4 3.8-1 5.5 0 2-.4 3.7-.7 5.2-.2 1.6-.6 2.7-.7 4.7v5.6c0 1.8-.4 3.2-.6 5.1a52 58.4 0 0 0-2.4 6 10.8 12 0 0 0-2.7 3.2c-.7.5-1.1 1.3-1 1.6 1.4.5 1 1.6 1 3.5l.7 5.2c.1 2 .5 3 1 4.4.6.8.7.4-.7.4-1 .8-2 .4-2.3-1.2a8.8 9.9 0 0 1-1.4-4.4c-.2-1.8-.5-3.6-1-4.8-.2-2.2-.7-2.2-2.7-2.4-1-.9-2.2-1.1-4-1.1-2 0-2-.2-2 2v5.6c-.4 1.6-1 2.8-1.5 4.3-1 .8-1.4 2.2-2.7 3.2-.5 1.8-1.4 2-3 2.4l-2-2.8c1-1.8 1.7-2 2.3-4 .8-1.6 1.2-2.6 1.7-4-.7-1.2-1.3-1.8-2-3.5a19.3 21.6 0 0 1-1.7-4.4c-1.1-.4-2.9-.5-3.7-1.2-1.7-.4-2.1 1.7-4 1.7h-4.8c-2.1 0-2.6 1.2-4.4 1.1-.5.2-1.8 0-3.7 0-1.5.6-3.2.4-4.8.4-1.7 0-3-.5-4.4-.8-1.5-.5-3-1-4.7-1.2-2 0-2.7.2-4 1.2-1 .7-2.6 2.3-3.7 3.2-.5 1.3-.8 3.5-1.5 5.1-.3 1.7-.9 2.6-1.2 4a13.5 15.1 0 0 0-1 4.8c-.2 2.6-.7 2.3-2.1 1.6-.6-1.2-1.5-2.3-2-3.6.2-2 .7-3 .7-5.1-.4-1.7-1.1-1.5-2-.5 0 2.1 0 3.7-.8 4.8a4.4 5 0 0 1-2 3.1 4.7 4.7 0 0 1-2.7 2.8c-.2 0 0-.5 0-1.6-.8-1.7 0-3.3 0-5.5 0-2-.2-3.3.4-5.1 0-2-.8-3.8-1-5.2-.7-1.5-1.1-2.2-2.8-2.8-1.2-.6-3-1.2-3.7-2.5a7 7.9 0 0 0-3.1-2.7c-1.5-.6-2.3-1.2-3.4-2-1-1.3-1.9-1.8-2.3-3.5-.7-1.2-.8-3.5-1.3-5.2a15.9 17.8 0 0 0-1-4.7 17.8 20 0 0 0-1-4.8l-1.1-5.2c0-1.9 0-3.8-.4-5.5v-5.6c-.2-1.7-.3-4-.6-5.2 0-2.1-.3-3.3-.8-4.8-.7-1.4-.7-2-2-2.3-.8 1.2-2.2 1.8-4 2-1.2-.3-3-.6-4.4-1.2-1.4-.4-2.2-1-3.3-1.7a31.7 35.5 0 0 0-2.1-3c-.2-2.1-.6-3.2-.7-5.3 0-1.5 0-.6 1.4-2.7"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#fefefe",
          d: "m430.3 138 .3-.4c-.6.7-.4.3 1-.3.6-.4 2-1.4 2.5-2 .6-.3 1.7-.7 2.2-1.3.6-.8 1.3-1.5 2.2-2.2.9-1 1.7-1.3 2.8-2 1.3-.2 1.9-.8 3.1-.3 1.2.3 1.7.3 2.6-.9 1-.6 2.1-1.4 2.5-2.4v-1.8c0 1.8-.4 2.5-1.5 3-.7 1.1-1.8 2.2-2.2 3.2-.7 1.2-.9 1.9-1.6 2.5-.7.9-1.7 1.4-2 2.8.4.7 0 1 .8 1.1.7.7 1.4.4 2.4 0a10.4 11.7 0 0 0 1.9-3.3l1.7-2.9c.8-.6 1.3-1.1 1.6-2.2 1-.6 1.8-1.3 2.5-2 .7-.4 1-.9 2-1.1a4.4 5 0 0 1-.7 3.1c-.2 1.6-.1 2.3.3 3.3.7.6.6 1 1 2 .4-1 .6-2.7.7-3.9v-.2c0 1.1 0 2.8-.3 3.6 0 1.6.4 2.4.8 3.6.3.7.7 1 1.1 1.4 0-1.6.5-2.6.6-4.1l.4 3.9c0 1.3.5 2.3 1 3.3.5.4.7 1.5.9.6.6-2 .6-4 1-6.2 0-1 0-2.6.5-3.3l-.6 3.3c.1-1 .2-2.5.6-3.3v-.4a28.6 32 0 0 1 .5 4.6c0 1.2-.1 2.4.2 3.6.7-.4 1.2-1.4 1.7-2.5a13.3 15 0 0 1 1.9-3.1l-2 3a13.3 15 0 0 1 2-3v-.2a29.5 33.1 0 0 0-.2 3.8c0 1.3 0 2.8.2 3.7.3 1.5.6 1.7.7 3.3 0 .8-.1 1.7.2 2 1 .3 1-.3 1.2-2 0-1.7.4-3 .5-4.7 0-2.1.2.3.5 1a9.5 10.7 0 0 1 .7 3.8c0 .8 0 1.6.2 2 1-.5 1.3-1.7 2-2.3.4-1.4 1-2 1.4-2.8 1.2-.3 1.2-.9 1.2-2.5 0-1.4-.1-2.8.3-4a30 33.7 0 0 0 .9-3.7c.4-.2.9.5 1.2 1.2.5.9.4 2.2.4 3.6a14 14 0 0 0 1.3 3.4 11 12.3 0 0 0 1.6 2.8c.3.9.3 2.5.3 3.7 1-1.2 1-3 1.1-4.8-.1-1.2-.1-2.8-.4-4 0-1.2-.3-2.4-.5-3.3-.7-.4-1-.8-.2-2 .7-.7 1.6-.4 2.8-.2.7.7.9 1.1 1 2.8 0 1.5 0 2.6.5 3.6.4.8.9 1.4 1.2 2.8.3.4.6 1 1.1.3.3-.8.5-2.4.8-3.4.2-1 .6-1.6 1.1-2 0 1.6 0 2.5.6 3.7l1.1 3.1c.5.4.6 1.3 1.3 1.7l.2-4.5v-4c0-1.2.4-2 .7-3 .8 1.1.8 1.5.8 3 .7-.3.8-1 1.1-1.9.5-.6.8-.8 1 .6.1 1.5.4 2.8.7 4.2.5.6 1 2.2 1.6 2.8a12 13.5 0 0 0 1.5 2.3c.4.8.4 1.4 1.5 1.6 0-1.9 0-3.8-.3-5.6 0-1.6-.3-2.2-.5-3.7-.4-.9-.6-2.4-.5-2.8a8 9 0 0 1 2.2 3.4l1.5 3.7a14.7 16.5 0 0 1 1.8 2.8c.9.8 1.3 1.7 2.2 2.5.4.5 1.5.8 1.7.5 0-1.6-.3-3-.7-4.4a6.6 7.4 0 0 0-.8-3.4c-1-.9-1.7-1.5-2.2-2.8-.3-.4-.3-.6-.4-1.4a19.3 21.6 0 0 1 3.4 3.9 5.1 5.8 0 0 0 1.9 2c.4.6 1.8 1.4 2.8 1.6a4.1 4.6 0 0 0 2.4 1.7l-2.4-1.6a4.1 4.6 0 0 0 2.4 1.6v.4a9.5 10.7 0 0 0-1.4-4.6 6.4 7.2 0 0 0-2.2-3 6.8 7.6 0 0 0-2.4-2.5c-.6-.9-1.6-2.4-2.2-2.8 1.1-.9 2.3.4 3.4 1 1 1.2 1.8 2.7 2.4 3.4a13.2 14.8 0 0 0 2.2 3.7c1 .7 1.7 1.3 2.6 2.2 1.4.4.9-.1.5-1.4-.5-1.6 0-1.6 1-.6.6.6 1.4 1.4 2.4 2 .3.6 1 1 1.6.6.3-.4.3-.4.3-.8-.5-1.8-1-3.2-2.2-3.7-.5-.9-1.5-1.7-2.2-2.5-.5-.8-1-1.3-1.4-2.3l1.4 2.2c-.5-.8-1-1.2-1.4-2.2h-.2c1.4 0 2 .5 3 1.2a5 5.6 0 0 1 2.2 2c.5.6 1.2 1.3 1.7 2.1l2.4 2c.8 1.2 1 2 1 3.6.4.9.5 2.5.7 3.4-.2 1.6-.7.3-.8-.6-.1-1.2-.6-1.1-1.4-.8 0 1.7.2 2.2.7 3.4a5.9 6.6 0 0 1-.9 2.8c-.6.4-.7-.8-1.2-1.4 0-1.7-.5-2-1.5-2.8v1.1c.6 1.2 1.2 2.3 1.2 3.9a8.8 9.9 0 0 1 .6 3.7c0 1.4 0 2.7-.3 4 0 1.4-.3 2-.3 3.6v7.9a17 19.2 0 0 0-.2 3.6l.2-3.6c-.2 1-.2 2.2-.2 3.6v.2c-.4-1.4-1-2.6-1.2-4a7.5 8.5 0 0 1-1.6-3c-.3-1.2-.3-2.6-.5-3.6-.4-1-.8-2-1.5-1.4-.3 2 0 3.3.7 5.3.4 1.3.4 2.5.8 3.7.5 1.5 1 1.6 0 3.3-.6 1-.8 1.2-1 2.3-.9.5-1.1.8-1.2 2-.3-1.1-1-2.4-1.4-3.7-.5-1.4-1-2.8-1.2-4-.6-.9-1.3-2.4-2-3l-1.8-3.3c-1-1.3-1.2-2-2-2.6-.1-.5-.4-1.3-1-.8 0 1.3 0 2.7.3 3.9.3 1.6.7 2.5.8 4.2v3c-.6-1.6-1.3-2.9-1.7-4.4-.6-.9-1.1-2.5-1.7-3-.4-1.2-.7-2.1-1.2-2.9-.1-.8-.5-.8-.8-1.4 0 1.6.5 2.2.8 3.3.5 1.2.6 2.9.5 3.5-.6-2-1.2-4.1-2-6a26 26 0 0 1-1.8-3.7c-.8-.9-1.5-1-2.2-1.6a4.3 4.9 0 0 1-1.7-1.4c.2 1.5.7 2.5 1 3.6.2 1.4.7 2.6.9 3.7-.2 2-.6-.5-1-1.4-.2-1.6-.7-2.4-1.1-3.3-.7-.6-1.3-1.5-2-2-.7-.3-.4 0-.4 1 0 1.8 0 3 .5 4 .5.8.5 1.9.5 3.4-.1 1.4-.3 2.4-.3 4v2.1c-.5-1.1-1-1.9-1.5-3.3-.7-1.3-1-2.3-1.6-3.7-.5-.2-1.5-.4-2 0 .2 1.4.7 2 .8 3.7-1 1-.8 1.4-1.4-.3-.6-1.3-1.2-1.2-2-2-1.2-.1-.8-1-1.1-2.3 0-1 0-2-.3-3-1.3 0-2 0-2.9.8-.3.8-.2 2.5 0 3.7v3.9c-.3 1-.7 1-1 2.3-.4 1.1-.5 2.5-.9 3.3-.9.9-.5 1-1-.5v-9c0-1.5.3-2.3.3-3.7-.5-1.1-.6-1.4-2.2-1.4a6 6 0 0 0 0 2.8c0 1.4.1 2.7.3 3.7l.2 3.6c0 1.5-.3 2.7-1 3.3-.8.4 0 1-.9 1.3a11 12.3 0 0 1-2.6-2c-1-.3-1.8-.6-3.1-.6-1.6 0-1.6-.2-2.2-1.6a23 25.8 0 0 1-1-4.6c-.5-1.3-.6-2.2-1-3.7a4.5 5.1 0 0 0-1.4-2c-.3 1.6-.6 2.7-.6 4.3-.3.7-.4 2.4-.6 3-.4-.7-.6-2.4-1-3.5-.3-1.7-.7-2.8-2.3-2.2-1.6 0-1.6 0-1.6 2l1.9 3.2v4c0 1.6 0 2.1-1 2.4-.4-1.6-1.2-3.3-2.2-4.7 0-1.1-.4-.8-1.4-.8-.6 0-1.3-.1-1.7.3v2.4c-.5.2-.7 0-1.1-.5-.5.9-.2 2 0 3a10 10 0 0 1-1.2 3.2c-.2-.4-.4-.2 0-.2-1.7-.8-3-1.2-4.4-1.7-.7 0-1.4 1-1.8 1.7-1.3.4-1.8.8-3.2.8l-3 .2c-1 .3-2 .4-3.2.4-.6-.3-1.8-.3-2.1-.6.5-.8 1-1.2 1.4-2.5a14.7 16.5 0 0 0 2-2l1.8-2.3c.4-1.4 1-1.6 1.7-2.2 1.5 0 1.7.6 3.1.8 1.4.6 2.2.9 3-.3 1-.5 2-1.4 3.2-1.6l2.4-1.7c1-.7 1.5-1.5 2.4-2.3.3-1.1 1-2 .7-3.3-1.3-.4-2.1-.3-3 .5-.9 1-1 1.4-2.3 2.2-1 .4-1.4.9-2.6 1.2-1 .4-2.2.2-3.3.2s-2.5 0-3.1.4c1-.8 2.3-1.7 3.3-2 1-.7 1.4-1 2.7-1.2.6-.8 1.1-.8 1.4-2.2.4-1.6-1-1.1-2-.5-.9.2-2 1-2.8 1.3a10.5 11.8 0 0 1-3 .6c-.4-.5.1-.9.4-1.6 1-.5 1.3-.7 1.4-2-1.3.2-1.7.7-2.9.8a18 18 0 0 1-3.8.6h-3.3c-1.2 0-1.8-.3-3.2-.3-1-.6-1-.8-1-2.5.8-1 1.5-.8 3-.8l2.6-1.5c.9-.2 1.4-.6 1.2-1h-3.3c-1.4-.7 0-1 .7-1.5 1 0 2.3 0 3 .5 1.5 0 2-.5 3.1-1.6 1-.8 1.5-1.4 2.5-2 .7-.9 1.4-1.4 1.9-2.2 1-1 1.7-1.7 2.2-2.6.6-.4 1-.8.7-1.4-1.5.2-2.2.9-3.2 1.7a7.3 8.2 0 0 1-1.9 1.6 6 6.7 0 0 1-3.1 1.3c-1.2 0-2.2-.3-3.3-.4-1.3-.1-.2-.5.2-1.1.5-.3.9-1.2.5-2-1-.3-2.2-.2-3.3-.2h-3.4c-1.3 0-1.8-.4-2.7-.9-.2-.8 0-.5 1-.5a13.2 14.8 0 0 0 3.1-.6c1.1-.3 1.3-.8 1.5-2.2-1.2 0-2.4 0-3.1-.3zm-20.7-6.5c-.2-2-.7-3.1-.7-5.2 0-1.5 0-.6 1.4-2.7l2-2c1.3-.8 2.4-1.7 3.7-2.4 1-.6 3-1.1 3.7-1.6a9.2 10.3 0 0 0 3-2.8c.2-1.7.4-3 .4-5 1.4-1 2.5-1.6 3.7-2 1.7-.6 2-1.4 3.8-1.7 1-.4 2.8-.4 4.4-.4 1.6 0 2.7 1.4 4.2 1.6 1.8.8 2.6 1.4 4 2.8.8 1.2 1.4 2.2 2.7 3 1.1.6 2.2 1.6 3.4 2 0 1.4.3 1.2-.6 1.2-.1 1.5-.4 1.3-1.7 1.4a5.9 6.6 0 0 1-2.2-2.3c.6-1.4.3 1.2 0 1.7-.5.6-.9 1.2-1.6.6-.4-1.4-.7-2.3-.7-4-.2-1.7-.7-.5-1 .3-.3 1.5-.2 2 .3 3.1-1.3 0-2.2-.2-3.1-.3-.9-.3-2 0-3 .6-1.2.9-.7.9-.2 2 1.1.3 2 1 3 1.6l3.3-.8c1.1-.5 2.2-.2 3.3 0 .6.4 1.4.4 1.7.8 0 .9 0 1.8-.3 2.3-.4.4-1 1.4-1.7 1.6a11.8 13.2 0 0 1-3.2 1.5c-1.5 0-2.1.4-3.2 1-.1 1.6-.5 1.9-1.7 2.4a7.5 8.5 0 0 1-3.3.8c-.7 0-1.4 0-1.7-.3a9.4 10.5 0 0 0 2-3.3c.2-.7.6-1 .2-1.5-1.4 0-1.8 0-2 1.6-.1 1.6-.6 1.9-1.6 2.4.3-1.4.3-2.5.7-3.7a18.3 20.6 0 0 1-3 .3c-.8.5-1.1.7-.8 1.6-1 .4-2.2.2-3.4 0-1 0-.4-.5-1.2-1-.5-1.1-1-1.4-2.2-1.4-.5.8-1.4 1-2 1.6-1.1.4-1.8 0-2.7-.5-1.2 0-1 .4-.7 1.4.5.3 0 .7.7.8.7.7 1.3.9 2.6.9 1-.4 2.2-.3 3.4-.3 1.2 0 1 .3 1 1.6-.8.7-2 .6-3.2.6a12.2 13.7 0 0 1-2.9-.8c-1 0-2-.3-2.8 0-.4.5-1.5.7-.2.8.5.6 3.3.3 3.4 1.3.7.8.5 1.9-.6 1.9a1.6 1.8 0 0 0-1.7 0l-3.1.1c1.8.2-1.3-2.2-2-3.2"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#bcbcbc",
          d: "m417.1 122.2-1.4 1-2.9 2.3c-.5.5-.5.8-1.1.8 1-.1 1.6-.5 2.6-1 1.2-.2 2.4-.5 3-1.2.7-.2 0-1.3-.2-2zm11-13.2c.2 0 .5.8 1 1.4.4 1 .7 1.8.7 3 .3-1.3.8-2.4 1-3.9-.4-.8-.4-1-1.5-1.1 0 .8.2.2-1.2.6"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#c4c4c2",
          stroke: "#000",
          strokeWidth: 0.9,
          d: "M349.4 417.7c-.5 0 .8-.5 1.3-.6.4-.8.6-1.3 1.3-1.8 1.1 0 1.7.4 2.2 1.1 1 .3 1.3.7 2.4.9.5.4 1 .4 0 .7-.6.3-1.5.4-2.6.4a7.2 7.2 0 0 0-2.6.7c-1.5 0-1.3 0-2-1.4z",
          transform: "matrix(1.08448 0 0 1.26674 42.6 -410.2)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#bcbcbc",
          d: "M432.5 109.2v.3c0-.8 0-.4.2 1.2a6.6 7.4 0 0 1 .5 3.3 5 5.5 0 0 0 1.5-2.5c0-2.2-.4-2.1-2.2-2.3m8.8 32.3h.3c-.8 0-.3 0 .9-.8.8-.6 1.5-1.6 2.6-2a9.5 10.7 0 0 1 3.1-2c.6-.3 1.1-.8 1.7-.2-.1 1.3-.4 2-1.5 2.5-.5.8-1.3 1.3-2 1.6-.8.5-1.7.5-2 1.5-1.3.7-1.5.5-3-.6zm4.6 8.2c.3-.4 1.9-2.2 2.6-2.8a11 12.3 0 0 1 2.4-2.8c.7-1.2 1.6-2 2.2-3.1l1.9-2.8c0 1.2-.2 2.8.2 3.6a5.1 5.8 0 0 1-.8 3.4c-.5 1-1 1.6-2.2 2.3-1 .6-1.6.8-2.5 1.6a19 21.4 0 0 1-2.2 1.4c-.7.3-.4.3-1.6-.8m-7.5 6.4h.3c-.7 0-.4 0 1-.8 1-1.2 1.8-1.7 3-2.2a7.5 8.5 0 0 0 3-.9c.5-.1 1-.5 1.3 0 .8 1.2 1 1.5-.2 2.3a6.9 7.7 0 0 1-2.4 1.4c-.6.5-1.8.5-3 .8-.8 0-1.4.1-1.8-.6l2 .6c-1 0-1.5.1-3.2-.6m10.3 0v-.2c0 .8 0 .4.5-1.2 1-1.6 1.2-2.5 2.4-2.8.5-.8 1.5-1 2.6-1.4.5.8.1 1.8 0 2.8-.3 1-1.1 1.8-1.7 2.6-.7.5-1 1.1-2.2 1.4-.8 0-.3 0-1.6-1.2"
        }),
        /* @__PURE__ */ jsx90("path", {
          d: "M425.3 119.7c0 .7-.5 1.4-1.2 1.4s-1.2-.7-1.2-1.4c0-.8.6-1.4 1.2-1.4.7 0 1.2.5 1.2 1.4"
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "#005120",
      fillRule: "evenodd",
      stroke: "#002b0d",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx90("path", {
          d: "M351.8 479.6h.9c-2.8 0-1.1-.2 3.5 3.5 2-1.6 2-1.8 3.5 1 1 1.5 1.2-.2 2.7-1.8.7 3.2 1.1 6.5 3.5 3.5 2.8 0 5.6-.2 7.1.9 1.8 3.3 1.2-.6 2.6.9 4 .4 3.9-3.4 8.1-4.4 2.6 3.3 3.8.8 7-.8 2.5.6 4.8 4.3 5.3.7 2-3.2 2.1-3 3.5 0 2 1.8 2.8-.8 4.4-1.7 3 1.7 6.3 2 10.6.9.8 2.9 2.6 1.6 4.5.8 3.9 1.7 5.2 2.2 9.7 0 2.2-2.6 1 .1 2.6 1.8 3.3-1 2.4-1.2 6.2-.9 3.9 0 4.2 0 5.3-2.6 2 1.9 2.6 3.3 5.3.9 4.2 0 2.9.5 5.3-1 1.9 4 2.3 1.2 4.5 2.7a14.5 14.5 0 0 1-6.2 7c-1.7 3-2.8 6-6.2 7.2-2.5 2.5-5.2 4-8 6.2-3.8 1-8 .8-12.3.8H388c-2.6 1.4-7 2-10.6 2.7-4 0-8.7 0-11.5-.9-1.9-1.9-5.2-4-7-6.2-2-1.5-2-4.4-3.6-6.2-1.4-2.5-2-6.5-3.5-8.8z",
          transform: "matrix(1.08448 0 0 1.26674 47.3 -411.4)"
        }),
        /* @__PURE__ */ jsx90("path", {
          d: "M437.5 487.6v.8c0-2.4.1-1.1-1.8 3.6-.3 1.1-1.2 1.4-2.6 1.8m-3.5-2.7h.9c-3.3 3-5.5 4.5-6.2 8l6.2-8c-3.3 3-5.5 4.5-6.2 8m-7.1-12.4s-.1 3.1-.9 4.4m-2.6 1.8v.8zm-7.1-5.3h.9-1c.4 0 .7 0 0 0zm-49.5 0c.4 0 2.2 2.8 4.4 4.4-.5 2.6-1.4 5.6 0 8m2.7-7.1c.4 0 2.1 2.8 4.4 4.4l-4.4-4.4c.4 0 2.1 2.8 4.4 4.4v.9c0-2.8-.2-5.6.9-7.1 1 1.7 2.2 4.3 2.6 1.8 5-.2 7.4-1.6 10.6-2.7 0 1.3-.2.7 1 1.8m60-3.6h.9c-1.7 1.4-3 4.3-4.4 6.2m-32.7-8.8h7",
          transform: "matrix(1.08448 0 0 1.26674 47.3 -411.4)"
        })
      ]
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M425.9 214.3c-11.5 0-15.4 13.5-26.9 13.5h-.6v.8c0 9.4.6 18.1 1.8 26.2 10.6-.8 14.5-13.4 25.7-13.4 11.5 0 15.3 13.4 26.8 13.4 11.6 0 15.4-13.4 26.9-13.4 11.5 0 15.4 13.4 26.9 13.4 11.5 0 15.3-13.4 26.8-13.4 11 0 15 12.5 25.6 13.4a139 156.1 0 0 0 1.9-27h-.7c-11.5 0-15.3-13.4-26.8-13.4s-15.4 13.5-26.8 13.5c-11.5 0-15.4-13.5-27-13.5-11.4 0-15.3 13.5-26.8 13.5-11.4 0-15.3-13.5-26.8-13.5zm0 52.7c-9 0-13.2 8.2-20.2 11.8a111 124.5 0 0 0 8.6 20.5c3.3-2.8 6.7-5.2 11.6-5.2 11.5 0 15.3 13.5 26.8 13.5 11.6 0 15.4-13.5 26.9-13.5 11.5 0 15.4 13.5 26.8 13.5s15.4-13.5 26.9-13.5a18.3 20.6 0 0 1 11.3 5 112 125.7 0 0 0 8.6-20.4c-6.7-3.7-11-11.7-20-11.7-11.4 0-15.3 13.5-26.8 13.5S491 267 479.6 267s-15.4 13.5-26.9 13.5c-11.4 0-15.3-13.5-26.8-13.5m53.7 52.7c-11.5 0-15.4 13.5-26.9 13.5-10.9 0-14.9-12-25-13.4a132 132 0 0 0 39.3 33c3.6-3.2 7.3 3.6 12.5 3.6 5.3 0 9-6.9 12.5-3.8a129.1 145 0 0 0 39-32.7c-9.8 1.7-14 13.3-24.6 13.3-11.5 0-15.3-13.5-26.8-13.5"
    }),
    /* @__PURE__ */ jsxs83("g", {
      transform: "matrix(.86465 0 0 .97062 -175.4 2.5)",
      children: [
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M332.5 541.4a110 110 0 0 1 10.5-3l16.3 15.7-13.4 2.7z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.6,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3 6.7-31.1m-4.4 31.2 5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(1.06 0 0 1.03 276.8 -178)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.4,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(-1.25 0 0 1.76 1290.4 -502)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(-1.25 0 0 1.3 1321.3 -302)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m395.3 572.2.9-73s2.6-.3 2.6 0-.3 72.7-.6 73c-.3.3-3.2.5-2.9 0zm28.5-69.8-.6 61.3-2 2.4.6-63.7z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M363 560.2s3 30 36.4 29.1c33.4-.9 42.7-30.2 42.7-30.2l-14.5-.6c-.3 0-11.6 14-26.2 13.7-14.6-.3-19.2-3.8-22.4-6.7-3.2-3-6-7.3-6-7.3l-17-6.7 1 6.4zm90.3-3-1-4v-3.4l1.6-3.6s-25.3 3.7-25.3 4l-.1 6.8 24.8.1z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m448.5 549.8-.6 6h4.1l-.3-6zm-4.3.3-.3 6.4 2.6-.3.3-6.1zm-4.4 6.4v-5l2.6-.9.3 5zm-5-.3.6-4.4 3 .3.2 4.7zm-5.5 0 .3-3.8 3-.3v4.4zm-67.4 3.7c.9 0 7.6 1.5 7.6 1.5l7 9.3",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M366.8 561.1c.3.3 6.1 19.8 34 19.8s34.6-22.1 34.6-22.1",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M439.8 559.4s-13.4 29-39 27c-25.5-2-29.6-11.6-31.6-16.6-2-5-3.2-9-3.2-9",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M373.2 558.2c.3-1.7.3-54.4.3-54.4l-1.7-.2-.3 53.7 1.7 1zm-41.5-17.1 22 10.7-.5 1.5S332 543.3 332 543c0-.3.2-1.5-.3-2z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M341.8 537.9c0 .8 3.2 18.6 3.2 18.6s2 .3 2 0l-3.4-18.3zm20.4.5c1.1 0 21-3.2 21-3.2l-.4 3.2-19.5 2z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M365 514.3c.7 0 7 3.2 9.7 2.4 2.7-.8.9-3 1.4-3 .6 0 2.6 1.5 3.8.3 1.2-1.1 2-4.6 1.5-4.3-.6.3-16 5.8-16.3 4.6z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M362.5 521.6c1.1.3 23.8-6.1 23.8-6.1s0 2-.3 2l-23.5 6.1z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M415 512.6s1.5 3.5 3 2.9c1.5-.6 2.9-1.8 2.9-1.8s1.2 3 3.2 2.4c2-.6 3.2-3.8 3.2-3.8s2 .6 2.9.3c.9-.3 2-5 2-5zm-1.7 28.2c-.3.6 1.5 2 3 2s2-2 2.3-1.4c.3.5.3 3.2 4 2.3 3.7-.9 3.8-3.5 3.8-3.5s-1.1.9 1.5 1.2c2.6.3 5.2-3.8 5-3.8-.4 0-19 3.5-19.6 3.2z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M363.4 513.1a5 5 0 0 0 .2 2.7l19-6.4s.8-1.5 0-1.5-19.5 5.8-19.3 5.3zm25-4c.5 0 19.4-6.1 19.4-6.1s.3 2.6 0 2.6l-17.7 5.2-1.8-1.7z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.3 521.9s-2.9 3.2-2 7.5c.9 4.4 2 8.2 2.3 8.2.3 0 3.5-5.8 7-6.1 3.5-.3 9.9 3.2 9.9 3.2s-.9-7-.6-10.2c.3-3.2 5.2-8.7 5.2-8.7l-21.8 6z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M386.9 516.6s-.6 2.7-.3 2.7l24.7-6.4V511l-24.4 5.5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#b6b6b4",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M355.5 551.8s-5.8-.8-5.5.6c.3 1.5 2.9 2.9 3.2 3.8.3.9-.9 4 .9 3.8 1.7-.3 3.4-1.5 3.4-2.4l-.3-5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M387.8 537.3v2l20.9-2.9-.6-1.5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M363 540.8c.4 0 0 2.6 2.4 2 2.3-.6 2.9-2 2.9-2s.6 3.2 3.8 2.9c3.2-.3 5-3.8 5-3.8s.2 2.6 2.2 1.7c2-.9 2.6-2.9 2.6-2.9l-18.3 2.6zm0-17.2s-2.6.9-1.7 6.1c.9 5.2 3 8.2 3.2 8.2.3 0 2.6-5 6.1-5.8 3.5-1 9.6 2.6 9.6 2.6s-.6-4.7.3-9a18 18 0 0 1 3.8-7.6s-20.4 5.5-21.2 5.5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m411.9 538.7.3 1.8s21-2.6 21-3c0-.2 0-2-.4-2-.3 0-20.6 3.5-21 3.2zm-.3-18.6.3 2 24.7-6.6s.6-1.8.3-1.8-24.7 7.3-25.3 6.4z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M414.2 510.8s-.3 1.8 0 1.8 18.3-4.4 18.3-4.7c0-.3 1.8-2 .3-1.7-1.4.3-18 5.5-18.6 4.6zm38.7 33.7-18-28.4m-2.4 19.7c.3-.8 1.2-18.3 1.2-18.3",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M389 510c1 .2 3.1 3.2 4.3 2.6 1.2-.6 2.9-2.4 2.9-2.4s-.3 3.5 2 3c2.4-.6 2.7-3 2.7-3s1.7 1 3.2 0c1.4-.8 2.8-5.2 2.3-5.2s-16.9 5.2-17.5 5zm-.6 8.4c0 .6-3 5.2-2 9.6 1 4.4 2.5 8.4 2.8 8.4.3 0 4.7-4.6 8.5-5.5 3.7-.9 9.3 2.9 9 2.9-.3 0-1.5-4.4-1.5-7.6 0-3.2 4.4-13 4.4-13zm0 21c0 .2.8 2.2 2.9 2.2 2 0 2.3-2 2.3-2s-.3 3.5 2.9 3.2c3.2-.3 4.3-3.5 4.3-3.5s.3 1.8 3 .9c2.6-.9 6-3.8 5.8-3.8-.3 0-21 3.8-21.3 3z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(-6.6 7.3)"
        }),
        /* @__PURE__ */ jsx90("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(6.6 3.8)"
        }),
        /* @__PURE__ */ jsx90("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(0 11)"
        }),
        /* @__PURE__ */ jsx90("path", {
          id: "fk_svg__l",
          fill: "#be0f17",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.6,
          d: "M409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0z",
          transform: "matrix(.04 -1.07 1.02 .04 251.6 668)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M398.2 500c0-.2 9 3.8 9 4.1 0 .3 32 42.8 32.3 42.8m-16-42.8 8.2 3.5 2.6 6.4m-61.4-10.4c-.3 0 9 7 9 7l1.2 5.7M341.3 546c4-1.7 32.2-26.4 32.2-26.4m-39.8 21.7 31.7-26.7m21.2 4 30 49.8m-3.6-29.2s3.5 11.7 7 13.5a86 86 0 0 1 7.6 4.6",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M412.6 539.5s2.5 13.8 6 16.4c3.5 2.6 7 5.5 7 5.5",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M391 439s3.4 19.2 10.4 23.6a950 950 0 0 1 12.8 8.1",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M390.7 438.7s7.5 15.2 14 19.8c6.3 4.7 15 9 15 9M366.3 440c2 3.5 1.7 10.2 4 12.5a66 66 0 0 1 5.8 7.6m-9.3-19.9c1.2 1.7 4.4 10.4 6.4 13 1.5 2.4 16.3 17.2 16.3 17.2",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M384.6 471.1a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm10.7 4.7a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zM409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zm11.9-4.5c0 1-.7 1.7-1.6 1.7-.9 0-1.6-.8-1.6-1.7 0-.9.7-1.8 1.6-1.8.9 0 1.6.8 1.6 1.8zm9.6-5.7c0 .9-.9 1.6-1.9 1.6-1 0-1.9-.7-1.9-1.6 0-.9.9-1.6 1.9-1.6 1 0 1.9.7 1.9 1.6z",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "red",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M374.1 404.4c-.9.6-15.4 4.1-13.4 3.8 2-.3 13.7 3 13.4 2-.3-1 0-5.2 0-5.8zm24.7-4.3c-.6 0-9 3.2-8.7 3.2.3 0 9.6 2.6 9.3 2-.3-.6-.3-4.4-.6-5.2zm25.3 2.9c-.6.3-10.5 2.6-8.7 2.9 1.8.3 8.4 2.6 8.4 2 0-.5 0-4.6.3-5z",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3 6.7-31.1m-4.4 31.2 5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(1.25 0 0 1.36 225.3 -323.4)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(-1.25 0 0 1.32 1259.2 -307.3)"
        }),
        /* @__PURE__ */ jsx90("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m426.4 558.5 27.6.6.3-2-28.5-.3zm1.2-7.3c3.2 0 27.3-4.6 27.3-4.6s.9-3 0-3-27.3 5.6-27.3 5.6z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx90("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(0 5.5)"
        })
      ]
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx90("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Fk_default = SvgFk;

// src/country-flag-icons/generated/Fm.tsx
import { jsx as jsx91, jsxs as jsxs84 } from "react/jsx-runtime";
var SvgFm = (props) => /* @__PURE__ */ jsxs84("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx91("defs", {
      children: /* @__PURE__ */ jsx91("clipPath", {
        id: "fm_svg__a",
        children: /* @__PURE__ */ jsx91("path", {
          fillOpacity: 0.7,
          d: "M-81.3 0h682.6v512H-81.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs84("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#fm_svg__a)",
      transform: "translate(76.3) scale(.94)",
      children: [
        /* @__PURE__ */ jsx91("path", {
          fill: "#6797d6",
          d: "M-252 0H772v512H-252z"
        }),
        /* @__PURE__ */ jsx91("path", {
          fill: "#fff",
          d: "m259.8 123-32.4 22.2 12.4-35.9-32.5-22.2h40.1l12.4-35.9 12.4 36h40l-32.4 22.1 12.4 35.9M259.8 390l-32.4-22.2 12.4 36-32.5 22.1h40.1l12.4 35.9 12.4-36 40 .1-32.4-22.2 12.4-35.9m-188.4-92.4L79.3 306l1.4-38-37.5-11.7 38.4-11.7 1.3-38 22.3 30.8 38.4-11.8-24.6 30.7 22.4 30.7m274.2-11.7 24.6 30.7-1.4-38 37.5-11.7-38.4-11.7-1.3-38-22.3 30.8-38.4-11.8 24.6 30.7-22.4 30.7"
        })
      ]
    })
  ]
});
var Fm_default = SvgFm;

// src/country-flag-icons/generated/Fo.tsx
import { jsx as jsx92, jsxs as jsxs85 } from "react/jsx-runtime";
var SvgFo = (props) => /* @__PURE__ */ jsxs85("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx92("defs", {
      children: /* @__PURE__ */ jsx92("clipPath", {
        id: "fo_svg__a",
        children: /* @__PURE__ */ jsx92("path", {
          fillOpacity: 0.7,
          d: "M-78 32h640v480H-78z"
        })
      })
    }),
    /* @__PURE__ */ jsxs85("g", {
      fillRule: "evenodd",
      strokeWidth: 0,
      clipPath: "url(#fo_svg__a)",
      transform: "translate(78 -32)",
      children: [
        /* @__PURE__ */ jsx92("path", {
          fill: "#fff",
          d: "M-78 32h663.9v480H-78z"
        }),
        /* @__PURE__ */ jsx92("path", {
          fill: "#003897",
          d: "M-76 218.7h185.9V32H216v186.7h371.8v106.6H216V512H109.9V325.3h-186z"
        }),
        /* @__PURE__ */ jsx92("path", {
          fill: "#d72828",
          d: "M-76 245.3h212.4V32h53.1v213.3H588v53.4H189.5V512h-53V298.7H-76z"
        })
      ]
    })
  ]
});
var Fo_default = SvgFo;

// src/country-flag-icons/generated/Fr.tsx
import { jsx as jsx93, jsxs as jsxs86 } from "react/jsx-runtime";
var SvgFr = (props) => /* @__PURE__ */ jsxs86("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx93("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx93("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx93("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Fr_default = SvgFr;

// src/country-flag-icons/generated/Ga.tsx
import { jsx as jsx94, jsxs as jsxs87 } from "react/jsx-runtime";
var SvgGa = (props) => /* @__PURE__ */ jsx94("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs87("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx94("path", {
        fill: "#ffe700",
        d: "M640 480H0V0h640z"
      }),
      /* @__PURE__ */ jsx94("path", {
        fill: "#36a100",
        d: "M640 160H0V0h640z"
      }),
      /* @__PURE__ */ jsx94("path", {
        fill: "#006dbc",
        d: "M640 480H0V320h640z"
      })
    ]
  })
});
var Ga_default = SvgGa;

// src/country-flag-icons/generated/Gb.tsx
import { jsx as jsx95, jsxs as jsxs88 } from "react/jsx-runtime";
var SvgGb = (props) => /* @__PURE__ */ jsxs88("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx95("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx95("path", {
      fill: "#FFF",
      d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"
    }),
    /* @__PURE__ */ jsx95("path", {
      fill: "#C8102E",
      d: "m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"
    }),
    /* @__PURE__ */ jsx95("path", {
      fill: "#FFF",
      d: "M241 0v480h160V0zM0 160v160h640V160z"
    }),
    /* @__PURE__ */ jsx95("path", {
      fill: "#C8102E",
      d: "M0 193v96h640v-96zM273 0v480h96V0z"
    })
  ]
});
var Gb_default = SvgGb;

// src/country-flag-icons/generated/Gd.tsx
import { jsx as jsx96, jsxs as jsxs89 } from "react/jsx-runtime";
var SvgGd = (props) => /* @__PURE__ */ jsxs89("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx96("defs", {
      children: /* @__PURE__ */ jsxs89("g", {
        id: "gd_svg__c",
        children: [
          /* @__PURE__ */ jsxs89("g", {
            id: "gd_svg__b",
            children: [
              /* @__PURE__ */ jsx96("path", {
                id: "gd_svg__a",
                fill: "#fcd116",
                d: "M0-1v1h.5",
                transform: "rotate(18 0 -1)"
              }),
              /* @__PURE__ */ jsx96("use", {
                xlinkHref: "#gd_svg__a",
                transform: "scale(-1 1)"
              })
            ]
          }),
          /* @__PURE__ */ jsx96("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(72)"
          }),
          /* @__PURE__ */ jsx96("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(144)"
          }),
          /* @__PURE__ */ jsx96("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(216)"
          }),
          /* @__PURE__ */ jsx96("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(288)"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx96("path", {
      fill: "#ce1126",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx96("path", {
      fill: "#007a5e",
      d: "M67.2 67.2h505.6v345.6H67.2z"
    }),
    /* @__PURE__ */ jsx96("path", {
      fill: "#fcd116",
      d: "M67.2 67.3h505.6L67.2 412.9h505.6z"
    }),
    /* @__PURE__ */ jsx96("circle", {
      cx: 319.9,
      cy: 240.1,
      r: 57.6,
      fill: "#ce1126"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__c",
      width: "100%",
      height: "100%",
      transform: "matrix(52.8 0 0 52.8 320 240)"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: -100,
      transform: "translate(-30.3)"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__c",
      id: "gd_svg__d",
      width: "100%",
      height: "100%",
      transform: "matrix(31.2 0 0 31.2 320 33.6)"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: 100,
      transform: "translate(30.3)"
    }),
    /* @__PURE__ */ jsx96("path", {
      fill: "#ce1126",
      d: "M102.3 240.7a80.4 80.4 0 0 0 33.5 33.2 111 111 0 0 0-11.3-45z"
    }),
    /* @__PURE__ */ jsx96("path", {
      fill: "#fcd116",
      d: "M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63.2 63.2 0 0 1-10.9-41.9 70 70 0 0 1 32.5 30.8c16.4-59.5-42-55.8-57.1-74.8"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: -100,
      transform: "translate(-30.3 414.6)"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__c",
      width: "100%",
      height: "100%",
      transform: "matrix(31.2 0 0 31.2 320 448.2)"
    }),
    /* @__PURE__ */ jsx96("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: 100,
      transform: "translate(30.3 414.6)"
    })
  ]
});
var Gd_default = SvgGd;

// src/country-flag-icons/generated/Ge.tsx
import { jsx as jsx97, jsxs as jsxs90 } from "react/jsx-runtime";
var SvgGe = (props) => /* @__PURE__ */ jsxs90("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx97("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx97("path", {
      fill: "red",
      d: "M272 0h96v480h-96z"
    }),
    /* @__PURE__ */ jsx97("path", {
      fill: "red",
      d: "M0 192h640v96H0z"
    }),
    /* @__PURE__ */ jsx97("path", {
      fill: "red",
      fillRule: "evenodd",
      d: "M146.8 373.1c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.1 4zm368-288c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.1c-16.9-1-31.2-3.9-31.2-3.9s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.1c16.9 1 31.2 4 31.2 4s-1-10-1-14.9 1-14.8 1-14.8-14.3 3-31.2 4zm-368 0c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.1 4zm368 288c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.2 4z"
    })
  ]
});
var Ge_default = SvgGe;

// src/country-flag-icons/generated/Gf.tsx
import { jsx as jsx98, jsxs as jsxs91 } from "react/jsx-runtime";
var SvgGf = (props) => /* @__PURE__ */ jsxs91("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Gf_default = SvgGf;

// src/country-flag-icons/generated/Gg.tsx
import { jsx as jsx99, jsxs as jsxs92 } from "react/jsx-runtime";
var SvgGg = (props) => /* @__PURE__ */ jsxs92("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx99("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx99("path", {
      fill: "#e8112d",
      d: "M256 0h128v480H256z"
    }),
    /* @__PURE__ */ jsx99("path", {
      fill: "#e8112d",
      d: "M0 176h640v128H0z"
    }),
    /* @__PURE__ */ jsx99("path", {
      id: "gg_svg__a",
      fill: "#f9dd16",
      d: "m110 286.7 23.3-23.4h210v-46.6h-210L110 193.3z"
    }),
    /* @__PURE__ */ jsx99("use", {
      xlinkHref: "#gg_svg__a",
      width: 36,
      height: 24,
      transform: "rotate(90 320 240)"
    }),
    /* @__PURE__ */ jsx99("use", {
      xlinkHref: "#gg_svg__a",
      width: 36,
      height: 24,
      transform: "rotate(-90 320 240)"
    }),
    /* @__PURE__ */ jsx99("use", {
      xlinkHref: "#gg_svg__a",
      width: 36,
      height: 24,
      transform: "rotate(180 320 240)"
    })
  ]
});
var Gg_default = SvgGg;

// src/country-flag-icons/generated/Gh.tsx
import { jsx as jsx100, jsxs as jsxs93 } from "react/jsx-runtime";
var SvgGh = (props) => /* @__PURE__ */ jsxs93("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx100("path", {
      fill: "#006b3f",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fcd116",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#000001",
      d: "m320 160 52 160-136.1-98.9H404L268 320z"
    })
  ]
});
var Gh_default = SvgGh;

// src/country-flag-icons/generated/Gi.tsx
import { jsx as jsx101, jsxs as jsxs94 } from "react/jsx-runtime";
var SvgGi = (props) => /* @__PURE__ */ jsxs94("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx101("path", {
      fill: "#da000c",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx101("path", {
      fill: "#fff",
      d: "M0 0h640v321.6H0z"
    }),
    /* @__PURE__ */ jsxs94("g", {
      stroke: "#000",
      transform: "translate(-160) scale(1.875)",
      children: [
        /* @__PURE__ */ jsxs94("g", {
          id: "gi_svg__a",
          fill: "#da000c",
          strokeLinecap: "square",
          children: [
            /* @__PURE__ */ jsx101("path", {
              fill: "#000001",
              stroke: "none",
              d: "M196.6 116.3h64v44h-64z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M229.8 153.9h-39l-8.7 5.7v6h47.7m-16.3-37c5.6 0 10.2 4.7 10.2 10.5v14.7h7.3v-56h-40.3v56h12.6v-14.7c0-5.6 4.5-10.5 10.2-10.5z"
            }),
            /* @__PURE__ */ jsx101("path", {
              fill: "#000001",
              stroke: "none",
              d: "M204.5 60h18.6v34h-18.6z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M223 88.7h-16.2v-5.8h-11.9v5.8h-8v-5.8H182v10.4h41m-36.2 0h35v4.5h-35zm14-45.7V83h6v-9.7c0-3.6 2.5-6.6 6.1-6.8h.4a6.8 6.8 0 0 1 6.8 6.8V83h5.7V47.6zm-2.3-4.8v4.8h29.3v-4.8zm-3.7-9.1v9.1h35v-9.1h-5.3v4.7h-6.6v-4.7h-10v4.7h-6.5v-4.7zM182 159.6h48m31-2.8h-32.4l-9.8 4.7v7H261"
            }),
            /* @__PURE__ */ jsx101("path", {
              strokeLinecap: "butt",
              d: "M218.8 161.5H262"
            })
          ]
        }),
        /* @__PURE__ */ jsx101("use", {
          xlinkHref: "#gi_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 512 0)"
        }),
        /* @__PURE__ */ jsxs94("g", {
          fill: "#f8d80e",
          children: [
            /* @__PURE__ */ jsxs94("g", {
              strokeLinecap: "round",
              children: [
                /* @__PURE__ */ jsx101("path", {
                  strokeWidth: 0.8,
                  d: "M273.3 150c-2.7 1-5 2.4-7.5 3.8a72.4 72.4 0 0 0-8.9 6c-1 .7-2 1.4-2.7 2.4-1 .8-2 2-1.8 3.5 0 .6.8-.8 1.4-.9a4.4 4.4 0 0 1 3.1-.4c1.3-1.4 3-2.3 4.4-3.4a77.4 77.4 0 0 1 13-7.6z"
                }),
                /* @__PURE__ */ jsx101("path", {
                  d: "M260.4 157.4v3.9m2.4-5.6v3.9m2.4-5.4v3.8m2.5-5.3v4"
                }),
                /* @__PURE__ */ jsx101("path", {
                  strokeWidth: 0.8,
                  d: "m238.9 150.2-1.2 3.3a86.6 86.6 0 0 1 15.8 8c1.7 1.2 3.5 2.3 4.8 3.9.3.8-.5 1.5-1.3 1.2-.7-.2-1.5-.5-2.2 0-1.1.5-2.1 2.2-.5 2.7 2.4 1.6 6.1.9 7.2-1.8.6-1.4.7-3.2-.5-4.4-2-2.3-4.8-4-7.4-5.7a89.2 89.2 0 0 0-14.7-7.2z"
                }),
                /* @__PURE__ */ jsx101("path", {
                  d: "m254 158-.3 3.4m3.1-1.7-.8 3.3m3.8-1-1.8 2.6m2.7 3.6-2.6-1.4m3.4-1.4-3 .3m-.8 4-.2-2.6m-1-.3-2.4 1.8m-9.4-15.7v3.1m6.3.3v3.5m-3.2-5.2v3.3"
                })
              ]
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M235.8 227.6v8h5v-4h6.9v4h5.4v-8zm0 11v8H253v-8h-5.4v4h-6.9v-4z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M253 193.7h5v58h-5z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M253 198.7h5v50h-5zm2.6-19.3 10.6 6.2-10.6 6.2-10.7-6.2zm-14.3 4h-2.7v4.4h2.7l14.3 8.3 14.2-8.3h2.8v-4.4h-2.8l-14.2-8.3z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M255.3 164.3a5 5 0 0 0-4 5.1v11.2a5 5 0 0 0 4.6 4.6 4.9 4.9 0 0 0 4.8-2.8l-1.7-1a2.9 2.9 0 0 1-3 1.8c-1.6 0-2.9-1.6-2.7-3.1v-11.2a2.9 2.9 0 0 1 3-2.6c.6-.2 1.5.7 1.9 0 .6-.9-.4-1.5-1-2zm5.8 3.9a5 5 0 0 1-1.9 1.6v7.5l2 1.1v-10.2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs94("g", {
          fill: "#da000c",
          children: [
            /* @__PURE__ */ jsx101("path", {
              fill: "#000001",
              stroke: "none",
              d: "M240.8 38.4h29.3v53.2h-29.3z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M238.8 38.4v44.5h9.3V69.7c0-3 2-7.3 7.9-7.3s8 4.3 8 7.3V83h9.2V38.4zm15.8 5h2.8v15.2h-2.8zm-8.3 3h3v11.1h-3zm16.5 0h2.9v11.1h-3zM235.6 32v6.3h40.8V32zm-3.8-7.4V32h48.5v-7.4h-6.1v4h-7v-4h-7.8v4h-6.8v-4h-7.9v4H238v-4zm-9 73.2v4.6h66.5v-4.6z"
            }),
            /* @__PURE__ */ jsx101("path", {
              d: "M220 82.9v15h72v-15h-6.8v5.8H276v-5.8h-12.2v5.8H248v-5.8h-12.2v5.8h-9v-5.8z"
            }),
            /* @__PURE__ */ jsx101("path", {
              strokeLinejoin: "round",
              d: "M228.7 102.4v54.4h12.8v-20.4c0-9.5 6.4-14 14.5-14 7.8 0 14.5 4.5 14.5 14v20.4h12.8v-54.4z"
            })
          ]
        })
      ]
    })
  ]
});
var Gi_default = SvgGi;

// src/country-flag-icons/generated/Gl.tsx
import { jsx as jsx102, jsxs as jsxs95 } from "react/jsx-runtime";
var SvgGl = (props) => /* @__PURE__ */ jsxs95("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx102("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx102("path", {
      fill: "#d00c33",
      d: "M0 240h640v240H0zm80 0a160 160 0 1 0 320 0 160 160 0 0 0-320 0"
    })
  ]
});
var Gl_default = SvgGl;

// src/country-flag-icons/generated/Gm.tsx
import { jsx as jsx103, jsxs as jsxs96 } from "react/jsx-runtime";
var SvgGm = (props) => /* @__PURE__ */ jsxs96("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx103("defs", {
      children: /* @__PURE__ */ jsx103("clipPath", {
        id: "gm_svg__a",
        children: /* @__PURE__ */ jsx103("path", {
          fillOpacity: 0.7,
          d: "M0-48h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs96("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#gm_svg__a)",
      transform: "translate(0 48)",
      children: [
        /* @__PURE__ */ jsx103("path", {
          fill: "red",
          d: "M0-128h640V85.3H0z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#fff",
          d: "M0 85.3h640V121H0z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#009",
          d: "M0 120.9h640V263H0z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#fff",
          d: "M0 263.1h640v35.6H0z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#090",
          d: "M0 298.7h640V512H0z"
        })
      ]
    })
  ]
});
var Gm_default = SvgGm;

// src/country-flag-icons/generated/Gn.tsx
import { jsx as jsx104, jsxs as jsxs97 } from "react/jsx-runtime";
var SvgGn = (props) => /* @__PURE__ */ jsx104("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs97("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx104("path", {
        fill: "red",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx104("path", {
        fill: "#ff0",
        d: "M213.3 0h213.4v480H213.3z"
      }),
      /* @__PURE__ */ jsx104("path", {
        fill: "#090",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Gn_default = SvgGn;

// src/country-flag-icons/generated/Gp.tsx
import { jsx as jsx105, jsxs as jsxs98 } from "react/jsx-runtime";
var SvgGp = (props) => /* @__PURE__ */ jsxs98("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx105("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx105("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx105("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Gp_default = SvgGp;

// src/country-flag-icons/generated/Gq.tsx
import { jsx as jsx106, jsxs as jsxs99 } from "react/jsx-runtime";
var SvgGq = (props) => /* @__PURE__ */ jsxs99("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx106("path", {
      fill: "#e32118",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx106("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx106("path", {
      fill: "#3e9a00",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx106("path", {
      fill: "#0073ce",
      d: "M0 0v480l180-240z"
    }),
    /* @__PURE__ */ jsxs99("g", {
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx106("path", {
          fill: "#fff",
          d: "M281.6 191.8h76.6V272c0 27-35.2 6.2-38.2 20.6-5.2-14.8-38.2 6.6-38.2-22.2z"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "#73452b",
          strokeWidth: 0.2,
          d: "M325.4 279.8s-1 1-2.8.2c-1.8-.8-2-51.4-2-51.4 4-4.4 7.2-5.8 7.2-5.8l2.4 2c-9 4.6-8.2 11.2-7.4 22.6.2 4.2.2 9.6 1.2 14.8 1.4 6.6 4.2 12.2 4.4 16.4.2 2.6-3 1.2-3 1.2z"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "#73452b",
          strokeWidth: 0.2,
          d: "M319.2 221.6h3.6c-3 29-.4 46.2-.4 54.6 0 2.8 1.6 3.8 1.4 3.8-3.6 4-5.4-.2-5.4-.2z"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "#a36629",
          strokeWidth: 0.2,
          d: "M313.6 279.8c-3.4 1.6-3.8-1.6-3.6-2 7.4-15 10.6-48 3.8-51.6l.4-3.2c2.6.8 5 4.2 5 4.2 1 37 0 52.2-.6 52.8-3.6 3.8-5-.6-5.2-1"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "none",
          strokeWidth: 0.2,
          d: "M313.4 279.2c-.6-3.2 5.2-11.4 4.8-20m5 7c1.8 5 2.6 9.4 2.2 13.6"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "#009a3b",
          strokeWidth: 0.2,
          d: "M331 208c1.2-1.4 1.2-1.4 3.4-1.4.4-3 5.4-3 5.8.8 4-.8 4.8 1.6 3.2 4 3.8-1 7.2 0 6.2 4.4 6.8 1.8 4.2 6.6 1.2 7.6-.4 3-3.2 4-7 2.8-4.8 3.4-7.6 2.2-9.8-1.2-5.4.8-5.8-.4-8.2-3.4-4.2 1.8-5 1.8-8.6-.4-.2 2.8-1.2 2-3 1.8.2 3.6-1.2 5.2-4.4 4 2.4 5-3.8 7.2-6.8 3-2.8.2-3-.6-4.4-1.6-1.2 4-5.6 3.4-6.4 1.2-5.6-.8-5-3.8-.4-4 .4-3.2 3.2-2.6 5-2.2.2-2 1.4-1.6 2.4-1.2-.6-1.4-.2-2.2 1.6-2.6-2.6-3.4-1-4.6 1.6-5.8-1.4-3.2 1-3 2.8-3.2-.2-3.4.8-4 4.4-4.4-.4-1.2.2-2.2 2.2-2.2-1.2-3.4.4-4.2 4-3.6.6-5 11.2-2.6 10.4 4.2 3 .4 4 1 4.8 3.4z"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "none",
          strokeWidth: 0.2,
          d: "M309.6 206.2c.8.4 1.8 0 2 2.2 1.6-2.8 3.6-1.2 3.6 2m11-5.8c-.8 1.2-3.8 1.2-3.4 4.4-1-1.4-3-1.8-3.8-.4m12-.6c0 .8-.2 3.2-1 4.4m13.4-1c.2.2-2.8 0-4.2 1m11.6 11c-.8-.4-2.4-1.4-3.6.2 0-.8 0-3-2.2-3m-1.2 5.6c0-2-.4-2.6-.8-3.2m-5.8.4c-1.6-1.2-3.2.6-3.2 1.6m-8.4-3.4c0-.8-.6-2.4.8-3M302.8 230c.4-2 1.8-2 1.6-3-.2-1.6-2-3-4.2-.8m4.2.8c1.2-.4 2.4-.2 2.8.4m-6.2-7.8c.8-.8 2.8-.6 4 0m0-4.8c1 0 2.8-.4 3.4 1.4 2.2-3.4 3.8-3 4.2-2.2m4-.4c1.6-.6 4.4 1 6 3.8.8-2.2 2-1.8 3.2-2m7.6 2c2.6-1.2 4.2 1.2 5 2.2 1.2-1.6 2.2-1.6 3.4-1.6m-32.6 4.2c.6-1 2-1.2 3-.6-.2-1.8 1-2.6 1.8-2.2"
        }),
        /* @__PURE__ */ jsx106("path", {
          fill: "gold",
          strokeWidth: 0.7,
          d: "m317.4 180.5-4.4.2-2.2 4-2.4-3.8-4.4.2 2-4-2.4-3.7 4.6-.2 2-4 2.4 3.8 4.4-.2-2 4zm-18.8 1.5-4.4 1-1.2 4.3-3.2-3.2-4.2 1 1.2-4.2-3-3.2 4.2-1.1 1.2-4.3 3.2 3.2 4.4-1-1.4 4.3zm-18.2 3.7-4 2-.2 4.4-3.8-2.4-4 2 .4-4.5-3.8-2.4 4-2 .4-4.5 3.6 2.5 4-2-.2 4.4zm42.8-5.2 4.4.2 2 4 2.4-3.8 4.4.2-2-4 2.4-3.7-4.4-.2-2.2-4-2.4 3.8-4.4-.2 2 4zM342 182l4.2 1 1.2 4.3 3.2-3.2 4.2 1-1.2-4.2 3.2-3.2-4.4-1.1-1.2-4.3-3.2 3.2-4.2-1 1.2 4.3zm18 3.7 4 2 .2 4.4 3.8-2.4 4 2-.2-4.5 3.6-2.4-4-2-.2-4.5-3.8 2.5-4-2 .4 4.4z"
        }),
        /* @__PURE__ */ jsxs99("g", {
          fill: "#fff",
          strokeWidth: 0.7,
          children: [
            /* @__PURE__ */ jsx106("path", {
              d: "m365.4 270.4 5 7.2 4.6-6.8-3.2-5.8zm-31.8 21 .4 7.2s2 0 3.8-.6c1.6-.6 3-1.8 3-1.8l-.2-3.8zm-26.8 0-.4 7s-1.8 0-3.6-.4c-1.6-.4-3-1.4-3-1.4l-2-4.8zm-32.2-21-5.2 7.2-5.6-9.2 4.2-4.4z"
            }),
            /* @__PURE__ */ jsx106("path", {
              d: "M299.6 305.8c0 6.8 41.2 6.8 41.2 0v-9.6c0 5-41.2 4-41.2 0z"
            }),
            /* @__PURE__ */ jsx106("path", {
              d: "M262.8 283.6c3.6 18.4 36.8 18.8 36.8 18.8v-6.2c-.8-2.4.6-3.2 6-4 2.2-.2 1.2-3.4 1.2-3.4s-14.4 2.6-24.6-1.4c-13.8-5.6-15.8-16.4-15.8-16.4s-1 8.4-3.6 12.6zm114.6 0c-3.4 18.4-36.6 18.8-36.6 18.8v-6.2c.6-2.4-.8-3.2-6.2-4-2.2-.2-1-3.4-1-3.4s14.4 2.6 24.6-1.4c13.6-5.6 15.2-16.4 15.2-16.4s1.4 8.4 4 12.6z"
            }),
            /* @__PURE__ */ jsx106("path", {
              d: "M265.4 276.6c-9.2-5-2-10.2-1.2-25 1.4 9 11.6 12.8 10.4 18.6-4.2.2-6.2-6.2-8.2.8zm109.4 0c9.2-5.2 1.6-10.2.8-25-1.4 9-11.4 12.8-10.2 18.6 4 .2 6-6.2 8 .8l1.4 5.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx106("path", {
          stroke: "none",
          d: "m271 283.4 1 .8-2.2 2.4c-1 1-1.1 1.6-.5 2.2.7.7 1.3.4 2-.4l2.5-2.6.8.8-2.4 2.8c-1.3 1.5-2.5 1.2-3.6.2-.8-.8-1.4-2 0-3.5zm4 3.4 1 .6-.2 4.8 2.2-3.4 1 .6-3.2 5.2-1.2-.6.2-4.8-2.2 3.4-1-.6zm1.8 8.4 2.8-5.6 1 .6-2.6 5.4zm4.4-4.8-2.2 5.8 2.2.8c2 .7 3-.2 3.6-1.9.7-1.8.4-3-1.6-3.9zm.8 1.4c2 .7 2.2 1.5 1.6 3-.6 1.3-1 1.8-3 .8zm5.8.8-3.6 5.4 1.4.4.8-1.4 2.4.6.2 1.4 1.4.2-1.4-6.4zm.4 1.4.4 2.4-1.6-.2zm3-.9-.2 6.2h2.3c2.2.1 2.8-1 2.9-3 0-1.8-.7-3-2.9-3zm1.2 1c2.2.1 2.5.8 2.5 2.3-.1 1.5-.4 2.1-2.6 1.8v-4zm19.8 7.7v6.4h1.4v-2.4s1.2 0 2.2-.2c.7-.2 1.3-.7 1.3-2 0-1.2-.7-1.8-1.9-1.8zm1.4 1h1.4c1.1 0 1 1.8 0 1.8h-1.4zm5.8-1-2.6 6.4h1.4l.6-1.6h2.6l.6 1.6h1.4l-2.6-6.4zm.6 1.4 1 2.4h-1.8zm3.4 3.8 3.4-4.2h-3v-1h4.8v1L325 307h3.6v1.2h-5.2zm20.2-12.4 1.2-.2.6 3.6c.2 1.3-.4 2.1-1.3 2.5-1 .4-2.4 0-2.5-1.7l1-.2c.2 1 .6 1.1 1 1 .5-.2.7-.8.6-1.4zm2-.4 1.1-.2.6 3c.2 1.3.6 1.8 1.5 1.7 1-.2 1.1-.8.9-2l-.7-3.1 1.2-.2.8 3.3c.4 2-.6 2.7-2 3-1.1.2-2.4 0-2.8-2zm6.2 2.8 1-.4c.5.9 1.2.8 1.8.6.8-.4 1-1.1.5-1.4-.6-.3-2 .2-2.7 0-.9-.4-1.3-1-1.2-1.7 0-1 .8-1.4 1.7-1.7 1-.3 2-.2 2.7 1l-1.2.4c-.4-.7-1-.6-1.4-.4-.4.2-1 .5-.6 1 .2.5 1.7.2 2.5.2s1.4.6 1.5 1.3c.2 1.1-.2 1.7-1.5 2.2-1.5.6-2.9 0-3.1-1.1m5.4-5-1.6.8-.4-1 4.4-1.8.4.8-1.6.8 1.8 4.4-1 .6zm2.6-2.2 1-.6 2.8 5.2-1 .6zm6.8.4 1.2-.4a2.4 2.4 0 0 1-2.4 3.3c-3 0-3.4-3.4-2.9-4.5.8-1.9 3-1.8 4-.8l-1 .8c-.6-.8-2-.3-2 .4a2.7 2.7 0 0 0 1.4 3c1 .4 2.4-.8 1.7-1.8m-.6-4.2 1-.8 3.6 4.8-1 .8zm3.8-3-1 .8 2.2 6 1-1-.6-1.2 1.8-1.6 1.2.6 1-.8zm.4 1.4 2 1-1.2 1.2z"
        })
      ]
    })
  ]
});
var Gq_default = SvgGq;

// src/country-flag-icons/generated/Gr.tsx
import { jsx as jsx107, jsxs as jsxs100 } from "react/jsx-runtime";
var SvgGr = (props) => /* @__PURE__ */ jsxs100("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx107("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 0h640v53.3H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 53.3h640v53.4H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 106.7h640V160H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 160h640v53.3H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#0d5eaf",
      d: "M0 0h266.7v266.7H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 213.3h640v53.4H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 266.7h640V320H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 320h640v53.3H0z"
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 373.3h640v53.4H0z"
    }),
    /* @__PURE__ */ jsxs100("g", {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 1.3,
      children: [
        /* @__PURE__ */ jsx107("path", {
          d: "M106.7 0H160v266.7h-53.3z"
        }),
        /* @__PURE__ */ jsx107("path", {
          d: "M0 106.7h266.7V160H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#0d5eaf",
      d: "M0 426.7h640V480H0z"
    })
  ]
});
var Gr_default = SvgGr;

// src/country-flag-icons/generated/Gs.tsx
import { jsx as jsx108, jsxs as jsxs101 } from "react/jsx-runtime";
var SvgGs = (props) => /* @__PURE__ */ jsxs101("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs101("defs", {
      children: [
        /* @__PURE__ */ jsxs101("linearGradient", {
          id: "gs_svg__b",
          children: [
            /* @__PURE__ */ jsx108("stop", {
              offset: 0,
              stopColor: "#d5dfff"
            }),
            /* @__PURE__ */ jsx108("stop", {
              offset: 1,
              stopColor: "#fff"
            })
          ]
        }),
        /* @__PURE__ */ jsxs101("linearGradient", {
          id: "gs_svg__a",
          children: [
            /* @__PURE__ */ jsx108("stop", {
              offset: 0,
              stopColor: "#474747"
            }),
            /* @__PURE__ */ jsx108("stop", {
              offset: 1,
              stopColor: "#f50"
            })
          ]
        }),
        /* @__PURE__ */ jsx108("linearGradient", {
          xlinkHref: "#gs_svg__a",
          id: "gs_svg__c",
          x1: 109.3,
          x2: 110.9,
          y1: 218.5,
          y2: 173.4,
          gradientTransform: "matrix(1.178 0 0 .50849 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs101("linearGradient", {
          id: "gs_svg__d",
          x1: 125.9,
          x2: 126,
          y1: 316.4,
          y2: 337.2,
          gradientTransform: "matrix(.96067 0 0 .6235 388 38.3)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx108("stop", {
              offset: 0,
              stopColor: "#b50000"
            }),
            /* @__PURE__ */ jsx108("stop", {
              offset: 1,
              stopColor: "#ffc500"
            })
          ]
        }),
        /* @__PURE__ */ jsx108("linearGradient", {
          xlinkHref: "#gs_svg__b",
          id: "gs_svg__e",
          x1: 407.9,
          x2: 456.4,
          y1: 149.4,
          y2: 147.4,
          gradientTransform: "matrix(.4361 0 0 1.37349 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx108("linearGradient", {
          xlinkHref: "#gs_svg__a",
          id: "gs_svg__f",
          x1: 215.8,
          x2: 229,
          y1: 103,
          y2: 103,
          gradientTransform: "matrix(.57794 0 0 1.03641 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx108("linearGradient", {
          xlinkHref: "#gs_svg__b",
          id: "gs_svg__g",
          x1: 117.6,
          x2: 78.2,
          y1: 1040.4,
          y2: 1003.7,
          gradientTransform: "matrix(1.9991 0 0 .29962 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx108("linearGradient", {
          xlinkHref: "#gs_svg__b",
          id: "gs_svg__h",
          x1: 264.7,
          x2: 255,
          y1: 246,
          y2: 226.4,
          gradientTransform: "matrix(.69142 0 0 .86628 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#006",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#6a4c2d",
      stroke: "#000",
      d: "M471 345s-2.6 6.8-4 6.8c-1.6 0-7-3-7-3s-3.9 6.4-6 6.7c-2 .4-7.4-.9-7.4-.9s-5.2 0-5.4-.7c-.2-.8.2-2.3.2-2.3s-7.5 6-9.1 5.6c-1.7-.3-7.3-7.4-7.3-7.4l-1 3.7-10.6-.4-9.3-6s-5.2 8.6-5.4 8.4c-.2-.1-9.1 2.1-9.1 2.1l-.6-1.7-6-3.5s4.7-6.5 4.7-6.7c0-.2-2.2-1-2.2-1l-3.4 2.8-6.9 4.5-6.9-3.2 3-5.6.4-4 5.4-8.3 66.2-64.3 32.6 60.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "m518 348.8 17.3-.6-7.4-3.6 65.7-2.5-9.3-3.5-8.2-11.2-34-2.5s-2.6-2-6.7-1c-.2-2.6-3.4-6-3.4-6l-21-1.7-13 9 8.8 22.6z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "url(#gs_svg__c)",
      stroke: "#000",
      d: "m451 156 1.8-6s3-5 3-7.4c0-2.2 2.3-4.9 2.3-4.9s6.9-2 8.4 2.3c7.4-11.3 16.2-.6 16.2-.6l2.4-2.8 5-6s7 6.5 7 7.6c.2 1.2 1.3.4 1.3.4l7.6-.6a9 9 0 0 0 2.9 8.2c2.7 1.6 5.1 11 5.1 11z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#656263",
      stroke: "#000",
      d: "M518 226.1c1.4-.8 5.5-2.1 5-8.2-.5-6-5.7-6.8-8.7-6.6-3 .2-5.5 2.8-5.5 2.8l-9.8-6.2s4.9-30.7 10-32.6c5-3.5 5.8-5 5.8-5.8 0-.9-1.8-2.9-1.8-2.9l-31.7-3.7-30 3.5s-2.2 3.6-2 5c.4 1.4.5 2.9 5.8 7 6 4.6 10 30.8 10 30.8s-8.3 4.2-8.9 3.6c-.5-.5-3-1-4.3-.8-1.3.2-5.7 2.5-5.7 8.2 0 5.8 4.4 9.1 4.4 9.1s28.6-3.3 32.9 4.6c4.1-9.5 31.3-6.2 34.6-7.8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M548.9 194.2s.3-3.3 2.7-4.9c2.4-1.6 18.2-2.4 22 0 3.8 2.4 5.2 14.1 5.2 14.1s2.4 4.1 2.6 7.2c.1 3 .5 5 .5 5s12.6 16.5 12.8 31.4c1.4 10.1 1.1 37.2-2.9 47.5a43.4 43.4 0 0 1-5.5 21.3s1.3 2.2 1.1 4.6c-.2 2.3-1.4 4.6-1.4 4.6l18.5 9.1-6.8-2.5 6.8 5.7-7.7-3.6 4.5 4.6c-.1-.2-11.2-5.1-11.2-5.1l5 4.7-8.5-4s5 5.5 5 5.2a91 91 0 0 0-7.4-3.2l.4 2.7s-5.8-.3-5.8-4.6a19 19 0 0 1-4.7-3.8l-13.2-2.2-14.9-44.6 3.5-75.2 1-3.8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fb0",
      stroke: "#000",
      d: "M539 434.8s-7.7-16-11.5-16.3c-3.4-6.6 12-60 41.7-63.1 16.3 1.3 1.3 18.8-9.4 13.4a44.7 44.7 0 0 0 6.7 11.5s-21.3 9.2-27.6 54.5zm-102.3 2.3s6.3-18.3 10.1-18.5c3.9-.2-10.1-60.9-40.6-61.3-16.4 1.3-1.3 18.9 9.5 13.5a44.8 44.8 0 0 1-6.8 11.5s21.5 9.2 27.8 54.8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00713d",
      stroke: "#000",
      d: "M464.6 323c0-.2-7.6 2.3-2.7 10.5.3-3.2 3.7-5 3.7-5s-5.1 6 .3 11.1c.7-4.8 3.8-6.3 3.8-6.3s-3.9 11.2 0 13.5c.5-4.5 3.3-6.5 3.3-6.5s-3.4 10-.3 12.3c.3-3.8 2.9-5.5 2.9-5.5s-1.5 10.5 2.5 11.2c0-3.7 3-7.3 3-7.3s-1.3 8.5 5 8.9c0-3.2 1.2-6.9 1.2-6.9s2.9 9 7 7.6v-7.7s2.7 8.6 7.7 7c-.7-2.4.3-5.3.3-5.3s2.6 5.4 7.4 3.6c.8-1.6-.2-4.8-.2-4.8s7 7.2 9 2.9c2.2-4.3-5.5-5.8-5.5-5.8h5.2s-1.7-4.4-8.7-5.4c2.4-1 4.9-.2 4.9-.2s-1.5-5.5-8.7-6.1c2.8-1 6-.3 6-.3s-1-5.2-9-6.7c1.3-1.4 4.7-1 4.7-1s-3.2-4.9-6.8-4.6c-3.6.3-36-3.3-36-3.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#3ec26d",
      strokeLinecap: "round",
      d: "M496.6 349.5s3 1.4 2.8 2.6m-1.1-4.9s3.7 2.6 3.6 4.5m-.3-5.8s2.9 1.8 3 4.7m1.9-3.6s1.4 3.2 1 3.8m1.9-2.1c.2 2.5-.2 2.8-.2 2.8m-36-18.5s3.5 2.2 3.2 5.3m-3.4-2.7s1.6 1.6 1.3 2.6m3-5.2s2.3 3.2 1.5 5.4m2.4-3.3s1 2 0 3m1.8-2.1s1.2 2 .1 2.7m-1.5 3.9s3.2.7 3.7 3.1m-1.8-5.3s3.4.2 3.8 3.8m.7-5.1s2.3 4 1.9 5.2m2.4-4.8s.9 3.7.2 5m2.6-3.5v4.3m-4.2-10.2s2 .8 2 2.9m-.1-4.8s2.7 1.5 2.5 4.5m.7-5.7s2.3 2.7 1.5 5.8m2.5-5.2s-.8 3.5-.4 4.9m3-2.5s-1.5 1.1-.7 2.6m-12.7 10.8s.5 2.6 0 3m-3.3-4.6s1.6 3 1 4.4m-4.6-4.5s1.9 2.2 1.8 4m-4.8-3.6s1.8 1.7 1.6 2.7m-3.1-.1s1.7 1.8 1.6 2.1"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "m441.3 229.3 24.3-.5s16 0 17.7 5.2c3-6.9 17-6.5 17-6.5l25-.8.5 60.6c-5 23.6-22 40.2-40.7 47.3a62.3 62.3 0 0 1-41.2-47.7z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#006b00",
      stroke: "#000",
      d: "m450 229 35.3 94.2 32-96.2c-10 .6-31.2-1.6-33.9 7.5-4-8.1-26.4-4.9-33.5-5.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M474 280c1.4.7 1.3-25.5 3.1-26.3l1.4-5.5c-1.5-2.7-8.4-2.6-11-.2l1.7 4.8c3.5 5.6 2.8 27.8 4.8 27.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#cdad56",
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M464.5 77s2.5-2.9 2.6-3.5c.2-.7 11.4-1.2 18-13.7 3.8-6.5 0-2.7 0-2.7L485 54s4.6-4.4 3-6.8c-1.8-2.4-1.2 3-4 3-2.7-.1-1.2-6-1.2-6s-.2-.6-1-1c-1.1.2-.8 2.2-1.8 2.4-1 .3-2-4.7-2-4.7s-1.7-2.3-3.1 4.8c.8 7.7 5.6 6.2 5.6 11.2 0 5-4.3 8.8-5.5 9-1.3 0-.8-4.3-.8-4.3s-.7-2-1.1-2c-.5 0 2.5-.5 2-6.1-1-6.8-1.8 1.6-3.6 1.2-1.9-.3-.5-6.2.2-7 .7-.6-.8-3.4-4.8 3.8-.3 3.6-.8-.9-1.6-.6-1.3 2.8-1.1 4.8.8 7.4 2.9 2.7 4.7 5.3 4.6 6.6-.1 1.4-1.6 4.5-3.7 4.5-2 0 .1-3.8 0-5 0-1.3-3.5-5.8-3.5-5.8s-2.4-3.9-2.1-4c.2-.1-.3-.7-1.4 3.3-1.1 4-2.5-2.6-2.5-2.6s-1.6 4.9 1.8 7.8c-2.6-.3-2.8.7-2.8.7 0 1.4 3.5 2 4 4.3.4 2.4-3.7 3.8-3.7 3.8s1.7 2.3 6.5-2.3c.1 3-1.8 5-1.8 5 1.6.7 2.8.6 3 2.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#cdad56",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.9,
      d: "M449 77s-2.2-3.2-2.3-3.8c0-.6-10.4.8-15.3-11.8-3.2-6 0-2.5 0-2.5l.2-2.9s-3.4-4.1-2-6.3c1.5-2.2 1 2.8 2.8 2.8 2.3-.1 1-5.4 1-5.4s.2-.6 1-.9c.9.1 1.3 3.2 2.1 3.4.9.2 2.7-3.6 3.3-4.4.8-.1.7-3.2 2 3.3-.7 6.9-6.4 5.5-6.4 10 0 4.6 3.6 8.1 4.7 8.2 1 .2.7-3.8.7-3.8s.6-1.8 1-1.8c.3 0-3.4.7-3-4.5.8-4.8 2.7.3 4.3 0 1.5-.3-.2-5 .2-5.8.1-.8 2.4-3.9 3.3 3 .3 3.3 2-2.7 2.7-2.5 1.2 2.6-.5 6-2.1 8.4-2.4 2.4-3.5 5-3.4 6.2 0 1.3.6 2.8 2.4 2.8 1.7 0 .5-2.2.6-3.3.1-1.1 3-4.8 3-4.8.6-1 .1-2.6.7-3.4 1 0 1.4-1.3 2.3 2.3 1 3.6 2.1-2.4 2.1-2.4s1.4 4.5-1.5 7.2c2.2-.3 2.4.6 2.4.6 0 1.2-1 1.7-1.4 4a3.7 3.7 0 0 0 1.1 3.3s-1.4 2.2-5.5-2a7 7 0 0 0 1.6 4.5c-1.4.7-2.4.6-2.6 2.3z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffc900",
      d: "M511.3 243c-2-1.8-2.3-.2-3.4-.6-.5-.2-.9-.7-1.3-1.1-.4-.4-.9-.6-1.4-.8l-.6 1.7c-.2.6.6 1.5.6 2.4-.2 1.3-.7 2.3-2.3 2.7.5-.9.7-.9.6-2 0-.5-1.6-1.5-1.4-2 .2-.9.7-1.8.4-2.7-.7.5-1.5.2-2.2.5-.5.3-.6 1.3-1.3 1.7-.8.4-2.5.2-4-.6.9-.7 1.6-.2 2.5-1 .4-.2.4-1.7.9-2l1.9-1c-.4-.5-.4-1.2-.8-1.6-.4-.5-2.1-.4-2.5-.8-.8-1-.7-2.1-1.4-3 2 .7 1.7 1.7 2.2 1.6 1-.5 2-.5 2.5-.3s1.4 1.5 2 1.7l.6-1.9c.2-.6-.8-1.5-.7-2.1.4-1.1 1.4-2.1 1.8-3.3l.4 3.1c.1.6 1.2.9 1.2 1.4.1.6-.5 1.8-.5 2.4.6-.1 1.5 0 2-.2.7-.1 1-1.5 1.6-1.6 1.2-.2 2-.1 3.3 0-1 .9-1.6.8-2.1 1.6-.5.3.1 1.4-1.1 2.2-.5.3-1.8 0-2.2.3l1.2 1.3c.4.5 2.1.7 2.5 1.2.8.8 1.2 2 1 2.9zm-54.3 1c2-1.9 2.3-.2 3.4-.7.5-.2.9-.6 1.3-1 .4-.5.9-.6 1.4-.9l.6 1.8c.2.5-.6 1.5-.6 2.3.2 1.3.7 2.3 2.3 2.8-.5-1-.7-1-.6-2 0-.6 1.6-1.6 1.4-2.1-.2-.8-.7-1.8-.4-2.6.7.4 1.5.2 2.2.4.5.3.6 1.3 1.3 1.7.8.4 2.5.2 4-.6-.9-.7-1.6-.2-2.5-.9-.4-.3-.4-1.8-.9-2-.4-.4-1.5-.8-1.9-1.1.4-.5.4-1.2.8-1.6.4-.5 2.1-.4 2.5-.8.8-1 .7-2.1 1.4-3-2 .7-1.7 1.7-2.2 1.6-1-.4-2-.5-2.5-.3s-1.4 1.5-2 1.7l-.6-1.9c-.2-.5.9-1.5.7-2-.4-1.2-1.4-2.2-1.8-3.4l-.4 3.2c-.1.5-1.2.8-1.2 1.3-.1.6.5 1.9.5 2.4-.6-.1-1.5 0-2-.2-.7 0-1-1.4-1.6-1.6-1.2-.2-2-.1-3.3.1 1 .8 1.6.8 2.2 1.5.4.4-.2 1.5 1 2.2.5.3 1.8 0 2.2.3l-1.2 1.4c-.4.4-2.1.6-2.5 1-.8 1-1.2 2-1 3"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M509.4 249.2c-1.9 1.5-14.3 4.6-14.4 15.3-.1 10.8 2.2 13.2-.1 13.5-4.5 0-5.1-12-5-17.3.1-5.3.3-4.5.3-4.5s3 .8 2.8 3.4c-.3 2.6 3-6.4 1.9-8.8 2 2 4.7 1.2 4.7 1 0 0-1.5-1.7-2.2-3-.6-1.1 2.3.8 2.3.8s.2-2-2.4-2c-3.3 0 .5-1 .5-1s2 1.7 3.2-.2a11 11 0 0 0-3.4-2.3s-1.8-3.4-4.2-4c-2.8-.7-2.5 1.2-5.7.9-.6 1.2-.6 1.4.7 1.8-2.2 1.5-1 4.4-1 4.4s3.4-1.4 3.3 1c-.1 2.5-2 2-3.3.5-1.2-.6-1.6.7-1.6.7l1.8 2s-3.4-.2-4.3 2.1c1.9-.1 3 .4 3 .4s-4 1.8-4.4 2.7c-.4 1-.5-1-.7-1l-3.8-1.4-1.3 5.9s2.6 2.5 4 1.7 4-3.3 5.5-2.6c-4.5 3.4-9 8.3-11.4 9-.6-.6-2.8-2.7-3.7-1.6-.9 1-.2 2.4 1 2.3 1-.2-3.8 1-2.8 3.1 1 2 1 1.9 1.8 1.4 1-.6-.7-.7 2.6-1.7s3.2-1.9 3.2-1.9-.7 1.5-2.5 2c-1.7.3-3.1.3-2.8.9.4.5 1.2 1.5 1 2-.3.6 3.6-2.8 4.7-.1 2.6-.2 4.4-3.4 3.1-5.3.2 2 1.4 2.7.7 3.7-.8.9 6-3.2 2.7-5.6.8 2 1 3.6 1 3.6s1.5 0 1.9-.6c.4-.6-.8 1.5-.3 1.9.5.4 3 2.7 2 4.3-.7-1-.8-2.4-1.6-2.3-.8.1-4 2.5-5.9 2.6-1.9.1 2.3 7 2.3 7s-2.9-.3-3.3 0c-.4.2-2.3-2.5-2.6-.9-.7 2 .6 1.2.6 1.2s-1.7-.8-2.6.2c-.9 1-1.7 1.9-1.1 2.3.6.4 3.4.4 3.8.3.4-.2-3.2.2-3.4.6-.3.4-.8 2 0 2.5.7.5 2.7-.3 2.8-.7.1-.4.2 1.5.2 1.5s3.3.3 3.3-3.1.3 2.4.3 2.4 3.3.6 3.4-2.8c.2-3.4.4 2.3.4 2.3s2.2-.7 2.2-1.2c0-.6-.1 6.7-1.7 8.8-2.4-1.6-4 1-4 1s.2 4 0 5c-.3 1 1.6-.6 1.7-1 .2-.4 2.5-1.5 2.6-1.7l.8-1.7s-.6 2-1.4 2.2c-1 .3-1.8 1.2-1.4 2 .3.9 1.7 1.4 2.2 2.2.6.8 2.3-4.7 2.3-4.7l.2 1.2s2.3-.6 2.5-1.7c.3-1-2.4-2-.2-3.8 2.1-1.7 0 1.7 0 1.7s.7 2.6 1.2 2.6c.6 0 1.8-5 .6-6.2-1.3-1.2 1.9 1.5 1.9 1.5s1.8-5-.2-5.7l-2.8-1s1-1.3.5-1.4c-.5-.2 2.7 3 3.2 2.1.5-.8 1.3-3.2-2.4-4.6-3.7-1.3-.1-5.1-.1-5.1s2.3 2.7 4 1.2c1.6-1.5-.2-1.5-.2-1.5s4.7-3 4.9-4.5c-1-.1-2.5.1-2.5.1s2.7-1.7 2-4.6c-1 1.5-2.4 1.5-2.4 1.5s2.3-2.3 2-4.5c-1.4 1.1-1.3 2-2.2 1.7-.9-.3-2.4-8.9 1.1-9.4 3.6-.6 1.7 4.2 1.8 4.2.2 0 5.4-2.2 0-5.7 1.3-.4 4 2 4 2s-1.2-6-7-2.3c1.5-1.5 2.4-2.4 3.5-2.2 1.2.3 5.3-.1 5.3-1.3-1-.8-3.2.4-4.4 0-1.1-.4 8.2-1.1 7.4-5.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M469 252.7s5.1-2.9 7.6.7m2.1 5.4c-.1 0-1.8 1.8-2.2 1.8m5.6 3.9s4.8.4 7.8-4.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M487.2 263s.4 2.7 1.2 2.7c.7 0-1.3.7-2 .2.8 1.2 1.3 3.4 0 4.2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M484.8 297.3s-1.6 1.9-3.7 2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M486.7 288.6s-1-5.5-.4-6.8c.4-1.8 2-2.5 3.4-4.8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M486.2 284.6s-1.3 3.3-6.9 2.2m8.4-10.3s.4 4.3-4.7 2.7m-1.5-22.2s-2 1.8-1.3 4.4"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#006b00",
      d: "M489.1 252.1s2.7-1 3.2-1.6a8 8 0 0 0 1.7-2.4c.2-.8-1.8-2-.8-3.8.7-.9 1.6-1 3 0 1.6 1-1.3-3-2.8-3.2-1.6-.1-2.6 1.1-3 .8-.4-.2.1 1.1-.5 1.1s1.3 1.1 1.2 1.8c-.2.7 2 3 1.9 3.5-.2.6-3.2 3.7-3.9 3.8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffc900",
      stroke: "#ffc900",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M491 243.2c1.2-.3 1.4 0 1.2 1a3 3 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M483 303.7s-.5 2.9.5 3.1c0-1 .3-1.8.5-2.1zm-2.5-3.5c-1-.1-2.5.8-2 1.8.7-.7 1.4 0 2-.7v-1zm0-2s-1.5-.2-1.7.9c1-.2 1.4-.3 1.7 0z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M474.1 282.2s1 .3 1.2 1.3c.7-.4 1-2.6-1.2-1.3zm-2.3 2.4s2-1.2 2.1 0c-.4.3-.5.6-.8.7-.3 0-.8-.8-1.3-.7zm-.1 3.9s1.2-1 1.6-.4c.5.8-.4.7-.4.7zm-1.7-21.9s-1.5-.6-2.1.5c1 .2 1.3.5 1.8.9-.2-.5-.4-1.2.3-1.4zm-2.9 8.3s0-1.9 1-2.6c.4.3.5.7.8 1.2-.6.2-1.4.2-1.8 1.4zm3.9-1.3s-1.6.8-1 1.7c.5-.7 1.1-.5 1.1-.5v-1.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M468.7 255.8c-.6.7.7 2.2 2.1 2 .4-1.6-1.7-2.5-2-2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      d: "M468.7 252.6c-.3.8.9 1.9 1.5 1.6.3-.8-1.2-2.2-1.5-1.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M470.2 254.6s.3 1.3 1.5 1a4 4 0 0 0-1-1.9c0 .3.1.8-.5.9zm.8 3.7s.7.8 2-.7c-.6.1-1.6-.4-1.6-.4s0 1-.4 1.1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M468.6 252.8c-.5.7.3 1.7 1.7 1.5.3-1.7-1.3-2-1.7-1.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "url(#gs_svg__d)",
      d: "M469.2 246.3s5.5-1.6 8.4.8c3 2.3 3 .2 3 .2s4.2 1.6 5.4 1.2c1.2-.3-.9.2.8-.9 1.7-1-3.4.3-3.8-1.9-.8-1.3 0-3-1.7-2.4-1.2-1.6.8-2.7.3-4.4-1.2 1-1.9-.3-2.9 2-2.3-.5-.3-3.8-2.9-4.1 0 2.3-1.9 2.4-2 3.8-1.1.8-6 3.7-4.6 5.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#c01500",
      stroke: "#000",
      d: "M406 425c3.6-1 22.9 4.2 30.3 12.2-1.6-14.3-5.5-25.1-5.5-25.1s-11.5-3.3-13-1.7a80.8 80.8 0 0 0-11.8 14.5zm-5.9-65.7c-1.3.2-2.7 1.1-4 3.4-1.6 3.8-2.7 13.5-5 15.8-2.2 2.2-4.3 2.4-4.3 4.5 0 2 .3 6.7 6.3 8.5 6.1.3 15.8-9.7 15.8-9.7s5-5.4 7-11.2c-11.7 4-20-6.8-15.8-11.3zm169.6 63.4a53 53 0 0 0-30.4 12.1c1.6-14.1 5.5-25 5.5-25 1.3-.3 11.3-3.2 12.8-1.6 2.3 2.4 9.7 9.7 12.1 14.5zm5.5-65.3c1.3.2 1.8 2 3 4.2 1.5 3.9 3 9.4 5.3 11.6 2.3 2.3 4.3 5.6 4.3 7.6s-.5 4.8-6.5 6.6c-6 .2-14.8-7.6-14.8-7.6s-5-5.3-7-11.2c11.7 4 19.2-6.3 15.7-11.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fb0",
      stroke: "#000",
      d: "M393.4 412.5s12.1 8.4 12.4 12.2c32.7-48.5 116.1-63.6 163.7-3.4 6.3-8.3 12.8-11 12.8-11-50-65.4-149.7-57.3-189 2.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#1e5aa6",
      stroke: "#000",
      d: "m517.4 227 4.8-.1-8.5 10.8 10.2 11.9-20.1 25.3 19 22.8a57.9 57.9 0 0 1-7.8 14l-10.9-12L524 275l-16.2-18.4zm-68.1 2.2h-5l9.5 10.4-10.1 12.6 21 22.8-17.4 23.3c2 5 5 10.8 8.3 15l10.3-13.1-21.2-23.6 15.5-19.7z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#1e5aa6",
      stroke: "#000",
      d: "m473 290.4-7.6 10 26.8 31c4.8-2.4 8.5-5.1 12.5-8.4l-14-16.1 5.7-16.7 8.2 9.4-25.5 32.6c-4.3-1.8-9-4.6-13.3-8.2l13.5-17.1zm-8.3-15.5 4.8 6.1-3.1-8.3zm34.9 5.4 4-5.2-1.5-2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556 195s4.8-4 8.1-4"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.7 194.5c.1-.1 28.1-4 29-5m-28.9 5.2 31.4-2.7m-31.5 2.8s33.3-1.5 35.3.2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.6 194.7s32.6.3 33.2 1m-33.1-1 31.4 2.6m-31.7-2.3s32 2.8 35 6.8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M593.1 207.5c0-.1-10.8-12.9-36.8-12.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.4 195s18 1.3 23.7 7.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.7 194.8s11.7-2.2 23.9 12.5"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "url(#gs_svg__e)",
      stroke: "#000",
      d: "M549.4 208.2s16.1.6 16.1 2.2-12 4.6-12.2 11.2c-.1 6.7 9.2 7.2 9.9 15.6.6 8.4-7.3 9.6-9 11.9-1.5 1-5.3 13-4.8 20 .5 6.9 2.5 30.5 6.2 35.3 2.8 2.2 7 9.3 11.7 7 4.6-2.1 1.4-10.2 1-12.4-.5-2.2 1.8-5.9 1.8-9.2 0-3.4-1.7-6-1.5-6.8.1-.8 12.8 3 12 15.5-.8 12.5-5.9 8.7-5.9 8.7s1.6 15.4-2.3 17.4c-7.2 3.8-12.4-.8-12.4-.8l.7 3.2-5.5-2.8s-7-10-8.5-14.5a126 126 0 0 1-2.9-28.5c.7-4.3 1.1-29.3.8-30.6-.3-1.2-1.6-22.1-.8-25.3.8-3.2 5.7-17.1 5.6-17.1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ff7000",
      stroke: "#000",
      d: "M532 204s11.2-10.9 17.7-9.6c3.3 0 .2 2.4.2 2.4s5.7.4 6.5 3c.1 1-2.7 1.4-2.7 1.4s2.3.5 2.5 2.5c.2 2.1-24 .5-24.3.4z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M532.6 203.6s12-1.6 17.1-6.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M544.8 200.3s8.9-.4 8.9 1"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M576.3 329.9s7.6-1.8 9.7-4.5c1.2-1 7.9 10-9.7 4.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      d: "M574.3 267s1 5.8-1.8 9.8c-1.4 1.6-5.7 4.3-5.7 6.2 0 1.9 1.6 4.4 1.3 6.6-.3 2.2-2.7 4.5-2.6 6.4 0 1.9 2.7 12 2.4 12.2m-7.6-60.2s-6 2-7.3 8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#c75b00",
      stroke: "#000",
      d: "M557.8 200.3s2 5.7 8.7.3c-4.3-5.9-8.7-.2-8.7-.3z"
    }),
    /* @__PURE__ */ jsx108("path", {
      d: "M562.7 200c0 .3-.3.6-.7.6-.4 0-.7-.3-.7-.6s.3-.5.7-.5c.4 0 .7.2.7.5"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M503.4 187s12.6 13.7 20.7 13.5c1.5 4-3.7 7.8-5.7 9.5-4.2-1.3-8 .3-17.6-11.6.6-7.6 2.7-11 2.6-11.4zm17-31.8c1.7-5 5-9 7.8-9.5-.8-3.8 5.9-20.9 25.3-27.4 1.2 8.7-8.3 17.4-8.3 17.4s28.7-5 34.5-12.2c-.6 3.2-6.4 23.6-37 23.4 11.6 11-3.7 19.8-10.2 17.1 12-9.2-3.5-14.7-12-8.8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#cccccd",
      stroke: "#ccc",
      d: "M530.2 148.1c5.8-3.7 7.9-3.7 12.7-3l-3.5.6s-.3.5 1.8 2.4c-2.4-.6-4.4-2-11 0z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M528 145.7s11.4-6 17.8-10.2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M518.2 210s15.7 4.3 17.5-18.2c-3.4-9.8-8.1-31-.9-37-6.6-4.6-14 .2-14 .2-.4 1-6.3 9.5 1.7 24.3-19-5-11.3 13-11.3 13 .8-3 10.9-5.6 13.4 8.8 1 3.6-6.8 9-6.4 9z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M535.9 192s16.6-9 16.2-30c-14.2.4-19.2 18.6-19.2 18.6z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M461.3 190.9s-12.3 10.7-19.3 7.3c-5.1 3-11.2-2.4-11.2-2.4s7 26.3 32.6 7.3a60.5 60.5 0 0 0-2-12.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M441.9 197.7c1-5.5 5.3-8.2 8.8-3 4.6 1 9.2-18-7.2-14.8 4.6-24.7-9.2-33.9-9.2-33.9s-4.9 27.4-2.6 32.4c2.2 5-3.3-9.3-21-13.4-.3 20.7 19.8 30.3 19.8 30.3s5.6 5.2 11.4 2.4z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M443.5 179.7s-7.7 6.6-6 15.5m-5.7-16.3s-1.8 6.3 2 15.4"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M430.6 196.4s3.6-5.8 11.3 1.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M432.1 156.3c0-.2-11.7 0-4.8 11.9-5.1 1.6-16.7-6-8.7-16-26.3-.7-37-13.3-37-24.9 7.7 8 26.2 4.8 32.7 9.7-8-7.4-6.4-17.7-6.4-17.7s22.4 6.7 26.4 26.6c-1.3 3.9-1.9 10.7-2.2 10.4z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M414 136.5c4.4 4.4 15.5 5.7 21.1 10.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#cccccd",
      stroke: "#ccc",
      strokeWidth: 0.7,
      d: "M419.2 149.5s9.2-1.2 11.9 2c-3.6 0-4.8-.9-10 1 1.4-.7 1-2 1.8-2s-3.3-1-3.7-1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#923f00",
      stroke: "#000",
      d: "M465 77.5s5.1-4.5 10.6-.5c-2.5 7.4-11.4 4.6-11.4 4.6s.3 3.7-.6 5.5c1.8 1.4 3.2 5.8 3.2 5.8s9.2-2.2 11.2 1.8c3.5-.5 6 0 6 0s7.2-1.8 9.7-1.8c2.5 0 10.5 2 11.3 3.6.7 1.4 3.4 11.4 5.2 11.2 1.8-.1-4.3 2.4-6-.1-1.6-2.5-1.1 3.3-1.1 3.3s5 5.3 5.6 6.5c.6 1.2-3.1 10.8-.3 17.5-2.5.2-2.7 2.8-2.7 2.8-.1 3-3.8 3.7-3.8 3.7l-1-4-2.4 1.5 1-3.1s3.4-8.3 3.7-11c.3-2.7-3.1-7.4-5.8-7.4-2.7 0-4.6 8.5-4.6 8.5s-1.3 6.3-.9 7l-1.8-2.1s-1.1 3.8-2 5c-1 1.2-2.9 1.6-2.9 1.6s-1.3-3.8-.8-5.3c.4-1.5 7.2-7.3 6.6-11.4-.6-4.2 0-3.2-.1-3.3-.2-.2-3.6-3.1-3.7-4.8-.2-1.6-4.5 2.1-10.1 1-1.7 3-2 10.5-2 10.5s-.5 9 .6 10c1.2 1.1-3 3.3-3 3.3l-2.9 4-1-2.3-2.1 1.5 1.2-3c-.1-2.3 2.9-8.4 2.9-13.6 0-5.2.3-10.8.3-10.8s-5.4-.3-5.3 5.4c.1 5.6-1.3 6-1 7.5.3 1.7 1.7 6.3 1.3 7.6-.4 1.4-2.2 1.8-2.2 1.8l-.5.7s-5.5 2.6-5.3 3.6l-.2-3-.3-4.3s3.3-2 3.3-7.2-.7-6-.6-7.2c.1-1.2.9-5.5.7-6-.1-.4-3 1.3-4 1.3-.9 0 1.7-3.1 2-5.4.3-2.2-3 2.1-5.7-.4 1.3-2.7 3.1-3.6 3.4-5.6.3-2.1-2 1.7-4.1.2.2-2 2.2-3.7 2.2-3.7s-1.7-.2-2.4 0c-1.3-.4 1.5-2.5 1.7-5.5.1-3-1.7-4.1-1.7-4.3 0-.1-3-2.6-3.4-3.7-.4-1-.4-2.2-.4-2.2s-5 3.6-10.7-4c5.3-4.5 11-1.2 11-1.2s1.5-4.2 8.3-3.9c6.8.3 8.2 4.2 7.9 3.8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M502.4 154.2c.1 0 12.6.4 12.7 7.1.2 6.7-3.8 5-4 5l-9-1.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fffeff",
      stroke: "#000",
      d: "M490.3 152.4s15.6-.1 14.7 6.7c-.9 6.8-4.8 5.4-4.8 5.4l-7.6-.6z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00f",
      stroke: "#000",
      d: "m481.5 151.7 9 .7s5.5.7 5.2 6c-.2 5.1-5.5 5.2-5.5 5.2l-8.8-.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M460.4 154.2c-.2 0-12.6.4-12.8 7.1 0 6.7 3.9 5 4 5l9.1-1.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M472.5 152.4s-15.6-.1-14.7 6.7c.8 6.8 4.8 5.4 4.8 5.4l7.5-.6z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      d: "m481.3 151.7-9 .7s-5.5.7-5.3 6c.3 5.1 5.6 5.2 5.6 5.2l8.8-.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#5e0043",
      stroke: "#000",
      d: "M505.4 226.7s6.5-9.5 9.3-8.5c2.4.8.5 8.2-.6 8.9zm-44.4 1.7c-2.1-2.8-5-10.7-7.8-8.5-2.4.8-.6 8.2.6 8.9z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M465.2 209.5s12.7 7.8 16.8 8c4.2.2 17.3-10.1 17.3-10.1"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#5e0043",
      stroke: "#000",
      d: "m466.5 179 2.4-3 12.1 6 12.4-5.5 2.4 2.6-13.8 9.7z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#474747",
      stroke: "#474747",
      strokeLinejoin: "round",
      d: "M456.8 178.8a51 51 0 0 1 10.3 18.7c1.4 7.9-.8-10.9-.8-10.9s9.7 4.8 10 7.8c.3 3 4.6-.2 4.8-.7l-28-18.2zm48-.5s-10.2 13.4-9 28c-2.1-7-.4-18.5-.4-18.5l-2.2 1.4s-2.4 9.9-5.3 11.4c-.5-1.2-.4-1.6-.4-1.6s-3.1 4-3.7 4.4c-.6.4.2 13.7.2 13.7s1 9.6 2.2 9.5a41 41 0 0 0-3 1.7l-1.3-25.6 2.9-2.9s3.8-4.7 4.1-9.2c-1.6 1.4-3.5 1.8-3.5 1.8s-.5 6.5-2 7.4c-1.6 1-1.6 2.6-1.6 2.6l-.4-8.5z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      d: "m481.4 193.8 2 40.5"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M456.5 213.2s4.7 2.7 6.4 11c15.2-1.1 20 4.2 20 4.2s12.4-6 18.2-4.8c2-4.3 7.8-9.7 7.8-9.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#b4b6b9",
      stroke: "#000",
      d: "m450.2 173.5 31.2 20.4 28.2-18.9s5.8-3.2 5.3-5.5c-.5-2.4-2.5-1.5-3.5-1-1 .3-29.5 20.5-29.5 20.5l-30.2-19.2s-2.2-.7-2.6.8c-.4 1.4.8 2.2 1.1 2.9z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#474747",
      stroke: "#474747",
      strokeLinejoin: "round",
      d: "M506 168.2s-8-3.4-8-.5c0 3 .3 3.3 1.6 5.2 1.3 1.8-1 3-1 3l-.8-2c-.4-1.3-4.7-2.2-5-3.8-.5-1.5.8-3.9-1.7-4.2-2.6-.3-5.1 1-5.6 4a61 61 0 0 1-3.9 9.8l.5-15.6c5.6.4 16 1.6 24.1 2.6-2.4-.4 1 .1.8 1-.2.6-1 .7-1 .5zm-28.2-3.9a37 37 0 0 0-10.4 1.9c-1.8 1 3 2.7 2.3 4-.6 1.5-.7 4.4-3 3.8-2.2-.6-9.8-4.4-10-5.7-.3-1.2-1.8-1.3-1.8-1.3s21.8-3 22.9-2.7z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M481.2 162.5v19.1m-14.7-41.7-9 14.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "url(#gs_svg__f)",
      stroke: "#000",
      d: "M482.6 139.5s3.8 5.2 3.4 6.7c1.5 1.2 3.3 6 3.3 6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M497.3 138.7s-8.2 11.6-8 12.5"
    }),
    /* @__PURE__ */ jsx108("path", {
      d: "M455.1 83.4c-.2.6-1.2.9-2.3.6-1.1-.4-1.9-1.2-1.7-1.8.2-.7 1.3-1 2.4-.6 1 .3 1.8 1.1 1.6 1.8m3.4-.2c.2.6 1.2.9 2.3.5 1.1-.3 1.9-1.1 1.7-1.8-.2-.6-1.3-.9-2.4-.5-1 .3-1.8 1.1-1.6 1.8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ff7000",
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M555 324s-3.2.5-3 .8c0 .3-9 .6-9.1.3-.2-.3-1.4 1.5-1.4 1.5l1.5-.9s2.2 2.3 2.8 2.1c.7-.1-.3 1 0 1.1.1.2.8-.4.8-.4l14.8-.2zm5.4 4.5-12 .4s-3.1 2.8-3.3 3.4c-.2.7 2 .9 2 .9l.6 2.3 1.6-.6s10.3 1.5 19.7-.6c4.8-1.6 5.7-3.6 2.3-4.9-3.3-1.2-10.8-.8-10.9-.9z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "url(#gs_svg__g)",
      stroke: "#000",
      d: "m519 353.4 21.7-1-4-3.4 59-2.4-2-4.7-66.1 2.7 8 3.7-18 .5.6 1.9-4.7-.2s5.3 2 5.4 3z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "url(#gs_svg__h)",
      stroke: "#000",
      d: "M543.4 232.9c-1.7-.9-9.4-2-17.9 3.6l.4 19.6s12.5-6.7 18.5-5.2c-.3-6-.3-13.8-1-18z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "m422.7 292.4-51.4 51m74.4-50.7-41.8 55m39.9-69.3-55.7 67.5m-1.7-.9 5.4-6.4m62.6-26.3-21.6 29.8m-.9 3.9.5 11.4m31.9-34.7-23 28.8m18.9-2.3 9.3-15.3m-5.7-2.9-11.2 12.6m7.8-24.6-7.6 9.3m-2.3-22.9s-23.3 34.1-22.9 37m20.5-41.4c-.6.3-20.1 26.2-20.1 26.2m-1.1 8.2-3.6 4.3m-4.5 6.5-5.4 7.1"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#8a9396",
      stroke: "#2b2b2b",
      d: "M420.2 213.8s-1.6 5 0 7.5 11.5 22.5 11.5 22.5 6.8-8.3 9.3-8.5c2.4-.3 1.3 21.6 1.3 21.6s-4 3.8-6.5 3.6c-2.5-.2 6 8.6 5.8 16-.2 7.5-11.2 44.5-15.3 45.1-4 .7 1.8-6.7 1.6-8.8-.3-2-1.4-.6-2.3-2.9-.9-2.2 1.4-5.6 1-7.9-.5-2.2-2.6-1.8-2.8-3.4-.2-1.6 1.4-2 1.1-3.8-.2-1.8-2.7-1.4-2.4-3 .2-1.5.4-.8.2-3.8-.2-2.9-.7 2-3.2 2.3-2.5.2-4.5 5.9-4.5 5.9s-5 7-9.9 3.8c3 6.3.7 9-.5 9.2-1 .3 1 5-1.8 5.2-2.7.2 2 10.6-1 11.5 3.3 1.6.6 3.6.6 3.6s-7.8.7-6.1 10.9c-23-8.2-34.3-22.1-34-36.4.2-14.2 4.7-27 15.7-31.7 3.2-11.8 8.6-24.4 8.6-24.4s-.9-5.2-.2-8.6a17 17 0 0 1 3.8-6.7s-.4-8.2-.2-12.2 1.8-5.9 2-8.1c.2-2.3-.7-13.8 1.6-15.8 2.2-2 6.5-1.8 8.8-3.2 2.2-1.3 5.2-3.8 8.1-3.6 3 .2 5.4 2.3 5.4 2.3s11 0 11.7 4.2c.7 4.3-2.2 6-2.2 6s1.6 6-5.2 11.6z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#cecfcf",
      stroke: "#2b2b2b",
      d: "M410.4 198.2c.3.7-.5 1.8-1.8 2.5-1.4.7-2.7.8-3 .2-.4-.7.4-1.8 1.7-2.5 1.4-.8 2.7-.8 3-.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      d: "M408.5 199.4c0 .4-.4.7-.8.7-.5 0-.9-.3-.9-.7 0-.5.4-.8.9-.8.4 0 .8.3.8.8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeWidth: 0.5,
      d: "M425 206.8s2.7 12.2-.5 20.7m1.4-26s5.3 7 4.6 15.8m-4.1-17.3c.1 0 4.5 3.7 4.3 6.3m-3.3-7.9s3 2 3.6 4.1"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M426 197.2s-10.5 17-9.1 27.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeWidth: 0.5,
      d: "M426.7 196.6s-14 8.3-16.5 35.4"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "m425.2 201.6-5.6 4.2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeWidth: 0.5,
      d: "M405 233.5s7.8-32.2 21.5-36.9"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M431.9 244.4s7.4-9.3 9.1-9c1.7.4 1.2 21.6 1.2 21.6s-5.5 4.1-6.7 4c-1.2-.2 6.2 10 6 13.7-.1 3.8-.3 3.8-.3 3.8s0-2.2-1.7-5.8c-1.8-3.7-.7-7.8-12-17-2.7-5.6 5.6 3.5 7.3 2.1 1.7-1.3-3-13.2-3-13.4z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      d: "M418.7 192s-3.1.8-3.5 2c-.5 1.4-2.3 2.6-3.3 2.2-1-.4-2.8-2-2.8-2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "M401 202.9s-4.7 4.6-2.4 5.2c2.3.6 4.7-3.7 4.7-3.7s0 7.3 2 6.1c2-1.1 7.7-5.2 7.7-5.2s2-.2 2.5 0c.4.1 5.3 4.4 8.6 2.8-1.9 4.8-4 5.4-4 5.4s-3.4 4.4-7.8 3.4c-4.4-1-5.5-2.8-5.5-2.8s-3.7.2-4.8-1.5l-1.6-2.6s-2 2-2.7 1c-.5-1 0-6.7 3.3-8.1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      d: "M427.5 196.4s-8.6-2.6-11.6 1.7c-3 4.2-2.3 6.6-.7 7"
    }),
    /* @__PURE__ */ jsx108("path", {
      d: "M428.8 196.1c0 1-.7 1.9-1.6 1.9-1 0-1.6-.9-1.6-1.9 0-1 .7-1.8 1.6-1.8.9 0 1.6.8 1.6 1.8"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M403.7 218.2s3.5 5.4 7.7 6.9-3 2.7-7.1 0c-3-4.2-2.2-7.2-2.2-7.2s.8-.8 1.6.3zm30.1 31.9s-9.9-13.7-12.7-14.5c-2.9-.7 2.2-1.3 5.2 1.6 3 3-.8-4.7-.8-4.7z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "M402.7 329.6c3.8-1 20.4 9.5 24 12.1 3.8 2.7 11.6 1 11.6 1s-3.6 2.2-5.8 2.7c-2.3.5 6.6.5 6.6.5s-21.1 5.9-42.6-5.4c-2-8.8 4.6-10.8 6.2-10.9z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M427 253.5s-2.9-.5-4.3-2.1c-1.4-1.7-3.4-5.7-5.5-7.4-2.1-1.6-12.6-7.4-16.4-7-3.8.4-5-.4-5.5-.9-.4-.5-2 .2-1.7 2.2.3 2-3 6.3-1.8 8.3a62 62 0 0 0 7.7 10.6c1 .3.4 4.8.4 4.8s4.8 4.9 6 5.1c1.2.3 2.5 1.2 2.3 2.4-.1 1.1-5.3 7.4-5.3 7.4s-5.5 3-5.6 4.5c0 1.7 1.4 5 5.8 6.1a41 41 0 0 0 16.8-.8c.6-1 1.6-7 1.2-7.7-.4-.6-3.3-2.4-4.8-2.2-1.5.3-2.9 1.5-2.7 1.8.1.3-2.1 1.4-2.1.3 0-1 4.4-6 4.8-5.5.4.4 6.6 1 7.8 4.1 1.1 3.1 1.1 5.4 4.4 5 3.2-.3 7.8-3.3 8.2-9.5a13 13 0 0 0-4.7-11c-1-.7-4.4-2.7-4.7-3.7-.2-1-1-4-.4-4.8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M368.3 281s10.5-2.7 13.2-2.6c2.7 0 13 4.8 16 7.7 3 3 9 9.8 13 9.2 4-.6 5.2-1.4 5.2-1.4l-1.6 3s-3.2.9-4.9.5c-1.6-.4-4.8-1.5-8-4.6-3.1-3-13-11.5-21.3-10.9-8.3.6-13.1 8.8-13.1 8.8s0-4 .4-4.9c.3-.8-1.8 2-1.8 2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M407 289.2s2.6.7 7 .7c4.3 0 6.6-1.9 6.6-1.9l-.3-1.7.7-2.3s3.3 3.3 3.3 4c0 .7-1.4 1-1.4 1l-.5-1.7-1.1 1.5s-6.3 5-9.8 4.2c-3.4-.7-6.6-3-5.7-3.5.9-.5 1.3-.3 1.2-.3zm-15.3 8.8s-3.8 0-5.5.8c-1.7.8-2.3 1.8-3.5 1.7-1.1-.2-2-1.6-1.7-2.2.5-1 2.8-2.2 7-1.9 4.3.4 3.7 1.6 3.7 1.6zm13.3 10.3c0-.2-.3-5.5-2.4-7.7a6.4 6.4 0 0 0-5.8-1.9c-1.2.3 4.2 2.7 4.8 4.2.5 1.6 2.3 6 1.8 7-.5 1-1.3-3-4.7-4.2-3.3-1.2-7.9-.5-7 1 1 1.4 4.7 0 6.6 3.3a60 60 0 0 1 3.3 6.5l.7-2.3 1.6-.4.3-4.4z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "m402.3 325.7-3.5-7s-1-4.3-4-5.5c-3-1.3-6.8-1-6.8.4-.1 1.5 6.2 3.4 6.6 4.2.4.8.2 2.2-.3 2.3-.6 0-3.4-1-4.8-.7-1.4.3-2.2 2.2-4.3 1.6-2.1-.5-3.9-7.2-3-8 .7-.6-1.6 1.3-2.1-.5-.5-1.7.7-7.2-.1-7.9-.8-.7-4.8-3-4.8-3.5-.1-.5.2-27 22.3-5-9.5-11.3-13.2-10-15-10.1-1.2 0-9.9.7-12 11.7-2.2 11-4.8 4.1-4.8 4.1s-.4 4.8 1.9 6.1c2.3 1.4-1.1 5.3-1.1 5.3s-4.2-10-3.5-14.5c-.9 3.5-.8 12.3 4.4 21.8a71.2 71.2 0 0 0 27.2 19.1c8-12.3 7.7-13.8 7.7-14z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#8a9396",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "M387.8 325.8s4.4.5 5.6 2.8c1.3 2.3 1.8 5.8 1.8 5.8.8-1.5 1-2.7 2.6-3.8 1.5-1.1 2.6-1.3 2.5-2 0-.9-4.8-5.8-7.1-6.1-2.4-.3-6.5 2.6-6.5 2.6s-.8 1 1 .7z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#8a9396",
      strokeLinecap: "round",
      d: "M398 337.4s11.6 5.3 30.6 5.6"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeLinecap: "round",
      d: "M436.7 283.6s-1 9.7-8.5 29"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#2b2b2b",
      d: "M435.2 289.6s-2.3 7-8.5 12.2"
    }),
    /* @__PURE__ */ jsx108("path", {
      d: "m401.3 410.3 2-2.2.6.5-.1.2-.2.3v.2l.2.2 2.6 2.3.2.2h.2l.1-.2q.4-.4.5-.8.2-.4.1-.8 0-.5-.4-1l.8-.4 1.2 2-3.2 3.6-.6-.5.2-.3.1-.2v-.2l-.2-.2-2.6-2.3-.3-.2h-.1l-.3.2-.2.2zm4.4-4.9 3.7-3.6 1.8.9-.3.7-1-.2-.6.2q-.3.1-.6.5l-.7.6 1 1.1.3-.2q.3-.2.3-.4v-.2l-.2-.3-.2-.2.6-.6 1.8 1.9-.6.5-.2-.1-.3-.3h-.2l-.4.3-.2.2 1 1 .2.2h.1l.2-.2.4-.3.6-.8q.2-.4.1-1 0-.4-.3-.9l.8-.4 1 2.3-3.8 3.7-.6-.6h.2l.2-.4v-.2l-.2-.3-2.4-2.4-.3-.2h-.2l-.2.1-.2.2zm7.7-7.4q1.2-1 2.4-.9 1.3.1 2.2 1.2.6.7.8 1.5.2.9-.1 1.6-.3.8-1.1 1.5-1 .9-2.2.9-1.4 0-2.4-1.2-1-1-.8-2.3.1-1.3 1.2-2.3m.7.7q-.5.5-.5 1.2 0 .8.7 1.6t1.5 1q.6 0 1.1-.4.6-.4.6-1 0-.9-.8-1.7-.4-.5-1-.8-.4-.2-.9-.2-.4 0-.7.3m6.1-6.2.5-.3.1.1 2.9-2v-.2l.4-.3 1.9 1.3-.5.7-.7-.3q-.4-.2-.8-.1l-.4.1-.1.1v.2l2.1 3 .2.3h.3l.5-.3.4.7-2.4 1.8-.5-.7.1-.1.3-.3v-.2l-.1-.3-2.1-3-.2-.2-.1.1q-.2.1-.3.4-.2.3-.2.7l.1.8-.8.2zm5.6-3.5 4.4-2.8 1.7 1.3-.6.7-.8-.4h-.7q-.3 0-.7.3l-.8.5.8 1.3.2-.2.4-.2v-.3l-.1-.4-.1-.2.7-.4 1.3 2.3-.7.4-.1-.3-.3-.3h-.2l-.4.2-.3.1.8 1.3.1.2h.1l.3-.1.4-.3.8-.6.3-.9v-1l.8-.2.5 2.4-4.6 2.8-.4-.7.1-.1.3-.3q.1 0 0-.2v-.3l-1.8-2.9-.3-.3h-.1l-.3.1-.2.1zm6.2-3.8 3.5-1.8.7-.3q.4-.2.9-.1.4 0 .7.2l.5.6q.4.7.1 1.3-.2.6-.8 1l1.8.8h.1l.3.1h.3l.2-.1.3-.1.3.7-1.7 1-3-1.5-.5.2.6 1.1.2.4h.5l.2-.2.4.8-2.7 1.4-.4-.8.3-.1.2-.2.1-.2-.1-.3-1.6-3.1-.2-.2q0-.1-.2 0h-.3l-.2.1-.4-.7zm2.6-.2.7 1.4.8-.4q.5-.2.7-.5l.2-.4v-.5l-.4-.3h-.4l-.7.2zm4.4-3.4 3.6-1.6.7-.2h.9q.4 0 .7.2l.5.7q.3.6 0 1.2t-.9 1l1.8.9.4.1h.5l.2-.2.4.8-1.8.8-3-1.6-.4.2.5 1.1.2.4h.4l.3-.1.3.7-2.7 1.3-.4-.8.3-.1.2-.2.1-.2-.1-.3-1.4-3.2q0-.2-.2-.3h-.5l-.2.2-.3-.8zm2.6 0 .6 1.5.9-.4.7-.4q.2-.2.2-.5v-.4l-.3-.4h-.5l-.7.2-1 .4zm6.8-3.9 1.3-.5 3.4 3.9.4.3h.5l.2.8-2.7 1-.3-.8.2-.1q.2 0 .3-.2v-.2l-.2-.2-.4-.5-1.7.6v1l.3.1.4-.1.3.8-2.3.8-.3-.8q.2 0 .3-.2l.1-.1v-.4zm1 3.2 1.1-.4-1.1-1.4zm3.8-4.9 2.7-.8 2.1 3.3v-4l2.8-.7.2.8-.3.1q-.2 0-.3.2v.4l1 3.4.1.2.2.1h.6l.2.7-2.9.9-.2-.9h.2q.3 0 .3-.2l.1-.1v-.3l-1-3.7-.1 5.4-.8.2-2.8-4.4 1 3.7.1.1.2.1h.3l.3-.1.2.8-2.4.7-.3-.8h.3l.3-.2v-.5l-1-3.3v-.3l-.2-.1h-.6zm12.4-3.3 3.2-.6h1q.5 0 .8.2.4.2.6.5l.3.7q.1.8-.4 1.4-.5.7-1.5.9l-1 .2.2 1.1v.3h.8l.1.8-3 .6v-.8h.1l.4-.2v-.5l-.6-3.3v-.4l-.2-.1h-.6zm2.4.6.4 1.7h.5l.7-.3.3-.4v-.5q0-.4-.4-.6-.3-.1-.8 0zm4.2-1.8 3.8-.5h.8l.8.2q.4.2.6.5.3.3.3.7.1.7-.3 1.2-.5.5-1.1.8l1.4 1.3.3.2.2.1h.6v.8l-1.9.3-2.3-2.4h-.5l.2 1.2v.4l.2.2h.6v.8l-3 .4v-.9h.2l.3-.1.2-.2v-.3l-.5-3.5v-.3h-.8zm2.4.7.2 1.6h1l.7-.3.4-.3v-.5l-.1-.4-.4-.2h-.8zm8.8-1.9q1.4-.1 2.4.7 1 .9 1 2.3 0 1-.3 1.7-.4.7-1 1.2-.8.4-1.8.5-1.4 0-2.3-.6-1.1-.9-1.2-2.4 0-1.4.8-2.4.9-1 2.4-1m0 1q-.7 0-1 .6-.6.6-.5 1.7 0 1 .6 1.6.4.5 1.1.5.7 0 1.1-.6.5-.6.4-1.7 0-.7-.3-1.2-.2-.5-.6-.7-.4-.3-.8-.2m4.6-1.1h3.4l1 .1.7.4.4.6.2.8q0 .8-.6 1.3t-1.7.5h-1v1.5l.4.1h.3v.9h-3v-.9h.5l.1-.1v-.4l.1-3.4v-.4l-.1-.1h-.6zm2.3 1v1.8h.6l.7-.1.3-.3q.2-.2.2-.5 0-.5-.3-.7-.3-.2-.8-.2zm4.5-1 3.8.3.8.1.8.4q.3.2.5.6l.1.8q0 .7-.6 1-.5.5-1.2.6l1.2 1.5v.1l.2.3h.2l.3.1h.3v.9l-2-.1-1.9-2.8h-.5v1.6h.6v1l-3-.3v-.8h.6l.2-.2v-.3l.2-3.5v-.3l-.3-.2h-.4zm2.2 1.2-.1 1.6h.9q.5.1.8 0 .3 0 .4-.2.2-.2.2-.5v-.4l-.4-.3-.8-.1h-1zm5.4-.6 3 .4v.9h-.3q-.3-.1-.4 0l-.2.4-.4 3.4v.4h.1l.3.2h.3l-.1.9-3-.4.1-.9h.2q.3.1.4 0h.1l.1-.3.4-3.5v-.5h-.4l-.3-.1zm6.5.9 1.4.3 1 5q0 .4.2.5l.4.2-.2.8-2.9-.5.2-.8h.5l.1-.1v-1l-2-.3-.3.6v.2q-.1.1 0 .2h.1l.4.2-.1.8-2.4-.4.1-.8h.4l.2-.1.2-.3zm-.8 3.3 1.3.2-.3-1.8zm5.9-2.4 2.7.7.2 4 2-3.4 2.7.7-.2.8h-.3q-.2-.2-.3 0-.2 0-.2.3l-.9 3.4v.4l.3.1.3.1-.2.9-2.9-.8.2-.8h.3l.3.1h.2v-.4l1-3.7-2.7 4.7-.8-.3-.3-5.1-.9 3.6v.2l.1.2h.3l.3.1-.2.9-2.5-.6.2-.9h.3l.3.1h.1l.2-.4.8-3.4v-.4l-.3-.1-.3-.1zm12.5 3.5 3 1.1 1 .5.5.6.2.7-.1.8q-.3.7-1 1-.8.3-1.8 0l-1-.4-.4 1v.5l.3.2h.3l-.3.9-2.9-1 .3-.9h.2l.4.2h.1l.2-.4 1.2-3.2v-.5l-.3-.2h-.2zm1.7 1.7-.6 1.7.5.2.7.1.5-.1.3-.5q.1-.4-.1-.7-.2-.3-.6-.4zm4.6.6 3.5 1.6.7.4q.4.2.6.6l.3.7-.2.8q-.3.7-.9.9h-1.3l.5 1.9.2.3.1.2.3.2h.2l-.3.9-1.8-.8-.8-3.3-.5-.2-.5 1.1v.6l.2.1.3.2-.4.7-2.7-1.2.3-.8.3.1.3.1h.2l.1-.3 1.4-3.2.1-.3v-.2l-.2-.1h-.2l-.2-.1zm1.7 1.9-.7 1.5.9.3q.4.3.7.3l.5-.1q.2-.1.3-.4.1-.2 0-.4l-.1-.4-.7-.4-1-.4zm8.5 2.9q1.3.7 1.7 1.9.4 1.2-.3 2.5-.4.8-1.1 1.2-.7.5-1.6.5-.8 0-1.7-.5-1.2-.6-1.7-1.7-.5-1.3.3-2.6.6-1.3 1.9-1.7 1.2-.3 2.5.4m-.4.9q-.6-.4-1.3-.1-.7.3-1.2 1.3-.5.9-.4 1.7.1.6.8 1 .6.3 1.2 0 .7-.3 1.2-1.2.4-.7.4-1.2 0-.6-.2-1zm5 1.5.5.3v.2l3 1.9.1-.1.5.3-.5 2.2-.8-.2v-.8q0-.4-.2-.7l-.3-.4h-.2l-.1.2-1.9 3-.2.4v.1l.1.1.4.3-.4.7-2.6-1.6.5-.7.1.1.4.2h.1l.3-.4 2-3v-.3h-.1q-.2-.2-.6-.2l-.6.1-.7.4-.6-.6zm5.6 3.8 4.2 3-.6 2-.8-.2v-1l-.2-.6q-.2-.3-.6-.5l-.7-.6-1 1.3.3.2.4.2h.3l.2-.4.2-.2.6.5-1.5 2.1-.6-.4.1-.2.2-.4v-.2l-.4-.4-.3-.1-.8 1.1-.1.3.2.3.4.3 1 .4q.4.1.8 0 .5-.1 1-.5l.4.7-2 1.4-4.3-3 .5-.8.1.1.4.2h.2l.2-.3 2-2.8.2-.3v-.1l-.3-.3-.2-.1zm6.9 8.8 2.3 2-.5.6-.2-.1-.2-.2h-.2l-.3.3-1.2 1.5-.7-.6.1-.5-1-.2-.7-.5q-.7-.6-1-1.3-.2-.8 0-1.6 0-.8.6-1.6.6-.7 1.4-1 .8-.3 1.6-.1.8.1 1.5.6l.5.6.4.7.3-.1.5.4-.9 2-.8-.4v-1.1l-.1-.7-.4-.5-.8-.3-.9.2q-.4.2-.9.8l-.6 1v1.1q.1.4.5.7l.5.3h.5l.4-.2.1-.2.2-.3v-.1l-.3-.3-.2-.2zm6.7 2 1 1-1.9 4.8q-.2.3-.1.5l.2.3-.6.7-2-2 .5-.7.1.2.3.1h.2l.2-.3.2-.5-1.4-1.3-.6.3-.2.1v.3l.3.3-.6.6-1.7-1.6.6-.6.2.2h.2l.4-.1zm-2.4 2.3.9.9.7-1.7zm6.5 1.4.4.4-.1.2 2.4 2.5h.2l.4.3-1 2-.8-.3.2-.8v-.7q0-.3-.2-.5h-.2l-.2.1-2.5 2.5-.3.3v.2l.3.4-.6.6-2-2.2.6-.6v.2l.4.2h.2l.3-.2 2.6-2.5.1-.2v-.1l-.5-.3h-.7l-.8.2-.3-.8 2-1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48ZM136.5 0v240h48V0Z"
    })
  ]
});
var Gs_default = SvgGs;

// src/country-flag-icons/generated/Gt.tsx
import { jsx as jsx109, jsxs as jsxs102 } from "react/jsx-runtime";
var SvgGt = (props) => /* @__PURE__ */ jsxs102("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs102("defs", {
      children: [
        /* @__PURE__ */ jsx109("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__d",
          cx: 447.4,
          cy: 308.3,
          r: 16.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs102("radialGradient", {
          id: "gt_svg__a",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0.2,
              stopColor: "#f9f0aa"
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsx109("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__e",
          cx: 451.6,
          cy: 313,
          r: 10.9,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx109("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__f",
          cx: 454.1,
          cy: 308.6,
          r: 9.8,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx109("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__g",
          cx: 458.4,
          cy: 307.1,
          r: 17.4,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx109("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__j",
          cx: 446,
          cy: 252.4,
          r: 13,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs102("radialGradient", {
          id: "gt_svg__m",
          cx: 477.9,
          cy: 215.3,
          r: 0.3,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0.3,
              stopColor: "#a50a0a"
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#4c0505"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("radialGradient", {
          id: "gt_svg__n",
          cx: 489.1,
          cy: 210.3,
          r: 0.3,
          fx: 489.1,
          fy: 210.3,
          gradientTransform: "scale(.97707 1.02346)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0,
              stopColor: "#fff"
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#fff",
              stopOpacity: 0
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("linearGradient", {
          id: "gt_svg__h",
          x1: 473.9,
          x2: 472.4,
          y1: 259.2,
          y2: 232,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0.2,
              stopColor: "#b07e09",
              stopOpacity: 0
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("linearGradient", {
          id: "gt_svg__i",
          x1: 483.1,
          x2: 485.5,
          y1: 296.7,
          y2: 326.6,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0.2,
              stopColor: "#b07e09",
              stopOpacity: 0
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("linearGradient", {
          id: "gt_svg__k",
          x1: 451.5,
          x2: 455.4,
          y1: 249.5,
          y2: 240.6,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0.2,
              stopColor: "#f9f0aa"
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("linearGradient", {
          id: "gt_svg__l",
          x1: 473.3,
          x2: 475.9,
          y1: 237.2,
          y2: 270.4,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx109("stop", {
              offset: 0.2,
              stopColor: "#f9f0aa"
            }),
            /* @__PURE__ */ jsx109("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx109("path", {
      fill: "#4997d0",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx109("path", {
      fill: "#fff",
      d: "M213.3 0h213.4v480H213.3Z"
    }),
    /* @__PURE__ */ jsxs102("g", {
      transform: "matrix(.81133 0 0 .8264 -69.4 -8)",
      children: [
        /* @__PURE__ */ jsxs102("g", {
          stroke: "#24420e",
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "none",
              strokeWidth: 0.4,
              d: "M452.1 377.5c2.7-.4 4.2-1.2 6-1.8m2.3-4.1a13 13 0 0 1 3 4.7m-8.1-5.1a13 13 0 0 1 3 4.2m-49.5-136.6c-1 1.6-3 2.7-4.8 3.4m-.3-.2c0-1.4-.2-3 0-4.4m-1.9 5c0 .4.4 1.4.6 2m2.1 1-2 .3m-4-.9c0 2.6.3 5.6.5 7.9m-1.8-1c.5.8 1 1.5 1.6 1.9m-4.6 6.5c.5.9 1 2 1.3 4m3.7-4.7-2 1.5m1.7 4.4c-1 .9-2.2 1.5-3.5 2.1m-3.8 40.4a16 16 0 0 0 4 4.7m.6 1.7a8 8 0 0 1-3-1m4.4 8.5 1.7 1m-.4 3.4c1.2.8 2.5 2.3 3.7 3.9m-1.4 2.8c1.4.3 2.5.7 3.2 1m-1 2.5h2m1.3-5.3-.5 4.2m1 1.6.4-1.6m4.7 6-.1 3.2m39.2 27.9-1.2 1.6m-2.4-3.9-.7-1.8"
            }),
            /* @__PURE__ */ jsxs102("g", {
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx109("path", {
                  fill: "#406325",
                  d: "M486.1 385a7.8 7.8 0 0 0-3.3-2.7c-7.7-4-15.4-5.9-24-7.3-2.1-.3-4.1-2.2-6.2-3.2-5-2.3-10.5-3.2-15.3-5.7-.3-.1-1.5-.8-2-1.5-2-2.2-5.5-2.9-7.6-5-8.4-7.8-17.2-15-21.8-25.5-5.6-12.7-12.5-25.8-11.6-40.2.6-9.2-.7-18.4 1.5-27 3.4-13 7.6-25.7 15.4-36.4l-1.3.8a103.8 103.8 0 0 0-15.4 36.3c-2.3 8.7-1 18-1.5 27-1 14.5 6 27.6 11.5 40.3 4.6 10.4 13.5 17.7 21.8 25.6 2.2 2 5.6 2.7 7.6 5a10 10 0 0 0 2 1.5c4.9 2.4 10.4 3.3 15.4 5.7 2 1 4 2.8 6 3.2a76.5 76.5 0 0 1 24.2 7.2 8 8 0 0 1 3.3 2.7l1.3-.9"
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#67923d",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M406.3 331.6a46.9 46.9 0 0 1-.2-23.5c6.7 13 4.5 23.7.2 23.5zm45.9 45.4a49 49 0 0 0-21.9 11.4c15.1.1 24-7.3 21.9-11.4zm7.5-4.3a60.1 60.1 0 0 1-14-26.5c15 10.9 18.9 24.3 14 26.5z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M454.6 372.8a55.1 55.1 0 0 1-16-22.8c15.3 8.2 20.3 20.2 16 22.8zM439 366c1-7.8-5.6-24.2-7.5-26-3 16.5 3 27.6 7.5 26zm-27.3-24.3a42 42 0 0 1 .5-21c5.5 11.7 3.3 21.2-.5 21zM398 264.9a51 51 0 0 1 21-16c-6.8 14.6-18 19.9-21 16z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M398.7 259.3a51.8 51.8 0 0 1 17.4-20c-3.7 15.7-13.7 23.2-17.4 20zm27.9 99.2a55 55 0 0 1-7.3-26.4c11.2 12.5 12 25.3 7.2 26.4zM397.9 322c-7 1.1-21.4-4.6-23-6.3 14.6-3.2 24.4 2 23 6.3zm-2.2-9.7c.8-5.5 8.6-15.8 10.3-16.6-1 12-7.4 18.6-10.3 16.6zm51.3 58.6a57 57 0 0 0-26.1 13.6c18 .1 28.7-8.7 26.1-13.6z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M406.4 331.5c4.2.2 6.4-10.4-.3-23.4a78.9 78.9 0 0 1 .3 23.4zm11.2 20a48.8 48.8 0 0 0-21.7-11.2c8.9 12.1 19.9 15.1 21.7 11.2zm-24.4-53a56.8 56.8 0 0 0-14.8-24c1.5 17.2 10.6 26.7 14.8 24zm8.4 34.3c-5-3.7-19-5.4-21-4.8 10.2 8.4 20.2 8.5 21 4.8zm-9.4-24.8a42 42 0 0 0-16.9-13.8c5.5 12.4 14.6 17 16.9 13.7zm2.8-47.6c.8-7.6-5.6-23.4-7.4-25.2-2.9 16 2.9 26.7 7.3 25.2zm4.4-14.9c2.7-6.5.8-22.4-.5-24.4-6.4 13.5-3.8 24.6.5 24.4z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M404.4 237.8a40.3 40.3 0 0 0 3.5-19.4c-7.2 9.7-7 18.9-3.5 19.4zm6-6.1a38.8 38.8 0 0 0 9-17.4c-9.7 7-12.2 15.8-9 17.4zm-16.1 43.2c.1.9-1-8.2-10-18.3.4 14.8 6.2 20.4 10 18.3zm32.6 85.8a53 53 0 0 0-25.8-6c12.6 10.4 24.9 10.6 25.8 6zM439 366c-4.6 1.5-10.5-9.5-7.6-26a99 99 0 0 0 7.5 26zm13.3 11c2 4.1-6.8 11.5-21.8 11.4 12-5 21.2-9.9 21.8-11.3zm7.3-4.4c4.9-2.3 1.1-15.5-14-26.4 8.6 13.2 14.5 24.6 14 26.4z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M454.6 372.7c4.2-2.7-.7-14.5-16-22.7 9.5 11.2 16.2 21 16 22.7zm-42.8-31c3.7.2 6-9.3.5-21 .7 11 .4 20-.5 21zM398 265c3 3.8 14-1.4 20.9-16a90.6 90.6 0 0 1-20.9 16z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M398.9 259.3c3.6 3.2 13.5-4.3 17.2-20-8 11.3-15.6 19.8-17.2 20zm27.7 99.1c4.7-1.1 4-13.8-7.3-26.3 5 13.5 8 24.8 7.3 26.3zM397.7 322c1.4-4.3-8.3-9.4-22.8-6.3 12.3 2.2 22 5 22.8 6.3zm-1.9-9.6c2.9 1.8 9.1-4.7 10.3-16.7a68.6 68.6 0 0 1-10.3 16.7zM447 371c2.5 5-8 13.7-26 13.6 14.2-5.9 25.3-11.8 26-13.6z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M399.4 326.3a45 45 0 0 0-17-15.8c5 13.6 14.2 19.1 17 15.8z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#67923d",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M392.4 274c4-4.7 17.5-9.2 19.6-9-8 10.5-18 12.6-19.6 9zm25.1 77.5c-1.8 4-12.7 1-21.7-11.1a84.4 84.4 0 0 0 21.7 11.1zm-24.4-53c-4.2 2.7-13.1-6.8-14.7-24 6.6 13.3 13 23.5 14.7 24zm8.4 34.3c-.7 3.7-10.7 3.6-20.8-4.7a74 74 0 0 0 20.8 4.7zm-9.5-24.9c-2.3 3.2-11.2-1.3-16.7-13.7 8.2 8 15.5 13.7 16.8 13.7zm2.8-47.6c-4.4 1.6-10.1-9-7.3-25 2.7 13.5 6 24.2 7.3 25zm4.5-14.9c-4.3.3-6.9-10.8-.5-24.3-.8 12.8-.5 23.3.5 24.3zm5-7.6c-3.4-.6-3.7-9.7 3.6-19.4a66.2 66.2 0 0 0-3.6 19.4zm6-6.1c-3.1-1.7-.7-10.4 9-17.3a66.2 66.2 0 0 0-9 17.3z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M394.3 274.9c-3.9 2.1-9.6-3.5-10-18.3 5 11.7 8.6 17.8 10 18.3zm32.5 85.8c-.9 4.6-13.1 4.4-25.7-5.9 13.2 4.3 24.3 6.7 25.7 5.9zm-8.2-9.5A41 41 0 0 1 412 332c9 8.7 10.2 18.1 6.8 19.2zm-16.8-25c-3.6-5.8-4-20.9-3-23 8.3 11.9 7.3 22.7 3 23zm-2.7.1c-2.7 3.3-11.9-2.1-16.8-15.8a77.3 77.3 0 0 0 16.8 15.8z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M392.4 274c1.6 3.6 11.4 1.5 19.5-8.9-12 6.8-16.7 9.8-19.5 8.9zm9.3 52c4.3-.3 5.3-11-3-22.8a72.7 72.7 0 0 1 3 22.9zm17 25.2c3.4-1 2.2-10.5-6.7-19.2 4.4 9.7 7.2 18 6.7 19.2z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M394.2 291.8c2-8.4-1.7-22.6-4.3-25.6-4.7 15.4-.2 26.6 4.3 25.6z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#67923d",
                  d: "M394 293.8c-6 1.3-8.7-12-4.1-27.1 1 13.5 2.8 26.1 4 27z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#67923d",
                  d: "M392.7 293.7a53 53 0 0 1 9-24.7c2 15.8-4.5 26.3-9 24.7z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#406325",
                  d: "M392.8 293.6c4.5 1.6 10.9-8.8 8.9-24.6-3.5 13.3-7.5 23.8-8.9 24.6z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#67923d",
                  d: "M394.1 303.3a50 50 0 0 1 10.6-23.7c.8 16.2-6.3 25.9-10.6 23.7z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#406325",
                  d: "M394.2 303.4c4.2 2.2 11.3-7.4 10.5-23.5-4.4 12.8-9 22.9-10.5 23.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs102("g", {
              fill: "#ba1f3e",
              stroke: "#511124",
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx109("circle", {
                  cx: 396.8,
                  cy: 251.3,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 405.2,
                  cy: 245.1,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 401.6,
                  cy: 241.7,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 392.5,
                  cy: 313.1,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 395,
                  cy: 297.1,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 408.2,
                  cy: 334.5,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 402.4,
                  cy: 336.4,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 446.7,
                  cy: 367.6,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 449.6,
                  cy: 374.7,
                  r: 1.3
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          stroke: "#24420e",
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "none",
              strokeWidth: 0.4,
              d: "M561.1 259c.7.6 1.2.8 2.3 1.9m-6.6-18.9c0-1.4-.6-3.7-.9-5m3.5 3c0 1.9-.3 3.7-1.1 5.4m-4.2-.5c1.8 1.6 3.5 3 5.3 3.9m3.8 1.2c.1 2-.1 4-.7 6m.4 1.5 1.3-2.3m-1.9 12.2c1.4.3 2.8 2 3.5 3.5m.5-1.3 1.6-2.2m1.7 30.8a24 24 0 0 1-2.4 3.4m-4 0c.8 1.4 1.6 3 2.6 4m2.5 5.9a13.2 13.2 0 0 1-4.5 4m.2 4.5c-1.1.8-2.5 3-3.7 4.7m8.4-20.2-2.1.9m-1.4-7.4 1.2 1m-9.3 37.4h-2m-2.1-1.8.6 1.6m-7.6 5.1c-.3 1.9-.1 3.7.1 5.6m4.3-9 1 2.2m3.9-.1-2.5.3M522 365.6l-1 1.8m11.9-4c-1.5.2-2.8 0-4.1-.2m-5.5 6c-1-.5-2-.7-3-1m-14.7 2.7c-.9.7-2 2.4-3 4m-.6-4.5c-2.4 1.3-3.2 3.7-4.4 5.8m2.8 2.8c-1.6-.4-3.4-1.2-5.3-2m16.7-.7c-2.3-1.2-4.7-1-7.1-1.4m10.8-.4c-3.7-.7-7-.6-10.3-.1m7.8-2.6-1.4-.6m-5.6 5.5-2.3-1.3m57.9-49.2c-1.2.8-2.5 2.3-3.7 3.9m1.8-79.6-2.2-.8"
            }),
            /* @__PURE__ */ jsxs102("g", {
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx109("path", {
                  fill: "#406325",
                  d: "M474.4 384.9c.8-1.3 2.1-2 3.3-2.7 7.7-4 15.4-5.8 24-7.2 2.1-.4 4.1-2.3 6.2-3.2 5-2.4 10.5-3.3 15.3-5.7.3-.2 1.5-.9 2-1.6 2-2.2 5.5-2.9 7.6-5 8.4-7.8 17.2-15 21.8-25.5 5.6-12.7 12.5-25.8 11.6-40.2-.6-9.2.7-18.4-1.5-27a104.6 104.6 0 0 0-15.4-36.4l1.3.8a103.8 103.8 0 0 1 15.4 36.4c2.3 8.6 1 17.9 1.5 27 1 14.4-6 27.5-11.5 40.3-4.6 10.4-13.5 17.6-21.8 25.5-2.2 2-5.6 2.7-7.6 5a10 10 0 0 1-2 1.5c-4.9 2.4-10.4 3.4-15.4 5.7-2 1-4 2.8-6 3.2A76.5 76.5 0 0 0 479 383a8 8 0 0 0-3.3 2.7l-1.3-.8"
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M553.6 334.6c2.8-7.4 0-24.8-1.4-27-6.7 15.4-3.4 27.6 1.4 27z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M546.5 341.6c2.3-5.6.7-19.3-.4-21-5.5 11.7-3.3 21.3.4 21zm16.9-74.1a46.9 46.9 0 0 0-19.3-14.6c6.2 13.3 16.5 18.2 19.3 14.6z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M561.8 259.5a43.3 43.3 0 0 0-14.5-16.7c3.1 13 11.4 19.3 14.5 16.7zm4.7 14.9c-3.5-4-15.2-7.9-17-7.7 7 9 15.6 10.9 17 7.7zm-2.8 46.4a40 40 0 0 0 20.3-5.7c-12.9-2.8-21.5 1.9-20.3 5.7zm-.2-5.7c0-5.6-6.3-16.8-8-18-.5 12 4.9 19.5 8 18z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M564 301.4a50 50 0 0 0-10.6-23.6c-.8 16.2 6.3 25.8 10.6 23.6zm-53 75.3a47.7 47.7 0 0 0 22.2 11c-8.8-12.3-20.1-15.1-22.1-11z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#67923d",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M553.6 334.4c-4.9.6-8.1-11.4-1.4-26.8-.5 14.2.2 25.7 1.4 26.8zM500.2 378a50 50 0 0 1 21.9 11.5c-15.1.1-24-7.3-22-11.4zm0-7.9c2-8 15-21.2 17.5-22.1-3.6 17.1-13.7 25.5-17.5 22.1zm21.3-4.1a54 54 0 0 1 7.5-26c3 16.4-3 27.5-7.5 26zm21.5-14.6a48.8 48.8 0 0 1 21.6-11.2c-8.9 12.1-19.8 15.1-21.7 11.2zm25.7-53.3c1-6.3 9.7-17.9 11.6-18.9-1.2 13.6-8.3 21-11.6 19z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M557 336.2a50.5 50.5 0 0 1 24.4-5.5c-11.8 9.7-23.5 9.8-24.4 5.5zm10.3-24.5a44 44 0 0 1 17.7-14.4c-5.8 13-15.3 17.8-17.7 14.4zm-1.5-45.6c0-7.6 8-22.7 10-24.2 1.1 16.1-5.7 26.2-10 24.2zm-6.9-25.9a40.4 40.4 0 0 1-.1-20c5.5 10.9 3.7 20 0 20z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M554.6 238a49.7 49.7 0 0 1-10.4-22.1c11.8 9.3 14.4 20.4 10.4 22.1zm11.7 34.5c-.3.9 3-7.7 14.2-15.3-4 14.3-11 18.3-14.2 15.3zm-34.1 89.9a61 61 0 0 1 29.2-6.7c-14.2 11.8-28.2 12-29.2 6.7zm14.3-20.8c-3.7.2-6-9.3-.5-21-.7 11-.4 20 .5 21zm16.9-74.1c-2.7 3.6-13-1.2-19.2-14.6a78.8 78.8 0 0 0 19.2 14.6zm-1.7-8c-3.1 2.6-11.3-3.6-14.4-16.7 6.7 9.4 13 16.5 14.4 16.7zm4.8 15c-1.4 3.1-9.9 1.3-16.9-7.7 10.4 5.9 14.5 8.4 17 7.7zm-2.6 46.2c-1.3-3.8 7.3-8.3 20.2-5.5a69 69 0 0 0-20.2 5.5zm-.4-5.6c-3.2 1.5-8.5-5.9-8-17.9a68.7 68.7 0 0 0 8 18z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M563.9 301.6c-4.3 2.2-11.3-7.4-10.5-23.5 4.4 12.8 9 22.9 10.5 23.5zm-52.7 75.1c2-4.2 13.1-1.4 22 10.8-11-6.7-20.5-11.3-22-10.8z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs102("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx109("path", {
                      d: "M521.5 365.8c4.6 1.6 10.5-9.4 7.6-25.9-2.8 14-6.2 25.1-7.6 26z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M531.8 360.6a55 55 0 0 0 4.6-27c-10 13.6-9.4 26.3-4.6 27zm-31.7 17.5c-2 4.1 6.7 11.5 21.8 11.3-12-4.8-21.2-9.8-21.8-11.3zm.2-8.1c3.8 3.4 13.8-4.9 17.4-22-8.1 12.4-15.7 21.8-17.4 22zm42.7-18.6c1.8 4 12.7 1 21.7-11.1a84.4 84.4 0 0 1-21.7 11.1zm25.8-53.3c3.3 2.1 10.3-5.3 11.5-18.8a74.8 74.8 0 0 1-11.5 18.8zM557 336.2c1 4.4 12.5 4.2 24.4-5.5-12.5 4-23 6.2-24.3 5.5zm10.4-24.6c2.5 3.4 11.9-1.4 17.7-14.4a75 75 0 0 1-17.7 14.4zM566 266c4.2 2 11-8 9.8-24-4 13-8.4 23.3-9.9 24zm-7-25.9c3.5.1 5.4-9-.2-20 1 10.5 1 19.1.2 20zm-4.3-2.2c4-1.7 1.4-12.7-10.4-22a81.7 81.7 0 0 1 10.4 22zm11.6 34.7c3.2 3 10.2-1 14.2-15.4-7.8 10.1-12.7 15.2-14.2 15.4zm-34 89.9c1 5.2 14.9 5 29-6.7-14.9 4.8-27.4 7.6-29 6.7z"
                    }),
                    /* @__PURE__ */ jsx109("path", {
                      d: "M539.1 354.8a41 41 0 0 0 3.6-20.1c-7.5 10-7.2 19.5-3.6 20zm19.6-28.7c3.6-5.7 4-20.9 3-23-8.3 11.9-7.3 22.7-3 23z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#67923d",
                  d: "M531.8 360.5c-4.8-.6-5.3-13.3 4.5-26.8-3.6 13.8-5.4 25.4-4.5 26.8zm35.2-68.3c-1-7.8 4-20.1 6.6-22.5 2.6 14.4-2.7 24-6.6 22.5zm-27.9 62.5c-3.6-.5-3.9-10 3.6-20a67.4 67.4 0 0 0-3.6 20zm23.4-104.2c-2.2-6 0-20 1.2-21.8 5.3 12.2 2.6 22.1-1.2 21.8zm-58.1 120.1c2.5-8 16.2-21 18.8-22-4.3 17.5-15 25.6-18.8 22zM559 329a45 45 0 0 1 16.9-15.8c-5 13.6-14.2 19.1-17 15.8zm-.2-3c-4.3-.4-5.3-11 3-22.9a72.7 72.7 0 0 0-3 22.9z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#406325",
                  d: "M567 294c5.2 1.9 9-9.8 6.6-23.9a98 98 0 0 1-6.6 24z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#406325",
                  d: "M567.8 293.6c.5-7.5-7-23-9-24.7-2 15.8 4.5 26.3 9 24.7zm-5.3-43.2c3.9.4 6.5-9.4 1.2-21.7.4 11.5-.2 20.8-1.2 21.7zm-58 120.1c3.8 3.7 14.4-4.4 18.7-21.8-8.8 12.3-17 21.6-18.7 21.8zm54.6-41.5c2.8 3.3 12-2.1 17-15.8a77.3 77.3 0 0 1-17 15.8z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  fill: "#67923d",
                  d: "M567.7 293.5c-4.5 1.7-10.9-8.7-8.9-24.5 3.5 13.2 7.5 23.7 8.9 24.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs102("g", {
              fill: "#ba1f3e",
              stroke: "#511124",
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx109("circle", {
                  cx: 564.6,
                  cy: 254.9,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 568.4,
                  cy: 266.8,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 569.8,
                  cy: 304.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 564.6,
                  cy: 297.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 549.9,
                  cy: 337.2,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 556.2,
                  cy: 339.9,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 513.8,
                  cy: 372.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 506.8,
                  cy: 377.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx109("circle", {
                  cx: 557.1,
                  cy: 249.3,
                  r: 1.1
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          id: "gt_svg__b",
          fill: "#8c959d",
          stroke: "#485654",
          strokeWidth: 0.1,
          children: [
            /* @__PURE__ */ jsx109("path", {
              d: "M434.3 336.3c-.2 1 .8 2.3 2 2 .5 0 .7-.5.2-.5-.4.2-.9 0-1.2-.3a2 2 0 0 1-.4-2z"
            }),
            /* @__PURE__ */ jsx109("path", {
              stroke: "none",
              d: "M437.2 338.3c-1 1.2-2.5 1.7-3.4.9-.6-.6-.8-1.2-.5-2l-1 1.3s.6 1.3 1.6 1.8c1.3.5 3-.3 4-1.6.8-1 1.6-2.4 1-3.6a4 4 0 0 0-2-1.7l-1 1c.5-.2 1.2 0 1.7.4 1.3 1 .6 2.5-.4 3.5"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#485654",
              stroke: "none",
              d: "M437.2 338.3a4 4 0 0 1-1.1 1c-.5.2-1 .4-1.5.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.5-.6c-.2-.2-.2-.4-.3-.7 0-.3 0-.5.2-.8l.1.1-1.1 1.3v-.1l1 1.3.7.4.8.1a3 3 0 0 0 1.6-.5c.5-.2 1-.6 1.3-1l1-1.4c.2-.5.4-1 .3-1.6 0-.3 0-.5-.2-.8a4.2 4.2 0 0 0-1.9-1.6h.1l-1 1.1h-.1c.2-.2.5-.2.7-.2l.8.2c.4.3.8.7.9 1.2.1.5 0 1-.2 1.4-.2.5-.5.9-.9 1.2m0 0c.4-.3.6-.7.8-1.2.2-.4.3-1 .2-1.4-.1-.5-.5-.8-.9-1-.4-.3-1-.4-1.3-.2h-.1l1-1.2a4.2 4.2 0 0 1 2 1.7c.2.2.3.5.3.8 0 .6-.1 1.2-.4 1.7-.2.5-.5 1-1 1.4-.3.5-.8.8-1.3 1.1-.5.3-1 .5-1.7.5a2.2 2.2 0 0 1-1.6-.6 5 5 0 0 1-1-1.4l1-1.3h.2l-.1.8c0 .2 0 .5.2.7l.5.5c.1.2.4.3.6.3.5.1 1 0 1.5-.2z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#6c301e",
              stroke: "#351710",
              strokeLinejoin: "round",
              strokeWidth: 0.2,
              d: "m515.2 249.3-40.1 39.5L434 328l-4.6 5.4c-2 2.3-4.4 5.3-7.2 8-.5.7-1.1.4-1.7.8-1.8 1-3.7 2.8-5 4.3L403.2 360c-.7.9-1 1.4-.4 2l6.6 8.8c1.2 1.2 2.6 1.8 3.2.8 3.1-5.5 11-13.8 14-20.3 1.7-4 3.9-11.1 5.5-12.8 2-2.2 7.1-7.8 11.8-12.7l1-1c.2-.4.5-.7.9-1 23.5-24 50.7-53.1 70.5-73.6z"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M431.9 328.1c-1.2 0-2-.7-2.9-1.4 1.2.4 2.4.8 3.5.3z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#b2b6ba",
              strokeWidth: 0.2,
              d: "m557 220.1-31.8 26.2c-.3.4-.6.3-.9 0l-2.9-2.4v-.6l1.4-1.4c.2-.2 0-.3-.1-.6l-.6-.6c-.3-.1-.5 0-.7.2l-1.4 1.5c-.7 0-1.3.6-1.4 1.4-19.2 18.7-35.8 35.4-54.9 53.8l-22.6 21.6c-.8 1-4.3 2.9-6.6 4.4-.8.5-1.5 1-1.8 1.5l-1.8 5.5c-.6 1.2-2.5 4-2.5 4.2l3.8 3.7 11.1-11.9.9-1a13.3 13.3 0 0 0-2.6-2.7l-.7-.5c-.1-.2.3-.5.5-.7 26.4-25.6 55-53.7 78.2-76.6a1.4 1.4 0 0 0 1 0l2.9 3.1c.6.7 1.2.7 1.7.4l31.9-28.5z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#485654",
              stroke: "none",
              d: "M431 330.4h.6l.5-.1.7-2.4.8-2.4c-.2-.2-.4-.4-.7-.4.3 0 .5.2.7.4l-.7 2.4-.7 2.4-.6.2z"
            }),
            /* @__PURE__ */ jsx109("circle", {
              cx: 438.2,
              cy: 328.1,
              r: 0.6,
              fill: "none",
              strokeWidth: 0.2
            }),
            /* @__PURE__ */ jsx109("circle", {
              cx: 434.4,
              cy: 331.9,
              r: 0.6,
              fill: "none",
              strokeWidth: 0.2
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#485654",
              stroke: "none",
              d: "M441 322.4a11.7 11.7 0 0 1-1.8-1.6 11.6 11.6 0 0 1 1.8 1.6"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "m502.2 259 3.5 3.5.6-.6-3.5-3.4-.6.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx109("use", {
          xlinkHref: "#gt_svg__b",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1) rotate(-2.8 -9.3 19640.2)"
        }),
        /* @__PURE__ */ jsxs102("g", {
          stroke: "#24420e",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "#67923d",
              d: "M434 365.4a55.8 55.8 0 0 0-29.3.9c16.3 8 29.5 4.6 29.2-1zm89 3.3c7.8-3.3 26.8-.7 29.1 1-16.2 7.9-29.5 4.5-29.2-1z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#406325",
              d: "M433.8 365.5c.3 5.5-12.8 8.9-29.1.9 15.3 1 27.8.4 29-1zm89.2 3.3c-.2 5.5 12.9 8.9 29.2.9-15.3 1-27.8.4-29.1-1z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          id: "gt_svg__c",
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "#b2b6ba",
              stroke: "#485654",
              strokeWidth: 0.2,
              d: "M508.5 360a237.5 237.5 0 0 0-76.1-68c3.5-.2 11.4 3.9 14.7 6 23.9 15.4 44.3 35.8 65.6 59.8-1.2 1.2-2 2-3.4 3z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#8c959d",
              d: "M510.6 359.8 509 361c-23-29.6-55-57.9-76.7-69 30.1 13.8 55.4 41.7 78 67.6h.1z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#485654",
              d: "M510.6 359.8 509 361a303 303 0 0 0-35.2-38 285 285 0 0 0-30.4-24.3c-3.6-2.4-7.3-4.7-11.1-6.7v-.2c8 3.7 15.4 8.2 22.5 13.3 7 5 13.6 10.7 20 16.6a360 360 0 0 1 18.3 18.5c6 6.4 11.6 13 17.4 19.5zm0 0c-5.8-6.6-11.5-13-17.5-19.4a355 355 0 0 0-18.3-18.5c-6.4-5.9-13-11.5-20-16.6-7-5-14.5-9.6-22.4-13.2v-.2a196.2 196.2 0 0 1 21.7 14.3 284.9 284.9 0 0 1 38.2 35.1 314 314 0 0 1 16.8 19.8z"
            }),
            /* @__PURE__ */ jsxs102("g", {
              fill: "#fab81c",
              stroke: "#6c301e",
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx109("path", {
                  strokeWidth: 0.2,
                  d: "M517.5 355c-2 .6-3.7 1.3-5.3 2.3-.2 1.4-2 3-3.5 3.3l-.6-.8h-.2l-.6.3c-.6 0-1.3.2-1.6 1-.4 1 .3 2.3 1.2 3.1 1 .7 1.4 1 2.4 1 1.1-.3 1.7-1.3 2-1.6 3.7 4.5 6.5 7 11.2 10.6 2.1 0 3.2-1.3 2.5-2.8-.2-.5-.8-.8-1.3-.6v-.5c2.4-2.2 3.5-5 .9-9.8-2.2-4-4.7-5.4-7-5.4h-.1zm6.2 4.6c.5.7.7 1.4 1 2 1.6 3 .3 6.7-2.3 7.8h-.2c.4-.7-.8-2.2-1.4-1.7.3-.7-.7-2-1.5-1.7.4-.7-.5-1.9-1.4-1.5.4-.7-.3-1.8-1.3-1.6.3-.8-.4-1.8-1.3-1.6 0-.8-.2-1.2-.5-1.5 1-.8 2.3-2.1 3.4-2.7 2.7-1.2 4.4 1 5.5 2.5z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  d: "M524.9 362.8c-.5-.3-.8-.8-.6-1.1.2-.4.7-.5 1.2-.2.5.2.8.7.7 1-.2.4-.8.5-1.3.3z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  d: "M524.6 361.8c-.5-.3-.8-.8-.6-1.2.2-.3.7-.4 1.2-.1.5.2.8.7.7 1-.2.4-.8.5-1.3.3z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  d: "M524 360.6c-.5-.2-.8-.7-.6-1 .2-.4.7-.5 1.2-.3.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  d: "M523.2 359.6c-.5-.3-.8-.8-.6-1.1.2-.3.7-.4 1.2-.2.5.3.8.8.7 1.1-.2.3-.8.5-1.3.2z"
                }),
                /* @__PURE__ */ jsx109("path", {
                  d: "M522.2 358.6c-.6-.2-.8-.8-.6-1v-.2c.2.1.7.2.6-.1 0-.2-.1-.3 0-.2l.6.2c.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z"
                })
              ]
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#fab81c",
              d: "M511.3 363.6c.7-1.8 2-3.4 3.5-3.8m-3.3 4.1c1.3.2 3.3-1.3 3.8-2.6m-2.6 4c1.6.4 3.3-1.2 4-2.4m-2.5 4c2 0 3.1-1.3 3.7-2.4m-2.2 3.9c1.7 0 3.2-1.3 3.6-2.4m-2.2 3.8c1.9 0 3.1-.9 3.7-2m-2 3.4c1.7.1 3-.9 3.4-1.8m-1.6 3.3c1.6 0 2.7-1 3.1-2"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#6c301e",
              d: "M511.3 363.6a7 7 0 0 1 2.3-3.2c.3-.3.7-.5 1.2-.6a4 4 0 0 0-1.2.6 6 6 0 0 0-1 1 8 8 0 0 0-1.3 2.2m.2.3c.4 0 .8 0 1.2-.2l1-.6 1-.8.6-1a2 2 0 0 1-.6 1 5.3 5.3 0 0 1-2 1.4c-.4.2-.8.3-1.2.2m1.2 1.4h1.2l1-.6a5.6 5.6 0 0 0 1.7-1.8l-.7 1-.9.9-1 .5zm1.5 1.6c.4 0 .8 0 1.1-.2l1-.5 1-.8.6-1a4 4 0 0 1-1.5 1.9l-1 .5zm1.5 1.5c.8 0 1.5-.3 2.1-.8a5.2 5.2 0 0 0 1.5-1.6c-.1.3-.3.7-.6 1l-.8.7-1 .6a3 3 0 0 1-1.2.1m1.4 1.4c.4 0 .8 0 1.1-.2a4.6 4.6 0 0 0 2-1l.6-.9-.6 1c-.3.2-.6.5-1 .6-.6.4-1.3.5-2 .5zm1.7 1.4a4.5 4.5 0 0 0 2-.5l.8-.5c.2-.3.5-.5.6-.8 0 .3-.3.6-.5.8a3.6 3.6 0 0 1-3 1zm1.8 1.5 1-.1.8-.4.7-.6.6-.8a3 3 0 0 1-3.1 1.9"
            })
          ]
        }),
        /* @__PURE__ */ jsx109("use", {
          xlinkHref: "#gt_svg__c",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1) rotate(-3.4 -13.8 16470.8)"
        }),
        /* @__PURE__ */ jsxs102("g", {
          stroke: "#24420e",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "#406325",
              d: "M409.2 240a52.4 52.4 0 0 0 19.5-17.9c-15.6 4.2-22.7 14.3-19.5 18zm145.8 4.7a50 50 0 0 0-15.6-19.9c2.8 15.2 12 22.8 15.6 20z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#67923d",
              d: "M409.2 240c-3.3-3.6 3.8-13.6 19.4-17.8-11 8.4-19.2 16.2-19.4 17.8zm145.8 4.7c-3.7 3-12.7-4.6-15.5-19.7 7.2 11 14 19.5 15.5 19.7z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          stroke: "#999270",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__d)",
              d: "M452.2 318.1s-6.1.7-7.9-7.8c-1.8-9.1 5.3-10 5.3-10s8.1-.9 13.2-1l2.2 18z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__e)",
              d: "M453 315.4s-4 .7-4.8-5.6c-.6-4.5 2.2-5.1 2.2-5.1l9.2 1.6v8.2z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__f)",
              d: "M450.4 304.7s6-.4 9-.8l1.3 5.7-7.1.4s-.5-5.1-3.2-5.3z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__g)",
              d: "M449.2 300.4s7.5-1.9 8.5 6.4c.2 2.2-1 7.2-4.7 8.6l13.9-1.5-1.3-15-4.6.4s-10 .3-11.8 1z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#f9f0aa",
              d: "M452.2 318.1s51.9-3.5 57.2-3.3c15.8-8.6 0-42.5-13.3-61.5 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 3 6 30.4 55 11.2 60.3z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__h)",
              d: "M507.8 273.3c-3.5-7.3-7.7-14.3-11.7-20 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 1 1.8 4.3 8 7.9 15.7"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__i)",
              d: "M455 285c5.6 14.6 8.7 30-1.6 32.9l-1.2.2s52-3.5 57.2-3.3c8.6-4.7 7.8-16.8 3.2-30"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__j)",
              d: "M447.4 243.5c-3.7 0-4.7 3.6-4.6 5.8.1 6 4.6 6.2 4.6 6.2l6-.3 2.8-12.2z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__k)",
              d: "m447.4 243.5 8.8-.5 1 9.1-7.8.4s2.5-7.3-2-9z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__l)",
              d: "M496.1 253.3c6.7-1 6.6-10 2-13.7-15.5-.6-35.8-.1-50.6 1 1.7 0 6.4.4 6.9 6.5a8.2 8.2 0 0 1-3 7 7 7 0 0 1-4 1.4h3.6l3-.4c21-2.7 42-1.8 42-1.8z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#b07e09",
              stroke: "none",
              d: "M458.5 267.4c-.2-.3-.4-.7-.8-.8-.2 0-.6 0-.5-.4h.8l1.6-.2c.4.1.3.5 0 .5-.5 0-.2.5-.1.8l1.3 3c.1.4.4.7.7.7l1.1-.1c.3-.2.2-.6.2-1-.1-.3.5-.2.5 0l.4 1.4c0 .2-.2.1-.4.1l-3 .2c-.3 0-.8.3-1 0 0-.4.6-.2.6-.5l-.3-1zm4.8-.4c-.1-.2-.3-.6-.7-.7-.2 0-.6 0-.6-.4.2-.2.5 0 .7 0l1.7-.2c.3 0 .4.5 0 .4-.3 0-.3.4-.2.7l1.5 3.4c0 .2.2.5.5.6.2 0 .6 0 .7.3 0 .3-.4.1-.6.1-.5 0-1 0-1.6.2-.2 0-.5 0-.5-.3s.5 0 .6-.4c0-.3-.2-.6-.4-1l-1.1-2.6zm4.5.8c0 .2.4 0 .5 0 .3 0 .6-.1.6-.4 0-.5-.3-1-.7-1.2-.3-.3-.7-.2-1.1-.2l.1.5zm.6 1.6c.2.3.3.7.6 1 .2.2.6.1.8 0 .3 0 .5-.3.4-.5-.1-.7-.5-1.3-1.2-1.5h-1l.2.5zm-2-2.4c-.2-.3-.3-.8-.7-1-.2 0-.6.1-.7-.2 0-.3.6-.1.8-.2.9 0 1.8-.3 2.6 0 .7.2 1.4.8 1.5 1.6 0 .4-.3.7-.6.8l.5.1c.6.2 1.1.6 1.4 1.2.2.4.3.9 0 1.3-.4.4-1 .4-1.4.4-.8 0-1.5 0-2.3.2-.3 0-.4-.5 0-.5.3 0 .3-.4.2-.6l-1.3-3zm7.4-1.9c.3 0 .4.3.5.5l.3.9c-.3.2-.5-.2-.6-.4-.2-.2-.4-.5-.7-.4h-1.2c-.2.2 0 .4.1.6l.6 1.4c.2 0 .6 0 .8-.3 0-.2-.3-.7.2-.6.3.2.2.6.4.9l.5 1.1c-.3.3-.5-.1-.6-.4-.2-.3-.7-.3-1-.3-.2 0 0 .2 0 .3l.6 1.5c.2.3.7.3 1 .3.3 0 .8 0 1-.4.2-.2-.3-.7 0-.8.4 0 .4.4.5.6 0 .3.2.6.3.8 0 .2-.3.2-.4.2l-3 .2c-.4 0-.9.2-1-.2 0-.3.7-.1.6-.5l-.4-1-1.1-2.7c-.2-.3-.4-.7-.8-.7-.2 0-.6 0-.4-.4h1zm2.3 1.3c-.1-.3-.3-.7-.7-.9-.2 0-.7 0-.7-.4.3-.2.7 0 1 0 .8 0 1.6-.3 2.4 0 .8.1 1.5.9 1.6 1.8 0 .4-.3.7-.7.8-.3 0 .2.1.3.2.7.3 1 .9 1.4 1.5.1.2.5.7.6.2 0-.5.6 0 .5.3 0 .4-.4.6-.7.6-.4 0-.9-.2-1.1-.6-.4-.6-.7-1.3-1.3-1.7a.8.8 0 0 0-.8-.2v.5l.6 1.2c.2.3.6.3 1 .3.3.1.2.6-.2.5h-1.7c-.3.2-.9 0-.7-.3.3 0 .7-.2.5-.5l-1-2.6zm1.4 1c.2.2.6 0 .9 0 .3 0 .3-.5.2-.7-.1-.5-.4-1-.9-1.2-.2 0-.8-.2-.9.1l.7 1.6zm7.2 1.6c.1.3.3.6.6.7.2 0 .6 0 .7.3 0 .3-.4.1-.6.2h-1.6c-.3.1-.6 0-.6-.3.2-.2.7 0 .7-.4l-.5-1.1-1.1-2.9c-.1-.3-.5-.3-.7-.3-.3 0-.7 0-.7.4 0 .3.2.6 0 .8-.3 0-.4-.3-.5-.5 0-.3-.2-.6-.4-1 0-.2.4-.1.5-.1l4.2-.2c.3 0 .5.2.5.5l.4 1c-.1.3-.5 0-.6-.3-.1-.3-.5-.7-.9-.7-.2 0-.6 0-.8.2l.2.7zm3.8-.9c-.2 0-.1.3-.1.4v.8c.1.4.5.3.8.4.2 0 .1.5-.2.4h-1.2c-.3.1-.8-.1-.5-.4.2 0 .4-.1.5-.3v-5c.2-.3.5 0 .6.2l3.6 4.5c.2.2.5.4.8.4.3 0 .4.5 0 .4h-1.5c-.2 0-.5.2-.7 0-.2-.1 0-.4.2-.4.3 0 0-.4-.1-.6l-.6-.8zm1.1-.5c.2 0 0-.1 0-.2l-1.3-1.7v2h1.3zm3.1-1.8c-.1-.4-.3-1-.8-1-.3 0-.7-.2-.5-.4h1.7c.7-.1 1.4-.1 2 .1 1.5.5 2.7 1.8 3 3.4 0 .6-.1 1.3-.6 1.6-.8.5-1.7.4-2.5.3l-1.4.1c-.3 0-.4-.5 0-.4.4 0 .4-.5.2-.7zm2 2.5c.1.3.2.7.5 1h1c.5 0 .7-.5.7-.9a5 5 0 0 0-.6-2.1c-.4-.7-1-1.2-1.8-1.4a3 3 0 0 0-1 0c-.1 0 0 .2 0 .4zm-21.1 12.4c0 .3.4.6.8.6.2 0 .7 0 .7.4-.2.2-.6 0-.8 0l-1.5.2h-.9c-.2 0-.2-.4.1-.4.3 0 .6-.1.6-.4l-.2-.8-1.2-2.8c0-.3-.4-.3-.7-.3-.2 0-.6.1-.7-.2 0-.3.5-.2.7-.4l1-.3c.2 0 .3.1.3.3zm.7-4.5h2c.4 0 .2-.5.4-.5.4 0 .4.5.4.7 0 .4-.3.7-.6.6H475l.5 1.2.6-.2c1 0 2.2.6 2.6 1.6.2.5.3 1 0 1.5-.4.5-1 .6-1.6.6-.5 0-1-.1-1.4-.6-.1-.2-.1-.7.2-.6.4 0 .7.2.7.6.1.2.5.1.7.1.3 0 .6-.2.6-.5 0-.5-.2-1-.5-1.4-.2-.4-.7-.7-1.3-.7l-.8.1c-.3 0-.3-.3-.4-.5l-.7-1.9.2-.1zm6.9 1c-.2-.4-.4-.9-.9-1-.2 0-.7-.1-.4-.4h1.6c.7-.2 1.5-.1 2.1.1 1.5.5 2.7 1.8 3 3.4 0 .6-.1 1.2-.7 1.6-.7.4-1.6.3-2.4.3l-1.3.2c-.3 0-.4-.5 0-.5.3 0 .3-.4.2-.7zm2 2.5c.1.3.3.7.6 1h1c.4-.1.6-.6.6-1 0-.7-.3-1.4-.7-2.1-.4-.7-1-1.2-1.8-1.3a3 3 0 0 0-1 0v.4zm6.4-4.3c.3 0 .4.3.5.5 0 .3.2.5.3.8-.2.3-.5 0-.6-.3-.1-.2-.3-.5-.6-.5h-1.3c-.2.2 0 .5 0 .6l.6 1.4c.3 0 .6 0 .8-.2.2-.2-.3-.7.2-.6.3 0 .3.5.4.8l.5 1.1c-.1.4-.5 0-.6-.3-.1-.3-.5-.3-.8-.3-.2 0-.4 0-.2.2l.6 1.5c.2.4.7.3 1 .3.4 0 .8 0 1-.3.2-.2-.2-.6 0-.8.4 0 .5.3.5.5l.3 1c0 .1-.3 0-.4 0l-3.1.2c-.3 0-.7.2-.9-.1-.2-.4.5-.2.6-.5l-.3-.9-1.1-2.9c-.2-.3-.4-.6-.8-.7-.2 0-.6 0-.4-.4h1zm-27.2 14.3c.1.5.6.7 1 .8.8.2 1.7.5 2.2 1.1.3.4.5.9.5 1.4 0 .5-.5.9-1 1-.5.2-1.1.1-1.7-.1-.2-.1-.1.4-.5.3-.2-.2-.1-.6-.2-.9a9 9 0 0 0-.4-1c0-.3.4 0 .5.2.3.6.9 1 1.6 1.1.4 0 .8-.2.8-.6 0-.5-.4-1-.8-1.2-.7-.3-1.4-.4-2-.8a2 2 0 0 1-1-1.6c0-.4.4-.8.8-.9.5-.2 1-.2 1.6 0 .2 0 .3-.3.6-.1 0 .2 0 .4.2.6l.3.9c-.2.2-.5 0-.5-.2-.3-.4-.5-.8-1-.8-.4 0-.8 0-1 .3zm6.6-1.7c.4 0 .4.3.5.5l.2.8c0 .3-.4 0-.5-.2-.1-.2-.3-.5-.7-.5h-1.2c-.2.2 0 .5 0 .6l.5 1.4c.3 0 .6 0 .8-.2.2-.2-.2-.6.1-.7.4 0 .4.5.5.7 0 .4.3.8.4 1.3-.1.3-.5 0-.5-.3-.1-.3-.5-.4-.8-.3-.2 0-.4 0-.3.2l.6 1.5c.1.3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6 0-.8.3-.2.6 0 .6.3l.2 1c0 .2-.3.2-.4.2l-3 .2c-.4 0-.8.3-1 0 0-.4.5-.3.6-.6 0-.2 0-.5-.2-.8l-1-3c0-.3-.3-.6-.7-.6-.2 0-.6-.1-.4-.4h1zm4.2 4.2c.1.3.3.6.6.7.3 0 .7-.1.8.2 0 .4-.5.2-.7.2-.6 0-1 0-1.6.2-.2 0-.5 0-.6-.2 0-.4.5-.2.6-.4l-.1-.8-1-3c-.2-.3-.3-.7-.7-.7-.2 0-.6 0-.5-.4.1-.2.4 0 .7 0 .7 0 1.4-.3 2.2-.2a2 2 0 0 1 1.7 1.2c.2.4.2 1 0 1.3-.5.4-1.1.5-1.7.6-.2 0 0 .2 0 .3zm-.6-1.8h.7c.3-.1.5-.4.4-.7 0-.5-.2-.9-.5-1.2-.3-.3-.8-.3-1.1-.2-.2.1 0 .3 0 .5zm6.2 1.5c0 .2.2.6.5.6.2 0 .7 0 .7.3s-.5.2-.7.2l-1.6.1c-.2 0-.5 0-.5-.3.2-.2.7 0 .7-.4l-.3-1.2-1-2.9c0-.3-.4-.2-.7-.2-.2 0-.6 0-.7.3v.8c-.2.2-.5 0-.4-.3l-.4-1c0-.3.3-.2.5-.3l4.1-.2c.3 0 .5.2.5.5l.4 1c-.1.2-.5 0-.5-.2-.2-.3-.5-.7-1-.7-.2 0-.5-.1-.8 0l.2.7zm2.1-3.3c-.1-.3-.2-.7-.6-.8-.2 0-.6 0-.6-.4.1-.2.4 0 .6 0l1.8-.2c.3-.1.5.4.2.4s-.6.2-.5.5l.5 1.6.7 2.2c0 .2.3.4.5.4.3 0 .7 0 .6.4h-.7l-1.6.2c-.2 0-.6-.2-.4-.4.2-.1.6 0 .6-.4l-.3-1.2zm5.8-1.6c.3 0 .3.3.4.5l.2.8c-.1.3-.5 0-.5-.2-.1-.3-.3-.6-.7-.6H485c-.2.2 0 .5 0 .7l.5 1.3c.2 0 .5 0 .8-.2.2-.1-.2-.6.1-.6.4 0 .4.4.5.6 0 .5.3.9.4 1.3-.1.3-.5 0-.5-.2-.1-.3-.5-.4-.8-.4-.1 0-.5 0-.3.2l.5 1.5c.1.3.5.4.7.4.4 0 .9 0 1.2-.3.2-.2 0-.6.1-.9.3-.1.5.1.5.4l.2 1c0 .2-.2.2-.4.2l-3 .1c-.4 0-.7.2-1 0-.1-.4.5-.3.6-.5a1 1 0 0 0-.1-.8l-1-3c0-.3-.3-.7-.7-.7-.2 0-.6-.2-.4-.4h1l2.9-.2zm2 1c-.1-.4-.4-.7-.8-.7-.3.1-.5-.6 0-.4h1.5l.7.9 2.2 2.9c-.2 0 0-.2-.1-.3l.4-3.6c.2-.2.7 0 1-.2.3 0 1 0 .8.4-.4 0-.8.2-.6.6l1.2 3.6c0 .4.4.6.8.5.3 0 .3.6 0 .5H494c-.3.1-.8.1-.7-.3.3 0 .8-.2.6-.6l-1-3.2c.1.1 0 .3 0 .4l-.2 3-.1.8c-.3.1-.4-.1-.5-.3l-2.9-3.7.2.3c.3 1 .5 2 .9 2.9 0 .4.5.5.8.5.4.2.1.5-.2.4h-1.5c-.3 0-.3-.4 0-.4.5 0 .4-.5.2-.8zm8.7.8c0 .2.4 0 .5 0 .3 0 .6 0 .7-.4 0-.4-.2-1-.5-1.2-.4-.3-.8-.2-1.2-.2v.5zm.5 1.6.4 1c.3.2.6.1.9.1.2 0 .5-.2.4-.5 0-.6-.3-1.3-.9-1.5h-1v.3zM496 288c-.1-.4-.2-.8-.6-1-.2 0-.6 0-.6-.3s.5 0 .7-.1c1 0 1.8-.2 2.7 0 .7.2 1.3.9 1.3 1.6 0 .4-.4.7-.7.9 0-.2.4 0 .5 0 .5.2 1 .6 1.2 1.2.2.4.3.9 0 1.3-.4.4-1 .4-1.5.4l-2.3.1c-.3 0-.4-.5 0-.4.3 0 .4-.4.2-.7zm5.1-.2c0-.3-.2-.8-.6-1-.2 0-.6 0-.6-.3.2-.3.6 0 1-.1h2c.8 0 1.5.6 1.7 1.4.1.4 0 1-.4 1.2l-.4.2c.6.2 1.1.7 1.4 1.2l.5.8c.2.2.3-.1.3-.3.4-.2.6.3.4.6-.1.4-.7.5-1 .4a.9.9 0 0 1-.8-.6l-1-1.7c-.3-.1-.6-.3-.9-.1v.4l.5 1.2c.1.3.5.4.8.4.4 0 .4.5 0 .4h-1.8c-.2 0-.6.2-.7 0-.2-.5.4-.3.6-.5l-.2-.9zm1.3 1c.1.3.6 0 .8 0 .3 0 .5-.3.4-.5 0-.5-.2-1-.5-1.3-.3-.2-.7-.2-1-.1-.2 0-.1.3 0 .5l.3 1.3zm6.9-2.6c.3 0 .3.3.4.5 0 .3.2.6.3.8-.2.3-.5 0-.6-.2 0-.2-.2-.6-.6-.6h-1.3c-.2.1 0 .4 0 .6l.4 1.4c.3 0 .6 0 .8-.2.3-.1-.1-.5.2-.7.4 0 .4.4.4.7 0 .5.3.9.4 1.3-.1.3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.2-.4 0l.5 1.7c.1.3.4.3.7.3.4 0 .9 0 1.2-.2.2-.2 0-.6.1-.8.3-.2.6 0 .5.3l.2 1c0 .2-.3.2-.4.2h-3.1c-.3 0-.6.2-.8 0-.3-.4.2-.3.4-.5s0-.5 0-.7l-.9-3.1c0-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1zm-32.8 13.1c0-.3-.2-.8-.6-1-.3 0-.7 0-.5-.3l1-.1c.8 0 1.6-.2 2.4 0 1.2.2 2.3 1.2 2.6 2.3.2.8.3 1.6-.2 2.3-.5.6-1.4.8-2.2.8-.7 0-1.3 0-1.9.2-.2.1-.6-.1-.4-.4.3 0 .7-.1.6-.5l-.4-1.5zm1.6 2.5c.1.3.2.7.4.9.3.2.7.1 1 0 .4 0 .8-.4.9-.9a4 4 0 0 0-.4-2.2 2 2 0 0 0-1.5-1.2 3 3 0 0 0-1.1 0c-.1 0 0 .2 0 .4zm7.1-4.5c.3 0 .3.3.4.5l.2.9c-.2.2-.5 0-.5-.2-.1-.3-.3-.6-.6-.6h-1.3c-.2.1 0 .4 0 .6 0 .5.2 1 .3 1.4.3 0 .6 0 .8-.2.2-.2-.1-.6.2-.7.4 0 .3.5.4.7l.3 1.3c0 .3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.1-.3.1 0 .5.2 1 .4 1.6 0 .3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6.2-.8.2-.2.4.1.4.4 0 .3 0 .6.2 1-.1.2-.3.1-.5.1l-3 .2c-.3 0-.6.2-.9 0-.2-.2.1-.4.4-.4.3-.1.2-.5.1-.7l-.7-3.2c-.1-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1zm6.5 4.1c0 .3.3.6.6.7.2 0 .6 0 .7.2.1.3-.4.2-.6.2l-1.7.1c-.3 0-.6.1-.8 0-.3 0-.2-.4.1-.4.3 0 .6-.1.7-.4l-.1-.8-.7-2.8c0-.3-.3-.3-.6-.3-.2 0-.6.2-.7-.1 0-.4.5-.3.7-.4l1.1-.4c.2 0 .3.1.3.3zm3.7-3.3c0-.4-.3-.8-.7-.8-.3 0-.7 0-.8.3-.1.4 0 .8.4 1l.9.5.2-.6zm.8 2.9c0-.5-.6-.8-1-1-.2 0-.4-.2-.5-.1a1 1 0 0 0-.4 1c.2.6.5 1 1 1 .4.1.8 0 1-.4v-.5zm1-.2c0 .5-.2 1-.6 1.3-.5.4-1.3.4-2 .2-.6-.1-1-.6-1.2-1.2 0-.5.1-1 .5-1.4.1 0 .5-.1.2-.2-.5-.2-1-.6-1-1.2-.2-.5 0-1 .5-1.3a2 2 0 0 1 2.6.7c.2.4.2.9 0 1.2l-.6.5c.5 0 1 .4 1.2.8.2.1.3.4.3.6zm3.2.6c.2 0 .5-.2.5-.4.1-.2 0-.7.3-.6.3 0 .2.3.3.6 0 .4 0 .8-.4 1.1-.2.2-.5.1-.8.1h-1.7c-.2 0-.5.2-.7 0-.2-.2 0-.5 0-.7.2-.7.6-1.2 1-1.6.4-.3.8-.6.8-1.1 0-.4 0-.8-.2-1.2a1 1 0 0 0-1.4-.3c-.3.1-.5.5-.3.7.2.2.6 0 .7.4.2.2 0 .6-.3.6-.4 0-.8-.3-1-.7-.1-.5.1-1.1.6-1.4.5-.3 1.1-.3 1.7-.2.5.2 1 .6 1.2 1.2.1.4.1.9-.1 1.3-.4.7-1.2 1-1.7 1.7-.1.1-.2.3-.1.6 0-.3.4-.2.5-.2zm3.9-.4c0 .2.3.5.6.6.2 0 .6 0 .7.2.2.3-.3.3-.5.3h-2.7c-.2-.1 0-.5.2-.4.3 0 .6-.1.7-.4v-.8l-.7-2.8c0-.3-.3-.3-.5-.3-.3 0-.6.2-.7 0-.2-.4.3-.4.5-.5l1.2-.4c.3 0 .3.1.4.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          fill: "#448127",
          stroke: "#34541f",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "url(#gt_svg__m)",
              stroke: "#4c0505",
              d: "M475.8 219.4 472 224c-1.2 5.2 1.8 9.2 7.7 12.6 4.7 3 13.5 3.7 16.3 1.3l-13.7-13z"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "m503.6 354.3-2-2.5a100.8 100.8 0 0 1-32.7 28.6c15.1-4.2 25-15.2 34.7-26.1zM488.1 390a455.8 455.8 0 0 1 18.2-32.3l-2.1-2.7c-7.4 12.2-16 26.7-16 35zm41.8-114.5a62 62 0 0 0-4.3-13 126.6 126.6 0 0 0-43.8-44v-.3h.4l-.1-.1h.4l-.2-.3h.4l-.3-.4h.4l-.3-.3h.5l-.3-.4h.4l-.4-.3.6-.1-.5-.3.5-.1-.4-.3.6-.2-.5-.3.6-.3-.6-.4.7-.2-.8-.3.7-.4h-.8l.5-.7h-.7l.3-.5h-.6l.3-.5-.7.1.3-.6-.6.4.2-.7-.7.4.1-.7-.6.5.1-.7-.5.5v-.7l-.5.6v-.7l-.4.5-.2-.6-.4.6-.1-.7-.3.7-.2-.7-.3.7-.2-.6-.2.6-.2-.6-.2.8-.2-.7-.3.8-.3-.7v.8l-.4-.7v.8l-.5-.6v.8l-.4-.6v.7l-.4-.3.2.7-.5-.3.2.6-.4-.2.1.6h-.4l.2.4h-.3l.2.4a9 9 0 0 0-.4 3.5c0 .2.6.4.7.6.3.4.2.6.2.6-1.6 2.6-3 4.6-3.1 7.6 1.2-1.6 2.6-3.6 4.4-3.6-.9 1.5-1.3 6.1-.3 6.8l.8-1.3c0 1 .1 1.8.4 2.3.3-.6.6-1.3 1-1.7 0 1.5.2 2.7.6 3.3.5-.8 1-1.2 1.6-1.6-.2.9-.5 1.7-.3 2.7.6-1 1.2-1.7 1.9-2.5-.4 1.6 0 2.8.4 4.5.4-2 .6-2.3 1.5-3.1.1 1.9-.2 3.6.2 4.7.8-1.7 1.4-1.5 2-2.6-.2 1.6-.5 3.3 0 4.7a4.5 4.5 0 0 1 1.9-2.6c0 2.2.5 1.8-.8 3.7.6.2 2.5-.4 3.6-.9-.5 1.2-.4 2.1-.9 3 1-.6 2-1.5 2.9-2.4-.4 1.4-1.5 2.8-1 4.1.3-1.3 1.3-2.3 2.3-2.5-.2.7-.3 2.2-1.3 2.9 2.4.2 3.4-1.4 4.6-2.7-.1 1.3 0 2.4 1.6 4.3-.3-2.4.2-1.9 1.3-3.3.6 2.1 1.2 4.4 3.4 6-1-2.3-1-3.5-.6-4.9.3 1.5 1.7 3.3 2 4.6.3-1.5.5-3 1-4a20 20 0 0 1 1.4 5.6c.5-1 .9-2 1.1-3 19.8 20.5 24.2 46.7 2.5 74.4 7.8-5.2 9.8-13.5 14.1-20.6-4.2 9.3-6 19.7-13.5 27.4 7.2-6.2 8.7-11.9 13-17.9-4.5 12.5-11 26.2-19.8 38.8l4.8 5.2 4-6.9c9.4-15.4 24.7-37.5 17-71.1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx109("path", {
          fill: "#eac102",
          stroke: "#a08307",
          strokeWidth: 0.2,
          d: "M473.2 215.3c-1 .2-1.4.6-2.2 1.4 1 .2 1.7.3 2.6.3.2 0 .3-.4.3-.6l-.2-1c0-.2-.6-.1-.8 0z"
        }),
        /* @__PURE__ */ jsx109("path", {
          fill: "#a08307",
          d: "M471 216.7a9.9 9.9 0 0 1 2.2-.5 9.8 9.8 0 0 1-2.2.5"
        }),
        /* @__PURE__ */ jsx109("circle", {
          cx: 477.7,
          cy: 215.4,
          r: 0.8,
          stroke: "#000",
          strokeWidth: 0.1
        }),
        /* @__PURE__ */ jsx109("ellipse", {
          cx: 477.9,
          cy: 215.3,
          fill: "url(#gt_svg__n)",
          rx: 0.3,
          ry: 0.4
        }),
        /* @__PURE__ */ jsxs102("g", {
          fill: "#34541f",
          children: [
            /* @__PURE__ */ jsx109("path", {
              d: "M488.2 389.7a83.4 83.4 0 0 1 7.4-17.2 199.6 199.6 0 0 1 7.1-12.2l2.6-4-2.5 4a407 407 0 0 0-7 12.3 133.7 133.7 0 0 0-7.6 17zm-18.9-9.5a75.8 75.8 0 0 0 29.7-23.1 153.5 153.5 0 0 0-11.2 11.8 70 70 0 0 1-18.5 11.3m37.3-29.3c.8-1 1.5-2.2 2.2-3.3a136.2 136.2 0 0 0 6-10.2c1.4-2.3 2.6-4.7 3.8-7l3.7-7-1.7 3.5-1.8 3.6a256 256 0 0 1-7.7 13.8 93.8 93.8 0 0 1-4.5 6.6m5.9-25.1a58.4 58.4 0 0 0 8.5-13.4 72.6 72.6 0 0 0 6-23 54.2 54.2 0 0 0-.1 4 58.8 58.8 0 0 1-5.8 19 59.9 59.9 0 0 1-8.6 13.4"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M510.9 320a52 52 0 0 0 8.7-12.5A96 96 0 0 0 524 297l.3-.9.3-.9.6-1.8a41.6 41.6 0 0 0 .2-15.4 58 58 0 0 0 .7 7.7c0 2.6-.2 5.2-.7 7.7-.3.6-.4 1.3-.6 1.9l-.3.9-.4.9a229 229 0 0 1-4.4 10.6 51.6 51.6 0 0 1-3.8 6.6 36 36 0 0 1-5 5.8z"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M505 349.2c1.3-1.6 2.4-3.3 3.6-5l1.8-2.5 1.7-2.5 3-5.4 2.6-5.5c1.8-3.7 3.5-7.4 5-11.3a78.8 78.8 0 0 0 5.3-23.8 58.4 58.4 0 0 0-2.6-24.2 52.4 52.4 0 0 1 2.8 24.2 80 80 0 0 1-5.3 23.9c-1.5 3.8-3.2 7.5-5 11.2l-2.8 5.5c-.9 1.9-1.8 3.7-2.9 5.4-.5 1-1.1 1.7-1.7 2.6l-1.8 2.5-3.6 5z"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M507.8 352.3a443.4 443.4 0 0 0 13.4-23.5 81.9 81.9 0 0 0 8.7-39.2c0-4.5-.4-9-1.2-13.4a57.6 57.6 0 0 0 .1 0c.9 4.4 1.2 9 1.2 13.4a102.9 102.9 0 0 1-3.6 26.7 82 82 0 0 1-5 12.6 442.6 442.6 0 0 1-13.5 23.4zM480 220.8h1.4a14.3 14.3 0 0 1 4.1 1.3 35.8 35.8 0 0 1 9 6.8 37.8 37.8 0 0 0-9-6.6 19 19 0 0 0-5.5-1.5"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          fill: "#448127",
          children: [
            /* @__PURE__ */ jsx109("path", {
              d: "M496.4 231.6s3 1.8 4.7 4.4c0 0-4.7-.9-8-4.6"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#34541f",
              d: "M496.4 231.6a14.4 14.4 0 0 1 4.8 4.4l.1.2h-.2a14.5 14.5 0 0 1-4.4-1.8c-1.4-.8-2.6-1.8-3.7-3a15.2 15.2 0 0 0 5.9 3.8l2.2.7v.2a11.1 11.1 0 0 0-2.2-2.5 17.7 17.7 0 0 0-2.5-2"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M489.6 230.7s7.2 4.6 8.3 5c0 0-1.7-3.5-5.1-5"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#34541f",
              d: "m489.6 230.7 4.1 2.5a156.9 156.9 0 0 0 3.1 1.8l1 .6v.1a10.7 10.7 0 0 0-2.1-2.9 10.7 10.7 0 0 0-2.9-2.1 8.4 8.4 0 0 1 3 2 11 11 0 0 1 2.1 3l.2.2-.3-.1-2.1-1.2a153.5 153.5 0 0 1-6.1-4z"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M492.5 228.4s3.7 1.6 4.6 4.3c0 0-6.8-2.8-8-4.3"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#34541f",
              d: "M492.5 228.4a10.7 10.7 0 0 1 2.8 1.6l1.1 1.2.8 1.5v.2h-.2a77.2 77.2 0 0 1-7-3.7l-.9-.8.9.7 1 .6a36 36 0 0 0 6.1 3h-.1c-.2-.4-.4-1-.8-1.3a4 4 0 0 0-1-1.2 10.8 10.8 0 0 0-2.7-1.8"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M486.8 231.3s6.6 4.7 8.6 4.7c0 0-2-3.3-5.4-4.7"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#34541f",
              d: "M486.8 231.3a124 124 0 0 0 7.4 4.3l1.2.3-.1.2a12.4 12.4 0 0 0-2.3-2.8 13 13 0 0 0-3-2 10.7 10.7 0 0 1 4.4 3.2l1 1.5.2.1h-.2c-.5 0-.9-.1-1.3-.3l-1-.5a33.3 33.3 0 0 1-6.3-4"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M486.8 232.7s3.4 3 5.4 3c0 0-2-3.3-5.4-4.8"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#34541f",
              d: "M486.8 232.7a32 32 0 0 0 4 2.5l.6.2.8.2-.1.1a12.4 12.4 0 0 0-2.3-2.7 13 13 0 0 0-3-2 10.7 10.7 0 0 1 4.4 3.1l1 1.5.2.2h-.2a4 4 0 0 1-1.6-.4 11.5 11.5 0 0 1-2.6-1.7 4 4 0 0 1-1.2-1"
            }),
            /* @__PURE__ */ jsx109("path", {
              d: "M485 226.2s7.2 5.1 8 7.9c0 0-6.4-3-7.6-4.5"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#34541f",
              d: "M485 226.2a51.6 51.6 0 0 1 7.5 6.6l.7 1.2v.3l-.2-.1a79.6 79.6 0 0 1-6.8-3.9l-.8-.7.8.7 1 .6a37.3 37.3 0 0 0 6 3l-.2.2-.7-1.2a29.3 29.3 0 0 0-5-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs102("g", {
          stroke: "#24420e",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx109("path", {
              fill: "#406325",
              d: "M445 370.3a42.2 42.2 0 0 1-20.4 4.8c10-8.2 19.7-8.4 20.4-4.8zm69.8 4.5c5.2 4.7 21 8 23.5 7.4-10.6-10.7-22.1-11.8-23.5-7.4z"
            }),
            /* @__PURE__ */ jsx109("path", {
              fill: "#67923d",
              d: "M445 370.3c-.7-3.7-10.5-3.4-20.4 4.8a69.6 69.6 0 0 1 20.4-4.8zm69.9 4.4c1.4-4.4 12.8-3.3 23.4 7.5a84 84 0 0 0-23.4-7.5z"
            })
          ]
        })
      ]
    })
  ]
});
var Gt_default = SvgGt;

// src/country-flag-icons/generated/Gu.tsx
import { jsx as jsx110, jsxs as jsxs103 } from "react/jsx-runtime";
var SvgGu = (props) => /* @__PURE__ */ jsxs103("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx110("path", {
      fill: "#be0027",
      fillRule: "evenodd",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#3b5aa3",
      fillRule: "evenodd",
      d: "M25.6 27.3h589.5v428.4H25.6z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#cbe0e5",
      fillRule: "evenodd",
      d: "M314.4 413.2a10 10 0 0 0 8.4.1c137.8-73.3 137.8-274.3.1-346.6a10 10 0 0 0-8.7.2c-134.3 73.4-134.7 272.1.1 346.3z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#add2d9",
      fillRule: "evenodd",
      d: "M314.4 416.9c2 1.7 6.4 1.5 8.4 0 101.5-76 102-123.3 97.6-123.3h-201c-3 0 1.8 48.2 95 123.3"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#fdf9a1",
      fillRule: "evenodd",
      d: "M235.3 331.2a39.2 39.2 0 0 1 27.9 1.7c7.6 4 12 4 20.2 4 8.6.2 15.3 6.5 24.6 6.8 17.1.4 24.3 8.9 11 9-6.2 0-19.7-4.3-26.2-3.4-13.6 1.4-22.2 4.4-35 18.7l14.8 10c12.8-5.1 14.9-11 22-11.2 8-.3 10.7-5.2 20-5.2a92.6 92.6 0 0 0 33-3.2c14.8-3.4 7.8-13.8-1.2-17.5-7.3-3.1-20.8-.1-29.2-3.2-6.4-2.5-1.2-6.5 2.3-7.3 3.4-.7 7.1.5 11.4 1.2 7.7.6 17.4-.1 24.1-1.2 14-2.1 13.4-6.2 20-6.3 5-.3 8.7-1.7 12-4.1 4-2.7 8.1-8 12.9-7.8l12.7.5-18 40.4-50.7 51.7-26.3 10-57.8-37.7-29.1-44.7z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#179a3b",
      fillRule: "evenodd",
      d: "m301.8 292 116-.6 2-10.3s-4.1-.6-7.5-.8c-4.1-.3-11.3 4.4-16 4.3-3.5 0-7.3-6-10.7-6-6 0-6.4 5.3-12 5.5-4.5-.2-6.4-3.6-12.3-3.2-6 .3-5.6 3.7-13.3 3.5-10.2-.3-14.3-9.1-22.5-9.2-13.6-.2-14 13-23.8 16.7z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#fdf9a1",
      fillRule: "evenodd",
      d: "m301.8 294.4 119.4-.6v-3.2l-122.2.6z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#a79270",
      fillRule: "evenodd",
      d: "M350.8 330.3c1.9 7 3.8 9.4 11.2 11.3 7.3 1.7 18.5-5.4 11.6-12.3-6.6-6.4-13.6-8-19.5-13.8-12.5-12.3-31.3-42.5-31.3-63.8 0-18.3-1.8-55.8-1.8-91.3 0-2.3-7 6.4-7 8.8.4 31.3.4 55 1.6 86.6 2 23.1 13 38.7 22.7 52.7 4.3 6.8 10.6 14 12.5 21.8"
    }),
    /* @__PURE__ */ jsx110("text", {
      x: 465.1,
      y: 269.5,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx110("tspan", {
        children: "G"
      })
    }),
    /* @__PURE__ */ jsx110("text", {
      x: 488.1,
      y: 269.6,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx110("tspan", {
        children: "U"
      })
    }),
    /* @__PURE__ */ jsx110("text", {
      x: 516,
      y: 269.6,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx110("tspan", {
        children: "A"
      })
    }),
    /* @__PURE__ */ jsx110("text", {
      x: 539.5,
      y: 269.5,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx110("tspan", {
        children: "M"
      })
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#239e46",
      fillRule: "evenodd",
      d: "M259.6 160.9c-1.5 3 3.6-.9 4.8-1.3 6.7-2.4 9.3-10.8 20.8-5.7 9 3.9 21.1 1.6 14.8 5.6-7.8 4.7-23.5 9.9-23.8 33.2 1.3 2.2 1.4 1.9 2.5-.6 2.4-5.4 13.7-20.1 19.3-18.9 2.3.6 8.9-6.7 9-4.6.7 5.8-9 17.6-8.8 33.3 0 3.7 4.5 4.9 6.6 2.3 2.2-2.3 3.4-4.6 7.2-7.6 6.6-5.4 4.8-28.6 5.6-27.5 4.7 6 5.4 23.3 12.4 30.3 5.9 5.9 10.6 3 9.3-5-2.5-16.4-10.2-11.7-13.9-28.6-.8-3.3-1-6.2 3.4-4.9 5.3 1.6 8.5 4 12.4 10 4 5.8 11.4 11.3 15.7 14.6 7.5 5.8 10.2.8 6.6-6.6a39.6 39.6 0 0 0-21-18.2c-6.2-2.2-8.4-2.4-13.8-3.4-1.5-.3-3-3.4-.4-5.1a42.5 42.5 0 0 1 19.6-7.7c6.7-.2 12 5.2 16.7 6.6 9.4 2.4 9.4-3.5 5.2-8-3.4-3.7-10.6-10-17.3-9.1-13.5 1.7-12.6 1.3-21 6.8-3 1.8-6.4 3.8-5.1 1.6 3-5.5.2-4.5 4.9-10.1 3.6-4 6.3-7 10-8 3.4-.9 8-4.5 9.3-6.4 3.4-4.6.5-7.3-4.7-5.7-4.6 1.2-7 4.2-10 5-7.4 2.4-13.3 19-14.2 21.4-1.1 2.8-2.4 1.4-2.2-1 1-11.7 2-31.5-2-39.6-6.4-12-5.8-6.4-8.2-.7-3.6 9-2.3 17.5 0 26.3 1 4.4 4.6 9.4 5.3 12.9.5 2.7-1.6-.8-2.8-2.5-3.9-6-6.8-10-13.2-13.3a35.3 35.3 0 0 0-20.2-2c-1.8.6 2 3.2 3.5 4.4 4.3 3.4 12.4 4.5 18 7.9 4.6 2.9 8.2 4.7 9.8 8.7.6 3 1.6 7.4-.4 7.3-5.1-.3-13-4.8-29.4-3-8.4 1.2-15.6 8.3-20.3 16.9"
    }),
    /* @__PURE__ */ jsx110("path", {
      fillRule: "evenodd",
      d: "M295.3 310.6h4.7v7.9h-4.7z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#fdf9ff",
      fillRule: "evenodd",
      d: "M271.7 257.9c18.8 26 49 41.2 49.6 53h-58.8c13.5-16.2 21.8-27.2 9.2-53"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#a68861",
      fillRule: "evenodd",
      d: "M254.6 311.5c25.6 5.7 56.1 8.9 75.6-.8.2 5.7-6.3 14-11.7 14h-49c5.7-.9 9-2.6 18.2-3l-26 .2c-3 .1-8-7.6-7.1-10.4"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#be0027",
      fillRule: "evenodd",
      d: "M312.6 425c2.6 1.5 6.7 1.4 9 .2 147.8-78.7 147.9-294.4.2-372a10.7 10.7 0 0 0-9.4.2c-144 78.8-144.4 292 .2 371.7zm.7-17.7a9.3 9.3 0 0 0 8 .1c123.6-72.8 125.1-265.1.1-334-2.4-1.8-5.9-1.2-8.3 0-118.4 70.1-125 254.5.2 333.9"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#bd0728",
      d: "M268.8 225.4q3.4 0 6 1.4 3.5 1.8 4.3 6.6H276q-.6-2.6-2.6-4-1.8-1.2-4.7-1.2-3.3 0-5.7 2.7-2.3 2.5-2.3 7.6 0 4.2 1.9 7 2 2.7 6.3 2.7 3.3 0 5.4-1.9 2.3-1.9 2.3-6.2H269v-2.7h10.6v13h-2.1l-.8-3.2q-1.6 1.9-3 2.7-2.2 1.2-5.5 1.2-4.3 0-7.5-2.8-3.4-3.6-3.4-9.7t3.3-9.7q3.2-3.5 8.2-3.5m-.6 0",
      "aria-label": "G",
      fontFamily: "helvetica",
      fontSize: 25.6
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#bd0728",
      d: "M292.4 226.1v15.2q0 2.6 1 4.3 1.4 2.7 5 2.7 4.1 0 5.7-2.8.8-1.6.8-4.2V226h3.4v13.8q0 4.4-1.4 7-2.1 4.3-8.2 4.3-6.3 0-8.5-4.4-1.2-2.5-1.2-6.9V226zm6.3 0",
      "aria-label": "U",
      fontFamily: "helvetica",
      fontSize: 25.6
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#bd0728",
      d: "m338.4 240.5-3.7-10.7-4 10.7zM333 226h3.7l9 24.5h-3.8l-2.4-7.3h-9.7l-2.7 7.3h-3.3z",
      "aria-label": "A",
      fontFamily: "helvetica",
      fontSize: 25.6
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#bd0728",
      d: "M357 226h4.9l6.9 20.7 7-20.7h4.7v24.4h-3.2v-20.6l-7 20.6h-3.1l-7-20.6v20.6H357z",
      "aria-label": "M",
      fontFamily: "helvetica",
      fontSize: 25.6
    })
  ]
});
var Gu_default = SvgGu;

// src/country-flag-icons/generated/Gw.tsx
import { jsx as jsx111, jsxs as jsxs104 } from "react/jsx-runtime";
var SvgGw = (props) => /* @__PURE__ */ jsxs104("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx111("path", {
      fill: "#ce1126",
      d: "M0 0h220v480H0z"
    }),
    /* @__PURE__ */ jsx111("path", {
      fill: "#fcd116",
      d: "M220 0h420v240H220z"
    }),
    /* @__PURE__ */ jsx111("path", {
      fill: "#009e49",
      d: "M220 240h420v240H220z"
    }),
    /* @__PURE__ */ jsxs104("g", {
      id: "gw_svg__b",
      transform: "matrix(80 0 0 80 110 240)",
      children: [
        /* @__PURE__ */ jsx111("path", {
          id: "gw_svg__a",
          fill: "#000001",
          d: "M0-1v1h.5",
          transform: "rotate(18 0 -1)"
        }),
        /* @__PURE__ */ jsx111("use", {
          xlinkHref: "#gw_svg__a",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        })
      ]
    }),
    /* @__PURE__ */ jsx111("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(72 110 240)"
    }),
    /* @__PURE__ */ jsx111("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(144 110 240)"
    }),
    /* @__PURE__ */ jsx111("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(-144 110 240)"
    }),
    /* @__PURE__ */ jsx111("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(-72 110 240)"
    })
  ]
});
var Gw_default = SvgGw;

// src/country-flag-icons/generated/Gy.tsx
import { jsx as jsx112, jsxs as jsxs105 } from "react/jsx-runtime";
var SvgGy = (props) => /* @__PURE__ */ jsx112("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs105("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx112("path", {
        fill: "#399408",
        d: "M2.4 0H640v480H2.4z"
      }),
      /* @__PURE__ */ jsx112("path", {
        fill: "#fff",
        d: "M.2 0c-.9 0 619.6 241.5 619.6 241.5L0 479.8z"
      }),
      /* @__PURE__ */ jsx112("path", {
        fill: "#ffde08",
        d: "M.3 20.2c3.4 0 559 217.9 555.9 220L1.9 463.2.3 20.3z"
      }),
      /* @__PURE__ */ jsx112("path", {
        fill: "#000001",
        d: "M1.9.8c1.8 0 290.9 240.9 290.9 240.9L1.8 477z"
      }),
      /* @__PURE__ */ jsx112("path", {
        fill: "#de2110",
        d: "M.3 33.9c1.6-15 260.9 208.4 260.9 208.4L.2 451.7V33.9z"
      })
    ]
  })
});
var Gy_default = SvgGy;

// src/country-flag-icons/generated/Hk.tsx
import { jsx as jsx113, jsxs as jsxs106 } from "react/jsx-runtime";
var SvgHk = (props) => /* @__PURE__ */ jsxs106("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx113("path", {
      fill: "#EC1B2E",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx113("path", {
      id: "hk_svg__a",
      fill: "#fff",
      d: "M346.3 103.1C267 98 230.6 201.9 305.6 240.3c-26-22.4-20.6-55.3-10.1-72.4l1.9 1.1c-13.8 23.5-11.2 52.7 11.1 71-12.7-12.3-9.5-39 12.1-48.9s23.6-39.3 16.4-49.1q-14.7-25.6 9.3-38.9M307.9 164l-4.7 7.4-1.8-8.6-8.6-2.3 7.8-4.3-.6-8.9 6.5 6.1 8.3-3.3-3.7 8.1 5.6 6.8z"
    }),
    /* @__PURE__ */ jsx113("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(72 312.5 243.5)"
    }),
    /* @__PURE__ */ jsx113("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(144 312.5 243.5)"
    }),
    /* @__PURE__ */ jsx113("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(216 312.5 243.5)"
    }),
    /* @__PURE__ */ jsx113("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(288 312.5 243.5)"
    })
  ]
});
var Hk_default = SvgHk;

// src/country-flag-icons/generated/Hm.tsx
import { jsx as jsx114, jsxs as jsxs107 } from "react/jsx-runtime";
var SvgHm = (props) => /* @__PURE__ */ jsxs107("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx114("path", {
      fill: "#00008B",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx114("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx114("path", {
      fill: "red",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx114("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx114("path", {
      fill: "red",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsx114("path", {
      fill: "#fff",
      d: "m527 396.7-20.5 2.6 2.2 20.5-14.8-14.4-14.7 14.5 2-20.5-20.5-2.4 17.3-11.2-10.9-17.5 19.6 6.5 6.9-19.5 7.1 19.4 19.5-6.7-10.7 17.6zm-3.7-117.2 2.7-13-9.8-9 13.2-1.5 5.5-12.1 5.5 12.1 13.2 1.5-9.8 9 2.7 13-11.6-6.6zm-104.1-60-20.3 2.2 1.8 20.3-14.4-14.5-14.8 14.1 2.4-20.3-20.2-2.7 17.3-10.8-10.5-17.5 19.3 6.8L387 178l6.7 19.3 19.4-6.3-10.9 17.3 17.1 11.2ZM623 186.7l-20.9 2.7 2.3 20.9-15.1-14.7-15 14.8 2.1-21-20.9-2.4 17.7-11.5-11.1-17.9 20 6.7 7-19.8 7.2 19.8 19.9-6.9-11 18zm-96.1-83.5-20.7 2.3 1.9 20.8-14.7-14.8-15.1 14.4 2.4-20.7-20.7-2.8 17.7-11L467 73.5l19.7 6.9 7.3-19.5 6.8 19.7 19.8-6.5-11.1 17.6zM234 385.7l-45.8 5.4 4.6 45.9-32.8-32.4-33 32.2 4.9-45.9-45.8-5.8 38.9-24.8-24-39.4 43.6 15 15.8-43.4 15.5 43.5 43.7-14.7-24.3 39.2 38.8 25.1Z"
    })
  ]
});
var Hm_default = SvgHm;

// src/country-flag-icons/generated/Hn.tsx
import { jsx as jsx115, jsxs as jsxs108 } from "react/jsx-runtime";
var SvgHn = (props) => /* @__PURE__ */ jsxs108("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx115("path", {
      fill: "#18c3df",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx115("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsxs108("g", {
      id: "hn_svg__c",
      fill: "#18c3df",
      transform: "translate(320 240) scale(26.66665)",
      children: [
        /* @__PURE__ */ jsxs108("g", {
          id: "hn_svg__b",
          children: [
            /* @__PURE__ */ jsx115("path", {
              id: "hn_svg__a",
              d: "m-.3 0 .5.1L0-1z"
            }),
            /* @__PURE__ */ jsx115("use", {
              xlinkHref: "#hn_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx115("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx115("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        }),
        /* @__PURE__ */ jsx115("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        }),
        /* @__PURE__ */ jsx115("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        })
      ]
    }),
    /* @__PURE__ */ jsx115("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(133.3 -42.7)"
    }),
    /* @__PURE__ */ jsx115("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(133.3 37.3)"
    }),
    /* @__PURE__ */ jsx115("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(-133.3 -42.7)"
    }),
    /* @__PURE__ */ jsx115("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(-133.3 37.3)"
    })
  ]
});
var Hn_default = SvgHn;

// src/country-flag-icons/generated/Hr.tsx
import { jsx as jsx116, jsxs as jsxs109 } from "react/jsx-runtime";
var SvgHr = (props) => /* @__PURE__ */ jsxs109("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx116("path", {
      fill: "#171796",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "red",
      d: "M0 0h640v160H0zm320 364.1c51.3 0 93.3-42 93.3-93.3V160H226.7v110.8c0 51.4 42 93.4 93.3 93.4z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "M320 362.6a91.8 91.8 0 0 0 91.6-91.5V161.8H228.5V271a91.8 91.8 0 0 0 91.5 91.5z"
    }),
    /* @__PURE__ */ jsxs109("g", {
      fill: "red",
      children: [
        /* @__PURE__ */ jsx116("path", {
          d: "M267.1 165.2H232v38.7h35.2zm0 77.4h35.3v-38.7H267zM232 270.9c0 3.5.2 7 .6 10.4h34.6v-38.7H232zm105.7-28.3h-35.2v38.7h35.2zm0 77.4h35.2v-38.7h-35.2zm35.2 21.2A89.2 89.2 0 0 0 393 320h-20v21.2zM267.1 320h35.3v-38.7H267zm-20.1 0a89.2 89.2 0 0 0 20.1 21.2V320zm79.1 38.7c4-.3 7.7-.8 11.5-1.6V320h-35.2v37.1a87 87 0 0 0 11.4 1.6c4.1.3 8.2.2 12.3 0"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "M407.4 281.3c.4-3.4.6-6.9.6-10.4v-28.3h-35.2v38.7zm-69.8-38.7h35.2v-38.7h-35.2zm0-77.4h-35.2v38.7h35.2zm70.4 38.7v-38.7h-35.2v38.7z"
        })
      ]
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "m410 158.8 21.8-49.5-16.6-26.8-27.6 10.2-19.4-22.2-25.4 14.7L320 66.5l-22.7 18.6-25.5-14.6-19.4 22.2-27.6-10.3-16.6 27 21.8 49.4a217.8 217.8 0 0 1 90-19.3c32 0 62.5 6.9 90 19.3"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#0093dd",
      d: "m253 94.8-27.4-10-15.3 24.7 5.9 13.3 14.8 33.7a219.7 219.7 0 0 1 34.6-12z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M251.4 119.3a13.3 13.3 0 0 1 1.6 6.2c0 7.3-6 13.3-13.4 13.3a13.4 13.4 0 0 1-13.1-10.8 13.4 13.4 0 0 0 11.7 6.9 13.4 13.4 0 0 0 13.2-15.6z"
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "m227.6 114 1-4.9-3.8-3.2-.1-.1.2-.1 4.6-1.6 1-4.8v-.2l.2.1 3.7 3.2 4.6-1.6h.2v.2l-1 4.8 3.7 3.2.2.2h-.3l-4.6 1.6-1 4.8v.2l-.1-.1-3.7-3.2-4.6 1.6h-.3z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#f7db17",
      d: "m233.6 107.6 3.5 3 4.3-1.5zm0-.2 7.8 1.6-3.4-3zm-8.3-1.6 7.8 1.5-3.5-3zm7.8 1.7-7.8-1.5 3.4 3zm.4-.3 5.2-6-4.3 1.5zm-5.6 6.4 5.2-6-4.3 1.5zm5.3-5.9-5.2 6 4.3-1.5zm5.6-6.4-5.2 6 4.3-1.5zm-5.6 6-2.6-7.6-.9 4.5zm2.7 8-2.5-7.5-.9 4.5zm-2.4-7.6 2.6 7.5.9-4.5zm-2.7-8 2.5 7.5 1-4.5z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#171796",
      d: "M297.5 87.4 272.1 73 253 94.9l12.6 49.6a219.8 219.8 0 0 1 36.1-6z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "red",
      d: "M262.5 132.2a232.3 232.3 0 0 1 38.2-6.4l-1-12.9a245.6 245.6 0 0 0-40.4 6.7zm-6.3-25a258 258 0 0 1 42.4-7l-1.1-12.7a270.7 270.7 0 0 0-44.5 7.4z"
    }),
    /* @__PURE__ */ jsxs109("g", {
      transform: "translate(-160) scale(.00237)",
      children: [
        /* @__PURE__ */ jsx116("path", {
          fill: "#0093dd",
          d: "m212105 36890-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z"
        }),
        /* @__PURE__ */ jsxs109("g", {
          id: "hr_svg__a",
          children: [
            /* @__PURE__ */ jsx116("path", {
              d: "M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z"
            }),
            /* @__PURE__ */ jsxs109("g", {
              fill: "#f7db17",
              children: [
                /* @__PURE__ */ jsx116("path", {
                  d: "M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zm-5008 0c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zm4539 905c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59m-4032 0a59.1 59.1 0 1 0 .2 118.2 59.1 59.1 0 0 0-.2-118.2m4294-304c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z"
                }),
                /* @__PURE__ */ jsx116("path", {
                  d: "M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zm4389 911c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7a340.4 340.4 0 0 0-93 126c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247a642 642 0 0 0-238-157c-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z"
                }),
                /* @__PURE__ */ jsx116("path", {
                  d: "M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z"
                }),
                /* @__PURE__ */ jsx116("path", {
                  fillRule: "evenodd",
                  d: "M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15a123 123 0 1 1 113-171l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54a123 123 0 1 1 0 246c-12 0-25-2-36-6l33 94-2 7zm3067-416a123 123 0 1 0 0 246 123 123 0 1 0 0-246m0 64a59.1 59.1 0 0 0 0 118c32 0 59-27 59-59s-26-59-59-59m-1082-91a123 123 0 1 0 123 123c0-68-55-123-123-123m0 64a59.1 59.1 0 1 0 .2 118.2 59.1 59.1 0 0 0-.2-118.2m-1064-40a123 123 0 1 0-.2 245.8 123 123 0 0 0 .2-245.8m0 64c-33 0-59 26-59 59s26 59 59 59a59.1 59.1 0 0 0 0-118"
                })
              ]
            }),
            /* @__PURE__ */ jsx116("path", {
              d: "M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110m799 5115-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48m59-326-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51m-1826-65 604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15m51 322 515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210 402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38m593-3082c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49m371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16l25-19c6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z"
            }),
            /* @__PURE__ */ jsx116("path", {
              fillRule: "evenodd",
              d: "M203459 50602a216.4 216.4 0 0 0 0 433 216.6 216.6 0 0 0 0-433m0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147m0 60a87 87 0 1 0 .1 174.1 87 87 0 0 0-.1-174.1m-1697-124c119 0 217 97 217 216s-97 217-217 217a216.6 216.6 0 0 1 0-433m0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147m0 60a87 87 0 1 1-.1 174.1 87 87 0 0 1 .1-174.1"
            })
          ]
        }),
        /* @__PURE__ */ jsx116("use", {
          xlinkHref: "#hr_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(-2.2 -55532.8 156275.8)"
        }),
        /* @__PURE__ */ jsx116("use", {
          xlinkHref: "#hr_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(2.2 459865.8 156275.8)"
        })
      ]
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#171796",
      d: "m387.2 94.9-19.3-22-25.2 14.5-4.3 51.1a219.7 219.7 0 0 1 36.2 6z"
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "M347.7 98c.8-.2 1.7-.2 2.6.3.3.1.6.3.8.6.4-.3.7-.6 1.2-.8a4 4 0 0 1 1.8-1c.9-.5 1.8-.8 2.7-.9h2.8c.8 0 1.6.2 2.3.6l2 1c.8.4 1.5.8 2.2 1a9.1 9.1 0 0 0 4.5.5c.4-.2.7.1.2.4-3.3 2-5.9.2-8.1-.6a16.2 16.2 0 0 1 2.1 1.7c.8.8 1.8 1.6 3.5 2.4a8.4 8.4 0 0 0 5 .7l.4.1-.1.5a4.8 4.8 0 0 1-2.6.7 10 10 0 0 1-5.2-1.3c-1.4-.7-2.3-1.6-3.3-2.4a7.5 7.5 0 0 0-3-1.4 6 6 0 0 0-2.9 0c.3.1.5.2.6.4.5.3 1 .4 2 .5.4 0 .2.3-.5.7a2 2 0 0 1-1.6.8c-1 .6-1.3.2-1.7-.2 0 .3 0 .5-.2.8a.6.6 0 0 1 0 .4l.2.7c0 .2 0 .3.2.4.2.2.3.4.3.7 0 .2.1.3.3.4l.6.6c.6.2.8.7 1 1.2.4.2.6.5.7.9.2 0 .4.2.6.4l2.6.1c.8.1 1.4.6 2 1.2h1.2a4 4 0 0 1 1.3-.3h2.3c.5.2.9.4 1.2.8.5.5 1.2.4 1.8.2a2.7 2.7 0 0 1 2.4 0 2.3 2.3 0 0 1 1-.2c.4-.3.7-.4 1-.4.6 0 1 0 .9.8 0 .2-.2.4-.3.4-.3.6-.7.7-1.3.7-.1.4-.3.7-.5.8.3.9 0 1.3-.7 1.2 0 .3-.3.4-.6.4a1.4 1.4 0 0 1-1 .5l.4.6c.4.7-.2 1-.8 1v1.2c.7.4.8.8.2 1.2.4.7.3 1.3-.5 1.6 0 .4 0 .8-.3 1-.2.2-.5.3-.3.6.3.5.2 1.1-.2 1.2l-.2.1-.2.2a9.6 9.6 0 0 0-1.5 1c-.1 0-.2.1-.2 0a9.6 9.6 0 0 1-1.8 2.4c0 .5-.4 1-1 1.1a.4.4 0 0 1-.3.4c.3.3.5.6.2 1a3 3 0 0 1-1.3.8c-1 .3-1.7.2-2-.2-.4-.3-.3-.6 0-.7-.7 0-.8-.2-.8-.7 0-.2.1-.2.3-.1.4 0 .7-.2 1-.3l.5-.6c0-.7.5-1 1.1-1.3.5-.2 1-.6 1.4-1.2l.9-1.5a1.2 1.2 0 0 1-.3-.7 1.5 1.5 0 0 1-.5-.6c-.5 0-.7-.2-.7-.5a1.1 1.1 0 0 1-.3 0c-.3.1-.5.3-.7.2a6.9 6.9 0 0 1-1.1 1c-.2.3-.4.5-.7.5-1 .1-1.5 1.2-2 1.7-.2.1-.3.4-.4.7 0 .6-.1 1-.4 1h-.4a1.2 1.2 0 0 0-.4 0c.3.3.3.6 0 .9-.1.3-.4.4-.8.4a3.6 3.6 0 0 1-1.6-.2c-.4-.2-.5-.5-.5-.7-.3-.2-.4-.3-.3-.5 0-.2.2-.3.4-.2l.6-.2a5.2 5.2 0 0 1 1.8-1.4 3 3 0 0 1 .7-.7c0-.5.5-1 1-1.4l.1-.6v-.3c-.2-.3-.3-.7-.1-1a1.3 1.3 0 0 1 0-.6c-1.1.6-1.5.4-1.6-.1-.4.3-.8.5-1 0-.4.1-.8.3-1.2.1l-.8.2-.4.7c0 .5-.2 1-.5 1.5a9.3 9.3 0 0 1-.7 1.5 1 1 0 0 1-.1.5c0 .6-.2.9-.5 1a2.4 2.4 0 0 1-.4.8v.2c.1.3.1.7-.2 1l-1 .6h-1c-.4-.3-.4-.4-.3-.6a.6.6 0 0 1-.5 0l-.4-.3c-.1-.2-.1-.4.1-.5l.9-.6c0-.2.2-.3.4-.4.2-.4.4-.6.6-.7l.7-1.5c.1-.1.2-.3.1-.4l.1-.3s.2-.1 0-.2a1.4 1.4 0 0 1 .2-1.2c.3-.4.6-1.4.3-2v-.8h-.3c-.2-.2-.4 0-.6.2l-.4.6c-.1.8-.5 1.5-1 1.6v1.2c0 .4 0 .7-.2.7s-.4.2-.5.5a1 1 0 0 0-.1.3c.3.3.2.7-.1 1-.6.6-1.4.5-2.2.3-.6-.3-.8-.5-.7-.8-.8 0-.7-.7 0-.9.8-.2 1.4-.7 1.9-1.4 0-.8.2-1.3.7-1.4 0-.5.2-1 .4-1.4.2-.4.3-.8.2-1.3-.4-.3-.4-.6 0-1 .1 0 .1 0 0-.2-.3 0-.3-.3-.3-.5s0-.2-.2-.2c-.6-.1-.5-.4-.2-.7.1 0 .2-.3 0-.4l-.1-.4c-.4-.3-.2-.6 0-.9l-.4-.8c-.7 0-1-.4-.6-.9a3.4 3.4 0 0 1 .7-.6c.1-.3.3-.6.2-.8-.2-.6.5-1 1-1.4a.9.9 0 0 1-.1-.4c-.3-.3-.2-.6.1-.8a1 1 0 0 1-.1-.5c-.8.2-.8-.3-.4-1-.5-.3-.4-.8.5-1.5a1 1 0 0 1 0-.4 2 2 0 0 0-1 .3c-.3.3-.6.2-.9.1a1.5 1.5 0 0 0-.4-.4.6.6 0 0 1-.2-.6c-1 0-1.1-.7-.6-1 .3-.3.6-.6.7-.9.2-.6.7-1 1.3-1.5v-.5a1.6 1.6 0 0 0-.7-.3 1.2 1.2 0 0 0-.6-.7c-.1 0-.2-.2 0-.4-.6-.4-.5-.7-.3-1"
    }),
    /* @__PURE__ */ jsxs109("g", {
      fill: "#f7db17",
      children: [
        /* @__PURE__ */ jsx116("path", {
          d: "M364.5 122a1.4 1.4 0 0 1-.2 0 8.4 8.4 0 0 1-.8.7c-.2-.3-.5 0-.2.1l-.2.2c0 .3-.2.4-.5.4h-.1a3 3 0 0 1 0-.3 3.5 3.5 0 0 1 0-.4 3.9 3.9 0 0 0-.1.4 2.8 2.8 0 0 0 0 .4c-.8.3-1.3 1.1-1.9 1.7l-.4.8c0 .2 0 .9-.3.9h-.2c0-.1-.2-.1-.4 0h-1c-.2.2.4.2.7.3.1.1.2.3.1.5-.2.7-1.8.5-2.3.2-.2-.1-.2-.3-.2-.5h.3c.2 0 .4 0 .5-.2 0 0 .1 0 0-.1 0-.1 0-.1 0 0a1.3 1.3 0 0 1-.5 0 2.6 2.6 0 0 1-.5 0h-.2c0-.1.2 0 .2 0l.7-.3a5.3 5.3 0 0 1 1.9-1.4l.8-.7c0-.7.4-1 .8-1.5l.3-.7v-.3c-.2-.4-.3-.7-.1-1a1.5 1.5 0 0 1 0-.8.3.3 0 0 0 0-.1 6.2 6.2 0 0 1 .8-.6v.8a1.3 1.3 0 0 0-.2.3.5.5 0 0 0 0 .2v.1a.4.4 0 0 1 0-.3l.3-.2.7-.4.7-.6v1l-.6.7v.1h.1a2.3 2.3 0 0 1 .5-.7 3.2 3.2 0 0 1 1-.6v1a1.5 1.5 0 0 0 .5.9"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "m349 113 .2-.2.4-.6a4 4 0 0 1 .5-.6 4 4 0 0 0-.4.7 5.8 5.8 0 0 0-.4.5v.2c.1.3.1.5.3.7l.3-.4a1.6 1.6 0 0 1 .4-.4 1.8 1.8 0 0 0 .5-.6h.1l-.2.4a2 2 0 0 1-.3.3l-.4.3a1.3 1.3 0 0 0-.2.4v.3c-.2.3-.5.5 0 .7a.6.6 0 0 0 .1.5l-.1.7c-.3.2 0 .2.1.2l.4-.4a4.3 4.3 0 0 1 .3-.4l.4-.5.1-.5h.1a1.4 1.4 0 0 1-.1.6 2 2 0 0 1-.5.5 3.8 3.8 0 0 0-.2.4 2.6 2.6 0 0 0-.3.4c.2.1.2.4.2.7h.1l.2-.2.2-.4h.1l-.2.4-.2.3c.2.1.2.3 0 .5-.4.3-.3.4 0 .7v1.2l.1.3h-.1v-.3c-.4.7-.6 1.1-.7 1.8-.6.1-.5.8-.6 1.3a3.9 3.9 0 0 1-1.9 1.5c-.1 0-.5.1-.5.3 0 .1.2.3.4.2.4-.5.7-.2.2.2v.3c.5.4 1.6.5 2.2.2.3-.3.5-.5.2-.9 0-.5.2-1 .8-1.2v-.4l.1-1.3.2-.1c.2 0 .6-.7.7-1.3v-.4c.1-.2.2-.2.3 0 0-.2 0-.3.2-.4.2-.3.5-.6.8-.4a3 3 0 0 1-.1-.8 2.7 2.7 0 0 1 0-1l.2-.2.3-.7.3-.7h.1l-.3.7-.3.8v.1a2.5 2.5 0 0 0-.1 1l.2.9.2.4v.6c.4.6 0 1.7-.3 2.2a1 1 0 0 0-.1.8c.2.2 0 .4-.1.6v.1c0 .2 0 .4-.2.5l-.7 1.6c-.4.1-.5.3-.6.7-.3.1-.3.2-.4.4a2.7 2.7 0 0 1-.9.6c-.3.1 0 .2.2.4.2.1.4-.2.6-.4.2-.3.3-.2.2 0a2 2 0 0 0-.2.7l.7.3c.4 0 .9-.4 1.2-.6.3-.2.2-.5.1-.8a2 2 0 0 1-.5 0 3.4 3.4 0 0 1-.5-.3 2.8 2.8 0 0 0 1 .2v-.3a2.7 2.7 0 0 0 .5-.8c.4-.2.4-.4.4-.9l.1-.5a10 10 0 0 0 .7-1.6c.4-.4.5-.9.5-1.4 0-.2.1-.3.3-.3a3.8 3.8 0 0 0 .3-.5l.1-.4a.8.8 0 0 1 .2-.2 1 1 0 0 0 0-.5 1.1 1.1 0 0 0-.1-.4.5.5 0 0 1-.1-.2v-.2h.1c.1 0 0 0 0 0v.1a.5.5 0 0 0 0 .2c.2.2.2.3.2.5a1 1 0 0 1 0 .5.7.7 0 0 0-.2.2 1.7 1.7 0 0 0 0 .3l.6-.1.4-.5.2-.6c.1 0 0 0 0 0a2 2 0 0 1-.1.7l-.3.3c.4.2.7 0 1 0V119l.4-.7c.1 0 .1 0 0 0l-.2.8v1c.1.4.2.5.5.3l.4-.2v-.1a18.2 18.2 0 0 1 1.8-1.6c.1.1 0 .1 0 .1a6.5 6.5 0 0 0-.8.7l-.8.7v.3c0 .3.1.5.6.3l.6-.2a1.3 1.3 0 0 1 .3-.2 8 8 0 0 1 .5-.3l.5-.3a3 3 0 0 1 .1-.6l.7-1.3a2.3 2.3 0 0 0 1.1-1.1h.1l-.4.7a2.5 2.5 0 0 1-.7.5l-.7 1.2a2.7 2.7 0 0 0-.1.5v.1a2.8 2.8 0 0 0 0 .8c.2 0 .4 0 .7-.3l.7-.7a1.7 1.7 0 0 1 .2-.5 1 1 0 0 1 .4-.4h.1v.1a.9.9 0 0 0-.4.3 1.7 1.7 0 0 0-.2.5v1.1l1-.5v1c0 .3.2.6.4.8a2.8 2.8 0 0 1 .5-.6l.3-.3.2-.2.3-.2-.2.3-.2.2-.3.2v.5h.6c0 .5 0 .6.5.6a3.2 3.2 0 0 1 0-.5l.1-.5h.1a1.9 1.9 0 0 0-.1.5 3.1 3.1 0 0 0 0 .5c.2.3.3.4.7.6l.2-.5a1.4 1.4 0 0 0 0-.4h.1v.5l-.3.5v.5a3 3 0 0 1 .2-.3l.3-.4c.1 0 .1 0 0 0 0 .2 0 .3-.2.4a4 4 0 0 0-.2.4l.2.2c-.6 1-1.3 2.5-2.5 3-.6.2-.9.5-1 1.2a1 1 0 0 0-.5.6l-1.2.3c0 .3 0 .4.3.4l.7-.3c.1 0 0 .5-.5.8v.1c.4.6 1.4.4 1.9.2.4 0 1-.5 1.2-.9.1-.2 0-.4-.2-.6-.8.1-.6-.6 0-.3.2 0 .3 0 .3-.3.6-.2.9-.5 1-1 .6-.7 1.2-1.4 1.6-2.1.1-.2.2-.4.1-.5a1 1 0 0 0 .2-.5l.1-.4h.1v.5a4.5 4.5 0 0 1-.2.3c0 .1 0 .2.2.2l1.5-1c0-.3.2-.4.4-.4l.2-.1c.1-.4 0-.6-.2-.8-.1-.4.1-.5.4-.7.2-.2.2-.7.2-1v-.2a2.6 2.6 0 0 0 0-.3l.1.3v.1c.3-.1.6-.3.7-.6 0-.3-.1-.6-.3-.8a9.6 9.6 0 0 1-.6.2 10.2 10.2 0 0 0 .7-.4 1.3 1.3 0 0 0 .3-.2c.2-.3-.3-.5-.5-.6l-.7-.7v-.1l.7.6v-1.1l-.2-.4a1.1 1.1 0 0 1-.5-.4 1 1 0 0 1-.1-.5l.2.4.4.4h1c.3-.3-.2-.7-.3-.9l-.1-.5h.1a1 1 0 0 0-.2-.2.6.6 0 0 0-.1 0v-.2a.7.7 0 0 1 .2.1l.2.2a.9.9 0 0 0 .1 0c.3 0 .5-.2.7-.5a3.6 3.6 0 0 0-.3-.4 10 10 0 0 0-.5-.3v-.1h.1a4 4 0 0 1 .8.8c.4 0 .4 0 .6-.3a1.5 1.5 0 0 0-.2-.4 2.5 2.5 0 0 0-.3-.4c0-.1 0 0 0 0 .2 0 .3.2.4.3l.2.5.4-.1c.3-.2 0-.8 0-1a2.8 2.8 0 0 0-.1 0l-.2-.2c0-.1 0 0 0 0h.2l.2.1.4-.6c0-.4 0-.2.5-.3.4 0 .6 0 .9-.6.1 0 .2 0 .2-.3s0-.4-.3-.4c-.5 0-.8 0-1 .3v.3c0 .1 0 0 0 0l-.2-.2c-.4 0-.7 0-1.1.2h-.2l.2.3.1.4a1 1 0 0 0-.2-.4 1.8 1.8 0 0 0-.3-.4 2.6 2.6 0 0 0-1-.2l.2.1.2.2v.1a7.7 7.7 0 0 1-.2-.2 6.5 6.5 0 0 1-.2-.2 2.7 2.7 0 0 0-.9.2l-.6.2.4.5.2.6a2.1 2.1 0 0 0-.3-.6 1.9 1.9 0 0 0-.4-.4 1.8 1.8 0 0 1-.5 0l.2.3-.3-.4a1.4 1.4 0 0 1-.5-.2 8.3 8.3 0 0 1 .2 1.5 7.8 7.8 0 0 0-.2-.9 4.7 4.7 0 0 0-.1-.7 1.7 1.7 0 0 1-.2-.2 2.1 2.1 0 0 0-.6-.4 1 1 0 0 1-.2.7c-.1 0 0 0 0 0a.8.8 0 0 0 .1-.8 3.1 3.1 0 0 0-1-.2 5.3 5.3 0 0 1 .5.8l.3.5v.5a2 2 0 0 0-.1-.5.7.7 0 0 0-.3-.4 5.6 5.6 0 0 0-.3-.5 4.6 4.6 0 0 0-.3-.4h-.4.1a.6.6 0 0 1 0 .3.5.5 0 0 0 0-.2.7.7 0 0 0-.2-.1h-.8a5 5 0 0 1 1 2.3 4.8 4.8 0 0 0-.4-1.2 5.1 5.1 0 0 0-.7-1h-.6a1.7 1.7 0 0 1 .4.4c0 .1 0 .1 0 0a1.6 1.6 0 0 0-.3-.1 2.4 2.4 0 0 0-.3-.2 5 5 0 0 0-.3 0l-.1.1a4.7 4.7 0 0 1 1 1.1c0 .1 0 0 0 0a3.8 3.8 0 0 0-.6-.6 4.7 4.7 0 0 0-.6-.4h-.6a5 5 0 0 1 .5 1.7h-.1a3.5 3.5 0 0 0-.2-.8 6.2 6.2 0 0 0-.3-.9 8 8 0 0 1-.4 0 9.1 9.1 0 0 1 .3 1.6v.1a9.3 9.3 0 0 0-.2-1 9.3 9.3 0 0 0-.3-.8 3.9 3.9 0 0 0-1.3-1 1.7 1.7 0 0 1 .4 1.1v.1a1.6 1.6 0 0 0-.2-.7 1.7 1.7 0 0 0-.4-.6 2 2 0 0 0-.3 0 15.6 15.6 0 0 0-1 0c.2.1.4.4.4.6 0-.2-.3-.5-.6-.7h-.6l.3.3.2.5.2.6.4.4s.1 0 0 0c0 .1 0 .1 0 0a1.1 1.1 0 0 1-.5-.3 1.5 1.5 0 0 1-.2-.7 1.3 1.3 0 0 0-.2-.4 2.7 2.7 0 0 0-.3-.4h-.7l.2.8.1 1h-.1a7.1 7.1 0 0 0 0-1 4.5 4.5 0 0 0-.3-.8 1 1 0 0 0-.6-.5.6.6 0 0 1 0 .3h-.1a.5.5 0 0 0 0-.3c-.2-.5-.3-.7-.6-.8v.4l-.2.4h-.1l.1-.5v-.4c0-.6-.2-1-.8-1.2v.2l-.1.5h-.1v-.5a1.9 1.9 0 0 0 0-.3l-.5-.5a2.3 2.3 0 0 1 0 .7 3 3 0 0 1-.4.8h-.1a3 3 0 0 0 .3-.8 2.2 2.2 0 0 0 .1-.8 1 1 0 0 1-.2-.3v.2h-.1v-.2l.1-.1v-.1a.7.7 0 0 0-.3-.5 1.5 1.5 0 0 1-.2.5h-.1c-.1 0 0 0 0 0l.1-.3.1-.3a1 1 0 0 1-.1-.2.8.8 0 0 1-.1.2 1.2 1.2 0 0 1-.2.2c-.1-.1 0-.1 0-.1l.1-.2a.7.7 0 0 0 .1-.2v-.2c0-.3 0-.4-.2-.7a.9.9 0 0 0-.3 0 2.8 2.8 0 0 0-.5.4v-.1a3.2 3.2 0 0 1 .4-.3.9.9 0 0 1 .4-.1.4.4 0 0 0 0-.2l-1 .3a1.6 1.6 0 0 1-.9-.2h.8c.3 0 .7 0 1.1-.2l.2-.6a1.7 1.7 0 0 1-.5 0l.6-.1v-.2c0-.2.3-.2.4 0 .2 0 .3.2.4.3.3.2.6 0 .9-.2h-.2v-.1h.3c.6 0 1 0 1.4-.5a7 7 0 0 1-1 0c-.2 0-.4 0-.6-.2l.7.1h1l.5-.3a5.4 5.4 0 0 1-2-.6 1.4 1.4 0 0 0-.6-.3c-.5 0-1 0-1.4.3l-.3-.3-.4-.2h-.6s-.1 0 0 0h1.2a4.5 4.5 0 0 1 1.7-.3 5.7 5.7 0 0 1 1.7-.2v-.2c.3-.3.4-.6.3-.9-.1-.2-.4-.5-.8-.7h-1.3a4 4 0 0 0-.8.1l.6.4.4 1v.1h-.2a2 2 0 0 0-.4-1c-.1-.2-.6-.3-.7-.4l-1.3.2-.7.4c.3-.1.6 0 .8 0 .3.2.5.4.6.8v.1h-.2a1 1 0 0 0-.5-.7c-.4-.2-1.2 0-1.6.3a4.2 4.2 0 0 0-.6.6h-.2v-.2l.7-.6.7-.4a2 2 0 0 1 1-.5l1.3-.2a1 1 0 0 0-.5-.5 1.4 1.4 0 0 0-.8 0c-.5.1-1 .4-1.5.7h.5l.1.2h-.5a1.4 1.4 0 0 0-.4 0l-1.5 1.2c-.5 0-.8 0-1 .2l-.1.6-.2.7c-.5.5-1 .9-1.3 1.5a1.4 1.4 0 0 1-.3.5.5.5 0 0 1 .3.1v-.2l.2-.4h.1a1.2 1.2 0 0 0-.1.4v.5h-.2a.3.3 0 0 0-.1-.2.5.5 0 0 0-.3 0l-.3.2-.2.3c0 .3.2.3.5.3.6 0 .1.4.4.7l.5.4h.5c0-.4 0-.6.2-.6a.8.8 0 0 1 .2-.4.8.8 0 0 0 0 .2.8.8 0 0 0-.1.2v.4a2.4 2.4 0 0 1 1-.2c.7-.8 1-.6.4 0l-.1.2a1.4 1.4 0 0 0-.2.6c-.2.1-1 .8-.7 1 .2 0 .4 0 .3.2-.1.2-.4.6-.3.9h.3a6.2 6.2 0 0 0 .7-.6 3.8 3.8 0 0 0 .5-.8h.1a9 9 0 0 1 .3-.8c0-.2.1-.5.3-.7l.3.3a.4.4 0 0 0 .2 0 .4.4 0 0 0 .3 0l.2-.3h.1a1.2 1.2 0 0 1-.3.4.5.5 0 0 1-.3 0 .5.5 0 0 1-.2 0 1.1 1.1 0 0 1-.3-.3 12 12 0 0 0-.5 1.4v.1a5.6 5.6 0 0 1-1.2 1.4l.2.5 1-1 .8-1a6 6 0 0 1-.3.6v1.1h-.1v-.9l-.3.3a11.6 11.6 0 0 1-1 1c-.3.3-.6.3-.2.7l.3-.3.4-.3h.1v.1l-.4.3-.4.3a.6.6 0 0 0 .1.3.5.5 0 0 1 .1 0l.8-.6c.1 0 0 .1 0 .1l-.7.6a.7.7 0 0 1-.1 0c-.3.3-1.2.8-1 1.2l.6-.2.6-.5c.1 0 0 0 0 .1a2.5 2.5 0 0 1-.6.5v.2-.1a3.6 3.6 0 0 1-.7.1c.1.4 0 .7-.3 1 0 .1-1 .9-.6 1a1 1 0 0 0 .3.2"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "M349.4 100.1a2.2 2.2 0 0 0-.6-.3 1.4 1.4 0 0 0-.5-.5c-.2-.2-.2-.1-.1-.3l.2-.1a.9.9 0 0 1 .3 0 .4.4 0 0 1 .2.2h.1c.1 0 0 0 0 0a.5.5 0 0 0-.2-.2 1 1 0 0 0-.4-.1.7.7 0 0 0-.4 0l-.2-.5.4.1.2.1a.7.7 0 0 0-.2-.2 2 2 0 0 0-.2 0 2.9 2.9 0 0 1 2.1.2c.4.1.6.3.8.6l-.2.2c-.5 0-.8 0-1 .2-.2.1-.2.4-.2.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "m365 121.8-.4.2c0-.3.2-.4.3-.6v.2zm2 4.2a2.3 2.3 0 0 1-.4.4 4 4 0 0 1-.5.4v-.1l.4-.4.4-.4zm1.3-1.6-.2.3h-.1l.2-.3zm-.7 0a1.1 1.1 0 0 1-.2.3 1 1 0 0 1-.5.4v-.1a1 1 0 0 0 .4-.3 1 1 0 0 0 .1-.4zm1.2-1.6a1 1 0 0 0-.1.2 1.1 1.1 0 0 0-.1.2h-.1a1.1 1.1 0 0 1 .3-.5zm1 0v.5l-.3.5c-.1 0 0 0 0 0l.1-.5zm-.4-6c.3.5.4 1 .4 1.5a7.3 7.3 0 0 1 .1-.6 1.4 1.4 0 0 0 .3-1.1c0-.1.1 0 .1 0v.6a1.7 1.7 0 0 1-.3.6l-.2 1h-.1v-.1c0-.6 0-1.2-.4-1.8zm-.8 1v.3h-.1v-.4zm-.2 1.4a6.2 6.2 0 0 1 .2 1.4 1 1 0 0 1 .1-.1l.3-.3h.1a1 1 0 0 0-.3.3.7.7 0 0 0-.2.4 5 5 0 0 0-.1-.9 5.9 5.9 0 0 0-.2-.8zm1 .5a3.6 3.6 0 0 1 .1 1.2v-.6a3.6 3.6 0 0 0-.1-.6m1-.2v.6a1.5 1.5 0 0 1 0 .5 1.2 1.2 0 0 0 0 .6l.1.6a2.5 2.5 0 0 1-.3-.6 1.3 1.3 0 0 1 0-.6 1.4 1.4 0 0 0 .2-.5 2.3 2.3 0 0 0 0-.6m.5-1.5-.1.3v.2h-.1v-.6zm-.5-2.6v.2c.1 0 .1 0 0 0 0 .1 0 0 0 0zs-.1 0 0 0c0-.1 0 0 0 0m.2-2v.8a.8.8 0 0 0-.2.3 1.4 1.4 0 0 0 0 .6h-.1a1.4 1.4 0 0 1 0-.6.9.9 0 0 1 .3-.4zm-2-.7c.4.2.6.4.8.7.2.2.3.5.3.9l-.6-.2v1.8c-.2.5-.5.8-1 1a3.8 3.8 0 0 0 0-1.8h.1a3.6 3.6 0 0 1 0 1.6 1.5 1.5 0 0 0 .7-.8 3.7 3.7 0 0 0 .1-1.9l.6.2c0-.3-.1-.5-.3-.8a2.5 2.5 0 0 0-.7-.6zm5.2-1v.2h-.1v-.2s0-.1 0 0zm-1.2 0 .3.1a.8.8 0 0 1 .1.2v.1a.8.8 0 0 0-.2-.2.6.6 0 0 0-.2-.2m-1.8.5.3.5v.6c-.1 0-.1 0 0 0l-.1-.6a1 1 0 0 0-.3-.5zm-6 .5v.4l-.1.1zm1-.6.2.4v.1h-.1v-.1l-.1-.3zm2.4 1.6v.1a1.1 1.1 0 0 1 0 .2.8.8 0 0 0 0-.2.6.6 0 0 0-.1 0zm.8-1.8v.2a.2.2 0 0 1 0 .2.1.1 0 0 0 0-.2c-.1-.1-.1-.1 0-.1zm-5.5.3a1 1 0 0 0 .2.7c.2.1.2.3.3.4v.4h-.1v-.4a.9.9 0 0 0-.2-.3 1 1 0 0 1-.2-.4 1.1 1.1 0 0 1-.1-.4zm2.2 1.5.2.7v.7c0 .3 0 .6.2.8l.6.7a2.9 2.9 0 0 1-.1-1l.3-1c.2 0 .2-.2.3-.3v-.4h.1v.4a1.5 1.5 0 0 1-.3.5 1.6 1.6 0 0 0-.3.9c0 .3 0 .6.2 1h-.1c-.4-.2-.6-.5-.8-.8a1.3 1.3 0 0 1-.2-.8v-.7a1.8 1.8 0 0 0-.2-.6c0-.1.1 0 .1 0zm-.9 1.4c0 .2 0 .5-.2.7a3.4 3.4 0 0 1-.4.6h.3a2.2 2.2 0 0 0 .7-.6l.3-.3c.1 0 0 0 0 0a3.6 3.6 0 0 1-.2.4 2.5 2.5 0 0 1-.3.2 24.5 24.5 0 0 1 0 .4v-.2a1.5 1.5 0 0 0-.1-.1 2.2 2.2 0 0 1-.4.2l-.4.2v-.1l.4-.7zm-1 0v.1h-.1c-.1 0 0 0 0 0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "M363 113.7c.2.3.2.6.2 1a1.9 1.9 0 0 1-.4.8 1.9 1.9 0 0 0-.5.6 2.6 2.6 0 0 0-.2.6l.2-.3.5-.3a4.6 4.6 0 0 0 1.1-.9h.1c.1 0 0 0 0 0a4 4 0 0 1-1.2 1 1 1 0 0 0-.4.3 2.3 2.3 0 0 0-.4.5c0-.4 0-.7.2-1l.5-.6.4-.8c0-.3 0-.6-.2-.9zm2.3 3.5.1.4.1.1c.2.3.3.5.3.8l-.1 1h-.1a1.8 1.8 0 0 0-.4-1 3.4 3.4 0 0 0-.8-.6v-.1c.4.2.7.4.9.7l.3.6a3.4 3.4 0 0 0 0-.6 1.3 1.3 0 0 0-.1-.7l-.1-.2c-.2-.2-.3-.3-.2-.4zm1 0 .1.2c0 .1 0 0 0 0h-.1l-.2-.2zm1 .3-.2.7-.2.7.2-.7zm.7 4a.3.3 0 0 1 0-.2zm-.7-1.2v.3l-.2.4v-.4l.1-.4h.1zm-1 0h.1v.1zm-1.1-.6a7.3 7.3 0 0 1-.1.2v.2h-.1a5 5 0 0 1 0-.2 5 5 0 0 1 0-.2h.1c.1 0 0 0 0 0zm-1.7 1.8a.7.7 0 0 0-.1.2 1.3 1.3 0 0 0 0 .2s-.1.1-.2 0v-.2a.8.8 0 0 1 .2-.3zm-4.8 4.6a.7.7 0 0 1 0 .2 1.1 1.1 0 0 1-.2.1c-.1 0-.1 0 0 0a.8.8 0 0 0 .1-.3zm.8-.4a.3.3 0 0 1-.1.2.6.6 0 0 1-.2 0 .4.4 0 0 0 .1-.1.3.3 0 0 0 0-.1zm1-.6a.5.5 0 0 1 0 .1.5.5 0 0 1-.2.1.4.4 0 0 0 0-.2zm1.5-3.8-.1.4a1.4 1.4 0 0 0 0 .4h-.1a1.4 1.4 0 0 1 0-.4v-.5h.1zm1-10.3a.9.9 0 0 1-.1.3 1.4 1.4 0 0 1-.2.3h-.1l.2-.3a.8.8 0 0 0 0-.3l.1-.1zm-1-1a1.9 1.9 0 0 1 .1 1 1.8 1.8 0 0 0 0-.5 1.5 1.5 0 0 0-.2-.4c0-.1 0 0 0 0zm-1.4 1.7a1.5 1.5 0 0 1-.4-.4.7.7 0 0 1-.1-.4l.2.4zm1.5 2.6v.2h-.1v-.2zm-2-2 .6 1 .1.8c.2 0 .3-.1.4-.3v-.9a1.9 1.9 0 0 0 .3-.6 3.5 3.5 0 0 0 .1-.5h.1l.4.8.3.9h-.1a2.9 2.9 0 0 0-.3-.9 3.9 3.9 0 0 0-.3-.6 2.9 2.9 0 0 1 0 .4 2 2 0 0 1-.3.5l-.1 1-.4.3v.4h-.1c0-.4 0-.8-.2-1.2a2 2 0 0 0-.5-1zm1.2 5v.3l-.1.4h-.1v-.8h.1c.1 0 .1 0 0 0zm-2.2.9v.3l-.1-.3c0-.1.1 0 .1 0m1.9-2.5a2.3 2.3 0 0 1-.2.6l-.3.5a1.1 1.1 0 0 0-.3.6 1.8 1.8 0 0 0 0 .7c0 .1 0 0 0 0a1.9 1.9 0 0 1-.1-.7c0-.2.1-.5.3-.7a2.1 2.1 0 0 0 .3-.5 2.1 2.1 0 0 0 .2-.6c.1 0 0 0 0 0zm-.5-.8v.6a2.2 2.2 0 0 1-.5.6 1.8 1.8 0 0 0-.4.5l-.2.5h-.1l.2-.6.5-.5a2 2 0 0 0 .3-.5 1 1 0 0 0 .1-.6zm-2.4 1.2c0 .4 0 .7-.2 1-.1.3-.3.6-.6.8h-.1v-.1c.3-.2.5-.5.6-.8.2-.2.2-.6.2-1zm-3 1.7v.2l.1.1v.1h-.1l-.1-.2v-.2s-.1 0 0 0zm-1.3 0a2.7 2.7 0 0 0 0 .7l.4.6.1.5v.4l.4-.5a1.4 1.4 0 0 0 .2-.6 1.6 1.6 0 0 1 0 .6l-.5.6h-.1a3.3 3.3 0 0 0 0-.5 1.8 1.8 0 0 0-.2-.4 2 2 0 0 1-.3-.7 2.7 2.7 0 0 1-.1-.7zm.2 4.2a2.6 2.6 0 0 1 .1-.8h.1a2.5 2.5 0 0 0-.1.8zm-.2 1.1v-.4s0-.1.1 0v.4zm-.8 2 .2-.3.2-.3h.1a4 4 0 0 1-.2.4l-.2.2c-.1 0-.1 0 0 0zm-1.1-6.6v.2h-.1v-.2zm-2 4.5a2.9 2.9 0 0 0 0-.1v-.2h.1v.3zm5-8-.3 1c0 .3.1.6.3.7.3.2.4.4.5.7v-.4c.1-.1.1-.3 0-.4h.1a2.7 2.7 0 0 1 0 1h-.1a6 6 0 0 1 0-.2l-.5-.6c-.3-.2-.4-.4-.4-.8l.2-1zm-.4-1.3a2.5 2.5 0 0 1 0 .8 4 4 0 0 1-.3.7 2.4 2.4 0 0 0-.2 1c0 .4.1.7.3 1v.1a2.5 2.5 0 0 1-.2-2.1 3.8 3.8 0 0 0 .2-.7c0-.3.1-.5 0-.8zc.1 0 0 0 0 0m-2.3 3.3a.8.8 0 0 0 0 .4l.1.5c0 .1 0 0 0 0a1.5 1.5 0 0 1-.3-.5.9.9 0 0 1 .1-.5zm-1-.4v.3a.9.9 0 0 1 0 .3.4.4 0 0 0-.1.3l.1.2v.1a.8.8 0 0 1-.2-.3.5.5 0 0 1 0-.4.8.8 0 0 0 .1-.2zm5.8-8.6a2.3 2.3 0 0 0 .3 1.5 2.6 2.6 0 0 1-.4-.7 2.3 2.3 0 0 1 0-.8zm-.7.7a4 4 0 0 1 .5 1.7h-.1a3.8 3.8 0 0 0-.5-1.6v-.1zm-3.6.1c-.4.5-.5 1-.6 1.3l.2.9.2.8a2.6 2.6 0 0 1-.2.8c-.1 0 0 0 0 0v-.8a2.3 2.3 0 0 0 0-.8 1.7 1.7 0 0 1-.3-1c0-.3.2-.7.6-1.2.1 0 0 0 0 0zm3.3-1.4v.5l-.4.4a.8.8 0 0 0-.3.4v.7c0 .1 0 0 0 0a1.9 1.9 0 0 1 0-.7 1 1 0 0 1 .3-.5 1 1 0 0 0 .3-.4.6.6 0 0 0 0-.4zm-3.5.3v.7c0 .2-.2.4-.4.6a1.2 1.2 0 0 0-.4.6 2.9 2.9 0 0 0-.1.7h-.1a3 3 0 0 1 .1-.8c0-.2.2-.4.4-.6l.4-.6a1 1 0 0 0 0-.6zm2 .1a.8.8 0 0 0 0 .2.5.5 0 0 0 .1.3.6.6 0 0 1-.2-.2.8.8 0 0 1 0-.3zm0-.5a.8.8 0 0 0-.5.4l-.2.7.2.5v.7a2.4 2.4 0 0 0 0-.7l-.3-.4a2 2 0 0 0-.5 1.2c0 .5.1 1 .5 1.5h-.1a2.7 2.7 0 0 1-.5-1.5c0-.5.2-.9.6-1.3 0-.3 0-.6.2-.8a1 1 0 0 1 .5-.4zm-.7-.8c0 .3 0 .6-.2.7a.8.8 0 0 0-.2.3 1.6 1.6 0 0 0-.1.4h-.1a1.7 1.7 0 0 1 0-.4 1 1 0 0 1 .3-.4c.2-.1.2-.4.2-.6a2.7 2.7 0 0 0 0-.1zm5.7 6 .1.5v.4a1.4 1.4 0 0 0 0-.4 1.9 1.9 0 0 0-.2-.4zm0 2v.6l-.2.6-.3.6.2-.6a2.1 2.1 0 0 0 .2-.6 1.6 1.6 0 0 0 0-.7h.1zm-1.2-1.8a2.5 2.5 0 0 1 .7 2.5h-.1a2.4 2.4 0 0 0-.6-2.4zc0-.1 0 0 0 0m0 2a5.3 5.3 0 0 1-1 1.4 2.5 2.5 0 0 0-.5 1 1.4 1.4 0 0 0-.1-.6 1.9 1.9 0 0 0-.2-.4 1.4 1.4 0 0 1-.3-.9l.3-.8.3-.6a2.4 2.4 0 0 0 0-.6h.1c.1 0 0 0 0 0a2.6 2.6 0 0 1-.3 1.3 1 1 0 0 0-.3.7c0 .3 0 .6.2.8a2 2 0 0 1 .3.8 2.6 2.6 0 0 1 .5-.8 5 5 0 0 0 .5-.6l.3-.7zm-3.2-1a2.8 2.8 0 0 0 .4 1.4v.1h-.1a2.3 2.3 0 0 1-.3-.7 3 3 0 0 1 0-.7zm-1.7 1v.3h-.1zm.6-1.6-.1.5a1.4 1.4 0 0 1-.3.5c-.1 0 0 0 0 0l.2-.5a1.4 1.4 0 0 0 0-.5zm-1.6 3.1a3.3 3.3 0 0 1-.3-1.7c0-.5.3-.8.6-1l.4-.7c.1-.2.2-.5.1-1s.1 0 .1 0v1l-.6.7a1.9 1.9 0 0 0-.5 1c0 .5 0 1 .3 1.7zm-1-1.1a.7.7 0 0 0 0 .3l.1.4a1 1 0 0 1-.2-.4.8.8 0 0 1 0-.4zm4.6-3.2c.1.2.3.5.3.8 0 .3 0 .6-.2.9h-.1c-.1 0 0 0 0 0l.2-.9a1.5 1.5 0 0 0-.3-.8zm1.4-1.1a2.4 2.4 0 0 1 0 1.7 1.8 1.8 0 0 0-.2-.8 1.5 1.5 0 0 0-.5-.5c0-.1 0-.1.1 0a1.6 1.6 0 0 1 .6 1v-.6a2.3 2.3 0 0 0-.1-.8zm.8-1.2.4.8v1a2 2 0 0 0 0 .5 1 1 0 0 0 .2.4 1 1 0 0 1-.2-.4 2.3 2.3 0 0 1 0-.5 3.5 3.5 0 0 0-.1-1 1.5 1.5 0 0 0-.4-.7c0-.1 0 0 .1 0zm-2.2-.2a1 1 0 0 0-.3.5v.7a2 2 0 0 1 0-.7c0-.2 0-.4.2-.5.1 0 .1 0 0 0zm-4.4 3a2 2 0 0 1-.3 1 2.5 2.5 0 0 1-.8.7c-.1 0 0 0 0 0l.7-.7c.2-.3.3-.6.3-1zm0-1.6v.5a2.2 2.2 0 0 1-.3.5l.1-.5v-.5zm2.9-.2v1h-.1zm.7-1.3c-.2.3-.3.5-.3.8l.2.7.3 1.2c0 .4-.2.7-.4 1.1l.3-1.1a1.9 1.9 0 0 0-.3-1.2l-.2-.7c0-.3 0-.6.3-.8.1 0 0 0 0 0zm-4.6-8.1a2 2 0 0 1 1-.5c.4 0 .8 0 1.2.3h.8-.8c-.4.5-.8.7-1.1.7a1 1 0 0 1-.9-.2c0-.1 0-.1 0 0a1 1 0 0 0 .9 0c.2 0 .6-.1 1-.5a1.9 1.9 0 0 0-1-.1 2 2 0 0 0-1 .4c-.1 0 0 0 0-.1z"
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "M351.6 101a.3.3 0 0 1 .3.3.3.3 0 0 1-.3.2.3.3 0 0 1-.2-.2.3.3 0 0 1 .2-.3m1.8 1.6a2.2 2.2 0 0 0 .8-.7c.1 0 0 0 0 .1a2.3 2.3 0 0 1-.2.3l-.5.4c-.1-.1 0-.1 0-.1zm3.7-1.6a.5.5 0 0 1 .3 0 .8.8 0 0 1 .3.2.7.7 0 0 0-.3 0 .5.5 0 0 0-.2 0l-.1-.1zm-2 .1a.8.8 0 0 1 .3-.4l.7-.1v.1a1 1 0 0 0-.7 0 .7.7 0 0 0-.3.5c-.1 0-.1 0 0 0zm.2.4a.4.4 0 0 1 0-.3.6.6 0 0 1 .3-.1h.1a.5.5 0 0 0-.3.2.3.3 0 0 0 0 .2zm-3.6 1.1-.1.3a.8.8 0 0 0 0 .3l-.1.1a1 1 0 0 1 0-.4c0-.1 0-.2.2-.3m1 .5v.2zm-.6-1.1a1 1 0 0 0 .3 0h.3a1.4 1.4 0 0 1-.3.1 1 1 0 0 1-.3 0s-.1 0 0-.1m.6-2a.3.3 0 0 0-.2.1.4.4 0 0 0-.1.2h-.1a.5.5 0 0 1 .2-.3.4.4 0 0 1 .2 0m-1 .2a.8.8 0 0 0-.2 0 .3.3 0 0 0 0 .2h-.1c-.1 0 0 0 0 0a.4.4 0 0 1 0-.2.9.9 0 0 1 .3-.1zm-.7 0a.8.8 0 0 0-.1.1.7.7 0 0 0-.1.2h-.1a.7.7 0 0 1 .1-.2.9.9 0 0 1 .2-.2zm-.8.7a1.7 1.7 0 0 0-.4.4v-.1a2 2 0 0 1 .4-.4zm0 .9-.2.2c-.1 0-.1 0 0 0v-.2zc.1 0 .1 0 0 0m-.7.2v.3l-.1.1c-.1 0 0 0 0 0v-.4zm1 1.4v.6h-.1v-.6zm-.6-.4v.3h-.1v-.3zm-.6-4.5a.7.7 0 0 1 .5.4v.1h-.1a.7.7 0 0 0-.2-.3.7.7 0 0 0-.2-.1zm5.2 6.7a1.6 1.6 0 0 1 0 1.4h-.1a1.6 1.6 0 0 0 0-1.3v-.1zm-1.7 2c0-.3.2-.5.3-.7l.4-.6c.2-.2.3-.4.3-.7a1.8 1.8 0 0 0 0-.7h.1a2 2 0 0 1-.3 1.5 6.3 6.3 0 0 0-.4.5zm-2.2-.6a.7.7 0 0 1 .2-.3.9.9 0 0 1 .3-.1.8.8 0 0 0-.2.2.6.6 0 0 0-.2.2zm-.4-.2.3-.3.3-.2v.1a1 1 0 0 0-.3.2 2 2 0 0 0-.2.3c-.1 0-.1 0 0 0zm2.3-2.2h.2a.8.8 0 0 0 .3 0v.1a.8.8 0 0 1-.6 0c0-.1 0-.1 0 0zm-1.2-.1c.1 0 .1 0 0 0m24.2 7a1.1 1.1 0 0 1 .2.3h-.1a.8.8 0 0 0 0-.1.8.8 0 0 0-.2-.2c0-.1 0 0 0 0zm-26.8 12.5.3.3a1 1 0 0 0 .5 0v.1a1 1 0 0 1-.5 0 1.7 1.7 0 0 1-.4-.3c0-.1 0-.1 0 0z"
    }),
    /* @__PURE__ */ jsxs109("g", {
      fill: "red",
      children: [
        /* @__PURE__ */ jsx116("path", {
          d: "M368.9 99.6a8.2 8.2 0 0 0 1.7 0c-.6.3-1.2.6-2 .7a.8.8 0 0 0 .3-.4.4.4 0 0 0 0-.3m-1.4-.1h1.2v.4s0 .2-.2.3c0 0-.1 0 0 .1a5.6 5.6 0 0 1-1.3 0 1 1 0 0 0 .3-.5.6.6 0 0 0 0-.4zm-10.5-3c.7-.2 1.3-.2 2-.2a1 1 0 0 1 .5.4c.1.2.2.5.1.8l.1.1h.1l-.1-1a1 1 0 0 0-.3-.2h.2a5 5 0 0 1 2.1.6c.2.2.3.3.2.5l-.3.5v.2h.2l.3-.7a.7.7 0 0 0 0-.3l1.7.8a.5.5 0 0 1 0 .5 1 1 0 0 1-.5.3v.1l.1.1c.3 0 .5-.2.6-.4a.6.6 0 0 0 0-.4l1.2.6v.3c0 .2-.1.3-.3.4 0 0-.1 0 0 .1 0 .1 0 0 0 0 .3 0 .5-.2.6-.4a.5.5 0 0 0 0-.3l.4.1a8.1 8.1 0 0 0 1.3.4.5.5 0 0 1 .1.4.7.7 0 0 1-.2.3v.2c-1.4-.1-2.7-.9-4.1-1.4l-.5-.2-1.6-.6-.1-.1a8.5 8.5 0 0 0-1.5-.4 6.1 6.1 0 0 0-1.6 0h-.1l-.1-.8a1.3 1.3 0 0 0-.5-.4z"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "M354.6 97a8.7 8.7 0 0 1 2-.5c.4.1.6.3.7.5v.6a4.2 4.2 0 0 0-1.7.2 1.2 1.2 0 0 0-.7-.6 1.2 1.2 0 0 0-.3-.1zm7.4 3.9a9.4 9.4 0 0 0-.5-.4 7 7 0 0 0-3-.8c.3-.4.4-.8.3-1.1a1.7 1.7 0 0 0-.7-.8h1a8 8 0 0 1 2 .6c0 .3.1.6 0 .8 0 .3-.2.5-.5.7 0 0-.1 0 0 .1 0 .1 0 .1 0 0 .4-.1.6-.4.7-.7v-.8l1 .6 1 .8c0 .4 0 .6-.3.8h-.9v.2z"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "m364 102.4-1.8-1.4c.4 0 .7 0 1-.2.1-.1.3-.4.3-.8l1.1 1 .6.5v.4a.5.5 0 0 1 0 .2.6.6 0 0 1-.4.2h-.7z"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "M366.2 103.8a11.8 11.8 0 0 1-2-1.3h.7a.8.8 0 0 0 .4-.2l.1-.4a1 1 0 0 0 0-.2 10.5 10.5 0 0 0 2.1 1.4c0 .3 0 .4-.3.5a3 3 0 0 1-1 .1z"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "M368.4 104.7a11.9 11.9 0 0 1-2-.8c.4 0 .7 0 1-.2.2 0 .3-.2.3-.5a10.8 10.8 0 0 0 1.3.6v.4l-.5.4s-.1 0 0 0z"
        }),
        /* @__PURE__ */ jsx116("path", {
          d: "M373.2 104.2s.4-.1.2 0c-1.4 1-3.1 1-4.8.5.3-.1.5-.2.6-.4a.6.6 0 0 0 0-.5l1.7.4a.4.4 0 0 1-.1.3l-.5.3s-.1 0 0 .1c0 .1 0 0 0 0 .3 0 .5-.2.6-.3a.6.6 0 0 0 .2-.4 9 9 0 0 0 2 0zm-9.7 24-.2.4-1.2.3c0 .3 0 .4.3.4l.7-.3c.1 0 0 .5-.5.8v.1c.4.6 1.4.4 1.9.3a3 3 0 0 0 1.3-1l-.3-.6c-.4.1-.6 0-.5-.2a3.9 3.9 0 0 0-1.5-.2m-15.1-4.8c-.3.3-.7.5-1 .6-.2 0-.6.1-.6.3 0 .1.2.3.4.2.4-.5.7-.2.2.2v.3c.5.4 1.6.5 2.2.2.3-.2.6-.5.2-.9a1.7 1.7 0 0 1 0-.2h-.6l-.4-.3zm10 3.5h-.1c-.2.2.3.2.6.3.2.1.2.3.2.5-.3.7-1.9.5-2.4.2-.2-.1-.2-.3-.2-.5h.3c.2 0 .4 0 .6-.2v-.2h-.2a1.3 1.3 0 0 1-.4.2 2.6 2.6 0 0 1-.5 0l-.2-.2h.2l.7-.2.1-.1c.5 0 1 0 1.3.2m-7.2-.4-.2.3a2.7 2.7 0 0 1-.9.6c-.2.1 0 .2.2.4.2.1.5-.2.6-.4.2-.3.3-.2.2 0l-.2.7.7.3c.4 0 1-.4 1.2-.6.3-.2.2-.5.1-.8a2 2 0 0 1-.5 0 3.4 3.4 0 0 1-.5-.3zm2.8-26.4h.3l.6.1a4.5 4.5 0 0 1 1.7-.3 5.7 5.7 0 0 1 1.7-.2v-.2c.3-.3.4-.6.3-.9-.1-.2-.4-.5-.8-.7h-1.3a4 4 0 0 0-.8.1l.6.4.4 1c-.2.1-.2 0-.2 0 0-.4-.2-.6-.3-.9l-.8-.4a9 9 0 0 0-1.3.2c-.3 0-.5.2-.7.3l.8.1c.3.1.5.4.6.8-.1.1-.1 0-.1 0a1 1 0 0 0-.5-.6c-.4-.2-1.3 0-1.7.2a4.2 4.2 0 0 0-.6.6zm-2.3-.4.7-.6.7-.4a2 2 0 0 1 1-.5l1.3-.2a1 1 0 0 0-.5-.5l-.8-.1-1.5.8h.5l.1.2h-.4a1.4 1.4 0 0 0-.4 0h-.1l-1.3 1c.3.1.6.2.7.4"
        })
      ]
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#0093dd",
      d: "m409 156.5 20.8-47-15.3-24.7-27.3 10-12.7 49.8a219.4 219.4 0 0 1 34.5 11.9"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "M382.6 113a251.7 251.7 0 0 1 39.6 13.7l-8 18.2a232 232 0 0 0-36.5-12.7z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "red",
      d: "m415.4 142 5.4-12.2a248.6 248.6 0 0 0-39-13.5l-3.2 12.4a235.9 235.9 0 0 1 37 12.8z"
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "M385.6 125.8c.3-.3.7-.2 1.1-.1.3-.2.7-.2 1-.2l.6-.2c.2 0 .2-.2 0-.3a.6.6 0 0 1 0-.3c-.7-.4-1-1-1.2-1.5-.3 0-.5-.2-.5-.3h-.5c-.8 0-1-.3-1.3-.5a1 1 0 0 1-.6-.4l-.3-.3c-.2-.3-.1-.7.2-.7h.7a2 2 0 0 1 .9-.1c.3 0 .5-.3.9-.6v-.4s0-.2.2-.1a1 1 0 0 1 .8.5c.5 0 1 .3 1.2.7.7 0 1.1.3 1.2.5 0 .2-.2.4-.5.6v.2l.4.4 1 .7c1-.1 2.6.6 4.8 2a18.6 18.6 0 0 1 4.1 1.2h.9c2.4-.4 4.7 0 6.8 1.5.8.1 1.5.4 2.2.7.5.2 1 .3 1.6.3a8 8 0 0 1 2.6.7c1 .2 1.9.6 2.4 1.2.4.5.3 1-.2 1.2-.3.6-.9.6-1.8.3-.6.1-1.3-.4-2-.9-.8-.2-1.6-.8-2.4-1.3l-1.3-.6h-.8v.2c.2.2.4.4.4.8v1c0 .4.3.6.7.9l1 .4c.2 0 .3.1.3.3l.4 1.7.4.3c.6.5.2 1-.3 1a3.1 3.1 0 0 1-1.3.8c-.4.2-.6 0-.7-.2a.5.5 0 0 1-.4-.2c-.5-.4-.1-1 1-.7l.2-.2a1.5 1.5 0 0 1 0-.9l-.3-.2a2.8 2.8 0 0 1-1-.6c-.6-.5-1.5-1-2.4-1.4-.7 0-1.2-.4-1.8-.7h-.8c-.2 0-.4 0-.5.2-.2.3-.5.2-.8.2h-1.6c-.4 0-.7 0-1 .3-.2.2-.4.2-.7 0a1 1 0 0 1-.3-.2c-.3 0-.5 0-.5-.2-.5-.1-.6-.2-.6-.4-.6-.1-.3-.6 0-.6l1.4.1c.4.1 1 0 1.2-.2l.5-.5a4 4 0 0 1-1.8-.5c-1.1-.7-2-.9-2.8-.3-.2.2-.3.2-.6.1a1 1 0 0 0-.5 0c-.5.1-.9 0-1.3-.1a4 4 0 0 1-1.8 0c-.6.3-1 .4-1.2.2a8.6 8.6 0 0 1-.6-.4c-.4-.1-.5-.2-.5-.3-.4 0-.5-.2-.5-.4-.2-.2 0-.3 0-.4.4-.2.7-.2 1 0 .3 0 .5.2.6.3h.6c.1-.2.5-.2 1-.2l.7-.2v-.2c-.4 0-.6-.4-.9-.7a3 3 0 0 1-1.5-.5c-.4 0-.7-.1-1-.3h-.7a2.5 2.5 0 0 1-1.4 0h-.8a1 1 0 0 1-1 .2 1.5 1.5 0 0 0-.8-.5c-.3-.1-.4-.2-.4-.4-.4-.2-.3-.4 0-.5.3-.1.5-.2 1 0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "M401.2 130.5s0-.2-.3 0c-.8 0-1.6 0-2.2-.4-.7-.4-1.3-.8-2-.8l.7-.4h1.5c.7 0 1.4.2 2 .4.4.2.8.5 1 .8a3.4 3.4 0 0 1 .8.7 2.5 2.5 0 0 1-.7 0 2.9 2.9 0 0 1-.8-.3"
    }),
    /* @__PURE__ */ jsx116("path", {
      d: "M403 94.7v.2l.9 4.9-3.7 3.2-.2.1.2.1 4.7 1.6 1 4.9v.2l.2-.1 3.7-3.3 4.6 1.6h.3v-.1l-1-4.9 3.7-3.2.2-.2h-.3l-4.6-1.6-1-4.9V93l-.2.1-3.7 3.3z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#f7db17",
      d: "m400.6 103 3.5-3 4.4 1.4zm8.5-1.7 3.4-3 4.4 1.5zm7.8-1.3-3.4 3-4.4-1.5zm-8.4 1.6-3.5 3-4.3-1.5zm-5-6.4 4.3 1.4.8 4.6zm5.5 6.4 4.4 1.5.9 4.5zm5.1 6.1-4.3-1.5-.9-4.5zm-5.6-6.4-4.3-1.5-.9-4.5zm3-7.7 1 4.6-3.5 3zm-2.7 8.1.8 4.6-3.4 3zm-2.8 7.5-.9-4.5 3.5-3zm2.8-8-.9-4.6 3.5-3z"
    })
  ]
});
var Hr_default = SvgHr;

// src/country-flag-icons/generated/Ht.tsx
import { jsx as jsx117, jsxs as jsxs110 } from "react/jsx-runtime";
var SvgHt = (props) => /* @__PURE__ */ jsxs110("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx117("path", {
      fill: "#d21034",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx117("path", {
      fill: "#00209f",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsxs110("g", {
      fill: "#f1b517",
      stroke: "#000",
      strokeWidth: 0.2,
      children: [
        /* @__PURE__ */ jsx117("path", {
          fill: "#fff",
          stroke: "none",
          d: "M244.3 179.7h151.4v120.5H244.3z"
        }),
        /* @__PURE__ */ jsx117("path", {
          fill: "#016a16",
          stroke: "#016a16",
          strokeWidth: 0.3,
          d: "m350.5 266.8-31 1-30.7.3s-15.8 5.8-22.3 7.1c-6.4 1.3-5.6 3.4-10.5 4.6-4 .9-4.5 1.1-6.8 1.3-1.5 0-3.2 1.2-5 2.4v16.7h151.5v-15.9c-1.6-.9-3.2-1.5-4.8-2-2.2-.8-3.7-1.6-7.7-2.5-5-1.1-4.2-3.3-10.6-4.6-6.5-1.3-22.1-8.4-22.1-8.4z"
        }),
        /* @__PURE__ */ jsxs110("g", {
          transform: "translate(-80) scale(1.6)",
          children: [
            /* @__PURE__ */ jsxs110("g", {
              id: "ht_svg__a",
              children: [
                /* @__PURE__ */ jsx117("path", {
                  d: "M244.5 143.5h1.4l2.6 10.7-.6 3.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "m243 136.3 1 8.3h1l-2-8.2z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m245.7 154.6-4.3-11.5 1.6-.1 5 14z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "m239.4 136.5 1.8 8h1.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m241.9 150.6-2.5-5.5 1-.2 4.7 9z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "m236 138.8 2.9 7.6h1.4l-4.2-7.6z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#0a328c",
                  d: "m242.3 151.4-11.5-12.5c-3.6 2.8-2.9 8-2.9 8l13 10.2z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  d: "m248.9 158.2-8.5-8.6c-3.6.2-.8 5.5-.6 6.2l9 7.7z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M248.1 156.8 230.6 138l-.7.5 18.6 20.6zm-18.5-20-.4-.5v-.9l-3.6-2.3 1.6 3.7 1.3.2.3.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M227.7 138.1a8.4 8.4 0 0 1 2.7-2.2l1 1.5-2.2 1.8-1.5-1z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#0a328c",
                  stroke: "#0a328c",
                  d: "m225.8 141.3.6 1c.4-.1 4-3.5 4-3.5h2.7l.7-.9c-2-2-3.7.3-3.7.3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "M228 143c0-1 1.8-3.2 2-3.3 1.3.4 2.5 1.2 3.9-1.8-1.2 1.4-3.5 0-3.5 0l-1 .8v.4l-3 2.8z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#0a328c",
                  d: "m237.3 154.7-14.4-11.4c-2.5 2.5-.4 10.2-.4 10.2l14 7.6.7-6.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  d: "m249.2 164-11.9-9.6c-4 .6-.8 6.5-.6 7.2l12.5 6.8z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m248.7 162-25.6-19.2-.5.6 26.8 21zm-26.8-20.2-.4-.4-.2-.8-4-1.7 2.3 3.3h1.3l.4.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M220.3 143.4a8.2 8.2 0 0 1 2.3-2.6l1.2 1.3-1.8 2.1z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#0a328c",
                  stroke: "#0a328c",
                  d: "M219 146.6v1.1c.4-.2 3.7-3.7 3.7-3.7l2.5-.5.6-.8c-1.8-2.1-3.7.7-3.7.7z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "M221 148.5c-.2-1 1.2-3.8 1.4-4 1.6.5 3 1.2 3.5-2-1 1.6-3.5.4-3.5.4l-.8 1v.5l-2.5 3.3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#0a328c",
                  d: "M236.2 161.7a2783.3 2783.3 0 0 1-18.5-10.5c-1.3 2.3-.1 5.5.5 6 0 1.5-.6 2.3.7 5.5.4 2 1.3 3.9 2.7 5 1.6 6.4 8.2 6.9 10.7 1.6z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  d: "m248.3 168.5-12.5-7.3c-4 .5 0 8 .3 8.7l12.2 4.3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m246.2 165.8-28.3-15-.5.6 30 16.7zM216.5 150l-.5-.3-.3-.8-4.1-1 2.7 2.9 1.2-.2.6.3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M215.2 151.8c.4-1 .8-1.9 1.8-3l1.4 1.1-1.4 2.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#0a328c",
                  stroke: "#0a328c",
                  d: "m214.1 155.2.6 1.2 3-4.6 2.5-.9.5-1c-2-1.8-3.5 1.4-3.5 1.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "M216.8 156.8c-.2-1 .5-4.2.7-4.3 1.5.5 2.8.6 3.2-2.6-1 1.5-3.3 1-3.3 1l-.7 1 .1.4-2 4z"
                })
              ]
            }),
            /* @__PURE__ */ jsx117("use", {
              xlinkHref: "#ht_svg__a",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 499.9 0)"
            })
          ]
        }),
        /* @__PURE__ */ jsxs110("g", {
          transform: "translate(-80) scale(1.6)",
          children: [
            /* @__PURE__ */ jsx117("path", {
              fill: "#016a16",
              stroke: "#016a16",
              d: "m248.8 125.6-.5 9h2.9l-.4-9 3-.3-.3-3.6-7.5.3v3.2z"
            }),
            /* @__PURE__ */ jsxs110("g", {
              id: "ht_svg__b",
              fill: "#016a16",
              children: [
                /* @__PURE__ */ jsx117("path", {
                  d: "M249.8 121.9c-7.8-7.8-13.9-4-15.3-2.9 1 .2 1.8-.4 2.3-.5l-1 1.2s2.5-1 2.8-1c-.4.3-.8 1-.8 1 .2 0 1.6-1.1 1.8-1.1-.4.4-.5 1.5-.5 1.5l1.2-.5c.3.2-.1.6.1.6 2-.2 4.7 1.7 5 2.3"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M247.9 123.3c-.8-1.8-15.6-5-18.6.3 1.2.3 2.3-1 2.3-1v1.2l1.9-1.6-.7 1.6 1.5-1.3v1.3l2-2-.3 1.1 1.7-.7-.2 1"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M247.2 123.6c-3.8-2.5-9.6-.8-9.6-.8-3.8 2-5.8 1.7-6.2 5.6.3-.1 1.3-1.4 1.3-1.4l.8 1.5.2-2.1.6 1.7 1-2.8.2 1.9 1.4-1.9.6.6.6-1.5.6 1s1-.6 1.5-.3l1-1.2.3.9 1-1 .3.7.9-.8v.6h3"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M246.4 124c-2.7 0-10.3 2.9-12.2 5.8a13.3 13.3 0 0 1 1.3-.6l.3 1.2.5-1.2.1 1c.3-.8.6-.8 1.2-.1l.2-1.1.3 1 .5-1.1s.3 1.2.5 1.2c0 0 .8-2.2 1.2-2.3l.1 1.4.5-1.4.5 1v-1.4l.6 1s.2-1 .6-1.2l.8.7 3.4-2.5"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "M246.9 124.7c-3.5 1.3-6.7 6.2-6.4 8.2 1.5-2 1.2-1.7 1.9.6 0 0 .2-2 .5-2.2l.5 1.4.1-1.9h.5l-.1-1.1.7.5c-.2-.7-.3-.9.4-1.5 0 0-1 .1-.2-1.5l.7.6s-.2-.7 0-1l2.6-.8"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m247.2 125-1.3 2.6.7.2-1.6 1.1 1.3-.1s-2 .7-2.2 2.7l2-1s-1.7 1.8-2 2.9l1.3-1s-1.2 1.2-1 3l.9-1c-.2 2.3-.2 2.5.8 4.2 0 0-.2-2.6 0-3l2.3 2.4-1.2-3.3s1.4 2 2.2 1.9l-1.8-2.7 1.8 1.4-2-3 1.8.6s-1.3-1.7-1.2-2.8l1.3 1.4s-.5-1.5-.4-2l.7.1-1.3-1.4.9-.2-.1-1 .6-.1v-1.1m-1.1 0c-2.2 3-1.1 7.5-2.4 9.9"
                })
              ]
            }),
            /* @__PURE__ */ jsx117("use", {
              xlinkHref: "#ht_svg__b",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 499.9 0)"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M251 166.5s1.1-10 1.1-14.2c0-3.4-.8-10.8-.8-10.8H248s-.5 7.4-.4 10.8c0 4.2 1.1 14.2 1.1 14.2z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M247.7 142h4l-.5-2.7h-2.9z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M248 139.8h3.5l-.7-2.7h-2.2z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M248.2 137.7h3l-.6-2.7h-1.9z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M250.7 134.7h-2l-.3 1h2.5zm.4 29.7h-2.6m2.8-2h-3m3.4-2h-3.8m4-2.1h-4m4-2.2h-4.1m4.2-2h-4.4m4.4-1.7h-4.6m4.6-2.2h-4.6m4.5-2.1h-4.5m4.3-2.2h-4.1m3.9-2h-3.7"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#0a328c",
              stroke: "#0a328c",
              d: "M250 119c-.8-.3-2.3-1.3-1.9-1.9l.7-1.2c1-2.2 0-1.4 0-2-.2-.8 3.8-.2 3.8 1.3 0 .5-.3.2-.2 2.6l-.8 1.5a3.5 3.5 0 0 1-1.7-.2z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "m250.4 125-1-.9.3-7.1 1 .3-.3 7.6z"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#d20014",
              stroke: "#d20014",
              d: "M251.7 119.3c.6-.4 1-1.5.6-2.1-1-1.3-1.7-.8-3.4-1.4-.3.4-1 1-.9 1.6 2.3 1 1.4.2 2.2.3.4 0 .6.5 1.5 1.5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs110("g", {
          transform: "translate(-80) scale(1.6)",
          children: [
            /* @__PURE__ */ jsx117("use", {
              xlinkHref: "#ht_svg__c",
              width: "100%",
              height: "100%",
              transform: "matrix(1 0 0 -1 0 320.4)"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#016a16",
              stroke: "#fff",
              strokeLinecap: "round",
              d: "M238.4 161.8c0 1.2-.9 2.3-1.9 2.3s-1.8-1-1.8-2.4v-1.2h3.7z"
            }),
            /* @__PURE__ */ jsx117("ellipse", {
              cx: 236.5,
              cy: 160.1,
              fill: "#fff",
              stroke: "none",
              rx: 1.8,
              ry: 0.9
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#016a16",
              stroke: "#f1b517",
              d: "m236.1 161-.3-3.2h1.4l-.2 3.3h-.9z"
            }),
            /* @__PURE__ */ jsx117("path", {
              id: "ht_svg__c",
              fill: "#016a16",
              stroke: "#fff",
              strokeLinecap: "round",
              d: "M238.5 160.1c-.2.5-1 .9-2 .9s-1.7-.4-2-.9a.8.8 0 0 0 0 .4c0 .7.9 1.2 2 1.2 1.2 0 2.1-.5 2.1-1.2a.8.8 0 0 0 0-.4z"
            }),
            /* @__PURE__ */ jsxs110("g", {
              id: "ht_svg__d",
              children: [
                /* @__PURE__ */ jsx117("path", {
                  d: "m246 172.8-7-2.2-3.1-5.3-10.9-.5.4 4 9.3 1.7.8 1.6 10.7 3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#503200",
                  d: "m238.7 174.3-11.2-16.5-.5.5 11 16.4z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "m228.6 158.5-1.2-2c-.3-.4-.6-.5-1.1-.2-.5.2-.4.7-.2 1.1l1 1.9z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m240 164.1-22.5-2.3-.6 3.3 22.4 2.3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m217 161-.5 4.5h1l.6-4.1zm3.8.7-.2 4.1h.6l.5-3.5zm15.3 1.8-.6 3.8h1.1l.5-3.8zm3.3.1-.7 4.4 1.2.2.4-2.3c0 .5.5.8 1 .8.6 0 1-.5 1-1 0-.6-.4-1-1-1a1 1 0 0 0-1 .6l.3-1.6zm-8 .7-3.2 3.5.4.4 4-2.7zM224 173l3.1-3.5-.3-.4-4 2.7zm8.1-.9-3.7-2.9-.4.3 3 3.8zm-9.3-6.7 3.9 2.8.4-.3-3-3.8zm4.2-2.3.4 4.6h.5l1.2-4.5zm1.2 11-.3-4.5h-.6l-.7 4.6zm5.1-6-4.8.4v.5l4.8.6zm-11.4 1.5 4.7-.7v-.4l-4.8-.5v1.6z"
                }),
                /* @__PURE__ */ jsx117("ellipse", {
                  cx: 227.7,
                  cy: 168.6,
                  rx: 1.3,
                  ry: 1.2
                }),
                /* @__PURE__ */ jsx117("path", {
                  fillRule: "evenodd",
                  strokeLinecap: "round",
                  d: "M234.4 168.6c0 3.5-3 6.5-6.7 6.5a6.6 6.6 0 0 1-6.7-6.5c0-3.6 3-6.5 6.7-6.5a6.6 6.6 0 0 1 6.7 6.5zm-1.3 0a5.3 5.3 0 0 1-5.4 5.2 5.3 5.3 0 0 1-5.4-5.3 5.3 5.3 0 0 1 5.4-5.1 5.3 5.3 0 0 1 5.4 5.2z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m223.5 165.3-1-.8m8.5 0 1-1m1 9.2-1.1-.9m-8.4 1.9 1-1m21.7-10.6 1.1 6-.9.4-1-6.3z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "M245.6 161.4c-.5-.3-1.2.1-2.4-1.3-1.9 1.7 0 2 .2 3.7.5.2.9-1.4 2.3-1.5l2.3-.2-.5-.7z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "m246.4 162.5-.2-1.7c-.3-.7-1-.1-1 .2l.2 1.7z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fillRule: "evenodd",
                  d: "M240.8 167.4v1.6c-.6.2-.5.6-.5 1.2v4.7c-.1.4-.7.4-1 .6-.3.3-.2.8 1 1l1 .1c1.5-.3 1.8-.8 1-1-.3-.2-.9-.4-1-.6v-1.2h1c.2 0 .7-.6.7-1.1v-2.5c0-1.4-1-1.6-1.4-1.5v-1.3zm1.6 2.7c0-.4-.6-.8-.8-.8-.2 0-.7.5-.7.9v1c0 .4.3 1.6.9 1.7.2 0 .6-.4.6-.8z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#fff",
                  d: "M234.3 172.3c-.7-.2-.7 1.2-.7 1.2h1c.5.2.8.8.6 1.2-.3.2-2.2-.5-2.3 0 .3 1.9 2.9 2.6 3.8 1.8.9-.9 1.1-3-1.8-3.7zm.6.6-.3.6"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m215 173-1-4m2.1 3.8-1.5-3.1m4 2.3-3.3-1.8m4.8 1.4-6.2-2.7"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "m210.2 166-2.6.1c-.2.1.5.9.4 1.1-.6 1.1-4.4 1-4.7.8-.5-.5 3.5-.8 3.6-1 0-.4-.6-1.2-.5-1.7 0-.7 1.7-1 1.7-1z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  fill: "#503200",
                  d: "m213.2 168-5-4.2s-.3-.2-.5 0 0 .4 0 .4l5.4 4.4.1-.5z"
                }),
                /* @__PURE__ */ jsx117("path", {
                  d: "m218.2 172.2-4.2-3.6-.3-1-.8.6c-.3.2-.6.8-.6.8h1.1l3.6 3.4 1.1-.2z"
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 232.5,
                  cy: 177.1,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 230.6,
                  cy: 175.7,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 228.1,
                  cy: 176.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 224.2,
                  cy: 177.4,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 222.5,
                  cy: 177.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 220.8,
                  cy: 177.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 219.2,
                  cy: 177.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 220,
                  cy: 176.3,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 221.6,
                  cy: 176.4,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 223.1,
                  cy: 176.2,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 222.4,
                  cy: 175,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("circle", {
                  cx: 220.8,
                  cy: 174.9,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx117("path", {
                  fillRule: "evenodd",
                  d: "M236.5 178c0-.3-.8-.2-.8-.6 0-.4 1.2 0 1.3.3.7-.6 1-.2 1.4 0 .6-.8 1.3-.8 2-.2.4-.4 1.4-.3 1.7.2.7-.6 1.3-.5 1.7 0 .2-.3.5-.3.7 0 .3-.7 1.2-.5 1.6 0 .3-.4.7-.1 1.1.1.3-.2.8-.2.8 0 0 .4-.6.3-.6.6 0 .2.4 0 .4.4 0 .3-.6.4-.7 0-.3.4-1.1.2-1.2-.2a.8.8 0 0 1-1.2 0c-.3.2-.7.2-.8 0-.5.5-1.4.4-1.7-.2h-.3a1 1 0 0 1-1.5 0c-.9.6-1.4.4-1.9 0-.5.7-1.4.7-1.5 0-.4.3-1.2.4-1.2 0 0-.2.7-.1.7-.4zm1.6.1c0 .2-.2.3-.4.3s-.4-.1-.4-.3.1-.2.4-.2.4.1.4.2zm1.9-.2c0 .2-.3.3-.6.3s-.5-.1-.5-.3c0-.1.2-.3.5-.3s.5.2.5.3zm3.5.2c0 .2-.2.3-.5.3s-.4-.1-.4-.3c0-.1.2-.3.4-.3s.5.1.5.3zm-1.9 0c0 .2-.2.3-.5.3s-.4-.1-.4-.4c0-.2.2-.4.4-.4s.5.2.5.4zm4 0c0 .1-.1.3-.3.3-.3 0-.5-.2-.5-.4s.2-.3.5-.3c.2 0 .4.1.4.3zm-1.2 0c0 .2 0 .3-.2.3s-.3-.1-.3-.3.1-.2.3-.2zm2.4.1c0 .2 0 .4-.3.4-.1 0-.3-.2-.3-.4s.2-.3.3-.3c.2 0 .3.1.3.3z"
                })
              ]
            }),
            /* @__PURE__ */ jsx117("use", {
              xlinkHref: "#ht_svg__d",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 499.9 0)"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#0a328c",
              stroke: "#0a328c",
              d: "M249.8 165.7c-2.5 0-4.5 1-4.5 2.1 0 .2 0 .4.2.6.5.6 2.3 1 4.4 1 2 0 3.6-.3 4.2-.9.2-.2.3-.4.3-.7 0-1.1-2-2-4.6-2z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7c0 .8 2 1.5 4.5 1.5 2.6 0 4.6-.7 4.6-1.5z"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#d20014",
              stroke: "#d20014",
              d: "M245.3 168v1l2.2 7 1.8-5.4 2 5.5 1.3-5.2 1.8 3.5v-1.9l-1.6-3.4a8.3 8.3 0 0 1-.6.2l-1 3.8-1.5-3.6a14.5 14.5 0 0 1-.7 0l-1.5 3.6-1.6-4.4c-.4-.2-.6-.5-.6-.7z"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#0a328c",
              stroke: "#0a328c",
              d: "M254.4 173.7v1.3c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-1.3c0 .9 2 1.5 4.5 1.5 2.6 0 4.6-.6 4.6-1.5z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "m251.7 175-1.1.2v1.3l1.2-.1zm-4.8-.1v1.3l1.1.2v-1.3a8.9 8.9 0 0 1-1.1-.2zm-1.6-1.2v1.3c0 .3.2.5.5.7v-1.3c-.3-.2-.5-.4-.5-.7zm9.1.2c0 .2-.4.5-.8.7v1.3c.5-.2.8-.5.8-.9z"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "none",
              d: "M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#fff",
              stroke: "#fff",
              d: "M253.4 167.5c0 .5-1.6 1-3.5 1-2 0-3.6-.5-3.6-1s1.6-.9 3.5-.9c2 0 3.6.4 3.6 1z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "m248.7 168.2.2 1.2h1l.1-1.2zm4.1-.3-1 .2.1 1.2 1-.2zm-5.4-2-.7.3.1 1 .6-.2zm2.4-.3h-.3l.2 1.2h.6l.2-1.2a9.7 9.7 0 0 0-.7 0zm2.7.4-.1 1 .7.3v-1a5.3 5.3 0 0 0-.6-.3zm-6.5 2.8.2-1.3-1-.5v1.5zm8.4-.3v-1.3l-.8.3zm9.3-8.5c.8 0 2 1 2.1 2.5 0 1-1.7 1-1.7 1 0 .5-1 .9-1.8 1-.8 0 .2-1.5.2-1.5-.5-1.3.2-2.7.2-2.7z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M262.5 163h.8s0 .3.2.3.3-.4.3-.4h1.2"
            }),
            /* @__PURE__ */ jsx117("path", {
              fill: "#d20014",
              stroke: "#f1b517",
              d: "M264.1 160.9c.7-.5.1-1.5-.4-1.5h-1c-.6 0-1.4.6-1.3 1 0 .5.4.7.8.6.2 0 .6-.6.8-.6.3 0 1 .6 1.1.5z"
            }),
            /* @__PURE__ */ jsx117("path", {
              fillRule: "evenodd",
              d: "M214.2 174.8c-.6.1-.7.8-.5 1.5-2.6.7-5 1.7-7.4 2.4-.1-.5 1.2-1.8 1.2-1.8.3.1.6.9.6.9 0-1.6 1.6-2.6 1.6-2.6-1-.2-3.7 1-4 1.4 0 0 1-.2 1.2 0 0 0-2.2 2.3-2.3 3 .4.7 4 1.3 4 1.3 0 .2-1 1-1 1 1.5.2 3.7-.8 4.3-1.4 0 0-1.7-.2-3-1.3 0 0 .2.7 0 1 0 0-2-.6-2.3-1 0 0 5-1.2 7.4-2 .1.5.6 1.3 1.2 1.1.3-.1.2-.8 0-1.4a.8.8 0 0 0 .6.2c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7a.8.8 0 0 0-.7.5c-.1-.5-.4-1.4-.8-1.3zm2 1.6c0 .2-.2.3-.4.3a.3.3 0 0 1-.4-.3c0-.2.2-.4.4-.4s.3.2.3.4z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M293 177.9c.2-.4 0-2.2 0-2.2-.5 0-1 .7-1 .7.5-1.6-.8-4-.8-4 .9.1 3.9 3 4 3.6 0 0-1.3-.5-1.5-.4.3 1.5 1.3 2.2 1.7 3 0 0-1.7.3-1.6 1.8h-1.1c-.4-.5.1-1.3.1-1.3l-7.7-3.2c-.5-.2-1.6-.8-1.4-1.4.1-.5 2 .3 2.4.5z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "m285.6 176.5 1-1.6c.3-.5-.4-1-.9-.4l-1 1.5c-.4.9.5 1.1 1 .5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs110("g", {
          fill: "#fff",
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx117("path", {
              d: "m290.2 288.6-.1-3-3.5.3-.2 3.1z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "m264.4 292.7-4.7-2.7c19.4 1.8 23.4-5 28.1-5.3 3-.3 3.3 3.2-2.3 1.5l1.5 3.6s-13.8 7.8-27.4 4.6zm84.8-4.1.1-3 4.3.2.2 3.1z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "m375.9 292 4.5-2.5c-22.4.7-17.3-3.6-28.4-4.8-3-.4-5 3.4 2.2 1.5l-1.4 3.6h3.5c7.6 5 17.8 5.5 24.6 3.9z"
            }),
            /* @__PURE__ */ jsx117("path", {
              d: "M285.5 286.3v5s12.3 4.6 34.4 4.6c22.2 0 34.4-4.6 34.4-4.6v-5s-9.3 4.3-34.4 4.3c-25 0-34.4-4.3-34.4-4.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx117("path", {
          fill: "#000001",
          stroke: "none",
          d: "m287.3 291.3 1.1-3.7.5.2-1 3.2 2 .5-.2.5zm3.6-1.6v-.7l.2-.7.6.2-.2.6-.3.7zm5.3-.3.5.2-.4 2.1-.4 1a1.2 1.2 0 0 1-.5.4h-1a2 2 0 0 1-.9-.4 1 1 0 0 1-.4-.6l.1-1 .5-2.2.5.1-.5 2.2a2.1 2.1 0 0 0 0 .8.7.7 0 0 0 .2.4l.5.2h1l.4-1zm.6 4 .6-3.7h.6l1.5 3.4.5-3h.5l-.6 3.9-.5-.1-1.6-3.3-.5 3zm4 .7.6-3.8h.5l-.5 3.8h-.5zm1.6-1.7c0-.6.3-1.1.7-1.4a2 2 0 0 1 1.4-.4c.4 0 .7.1 1 .3l.5.8c.2.3.2.7.1 1a2.2 2.2 0 0 1-.3 1 1.7 1.7 0 0 1-.8.7 2 2 0 0 1-1 .1 2 2 0 0 1-1-.3 1.7 1.7 0 0 1-.5-.8 2.1 2.1 0 0 1-.1-1m.5 0c0 .5 0 1 .3 1.2.2.3.5.5.9.5s.7 0 1-.3c.3-.2.4-.6.5-1a1.9 1.9 0 0 0 0-1 1.2 1.2 0 0 0-.5-.5 1.3 1.3 0 0 0-.7-.3c-.3 0-.7 0-1 .3-.2.2-.4.6-.5 1.2zm3.7 2.3.3-3.8h.6l1.8 3.2.2-3h.5l-.3 3.9h-.5l-1.9-3.2-.2 3zm5.6.4.1-3.8 2.7.1v.5l-2.1-.1-.1 1.1 1.9.1v.5l-2-.1v1.8zm3 .1 1.5-3.8h.6l1.5 4h-.6l-.4-1.3h-1.7l-.4 1.2zm1-1.5h1.4l-.4-1a9.8 9.8 0 0 1-.2-.9l-.2.8-.5 1.1zm3.1 1.6v-3.8h.6v3.8zm2.5 0V292h-1.3v-.4h3.1v.4h-1.3v3.4zm4 0-.3-4h.6l.1 3.4h2v.4zm2.6-.2 1.2-4h.6l2 3.7h-.7l-.5-1h-1.7l-.3 1.3zm1-1.7h1.4l-.5-1-.4-.9a4.8 4.8 0 0 1-.1.8zm4.7 1.2-.4-3.8 2.6-.3.1.5-2.1.2v1.2l2-.2v.5l-1.9.2.2 1.7zm3-2.1a2 2 0 0 1 .2-1.6 2 2 0 0 1 1.3-.7l1 .1c.4.1.6.3.8.6l.4 1-.1 1a1.6 1.6 0 0 1-.6.8 2 2 0 0 1-.9.4 2 2 0 0 1-1-.1 1.7 1.7 0 0 1-.8-.6 2.1 2.1 0 0 1-.4-1zm.5-.1c0 .4.2.8.5 1 .3.3.6.3 1 .3s.7-.2 1-.5c.2-.3.2-.7.2-1.2a2 2 0 0 0-.3-.8 1.3 1.3 0 0 0-.6-.5 1.4 1.4 0 0 0-.7 0c-.4 0-.7.1-1 .4-.1.3-.2.7-.1 1.3m4.1 1.3-.6-3.8 1.7-.3h.8c.2 0 .4 0 .5.2l.3.6c0 .3 0 .5-.2.7-.1.2-.4.4-.7.5a1.4 1.4 0 0 1 .3.1l.5.5 1 .9h-.7l-.7-.6a7.4 7.4 0 0 0-.5-.5 1.2 1.2 0 0 0-.3-.2.8.8 0 0 0-.3 0h-.3l-.6.1.4 1.7zm.2-2.2 1-.2a1.7 1.7 0 0 0 .6-.2.6.6 0 0 0 .3-.6.6.6 0 0 0-.2-.4h-.7l-1.3.1zm6.3-.4h.5c0 .4-.1.8-.3 1a2 2 0 0 1-1 .6 2 2 0 0 1-1 0 1.6 1.6 0 0 1-.8-.6 2.6 2.6 0 0 1-.5-1 2.2 2.2 0 0 1 0-1c0-.4.3-.7.5-.9l.9-.4h1c.4.2.6.4.8.8l-.5.2a1.2 1.2 0 0 0-.5-.5 1.1 1.1 0 0 0-.7 0 1 1 0 0 0-.7.3 1.1 1.1 0 0 0-.3.7v.7a2.3 2.3 0 0 0 .4.8c.1.2.3.4.6.4h.7a1.1 1.1 0 0 0 .6-.3c.2-.2.3-.5.3-.8m1.4 1-1-3.7 2.7-.7.2.4-2.3.6.3 1.1 2.1-.5.2.4-2.2.6.4 1.2 2.4-.6v.4z"
        })
      ]
    })
  ]
});
var Ht_default = SvgHt;

// src/country-flag-icons/generated/Hu.tsx
import { jsx as jsx118, jsxs as jsxs111 } from "react/jsx-runtime";
var SvgHu = (props) => /* @__PURE__ */ jsx118("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs111("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx118("path", {
        fill: "#fff",
        d: "M640 480H0V0h640z"
      }),
      /* @__PURE__ */ jsx118("path", {
        fill: "#388d00",
        d: "M640 480H0V320h640z"
      }),
      /* @__PURE__ */ jsx118("path", {
        fill: "#d43516",
        d: "M640 160.1H0V.1h640z"
      })
    ]
  })
});
var Hu_default = SvgHu;

// src/country-flag-icons/generated/Id.tsx
import { jsx as jsx119, jsxs as jsxs112 } from "react/jsx-runtime";
var SvgId = (props) => /* @__PURE__ */ jsxs112("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx119("path", {
      fill: "#e70011",
      d: "M0 0h640v240H0Z"
    }),
    /* @__PURE__ */ jsx119("path", {
      fill: "#fff",
      d: "M0 240h640v240H0Z"
    })
  ]
});
var Id_default = SvgId;

// src/country-flag-icons/generated/Ie.tsx
import { jsx as jsx120, jsxs as jsxs113 } from "react/jsx-runtime";
var SvgIe = (props) => /* @__PURE__ */ jsx120("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs113("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx120("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx120("path", {
        fill: "#009A49",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx120("path", {
        fill: "#FF7900",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Ie_default = SvgIe;

// src/country-flag-icons/generated/Il.tsx
import { jsx as jsx121, jsxs as jsxs114 } from "react/jsx-runtime";
var SvgIl = (props) => /* @__PURE__ */ jsxs114("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx121("defs", {
      children: /* @__PURE__ */ jsx121("clipPath", {
        id: "il_svg__a",
        children: /* @__PURE__ */ jsx121("path", {
          fillOpacity: 0.7,
          d: "M-87.6 0H595v512H-87.6z"
        })
      })
    }),
    /* @__PURE__ */ jsxs114("g", {
      fillRule: "evenodd",
      clipPath: "url(#il_svg__a)",
      transform: "translate(82.1) scale(.94)",
      children: [
        /* @__PURE__ */ jsx121("path", {
          fill: "#fff",
          d: "M619.4 512H-112V0h731.4z"
        }),
        /* @__PURE__ */ jsx121("path", {
          fill: "#0038b8",
          d: "M619.4 115.2H-112V48h731.4zm0 350.5H-112v-67.2h731.4zm-483-275 110.1 191.6L359 191.6z"
        }),
        /* @__PURE__ */ jsx121("path", {
          fill: "#fff",
          d: "m225.8 317.8 20.9 35.5 21.4-35.3z"
        }),
        /* @__PURE__ */ jsx121("path", {
          fill: "#0038b8",
          d: "M136 320.6 246.2 129l112.4 190.8z"
        }),
        /* @__PURE__ */ jsx121("path", {
          fill: "#fff",
          d: "m225.8 191.6 20.9-35.5 21.4 35.4zM182 271.1l-21.7 36 41-.1-19.3-36zm-21.3-66.5 41.2.3-19.8 36.3zm151.2 67 20.9 35.5-41.7-.5zm20.5-67-41.2.3 19.8 36.3zm-114.3 0L189.7 256l28.8 50.3 52.8 1.2 32-51.5-29.6-52z"
        })
      ]
    })
  ]
});
var Il_default = SvgIl;

// src/country-flag-icons/generated/Im.tsx
import { jsx as jsx122, jsxs as jsxs115 } from "react/jsx-runtime";
var SvgIm = (props) => /* @__PURE__ */ jsxs115("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx122("defs", {
      children: /* @__PURE__ */ jsx122("clipPath", {
        id: "im_svg__a",
        children: /* @__PURE__ */ jsx122("path", {
          fillOpacity: 0.7,
          d: "M-77.6 0H605v512H-77.6z"
        })
      })
    }),
    /* @__PURE__ */ jsxs115("g", {
      clipPath: "url(#im_svg__a)",
      transform: "translate(72.8) scale(.94)",
      children: [
        /* @__PURE__ */ jsx122("path", {
          fill: "#ba0000",
          fillRule: "evenodd",
          d: "M629.4 512H-102V0h731.4z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M281 376c.2-.6.6-6.8.4-6.8s-9.4-10.9-9.2-10.9c.2 0 11.8 2.6 11.8 2.2 0-.4 4.7-11.5 4.7-11.7l5.6 13.5 11.5 5-8 6.7 1.7 13c0 .3-8-7.6-8-7.6l-8.9 1s-1.2-4-1.6-4.4z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.6,
          d: "M218.7 206.9c-7.7 4-37 37.5-41 42.7a77.3 77.3 0 0 1-16.8 23.4c-7.3 5.5-11.3 13-10.3 20 0 9 4.9 15 8.8 21.1 2.3 2.9 5.5 4.7 8.8 5 6.9.8 7.5 3 11 4.2 13.4 18.4 33.6 32 48 42.7a68.4 68.4 0 0 1 18 12.4c4.2 8.2 3.4 16 2.8 20L237.3 439c-1.9 11 7.8 8.6 8.3 6.4 4.3-5.7 10.8-1.7 20-34.3l12.8-17.1s4.9-2 4.9-2.5c7.5-9 1.8-14-2.5-15.7l-9.2-3.4s-10.8-10.8-11.3-10.8c-5.1-14.9-30.3-46.6-36.1-51-4-4.3-6-6-9.8-8.4-5.9-2.8-7.8-3.8-11.4-5.2-3-1.2-.9-4.5 1-6 20-10.9 35.7-22.9 54.8-35.1l3-2-6.9-39.2-31.8-11.2c-1.7 1.1-3 2.3-4.4 3.4z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffec00",
          fillRule: "evenodd",
          d: "M245.3 413.1c0-.4 20-4 20-4l-2.5 7.4-19.7 6z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M193.6 338.5a37.9 37.9 0 0 1 21.6-20.4"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.4,
          d: "M244.6 413.3c1.3-.3 7-2 8.6-2.3 1.8-.4 3.5-.8 5.2-1.4 2-.4 3.2-.8 5.2-1.1a39 39 0 0 1 5-1.4M241 425.6a14.6 14.6 0 0 1 2.5-2c1.1-.4 5-2 6.5-2.3a54 54 0 0 0 4.7-1.4l4.6-1.2c1.5-.6 2.9-1 4.4-1.4"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M249 341.4h-.2c.8 0 .3 0-.9 1.4-.4 1.1-4 3.7-6.8 3.7a53 53 0 0 1-4.7.3l-1.3-.3m13.7 53.5h1.4c1.5 0 3 .3 4.2.3 1.5 0 2.9.4 4.3.4 1.5.2 3.2.1 4.7.4 1.6 0 3 .3 4.7.3 1.4.1 2.2.3 3.7.3l-3.7-.3c1.4.1 2.2.3 3.7.3m-32.7 33a13.6 13.6 0 0 1 2.3-2c1-.3 4.6-2 6-2.2a46.7 46.7 0 0 0 4.2-1.5l4.3-1c1.3-.7 2.6-1.1 4-1.5m5.8-41.2c-.8 2.3.3 2.9.7 3.9a12 12 0 0 0 5.7 3.4c1.2.3 2 .6 3.4 1.2.9 0 1.3.3 2 .5m-124.4-94.8h.3c-.9 0-.3.1 1.1-1 1-1.1 1.7-1.6 2.6-2.7m14.4 24c.2 0 16.6-8.2 18.3-10l3.7-2.9c1-.5 1.7-1.1 2.6-1.7.7-1 1.7-1.7 2.3-2.7 1-.9.5-1.8 1.4-2.9l1.3-3.8m20.8 12.2c.1.6-.2 2.4-.2 3.8 0 1.6-2.1 6.5-4.6 8"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m192.6 307.8 6.7 2.1c5 1.8 15.4 8.4 16.5 9.3 1 .8 3 1.6 3.6 2.5 1.2 1 2 2.1 2.9 3.2 1 1.2 2 2.3 2.5 3.4a113.2 113.2 0 0 1 13.4 24.5c.7.7 1 1.7 1.7 2.8.6 1.4 1.3 2 2 3.1 1 .7 2.2 2 3.4 2.6 1.3 1.1 2.5 1.5 3.5 2.3 1.3.6 16.3 10 17 10.5 1.4 1.1 5.5 5.4 2.6 8.6-1.2 1-2.4 2.5-3.4 3-1.1 1.2-2.6 1.7-3.9 2.2-6.7 2-10.2 1.3-11.5 1.3h-1.4m-88.8-114.9c2 .8 1.2.2 2.9 1 1.2.5 2 .5 3 1 1.3.3 4.7 1 6.3 2.6 1.2 1 2 2 3.4 2.7a21.8 21.8 0 0 0 4.6 2.4c1.6.6 3.4 1.3 5 1.3h7.8-4 4"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffe606",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M159 293.3c4.2-.3 11.3 1 11.5 1l9.4-.2c5-.4 6-2.3 6.8-3.7 1.9-2.8 3.1-3.8 4.6-6 2.2-1.6 5.4 2.3 5.5 2.3 8 7.6 1.6 16.8 1.2 17.1-4 3.7-4.9 3.9-7.3 1.6-2.4-2.9-3.1-4.2-5.1-5.2-3.9-1.8-11.8-.4-12-.4l-4.1 1.6c-2 .7-3.2 2.4-6.5 3-3.5.2-4.6-.1-6.3-2.9-2.3-3.5-1.2-7.8 2.3-8.2z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M381.8 120.7c-.6 0-6.3 2.8-6.2 3 .1.1-4.8 13.5-4.9 13.4-.1-.2-3.5-11.7-3.9-11.5-.3.2-12.3 1.6-12.4 1.7l9-11.5-1.3-12.5 9.8 3.8 10.5-8c.2-.1-2.7 10.8-2.7 10.8l5.2 7.2s-3 3-3.1 3.6z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.6,
          d: "M265 257.9c7.1 4.7 50.7 13.9 57.3 14.8a77 77 0 0 1 28.6 3.2c8.3 3.6 16.8 3.4 22.5-1 7.8-4.2 10.6-11.4 14-18a12 12 0 0 0 0-10c-2.6-6.4-1-8-1.6-11.6 9.4-20.8 11.4-45 13.6-62.9-.2-10.5.9-18.5 2-21.7a32 32 0 0 1 16-12.2l40.7-10.6c10.6-3.8 3.7-11 1.5-10.4-7-1-6.8-8.6-39.7-.7l-21.2-2.7s-4-3.3-4.5-3c-11.5-2.1-13.1 5.3-12.5 9.8l1.6 9.8s-4.1 14.6-3.9 15c-10.5 11.8-26 49.6-27 56.9-.5 6.8-3 5.5-2.4 12.2 0 5.2-.6 2 1.1 12.6.5 3.2-3.5 3-5.7 2-19.2-12-37.4-19.9-57.5-30.5l-3.1-1.6-30.8 25.2 5.8 33.2c1.8 1 3.4 1.5 5.1 2.2z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffec00",
          fillRule: "evenodd",
          d: "M431.7 133.6a375 375 0 0 1-13.3-15.4l7.6-1.5 14.8 14.3z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M392 215.2a37.9 37.9 0 0 1-28.4-8.8"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.4,
          d: "M432.2 134.1c-1-.9-5.2-5-6.2-6.4a66.5 66.5 0 0 0-3.8-3.8c-1.3-1.5-2.3-2.4-3.6-4a37.1 37.1 0 0 1-3.6-3.6m29.6 15c-.3 0-2-.7-3-1.2-.8-.9-4.2-3.4-5.1-4.6a54.2 54.2 0 0 0-3.5-3.4c-1.2-1.3-2.1-2-3.3-3.5a30.3 30.3 0 0 1-3.4-3"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m367.3 165.5.1.3c-.4-.8-.2-.3 1.7 0 1.2-.2 5.2 1.7 6.5 4.1.8 1.1 2 2.8 2.6 4 .2.3.2 1 .4 1.3m40-38.2-.2-.2-.6-1-1.8-3.9c-.7-1.2-1-2.7-1.7-3.9-.6-1.4-1.5-2.8-2-4.2-.8-1.5-1.2-2.8-2-4.4-.7-1.2-.8-2-1.6-3.3l1.6 3.3c-.7-1.2-.8-2-1.6-3.3m44.8 12.3a12 12 0 0 1-2.8-1c-.8-.7-4-3-5-4a47 47 0 0 0-3.3-3c-1-1.3-1.9-2-3-3.3a26.2 26.2 0 0 1-3.2-2.7m-38.9 15c2.5-.4 2.5-1.6 3.1-2.5.5-1 .9-3.5.2-6.6l-.6-3.5c-.4-.9-.4-1.4-.5-2m-21.7 154.8-.1-.2c.4.8.2.3-1.6-.5l-3.5-1m13.9-24.3c-.1-.2-15.3-10.4-17.7-11-1.4-.7-2.7-1-4.3-1.8l-2.8-1.4c-1.3-.2-2.4-.7-3.5-.7-1.2-.4-1.9.4-3.2.2l-4 .7m.5-24.1c.4-.4 2.2-1 3.4-1.7 1.4-.7 6.7-1.3 9.2.1"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m365.7 231.2-1.5-7a100 100 0 0 1 0-18.8c.2-1.3 0-3.4.5-4.5.3-1.4.8-2.7 1.3-4 .6-1.5 1.1-2.8 1.7-3.9.7-4 12-20.1 12.8-20.9a43 43 0 0 1 2-2.7c.3-1 1-1.8 1.6-3 1-1.1 1.2-2 1.8-3.2.1-1.1.6-2.9.6-4.2.3-1.7 0-3 .3-4.1-.2-1.5.7-19.2.8-20 .3-1.8 2-7.5 6.2-6.5 1.5.5 3.3.8 4.4 1.5 1.4.4 2.6 1.5 3.7 2.3 5 4.9 6.1 8.2 6.8 9.4l.7 1.2M352.6 276l-.1-.2c.4.7.2.3-.3-1.1-.1-1.3-.5-3-.7-4.2-.3-1.3-.9-2.7-.7-3.5-.5-1.3-.2-2.3 0-3.6.3-1.6.5-2.7.5-4.2.2-2 0-3.2.1-5-.5-1.5-.6-2.7-1.3-4.2l-2-4-2-3.5 2 3.4-2-3.4"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffe606",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M369.5 267.6c-2.3-3.6-4.7-10.4-4.8-10.5l-4.7-8.2c-2.8-4-5-4-6.6-4-3.4-.3-4.9-1-7.4-1.1-2.6-1.2-.7-5.9-.8-6 2.7-10.6 14-9.6 14.4-9.4 5.1 1.7 5.7 2.4 4.9 5.6-1.3 3.5-2 4.8-2 7 .3 4.2 5.5 10.5 5.5 10.6l3.4 2.8c1.6 1.4 3.7 1.6 5.8 4.3 1.9 2.9 2.2 4 .6 6.8-2 3.8-6.2 4.9-8.3 2.1z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M105.2 168.7c.5.4 5.8 3.7 6 3.5s14-3.4 13.8-3.2-7.8 9.3-7.4 9.5c.4.2 8 9.4 8.2 9.5l-14.5-1.2-9.8 7.8-2.2-10.2L87 180c-.2-.1 10.5-3.6 10.5-3.6l3.2-8.3s4.1.7 4.7.6z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.6,
          d: "M284 191.3c0-8.7-16.2-50.2-19-56.1a77.2 77.2 0 0 1-13-25.7c-1.5-9-6.3-16-13-18.4-7.9-4.1-15.5-2.5-22.8-1.8-3.6.7-6.7 2.7-8.4 5.5-4 5.7-6.1 5.2-8.9 7.7-22.5 3.5-43.8 15.1-60 23a68 68 0 0 1-19.3 10.2 32 32 0 0 1-19-6.6l-31.1-28.3c-9-6.7-11.2 3-9.5 4.5 3 6.4-3.5 10.3 21.2 33.6l9.3 19.2s-.5 5.2 0 5.4c4.4 10.8 11.6 8.1 15 5.1l7.3-6.7s14.5-4.6 14.7-5c15.6 2.3 55.8-5.3 62.4-8.5 6-3.3 6.3-.5 11.5-4.7 4.3-2.9 2-.6 10-7.9 2.4-2 4.3 1.3 4.8 3.7.4 22.7 3.8 42.2 5.9 64.8l.4 3.5 38 12 24.6-23-1-5.6z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffec00",
          fillRule: "evenodd",
          d: "M88.7 119.8c.3.3-5.6 19.6-5.6 19.6l-5.4-5.5 3.8-20.3z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M178.8 108.4c7.2 8 9.5 21.2 8.2 28.6"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.4,
          d: "M89 119.1c-.3 1.3-1.5 7.2-2 8.7a66.8 66.8 0 0 0-1.2 5.3l-1.4 5.2c-.2 1.7-.5 3.3-1 5m-3.7-33c.1.3.5 2 .6 3.1-.2 1.2-.5 5.4-1 6.9a54.4 54.4 0 0 0-.9 4.8l-1 4.6a30.6 30.6 0 0 1-.8 4.6"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m150.7 156.3.1-.3c-.4.8 0 .3-.8-1.4-.9-1-1.4-5.3-.2-7.8a55 55 0 0 1 2-4.3c.1-.3.6-.7.8-1M98.8 129l-.1.2-.6 1c-.6 1.4-1.6 2.6-2.2 3.7-.6 1.3-1.7 2.3-2.3 3.6l-2.4 4c-.9 1.4-1.8 2.5-2.6 4l-2 3.2 2-3.2-2 3.2m-14.2-44.3c.2.2.7 1.9.8 3-.2 1-.4 5-.8 6.3l-.7 4.4c-.4 1.6-.5 2.7-1 4.3a26.2 26.2 0 0 1-.5 4.2M104 151c-1.7-1.9-2.7-1.2-3.8-1.3a12 12 0 0 0-5.7 3.5c-.8.9-1.5 1.6-2.6 2.5-.5.8-.9 1-1.4 1.5M232 90.4l-.1.3c.4-.8.1-.4.5 1.5.5 1.3.5 2.2 1 3.4m-27.9 1.8c0 .2-.3 18.5.5 20.9.2 1.5.6 2.7.8 4.6 0 1 .3 2 .4 3 .6 1.2.7 2.4 1.4 3.3.3 1.3 1.3 1.4 1.9 2.5.7.9 2 2.4 2.8 3m-20.5 12.9c-.6-.2-2-1.4-3.2-2-1.4-.8-4.9-4.9-5-7.8"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m206.5 121.6-5 5a94.3 94.3 0 0 1-15.8 10.3c-1.2.6-2.7 2-4 2.1-1.3.6-2.7.8-4 1.1a113.4 113.4 0 0 1-28.7 1.5 43.2 43.2 0 0 1-3.4-.2c-1 .2-2 .1-3.3.2-1.6-.1-2.4.2-3.7.3-1 .6-2.7 1.1-3.9 1.9-1.5.6-2.5 1.5-3.6 2-1 .9-16.4 9.8-17.2 10.2-1.6.7-7.3 2.5-8.8-1.6-.4-1.6-1-3.3-1.1-4.5-.5-1.4-.2-3-.2-4.4 1.4-6.9 3.6-9.6 4.2-10.8l.7-1.2M251 108l-.1.3c.3-.7.2-.4-.8.8-1 .8-2.2 2-3.1 3-1 .8-1.8 2-2.6 2.4-.8 1-1.8 1.4-3 2a20 20 0 0 0-3.8 1.9c-1.7.8-2.7 1.7-4.2 2.6-1 1.2-2 2-2.8 3.4-.8 1.3-1.6 2.4-2.3 3.9l-1.8 3.5 1.8-3.5-1.8 3.5m11.7 73.1.3-.5c-.5 1-.4.7.1-.9 0-1.8.5-4.1.5-5.8.3-1.8.6-3.7.6-5.5-.1-2-.1-4-.4-6 0-1.8-.3-3.7-.3-5.6 0-1.8-.2-3.3-.6-5a29.5 29.5 0 0 0-.4-4.8c.1-1.2-.2-2.4-.5-3.4l-1.2-5.1-1-4.1c-.2-1.6-1-3.6-1.4-4.9a13.6 13.6 0 0 1-1.1-3.4c-.5-1.1-1.2-2.4-1.3-3.6l-1.6-3.7-1.4-3.6c-.5-1.4-1.1-2.6-1.5-4-.5-.5-.6-1-.8-1.4"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffe606",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M234.9 98.5a59 59 0 0 1-6.2 9.7l-4.2 8.4c-1.8 4.6-.7 6.5.1 7.8 1.7 3 2 4.6 3.2 6.8.5 2.8-4.5 3.8-4.5 3.9-10.4 3.6-15.7-6.4-15.7-6.9-1.4-5.2-1.2-6 2-7.1 3.6-.9 5-1 6.8-2.2 3.5-2.6 5.9-10.3 6-10.4l.4-4.4c.3-2-.6-4 .4-7.2 1.4-3.2 2.2-4 5.4-4.3 4.2-.3 7.5 2.6 6.3 5.9z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M221.3 199.7c-1.6-1.5 29.4 11.2 33.7 11.3 5.8-2.1 29.9-22.4 29.9-22.4.2 2 1.1 7.1 3.4 8.2-9.3 7.5-17.7 14.8-27 22.3.6 12-1.5 24.7 4.5 38 0 0-7.2.2-7.2 0-6.4-6.4-8.7-37.2-8.7-37.2l-30.6-13.6c1.5-1 2.6-3.9 2-6.7z"
        }),
        /* @__PURE__ */ jsx122("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M250.8 231.3c.5-.4-5.6 2.8-7.2 3.6-28.1 15-42.6 37-43.5 37.8l-2.2 3.4-2.3 3a60.6 60.6 0 0 1-3.6 4.7c-.2.6.4-.3.2.2m77.9-70.6a79 79 0 0 0 6.5 4.7c26.2 18.2 52.3 21.1 53.5 21.5 1 0 2.5.3 4 .5 1.2 0 2.6.4 3.8.5 1.4.2 4.4.8 5.8 1.2.6-.2-.5-.3 0-.4"
        })
      ]
    })
  ]
});
var Im_default = SvgIm;

// src/country-flag-icons/generated/In.tsx
import { jsx as jsx123, jsxs as jsxs116 } from "react/jsx-runtime";
var SvgIn = (props) => /* @__PURE__ */ jsxs116("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx123("path", {
      fill: "#f93",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx123("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx123("path", {
      fill: "#128807",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsxs116("g", {
      transform: "matrix(3.2 0 0 3.2 320 240)",
      children: [
        /* @__PURE__ */ jsx123("circle", {
          r: 20,
          fill: "#008"
        }),
        /* @__PURE__ */ jsx123("circle", {
          r: 17.5,
          fill: "#fff"
        }),
        /* @__PURE__ */ jsx123("circle", {
          r: 3.5,
          fill: "#008"
        }),
        /* @__PURE__ */ jsxs116("g", {
          id: "in_svg__d",
          children: [
            /* @__PURE__ */ jsxs116("g", {
              id: "in_svg__c",
              children: [
                /* @__PURE__ */ jsxs116("g", {
                  id: "in_svg__b",
                  children: [
                    /* @__PURE__ */ jsxs116("g", {
                      id: "in_svg__a",
                      fill: "#008",
                      children: [
                        /* @__PURE__ */ jsx123("circle", {
                          r: 0.9,
                          transform: "rotate(7.5 -8.8 133.5)"
                        }),
                        /* @__PURE__ */ jsx123("path", {
                          d: "M0 17.5.6 7 0 2l-.6 5z"
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx123("use", {
                      xlinkHref: "#in_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(15)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx123("use", {
                  xlinkHref: "#in_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(30)"
                })
              ]
            }),
            /* @__PURE__ */ jsx123("use", {
              xlinkHref: "#in_svg__c",
              width: "100%",
              height: "100%",
              transform: "rotate(60)"
            })
          ]
        }),
        /* @__PURE__ */ jsx123("use", {
          xlinkHref: "#in_svg__d",
          width: "100%",
          height: "100%",
          transform: "rotate(120)"
        }),
        /* @__PURE__ */ jsx123("use", {
          xlinkHref: "#in_svg__d",
          width: "100%",
          height: "100%",
          transform: "rotate(-120)"
        })
      ]
    })
  ]
});
var In_default = SvgIn;

// src/country-flag-icons/generated/Io.tsx
import { jsx as jsx124, jsxs as jsxs117 } from "react/jsx-runtime";
var SvgIo = (props) => /* @__PURE__ */ jsxs117("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx124("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#000063",
      fillRule: "evenodd",
      d: "M640 416.2c-7.2 6.7-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.7c11.4 0 17.1-23 36.3-23 28.5 0 38 32.4 76 32.4 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.2 32.4-15.8zm0-81.2c-7.2 6.7-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.8c11.4 0 17.1-23.1 36.3-23.1 28.5 0 38 32.5 76 32.5 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.5-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.2 32.4-15.8zm0-81.1c-7.2 6.7-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.8c11.4 0 17.1-23.2 36.3-23.2 28.5 0 38 32.5 76 32.5 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.5-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.2 32.4-15.8zm0-81.1c-7.2 6.6-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.7c11.4 0 17.1-23 36.3-23 28.5 0 38 32.4 76 32.4 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.5-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.3 32.4-15.9zm0-81.3c-7.2 6.7-13.3 22.1-32.4 22.1-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 .1-24.8 23.3-36.2 23.3v41.8c11.4 0 17.1-23.1 36.2-23.1 28.5 0 38.1 32.5 76.2 32.5 19 0 28.5-32.5 47.6-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.4-32.5 28.7 0 38.2 32.5 76.3 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.3 32.4-15.9v-48Zm0-81c-7.2 6.6-13.3 22-32.4 22C569.5 32.5 560 0 531.4 0c-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5C198 32.5 188.6 0 160 0c-19 0-28.6 32.5-47.6 32.5C74.2 32.5 64.7 0 36.2 0 17.2 0 11.4 23.2 0 23.2v41.9C11.4 65 17.1 42 36.2 42c28.5 0 38.1 32.4 76.2 32.4 19 0 28.5-32.4 47.6-32.4 28.6 0 38.1 32.4 76.3 32.4 19 0 28.4-32.4 47.4-32.4 28.7 0 38.2 32.4 76.3 32.4 19 0 28.6-32.4 47.6-32.4 28.6 0 38.1 32.4 76.2 32.4 19 0 28.6-32.4 47.6-32.4 28.6 0 38.2 32.4 76.2 32.4 19 0 25.2-9.2 32.4-15.8z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#a24300",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2.1,
      d: "m474.8 131.7-3.5 329c0 17.3 15.7 17.3 17.4 0l-3.5-329Z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.8,
      d: "m510.7 254-11-11.9-2.6 12.1-4.7-17.5-4.5 8.8-.8-18.6-4.4 8.8-.8-18.6-4.4 8.8L475 204l-4.4 8.8L468 191l-4.5 8.8-2.5-21.9-1.3-11 2.2-4.3 5.8 2.1 9.1 8.7 18.3 17.4-11.3-4.3 18.3 17.4-11.4-4.3 18.3 17.3-11.4-4.2 16.6 14-11.3-4.2 16.5 14-11.3-4.2 12.6 15.2-13.1-7.6 3 14.3z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M510.7 254 462 162.6m33.1 28.2L469 175.6l-5.4 24.1"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m502.2 203.8-26.3-15.1-5.3 24.1"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m509.1 216.8-26.2-15-5.4 24"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m514.3 226.7-24.5-11.9-7 21"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M519.5 236.5 495 224.6l-7 21"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m520.8 247.4-22.3-16.2-1.4 23"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "m383 97.9 17.8 6.8-5.2-13.5 15.6 15.3-1.5-11 12.6 18.4-1.5-11 12.6 18.4-1.5-11 16.3 20.8-1.5-11 16.3 20.8-1.4-11 16.2 20.8 8.2 10.4.7 5.5-6.7.6-14-4.3-28.2-8.7 13.3-1.1-28.1-8.7 13.3-1.1-28.1-8.7 13.3-1.2-24.4-6.2 13.3-1.1-24.4-6.2 13.3-1.2-21.5-9.3 17.1 1.3L383.1 98z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m383 97.9 103.7 68.7m-48.9-12.4 34.1 2.6-10.3-26.9"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m423 144.4 34 2.6-10.3-27"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m408.2 134.6 34 2.6-10.3-27"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m397 127.2 30.5.1-6.7-24.4"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m386 119.8 30.4.2-6.7-24.5"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m377.8 109.4 31.1 5.7-13.2-23.9"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "M589.8 120.8 575 131.7l16.4 1.8-22.9 5.4 12.2 3.6-24.7 1.8 12.2 3.6-24.7 1.8 12.1 3.7-28.9 3.6 12.2 3.6-28.9 3.6 12.2 3.6-28.9 3.6-14.5 1.8-6-1.8 2.2-5.4 10.7-9 21.3-18.1-4.6 10.8 21.3-18-4.6 10.8 21.3-18-4.6 10.8L553 119l-4.5 10.9 17-16.3-4.5 10.8 19-12.6-8.7 12.7 18.6-3.6z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m589.8 120.8-117 50.6m34.1-32.5-17.4 25.3 32.7 3.6"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M523.7 131.7 506.2 157l32.7 3.6"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m540.4 124.4-17.5 25.3 32.7 3.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m553 119-13.3 23.5 28.5 5.4"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m565.5 113.6-13.3 23.5 28.5 5.4"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m580 111.8-19.4 21.7h30.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "M587.4 230.3 569 225l6.6 13-17.1-14 2.6 10.7-14.5-17.2 2.7 10.8-14.5-17.3 2.6 10.8-18.5-19.4 2.7 10.8-18.5-19.4 2.7 10.8-18.5-19.4-9.2-9.7-1.3-5.4 6.6-1.2 14.5 3.2 29 6.4-13.2 2.2 29 6.4-13.2 2.2 29 6.4-13.2 2.3 25 4.2-13.2 2.2 25 4.2L569 211l22.3 7.5h-17l13 12z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m587.4 230.3-110.6-60.2m50 8.4-34.2.2 13.2 26"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m542.6 187.1-34.2.2 13.2 26"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m558.4 195.7-34.2.2 13.2 26"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m570.3 202.2-30.3 2.3 9.3 23.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m582.2 208.7-30.3 2.2 9.2 23.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m591.3 218.4-31.5-3.2 15.8 22.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.8,
      d: "m395.2 236.6 9.3-13-14.1 2.1 17.4-9.9-11.1-.5 20-7-11.1-.6 20-7-11.1-.6 23-9.6-11.2-.5 23-9.7-11.1-.5 23-9.6 11.5-4.9 5.6.3-.4 5.3-6.3 10.4-12.6 20.8.8-10.6-12.6 20.8.7-10.7-12.6 20.8.7-10.6-9.6 18.2.7-10.6-9.6 18.2.7-10.6-12.2 15.4 3.7-13.2z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m395.2 236.6 83-71m-19.1 36.5 7.3-26.4-28.2 4.1"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m447.2 212.3 7.3-26.4-28.2 4"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m435.3 222.4 7.4-26.4-28.2 4.1"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m426.4 230 4.4-23.8-25.2 1.5"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m417.5 237.6 4.4-23.8-25.2 1.5"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m406 242.4 10-23.5-25.6 6.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "m563 66.2-17.9 12-2.9-12.9-10.5 17.8-2-8.5-8.6 18.2-1.2-8.4-6.7 18.7-3.8-9-6.7 22.7-3.8-9-6.7 22.7-3.9-9-6.7 22.7-3.3 11.4 1.9 4.5 7.2-2.4 12.4-9.2 25-18.4-14.4 4.7 24.9-18.5-14.4 4.8 24.9-18.5-14.4 4.8 25-14.4-17 4L566 83.3l-16.3 4.2 19.7-15.6-17 8.1z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m556 72.7-25.8 22.2-50 65.2"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m519.3 132.8-28.6 13.5-2.4-20.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m530.2 119.2-29 13.4-2.3-20.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m540.5 105.5-28.7 13.4-2.2-20.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m549.1 95.3-26.8 9.9-3-17"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M559 85.5 530.2 95l-1-16.4"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m562.8 76.2-26.6 13.6 5.2-20.6"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "m466.1 43.8 8 18.2 10.3-9.6-1.7 19.8 6.8-6.4-3.7 19.4 6-6.6-5.5 19 8.7-6-8 22.3 8.6-6-8 22.5 8.7-6-8 22.4-4 11.2-4.4 3-4.8-5.3-5-13.4-10-26.9 9.4 10.5-10.1-27 9.4 10.6-10-27L468 93l-12.5-23.4 12 11.1-14.4-23.9 11.3 11-7.3-22.2 9.6 14.6z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m468.2 52.4 8.5 30.5 3.2 78"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m463 120.2 16.2 24.3 14.7-16.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m462 103.7 16.5 24.4 14.7-16.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m461.5 87.3 16.4 24.4L492.3 95"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m460.4 74.9 16.8 20.4 13-13"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m458 62 18.7 21 11-13.6"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m460.3 52.4 14.4 23.5 8.1-19.9"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.9,
      d: "m359 178 23.3-16.2-11.7-6 20.5 3.4-7-9.3 19.8 7.5-7-9.3 19.9 7.4-7-9.2 24 8.1-7-9.3 23.3 12.1-7-9.3 24 8.2 11.7 6 3.5 4.6-4.7 3.3-12.9 1.8-20.7 8.6 3.8-7.4-25.7 3.6 9.3-6.4-26.3 7.6 9.4-6.5-22.2 8.3 9.9-10.4-22.8 12.2 10-10.4-18.8 13 10.5-14.4z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m366.3 173.6 24.2-10.5 12.9-1.8 10.7-.2 18.5 1.2 16.7.7 33 3.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m447.2 176.9 18.5-11.4-18.8-14.7"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m426.5 175.2 22.7-12.2-18.7-14.8"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m411.7 174.8 20.9-12.5-19-13.7m-29.5 29.6 19.3-16.9-15.6-8.5"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m375.5 179.3 15-16.1-12-4.5m18.4 17.7 19-15.2-15.2-10.4"
    }),
    /* @__PURE__ */ jsxs117("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx124("path", {
          fill: "#c00",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "m541.5 1173.3-1.7-229.1-61.1-107c-15.3-52.6-7.8-78 17-79.8 24.7-1.6 49.2 13.6 84.8 15.3 35.6 1.7 28.9-59.4 81.5-57.7 52.6 1.7 144.3 32.3 222.3 37.4 78.1 5 118.8-27.2 208.8-30.6 90-3.4 113.7 42.4 118.8 42.4 5.1 0 30.6-18.6 56-22 25.5-3.4 34 10.2 34 10.2s-1.7 57.7-13.6 91.6c-11.9 34-54.3 90-56 90-1.7 0-15.3 249.5-15.3 251.2 0 1.7-675.5-6.8-675.5-11.9z",
          transform: "matrix(.12934 0 0 .11906 367.5 215.5)"
        }),
        /* @__PURE__ */ jsxs117("g", {
          stroke: "#000",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff100",
              d: "M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8z",
              transform: "matrix(-.12934 0 0 .11906 596.6 257.6)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 594.5 257.4)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 596.8 252.6)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 598 247.6)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 598.9 242.4)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 598.7 236.8)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 591.2 261.7)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 596.7 231.4)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 592.5 227.1)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 586.8 224.3)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 581 223.9)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 575 224)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 568.8 225)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 562.7 225.7)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 556 226.6)"
            }),
            /* @__PURE__ */ jsx124("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 550.4 228.1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 369.5 257.4)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 367.2 252.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 366 247.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 365.2 242.4)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 365.4 236.8)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 367.3 231.4)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 371.4 227.1)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 377.2 224.3)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 382.9 223.9)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 389 224)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 395.2 225)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 401.4 225.7)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 407.9 226.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 413.6 228.1)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 372.8 261.7)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3,
          d: "M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3c0-53.2-35.4-88.6-35.4-88.6 0 6.8-35.5 35.5-35.5 88.6 0 53.1 17.7 106.3 17.7 106.3s-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z",
          transform: "matrix(.04311 0 0 .04536 398.7 310.9)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3,
          d: "M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3c0-53.2-35.4-88.6-35.4-88.6 0 6.8-35.5 35.5-35.5 88.6 0 53.1 17.7 106.3 17.7 106.3s-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z",
          transform: "matrix(.04311 0 0 .04536 444.5 310.9)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M531.5 832.7V673.2s35.4 53.2 88.6 53.2c43.5 0 88.6-70.9 88.6-70.9s41.5 53.2 88.6 53.2c42 0 88.5-68.6 88.5-68.6s43.2 68.6 88.6 68.6c45.5 0 88.6-53.2 88.6-53.2s46.3 70.9 106.3 70.9c53.1 0 70.9-53.2 70.9-53.2v159.5z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M708.7 832.7v-124S815 744 815 832.7z",
          transform: "matrix(.12934 0 0 .11906 344.5 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M708.7 832.7v-124S815 744 815 832.7z",
          transform: "matrix(-.12934 0 0 .11906 619.4 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7z",
          transform: "matrix(.12934 0 0 .11906 413.3 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M584.6 847.5c0-88.6 124.1-159.4 124.1-159.4s124 70.8 124 159.4h-248z",
          transform: "matrix(.12934 0 0 .11906 390.4 255.9)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M1275.6 655.5c-35.4-17.7-166-35.4-376.3-35.4s-350 17.7-385.5 35.4c-35.4 17.7-35.4 53.2 0 70.9 35.4 17.7 175.3 35.4 385.5 35.4s340.9-17.7 376.3-35.4c35.4-17.7 35.4-53.2 0-70.9z",
          transform: "matrix(.12788 0 0 .11906 367 278.7)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "gray",
          d: "M527.9 365.2c0 4.2-38.2 4.2-45.9 4.2-8.3 0-45.8 1.2-45.8-4.2 0-4.2 37.8-4.2 45.8-4.2s45.9.8 45.9 4.2"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#c00",
          d: "M440.8 350c0 1.4-1 2.6-2.3 2.6s-2.3-1.2-2.3-2.6c0-1.4 1-2.5 2.3-2.5 1.2 0 2.3 1.2 2.3 2.5m87 0c0 1.4-1 2.6-2.3 2.6-1.2 0-2.3-1.2-2.3-2.6 0-1.4 1-2.5 2.3-2.5 1.3 0 2.3 1.2 2.3 2.5"
        }),
        /* @__PURE__ */ jsx124("path", {
          d: "M486.6 348.8c0 1.3-2.1 2.4-4.6 2.4-2.4 0-4.6-1.1-4.6-2.5s2-2.5 4.6-2.5 4.6 1.2 4.6 2.5z"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#006300",
          d: "M508.6 348.8c0 1.3-1.6 2.4-3.5 2.4s-3.4-1.1-3.4-2.5 1.6-2.5 3.4-2.5 3.5 1.2 3.5 2.5zm-47.2 0c0 1.3-1.5 2.4-3.4 2.4s-3.5-1.1-3.5-2.5 1.5-2.5 3.5-2.5c1.9 0 3.4 1.2 3.4 2.5z"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z",
          transform: "matrix(.0739 0 0 .06804 379.9 300.5)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3.3,
          d: "M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9z",
          transform: "matrix(.03696 0 0 .05953 385 309.3)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3.3,
          d: "M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9z",
          transform: "matrix(-.03696 0 0 .05953 579 309.3)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M903.5 602.4a17.7 17.7 0 1 1-35.4 0 17.7 17.7 0 0 1 35.4 0z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z",
          transform: "matrix(.0739 0 0 .06804 379.9 256.2)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M903.5 602.4a17.7 17.7 0 1 1-35.4 0 17.7 17.7 0 0 1 35.4 0z",
          transform: "matrix(.12934 0 0 .11906 367.7 213.7)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M850.4 655.5h70.9v53.2h-71z",
          transform: "matrix(.12934 0 0 .11906 367.5 215.5)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M850.4 683.3h70.9v202.5h-71z",
          transform: "matrix(.12934 0 0 .11906 367.5 215.5)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 251.2)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 245.8)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 240.8)"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 235.5)"
        }),
        /* @__PURE__ */ jsx124("path", {
          d: "M486.9 356.8c0 1-2.1 1.7-4.8 1.7s-4.5-.7-4.5-1.7 2-1.7 4.6-1.7 4.7.8 4.7 1.7M529 361c-.3.7-2.6.8-5.1 0-2.6-.5-4.4-1.4-4.2-2 .3-.8 2.6-.8 5.1-.2 2.6.6 4.4 1.5 4.2 2.2m-17.7-2.8c0 .8-2.3 1.3-5 1.2-2.5-.2-4.6-1-4.5-2 .1-.8 2.4-1.2 5-1 2.6.1 4.7.9 4.5 1.8m-77.5 2.8c.2.7 2.5.8 5 0 2.6-.5 4.5-1.4 4.2-2-.3-.8-2.5-.8-5-.2-2.6.6-4.4 1.5-4.2 2.2m18.5-3.2c.1.8 2.4 1.3 5 1.1 2.6-.2 4.7-1 4.5-1.9 0-.7-2.3-1.3-5-1.1-2.5.2-4.6 1-4.5 1.9"
        })
      ]
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx124("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    })
  ]
});
var Io_default = SvgIo;

// src/country-flag-icons/generated/Iq.tsx
import { jsx as jsx125, jsxs as jsxs118 } from "react/jsx-runtime";
var SvgIq = (props) => /* @__PURE__ */ jsxs118("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx125("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx125("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx125("path", {
      fill: "#000001",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsxs118("g", {
      fill: "#007a3d",
      transform: "translate(-179.3 -92.8) scale(1.75182)",
      children: [
        /* @__PURE__ */ jsx125("path", {
          d: "M325.5 173.2a5 5 0 0 1-1.4-1c-.3-.5-.1-.5 1.2-.2 2.3.7 3.8.4 5.3-.8l1.3-1.1 1.5.7c.9.5 1.8.8 2 .7.7-.2 2.1-2 2-2.6 0-.7.6-.5 1 .3.6 1.6-.3 3.5-2 3.9-.7.2-1.4.1-2.6-.3-1.4-.5-1.7-.5-2.4 0a5.4 5.4 0 0 1-5.9.4m5.8-5.3a8 8 0 0 1-1-4c.1-.6.3-.8.8-.6 1 .3 1.2 1 1 3 0 1.8-.3 2.3-.8 1.6m-67.6-1.9c-.1 1.3 2.4 4.6 3.5 5.2-.8.3-1.7.2-2.4.5-4 4-18.4 18-21 21.4 7.8.2 16.4-.1 23.7-.4 0-5.3 5-5.6 8.4-7.5 1.7 2.7 6 2.5 6.6 6.6v17.6H216a9.7 9.7 0 0 1-12.3 7.5c2-2 5.4-2.8 6.6-5.7 1-6.4-2-10.3-4-14a24 24 0 0 0 7-3.6c-2.3 7 6.2 6.3 12.4 6.1.2-2.4.1-5.2-1.7-5.6 2.3-.9 2.7-1.2 6.6-4.4v9.6l46.1-.1c0-3 .8-7.9-1.6-7.9-2.2 0 0 6.2-1.8 6.2h-35.7v-6c1.5-1.6 1.3-1.5 11.6-11.8 1-1 8.3-7.6 14.6-13.7zm89.1-.3c2.5 1.4 4.5 3.2 7.5 4-.3 1.3-1.5 1.8-1.8 3.1v27c3.4.7 4.2-1.3 5.8-2.3.4 4.3 3.2 8.5 3 12h-14.5zm-19.4 14.5s5.3-4.5 5.3-4.7V199h3.8l-.1-26.3c1.5-1.6 4.6-3.8 5.3-5.4v42h-33.4c-.5-8.7-.6-17.7 9.6-15.8V190c-.3-.6-.9.1-1-.7 1.6-1.6 2.1-2 6.5-5.8l.1 15.5h3.9zm-12.6 18.6c.7 1 3.2 1 3-.8-.3-1.5-3.5-1-3 .8"
        }),
        /* @__PURE__ */ jsx125("circle", {
          cx: 224,
          cy: 214.4,
          r: 2
        }),
        /* @__PURE__ */ jsx125("path", {
          d: "M287 165.8c2.5 1.3 4.5 3.2 7.6 4-.4 1.2-1.5 1.7-1.8 3v27c3.4.7 4.1-1.2 5.7-2.3.5 4.3 3.2 8.6 3.1 12H287z"
        })
      ]
    })
  ]
});
var Iq_default = SvgIq;

// src/country-flag-icons/generated/Ir.tsx
import { jsx as jsx126, jsxs as jsxs119 } from "react/jsx-runtime";
var SvgIr = (props) => /* @__PURE__ */ jsxs119("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx126("defs", {
      children: /* @__PURE__ */ jsx126("clipPath", {
        id: "ir_svg__a",
        children: /* @__PURE__ */ jsx126("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.7v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs119("g", {
      fillRule: "evenodd",
      clipPath: "url(#ir_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx126("path", {
          fill: "#fff",
          d: "M-192 0h896v512h-896z"
        }),
        /* @__PURE__ */ jsx126("path", {
          fill: "#da0000",
          d: "M-192 343.8h896V512h-896z"
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M-21.6 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M52.4 367.7v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M49.6 351H53v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M17.8 359.9H21V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M17.8 359.9H21V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M17.8 359.9H21V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371H7.3zm-14.3 0h3.4V371H-7z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M9.6 367.7v3.4H-5.5v-3.4zm1-8.7v3.4H1V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M-102.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3H-95zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-28.2 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-31 351h3.4v20H-31zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-62.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-62.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-62.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-71 367.7v3.4h-15v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M58.3 351h49v3.3h-49zm7.3 16.8H69v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M132.3 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M129.5 351h3.4v20h-3.4zm-8.4 0h3.4v20H121zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M97.7 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M97.7 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M97.7 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M89.6 367.7v3.4H74.4v-3.4zm1-8.7v3.4H81V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M622.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H630zm41.9 0v3.3H662v-3.4zm5.3-16.8h3.3v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M696.7 367.7v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M694 351h3.3v20h-3.4zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M662 359.9h3.5V371H662z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M662 359.9h3.5V371H662z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M662 359.9h3.5V371H662zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M654 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M138.7 351h49.1v3.3h-49zm7.4 16.8h3.3v3.3h-3.3zm41.8 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M212.8 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M210 351h3.4v20H210zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M178.1 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M178.1 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M178.1 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.2 0h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M170 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M219.5 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zM274 351h3.3v20H274z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M293.5 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M290.7 351h3.4v20h-3.4zm-8.4 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M258.9 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M258.9 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M258.9 359.9h3.4V371h-3.4zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H234z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M250.8 367.7v3.4h-15.2v-3.4zm1-8.7v3.4H242V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsx126("path", {
          fill: "#239f40",
          d: "M-192 0h896v168.2h-896z"
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M300.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H308zm41.9 0v3.3H340v-3.4zm5.3-16.8h3.3v20h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M374.7 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M372 351h3.3v20H372zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M340 359.9h3.5V371H340z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M340 359.9h3.5V371H340z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M340 359.9h3.5V371H340zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M332 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M381.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M455.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M452.7 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M420.8 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M420.8 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M420.8 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M412.7 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H404V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M462.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M536.2 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M533.4 351h3.4v20h-3.4zm-8.4 0h3.3v20H525zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M501.6 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M501.6 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M501.6 359.9h3.3V371h-3.3zm-39.4 0h3.4V371h-3.4zm28.9 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M493.4 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M543.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M617.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M614.6 351h3.4v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M582.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M582.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M582.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H558z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M574.6 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H566V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M-183.8 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-109.8 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-112.5 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-144.4 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-144.4 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-144.4 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-152.5 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M-21.6 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M52.4 160.2v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M49.6 143.4H53v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M17.8 152.3H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M17.8 152.3H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M17.8 152.3H21v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3H7.3zm-14.3 0h3.4v11.3H-7z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M9.6 160.2v3.4H-5.5v-3.4zm1-8.7v3.3H1v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M-102.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2H-95zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-28.2 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-31 143.4h3.4v20.2H-31zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-62.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-62.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-62.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-71 160.2v3.4h-15v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M58.3 143.4h49v3.4h-49zm7.3 17H69v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M132.3 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M129.5 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2H121zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M97.7 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M97.7 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M97.7 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M89.6 160.2v3.4H74.4v-3.4zm1-8.7v3.3H81v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M622.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H630zm41.9-.2v3.4H662v-3.4zm5.3-16.8h3.3v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M696.7 160.2v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M694 143.4h3.3v20.2h-3.4zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M662 152.3h3.5v11.3H662z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M662 152.3h3.5v11.3H662z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M662 152.3h3.5v11.3H662zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M654 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M138.7 143.4h49.1v3.4h-49zm7.4 17h3.3v3.2h-3.3zm41.8-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M212.8 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M210 143.4h3.4v20.2H210zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M178.1 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M178.1 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M178.1 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.2 0h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M170 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M219.5 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.3v20.2H274z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M293.5 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M290.7 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M258.9 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M258.9 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M258.9 152.3h3.4v11.3h-3.4zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H234z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M250.8 160.2v3.4h-15.2v-3.4zm1-8.7v3.3H242v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M300.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H308zm41.9-.2v3.4H340v-3.4zm5.3-16.8h3.3v20.2h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M374.7 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M372 143.4h3.3v20.2H372zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M340 152.3h3.5v11.3H340z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M340 152.3h3.5v11.3H340z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M340 152.3h3.5v11.3H340zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M332 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M381.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M455.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M452.7 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M420.8 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M420.8 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M420.8 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M412.7 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H404v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M462.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M536.2 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M533.4 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2H525zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M501.6 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M501.6 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M501.6 152.3h3.3v11.3h-3.3zm-39.4 0h3.4v11.3h-3.4zm28.9 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M493.4 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M543.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M617.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M614.6 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M582.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M582.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M582.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H558z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M574.6 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H566v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M-183.8 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-109.8 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-112.5 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-144.4 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-144.4 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-144.4 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M-152.5 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx126("path", {
          fill: "#d90000",
          d: "M-68.8 339.5h6V350h-6zm160.5 0h6V350h-6zm-283.7 0h6V350h-6zm81.5 0h6V350h-6zm80.9 0h6V350h-6zm40 0h6V350h-6zm40.9 0h6V350h-6zm80.4 0h6V350h-6zm203 0h6.1V350h-6zm-162.1 0h6V350h-6zm40 0h6V350h-6zm40.5 0h6V350h-6zm40.4 0h6V350h-6zm323.2 0h6V350h-6zm-242.7 0h6V350h-6zm40.8 0h6V350h-6zm41.3 0h6V350h-6zm38.8 0h6V350h-6zm41.3 0h6V350h-6zm40.4 0h6V350h-6zm119.7 0h6V350h-6zm-38.8 0h6V350h-6zm-808.9 0h6V350h-6z"
        }),
        /* @__PURE__ */ jsx126("path", {
          fill: "#239e3f",
          d: "M-68.8 162.6h6v10.5h-6zm160.5 0h6v10.5h-6zm-283.7 0h6v10.5h-6zm81.5 0h6v10.5h-6zm80.9 0h6v10.5h-6zm40 0h6v10.5h-6zm40.9 0h6v10.5h-6zm80.4 0h6v10.5h-6zm203 0h6.1v10.5h-6zm-162.1 0h6v10.5h-6zm40 0h6v10.5h-6zm40.5 0h6v10.5h-6zm40.4 0h6v10.5h-6zm323.2 0h6v10.5h-6zm-242.7 0h6v10.5h-6zm40.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm38.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm40.4 0h6v10.5h-6zm119.7 0h6v10.5h-6zm-38.8 0h6v10.5h-6zm-808.9 0h6v10.5h-6z"
        }),
        /* @__PURE__ */ jsxs119("g", {
          fill: "#da0000",
          children: [
            /* @__PURE__ */ jsx126("path", {
              d: "M279.8 197.5c8.4 10.4 34.5 67.6-15.7 105.2-23.7 17.8-9 18.6-8.3 21.6 38-20.1 50.3-47.5 50-72-.2-24.4-13.2-46-26-54.8"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M284.8 194.8a73.3 73.3 0 0 1 15.7 112.4c27.2-6 62-86.4-15.7-112.4m-57.6 0a73.3 73.3 0 0 0-15.6 112.4c-27.3-6-62-86.4 15.6-112.4"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M232.2 197.5c-8.4 10.4-34.5 67.6 15.7 105.2 23.6 17.8 9 18.6 8.3 21.6-38-20.1-50.3-47.5-50-72 .2-24.4 13.2-46 26-54.8"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "M304.2 319.1c-14.9.2-33.6-2-47.5-9.3 2.3 4.5 4.2 7.3 6.5 11.7 13.2 1.3 31.5 2.8 41-2.4m-95 0c14.9.2 33.6-2 47.5-9.3-2.3 4.5-4.2 7.3-6.5 11.7-13.2 1.3-31.5 2.8-41-2.4m27.3-138.7c3 8 10.9 9.2 19.3 4.5 6.2 3.6 15.7 3.9 19-4.1 2.5 19.8-18.3 15-19 11.2-7.8 7.5-22.2 3.2-19.3-11.6"
            }),
            /* @__PURE__ */ jsx126("path", {
              d: "m256.4 331.6 7.8-9 1.1-120.1-9.3-8.2-9.3 7.8 1.9 121z"
            })
          ]
        })
      ]
    })
  ]
});
var Ir_default = SvgIr;

// src/country-flag-icons/generated/Is.tsx
import { jsx as jsx127, jsxs as jsxs120 } from "react/jsx-runtime";
var SvgIs = (props) => /* @__PURE__ */ jsxs120("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx127("defs", {
      children: /* @__PURE__ */ jsx127("clipPath", {
        id: "is_svg__a",
        children: /* @__PURE__ */ jsx127("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs120("g", {
      fillRule: "evenodd",
      strokeWidth: 0,
      clipPath: "url(#is_svg__a)",
      children: [
        /* @__PURE__ */ jsx127("path", {
          fill: "#003897",
          d: "M0 0h666.7v480H0z"
        }),
        /* @__PURE__ */ jsx127("path", {
          fill: "#fff",
          d: "M0 186.7h186.7V0h106.6v186.7h373.4v106.6H293.3V480H186.7V293.3H0z"
        }),
        /* @__PURE__ */ jsx127("path", {
          fill: "#d72828",
          d: "M0 213.3h213.3V0h53.4v213.3h400v53.4h-400V480h-53.4V266.7H0z"
        })
      ]
    })
  ]
});
var Is_default = SvgIs;

// src/country-flag-icons/generated/It.tsx
import { jsx as jsx128, jsxs as jsxs121 } from "react/jsx-runtime";
var SvgIt = (props) => /* @__PURE__ */ jsx128("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs121("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx128("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx128("path", {
        fill: "#009246",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx128("path", {
        fill: "#ce2b37",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var It_default = SvgIt;

// src/country-flag-icons/generated/Je.tsx
import { jsx as jsx129, jsxs as jsxs122 } from "react/jsx-runtime";
var SvgJe = (props) => /* @__PURE__ */ jsxs122("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx129("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx129("path", {
      d: "m1.3-.077 637.387 480.088m-637.387 0L638.687-.077",
      color: "#000"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#cf142b",
      d: "M0-.077V28.84l280.494 211.127L0 451.194v28.718h44l275.994-210.236L595.788 480.01h44.2v-29.114l-280.495-210.93L639.987 28.74V.022h-43.999L319.994 210.061 43.999-.077Z",
      color: "#000"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#cf142b",
      stroke: "maroon",
      strokeMiterlimit: 140.8,
      strokeWidth: 0.5,
      d: "M364.2 65c10.8 44 4.8 98.2-44.2 128.4-49-30.2-55-84.4-44.2-128.4 11.6-10.5 64.2-17 88.4 0z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M295.1 91a6.6 6.6 0 0 1-2.4-.4 6 6 0 0 1-1.4-2 10.4 10.4 0 0 1-2.7.2 7.2 7.2 0 0 1-2.1-1.2 4 4 0 0 0 2.2-.9 10.7 10.7 0 0 1-2.5-.5c-.8-.4-1.5-.8-2.1-1.3.8-.2 1.6-.2 2.1-.8l-2.4-.3a8.4 8.4 0 0 1-1.7-1.3c.8 0 1.6-.3 2.2-1a8.2 8.2 0 0 1-2.3-.1 11.8 11.8 0 0 1-2.4-1.6 4.6 4.6 0 0 0 2.6-.8l-.6-1c-.6-1.2-1.8-.7-2.7-1.1a2.4 2.4 0 0 1-1.4-1.8c0-.9.4-2.3 2.4-2-1-1.6.1-2.7 1.2-3.2 1-.4 2-.2 2.7 1.5a5.6 5.6 0 0 1 1.4-.8 1.5 1.5 0 0 1 1.8.6v1.2c-.3.6-1 1-1 1.8-.3.8.5 2.4.5 2.4s4 3.2 5.7 4.8l2.8 3h4.1l.3 6.6H295z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M284.2 69.2a2.4 2.4 0 0 1 .7 2.4c.2.3.5.5 1 .4a1 1 0 0 0 .7-1.3c-.4-.3-.5-1.1-2.4-1.6zm-4.5.5a4.6 4.6 0 0 0-1.1.1 2.4 2.4 0 0 1 1.6 2c.3.1.8.1 1-.1a1 1 0 0 0 .2-1.5c-.4 0-.8-.5-1.6-.5zm-1.3 4.2c-.5.1-1.2-.4-2.7.8a2.4 2.4 0 0 1 2.3 1c.3 0 .7-.1.9-.4a1 1 0 0 0-.5-1.4z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M317.6 94c-.6-.2-1.5-1-2.2-1a2 2 0 0 0-1.7 1 1.8 1.8 0 0 0 .4 1.5l1.3.8a4.4 4.4 0 0 0-1 1.6 1.6 1.6 0 0 0 .6 1.1c.4.5.6.8 1.2.8a6.6 6.6 0 0 0 1.5-.1 2.4 2.4 0 0 0 .1 1.1 2.3 2.3 0 0 0 2.1 1.1 1.4 1.4 0 0 0 1.2-.6c.3-.4.3-1.4.7-1.9l1.9-1.6c.8.4.8 1.2.6 2a6.9 6.9 0 0 0 1.6-1.4 7 7 0 0 0 .5-1.8 2 2 0 0 1 .8 2 7.8 7.8 0 0 0 1.6-1.2 6 6 0 0 0 .8-2c.6.7.8 1.6.5 2.3a6.4 6.4 0 0 0 1.7-1.6 7.2 7.2 0 0 0 .4-1.6c1.6.1 2.8-.6 2.8-1.4 0-.5-.6-1.3-1.9-1.6a7 7 0 0 1-.6-1.2 1.8 1.8 0 0 1 0-1.1 4.8 4.8 0 0 1 1.5-2 18.4 18.4 0 0 1 2.8-1.5l-.6-2.9-6.5-1-7.4 1.8c1.4.6 4.3 2.7 4.1 3.5 0 .3-.7.6-1 1-.2.2 0 .8.2 1 .2.4 1 .5 1.3.9.2.3.2.8 0 1-.5.7-2.2 1-3 1.3l-4 2.1a5.5 5.5 0 0 1-2.2-.4z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M333.1 85.1s-.1 2.4-1.1 3a1.8 1.8 0 0 1-1.4.1 1.8 1.8 0 0 1-1-1l-.3-1.1a9.4 9.4 0 0 0-2.3-.7c-1.2 0-2.4.3-3.6.6a8 8 0 0 1 2.7-3.2l3.9-.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M343.6 69.4c1.1-.1 3.4-.6 4.2-1.3l1.4-1.4c-.2 2.3-1.4 3.7-3.8 4.7a13.8 13.8 0 0 1-6.2.8 28.2 28.2 0 0 1-3.8-.8c1.4 1.4.7 2.4-1 3 0 0 .2-1.3-.2-1.5-1-.4-2.4.1-3.5.8a6.9 6.9 0 0 1-3 .6 8 8 0 0 1-3.6-.5c-.8-.2-2.3-1.3-2.8-1.2-1.4.2-3 .4-3.7 1.4-.2.3-.2.8 0 1.2a4 4 0 0 0 2.6 1.5c2.8.6 5.6.7 8.4.3l9.6-1.9c3-.5 6.8-1.4 9-1.9a34.2 34.2 0 0 1 8.9-1c5.3.1 7 2.8 6.9 5.6-.2 2.8-3.3 4.1-6 5-4.8 1.4-11.4.6-15.6.4l2 1.6c.8.6 1.2 1.8 2 2 1.3.4 3.2-.4 4.5-.4 1.9-.2 5 0 5 0a3 3 0 0 1 1.3-.8 2.4 2.4 0 0 1 1.2 0c.6.2 1 .8.8 2 .2.2.5.5 1 .6h1.7l1.6.8-1.5.5a3.1 3.1 0 0 0-.7.7c.7 0 1.3 0 2 .3a3.8 3.8 0 0 1 1.2 1 2.9 2.9 0 0 0-1.3.2 6 6 0 0 0-.8.6s1.6-.1 2.2.3l1.1 1.2a6.6 6.6 0 0 0-1.3 0l-.8.4a5.6 5.6 0 0 1 1.6 1.2c.4.4.5 1 .6 1.6a8 8 0 0 0-1.1-.6 2.9 2.9 0 0 0-.8 0l.2 2.2c0 .6 1 1.2 1 1.6a1 1 0 0 1-.1 1.2 2.2 2.2 0 0 1-2.2.7 3 3 0 0 1-1-.6 5 5 0 0 1-.9 1c-.5.4-.6.4-1.3.4a2 2 0 0 1-1.3-.5 4.3 4.3 0 0 1-.7-1.6l-1.6.3a2.2 2.2 0 0 1-1.5-.7 1.6 1.6 0 0 1 .3-1.8c.4-.4 1.6-.5 2.2-.8a5 5 0 0 0 1.6-1.3 38 38 0 0 1-3.8-3 25.6 25.6 0 0 1-1.6-2.1s-3.4 1-4.7 1a26 26 0 0 1-6.4 0c-4.8 0-8-6.6-12.3-8.2a5 5 0 0 0-3.3 0c-5 1-10.4 6.8-15.3 8-2.1.4-4.3.6-6.4.7a5.6 5.6 0 0 1-1.3 1.7 7.2 7.2 0 0 1-2.6.5 8.3 8.3 0 0 1-1 2.3 7.1 7.1 0 0 1-2 1.3 3.3 3.3 0 0 0 0-2.3 9 9 0 0 1-1.5 2 12 12 0 0 1-2.2 1.1c.2-.6.5-1.3 0-2.1a7.7 7.7 0 0 1-1.2 1.8c-.6.5-1.3.8-2 1a2.4 2.4 0 0 0 0-2.3 6.9 6.9 0 0 1-1.2 1.9 12.2 12.2 0 0 1-2.6 1.3 3.7 3.7 0 0 0 .4-2.4h-1.2c-1.5 0-1.6 1.3-2.3 1.9a2.7 2.7 0 0 1-2.4.4c-.8-.4-1.7-1.4-.5-3-2 .2-3-1-3-2.2 0-1 .3-1.9 2.4-1.8a4 4 0 0 1-.2-1.4 1.4 1.4 0 0 1 1.5-1.2c.4 0 .8.3 1.2.6.4.4.5 1.1 1.2 1.6.8.6 2.7.5 2.7.5a50.2 50.2 0 0 1 6.2-2.8c1.3-.4 5-1 5-1V81a86.9 86.9 0 0 1 13 1.1l5.2-.3s8.4-1.3 12.4-1.7c2-.2 4-.3 6.1-.2 3 .2 5.6.9 8.6 1 2.1.3 4.3.4 6.4.3 3.5-.2 9.7 0 11.7-3a2 2 0 0 0-.6-2.6 3.1 3.1 0 0 0-3-.8c-.8.1-1.6.6-1.7 1.2a1.4 1.4 0 0 0 .3 1.1c.2.4.6.7 1.1.9a3.8 3.8 0 0 1-2.2-.3 6.4 6.4 0 0 1-1.4-2.2 2 2 0 0 0-.5 1.5c0 .6.2 1.2.7 1.6a4.2 4.2 0 0 1-2.4-.8 6.8 6.8 0 0 1-.9-2.2 2.4 2.4 0 0 0-.8 1.6c0 .6.3 1 .5 1.7a5 5 0 0 1-2.2-1.2 6.4 6.4 0 0 1-.7-2.2l-9 1.8-9.5 1.6a24 24 0 0 1-11.3-.8c-1.6-.8-2.4-1.3-2.8-2.7a3.2 3.2 0 0 1 1-2.7 9.8 9.8 0 0 1 5-2.6 76.3 76.3 0 0 1 8.8-1.6 33.6 33.6 0 0 1 9.5.4c1.4.2 3-.1 3.3-.6.4-.4 1-.8.2-1.8.8 0 1.4.5 1.8 1.2.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M343.6 69.4c1.1-.1 3.4-.6 4.2-1.3l1.4-1.4c-.2 2.3-1.4 3.7-3.8 4.7a13.8 13.8 0 0 1-6.2.8 28.2 28.2 0 0 1-3.8-.8c1.4 1.4.7 2.4-1 3 0 0 .2-1.3-.2-1.5-1-.4-2.4.1-3.5.8a6.9 6.9 0 0 1-3 .6 8 8 0 0 1-3.6-.5c-.8-.2-2.3-1.3-2.8-1.2-1.4.2-3 .4-3.7 1.4-.2.3-.2.8 0 1.2a4 4 0 0 0 2.6 1.5c2.8.6 5.6.7 8.4.3l9.6-1.9c3-.5 6.8-1.4 9-1.9a34.2 34.2 0 0 1 8.9-1c5.3.1 7 2.8 6.9 5.6-.2 2.8-3.3 4.1-6 5-4.8 1.4-11.4.6-15.6.4l2 1.6c.8.6 1.2 1.8 2 2 1.3.4 3.2-.4 4.5-.4 1.9-.2 5 0 5 0a3 3 0 0 1 1.3-.8 2.4 2.4 0 0 1 1.2 0c.6.2 1 .8.8 2 .2.2.5.5 1 .6h1.7l1.6.8-1.5.5a3.1 3.1 0 0 0-.7.7c.7 0 1.3 0 2 .3a3.8 3.8 0 0 1 1.2 1 2.9 2.9 0 0 0-1.3.2 6 6 0 0 0-.8.6s1.6-.1 2.2.3l1.1 1.2a6.6 6.6 0 0 0-1.3 0l-.8.4a5.6 5.6 0 0 1 1.6 1.2c.4.4.5 1 .6 1.6a8 8 0 0 0-1.1-.6 2.9 2.9 0 0 0-.8 0l.2 2.2c0 .6 1 1.2 1 1.6a1 1 0 0 1-.1 1.2 2.2 2.2 0 0 1-2.2.7 3 3 0 0 1-1-.6c-.2.4-.5.7-.9 1a1.8 1.8 0 0 1-1.3.5 2 2 0 0 1-1.3-.6 4.3 4.3 0 0 1-.7-1.6l-1.6.3a2.2 2.2 0 0 1-1.5-.7 1.6 1.6 0 0 1 .3-1.8c.4-.4 1.6-.5 2.2-.8a5 5 0 0 0 1.6-1.3 38 38 0 0 1-3.8-3 25.6 25.6 0 0 1-1.6-2.1s-3.4 1-4.7 1a26 26 0 0 1-6.4 0c-4.8 0-8-6.6-12.3-8.2a5 5 0 0 0-3.3 0c-5 1-10.4 6.8-15.3 8-2.1.4-4.3.6-6.4.7a5.6 5.6 0 0 1-1.3 1.7 7.2 7.2 0 0 1-2.6.5 8.3 8.3 0 0 1-1 2.3 7.1 7.1 0 0 1-2 1.3 3.3 3.3 0 0 0 0-2.4 9 9 0 0 1-1.5 2 12 12 0 0 1-2.2 1.2c.2-.6.5-1.3 0-2.1a7.7 7.7 0 0 1-1.2 1.8c-.6.5-1.3.8-2 1a2.4 2.4 0 0 0 0-2.3 6.9 6.9 0 0 1-1.2 1.9 12.2 12.2 0 0 1-2.6 1.3 3.7 3.7 0 0 0 .4-2.4h-1.2c-1.5 0-1.6 1.3-2.3 1.9a2.7 2.7 0 0 1-2.4.4c-.8-.4-1.7-1.4-.5-3-2 .2-3-1-3-2.2 0-1 .3-1.9 2.4-1.8a4 4 0 0 1-.2-1.4 1.4 1.4 0 0 1 1.5-1.2c.4 0 .8.3 1.2.6.4.4.5 1.1 1.2 1.6.8.6 2.7.5 2.7.5a50.2 50.2 0 0 1 6.2-2.8c1.3-.4 5-1 5-1V81a86.9 86.9 0 0 1 13 1.1l5.2-.3s8.4-1.3 12.4-1.7c2-.2 4-.3 6.1-.2 3 .2 5.6.9 8.6 1 2.1.3 4.3.4 6.4.3 3.5-.2 9.7 0 11.7-3a2 2 0 0 0-.6-2.6 3.1 3.1 0 0 0-3-.8c-.8.1-1.6.6-1.7 1.2 0 .4 0 .8.3 1 .3.4.6.7 1.1 1 0 0-1.7 0-2.4-.4a4.6 4.6 0 0 1-1.2-2.1 2 2 0 0 0-.5 1.5c0 .6.2 1.2.7 1.6a4.2 4.2 0 0 1-2.4-.8 6.8 6.8 0 0 1-.9-2.2 2.4 2.4 0 0 0-.8 1.6c0 .6.3 1 .5 1.7a5 5 0 0 1-2.2-1.2 6.4 6.4 0 0 1-.7-2.2l-9 1.8-9.5 1.6a22 22 0 0 1-11.3-1c-1.6-.6-2.4-1.1-2.8-2.5a3.2 3.2 0 0 1 1-2.8 9.8 9.8 0 0 1 5-2.5 76.3 76.3 0 0 1 8.8-1.6 33.6 33.6 0 0 1 9.4.4c1.4.2 3-.1 3.4-.6.4-.4 1-.8.1-1.8a2 2 0 0 1 1.8 1.2c.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M307.6 82.3c1 .7 2-.1 2.2-.2a2.6 2.6 0 0 1-.8-1.1 7.1 7.1 0 0 1-.2-2c0-1.6.6-1.9.6-1.8a7.4 7.4 0 0 0 1.6-.7 2.4 2.4 0 0 0 .7-1.5 5.1 5.1 0 0 0-.2-1.9c-1.6 0-2 .1-2.4.6a7.2 7.2 0 0 0-.2-1.6 4.8 4.8 0 0 0-.6-1.2 2.2 2.2 0 0 0-.5-.6c0 .5-.4.8-.6 1.1a6.6 6.6 0 0 0-.6-2.1 6.2 6.2 0 0 0-1.2-1 6.2 6.2 0 0 0-1.5.2 6.6 6.6 0 0 0-1.6 1.6 2.4 2.4 0 0 1 .1-1.3c-.2 0-.5 0-.8.2a4.8 4.8 0 0 0-1.1.7 7.2 7.2 0 0 0-1 1.2c0-.7-.4-1-1.7-1.9a5.1 5.1 0 0 0-1.2 1.6 2.4 2.4 0 0 0-.2 1.6c.2.6.6 1 1 1.5 0-.1.4.5-.5 1.8a7.2 7.2 0 0 1-1.3 1.5 2.6 2.6 0 0 1-1.3.5c.3.9.4 1.3 1.8 1.5-3 2.2-3.4 5.7-1 8.7a6.9 6.9 0 0 1 .9-1.5 4.3 4.3 0 0 0 1 2.6c.2.3.4 2 .8 2.4l1 1s.3-1.3.9-1.5l2-.6c.9-.3 2.1-1.9 2.1-1.9l-.2 2c4-1.4 5-4.2 4-7.9"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#504416",
      d: "M299.8 77.4a8.2 8.2 0 0 1-.8 4l2.5 1 2.7.4c-.3-1.1.8-3.2 1.3-3.8h-1.9l-.8-.8-1.6.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#fff",
      d: "M300.2 78a3.2 3.2 0 0 0 0 2l.8-1.6zm3.8 1.2-.2 1.8a3.2 3.2 0 0 0 1-1.7zm-3.8 1.3a3.2 3.2 0 0 0-1 1.7h.9zm3.3.9-.7 1.6.6.4a3.2 3.2 0 0 0 .1-2m-3-8.6c-.5 0-.8.2-1 .6 0 .4.3 1 1 1.2a1.4 1.4 0 0 0 1.7-.7c.2-.5-.4-.8-1.2-1a2.6 2.6 0 0 0-.5-.1m5.4 1.6c-.4 0-.6 0-.8.4a1.4 1.4 0 0 0 1.1 1.4c.8.3 1.4 0 1.6-.5.1-.6-.4-1-1-1.2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#d1b948",
      d: "M300.5 72.6a1.5 1.5 0 0 0-.5.1.8.8 0 0 0-.6.6c0 .3 0 .6.2.9.2.3.6.5.9.6.8.2 1.6 0 1.8-.8a.7.7 0 0 0-.2-.8 2.8 2.8 0 0 0-1-.4 2.6 2.6 0 0 0-.6-.2m0 .4a2.5 2.5 0 0 1 .5 0l.8.4c.3 0 .4.4.3.5a1.2 1.2 0 0 1-1.5.7 1.4 1.4 0 0 1-.8-.6.8.8 0 0 1 0-.6.6.6 0 0 1 .3-.4zm5.4 1.2h-.2a.7.7 0 0 0-.7.5 1.4 1.4 0 0 0 1.2 1.6c.3.2.8.2 1 0 .3 0 .6-.3.6-.6a.8.8 0 0 0-.1-.8 2 2 0 0 0-1-.5zm0 .3.8.1c.3 0 .6.3.8.4.1.2.2.4.1.7a.8.8 0 0 1-.5.5h-.9a1.2 1.2 0 0 1-1-1.4c0-.2.2-.2.5-.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M300.6 71.7a1.3 1.3 0 0 0-1 .2c-.2.2-.2.7-.2.7h.4l.7.1 1.3.6h1.5l-1.2-.7c-.5-.2-1-.8-1.6-1zm7 2c-.6-.2-1.1 0-1.6 0l-1.4-.1 1.2.8 1.5.2.6.2.4.3.3-.6a1.3 1.3 0 0 0-1-.8m-8.6 7.7c-1.3 3.5 4 5.2 4.8 1.4a11 11 0 0 1-4.8-1.4"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#806600",
      d: "m299 81.1-.2.3a2.7 2.7 0 0 0 0 2.4 2.8 2.8 0 0 0 5.4-.8v-.4h-.3a10.7 10.7 0 0 1-4.8-1.3zm.1.4A14 14 0 0 0 304 83a3.2 3.2 0 0 1-1.1 1.7 3.5 3.5 0 0 1-2.2.2 3.5 3.5 0 0 1-1.6-1.4 2.6 2.6 0 0 1 0-1.9z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M301.3 78.4a15.2 15.2 0 0 0-.8 7.2c1.6-1.8 2.4-4.2 3-6.4 0-.2-.4-.3-.5-.4l-.4-.6a3.4 3.4 0 0 1-.7.4 2 2 0 0 1-.6-.1z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M305.4 68.2a6.2 6.2 0 0 0-1.5.3 6.6 6.6 0 0 0-1.6 1.6 2.4 2.4 0 0 1 0-1.3c-.2 0-.5 0-.7.2a4.8 4.8 0 0 0-1.2.7 7.2 7.2 0 0 0-1 1.1c.4 0 1.6-1 2-.9.4 0 .2 1 .5 1.1.5 0 1-.8 1.6-1.2a3 3 0 0 1 1.6-.8 2.4 2.4 0 0 1 1 1.6c.3.8.5 1.6.9 1.9.3.1.6-.8 1-.8.5.2.7 1.7 1.1 2a7.2 7.2 0 0 0-.2-1.6 4.8 4.8 0 0 0-.7-1.2 2.2 2.2 0 0 0-.5-.6c0 .4-.4.8-.6 1.1a6.6 6.6 0 0 0-.5-2.1 6.2 6.2 0 0 0-1.2-1zm-6.5 5.7c-.6 1 0 2 1.2 2.1l-.4 1.1.6 1.3 1.2.4 1-.4.9 1 1 .2 1.3-.8.5-.9h.8l.8-.4.2-.9a2.3 2.3 0 0 1-2.6.4 2 2 0 0 1-.5 1.4 1 1 0 0 1-1 .2 2.3 2.3 0 0 1-1.2-1c-.5.3-.8.6-1.2.5a1.4 1.4 0 0 1-1-1 1.6 1.6 0 0 1 .5-1.4c-2.4-.7-1.6-1.4-2.2-1.8zm-1.3.3a19.8 19.8 0 0 1-2 2.8 2.6 2.6 0 0 1-1.3.5c.3.9.4 1.3 1.8 1.5-3 2.2-3.4 5.7-1 8.7a6.9 6.9 0 0 1 .9-1.5 4.3 4.3 0 0 0 1 2.6c.2.3.4 2 .8 2.4l1 1s.3-1.3.9-1.5l2-.6c.9-.3 2.1-1.9 2.1-1.9l-.1 2c4-1.4 5-4.2 3.9-7.9 1 .7 2-.1 2.2-.2a2.6 2.6 0 0 1-.8-1.2 7.8 7.8 0 0 1-.2-2l-.2-1.1-.5 1.7v1.8a5.4 5.4 0 0 1-1.9-1 31.2 31.2 0 0 1 .8 4c0 .9-.1 1.8-.4 2.7a7 7 0 0 1-1.7 1.7 20.2 20.2 0 0 0 .3-2.4c0-.8-.4-3-.4-3a16.5 16.5 0 0 1-.8 3l-1.3 2c.3-2.1.2-2.2-.1-3 0 0-.5 2.6-1.5 3.7a8 8 0 0 1-1.6.8 1.8 1.8 0 0 0-.8.6l-.6-1.8a20.9 20.9 0 0 1-1.2-2.4c-.3-1.2 1.3-3.6 1.3-3.6-.6 0-1.2.7-1.9 1.4a18.2 18.2 0 0 0-1.3 1.8 16 16 0 0 1-.5-2.4 4.5 4.5 0 0 1 .7-2.2 21.6 21.6 0 0 1 3.4-3.3 4.5 4.5 0 0 1-3 0s1.3-1.3 1.4-1.6a4.3 4.3 0 0 0 .6-2zm5.2 1.2h-1.3v.6l.6.2.8 1 1.7-.5.3-.4a6.5 6.5 0 0 0-1.6-.9 2.5 2.5 0 0 0-.5 0"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M307.6 82.3c1 .7 2-.1 2.2-.2a2.6 2.6 0 0 1-.8-1.1 7.1 7.1 0 0 1-.2-2c0-1.6.6-1.9.6-1.8a7.4 7.4 0 0 0 1.6-.7 2.4 2.4 0 0 0 .7-1.5 5.1 5.1 0 0 0-.2-1.9c-1.6 0-2 .1-2.4.6a7.2 7.2 0 0 0-.2-1.6 4.8 4.8 0 0 0-.6-1.2 2.2 2.2 0 0 0-.5-.6c0 .5-.4.8-.6 1.1a4 4 0 0 0-1.8-3.2c-1.4 0-2.2.8-3.2 1.8a2.4 2.4 0 0 1 .2-1.2 2.2 2.2 0 0 0-.8.2 4.8 4.8 0 0 0-1.1.7 7.2 7.2 0 0 0-1 1.2c0-.7-.4-1-1.7-1.9a5.1 5.1 0 0 0-1.2 1.6 2.4 2.4 0 0 0-.2 1.6c.2.6.6 1 1 1.5 0-.1.4.5-.5 1.8a7.2 7.2 0 0 1-1.3 1.5 2.6 2.6 0 0 1-1.3.5c.3.9.4 1.3 1.8 1.5-3 2.2-3.4 5.7-1 8.7a6.9 6.9 0 0 1 .9-1.5 4.3 4.3 0 0 0 1 2.6c.2.3.4 2 .8 2.4l1 1s.3-1.3.9-1.5l2-.6c.9-.3 2.1-1.9 2.1-1.9l-.2 2c4-1.4 5-4.2 4-7.9z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#806600",
      d: "M297.8 70.2a3.2 3.2 0 0 0-.6 1.6 6.4 6.4 0 0 0 1 1.7l.4-2.4c0-.4-.8-1-.8-1Zm2.1 2.1a.8.8 0 0 0-.3.1c-.2.2-.4.2-.6.6l.8-.4a.4.4 0 0 1 .3 0c.4.4.8.5 1.2.7a4.9 4.9 0 0 0 1.9 0 2.7 2.7 0 0 1-.2.8s-.7.2-1 .5a8.6 8.6 0 0 0-.3.4 1 1 0 0 0-.3.3v.8h.2c.4.1.8.5.8 1l.2.2a.5.5 0 0 0 .3 0h.4c.3-.3.8-.4 1.3-.3h.1l.1-.1c.2-.2.2-.3.2-.6V76a7.5 7.5 0 0 0-.1-.6l-.4-1 .1-.9a5 5 0 0 0 1.6 1.2l1.4.1.3.2.5.6c0-.3 0-.6-.2-.8-.1-.2-.3-.2-.5-.2-.4-.2-1 0-1.3-.2a4 4 0 0 1-1.5-1l-.3-.2-.1.2-.3 1.2.4 1.2a6.2 6.2 0 0 1 .1.7v.1a2.2 2.2 0 0 0-1.7.5h-.1a2.6 2.6 0 0 0-1.2-1.3v-.3l.1-.2.4-.3c.2-.3.8-.5 1-.8.2-.3.3-.7.3-1v-.4h-.3a3.6 3.6 0 0 1-1.8.2l-1.2-.6a.8.8 0 0 0-.3 0zm-1 1.4a1.6 1.6 0 0 0-.3 1.7c.3.4.7.7 1.2.8l-.1.2-.2.8c.1.6.4 1 .8 1.4a1.8 1.8 0 0 0 1.3.4 1.8 1.8 0 0 0 .8-.4l.6.8a1.8 1.8 0 0 0 1.3.3 1.8 1.8 0 0 0 1.8-1.5v-.1a1.6 1.6 0 0 0 1.4-.2c.4-.4.7-1 .7-1.6-.4.3 0 .8-1 1.4a1.1 1.1 0 0 1-1.1 0l-.4-.3v1a2.2 2.2 0 0 1-.3.5c-.3.3-.8.5-1.2.5a1.4 1.4 0 0 1-.8-.2 2 2 0 0 1-.6-.8v-.5l-.3.3-.5.3a1.4 1.4 0 0 1-.5.1 1.4 1.4 0 0 1-.9-.3 2 2 0 0 1-.8-1.2l.2-.5a1.4 1.4 0 0 1 .2-.4l.2-.4h-.4a1.4 1.4 0 0 1-1-.6c-.6-.6 0-1-.1-1.5m12 .2s-1 0-1.3.4a8.8 8.8 0 0 0-.8 2.3 6.4 6.4 0 0 0 1.6-1 3.2 3.2 0 0 0 .5-1.7"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#2b2200",
      d: "M301 73.1a.6.6 0 0 0-.2 1.1.6.6 0 1 0 .2-1zm5.4 1.6a.6.6 0 0 0-.2 1 .6.6 0 1 0 .2-1"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M280.2 91.5c-.5.3-1.2-.2-2.7 1a2.4 2.4 0 0 1 2.4 1c.3 0 .7-.2.8-.6a1 1 0 0 0-.5-1.4zm33.9 1.6c-.5.3-1.2-.2-2.7 1a2.4 2.4 0 0 1 2.4 1 1 1 0 0 0 .8-.5 1 1 0 0 0-.5-1.5zm-36.4 2c-.4.3-1.2.2-2.1 1.9a2.4 2.4 0 0 1 2.6 0c.3-.2.5-.6.5-1a1 1 0 0 0-1-1zm37 2.6c-.4.4-1.2.3-1.9 2a2.4 2.4 0 0 1 2.5-.2c.4-.1.5-.5.5-.8a1 1 0 0 0-1.2-1zM280.1 99a1.3 1.3 0 0 0-.6.2c-.2.5-.9.8-.8 2.7a2.4 2.4 0 0 1 2.2-1.3c.2-.3.3-.7 0-1a1 1 0 0 0-.8-.6zm73.8.3h-.5c-.1.5-1 .8-1.1 2.7a2.4 2.4 0 0 1 2.4-1c.2-.4.2-.8.2-1.1a1 1 0 0 0-1-.6zm-35.2 1.2a1.3 1.3 0 0 0-.6.3c0 .5-.8.8-.5 2.7a2.4 2.4 0 0 1 2-1.4c.2-.4.2-.8 0-1a1 1 0 0 0-.8-.6zm43.8.2a1 1 0 0 0-1 .6c.2.5-.3 1.2.8 2.7a2.4 2.4 0 0 1 1.1-2.3 1 1 0 0 0-.5-1 1.3 1.3 0 0 0-.4 0zm-4.8.6c-.2 0-.4.1-.7.4 0 .4-.6 1 .1 2.8a2.4 2.4 0 0 1 1.7-2 1 1 0 0 0-.3-1 1 1 0 0 0-.8-.2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M295.2 127a6.2 6.2 0 0 1-2.2-.3 5.8 5.8 0 0 1-1.5-1.8 9 9 0 0 1-2.5 0 6.8 6.8 0 0 1-2-1 3.8 3.8 0 0 0 2.1-1 10.2 10.2 0 0 1-2.4-.3 11.2 11.2 0 0 1-2-1.3c.7-.2 1.5-.2 2-.8a8.8 8.8 0 0 1-2.1-.3 8 8 0 0 1-1.8-1.2 2.9 2.9 0 0 0 2.2-1 7.8 7.8 0 0 1-2.3-.2 11.2 11.2 0 0 1-2.2-1.5 4.4 4.4 0 0 0 2.4-.6l-.5-1c-.6-1.2-1.8-.8-2.6-1.1a2.2 2.2 0 0 1-1.3-1.6c-.1-.9.3-2.2 2.3-2-1-1.4 0-2.5 1-3 1-.4 2-.2 2.6 1.4a5.3 5.3 0 0 1 1.4-.8 1.4 1.4 0 0 1 1.6.6c.2.4.2.8 0 1.2-.2.5-.8.8-1 1.6-.2.8.6 2.4.6 2.4s3.8 3 5.5 4.6l2.6 2.7h3.8l.3 6.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M284.8 106.3a2.4 2.4 0 0 1 .6 2.3c.3.4.6.4 1 .4a1 1 0 0 0 .6-1.2c-.4-.4-.4-1-2.2-1.5zm-4.2.5a4.4 4.4 0 0 0-1.2 0 2.4 2.4 0 0 1 1.6 2 1 1 0 0 0 1 0 1 1 0 0 0 0-1.5c-.2 0-.6-.5-1.4-.5zm-1.3 4c-.5 0-1.1-.3-2.6.8a2.4 2.4 0 0 1 2.2 1c.4 0 .8-.2.9-.5a1 1 0 0 0-.5-1.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M316.6 130c-.6-.2-1.4-1.1-2.1-1.1a2 2 0 0 0-1.6 1 1.7 1.7 0 0 0 .4 1.4l1.2.9a4.2 4.2 0 0 0-.8 1.4 1.4 1.4 0 0 0 .5 1.1c.4.5.4.7 1.2.8a6.2 6.2 0 0 0 1.2-.1c0 .3 0 .8.3 1a2.2 2.2 0 0 0 1.9 1c.5 0 1-.1 1.2-.5.2-.4.2-1.4.6-1.8l1.8-1.6c.8.5.7 1.1.6 1.9a6.6 6.6 0 0 0 1.5-1.2 5.5 5.5 0 0 0 .5-1.9 2 2 0 0 1 .8 2 7.4 7.4 0 0 0 1.6-1.2l.7-1.7a2.2 2.2 0 0 1 .4 2 6 6 0 0 0 1.6-1.6 6.9 6.9 0 0 0 .5-1.4c1.6 0 2.5-.6 2.6-1.3 0-.5-.6-1.3-1.8-1.5a6.6 6.6 0 0 1-.7-1.2 1.6 1.6 0 0 1 0-1.1 4.6 4.6 0 0 1 1.5-1.8 17.4 17.4 0 0 1 2.7-1.6l-.6-2.6-6.2-1-7 1.7c1.3.6 4.1 2.6 4 3.4-.2.2-.9.5-1.1.8-.2.4 0 .8.2 1 .3.5 1 .6 1.2.9a.8.8 0 0 1 0 1c-.4.7-2 .9-2.8 1.2l-3.8 2a5.2 5.2 0 0 1-2.2-.4z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M331.4 121.4s-.1 2.3-1 2.8a1.7 1.7 0 0 1-1.5.3 1.8 1.8 0 0 1-.8-1.1l-.3-1a9 9 0 0 0-2.3-.7 13.3 13.3 0 0 0-3.3.6 7.7 7.7 0 0 1 2.4-3l3.8-.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M341.4 106.5c1-.1 3.2-.6 4-1.2l1.2-1.3c-.1 2-1.2 3.4-3.6 4.4a13.1 13.1 0 0 1-5.9.7 26.8 26.8 0 0 1-3.5-.8c1.3 1.5.6 2.4-1 3 0 0 .3-1.3-.2-1.5-1-.4-2.2.2-3.4.8a6.5 6.5 0 0 1-2.8.6 9.1 9.1 0 0 1-3.4-.5c-.8-.2-2.2-1.3-2.7-1.2-1.3.3-2.8.4-3.5 1.4a1.1 1.1 0 0 0 0 1.2 4 4 0 0 0 2.5 1.3c2.6.6 5.3.7 8 .3 2.8-.4 6.2-1.2 9-1.7l8.8-2a32.6 32.6 0 0 1 8.4-.7c5 0 6.6 2.5 6.5 5.1-.2 2.8-3.2 4-5.8 4.8-4.6 1.4-10.8.6-14.7.5l1.9 1.4c.7.6 1 1.7 2 2 1.1.3 3-.4 4.2-.5l4.8.1c.2-.3.7-.6 1.2-.8a2.4 2.4 0 0 1 1 0c.6.2 1 .8.8 1.9a1.8 1.8 0 0 0 .9.5c.6.2 1.3 0 1.7.2l1.5.6-1.5.6a3 3 0 0 0-.6.6 7.6 7.6 0 0 1 2 .3c.3.2.7.5 1 1a2.7 2.7 0 0 0-1.2 0 5.7 5.7 0 0 0-.8.7s1.6-.1 2.2.3l1 1a6.3 6.3 0 0 0-1.2.2 4 4 0 0 0-.8.3 5.4 5.4 0 0 1 1.6 1.1 3.7 3.7 0 0 1 .5 1.6 7.6 7.6 0 0 0-1-.6 2.8 2.8 0 0 0-.8 0l.2 2.1c0 .5.8 1.1 1 1.5.2.4.1 1-.2 1.2a2.2 2.2 0 0 1-2 .6 3 3 0 0 1-1-.6 4.7 4.7 0 0 1-.8 1c-.4.4-.7.3-1.3.3a1.8 1.8 0 0 1-1.3-.4 4 4 0 0 1-.6-1.5l-1.5.3a2 2 0 0 1-1.4-.7 1.6 1.6 0 0 1 .2-1.7c.4-.5 1.6-.5 2.2-.8a4.8 4.8 0 0 0 1.4-1.2 36 36 0 0 1-3.5-2.9 24.4 24.4 0 0 1-1.6-2l-4.5 1a24.7 24.7 0 0 1-6 0c-4.6 0-7.6-6.3-11.7-7.8a4.8 4.8 0 0 0-3.2 0c-4.8 1-9.9 6.4-14.6 7.6a43.6 43.6 0 0 1-6 .7 5.3 5.3 0 0 1-1.3 1.6c-.8.3-1.6.5-2.4.5a8 8 0 0 1-1 2.1 6.8 6.8 0 0 1-2 1.3c.3-.8.4-1.5 0-2.2a8.6 8.6 0 0 1-1.3 1.9 11.4 11.4 0 0 1-2 1.1c0-.6.3-1.3 0-2a7.3 7.3 0 0 1-1.3 1.7c-.5.4-1.2.8-1.9 1a2.4 2.4 0 0 0 0-2.2 6.5 6.5 0 0 1-1.1 1.7 11.5 11.5 0 0 1-2.4 1.3c.3-.8.5-1.5.3-2.2H286c-1.3 0-1.4 1.1-2.1 1.7a2.6 2.6 0 0 1-2.2.4c-.9-.4-1.7-1.4-.6-3-1.9.3-2.8-.9-2.8-2 0-.9.3-1.8 2.2-1.7a3.8 3.8 0 0 1-.2-1.3 1.4 1.4 0 0 1 1.5-1c.4 0 .8 0 1.1.4.4.4.5 1 1.2 1.6a5.8 5.8 0 0 0 2.6.4 47.7 47.7 0 0 1 5.8-2.6c1.3-.4 4.8-1 4.8-1v-8.7h3.1c2.6 0 9.3 1 9.3 1l4.8-.3s8-1.2 12-1.6a38.6 38.6 0 0 1 5.7-.2c3 .1 5.4.8 8.1 1 2.1.2 4.2.3 6.2.2 3.3-.1 9.2 0 11-3a2 2 0 0 0-.4-2.3 3 3 0 0 0-3-.8c-.6.1-1.5.6-1.5 1.2-.1.4 0 .8.2 1.1l1 .8a3.7 3.7 0 0 1-2-.3 6 6 0 0 1-1.3-2.1 2 2 0 0 0-.5 1.4 2.2 2.2 0 0 0 .7 1.6 4 4 0 0 1-2.3-.8 6.5 6.5 0 0 1-.9-2.1 2.3 2.3 0 0 0-.8 1.5c0 .6.4 1 .6 1.6a4.8 4.8 0 0 1-2-1.1 6.2 6.2 0 0 1-.9-2.1l-8.5 1.6a101 101 0 0 1-9 1.6c-4.6.6-8 .3-10.8-.8-1.5-.6-2.2-1.2-2.6-2.4a3 3 0 0 1 .8-2.7 9.4 9.4 0 0 1 4.8-2.4 72.6 72.6 0 0 1 8.4-1.6 32 32 0 0 1 9 .5c1.4.1 2.8-.2 3.2-.6.4-.4 1-.8.2-1.8.7 0 1.3.5 1.6 1.2.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M341.4 106.5c1-.1 3.2-.6 4-1.2l1.2-1.3c-.1 2-1.2 3.4-3.6 4.4a13.1 13.1 0 0 1-5.9.7 26.8 26.8 0 0 1-3.5-.8c1.3 1.5.6 2.4-1 3 0 0 .3-1.3-.2-1.5-1-.4-2.2.2-3.4.8a6.5 6.5 0 0 1-2.8.6 9.1 9.1 0 0 1-3.4-.5c-.8-.2-2.2-1.3-2.7-1.2-1.3.3-2.8.4-3.5 1.4a1.1 1.1 0 0 0 0 1.2 4 4 0 0 0 2.5 1.3c2.6.6 5.3.7 8 .3 2.8-.4 6.2-1.2 9-1.7l8.8-2a32.6 32.6 0 0 1 8.4-.7c5 0 6.6 2.5 6.5 5.1-.2 2.8-3.2 4-5.8 4.8-4.6 1.4-10.8.6-14.7.5l1.9 1.4c.7.6 1 1.7 2 2 1.1.3 3-.4 4.2-.5l4.8.1c.2-.3.7-.6 1.2-.8a2.4 2.4 0 0 1 1 0c.6.2 1 .8.8 1.9a1.8 1.8 0 0 0 .9.5c.6.2 1.3 0 1.7.2l1.5.6-1.5.6a3 3 0 0 0-.6.6 7.6 7.6 0 0 1 2 .3c.3.2.7.5 1 1a2.7 2.7 0 0 0-1.2 0 5.7 5.7 0 0 0-.8.7s1.6-.1 2.2.3l1 1a6.3 6.3 0 0 0-1.2.2 4 4 0 0 0-.8.3 5.4 5.4 0 0 1 1.6 1.1 3.7 3.7 0 0 1 .5 1.6 7.6 7.6 0 0 0-1-.6 2.8 2.8 0 0 0-.8 0l.2 2.1c0 .5.8 1.1 1 1.5.2.4.1 1-.2 1.2a2.2 2.2 0 0 1-2 .6 3 3 0 0 1-1-.6 4.7 4.7 0 0 1-.8 1 1.7 1.7 0 0 1-1.3.5 1.8 1.8 0 0 1-1.3-.6 4 4 0 0 1-.6-1.5l-1.5.3a2 2 0 0 1-1.4-.7 1.6 1.6 0 0 1 .2-1.7c.4-.5 1.6-.5 2.2-.8a4.8 4.8 0 0 0 1.4-1.2 36 36 0 0 1-3.5-2.9 24.4 24.4 0 0 1-1.6-2l-4.5 1a24.7 24.7 0 0 1-6 0c-4.6 0-7.6-6.3-11.7-7.8a4.8 4.8 0 0 0-3.2 0c-4.8 1-9.9 6.4-14.6 7.6a43.6 43.6 0 0 1-6 .7 5.3 5.3 0 0 1-1.3 1.6 6.8 6.8 0 0 1-2.4.5 8 8 0 0 1-1 2.1 6.8 6.8 0 0 1-2 1.3c.3-.8.4-1.5 0-2.2a8.6 8.6 0 0 1-1.3 1.9 11.4 11.4 0 0 1-2 1.1c0-.6.3-1.3 0-2a7.3 7.3 0 0 1-1.3 1.7c-.5.4-1.2.8-1.9 1a2.4 2.4 0 0 0 0-2.2 6.5 6.5 0 0 1-1.1 1.7 11.5 11.5 0 0 1-2.4 1.3c.3-.8.5-1.5.3-2.2H286c-1.3 0-1.4 1.1-2.1 1.7a2.6 2.6 0 0 1-2.2.4c-1-.4-1.7-1.4-.6-3-1.9.3-2.8-.9-2.8-2 0-.9.3-1.8 2.2-1.7a3.8 3.8 0 0 1-.2-1.3 1.4 1.4 0 0 1 1.5-1c.4 0 .8 0 1.1.4.4.4.5 1 1.2 1.6a5.8 5.8 0 0 0 2.6.4 47.7 47.7 0 0 1 5.8-2.6c1.3-.4 4.8-1 4.8-1v-8.7h3.1c2.6 0 9.3 1 9.3 1l4.8-.3s8-1.2 12-1.6a38.6 38.6 0 0 1 5.7-.2c3 .1 5.4.8 8.1 1 2.1.2 4.2.3 6.2.2 3.3-.1 9.2 0 11-3a2 2 0 0 0-.4-2.3 3 3 0 0 0-3-.8c-.6.1-1.5.6-1.5 1.2a1.2 1.2 0 0 0 .2 1l1 .9a4.9 4.9 0 0 1-2.2-.4 4.4 4.4 0 0 1-1.1-2 2 2 0 0 0-.5 1.4 2.2 2.2 0 0 0 .7 1.6 4 4 0 0 1-2.3-.8 6.5 6.5 0 0 1-.9-2.1 2.3 2.3 0 0 0-.8 1.5c0 .6.4 1 .6 1.6a4.8 4.8 0 0 1-2-1.1 6.2 6.2 0 0 1-.9-2.1l-8.5 1.6a101 101 0 0 1-9 1.6c-4.6.6-8 .3-10.8-.8-1.5-.6-2.2-1.2-2.6-2.4a3 3 0 0 1 .8-2.7 9.4 9.4 0 0 1 4.8-2.4 72.6 72.6 0 0 1 8.4-1.6 32 32 0 0 1 9 .5c1.4.1 2.8-.1 3.2-.6.4-.4 1-.8.2-1.8.7 0 1.3.5 1.6 1.2.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M307 118.8c1 .6 2-.2 2.3-.2a2.5 2.5 0 0 1-.8-1.2 6.8 6.8 0 0 1-.3-1.8c0-1.6.5-1.8.6-1.6a7 7 0 0 0 1.4-.8c.4-.3.7-.8.8-1.3a4.8 4.8 0 0 0-.2-1.9c-1.5 0-1.8.2-2.2.6a6.9 6.9 0 0 0-.3-1.5 4.6 4.6 0 0 0-.5-1.2 2 2 0 0 0-.6-.5c0 .4-.3.8-.6 1a6.4 6.4 0 0 0-.4-2 1.6 1.6 0 0 0-2.6-.8 6.4 6.4 0 0 0-1.6 1.5 2.2 2.2 0 0 1 .2-1.2 2 2 0 0 0-.8.2 4.6 4.6 0 0 0-1 .7 6.9 6.9 0 0 0-1.1 1.1c0-.6-.3-1-1.6-1.7a4.8 4.8 0 0 0-1.1 1.6 2.4 2.4 0 0 0-.1 1.4 7 7 0 0 0 .8 1.4c.1 0 .5.4-.4 1.7a6.8 6.8 0 0 1-1.2 1.4c-.4.3-.8.5-1.3.5.4.8.5 1.2 1.8 1.4-3 2-3.2 5.4-1 8.3.2-.5.5-1 .9-1.4a4 4 0 0 0 .8 2.5c.3.3.5 1.8.8 2.3l1 1s.3-1.3.9-1.5l2-.6a7.4 7.4 0 0 0 2-1.7l-.3 1.8c3.8-1.3 4.8-4 3.7-7.5"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#504416",
      d: "M299.6 114a7.8 7.8 0 0 1-.8 4l2.6 1 2.4.2c-.2-1 .8-3 1.2-3.6h-1.7l-.8-.8-1.5.3-1.4-1z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#fff",
      d: "M300 114.7a3 3 0 0 0 0 1.9l.7-1.6zm3.6 1.1-.2 1.7a3 3 0 0 0 1-1.6h-.8zM300 117a3 3 0 0 0-.9 1.6l.7.1zm3.2 1-.8 1.5.7.3a3 3 0 0 0 0-1.9zm-2.9-8.2c-.5 0-.8.1-.9.4-.1.5.3 1 1 1.3a1.3 1.3 0 0 0 1.6-.6c0-.6-.4-.8-1.1-1zm5.2 1.4c-.4 0-.6.2-.8.4a1.3 1.3 0 0 0 1 1.4c.9.3 1.3 0 1.5-.5.2-.5-.2-.9-1-1.1a3.2 3.2 0 0 0-.8-.2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#d1b948",
      d: "M300.3 109.6a1.4 1.4 0 0 0-.4 0 .8.8 0 0 0-.5.6c-.1.3 0 .6.1.8.2.4.5.5.8.6a1.4 1.4 0 0 0 1.8-.8.6.6 0 0 0-.3-.6 2.7 2.7 0 0 0-1-.5 2.4 2.4 0 0 0-.5 0zm0 .2.5.1.8.4a.4.4 0 0 1 .2.5 1.2 1.2 0 0 1-1.4.6 1.4 1.4 0 0 1-.7-.4.7.7 0 0 1-.2-.7.6.6 0 0 1 .4-.4zm5.2 1.3a1.6 1.6 0 0 0-.2 0 .6.6 0 0 0-.7.5 1.4 1.4 0 0 0 1.2 1.6 1.6 1.6 0 0 0 1 0c.2-.2.5-.4.6-.7a.8.8 0 0 0-.3-.8 2 2 0 0 0-.8-.4 3.3 3.3 0 0 0-.8-.2m0 .3.7.1c.3 0 .5.2.8.4l.1.6a.7.7 0 0 1-.5.4 1.4 1.4 0 0 1-.8 0 1.2 1.2 0 0 1-1-1.2c0-.3.2-.3.5-.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M300.4 108.6a1.2 1.2 0 0 0-1 .3c-.2.1-.2.6-.2.6h.6l.5.2 1.3.5h1.4l-1.2-.6c-.4-.2-.8-.9-1.4-1m6.6 2c-.4-.2-1 .1-1.5 0l-1.3-.1 1.2.8 1.4.2.6.2.4.2.2-.5a1.2 1.2 0 0 0-1-.8m-8 7.4c-1.4 3.2 3.8 4.8 4.6 1.3a10.5 10.5 0 0 1-4.6-1.3"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#806600",
      d: "M298.8 117.6v.3a2.6 2.6 0 0 0 0 2.3 2.6 2.6 0 0 0 5-.8v-.3h-.2a10.2 10.2 0 0 1-4.6-1.3l-.2-.1zm.2.5a13.3 13.3 0 0 0 4.5 1.2 3.1 3.1 0 0 1-1 1.7 3 3 0 0 1-2 .2 3.4 3.4 0 0 1-1.6-1.4 2.5 2.5 0 0 1 0-1.7z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M301.1 115.2a14.4 14.4 0 0 0-.8 6.7c1.6-1.6 2.4-4 2.9-6.1l-.5-.4a6.5 6.5 0 0 1-.3-.5 3.2 3.2 0 0 1-.7.3 2 2 0 0 1-.6 0z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M305 105.4a6 6 0 0 0-1.4.2 6.3 6.3 0 0 0-1.6 1.5 2.2 2.2 0 0 1 0-1.2c-.2 0-.4 0-.6.2a4.6 4.6 0 0 0-1.2.7 6.9 6.9 0 0 0-1 1c.6 0 1.7-1 2-.8.4 0 0 1 .5 1s.9-.6 1.5-1.1c.5-.5 1.2-.8 1.6-.7a2.4 2.4 0 0 1 .9 1.4c.2.8.4 1.6.8 1.8.3.2.6-.8 1-.7.4.2.6 1.6 1 1.9a6.9 6.9 0 0 0-.2-1.5 4.6 4.6 0 0 0-.6-1.2 2 2 0 0 0-.5-.5c0 .4-.4.8-.6 1a6.4 6.4 0 0 0-.5-2 6 6 0 0 0-1.1-1m-6.3 5.5c-.5.8.2 1.7 1.3 1.9l-.5 1 .7 1.2 1 .4 1.1-.4.7 1 1 .2 1.3-.8.5-.8h.8l.6-.4.2-.8c-.6.6-1.6.8-2.4.4a2 2 0 0 1-.4 1.3 1 1 0 0 1-1 .2 2.2 2.2 0 0 1-1.1-.9c-.5.2-.8.5-1.1.4a1.4 1.4 0 0 1-1-1 1.5 1.5 0 0 1 .4-1.3c-2.4-.7-1.6-1.3-2-1.6zm-1.2.2a18.8 18.8 0 0 1-1.8 2.6c-.4.3-.8.5-1.3.5.4.8.5 1.2 1.8 1.4-3 2-3.2 5.4-1 8.3.2-.5.5-1 .9-1.4a4 4 0 0 0 .8 2.5c.3.3.5 1.8.8 2.3l1 1s.3-1.3.9-1.5l2-.6a7.4 7.4 0 0 0 2-1.7l-.3 1.8c3.9-1.3 4.8-4 3.7-7.5 1 .6 2-.2 2.3-.2a2.5 2.5 0 0 1-.8-1.2 7.4 7.4 0 0 1-.3-1.8v-1.1l-.6 1.6a8 8 0 0 0 0 1.7 5.2 5.2 0 0 1-1.8-.8c.4 1.2.6 2.4.8 3.7 0 .8-.2 1.7-.5 2.5a6.6 6.6 0 0 1-1.6 1.7l.3-2.3-.3-2.8a15.7 15.7 0 0 1-.8 2.7l-1.2 2c.1-2 0-2.2-.2-2.9 0 0-.5 2.5-1.3 3.6a7.5 7.5 0 0 1-1.6.7 1.7 1.7 0 0 0-.7.6l-.6-1.7a19.8 19.8 0 0 1-1.2-2.2c-.3-1.2 1.2-3.6 1.2-3.6-.6 0-1.1.7-1.7 1.4a17.4 17.4 0 0 0-1.3 1.6 15.2 15.2 0 0 1-.5-2.2c0-.8.3-1.5.7-2.1.6-1 3.3-3 3.3-3a4.2 4.2 0 0 1-2.8 0l1.2-1.7a4.2 4.2 0 0 0 .5-1.9m5 1.1h-1.2v.5l.5.3.8 1 1.6-.5.3-.4a6.2 6.2 0 0 0-1.5-.8 2.4 2.4 0 0 0-.4 0z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M307 118.8c1 .6 2-.2 2.3-.2a2.5 2.5 0 0 1-.8-1.2 6.8 6.8 0 0 1-.3-1.8c0-1.6.5-1.8.6-1.6a7 7 0 0 0 1.4-.8c.4-.3.7-.8.8-1.3a4.8 4.8 0 0 0-.2-1.9c-1.5 0-1.8.2-2.2.6a6.9 6.9 0 0 0-.3-1.5 4.6 4.6 0 0 0-.5-1.2 2 2 0 0 0-.6-.5c0 .4-.3.8-.6 1a3.8 3.8 0 0 0-1.6-3c-1.3 0-2.1.7-3 1.7a2.2 2.2 0 0 1 0-1.2 2 2 0 0 0-.6.2 4.6 4.6 0 0 0-1 .7 6.9 6.9 0 0 0-1.1 1.1c0-.6-.3-1-1.6-1.7a4.8 4.8 0 0 0-1.1 1.6 2.4 2.4 0 0 0-.1 1.4 7 7 0 0 0 .8 1.4c.1 0 .5.4-.4 1.7a6.8 6.8 0 0 1-1.2 1.4c-.4.3-.8.5-1.3.5.4.8.5 1.2 1.8 1.4-3 2-3.2 5.4-1 8.3.2-.5.5-1 .9-1.4a4 4 0 0 0 .8 2.5c.3.3.5 1.8.8 2.3l1 1s.3-1.3.9-1.5l2-.6a7.4 7.4 0 0 0 2-1.7l-.3 1.8c3.8-1.3 4.8-4 3.7-7.5z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#806600",
      d: "M297.7 107.2a3.1 3.1 0 0 0-.5 1.6 6 6 0 0 0 .9 1.6l.5-2.2c-.1-.4-.8-1-.8-1zm2 2a.8.8 0 0 0-.3.2c-.2.1-.4.1-.4.4l.7-.2a.3.3 0 0 1 .2 0l1.2.6h1.9l-.3.8-.9.4-.4.4-.2.4v.6h.2a1 1 0 0 1 .8.9l.2.2a.5.5 0 0 0 .2.1h.4a1 1 0 0 1 1.2-.3h.1l.1-.1a1.3 1.3 0 0 0 .3-.6v-.4a7.2 7.2 0 0 0-.2-.4c0-.4-.3-1-.3-1l.1-.8a4.7 4.7 0 0 0 1.5 1.1l1.3.1c.2 0 .3 0 .3.2l.4.5a.8.8 0 0 0-.1-.8l-.5-.2-1.3-.1a3.8 3.8 0 0 1-1.4-1l-.2-.2-.1.2a2 2 0 0 0-.4 1.2l.4 1a5.8 5.8 0 0 1 .2.7 1 1 0 0 1-.2.3 2.2 2.2 0 0 0-1.5.4h-.1a2.5 2.5 0 0 0-1.2-1.3v-.3l.2-.1c0-.2.2-.3.3-.3.3-.3.8-.5.9-.8.2-.3.4-.6.4-1v-.3h-.3a3.4 3.4 0 0 1-1.6.1c-.4 0-.8-.4-1.2-.5a.8.8 0 0 0-.3 0zm-.9 1.4a1.5 1.5 0 0 0-.2 1.6c.2.4.6.7 1 .8v.1c-.2.3-.2.6-.2.8 0 .6.4 1 .8 1.3.3.3.8.5 1.2.4a1.7 1.7 0 0 0 .8-.2l.5.6c.4.2.8.4 1.3.3a1.8 1.8 0 0 0 1.6-1.4v-.2a1.5 1.5 0 0 0 1.4-.1 1.6 1.6 0 0 0 .6-1.5c-.3.3 0 .8-.8 1.3-.4.2-.8.2-1.1 0l-.4-.3v.9l-.3.5a1.6 1.6 0 0 1-1 .6 1.4 1.4 0 0 1-1-.3 1.8 1.8 0 0 1-.4-.7l-.2-.5-.2.3-.4.2-.5.2c-.3 0-.7 0-.8-.3a2 2 0 0 1-.7-1.2v-.5c0-.2.1-.3.3-.4l.1-.3h-.4a1.4 1.4 0 0 1-1-.5c-.5-.7 0-1 0-1.5m11.4.2s-1 0-1.2.4a8.3 8.3 0 0 0-.8 2 6 6 0 0 0 1.6-.7c.3-.6.4-1.1.4-1.6z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#2b2200",
      d: "M300.8 110a.5.5 0 0 0-.2 1.1.5.5 0 1 0 .1-1zm5.1 1.6a.5.5 0 0 0-.1 1 .5.5 0 1 0 .1-1"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M281 127.6c-.5.2-1.2-.2-2.5 1a2.4 2.4 0 0 1 2.2.8 1 1 0 0 0 .8-.5 1 1 0 0 0-.5-1.3zm32.3 1.5c-.5.2-1.1-.2-2.5 1a2.4 2.4 0 0 1 2.2.9c.4 0 .8-.3.8-.6a1 1 0 0 0-.5-1.3zm-34.7 1.8c-.4.3-1.2.2-2 1.8a2.4 2.4 0 0 1 2.4 0c.4-.1.6-.5.6-.8a1 1 0 0 0-1-1zm35.2 2.5c-.3.4-1 .4-1.8 2a2.4 2.4 0 0 1 2.4-.2 1 1 0 0 0 .6-.8 1 1 0 0 0-1.2-1zm-32.8 1.4a1.2 1.2 0 0 0-.5.2c-.2.4-.9.8-.8 2.5a2.4 2.4 0 0 1 2-1.2 1 1 0 0 0 .1-1 1 1 0 0 0-.8-.5zm70.2.2h-.4c-.2.6-1 .8-1 2.6a2.4 2.4 0 0 1 2.1-1c.3-.3.3-.7.3-1a1 1 0 0 0-1-.6zm-33.4 1.2a1.2 1.2 0 0 0-.6.3c0 .5-.8.8-.5 2.6a2.4 2.4 0 0 1 2-1.4 1 1 0 0 0 0-1 1 1 0 0 0-.9-.5zm41.6.2a1 1 0 0 0-1 .6c.2.4-.2 1 .9 2.5a2.4 2.4 0 0 1 1-2.1.9.9 0 0 0-.5-1 1.2 1.2 0 0 0-.4 0zm-4.4.5a1.1 1.1 0 0 0-.8.4c0 .5-.6 1 .1 2.6a2.4 2.4 0 0 1 1.6-1.7c.1-.4 0-.8-.2-1a1 1 0 0 0-.8-.3z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M303.1 158.7a5 5 0 0 1-1.7-.3 4.6 4.6 0 0 1-1.2-1.4h-2a5.4 5.4 0 0 1-1.6-.8 3.1 3.1 0 0 0 1.6-.8 8.2 8.2 0 0 1-1.9-.3 9 9 0 0 1-1.6-1c.6-.2 1.2-.1 1.6-.7a7 7 0 0 1-1.7-.2 6.4 6.4 0 0 1-1.5-1 2.3 2.3 0 0 0 1.8-.7 6.3 6.3 0 0 1-1.8-.1 9 9 0 0 1-1.7-1.2 4 4 0 0 0 1.8-.5l-.4-.8c-.4-1-1.4-.7-2-.9a1.8 1.8 0 0 1-1.1-1.4c0-.7.3-1.7 1.8-1.6-.8-1 0-2 .9-2.4.8-.2 1.5-.1 2 1.2a4.2 4.2 0 0 1 1.2-.7 1.1 1.1 0 0 1 1.4.6v.9c-.3.4-.8.7-.8 1.3a3.7 3.7 0 0 0 .4 1.9s3 2.4 4.4 3.7c.8.7 2 2.2 2 2.2h3l.3 5z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M294.8 142c.5.6.7 1.3.5 2a.8.8 0 0 0 .8.2.8.8 0 0 0 .5-1c-.4-.2-.4-.8-1.8-1.1zm-3.4.5a3.5 3.5 0 0 0-.8 0 2 2 0 0 1 1.2 1.6.8.8 0 0 0 .8-.1.8.8 0 0 0 0-1.1c-.3 0-.5-.4-1.2-.4zm-1 3.2a3 3 0 0 0-2 .6 2 2 0 0 1 1.7.8c.2 0 .5 0 .6-.4a.8.8 0 0 0-.3-1z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M318 161c-.6-.1-1.3-.8-1.8-.8a1.6 1.6 0 0 0-1.3.8 1.4 1.4 0 0 0 .3 1.2l1 .6a3.4 3.4 0 0 0-.7 1.2c0 .3.1.6.4.9.3.4.4.5.9.6l1.1-.1c0 .3 0 .6.2.8a1.8 1.8 0 0 0 1.6.8c.3.1.7 0 .9-.4.2-.3.1-1 .5-1.4l1.4-1.3c.6.4.6.9.5 1.5a5.3 5.3 0 0 0 1.2-1c.2-.4.4-.9.4-1.4.5.4.8 1 .6 1.6a6 6 0 0 0 1.2-1 6 6 0 0 0 .6-1.4c.4.4.6 1 .4 1.6a4.8 4.8 0 0 0 1.3-1.2l.3-1.2c1.3 0 2.1-.4 2.1-1 .1-.5-.4-1-1.4-1.2a5.4 5.4 0 0 1-.5-1 1.4 1.4 0 0 1 0-.8 3.7 3.7 0 0 1 1.2-1.5 14 14 0 0 1 2.2-1.3l-.5-2.1-5-.8-5.7 1.4c1 .4 3.4 2 3.2 2.7 0 .2-.5.4-.8.8-.2.1 0 .4.1.8.3.2.8.3 1 .6a.6.6 0 0 1 0 .8c-.3.5-1.6.7-2.3 1-1 .4-3 1.6-3 1.6a4.2 4.2 0 0 1-1.7-.4z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M328 154.2s0 1.9-.7 2.3c-.4.2-.8.3-1.2.1a1.4 1.4 0 0 1-.7-.8l-.2-.8a7.2 7.2 0 0 0-1.8-.5c-1 0-1.8.1-2.7.5a6.2 6.2 0 0 1 2-2.5l3-.3 2.4 2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M333.8 142.2c.8 0 2.2-.4 2.7-1l.8-1a4 4 0 0 1-2.3 3.6 7.3 7.3 0 0 1-4 .5 15.1 15.1 0 0 1-2.4-.5c1 1 .5 1.8-.6 2.4 0 0 .2-1-.2-1.2-.6-.4-1.4 0-2.1.5-.6.3-1.2.6-2 .6a5.1 5.1 0 0 1-2.2-.4c-.5-.3-1.4-1-1.7-1-.8.2-2 .3-2.4 1v1a2.5 2.5 0 0 0 1.6 1.1c1.8.5 3.6.5 5.3.2 2-.3 4.2-1 6.1-1.4 2-.4 4.3-1 5.8-1.5a18 18 0 0 1 5.6-.6c3.2 0 4.4 2 4.3 4.1-.2 2.2-2.2 3.2-3.9 3.8-3 1.1-7.2.5-9.7.4l1.3 1.2c.4.4.6 1.4 1.2 1.6.8.2 2-.3 2.8-.4a29.3 29.3 0 0 1 3.2 0 2 2 0 0 1 .8-.6h.8c.3.1.5.6.4 1.5l.6.5h1.1l1 .6a5.6 5.6 0 0 0-.9.4 2.2 2.2 0 0 0-.5.6l1.3.1.8.8a1.6 1.6 0 0 0-.8.1 4 4 0 0 0-.6.6s1-.1 1.5.2l.6.8a3.4 3.4 0 0 0-.8 0l-.5.4a3.6 3.6 0 0 1 1 .9c.2.4.3.8.3 1.3a5 5 0 0 0-.6-.5 1.6 1.6 0 0 0-.6-.1l.2 1.8c0 .4.6.8.7 1.2.2.3 0 .7-.2 1-.2.4-.8.6-1.3.4a2 2 0 0 1-.7-.4l-.4.8c-.4.2-.5.2-1 .2a1 1 0 0 1-.7-.4 3.7 3.7 0 0 1-.5-1.2l-1 .3c-.4 0-.8-.3-1-.6a1.4 1.4 0 0 1 .2-1.3c.3-.4 1-.4 1.5-.6a4 4 0 0 0 1-1 25.3 25.3 0 0 1-2.5-2.4l-1-1.6s-2 .8-2.9.8a13.6 13.6 0 0 1-4 0c-3.1 0-5.1-5-7.8-6.2a2.6 2.6 0 0 0-2.1 0c-3.2.7-6.6 5.1-9.6 6a24 24 0 0 1-4 .6 4.3 4.3 0 0 1-.9 1.3 3.8 3.8 0 0 1-1.6.3 7.2 7.2 0 0 1-.6 1.8 4.4 4.4 0 0 1-1.3 1 3 3 0 0 0 0-1.7 7 7 0 0 1-1 1.4 7.2 7.2 0 0 1-1.3 1 2.4 2.4 0 0 0 0-1.6 6.2 6.2 0 0 1-.8 1.3 5.2 5.2 0 0 1-1.3.8 2.2 2.2 0 0 0 0-1.7 5.5 5.5 0 0 1-.7 1.3 7.2 7.2 0 0 1-1.6 1 3.4 3.4 0 0 0 .2-1.8h-.8c-1 0-1 1-1.4 1.5a1.5 1.5 0 0 1-1.5.3c-.6-.2-1-1.1-.4-2.3a1.6 1.6 0 0 1-1.9-1.6c0-.8.3-1.5 1.5-1.5a3.7 3.7 0 0 1 0-1c0-.6.4-1 .8-.9.4 0 .6.2.8.4.3.3.4.8.8 1.2a3.2 3.2 0 0 0 1.7.4 29.4 29.4 0 0 1 4-2.1 31 31 0 0 1 3.1-.8v-7c.7 0 1.4.2 2 0 2.1.2 4.2.5 6.2.9l3.2-.3s5.4-1 7.8-1.2c1.3-.3 2.6-.3 3.9-.3 1.9.2 3.6.8 5.4.8 1.4.3 2.7.3 4 .3 2.3-.2 6.2 0 7.4-2.4a2 2 0 0 0-2.3-2.6c-.4.2-1 .5-1 1 0 .3 0 .6.2.8.1.3.4.5.7.8a2 2 0 0 1-1.4-.4 5.2 5.2 0 0 1-.9-1.6 1.8 1.8 0 0 0-.3 1.2c0 .4.1.8.4 1.2a2.4 2.4 0 0 1-1.5-.7 5.8 5.8 0 0 1-.6-1.6c-.2.3-.4.7-.4 1.1 0 .5.1 1 .3 1.4a3 3 0 0 1-1.4-1 5.7 5.7 0 0 1-.5-1.6l-5.6 1.3-6 1.3c-3 .4-5.3.2-7.2-.7a2.6 2.6 0 0 1-1.6-2 2.7 2.7 0 0 1 .5-2.1 6 6 0 0 1 3.2-2 40.7 40.7 0 0 1 5.5-1.2 17.6 17.6 0 0 1 6 .3c.8.3 1.5 0 2-.4a1 1 0 0 0 .2-1.4c.5 0 .9.5 1 1a2.5 2.5 0 0 1 0 1.1"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M337.4 140.2a9.2 9.2 0 0 1-1.6 2.1 6.8 6.8 0 0 1-3 1.1 10.7 10.7 0 0 1-3-.2 13.3 13.3 0 0 1-2.8-.9 5.6 5.6 0 0 1 .8 1.8 3.8 3.8 0 0 0-1.6-.1l-1.6.8c-.8.2-1.8 0-2.4-.2-.8-.1-1-.4-1.7-.3l-.7.3 2.1 1.2 2 .3 1.3-.3 1.4-.8 1.2-.1.3.5v.8l.8-.8.1-.5-.2-1 1.6.3 1.8.2 2-.4 1.8-.8.9-1.1zm5.2 5.4a2.6 2.6 0 0 0-1.3.5 2.2 2.2 0 0 0-.6 1.7 16.4 16.4 0 0 1-.8-2.1c-.8.8-.8 1.8-1 2.7a15.4 15.4 0 0 1-.8-2.5 4.8 4.8 0 0 0-1.4 2.3 4.8 4.8 0 0 1-.5-2h-.2c-2.6.4-8.2 2.3-12.6 2.7-2.4.2-5.2 0-6.7-1a3 3 0 0 1-1.3-2l-.2 1 .8 1.3 1.6 1 3 .7 3.4-.4 2-.1 10-2.4v1.3l.8.8.8.5-.2-1.1v-.8l.4-.5.5 1.4.7.6 1 .2-.5-.7v-.9l.3-.8.5 1.3.5.5h1.3l-.8-.7-.2-.8.6-.7 1.1-.3 1 .4.6.7.2 1-.1.8c1.7-1.6 0-3.6-2-3.6zm3.4 1.6a4.5 4.5 0 0 1-1.1 2.8c-3 3.3-9.8 2.2-13 1.1l-1.4-.2a15.5 15.5 0 0 0-.8-.3 8 8 0 0 0-2-.3 21.2 21.2 0 0 0-3.9.3c-2.4.2-7.8 1.2-7.8 1.2l-3.2.3a45.6 45.6 0 0 0-6.2-.8 9.5 9.5 0 0 1-2 0v1.1l2.8.6h-.4l-1.9 3.6-.4-1.6-.1 2.5-.4.7-2.4.6-2.4 1-1.8 1.4-1.8-.5-.8-1.3c.1.7.4 1.3.7 2 .5.5 2 .6 2 .6a30 30 0 0 1 3.3-2l1.6-.6a4.4 4.4 0 0 0 1.6 1.2c0-1.6 1-1.6 2.4-2.4v1s2.7-1 3.4-1.8a4.9 4.9 0 0 0 1.1-1.9 5 5 0 0 0 .1-2.1 62.6 62.6 0 0 0 1.8 0c2.7-.1 5.6-1.3 8.2-1.6 2-.4 4.5-.8 6.4-.4 1.6.3 2.2 1 3.6 2 1.2.8 2.4 3.2 4 3.2 0 0 .9 0 1.4-.2.8 0 1.3-.4 2-.5a12.2 12.2 0 0 1 2.4.2c.7-1 1-1 1.2-.8.4.2.4.8.1 1.3a2.2 2.2 0 0 0 1.9.8c-.4.4-.8.8-1 1.3a2.6 2.6 0 0 1 1.7.3 3.3 3.3 0 0 0-.8 1.2 5 5 0 0 1 1.6.3c-.4.2-.8.4-.8.8l1.3 1c-.6 0-.8 0-1 .3l.9 1.7-.2-1.6.6.2c.2 0 .5.2.6.5a3.4 3.4 0 0 0-.2-1.3 3.6 3.6 0 0 0-1-.9l.4-.3h.8a6.4 6.4 0 0 0-.6-.9c-.4-.3-1.5-.2-1.5-.2a4 4 0 0 1 .6-.6 1.6 1.6 0 0 1 .8 0 2.6 2.6 0 0 0-.8-.9 4.2 4.2 0 0 0-1.3-.1l.5-.6a5.6 5.6 0 0 1 .9-.4 5.8 5.8 0 0 0-1-.6h-1.1a1.2 1.2 0 0 1-.6-.5c.1-.8-.1-1.3-.4-1.5a1.3 1.3 0 0 0-.8 0c-.4.1-.7.4-.8.7a29.3 29.3 0 0 0-3.2 0c-.8 0-2 .5-2.8.3-.6-.2-.8-1.2-1.2-1.6l-1.3-1.2h2.9l3 .2h1.8c2.2-.6 4.7-1.2 5.7-3.8v-2zm-22.4 5.1a6 6 0 0 0-2.4.5 29.8 29.8 0 0 0-5.1 3.5 25 25 0 0 1-3.2 2 18.4 18.4 0 0 1-4.6.6s-.4 1.6-1 1.9c-.4.3-1.5-.3-1.5-.3l-.1 1.3a5.8 5.8 0 0 1-.5 1.4 4.5 4.5 0 0 0-.3-1 5.2 5.2 0 0 0-.8-1 9.4 9.4 0 0 1-.4 1.4l-.9 1.4a5.2 5.2 0 0 0-.2-.8 8.3 8.3 0 0 0-.8-1.2 13.4 13.4 0 0 1-.4 1.4l-.5 1a4.8 4.8 0 0 0-.2-.5 11.8 11.8 0 0 0-.8-1.2l-.7 1.5-.6.8a2.6 2.6 0 0 0-.2-1.2 1.2 1.2 0 0 0-1-.3c-1 .2-1.5 1.2-2.1 2.1-.2.2-.5.3-.4 0a.8.8 0 0 0 0-.7.6.6 0 0 0-.7-.3c-.4.3.8-1.2.8-1.2a8.6 8.6 0 0 1-1.6-.1c-.4-.1.1 0 .1-.8 0-.9-.8-.8-.5-.8a2.3 2.3 0 0 1 1.3.1s-.4-.4-.2-.8c0-.1.5-.4.6-.8a1.1 1.1 0 0 0-.5-1c-.1.4-.8.2-.8.7v1.1c-1.2 0-1.5.7-1.5 1.5a1.6 1.6 0 0 0 2 1.6c-.9 1.2-.3 2 .3 2.3a1.5 1.5 0 0 0 1.5-.3c.5-.5.5-1.5 1.4-1.5h.8a4 4 0 0 1-.2 1.9 7.2 7.2 0 0 0 1.6-1l.8-1.4a2.2 2.2 0 0 1 0 1.7 5.2 5.2 0 0 0 1.2-.8 6.2 6.2 0 0 0 .8-1.4 2.4 2.4 0 0 1 0 1.7 7.2 7.2 0 0 0 1.3-1 7 7 0 0 0 1-1.4 3 3 0 0 1 0 1.7 4.4 4.4 0 0 0 1.3-1 7.2 7.2 0 0 0 .6-1.7c.6 0 1-.1 1.6-.4a4.3 4.3 0 0 0 .8-1.3 24 24 0 0 0 4-.5c3.2-1 6.5-5.4 9.7-6.2a2.6 2.6 0 0 1 2 0c2.8 1.3 4.9 6.4 7.8 6.4 1.4 0 2.1.3 4 0l3-.9 1 1.6a25.3 25.3 0 0 0 2.4 2.4 3.5 3.5 0 0 1-1 1c-.3.2-1.1.2-1.4.6a1.4 1.4 0 0 0-.1 1.3c.2.3.5.5 1 .6l.9-.3a3.7 3.7 0 0 0 .4 1.2c.2.3.6.4.8.5.4 0 .8 0 1-.4l.4-.8c.2.3.4.4.7.5a1.3 1.3 0 0 0 1.3-.5c.3-.3 0-1.3-.1-1.7a7.8 7.8 0 0 0 0 1.2.8.8 0 0 0-1.5 0 1.4 1.4 0 0 1-.7-.8l-.2 1c-.1.2 0 .6-.3.6 0-1-.7-1-1.2-.8a2 2 0 0 1 0-1 7.2 7.2 0 0 1-1 .5c-.3 0 0-.2-.2-.5 0-.3-.6-.2-.4-.3l1.5-.8a5 5 0 0 0 1-1.4 25.6 25.6 0 0 1-2.5-2.4l-1.5-2.4a26.2 26.2 0 0 1-4.8 1 7.4 7.4 0 0 1-3.4-.4c-1.8-.9-2.8-3.1-4.3-4.3-1-.8-1.9-1.7-3-1.9a2.9 2.9 0 0 0-.4 0"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M333.8 142.2c.8 0 2.2-.4 2.7-1l.8-1a4 4 0 0 1-2.3 3.6 7.3 7.3 0 0 1-4 .5 15.1 15.1 0 0 1-2.4-.5c1 1 .5 1.8-.6 2.4 0 0 .2-1-.2-1.2-.6-.4-1.4 0-2.1.5-.6.3-1.2.6-2 .6a5.1 5.1 0 0 1-2.2-.4c-.5-.3-1.4-1-1.7-1-.8.2-2 .3-2.4 1v1a2.5 2.5 0 0 0 1.6 1.1c1.8.5 3.6.5 5.3.2 2-.3 4.2-1 6.1-1.4 2-.4 4.3-1 5.8-1.5a18 18 0 0 1 5.6-.6c3.2 0 4.4 2 4.3 4.1-.2 2.2-2.2 3.2-3.9 3.8-3 1.1-7.2.5-9.7.4l1.3 1.2c.4.4.6 1.4 1.2 1.6.8.2 2-.3 2.8-.4a29.3 29.3 0 0 1 3.2 0 2 2 0 0 1 .8-.6h.8c.3.1.5.6.4 1.5l.6.5h1.1l1 .6a5.6 5.6 0 0 0-.9.4 2.2 2.2 0 0 0-.5.6l1.3.1.8.8a1.6 1.6 0 0 0-.8.1 4 4 0 0 0-.6.6s1-.1 1.5.2l.6.8a3.4 3.4 0 0 0-.8 0l-.5.4 1 .9c.2.4.3.8.3 1.3a5 5 0 0 0-.6-.5 1.6 1.6 0 0 0-.6-.1l.2 1.8c0 .4.6.8.7 1.2.2.3 0 .7-.2 1-.2.4-.8.6-1.3.4a2 2 0 0 1-.7-.4l-.4.8a1 1 0 0 1-1 .3 1.2 1.2 0 0 1-.7-.5 3.7 3.7 0 0 1-.5-1.2l-1 .3c-.4 0-.8-.3-1-.6a1.4 1.4 0 0 1 .2-1.3c.3-.4 1-.4 1.5-.6a4 4 0 0 0 1-1 25.3 25.3 0 0 1-2.5-2.4l-1-1.6s-2 .8-2.9.8a13.6 13.6 0 0 1-4 0c-3.1 0-5.1-5-7.8-6.2a2.6 2.6 0 0 0-2.1 0c-3.2.7-6.6 5.1-9.6 6a24 24 0 0 1-4 .6 4.3 4.3 0 0 1-.9 1.3 3.8 3.8 0 0 1-1.6.3 7.2 7.2 0 0 1-.6 1.8 4.4 4.4 0 0 1-1.3 1 3 3 0 0 0 0-1.7 7 7 0 0 1-1 1.4 7.2 7.2 0 0 1-1.3 1 2.4 2.4 0 0 0 0-1.6 6.2 6.2 0 0 1-.8 1.3 5.2 5.2 0 0 1-1.3.8 2.2 2.2 0 0 0 0-1.7 5.5 5.5 0 0 1-.7 1.3 7.2 7.2 0 0 1-1.6 1 3.4 3.4 0 0 0 .2-1.8h-.8c-1 0-1 1-1.4 1.5a1.5 1.5 0 0 1-1.5.3c-.6-.2-1-1.1-.4-2.3a1.6 1.6 0 0 1-1.9-1.6c0-.8.3-1.5 1.5-1.5a3.7 3.7 0 0 1 0-1c0-.6.4-1 .8-.9.4 0 .6.2.8.4.3.3.4.8.8 1.2a3.2 3.2 0 0 0 1.7.4 29.4 29.4 0 0 1 4-2.1 31 31 0 0 1 3.1-.8v-7c.7 0 1.4.2 2 0 2.1.2 4.2.5 6.2.9l3.2-.3s5.4-1 7.8-1.2c1.3-.3 2.6-.3 3.9-.3 1.9.2 3.6.8 5.4.8 1.4.3 2.7.3 4 .3 2.3-.2 6.2 0 7.4-2.4a2 2 0 0 0-2.3-2.6c-.4.2-1 .5-1 1 0 .3 0 .5.2.8l.7.8a2.7 2.7 0 0 1-1.6-.4 3.8 3.8 0 0 1-.7-1.6 1.8 1.8 0 0 0-.3 1.2c0 .4.1.8.4 1.2a2.4 2.4 0 0 1-1.5-.7 5.8 5.8 0 0 1-.6-1.6c-.2.3-.4.7-.4 1.1 0 .5.1 1 .3 1.4a3 3 0 0 1-1.4-1 5.7 5.7 0 0 1-.5-1.6l-5.6 1.3-6 1.3c-3 .4-5.3.2-7.2-.7a2.6 2.6 0 0 1-1.6-2 2.7 2.7 0 0 1 .5-2.1 6 6 0 0 1 3.2-2 40.7 40.7 0 0 1 5.5-1.2 17.6 17.6 0 0 1 6 .3c.8.3 1.5 0 2-.4a1 1 0 0 0 .2-1.4c.5 0 .9.5 1 1 .2.3.1.7 0 1.1z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M310.2 152.2c.8.4 1.6-.2 1.8-.3a2 2 0 0 1-.6-.8 5.4 5.4 0 0 1-.3-1.6c0-1.2.5-1.3.5-1.3a5.6 5.6 0 0 0 1.1-.5c.3-.3.6-.7.7-1.1a3.8 3.8 0 0 0-.2-1.5c-1.2 0-1.5 0-1.8.4a5.5 5.5 0 0 0-.2-1.2 3.7 3.7 0 0 0-.5-1 1.6 1.6 0 0 0-.4-.3c0 .3-.2.6-.4.8a5 5 0 0 0-.5-1.6 1.4 1.4 0 0 0-2-.7 5 5 0 0 0-1.2 1.2 1.8 1.8 0 0 1 0-1 1.6 1.6 0 0 0-.5.2 3.7 3.7 0 0 0-.9.6 5.6 5.6 0 0 0-.8.9c0-.5-.2-.8-1.3-1.4a4 4 0 0 0-.9 1.2 1.8 1.8 0 0 0-.1 1.2l.7 1.1s.4.4-.3 1.5a5.4 5.4 0 0 1-1 1 2 2 0 0 1-1 .4c.2.8.3 1 1.3 1.2-2.4 1.6-2.5 4.3-.8 6.6l.8-1.2c0 .8.3 1.5.7 2 .2.3.3 1.6.6 2l.7.7s.4-1 .8-1.1l1.6-.5a6 6 0 0 0 1.6-1.5l-.2 1.6c3.1-1.2 3.8-3.2 3-6"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#504416",
      d: "M304.2 148.3a6.2 6.2 0 0 1-.6 3.1l2 .8 2 .3c-.2-.8.6-2.4 1-3h-1.5l-.6-.6-1.1.3-1.2-.8z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#fff",
      d: "M304.6 148.8a2.4 2.4 0 0 0 0 1.5l.5-1.2zm2.8 1-.1 1.3c.3-.4.6-.8.7-1.3zm-2.8 1a2.4 2.4 0 0 0-.8 1.2h.6l.2-1.3zm2.5.6-.6 1.2.5.3a2.4 2.4 0 0 0 0-1.5zm-2.3-6.6c-.4 0-.6 0-.7.4-.1.4.1.8.8 1a1 1 0 0 0 1.2-.5c.1-.4-.3-.7-.8-.8a2 2 0 0 0-.5-.1m4.2 1.2c-.4 0-.6 0-.7.3a1 1 0 0 0 .8 1.1c.7.2 1.1 0 1.2-.4.2-.4-.1-.8-.8-1a2.6 2.6 0 0 0-.5 0"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#d1b948",
      d: "M304.8 144.8a1.1 1.1 0 0 0-.3 0 .6.6 0 0 0-.5.5.8.8 0 0 0 .2.6c.1.3.4.4.6.5a1.1 1.1 0 0 0 1.4-.6.6.6 0 0 0-.2-.6 2.2 2.2 0 0 0-.8-.4 2 2 0 0 0-.4 0m0 .2h.4l.6.4c.2 0 .3.1.2.3-.2.5-.7.6-1.1.5a1 1 0 0 1-.6-.4.6.6 0 0 1-.1-.5.4.4 0 0 1 .3-.3zm4.2 1h-.2a.6.6 0 0 0-.6.3 1.1 1.1 0 0 0 1 1.3h.7a.8.8 0 0 0 .5-.6.6.6 0 0 0-.2-.5 1.5 1.5 0 0 0-.6-.4 2.6 2.6 0 0 0-.6-.2zm0 .2h.5c.3 0 .4.2.7.4a.4.4 0 0 1 0 .4.6.6 0 0 1-.4.4h-.6a1 1 0 0 1-.8-1c0-.2.2-.2.4-.2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "M304.8 144a1 1 0 0 0-.8.2v.4h.3l.5.2 1 .5 1.2-.1-1-.5c-.4-.1-.7-.7-1.2-.8zm5.4 1.5H308l1 .6 1 .1.6.2.3.2.1-.4a1 1 0 0 0-.8-.7m-6.5 6c-1 2.6 3.1 4 3.7 1a8.4 8.4 0 0 1-3.7-1"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#806600",
      d: "M303.6 151.2v.2a2 2 0 0 0 0 1.8 2.2 2.2 0 0 0 4-.6v-.3h-.2a8.2 8.2 0 0 1-3.6-1zm.2.3a10.6 10.6 0 0 0 3.6 1 2.5 2.5 0 0 1-.8 1.4 2.6 2.6 0 0 1-1.6.1 2.7 2.7 0 0 1-1.3-1 2 2 0 0 1 0-1.5z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M305.4 149.2a11.6 11.6 0 0 0-.6 5.4 11.5 11.5 0 0 0 2.4-5l-.5-.2a5.2 5.2 0 0 1-.2-.4l-.6.2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      d: "m308.6 141.4-1.2.1a5 5 0 0 0-1.2 1.2 1.8 1.8 0 0 1 0-1 1.6 1.6 0 0 0-.5.2 3.7 3.7 0 0 0-1 .6 5.6 5.6 0 0 0-.8.8c.4 0 1.3-.8 1.6-.7.3 0 .1.8.4.8.3.1.7-.4 1.2-.8.4-.4 1-.7 1.2-.6.4.2.7.6.8 1.1.2.7.3 1.4.6 1.5.3.1.5-.7.8-.5.4 0 .5 1.3.9 1.4a5.5 5.5 0 0 0-.2-1.2 3.7 3.7 0 0 0-.5-1 1.6 1.6 0 0 0-.4-.3c0 .3-.3.6-.5.8a5 5 0 0 0-.4-1.6 4.7 4.7 0 0 0-.8-.8m-5 4.4c-.5.7 0 1.3.9 1.6l-.3.8.4 1 1 .2.8-.3.6.8.8.2 1-.7.4-.7h.6l.5-.2.3-.7a1.8 1.8 0 0 1-2.1.3 1.6 1.6 0 0 1-.3 1 .8.8 0 0 1-.8.2 1.8 1.8 0 0 1-.8-.7c-.4.2-.8.4-1 .3a1.1 1.1 0 0 1-.8-.8 1.2 1.2 0 0 1 .3-1c-1.8-.5-1.2-1.1-1.6-1.3zm-1 .2a15.1 15.1 0 0 1-1.6 2 2 2 0 0 1-1 .4c.3.8.4 1 1.4 1.2-2.4 1.6-2.5 4.3-.8 6.6l.8-1.2c0 .8.3 1.5.7 2 .2.3.3 1.6.6 2l.7.7s.4-1 .8-1.1l1.6-.5a6 6 0 0 0 1.6-1.5l-.2 1.6c3.1-1.2 3.8-3.2 3-6 .8.4 1.6-.2 1.8-.3a2 2 0 0 1-.6-.8 6 6 0 0 1-.3-1.6v-.8l-.5 1.3a6.4 6.4 0 0 0 0 1.3 4.2 4.2 0 0 1-1.4-.7l.6 3c0 .7-.1 1.4-.4 2a5.3 5.3 0 0 1-1.2 1.4l.2-1.8-.3-2.3a12.6 12.6 0 0 1-.7 2.2l-1 1.6c.2-1.6.2-1.7 0-2.4a9 9 0 0 1-1.1 2.9 6 6 0 0 1-1.2.6 1.4 1.4 0 0 0-.6.5l-.5-1.4a16 16 0 0 1-1-1.8c-.2-.9 1-2.8 1-2.8-.4 0-.8.5-1.3 1.1l-1.1 1.3a12.2 12.2 0 0 1-.4-1.8 3.4 3.4 0 0 1 .5-1.6 16.5 16.5 0 0 1 2.7-2.6 3.4 3.4 0 0 1-2.3.1l1-1.3c.3-.5.5-1 .5-1.6zm4 .8h-1v.5l.4.1.6.8 1.4-.4.2-.3a5 5 0 0 0-1.2-.6 2 2 0 0 0-.4 0z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M310.2 152.2c.8.4 1.6-.2 1.8-.3a2 2 0 0 1-.6-.8 5.4 5.4 0 0 1-.3-1.6c0-1.2.5-1.3.5-1.3a5.6 5.6 0 0 0 1.1-.5c.3-.3.6-.7.7-1.1a3.8 3.8 0 0 0-.2-1.5c-1.2 0-1.5 0-1.8.4a5.5 5.5 0 0 0-.2-1.2 3.7 3.7 0 0 0-.5-1 1.6 1.6 0 0 0-.4-.3c0 .3-.2.6-.4.8a2 2 0 1 0-3.7-1 1.8 1.8 0 0 1 0-1 1.6 1.6 0 0 0-.5.1 3.7 3.7 0 0 0-.9.6 5.6 5.6 0 0 0-.8.9c0-.5-.2-.8-1.3-1.4a4 4 0 0 0-.9 1.2 1.8 1.8 0 0 0-.1 1.2l.7 1.1s.4.4-.3 1.5a5.4 5.4 0 0 1-1 1 2 2 0 0 1-1 .4c.2.8.3 1 1.3 1.2-2.4 1.6-2.5 4.3-.8 6.6l.8-1.2c0 .8.3 1.5.7 2 .2.3.3 1.6.6 1.9l.7.8s.4-1 .8-1.1l1.6-.6a6 6 0 0 0 1.6-1.4l-.2 1.6c3.1-1.2 3.8-3.2 3-6z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#806600",
      d: "M302.7 142.9a2.5 2.5 0 0 0-.5 1.2 4.8 4.8 0 0 0 .8 1.3c.2-.6.4-1.2.4-1.8 0-.3-.7-.8-.7-.8zm1.6 1.6a.6.6 0 0 0-.2 0c-.2.1-.3.1-.4.5.2 0 .4-.1.5-.3a.3.3 0 0 1 .3 0l1 .5a3.8 3.8 0 0 0 1.4 0l-.2.6-.7.4-.2.3a.8.8 0 0 0-.3.3v.6h.1c.4.1.6.4.6.8h.1l.2.1h.5a.8.8 0 0 1 1-.2v-.1l.3-.4v-.3a5.8 5.8 0 0 0-.1-.4c0-.3-.4-.8-.4-.8 0-.3 0-.5.2-.7.3.4.8.7 1.2.8.3.2.7.2 1 .2h.2l.4.6a.7.7 0 0 0 0-.7l-.5-.1-1-.1a3 3 0 0 1-1.1-.8l-.2-.2-.2.2a1.6 1.6 0 0 0-.1 1l.2.7a5 5 0 0 1 .1.6.8.8 0 0 1 0 .2 1.8 1.8 0 0 0-1.3.4 2 2 0 0 0-1-1 .8.8 0 0 1 0-.3l.1-.1a6 6 0 0 1 .3-.3l.7-.5.3-.9v-.2h-1.6c-.2 0-.5-.3-.9-.3a.6.6 0 0 0-.2 0zm-.8 1a1.2 1.2 0 0 0-.1 1.3c.2.3.4.6.8.6v.2a1.6 1.6 0 0 0-.1.6c0 .4.2.8.5 1 .4.2.7.4 1 .4a1.4 1.4 0 0 0 .7-.2l.4.4c.3.3.7.4 1 .4a1.4 1.4 0 0 0 1.3-1.2v-.1c.4 0 .8 0 1.2-.2.3-.2.4-.7.4-1.1-.3.2 0 .6-.6 1h-.9l-.3-.3v.7a1.6 1.6 0 0 1-.2.4 1.4 1.4 0 0 1-1 .5l-.6-.1a1.4 1.4 0 0 1-.4-.6v-.4l-.3.2a1.6 1.6 0 0 1-.3.2h-.4a1 1 0 0 1-.7-.2 1.6 1.6 0 0 1-.6-.8l.1-.5.2-.3.1-.2h-.3a1.1 1.1 0 0 1-.8-.5c-.4-.5 0-.8 0-1.2zm9.2.2s-.8 0-1 .3a6.6 6.6 0 0 0-.6 1.7 4.8 4.8 0 0 0 1.3-.7 2.4 2.4 0 0 0 .3-1.3"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#2b2200",
      d: "M305.1 145.1a.4.4 0 0 0 0 .8.4.4 0 1 0 0-.8m4.2 1.2a.4.4 0 0 0-.1.8.4.4 0 1 0 0-.8z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M293.8 159.2c-.3 0-.8-.2-1.6.8a1.4 1.4 0 0 1 1.4.6.6.6 0 0 0 .6-.4.8.8 0 0 0-.4-1zm21.4 1.2a2.8 2.8 0 0 0-2 .8 2 2 0 0 1 1.8.6.8.8 0 0 0 .7-.4.8.8 0 0 0-.5-1zm-23 1.4c-.2.3-.8.2-1.2 1.5a1.4 1.4 0 0 1 1.6 0 .8.8 0 0 0 .4-.7.7.7 0 0 0-.8-.8zm23.4 2c-.2.4-.8.3-1.4 1.6a2 2 0 0 1 1.9-.1.8.8 0 0 0 .4-.7.8.8 0 0 0-.8-.8zm-21.7 1.2a.7.7 0 0 0-.4.1 3.2 3.2 0 0 0-.5 2c.4-.7.7-.8 1.3-1a.8.8 0 0 0 .1-.7.6.6 0 0 0-.5-.4zm46.4.1a.8.8 0 0 0-.2.1 3.1 3.1 0 0 0-.7 2 1.4 1.4 0 0 1 1.4-.8c.2-.2.2-.6.2-.8a.6.6 0 0 0-.7-.5zm-21.5 1-.5.1a2.8 2.8 0 0 0-.4 2.2 2 2 0 0 1 1.6-1.1.8.8 0 0 0 0-.8.8.8 0 0 0-.7-.4zm27 .1c-.3 0-.4.1-.6.4 0 .8 0 1.6.5 2.1 0-.6.1-1.3.7-1.7a1 1 0 0 0-.3-.8.7.7 0 0 0-.3 0zm-3 .4a.7.7 0 0 0-.5.4 3.4 3.4 0 0 0 .1 2 1.8 1.8 0 0 1 1-1.4.8.8 0 0 0-.1-.8.6.6 0 0 0-.5-.2z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "gold",
      stroke: "#806600",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M378.7 21.3V21l.8-1.6a9 9 0 0 0-6.9 2 17.5 17.5 0 0 0-2.8 3.7 11.6 11.6 0 0 0-.8 3.2 18 18 0 0 0-1.9-1.6 2.7 2.7 0 0 0-1.3-.4 4.8 4.8 0 0 0-3.2 1.5 6 6 0 0 0-1.5 3c-.4 1.6 0 3.2-1 4.6l-1.6 1.8a8 8 0 0 0 2.7.6 4.2 4.2 0 0 0 2.8-1.5c.6-.8.9-1.9 1.8-2.5a1.4 1.4 0 0 1 1.2-.2c.5.2.6 1.2.4 1.6l-1 3.4-1.8-.4-1.4.8-.6.3h0l1.2 1.8.5.2h0a13.4 13.4 0 0 1-.4.2l-3.3 1.6-.4.2h0l-2.4.1a11.1 11.1 0 0 1-1.6-.2l-2.4-.8a7.2 7.2 0 0 1-.7-.4l-1.3-1.4a12 12 0 0 1-2.1-4.3 5.8 5.8 0 0 0 5-5.7v-.8a4.3 4.3 0 0 0-.1-.4 4.2 4.2 0 0 0-.3-1 6 6 0 0 0-.3-.6 6.7 6.7 0 0 0-.6-1 7.2 7.2 0 0 0-.4-.4 5.4 5.4 0 0 0-3.5-1.7h-1.3a5.8 5.8 0 0 0-3.2 1.6 5.6 5.6 0 0 0-1.4 2.2l-.2.8a7.4 7.4 0 0 0-.1 1.3h0a5.8 5.8 0 0 0 3.2 5.2 26.9 26.9 0 0 1-2.7 2.6 15.2 15.2 0 0 1-8.7 4 14.4 14.4 0 0 1-10.6-3 12.2 12.2 0 0 1-2.3-2.8h1.3l1.6-1.6h.1l-.5-.4-1.2-1h-.5l.4-3.8c0-.6.4-1.6 1-1.6a1.6 1.6 0 0 1 1.4.8c.8 1 .4 2.1.8 3.2a4.6 4.6 0 0 0 2.4 2.6c1.2.3 2.2.5 3.3.4l-.9-2.4c-.6-1.8.5-3.2.8-5a5.8 5.8 0 0 0-.2-3.6 5.6 5.6 0 0 0-3-2.8 3.6 3.6 0 0 0-1.6 0l-2.8.8s.8-2.4.5-3.6a15 15 0 0 0-1.6-4.8 22.6 22.6 0 0 0-3.5-3.7 22.6 22.6 0 0 0-3.5 3.7 15 15 0 0 0-1.6 4.8c-.2 1.2.5 3.6.5 3.6a23 23 0 0 0-2.8-.8 3.6 3.6 0 0 0-1.6 0 5.6 5.6 0 0 0-3 2.8 5.8 5.8 0 0 0-.2 3.6c.3 1.8 1.4 3.2.8 5l-1 2.4c1.2 0 2.2 0 3.3-.4a4.6 4.6 0 0 0 2.4-2.6c.5-1 .2-2.3 1-3.2.2-.5.7-.8 1.2-.8.7 0 1.1 1 1.1 1.6l.4 3.7h-.5l-1.6 1.6 1.6 1.5h1.3a12.2 12.2 0 0 1-2.4 2.8 14.4 14.4 0 0 1-10.6 3 15.2 15.2 0 0 1-8.6-4 27.4 27.4 0 0 1-2.6-2.6 5.8 5.8 0 0 0 3.4-5.2h0a6 6 0 0 0-1.8-4.2 5.8 5.8 0 0 0-3.3-1.6l-.3-.2h-1a5.4 5.4 0 0 0-3.4 1.8 6.6 6.6 0 0 0-1.3 2l-.3 1a4.3 4.3 0 0 0 0 .4 5.7 5.7 0 0 0 0 .8 5.8 5.8 0 0 0 4.7 5.7 12 12 0 0 1-2.1 4.3l-1.4 1.4a7.2 7.2 0 0 1-.8.4l-2.3.8a11.1 11.1 0 0 1-1.6.2l-2.3-.1h0l-.4-.1-3.4-1.7-.3-.2h0l.5-.2 1.2-1.8h0l-.6-.3-1.4-.8-1.7.4-1.1-3.3c-.2-.5-.1-1.5.4-1.7a1.4 1.4 0 0 1 1.2.2c.8.6 1.2 1.8 1.8 2.5a4.2 4.2 0 0 0 2.8 1.5 8 8 0 0 0 2.7-.6l-1.6-1.8c-1.1-1.4-.6-3-1-4.7a6 6 0 0 0-1.5-3 4.8 4.8 0 0 0-3.2-1.4 2.7 2.7 0 0 0-1.3.4 18 18 0 0 0-2 1.6 11.6 11.6 0 0 0-.7-3.2 17.5 17.5 0 0 0-2.8-3.7 8.6 8.6 0 0 0-6.8-2l.7 1.6v.3h.1l8.2 18.4-1.1.2-1.2 2 1.9 1 2.4-.6c.8 2 1.4 3.9 2 5.8l-2 .2h0c-.4.5-.6.5-.6 1h0c0 .3.1.8.4 1h0l.3.2h0l.5.3h1l.2 1.3-.1-.1v2l-1.2 2.6L274 59l.8 2.1.6-.4.1.7h-.3l.5 1h0l-.7.2c-.4.4-.5.5-.5 1h0c0 .2 0 .7.3 1h0l.8.5c3.8-.5 8-1 12.2-1.3l4-.3c7-.5 14.2-.5 21.3-.6h13.6c4.3 0 13.3 0 21.4.6a193 193 0 0 1 2.2.2l2.3.1a280.6 280.6 0 0 1 5.3.5l6.4.8h0l.3-.2.7-.7a1 1 0 0 0 0-.6h0c0-.5-.2-.6-.5-1h0l-.7-.1.2-.9h0l.2-.9.5.4.8-2 2-2.4-1.2-2.8V52h-.2l.3-1.3.9.1h0c.2 0 .3 0 .4-.2.6-.4.8-.8.8-1.3h0c0-.4-.2-.6-.6-1h0l-2.3-.2a286.4 286.4 0 0 1 2.2-5.9l2.5.7 2-1-1.2-2-1.2-.2 8.3-18.3h.1z"
    })
  ]
});
var Je_default = SvgJe;

// src/country-flag-icons/generated/Jm.tsx
import { jsx as jsx130, jsxs as jsxs123 } from "react/jsx-runtime";
var SvgJm = (props) => /* @__PURE__ */ jsx130("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs123("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx130("path", {
        fill: "#000001",
        d: "m0 0 320 240L0 480zm640 0L320 240l320 240z"
      }),
      /* @__PURE__ */ jsx130("path", {
        fill: "#090",
        d: "m0 0 320 240L640 0zm0 480 320-240 320 240z"
      }),
      /* @__PURE__ */ jsx130("path", {
        fill: "#fc0",
        d: "M640 0h-59.6L0 435.3V480h59.6L640 44.7z"
      }),
      /* @__PURE__ */ jsx130("path", {
        fill: "#fc0",
        d: "M0 0v44.7L580.4 480H640v-44.7L59.6 0z"
      })
    ]
  })
});
var Jm_default = SvgJm;

// src/country-flag-icons/generated/Jo.tsx
import { jsx as jsx131, jsxs as jsxs124 } from "react/jsx-runtime";
var SvgJo = (props) => /* @__PURE__ */ jsxs124("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx131("defs", {
      children: /* @__PURE__ */ jsx131("clipPath", {
        id: "jo_svg__a",
        children: /* @__PURE__ */ jsx131("path", {
          fillOpacity: 0.7,
          d: "M-117.8 0h682.6v512h-682.6z"
        })
      })
    }),
    /* @__PURE__ */ jsx131("g", {
      clipPath: "url(#jo_svg__a)",
      transform: "translate(110.5) scale(.9375)",
      children: /* @__PURE__ */ jsxs124("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx131("path", {
            fill: "#000001",
            d: "M-117.8 0h1024v170.7h-1024z"
          }),
          /* @__PURE__ */ jsx131("path", {
            fill: "#fff",
            d: "M-117.8 170.7h1024v170.6h-1024z"
          }),
          /* @__PURE__ */ jsx131("path", {
            fill: "#090",
            d: "M-117.8 341.3h1024V512h-1024z"
          }),
          /* @__PURE__ */ jsx131("path", {
            fill: "red",
            d: "m-117.8 512 512-256-512-256z"
          }),
          /* @__PURE__ */ jsx131("path", {
            fill: "#fff",
            d: "m24.5 289 5.7-24.9H4.7l23-11-15.9-19.9 23 11 5.6-24.8 5.7 24.9L69 233.2l-16 19.9 23 11H50.6l5.7 24.9-15.9-20z"
          })
        ]
      })
    })
  ]
});
var Jo_default = SvgJo;

// src/country-flag-icons/generated/Jp.tsx
import { jsx as jsx132, jsxs as jsxs125 } from "react/jsx-runtime";
var SvgJp = (props) => /* @__PURE__ */ jsxs125("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx132("defs", {
      children: /* @__PURE__ */ jsx132("clipPath", {
        id: "jp_svg__a",
        children: /* @__PURE__ */ jsx132("path", {
          fillOpacity: 0.7,
          d: "M-88 32h640v480H-88z"
        })
      })
    }),
    /* @__PURE__ */ jsxs125("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#jp_svg__a)",
      transform: "translate(88 -32)",
      children: [
        /* @__PURE__ */ jsx132("path", {
          fill: "#fff",
          d: "M-128 32h720v480h-720z"
        }),
        /* @__PURE__ */ jsx132("circle", {
          cx: 523.1,
          cy: 344.1,
          r: 194.9,
          fill: "#bc002d",
          transform: "translate(-168.4 8.6) scale(.76554)"
        })
      ]
    })
  ]
});
var Jp_default = SvgJp;

// src/country-flag-icons/generated/Ke.tsx
import { jsx as jsx133, jsxs as jsxs126 } from "react/jsx-runtime";
var SvgKe = (props) => /* @__PURE__ */ jsxs126("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx133("defs", {
      children: /* @__PURE__ */ jsx133("path", {
        id: "ke_svg__a",
        strokeMiterlimit: 10,
        d: "m-28.6 47.5 1.8 1 46.7-81c2.7-.6 4.2-3.2 5.7-5.8 1-1.8 5-8.7 6.7-17.7a58 58 0 0 0-11.9 14.7c-1.5 2.6-3 5.2-2.3 7.9z"
      })
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#000001",
      d: "M0 0h640v144H0z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#060",
      d: "M0 336h640v144H0z"
    }),
    /* @__PURE__ */ jsxs126("g", {
      id: "ke_svg__b",
      transform: "matrix(3 0 0 3 320 240)",
      children: [
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#ke_svg__a",
          width: "100%",
          height: "100%",
          stroke: "#000"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#ke_svg__a",
          width: "100%",
          height: "100%",
          fill: "#fff"
        })
      ]
    }),
    /* @__PURE__ */ jsx133("use", {
      xlinkHref: "#ke_svg__b",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#b00",
      d: "M640.5 168H377c-9-24-39-72-57-72s-48 48-57 72H-.2v144H263c9 24 39 72 57 72s48-48 57-72h263.5z"
    }),
    /* @__PURE__ */ jsx133("path", {
      id: "ke_svg__c",
      d: "M377 312c9-24 15-48 15-72s-6-48-15-72c-9 24-15 48-15 72s6 48 15 72"
    }),
    /* @__PURE__ */ jsx133("use", {
      xlinkHref: "#ke_svg__c",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    }),
    /* @__PURE__ */ jsxs126("g", {
      fill: "#fff",
      transform: "matrix(3 0 0 3 320 240)",
      children: [
        /* @__PURE__ */ jsx133("ellipse", {
          rx: 4,
          ry: 6
        }),
        /* @__PURE__ */ jsx133("path", {
          id: "ke_svg__d",
          d: "M1 5.8s4 8 4 21-4 21-4 21z"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#ke_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#ke_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#ke_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(1 -1)"
        })
      ]
    })
  ]
});
var Ke_default = SvgKe;

// src/country-flag-icons/generated/Kg.tsx
import { jsx as jsx134, jsxs as jsxs127 } from "react/jsx-runtime";
var SvgKg = (props) => /* @__PURE__ */ jsxs127("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx134("defs", {
      children: /* @__PURE__ */ jsx134("clipPath", {
        id: "kg_svg__a",
        children: /* @__PURE__ */ jsx134("path", {
          fillOpacity: 0.7,
          d: "M-85 0h682.7v512H-85z"
        })
      })
    }),
    /* @__PURE__ */ jsxs127("g", {
      fillRule: "evenodd",
      clipPath: "url(#kg_svg__a)",
      transform: "translate(79.6) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx134("path", {
          fill: "red",
          d: "M-128 0h768.8v512H-128z"
        }),
        /* @__PURE__ */ jsx134("path", {
          fill: "#ff0",
          d: "M105.5 261.1c13.6-16.6 41.9-.4 65-12.3-27.4 1.5-42.3-13.2-63.9-11.1 22.4-13.8 41.5 4.5 66.5-2.8-33.1-2.8-31.7-17.7-61.9-19.8 26.8-11.4 40 11.8 66.3 6.5-31-7.1-35-25.3-58-29.2 33.6-5 31.4 14.8 64.3 17.2-33.4-14.3-24.7-26.8-52.6-37.7 31.3-.7 29.2 21 61 26.6-27.2-17.2-23.9-32.9-46.2-45.2 26.5.5 29 27.6 56.1 36-24.1-19.1-17.8-35.3-38.6-52.4 26.4 6.2 22.5 29.6 50 44.6-20.4-22.6-12.6-38.8-30.3-57.3 25.4 8.1 15.7 30.4 42 51.6-15-24.9-5.7-40.8-20.6-61.7 23.6 12.1 12.2 34.9 34 57.5-10.3-25.5 0-41.3-10.5-63.9 20.2 15 8.2 39.3 24.5 62.5-6-32 7.8-37.2 3.5-65.2 15.3 18.8-1.8 37.6 10 65.3-1.5-31.5 15.3-38.8 12.4-64 15.1 22.6-8.5 42.3 1.4 66.5 2.5-29.8 22.1-37.6 22.4-60.8 12 21.3-14 36.7-9.8 65 8.5-31.2 29.4-35 32-56 7.1 24.6-21.4 36-19.7 63.4 8.5-27.7 34.6-31 40-51.4 3.3 26-22.4 30.7-29.7 59.5 13.5-23.5 37.2-25.4 47.8-44-.8 25.8-29.8 29.2-38.7 53.3 16.7-20.5 37.7-17 54.4-35.1-1.8 23.3-31.3 22-47 46.1 18.1-16.7 45.4-11.7 59.3-26.1-.7 20.6-36.9 19-54 37.5 21-11.6 47.8-4.8 63.2-15.5-2.8 18-41 13.8-59.3 28 25.2-7 44.7 3.7 65-4-9.9 17.5-44.6 6.4-63 17.8 22-3.7 45.2 9.6 65.1 5.3-6.5 15.2-44.6-1-65 8.5 24.4-.2 40.3 15.5 63 14.4-12.3 13.8-45.7-5.1-65.2-1.9 23.8 5 42 24.6 60 25.6-14.9 11.3-42.5-14.5-65-11.3 23.2 6.2 42.6 32.5 55.8 33.1-14.3 9.8-42.5-22.5-61.8-21.3 23.5 10.6 34.2 37.5 49.7 41.3-19.1 6.1-37.9-29.2-58.4-30.5 23.8 15 25.1 38 43.4 48.2-19.3 4.7-33-35.2-53.3-38.6 19.5 14.3 22.5 45 35.4 54.6-19.6 1-26.7-40.7-46.8-46.7 17.2 14.4 13.1 45.6 26.5 59-20.4-4.3-17.8-40.6-39.1-52.9 15.3 19.4 7.5 46.9 17.5 62.4-19.9-8-11.3-40.6-30.2-59 10.3 20.6-.8 44.6 7.4 64.5-18.2-8.9-6-47.4-19.9-62.7 6.4 23.8-5.4 43.5-.6 64.8-18.6-21.5 2.8-43.2-13.3-65.1 4.2 25.1-13.4 42.7-10.6 63.7-14.7-17.2 8-44.7-3.5-66.4 2.4 24.7-20.3 46.4-18.7 62-12-20 13.3-43.6 6.5-66.3-1.4 23.6-24.4 36.4-28.7 57.9-7.7-23.7 19.6-40.8 17.2-64.1-7.8 22.1-30 31-37.8 52.5-6.4-23.7 26-36.2 26.8-61-10 23.2-36.5 28.4-45.3 46.2-3.3-23.5 33.8-34 35.2-56.3-12 21.4-41 22.3-51 39.3-1.5-23.4 37.6-26.3 43.7-50.8-11.9 18.2-43.7 15.9-57 30.7 2.1-21.7 44.4-23 51.2-42.6-15.8 15.2-45 9-61.5 21 9.2-21.4 48.9-16.9 57.8-32.3-17.5 9.1-48.6.2-64 9.4 14-20.2 44.8-8.1 62.3-22-28.4 4.1-45.5-7.2-65.2-2z"
        }),
        /* @__PURE__ */ jsx134("path", {
          fill: "#ff0",
          d: "M356 256.1a99.2 99.2 0 1 1-198.5 0 99.2 99.2 0 0 1 198.4 0z"
        }),
        /* @__PURE__ */ jsx134("path", {
          fill: "red",
          d: "M343.2 256.3a86.3 86.3 0 1 1-172.6 0 86.3 86.3 0 0 1 172.6 0"
        }),
        /* @__PURE__ */ jsx134("path", {
          fill: "#ff0",
          d: "M331.2 256.5a74 74 0 1 1-148.2 0 74 74 0 0 1 148.2 0"
        }),
        /* @__PURE__ */ jsx134("path", {
          fill: "red",
          d: "M194 208c20.5-.5 46 1.4 62.9 14.8a97.1 97.1 0 0 1 60.5-14.3l11 20.1a101 101 0 0 0-50 8.2 85.3 85.3 0 0 1 34.6 72.1c-2.7 3.4-7 7.1-9.7 10.5 4-28.5-11-60.3-32.9-77 17.8 25.6 28.3 48.6 25.4 80.4l-10 6.4c4.6-28-2-61-22.7-80 12 17.5 23.8 49 16.4 81-3.2 1-8.2 3.7-11.4 4.6a96 96 0 0 0-10.8-78.7c-13.8 19.8-18.3 50-10.5 78-3.8-1-6.7-2.2-10.6-3.1-5.7-30 2.2-64 15.9-81.7-14 8.1-27.1 42.7-23.4 78l-9.3-4.3c-4.5-26.3 7.4-60.6 24.5-80.4-19.4 12.2-35.2 42.3-32.5 74.6-3-2.6-5.7-3.9-8.7-6.6-3.4-28.2 13-56.6 32.1-73.6-16.1-7.3-30-8.7-50-8.4 3.1-6.5 6-14.1 9.2-20.7z"
        })
      ]
    })
  ]
});
var Kg_default = SvgKg;

// src/country-flag-icons/generated/Kh.tsx
import { jsx as jsx135, jsxs as jsxs128 } from "react/jsx-runtime";
var SvgKh = (props) => /* @__PURE__ */ jsxs128("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx135("path", {
      fill: "#032ea1",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#e00025",
      d: "M0 120h640v240H0z"
    }),
    /* @__PURE__ */ jsxs128("g", {
      fill: "#fff",
      stroke: "#000",
      transform: "matrix(1.2 0 0 1.2 85.6 -522)",
      children: [
        /* @__PURE__ */ jsxs128("g", {
          strokeLinejoin: "bevel",
          children: [
            /* @__PURE__ */ jsx135("path", {
              d: "M139 623.5h113.8v43.8H139z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M247 647.6h3.5v16.5H247zm-108-8.1h113.8v5H139zm0-7h113.8v4.6H139z"
            }),
            /* @__PURE__ */ jsx135("path", {
              strokeWidth: 0.9,
              d: "M139 625.7h113.8v4.3H139z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M169 647.6h3.6v16.5H169zm49 0h3.6v16.5H218zm-78 0h3.5v16.5H140zm7 0h3.5v16.5H147zm7.5 0h3.5v16.5h-3.5zm7.5 0h3.5v16.5H162zm62.8 0h3.6v16.5h-3.6zm7.5 0h3.6v16.5h-3.6zm7.5 0h3.6v16.5h-3.6z"
            }),
            /* @__PURE__ */ jsx135("path", {
              strokeLinejoin: "miter",
              d: "M94.5 669.5a9.3 9.3 0 0 0 4.4-5.3H292a9.3 9.3 0 0 0 4.4 5.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M193 556.8s-.1-4.1 2.3-4.2c2.3 0 2.2 4.2 2.2 4.2zm-12.5 54.5v-5.5c0-2.8-2.8-3-2.8-5 0 0-.4-3 .4-4.4 1.1 4 3 3.3 3 1.6 0-1.4-1-2.8-3.3-6.3-.8-1.1-.3-4.6.7-5.9.4 3 .9 4.5 2.2 4.5.8 0 1.4-.5 1.4-2 0-2-1.3-3-2-4.8a5 5 0 0 1 1.1-5.3c.5 3 .4 4.2 1.7 4.2 2.7-.9 0-4.8-.6-5.8-.6-1.1 1-3.4 1-3.4.8 2.7 1 2.9 2 2.6 1.2-.3 1-2-.4-3.4-.9-1-.8-2.3.2-3.3 1 1.9 2.2 1.8 2.3.6l-.8-4.4H204l-.9 4.3c-.2 1.2 1.4 1.5 2.4-.5 1 1 1.1 2.4.2 3.3-1.4 1.4-1.6 3.1-.4 3.4 1 .3 1.2 0 2-2.6 0 0 1.5 1.5 1 3.4-.6 1-3.3 5-.6 5.8 1.3 0 1.2-1.2 1.7-4.2a5 5 0 0 1 1 5.3c-.6 1.8-2 2.8-2 4.8 0 1.5.7 2 1.5 2 1.3 0 1.8-1.4 2.2-4.5 1 1.3 1.5 4.8.7 6-2.3 3.4-3.4 4.8-3.4 6.2 0 1.7 2 2.4 3-1.6.9 1.4.5 4.4.5 4.4 0 2-2.7 2.2-2.8 5v5.5zm7.2-46-.4-3.1h15.9l-.4 3.1zm1-3.2-.2-2.5H202l-.3 2.5zm2.3-2.6-.3-2.6h9l-.1 2.6zm33 110c-2-.7-5-2.9-5-5v-24.3l2.6-3.4H169l2.5 3.4v24.3c0 2.1-2 4.3-4 5z"
        }),
        /* @__PURE__ */ jsx135("path", {
          strokeLinejoin: "bevel",
          d: "M178.2 647.6h3.6v16.5h-3.6zm30.4 0h3.6v16.5h-3.6z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M168 609.2v27.6h54v-27.6a4.2 4.2 0 0 0-2.6 2.8v11.8h-48.7V612s-.6-2-2.8-2.8z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M214.6 669.5c-1.8-.7-5.6-2.9-5.6-5v-27.2c.4-1.5 2.4-2.4 3.7-3.4H177c1.7 1 3.6 1.7 4.3 3.4v27.2c0 2.1-3 4.3-4.8 5z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M219.4 634.2v-19.6h-4.9v-1.9h-38.8v2h-5v19.5zM207 669.5c-1.8-.7-4.3-2.9-4.3-5v-23.2l1.4-2.1h-17.7l1.5 2v23.3c0 2.1-2.6 4.3-4.3 5z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M190.7 639.2h9v30.3h-9z"
        }),
        /* @__PURE__ */ jsx135("path", {
          strokeLinejoin: "bevel",
          d: "M204.4 632.5c0-2 5.8-2.1 8.8-3.8h-36c3 1.7 8.7 1.8 8.7 3.8l1.2 3.9 15 .6z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M211.4 611.3c0-4.9.2-6.7 1.7-6.7V620c-3.7 1.4-6.3 6-6.3 6h-23.2s-2.6-4.6-6.3-6v-15.5c1.8 0 1.8 2 1.8 6.7zm1.7-2c0-5.6 4.9-6.2 4.9-6.2v5c-1.9-.1-2.8 1.6-2.8 4 0 2.5 1.5 2.5 1.5 2.5v14.2h-3.6z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M177.3 609.3c0-5.6-4.9-6.2-4.9-6.2v5c1.9-.1 2.8 1.6 2.8 4 0 2.5-1.5 2.5-1.5 2.5v14.2h3.6z"
        }),
        /* @__PURE__ */ jsxs128("g", {
          fill: "none",
          strokeWidth: 0.8,
          children: [
            /* @__PURE__ */ jsx135("path", {
              d: "M186.8 570.6H204m-19.2 5.4h21m-23 6.5h24.9m-27 7.9h29.5m-30.2 9h30.4"
            }),
            /* @__PURE__ */ jsx135("path", {
              strokeWidth: 1,
              d: "M170.8 629h48.6m-33.2 0h18v6.6h-18z"
            })
          ]
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M184 614.2c3 3.6 2.6 9.7 2.6 13.3H204c0-3.6-.4-9.7 2.6-13.3zm9.7-41-2.4-1.3v-3.5c1 .3 2 .4 2.2 2 .3-2.3 1-2.1 1.9-3 1 .9 1.5.7 1.9 3 0-1.6 1.2-1.7 2.1-2v3.5l-2.3 1.2z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "m193.5 578.9-4-2.8V573c1.5.3 3 .5 3.2 2.2.4-2.5 1.3-3.7 2.7-4.7 1.3 1 2.2 2.2 2.7 4.7.1-1.7 1.7-1.9 3-2.2v3.2l-3.9 2.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "m193.2 587.8-4.5-4v-4.7c1.6.4 3.4.6 3.6 3.1.5-3.5 1.5-5.4 3-6.8 1.6 1.4 2.6 3.3 3.2 6.8.2-2.5 2-2.7 3.6-3.1v4.7l-4.6 4zm8.4 5.3-4 5.7h-4.7l-4.1-5.7zm-15.2 9.5c2 1.1 2.8 3.4 3 7.6H201c.2-4.2 1-6.5 3-7.6z"
        }),
        /* @__PURE__ */ jsx135("path", {
          strokeLinejoin: "bevel",
          d: "M204.2 593v-5.6a5.2 5.2 0 0 0-3.8 3.3c0-2-2.5-6.3-5.2-8.5-2.7 2.4-5.3 6.4-5.2 8.4-.5-1.5-1.8-2.7-3.8-3.2v5.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          strokeLinejoin: "bevel",
          d: "M205 602.6V597c-2.1.6-3.5 1.7-4.1 3.3 0-2-2.7-6.3-5.7-8.5-3 2.5-5.8 6.4-5.7 8.5-.5-1.5-2-2.7-4.1-3.3v5.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          strokeLinejoin: "bevel",
          d: "M207.4 614.3v-6.6a9.6 9.6 0 0 0-5.1 3.8c0-3.5-4-9-7.1-10.7-3.2 1.8-7.1 7.4-7.1 10.7a9.7 9.7 0 0 0-5.2-3.8v6.6z"
        }),
        /* @__PURE__ */ jsx135("path", {
          strokeLinejoin: "bevel",
          d: "M206 629v-6.8c-2.4.9-3 3.1-3.8 4.7.3-6.9-3.8-14.2-7-16.1-3.2 1.9-7.4 9.4-7 16-.8-1.4-1.5-3.7-3.8-4.6v6.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M204.4 639.2v-6.8c-2.5.6-2.6 1.5-3.4 3 .3-4.1-2.6-8.8-5.8-10.6-3.2 1.8-6 6.5-5.8 10.6-.8-1.5-.9-2.4-3.4-3v6.8z"
        }),
        /* @__PURE__ */ jsxs128("g", {
          id: "kh_svg__a",
          children: [
            /* @__PURE__ */ jsx135("path", {
              d: "M99 664.2v-20.4c-.7-2.6-3-5-4.6-5.4v-18l3.7 2 4.3 18.9v23z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M99 664.3v-20.5c-.7-2.6-3-5-4.6-5.4v-19.2c2.5 0 3.7 3.2 3.7 3.2l4.3 18.9v22.9z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M96.3 669.5c1.7-.7 4.2-2.9 4.2-5v-25.6l-1.2-2H143l-1.7 2v25.6a6 6 0 0 0 3.4 5z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M135.8 669.5c-1.7-.7-4.2-2.9-4.2-5v-24.3l3.6-3.4h-29.6l3.6 3.4v24.3c0 2.1-2.5 4.3-4.2 5z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M131.7 669.5c-1.7-.7-4.3-2.9-4.3-5v-22l2.4-3.3H111l2.4 3.3v22c0 2.1-2.5 4.3-4.3 5z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M116 639.2h8.9v30.4h-9z"
            }),
            /* @__PURE__ */ jsx135("path", {
              strokeLinejoin: "bevel",
              d: "M103.7 647.6h3.6v16.5h-3.6zm30.8 0h3.5v16.5h-3.6zm-33.9-27.8h4.4v17h-4.4zm0-3.2h4.3v3.2h-4.3zm35.6 6.9h6.1v13h-6.1z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M104.9 636.6v-29c1.2 0 1.4 4.3 4.2 4.3 1.5 0 1.4-1.8.5-3.2-.7-1.3-1.6-3-.4-6.3.9 2.5 3.1 3.3 2.7 1.8-.7-2.7-2.8-3.2-1.2-7.3.5 3.4 2.7 3.3 2.2 1.3-.6-2.3-1.9-3.3-.3-6.5.9 3.7 2 3.5 2 1.2 0-3.4 0-7 4.2-8.3 0 0 .3-3 1.9-3 1.5 0 1.8 3 1.8 3 4.3 1.3 4.2 5 4.2 8.3 0 2.3 1.1 2.5 2-1.2 1.6 3.2.3 4.2-.3 6.5-.5 2 1.7 2.1 2.2-1.3 1.6 4.1-.5 4.6-1.2 7.3-.4 1.5 1.8.7 2.7-1.8 1.2 3.3.3 5-.4 6.3-.8 1.4-1 3.2.5 3.2 2.8 0 3-4.2 4.2-4.2v28.9zM98 614.7v22.1h2.5v-22.1c-.9-.5-1.7-.5-2.5 0z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M98.2 629c3.1 1.6 6.2 3.5 7 7.8h-7zm43.2-6.6v14.4h2v-14.4c-.6-.3-1.5-.4-2 0z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M143.4 629c-3.1 1.5-6.2 3.3-7 7.7h7zm-20.6-33.7 1.8-1.5v-2c-.6 0-1 .3-1.5 1a5 5 0 0 0-2.5-3 5 5 0 0 0-2.6 2.9c-.5-.7-.8-.8-1.5-1v2l1.8 1.6z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "m123.8 600.2.8-1.9v-2.5c-.6 0-1 .3-1.5 1a5 5 0 0 0-2.5-3 5 5 0 0 0-2.6 2.9c-.5-.7-.8-.8-1.5-.9v2.5l.8 1.9z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "m124 606.8 2.6-3.3v-3.2c-1 0-1.5.5-2.2 1.6-.7-2.3-2-2.7-3.8-3.8-1.9 1-3.2 1.5-3.8 3.7-.8-1.1-1.3-1.4-2.3-1.5v3.2l2.7 3.3z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M124.7 613.3s3.2-2.7 3.3-4.2v-3.5c-1.2.1-2.3.4-3.2 1.9-.8-2.9-2-3.7-4.2-5-2.3 1.3-3.5 2.1-4.2 5-1-1.5-2-1.8-3.3-2v3.6a15 15 0 0 0 3.3 4.2z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M126 625.3s4.4-4.7 4.5-6.6v-5.4c-1.6.2-3.2 1.3-4.4 3.6-1-4.5-2.6-7.6-5.5-9.8-3 2.2-4.6 5.3-5.6 9.8-1.2-2.3-2.7-3.4-4.3-3.6v5.4c.3 1.9 4.4 6.6 4.4 6.6z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M126 632.4s3.7-3.7 4.5-5.3v-5.4c-1.6.2-3.2 1.3-4.4 3.5a14 14 0 0 0-5.5-9.2c-3 2.2-4.6 4.7-5.6 9.2-1.2-2.2-2.7-3.3-4.3-3.5v5.4c1 1.6 4.4 5.3 4.4 5.3z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M127.5 636.6c-1-4.7-2-8.2-7.1-11.7-5.2 3.5-6.1 7-7.2 11.7z"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M130.2 639.2v-6.8c-2.4 1-4.5 2.3-5.3 3.8-.8-3.8-2.5-5.4-4.6-7.7-2.1 2.3-3.5 4-4.4 7.7-.8-1.5-2.9-2.9-5.2-3.8v6.8z"
            })
          ]
        }),
        /* @__PURE__ */ jsx135("use", {
          xlinkHref: "#kh_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 390.7 0)"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M72.7 694.3H318v12.5H72.7zm-6.5 12.5h258.3v12.5H66.2zm19.4-31.3H305v8.1H85.6z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M79.2 683.6h232.4v10.6H79.2zm10.2-14.3h212v6.2h-212z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M112.4 669.3h16v50h-16z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M116 669.3h8.9v50h-9zm71 0h16v50h-16z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M190.7 669.3h9v50h-9zm71.5 0h16v50h-16z"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M265.7 669.3h9v50h-9z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "none",
          d: "M99 664.2h193M115.8 713h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m65.8 37.5h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m66.2 37.5h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2"
        })
      ]
    })
  ]
});
var Kh_default = SvgKh;

// src/country-flag-icons/generated/Ki.tsx
import { jsx as jsx136, jsxs as jsxs129 } from "react/jsx-runtime";
var SvgKi = (props) => /* @__PURE__ */ jsxs129("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx136("defs", {
      children: /* @__PURE__ */ jsx136("clipPath", {
        id: "ki_svg__a",
        children: /* @__PURE__ */ jsx136("path", {
          fillOpacity: 0.7,
          d: "M-86.3 0h682.6v512H-86.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs129("g", {
      clipPath: "url(#ki_svg__a)",
      transform: "translate(81) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx136("path", {
          fill: "#e73e2d",
          fillRule: "evenodd",
          d: "M-164.3 0h835.8v306.5h-835.8z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M204.3 282.1c-19.4-15.2-55.6-10-61.6-51.3 27.7 21.5 22.7-1.2 64 19.3z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M209.5 263.4c-13.9-20.4-50-26.6-43-67.7 19.9 28.9 22 5.7 55.2 37.9z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M215.8 250c-5-24.1-36-43.6-13.8-79 7.2 34.4 18 13.8 36.4 56.2z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M230.3 237.6c2.7-24.5-20.8-52.6 11.1-79.4-3.6 34.9 13 18.7 17.5 64.6z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M243.3 227.7c12.4-21.3 2.5-56.5 42.6-67.9-17.6 30.3 4.2 22.3-10.5 66z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M262 230.3c18.6-16.2 20.4-52.8 62-50.9-26.3 23.2-3 22.5-31 59.4z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M278.6 239.9c22.5-10.1 34.9-44.5 74.1-30.5-32 14.5-9.5 20.7-47 47.7z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M292.5 255c24.4-3.4 46-33 79.7-8.4-34.7 4.9-15 17.1-58.5 32.5z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m379.5 259.6-112.1 2.5 4.7 30.2z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m363 218.4-103.8 39.9 17.3 33.3z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m280.6 280.7 53.7-97.6-82.4 76.7z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m279.5 272.6 17.2-109.4-53.8 97.2z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m273 263.7-18-110.2-20 110.7z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m263.7 254.3-52.3-92 20 111.8z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m255.6 253.6-81.1-68.5 57.6 98z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m146 218.9 87 71.9 13.4-37.6z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m232.1 260.9-102.3-1.5 101.9 34z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M315.1 279.2a61.4 61.4 0 1 1-122.7 0 61.4 61.4 0 0 1 122.7 0z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#005989",
          fillRule: "evenodd",
          d: "M-165.1 303.4h839.9V512h-840z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M-165.6 454c15.6 7.2 38 25.3 62 25.3 40-.3 41-27.4 81.6-26.1 40.7 1 33.3 29.6 88.2 29.5 45.4-.2 60-34.7 99.2-30.6 29-1.5 40.8 32.7 85.3 33.2 46.2 1 63.1-37.3 92-34.1 31 0 41 30.8 84.3 31 55.2.3 64.9-32 99.3-30 24.6-.5 44 23.7 80 24.3 28.6.5 52.7-21.2 69-29l.7-36.8c-17 6.3-42.4 27.1-67.7 27.3-36.6 1.4-59.1-24-84.5-23.7-30.4.3-42.5 31.3-94 31.3-47.2 0-58-31.3-88.4-31.3-29.7.2-38.8 34-90.3 33.4-42-.5-58.3-32.3-88-32-31.5 0-64 30.9-99 29.4-48-2-58.5-29.4-90-29.4-23.5 0-49 25.6-77.3 26-28.2.5-59.9-25.5-62.8-26zm0-73c15.6 7.3 38 25.4 62 25.4 40-.3 41-27.4 81.6-26.2 40.7 1 33.3 29.7 88.2 29.5 45.4 0 60-34.6 99.2-30.5 29-1.5 40.8 32.7 85.3 33.1 46.2 1 63.1-37.2 92-34 31 0 41 30.8 84.3 31 55.2.3 64.9-32 99.3-30 24.6-.5 44 23.7 80 24.3 28.6.5 52.7-21.2 69-29l.7-36.8c-17 6.3-42.4 27-67.7 27.3-36.6 1.3-59.1-24-84.5-23.7-30.4.3-42.5 31.3-94 31.3-47.2 0-58-31.3-88.4-31.3-29.7.2-38.8 34-90.3 33.4-42-.5-58.3-32.3-88-32-31.5 0-64 30.8-99 29.3-48-2-58.5-29.4-90-29.4-23.5 0-49 25.7-77.3 26.1-28.2.4-59.9-25.5-62.8-26l.4 38.3z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M-165.6 309c15.6 7.2 38 25.2 61.9 25.2 40-.2 41-27.4 81.6-26.1 40.6 1 33.2 29.6 88.1 29.5 45.3-.1 60-34.7 99-30.5 29-1.5 40.8 32.7 85.3 33.1 46.1 1 63-37.3 92-34.1 30.8 0 41 30.8 84.2 31 55 .3 64.7-32 99.2-30 24.5-.5 43.9 23.7 79.8 24.3 28.7.5 52.7-21.2 69-29l.7-36.8c-17 6.4-42.3 27.1-67.7 27.3-36.4 1.4-59-23.9-84.4-23.7-30.3.3-42.4 31.3-94 31.3-47 0-57.8-31.3-88.2-31.3-29.7.3-38.8 34-90.1 33.4-42-.5-58.3-32.2-88-32-31.5 0-64 30.9-98.8 29.4-48.1-2-58.5-29.4-90-29.4-23.5 0-48.9 25.6-77.2 26-28.2.5-59.8-25.4-62.8-26l.4 38.3z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.8,
          d: "M136.8 76c61-4.2 50-9.4 74.5-13.4 31 4.3 34.5 23 51.8 34.5 0 0-6.5 22-27.7 18.9-2.9-8.8 10.2-11.6-27.5-34.6-22-1.3-61.3 3.9-71-5.4zm189.3 33.9-44 1.8v10.9c29.7 1 35-3 44-12.7z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeLinejoin: "round",
          strokeWidth: 1.7,
          d: "M174.8 108c7.7-3.9 11.5-2.3 18.2-2.5 4.5 8.3 8.8 9 18.8 10a49.5 49.5 0 0 0 39.9 21.8c29.9-.8 39.4-21.7 59.5-24h21.2c-3.5-6-6.3-9.5-14-9.9-15.8-.8-36.2-.4-54 3.6l-25.1 6.3c-7.4-3.6-25.3-22.4-36.8-22-6.7 1.8-6.7 4.1-10 6.7-6.5 2.8-13 1.4-17.7 10z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M205.1 99a3.2 3.2 0 1 1-6.3 0 3.2 3.2 0 0 1 6.3 0z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.8,
          d: "M225.6 107.8c44.9-54.1 84.1-47.5 135.3-51.2 1.7 6.3 1 15.7-23.3 24-33.4 5-93.1 40.2-93.4 40.2-11.1-.6-18.9-12.2-18.6-13z"
        }),
        /* @__PURE__ */ jsx136("path", {
          fill: "none",
          stroke: "#d9a43e",
          strokeLinecap: "round",
          strokeWidth: 1.8,
          d: "M317.9 72.5 351 74m-36.7 4 24.1 2"
        })
      ]
    })
  ]
});
var Ki_default = SvgKi;

// src/country-flag-icons/generated/Km.tsx
import { jsx as jsx137, jsxs as jsxs130 } from "react/jsx-runtime";
var SvgKm = (props) => /* @__PURE__ */ jsxs130("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx137("defs", {
      children: /* @__PURE__ */ jsx137("clipPath", {
        id: "km_svg__a",
        children: /* @__PURE__ */ jsx137("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs130("g", {
      fillRule: "evenodd",
      clipPath: "url(#km_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx137("path", {
          fill: "#ff0",
          d: "M0 0h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#fff",
          d: "M0 128h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#be0027",
          d: "M0 256h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#3b5aa3",
          d: "M0 384h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#239e46",
          d: "M0 0v512l381.9-255.3z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#fff",
          d: "M157.2 141.4c-85-4.3-123.9 63.5-123.8 115.9-.2 62 58.6 113 112.8 110C117 353.5 81.2 314.6 81 257c-.3-52.1 29.5-97.5 76.3-115.6z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#fff",
          d: "m156 197-12-9.3-14.6 4.6 5.2-14.4-8.8-12.4 15.2.6 9-12.3 4.3 14.7 14.4 4.8-12.6 8.5zm-.3 52.1-12-9.4-14.6 4.6 5.3-14.3-8.9-12.4 15.3.5 9-12.2 4.2 14.6 14.5 4.9-12.7 8.5zm.2 52.6-12-9.4-14.5 4.6 5.2-14.3-8.8-12.4 15.2.5 9-12.2 4.3 14.6 14.4 4.8-12.6 8.6zm-.2 53-12-9.3L129 350l5.3-14.4-8.9-12.4 15.3.6 9-12.3 4.2 14.7 14.5 4.8-12.7 8.5z"
        })
      ]
    })
  ]
});
var Km_default = SvgKm;

// src/country-flag-icons/generated/Kn.tsx
import { jsx as jsx138, jsxs as jsxs131 } from "react/jsx-runtime";
var SvgKn = (props) => /* @__PURE__ */ jsxs131("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx138("defs", {
      children: /* @__PURE__ */ jsx138("clipPath", {
        id: "kn_svg__a",
        children: /* @__PURE__ */ jsx138("path", {
          fillOpacity: 0.7,
          d: "M-80.1 0h682.7v512H-80.1z"
        })
      })
    }),
    /* @__PURE__ */ jsxs131("g", {
      fillRule: "evenodd",
      clipPath: "url(#kn_svg__a)",
      transform: "translate(75.1) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx138("path", {
          fill: "#ffe900",
          d: "M-107.8.2h737.6v511.3h-737.6z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#35a100",
          d: "m-108.2.2.8 368.6L466.6 0z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#c70000",
          d: "m630.7 511.5-1.4-383.2-579 383.5z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#000001",
          d: "m-107.9 396.6.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#fff",
          d: "m380.4 156.6-9.8-42.2 33.3 27 38-24.6-17.4 41.3 33.4 27-44.2-1.5-17.3 41.3-9.9-42.2-44.1-1.5zm-275.2 179-9.9-42.3 33.3 27 38-24.6-17.4 41.3 33.4 27-44.1-1.5-17.4 41.3-9.8-42.2-44.1-1.5z"
        })
      ]
    })
  ]
});
var Kn_default = SvgKn;

// src/country-flag-icons/generated/Kp.tsx
import { jsx as jsx139, jsxs as jsxs132 } from "react/jsx-runtime";
var SvgKp = (props) => /* @__PURE__ */ jsxs132("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx139("defs", {
      children: /* @__PURE__ */ jsx139("clipPath", {
        id: "kp_svg__a",
        children: /* @__PURE__ */ jsx139("path", {
          fillOpacity: 0.7,
          d: "M5 .1h682.6V512H5.1z"
        })
      })
    }),
    /* @__PURE__ */ jsxs132("g", {
      fillRule: "evenodd",
      clipPath: "url(#kp_svg__a)",
      transform: "translate(-4.8 -.1) scale(.93768)",
      children: [
        /* @__PURE__ */ jsx139("path", {
          fill: "#fff",
          stroke: "#000",
          d: "M776 511.5H-76V.5h852z"
        }),
        /* @__PURE__ */ jsx139("path", {
          fill: "#3e5698",
          d: "M776 419H-76v92.5h852z"
        }),
        /* @__PURE__ */ jsx139("path", {
          fill: "#c60000",
          d: "M776 397.6H-76V114.4h852z"
        }),
        /* @__PURE__ */ jsx139("path", {
          fill: "#3e5698",
          d: "M776 .6H-76V93h852z"
        }),
        /* @__PURE__ */ jsx139("path", {
          fill: "#fff",
          d: "M328.5 256c0 63.5-53 115-118.6 115S91.3 319.5 91.3 256s53-114.8 118.6-114.8c65.5 0 118.6 51.4 118.6 114.9z"
        }),
        /* @__PURE__ */ jsx139("path", {
          fill: "#c40000",
          d: "m175.8 270.6-57-40.7 71-.2 22.7-66.4 21.1 66.1 71-.4-57.9 41.2 21.3 66.1-57-40.7-58 41.3z"
        })
      ]
    })
  ]
});
var Kp_default = SvgKp;

// src/country-flag-icons/generated/Kr.tsx
import { jsx as jsx140, jsxs as jsxs133 } from "react/jsx-runtime";
var SvgKr = (props) => /* @__PURE__ */ jsxs133("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx140("defs", {
      children: /* @__PURE__ */ jsx140("clipPath", {
        id: "kr_svg__a",
        children: /* @__PURE__ */ jsx140("path", {
          fillOpacity: 0.7,
          d: "M-95.8-.4h682.7v512H-95.8z"
        })
      })
    }),
    /* @__PURE__ */ jsxs133("g", {
      fillRule: "evenodd",
      clipPath: "url(#kr_svg__a)",
      transform: "translate(89.8 .4) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx140("path", {
          fill: "#fff",
          d: "M-95.8-.4H587v512H-95.8Z"
        }),
        /* @__PURE__ */ jsxs133("g", {
          transform: "rotate(-56.3 361.6 -101.3) scale(10.66667)",
          children: [
            /* @__PURE__ */ jsxs133("g", {
              id: "kr_svg__c",
              children: [
                /* @__PURE__ */ jsx140("path", {
                  id: "kr_svg__b",
                  fill: "#000001",
                  d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
                }),
                /* @__PURE__ */ jsx140("use", {
                  xlinkHref: "#kr_svg__b",
                  width: "100%",
                  height: "100%",
                  y: 44
                })
              ]
            }),
            /* @__PURE__ */ jsx140("path", {
              stroke: "#fff",
              d: "M0 17v10"
            }),
            /* @__PURE__ */ jsx140("path", {
              fill: "#cd2e3a",
              d: "M0-12a12 12 0 0 1 0 24Z"
            }),
            /* @__PURE__ */ jsx140("path", {
              fill: "#0047a0",
              d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z"
            }),
            /* @__PURE__ */ jsx140("circle", {
              cy: -6,
              r: 6,
              fill: "#cd2e3a"
            })
          ]
        }),
        /* @__PURE__ */ jsxs133("g", {
          transform: "rotate(-123.7 191.2 62.2) scale(10.66667)",
          children: [
            /* @__PURE__ */ jsx140("use", {
              xlinkHref: "#kr_svg__c",
              width: "100%",
              height: "100%"
            }),
            /* @__PURE__ */ jsx140("path", {
              stroke: "#fff",
              d: "M0-23.5v3M0 17v3.5m0 3v3"
            })
          ]
        })
      ]
    })
  ]
});
var Kr_default = SvgKr;

// src/country-flag-icons/generated/Kw.tsx
import { jsx as jsx141, jsxs as jsxs134 } from "react/jsx-runtime";
var SvgKw = (props) => /* @__PURE__ */ jsxs134("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx141("defs", {
      children: /* @__PURE__ */ jsx141("clipPath", {
        id: "kw_svg__a",
        children: /* @__PURE__ */ jsx141("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs134("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#kw_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx141("path", {
          fill: "#fff",
          d: "M0 170.6h1024v170.7H0z"
        }),
        /* @__PURE__ */ jsx141("path", {
          fill: "#f31830",
          d: "M0 341.3h1024V512H0z"
        }),
        /* @__PURE__ */ jsx141("path", {
          fill: "#00d941",
          d: "M0 0h1024v170.7H0z"
        }),
        /* @__PURE__ */ jsx141("path", {
          fill: "#000001",
          d: "M0 0v512l255.4-170.7.6-170.8z"
        })
      ]
    })
  ]
});
var Kw_default = SvgKw;

// src/country-flag-icons/generated/Ky.tsx
import { jsx as jsx142, jsxs as jsxs135 } from "react/jsx-runtime";
var SvgKy = (props) => /* @__PURE__ */ jsxs135("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx142("path", {
      fill: "#006",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsxs135("g", {
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: 9.6,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__a",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__b",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__c",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__d",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__e",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__f",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__g",
          width: "100%",
          height: "100%"
        })
      ]
    }),
    /* @__PURE__ */ jsxs135("g", {
      stroke: "#000",
      strokeWidth: 1.4,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsxs135("g", {
          id: "ky_svg__b",
          fill: "#fcea83",
          children: [
            /* @__PURE__ */ jsx142("path", {
              d: "M754.4 449.6c2.9 7.6 23.5 17.7 47.5 4.8 16.3-9.2 26.8-22 36.9-45 2.8-5.8 4.3-13-2.4-17.3-5.3-3.9-14-8.2-17.8-12-1.9-2-3.8-3.4-5.2-4.8 1 1 1.9 1.9 2.8 3.3 9.6 11.5-.4 28.3-11 38.4-7.7 7.2-21.5 24.9-41.7 8.1-4.3-3.8-14.4 12-9 24.5zm291.4 0c-3.4 7.6-24 17.7-47.5 4.8-16.2-9.2-26.8-22-37.3-45-2.4-5.8-3.9-13 2.8-17.3 5.3-3.9 14-8.2 17.8-12 1.9-2 3.3-3.4 5.2-4.8-1 1-1.9 1.9-2.8 3.3-9.6 11.5.4 28.3 10.5 38.4 7.7 7.2 22 24.9 42.2 8.1 4.3-3.8 13.9 12 9 24.5z"
            }),
            /* @__PURE__ */ jsx142("path", {
              d: "M900.1 490.8c38.3 0 97.3-17.3 129-77.7 5.2-10 0-15.3-6.3-18.6a73 73 0 0 1-19.2-14c7.7 7.7 6.2 13 1 21.6-24.5 40.8-58 61.4-104.5 61.4s-80-20.6-104.5-61.4c-5.2-8.6-6.7-13.9.5-21.5a66 66 0 0 1-19.2 13.9c-6.2 3.3-11.5 8.6-6.2 18.6 31.6 60.4 91 77.7 129.4 77.7z"
            })
          ]
        }),
        /* @__PURE__ */ jsx142("path", {
          id: "ky_svg__c",
          fill: "#c8102e",
          d: "M811.4 409.8c-1-4.8-7.1-2.9-9 2.9a68.4 68.4 0 0 1-6.8-10.6c-5.7-8.6-6.7-14.4 1.5-22.5 3.8-3.8 11.5-8.2 16.7-3.4 11 9.1 5.3 24-2.4 33.6zm176.9 0c1-4.8 7.7-2.9 9.6 2.9 2.4-3.4 4.8-6.7 6.7-10.6 5.7-8.6 6.7-14.4-2-22.5-3.3-3.8-11-8.2-16.7-3.4-10.6 9.1-5.3 24 2.4 33.6zm-233.9 39.8c-4.8-7.2-8.6-26-9.6-30.7-1.4-4.3-1.9-8.2 3.4-10 5.3-2 10 4.7 12.4 10.5 2.4 5.7 6.3 14.3 10.6 24.9-10.6-6.2-19.2-2-16.8 5.3zm291.4 0c4.3-7.2 8.1-26 9.6-30.7 1-4.3 1.9-8.2-3.4-10-5.3-2-10 4.7-12.4 10.5-2.4 5.7-6.3 14.3-10.6 24.9 10.6-6.2 18.7-2 16.8 5.3z"
        }),
        /* @__PURE__ */ jsxs135("g", {
          fill: "#00493d",
          stroke: "none",
          children: [
            /* @__PURE__ */ jsx142("path", {
              d: "m782.2 406.4-3.8 2c-1 .4-1 1.4-1 1.9h-.5L775 406h.5c0 .4.5 1 1.4.4l8.2-4.3c1-.5 1-1 .5-1.4l.4-.5 2.4 4.8h-.4c-.5-.5-1-1-2-.5l-3.3 2 1.4 2.8 3.9-1.4c1-.5.4-1.5.4-2h.5l2 4.4c-.5-.5-1-1-2-.5l-8.1 4.3c-1 .5-1 1-.5 1.4l-.5.5-2.4-4.3.5-.5c.5.5 1 1 2 .5l3.8-2zm8.2 6.3c1-.5 1-1 .4-2h.5l4.8 7.2-3.3 2.4v-.4c1.9-1.5 1.9-3.4 1.4-3.9s-1-1-1-1.4c-.4 0-.4-.5-1.4.5l-3.4 2.4c.5.4 1 1.9 3.4.4h.5l-5.3 3.9v-.5c2.4-2 1.4-3.4 1-3.8l-3.4 2.4c-1 .4-1 1-1 1.4.5 0 .5.5 1 1 .5 1 2 1.9 4.3 1l.5.4-3.8 1.4-4.8-7.6h.5c.4.4 1 1 1.9.4zm7.6 18.2-3.3 2.8c-.5.5-.5 1.5 0 2h-.5l-3.4-3.4.5-.5c.5.5 1 1 2 0l6.2-6.2c1-.5 1-1 .4-2l3.4 4c-.5-.6-1.4-.6-2 0l-2.8 2.8 2.4 2.4 2.9-2.4c1-1 .5-1.4 0-2l.5-.4 3.3 3.8h-.5c-.4 0-1-.4-1.9.5l-6.2 5.8c-1 1-1 1.4-.5 1.9v.5l-3.3-3.9c.4 0 1.4.5 1.9 0l3.3-3.3zm7.2 10.1 1.5 1.4 1.9-4.3s-1.5.4-3.9 1.9zl-.5.4-1-1c-.4.5-.9.5-1.4 1-1.4 1-1 1.5-.4 2v.4l-2.4-2.4h.4l2-.5 9.5-5.2.5.4s-.5.5-4.8 10.1c0 1-.4 1.4 0 2.4l-3.8-3.3.5-.5c.5 1 1.4 1 1.9 0 0-.5.5-1.5.5-2l-1.5-1.4.5-.5zm3.8 9.5.5-.5c.5.5 1 .5 2 0l6.2-8.1-.5-.5c-1-.5-2.4-.5-3.8 1v-.5l1.9-2.4 7.2 5.3-2.4 2.8h-.5c1.4-1.4 1-3.3 0-3.8v-.5l-6.2 8.2c-1 .5-.5 1.4 0 1.9h-.5z"
            }),
            /* @__PURE__ */ jsx142("path", {
              d: "m821.5 452.4-2.4 3.4c-.5 1 0 1.4.5 2l-.5.4-3.8-2.9v-.5c1 .5 1.4.5 1.9-.4l5.3-7.2c.4-1 0-1.5-.5-2l.5-.4 3.8 2.8v.5c-1-.5-1.4-.5-2 .5L822 452l2.9 1.9 2.4-3.4c.4-1 0-1.4-.5-1.9l.5-.5 3.8 2.9v.5c-.5-.5-1.4-.5-2 .5l-4.7 7.6c-1 .5-.5 1 0 1.5v.4l-4.3-2.8h.5c.4 0 1 0 1.4-.5l2.4-3.8zm9.6 13.5.5-.5c.5.5 1.4.5 1.9-.5l3.8-8.1c.5-1 0-1.5-.5-2l8.2 3.9-2 3.8-.4-.5c1.4-1.9 0-3.8-.5-4.3-.5 0-1-.5-1.4-.5-.5 0-.5 0-1 1-.5.5-1.9 3.3-1.9 3.3.5.5 1.4 1.5 3.4-1h.4l-2.8 5.8-.5-.4c1.4-3-.5-3.4-1-3.4l-1.9 3.8c-.5 1 0 1.5.5 1.5v.5zm13.9 6.7c-1.4-1-1.4-3.9 0-6.7 1-3 2.9-5.3 4.8-4.4 1.4.5 1 3.4 0 6.3-1.5 3.3-3.4 5.2-4.8 4.8h-.5c3.4 1.4 5.8-.5 7.2-3.9 1.4-2.8 1-6.2-2-7.6-2.8-1.5-5.7.4-7.1 3.8-1.4 3.4-1 6.7 2 7.7zm14.8.9 2-5.7c.4-1 0-1.5-.5-2l2.4.5v.5c-.5 0-1 0-1.5 1l-1.9 5.7c-1 2.4-2.4 4.3-5.2 3.4-2-.5-3.4-2.9-2.4-5.3l2.4-6.2c.4-1 0-1.5-.5-2v-.4l4.3 1.9v.5c-.5-.5-1.4-.5-1.4.5L855 472c-.5 1.9-.5 3.8 1 4.3 1.4.5 2.8-.5 3.7-2.9zm4.4-6.2c0-.5 0-.5-.5-.5l3.3.5 3 9.1 1.4-5.8c.4-1 0-1.4-.5-1.9l2.8.5-.4.5c-.5 0-1 0-1.5 1l-2.4 10.5h-.4l-3.9-11.5-2.4 7.7c0 1.4.5 1.4 1 1.9v.5l-2.9-1v-.5c.5.5 1.4 0 1.4-1l2.4-8.6zm16.3 9.6c-1 4.3-3 5.3-3.9 5.3h-1s-.4-.5 0-1l1.5-9.6c.5-.5.5-1 1-.5h1c.9 0 1.8 2 1.4 5.8l1.4.5c1-4.8-1-6.8-3.4-7.2-1.9-.5-4.8-1-4.8-1v.5c.5.5 1.5.5 1 2l-1.4 8.5c-.5 1-1 1.5-1.5 1.5h-.4l4.7 1c2.4.4 4.8 0 5.8-5.3zm4.3-3.9c0-1-1-1.4-1.5-1.4v-.5l8.7 1-.5 3.8c0-2.4-1.5-3.3-2.4-3.3-.5-.5-1-.5-1.5-.5-.4 0-.4 0-.4 1.4l-.5 3.9c.5 0 1.9.4 2.9-2.4l-.5 6.2h-.5c0-2.9-1.4-2.9-2-2.9l-.4 4.3c0 1 0 1 .5 1l1 .5c1.4 0 2.8-.5 3.8-3.4h.5l-1 3.8-9.1-1c1 0 1.4-.4 2-1.3zm15.8 5.8c0 4.3-1.5 5.7-2.9 5.7-.5-.4-.5-.4-1-.4l-.4-.5.5-10c0-.6 0-.6.4-.6h1c1 0 2.4 1.5 2.4 5.8h1.9c0-4.8-2.4-6.2-4.8-6.2-2-.5-4.8-.5-4.8-.5v.5c.5 0 1.5.4 1.5 1.4l-.5 9.1c0 1-.5 1.4-1 1.4v.5h4.3c2.4 0 4.8-1 5.3-6.2h-2zm13.9 3.8c0 1 .5 1 1.4 1v.5l-5.3.4c.5-.4 1.5-1 1.5-1.9l-1-9c-.5-1-1-1-1.9-1v-.5l5.3-.5c-.5.5-1.5 1-1 2zm4.8 1v-.5c.5 0 1-.5 1-1.4l-2-10h-.5c-1 .4-1.9 1.3-1.4 3.3h-.5l-.5-3.4 8.7-1.4.4 3.3h-.4c0-1.9-1.5-2.4-3-2.4h-.4l2 10c0 1 .4 1.5 1.4 1.5v.5zm20.6-9.6-2-5.7c0-1-.9-1-1.4-1v-.5l2.4-1v.5c-.5.5-.5.5-.5 1.5l2 6.2c.4 2 .4 4.8-2.4 5.8-2 .4-4.3-.5-4.8-3.4l-2-6.2c-.4-1-.9-1-1.4-1l-.5-.5 4.8-1.4v.5c-.4.5-1 1-.4 1.9l1.4 6.2c.5 2 2 2.9 3.3 2.9 1.5-.5 2-2.4 1.5-4.8m5.3-3.4c2.3-1 1.9-2.3 1.4-3.8-.5-1.4-1.4-2.4-2.4-1.9-.5 0-1 .5-.5 1zl.4.5 1 3.9c.5 1 1.4 1 2 .4v.5l-4.4 2-.5-.5c1-.5 1-1 1-2l-3.4-8.1c-.5-1.4-1-1-1.9-1v-.4l4.8-2c2-.4 3.8 0 4.8 2 .5 2.4-.5 3.8-2.4 4.8-.5 0-1 .4-1 .4z"
            }),
            /* @__PURE__ */ jsx142("path", {
              d: "M957.1 472c-1.4.6-3.3-1.4-4.8-4.7-1.4-2.9-1.4-5.8 0-6.2 1.5-.5 3.4 1.4 4.8 4.3 1.5 2.9 1.5 5.7 0 6.7 3-1 3.9-4.3 2.4-7.7-1.4-2.9-4.3-4.8-7.2-3.8a5.6 5.6 0 0 0-2.4 7.7c1.5 3.3 4.4 5.2 7.2 3.8zm.5-13.3h-.9l2.8-2 8.7 4.8-3-5.2c-.4-1-1.4-1-1.8-1v-.5l2.4-1c-.5.6-1 1 0 2l4.8 9.6-.5.5-10.6-5.8 3.9 7.2c.4 1 1.4 1 1.9.5v.5l-2.4 1.4v-.5c.5-.5.5-1 0-1.9l-3.8-7.7zm21.6 1.4v-.5c0-.5.5-1 0-1.9l-5.8-8.1h-.5c-1 .4-1.4 2.4 0 3.8l-.4.5-2-3.4 7.2-4.8 2 3c-1.5-1.5-3-1.5-3.9-1l-.5.4 5.8 8.2c.5 1 1.4 1 2 .5v.4z"
            }),
            /* @__PURE__ */ jsx142("path", {
              d: "m984.5 448.6 2.8 3.4c.5.4 1.5.4 2 0v.4l-3.9 3.4v-.5c.5-.5.5-1 0-1.9l-5.7-7.2c-.5-1-1-.5-2-.5l3.9-3.3v.5c0 .4-.5 1 0 1.9l2.4 2.8 2.8-1.9-2.3-3.3c-.5-1-1.5-.5-2-.5l3.9-3.4v.5c-.5.5-.5 1 0 2l5.7 7.1c.5.5 1 .5 1.5 0l.4.5-3.8 3.4-.5-.5c.5-.5 1-1 .5-2l-2.9-3.3zm4.3-10.1c-.5-.4-1.5-.4-2 0v-.4l6.3-5.8 2.9 2.9h-.5c-1.5-2-3.4-1-4.3-.5 0 .5-.5.5-1 1 0 0 0 .4.5 1.4l2.9 2.9c.4-.5 1.9-1.5 0-3.9h.4l3.9 4.4v.4c-2.4-2.4-3.4-1-3.9-.4l3 2.8c.4 1 .9 1 .9 1l1.4-1.4c.5-.5 1-2 0-4.8h.5l1.9 3.3-6.2 6.2-.5-.4c.5-.5 1-1 0-2zm11.5-13.4c-.5.5-.5 1.5.4 2 1 .9 2 .9 3.9 0 1-.5 2.8-1 4.3.4 2.4 2.4 1.4 4.3 1 5.3-.5.5-1.5 1-2 1.4-.5 0-.5 0-.5.5v.5l-3.3-2.9h.5c1.9 1 3.8 1.4 4.8 0 1-1 0-2-.5-2.4-1-1-2-1-3.4 0-1.4.5-3.3.5-4.8-.5-1.9-1.9-1.9-3.3-1-4.8l2-1.4c.5 0 .5 0 0-1l3.4 2.4h-.5c-2.4-1-3.9-.4-4.3.5m4.3-3.8c-1-.5-1.5 0-2 .5h-.4l5.3-7.7 3.3 2.4-.5.5a3.3 3.3 0 0 0-4.3 0c0 .5-.5 1-.5 1.4-.4 0-.4.5.5 1 .5.5 3.4 2.4 3.4 2.4.5-.5 1.4-1.5-.5-3.4v-.5l4.8 3.9c-2.9-1.5-3.4 0-3.8.4l3.3 2.4c1 .5 1.4.5 1.4.5 0-.5.5-1 1-1.4.5-1 1-2.4-1-4.3l.5-.5 2.4 2.9-4.8 7.2h-.5c.5-1 .5-1.5-.4-2.4zm12.9-8.6-1.4 2.4c-2-2-2.9-3.4-2.9-3.4zh1c.5 0 1.4.4 1.9.4 1.4.5 1 1 .5 2h.5l2.4-4.4c-1 1-1.5.5-2.4.5-10.1-1.9-11-2.4-11-2.4v.5l7.6 8.6c.5.5.5 1.5.5 2h.5l1.4-2.4-.5-.5c-.5 1-1 1.4-1.9 0l-1-1 1.5-3.3zm-2.9-10.6c-.4.5-.4 1.5 1 2 1.4.4 2 0 3.4-1s2.8-2 4.7-1c3 1.5 2.4 3.9 2 4.8l-1.5 2v.9l-3.8-2c2.4.5 4.3 0 4.8-1.4.5-1-.5-1.9-1-2.4-1-.4-1.9 0-3.3 1-1.5 1.4-3 2-4.8 1-2-1-2.9-2.4-2-3.9 0-1 1-1.4 1.5-1.9 0-.5 0-.5-.5-1v-.4l3.9 1.9h-.5c-2.4-.5-3.9.5-3.9 1.4"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs135("g", {
      stroke: "#000",
      strokeWidth: 1.4,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsxs135("g", {
          id: "ky_svg__d",
          fill: "#073163",
          children: [
            /* @__PURE__ */ jsx142("path", {
              fill: "#fff",
              d: "M863.2 232.5c-6.2 1.4-10.5 1.9-16.3-3.4-3.8-3.8-2.9-10.5 1-13 4.3-2.8 8.1-4.7 13.4-3.3 5.3 1.5 19.2 14.4 15.8 14.9-3.4 0-8.6 3.3-13.9 4.8zm14.8-23c2-1.5 4.4-2.4 10.6-3 5.8-.4 10-.4 11.5 4 2 5.2 3.4 11.4 7.2 14.3-2.4 1.4-14.4 2.9-18.7.5-5.7-2.9-7.2-14-10.5-15.8zm41.3.5c1.9-1.5 4.3-1.5 10.5-1s8.6 1 10 5.3c1.5 4.8 0 11 3 15.3-3 1-12.5 1-15.9-2.4-5.2-3.8-4.8-14.9-7.6-17.3z"
            }),
            /* @__PURE__ */ jsx142("path", {
              d: "M948 212.8c-4.3-1-7.2-1.4-9 0 2.3 2.9.4 14.4 5.2 18.2 3.3 2.4 12 3 13.9-2.4 2.4-4.8 2.4-12-10-15.8zm-49.3-4.8c1.4-1.4 4.3-1.9 10-1.9 6.3 0 10 1 12 4.8 2 4.8 1.4 11 4.8 14.9-1.4 1.9-14.4 1.9-18.2-1-5.3-3.4-5.8-14.4-8.6-16.8zm-40.7 4.3c0-2.4 3.3-2.8 12-3.3 8.5-1 9-.5 11.9 5.7 1.4 3.4 3.3 9.1 7.2 11-10.6 2.5-14 3.9-19.7.5a29.2 29.2 0 0 1-10-10.5c-.5-1.4-.5-2.9-1.5-3.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs135("g", {
          fill: "#f9d050",
          strokeWidth: 0.6,
          children: [
            /* @__PURE__ */ jsxs135("g", {
              id: "ky_svg__f",
              children: [
                /* @__PURE__ */ jsx142("path", {
                  d: "M881 163.5c-10.1-7.7-22.1-14.9-33.1-16.3a280 280 0 0 1 32.6 25.4"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M886.7 156.3c-12-8.2-25.9-17.3-39.3-18.2a124 124 0 0 1 33 27.8m21.6-23a93 93 0 0 1 23.5-32.2c-4.8 10.1-10 30.7-12.5 38.9"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M912.6 140.5A48.4 48.4 0 0 1 937 115a101.2 101.2 0 0 0-18.2 35"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M916.9 150a84.5 84.5 0 0 1 37.8-31.6c-12 12-29.7 34-34 42.7m2.9-.5c8.6-4.8 25.9-12.5 38.3-10-7.6 2.8-30.6 13.3-40.7 23"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M921.7 157.2c8.1-8.6 23-21.5 38.8-26.8-11.5 11-36 36-39.3 39.8M898.7 152c-5.8-17.8-14.4-34.5-27.3-39.8a130.9 130.9 0 0 1 21 48.9m-4.8-9.6c-9.5-11.5-22.5-23-37.3-25.4a90.1 90.1 0 0 1 33 38.8"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M893 151c-12-21.6-21.2-25.4-26.4-29.7 4.3 8.1 14.8 29.7 21 38.8"
                }),
                /* @__PURE__ */ jsx142("path", {
                  fill: "none",
                  d: "M869 149.6a57.7 57.7 0 0 1 17.2 16.7"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M869 159.6c2.8 2.4 8.1 5.3 12.9 9.6m44.1-2.4c4.8-3.8 15.3-10 20.6-12m-24 8.7c4.8-6.3 14.4-14.9 17.8-17.8m-4.4-12a286.9 286.9 0 0 0-18.2 22.6m5.8-26.9a157 157 0 0 0-12 21.1m-25.9-20.1c2.9 7.7 8.2 20.6 10 25.9m-14.3-17.8c2 3 5.8 9.6 7.2 14.4"
                })
              ]
            }),
            /* @__PURE__ */ jsxs135("g", {
              id: "ky_svg__g",
              children: [
                /* @__PURE__ */ jsx142("path", {
                  d: "M897.7 136.1c0-4.3 2.9-9 5.8-9 3.3 0 5.7 5.7 5.7 9 0 3.9-2.9 7.2-5.7 7.2-3 0-5.8-2.8-5.8-7.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M891.5 140c.5-4.8 3.8-8.6 6.7-8.2 2.9.5 4.3 6.3 3.8 9.6-.5 3.8-3.8 6.7-6.2 6.2-2.4 0-4.8-3.3-4.3-7.6zm12.9 1.4c-1-4.3 1-9 3.9-9.6 2.8-.4 5.7 4.3 6.2 8.2 1 3.8-1.5 7.6-3.9 7.6-2.3.5-5.7-1.9-6.2-6.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M897.2 145.2c0-4.7 2.9-9 5.8-9 3.3 0 5.7 5.2 5.7 9 0 3.9-2.8 7.2-5.7 7.2-2.9 0-5.8-2.8-5.8-7.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M888.6 147.6c0-4.3 3.4-9 6.2-9 3 0 5.8 5.7 5.8 9 0 3.9-3.4 7.2-5.8 7.2-2.8 0-6.2-2.8-6.2-7.2zm17.7-1.9c0-4.3 3-9 5.8-9 3.3 0 5.7 5.7 5.7 9 0 3.9-2.8 7.2-5.7 7.2-2.9 0-5.8-2.9-5.8-7.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M904.4 149.6c0-4.8 3.4-9.1 6.2-9.1 3 0 5.8 5.2 5.8 9 0 3.9-2.9 7.3-5.8 7.3-2.8 0-6.2-3-6.2-7.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M896.8 153.9c0-4.8 2.8-9.1 5.7-9.1 3.4 0 5.8 5.7 5.8 9 0 4-3 7.3-5.8 7.3-2.9 0-5.8-3-5.8-7.2zm-12 0c0-4.8 2.4-9.1 4.8-9.1s4.3 5.7 4.3 9c0 4-2.4 7.3-4.3 7.3-2.4 0-4.8-3-4.8-7.2zm26.8-.9c0-4.4 2.4-8.7 4.8-8.7s4.8 5.3 4.8 8.6c0 4.3-2.9 7.2-4.8 7.2-2.4 0-4.8-2.9-4.8-7.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M914.5 161c1-4.7 3.8-8.6 5.7-8 2 .4 2.4 6.1 1.5 9.5-.5 4.3-3.4 6.7-5.3 6.2-2-.4-2.9-3.8-2-7.6z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M905.4 159.6c.5-4.3 3.3-8.6 5.7-8.1 2.9 0 4.3 5.7 3.9 9-.5 4.4-3 7.3-5.3 6.8-2.4 0-4.8-3.4-4.3-7.7zM892 161c-1.5-4.7-4.4-8-6.3-7.6-1.9.5-2.4 6.2-1.4 9.6 1 3.8 3.8 6.2 5.7 5.7 1.5-.4 3-3.8 2-7.6z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M888.6 160.1c0-4.3 2.4-8.6 4.8-8.6 2.9 0 4.8 5.3 4.8 8.6 0 4.3-2.4 7.2-4.8 7.2-2 0-4.8-2.9-4.8-7.2z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M895.8 162c0-4.8 2.9-9 5.7-9 3.4 0 5.8 5.2 5.8 9 0 3.9-2.9 7.2-5.8 7.2-2.8 0-5.7-2.9-5.7-7.2zm2.4-52.7c-1 3.8-4.3 7.2-2 12.5-4.2-1.5-8-2-11.4 1.9 4.3-.5 8.1 1 10 3.8-3.8-.5-5.7 1.5-6.7 3.9 3.4-1 6.7-2 8.2-1.5-1.5 1.5-3.9 3.8-4.3 5.8 2.8-2.4 6.2-2 8.1-3.4-1.4 3.4 1.4 6.7 3.8 10-.4-4.7 2.4-8 1-10.5 4.3 1 4.8 4.8 11 4.8-2.4-1.4-3.8-6.2-6.7-6.2 1.4-.5 7.2-1 8.2 0-1-2-4.4-3.8-6.3-3.8 2-2 5.3-5.8 7.7-6.8-3.4.5-8.6 1-10.5 3.9 4.7-3.9 3.8-11 9-12-2.8-.5-7.1 1.4-10.5 4.8 1.5-2.9 1.5-6.7 3.4-7.7-3.9 1-8.2 5.8-9.6 8.2a18 18 0 0 0-2.4-7.7z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M900.6 117c0 1.4 0 4.3-.5 5.2m6.7-5.7c-1 1-2.9 4.3-2.9 7.2"
                }),
                /* @__PURE__ */ jsx142("path", {
                  fill: "none",
                  d: "M909.7 122.2a7.6 7.6 0 0 0-3.4 4.4"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs135("g", {
          id: "ky_svg__e",
          fill: "#059334",
          children: [
            /* @__PURE__ */ jsx142("path", {
              d: "M858.9 169.7c-3.4 0-6.2-1.4-8.2-3.8-3.3-4.4-12.4-6.3-16.3-2.4-1.4 1-3.3 1-4.7 1.4-2.4 0-5.3 2.4-4.4 7.2 2-1.5 2.4 0 3.9 0 1-.5.5.5.5 1.4 0 2.4 5.2 7.2 10 6.7 5.3 0 7.7 2 8.6 3 1.5 1.3.5.9 1.5 3.3 1.4 1.4 1.9 1.9-.5 3.8a9.7 9.7 0 0 0 0 14.9c6.2 4.7 22 12 39.8-2 17.2-13.4 44-5.7 46-1 2.4 4.9 3.3 7.7 3.8 10.1.5 2 2.9 3.9 6.3 3.4 3.3 0 7.1 1.4 9 2.9 2.5 1.4 5.8 1 4.9-3.4-2-13.4-10.1-15.3-11-21.5 4.7.4 8 .4 10-1.5 1.4-1.9 3.3-5.3 5.3-6.2 1.4-1 1.4-2-.5-1.5-2.4.5-3.8 1.5-8.2 1-22-2.4-83.8-19.2-95.8-15.8z"
            }),
            /* @__PURE__ */ jsx142("path", {
              fill: "#000001",
              d: "M956.7 186a34.8 34.8 0 0 0-9.2 9.6c-4.7 6.2-19.1 12.4-36.9 12.4-17.2 0-27.7-2.8-35.4-9a60.6 60.6 0 0 0-10.6-6.8c-5.2-2.4-6.2-7.7-4.8-12-1.4 2.4-2.3 4.8-5.2 4.3-2 0-5.8 0-4.8 2-.5-1-.5-2.4-1-3l-1-.9c1.5 1 4.9-1.9 7.3-1.9 1.9.5 4.3-1.9 3.8-4.8l-1.4-6.2c3.8-2 54.1 7.2 64.2 8.1 10 .5 38.8 4.8 35 8.2z"
            }),
            /* @__PURE__ */ jsx142("path", {
              d: "M865.6 167.8c4.8-4.8 10.5-7.2 16.3-5.8h1.4c3-2.4 9.6-2.9 13.5-1h1.9c5.7-1.9 16.7 0 20.6 3.9l1.4 1c13-1 20.6 4.7 29.7 13.9 1 1 2.4 2.8 4.8 3.3 2.9.5 3.4 2 1 3.4a37.8 37.8 0 0 0-10 9c-4.4 5.8-18.3 11.6-35.6 11.6-16.7 0-26.8-3-34.5-8.7-4.3-3.3-7.6-5.2-10-6.7-2.9-1-6.7-4.8-5.3-8.6 1-3.8-1.4-8.6-3.3-13.4 1.4-1 5.2-2.4 7.1-1.4z"
            }),
            /* @__PURE__ */ jsxs135("g", {
              fill: "#00493d",
              children: [
                /* @__PURE__ */ jsx142("path", {
                  d: "M950.4 179.8c-9-9.2-16.7-14.9-29.7-14 0 .5 0 2-.5 3a66.3 66.3 0 0 1 23.5 17.7c2-2 5.3-4.3 6.7-6.7zm-31.1-14.9c-3.9-3.8-14.9-5.8-20.6-3.8 0 1.9 0 4.8-1 6.7 3.4 1.4 6.2 4.8 9.1 8.1 2-.5 6.7-1.9 9.1-2.4a44 44 0 0 0 3.4-8.6zm-22.5-3.9c-3.9-1.9-10.6-1.4-13.5 1-1 2-1.4 5.8-1.4 7.7 2 0 4.8 1.4 5.7 2.4 3-1 6.8-2.9 8.2-4.3.5-2 1.4-4.8 1-6.7zm-31.2 6.8c4.8-4.8 10.5-7.2 16.3-5.8-1 1.5-1.4 4.3-1.4 7.2-5.3-.5-12 1-14.9 2.9z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M941.8 187.4a64.2 64.2 0 0 0-22-16.8c0 .5-1 2.4-1.5 3.9 2.9 4.3 8.6 13.9 11 19.2 2.4-1 9.1-3.9 12.5-6.3zM905.4 198a179 179 0 0 0 1.4-19.7c2.4-.5 7.2-1.9 9.1-2.4 2.4 3.9 8.2 14 10.6 18.7-5.8 1.4-15.4 3.8-21.1 3.4zm-16.8-23c2.4-1 5.8-3 8.1-4.8 2 1.4 5.8 4.8 7.2 6.7 0 4.3-1.4 16.8-1.9 21-3.8 0-10-.9-13.4-2.8.5-7.2 1-15.3 0-20.1zm-24 5.7c.5-1 1-4.3 1-5.7 3.8-2.4 13.4-4.8 20.6-1 .5 4.8 0 16.8-.5 19.7a96.4 96.4 0 0 0-21-13z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs135("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx142("path", {
                  fill: "#000001",
                  stroke: "none",
                  d: "M840.7 172c-1 0-1.5-2.8-3.4-2.8-.5 0-1.9.5-2.4 0 0 1 .5 2 1 2.4.5 1.4 2.9.5 4.8.5z"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M840.7 180.2c5.7 0 6.7-7.2 9.6-7.6m-6.3 8.1c4.3 2 7.7-8.1 11-7.7m-19.6-4.7c1.4 0 2.4-2 4.8.4 1 1 2.4 1.5 3.4 1.5m-1 5.2c-2 3-5.3 4.8-7.2 3.9m-1-15.8c-1.4 1-2.3 2.8-3.3 4.3m-1.4 2.8v2.4"
                })
              ]
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs135("g", {
      strokeWidth: 1.4,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsx142("path", {
          id: "ky_svg__a",
          fill: "#fff",
          d: "M989.7 233v93.4c0 81-38.3 108.8-89.6 130.8-51.3-22-90-49.8-90-130.8v-93.5h179.6z"
        }),
        /* @__PURE__ */ jsx142("path", {
          fill: "#c8102e",
          d: "M900.1 312c4.3 0 11-3.8 16.8-9.6 6.2-6.7 16.8-9 27.8 0 11 9.1 17.7 5.3 23.5 0 5.7-5.2 10.5-7.2 21.5-7.2V233H810v62.3c11 0 15.8 2 21.6 7.2 5.7 5.3 12.4 9.1 23.5 0 11.5-9 21.5-6.7 28.2 0 5.3 5.8 12 9.6 16.8 9.6z"
        }),
        /* @__PURE__ */ jsx142("path", {
          fill: "#0b50a0",
          d: "M900.1 360c5.8 0 17.3-6.3 20.1-7.7 10.6-6.3 18.2-.5 24.5 2.4 6.7 2.8 19.1 6.2 26.8 0 7.7-6.3 12-5.8 17.3-5.8 1-7.2 1-14.4 1-22.5v-5.8c-6.8-1.4-10.1.5-17.3 6.8-7.2 6.2-15.4 4.8-26 1-10-4.4-20-12-30.1 0a24.2 24.2 0 0 1-16.3 8c-7.2 0-13.4-4.7-16.3-8-10.5-12-20.1-4.4-30.2 0-10.5 3.8-19.2 5.2-26.3-1-6.7-6.3-10.1-8.2-17.3-6.8v5.8c0 8.1.5 15.3 1.4 22.5 5.3 0 9.2-.5 16.8 5.8 7.7 6.2 20.6 2.8 26.9 0 6.7-2.9 14.3-8.7 24.9-2.4 2.9 1.4 13.9 7.6 20.1 7.6zm0 20.6a51 51 0 0 0 23.5-7.2c9.6-5.3 16.3-3 25.9 1.9 10 4.8 18.2 3.3 24 0 2.8-2 5.2-5.8 11.4-4.3-2.8 12-7.2 22.5-12.4 31.1a32.5 32.5 0 0 1-25-1.9c-10-4.8-22.5-7.7-29.2-3.4a36 36 0 0 1-18.2 5.8c-5.3 0-12-2-18.2-5.8-6.7-4.3-19.2-1.4-29.2 3.4a32.5 32.5 0 0 1-25 2c-5.2-8.7-9.5-19.3-12.4-31.2 6.2-1.5 8.6 2.4 11.5 4.3a23.9 23.9 0 0 0 23.5 0c10-4.8 16.7-7.2 26.3-2a51 51 0 0 0 23.5 7.3m0 76.6a191.9 191.9 0 0 0 51.3-29.7c-3.9-1.4-6.2-.5-9.6-2.9-3.4-2.4-13.4-3.3-22 1.5a39 39 0 0 1-39.3 0c-8.7-4.8-18.7-3.9-22-1.5-3.4 2.4-5.8 1.5-9.7 3a184.7 184.7 0 0 0 51.3 29.6"
        }),
        /* @__PURE__ */ jsxs135("g", {
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx142("path", {
              fill: "#f9d050",
              d: "M887.6 256.4c.5 1-.4 3.4 0 4.3 1 2 1 3 2.4 3.9h3.4c10.5 0 23-4.3 33.5-4.3 10.1 0 16.3 3.3 22 3.3 3.4 0 6.3-2.4 6.3-4.8s-3.8-3.8-12-3.8c-11.5 0-17.7 2.9-27.3 2.9-14.4 0-16.8-5.3-16.8-7.7 0-2.4 2.4-5.7 10.1-5.7 2.4 0 4.3-.5 5.3-1.5.5-1 1.9-2.9 4.8-4.3 3.3-2 10 0 13.4-2.4 0 2-2.9 4.8-5.3 5.8 4.8-1.5 10-1.5 11 2.4-2.4-1.5-6.2-.5-7.6 0-2 .4-2.9 1-4.8 1.4 1.9-.5 2.9 3.3 5.7 3.3-2.8 2.4-7.6 2.4-12.4.5-1.5-.5-5.3-1.9-7.7-1.9-4.8 0-7.7 1-7.7 2.9 0 2.4 3 3.8 11.5 3.8 8.7 0 13.5-2.4 26.4-2.4-1-1.4.5-2.9-1.4-4.3 4.8 0 10 1.4 12 4.8-.5-3.4 2.3-6.2 1.4-9.1 2.9.5 5.3 3.3 5.7 5.7 0-1.4 2-1.4 2-2.8a7.4 7.4 0 0 1 3.8 7.6c1.4-2.4 2.9-1.4 3.8-4.3 1 2 .5 7.7-2.9 9.6 3-2 7.2-2 10.1 1.4-2.9-.4-4.3 1-5.7 1.5A44.4 44.4 0 0 1 948 267c-7.6-.5-8.6-2-13.4-2 2.9.5 8.6 6.3 14 6.3 3.3 0 5.7 0 7.1-.5 1.4-.5 3.8 0 5.7 1 1.5 1.4 4.4 2.8 6.3 2.4-.5 1.9-1.5 2.8-2.9 3.3 2.4 1.5 1 2.4 3.4 4.3-1 0-2 1-3.4.5 1.4 1.4 1.4 3.4 2.9 4.3-.5 0-2 .5-2.9 0 1.4 2 0 4.3 1.4 5.3 1.5 2-1.4 4.3-3.8 2.4.5 1.4-1 2.9-2.4 2.4s-2.4-2-2-2.4c0-.5 0-.5.6-1-1 1.5-2.9 1.5-3.9 1-.4-.5-1-1-1-1.4-3.3 1-4.7-2-4.2-3.4.4-1.4 3.3-2 4.3-1.4 1 .4 1.9 1 2.9 0 1-.5 1.4-1.5 1.4-2.4 0-1.5-1.4-5.8-7.7-5.3-7.2.5-18.7-1.4-24.4-3.4-.5-.4-1-.4-1.5-1 0 2-1.9 3-1.9 4.9 0 2.4 1 4.3 3.9 5.2-1.5 2.4-3.9 2-4.8.5 0 1.5-2 2.4-2 4.3-.4-1-1-1.4-1.4-2.4-1.4 3.4-5.3 5.3-7.2 4.4-2.4 1.9-5.2 1.4-6.2-.5-1.4 1-3.4 1-4.3 0 0 1.4-1 1-1.5 2.9 0 1-1.9 1.4-2.8 1-1-.6-1.5-2.5-.5-3.4-1.4 1-2.9 1-3.8 0 0-1 0-2.4 1-3h.9c-1-.4-2.4 0-3.4-.4-1-1-1-2-.5-2.9.5-.5 2-1.4 3-.5l.4.5c0-1 .5-1.9 1-1.9 1-.5 2.3-.5 3.8 1 1 1.4 1.9 1.4 4.8 1 2.4 0 6.2-2.5 9-4.9-8-1.4-3.3-6.7-.9-8.6-1.9-.5-4.8-.5-6.7.5-10 5.3-20.6 11.5-27.3 9.6a6 6 0 0 0 1 2.8c-1.5 0-4.4 0-5.3-1.4-.5 1-1.4 3.4-.5 5.3-1-1-3.8-2-5.3-2.4 1 1 0 2.9.5 4.3-1.4-1.4-3.8-2.4-4.8-1.4s-2.9 1.4-4.3 1a7.5 7.5 0 0 1-3.8 2.8c0-1 0-2.4-.5-2.9-.5 1.5-2 3.4-3.8 4.3 0-1 0-2.4-.5-3.3 0 1.9-3.8 2.9-4.3 4.3.5-1.4.5-2.9.5-3.8a7.3 7.3 0 0 1-4.8 3.3c.4-1 1-2 .4-2.9-.4 2-3.3 3-5.7 2.4 0 1-2 2.4-4.3 1-1.5-.5-2.4-2-1.5-2.9-1.9 0-3.8-1.9-2.8-3.3 0-.5.4-1 .4-1.5-1.4-1-1.9-2.9-.4-4.3.4-.5 1.9-.5 2.8-.5 0-3.8 3.4-3.8 4.8-1 1 1.5 3.9 3.9 6.3 3.4 1 0 1.4-.5 2.4-.5a43 43 0 0 0 12-6.2c.4-1.4.4-2.4.4-3.3-1.9 1-3.8 1.9-4.8 3.3v-1.4c-1.4 0-3.8-.5-4.8-.5.5-.5 1-2.9 2-3.4-2.4.5-4.8 0-6.8-.4 1-1 1-2.4 1.5-3.9-1 .5-3.4-.4-5.3 0 .5-1.4 1-3.3 2.4-3.8-2 .5-4.3 0-6.7-1 2 0 2.9-2.4 4.3-2.4-3.8 0-4.8-1.9-6.7-2.8 1.4.4 2.4-1 3.8-1-1.4-.5-3.8-2.9-2.8-4.3-.5.5-1 1.4-2 2-1 .4-2.8 0-4.3-1.5-1-2-.5-4.3 1.5-4.8a2.3 2.3 0 0 1-1.5-3.9c.5-1 2.4-2.3 3.4-1l1.4 2c-.5-1-.5-2.9-.5-4.3.5-1.4 1.5-1.4 3-2 1.3 0 2.3 1.5 2.3 3 0 1.4.5 2.3 1 4.3l.4-2c0-1.9 2.4-1.4 3.9-1 1.4.6 1.9 3.4 0 4.9-1 1-.5 2.4.5 3.3 3.3 5.3 9 9.6 13.9 10.1 0-2 1-3.8 2.4-5.3 0-1 .4-2.4 1-3.3.4-2.9 1.8-4.3 3.7-3.4-.4-.5-1-1-1-1.4-1.4-1.5-2.8-3.9-1.8-5.8 1-1.9 3.8-1.4 4.8-.4-.5-3 2.8-5.3 2.8-6.8.5 1.5 1.5 3.4 1 4.8.5-1.9 3.8-4.3 6.2-5.2-1 1.4 2 3.8 1.5 5.2 1-2.4 4.8-3.8 7.6-3.8-1 1-1 2.9-1 3.8 1.5 0 4-.4 4.9-1.9 0 2-1 3.9-2 4.8.5-.5 2.4-.5 3.9-.5-1.5 1.5-1 3-2.4 3.9 1.9-1 4.3-1 4.8 1 1 1.4-.5 3.8-1.5 5.2-1 .5-1.9 1.4-2.4 1.4z"
            }),
            /* @__PURE__ */ jsxs135("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx142("path", {
                  d: "M858 262.2c-3.4 1.4-4.4 4.8-4.9 6.7"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M857.5 265.5c-4.8 3-6.8 5.3-5.8 10.6m8.1 3.9c3-1 4.8-2 7.2-6.3"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M865.6 275.6c-1 2 0 5.3-1.4 6.7a8.8 8.8 0 0 0 4.8-6.7"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M866.6 280.9c1.9-1 4.8-3.9 6.2-7.2-.5 1.4 0 3.8-1 5.3 2.4-2.4 3.4-3.9 3.9-6.3l.4 2c1-1 2-2 2-3.9m-.1 1.4v2.4c2-1.4 2.5-3.3 2.5-5.7"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M880 271.8c2.9-2 3.3-4.8 3.3-9.1m0 4.8c2-1.5 2.4-2.4 2.4-6.8m-6.2-12.9c-1 0-2 .5-2 2 0 .9-1.4 2.3-1.4 3.8-.4 1.9-1.4 2.4-2.8 1.9-1.5-1-1.5-1-1.5-2.4 0-2 2.4-2.4 2.4-4.3.5-1 1-2.4 1.5-2.4-2.4 1.4-5.8.4-6.3-2.4"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M883.8 249.2c-1 .5-2-1-3.3-.4-.5 0-2 .4-2.4 0"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M877.1 251.6c.5.5 2.9 1.5 5.3.5-2 .5-3.4-1.9-1.5-3.3m-8.1-2c-2 0-3.4 1.5-2.9 3 .5 1.4 2.4 1.4 3.8.4m-4.3 20.6c.5-.5 1-1.4 1-2 1 0 2-.4 2.4-.9 1.9 0 3.3-1.4 3.8-2.8 1 0 1.5-2.4 2-3.4.4.5 1.4 0 1.9-2 1 .6 2.4 0 2.8-1.4m-19.6-3.3c0 .5-1 1.4-2 2 .5.9 0 3.3-.9 3.7.5 1 0 2.4-.5 3.4 0 .5.5 2 .5 2.4m4.8-21.1c-1 2.4-.5 5.3 1.4 5.8"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M866.6 253c-.5 2.5-.5 5.8-1 7.3-.5 1-1.4 4.3 2.4 5.2 4.3 1 6.7.5 9.1-6.7m7.2 18.7c0 .5-.5 1.5-1.4 1.5m4.7-2.4c0 1-1 2.4-1.4 2.8m4.8-3.8c0 1 0 2.4-1 2.9m-28.2-32.6c.4 0 1 1 1.4 1.9-1.4-1-2.9 1.4-2 2.9m-.9 3.3-1.9 1.5m.5 2.8c-.5 0-1 .5-1.4.5m-21.6-9.1c0-.5 0-.5.5-1m-4.8-.4c-.5 0-.5 0-1-.5m1.4 7.2h1m-2.9-2.9a5 5 0 0 0-2.8-1.4m29.2 19.2c-3.4 2.8-4.8 5.2-5.3 8.6m8.6-6.3a11 11 0 0 1-3.8 4.4m-14.8 10a11 11 0 0 1-9.6-1.4c-.5-.5-1-.5-1.5-1m25.4-4.2c-.4 1.8-1 4.2-1.9 4.7 3.9-2 7.2-4.8 7.7-9.1M827.7 289c1.5-.5 3 .5 3.9-.5m79.5-15.3c1 .5 2.4 1 2.9 1.4.5-1 2.4-2.4 3.8-2.8m-40.7 11.5c-.5-2 .5-4.3 3.4-5.3m-22.1 13.4c.5-1 .5-2.4 1-3.3m-22.1 4.8c-.5 1-1.4 1.9-1.4 2.8m-5.8-1.9s0-.5.5-.5c1-.4 2.4-1.4 2.9-2.4m61.8-3.8c-1 .5-1.4 0-1.9-.5m1.4 2.9s-.4.5-1 .5m3.4 1.9c-.5.5-1 1-1.4 1m15.3 0c1-.5 1.5-1.5 2-3.4m-8.2 2.9c1.4-.5 2.4-1.5 3.8-2.9m9.6-1c0-1 0-1.9.5-2.8m35 7.2c-1-1-1-2.4.5-3.4 1-.5 1.4-1 2.4-1.4"
                }),
                /* @__PURE__ */ jsx142("path", {
                  d: "M924.5 276c-7.6-3.3-7.1-7.6-13.4-7.1m47.5 22.1c.5.4 0 1.9 0 2.3m4.3-2.3c-.5 1.4-.5 1.9-.5 3.3M926 245.9h-4m-36.3 16.3c0 1 1.5 2.9 5.3 2.9-.5 0-1-.5-1-.5m-2.4-8.2c-.4.5-1 0-1 0-.9-1 .6-2.8 2-3.8-1.4.5-2.4.5-3.4.5-1 2.9-3.8 4.3-5.7 2.4-.5 1.9-2.9 4.3-4.8 3.8-2-1-2.4-2.4-2-3.8-2.3 2.8-5.2 1-6.1 0-.5-1 0-3.4 1-6.3"
                })
              ]
            }),
            /* @__PURE__ */ jsx142("path", {
              stroke: "none",
              d: "M918.3 274.6c-1.4 1-2.9 0-4.3 1.5-1 1 .5 1.4 1.4 1.4-.4 1.5-.4 2 2 2-1 1.4 1.9 1.9 1.4 3.8a4.6 4.6 0 0 0 1-4.8c-.5-1.5-3-2.4-1.5-3.9"
            }),
            /* @__PURE__ */ jsx142("path", {
              fill: "#073163",
              stroke: "none",
              d: "M874.7 259.3c-2-1-2.4-2.4-2-3.8-.4 1-1.3 1.4-2.3 1.4-2 4.3-4.3 8.2-7.2 8.2-3.4.4-2.9 3.8-.5 3.8 5.3 1 7.7-1 12-9.6m-47.4-11.5c1.4-1.4.4-2.9-.5-3.3-1.5-.5-4.3 0-5.8 2.3 1.5-.4 3-.4 3.4.5.5 1 1.4 2 2.9.5m2.4-8.6c3.3 0 4.3.5 4.7 1.9.5 1-.4 2.4-1.4 2.4-1.4 0-2.9-1-2.4-1.4.5-1 .5-2.4-1-3zm9.5 7.6c2.4.5 3.4-1 2-2.8-.5-1.5-2-2.4-4.4-2 2.4 1.5 0 3.9 2.4 4.8m-17.7 8.2a4 4 0 0 0 4.8 2c1.4-.6 2-2 1.4-3-1-1.4-2.4-1.9-2.8 0-1 2-2.4 1.5-3.4 1m7.2 29.2c-1-1.9-3.8-1.9-6.2 0 1-.5 2.8 0 3.3 1s1.5 1 2 1c.4-.5 1.4-1 .9-2m3.8-2.8c0-2.4-3.3-3-5.2-2 1 0 2.4 1 2.4 2 .4 1 1.4 1.4 1.9 1.4 1-.5 1.4-1 1-1.4zm-4.8 8.6c-2.8-.5-4.3 2.9-4.3 5.2.5-1.4 2-2.3 3.4-1.9 1.4 0 1.9-.4 1.9-1.4.5-1 0-1.4-1-2zm.5 8.1c1 .5 2-.5 2.4-1.9 0-1 2-1 2.4-.5 1 .5 1 2.4-.5 3.4-1 .5-3.3 1-4.3-1m66.6-14.4c-1-.4-3.3-1.4-5.2 0 1.4-.4 2.4.5 2.8 1.5 0 1 1.5 1.4 2 .5.4-.5 1-1.5.4-2m-4.3 3.4c-1.9-1-4.3 1.4-4.8 3.4a7 7 0 0 1 3.4-1.5c1 .5 1.9 0 1.9-1 .5-.4.5-.9-.5-.9m2.5 3.9c-1.5 0-3.4 1.9-3.4 3.8.4-1 1.4-1.5 2.4-1 1 0 2.4-.5 2.4-1.4 0-1-.5-1.5-1.5-1.5zm4.2 3.8c-1-.5-2.4 0-2.4 1.4s0 2.9-.4 3.4c1-1 1.9-1.5 2.8-2 .5-.4 1-1.9 0-2.8m54.2-4.3c-1-1-2.4-.5-2.9.4-.5 1-1 3.4 0 5.3 0-1 1-2.4 2-2.4 1.4-.5 1.8-2.4.9-3.3m2.9 1.9c-2 1-2 4.3-.5 6.2 0-1 .5-2.4 1.4-2.9 1.5 0 2-1.9 1.5-2.8-1-1-2-.5-2.4-.5m5.7 1.9c-1-.5-2 .5-2 1.4-.4 1.5.6 3.4 2 4.3 0-1 .5-1.9 1-2.4 1.4-1 1-2.8-1-3.3m4.3-.5c-1 0-1.9 1.4-1 2.9.5 1 1.5 1.4 3.4 1-.5 0-1.4-1.5-1-2 .5-1 0-1.9-1.4-1.9"
            })
          ]
        }),
        /* @__PURE__ */ jsxs135("g", {
          id: "ky_svg__h",
          children: [
            /* @__PURE__ */ jsx142("path", {
              fill: "#f9d050",
              d: "m831.1 383.4 24-73.8 24 73.8-62.9-45.5H894Z"
            }),
            /* @__PURE__ */ jsx142("path", {
              fill: "#024919",
              d: "m835.9 376.7 49.8-36.4h-61.3l49.3 36.4-18.6-58.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__h",
          width: "100%",
          height: "100%",
          x: 90.1
        }),
        /* @__PURE__ */ jsx142("use", {
          xlinkHref: "#ky_svg__h",
          width: "100%",
          height: "100%",
          x: 45,
          y: 52.2
        }),
        /* @__PURE__ */ jsx142("path", {
          fill: "none",
          stroke: "#000",
          d: "M989.7 233v93.4c0 81-38.3 108.8-89.6 130.8-51.3-22-90-49.8-90-130.8v-93.5h179.6z"
        })
      ]
    })
  ]
});
var Ky_default = SvgKy;

// src/country-flag-icons/generated/Kz.tsx
import { jsx as jsx143, jsxs as jsxs136 } from "react/jsx-runtime";
var SvgKz = (props) => /* @__PURE__ */ jsxs136("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx143("path", {
      fill: "#00abc2",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsxs136("g", {
      fill: "#ffec2d",
      children: [
        /* @__PURE__ */ jsxs136("g", {
          transform: "matrix(.48 0 0 .48 345.8 201.6)",
          children: [
            /* @__PURE__ */ jsx143("circle", {
              r: 134.6
            }),
            /* @__PURE__ */ jsxs136("g", {
              id: "kz_svg__c",
              children: [
                /* @__PURE__ */ jsxs136("g", {
                  id: "kz_svg__b",
                  children: [
                    /* @__PURE__ */ jsx143("path", {
                      id: "kz_svg__a",
                      d: "M0-152.9c8-.1 11-5.1 11-11.1 0-8-11-46.1-11-46.1S-11-172-11-164c0 6 3 11.1 11 11.1"
                    }),
                    /* @__PURE__ */ jsx143("use", {
                      xlinkHref: "#kz_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(90)"
                    }),
                    /* @__PURE__ */ jsx143("use", {
                      xlinkHref: "#kz_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "scale(-1)"
                    }),
                    /* @__PURE__ */ jsx143("use", {
                      xlinkHref: "#kz_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(-90)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx143("use", {
                  xlinkHref: "#kz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(22.5)"
                }),
                /* @__PURE__ */ jsx143("use", {
                  xlinkHref: "#kz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(45)"
                }),
                /* @__PURE__ */ jsx143("use", {
                  xlinkHref: "#kz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(67.5)"
                })
              ]
            }),
            /* @__PURE__ */ jsx143("use", {
              xlinkHref: "#kz_svg__c",
              width: "100%",
              height: "100%",
              transform: "rotate(11.3)"
            })
          ]
        }),
        /* @__PURE__ */ jsxs136("g", {
          transform: "translate(-172.8) scale(.48)",
          children: [
            /* @__PURE__ */ jsx143("path", {
              d: "M1075.8 655c-3.5 6.3-5.6 13.6-10 19.3-13.6-12.3-33.2-12-50.4-12.7-14.2-.8-29.6-2.1-40.6-12.2-11.5-9.5-21-21.7-33.8-29.4a83.2 83.2 0 0 1-33.1-15.3c-20.2-16.5-31.8-41-51.6-58-3.7-3.6-8.2-6.5-12.4-9.6-4 1-2.2 9.6-7.1 5.2-2.7-2-9.4-2.1-10 .6 6 8 12.1 17 13 27.2-4.2.4-11.5-.9-13.5.6a84.3 84.3 0 0 0 20.4 21.3c-3.8.6-11.3.3-12.8 1.8a59 59 0 0 0 26.8 14.7c2 2.8-3.1 8.2 1.3 10.6 2.5 1 10.9 2.8 5.1 5.7-4 2.6-2.5 8.9 2.6 8.7 3.2 1.7 10.4 2 11 5-2.9 2.8-11.7 6.2-4.2 9a52 52 0 0 0 23.1 6.7c-4 3.4-9 5.3-13.1 8.5 18.5 10.9 39 18 59.4 25 8 2.6 16.3 5.1 24.7 6.7-24.4-1.4-48-8.6-70.2-18.5-11.5-5-23-9.9-34.8-14.2 5.1-2.7 11.1-3.4 16.5-5.7-11.2-2.2-23.3-3-33-9 1.4-2.8 7-2.9 10.2-4.3 6-1.4 9.6-3 1.3-3.6-8.4-2.3-18-1.3-25.5-6.3.5-3 8.3-2 11.4-3.3 4-.7 8.4-1.3 11.6-4-13-5.3-30-1.5-40.2-13-2.3-4.4 7.3-.9 10-1.6 7 0 14.5 2.2 21.2-.6-19-8.3-39.3-16-53.7-31.4-1.6-2.5-6.4-9.3-2.5-10.1 11.2 1.5 19.3 13.7 31.4 11.8 1.6-2.1-7-5.6-9.2-8.7a229.4 229.4 0 0 1-46.8-51c-.8-6.7 9.5-7.7 12.2-2.6 13.4 13 25.5 28 42.2 36.8 6 2.9-3.4-3.4-4.6-5.7a298.7 298.7 0 0 1-40.9-57.9c-2-3.8-5.1-10.7.7-12.7 5.7-2.9 11.5 1 14.4 6 11.3 14.3 19.7 31.3 33.8 43.2-12-23.3-24.9-48-25.2-74.8.3-5.2.6-13 7.7-12.9 6-.9 5 6.7 7 10.3 5.8 19.8 8.3 41.2 20 58.6-2.5-14.6-6.4-29.7-3.8-44.6.6-5 6-6.4 9.7-3.4 2.9 7 3.5 15.9 6.1 23.5a237 237 0 0 0 93 127.2 244.7 244.7 0 0 0 123.3 42.3c4 .4 8 .5 11.9.7m136.4 91.1c-7.2 4.4-12.8-3.4-18.8-5.7-4.4 2.4-4.8 10.2-8.8 14-4.8 5.5-10.8-1.6-10.3-7-5.8 4.9-8.7 16-18 14.4-4.5-3.6-7.8-11.2-11.2-2.5-2.7 4.2-10 10.2-13.9 3.8-1.2-5.6-4-12.2-7-3.3-2.2 6.4-9 11-15.4 8.2-3.6-2.9 2.8-13.7-1.7-13-6.8 4.6-10.8 15.7-20.3 14.8-3.7-4 2.3-11.1-1.8-15.7-4.7 6.1-10 15.1-18.3 15.7-4-3.2.2-12.5-2.4-13.8-8.4 5-17.4 14.1-28 11.3 4.1-16 21.5-21.5 36-22.7 25.1-3.1 51.5 2.6 75.7-6.5 3.9-2.4 13.3-5.7 10-11.2-3-4.4 7.7-2.7 8.7-7.8-.6-6.4 5-5.5 10.4-6 24.4-1.1 48.5 4 72.8 4.9 1.8 11.8-11.3 20.1-22 16.5-5 .8-12.5-11.6-11-2.6-1 4.8-.4 11-4.7 14.2m-207.4-24.2c5.6 5.1 9.6-1 14.9-3.3a197 197 0 0 0 48.3-27.3c9.2-7.6 17.2-17.5 29.6-20 24.2-7.3 49.9-6.4 74.1-13.2 18.5-25.2 49.8-34.3 76.1-48.8 5.9-1.8 8.2-6.7 10-12 10-15.9 23.7-29.9 39.9-39.5a37.2 37.2 0 0 1 25.4-4.6 42.4 42.4 0 0 1-13.7 26.5c5.9-.1 11-3.8 16.8-3.6 2 10.6-9.4 16.1-15.5 22.7 3.4.8 16.4 1.8 9.3 5.2-9 6.2-19.3 10.5-27.6 17.8 7.7 1.4 8.6 3 .8 5.8-4.3 2.8-12.4 3.8-13.2 9.4 5.8 3.6-2.6 7-5.9 8.2-6.2 1.5-12.8 4.2-4.5 9-3.1 4.7-9.9 5.7-15.4 5.2 1.7 5.4 4.1 11.4-2.8 13.8a107.7 107.7 0 0 1-53.6 22.4c24.5 1.8 49.8-2.7 70.7-16 2.8-3.3 17.3-6.9 9.2-9.6-3.8-1.6-12-3.4-12.6-6.3 11.4-7 25.7-4.5 37.9-8.6.3-4-9.3-2.9-12.9-3.8-8.5-.7-8-2.9.2-3.7 10.4-2.8 22.2-3.3 31-10-7.1-3.4-16.1-.5-23.7-3.2 12.9-5.6 28.1-6.2 39.7-14.7 5.3-5.9-6.8-4-10.3-3.9-7.1 1.3-10.4-2.2-2.3-5.1 13.9-10.3 31.4-16.9 41.2-31.7 2.3-3.3 5.4-13.3-2-9.8-9.6 3.3-18.1 14.1-29.2 10.8 21.8-16.9 42.4-36 57.3-59.3.8-6.8-9.8-7.5-12.5-2.2-14 13.4-26.6 29.3-44.5 37.8a280.6 280.6 0 0 0 43.6-56.4c2.7-6 9.8-13.3 6-20-6.3-5.2-14.1-.4-17.3 5.7-10.9 14.2-19.1 30.7-33 42.3 12.1-23.3 24.8-48.2 25-75 0-5.6-1-13.8-8.6-12.7-6 1-4.5 10-7 14.5-5.4 18.4-8 38.3-19 54.3 2.5-14.9 6.8-30.5 3.5-45.5-1.6-6.8-12.5-3.9-11 2.8-13 65.9-57.3 123.5-115 156.8-26.5 15-56 24.6-86.2 29-8 1.7-16.8.7-24.5 3.5-18.8 14.3-30.1 38.4-53.8 45.9-10.7 5.3-24.5 6.4-32.1 16.2a8.6 8.6 0 0 0-.8 4.2m51.7-10.3c-3.6.2-7.1.6-10.6 1.7-4.7.7-9.2 2.3-13.8 3l-1.9.4-3.1.3a10.9 10.9 0 0 1 0 5.1 6 6 0 0 1-1.4 2c-.6.8-1.3 1.4-2.2 1.8a7 7 0 0 1-2.6.7c-.9 0-1.8 0-2.7-.4-.9-.3-1.7-.8-2.5-1.5l-2.8.5h-2.6l-2.8-1a16.1 16.1 0 0 1-2.6-1.3c-3.4 2-7.2 3.9-9.3 7.4a11 11 0 0 0-1.6 5.3c-.2 2.4.4 4.8 1.4 7 .4.6.7-2.3 1.8-2.7 1.9-1.6 4.3-2.7 6.7-3.3 2-1 1.7 0 .9 1.6-.2.9-1.3 4 .2 2.4a65 65 0 0 1 21.6-4.1c10.6-1.1 21.2-1.4 31.8-1.5l30 .6c4.8.2 9.6 1.2 14.3.4 1.1-.3 2.9-.3 3.6-1-2.2-1.2-4.7-1.3-7-1.6h-19.1c-5.3-.5-10.8-.6-15.8-2.6-1.4-.5-2.6-1.8-3.9-.4a24 24 0 0 1-5.9 1.3c-3.5.2-7-.5-10.2-1.8 2.3-3.2 5.1-6 7.7-9l-6.2-1.3c3.7-2.5 7-5.4 10.6-8"
            }),
            /* @__PURE__ */ jsx143("circle", {
              cx: 1020,
              cy: 720.9,
              r: 2.4
            }),
            /* @__PURE__ */ jsx143("circle", {
              cx: 1019.8,
              cy: 720.5,
              r: 1,
              stroke: "#ffec2d",
              strokeWidth: 0.4
            })
          ]
        }),
        /* @__PURE__ */ jsxs136("g", {
          transform: "scale(.48)",
          children: [
            /* @__PURE__ */ jsxs136("g", {
              id: "kz_svg__f",
              children: [
                /* @__PURE__ */ jsxs136("g", {
                  id: "kz_svg__e",
                  children: [
                    /* @__PURE__ */ jsx143("path", {
                      d: "M120 73s-9.6-8.2-12.9-4.1c-5.2 6.5 16.2 39 16.2 50.4 0 18.8-12.6 23.9-28 26.5-10.4 1.8-27.3-.7-27.3-.7 3.2-4.3 5.3-5.6 10.6-5.9-6-3-12-9.8-12-20.3 0-16.1 6.6-22.8 6.6-41C73.2 68 65 55 65 55c14.6 1.5 21.8 15 17.7 25.8a7 7 0 0 0 6.3-1.9c1 3-.6 6.5-2.9 9.5 1.8 1 3.2.4 6-.2-.2 3-2 6.4-6.6 9.5 13.2-3.4 21.2 5.7 21.2 15.3 0 7.3-5 12.5-10 12.5-1.6 0-4-.7-5.3-1.7-1 2-.4 4.7.5 6.7-3.6-1-6-3.2-4.3-7.7-2.8-.2-5-1.2-6.5-3 1.5-2 3.8-3 6.5-3-2-4.2.3-6.5 3.6-8.4 0 0-2.1 8.4 3.2 8.4 2.4 0 4.6-.7 4.6-4.3 0-3.1-2.7-7.4-9-7.1-6.2.3-11.3 4.3-11.3 14.3 0 9.2 7.5 13.8 17.3 14 8.8.4 15.5-4.4 15.5-13.5C111.5 108 94 80.4 94 69.6c0-8.1 7.2-12.7 14.4-12.7 9.2 0 17 9.2 17 9.2l-5.4 6.8z"
                    }),
                    /* @__PURE__ */ jsx143("path", {
                      id: "kz_svg__d",
                      d: "M122 292.1c0 20.3-18.2 30.7-32.5 30.7-19.2 0-29.5-11.5-29.5-26.6 0-8.5 1.6-13.9 5.5-22l44.2-91.7a27 27 0 0 0 2-12.2c0-8.2-8-14.9-16.3-15-7.6-.3-16 7-16 15.3 0 10.1 5.3 14.6 10.7 14.6 6.6 0 9.2-2.7 9.2-7.4 0-3.2-1.5-4.6-3.8-4.6-5.7 0-4 7.6-4 7.6a5.2 5.2 0 0 1-3.9-7 10.2 10.2 0 0 1-5.5-3.3c1.5-1.5 3.3-2.6 5.5-3-1.3-4.4.5-6.5 4.3-7.5a7.6 7.6 0 0 0-.5 4.8c6-1.8 15.3 1 15.3 11.4s-7.2 19.1-20.7 17c3.2 1.5 4.8 4.6 5.2 8.1-2.5-1-5.2-1-5.2-1 1.6 2.7 3.8 5 3.7 10.6-2.5-1.2-4.9-3.3-8-2 5 10-1.2 23.6-17 26.8 5.8-6.8 8.6-14 8.6-21.3 0-23.5-6.5-27.4-6.5-43.8a24 24 0 0 1 10.5-19.2v.3A14 14 0 0 1 68 145a62 62 0 0 1 34 .3 25 25 0 0 1 18 12 36 36 0 0 1 0 28.9c-6.3 13-35.7 75.6-44.9 95.2-2 4.2-3.1 8.6-3.1 13.4 0 12 11 16.2 17.2 16.2 7.5 0 15.2-5.7 15.2-12.8 0-4.5-2.5-7.3-6-7.3-8.5 0-8 7.2-6.3 11.8-5.3-2.4-8.3-6.6-7.5-11a14 14 0 0 1-8.4-4.8c2-2.6 4.6-4.6 8.4-4.7-1.7-6.9 3-9.8 7.5-11.4-1.4 5-2.4 10.9 6.3 10.9 6.3 0 11.2 1 14.1 5.2l.7-27c.4-8.1-10.8-8-18-5.5 2.7-9.3 8.2-14.4 21-13.1a10 10 0 0 1-6.4-9.8c0-7.6 6.2-16 10.2-18.5l2 79z"
                    }),
                    /* @__PURE__ */ jsx143("use", {
                      xlinkHref: "#kz_svg__d",
                      width: "100%",
                      height: "100%",
                      transform: "matrix(1 0 0 -1 0 645)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx143("use", {
                  xlinkHref: "#kz_svg__e",
                  width: "100%",
                  height: "100%",
                  transform: "matrix(-1 0 0 1 240 0)"
                })
              ]
            }),
            /* @__PURE__ */ jsx143("use", {
              xlinkHref: "#kz_svg__f",
              width: "100%",
              height: "100%",
              transform: "matrix(1 0 0 -1 0 1000)"
            })
          ]
        })
      ]
    })
  ]
});
var Kz_default = SvgKz;

// src/country-flag-icons/generated/La.tsx
import { jsx as jsx144, jsxs as jsxs137 } from "react/jsx-runtime";
var SvgLa = (props) => /* @__PURE__ */ jsxs137("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx144("defs", {
      children: /* @__PURE__ */ jsx144("clipPath", {
        id: "la_svg__a",
        children: /* @__PURE__ */ jsx144("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs137("g", {
      fillRule: "evenodd",
      clipPath: "url(#la_svg__a)",
      children: [
        /* @__PURE__ */ jsx144("path", {
          fill: "#ce1126",
          d: "M-40 0h720v480H-40z"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#002868",
          d: "M-40 119.3h720v241.4H-40z"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fff",
          d: "M423.4 240a103.4 103.4 0 1 1-206.8 0 103.4 103.4 0 1 1 206.8 0"
        })
      ]
    })
  ]
});
var La_default = SvgLa;

// src/country-flag-icons/generated/Lb.tsx
import { jsx as jsx145, jsxs as jsxs138 } from "react/jsx-runtime";
var SvgLb = (props) => /* @__PURE__ */ jsxs138("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx145("defs", {
      children: /* @__PURE__ */ jsx145("clipPath", {
        id: "lb_svg__a",
        children: /* @__PURE__ */ jsx145("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs138("g", {
      clipPath: "url(#lb_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsxs138("g", {
          fillRule: "evenodd",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx145("path", {
              fill: "#EE161F",
              d: "M-128 384h768v128h-768zm0-384h768v128h-768z"
            }),
            /* @__PURE__ */ jsx145("path", {
              fill: "#fff",
              d: "M-128 128h768v256h-768z"
            })
          ]
        }),
        /* @__PURE__ */ jsx145("path", {
          fill: "#00A850",
          d: "M252.1 130c-7.8 15.5-13 15.5-26 26-5.2 5.1-13 7.7-2.6 13-10.5 5.1-15.7 7.7-20.9 18.1l2.6 2.6s10-4.8 10.4-2.6c1.8 2.1-13 10-14.9 11.3l-11 7c-13.1 10.3-21 7.7-28.7 23.3l26-2.6c5.2 18.2-13 20.8-26 28.6l-20.9 13c5.3 18.2 20.9 7.8 33.9 2.6l2.6 2.6v5.2l-26 13s-30.8 17.6-31.3 18.2c-.2 1 0 5.2 0 5.2 10.4 2.6 26 5.2 36.5 0 13-5.2 15.6-10.4 31.2-10.4a100.6 100.6 0 0 1-52 20.8v10.4c15.6 0 26 0 39-2.6l33.8-10.4c7.8 0 15.7 7.8 13 15.6-7.7 28.6-39 23.4-49.4 46.8L213 369c10.4-5.2 20.8-10.3 33.8-7.7 15.6 5.2 15.6 15.6 36.4 20.8l-5.2-13c5.2 2.6 10.4 2.6 15.7 5.2 13 5.2 15.6 10.4 31.2 7.8-13-15.6-15.6-13-26-23.4-10.4-15.6-15.7-39 0-41.6l18.2 5.2c18.2 2.6 18.2-2.6 44.2 7.8 15.7 5.2 20.9 13 39 7.8-7.7-18.2-36.3-31.2-54.6-36.4 20.9-13 15.6 5.2 44.3-2.6v-5.2C369.3 278 361.4 265 332.8 265l44.3-5.2v-5.2s-43.7-11.4-44.7-11.9c.3-1.3 1.4-3.3 4.3-4.5 8.3 5.4 33.3 4.8 34.8 4.7-.8-6.4-12.7-11.7-23-16.9 0 0-44.7-27.5-44.9-29.9.9-7 18.3 1.1 37 6.5-5.2-10.4-15.6-15.6-26-18.2l15.6-2.6c-10.4-23.4-36.4-20.8-52-31.2-10.5-7.8-10.5-13-26.1-20.7z"
        }),
        /* @__PURE__ */ jsx145("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 3.2,
          d: "M224 303c1.9-6.1 4.4-11.6-7.2-16.9-11.6-5.3 5.8 21.1 7.2 17zm13.7-12.3c-2.3.3-3.6 8.8 1.1 11.2 5.2.8 1-11.1-1.1-11.2m13.5-1c-2.4.8-2.5 12.8 6 10.6 8.6-2.1 0-11.5-6-10.5zM267 259c1.8-3-.1-15-7.4-10-7.4 5.1 5 10.8 7.4 10m-16-10c2.3-.9 2.5-8.3-4-6.3-6.3 1.9 2.3 7.8 4 6.3m-14.4 2.9s-4.5-6.2-8-4.9c-4.3 4.2 8.3 5 8 4.9M187 271.7c1.9.2 16-2.3 20.9-7.8 4.9-5.5-25.1 2.3-25.1 2.4 0 .1 2.8 4.9 4.2 5.4m141.1-35c.7-1.3-7.5-7.1-12.4-4.8-1.3 4.3 12.4 5.7 12.4 4.8m-27.8-14c1.6-2.2-3.5-11.3-13.7-6.2-10.2 5 10.7 9.8 13.7 6.3zm-32.1-5.3s2.5-8.2 8.6-6.6c7 5.3-8.3 6.9-8.6 6.6m-6-6.2c-1-2.3-7.3-1-14.6 3.9-7.4 4.7 16.8 1.4 14.6-4zm18.7-22.1s6.5-3 8.5 0c2.7 4.3-8.6 0-8.5 0m-5.5-2.9c-1.3-2.6-8.5-2.9-8.3 1-1.2 3 9.4 2.4 8.3-1m-17.2 0c-.7-1.5-11 0-14 6.2 5 2.4 16.3-2.3 14-6.2m-22 6.3s-13.4 8.3-14.3 14.3c.4 5.2 16.8-9.4 16.8-9.4s1.4-5.8-2.4-4.9zm-14.9-7.5c.4-1.7 6.7-5.6 7.2-5.3.5 1.7-5.1 6.3-7.2 5.3m4.3 31.6c.3-2.5-16-2.3-9.9 5.2 5.2 6.3 11-4.1 9.9-5.2m-15 10.7c-.8-1.6-2-6-4.2-6.4-1.9 0-11.7 2-12.5 3.6-.4 1.3 4.1 9.4 5.6 9.6 1.8.7 10.9-6 11.2-6.8zm88.4 55.2c.5-1.8 17.3-7.5 23-2 6.8 9.3-23.4 5-23 2m46 10.9c3.7-6.2-11.3-13.6-17.6-6.5 2.2 8.5 14.6 11.6 17.6 6.5"
        })
      ]
    })
  ]
});
var Lb_default = SvgLb;

// src/country-flag-icons/generated/Lc.tsx
import { jsx as jsx146, jsxs as jsxs139 } from "react/jsx-runtime";
var SvgLc = (props) => /* @__PURE__ */ jsx146("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs139("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx146("path", {
        fill: "#65cfff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx146("path", {
        fill: "#fff",
        d: "m318.9 42 162.7 395.3-322.6.9z"
      }),
      /* @__PURE__ */ jsx146("path", {
        fill: "#000001",
        d: "m319 96.5 140.8 340-279 .8z"
      }),
      /* @__PURE__ */ jsx146("path", {
        fill: "#ffce00",
        d: "m318.9 240.1 162.7 197.6-322.6.5z"
      })
    ]
  })
});
var Lc_default = SvgLc;

// src/country-flag-icons/generated/Li.tsx
import { jsx as jsx147, jsxs as jsxs140 } from "react/jsx-runtime";
var SvgLi = (props) => /* @__PURE__ */ jsxs140("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx147("path", {
      fill: "#002b7f",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx147("path", {
      fill: "#ce1126",
      d: "M0 240h640v240H0z"
    }),
    /* @__PURE__ */ jsxs140("g", {
      fill: "#ffd83d",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transform: "scale(.8)",
      children: [
        /* @__PURE__ */ jsxs140("g", {
          id: "li_svg__a",
          children: [
            /* @__PURE__ */ jsx147("path", {
              stroke: "none",
              d: "m216.4 122.3-1.9 62.5h-63.4c-7.8-15.2-14.2-28-14.2-45.5 0-14.6 11.5-26.2 28-26.2 17.5 0 36.8 5.9 51.5 9.2"
            }),
            /* @__PURE__ */ jsxs140("g", {
              strokeWidth: 1.5,
              children: [
                /* @__PURE__ */ jsx147("path", {
                  d: "M144.5 125.2v36m5-39.7v48m5.2-50.5v57.2m5-58.4v44.9m5.1-45.1v45.3m5.1-47v47m5.1-47v47m5.1-46.5v47m5.1-46.5v46.9m5.1-44v47m5-46.5v52.9m5.2-52.9v47m5-47v47"
                }),
                /* @__PURE__ */ jsx147("path", {
                  fill: "#000001",
                  d: "M176.4 118c10.8 1.7 34.4 12.8 31.7 27.7-3.8 21.2-16.2 12.7-32.6 9.7l-12.4 4.1c-4.5 4.5-11 8.7-15.4 3.2h-7.4v28.8h81.4V122z"
                })
              ]
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 212.8,
              cy: 113,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 201.7,
              cy: 110.3,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 190.4,
              cy: 107.5,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 179.1,
              cy: 105.6,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 167.8,
              cy: 104.5,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 156.8,
              cy: 105.1,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 146.2,
              cy: 108.7,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 137.3,
              cy: 115.3,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 131,
              cy: 124.4,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 127.9,
              cy: 135.2,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 128,
              cy: 146.3,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 130.2,
              cy: 157.2,
              r: 4.9
            }),
            /* @__PURE__ */ jsx147("path", {
              d: "m215 119.5-.5 6.5c-12.3-2-29.7-8.8-46-8.8-15 0-26.6 6-26.6 21.2 0 14.9 6.3 28.5 14.7 42.3l-8.7 4c-7.8-15-14.3-28-14.3-45.4 0-14.6 11.5-29 31.3-29 17.5 0 35.4 6 50.1 9.2"
            })
          ]
        }),
        /* @__PURE__ */ jsx147("use", {
          xlinkHref: "#li_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 444 0)"
        }),
        /* @__PURE__ */ jsx147("path", {
          d: "m222 53.1-5.2 9.7 5.2 9.6 5.1-9.6L222 53zm0 24.4-5.2 9.6 5.2 9.7 5-9.8zM203.6 75l8.1 5.1 8.1-5.1-8-5.2zm20.5 0 8.1 5.1 8.2-5.1-8.2-5.2z"
        }),
        /* @__PURE__ */ jsx147("circle", {
          cx: 222,
          cy: 75.1,
          r: 3.9
        }),
        /* @__PURE__ */ jsx147("circle", {
          cx: 222,
          cy: 100,
          r: 10.5
        }),
        /* @__PURE__ */ jsx147("path", {
          fill: "none",
          strokeWidth: 1.5,
          d: "M219.3 89.9v6.6a62.5 62.5 0 0 0-7.4.8m20.2 0a62.1 62.1 0 0 0-7.5-.8v-6.6m-12.8 12.7a61.4 61.4 0 0 1 10.2-.9c3.4 0 6.8.3 10 .9"
        }),
        /* @__PURE__ */ jsx147("path", {
          d: "M211.8 117.7c-1 17-3 34.5-9.7 47.1l10.8-4.4c3.8-14.3 4.6-32.8 5.7-41.6zm20.4 0-6.9 1.1c1.2 8.8 2 27.3 5.7 41.6l10.8 4.4c-6.6-12.6-8.6-30-9.6-47.1"
        }),
        /* @__PURE__ */ jsx147("path", {
          d: "M222 154.7c-13 0-22.5 6-23 21.6-3.2-5.6-16.5-23-29-20.7-7.4 1.4-14 11.7-12.8 23.4-6.2-17.6-24.1-20.5-37.3-10 11.7 9.5 16.9 37.8 26.7 50h150.7c9.8-12.2 15-40.5 26.7-50-13.1-10.5-31.1-7.6-37.2 10 1-11.7-5.5-22-13-23.4-12.4-2.3-25.7 15.1-28.9 20.7-.5-15.5-10-21.6-23-21.6z"
        }),
        /* @__PURE__ */ jsxs140("g", {
          strokeWidth: 1.5,
          children: [
            /* @__PURE__ */ jsx147("path", {
              fill: "#000001",
              d: "M297.1 219c0 5.6-33.6 11.7-75.1 11.7s-75.2-6-75.2-11.7c0-5.5 33.7-8.5 75.2-8.5 41.4 0 75.1 3 75.1 8.5"
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 222,
              cy: 114.4,
              r: 3.5
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 222,
              cy: 122,
              r: 3.7
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 222,
              cy: 130.2,
              r: 4.1
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 222,
              cy: 139.3,
              r: 4.7
            }),
            /* @__PURE__ */ jsx147("circle", {
              cx: 222,
              cy: 149.4,
              r: 5.1
            }),
            /* @__PURE__ */ jsx147("path", {
              fill: "#000001",
              stroke: "none",
              d: "M220 159.2c-.6 0-1.1.5-1 1.4l.6 4.3c.2 1.5 1 1 1.3 0 .2-1.2.1-2 .2-4.1 0-1.1-.6-1.6-1.2-1.6zm4 0c-.6 0-1.1.5-1.1 1.6 0 2.1 0 2.9.2 4 .2 1.2 1 1.6 1.3 0l.5-4.2c.2-1-.4-1.4-.9-1.4m-7.7.6a1 1 0 0 0-1 1c0 1 .3 2.3.4 3.8.2 1.5 1.3 1 1.4 0 0-.8.2-2.2 0-3.9 0-.6-.2-.9-.6-1a.8.8 0 0 0-.2 0zm11.1 0c-.3 0-.6.3-.7 1a20.1 20.1 0 0 0 .2 3.8c0 1 1.2 1.5 1.3 0 0-1.5.4-2.7.4-3.7 0-.6-.5-1-1-1.1a.8.8 0 0 0-.2 0m-15.4 1.7c-.5.1-1 .7-.8 1.3.3 1.3.6 2.7.6 4 0 1.1.9.7 1 0a59.8 59.8 0 0 0 .1-4c0-1-.5-1.4-1-1.3zm19.6 0c-.3.1-.6.5-.6 1.3l.2 4c0 .7 1 1.1 1 0 0-1.3.2-2.7.5-4 .2-.6-.3-1.2-.7-1.3a.6.6 0 0 0-.3 0zm-59 .2c-.6 0-1 .7-.6 1.5.6 1.4 1.3 2.2 1.9 3.6.5 1.3 1.4.5 1.1-.4l-1.4-3.7c-.3-.7-.7-1-1-1m98.8 0c-.4 0-.7.3-1 1-.9 1.9-1.2 2.8-1.5 3.7-.2 1 .6 1.7 1.2.4l1.8-3.6c.4-.8 0-1.5-.5-1.5m-94.8 0c-.5.2-.7.7-.5 1.3.6 1.2 1.3 2.5 1.8 3.8.4 1.1 1.4.8 1-.2l-1-3.7c-.4-1-1-1.3-1.3-1.2m90.5 0c-.4.1-.8.5-1 1.2-.7 2-.8 2.6-1.1 3.7-.4 1 .6 1.3 1 .2l1.8-3.8c.2-.6 0-1.1-.4-1.3a.6.6 0 0 0-.3 0m-85.5 1c-.6.1-1 .9-.6 1.9.4 1.2 1 2.3 1.6 3.7.6 1.4 1.5 1.1 1.3.2-.3-.9-.5-2.3-1.2-4.5-.3-1-.7-1.4-1.1-1.3m80.8 0c-.4 0-.9.3-1.2 1.3-.6 2.2-1 3.6-1.1 4.5-.3 1 .7 1.2 1.2-.2.6-1.4 1.2-2.5 1.6-3.7.4-1 0-1.8-.5-1.9m-93.2.7c-.6 0-1 1-.7 1.7.5 1 .9 1.4 1.4 2.6.6 1.2 1.2.3 1-.5-.3-.8-.6-1.7-.8-2.8-.2-.8-.6-1-1-1zm105.6 0c-.4 0-.7.2-1 1l-.7 2.8c-.2.8.4 1.7 1 .5.5-1.2.8-1.5 1.4-2.6.3-.7-.2-1.6-.7-1.7m-67 2.8c-.7 0-1.3.8-1 1.5.2 1.2.8 2.2 1.1 3.7.4 1.3 1.3.7 1.2-.2a28.7 28.7 0 0 0-.5-4c-.2-.7-.5-1-.9-1zm28.4 0c-.3 0-.7.3-.8 1a28.7 28.7 0 0 0-.6 4c0 .9.9 1.5 1.2.2l1.2-3.7c.2-.7-.4-1.5-1-1.5m-14.2 1.2c-.8 0-.9 1-.9 1.7a12.3 12.3 0 0 1-2 6.4c-1 1.2-2.3.9-3.5.2a22.3 22.3 0 0 1-3.3-2.2c-1.4-1-2.4-.4-.8 1.9 4.6 6.6 9.6 12.2 9.6 23 0 1.3.3 1.7.9 1.7s.8-.4.8-1.8c0-10.7 5-16.3 9.6-23 1.6-2.2.6-2.8-.7-1.8a21 21 0 0 1-3.3 2.2c-1.3.7-2.6 1-3.5-.2a12.3 12.3 0 0 1-2-6.4c-.1-.7-.2-1.7-1-1.7zm-35.3-1.6a.6.6 0 0 0-.2 0c-.3.1-.4.4-.3 1l1.1 3.9c.3 1 1.4.7 1.2-.5l-.6-3.1c-.2-.8-.8-1.3-1.2-1.3m70.6 0c-.5 0-1 .5-1.2 1.3-.4 1.4-.4 1.8-.6 3-.3 1.3.9 1.5 1.1.6l1.2-4c0-.5-.1-.8-.4-.9a.6.6 0 0 0-.2 0zm-91.6.4c-.6 0-1 .8-.4 1.8.6 1.2 1.7 2.6 2.2 3.5.5.8 1.4.2.8-.8-.6-1-.8-2.3-1.6-3.8a1 1 0 0 0-1-.7m112.5 0c-.3 0-.7.2-1 .7-.7 1.5-1 2.7-1.5 3.8-.6 1 .2 1.6.7.8.5-.9 1.6-2.3 2.2-3.5.6-1 .2-1.8-.4-1.8M134 169.5c-.6 0-.8 1.2-.2 2a19.2 19.2 0 0 0 2.6 2.7c.8.8 1-.2.6-1l-1.8-2.7c-.5-.7-.9-1-1.2-1m175.9 0c-.3 0-.7.3-1.1 1l-1.9 2.7c-.4.8-.2 1.8.7 1a19 19 0 0 0 2.6-2.7c.6-.8.4-2-.3-2m-170.8 1c-.6 0-1 .4-.5 1.3l1.9 3.8c.5 1 2 1.3 1.4-.2l-1.3-3.8c-.3-.7-1-1-1.5-1zm165.8 0c-.6 0-1.3.4-1.6 1.1l-1.2 3.8c-.6 1.5.9 1.2 1.4.2.5-1 1.3-2.5 1.8-3.8.5-.9.1-1.3-.4-1.3m-175.6.4c-.8 0-.8.7-.1 1.2.9.7 2 1.4 3 2.3 1.3 1 1.7 0 1-.8-.6-.8-1.2-1.6-2.9-2.5-.4-.2-.7-.2-1-.2m185.3 0c-.2 0-.6 0-1 .2-1.6.9-2.3 1.7-3 2.5-.6.9-.1 1.8 1.1.8 1-.9 2.2-1.6 3-2.3.8-.5.7-1.2 0-1.2zm-109.6.7c-.5 0-.8.5-.7 1.2l1 3.6c.2 1.1 1.5 1.1 1.3 0-.2-1-.3-2.3-.7-3.9-.1-.6-.4-.9-.8-1a.6.6 0 0 0-.1 0zm33.8 0c-.3 0-.6.3-.8 1-.4 1.5-.5 2.8-.7 3.9-.2 1 1.1 1 1.3-.1l1-3.6c.2-.7-.2-1.2-.6-1.2a.6.6 0 0 0-.2 0m-64-2c-.3 0-.5.7-.2 1.7a26 26 0 0 1 1.6 9c-.3 1.2-1 1.3-1.9 1a18.8 18.8 0 0 1-2.8-1.7c-.8-.5-1.7.1-.5 1.1 6 5 10.3 10.7 12 17.6.2 1.4 1.1 1.6.9 0-1.4-8.7-1.7-15.9.4-20.3.8-1.7 0-3.3-1.2-.6-.9 1.8-2.2 2.5-3.3 1a47.9 47.9 0 0 1-4-7.7c-.2-.7-.5-1-.8-1.1a.3.3 0 0 0-.1 0zm94.1 0c-.3 0-.6.4-.8 1-.7 2-2.9 6.2-4 7.8s-2.4.8-3.2-1c-1.3-2.7-2-1.1-1.3.6 2.1 4.4 1.8 11.6.5 20.3-.3 1.6.6 1.4 1 0a32.4 32.4 0 0 1 11.8-17.6c1.2-1 .3-1.6-.5-1a18 18 0 0 1-2.8 1.5c-1 .4-1.6.3-1.9-1-.2-1.2.2-3.9 1.7-9 .2-.8 0-1.5-.3-1.6a.3.3 0 0 0-.2 0M144.4 172c-.5 0-1 .4-.7 1.2.4 1.4 1.2 2.8 1.5 3.6.3.9 1.2.5 1-.7l-.5-3.1c0-.6-.7-1-1.3-1m155.1 0c-.6 0-1.2.4-1.3 1l-.4 3.1c-.2 1.2.7 1.6 1 .7.2-.8 1-2.2 1.4-3.6.3-.8-.1-1.2-.7-1.2m-136.3-1.7c-.6-.1-.7 1.5-.2 2.2l2.8 3.1c.8 1 1.3.1.8-.7l-2.6-3.8c-.3-.5-.6-.8-.8-.8m117.5 0c-.2 0-.5.3-.8.8l-2.6 3.8c-.5.8 0 1.7.9.7l2.7-3.1c.5-.7.5-2.3-.2-2.2m-132 4c-.4 0-.7.2-.5 1 .2 1.2.5 2 .8 3.1.3 1 1 .9 1-.1l-.3-3.2a1.1 1.1 0 0 0-1-.9zm146.5 0a1 1 0 0 0-1 .8l-.3 3.2c0 1 .8 1.2 1 .1l.9-3c.2-.9-.2-1.2-.6-1.2zm-133.4 1.4c-.6 0-1.1.7-.4 1.6 1.1 1.5 2.4 2.5 2.9 3 .4.6 1.5.4.8-.7l-2.3-3.5c-.2-.4-.6-.5-1-.4m120 0c-.2 0-.5.1-.6.4l-2.4 3.5c-.7 1.1.4 1.3.9.8.4-.6 1.7-1.6 2.9-3.1.7-1 .1-1.6-.5-1.6a.9.9 0 0 0-.2 0zm-140.7 4.1c-.4 0-.6.4 0 1.3a17 17 0 0 1 3.3 6.4c.1 1.4-.5 1.4-1.1 1.4-1.9 0-2.8-1.4-4.4-1.8-1.7-.3-2 .5-.8 1.4a53.4 53.4 0 0 1 14.7 13.8c1 1.9 2.3 2.5 1.6.8a23.7 23.7 0 0 1-2.4-12.6c.5-2.8 1.2-4.6 1.1-6.2 0-1.5-1-1.4-1.3 0l-1 2.8c-.4.5-1.8.8-3-.9a48 48 0 0 0-5.6-5.8c-.3-.3-.7-.5-1-.6zm161.7 0c-.3 0-.7.2-1.1.6a48.2 48.2 0 0 0-5.5 5.8c-1.3 1.7-2.7 1.4-3 1a12 12 0 0 1-1-2.9c-.4-1.4-1.3-1.5-1.4 0 0 1.6.6 3.4 1.1 6.2s0 7.2-2.3 12.6c-.8 1.7.6 1 1.6-.8a53 53 0 0 1 14.6-13.8c1.2-.9 1-1.7-.7-1.4-1.7.4-2.6 1.8-4.4 1.8-.6 0-1.3 0-1.2-1.4.1-1.3 1.8-4.4 3.3-6.4.6-1 .5-1.3 0-1.3"
            }),
            /* @__PURE__ */ jsx147("path", {
              d: "m150.1 212.7 2 6.1m2-7.3 1.8 6.2m2.6-7 1.2 6.4m2.8-7.1 1.3 6.3m3.8-6.8 1 6.4m4.5-6.4 1.1 6.3m4.3-8.1.8 6.4m4.2-6.1.8 6.4m4.1-7 .8 6.4m4-7 .5 6.5m4.8-6.5.4 6.5m4.4-6.8.3 6.5m4.9-6.8.3 6.4m5.7-6.6.3 6.5m79 .2-2 6.1m-2-7.3-1.7 6.2m-2.6-7-1.2 6.4m-2.8-7.1-1.3 6.3m-4-6.8-1 6.4m-4.4-6.4-1.1 6.4m-4.2-8.2-.8 6.4m-4.3-6.1-.8 6.4m-4-7-.9 6.4m-4-7-.5 6.5m-4.8-6.5-.4 6.5m-4.3-6.8-.3 6.5m-5-6.8-.2 6.4m-5.8-6.6-.2 6.5m-7.2-7v7.2"
            })
          ]
        })
      ]
    })
  ]
});
var Li_default = SvgLi;

// src/country-flag-icons/generated/Lk.tsx
import { jsx as jsx148, jsxs as jsxs141 } from "react/jsx-runtime";
var SvgLk = (props) => /* @__PURE__ */ jsxs141("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx148("path", {
      fill: "#ffb700",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx148("path", {
      fill: "#ff5b00",
      d: "m26.7 240 88-213.3h88v426.6h-88z"
    }),
    /* @__PURE__ */ jsx148("path", {
      fill: "#005641",
      d: "M26.7 26.7h88v426.6h-88z"
    }),
    /* @__PURE__ */ jsx148("path", {
      fill: "#8d2029",
      d: "M229.3 26.7H616v426.6H229.3z"
    }),
    /* @__PURE__ */ jsx148("path", {
      id: "lk_svg__a",
      fill: "#ffb700",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M579.3 408.6s3.6 7.3 7.6 10.4c6 4.4 18 4 23.3 9.3 6.1 6.1-.5 14.2-.5 15l.4 4.2s-4.2 0-6 .3c-2.6.4-3.6 2.6-8.6 2.3-12.3-.8-11.8-12-12.5-21.5-.6-3.6-2-8.4-2.9-12-.7-3-.8-8-.8-8z"
    }),
    /* @__PURE__ */ jsx148("use", {
      xlinkHref: "#lk_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 845.3 0)"
    }),
    /* @__PURE__ */ jsx148("use", {
      xlinkHref: "#lk_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(1 0 0 -1 0 480)"
    }),
    /* @__PURE__ */ jsx148("use", {
      xlinkHref: "#lk_svg__a",
      width: "100%",
      height: "100%",
      transform: "rotate(180 422.7 240)"
    }),
    /* @__PURE__ */ jsxs141("g", {
      transform: "translate(0 -76)",
      children: [
        /* @__PURE__ */ jsx148("use", {
          xlinkHref: "#lk_svg__b",
          width: "100%",
          height: "100%",
          stroke: "#000",
          strokeWidth: 5.6
        }),
        /* @__PURE__ */ jsxs141("g", {
          id: "lk_svg__b",
          fill: "#ffb700",
          children: [
            /* @__PURE__ */ jsx148("path", {
              d: "m363.5 415.8 2.3-1.4 1 1.4c1.3 1.8 5 1.7 7.4 0l1.9-1.5 1.6 1.4c2 1.9 5.8 1.9 8.3 0 1.7-1.2 2-1.3 3-.3.7.6 2.7 1.2 4.4 1.5 3.2.4 3.2.4 5-2.4 1.6-2.3 1.8-3.2 1.5-5.5a59.4 59.4 0 0 1-.6-5.3c-.2-2.6-.1-2.6 3.6-4a50.5 50.5 0 0 0 5.4-2c1.5-.9 5.7-5.8 5.7-6.8 0-.2-1.6-.6-3.6-.8-8-1-9.3-5.2-4.1-13 8.3-13 13.4-25.5 13.4-33.4 0-3.6.3-4.8.7-4 1.9 3.1-1.5 16.4-6.5 26l-2 3.8 1.9-.4c1-.3 7.4-3 14-6 18.2-8.2 24.4-9.8 36.2-9.3 9.9.4 14 2.3 21 9.6 3.7 4 7.3 6.7 13.8 10.8 13.8 8.6 14.4 9.4 15.1 19.6.7 10.3.3 10.9-7.5 12.6-6.7 1.5-10.9 4.6-12 9-.6 2.2.7 2.3 4 .1l2.5-1.6 1.1 1.6c1.5 2.1 4.5 2.1 7 0l2-1.5 2 1.5c3 2.5 7 1.9 8.2-1.2.2-.5.8-.4 2 .7 2.3 2 8 2.8 8.6 1.2.2-.6-.2-2-1-3.2-3.3-5-4.4-7.3-4.4-10 0-3.8 1-5.7 5.4-8.7 5.2-3.8 6.8-8.6 2.8-8.6-2.4 0-4.9-2.2-6.5-5.7-3.2-7.2-2.5-15.2 2.3-28.6a57.6 57.6 0 0 0 5.4-25.2c0-7.4-.2-8.6-1.8-12.7a45.4 45.4 0 0 0-4.6-8.1l-2.8-3.7 3.5-3c10.8-8.9 8.6-23.5-4.4-29.1-4-1.8-5-1.9-12-1.9-4 0-10.5.6-14 1.3a98.2 98.2 0 0 1-14.2 1.2c-6.8 0-8-.2-10.6-1.6-2.7-1.4-3.2-2.1-3.7-5.5a2 2 0 0 0-1.1-1.5c-1-.3-5.2 3.4-5.8 5-.4.9-.6.8-1.5-.3a13.4 13.4 0 0 1-2-3.6c-1-3.3.3-5.7 4.2-7.6l3-1.4-1.8-1.1c-3.6-2.3-9.8-.7-12 3-.7 1-1.4 2-1.6 2-.2 0-1.4-1-2.6-2.3-4.7-4.6-3.1-11.4 3.2-13.4 3.3-1.1 6.3-.3 6.9 2 1 3.3 3.8-1.1 3.3-5.2-.3-2.7-.3-2.8 1.6-2.8 2.6 0 8 3.4 9.8 6 2 3.1 1.8 8-.4 11.6l-1.7 2.8 2.3-.4c3.2-.7 6.4-2.7 8-5.2a12 12 0 0 0 .4-10.4c-1.5-2.7-1.3-3.1.9-2.2 3.6 1.5 5.6 3.2 7 6.1 1.4 2.6 1.5 3.2.8 6a17 17 0 0 1-2.2 4.8c-1.2 1.6-1.3 1.9-.3 1.9 1.8 0 5.4-1.7 6.7-3 .7-.8 1.7-2.5 2.2-4l1-2.5 1 2c1.5 2.7 4.5 5.2 8.1 6.8 3.9 1.6 5.5 1.7 3.5.2-1.4-1-4-8.5-3.1-9.2a51 51 0 0 1 11.7 9c5.7 5.1 9.3 6.8 14.5 6.8 6.7 0 10.6-5.8 7.6-11.3-1.7-3.2-5.6-3.7-8-1-1 1.3-1.3 2.3-1 3.7.4 1.6.3 1.8-1.2 1.8-2 0-5.8-2.5-12.6-8.2a102 102 0 0 0-32.1-18.7 70.4 70.4 0 0 0-24.3-1.3c-6.4 1.2-14 4.9-18.2 8.8-7.3 7-7.4 16.3-.3 24.8l2 2.4-1.3 2.2a9.3 9.3 0 0 0 .4 10.4c1 1.4 2 2.5 2.3 2.5.2 0 .4-.9.5-2 .2-2.7 1.4-4.5 3.4-5.2 1.8-.7 3-.3 11.2 3 8.7 3.4 23 3.6 38.2.6a42.6 42.6 0 0 1 20 .2c7.2 3 8.8 10.7 3.6 16.5-2.3 2.6-4.4 3.6-11.7 5.6a54.3 54.3 0 0 1-19.5 1.5c-10.8-.1-14.7.1-19 1-4.9 1-7.8 1.1-21.8.8l-16.3-.4 1.8 1.4a22 22 0 0 0 3.1 2.3c1.3.7 1.2.8-.6 1.5-1 .4-3.4.7-5.3.7h-3.3l-.4 2.8a10 10 0 0 0 0 4c.4 1 .2 1.2-.8.8-.7-.3-2.6-.8-4.3-1.1a26.7 26.7 0 0 1-5-1.6c-1.9-1-2.1-1-2.8.3-.6 1-6.2 5.2-7 5.2a26.7 26.7 0 0 0-2.2-7.5c-1-2.1-1.9-4.5-2.2-5.2-.3-1.1-.5-1.2-1-.3-.3.5-.7 2-1 3.2a15.5 15.5 0 0 1-1.8 4.6l-1.5 2.2-1-1.9c-1-2-2.6-4.2-3.2-4.2-.2 0-.5.6-.7 1.5-.5 1.6-4.4 6.3-5.4 6.3-.3 0-.6-1.3-.6-3 0-1.5-.3-2.9-.7-2.9-.4 0-.7.5-.7 1 0 1.2-3.3 5-4.5 5-.4 0-1.2.4-1.7 1-1.2 1.3-2.2 1.1-1.7-.4a9 9 0 0 0-.4-3.8l-1-3.2c-.2-.5-1.4-.3-4 .5-4 1.3-5.4 1-3.3-.6.8-.6 2-2.7 2.6-4.6.7-2 1.7-3.7 2.2-3.9.7-.2.7 0-.2 1.2a5.7 5.7 0 0 0-1.1 2.6c0 .5-.5 1.8-1 2.9-.6 1-1 2-.9 2.1s1.7-.5 3.5-1.3l3.2-1.6v1.4c0 .8.4 2.8.9 4.5l.9 3 2.2-1c2.2-1 4.3-4.6 4.3-7.5 0-1.4.8-1.2 1.2.3 0 .4.6 2.1 1 3.7l1 2.8 1.5-1.8c.9-1 1.9-3 2.3-4.3.8-2.4 2-3.5 2-1.7 0 1.2 3.4 5.8 4 5.4.4-.2 1-1.9 1.5-3.8 1-4 2.5-6.6 3.5-6 .4.2.5.6.3 1-.2.2.6 2.8 1.8 5.6a2557.7 2557.7 0 0 1 2.6 6.3c.4 1 .8 1 3.3-1.3 1.5-1.4 3-2.9 3.1-3.4.3-.8.6-.7 2 .2a25 25 0 0 0 9.5 2.8c.2-.2.4-2 .4-4l.1-3.7 2 .4c1 .3 3.3.3 5 0l3-.4-2.7-2c-1.5-1-3-2.3-3.4-2.9-.3-.6-1.7-1.2-3.2-1.3-4.1-.4-11.4-4.4-11.4-6.4 0-.4 1 .3 2.2 1.4 2.8 2.5 6.6 4 10 4h2.4l-1.5-2a11.9 11.9 0 0 1-2-5.2c-.2-3-.5-3.4-3.6-5.5a35.2 35.2 0 0 1-5-4.3l-1.7-1.9-.9 2.3c-.5 1.3-1 2.3-1.3 2.3-.2 0-1.2-.8-2-1.7a7 7 0 0 0-2-1.6c-.3 0-1 1.2-1.8 2.7l-1.4 2.7-1-1.5a23.8 23.8 0 0 0-3-3.4c-1.2-1-1.7-1.8-1.3-1.8.4 0 1.7 1 3 2.3l2.2 2.3 1-1.7a6 6 0 0 0 .5-3.8c-.4-1.8-.3-1.9.3-.7a16 16 0 0 0 3 3l2.2 1.8 1.5-2.7c1.5-2.8 1.5-2.8 2.1-1.1 1 2.1 7.5 7.5 13 10.6 1 .5.6-1.1-1-5a12.7 12.7 0 0 1-.8-4c0-1.8-.5-2.6-2.8-4.4a10.9 10.9 0 0 1-5-8.4c-.3-1.7-.9-3.5-1.4-4.1-.6-1-.8-.4-.6 2.6.2 2.1-.1 4.7-.6 5.8l-.8 2-.6-1.7c-.4-.9-2-2.5-3.5-3.5s-2.6-2-2.4-2.2c.2-.2 1.8.7 3.5 2 2.7 2.1 3.2 2.3 3.6 1.4.4-1 0-5.6-.8-8.8-.4-1.6-.4-1.6 1.6.4 1.4 1.4 2.2 3.2 2.9 6.2.8 3.8 1.2 4.5 4.7 7.6 2.1 1.9 4 3.3 4.1 3.2.2-.2.4-5 .6-10.8.4-11.1 0-13.8-2.7-17.2l-1.4-1.8 2.2-2.3a16 16 0 0 0 4.7-8.8l.4-2.7-2.4 2.3c-2 1.9-3 2.3-5.3 2.3s-3.2-.4-4.7-2a20 20 0 0 0-8.3-4.8c-1.2-.4-1.6-.2-1.6.6 0 .6-.6 2.2-1.4 3.7l-1.4 2.6-3-3c-1.9-1.7-4-3.2-5.7-3.6-4.1-1-4.3-1-4.3 2.1 0 4.7-2 5.6-5.6 2.5-2.8-2.4-5-3-10.3-2.3l-4 .4.7 1.8c.6 1.5.5 2.2-.8 3.9-2.1 2.8-4.8 4-9 4-2 0-4.4.4-5.4.9s-3.6 1-5.7 1.2c-2 .2-4.3.6-5 .8-1 .4-1 0-.7-2.2.5-3.4-2-6-5.7-6-4.9 0-7.1 4.4-5.2 10.2a44.6 44.6 0 0 1 1 3.8 23 23 0 0 0 5.2 6.6c2.6 2.6 5 5.3 5.4 6a9 9 0 0 0 3 2.5l2.2 1.2-.3-2.4c-.3-2.6.2-3 1.6-1.1.5.6 1.8 1.7 2.8 2.3 1.7 1 2 1 2 .2 0-.6.3-1.9.7-2.9l.7-1.8 1.3 2.5c.7 1.4 3 4.5 5.1 7 4.1 4.7 6.7 10 5.4 11.2-.6.5-2 .5-5-.1-2.2-.4-5-.7-6.2-.5-2.3.3-2.5 0-1-1.8 1.5-2 1.2-2.3-1.8-2.3-3.5 0-12.2-1.7-15.6-3-3.2-1.3-4-1-5 2.1l-1.7 5.6-1 3 3.6-.3a37 37 0 0 0 5.5-1 6 6 0 0 1 2.2-.3c.2.1-.3 1.3-1 2.7l-1.4 2.4 2.2-.4c1.2-.3 3-.9 4-1.4 1.8-.8 2-.8 3.4 1.5 1.7 2.7 3 2.6 3.3-.3.3-3 1.3-2.6 3.2 1.4 1.8 3.8 3.6 5.2 4 3 .1-.8 1-2 2.1-2.8 2.2-1.5 3.8-1 4.7 1.3 1 2.5-1.2 5-7.4 8.8a43 43 0 0 0-21.7 31c-1.9 11.8 4 24 15.6 32.9 5.6 4.2 14.5 8.6 13.9 7-2.4-7.3-2.3-21 .1-23.3.4-.4.3 1-.3 3.1-2 7.9-1 14.1 4 28.7 4.4 13.2 3.8 18.9-2.6 22.6-2 1.2-3.3 1.4-8.8 1.3-6 0-6.7 0-8.6 1.6a15.7 15.7 0 0 0-4.3 8.6c0 1.3 1.4 1.1 4-.4z"
            }),
            /* @__PURE__ */ jsx148("path", {
              d: "m460.5 415.5 2.5-1.6 1.7 1.6c2.2 2.1 4.9 2 7-.1 1-1 1.8-1.6 1.9-1.5l.9 1.6c.5.9 1.6 1.3 3.6 1.5 2.3.1 3 0 4-1.4l1-1.7 2.5 1.6c6.8 4.4 10.4-.2 7.3-9.3-1.5-4.6-.6-7.2 4.3-13 2.1-2.5 3.8-5.2 3.8-6 0-1.1-.4-1.3-3.2-1.2-2.6 0-3.4-.3-4.8-1.8-2.3-2.5-2.1-5.4.4-8.6l2-2.5-3.6-2.4a59.7 59.7 0 0 1-8-7.1 25.7 25.7 0 0 0-17.5-9l-4.7-.5v3.6c0 4.5 2.2 8.9 8 16.3 6.6 8.4 7 9.7 7.3 20.7l.3 9.3-2 1.8c-1.7 1.6-2.4 1.9-8 2.2-5.3.3-6.5.6-8 2a8.7 8.7 0 0 0-3.4 5.3c-.3 1.5-.2 1.8.9 1.8.7 0 2.4-.7 3.8-1.6m-142.2-24a5.8 5.8 0 0 0 1-3c0-1 .6-1.4 3.2-1.8l3.1-.4-2-1.7c-2.5-2-2.8-3.5-.6-3.5s5.8-2.2 6.4-3.9c.3-.8 0-1.8-.4-2.3-1.2-1.4-3.5-1.2-3.9.4-.5 1.6-1.2 1.6-3 0-2.5-2.5-2.6-7.6 0-10.6 1.1-1.4 1.1-1.4-.4-2.9-1.6-1.6-2.8-4.6-2-5.4.2-.2 1.5 0 2.8.5 2 .6 2.7.6 3.5 0 2.3-1.9-.2-4.3-4-3.7-1.6.2-2.2 0-2.4-.8-.2-.6-1.5-1.4-3-1.8-2.7-.7-2.7-.7-2.7 1.2 0 2-1.2 2.4-3.4 1.1-1.8-1-3.5-.2-3.5 1.7 0 1.8 1.7 2.6 5 2.4 2.4-.1 2.5 1.7.2 4.3l-1.7 2 1.3 1.9c2 2.8 1.8 7.5-.3 9.9l-1.7 1.8-1.1-1.5c-1.6-2-3.7-1.9-4.3.3-.3 1.4 0 2 1.8 3.6 1.2 1 3 1.8 3.9 1.8 2.3 0 2.2 1.9-.2 3.7l-2 1.5 3 .4c1.6.3 3 .7 3 1 0 1.3 2 5.2 2.6 5.2.4 0 1.2-.7 1.8-1.5z"
            }),
            /* @__PURE__ */ jsx148("path", {
              d: "M356.5 374.9c2.7-1 8.5-6 8.5-7.1 0-.4-1.6-2.2-3.6-4-4-3.6-8.5-9.9-9.7-13.5-.6-2-3.5-5.2-11.7-13.2l-10.9-10.5-3.1.8c-1.8.4-3.9.8-4.7.8-1.5 0-1.5 0 .5 1.6l2 1.6 3-1.6c2.7-1.6 2.8-1.6 3.1-.3.2.7-.2 2-1 2.9-.7.9-1.1 2-1 2.3.3.3-.4 1-1.5 1.6-2 1-3.5 4.3-1.9 4.3 1.5 0 4.7-4 4.3-5.3-.2-.7 0-1.4.2-1.6 1.3-.7 1.2 2.4 0 4-.8.8-1.2 1.8-1 2.2.2.3-.5 1-1.6 1.6-2 1-3.5 4.3-1.9 4.3s4.7-3.8 4.4-5.2c-.2-.7-.2-1.5.1-1.7.9-.4 1.3 2 .6 3.2a2.3 2.3 0 0 0 0 2.2c.7 1.3 0 3.7-1.3 4.5-.5.3-.2 1 1.2 2 2 1.4 2 1.6 2 8 0 5.4.2 6.8 1.2 7.7 1 1 1.2 1 1.2 0s2-2.4 3.5-2.4c.5 0 3.4 2.5 6.5 5.5s6.4 5.7 7.3 5.8l2.2.4c.3 0 1.7-.3 3.1-1zm-33.3-26.1c0-1.7-3.6-3.6-7.9-4-3.5-.5-3.5-.4-3.5 1.3 0 1.4.5 2 3 3 3.8 1.7 8.4 1.5 8.4-.3"
            }),
            /* @__PURE__ */ jsx148("path", {
              d: "M327.1 348.6c1.8-1.6 2.6-3.4 1.5-3.4-1.2 0-4.4 2.8-4.4 4 0 1.6.6 1.5 3-.6zm-3.7-5.1c.1-1-.5-1.6-2.3-2.5-4-1.7-8.6-2.6-9.7-1.7-2.1 1.7-.7 3.9 2.6 4.3 1.4.1 3.2.5 4.1.9 2.6 1 5 .5 5.3-1m0-5.3c.2-1.3-.7-1.8-8-4.4-5.5-2-7.9-1-6.1 2.3.6 1.1 1.6 1.6 3.9 2 1.7.2 4 .7 5.1 1.1 3 1 4.8.6 5-1zm3.6-4.9c1.1-1.1 2-2.4 2-3 0-1.5-4.3 1.3-4.9 3.3-.6 2.3.5 2.2 3-.3zm-3.6-.3c.2-1.6-2.4-3-7.6-4.1-3.9-.9-5.6-.4-5.3 1.4.2 1 1.5 1.7 5 2.8 5.9 1.8 7.6 1.8 7.9-.1m5-7.4c6.8-3 7.3-10.5 1-12.5-2.6-.8-4.2-.3-5.2 1.4-.8 1.4-.3 3.8.7 3.8.4 0 .7.5.7 1 0 2.7-10.2 3.8-14.4 1.7-1.5-.7-2-2.7-.9-2.7 1 0 1.6-2 1.1-3.3-.6-2-2.6-2.6-5.3-1.8-6.3 1.6-6.1 9 .3 12a33.6 33.6 0 0 0 22 .4"
            }),
            /* @__PURE__ */ jsx148("path", {
              d: "M324.3 319.8c.4-.4.2-1-.4-1.4-1.4-1.1-1.3-2.8.2-4.7 1.2-1.4 1.3-3.6 1.7-25.1.7-37.1 3.5-65 7.1-71.8 1.5-2.6 1.3-2.6-2.5 0a36 36 0 0 0-11.7 13.6c-6.2 11.5-8.3 27-8.3 60.2 0 18.8.1 21.3 1.2 23 1 1.8 1 2.4.4 4.2-.5 1.1-.7 2.3-.5 2.5 1.4 1.3 11.4 1 12.8-.5m56.1-35.4c.3-.3-.2-2-1-3.6-1.2-2.6-1.7-3-3.4-3a65 65 0 0 1-23-6.4c-5.1-2.3-7-2.8-7.5-2.2-1.6 1.5 1 5 5 6.9a64 64 0 0 0 18.3 3.7c2.7 0 2.8 0 1.2 2.3l-1 1.6h3l5 .6c3 .7 3 .7 3.4.1"
            }),
            /* @__PURE__ */ jsx148("path", {
              fill: "#000001",
              d: "M412 301.1c0-1-2.9-3.5-5.7-5.2-2.3-1.3-2.7-1.4-2.7-.3 0 1.6-1.4 5.7-2 5.7-.3 0-.8-.8-1-1.7-.3-1-1.4-3-2.5-4.3l-2-2.5-1.4 2.3c-1.4 2.2-3.9 4.3-5 4.3-.2 0-.3-1.2 0-2.5.1-1.6 0-2.8-.5-3-.4-.3-.8-.2-.8.2 0 .8-3.4 4.6-4 4.6-.4 0-.8-1-1-2.4l-.8-4.8c-.2-1.2.3-.4 1 2l1.6 4.1 1.6-2.5a11 11 0 0 0 1.6-3.4c0-.5.3-.7.7-.5.4.2.9 1.9 1.1 3.7l.5 3.4 1.8-2a28.8 28.8 0 0 0 2.6-3.2c.7-1.2.8-1.2 2.3 0 .8.8 2.1 2.5 2.9 3.9s1.5 2.4 1.6 2.3l.6-3.2.4-3c.1-.5 5.4 3 7.4 4.7 1.2 1.1 2.4 1.9 2.6 1.7.2-.2.4-1.8.4-3.7 0-2.8-.3-3.6-2-5.1-2-1.8-2-1.8-2.8-.5-1 1.7-2.1 1.7-2.1 0 0-1.2-3.8-5.9-4.7-5.9-.3 0-1.1 1-1.8 2.3s-1.5 2.3-1.7 2.3c-1 0-6.3-6-6.3-7 0-.8.4-.6 1.3.8a21 21 0 0 0 3.1 3.6c2 1.8 2.8 1.4 3.6-2.1.3-1 .7-1.8 1-1.8.8 0 5.4 4.9 6 6.5l.7 1.6.5-1.8c.6-2.2 1.3-2.2 2.3-.2.4.8 2.4 2.6 4.4 3.8l3.7 2.4.7-2.4c.4-1.3 1-2 1.2-1.6.4.5-.6 4.5-1.3 5.3 0 .1-1.3-.6-2.6-1.5l-2.5-1.8v3.2c0 1.7-.2 3.8-.4 4.6-.5 1.6-1.7 2-1.7.6zm-18.5-25.4c-4.4-3.6-5-4.4-5-6.2l.1-1.8.3 1.7c.2 1 1.4 2.6 2.8 3.8l2.6 2 1.5-1.8c.9-1 1.6-2.2 1.6-2.6 0-1.2.2-1.1 3.2 1.5 2.6 2.3 2.7 2.3 3 .8.3-.8.2-2.4 0-3.5-1-3-.8-3.4.5-1.6l2.4 2.8c1 1.1 1.1 1.1 1.5-.3.3-.9.5-2.4.5-3.4v-1.9l2.3 2.7c2.3 2.6 2.5 2.7 3.1 1.4.5-.7.8-2.4.8-3.7 0-1.8.2-2.2.6-1.6.8 1.2.3 4.2-1.1 6.8l-1 2-1.3-2.1c-1.7-2.6-2.3-2.6-3.3.2-1 2.7-1.7 2.9-2.7.8-.6-1.3-.8-1.1-1.2 1.7l-.5 3-3-2.3-3-2.3-1.5 1.5c-.7.9-1.3 2-1.3 2.4 0 1-.8 1-1.9 0m39-13.6c-1.5-1.4-2.6-2.8-2.4-3 .3-.3.5-.4.6-.2a67 67 0 0 0 3 3c3.4 3.6 2.7 3.7-1.1.2zm-52-5.4c-1.4-2-1.3-3.2.5-5.4 1.2-1.5 1.8-1.7 4-1.4 1.5.1 4.6 1.4 6.9 2.8a21.2 21.2 0 0 0 11 3l-1.7-2.8c-2.2-3.3-2.2-3.7.4-1.7 2.6 2.1 5.7 2.7 12.7 2.5l3.4-.1-2-2c-2.7-2.7-1.9-3 1.2-.3 2.8 2.5 2.7 2.7-3.4 3.3a23 23 0 0 1-7.6-.5c-3.4-1-3.6-.9-2.9.2.4.7 1 1.2 1.3 1.2.4 0 .7.4.7.8 0 1.3-7.4.1-11-1.6-8-4.1-9-4.5-11-3.9a4.3 4.3 0 0 0-2.4 2.3c-1.3 3.3 3.4 5.9 5.3 3 .6-.9.5-1.4-.5-2.5-1.4-1.4-1.2-1.6.6-1 1.3.5 1.4 3.6.2 4.8-1.3 1.3-4.5 1-5.7-.7"
            }),
            /* @__PURE__ */ jsx148("path", {
              fill: "#000001",
              d: "M412.4 248.6c-1-1-.2-1.2 4.3-1.3 5.6-.1 9-1 13-3.6 3.2-2 4.1-1.6 1 .5-2.7 2-7 3.4-11.3 3.8l-5.1.7c-.8.2-1.7.1-2-.1z"
            })
          ]
        })
      ]
    })
  ]
});
var Lk_default = SvgLk;

// src/country-flag-icons/generated/Lr.tsx
import { jsx as jsx149, jsxs as jsxs142 } from "react/jsx-runtime";
var SvgLr = (props) => /* @__PURE__ */ jsxs142("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx149("defs", {
      children: /* @__PURE__ */ jsx149("clipPath", {
        id: "lr_svg__a",
        children: /* @__PURE__ */ jsx149("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs142("g", {
      fillRule: "evenodd",
      clipPath: "url(#lr_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx149("path", {
          fill: "#fff",
          d: "M0 0h767.9v512H0z"
        }),
        /* @__PURE__ */ jsx149("path", {
          fill: "#006",
          d: "M0 0h232.7v232.8H0z"
        }),
        /* @__PURE__ */ jsx149("path", {
          fill: "#c00",
          d: "M0 464.9h767.9V512H0z"
        }),
        /* @__PURE__ */ jsx149("path", {
          fill: "#c00",
          d: "M0 465.4h767.9V512H0zm0-92.9h767.9v46.2H0zm0-93.2h766V326H0zM232.7 0h535.1v46.5H232.7zm0 186h535.1v46.8H232.7zm0-92.7h535.1v46.5H232.7z"
        }),
        /* @__PURE__ */ jsx149("path", {
          fill: "#fff",
          d: "m166.3 177.5-50.7-31-50.4 31.3 18.7-50.9-50.3-31.4 62.3-.4 19.3-50.7L135 95h62.3l-50.1 31.7z"
        })
      ]
    })
  ]
});
var Lr_default = SvgLr;

// src/country-flag-icons/generated/Ls.tsx
import { jsx as jsx150, jsxs as jsxs143 } from "react/jsx-runtime";
var SvgLs = (props) => /* @__PURE__ */ jsxs143("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx150("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#009543",
      d: "M0 336h640v144H0z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#00209f",
      d: "M0 0h640v144H0z"
    }),
    /* @__PURE__ */ jsx150("path", {
      stroke: "#000",
      strokeWidth: 1.6,
      d: "M319.6 153c-2.7 0-5.4 3-5.4 3l.3 32.4-10.3 10.7h8.3v18.5l-49 66-7.2-2.6-12.7 27s31.3 19.6 76.7 19c49.8-.5 76.9-19.9 76.9-19.9l-13-26.6-6.5 2.8-49.6-65.6v-19.1h8.2L325.1 188v-32.2s-2.7-3-5.5-2.9z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8,
      d: "M336.7 230.4h-33.9s-12.2-25.9-10.3-44c2-18.4 12.6-27.1 26.6-27.3 16.6-.1 25.2 8.1 27.8 26.6 2.6 18.3-10.2 44.7-10.2 44.7z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#fff",
      d: "M260.5 292.1c-.6.7-4.7 8.9-4.7 8.9l7-1.5zm4 10.5-7.4 2.4 8.9 3.5zm3.3-10.3 3.7 10.9 9-2.6-2.3-5.2zm5.8 14.8 1.2 4.4 12 3-4.8-10.2zm13.2-9.3 4.3 10.2 9-3.5-3-4.5zm6 13.9 1.4 3.8 14 2-5.9-9.2-9.6 3.4zm13.4-11 5.2 9.1 13-4.8-1.4-3.5-16.8-.7zm7.6 12.4 2.7 4.8 16.2-.5-6-9-13 4.7zm17.1-12 4.4 7.6 10.4-5-2.8-4zm17 5.8-10.3 5.1 2.7 4.5 13.8-2.2zm3.3-8 5.3 6.7 8.7-6.9-3-3zm15.9 3.5-8.3 6.3 2.2 3.9 11.4-3zm11.4-13 2 2.9-5.7 8.5-5.9-7.6zm3.9 7.3 3.5 7-7 2.4-.6-3.3 4-6z"
    })
  ]
});
var Ls_default = SvgLs;

// src/country-flag-icons/generated/Lt.tsx
import { jsx as jsx151, jsxs as jsxs144 } from "react/jsx-runtime";
var SvgLt = (props) => /* @__PURE__ */ jsx151("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs144("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(.64143 .96773)",
    children: [
      /* @__PURE__ */ jsx151("rect", {
        width: 1063,
        height: 708.7,
        fill: "#006a44",
        rx: 0,
        ry: 0,
        transform: "scale(.93865 .69686)"
      }),
      /* @__PURE__ */ jsx151("rect", {
        width: 1063,
        height: 236.2,
        y: 475.6,
        fill: "#c1272d",
        rx: 0,
        ry: 0,
        transform: "scale(.93865 .69686)"
      }),
      /* @__PURE__ */ jsx151("path", {
        fill: "#fdb913",
        d: "M0 0h997.8v164.6H0z"
      })
    ]
  })
});
var Lt_default = SvgLt;

// src/country-flag-icons/generated/Lu.tsx
import { jsx as jsx152, jsxs as jsxs145 } from "react/jsx-runtime";
var SvgLu = (props) => /* @__PURE__ */ jsxs145("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx152("path", {
      fill: "#ed2939",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx152("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx152("path", {
      fill: "#00a1de",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Lu_default = SvgLu;

// src/country-flag-icons/generated/Lv.tsx
import { jsx as jsx153, jsxs as jsxs146 } from "react/jsx-runtime";
var SvgLv = (props) => /* @__PURE__ */ jsx153("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs146("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx153("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx153("path", {
        fill: "#981e32",
        d: "M0 0h640v192H0zm0 288h640v192H0z"
      })
    ]
  })
});
var Lv_default = SvgLv;

// src/country-flag-icons/generated/Ly.tsx
import { jsx as jsx154, jsxs as jsxs147 } from "react/jsx-runtime";
var SvgLy = (props) => /* @__PURE__ */ jsxs147("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx154("defs", {
      children: /* @__PURE__ */ jsx154("clipPath", {
        id: "ly_svg__a",
        children: /* @__PURE__ */ jsx154("path", {
          d: "M166.7-20h666.6v500H166.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs147("g", {
      clipPath: "url(#ly_svg__a)",
      transform: "matrix(.96 0 0 .96 -160 19.2)",
      children: [
        /* @__PURE__ */ jsx154("path", {
          fill: "#239e46",
          d: "M0-20h1000v500H0z"
        }),
        /* @__PURE__ */ jsx154("path", {
          fill: "#000001",
          d: "M0-20h1000v375H0z"
        }),
        /* @__PURE__ */ jsx154("path", {
          fill: "#e70013",
          d: "M0-20h1000v125H0z"
        }),
        /* @__PURE__ */ jsx154("path", {
          fill: "#fff",
          d: "M544.2 185.8a54.3 54.3 0 1 0 0 88.4 62.5 62.5 0 1 1 0-88.4M530.4 230l84.1-27.3-52 71.5v-88.4l52 71.5z"
        })
      ]
    })
  ]
});
var Ly_default = SvgLy;

// src/country-flag-icons/generated/Ma.tsx
import { jsx as jsx155, jsxs as jsxs148 } from "react/jsx-runtime";
var SvgMa = (props) => /* @__PURE__ */ jsxs148("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx155("path", {
      fill: "#c1272d",
      d: "M640 0H0v480h640z"
    }),
    /* @__PURE__ */ jsx155("path", {
      fill: "none",
      stroke: "#006233",
      strokeWidth: 11.7,
      d: "M320 179.4 284.4 289l93.2-67.6H262.4l93.2 67.6z"
    })
  ]
});
var Ma_default = SvgMa;

// src/country-flag-icons/generated/Mc.tsx
import { jsx as jsx156, jsxs as jsxs149 } from "react/jsx-runtime";
var SvgMc = (props) => /* @__PURE__ */ jsx156("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs149("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx156("path", {
        fill: "#f31830",
        d: "M0 0h640v240H0z"
      }),
      /* @__PURE__ */ jsx156("path", {
        fill: "#fff",
        d: "M0 240h640v240H0z"
      })
    ]
  })
});
var Mc_default = SvgMc;

// src/country-flag-icons/generated/Md.tsx
import { jsx as jsx157, jsxs as jsxs150 } from "react/jsx-runtime";
var SvgMd = (props) => /* @__PURE__ */ jsxs150("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs150("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx157("path", {
          fill: "#00319c",
          d: "M0 0h213.3v480H0z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#ffde00",
          d: "M213.3 0h213.4v480H213.3z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#de2110",
          d: "M426.7 0H640v480H426.7z"
        })
      ]
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "m360.4 320.4 24.2 35c1.4 2 2.7 3.9.7 5.2-2 1.3-1.4 6.4 0 8.4 2.7 3.9 6 4.5 8 3.2l18.4-11.6c2-1.2 2.7-4.5 0-8.4-1.5-2-6-4.5-8-3.2-2.1 1.3-3.5-.7-4.8-2.6l-24.3-35"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#a77b3b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M177.2 696.3c0 24.4-9.6 44.3-21.3 44.3-11.7 0-21.3-19.9-21.3-44.3S144.3 652 156 652s21.3 19.8 21.3 44.3z",
      transform: "matrix(.52728 -.42386 .44358 .50386 -32.4 20)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "m262 306.1-21.5 36.7c-1.2 2-2.4 4-4.5 3-2.1-1.2-6.6 1.7-7.8 3.8-2.4 4-1.5 7.2.7 8.4l19.2 10.2c2 1.1 5.4.2 7.8-3.8 1.1-2.2 1.4-7.3-.7-8.4-2.1-1.1-1-3.2.3-5.2l21.4-36.7"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#a77b3b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.7,
      d: "M331.2 280.6h-19.6c-.6.6-6.2 35.6-12.2 49-7.3 16.3-29.2 30.7-29.2 30.7s13.1 4 17 6.6c1-.3 22-4.7 24.4-30.3 2.4 25.6-14.6 37.3-14.6 37.3s24.4 7 24.4 23.3c0-16.3 24.4-23.3 24.4-23.3s-12.2-11.7-14.7-37.3c5 25.6 23.5 30 24.5 30.3 3.9-2.6 17-6.6 17-6.6s-21.9-14.4-29.2-30.7c-6-13.4-11.6-48.4-12.2-49zm-83-116.7 36.6 11.7c12.1 0 24.4-11.7 24.4-23.4.4-26-9.8-35-12.2-35l4.8-4.6-7.3-7s2.5-12.1 26.9-11.7c24.4.5 24.4 11.7 24.4 23.3s-12.2 11.7-12.2 35c0 11.7 12.2 23.4 24.4 23.4l36.6-11.7v116.7H248.1z"
    }),
    /* @__PURE__ */ jsxs150("g", {
      fill: "none",
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx157("path", {
          strokeWidth: 0.5,
          d: "m302.2 292.2 14.6 15 14.7-15 14.6 15 29.3-15 14.3 15.8 15-15.8 21.6 15.8 22.3-15.8 14.6 15 14.7-15",
          transform: "matrix(.16672 0 0 .46773 253.9 31.9)"
        }),
        /* @__PURE__ */ jsx157("path", {
          strokeWidth: 0.2,
          d: "m432.3 435.8-7.1 39m10.6-39v39m7.1-39v39m7.1-39 3.5 39m3.6-39 3.5 39",
          transform: "matrix(.68905 0 0 .65843 16.2 -144)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs150("g", {
      stroke: "#000",
      strokeWidth: 2.5,
      children: [
        /* @__PURE__ */ jsx157("path", {
          fill: "#a77b3b",
          fillRule: "evenodd",
          d: "M318.9 361.4c35.4 17.7 35.4 53.2 35.4 70.9-1.2 16.1 0 354.3 0 354.3s-2.3-20-17.7-35.4L319 733.5l-17.7-17.7c-13-11.8-17.7-35.5-17.7-53.2v-248s0-17.8 35.4-53.2z",
          transform: "matrix(-.68905 0 0 .65843 443.4 -144)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(-.68905 0 0 .65843 443.4 -237.3)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(-.68905 0 0 -.65843 443.4 530.2)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(-.68905 0 0 .65843 443.4 -190.7)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "m301.4 557-.2 158.8",
          transform: "matrix(-.68905 0 0 1.24911 443.4 -566.8)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(-.68905 0 0 1.12111 431.4 -464)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(-.68905 0 0 1.2559 419.2 -548.3)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs150("g", {
      stroke: "#000",
      strokeWidth: 2.5,
      children: [
        /* @__PURE__ */ jsx157("path", {
          fill: "#a77b3b",
          fillRule: "evenodd",
          d: "M318.9 361.4c35.4 17.7 35.4 53.2 35.4 70.9-1.2 16.1 0 354.3 0 354.3s-2.3-20-17.7-35.4L319 733.5l-17.7-17.7c-13-11.8-17.7-35.5-17.7-53.2v-248s0-17.8 35.4-53.2z",
          transform: "matrix(.68905 0 0 .65843 199.3 -144)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(.68905 0 0 .65843 199.3 -237.3)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(.68905 0 0 -.65843 199.3 530.2)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(.68905 0 0 .65843 199.3 -190.7)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "m301.4 557-.2 158.8",
          transform: "matrix(.68905 0 0 1.24911 199.3 -566.8)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(.68905 0 0 1.12111 211.4 -464)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(.68905 0 0 1.2559 223.6 -548.3)"
        })
      ]
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#a77b3b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M177.2 696.3c0 24.4-9.6 44.3-21.3 44.3-11.7 0-21.3-19.9-21.3-44.3S144.3 652 156 652s21.3 19.8 21.3 44.3z",
      transform: "matrix(.63605 .25323 -.26502 .60778 361.1 -165.2)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "red",
      fillRule: "evenodd",
      d: "M248.1 175.6h146.5v70H248.1z"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#564dff",
      fillRule: "evenodd",
      d: "M248.1 245.6h146.5v35c0 23.3-36.6 23.3-73.2 46.6C284.7 304 248 304 248 280.6z"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "none",
      stroke: "#ff0",
      strokeWidth: 2,
      d: "M336.6 485.4h212.6V645c0 35.4-53.1 35.4-106.3 70.9-53.1-35.5-106.3-35.5-106.3-71V485.5z",
      transform: "matrix(.68905 0 0 .65843 16.2 -144)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M385.6 129.9S335 185.4 335 238.5c0 53.1 53.1 70.9 53.1 70.9s-17.7 0-17.7 70.8c0 35.5 53.1 17.8 53.1 35.5s-.7 60.5 0 88.6c0 17.7-35.4 0-35.4 17.7 0 8.8 26.6 53.1 53.2 53.1s53.1-44.3 53.1-53.1c0-17.7-35.4 0-35.4-17.7v-88.6c0-17.7 53.1 0 53.1-35.5 0-70.8-17.7-70.8-17.7-70.8s53.2-17.7 53.2-70.9-50.7-108.6-50.7-108.6 28.5 73.2 28.5 108.6c0 17.7-13.3 53.2-48.7 53.2 0 0-9-17.8-17.7 0 0 0-10.2-17.8-17.7 0-2.6 6-7.2-17.8-17.8 0-4.4 4.7-8-17.8-17.7 0-17.7 0-53.1-17.8-53.1-53.2s32.9-108.6 32.9-108.6z",
      transform: "matrix(.48234 0 0 .30917 108.5 140.1)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M382.7 248c-3.6 3.6 4.6 61.3 7 63.8 3.6 3.5 24.9 3.5 28.4 0 2.5-2.5 0-56.7-3.5-60.2-3.6-3.6-29.4-6-32-3.6z",
      transform: "matrix(.48234 0 0 .30917 110.4 201.6)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M382.7 248c-3.6 3.6 4.6 61.3 7 63.8 3.6 3.5 24.9 3.5 28.4 0 2.5-2.5 0-56.7-3.5-60.2-3.6-3.6-29.4-6-32-3.6z",
      transform: "matrix(-.48234 0 0 .30917 532.4 201.6)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M414.6 228.5a16 16 0 1 1-32 0 16 16 0 0 1 32 0z",
      transform: "matrix(.5544 0 0 .38542 82.7 183.7)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M414.6 228.5a16 16 0 1 1-32 0 16 16 0 0 1 32 0z",
      transform: "matrix(.55441 0 0 .38543 118 183.7)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fillRule: "evenodd",
      d: "M336.8 307.5c0 1.5-2 2.7-4.3 2.7-2.4 0-4.3-1.2-4.3-2.7s2-2.7 4.3-2.7 4.3 1.2 4.3 2.7m-22.3 0c0 1.5-1.9 2.7-4.2 2.7-2.4 0-4.3-1.2-4.3-2.7s1.9-2.7 4.3-2.7c2.3 0 4.2 1.2 4.2 2.7"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "m439.4 550-7.8-10.3-12.8 1.7 1.8-12.8-10.3-7.7 10.3-7.8-1.8-12.8 12.8 1.8 7.8-10.3 7.8 10.3 12.7-1.8-1.7 12.8 10.2 7.8-10.2 7.8 1.7 12.7-12.8-1.7z",
      transform: "matrix(.67225 0 0 .64237 26 -133.3)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "m496 591.7 21.3 10.7 21.3-10.7-21.3-10.6z",
      transform: "matrix(.68905 0 0 .65843 16.2 -144)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "m496 591.7 21.3 10.7 21.3-10.7-21.3-10.6z",
      transform: "matrix(.68905 0 0 .65843 -88.8 -144)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M535 659c-3.5-7-14.1-10.6-21.2-10.6s-14.2 0-21.3 10.7c0-14.2 10.5-21.3 21.3-21.3a22.7 22.7 0 0 1 21.2 21.3z",
      transform: "matrix(.59753 -.3279 .34316 .57097 -165.2 86.5)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 13.7 -155.7)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 8.8 -139.4)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 6.4 -148.7)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 18.6 -139.4)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 21 -148.7)"
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 13.7 -146.4)"
    }),
    /* @__PURE__ */ jsxs150("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx157("path", {
          fill: "#da4500",
          d: "M297.8 120.4c-12.4 0-14 2-19.6 3.9 0-5.4 13.8-11.7 26-11.7 0 3.9-3.2 7.8-6.4 7.8"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#cac9c7",
          d: "M316.5 108c0 2.5-2.2 4.6-4.9 4.6s-4.9-2.1-4.9-4.7 2.2-4.6 4.9-4.6 4.9 2 4.9 4.6z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#ff0",
          stroke: "#000",
          strokeWidth: 1.1,
          d: "M361.4 357.9v10.6h17.7v53.1h10.7v-53.1h17.7v-10.6h-17.7v-14.2H379v14.2z",
          transform: "matrix(.68905 0 0 .65843 16.2 -144)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#da4500",
          d: "M304.3 112.6a78.5 78.5 0 0 0-29.3 3.9c0-7.2 8.4-15.6 22.8-15.6 3.2 0 6.5 7.8 6.5 11.7"
        })
      ]
    }),
    /* @__PURE__ */ jsxs150("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx157("path", {
          fill: "#008500",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M67.3 613c-14.2-14.2-16.6-21.4 3.6-10.1l283.7 247.5-3.4 7L67.4 613z",
          transform: "matrix(.38821 .29653 -.14073 .23692 237.4 71.3)"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#008f00",
          d: "M228.4 330.4c.8-10.6-18.6-22-19.4-21.3-.7.8 1.2 7 4.9 10.1-7-3.6-14.4-5.8-14.6-4.3-.6 2.2 11 7.2 12 9.2 0 1.4-8.6 1.2-8.4 2.6.2 1.4 24.3 13.6 25.5 3.7M209 299.6c.8-10.6-18.6-22-19.3-21.3-.8.7 1.1 6.9 4.8 10.1-7-3.6-14.4-5.9-14.6-4.3-.5 2.1 11 7.2 12 9.2.1 1.4-8.5 1.2-8.4 2.6.2 1.4 24.3 13.5 25.5 3.7m-14.8-28c.8-10.6-18.6-22-19.4-21.3-.7.7 1.2 6.9 4.9 10.1-7-3.6-14.4-5.9-14.6-4.3-.5 2.1 11 7.2 12 9.2 0 1.4-8.5 1.2-8.4 2.6.2 1.4 24.3 13.6 25.5 3.7m-14.6-30.4c.7-10.5-18.6-22-19.4-21.3-.8.8 1.2 7 4.8 10.2-7-3.7-14.4-5.9-14.5-4.3-.6 2.1 11 7.2 11.9 9.1.1 1.4-8.5 1.3-8.3 2.7.1 1.4 24.2 13.5 25.5 3.6"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#008f00",
          d: "M184.6 239.9c9.4-5.7 7.5-27.4 6.5-27.6-1.1-.1-5.2 5-5.7 9.8-1.1-7.6-3.6-14.6-5-13.8-2.1.8.4 12.7-.7 14.6-1 1-6-5.8-7-4.8-1.2 1 2.8 26.7 12 21.8zm13.6 26.6c10.8-2.4 16.7-23.4 15.7-23.9s-6.6 3-8.7 7.4c1.6-7.5 1.7-14.9 0-14.6-2.3.1-4 12.1-5.7 13.5-1.3.6-3.7-7.3-5-6.8-1.4.6-6.6 26.1 3.7 24.4m16.2 27.2c9.9-4.8 10-26.6 9-26.8-1-.3-5.5 4.5-6.5 9.2-.4-7.7-2.2-14.8-3.7-14.1-2.2.6-.8 12.6-2 14.4-1.2.9-5.5-6.3-6.7-5.4-1.2.8.4 26.8 10 22.7zm17.6 35.6c10.3-3.9 12.8-25.5 11.8-25.9-1-.3-6 4-7.5 8.6.4-7.7-.6-15-2.2-14.4-2.3.4-2.1 12.5-3.5 14.2-1.3.7-4.8-6.8-6-6-1.3.6-2.5 26.7 7.4 23.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M209 776c0 7.8-10.2 14.2-23 14.2s-23-6.4-23-14.2 10.3-14.2 23-14.2 23 6.4 23 14.2z",
      transform: "matrix(.60164 .32097 -.3359 .5749 389.6 -146.8)"
    }),
    /* @__PURE__ */ jsxs150("g", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx157("path", {
          d: "M156 414.6v-7.1h7v-7.1h7v7h7.2v7.2H170v17.7h-7v-17.7zm7 60.2h7v205.5h-7z",
          transform: "matrix(.49887 .1571 -.1826 .4713 451.4 -3.7)"
        }),
        /* @__PURE__ */ jsx157("path", {
          d: "M159.4 676.8h14.2v56.7h-14.2zM156 439.4h21.3c14.1 0-3.6 39-3.6 39h-14.1s-17.8-39-3.6-39zm17.6-5.4c0 3-3.1 5.4-7 5.4s-7.1-2.4-7.1-5.3 3.1-5.4 7-5.4 7.1 2.4 7.1 5.4z",
          transform: "matrix(.49887 .1571 -.1826 .4713 451.4 -3.7)"
        })
      ]
    }),
    /* @__PURE__ */ jsx157("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M209 776c0 7.8-10.2 14.2-23 14.2s-23-6.4-23-14.2 10.3-14.2 23-14.2 23 6.4 23 14.2z",
      transform: "matrix(.57449 -.36357 .38048 .54895 -2.3 4.2)"
    })
  ]
});
var Md_default = SvgMd;

// src/country-flag-icons/generated/Me.tsx
import { jsx as jsx158, jsxs as jsxs151 } from "react/jsx-runtime";
var SvgMe = (props) => /* @__PURE__ */ jsxs151("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx158("path", {
      fill: "#d3ae3b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#c40308",
      d: "M24 24h592v432H24z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M424.5 236.1a58 58 0 0 0 19.4-9.2c7-5.6 8.3-10.1 8.8-12.5.6-2.4.8-4.3-1-3-1.8 1.4-7.1 5.6-10.7 7.6-3.7 2-7 3-9 3.6-2 .5-3.6.9-1.7.1 2-.7 8.1-2.9 13-7.7 4.7-4.8 8.5-12 8.6-16.4 0-4.4-.3-4-1.7-3-1.4 1.1-6.4 7.3-9.3 9.7a90 90 0 0 1-9.7 6.9c-2.3 1.3-5.5 2.8-1-.3 4.5-3 13-10.3 16.5-19.7a35.4 35.4 0 0 0 2.7-15.8c0-1-.8-2.8-1.6-1.1-.8 1.7-6.5 13-11 18-4.6 4.8-3.5 3.9-4.6 4.7-1 .8-2.7 2.2-.5-.6a51.2 51.2 0 0 0 12.2-31.7c0-3.6-1.5-8.6-2.2-10.1-.7-1.5-1.4-2.6-1.7-.9a191 191 0 0 1-5.8 18.4 75 75 0 0 1-6.7 12.8c-.8 1.1-2.8 3.6-.6-.5a77.4 77.4 0 0 0 7-27.6 44 44 0 0 0-2.6-20.9c-1.6-3.1-3-4.2-3-4.2s.3 7.8-2 19-5.7 17-5.7 17-1.5 1.7-.5-1a62.4 62.4 0 0 0 1.4-34.5c-2.3-7.5-6.2-11.3-6.2-11.3-1 10.7-.9 24.5-4.8 35.7-.7-.7-1.7-1.9-2.1.6a63.1 63.1 0 0 1-7 19.4c-4.8 8.8-6.8 10-6.8 10l-1.5-3.4c-.6-1.2-1-1.8-1.8-.2s-3.5 7.8-9.4 14.6-9.2 10.2-9 15.3c.1 5 2.8 7.7 6.4 10 3.6 2.3 4.2 3.6 3.7 6.4-.6 2.8-3.8 3.7-6.6 3.8-2.7.1-6.2-.1-7.5.6-1.2.7-1.3 2.5-2.6 3.7-1.2 1.3-1.8 2-3 2.2l-1 .1c-.2-13.5 5-19.5 5-19.5l-14.6-17.1a50.8 50.8 0 0 1-2.2 1 4 4 0 0 0-.4-.6 11 11 0 0 1-2.6-7.8c.7 0 2.2.6 3.5.3 1.3-.2.3-1.6 0-2.8-.5-1.3-.9-5.7-.6-7.3l.4-2.3s2.1 2.3 3.4 2.3c1.3 0 1.2-1.3 1.4-2.8.3-2.2 1.3-5 3-6.5 0 0 2.4 1.6 5 1.6s6.2-.7 9-3.5c3-2.7 2.9-3.3 2.9-3.3s5.3 1.8 9.3 2c4 .2 8.3-.4 10.4-4.7 2-4.2-.6-8.2-1-8.8-.6-.7-1.9-1.2-1.9 0s.1 4.4-2.4 6c-2.4 1.6-4.3 1.5-6.6.8a20.5 20.5 0 0 0-13.1-.4 17 17 0 0 1 6.1-4.2c3-.9 4.8.4 5.8 1.6 1 1.2 1.9 3 2.7.3.8-2.8.3-6-1-8a7.6 7.6 0 0 0-7.2-3c-3 .2-4 .7-4 .7s-1.5-4.3-5.3-5a21 21 0 0 0-14 3s-3.1.7-6.4-.2a21 21 0 0 1-5.4-2.8l1.1-3.5 1.9-.6c1-.4.7-.7.9-1.5.1-.8-1.8-2.2-1.8-2.2s-.3-2.5 2.9-4.1l2.8-1.4s1.9.3 2.6-.2c.8-.6.8-1 .8-1s1.4-.4 2-1.2c.4-.9.5-2.1.2-3.1-.4-1-.9-1.2-.4-1.7s1-1.6 1-2.4l.1-1s1.1-.4 1-2c0-1.7-.9-2.3-1.4-2.5l-.9-.1s0-1-.9-2.3c-.8-1.4-1.4-2-1.4-2s.6-.4.3-1.5-1.1-1.7-1.9-2c-.7-.2-1.5 0-1.5 0l-3.7-2.1-1.5-.8s0-1-.4-1.6c-.5-.5-1.5-.8-2-.8s-1 .3-1 .3l-6-1.4c-1.8-.2-1.9-.4-1.9-.4s-3.8-1.8-5.2-2l-2-.5s1.6-1.8 1.7-4a6 6 0 0 0-2.8-5l-1.6-.8V93l2.8.3.2-4.6-2.7.3.4-2.7h-5.8l.4 2.7-2.8-.2.3 4.5 3-.4-.4 1.7s-1 .2-2 .9a5.4 5.4 0 0 0-2.6 4.7c0 2.2 1.3 4 1.3 4l-1.8.4c-1.5.3-5.3 2.1-5.3 2.1s0 .2-1.8.4l-6 1.4s-.6-.3-1-.3-1.6.3-2 .8c-.4.6-.5 1.6-.5 1.6l-1.4.8-3.7 2.1s-.8-.2-1.6 0c-.7.3-1.5 1-1.8 2-.3 1.1.3 1.6.3 1.6s-.6.5-1.5 1.9a6 6 0 0 0-.9 2.3l-.8.1c-.6.2-1.5.8-1.5 2.5 0 1.6 1 2 1 2v1c.1.8.6 2 1.1 2.4.5.5 0 .7-.3 1.7-.4 1-.3 2.2.2 3 .5 1 2 1.4 2 1.4s0 .3.7.9 2.6.2 2.6.2l2.9 1.4c3.2 1.6 2.9 4 2.9 4s-2 1.5-1.8 2.3c.1.8 0 1.1.9 1.5l1.9.6 1 3.5a21 21 0 0 1-5.4 2.8c-3.2.9-6.4.2-6.4.2a21 21 0 0 0-13.9-3c-3.8.7-5.4 5-5.4 5s-1-.4-4-.8c-3-.3-5.8 1-7.1 3-1.4 2.1-1.8 5.3-1 8.1s1.6.9 2.6-.3 2.8-2.5 5.8-1.6c3 1 6 4 6.2 4.2 0 0-.5-.3-3.9-.8-3.7-.5-6.9.4-9.2 1.2-2.3.7-4.2.8-6.7-.8-2.4-1.6-2.4-4.8-2.4-6 0-1.2-1.3-.7-1.8 0-.4.6-3 4.6-1 8.8 2 4.3 6.3 5 10.4 4.7 4-.2 9.3-2 9.3-2s0 .6 2.8 3.3a13 13 0 0 0 9 3.5c2.7 0 5-1.6 5-1.6 1.7 1.5 2.7 4.3 3 6.5.2 1.5.1 2.8 1.4 2.8 1.4 0 3.5-2.3 3.5-2.3l.4 2.3a26 26 0 0 1-.6 7.3c-.4 1.2-1.4 2.6 0 2.8 1.3.3 2.7-.2 3.5-.3 0 3.2-.7 5.3-2.6 7.8a4.4 4.4 0 0 0-.4.6 53.9 53.9 0 0 1-2.2-1l-14.6 17.1s5.3 6 5 19.6a20.6 20.6 0 0 1-1-.2c-1.2-.2-1.8-1-3-2.2-1.3-1.2-1.4-3-2.6-3.7-1.3-.8-4.8-.5-7.5-.6-2.8 0-6-1-6.6-3.8-.5-2.8.1-4 3.7-6.4 3.6-2.3 6.3-5 6.4-10 .2-5.1-3-8.5-9-15.3-5.9-6.8-8.6-13-9.4-14.6-.8-1.6-1.2-1-1.8.2l-1.5 3.3s-2-1.2-6.8-10a63 63 0 0 1-7-19.3c-.4-2.5-1.4-1.3-2-.6-4-11.2-3.8-25-4.9-35.7 0 0-3.9 3.8-6.2 11.3-2 6.8-2 14.9-1.3 22 .6 6.7 2 10.7 2.7 12.5 1 2.7-.5 1-.5 1s-3.4-5.8-5.7-17c-2.3-11.2-2-19-2-19s-1.4 1-3 4.2a44 44 0 0 0-2.6 21 77.4 77.4 0 0 0 7 27.5c2.2 4 .2 1.6-.6.5a71 71 0 0 1-6.7-12.8c-2-5.5-5.6-16.6-5.8-18.4-.3-1.7-1-.6-1.7.9s-2.3 6.5-2.2 10.2a51.2 51.2 0 0 0 12.2 31.6c2.2 2.8.5 1.4-.5.6-1-.8 0 .1-4.5-4.7a91.7 91.7 0 0 1-11-18c-.9-1.7-1.6.1-1.7 1.1-.1 1-.7 6.5 2.7 15.8 3.5 9.4 12 16.7 16.5 19.7 4.5 3.1 1.3 1.6-1 .3a90 90 0 0 1-9.7-6.9c-2.9-2.4-7.9-8.6-9.3-9.7-1.4-1-1.7-1.4-1.7 3 .1 4.4 3.9 11.6 8.7 16.4 4.8 4.8 11 7 12.9 7.7 1.9.8.3.4-1.7-.1a40.2 40.2 0 0 1-9-3.6 93 93 0 0 1-10.7-7.6c-1.8-1.4-1.6.6-1 3 .5 2.4 1.9 6.9 8.8 12.5a57.7 57.7 0 0 0 19.4 9.2c2.9.8.9.8.9.8l-6.8-1.4a71.3 71.3 0 0 1-16.7-7.3c-2.3-1.5-2.7-2-2.4 1a20 20 0 0 0 8.9 12.9 49.6 49.6 0 0 0 17.2 4.8c2.5.1 1.8.4.7.5a50.5 50.5 0 0 1-19.2-3.2l-.5-2c-.2-1.2-.9-1-1.2-.8-.4.3-.7.5-2 1.1-1.3.7-1.3-.1-1.4-.5l-.3-3c0-.8-.5-.9-1.1-.6l-4.7 2c-1 .4 0 1.3.5 2.3a147.3 147.3 0 0 0 1.5 2.6l-3.7 1c-.8.2-.6.8-.3 1.4l1.9 4.6c.3.8 1.1.3 1.1.3l2.7-1.6 1 3.7s-1.3.3-2.7 1.2c-1.3 1-1 2.3.7 2.7 1.6.5 3.6 1.4 5.7 5.3 2.2 3.9 2.7 10.9 4 22 1.4 11 8.4 16.6 9.4 17.3 1 .7.4 1.3.4 1.3s-1 1.4-.5 3.5a5.3 5.3 0 0 0 3.2 3.8c1 .3.7 1.3.7 1.3s-.5 2.3 0 6.7c.5 4.3 4 9.1 5 10 1 .8 1 1.2 1 1.6-.2.3-.9 0-2 1a12.2 12.2 0 0 0-3.4 3.6c-.8 1.6-.5 2.5-.2 4.5.2 2.1 3.3 4 3.3 4s-.6.1-.7 1.7c-.1 1.5 1 3.2 2.4 4.4 1.3 1 4 1.6 4 1.6l.3 2.2c.2 1 1.9 1.9 3 2.5 1.1.6 3.3.3 4.2-.2.9-.4 1.5.1 2 1 .6 1 .4 4.4.4 5.8 0 1.4-.8 2.8-.4 3.5.5.7 1.8.2 3.2-.5 1.3-.8 1.6-.2 2.8.5a9 9 0 0 0 3.5 1.4c.5 0 .3-1.3.3-2.3s.2-3.4.7-3.8c.2-.2 2.3-.3 3.8-1 .7-.3 1.7-.6 1.7-1.3.1-.7-1-.7-3.2-1.9-2.3-1.1-2.7-1.8-4.2-2.8-1.4-1-.7-1.3-.7-1.8 0-.4.7-.9 1-1.4.2-.6 0-1.8 0-1.8l1.8-1.8 2-2.3c.8-.6 2-3.6 2.7-4.5.8-1 2.5-2 3.6-3.4a29.7 29.7 0 0 1 11.3-7.6s-.1 2.6 1 3.9 2.6-1 7.5-4.5c5-3.5 8.6-4.7 8.6-4.7l2.4 3.3c1.3 1.6 2.5-.1 8.5-8.5 4.8-6.5 11-12.6 13.5-14.8l1.3.6-.4 1c-.5 1.8-1.4 3-2.6 5.3-1.1 2.4-3 3-5 6.2s-2.4 5.5-2.6 8.8c-.2 3.3 1.7 4 1.7 4s-3 3-4 5.2c-.9 2.2-1.3 6.7-1.3 6.7s-.5.2-1.6 2.5-3.1 2.6-6 5.5c-3 3-6.2 4.2-7.7 5-1.5 1-1 1.9-.7 3 .4 1.2 2.5 2.4 5 3.3 2.3.9 3.2.5 4.8.5 1.7-.1.4 1.2-.3 1.9s-1.6 3.1-1.5 5.8c.2 2.7 2.2 2 4.7 1.6a28 28 0 0 0 5.3-1.6l-.2.8c-.3.7-.4 1.3-.4 3.4 0 2.1.3 3.2 1 3.7.5.6 1.8-.6 2.7-.9.9-.2 2.4-1.1 4.6-1.6 2.2-.5 3-1.5 3-1.5s-.5.7-.6 2.2c-.2 1.6-.1 3.8.2 5.2a9.4 9.4 0 0 0 2.9 4.2c1.5 1.4 1.8.8 3-1 1-1.7 3.3-3.9 3.3-3.9l1.7 5.5c1.5 4.9 6.5 9 6.5 9s5-4.1 6.5-9l1.6-5.5s2.3 2.2 3.4 4c1.1 1.7 1.5 2.3 3 1a9.4 9.4 0 0 0 2.8-4.3c.3-1.4.4-3.6.3-5.2-.2-1.5-.7-2.2-.7-2.2s.8 1 3 1.5 3.8 1.4 4.7 1.6c.9.3 2.1 1.5 2.7 1 .6-.6 1-1.7 1-3.8 0-2.1-.1-2.7-.4-3.4l-.3-.8s2.9 1.2 5.4 1.6c2.5.5 4.5 1 4.6-1.6a10 10 0 0 0-1.4-5.8c-.7-.7-2-2-.4-2 1.7.1 2.5.5 5-.4 2.3-1 4.4-2.1 4.8-3.3.4-1.1.9-2-.7-3-1.5-.8-4.7-2-7.6-5-3-2.9-5-3.2-6-5.5-1.1-2.3-1.6-2.5-1.6-2.5s-.5-4.5-1.4-6.7c-1-2.2-4-5.2-4-5.2s2-.7 1.7-4c-.2-3.3-.5-5.5-2.5-8.8-2.1-3.2-4-3.8-5-6.2-1.3-2.4-2.2-3.5-2.7-5.2l-.4-1a146 146 0 0 1 1.8-.8c2.4 2.2 8.7 8.2 13.5 14.8 6 8.4 7.2 10.1 8.5 8.4l2.4-3.2s3.7 1.2 8.6 4.7c5 3.5 6.4 5.7 7.5 4.4.6-.6.8-1.7.8-2.6a104 104 0 0 1 11.8 4.2c4.3 1.8 4.7 2.8 8.1 5.4 3.4 2.7 8.2 2.5 12.8 1a304 304 0 0 0 21.6-7.5c4.9-2 8.4-4 9-4.9.4-1 1-3.7 1-4.7s-1-2.4-1.4-2.7c-.4-.2-.2-1-.1-1.6 0-.6-.3-2.5-1-3.3-.8-.8-.7-1.1-.6-3.5.2-5-3.4-11.4-8.4-13.4 0 0-.2-.6-.6-1l-1-.6v-3.5c0-.6.2-.5.6-.4.3.2.9.9 1.7 1.1.8.2 1.3-.4 1.5-1.3.2-1 .8-2.8 1.2-3.7.3-1-.1-1-.5-1.2l-2.2-.4c-.6-.1-.6-.2-.4-.5l1-2c.8-1 .1-1.1-.6-1.4a58.4 58.4 0 0 0-4.9-1.3c-.9-.2-1 .6-1 1v2.6c0 .6-.5.4-.9.3a12.6 12.6 0 0 1-1.7-1.2c-.7-.4-1 0-1.3.7l-1.3 4.3c-.2.9-.1 1.5.2 1.6.3.2 2 0 3 0 .9 0 .3.6.3.6l-1.3 2.3c-.4.7-1 .8-1.8.8h-2s-5.3.2-9.2 3-5 5.3-5.6 6.7c-.6 1.4-1.3 1.1-1.9 1.6-.6.5-2.3 2.3-2.3 3.4s.4 1.7-1.3 2.8c-1.7 1.1-3 5.9-.8 8.3 2.3 2.5 3.2 5 4 6.2.6 1.2 0 1.7-.7 1.7s-1.8-1-2.9-1.8l-8.5-6.5c-2.3-1.7-.6-1.5-.6-1.5s.6 0 1.9-.5c1.3-.6 1.5-1.3.2-1.7a16.7 16.7 0 0 1-4.6-2.6c-.7-.7-1-1.4.3-2.1 1.3-.7 4.2-2.6 2-3.2-2.4-.7-5-1.1-7.3-1.8-2.2-.6-2.4-1.2-2.4-1.2l1.5-2.1s1.1-1.7-.2-1.9c-1.4-.2-4.8-.6-7.8-2a18.8 18.8 0 0 1-11.3-12.5v-.1c1.2 2.2 3.8 6.4 7.8 6.5 5.5.2 6.1-1.5 4.9-3.3-1.3-1.8-2.7-3.4-3-4-.4-.5-.5-1.2 1 .2 1.4 1.3 4 5.9 12.3 5.4 8.2-.6 8.2-2.2 8.2-2.6 0-1.6-1.7-1.9-2.7-2.9-.5-.5-.8-1.2.9-.6s5.7 1.4 11.3.2c2.1-.5 8-3 8.5-6 0 0-3.7-.2-6.3-1.3-2.5-1-4-2-1.3-1.4 2.7.5 8 1.6 12.7 0 2.7-.9 6.2-3 6.2-7.1 0 0-5-1-6.9-1.8-1.9-.6-2.5-1.2-2.5-1.2s7.3 2.3 13.8-1c6.6-3.3 6.9-7.9 6.9-9 0-1-.2-1.3-.2-1.3s-6 1.4-10.4 1.4c-4.5 0-5.9-.4-5.9-.4s12.5-.4 18.8-4.2c6.3-3.9 6.7-11.5 6.7-11.5s-7.1 2.6-11.6 3.1-7.2.5-8.3.4c-1.1 0-1.8-.4.7-.5a49 49 0 0 0 17.2-4.8c5.3-3.1 8.6-9.7 8.9-12.8.3-3.1 0-2.6-2.4-1-2.3 1.4-11 5.9-16.7 7.2l-6.8 1.4s-2.2-.1.7-.9zm-225.2 14.4-2.5 1.4-1.3-2.7c-.2-.6-.1-.8.2-.8l2.3-.4h.3c.3.7.6 1.6 1.1 2.4zm76.8 45a20.1 20.1 0 0 1-8.8 7c-3 1.4-6.3 1.8-7.7 2-1.4.2-.2 2-.2 2l1.4 2s-.2.6-2.4 1.3c-2.2.6-5 1-7.2 1.7-2.3.6.6 2.5 2 3.2 1.2.7 1 1.5.2 2.1-.7.7-3.2 2.2-4.6 2.6-1.3.4-1 1.1.2 1.7 1.4.5 5 1.2 5 1.2l-2.3 1.8a18.9 18.9 0 0 1-8.7 3c-2.5.1-6.6.3-11.7 0l-5.8-.3-.5-4.3a21.5 21.5 0 0 0-3-7.8l-3.7-5 .2-1.5c.2-.8 0-1.7-.5-3.3-.6-1.5-3.6-3.8-3.6-3.8l-.2-3.2c0-1.6-1-7.7-2-10.6-1-2.9-5.7-10.5-7.8-14a39.2 39.2 0 0 1-4.3-19.8l.5-1.3a12.9 12.9 0 0 0 3.5 3.2c6.3 3.8 18.8 4.2 18.8 4.2s-1.4.4-5.9.4-10.4-1.4-10.4-1.4-.2.3-.2 1.4c0 1 .3 5.6 6.9 9 6.5 3.2 13.8 1 13.8 1s-.6.5-2.5 1.1c-1.8.7-7 1.8-7 1.8 0 4 3.6 6.2 6.3 7.2 4.7 1.5 10 .4 12.7-.1 2.8-.6 1.2.3-1.3 1.4-2.6 1.1-6.3 1.3-6.3 1.3.6 3 6.4 5.5 8.6 6 5.5 1.2 9.6.4 11.2-.2 1.7-.6 1.4.1.9.6-1 1-2.7 1.3-2.7 2.9 0 .4 0 2 8.2 2.6 8.2.5 11-4 12.4-5.4 1.4-1.4 1.3-.7 1-.1-.4.5-1.8 2.1-3 4-1.3 1.7-.7 3.4 4.8 3.2 4 0 6.6-4.4 7.8-6.6v.1l.3.3a51.7 51.7 0 0 1-2.4 5.3zm66.4-178.2-1.1-2s3 1.4 5 3.5c1.8 2 1.7 3.2 2 4.2.3 1 0 2.9-.3 4.7-.3 1.7-.3 2.8.1 3.4.3.7.7 1 .7 1l-2.7.8c-1.3.6-3 1-4 .2-.9-.8-1.1-1.3-.5-1.8.6-.5 2.8-1.2 3-5 .3-3.7-1.5-7.6-2.2-9m-17 10.3c.8-1.8 1-3.5.5-7.2-.4-3.1-1-5.7-1.2-9 0 0 2.3.4 5.6 3.4s4 6.1 4 7.6-.7 3.4-.9 4.8c0 1.5.4 2.8.4 2.8s-1.1.5-2.2 1.3c-1.1.7-1.9 1.2-3.5 1-1.7 0-2.7-.7-3.7-1.2l-1.5-.6s1.9-1.1 2.6-3zm-16-12.8a14 14 0 0 1 5.6-3.5c-.1 3.4-.7 6-1.2 9-.5 3.8-.3 5.5.5 7.3.7 1.8 2.6 2.9 2.6 2.9s-.6 0-1.6.6c-1 .5-2 1.2-3.6 1.3-1.7 0-2.4-.4-3.5-1.1a14 14 0 0 0-2.3-1.3s.5-1.3.4-2.7c-.1-1.5-1-3.3-1-4.8.1-1.6.8-4.6 4.1-7.7m-11.8 18.3c-1 .8-2.7.4-4-.2l-2.6-.8s.3-.3.6-1c.4-.6.4-1.7.1-3.4-.3-1.8-.5-3.7-.3-4.7.3-1 .3-2.2 2.1-4.2 1.9-2.1 5-3.6 5-3.6l-1.2 2.1c-.7 1.4-2.5 5.3-2.2 9 .3 3.8 2.5 4.5 3 5 .6.5.4 1-.6 1.8zm43.8 31.7c-3.2 1.7-5 1.3-5 2.7.2 1.3 3.1 2.3 3.1 2.3s-3 3.2-5.3 4.6c-2.3 1.5-5 2.4-5 2.4s-1 .2-.4 1.6a5.4 5.4 0 0 0 2.2 2.9l1.1.5s-4 4.3-5.8 5.7a15.3 15.3 0 0 1-4.3 2.5c-1.4.6-.7 3-.4 4 .4 1 1.6 2.5 2.4 2.7.7.2 1 .8 0 2.2-.7 1.1-3 4-4 5.6h-.1l-4.2-5.6c-.9-1.4-.6-2 0-2.2.8-.2 2-1.6 2.4-2.7.3-1 1-3.4-.4-4a15.2 15.2 0 0 1-4.2-2.5 80.2 80.2 0 0 1-5.8-5.7l1-.5a5.4 5.4 0 0 0 2.3-2.9c.5-1.4-.4-1.6-.4-1.6s-2.7-1-5-2.4c-2.4-1.4-5.4-4.6-5.4-4.6s3-1 3-2.3c.2-1.4-1.6-1-4.9-2.7-3.2-1.8-4.3-4.1-4.3-4.1s3.8-1.3 5.7-5a7 7 0 0 0 .7-3.6h.1c6 2 13.1 2.8 19.4 2.8a63 63 0 0 0 19.3-2.8h.2a7 7 0 0 0 .7 3.6c1.9 3.7 5.6 5 5.6 5s-1 2.3-4.3 4z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M361.2 237.8c0-10.2 4.7-16.7 4.7-16.7l-12.7-14.6c-12.2 4.7-23.3 5-33.2 0-9.9 5-21 4.7-33.1 0L274 221.1s4.7 6.5 4.7 16.6-2 17.8-3.1 22.7c-1.2 5-2.1 14.1.5 20.7a26.3 26.3 0 0 0 16.7 17c11.3 4.8 17.3 7.3 21.2 10.6 4 3.2 5.9 5.9 5.9 5.9s2-2.7 6-6c3.9-3.2 9.8-5.7 21-10.4a26.4 26.4 0 0 0 16.8-17.1c2.7-6.6 1.7-15.8.5-20.7-1.1-5-3-12.5-3-22.6"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M357.2 242c-1.6-9.8 4-18.3 4-18.3l-10.9-12.8c-8.4 4.7-20.1 4.1-30.3-.6-10.1 4.7-21.8 5.3-30.2.6l-11 12.8s5.7 8.5 4 18.3c-1.5 9.7-5 25-4.1 31.3.9 6.3 5.3 13.6 9.8 17.4a58 58 0 0 0 16.2 8.7 46.7 46.7 0 0 1 15.3 10s1.5-1.5 3.7-3.2c2.3-1.7 7-5 11.7-6.8a59 59 0 0 0 16.1-8.7c4.6-3.8 9-11.1 9.9-17.4.8-6.3-2.6-21.7-4.2-31.4z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#1d5e91",
      d: "M356.1 243.1a32.5 32.5 0 0 1 3.2-19l-9.8-11c-8.4 4.4-18.5 3.3-29.5-.6-11 3.9-21.1 5-29.4.7l-9.9 11s4.7 8.4 3.2 18.9-4 22.4-3.6 29.4l.2 1.4h9s.5-.6 1.5-1 1.3-.7 1.3-.7.2-1.8 1.2-2.2c1.1-.4 1.6-.4 2-.4.5 0 .8-.1 1.3-.6.5-.6 2-1.8 2.6-3.6.6-1.9 1-2.6 1-3.8 0-1.2.4-3 .4-3s-.2-.6-1.1-.3c-1 .3-1-.6-1.2-1.5 0-.9 0-2.7.5-3.6l.7-1.1-.4-1.5s-5.7 1.2-6.7-3.3-1.1-6.5-1.3-7c-.1-.5-.3-.7-1-.7-.8 0-2.4-.4-3.6-2.7-1-2.3-1.2-3.3-.8-4.2.3-.9.9-.5 1-.3.3.3 1.8 2.5 2.4 1.9.6-.6.3-.6-.6-2.3-.8-1.8-.5-2.3-.4-3.2l-.3-2.5c0-.4.5-.8 1-.6.6.3 1 .6 1.3 1 .2.2.3.6.8.4.5-.3.2-1.9.2-2.4 0-.6.6-1 1.3-.5a2.2 2.2 0 0 1 1.2 1.8c0 .6 0 1.1.3 1.1s.6-.9.7-1.4c0-.6.4-1.5.9-.7.5.7.7 1.7.5 2.8-.2 1.1.2.5-.2 2.4-.4 2-.6 2.8-.5 4.2 0 1.5 0 2.3.8 4 .7 1.8 1.3 3.8 2.6 3.9h1.7s1.5-2.8 2.6-3.5c1.2-.6 2.8-.7 4-.9 1-.1 1.5-.5 1.5-.8 0-.2-.3-.3-1.7-.5s-2.5-.5-2.6-1.6c0-1 .3-2-.6-2-1 0-3.2-.8-4-2.2-.8-1.5-.6-1.8-.5-2.7 0-.8 1.1-2.4 1.8-.9.7 1.6 1.1 1.8 1.7 2 .5.4 1.3.5 1-.5-.5-1-.7-1.7-.6-2.5 0-.8.6-1.1 1.2-1.2l3.4-1 1-.2s.1-.7 1.4-1a9 9 0 0 1 3-.5c.8 0 1.5.1 2.7-.4a5.7 5.7 0 0 1 2.9-.7 3.7 3.7 0 0 1 1.9.8c.5.3.4.9.4 1.4 0 .5 0 .8.8.8.9 0 1.6 0 2.3.3.8.3 1.8.7 1.2 1.5-.7.8-.7 1.7-1.2 1.7-.4 0-.4.4-.5.7-.2.3-.4.5.1.8.5.3.5.6 1.2 1.2.6.6 1.6 1.3.6 2.3-1 1-2.7 1.8-2.7 1.8s-1 .5.1 1.1c1.2.7 1.7 2 2.1 2.3l1.2.8c.3.1.2 1 .2 1l-1.5.8c-.8.4-1.7.8-2.5.8s-1.3 0-1 .7c.4.8 1 1.6 1.1 2l.3 1.2s1.4.3 2.6.3l4.3-.2c2.6-.3 3.4-.4 5.9-.1 2.5.2 2.9.2 3.5.4l1.4.6s3.5 0 5.5-.5c2-.4 2.4-1.7 2.1-2.4-.3-.6-.2-1.6-3.6-2-3.5-.6-4.8-.4-7.5-.9-2.8-.5-7-1.9-7.7-5.3-.8-3.4 2-4.8 3.3-5.5l5.8-2.3c1.4-.5 3.9-1 6.5-.7 2.7.4 4.2 1 5.3.5 1-.7 1.9-.2 1.7.8-.2 1-1.3 2.9-4.3 3.8-3 .9-6.6 1-8.5.5-2-.6-3.4-1.3-4.6-.9-1.2.4-2.5 1.9-1.3 3.7 1.3 1.7 7.9 2.3 9.6 2.4 1.8.2 8.3-.2 10.2 3 1.8 3.2.3 6.9-1.8 7.7a29 29 0 0 1-5.7 1.5l-1.7.3s.8 1.7.8 2.4-.1 2 .7 2.6c.8.5 2 .9 3.3.7 1.4-.1 3 .8 3.1 2 .1 1.3.5 3 .6 5.5.2 2.5 0 4.5 0 4.5s0 1-.4 1.9c-.3 1-2 4.4-2 4.4h9.5l.2-1.4c.4-7.1-2-19-3.6-29.5z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#6d8c3e",
      d: "M281.6 278.6a27.4 27.4 0 0 0 11.6 14.3c8.2 5 11.8 4.3 19.5 9.3 7.7 5 7.2 5.8 7.3 5.8.1 0-.4-.8 7.3-5.8s11.3-4.4 19.5-9.3a27.4 27.4 0 0 0 11.6-14.3h-76.7z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M288.3 237.2c.9 1 1.5 1.2 2.9 1 1.3 0 1.7.9 1.9 2 .2 1 .2 3.5 1.2 5.8s4.2 2.5 4.2 2.5c0-1.1.5-2.6 1-3.9 0-.2.5-1.2-.7-1.2s-1.1-.5-1.8-1.6c-.7-1-2-4-2.4-6a16 16 0 0 1 .6-5.7c.4-1 .4-1.7 0-1.9h-1s.2 1-.1 1c-.3.2-.6-.4-.8-1-.3-.7-.5-.6-1-.6s-.5.5-.1 1c.3.4.1 1.3.1 1.3l-1.4-1c-.5-.2-1.4.2-1.5.8-.1.5.3 2 1.2 2.7s1 2.2.6 3c-.2.6-1.5.5-1.8.2a.8.8 0 0 0-1.2 0c-.4.5-.8.7.1 1.6m-.5-2.5-.7-.6a35.1 35.1 0 0 1-.5-.7l-.1.7c0 .5.6 1.2.6 1.2zm2-6.4c.4-.1.7-.2.4-.7-.4-.5-.6-1-1-1-.3-.2-.6-.1-.6-.1l.5 1.3c0 .5.2.7.6.5zm2.4-2c0 .5 0 .7.4.5.4-.2.5-.7.3-1a2 2 0 0 0-.6-.7l-.3-.2s.2 1 .1 1.5zm3.4.6-.1-1s0 .6-.3 1c-.2.3-.1.2 0 .5.3.2.4 0 .4-.5m5.4 23.5c.7 1.6 2.4-.9 4-2.9s1.5-.4 1.3 1.2a7.6 7.6 0 0 0 1 4.5c.7 1 1.2.4 1.5-.4.2-.7.5-2.4 1-3.2.5-.7 1 0 1 .6.1.7 1 2.2 1.7 3.1.8 1 1.2-.3 1.5-1.4l.7-3.5c.2-.6 1 0 1 0l1.6 1.5c1 1 1.1-.6 1.2-1.4.1-.8-.1-2.5.2-2.8.3-.3 1.2.4 2.5 1 1.4.7 1.3-.6 1.2-1.3a7.4 7.4 0 0 0-2-3.4c-1.2-1-1.3-2-1-2.5.4-.5 1.7 0 2.6-.1l1.8-.3c.7-.2.7-.8.7-.8s-.5-.8-1.4-1.6c-.9-.8-1.4-1.4-2.5-1.6-1.1-.3-2.6 0-2.6 0l-.2-.4c-.1-.3-.4-.3-.6 0l-1.2 1.1c-.4.4-.7.6-1 .5-.2-.2.3-.6.3-.6s.5-.4 1-1.4c.6-1 .7-2 .3-2.6-.4-.4-1.5 0-2.2 0-.6 0-1 .2-1-.2 0-.3.6-.1 1.4-.2.8-.1 1.3-1 1.5-1.9s.5-.6 1-.2c.4.5.9.4 1 0l1-1.8c.5-.8.8-1.9.3-2.6-.6-.8-2-.7-2.6-.2-.6.5-1 1-1.1 2.1-.2 1.2-.5.5-.5.2 0-.4-.4-1-.2-1.5.2-.4 0-1 0-1s-.1-1-1.2-1.1a8.6 8.6 0 0 0-3.5.3c-1 .2-.9 1.2-.9 1.2l-1.7.1c-.9.1-2 .5-2.8.7-.8.2-1.1.3-1.1.7l.1 1.1s.7 0 1 .3.2.5-.2.7c-.4.2-.6.2-.6.7s.2.7.7.7c.4 0 1.3 0 2.3.4s1.3 1.4 1.2 2c0 .5-1.5 1.2-2.3 1.2s-1 .1-1 .6 1 .4 1 .4l2.6.3c1.7.2 2 .6 2.8 1.2.7.7.2.9-.2 1-.4.3-1 .8-1.5 1-.6.2-1 .6-1.5.7-.5.1-1.8 0-4.2 1-2.4 1-3.3 4.1-3.3 4.1l1.4-.7c1.1-.5 2.5-1.2 3.8-2 1.2-.7 1.2.4.6 1.5s.6.9 1 .6l2-1.3c1.2-.6.8.4.8.4s-.4.7-.5 2.5c-.1 1.7 1.7 0 2.5-1 .9-1.1 1.2 0 .6 1.2-.6 1.3-1.8 2.3-2.5 2.3s-1.2-.8-1.3-1.2c0-.4.3-1.7-.1-2-.5-.3-1.7 0-2.6.6-.9.5-1 .1-1.3-.4-.2-.4.3-.6.1-1-.2-.2-.6 0-1 .2l-2.8 1.5c-1.7.9-1.6 1.3-1.6 2.5s.3 1.5 1 3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m316.7 224.2 1-.5 1.5-.3c.7 0 .6-.5.4-.8-.1-.4-.4-.5-1.4-.5-.9 0-1.5.5-2 .7l-1.1.4.4.6c.4.5.9.6 1.2.4m3.8 3.7.8-.2 1.3-.6c.6-.2.8-.3 1.2-1 .4-.8-.4-.8-1.5-1-1-.3-1.6 0-1.7.5-.1.4 0 .8-.5 1.6s0 .7.4.7m-.3 1c-1 0-2.3 1.5-2.7 1.8-.4.3-.2.6-.2.6l.4 1.2c.2.7.2 1.7.2 1.7h.8c.6 0 1-.2 1.6-.7a4 4 0 0 1 1.8-.7c.9-.2 1.3-.3 2.2-.8 1-.5-.5-1.4-1.5-2.2a3.7 3.7 0 0 0-2.6-1zm-14 3.6c.8-.1 1.2-.5 1.2-1s-.4-1-1.5-.9c-2.6.3-5.1-.7-5.6-3.2 0 0-.8 1.6.8 3.4 1.6 1.8 4.3 1.8 5.1 1.7m-8.9 41 .5.4h4c.7-.2.7-.8.7-1.2 0-.5.4-2 1-4.7.5-2.6 1.5-4.5 1.9-5.6.4-1-.4-1.4-.7-2l-.8-2.5c-.1-.6-1-.5-1.6-.5-.5 0-.6.9-.7 1.7 0 .8-.4 3.1-.8 5.1-.4 2-2.7 4.7-3.3 5.3-.6.6-1.2.8-1.6.8-.4 0-1.4 0-1.8.3a2.4 2.4 0 0 0-1 1.6c0 .6.9 1 .9 1l1-.8c.3-.4 1-.5 1.5-.6.7-.1.7.1.5.4-.2.3-.1.4.3 1.2zm-6-.2c-.4 0-.6.4-.7.6h2.6a1.4 1.4 0 0 0-.3-.7c-.3-.3-1.1-.1-1.7 0z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M294.8 273.2a3 3 0 0 0-1 .7h2.9c0-.2.1-.6-.2-.9-.7-.5-1.3 0-1.7.2M319 272c-.3 0-.6.3-1 .6-.5.3-.6.8-.7 1.2a.3.3 0 0 0 0 .1h1.3a.2.2 0 0 0 0-.1c0-.4.2-.7.7-1.1.5-.5 0-.7-.3-.7m2.3 1.3c0-.4-.1-.7-.4-.7-.2 0-.7.5-1 .8a2.4 2.4 0 0 0-.5.5h1.7z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M332.3 260.4c.8-.6.7-.8.7-1.5 0-.6 0-.8-.3-1a5.9 5.9 0 0 0-2.8-.8c-1.1 0-3.4.3-4.2.8-.9.6-1.3 2.7-1.3 3.8 0 1 .2 1.2.5 1.2s.8-.8.8-.8l1.8 2.5c.7 1 .4 1.4 0 2.2-.2.8-1.4 2.9-2.2 3.3-1 .5-1.6 0-2.6-.1-1.1-.2-1.7.1-2.3.7s0 1.1.4 1.1c.3 0 .8 0 1.2.5.3.3.1 1.2 0 1.6h5.2c.9-.4 1.5-1.6 1.7-2.3.3-.7 1.4-1.7 2-2.2.5-.5.5-.8.5-2s-.2-1.7-.6-2.5c-.5-.8-.8-2-.6-2.6 0-.7 1.2-1.4 2-2z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M323.7 247.4c.6.9.3 1-.4 1.2a8.5 8.5 0 0 1-2.8.2c-1.1-.1-1.1 0-1.1.6a5 5 0 0 1-.8 2.7c-.7 1-1.6.6-2 .2-.6-.3-.9-.2-1 .4l-1.2 2.1c-.5 1-.9 1-1.3.9-.4-.1-.7-.7-1.1-.7-.4 0-1-.8-1.6-1.8-.6-.9-.9.1-1.3 1-.4.8-.7 1.3-1.5 1.2-.7 0-1.6-1.5-2-2.3-.4-.8-.7-1.6-1.3-1.6-.7 0-1.7 1.4-2.4 1.7-.7.4-1 .3-1.3-.2-.3-.4-.7.2-1.1 1.2-.4 1.1 0 2 .6 2.3.6.3 1.7-.5 2.5-1 .8-.6 1.1-.5 2-.5.8 0 .7 1.4 1 3.3.4 2 1.5 2.2 1.5 2.2s.4.3 1.3-1.1c.9-1.5 1-3 1.8-3 .9 0 1 .2 1.8 1.4.8 1.1 1.5 2 2 1.1.5-.8.9-2.1 1.5-2.6.5-.4 1-.6.4.3-.5.8-.8 1.7.4 1.4 1.2-.4 5.7-2.2 7.6-2.6l4.7-.5 4-.3c1 0 1 0 1.1-.7 0-.7-.5-.5-2.3-.5-1.8 0-3 .2-4.3.4-1.3.2-1.8.2-1.6-.2.2-.3.6-.5 2-.7a58 58 0 0 1 6-.5c1.6 0 1 .5 1 1.5-.2 1 0 2.6.2 3.5 0 1 .1 1.3 1 2.7s3.7 2.2 4.5 2.6c.9.5.7 0 .7-.8s.7-.8 1.4-.3c.7.4 2 .7 2.9 1 .8.2 1 .4 1 .8 0 .5 0 1.5.2 2.4 0 1 0 1.2-.4 1.8l-2 2.3s-.8 0-2.3.4c-1.6.3-2.1 1.1-2.3 1.7-.1.7.3.9.4 1.1v.8h.4c0-.2.3-.5.5-.8.6-.7 2-.9 2.9-.5.6.3.6 1 .5 1.3h3.6l2-3.9a6 6 0 0 0 .6-2.6c0-1.2.2-5.8 0-6-.3-.3 0-1.1 0-2.4-.1-1.3 0-2.3-2.4-2.5-2.4-.2-3.2-1.2-4-2-.8-.8-.6-2.7-1.2-5-.7-2.2-2.3-2.6-5-3.1a23.3 23.3 0 0 0-7-.5c-2.2.2-4.8.5-6.2.4-1.5-.2-1.2.2-.7 1z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m337.3 273.4-.5.5h2.4a1 1 0 0 0-.2-.7c-.4-.4-1-.2-1.7.2m4.4-.2a2.2 2.2 0 0 0-.8.7h2.5a1 1 0 0 0 0-.3c-.1-.4-.9-.8-1.7-.4m-61 1.6a24.1 24.1 0 0 0 .5 2.3h77.6l.6-2.3h-78.8zm52.3-37.1c2.4 1.6 10.2 1.7 13.9 2.4 3.6.8 3.4 3.6 2.3 5-1.2 1.5-6.3 1.7-7.2 1.8.5.3 1.2 1.4 1.2 1.4l2.1-.2a11 11 0 0 0 6.1-2c1.9-1.6 1.8-4 .1-5.8-1.6-1.6-4.3-1.8-7-2.1-2.8-.3-5-.5-8-1-3.2-.6-4.7-1.8-4.7-3.6s1.7-2.8 2.9-3.1c1.2-.4 3.1-.9 4.9-.2 1.7.6 3.7.7 7.1.3 3.4-.5 4.2-2.8 4.2-2.8s-.4.2-2.2.2c-1.7 0-3-.7-6-.7-3.2 0-4.3 1-5.8 1.6-1.5.5-5.4.9-6.5 3.4-1.2 2.5.1 3.7 2.6 5.4"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 312.6,
      cy: 226,
      fill: "#b96b29",
      rx: 1.5,
      ry: 1.4
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M344 228.4c-2-.2-4.5.4-4.5.4s.5.4 1.2.3c.6 0 1.8 0 3.7.3 1.9.3 3.2-.6 3.2-.6z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#1d5e91",
      d: "M325.6 264.6c-.5-.8-.6-.7-1.2-.2-.5.4-1-1.2-1.1-2.2l.4-4.1s-2.6.5-4 1l-4 .9c-1.1.2-1.8.5-2.4.4-.6-.2-1.9-.2-2.9-.2s-1 .2-2 1.2-1.3 1.5-2 3.4a20 20 0 0 0-1.4 6 15.6 15.6 0 0 1-.7 3.1h12.2l.5-1.2a3 3 0 0 1 1.4-1.4c.5-.2 1-.2 1.2-.8.2-.5.8-1 1.4-1.2.7-.3 1.8-.2 2.8.1 1 .3 1.4-.4 1.7-.8.3-.4.4-1 1-1.6.5-.7 0-1.3 0-1.3l-1-1.1zm19.5.3c-.1-.7 0-.8-.5-.9-.4 0-1.1-.2-1.7-.5-.6-.2-.5 1.4-.5 1.4s-1.5.2-3.1 0-3.5-1.7-4.2-2.2a5.5 5.5 0 0 1-1.4-1.5l-1 .7c-.5.3-.8 1.3-1 2.4 0 1 1.3 2.2 1.4 3.2 0 1-1.2 3.1-1.8 4a9 9 0 0 0-1.2 2.4h5.9a3 3 0 0 1 .6-1c.6-.6 1.6-.7 1.6-.7l.2-.8c.2-.5.9-1.2 2.3-1.8 1.5-.5 3.3-.6 3.3-.6s.7-.6 1.2-1.4c.5-.8 0-2 0-2.7z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M296.2 329.6c1.1.4 3.2-.4 4.2-1.6 1-1.3 1.4-3.2 2.1-4.3l1.3-1.9s-.2 1.8-1.2 4.3a15.5 15.5 0 0 0-.8 6.8c.4 2.7 2.2 3.1 3.2 2.7.8-.2 2-1.4 3-3.2l1-2c.6-1.3 1.2-3.5 1.5-3.4.7.1.3 1.6 0 2.6-.5 2-1.5 5-1.6 7 0 1.7.2 5 2 5.2 1.8.1 2.8-1.5 3.8-5.2s1.2-5 1.7-5c.4 0 .4 2.6.4 3.7a18.2 18.2 0 0 0 1.6 7.4c.9.8 1.6.7 1.6.7s.7.1 1.6-.7c.9-.8 1.6-6.3 1.6-7.4 0-1 0-3.6.5-3.6s.6 1.2 1.6 4.9 2 5.3 3.8 5.2c1.9-.2 2-3.5 2-5.3 0-1.8-1.1-4.8-1.6-6.9-.5-2 .2-1.9 1.6.8l1.3 2.5c1 1.6 2 2.5 2.6 2.7 1 .4 2.8 0 3.2-2.7.5-2.7-1.6-10.5-1.6-10.5l1 1.3c.7 1.1 1 3 2 4.3 1 1.2 3.1 2 4.2 1.7 1-.4 1.2-2.4.4-6.1s-4-5.7-6.4-8.6a31.6 31.6 0 0 1-4-8.2 27 27 0 0 0-7.9 5.6l-5.9 6.3s-1-1.3-5.8-6.3a27 27 0 0 0-8-5.6c-.2.6-2.2 5.2-4.4 7.9-1 1.3-2.5 2.3-3.6 3.6a12.4 12.4 0 0 0-2.4 5.3c-.8 3.6-.6 5.7.5 6z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M296 342c1.5-1.2 2.2-2 2.2-2s1-.8.8.9c-.3 1.6-.8 5-.5 6.4.4 1.4.5 2.7 2.3 1.6 1.8-1 2.3-1.7 3.1-2.6.9-.9 1.8-1.3 1.6.1-.3 1.4-.9 3.6-.6 6.4.3 3 1.7 3.3 3.6.9a32.3 32.3 0 0 0 3.5-5.9c.5-1.2 1.6-2.2 1.6 0 0 4.8 1.1 11.8 6.4 13.6 5.3-1.8 6.4-8.8 6.4-13.6 0-2.2 1.1-1.2 1.7 0a32.4 32.4 0 0 0 3.5 5.9c1.8 2.4 3.2 2 3.5-.9.3-2.8-.3-5-.5-6.4-.2-1.4.6-1 1.5-.1s1.3 1.5 3 2.6c1.9 1 2-.2 2.4-1.6.3-1.5-.2-4.8-.5-6.4-.2-1.7.8-.8.8-.8l2.1 2a6 6 0 0 0 3.4 1.2s.9-5-1.2-8c-2-3-2.9-4-2.9-4s-1.1 0-2-.4c-1-.3-1.8-1-1.8-1v2.8l3.1 3.1c.6.8 1.8 2 0 .8a50.5 50.5 0 0 1-3.1-2.4s-.4 2.5-1.1 3.2c-.7.6-1.8.7-2.2.5l-.4-.1-.2 1s1.6 3 1.8 4.1c.3 1.2 0 1-.8-.5-.7-1.5-2.2-3.5-2.8-4.5-.6-1.1-1.6-1.8-1.5-.5.1 1.4-.5 3.9-1 4.8-.4.9-.7 1.2-.7 1.2l1.1 4c.1.7 0 1.5-.5.6-.6-.8-2.1-4.2-2.1-4.2s-2.1 0-2.7-.7c-.6-.6-1.6-2.9-1.6-2.9s-.8 3-1.5 4c-.7.9-2.4 1.8-2.4 1.8l-.2 6c-.2 1-.2 1.3-.6 1.3s-.4-.4-.5-1.3l-.3-6s-1.6-1-2.3-1.9c-.7-1-1.6-3.9-1.6-3.9s-1 2.3-1.5 3c-.6.5-2.7.6-2.7.6s-1.6 3.4-2.2 4.2c-.5.9-.6.1-.5-.5l1.1-4.1s-.3-.3-.7-1.2c-.5-1-1-3.4-1-4.8.1-1.3-.8-.6-1.5.5s-2 3-2.8 4.5-1 1.7-.8.5c.2-1.2 1.8-4.1 1.8-4.1l-.1-1-.5.1c-.4.2-1.4.1-2.2-.5-.7-.6-1-3.2-1-3.2l-3.2 2.4c-1.8 1.2-.6 0 0-.8l3.2-3.1v-2.8s-1 .7-1.8 1c-1 .4-2.1.4-2.1.4l-2.9 4c-2 3-1.2 8-1.2 8s2 0 3.4-1.3zm25.8 33.5L320 373s-.4.8-1.8 2.4a43 43 0 0 1-4.5 4s.3 4.2 1.8 6.5c1.3 1.9 2.5 3.6 4.5 5 2-1.4 3.3-3.1 4.5-5 1.6-2.3 1.9-6.5 1.9-6.5s-3.2-2.4-4.6-4z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M319.4 380.6c0 1 0 3.4.6 3.4s.5-2.4.6-3.4l.2-3.3h-1.6s0 2.3.2 3.3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M320 151.3c-5.7.1-12.3-.7-16-2l-3.8.8a52 52 0 0 0 19.8 3.3c8.8-.1 13.8-1 19.8-3.3l-4-.8a50.7 50.7 0 0 1-15.8 2m20.5-4.7c-.4-.4-3-2.2-3.7-2.5-.6-.4-.1-1.3 0-1.6.1-.4 3-1.2 4.6-1.7 1.6-.4 1.4-.7 1.4-.7s-1-1.1-6.8-1.7c-5.8-.7-16-.5-16-.5s-10.2-.2-16 .5c-5.8.6-6.8 1.7-6.8 1.7s-.2.3 1.4.7a19 19 0 0 1 4.6 1.6c.1.4.6 1.3 0 1.6a45 45 0 0 0-3.7 2.6c-.5.4-.5 1 .2 1s.7 0 2.7-.4a94.4 94.4 0 0 1 35.2 0c2 .4 2 .4 2.7.4.7 0 .7-.6.2-1"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M333.9 149c-4-.4-6.5-1-13.9-.9-7.4.1-10 .5-13.9 1 2.5 1 6.6 1.5 13.9 1.5s11.4-.5 13.9-1.5zm-15-57.5-.1 2.8 3-.2-.3-2.7 3.3.5.1-2.6-3.4.3.6-2.9h-3.8l.7 2.9-3.3-.3v2.6zm6.5 7.1h-4v-3.4a6 6 0 0 0-1.3-.2l-1 .1v3.5h-4.3a4.6 4.6 0 0 0-.2 2h11v-.6a5.4 5.4 0 0 0-.2-1.4"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#1d5e91",
      d: "M320.1 105a5.5 5.5 0 0 0 5.2-3.4H315a5.5 5.5 0 0 0 5.2 3.5zm2.3-9.5v2.4h2.7a5.3 5.3 0 0 0-2.7-2.4m-4.5 0a5.3 5.3 0 0 0-2.8 2.4h2.8z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "m323.3 140-3.3-1.5-3.3 1.7c-1.2.5-1 .4-1.4 1.2-.3.9 0 1.2.6 1.4l4.1 2 4.6-2c.8-.4.7-.8.4-1.5-.2-.6-.7-.8-1.7-1.3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m320 139.3-3.5 1.7 3.6 1.9 3.5-1.9zm0-12.3s-.3 1.2-.7 1.8c-.4.5-.7 1-.6 1.7 0 .6.8 1 1.3 1 .4 0 1.2-.4 1.3-1 0-.7-.2-1.2-.6-1.7-.4-.6-.7-1.8-.7-1.8"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 320,
      cy: 132.8,
      r: 0.7,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M317.6 129.4s1.1-1.3 1.6-2.2l.8-1.5.8 1.5c.4.9 1.6 2.2 1.6 2.2s1.6-1 2.6-4c1-3.2-.3-6.6-.7-10.1a208 208 0 0 1-.8-9.8 7.3 7.3 0 0 1-3.5 1 7.3 7.3 0 0 1-3.6-1s-.3 6.2-.8 9.8c-.4 3.6-1.6 6.9-.6 10 1 3.2 2.6 4 2.6 4z"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 320,
      cy: 122.3,
      fill: "#b96b29",
      rx: 2.8,
      ry: 2.7
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 320,
      cy: 115.8,
      fill: "#b96b29",
      rx: 2.7,
      ry: 2.6
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 320,
      cy: 109.7,
      fill: "#b96b29",
      rx: 2.6,
      ry: 2.5
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 320,
      cy: 121.8,
      fill: "#d4af3a",
      rx: 1.5,
      ry: 1.4
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 320,
      cy: 115.4,
      r: 1.4,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 320,
      cy: 109.2,
      fill: "#d4af3a",
      rx: 1.3,
      ry: 1.2
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M319.9 336c.2.1.2-.3.2-1.2l.4-4c.2-1.2-.3-1.1-.6-1-.3 0-.5.9-.5 1.4l.1 4.2c0 .6.2.6.4.7z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m290.4 359.1 5.2-3.6a11.8 11.8 0 0 0 4-4h-1c-.6 0-1-.7-1.1-1.5 0-.8 0-2.3.2-4.1.2-1.8-.3-3.3-.3-3.3s-1.2 1.1-3 2c-2 1-2.7.6-2.7.6l-.4-1.9-2 3.7c-1.1 2-4.2 4.2-6.4 5.8a28.6 28.6 0 0 1-6.4 4c-1.8.7-.7 1.5-.7 1.5s1.8 1.8 6.5 2.7c4.6.8 6.9-1 8.1-1.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M306.8 357.3c-1.7-.2-2.7-.8-3-2.6-.2-1.2 0-5.7 0-5.7l-1.1 1.2c-.7.8-2 1-2 1l-1 1.6a9.3 9.3 0 0 1-3 3.2 50.7 50.7 0 0 0-4.6 3.2 28.1 28.1 0 0 1-4.3 3.1 7 7 0 0 0-3.6 4.7c-.5 2.4 0 3.1 1.8 3 1.8-.1 2 0 5-.7 3-.8 7.3-4.1 10.4-6 3-2 5.4-6 5.4-6"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M315 360s-1.2-1.6-1.7-3.4l-1.3-5.4-1.5 3.3c-1 2.1-2.7 2.7-2.7 2.7s0 .9-1.5 2.7a21 21 0 0 1-5.7 4.8c-2.1 1.2-5 3-6.4 5.1-1.5 2.2-1.7 4.4-1 5.4.8 1 1.8-.1 3.2-.9 1.4-.7 5.5-1.3 11.2-4.4 5.6-3 7.4-9.9 7.4-9.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M317.5 372.7c1.5-2.4 1.8-8 1.8-8l-1.3-1c-.8-.7-2.2-2.9-2.2-2.9l-2 3.8c-1 1.8-1.5 2.4-3.6 4.3-2.1 2-5 3.9-6.2 6-1.2 2-.5 6.1.3 7.5.8 1.5 2 1 3-.1l3.7-3.3c2.1-1.8 5-4 6.5-6.3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M299 325.3c.8-1.7 1.7-3.7 2.5-4.8a15 15 0 0 0 1.3-2.2s-2 1.8-2.8 3.1c-.8 1.4-1.3 2.6-1.7 4-.3 1.4-.2 1.6.7 0zm8 1.5.5-1.9s.3-1 .1-1.1c-.2-.1-1 .6-1.6 2.5-.5 1.8-1.4 4.5-1.2 4.6.2 0 1.8-3 2.2-4.1m6.3 5 .3-.8s.7-2 .7-2.5c0-.4-.2-1-.8.1s-.6 2.2-.7 2.6c0 .5-.7 2.1-.5 2.3.2.1.6-.9 1-1.7M293.7 351l-.8-.5-1.3 1.5c-.7.7-1.5 1-2 1.7a8 8 0 0 1-2.7 2.3c-1.3.7-1.8 1-1.6 1.1.3.2 1.2-.3 1.2-.3s.3 0 1.9-1c1.6-.9 2-1.4 3-2.3 1-.9 2.3-2.5 2.3-2.5m6.8 8.1c.6-.6 1.3-1 1-1.4-.4-.3-.8-.3-1.4.2l-2.8 2.6-2 1.5c-.7.6-2.3 1.4-3 1.8-.8.5-.1.5-.1.5l1.2-.5 2.5-1s.7-.3 1.6-1c1-.7 2.4-2 3-2.7m7.9 5.5c.5-1 0-.8-.9-.4-.8.3-2.7 2.4-3.8 3.1-1.1.8-2 1.1-3 1.6-.9.4-.9.7-.8.9 0 .2.4.2.8 0l1.6-.9 1-.2c.6 0 1.3-.6 2.4-1.6 1.2-1 2.2-1.5 2.7-2.5m3.7 7.2c-1.4.8-3.8 2.7-4.5 4-.6 1.2-1 2.1-.8 2.3.2.2.9-.2 1.2-.7l.9-1.2s2.4-2.4 3.3-3a8.3 8.3 0 0 0 2.6-3c.4-1 .1-1.4.1-1.4s-1.5 2.1-2.8 3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#c52126",
      d: "M275 170a22.3 22.3 0 0 0-8.3-2.6c-3.7-.3-6.5.2-9.5 1-2.2.6-4 .7-5.7.3-2.6-.7-4.6-3-5.3-6 0 0-2.4 3.1 0 6.5a7.2 7.2 0 0 0 4.4 2.9c5 1 10-2 14.3-2.4 4-.2 7.3 2.4 7.3 2.4s1 .8 2.3 0c1.4-.8 1.8-1.4.5-2.2z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m260.3 317.5-1.2-.2c-.7 0-2.2-.6-2.7-.8-.4-.2-1.1-.2-1.6.3-.4.5-4 2.7-4 2.7h6c2 0 3.5-2 3.5-2"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M277.4 316.4v-.5l-.8-1.8s-1 .6-1.9 1.5c-1.2 1.3-2.4 3-3 3.7-1 1.3-2.4 2.5-1.2.5s1.6-3 2.6-4.4c1-1.3 1.7-2 1.5-2l-3.4-.5c-2.5-.3-4.1-1.3-5.3-2l-3.3-1.9s-4.3 1.9-5.9 2.3c-1.6.4-2.6.6-1 1.4 1.6.8 2.9 1 3.7 1.5a11 11 0 0 0 4.6 1.2c1.4 0 3.9 0 3 1-1 1.1-2.1 3-3.2 6a20.3 20.3 0 0 0-1 7v2.5s1.8-2 6.6-5 6.6-4 7.5-4.4c.9-.4 1.3-.4 1.1-1.5z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M295.6 302a68.5 68.5 0 0 1-.9-.4 1 1 0 0 0-.2 0 15 15 0 0 0-4.6 4.2c-1.2 1.9-2.4 2-1.1 0a17.9 17.9 0 0 1 3.2-4.2 23.5 23.5 0 0 1 1-.8 53.3 53.3 0 0 1-7.3-4.2l-1.6 2.5c-1 1-3.3 2-3.3 2s1.8-2 2.4-3.3l.8-2.5a31.6 31.6 0 0 1-4.8-4.6 17.8 17.8 0 0 1-4.1 7.4c-3.8 4.2-11.3 6.3-11.3 6.3s-2.6.3-.5.9c2.2.5 3.7 1.5 7.8.8l5-1.1c.6-.2 2 0 0 .7-2 .8-6.9 1.5-8.7 1.4-1.9-.2-4.4-.6-1.8.8 2.7 1.4 3.8 2 5.4 2s2.3.5 3.9.5 2-.3 3-.5c1.2-.3 2 .1 2 .6 0 .4-1.6 1.7-1.5 4.7 0 3.1.3 5.1.5 6 .3 1 1 2.4 1.4 3.2.5.8.7 1.7 1.1-.1.5-1.8 1.5-4.4 1.9-6.1.3-1.7.6-1.8.7-2.7.2-.9 1.2-1.6.7 0a133.4 133.4 0 0 0-1.3 5.2c-.3 1.5-1.1 4.2.2 2 1.4-2 6.4-7.7 7.3-8.8l2-2.8c.7-.8 2.4-1.9 3.3-3.1a28.5 28.5 0 0 1 3.9-4zm-69.5-129.2c0 3.1 3.5 9 5.5 12.2 1.9 3.1 2.4 4.4 2 4.6-.2.2-1-1.4-2.1-2.8s-3.2-4.7-5-7.2c-1.6-2.5-4.2-8.4-4.5-8.9-.4-.5-.5-.9-1.4-.2-.8.7-2.5 7.2-.5 11.6 2 4.4 5 7.6 6.3 9.2 1.3 1.5 3 4 2.7 4.1-.3.2-.8-.4-2.3-2L221 187a51.6 51.6 0 0 1-3.8-6c-.2-.5-.6-.4-.8-.2-.5.6-1.4 1.9-1 5.4a17 17 0 0 0 5.3 10.2c2.3 2.4 4.6 4.5 4.2 4.9-.3.3-2.7-1.8-4.3-3.3-1.6-1.6-5.5-5.4-6.4-6.5-.9-1-2.1-.5-2 3.7 0 4.3 4.7 8.5 6.6 10.9 2 2.3 4.4 3.7 4.2 4.2-.2.5-2.2-.7-3.4-1.6l-7-4.6c-1-.7-1.4.6-.2 4.6 1.2 4 4.7 7.2 6.8 8.7 2 1.5 5.4 3.3 5.2 3.8-.2.4-1.6-.2-3.6-1.1a39.4 39.4 0 0 0-6-2.3c-1.6-.5-1.6.7-1.6.7s-.3 3.5 2.2 6.2a13.3 13.3 0 0 0 8 4.3c2.6.5 3 .6 3 1-.1.4-.4.5-1 .5l-5.4.2c-2.2 0-3.4.6-3.4 1.6s-.1 2.3 3.3 4.6 7.2 2.6 8.8 3c1.6.3 1.7.4 1.4.9-.4.5-1.1.4-3.6.7-2.6.2-4.1 1.2-4.5 2-.3.6.2 2.6 2.3 4 2 1.4 4.8 1.9 8.8 1.6 4-.3 5-.3 5.1.3.2.7-1.2 1-3.2 1.2-2 .4-3.5.4-4.7 1.3-1.1 1-.2 2.9 1.7 4.3 2 1.4 6.8 1.4 8.8 1.3 2-.2 5-.9 5.3-.4.2.6-1.5 1.4-3.6 2.1-2 .8-2.7 1.2-3 2.1-.5.9-.1 1.7 2.3 2.6 2.5 1 6.1 1 8 0 1.9-.8 2.9-1.1 3.2-.8.4.3 0 .7-.4 1.1-.4.5-2 1.8-4 2.3-2.1.6-2.3.6-3 2.2-.8 1.7 1 3 4.8 3.2 3.8.1 8.8-1.4 10.4-2.3 1.6-1 2.2-1.1 2.5-.8.2.3.2.5-.6 1.1-.8.6-3.4 2.5-4.7 2.8-1.2.3-1.4 1.3-1.4 2.1 0 1-.3 2.6 3 3.5 3.4.8 7.3.2 11-2.4a8.3 8.3 0 0 0 2.2-2 28 28 0 0 1 .2-8c-.7 0-2-.3-3.4-.9-2-.8-2.8-2.6-3.3-3.6-.4-1-1.1-1-2-.8-.7.3-1.5.6-2.6.6a7.9 7.9 0 0 1-5.3-2.8c-1.8-2-1.4-4-1.5-5 0-1-1.7-.3-2.5-.3s-3.1-.4-5.3-1.9c-2.1-1.4-2.1-3.4-2.3-4.3-.2-.8-1-1.3-1.7-1.6-.7-.2-1.8-.5-3.3-1.7a6.9 6.9 0 0 1-2-4.4c-.1-.8-1-.8-4-2.4-3-1.5-2.7-4.7-2.6-6 .1-1.3 1.5-2.3 1.5-2.8s-1-.6-2-1.2-3.5-1.6-3.6-5.4c0-3.7 2.4-4.1 2.4-4.1l-1.4-.8c-1-.6-3.8-2.5-3.8-4.7s1-3.2 1.8-3.8 2.7-1 2.7-1-1.3-.9-1.8-2.6c-.5-1.7-.7-3.9.5-5.4 1.3-1.6 3.4-1.6 4.6-1.6 1.1 0 2.1.6 2.5.3.4-.3.5-.6 0-1.5a6.6 6.6 0 0 1 0-3.7c.3-.8.4-2.2 3.2-3.2 2.9-.9 6 1 6.9 1.6.9.5.5-.8.5-1.7 0-1-2-3.3-4.2-6.6a73 73 0 0 1-5.6-10.2 65.7 65.7 0 0 1-4.5-13.4c-.3-1.6-1-.8-1-.8s-.6.2-2.2 4.1a25 25 0 0 0-1.6 10.5"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M276.5 241.4c-1.7-.1-4-1-5.7-3.6-1.7-2.5-4.3-3-8.8-3-4.4.1-6.5-2-7.6-5.2-1.1-3 .1-6.6 4.7-8.9 4.6-2.2 6.7-4.7 6.8-8.6.2-3.9-4.5-8.7-9.3-14.1-4.7-5.5-8.4-13.2-8.4-13.2s-1.4 1.8-1.4 3.7c0 1.8.7 3.7 0 4.2s-1-.8-3.7-2c-2.8-1.2-5-1.4-6.7.6-1.8 2 0 5.4 1.5 7 1.6 1.7 2.9 3 2.4 3.5-.4.6-2.7-.9-3.5-1.4-.8-.5-2.6-2.5-5.3-2.3-2.6.3-3.6 1-3.8 3.3-.3 2.3 2.4 4.2 4.1 5.1 1.7.9 2.4 1.6 2 2-.5.3-.9 0-1.7-.3a8 8 0 0 0-4.3 0c-1.4.6-3.6 2.5-1.5 4.8s6.4 3.2 7.2 3.3c.9.2 1.3 0 1.4.6 0 .7-1.8.7-4.1.8-2.4.1-3 2.4-2.7 4 .3 1.8 4.2 3.7 6.4 4 2.1.4 2.9 0 3 .7.2.6-.2.8-1.4 1.2-1.2.3-3.5.6-4 2.5-.4 1.9-.5 2.7 1.3 4.4 1.8 1.6 4.8 1.4 5.6 1.2.9-.2 2-1.1 2.8-.3.9.9-.8 1.6-2.3 2.6-1.4 1-1.3 3 1.2 4.4 2.5 1.4 5 .9 6 .5 1-.3 2.4-2 3.1-1 .7 1.1-2.2 1.5-3.4 3-1.2 1.4-.7 3.8 1.7 5.3s6.4.4 7-.2c.7-.6 1.6-.8 2.1-.3s-.2 1.9-.8 3c-.5 1.3-1.4 4.8 2.2 6.2s6.9-1.7 7.5-2.3c.6-.6 1.2-.7 1.7-.5.5.3.3.8-.1 1.4-.5.6-1.4 3.2 1.2 5a6.3 6.3 0 0 0 4.7 1l2-7.2h-.6c-.3 0-.4.5-.4.7 0 .2 0 .4-.2.4-.3 0-.4.2-.8.5-.5.3-.9.7-1.1.5-.3-.2 1-.8 1.2-1.2.3-.4 1-1 1-1.4 0-.4.2-.6.9-1.1l.4-.6a100.5 100.5 0 0 0 1.7-12.7zM203 187.6a37.3 37.3 0 0 0 9.3 12.1l-1-3.2c-.4-1.4-.2-2.9-.2-2.9s-1.3-1.7-3.8-5.6c-2.6-3.9-3.9-9.6-3.9-9.6s2.4 5.7 4.2 8.8c1.8 3 4 5.5 4 5.5s.6-2.7 1.2-2.8c.5-.2.9.2 1.3.8.5.6.9.6.9.6l-1.6-2.8-1.5-2.2c-1.5-2.3-4.6-6.6-6.1-10.9-1.6-4.3-5.1-15.1-5.7-18.3-.6-3.2-1.2-1.4-1.8.9a27.6 27.6 0 0 0-1 10.7 53.5 53.5 0 0 0 5.7 18.9m5 21a135.9 135.9 0 0 0 3.5 2.5l-.6-1.7-.3-2.9-2.8-2.5a41.7 41.7 0 0 1-5.6-6c-3-3.6-.6-1.4 1.8 1.2s7 6.3 7 6.3v-.8a3.1 3.1 0 0 1 .7-1.9c.4-.6.2-.6-2.4-2.6a74.5 74.5 0 0 1-17.6-24.4s-1.4 9 4 18.7c5.4 9.9 10.8 13 12.2 14.1zm28.5 56.3c3-1.2 2.1-4.1 2.1-4.1s-1.8.5-3.5 1.2c-1.7.6-5.8 1.8-7.4 1.8-1.7 0-1.7-.2-1.7-.4s1.2 0 3.6-.4a29 29 0 0 0 7.2-3.1c.7-.5.6-.6-.4-.7a4.5 4.5 0 0 1-2.4-.9c-.4-.3-1.5.1-4.2.8a50.8 50.8 0 0 1-21.5.7c-.6-.2-1.3.2.7 3.7 2.1 3.5 9.4 5.3 14.4 5.3s10.1-2.8 13-3.9zm-13.4-7.2c5.2 0 7.1-1.5 7.1-1.5l-.7-1.3c-.7-1-.6-2.9-.6-2.9l-3.4.6c-2.1.3-4.6.6-7.4.1-2.8-.5-1.6-.8.6-.5 2.2.2 6.4-.6 7.8-1 1.4-.5.8-1-.1-1.3-1-.3-3.5-1.9-3.5-1.9s-6.3.8-12.1.2c-6-.7-9.6-2.2-10.8-2.4-1.2-.2-1.2.3-1.2.3s-.3.6 1.8 3.7c2 3.2 6 5.3 9.3 6.3 3.4 1 8 1.6 13.2 1.6m-1.4-12.2-.5-1.3c-.3-1 .6-1.9.6-1.9s-1.2-.3-5.1-.8c-3.9-.5-4.1-.8-6.5-1.3-2.4-.6-4-1.3-4-1.5.1-.3.9 0 2.3.6 1.4.5 7.4 1.2 9.9 1.5 2.5.4 3.9.6 4.3.4.5-.3 2-.7 2-.7l-2.4-.5a8.4 8.4 0 0 1-3.2-1.3c-.7-.5-.9-.6-4-1-3.3-.3-5.8-1.3-11.5-3.4-5.7-2-10-4.6-11.1-5.5-1.2-1-1-.3-.8 1 .3 1.1.3 2.6 3.2 6 2.8 3.3 4.2 4.8 11.5 7.4 7.2 2.7 15.3 2.3 15.3 2.3M200.2 228a40.6 40.6 0 0 0 15.5 6.4c.4-.4-.4-2 0-2.8.4-1.1 1-1.1 2.6-1.2 1.6-.1.5-.4.2-.4l-3-.7c-2.6-.7-5.2-1.1-8.7-2.4-3.5-1.4-4.6-2.3-4.5-2.6.1-.3 1.6.8 5 2 3.2 1.3 7 1.8 9 2.3 2.1.4.3-.5-.7-1-1-.6-2.3-2.8-2.3-2.8s-2.3-.4-6-1.5a48.8 48.8 0 0 1-10-4.2c-1.1-.6-2.2-1.4-3.3-2.2l-5.1-3.7c-1.3-1-1-.2-.8.4s1 3.2 3 6.1c2 3 2.7 3.8 9.1 8.3m-1-12.7c6.3 5 11.7 6.6 12.6 7 1 .4.9-.2.7-.7-.2-.5-.3-2.2-.3-2.2l-4.8-2.8a79.6 79.6 0 0 1-7.1-4.7c-1.9-1.3-.8-1.2-.2-.7.6.5 3.1 2 5.7 3.6l6.4 3.9s.1-.9.7-1.4c.5-.5 1.8-.4 1.8-.4l-1-1.3c-.4-.6-2.5-1.3-4.9-2.4a57.5 57.5 0 0 1-9.6-6.8c-3-2.6-9-9.1-9.5-9.7-.4-.5-.6-.4-.7.3 0 .6-.2 1 .4 4 .7 3 3.5 9.4 9.8 14.3m22.3-47.2c.7 1.5 1.5 2.6 2 3.6a52 52 0 0 1 1.4 2.4s.2-.5 0-1.4c-.1-.8-.2-2 0-3.5l.3-2.3c0-.7-.4-1.4-.5-1.9l-1.5-7c-.5-2.7-1-6.4-.9-9.7 0-3.2.5-1.6.5 0a62.2 62.2 0 0 0 2.8 17.2s0-.9.5-2.1c.5-1.3 1.3-2.7 2-4.2.5-1.6.3-1.9.3-1.9s-2.2-10.6-2.8-15.6c-.6-5-1.5-18.1-1.5-18.1-3.3 3.2-5.7 11.8-6 20-.4 6 .6 11.7.9 14 .5 4.5 1.3 8 2.5 10.5m-7.2 16.8c.1-2.4.7-4.3 2.2-4.8 0 0-1.3-2.4-2.5-5.8a45.7 45.7 0 0 1-1.9-7.7c-.8-5.6-1.5-11.5.2-2 1.7 9.7 3.7 13 3.7 13l2.5 4a17.3 17.3 0 0 1-.4-4.9c.1-1.9.4-4.5 1-6.5 0 0-3-6-4.9-13a82.2 82.2 0 0 1-3.2-22.7s-3 2.3-4 13.9a69 69 0 0 0 7.3 36.5m33.3 88.6-2-1.3c-1.4-.9-1-3.7-1-3.7l-1.4 1a19.2 19.2 0 0 1-3.7 2.2c-1.5.6-2.2 1-3 1.2-1 .3-.8 0 0-.5.8-.4 1-.7 3-1.4 1.9-.8 5.7-4.2 5.7-4.2l-2.5-.1c-1.6 0-3.6-.9-3.6-.9s-1.6 1.4-8 4.2a50 50 0 0 1-11.8 3.5s.7 3.2 3.8 4.3c2.5 1.1 6 1.8 12.9.2a43.5 43.5 0 0 0 11.6-4.5m8.4 6.5c.5-2.7-1-4.6-1-4.6l-1.3 1.1c-1 .9-2.4 2.5-5 3.9-2.8 1.3-3.7 1.2-1.1-.2s6.4-5.3 6.4-5.3l-1-.4c-1-.4-2.8.3-10 4.6s-11.4 4.5-11.4 4.5 3.2 3.9 12 3.6c8.7-.3 11.8-4.5 12.4-7.2m16.5-3.1s-1 1.3-2.3 2.2c-1.3.9-4.7 1.4-4.7 1.4l-.8 1.2c-.7 1-2.2 3-3.7 4-1.6 1.2-4 2-4.1 1.6-.1-.3 1.4-.8 2.9-1.8 1.5-.9 2.8-2.6 3.8-3.7 1-1.2-.4-1-.4-1h-3.5c-1.7-.2-1.4 0-1.9.7l-2.4 3-4.4 5.1c-1 1.2-.2 1.5-.2 1.5s.4.7 4.3 1.2c2.4.2 5 0 7.8-1.6a23 23 0 0 0 5.2-4.5c4.6-5.1 4.4-9.3 4.4-9.3m2 10.5-1.4 1.8 1.2-3c.3-.6.7-1 1-1.4-.7-1.4-1.3-3-1.6-4.7-.5 1.4-1.8 5.5-3.4 8.1-2 3.2-3.8 4.4-2.7 5.3 1.2.8 3.4 1 6-.2 2.4-1.2 3.1-3.3 3.5-5a24.8 24.8 0 0 1-1.2-2.1 5 5 0 0 0-1.3 1.2z"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 274,
      cy: 158.6,
      fill: "#d4af3a",
      rx: 1.8,
      ry: 1.6
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M270.3 155.5c1.6 0 2.4-.8 4.2-.6 2.2.2 5 1.4 8.6 3.3a14.6 14.6 0 0 0 9.8.9c1-.3 2-.9 2.9-1.4 4.2-2.4 3.2-7.1 3.2-7.1a16.7 16.7 0 0 1-10.7 3.2l1 .8c.5.6 1.7 1.4 1.3 1.7-.4.3-2-1.2-3.2-2.2a19.4 19.4 0 0 0-6.5-3.2c-3.3-1-7-1-9.5.4-2.5 1.3-2.7 3-2.3 3.7.2.4.6.5 1.1.5zm46.2 34.7c-.8-.2-2.1-.4-3.8-2a71.4 71.4 0 0 1-6.3-7c-.5-.8-.3-1.5.9-2 1.1-.5 2-2 2-2s-2.6-1-4.3-2.2a44 44 0 0 1-6.2-5.7c-.6-1-.3-1 .5-1.3.8-.3 1-.8 1-.8s-1.8-1.2-3.5-2.6a71 71 0 0 1-4-3.6c-2.6 1-6.7.6-8.9.2-3.8-.7-6.6-2.3-6.6-2.3l-.6 1.8c-.5 1.2-2.3 1.8-4 .7-1.8-1.2-1.4-3.7-1.4-3.7s-1.5-1-4.4-2c-3-1.1-5.4-1.3-7.8-.2-2.4 1.1-3.6 4.4-3.6 7 0 2.4 1.4 1.3 1.6 1 .3-.3.9-2.1 3.9-2.6s5.7 1 9.2 3.8c3.4 2.8 4.1 3 5.9 4.8 1.7 1.8.3 2.7-2.6 3.7-3 1-6.8-1-6.9-.9-.6.3 1.3 3 3.8 4 2.6 1 5.8.3 8.3-.8 1.7-.6 2 0 2.6.6a15 15 0 0 1 4 9 4 4 0 0 0 2.6-3c0-.6.2-1.8 1.2-1 1 1 1.7 6 1.7 8.2s-.7 5.3-.7 5.3h.7l2.3-1.2c1.1-.7 1.2 0 1.2 1.3s.4 3.6 2 7.8c1.7 4.2 4.1 5.5 4.1 5.5s.5-.8 1-2.5.8-4.8.8-7.7c0-2.8-.8-8.8-.8-8.8s3.5 4.2 7 5.2c3.6 1 7.2.4 8.7-1.3 1.5-1.7.1-2.5-.6-2.7"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M293 201s-1 2.5-1.7 3.3l-.8 1s1 1 2.6 1.4l3 .8s-1.8-2.4-2.4-4.1l-.7-2.3zm21.4-1.3a71.6 71.6 0 0 0-.8-2.1 15 15 0 0 1-8.2-1.7s1.7 3.3 3.3 4.5l1.9 1.2s-1.7.3-3.9-2c-2.2-2-3.1-4.6-3.1-4.6s.5 5.8-.4 9.3l-1.1 4s4.6.9 9.8-.6c5.2-1.4 5.6-1.9 5.6-1.9s.6-.1-.2-1.2a28 28 0 0 1-2.9-5z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M305 187a11 11 0 0 1-1.8-2.3s-.5.5 0 1.3a15 15 0 0 0 4.3 3.7 11.1 11.1 0 0 0 3 1.2v-.4s-3.9-1.7-5.5-3.5m-6.3 12-.4-8.3c0-1-.7-.8-.7-.8l-.8.3 1.6 10.6c.1 1.2.7 1 1 1-.6-.3-.7-2.5-.7-2.8m-9.8-31.4c-.6-.6-2-1-.7.4s3 3.2 3.5 4.7c.5 1.4.8 3.3 0 2.9-.9-.4-1.5-.4-2.4-1.2a15 15 0 0 0-3.2-2.1c-.7-.2-2 0-1 1a24.8 24.8 0 0 0 4 3.6c1.8 1.3 3 2 4 2.6a36.9 36.9 0 0 0 1.9 1.3s-.9-6-2.5-8.5a26.3 26.3 0 0 0-3.6-4.7m-32 99.2a7 7 0 0 1-2.8 1.3s-.8 0-.8.2 1 0 1.8-.1a8 8 0 0 0 2.6-1.4c.5-.4 1.2-.8 1-1.4-.3-.6-.6.5-1.8 1.4m10.3 5.5-2.2 1.8-1.3.7c-.7.2-.9.6-.9.6s.2.2.9 0 2.7-1.7 3.4-2.3c.7-.6 1-.7.7-1s-.4 0-.6.2M225.3 198c.4.4.8 1 1 .9.2-.2 0-.5-.5-1l-.8-.9-1.1-1.5c-.4-.4-1-.7-.3.3zm-3.2 7 1.4 1.3c.5.5.8 1.1 1.1.8.3-.3-.7-.9-1.2-1.5a7.5 7.5 0 0 0-1.4-1.4 10 10 0 0 0-1.2-.8zm1.2 11.2c.8.9 2 1.1 2.1.8.2-.4 0-.6-.7-1a24 24 0 0 1-2.3-1.4l-1.4-1.1c-.4-.4-.8-.7-1-.6-.1.1 1.1 1.5 1.5 1.7.4.2 1 .8 1.8 1.6m2.3 9c0-.3 0-.5-.6-.5a26.9 26.9 0 0 1-1.6-.2s-1.3-.5-1.3-.2c-.1.3 1 .8 1.5.8l1.4.4c.3.2.6 0 .6-.3m1 9.8c-1.4 0-2.6-.3-2.7 0-.1.1.6.5 1.3.7.8.3 2 .3 3 .4 1 0 1-.2 1-.6 0-.5-1.2-.5-2.6-.5m11 10.8c-.2-.2-.7 0-1.5 0-.8.3-2 .5-2.8.5l-2.4-.1-.9.2c0 .2 1.2.2 3 .4 1.7.2 2.9-.2 3.7-.3.8-.2 1.1-.5 1-.7zm4.6 7.6a5.6 5.6 0 0 1-2.2.4l-2.2.3s-.8 0-.6.4c0 .3.3 0 1-.1h2.3c1.1 0 1.8-.4 2.5-.5.7-.1 1.5-.5 1.2-1-.4-.4-1.2.2-2 .5m8.9 5.8-2.4 1.8-1.2.6c-.7.4-.7.6-.6.8.2.2.6-.3 1-.5.5-.1 1.8-1 2.5-1.6.7-.6 1.6-1 1.5-1.5-.2-.4-.3-.1-.8.4m-14.8-74.8 1.7 2.3c1.6 1.9.7.1.3-.4l-3.4-4.5c-.8-.9-.9-.5-.5 0zm-3.2 9.8c.2-.2-.3-.4-1.2-1.5l-2.6-3.3s-.5-1-.7-1c-.1.1.6 1.8 1.3 2.5.7.7 1.7 2 2.2 2.7.5.6.7.9 1 .6m4.2 18.5c0-.5-1.7-.5-2.5-.6l-2.2-.5s-1.6-.3-1.7 0c0 .1.3.3 1.2.5l3.4.8c1 .1 1.8.3 1.8-.2m-4.2-10c1.1 1 1.9 1.4 2.5 1.7.6.4 1 .8 1.4.5.3-.4-.3-.7-1.3-1.1-1-.5-1.4-.9-1.4-.9l-1-.5c-.6-.3-1.4-.6-.2.3m9.9-6.5-1.4-1s-.8-.8-1-.5c-.2.3 1 1 1.5 1.6.6.5 1.6 1.9 2 1.6.6-.3-.4-1.1-1.1-1.7m-6.5 25.7-1.6.4c-.6.2-.7.4.5.4 1.1 0 1.5-.3 2.7-.5 1-.2 1.5-.3 1.3-.7-.2-.3-.8-.2-1.2 0zm1.7 9.3c0 .2.8 0 1.4-.2.6-.2 1.8-.9 2.5-1 .7-.3.7-.4.7-.8s-.8 0-1.7.2c-.9.3-2 1.2-2 1.2s-.8.4-.9.6m12 5.6c.9-.5 1-.8.7-1-.3-.3-.5-.3-1.2.2a51 51 0 0 1-2 1.5l-1 .5c-.6.2-1.2.7-1 1 .1.1 1.2 0 1.7-.6s2-1 2.8-1.6m5.7 7.5c.3-.3 1.3-.6 1.8-1 .4-.3.7-1.3.3-1.4-.3-.1-.5.4-1.3 1l-3.5 2.4-.7.3c-.8.2-.4.5.2.4.6-.1 1-.1 1.8-.7zm8.3 7.1a10 10 0 0 0 2.3-1.7c.5-.4 1.1-1 .7-1.3-.3-.3-.7.1-1.3.6l-2.1 2.2s-.3 0-1 .7c-1 .7 0 .5.2.3a3 3 0 0 1 1.2-.8"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m295.2 143.5 3.2 1.4 3.4-2.4-4-1z"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 309.2,
      cy: 142.1,
      fill: "#b96b29",
      rx: 3.2,
      ry: 3.1
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 309.2,
      cy: 141.4,
      r: 1.9,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M302.4 131.4c.9.3 2 .2 2 .2s.3-1.4-.5-2.1l-2-1.7-.5-.6-.1 2c0 .8.3 1.9 1.2 2.2z"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 304.2,
      cy: 133,
      r: 0.6,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m299.8 132.4-.8.9s.6 0 1.2.4c.5.4 1.2.7 1.8.6.7 0 1-.7.8-1-.1-.5-.4-1-1.5-1.3-1-.4-1.3 0-1.5.4m2.2 3.7c-2 .2-4.7-2-4.7-2-.2 1.8-1.3 2.7-3 3l.1.1s1.6.8 3.5 1.1a7 7 0 0 0 2.5-.2c1-.2 2.3-.5 3-1 1.2-.7.8-2.6.8-2.6s-.2 1.5-2.2 1.6m-7.9-2c-.8-.3-2-.9-2.6-1-.5 0-1.2 0-1.1.9.1 1 1.1 1.4 2 1.4 1 0 1.5-.3 2.1-.6.6-.3.5-.4-.4-.7m-6.3-3.4c-.9-.7-1.7-.9-1.7-.9s-.6 1.6-.3 2.6c.4 1 1 1.2 2 1.2.8 0 2-.5 1.7-1.2a5 5 0 0 0-1.7-1.7"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 288.6,
      cy: 135.1,
      fill: "#d4af3a",
      rx: 0.7,
      ry: 0.5
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M290.6 127.3a11 11 0 0 1 2-9.3c2.5-3.6 7-5.1 7-5.1l1.5-1.8c1.4-1.5 4.2-3.4 4.2-3.4l-5.2 1.5a2.3 2.3 0 0 1-2.2 2.4c-.5 0-1-.2-1.3-.4-1 .1-4.4 2.2-5.3 2.9l.3 1.2a2.3 2.3 0 0 1-2.2 2.3c-.4 0-.7 0-1-.2a9.6 9.6 0 0 0-.3.5 23.4 23.4 0 0 0-1.7 3.7c.6.4 1 1.1 1 2 0 1.3-.9 2.3-2 2.3a7.9 7.9 0 0 0 0 1.5c.1.7.4 1.2 1.7 1.6 1.3.3 3.1 2.6 3.1 2.6.1 0 1-1.6.4-4.3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M298.6 110.3c.5-.4.6-1 .2-1.4-.4-.3-1-.3-1.5.1s-.6 1-.2 1.4c.3.3 1 .3 1.5-.1m-8.5 5.7c.6-.5.7-1.3.3-1.7-.5-.4-1.2-.4-1.8.1s-.6 1.3-.2 1.7c.4.4 1.2.4 1.8-.1z"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 285.1,
      cy: 123.2,
      r: 1.3,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M313.3 105c-.7.2-2 .6-3.8 1.6 1.3 0 2.3.8 2.3 1.9 0 1-1.1 2.2-2.4 2.2a2.2 2.2 0 0 1-2.2-2.2l.1-.7-1.7 1.2a17.6 17.6 0 0 0-7.2 8c-2 3.8-2.8 8-2 10.4 1 2.5 4.2 3 4.3 3 0 0-.4-.3-.5-.8l.3-1.6v-2.1s.8-.1 1.2.4l1.4 1.7 1.6 1.5s.6-1 .6-2.1-.7-2.3-.9-4.3c-.1-2 1-5.5 2.8-8 2-2.6 5.5-5 6.6-5.5a2.1 2.1 0 0 0 1.3-1.7l.3-2c0-1.2-1-1.1-2-.9z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M309.2 109.5c.7 0 1.4-.7 1.4-1.3 0-.6-.6-1-1.3-1-.8 0-1.4.4-1.4 1s.6 1.3 1.3 1.3m6.2 24.4c1 .4 2.1.1 2.6-.2.6-.4.7-1.3.1-1.8a2 2 0 0 0-2.1-.2l-2 1.3s.4.5 1.4.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M318.6 135c-.4.6-.7.9-1.8 1-1 0-2.3 0-3-.8a7.7 7.7 0 0 1-1.3-1.7h-1.2s-.4 1.7-1 2.1c-.5.5-2.5.6-3.3 0-.9-.7-1.6-1.4-1.8-1.3-.1 0 0 .7.9 1.4s1.5 1.3 2.9 1.3h8s1.6 0 2-1c.5-.9.5-1.5.3-1.7-.2-.3-.4.1-.7.7"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M306.4 133.7c1.2.6 1.9.2 2.3-.3l.6-.8-1.7-.7c-.6-.4-1-.7-1.5-.6l-.6.1s-.3 1.6 1 2.2z"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 300.7,
      cy: 121.9,
      fill: "#b96b29",
      rx: 2.7,
      ry: 2.6
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M305.3 112.7c-1-.7-2.6-.4-3.5.6-.9 1.1-.7 2.6.4 3.3 1 .7 2.6.4 3.5-.6.8-1.1.7-2.6-.4-3.3"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: 300.6,
      cy: 121.5,
      fill: "#d4af3a",
      rx: 1.6,
      ry: 1.5
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M304.2 113a1.8 1.8 0 0 0-2 .8c-.3.6.1 1.2 1 1.4 1.7.3 2.5-1.8 1-2.2m-40.7 206s-4.1 2-5.4 2.3l-1.6.4s-2.8 2.5-4.9 3.8a18.3 18.3 0 0 1-7.1 2.4c-3.2.4-12 .3-16 .1-4-.1-6.4.8-8.1 2.7-1.7 2-2.1 4.7 0 6.8 2.2 2.1 4.6 1 5.4-.2.8-1.3.4-3 0-3.7-.3-.8.7-1 1.8-1.1a24.3 24.3 0 0 1 10.7 2.3c1.3.7.6.8-.3.7-1-.2-2-.5-3.5-1.1-1.6-.6-3-1-4-1s-.7.5-.5.9l1 1.6c.1.4-.3 1.9-.3 1.9l.5 1 .8-1.5c.2-.5-.1-1.5.1-2 .2-.4 1-.4 1.7.4a6.7 6.7 0 0 1 1.8 3.5c.3 2-.3 3.3-.3 3.3s.8.7 1 1.1l-.3 2.3s.6.3 1-.7c.6-1 1.2-3 1.3-3.6.2-.7.6-1.9 1.4-1 .8 1 1.4 2 1.5 2.6l.2 1s1.8-1.7 2.4-2.8a17 17 0 0 1 3.6-3.9c1.7-1.4 4.6-4.2 6-5.2 1.5-1 5.2-3 6.4-3.6 1.1-.7 1.3-.8 1.5-2.7.2-2 1.2-3.8 1.6-5.1zm-65.8-73.7c0-.4-.7-1.5-.8-2.1-.2-.6-.8-.3-.8-.3s-1.3.8-2.3 1c-1 .3-1 0-1.2-.6l-.5-3.2c-.2-1-.4-1-.8-.8l-2.4 1c-.9.3-.6.7-.3 1.2l1.6 3.1c.5.7 0 1-.4 1.3l-2.3.6c-1 .4-1 .6-.8 1 0 .3.8 1.7 1.1 2.3.4.6.7.2.7.2s1.1-1 2-1.4c.9-.4 1-.3 1.2.4l1.5 4.8c.2.7.5.6 1 .4l1.6-.4c.5-.2.7-1.3.7-1.3l-2.5-4.4c-.5-1 0-1.1.4-1.2.4 0 1.6-.2 2.6-.5 1-.2.7-.8.7-1.2zm22.3 96.5c-.1-.8 0-1.7-.6-2.3a8.1 8.1 0 0 1-1.8-3c-.3-1 .3-1.6.2-2.2-.1-.6-1-.6-1.7 0-.8.7-1.9 1.3-1.9 3.2 0 2 .7 4.2 3.4 5 2.6.8 2.6.2 2.4-.6zm2.7-.9s-.5-.3-.8.2c-.2.5-.2.7.5 1.9.7 1 1.2 1.3 2 1.8s.2-.5.1-.8c0-.3 0-.7-.2-1s-.3-.5-.3-1.3-1.3-.8-1.3-.8"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M226 350c.5-.8 1-1 2.1-1.5a15.3 15.3 0 0 1 4.2-1c.7 0 2.5-1.4 2.2-3-.3-1.4-1.4-2-2.3-2.2-1-.3-1.8-.3-2.1.2-.3.5-.9 1-2 1.4s-1.1.7-1.8 1c-.6.1-.1.5-.7 1-.5.4-1.3 0-2.1-.3-.9-.2-1-.4-1.9-.4l-3.4-.2h-.7c-.6 0-.6 0-.9.6s.1 2.1.7 2.9c.6.7 2.6 1 3.9 1.5l3 .8c1.2.1 1.3 0 1.8-.8m12.2 1.2c1-.7.4-2 .2-2.7-.3-.7-1.7-.9-2.5-.9-.7 0-1.1 0-1.5.4-.4.3-1 .8-2 1.2-1.2.3-2 .7-3.6 1.3-1.5.6-2 1.6-2.6 2-.6.4-1.9 0-1.9 0s-.9-.2-1.2 0c-.3.3 0 .8.6 1.5.6.6 1.8.6 3 1 1.4.4 1.6 0 2.1-.3s1-1 1.8-1.6c1-.6 3-.7 3.9-.8 1-.1 2.6-.4 3.7-1.1m0-4.6c.4.4 1 1 1.3.3.4-.6 1-2 .6-2.8-.4-.8-1-1.5-1-1.5l-1 3c-.4.5-.4.6 0 1zm-4-7c0-1.2-1-2.8-1-2.8s-.3 1.2-.9 2.2c-.5 1-1 1.6-1 1.6l1.7.4c.5 0 1.1 0 1.1-1.3zm-7.6 2.8c1.4-.2 2.1-.8 2.7-1.3.6-.5 1-1.9.6-2.6-.4-.7-1.4-1.4-1.8-1.4h-.8s-.4 1.3-1 2c-.5.6-1.1 1-1 1.9 0 .8-.1 1.7 1.3 1.4m2.8-6.3a2.4 2.4 0 0 0-.6-1.9l-.8-.7-.2 1.6-.1.6.7.6c.4.1 1 .4 1-.2m-17.3-35.7 1-6a39 39 0 0 0-6.3-15.4c-2.4-3.8-5-10-6-13.2a37.4 37.4 0 0 1-2-10c0-2.3 1-3.5 1-3.5s.5-.6.1-1-1 0-1.7.6a7.5 7.5 0 0 0-1.5 2.6l-.3 1.1s-1.2-.3-3.3-.1c-2 .2-3 .3-3 .8 0 .4.3.7 1.7 1.4 1.5.6 2.4.9 3.1 1.7.8.9 2.6 5.2 3.2 7.3.6 2.1 1.8 7.8 2.3 12.2a49 49 0 0 0 4 14.4c.8 1.5 4.5 8.5 7.7 7zm3.7 10.4c-1.4.8-1.3 6.4-.7 9.3.6 2.9 3.4 6.5 4.3 7.5.9 1 1 1 1.5.7l.7-.2s1.2-.5 2.1-1.2c1-.7.6-2.5.4-4-.1-1.6-1.4-4.8-3.6-8.5-2.2-3.6-3.3-4.4-4.7-3.6m1.5-4.5c0-1.9-1.6-3.2-3.4-3.2-.9 0-1.6.2-2.1.6-1.9 1.7-.7 5.8 2 5.8.9 0 2-.1 2.7-.8.7-.6.8-1.6.8-2.4m26.5 52.7a7 7 0 0 1-2.2-1.2 10 10 0 0 1-3.1-3c-.3-.7-.3-.7-1.4-.4-1 .4-2.5.3-3.6.4-1 0 .2 1.3 1 2.4.7 1.2.4 5.1.4 5.1l-.1.9c-.2.6 0 1 .2 1 .3.2.5 0 1.3-1 .8-.9 2.2-3.2 2.2-3.2l1.4.3c1.2.3 3.1.1 4.1-.2 1-.3.6-1-.2-1.1"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M239.2 362c-.5 0-.7-.1-1 .2l-.6 1.4c-.1.3 0 .6.2.9l.8.5s.4.5.8.7c.5.2.5-.4.5-.9l.3-1.9c0-.6-.4-.8-1-.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#1d5e91",
      d: "M435 324.2c-1.3-.3-1.9-.8-1.9-.8s-.5 0-1 .7c-.3.8-2 1.8-2 1.8s-2.2.6-2.5 2.2c-.3 1.5.8 2 1.8 1.9 1.1-.2 3.7-.7 4.9-2.1 1.1-1.4 1.3-2.2 1.5-2.7.2-.5.4-.7-.9-1zm3.5-12.4a15 15 0 0 0-7.4-9.9l-2.1 7.5c-.5 1.8-.5 1.7.9 2l6.7 1.6c.9.3 2.4 1 1.9-1.2m-20.6-3.2c1 .1 1-.3 1.3-1.7l2.1-8.2s-4.5-.1-8.5 1.8c-3.9 1.9-5.6 5.4-5.6 5.4s1 .4 3.7 1 6 1.5 7 1.6zm-10.5 9.3-2.2-.4s1 3.8 2.7 6c1.7 2.2 3.5 3.2 7 3.3 3.5 0 6-1.9 6.5-3.4.4-1.5 1.1-2.6 1.1-2.6s-6.2-.8-8.8-1.4z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m406.3 315.5 15.5 3c1 .3 2 .5 2.2.2.3-.3.5-.5 1.6-.9 1.2-.4 1.1-1.5 1.1-1.5l.4-2.2c.2-1 .8-1.4 2-.1 1.3 1.3 1.5 3.2 1.7 5 .3 2 3.2 2.4 4.4 2.6 1.1.2 1.6-.2 2.3-1.3.7-1 1-3.2 1.2-4.6.2-1.4 0-1.2-1.4-1.6l-9.3-2.2c-1.2-.2-1-1-.7-1.9.1-.8 2.8-9.2 2.8-9.2a18.9 18.9 0 0 0-7.7-2.3l-2.3 10c-.3 1.3-1.2 1.3-2.5 1-1.4-.2-11.3-2.5-11.3-2.5l-.8 1.8a15.5 15.5 0 0 0-1.1 5.2c0 1.2.4 1.2 1.9 1.5"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M440.3 323.3c-1.3-.9-2.3-1.1-3 .5-.7 1.6-.7 4-2.4 5.6-1.8 1.7-4.2 3.4-6.6 3.2-2.4-.2-3.7-.7-3.2-3.5.6-2.7 4.3-3.6 5.1-5 .9-1.5.7-3.1-.6-4.2-1.3-1.1-3.1-1.3-3.6-1a8 8 0 0 0-2.8 3.7c-.7 2-1.2 3.7-2.8 5a12.2 12.2 0 0 1-9 2c-3.1-.8-4.3-1.8-5.5-5-1.2-3.1-2.6-8.3-3.2-9-.7-.5-1.5-1-2.8 0-1.4 1-1.5 2.4-1.7 3.6-.2 1.1 0 2.5 1.4 4.1 1.4 1.7 2.8 3.3 3.3 5 .5 1.8 2 4.4-.1 4.5-2.2.2-3.2.2-4.8-1.4-1.7-1.6-8.2-6-10-7.4a29 29 0 0 0-2.5-2c-3 0-6-1.2-9-3.3 0 0 1.8 4.4 2.1 6.1.4 1.7.3 2.6.3 2.6l9.1 4.6a168 168 0 0 1 10.3 5.8c2.5 1.5 4.7 4 9.1 3 4.5-.9 13.5-3.6 16.5-4.5 2.9-.9 11-2.9 14-5 3-2 3.2-1.9 3.7-4 .5-2 0-3.1-1.3-4m-17.2-31 2.2-.3c1.5-.1 1 1.3.7 1.9l-1.4 2.7c-.6 1 .2 1.2.6 1.4l2.3.6c1.3.3 1-.6 1-1l.3-3.8c.1-.9 1-.6 1.2-.5l1.7 1c.6.3 1 0 1-.4l.8-2c.2-1-.4-.8-1-.8h-2.4c-1 0-.4-1-.4-1l1.3-2.1c.6-.9.4-1-.2-1.2l-2.8-.7c-.5-.1-.7 0-.7.3l-.1 2.7c0 .7 0 1-1 1-.8.1-1.3-.4-2-1.1-.7-.8-1-.5-1-.2l-.8 3c-.2.7.1.6.6.6zm4.8 21.8s-.1 1.7-.3 2.3c-.2.7-.6 1.6.1 1.8.8.2 1.4.5 1.8.4.5-.1.3-1 0-1.7a6.4 6.4 0 0 0-1.1-2.2zm10.5 7c.2.5.7.6 1 .7.4.1 1 .1 1-.5s0-1.5-.5-2.2c-.5-.8-.8-1.3-1.1-.2-.4 1-.6 1.6-.4 2.2m-36.7-7 1.4.4s0-1.7.3-2.8c.2-1.2.7-2 .3-2-.4 0-.7.4-1 .9-.3.5-1.1.6-1.4 2-.3 1.3.1 1.4.4 1.4z"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 408.9,
      cy: 311.2,
      r: 2.3,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 415.5,
      cy: 312.8,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 434.6,
      cy: 316.9,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 422.1,
      cy: 314.4,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 423.8,
      cy: 308.6,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 425.5,
      cy: 302.9,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 409.1,
      cy: 310.9,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 415.6,
      cy: 312.6,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 434.8,
      cy: 316.6,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 422.2,
      cy: 314.1,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 424,
      cy: 308.4,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: 425.7,
      cy: 302.6,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m349.5 359.1-5.2-3.6a11.8 11.8 0 0 1-3.9-4h1c.6 0 1-.7 1-1.5.1-.8 0-2.3-.2-4.1-.2-1.8.3-3.3.3-3.3s1.3 1.1 3.1 2c1.9 1 2.6.6 2.6.6l.5-1.9 2 3.7c1 2 4.1 4.2 6.3 5.8 2.2 1.7 4.6 3.4 6.4 4 1.8.7.8 1.5.8 1.5s-1.8 1.8-6.5 2.7c-4.7.8-7-1-8.2-1.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M333.2 357.3c1.7-.2 2.7-.8 3-2.6.2-1.2-.1-5.7-.1-5.7l1.2 1.2c.6.8 2 1 2 1s.2.6.9 1.6a9.3 9.3 0 0 0 3 3.2c1.6 1 3.5 2.2 4.7 3.2a28.1 28.1 0 0 0 4.2 3.1 7 7 0 0 1 3.6 4.7c.6 2.4.1 3.1-1.7 3-1.9-.1-2 0-5-.7-3-.8-7.3-4.1-10.4-6-3.1-2-5.4-6-5.4-6"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M325 360s1.2-1.6 1.6-3.4l1.4-5.4 1.4 3.3a4.9 4.9 0 0 0 2.8 2.7s0 .9 1.5 2.7a21 21 0 0 0 5.6 4.8c2.2 1.2 5 3 6.5 5.1 1.5 2.2 1.6 4.4 1 5.4-.8 1-1.8-.1-3.2-.9-1.5-.7-5.6-1.3-11.2-4.4-5.6-3-7.5-9.9-7.5-9.9z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M322.5 372.7c-1.6-2.4-1.8-8-1.8-8l1.3-1c.7-.7 2.2-2.9 2.2-2.9l2 3.8c1 1.8 1.4 2.4 3.6 4.3 2 2 5 3.9 6.1 6 1.3 2 .6 6.1-.2 7.5-.8 1.5-2 1-3.1-.1L329 379c-2.1-1.7-5-4-6.5-6.3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M341 325.3c-.8-1.7-1.8-3.7-2.5-4.8a15 15 0 0 1-1.3-2.2s2 1.8 2.8 3.1c.8 1.4 1.3 2.6 1.6 4 .4 1.4.2 1.6-.6 0zm-8 1.5-.5-1.9s-.3-1-.2-1.1c.2-.1 1 .6 1.6 2.5.6 1.8 1.5 4.5 1.3 4.6-.2 0-1.9-3-2.2-4.1m-6.3 5-.4-.8s-.6-2-.6-2.5c0-.4.2-1 .7.1s.6 2.2.7 2.6c.1.5.7 2.1.5 2.3-.1.1-.5-.9-1-1.7zm19.5 19.2.9-.5 1.2 1.5c.7.7 1.5 1 2 1.7a8 8 0 0 0 2.8 2.3c1.3.7 1.8 1 1.5 1.1-.2.2-1.1-.3-1.1-.3s-.4 0-2-1c-1.5-.9-1.9-1.4-2.9-2.3zm-6.8 8.1c-.6-.6-1.2-1-.9-1.4.4-.3.8-.3 1.3.2l2.9 2.6 2 1.5c.7.6 2.3 1.4 3 1.8.8.5 0 .5 0 .5l-1.2-.5-2.4-1-1.7-1c-1-.7-2.4-2-3-2.7m-7.8 5.5c-.5-1 0-.8.8-.4.9.3 2.8 2.4 3.9 3.1 1 .8 2 1.1 3 1.6.8.4.8.7.8.9 0 .2-.4.2-.8 0l-1.7-.9-1-.2c-.5 0-1.3-.6-2.4-1.6-1.1-1-2.1-1.5-2.6-2.5m-3.7 7.2c1.4.8 3.8 2.7 4.4 4 .6 1.2 1 2.1.9 2.3-.3.2-1-.2-1.2-.7l-1-1.2s-2.4-2.4-3.2-3a8.3 8.3 0 0 1-2.7-3c-.3-1 0-1.4 0-1.4s1.4 2.1 2.8 3"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#c52126",
      d: "M365 170a22.3 22.3 0 0 1 8.3-2.6c3.6-.3 6.4.2 9.5 1 2.1.6 3.9.7 5.6.3 2.6-.7 4.6-3 5.3-6 0 0 2.4 3.1 0 6.5a7.2 7.2 0 0 1-4.3 2.9c-5.1 1-10.1-2-14.3-2.4-4.1-.2-7.3 2.4-7.3 2.4s-1 .8-2.4 0c-1.3-.8-1.7-1.4-.4-2.2z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m379.6 317.5 1.2-.2c.7 0 2.2-.6 2.7-.8.5-.2 1.2-.2 1.6.3.5.5 4.1 2.7 4.1 2.7h-6c-2.1 0-3.5-2-3.5-2z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M362.6 316.4v-.5l.8-1.8s1 .6 1.8 1.5c1.2 1.3 2.5 3 3 3.7 1 1.3 2.5 2.5 1.3.5s-1.6-3-2.6-4.4l-1.6-2 3.4-.5c2.5-.3 4.2-1.3 5.3-2l3.3-1.9s4.3 1.9 6 2.3c1.6.4 2.5.6 1 1.4-1.6.8-3 1-3.7 1.5a12 12 0 0 1-4.6 1.2c-1.5 0-4 0-3 1a22 22 0 0 1 4.2 13l-.1 2.5s-1.8-2-6.6-5a71 71 0 0 0-7.4-4.4c-.9-.4-1.3-.4-1.2-1.5z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M344.4 302a68.5 68.5 0 0 0 .8-.4h.3c.5.3 3.4 2.3 4.6 4.2 1.2 1.9 2.4 2 1 0a17.9 17.9 0 0 0-3.2-4.2 23.4 23.4 0 0 0-1-.8 53.3 53.3 0 0 0 7.3-4.2c.4.6 1 1.7 1.7 2.5 1 1 3.2 2 3.2 2s-1.8-2-2.4-3.3l-.8-2.5a31.7 31.7 0 0 0 4.8-4.6c.3 1.3 1.3 4.2 4.2 7.4 3.7 4.2 11.2 6.3 11.2 6.3s2.6.3.5.9c-2.1.5-3.6 1.5-7.8.8l-5-1.1c-.5-.2-2 0 0 .7 2.1.8 7 1.5 8.8 1.4 1.8-.2 4.4-.6 1.7.8-2.6 1.4-3.7 2-5.3 2s-2.3.5-4 .5c-1.5 0-2-.3-3-.5-1.2-.3-1.9.1-1.9.6 0 .4 1.5 1.7 1.5 4.7 0 3.1-.3 5.1-.6 6-.3 1-1 2.4-1.4 3.2-.4.8-.6 1.7-1-.1-.5-1.8-1.5-4.4-1.9-6.1l-.8-2.7c-.1-.9-1.1-1.6-.6 0a133.4 133.4 0 0 1 1.2 5.2c.4 1.5 1.1 4.2-.2 2-1.3-2-6.4-7.7-7.2-8.8l-2.1-2.8c-.7-.8-2.4-1.9-3.2-3.1a28.5 28.5 0 0 0-4-4zm69.5-129.2c-.1 3.1-3.5 9-5.5 12.2-2 3.1-2.5 4.4-2.1 4.6.3.2 1.1-1.4 2.2-2.8l4.9-7.2c1.7-2.5 4.2-8.4 4.6-8.9.3-.5.4-.9 1.3-.2s2.6 7.2.5 11.6c-2 4.4-5 7.6-6.2 9.2-1.3 1.5-3 4-2.7 4.1.3.2.7-.4 2.3-2a47.3 47.3 0 0 0 9.6-12.5c.2-.4.5-.3.8 0 .5.5 1.4 1.8 1 5.3a17 17 0 0 1-5.3 10.2c-2.3 2.4-4.6 4.5-4.3 4.9.4.3 2.7-1.8 4.3-3.3 1.6-1.6 5.6-5.4 6.4-6.5 1-1 2.2-.5 2.1 3.7 0 4.3-4.7 8.5-6.7 10.9-2 2.3-4.3 3.7-4.1 4.2.2.5 2.1-.7 3.4-1.6l7-4.6c.9-.7 1.3.6.1 4.6-1.2 4-4.6 7.2-6.7 8.7-2 1.5-5.4 3.3-5.2 3.8.2.4 1.6-.2 3.5-1.1 2-1 4.3-1.8 6-2.3 1.6-.5 1.6.7 1.6.7s.4 3.5-2.1 6.2a13.3 13.3 0 0 1-8 4.3c-2.6.5-3 .6-3 1s.4.5 1 .5l5.3.2c2.3 0 3.5.6 3.5 1.6s0 2.3-3.3 4.6c-3.5 2.3-7.3 2.6-8.9 3-1.6.3-1.6.4-1.3.9.3.5 1 .4 3.6.7 2.5.2 4 1.2 4.4 2 .3.6-.2 2.6-2.3 4-2 1.4-4.7 1.9-8.7 1.6-4-.3-5-.3-5.2.3-.1.7 1.2 1 3.2 1.2 2 .4 3.6.4 4.7 1.3 1.2 1 .3 2.9-1.7 4.3-1.9 1.4-6.7 1.4-8.7 1.3-2-.2-5.1-.9-5.3-.4-.2.6 1.5 1.4 3.5 2.1 2.1.8 2.7 1.2 3.1 2.1.4.9 0 1.7-2.4 2.6a12 12 0 0 1-8 0c-1.8-.8-2.8-1.1-3.2-.8-.3.3 0 .7.4 1.1.4.5 2 1.8 4.1 2.3 2 .6 2.3.6 3 2.2.8 1.7-1.1 3-4.9 3.2-3.7.1-8.7-1.4-10.3-2.3-1.6-1-2.2-1.1-2.5-.8-.3.3-.2.5.6 1.1.8.6 3.3 2.5 4.6 2.8 1.3.3 1.4 1.3 1.4 2.1 0 1 .4 2.6-3 3.5-3.3.8-7.3.2-10.9-2.4a8.3 8.3 0 0 1-2.2-2 28 28 0 0 0-.3-8c.7 0 2-.3 3.4-.9 2-.8 2.8-2.6 3.3-3.6s1.2-1 2-.8c.8.3 1.6.6 2.7.6a7.9 7.9 0 0 0 5.3-2.8c1.7-2 1.4-4 1.5-5 0-1 1.6-.3 2.4-.3.8 0 3.2-.4 5.3-1.9 2.2-1.4 2.2-3.4 2.4-4.3.2-.8 1-1.3 1.7-1.6.7-.2 1.7-.5 3.2-1.7 1.5-1.2 2-3.5 2-4.4.2-.8 1-.8 4-2.4 3-1.5 2.8-4.7 2.6-6 0-1.3-1.5-2.3-1.5-2.8s1-.6 2-1.2 3.6-1.6 3.6-5.4c0-3.7-2.4-4.1-2.4-4.1l1.5-.8c1-.6 3.7-2.5 3.7-4.7s-1-3.2-1.7-3.8c-.7-.5-2.7-1-2.7-1s1.2-.9 1.8-2.6c.5-1.7.7-3.9-.6-5.4-1.2-1.6-3.4-1.6-4.5-1.6-1.2 0-2.2.6-2.6.3-.4-.3-.4-.6 0-1.5.4-.8.4-3 .1-3.7-.3-.8-.4-2.2-3.3-3.2-2.9-.9-5.9 1-6.8 1.6-1 .5-.5-.8-.5-1.7 0-1 1.9-3.3 4.1-6.6 2.2-3.4 3.2-5.1 5.7-10.2A65.7 65.7 0 0 0 409 159c.4-1.6 1-.8 1-.8s.7.2 2.2 4.1a25 25 0 0 1 1.7 10.5"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M363.4 241.4c1.7-.1 4-1 5.7-3.6 1.7-2.5 4.3-3 8.8-3 4.5.1 6.6-2 7.7-5.2 1-3-.2-6.6-4.8-8.9-4.5-2.2-6.6-4.7-6.8-8.6-.1-3.9 4.6-8.7 9.3-14.1 4.8-5.5 8.5-13.2 8.5-13.2s1.4 1.8 1.4 3.7c0 1.8-.7 3.7 0 4.2s.9-.8 3.7-2c2.7-1.2 5-1.4 6.7.6 1.7 2 0 5.4-1.6 7-1.5 1.7-2.8 3-2.4 3.5.4.6 2.8-.9 3.5-1.4.8-.5 2.6-2.5 5.3-2.3 2.7.3 3.6 1 3.9 3.3.2 2.3-2.4 4.2-4.2 5.1-1.7.9-2.4 1.6-2 2 .5.3 1 0 1.7-.3a8 8 0 0 1 4.3 0c1.4.6 3.6 2.5 1.6 4.8-2.1 2.3-6.4 3.2-7.3 3.3-.8.2-1.3 0-1.4.6 0 .7 1.8.7 4.2.8 2.3.1 3 2.4 2.7 4-.4 1.8-4.3 3.7-6.4 4-2.2.4-3 0-3.1.7-.2.6.2.8 1.4 1.2 1.2.3 3.6.6 4 2.5.4 1.9.5 2.7-1.3 4.4-1.8 1.6-4.7 1.4-5.6 1.2-.9-.2-1.9-1.1-2.8-.3-.8.9.8 1.6 2.3 2.6 1.5 1 1.4 3-1.1 4.4-2.5 1.4-5 .9-6 .5-1-.3-2.5-2-3.2-1-.7 1.1 2.2 1.5 3.4 3 1.2 1.4.8 3.8-1.6 5.3-2.5 1.5-6.4.4-7.1-.2-.7-.6-1.6-.8-2-.3-.6.5.2 1.9.7 3 .5 1.3 1.5 4.8-2.2 6.2s-6.9-1.7-7.5-2.3c-.6-.6-1.2-.7-1.7-.5-.5.3-.2.8.2 1.4.4.6 1.4 3.2-1.2 5a6.3 6.3 0 0 1-4.7 1c-.6-2-1.3-4.2-2-7.2h.5c.4 0 .5.5.5.7 0 .2-.1.4.2.4.3 0 .3.2.8.5.4.3.8.7 1 .5.3-.2-.9-.8-1.2-1.2-.3-.4-1-1-1-1.4 0-.4-.2-.6-.8-1.1a2.4 2.4 0 0 1-.5-.6 97.9 97.9 0 0 1-1.2-7.2 57.1 57.1 0 0 1-.4-5.5zm73.7-53.8c-3.9 7.8-9.3 12.1-9.3 12.1l1-3.2c.3-1.4.1-2.9.1-2.9s1.4-1.7 3.9-5.6c2.5-3.9 3.8-9.6 3.8-9.6s-2.3 5.7-4.1 8.8c-1.9 3-4 5.5-4 5.5s-.7-2.7-1.2-2.8c-.5-.2-1 .2-1.4.8-.4.6-.8.6-.8.6l1.5-2.8 1.6-2.2c1.4-2.3 4.5-6.6 6-10.9a169 169 0 0 0 5.7-18.3c.7-3.2 1.3-1.4 1.9.9.6 2.3 1.4 5.7.9 10.7a53.5 53.5 0 0 1-5.6 18.9m-5 21a135.9 135.9 0 0 1-3.5 2.5l.5-1.7.3-2.9 2.9-2.5a41.7 41.7 0 0 0 5.6-6c2.9-3.6.5-1.4-1.9 1.2-2.3 2.6-6.9 6.3-6.9 6.3v-.8a3.1 3.1 0 0 0-.7-1.9c-.4-.6-.2-.6 2.3-2.6a73.8 73.8 0 0 0 17.6-24.4s1.5 9-4 18.7c-5.4 9.9-10.8 13-12.2 14.1m-28.5 56.3c-3-1.2-2.2-4.1-2.2-4.1s1.8.5 3.5 1.2a36 36 0 0 0 7.5 1.8c1.6 0 1.6-.2 1.7-.4 0-.2-1.3 0-3.7-.4a29 29 0 0 1-7.2-3.1c-.7-.5-.6-.6.5-.7a4.5 4.5 0 0 0 2.3-.9c.4-.3 1.5.1 4.2.8a50.6 50.6 0 0 0 21.5.7c.7-.2 1.4.2-.7 3.7-2 3.5-9.3 5.3-14.4 5.3-5 0-10-2.8-13-3.9m13.4-7.2c-5.2 0-7.2-1.5-7.2-1.5l.7-1.3c.7-1.1.6-2.9.6-2.9l3.4.6c2.2.3 4.7.6 7.5.1s1.6-.8-.6-.5a29 29 0 0 1-7.8-1c-1.4-.5-.9-1 0-1.3 1-.3 3.5-1.9 3.5-1.9s6.3.8 12.2.2c5.9-.7 9.6-2.2 10.8-2.4 1.1-.2 1.1.3 1.1.3s.3.6-1.7 3.7c-2 3.2-6 5.3-9.4 6.3a50.3 50.3 0 0 1-13.1 1.6m1.3-12.2.6-1.3c.3-1-.6-1.9-.6-1.9s1.2-.3 5-.8c4-.5 4.2-.8 6.5-1.3 2.4-.6 4-1.3 4-1.5 0-.3-.8 0-2.2.6a94 94 0 0 1-14.3 1.9c-.4-.3-2-.7-2-.7l2.4-.5a8.4 8.4 0 0 0 3.2-1.3c.7-.5 1-.6 4.1-1 3.2-.3 5.8-1.3 11.5-3.4 5.6-2 10-4.6 11-5.5 1.2-1 1.1-.3.8 1-.3 1.1-.2 2.6-3.1 6-2.9 3.3-4.3 4.8-11.5 7.4-7.3 2.7-15.4 2.3-15.4 2.3m21.4-17.6a40.5 40.5 0 0 1-15.5 6.4c-.3-.4.4-2 0-2.8-.3-1.1-1-1.1-2.6-1.2-1.5-.1-.5-.4-.1-.4l3-.7c2.5-.7 5.1-1.1 8.6-2.4 3.6-1.4 4.6-2.3 4.5-2.6 0-.3-1.6.8-4.9 2-3.2 1.3-7 1.8-9 2.3-2.2.4-.4-.5.6-1 1-.6 2.4-2.8 2.4-2.8s2.3-.4 6-1.5a48.8 48.8 0 0 0 10-4.2l3.2-2.2 5.2-3.7c1.3-1 .9-.2.7.4s-1 3.2-3 6.1c-2 3-2.7 3.8-9 8.3zm1-12.7c-6.2 5-11.7 6.6-12.6 7-1 .4-.8-.2-.7-.7.2-.5.3-2.2.3-2.2l4.8-2.8c2.5-1.4 5.3-3.4 7.2-4.7 1.8-1.3.7-1.2.1-.7-.5.5-3.1 2-5.7 3.6l-6.4 3.9s0-.9-.6-1.4c-.5-.5-1.9-.4-1.9-.4l1-1.3c.5-.6 2.6-1.3 4.9-2.4 2.3-1 6.5-4.2 9.6-6.8 3.1-2.6 9.1-9.1 9.5-9.7.4-.5.7-.4.7.3 0 .6.3 1-.4 4s-3.4 9.4-9.7 14.3zM418.5 168c-.7 1.5-1.5 2.6-2 3.6L415 174v-1.4c.1-.8.3-2 0-3.5 0-.8-.3-1.6-.2-2.3 0-.7.3-1.4.4-1.9l1.6-7c.4-2.7.9-6.4.8-9.7 0-3.2-.5-1.6-.5 0s-.1 4-.6 7.8c-.5 3.7-2.1 9.4-2.1 9.4s-.1-.9-.6-2.1l-1.9-4.2c-.6-1.6-.4-1.9-.4-1.9s2.3-10.6 2.8-15.6c.6-5 1.6-18.1 1.6-18.1 3.2 3.2 5.6 11.8 6 20 .4 6-.6 11.7-1 14-.5 4.5-1.3 8-2.5 10.5zm7.2 16.8c0-2.4-.6-4.3-2.2-4.8 0 0 1.4-2.4 2.6-5.8a45 45 0 0 0 1.8-7.7c.9-5.6 1.6-11.5-.1-2-1.7 9.7-3.8 13-3.8 13l-2.4 4c.3-1.7.4-3 .3-4.9 0-1.9-.3-4.5-1-6.5 0 0 3-6 5-13a81.4 81.4 0 0 0 3.1-22.7s3 2.3 4 13.9a68.4 68.4 0 0 1-7.3 36.5m-33.2 88.6 1.9-1.3c1.5-.9 1-3.7 1-3.7a48.7 48.7 0 0 0 5.2 3.2c1.4.6 2.1 1 3 1.2 1 .3.7 0 0-.5-.8-.4-1-.7-3-1.4-2-.8-5.8-4.2-5.8-4.2l2.5-.1c1.6 0 3.6-.9 3.6-.9s1.6 1.4 8 4.2a50 50 0 0 0 11.8 3.5s-.6 3.2-3.7 4.3c-2.6 1.1-6 1.8-13 .2a43.5 43.5 0 0 1-11.5-4.5m-8.4 6.5c-.6-2.7 1-4.6 1-4.6l1.3 1.1c1 .9 2.3 2.5 5 3.9 2.7 1.3 3.7 1.2 1-.2a39.3 39.3 0 0 1-6.3-5.3l1-.4c1-.4 2.7.3 10 4.6 7.1 4.3 11.4 4.5 11.4 4.5s-3.2 3.9-12 3.6c-8.7-.3-11.9-4.5-12.4-7.2m-16.6-3.1s1 1.3 2.3 2.2c1.3.9 4.8 1.4 4.8 1.4l.8 1.2c.6 1 2.1 3 3.7 4 1.5 1.2 4 2 4 1.6.2-.3-1.3-.8-2.8-1.8-1.5-.9-2.9-2.6-3.9-3.7-1-1.2.5-1 .5-1h3.5c1.7-.2 1.3 0 1.8.7l2.4 3 4.4 5.1c1 1.2.3 1.5.3 1.5s-.5.7-4.4 1.2c-2.4.2-5 0-7.7-1.6a23.4 23.4 0 0 1-5.2-4.5c-4.7-5.1-4.5-9.3-4.5-9.3m-2 10.5 1.5 1.8s-.7-2-1.3-3l-.9-1.4c.7-1.4 1.2-3 1.6-4.7.4 1.4 1.7 5.5 3.4 8.1 2 3.2 3.8 4.4 2.6 5.3-1.1.8-3.4 1-6-.2-2.4-1.2-3-3.3-3.4-5a24.8 24.8 0 0 0 1.2-2.1c.3.2.8.5 1.3 1.2"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: -365.9,
      cy: 158.6,
      fill: "#d4af3a",
      rx: 1.8,
      ry: 1.6,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M369.7 155.5c-1.6 0-2.5-.8-4.3-.6a26 26 0 0 0-8.5 3.3 14.6 14.6 0 0 1-9.8.9c-1-.3-2-.9-2.9-1.4-4.3-2.4-3.2-7.1-3.2-7.1a16.7 16.7 0 0 0 10.6 3.2l-.9.8c-.6.6-1.7 1.4-1.4 1.7.4.3 2-1.2 3.3-2.2 1.3-1 3.2-2.2 6.5-3.2s7-1 9.4.4c2.5 1.3 2.7 3 2.4 3.7-.2.4-.7.5-1.2.5m-46.2 34.7c.8-.2 2-.4 3.8-2a69 69 0 0 0 6.3-7c.5-.8.3-1.5-1-2-1-.5-1.9-2-1.9-2s2.5-1 4.3-2.2c1.7-1.2 5.6-4.8 6.2-5.7.5-1 .3-1-.5-1.3-.9-.3-1-.8-1-.8s1.8-1.2 3.5-2.6a71 71 0 0 0 4-3.6c2.6 1 6.6.6 8.8.2 3.8-.7 6.7-2.3 6.7-2.3l.6 1.8c.5 1.2 2.2 1.8 4 .7 1.8-1.2 1.4-3.7 1.4-3.7s1.4-1 4.4-2c3-1.1 5.3-1.3 7.7-.2 2.4 1.1 3.6 4.4 3.6 7 0 2.4-1.3 1.3-1.6 1-.3-.3-.8-2.1-3.8-2.6s-5.8 1-9.2 3.8c-3.4 2.8-4.2 3-6 4.8-1.6 1.8-.3 2.7 2.7 3.7s6.7-1 6.9-.9c.5.3-1.3 3-3.9 4-2.5 1-5.8.3-8.3-.8-1.7-.6-2 0-2.5.6a15 15 0 0 0-4 9 4 4 0 0 1-2.6-3c-.1-.6-.3-1.8-1.2-1-1 1-1.8 6-1.8 8.2s.7 5.3.7 5.3h-.7l-2.3-1.2c-1-.7-1.2 0-1.2 1.3s-.4 3.6-2 7.8c-1.7 4.2-4 5.5-4 5.5s-.5-.8-1-2.5a33 33 0 0 1-.8-7.7c0-2.8.7-8.8.7-8.8s-3.4 4.2-7 5.2-7.1.4-8.6-1.3c-1.5-1.7-.2-2.5.6-2.7"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M347 201s1 2.5 1.6 3.3c.6.9.9 1 .9 1s-1.1 1-2.7 1.4a35.5 35.5 0 0 1-3 .8s1.8-2.4 2.4-4.1l.7-2.3zm-21.5-1.3a71.6 71.6 0 0 1 .9-2.1 15 15 0 0 0 8.1-1.7s-1.6 3.3-3.3 4.5l-1.8 1.2s1.6.3 3.8-2c2.2-2 3.2-4.6 3.2-4.6s-.5 5.8.4 9.3l1 4s-4.6.9-9.8-.6c-5.2-1.4-5.6-1.9-5.6-1.9s-.6-.1.2-1.2a28 28 0 0 0 3-5z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "m335 187 1.7-2.3s.6.5 0 1.3a16 16 0 0 1-4.2 3.7c-1.6.9-3.1 1.2-3.1 1.2v-.4s4-1.7 5.5-3.5zm6.3 12 .4-8.3c0-1 .6-.8.6-.8l.8.3-1.5 10.6c-.2 1.2-.7 1-1 1 .5-.3.6-2.5.7-2.8m9.8-31.4c.6-.6 1.9-1 .6.4-1.3 1.4-3 3.2-3.4 4.7-.5 1.4-.8 3.3 0 2.9.8-.4 1.4-.4 2.3-1.2 1-.7 2.6-2 3.3-2.1.7-.2 2 0 1 1a24.8 24.8 0 0 1-4 3.6l-4 2.6a36.9 36.9 0 0 1-2 1.3s1-6 2.6-8.5a26.3 26.3 0 0 1 3.6-4.7m32 99.2c1.2 1 2.8 1.3 2.8 1.3s.7 0 .7.2-.9 0-1.8-.1a8 8 0 0 1-2.6-1.4c-.4-.4-1.1-.8-.9-1.4.2-.6.6.5 1.8 1.4m-10.4 5.5 2.3 1.8 1.3.7c.6.2.8.6.8.6s-.1.2-.8 0c-.7-.2-2.8-1.7-3.5-2.3-.6-.6-1-.7-.7-1 .3-.2.4 0 .6.2m42-74.4c-.4.4-.9 1-1 .9-.3-.2 0-.5.4-1l.8-.9 1.1-1.5c.4-.4 1-.7.3.3zm3.1 7-1.3 1.3c-.5.5-.9 1.1-1.2.8-.3-.3.7-.9 1.2-1.5a7.5 7.5 0 0 1 1.4-1.4 10 10 0 0 1 1.3-.8zm-1.2 11.2c-.8.9-2 1.1-2 .8-.2-.4 0-.6.7-1a24.4 24.4 0 0 0 4.6-3c.2 0-1 1.4-1.4 1.6-.4.2-1 .8-1.9 1.6m-2.2 9c0-.3-.1-.5.5-.5l1.6-.2s1.3-.5 1.4-.2c0 .3-1 .8-1.6.8l-1.4.4c-.3.2-.5 0-.5-.3m-1 9.8c1.4 0 2.6-.3 2.7 0 0 .1-.7.5-1.4.7-.7.3-2 .3-3 .4-.9 0-1-.2-1-.6 0-.5 1.3-.5 2.7-.5m-11 10.8c.1-.2.6 0 1.4 0 .8.3 2.1.5 2.8.5l2.4-.1 1 .2c0 .2-1.3.2-3 .4-1.8.2-3-.2-3.8-.3-.8-.2-1-.5-.9-.7zm-4.6 7.6a6 6 0 0 0 2.1.4l2.3.3s.7 0 .6.4c-.1.3-.4 0-1-.1h-2.4c-1.2 0-1.8-.4-2.5-.5-.7-.1-1.5-.5-1.1-1 .4-.4 1.1.2 2 .5m-9 5.8 2.5 1.8 1.1.6c.8.4.7.6.6.8-.1.2-.6-.3-1-.5a16.4 16.4 0 0 1-2.5-1.6c-.7-.6-1.6-1-1.4-1.5.1-.4.3-.1.8.4zm14.9-74.8-1.7 2.3c-1.6 2-.7.1-.4-.4l3.4-4.5c.8-.9 1-.5.5 0zm3.2 9.8c-.2-.2.3-.4 1.1-1.5l2.7-3.3.6-1c.2.1-.6 1.8-1.3 2.5-.7.7-1.6 2-2.1 2.7-.5.6-.8.9-1 .6m-4.3 18.5c0-.5 1.8-.5 2.6-.6l2.2-.5s1.6-.3 1.6 0c0 .1-.3.3-1.2.5l-3.3.8c-1 .1-1.9.3-1.9-.2m4.3-10a15.3 15.3 0 0 1-2.5 1.7c-.6.4-1.1.8-1.4.5-.4-.4.2-.7 1.2-1.1l1.5-.9 1-.5c.5-.3 1.3-.6.2.3m-10-6.5 1.4-1s.9-.8 1-.5c.2.3-1 1-1.5 1.6-.5.5-1.5 1.9-2 1.6-.5-.3.5-1.1 1.2-1.7zm6.6 25.7 1.5.4c.7.2.7.4-.4.4s-1.6-.3-2.7-.5-1.5-.3-1.3-.7c.1-.3.7-.2 1.2 0zm-1.8 9.3c.1.2-.8 0-1.4-.2-.5-.2-1.7-.9-2.4-1-.7-.3-.7-.4-.7-.8s.7 0 1.6.2c1 .3 2 1.2 2 1.2l1 .6zm-12 5.6c-.8-.5-1-.8-.7-1 .3-.3.6-.3 1.2.2a51 51 0 0 0 2 1.5l1.1.5c.5.2 1.2.7 1 1-.2.1-1.2 0-1.7-.6s-2-1-2.9-1.6m-5.6 7.5c-.4-.3-1.4-.6-1.8-1-.5-.3-.8-1.3-.4-1.4.4-.1.6.4 1.4 1l3.5 2.4.7.3c.7.2.4.5-.2.4-.7-.1-1-.1-1.8-.7zm-8.4 7.1a9.2 9.2 0 0 1-2.2-1.7c-.5-.4-1.2-1-.8-1.3.4-.3.8.1 1.4.6l2.1 2.2s.2 0 1 .7c.9.7 0 .5-.3.3a3 3 0 0 0-1.2-.8"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m338.2 142.5 4-1 2.5 2-3.1 1.4z"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: -330.8,
      cy: 142.1,
      fill: "#b96b29",
      rx: 3.2,
      ry: 3.1,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: -330.8,
      cy: 141.4,
      r: 1.9,
      fill: "#d4af3a",
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M337.5 131.4c-.8.3-1.9.2-1.9.2s-.3-1.4.5-2.1l2-1.7.5-.6v2c.1.8-.3 1.9-1.1 2.2"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: -335.8,
      cy: 133,
      r: 0.6,
      fill: "#d4af3a",
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "m340.2 132.4.8.9s-.7 0-1.2.4c-.6.4-1.2.7-1.9.6a.9.9 0 0 1-.8-1c.2-.5.5-1 1.5-1.3 1-.4 1.3 0 1.6.4m-2.2 3.7c2 .2 4.6-2 4.6-2 .3 1.8 1.4 2.7 3 3v.1s-1.7.8-3.5 1.1a7 7 0 0 1-2.5-.2 10.6 10.6 0 0 1-3-1c-1.2-.7-.9-2.6-.9-2.6s.2 1.5 2.2 1.6zm7.8-2c.8-.3 2-.9 2.6-1 .5 0 1.3 0 1.1.9 0 1-1 1.4-2 1.4s-1.5-.3-2-.6c-.6-.3-.5-.4.3-.7m6.3-3.4c1-.7 1.7-.9 1.7-.9s.6 1.6.3 2.6-1 1.2-1.9 1.2c-.8 0-2.1-.5-1.8-1.2.4-.6.8-1 1.7-1.7"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: -351.3,
      cy: 135.1,
      fill: "#d4af3a",
      rx: 0.7,
      ry: 0.5,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M349.4 127.3c.5-2.7.4-5.6-2-9.3a16 16 0 0 0-7-5.1L339 111c-1.4-1.5-4.3-3.4-4.3-3.4l5.2 1.5a2.3 2.3 0 0 0 2.3 2.4c.4 0 .9-.2 1.3-.4 1 .1 4.4 2.2 5.2 2.9a2.3 2.3 0 0 0-.3 1.2 2.3 2.3 0 0 0 2.3 2.3c.3 0 .7 0 1-.2l.3.5a23.4 23.4 0 0 1 1.6 3.7c-.6.4-1 1.1-1 2 0 1.3 1 2.3 2 2.3v1.5c0 .7-.4 1.2-1.7 1.6-1.3.3-3 2.6-3 2.6-.2 0-1.1-1.6-.4-4.3z"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M341.3 110.3c-.4-.4-.5-1-.1-1.4.3-.3 1-.3 1.5.1s.6 1 .2 1.4c-.4.3-1 .3-1.6-.1m8.5 5.7c-.5-.5-.6-1.3-.2-1.7.4-.4 1.2-.4 1.7.1.6.5.7 1.3.2 1.7-.4.4-1.2.4-1.7-.1"
    }),
    /* @__PURE__ */ jsx158("circle", {
      cx: -354.8,
      cy: 123.2,
      r: 1.3,
      fill: "#d4af3a",
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M326.6 105c.7.2 2 .6 3.8 1.6-1.3 0-2.3.8-2.3 1.9 0 1 1.2 2.2 2.5 2.2s2.2-1.1 2.2-2.2c0-.2 0-.5-.2-.7l1.8 1.2c4.2 2.8 5.1 4.1 7.2 8 2 3.8 2.8 8 1.9 10.4-.9 2.5-4.2 3-4.2 3s.4-.3.4-.8l-.2-1.6c-.2-1 0-2.1 0-2.1s-.8-.1-1.2.4l-1.5 1.7-1.5 1.5s-.7-1-.7-2.1.8-2.3 1-4.3c0-2-1-5.5-2.9-8a22 22 0 0 0-6.6-5.5 2.1 2.1 0 0 1-1.3-1.7l-.2-2c-.1-1.2 1-1.1 2-.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M330.8 109.5c-.8 0-1.4-.7-1.4-1.3 0-.6.5-1 1.3-1 .7 0 1.3.4 1.3 1s-.5 1.3-1.2 1.3m-6.2 24.4c-1 .4-2.2.1-2.7-.2-.5-.4-.7-1.3 0-1.8a2 2 0 0 1 2-.2l2 1.3s-.3.5-1.3.9"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M321.4 135c.3.6.6.9 1.7 1 1.1 0 2.3 0 3-.8a7.7 7.7 0 0 0 1.3-1.7h1.3s.4 1.7 1 2.1c.5.5 2.4.6 3.3 0 .8-.7 1.6-1.4 1.7-1.3.2 0 0 .7-.8 1.4s-1.5 1.3-3 1.3H323s-1.6 0-2-1c-.5-.9-.6-1.5-.3-1.7.2-.3.3.1.7.7"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M333.5 133.7c-1.2.6-1.9.2-2.3-.3l-.5-.8 1.7-.7c.5-.4.9-.7 1.5-.6l.6.1s.2 1.6-1 2.2z"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: -339.3,
      cy: 121.9,
      fill: "#b96b29",
      rx: 2.7,
      ry: 2.6,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#b96b29",
      d: "M334.7 112.7c1-.7 2.6-.4 3.5.6.8 1.1.7 2.6-.4 3.3-1 .7-2.6.4-3.5-.6-.9-1.1-.7-2.6.4-3.3"
    }),
    /* @__PURE__ */ jsx158("ellipse", {
      cx: -339.4,
      cy: 121.5,
      fill: "#d4af3a",
      rx: 1.6,
      ry: 1.5,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx158("path", {
      fill: "#d4af3a",
      d: "M335.8 113c.7-.2 1.5.2 1.9.8.3.6 0 1.2-1 1.4-1.7.3-2.5-1.8-1-2.2z"
    })
  ]
});
var Me_default = SvgMe;

// src/country-flag-icons/generated/Mf.tsx
import { jsx as jsx159, jsxs as jsxs152 } from "react/jsx-runtime";
var SvgMf = (props) => /* @__PURE__ */ jsxs152("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx159("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx159("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx159("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Mf_default = SvgMf;

// src/country-flag-icons/generated/Mg.tsx
import { jsx as jsx160, jsxs as jsxs153 } from "react/jsx-runtime";
var SvgMg = (props) => /* @__PURE__ */ jsx160("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs153("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx160("path", {
        fill: "#fc3d32",
        d: "M213.3 0H640v240H213.3z"
      }),
      /* @__PURE__ */ jsx160("path", {
        fill: "#007e3a",
        d: "M213.3 240H640v240H213.3z"
      }),
      /* @__PURE__ */ jsx160("path", {
        fill: "#fff",
        d: "M0 0h213.3v480H0z"
      })
    ]
  })
});
var Mg_default = SvgMg;

// src/country-flag-icons/generated/Mh.tsx
import { jsx as jsx161, jsxs as jsxs154 } from "react/jsx-runtime";
var SvgMh = (props) => /* @__PURE__ */ jsx161("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs154("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx161("path", {
        fill: "#3b5aa3",
        d: "M0 0h639.9v480H0z"
      }),
      /* @__PURE__ */ jsx161("path", {
        fill: "#e2ae57",
        d: "M0 467 639.9 0v87L0 480z"
      }),
      /* @__PURE__ */ jsx161("path", {
        fill: "#fff",
        d: "M22.4 480 640 179.2l-.1-95.5L0 480zm153-464.8L169 118l-27-65.6 10.4 69.8-41.9-56.4 27.5 64.3-55-42.6 42.8 53.6-62.1-27.6 54.4 41.2-67.7-9 64 25.4L14 180.3l100.6 6.7-63.7 26.2 67-9-54.3 40 63-27.6-43 54 54.6-41.3-27 62.9 43.6-54.7-11.8 68.1 27.5-63.7 6.2 100.7 9.7-100.4 23.7 64-9-69 43.4 54.8-28.6-64 54.6 44-43.4-54.9 64.9 27-57.4-41.9 69.9 11.8-67-25.7 104.1-6.5-104-9.7 68.5-22.8-71 9 58.6-41-66 26.5 45.6-55.3-55.6 43.4 26.7-66.4-43.1 56.4 9.3-70.4-25.7 66.5-9.6-102.8z"
      })
    ]
  })
});
var Mh_default = SvgMh;

// src/country-flag-icons/generated/Mk.tsx
import { jsx as jsx162, jsxs as jsxs155 } from "react/jsx-runtime";
var SvgMk = (props) => /* @__PURE__ */ jsxs155("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx162("path", {
      fill: "#d20000",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffe600",
      d: "M0 0h96l224 231.4L544 0h96L0 480h96l224-231.4L544 480h96zm640 192v96L0 192v96zM280 0l40 205.7L360 0zm0 480 40-205.7L360 480z"
    }),
    /* @__PURE__ */ jsx162("circle", {
      cx: 320,
      cy: 240,
      r: 77.1,
      fill: "#ffe600",
      stroke: "#d20000",
      strokeWidth: 17.1
    })
  ]
});
var Mk_default = SvgMk;

// src/country-flag-icons/generated/Ml.tsx
import { jsx as jsx163, jsxs as jsxs156 } from "react/jsx-runtime";
var SvgMl = (props) => /* @__PURE__ */ jsx163("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs156("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx163("path", {
        fill: "red",
        d: "M425.8 0H640v480H425.7z"
      }),
      /* @__PURE__ */ jsx163("path", {
        fill: "#009a00",
        d: "M0 0h212.9v480H0z"
      }),
      /* @__PURE__ */ jsx163("path", {
        fill: "#ff0",
        d: "M212.9 0h214v480h-214z"
      })
    ]
  })
});
var Ml_default = SvgMl;

// src/country-flag-icons/generated/Mm.tsx
import { jsx as jsx164, jsxs as jsxs157 } from "react/jsx-runtime";
var SvgMm = (props) => /* @__PURE__ */ jsxs157("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx164("path", {
      fill: "#fecb00",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#34b233",
      d: "M0 160h640v320H0z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#ea2839",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsxs157("g", {
      transform: "translate(320 256.9) scale(176.87999)",
      children: [
        /* @__PURE__ */ jsx164("path", {
          id: "mm_svg__a",
          fill: "#fff",
          d: "m0-1 .3 1h-.6z"
        }),
        /* @__PURE__ */ jsx164("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        }),
        /* @__PURE__ */ jsx164("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        }),
        /* @__PURE__ */ jsx164("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx164("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        })
      ]
    })
  ]
});
var Mm_default = SvgMm;

// src/country-flag-icons/generated/Mn.tsx
import { jsx as jsx165, jsxs as jsxs158 } from "react/jsx-runtime";
var SvgMn = (props) => /* @__PURE__ */ jsxs158("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#ffd900",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx165("path", {
      fill: "#da2032",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx165("path", {
      fill: "#0066b3",
      d: "M213.3 0h213.4v480H213.3Z"
    }),
    /* @__PURE__ */ jsx165("circle", {
      cx: 106.7,
      cy: 181.8,
      r: 40
    }),
    /* @__PURE__ */ jsx165("circle", {
      cx: 106.7,
      cy: 163.6,
      r: 43.6,
      fill: "#da2032"
    }),
    /* @__PURE__ */ jsx165("circle", {
      cx: 106.7,
      cy: 170.9,
      r: 29.1
    }),
    /* @__PURE__ */ jsx165("path", {
      d: "M109.7 76.4a8.7 8.7 0 0 0-5.2 7.5c-.2 2.5.9 5.3 1 7.7 0 4.2-4.3 5.6-4.3 11.5 0 2 1.9 4.3 1.9 9.6-.4 2.8-2 3.5-3.7 3.7a3.6 3.6 0 0 1-3.6-3.7 3.6 3.6 0 0 1 1-2.5 3.6 3.6 0 0 1 .4-.3c.8-.9 2-1.2 2-3.4 0-1.1-.8-2.2-1.5-4.2s-.2-5.2 1.4-7.1c-2.6 1-4.1 3.4-5 5.6-.8 2.7 0 4.2-1.2 6.5-.7 1.4-1.5 2-2.3 3.2-1 1.4-2 4.4-2 5.9a18.2 18.2 0 0 0 36.3 0c0-1.5-1.1-4.5-2-5.9-.9-1.2-1.7-1.8-2.4-3.2-1.2-2.3-.4-3.8-1.3-6.5-.8-2.2-2.3-4.6-4.9-5.6 1.6 2 2 5.2 1.4 7.1-.7 2-1.4 3-1.4 4.2 0 2.2 1.1 2.5 2 3.4a3.6 3.6 0 0 1 .3.3 3.6 3.6 0 0 1 1 2.5 3.6 3.6 0 0 1-3.6 3.7c-2-.3-3.5-1.2-3.7-3.7 0-7 3-7.4 3-12.6 0-7.4-6.6-10.9-6.6-16.3 0-1.8.4-5 3-7.4M26.7 229H63v174.5H26.7Zm123.6 0h36.4v174.5h-36.4zm-80 0H143l-36.3 21.8Zm0 29H143v14.6H70.3Zm0 101.9H143v14.6H70.3Zm0 21.8H143l-36.3 21.8Z"
    }),
    /* @__PURE__ */ jsx165("circle", {
      cx: 106.7,
      cy: 316.4,
      r: 36.4
    }),
    /* @__PURE__ */ jsxs158("g", {
      fill: "#da2032",
      transform: "translate(-38.8 32.7) scale(.72727)",
      children: [
        /* @__PURE__ */ jsx165("circle", {
          cx: 200,
          cy: 363.5,
          r: 10
        }),
        /* @__PURE__ */ jsx165("circle", {
          cx: 200,
          cy: 416.5,
          r: 10
        }),
        /* @__PURE__ */ jsx165("path", {
          d: "M200 334a29.5 29.5 0 0 1 0 59 23.5 23.5 0 0 0 0 47v6a29.5 29.5 0 0 1 0-59 23.5 23.5 0 0 0 0-47z"
        })
      ]
    })
  ]
});
var Mn_default = SvgMn;

// src/country-flag-icons/generated/Mo.tsx
import { jsx as jsx166, jsxs as jsxs159 } from "react/jsx-runtime";
var SvgMo = (props) => /* @__PURE__ */ jsxs159("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx166("path", {
      fill: "#00785e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx166("path", {
      fill: "#fbd116",
      d: "m295 108.7 40.5 29.5L320 90.5l-15.5 47.7 40.6-29.5z"
    }),
    /* @__PURE__ */ jsxs159("g", {
      id: "mo_svg__a",
      children: [
        /* @__PURE__ */ jsx166("path", {
          fill: "#fff",
          d: "M320 331.6H217.5a146.3 146.3 0 0 1-3.8-4H320a2.1 2.1 0 0 1 1.4 2c0 .8-.5 1.7-1.4 2m0-31.3a13 13 0 0 0 1.2-7.6 12.4 12.4 0 0 0-1.2-3.8 82 82 0 0 1-32.5 19 81 81 0 0 1-23.5 3.5h-63.1a144.4 144.4 0 0 0 5.8 8h61c20 0 38.2-7.2 52.3-19.1m-109.6-24.7a32.3 32.3 0 0 1-9.7 2 81 81 0 0 0 60.8 27.5 80.9 80.9 0 0 0 58.5-25 441 441 0 0 0 4.5-58.8 441 441 0 0 0-4.5-67.7c-6.6 6-19 18.7-24.8 38.3A81 81 0 0 0 292 215a80.7 80.7 0 0 0 13.7 45 80.7 80.7 0 0 1-17-49.5c0-12.4 2.8-24.2 7.8-34.7a32.5 32.5 0 0 1-7.5-13 80.7 80.7 0 0 0-10.5 40c0 18 5.9 34.7 15.9 48.1a95 95 0 0 0-73.4-29.4 32.6 32.6 0 0 1 6.8 8.9 95 95 0 0 1 68.6 29.4 95 95 0 0 0-61-22.2 95 95 0 0 0-36.7 7.3 81.2 81.2 0 0 0 82.6 52.2c-4.7.8-9.5 1.3-14.4 1.3a80.8 80.8 0 0 1-56.4-22.8zM320 364.4h-53.1a143.5 143.5 0 0 0 53.1 10.1 11 11 0 0 0 1.3-5 11 11 0 0 0-1.3-5.1m0-24.5h-93.6a143.8 143.8 0 0 0 7.8 6.2H320a4.6 4.6 0 0 0 1.3-3.1 4 4 0 0 0-1.3-3.1m0 12.5h-76.7a143.6 143.6 0 0 0 14.4 8H320a7.6 7.6 0 0 0 1.2-4.2 7.5 7.5 0 0 0-1.2-3.8"
        }),
        /* @__PURE__ */ jsx166("path", {
          fill: "#fbd116",
          d: "m200.5 174.8 25.4 23.6-6.7-34-14.6 31.4 30.3-16.8zm36.9-32 34.7.6-27.7-21 10.1 33.3 11.3-32.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsx166("use", {
      xlinkHref: "#mo_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    })
  ]
});
var Mo_default = SvgMo;

// src/country-flag-icons/generated/Mp.tsx
import { jsx as jsx167, jsxs as jsxs160 } from "react/jsx-runtime";
var SvgMp = (props) => /* @__PURE__ */ jsxs160("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx167("defs", {
      children: /* @__PURE__ */ jsx167("clipPath", {
        id: "mp_svg__a",
        children: /* @__PURE__ */ jsx167("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs160("g", {
      clipPath: "url(#mp_svg__a)",
      children: [
        /* @__PURE__ */ jsx167("path", {
          fill: "#0071bc",
          fillRule: "evenodd",
          d: "M-160 0h960v480h-960z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M370 365.7s15.2-16.1 29.8-13c4.4-17 21-18.4 21-18.4s-1.7-18.7 19.5-22.8c.6-12.7 13.5-23.3 13.5-23.3s-2.6-19.7 10.8-24.3c-8.2-15.6 2.8-27 2.7-27.3-.2-.3-14-24.8-1.6-31.8-13-11-8.8-23.4-8.8-23.4s-14.2-3.7-9.1-20.7c-11.7-2-14-20.9-14-20.9s-18 3.7-20.2-12c-12 1.9-13.2-9.8-13.4-9.8-.1 0-23.5 6.3-28.2-11.4-9.1 4.7-13-3.7-13-3.7s-13 6.5-20.8-6c-15.5 9.7-24.2-.4-24.2-.4s-20.3 13.4-27 3c-12 12.2-22.8 7-22.8 7s-9 16-23.7 12c-3.3 14.9-20.2 15.2-20.2 15.2s1.8 13.1-18.4 16.7c-2.6 15.5-13.2 18-13.2 18s1 15.2-8.5 20c3.4 8.5-5.4 18.9-5.4 18.9s9.4 11.7-3.4 24.9c12.3 3.2 3.4 24.4 3.4 24.4s17 7.6 6.3 21.7c12.2 4 8.4 13.6 8.5 19.3 7.8 3.5 14.6 1.8 11.3 17.4 23.8 2.7 12.6 15.8 12.6 15.8s11 .5 6.7 9.3c20.3-.5 23.3 15.2 23.3 15.2s18.8-5 21.3 2.3-8.2 56.7-8.2 56.7-16 0-27.8-12.8c-27.8-.7-21.6-19-22-19-.5 0-9.3 3.4-13.8-11.9-18.6 3.8-18-11.8-18.2-12-.1-.1-8.3-3.8-5.3-11.5-19.1 1.7-17.7-17-17.7-17-4.2-1.7-5.7-5.6-5.1-9.5-2.5-.9-19.5-1.2-10.7-23.6-16.2-9.8-6.1-21-6.1-21s-22.4-11.6-5.1-25c-13-19 1-28.5 1-28.5s-17.9-18.1.3-31c-3-27.5 13.4-34.1 13.4-34.1s-8.6-22.4 14.8-31.8c1.5-22.7 17.9-23.3 17.9-23.3s.4-18 26.2-16.2c5-16.1 22.5-12.9 22.5-12.9s5.4-19.5 29.3-10.1c12.1-23.7 30.2-11.6 30.2-11.6s11.4-7.4 17-5c7.3-12.5 22.8-.6 32.7 1.9 3.7-1.5 16.6-11.2 26.5 1 13.2-8.5 24.5 7 24.5 7s18.1-9.2 26.6 11.8c38.5-3.5 33 21.7 33 21.7s30.2-6.9 23.6 23.3c27.6 1.9 24.8 20 24.8 20s17.4 13.2 9.8 25c15.5.8 9.8 15.7 9.8 15.7s11.9 4.6 2 23c22.7 18.1 4.4 36.2 4.3 36-.2-.1 12.1 14.6 1 31.6 3.4 27-10.2 33.8-10.2 33.8s3.5 17.5-11.7 22.4c-.3 20.5-19.7 23-19.7 23s5.2 9-14 18.3c-.8 13.7-20.8 14.8-20.8 14.8s-1.9 25.2-27.4 18.4c-6.1 20.2-36 14.2-36.6 14-.5-.3-5.7-43.4-5.7-43.5z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 1.9,
          d: "M185 124s6.4 5.6 5.2 14c-1.2 8.3-6 19.9-5 28.5.6 3.5.3 9.7.3 9.7s-5.7-8.2-5.8-17 6.2-17.1 6.2-23.6-1.1-11.7-1-11.5zm-3.2 2.6s-8.4 8-9.5 15.7c-.8 4-1 22.7-1.2 31-.2 2.5-1.2 12.5-1.4 16.2-.3 3.6 6.1-6.2 6.5-14.3-.2-8.3-.2-25.8.6-28.5.8-3.4.6-7.1 1.8-10.5z"
        }),
        /* @__PURE__ */ jsxs160("g", {
          fill: "#ffd200",
          fillRule: "evenodd",
          stroke: "#ef8a10",
          children: [
            /* @__PURE__ */ jsx167("path", {
              strokeWidth: 1.9,
              d: "M366 100.5s10.8-5 14-14.4-9.5-9.4-11.1-6.4c-1.7 3 1.4 10.3.6 12.3-.8 2-5.2 6.6-3.5 8.4z"
            }),
            /* @__PURE__ */ jsx167("path", {
              strokeWidth: 2.5,
              d: "M269.8 103.9s7-9.7 5.2-19.4c-1.9-9.6-12.8-3.6-12.8-.2s6.2 8.3 6.5 10.4c.3 2.1-1.3 8.4 1 9.1zm-19.1 5.7s7-9.7 5.2-19.3c-1.8-9.7-12.8-3.7-12.8-.3 0 3.4 6.3 8.4 6.6 10.5.2 2-1.3 8.3 1 9.1zm-21.1 6.5s7-9.6 5.2-19.3c-1.9-9.7-12.8-3.7-12.8-.3 0 3.4 6.2 8.4 6.5 10.5.3 2-1.3 8.3 1 9.1zm-15 14.9s7.1-9.7 5.3-19.3c-1.8-9.7-12.8-3.7-12.8-.3 0 3.4 6.3 8.4 6.5 10.5.3 2-1.3 8.3 1 9.1zM199 145.4s7-9.7 5.2-19.4-12.8-3.6-12.8-.2 6.3 8.3 6.6 10.4c.2 2.1-1.3 8.4 1 9.2z"
            }),
            /* @__PURE__ */ jsx167("path", {
              strokeWidth: 1.9,
              d: "M235 61.7s-9.4 7.4-10.2 17.2c-.8 9.8 11.3 7 12.2 3.7 1-3.3-3.7-9.7-3.4-11.8.3-2 3.5-7.7 1.4-9zm31.3-9.6s-9.3 7.4-10.2 17.2c-.8 9.8 11.3 7 12.3 3.7.9-3.3-3.8-9.8-3.5-11.9.3-2 3.5-7.7 1.4-9zm-116.7 84.5s2 11.8 10.2 17.3c8.2 5.4 11.5-6.6 9.1-9s-10.3-1.4-12-2.6c-1.7-1.3-5-6.8-7.3-5.7zm-15.6 40s0 12 7.3 18.7c7.2 6.6 12.4-4.7 10.4-7.4s-10-3-11.4-4.5c-1.5-1.6-4-7.5-6.3-6.7zm36 44.8s-4.2-11.2-13.3-15c-9.1-3.6-10 8.8-7.2 10.7 2.9 1.8 10.4-.7 12.3.2 2 .9 6.3 5.6 8.3 4zm-7.4-19.4s7.2-9.5 5.6-19.1c-1.7-9.7-12.7-4-12.8-.6 0 3.4 6 8.5 6.3 10.6.2 2.1-1.5 8.3.9 9.2zm225.6-91.9s10.8-5 14-14.3-9.5-9.4-11.1-6.5c-1.7 3 1.4 10.4.6 12.3-.8 2-5.2 6.7-3.5 8.5zm32.8 16.4s6.4-10.1 3.9-19.6c-2.5-9.5-13-2.8-12.8.6.2 3.3 6.8 7.9 7.2 10 .4 2-.7 8.4 1.7 9zm89.6 93s-4.3-11.1-13.4-14.9c-9.1-3.7-10 8.8-7.2 10.6 2.9 1.9 10.5-.7 12.3.2 2 1 6.3 5.7 8.3 4.1zm-43.8 7s.2-12 7.5-18.6c7.3-6.6 12.4 4.9 10.4 7.6-2.1 2.7-10 2.8-11.6 4.3-1.4 1.5-4 7.4-6.3 6.6zm-7-126.8s-11.3-4.3-20 0c-9 4.4-.2 13.4 3 12.5 3.3-1 6.4-8.3 8.4-9.1 2-.8 8.4-1 8.5-3.4zM434 78.3s-11.1-4.3-20 0c-8.8 4.4-.1 13.4 3.2 12.5 3.2-1 6.4-8.3 8.3-9.1 2-.8 8.4-1 8.5-3.4zm-38-20.4s-9.5 7.3-10.4 17c-1 9.8 11.2 7.1 12.2 3.9 1-3.3-3.7-9.8-3.4-11.9.4-2 3.6-7.6 1.6-9zm-24.8-6s-4.4 11.1-.1 20c4.3 8.9 13.3.2 12.4-3-.9-3.3-8.2-6.5-9-8.4-.8-2-.9-8.5-3.3-8.6zm-70.5 43s7.7-9.2 6.6-19c-1.1-9.7-12.5-4.5-12.7-1.1-.3 3.4 5.6 8.8 5.7 10.9.1 2-1.9 8.2.4 9.1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c8a8c",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M342.8 114.4s18.5 1.2 19.4 11.8-4.4 17.1-4.4 17.1 2.3 23-15.8 29.7c-19.4 2.3-49.9.5-49.9.5s-9 2.2-12.6-16.3a305 305 0 0 1-4.6-31.6s1.8-10.4 14.9-11c13-.7 52.8 0 53-.2z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 1.9,
          d: "M357.7 143.2s-10 12.4-9 17.5"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c8a8c",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M344.3 172.3c2.5 2.1 4.8 4.4 5.3 12l1 15.4 13 116.6 11.4 84.3.8 13s-2.7 9.7-10.4 10.5c-5.5 11.6-35.7 15-38.7 14.9-2.7-.2-12.3-4.2-18.1-3.7-5.9.5-16 4.4-20.5 3.8-4.5-.7-14.8-4.2-16.6-11.6-12.7-4-14.7-13.7-14.7-13.7l13.7-97.5 13.3-123.4s1.6-16.4 8.2-18.9c6.9-.6 42.4.7 52.3-1.7z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "m274.4 341.1-2.7 86.3m86.5-74.9 7.6 71.2"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#000",
          d: "m136.6 296.3-.3 1m358.7-4.1.3 1"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#6b18b5",
          strokeLinejoin: "round",
          strokeWidth: 1.9,
          d: "M127 179.8s5.6 7.9 6.7 12.4c1 4.5 2.9 13.4 5.3 17 2.5 3.7 16.6 23.9 17.4 32.3.1 5.6-5.9 15-14.7 15.2-5.6-.2-19.8-3.8-20.4-16-.6-12.3 4.3-12.5 5-20 .5-7.4.7-40.7.7-40.9z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#6b18b5",
          strokeLinejoin: "round",
          d: "M224.5 72.8s-6 .4-10.4 2.9c-3.5 2.1-9.5 5.3-13.6 11-10.6 8.2-26.5 12-31.5 19-3 4.6-2.8 15.7 4.7 20.5 4.8 2.7 19 7 25.8-3.1 6.8-10.2 2.7-13 6-19.6a117.4 117.4 0 0 1 19-30.7zM367 58s-4.4-4-9.3-5.5c-4-1-10.6-.6-17.5-1.3-13.3-1.8-27-11.4-35.3-10.2-5.4 1-13.3 9-11.5 17.6 1.3 5.4 7.3 16.2 19.4 14.1 12-2.1 12-4.8 19-7 17.4-9.7 35-7.7 35.2-7.7zm141.4 137.4c1-2.3-.9-6.6-2.2-11.5-1.2-4-3.1-10-7.7-15.5-5.4-12.2-4.5-29-10-35.4-3.7-4-14.6-6.6-21-.4-3.9 4-11.4 16.6-3.2 25.7 8.2 9 11.8 5.7 17.4 10.5 13.5 9 20 25 26.7 26.6zM503.5 302c1.9-2.5 5.2-7.4 4.8-11.5-.3-3.2 1.5-13 1.7-17.3 1.2-13.3 9.5-24.2 7.2-35.7-1.3-5.4-9.2-13-17.8-10.8-5.2 1.6-17 8-14.3 20 2.7 12 6.6 11.7 9.1 18.7 7.3 14.5 2.7 31.7 9.3 36.6z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M405.5 386.8s-2.3 4.4 6.8 8.2m11.3-18.4s10-2.5 16.8 0m13.2-25.4c0 .2-1.4 4.5 6.6 10.8m-.8-22s5.9 4.3 15.8 4m-75.4 8.6s.3 11.5-5.6 16.8m25.4-34.5s9.7 2.4 17.7-1.6m44.6-15.3s2.1 3 12.9 2.5m-54.9-9.3c.3.2 12.7 4.2 20.5.6m4.2-47.8s.5-.7 4.3 12.7m5.2-50.4s-.5 7.1-6.2 10.2m42.9-39.4s-8.4 6.8-6.8 9.5m-34.7-14.4s4.3 7.3-2.8 12.3M448.2 161s7.5-.3 10.8 6.1m-24.8-27.3h5.7m24-26c0 .1 1.5 1.5-1.4 4.5m-52-3.8s4 6.2 3.3 13.9m19.8-35.1c1.8-.2 7.7-2.8 7.7-2.8m-33.4-22c-.1 0-2.2 7.7 1.6 10.5m-11.1 25c0 8.4 6.6 6.3 2 14.3M382.2 97a57 57 0 0 0-10.4 9.4m-16.4-13.7s4.4 4.3 3.3 10.2m-16-13.7s-2.2 6.6-5.1 8.3m-18-10c-.1.3-3.6 7.8-6 9.1m-25.6-9c.2 0 3.5 7-.8 12m-6.5-48c.2.2.7 5.4-2.6 10m-28.7 1.9c0 .1 1.4 5.9-7.8 7.8m-9.9 45.2c.2.3 8.9 1.7 8.9 1.7M210 136.6c.2-.2 10.6-3.3 10.6-3.3m-27.4 16.3c.3 0 7.3 1.3 9 .4m-14 6s2.3 1.3.4 13m-34.2-43.5 4.2 6.2m-18.5 26c0-.2 4.2 6.2 9.8 7.4m23 25.2a49 49 0 0 0 8-2M170 213.8c.2 0-.1-4.3 5.2-7.3M163 224.7c0 .2 5 6.4 8.5 7.3m-11.5 4.7c.6-.2 6-4.9 12.2-4.5m-13.9 20.6s.2 5.4 16.2 4m-14.6 15c0-.2 4.7-10.8 14.2-14.8m-1.4 28.4s1.4-4.6 9.4-7.7m-.5 25.5s5.7-4.7 7.8-5.3m-.7 19.3s3.5 3.6 12.2-2.7m-54 5.6c1-.2 13.7-3.1 18 3.5m-13 7s13.4-1.8 15.1-.4m32.7 3.1s-1.8 3.7 14.7-2.4m5.8 9c-3 5 .7 9-3.2 11.3m-47-4.3c.5-.4 6-2.3 5.2-10.3m-.2 22.3c.7-.2 9.9-4.2 11.8-2.1m6.3 13.7s1.2-8.2 3.8-9m10 21.3s7.7-.1 11-2.6m3.8-25c.2.2 7.1 3.8 22 .2m-16.4 33s2 10.6 2 13"
        }),
        /* @__PURE__ */ jsxs160("g", {
          fill: "#de2010",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.5,
          children: [
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.60885 -.2011 .2072 1.65762 94.8 75)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.60885 -.2011 .2072 1.65762 93.4 57.3)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.58497 -.3417 .35206 1.633 78 74)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.4455 -.73446 .7567 1.4893 55.9 163)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.4455 -.73446 .7567 1.4893 48.9 147.1)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.3781 -.85423 .88011 1.41987 40 167.4)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.28907 -.98346 1.01327 1.32812 33.8 193)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.1329 -1.15994 1.19508 1.16722 35.3 239)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.02138 -1.25922 1.29739 1.05234 34.3 262.7)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.79817 -1.41132 1.45408 .82236 51.9 315)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.66642 -1.4781 1.52289 .6866 56.8 337.4)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.56582 -1.51945 1.5655 .58296 57.9 352.4)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.4482 -1.5582 1.60543 .46178 63 370.4)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.20288 -1.60864 1.65738 .20903 94.7 408.9)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.06506 -1.62008 1.66918 .06703 106.3 427.4)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.06506 -1.62008 1.66918 .06703 88.8 428)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.36132 -1.5806 1.62852 -.37226 172.5 473.5)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.49045 -1.54542 1.59227 -.50531 188.3 485.8)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.67103 -1.476 1.52073 -.69138 221.9 499.1)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.7945 -1.41337 1.4562 -.81858 241.4 508.3)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.94339 -1.31867 1.35863 -.97197 271.6 515.4)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.05159 -1.2341 1.27151 -1.08344 292.4 520.2)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.13737 -1.15553 1.19056 -1.17183 308.9 526.1)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.2301 -1.05628 1.08829 -1.26738 331.4 529.6)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.33573 -.91908 .94693 -1.3762 362.5 526.1)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.47374 -.67597 .69645 -1.51841 415.9 504)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.52895 -.53958 .55593 -1.5753 438.7 497.5)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.61445 -.12005 .15429 -1.33344 500.5 406)"
            }),
            /* @__PURE__ */ jsx167("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.58082 -.36035 .37125 -1.62873 468.4 480.8)"
            })
          ]
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#ffe300",
          fillRule: "evenodd",
          d: "M480 194.7c2.2-2.3 4.2-3 6.7-2.1-1-6.1-2.8-8.2-5.2-7.4-2.3.7-3.4 3.8-1.5 9.5m3.3 18.2c2.3-2.1 4.3-2.6 6.8-1.6-.4-6-2.2-8.3-4.6-7.7-2.4.5-3.6 3.6-2.2 9.3m-7.8-35c1.5-2.7 3.3-3.8 6-3.7-2.5-5.6-4.8-7.1-7-5.8-2 1.3-2.2 4.6 1 9.6zm-8.1-16.6c1.5-2.8 3.3-3.9 6-3.7-2.5-5.7-4.9-7.2-7-5.9-2 1.3-2.2 4.6 1 9.6m-19.5-30.5c1-3 2.6-4.4 5.2-4.6-3.3-5.2-5.9-6.3-7.7-4.7s-1.5 5 2.5 9.3M435 117.5c1-3 2.4-4.4 5-4.8-3.4-5-6-6-7.8-4.4-1.8 1.7-1.4 5 2.8 9.2M408.3 95c0-3.2 1-5 3.3-6.2-4.8-3.7-7.7-3.8-8.8-1.7s.2 5.1 5.5 7.9m14 10.5c.4-3.1 1.7-4.8 4.3-5.5-4.2-4.5-6.9-5.2-8.4-3.3-1.5 2-.7 5.1 4 8.8zm-30-19.3c-.3-3.1.5-5 2.7-6.5-5.2-3.2-8-3-9-.8-.9 2.3.8 5.1 6.4 7.3zM376.2 79c-.8-3-.3-5 1.7-6.8-5.6-2.4-8.4-1.9-9 .5-.6 2.4 1.5 4.9 7.3 6.3m-17.5-5.4c-1.1-3-.8-5 1.1-7-5.8-1.9-8.5-1.1-9 1.3-.3 2.4 2 4.8 7.9 5.7m-17.3-3.4c-1.2-2.8-1-5 .7-7-6-1.5-8.6-.5-8.8 2-.3 2.4 2.2 4.6 8.1 5m-18.2-1.4c-1.6-2.7-1.6-4.8 0-7-6.1-.9-8.7.4-8.6 2.8 0 2.5 2.7 4.4 8.6 4.2m-35.7 2.7c-2.2-2.2-2.7-4.3-1.8-6.8-6 .6-8.2 2.4-7.6 4.8.6 2.4 3.7 3.6 9.4 2m17.6-2.3c-1.9-2.5-2.2-4.6-.9-7-6.1-.2-8.5 1.3-8.2 3.8.3 2.4 3.2 4 9 3.2zm-34.9 6c-2.4-1.9-3.3-3.8-2.7-6.4-6 1.5-7.8 3.6-6.9 5.8 1 2.3 4.2 3 9.6.6m-33 15.2c-2.8-1.4-4-3.1-3.9-5.8-5.6 2.6-7 5-5.6 7 1.3 2 4.6 2.2 9.5-1.2m16-8.1c-2.7-1.7-3.6-3.6-3.2-6.2-5.9 1.8-7.6 4-6.5 6.2 1.1 2.2 4.4 2.8 9.6 0zm-45.6 28.8c-3-.8-4.6-2.3-5-5-5 3.8-5.8 6.4-4.1 8.1 1.8 1.7 5 1.2 9-3.1zm14.1-11.6c-3-1-4.4-2.6-4.6-5.2-5.2 3.2-6.3 5.8-4.7 7.7 1.6 1.8 5 1.5 9.3-2.5m-26.7 24c-3-.6-4.7-1.9-5.4-4.5-4.6 4.1-5.2 6.9-3.3 8.4 1.9 1.6 5 .7 8.7-4zM183.7 138c-3.2-.2-5-1.3-5.8-3.8-4.2 4.5-4.6 7.2-2.6 8.6 2 1.4 5.1.2 8.4-4.8m-9.4 15c-3.2.2-5-.7-6.4-3-3.4 5.1-3.4 8-1.2 9s5.1-.6 7.6-6m-8.3 16c-3 .6-5 0-6.7-2.2-2.7 5.5-2.3 8.3 0 9 2.3.8 5-1.2 6.7-6.9zm-6.6 16.3c-3 1.1-5 .8-7-1-1.8 5.8-1 8.5 1.5 8.9 2.4.3 4.7-2 5.5-8zm-4.5 18.2c-2.8 1.3-4.9 1.2-7-.5-1.4 6-.4 8.5 2 8.7 2.5.3 4.7-2.2 5-8.2m-1.8 15.2c-2.6 1.4-4.7 1.6-7 .5-.7 4.9.6 6.8 3 6.6 2.4-.2 4.3-2.4 4-7.1m307-72.2c1.1-3 2.7-4.4 5.3-4.6-3.2-5.2-5.7-6.3-7.6-4.8-1.9 1.6-1.6 5 2.3 9.4m25.2 85c2.3-2.2 4.4-2.7 6.8-1.6-.4-6.1-2.2-8.3-4.6-7.8-2.3.6-3.6 3.6-2.2 9.4"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 1.9,
          d: "M461.3 132s-7 6.9-5.7 15.2c1.2 8.3 6.5 18.6 5.5 27.3-1 8.6-2.5 14.3-2.5 14.3s8-9.1 8-18c.2-8.7-5.4-20.3-5.4-26.7s.3-12.2.1-12zm12.7 28s-5.3 4-4.8 13c.5 9.1 10 25.8 10 25.8s6.8 14 6.5 17.7c-.2 3.7 1.3-3.5.6-11.5s-11-25.8-11-25.8-2.2-3.6-2-9.7c.2-6 .8-9.4.8-9.5z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#6b18b5",
          fillRule: "evenodd",
          d: "M313 47.4c0-1.8-2.2-3.4-4.8-3.4s-4.7 1.6-4.7 3.4 2 3.4 4.7 3.4 4.7-1.5 4.7-3.4zm2 8c0-1.8-2.2-3.3-5-3.3-2.6 0-4.8 1.4-4.8 3.2s2.2 3.3 4.9 3.3 4.8-1.5 4.8-3.3zm6-9.4s-5.6 4.1-3.3 5.8c2.3 1.7 8.6-3.6 8.6-3.6zm163.3 95.4c0-1.2-.5-2.3-1.4-2.9a2.6 2.6 0 0 0-3 0c-.9.6-1.4 1.7-1.4 2.9s.5 2.3 1.4 2.9a2.6 2.6 0 0 0 3 0c.9-.6 1.4-1.7 1.4-2.9m-2.1-8c0-2-1.4-3.5-3-3.5s-3.1 1.6-3.1 3.6 1.4 3.5 3 3.5 3.1-1.6 3.1-3.5zm1.5 16.2c0-1-.6-1.8-1.2-1.8s-1.2.8-1.2 1.8.5 1.9 1.2 1.9 1.2-.9 1.2-1.9m4.9-14.4c0-1.2-.6-2.1-1.2-2.1-.7 0-1.2.9-1.2 2s.5 2.2 1.2 2.2c.6 0 1.2-1 1.2-2.1m-13.4 1.4c0-1-.6-1.7-1.2-1.7s-1.2.8-1.2 1.7.5 1.8 1.2 1.8 1.2-.8 1.2-1.8m2.1 11.4c0-1.5-1.1-2.7-2.5-2.7s-2.5 1.2-2.5 2.7c0 1.6 1 2.8 2.5 2.8s2.5-1.2 2.5-2.8m-6.6-5c0-1.3-1-2.4-2.1-2.4-1.2 0-2.2 1-2.2 2.4s1 2.4 2.2 2.4c1.1 0 2-1 2-2.4zm-1-6.8a2 2 0 0 0-1-1.7 1.8 1.8 0 0 0-1.9 0 2 2 0 0 0-.9 1.7 2 2 0 0 0 1 1.8 1.8 1.8 0 0 0 1.8 0c.6-.4 1-1 1-1.8m30.1 34.4c-2.7-3.6-7.1-5.1-9.8-3.4-2.6 1.7-2.6 6 .2 9.7 2.7 3.6 7 5.1 9.7 3.4 2.7-1.8 2.7-6 0-9.7zm7.8 66.7c.5-4.5-1.6-8.4-4.8-8.8-3.2-.3-6.2 3-6.8 7.4-.5 4.4 1.7 8.3 4.9 8.7 3.2.4 6.2-3 6.7-7.3m1.6 38.8c1-4.4-.9-8.5-4-9.2-3.2-.6-6.5 2.4-7.4 6.8-.9 4.3 1 8.4 4 9 3.2.7 6.5-2.3 7.4-6.7zm7.5-36.4c0-1.7-1.2-3.1-2.6-3.1s-2.7 1.4-2.7 3.1c0 1.8 1.2 3.2 2.7 3.2s2.6-1.4 2.6-3.2m-6.5 7.3-5.4 6.2s-5.1.1-4.8 1.8c.2 1.6 7 6.6 7 8.6-.1 2 4.4-.5 4.4-.5l3.7-11.1s-.2-7.7-2.2-7.6c-2 .2-2.5 2.5-2.7 2.6m-357.4-2.4a2.6 2.6 0 1 0-5.1 0 2.6 2.6 0 0 0 5.1 0m2.5-8c0-1.4-1.2-2.6-2.6-2.6s-2.6 1.2-2.6 2.7 1.2 2.7 2.6 2.7a2.7 2.7 0 0 0 2.6-2.7zM134 199.2c-1-2.2-3-3.4-4.5-2.7-1.5.7-2 3-1 5.2s3 3.4 4.5 2.7c1.6-.7 2-3 1-5.2m6.5 23.4c-1.4-2.8-4.1-4.4-6.2-3.5s-2.7 3.9-1.4 6.7 4 4.4 6.2 3.5 2.7-3.9 1.4-6.7m6.8 17.2c.5-3.5-1-6.8-3.2-7.2-2.3-.5-4.4 2-4.9 5.5-.4 3.5 1 6.7 3.3 7.2 2.2.5 4.4-2 4.8-5.5m-11 2.5c1.4-3.3.9-6.8-1.1-7.8s-4.8.7-6.2 4-.9 6.7 1.2 7.8 4.7-.7 6.1-4"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#6b18b5",
          fillRule: "evenodd",
          d: "M131.3 234.8c0-1.7-1.3-3-2.9-3s-2.9 1.4-2.9 3 1.3 3 3 3 2.8-1.3 2.8-3m-2.3-7.5c0-1.5-1.2-2.7-2.6-2.7a2.7 2.7 0 0 0-2.6 2.8c0 1.4 1.2 2.7 2.6 2.7s2.6-1.3 2.6-2.8m2.4-14.3c0-2.6-1.1-4.6-2.5-4.6s-2.5 2-2.5 4.6c0 2.5 1.1 4.6 2.5 4.6s2.5-2 2.5-4.6m7.8-1.1c.3-2.5-.5-4.7-2-5-1.3-.1-2.7 1.8-3 4.3-.4 2.5.5 4.7 1.9 4.9 1.3.2 2.7-1.7 3-4.2zm55-110c1.1-3.6 0-7.2-2.3-8-2.3-.9-5 1.3-6 4.9-1 3.6 0 7.2 2.3 8 2.3.9 5-1.3 6-4.9m-10.4 15.9c3-2.7 4.4-6.3 3-8.1-1.5-1.9-5.2-1.2-8.3 1.4s-4.3 6.2-2.9 8c1.5 1.9 5.2 1.3 8.2-1.3m-6-8.8c3-2.3 4.2-5.4 2.8-7s-5-1-8 1.2c-3.1 2.3-4.4 5.4-3 7s5 1 8.1-1.2zm23.5-15.5c2-1.6 2.9-3.8 2-4.9-1-1-3.5-.7-5.6.9s-2.9 3.7-1.9 4.8c1 1.1 3.4.7 5.5-.8"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#6b18b5",
          fillRule: "evenodd",
          d: "M189 108.5c1.4-2.2 1.5-4.5.2-5.2-1.3-.7-3.5.4-4.9 2.6s-1.5 4.5-.2 5.2c1.3.7 3.5-.5 4.9-2.6m17.7-9.3c2.2-1.9 3-4.3 2-5.5-1.2-1.2-4-.6-6.2 1.2s-3 4.3-1.9 5.5c1.2 1.2 3.9.6 6.1-1.2m-32 21.6c2 0 3.6-1.1 3.4-2.3 0-1.1-1.9-2-4-1.9-2 .1-3.6 1.2-3.4 2.3.1 1.2 2 2 4 2zm38.7-33.1c1.4-2.2 1.5-4.5.2-5.2-1.2-.7-3.4.4-4.8 2.6s-1.5 4.5-.2 5.2c1.3.7 3.4-.4 4.8-2.6"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#ffd200",
          fillRule: "evenodd",
          stroke: "#ef8a10",
          d: "M446.8 153.4s6.4-10.1 4-19.7c-2.5-9.5-13-2.7-12.8.7.2 3.3 6.8 7.9 7.2 10 .4 2-.8 8.3 1.6 9z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M324.9 69.3s23 .9 23.1 15.8c0 2.3 0 5-.8 11.7 4.6-2.5 7.6-9.3 7-13.7.1-15.1-20.5-25.5-29.3-13.8z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M310.3 68.6s18.5-3.8 18.7 11c.1 15-6 17.3-6 17.3s14.3-3 14.4-18.1c0-15.2-18.3-21.9-27.1-10.2z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#f7df73",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.5,
          d: "M373.3 390s86.8-24.6 113-131C471 368.1 376 403 376 403l-2.8-13z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M382.2 396.6c2.7 0 9.3-7.4 13.1-8.2 3.8-.8 4.2-4.7-.1-4.8-4.4-.2-8.2 5-8.2 5s-3.8 3.2-7.8 3.6c-4 .4-1.4 5.4 3 4.4"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          stroke: "#8c1800",
          strokeWidth: 2.5,
          d: "M432.2 359.3s-9 5.2-7.8 6.5c1.3 1.3 9.3-5 9.5-5 .1-.2 3.4-4.2-1.7-1.5z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M400.7 383s-2.7-1 4.2-3.6c7-2.7 6.5-5.8 8.8-7.1 2.2-1.3 7-4.7 8-2.7s-5 6-6.5 6.4c-1.4.4-8.3 6.8-10.3 7.3-2 .6-3.4.3-4.2-.3"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 3,
          d: "M445.6 346c-6 6.7-6 6.5-6 6.5"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 2.8,
          d: "m454.5 335.2-5.7 6.9"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 2.5,
          d: "m463.4 321-6.4 10.2"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 2.3,
          d: "m470.9 306.6-5.3 10.5m8.6-18-1.6 3.6"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.4,
          d: "m478 289-1.4 4.4"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#f7df73",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M160.3 216s52-14.7 67.6-78.5c-9.1 65.5-66 86.2-66 86.2z",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M250.7 394.4c-2.7 0-9.2-7.5-13-8.3-3.8-.9-4.2-4.8.1-5 4.4 0 8.1 5.1 8.1 5.1s3.8 3.3 7.7 3.8c4 .4 1.4 5.4-2.9 4.4"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          stroke: "#8c1800",
          strokeWidth: 1.5,
          d: "M195.5 197.6s-5.4 3.2-4.6 4c.7.7 5.5-3 5.6-3.1.1-.1 2-2.5-1-.9z",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M232.4 380.6s2.6-1-4.2-3.7-6.5-6-8.7-7.2c-2.2-1.3-7-4.7-8-2.7s5 6 6.5 6.4c1.4.5 8.2 7 10.2 7.5 2 .6 3.3.3 4.2-.3"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.8,
          d: "m203.5 189.7-3.5 3.9",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.7,
          d: "m208.9 183.2-3.4 4.1",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "m214.2 174.7-3.8 6.1",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.4,
          d: "m218.7 166.1-3.2 6.3m5.2-10.9-1 2.2",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 0.8,
          d: "m223 155.5-.9 2.7",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M490.4 239.3c.5 6.7 7 13 4.4 24.7-3.2 13.3-14.8 44.7-12.8 50.2-3.4-4.7-2.8-9-3-15.6-.4-6.5 9.4-30.9 10.3-39.1 0-7.4.7-17.5 1.1-20.2z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M490.4 239.4s10.7 13.5 10.1 24.2c-.5 10.7-6.5 23.2-4.5 28.7a21.7 21.7 0 0 1-4.6-14.2c-.3-6.5 5.3-13.8 4.1-20.9-1.1-7-5.2-17.8-5-17.8zm-349.3 3c-.4 6.7-5.4 12.7-2.8 24.3 3.2 13.3 15 30 13 49.2 3.5-4.7 4.5-10 4.8-16.5.2-6.5-13-28.5-13.8-36.8 0-7.4-.8-17.5-1.2-20.2z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M141.1 242.6s-10.4 13-9.8 23.7c.1 7.1 13.2 36.8 11.2 42.4 3.5-4.7 4.4-4.1 4.3-11.2-3.8-18.3-10.7-29.9-9.5-37 1.1-7.1 4-18 3.8-18z"
        }),
        /* @__PURE__ */ jsx167("path", {
          fill: "#fff",
          stroke: "#000",
          strokeDashoffset: 1,
          strokeLinecap: "square",
          strokeLinejoin: "round",
          strokeWidth: 1.7,
          d: "m100 125.8 22 68.2h72l-58 42.2 22.1 68.2-58-42.1-58 42.1 22-68.2L6 194h71.8z",
          transform: "matrix(1.16516 0 0 1.16534 202 -23.6)"
        })
      ]
    })
  ]
});
var Mp_default = SvgMp;

// src/country-flag-icons/generated/Mq.tsx
import { jsx as jsx168, jsxs as jsxs161 } from "react/jsx-runtime";
var SvgMq = (props) => /* @__PURE__ */ jsxs161("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx168("path", {
      fill: "#231f1e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "#00a650",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "#ef1923",
      d: "m0 0 320 240L0 480z"
    })
  ]
});
var Mq_default = SvgMq;

// src/country-flag-icons/generated/Mr.tsx
import { jsx as jsx169, jsxs as jsxs162 } from "react/jsx-runtime";
var SvgMr = (props) => /* @__PURE__ */ jsxs162("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx169("path", {
      fill: "#cd2a3e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx169("path", {
      fill: "#006233",
      d: "M0 72h640v336H0z"
    }),
    /* @__PURE__ */ jsx169("path", {
      fill: "#ffc400",
      d: "M470 154.6a150 150 0 0 1-300 0 154.9 154.9 0 0 0-5 39.2 155 155 0 1 0 310 0 154.4 154.4 0 0 0-5-39.2",
      className: "mr_svg__mr-st1"
    }),
    /* @__PURE__ */ jsx169("path", {
      fill: "#ffc400",
      d: "m320 93.8-13.5 41.5H263l35.3 25.6-13.5 41.4 35.3-25.6 35.3 25.6-13.5-41.4 35.3-25.6h-43.6z"
    })
  ]
});
var Mr_default = SvgMr;

// src/country-flag-icons/generated/Ms.tsx
import { jsx as jsx170, jsxs as jsxs163 } from "react/jsx-runtime";
var SvgMs = (props) => /* @__PURE__ */ jsxs163("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx170("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      d: "M384.9 111h205.5l-.3 146.3c1.7 58.7-34.9 95.2-102.3 111.7-47.9-12-103-36.5-103.2-110z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#00a2bd",
      stroke: "#000",
      strokeWidth: 1.8,
      d: "M389.4 115.4h196.4l-.2 140.2c1.6 56.3-33.4 91.2-97.8 107-45.8-11.4-98.5-35-98.6-105.4z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#a53d08",
      d: "M584.3 272.2c-7.2 53.7-48.6 77.2-96.5 89.7-42.5-11.4-88.2-29.6-97-89.5z"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "m480 141.5-.3-17.6 14 .1.1 17.5H532l.1 13.7-38.3.2-.3 161.4-13.6.1-.2-161.7-38 .2v-14z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#ff9a08",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.8,
      d: "m449 278.8 35 36.3c12.1-13.3 3.7-63-12.2-72.1-1.9 5.9-5.1 13-8.6 15.2-7.5 5.2-26.1 11.2-19.9 15 1.4-1.9 5.1-3.7 6.9.6 2 6.9-7.8 7.3-7.8 7.3s-6.2-.8-7.3-7c-1-6.4 9.3-12.2 10.2-12.6.8-.3 14.3-4 16.6-15.9 2.9-11.8 5.8-10 6.3-10.2 17.7 1.7 29.2 33.3 29.9 55.5.6 22.2-9 37-10.8 38-1.7.9-42-47.9-42-47.9z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#ff9a08",
      stroke: "#000",
      strokeWidth: 0.8,
      d: "m474.6 245 .2 65.5m-4.2-64.2.3 59.4m-4.5-50.8.2 47.2m-3.7-43.9.2 39.1m-3.9-37.3v33m-4-30.4v26.1m-3.5-24v20"
    }),
    /* @__PURE__ */ jsxs163("g", {
      fill: "none",
      stroke: "#ffdf00",
      strokeLinecap: "round",
      strokeWidth: 1.8,
      children: [
        /* @__PURE__ */ jsx170("path", {
          strokeWidth: 0.8,
          d: "m448.5 283 36 41.2"
        }),
        /* @__PURE__ */ jsx170("path", {
          strokeWidth: 1.4,
          d: "M486.3 257s16.4 35.7 1.2 65m-43.2-46.6s1.2-3.1 2.7-1.8m-5.5-7.3s-6.6 5.7-3 9.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#008021",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M494 175.4c2.3-2 3.6-3.3 5.1-3 1.5.2 3.5 0 5-.4a31 31 0 0 1 12-.4c1 .2 2.5.7 4.6 2.5 2.1 1.8 5.2 5 4.2 13.6s-.7 12.3-1.2 17.2c-.8 8.5-2.7 15.5-6 15 4.5 8 5 15 8 20.5s4.8 16.8 3.7 29c-1.2 12.3-4.4 39.7 5.3 58.2-1.6 1.1-5.5 0-9-3.7s-5-3.6-7.8-1.4c-8.8 6.7-17 14.8-29.1 6.7-2.8-1.8-3.6-4-1.6-9.7 5-14 7.5-33.4 6.7-42.4z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#ffe1cf",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M502.3 166.8a9.6 9.6 0 0 1-.1 6.8 9 9 0 0 0 .5 8.4c2.7-4 6.6-3.2 9-5.4 2.2-2.3 2.7-4.5 4.4-5-1.7-1.5-4.3-3.2-3.8-7.5.6-4.4 6.7-8 1.2-14.6a8 8 0 0 0-13.4 1.2c-.3.8.2 2.4-.7 3.4a8 8 0 0 1-2.1 2c-.5.4-.8.9-.2 1.6.2.3.6.3 1 .4l-.8 1.5c-.3.3-.2.6.2 1-.5 1.3.4 1.5-.2 2.5-.6.9-1.2 2 .6 3 .6.3 3 .8 4.4.7zm-22.5 23c-3.2.8-8.4-.6-12.3-.2-1.8.2-3.2-.7-3-2.4.3-1.7.6-4.4.2-6.8a31.6 31.6 0 0 1 3.8-14.8 33 33 0 0 0 3.8-11.6c0-1.9.2-3.9 1.8-5 1.2-.7 1.4-1.4 1.8-2 1-1.5 2-1.8 2-1 .1.5 0 1-.5 1.6 1-.8 2.8-1.8 3.2-2 .4-.4 2.4-1.8 2.5-.4.8-.4 1.4-.4 1.6 0 .2.5 0 .7-.3 1 .6 0 1.2.9 0 1.8.7-.2 1.3.8.2 1.7-1 1-2.4 1.6-2.7 2.4-.4.8-3.2 2.9-4.3 3.3-1.1.5-1.2 1.1-1.2 2.7 0 17.8-2 16.3-2 20.7 0 1-.3 2.1.8 1.8a15 15 0 0 1 4.6-.9v10zm.7 38.2c5.2-2.6 11.2-3.6 14.3-4.4a62.4 62.4 0 0 0 10.4-4.4c2.5-1.3 4.5-3 5.9-3.5a6.5 6.5 0 0 0 3.8-3.2 50.4 50.4 0 0 0 6.9-21.8c0-4-1-8.6-5-5.4a29.6 29.6 0 0 0-8.8 13.2c-1.6 6.4-3 7.9-3.3 9.1-.4 1.3-1.6 1.3-3.2 1.6a26.7 26.7 0 0 0-13.6 6.4 136 136 0 0 1-14.2 9.2c-3.7 2.1-4.4 2.3-5.2 4-.8 1.6-1.6 3-2.2 3.6-.8.8-1 1.6-.8 2.6.1.8-.2 4.2-.3 5.4 0 1.2.3 1.4.7 1.5.4 0 1-.2 1.3-1.6-.2 1.4 1.7 1 1.8-.1 0 1.5 2 .6 2-.8 0 1 1.7.3 1.7 0 .4-1.3.7-2.5 1.2-3.4.6-1.4 1.3-3.2 2.7-4 1.5-1.2.8-2.4 3.9-4zm37.4 94.5c.3 1.3 1 2.7 1.2 3.6.2.8-.2 1.1-.4 1.6a32.8 32.8 0 0 0-2.8 8.8c0 1.2-1 2.4-1.3 3.2-.5.8-.3 1.5.8 2.3.4.3 2-.2 2.1-1 .7.6 1.6.4 2.1-.5.6.5 1.5.2 2-.7.5.3 1.3-.3 1.6-.8.8.4 1.6 0 1.6-1.6 0-.4.3-1 .5-1.3.2-.4.3-1.1.3-1.7 0-.7.3-2 .9-2.8.6-1 1.5-2.5 1.1-4-.4-1.4-1-1.3-1.5-3.2-1.3-1.4-3-3.2-4.8-3.4-1.8 0-2.8 1.1-3.4 1.5zm-32.9 9.9c1.7 1.6 5.3 1.6 7.8-1-.9-.4-3-1.4-3.8-2a12.4 12.4 0 0 1-4 3z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#870f00",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M501.4 149c.6-4 3.5-4 5.3-3.5.8.1 2.6.3 4.4-.2 3.4-.9 6 .3 5.6 3.6 1 .7 2 2.3 1.7 3.7-.1 1.4.2 2 1.4 2.1 1.3.2 4 1.8 2.2 4 1.7 1 3 3.7 2.1 5.4-.9 1.8-3.6 2.1-4.8.5-1.3.6-3.3.7-4.6-.6-.9 1-3 .9-3.5 0-.4-1-1-1.4-1.9-1.7-.9-.3-1-2.8.4-3.1-.1-.8 0-1.6.3-2 .3-.4 0-1.2-.8-1.8-.8-.7-1.5-3-.7-4.4-1.4.5-4.4-.9-5-1.8-.7-1-1.6-1-2.1-.2z"
    }),
    /* @__PURE__ */ jsxs163("g", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      children: [
        /* @__PURE__ */ jsx170("path", {
          d: "M502.3 166.8c2.2-.3 3-1.6 4.6-1.6m-9.4-4.7.5.3c.4.3 1 .4 1.4.4m-1.3-3.1 1 .6m4.2-9.7c-1.3-1.3 2.2-3.8 6-.2.8.8 2.5.8 3 .6m-3.8 1.6c1.8-.4 4.3-.4 5.1 1.6.8 2 2.3.6 3.5 3 1.2 2.3 3 4.8 5 3m-7.4 5.4a4 4 0 0 1-.4-3.2c-.7-.8-.4-2.5 0-3.3m-4.6 1.7c0 .7 1 2 2.4 2.2m7.2 3.2c-.8-1-.7-2-.5-3.2"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M510.9 153c0 1.1.6 2.5 1.6 3 .3.6 1.4 2.2 3.8 2m.4-9a10.9 10.9 0 0 0-5.2-2.6m-8.8 35.6c-2 2.7-3.2 6.4-2.4 11.6 1 5.2 2.4 12.8-1.3 16.2m18.6 10.1c-2.6-.7-6.4-.7-8.5.9-2 1.5-5.6 1.6-7.9.4"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M512 219.6c-2.3.4-3.3 2.1-3.3 6.4 0 4.2-1 10.4-.2 16.6m-.6-21.1c-1.6.4-3.2.4-2.8 4.5m-5.1 0c.1-2.4 1-4.8 2.6-4.3m14.1 4.9c0-5.6-1.2-7.1-2.8-7 2.2 0 3.7.3 4.7 9.2.6 6.8 2 9 3.7 14.4 4.1 13.6 2 34.5 4.1 42m-12.9-57a71.4 71.4 0 0 1-.4 49.3c4.8 13.4 9.6 23.1 10.5 28.6m-23.9-48c.8-2.9-2.2-3.2.4-13.3 1.1-4.4 1.3-7 .6-8.4"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M500.7 242.4c-1 4.4 3.3 12.8 1.2 19m-5.5 1.1c0 4 .9 9 .7 13-.2 3.9 1.4 5.7 3.2 9.4 6.8 13.4 11.2 22.9 10.7 35.5-.2 2.4.6 7.2-1.8 8.6m-12.6 3.4c.7 0 1.4-.4 2.3-2.4a64.8 64.8 0 0 0 2.4-23m1.4 9.6c.4 2.6.4 8-1.3 12.4"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M507.1 308.7c1 5.6 1 10.7.1 14.3m-2.4 0c.2 2.2 1.2 8-.5 8.5m9.2-35.3c4.3 6.7 7.6 23.2 11.2 26.6m-7.6-2.6c0-1.8-.1-4.4-1.2-5.6M471 239.4c.1-1.2-.1-2.4 1.3-4.4m-3.3 5.2c.2-4.4.1-4.8 1.4-6m-3.2 6.1c0-3.2-.3-4.3 1-6.3m14.9-88.8-4.5 3.4m5.8-2.4c-.5 0-2.1 1.4-5 3.6m5.1-1.8c-1 .4-2.6 2-4.2 3.2m-2.9-3.5-1.6 1.6M517.5 341c-.2-.2-.2-1.3.3-2.4m1.9 1.9c-.4-.3 0-1.7.2-2.6m1.7 1.9c-.4-.2-.5-1 0-2m1.5 1.2c-.2 0-.3-.6.1-1.8"
        })
      ]
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "M500.5 152.7c.8 1 1.7 1 1.8 1.6.2.8.3.8.4 1 .2.2-.4.2-.6 0h-1.4c-.4 0-.8-.5-.6-.5.3-.1.3-.2.2-.4 0-.3.2-.6.4-.7l-.1-.3c-.2-.3-.3-1-.1-.8zm.5-1.1a6.4 6.4 0 0 1 3.4 1.6c.7.8.1.6-.2.6s-1-.2-1.4-.6a4.6 4.6 0 0 0-1.9-1.2c-.3 0-.6-.4 0-.4z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Ms_default = SvgMs;

// src/country-flag-icons/generated/Mt.tsx
import { jsx as jsx171, jsxs as jsxs164 } from "react/jsx-runtime";
var SvgMt = (props) => /* @__PURE__ */ jsxs164("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx171("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx171("path", {
      fill: "#cf142b",
      d: "M320 0h320v480H320Z"
    }),
    /* @__PURE__ */ jsxs164("g", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 96,
      transform: "translate(161.8 160.6) scale(.0147)",
      children: [
        /* @__PURE__ */ jsx171("path", {
          fill: "none",
          stroke: "#cf142b",
          strokeWidth: 512,
          d: "M-2048-7168h4096v3890.8A1094 964 45 0 1 3277.2-2048H7168v4096H3277.2A964 1094 45 0 1 2048 3277.2V7168h-4096V3277.2A1094 964 45 0 1-3277.2 2048H-7168v-4096h3890.8A964 1094 45 0 1-2048-3277.2Z"
        }),
        /* @__PURE__ */ jsx171("path", {
          stroke: "none",
          d: "M2024-3275.2A1094 964 45 0 1 3275.2-2024v4048A964 1094 45 0 1 2024 3275.2h-4048A1094 964 45 0 1-3275.2 2024v-4048A964 1094 45 0 1-2024-3275.2Z"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 48,
          d: "M-2024-7144h4048V7144h-4048zm-5120 5120H7144v4048H-7144Z"
        }),
        /* @__PURE__ */ jsx171("path", {
          d: "M-1792-6912h3584V6912h-3584zm-5120 5120H6912v3584H-6912Z"
        }),
        /* @__PURE__ */ jsx171("circle", {
          r: 3200
        }),
        /* @__PURE__ */ jsx171("circle", {
          r: 2368
        }),
        /* @__PURE__ */ jsxs164("g", {
          id: "mt_svg__a",
          strokeLinejoin: "round",
          strokeWidth: 48,
          children: [
            /* @__PURE__ */ jsx171("path", {
              d: "M3084-2565c-111 85-322 302-450 461l-119-74c163-141 389-350 514-499zm-101-185c-201 59-585 172-749 276l-36-52c69-99 147-506 144-622l125 28c-41 100-81 314-92 453 129-23 435-123 522-186z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M3240.8-2291.9h-158.6a600 330 45 1 0-242.3 173.3l112.1-133.7 138.1 138.1-154.5 154.4a1070 940 45 0 1-974.1-1283 1070 940 45 0 1 1279.3 950.9z"
            })
          ]
        }),
        /* @__PURE__ */ jsx171("use", {
          xlinkHref: "#mt_svg__a",
          transform: "rotate(90)"
        }),
        /* @__PURE__ */ jsx171("use", {
          xlinkHref: "#mt_svg__a",
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsx171("use", {
          xlinkHref: "#mt_svg__a",
          transform: "rotate(-90)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs164("g", {
      transform: "translate(161.8 160.6) scale(.0147)",
      children: [
        /* @__PURE__ */ jsx171("path", {
          d: "M-2541 1790c-72-126-167-287-219-329 32-22 75-54 97-60-1 80 120 246 120 246l178-117c-50-77-94-136-130-159 44-32 91-59 104-62 1 39 24 104 92 184 0 0 166-88 220-156l70 114c-78 15-428 233-532 339m-247-1517c-187 34-282 193-250 372 32 181 194 305 372 275 178-31 279-195 245-385s-180-296-367-262m27 108c150-27 276 46 297 162s-72 231-223 258-271-69-288-166c-18-99 63-227 214-254m366-1100c-62 98-199 188-320 271-17-86-81-141-155-146-79-4-160 59-174 101-20 58-45 307-45 307 156-12 497 15 614 58l14-132c-77 20-251-16-251-16l4-58 180-142c23-18 158-144 162-234 1-28-23-21-29-9m-361 441c-71 2-219-6-260-24 16-143 60-194 136-187 70 7 144 47 124 211m682-1772c-136 11-306 139-302 249 1 58 21 138 98 196 76 58 155 75 218 63 61-11 162-96 161-143 0-46-108-174-176-174l113-121c29 70 145 172 188 185-49 117-110 239-238 298-128 60-261 57-382-57-114-108-70-316 2-397 79-89 226-127 229-196zm638-673 24 454s9 161-28 261l141-99c-55-44-44-179-44-179l228-122s108 69 97 153l194-79c-113-43-253-142-253-142zm73 141 208 138-203 109zm1018-474c-26 111 2 330 43 512 141-13 249-27 297-87l13 150c-139 0-292 16-432 38 2-205-19-474-77-590zm1059 67c-65 94-119 308-147 492 136 40 242 66 309 27l-43 145c-129-50-278-92-416-123 76-189 155-448 144-576zm1071 485-396 225s-140 81-246 93l151 80c15-68 141-119 141-119l212 149s-14 129-94 156l157 138c-11-120 14-291 14-291zm-94 128-31 249-189-133zm304 932-62-117c102-8 409-188 550-280l22 40-132 603c118-47 305-145 356-199l70 133c-131-19-374 101-558 213l-18-32 113-587s-305 138-341 226m930 872c-12-89-14-150-57-170l-5-37 109-18c45 117 96 443 89 527l-112 18-5-31c37-42 0-196 0-196-166 17-455 64-496 121l-26-154c59 20 350-11 503-60M2388 752c62-98 201-187 322-269 17 86 80 142 155 146 79 5 160-56 174-99 21-58 47-306 47-306-156 10-496-19-613-63l-15 132c77-19 251 17 251 17l-4 58-181 141c-24 18-160 143-165 233-1 28 23 20 29 10m365-439c71-1 219 8 260 26-17 143-62 194-138 186-70-8-143-48-122-212m-566 836-93 160c72-11 172 46 253 99 27 72 133 256 125 436l120-206c-53-24-115-50-155-243 158-59 276-78 326-50l106-180c-123 74-412 150-460 134-50-29-192-73-222-150"
        }),
        /* @__PURE__ */ jsx171("circle", {
          cx: 1475,
          cy: 2361,
          r: 125
        }),
        /* @__PURE__ */ jsx171("circle", {
          cx: -1475,
          cy: 2361,
          r: 125
        })
      ]
    }),
    /* @__PURE__ */ jsxs164("g", {
      transform: "translate(161.8 201.5) scale(.0147)",
      children: [
        /* @__PURE__ */ jsx171("path", {
          d: "M195 268c-13 9-48-9-56-37 0 9-2 37-19 53-41 39-85 20-120 20s-79 19-120-20c-17-16-19-44-19-53-8 28-43 46-56 37-12-9-6-48 18-64-8 2-36 9-56-2-50-27-45-75-56-108s-43-69-18-120c10-21 36-32 44-35-29 1-56-27-52-41 5-15 44-21 67-3-6-7-20-31-16-54 10-56 57-66 85-87 29-21 53-62 109-54 23 3 41 24 47 31-10-27 8-62 23-62s33 35 23 62c6-7 24-28 47-31 56-8 80 33 109 54 28 21 75 31 85 87 4 23-10 47-16 54 23-18 62-12 67 3 4 14-23 42-52 41 8 3 34 14 44 35 25 51-7 87-18 120s-6 81-56 108c-20 11-48 4-56 2 24 16 30 55 18 64M-93 128c16 12-27 48-10 93 19 53 72 37 103 37s84 16 103-37c17-45-26-81-10-93s38 40 85 39c57-3 58-57 67-87 10-30 42-75-3-110-37-30-86 0-92-19s50-23 64-69c15-55-37-72-62-91-26-18-59-62-106-31-39 27-26 82-46 82s-7-55-46-82c-47-31-80 13-106 31-25 19-77 36-62 91 14 46 70 50 64 69s-55-11-92 19c-45 35-13 80-3 110 9 30 10 84 67 87 47 1 69-51 85-39"
        }),
        /* @__PURE__ */ jsx171("path", {
          d: "M0 199c-9 0-20-21-14-38-3 5-14 17-28 19-34 5-48-20-65-32-17-13-45-19-51-52-3-14 6-29 9-33-14 11-37 7-40-2-3-8 14-25 31-25-5-1-20-8-26-20-15-31 4-52 11-72 6-20 3-49 33-65 12-7 29-3 34-1-15-10-18-33-11-39 8-5 29 6 34 22 0-5 1-22 11-31 25-24 51-12 72-12s47-12 72 12c10 9 11 26 11 31 5-16 26-27 34-22 7 6 4 29-11 39 5-2 22-6 34 1 30 16 27 45 33 65 7 20 26 41 11 72-6 12-21 19-26 20 17 0 34 17 31 25-3 9-26 13-40 2 3 4 12 19 9 33-6 33-34 39-51 52-17 12-31 37-65 32-14-2-25-14-28-19 6 17-5 38-14 38M0 85c11 0 4 30 25 44 25 17 43-6 57-16s42-20 33-49c-7-25-37-27-34-38 3-10 29 6 50-10 24-19 7-43 2-59-6-16-6-46-37-47-26-1-37 27-46 21s15-26 6-50c-11-29-39-20-56-20s-45-9-56 20c-9 24 15 44 6 50s-20-22-46-21c-31 1-31 31-37 47-5 16-22 40 2 59 21 16 47 0 50 10 3 11-27 13-34 38-9 29 19 39 33 49s32 33 57 16c21-14 14-44 25-44"
        }),
        /* @__PURE__ */ jsx171("circle", {
          r: 48
        })
      ]
    }),
    /* @__PURE__ */ jsxs164("g", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 36,
      children: [
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.7,
          d: "M137.9 185.8a588.3 588.3 0 0 1 48 0"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.4,
          d: "m160 143.3 1.3 1.5m2 19.2c-.1 1.2 0 2.5.2 3.2m-3.2-3c.4.5 1 2.3 1 3"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.5,
          d: "M170.2 185.6c-.6.2-1.6.8-1.6 1.3s1.2.6 1.6.7c-.7.2-2.7.6-3.6.2-.6.3-5.2-.7-6.2-.7-.6 0-1.4-.6-1.3-1.7 0-.2.2-.8.7-1-.3-.6 1.1-1.5 2.5-2.4-2 .3-4.7-.5-5.4-1.3-1.6-.6-2.3 0-3 1.4 0 2.4-1.3 3.6-3 3.4-1-.2-1.3.3-1.6.5l3.3 1c2.2 2 1 3.6.5 4-.5.3-1.7.1-2.4.1-.8 0-.8.3-1 .4-.6.3-1.1.4-1.3.2 0-.3.3-1.7 1.2-1.9.5 0 1.5-.3 1.5-.8 0-.4-1.8-.4-3.2-.9-1.1-.4-1.5-1-1.1-2.9.3-2 2.7-2.3 3.9-2.3-.2-.8 0-2.3 1-3.3 1.6-1.5 4-1 6.1-.8 1.2-.7 3.4-1.7 5.6-1.8 2 0 10.6-2.3 14.5-1.8-1-1.3-.7-4.4.9-5.3 2-1.2 4.2 2 4.8 1.4.5-.6-.7-1.4-2.2-3-.4-.6-.3-.6-.3-.8 0-.5 0-1 .3-1.2.2-.1 1.4.3 1.7.8.4.6.9.8 1.3.5.5-.4-.2-.2-.5-1-.1-.5-.5-.9-.4-1.3a7 7 0 0 1 2.3-1.6c.4.4.6.9.9 1.3.7 1.1 1.4.8 1.9 1.6.1.3.1 1 .5 1.7a9.6 9.6 0 0 0 3.5 3.6c.3.2.6.5.6.7 0 .4-.2.8-.4 1-.2.2-1 .2-1.6-.1-1-.5-1.5-.8-2.1-.7-1.4.2-2.3 2.4-4.3 2.4-1.8-.2-3-2.9-4.1-2.1-1.1.8 2.5 3 2 4 .4.2.9 1 .7 1.7a6 6 0 0 0 3.9-2.7c1-1.3 1.7-2 2.2-2.2.6-.3 1.3 0 1.3.5l.9.3c.5.2.3.8.2 1l-.6-.4c-.3 0-.8.3-1.2.6-.4.4-.7 1.2-1.2 1.7l-2 2.2c.3.4.2 1.1.2 1.5.1 0 .5 0 .7.2.2.1.1.3 0 .7 0 .5-2 2.7-2.4 2.6-.8 0-1.4-1-1.3-1.3-.9.4-1.3-.6-1.3-1a7 7 0 0 1-2.2 1.5c-.4.1-.6.2-.8-.4-.1.4-1.3.8-1.6.9-1.5.3-3.1 1-4.6 1l-3.8-.1z"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.3,
          d: "M175.5 171.4c0 .6-.9 2 .4 3.2.8.6 2.1 1.1 2.5 2 .4.7-.1 1.3-.3 1.3-.8-.2-1.9 1.2-2.3 2.2-.4-1.4-1.3-1-2.5-.8.3-1.5-.8-2.4-2.6-2.6.3-.3-.2-.7-.6-1.1-.4-.4-1.8-.1-2-.4 0-.3.7-1 .3-1.5-.4-.7-2-.3-2.6-.5.2-.8.2-1.3-.2-2s-2.2-.5-3.1-.7c.7-.5 1-1.3.6-2.1-.4-1-2.4.1-2.4-1 .1-.5 2.4-.8 3.3-.9.8 0 3.7.7 6.5 1.3.6.6 5 1.9 5 3.6"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.5,
          d: "M182.8 182.6c1.4-.7 2.7-1.6 4.1-2.8m-25.6-1c1.2 0 3.9.4 4.7 1.4.7 1 1.2 2.7-4.1 4 1.6 0 4-.3 4.8-.1.8-.2 2.5-.7 3.2-.5-.3.1-1.2.4-1.2 1 0 .5.4.5 1.1.8m5.1-3.6c1.9.4 4.6-.2 5 1.8"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.4,
          d: "M181.2 166.8c.5.6 2 1.5 2.7 2 1 .8 1.4-.1.7-1.4"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.3,
          d: "M168.1 175.2a30 30 0 0 1 6.1-.7m-8.4-1.3c3-.8 6.2-.5 8.2-.5m-.5 6.4 2.6-2.5m-5.4 0c1-.3 2.6-1 4-1.2m-4.2-7.6c1.6-1.5 3.4-1.3 5.2-2.2 1-.6 2-2 3-3.1.5-.4.9-.8 2-.7 1.4.1 1.5.5-.1.7-1.2.2-1.3.7-1.7 1.6-.4.8 0 1.7.2 2.3a9 9 0 0 0-.8 2.2c0 .3.1.6.5 1.1m-16.3.8c4-.9 10 .7 11.1.7"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.2,
          d: "M187.7 177c1.3-.7 1.3-2 3-2.6m-6.6 9.1c1.7-.8 2-1.5 3-2.2m.9-13.7c-.2 0-.6 0-.8-.3-.2-.3-.3-.7-.1-.8.1-.2.3-.1.7.2s.3.7.2.9m.3 3c-.8.2-1-.5-1.7-.6-.9-.2-1.4.4-1.4.9s.5 1 1 1c.6 0 1-.3 2.1-.2m-3.8-7.2c.6 0 1.3.2 1.7-.2"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.1,
          d: "M162.7 150.7a.4.2 75 0 1-.2-.7.4.2 76 0 1-.2-.7.4.2 77 0 1-.2-.7.4.2 79 0 1-.1-.7.4.2 80 0 1-.2-.7.2.4-8 0 1-.1-.7.2.4-7 0 1-.1-.8.2.4-5 0 1-.1-.7.2.4-3 0 1-.1-.7.2.4-1 0 1 0-.8.2.4 1 0 1-.1-.7.2.4 4 0 1 0-.8.2.4 6 0 1 0-.8.2.4 9 0 1 .1-.7.2.4 12 0 1 .2-.8.2.4 15 0 1 .1-.7.2.4 19 0 1 .2-.8.2.4 23 0 1 .3-.7.2.4 27 0 1 .3-.7.2.4 31 0 1 .3-.7.2.4 35 0 1 .5-.7.2.4 40 0 1 .5-.7.2.4 45 0 1 .5-.6.2.4 49 0 1 .6-.7"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.1,
          d: "m163.6 150.4-.9.3m.7-1-.9.3m.8-1-1 .3m.9-1-1 .3m.9-.9-1.1.2m1-1-1.2.3m1-1-1.1.3m1.1-1-1.2.2m1.2-.8h-1.4m1.4-.7h-1.4m1.4-.7h-1.5m1.5-.7h-1.5m1.6-.7-1.6-.1m1.7-.6-1.6-.2m1.7-.4-1.7-.3m1.9-.4-1.7-.4m1.9-.2-1.8-.5m2-.2-1.8-.6m2 0-1.7-.7m2 .2-1.7-1m2.1.4-1.8-1m2.2.5-1.7-1.2m2.1.7-1.6-1.4m2.1 1-1.6-1.6m2.1 1-1.5-1.7"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.5,
          d: "m173 140.7-2.5.3c-.2.5-.2 1.9-.2 2.4 2.3 2.3 4.6 5.2 4.8 7.9.7.6 1.2 1.2 1.6 2.3 1.7-.9 3.4-2.3 4.8-2.7 1-.2 2.6-.3 3.5.2l5.6 3.4c1.2.8 2 1.7 2.6 2.6.5.8.6 2.3.4 2.7l-3.4-1c-.2-.5 0-1.2.3-1.7.2-.6.2-.6-.3-1-.3-.2-.8-.2-1 0-.4 0-1-.2-1.2-.6-.3-.5-3.9-2-4.5-2.2-.6 0-1.5 0-2.2.6-.4.6-1.6 2.4-2.5 3.3-.2.2-.3.5-.1.8l3.6.1c1.4.2 3 1.6 3.8 2.5 3.5 3.2 4.8 5 5.9 6 .5.5 1 1 1 1.8h-3.4c0-1.3-.2-2.1-.4-2.8-.4-.5-1.1-.3-1.4-.3-.3 0-.7-.5-1-1-.5-1-2.3-2.3-3.1-2.8-.8-.5-1.1-.3-2-.4-.5-.1-1.6-.3-2.5 0-.9.3-3.4 1.1-5.7 1.4-.8.4-3.3.8-6 1.4-2 .4-6.5 1.2-7.4 1.2-.3 2.1-2.6 5.2-3.2 5.5-.7.9-.7 1.7-.2 2 .5.5 3.9.5 4.7.5l2.9.1c.5.1 1.3.8 2.2 1.3.6.3.7.7 1.1 1.3.3.4.7.8.8 1.2h-4c0-1-.5-1.7-1-1.7-.6.4-1.3.9-2.1.6-3.1-.2-5.1 0-8-.3-.9 0-1.6-1.2-1.3-2.3.3-1 .2-1.8 0-2.6-.3.3-1.5 1.4-2.1 2.2-1 1.1-.4 2.3 0 3 .5.5 3.9 3.7 4.3 4.6.3.6 1.7 1.6 3 2.7.4 1 1.2 1.5 1.8 2.1h-5l.2-1.3c0-.3-.3-.9-1-.8-.6 0-1.2-.7-1.4-1.3-.2-.7-2.5-3.6-3.2-4.2l-3-2.9c-.4-.1-.5-.8 0-1.3.4-.4 1.6-2.4 2-3.8.3-.9 0-1-.2-1.2a19.8 19.8 0 0 1-5.4-6 7 7 0 0 1-4-.3c-1-.5-2.2-.6-2.9.4-.4.7-.4 1.8.3 2.3 1 .8 2.1 2 3.3 3.4 1 1.3.1 2.3-1.3 3.5.2.5 0 .4.2 1.3.5.7.5 2.4-.1 2.7-.6.4-1.4.8-2 1.6-.8.9-1 0-.8-1.4.2-.9-.5-1.6-1.1-2.3-.6-.6-.3-2.6 0-3.2.5-.6.8-1.7 0-2.6-.9-.8-2.5-2.6-2.3-5a3.8 3.8 0 0 1 5.2-3.3c3 1.3 4.7 1 5.6.8.8-1.4 2-2.8 3.8-3.8 1.7-1 5-2.3 8.3-2.8l8.1-3c1.1-.2 1-1.2 1-1.8-1-5.5-.8-11.3 3.7-14.2.5-.5.3-1.7 1-2.6l1.3 2.2c2 .7 5.4 1.9 6.8 2.6.6.3 1.3.3 1.7.5.4.2.7.5 1 1 .3.6 0 1.3-.4 1.5-.3.1-1.9-.4-2.3 0 0 .3.5.7 1.4 1 .3.2-.3 1-.7 1-.3 0-.7 0-.9-.3-1-.2-2-.6-3-1"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.5,
          d: "M167.3 137.1c0 3.4 1.1 5.1 3 6.3m6.4 10.2a9.5 9.5 0 0 1 0 4m-24.7 13c2.5-1.1 4.8-4 4.7-5.8 0-1-.9-2.5-3.1-2.6m3 2.6c.8.3 2.3.1 3.5.3m12.6-8.3c2 .1 4.6 1.3 6 1.2m-7 2.8c1.8.4 1.8 1.2 5.3 1m-6-12.2c1.9 0 3 1 4 1.7"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.3,
          d: "M156.3 166.4c1.4 0 2.4-.2 3-1.4m8-27.9c0 2.8 1 3.5 3.2 3.9"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.2,
          d: "M178 137.6c-.1.7-.2 1.3 1 1.2m-6.1-3.1c-.9 2.2 3.6 2.5 3.7 4m-25 14.7c2.2 1 2 5.3 2 7.8"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.2,
          d: "M175.6 139.7c-.7 1.4-2.3 3.5-3.8 4.6-2.4 1.7-5 3-8.1 3.7-.5.1-1 .3-1.6.1-.6 0-1.3-.5-1.7-1.4-.2-.4-.1-2.6.7-2.9a6 6 0 0 1 2.4-.4c.5 0 1 .2 1 .8 0 .5-.5.8-1 .7-.6-.2-1.5-.6-2-.2-.4.2-.7 1.2-.4 1.7.4.7.7.9 1.1 1l1.3-.1c3-.8 5.5-2 7.8-3.6 1.5-1 3-3.4 3.6-4.4zm-12 4.3c-.9-.2-2.4 0-2.5.4.7-.4 1.5-.3 2.5 0 .3 0 .4-.3 0-.4m6-7.5.3-.7c.1-.1-.2-1.7 1.4-.9 1.7 1 .4 1.7.3 1.8l-.4.7"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.4,
          d: "m166.7 135 9.5 5"
        }),
        /* @__PURE__ */ jsxs164("g", {
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx171("path", {
              fill: "#fff",
              d: "M154.7 135.4c-1.6.2-4.7-.2-6.4-.5-.8-.1-3.1 3.2-4.3 3.4-1.2.3-2.4-2.4-4.1-1.8-.9.7 0 4-.5 4.3-.5.5-2-1.6-3-1-1 .8.8 5.1.3 5.6-.4.5-2.6-1.9-3.3-1.4-.7.4.7 7.2 0 7.5-.6.4-3.7-1.8-4-.9-.5 1 4.3 3.1 5.6 3.2l1.3-.5c.4.2 4.2.5 4.6.5l2.1-2.2c3.3-4.3 7-8.3 11.7-8z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m140.2 136.5 6.3-.3m-10.1 3.6 3-1m-6 5 2.9-1.2m-7 8 4-3.6m3 6.2c1.7-3 5-6.2 7.9-7.9m-10.7 6.2c2.4-2.9 9.1-7.6 11.3-8m-5.4-2.7c2.8-1.2 6.8-1.4 10-1.7m-5.5-.8c.4 0 5.2-.6 7.3-.5m-14.5 7.7c3.7-2.2 7.4-4 11.5-5.3"
            })
          ]
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.4,
          d: "M168.2 191.2c.3.1.6.8.6.8s-.6.3-.8.2l-29.5-8.8c-.8-.2-.5-1.6.4-1.3zm-28-41c-.2-.7-.8-1.2-1.2-1.3-.2 0-.9.7-.8.9 0 .4.9 1 1.2 1zm2.7 1-2.5 2.5c-.3.3.3.8.6.5l2.5-2.4c.3-.3-.3-.9-.6-.6m-1.2 2.4 7.7 7.9 1.5.2-.2-1.6-8-7.6z"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.1,
          d: "m149.8 160.6-7.6-7.6"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          strokeWidth: 0.5,
          d: "M160 138.6c0-.5.2-.7.5-1 .5-.3.3-.1.6 0l.8.5c.2.2.3.1.4 0 .1-.2.1-.6.3-.8a.2.2 0 0 0 .2-.2c.2 0 .2-.1.2-.3 0-.1.1-.4.3-.4.2 0 .6.3.6 0l.3-1.6c.6.1.4-.6.6-.6.6.2.9-.8.5-1.2 0-.8.7-1 1.7-1-.1-.5-.9-.7-1.4-1.4-.5-.7-2-1.6-3.8-1.6-1.7 0-3.1 1.6-3.8 2.3-.6.7-2 1-2.3 1-.4-.1-.6-.4-1-.4H153c-.6 0-.8.4-1.5.3-.4 0-2 0-2.5.2-.4.2 0 1.2.5 1.3.2 0 1.5 0 2 .3s2 .4 2.6.1c1.3-.4 2.1.4 3.5.8l.5.1c0 .8 0 1.1-.4 1.1h-1.2l-1.3-.6c-.6-.1-1 .1-1.2.2-1.7.7-7.7 5.4-8.3 6.5-.7 1.2-1.7 1.9-2.6 3.7-.5 1-1.5 2.2-2.1 3.8-1 .5-2.1 1.4-2.3 1.7-.1.2.2.6.4.6 0 .1.3.5.6.5-.2.2.2.5.4.4 0 .2.2.7.5.7l2.4-2.5c0-1 .6-2.2 1-2.8 1.3-1.5 3-4.2 3.4-4.9.3-.4 3.2-1.5 4-2.2-.3 2-.2 3.4 0 4.6.5 2 1.1 3.3 1.5 5 .4 1.7 0 2.7 0 3.5.1.6.3.7 1 1 .5.4 2.9 0 3.6.3 1.4.4 2.6.5 3.1.6a5 5 0 0 1 3.5.6c.6.5 1.7 3 2.1 4 .4.9 2.6 2.1 3 2.7.5.5.9 2 .8 2.7 0 .6 0 .9.7.8.5 0 2.5.3 2.8.5.4.2 1.2.9 1.5.9.3 0 1.7.2 2.4.1s.6-1.1.3-1.2a30 30 0 0 1-2-.4 8.2 8.2 0 0 1-2.7-2.1c-.6-.7-.9-1.7-1.3-2.5a58 58 0 0 0-3.1-4.5c-.2-.3-1.4-3-1.6-3.8-.3-.7-.8-.7-1.3-.9-1.8-.5-2.5-.7-4.4-1-1.3-.3-1.6-.4-1.8-1.4 0-.8-.6-2.2-.3-3.2l.4-1.8c0-.5.4-1.3.4-1.7l.2-3zm1.4 8.2c-.2 0-1 .2-1.5 0-.1 0 0-.4 0-.4s-.2-.3 0-.4c0 0-.2-.4 0-.4-.2-.2-.2-.4 0-.5.1-.1 1-.2 1.4-.1.3.5.2 1.3.1 1.8"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.5,
          d: "M158.1 135.1c.4.3.4 0 1.1-.2.8-.3 1.3.4 1 1-.2.6-.2 1.2.6 1.2s1-.7 1.2-1c.2-.3.5-.3.7-.7.2-.8 1-.6 1.5-.5m1-1.9c-.3.2-1.2-.5-1.4-1.1-.2-.8-.8-1.4-1.8-1.4s-3 .6-3.3 1.7a43 43 0 0 0-.3 1.7c-.3.1-.7 0-.7.2l-.1.8m-6.3 6.3 2-1"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.3,
          d: "M153.4 140.3c.5 1.3 1 2.6 1.7 3m1.1.5c.9.5 1.5.3 2.5.2m-5.1 9.5c2.1 0 3 1 4.7 1.6 1.8.5 4.2.2 6.5 1.3m-11.9-9.7c.6.4 1.3.6 2 .6m.9 0c1.1.3 2.1.7 2.3 1.4m-2.8 1.1c1 1 3 1.8 4.2 1.8"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.2,
          d: "M157 136c.9 3.2 1 4.4 3.2 5m-4.1-5.1c1 3.1 2 4.8 4.1 5m-5-5.4c1 3.1 2.4 5.3 5 5.4m11.6 24.8c-.5-.4-.6-.6-1-1.3l-.7-1.6-.5.3c-.3.1-.5-.3-.2-.4l.4-.2-.6-1.2c-.3 0 0-.2.2-.3.3-.1.6-.3.4 0l.6 1.2.4-.2c.3-.2.5.3.2.4l-.5.2.8 1.6c.4.7.5.9.5 1.5m-.1-3.4-2.4 1.3m-2.2-1.8 3.2-1.6m-3.7 1 3.3-1.6"
        }),
        /* @__PURE__ */ jsx171("path", {
          strokeWidth: 0.1,
          d: "m140.1 153 1.1-1m-1.5.5 1-1m-1.6.5 1.1-1m19.8-4.6h1m-1.1-.8h1m-1 .4h1m1.3-9.2.6.3"
        })
      ]
    })
  ]
});
var Mt_default = SvgMt;

// src/country-flag-icons/generated/Mu.tsx
import { jsx as jsx172, jsxs as jsxs165 } from "react/jsx-runtime";
var SvgMu = (props) => /* @__PURE__ */ jsx172("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs165("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx172("path", {
        fill: "#00a04d",
        d: "M0 360h640v120H0z"
      }),
      /* @__PURE__ */ jsx172("path", {
        fill: "#151f6d",
        d: "M0 120h640v120H0z"
      }),
      /* @__PURE__ */ jsx172("path", {
        fill: "#ee2737",
        d: "M0 0h640v120H0z"
      }),
      /* @__PURE__ */ jsx172("path", {
        fill: "#ffcd00",
        d: "M0 240h640v120H0z"
      })
    ]
  })
});
var Mu_default = SvgMu;

// src/country-flag-icons/generated/Mv.tsx
import { jsx as jsx173, jsxs as jsxs166 } from "react/jsx-runtime";
var SvgMv = (props) => /* @__PURE__ */ jsxs166("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx173("path", {
      fill: "#d21034",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx173("path", {
      fill: "#007e3a",
      d: "M120 120h400v240H120z"
    }),
    /* @__PURE__ */ jsx173("circle", {
      cx: 350,
      cy: 240,
      r: 80,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx173("circle", {
      cx: 380,
      cy: 240,
      r: 80,
      fill: "#007e3a"
    })
  ]
});
var Mv_default = SvgMv;

// src/country-flag-icons/generated/Mw.tsx
import { jsx as jsx174, jsxs as jsxs167 } from "react/jsx-runtime";
var SvgMw = (props) => /* @__PURE__ */ jsx174("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs167("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx174("path", {
        fill: "#f41408",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx174("path", {
        fill: "#21873b",
        d: "M0 320h640v160H0z"
      }),
      /* @__PURE__ */ jsx174("path", {
        fill: "#000001",
        d: "M0 0h640v160H0z"
      }),
      /* @__PURE__ */ jsx174("path", {
        fill: "#f31509",
        d: "M220.5 141c22.3-49.2 84.5-72.8 138.8-52.5a98.4 98.4 0 0 1 58 52.5zm-26 6.4a332.3 332.3 0 0 1-52.4-7.8c-4.1-1.3-4.3-3.6-3.8-5.3.5-1.7 3.1-3.6 6.2-3 5.6 1.4 28.8 7 50 16.1m124.6-85.9c-4.2-21-5.2-44-4.8-48C314.7 9.6 317 9 319 9s4.7 1.8 4.7 4.7c0 5.3-.1 27-4.6 48zm11.6.5a249 249 0 0 1-.3-48.2c.8-3.9 3.2-4.4 5.1-4.2 2 .1 4.5 2.1 4.2 5-.5 5.3-2.6 26.9-9 47.4m10.4 1.3c-.2-21.3 3-44.3 4.1-48 1.1-3.9 3.6-4.2 5.5-3.9 2 .3 4.3 2.5 3.8 5.3-1 5.3-5.2 26.6-13.4 46.6m11 2.2c1.8-21.2 7.3-43.8 8.8-47.5 1.5-3.7 4-3.8 5.8-3.4 2 .5 4 2.8 3.3 5.6-1.6 5.1-7.7 26-17.8 45.3zm10.9 3.2c3.9-21 11.5-43.1 13.3-46.7 1.9-3.5 4.3-3.5 6.2-2.9 1.8.6 3.7 3.2 2.7 5.8A264 264 0 0 1 363 68.7m10.1 3.8c5.8-20.7 15.5-42 17.7-45.5 2.2-3.4 4.6-3.1 6.4-2.3 1.8.7 3.4 3.4 2.1 6-2.5 4.8-12.5 24.4-26.2 41.8m10 4.7a262.9 262.9 0 0 1 22-43.9c2.4-3.2 4.9-2.7 6.6-1.8a4.4 4.4 0 0 1 1.5 6.1c-3 4.6-14.9 23.4-30.1 39.6m9.4 5.5c9.7-19.4 23.3-39 26.1-42 2.8-3 5.2-2.3 6.8-1.3a4.4 4.4 0 0 1 1 6.2c-3.5 4.4-17.2 22.1-34 37zm8.8 6.2c11.6-18.6 27-37 30.1-39.7 3-2.8 5.4-2 6.9-.8a4.3 4.3 0 0 1 .3 6.2c-3.8 4.1-19.1 20.7-37.3 34.3m8.3 6.9a284 284 0 0 1 33.8-37.2c3.3-2.5 5.5-1.5 6.9-.3a4.3 4.3 0 0 1-.3 6.3c-4.1 3.8-21 19.1-40.4 31.2m7.6 7.5A278.4 278.4 0 0 1 454.4 69c3.6-2.3 5.7-1.1 7 .3 1.2 1.3 1.5 4.4-1 6.2a306 306 0 0 1-43.2 27.8m6.5 7.8A297.1 297.1 0 0 1 464 79.6c3.7-2 5.7-.6 6.8.9 1.2 1.4 1.1 4.5-1.4 6.1-4.8 3-24.3 15.6-45.7 24.5m5.9 8.3a307 307 0 0 1 43-28.1c4-1.7 5.9-.2 6.9 1.3 1 1.6.6 4.6-2 6a320.8 320.8 0 0 1-48 20.8zm5.4 9.6a313.4 313.4 0 0 1 45.8-24.4c4.1-1.4 5.8.3 6.6 1.9.9 1.6.3 4.6-2.6 5.8-5.3 2.2-27 11.4-49.8 16.7m4.2 9.2a320 320 0 0 1 48-20.8c4.2-1 5.7.8 6.4 2.5.6 1.6-.3 4.6-3.2 5.5-5.5 1.9-28 9.3-51.2 12.8m3.4 9.8a324.5 324.5 0 0 1 49.8-16.9c4.2-.6 5.6 1.2 6.1 3 .5 1.7-.7 4.5-3.7 5.3-5.7 1.3-28.8 7-52.2 8.6M307.8 62a252.4 252.4 0 0 1-9.7-47.4c0-3.9 2.3-4.8 4.2-5 2-.1 5 1.5 5.2 4.3.5 5.3 2.6 26.9.4 48.1zm-11 1.3a251 251 0 0 1-14.3-46.4c-.4-4 1.8-5 3.7-5.3 2-.3 5 1 5.6 3.8a263 263 0 0 1 5 47.9m-11 2.2A259 259 0 0 1 267 20.3c-.8-3.9 1.3-5.1 3.2-5.6 1.9-.4 5 .6 5.9 3.4 1.5 5.1 7.7 26 9.6 47.3zm-10.5 3A264 264 0 0 1 252.5 25c-1.1-3.8.8-5.2 2.6-5.8 1.9-.6 5.1.2 6.2 2.8 2 5 10.2 25.4 14 46.4zM265.2 72a270.4 270.4 0 0 1-27-41.5c-1.4-3.7.4-5.3 2.2-6 1.8-.8 5-.2 6.4 2.4 2.5 4.8 12.5 24.5 18.4 45.1m-10.3 5a275.6 275.6 0 0 1-31-39.2c-1.7-3.5-.1-5.2 1.6-6.1 1.7-.9 5-.6 6.6 1.9 3 4.6 15 23.3 22.8 43.4m-9.4 5.4A285.2 285.2 0 0 1 211 45.7c-2.1-3.4-.7-5.2 1-6.3 1.5-1 5-1 6.7 1.4 3.4 4.3 17.1 22 26.8 41.5zm-8.7 6a292.2 292.2 0 0 1-37.9-33.9c-2.4-3.2-1.1-5 .4-6.2a5.5 5.5 0 0 1 6.8.8c3.8 4 19.2 20.7 30.7 39.3m-8.5 7a299 299 0 0 1-41-30.7c-2.8-3-1.7-5-.3-6.3a5.5 5.5 0 0 1 6.9.3c4.2 3.7 21 19 34.4 36.6zm-7.4 7A306.6 306.6 0 0 1 177.2 75c-3-2.8-2.1-4.8-.8-6.2 1.2-1.4 4.5-2.1 6.9-.3a292 292 0 0 1 37.6 34zm-7 8.2a313 313 0 0 1-46.2-23.8c-3.3-2.5-2.6-4.7-1.5-6.1 1.1-1.5 4.3-2.5 6.9-.9 4.8 3.1 24.3 15.5 40.8 30.8m-6.3 8.8c-22.2-7-44.9-17.6-48.4-19.9-3.6-2.2-3-4.4-2.1-6s4-2.8 6.8-1.4c5 2.7 25.8 13.5 43.7 27.3m-5.3 9c-22.8-5.3-46.3-14-50.1-16-3.7-2-3.5-4.2-2.6-5.8.8-1.6 3.7-3.1 6.6-2 5.3 2.3 27 11.4 46.1 23.8m-4.2 9a328.5 328.5 0 0 1-51.4-12.2c-4-1.6-3.8-3.9-3.2-5.5.7-1.7 3.5-3.4 6.4-2.5 5.6 1.9 28 9.3 48.2 20.2"
      }),
      /* @__PURE__ */ jsx174("path", {
        fill: "#f31509",
        d: "M194.5 147.4a332.4 332.4 0 0 1-52.4-7.8c-4.1-1.3-4.3-3.6-3.8-5.3.5-1.7 3.1-3.6 6.2-3 5.6 1.4 28.8 7 50 16.1"
      }),
      /* @__PURE__ */ jsx174("path", {
        d: "M129.4 141.5h381.2v12.6H129.4z"
      })
    ]
  })
});
var Mw_default = SvgMw;

// src/country-flag-icons/generated/Mx.tsx
import { jsx as jsx175, jsxs as jsxs168 } from "react/jsx-runtime";
var SvgMx = (props) => /* @__PURE__ */ jsxs168("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs168("defs", {
      children: [
        /* @__PURE__ */ jsx175("radialGradient", {
          xlinkHref: "#mx_svg__a",
          id: "mx_svg__b",
          cx: 842.3,
          cy: 103.7,
          r: 25.9,
          gradientTransform: "matrix(.14152 .03595 -.03453 .14198 213.1 162.4)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx175("radialGradient", {
          xlinkHref: "#mx_svg__a",
          id: "mx_svg__c",
          cx: 651.5,
          cy: 550.5,
          r: 25.9,
          gradientTransform: "matrix(-.13441 -.05384 .04964 -.12489 397.9 -24.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx175("radialGradient", {
          xlinkHref: "#mx_svg__a",
          id: "mx_svg__d",
          cx: 380.8,
          cy: 740.4,
          r: 25.9,
          gradientTransform: "matrix(.07536 .00282 -.00343 .14804 412.4 -203.6)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs168("linearGradient", {
          id: "mx_svg__a",
          children: [
            /* @__PURE__ */ jsx175("stop", {
              offset: 0,
              stopColor: "#fff"
            }),
            /* @__PURE__ */ jsx175("stop", {
              offset: 1,
              stopColor: "#f15770"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ce1126",
      d: "M426.7 0H640v480H426.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M213.3 0h213.4v480H213.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#006847",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m355.8 289.4.2 4.5 1.7-1.1-1.3-3.7z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 355.6,
      cy: 288.2,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m361.1 296.4-3.2-3.1-1.5 1.2 4.5 2.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M360.9 298.2c-.5-.6-.3-1.5.3-2 .7-.5 1.6-.4 2 .2.5.6.3 1.5-.3 2-.7.5-1.6.4-2-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m386.3 249.6 3.4 3.3.4-1.7-3.1-2z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 385.9,
      cy: 248.7,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "M395.2 251.6 390 253l.5-1.7 4.4-.4z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 396,
      cy: 250.8,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m378 276.8-3.2-4.8.5-.3 3.5 4.2z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 374.5,
      cy: 270.8,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m378.1 277 4 .7.1-.5-3.3-1.4z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 383.3,
      cy: 277.7,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M284.6 288c0 .8-.5 1.2-1 1.2s-1-.5-1-1.2.5-1.3 1-1.3 1 .7 1 1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m284.6 290.3 1 5-1.3-.5-.4-4.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M285.7 288.6c.6.7-.4 1.9-1.4 2.2-1 .3-2.4-.2-2.4-1.2s1.6-.5 2-.6c.6-.2 1.2-1.2 1.8-.4z"
    }),
    /* @__PURE__ */ jsx175("ellipse", {
      cx: 277,
      cy: 296.3,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      rx: 1.6,
      ry: 1.1
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m279.6 296 4.8-.2-.8-1-4 .4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M280 295.4c.5 1.3.5 3-.9 2.7-1.4-.1-1-1.4-1.2-1.8-.2-.9-1-1.7-.2-2.5s2 .4 2.3 1.6z"
    }),
    /* @__PURE__ */ jsx175("ellipse", {
      cx: 264.4,
      cy: 269.2,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      rx: 0.9,
      ry: 1.4
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m264.4 272.4.1 4.6-1.2-1v-3.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M266.2 271c.3 1-1.3 1.6-2.4 1.4-1-.2-1.9-.7-1.7-1.7.1-1 1.5-.8 2-.5.4.3 1.8-.8 2.1.7z"
    }),
    /* @__PURE__ */ jsx175("ellipse", {
      cx: 256.2,
      cy: 276.5,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      rx: 1.6,
      ry: 0.7
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m259.1 276.5 3.6-.3 1.6 1.2-5.3-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M257.8 274.5c1 0 1.6 1.1 1.5 2.3-.2 1.1-1 2-2 2-.9-.2-.8-1-.8-1.2 0-.3.5-.7.6-1 0-.4-.3-1.3-.1-1.6 0-.4.3-.5.8-.5zm-3-28.3c-.4.6-1.2 1.1-1.6.9-.4-.3-.2-1.2.2-1.8.4-.7 1-1 1.4-.8.4.3.4 1 0 1.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m250.7 253.5 2-4.8-.2-.3-2.4 3.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M252.4 248.7c-1-.7-1.2-1.5-1-2.3.4-.7 1.2-.2 1.2-.2l.8.7c.4.2 1 0 1.4.6.5.6.2 1.2-.1 1.4-.4.1-1.5.4-2.3-.2zm-8.5-.6c.7.4 1.1 1 .9 1.5-.3.5-1 .5-1.8 0-.7-.3-1-1-.8-1.5.2-.4 1-.5 1.7 0z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m246 250.2 3.8 2.2-.1 1.8-4.1-3.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M246 250.6c-.8 1-1.6 1-2.3.7-.7-.5-.1-1.2-.1-1.2l.8-.7c.2-.4 0-1 .7-1.4.7-.4 1.2 0 1.3.3.1.4.3 1.5-.4 2.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "m356.6 289.8-.4.4-.3 1v-1.5l.5-.3zm.2-.9s-.3.5-1.1.5-1.2-.4-1.3-.8c-.1-.4-.1-.7.2-1.2.2-.5-.4.4-.4.4v1l.6.6.5.2h.4l.7-.2.4-.3zm4.2 7.3s-.4.2-.7.1c-1.9-.6-3.5-1.8-3.5-1.8l3.8 2.4zm2.4 1.1s0 .7-.8 1c-.7.3-1.2.2-1.5-.1s-.4-.6-.4-1.2l-.1.6.4.8.8.4.5-.1.5-.2.4-.5.3-.5zm24.3-47.6-.1.4v.7l-.9-1 .4-.5zm-.5-1.2c0 .7-.9 1.6-1.6 1.3-.7-.3-1.2-1-.9-1.8l-.2.3.1 1.1.7.6h.9l.6-.3.4-.7zm10 1.8s-.1-.4 0 0-.6 1.7-1.4 1.6c-.7-.1-1-.8-1-1.4 0-.6-.1.2-.1.2v.8l.5.4.6.4.6-.2.7-.3.2-.6v-.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M393.8 251s0 .4-.4.7l-1.3.7 2.8-.8-.2-.7zm-17.1 22.5-.1.5v.8l-1.6-2.5.5-.3zm-.9-2.4c-.2.7-1.4 1-2 .8-.5-.4-1-1.6-.3-2l-.4.2-.1.7.2.7.6.7.5.1.8-.2.6-.4s.4-1.3.1-.6m5.6 5.7s0 .3-.5.3h-1.6l2.6.6.2-.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M384.6 277.5c.3.8-.5 1.7-1.5 1.4-1-.3-1.3-1.3-1-1.8l-.2.6.2.8.6.6h1.3l.6-.7.2-.7-.1-.2zm-99 11.1c.3.3-.1 1.5-1.2 2-1.2.4-1.7 0-2-.4-.3-.4-.3-.8-.3-.8l-.2.2.2.6.5.5 1 .2.8-.1.7-.5.4-.3.3-.5v-.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "m284.6 291.1-.3.4-.3.8v-1.4l.5-.3zm-3.8 4s0 .3.2.5l1 .3h-1.8l-.2-.7h.8zm-.6 1.2v.2a1.4 1.4 0 0 1-.1.5c-.2.5-.3 1-1 .9a1.2 1.2 0 0 1-1-1.1c0-.4-.2-.6-.2-.6v.6l.4 1 .7.3h.5l.5-.2.2-.6.1-.5zm-4.7-.1s.2.8 1.2.8 1.2-.2 1.2-.2v.3l-.2.2H276l-.3-.3-.3-.5v-.3zm-9.4-25.4v.4c-.1.3-.7 1-1.8 1-1 0-1.5-.3-1.8-.7-.3-.3-.4-.8-.4-.8v.5l.4.7 1.1.5h1l1-.3.5-.5.1-.6zm-1.7 2.3s-.4 0-.6.2a4 4 0 0 0-.4.4v-1.3h1zm-4.7 3.4.5.3c.5.3 3.1.5 3.1.5h-4.1l.1-.8zm-.5 0-.2.6c-.2.5-.7 1.6-1.6 1.4-.9-.1-.7-.8-.7-.8v-.4l-.2.7.2.4.4.2.7.1.4-.2.6-.5.2-.5.2-.6zm-2.2.2s0 .2-.7.2-1.7-.3-1.7-.3l.4.4.5.2h1.3zm-2-29s0 .5-.3.8c-.4.3-1.3.5-1.8.2s-1.5-1.3-1.5-1.3l.4.8.7.6 1 .3 1-.2.4-.4.2-.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M252 249.1v.6l-.2 1.1.9-2-.4-.2zm-5.4 1.5.2.5c.2.5 2.3 2.6 2.3 2.6l-3.3-2.9.4-.5zm-1 .3s-.5.3-1 .3c-.3 0-1 0-1-.4-.1-.5.1-.7.1-.7l-.3.6.1.4.5.3h.7l.6-.3.2-.2zm-1.5-1.4h-.5c-.7 0-1.4-.8-1.4-.8l.5.8 1 .5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#9ca168",
      d: "M399.9 240.2c-.3 3.8-4.1 5.8-6.1 7.2-2 1.4-3 3.2-3 3.2l-.6 2.2-.3 1.5-.1.5c.1.4.3 1 .3 2l-.1 4.3 2.7-1.9 1.9-.7.6-.1s-2.2 2.1-3 4.4c-.8 2.3-2.4 7.2-5.3 8.8-3 1.6-4.8 1-5.7 1.8-1 .8-1 1-1 1l-1.3 1.8-1 1.2-.9.7-.6.4a7.5 7.5 0 0 1-.2 1.7l-.7 2.4s.6-.4 1.3-.5h1.3s-.5.6-.7 1.3c-.2.6.1 4.6-3.6 7-3.8 2.3-13.4 2-13.4 2l-1.8.7-1.7 1.3-1.6 1.7v.4s-1.3 1.5-2.1 2l-2.8 1.9 2.2.1 3.5 1.5s-2.2 0-3.6.5c-1.5.6-8.2 4.4-11.4 4.3-3.3-.1-8-4.9-8-4.9l-2-1.4-3.5-.7-4.3-.2v-.6l.1-.7s1.5-.2 3.8.1c2 .2 2.7 1 4.4 1.1 1.7.2 3 0 3.5-.3.7-.3 5.9-4.7 5.9-4.7l5.8-2 2.3.3 1 .2.9.3-1 1a7.3 7.3 0 0 1-1.4 1.1l.7.6 3.7-.6 1.2.3.3.2c0-.3.2-.8.6-1.3.4-.6 2.5-2.3 3.4-2.9l1.4-1c.3-.3 1.5-3.3 1.5-3.3l.1-1.6 4.1-4 2.8-2.9 1.2-3.3-.2-.7s1 1 .9 3c-.2 2.2-.7 2.9-.7 2.9s2.8-2 4.3-2.6c1.2-.5 2-.5 2.4-.5.4-.2 1.5-.9 2.1-1.8.8-1.2 1-1.5 1-2l.2-2.8-.3-7 2.4-5.4 3.5-3.1.7-.4-.4 1.2v1.5s1.8-2.5 2.7-2.9l.5-.3a7 7 0 0 0 .8-2l.3-3v-3l-.5-2.3-1.7-4.3v-5.8l-1.2-1.6s1.1 0 2.5 2a13.5 13.5 0 0 1 1.9 5l3.3-10.3s.9 1.2 1.5 3.3l.8 3.3 1.4-2.8.1 1c.2 1 2.3 2.1 2 6m-67.3 65s-.7-1.6-3.9-3.2c-3.1-1.5-5.5-1.8-5.5-1.8v1.1l5 2.2 2.4 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#717732",
      d: "M355.4 295.6c.3-.4 3-2.8 4.4-3.5s3.2-.8 3.2-.8c1.9-.4 2.2-.1 6.6-2.5 4.3-2.4 5.3-5.2 6.2-5.9.8-.7 2.3-.8 2.3-.8l-3.4 3.9a28.5 28.5 0 0 1-5.8 4.5 17.8 17.8 0 0 1-7.6 1.8 7.7 7.7 0 0 0-4 2c-1.3 1-2 2.2-2 2.2s-.2-.5 0-.9zm12-12.7c-4 3.7-5.3 7.2-5.3 7.2l5.4-4.9c1.9-1.8 4.5-2.6 5.6-3.7 1.2-1.1 1.3-2 2-2.7l1.3-1s-1.8-1.4-9 5.1m-8.5 8.6s1.7-.8 2.4-2.3c.5-1.2.2-1.5 1-2.8 0 0 4.2-4 5.7-5.8 2.6-3.1 1.4-5.7 1.4-5.7s.3 1.3-.8 2.7c-1 1.4-6.5 5-7.2 7.2-.6 2.2-.3 2.3-.6 3.4-.6 2.6-1.9 3.3-1.9 3.3m-2.8 10.5s-2.1-1.4-4.5-1.3c-4.9.4-9 3.4-12.2 3.4-3.1.1-4.4-1.5-6.9-3.2-2.6-1.8-9.2-1.5-9.2-1.5v.3s4.4 0 6.4.6c3.6 1 5.6 4.8 9.7 4.6 5.5-.3 9.9-3.6 12-3.6 3.8 0 4.7.7 4.7.7m-24-2.4s3.7.6 6.6-1.5c3-2.1 6.4-5 8.3-5.2 2 0 4 .4 4 .4s-2.5-1-4.4-1c-2 0-4 .2-5.8 1.3-1.8 1.1-2.7 3-4.6 4.3a12.8 12.8 0 0 1-4.1 1.7m-.7 5c-.5 0-1.1.3-1.3.3-.2 0-1.3-1.2-3-2-1.6-1-4-1.4-4-1.4s-.3 0 .3.2l3.8 1.5a8.6 8.6 0 0 1 2.6 2.1c.1.3.6.9 1.5.8 1 0 1.3-.5 1.2-1 0-.3-.6-.5-1.1-.5m2.6-3.6s1.5.8 4 .8c5.2-.2 8.6-3.8 12-5 3.4-1.4 5.2-.3 5.2-.3s.1-.2 0-.2a7 7 0 0 0-3.9-1.2c-5.7 0-11.2 3.7-13.5 4.7-2.3 1-3.8 1.2-3.8 1.2m56-39.9c-1.8 1.9-4.5 7.7-5.6 9.3-1.2 1.6-2.7 2-3.3 2.7-.6.6-2.7 3.5-3.2 4.1-.5.7-.6.5-1 .8-.3.3-.5.3.1.2.6-.1.8-.5 1.6-1.5 1-1 .9-1.4 2.3-2.7 1.4-1.2 3.9-2.6 5.1-4.2 1.3-1.5 3.8-7.5 5.2-9 1.4-1.5 4-2.4 4-2.4s-2-.6-5.3 2.7zm-9 11.1s-.1-1 1.2-2.6 1.7-1.3 2.8-3.6c1-2.3 1.5-4.5 2.3-6.9.9-2.4 2.3-4.8 2.3-4.8s-1.3.2-2.7 2a34.5 34.5 0 0 0-4.8 8.7c-1.1 3.4-1.1 7.2-1.1 7.2m-1.7 2.2s.5-.2.5-3.2c.1-2.9-.1-7 .7-9 .9-2 5.4-7 5.4-7s-1.9.5-4.5 2.5-3.7 4.7-3.6 6.7c.2 2 1.3 4.2 1.4 6.1l.1 4zm10.5-20.1s1.1-4 1.6-5 .5-1.5 2.7-4c1.3-1.5 2.6-2.4 3.1-4.4.6-2 .6-7.7.6-7.7s-.6.5-1.1 1.5c-.5 1-.1 4.7-1 6.4-.8 1.7-2.7 5.6-3.7 6.5 0 0-.2-2.9.2-5.7.3-3 1.3-3.8 1.7-5.7.4-1.9.2-6.7.2-6.7s-1.5 1.5-2.3 3.4c-.8 1.8-1.2 5-1.2 7.5s.5 4.5.6 5.9c.1 1.4.2 2-.4 3.6l-.6 2a34.8 34.8 0 0 1-.7 2.6zm-3.5-21.6s1.4 1.7 1.2 3.6c-.3 2-1 4.5-.2 6.5.7 2 1.9 2.2 2.2 3.4.3 1.2.3 3.4.3 3.4s.6-4.3.2-5.5c-.5-1.1-.7-.6-1.3-1.8s0-4.7-.4-6.7c-.5-2-2-2.9-2-2.9"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#9ca168",
      d: "M306.7 304.8s.4-1 3.1-2.4a34 34 0 0 1 7.3-3c.3.3-.3 1.8-.3 1.8l-2.6.8-2.1 1.2-2.5 1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#9ca168",
      d: "M313.6 297.7c-3.4.1-5.3 1-6 1-.2.1-.7.5-1.2.3a4.9 4.9 0 0 1-1.5-1.5l-.7-.7-.2 2.5-5-4.4-.6 3-.7 1.3-5-4.8.2 3.7-1.4.1-3.6-2.5-1 .4 1.2 2.2-4.6.3-1 .8a6.3 6.3 0 0 0-1 1v.4h1.9c.4-.2.6-.7.7-.5.2.2.3 1.2.9 1.1.6 0 2.7-1.7 4.2-1 1.7.8-2.2 2-1.8 3.1.4 1.2 3.2.7 4 .3.6-.3 2.7-3 3.6-2 1.2 1.4-2.5 2.5-1.8 3.9.6 1.3 2.7 1 3.7.4 1-.5 3.4-4.1 3.9-3.4.9 1.4-2 2.7-1.3 3.7.8 1 2.3 0 3.4-.8s1.5-2.5 3-3.3c1.4-.8 1.3-.5 1.7-.5.4 0 1.5-1.1 1.5-1.1l3.5-1.5 1.6.2.9.4 1.7.2.2-1.4s-2-1-3.3-1zm-27.4 0 .7-1.3-.4-.6s-1.2-.7-2.3-1.8a6.9 6.9 0 0 0-2-1.6L280 291l-.8-2.8-.5-.9-1.3.6-1.7-6.1-.3-1.1h-.7l-1.5 3.6-1.5-2.3-.4-5-1 1-1.3 1.4-2.3-4.6s-.1-.1-.3.3c0 .3-.3 1.8-.1 2.6a26.2 26.2 0 0 1-6-5.2l-1-2.5 1-2 .5-2.6-2.2.9-.4-5.7-.3-1.8-2.7 3.8-1-1.7v-3.6l-.7-.2-1 2s-1.1-2-1.6-2.5c.1-.8.2-2.9-.3-4.5-.6-2-1.3-3.1-1-4.8.2-1.6.9-1.8.8-2.5 0-.8-1.2.5-.8-.5.4-1 3.8-3.2 3.1-4.4-.7-1.1-4 1.9-3.3-.1.8-2 4-2 4.2-4.9.1-1.7-3 1.1-3.3.2-.3-.8 2-2.6 1.9-3.8 0-1 .4-1.2-.2-1.8-.6-.6-2.6 2.3-2.6 2.3l-2-.7-.8 3-.6 2.5-2.6-1.5.7 3.1.6 3-2.7-.7 1.4 2.6 1.9 2 1.1 1.5.9.4 1 1.1.5 1.7.6 1.9.1 1.8v2.4l-.1.4v1.1c-.5 0-1.4-.8-1.7-.3-.3.6 1.6 2 1.2 2.4-.3.4-3-.5-3.2.3-.2 1 .2 2.2 1.8 2.6s5.3 1.2 4.7 2c-.6.7-4.7-2.3-4.5-.1a3.8 3.8 0 0 0 2.6 3.4c1 .4 5.1 0 4.9 1-.3.9-3.3-.4-3.6 1-.3 1.4 2.1 1.6 2.6 1.6s2.2-.1 2.9.4l4.3 4.1a75.7 75.7 0 0 0 4.6 3.4c-.8 0-2.4-.3-2.6.3-.3.7 6 3 4.2 3.8-1.8.7-3.8-2-4.3-.4-.6 1.7 1.2 3 2.2 3.6 1 .6 6.7.1 5.6 1.4-1.1 1.3-5.3-.8-5.3.7s2.7 4 4.2 3.9c1.4 0 3-2.4 3.6-1.1.7 1.2-1 1.7.3 2 1.4.4 2.3-1.4 4-1 1.5.3 4 1.3 5.4 2.5a79 79 0 0 1 2.9 2.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#717732",
      d: "M308.4 304.1c1 0 1 .6 1.2.6.1 0 1.8-1.5 3.3-2.3a17.5 17.5 0 0 1 4-1.4l.1.2s-2.8.7-4.2 1.7l-3 2.1c-.2.2-.8.7-1.7.7-1 0-1.4-.6-1.4-.9 0-.2.7-.7 1.7-.7m8.5-4.3s-.9.1-1.3-.3a4.3 4.3 0 0 0-2.6-.8 7 7 0 0 0-4 1.8c0 .1-.3.6-1.4 1.3.4.1 1.1-.4 2-1a7.4 7.4 0 0 1 3.6-1.4c1-.2 1.7.4 2.2.7.5.4 1.4.3 1.4.3zm-50.5-20.6v-.7a16.1 16.1 0 0 1-2.2-1.1c-1.6-1-5-3.8-5-3.8l2.8 2.7c1.4 1.3 4 2.9 4 2.9zm35.6 25.2 1.5-2.1c.9-1.5 1.7-2 1.9-2.2.1-.2-.4-.9-.7-1.4l-.2-1.2s.4.8 1 1.3a9.5 9.5 0 0 1 1.1 1s1.4-.2 1.4-.5c0-.2 0-.4-.2-.5-.3-.1-.5.2-1.1 0-1.3-.6-1.8-2.6-2.6-2.6-.8-.1-.2 2-.6 2-1.1.2-2-4.3-5-4.5-2 0-2.3.3-2.4.7 0 .5 2.5 3.1 1.6 3.5-.8.4-3.5-4.2-5.5-4.2-1.9 0-2 .7-2 1.1.2.4 2.2.8 1.8 2.2-.5 1.4-2.5-2-4.3-1.9-1.8.2-2 .3-2 .9-.1.5.6 1.2.3 1.4-.2.2-1.4.1-2.3.7-.9.7-2.1 2.4-2.1 2.4s1.2-1.7 2.7-1.9a50 50 0 0 1 5.6 0l-1.1-.8c-.6-.5-1.1-1.6-1.1-1.6l1.7 1.5c.8.7 1.9 1.2 1.9 1.2s1.7.2 1.8.4c.1.2 0 .6-.8 1.3l-1.7 1.7 2-1.6 1.5-1.2 1.4.2c.1 0 0-.5-.8-1.7l-1.6-2.5s1 .9 2 2.3c1.1 1.3 1 2 1.4 2 .4 0 1 .2 1.4.1.4 0 .3.6-.4 1.7s-1.2 2.5-1.2 2.5.8-1.2 1.6-2c.7-.8 1.1-1.7 1.5-1.8h1.5l-.8-1.6c-.6-1-.8-2.6-.8-2.6s.6 1.4 1.4 2.5l1.3 1.9 1.4-.1.3.1c0 .5-.2.7-.7 1.8a17.7 17.7 0 0 0-1 2.1M280.5 292c1.2.5 1.7.5 1.7.5s-1.7-1-2.1-2.4c-.5-1.4 0-4.4-.8-4.3-.7 0-1.1 2.1-1.8 1.7-.8-.4.2-4.4-.6-6-.8-1.7-2.6-2.9-3-2.3-.4.6-.3 4.2-1.5 3.5-1.1-.8.1-4-.2-5.3-.4-1.5-1.2-2.5-1.9-2.1-.6.3.3 3-.7 3s-.9-1.9-1.3-2c-.5-.2-.6.3-.9 0-.2-.4 0-1.7-.6-1.6-.6.1-.5 1.2-.3 1.7.1.6.5 1.4.7 1.8.2.4 1 .9 1 1.2-.1.3-.5.6-1 .6h-1.9s1.4.4 1.9.4 1.4-.2 1.7.2c.2.5 1.4 2 1.4 2s.3-.8.4-2.2c.2-1.5 0-2.7 0-2.7s.5 1.6.4 2.7c0 1-.4 3-.4 3s1.1.8.8 1c-.3.3-1.5.3-2.8.3-1.4 0-3.3-.5-3.3-.5a13.7 13.7 0 0 0 6.7 1.3l1.8 2s.9-1.5 1-3v-3l.4 2.8c0 1.3-.4 3.6-.6 3.8a5 5 0 0 1-1.9 1l-3.5.5s2.2.3 3.8 0c1.5-.4 1.7-.9 2.2-.6l.8.7 1.3 1c.1.1-.7.4-1 .7l-1.5.7 2.2-.7a22.3 22.3 0 0 0 1.1-.4l.5.2-.1-1.2-.3-1.8s.5.8.7 1.6l.1 1.6s.2.2 1.4.6m-31.1-35.6s.3-1.7.3-3.6a14.3 14.3 0 0 0-1.9-5.8l1-1.4-1.2 1-1.2-.5a3 3 0 0 1-.9-1l1.2.8c.6.2.7.1.7.1l-.5-2-1.9-1c-1.3-.6-2.5-1.8-2.5-1.8l2.8 1.5c1 .4 1.6.4 1.6.4l1.6-.6 1.7-1.1s-1 .6-1.8.7l-1.6.3-.3-2.4-1.1-1.1c-.9-1.2-1.6-2.9-1.6-2.9s1 1.2 1.7 1.7c.7.6 1.4 1.5 1.4 1.5l1.6-1 2.8-2-2.7 1.3-1.6.7s-.2-1 0-1.5c.3-.4.8-1.2.7-1.6 0-.5-.4-.3-.5-.7-.2-.3.4-2.6.4-2.6l.1 1.2c0 .5-.2 1 .4 1 .6 0 3.2-2.7 3.6-3.2.3-.5.8-1.8-.6-1.3-1.4.6-1 1.8-2.2 1.7-.4 0-.8-1.5-1.2-1.2-.4.4-1.4 1.3-1.6 2.4-.2 1 .2 2.6-.4 3.1-.6.5-1-1.8-2.2-1.5-1.2.3-1.5 2-1.3 2.6.2.6 2.7 3.5 2 4-.9.3-2.9-2.6-4-.6-1 1.9 3.4 4 4 4.4.5.5 0 .6.8 1.6s1.8 1.2 2.4 1.8a13 13 0 0 1 2.1 5.9zm11.7 17.1s-1-1.2-.7-3.3c.3-2 1.8-5.7 1.3-6.2s-2 2.2-2.4 1.6c-.4-.6.9-4.3.2-5.8-.6-1.5-.7-2.5-2-2.3-1.3.1-1.8 4.4-2.5 3.6-.6-.7.4-2.6 0-3.7-.5-1-.7-1.3-1.3-1.2-.7.2-1 2.2-1.4 2.1-.5 0-1.2-2.3-2.2-2-.9.3 2.3 4.5 2.3 4.5s.5-.5.8-1.2l.6-1.5s.3 1.3 0 1.9c-.2.5-.3 1.7-.3 1.7s-.8.3-2.1 0a8.8 8.8 0 0 1-2.3-.7s.8.6 2.1 1l2.7.7a44.9 44.9 0 0 0 2 2.7l.8-2.1 1.3-3.5-.6 3.9-.7 3s-1 0-2.6-.3l-3.6-.8 3.6 1.2 2.8.7 1.4 1.9 1-1.5 1-1.8s-.3 1.4-.7 2.3a27.4 27.4 0 0 1-.7 1.4l-1.8.2h-2.5a19.6 19.6 0 0 0 4.5.9s0 .5.7 1.3a4.6 4.6 0 0 0 1.3 1.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M314.4 310.8s-.6-.6-1.4-1c-.9-.5-1.2-.4-1.2-.4l-.4-.1.8-2 5.5-5.3.9-5.3h3.4v7.2l1 .5 6.2 3.7v1.6l-1 .4-.7.4-2.3.2-4-3-1.8-1.7-3 4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#016848",
      d: "m318.8 296.7-.1 1c0 .9 0 5.2-.2 5.8-.2.6-3.2 1.8-4.9 3.3-1.7 1.5-1.8 2.6-1.8 2.6s-.5 0-1.6.4c-1 .4-1.5 1-1.5 1s.6-2.6 3.4-5c2.7-2.6 4-2.8 4.4-3.2.3-.4 0-5 0-5.5.1-.4.5-.4.7-.4zm7 15.7.8-1.1 1-.8-1.5-.8c-1.5-.6-2.3-.4-3.3-1.2a13.6 13.6 0 0 1-2.2-2l-1.5 1.2 1.7 2c.9.8 2.7 1.1 3.5 1.6a8.8 8.8 0 0 1 1.6 1.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#cd202a",
      d: "M321.5 296.6s1.7 0 1.9.2l.2.6c0 .1 0 4-.2 5.3a8 8 0 0 1-1.4 3l-4 3.7c-1.2 1.2-2.4 2.8-2.4 2.8l-.8-1c-.3-.4-.7-.6-.6-.9a10 10 0 0 1 3.3-3.4c2-1.3 3.6-2.8 4-4.9.3-2 0-5.4 0-5.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#cd202a",
      d: "M332.5 310s-.4-.4-1.8-.4l-1.5.1s-.8-1-2-1.7c-1.2-.8-2.1-.7-3.5-1.6-1.3-.8-2-2.1-2-2.1l1-2s1.2 1.5 2.4 2.4c1.1.9 3.7 1.7 4.6 2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#30c2dc",
      stroke: "#0872a7",
      strokeWidth: 0.5,
      d: "M345 286.4s-3.6-1.4-3.4-2.7c.3-1.2 8.3-3.3 8.3-3.3l.1-2.1s-1.2-.1-3.2.5c-2 .7-5.2 1.6-8.6 1.6a1735.4 1735.4 0 0 0-34.4-2.2c-3.7-.3-6-6-6-6l-1.8.4s.5 2.7-.4 3a65 65 0 0 1-13.9-6l-.6 2.6s7.3 4 7.1 5.5c-.2 1.4-2.4 1.3-2.4 1.3l1 1.8c.3 0 12 .6 12.3 4.1 0 1.5-3 2.3-3 2.3l1 1.2v.6s6.7 0 8.5 1c1.8 1 2.7 2.6 5 3.8 2.2 1.3 17.3 1 19.6.3 2.7-.7 4.3-3.7 8.7-5 4.3-1.4 5.7-1.4 5.7-1.4z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 284.5,
      cy: 280.7,
      r: 2.1,
      fill: "#fff",
      stroke: "#0872a7"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 296.4,
      cy: 270.9,
      r: 2.1,
      fill: "#fff",
      stroke: "#0872a7"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 346.5,
      cy: 286.6,
      r: 2.1,
      fill: "#fff",
      stroke: "#0872a7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      d: "M275.1 267.8c-.7 1.6 2 4.6 4 5 1.8.2 2.8-.2 3.2-1.1a2.8 2.8 0 0 0-.4-2.5c-1.2-1.7-6-3-6.8-1.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M281 270.2c0-1-1.6-1.9-2.6-1.9s-2 0-1.8.5c.1.6 2.7 1.3 2.8 1.6 0 .3-.8.6-.4 1 .5.4 1 .1 1.4-.2.4-.3.7-.4.7-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      d: "M297.7 288.3c.4 1.4-.7 2-2 2.7-1.5.6-4.3.2-5-.9-.6-1.1 1-3 2.8-3.4 1.7-.4 3.8.3 4.2 1.6"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M294.8 289c.5 0 .6 1 1 .8.5 0 1-.8.8-1.3-.1-.6-1-1.3-1.8-1.2-.8 0-3 2-2.8 2.5.2.5.8.5 1.2.3.4-.2 1-1 1.6-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      d: "M349.2 281c1.3 1.7 3.6.2 4.2-.5.6-.6 2.4-1.7 1.7-2.8-.8-1.1-2-1-3-1-.8 0-2.6 1.4-2.9 2-.3.5-.6 1.6 0 2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M349.6 280s.1-1.9 1.8-2c1 0 1 .3 1.8.7.7.4 1-.5 1-.5s0 1.3-1.1 1.3c-1.2 0-.8-.5-2-.7-1-.2-1.5 1.1-1.5 1.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "m321.9 276.4-.9-.6h-2.8l-3.4.1 3.4 9.9 4 5.8 1.6.6 3.1-.2.6-1.6-1.2-9.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "m310.6 277 .2-1.1 1.8-.1a7.2 7.2 0 0 1 2.2.1s2.3 2.9 3.1 4.7c.8 1.8 1.7 4.8 2.7 6.6 1 1.9 3.2 5 3.2 5h-4l-2-.6-5.6-9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M308.2 275.8h2.6a14 14 0 0 1 3.9 5.4c1 2.8.5 3.2 1.8 6.2 1.4 2.9 3.2 4.9 3.2 4.9s-3.9.2-6-.2c-2.3-.4-3-.3-3.6-1a9.2 9.2 0 0 0-1.7-1.3h-2.2l.5-3.1-.6-6.9.1-3.5zm23.4 1.8-3.7-1.5-7-.4.6 3.6a30.2 30.2 0 0 0 2.6 7.7c1.1 2 2.2 4.4 2.8 5 .6.5 4.6-1.1 4.6-1.1l2.6-.4-.3-2.8-.4-1 .6-8-.6-1.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M307.1 277.7c0 .8 1 .9 1.2.8.2 0 1-.3 1-1.5s-.7-2.1-2.2-2.2c-1.4 0-2.5 1.7-2.5 3 0 1.2 1.2 1.8 1.2 2.3 0 0-1.2 1.1-1.1 3.1 0 2 1.6 3.6 1.6 3.6s-1.7 1.3-1.7 2.7c0 1.4 1.3 2.3 2.6 2.3 1.2 0 2.8-.8 2.8-1.8s-1-1.7-1.7-1.7c-.8 0-1.1.5-1.1.8m25.6-10.9c0 .9-.6 1-1 1s-1.2-.4-1.2-1.5c0-1 1.4-1.6 2.4-1.6.9 0 2.4 1.2 2.4 2.7 0 1.5-1 2.6-1 2.6s.6.3.6 2.2c0 2-1.2 3.3-1.2 3.3s1.6.6 1.6 2.6-1.4 2.6-2.3 2.6c-1 0-2.6-.5-2.6-1.9 0-1.3.8-1.8 1.5-1.8.6 0 1.3.7 1.3 1.5"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#953220",
      d: "m309.5 288.6.4.6c.2.4.3 1 .8 1.4.8.7 7.2 1 9.2 1 2 0 7.8.2 8.9-.4 1-.7 1.2-1.8 1.9-2.3l.9-.4-.9.7v1.4l.5.8s-.1.4-.8.8c-.7.4-1.3.5-2.3.6-1 .1-13.2.1-15.2-.2-2-.4-1.8-.3-2.4-.7a4.3 4.3 0 0 1-1-1l.3-.8-.3-1.4zm20-11.8 1 .5s-.9.3-1.6 2.3c-.7 2-.1 2.5-.6 2.7-.5.2-5.8 0-5.8 0l-1-2.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M346.4 276s-.9-.3-1.3-1c-.4-.8-.8-1.7-.5-2 .4-.1 1 .5 1 1.1 0 .6.8 2 .8 2zm10.4-2.8s.7 1.2 1 1.3l1.2.6s-1.5 0-2-.4a8.3 8.3 0 0 1-1-1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M360 274.2s-1 .5-1.6.2c-.8-.3-1.4-.7-1-1 .2-.4.4-.3.8.2.4.4 1.8.6 1.8.6m5.3-4.5s-.8.6-1.3.6-1.5-.2-1.5-.4 1.3-.4 1.6-.3zm-8-10.5s-1.1.4-1.5 1c-.4.5-.3 1.2.2 1.2s.6-.7.6-1zm-5.2 2.9s-.9.5-1 1c-.3.5-.5 1.6 0 1.6s.7-.8.7-1.2c0-.5.3-1.4.3-1.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "m342.8 268.4-2.9 3s6.6 3.7 11.7 3.5c5-.1 10.8-4 11.2-5 .4-.7 0-4.3-.6-5.4-.7-1.1-4.2-3.8-5.5-3.7-1.3.1-3.7 1.9-5.8 4-2.2 2.1-2 3.9-5 3.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#0c8489",
      d: "M342 269.6s7 1 9.1-.8c2-1.8 4.3-5.3 5.7-6 1.4-.9 2-.9 2-.9l1.6 1.1 1.8 1.5.6 3.4v1.8l-2.2 1.8-4 1.9-4 1.2-3.2-.1-6.7-2-1.7-1.1-.4-.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M352.8 265.5c0-.6.4-.6 1-.6s1 .2 1 .8-.5 1.4-1 1.4c-.6 0-1-1-1-1.6m2.8 1.8c0-.6.4-.8 1-.8.7 0 1.3.7 1.3 1.2s-.5 1-1.1 1c-.7 0-1.2-.9-1.2-1.4m-1 4.2c0-.7.5-.8 1.1-.8.6 0 1 .3 1 1a1.2 1.2 0 0 1-1.1 1.2c-.7 0-1-.7-1-1.4m-3.7-1.3c0-.7.7-1 1.3-1 .6 0 1 .7 1 1.4s-.4 1.3-1 1.3-1.3-1-1.3-1.7m-5.9.7a1.4 1.4 0 1 1 3 0 1.4 1.4 0 0 1-3 0"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M355.6 267.3c0-.5.7-.8 1-.8.5 0 .8.4.8.8s-.3 1-.7 1c-.4 0-1-.5-1-1zm-1 4c0-.5.6-.8 1.2-.8s1 .3 1 .8-.5 1-1 1c-.6 0-1.1-.4-1.1-1zm-3.7-1.2c0-.6 1-.9 1.5-.9.4 0 .3.4.3 1 0 .7-.3 1.2-.7 1.2s-1-.7-1-1.3zm1.8-4.7c0-.5.4-.5.8-.5s.6.1.6.7-.3 1-.6 1c-.4 0-.8-.6-.8-1.2m-7.7 5.1c0-.6.6-1.3 1.4-1.3s1.7.3 1.7 1c0 .6-1 1.8-1.8 1.8-.9 0-1.3-.8-1.3-1.5"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M347.7 269.4s-1 .1-1.5.6-.5 1-.3 1.2c.3.2.7-.3.8-.6 0-.2 1-1.2 1-1.2m4.7-1s-1 .6-1 1.3c-.1.6 0 1 .2 1 .3 0 .5-.9.4-1.2-.1-.3.4-1.2.4-1.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M353.2 269.3s-.6 0-1 .4c-.5.5-.9 1-.6 1 .3 0 .8-.2.8-.5 0-.2.8-.9.8-.9m1-5.4-.8.6c-.2.2-.5 1-.2 1 .3.2.5 0 .8-.5.2-.5.2-1.1.2-1.1m3.5 2.3s-.9 0-1.2.5c-.3.4-.5.8 0 .8.3 0 .4-.2.6-.5.1-.4.6-.8.6-.8m-.5 4.1s-.2.7-.8 1c-.5.3-.7.5-1 .1-.1-.4.2-.6.4-.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M362.8 267.5s.4 2-1.3 3c-1.7.9-6.4 4.2-10.9 3.8-4.5-.4-9.6-3-9.6-3l-.7.4 1.2.5 3.4 1.4 4 1.2 2.5.1 2.1-.2 4-1.3 3.3-1.7 1.8-1.4.4-.6v-1.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M274.9 242.2s1 .9 1 1.6c-.2.8-.4 1.1-.7 1-.3-.2-.3-1-.3-1.3zm7.7 7.1s-.3 1.4-.9 1.5c-.5.1-.9-.4-.8-.7.1-.2.6 0 .8-.2zm-16.8 1s.4.8 1 1c.8 0 1-.4 1-.6-.1-.2-.4-.2-.8-.2zm3 6s.7.6 1.5.7a1.3 1.3 0 0 0 1.3-.7c0-.2-1-.2-1.3 0-.3.3-1.5 0-1.5 0m5.3 4.4s1.4-.2 1.6-.6c.2-.4.6-1 .3-1.3-.3-.4-.5.5-.7.9-.1.3-1.2 1-1.2 1"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M282.6 257.1s1-6-4-10.4c-5-4.3-8.1-3.2-9.8-1.6-1.7 1.6-3.2 6.7 2 11.3 5.3 4.5 11.7 3 11.7 3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#0c8489",
      d: "M267.6 250.7s-.1-3.4 1.5-4.4c1.5-1 6.8-1.8 9.3 3.1 2.6 5 2.7 7.4 2 10h-2.7l-4.3-1.8-3.5-2.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M282 258s-.9 1-2.7 1c-1.7-.2-10-2.3-12-9.8v1.7l.1.5.6 1.5 1.7 2.5 2.2 1.9 2.8 1.4 2 .6 2.5.4h1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M277.7 255.9c0-.7.3-.7.8-.7s1-.2 1 .4c0 .7-.4 1.6-1 1.6-.4 0-.8-.7-.8-1.3m.3-4c0-.4.4-.8 1-.8.5 0 .9.4.9.9 0 .4-.4.8-1 .8-.5 0-.9-.4-.9-.8zm-3.7 4.4c0-.4.4-.7 1-.7s1 .3 1 .7c0 .3-1 .8-1.5.8-.6 0-.5-.5-.5-.8m-.4-4.6c0-.6.3-.4.8-.4s1.2.1 1.2.7-.7 1.4-1.2 1.4-.8-1.2-.8-1.7m-3.4.7c0-.5.3-1.1.9-1.1s1.3.6 1.3 1.1c0 .5-.5 1-1.1 1-.6 0-1.1-.5-1.1-1m.6-4c0-.6.3-.5 1-.5.6 0 1.1.2 1.1.7 0 .5-.7 1.2-1.4 1.2-.6 0-.7-1-.7-1.5zm3.7-.5c0-.4.5-.3 1-.3.7 0 1.1.4 1.1 1s-.7 1-1.3 1c-.6 0-.8-1.2-.8-1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M271 248.3c.2-.4.4-.7.8-.7.5 0 .9.1.9.7 0 .4-.4.9-.8.9-.5 0-1-.5-.8-1zm-.6 4c0-.5.2-1 .7-1s1 0 1 .5-.5 1.1-1 1.1-.7-.1-.7-.6m4.4-4.3c0-.4.3-.4.8-.4s.8 0 .8.5c0 .4-.4.7-.8.7s-.8-.4-.8-.8m-.9 3.9c0 .5.5 1 1 1s1-.5 1-1c0-.6-.6-1-1-1s-1 .4-1 1m4.3-.6c0 .5.4.9 1 .9.5 0 .9-.4.9-.9s-.5-.9-1-.9-1 .4-1 1zm-4.1 5c0-.5.5-.9.9-.9s.9.3.9.7c0 .4-.8 1-1.2 1-.5 0-.6-.4-.6-.9zm3.6-.7c0-.5.4-.6 1-.6.5 0 .8.1.8.6 0 .6-.5 1-1 1s-.8-.5-.8-1"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M278.7 249.4s.5.7.6 1.3v1.2c-.3 0-.6-.4-.7-.9-.1-.5 0-1.6 0-1.6zm-3.2-3.3s.4.5.4 1 0 1-.3 1-.3-.4-.3-.8zm-3.7.5s.4.5.4 1 0 1-.3 1-.3-.4-.3-.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "m270.5 247.3 1 .4c.3.4.5.8.3 1-.1.2-.5-.1-.6-.4zm2.8 3.8s.7 0 1.1.5c.4.3.8.6.5.9-.2.2-.7-.2-1-.5zm-3.4 0 1 .3c.3.2.4.7.2.8-.1.1-.4 0-.6-.4zm8.3 2.5.2 1.4c0 .5.1 1-.2 1s-.3-.7-.3-1c0-.5.3-1.4.3-1.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "m277.3 254.9.8.5c.3.2.3.6.1.6l-.4-.5a9.2 9.2 0 0 1-.5-.6m-3.7.2.9.3c.2.2.3 1 .2 1.1 0 .1-.4 0-.6-.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M272.1 243.8s-3.2.7-3.8 2.9c-.6 2-.7 4.4-.7 4.4l-.4-2.7.6-1.7 1-1.6 1.4-1 1.3-.4zm10.2 12.5s.4-.8-.6-3.4c-1-2.5-3-6-3-6l1.6 1.8 1.2 2 .6 1.8.5 1.7v1.6l-.3.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M285.6 252.2s1.2.7 1.3 1.1c.1.4.2.6-.1.7-.3.1-.8-.4-1-.7a6.5 6.5 0 0 1-.2-1.1m-4.8 12.8s.6-1 1.3-1.3c.7-.4 1.2-.4 1.4-.1.2.2-.4.7-1 .9zm8.1 3.1s.8-.4 1.3-1c.5-.5.6-.9.4-1-.2-.3-.8 0-1.1.5-.3.4-.6 1.5-.6 1.5m-.9-.7s.3-1 .6-1.4c.3-.3.6-.5 1-.3.2.2 0 .6-.2.9a7.8 7.8 0 0 1-1.4.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M301.5 261.2s-5-7.2-12.8-7.6a7.4 7.4 0 0 0-8 7c.2 1.6 2.6 5.2 10.9 5.8 8.3.6 9.6-3.9 10-4.1.3-.2-.1-1-.1-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#0c8489",
      d: "M295.6 256.3s2 1.5 3 2.8c.8 1.2 1 2.2.5 2.3-.5.2-5-4-8.8-4.9-3.7-.9-6.9 0-7.6 1.7s-.4 4.5 1.2 5.6c1.8 1 9.7 2.3 9.7 2.3l3.7-.5 2.3-1.3.5-1.3.6-1.6.2-.7-1.9-2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M289.2 257.3c0 .4-.5.7-1 .7s-.9-.3-.9-.7c0-.5.4-.9 1-.9s1 .4 1 .9zm-4.6 1.6c0-.5.6-.4 1-.4.6 0 1 .3 1 .8s-.8 1.1-1.3.9c-.6-.3-.7-.8-.7-1.3m5 2.7c0-.6.4-1 1-1 .7 0 1.2.4 1.2 1s-.8 1.2-1.5 1.2-.7-.6-.7-1.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M285.8 262.7c0-.5.6-.6 1-.6.5 0 1 .5 1 1s-.5.9-1 .9c-.4 0-1-.8-1-1.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M292.5 264.5c0-.4.2-.8.7-.8.4 0 1 .3 1 .7 0 .4-.5.9-1 .9a.8.8 0 0 1-.7-.8m3-2.3c0-.5.3-.4.8-.4s1 .2 1 .8-.6.8-1.1.8c-.5 0-.7-.6-.7-1.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M289 256.9c0 .4-.2.6-.7.6s-.9-.2-.9-.6c0-.5.2-.6.6-.6s1 .1 1 .6m-2.5 1.9c0 .5-.7.7-1 .7-.5 0-.8-.2-.8-.7 0-.5.3-.6.8-.6s1 .1 1 .6m1 3.8c0 .4 0 .7-.5.7s-1-.3-1-.7c0-.4 0-.7.5-.7s1.1.3 1.1.7zm4-1.3c0 .4-.7 1-1.2 1-.4 0-.6-.9-.6-1.3s.4-.7.8-.7 1 .6 1 1m5.8 1.3c0 .4-.7.4-1 .4-.5 0-.8-.5-.8-1 0-.4.1-.8 1-.7.5 0 .8.8.8 1.3m-3.4 1.7c0 .5-.3.8-.7.8a.8.8 0 0 1-.8-.8c0-.4.4-.6.8-.6s.7.2.7.6"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M294.4 262s.8-.3 1.5-.3c.6 0 .6.3.6.4 0 .1-.5.3-.7.2a86.2 86.2 0 0 1-1.4-.4zm-3.3 2.8s.6-.4 1.1-.5c.5-.1.9 0 .8.4 0 .3-.2.3-.6.3zm-2.2-5s1.4.6 1.7 1.1c.3.6.4.7.1.9-.3.2-.6-.2-.8-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "m288.5 261.6 1.6-.3c.5 0 .6 0 .7.2 0 .2-.1.3-.5.3zm-3.4 0s1.2.2 1.5.5c.3.3.3.6.1.7 0 .2-.6.1-.8 0z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M285 263.3s.4-.7.8-.8 1-.1 1 .1c.1.2-.4.5-.7.6zm-1-5.1 1.2.3c.4.3.5.6.4.7 0 .1-.5.2-.8 0-.5-.4-.7-1-.7-1zm2.6-3s1.2.4 1.6 1c.4.5.3.8.1.9l-.9-.4c-.3-.3-.8-1.4-.8-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M300 263.7s-2.3 2-7.7 1.9c-5.5-.2-10.4-2.5-11.6-5l.5 1.2 1.2 1.6 3.8 2 4.3.9 3.3.2 3.2-.6 2.5-1.1.4-.7zm.8-2.5s-.9-1.2-2.2-2.3c-1.2-1.2-6.2-4.4-6.2-4.4l4 1.8 2.7 2.2 1.8 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M301 256.4s1.4.5 1.6.8l.5.6s-.3 1-.6.6l-.8-.9zm4-2.2s1.3.5 1.8 1.1c.5.7.4 1.2.2 1.3-.2 0-1-.7-1.2-1a47.3 47.3 0 0 0-.7-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M306.4 254s1.2.8 1.4 1.2c.1.4.5 1 .1 1-.3.2-.9-.4-1-.8l-.6-1.5zm6.8 1.5s1 .4 1 1.2v1.3l-.7-.7v-.7l-.3-1zm1.8.7s.8.7.9 1.2c0 .5.2.8-.3 1-.4 0-.6-.5-.6-1zm-12.3 15s.6.2 1.2 0c.5-.2 1-.7.9-1-.1-.4-.4-.7-.8-.2-.4.4-.2.6-.5.8zm6.8 1.8s.9-.2 1.5-.9c.6-.6.9-1 .5-1.2-.4-.2-1 0-1 .5zm5.5.1 1.3-.9c.5-.4.7-.7.4-1-.3-.5-.6-.2-.8 0l-.2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M316.7 273.1s.8-.9 1-1.4c.1-.5.2-1-.1-1-.4 0-.8.5-.8.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M299.9 264.1c0-2.4 3.5-8 7.5-8 1.6 0 4.9 1 7.5 2.1 2.2 1 3 2 4.4 2.4 1.5.4 3.7.1 3.7.1l5-.5-4 5.7-1.4 1.2s-1.2 2.4-4.7 3.8c-3.6 1.4-9.5.4-12.2-.3-2.7-.7-6-3.2-5.8-6.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M299.9 264.1h.2c0-.5.2-1.3.6-2.1a12.2 12.2 0 0 1 2.7-3.8c1.1-1 2.5-1.8 3.9-1.8.8 0 2 .2 3.4.6a29.4 29.4 0 0 1 4.1 1.4c1 .5 1.8 1 2.4 1.5.7.4 1.3.8 2 1a9 9 0 0 0 2 .2l1.8-.1 4.4-.5-3.6 5.2-1.4 1.2v.1a9 9 0 0 1-4.6 3.7c-1.3.4-2.8.6-4.5.6-2.8 0-5.9-.5-7.6-1a8.4 8.4 0 0 1-3.8-2.1 5.7 5.7 0 0 1-1.8-4h-.5c0 1.7.8 3.2 2 4.4a9 9 0 0 0 4 2.3c1.7.4 4.8 1 7.7 1a14 14 0 0 0 4.7-.7 9.4 9.4 0 0 0 4.9-4h-.3l.2.1 1.4-1.3 4.3-6.2-5.6.7h-.1a14.8 14.8 0 0 1-3.4-.1 5.5 5.5 0 0 1-1.9-1c-.6-.4-1.4-1-2.5-1.4a29 29 0 0 0-4.2-1.5c-1.3-.4-2.6-.6-3.4-.6h-.1c-1 0-2 .3-3 1a11.2 11.2 0 0 0-3.3 3.5 8.3 8.3 0 0 0-1.4 3.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#0c8489",
      d: "M324 264.9c-.4.3-1 .3-1.4.3-.5 0-11.6-6.7-15-6.4-3.5.3-6.8 1.7-6.9 5.3 0 3.5.8 3.5 1.5 4.5s7.5 2.5 7.5 2.5h4.1l3.3-.4 3-1.6 1.5-1.3 1.1-1.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M306.5 263c0 .8-.3 1.3-1 1.3-.6 0-1.1-.3-1.1-1s.4-1 1-1c.7 0 1 .1 1 .8zm1.1-3c0-.6.6-.8 1.2-.8.7 0 1.2.2 1.2.8 0 .6-.5 1-1.2 1-.6 0-1.2-.4-1.2-1m6.7 1.8c0-.5.4-.9 1-.9.5 0 .9.4.9 1s-.4.8-1 .8a1 1 0 0 1-1-.9zm1.3 4c0-.6.5-1 1-1 .6 0 1.2.2 1.2.8s-.2 1.3-.8 1.3c-.6 0-1.4-.4-1.4-1zm-3.2 2.7c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1 0 .5-.5.9-1 .9-.7 0-1.2-.4-1.2-1zm-6-1c0-.6.3-1 .9-1a1 1 0 1 1 0 1.9 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M306.4 263c0 .5-.4 1-1 1a1 1 0 0 1-1-1c0-.6.4-.8 1-.8s1 .2 1 .7zm3.3-3.2c0 .5-.2.9-.8.9-.5 0-1.3-.4-1.3-.9s.5-1 1-1c.6 0 1 .5 1 1zm6.4 1.7c0 .5-.4.9-1 .9s-.9-.4-.9-.9c0-.4.4-.8 1-.8s.9.4.9.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M312.7 264.2c0 .7-.3 1.2-1 1.2-.6 0-1.1-.3-1.1-1s.3-1 1-1 1 .2 1 .8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M308 267.2c0 .5-.4 1-1 1s-1-.5-1-1 .6-.8 1.2-.8.8.3.8.8m4.5-3a1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1m5.2 1.3c0 .6-.3 1-1 1-.6 0-1.1-.4-1.1-1s.2-.8.8-.8c.6 0 1.3.2 1.3.8m-3.3 2.7c0 .6-.4 1-1 1s-1.1-.4-1.1-1c0-.5.5-.8 1-.8.6 0 1 .3 1 .8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M314.8 265s1.6-.2 1.9 0c.3.4.3.8.1 1-.1 0-.8.1-1-.1 0-.3-1-1-1-1zm-1.7-5.4s1.3.3 1.8.9c.5.5.4 1 .4 1.1-.2.1-.6.2-1-.2zm-3.7 2.6s1.5.8 1.8 1.3c.3.4.4.8.2 1-.1.2-.8 0-1-.3 0-.3-1-2-1-2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M308.7 263.3s1.7.2 2 .5c.5.4.8.4.8.6 0 .3-.3.4-.5.4a3.6 3.6 0 0 1-1.2-.5l-1-1zm-1.9-4.8s1.7.2 2 .5c.4.3.5 1 .1 1.2-.4.2-.8-.2-1-.5a8.2 8.2 0 0 0-1-1.2zm-3.6 2.5s1.5.8 2 1.4c.3.4.5.7 0 1-.4 0-.9-.7-.9-1a9 9 0 0 0-1.1-1.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "m302.8 263 1.5-.2c.5 0 1.2-.1 1.2.2 0 .4-.6.5-1 .4zm8.6 5.6s1.1-.7 1.7-.6c.5.1.7.1.7.4 0 .4-.7.3-.9.3zm-6-.9s.4-.6.9-.7c.4 0 .6 0 .7.2 0 .2-.4.6-.6.6h-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M322.6 266.6s-1.6 2-4 3a14 14 0 0 1-7.2 1.1 15.2 15.2 0 0 1-11.2-5.2l.4 1.1 2 2.6 2.3 1 3.5 1 3.3.3h2.5l3-.5 1.9-.7 1.3-.8 1-.8 1.2-2zm-3-5.9s-1 .3-3-.9-4.3-2.8-8.8-2.8c-4.5 0-5.9 3-6.2 3.2l2-2.6 2-1.1 1.7-.3h1.5l2 .6 1.7.6 2.1.7 1.8 1 2.2 1.1zm6 1.4h-3.4c-.8 0-.8.2-1 .4a4 4 0 0 1-.2.4l-.8-1.7 3.5-.5 2 .7-.2.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#0c8489",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M320.7 280.4c.2.5.6 1 1.1 1h1.6l3.6-.3 1.2-1.4.8-3.2 1-1.2 3.3-1.9 2.8-.8 1.9-.2 2.5-.8 1.9-1 .8-1.2.8-1.8-.8-2.5-2-2.7-3.4-1.3H335l-3 1.1-5.5 1.3s-3 1.3-4.3 3.7c-1.3 2.3-1.2 3-1.5 6-.2 3.2 0 7.2 0 7.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M322.2 279.2c1 0 .2-1.7 1.4-3.8 1.2-2 2.6-4.6 3-4.6s.4.4.9.3c.4-.2 1.2-.8 1.2-1 0-.2 0-1.3 1-2 .8-.8 2.1-1.9 2.7-2 .6-.1 1-.3 1 0 .1.3-.3.7.1.8.4.2 1.4.1 1.6-.5l.2-1s.6-.5 1.8-.3c1.2.3 1.3.2 1.4.7.1.4-.5.5-.4.8v.6c.2.2.4 1 1.2 1 .8-.1 1.1-.6 1.1-.6l.3-.4s.2-.5-.1-.7c-.3-.2-.2-.4 0-.3.4.1 1.6 1.8 2 1.1.4-.7.5-1.7.2-2a91.2 91.2 0 0 1-1.9-2.7l-3-1-4 .3-4 2.2-3.6 2s-.2 2.9-.8 2.3c-.7-.5-1.6-2-1.9-1.5-.3.5-.9 2.7-1.3 3.8-.3 1-1.4 4.4-1.3 5.6.1 1.2.8 2.9 1.2 2.9"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8cbebf",
      d: "M325.8 274.4c-.3 0-.7.3-.8.5-.2.2-.3.5-.2 1 0 .3.7.7.7.7h.5l1-.3.3-.8c0-.5-.3-.6-.4-.6a29 29 0 0 1-1.1-.5m6.2-5c-.6-.3-.8.1-1 .3v.5s.2.8.4 1c.3 0 1.1.3 1.3 0 .3-.2.5-.4.5-.9s-.7-.7-.7-.7zm5 1.1c0-.2-.5-.3-.9-.2-.3 0-.7.4-.6 1 .2.7.8.7 1.2.6.5-.1.4-.8.4-.9zm-14.4 1c0 .3.5 1 1.2.9a1.3 1.3 0 0 0 1.2-1c0-.4-.4.3-1 .5s-.7.2-1 0c-.2-.4-.4-.4-.4-.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M327.3 275.5s0 .6-.4 1c-.5.3-.8.3-1 .3-.3 0-.6 0-.8-.3l-.3-.7s.5.8 1.3.6a2 2 0 0 0 1.2-.9m13.3-8.3s0 .6-.5.9c-.5.3-.7.3-1 .3-.2 0-.6-.1-.7-.4-.6-1-.3-1.5-.3-1.5s.4 1.6 1.3 1.5a2 2 0 0 0 1.2-.8m-11.9 2.9s-.4 1.2-1.2 1.2c-.9 0-.8-.2-.7-.4 0-.1.3.2.7 0 .4 0 1.2-.8 1.2-.8m2.3-.3s0 1 .2 1.2c.3.4.7.5 1 .5s.6 0 .9-.4.1-.8.1-.8l-.2.5c-.3.3-.5.3-.8.3s-.7 0-.8-.3zm4.3-4.3s.2.7-.3 1.2c-.5.6-1.5.2-1.5.2s.8.3 1.2-.2c.4-.4.6-1.2.6-1.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#04534e",
      d: "M321.7 281.1s5.3 0 5.7-.8c.4-.7-.4-3.6 2.7-5.8 3.2-2.2 5.7-2.2 7.4-2.3 1.7-.2 5.3-1.3 6-4.5.3-2-2.3-2.2-3.3-4-1-2-3.6-1.2-3.8-1.2-.1 0-3 0-4.3 1.3-.9.8-.8 1.8-1.1 2.2-.4.5-4 0-4.3.6-.4.6.1 1.7-.2 2-.2.3-1-.8-1-.8l.2-2.8 4.5-2.6 5-2.8 3.5.1 3.5 1.8 1.7 2s.3.8.5 2.3a5.3 5.3 0 0 1-.2 2c-.8 2.8-3.7 4.8-6.7 5a14 14 0 0 0-7 2.5c-1.4 1-2.1 5.3-2.1 5.9 0 .5-6.6.1-6.6.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M324 270.8c-.3.3-.7.2-.8 0-.2-1 .3-2.2.3-2.2v1.6c.1.2.4.1.5.3zm3.2-.6c-.2-.1-.1-1 0-1.3.2-.3 1.7-1.4 1.7-1.4l-.6 1.5c-.2.4-.7 1.3-1 1.2zm-1.2 5.3c-.3 0-.3-.4-.3-1s1-1.6 1-1.6l-.4 1.2.2 1c0 .3-.3.4-.5.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M328.4 274s-.5.6-1 .9c-.5.3-1.1.7-1.4.6-.4 0 .1-.8.3-.9zm4.5-6.4s-.6.5-.9 1.2c-.3.7-.4 1.3-.1 1.4.3.2.7-.8.8-1.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#231f20",
      d: "M334.6 269.9s-.5-.4-1.2-.6c-.8-.2-1 0-1.2.2 0 .2-.6.5-.3.7.2.2.6-.3.8-.3.2-.1.5-.3.9-.2zm-1-4.5c.3.3.7-.2 1-.6.4-.4.7-1.2.7-1.2l-1 .7c-.4.3-.9 1-.7 1.1m6.9-.1s-1 .4-1.2.8c-.3.4-.7.8-.4 1 .3.3.6-.2.8-.5zm-2 4.6s-.3.6-.9 1c-.5.4-1.2.5-1.3.3-.1-.2.1-.6.3-.7l.8-.2a7.3 7.3 0 0 0 1.1-.4"
    }),
    /* @__PURE__ */ jsx175("ellipse", {
      cx: 328.8,
      cy: 207.4,
      fill: "url(#mx_svg__b)",
      rx: 2.9,
      ry: 4.3,
      transform: "rotate(8.7)"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m295.4 247-1.7 4.2 1.4-.2.7-3.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M296.1 245.1c-.6 0-1.1.4-1.2 1 0 .7.4 1.3 1 1.4.6 0 1.1-.4 1.2-1 0-.7-.3-1.3-1-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m369.7 255.8-4.2 4 1.7.4 2.9-3.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M371.6 254.1a1.5 1.5 0 0 0-2 .6c-.5.7-.3 1.5.4 2 .7.3 1.6 0 2-.7.4-.6.2-1.5-.4-1.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m262.8 233 2.2 4.9 1-1.4-2.6-3.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M261.9 230.9c-.6.4-.6 1.3-.1 1.9.4.6 1.3.7 1.8.2.6-.5.6-1.3.1-2a1.3 1.3 0 0 0-1.8-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M296.6 245.3s.3.1 0 0c-.5 0-1.4.4-1.4 1a1 1 0 0 0 1 1c.5 0-.2.2-.2.2l-.7-.2-.2-.4-.2-.5.1-.6.4-.5.5-.2h.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M295.6 248.1s-.3 0-.5.3a49.4 49.4 0 0 1-.7 1.1l1-2.3.4.2zm76.4 6.4s.3.4-.1 0c-.4-.3-1.8-.2-2.1.5-.4.8 0 1.4.6 1.7.6.2-.2 0-.2 0l-.7-.5-.1-.6v-.7l.5-.6.7-.3h.7l.3.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M369.4 257.3s-.3-.2-.8 0l-1.4.9 2.3-2.2.5.6zm-107-26.7s.4-.1 0 .1c-.5.3-.8 1.4-.3 2 .6.5 1.3.4 1.7 0 .4-.5 0 .2 0 .2l-.7.4h-.6l-.6-.3-.4-.6v-.8l.2-.5.3-.3.3-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#aa8c30",
      d: "M264 233.8s-.3.1-.2.6l.3 1.5-1.2-2.7.7-.2z"
    }),
    /* @__PURE__ */ jsx175("ellipse", {
      cx: 337.6,
      cy: -128.1,
      fill: "url(#mx_svg__c)",
      rx: 4.6,
      ry: 3.1,
      transform: "rotate(62.9)"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "M262.6 241.2s1 .2 1.5 0 .6-.7.7-.8.3-.6.2-1a3.8 3.8 0 0 0-1-1.4l-1-.1c-.1-.1 0-.4-.2-.5-.3 0-1.7 1.6-1.5 1.8.3.3.4 0 .5.1v1.1c0 .3.8.8.8.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "M264 238.1c.1.3.7 1 .9 1 .2.2.8.2 1 0 .3 0 1-.7 1-1a1.5 1.5 0 0 0-.1-.7c-.2-.3-.1-1-.4-1.1-.2 0-.3-.1-.5-.3v-.7c-.3-.3-2.6 1.1-2.4 1.4.2.2.4 0 .5.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "M269.2 237.6c.2-.4.1-1.5-.1-1.8s-.6-.3-.7-.4c0-.1.3-.2.3-.5s-2.6.1-2.4.4c.2.3.6.1.6.3 0 .2-.4.4-.5.6l.3 1.1c0 .2 0 .4.2.5l.6.2h1.4c.1-.1.2-.1.3-.5zm22 12.8s.3.7.8 1h1l.6-.5c.2-.2.4-1.2.3-1.4 0-.2-.5-.6-.5-.8 0-.2.3-.2.2-.4-.1-.2-2-.2-2 .2 0 .3.3.2.2.3 0 .2-.5.5-.6.7-.2.1 0 1 0 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "M293.8 249.5c0 .2-.2 1 0 1.1 0 .2.3.7.5.8h1.2a1.2 1.2 0 0 0 .4-.6c.1-.3.6-.7.5-.9-.1-.2-.2-.2-.1-.4 0-.2.3-.2.3-.5s-2.1-1-2.2-.7c0 .3.3.2.2.4 0 .2-.7.6-.8.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "M297.3 252.5c.3-.2 1-.9 1-1.1 0-.4-.3-.6-.2-.7l.5-.1c.1-.2-1.6-1.6-1.7-1.3 0 .3.3.4.2.5l-.7.1c-.1.1-.5.6-.5.8 0 .2-.3.2-.2.5l.2.4c.1.2.8.9 1 .9zm66 5.5s0 .8.4 1.2c.3.3.6.3.8.4h.7a3 3 0 0 0 1-1c0-.3-.3-.8-.2-1s.3 0 .3-.2c0-.3-1.6-1.1-1.7-.8-.1.2.2.3 0 .4l-.8.2c-.2 0-.5.8-.5.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "m366 258.5-.8.8c0 .2 0 .7.2.8 0 .2.7.6 1 .5.1 0 .3 0 .5-.2.2-.1.8-.2.8-.4l.1-.4c.1-.1.4 0 .6-.2.2-.2-1.2-1.7-1.4-1.5-.2.2 0 .3 0 .4-.2 0-.9 0-1 .2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#e92736",
      d: "M366.4 262.2h1.4l.4-.5c.1 0 .1.2.4.2.2 0 0-2-.3-1.8-.2.1-.1.5-.2.4-.2 0-.3-.3-.5-.3a2.4 2.4 0 0 0-1 .1s-.2 0-.3.2l-.2.4v1c.1.2 0 .2.3.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f7e204",
      d: "M264.2 239c.2.4-.1 1.2-.3 1.4-.1.2-1.3-.1-1.3-.3 0-.2-.1-.6 0-.8.2-.2.6-.7.9-.6.3 0 .6.3.7.4zm.3-1.3c-.2.3 0 .6.2.7.1.2 1 .4 1.2.3.2-.2.6-1.5.4-1.7-.2-.2-.6-.2-.7-.2-.2 0-1 .6-1.1.9m2.7-1.3v.7c.2.1.7.5 1 .5.3 0 .5-1 .5-1.1 0-.2-.1-.3-.3-.4l-1.2.2zm26.1 13.7c0 .4-.7.7-.9.7-.2 0-.7-1-.6-1 .1-.2.3-.5.5-.5s.7 0 .9.2zm1.1-.6c-.2.1-.3.4-.3.6 0 .2.3.8.5.9.2 0 1.2-.5 1.3-.7 0-.2-.2-.5-.4-.6l-1-.2zm2.4 1c-.2 0-.4.3-.4.5 0 0 0 .6.3.8.2.2.8-.2.9-.3v-.4c0-.2-.8-.6-.8-.6m68.6 8.2c-.2.2-.9.2-1 0-.3 0-.3-1-.1-1 .1-.1.4-.3.6-.2.2 0 .6.3.6.6zm1 .1c-.3 0-.5.1-.6.3-.1.1-.2.7 0 .9.1.1 1.2.2 1.3 0v-.5zm1 2h-.5c-.1 0-.4.4-.4.7 0 .2.7.3.8.3l.3-.2-.1-.8z"
    }),
    /* @__PURE__ */ jsx175("ellipse", {
      cx: 438.6,
      cy: -93,
      fill: "url(#mx_svg__d)",
      rx: 2.2,
      ry: 4.5,
      transform: "rotate(47.9)"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "M285.8 199.3s-3.8.3-6.5-.1-2-7.3-2.1-7.5c0-.2-1.6-1.8-1.4-3.3.3-1.5 5.2-5.5 5.8-5.8.5-.1 1.5.3 1.5.3s1.2-1.2 1.6-1.2c.4 0 .9.7.8 1-.2.3-1.9 1.3-2 2-.2.8 0 1.5-.5 2.3-.5.7-1.4 1.7-1.5 2.4-.1.6-.4 1.1 0 1.4.5.2 2.1 0 3.5-.6 1.4-.7 2-1.5 2.1-1.4.2 0-.8 1.7-2.3 2.4-1.5.6-2.5 1.3-3.3 1.2 0 0-.8 2 1.8 2.2 2.6 0 4-.6 4-.6zm-15 16s2 .8 2 3-2.1 4.1-2 8c0 4 .6 4 5.8 8.3a5.7 5.7 0 0 1 1.6 2.5c.3 1.3 1.2 8.9 6.2 8.9s5.8-3.3 5.8-3.3l-2.2-3.1s-1.7.5-2.7.3a3.4 3.4 0 0 1-2.3-2.1c-.6-1.2-.7-4.1-1.6-5.4-2-3.2-5.8-3.7-5.9-7 0-3.4 2.3-3.7 1.7-7.7-.7-4-5.4-5.8-5.4-5.8l-1.9-.8-.7 4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f1a720",
      d: "M284.7 187.6c1.7-.4.7-4.8.7-4.8l-1.2 1s.8 1 .8 2-.3 1.8-.3 1.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "m287.8 231.5-.9-.7c-.6-.4-3.2-2.6-2.8-8.9.5-7.2 11-11 11.6-13.8.8-3.2 3.1-4.5-5.2-11l-2 2.2 3.5 2.6s.7-.4.8.6c0 1-1 1.7-1.2 2.5-.2.7-5.4 4.3-5.8 4.6l-3 2.4s-1.3 1.3-2.5 4.1c-1.3 2.8-.7 6.4-.7 6.4s0 7.6 8.2 9"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "m282.7 235.5.6 2.7-1.7.6h-.7l-.5.2-1.3 1.2h-.3s-.2 0-.3-.8c0-.8-.2-1.5-.2-1.5l1.6.7h.6l.3-.1.7-1.5zm-4.8.5-.8-1-1-.9 1.2-.6h1.2l-.2 1.5zm2.7-4.3s.8.3 1 1l.6 1.2-2-.2-1.4-.4 1-1.4zm-.7 11.9s-.4-.3-.7-.9l-.4-1.6 1.3-.3 1.5.7h.4l-.3.8-1.5 1.3zm5-4.1s-1-.4-1.2-1c-.2-.5-.4-.4-.4-.4l-.3 1.5-.5 1.5.2.2 1.1-.3.9-.9.3-.6zm-4.7 4.8 1.4.7c.8.5 1.2.5 1.2.5l.6-.6.7-1.3v-.1l-3 .3zm4.4-1.2 2.7-1.6.1-1.4-.5-.4h-1.5l-.5 1.8zm-1.8 2.5s1.8.8 5-.4c1.4-.5 1.7-1.2 1.7-1.2l-1.3-.5-1.2 1zm-2.5-20.3-.4-1.4c-.2-.8-.1-1.1-.1-1.1l.9.5 1.3 1-1 .7zm2.2 3.7-.9-1a12.4 12.4 0 0 1-.6-1.2l1 .2 1.1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#c6c7a6",
      d: "M276.6 187c-.2.7-.4 1.9.5 2 .4.2 2.3 0 4.5-2.4 1-1.2 1-2.4 1-2.4l.5-1.3s-.9-.6-2.2.2c-1.3.8-4.3 4-4.3 4z"
    }),
    /* @__PURE__ */ jsx175("circle", {
      cx: 282.5,
      cy: 183.6,
      r: 0.4,
      fill: "#1c242f"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "M279.7 184a17.7 17.7 0 0 0-1.7 1.7s1.4-.4 2.6-1.5c.6-.6 2-.8 2.6-.7.4.1.2-.4 0-.5-.3-.3-1.4-.4-1.6-.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "M284.1 224.5v-2.2l-.9.8-.8 1.1 1.3.5zm-4.5-2.6v-2.3c0-1 .5-3.1.5-3.1l.6 1.4 1.5 2.4.5.4-1.3 1-1.4.4zm4.5-.6.3-1c.1-.6.5-1.4.5-1.4v.1a25 25 0 0 0-2 1.7l.8.7h.5m-3.7-6s.2-.6 1-1.5l1.3-1.8.6 2.4.4 2v.4l-.7.2c-.2 0-1.6 0-1.8-.3zm4.8 2.9.8-.9 1-1-3.2.6.5 1zm-2-6.7s.3 0 1.2-1c.8-.8 1.3-.7 1.3-.7l.3 3.4-1.6-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "m287.3 216.2 2-2-3.3-1 .6 2.3zm1.4-5.2.2-3.3s-.7.3-1.5 1l-1.2.9.4.6 1 .7h1zm2.8-3.2V205s-.5.8-1 1.2l-.9.8.9.6h1zm1.2 3.5 1.6-1.3a6.5 6.5 0 0 0 1.5-1.7l-4.2-.3.2 1.7 1 1.6zm-9.6-13.8-.2 1.8h3.5l-.9-1.2-1-.6-1-1zm6.6 16.2c.2 0 1.1-.8 1.6-1.2.4-.5 1.2-1 1.2-1l-3.3-.3v2.2zm6.3-5.9s.4-1.3.3-2.6c0-1.2-.2-1.8-.2-1.8l-2.5 1.7.4 1.2 1 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "M291.8 204.8s.7-1 .8-1.4v-.4h2l1.1.2h.2l-.9 1.1-1.2.7-1.5.2zm4-2-1.3-2c-.4-.7-.8-1-.8-1l-1 2.7v.3h3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "m271.6 222.2-.3.8s1.3-.7 2.3-.7c1 0 2.1 1.3 2.1 1.3l.2-.9s-1.3-1.3-2.2-1.3c-.8-.1-2 .8-2 .8zm.7-5.8.3.4c0 .1.1-1 1.4-1.5 1.4-.6 2-.1 2-.1s-.2-.8-.8-1c-.6-.1-1.1 0-1.8.5a3.7 3.7 0 0 0-1.1 1.7m4.4 4.4s-.6-1.4-1.6-1.6c-1.1-.3-2.5.5-2.5.5l-.2.7s1.5-.8 2.5-.4c1.1.5 1.5 1.7 1.5 1.7l.3-1zm-5-5.1.4.5s-.2-1.4.5-2.1a4.9 4.9 0 0 1 1.1-1l-.6-.3s-.9.5-1.2 1.1a3.2 3.2 0 0 0-.2 1.8m-.5-2.3c.3-.8 1.2-1 1.2-1l-.3-.3h-.5s-.5.3-.9 1c-.3.9-.3 2-.3 2l.6.3s-.1-1.4.2-2m7.8-19.2c.9-.4 1.5-.3 1.5-.3s-1.3 1.3-.7 2.9c-.7 1.3-.9 2.3-.9 2.3h.7l.4-1.8c.8 1.3 2 2 2 2h1s0-1.3.4-2.4h.1a5 5 0 0 0 2 1.5v-.4s-1.1-.6-1.7-1.5l-.1-.1a4.2 4.2 0 0 1 1.8-1.7l.7.6.2-.2-.5-.7h-.6l-1.8 1.7a9.2 9.2 0 0 1-.8-1.5l-.4-.2s-1.1.1-2 1.7c-.2-1.2 1.1-2.4 1.1-2.4v-.5l-2.4.6c-1 .3-1.7 1.2-1.7 1.2v.8s1-1.1 1.7-1.6m1.5 2.2c.6-1 2-1.5 2-1.5s0 .7.7 1.7c-.5.9-.8 2.2-.8 2.2s-1-.6-1.9-2a1.6 1.6 0 0 1-.2-.3zm-7.6 21.1v.8s.8-.9 2-1c1.2 0 2.3 1 2.3 1s0-1-.2-1.2c-.1 0-1.1-.6-2-.6s-2.1 1-2.1 1m21.4-11.2-.5-1 .6-.3a12.5 12.5 0 0 0 1.7-1.6l-.4-.6h-1.6l-1.4-.1.5-1.7.6-1.4-.6-.5s.2.5-.8.6c-1 .1-2.8-.8-2.8-.8v.4l2.5.7c.6 0 1-.1 1.2-.3l-.5 1.3-.3 1 .2.2v.8l1.4.1 1.6.1s-.8 1-1.7 1.5a2.3 2.3 0 0 1-.3 0l-1-1.5-.1.5.7 1.2a5 5 0 0 1-1.5-.1l-.4.4v2.5l-1.8-.6-.3.3v-.1l-.4.4s-.4 1.4-.3 3.1v.1a4.9 4.9 0 0 1-2.4-1.3l-.4.3s-.3 1.4 0 3.2c-1.3-.3-2.5-1.5-2.5-1.5l-.5.5a60 60 0 0 0 .7 4.7 4.9 4.9 0 0 1-.7 0c-1.4 0-2.3-1.3-2.3-1.3l-.4 1s.6 2.7 2 4l.4.2c-1.3 1-2.8 1.2-2.8 1.2v.9a44.7 44.7 0 0 0 2.2 1.5 4.8 4.8 0 0 1-1.6 1l.2.5 1.8-1.3 1.8.5v-.5l-1.5-.3.1-.1c.5-.4 1.4-1.8 1.4-1.8v-1s-.5 0-1.1-.6c1.8-1.2 1.9-1.8 1.9-1.8l.4-.6s-.7-.3-1.1-1.2l2.9-.7.2-.2s-.7-1.2-1-2.6l3 .6.4-.4-.5-2.4c1.8 0 3.2.2 3.2.2l.3-.3s-1-1.9-1-3a4.8 4.8 0 0 0 1 0h3l.3-.5s-1.4-1-1.7-1.5m-10.5 15.5s-.5 1-1.4 2l-.2.2a4.6 4.6 0 0 1-.5-.2c-1.1-.6-1.4-1.3-1.4-1.3l2.5-1.6zm.9-3.2-2 2a4.1 4.1 0 0 1-.4-.5c-.8-1.2-2-2.1-1.8-3.8 0 0 .7 1.2 2.2 1a14 14 0 0 0 1-.1c.4 1 1 1.4 1 1.4m2-2.5-2.7.7a5.3 5.3 0 0 1-.1-.5c-.5-1.6-.5-4-.5-4s1 .8 2.6 1.2zm-.5-3c-.2-1.4.1-2.9.1-2.9s.8.8 2.3 1c.1 1.5.3 2.1.3 2.1zm5.8-2.2s-1 .4-2.8.1a15.3 15.3 0 0 1 0-.5 23 23 0 0 1 0-3l2.3.7a10 10 0 0 0 .5 2.7m0-3.1h-.2V205s1 .3 1.7.2c.2.4 0 .5.5 1.2.4.7 1.1 1.3 1.1 1.3s-2.3.2-3.2 0zm-7.6 18.6-.1-.5s-1 .7-1.2 1.4a1.6 1.6 0 0 1-.3-.1l-2-.8.2.4 1.8.8h.2l-.5 1.4.2.3.5-1.7 1.2.1-.2.8-.4 1.5.5.3h2l-.3-.4-.7-.1h-1.1l.3-1.2.3-.8-.3-.7-1 .2a3 3 0 0 1 .9-.9m-11.3-1.3c1.3 0 2.3.9 2.3.9v-.6s-1-1.4-2.1-1.4c-1.2 0-2.5 1.2-2.5 1.2v1.2s1-1.3 2.3-1.3m13.3 19.4c-1.3.6-2.7.6-2.7.6l.8-1.5c2.5-.8 3-2.4 3-2.4l-.2-.7s-.6 1.6-2.6 2.4c.4-1.2.7-3.2.7-3.2l-.7-.2s-1 1.3-2 1.6a7.7 7.7 0 0 0 .8-2.7l-.3-.5s-.7.6-1.7.8a1.8 1.8 0 0 1-.6 0c.6-.8 1.7-3.2 1.7-3.2l-.2-.5s-.8 2.1-1.7 3.2a10.6 10.6 0 0 1-.3.4c-1-.3-2.2-1-2.2-1l.1.3s.8.6 1.8 1a27.3 27.3 0 0 1-1.3 1.2v1l3 .4c-1 1.6-2 2.1-2 2.1l.5.7s1.3 0 3.7-.6c-.6 1.2-1.2 1.8-1.2 1.8s2.2.2 3.7-.6 2-1.6 2-1.6l-.4-.4s-.4 1-1.7 1.6m-6.9-4 1.2-1.5c1.6.3 2-.1 2-.1s.3.8-.6 2.3c-1.1 0-2.6-.8-2.6-.8zm1.4 3 1.3-1.6.3-.3c1.5 0 2.3-1.3 2.3-1.3s.2 1.2-.5 2.7c-1.9.7-3.4.5-3.4.5m-1.9-9.8c1.5 0 3.3.7 3.3.7l-.2-.7-2.9-.6a3.6 3.6 0 0 1 1.6-1.6l-.5-.3s-.6.1-1.4 1.5a4.1 4.1 0 0 0-.2.4 4 4 0 0 0-.3 0 5 5 0 0 0-2.4.7l.2.4s1.1-.5 2.3-.5a25.7 25.7 0 0 0-.7 2.4l.3.6zm-3-6.2-.3-.7s-1.5-.6-2.7 0c-1.1.5-2 1.9-2 1.9l.5.9s.8-1.5 1.9-1.9c1-.3 2.6-.2 2.6-.2m3 2.4-1-.6s-1.7.5-2.2 1.1c-.6.6-1.1 2.1-1 2.5.2.5.7.7.7.7s.3-1.5 1.1-2.3c.8-.8 2.4-1.4 2.4-1.4m-3.9-.5a4.5 4.5 0 0 1 2-1l-.7-.5s-1.5.2-2.2.9c-.8.7-1.8 2.1-1.8 2.1l.9.9s1.2-1.8 1.8-2.4m5.2-44.7c.8-1 1.6-1 1.9-1h.6a9.3 9.3 0 0 0-.8 2.5c-.2 1-.7 1.2-1 1.9-.4.7-1.1 1.8-1.2 2.8 0 1 .3 1.6.5 1.7.3.1.8-.4.7-.7 0-.3-.3 0-.4 0-.2 0-.2-.3-.3-.9-.1-.6.7-2.2 1-2.8.3-.5 1-1.1 1-2l.7-2.5c0-.1-.4-.2-1.3-.3-.6 0-1.5.5-1.9 1.2-.4.6-1.7 1.1-1.7 1.1s1.4 0 2.2-1"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "M285.2 194.5h-2.5l.7 2zm-3-.1-.5-.4a1.5 1.5 0 0 0-.3-.3l-.9.5-.5 1.9.3.3 2-2zm-.3 5-1.8-2.7-1 2.2.5.2 1.2.2h1.1zm7.4 44.7a9 9 0 0 1-4.8 1.5 6.7 6.7 0 0 1-3.4-1 4 4 0 0 1-1.5-1.7c-.6-1.1-.8-2.5-1-4-.3-1.3-.5-2.6-1.1-3.6-.8-1.3-2.4-2.1-3.8-3.3a7.3 7.3 0 0 1-2.8-5.2 8.1 8.1 0 0 1 0-.8c0-1.7.5-3.2 1-4.5s1.2-2.5 1.2-3.5v-.5c-.3-.7-1-1.4-1.5-1.9s-1.2-.8-1.2-.8l-1-.2-.1.3 1 .2v-.1.1l1.3 1c.5.4 1 1 1.1 1.5a1.9 1.9 0 0 1 0 .4c0 1-.5 2-1 3.3a11.7 11.7 0 0 0-1.2 4.7v.8a7.7 7.7 0 0 0 3 5.5c1.5 1.1 3 2 3.7 3.2.8 1.2 1 3 1.3 5 .2.8.4 1.7.8 2.5s.9 1.5 1.6 2a7 7 0 0 0 3.7 1c2.7 0 4.9-1.6 4.9-1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "M287.2 239.2a2.6 2.6 0 0 1-1.3.4c-.5 0-1.1-.2-1.7-.8a4 4 0 0 1-1.2-2.3c-.2-.9-.3-2-1-3.3-.5-1.5-2-2.6-3.5-3.7-1.3-1.1-2.6-2.2-2.9-3.4a3.3 3.3 0 0 1 0-.7c0-1 .4-2 .8-3.1a10.8 10.8 0 0 0 .9-4.8c-.2-2-1.7-3.5-3.2-4.5a14.1 14.1 0 0 0-2.8-1.4l-.1.3h.2c.5.3 1.8.9 3 1.8 1.3 1 2.4 2.2 2.6 3.8v.8c0 1.5-.4 2.7-.9 3.9s-.9 2.2-.9 3.2l.1.8c.3 1.3 1.6 2.4 3 3.6 1.5 1 3 2.2 3.5 3.5.6 1.3.7 2.4.9 3.2.2 1 .4 1.7 1.2 2.5.7.7 1.4.9 2 .9a2.8 2.8 0 0 0 1.4-.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "M296.4 231.6s1.7.4 1.6 1.8a13.3 13.3 0 0 1-.8 3.4l-2.4-2.2 1.3-1.2.5-.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M266.4 214.5s-1.7.6-2.1-.1c-.4-.8-.2-1.4-.2-1.5 0-.2-1-.3-1-1.3.1-1 1.4-.9 1.6-.9.3 0 .4-1.5 1.3-1.4.8 0 1.2 1 1.2 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M268.3 215s-1.5.8-2 0c-.4-.7 0-1.6-.1-1.8-.2-.1-1-.4-.9-1.3.2-.9 1.1-.6 1.4-.8.3-.1.6-1.4 1.5-1.2.9.3 1 1 1 1l-1 4.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M270.8 215.3s-.5 1-1.5.8c-1-.2-.7-1.7-.9-2-.1-.3-.9-.5-.8-1.4.2-1 1.1-.9 1.5-1 .3-.1.7-1.6 1.4-1.4.7.3 1.3 1.1 1.2 1.5 0 0-1.5.5-1.7 1.5-.2 1 .8 2 .8 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#af7029",
      d: "m293.7 231.2-2.2-2.6c-.9-1.3-2.3-2.7-2.3-2.7l-2.2-1.1-1.4-2.4-.2-2.8.6-1.6.8-1.2s-4.6 1.7-2.2 10.5c1 3.8 3.5 4.3 3.5 4.3l4.3-.3h1.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#816c2a",
      d: "M291.6 201.7c.4 0 .6.2.8.4l.2.6v.4c-1.6 3.4-4.8 5-7.8 7a13.8 13.8 0 0 0-3.8 4 12 12 0 0 0-1.6 6.8c.1 5 2 7.8 4.2 9.3a9.7 9.7 0 0 0 5.2 1.5h.4l1.4-.1a35.8 35.8 0 0 1 3-.2l1.8.1.9.4a.8.8 0 0 1 .2.5c0 .4-.3.8-.6 1.2l-1 .7.2.3a4 4 0 0 0 1-.8c.4-.4.7-.9.7-1.4 0-.2 0-.5-.3-.7-.2-.3-.6-.4-1.1-.5l-1.8-.1c-2 0-4.5.3-4.5.3v.2-.2a6.8 6.8 0 0 1-.3 0 9.4 9.4 0 0 1-5-1.5c-2.1-1.4-4-4-4-9v-.4c0-2.7.5-4.7 1.5-6.3 1.4-2.4 3.7-3.8 6-5.3a14 14 0 0 0 5.5-5.7v-.5c0-.2 0-.6-.2-.8-.2-.3-.5-.5-1-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M297.8 232.7s-1 2-1.4 2c-.2 0 1 .3 1.3.8l-.3.5s-1.2-.9-2-1v-.6l1.1-.7a4 4 0 0 0 .9-1.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3d",
      d: "m302 234-2.7.8-1.3-1s0-1-.5-1.5l-1.6-1c-.6-.2-2.5-.2-2.5-.2l-5-5.3 2 .2 2.8-.4 2.7-.2 1.4.2 1.6.4.8.7.8.8.8 1.3.6 1.6.2 1.7v1.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#af7029",
      d: "M302.2 233.8s-1 .3-2.2.3c-1.3 0-2-.2-2-.2l-.2.9c-.2.9-.5 1.3-.5 1.3v3.2l2.6.5 1.4-.5.7-3.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3d",
      d: "M301.5 232.5v1.2l.6.2v-1.2zm-2.5-30-.3-2.1-.8-1.5-1.1-1.5-1.2-1.3-.6-.5-.3-.5-2.9.2-1.4 1.7s3.8 2.8 5.3 5.8a7 7 0 0 1 2.8 1.7l.1-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#af7029",
      d: "M296.3 205c0 2.2-.5 3.2-.8 3.7l1.8-2 1.2-2.2a7 7 0 0 0-2.8-1.7c.4.7.6 1.4.6 2.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#816c2a",
      d: "m300.3 237.9-1.4-1.6c-.6-.6-1.3-1-1.3-1l-.2.4h.1l1.2.8a17.6 17.6 0 0 1 1.3 1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#6f5b24",
      d: "M302 235.5s-.3 1-1.3 1.8c-1 1-2.2 1.5-2.2 1.5l2.8 1 1.9-1.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#404118",
      d: "m302.4 237.8-.2.3-.5.5-.4.5.6-3 .6 1v.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "none",
      stroke: "#78732e",
      strokeWidth: 0.2,
      d: "M285.8 199.3s-3.8.3-6.5-.1-2-7.3-2.1-7.5c0-.2-1.6-1.8-1.4-3.3.3-1.5 5.2-5.5 5.8-5.8.5-.1 1.5.3 1.5.3s1.2-1.2 1.6-1.2c.4 0 .9.7.8 1-.2.3-1.9 1.3-2 2-.2.8 0 1.5-.5 2.3-.5.7-1.4 1.7-1.5 2.4-.1.6-.4 1.1 0 1.4.5.2 2.1 0 3.5-.6 1.4-.7 2-1.5 2.1-1.4.2 0-.8 1.7-2.3 2.4-1.5.6-2.5 1.3-3.3 1.2 0 0-.8 2 1.8 2.2 2.6 0 4-.6 4-.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      stroke: "#4d2a15",
      strokeWidth: 0.4,
      d: "M318.7 170.6s-7-1.3-7 4.5c.1 1.9.5 2.5 2 3 1.5.3 4.4.5 7 2.7 2.5 2.3 2.7 4 2.7 5.3 0 1.4-.7 2.6-.7 2.6l1.6 7.7 1.6 5.7 4.8-2.7 2.8-8.5-3.6-15.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M325.6 200s2.5-1 3-3c.3-.5-2.4-2.9-2.4-2.9-.1 0 1.3.7 2 1.3.6.6 1.1.9 1.3.8.2-.1 1.3-2.7.9-3.3-.4-.6-1.1-2-2.1-2.6-1-.7-2.4-.6-2.4-.6s1.9-.6 2.8 0c1 .5 1 1 1.1.9.1-.3-.2-2.9-.6-3.7-.4-1-.8-1.3-2-1.6-1.1-.2-2.3-.1-2.3-.1s1.6-.9 2.8-.6c1.3.3 1.3 1 1.4.8 0-.1-.6-2.4-1-3a6.7 6.7 0 0 0-2.1-1.8l-1.8-.2h-.6s1-.6 2.1-.5c1.2.1 1.3.5 1.4.4.2 0-.1-.2-.8-.7s-4.2-2-4.2-2h-3.3s0-.8 1-1c.9-.1 1.1.1 1-.1 0-.3-2.6-.8-2.6-.8H316l-3 .3s.2-.5.7-.9c.3-.3.9-.5 1.3-.6 1-.3-.6-1.1-.6-1.1l.9-1.3 3.9.3 8.2 4.8 3.9 3.3 2.4 6.2-.7 10.8-5.5 4.5-2.4.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M318.4 173.3s-.2-.7-.2-1.7.2-.9.2-.9-2.7-.3-4.6 1.2c-1.9 1.5-.8 4.1-.8 4.1s.8-.8 1.9-1.2c1-.4 3-.3 3-.3.2-.2-.4-1-1.1-1.1-.8-.2-2.1-.2-2.1-.2s.8-.5 2.2-.4c1.4.1 1.6.5 1.6.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "m326.7 200.9-1.8.6 1 7.5 7.2 12.1 3.7-.6 1.3-2.3 1 .5c.4.4 1.8 2.8 3 3.3 1.1.4 1.7.2 2.7 1 1 1 4.9 6.6 5 6.8.3.2-.1-2.4-.1-2.4l-1.2-3.4-1.4-2.4-.3-.6h2l1.2.8 2 1.5.9 1.2.5 1.2.2 1 .5 1.6 1 2.3 1.3 2.1.4-.9-.6-2.5-2-6-1-2 1.9 1.2c.4.1 1.8 2.2 1.8 2.2l.9 2.2.6 2 .4 1.7.7 1.9 1-.7-.1-1.3-1-4.2-.4-4.5s.6 0 1.2.7a9 9 0 0 1 1.2 2.3l.5 4.1.7 3.8 1.2 3.8 1.2 2.4.9 1.3v-2l-1.6-16 .2-.6s.2-.1.8.7c.5.7 1 1.9 1 1.9l.5 2.5.2 1.7.3 3.3.5 3.5 1.6 3.8.9 2 .5-2.4-.8-17.1.4-.5s.9.7 1.2 1.3l.8 1 .6 3.8.4 10.7.4 2.8 3.2-28.2 2-.4.2-.6-1.5-1-3.2-5-2.1-4.9-3.8-7-6.6-8-5.2-4.3a20 20 0 0 0-1.9-1.3l.4-1 1-1.7-.1-.1h-.9l-2.2.4-2.2-.7-4.4-3-4.6-2.3-2.8-1-6.6-1.6-6.6-1h-3l-2.6.5s-1.4.6-1.8 1.5c-.5.8-.5 1.4-.4 2.6.2 1.3 1 1.9 2.8 2.7 1.8.7 6.2 3.6 6.2 3.6l2 2.1.8 1 .2.8 1.4 11.1-2.8 6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M333.8 218.2s1.2 2 2.9.5c1.7-1.6-.8-6-.7-6.3 0-.3.7-.3.7-.3l1.3 2.2s.7 1.3.4 3.2c-.2 2-2.1 3.7-2.1 3.7l-2.2-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m375.3 244.2-1.6-4.5-.4-3.5c0-.6-.3-7.9-.5-9.3 0-1.4 0-3-.2-3.1l-1.6-2.2-.7-.7.5-.3s.6.6.7.3c.2-.4 0-2-.6-4.5-.7-2.5-3.9-8.3-3.9-8.3l.4.2.9 1 1.8 1.5 4.1 1.5 2.2.3 1.4 2.9s1 4.9 1 7.4c0 2.4-.2 4.5-1.2 7-1 2.4-1.2 10.3-1.3 11.5-.1 1.3-.6 2.5-.6 2.5l-.5.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M375.3 231.2s.8-1 1.2-2.4c.4-1.4.5-12.4-.8-13.7a10 10 0 0 0-4-2.3c-.2 0 1 3.5 1 3.5l.8 1.4.6 1.8c.1 1 .9 3.1 1 6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M369.3 238s.5-5.1.3-9c-.3-3.7-.6-4.2-1-4.9a32.3 32.3 0 0 1-2.5-6.3c-.9-3.2-1.5-5.6-2-6.2-.6-.6-1.7-2-2-1.6-.3.3-.3 1.1-.3 1.1l-1.5-.4-.4-1 .5-1.6v-.7l-.3-1.1 2 1.6 4.2 2.8 2 8.6 2 5.3.2 9-.2 8-1-3.5zm2.4-24.7s1 1 1.7 1.4c.7.4 1.8 1.1 1.6 1.2a8 8 0 0 1-2-.8l-1.2-.8v-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M363.7 236s.8-1.8.7-4.1a49 49 0 0 0-1.6-8.6c-.4-.7-2-1.7-3.5-4.8s-1.3-3.8-2.3-5c-1-1-2-2.4-2-2.4l.3-3.3 3.6 1.8 1.6.8 1.8 8.7 1.6 2.5.7 3.5.9 8 .4 6.6-.2.5zm-4.2-3.7s.1-2.5-.5-4.8c-.7-2.3-1.1-4-1.9-4.8-.7-.7-2.5-2.6-4.1-5-1.6-2.5-3.9-5-3.9-5v-3.3l2 1.5a57.1 57.1 0 0 1 2.4 1.2l1 3.7 1.2 2.7 1.8 2.4 1.2 1.1.7 4 .4 2.3 1 3.2-.4 1.7zm-3 0-1-.9s.6-.6.3-2c-.3-1.2-.6-2.4-1.2-3.7-.6-1.2-.7-2-1-2.3a121 121 0 0 0-4.5-4c-1-1-2.7-2.6-3.7-3.3-1-.6-1.8-.8-1.8-.8l-.5-4s1.3 1.8 2.1 2a54.7 54.7 0 0 0 2.1.8l2.8 5 1 1.3 2.6 2 1 2.2.9 2.5 1 3.4.1 2zm-5.5-1s-1.7-2-2-3.2c-.2-1.2.2-1.2-.3-2.6-.5-1.4-2.3-3.5-3.7-4.6-1.4-1.2-3.4-2.8-3.3-3.8.1-.9.4-1 .4-1l.8.8 4.5 4.7 1.4 2.5 1 3.1.7 1.5.7 1.8zm16-23.3s3.1 3.8 4 .3c.3-1.6-1.2-4.6-1.2-4.6s-2.8-5-3.8-6.2l-5.7-7.3-3.5-1.6 1.2 2s2.6 2.6 5.9 8.4c3.3 5.7 2.7 8.9 2.7 8.9zm-17.8-23s6.1 5.2 10 10.8c4 5.7 5.5 9.4 4.7 10.2-1 .7-3.4-.4-4.4-2-1-1.6-1.8-4.4-5.5-8.6-3.7-4.2-5.5-4.8-5.5-4.8l-2.7-4.3zm-3.2 12.5s3.6 3 6 5.4a37.4 37.4 0 0 1 3.4 4.2l1.4 1.4s-.9-1.5-.4-2c.5-.6 1.1-.3 1.1-.3l-11.5-12zm-.7.3s1.2 2.3 3 4.1a464.6 464.6 0 0 0 4.1 4l.8 2.9s-5.2-4-5.2-3 1.2 3 1.2 3l-1.6-1-2.2-3.1-1.3-2.8-1.5-3.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M329.5 210.2s2.7 2.4 4.2 0c1.5-2.3.3-5 .3-5s3.9 5.6 5 .3c.2-1-2.4-4.6-2.4-4.6l1-.9 1.9 3.3s1.8-.8 1.8-3-1.9-5.3-1.9-5.3l1.8 2s3.6 0 3.7-2c0-2.2-3-4.5-3-4.5s2.4.1 2.4-1.3c0-1.4-3.4-2.4-3.4-3.3 0-.9 1-2.4 2.5-1.5 1.5.8 3.5 1.4 4.4-.2.8-1.6-.1-2-.1-2l-2.1-.4-3.4-1.8-2.7-1-2.8-.4 1 2 .8 5.8v2.6l.5 5.8-1.4 4.7-.7.9-.5.6-1.2 2.6-1.6 1.8-2.2 2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M348.8 220.9s-.7-1.7-2.2-2.9a7.8 7.8 0 0 0-3.8-1.2l4 4.2zm5.6 1s-1.3-2.6-2.8-4.2c-1.5-1.6-2.5-3.6-3-3.6h-.6l.4 3.3 2.7 2.7s2.6 2 3.3 1.8m4.6-.2s-.6-3-2.2-6c-1.5-2.8-3.1-4-3.1-4l.4 3 1.2 3 2 3zm3.8-1.7s1-6.2 0-8c-.9-1.6-2.7-2-2.7-2l-.6 1 .6 4.3 1.5 3.4zm3.7-10.3s.9.4 2 2.5a40 40 0 0 1 2.6 8.6c0 .3-.5.2-.7.2-.2-.1-3.9-6-3.9-6l-.6-5.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M340.4 216.8s2-.4 2-1c0-.8-2.4-2.2-2.2-3.3 0-.5 2 .1 2.1-.3.1-.4-2-3.6-1.3-4.4.6-.8 2.4 3.5 2.4 3.5s1 2 .7 3.2c-1.2 3.6-3.7 2.3-3.7 2.3m4.6-4.4c.1-.3 3.1.4 3.1.2.2-.7-2.7-3-2.7-3s-.6-1.2-.4-1.4c.2-.2 2 .2 2 0 .2-.3-2-3.2-2-3.7s.6 0 .6 0 1.7 1.7 2.6 3.2c1 1.4 1.8 2.6 1.5 4.9-.4 2.5-5 .6-4.7-.2m13.6-4.6s-.5-2-.2-2.3l1.1-.5s-1.6-1-2.4-1c-.7 0-.8-.2-1 0-.2.4 1.3 2.4 1.3 2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M349.4 209.4s4.7 1.2 4.9.8c.2-.3-3.7-4-3.7-4s-.3-.6-.2-.8c0-.2 1.7-.3 2.2.1s0 1.2.1 1.5c.2.3 1.7 2.5 2 2.1.2-.3-.4-3-.3-3.3.2-.2 1.8 1.6 2.3 1.9.4.3 3 2.3 3.3 1.4.3-1 .4-1.1.3-1.7 0-.6.9 2.6-.3 3-1.2.4-2.6-.4-2.6-.4l-1.1-.8-.6-.7s.7 2.5-.2 2.7c-.8.3-1.7.2-1.7.2l-2-.2zm10.7-3.2s5 3 5.4 2.5c.5-.5-1.2-7.5-1-8.2.3-.6 4 7.9 2.2 9-1.4 1-2 .3-2 .3l-2.5-1.3zm13.8 12.6 1 .5.7.2-1.4.2-.3-1zm-4.8-16.4.7.3.7.3s-.4.3-.6.2h-.4zm-1.4-2.5s.5.3 1.1-.2c.7-.4.7-.8.6-1 0-.2-1-.2-1.4-.5-.3-.2-.3-.6-.3-.6h-1.1l-.4.1zm4.3 14.4s1.5 1 2 1c.4 0 1.1.5 1 .6 0 .1-1.2.2-1.8-.1-.6-.3-.7-.1-.7-.1zm-8.1-22.5h.6c.3 0 .5-.2.6 0 .2.2 0 1.2-.3 1.5l-1 .5a48.4 48.4 0 0 1-1.6-2.2zm-7.1-6.4h1.5c.5 0 1 .3 1.5.6.4.3.9 3.3.6 3.8-.2.6-3.6-2-3.7-2.1 0-.3-1.5-2.5-1.5-2.5zm-3.2-1.4s2.5.2 2.2-1.3a3.2 3.2 0 0 0-1.3-2.3l-2.9 2.1zm-6.5-2.8s.7.4 1.4 0c.7-.2 2.6-2.7 4-3 1.4-.3 1.7-.3 2 0 .2.4 0 1.8-.2 2.2-.3.4-4.4 2-4.4 2l-1.5-.1a9.6 9.6 0 0 1-1.3-.5zm-.7-4.5c-.7-1.4-1.7-2-2.2-1.9-.4.1 1.4 1.5 1.7 3.5.3 2 .2 3.3.2 3.4l.8.1.2-.7.1-.5v-.5l-.1-1-.2-.9-.2-.6zm-5.8-2a15.4 15.4 0 0 0-5.5-3.7c-.2 0 4 2.5 5 4 .9 1.7.9 3.9 1.3 4.2.4.3.8-.2.9-.2 0 0 .3-.5.2-.7l-.2-1-.7-1-.4-.8zm-5.5-2.3c-2.4-2-6.6-3-10-3-3.5-.2-5.3.2-4.8 2s2 2.8 5 2.8c2.9 0 3.6-.3 5.2.2a9.7 9.7 0 0 1 3.6 2c.5.5-1.1-1.5-2.6-2.6-1.5-1.2-2.5-1.7-2.5-1.7s-.3-.7 1.7-.4c2 .3 4.7 1.6 5.5 3.3.7 1.7.6 2.6.6 3 0 .3.7-.2.7-.2l.3-.9s0-.6-.3-1.4c-.4-.7-.5-1-1.4-2-.9-1.1-1-1-1-1zm-9.6 28.5c1.5 0 4.8-2.8 5.2-6.7.5-4-1.9-11.9-2.5-12.7-.5-.9 1-.4 1.7.4a25 25 0 0 1 2.5 10.6c0 4.2-.8 5.3-3 7.5-2.2 2-4 1.8-4 1.8zm5.1 11.6s.7 1 1.6.6c1.5-.5 3.8-1.7 3.8-3.8 0-1.4-1.8-2.7-1.9-3.2v-1l1.6.4.5 2.2s.6.7 1.3.4c.6-.2 2.5-1.6 2.2-3-.3-1.2-2-2.9-2.2-3.5-.2-.7 0-1.2 0-1.2l1.6.2.4 2s.4.6 1.3.4c.8-.1 2.4-1.7 2-2.5l-1.5-2.6v-.9l.5.4s.6.2 1.8-.1c1.1-.4 2.3-1.2 2.3-2s-1-1.6-1-2v-.6h.8l1 1.2.1 1.4-.3 1.2-1.4 1.6-1.4.6h-.4l.8 1.4-.2 2-1.3 1.2-1.7 1-.1 1.9-1 2-2 1.2h-.7l-.2 1.2-1.4 2-2.3 1.5-1.7.3-1-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M343.4 191.4s4 1.1 3.8-1.4c0-1.3-3.8-4.5-4-5-.3-.6-.2-1.3-.2-1.3l1.9 1.8s2.5.6 3.2-.9c.7-1.4.1-2.3 0-2.3l.6-.1 1.1.2-.1 2.2-1.3 5.5s.3 2.2-1.4 2.3c-1.7.2-3.6-1-3.6-1m3.7 29.5s0-1.1-.8-2c-.9-.7-2.5-1.4-2.8-1.6a63 63 0 0 0 2.8 3.5zm5.6.2s-2-2.4-2.3-3.3c-.5-.8-1.5-2.6-2.3-2.7-.8 0 .8 3 .8 3l3.2 2.9zm5.4 0-2.1-4.2c-.4-.9-1.3-3.4-2.3-4.1-1-.7.1 1.1.1 1.1l1.1 3.3 1.9 2.9zm3.9-2.4s-.1-2.7-.5-4.6c-.3-1.8-1.7-3.4-1.8-3.3v3.3zm8.1 2-2-4.7c-.5-1.6-1.8-4.1-2-4.2l.4 3 1.7 4.7zm7-8.5s-1.2-1.2-3.9-2.3c-2.7-1-5.4-1.2-5.4-1.2l.3.4 1.3 1 2.8 1.5 3.7.9 1.3-.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M348.2 213.8s0 2.4 1.3 3.8c1.2 1.5 4 4 4.6 4.6.6.5 1 3.4 1.9 5.8.8 2.4 1 4.4 1.4 5.1.4.7 1.1 1.8.5 1.7-.5-.1-1-.8-1.4-1.7-.3-.9-.2-.9-.2-2 0-1.3-1.8-7.5-2.7-8.1-.9-.7-4.8-4-6.4-6.3-1.5-2.3-1.2-2.8-1.2-2.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M354.6 229.3c-.8-1.7-1-3.3-1.2-4.3a16 16 0 0 0-4.4-4.2c-.6-.3-1.9 0-2.4-.3l-3.7-4s-.5.5-.3.6c.1.1 3.4 3.7 4.6 4.8 1.2 1.2 1.9 3.7 2.7 5.7.9 2 .5 1.6.6 2.5.1 1 .7 1.5 1.3 1.5.6 0 .8-.2.6-.4a10.3 10.3 0 0 1-2.2-3.5c-.7-1.7-1.5-4.9-2.5-6l-.3-.3 1.3-.2c.8 0 4.1 3 4.4 4 .3.8 0 1.2 1.4 4.2s2 3.7 2 3.7h.2s-1.2-2-2-3.8zm-5.2-19.9s2.5 1.5 3.2 1.7a9.8 9.8 0 0 0 1.2.3s.4 4.4 2.1 6.8c1.8 2.5 3.2 3.4 3.2 3.4s0 4.8 1.4 8c1.3 3.3 1.5 7.3 1.2 8-.3.6-1.4-2-2-4.3l-2-6.2a13 13 0 0 0-2.5-4.4c-.8-.7-.2-.6.3-.2.4.4 1.7 2 2.5 4.5s1.1 5 1.5 5c.5 0 .8-.3.8-.9 0-.4-.6-1.8-1-4.1a17 17 0 0 0-1.2-4.7c-.4-.6-1-.7-2.4-3.4a20.3 20.3 0 0 1-2.5-5.3c-.2-1.2 0-1-.2-1.3-.2-.1-.4 0-1.6-.6-1.1-.6-2-2.3-2-2.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M355.7 208.5s1.4 1.2 2.3 1.5c.8.4 2 .4 2 .4s-.3 4.2 1.3 6.9 3.3 4.2 3.3 4.2.3 1 .8 6.8l.7 8.3c.1 2.3.2 10.6-.1 10.3-1.3-1-.2-5.4-.9-7.3-.6-1.8-1.6-2.1-2.8-7.4-1.2-5.2-.4-6.4-1.3-8.3-.9-2-2-2.2-2-2.2s1.6.4 2.3 2c.6 1.6.7 6 1.3 8.2 1.2 4.9 2.9 7.4 2.9 7.4s-.4-6.2-.8-9.7c-.5-3.5-.5-6.4-1.1-7.7-.7-1.4-2.1-2.4-3-4.2-.8-1.8-1.1-5.3-1.5-6.2-.4-.9-.6-.6-1.2-.8-2-.8-2.2-2.2-2.2-2.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M360.1 206.2s1.3 1.5 3.1 2.6c1.8 1 2.8.7 3 1 .3.2-.3 3.8 1.6 7.2 1.9 3.4 2.6 3.5 2.6 4l.6 13.9c.3 3.4.5 14.8-.9 14.8s-.1-8.5-.8-10.4c-.7-2-.7-1.4-1.3-3-.7-1.6-.7-7.8-1.8-11.5-.8-2.8-1.6-3.2-1.6-3.2s1.4.7 2 3c.6 2.2.8 10 1.5 11.1.8 1.3 1.8 2.8 2 4a157 157 0 0 0-.4-15.6c-.3-1-3.5-6.6-3.7-9.7-.3-3.2-.4-3.5-.7-3.7-.2-.3-1.1 0-2.6-1.5-1.5-1.4-2.6-3-2.6-3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M367.3 208c0-.3 1 1.7 3.7 2.8 2.9 1.2 5.6 1 6 1.3.3.3 2 4.5 2.1 10.2.1 5.6-1 5.1-1.8 10-.9 4.9-1 14.8-1.5 16.3-.2.5-.5.8-.8 1.7-.3 1 .2 2.8-.7 2.8-.8 0-1-1.4-1-2.1 0-.8 1-3.5 1-6.2s-.6-3-1-6.2c-.4-3.3-.4-13.5-.8-14.5-.3-1-2.1-3.1-2.1-3.1s1.9 1.2 2.4 2.6c.4 1.3.5 12.7 1 15 .5 2.4.3-.5.5-1.8s.9-7 .8-10c-.1-3-1.4-9.4-2.4-10.5 0 0 .5.6 1.1 2 0 .1.4.5.8.7l1 .5s-.6 0-1-.3c-.4-.1-.6-.4-.6-.4a23.9 23.9 0 0 1 1.3 8c.1 5.2-.7 16.4.1 16.5.8.2.7-6 1.5-11.2.8-5 2-5.8 1.6-9.9-.3-4.1-1.4-8.6-2.3-9.2-.9-.5-3.4-.3-5.6-1.8-2.2-1.4-3.4-2.9-3.3-3.2m-35.8 5.7s.8.4 1.7 0c1-.5 3.5-2.5 3.5-3.3v-1.6s0 .3.7.4c.8.1 2.8-1.4 3-2.4a8 8 0 0 0-.1-3.1c-.2-.4.6.3 1 0 .4-.4 2.4-1.7 2.4-3 0-1.4-1.1-2.6-1.1-2.6s1 .2 1.6 0c.5-.1 2.5-1.3 2.4-2.4 0-1.2-.7-3-2.3-3.2 0 0 1.2.3 2.3-.1 1-.4 1.5-1 1.5-2.3 0-1.2-2.3-4-2.6-4.2-.4-.2 2.4.8 3-.3.8-1.1.9-1.9.7-2.5-.2-.7-.8-.8-.8-.8s1.2.3 2.8-.5 3-2 3.8-1.9c.8 0-2.3 1.7-2.5 2.6 0 .4.9 1 2.3 2 0 .1 0 .2.2.3.7.3 3 .4 3.3.5.2.2-2.4.1-2.2.3a34.1 34.1 0 0 1 5.7 5.4c.1 0 .5.4 1 .5l1.3.3h-1.6a65.3 65.3 0 0 1 3.3 4.7c0 .1.4.6.9.8.5.2 1 .1 1.1.2.1.2-1.4 0-1.3.2a82 82 0 0 1 3.3 6s-3-5.3-6.7-9.5c-3.8-4.2-4.7-4.7-4.8-4.4-.2.4 2.7 4.1 4.3 6.7 1.6 2.6 3 5.9 3 5.9s-3.7-7.8-9-12.6c-5.2-4.8-5.8-5.5-6.3-5.4-.6.2-1 3.8-.7 4.5.3.7 4.2 3.6 7.4 7.5 3.3 3.8 7.5 10.4 7.5 10.4s-3-4.7-8-10-6.9-6.6-7.3-6.5c-.4 0-.4 1-1 1.8-.6.7-1.8.6-1.8 1s4.2 4.3 5 4.7c.9.5 1.4.3 2 .6l1.4 1-1.6-.5c-.6-.2-1.3-.3-1.3 0s3.5 4.3 4 4.6c.6.3 1 .1 1.7.4.8.3 2 1.1 2 1.1s-1.3-.7-2.1-.8c-.9-.2-1.2 0-1.2.2s2.6 3.6 2.5 3.6c-.1 0-4-4.6-7.3-7.5-3.3-3-4.8-3.6-5-3.5-.2.1 0 1-.9 1.3-.8.3-1.5.4-1.5.7 0 .3 3 3 5 5.4a149.4 149.4 0 0 1 4 4.5l-4.5-4.3c-2.3-2.2-3.5-3-3.8-3-.2.2-.2 1.3 0 1.6.2.3 4.6 5.4 4.4 5.5-.1.2-5-6-5.4-6-.3 0-.5.7-.8 1-.4.4-1.8.4-1.8 1 0 .4 7 7.3 6.9 7.5 0 0-5.8-5-6-4.7-.2.3 2.4 5 2.2 5.2-.1 0-3.4-5-3.7-5-.3 0-.2.6-1 1.3-1 .8-2 .4-2 .8 0 .3 4.8 5.7 4.7 5.8-.2.1-5-5.1-5-4.8-.1 0-.4.3-.2.7.3 1.3 1.4 3.6 1.3 3.8 0 0-1.6-3.2-2-3-.4 0-.4.7-1.2 1.1-.7.5-1.3.4-1.3.7 0 .3.8 1 1.2 1.7.4.7.7 2.4.7 2.4s-.5-1.4-1.1-2.3c-.7-.9-1.3-1.5-1.9-1.5s-.8.5-.8.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M377 212s1.5 0 1.7-.4c.2-.3-.6 0-2-1.6s-5-12.1-9-17.4c-6.6-8.7-12.7-12.7-12.7-12.7s7.3 4.2 13 12.4c5.6 8.4 7 14.9 8.6 16.6 1.6 1.7 3.2 2 3 2.5 0 .5-.3.8-.9 1l-2 .1zm-48-2.2.3.1c.3 0 2.3-1.9 2.2-2.5 0 0-1-.3-1.6-1-.7-.8-.9-1.9-.9-1.9s.7 1.3 1.2 1.6c.6.4 1.4.6 1.8.3.3-.2 3.2-2.4 3-3.2 0 0-.9 0-1.8-.6-.8-.6-1-2-1-2s.6 1.1 1.5 1.5c.8.4 1.7.3 2 0 .2-.3 2-3 1.8-3.7 0 0-1 0-1.8-.5-.9-.6-1.3-2.2-1.3-2.2s.6 1.3 1.7 1.5c1.1.3 2-.4 2.2-1.2.2-.8.8-3.7-.2-4.5 0 0-1.4.5-2.4 0-1-.6-1.4-1.9-1.4-1.9s.9 1.2 2 1.4c1.2.1 1.7-.5 1.9-1a5.9 5.9 0 0 0-.1-3c-.4-1-1.1-.8-1.3-2.2 0 0-.3.5-1.8.5s-2.3-1.6-2.3-1.6 1.2 1 2.4 1a1.9 1.9 0 0 0 1.6-1.9c0-.7-.6-1.4-1-2.1-.2-.8-.3-1.7-.5-1.6-.2 0-.5.8-2 .6-1.5-.3-1.8-1.3-1.8-1.3s1 .7 2 .7c.8 0 1.3-.5 1.3-1 0-.6-.3-1.7-2.2-3.3a58.1 58.1 0 0 0-3.5-2.7 21.8 21.8 0 0 0 6.6 5.3s1.7.6 2 0c.1-.6.1-1.4-.5-2.4-.5-1-2-2.6-2-2.6s1.6 1.3 2.3 2.7c.8 1.3.4 2.2.5 2.6 0 .3 3.3 1.6 4 1.1.8-.4.5-1.4-.2-2.3l-1-1.8s.7.8 1.2 1.8c.6 1 1 1.7.8 2.1-.2.5-.6.7-.6.9l2.3 1.3c1 .6 2.3 1 2.5.8.2-.4.3-1.1.2-2.2-.1-1-.7-2.7-.7-2.7s.7 1.6.8 2.7-.1 2 .1 2.4c.3.4 1.1.5 1.1.5s-.6.4-2 0c-1.5-.4-7.7-3.6-8-3.3-.3.4 2.9 2.3 4.3 3.7 1.5 1.3 2.2 2.8 2.2 2.8s-1.1-1-2.2-1.6c-1.1-.6-4.4-2.3-4.7-2-.2.2 1.3.5 1.4.7.1.3-1 1.3-1 1.8 0 .4 4.7 3.7 4.5 4-.1.4-1.2 1.3-1.4 1.2-.1 0-2.5-1.8-2.5-1.6s1.4 1.5 1.4 1.7c0 .3-1 .8-.8 1.4.2.6 2.6 2.6 2.6 3.3 0 .7-1.4 1.3-1.1 1.7l1.5 2s-1.4-.9-1.8-1.4c-.4-.4-1.3-1.5-1.5-1.3-.1.1-1 2-1 2.5.2.4 1.3 1 1.5 2.3.2 1.1-.2 2.4-.3 2.4 0 0-1.6-2-2-2.1-.2 0-.6.1-.9.6s-1.2 2.1-1 2.4c0 .3 1.6.7 1.6 1.9a3.4 3.4 0 0 1-1 2.3l-2.1-2.4c-.2 0-2.2 2.3-2.3 2.6 0 .2 1.4 1.3 1.2 1.7-.3.4-1.3-.2-1.8.1l-1.7.7c-.2 0-.5-.6-.5-.6"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "m355 180 .5-1c.3-.3 1.5-1.7 1-2-.4-.2-2 .3-3 .2-1 0-1.7.2-4.6-2.3 0 0-9.3-6.4-23.6-7.3-4.6-.2-6.6 1.4-6.8 2.2 0 .2 1.2-1.8 5.7-1.7 2 0 16.5 1.1 24 7 .4.3 2.9 2.7 5.2 2.4 2.3-.2 2.8-.5 2.7-.2 0 .4-.7 1.2-.9 1.6a9.2 9.2 0 0 0-.3 1.1zm-25 2v-.2c-.2-.4-1.1-1.7-2.7-3.1a37.4 37.4 0 0 0-8-4.3c-.3-.1 6 2.9 7.7 4.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M330 192.2s-.4-.6-1.7-1.4a9.9 9.9 0 0 0-2.5-1.1l3 .7a4.8 4.8 0 0 1 1.1 1.8zm-.8-5.3s-.4-.6-2.1-1.2-2.2-.5-2.2-.5 1.6-.7 2.8 0a2.7 2.7 0 0 1 1.5 1.6zm-1-4.5s-.4-.8-2-1.3c-1.5-.6-2.6-.7-2.6-.7s1.6-.4 3.2.2c1.5.6 1.4 1.8 1.4 1.8m-2-2.8s-.4-.6-3.3-1.3c-3-.7-4-.7-4-.7s4.1-.4 5.2.1c1.1.5 2.2 1.9 2.2 1.9zm-5.3-3s-1.8-.6-3.5-.7-4.4.1-4.4.1 5-.8 6.3-.5c1.4.3 1.6 1 1.6 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M304.5 238.4s.9 1.6 2.6 1.6c1.8.1 3.1 2.6 3.1 2.6l-1.9 1.9-4.6.2-1.5-2.4zm0-1.6c.2-.3-1.3-3.3-2.4-3.8-1-.5.4 1 .2 1.6-.3.6-.4 1.4-.3 1.5 0 0 .9 1.4.4 2-.4.5 2.2-1.3 2.2-1.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M303.8 241.4s.8.4 1.4.2c.7-.2 1.3-.9 1.3-.9m-3.6-.5s2.6-1.9 2.4-2.9c-.2-1-.7-1-1-.9a7 7 0 0 0-2.1 1.7c-.1.3.7 2.1.7 2.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M301 241.5s.6 1.3 1.4 1.3c.8 0 2-.7 2-1.2.1-.5-.8-1.5-1.3-1.7-.6-.3-1.9.4-1.9.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M303.4 239.8c0 .4-1.7 1.2-2.3 1.2-.5 0-1.6-1.3-1.2-1.5l1.5-.4c.4-.2.5-.8.7-.8.3 0 1 .1 1.1.5.2.5.4.6.2 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M301.8 240.9s-2.6 3.4-3.7 3.3c-1-.2.5-5 .5-5l1.2.6c.9.2 1.7.6 2 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M297.2 238.4s3.3.6 3.4 1.1c.2.6-1.5 1.3-2.5 1.3-.9 0-.9-2.4-.9-2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202220",
      d: "M289 243.4s.5 1.6 1.9 1.7c1.4 0 2.8-1.5 2.8-1.5l-3.4-1.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "m289 243.4.4.9c.3.4.7.8 1.5.9h.1c1.4 0 2.7-1.6 2.7-1.6l-3.4-1.4zl1.3-1 3.3 1.3v-.1l-.2.2c-.4.4-1.4 1.2-2.4 1.2h-.1a1.8 1.8 0 0 1-1.4-.8 2.8 2.8 0 0 1-.3-.6v-.1l-.1-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202220",
      d: "M290 243s.5 1.2 2.4 1.2 3.3-1.5 3.3-1.5l-3-2.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "M290 243s.5 1.2 2.4 1.3c2 0 3.4-1.5 3.4-1.5l-3-2.5-3 2.7zl2.8-2.5 2.9 2.3v-.1a5 5 0 0 1-3.2 1.4 3 3 0 0 1-2-.6 2.2 2.2 0 0 1-.3-.4 1.1 1.1 0 0 1-.1-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "M290.2 243.3s.9.6 1.8.7c1 0 2.2-.3 2.2-.3l-1.1.4-.8.1-.8-.1-.6-.3zv-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202220",
      d: "M292.4 241.6s.8 2 2.6 1.8c1.7-.2 1.7-1.2 1.7-1.2l-2-2.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "m292.4 241.6.5 1c.4.4 1 1 1.8 1l.3-.1c.8-.1 1.3-.4 1.5-.7.3-.3.3-.6.3-.6l-2-3zl2.4-2.1 1.9 2.7c0 .2-.3 1-1.8 1.1h-.2a2.2 2.2 0 0 1-1.7-.8 4 4 0 0 1-.4-.6v-.2a1.5 1.5 0 0 1-.1-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "M292.6 242s1 1.3 2 1.3a3 3 0 0 0 1.5-.4v.1l-.5.3-.8.1h-.8l-.7-.5zm-3.2 2s.8.9 1.5.9a4.7 4.7 0 0 0 1.9-.6h.1l-.2.1-.8.4-.9.3-.7-.1-.6-.4-.3-.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M297 238.3c.8-.2 2.4 2 2.4 3.2s-.5 2.7-1.3 2.7-2.6-1.7-3-2.5c-.4-.9-.8-1.4-.5-1.9.3-.4 2.4-1.5 2.4-1.5zm-8 .2s-1.4-1-1.9-.5-.3 2.3 0 2.6c.4.4 2-.8 2-.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M288.8 239.7s-1.8.2-1.8 1 .9 1.6 1 1.8c.2.1 1.8-.7 1.8-.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M289.5 241.1s-1.8.6-1.8 1.2.8 1.7 1.3 1.7 1-1 1.2-1.3c.3-.2-.7-1.6-.7-1.6zm.8-5.1s-.3-.5-1-.2c-.8.3-1.6 1-1.5 2.3.1 1.1.6 2 .6 2l2.7-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M290.5 238s-2.2.8-2.3 1.7c-.1.9.5 1.7 1 2 .7 0 2.6-1.8 2.6-1.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M292.5 241.7s-2.2 1.5-2.5 1.5c-.3 0-1.2-1.2-1-2 .2-.8 1.7-1.3 2.3-1.6.6-.2 1.2 2.1 1.2 2.1zm2-8.2s-.7-.6-2-.5c-1.4.1-2.4 2-2.6 2.8-.2.9 0 2.6.5 2.8.5.3 3.3-2 3.3-2l.8-3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M291.8 240.3c-1-.1-1.8-1.5-1.7-2.3.2-.8 2-2.2 3-2 1 .1.8 2.5.8 2.5s-1.2 1.9-2.1 1.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M294.7 240s-.4 1.2-1.4 1.7c-1 .4-1.5 0-2-.7-.6-.8.2-1.2.6-1.6.5-.4 1.7-.7 1.7-.7l1.1 1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M293.2 237.2s-1 .8-.4 1.8 1 1.4 1.8 1.5c.8.1 1.3-.2 1.9-.9.6-.7 1.5-1 1.4-2-.1-.9-.4-1.6-1-1.8-.5-.3-2.2 0-3.7 1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202220",
      d: "M296.2 233s-1-.5-1.9 0c-.8.5-1.4 1.5-1.5 2.4l.2 2.3s1.2-.4 2-1c.7-.6 1-.8.8-1.1 0-.2-.4-.4-.4-1.2 0-1.4.8-1.5.8-1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "M296.2 233s-1.2-.3-1.9.1a3.2 3.2 0 0 0-1.3 1.9c-.3.8-.1 1-.1 1v-1.4c.4-.8 1-1.5 1.6-1.7.8-.3 1.7 0 1.7 0z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "m328.8 257 1.6-.8 2-1.2.4 2.2-1.8 1.4h-1.5l-.9-.7.2-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M326.4 257.2h1c1.1 0 1.2-.3 1.4-.3.2.1.5 1.3.5 1.3l-.4.7-1.5.9-1.3-.8-.1-1.8zm12.1-.8s-.3-.5-.9-1l-2.2-1.9v5l2.3-.1 1.1-1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M326.4 257.2s-.4-.5-1.3-.4c-1 0-2 .9-2.1 1.5-.1.7 0 2.6.5 3 .5.4 1.2.5 2.2.3 1-.3 6.4-3.6 6.4-3.6l-1.4.3c-.7.2-1.4-.1-1.4-.1s-.7.8-1.6 1c-.8 0-1-.5-1.2-.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "m330 258.9-1.2.5-1.3.6.4 1.6 2.3.5 1.4-1.1v-1.6l-1.7-.5zm10.4-1.2-.8-.8c-.4-.4-1-.5-1-.5l-1.3 1.5v1l1.2.7.9.2 1.1-.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M332.6 257s-1 .4-1.5.8l-1.2 1c0 .2 1.1 1.4 1.1 1.4l1.2.1 2.5-1.7-.2-1.6zm9.5 2-.5-.7c-.4-.4-1-.6-1.2-.6-.3 0-1.3 1.5-1.3 1.5v.4l.8 1 1.6.5 1.1-1.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "m338 260.8 1.2.2s0 .3.3.5c.3.3.3 0 .3 0s.2 1.2 1.4 2c0 0 1.4.6 2 .2.8-.4.7 0 .7 0l2-2.4s0-.5-.5-.5c0 0 .4-1.6-1-2-1.2-.2-2.2.2-2.2.2s-1 1.8-1.6 1.6a2.4 2.4 0 0 1-.8-.5l-.7-.9s-.4.1-.9-.2c-.5-.3-.9-1.1-.9-1.1s-.7-.1-1-.4l-.5-.8-1.9 1.4s0 .5-1.1 1.3-1.7.8-1.7.8-.4 1.7-1.6 1.4c-1.2-.3-2-1.6-2-1.6s-.9-.2-1.4.6c-.6.7-.9 1-.9 1.7 0 .8.5 1.8 1 2.2.3.3 1.5 1.3 3 .6 1.4-.8.9-2 .9-2l.8-.5c.9-.6 1.8-1.5 2.5-1.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M335.8 250.8v3.2s.4 2.9-.2 3.7c-.6 1-2.9.7-3.2 0-.3-.8-.2-3.2-.2-3.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M333.3 260.5s-.5.8 1 1c.4 0 .7-.2.9-.4.4-.4.3-.8.3-.8s-.2 1.2 1.2 1.2c1.4.1 1.3-1.3 1.3-1.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202220",
      d: "M321.2 263.1s-.8-1.4.1-1.9c1-.5 1.5 0 2.1 0 .6 0 .4-1.4.3-1.7a3.7 3.7 0 0 0-.7-1.2c-.2-.2-3.5.2-3.4 2.3 0 2.1 1.6 2.5 1.6 2.5m5 5.2s-1-1.5-.4-2.4c.5-.9 1-.3 1.2-.4.3 0 .4-.6 0-1.6-.5-1-1.1-1.4-1.4-1.5-.4 0-2.3 1.4-2 3.2a3.5 3.5 0 0 0 2.6 2.7m18.2-1.8s3.5 1.5 3.7-2c.2-2-1.5-3.3-2-3.3-.4 0-.7.3-1.3 1-.7.8-1.1 1.3-.9 1.6.3.3 1.3-.3 1.8.8.7 2-1.3 1.9-1.3 1.9"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4b4139",
      d: "M326.2 268.3s-2.7-.6-2.7-3.3c0-1.8 2-2.6 2-2.6s-1.8 1-1.8 2.6c-.1 2.7 2.5 3.3 2.5 3.3m-5-5.2s-1.6-.3-1.7-2.6c-.2-2.3 3.5-2.2 3.5-2.2s-3.5.2-3.4 2.4c.2 2.2 1.6 2.4 1.6 2.4m23.2 3.4s.7.3 1.5.3 1.8-.3 2-1.6c.4-1.3.3-2-.6-3.1-.6-.9-1.2-.8-1.2-.8s.6 0 1 .8c.6.8 1.3 1.6.8 3.1s-2 1.5-2.5 1.5a5.5 5.5 0 0 1-1-.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "m302.6 192.4-.6-.2.4-1 1.9-.7 1.8-.1 2-.1.8.6 1 2.3-3.6 2.2-.6.2-.2-1-.6-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "m337 245.5-.3-5.5-14.8 4.6 5.8 5.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "m309.4 235.9-1.2-1-1.4-.8h-1.1l-.2.3.2.5 1.3 1.6 2.3 1.2.8.7.5.2-1.1-2.7zm-.3 2.3.8.2.9 1 .5 1 .7 1.3.2.8-1.6-.3-4.8-1.5.4-1.2.8-.7.7-.3 1-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M312.2 242.2h.8l.6-.5-.3-1.8.3-5.8-3.9-4.6-.8 2.6 1.1 4.7.9 2.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M309.4 231.7s-.2.4.1 2c.3 1.5.9 4.9 2.2 7.2l-1.3-1.9s-2-4.6-1.7-8.2c.3-3.5.7.8.7.8zm2.9 2.9s-.9 1-1 1.9v2.2s0-1 .8-1.3c.9-.3.7 2.3.8 2.6l.5-4.7zm.4 9.6-4.4-1c-2.3-1-3.5-1.8-3.4-2.3 0-.6 4 .1 4.6.2l2.4 1h1l1.9-.8.2 2zm-7.3-.8s1 .8.5 1a4.4 4.4 0 0 1-2.3.3l4.2 1 .9-.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M304.2 242.2c.2-.2.3.7 1.8.8 1.5.2 2.2-.2 2.2-.2l.7.4.8.2-.7 1.1-2.8-.8-1.5-.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "m314 240.3.8 1 .5-2.4v-2.5l-1.6-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m309.7 236.1-1.3-2.1-1.7-3.1 1-1.8 1.3 1.8s-.4 1.3-.1 2.5c.2 1.2.8 2.7.8 2.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M300.8 244s.6-.9 1.9-1a7.6 7.6 0 0 1 2.4.2l2.6 1.4.6.9-5-.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "m314 235 .2 4c0 1 .7 2 .6 2.3-.2.4-.4.6-1 .9-.6.2-2 0-2 0s1.3-.2 1.4-.5c0-.2-.4-1.4-.5-2.4 0-1 .1-2.2-.3-2.2-.3 0-.7.4-.8.6 0 0 .4-3.8.8-4.2.4-.4 1.6 1.6 1.6 1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M304.7 243s-.5-.4-.5-.8c0-.3.6 1.6 3.4 1.5 2.8 0 2.6-.2 2.6-.2h1.3s-.3 1.3-.5 1.4a61 61 0 0 0-2.2 1.4l-.7.4v-.2l-.3-2.1-2.4-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M309.7 236.1s-3.2-3.3-4.3-5.5c-1-2.2-.4-5.2-.4-5.2l3 4s-.4.7-.3 2c.2 1.2 2 4.7 2 4.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M307.6 248.3c0-.3-.2-1 .4-1.8 2-2.4 6.8-4 6.8-4v2.8l-6.2 3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M308 246c.3-.1 1.4-1 1.4-1.3 0-.4-.7-.4-2.1-.7-1.5-.3-2.6-1-2.6-1s1.7 1.4 2.4 1.7c.7.2.6.5.5.7zm8.3.7s-.9-1.3-1.2-2.1c-.3-.8-.3-2.1-.3-2.2l-1 .7-2 .7s2 0 2 .6c0 .7-3 1-3 1 0 .1 2.4-.4 2.3.1-.2.6-1.2.7-2.5 1.2l-2.3 1-.7.5s.6.4 1.5.3c.9 0 2.9-.5 2.9-.5l3.8-1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M316.3 246.7s-1-.3-1.8-4.8-.6-5.7-.6-5.7l1.8 1.3 1.7 3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M316.9 239.3s-.9 2.5-.9 4c0 1.4-.1 2.4.3 3.4s1.8 2.3 1.8 2.3l.7-.6.3-2 .1-3.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M319.4 242.7s.4 6.3-1.2 6.5c-.7 0-1.9-2.4-1.9-2.5 0 0 1.4 2.3 2 2.1 1-.4.6-6.6.6-6.6zm-3.1 4s-.3 0-.7-.8c-.4-.7 0 .6-3.4 1.8-3.4 1.2-4.6.5-4.6.5s1.1 1 4.5 0 3.1-1.3 3.6-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M310 238.7s.6.5 1.2 1.7a363.3 363.3 0 0 0 1 2h.2s-.4-1.3-1-2.2l-2.2-3.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M308 246.5s.3-1.1 0-1.4c-.3-.2-.7 0-3-.2a34 34 0 0 1-4.2-.9s1.6 1 3 1.4l3.5.8.5.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "m308 246.5-.2-.5c-.3-.3-.7.1-3.5-.7-2.8-.7-3.5-1.3-3.5-1.3s1 1 3.4 1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M309.3 238.2s-2.1.1-2.8.7c-.7.5-1.6 2-1.6 2l1.3.1s-.1-1.2.5-1.9c.7-.6 1.7-.7 2.6-.9"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M305.3 234.2s.8 1.2 1.7 1.5c.9.4 1.8.8 2.2 1.2.4.4.9 1.8.9 1.8s-3-1.3-3.7-2a9.6 9.6 0 0 1-1.1-2.5"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M308.2 235s-.3-.5-1.1-.9-1.4-.3-1.7-.1-.1.2-.1.2l1 1.7.7-.2s-1.6-1-1.3-1.3c.8-.7 2.5.5 2.5.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "m316.3 231.1 17-8.7 8 11.1-14.7 4-7.7.6-3.8-2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m339 235.9 21 18.2-2.3 1.6-5-1.4-10.2-10.1-3.8-3.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m366 250.5-12-9.1-15.3-11.5.4 5.5 17.4 16 5.7 2.7 3-.8 1.4-1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#803f1d",
      d: "M339 237.6s6 6.9 10.6 10.4 9 7.3 10 6.7c.8-.5.5-1 .5-1l-21.3-17.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m353.8 255.1-2.1 1.7-2.5-1-13-13.2.7-2.5 1.8.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M366 250.5s-1.6 3.8-5 2.9c-3.4-.9-22-18.5-22-18.5v1.8s18.8 17.3 22.5 18c3.6.7 6.6-2.5 6.2-2.8a43.7 43.7 0 0 0-1.7-1.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#803f1d",
      d: "M336.9 240.4s6 7.7 9.1 10.5c3.2 2.9 6 5 7.2 4.8 1.3-.2-.7-1.7-.7-1.7l-9.1-9-4.7-4.6s-1.8-.7-1.8 0"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M338.4 240.4s15.2 15.5 16.4 15.9c2.5.7 6.2-2 6.2-2l-1.3-.7-.2.5s-.7 1.6-4 .9c-3.2-.7-16.6-15.1-16.6-15.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m344 255.3-5.5-6.4-1.2-2.1-.3-2.7 11 11.1-1.5 1-1.4-.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M354.1 255.5s-1.3 2-3.2 1.6a5.4 5.4 0 0 1-2.8-1.7L337.5 245l-.3-1.6s11.7 12.3 13.7 12.8c1.6.4 2.7-1.4 2.7-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M348.2 255.1s-.5 1.6-2 1.4c-1.6-.3-2-.9-2-.9l-6.6-7.7-.1-2s6.8 9.3 8.3 9.8c1.6.5 2-1 2-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#b07229",
      d: "M341.3 234.9s6.3 5.4 6.8 5.6c.5.3 2.7.4 2.8.7.2.3-1.4 0-1.5.3-.1.4 3.2 3 3.7 3.1.5 0 3.2 0 3.1.4 0 .3-1.8 0-1.9.4 0 .4 2.9 2.7 3.4 2.8.5 0 3.9 0 3.9.4 0 .3-2.7 0-2.7.5.1.6 4.6 3.4 4.4 3.8-.2.4-5.4-3.5-5.5-3.3-.2.2-.4 1.4-.7 1.6-.3.2 0-1.6-.2-2.4-.3-.8-3.4-3.1-3.7-2.9-.3.3 0 1.7-.4 1.7s.1-1.7-.2-2.3a16 16 0 0 0-3.6-3c-.4 0-.1 1.3-.4 1.5-.3.2-.2-1.5-.6-2-.4-.5-7-6.5-6.7-7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M330.5 252.3s0 2.4-1 2.8c-1.1.3-3.1-4.4-3.1-4.4l-.5-4.4 3.1 3zm8.4-1.2V250c0-.6-.3-1.5-.3-1.5l-.2-2.4-.6-1.7-.4-1h-.7l-1.7 1.2-.5 1.6.8 3 .8 2.7 1.3.4 1.5-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M336.8 255.3c.3-.1-.4-3.4-.4-3.4l-2-4.8-.5-1.7-1.5-.6-1 1.2.2 1.9s1.5 3.2 2.2 4.3c.8 1.1 2.3 3.3 3 3.1"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M335 245a6 6 0 0 1 1.4 2.6s1.3 3.6 1.1 4c-.2.3-1 .3-1 .3s1.8 1.8 2.3 1.6c.5-.2.3-2 .1-2.4-.1-.4-.7 0-1-.5-.1-.4-.8-2.7-.8-4.2v-2.7c.2-.3 1.5 3 1.5 4.7l.6.7-.6-3.2-.7-2.3c0-.2.3-.8.3-1.5v-1s.6.5.9.5c.3 0 .7-.4.8-2 .2-1.5-.1-6-.1-6l-6.8 9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M335 244.3s-.3 2.4.6 4.8l1.3 3c.2.3.2 2.9-.1 3.2 0 0-1.8-4.4-2.4-6.6-.5-2.1-.7-3-1-3.2l-.8-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M334.4 257c.2 0 0-1 0-1l-.2-2.3-2.4-4.9-2.6-2.3-1.4-2-.2 4s2 4 3.1 5c1.3 1.2 3.3 3.6 3.7 3.5"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M324.7 246s.4 1.1.4 1.8v1.4l1.8 3.5c.9 1.5 1.7 3.1 2.4 2.8.7-.4 1-1.5 1-1.7.1-.1-.8 1.3-1.2 1.1a40 40 0 0 1-2.3-6.6l-1-.8a18.4 18.4 0 0 1-1.1-1.4zm7 5.5-1.7-3.1c-.5-1-1.2-1.7-1.4-1.7-.2 0-.5-2-.5-2s.7 1.3 1.6 1.7c1 .5 1.5.8 2 .7l.2 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#5c3a1d",
      d: "M327.4 248.3s.5 1.4 1.4 2.7c.8 1.3 2.3 2.9 2.3 2.9s-1.6-1.6-2.5-2.8a14 14 0 0 1-1.4-2.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M332 246.7s.5-1.2.8-1.3l1.2-.3s-.7-.1-1.2-.8l-1.3-1.3.4 2zm-.4.4s2 4 2.4 5.5c.5 1.3.4 3.4.4 3.4s-.2-1.5-.6-2.7l-2.4-5c-.1-.3.2-1.2.2-1.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m334.2 244.4.5-6-.5-2.2-2.7-6s-.1.8-.8.8a6.2 6.2 0 0 1-3.1-1.8 9.2 9.2 0 0 0-.2 4.8l5.3 9.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8b441f",
      d: "M323.8 248.3s.8 1 1.3 1c.4-.2.3-2.1-.3-3.2-.6-1-7-9.6-8-10.1s7 12.3 7 12.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8b441f",
      stroke: "#5c3a1d",
      strokeWidth: 0.1,
      d: "M328.1 244.8c.2.4.6 3.1-.5 3.4-1.5.3-8.5-9.4-9.6-10.7 0 0-4.4-2.8-4.5-3.5-.1-.7 4.7 1 4.7 1l9.5 9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M323.8 248.3s-.8-1.3-.9-2.3c0-1-.4-1.5-.4-1.9 0-.3-5.2-7.7-5.7-8.2-.6-.5-2.3-1.4-2.3-1.4a15.5 15.5 0 0 0 .3 2.4s1.6 3 4 5.7a458.4 458.4 0 0 0 5 5.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M331.6 247c.7-.3.4-2.7.1-3.5a458.4 458.4 0 0 0-4.4-9.4l-1.3.4-2.3-1.8-1.4-1.5s.5 2.1.4 3.1v1.6l3.3 5.9zm4.7-5.2 1-1.3-.5-4.4-2.8-9.4s-.7.1-1.4-.3c-.6-.4-1.4-1.3-1.4-1.3l.7 5.7 2.9 8 .2 2.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M327.7 244s-2.8-3-3.7-4.5l-1.7-3s-.8.3-1.8 0c-1-.5-2.2-1.8-2.2-1.8s-.8 1.5 3.2 5.6c4.6 4.6 6.2 3.7 6.2 3.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8b441f",
      d: "M334.4 245c1.2-.4 1.1-5.4 0-8.7-1-3.3-2.9-6.2-2.9-6.2s2.3 5.4 2.8 7.5c.4 2.2 0 3.7-.4 3.6-.4-.1-.4-1.3-1.3-3.4-1-2-1.6-2.6-1.6-2.6s3.3 8.8 2.3 8.6c-.9-.2-5.3-9.9-5.5-10.2-.2-.2-.4.4-.4.4s4 12.2 7 11"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m337 221.3 2 4.2.6 4.4.2 3.7s0 7.4-.8 7.6c-1 .1-1.4-.7-1.4-.9a2729 2729 0 0 1-1.7-8.3l-1.7-8.5.6-.6.2-1.2 1.3-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8b441f",
      d: "M331.6 247c.8 0 0-2 0-2s-.6 1-1.2.3c-.5-.7-1.3-3.1-1.3-3.1l-.5-1.5s-.6 1.6-1.3 1.6-4.6-6.4-4.6-6.4l-.4.6s5.4 11.1 9.3 10.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M329.1 242.2s.7-1.6.4-3c-.3-1.5-2.2-5.1-2.2-5.1s-.6.1-1.4-.2a9.6 9.6 0 0 1-2.2-1.2 38.3 38.3 0 0 0 5.4 9.5m3.1-2.3s-.5-3.4-2-6.6c-1.6-3.1-2.6-4.1-2.6-4.1v3.5s1.5.5 2.6 2.4c1 2 2 4.8 2 4.8m4.3-5.8s-.3-3.7-.8-5.8l-1.2-5s0-.2.3-.4h.6c.8.3 1.1 2.2 1.1 2.2l-.1-3.1-.3-.5h-1.4s.3 1-.1 1.3c-.3.3-.6-.2-.7-.3l-.2.4.4 2-.1 1.7s.5 2.2 1.2 3.5c.6 1.4 1.3 4 1.3 4m3.3-.5s.6-5.3-.6-8.7c-1.2-3.4-2.2-4.2-2.2-4.2l-.6.6s1.8 3 2.4 5.6zm-5.4 2.7s-.6-4.1-1.3-6.8a82.8 82.8 0 0 1-1-3.6l-1.1-1s.7 2.7.6 3.6l-.1 1.4s.5 1.4 1.3 2.6a25.5 25.5 0 0 1 1.6 3.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "M337.2 242.9c1 0 .1-6-.3-7.5-.4-1.6-3-8.8-3-8.8s3 10.3 2.8 10.8c-.3.8-1.5-3.1-1.7-3-.2 0 2.2 6.9 1.3 7-.8 0-1.3-1.5-1.3-1.5l.1 1.5s.6 1.4 2.1 1.5"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "M338.5 239.9c.7 0-.2-5.7-.7-8.2l-2-7.5s1.5 3.5 2.3 7.5c.8 4 1.4 9 .6 9.2-.8 0-1.2-.8-1.2-.8v-.9s.3.7 1 .7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#312317",
      d: "M328.8 246.5c0 .4 0 2.4-1 2.2-1-.1-2.9-1.9-3.3-3 0 0 2.2 2.5 3 2.4.8 0 .8-2.5.6-3.2 0-.6.6 1.6.6 1.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M334.1 219.5s1.4.9 2.4.3a4 4 0 0 0 1.8-3c0-.8 0-1.5-.7-2.4-.7-.9 1 .7 1 2.3 0 1.6 0 4.3-2.5 5-2.5.5-1.4-.2-1.4-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M332.1 214.7s1.6 2.6 2.2 5c.7 2.3.5 3.2.2 3.3-.4 0-.6-.3-.7-.9 0-.6-1.7-7.4-1.7-7.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#1e2121",
      d: "m304.1 218 10.6 15.3 13.2-15-8.3-8.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m317.5 208.5-.6 2.4 1.3 4.1 2.2 2.3 2.5 1.7.6-2 .6-2.2.7-.2 1.6.6 1-1.5 1.8-3.1-.4-1.2-.4-.9-2.7-4.6-.9 1.7-.8.5-1.6-.8-1.8 2.4-2.3-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#5c3818",
      d: "M323 219s.4-.3.6-1.6c.2-1.2.2-4.9-.1-6.4-.3-1.5-1.3-4.4-1.5-4.2-.2.3 1.5 3.3 1.3 7-.3 3.6-.2 4.6-1 5-.7.3.6.2.6.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#5c3818",
      d: "M323.6 212.8s1.7 2.5 2.5 1.6c.9-.9.5-4 0-5.3l-1.2-3 .5-.6.9 3.4c.3 1.4 1.3 5.2.1 6-1.1.6-2.8-1.5-2.8-1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M317.9 214.6s.6-1 1.4-1c.8 0 1 .3 1 .3l.6 2 1.2 2.2 1 1-.5.6-.9.2-2.5-1.4-.7-1-.6-3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M322 236.3c-.8.5-2.7-.5-3.7-1.4l-6.8-6.7-.8-3.2 2.2.6 3.9-1.7.7-1.3 4.6-2.4 2.6-1.4 5.5-.1 1.4-2.7s1.8 3.2 2.1 4.5c.4 1.4.3 5.4-.2 5.7-.5.3-2.3-1.2-2.6-1.3-.2-.1 1.4 5.7 0 6-1.3.2-3.6-2.2-3.6-2.2s1 5.2-.2 5.2a10 10 0 0 1-5-2.6s1.3 4.3 0 5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "m321 229.6 1.1 1.7c.3.4 0 2.9-.2 3.4-.3.9-1.6-1.2-2.3-3l-2.2-3.8c0-.4 3.5 1.7 3.5 1.7zm10.8-12.9s2 8.1 1 8.4c-1 .3-3.6-2.6-4-3l-4-6.4-.8-.8.2-.4 1.7.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M317.9 232.3c-.4.3-1.3-1-1.7-1.4l-3-3.3a11.5 11.5 0 0 1-2.2-2.5c0-.3-.8-1.1-.8-1.1l.7-1h.9s5.4 4.2 5.7 5c.4.6.6 4.1.4 4.3m8 0c-.2.3-3.7-2.3-5.2-4.4-1.5-2.2-3-4-3.5-5l-.6-1.9 1 .2s8.8 10.8 8.4 11.2zm1.3-3.7c-.2.3-1.7-.9-2.7-2.1-1-1.3-.4-2.9-.4-2.9s3.3 4.8 3.1 5m2-.5c-.5.3-2.5-2.2-4.2-5-1.3-2-1.6-2.3-1.8-2.5-.5-.3-1.4-.4-1.4-.4l-.2-.3 1-.2.6-.8 1-1.3 4.3 8.5s1 1.9.7 2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M318.3 234.9c0 .3 0 .6-1.2.5a21 21 0 0 1-9.9-7.8l-3-5 1.1-1.4 9.6 11z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M318.3 234.9c0 .5-.5.6-1.1.5-.6-.2-3-1-6.9-5.3a33.3 33.3 0 0 1-5.3-7.4l-.2-1.8 1.2-.5 6.5 10z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M324.6 230.6s-2-1.5-3.2-3a24 24 0 0 1-3.8-5.7c.1-.7 1.2-.7 1.2-.7v-1.8l.2-.6 1.9.8 2.3 2.9.9 1.1s1.5 3.7 1.2 4c-.3.3-2.4-2-2.7-1.7-.3.3 2.4 4.4 2 4.7m-3.7-1s.7 1 .4 1.7c-.3.7-.5 1-1.5-.4a16 16 0 0 0-2.3-3c0 .1.1 2.3-.3 2.3-.5 0-2-1.9-3-3.3l-2.5-3.9v-2l-.1-2.5.3.9.4.7 3.6 4.2 1-.7 2.1 4zm-13.5-6.1s2.8 4.8 5.3 7.5a17.4 17.4 0 0 0 5.6 3.9l-8.4-9.9zm21.2 2.8a12 12 0 0 1-3-3.4c-1-1.6-1.9-4-1.8-5 0-1 .4-3.4.4-3.4s2.8 3 3.4 4.3c.5 1.4 1.7 3.3 1.4 3.5-.2.2-2.1-1.3-2.4-1-.2.4 2.3 4.8 2 5m3.2-3c-.3.1-1.8-1.6-2.1-2.6a14.8 14.8 0 0 1-.6-3.2l-1.2-3v-3.3l1.4-.2 1.9 2.7s.7 1.5.7 3.7c0 2.3.3 5.6 0 5.8zm-22.5 8a41.8 41.8 0 0 1-4-6l-1-2.9.5.4s.8 3.2 4.7 7.1c4 4 4.9 4.2 4.9 4.2s.7 2.2.4 3c0 0-2.9-2.6-5.5-5.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M313.6 235.9s-3.4-3-6-6.4a46.6 46.6 0 0 1-4.4-6.6l1.2-1a46.3 46.3 0 0 0 9.2 14m4.7-1-6-6.1c-2-2.2-3-4.4-3-4.4l1.6.6s.7 1.7 2 3.5zm-.8-7s-2.1-2.6-3.1-4.2l-2-3.8s2.8 3.3 3.6 3.5c.9.2.9 0 .9 0s-.4 1.2-.1 2.2zm.9-10.6s.3 1.9.1 3c-.2 1-.8 1-.8 1a15.7 15.7 0 0 0 4 4l-1.8-2.7c-.5-1-1.3-2-1-2.8.4-1 2.1.6 2.6 1l2.6 2.8s-.8-2.5-1.8-3.4a53.6 53.6 0 0 0-4-2.9z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "m327 222.8-1.7-4.2-1.6-5.2v2.8c-.1 1.2-.5 3-1 3.3-.6.2-.7.3-1.7 0-1-.2.7.5.7.5s1 0 1.4-.5c.4-.5.5-1.5 1-1.4.4.2 1 1.7 1.3 2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#202020",
      d: "M323.7 213.4s2 2.3 3 1.3c.8-1 .3-4 .3-4s1.2.5 1.6.2c.4-.4.2-1.5.2-1.5s2.3 3.2 3.3 5.3c1.1 2 1.6 5.8 1.6 5.8s-1.8-3-2.7-5.8c-.9-2.6-2.1-3.8-2.3-3.5a5.3 5.3 0 0 0-.3 3c.2 1 1 2.1 1.5 3.5l1.1 3.4-1.6-2.5c-.7-.8-1.3-1.2-1.7-1.6-.4-.4-1-1.2-1.7-1.4-.6-.3-1.8-.9-1.8-.4s-.3-1-.3-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#171717",
      d: "M316.8 223.3a27 27 0 0 0 4.2 6.3s-2-1.8-2.8-3a15.5 15.5 0 0 1-1.4-3.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M330.2 223.9c-.3 0-1.3-.3-1.4 0 0 .4.6 1.8 1.3 2.5.7.7 1 .7 1.1.6.2 0 0-.7-.2-1.4v-1.7c-.1-.3-.8 0-.8 0"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "m306 209.4-1.3.7-1.4 3 .4 5.3 2.1 3c.8 1.2 3.5 4.2 4.2 4 .7-.2 1.4-2.3 1.5-3.4l.2-3.2 1.8 2.3c1.1 1.3 2 2.4 2.6 2.3.5 0 2-3.2 2-3.6.1-.4-3.8-10-3.8-10l-1.8-1-6.6.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "m314.8 217.4 1 3.7c.5 1.2 0 2.3.3 2.3.2 0 2.3-2.7 2.3-4 0-1.2 0-2.5-.5-6.3s.2-5 .2-5l-1.2-1-2 4.2zm-7-2.2.7 5c.3 1.2 1 3.3 1.4 3.2.4 0 1.6-3.3 1.7-4.4 0 0-.9-1.6-.8-5.5 0-4-.4-4.4-.4-4.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#45392d",
      d: "M302.5 207.5s-3.1 4.6-3 7c0 2.5.4 2 1.1 4.2.7 2.3 1.1 5.6 1.2 5.9 0 .2.5-.2.5-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M302.5 208s-2.7 4.3-2.5 6.6c.2 2.3.5 2.3 1.3 4.4.8 2 .8 5.4.8 5.4s1-.2 1.9-.9c1-.7 1.8-2.1 1.8-2.1l-1-2.1a8 8 0 0 1-.6-2l-.8-1 .2-4.1.7-3v-1l-1.8-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M317.2 215.3s-1.3-.3-1.9-.6c-.6-.3-.8-1.1-.8-1.1l.4-.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d2a567",
      d: "M303 208.5s-2 4.3-1.7 7.2 1.9 6.6 2 6.7c.2 0 0-.3.1-1v-8.7l.9-2.8v-1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M307.8 209.5s.3 1.2.1 1.8c-.2.5-1.2 1.2-1.6 2-.5.8-1 2.8-1 2.8s.4-1.1 1-1.8c.7-.7 1-1.2 1-.8.2.4.4 2 .3 2.3-.1.3-.7.8-1 2-.4 1.3 0 2.4 0 2.4l.5-2.2c.2-.6.7-1 .7-1l1 2.4s0-1.1.3-2c.1-.8 1-2 1.3-2 .3 0 .8-.1-.3-.7-.4-.2-.1-4.2.1-4.4.3-.2 1.9-.2 1.7-.8a11 11 0 0 0-1.6-2.2c-.1-.1-2.5 2.2-2.5 2.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "m317 218.1-1.5-.3c-.5 0-.6-.6-.6-.6l.2-.6 1.2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M304.4 218.6c0 .4-.3.9-.5 1.5-.3.7-.4 1.6-.4 1.6l-.4-3.3-.3-2.4c-.2 0-.7.7-.7.7s0-1.6.3-2.3c.3-.7.5-1.8.3-2-.3-.1-.8.3-1 .7a30.8 30.8 0 0 0-.8 1.3s.3-1.3.6-1.9c.3-.5 1.8-2.2 2-2.8.4-.7.4-1.4.4-1.4h1s1 .8 1 1.5c0 .4-1 .9-1 1 0 0-.8-.1-1 3.2-.2 3.4.6 3.2.5 4.6m9.4-8.7s.2 1.8 0 2.4c-.2.6-.7 1-1.1 1.8-.4.7-.4 2.4-.4 2.4l.5-1.4.7-1c.1 0 .6.7.8 1.7l.8 2.5s-.2-1.2.1-1.2.5-.1.9.2l.9.8s0-.5-.7-1.1c-.6-.7-1-.6-1.1-1.5-.2-1-.3-1.8-.2-2.2 0-.3.5.3.9.7l1.5 1.4-.7-1v-3c0-1 0-1.9.4-2.1.3-.3.4-1.6.2-1.8-.1-.2-3.5 2.4-3.5 2.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#1e2121",
      d: "M324.6 206.1a23.7 23.7 0 0 0 1.5 7.1s-1-2-1.6-3.6-.9-3.5-1.3-3.6c-.4-.2-1 .8-1 1.5s.5 3.3 1.1 4.2c.6 1-1-1.2-1.3-2.3l-.7-2.2s-.4 1-.3 2c.2 1.1 1.1 2.7 1.1 2.7l-1-1-.6-.7s0 1.5.4 2.1l1.2 1.7-1.3-1-.4-.8s.2 2.1.6 3.3l1.5 3s-1.2-1-2-2.9c-.8-1.8-1.2-7.3-1-8.1l1.1-1.9c.6-.8 1.3-4.7 1.3-4.7s.9 3.6 1.5 4.3c.6.7 1.2 1 1.2 1zm-8.6-1 .8 1.3.6 1s-1 1.1-2.3 2c-1.2 1-2.8 2-3.1 1.5-.4-.5-.4-1-.4-1s1.4-.8 2.4-1.8a6.6 6.6 0 0 0 1.6-2.2c.2-.6.5-.9.5-.9zm-10.9 3.5s.2 2.2 1.2 2.2c.9 0 3.7-2.9 3.9-3 .2-.1.4-.8.4-1l-.2-.8s-3 3-4 3.2c-.9 0-1.3-.6-1.3-.6m.1-3-.3 2c0 .5.2.9.2.9s-2.2.7-2.5 0c-.4-.6-.1-1.6-.1-1.6h1.5c.6-.2 1.2-1.3 1.2-1.3m20.3-3.1 1.5 3.2 1.4 2.8s-1.4-1.7-1.9-2l-1.2-1 .2-1.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M302.1 207h1.3c.5 0 .8-.2.8-.2l.9-1.2s-.5 1.4-.2 2.5c.3 1 1 1.1 1.2 1.1a4 4 0 0 0 2.2-1.1c.9-1 2.1-1.9 2.1-1.9s-.3 1.3.2 2.7c.5 1.3 1.2 1.3 2.2.4 1-.8 2-2.2 2.6-2.8l.7-1 1.1-1 1-5.4-.5-.7-1.4.7-1.7-.7-.5-.7-1 1.7-1 .6-.5.1-1.2.3-.5-1.1-.3-.8-.6-.3-2.4 2.5-1.4-.1-1.3 2.2-1 1.3-1 2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M313.9 201.5s.2 1.3-.5 3.6-1.6 3.9-1.6 3.9 2.4-1.5 3.6-4.2c1.1-2.6.9-5.7.9-5.7zm3-2.5s.2.4 0 2.4l-.8 4 .6 1.2c.4.7 1.2 1.8 1.7 1.6.6-.2 1.6-.9 2.2-2.2.6-1.4 1.1-2.7 1.4-2.9.2-.2.3.1.4.2 0 .1.3 1.3.9 1.8.5.5 1.3 1.3 1.6 1 .4-.2.8-.9.7-1.2l-1.3-4-1.6-4-1-1.6-2.8.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M321.7 195.3s.8 1.7.9 3.6c0 1.8-.4 3.8-.4 3.8s.2-2.3 0-3.7c-.3-1.4-.7-2.3-.7-2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M325.6 202.6v2.3c-.2.8-1.3-.5-2-3-.6-2.5-.5-3-1-4.3l-.9-2.2 1.5-.3zm-7 4.6s2.8-1.5 3.1-6.2c.2-2.1-1.2-5.7-1.2-5.7s0 3.8-1 6.2a60.9 60.9 0 0 1-1.9 4s.7-.2 1-.6l.8-1.1s.1.7-.1 1.6l-.6 1.8zm-2.3-8.1s-.1 1-1.3 2c-1 .9-3.1 1.9-3.1 1.9s1.5-1.4 2-2.6c.6-1.2.1-2 .1-2s-.2.6-.8 1.1c-.6.5-1.6.6-1.6.6s0-.6.7-1.3c0-.1 0-.4.2-.7.3-1 1.1-2.3 1.1-2.3s.7 1.4 1.3 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#1e2121",
      d: "M324.7 193.6a17.6 17.6 0 0 0 .9 9s-1.4-2.2-1.7-3c-.4-1-.4-2.3-.7-3a3.2 3.2 0 0 0-1-1c-.3-.2-1-.1-1-.1s.8-.4.8-1.1v-1l1.4.3h1.3zm-6 9.8s1.4-2 1.8-4.6c.4-2.6 0-3.5 0-3.5s-.6 0-1.1-.5c-.5-.5-1.3-1.8-1.3-1.8s.2 1.4 0 3c-.4 1.6-1.8 3-1.8 3s.8.4 1.4 0c1.5-.9 1.4-2.5 1.4-2.5s.3.2.3 2.2-.7 4.7-.7 4.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M301.2 206.9c-.3 0 1-2 1.8-3.4l2.1-3.4s.3.3.8.3a3.6 3.6 0 0 0 2.4-1.7 7 7 0 0 0 1-2.5c0-.3-.1 1.8 1 3 1 1.1.9 1 1.3 1 0 0 0 1.4-.4 2.7l-.8 3.3s.2-2.5-.3-3.2c-.4-.8-.6 0-1 1-.3.9-1.1 1.5-1.1 1.5s.6-1.1 1-2.3c.4-1.2.2-1.2 0-1.2 0 0-.2-.1-.6.4-.5.5-.9.6-.9.6s.5-.4.7-1a6 6 0 0 1 1-1.8c.2-.3.4-.7.4-1 0-.2 0-.7-.2-.7s-.5.3-1.4 1.2l-1.3 1.3-.9 2.6a17 17 0 0 1-1 2.8l-.6.4.9-2.4 1-3.4c-.2-.3-.7-.3-.8 0l-2 2.8c-1 1.4-1 3.1-1.2 3.2l-1-.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#874f20",
      d: "M325.7 192.1c0 .2 0 1.2-1 1.5a3.5 3.5 0 0 1-2.3-.2c-.2 0-.2-1.4-.2-1.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#b27129",
      d: "M306 195.4s-.2.9-.8 2c-.5 1.2-1.4 2.2-1.3 2.4 0 .1.6.7 1.4.6.8 0 1.1-4.8 1.1-4.8l-.1-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M318.4 192.7s-.3 6.4-2.1 6.4-2.7-3.2-2.7-3.2-.1 4.3-2.4 4.3c-1 0-2.1-3.4-1.9-4 0 0-.4 2.3-1.5 3.2-2.2 1.7-3.5.9-3.6.6 0-.3 1.8-2 2-4.6 0 0 .4.1 1-.6s.7-1.6 1.3-1.5c.5.2 3-1 3-1l1.4-1.7s.2.5 1.2-.2a3.6 3.6 0 0 0 1.3-1.7l2.7 2.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#b27129",
      d: "m311.4 186.6 2.7 3.8.6-.5c.4.5.6.9.4 1.2-.4 1-1.3 2.3-.5 3.7 0 0-.3-.8.1-1.8s.7-1.4 1-1.3c.2 0 .6 5.8 1 5.8.3 0 .9-2.7.9-4.5 0-1.8.3-.3.5 0 .2.4 1.8 3 3.1 2.6 1.4-.4 1.2-2.8 1.2-3.3 0-.6-1-3.7-1-3.7l-6.1-3.9-.5 1.6c-.3 1-3.4.3-3.4.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M320 186s.4.4 1 1.9.7 6.4-.1 6.4c-.8 0-2.3-1-2.6-1.6-.3-.7 0-3.1-.4-3.8a8.1 8.1 0 0 1-1.2-2.7l.1-2 1.4-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "m319.6 184.5 2.6 3.9 2.3 3.3 1.2.4a2.5 2.5 0 0 1-3.2.5c-.9-.5-.4-2-1.5-4.5-1.2-2.5-3.2-3.6-3.2-3.6l.7-.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#1e2121",
      d: "M318.2 182.4s2.3 1.5 3.1 3.2c.9 1.7 1.3 2.7 2.3 4.3 1 1.6 2.1 2.1 2 2.2 0 .1-.7.3-1.2 0a4.7 4.7 0 0 1-1.4-1.6 35 35 0 0 0-2.4-4.2c-.5-.7-2.3-2-2.3-1.9 0 .1.5.5 1.5 2.1a7 7 0 0 1 1.2 3.1l-1.1-2c-1-1.5-2.8-3.3-2.9-3-.1.2 1 1.9 1.5 2.9l1.3 3.3-1.8-3c-1-1.5-1.2-1.3-1.6-1.8l-1.4-1.8s1 .3 1.8-.3c1-.6 1.4-1.5 1.4-1.5"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M312.3 186.7s1.5.3 2.3.2h1.1s.5.6.5 1.4c0 .7-.5 2.1-.8 2.2-.2 0-.2-1.3-.5-1.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#b27129",
      d: "M313.1 190.6s.5 1.6.1 3.9c-.4 2.2-1.7 4.6-2 4.6-.3 0-.2-2.6-.4-4a38.8 38.8 0 0 0 0-.4l-.5 1.6.4-2.6-.1-.8 1.6-2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M310.3 192.3c-.5.5-1.2.4-1.8.6-.6.2-.9 1-.9 1s.5-.3.7-.2c.3.1.5.1.1 1.2-.5 1.1-2.2 3-2.1 3 0 0 2-1.5 2.5-2.5.7-.9.6-1.4.8-1.8 0-.3.8-.7 1-.7.1 0 .5 0 .6.7l.6 2.6.8-2.6c.2-1 .2-2.9.2-2.9l-.6-.1c-.5-.1-1.5-1-1.5-1s.2 2-.5 2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M318.3 180.8s.6 1.5-.7 2.6c-.4.3-.7.5-1.4.6a4.5 4.5 0 0 1-1.7-.6l-4-1.6-2-.6-1-.3.2-1.1h3l3 1.2 1.3.5 1.1.2h.9l.7-.2.4-.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M318.3 180.8c0 .3-.3 1.1-.6 1.3-.3 0-.8.3-2 0-1.1-.2-2.3-1-3.6-1.3-1.3-.4-2.3-.7-3.3-.7s-.5-.4-.5-.4 2.3-.3 4.3.5c2 .7 2.9 1.2 4 1.2 1.4 0 1.7-.6 1.7-.6"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M307.6 179.6h.9c.4 0 .7-.3.7-.3s0 .5-.2.7c-.3.2-1 .1-1.2.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M315.3 184.4s1.3 1.3 1 2.4l-2.7-1.2-4.2-1.7-2.3-.7-.3-.4.6-.8.2-.8 2.8.4 3 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M312.4 186.3s2.4 3.1 1.8 4.1l-5.6-3.5-2 3.3-4.7-2.3s3.8-3 4.2-3.5l.5-.7 2 .4 3.4 1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M311 181.6s2 .5 3.3 1.2c1.3.6 3 .8 3 .8s-.6.7-2 .8c-.4 0-1.4-.8-2-1.3-.7-.4-2.6-1-2.6-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M307.6 180.6s1.4.3 2.2.7c1 .3 1 .2 1.2.1.3 0 .3-.2.3-.2s.2 1-.5 1-1-.3-1.8-.7c-1-.4-1.5 0-1.5 0v-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M315.4 186s1 .7.9.9c-.2 0-.7.3-1.6.4a3.4 3.4 0 0 1-2-.4c-.6-.2-1-1.3-2.5-2a18 18 0 0 0-2.8-.9l-1.3-.2 1-.4 3.2.6 2.8.9 1.7.8.6.4zm-5.4 2 .6 2.6-.4 1.5-.8.6-.8-.3-.3-.5s.4-.6 0-1.1c-.3-.6-2-1.2-2-1.2s.7-1.3 1.4-1.6c.8-.3.4-1.2.4-1.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M306.8 182.8s.5.4 1.5.5c.5 0 1.3.2 2.2.5l1-.3-.5.4c.9.2 2 .7 2.5.9a5.8 5.8 0 0 1 2 1.3l-2-1a17.4 17.4 0 0 0-3-.9c-2-.3-4-.2-4.3-.4-.4 0 .1-.1.4-.3.2-.2.2-.7.2-.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M314 189.8s.7.7 0 .9c-.6.2-2.4.2-3.2-.7l-.6-1.2a14 14 0 0 0-2.4-1.7c-.7-.5.3-.5.3-.5l3.6 1.5a13 13 0 0 1 2.3 1.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M314 189.9s-1.2-1.8-4.9-3.3l1.2-.2h-2a24 24 0 0 0-.8-.3c-2-.6-2-.6-2.2-.8-.1-.3-.4 0-.6.3l-.7 1a5 5 0 0 1 2.5-.1c1.1.3 1 .7 1 1-.1.5-1.4 2-1.3 2.1.2 0 1-1.5 2-1.3 1 .3 1.2.8 1.2.8s0-.6-.2-.8c-.2-.2-1.3-1.3-1-1.3.3 0 1.6.3 3.3 1.2 1.8.9 2 1.1 2.6 1.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M308.1 187s2.8.8 2.7 3.8c-.1 3-2.3 2.4-2.5 1.3-.2-1 .3.5 1 .4.9-.2 1-1 1-2.2 0-1-.3-1.6-1-2.2a12 12 0 0 0-1.2-1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#6c3f18",
      d: "M296 179.9s.4.2-.4 2.3c-.8 2.1-1.3 2.8-2.5 4.2-2.2 2.4-3.2 2.5-3 3.5.3 1 1.1.8 1.3.8.2 0 4.3-6 4.3-6l.9-3.5-.2-1-.3-.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#dbad6c",
      d: "M306.1 175.6s1.2 1.8.8 5c-.3 3.4-4.7 6.3-4.7 6.3l-6.4 4.4-2.7-.2h-.8c-.4-.1-.8-.5-.9-.5l-.5-1.2.9-1 2.3-2.3 1.4-2s.7-1.3.8-2.5c0-1.1-.2-1.7-.2-1.7l.5.8.3 1.8-.2 2 1.6-1.2 2.2-1s.7 0 1-1.3c.5-1.2.9-3 .9-3.8l-.1-1.8h.3c.2 0 .7 1.2.7 1.7l.4 2.8 1-1 1-1.5c.2-.5.4-1.3.4-1.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "M306.8 192.2s.5.4.3 1.6c-.2 1.2-1.1 1.8-1.6 1.8V194l-1.4-1.2-1.5-.4.3-.3c.1-.2 1.7-.8 1.7-.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M305.7 192.2s.5.4 1.2.3c.7-.2 1-1.3.6-1.8-.4-.4-.2 1-.7 1.3-.4.1-1-1.2-1.5-1.3-.7-.1-1.6.3-1.9.7-.2.4 1 0 1 0l.7.3h.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "M296.5 187.6s.8.3 1.7.1l3.1-1 1.8-1.3c.7-.7 3.1-2.2 3.4-5.1.2-3-.4-4.7-.4-4.7s3.5 3.8.5 8.2c-2 2.8-3.8 3.7-3.8 3.7s3.4-1 3.7-.2c.3.8-.1 2-.2 2.3 0 0 1.9.4 2.2 1.4.1.6-2.2-.7-4-.2-1.8.4-2.5 1.4-2.5 1.4s-.4-.5-2-.5c-1.5 0-2.2.7-3.1.7-1 0-3.7-.6-4.2-1.4l1.8-2.2c.8-1.6 2-1.2 2-1.2"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M303.8 179.7s1.3-1.3 1.8-2.3c.4-1 .5-1.8.5-1.8s.2 1-.6 2.3-1.7 2-1.7 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "M303.4 176.7s1.1 4.4 0 6.1c-1.3 1.8-6.5 4.1-6.5 4.1s4-2.1 5.2-4.6 1.1-4.5 1.1-4.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#1e2121",
      d: "M298.2 187.7s1.7 0 2.6-.6c1-.5 2.3-1.7 2.3-1.7s-1.2 1-1.6 1c-.3 0-.6-.5-.5-.9 0 0-.3.8-1 1.4-.8.5-1.8.8-1.8.8m3.9-5.4s1.4-1.4 1.4-4.4c0-3-1.2-2.5-1.2-2.5s1 .7.7 3c-.2 2.3-1 4-1 4zm1.7.3s1.6-.3 2.1-1.3.6-2.7.6-2.7-.2 1.7-.7 2.3c-.4.6-2 1.7-2 1.7m-1 9.5s.8-1.5 1.9-1.1c1 .4 1 1.2 1 1.2s-.4-.6-1.2-.7c-.7 0-1.6.6-1.6.6zm-2.9-2.7 3.7-1 3-1s-1.2 1.3-3 2.3c-1.6 1-3 1-3 1s3.2-1.4 3.4-2c0 0-3 .9-4 .7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M296.2 185.8a2.6 2.7 67.8 0 1-3 4.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f16e16",
      d: "M296.1 186.1a2.3 2.4 67.8 0 1-2.7 3.8"
    }),
    /* @__PURE__ */ jsx175("path", {
      d: "M295 187.4a1 1 0 1 1-.8 1.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#d5d3ca",
      d: "M295.2 188.6a.3.3 0 1 1-.6-.1.3.3 0 0 1 .3-.3.3.3 0 0 1 .3.4"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M296.8 184.2s1.6-1.5 1.9-3.5c.3-2 .1-3.2.1-3.2l.9 1 .3 1.4-.5 2.6 1.6-.8c.6-.8 1.5-4.2 1.2-6.3 0 0 .4 1-.2 3.8-.6 2.9-1 3.2-3.2 4.4a9.6 9.6 0 0 0-3.8 4.2 19 19 0 0 1-2.3 3l1.6-2.6c.8-1.8 1.7-2.8 1.7-2.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#904720",
      d: "M296.1 185.4s.7-2 .7-3.1-.7-2.4-.7-2.4 1-.1 1 2.2c.1 2.4-.4 2.6-1 3.3"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#4d2a15",
      d: "M299.2 182.8s.7-1.7.7-3c0-1.1-1-2.3-1-2.3s1.1.3 1.2 2.4c.1 2.2-.2 2.2-1 3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#ab6d29",
      d: "M292.1 191s-.6-.8-.5-1.3c0-.6 0-.7 1.4-2.2a13 13 0 0 0 2.5-3c.3-.9 1.5-3 .6-4.6 0 0 .6 2.4-.8 4.3a15.7 15.7 0 0 1-3.3 3.7c-1.1.8-1.3 1.2-1.2 1.7 0 .5.1 1 .3 1 .4.3 1 .3 1 .3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#6c4119",
      d: "M305.5 195.6s.3 0 .5-.3.2-1-.3-1.6a3.3 3.3 0 0 0-1.7-1.1l-2-.4s.4.8 1.3 1.3c.4.2 1.2 0 1.6.4.5.4.6 1.7.6 1.7"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#6c4119",
      d: "M305.5 195.6s1.5-.5 1.6-2l-.1-1.2s.2.5.8.7l.6-.2s-1 2.8-3 2.7z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#bf802d",
      d: "m294.8 195.3.8.8.9 1 3.7-1 1.2-1.2-1-1.6h-2.7l-3 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9c83a",
      stroke: "#8f4620",
      strokeWidth: 0.4,
      d: "m303.8 194-.7-.9-.7-.6c-.6-.3-2.8-.3-2.8-.3l-1.6.3s-.5.5-1.3.3a22 22 0 0 1-2.6-1l-1.9-.7s-1.3-.6-1.6-.5c-.3.1-1.5 1.3-1.5 1.3s-.2.7.3.7c.4 0-.7.2-.7.2s-2.8 1.6-3.2 4.4c-.5 2.7 4.6 6.8 6.5 4.7 0 0-2.8-2-2.2-3.7.5-1.7 1.8-2.8 4-3 2.1 0 2.3-.3 3.2-1 1-.6 2.7-1 4 .3 1.3 1.4-5 2.7-5 2.7l.7 1s7.7-2.7 7-4.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcf3d8",
      d: "M289.4 200.7s-3.1-.8-2.9-3.7c.3-2.8 3-3.9 3.4-4 .4-.2.3-1.6.8-1.8a2.4 2.4 0 0 1 2 .5l1.4.8s-5.5 2.4-5.5 5.6c0 2.1.8 2.5.8 2.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fdeaaf",
      d: "M303.8 193.8s-.4.2-.5 0c-.6-1-2-1.4-3-1.3-1.5 0-2.4.5-3.4.5s-.7-.1-1.8-.2c-1.1 0-3.5-1.8-4-1.6-.6.2-.8.8-.8 1.1.1.4-1 .4-1 .1-.2-.2.7-1.7 1.7-1.7 2.6 0 4.6 1.7 5.8 1.7 1.3 0 1.7-.7 3.4-.7s3.5.8 3.6 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#513625",
      d: "M295.2 195.8s1.3-.2 2.2-.6l2.2-.8-2 1.2-2 .5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9c83a",
      d: "M290.8 202.3c-.2 0-1.3 0-3-1.1-1.8-1.2-2.3-3.2-2.3-3.2s-.4-1.9 1.4-3.8c1.8-1.9 2.1-1.3 2.2-1.2.1 0 0 .1 0 .1l-1.7 1.3-.7 1.3-.7 1.2v1.4l.8 1.5 2.5 1.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8b5122",
      d: "M289.8 191.4v-.2.3-.3.3-.3l-.3.2h.2v-.2l-.2.2.2-.2h-.2a.3.3 0 0 0 0 .2l.2-.2h-.2.2-.2.2-.2.2l-.2-.1.2.1-.2-.1-.1.1a4.6 4.6 0 0 0-.4.5l-.2.6v.1c0 .3.2.5.4.6h1.4a.3.3 0 0 0 .1-.4.3.3 0 0 0-.3-.2l-.7.1a.8.8 0 0 1-.3 0v-.2a.5.5 0 0 1 0-.2 3 3 0 0 1 .3-.5l.2-.1zl.1-.2a.3.3 0 0 0-.3-.2.3.3 0 0 0-.2.3.3.3 0 0 0 .3.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9c83a",
      d: "m295.1 194.1-3.8 1.1c-.3.2 1.2 0 2.4 0l1.3.1.9-.2c1.4-.5 4.4-1.6 4.7-.3.2 1-4.1 2-4.1 2v.5l3.4-.9 1.9-1 .5-.9-1.7-1.2H298l-1.2.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "M289.7 199.5c.3.8.9 2 1.6 2.3 0 0 .1 0 0 0 0 .1-.5.5-1.7.1-1.2-.3-3-.7-4.1-4v.7l.7 1.3 1.1 1.2 1.9 1.1 1.2.3 1-.2.6-.4-1.1-1-1.4-2.3z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fcca3d",
      d: "M302.1 232.6v1.2h-.7v-1.5zm-4.7-34.4-1.2-1.4-.8.1 1.2 1.8z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#816c2a",
      d: "m302 235.5-1.7-1a10 10 0 0 0-2.4-.6v.3h.2l2.1.6a14.3 14.3 0 0 1 1.7 1zm0-3.1h-3a4 4 0 0 0-1.3.7l.1.2a3.8 3.8 0 0 1 2.6-.7 23 23 0 0 1 1.4.1v-.3zm-.4-2.7-2.6 1.4-1.6 1.2.2.2.5-.4a16.5 16.5 0 0 1 2.6-1.6l1-.5zm-1.7-2.7s0 .7-.3 1.2a8.6 8.6 0 0 1-.6.8 86.3 86.3 0 0 1-2.5 2.6l.2.3a220.4 220.4 0 0 0 2.5-2.7l.7-.8c.3-.6.3-1.3.3-1.4zm-2.1-1.2a4.2 4.2 0 0 1-.2 2.2l-1 2.2-.4.9-.2.3.2.2s1.3-2.2 1.7-3.5c.2-.5.2-1 .2-1.5a4 4 0 0 0 0-.9zm-2.1-.3a8.7 8.7 0 0 0 0 1.2c0 .6 0 1.2-.2 1.7l-.7 1.8-.3 1 .3.1 1-2.8c.2-.5.2-1.2.2-1.8v-1.2zm-1.6 0v1.2l-.3 2a52.2 52.2 0 0 0-.5 2.5h.3l.2-.8.3-1.7c.3-1 .3-3.2.3-3.2zm-1.8.3a13 13 0 0 0 0 2.9 14 14 0 0 0-.4 2.5h.3a23.3 23.3 0 0 1 .4-2.4l.1-1.4v-1.6zm-1.3.2v.2a9 9 0 0 1-.3 2.2l-.6 1.9-.2 1h.3l.8-2.9a8.9 8.9 0 0 0 .3-2.2v-.2zm-1.6 0v.7c0 .6 0 1.4-.4 2a5.5 5.5 0 0 1-1.3 1.6 9.8 9.8 0 0 1-.7.4l-.2.2.1.3s1.7-1 2.4-2.3c.4-.7.5-1.6.5-2.2v-.7zm-.9-.3v.2a6.7 6.7 0 0 1-1 1.9c-.3.4-.9.8-1.3 1.1a12.1 12.1 0 0 1-.8.5l.2.3s1.4-.8 2.1-1.7a8 8 0 0 0 1.1-2.2h-.3zm-1.5-.7v.1a6.2 6.2 0 0 1-1 1.3c-.1.2-.5.4-.9.6l-.6.4.1.3.7-.4 1-.7.7-.9.3-.6zm-.7-1-.3.3-.9 1a6.5 6.5 0 0 1-.5.4l-.4.3.1.3.7-.4c.7-.6 1.5-1.7 1.5-1.7zm-.4-.6-.2.2-.9.6a2 2 0 0 1-.8.3v.4l.6-.3c.7-.3 1.5-1 1.5-1zm-.2-.7-.8.4-.6.3a1.9 1.9 0 0 1-.4.2v.3c.2 0 .3 0 .5-.2l1.4-.7zm-.4-1.3-.5.5-.9.3v.3a2 2 0 0 0 1.2-.5 3.8 3.8 0 0 0 .5-.4zm.1-2.2-.6.5c-.3.3-.6.6-.7 1a.6.6 0 0 1-.1 0v.5l.2-.2a.8.8 0 0 0 .2-.2c0-.2.4-.6.7-.9a7.9 7.9 0 0 1 .5-.5zm10.7-12.8h1.6l.1-.2v-.1h-.1v.3-.1h-.2.1-.1v-.2l.1.1v-.1.1-.1h-1.5zm0-1h.2c.2 0 .4 0 .6-.2.4-.1.7-.4 1-.6l.5-.3a.8.8 0 0 1 .3 0v-.4l-.6.2-1 .7-.8.3zm0-1.5.7-.2 1.2-.8c.4-.3.7-.4 1-.4v-.3c-.3 0-.5 0-.8.2l-1.2.7a3 3 0 0 1-1 .5v.3zm-.6-1.4 1.5-1 1.6-1.2-.1-.3-1.7 1.2c-.5.5-1.1.9-1.5 1l.2.4zm-1-1.5 3.2-2.3-.2-.3-3.2 2.3zm-1.5-1.6a20.7 20.7 0 0 1 3.4-2.3l-.2-.2-1.5 1-1.9 1.3zm-1-1a123.7 123.7 0 0 1 2.6-1.8l.8-.5-.1-.3a7.6 7.6 0 0 0-.8.5 113 113 0 0 0-2.7 2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "m294.5 195.4.1.1a17.3 17.3 0 0 1 2.5 2.5c1 1.2 1.8 2.7 1.8 4.1v.5a9.5 9.5 0 0 1-2.5 5c-2 2.3-4.8 4.4-7 6.4a18 18 0 0 0-3 3.1 6.1 6.1 0 0 0-1.2 3.7 6.4 6.4 0 0 0 1.1 3.4 4.4 4.4 0 0 0 3.9 2c1.8 0 3.8-.7 5.6-.7 1.6 0 3 .4 4.4 1.9 1.3 1.4 1.7 3.6 1.7 5.7 0 1.6-.2 3-.4 4.2a25.6 25.6 0 0 1-.4 1.8h.3s.8-2.8.8-6c0-2.1-.4-4.5-1.8-6a5.8 5.8 0 0 0-4.6-1.9c-1.9 0-3.9.6-5.6.6a4 4 0 0 1-3.6-1.8 6 6 0 0 1-1-3.3v-.1c0-1.6.7-3 1.9-4.3 1.8-2 4.5-4 7-6.2 2.3-2.2 4.4-4.5 4.7-7.5v-.5c0-1.8-1.1-3.5-2.3-4.8a17.2 17.2 0 0 0-2.3-2.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "m292.1 198.4-.4-.3-.3.1.6.5zm1 1-.3-.3h-.1l.2.4z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "m294.5 201-.2-.4-.2.2zm1 1.5-.1-.3h-.3l.4.5zm.7 1.5-.2-.4v.4zm0 1.5v-.4l-.2-.1v.5zm0 1v-.5l-.1-.1v.6zM284 221.1l.1-.7c.1-.3-.3.1-.3.1v.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "m284 222.1-.3.1.1.5.1-.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#78732e",
      d: "M284 223.9v-.4h-.2v.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "M284 224.9v-.4h-.1v.4zm.3 1.4v-.4l-.2.1zm.4 1.4-.1-.5h-.2l.2.6z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "m285.6 229.7-.2-.3h-.2zm1.5 1.4-.5-.3c-.3-.3-.1.2-.1.2l.4.2zm9.8.8-.4-.3c-.2 0 0 0 .2.4.1.3.2-.1.2-.1"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "m297.7 232.5-.3-.3v.3h.2z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#a8ac71",
      d: "M297.9 233c-.1-.2-.2.1-.2.1l.2.3zm0 1.3v-.5c0-.2-.1 0-.1 0v.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#fff",
      d: "m297.4 235.7.2-.4h-.2zm-14.8-52s.5-.2.1.4l.3-.5h-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#f9c83a",
      d: "m294.6 195 .4.3h-.5z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#8f4620",
      d: "m295 195.3-.7.1c-.2 0 .2-.2.2-.2l.4.1z"
    }),
    /* @__PURE__ */ jsx175("path", {
      fill: "#977c2e",
      d: "M301 239.1s.3 0 .5-.3-.1.4-.1.4l-.3.1-.2-.2z"
    })
  ]
});
var Mx_default = SvgMx;

// src/country-flag-icons/generated/My.tsx
import { jsx as jsx176, jsxs as jsxs169 } from "react/jsx-runtime";
var SvgMy = (props) => /* @__PURE__ */ jsxs169("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs169("g", {
      clipPath: "url(#my_svg__a)",
      children: [
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 0h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 34.3h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 68.6h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 102.9h640V137H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 137.1h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 171.4h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 205.7h640V240H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 240h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 274.3h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 308.6h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 342.9h640V377H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 377.1h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#C00",
          d: "M0 411.4h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 445.7h640V480H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#006",
          d: "M0 .5h320v274.3H0z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#FC0",
          d: "m207.5 73.8 6 40.7 23-34-12.4 39.2 35.5-20.8-28.1 30 41-3.2-38.3 14.8 38.3 14.8-41-3.2 28.1 30-35.5-20.8 12.3 39.3-23-34.1-6 40.7-5.9-40.7-23 34 12.4-39.2-35.5 20.8 28-30-41 3.2 38.4-14.8-38.3-14.8 41 3.2-28.1-30 35.5 20.8-12.4-39.3 23 34.1zm-33.3 1.7a71.1 71.1 0 0 0-100 65 71.1 71.1 0 0 0 100 65 80 80 0 0 1-83.2 6.2 80 80 0 0 1-43.4-71.2 80 80 0 0 1 126.6-65"
        })
      ]
    }),
    /* @__PURE__ */ jsx176("defs", {
      children: /* @__PURE__ */ jsx176("clipPath", {
        id: "my_svg__a",
        children: /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        })
      })
    })
  ]
});
var My_default = SvgMy;

// src/country-flag-icons/generated/Mz.tsx
import { jsx as jsx177, jsxs as jsxs170 } from "react/jsx-runtime";
var SvgMz = (props) => /* @__PURE__ */ jsxs170("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx177("defs", {
      children: /* @__PURE__ */ jsx177("clipPath", {
        id: "mz_svg__a",
        children: /* @__PURE__ */ jsx177("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs170("g", {
      clipPath: "url(#mz_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx177("path", {
          fill: "#009a00",
          fillRule: "evenodd",
          d: "M0 0h768v160H0z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M0 160h768v16H0z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "#000001",
          fillRule: "evenodd",
          d: "M0 176h768v160H0z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M0 336h768v16H0z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "#ffca00",
          fillRule: "evenodd",
          d: "M0 352h768v160H0z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "red",
          fillRule: "evenodd",
          d: "M0 0v512l336-256z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "#ffca00",
          fillRule: "evenodd",
          d: "m198.5 333-51.2-37.5L96.1 333l19.9-60.3-51.5-37.1 63.5.2 19.3-60.4 19.4 60.5 63.5-.3-51.5 37.1z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "M102.8 290.9h37c3 3.3 9.5 4.7 15.8 0 11.6-6.4 34 0 34 0l4.4-4.7-10.7-35.2-3.9-4.2s-8.3-5-24-3.3c-15.7 1.7-21.2-.5-21.2-.5s-13.7 1.6-17.6 3.6l-4.4 4.4z"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "M110.3 281.8s35.2-4.4 45.4 9.1c-5.7 4-10.8 4.3-16.2.3.8-1.5 12.6-13.8 42.7-9.7"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "m148 246.6-.3 38.8m31.7-38.3L186 278"
        }),
        /* @__PURE__ */ jsx177("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "m117 246.6-3.7 16"
        }),
        /* @__PURE__ */ jsx177("path", {
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "m78.9 295.1 8.6 10.2c1 .6 2 .6 2.9 0l12.8-15.4 5.4-6.7c.9-1 1.1-2.1 1-3l10.4-9.3 2.2.2c-1-.2-1.7-.7-1-1.8l2.4-1.8 1.8 2.3s-2.6 3.4-2.9 3.4h-2.8l-5.4 4.9 2.4 2 3.5 9.8 4.4-3.1-2.8-10 6.1-6.7-2.3-3.6 1.6-2s21.3 13.4 29.6 9.8c.2 0 .5-9.6.5-9.6s-22.2-2.3-22.7-6.7 5-5 5-5l-2.4-3.2.5-1.8 3.9 4.8 8.7-7.4 51.5 58.6c2.8-1.1 3.4-1.8 3.6-4.6L155 241.5l3.8-4.1c.8-.9 1-1.2 1-2.6l6-5.1a7.3 7.3 0 0 1 3.8 3L186 219c.4.4 1.7.8 2.6.4l26.9-25.9-29.3 20.7-1-.7c0-.9 1-1 0-2.6-1.2-1.4-2.9 1.3-3.1 1.3-.3 0-4.3-1.4-5.2-3.2l-.2 4.7-7.5 7-5.7-.3-8.2 8-1 3 1.3 2.7s-4.4 3.8-4.4 3.6c0-.3-.9-1.2-1-1.3l3.8-3.4.5-2.3-1.2-2c-.4.3-5.2 5.4-5.5 4.8l-14-15.5.8-2.9-8.7-9.5c-3.2-1.1-8.3-1.3-9.3 5.7-.8 1.6-7.4.2-7.4.2l-3.6.8L85.2 241l11.3 13.6 23.2-29.3.7-8.3 4.8 5.4c1.7.2 3.2.3 4.7-.5l13.7 15.3-2.3 2.3 2 2.2 2.4-1.6.9 1.3c-1.1.6-2 1.5-3.1 2.1-1.8-1.2-3.6-2.7-3.5-5l-7.7 6.4-.3 1.2-22.9 19-2 .3-.5 6 14.9-12.4v-1.8l1.5 1.3 11.6-9.3s.8 1 .5 1-10.3 9.3-10.3 9.3l-.2 1-1.8 1.6-1-.8-14 12.4h-2l-7.7 7.7c-2 .2-3.7.4-5.4 1.5z"
        })
      ]
    })
  ]
});
var Mz_default = SvgMz;

// src/country-flag-icons/generated/Na.tsx
import { jsx as jsx178, jsxs as jsxs171 } from "react/jsx-runtime";
var SvgNa = (props) => /* @__PURE__ */ jsxs171("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx178("defs", {
      children: /* @__PURE__ */ jsx178("clipPath", {
        id: "na_svg__a",
        children: /* @__PURE__ */ jsx178("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs171("g", {
      fillRule: "evenodd",
      clipPath: "url(#na_svg__a)",
      children: [
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#3662a2",
          d: "m-26.4.2.8 345.6L512.5 0z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#38a100",
          d: "M666.4 479.6 665 120.3 122.3 479.8l544-.2z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#c70000",
          d: "m-26 371.8.4 108.2 117.5-.1L665.4 95.4l-.7-94.1-116-1L-26 371.7z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#ffe700",
          d: "m219.6 172-21.8-13.2-12.6 22.1-12.2-22.2-22 12.9.6-25.4-25.4.2 13.2-21.8-22.1-12.5 22.2-12.3-12.8-22 25.4.6-.1-25.5 21.7 13.2L186.3 44l12.2 22.2 22-12.9-.6 25.4 25.4-.2-13.2 21.8 22.1 12.5-22.2 12.3 12.8 22-25.4-.6z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#3662a2",
          d: "M232.4 112.4c0 25.6-20.9 46.3-46.6 46.3s-46.6-20.7-46.6-46.3 20.8-46.2 46.6-46.2 46.6 20.7 46.6 46.2"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#ffe700",
          d: "M222.3 112.4a36.5 36.5 0 1 1-73 0 36.5 36.5 0 0 1 73 0"
        })
      ]
    })
  ]
});
var Na_default = SvgNa;

// src/country-flag-icons/generated/Nc.tsx
import { jsx as jsx179, jsxs as jsxs172 } from "react/jsx-runtime";
var SvgNc = (props) => /* @__PURE__ */ jsxs172("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx179("path", {
      fill: "#009543",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx179("path", {
      fill: "#ed4135",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx179("path", {
      fill: "#0035ad",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx179("circle", {
      cx: 240,
      cy: 240,
      r: 157.3,
      fill: "#fae600",
      stroke: "#000",
      strokeWidth: 5.3
    }),
    /* @__PURE__ */ jsx179("path", {
      stroke: "#000",
      strokeWidth: 6.4,
      d: "M213.3 263.5h53.3M213.3 224h53.3M240 83.2V352"
    }),
    /* @__PURE__ */ jsx179("path", {
      fill: "#000001",
      d: "M176.6 384.4c64.2 26.3 124.4 1.7 124.4 1.7s-22.7-24.6-34.3-34.2c-11.4-9.4-44.8-9-56.2 0a488.7 488.7 0 0 0-33.9 32.5"
    }),
    /* @__PURE__ */ jsx179("ellipse", {
      cx: 240,
      cy: 312.5,
      fill: "#000001",
      rx: 17.6,
      ry: 25.6
    }),
    /* @__PURE__ */ jsx179("ellipse", {
      cx: 240,
      cy: 243.7,
      fill: "#000001",
      rx: 21.3,
      ry: 13.5
    }),
    /* @__PURE__ */ jsx179("circle", {
      cx: 240,
      cy: 181.3,
      r: 21.3,
      fill: "#000001"
    }),
    /* @__PURE__ */ jsx179("path", {
      fill: "#000001",
      d: "M265.6 101.9s1.8 3-2 10c-18.6 33.5-37.3 34.2-40.8 37.1-4 3.2-5.6 3-5.6 3 .3-2.9.5-14.6.7-15.7 2.9-15.7 26.5-15.5 45-31.5 2.9-2.5 2.7-3 2.7-3zm-62.4 72s4.3 12 4.8 24c1 19.2 19.4 19.7 32 19.7v-10.7c-9.5 0-17.7-1.4-24.5-15.4a122.7 122.7 0 0 0-12.3-17.6m-.5 154.6s6.7-8.3 14.6-27.7c4-10.1 13.8-16 22.7-16v-15c-20.3 0-30 7.5-31 18.6a329 329 0 0 1-6.3 40.1"
    }),
    /* @__PURE__ */ jsx179("path", {
      d: "M276.8 173.9s-4.3 12-4.8 24c-1 19.2-19.4 19.7-32 19.7V207c9.5 0 17.7-1.4 24.5-15.5 3.6-6.2 7.7-12.1 12.3-17.6m.5 154.7s-6.7-8.4-14.6-27.8c-4-10.1-13.8-16-22.7-16V270c20.3 0 30 7.5 31 18.6a329 329 0 0 0 6.3 40"
    })
  ]
});
var Nc_default = SvgNc;

// src/country-flag-icons/generated/Ne.tsx
import { jsx as jsx180, jsxs as jsxs173 } from "react/jsx-runtime";
var SvgNe = (props) => /* @__PURE__ */ jsxs173("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx180("path", {
      fill: "#0db02b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx180("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx180("path", {
      fill: "#e05206",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx180("circle", {
      cx: 320,
      cy: 240,
      r: 68,
      fill: "#e05206"
    })
  ]
});
var Ne_default = SvgNe;

// src/country-flag-icons/generated/Nf.tsx
import { jsx as jsx181, jsxs as jsxs174 } from "react/jsx-runtime";
var SvgNf = (props) => /* @__PURE__ */ jsx181("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs174("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx181("path", {
        fill: "#fff",
        d: "M194.8 0h250.4v480H194.8z"
      }),
      /* @__PURE__ */ jsx181("path", {
        fill: "#198200",
        d: "M0 0h194.8v480H0zm445.2 0H640v480H445.2z"
      }),
      /* @__PURE__ */ jsx181("path", {
        fill: "#198200",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        d: "M313.5 351.3v52.6l21.3.2s-6.8-45.8-3.1-52c3.7-6 7.2-5.2 7.2-5.2s13.9 4.2 15.4 3.5c1.5-.6-.2-5.2 7.2-4.6 2.4-.9 1.1-5 3.3-5.2 2.2-.3 44.5 11.8 53.7.4-2.4-6.4-10.7-.5-12.9-.2-2 0-10.3-4-15.1 0-4.4-3.3-24.4-5.5-24.4-5.5-2.6-2.6 47.6 1.3 50.5-.7 5.9-5.9-11-5.2-13.6-3.3a14.8 14.8 0 0 0-14.2-.6c-1.7-4.1-18-2.4-27-3.5-3-1.7-2.5-2.7-.5-3.8 19 .8 37.8 3.3 56.8 2.5 5.1-6.7-6.5-9.3-13.6-3.5-4.2-7-12.7-.3-18.4-1-5.7-.6-3-7.6 4.2-6.5 7.2 1 20.1-.4 22.5-3.7s-1.4-6.7-13.3-3.5c-4-4-13 0-17.1 1.3-5.6-3.1-18.5-.5-22.8.6-4.3-2.6 22.5-7 22.5-7 10.4-.2 16.3-2 19.5-2.8 15.7-8.4-.2-9.3-8.4-3.2-5.1-4-10 .3-14.6 1.8a38.2 38.2 0 0 1-13.4 2c0-.6 12.6-8.3 12.6-8.3s15.3-1.1 18.4-1.5c3-.5 18.8-8.5-2.7-3.1-7.4.6-11.8.2-14.7.4-16.5-1.7 1.6-3.3 1.6-3.3s23.4-2.1 23.7-3.3c.4-9-19.1-4.8-19.3-4.8 0-6.5-18.2.2-18.2 0-3.5-2 2-4.1 2-4.1 4.8-1.2 12-1.6 13.9-3.1 0 0 13.6-.1 15.2-3.7-3.3-9.3-28.8 1.6-32.2 3.2-4.6 0 3-7.4 3.3-7.6.2-.3 21-1.1 30.9-14.5.7-8.1-11.6 4.6-11.6 4.6-1-10.6-13.4.7-20.6 1.5-7.3 1-7.5-3.3-2.5-4 5-.6 10.8-.1 13.6-7.8 2.9-7.7 11.4.4 13-2.4 1.5-2.9-3.1-5.3-3.1-5.3s6.4-6.6-4-6.3c-10.2.2-23.6-1.4-23.6-1.4s10.7-4.1 20.8-4c10 .3 4.6-7.1-5-7.1-9.7 0-14.7-3.3-14.7-3.3l16.4-6.2-1-4.6s9.6-7.7-4-5.9l-15.2 2-27.4 4.1c-.2 0-7.4-2.2-.4-4s31.8-6.7 35.5-5.4c3.7 1.3-.4-9.2-13.6-10.5-13.1-1.3-21.3 3.3-21.3 3.3s-8.5-3.1-.6-5.7c7.9-2.7 20.4.9 20.4.9s14-4.2 2.4-6c-11.6-1.7-15.3 1.6-20.6 1.8-2.1-2.7 18.2-3.3 19.5-5.5-2.2-4-14.8 0-22.2 0-3-1.3-3.3-3.5.3-4.8 7.5-.3 14.6.1 22.1-.2-.2-4 0-8.7-.2-12.8-9.6-1.7-20.8 1.3-26.1 1 1.4-4.3 22-5.5 24.3-6.7 4.8-6-20.1 0-20.4 0-4.3-.6-4-3.4-1.3-5 6.4-.7 20.6 1 19.6-3.4-.8-4-10-1.9-13.6-1-3.8.9-9.3.2-9.3.2-2.3-3.2 21.5-1.9 21.3-4.4-.3-2.8-15.1-.8-20.2-.6-3.9-2.7 19-4.5 19.3-4.8.9-7.3-15.3 0-18.4 0-3 0-1.5-4.6-1.5-4.6s6.3-2.9 6.1-3.3a22 22 0 0 0-5.2-2c-.5 0 0-5 0-5s5.2-4 4.8-5.1c-.5-1.1-6.2.9-6.2.9v-4.4s4.2-.4 4.6-2.4c.5-2-5-2.2-5-2.2l-2.2-23-2 21.5-7.2 1s5 2.9 6 5.8c.8 2.8-6.2 2-6.2 2s5.7 4.8 6.1 6.5c.5 1.8-7.9 2.2-7.9 2.2s7 5 7.5 7.9c.4 2.8 0 4.4 0 4.4s-11.6-10.1-19-7.3c-4 2 8.8 3 17.2 10.3 0 1.7-20.5-5-21.2-.8.4 1.1 21.9 4.2 23.4 7-7.8.3-24-1.7-23.4.9-1.7 3 15.2 1.3 22.3 3.7 2.1 2.4 1.9 4.4-1.7 4.6-6.9-3.3-22.1-5.7-22.2-1.5.1 1 15.8.4 21.5 4.1-7.6 1.8-33.4-3.5-33.5-1 .7 1.3 4.8 6.5 11.8 6.3 7-.2 23.3 2.8 24.4 5 1 2.2-21.1-4.6-29.4-.6-8.4 4 23.9 1.5 29.1 6.3 5.3 4.9-10.5-.4-10.5-.4s-22-3-25.2-1.5c-3.3 1.5-7 5-7 5s2.2 4.4 4.4 3.5c2.2-.9-.7 2.7-.7 2.7s30.7 7.4 37.5 14c6.8 6.6-39-10.3-39-10.3s-18.5 6.8 1 7.2c-2.2 3.3 1.2 5.3 1.2 5.3s32.4 6.8 35.7 12c3.3 5.3-22.1-5-27.9-7.9-5.7-2.8-21.9 1.8-21.7 2.9.3 1 8 2.6 8.1 4.6.3 2-9.4 2.6-9.4 4.4 0 1.7 41 10.3 52 19.5s-32.2-11-32.2-11 2.4 3.3 0 4.2c-2.5.9-11-12.3-25-4.2-2.6 3.4 12.2 6 16 6.4-1.3 3.3-2.4 4.4 2.8 7.7s-10.3-4.8-10.3-4.4l1.1 5.7c-4.8-4-10.7-5.1-16.2-1.1 0 0-.2 4 5.5 6.4-3.1 6.3 3.5 4.3 14 10.3-15.6-4.1-16.9 3.5-5.7 5.2s41.9 2.9 49.1 12.3c7.3 9.4-10.3-3.6-12.3-4-.4.3-.8 4.9-.8 4.9-4.7-2.7-9-5.2-14.6-6.3-.5.9-.3 2.1-.8 3-5-3.7-9.5-6.2-16.9-6.6l-.9 3.5s-6.1-7.7-18.2 0c-6.7 4.9 25.5 1.8 30.7 7.5 5.3 5.7 1.1 6.6 1.1 6.6l-13.1-4.9s-15.6-2.8-20 .7 64 12 66 21.5c1.4 5-16-5.4-31.1-9.9l-1.8 5s-6-6-12.7-7c-.2 0 1.3 6 1.3 6s-16.8-8-25.4-3.8c-8.5 4.2 29.8 6.4 33.3 10.3 3.5 4-11.6-2.6-13 0-1.2 2.7-19.9-4.8-19.6-1.3.2 3.5 2.6 5.5 2.6 5.5s38.8 3.7 40.1 8.3c1.3 4.6-21.5-2.6-21.5-2.6s-2.2 3.3-.4 4.8c1.7 1.6-13.2-8.7-11.8-2-4.9-1.9-17.4-7.8-15.6-3.2 1.7 4.6 35.3 11.2 35.3 11.2s-14.7 1-14 4.8c-19-11.5-18.5-4.2-18-4 .4.2-24.4-6.1-5.7 4s10 8.3 10.3 8.5c.2.2 2 5 1.5 5-.4 0-12.7-6.5-16.9-7-4.1-.4-23.9 5.5-2.8 14.8s34-2.2 45.6-1c11.6 1.4 17 3.4 16 7-1.1 3.8-11.9-12.1-23.2 1.7-13-2.6-21.7-4-15 5.4-21-7.9-34 2.4-7.4 6.6 26 .8 42-6.4 42-6.4s4.5 8.1 10.8 2.4c6.4-5.7 6.6 2.2 6.8 2.2l6.2-2.6z"
      }),
      /* @__PURE__ */ jsx181("path", {
        fill: "#fff",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.8,
        d: "M316 320.2v-3.7s-8.2-1.5-12.3-.7c-2.3-1.3-4.6-3.1-7.5-1.6-.5 1.2 5.3 4.3 7.2 4.3a41.1 41.1 0 0 0 12.7 1.7zm0 6s-8.3-3.1-11.6.4c.5 3.7 9.7 5.5 11.7 4.5 1.9-1 0-4.8-.1-5zm14 1.4v2.6s9.8 1.9 11.6-.2c1.7-2.1-8-3.5-11.7-2.4zm-.5-10.2.3 2.9s8.6 1.9 11.9-2.8c3.3-4.7-7.5 0-12.2-.1m.4-10v2s6.5 1 8-1.8c1.4-2.8-7.8 0-8-.2m-13.4-6c-1-1.3-4.5-4.8-13.8-5.8-6.5 0 11.7 9.5 13.8 5.9zm13.2-9.7-.2 2.7s22-6.6 27.1-6.1c4.6-1.3 5.6-4.5 5.4-4.5-4-2.9-22.9 2.3-32.3 7.9m.5-7.8-.3 2.6s15.5-3 19.7-6c4.1-3-19.2 3.5-19.4 3.4m-.6-7.6v2.6s10.3-.4 12.5-2.4c1.3-2.1-9.2-.3-12.5-.2m21.6 21.7s5.4.8 6.4-.8c-.2-2.8-6.4 1-6.4.8M330 266.6l.1 5.7s24.9-7.9 26.5-9.3c1.5-1.5 5-6-26.6 3.6m-.7-7.9v4.2s10-.8 14.6-4.5c4.6-3.8-14.6.4-14.6.3m-12-9.3.6 3.7-32.9-10.6c.1 0-1.6-5.4 32.3 6.9m.5-13.3c0 .4 0 3.6-.2 3.5 0 0-22.8-9.5-23.7-8.7-3-7 24 5.4 24 5.2zm11.1 6 .4 3.1s14-2.9 14.8-4.3c.8-1.4-15.2 1.2-15.2 1.1zm.3 7.4c.2.7.4 3.3.4 3.3s5.6-.5 6.5-1.8c.8-1.3-6.9-1.5-6.9-1.5m-.8-17v3s15.4-3 17-4.4c1.7-1.5-17.3 1.4-17 1.4m0-8.5c0 .2-.5 3.1-.1 3.1s18.6-3 21.5-5.7c2.8-2.5-21 2.9-21.3 2.6zm-.2-14.9v3.3s11.8-2.5 14-5c2.2-2.5-14 2-14 1.7m-2-21.6.2 4.8s16-2.2 18.2-4.8c2.3-2.7-18.5 0-18.4 0m-7.4-36.5v3s-7.5-.3-5.7-1.6 5.7-1.1 5.7-1.4m7 4 .2 4.2s9.7-1 10.4-2.5c.8-1.5-10.4-1.6-10.6-1.6zm-.6 6s.2 2.6.4 2.6 3.9-.3 4.7-1.3c.8-1-4.7-1-5-1.3zm-8.2 11.8c0 .3.3 4 0 3.8s-21.2-6.1-23.2-6c-1.9 0-2.4-4.9 23.2 2.2m1.7 6.9c0 .7.5 4.6-.3 4.4-.7-.2-14.3-4.5-12.9-5.8 1.4-1.3 13.2 1.7 13.2 1.4m-1.2 29 .1 3.5s-23.7-7.2-24.5-8.4c-.8-1.2-3.1-6.8 24.4 4.9m1 8.5v3.3l-32.2-11.3s-2.6-8.4 32.1 8z"
      }),
      /* @__PURE__ */ jsx181("path", {
        fill: "#fff",
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: 0.8,
        d: "m280.3 328.7-.2 3.5s-6.2-1.8-8.2-5.3c3.6-1 8.5 1.9 8.4 1.8z"
      })
    ]
  })
});
var Nf_default = SvgNf;

// src/country-flag-icons/generated/Ng.tsx
import { jsx as jsx182, jsxs as jsxs175 } from "react/jsx-runtime";
var SvgNg = (props) => /* @__PURE__ */ jsx182("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs175("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx182("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx182("path", {
        fill: "#008753",
        d: "M426.6 0H640v480H426.6zM0 0h213.3v480H0z"
      })
    ]
  })
});
var Ng_default = SvgNg;

// src/country-flag-icons/generated/Ni.tsx
import { jsx as jsx183, jsxs as jsxs176 } from "react/jsx-runtime";
var SvgNi = (props) => /* @__PURE__ */ jsxs176("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs176("defs", {
      children: [
        /* @__PURE__ */ jsxs176("linearGradient", {
          id: "ni_svg__f",
          x1: 498.7,
          x2: 500.6,
          y1: 289.1,
          y2: 283.4,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx183("stop", {
              offset: 0,
              stopColor: "#510000"
            }),
            /* @__PURE__ */ jsx183("stop", {
              offset: 0.3,
              stopColor: "#8a0000"
            }),
            /* @__PURE__ */ jsx183("stop", {
              offset: 1,
              stopColor: "#a00"
            })
          ]
        }),
        /* @__PURE__ */ jsxs176("linearGradient", {
          id: "ni_svg__g",
          x1: 501.4,
          x2: 502.9,
          y1: 291.4,
          y2: 287.4,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx183("stop", {
              offset: 0,
              stopColor: "#ff2a2a"
            }),
            /* @__PURE__ */ jsx183("stop", {
              offset: 1,
              stopColor: "red"
            })
          ]
        }),
        /* @__PURE__ */ jsxs176("linearGradient", {
          id: "ni_svg__b",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx183("stop", {
              offset: 0,
              stopColor: "#F5F549"
            }),
            /* @__PURE__ */ jsx183("stop", {
              offset: 1,
              stopColor: "#97C924"
            })
          ]
        }),
        /* @__PURE__ */ jsxs176("linearGradient", {
          id: "ni_svg__a",
          children: [
            /* @__PURE__ */ jsx183("stop", {
              offset: 0,
              stopColor: "#025"
            }),
            /* @__PURE__ */ jsx183("stop", {
              offset: 0.5,
              stopColor: "#04a"
            }),
            /* @__PURE__ */ jsx183("stop", {
              offset: 1,
              stopColor: "#025"
            })
          ]
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__h",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__b",
          id: "ni_svg__v",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__o",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__p",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__q",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__r",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__b",
          id: "ni_svg__u",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__x",
          x1: 98.9,
          x2: 125,
          y1: 1440.2,
          y2: 1440.2,
          gradientTransform: "scale(4.45715 .22436)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__j",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__l",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__m",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__i",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__b",
          id: "ni_svg__s",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__y",
          x1: 47.9,
          x2: 61.7,
          y1: 3054.2,
          y2: 3054.2,
          gradientTransform: "scale(9.12405 .1096)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx183("clipPath", {
          id: "ni_svg__c",
          children: /* @__PURE__ */ jsx183("path", {
            d: "m500 226.4-63.7 110.3h127.4z"
          })
        })
      ]
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#0067c6",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#c8a400",
      d: "m248 239.5 8 .5v-1.2l-3-.2.2-3.8 3.3-2.4.1-1.5-3.5 2.5c-.1-.8-.6-1.7-1.4-2-.8-.2-1.6-.2-2.3.3-.8.6-1 1.6-1 2.5zm1.2-1.1.3-4c.1-.6.2-1.4.8-1.8a1 1 0 0 1 1.5.5c.4 1 .2 2.1.1 3.2l-.1 2.2zm-.2-11.2 7.8 1.8 1.8-7.6a198 198 0 0 1-1.1-.2l-1.5 6.4-2.4-.5 1.4-5.8-1.1-.3-1.4 5.8-2-.5 1.4-6.2-1.2-.2zm2.8-10.5 7.6 2.7.4-1.1-3-1 1.2-3.5c.2-1 .4-2-.1-3a2.5 2.5 0 0 0-2-1c-1 0-1.6.7-2 1.5-.6 1-1 2.2-1.3 3.4zm1.5-.7 1.2-3.4c.3-.6.6-1.3 1.3-1.5a1 1 0 0 1 1.2.9c.2 1-.3 2-.6 3l-.7 1.9zm2.7-9 4.3 2.6c.8.4 1.8.6 2.7.2a6.5 6.5 0 0 0 2.4-3c.4-1 .8-2.2.2-3.2-.6-1-1.7-1.4-2.7-2l-2.7-1.6-.6 1 4 2.4c.7.4 1.2 1 1.1 1.9a6 6 0 0 1-1.2 2.5c-.4.6-1.2 1.1-2 1-.8-.2-1.5-.8-2.2-1.2l-2.7-1.5-.6 1zm5.8-9.3 6.3 4.8 3-3.8c.6-.9 1-2 .7-3a2.5 2.5 0 0 0-2-1.4c-.5 0-1 .3-1.2.4.2-.9-.5-1.7-1.2-1.9-1-.3-2 .3-2.6 1l-2 2.5zm1.6-.3c.7-1 1.4-2 2.2-2.8.4-.4 1-1 1.5-.6.5.2.7.9.4 1.3-.4.9-1 1.5-1.6 2.3l-.8 1.1zm2.6 2 2.3-3c.4-.4 1-1 1.6-.8.6.1 1 .7.8 1.3-.3 1-1.1 1.8-1.8 2.7l-1 1.3zm3-10.2 5.5 5.8 4.7-4.5-.8-.8-3.8 3.6h-.1l-4.7-5zm7-6.2 4.9 6.3 1-.7-5-6.3zm7.2-4.9a6.7 6.7 0 0 0-2 1.8 3.6 3.6 0 0 0-.1 4.2 4.1 4.1 0 0 0 1.6 1.5 3.6 3.6 0 0 0 2 .4 6.5 6.5 0 0 0 2.7-1 5.4 5.4 0 0 0 2-2c.4-.8.5-1.6.3-2.4l-1 .4c.2 1.6-.8 2.4-2 3-1.8 1.2-3.5 1.1-4.6-.5-1.1-1.9 0-3.4 1.6-4.4 1.1-.7 2.2-1.2 3.2-.5l.9-.8a3.2 3.2 0 0 0-2-.6c-.9 0-1.7.4-2.6 1zm9.5-4.7-.9 9 1.3-.5.2-2.8 4-1.6 2.2 1.8 1.2-.5-6.8-5.9zm1 1 2.7 2.2-3 1.2zm16.5-6 .5 8 4.3-.2c1.2-.2 2.4-.4 3.1-1.4 1-1 1.2-2.7.7-4.1a3.5 3.5 0 0 0-2.7-2.4c-1.2-.2-2.4 0-3.6 0l-2.3.2zm1.2 1.1 3.5-.1a3 3 0 0 1 1.8.5c.8.6 1.3 1.5 1.2 2.5a2.7 2.7 0 0 1-2 2.4c-.6.2-1.3.2-1.9.3l-2.2.1zm10-1.5-.5 8 7.8.4v-1.1l-6.6-.4.1-2.4 6 .3v-1.1l-5.9-.3.1-2.2 6.4.4v-1.2zm20.8 3.3-2.9 7.5 1 .4 2.4-6v-.2l.2.3 2.8 8 1.3.5 2.9-7.5-1-.4-2.3 6-.1.2-.2-.3-2.7-8zM353 176l-3.7 7-1-.5 3.6-7.1zm6 3.5a6.7 6.7 0 0 0-2.4-1 3.6 3.6 0 0 0-4 1.5 4.1 4.1 0 0 0-.6 2.1c0 .7.1 1.4.6 2.1.4.7 1 1.3 2 2a6 6 0 0 0 2.7 1 3.5 3.5 0 0 0 2.2-.7l-.8-.9c-1.4 1-2.5.3-3.6-.4-1.8-1.2-2.5-2.8-1.4-4.5 1.2-1.8 3.1-1.3 4.7-.3 1 .7 2 1.5 1.8 2.7l1 .4a3.2 3.2 0 0 0-.3-2c-.4-.8-1-1.4-1.9-2m7.6 5.7-8.3 3.4 1 .9 2.6-1 3.3 2.8-.7 2.7 1 .9 2.1-8.8zm-.3 1.4-.8 3.4-2.5-2zm6.4 4.2-6.2 5 .7 1 2.5-2 2.4 3-.7 4 .9 1.1.8-4.2c.7.5 1.7.8 2.5.4.7-.4 1.4-1 1.4-1.8 0-1.1-.7-2-1.3-2.8zm-.2 1.6 2.6 3.2c.4.6.9 1.4.4 2-.3.6-1.1.6-1.6.2-1-.7-1.6-1.7-2.4-2.6l-1-1.1zm9.5 11.1-9 .4.7 1.2 2.8-.1 2.2 3.8-1.6 2.3.7 1.2 4.9-7.6zm-.7 1.2-2 3-1.5-2.8zm5.9 9.4c-.5-1.3-1.3-2.7-2.7-3.4a3.8 3.8 0 0 0-4.5 1c-1 1-1 2.5-.7 3.9.3 1.5 1 3 2 4.1l-.6.2.4 1.1 3.8-1.3-1.5-4.1-.8.3 1 3-1.2.5a7 7 0 0 1-2.1-3.8c-.3-1.1-.3-2.4.5-3.2 1-1 2.6-1.3 3.7-.5s1.7 2.1 2 3.4c.3.9.2 1.9-.4 2.6-.2 0 0 .3.1.4l.3.5a2.8 2.8 0 0 0 1.1-2.2 7 7 0 0 0-.4-2.5m2.3 6.3-4.5.8a4.1 4.1 0 0 0-1.9.8 2.5 2.5 0 0 0-.8 1.5v2.4c.3 1 .6 1.7 1 2.3.3.6.7 1 1.2 1a4 4 0 0 0 2 0l4.5-.8-.2-1.1-4.4.8c-2 .4-2.6-.6-3-2.4-.3-1.8 0-3 1.9-3.3l4.4-.9zm2.4 13.6-8.3-3.6.1 1.4 2.6 1 .3 4.4-2.4 1.5.1 1.3 7.7-4.7zm-1.2.7-3 1.9-.2-3.2zm-136.5 20-1.2.3 1.3 4.9 1.2-.3zm131.6 0 1.2.3-1.3 4.9-1.2-.3zm-119.2 20.5-9 1 .8 1.1 2.8-.3 2.4 3.6-1.4 2.5.8 1 4.3-7.8zm-.7 1.3-1.7 3-1.8-2.6zm4.1 3.6-5.7 5.3.8.8 4.8-4.5-2.6 7 1 .9 6.8-2-4.7 4.3.8.8 5.7-5.3-1.2-1.2-7 2 2.6-6.7zm8.3 8.4-4.8 6.5 6.2 4.6.7-.9-5.3-4 1.5-2 4.7 3.7.7-1-4.7-3.5 1.3-1.7 5 3.8.7-1zm7.8 5.8-3.7 7 1 .6 1.5-2.8 3.4 1.8.8 4 1.3.7-.9-4.2c.9.3 2 .1 2.5-.6.5-.6.9-1.3.6-2.1-.2-1-1.3-1.6-2.1-2.1zm.5 1.5 3.6 2c.6.4 1.3.9 1.2 1.6 0 .7-.7 1-1.3.9-1.2-.2-2.2-.9-3.2-1.4l-1.5-.8zm8.6 3.2-3 7.4 1 .5 3-7.4zm7.2 2.5a6.7 6.7 0 0 0-2.6-.4 3.6 3.6 0 0 0-3.4 2.6 4.1 4.1 0 0 0 0 2.1c0 .8.4 1.4 1 2a6 6 0 0 0 2.4 1.3 5.4 5.4 0 0 0 2.9.2 3.4 3.4 0 0 0 2-1.2l-1-.6c-1 1.3-2.3 1-3.6.5-2-.7-3.1-2-2.5-4 .7-2 2.7-2 4.4-1.5 1.2.4 2.3 1 2.4 2.1l1.2.2a3.2 3.2 0 0 0-.9-2 5.4 5.4 0 0 0-2.3-1.3m8 1.8-5.2 7.3 1.3.2 1.6-2.3 4.4.7.9 2.6 1.3.2-3-8.5zm.5 1.3 1.2 3.4-3.2-.5zm18.3-1.2c-1 .1-1.7.4-2.4.9a3.6 3.6 0 0 0-1.7 3.9c.1.7.4 1.3 1 2 .4.5 1 .8 1.8 1 .7.2 1.7.2 2.8 0 1-.2 2-.6 2.6-1.2a3.4 3.4 0 0 0 1.1-2h-1.2c-.3 1.6-1.5 2-2.8 2.2-2.1.4-3.7-.3-4.1-2.3-.4-2.1 1.3-3.1 3-3.5 1.3-.2 2.5-.3 3.2.7l1-.4a3.2 3.2 0 0 0-1.6-1.3 5.4 5.4 0 0 0-2.7 0m5.3-1 2.3 7.7 7.5-2.2-.4-1.1-6.3 1.9-.7-2.4 5.7-1.7-.3-1-5.7 1.6-.6-2 6-1.8-.3-1.1zm8.7-2.7 3.3 7.3 1-.5-2.8-6 7.8 3.5h.5l1-.5-3.4-7.3-1 .5 2.8 6-8-3.6zm8.8-4.1.6 1 2.8-2h.2l3.7 5.7 1-.7-3.7-5.6v-.1l2.9-2-.6-.9zm8-5.6 5.4 6 .9-.9-2.1-2.3 2.8-2.6 4 .6 1.2-1-4.3-.6c.5-.7.7-1.8.2-2.6-.4-.7-1-1.3-1.9-1.2-1 0-2 .8-2.7 1.4zm1.6.1 3-2.8c.6-.4 1.4-.9 2-.5.7.3.7 1.1.3 1.6-.6 1-1.5 1.7-2.4 2.6l-1.1 1-1.8-2zm7.7-9.4 3.6 8.3.8-1-1-2.6 2.7-3.4 2.7.6.9-1-8.8-2zm1.4.3 3.5.7-2 2.5zm2.1-4.8 6.7 4.3 3.5-5.4-1-.6-2.7 4.3-.1.2h-.1l-5.7-3.8z"
    }),
    /* @__PURE__ */ jsxs176("g", {
      clipPath: "url(#ni_svg__c)",
      transform: "matrix(.8 0 0 .8 -80 0)",
      children: [
        /* @__PURE__ */ jsx183("path", {
          fill: "#fff",
          d: "m500 226.4-31.5 54.5-15.4 26.7h93.8l-14.7-25.4z"
        }),
        /* @__PURE__ */ jsxs176("g", {
          id: "ni_svg__e",
          children: [
            /* @__PURE__ */ jsxs176("g", {
              id: "ni_svg__d",
              children: [
                /* @__PURE__ */ jsx183("path", {
                  fill: "#17c0eb",
                  stroke: "#17c0eb",
                  strokeWidth: 0.1,
                  d: "m500 226.4-2.4 4 2.4 55 2.4-55z",
                  opacity: 0.6
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#fff",
                  d: "M500 277.5h-.1l.1 3 .1-3z"
                })
              ]
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(72 500 285.5)"
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(144 500 285.5)"
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(-144 500 285.5)"
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(-72 500 285.5)"
            })
          ]
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(8 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(16 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(24 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(32 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(40 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(48 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(56 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(64 500 285.5)"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "red",
          d: "M500 265.8a44.2 44.2 0 0 0-29 10.8L456.4 302a45 45 0 0 0-.8 8.3h5a39.4 39.4 0 0 1 78.7 0h5a45 45 0 0 0-.7-8.3L529 276.6a44.3 44.3 0 0 0-29-10.8"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#f60",
          d: "M500 266.7a43.5 43.5 0 0 0-30.3 12.2l-12 20.9a43.6 43.6 0 0 0-1.3 10.4h4.3a39.4 39.4 0 0 1 78.6 0h4.3a43.9 43.9 0 0 0-1.3-10.5l-12-20.8a43.5 43.5 0 0 0-30.3-12.2"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#ff0",
          d: "M500 267.5a42.7 42.7 0 0 0-32 14.3l-8.7 15a42.7 42.7 0 0 0-2 13.5h3.3a39.4 39.4 0 0 1 78.7 0h3.5c0-4.7-.8-9.2-2.1-13.4l-8.8-15.1a42.6 42.6 0 0 0-31.9-14.3"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#0f0",
          d: "M500 268.3a42 42 0 0 0-34.9 18.6l-2.8 4.9a41.8 41.8 0 0 0-4.3 18.5h2.7a39.4 39.4 0 0 1 78.6 0h2.7a41.8 41.8 0 0 0-4.3-18.5l-2.8-5a42 42 0 0 0-34.9-18.6z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#0cf",
          d: "M500 269a41.2 41.2 0 0 0-41.2 41.3h1.9a39.4 39.4 0 0 1 78.6 0h1.9A41.2 41.2 0 0 0 500 269"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#00f",
          d: "M500 269.8a40.4 40.4 0 0 0-40.4 40.4h1.4a39 39 0 1 1 78 0h1.4A40.4 40.4 0 0 0 500 270z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "purple",
          d: "M500 270.7a39.6 39.6 0 0 0-39.6 40.3h.8v-.8a38.8 38.8 0 1 1 77.6.8h.8v-.8a39.6 39.6 0 0 0-39.6-39.6z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#510000",
          d: "M500.4 288.1c-.7 0-1.2-.5-1.8-.6a2.2 2.2 0 0 0-.7 2.1c.3.1.3.4.9.9s.5.7.4 2c0 .4.1 1.5.6 1.6.5.1 1-.3 1.1-1.2.1-.7.4-1.2.7-1.6.3-1.9-.2-2.6-1.2-3.2"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "red",
          d: "M497.2 283.5c-.6 0-1.6 1-2 .5-.2-.3-.3-.9 0-1.4a4.8 4.8 0 0 1 2.2-2.3c2.3-1.4 3.9-1 5 1 1.1 1.8 2.2 3.8 2.3 5.4 0 .5.3 1.4-.2 1.9-1.3 1.4-4.6-1.5-6.5-1-.6.1-1.4.6-2 .2-.4-.3 0-1 .3-1.3.6-.5 1.5-2.4 1.4-3.2 0-.4 0 .2-.5.2"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "url(#ni_svg__f)",
          d: "M497 282.6c-1.2.4-1 1-1.6 1.5.2.1.8.3 1.4-.3.2-.2.5-.3.7-.3l-.7.7a5.2 5.2 0 0 0-1.4 1.8c-.3.8-.4 1.7-.3 1.8 0 0 .4.8 1.5 1.2 2 .8 2.4 2.5 4.5 2.5 1.6 0 1.4-1.1 2.7-.9 1 .2 1.7-.7.6-1.2a14 14 0 0 0-5.4 0c-.4-4 0-2.6-.1-4.4-.1-1.7-.7-1.8 0-3.3-.5 1-1.2.8-2 .8z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#ff2a2a",
          d: "m501 279.8-.1.6.3 1 .2 1c0 .3.4.4.7.6.4.3 0 1 .3 1.1.2 0 .5-1 .5-1.2v-.7a15.3 15.3 0 0 0-.5-.9 3.6 3.6 0 0 0-.2-.3 4.2 4.2 0 0 0-.8-.9 4 4 0 0 0-.3-.2l-.2-.1z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "url(#ni_svg__g)",
          d: "m501.3 287.4-2-.7c-1.3-.4-2.6-1.2-3.5-.8-.3.1-.3.4-.4.9 0 .5-.5 1.3 0 1 .6-.4 2.4.8 3 1.1.3.2 1 .6 1.1 1 .2.6 0 1.8 0 2.4 0 .5.2 1.8.7 2 .6.1 1.1-.4 1.3-1.3.3-.9.4-1.4.8-1.9s.8-.8 1.3-.9c.6 0 1.4.5 1.4-.2 0-.4-.4-.8-.2-1.4.1-.5-.4-.4-.9-.6z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#910000",
          d: "M498.4 288.9c-.4-.2-2.3-1.5-3-1-.3 0-.4 0-.4-.3l.2-.9c0-.3.2-.8.5-1 .7-.6 2.3.5 3.1.8z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#ff3a3a",
          d: "M501.8 291.4c.9-1.6 1.5-1.4 2.6-1.4.4 0 .5-.3.4-.7-.3.6-1.7 0-2.5.3-1.5.7-1.2 3.7-2 4 .8.7 1.1-1.7 1.5-2.2"
        }),
        /* @__PURE__ */ jsxs176("g", {
          fill: "url(#ni_svg__h)",
          children: [
            /* @__PURE__ */ jsx183("path", {
              fill: "#fff",
              d: "m453.1 307.6-10 17.3H557l-10-17.2h-93.8z"
            }),
            /* @__PURE__ */ jsxs176("g", {
              id: "ni_svg__n",
              fill: "url(#ni_svg__i)",
              children: [
                /* @__PURE__ */ jsx183("path", {
                  id: "ni_svg__k",
                  fill: "url(#ni_svg__j)",
                  d: "M449.7 321.4a36 36 0 0 0-4.7.3l-.5.9c2.4-.3 4.7-.7 7.2-.7 3.2 0 6.2.8 9.7.8h4.6c3.5 0 6.4-.8 9.7-.8 3.3 0 6.3.8 9.8.8h4.6c3.5 0 6.4-.8 9.7-.8 3.3 0 6.3.8 9.8.8h4.5c3.5 0 6.5-.8 9.8-.8 3.3 0 6.3.8 9.8.8h4.5c3.5 0 6.5-.8 9.8-.8 2.6 0 5 .5 7.5.7l-.5-1a38 38 0 0 0-4.4-.2h-4.5c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8H522c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8H498c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8h-4.5c-3.5 0-6.5.7-9.8.8-3.3 0-6.2-.8-9.7-.8z"
                }),
                /* @__PURE__ */ jsx183("use", {
                  xlinkHref: "#ni_svg__k",
                  width: "100%",
                  height: "100%",
                  y: -1.1,
                  fill: "url(#ni_svg__l)"
                }),
                /* @__PURE__ */ jsx183("use", {
                  xlinkHref: "#ni_svg__k",
                  width: "100%",
                  height: "100%",
                  y: -2.2,
                  fill: "url(#ni_svg__m)"
                })
              ]
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__n",
              width: "100%",
              height: "100%",
              y: -3.3,
              fill: "url(#ni_svg__o)"
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__n",
              width: "100%",
              height: "100%",
              y: -6.7,
              fill: "url(#ni_svg__p)"
            }),
            /* @__PURE__ */ jsx183("path", {
              fill: "url(#ni_svg__q)",
              d: "M453.2 307.5v.2h93.7l-.1-.2zm-.2.3-.1.3H547l-.1-.3h-94zm-.2.4-.2.3h94.8l-.2-.3zm-.3.5-.3.5h95.6l-.3-.5zm-.4.7-.3.5h96.4l-.3-.5zm-.4.7-.2.4h97l-.2-.4zm-.4.7-.2.4H549l-.3-.4zm-.4.7-.3.6h98.8l-.3-.6H451z"
            }),
            /* @__PURE__ */ jsx183("path", {
              fill: "url(#ni_svg__r)",
              d: "M457.4 312.3c3.4.7 3.7 0 3.7 0zm81.5 0s.3.7 3.7 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs176("g", {
          fill: "#ccd11e",
          children: [
            /* @__PURE__ */ jsxs176("g", {
              id: "ni_svg__t",
              children: [
                /* @__PURE__ */ jsx183("path", {
                  fill: "url(#ni_svg__s)",
                  d: "M530.6 297c-1.7 0-2.2.9-2.2.9-2.7 10.6-11.8 21.3-22.6 21.3h-8V330h61.4l-6.2-11c-9.7-1.4-17.6-11.3-20.1-21.1 0 0-.6-.9-2.3-.9"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#97c924",
                  d: "M530.6 297.5c-.8 0-1.2.1-1.5.3l-.3.3a33.6 33.6 0 0 1-8.4 14.7c-4 4.1-9 6.9-14.6 6.9h-7.7v9.9H559l-5.7-10c-4.7-.7-9-3.2-12.4-6.8a33.6 33.6 0 0 1-8.4-14.7l-.3-.3a2.8 2.8 0 0 0-1.6-.3"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#ede71f",
                  d: "M530.6 297.5h.4v10.8a13 13 0 0 1-2 6.4c-.5 1.6-1 1-2.3 2.9a25.4 25.4 0 0 1-5.2 1.2c-2.5.4-8 .8-10.9.1a23 23 0 0 0 9.8-6 30.6 30.6 0 0 0 2.1-2.5 33.7 33.7 0 0 0 3-4.4l1-2a33.9 33.9 0 0 0 1.3-2.9 29.8 29.8 0 0 0 1-3l.3-.3.6-.2z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#c6cb24",
                  d: "M530 298.9c-.5 6-2.3 13.2-6.7 17.8-1.6 1.3-3.7 2.6-5.6 2.3 6.7-5.5 10.8-14 12.2-20.1z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#9ecb34",
                  d: "M524.5 309.3c-1 2.7-4.8 6.7-8.8 10h-2.9c2.5-.2 8.3-5 11.7-10"
                })
              ]
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__t",
              width: "100%",
              height: "100%",
              x: -15.3
            }),
            /* @__PURE__ */ jsxs176("g", {
              fill: "#c6cb24",
              children: [
                /* @__PURE__ */ jsx183("path", {
                  fill: "url(#ni_svg__u)",
                  d: "M502.2 298c2.8 10.5 11.8 21.2 22.6 21.2h8.1V330h-65.8v-10.8h8c10.8 0 19.9-10.7 22.6-21.3 0 0 .6-.8 2.3-.8 1.7 0 2.2.8 2.2.8z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#97c924",
                  d: "M500 297.5c.8 0 1.2.2 1.5.3l.3.3a33.6 33.6 0 0 0 8.4 14.7c4 4.1 9 6.9 14.6 6.9h7.7v9.9h-65v-10h7.7c5.5 0 10.6-2.7 14.6-6.8a33.6 33.6 0 0 0 8.3-14.7l.3-.3a3 3 0 0 1 1.6-.3"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#ede71f",
                  d: "M499.3 297.5a3.4 3.4 0 0 0-.3 0l-.6.3-.3.3a28.9 28.9 0 0 1-1 3 34.2 34.2 0 0 1-1.2 3 34.2 34.2 0 0 1-1 1.9 33.6 33.6 0 0 1-3 4.4 30.7 30.7 0 0 1-2.1 2.4 23 23 0 0 1-9.8 6.1c2.8.7 4 0 6.5-.4 2-.3 4.2-.6 6-1.2 1.5-2 1-1.3 1.5-2.9 1.2-2.2 3-4.2 3.4-6.7 1.6-3 1.9-8.6 1.9-10.2"
                }),
                /* @__PURE__ */ jsx183("path", {
                  d: "M499.3 298.9c-.4 6-2.3 13.2-6.7 17.8-1.6 1.3-3.6 2.6-5.6 2.3 6.8-5.5 10.9-14 12.3-20.1"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#9ecb34",
                  d: "M493.8 309.3a31 31 0 0 1-8.8 10h-2.8c2.5-.2 8.2-5 11.6-10"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#ede71f",
                  d: "m501 297.6.5.2.4.3a32.3 32.3 0 0 0 1 3 33.6 33.6 0 0 0 1.2 3l1 1.9a33.6 33.6 0 0 0 3 4.4 30.7 30.7 0 0 0 2.1 2.4 24 24 0 0 0 9.8 6.5c-7.3 0-10.4-.6-13-4a19 19 0 0 1-4.2-7c-.5-2-2-6.5-1.9-10.7z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  d: "M501.5 298.9c.4 6 2.2 12 6.6 16.6 1.6 1.4 3.6 2.6 5.6 2.3a31.1 31.1 0 0 1-12.2-18.9"
                })
              ]
            }),
            /* @__PURE__ */ jsxs176("g", {
              id: "ni_svg__w",
              children: [
                /* @__PURE__ */ jsx183("path", {
                  fill: "url(#ni_svg__v)",
                  d: "M484.8 297c-1.8 0-2.3.9-2.3.9-2.5 9.8-11.8 22.3-21.5 23.8l-4.8 8.3h49v-11.3c-8.8-2.4-15.9-11.7-18.2-20.8 0 0-.5-.8-2.3-.8z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#97c924",
                  d: "M484.8 297.5c-.8 0-1.3.2-1.6.3l-.3.3a43.4 43.4 0 0 1-8.1 15c-3.4 4.3-9.7 8.6-14 9l-4.3 7.5h48v-10.7a23.2 23.2 0 0 1-9.5-6 33.6 33.6 0 0 1-8.4-14.8l-.3-.3a2.9 2.9 0 0 0-1.5-.3"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#93bc30",
                  d: "M483.4 298.9c-.6 9-5.6 20.5-11.3 22.4-1.9.7-5.1.9-6.2 1a36 36 0 0 0 17.6-23.4z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#ede71f",
                  d: "M484.8 297.5h-.5v10.8c0 2.3.9 4.2 2 6.4l.2.5c.5 1.1.8 1.5 2.3 2.7a22 22 0 0 0 14.8 4c-1.1-.9-2.3-1.7-3.4-2.4l4.5-.5a23 23 0 0 1-9.7-6.2 30.5 30.5 0 0 1-1.4-1.5l-.6-.8a35 35 0 0 1-3.2-4.5 34.2 34.2 0 0 1-1-2 34 34 0 0 1-1.6-3.9 31.7 31.7 0 0 1-.6-2l-.3-.3a2.2 2.2 0 0 0-.6-.2 3.6 3.6 0 0 0-1-.1z"
                }),
                /* @__PURE__ */ jsx183("path", {
                  d: "M485.4 298.9c.5 6 2.3 13.2 6.7 17.8 1.6 1.3 3.6 2.6 5.6 2.3a38.5 38.5 0 0 1-12.3-20.1"
                }),
                /* @__PURE__ */ jsx183("path", {
                  fill: "#9ecb34",
                  d: "M489.6 307.3a35 35 0 0 0 14.6 14.9h2.5c-4.4-2.4-11.5-5.8-17-15z"
                })
              ]
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__w",
              width: "100%",
              height: "100%",
              x: -15.4,
              fill: "#c6cb24"
            })
          ]
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#fff",
          d: "M556.5 324.7c-.6.2-4.4-.2-6.4 0l-1.3.3h-3.3c-3.6 0-6.7 1-10.1 1-3.4 0-6.5-1-10-1H522c-3.6 0-6.7 1-10.1 1-3.4 0-6.5-1-10-1h-3.4c-3.6 0-6.7 1-10 1-3.5 0-6.5-1-10.1-1H475c-3.6 0-6.6 1-10 1-3.5 0-6.5-1-10.1-1h-3.4c-2.8 0-6.2.6-8.9.8l-6.3 10.9h127.4z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "url(#ni_svg__x)",
          d: "M548 323.1h-.6c-3.2.1-5.6 1.1-11.2 1.1s-6.2-1-12.6-.8c-6 0-8.4 1.2-11.7 1.2-3.2 0-8.4-.7-12.5-.3-4 .4-8.8 1.3-12 1.3-3.9 0-7.8-.7-11.8-.3-4.1.4-6 1.5-11.1 1.5-4.4 0-9-.7-12.8-.7-3.4 0-7.2 1-10 1.4l-.9 1.5c2.3-.3 8.6-1.3 10.8-1.3 2.4 0 10.7.5 15.3.3 4.7-.1 5.2-1.2 10.7-1.2 3.8 0 6.6.4 10.5.4 2.5 0 4.7-1.2 8.4-1.2l2.8-.1c3.1-.5 8.4 0 12 .2 3.3.2 5.5-.6 9-.7l4.4-.1c3.5-.2 6.4.6 9.7.6 3.2-.2 6.4-1 9.8-1l4.5-.2c2.3 0 5.9 0 8.3.5l-.8-1.4c-2.4-.1-5.3-.7-8.2-.7"
        }),
        /* @__PURE__ */ jsxs176("g", {
          id: "ni_svg__A",
          children: [
            /* @__PURE__ */ jsx183("path", {
              id: "ni_svg__z",
              fill: "url(#ni_svg__y)",
              d: "M450.3 334.8c-3.4 0-6.4.8-9.6.9a31.8 31.8 0 0 1-3.6-.3l-.5.8h6c3.5 0 6.4-.8 9.6-.9 3.3.1 6.2 1 9.7 1h4.5c3.4 0 6.4-.9 9.6-1 3.3.1 6.3 1 9.7 1h4.5c3.5 0 6.4-.9 9.7-1 3.2.1 6.1 1 9.6 1h4.5c3.4 0 6.4-.9 9.7-1 3.2.1 6.2 1 9.6 1h4.5c3.5 0 6.4-.9 9.6-1 3.3.1 6.2 1 9.7 1h4.5l1.8-.1-.5-.8c-1 .1-2.1.3-3.2.3-3.3 0-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.5 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5z"
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__z",
              width: "100%",
              height: "100%",
              y: -1.3
            }),
            /* @__PURE__ */ jsx183("use", {
              xlinkHref: "#ni_svg__z",
              width: "100%",
              height: "100%",
              y: -2.6
            })
          ]
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__A",
          width: "100%",
          height: "100%",
          y: -3.9
        }),
        /* @__PURE__ */ jsx183("use", {
          xlinkHref: "#ni_svg__A",
          width: "100%",
          height: "100%",
          y: -7.7
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#97c924",
          d: "m443.9 324.7-2.5 4.2c2.9-.5 7.1-1.7 10.7-1.7 3.6 0 8 .9 12.4 1 5 0 7-1.2 11-1.6 4.1-.4 8 .5 12 .6 3.1 0 7.9-1.1 12-1.5 4-.5 7.7.3 12.5.3 4.9.1 5.7-1.2 11.6-1.3 6.4-.1 7 .9 12.6.9 4.2.2 7.9-.9 11.7-1.1 3.8-.3 5.5 0 8.3 0l-1.9-3.2-101.3 2.3z"
        }),
        /* @__PURE__ */ jsx183("path", {
          fill: "#fff",
          d: "m550 324.6 4 .3a91.4 91.4 0 0 0 2.9.3l-.4-.5c-.6.2-4.4-.2-6.4 0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#c8a400",
      d: "m320 179.9-25.7 44.5L268 270h104l-25.7-44.6zm0 2.4 25.2 43.7 24.7 42.8h-99.8l25.2-43.8z"
    })
  ]
});
var Ni_default = SvgNi;

// src/country-flag-icons/generated/Nl.tsx
import { jsx as jsx184, jsxs as jsxs177 } from "react/jsx-runtime";
var SvgNl = (props) => /* @__PURE__ */ jsxs177("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx184("path", {
      fill: "#ae1c28",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx184("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx184("path", {
      fill: "#21468b",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Nl_default = SvgNl;

// src/country-flag-icons/generated/No.tsx
import { jsx as jsx185, jsxs as jsxs178 } from "react/jsx-runtime";
var SvgNo = (props) => /* @__PURE__ */ jsxs178("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx185("path", {
      fill: "#ed2939",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx185("path", {
      fill: "#fff",
      d: "M180 0h120v480H180z"
    }),
    /* @__PURE__ */ jsx185("path", {
      fill: "#fff",
      d: "M0 180h640v120H0z"
    }),
    /* @__PURE__ */ jsx185("path", {
      fill: "#002664",
      d: "M210 0h60v480h-60z"
    }),
    /* @__PURE__ */ jsx185("path", {
      fill: "#002664",
      d: "M0 210h640v60H0z"
    })
  ]
});
var No_default = SvgNo;

// src/country-flag-icons/generated/Np.tsx
import { jsx as jsx186, jsxs as jsxs179 } from "react/jsx-runtime";
var SvgNp = (props) => /* @__PURE__ */ jsxs179("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx186("defs", {
      children: /* @__PURE__ */ jsx186("clipPath", {
        id: "np_svg__a",
        children: /* @__PURE__ */ jsx186("path", {
          fillOpacity: 0.7,
          d: "M0-16h512v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsx186("g", {
      clipPath: "url(#np_svg__a)",
      transform: "translate(0 15) scale(.9375)",
      children: /* @__PURE__ */ jsxs179("g", {
        fillRule: "evenodd",
        children: [
          /* @__PURE__ */ jsx186("path", {
            fill: "#ce0000",
            stroke: "#000063",
            strokeWidth: 13.8,
            d: "M6.5 489.5h378.8L137.4 238.1l257.3.3L6.6-9.5v499z"
          }),
          /* @__PURE__ */ jsx186("path", {
            fill: "#fff",
            d: "m180.7 355.8-27 9 21.2 19.8-28.5-1.8 11.7 26.2-25.5-12.3.5 28.6-18.8-20.9-10.7 26.6-9.2-26.3-20.3 20.6 1.8-27.7L49 409l12.6-25-29.3.6 21.5-18.3-27.3-10.5 27-9L32.2 327l28.4 1.8L49 302.6l25.6 12.3-.5-28.6 18.8 20.9 10.7-26.6 9.1 26.3 20.4-20.6-1.9 27.7 27-11.4-12.7 25 29.4-.6-21.5 18.3zm-32.4-184.7-11.3 8.4 5.6 4.6a93.8 93.8 0 0 0 30.7-36c1.8 21.3-17.7 69-68.7 69.5a70.6 70.6 0 0 1-71.5-70.3c10 18.2 16.2 27 32 36.5l4.7-4.4-10.6-8.9 13.7-3.6-7.4-12.4 14.4 1-1.8-14.4 12.6 7.4 4-13.5 9 10.8 8.5-10.3 4.6 14 11.8-8.2-1.5 14.3 14.2-1.7-6.7 13.2z"
          })
        ]
      })
    })
  ]
});
var Np_default = SvgNp;

// src/country-flag-icons/generated/Nr.tsx
import { jsx as jsx187, jsxs as jsxs180 } from "react/jsx-runtime";
var SvgNr = (props) => /* @__PURE__ */ jsxs180("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx187("defs", {
      children: /* @__PURE__ */ jsx187("clipPath", {
        id: "nr_svg__a",
        children: /* @__PURE__ */ jsx187("path", {
          fillOpacity: 0.7,
          d: "M-54.7 0H628v512H-54.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs180("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#nr_svg__a)",
      transform: "translate(51.3) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx187("path", {
          fill: "#002170",
          d: "M-140 0H884v512H-140z"
        }),
        /* @__PURE__ */ jsx187("path", {
          fill: "#ffb20d",
          d: "M-140 234.1H884V278H-140z"
        }),
        /* @__PURE__ */ jsx187("path", {
          fill: "#fff",
          d: "m161.8 438-33-33-10.5 45.4-12-45-31.9 34 12.1-45L42 407.9l33-33-45.4-10.6 45-12-34-31.8 45 12L72 288l33 33 10.6-45.4 12 45 31.8-34-12 45 44.5-13.5-33 33 45.4 10.5-45 12 34 32-45-12.2z"
        })
      ]
    })
  ]
});
var Nr_default = SvgNr;

// src/country-flag-icons/generated/Nu.tsx
import { jsx as jsx188, jsxs as jsxs181 } from "react/jsx-runtime";
var SvgNu = (props) => /* @__PURE__ */ jsxs181("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx188("path", {
      fill: "#fedd00",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx188("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx188("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx188("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx188("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx188("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsx188("circle", {
      cx: 160,
      cy: 120,
      r: 40.8,
      fill: "#012169"
    }),
    /* @__PURE__ */ jsx188("path", {
      fill: "#fedd00",
      d: "m160 79.2 24 73.8-62.8-45.6h77.6L136 153M66.7 98.3l14 43.4L43.9 115h45.7l-37 26.8m200.7-43.5 14.1 43.4-36.9-26.8h45.7l-37 26.8M160 178.3l14.1 43.4-37-26.8h45.7l-37 26.8M160 18.3l14.1 43.4-37-26.8h45.7l-37 26.8"
    })
  ]
});
var Nu_default = SvgNu;

// src/country-flag-icons/generated/Nz.tsx
import { jsx as jsx189, jsxs as jsxs182 } from "react/jsx-runtime";
var SvgNz = (props) => /* @__PURE__ */ jsxs182("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx189("defs", {
      children: /* @__PURE__ */ jsxs182("g", {
        id: "nz_svg__b",
        children: [
          /* @__PURE__ */ jsxs182("g", {
            id: "nz_svg__a",
            children: [
              /* @__PURE__ */ jsx189("path", {
                d: "M0-.3v.5l1-.5z"
              }),
              /* @__PURE__ */ jsx189("path", {
                d: "M.2.3 0-.1l1-.2z"
              })
            ]
          }),
          /* @__PURE__ */ jsx189("use", {
            xlinkHref: "#nz_svg__a",
            transform: "scale(-1 1)"
          }),
          /* @__PURE__ */ jsx189("use", {
            xlinkHref: "#nz_svg__a",
            transform: "rotate(72 0 0)"
          }),
          /* @__PURE__ */ jsx189("use", {
            xlinkHref: "#nz_svg__a",
            transform: "rotate(-72 0 0)"
          }),
          /* @__PURE__ */ jsx189("use", {
            xlinkHref: "#nz_svg__a",
            transform: "scale(-1 1) rotate(72)"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#00247d",
      fillRule: "evenodd",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsxs182("g", {
      transform: "translate(-111 36.1) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "matrix(45.4 0 0 45.4 900 120)"
        }),
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "matrix(30 0 0 30 900 120)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs182("g", {
      transform: "rotate(82 525.2 114.6) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "rotate(-82 519 -457.7) scale(40.4)"
        }),
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "rotate(-82 519 -457.7) scale(25)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs182("g", {
      transform: "rotate(82 525.2 114.6) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "rotate(-82 668.6 -327.7) scale(45.4)"
        }),
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "rotate(-82 668.6 -327.7) scale(30)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs182("g", {
      transform: "translate(-111 36.1) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "matrix(50.4 0 0 50.4 900 480)"
        }),
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "matrix(35 0 0 35 900 480)"
        })
      ]
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Nz_default = SvgNz;

// src/country-flag-icons/generated/Om.tsx
import { jsx as jsx190, jsxs as jsxs183 } from "react/jsx-runtime";
var SvgOm = (props) => /* @__PURE__ */ jsxs183("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx190("defs", {
      children: /* @__PURE__ */ jsx190("clipPath", {
        id: "om_svg__a",
        children: /* @__PURE__ */ jsx190("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs183("g", {
      clipPath: "url(#om_svg__a)",
      children: [
        /* @__PURE__ */ jsx190("path", {
          fill: "#ef2d29",
          fillRule: "evenodd",
          d: "M-3.3-21.6H699v553H-3.3z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#009025",
          fillRule: "evenodd",
          d: "M174.6 317.3h535.7V525H174.6z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M174.6-35.4h564.9v190h-565z"
        }),
        /* @__PURE__ */ jsxs183("g", {
          stroke: "#ef2d28",
          children: [
            /* @__PURE__ */ jsxs183("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 111.3 -13.4)",
              children: [
                /* @__PURE__ */ jsx190("rect", {
                  width: 138.2,
                  height: 85,
                  x: 17.7,
                  y: 467.7,
                  strokeWidth: 1.4,
                  rx: 11.3,
                  ry: 11.8
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 131.1,
                  height: 78,
                  x: 21.3,
                  y: 471.3,
                  strokeWidth: 1.3,
                  rx: 10.7,
                  ry: 10.9
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m65 396 9.7.5.4 5.8 8 5.3 6.2-6.7 7.5 5.3-7 5.8 1.7 8 8.8-.5V430l-7-.4-3.6 6.6 8 7.5-6.2 6.2-6.7-6.6-9.7 2.6.5 9.7-10.6 1-1.4-9.4-8.8-4.8-4.9 6.6-7.5-4.9 4.4-7.5-5.3-4.8H34l-.4-13.7 7.5.9 5.3-8-6.2-6.2 8-7 5.7 5.7 9.7-1.8z",
                  transform: "matrix(.68108 0 0 .5852 38 260.7)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 68.9,
                  cy: 426.8,
                  strokeWidth: 1.3,
                  rx: 11.1,
                  ry: 9.9,
                  transform: "matrix(.65819 0 0 .70224 38.8 209.6)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m39 474.8-10.7 10.6m17.8-10.6-10.7 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6L78 485.4m17.7-10.6L85 485.4m17.8-10.6L92 485.4m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m-17.7-10.6L78 485.4m46-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m0-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.7 10.6M85 474.8l10.6 10.6m-17.8-10.6 10.7 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6M85 474.8l10.6 10.6m-46-10.6 10.5 10.6m-17.7-10.6 10.7 10.6m-17.8-10.6L46 485.4m-17.8-10.6L39 485.4m0 49.6-10.6 10.7M46 535l-10.7 10.7M53.2 535l-10.7 10.7M60.2 535l-10.6 10.7M67.3 535l-10.6 10.7M74.4 535l-10.6 10.7M81.5 535 71 545.7M88.6 535 78 545.7M95.7 535 85 545.7m17.7-10.7L92 545.7m18-10.7-10.7 10.7M117 535l-10.6 10.7M88.6 535 78 545.7m46-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m0-10.7 10.6 10.7M127.6 535l10.6 10.7M120.5 535l10.6 10.7M113.4 535l10.6 10.7M106.3 535l10.6 10.7M99.2 535l10.7 10.7M92 535l10.7 10.7M85 535l10.6 10.7M78 535l10.6 10.7M70.9 535l10.6 10.7M63.8 535l10.6 10.7M56.7 535l10.6 10.7M85.1 535l10.6 10.7m-46-10.7 10.5 10.7M42.5 535l10.7 10.7M35.4 535l10.7 10.7M28.4 535 39 545.7"
                })
              ]
            }),
            /* @__PURE__ */ jsxs183("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)",
              children: [
                /* @__PURE__ */ jsx190("rect", {
                  width: 138.2,
                  height: 85,
                  x: 17.7,
                  y: 467.7,
                  strokeWidth: 1.4,
                  rx: 11.3,
                  ry: 11.8
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 131.1,
                  height: 78,
                  x: 21.3,
                  y: 471.3,
                  strokeWidth: 1.3,
                  rx: 10.7,
                  ry: 10.9
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m65 396 9.7.5.4 5.8 8 5.3 6.2-6.7 7.5 5.3-7 5.8 1.7 8 8.8-.5V430l-7-.4-3.6 6.6 8 7.5-6.2 6.2-6.7-6.6-9.7 2.6.5 9.7-10.6 1-1.4-9.4-8.8-4.8-4.9 6.6-7.5-4.9 4.4-7.5-5.3-4.8H34l-.4-13.7 7.5.9 5.3-8-6.2-6.2 8-7 5.7 5.7 9.7-1.8z",
                  transform: "matrix(.68108 0 0 .5852 38 260.7)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 68.9,
                  cy: 426.8,
                  strokeWidth: 1.3,
                  rx: 11.1,
                  ry: 9.9,
                  transform: "matrix(.65819 0 0 .70224 38.8 209.6)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m39 474.8-10.7 10.6m17.8-10.6-10.7 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6L78 485.4m17.7-10.6L85 485.4m17.8-10.6L92 485.4m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m-17.7-10.6L78 485.4m46-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m0-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.7 10.6M85 474.8l10.6 10.6m-17.8-10.6 10.7 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6M85 474.8l10.6 10.6m-46-10.6 10.5 10.6m-17.7-10.6 10.7 10.6m-17.8-10.6L46 485.4m-17.8-10.6L39 485.4m0 49.6-10.6 10.7M46 535l-10.7 10.7M53.2 535l-10.7 10.7M60.2 535l-10.6 10.7M67.3 535l-10.6 10.7M74.4 535l-10.6 10.7M81.5 535 71 545.7M88.6 535 78 545.7M95.7 535 85 545.7m17.7-10.7L92 545.7m18-10.7-10.7 10.7M117 535l-10.6 10.7M88.6 535 78 545.7m46-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m0-10.7 10.6 10.7M127.6 535l10.6 10.7M120.5 535l10.6 10.7M113.4 535l10.6 10.7M106.3 535l10.6 10.7M99.2 535l10.7 10.7M92 535l10.7 10.7M85 535l10.6 10.7M78 535l10.6 10.7M70.9 535l10.6 10.7M63.8 535l10.6 10.7M56.7 535l10.6 10.7M85.1 535l10.6 10.7m-46-10.7 10.5 10.7M42.5 535l10.7 10.7M35.4 535l10.7 10.7M28.4 535 39 545.7"
                })
              ]
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "M538.6 531.5c1.7 166.6 24.8 202 3.5 202s-31.9-92.1-31.9-205.5 14.2-205.5 35.5-205.5-9 31.9-7.1 209z",
              transform: "matrix(-.32136 -.12684 -.20158 .20221 345.9 61.4)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.2,
              d: "m545.7 779.5-60.3 17.7c56.7 60.3 120.5 85 138.2 74.4 17.7-10.6-31.9-35.4-78-92z",
              transform: "matrix(-.19848 0 0 .17744 145.3 -13.4)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "m547.3 786.9-51 14.7c56.7 60.3 112.8 77.4 127.3 70 14.6-7.3-30.3-28-76.3-84.7z",
              transform: "matrix(-.19334 0 0 .17062 142.8 -8.1)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M353.1 634.2c.2 1.3.8 7.1 1.3 9.4 0 3.2.3 5.6.6 8.1.8 2.2.7 4.2 3.1 5a9.9 9.9 0 0 0 5 4.4 27.7 27.7 0 0 0 6.3 3.8 11.6 11.6 0 0 0 7.5.6c2.2-1.5 3.8-3.1 5.6-4.4.4-2 .8-4.9 1.3-6.9a32.6 32.6 0 0 0-1.3 8.2c.2 3 1.3 4.4 2.5 6.8",
              transform: "matrix(-.13978 0 0 .12414 123 20.4)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "m389.4 681.7.6-.6c-1.5 1.5-.9.8 2.5-1.3 2.4-1.2 5-1.8 8.1-2.4h8.8c3.4 0 5.7.5 8.1 1.2 1.8 1.8 4.4 2.8 6.3 4.4a11 11 0 0 1 3.7 5c1.7 1.7 2.8 4.3 4.4 5.6.7 2.9 2.1 2.8 3.1 5-3 .2-5.3.6-6.9 2.5-2.6 1.3 2.2-1.3 3.2-2.5 2-.6 2.5-1.2 5.6-1.2 2.8-1 4.6.7 7.5 1.2 1.7 1 2.2 1.3 4.4 1.3",
              transform: "matrix(-.13978 0 0 .12414 124.9 19.7)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M438.1 724.9c1.3 0 7.1 1.1 9.4 0 2.6-.7 4-2 5.6-4.4.8-1.7 0 3 0 5 .3 3.7 1.4 3.7 3.2 6.2 1.8 1.2 3.7 2.8 5.6 3.8a18 18 0 0 0 5.6 3.1c2 1 4.1 1.8 5.6 3.1 2.1 1.5 2 3.3 3.2 5.7-.3 3-.8 4.8-2.5 6.2-.8 2.1-2.4 4.2-3.8 5.6-1.5 3-3.3 4.3.6 5 2.2 1 3.4.2 5.7 0",
              transform: "matrix(-.13978 0 0 .12414 127 18.2)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M480.6 771.7c1.6-.4 7-2.2 9.4-3.1h8.8c3.3.3 4 1.3 6.8 2.5 1.9 1.9 3.1 3.2 5.7 4.4 1.3 1.7 4 4.7 5 6.9a25.5 25.5 0 0 1 1.2 8c0 3.7-1 4.4-1.2 7.6a19.3 19.3 0 0 1-3.8 7.5c-.3.8-.5 1-1.2 1.2",
              transform: "matrix(-.13978 0 0 .12414 127.4 17.8)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 2.3,
              d: "M538.1 818c.4 0 1.2 2 2.5 3.7 2.9 3 3.2 3.2 7.5 3.2 4-.2 3.5-1.6 6.3-2.5 1.3-2 2.9-3.6 4.4-6.3 1-1.6 1.9-4.1 3-5.6 1.2-1.9 2.6-3.3 3.8-5 1.2-.5 1.6-1 3.2-1.3-3.6.6-4 1.9-6.3 3.8a58.9 58.9 0 0 0-3.1 5.6c-.4 2.7-1.2 4.8-1.3 8.1 0 3.5 0 5.9 1.3 8.8 1.5 1.5 2.5 3.1 4.4 4.4a36.7 36.7 0 0 1 4.3 5l5.7 3.7c1.8 1.1 3.9 2.2 6.8 2.5 3.7-.3 4.8-1.3 7.5-2.5 2.4-1.7 4.2-2.8 6.3-4.4a21 21 0 0 0 4.4-5c3.3-.8 5.5-.5 7.5 1.3a16.5 16.5 0 0 1 4.3 4.4c1 .5 2.8 2 3.8 2.5",
              transform: "matrix(-.09924 0 0 .09799 109.5 38.8)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.9,
              d: "M503.8 836.1c-.8.3-3.8 2.4-5 3.1-.8 2.7-2.1 4.1-2.5 7-.7 2.6-.7 5.6-.7 8.7.7 3.2 2 5.5 3.2 8 2 1.4 3 2.4 5.6 3.8 2.5.4 5 .7 8.1.7 2 .6 5.6.9 7.5 0 2.8-.4 4.9-1.5 6.9-2.5 2.3-1.3 3.7-2.6 6.2-3.8 1.3-1.8 3.2-3.5 5-5.6 1.6-2.1 2.7-3.3 3.8-5.6-1 2.6-2.3 5-3.1 7.5-1.5 2.6-2.3 3.6-2.5 6.8-1 2.6-.7 5.8-.7 8.8.3 2 .4 5.8 1.3 7.5v1.9",
              transform: "matrix(-.12338 0 0 .12229 111.4 19.3)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.2,
              d: "M541.3 799.2v.7c0-1.7 0-.9-.7 2.5-1.1 1.4-4 1.8-6.2 1.2-2-1.7-2-3-5.6-3.7-3.6.2-5 1.2-7 2.5a9.5 9.5 0 0 0-5 4.3c-.7 2.1-1.1 3.6 1.3 4.4a15.2 15.2 0 0 0 7 2.5c2.8 0 4.9-.3 6.2 1.3 2 2 1.8 3.2 1.8 6.8.7 1.1.8 4.4 1.3 5.7a10.6 10.6 0 0 0 5.6 1.2c.7-2 1.4-5.4 1.9-7.5.5-2.2.6-5.4 1.9-6.9a16.6 16.6 0 0 1 4.3-4.4 8 8 0 0 1 3.8-2.4c-2.5 1.2-2.8 2.6-3.1 5.6 2.1 1 2.7 1.8 6.2 1.9 3.5-.3 4.3-1.2 5.6-3.2.3 3.2 1.3 4.2 2 7 1.2 1.8 1.7 3.7 3 6.2-.5 3-1.7 3.1-1.8 6.8-.8 2.5-.8 4.8-2.5 6.3-.8 1-1.4 1.1-3.2 1.2 3.6 0 5.8-.4 8.2-1.8 1.8-1.2 3.2-2.6 5-3.8a23.9 23.9 0 0 1 7.5-3.8c2.9 0 5-.3 6.2 1.3 1.8 1.3 3 3.5 3.8 6.3.5 3.2.8 5.4-.7 7.5-1 2.4-1.3 3.3 0 6.2 1.5 2 3.6 2.3 7 3.1 2.3-.1 4.6-.6 6.2-1.2",
              transform: "matrix(-.19848 0 0 .17744 145.3 -13.4)"
            }),
            /* @__PURE__ */ jsxs183("g", {
              fillRule: "evenodd",
              strokeWidth: 1.3,
              transform: "matrix(-.19848 0 0 .17744 145.3 -13.4)",
              children: [
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4z",
                  transform: "matrix(1.4216 -.73423 .46161 .89375 -716.8 541)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4",
                  transform: "matrix(1.1373 -.58739 .44532 .86221 -554.8 471.8)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M563.4 301.2c.2 18.9 0 40.2 0 60.2H535c0-20-.2-41.3 0-60.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M559.8 304.7c.2 19 0 33.1 0 53.2h-21.2c0-20-.2-34.3 0-53.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M542.1 311.8h14.2v39h-14.2zm0 0 14.2 39m-14.2 0 14.2-39m-14.2-198.4h14.2",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 545.7,
                  cy: 92.1,
                  r: 3.5,
                  fill: "#ef0000",
                  transform: "matrix(1.6046 .45375 -.36215 1.5787 -734.9 -170.8)"
                })
              ]
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "M538.6 531.5c1.7 166.6 24.8 202 3.5 202s-31.9-92.1-31.9-205.5 14.2-205.5 35.5-205.5-9 31.9-7.1 209z",
              transform: "matrix(.32136 -.12684 .20158 .20221 -181.5 60.8)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.2,
              d: "m545.7 779.5-60.3 17.7c56.7 60.3 120.5 85 138.2 74.4 17.7-10.6-31.9-35.4-78-92z",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "m547.3 786.9-51 14.7c56.7 60.3 112.8 77.4 127.3 70 14.6-7.3-30.3-28-76.3-84.7z",
              transform: "matrix(.19334 0 0 .17062 21.6 -8.8)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M353.1 634.2c.2 1.3.8 7.1 1.3 9.4 0 3.2.3 5.6.6 8.1.8 2.2.7 4.2 3.1 5a9.9 9.9 0 0 0 5 4.4 27.7 27.7 0 0 0 6.3 3.8 11.6 11.6 0 0 0 7.5.6c2.2-1.5 3.8-3.1 5.6-4.4.4-2 .8-4.9 1.3-6.9a32.6 32.6 0 0 0-1.3 8.2c.2 3 1.3 4.4 2.5 6.8",
              transform: "matrix(.13978 0 0 .12414 41.4 19.7)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "m389.4 681.7.6-.6c-1.5 1.5-.9.8 2.5-1.3 2.4-1.2 5-1.8 8.1-2.4h8.8c3.4 0 5.7.5 8.1 1.2 1.8 1.8 4.4 2.8 6.3 4.4a11 11 0 0 1 3.7 5c1.7 1.7 2.8 4.3 4.4 5.6.7 2.9 2.1 2.8 3.1 5-3 .2-5.3.6-6.9 2.5-2.6 1.3 2.2-1.3 3.2-2.5 2-.6 2.5-1.2 5.6-1.2 2.8-1 4.6.7 7.5 1.2 1.7 1 2.2 1.3 4.4 1.3",
              transform: "matrix(.13978 0 0 .12414 39.5 19)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M438.1 724.9c1.3 0 7.1 1.1 9.4 0 2.6-.7 4-2 5.6-4.4.8-1.7 0 3 0 5 .3 3.7 1.4 3.7 3.2 6.2 1.8 1.2 3.7 2.8 5.6 3.8a18 18 0 0 0 5.6 3.1c2 1 4.1 1.8 5.6 3.1 2.1 1.5 2 3.3 3.2 5.7-.3 3-.8 4.8-2.5 6.2-.8 2.1-2.4 4.2-3.8 5.6-1.5 3-3.3 4.3.6 5 2.2 1 3.4.2 5.7 0",
              transform: "matrix(.13978 0 0 .12414 37.4 17.6)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M480.6 771.7c1.6-.4 7-2.2 9.4-3.1h8.8c3.3.3 4 1.3 6.8 2.5 1.9 1.9 3.1 3.2 5.7 4.4 1.3 1.7 4 4.7 5 6.9a25.5 25.5 0 0 1 1.2 8c0 3.7-1 4.4-1.2 7.6a19.3 19.3 0 0 1-3.8 7.5c-.3.8-.5 1-1.2 1.2",
              transform: "matrix(.13978 0 0 .12414 37 17.2)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 2.3,
              d: "M538.1 818c.4 0 1.2 2 2.5 3.7 2.9 3 3.2 3.2 7.5 3.2 4-.2 3.5-1.6 6.3-2.5 1.3-2 2.9-3.6 4.4-6.3 1-1.6 1.9-4.1 3-5.6 1.2-1.9 2.6-3.3 3.8-5 1.2-.5 1.6-1 3.2-1.3-3.6.6-4 1.9-6.3 3.8a58.9 58.9 0 0 0-3.1 5.6c-.4 2.7-1.2 4.8-1.3 8.1 0 3.5 0 5.9 1.3 8.8 1.5 1.5 2.5 3.1 4.4 4.4a36.7 36.7 0 0 1 4.3 5l5.7 3.7c1.8 1.1 3.9 2.2 6.8 2.5 3.7-.3 4.8-1.3 7.5-2.5 2.4-1.7 4.2-2.8 6.3-4.4a21 21 0 0 0 4.4-5c3.3-.8 5.5-.5 7.5 1.3a16.5 16.5 0 0 1 4.3 4.4c1 .5 2.8 2 3.8 2.5",
              transform: "matrix(.09924 0 0 .09799 55 38.2)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.9,
              d: "M503.8 836.1c-.8.3-3.8 2.4-5 3.1-.8 2.7-2.1 4.1-2.5 7-.7 2.6-.7 5.6-.7 8.7.7 3.2 2 5.5 3.2 8 2 1.4 3 2.4 5.6 3.8 2.5.4 5 .7 8.1.7 2 .6 5.6.9 7.5 0 2.8-.4 4.9-1.5 6.9-2.5 2.3-1.3 3.7-2.6 6.2-3.8 1.3-1.8 3.2-3.5 5-5.6 1.6-2.1 2.7-3.3 3.8-5.6-1 2.6-2.3 5-3.1 7.5-1.5 2.6-2.3 3.6-2.5 6.8-1 2.6-.7 5.8-.7 8.8.3 2 .4 5.8 1.3 7.5v1.9",
              transform: "matrix(.12338 0 0 .12229 53 18.6)"
            }),
            /* @__PURE__ */ jsx190("path", {
              fill: "none",
              strokeWidth: 1.2,
              d: "M541.3 799.2v.7c0-1.7 0-.9-.7 2.5-1.1 1.4-4 1.8-6.2 1.2-2-1.7-2-3-5.6-3.7-3.6.2-5 1.2-7 2.5a9.5 9.5 0 0 0-5 4.3c-.7 2.1-1.1 3.6 1.3 4.4a15.2 15.2 0 0 0 7 2.5c2.8 0 4.9-.3 6.2 1.3 2 2 1.8 3.2 1.8 6.8.7 1.1.8 4.4 1.3 5.7a10.6 10.6 0 0 0 5.6 1.2c.7-2 1.4-5.4 1.9-7.5.5-2.2.6-5.4 1.9-6.9a16.6 16.6 0 0 1 4.3-4.4 8 8 0 0 1 3.8-2.4c-2.5 1.2-2.8 2.6-3.1 5.6 2.1 1 2.7 1.8 6.2 1.9 3.5-.3 4.3-1.2 5.6-3.2.3 3.2 1.3 4.2 2 7 1.2 1.8 1.7 3.7 3 6.2-.5 3-1.7 3.1-1.8 6.8-.8 2.5-.8 4.8-2.5 6.3-.8 1-1.4 1.1-3.2 1.2 3.6 0 5.8-.4 8.2-1.8 1.8-1.2 3.2-2.6 5-3.8a23.9 23.9 0 0 1 7.5-3.8c2.9 0 5-.3 6.2 1.3 1.8 1.3 3 3.5 3.8 6.3.5 3.2.8 5.4-.7 7.5-1 2.4-1.3 3.3 0 6.2 1.5 2 3.6 2.3 7 3.1 2.3-.1 4.6-.6 6.2-1.2",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)"
            }),
            /* @__PURE__ */ jsxs183("g", {
              fillRule: "evenodd",
              strokeWidth: 1.3,
              transform: "matrix(.19848 0 0 .17744 19.1 -14)",
              children: [
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4z",
                  transform: "matrix(1.4216 -.73423 .46161 .89375 -716.8 541)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4",
                  transform: "matrix(1.1373 -.58739 .44532 .86221 -554.8 471.8)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M563.4 301.2c.2 18.9 0 40.2 0 60.2H535c0-20-.2-41.3 0-60.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M559.8 304.7c.2 19 0 33.1 0 53.2h-21.2c0-20-.2-34.3 0-53.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  fill: "#fff",
                  d: "M542.1 311.8h14.2v39h-14.2zm0 0 14.2 39m-14.2 0 14.2-39m-14.2-198.4h14.2",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 545.7,
                  cy: 92.1,
                  r: 3.5,
                  fill: "#ef0000",
                  transform: "matrix(1.6046 .45375 -.36215 1.5787 -734.9 -170.8)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs183("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)",
              children: [
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M305.6 396.9c0 124 .5 170.7-5.6 177.1-5.8 6.9-167.1 0-167.1 35.4s132.8 71 172.7 71c53.2 0 79.7-35.5 79.7-106.4V397h-79.7z",
                  transform: "matrix(1.3333 0 0 1 -141.7 0)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 35.4)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "scale(1 .99999)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 17.7)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 53.1)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 256.9,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 394.3)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 292.3,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 391.1)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 327.8,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 390.5)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 363.2,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 390.5)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 398.6,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 391.1)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 434.1,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 394.3)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 485.4 372 581.1m-95.6-95.7 95.7 85M290.5 489l81.6 70.9m-71-71 71 60.3M311.8 489l60.2 49.6M322.4 489l49.6 39m-39-39 39 28.3M343.8 489l28.4 21.2M354.3 489l17.8 14.2M365 489l7 7m-106.2 0L372 591.8m0-106.3L255 591.7m106.3-106.3-102.7 92.2m88.6-88.6-81.5 70.8m70.8-70.8-70.8 60.2M326 489l-60.2 49.6m49.6-49.6-49.6 39m39-39-39 28.3M294 489l-28.3 21.2m17.7-21.2-17.7 14.2m7-14.2-7 7m106.3 0L255 602.5m117-95.7L255 613m117-95.7L255 623.6m117-95.7L255 634.4m117-95.7L255 644.9m117-95.7L255 655.5m117-95.7L255 666.1m117-95.6L255 676.8m117-95.7-109.9 99.2M372 591.7l-99.2 88.6m95.6-74.4-78 70.9M365 620l-63.8 56.7m56.7-39-32 28.3m-60.1-159.4 102.7 92.1m-102.7-81.5 102.7 92.2M265.8 528l99.2 88.5m-99.2-78 99.2 88.7m-99.2-78 95.6 85m-99.2-77.9 95.7 85M262.2 567l88.6 78m-92.1-71 88.6 78M255 581l85 74.4m-85-63.8 81.5 70.9M255 602.3l71 63.7"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 70.9)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m255.1 613 63.8 56.7m-63.8-46 56.7 49.5m-56.7-39 49.6 42.6m-49.6-32 35.5 32M255 655.5l28.4 24.8M255 666.1l17.7 14.2"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 256.9,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 447.5)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 292.3,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 444.3)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 327.8,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 443.6)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 363.2,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 443.6)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 398.6,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 444.3)"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 434.1,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 447.5)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m113.4 652 127.5-74.4m-134.6 70.8 120.5-70.8m-124 63.7 109.8-63.7M99.2 634.3l95.7-56.7M92 627.2l88.6-49.6m-85 39 60.2-35.5M92 609.4l46-28.3m-46 17.7 32-17.7m0 74.4 120.4-70.9M134.7 659 248 591.7m-102.7 70.9 106.3-63.8m-95.7 67.3 88.6-53.1M170 666.1l78-46m-67.4 49.6 67.3-39m-56.7 42.5 53.2-31.9m-39 32 42.5-24.9m-28.3 28.4L248 659m-14 17.8 17.7-10.6"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(0 1 -.99999 0 655.5 308.3)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m49.6 623.6 42.5-35.4m-42.5 10.6 42.5 42.5"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "m260.1 388 5.6 26.6c35.5 5.9 65.3 5.9 100.8 0l11.1-26.6c-35.4 5.9-82 5.9-117.5 0z",
                  transform: "matrix(0 .63333 -.8 0 423.8 416.3)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M258.7 350.8v-17.9c-10.7.2-17.8-10.5-17.8-21.2l-35.4.1c0 10.6-7 21.3-17.7 21.3v17.7z",
                  transform: "matrix(1.4983 0 0 1 -15.6 53.1)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.4,
                  d: "M296 343.7h45.6V365H296zm3.9-21.3h37.9v21.3h-38zm0-21.2h37.9v21.2h-38zm3.8-28.4H334v28.4h-30.3zm-1.3-24.8h33v24.8h-33z"
                }),
                /* @__PURE__ */ jsx190("ellipse", {
                  cx: 237.4,
                  cy: 161.2,
                  strokeWidth: 1.3,
                  rx: 42.5,
                  ry: 33.7,
                  transform: "matrix(1.0333 0 0 1 75.3 63.8)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M258.7 159.4c0 9.3 10.6 24.8 10.6 24.8-7.7 6.2-20.2 10.7-31.9 10.7s-26.3-2.6-31.9-10.7c0 0 10.6-15.4 10.6-24.7s-10.6-21.3-10.6-21.3a54.6 54.6 0 0 1 32-10.6c11.6 0 24 4.5 31.8 10.6 0 0-10.6 12-10.6 21.3z",
                  transform: "matrix(1.0333 0 0 1 75.3 63.8)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M251.6 159.4c0 9.3 10.6 28.4 10.6 28.4-7.7 6-13 7-24.8 7s-19.2 1.1-24.8-7c0 0 10.6-19 10.6-28.4s-10.6-24.8-10.6-24.8c7.7-6 13-7 24.8-7 11.7 0 17.1 1 24.8 7 0 0-10.6 15.5-10.6 24.8z",
                  transform: "matrix(1.0333 0 0 1 75.3 63.8)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 75.3 60.2)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 163.2 60.2)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 119.3 60.2)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 119.3 24.8)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0702 0 0 1 80 226.8)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0702 0 0 1 140.6 226.8)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.3,
                  d: "M212.6 311.8h49.6l-24.8 31.9z",
                  transform: "matrix(1.0702 0 0 1 64.8 53.1)"
                }),
                /* @__PURE__ */ jsx190("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.427 0 0 1.3333 40.7 167.7)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs183("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 18.8 -19.1)",
              children: [
                /* @__PURE__ */ jsx190("rect", {
                  width: 81.5,
                  height: 21.3,
                  x: 262.2,
                  y: 524.4,
                  strokeWidth: 1.2,
                  rx: 4.3,
                  ry: 3.7
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.2,
                  d: "M368.5 506.7c-9.8 0-17.7 8.3-17.7 18.5v16.1a18 18 0 0 0 17.7 18.5 18 18 0 0 0 17.7-18.5v-16a18 18 0 0 0-17.7-18.6zm0 7c-5.9 0-10.6 6.7-10.6 14.9v9.3c0 8.2 4.7 14.8 10.6 14.8 5.9 0 10.6-6.6 10.6-14.8v-9.3c0-8.2-4.7-14.8-10.6-14.8zm-92.1-3.5c-6 0-10.6 6.6-10.6 14.9v16.4c0 8.2 4.7 14.8 10.6 14.8 5.9 0 10.6-6.6 10.6-14.8V525c0-8.3-4.7-14.9-10.6-14.9zm0-7a18 18 0 0 0-17.7 18.5v23.2a18 18 0 0 0 17.7 18.5c9.8 0 17.7-8.3 17.7-18.5v-23.2a18 18 0 0 0-17.7-18.6z"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 1.2,
                  d: "M248 517.3c-5.9 0-10.6 6.6-10.6 14.8v3.9c0 8.2 4.7 14.8 10.6 14.8 6 0 10.7-6.6 10.7-14.8v-3.9c0-8.2-4.8-14.8-10.7-14.8zm0-7a18 18 0 0 0-17.7 18.5v10.6a18 18 0 0 0 17.7 18.5c9.8 0 17.8-8.3 17.8-18.5v-10.6a18 18 0 0 0-17.8-18.6z"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 0.9,
                  d: "M478.4 237.4c-6 0-10.7 6.6-10.7 14.8v16.5c0 8.1 4.8 14.8 10.7 14.8 5.8 0 10.6-6.6 10.6-14.9v-16.4c0-8.2-4.8-14.8-10.6-14.8zm0-7a18 18 0 0 0-17.8 18.4V272a18 18 0 0 0 17.7 18.6c9.9 0 17.8-8.3 17.8-18.6v-23.2a18 18 0 0 0-17.7-18.5z",
                  transform: "matrix(1.8 0 0 1.1176 -655.5 242.2)"
                }),
                /* @__PURE__ */ jsx190("path", {
                  strokeWidth: 0.9,
                  d: "M478.4 237.4c-6 0-10.7 6.6-10.7 14.8v16.5c0 8.1 4.8 14.8 10.7 14.8 5.8 0 10.6-6.6 10.6-14.9v-16.4c0-8.2-4.8-14.8-10.6-14.8zm0-7a18 18 0 0 0-17.8 18.4V272a18 18 0 0 0 17.7 18.6c9.9 0 17.8-8.3 17.8-18.6v-23.2a18 18 0 0 0-17.7-18.5z",
                  transform: "matrix(1.8 0 0 1.1176 -425.2 245.7)"
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 42.5,
                  height: 21.3,
                  x: 375.6,
                  y: 524.4,
                  strokeWidth: 1.2,
                  rx: 2.3,
                  ry: 3.7
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 24.8,
                  height: 28.4,
                  x: 336.6,
                  y: 520.9,
                  strokeWidth: 1.2,
                  rx: 1.3,
                  ry: 4.9
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 24.8,
                  height: 28.4,
                  x: 219.7,
                  y: 520.9,
                  strokeWidth: 1.2,
                  rx: 1.3,
                  ry: 4.9
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 49.6,
                  height: 35.4,
                  x: 141.7,
                  y: 517.3,
                  strokeWidth: 1.2,
                  rx: 2.6,
                  ry: 6.1
                }),
                /* @__PURE__ */ jsx190("rect", {
                  width: 46.1,
                  height: 35.4,
                  x: 450,
                  y: 520.9,
                  strokeWidth: 1.2,
                  rx: 2.5,
                  ry: 6.1
                })
              ]
            })
          ]
        })
      ]
    })
  ]
});
var Om_default = SvgOm;

// src/country-flag-icons/generated/Pa.tsx
import { jsx as jsx191, jsxs as jsxs184 } from "react/jsx-runtime";
var SvgPa = (props) => /* @__PURE__ */ jsxs184("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx191("defs", {
      children: /* @__PURE__ */ jsx191("clipPath", {
        id: "pa_svg__a",
        children: /* @__PURE__ */ jsx191("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs184("g", {
      clipPath: "url(#pa_svg__a)",
      children: [
        /* @__PURE__ */ jsx191("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M92.5 0h477.2v480H92.4z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#db0000",
          fillRule: "evenodd",
          d: "M323 3.6h358v221.7H323z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#0000ab",
          fillRule: "evenodd",
          d: "M3.2 225.3h319.9V480H3.2zm211.6-47.6-42-29.4-41.7 29.6 15.5-48L105 100l51.6-.4 16-48 16.3 47.9h51.6l-41.5 30 15.9 48z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#d80000",
          fillRule: "evenodd",
          d: "m516.9 413.9-42.4-27.7-42.1 28 15.6-45.6-42-28 52-.5 16.2-45.4 16.4 45.3h52l-41.8 28.5 16 45.4z"
        })
      ]
    })
  ]
});
var Pa_default = SvgPa;

// src/country-flag-icons/generated/Pe.tsx
import { jsx as jsx192, jsxs as jsxs185 } from "react/jsx-runtime";
var SvgPe = (props) => /* @__PURE__ */ jsxs185("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx192("path", {
      fill: "#D91023",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx192("path", {
      fill: "#fff",
      d: "M213.3 0h213.4v480H213.3z"
    })
  ]
});
var Pe_default = SvgPe;

// src/country-flag-icons/generated/Pf.tsx
import { jsx as jsx193, jsxs as jsxs186 } from "react/jsx-runtime";
var SvgPf = (props) => /* @__PURE__ */ jsxs186("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx193("defs", {
      children: /* @__PURE__ */ jsx193("clipPath", {
        id: "pf_svg__a",
        children: /* @__PURE__ */ jsx193("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs186("g", {
      clipPath: "url(#pf_svg__a)",
      children: [
        /* @__PURE__ */ jsx193("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#fff",
          d: "M80 0h480v480H80z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#083d9c",
          fillRule: "evenodd",
          stroke: "#083d9c",
          strokeWidth: "2pt",
          d: "M277.3 340.8s10.8-8.8 21.4-8.8 13.4 7.3 20.8 7.9c7.3.6 13.4-7.3 22.5-7.6 9.1-.3 20.5 6.4 20.5 6.4l-39.8 12-45.4-10zm-22.9-13 135.4.7s-11.7-12.7-25.5-13c-13.8-.2-10 6-20.5 6.8-10.6.9-13.2-6.4-22.9-6.2-9.6.3-15.2 6.2-22.5 6.5-7.4.3-16.7-7.3-22.3-7-5.6.3-25.5 8.7-25.5 8.7l3.8 3.6zm-17.3-16 167 .5c2.7-3.8-8.2-12.9-18.1-13.7-8.2.3-14 8.5-20.8 8.8-6.8.3-14.4-8.5-22-8.2-7.6.3-15.5 8.2-23.1 8.2-7.7 0-13.2-8.5-22.9-8.5s-14 9.3-21.4 8.8c-7.3-.6-13.8-9.4-20.8-9.4s-18.7 10.5-21 10c-2.4-.7 2.9 4.3 3.1 3.4z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "red",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.5,
          d: "m301.3 218.9 38.4 10.2v-54.8c-17.6 1-32.2-33.4-1.2-35.7-30.5-4.4-34 3.5-37.5 12z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#083d9c",
          fillRule: "evenodd",
          stroke: "#083d9c",
          strokeLinecap: "round",
          strokeWidth: 5,
          d: "m277 258.7 86.7.3"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 4,
          d: "m281.1 238 10.3 13.7m-10.3 0 11.1-13.5M287 237l-.3 8.5m10.8-7.6 10.3 13.8m-10.3 0 11.1-13.5m-5.2-1.2-.3 8.5m11.1-7.6 10.3 13.8m-10.3 0 11.1-13.5m-5.2-1.2-.3 8.5m11.7-7.6 10.2 13.8m-10.2 0 11.1-13.5m-5.3-1.2-.2 8.5m11-7.6 10.3 13.8m-10.2 0 11.1-13.5M354 237l-.3 8.5"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#ef7d08",
          fillRule: "evenodd",
          d: "m218.7 259.6 36.9.3v-23.1l-42.2-2.1zm-1.8-32 39.3 3.9-.3-16.4-38.4-15.3-.6 27.9zm8-32.7 30.1 14.6 4.3-4.5s-2.8-1.9-2.6-3.7c0-1.7 2.8-2 2.8-4 0-1.7-3-2-3.1-3.7-.2-2 2.4-4 2.4-4l-27.2-23.7-6.8 29zm198 65h-39l-.3-22.6 42.8-3.2zM384.2 232l46.3-5.6-10-26.7-36.6 15.6zm33.7-39.6L384.5 210c-.5-2-.9-3.8-3.2-5.3 0 0 2-1.2 2-3.2s-2.6-2.4-2.6-3.5 2.4-2.2 2.6-4.9c-.3-1.8-2.6-4.4-2.2-4.9l26-19.8zm-72.4 39.1 16.7-.7.3-6.7zm-51-.5-17.5-.5v-7l17.6 7.5zm0-2-17.5-9v-11.8s-2 .3-1.8-2c.1-4.9 12.9 8.9 19.4 13.4zm51-1.1v-7.7s15.8-14.2 19.1-16.9c0 3-1.8 5.2-1.8 5.2v11.2zM243 163.8l17.8 19.7c.4-1.8 4.5-2.1 8.6-1.8 4 .3 7.3-.3 7.3 2.6s-2 2.5-2 4.6 3 1.9 3 4.5-2.2 2.1-2.2 4.1c0 1.7 2.4 1.8 2.4 1.8l16.6 16.1v-17.2l-34.2-53.7zm27.4-20.4 23.3 47.5s.2-43.8 4.1-46.1l-6.5-12zm101 1.9-26 46.2V172s2.2-3.2-1.2-3c-3.4.3-7.5-.2-7.5-.2l10.4-36.6zM398 165c-.3.5-17.5 18-17.5 18-.8-2-6-1-11-1-4.9 0-5.6 1.6-5.3 2.9.5 3.3 2.2.8 2.2 4 0 3.1-2.4 2-2.7 4.2.3 2.7 3.8 2 1.7 4l-19.9 19.2v-18.2l37.1-57.6z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "red",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.5,
          d: "M309.8 268.4c-8.3 13.8-30.6 9.7-35.9 0-1.5-.4-.6-59.5-.6-59.5s-2.5-1.1-2.6-3c-.1-1.8 3.4-2 3.4-4.3s-3.6-1.4-3.7-3.8c0-2.2 3.9-2 3.7-4-.2-2.4-4.3-2-4.5-4.2 0-1.7 3-3.2 3.8-4a61.3 61.3 0 0 1-2.8 0l-6.4.1c-4.6 0 0 1 0 3.6 0 1.7-2.3 2.9-2.5 4.3-.1 1.6 3.2 2.6 3.3 4.5 0 1.6-3.3 1.7-3.2 3.3.2 2.5 3 3.1 2.9 4.7 0 1.5-3.6 2.1-3.7 3.3.2 2.4.6 60.8.6 60.8 5.7 29.8 38.8 37.3 48.2-1.8zm21.9 0c8.3 13.8 30.6 9.7 35.8 0 1.6-.4.7-59.5.7-59.5s2.5-1.1 2.6-3c.1-1.8-3.2-2-3.2-4.3s3.4-1.4 3.4-3.8c0-2.2-3.5-2-3.3-4.2.2-2.3 3-2 3.1-4.2.1-1.9-1.7-3-2.6-3.8h2.7l6.4.1c4.5 0 0 1 0 3.6 0 1.7 2.3 2.9 2.5 4.3 0 1.6-3.2 2.6-3.3 4.5 0 1.6 3.3 1.7 3.2 3.3-.2 2.5-3 3.1-3 4.7.1 1.5 3.7 2.1 3.7 3.3l-.5 60.8c-5.7 29.8-38.9 37.3-48.2-1.8z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#083d9c",
          fillRule: "evenodd",
          stroke: "#083d9c",
          strokeWidth: "2pt",
          d: "M301.7 295.6H339c.3-.3-8.4-13-18.6-12-11.5.3-19.3 12-18.7 12zm118.9-1h-51s6.6-3.8 8.4-7.4c3.3 1.8 2.4 3.6 9 3.9 6.6.3 12.9-7.5 19.2-7.2 6.3.3 14.4 11 14.4 10.8zm-201 0h51s-6.6-3.8-8.4-7.4c-3.3 1.8-2.4 3.6-9 3.9-6.6.3-13-7.5-19.2-7.2-6.3.3-14.4 11-14.4 10.8zm3.8-16 36.3.3s-2.3-5-2.6-11.1c-9.4-3.2-17 7-23.8 7.3-6.7.3-13.7-7.3-13.7-7.3zm194 0-36.4.3s2.3-5 2.6-11.1c9.4-3.2 17 7 23.8 7.3 6.7.3 13.7-7.3 13.7-7.3zM311 279l18.4-.5s.3-5.6-9.3-5.6-8.8 6.4-9.1 6.1zm-11.2-7.9a17 17 0 0 0 8.2-7.6l-12.6.3s-5.8 3.5-8.7 7.3zm40.8 0a17 17 0 0 1-8.2-7.6l12.6.3s5.8 3.5 8.7 7.3z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#de2010",
          fillRule: "evenodd",
          d: "M-40 360h720v120H-40zm0-360h720v120H-40z"
        })
      ]
    })
  ]
});
var Pf_default = SvgPf;

// src/country-flag-icons/generated/Pg.tsx
import { jsx as jsx194, jsxs as jsxs187 } from "react/jsx-runtime";
var SvgPg = (props) => /* @__PURE__ */ jsxs187("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs187("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx194("path", {
          fill: "#000001",
          d: "m1.6 0-.5 480h640z"
        }),
        /* @__PURE__ */ jsx194("path", {
          fill: "red",
          d: "m640.6 480 .5-480H1.1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx194("path", {
      fill: "#fc0",
      stroke: "#fc0",
      strokeWidth: 1.1,
      d: "m178 54-3.8-.2c-1.2-2.8-4.5-3.8-6.6-2.6A333 333 0 0 1 156 51l7.1 3.1C165 59 171 60 171 60c-.6 8.8-8.9-1.1-15.9 3.9-5 3-5 6.5-7.7 12.3-.9 1.6-4.4 5.8-4.4 5.8l5.9-.5L147 84l7-1-1.5 1.4c1 .2 8-1.7 8-1.7L160 85l8-2.9s1.6 1.3 3 1.9l1-4 4 1 1-4c6 8 8 16 19 18l-1-4a262.2 262.2 0 0 1 8.7 4l.9-1.7c4.8 3.4 8.7 3.3 11.4 3.7l-2-5 2 1-3-8 3 1-4-6 1.5-1-.5-3c6 2 14 5 15 12 1 11-11 14-19 13 6 5 17 3 22-2 2-2 3-5 4-8 1 3 3 7 3 11-1 9-13 12-21 13 9 5 25-1 26-14 0-11-7-16-10-21l-1-5.4 3 1.4s-1.8-3.3-2-4c0 0-3.1-8.5-4.2-10.4l2.2.4-8.2-10.3 2.3-.2S215.6 44 213 43l3-1c-6-3-13-1-19 3l1-3-1.8.2v-3.5L198 36l-3-1 2-5-3 1 1-5s-2.2 1-3.6.9a51.7 51.7 0 0 0 1.6-3.4c-1-1.5 0-4.5 0-4.5-7 1-8 2-12 8-6 11-4 16-3 27z",
      transform: "matrix(2.21989 0 0 2.21194 1.1 0)"
    }),
    /* @__PURE__ */ jsx194("path", {
      fill: "red",
      fillRule: "evenodd",
      stroke: "red",
      strokeWidth: 1.4,
      d: "M215.8 70.4c.5.9 6.2 3.6 10.4 6-1.1-4.6-9.4-5.6-10.4-6z",
      transform: "matrix(2.21989 0 0 2.21194 1.1 0)"
    }),
    /* @__PURE__ */ jsx194("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m175 399-14.2-9-19 9.1 4.3-16.2-14.5-15.1 16.7-1 10-18.4 6.1 15.5 20.7 3.8-13 10.6zm36.2-79-6.6-3-6.3 3.6 1-7.2-5.4-4.9 7.1-1.3 3-6.6 3.5 6.4 7.2.8-5 5.2zm32-45.2-14.5-7-13.9 7.8 2.3-15.7-11.8-10.8 15.7-2.8 6.6-14.4 7.6 14 15.8 1.8-11 11.5zm-65.8-63-17-8.5-16.5 9.1 2.8-18.6-13.8-13 18.7-3 8-17 8.7 16.7 18.8 2.3-13.3 13.4zm-60.8 65.4-17-10-17 10.3 4.3-19.3-15.1-13 19.7-1.8 7.7-18.3 7.9 18.2 19.8 1.6-14.9 13z"
    })
  ]
});
var Pg_default = SvgPg;

// src/country-flag-icons/generated/Ph.tsx
import { jsx as jsx195, jsxs as jsxs188 } from "react/jsx-runtime";
var SvgPh = (props) => /* @__PURE__ */ jsxs188("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx195("path", {
      fill: "#0038a8",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx195("path", {
      fill: "#ce1126",
      d: "M0 240h640v240H0z"
    }),
    /* @__PURE__ */ jsx195("path", {
      fill: "#fff",
      d: "M415.7 240 0 480V0"
    }),
    /* @__PURE__ */ jsx195("path", {
      fill: "#fcd116",
      d: "M26.7 42.4 41 55l16.6-9.2-7.4 17.5 14 13-19-1.6-8.1 17.2-4.3-18.5L14 71l16.3-10zm323.8 172.3.4 19 18 6.3-18 6.2-.4 19-11.5-15.1-18.2 5.5 10.8-15.6-10.8-15.6 18.2 5.5zM37.2 388.1l8 17.2 19-1.6-13.9 13 7.4 17.5-16.6-9.1-14.4 12.4 3.6-18.7L14 409l18.9-2.4zm114.2-249-6.2 6.2 3.1 47-3 .3-5.7-42.9-5.1 5 7.6 38.4a47.5 47.5 0 0 0-17.2 7.1l-21.7-32.4H96l26.4 34.3a48 48 0 0 0-2.4 2l-31.1-35.5h-8.8v8.8l35.4 31-2 2.5-34.3-26.3v7.1l32.5 21.7c-3.4 5.2-5.9 11-7.1 17.2L66.3 223l-5.1 5 42.9 5.7c-.2 1-.3 2.1-.3 3.1l-47-3-6.2 6.2 6.2 6.2 47-3.1.3 3.1-42.9 5.7 5 5 38.4-7.6a47.5 47.5 0 0 0 7.1 17.2l-32.5 21.7v7.2l34.3-26.3a48 48 0 0 0 2 2.4l-35.4 31v8.8H89l31-35.4 2.5 2L96 312.2h7.2l21.7-32.5c5.1 3.4 11 5.9 17.2 7.1l-7.6 38.4 5 5 5.7-42.9c1 .2 2 .3 3.1.3l-3 47 6.1 6.2 6.3-6.2-3.1-47 3-.3 5.7 43 5.1-5.1-7.6-38.4a47.5 47.5 0 0 0 17.2-7.1l21.7 32.5h7.2l-26.4-34.3a48 48 0 0 0 2.4-2l31.1 35.4h8.8v-8.8l-35.4-31 2-2.4 34.3 26.3v-7.2l-32.5-21.7c3.4-5.1 5.9-11 7.1-17.2l38.3 7.6 5.1-5-42.9-5.7c.2-1 .3-2 .3-3.1l47 3 6.2-6.1-6.2-6.2-47 3-.3-3 42.9-5.7-5-5-38.4 7.5a47.5 47.5 0 0 0-7.1-17.2l32.5-21.7v-7.1l-34.3 26.3a48 48 0 0 0-2-2.4l35.4-31v-8.9H214l-31 35.5a48 48 0 0 0-2.5-2l26.4-34.3h-7.2L178 200.2c-5.1-3.4-11-5.9-17.2-7.1l7.6-38.3-5-5-5.7 42.8-3.1-.3 3-47z"
    })
  ]
});
var Ph_default = SvgPh;

// src/country-flag-icons/generated/Pk.tsx
import { jsx as jsx196, jsxs as jsxs189 } from "react/jsx-runtime";
var SvgPk = (props) => /* @__PURE__ */ jsxs189("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx196("defs", {
      children: /* @__PURE__ */ jsx196("clipPath", {
        id: "pk_svg__a",
        children: /* @__PURE__ */ jsx196("path", {
          fillOpacity: 0.7,
          d: "M-52.3 0h682.6v512H-52.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs189("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#pk_svg__a)",
      transform: "translate(49) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx196("path", {
          fill: "#0c590b",
          d: "M-95 0h768v512H-95z"
        }),
        /* @__PURE__ */ jsx196("path", {
          fill: "#fff",
          d: "M-95 0H97.5v512H-95z"
        }),
        /* @__PURE__ */ jsxs189("g", {
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx196("path", {
              d: "m403.7 225.4-31.2-6.6-16.4 27.3-3.4-31.6-31-7.2 29-13-2.7-31.7 21.4 23.6 29.3-12.4-15.9 27.6 21 24z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "M415.4 306a121.2 121.2 0 0 1-161.3 59.4 122.1 122.1 0 0 1-59.5-162.1A118.6 118.6 0 0 1 266 139a156.2 156.2 0 0 0-11.8 10.9A112.3 112.3 0 0 0 415.5 306z"
            })
          ]
        })
      ]
    })
  ]
});
var Pk_default = SvgPk;

// src/country-flag-icons/generated/Pl.tsx
import { jsx as jsx197, jsxs as jsxs190 } from "react/jsx-runtime";
var SvgPl = (props) => /* @__PURE__ */ jsx197("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs190("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx197("path", {
        fill: "#fff",
        d: "M640 480H0V0h640z"
      }),
      /* @__PURE__ */ jsx197("path", {
        fill: "#dc143c",
        d: "M640 480H0V240h640z"
      })
    ]
  })
});
var Pl_default = SvgPl;

// src/country-flag-icons/generated/Pm.tsx
import { jsx as jsx198, jsxs as jsxs191 } from "react/jsx-runtime";
var SvgPm = (props) => /* @__PURE__ */ jsxs191("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx198("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx198("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx198("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Pm_default = SvgPm;

// src/country-flag-icons/generated/Pn.tsx
import { jsx as jsx199, jsxs as jsxs192 } from "react/jsx-runtime";
var SvgPn = (props) => /* @__PURE__ */ jsxs192("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx199("path", {
      fill: "#00247d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M410.1 252.3a56.5 56.5 0 0 0-19 27.8c-5.7 27.3-13.3 33.4-25 27.5 0 14.7 12.9 15.8 18.5 7.3 0 13.7 5 25.6 16.2 35.8 4.8 4.3 5.7 1.4 3.4-3.4-2.2-4.7-2.2-20-6.7-28.8 7.2 5.1 17.8 2.2 17-12-9.3 5.4-18.5 5.2-19.5-7.7-1.1-15 4.7-37 15.1-46.5zm-11-108.6c.7-5.5-.5-11-4.5-14.5-7.6-6.7-15.1-4.5-20.7 1-8.3-4.6-12.8 11.4-22.2 8.7 1.5 5.2 4 7.4 8.8 5.6-5 4.5 0 10-5.9 15.4 10.6 3.4 16.2-2.5 15.8-12.7a9.6 9.6 0 0 0 13.7-.7c-5.6-1.8-5.6-6.7-3.4-11.2 3.4-6.8 19.3-6.5 18.4 8.4z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M423.6 222.1c-12 6.4-33.8 3.7-35.9-12-2-15.5 13.1-22.5 17.2-24.5 6.3-3.2 11.3 2.5 9.2 9 7-2.4 8.6-10.6 5.2-15.3 9.3.7 17.8-6.3 21.4-16.2-3.2 3-12 1-19.3.5 2.2-2.5 2.2-7.3 1.5-9.8-7.6 7.9-18.7 4.3-33.3 27a1023.3 1023.3 0 0 0 9.6-37.1c.8-15-15-15.2-18.4-8.4 3.7 4.2 1.7 9 .4 16.5-1.6 8.7-5 29-7.9 35.8-.9-10.6-7.9-11.3-9.2-16.5-2 1.4-3.2 5-2.7 7.5-2.5-2.7-11.1.7-14.3-3.4-3.3 6.7 2 13.5 7.7 16.5-3.3.2-4 4.1-7.7 4.1 4.9 5.7 9.9 8 15.6 8.4 5.8.4 10 2.6 13.5 9.6 5.7 11.3 27.2 18.6 47.4 8.3z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M453.4 208.4c-6.8 18.7-25.3 32-33.6 34-14.2 3.5-43.2 17.6-51 24.8a9 9 0 0 1-3.2-1.3c-3.8-2.7-7-11.5-.2-19 21.2-19.8 44-11.2 58.2-24.8-12 6.3-33.8 3.6-35.8-12a55 55 0 0 0 54.5-16.2 97.7 97.7 0 0 1 11 14.5z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M410.1 252.3c-10.7 9-16.2 31.4-15.1 46.5.3 4.2 1.5 7 3.3 8.8.8-8.6 6.7-30.7 22-40.6 12.8-8.3 32.9-27 40.3-48.5a17.2 17.2 0 0 0-7.9-9.2c-7.4 20.2-27.1 29.9-42.6 43z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#316d3a",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M446.5 199.7a50.3 50.3 0 0 1-20.9 16.8 11 11 0 0 0 2.5-6.8 76.9 76.9 0 0 1-40.4.5 55 55 0 0 0 54.6-16.2 21 21 0 0 1 4.2 5.7z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M365.4 247c-17.2 16-5.8 30.2 1 33.3-1.9 11.3 8.7 10 8.5 19.4 4.3-2.4 5.4-9 4.7-14.2 5.5 5.9 19.2-.7 22.1 10.2 1.9-12-7.4-24-18.9-22.8 4.8-4.3 2-11.3-2.5-13.1-.9 8.8-10.8 8.8-14.6 6-3.9-2.6-7-11.4-.3-18.9z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M402.7 349.6c-1.8 1-1.7 3.5-.5 5 2.3 3.2-1.7 10.4 6 11.9 2.2.5 4-1 4.8-3.5 2.4-7.1-5.2-7.9-5.9-11.3-.6-3.4-2.8-3-4.4-2.1z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M409.2 362.9c-2.5 1.2-4.8 2.8-3.7 11 .4 3.3.2 11.4-2.8 11.5 1.8 1 5.7 2 7.3-.2 1.5 2.6 5 1.8 6.3-1.3 1.8 1.4 4.3-1 4.3-3.2 1.5 1 4.7-.4 3.9-5.3 2 .7 4.4-.7 5.3-1.9-2.8-.6-10-4.4-11.6-7.4-1.7-3.1-6-4.6-9-3.2z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M370 134.7c1.2-1.6 2.5-3.2 4-4.6m39 34.5c2-1.1 5-1.3 8.4-1M410 385.2c-.8-1.1-1.1-5.8-.6-8.7m6.9 7.4c-1.3-1-3.6-4.3-4-7.1m8.3 3.9a19 19 0 0 1-6.3-8.9m10.2 3.6c-1.9-.4-7.6-4.1-10-8"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M528.5 247.2c27.7 23.2 29.5 41.7 25.3 52.5-2.3-10.1-13.8-25.9-25.8-30z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M478.9 234h51.4v61c0 51.9-28.8 82.5-58.2 98.8A108.3 108.3 0 0 1 414 295v-61h36c0 3.2.4 8 4 12.7 8.6-.8 18.2-7.2 24.9-12.6z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#006ec7",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M530.3 234v61c0 15.6-2.6 29.4-7 41.3L472 242.6l-51 93.7c-4.5-12-7.1-25.7-7.1-41.3v-61z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      d: "M524.8 331.9a116 116 0 0 1-3.8 10L472 251l-48.7 91c-1.3-2.8-2.9-7.3-3.8-10l52.7-97.6z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m495.3 365.3 5 2.3a36 36 0 0 0 2.2-19.8c-2.9 7.4-12.8 7.2-15.5 11.7 1.6.8 3.2 2 4.5 2.9-3.4 3.4-11.3 9-15.8 10.4v-48.4c0-3.4-1.2-6.2-1.2-9v-10c0-2.3-.4-5.6-2.4-5.6s-2.5 3.3-2.5 5.6v10c0 2.8-1.1 6-1.1 9v48.4c-2.5-7.2-12.2-4.8-16.7-12a14 14 0 0 1 5.4-.2c-3.4-11.5-12.7-12.4-14.4-15.8 0 4.8-2 15.8 1.1 20.6.7-.9 1.8-1.8 3-2.5 3.9 8.3 21.1 8.3 25.2 22.1 3.3-5 15-11 23.2-19.7z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M472.1 325c3.8 0 16-1.2 20.4-1.2 1.2 0 2.1-1.8 2.1-3.9 0-2-.9-3.8-2-3.8-4.5 0-16.6-1.2-20.5-1.2-3.8 0-16 1.2-20.4 1.2-1.2 0-2.1 1.7-2.1 3.8 0 2.1 1 3.9 2 3.9 4.5 0 16.7 1.2 20.5 1.2zm-2.5-19.8c-.8-.7-1.8-1-3-1-2.6 0-4.7 1.8-4.7 4.1 0 2.4 2.1 4.3 4.7 4.3 2.5 0 4.6-2 4.6-4.3 0-1.8 2.6-1.8 2.6 0 0 3.7-3.2 6.7-7.2 6.7s-7.3-3-7.3-6.7c0-3.6 3.3-6.6 7.3-6.6a8 8 0 0 1 3.3.8c0 .6-.3 1.7-.3 2.7z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M451.7 323.8c1.1 0 2-1.8 2-3.9 0-2-.9-3.8-2-3.8"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M453.4 323.8c1.1 0 2-1.8 2-3.9 0-2-.9-3.8-2-3.8m11.1 8.4c1.4 0 2.5-2 2.5-4.6 0-2.5-1-4.6-2.5-4.6m2.6 9.4c1.5 0 2.6-2.1 2.6-4.8 0-2.7-1.1-4.8-2.6-4.8m8.7 9.7c1.5 0 2.6-2.2 2.6-4.9s-1.2-4.9-2.6-4.9m2.7 9.6c1.4 0 2.6-2 2.6-4.7 0-2.6-1.2-4.7-2.6-4.7m12.1 8.6c1.2 0 2.1-1.7 2.1-3.9s-.9-4-2-4m-43.7 47c1.3-.9 3-1.6 4.8-2m41.1 2.4-1.4-1m3.8 3c3.2-3.4 5.8-7.3 7.3-11.7"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M461.8 277.2c0-1.2.9-1.6 2-2.4 1.2-1 1.7-1.4 2.9-1.4h14.8c1 0 1.3.3 1.3 1.3v20c0 1-.2 1.4-1.3 1.4h-19.7v-19.2"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#e5e5e5",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M477.8 297.8c2 0 1.6 0 3-1.4s1.3-1.3 1.3-2.6v-18.4c0-1-.3-1.2-1.3-1.2h-13.7c-1 0-1.5.4-2.7 1.3-1 .8-1.8 1.2-1.8 2.2v20.1z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M479.3 297.4c0 1-.3 1.3-1.4 1.3h-14.8c-1.1 0-1.3-.3-1.3-1.3v-20.1c0-1 .2-1.3 1.3-1.3h14.8c1.1 0 1.4.3 1.4 1.3z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M508 222.3c2.8 3.2 3.8 7.5 2.2 11.8H506c1.8-5.5.7-10.6-7-11.3-11.4-1-24.8 21.2-44.9 23.9-5.8-7-5.5-20.3 2-26.6a82 82 0 0 0-17.7-28.6 55 55 0 0 0-10.7-.7c3-6.4 11.3-13 18.1-15.7a82 82 0 0 1 3.4-4.5c.7-8.7 42-4.7 50.7.7 0 9.8 3.9 42.2 8.2 51z"
    }),
    /* @__PURE__ */ jsx199("path", {
      d: "M458 228.2c-1-15-7.1-27.4-15.7-35.8a23.5 23.5 0 0 0 18-3c7.5-5 27-13.6 34-9.9.6 1.3 1 4 .5 5.9-1.7-4.5-20.4 2.4-25.7 4.6-5 2.3-7.3 5.5-5.5 12.6-3-2.5-2-4.8-5-6.6 1.2 2.9 2.2 8.2 2.6 12.5-1.2-3-3.2-9.6-7.6-13.5a74.2 74.2 0 0 1 5.6 34.8c3 0 9.8-3 12.4-5-2.3 3.3-9.2 5.7-13.5 6.6a22 22 0 0 0-3.3 11.8c-.3-4.2 1-14.3 3.1-15zm50-5.9c-3.8-4.2-10.7-6.4-19.6-4a28 28 0 0 1 6.8-2.3c-.3-2.3-2.4-12.5-2.8-15l2.5-1c1.3 6.1 2.8 13.1 3.8 16 .8.1 2.6.5 4.2 1.3-.7-2.4-4.5-19.4-4.4-21.2l3.4-1.8a138 138 0 0 0 6 28z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M506 234c1.7-5.3.6-10.5-7-11.2-6-.5-12.4 5.3-20 11.3zm-49.9-48.5a45 45 0 0 1-14.8-1.5c.2-1 .6-2 1.1-3.2a47 47 0 0 0-8.5 6.8c5.4 1.2 16.6 1.7 22.2-2.1z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M456 220c1.2 3.7 2 7.2 2.1 10.3m-12.4-55.2c-2 3-3.8 6.2-4.4 9a47.6 47.6 0 0 0 14.8 1.4"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M438.4 191.5c1.4.3 2.8.5 4 .9 4 1.1 12.3 1.1 18-3 5.6-4 21-16.7 38.3-18"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M433.9 187.6c5.4 1.2 16.6 1.7 22.2-2.1a76.1 76.1 0 0 1 38.4-14.8"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M528.5 247.2c19 13 33 25.7 37 46s11.7 25.7 21.2 20.3c-2.2 11.7-14 13-23.9 4 1 13.6-4.5 29.8-18.5 35.7-.9-8.1 4.5-14.6 3-21.2-.7-3-1-9.7 2.9-12.9-7.5 2.5-19.2-2.2-20.3-13.3 8.6 4 19.6 4.7 23.9-6.1 4.2-10.8 2.4-29.3-25.3-52.5zm23.9-105.6c5.9-15.3 21.2-13.7 26.4-7.2 15.1-8.6 17.2 10.8 30 7-.2 3.6-4.5 7-9.2 6.7 5 4.5-2 11.3 8.5 15.4-9 4.5-21.6-.2-25-12.7-3 5.9-13.5 5.9-17.8 1.2 9.2-2.5 8.6-11 3.4-14.5-5.3-3.4-14.5-2-16.3 4.1zm-45.7 33.8a82.2 82.2 0 0 0 22.3 34.8c10.8 10 27.1 7.4 36.3-2 .2 18.8-19.4 20.3-30.2 14.4-4.8-2.6-8.7-1.3-4.1 3 7 6.2 22.3 11 40.4 14.8 31.5 6.8 20.3 31.8 11 31.6 2.7 0 4.9-2.9 1-6.3-27.4-24.7-83-15-82.2-70-5.8 14.5-30 8.8-18.7-8.3 3.6 2.9 10 3.1 11.7-1.4 1.4-3.5.5-9.6-5.8-14.9 1 0 3.3 0 3-2.6.3 1.6 1.7 3.8 5.3 3 1 1.7 2 2.7 3.5 2.1.3 0 1.1-.5.8-2.1.2 3 3.8 4.1 5.7 3.9z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M535 222.6c13.1 8.5 28 8.5 41.5-7.2 4.3-5 11-9.3 15.8-9.7 4.8-.5 4.5-5 8.1-6-2.2-.6-3.1-3.3-6.5-3 8.5-2.9 6-9.7 10.1-13-3.4 1.3-8.6-3.7-13.5 2.7 1.3-3-.5-6.4-1.7-7.8.5 3.4-6.6 4-8 12.6-.7 4.8-3.4 4.6-3.8-2.9-.3-5.4-3-20.5-6-28.2-3.2-7.6-4-18.2.3-19.7a7.7 7.7 0 0 0-2.6-2.8c-5.3-3.4-14.5-2-16.3 4-5.8 15.4 10.6 24.2 9.3 40.9-2.5-12.4-22.6-15.6-22.4-27.8-6.5 3-5.6 8.4-3.1 12.7-4-6.3-13.3 4-21.2-4.5-1 11.3 9 15.5 17.1 16-4 7.2 1.4 13.3 6.8 15.3.2-12.6 26.1-7.5 26.4 14.2.2 18.5-19.7 20-30.3 14.2zm36.4 17.8c31.5 6.8 20.3 31.8 11 31.6-5.9-.2-11.5-5.1-11.8-9.4-6.8 3.6-5 10.7.2 13.5-14.2-1.6-20.2 7.7-20.5 18 2.6-4.8 10.4-5 13.4-4s10.5 1.5 13.5-2c-2.5 2.2 1.6 7.2-2 11 12-.4 17.1-11.5 15-16.3 15.4-14 12.5-36.8-18.8-42.4zm-24.1 107.2c2 1.2 1.8 4 .4 5.7-2.8 3.4 1.4 11.5-7.2 13-2.5.3-4.4-1.3-5.2-4.2-2.4-8 6.1-8.6 7-12.3 1-3.8 3.3-3.3 5-2.2z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M539.6 362.1c2.7 1.4 5.1 3.4 3.7 12.4-.7 3.7-.8 12.8 2.5 13-2 1-6.4 1.9-8-.5-1.9 2.8-5.7 1.8-7-1.8-2.2 1.6-4.8-1.3-4.7-3.7-1.8 1-5.3-.7-4.2-6-2.2.6-4.9-1-5.8-2.4 3.1-.6 11.2-4.5 13.3-7.8 2-3.4 7-4.8 10.2-3.2z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M537.7 387c1-1.2 1.5-6.5 1-9.7m-8 7.9c1.5-1 4.2-4.5 4.8-7.7m-9.5 4a22 22 0 0 0 7.4-9.7m-11.5 3.7c2-.4 8.6-4.3 11.4-8.6"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M501.2 195.8c-.4 23 9.2 34.8 22.6 42.4-5-3-2.8-13.1-9.5-16.4 1.6-.1 4 2.1 8 1.2-2-4.2-5-10.8-12.4-11.7 2-.2 6 .5 8.8-.5-3.8-6-14-3.1-17.5-15zm-2.4-22c-.8-.3-1.5-1.1-2.1-2.2-3.6.8-5-1.5-5.3-3 .3 2.6-2 2.5-3 2.6 6.3 5.2 7.2 11.3 5.8 14.8-1.8 4.5-8 4.3-11.7 1.4-.5 9.6 12 12.7 16.5.7 0 2 2.6 1.8 3.2 4.5 3.2-5.2.8-12.7-3.4-18.8z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M479 128a27 27 0 0 1-8-18.9c.2-5 2.2-10.3 9.5-8-2.3 0-.7 4.4-3 4.9 1.8.7 4.4-.9 4.8-2 .4 1.6 3.4 1.2 3.6 3 1.1-.9-.1-5.3-1.8-6.2 1.2-.7 2-4.2 1.4-5.9-1.2.2-2.9 1.8-3.2 4.1.6-1.8-.1-6.3-3.3-7-.9 1.2-1.1 4.3.1 6-2.9-.7-7.2 1.2-8.2 3.7.2-3 .6-7.3 2.5-10 .6-.8-1-2.4-2.1-.3-2.2-4.3-8-6.5-10.7-4.4-2.6 2.2-6-1-8.2 2.4-2.1 3.4-9.4 3.7-9 7.3.2 2.2-.3 5.5-1.4 6.7-2.6 2.9 1.3 5 2 7.6-.5-8.5 13.1-25.2 26.8-18.7a30.2 30.2 0 0 0-2.7 11.6c-.6 7.7.6 18.5 8 24.9z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#c8102e",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M483 101.1c0-2 3.5-4.7 8.2-4.6 5.7 0 10 5.2 14.6 4.7s2.4 2 1.4 2.8c-1 .6-1.5 1.6-1.2 2.9.3 1.2-.2 2-2 .9-4.1-2.6-8.2 1-13.6-1-4.5-1.7-7.2-2.7-7.4-5.7z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M459.8 154.4a34.3 34.3 0 0 0-15-16.7l-.2-3.8a50 50 0 0 0 10.1-7.6c17 8 40-3.4 50.6-15.3l4 2.4-2 2.7-2.1-1.1a129.6 129.6 0 0 1-15.2 14.2c3.9 1 9.3 1.7 10.8 1.6 9.4-6.8 16.9-12.9 20.5-13.3l3 4-2.7 2-2.1-1.3a108.7 108.7 0 0 0-26.2 38.8c-6.3-1.4-28.9-.5-33.5-6.6z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M490 129.2c-1.5-.4-2.8-.8-3.5-1.2a22.7 22.7 0 0 1-12.1 3.4"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M460.7 151.9c-1.5-8.4 1-17.8 5.2-20.6a33.6 33.6 0 0 0 34.8-.5"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M460.7 147.5c7.2-.2 23 1 26.7 1.5 3.9.6 10.3 2.2 9.4 4.1m-32.8-6.8 2.1-2-2-2.1-2.1 2z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M469 104.3c-2.6-3.6-9.8-4.8-11.3 0-.7 2.2-1.7 4.5-3.4 5.5s-1.3 4.1-.6 5.4c1.8 3.3.2 6.5 3.7 8.6 0-2.6 3.9-5.3 7.1-6 3.3-.6 8.3-3.6 9-6.8.6-3.4 1.8-6-4.5-6.7z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M452.7 136.8h1v6.1l.5.3 5.3-3 .5.7-5.4 3.1v.6l5.4 3-.5.8-5.4-3c-.1.1-.3.3-.5.3v6.2h-.9v-6.2a2 2 0 0 1-.5-.3l-5.3 3.1-.5-.8 5.3-3v-.7l-5.3-3 .5-.8 5.3 3 .5-.3z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M460.7 151.8a10.7 10.7 0 1 1 .9-14 24 24 0 0 0-1.2 5.7 7.3 7.3 0 1 0-7.3 8c3.4 0 6.3-2.3 7.2-5.4 0 1.4 0 4.6.4 5.7z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M448.6 162c-.6-.8-1.9-3-1.7-4.5a6 6 0 0 1 3.8 1.5c-.1-1.2-.6-3.6-.3-4.8 1.2.5 3.8 2 4.7 3.6-.2-1.1-.7-4-.2-5.8 1.3.8 3.6 2.9 4 4.4.2-2.3 1-6 1.6-7 1 1 2.6 2 3.6 3.4.2-1.9 1.2-4 2.5-4.5 1 1 2.6 3.7 3 6.6 1-.3 2.3-2 2.9-3 .5 1 1.1 2.5.7 4.5 1.3-1.2 2.8-2.7 3-4.1 1 .7 2.7 2.4 3.1 4.2-.2-1.5 0-4.1-.5-5.6 1.6 1 3 2.5 3.3 4.2.5-1.6 1.5-4.4 2.4-5 .9 1.8 1.8 4 1.7 5.7.6-1.1 1.4-3.2 2.3-3.6.8 1.2.7 4 .5 5.4.8-1.1 2.3-2.5 3.2-3 0 .8.2 2.1 0 3.1a14 14 0 0 0 3.2-5.2c1.6.8 3.2 3.5 3.3 4.9 1.2-.5 3.4-2.5 4-3.6 0 .8.4 3 0 4.6.7-.7 1.3-2 1.7-2.6.4 1.1 0 3.8-.4 5.3a6 6 0 0 1 3.4-1.5 20 20 0 0 1-2.5 7.8c-10.8-3-33.5-4.1-56.3-5.4z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      d: "M486.4 102.3c0-.9 1.8-2.7 5.1-2.7 4 0 7.7 3 10.9 2.7 3.2-.2 1.6.9 1 1.1-.8.3-1.1.7-1 1.2.3.6 0 .9-1.4.4-2.8-1-5.7.4-9.4-.4-3.2-.7-5.1-1-5.2-2.3"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M452.1 168.8c-3.3 4-6.7 3.4-7.4.8-.7-2.6 1.8-3.8.9-6.1s1.5-3.3 2.6-2.3 4.8-2.2 6.3 1.2c1.6 3.4 2.8 5.7 2 7-1 1.4-3.7.7-4.4-.6zm14.6-6.1c-.6-1.5 2.9-4.4 4.7-2.3 1.8 2 4.6-2.2 6.2 1 1.6 3.2 2 4.9 2.9 6.7.7 1.8-4.3 2.7-5.9 1.2.2 1-4.4 1.9-5.6-1.2zm23.4 1.9c-.8-1.6 3.3-3.9 5.5-1 .5-1.2 4.6-1.4 4.9 2l.5 6.9c.1 1.3-2.5 2.6-4.3-.9-3.4.7-4.9-1.2-5.3-3.1-.4-2-.8-3-1.3-4z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M454.3 162.3c-.5-1.1 3-3.4 5.2-1.7 2.3 1.7 5.5-1.4 7 1.6 2.7 6.2 2.8 6.6 2 7.8-.8 1.2-4.5.7-5.4-1-.1 1.2-3.3 1-4.9.1-1.8-1-3.1-4.8-3.9-6.8zm23.7.3c-.7-1.8 4.6-3.3 7-.2 1.1-1.1 3.7-1.2 5.1 2.2 1.5 3.3 1.7 5.1.7 6-.8.6-3.5 1-4.4-.5-1.3.8-5.1.1-6-2-.8-2.1-1.5-4-2.3-5.5zm22.5 3.4c0-1.7 2.8-2.4 3.9 0 1 2.2 4.5.1 4.8 4 0 .7-.4 3.5-1.5 4.9-1 1.3-6.3 0-6.7-2.9z"
    }),
    /* @__PURE__ */ jsx199("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M452.1 168.8c-1.2-1.7-2.9-4.4-5-1.5m16.1 1.7c-.8-.9-1.7-2.5-2-3.7m13.4 4c-.8-.6-2-1.7-2.6-2.9m1.6-3c2 .2 3.3 2 3.9 2.9.6.8 2 2.4 3 2.5m5.9 1.3c-.7-1-1.4-2-1.5-2.8m.1-4.9c.6 1 1.1 1.7 1.5 2.6m10.1 6.6a9.3 9.3 0 0 0-3.5-3.9m3.1-2.3c.1 3.3 4.5 3.6 4.7 6m3.5-5.4c.4.8.6 1.6.6 3"
    })
  ]
});
var Pn_default = SvgPn;

// src/country-flag-icons/generated/Pr.tsx
import { jsx as jsx200, jsxs as jsxs193 } from "react/jsx-runtime";
var SvgPr = (props) => /* @__PURE__ */ jsxs193("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx200("defs", {
      children: /* @__PURE__ */ jsx200("clipPath", {
        id: "pr_svg__a",
        children: /* @__PURE__ */ jsx200("path", {
          fillOpacity: 0.7,
          d: "M-37.3 0h682.7v512H-37.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs193("g", {
      fillRule: "evenodd",
      clipPath: "url(#pr_svg__a)",
      transform: "translate(35) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx200("path", {
          fill: "#ed0000",
          d: "M-37.3 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx200("path", {
          fill: "#fff",
          d: "M-37.3 102.4h768v102.4h-768zm0 204.8h768v102.4h-768z"
        }),
        /* @__PURE__ */ jsx200("path", {
          fill: "#0050f0",
          d: "m-37.3 0 440.7 255.7L-37.3 511z"
        }),
        /* @__PURE__ */ jsx200("path", {
          fill: "#fff",
          d: "M156.4 325.5 109 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3z"
        })
      ]
    })
  ]
});
var Pr_default = SvgPr;

// src/country-flag-icons/generated/Ps.tsx
import { jsx as jsx201, jsxs as jsxs194 } from "react/jsx-runtime";
var SvgPs = (props) => /* @__PURE__ */ jsxs194("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx201("defs", {
      children: /* @__PURE__ */ jsx201("clipPath", {
        id: "ps_svg__a",
        children: /* @__PURE__ */ jsx201("path", {
          fillOpacity: 0.7,
          d: "M-118 0h682.7v512H-118z"
        })
      })
    }),
    /* @__PURE__ */ jsx201("g", {
      clipPath: "url(#ps_svg__a)",
      transform: "translate(110.6) scale(.9375)",
      children: /* @__PURE__ */ jsxs194("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx201("path", {
            fill: "#000001",
            d: "M-246 0H778v170.7H-246z"
          }),
          /* @__PURE__ */ jsx201("path", {
            fill: "#fff",
            d: "M-246 170.7H778v170.6H-246z"
          }),
          /* @__PURE__ */ jsx201("path", {
            fill: "#090",
            d: "M-246 341.3H778V512H-246z"
          }),
          /* @__PURE__ */ jsx201("path", {
            fill: "red",
            d: "m-246 512 512-256L-246 0z"
          })
        ]
      })
    })
  ]
});
var Ps_default = SvgPs;

// src/country-flag-icons/generated/Pt.tsx
import { jsx as jsx202, jsxs as jsxs195 } from "react/jsx-runtime";
var SvgPt = (props) => /* @__PURE__ */ jsxs195("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx202("path", {
      fill: "red",
      d: "M256 0h384v480H256z"
    }),
    /* @__PURE__ */ jsx202("path", {
      fill: "#060",
      d: "M0 0h256v480H0z"
    }),
    /* @__PURE__ */ jsxs195("g", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      children: [
        /* @__PURE__ */ jsx202("path", {
          d: "M339.5 306.2c-32.3-1-180-93.2-181-108l8.1-13.5c14.7 21.3 165.7 111 180.6 107.8z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M164.9 182.8c-2.9 7.8 38.6 33.4 88.4 63.8 49.9 30.3 92.9 49 96 46.4l1.5-2.8c-.6 1-2 1.3-4.3.6-13.5-3.9-48.6-20-92.1-46.4-43.6-26.4-81.4-50.7-87.3-61a6.3 6.3 0 0 1-.6-3.1h-.2l-1.2 2.2zm175.3 123.8c-.5 1-1.6 1-3.5.8-12-1.3-48.6-19.1-91.9-45-50.4-30.2-92-57.6-87.4-64.8l1.2-2.2.2.1c-4 12.2 82.1 61.4 87.2 64.6 49.8 30.8 91.8 48.9 95.5 44.2z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M256.2 207.2c32.2-.3 72-4.4 95-13.6l-5-8c-13.5 7.5-53.5 12.5-90.3 13.2-43.4-.4-74.1-4.5-89.5-14.8l-4.6 8.6c28.2 12 57.2 14.5 94.4 14.6"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M352.5 193.8c-.8 1.3-15.8 6.4-37.8 10.2a381.2 381.2 0 0 1-58.6 4.3 416.1 416.1 0 0 1-56.2-3.6c-23.1-3.6-35-8.6-39.5-10.4l1.1-2.2c12.7 5 24.7 8 38.7 10.2A411.5 411.5 0 0 0 256 206a391.8 391.8 0 0 0 58.3-4.3c22.5-3.7 34.8-8.4 36.6-10.5zm-4.4-8.1c-2.4 2-14.6 6.3-36 9.7a388.2 388.2 0 0 1-55.8 4c-22 0-40.1-1.6-53.8-3.6-21.8-2.8-33.4-8-37.6-9.4l1.3-2.2c3.3 1.7 14.4 6.2 36.5 9.3a385 385 0 0 0 53.6 3.4 384 384 0 0 0 55.4-4c21.5-3 33.1-8.4 34.9-9.8zM150.3 246c19.8 10.7 63.9 16 105.6 16.4 38 .1 87.4-5.8 105.9-15.6l-.5-10.7c-5.8 9-58.8 17.7-105.8 17.4-47-.4-90.7-7.6-105.3-17v9.5"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M362.8 244.5v2.5c-2.8 3.4-20.2 8.4-42 12a434 434 0 0 1-65.4 4.4 400 400 0 0 1-62-4.3 155 155 0 0 1-44.4-12v-2.9c9.7 6.4 35.9 11.2 44.7 12.6 15.8 2.4 36.1 4.2 61.7 4.2 26.9 0 48.4-1.9 65-4.4 15.7-2.3 38-8.2 42.4-12.1m0-9v2.5c-2.8 3.3-20.2 8.3-42 11.9a434 434 0 0 1-65.4 4.5 414 414 0 0 1-62-4.3 155 155 0 0 1-44.4-12v-3c9.7 6.5 36 11.2 44.7 12.6a408 408 0 0 0 61.7 4.3c26.9 0 48.5-2 65-4.5 15.7-2.2 38-8.1 42.4-12m-107 68.8c-45.6-.2-84.7-12.4-93-14.4l6 9.4a249.8 249.8 0 0 0 87.4 14.3c34.7-1 65-3.7 86.3-14.1l6.2-9.8c-14.5 6.9-64 14.6-93 14.6"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M344.9 297.3a143 143 0 0 1-2.8 4c-10 3.6-26 7.4-32.6 8.4a295.5 295.5 0 0 1-53.7 5c-40.4-.6-73.5-8.5-89-15.3l-1.3-2.1.2-.4 2.1.9a286.5 286.5 0 0 0 88.2 14.5c18.8 0 37.5-2.1 52.6-4.8 23.2-4.7 32.6-8.2 35.5-9.8l.7-.4zm5.3-8.8a287.2 287.2 0 0 1-2 3.5c-5.4 2-20 6.2-41.3 9.2-14 1.9-22.7 3.8-50.6 4.3a347.4 347.4 0 0 1-94.2-14L161 289a390 390 0 0 0 95.4 14c25.5-.5 36.4-2.4 50.3-4.3 24.8-3.8 37.3-8 41-9.1a2.9 2.9 0 0 0 0-.2l2.6-1z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M350.8 237.6c.1 30-15.3 57-27.6 68.8a99.3 99.3 0 0 1-67.8 28.2c-30.3.5-58.8-19.2-66.5-27.9a101 101 0 0 1-27.5-67.4c1.8-32.8 14.7-55.6 33.3-71.3a99.6 99.6 0 0 1 64.2-22.7 98.2 98.2 0 0 1 71 35.6c12.5 15.2 18 31.7 20.9 56.7M255.6 135a106 106 0 0 1 106 105.2 105.6 105.6 0 1 1-211.4 0c-.1-58 47.3-105.2 105.4-105.2"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M255.9 134.5c58.2 0 105.6 47.4 105.6 105.6S314.1 345.7 256 345.7s-105.6-47.4-105.6-105.6c0-58.2 47.4-105.6 105.6-105.6zM152.6 240c0 56.8 46.7 103.3 103.3 103.3 56.6 0 103.3-46.5 103.3-103.3s-46.7-103.3-103.3-103.3S152.6 183.2 152.6 240"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M256 143.3a97 97 0 0 1 96.7 96.7 97.1 97.1 0 0 1-96.7 96.8c-53 0-96.7-43.6-96.7-96.8a97.1 97.1 0 0 1 96.7-96.7M161.6 240c0 52 42.6 94.4 94.4 94.4s94.4-42.5 94.4-94.4c0-52-42.6-94.4-94.4-94.4a94.8 94.8 0 0 0-94.4 94.4"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M260.3 134h-9.1v212.3h9z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M259.3 132.8h2.3v214.7h-2.2V132.8zm-9 0h2.4v214.7h-2.3z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M361.6 244.2v-7.8l-6.4-6-36.3-9.6-52.2-5.3-63 3.2-44.8 10.6-9 6.7v7.9l22.9-10.3 54.4-8.5h52.3l38.4 4.2 26.6 6.4z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M256 223.8c24.9 0 49 2.3 68.3 6 19.8 4 33.7 9 38.5 14.5v2.8c-5.8-7-24.5-12-39-15-19-3.6-43-6-67.9-6-26.1 0-50.5 2.6-69.3 6.2-15 3-35.1 9-37.6 14.8v-2.9c1.3-4 16.3-10 37.3-14.3 18.9-3.7 43.3-6.1 69.6-6.1zm0-9.1a383 383 0 0 1 68.3 6c19.8 4 33.7 9 38.5 14.6v2.7c-5.8-6.9-24.5-12-39-14.9-19-3.7-43-6-67.9-6a376 376 0 0 0-69.2 6.2c-14.5 2.7-35.4 8.9-37.7 14.7v-2.8c1.4-4 16.6-10.3 37.3-14.3 19-3.7 43.3-6.2 69.7-6.2m-.6-46.2c39.3-.2 73.6 5.5 89.3 13.5l5.7 10c-13.6-7.4-50.6-15-94.9-14-36.1.3-74.7 4-94 14.4l6.8-11.4c15.9-8.3 53.3-12.5 87.1-12.5"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M256 176.7a354 354 0 0 1 61.3 4.3c16 3 31.3 7.4 33.5 9.8l1.7 3c-5.3-3.4-18.6-7.3-35.6-10.5s-38.7-4.3-61-4.2c-25.3-.1-45 1.2-61.8 4.2a108.9 108.9 0 0 0-33.3 10.3l1.7-3.1c6-3 15.3-6.7 31.1-9.6 17.5-3.2 37.4-4.1 62.4-4.2m0-9c21.4-.2 42.6 1 59.1 4a96 96 0 0 1 30.6 10l2.5 4c-4.2-4.7-20-9.2-34.1-11.6-16.4-2.9-36.7-4-58.1-4.2a361 361 0 0 0-59.5 4.4 97.3 97.3 0 0 0-29.6 9.1l2.2-3.3c5.8-3 15.2-5.8 27-8.1a357 357 0 0 1 59.9-4.4zM308.4 284a276.4 276.4 0 0 0-52.5-4c-65.5.8-86.6 13.5-89.2 17.3l-5-8c16.8-12 52.4-18.8 94.6-18.2 21.9.4 40.8 1.9 56.6 5l-4.5 8"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M255.6 278.9c18.2.3 36 1 53.3 4.2l-1.2 2.2c-16-3-33.2-4-52-4-24.3-.2-48.7 2.1-70 8.2-6.7 1.9-17.8 6.2-19 9.8l-1.2-2c.4-2.2 7-6.6 19.6-10 24.4-7 47.2-8.3 70.5-8.4m.8-9.2a327 327 0 0 1 57.3 5l-1.3 2.3a299 299 0 0 0-56-4.9c-24.2 0-49.9 1.8-73.3 8.6-7.5 2.2-20.6 7-21 10.7l-1.2-2.2c.2-3.4 11.5-7.9 21.7-10.8 23.5-6.9 49.3-8.6 73.8-8.7"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "m349.4 290.5-7.8 12.3-22.7-20.1-58.6-39.5-66.2-36.3-34.3-11.7 7.3-13.6 2.5-1.3 21.3 5.3 70.4 36.3 40.6 25.6L336 272l13.9 16z"
        }),
        /* @__PURE__ */ jsx202("path", {
          d: "M158.6 195.5c6-4 50.2 15.6 96.6 43.6 46.1 28 90.3 59.6 86.3 65.5l-1.3 2.1-.6.5c.1-.1.8-1 0-3.1-2-6.5-33.4-31.5-85.3-62.9-50.7-30.1-92.9-48.3-97-43.1zM351 290.4c3.8-7.6-37.2-38.5-88.1-68.6-52-29.5-89.6-46.9-96.5-41.7L165 183c0 .1 0-.2.4-.5 1.2-1 3.3-1 4.2-1 11.8.2 45.5 15.7 92.8 42.8 20.8 12 87.6 55 87.3 67 0 1 .1 1.2-.3 1.8l1.7-2.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs195("g", {
      transform: "translate(0 26.7) scale(1.06667)",
      children: [
        /* @__PURE__ */ jsx202("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M180.6 211a58.7 58.7 0 0 0 17.5 41.7 59 59 0 0 0 41.8 17.6 59.4 59.4 0 0 0 42-17.4 59 59 0 0 0 17.4-41.8v-79.2l-118.7-.2z"
        }),
        /* @__PURE__ */ jsx202("path", {
          fill: "red",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M183 211.1a56.4 56.4 0 0 0 16.8 40 57 57 0 0 0 40.2 16.8 56.9 56.9 0 0 0 40.2-16.6 56.4 56.4 0 0 0 16.7-40v-77H183v76.8m91-53.7v48.9l-.1 5.1a33.2 33.2 0 0 1-10 24 34 34 0 0 1-24 10c-9.4 0-17.7-4-23.9-10.2a34 34 0 0 1-10-24v-54z"
        }),
        /* @__PURE__ */ jsxs195("g", {
          id: "pt_svg__e",
          children: [
            /* @__PURE__ */ jsxs195("g", {
              id: "pt_svg__d",
              fill: "#ff0",
              stroke: "#000",
              strokeWidth: 0.5,
              children: [
                /* @__PURE__ */ jsx202("path", {
                  stroke: "none",
                  d: "M190.2 154.4c.1-5.5 4-6.8 4-6.8.1 0 4.3 1.4 4.3 6.9z"
                }),
                /* @__PURE__ */ jsx202("path", {
                  d: "m186.8 147.7-.7 6.3h4.2c0-5.2 4-6 4-6 .1 0 4 1.1 4.1 6h4.2l-.8-6.4zm-1 6.4h17c.3 0 .6.3.6.7 0 .5-.3.8-.6.8h-17c-.3 0-.6-.3-.6-.8 0-.4.3-.7.7-.7z"
                }),
                /* @__PURE__ */ jsx202("path", {
                  d: "M192 154c0-3.3 2.3-4.2 2.3-4.2s2.3 1 2.3 4.2H192m-5.8-9h16.3c.3 0 .6.4.6.8 0 .3-.3.6-.6.6h-16.3c-.3 0-.6-.3-.6-.7 0-.3.3-.6.6-.6zm.4 1.5H202c.3 0 .6.3.6.7 0 .4-.3.7-.6.7h-15.5c-.4 0-.6-.3-.6-.7 0-.4.2-.7.6-.7zm5-10.6h1.2v.8h.9v-.8h1.3v.9h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.4c-.3 0-.6-.2-.6-.5zm4.6 2.7.3 6.4h-4.3l.3-6.5h3.7"
                }),
                /* @__PURE__ */ jsx202("path", {
                  id: "pt_svg__a",
                  d: "M191 141.6v3.4h-4v-3.4z"
                }),
                /* @__PURE__ */ jsx202("use", {
                  xlinkHref: "#pt_svg__a",
                  width: "100%",
                  height: "100%",
                  x: 10.6
                }),
                /* @__PURE__ */ jsx202("path", {
                  id: "pt_svg__b",
                  d: "M186.3 139h1.2v1h.9v-1h1.2v1h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.3a.6.6 0 0 1-.6-.6z"
                }),
                /* @__PURE__ */ jsx202("use", {
                  xlinkHref: "#pt_svg__b",
                  width: "100%",
                  height: "100%",
                  x: 10.6
                }),
                /* @__PURE__ */ jsx202("path", {
                  fill: "#000001",
                  stroke: "none",
                  d: "M193.9 140.6c0-.6.9-.6.9 0v1.6h-.9z"
                }),
                /* @__PURE__ */ jsx202("path", {
                  id: "pt_svg__c",
                  fill: "#000001",
                  stroke: "none",
                  d: "M188.6 142.8c0-.6.8-.6.8 0v1.2h-.8z"
                }),
                /* @__PURE__ */ jsx202("use", {
                  xlinkHref: "#pt_svg__c",
                  width: "100%",
                  height: "100%",
                  x: 10.6
                })
              ]
            }),
            /* @__PURE__ */ jsx202("use", {
              xlinkHref: "#pt_svg__d",
              width: "100%",
              height: "100%",
              y: 46.3
            }),
            /* @__PURE__ */ jsx202("use", {
              xlinkHref: "#pt_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(-45.2 312.8 180)"
            })
          ]
        }),
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#pt_svg__d",
          width: "100%",
          height: "100%",
          x: 45.7
        }),
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#pt_svg__e",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 479.8 0)"
        }),
        /* @__PURE__ */ jsxs195("g", {
          id: "pt_svg__f",
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx202("path", {
              fill: "#039",
              d: "M232.6 202.4a8.3 8.3 0 0 0 2.2 5.7 7.2 7.2 0 0 0 5.3 2.4c2.1 0 4-1 5.3-2.4a8.3 8.3 0 0 0 2.2-5.7v-10.8h-15z"
            }),
            /* @__PURE__ */ jsx202("circle", {
              cx: 236.1,
              cy: 195.7,
              r: 1.5
            }),
            /* @__PURE__ */ jsx202("circle", {
              cx: 244.4,
              cy: 195.7,
              r: 1.5
            }),
            /* @__PURE__ */ jsx202("circle", {
              cx: 240.2,
              cy: 199.7,
              r: 1.5
            }),
            /* @__PURE__ */ jsx202("circle", {
              cx: 236.1,
              cy: 203.9,
              r: 1.5
            }),
            /* @__PURE__ */ jsx202("circle", {
              cx: 244.4,
              cy: 203.9,
              r: 1.5
            })
          ]
        }),
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          y: -26
        }),
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          x: -20.8
        }),
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          x: 20.8
        }),
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          y: 25.8
        })
      ]
    })
  ]
});
var Pt_default = SvgPt;

// src/country-flag-icons/generated/Pw.tsx
import { jsx as jsx203, jsxs as jsxs196 } from "react/jsx-runtime";
var SvgPw = (props) => /* @__PURE__ */ jsxs196("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx203("defs", {
      children: /* @__PURE__ */ jsx203("clipPath", {
        id: "pw_svg__a",
        children: /* @__PURE__ */ jsx203("path", {
          fillOpacity: 0.7,
          d: "M-70.3 0h640v480h-640z"
        })
      })
    }),
    /* @__PURE__ */ jsxs196("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#pw_svg__a)",
      transform: "translate(70.3)",
      children: [
        /* @__PURE__ */ jsx203("path", {
          fill: "#4aadd6",
          d: "M-173.4 0h846.3v480h-846.3z"
        }),
        /* @__PURE__ */ jsx203("path", {
          fill: "#ffde00",
          d: "M335.6 232.1a135.9 130.1 0 1 1-271.7 0 135.9 130.1 0 1 1 271.7 0"
        })
      ]
    })
  ]
});
var Pw_default = SvgPw;

// src/country-flag-icons/generated/Py.tsx
import { jsx as jsx204, jsxs as jsxs197 } from "react/jsx-runtime";
var SvgPy = (props) => /* @__PURE__ */ jsxs197("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx204("path", {
      fill: "#0038a8",
      d: "M0 319.7h640V480H0z"
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "#d52b1e",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsxs197("g", {
      fill: "none",
      stroke: "#000",
      transform: "translate(-116.4) scale(1.45455)",
      children: [
        /* @__PURE__ */ jsx204("circle", {
          cx: 300,
          cy: 165,
          r: 42.2,
          strokeWidth: 1.1
        }),
        /* @__PURE__ */ jsx204("circle", {
          cx: 300,
          cy: 165,
          r: 34.7,
          strokeWidth: 0.5
        }),
        /* @__PURE__ */ jsx204("circle", {
          cx: 300,
          cy: 165,
          r: 26.6,
          strokeWidth: 0.4
        })
      ]
    }),
    /* @__PURE__ */ jsx204("path", {
      d: "m287.3 263.7-7.1 4.2-2.2-3.7a6.2 6.2 0 0 1-.7-1.6 2 2 0 0 1 .1-1.3c.2-.4.5-.7 1-1 .4-.2.7-.3 1.1-.3a2.3 2.3 0 0 1 1.1.2l.8.6v-1.3l.3-.5 1.5-2.3 1.4 2.5-1.4 2.4-.3.8.1.6.1.2 3-1.7zm-5.5.3-.6-1-.4-.5a.7.7 0 0 0-.5-.2.8.8 0 0 0-.5.1l-.4.6c0 .2.1.5.4.9l.5 1zm-6.7-5.5-2.2-6.5 1.7-.6 1.3 4.1 1.3-.4-1.3-3.8 1.6-.5 1.3 3.7 1.5-.5-1.4-4.2 1.8-.5 2.2 6.6zm-2.9-9.7-.4-4.2c-.2-1 0-1.6.4-2.1.4-.6 1-.9 1.8-1 .8 0 1.5.1 2 .6.5.4.8 1.2 1 2.2l.1 1.4 3-.4.4 2.6zm3.3-3-.1-.6c0-.5-.2-.8-.4-1a.8.8 0 0 0-.7-.2 1 1 0 0 0-.6.4c-.2.1-.2.5-.2 1l.1.7zm-3.5-12.5.3-2.6 4.8.6a4.2 4.2 0 0 1 1.4.4c.4.2.8.4 1 .8.4.3.5.7.6 1 .2.6.2 1.2.1 1.9l-.2 1.3c-.1.5-.3.8-.5 1.1a3 3 0 0 1-1.8 1.3h-1.4l-4.9-.5.3-2.5 5 .5c.4 0 .8 0 1-.2.4-.2.5-.6.6-1a1.4 1.4 0 0 0-.3-1c-.2-.4-.6-.5-1-.6zm1-6 1.7-4.6c.2-.8.6-1.3 1.1-1.5a2 2 0 0 1 1.6-.2c.5.2.8.5 1 .9.2.3.3.6.3 1 .3-.5.7-.8 1.1-1a2 2 0 0 1 1.4 0 2.2 2.2 0 0 1 1.5 1.8v1l-.3 1-1.5 4.2zm4-1.4.4-1.1c0-.4.1-.7 0-.8 0-.2-.2-.4-.4-.5a.7.7 0 0 0-.6 0c-.2.2-.4.4-.5.8l-.4 1zm3 1 .5-1.2c.1-.4.2-.7 0-1a.8.8 0 0 0-.4-.4.7.7 0 0 0-.7 0l-.5.9-.4 1.2zm-3-9.6 1.3-2.2 5.4 3.2 2-3.4 1.8 1-3.4 5.6zm5-7.6 1.6-2 6.4 5.3-1.6 2zm11.1-4.3 2.2-1c.3.6.4 1.2.5 1.7a3.1 3.1 0 0 1-.3 1.5 4.5 4.5 0 0 1-1.2 1.5 4 4 0 0 1-2 1.1 3.5 3.5 0 0 1-2 0 4.7 4.7 0 0 1-2-1.6c-1-1-1.4-2-1.3-3.1a4.2 4.2 0 0 1 1.6-2.9 4.2 4.2 0 0 1 2.3-1c.7-.1 1.5 0 2.3.5l-1.4 1.9a1.9 1.9 0 0 0-.6-.3 1.5 1.5 0 0 0-.7 0 1.5 1.5 0 0 0-.6.4 1.5 1.5 0 0 0-.6 1.4c0 .4.4.9.8 1.4.6.7 1.1 1.1 1.6 1.2.4 0 .8 0 1.2-.4.4-.3.6-.6.6-1s-.1-.8-.4-1.3m8.8-3.2-2.5 1.4.3 1.4-2.3 1.2-1.2-8.7 2.5-1.3 6.6 5.8-2.4 1.3zm-1.3-1.3-2.2-2.2.6 3zm7.8-8.5 3.8-.6a4.6 4.6 0 0 1 1.8 0c.5.1 1 .3 1.3.7s.7.7.9 1.2c.2.4.4 1 .4 1.5.2.9.2 1.6.1 2a3.4 3.4 0 0 1-.6 1.4 2.7 2.7 0 0 1-1 .9 6 6 0 0 1-1.5.5l-3.7.6zm2.9 1.4.8 4.5.6-.1c.5-.1.9-.2 1-.4.3-.1.4-.4.5-.7v-1.4c-.2-.9-.5-1.4-.8-1.7-.3-.3-.8-.4-1.5-.3zm7.8-2.8 6.8.3v1.8l-4.3-.2-.1 1.3 4 .2-.1 1.7-4-.2v1.6l4.4.2-.1 1.9-7-.3zm10 .8 2.4.6-1.5 6 4 1-.6 2-6.3-1.6zm13.2 4.4 3.7 2.2c.8.4 1.3 1 1.4 1.6.2.6 0 1.3-.3 2a2.5 2.5 0 0 1-1.7 1.3c-.6.1-1.4 0-2.3-.6l-1.2-.7-1.6 2.6-2.2-1.3zm.4 4.4.6.3 1 .3a.8.8 0 0 0 .6-.4 1 1 0 0 0 0-.7c0-.3-.2-.5-.6-.8l-.6-.3zm7.2 9.6-2.1-2-1.2.7-2-1.7 8-4 2 2-3.4 8.1-2-1.8zm.8-1.7 1.4-2.8-2.7 1.6zm1 5.5 6.9-4.7 2.3 3.5 1 1.7-.1 1.2a2.3 2.3 0 0 1-1 1.1c-.3.3-.7.4-1 .4a2.3 2.3 0 0 1-1.2-.2c-.2 0-.5-.3-.8-.5l.2.7-.2.6a3.3 3.3 0 0 1-.2.6l-1.3 2.3-1.6-2.3 1.3-2.6.3-.7a1 1 0 0 0-.2-.7l-.1-.2-2.8 2zm5.5-.6.7.9.4.4c.2.2.3.2.5.2a.8.8 0 0 0 .5-.1.8.8 0 0 0 .3-.6c0-.2 0-.5-.3-.9l-.7-.9zm2.6 12.4-1-2.8-1.5.2-1-2.5 8.9-.1 1 2.6-6.5 6-1-2.6zm1.5-1.2 2.4-2-3.1.3zm2.1 9 1.7-.2.6 3.9-3.5.5a8 8 0 0 1-1.3-1.8 6.8 6.8 0 0 1-.6-2 5 5 0 0 1 .1-2.5 4 4 0 0 1 1.3-1.6 4.9 4.9 0 0 1 2.2-.9 5 5 0 0 1 2.4.2 3.6 3.6 0 0 1 1.7 1.4c.4.6.6 1.3.8 2.2v2a2.7 2.7 0 0 1-.6 1.3c-.3.4-.7.6-1.2.9l-.8-2.4c.3-.1.5-.3.7-.6s.1-.6 0-1a1.7 1.7 0 0 0-.7-1.2c-.4-.3-1-.4-2-.2a3 3 0 0 0-1.7.7c-.4.4-.5 1-.4 1.5 0 .3.1.6.3.8l.5.8h.8zm5.4 12-.2 2.6-5-.4a4.2 4.2 0 0 1-1.3-.4 3 3 0 0 1-1-.8 3 3 0 0 1-.6-1.1 5.1 5.1 0 0 1-.2-1.8l.2-1.3.5-1.2a3 3 0 0 1 .8-.8 2.6 2.6 0 0 1 1-.4 4.9 4.9 0 0 1 1.4-.2l5 .5-.3 2.5-5-.4c-.5 0-.9 0-1.1.3a1.4 1.4 0 0 0-.5 1c0 .4 0 .8.3 1 .2.3.5.5 1 .5zm-9.1 8.8.9-2.8-1.2-.8.8-2.5 7 5.6-1 2.6-8.8.4.9-2.5zm1.9 0 3 .1-2.5-1.8zm3 6.8-1.5 2.4h-3.3l1.5 2.9-1.4 2.4-2.5-5.2-3-1.8 1.4-2.2 3 1.8z"
    }),
    /* @__PURE__ */ jsxs197("g", {
      fill: "#009b3a",
      stroke: "#000",
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx204("path", {
          d: "M328.1 211.3s23.4 10.1 19.3 30.9c-4 20.8-17 20.6-22.2 23-5 2.2-8.6 5.5-10.6 5-2-.4-4.7-2-4.7-2s-.2 3.5 3.9 4c4.1.7 9.5-5.3 12-6 2.6-.6 18.5-2.4 22.4-23.5 4.5-22.6-20-30.7-20-31.4z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M339.9 215.8a3.2.8 75.1 0 1-1.5 0 3.2.8 75.1 1 1 1.5 0z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M339.1 216a3.3.7 63.3 1 1-1.4.5 3.3.7 63.3 0 1 1.4-.5zm-2.3 1.5a3.1.8 17 0 1-.2 1.6 3.1.8 17 0 1 .2-1.6z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M337.1 216.7a3.3.7 34.2 1 1-.7 1.3 3.3.7 34.2 1 1 .7-1.3z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M338.1 216.3a3.3.7 46.2 1 1-1 1 3.3.7 46.2 0 1 1-1z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m339.7 219.2-1 .6c-.3 0-.6-.3-1.2 0s-1 .9-1.1 1.2c-.1.3.2.5.9.1.7-.3.9-.9 1.2-1.1l1.3-.7.8-1.3c.3-.4 1.2-1 1.6-1.8.3-.6.2-1.1-.2-.9a3 3 0 0 0-1.2 1.3c-.2.4 0 1-.3 1.4zm7.3 2.4a1 4.8-1.6 1 1-2.2-.5 1 4.8-1.6 1 1 2.2.5z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M345.8 221.5a5 1 77.5 1 1-2.2.1 5 1 77.5 1 1 2.1 0z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M342 222.7a4.7 1.1 35 1 1-.7 2.2 4.7 1.1 35 1 1 .7-2.2z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M342.8 221.6a5 1 50.9 0 1-1.4 1.6 5 1 50.9 1 1 1.4-1.5z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M344.3 221.5a5.1 1 61.8 1 1-1.8 1 5.1 1 61.8 1 1 1.8-1z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m345.6 226.4-1.8.4c-.3 0-.6-.7-1.5-.5-.9.2-1.7.8-2 1.2-.2.4.1.8 1.2.6 1.2-.2 1.6-1 2.2-1 .5-.2 1.4-.4 2-.4.2-.4 1-1.2 1.5-1.6.5-.5 2-1 2.7-1.8.7-.8.7-1.6 0-1.5a4.8 4.8 0 0 0-2 1.3c-.5.6-.4 1.5-.9 2zm5.1 4.9a1 4.8 8.7 1 1-2-1 1 4.8 8.7 1 1 2 1z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M349.6 231a1 5-2 1 1-2-.3 1 5-2 1 1 2 .3z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M345.7 231.4a4.7 1.1 46 1 1-1 2 4.7 1.1 46 1 1 1-2z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M346.7 230.5a5 1 61.8 1 1-1.7 1.3 5 1 61.8 1 1 1.7-1.3z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M348.1 230.7a5.1 1 72.5 1 1-1.9.7 5.1 1 72.5 1 1 2-.7z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M348.5 235.8h-1.7c-.3 0-.5-.8-1.4-.8a3.3 3.3 0 0 0-2.1.8c-.4.4-.1.8 1 .8s1.7-.5 2.3-.6h2l1.8-1.2c.6-.4 2.1-.6 3-1.3.7-.6.9-1.4.3-1.4a5 5 0 0 0-2.3.9c-.5.4-.6 1.3-1.2 1.7-.4.2-1.6 1.1-1.7 1m2.5 6.4a1 4.8 31.3 0 1-1.4-1.7 1 4.8 31.3 0 1 1.4 1.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M350.1 241.3a1 5 20.6 0 1-1.8-1.1 1 5 20.6 0 1 1.8 1.1m-3.7-1.2a4.8 1 70 0 1-1.8 1.5 4.8 1 70 0 1 1.8-1.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M347.6 239.7a1 5.1-4.9 0 1-2 .5 1 5.1-4.9 1 1 2-.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M349 240.4a1 5.2 5.5 1 1-2-.1 1 5.2 5.5 1 1 2 .1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M347.3 245.3s-1.4-.5-1.6-.7c-.3-.2-.1-.8-1-1.3a3.1 3.1 0 0 0-2.2 0c-.5 0-.4.6.6 1 1 .6 1.8.2 2.3.4l1.8.9c.5-.2 1.6-.3 2.2-.4.6-.1 2.1.4 3.2 0 .9-.3 1.3-1 .7-1.2a4.5 4.5 0 0 0-2.3 0c-.7.1-1.1 1-1.8 1-.5 0-1.9.4-2 .3m1 7.7a1.3 5.5 48.5 1 1-1.1-2.4 1.3 5.5 48.5 1 1 1 2.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M347.3 251.9a1.2 5.8 37.5 1 1-1.5-2 1.2 5.8 37.5 1 1 1.5 2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M343.7 249.2a1.3 5.5-3.5 1 1-2.4 1 1.3 5.5-3.5 1 1 2.4-1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M345.1 249.2a1.2 5.9 11.6 0 1-2.3-.2 1.2 5.9 11.6 1 1 2.3.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M346.3 250.4a1.2 6 22.1 1 1-2.1-.8 1.2 6 22.1 1 1 2.1.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M343 255.3a16.3 16.3 0 0 1-1.6-1.4c-.2-.3.1-1-.7-1.8s-1.8-1-2.4-1c-.6.1-.6.7.3 1.6 1 1 2 .8 2.4 1.2.6.4 1.4 1.1 1.7 1.6l2.6.4c.7 0 2.2 1.1 3.5 1.1 1 0 1.8-.5 1.2-1a5.3 5.3 0 0 0-2.6-1c-.8 0-1.5.8-2.2.6l-2.3-.3m-2.3 7.3a1.4 6 79.8 1 1 .3-2.9 1.4 6 79.8 1 1-.3 2.9"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M340.5 261a1.3 6.4 68.5 0 1-.5-2.6 1.3 6.4 68.5 0 1 .5 2.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M338.4 256.4a1.4 6 26.2 0 1-2.8-.5 1.4 6 26.2 1 1 2.8.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M339.9 257.2a1.3 6.5 41.8 0 1-2.3-1.5 1.3 6.5 41.8 0 1 2.3 1.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M340.3 259.1a1.3 6.5 52.7 1 1-1.6-2 1.3 6.5 52.7 0 1 1.6 2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M334.4 261.7a18.1 18.1 0 0 1-.7-2.2c-.1-.4.6-.8.3-2a4.3 4.3 0 0 0-1.9-2.3c-.5-.3-.9.2-.5 1.6.4 1.4 1.4 1.9 1.7 2.6l.8 2.4 2.2 1.9c.6.5 1.5 2.4 2.7 3.1 1 .7 2 .5 1.8-.2a6.2 6.2 0 0 0-2-2.4c-.7-.6-1.8-.3-2.5-.8-.4-.5-2-1.6-2-1.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M330.8 268a1.8 6.1 89 0 1 0-3.5 1.8 6.1 89 0 1 0 3.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M330 262.5a1.7 6.3 37.6 0 1-2.7-2.2 1.7 6.3 37.6 1 1 2.6 2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M330.8 265.3a1.7 6.2 66.5 0 1-1.2-3.3 1.7 6.2 66.5 0 1 1.2 3.3m1.7-53.4a3.8.8 41.1 0 1-1.5.8 3.8.8 41.1 1 1 1.5-.8m-1.9 1.5a3.9.8 8.2 0 1 .3 1.6 3.9.8 8.2 1 1-.3-1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M331.4 212.4a4 .7 26.8 1 1-.8 1.3 4 .7 26.8 0 1 .8-1.3M303.7 262s5.1 1.1 9.6 2.7c4.5 1.7 11.3 7.2 13.1 7.6 2 0 4.9-.7 6-3.6-3.2.8-5 2.1-8 .5-1.1-.4-4.6-3.6-8.5-5.3-3.8-1.7-11.5-3.6-11.5-3.6l-.7 1.7m5.5-46.5 5.9-3.1-6.5 1.7-.8 1.1 1.4.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M314.8 217c-2.3-.5-5.8-1.3-8-1.4 1.5-1.7 3.6-4.7 5-6.4-1 1.7-2.3 4-2.8 5.5 1.5.9 4 1.6 5.8 2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M308.1 215.9a314.4 314.4 0 0 1 5.3-4.1l-6.1 2.7-.6 1.3h1.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M313.7 216.9c-2.3-.5-5.8-1.3-8-1.5 1.4-1.7 3.5-4.7 4.8-6.6-.8 1.8-2.2 4.1-2.7 5.8 1.6.9 4.1 1.6 6 2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m307.3 216.2 6.1-2.6-6.6 1.1-.9 1 1.3.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M313 217c-2.3-.3-6-.7-8.2-.6 1.3-2 3-5.3 4.1-7.3-.6 1.9-1.7 4.4-2 6.1 1.7.8 4.3 1.2 6.1 1.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m306.6 216.2 4.2-5-5.3 3.9-.3 1.3 1.4-.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M313 217.3c-2.5 0-6.4-.3-8.8 0 1.2-2.3 2.7-6 3.6-8.3-.4 2.1-1.3 5-1.4 6.9 1.8.6 4.6 1 6.6 1.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m305.8 217.4 5-4.9-6.1 3.5-.4 1.4h1.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M311.9 217.4c-2.7 0-6.8-.1-9.5.2 1.8-2.5 4.2-6.6 5.6-9.1-1 2.3-2.4 5.4-3 7.5 1.9.7 4.8 1 6.9 1.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m304 217.8 6.6-5.5-7.4 3.9-.8 1.6h1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M311 217.6c-2.7.4-6.9.8-9.4 1.5 1.3-2.7 3.1-7 4.2-9.7-.6 2.4-1.7 5.6-2 7.8 2 .4 5 .3 7.1.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m303.2 218.9 5-7-6.3 5.7-.3 1.7 1.6-.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M309.4 218.4c-2.6.3-6.8.5-9.4 1 1.5-2.6 3.5-6.8 4.8-9.4-.8 2.3-2 5.5-2.4 7.7 2 .5 5 .5 7 .7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m302.3 219.6 6.4-5.5-7.3 3.9-.7 1.6h1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M308.7 218.7c-2.7.6-6.9 1.3-9.4 2.1 1.2-2.7 2.8-7.1 3.8-9.8-.5 2.4-1.4 5.6-1.6 7.8 2 .3 5 0 7.2-.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m301.2 220 4-7.7-5.4 6.6-.1 1.7 1.5-.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M308.7 219.1c-3 .8-7.4 1.8-10 2.8 1-3.1 2.1-8 2.9-11.1-.3 2.7-.9 6.3-.8 8.8 2.3.2 5.5-.3 7.8-.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m300.4 221.7 5.2-7.6-6.6 6.1-.3 2 1.7-.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M307.5 220c-2.8.9-7.2 2.1-9.8 3.3.8-3.2 1.8-8.1 2.4-11.2-.1 2.7-.5 6.3-.3 8.7 2.2.1 5.4-.6 7.7-.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m299.4 222.8 3.9-8.4-5.6 7.2v2l1.7-.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M306.4 221.2c-2.8.6-7.3 1.5-10 2.4 1.1-3 2.5-8 3.4-11-.4 2.7-1.1 6.4-1.1 8.7 2.2.3 5.4-.1 7.7-.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m298.4 223.6 6.4-6.6-7.5 4.9-.6 1.8 1.7-.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M305.2 222.3c-2.9.4-7.3.8-10 1.5 1.3-3 3-7.8 4-10.8-.6 2.7-1.5 6.3-1.7 8.7 2.2.5 5.4.4 7.7.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m297.2 223 4.3-8.3-5.9 7v1.9l1.6-.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M305.5 221.3c-3 1.3-8 3-10.9 4.6 1-3.7 2-9.5 2.6-13.1 0 3.1-.5 7.4-.3 10.1 2.5 0 6-1.1 8.6-1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m296.6 225.4 5.2-9.4-6.9 8-.2 2.2 1.9-.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M304.3 222.5c-3 1.4-7.8 3.4-10.6 5.1.8-3.6 1.5-9.5 2-13 0 3-.2 7.3.1 10 2.5-.3 6-1.5 8.5-2.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m295.5 226.8 3.8-10.1-5.7 9 .2 2.3 1.7-1.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M303 223.3c-3 1.5-7.8 3.5-10.6 5.3.7-3.7 1.4-9.5 1.9-13.1 0 3-.2 7.3.2 10 2.5-.3 6-1.6 8.5-2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m294.7 228 5.8-8.9-7.4 7.3-.3 2.2 1.9-.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M302.7 222.8c-2.7 2.2-7 5.4-9.4 7.8 0-3.8-.5-9.5-.8-13 .6 2.9 1.3 7 2.3 9.5 2.4-.9 5.5-3 8-4.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m295 228.5.6-10.7-2.8 10.4.8 2 1.4-1.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M302 223.8c-2.8 2.2-7 5.3-9.5 7.7 0-3.7-.5-9.5-.8-13 .7 3 1.3 7 2.3 9.5 2.4-.8 5.5-3 8-4.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m294.3 230.3 2.7-10.5-4.7 9.6.3 2.2 1.7-1.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M301.6 224c-2.5 2.6-6.6 6.4-8.9 9-.4-3.7-1.5-9.6-2.2-13.2 1 3 2.1 7.1 3.4 9.5 2.3-1.1 5.4-3.6 7.7-5.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m294.3 231.6.5-11.1-2.7 10.8.8 2 1.4-1.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M300.8 226c-2.7 2.2-7 5.5-9.6 8 0-3.8-.7-9.8-1-13.5.7 3 1.5 7.3 2.5 9.9 2.5-1 5.7-3.1 8.1-4.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293.5 232.9 3.8-10.5-5.8 9.3.2 2.3 1.8-1.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M300.8 226c-2.5 2.5-6.3 6.4-8.5 9.1-.4-3.8-1.5-9.8-2.1-13.4 1 3 2 7.2 3.2 9.6 2.3-1.2 5.1-3.7 7.4-5.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293.6 233.4-.4-11-1.8 11 1 1.9 1.2-1.9"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M299.6 226.8c-2.4 2.6-6.1 6.5-8.2 9.3-.5-4-1.8-9.8-2.5-13.5 1 3 2.3 7.2 3.5 9.6 2.2-1.2 5-3.8 7.2-5.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293 234.5 1.2-11.2-3.3 10.6.7 2.2 1.4-1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M299 227.2c-2 2.9-5.5 7-7.4 10-.8-3.8-2.5-9.5-3.5-13 1.3 2.8 2.8 6.8 4.2 9.1 2.1-1.4 4.7-4.2 6.8-6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293 235.6-.8-11.3-1.4 11.2 1 2 1.1-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298.9 227.9c-2 3-5.3 7.3-7 10.4-1-3.8-3-9.5-4.2-13 1.4 2.8 3.1 6.8 4.7 9 2-1.5 4.5-4.5 6.5-6.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293.6 236.6 1.2-11.3-3.2 10.6.6 2.3 1.4-1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298.4 229c-1.7 3.1-4.5 8-6 11.3-1.3-3.6-3.8-9-5.3-12.4 1.7 2.6 3.7 6.3 5.5 8.4 1.9-1.8 4-5.2 5.8-7.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293.3 237.6-3.2-10.8 1 11.3 1.5 1.6.6-2.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298.4 230.2c-1.8 3.2-4.8 8-6.3 11.3-1.3-3.6-3.8-9-5.4-12.3 1.7 2.6 3.8 6.3 5.6 8.3 2-1.8 4.2-5.1 6-7.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293.4 239.6-1.2-11.3-1 11.3 1.1 2 1.1-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298.6 231.2c-1.9 3.1-5 7.9-6.5 11.1-1.3-3.6-3.7-9-5.2-12.4 1.7 2.6 3.7 6.4 5.5 8.4 2-1.7 4.3-5 6.2-7.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m293.3 240.5-2.1-11-.1 11.2 1.3 1.8.9-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.8 232.8c-2 3-5.3 7.5-7 10.7-1.1-3.7-3.3-9.4-4.6-12.8 1.5 2.7 3.4 6.6 5 8.8 2.1-1.6 4.6-4.7 6.6-6.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m292.3 241.7 1-11.3-3.1 10.7.7 2.2 1.4-1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.9 233c-1.7 3.3-4.6 8.3-6 11.6-1.4-3.5-4-8.8-5.7-12 1.8 2.4 4 6 5.8 8 2-1.9 4-5.3 5.9-7.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m292 242.7-3.5-10.6 1.3 11.2 1.5 1.6.6-2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.4 233.9c-1.2 3.6-3.2 9-4 12.7-2-3.2-5.5-7.8-7.6-10.7 2.1 2.1 4.9 5.2 7 6.7 1.6-2.3 3.2-6 4.6-8.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m295 243.5-3.7-10.4 1.6 11.2 1.5 1.4.6-2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.4 235c-1.2 3.6-3.2 9.1-4 12.7-2-3.2-5.4-7.7-7.6-10.5 2.1 2 4.9 5 7 6.6 1.6-2.3 3.2-6.1 4.6-8.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m295 245.3-4.8-9.7 2.8 10.8 1.7 1.2.4-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297 235.9c-.7 3.7-2 9.5-2.5 13.2-2.3-2.9-6.3-7-8.7-9.4 2.3 1.7 5.4 4.4 7.7 5.5 1.3-2.5 2.4-6.5 3.5-9.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m295.4 246.8-2.6-10.9.4 11.3 1.4 1.7.8-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297 237c-.4 3.9-1.2 9.8-1.2 13.5-2.6-2.5-6.9-6-9.5-8.1 2.4 1.4 5.7 3.6 8.1 4.4 1-2.6 1.8-6.8 2.6-9.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m295.5 247.6-6.9-7.8 5.2 9.5 2 .6-.3-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.2 238.4c-.4 3.8-1.2 9.7-1.3 13.4-2.6-2.5-6.9-6-9.5-8.2 2.5 1.4 5.8 3.7 8.1 4.5 1.1-2.6 1.8-6.8 2.7-9.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M296.3 249.4 291 240l3.3 10.7 1.7 1.1.3-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.5 240c-.3 3.8-.8 9.7-.8 13.5a117 117 0 0 0-9.8-7.6c2.6 1.2 6 3.3 8.3 4 1-2.7 1.6-7 2.3-10"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m297 251.2-6.6-8.3 4.8 9.8 1.8.8v-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.6 241.8c-.3 3.8-.8 9.7-.7 13.5-2.7-2.4-7.1-5.6-9.9-7.6 2.6 1.3 6 3.3 8.4 4 1-2.7 1.5-7 2.2-10"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m297.5 252.6-4.5-10 2.5 11 1.6 1.3.4-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M297.7 242.9c.2 3.9.2 9.8.6 13.6a134 134 0 0 0-10.4-6.2c2.6.9 6.1 2.4 8.6 2.8.7-2.9.8-7.1 1.2-10.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m298.3 252.2-8.3-5.7 7 7.8 2 .1-.7-2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298 243.3c.3 3.9.7 9.8 1.3 13.5-3-1.9-7.8-4.3-10.8-5.8 2.7.8 6.3 2.2 8.8 2.5.5-2.9.4-7.1.7-10.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m299.3 254.3-7-8 5.3 9.6 1.9.7-.3-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298.6 244.8c.5 3.8 1 9.7 1.9 13.4-3-1.7-8-3.8-11-5.1 2.7.6 6.4 1.8 8.8 2 .4-3 .2-7.2.3-10.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m300.6 255.7-8.3-5.9 7 8 2 .1-.7-2.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M298.9 246.4c.7 3.8 1.7 9.7 2.7 13.3-3.1-1.5-8.2-3.1-11.3-4.1 2.8.3 6.5 1.2 9 1 .2-2.9-.3-7-.4-10.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m301.6 256.9-7-8.2 5.2 9.7 2 .8-.2-2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M299.3 247.4c1.1 3.7 2.6 9.5 4 13-3.3-1-8.4-2-11.6-2.6 2.8 0 6.5.3 9-.1 0-3-1-7.1-1.4-10.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m302 256.9-9.7-2 9.1 4.5 1.9-.7-1.4-1.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M300 248.6c1 3.7 2.5 9.4 3.8 12.9-3.2-1-8.3-2-11.5-2.6 2.8 0 6.5.3 9 0 0-3-1-7.2-1.3-10.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m303.5 257.9-9.2-4.5 8.2 6.7 2-.2-1-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M299.5 249.2c1.8 3.4 4.5 8.7 6.5 11.7-3.4-.2-8.6 0-11.8 0 2.7-.5 6.4-1 8.7-2-.7-2.9-2.4-6.7-3.4-9.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m305 258.9-9.6-2.6 9 5 1.8-.5-1.3-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M300.4 250.7c1.9 3.3 4.6 8.6 6.7 11.6-3.4-.2-8.6 0-11.8.2 2.6-.7 6.4-1.2 8.6-2.2-.6-2.9-2.4-6.7-3.4-9.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m306.1 259.7-8.9-5.3 7.8 7.4h2l-.9-2.1"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M301.2 251.5c2.1 3.1 5.3 8 7.6 10.9a90 90 0 0 0-11.6 1.7c2.6-1 6.2-2 8.4-3.3-1-2.8-3.1-6.5-4.4-9.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m306.8 260.5-9.6-.3 9.5 2.9 1.7-1.1-1.6-1.5m5.6-46.6 6.9-1.1-6.9.1-1.2.6 1.2.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M316.2 215.4c-2-.6-5-1.6-7.1-2l7.4-3.5c-1.5 1-3.8 2.2-5 3.2 1.2.8 3.3 1.6 4.7 2.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m312 214.1 6.8-1.8-7 .9-1 .7 1.3.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M316.5 215.9c-2.4-.3-6-.7-8.3-.7 1.8-1.6 4.2-4.1 5.7-5.7-1 1.5-2.6 3.4-3.3 4.8 1.6.7 4.1 1.1 5.9 1.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m309.6 214.6 7-.8-6.8-.2-1.3.6 1 .4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m314.7 216.1-7.5-1.3 6.9-3.8c-1.4 1-3.4 2.4-4.4 3.4 1.3.6 3.5 1.2 5 1.7"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m309 214.6 6.1-2.7-6.7 1.8-.8.8h1.4"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M314.5 216.9c-1.7-.7-4.5-2-6.2-2.5l4.4-4.8c-.8 1.3-2 3-2.6 4.4 1.2 1 3 2 4.4 2.9"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m309.3 215 4.8-2-5.2.6-.6 1 1 .4m-4 44.6h-9.8l10 2.5 1.6-1-1.8-1.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m307.1 260.2-10-2.3 9.6 4.7 2-.6-1.6-1.8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m308.8 260.9-10-.5 10 3 1.7-1-1.7-1.5"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M302.5 253.9c2.5 2.8 6.4 7.4 9.1 9.9-3.3.5-8.3 1.8-11.4 2.7 2.4-1.2 6-2.6 8-4-1.4-2.6-4-6-5.7-8.6"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m310.1 261.4-10-3.3 9.4 5.6 2-.4-1.4-2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M303.4 254.5c2.8 2.6 7 6.7 10 9-3.2.9-8 2.8-11 4 2.3-1.4 5.6-3.2 7.4-5-1.6-2.4-4.5-5.5-6.4-8"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m311 262-9.5 1.9 10 .6 1.4-1.3-2-1.2"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m309 261.4-9.8.8 10.1 1.7 1.6-1.2-2-1.3"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m310.8 262-10.2-1.7 10 4 1.8-.7z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m312.5 262.5-10 .2 10.2 2.3 1.6-1.1z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M305.7 256c2.8 2.6 7 6.8 9.9 9.2-3.3.7-8.3 2.4-11.3 3.4 2.4-1.3 5.8-2.9 7.7-4.5-1.6-2.5-4.4-5.7-6.3-8.2z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m313.9 262.9-10.2-2.6 9.8 5 1.9-.6z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "M306.6 256.5c3 2.4 7.6 6.2 10.7 8.2-3.2 1.1-7.8 3.5-10.6 4.9 2.2-1.7 5.3-3.7 7-5.5-1.8-2.4-5-5.3-7-7.6z"
        }),
        /* @__PURE__ */ jsx204("path", {
          d: "m314.8 263.4-9.3 2.6h10l1.3-1.5-2-1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "#fedf00",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m327.6 249.5-7.6-5.3-7.6 5.3 2.9-8.4-6.7-5.2h8.6l2.8-8.4 2.8 8.4h8.6l-6.7 5.2z"
    })
  ]
});
var Py_default = SvgPy;

// src/country-flag-icons/generated/Qa.tsx
import { jsx as jsx205, jsxs as jsxs198 } from "react/jsx-runtime";
var SvgQa = (props) => /* @__PURE__ */ jsxs198("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx205("path", {
      fill: "#8d1b3d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx205("path", {
      fill: "#fff",
      d: "M0 0v480h158.4l97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6L256.1 80l-97.7-26.7 97.8-26.6L158.3 0z"
    })
  ]
});
var Qa_default = SvgQa;

// src/country-flag-icons/generated/Re.tsx
import { jsx as jsx206, jsxs as jsxs199 } from "react/jsx-runtime";
var SvgRe = (props) => /* @__PURE__ */ jsxs199("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx206("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx206("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx206("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Re_default = SvgRe;

// src/country-flag-icons/generated/Ro.tsx
import { jsx as jsx207, jsxs as jsxs200 } from "react/jsx-runtime";
var SvgRo = (props) => /* @__PURE__ */ jsx207("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs200("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx207("path", {
        fill: "#00319c",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx207("path", {
        fill: "#ffde00",
        d: "M213.3 0h213.4v480H213.3z"
      }),
      /* @__PURE__ */ jsx207("path", {
        fill: "#de2110",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Ro_default = SvgRo;

// src/country-flag-icons/generated/Rs.tsx
import { jsx as jsx208, jsxs as jsxs201 } from "react/jsx-runtime";
var SvgRs = (props) => /* @__PURE__ */ jsxs201("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx208("defs", {
      children: /* @__PURE__ */ jsx208("clipPath", {
        id: "rs_svg__a",
        children: /* @__PURE__ */ jsx208("path", {
          fillRule: "evenodd",
          d: "M60 0h1200v900H60z"
        })
      })
    }),
    /* @__PURE__ */ jsxs201("g", {
      clipPath: "url(#rs_svg__a)",
      transform: "translate(-32) scale(.53333)",
      children: [
        /* @__PURE__ */ jsx208("path", {
          fill: "#fff",
          d: "M0 0h1350v900H0z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#0c4076",
          d: "M0 0h1350v600H0z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#c6363c",
          d: "M0 0h1350v300H0z"
        }),
        /* @__PURE__ */ jsxs201("g", {
          transform: "matrix(1 0 0 1.00437 0 -.3)",
          children: [
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M473.4 259.4v-.2h1v.2l-.5.5-.6-.6zm1 0v.5h-.5l.4-.6zm-93 5.2-1 .2.3-.6 4.2-.2 4-.3 4-.2 3.8-.3 4-.2 3.6-.3 3.7-.2 3.7-.2 3.5-.2h3.4l3.3-.3 3.2-.2 3.2-.2 3-.2h3l3-.2 3-.2 2.7-.2h2.8l2.7-.2 2.5-.2h2.5l2.4-.3h2.2l2.2-.2h2.2l2-.2h2l2-.2h5.3v1h-5.5l-1.8.2h-2l-2 .2h-2.2l-2.2.2-2.4.2h-2.4l-2.5.2-2.5.2H446l-2.8.3h-2.8l-3 .3-2.8.2h-3l-3 .3-3.3.2-3.3.2-3.3.2h-3.5l-3.5.3-3.6.2-3.5.3-3.8.2-3.8.2-4 .3-4 .2-4 .3-4.2.2.5-.6zm-1 .2-.3-.5h.7zm6.4 31-6.5-31 1-.2 6.5 31-.5.7zm.5.5h-.4l-.2-.4.5.3zm95-4-.2 1h.2-5.8l-3 .2h-3l-2.8.2h-3l-3 .2h-6l-3 .2h-3l-3 .2h-3l-3 .2h-3.2l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-2.8.2h-5.8l-2.7.2h-2.7v-1h5.8l2.7-.2h5.8l3-.2h3l2.8-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3.2l3-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3l2.8-.2h3l2.8-.2h.2zm-.2 0h.2zm94.5 3.4 1 .2-.5.3h-2.8l-2.8-.2h-8.8l-2.8-.2h-3l-3-.2H551l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3.2-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2H485l-3-.2.2-1h2.8l3 .2h3l2.8.2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3.2l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h5.8l2.7.2h3l2.7.2h2.8l-.5.5zm1 .2v.3h-.5l.5-.4zm6.5-31.2-6.5 31h-1l6.5-31.2.6-.4zm-.4-.6h.5v.6zm-93.7-4.8h1l-.6-.5h5.4l2 .2h2l2 .2h2l2.4.2h2.4l2.4.3h5l2.6.3h2.7l3 .3 2.8.2h3l3 .3 3 .3 3.3.2 3.3.2 3.4.2h3.4l3.6.3 3.6.2 3.7.2 3.6.3 4 .2 3.8.3 4 .2 4 .3 4.2.2v1l-4.3-.2-4-.3-4-.2-4-.3-3.7-.2-3.8-.2-3.6-.3-3.6-.2-3.5-.2h-3.4l-3.3-.3-3.3-.2-3.2-.2-3-.2h-3l-3-.2-3-.2h-2.7l-2.6-.3h-2.6l-2.6-.3h-2.5l-2.4-.2-2.3-.2h-2.2l-2.2-.2h-2l-2-.2h-2l-1.8-.2h-3.3l-.5-.6zm.4.5h-.5v-.6l.4.5zm.5-.8v.2h-1v-.2l.3-.5.6.5zm-1 0v-.4h.3l-.4.4zm-8 .3.2-1h8.8l.3.2v.8h-.5v.2h-.3l-.2-1h.2v.7h.2-8.2zm-8.1.2v-1l-.2 1h-.4l-.2-.2-.3-.3v-.5l.2-.2h9.4v1h-8.8l.2-.2v-.8h-.2.4v1zm0-1v1l-.6-.5.5-.5zm-.6.5v-.5h.5l-.6.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M583.5 264.2c3.2-6.6 6.7-13 11.2-18.7-11.7 8.8-18 7.5-18.7-4-.7-.2-1.7-.2-2.6-.2-9 14-17.7 12-26.2-5.8-11.5 18.4-21.4 18-29.2-1-13.3 16.6-24.5 16.7-33.6.2v-2c.5.2 0 .3-1 0l-.3-.3a69.3 69.3 0 0 1-1 .2c-.2 0-.5 0-.8-.2l-.2.4c-1.2.2-1.6 0-1 0v2c-9.2 16.4-20.4 16.3-33.7-.4-7.8 19-17.7 19.5-29.2 1-8.4 18-17 20-26 6-1 0-2 0-2.7.2-.8 11.4-7 12.7-18.8 4 4.6 5.5 8 12 11.3 18.6 34-1.4 67.6-3.2 101.3-5 34 1.8 67.6 3.6 101.5 5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m595 246-.6-1 .7 1-.3.4-.4.5-.4.4-.5.6-.4.5-.3.6-.4.6-.4.6-.5.5-.3.6-.4.6-.4.4-.3.6-.3.6-.3.6-.4.6-.3.5-.3.6-.4.5-.3.6-.3.7-.4.6-.3.6-.3.5-.3.6-.2.8-.3.6-.4.6-.2.6-.3.6-.3.6-.3.6-1-.4.3-.6.3-.7.3-.6.2-.5.4-.6.3-.7.2-.6.3-.6.3-.6.4-.6.3-.6.3-.6.3-.6.5-.6.3-.6.4-.6.3-.6.4-.5.2-.5.4-.6.4-.7.3-.6.4-.5.4-.6.5-.6.4-.5.3-.6.4-.6.4-.6.5-.5.4-.6.4-.5.7.7zm-19.2-4 .3-1 .5.5v1l.2 1v1l.3.7.2.8.3.7.3.7.2.6.4.5.3.5.4.4.5.3.4.3.4.3.5.2h.4l.5.2h1.9l.7-.2.7-.2.8-.3.8-.3.8-.3 1-.5.8-.6 1-.5 1-.7 1-.7 1-.7 1-1 .7 1-1 .7-1 .8-1 .7-1 .6-1 .5-1 .5-1 .5-.8.4-1 .3-.7.3-.8.2h-.8l-.8.2h-2l-.7-.3-.5-.2-.6-.3-.5-.5-.6-.4-.5-.4-.5-.5-.3-.5-.4-.7-.3-.7-.2-.7-.3-.8-.2-1v-.8l-.2-1v-1l.2.3zm.3-1 .4.2v.3zm-2.2.6-.8-.6.4-.2h2v.2h.4l-.2 1h-1.2v-.2h-1.2l.4-.2zm-.8-.6v-.2h.4zm-25.3-5.2-1-.6h1l.8 1.7.8 1.4.8 1.5.8 1.2.8 1.2.8 1.2.8 1 .8 1 .8.8.8.8.8.7.7.5 1 .4.7.3.8.3.7.3h2.3l.8-.2.8-.2.8-.3.8-.4.8-.6.8-.6.8-.7.8-.6 1-1 .7-1 .8-1 .8-1 1-1.4.8.6-.8 1.3-1 1-.7 1.2-1 1-.7 1-1 .7-.8.6-.8.6-1 .6-.7.4-1 .4-.8.2-1 .2h-3l-1-.4-.7-.3-1-.5-.7-.5-1-.6-.7-.7-1-.8-.8-1-.8-1-.8-1-.8-1.2-.8-1.3-.8-1.3-.8-1.5-.8-1.6-.8-1.7h1zm-1-.6.6-.7.4.8h-1zm-28.3-.5-.8-.6 1 .2.6 1.7.7 1.5.7 1.5.8 1.4.7 1.3.8 1.2.8 1 .8 1 .8.7.8.7.8.6 1 .5.7.4.8.2 1 .2h2.5l1-.3.8-.2 1-.4.8-.6 1-.7 1-.6 1-1 1-1 1-1 1-1.2 1-1.3 1-1.6 1-1.5 1.2-1.8 1 .6-1.2 1.7-1 1.5-1.2 1.5-1 1.3-1 1.3-1 1.2-1.2 1-1 1-1 .8-1 .7-1 .6-1 .4-1 .4-1 .4h-3l-1-.2-1-.3-.8-.6-1-.5-.8-.8-1-.8-.7-.8-1-1-.8-1-.8-1.3-.8-1.4-.8-1.5-.8-1.5-.7-1.7-.8-1.7h1zm-.8-.6.5-.6.5.8h-1zm-33.8.7h1v-.2l.8 1.5 1 1.4.8 1.2 1 1.2.8 1 1 1 .8 1 1 .8.8.7 1 .6 1 .4 1 .4.8.3 1 .3 1 .2h2l1-.2 1-.3 1-.3 1.2-.4 1-.6 1.2-.6 1-.6 1.3-.8 1-1 1.3-1 1.2-1 1-1.3 1.4-1.3 1.2-1.4 1.2-1.5.8.7-1.3 1.5-1 1.5-1.3 1.3-1.2 1.3-1.2 1-1.2 1-1 1-1.3 1-1.2.7-1 .6-1.3.6-1 .5-1.3.3-1.2.3h-1l-1.2.2h-1l-1.2-.2-1-.2-1-.3-1-.4-1-.5-1-.7-1-.6-1-1-1-.8-1-1-1-1.2-.8-1.2-1-1.3-.8-1.5-1-1.5v-.3zm0 .3v-.3zm1-2.3v2h-1v-2l.8-.5.3.5zm-1 0v-.8l.8.2-.8.5zm-1 .3 1-.4-.4-.3h1l-.2.2v.4l.4-1h.2v.2l.2.2v.6h-1.8l-.5-.3zm.5.3h-.3v-.3zm.3-1 .2.3-1 .4v-.4l.2-.7.6.2zm-.6-.4.4-.2.2.4zm-1 1 .2-1h.8l.2 1h-1zm-.4-.4-1-.4.7-.3h.8v1h-1zm-1-.4.3-.4h.3zm0 .4v-.4l1 .4-.2.4-.4.3zm.8.4v.3h-.4zm-1-.3h-1l.7.4v.2h.2v-.8h-.2.2l.2-.2h.4l.2 1h-1.9v-.2h-.2v-.5h.2v-.2h.2l.8.4zm-.7-.5.7-.3v.7zm-.3 2.5v-2h1v2.3zm1 0v.2zm-33.6 0-1-.5h1l1 1.4 1.3 1.4 1.3 1.3 1.2 1.2 1.2 1 1.2 1.2 1 1 1.2.7 1 .7 1.2.7 1 .6 1.2.4 1 .3 1 .3h1l1 .2h1l1-.2 1-.2 1-.2 1-.4 1-.5 1-.7.8-.7 1-.8.8-1 1-1 .8-1 1-1.2.8-1.2.8-1.4 1-1.5.8.5-1 1.5-.8 1.4-1 1.2-.8 1.2-1 1.2-1 1-.8 1-1 .8-1 .7-1 .8-1 .5-1 .4-1 .4-1 .3-1.2.2h-2.2l-1-.2-1.3-.3-1-.3-1.2-.5-1-.6-1.2-.6-1.2-.8-1.2-.8-1.2-1-1.2-1-1.2-1-1.2-1.4-1.2-1.3-1.3-1.5-1-1.5h.8zm-1-.5.3-.8.7.7zm-28.3 1.5-1-.4h1l1 1.6 1 1.4 1.2 1.5 1 1.2 1 1.2 1 1 1 1 1 1 1 .7 1 .8 1 .6.8.4 1 .3.8.4h2.8l.8-.2.8-.3.8-.5 1-.5.7-.6 1-.7.7-.8.8-1 .8-1 .8-1.3.8-1.3.8-1.4.8-1.5.7-1.6.8-1.8 1 .4-.8 1.7-.7 1.7-.8 1.5-.8 1.4-.8 1.3-1 1.2-.7 1-1 1-.7 1-1 .7-.8.7-1 .4-.8.5-1 .2-1 .2h-3l-1-.3-1-.3-1-.4-1-.6-1-.7-1-.8-1-1-1-1-1-1-1-1.4-1-1.3-1.2-1.5-1-1.5-1.2-1.7h1zm-1-.4.5-.8.5.7h-1zm-25.6 6.5v-1l.3.2 1 1.3.7 1.2.8 1 .8 1 .8.8 1 .8.7.8 1 .6.7.5.7.3.8.3.8.2.8.2h2.3l.8-.4.8-.3.8-.4.7-.5 1-.6.7-.8.8-.8.8-.8.8-1 1-1 .7-1.2.7-1.2.8-1.3.8-1.6.8-1.5.8-1.7 1 .4-1 1.7-.7 1.5-1 1.4-.7 1.3-.8 1.3-.8 1.2-.8 1-1 1-.8 1-.8.8-.8.7-1 .6-.7.5-1 .5-1 .3-.7.3h-2.6l-1-.2-.8-.2-1-.4-.8-.4-1-.6-.8-.6-.8-.7-1-1-.7-.8-1-1-.8-1-1-1.3-.7-1.4.4.2zm0-1h.2v.2l-.3-.2zm-2.2.8h-1l.4-.5h1.2v-.2h1.5v1H389v.2h-.4zm-1 0v-.4h.4zm-18 3.6-.6.7.6-1 1 1 1.2.6 1 .7 1 .6 1 .4.8.5 1 .4.7.3.8.3.8.3.8.2h.7l.7.2h1.7l.4-.2.5-.2.4-.3.4-.3.4-.3.4-.4.3-.5.2-.5.3-.6.3-.7.3-.7.3-.8v-.8l.3-1v-.8l.2-1h1v1l-.2 1-.2 1-.2 1-.2.7-.2.8-.3.8-.4.7-.2.6-.5.6-.4.5-.6.5-.5.4-.7.2-.6.2-.6.2h-3.3l-.8-.3-.8-.3-1-.3-.8-.4-1-.5-.8-.5-1-.5-1-.6-1-.7-1-.8-1.2-.8.7-.8zm11 18.5v1l-.4-.3-.3-.6-.2-.6-.3-.6-.3-.6-.4-.6-.3-.6-.3-.7-.3-.5-.4-.6-.4-.7-.3-.6-.4-.6-.3-.5-.4-.6-.4-.7-.4-.5-.3-.6-.4-.6-.4-.6-.4-.6-.3-.5-.4-.7-.3-.6-.3-.5-.4-.6-.4-.5-.4-.5-.4-.5-.4-.6-.4-.5-.4-.6-.4-.5.7-.8.4.5.4.6.4.5.4.6.4.5.4.5.4.5.4.6.4.6.4.5.3.6.4.6.4.5.4.6.4.6.3.6.5.6.3.6.3.6.5.6.3.6.3.6.5.6.3.7.3.7.4.6.3.6.4.5.4.6.3.7.3.7.3.6-.5-.3zm0 1h-.3v-.3zm101.4-6v1l-3.2.2h-3.2l-3 .3h-3.3l-3 .3-3.3.2H460l-3 .3-3.3.3h-3.2l-3 .3H444l-3 .3h-3.3l-3.3.2-3 .2h-3.3l-3.2.3h-3l-3.3.3-3.3.2h-3l-3.3.3h-3.2l-3 .2-3.3.2h-3.3l-3.2.2h-3l-3.3.3H384l-3 .2-.2-1h3.2l3.2-.3h3l3.3-.2 3.2-.2h3l3.3-.3h3.2l3-.3h3.3l3.2-.3h3l3.3-.2h3.2l3-.3h3.3l3.2-.3 3-.2h3.3l3.2-.3h3l3.3-.3 3.2-.2h3l3.3-.3 3-.3h3.3l3.2-.3 3-.2h3.3l3.2-.3 3-.3h.2zm101.2 5v1h-3l-3.3-.2-3-.2h-3.3l-3-.3h-3.3l-3.2-.3h-3l-3.3-.2-3.3-.2h-3l-3.3-.3-3.2-.2h-3l-3.3-.3h-3.3l-3-.3h-3.3l-3.2-.3-3-.3h-3.3l-3.3-.3h-3l-3.3-.3h-3l-3.3-.2-3-.2-3.2-.2h-3.2l-3.2-.3h-3l-3.3-.2.2-1h3l3.3.3 3.2.2 3 .2 3.3.2h3l3.3.3h3.2l3 .2 3.3.2 3.2.2h3l3.3.3h3l3.3.2 3.2.2h3l3.3.3h3.3l3 .3h3.3l3.2.3h3l3.3.3h3.3l3 .3h3.3l3.2.2h3.2l3 .2 3.3.2h3.2zm0 1v-1l.5.7zm.5-.3-.2.3h-.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "m459.4 276.2 22.7-11.5 23 11.5-23 11.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M474 259.2v.2c-17.6.7-48.6 2.5-93.2 5.3l6.5 31c29.6-.8 64.3-2 94.8-3 30.7 1 65.3 2.2 95 3l6.5-31c-44.6-2.8-75.6-4.6-93-5.3v-.2c1.7-.4-1-.4-8.4-.2-7-.2-10-.2-8 .2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "m597.3 236.7-3.7-.6c-7 17.5-13.4 18-14.6 1.4 1.6-.6 1-3.3 2.8-2.2 1 .5 2-1 1.3-2-2-1.5-3.6-1.3-5.4.4-.8-2.7-3-4-5.4-2.8-1 .5-.7 2.5.4 2.4 1.8-.2 1 1.6 1.6 3-12.5 16.4-19 14.4-17.4-7.3-3-.7-6.5-1.3-9.6-2.4-11.5 23.3-19.7 24.3-26.4 3.4 1.4-1 1-3.8 3-3 1.3.6 2.3-1.5 1.2-2.4-2.4-2-5-1.3-6.8 1.3-1.4-3-4-4-6.6-2.2-1.2.7-.5 3 .8 2.6 2.3-.7 1.3 2.4 3 3.5-5 19.6-30.8 21-26.6-8.2-2.4 0-4.5 0-6.6.2l-6.7-.2c4.2 29-21.5 27.8-26.6 8 1.6-1 .6-4 3-3.4 1.2.3 2-2 .7-2.7-2.6-1.7-5.2-.7-6.6 2.2-1.7-2.7-4.3-3.4-6.7-1.4-1 1 0 3 1 2.5 2.2-.8 1.8 2 3.2 3-6.7 21-15 20-26.4-3.4-3 1-6.5 1.7-9.5 2.3 1.6 21.6-5 23.6-17.4 7 .6-1.2 0-3 1.7-2.8 1 0 1.5-2 .4-2.4-2.4-1-4.5 0-5.3 2.8-1.7-1.7-3.5-2-5.5-.4-.8 1 .4 2.5 1.3 2 1.8-1 1.2 1.6 2.8 2.2-1.2 16.5-7.6 16-14.6-1.3l-3.7.7c0 4 1.3 8.5 3.8 11.7 10.6 13.5 18.5 10.4 18.8-4.7 14 16.4 24.4 14.3 26.2-3 11.7 21.8 30.5 11.4 31-2 5 19.4 33.5 19.2 35.4-3 1.8 22.2 30.3 22.4 35.4 3 .4 13.4 19.2 23.8 31 2 1.7 17.3 12.3 19.4 26 3 .4 15 8.3 18.2 19 4.7 2.4-3.2 3.8-7.6 3.7-11.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m593.7 235.6 3.7.6-.2 1-3.6-.6-.4-.7zm-.5.3v-.4h.5zm-14.3 1 .2 1 .3-.6.2 1.4v1.4l.3 1.3.2 1.2.2 1 .3 1 .3 1 .3.7.3.7.3.6.3.5.3.5.4.2.3.2h1.3l.4-.3.4-.2.5-.4.4-.3.6-.6.5-.6.6-.7.7-1 .6-.8.7-1.2.6-1.2.6-1.3.7-1.3.5-1.5.7-1.6 1 .3-.8 1.6-.6 1.4-.7 1.4-.5 1.3-.7 1.3-.6 1-.6 1-.7 1-.7.8-.6.8-.6.6-.5.5-.6.3-.7.4-.5.2h-1.2l-.6-.2-.5-.2-.5-.4-.5-.4-.4-.6-.3-.6-.3-.8-.4-.8-.3-1-.2-1-.3-1-.2-1.3-.2-1.3-.2-1.5v-1.6l.3-.5zm-.5.4v-.4h.4zm3.5-2.7-.5 1v-.2h-.4v.2h-.2v.2l-.2.2v.3l-.2.3-.2.3v.2h-.2v.3h-.3v.2h-.3l-.2.2-.3-1v-.2h.2v-.2h.2v-.2l.2-.2v-.5h.2v-.4l.2-.2v-.3l.2-.2.2-.2h.2l.2-.2h1l.2.2zm.8-1 .6-1v.2h.2l.2.3v1.6h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.5v.2h-.8l-.3-.2.5-1v.2h.4v-.2h.2v-.2h.2v-.8zm.6-1v.2zm-6.3 1 1-.3-.8-.2h.2l.2-.3.2-.2.2-.2.3-.2h.2l.2-.2h.2v-.2h.4l.2-.2h2.3l.2.2h.2l.2.2h.2l.2.2h.2l.2.2.2.2-.6.8-.3-.2h-.2l-.2-.2-.2-.2h-.3l-.2-.2h-2.1v.2h-.3v.2h-.2l-.3.2v.2h-.3v.2l-.3.2zm1 .3-.7.5-.2-.8 1 .3zm-5.6-2.7-.4-1h.5l.3-.2h2.1l.4.2h.4l.2.3h.2v.2l.3.2h.2l.2.2v.2l.2.2v.2l.2.2.2.2v.2l.2.3v.2l.2.2v.2l-1 .3v-.5h-.2v-.3l-.2-.2v-.2h-.3v-.3h-.2v-.4h-.3v-.2h-.3v-.2h-.6v-.2h-2l-.2.2zm0 1.4.2 1h-.6v-.2h-.2l-.2-.2-.2-.2-.2-.2V231l.2-.2.2-.2.3-.2.4 1h-.2v1.2h.2zm2.2 3.7-.8-.6v.5-.2h-.2v-1h-.2v-1l-.2-.2h-.7v-1.2h.6l.3.2.2.2h.2v.2l.2.3v.4h.2v1.5h.2v.8zm0-.5h.2l-.2.4zm-18-6.6.3-1 .3.6v2l-.2 1.8v4.9l.3 1.4v1.3l.3 1 .2 1 .3 1 .4.8.3.8.4.5.5.5.4.3.4.3.5.2h1l.6-.2.7-.3.7-.4.8-.5 1-.4.7-.8 1-.8 1-1 1-1 1-1 1-1.4 1-1.4 1.3-1.4.8.6-1.2 1.5-1 1.3-1.2 1.3-1 1-1 1.2-1 1-1 .8-1 .8-.8.6-1 .5-.7.4-.8.3h-.8l-.8.2h-.7l-.7-.2-.6-.3-.6-.5-.5-.5-.4-.7-.5-.7-.4-1-.2-1-.2-1-.2-1.2-.2-1.3V229l.5.6zm.3-1h.3v.6zm-9.3-1.6-1-.4.7-.3.3.2h.3l.3.2h.3l.2.2h.3l.4.2h.6l.3.2h.3l.4.2h.6l.3.2h.5l.3.2h.7l.3.2h.6l.3.2h.5l.3.2h.8l.3.2h.3l-.3 1h-.8l-.2-.2h-.6l-.3-.2h-.8l-.3-.2h-.6l-.4-.2h-.7l-.4-.2h-.3l-.3-.2h-.6l-.3-.2h-.2l-.3-.2h-.6l-.4-.2h-.3l-.4-.2h-.4l-.3-.2h-.2l.7-.4zm-1-.4.3-.4h.4l-.6.4zm-26.2 3.2.6.8.3-.6.6 2 .5 1.7.7 1.6.6 1.6.7 1.4.7 1.2.6 1 .7 1 .7 1 .7.6.6.6.7.4.7.4.7.2h1.4l1-.2.6-.2.8-.4 1-.6.7-.6 1-.8 1-1 .8-1 1-1.2 1-1.3.8-1.4 1-1.6 1-1.7 1-1.8 1-2 1.2-2 1 .3-1.2 2.2-1 2-1 1.8-1 1.8-1 1.6-1 1.5-1 1.3-1 1.2-1 1-1 1-1 1-.8.7-1 .5-.8.4-1 .2-.8.2h-1.8l-.8-.3-.8-.3-.8-.5-.8-.6-.7-.8-.8-1-.7-1-.7-1-.7-1.4-.7-1.4-.7-1.5-.7-1.7-.6-1.7-.7-1.8.2-.6zm-.2.6v-.4l.2-.2zm3.8-3.6-.3 1h-.3l-.2-.2h-.2v.2h-.2v.2h-.2v.5h-.2v.4l-.2.3-.2.2v.2l-.2.3-.3.3-.2.3h-.2l-.5-.7.2-.2.2-.2v-.5h.2v-.4h.2v-.3l.2-.3v-.2l.2-.2.2-.3.2-.2h.2v-.2h.5v-.2h.7l.2.2zm.7-1.6.6-.8.2.2.2.2v.2l.2.3v1.3l-.2.3v.2l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2h-1.1l.4-1h.7v-.2h.2v-.6h.2v-.7h-.2v-.2zm-7 1 1-.3h-1l.2-.3v-.3h.3l.2-.3.2-.3.2-.2.3-.3.3-.3h.2l.2-.3h.3l.2-.2h.5l.2-.2h2.2l.3.2h.2l.3.2h.3l.3.3h.2l.3.3.3.2-.6.8-.2-.2h-.2l-.2-.3-.4-.2h-.2l-.2-.2H521v.2h-.5l-.2.3h-.2v.2h-.2l-.2.3-.2.2-.3.3v.2l-.2.3-.2.2h-1zm1 .2-.6.7-.3-1 1 .2zm-7-2-.4-1h.3l.2-.2h.3l.4-.2h.2l.3-.2h.4l.3-.2h1.6l.2.2h.2l.3.2h.2l.2.3.3.2.2.2v.2l.3.2.2.2.2.2v.2l.3.2.2.3.3.4v.3l-.8.4-.2-.4-.2-.2v-.2l-.3-.2v-.2l-.3-.2-.3-.3h-.2v-.2h-.3l-.3-.2h-.2l-.3-.2h-.4l-.2-.2h-1.2l-.2.2h-.5l-.2.2h-.2l-.2.2-.2.2zm.5 1.7.3 1h-.5l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2v-.2l-.2-.2V224l.2-.2.2-.3.3-.2.5 1h-.2v1.2h.2v.2h.4zm3.7 4-1-.2.2.5h-.2l-.2-.2h-.2v-.3h-.2l-.2-.3v-.4l-.2-.2v-.3l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2h-.6l-.4-1h1.1l.3.2h.2v.4h.2v.3l.2.2v.2h.2v.5l.2.3v.5h.2v.4h.2l.2.2.2.2.3.6zm-.3-.5.3.2v.3zm-27-7.2v-1l.6.5-.3 2.7-.2 2.4v2.2l.2 2 .3 2 .4 1.7.5 1.5.7 1.4.6 1 .8 1.2 1 1 1 .7 1 .6 1 .5 1 .4 1.3.3h2.4l1.3-.2 1.2-.3 1.2-.5 1.2-.5 1-.7 1.2-1 1-.8 1-1 1-1.3 1-1.3.8-1.3.8-1.5.6-1.7.5-1.7 1 .2-.6 2-.7 1.6-.8 1.6-1 1.5-1 1.4-1 1.3-1 1-1.2 1-1.2 1-1.2.8-1.3.7-1.2.5-1.3.3-1.4.2h-2.5l-1.2-.3-1.3-.4-1.2-.5-1-.7-1-1-1-1-1-1-.8-1.5-.7-1.5-.6-1.6-.4-1.8-.3-2-.2-2.2V227l.2-2.6.3-2.7.5.6zm0-1h.7v.5l-.6-.5zm-6.6 1.2.2-1h4l.2-.2h2.1v1h-4.1l-.2.2h-2zm-6-.8h-1l.5-.4h5.1l.2.2h1.2v1h-4l-.3-.2h-2l.5-.6zm-1 0v-.5h.5zm-26.4 7.8.5.8.3-.5.6 1.7.5 1.7.7 1.5 1 1.4.8 1.4 1 1.2 1 1 1 1 1.2 1 1.2.6 1.2.5 1.2.5 1.2.3 1.2.2h2.4l1.2-.3 1-.3 1.2-.4 1-.7 1-1 .8-.8 1-1 .6-1.3.6-1.5.6-1.6.4-1.8.3-2v-2l.2-2.3-.2-2.5-.3-2.7h1l.3 2.6.2 2.5v2.2l-.2 2.2-.3 2-.5 1.8-.5 1.6-.7 1.5-.8 1.4-1 1.2-1 1-1 .8-1 .7-1.2.5-1.3.4-1.3.3H463l-1.2-.2-1.3-.3-1.3-.5-1.3-.6-1.3-.7-1.2-1-1.2-1-1-1-1-1.2-1-1.3-1-1.5-.7-1.6-.7-1.7-.6-2 .2-.5zm-.2.5v-.3l.2-.2zm3.7-4-.2 1-.2-.2h-.7v.2l-.2.2v.4l-.2.2v.5l-.2.2v.2l-.2.3v.2l-.2.2v.2h-.2v.3h-.3l-.2.2h-.2l-.4-.7.2-.2.2-.2h.2v-.3l.2-.2v-.5l.2-.2v-.5l.2-.3v-.3l.2-.2.3-.3.2-.2h.2l.2-.2h1.1zm.4-1.8.6-1v.2h.3v.3h.2v.2l.2.2v1.5l-.2.2v.2l-.2.2-.3.2-.2.2h-.9l.3-1h.4v-.4l.2-.2v-.8h-.2v-.2h-.2zm-6.7 2 .8-.6h-.8v-.2l.2-.3.3-.4v-.2l.3-.2.2-.2.2-.2.2-.2.2-.2.2-.2h.2l.3-.3.3-.2h.2l.3-.2h.5l.2-.2h1.6l.4.2h.2l.3.2h.2l.3.2.2.2h.3l-.6 1-.2-.2h-.2l-.2-.2h-.3l-.2-.2h-.5l-.2-.2h-1.3l-.2.2h-.3v.2h-.3l-.2.3-.2.2-.3.3-.3.3-.2.2v.2l-.2.2-.2.2v.3h-.2zm1 0-.5.7-.5-.8h1zm-7-1.2-.8-.8.2-.2.2-.2h.3l.2-.3h.2l.2-.2h.3l.3-.2h2.5l.3.2h.2l.3.2.2.2h.2l.2.3h.2l.2.2.2.2.2.3.2.2h.2v.4l.3.2-.8.6-.2-.2v-.3l-.3-.2-.2-.2-.3-.3-.2-.2h-.2l-.2-.2v-.2h-.2l-.2-.2h-.4l-.2-.2H441l-.2.2h-.2l-.2.2h-.2l-.2.3h-.2l-.2.3zm.5 1.6.4 1h-1.3l-.2-.2-.3-.2h-.2v-.2l-.2-.3v-.2l-.2-.2v-1.6l.2-.2.2-.2v-.2l.8.8-.2.2v1l.2.2.2.2h.4zm3.8 3.6-1-.4.2.6h-.2v-.3h-.3v-.2h-.2v-.3h-.2v-.5h-.2v-.6h-.2v-.5l-.2-.2-.2-.2h-.2v-.2h-.5v.2l-.5-1h.4l.2-.2h.6l.2.2.3.2h.2v.2l.2.2.2.3v.2l.2.2v.2l.2.3v.2l.2.2.2.2.2.2.2.2.2.6zm-.2-.6.3.2v.4l-.2-.6zm-26.6-2.5-.3-1 .5.4 1 2 1 2 1.2 2 1 1.6 1 1.6 1 1.5 1 1.4.8 1.2 1 1 .8 1 1 .8.7.6 1 .6.6.4.8.2.8.2h1.3l.7-.2.7-.4.7-.4.7-.6.7-.7.8-.7.6-1 .7-1 .8-1.3.6-1.4.7-1.5.7-1.5.7-1.8.6-2 1 .5-.7 2-.6 1.6-.7 1.7-.6 1.5-.7 1.4-.7 1.3-.7 1.2-.7 1-.8.8-.7.8-.7.6-.8.5-1 .4-.7.4H432l-1-.2-.7-.3-1-.5-1-.6-.8-.8-1-1-.8-1-1-1-1-1.2-1-1.3-1-1.5-1-1.6-1-1.8-1-1.8-1-2-1-2.2.5.3zm-.3-1h.3l.2.4zm-9 3h-1l.4-.6h.7l.3-.2h.6l.4-.2h.9l.3-.2h.5l.3-.2h.6l.4-.2h.3l.3-.2h.6l.3-.2h.5l.3-.2h.3l.4-.2h.3l.3-.2h.3l.3-.2h.3l.2 1h-.7l-.3.2h-.3l-.3.2h-.3l-.3.2h-.5l-.3.2h-.3l-.4.2h-.6l-.4.2h-.6l-.3.2h-.6l-.2.2h-.6l-.3.2h-.7l-.3.2h-.8v.2h-.4zm-1 0v-.5h.4zm-17.4 7 1 .3v-.5l1 1.4 1 1.4 1.2 1.3 1 1 1 1 1 1 1 .8.8.8 1 .6.6.4.8.4.7.3h.6l.6.2h.4l.5-.2.3-.2.5-.2.4-.5.3-.5.4-.7.2-.7.3-1 .2-1 .2-1v-2.7l.2-1.5v-5l-.2-1.8h1v2l.2 1.8v4.9l-.2 1.4v1.4l-.3 1.2-.3 1-.3 1-.2 1-.4.7-.4.7-.6.5-.5.5-.7.3-.7.2H402l-.6-.2-.8-.4-1-.5-.7-.5-1-.6-1-.8-1-.8-1-1-1-1-1-1.2-1-1.3-1.2-1.4-1-1.6-.2-.5zm0 .4v-.3.4zm2-3.7v1h-.6v.8l-.2.3v1h-.2v.3l-1-.4v-.4l.2-.2v-.9h.2v-.5l.2-.2v-.2h.4v-.2h1zm.3-1.4.3-1 .2.2h.2v.2h.2v.7h.2v1.2l-.2.2v.3l-.2.2-.2.2h-.2l-.2.2h-.5v-1h.4v-.2h.2v-.8l-.2-.2zm-5.7 2.7.7-.8-.8.2v-.2l.2-.3v-.3l.2-.3v-.2l.2-.2.2-.2v-.2l.3-.2v-.2l.3-.2h.2v-.3h.3l.3-.2.2-.2h.4v-.2h2.5l.3.2h.2l.3.2-.4 1-.3-.2h-.5l-.2-.2h-1.3l-.3.2h-.2v.2h-.2l-.2.2v.2h-.2l-.2.2v.2h-.2v.3l-.2.2v.2h-.2v.5l-.2.2-1 .3zm1-.3-.4.8-.7-.5zm-5.8-.2-.7-.6v-.2l.3-.2h.3l.2-.2h.2l.2-.2.3-.2h.2l.2-.2h2.1l.2.2h.2l.2.2h.2l.2.2.3.2.2.2h.2l.2.3v.2l-.7.8v-.2h-.3v-.2l-.3-.2-.3-.2h-.3v-.2h-.2l-.2-.2h-2v.2h-.3l-.2.2-.2.2zl-.2.2zm-.7-.6v-.2zm1.4 1.7.6 1h-1.3l-.3-.2-.2-.2v-.2h-.2l-.2-.2v-.3l-.2-.2v-.8l.2-.3h.2l.7.5v.8h.2v.2h.2v.2h.2zm3.6 2.7h-1l.3.5v-.2h-.3v-.2h-.3v-.3h-.2v-.2h-.2v-.2l-.2-.2v-.3h-.2v-.2l-.2-.3v-.2h-.7l-.6-.8h.2l.2-.2h1.1l.3.2.2.2v.2h.2v.4l.2.2v.5h.2v.2l.2.2.2.2h.2zm-.4-.5h.4v.4zm-14.7-.4v-1l.4.3.8 1.5.6 1.5.7 1.3.7 1.3.6 1.2.6 1 .6 1 .6 1 .5.6.6.7.5.7.6.4.5.5.3.2.5.2h1.1l.3-.3.3-.2.4-.4.3-.4.4-.5.3-.6.3-.8.3-.8.2-1 .3-1 .3-1.3.2-1.3v-1.4l.2-1.4h1v1.5l-.2 1.4-.2 1.3-.2 1.2-.2 1-.2 1-.3 1-.4.8-.4.8-.4.6-.4.6-.5.4-.5.4-.5.2-.6.2h-1.1l-.6-.3-.7-.4-.6-.4-.5-.6-.6-.6-.7-.7-.7-.7-.6-1-.6-1-.6-1-.6-1.2-.6-1.2-.7-1.4-.7-1.5-.6-1.7zm0-1h.3v.3zm-3.8.6 3.6-.6v1l-3.6.6-.5-.5zm-.5.5v-.4h.4zm4.7 11.4-.8.7-.3-.3v-.3l-.3-.3-.2-.3-.3-.3-.2-.3-.2-.3v-.4l-.3-.3-.2-.4-.2-.4v-.4l-.2-.4v-.4l-.3-.4v-.4l-.2-.3v-.4l-.2-.4v-.9l-.2-.3v-.8l-.2-.5V238l-.2-.5v-.7h1v1.9l.2.4v1.1l.2.5v.7l.2.3v.4l.2.4.2.3v.4l.2.5.2.3v.4l.2.3.2.4.2.2v.3l.3.4.2.2v.3l.3.3.2.4.2.3.2.3.2.3zm18.7-4.7-.8.7 1-.3-.2 1.4v1.4l-.2 1.3-.2 1.2-.2 1-.3 1-.2 1-.3 1-.4.7-.4.8-.4.7-.6.6-.5.5-.5.4-.7.3-.6.3h-.7l-.8.2h-.7l-.8-.2-.8-.2-.8-.2-1-.4-.7-.5-1-.7-1-.6-.8-.8-1-1-1-1-1-1-.8-1-1-1.3.8-.6 1 1.3 1 1 .8 1 1 1 1 .8.7 1 1 .5.7.6.8.5.8.4.7.2h.7l.7.3h1.4l.6-.2.4-.2.6-.2.4-.3.5-.5.4-.5.4-.6.4-.7.3-.8.3-.8.3-1 .4-1 .2-1 .2-1.2v-1.2l.2-1.3v-1.3l1-.4zm-1 .4V242l1 1zm27.3-3.2-1 .4 1-.2-.2 1.6v1.5l-.4 1.3-.4 1.3-.4 1.2-.4 1.2-.5 1-.7 1-.6 1-.6.7-.6.7-.8.6-.7.5-1 .4h-.8l-1 .3h-2.8l-1-.3-1-.4-1.2-.4-1-.6-1.2-.6-1.2-.8-1-.8-1.3-1-1.2-1-1.3-1.2-1.2-1.3-1.3-1.5-1.3-1.5.7-.7 1.2 1.5 1.3 1.4 1.2 1.2 1.2 1.2 1 1 1.3 1 1 .8 1.2.7 1 .7 1 .6 1 .4 1 .3 1 .2h1l.8.2h.8l1-.2.7-.3.7-.4.7-.5.7-.4.6-.6.6-.7.5-.8.5-1 .4-1 .5-1 .2-1.2.4-1.3.3-1.3v-1.5l.3-1.6h1zm-1 0 .2-1.5.8 1.5zm31.8-1.8-.8.3h1v1l-.3 1.4-.4 1.2-.4 1.2-.5 1-.6 1.3-.6 1-.7 1-.8 1-1 1-1 .7-1 .7-1 .7-1 .6-1.2.5-1.2.4-1.2.3h-3.8l-1.3-.2-1.3-.4-1.4-.4-1.3-.7-1.3-1-1.3-.8-1.3-1.2-1.3-1.2-1-1.5-1.3-1.6-1.2-1.8-1-2 .8-.5 1 2 1.2 1.6 1.2 1.7 1.2 1.4 1 1.3 1.3 1 1.2 1 1.3.7 1.2.6 1.2.5 1.3.5 1.2.2h3.6l1.2-.3 1-.3 1-.3 1.2-.5 1-.6 1-.7.7-.8 1-1 .6-.7.6-1 .6-1 .6-1 .4-1 .4-1.2.3-1V239h1zm35.6-3-1 .2h1l-.2 2-.4 2-.6 1.6-.6 1.7-.8 1.6-1 1.3-1 1.3-1 1-1.3 1-1.3 1-1.3.8-1.3.6-1.5.6-1.5.3-1.5.2h-1.5l-1.6.2-1.4-.2-1.6-.2-1.5-.3-1.5-.5-1.4-.6-1.4-.7-1.4-1-1.3-1-1.2-1-1-1.2-1-1.4-1-1.4-1-1.6-.6-1.6-.5-1.8 1-.3.5 1.7.6 1.6.8 1.5 1 1.3 1 1.3 1 1.2 1.2 1 1.2 1 1.3.8 1.3.7 1.4.5 1.4.5 1.4.3 1.5.2h4.4l1.5-.3 1.4-.4 1.3-.5 1.3-.5 1.3-.7 1-1 1.2-.8 1-1 1-1.3 1-1.4.6-1.4.7-1.7.5-1.7.4-1.8.2-2h1zm35.5 3-1 .2h1l-.4 1.8-.7 1.6-1 1.6-1 1.4-1 1.4-1 1.2-1.3 1-1.2 1-1.4 1-1.3.6-1.5.6-1.4.5-1.6.3-1.5.2-1.5.2h-1.6l-1.5-.2-1.4-.3-1.5-.4-1.4-.6-1.4-.6-1.3-.8-1.4-1-1.2-1-1-1-1.2-1.3-1-1.4-.7-1.7-.7-1.7-.5-1.7-.4-2-.4-2 1-.2.3 2 .3 1.8.5 1.7.6 1.6.8 1.3 1 1.4.8 1.2 1 1 1.2 1 1.2.8 1.3.7 1.3.6 1.4.6 1.4.3 1.4.2h4.5l1.4-.2 1.5-.3 1.4-.5 1.3-.5 1.3-.7 1.3-.8 1-1 1.2-1 1-1 1-1.4 1-1.3.7-1.5.6-1.6.5-1.7h1zm31 2h-1l1 .2-1.2 2-1.2 1.7-1.2 1.6-1.2 1.5-1.3 1.2-1.4 1.2-1.3 1-1.3.7-1.3.6-1.3.5-1.4.5-1.3.2H530l-1.3-.3-1.2-.3-1.2-.4-1-.5-1-.6-1-.7-1-.8-1-1-.7-1-.8-1-.6-1-.6-1-.5-1.2-.3-1.2-.3-1.2-.2-1.3v-1l1-.2v1.2l.2 1.2.3 1 .4 1.2.5 1 .6 1 .7 1 .7 1 .7 1 1 .8.8.7 1 .6 1 .6 1 .5 1 .4 1 .4 1.3.2 1.2.2h2.4l1.2-.3 1.2-.4 1.3-.4 1.2-.6 1.3-.7 1.2-1 1.2-1 1.2-1.2 1.2-1.3 1.2-1.6 1-1.6 1.2-2 1 .2zm-1-.2.8-1.5.2 1.6h-1zm27.2 3.2h-1l1 .3-1.4 1.5-1.3 1.4-1.2 1.2-1.3 1-1.2 1.2-1.2 1-1.2.8-1 .8-1.2.6-1 .6-1.2.4-1 .4-1 .2-1 .2h-2l-1-.3h-.8l-.8-.5-.8-.5-.7-.6-.8-.7-.6-.8-.6-1-.6-1-.5-1-.5-1-.4-1.4-.3-1.3-.3-1.4-.2-1.6-.3-1.6 1-.2.2 1.6.2 1.5.3 1.3.3 1.3.4 1.2.4 1 .5 1 .5 1 .6.8.6.7.6.6.6.5.7.6.6.3.8.2h.8l.8.2h.8l1-.2 1-.2.8-.3 1-.4 1-.6 1.2-.6 1-.6 1.2-.8 1.2-1 1-1 1.4-1.2 1.2-1.2 1.3-1.4 1.3-1.5zm-1-.4 1-1v1.4zm19 4.8.7.7-1 1.2-1 1-1 1-1 1-1 1-.8.7-1 .6-.8.6-.8.4-1 .4-.7.3-1 .3-.7.2h-1.5l-.7-.2-.6-.3-.6-.3-.6-.4-.6-.5-.5-.6-.4-.7-.4-.8-.4-.8-.3-1-.3-1-.3-1-.3-1-.2-1.3V246l-.2-1.3v-1.3h1v2.6l.2 1.3.2 1 .2 1.2v1l.4 1 .4.7.3.8.5.6.4.5.4.5.4.5.5.3.5.3.6.3h.6l.6.2h.6l.7-.2h.6l.7-.4.8-.5 1-.4.7-.5 1-.6.7-1 1-.7.8-1 1-1 1-1 1-1.2zm4-10.7v-1l.6.4v2.9l-.2.4v.7l-.2.4v.5l-.2.4v.3l-.2.4v.3l-.3.4v.4l-.2.4-.2.4v.3l-.3.3-.2.4-.2.3-.2.4-.2.3-.2.4-.2.4-.2.3-.2.4-.2.4-.3.3-1-.6.3-.2.3-.3.2-.3.2-.4.2-.3.2-.3.2-.3v-.5l.3-.3v-.3l.2-.5.2-.3v-.4l.3-.3v-.4l.2-.3v-.7l.2-.4v-.3l.2-.4v-.5l.2-.4v-1l.2-.4v-1.8l.5.5zm0-1h.6v.4l-.5-.5zm0 0v1zm0 1"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M482 263h-22.5l-1.3.2H451l-1.3.2h-4.4l-1.2.2h-2.3l-6.3.4h-.3c-3 0-6 .3-9 .4h-.8l-18.2 1.3h-.2a965 965 0 0 0-26.4 2.4c-5 .6-6-5.3 0-6a960.5 960.5 0 0 1 26.3-2.2 983.7 983.7 0 0 1 37-2.2h2.4l15.4-.5h16.8a1082.3 1082.3 0 0 1 7.2 0h16.6l15.2.5h3.3a984 984 0 0 1 37 2.3 960.5 960.5 0 0 1 26.2 2c5.8.7 5 6.6 0 6a965.6 965.6 0 0 0-26.4-2.3h-.3a978.4 978.4 0 0 0-18.3-1.2h-.6l-9.2-.5h-.3c-2.2 0-4.3-.2-6.4-.3h-2.3l-1.2-.2h-4.5l-1.3-.2H506l-1-.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#0c4076",
              d: "M482 105a17.3 17.3 0 0 1 .1 34.7c-9.3 0-17-7.8-17-17.3 0-9.6 7.7-17.3 17-17.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M485.3 85c1.6-.2 3-1.5 3-3.2 0-1.7-1.4-3-3-3.2 0-1.7-1.4-3-3.2-3a3 3 0 0 0-3 3c-1.6 0-3 1.5-3 3.2a3 3 0 0 0 3 3v6.5h-5.5a3 3 0 0 0-3-3c-1.8 0-3 1.3-3.2 3a3 3 0 0 0-3 3c0 1.8 1.3 3.2 3 3.2a3 3 0 0 0 3 3c1.8 0 3.2-1.2 3.2-3h5.5V119h6.3V97.6h5.5a3 3 0 0 0 3 3c1.8 0 3-1.4 3.2-3 1.7 0 3-1.5 3-3.2a3 3 0 0 0-3-3c0-1.8-1.4-3.2-3-3.2-2 0-3.2 1.4-3.2 3h-5.5V85z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M487.8 81.8h1v1h-.2v.5h-.2v.3l-.2.3-.2.2v.2h-.2l-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2v.2h-.8l-.2.2h-.3v-1h.7V84h.2l.3-.2h.2v-.2h.2v-.2l.2-.2V83h.2l.2-.2v-.4l.2-.2zm-3-3.2h1l-.5-.5h.2l.3.2h.4l.3.2h.3l.2.2.2.2h.2v.2h.2l.2.2.2.3.2.2v.2h.2v.4h.2v.5l.2.2v.7h-1V81h-.2v-.4l-.2-.2V80h-.4v-.2h-.2v-.2h-.2l-.3-.2h-.2V79h-.8l-.4-.6zm.4.5h-.4v-.4zm-3-3v-1h.7l.2.2h.2l.3.2h.2l.2.2.2.2h.2v.3l.2.2.2.3.2.2v.2h.2v.4h.2v.8h.2v.3h-1V78h-.2v-.5h-.2v-.2l-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.4zh-.4zm-3.2 3v-1l-.5.6v-.8l.2-.2V77h.2v-.6h.2v-.2l.2-.2.2-.2.2-.2h.2v-.2h.3v-.2h.3l.3-.2h.4l.2-.2h.4v1h-.5v.2h-.3l-.2.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.2h-.2v.5h-.2v1l-.6.5zm.5-.4v.5h-.5zm-3 3.2h-1V81l.2-.3v-.5l.2-.2v-.2l.2-.2.2-.3.2-.2h.2l.2-.2h.2v-.2h.3v-.2h.5l.3-.2h.7v1h-.7l-.2.2h-.2l-.2.2-.2.2-.2.2-.2.2v.2h-.2v.4l-.2.2v.8zm3 3h-1l.5.6h-1V85h-.7v-.2h-.3v-.2h-.2l-.2-.2-.2-.2V84h-.2v-.2l-.2-.2-.2-.3v-.5h-.2v-1h1v1h.2v.4h.2v.2h.2v.2l.2.2h.2v.2h.2l.3.2h.7v.2h.2zm-.5-.4h.5v.5l-.5-.6zm-.5 7V85h1v6.3l-.5.5-.5-.5zm1 0v.4h-.5l.5-.5zm-6-.6h5.5v1h-5.5l-.5-.5zm0 1h-.5v-.5zm-3-3v-1h1.2v.2h.3l.3.2.3.2.3.2v.2l.2.2.2.3.2.3.2.3v.4l.2.2v.8h-1v-.7l-.2-.2V90h-.2v-.2h-.2v-.2l-.2-.2-.2-.2h-.2V89h-.4l-.2-.2h-.8zm-3.2 3v-1l-.5.4v-.8l.2-.3V90l.2-.3v-.2h.2v-.2l.2-.2h.2v-.3h.2l.2-.2.2-.2h.2V88h.7v-.2h1.1v1h-1l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2v.2h-.2v.4h-.2v.8l-.2.2v.3l-.5.5zm.5-.5v.5h-.5zm-3 3h-1V93h.2v-.2h.2v-.3l.2-.3.3-.3v-.2h.2v-.2h.2v-.2h.2l.2-.2h.2V91h.7l.2-.2h.8v1h-.7l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2v.2h-.2v.5h-.2v.7zm3 3.2h-1l.5.5h-1v-.2h-.5l-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2v-.2h-.3v-.2l-.2-.2V96h-.2v-.4l-.2-.3v-.8h1v.9h.2v.2l.2.3h.2v.2h.2v.2h.2v.2h.2l.2.2h.5v.2h.4l.6.5zm-.5-.5h.5v.5zm3 3v1h-1l-.2-.2h-.3v-.2h-.3v-.2h-.2l-.2-.2-.2-.3v-.2h-.2v-.3h-.2V99h-.2v-.5l-.2-.2V98h-.2v-.5h1v.7h.2v.4h.2v.2l.2.2v.2h.2v.2h.2v.2h.2l.2.2h.2l.3.2h.6zm3.2-3v1l.5-.4v.8l-.2.2v.3h-.2v.3l-.2.3-.2.2-.2.2-.2.2-.3.2-.2.2h-.2l-.2.2h-.2l-.3.2h-.8v-1h.9v-.2h.2l.2-.2h.2v-.2h.2l.2-.2V99h.2v-.2l.2-.3v-.2l.2-.2v-.4zm-.5.6V97h.5l-.5.6zm6 .5h-5.5v-1h5.5l.5.6zm0-1h.5v.6zm-.5 22V97.6h1V119l-.5.5-.5-.5zm.5.5h-.5v-.5zm6.3 0H479v-1h6.3l.5.5zm.5-.5v.5h-.5zm0-21.4V119h-1V97.6l.5-.5.5.6zm-1 0V97h.5l-.5.6zm6 .5h-5.5v-1h5.5l.5.6zm0-1h.4v.6zm3 3v1h-1l-.3-.2h-.2l-.3-.2-.2-.2h-.2v-.2h-.2l-.2-.2v-.2h-.2v-.2l-.2-.2V99h-.2v-.2h-.2v-1l-.2-.2h1v.4l.2.2v.2l.2.3v.2h.2v.2h.2l.2.2v.2h.2l.3.2h.2v.2h1.1zm3.2-3v1l.5-.5v.7h-.2v.5l-.2.3v.4h-.2v.3h-.2v.2h-.2v.2h-.3v.2l-.3.2h-.3l-.2.2h-.3l-.2.2h-.8v-1h.9v-.2h.2v-.2h.2l.2-.2.2-.2V99h.2v-.2l.2-.2v-.2l.2-.2v-.6l.6-.6zm-.5.5V97h.5l-.5.5zm3-3h1v.9l-.2.3v.2h-.2v.6h-.2l-.2.2v.2h-.2v.2h-.3v.2h-.2v.2h-.3l-.3.2h-.2l-.3.2h-.7v-1h.8V97h.2v-.2h.2l.2-.2.2-.2h.2V96l.2-.3v-.2h.2v-.7l.2-.3zm-3-3.2h1l-.5-.6h.7l.2.2h.4l.3.2.3.2.3.2.2.2.2.3.2.2v.5h.2v.3h.2v.7l.2.3v.4h-1v-.6h-.2v-.4l-.2-.2-.2-.2v-.2h-.2l-.2-.2-.2-.2h-.2V92h-.5l-.2-.2h-.5l-.5-.5zm.5.5h-.5v-.5zm-3-3v-1h1.1l.2.2h.4v.2h.3v.2l.3.2.2.3h.2v.3h.2v.4l.2.2v.4h.2v.7h-1v-.8h-.2V90l-.2-.2-.2-.2-.2-.2-.2-.2h-.2V89h-.5v-.2h-.6zm-3.2 3v-1l-.6.5v-.9l.2-.2V90l.2-.3.2-.3.2-.3h.2v-.2l.2-.2h.2v-.2h.2l.2-.2h.3l.2-.2h.3l.2-.2h1v1h-1l-.3.2h-.2v.2h-.2l-.2.2v.2l-.2.2-.2.2v.2l-.2.2v.7l-.7.6zm.5-.5v.5h-.6zm-6-.5h5.5v1h-5.5l-.5-.5zm0 1h-.5v-.5zm.5-7v6.5h-1V85l.4-.6.6.5zm-1 0v-.4h.4zm.5 0v-.4zm-.5 0v-.4h.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M499.8 122.4h-1v-1.7l-.2-1v-.7l-.3-.8-.2-.8-.2-.8-.3-.8-.3-.7-.4-.6-.4-.7-.4-.7-.5-.7-.5-.6-.5-.6-.6-.5-.7-.6-.6-.6-.6-.5-.5-.6-.7-.4-.7-.4-.6-.4-.8-.3-.7-.4-1-.3-.7-.2h-.8l-.8-.2h-.8l-1-.2h-1v-1h2l.8.2h1l.8.3.8.4.8.2.8.4.8.3.8.4.7.4.7.6.7.5.7.6.6.6.6.6.6.6.6.6.5.7.5.7.5.7.4 1 .4.6.4.8.3.8.3 1 .3.7.2.8v1l.2.7v2zM482 140.2v-1h1.8l1-.2.7-.2.8-.2.8-.2 1-.3.6-.2.8-.3.7-.4.8-.3.7-.4.6-.5.7-.5.6-.5.6-.6.5-.5.5-.6.5-.6.5-.6.4-.7.4-.6.4-.8.3-.7.3-1 .3-.6.3-.8.2-.8v-1l.2-.7v-1.6h1v2.8l-.2.8-.2.8-.3 1-.3.7-.3.8-.3.8-.3 1-.4.6-.5.7-.5.7-.5.7-.6.6-.6.7-.6.6-.6.5-.7.6-.7.5-.7.6-.7.4-.8.4-.8.4-.8.3-.8.4-.8.2-1 .2-.8.2h-.8l-1 .2h-1zm-17.5-17.8h1v1.8l.2.7v.8l.3.8.2.8.3.7.3 1 .3.6.5.8.4.7.3.8.5.6.5.6.5.7.6.5.5.6.5.5.7.5.6.5.7.4.7.4.7.5.7.3.7.3.8.4.8.2.8.2.8.2h1.8l.7.2v1h-1.8l-.7-.2-1-.2-.8-.2-.8-.2-1-.3-.7-.2-.8-.4-.8-.4-.7-.4-.7-.5-.7-.4-.7-.5-.7-.4-.7-.6-.5-.7-.5-.6-.5-.7-.5-.7-.5-.7-.4-.7-.4-1-.3-.7-.5-.8-.2-.8-.3-1-.2-.7v-1l-.2-.8v-1.8zm17.6-17.8v1h-1.7l-.7.2h-.8l-.8.3-.8.3-.8.3-.7.3-.8.2-.8.4-.7.4-.7.4-.6.5-.7.4-.6.5-.6.5-.6.6-.5.7-.5.6-.5.7-.4.7-.5.7-.4.7-.2.8-.3.8-.3.8-.2.8-.2.8v.8l-.2 1v1.7h-1v-2.8l.2-1 .2-.8.3-1 .2-.8.4-.8.2-.8.4-.7.4-1 .5-.6.5-.7.5-.7.6-.6.6-.6.7-.6.6-.6.6-.5.7-.4.7-.5.7-.3.8-.4.8-.3.8-.4 1-.2.7-.3h1l.8-.2h.8l1-.2h.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M499 118.8a17.6 17.6 0 0 1 0 6c-5.5-.2-11.2-.3-17-.3-5.5 0-11.2 0-17 .3a17.5 17.5 0 0 1 .3-6l16.8-.3c5.8 0 11.4.2 17 .3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M499.8 122.4h-1V120h-.2v-1l1-.2v1.7l.2.2v1.6zm-.7 3 .2-1-.6.3v-.8l.2-.2v-1.1h1v2.2h-.2zm.6-.5v.3h-.5l.6-.4zm-17.5 0v-1H494l.4.2h4.8v1h-10.6l-.5-.2h-6zm-17.4 0 1-.3-.5-.4h4.7l.4-.2H482v1h-11l-.5.2H465l-.5-.3zm.6.3h-.5v-.4l.5.3zm-.7-3h1v2.4l-1 .3v-2.6zm.8-4v1l.5-.3v.8l-.2.2v2.5h-1v-3h.2v-.4l.5-.5zm-.5.5v-.4h.5zm17.3-.8v1h-9.1l-.5.2H466l-.7.2v-1h2.5l.5-.2h9l.5-.2h4.2zm17.5.8-1 .2.4.4h-3.6l-.5-.2h-10.3l-.5-.2h-2.1v-1h10l.5.2h6.1l.5.6zm-.5-.5h.4v.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M468.8 133.2c-3.6-2.3-4.3 1.2-4.2 4.7.4 13.2 3 25.8-.6 42-1.4 6.4-3.7 10-1.5 11.3 5.7 3.2 8.3 6 7.4 7.7 1.5 3.2 5.7 2.6 12 1.6 6.6 1 10.7 1.6 12.4-1.6-1-1.6 1.7-4.5 7.4-7.7 2.2-1.2 0-5-1.5-11.3-3.5-16.2-1-28.8-.7-42 0-3.6-.5-7-4-4.8a28.6 28.6 0 0 1-26.8 0z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M465 138h-1v-1.5l.2-.3v-1.6l.2-.3v-.3h.2v-.4l.2-.2v-.3h.2l.2-.3.2-.2.2-.2h.2l.2-.2h1.8l.4.2.4.2h.3l.4.3-.4 1-.4-.3h-.2l-.3-.2h-.3l-.2-.2h-1.2v.2h-.2v.2l-.2.2v.2l-.2.2v.4l-.2.3v.4l-.2.2v2.5zm-.5 42-1-.2.3-1.5.3-1.4.3-1.6.2-1.4.2-1.5.2-1.4v-2.5l.2-1.4V154l-.2-1.2v-2.5l-.2-1.2V148l-.2-1.2v-1.2l-.2-1.3V142l-.2-1.3V138h1v3.5l.2 1.2v2.6l.2 1.2v1.3l.2 1.2v2.5l.2 1.2v1.3l.2 1.3v13.3l-.2 1.4v1.4l-.3 1.5-.2 1.4-.2 1.6-.2 1.4-.2 1.5-.3 1.6zm-1.8 11-.4.8-.3-.2-.2-.2-.2-.2-.2-.2v-.2l-.2-.3V188l.2-.3v-.4l.2-.3v-.4l.2-.4v-.5l.3-.4.2-.4v-.5l.3-.3v-.5l.3-.5v-.6l.3-.4.2-.6v-.6l.3-.6 1 .3-.2.7v.6l-.3.5v.6l-.2.5-.2.4v.6l-.3.4v.5l-.3.4v.4l-.2.4v.4l-.2.4v.4l-.2.3v.4l-.2.4v1.9zl.2.2zm7.6 7.8-1 .4v-.4h.2v-1l-.2-.2v-.2l-.2-.2v-.4l-.3-.2-.2-.2-.2-.3h-.3l-.2-.4-.3-.2-.3-.3h-.3l-.4-.4-.4-.3-.3-.2-.5-.2-.4-.3-.3-.3-.5-.3-.5-.3-.4-.3-.5-.3-.6-.2.5-1 .6.4.5.3.5.3.4.3.5.4.4.3.5.3.5.2.3.3.4.3.4.3.3.4.2.2.3.3.3.2.2.2.2.3.3.2.2.2v.2l.3.3v.2l.3.2v.5l.2.2v1.1l-.2.3v-.5zm-1 .4v-.4zm13 1-.2 1h.2-1.2l-.5.2h-1.2l-.6.2h-1l-.5.2h-4.7l-.4-.2h-.3l-.3-.2-.3-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.3h-.2l-.2-.4-.2-.4 1-.4v.2l.2.3.2.2.2.2.2.2h.2l.2.2h.2l.3.2h.3l.3.2h.3l.2.2h4.3l.5-.2h1l.6-.2h1.1l.5-.2h.8zm-.2 0h.2zm12-1 1-.4v.4l-.3.4-.2.3h-.2l-.3.4-.2.2-.3.2-.3.2-.3.2-.4.2h-.3l-.3.2h-.4l-.4.2H486l-.6-.2h-.5l-.6-.2h-1.2l-.5-.2h-.6l.2-1h1.8l.5.2h.6l.6.2h1.1l.5.2h4.2l.3-.2h.3l.2-.2h.3l.2-.2.2-.2.3-.3.2-.2.2-.2v-.3l.3-.2v.5zm1-.4v.4zm6.5-8 .5 1-.5.3-.5.4-.5.3-.4.2-.4.2-.4.3-.4.3-.4.3-.4.3-.3.3-.3.3h-.3l-.2.4-.3.2-.3.3h-.2l-.2.4-.2.2-.2.2v.2l-.3.2v.7h-.2v1.2l-.8.5v-.2l-.2-.2v-1.3l.2-.2v-.3l.3-.3v-.3l.3-.2.2-.3.2-.3.3-.3.2-.2.3-.3.3-.4.4-.2.3-.3.4-.2.4-.3.4-.3.4-.2.4-.3.5-.3.5-.3.5-.2.5-.3.5-.3.5-.3zm-1.7-10.7 1-.2v.6l.3.6.2.6.2.5v.7l.3.5v.5l.2.4v.6l.2.5.2.5v.4l.2.3v.4l.2.4v.5l.2.3v.7l.2.3v1.8l-.2.3v.2l-.3.3h-.2l-.2.3-.3.2-.5-1h.2l.2-.2v-.4h.2v-2.5l-.2-.3v-.3l-.2-.3v-.4l-.2-.4v-.4l-.2-.4v-.4l-.3-.5v-.6l-.2-.4v-.6l-.3-.5v-.6l-.3-.6v-.5l-.2-.6-.2-.6zm-.7-42h1v5.9l-.2 1.4v1.2l-.2 1.2v1.3l-.2 1.3v2.5l-.2 1.2v2.6l-.2 1.2v9.3l.2 1.4v1.4l.2 1.3.2 1.5.2 1.5.2 1.4.2 1.5.3 1.3.3 1.5-1 .3-.3-1.5-.3-1.5-.2-1.4-.2-1.5-.2-1.3-.2-1.5v-1.4l-.2-1.4V167l-.2-1.3v-10.3l.2-1.3v-2.5l.2-1.3V149l.2-1.2v-1.3l.2-1.2V143l.2-1.2zm-3.3-4.4-.5-1h.4l.3-.2.2-.2h.3l.4-.2h1.2l.3.2h.2l.2.3v.2l.2.2h.2v.4l.2.2v.3h.2v.7l.2.3v1.5l.2.3v1.1h-1v-2.4l-.2-.3v-.8l-.2-.3v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-1.1l-.2.2h-.3l-.3.2-.3.2zm-27 0 .4-1 .8.5.7.5.7.4.7.2.7.3.8.2.8.3 1 .2.7.2 1 .2h.7l1 .2h.8l1 .2h4.6l.7-.2h1l.8-.3h.8l1-.3.7-.2.8-.3.8-.2.8-.3.7-.4.8-.3.7-.4.7-.3.5 1-.7.3-.7.4-.8.4-.7.3-1 .4-.7.3-.7.3-1 .2-.7.2-1 .2h-.8l-1 .2h-1l-.8.2h-4.6l-1-.2h-.8l-1-.2-.8-.2-1-.2-.7-.2-.8-.3-.8-.3-.8-.3-.8-.2-.8-.4-.7-.4-.7-.4z"
            }),
            /* @__PURE__ */ jsxs201("g", {
              id: "rs_svg__b",
              children: [
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M363 212c-2-4-.3-9.8.3-11 .3-.8-.6-2.2-1-2.8-13-18.3-13.2-20-4.3-26.8 8-6 26.2-12 39.2-16.2 2.7-2 4.4-5 6.8-7.2-25 1.8-52 12-65.5 23.8-7.2 6.2 1.5 19 12.2 38 6.7 5 9.8 7 12.3 2.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m362.8 200.7 1 .4v.2l-.2.2v.3l-.2.3v.5l-.2.2v.6l-.2.4v.7l-.2.3v1.6l-.2.4v2.5l.2.4v.4l.2.4v.4l.2.4v.3l.3.4-1 .3v-.4l-.3-.5v-.4l-.2-.4v-.4l-.2-.5v-.8l-.2-.6v-2.9l.2-.4v-1.2l.2-.3v-.4l.2-.2v-.6l.2-.3v-.6l.2-.2v-.2l.2-.2zm-1-2.2 1-.6v.2h.2v.4h.2v.4h.2v.2l.2.2v.4h.2v1.2l-1-.3v-.6l-.2-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2zm-4-27.5.5 1-.8.5-.7.6-.7.6-.5.6-.6.5-.6.5-.5.6-.5.5-.3.4-.3.5-.3.5v.5l-.3.5v1.7l.2.6.2.8.2.7.4.8.4.8.4 1 .5 1 .6 1 .7 1 .7 1.3 1 1.2.7 1.3 1 1.4 1 1.5 1 1.5 1.3 1.7-.8.5-1.3-1.7-1-1.5-1-1.5-1-1.4-1-1.3-.8-1.2-.8-1.2-.7-1-.6-1-.7-1-.4-1-.6-1-.3-.7-.2-1-.2-.7v-.7l-.2-.7v-1.4l.2-.6.2-.6.2-.6.3-.6.4-.6.5-.5.5-.5.5-.5.6-.6.7-.5.7-.7.7-.6.7-.7zm39-16.2.7.8h-.2l-1.2.5-1.2.5-1.2.4-1.4.3-1.3.4-1.4.5-1.4.4-1.3.5-1.5.5-1.4.5-1.3.5-1.3.5-1.4.5-1.4.5-1.3.5-1.4.5-1.4.5-1.3.6-1.3.6-1.3.5-1.2.7-1.2.5-1.2.6-1 .5-1.2.6-1 .4-1 .6-1 .6-1 .5-1 .7-.7.6-.7.6-.6-1 .8-.5 1-.6.8-.7 1-.6 1-.6 1-.4 1-.6 1.2-.6 1.2-.5 1-.7 1.4-.6 1.3-.5 1.3-.6 1.3-.5 1.2-.4 1.4-.5 1.3-.5 1.3-.5 1.4-.5 1.3-.5 1.4-.5 1.4-.5 1.4-.4 1.4-.5 1.3-.4 1.3-.4 1.3-.4 1.3-.5 1.2-.4 1.3-.5 1.3-.4 1.2-.3zm.7.8h-.2zm6.6-7v-1l.4.8-.2.2-.3.2-.3.3-.2.3-.2.2-.2.2v.3l-.3.2-.2.2-.2.2-.2.3-.3.3-.2.3-.2.2-.2.3v.3l-.3.2-.2.3-.2.2-.3.2-.2.3-.2.2-.2.2h-.2l-.3.4-.3.2-.2.2-.3.2-.2.2-.3.2-.2.2-.6-.8v-.2l.3-.2.3-.2.2-.2.2-.2.2-.2.3-.2.2-.2.2-.2v-.2l.3-.3.2-.2.2-.2.2-.2v-.2l.3-.2.2-.2.2-.3.2-.3v-.3l.3-.2.2-.2.2-.3.2-.2v-.2l.4-.3.2-.2.2-.2.2-.3.2-.2h.3l.2-.3.4.8zm0-1 1.4-.2-1 1-.4-1zM338.8 172l-.7-.8 1.5-1 1.4-1.2 1.4-1 1.5-1.2 1.5-1 1.7-1 1.7-1 1.7-1 2-1 1.8-1 2-1 2-1 2-.8 2-1 2.2-.7 2-.8 2.3-.8 2.3-1 2.2-.6 2.3-.7 2.3-.6 2.4-.5 2.3-.6 2.4-.7 2.4-.5 2.4-.4 2.4-.4 2.4-.4 2.3-.3 2.3-.3 2.4-.3 2.3-.2v1l-2.3.2-2.3.3-2.3.3-2.3.3-2.4.4-2.3.4-2.4.4-2.3.5-2.3.6-2.3.5-2.3.6-2.3.7-2.2.7-2.2.7-2.2.8-2.2.8-2.2.8-2 1-2 .7-2.2 1-2 1-2 1-1.8.8-1.8 1-1.8 1-1.7 1-1.6 1-1.5 1-1.6 1-1.5 1.2-1.4 1-1.2 1.2zm12.2 37.3-.5.8-.2-.2-1-1.6-1-1.8-1-1.7-1-1.7-.8-1.7-1-1.6-.8-1.5-.8-1.5-1-1.5-.7-1.5-.8-1.4-.7-1.3-.7-1.4-.5-1.3-.6-1.3-.6-1.2-.4-1.2-.5-1.2-.3-1-.3-1-.4-1.2v-1l-.2-1v-2.8l.3-.8.3-.8.4-.7.5-.8.5-.7.6-.6.8.8-.6.5-.5.6-.4.7-.3.6-.3.7-.2.8v4.5l.4 1v1l.5 1 .4 1 .4 1.3.5 1.2.4 1.2.6 1.3.7 1.3.7 1.4.7 1.4 1 1.4.7 1.5 1 1.5.8 1.5 1 1.6.8 1.7 1 1.7 1 1.7 1 2 1 1.6h-.3zm-.5.8-.2-.2.2.3zm12.5 1.3v1l.5-.2-.3.4-.2.4-.3.4-.3.3-.3.2-.2.3-.3.2-.3.2h-.3l-.5.2h-2.1l-.4-.2-.5-.2-.4-.2-.3-.2-.5-.2-.4-.3-.5-.3-.5-.3-.4-.4-.6-.3-.5-.3-.5-.4-.6-.4-.5-.4-.6-.4-.5-.5.5-.8.7.4.5.3.6.5.6.3.5.5.4.4.5.2.4.3.4.3.5.3.4.3.4.2.5.2.4.2h.5l.3.2h1.5l.2-.2h.3l.2-.3.2-.2.3-.2.2-.3v-.3l.4-.4.2-.4.4-.4zm-.4.3v-.4h.4zm.4.6v-1l.5.3zm.5-.7.3.6h-.8z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M359 213.6a34 34 0 0 1-1-4.7c-.7-2.8-.4-5.7.5-8.3-3-4.2-6.4-8.8-8.8-13.3-1.7-3.3-3-7-2-10.6 1-4 4.5-6.6 7.6-9 3.7-2.8 8.6-5.3 13.6-7.5 11-4.6 20-7 26.5-7l-4.2 3.8c-12 4-26.4 9.2-33.3 14.5-9 6.8-8.6 8.4 4.3 26.7.4.6 1.3 2 1 2.7-.6 1.2-1.8 7.2 0 11.4-1 2-2.6 1-4.2 1.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m357.4 209 1-.2v.7l.2.2v.7h.2v.8l.2.3v.3l.2.3v.7h.2v.6h.2l-1 .4v-.3l-.2-.3v-.2l-.2-.3v-.5l-.2-.3v-.6h-.2v-.5l-.2-.3v-.7l-.2-.3v-.2zm.6-8 1-.6v.5l-.2.4v.2l-.2.2v1l-.2.2v.8l-.2.2v4.7l.2.3-1 .2v-.6l-.2-.2V203h.2v-1l.2-.2v-.5l.2-.2v-.2l.2-.3v.5zm1-.6v.5zm-9.7-12.8 1-.5v.6l.3.4.3.4v.4l.4.5.2.4.3.4v.5l.4.4.3.4.2.4.2.4.3.4.2.4.3.5.3.4.3.3.3.4.2.4.2.5.3.5.3.4.3.4.3.4.3.4.2.4.3.4.2.4.3.4.3.4.3.4.3.4-1 .6-.2-.4-.3-.4-.3-.4-.3-.4-.4-.4-.3-.4-.2-.4-.2-.4-.3-.4-.3-.4-.3-.5-.4-.4-.3-.3-.3-.4-.2-.4-.3-.5-.3-.5-.3-.4-.4-.4-.3-.4-.2-.5-.2-.4-.3-.5-.2-.4-.3-.4-.3-.4-.2-.4-.3-.5-.2-.4-.2-.5-.3-.5-.2-.4zm-2-11 1 .4-.2.3v4.1l.2.4v.3l.2.3v.7l.3.3v.4l.2.4v.6l.3.3v.3l.3.3v.2l.3.3v.3l.2.3-1 .6v-.3l-.2-.3-.2-.3v-.3l-.3-.4v-.3l-.3-.3v-.3l-.3-.3-.2-.3v-.3l-.2-.2v-.4l-.2-.3v-.3l-.2-.3v-.7l-.2-.4V180l-.2-.4V178l.2-.2v-.7l.2-.3zm7.7-9.2.6.8-.3.2-.3.3-.3.2h-.3l-.3.3-.2.3-.2.2-.3.3-.3.3-.3.2-.3.3-.2.2-.3.3-.4.3-.2.2-.3.3v.3l-.4.3-.2.3-.2.2-.3.3-.3.3-.2.3-.2.4v.3l-.3.3-.2.3v.3l-.3.3v.3l-.2.3v.4l-1-.3v-.4l.2-.4v-.4l.2-.4.2-.4v-.3l.3-.4.2-.2.2-.3.2-.3v-.3l.4-.5.2-.3.2-.2.3-.3.4-.3.2-.3.3-.2.2-.2.3-.3.2-.3.3-.2.3-.3.3-.2.3-.3.2-.2.3-.2.3-.3.3-.2h.4l.3-.4.3-.2zm13.7-7.5.4.8-.4.2-.4.2-.5.2-.5.2-.4.2-.5.2-.4.3-.6.2-.5.2-.5.2h-.5l-.4.3-.5.3-.3.2-.4.2-.5.3-.4.2-.4.2-.4.3-.5.2-.3.2-.4.3-.4.2-.5.2-.4.2-.2.3-.4.2-.4.2-.4.2-.3.3-.4.3-.4.2-.6-.8.3-.3h.4l.4-.4.4-.3.4-.2.4-.2.4-.2.4-.3.4-.2.4-.2.4-.2.4-.3.5-.2.5-.2.4-.2.4-.2.4-.3h.4l.5-.3.4-.3.6-.2.4-.2.5-.2.5-.3.4-.2.5-.2h.4l.4-.3.5-.2.5-.2.4-.2h.5zm27-6.4-.6-.7.5.7H394l-.6.2h-1.8l-.7.2h-.8l-.7.2h-.7l-.8.3-.8.2h-.7l-.8.2-.8.2-1 .2-.8.2-.8.3-1 .3-.8.3-1 .3-.8.2-1 .3-.8.3-1 .3-1 .5-1 .3-.8.4-1 .4-1 .4-1 .4-1 .4-.5-1 1-.4 1-.4 1-.4 1-.4 1-.3 1-.5 1-.3 1-.4 1-.3.8-.3 1-.3.8-.4 1-.2.8-.3h1l.8-.4.8-.2.8-.2.8-.2h.8l.8-.3.8-.2h.7l.7-.2h.8l.7-.2h1.4l.5-.2h1.9l.4.8zm-.3-1h1.4l-1 1zm-4.4 4 4-3.7.8.6-4 3.8-.3.2zm.7.8-.2.2zM358.3 172l-.6-1 .7-.5.7-.5 1-.5.7-.5.8-.5 1-.5.8-.4 1-.5 1-.4.8-.5 1.2-.4 1-.5 1-.3 1-.5 1.2-.5 1-.4 1.3-.5 1-.4 1.2-.5 1-.5 1.3-.5 1-.4 1.3-.4 1.2-.5 1.2-.4 1.2-.4 1.2-.5 1-.4 1.3-.3 1.2-.4 1-.3 1.2-.4.3 1-1.2.3-1 .3-1.3.4-1 .4-1.3.5-1.2.4-1.2.3-1.2.4-1 .4-1.2.6-1.2.4-1 .4-1.3.5-1 .3-1.3.5-1 .4-1.2.5-1 .4-1 .6-1.2.5-1 .5-1 .5-1 .5-1 .5-.8.5-1 .4-.8.4-.8.5-.8.4-.7.5-.7.4zm4.4 26-.8.5-1.3-1.7-1-1.5-1-1.5-1-1.4-1-1.3-.8-1.2-.8-1.2-.7-1-.6-1-.7-1-.4-1-.5-1-.4-.7-.2-1-.2-.7v-.7l-.2-.7v-1.4l.2-.6.2-.6.2-.6.3-.6.4-.6.5-.5.5-.5.5-.5.6-.6.7-.5.7-.7.7-.6.7-.7.6 1-.8.5-.7.6-.7.6-.5.6-.6.5-.6.5-.5.6-.5.5-.3.4-.3.5-.3.5v.5l-.2.6v2.2l.3.8.3.7.4.8.4.8.4 1 .6 1 .5 1 .7 1 .7 1.3 1 1.2.7 1.3 1 1.4 1 1.5 1 1.5 1.3 1.7zm1 3-1-.3v-1h-.2v-.2l-.2-.2v-.2h-.2v-.4l.7-.7.2.2v.4h.2v.2l.2.2v.2l.2.2v.4h.2v1.4zm.2 11.6-1-.5v.6l-.2-.4-.2-.5v-.4l-.2-.4v-.6l-.2-.4v-.5l-.2-.4v-5.4l.2-.4v-.7l.2-.4v-.5l.2-.3v-.4l.2-.2 1 .3v.2l-.2.2v.6l-.2.2v.6l-.2.3v1.1l-.2.4v5.1l.2.4v.8l.3.4v.4l.2.4zv.4zm0-.4v.4zm-5 1v1zh.2l.2-.2h1.4v.2h1.5l.2-.2h.2v-.2h.2v-.2l.2-.2.2-.3 1 .6-.2.2-.2.2v.2l-.2.2h-.2v.2l-.3.2h-.4l-.2.2h-.3v.2h-3v-1zm0 1v-1l.6.2-.5.7zm.6-.8.2.7h-.7l.6-.6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M468 132.2c.3-2.3 0-2-.3 1.6-.3-.7-.8-1-1.4-1-1 0-1.7 1.6-1.8 5.2l.2 2.8c-33-.7-52.7 4.3-57.7 14-4.2 7.8 3 21 13.6 36 1.3 1.8 1.2 1.6 0 3-1.8 2.3-3.8 6-2.3 9.2a24.3 24.3 0 0 1-21 1.5c-1-3-3.4-4.4-5.4-5.8-.5-.2-2-1-2-1.4l-10.2-31.6c-9.5-30.7 75.3-33.5 88.3-33.5"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m467.3 134 1-.4-1 .2V132h.2v-1.2l.2-.2.6-.3.3.3v1.6h-1V131l.4.2h.6v-.2 1l-.2.2v1.8h-1zm1 0-.2 1.6-.7-1.5h1zm-2-.7v-1h.7v.2h.4v.2h.2v.2h.2v.2h.2v.2h.2v.2l-1 .5v-.2h-.2v-.2h-.2v-.2zM465 138h-1v-1.8l.2-.3v-.9l.2-.3v-.7h.2v-.3l.2-.3.2-.3.2-.2h.2v-.2h.2v-.2h.5v1h-.2v.2h-.2v.2l-.2.2v.3l-.2.3v.6l-.2.2v2l-.2.3v.4zm-.3 3.3v-1l-.5.5v-2.3h-.2v-.4l1-.2v1.8l.2.2v1zm.5-.5v.5h-.5zM407.4 155l-1-.5.7-1 .7-.8.7-1 .8-.7 1-.8 1-.8 1-.8 1-.7 1.3-.7 1.2-.7 1.4-.6 1.6-.6 1.5-.5 1.7-.7 1.7-.5 1.8-.4 2-.5 1.8-.5 2-.3 2.2-.4 2.2-.3 2.2-.2 2.4-.3 2.4-.2 2.5-.2h2.5l2.7-.2h2.7l2.8-.2h9v1H453l-2.8.2h-2.6l-2.6.2-2.5.2-2.4.2-2.3.3-2.2.2-2.2.3-2 .4-2 .3-2 .4-1.8.4-1.8.4-1.7.5-1.6.5-1.5.6-1.5.5-1.3.5-1.3.7-1.2.6-1 .7-1 .7-1 .7-1 .7-.6.8-.7.8-.6.8-.6 1zm13.6 35.5-.8.6-1-1.3-1-1.4-1-1.4-1-1.5-.8-1.3-.8-1.4-1-1.3-.7-1.3-.8-1.3-.8-1.4-.7-1.2-.7-1.3-.6-1-.6-1.3-.5-1.2-.5-1.2-.5-1.2-.4-1-.5-1-.3-1.2-.3-1-.3-1-.2-1.2v-1l-.2-1V158l.3-.8.3-1 .2-.7.3-.8 1 .5-.4.7-.2.7-.2.8-.2.8v4.5l.2 1 .3 1v1l.5 1 .3 1.2.4 1 .5 1.2.5 1 .5 1.2.6 1.2.6 1.2.6 1.3.7 1 .7 1.4.8 1.3.8 1.3.8 1.3 1 1.3.8 1.4 1 1.3.8 1.4 1 1.4 1 1.5zm0 3.8-.8-.7.2-.3.2-.2h.2v-.2l.2-.2v-.4l-.2-.2v-.2h-.2v-.3h-.2v-.3h-.2l.8-.7.2.3.2.3v.2h.2v.4h.2v.2l.2.2v1l-.2.2v.2h-.2v.2l-.2.2-.2.2-.2.3zm-2.5 9-.4-.8-.2.7v-.3l-.2-.5v-.3l-.2-.3v-3.5l.2-.3v-.3l.2-.4.2-.3v-.3l.2-.3.2-.3v-.3l.3-.2v-.3l.3-.2.2-.3v-.2l.3-.3.2-.2v-.3l.3-.2.2-.2.8.7-.2.2-.2.2v.2h-.3v.3l-.3.3-.2.2v.3l-.3.3v.3l-.2.2-.2.3v.7l-.2.2v.2l-.2.3v.6l-.2.4v2.7l.2.3.2.3-.3.6zm.3-.5v.4l-.3.2zm-22 1.8 1-.3-.2-.3.6.2.7.3.5.2.6.2h.8l.6.2.6.2h.7l.6.2h5.7l.7-.2h.5l.7-.3h.6l.7-.2.6-.2.7-.2.7-.2.6-.2.6-.3.6-.3.6-.2.7-.4.6-.3.5 1-.6.2-.7.4-.6.4-.7.2-.6.3-.7.2-.6.2-.6.2-.7.2-.6.2h-.6l-.7.3h-.7l-.6.2h-.7l-.7.2h-5l-.7-.2h-.7l-.6-.3h-.7l-.7-.3-.6-.3-.7-.3-.6-.2-.8-.3-.3-.4zm.4.3-.2-.2v-.2zm-5.6-5.8.6-1 .2.2.2.2h.2l.2.2.2.2h.2l.2.2v.2h.3v.3h.3l.2.3h.2l.2.3.3.3.2.2.2.2.2.2v.2l.3.2v.2l.3.2.2.2v.2l.3.3.2.2.2.2v.2l.3.3v.3l.2.3-1 .3-.2-.2v-.3h-.2v-.3l-.2-.3-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.3-.2-.2-.2-.3-.3-.2-.2-.3-.3h-.2l-.2-.3v-.2l-.3-.2h-.2v-.3h-.3l-.2-.2h-.2l-.2-.2h-.2l-.2-.3h-.2zh-.2zm-2-1.7.8-.3h.2v.2h.2l.2.2h.2v.2h.4v.2h.2l.2.2h.2l-.6 1-.2-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2zm-10.2-31.7 1-.3.2 1 .3 1 .2.8.3 1 .3 1 .3.8.4 1 .3 1 .3 1 .3 1 .3 1 .3.8.2 1 .4 1 .3 1 .2 1 .3 1 .3 1 .4 1 .3 1 .3 1 .3 1 .5 1 .3 1 .3 1 .5 1 .3 1 .3 1 .4 1.2.4 1 .3 1 .4 1.2-1 .3-.3-1-.2-1.2-.3-1-.4-1-.2-1-.3-1-.3-1.2-.4-1-.3-1-.3-1-.4-1-.3-1-.3-1-.3-1-.4-1-.4-1-.3-1-.4-1-.3-1-.3-.8-.3-1-.4-1-.3-1-.3-1-.3-.8-.3-1-.2-1-.3-1-.3-.8-.3-1-.4-.8-.2-1zm88.2-33.6h1l-.5.5h-5.4l-2.5.2h-2.8l-3 .2-3.3.2-3.5.2-3.7.3-3.8.3-4 .4-4 .5-4 .6-4.2.6-4 .7-4.2 1-4 .8-4 1-3.7 1-3.7 1.3-3.4 1.4-3.3 1.4-3 1.5-2.6 1.6-2.3 1.7-2 2-1.6 1.8-1.2 2.2-.8 2.2-.4 2.3v2.5l.7 2.7-1 .3-.6-2.8v-2.8l.3-2.6 1-2.4 1.2-2.2 1.8-2 2-2 2.5-2 2.7-1.6 3-1.5 3.3-1.6 3.5-1.3 3.6-1 4-1.2 3.8-1 4-1 4-.7 4.2-.6 4.2-.6 4-.6 4-.5 4-.4 4-.4 3.7-.4 3.5-.2 3.3-.2 3-.2h3l2.4-.2h5.4l-.6.4zm1 0v.5h-.5l.7-.5zm-.5 0h-.4zm.7 0v.5h-.6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M405 190.2c3.5 0 6.4 2.8 6.4 6.4 0 3.5-3 6.4-6.4 6.4s-6.4-3-6.4-6.4c0-3.6 3-6.4 6.4-6.4"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M412 196.6h-1a6 6 0 0 0-3.4-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.6zm-7 7v-1c2.2 0 4.3-1.4 5.2-3.4a6 6 0 0 0 .7-2.6h1c0 2.3-1.4 4.6-3.4 6a7 7 0 0 1-3.6 1zm-7-7h1c0 2.2 1.4 4.3 3.4 5.3a5.8 5.8 0 0 0 2.6.5v1a7 7 0 0 1-5.8-3.3 7 7 0 0 1-1-3.6zm7-7v1a6 6 0 0 0-5.2 3.3 6 6 0 0 0-.7 2.6h-1c0-2.4 1.4-4.7 3.4-6a6.8 6.8 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M350.8 203.6c3.2 0 6 2.7 6 6s-2.8 6-6 6c-3.3 0-6-2.7-6-6s2.7-6 6-6"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M357.2 209.6h-1c0-2-1-4-2.8-4.8a5.4 5.4 0 0 0-2.6-.7v-1a7 7 0 0 1 5.4 3 6.5 6.5 0 0 1 1 3.6zm-6.4 6.4v-1c2 0 4-1.2 4.8-3a5.5 5.5 0 0 0 .6-2.4h1c0 2-1.2 4.3-3 5.4a6.4 6.4 0 0 1-3.4 1m-6.5-6.4h1c0 2 1.2 4 3 4.8.8.4 1.6.6 2.5.6v1a6.6 6.6 0 0 1-5.5-3 6.5 6.5 0 0 1-1-3.4m6.5-6.5v1c-2 0-4 1.3-5 3a5.5 5.5 0 0 0-.5 2.6h-1c0-2.2 1.2-4.4 3-5.5a6.4 6.4 0 0 1 3.5-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M345 192.7c3.4 0 6 2.7 6 6s-2.6 6-6 6c-3.2 0-5.8-2.7-5.8-6s2.6-6 6-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M351.5 198.7h-1c0-2-1.2-4-3-5a5.3 5.3 0 0 0-2.4-.5v-1c2.3 0 4.4 1.2 5.5 3a6.5 6.5 0 0 1 1 3.5zM345 205v-1c2 0 4-1 4.8-2.7a5.5 5.5 0 0 0 .7-2.6h1c0 2.2-1.2 4.3-3 5.5a6.4 6.4 0 0 1-3.4 1zm-6.3-6.3h1c0 2 1.2 4 3 4.8a5 5 0 0 0 2.4.6v1c-2 .2-4.2-1-5.3-3a6.5 6.5 0 0 1-1-3.3zm6.4-6.5v1c-1.8 0-3.7 1-4.6 2.8a5.5 5.5 0 0 0-.7 2.7h-1c0-2.2 1.2-4.4 3-5.5a6.4 6.4 0 0 1 3.4-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M339.8 181.7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M346.2 187.7h-1c0-2-1.2-4-3-5a5.4 5.4 0 0 0-2.4-.5v-1c2.2 0 4.3 1.2 5.4 3a6.5 6.5 0 0 1 1 3.5m-6.4 6.4v-1c2 0 3.8-1 4.7-2.7.5-.8.7-1.7.7-2.6h1c0 2-1 4.3-3 5.4a6.4 6.4 0 0 1-3.4 1zm-6.4-6.3h1c0 2 1 4 3 4.8.7.4 1.5.6 2.4.6v1a6 6 0 0 1-5.4-3 6.5 6.5 0 0 1-1-3.3zm6.4-6.5v1c-2 0-4 1.2-4.8 3a5.5 5.5 0 0 0-.6 2.5h-1c0-2.2 1-4.4 3-5.5a6.4 6.4 0 0 1 3.4-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M444.3 202.2c3.4-.3 2.5 5.8 2 7.2-1 1.8-1.8 1.8-3 .2-.8-1.3-2.4-7.2 1-7.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m446.6 209.6-1-.4h.2v-.7l.2-.3v-.5l.2-.3V204h-.2v-.3l-.2-.2v-.2l-.2-.2h-.2l-.3-.2h-.2l-.2-.2h-.3v-1h.7l.3.2h.3l.3.2v.2l.3.3.2.2.2.3v.2l.2.3v.7l.2.3v3.7l-.2.3v.5l-.2.3v.5h-.2zm-3.7.3.8-.7.2.3v.2h.2v.2h.2v.2h.7l.2-.2v-.2h.2v-.2h.2v-.3l1 .3v.2l-.2.2v.3h-.2v.2l-.2.2-.2.2h-.4v.2H444v-.2h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.3h-.3zm1.2-8.4v1h-.4v.2h-.3v.2h-.3v.3l-.2.2v.4h-.2v3.2l.2.2v.6l.2.2v.3l.2.2v.2l.2.2v.2h.2l-1 .7v-.5l-.2-.2v-.2l-.2-.4v-.2l-.2-.3v-.2l-.2-.3v-.7l-.2-.3v-3l.2-.3v-.3l.3-.3.2-.2.2-.3h.2l.2-.3.3-.2h.4l.2-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M444.5 205.5c8-.6 6 13.8 4.4 17-2 4.2-4 4.3-6.7.5-2-3-5.8-17 2.2-17.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m449.4 222.7-1-.4.2-.3.2-.4v-.4l.3-.5.2-.5v-.6l.2-.6.2-.7V217l.2-.7v-5.1l-.3-.7v-.6l-.3-.7-.3-.6-.3-.5-.3-.5-.3-.4-.3-.4-.4-.4-.5-.2-.5-.2-.5-.2h-1.4v-1h1.5l.6.2.7.2.5.4.6.4.4.4.4.5.4.7.3.6v.7l.3.6.2.7v.7l.3.8v6.3l-.3.7v.7l-.2.6v.6l-.3.6v.5l-.3.5v.4l-.3.3zm-7.5.5.8-.5.2.3.2.3.3.3.2.3h.2v.4h.3l.2.3.2.2h.4l.2.2h1v-.2h.3l.2-.3v-.2l.2-.2.2-.2h.2l.2-.4v-.3l.3-.3.3-.3.2-.4 1 .4-.3.4-.2.5-.2.3-.2.4-.2.3-.2.3-.2.2-.2.2-.2.3-.3.2h-.2v.3h-.4l-.2.2H445l-.4-.2h-.2l-.3-.3v-.2l-.4-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.4-.2-.4zm2.5-17.2v-1zh-.6l-.7.2-.5.2-.5.3-.4.3-.5.4-.3.4-.3.4-.3.6-.2.5v.6l-.2.5v.7l-.2.7v.6l.2.7v1.4l.2.7v.8l.3.7v.6l.3.7.2.6.2.5.2.6.2.7.2.5.2.4.2.4.2.4.2.3-1 .5v-.3l-.3-.5-.2-.4-.2-.4v-.6l-.4-.5-.2-.7-.2-.6-.2-.7-.2-.7v-.7l-.3-.6v-.8l-.2-.7V213l-.2-.7v-.8l.2-.7v-.6l.2-.7v-.7l.4-.6.2-.6.4-.6.4-.5.4-.5.5-.4.6-.3.7-.3.7-.2h.8v1zm0-1v1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M379.7 210.8c3.3-1 4 5 3.6 6.6-.4 2-1.2 2.2-2.7 1-1-1.2-4-6.5-1-7.6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m383.8 217.5-1-.2v-2.8l-.2-.3v-.7l-.2-.3v-.3l-.2-.2v-.3l-.3-.2-.2-.2-.3-.3-.3-.3h-.3l-.3-.2h-.6l-.4-1h1.5l.2.2.3.2.2.2.3.2.2.3.2.2v.3l.3.3v.4l.2.3v.3l.2.3v.3l.2.4v.6l.2.3v2.5zm-3.5 1 .7-.6h.2v.2h.2l.2.2h.2v.2h.4l.2-.2v-.2h.2v-.6h.2v-.3l1 .2v.4h-.2v.4l-.2.3v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-1v-.2h-.3l-.2-.2h-.2v-.2h-.2zv-.2zm-.7-8.2.3 1h-.3l-.2.2h-.2v.2l-.2.2v.2l-.2.2v1.8l.2.4v.3l.2.3v.2l.2.3.2.3v.3l.2.3.2.3v.2l.3.2v.2l.2.2.3.3.2.2-.7.6h-.2v-.4l-.3-.2v-.2l-.3-.2v-.3l-.3-.2v-.2l-.2-.3v-.3l-.3-.3v-.4l-.2-.3v-.3l-.3-.3v-.7l-.2-.3V212l.3-.2.2-.3.2-.3.3-.2.2-.2h.2l.4-.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M380.7 214c7.7-2.5 9.2 12 8.4 15.5-1 4.5-2.8 5-6.2 2-2.6-2.4-9.7-15-2-17.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m389.6 229.6-1-.2v-.8l.2-.4v-2.9l-.2-.7V223l-.3-.7v-.7l-.3-.8-.2-.7-.2-.6-.2-.7-.3-.7-.2-.6-.3-.6-.3-.4-.4-.5-.3-.4-.4-.3-.4-.4-.4-.4-.5-.2h-.5l-.5-.2h-1.1l-.6.3-.4-1 .7-.2h2.2l.7.2.7.2.5.4.5.5.5.4.4.5.4.5.4.6.3.7.3.6.3.6.3.7.2.8.2.8.2.7v.8l.3.7v1.5l.2.7v4.4zm-7 2.3.5-1 .5.4.2.2.3.3h.3l.3.3h.2l.3.3h.3l.2.2h1.4l.2-.2.2-.2.2-.3.3-.3v-.6l.2-.2v-.3l.2-.4v-.2l.2-.4 1 .2v.4l-.2.4v.4l-.2.4-.2.3v.3l-.2.3-.2.4v.3l-.3.2h-.2v.3l-.3.2h-.2l-.2.3h-.8l-.3.2h-.5l-.3-.2h-.2l-.3-.2h-.4l-.3-.3-.3-.2h-.3l-.3-.3-.3-.3-.2-.2-.3-.3zm-2-18.5.3 1-.7.2-.6.3-.4.3-.4.4-.4.4-.3.5-.2.5v.5l-.2.6v2.5l.2.6.2.7.2.6.2.7.3.7v.7l.4.6.3.7.4.6.4.6.3.6.4.6.4.5.3.4.3.4.4.4.2.4.3.3-.5 1-.3-.4-.3-.3-.4-.4-.4-.5-.3-.5-.4-.5-.4-.6-.3-.7-.5-.6-.3-.6-.4-.6-.3-.6-.3-.7-.3-.7-.3-.7-.3-.7-.2-.8-.2-.8v-.7l-.2-.7V218l.2-.7.2-.6.2-.6.3-.5.4-.5.6-.5.6-.4.7-.2.6-.3zm0 .5v-.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M464.2 137.8c-17.2-1.6-35 .2-52.3 7-14.8 6-13.4 23.2 4.6 47-1.7 3-2.6 6.8-2.7 11h4.8c-1.3-2.8 0-6.4 1.8-9 1-1.5 1.3-1.2 0-3-10.7-15-17.8-28.2-13.6-36 5-9.7 24.6-14.7 57.7-14 0-1 0-1.8-.2-2.7 0 0-.2 0-.3-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m412 145.4-.3-1 1.7-.6 1.6-.6 1.7-.6 1.6-.5 1.6-.4 1.6-.5 1.6-.4 1.7-.4 1.5-.4 1.7-.4 1.6-.4 1.7-.3 1.6-.3 1.8-.3h1.6l1.7-.3 1.7-.2 1.7-.2 1.6-.2h3.3l1.6-.2h11.5l1.6.2h1.6l1.6.3v1l-1.7-.2h-4.9l-1.6-.2h-9.7l-1.6.2H443l-1.5.3-1.7.2-1.6.2-1.6.2H435l-1.7.4-1.6.3-1.7.3-1.6.4-1.6.3-1.7.5-1.5.4-1.6.4-1.8.5-1.6.6-1.6.6-1.7.6-1.6.6-1.6.6zm5 46.7-1-.4.2.5-1.7-2-1.5-2.3-1.5-2-1.3-2.2-1.3-2-1.2-2-1-2-1-2-1-2-.7-1.7-.6-1.8-.5-1.8-.6-1.7-.4-1.6-.3-1.7-.2-1.6v-4.4l.2-1.3.3-1.3.4-1.2.5-1.2.5-1.2.7-1 .8-1 .8-1 1-.7 1-.8 1.3-.8 1.4-.6 1.3-.5.4 1-1.2.5-1.2.6-1 .7-1 .8-1 1-1 .8-.6 1-.7 1-.5 1-.5 1-.3 1.2-.3 1.2-.2 1.2v3.8l.2 1.5.3 1.7.3 1.6.5 1.6.6 1.6.7 1.8.8 1.8 1 2 .8 1.8 1 2 1.2 2 1.2 2 1.4 2 1.4 2.2 1.5 2 1.7 2.3zm0-.5.2.3-.2.3v-.5zm-3 11v1l-.6-.6v-2.5l.2-.4v-1l.2-.4v-.7l.2-.5v-.4l.2-.2v-.4l.2-.3v-.3l.2-.3v-.4l.2-.3v-.3l.2-.3v-.3l.3-.3v-.3l.2-.2.2-.3v-.3l.3-.3v-.4l1 .5v.4l-.3.2v.3l-.2.2-.2.3v.3l-.2.3v.4l-.2.3v.3l-.2.4v.3l-.2.3v.3l-.2.4v.7l-.2.3v.8l-.2.4v.8l-.2.4v1.4l-.2.4v.7l-.5-.6zm0 1h-.6v-.6l.5.5zm4.3-.4 1-.4-.5.8h-4.6v-1h4.6l-.5.7zm1-.4.3.7h-.8l.4-.7zm1-9 .7.6-.2.2v.3l-.2.2-.2.2v.2l-.3.3v.4l-.2.3-.2.2v.3l-.2.3v.2l-.2.3v.7l-.2.2v.5l-.2.3v2.2l.2.3v.4l.2.2-1 .5v-.5l-.2-.3v-.7l-.2-.3v-2.7l.2-.3v-.3l.2-.2v-.3l.2-.3v-.3l.2-.4v-.3l.2-.3.2-.3v-.2l.2-.3.2-.3v-.3l.3-.3v-.3h.3l.2-.3zm0-2.5.7-.5.2.3.2.3v.2h.2v.4h.2v.4l.2.2v.5l-.2.2v.2h-.2v.2l-.2.2v.2h-.2v.3l-.2.2-.8-.6v-.2l.2-.2.2-.2v-.2h.2v-.4h.2v-.2h-.2v-.2l-.2-.2v-.3h-.2v-.3h-.2zm-13.8-36.5 1 .5-.4.7-.2.7-.2.8-.2.8v4.5l.2 1 .3 1v1l.5 1 .3 1.2.4 1 .5 1.2.5 1 .5 1.2.6 1.2.6 1.2.6 1.3.7 1 .7 1.4.8 1.3.8 1.3.8 1.3 1 1.3.8 1.4 1 1.3.8 1.4 1 1.4 1 1.5-.8.6-1-1.3-1-1.4-1-1.4-1-1.5-.8-1.3-.8-1.4-1-1.3-.7-1.3-.8-1.3-.8-1.4-.7-1.2-.7-1.3-.6-1-.6-1.3-.5-1.2-.5-1.2-.5-1.2-.4-1-.5-1-.3-1.2-.3-1-.3-1-.2-1.2v-1l-.2-1V158l.3-.8.3-1 .2-.7.3-.8zm57.7-13.7h1l-.5.5h-14.5l-2.6.2H445l-2.5.3-2.4.2-2.3.3-2.2.2-2.2.3-2 .4-2 .3-2 .4-1.8.4-1.8.4-1.7.5-1.6.5-1.5.6-1.5.5-1.3.5-1.3.7-1.3.6-1 .7-1 .7-1 .7-.8.7-.8.8-.7.8-.6.8-.6 1-1-.5.7-1 .7-.8.7-1 .8-.7 1-.8 1-.8 1-.8 1-.7 1.2-.7 1.3-.7 1.4-.6 1.6-.6 1.5-.5 1.7-.7 1.7-.5 1.8-.4 2-.5 1.8-.5 2-.3 2.2-.4 2.2-.3 2.2-.2 2.4-.3 2.4-.2 2.5-.2h2.5l2.7-.2h2.7l2.8-.2h9l-.6.6zm1 0v.5h-.5zm-1-2.3.7-.7v1.9h.2v1h-1v-2.3l-.2-.2v-.4.3zm.7-.7v.3-.2zm-1.2-.4.8.7v-.6.2h.2v.2l-.7.7v-.4h-.2v-.6zm0 .7-.3-.2.3-.4zm.8 0-.8-.6h.4zm-.4-.7h1l-.6.8-.4-.7z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M380.6 142.7c3.4 0 6 2.7 6 6s-2.6 6.3-6 6.3-6.2-2.7-6.2-6.2a6 6 0 0 1 6.2-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M387.2 148.8h-1c0-2-1.2-4-3-5a5.6 5.6 0 0 0-2.6-.6v-1c2.2 0 4.5 1.2 5.6 3a6.7 6.7 0 0 1 1 3.6m-6.6 6.7v-1c2 0 4-1.2 5-3a7 7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1m-6.7-6.7h1c0 2 1.2 4.2 3 5a5.6 5.6 0 0 0 2.6.7v1a6.6 6.6 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7m6.6-6.7v1.2c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1c0-2.2 1-4.4 3-5.6a6.6 6.6 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M392.6 138.7c3.4 0 6.2 2.8 6.2 6.2 0 3.3-2.8 6-6.2 6a6 6 0 0 1-6-6c0-3.5 2.6-6.3 6-6.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M399.3 145h-1c0-2.2-1.3-4.3-3.2-5.2a5.6 5.6 0 0 0-2.4-.6v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.7zm-6.7 6.6v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .7-2.7h1c0 2.2-1.2 4.4-3.2 5.6a6.6 6.6 0 0 1-3.4 1zM386 145h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.6.6v1a6.7 6.7 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.5zm6.6-6.8v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.7h-1c0-2.4 1.2-4.7 3.2-5.8a6.6 6.6 0 0 1 3.4-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M394.2 144a261.2 261.2 0 0 0 2 2.4c-9.8 5.4-14 11-13 16.7.2 1 3.2 11.5 9.8 31.7 4.5 3 7.8 6 10 8.4-.2.4.8 1.2.5 1.5.7 3-2.8 2.4-5 1.7-1.2-3-4.6-6-6.6-7.5-.5-.2-2-1-2-1.4l-10.2-31.6c-3-9.8 3.6-16.8 14.4-21.7z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m396.3 147-.5-1v.7h-.2v-.2h-.2v-.2l-.2-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2l.8-.7.2.2h.2v.4h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l.2.2v1zm.2-1 .3.6-.5.3zm-12.7 17-1 .2v-3.9l.2-.6.2-.5.2-.6.2-.5.3-.5.2-.5.3-.6.4-.5.3-.6.4-.6.5-.5.4-.6.6-.5.5-.5.6-.5.6-.6.5-.5.7-.4.7-.5.6-.5.8-.5.8-.5 1-.5.7-.5.8-.5.5 1-1 .4-.7.5-.8.4-.8.5-.8.4-.7.5-.7.4-.6.5-.7.4-.6.5-.6.4-.5.5-.6.4-.5.6-.5.5-.4.5-.3.5-.3.5-.3.5-.2.5-.2.5-.2.5-.2.5-.2.5v.5l-.2.5v3.1zm9.5 31.3-.6.8-.2-.2-.6-1.8-.7-1.8-.5-1.8-.6-1.7-.5-1.6-.5-1.5-.5-1.5-.5-1.5-.4-1.4-.4-1.2-.4-1.3-.4-1.3-.4-1-.3-1.3-.4-1-.3-1-.3-1-.3-1-.3-.8-.2-.8-.2-.8-.2-.6-.2-.7v-.5l-.3-.5v-.5l-.2-.4v-.8h-.2v-.3h1v.3l.2.3v.4l.2.3v.5l.2.5.2.6.2.7.2.7.2.7.2 1 .3.7.2 1 .2 1 .3 1 .3 1 .4 1 .4 1.2.3 1.2.3 1.3.5 1.3.4 1.4.5 1.5.4 1.5.7 1.6.5 1.6.5 1.7.6 2 .6 1.7.5 1.8-.2-.2zm-.6.8-.2-.2.2.3zm10.7 8.4-.7-.6v.6l-.2-.2-.2-.2-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2-.2-.2-.2-.3-.3-.2-.3-.2-.2-.2-.3-.3-.3-.3-.3-.2-.4-.3-.3-.2-.4-.3-.4-.3-.3-.2-.4-.3-.4-.3-.4-.3-.3-.3-.5-.3-.4-.2-.3-.3-.4-.2-.4-.3-.5-.3-.4-.3-.3-.3.6-.7.4.3.4.3h.5l.4.4.3.3.4.3.4.3.5.3.3.2.4.3.3.4.4.3.2.2.4.2.3.3.2.2.3.3.3.3.3.2.4.3.3.2.3.3.3.3.2.2.3.3.3.3.3.3.2.2.3.2.2.3.2.2.2.3v.6zm0-.6.3.3-.3.4v-.6zm.6 1.6-1 .2.2-.5v.2h-.2v.2-.2l-.2-.2v-.2h-.2v-1.2l.8.6v-.2h.2v.2l.2.2v.2l.2.2v.7l-.2.2.2-.6zm-1 .2v-.3l.2-.2-.2.6zm-5 1.8 1-.4-.4-.3h.4l.2.2h.7l.4.2h2.3v-.2h.2v-1.4l1-.2v1.6l-.2.3v.2l-.2.2h-.2l-.2.2h-.4l-.2.2h-3l-.3-.2h-.5l-.3-.2h-.5l-.3-.4zm.2.3h-.2v-.3zm-6.6-7.5.6-1 .2.3h.2l.2.3h.2l.3.3.2.3.2.2.2.2.2.2h.2l.2.3.3.2v.3l.4.2.2.3.2.2.3.3.3.2.2.3.3.3.2.2.2.3.2.4.2.3.2.3.2.2.2.3v.3l.3.3v.4l.3.3v.3l-1 .4v-.3l-.2-.4-.2-.3v-.2l-.3-.2v-.3l-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.3-.2-.2-.3v-.2l-.3-.3-.3-.2-.2-.2-.2-.2-.3-.2-.2-.2-.2-.2h-.2l-.2-.3h-.2l-.2-.3h-.2l-.2-.3h-.2l-.2-.2zm.6-1 .3.3-.3-.2zm-2.7-.7 1-.3.2.2h.2v.2h.2v.2h.4v.2h.2l.2.2h.2l-.6 1-.2-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2zm-10-31.7.8-.3.3 1 .3 1 .2.8.3 1 .3 1 .3.8.4 1 .3 1 .3 1 .3 1 .3 1 .3.8.2 1 .4 1 .3 1 .2 1 .3 1 .3 1 .4 1 .3 1 .3 1 .3 1 .5 1 .3 1 .3 1 .5 1 .3 1 .3 1 .4 1.2.4 1 .3 1 .4 1.2-1 .3-.3-1-.2-1.2-.3-1-.4-1-.2-1-.3-1-.3-1.2-.4-1-.3-1-.3-1-.4-1-.3-1-.3-1-.3-1-.4-1-.4-1-.3-1-.4-1-.3-1-.3-.8-.3-1-.4-1-.3-1-.3-1-.3-.8-.3-1-.2-1-.3-1-.3-.8-.3-1-.4-.8-.2-1zm15-22-.7.5h.6l-1 .6-1 .4-1 .5-.8.4-1 .5-.7.4-1 .5-.7.5-.8.5-.7.6-.7.6-.5.6-.7.6-.5.6-.6.7-.5.6-.4.7-.4.6-.4.7-.3.7-.3.7-.3.7v.8l-.2.7v.7l-.2.8v2.6l.3.8v1l.3.7-1 .3-.2-1v-.8l-.3-1V159l.2-1 .2-.7.2-.6.3-.8.4-.7.5-1 .4-.6.4-.7.6-.7.5-.7.6-.6.8-.6.6-.6.8-.6.7-.6.7-.5.8-.6 1-.5.7-.5 1-.5 1-.5.8-.5 1-.5 1-.5.6.2zm-.5-.3.4-.2.2.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "m356 217-.4 2c-2.8.5-5.3.7-7.3.3 3.4-3.3 6-4 7.6-2.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m355 218.8.4-2 1 .2-.3 2-.3.4-.6-.6zm1 0v.5h-.3zm-8 .2.7.7-.3-1 .2.2h4.1l.3-.2h1l.2-.2h.7l.2-.2h.3l.2 1h-.8l-.4.2h-.5l-.4.2h-1.3v.2h-3.7l-.4-1zm.2 1-1-.3.8-.7zm8.2-3-1-.2.2.5v-.2h-.6v-.2h-.6l-.2-.2H353v.2h-.6l-.2.3-.2.2h-.3l-.2.2-.3.2-.2.2-.3.2-.3.2-.2.2-.3.2-.4.3h-.3l-.3.4-.3.3-.7-.7.3-.3.3-.3.3-.3.2-.2.3-.2.3-.2.3-.3h.4l.3-.3h.3l.2-.3h.3l.3-.3h.6l.3-.2h.5l.4-.2h1.3l.2.2h.3l.2.2h.2l.2.2.3.3v.5zm0-.5v.5zm-.5.4h.4-.5zm.3-.5.2.2v.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M355.6 212.3c1.8.4 2 .7 2.7 1 1 0 2.4 0 3.3-1 4-2.2 4 2 2.5 5-1 2.4-.5 5 .6 7 1.2 2.2 1 3.2 0 4l-1.6 1c-1 1.2-1.8 1-2-.6-3.8-1.6-5-5.3-6.2-8.6-1.7-4.7-7.8-5.8.8-7.7z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M358.4 212.7v1h-.7v-.2h-.4l-.2-.2h-.4l-.2-.2h-.8l-.3-.2.2-1h.4l.2.2h.4l.2.2h.4v.2h.8v.2zm3-.7.5 1v-.2l-.2.2h-.3v.2h-.2l-.2.2h-.2l-.2.2h-2.1v-1h2.2l.2-.2h.2v-.2h.2zm3 5.6-.8-.4v-.3l.3-.4v-.5l.2-.2v-.6l.2-.3v-2.2h-.2v-.2h-.2v-.2h-1.2l-.3.2-.3.2-.3.2-.6-1 .4-.2.3-.2h.5l.3-.2h1.8l.2.2.2.2v.2l.2.3v.4l.2.3v2.4l-.2.3v.3l-.2.4v.3l-.2.3v.3zm.6 6.3-1 .4v-.4l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.5l-.2-.2v-.8l-.2-.2v-2.3l.2-.2v-.3l.2-.3v-.3l.2-.2 1 .4-.2.2v.4l-.2.2v.8l-.2.2v2l.2.2v.5l.2.2v.4h.2v.2l.2.2v.4h.2zm0 4.6-.6-1h.2v-.2h.2v-1.6l-.2-.3v-.3l-.2-.2v-.2l-.2-.2v-.2l.8-.5v.2l.2.2v.2l.2.2v.2l.2.2v.2l.2.3v1.7l-.2.2v.2h-.2v.2h-.2v.2l-.2.2zm-1.6 1-.8-.7v-.2h.2l.2-.2h.2v-.2h.4v-.2h.2v-.2h.4v-.2h.2l.6.8h-.2v.2h-.4v.2h-.2l-.2.2h-.2v.2h-.2zm-.8-.7v-.2zm-1.8 0 .4-.8.3.4v.5h.2v.2h.4v-.2h.2v-.2h.2l.8.6-.2.2-.2.2-.3.2h-.2v.2h-1.1l-.2-.2v-.2l-.2-.2v-.4h-.2v-.7zm.4-.8h.3v.4zm-7-8 1-.3.2.2v.3l.2.3v.4l.2.3v.3l.3.3.2.4v.3l.2.3.2.3v.3l.3.3v.2l.2.3v.2l.3.3.2.3.2.2v.3l.3.2.2.3.2.2.2.2.2.2h.2l.3.3.3.2.3.2.3.2h.3l.2.2-.4 1-.3-.2-.4-.2-.2-.2-.4-.2-.3-.2-.2-.3-.3-.3-.2-.2-.3-.3-.3-.2-.2-.3-.2-.3-.2-.3-.3-.4-.2-.3-.2-.3-.2-.3v-.4l-.2-.3v-.3l-.3-.3v-.3l-.3-.2v-.3l-.2-.4v-.2l-.2-.3-.2-.3v-.3l-.2-.4v-.3zm1.4-8.4v1l-.6.2-.7.2h-.6l-.5.3h-.4l-.4.3h-.3v.3l-.2.2v.2h-.2v.2l.2.3.3.2.2.3.2.2.2.3.3.2v.3l.4.3.2.3.3.5.2.3.2.4.3.4.2.4v.5l.3.4-1 .3v-.4l-.3-.5-.2-.4-.2-.3-.3-.3-.2-.3v-.2l-.4-.3-.2-.3-.3-.3v-.4l-.3-.2-.3-.3-.3-.4v-.2l-.2-.3-.2-.4v-.6l.3-.3v-.2l.3-.3h.3l.4-.3.4-.3.5-.2h.4l.7-.3.8-.2zm0 1v-1zm0-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M357 212.5c3.5 1.2 4-.7 6-.6-.8 5-1.7 7.7-7 5-3-1.6-6.7.7-7.4 2.3-.3.6-2-.6-2.6-2-2.6-5.8 6.7-6.4 11-4.8z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m363.6 212-1-.2.5.6H362v.2h-.3l-.2.2h-.2l-.3.2h-.3v.2h-.7l-.2.2h-2l-.4-.2h-.3l-.3-.2.3-1h.3l.3.2h.4l.2.2h1.3l.2-.2h.2l.2-.2h.5l.2-.2h.2l.3-.2h.5l.2-.2h.4l.6.6zm-.5-.6h.7v.6zm-7.2 6 .4-1 .5.4.5.2h.4l.4.3h.3l.4.2h1.7l.2-.2.3-.3.2-.3v-.2l.2-.2.2-.3v-.3l.2-.3v-.3l.2-.2v-.4l.2-.4v-.4l.2-.4v-.9l.2-.5 1 .2v.5l-.2.5v.8l-.2.5v.4l-.2.4v.4l-.3.4v.3l-.2.4-.2.4v.2l-.3.3-.2.3-.2.2-.3.2-.2.2h-.2l-.3.2h-.3l-.3.2h-1.6l-.4-.2-.4-.2h-.4l-.4-.3-.5-.3-.5-.3zm-6.8 2-1-.3h.2v-.3h.3v-.3l.3-.2v-.2l.3-.2h.3l.2-.3.2-.2h.3l.2-.3h.3l.2-.3h.3l.3-.2h.3l.2-.2h.3l.4-.2h2.3l.3.2h.3l.3.2h.2l-.4 1h-.3l-.2-.2h-.5l-.3-.2h-1.8l-.3.2h-.3l-.3.2h-.3l-.2.3h-.2l-.3.2h-.2l-.2.2h-.2v.2l-.2.2h-.2v.3h-.2v.2h-.2v.2zm-3.5-2 1-.3v.4h.2v.4h.2v.2l.2.2h.2v.2l.2.2h.2v.2h.4v.2l.8.5v.2l-.3.2h-1v-.2h-.2l-.3-.2h-.2v-.2l-.2-.2-.2-.2h-.2v-.3h-.2v-.2h-.2v-.3h-.2v-.4h-.2zm11.8-5.4-.3 1-.4-.2h-.5l-.3-.2h-.5l-.5-.2h-5l-.5.2-.4.2h-.4l-.4.3-.4.3-.3.2v.2l-.4.2-.2.2v.3l-.3.2v1.6l.3.4.2.5-1 .5-.2-.5-.2-.6V215l.2-.6.2-.4.2-.4.3-.3.2-.4.3-.3.4-.3.4-.2.4-.2.5-.2h.5l.5-.3h1.1l.5-.2h3.3l.6.2h.5l.4.2.5.2h.3zm0 .5v-.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M458.8 124.5c3.4 0 6.2 2.7 6.2 6 0 3.5-2.8 6.3-6.2 6.3s-6-2.8-6-6.2a6 6 0 0 1 6-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M465.5 130.6h-1c0-2-1.3-4.2-3.3-5a5.5 5.5 0 0 0-2.4-.6v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.6m-6.7 6.7v-1c2 0 4-1.2 5-3a5.6 5.6 0 0 0 .6-2.7h1c0 2.3-1 4.5-3 5.7a6.6 6.6 0 0 1-3.6 1m-6.6-6.7h1c0 2 1.3 4.2 3.2 5a5.5 5.5 0 0 0 2.4.7v1a6.6 6.6 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.6 5.6 0 0 0-.6 2.6h-1c0-2.2 1.2-4.4 3.2-5.6a6.6 6.6 0 0 1 3.4-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M446.3 124.5a6 6 0 0 1 6 6c0 3.5-2.6 6.3-6 6.3s-6-2.8-6-6.2c0-3.4 2.6-6 6-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M453 130.6h-1c0-2-1.3-4-3.2-5a5.5 5.5 0 0 0-2.5-.6v-1c2.3 0 4.5 1.2 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.3 5-3a7 7 0 0 0 .6-2.7h1c0 2.3-1.3 4.5-3.2 5.7a6.6 6.6 0 0 1-3.5 1zm-6.6-6.7h1c0 2 1.2 4.2 3 5a5.5 5.5 0 0 0 2.6.7v1a6.5 6.5 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.6 5.6 0 0 0-.6 2.6h-1a7 7 0 0 1 3-5.6 6.6 6.6 0 0 1 3.6-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M433.8 125.5a6 6 0 0 1 6 6c0 3.5-2.6 6.3-6 6.3s-6-2.8-6-6.2 2.6-6 6-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M440.4 131.6h-1c0-2-1.2-4-3-5a5.5 5.5 0 0 0-2.6-.6v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.6m-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1m-6.6-6.7h1c0 2.2 1.3 4.3 3.2 5.2a5.5 5.5 0 0 0 2.4.5v1a6.4 6.4 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1c0-2.3 1.3-4.6 3.3-5.7a6.6 6.6 0 0 1 3.3-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M422.3 127.7c3.3 0 6 2.8 6 6.2 0 3.3-2.7 6-6 6s-6.2-2.7-6.2-6 3-6.3 6.3-6.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M429 134h-1a6 6 0 0 0-3.3-5.2 5.5 5.5 0 0 0-2.4-.6v-1c2.2 0 4.4 1.2 5.6 3.2a6.7 6.7 0 0 1 1 3.5zm-6.7 6.5v-1c2 0 4-1.2 5-3 .4-1 .6-1.8.6-2.6h1c0 2-1.3 4.3-3.3 5.5a6.6 6.6 0 0 1-3.4 1zm-6.7-6.6h1c0 2 1.2 3.8 3 4.8a5 5 0 0 0 2.7.7v1a7 7 0 0 1-5.7-3 6.7 6.7 0 0 1-1-3.6zm6.7-6.8v1c-2 0-4.2 1.3-5 3.2a5.7 5.7 0 0 0-.7 2.5h-1c0-2.5 1.3-4.7 3.3-6a6.6 6.6 0 0 1 3.3-.8z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M346.3 159.4a6 6 0 0 1 6 6.2c0 3.4-2.6 6.2-6 6.2s-6-2.8-6-6.2a6 6 0 0 1 6-6.2"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M353 165.6h-1c0-2-1.3-4-3.2-5a5.6 5.6 0 0 0-2.5-.7v-1c2.2 0 4.5 1 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.2 5-3a7 7 0 0 0 .6-2.7h1c0 2.3-1.3 4.5-3.2 5.7a6.6 6.6 0 0 1-3.5 1zm-6.7-6.7h1c0 2 1.3 4.2 3.2 5a5.6 5.6 0 0 0 2.5.7v1a7 7 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.7-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1a7 7 0 0 1 3-5.7 6.6 6.6 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M356.8 152.8c3.4 0 6.2 2.7 6.2 6 0 3.6-2.8 6.3-6.2 6.3-3.4 0-6-2.6-6-6a6 6 0 0 1 6-6.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M363.5 159h-1c0-2.2-1.3-4.2-3-5a5.6 5.6 0 0 0-2.7-.7v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.6zm-6.7 6.6v-1a5.7 5.7 0 0 0 5.7-5.7h1a7 7 0 0 1-3 5.6 6.6 6.6 0 0 1-3.7 1zm-6.6-6.7h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.6.6v1a7 7 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.6-6.8v1c-2 0-4 1.3-5 3.2a5.7 5.7 0 0 0-.6 2.5h-1c0-2.3 1.2-4.6 3-5.8a6.6 6.6 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M368.8 147c3.4 0 6 3 6 6.3 0 3.4-2.6 6.2-6 6.2s-6-2.8-6-6.2a6 6 0 0 1 6-6.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M375.4 153.3h-1c0-2-1.2-4.2-3-5a5.6 5.6 0 0 0-2.6-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7m-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1m-6.7-6.7h1c0 2 1.4 4 3.2 5a5.6 5.6 0 0 0 2.6.7v1a6.9 6.9 0 0 1-5.7-3.2 6.7 6.7 0 0 1-1-3.5zm6.8-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.7h-1c0-2.3 1-4.5 3-5.7a6.6 6.6 0 0 1 3.6-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M338.2 169.5a6 6 0 0 1 6 6.2c0 3.4-2.6 6.2-6 6.2s-6.2-3-6.2-6.3 2.8-6.2 6.2-6.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M344.8 175.7h-1c0-2-1.3-4.2-3.2-5a5.6 5.6 0 0 0-2.4-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7m-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1c0 2.3-1.2 4.5-3.2 5.7a6.6 6.6 0 0 1-3.4 1m-6.7-6.7h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.7.7v1a6.9 6.9 0 0 1-5.7-3.2 6.7 6.7 0 0 1-1-3.5m6.7-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.7 2.7h-1c0-2.3 1.2-4.5 3.2-5.7a6.6 6.6 0 0 1 3.5-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "m454.2 276.3-22 12.8-23.4-10 22-12.8z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m431 266.7-22 12.8-.4-1 22-12.7h.5v1zm-.4-1h.5-.4zm23.5 11-23.3-10 .4-1 23.4 10v1h-.3zm.4-1 1 .5-1 .5zm-22.4 13 22-13 .5 1-22 12.8h-.5zm.5.8-.2.2h-.3zm-23.4-11 23.4 10-.4 1-23.3-10v-1h.4zm-.3 1-1-.4 1-.4v1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#c6363c",
                  d: "M431 270.6c5.8-.3 10.5 2.5 10.8 6.3.2 3.7-4.2 7-9.8 7.4-5.7.3-10.4-2.5-10.7-6.3-.2-3.6 4.2-7 9.8-7.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M442.3 277h-1v-.7l-.2-.3v-.6l-.3-.3v-.2l-.3-.2-.2-.3-.2-.3-.3-.2-.3-.3-.2-.2-.3-.2h-.5l-.3-.3-.3-.2-.5-.2-.4-.2h-.3l-.4-.2h-.4l-.5-.3h-.9l-.5-.2h-.8l-.5-.2h-1l-.5.2v-1h3.6l.4.2.5.2h.5l.4.2.5.2.5.2.4.2.3.2.4.2.4.2.4.2.4.3.3.3.4.3.3.3.3.3.2.4.2.3.2.3.2.4v.3l.3.4.2.4v.8zm-10.3 8v-1l.4-.2h.9l.5-.2h.4l.4-.2h.5l.4-.3h.5l.4-.2.4-.2.4-.2.3-.2.4-.2.4-.3.4-.2.3-.2.3-.3.3-.2.3-.3v-.3l.3-.3.2-.4.2-.2v-.3l.2-.2v-.6l.2-.3v-1.1l1-.2v1.6l-.2.4v.3l-.3.5v.3l-.3.4-.3.3v.3l-.4.4-.3.3-.3.3-.3.2-.3.3-.4.3-.4.2-.4.3-.4.3-.4.2-.4.2-.5.2h-.4l-.4.2-.5.2h-.4l-.5.2h-.4l-.5.2h-1zm-11.2-6.8h1v.5l.2.3v.3l.2.3.2.3v.2l.3.3.2.2v.3l.4.2.2.3.3.2.2.2.3.2.4.2.2.2h.4l.4.3h.4l.4.2.4.2h.4l.5.2h1l.4.2h2.3v1H428l-.5-.2h-.4l-.5-.3h-.6l-.4-.3h-.4l-.5-.3-.3-.2-.3-.3-.4-.2-.4-.2-.3-.3-.3-.2-.3-.3-.3-.3-.3-.3v-.3l-.3-.3-.2-.3-.2-.4-.2-.3v-1l-.2-.4zm10.3-8 .2 1h-1.5l-.5.2h-.5l-.5.2-.4.2h-.5l-.4.3-.5.2-.4.2-.3.2-.4.2-.3.2-.3.3-.4.2-.3.3-.3.2-.2.3-.3.2-.2.3-.2.3-.2.4-.2.3v.3l-.3.3v.8l-.2.3v.6l-1 .2V277l.2-.4v-.3l.2-.4v-.5l.3-.3.2-.4.3-.3.2-.3.3-.3.2-.4.4-.3.4-.3.3-.3.4-.3.5-.2.3-.3.5-.3.4-.2.4-.2.6-.2h.4l.5-.2h.5l.5-.3h.5l.5-.2zl.5-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "m382.4 270 23.8 9-19.7 13c-5-1.6-9-19-4-22z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m406 279.4-23.8-9 .4-1 23.7 9v1zm.3-1 1 .4-1 .5v-1zm-20 13.3 19.6-13.2.4.8-19.6 13.3h-.4zm.5 1h-.4zm-4.2-23.3-.4 1h.5l-.4.2-.4.3-.4.4-.2.5-.2.4-.2.7-.2.8v1.5l-.2.8v2.8l.3.8v1l.2.8.2 1 .2 1 .3.7v1l.5 1 .3.7.3.7.5.8.4.6.3.6.4.6.4.5.5.4.4.2.3.3.4.2-.3 1-.6-.3-.5-.3-.5-.3-.5-.5-.4-.6-.6-.6-.4-.7-.4-.7-.4-.7-.4-1-.3-.8-.3-1-.3-.8-.4-1-.2-.8-.2-1-.2-1v-.8l-.3-1v-5.2l.3-.8.2-.7.3-.6.3-.6.4-.5.4-.5.5-.4h.6zm-.5 0h.6-.5zm.4.4.2-.4zm-.3-.4h.6-.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#0c4076",
                  d: "M382.8 274.3c5.7-.6 10.5 2 11 5.8.3 3.8-4 7.4-9.6 8-3.6.3-6-3-6.3-6.3-.5-3.4 1-7 4.8-7.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M394.2 280h-1v-.5l-.2-.3v-.3l-.2-.4-.2-.3-.2-.2-.2-.2-.2-.3-.2-.2-.3-.3-.2-.2-.3-.2-.3-.2-.4-.2-.3-.2-.4-.2-.3-.2h-.4l-.5-.3h-.4l-.4-.2h-.8l-.5-.2h-3.6l-.2-1h3.8l.4.2h.5l.4.2.4.2h.4l.5.3.4.2h.5l.4.3.2.2.4.3.3.2.2.3.3.3.3.3.2.2.3.3.2.3.2.3v.5l.3.4v.2l.2.4v.4zm-10 8.4v-1h1l.5-.2h.4l.6-.2.5-.2h.5l.4-.3.4-.2h.4l.4-.3.3-.3.4-.2.2-.2.4-.3.3-.2.2-.3.3-.2.2-.3.3-.3.2-.3.2-.2.2-.3v-.4l.3-.3v-.8l.2-.4v-1h1v1.6l-.2.3v.3l-.2.4-.2.3-.2.4-.2.3-.2.4-.3.4-.2.3-.3.3-.3.3-.5.3-.3.3h-.4l-.4.4-.4.2-.4.3h-.4l-.4.3-.5.2h-.5l-.4.3-.5.2h-.6l-.5.2h-.7l-.5.2h-.5zm-6.8-6.7h1v.7l.2.3v.3l.2.4v.3l.2.2v.2l.2.3.2.2v.3l.3.2.2.3v.2l.2.2h.2l.2.3h.2l.2.3.2.2h.3l.2.2h.2l.2.2h.2l.3.2h1.4v1h-2.1l-.3-.2h-.4l-.3-.3-.3-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.3-.2-.2v-.2l-.3-.3-.2-.3v-.2l-.3-.4v-.3l-.3-.3-.2-.3v-.3l-.2-.3v-.6l-.2-.3v-.3zm5.4-8v1h-.2l-.4.2h-.8l-.3.3-.3.2-.3.2-.2.2h-.2l-.2.2v.2l-.3.2v.3h-.3v.3l-.2.3-.2.2v.7l-.2.3v.4l-.2.3v2.2h-1V279l.2-.3v-.3l.2-.2v-.3l.2-.3.2-.3v-.4l.3-.3.2-.3.2-.2v-.3l.3-.2.3-.2h.2l.3-.3.4-.2.3-.2h.3l.3-.2h.7l.4-.2h.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M457.5 280.4c1.7 0 3.2 1.5 3.2 3.2 0 1.8-1.5 3.3-3.2 3.3-1.8 0-3.2-1.6-3.2-3.4 0-1.7 1.4-3.2 3.2-3.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M461.2 283.6h-1v-.6l-.2-.2v-.2l-.2-.3v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.7v-1h1l.3.2.2.2h.2l.3.2v.2h.2v.2h.2v.3h.2v.2l.2.2v.2h.2v.2l.2.3v.5l.2.2v.2zm-3.7 3.8v-1h.4l.3-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2.2-.2v-.2l.2-.2v-1h1.2v.8l-.2.2v.3l-.2.2v.2l-.2.2-.2.3h-.2v.3h-.3l-.2.2-.3.2-.3.2h-.6v.2h-.6v.2h-.3zm-3.7-3.8h1v1h.2v.2l.2.2v.2l.2.2h.2v.2h.2v.2h.2l.2.2h.2v.2h1v1.2h-.7l-.2-.2h-.5v-.2h-.3l-.2-.2-.3-.2-.2-.2h-.2v-.3h-.2l-.2-.3-.2-.3v-.2l-.2-.3v-.3l-.2-.3zm3.7-3.7v1h-.9l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.3v.5h-.2v.8h-1v-1.2l.2-.2v-.3h.2v-.3l.2-.2.2-.2v-.2h.4v-.2l.2-.2h.2v-.2h.5v-.2h.4v-.2h1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M408.7 283c1.8 0 3.2 1.6 3.2 3.4 0 1.7-1.5 3.2-3.3 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.3 3.2-3.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M412.4 286.4h-1v-.9l-.2-.2v-.2l-.2-.2v-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.4l-.2-.2h-.8v-1.2h.7v.2h.7v.2h.3v.2h.3v.2h.3l.2.2.2.3h.2l.2.3.2.3v.3h.2v.6l.2.2v.9zm-3.7 3.7v-1h1v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.3h.2v-.5l.2-.2v-.4h1v.8l-.2.2v.3l-.2.2v.3h-.2v.3h-.2l-.2.3h-.2v.2h-.3l-.2.2h-.2v.2h-.3v.2h-.5l-.2.2h-.8zm-3.7-3.6h1v.8h.2v.5h.2v.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.5v.2h.7v1h-1.2v-.2h-.3v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.3h-.3v-.3h-.2v-.3l-.2-.2v-.2l-.2-.3v-.8zm3.7-3.8v1h-.7v.2h-.5v.2h-.2l-.2.2v.2h-.2l-.2.2v.2l-.2.2v.2h-.2v.7l-.2.3v.4h-1v-1l.2-.2v-.3l.2-.3.2-.3v-.3h.3v-.3h.2l.2-.2.2-.2h.2v-.2h.6l.3-.2h.5l.3-.2h.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M407 268.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.2 3.2-3.2"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M410.7 271.5h-1v-.7l-.2-.2v-.3l-.2-.2h-.2v-.4h-.2v-.2h-.2l-.2-.2h-.2l-.2-.2h-.5v-.2h-.4v-1h.8v.2h.3l.3.2h.2l.3.2h.2v.2l.3.2.2.2.3.3.2.3v.3h.2v.4l.2.2v1zm-3.7 3.7v-1h1v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2.2-.2v-.4h.2v-1h1v1.2l-.2.2-.2.3v.3h-.2l-.2.3h-.2v.3h-.3v.2h-.2v.2h-.2l-.2.2h-.5l-.3.2h-.7zm-3.7-3.7h1v.8l.2.2v.4h.2v.2l.2.2v.2h.2v.2h.2v.2h.2l.2.2h.5l.2.2h.5v1h-.9l-.3-.2h-.2l-.3-.2-.3-.2h-.2l-.2-.2-.2-.3h-.3v-.3l-.2-.3v-.3h-.2v-.4l-.2-.2v-.8zm3.7-3.7v1h-.8v.2h-.5l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.3l-.2.2v.7h-1v-1.2h.2v-.6h.2v-.3h.2v-.3h.3l.2-.2v-.2h.3v-.2h.3l.2-.2h.4v-.2h.5l.2-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M457.3 266.2c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.6-3.2 3.3-3.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M461 269.4h-1v-.8h-.2v-.3l-.2-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2h-.2l-.2-.2h-.2l-.3-.2h-.7v-1h1.1l.2.2h.3l.3.2.3.2.2.3h.2v.2h.2v.2h.2v.3h.2v.3l.2.2v.5l.2.2zm-3.7 3.7v-1h1.2v-.2h.2l.2-.2.2-.2v-.2h.2v-.2h.2v-.2l.2-.2v-.5h.2v-.8h1v1.1l-.2.2v.2l-.2.2-.2.3-.2.3-.2.2-.2.2-.2.2h-.2v.2h-.3v.2h-.4l-.2.2h-1zm-3.7-3.6h1v.5l.2.2v.3l.2.2v.2h.2l.2.2v.2h.2v.2h.2l.3.2h.2l.2.2h.7v1h-1l-.3-.2h-.3l-.3-.2-.3-.2v-.2l-.3-.2-.2-.2v-.2h-.2v-.3h-.2v-.6l-.2-.2v-.7zv-.2zm3.7-3.7v1h-.7v.2h-.4l-.2.2h-.2v.2h-.2v.2l-.2.2-.2.2v.4h-.2v.8h-1.2v-.5l.2-.3v-.4l.2-.2v-.2h.2v-.3h.2v-.3h.2v-.2h.3v-.3l.3-.2.3-.2h.3l.2-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M371 237.4c2.3-.8 6 4.6 7 4.5 1.2-3-1.2-10.5-5.5-16.3-3-1-3.2-3-3.8-7.3-.2-1.3-2.7-.4-2.7 2 0 2.3-.3 3.6.3 5.6.2.8 0 1.6-.8 2.3 4.5 1.8 5.6 4 5.4 9z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m377.6 241.8 1 .3-.5.4h-.4l-.3-.2-.2-.2-.3-.3-.2-.2-.2-.2-.2-.2-.3-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2-.2-.3-.2-.2-.3h-.3l-.3-.3h-.2l-.3-.3-.3-.2h-.2l-.3-.2h-.4l-.2-.2h-.4l-.4-1h1.3l.3.2h.3l.3.2.2.2h.3l.3.3.2.2h.3l.3.3.3.3v.2l.4.2.2.3.3.2v.2l.4.3.2.2.2.2.2.2.2.2.2.2h.2v.2h.3v.2zm1 .3-.2.4h-.3l.5-.3zm-6.3-15.8.4-1 .2.2.3.5.4.5.4.6.4.7.4.5.3.6.5.6.3.6.3.6.4.6.3.6.2.6.2.6.2.5.2.6.2.7.2.5v.6l.3.5v.6l.2.4v.5l.2.4v3.3l-.2.3-1-.2v-.3l.2-.3v-3.6l-.3-.5v-.4l-.2-.5-.2-.5-.2-.5v-.5l-.4-.6-.2-.7-.2-.5-.3-.6-.2-.6-.3-.5-.3-.5-.4-.6-.3-.7-.4-.5-.4-.6-.4-.6-.3-.5-.5-.5-.4-.5.3.2zm.4-1 .2.2-.3-.2zm-4.5-6.7h1v.7l.2.3v1l.2.3v.5l.2.3v.5l.2.2v.4h.2v.3l.2.2v.2h.2v.3h.2l.2.2v.2h.2l.2.2h.2l.2.2h.2l.2.2h.2l.3.2-.4 1h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.2l-.2-.3-.2-.2h-.2v-.2l-.3-.2-.2-.2-.2-.2v-.2l-.2-.2v-.2l-.2-.3v-.2l-.2-.2v-.3l-.2-.2v-.9l-.2-.3v-.6l-.2-.3V219l-.2-.5zm-1.7 1.8h-1v-1l.2-.2.2-.2v-.4h.2l.2-.3h.2l.2-.2.3-.2h.2l.2-.2h1.2v.2h.2v.3l.2.2v.2h-1.6v.2h-.2v.2h-.2v.2h-.2v.3l-.2.2v.8zm.3 5.6-1 .2v-.6l-.2-.2V224h-.2v-3.6h1v4.2l.2.2v.7l.2.2zm-1 2-.5.8v-1l.2-.2v-.2h.2v-.4h.2v-.4l-.2-.2v-.2l1-.3v1.8h-.2v.4h-.2v.2h-.2v.2l-.2.2h-.2zm-.5.8-.8-.3.7-.6v.8zm5 8.6h1zv-.5l.2-.5v-2l-.2-.3v-.7l-.2-.3v-.6l-.2-.3v-.2l-.2-.3-.2-.3v-.2l-.3-.3v-.2l-.3-.2-.2-.2-.3-.2-.2-.2-.3-.2h-.3l-.3-.3-.2-.2-.3-.2-.4-.2h-.3l-.4-.2.4-1 .4.2.5.2.4.2.3.2.3.2.4.2.3.2.3.2.3.2v.2l.4.3.2.3.3.3v.2l.3.3v.4l.3.3v.3l.3.3v.7l.2.3v.7l.2.4v2.9h-1zm1 0h-1l.5-.5.6.4zm-1 0v-.4h.5l-.4.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M368.8 218.5c-.4 1-.6 1.8-.7 3.4 0 1 .5 2 1.2 3 .8 1 1.8 2 3 2.6.8.5 1.6 1.7 2.3 3 .7 1.4 1.2 3 1.2 4 0 3.5.8 6.7 2.4 7.3 1.2.3 1.6.2 2.4 0-.2-.6 0-1.5-.7-2.4a8 8 0 0 1-1.4-3.7c0-1-.5-1.6-.2-3.3.4-1.2 1-1.6 1-2.7-.3-2-2-6-4.3-6s-3.4-.3-4.6-3.4c-.3-1-1-1.6-1.2-2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m368.6 222-1-.2v-1.2l.2-.2v-1h.2v-.7h.2v-.4l1 .3v.4h-.2v1l-.2.2v1.5zm1 2.8-.8.6v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.4h-.2v-.5l-.2-.2v-.7l-.2-.2v-.7h1v1.1h.2v.7h.2v.4h.2v.4h.2v.2zv.2zm3 2.4-.6 1v-.2h-.4v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.3v-.2h-.2l-.2-.2v-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2.8-.6.2.2.2.2v.2h.2l.2.2v.2h.2l.2.2.2.2h.2v.2h.2v.2h.3l.2.2.2.2h.2v.2zm2.4 3.2-1 .4v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2l-.2-.2h-.2l.5-1h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l.2.2v.2l.2.2v.2h.2v.3h.2v.3h.2zm1.2 4.2h-1v-.8l-.2-.2v-.8h-.2v-.5h-.2v-.4h-.2v-.5h-.2v-.2l-.2-.2 1-.4v.4h.2v.4h.2v.5l.2.2v.3h.2v.6h.2v1h.2zm2 6.8-.3 1h-.3l-.2-.2-.3-.3v-.2l-.3-.2h-.2l-.2-.3v-.2h-.2v-.3l-.2-.2v-.3l-.2-.2v-.3l-.2-.2v-.5l-.2-.3v-.8l-.2-.3V236l-.2-.3v-1.5h1v2.1l.2.3v1.4l.2.2v.8l.2.2v.2l.2.2v.4l.2.2v.2l.2.2.2.2v.2h.2v.2h.2l.2.2zm1.7.8 1-.3-.5.5h-.4v.2h-1.4l-.2-.2h-.4l.3-1h.7v.2h1.2v-.2zm1-.3v.4h-.5l.4-.5zm-1.7-2 .8-.7h.2v.4h.2v.4h.2v.8l.2.2v1l-1 .4V241l-.2-.2v-.8h-.2v-.2zm-1.5-4h1v.8h.2v.8l.2.2v.2l.2.2v.2h.2v.5h.2v.2h.2v.2l-.7.7v-.2l-.2-.2v-.4h-.2v-.5h-.2v-.2l-.2-.3v-.2l-.2-.2v-.2l-.2-.3v-.4l-.2-.2v-.5zm-.2-3.4 1 .2v3l.2.2-1 .2v-.8l-.2-.2zm1-2.5h1v.7h-.2v.6l-.2.2v.2l-.2.2v.2h-.2v.6h-.2v.2l-1-.2v-.4h.2v-.4l.2-.2v-.2l.2-.2v-.2l.2-.2v-.9zm-4-5.5v-1h1.1l.3.2h.2l.2.2h.3l.2.2.2.2v.2l.3.2v.2l.3.2.2.3v.2l.3.3.2.2.2.3v.2l.2.3v.2l.2.3v.3l.2.2v.3l.2.2v.5l.2.3v.8h-1v-1l-.2-.2v-.4l-.2-.3-.2-.4v-.2l-.2-.2v-.3l-.3-.3v-.2l-.2-.2v-.3l-.2-.2-.3-.3-.2-.2-.3-.3-.3-.2-.3-.2h-.8zm-5-3.7 1-.4v.3l.2.3v.2l.2.2v.2l.2.2v.2l.2.2.2.2v.2h.2v.2h.2v.2h.4v.2h.7v.2h1.7v1H373l-.3-.2h-.4v-.2h-.3v-.2h-.3v-.3h-.3v-.2l-.2-.2-.2-.3-.2-.2v-.2l-.2-.2-.2-.4-.2-.2v-.3l-.2-.2zm-.4-2-1-.5h1.2v.4h.2v.2h.2v.2h.2v.4h.2v.2l.2.2v.2l.2.2-1 .4v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2zm-1-.5.5-1 .5 1zm.6.2.4.2zm-.5-.2.4-1 .5 1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "m360 227 2-1a6 6 0 0 1 4-.2c5.5 1.7 8 11.6 1.8 14-1.2.2-2.3-1-3.4-3.3a20.5 20.5 0 0 0-4-6.8c-1-1-1-2-.4-2.6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m362 225.5.3 1h-.4v.2h-.4v.2h-.8v.2h-.2l-.2.2-.7-.7.2-.2v-.2h.4v-.2h.8v-.2h.4v-.2h.4zm4-.2-.2 1h-.5v-.2h-2.1v.2h-.7l-.2.2-.5-1h.4l.3-.2h.8v-.2h1.6l.2.2h.4zm2 15-.2-1h-.2l.5-.2h.6l.4-.4.4-.3.3-.4.3-.5.2-.4.2-.3.2-.5v-.5l.2-.5V232l-.3-.4-.2-.5-.2-.5v-.5l-.4-.4-.2-.5-.4-.3-.3-.5-.4-.3-.3-.5-.4-.3-.5-.3-.3-.4-.5-.2h-.4l.2-1h.6l.5.3.7.3.4.4.6.3.5.4.5.6.3.4.4.5.3.5.3.6.3.5.3.7.2.6v.6l.3.5v3.4l-.2.5-.2.6-.3.6-.2.5-.3.5-.4.5-.4.4-.4.3-.6.3-.6.3zm-4-3.6 1-.4v.4l.2.2.2.3.2.3v.2h.2v.5h.2v.2l.2.2.2.2h.2v.2h.2l.2.2h.8v1.2h-.8v-.2h-.5l-.2-.2-.2-.2-.2-.2-.2-.2v-.2h-.2l-.2-.2v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.3-.3-.3zm-4-6.6.7-.6.2.2v.2h.2l.2.3v.3h.2l.2.3v.2l.2.2h.2v.3l.3.2v.2l.2.2.2.2v.4l.2.2.2.3v.3l.2.2.2.3v.3l.2.3v.3l.3.3.2.4v.3l.3.3v.3l-1 .4v-.6l-.2-.2v-.3l-.3-.2v-.3l-.2-.2v-.5l-.3-.3v-.2l-.2-.2v-.3l-.3-.2-.2-.3v-.2l-.3-.2v-.2h-.2v-.3h-.3v-.3l-.2-.2-.3-.3v-.2l-.2-.2h-.2v-.2l-.2-.2zm0-3.4v1l.3-.2v.2h-.2v.8h.2v.4l.2.2.2.2v.2l-.7.7h-.2v-.2l-.2-.2-.2-.2v-.3h-.2V227h.2v-.2h.2zm-.4 0h.4zm.4 1v-1l.3 1zm.3 0h-.2.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M362.8 227.7c5.4-2 9.4 8.3 4.3 10.2-2.6 1-2.8-2.4-3.4-4.3-.7-2.5-6-4-.8-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m367.3 238.4-.4-1h.3l.3-.3.3-.2.2-.3.2-.3.2-.3v-.5l.2-.4v-2.7l-.2-.4-.2-.5-.2-.4-.2-.4-.3-.4-.3-.4-.2-.3-.4-.4-.3-.2-.3-.2-.4-.2-.4-.2h-.4l-.3-.2h-1.3l-.4.2-.4-1h.6l.5-.2h1.6l.5.3.5.2.4.2.4.4.5.4.4.4.3.4.3.5.2.4.3.6.3.5.2.6.2.6v.5l.2.5v1.6l-.2.5v.5l-.3.5-.2.4-.3.5-.4.3-.4.4-.4.2-.5.2zM363 234l1-.4.2.2v.6l.2.2v.8l.2.2v.4l.2.2v.2l.2.3.2.3v.2h.2v.2h.2l.2.2h1.2l.3.8h-.3l-.3.2h-1.2l-.2-.2h-.2v-.2l-.3-.2-.3-.3v-.2l-.2-.2v-.2h-.2v-.3l-.2-.2v-.4h-.2v-.8l-.2-.2v-.8l-.2-.2v-.2zm-.4-6.7.4 1h-.5l-.3.3h-.4l-.2.3h-.2l-.2.2v.2h-.2v.4h.2v.3l.2.2v.2h.3v.3l.3.2h.2l.2.2.2.2.2.2.2.2.2.3.2.3.2.2v.3l.3.2v.6l-1 .3v-.7l-.2-.2h-.2v-.3l-.3-.2h-.2v-.3l-.3-.2-.2-.2-.2-.2-.2-.2v-.2l-.2-.2h-.2v-.3l-.3-.3v-.2l-.2-.2v-.8l.2-.3v-.3l.3-.2.2-.2.3-.3.3-.2h.4l.4-.3.6-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#0c4076",
                  d: "M363.4 229.3c2.6-1 6.2 5 3 6.5-2.3 1-4-.3-4.8-2-.7-2 0-3.8 1.7-4.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m366.5 236.3-.4-1h.3l.2-.2h.2v-.2l.2-.2v-2l-.2-.3v-.3h-.2v-.4l-.3-.3-.2-.2-.3-.4-.2-.2-.2-.2h-.2v-.2l-.3-.2h-1.1l-.3-1h1.5l.4.3.3.2.2.3.2.2.3.2.2.2.2.3v.3l.3.3.2.4.2.3v.4l.2.4v2.6l-.2.3-.2.4-.2.3-.2.2h-.4l-.3.3zm-5.4-2.5 1-.3.2.3.2.3v.2l.2.3.2.2.2.2h.3v.2h.2l.3.2h.4v.2h1.3l.3-.2.5 1h-.7l-.2.2h-1.9l-.2-.2h-.2v-.2h-.3l-.2-.2-.3-.2-.3-.3-.3-.3h-.2v-.3l-.2-.3-.2-.3v-.2zv-.2zm2.2-5 .3 1h-.3l-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.7l-.2.2v1.1l.2.2v.3l-1 .3v-.7l-.2-.3v-1.5l.2-.2v-.3l.2-.2.2-.3.2-.3v-.2l.3-.2v-.2h.3l.2-.2.3-.2h.2zm.2.5-.2-.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M400 179.7c3.6 0 6.4 2.8 6.4 6.4 0 3.6-2.8 6.5-6.3 6.5s-6.3-3-6.3-6.4 3-6.3 6.4-6.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M407 186h-1c0-2-1.4-4.3-3.3-5.2a5.8 5.8 0 0 0-2.6-.6v-1c2.4 0 4.7 1.2 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1a6 6 0 0 0 5.3-3.3 6 6 0 0 0 .6-2.6h1c0 2.4-1.3 4.7-3.3 6a6.8 6.8 0 0 1-3.6 1zm-6.8-7h1a6 6 0 0 0 3.3 5.4 5.8 5.8 0 0 0 2.6.6v1a6.8 6.8 0 0 1-5.7-3.3 7 7 0 0 1-1-3.6zm7-7v1.2a5.9 5.9 0 0 0-5.3 3.2 6 6 0 0 0-.8 2.7h-1a7 7 0 0 1 3.3-5.8 6.8 6.8 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M395.4 169c3.5 0 6.4 3 6.4 6.4 0 3.6-3 6.4-6.4 6.4s-6.3-2.8-6.3-6.4c0-3.5 3-6.4 6.4-6.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M402.3 175.4h-1c0-2.2-1.3-4.3-3.2-5.3a5.8 5.8 0 0 0-2.6-.5v-1c2.4 0 4.6 1.3 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1c2.3 0 4.4-1.4 5.4-3.3a6 6 0 0 0 .6-2.6h1c0 2.4-1.2 4.7-3.2 6a6.8 6.8 0 0 1-3.6 1zm-6.7-7h1a6 6 0 0 0 3.2 5.3c.8.4 1.7.6 2.6.6v1a6.8 6.8 0 0 1-5.8-3.2 7 7 0 0 1-1-3.6zm6.8-7v1c-2 0-4.2 1.4-5.2 3.3a6 6 0 0 0-.6 2.7h-1c0-2.3 1.2-4.6 3.2-6a7 7 0 0 1 3.6-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M410.7 131.5c3.4 0 6 2.7 6 6s-2.6 6.3-6 6.3-6.2-2.7-6.2-6.2a6 6 0 0 1 6.2-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M417.3 137.7h-1c0-2.2-1.2-4.2-3-5a5.6 5.6 0 0 0-2.6-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7m-6.6 6.6v-1c2 0 4-1.2 5-3 .4-1 .6-1.8.6-2.6h1c0 2.2-1.2 4.5-3 5.6a6.6 6.6 0 0 1-3.6 1m-6.7-6.7h1c0 2.2 1.3 4.2 3.2 5a5.6 5.6 0 0 0 2.5.7v1a6.6 6.6 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.6zm6.7-6.6v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.7 2.6h-1a7 7 0 0 1 3-5.6 6.6 6.6 0 0 1 3.7-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M400.4 136.2c3.5 0 6.3 3 6.3 6.4 0 3.5-2.8 6.4-6.3 6.4s-6.4-3-6.4-6.4c0-3.5 2.8-6.4 6.4-6.4"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M407.2 142.6h-1a6 6 0 0 0-3.3-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.6zm-6.8 7v-1c2 0 4.2-1.4 5.2-3.3a6 6 0 0 0 .6-2.7h1c0 2.3-1.2 4.7-3.2 6a6.8 6.8 0 0 1-3.6 1m-7-7h1c0 2.2 1.4 4.3 3.3 5.3a5.8 5.8 0 0 0 2.7.5v1a7.2 7.2 0 0 1-6-3.2 7 7 0 0 1-1-3.7zm7-7v1a6.2 6.2 0 0 0-5.3 3.3 6 6 0 0 0-.5 2.6h-1c0-2.4 1.2-4.7 3.2-6a6.8 6.8 0 0 1 3.7-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M392.8 145.3c3.5 0 6.3 2.8 6.3 6.4 0 3.5-2.7 6.4-6.2 6.4s-6.4-2.8-6.4-6.3c0-3.6 3-6.4 6.4-6.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M399.6 151.7h-1a6 6 0 0 0-3.2-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.7m-6.8 7v-1c2 0 4.2-1.4 5.2-3.4a6 6 0 0 0 .6-2.6h1c0 2.3-1.2 4.6-3.2 6a6.8 6.8 0 0 1-3.6 1m-7-7h1c0 2 1.4 4.3 3.3 5.2a5.8 5.8 0 0 0 2.8.6v1a7.4 7.4 0 0 1-6-3.3 7 7 0 0 1-1-3.6zm7-7v1a6 6 0 0 0-5.3 3.3 6 6 0 0 0-.6 2.7h-1c0-2.4 1-4.7 3.2-6a7 7 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#fff",
                  d: "M391.5 156.7c3.6 0 6.4 2.8 6.4 6.4s-3 6.5-6.5 6.5-6.3-3-6.3-6.4 2.8-6.3 6.3-6.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M398.4 163h-1c0-2-1.3-4.2-3.2-5.2a5.8 5.8 0 0 0-2.7-.6v-1c2.4 0 4.7 1.2 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1a6 6 0 0 0 5.4-3.3 6 6 0 0 0 .6-2.6h1c0 2.5-1.3 5-3.4 6a6.8 6.8 0 0 1-3.5 1zm-6.7-7h1c0 2.3 1.3 4.4 3.2 5.4.7.4 1.6.6 2.5.6v1a7 7 0 0 1-5.8-3.2 7 7 0 0 1-1-3.7zm6.8-6.8v1c-2 0-4.2 1.3-5.2 3.2a6 6 0 0 0-.6 2.7h-1c0-2.3 1.2-4.6 3.2-5.8a7 7 0 0 1 3.5-1z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M474.4 198c-2.7-5-5.6-8.2-8.6-9.6 4.2-13.2 5.2-30.2 2.7-51-.2-3.3-1-4.6-2.2-4.6-1 0-1.7 1.6-1.8 5.2.8 11.6 1.7 21.6 1.2 30.2-.5 7.6-2.3 14-4.2 21.2-.3 1 .4 1.7 3.8 3.7 2.6 1.5 4.2 3.3 4.7 5 .7-.2 1.2 0 1.5 0 2.5.8 3.6.6 3 0z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m465.3 188.2 1 .3-.3-.6h.3l.3.2.3.2.2.2h.3l.3.3h.3l.4.4.2.2.3.2.2.3.3.3.3.3.3.3.3.2.3.3.3.3.2.3.2.5.3.3.3.4.2.3.3.4.3.3.2.4.3.4.3.5.2.5.3.4.3.4.3.5.3.5-1 .5-.3-.5-.2-.4-.3-.5-.2-.5-.3-.4-.3-.3-.2-.4-.3-.4-.3-.5-.3-.4-.2-.2-.3-.4-.4-.3-.2-.2-.3-.3v-.3l-.4-.3-.3-.4-.2-.3-.2-.2-.3-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.3-.2h-.3l-.3-.3-.4-.2-.3-.6zm.3.6h-.4v-.6zm2.4-51.5h1l.2 2 .2 1.8.2 2 .2 2v1.8l.2 1.8v1.8l.2 1.8v15l-.3 1.5-.2 1.5v1.5l-.3 1.5-.2 1.5-.2 1.4-.2 1.5-.2 1.3-.3 1.4-.3 1.3-.3 1.4-.3 1.3-.4 1.3-.3 1.3-.4 1.2-1-.3.4-1.2.4-1.3.4-1.3.3-1.3.3-1.2.3-1.3.3-1.4.2-1.3.3-1.4.3-1.5.2-1.4V172l.3-1.6V169l.2-1.7v-1.6l.2-1.6v-13.6l-.2-1.8v-2l-.2-1.7-.2-2-.2-1.8-.2-2-.2-2zm-1.7-4v-1h.6v.2h.3v.2h.2l.2.3h.2v.5h.2v.3l.2.2v.3l.2.2v.4l.2.4v.9l.2.3v.4h-1v-.9l-.2-.2v-.6l-.2-.2v-.5h-.2v-.5h-.2v-.2l-.2-.2h-.2v-.2h-.4zM465 138h-1v-1.7l.2-.3v-1l.2-.3v-.7h.2v-.3l.2-.3v-.3h.2l.2-.2.3-.2.2-.2h.5v1h-.2v.2h-.2v.2l-.2.2v.3l-.2.3v.6l-.2.2v1.6l-.2.4v.7zm1.2 30.2h-1V154l-.2-1v-2.8l-.2-1v-2l-.2-1v-1l-.2-1v-2l-.2-1V139l-.2-1 1-.2v1l.2 1.2v2l.2 1v2.2l.2 1v2l.2 1v2l.2 1v2.8l.2 1v12zm-4.3 21.3-1-.3.2-.6v-.7l.3-.8.2-.6.2-.7v-.7l.2-.7.2-.6.2-.7v-.6l.3-.6v-.6l.2-.6.2-.7v-.5l.2-.6.2-.8v-.6l.2-.7.2-.7v-.7l.2-.6v-.7l.2-.6v-.7l.2-.7v-.7l.2-.6V169l.2-.8h1v1.5l-.2.7v1.5l-.2.6v.7l-.2.8v.7l-.2.6v.8l-.2.7-.2.6v.8l-.2.6-.2.7v.7l-.3.7v.6l-.3.7v.6l-.3.6-.2.6v.6l-.3.7-.2.5-.2.7v.6l-.3.7-.2.7-.2.6v.7zm3.6 3-.5 1-.2-.2h-.3l-.3-.3-.3-.2h-.4l-.2-.3h-.2l-.3-.3h-.3v-.2l-.3-.2h-.2l-.2-.2-.2-.3h-.2v-.2h-.2l-.2-.2v-.2l-.2-.2v-1l1 .2v.5h.2v.2l.2.2h.2v.2h.2l.2.2.3.3h.2l.2.2.2.2h.2l.2.3h.3l.3.3.3.2h.3zm4.2 5.2.4 1-.7-.4v-.2l-.2-.2v-.3l-.2-.2v-.3l-.2-.3-.3-.3-.2-.3-.3-.2-.3-.3v-.2h-.3v-.2h-.3v-.2l-.3-.2h-.2v-.3h-.3l-.2-.2h-.3l-.2-.2-.2-.2h-.2l.6-1 .2.2h.2l.3.3.2.2.2.2h.2v.3h.4l.2.3.3.3.3.3.2.2.3.3v.3l.3.2h.2v.3l.3.2v.2h.2v.3l.2.2v.2l.2.3v.3l.2.2v.2l-.6-.3zm.4 1h-.5l-.2-.4zm1.4-1.2-.3 1h-1l-.4-.8h.2l.2-.2zm3.3.5h-1l.7-.4.2.2v.8l-.2.2h-.2v.2h-1.8l-.2-.2h-.3l-.2-.2h-.5l.3-1h.7l.2.2h1v.2h.7v.4zm-1 0v-1l.7.6-.8.4zm0 0h1l-1 .3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M458.4 214.6c1.6-1 2-.8 2.4-1.4.6-.8.6-2.2.4-3.5-.8-5.3 2.4-4.6 6-2.2 1.7 1 3.5 4 5 5.3s2.8 1.5 3.2 2v9.2c-.4.6-1.7.7-3.2 2-1.5 1.5-3.3 4.2-5 5.4-3.6 2.3-6.8 3-6-2.2.2-1.3.2-2.7-.4-3.5-.5-.7-.8-.4-2.4-1.4a7 7 0 0 1-2.3-2.2c-.4-.8 0-1.7 0-2.6 0-1-.4-1.8 0-2.6.6-.8 1.4-1.6 2.4-2.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m460.4 213 .8.5-.2.2-.2.2h-.4v.2h-.4l-.2.2h-.2l-.2.2h-.2v.2h-.5v.2l-.7-1h.6v-.2h.2l.2-.2h.2l.2-.2h.4v-.2h.4v-.2h.2zm.3-3.2 1-.2v2.9l-.2.3v.2h-.2v.2l-1-.5v-.2h.2v-.4h.2v-2.6zm6.7-2.8-.6 1-.3-.3-.3-.2-.3-.2-.4-.2h-.3l-.3-.2h-.3l-.3-.2h-.3v-.2h-.4l-.2-.2h-1.1v.2h-.2v.2l-.2.2v.6l-.2.3v2l-1 .2v-3l.2-.4v-.3l.3-.2.3-.2.2-.2h.2l.2-.2h.2l.2-.2h1.5v.2h.5l.3.2h.3l.4.3h.3l.3.2.4.2.3.2.3.2zm5 5.4-.6.7-.3-.2-.3-.3-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2v-.2h-.2v-.3l-.3-.2-.3-.3-.2-.2v-.2l-.3-.2v-.2h-.3l-.2-.3-.3-.2-.2-.2h-.2l-.2-.2v-.2h-.3v-.2h-.2l.6-1 .2.2.3.2v.2h.3v.3h.3l.2.2.2.2v.2l.3.2h.2v.3l.3.3.2.2v.2l.3.2.3.3h.2v.3l.3.2.2.2.2.2.3.3v.2h.3v.3h.3v.3h.2zm3.5 2.4h-1.2v.3h-.2l-.2-.2h-.2v-.2h-.4l-.2-.2h-.2v-.2h-.3v-.2h-.3v-.2l-.3-.2-.3-.2-.2-.3.7-.6h.2v.2h.2v.2h.2v.2h.2v.2h.3l.2.2.2.2h.2l.2.2h.2l.2.2h.2v.2h.4v.2l.2.2v.2zm-.2-.2v.2zm0 4.8h-1v-4.5l1-.2v4.5zm-1 0h1zm1 5-1-.7v.3-4.4h1zm0-.4v.2zm-3.3 2.5-.7-.8h.2v-.2l.3-.2.3-.2h.3v-.2h.3v-.2h.2l.2-.2h.2v-.2h.4v-.2h.4v-.2l1 .5-.2.2-.2.2h-.2v.2h-.4l-.2.2h-.2v.2h-.4v.2h-.3v.2h-.2l-.2.2-.2.2v.2h-.3zm-5 5.3-.7-.8h.2v-.2l.3-.2.3-.2.2-.2.3-.3.2-.2.2-.2.2-.2v-.2h.3v-.3l.2-.3.2-.2v-.2l.3-.2.3-.2v-.2l.3-.2.2-.2v-.2h.3v-.3l.3-.2.2-.2h.2v-.3h.3v-.3l.8.8-.2.2-.2.2-.2.2v.2h-.3v.3l-.3.2-.3.2-.2.2-.2.2-.2.2v.2l-.3.2v.2l-.2.2h-.2v.3h-.3l-.2.3v.2h-.2l-.2.3-.2.2-.3.3-.3.3-.3.2zm-6.8-2.7 1 .3v2.6l.2.2v.2h.2v.2h1.7v-.2h.4l.3-.2h.3l.3-.3.3-.3h.3l.2-.3.3-.2.3-.2.6.8-.4.2-.3.3-.3.2h-.4l-.3.3-.3.2h-.3l-.2.3h-.4l-.3.2h-.4l-.3.2h-.9l-.3-.2h-.3l-.2-.3-.2-.2-.2-.2v-.3l-.2-.2v-.7l-.2-.3zm-.3-3 .8-.6v.2h.2v.4h.2v.6l.2.2v2.4l-1-.2v-2.5h-.2v-.4h-.2zm-2.3-1.3.7-.8h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.2v.2h.2l.2.2.2.2-.8.6-.2-.2h-.2v-.2h-.4l-.2-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2zm.7-.8.5.2zm-3-1.7.8-.5.2.2v.2h.2v.4h.2v.2h.2v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2l-.5 1v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2zm-.3-3h1v2.4l-.7.5v-.2h-.2v-.4l-.2-.2v-2.1zm.3-2.8.8.6v.4l-.2.2v1.8h-1V217h.2v-.4zm2.4-2.4.7 1h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2h-.2v.2l-1-.5h.2v-.2l.2-.2.2-.2v-.2h.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm.7 1 .5-.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M475.5 220.2v1c-4 .4-7 2-9.7 4.3 1.8-2.7 5.7-4.7 9.7-5.3m0-1.6v-.8c-4-.5-7-2-9.7-4.4 1.8 2.7 5.7 4.6 9.7 5.2"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M461.2 207.3c1 .4 2.3 1 3.4 2 1.6 1.5.6 4-1.5 6.6-.6.7-1 2-1 3.5 0 1.3.5 2.7 1 3.5 2.2 2.5 3.2 5 1.6 6.6-1 1-2.3 1.5-3.4 2v-2.4c.2-1.3.2-2.7-.4-3.5-.5-.7-.8-.4-2.4-1.4a7 7 0 0 1-2.3-2.2c-.4-.8 0-1.7 0-2.6 0-1-.4-1.8 0-2.6.6-.8 1.4-1.6 2.4-2.2 1.6-1 2-.8 2.4-1.4.6-.8.6-2.2.4-3.5v-2.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m465 209-.8.6-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.4v-.2h-.5v-.2h-.2l-.2-.2h-.2l-.2-.2h-.2l.4-1h.2l.2.2h.2l.2.2h.3l.2.2h.2v.2h.3l.2.2h.2v.2h.3v.2h.2l.2.2.2.2.2.2zm-1.5 7.2-.8-.6.2-.3v-.2h.2l.2-.3.2-.3v-.2l.3-.2v-.5l.2-.2v-.2h.2v-.3l.2-.2v-.4h.2v-1.6l-.2-.3-.2-.2-.2-.2.7-.7.3.3v.2l.2.2v.2h.2v.5l.2.2v1l-.2.2v.4l-.2.2v.5l-.2.3v.3l-.3.2v.5l-.3.2v.3l-.3.2-.2.3v.2l-.3.2-.3.3-.2.2zm-1 3.3h-1v-.7l.2-.2v-1.2h.2v-1h.2v-.4l.2-.2v-.2h.2v-.2l1 .6h-.2v.4h-.2v.2l-.2.2v.9h-.2v1.4h-.2v.5zm1 3.2-.8.6v-.2h-.2v-.2h-.2v-.4h-.2v-1.1l-.2-.3V220h-.2v-.5h1v1.1l.2.2v.4l.2.2v.4l.2.2v.2h.2v.2zm1.5 7.3-.8-.8h.2v-.2h.2v-.3l.2-.2v-1.9l-.2-.2v-.2l-.2-.2v-.2l-.2-.3v-.2l-.2-.2-.3-.3v-.3l-.3-.2-.2-.2v-.2l-.3-.3-.3-.2.8-.6.2.2h.2v.4l.2.2.2.3h.2v.3l.3.3v.5l.3.3v.3l.2.2v.5l.2.2v.5l.2.2v.7l-.2.4v.4l-.2.2v.2l-.2.2v.2l-.3.2v.2zm-4.3 1.7 1-.2-.7-.4h.7v-.2h.4l.2-.2h.2l.2-.2h.2v-.2h.4v-.2h.2l.2-.2.2-.2h.2v-.2h.2v-.2l.8.8h-.2v.2h-.2v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-.2v.2h-.4v.2h-.4v.2h-.5v.2h-.2l-.2.2h-.2l-.7-.3zm.7.4-.6.3v-.6l.6.4zm-.7-3 1 .3v2l-1 .3v-2.4zm-.3-3 .8-.6v.2h.2v.4h.2v.6l.2.2v2.4l-1-.2v-2.4h-.2v-.4h-.2zm-2.3-1.3.7-.8h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.2l.2.2.2.2.2.2-.8.6-.2-.2h-.2v-.2h-.4l-.2-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2zm0 0-.3-.2zm-2.3-2.4.8-.5.2.2v.2h.2v.4h.2v.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2l-.5 1v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2zm0 0 .3.5zm-.3-3h1v2.4l-.7.5v-.2h-.2v-.4l-.2-.2v-2.2zm.3-2.8.8.6v.4l-.2.2v1.8h-1V217h.2v-.4zm2.4-2.4.7 1h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2h-.2v.2l-1-.5h.2v-.2l.2-.2.2-.2v-.2h.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2h.2zm2.4-1 .8.5-.2.2-.2.2h-.4v.2h-.4l-.2.2h-.2l-.2.2h-.2v.2h-.5v.2l-.7-1h.6v-.2h.2l.2-.2h.2l.2-.2h.4v-.2h.4v-.2h.2zm.3-3.2 1-.2v2.9l-.2.2v.2h-.2v.2l-1-.5v-.2h.2v-.4h.2zm.5-2v-1l.5.6v2.1l-1 .2V207l.5.6zm0-1h.6v.6zm0 0v1h-.2zM361 226.3l.7-.3c-1.6-2.2-2-4.2-1.3-6.3-1.3 1.6-1 4.2.6 6.6"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M410.7 200c1.4 1.6 1.2 2 2 2.5 1 .6 2 .4 3.3 0 5-2 5 2 3.5 6.4-.7 2-2.8 4.3-3.7 6.2-1 1.7-.7 3-1 3.5a95.4 95.4 0 0 1-4 .6l-4 .5c-.6-.3-1-1.6-2.6-3s-4.4-3-6-4.6c-3-3.5-4.6-6.8.2-6.7 1.2 0 2.4-.2 3-1 .4-.7 0-1 .4-3 .3-1.2.8-2.3 1.4-3 .6-.8 1.5-.6 2.3-.7 1-.2 1.6-.7 2.5-.2 1 .4 2 1.2 2.7 2.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m413 202-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.3-.3-.3.8-.6.3.2.2.3v.2h.2v.4h.2v.4h.2v.2l.2.2v.2h.2v.2l.2.2zm2.9 0 .2 1h-.5l-.2.2h-.8v.2h-1.2l-.3-.2h-.2l-.2-.2h-.2l.5-1v.2h.8v.2h1l.2-.2h.4l.2-.2zm4 7-1-.3v-.4l.2-.4v-.5l.2-.4v-.3l.2-.3v-.7l.2-.4v-1.7l-.2-.2v-.4h-.2l-.2-.3h-.2l-.3-.2H417l-.4.3h-.4l-.3-.8.3-.2h.5l.4-.2h1.8l.3.2h.3l.2.3.2.4v.2l.3.3.2.4v3.3l-.2.4v.4l-.2.4v.4l-.2.4v.4zm-3.7 6.4-1-.5v-.2l.2-.2.2-.2v-.2l.2-.2v-.4l.2-.2.2-.2v-.2l.2-.2.2-.2.2-.3.2-.2.2-.3.2-.2v-.2l.2-.2h.2v-.3l.2-.2v-.2l.2-.2.2-.3v-.2l.2-.2v-.2l.2-.3 1 .3v.2l-.2.3v.2l-.2.2-.2.3v.2l-.2.2v.3l-.3.2-.2.2v.2l-.2.2-.2.2v.2l-.2.2-.2.2v.2l-.3.2v.2l-.2.2-.2.2v.2l-.2.2v.4h-.3v.3l-.2.2-.2.2v.2zm-1.5 3.8-.2-1-.3.2v-.4h.2v-1l.2-.2v-.4l.2-.3v-.4l.2-.3v-.2h.2l1 .4-.2.2-.2.3v.3h-.2v.7h-.2v.9l-.2.2v.4l-.2.2v.2zm.3 0h-.2.3zm-4.3.6v-1h1.1v-.2h1.2v-.2h1.1l.3-.2.2 1h-.4l-.3.2h-.9l-.2.2h-1.3v.2h-.7zm0 0v-1 .5-.5zv-.5zm-4 .5.4-1h-.2 1.3l.3-.2h1.9l.2-.2.2 1h-.8v.2h-1.4v.2h-2zm.2 0h-.3.2zm-3-3 .5-1 .2.3.3.3h.2l.2.3.2.2.2.3.2.2v.2h.2v.2h.2v.2l.2.2v.2h.2v.2h.2v.2l-.4 1v-.2h-.2l-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.3v-.2h-.2v-.2h-.3v-.3zm-6-4.8.7-.6.2.2.3.3.3.3h.2v.3l.3.2h.3l.2.3h.2l.2.3.3.3.2.2.2.2h.2v.2l.3.2h.2l.2.3.2.2.3.3h.2l.2.3.3.2.2.2h.2v.2l-.5.8h-.3v-.2l-.3-.2h-.2v-.2l-.3-.2h-.3l-.2-.2-.2-.2h-.2v-.2l-.3-.2h-.2l-.2-.3h-.2v-.2h-.3l-.2-.2-.2-.2h-.2v-.3h-.3l-.2-.3-.2-.2h-.2v-.3h-.3v-.3l-.3-.2h-.2v-.3l-.3-.2zm.4-7.5v1H397l-.2.2h-.4l-.2.2v.2h-.2v1.5l.2.3v.3l.2.2.2.3.2.4.2.3.2.3.2.3.2.3.3.3v.2l.4.3.3.4-.8.5-.4-.3-.3-.3-.2-.4-.2-.4-.2-.3-.3-.4-.2-.3v-.4l-.3-.4v-.3l-.3-.3v-.3l-.3-.3V206l.2-.2.2-.2.2-.2.3-.2h.2l.3-.2h.7l.4-.2h.8zm2.5-.8.8.5-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2l-.2.2h-.5l-.2.2h-1.1v-1h1.4l.2-.2h.2l.2-.2h.2v-.2zv-.2zm.4-2.8 1 .2v.4h-.2v2h-.2v.4l-.2.2-1-.4h.2v-1.4l.2-.3v-.8zm1.4-3.2.8.6-.2.2v.2h-.2v.4h-.2v.4h-.2v.4l-.2.2v.4l-.2.2v.4l-1-.2v-.7l.2-.2v-.4l.2-.2v-.4h.2v-.4h.2v-.4h.2v-.2h.2v-.4zm.8.6.5-.7zm1.8-1.5.2 1H404v.2h-.4v.2h-.2l-.8-.5.2-.2.2-.2h.2v-.2h.4l.2-.2zm.2 1h-.7.6zm2.7-1.2-.5 1H406l-.2.2h-.4l-.2-1h.8l.2-.2h2.1zm3 3h-1v.2-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2.5-1v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2v.2l.2.2.2.2.2.2v.2l.3.3zm-.2-.4h.2v.3-.4zm-.8.3h1l-1 .2v-.3zm0 .2v-.3.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "M410 219.4h-.7c-1.4-3.8-3.5-7-6.3-9.5 2.8 1.4 5.5 5.3 7 9.4zm1.4-.2c.3 0 .5 0 .8-.2-.5-4 0-7.5 1.5-11-2 2.5-2.8 7-2.3 11.2"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M418.3 202c-.2 1.4-.4 3-1 4.3-1 2-3.8 1.3-6.6-.7-.8-.6-2.2-.8-3.4-.6-1.3.3-2.4.8-3 1.7-1.5 2.6-3.4 4-5.2 2.6-1-1-2-2.3-2.7-3.5.5-.2 1.2-.3 2-.3 1.3 0 2.5-.2 3-1 .5-.7 0-1 .6-3 0-1.2.6-2.3 1.2-3 .6-.8 1.5-.6 2.3-.7 1-.2 1.6-.7 2.5-.2 1 .4 2 1.2 2.7 2.3 1.4 1.6 1.2 2 2 2.5 1 .6 2.2.4 3.3 0 1-.4 1.7-.6 2.3-.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m417.7 206.5-1-.4.2-.2v-.5l.2-.2v-.4l.2-.2v-.9l.2-.2v-1.2h.2v-.4h1v1.1l-.2.3v1h-.2v.7h-.2v.7h-.2v.3l-.2.3zm-7.2-.5.5-.8.3.2h.2l.3.3h.2l.3.3h.2l.3.2.2.2h.2l.3.2h.4v.2h.7l.2.2h1v-.2h.2l.2-.2.2-.3.2-.2 1 .5-.2.2-.2.3-.3.3v.2h-.2l-.2.2h-.2l-.3.2h-2l-.2-.2h-.2l-.3-.2h-.2l-.2-.2h-.2l-.3-.2-.2-.2h-.2l-.3-.3-.2-.2h-.3l-.3-.3-.2-.2zm-3-.4-.3-1h1.1v-.2h1.3v.2h.6v.2h.4v.2h.2l.2.2-.5.8h-.2v-.2h-.4v-.2zm-2.7 1.3-.8-.6v-.2h.2v-.2h.2v-.2l.2-.2h.2v-.2h.2l.2-.2h.2l.2-.2h.3v-.2h.8l.2-.2h.5l.2 1h-.7v.2h-.4v.2h-.4l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2zm-6 2.7.6-.8h.3v.2h.5l.2.2h.5l.3-.2h.3v-.2h.3v-.2h.2v-.3h.3v-.3h.3v-.3l.3-.3.2-.2.2-.2v-.2h.3v-.4l.3-.2.8.5v.2l-.3.2v.3l-.3.2h-.2v.3l-.3.2-.2.2-.2.2-.3.3h-.2l-.2.3h-.2v.3h-.3l-.3.2h-.4l-.3.2h-1.2l-.2-.2h-.2l-.2-.2-.2-.2h-.2zm-2.7-4.4.5 1 .3-.8v.3h.2v.2l.2.2v.2h.2v.2l.2.2v.2h.2v.2l.2.2.2.2.2.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2l-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.2h-.2v-.4h-.2v-.2h-.2V205zm0 .8-.4-.4.5-.3v.8zm2.4-1v1H397v.2h-.4l-.5-1h1.2v-.2zm2.5-.8.8.5-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2l-.2.2h-.7l-.2.2h-1.2v-1h1.4l.2-.2h.4v-.2h.2v-.2h.2v-.2zm.4-2.8 1 .3v.3l-.2.3v1.7h-.2v.7h-.2l-1-.4h.2v-1.4h.2v-1.3zm1.4-3.2.8.6-.2.2v.2h-.2v.4h-.2v.4h-.2v.4l-.2.2v.7h-.2v.5l-1-.3v-.7l.2-.2v-.4l.2-.2v-.4h.2v-.4h.2v-.4h.2v-.2h.2v-.4zm0 0 .4-.5zm2.6-1 .2 1h-.6v.2h-1v.2h-.2l-.2.2-.8-.6.2-.2.2-.2h.2v-.2h.4l.2-.2h1.4zm0 0h.6zm3 0-.6.8H406v.2h-.5l-.2-1h.8v-.2h2.1zm-.6.8.3.2zm3.3 1.6-.6.6-.2-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2l-.2-.2.5-1v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2v.2l.2.2.2.2.2.2v.2zm2 2.5-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.3-.2-.3.7-.6.3.2.2.3v.2h.2v.2l.2.2v.4h.2v.2l.2.2v.2h.2v.2l.2.2zm-.6 1-.2-.2h.2zm3.5-1 .2 1h-.5l-.2.2h-.8v.2h-1.3l-.2-.2h-.2l-.2-.2h-.2l.5-1v.2h.6l.2.2h1.1l.2-.2h.4l.2-.2zm2.8 0h-1l.5.5h-1l-.2.2h-.4l-.2.2h-.2l-.3-1 .2-.2h.8v-.2h1.5l.5.4zm-.5-.5h.6l-.2.5-.5-.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M391.8 221.2c.7-1 1-.8 1.2-1.3.2-1-.3-2-1-3.2-2.2-4.6.3-4.2 3.6-2.4 1 .4 2 1.2 3 2 1 1 1.8 1.8 2.7 2.4 1.6 1.2 2.7 1.2 3 1.7 1 2 1.5 3.5 1.8 4.2.3.7 1 2.3 1.6 4.2 0 .4-1 .5-1.8 2-.7 1.2-1.2 3.5-2 4.7-1.4 1.6-2.5 2.6-3.4 2.4-1 0-1.6-1.3-1.8-4.2a4 4 0 0 0-1.5-3c-.5-.6-.6-.4-2-1.2a9.3 9.3 0 0 1-2.4-2c-.6-.6-.7-1.3-1-2-.3-1-.8-1.6-.7-2.4a3.8 3.8 0 0 1 .8-2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m392.5 219.7 1 .3v.2l-.2.2v.2h-.2v.2h-.2v.2h-.2l-.2.2v.2h-.2l-.8-.5v-.2l.2-.2.2-.2.2-.2h.2v-.2h.2zm-.8-2.7 1-.5v.4l.2.2v.4l.2.3v.2l.2.2v2l-1-.3v-1.2l-.2-.2v-.4h-.2v-.4h-.2v-.4zm4.2-3-.6.8h-.3l-.2-.3h-.3l-.3-.3h-.3l-.3-.2h-.3l-.2-.2h-.5l-.2-.2h-.6v1.5l.3.4.2.3.2.4.2.5-1 .5v-.4l-.3-.4-.2-.4v-.7l-.2-.2v-1.5l.2-.2h.2l.2-.2h.2l.2-.2h1.2l.2.2h.6l.3.3.3.2h.3l.3.2.2.2.4.2h.3zm2.8 2-.7 1v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2.5-1v.2h.2v.2h.2l.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2zm2.8 2.4-.6.8h-.2v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2l.6-1v.2h.2l.2.2v.2h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2zm3.3 2-1 .3v.2-.2h-.2v-.2h-.4l-.2-.2h-.2l-.2-.2h-.3l-.2-.2h-.3v-.2h-.3v-.2h-.3v-.2h-.3v-.2l.6-.8.2.2h.2v.2h.3l.2.2h.2l.2.2h.2v.2h.4l.2.2h.4v.2h.2l.2.2h.2v.3zm-.2-.3v.2zm1.7 4.5-1 .4v-.7l-.2-.2v-.4l-.2-.2v-.5h-.2v-.4l-.2-.3v-.3h-.2v-.5h-.2v-.5h-.2v-.3l1-.4v.4l.2.3v.2l.2.3v.2l.2.3v.3l.2.3v.4h.2v.4l.2.2v.4h.2v.4zm0 0-1 .4h.3l.3.2-.5-.5.6.5-.5-.5.6.5-.5-.5.2.4-.2-.3v.2l1-.5v.2-.4.4l-.4-.5.6.5-.5-.5.6.5-.5-.5h.4v.3zm0-.2v.2zm1.6 4.7-1-.2v.3-.5l-.2-.3v-.2l-.2-.3v-.3l-.2-.3v-.2l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.4l-.2-.2 1-.5v.4h.2v.5h.2v.5l.2.2v.3l.2.3v.5l.2.2v.3l.2.2v.2l.2.2v.6zm0-.3v.3zm-1.7 2.4-1-.4.2-.2v-.2h.2v-.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2h.2v-.2l1 .2v.4h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2zm-2.2 5-.7-.7.2-.3v-.2h.2v-.3l.2-.2v-.4l.2-.2v-.5h.2v-.4h.2v-.5h.2v-.2l.2-.3v-.2l.2-.3v-.2l.2-.2 1 .5-.2.2v.3h-.2v.4h-.2v.5l-.2.2v.3l-.2.2v.3l-.2.2v.3l-.2.2v.3l-.2.2v.3h-.2v.3h-.2v.3l-.2.2v.2zm-3.7 2.7.2-1h.4v-.2h.2l.2-.2h.2v-.2h.2l.2-.2.2-.2.2-.2.2-.2.2-.3.2-.2v-.2h.2v-.3l1 .7h-.2v.3h-.3v.3h-.2v.3h-.4v.4h-.2v.2h-.2l-.2.2-.2.2-.2.2h-.3v.2h-.4v.2h-1zm-2.2-5h1v.3l.2.2v1.1h.2v.5l.2.2v.3l.2.2v.2h.2v.2h.2v.2h.2v1h-.8v-.2h-.2l-.2-.2-.2-.2v-.3h-.2v-.2l-.2-.2v-.3l-.2-.3v-.4h-.2v-1l-.2-.2v-1zm-1.2-2.6.7-.6.2.2v.2h.2v.2l.2.2v.2h.2v.3l.2.2v.2h.2v.7h.2v.6l-1 .2v-1h-.2v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.4h-.2v-.2zm-2-1 .4-.8h.3v.2h.4v.2h.4v.2h.4v.2h.4v.2h.2v.2l-.6.7h-.2l-.2-.2h-.4v-.2h-.4l-.2-.2h-.2l-.2-.2h-.3zm-2.5-2 .7-.6.2.2.2.2.2.2.2.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.2l.2.2-.5 1v-.2h-.2v-.2h-.4v-.2l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2zm-1.2-2.3 1-.4v.2h.2v.4h.2v.5h.2v.4h.2v.2l.2.2-.7.7h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.8h-.2v-.2zm-.6-2.5h1v.8h.2v.4l.2.2v.2l.2.2v.2l-1 .5v-1h-.2v-.4h-.2v-.6h-.2v-.8zm1 0v.2zm.4-1.5v-1l.3.8v.4h-.2v.2h-.2v.8h-.2v.2h-1v-.9l.2-.2v-.4l.2-.2v-.2h.2v-.4h.2v-.2h.2l.4.7zm0-1h1l-.7.8-.2-.8zm0 0v1l-.4-.8.4-.3zm0 1h-1l.6-.8.4.7z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m406.5 226 .2 1c-1.4.4-2.6 1-3.6 1.8s-1.7 2-2.3 3.2c.2-1.4 1-2.7 2-3.7s2.3-1.8 3.8-2.2zm-.6-1.6-.5-1c-1.6 0-3.2-.4-4.7-1-1.5-.7-3-1.6-4.4-2.8 1 1.3 2.6 2.4 4.3 3.3 1.6.7 3.5 1.3 5.2 1.5z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M391.4 213.8c1 .4 1.6.8 2.8 1.8.8.7 1.3 1.7 1.5 3 0 1 0 2.5-.3 3.8-.2.8 0 2.2.5 3.6.4 1.4 1 2.8 2 3.5 2.3 2.5 4 5 3.4 6.7a4 4 0 0 1-1.5 1.8c-.4-.6-1-1.2-1.4-2.2a8 8 0 0 0-1.5-3.5c-.5-.6-.7-1.3-2-2.2-1-.5-2-.3-2.6-1-1.2-1.6-3-5.5-1.3-7.2 1.7-1.7 2.3-2.7 1-5.6-.5-1-.5-1.8-.6-2.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m394.5 215.2-.7.8-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2l-.2-.2h-.4l.3-1h.4v.2h.4v.2h.4v.2h.4v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2v.2zm1.7 3.2-1 .2v-.6h-.2v-.7h-.2v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l.7-.8h.2v.2l.2.2v.2h.2v.2l.2.2v.2h.2v.4l.2.2v.4h.2v.8h.2v.2zm-.3 4h-1V221h.2v-2.4l1-.2v3.3l-.2.2zm-1 0v-.3zm1.4 3.5-1 .2v-.5l-.2-.3v-.4l-.2-.3v-.8h-.2v-1.4h1v1.9h.2v.7h.2v.7h.2zm1.8 3.2-.7.7v-.2l-.2-.2h-.2v-.4h-.2v-.2l-.2-.3v-.2h-.2v-.2l-.2-.3v-.2h-.2v-.5l-.2-.2-.2-.3v-.4h-.2l1-.4v.2l.2.2v.2l.2.3.2.2v.3l.2.2v.2h.2v.2h.2v.4h.2v.2h.2v.2h.2v.2zm3.6 7.2-1-.4.2-.2v-1.3l-.2-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.3-.2-.2-.3v-.3l-.3-.2-.2-.2-.2-.3-.2-.2-.2-.2-.2-.2-.3-.3h-.2l.7-.8.3.2.2.2.2.3.3.4.3.2.2.2v.3l.3.3.3.2.2.3v.2l.3.2.2.3v.2l.2.2.2.2v.2l.2.2v.2l.2.3v.7l.2.2v1.2l-.2.2zm-2.4 1.8 1-.4-.8-.2.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l1 .4v.2l-.2.2v.2l-.2.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2l-.2.2zm.8.2-.5.3-.3-.5zm-2-2.5 1-.3v.4h.2v.4h.2v.2h.2v.2l.2.2v.2h.2v.4l-.8.4v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.4l-.2-.2v-.2zv-.3zm-1.5-3.3.8-.7v.2h.2v.2l.2.2v.2l.2.2v.2h.2v.5h.2v.4l.2.2v.4l.2.3v.7l-.8.2v-.4h-.2v-.5l-.2-.2v-.5h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2zm-2-2.2.4-1 .3.2.2.2h.2l.2.2.2.2.2.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2l-.7.7-.2-.2v-.2h-.2v-.2h-.2v-.4h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2zm-2.7-1.3.8-.6h.2v.2h.2v.2h.9l.2.2h.4l.2.2h.2l.2.2-.4 1v-.2h-.4l-.2-.2h-.9v-.2h-.4l-.2-.2h-.2l-.2-.2-.2-.2zm-1.2-7.8.7.7v.3h-.2v.3h-.2v2.2l.2.3v.5l.2.2v.2l.2.3v.2l.2.2v.2l.2.2v.2l.3.2v.2h.2v.3l.2.2-.7.7-.2-.3-.2-.3v-.2l-.2-.2v-.2h-.3v-.3l-.2-.3-.2-.4v-.2l-.2-.3v-.2l-.2-.2v-.6l-.2-.3v-2.1l.2-.3v-.2h.2l.2-.3.2-.3zm.7-5 1-.5v.5l.2.2v.3l.2.2v.7h.2v1.7l-.2.2v.2l-.2.2v.2h-.2v.3h-.2v.2l-.2.2-.3.3h-.2l-.2.3-.8-.6.2-.3h.2l.2-.3.2-.3.2-.2v-.3l.2-.2v-.2l.2-.3v-.7l-.2-.2v-.5l-.2-.2-.2-.4v-.2zm0-3v1l.4-.7v1.4h.2v1.1h.2l-1 .6v-.9h-.2v-.7l-.2-.2v-1l.4-.7zm-.6.5-.3-.7h.7l-.5.6zm.4.3v-1zm0-1"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M434 226.2c-1.2 1-1.5 1-2 1.6-.3.8 0 2 .3 3.3 1.5 5-1.4 4.4-5 2.6-1.6-1-3.6-3.2-5.2-4.4-1.5-1-2.6-1-3-1.6a118.7 118.7 0 0 1-1-4.3c0-.7-.5-2.4-1-4.4.4-.7 1.4-1 2.5-2.5 1-1.7 2.2-4.7 3.6-6 3-3.2 6-4.5 6 1.3 0 1.4.3 3 1 3.6.6.6 1 .3 2.5 1 1 .6 2 1.3 2.6 2 .7 1 .5 2 .7 2.8 0 1 .5 1.7.2 2.6-.5 1-1 1.7-2 2.4z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m432.6 228-1-.5h.2v-.4h.4v-.2h.4v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.8.8-.2.2h-.2v.2h-.2l-.2.2-.2.2h-.2v.2h-.4v.2zm0 2.9-.8.3v-.2l-.2-.2v-.7h-.2v-2.3h.2v-.2l1 .4v.2h-.2v2.1h.2v.7zm-5.4 3 .5-.8h.3l.3.3h.3l.3.3h.2l.3.2h.2l.3.2h.7l.2.2h.7v-.2h.2v-.4l.2-.3v-1.1l-.2-.3v-.3l-.2-.4 1-.4v.4l.2.4v.8l.2.3v1.1l-.2.4v.2l-.3.2-.2.2h-.2l-.2.2-.4.2h-1.2l-.3-.2h-.6l-.3-.3-.2-.2h-.3l-.3-.2-.4-.2-.3-.2zm-5.4-4.3.6-1 .2.2.3.2.2.3h.2v.3h.3v.3l.3.2.2.2h.2v.3h.3l.2.3.2.3.2.2.3.3h.2v.2l.2.2h.2l.2.2v.2h.3v.2h.2l.2.2.3.2-.5 1-.2-.2h-.2v-.2l-.3-.2h-.2l-.2-.2-.2-.3h-.2l-.2-.2h-.2v-.3h-.3l-.3-.3h-.2v-.3l-.3-.3h-.2l-.2-.3-.3-.3h-.2v-.2h-.3l-.2-.3-.3-.3-.3-.2-.3-.2h-.2zm-3.4-2 1-.2v-.2h.2v.2h.4l.2.2h.4v.2h.7l.2.2h.2l.2.2.3.2h.2l.2.2-.6 1v-.2h-.3v-.2h-.2l-.2-.2-.2-.2h-.3l-.2-.2h-.2v-.2h-.4l-.2-.2h-.2l-.2-.2h-.2v-.2h-.2v-.3zm.2.3v-.3zm-.6-4.2v-1l.5.4v.4l.2.2v1h.2v1.3h.2v1h.2v.5l-1 .2v-.7l-.2-.3v-.7l-.2-.3v-.7h-.2v-.8l-.2-.2v-.6l.4.4zm0-1h.5v.4zm-.5.6 1-.2v-.2l-.5-.2v1h-.3zm-.8-4.7 1 .4v-.2 1.1h.2v1.1l.2.3v.8l.2.2v.9l-1 .2V222l-.2-.2v-.8l-.2-.3v-.7h-.2v-.8l-.2-.2v-.3zm0 .3v-.3zm2.4-2.8 1 .5-.2.2-.2.2-.2.3-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2l-1-.3h.2v-.4h.2v-.2h.4v-.2h.2l.2-.2.2-.2.2-.2h.2v-.2l.2-.2.2-.2v-.2h.2zm3.7-6.2.8.7h-.2v.3h-.2v.3l-.3.3v.2l-.2.2v.2h-.2v.3l-.2.3v.4l-.3.2v.2l-.2.2v.2l-.2.2v.2l-.2.2v.3l-.2.3v.2l-.2.2v.2h-.2v.2l-.2.2-.2.2-1-.4.2-.2.2-.3v-.2h.2v-.3l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.3l.2-.2v-.2h.2l.2-.3v-.2l.2-.2v-.3l.2-.2v-.2l.3-.2v-.2l.2-.2.2-.3v-.2l.2-.2h.2zm6.8 1.8h-1v-1.4l-.2-.4v-.6l-.2-.2v-.4l-.2-.2h-.3v-.2h-1.2l-.3.2-.3.2h-.2l-.3.3-.2.3-.3.2-.2.2-.3.2-.2.2-.3.2-.2.3-.8-.7.3-.3.3-.3.3-.2.2-.3.3-.3.4-.2.3-.2.2-.2h.2l.3-.3h.2l.3-.2h.3l.2-.2h1.2l.3.2.3.3.2.2.2.2.2.3v.6l.2.5v.4l.2.3v1.5zm1 3.3-.8.8-.2-.2v-.2h-.2v-.2l-.2-.2v-.6l-.2-.2v-.7l-.2-.2V212h1v2h.2v.3l.2.2v.2h.2v.2zm2.2 1-.4 1-.3-.2h-.2l-.3-.2h-.4v-.2h-.9v-.2h-.4v-.2h-.2v-.2l.6-.7v.2h.4v.2h.8l.2.2h.4l.2.2h.2l.2.2zm2.8 2.2-.8.6h-.2v-.2l-.2-.2h-.2v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2.3-1 .3.2h.2l.2.2.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2zm-.8.6.4.5zm1.5 2.3-1 .2V220l-.2-.2v-.8h-.2v-.4l.7-.6v.2l.2.2v.2l.2.2v2.2h.2v.2zm0 3-.8-.4v-2.1l-.2-.2v-.4h1v1l.2.2v1.8zm-1.8 2.6-.7-.8h.2v-.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2h.2v-.2l1 .4-.2.2v.2l-.2.2v.2h-.2v.4h-.2v.2h-.2v.2l-.2.2-.2.2v.2h-.2l-.2.2zm-.7-.8"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m418 222.6-.2-1a14 14 0 0 0 7.8-5.3c-1.2 3-4.3 5.3-7.7 6.3zm.2 1.5c0 .4.2.7.3 1 3.4 0 6.4 1 9.2 3-2-2.3-5.8-3.8-9.5-4"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M432.7 233.3a11 11 0 0 1-3.4-1.5c-1.6-1.3-1.2-3.8.3-6.4.4-.8.5-2.2.2-3.5a6.3 6.3 0 0 0-1.4-3.5c-2.4-2.3-3.8-4.8-2.6-6.6.8-1.3 2-2 2.8-2.7.3.6.4 1.5.4 2.5 0 1.4.3 3 1 3.6.6.6 1 .3 2.5 1 1 .7 2 1.3 2.6 2 .7 1 .6 2 .7 2.8 0 1 .5 1.7.2 2.6-.5 1-1 1.7-2 2.4-1.2 1-1.5 1-2 1.6-.3.8 0 2 .3 3.3.3 1 .4 1.7.4 2.3z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m429 232.2.6-.8h.2v.2h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.4l.2.2h.4l.2.2h.2l-.3 1h-.4v-.2h-.4l-.2-.2h-.3v-.2h-.4l-.2-.2h-.2l-.2-.2h-.2v-.2h-.2l-.3-.2h-.2v-.2zm0-7 1 .5v.2h-.2l-.2.4v.2l-.2.2v.2l-.2.3v.4l-.2.2v.5l-.2.2v1.5l.2.3v.2h.2v.3l.2.2.2.2-.6.8-.2-.2-.3-.3v-.2h-.2v-.3l-.2-.2v-.4l-.2-.3V228h.2v-.7l.2-.3.2-.3v-.3l.2-.2v-.3l.3-.3v-.5zm.3-3.3 1-.2v.8h.2v1.9l-.2.2v.7h-.2v.2l-1-.4h.2v-.6h.2V222zm-1.3-3.2.7-.7v.2h.2v.4h.2v.2l.2.2v.2l.2.2v.2l.2.2v.5h.2v.7l.2.2v.8h-1v-1.2l-.2-.2v-.4h-.2v-.4h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2zm-2.7-7.2 1 .6h-.2v.7l-.2.2v.7l.2.2v.4l.2.2v.2l.2.2v.2l.2.2v.2l.3.2v.2l.2.2.2.2v.2l.3.3.2.3v.2l.3.2.2.2h.2l-.7.8-.2-.2-.2-.2-.3-.2-.2-.2v-.3l-.2-.2-.2-.2-.2-.2-.2-.2v-.2l-.3-.2-.2-.3h-.2v-.3l-.2-.2v-.3l-.2-.2v-.2l-.2-.3v-.4l-.2-.2v-1l.2-.3v-.2l.2-.2v-.2zm3.8-2.5-.8.4.7.3h-.2l-.2.2h-.2l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-1-.6h.2v-.2l.2-.2.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2h.2l.2-.2.2-.2h.2v-.2h.2l.2-.2.2-.2h.2v-.2zm-.6 0 .5-.5v.6h-.6zm1 2.8h-1v-2.1h-.2v-.4l1-.3v1h.2v2zm1 3.3-.7.8-.2-.2v-.2h-.2v-.2l-.2-.2v-.7l-.2-.2v-.7l-.2-.2V212h1v1.7h.2v.6l.2.2v.2h.2v.2l.2.2zm2.3 1-.4 1-.3-.2h-.2l-.3-.2h-.4v-.2h-.9v-.2h-.4v-.2h-.2v-.2l.6-.7v.2h.4v.2h.8l.2.2h.4l.2.2h.2l.2.2zm2.8 2.2-.8.6h-.2v-.2l-.2-.2h-.2v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2.3-1 .3.2h.2l.2.2.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2zm-.8.6.4.5zm1.5 2.3-1 .2V220h-.2v-.8h-.2v-.4l.7-.6v.2l.2.2v.2l.2.2v2h.2v.2zm0 3-.8-.4v-2.2l-.2-.2v-.4h1v1l.2.2v1.8zm-1.8 2.6-.7-.8h.2v-.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2h.2v-.4h.2v-.2l1 .4-.2.2v.2l-.2.2v.2l-.2.2v.2h-.2v.2h-.2v.2l-.2.2-.2.2v.2h-.2l-.2.2zm-1.7 1.4-1-.5v-.2h.2v-.2h.2v-.2h.4v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.8.8-.2.2h-.2v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-.2zh-.2v.2zm0 2.9-1 .3v-.7h-.2v-3h.2l1 .4h-.2v2.6h.2v.2zm-.2 2.8.3-1-.6.5v-1h-.2v-.9l-.2-.2 1-.5v.9h.2v1h.2v.7zm.7-.5v.7l-.7-.2zm-.5 0-.2.5zm.5 0v.7l-.7-.2z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M410.6 216.4c4 0 8 3.4 8.4 7.7.6 4.4-2.2 7.7-6 7.8-4 0-7.5-3-8.3-7.3-.7-4 1.8-8 6-8z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m419.5 224-1 .2v-.8l-.2-.4v-.3l-.2-.4v-.3l-.2-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.3-.3-.2-.2-.3-.3-.3-.2-.2-.3-.3-.3-.2-.3-.2-.4-.2h-.3l-.3-.3h-.4l-.3-.3h-.3l-.4-.2h-.3l-.3-.2h-1.5v-1h1.9l.4.2h.3l.4.3h.4l.4.3.4.2.3.2.5.2.3.3.3.2.4.2.3.3.3.3.3.3.3.4.2.3.2.4.3.4.2.4.2.4.2.4v.4l.2.4v.4l.2.4v.8zm-6.6 8.3v-1h.9l.2-.2h.6l.3-.2h.4l.2-.2.3-.2h.2l.2-.3h.2l.2-.3.3-.3.3-.2v-.2l.3-.3.2-.2v-.3l.3-.3.2-.4v-.3l.2-.3v-.7l.2-.3V224l1-.2v2.5l-.2.4v.8l-.3.4v.3l-.2.3v.4l-.3.3-.2.3-.3.3h-.2l-.2.4-.3.2-.3.3h-.3l-.3.3-.3.2h-.2l-.3.3h-.4l-.2.2h-.4l-.3.2H413zm-8.7-7.7 1-.2v.7l.2.5v.3l.3.4v.3l.3.3.2.4.2.3.2.3.2.3.2.3.3.3.2.3h.3l.2.3.3.3.2.2.3.2.3.2h.4l.3.3.3.2h.3l.3.2h.7l.3.2h1.2v1h-2l-.3-.2h-.4l-.4-.3h-.4l-.4-.3-.3-.2-.4-.2-.3-.2-.4-.2-.4-.2-.3-.3-.2-.2-.2-.2-.3-.3-.2-.3-.3-.3-.2-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.4v-.4l-.2-.4-.2-.4v-.8zm6.2-8.7v1h-1l-.3.2h-.4l-.3.2h-.3l-.3.3h-.2l-.2.3-.3.2-.2.2v.2l-.3.2-.2.2-.2.3-.2.3v.2l-.2.3v.4l-.3.3v.6l-.2.3v.7l-.2.3v.7l.2.4v.8l-1 .2v-3.3l.2-.3v-.3l.2-.4v-.3l.3-.4v-.3l.3-.3.2-.3.2-.3.2-.3h.2l.2-.4.3-.2.3-.2.3-.2.3-.2.3-.2.3-.2h.3l.4-.2h.4l.3-.2h.9z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#edb92e",
                  d: "M411 218.6c2.8-.2 5.7 2.4 6 5.5.5 3.3-1.5 5.8-4.4 5.8-2.8 0-5.5-2.3-6-5.3s1.3-5.8 4.3-6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m417.6 224-1 .2v-.6l-.2-.3v-.2l-.2-.3v-.4l-.2-.2v-.2l-.2-.3-.2-.3v-.2l-.3-.2-.2-.2-.2-.3-.2-.2-.2-.2h-.2l-.2-.3h-.2l-.3-.3h-.2l-.2-.2-.4-.2h-.5v-.2h-1.1v-1h1.1l.4.2h.3l.2.2h.2l.3.2h.3l.2.3h.3l.2.2.3.2h.2l.3.3.2.3.2.2.2.2v.2l.3.3h.2v.4l.3.3v.3l.3.2.2.3v.3l.2.3v.8l.2.3zm-5 6.3v-1h1.1l.2-.2h.4l.2-.2h.2v-.2l.3-.2h.3v-.2l.3-.2v-.2h.2l.2-.3v-.2l.2-.2.2-.3v-.7l.2-.2v-1.6h1v2.2l-.2.3v.2l-.2.3v.2l-.3.3-.2.2v.3l-.3.2-.2.2-.2.2-.3.2-.2.2-.2.2h-.2l-.2.2h-.2l-.3.2h-.2l-.2.2zm-6.5-5.8h1l.2.4.2.4v.2l.2.3.2.3v.3l.3.2.2.2.2.2v.2l.3.2.2.2.3.3.2.2.2.2h.2v.3h.3l.2.2h.7l.2.2h1.1v1H411l-.4-.2h-.2l-.3-.2h-.2l-.2-.3h-.3l-.2-.3-.4-.3-.2-.3-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3v-.2l-.3-.2-.2-.2-.2-.3v-.3l-.2-.3v-.3l-.2-.2v-.7zm5-6.4v1h-.6l-.2.2h-.5l-.2.2h-.2l-.2.2-.2.2h-.2l-.2.3v.2l-.3.2-.2.3v.2h-.2v.3l-.2.2v.2l-.2.2v.7l-.2.2v1.7h-1V222h.2v-.4l.2-.3v-.2l.2-.2v-.2l.3-.3v-.2h.2l.2-.3.2-.2.2-.2.2-.2h.2l.2-.2h.3l.2-.3h.2l.2-.2h.6l.3-.2h.6z"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#0c4076",
                  d: "M411.2 220.7c2 0 3.6 1.5 4 3.5.2 2-1 3.6-3 3.6a4 4 0 0 1-3.7-3.4c-.3-2 1-3.6 2.7-3.7"
                }),
                /* @__PURE__ */ jsx208("path", {
                  fill: "#21231e",
                  d: "m415.6 224-1 .3v-.4l-.2-.2v-.4h-.2v-.3l-.2-.2-.2-.3-.2-.2-.2-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2h-.6v-.2h-.6v-1h1l.2.2h.2l.3.2h.3v.2h.3l.2.3v.2h.3l.2.2.2.2.2.3.3.2v.4h.2v.3l.2.3v.4zm-3.3 4.3v-1h.7l.2-.2h.4v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.5l.2-.2v-1.1l1-.3v2h-.2v.3l-.2.3-.2.3-.2.2h-.2v.2l-.2.2h-.2v.2h-.3l-.2.2h-.4v.2h-1zm-4.3-3.8 1-.2v.5l.2.3v.4h.2v.2l.2.2.2.2.2.3.2.2.2.2h.3v.2h.4l.3.2h.8v1h-1.3l-.2-.2h-.2l-.3-.2h-.2v-.2h-.2v-.2l-.3-.2-.3-.2v-.2h-.2v-.3h-.3v-.3l-.2-.2v-.2h-.2v-.5l-.2-.2v-.5zm2.7-3.8h1l-.5.5h-.7l-.2.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.5h-.2v1.3l-1 .3v-1.8h.2v-.5h.2v-.3h.2v-.3h.3v-.3h.3v-.2h.3v-.2h.3v-.2zl.2-.2h.4l-.5.5zm1 0v.5h-.5zm0 0h-1l.5-.5zm-1 0v-.5h.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M482 183c4 0 7 3 7 7s-3 6.7-7 6.7c-3.6 0-6.7-3-6.7-6.8 0-4 3-7 6.8-7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M489.5 189.8h-1c0-2.3-1.4-4.6-3.5-5.6a6.3 6.3 0 0 0-3-.7v-1c2.6 0 5 1.3 6.4 3.5a7.4 7.4 0 0 1 1 3.8zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5.2-3.7 6.5a7.3 7.3 0 0 1-3.7 1zM475 190h1a6.4 6.4 0 0 0 6.3 6.2v1a7.1 7.1 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.5v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.7 1.4-5 3.5-6.4a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M482 171c4 0 7 3 7 7a6.8 6.8 0 1 1-13.7-.2c0-3.7 3-6.7 6.8-6.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M489.5 178h-1c0-2.4-1.4-4.7-3.6-5.8a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.3v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.5-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 178h1a6.4 6.4 0 0 0 6.3 6.3v1a7.1 7.1 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M482 159.6c4 0 7 3 7 7a6.8 6.8 0 1 1-13.7-.2c0-3.7 3-6.8 6.8-6.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M489.5 166.5h-1c0-2.4-1.4-4.7-3.6-5.7a6.3 6.3 0 0 0-3-.7v-1c2.6 0 5 1.5 6.4 3.6a7.4 7.4 0 0 1 1 4zM482 174v-1c2.5 0 4.7-1.5 5.8-3.6.4-1 .7-2 .7-3h1c0 2.6-1.4 5-3.5 6.4a7.3 7.3 0 0 1-4 1zm-7.2-7.5h1c0 2.4 1.4 4.7 3.6 5.7a6.3 6.3 0 0 0 2.7.7v1a7.2 7.2 0 0 1-6-3.6 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.4 6.4 0 0 0-5.5 3.6 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.4a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M482 127c4 0 7 3.2 7 7s-3 6.8-7 6.8a7 7 0 0 1 .1-13.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M489.5 134h-1c0-2.4-1.4-4.7-3.6-5.8a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.3v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.5-1.5 5-3.7 6.3a7.3 7.3 0 0 1-3.7 1zM475 134h1c0 2.3 1.4 4.6 3.5 5.6a6.3 6.3 0 0 0 2.8.7v1a7.3 7.3 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M482 137.2c4 0 7 3 7 6.8s-3 7-7 7c-3.6 0-6.7-3.2-6.7-7s3-6.8 6.8-6.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M489.5 144h-1c0-2.3-1.4-4.6-3.5-5.7a6.3 6.3 0 0 0-3-.6v-1c2.7 0 5.2 1.4 6.5 3.6a7.4 7.4 0 0 1 1 3.7m-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 144h1c0 2.4 1.4 4.7 3.5 5.7a6.3 6.3 0 0 0 2.8.7v1a7 7 0 0 1-6-3.5 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.4 6.4 0 0 0-5.5 3.6c-.5 1-.7 2-.7 2.8h-1c0-2.5 1.4-5 3.5-6.2a7.3 7.3 0 0 1 3.8-1.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M482 148.2c4 0 7 3 7 6.8s-3 7-7 7c-3.6 0-6.7-3.2-6.7-7s3-6.8 6.8-6.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M489.5 155h-1c0-2.3-1.4-4.6-3.6-5.7a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 155h1c0 2.4 1.4 4.7 3.5 5.7a6.3 6.3 0 0 0 2.8.7v1a7.3 7.3 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.5 6.5 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.5 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M487 195.5c1 1.6.7 2 1.4 2.4.8.6 2 .6 3.4.4 5.3-1 4.5 2.3 2.2 6-1 1.7-3.8 3.5-5.2 5-1.4 1.5-1.6 2.8-2 3.2h-9.2c-.5-.4-.7-1.7-2-3.2-1.5-1.5-4.2-3.3-5.3-5-2.4-3.7-3-7 2.2-6 1.3.2 2.6.2 3.4-.5.6-.6.3-1 1.3-2.5a7 7 0 0 1 2.2-2.3c1-.5 1.8-.2 2.6-.2 1 0 2-.3 2.8.2a7 7 0 0 1 2.2 2.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m488.7 197.5-.7.8-.2-.2h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.3v-.2l.8-.6v.2h.2v.3l.2.2v.2h.2v.4h.2v.4h.2v.4h.2zm-.7.8-.3-.3zm3.8-.4v1h-2.4l-.2-.2h-.2l-.2-.2h-.3l-.2-.2.7-1v.2h.2v.2h.8l.2.2h1.9zm2.6 6.6-.8-.6.2-.3.2-.3.2-.4.2-.3v-.3l.3-.3v-.2l.2-.2v-.6l.2-.2v-1.3l-.2-.2h-.2v-.2h-.5l-.2-.2h-2l-.2-1h2.8l.3.2h.2l.2.2.2.2.2.2.2.2v.3l.2.3v1.7l-.2.3v.3l-.3.2v.4l-.3.3v.2l-.3.4v.3l-.3.2-.3.4zm-5.3 5.2-.6-.7.3-.2v-.2h.3l.2-.3v-.2h.3l.2-.2h.2v-.3h.2l.2-.3.2-.2h.2l.2-.3h.2v-.3l.3-.2h.2l.2-.3v-.2l.2-.2.2-.2h.2v-.3h.3v-.4h.3v-.3h.2v-.3l1 .6-.2.2-.2.3v.3l-.2.2h-.2l-.2.3v.2l-.3.2-.3.3v.2h-.3l-.2.3-.2.2h-.2l-.2.3-.2.2-.3.3-.3.3h-.2v.3l-.3.2h-.2v.3l-.3.2h-.2v.3h-.2l-.2.3zm-2.3 3.3v-1l-.3.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2h.2v-.2l.2-.2.2-.3.3-.3.8.6v.2l-.2.2-.2.2-.2.3v.2h-.2v.2l-.2.2v.2l-.2.2v.2h-.2v.4h-.2v.2l-.2.2v.2h-.5zm.3 0h-.2zm-5 .2v-1h4.7v1h-4.5zm0-1h.2zm0 0v1zm-4.7.8.6-.8h-.4 4.2l.2 1h-4.7l-.3-.2zm.3 0h-.2zm-2.4-3.2.7-.7v.2l.2.2.2.3.2.3.2.2v.2h.2v.4h.2v.4h.2v.4h.2v.4h.2v.2l-.5.8-.2-.2v-.2l-.2-.2v-.2h-.2v-.4h-.2v-.4l-.2-.2v-.2h-.2v-.2l-.2-.3-.2-.2-.2-.3-.2-.2zm-5.4-5.2 1-.6v.2l.2.3h.2v.3l.2.2h.2v.3h.3v.3l.2.2h.2l.2.3.2.2v.2l.3.2h.3l.2.3h.2l.2.2v.2h.2l.2.3h.2l.2.3h.2v.3l.3.2h.2v.3h.3v.3l-.6.8-.2-.2-.3-.3-.3-.2-.3-.2v-.2l-.2-.2h-.2l-.2-.3h-.2l-.2-.2h-.2v-.3l-.3-.2h-.2l-.2-.3v-.2h-.3l-.2-.3v-.2h-.3l-.2-.3v-.2l-.3-.2h-.2v-.3l-.3-.2-.2-.2-.2-.2zm2.7-6.7v1l-.6-.2h-2.1l-.2.2h-.2v.2h-.2v.4l-.2.2v1.1l.2.2v.3l.2.3v.2l.2.3.2.4v.3l.3.3.3.4.2.3.2.3-1 .6v-.4l-.3-.3-.2-.4-.2-.4v-.3l-.3-.4v-.4l-.3-.3v-.4l-.2-.3v-.6l-.2-.3v-1l.2-.2v-.2l.3-.2.2-.2.2-.2.4-.2h.3l.3-.2zm3-.5.8.8-.2.2h-.2l-.2.2h-.4l-.2.2h-3v-1h2.5l.2-.2h.4v-.2zm1.4-2.3.7.6v.3l-.2.2v.2h-.2v.4h-.2v.8h-.2v.2h-.2v.2l-.2.2-.8-.7h.2v-.4h.2v-.4h.2v-.2l.2-.2v-.4h.2v-.3h.2v-.3zm0 0 .2-.4zm2.3-2.4.5.8-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-.2.2v.2l-1-.6.2-.2.2-.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm2.8-.3v1h-2.4l-.5-.7h.2v-.2h.4l.2-.2zm3 .3-.5.8h-.4v-.2H482v-1h2.5l.2.2h.2zm0 0 .3.2zm2 3.2v-1l-.4.8-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2v-.2l.4-.8h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2zm.4-.8.5.8h-1zm-.4-.2v1l-.4-.2zm-.4.8-.5-.8h1l-.4.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m481.4 212.8-1-.2c-.4-3.7-2-7-4.3-9.6 2.8 1.8 4.8 5.7 5.4 9.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M494.2 198.3c-.5 1-1 2.4-2 3.5-1.5 1.6-4 .5-6.5-1.6-.8-.6-2.2-1-3.6-1a6 6 0 0 0-3.4 1c-2.5 2-5 3.2-6.6 1.6-1-1-1.5-2.4-2-3.5h2.5c1.3.3 2.6.3 3.4-.4.6-.6.3-1 1.3-2.5a7 7 0 0 1 2.2-2.3c1-.5 1.7-.2 2.6-.2 1 0 2-.3 2.8.2.8.5 1.5 1.3 2.2 2.3 1 1.6.7 2 1.3 2.4 1 .6 2.2.6 3.5.4 1-.2 1.8-.2 2.4 0z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m492.6 202-.7-.6v-.2l.2-.2.2-.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.3v-.4l1 .5v.4l-.2.2v.2l-.2.2v.4h-.2v.2l-.2.2v.3h-.2v.2h-.2v.2h-.2v.3l-.2.2-.2.2h-.2zm-7.3-1.4.7-.7h.2l.2.2.3.2.2.2.3.3h.3l.2.2h.2l.2.2h.2l.2.2h.2l.2.2h.4l.2.2h1.6l.2-.2.2-.2h.2v-.2l.8.7-.2.3h-.2v.3h-.3l-.3.2h-.3l-.2.2h-1.9l-.3-.2h-.3l-.2-.2h-.3l-.2-.2h-.3l-.2-.2-.2-.2h-.3l-.2-.3h-.3l-.2-.3-.2-.2-.2-.2-.2-.2-.3-.2zm.7-.7.5.3zm-4-.2v-1h2v.2h.7v.2h.4l.2.2h.2l.2.2h.2v.2h.2l-.7.8h-.2v-.2h-.2v-.2h-1v-.2h-1v-.2zm-3 .8-.7-.7v-.2h.2l.2-.2h.2v-.2h.2l.2-.2h.5v-.2h1.2v-.2h1v1h-1.5v.2h-.5l-.2.2h-.4v.2h-.2zm-7.3 1.5.7-.6.3.2.2.2h.2v.2h1.7v-.2h.5l.2-.2h.2v-.2h.3l.2-.2.2-.2h.3l.2-.3h.2l.2-.3.3-.2v-.2h.3l.7.6-.3.2-.2.2-.3.2-.2.2-.2.2h-.3l-.2.3h-.3l-.2.2h-.2l-.3.2h-.2l-.2.2h-.2l-.2.2h-.3l-.3.2H473l-.4-.2h-.2l-.2-.2-.2-.2zm-1.7-4 .2 1 .3-.7v.2l.2.2v.3l.2.2v.4l.2.2v.2h.2v.4h.2v.4h.2v.2h.2v.2h.2v.2l.2.2-.7.7h-.2v-.2h-.2v-.2h-.2v-.5h-.2v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.4h-.2v-.4l-.2-.2v-.4h-.2l.4-.8zm-.4.7-.2-.6.6-.2zm3-.6-.2 1-.2-.2H470l-.2-1h2.4zm3-.5.7.8-.2.2h-.2l-.2.2h-.4l-.2.2h-2.8v-1h2.3l.2-.2h.4v-.2h.2zm.7.8-.5.4zm.6-3 .7.5v.3l-.2.2v.2h-.2v.4h-.2v.8h-.2v.2h-.2v.2l-.2.2-.8-.7h.2v-.4h.2v-.4h.2v-.2l.2-.2v-.4h.2v-.3h.2zm2.3-2.5.5.8-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-.2.2v.2l-1-.6.2-.2.2-.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm2.8-.3v1h-2.3l-.5-.7h.2v-.2h.4l.2-.2zm3 .3-.5.8h-.4v-.2H482v-1h2.5l.2.2h.2zm0 0 .3.2zm2.4 2.4-.8.6-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2v-.2l.4-.8h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2zm1.3 2.3-.7.8-.2-.2h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.3v-.2l.8-.6v.2h.2v.3l.2.2v.2h.2v.4h.2v.4h.2v.4h.2zm-.7.8-.3-.3zm3.8-.4v1h-2.4l-.2-.2h-.2l-.2-.2h-.4v-.2h-.2l.7-1v.2h.2v.2h.8l.2.2h1.9zm3 .5-1-.4.3.8H492l-.2-1h2.4l.5.7zm-.5-.7h.6l-.3.7zm0 .5.4.2zm0-.5h.6l-.3.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M482 211.7c4.4 0 8 3.4 8 7.7s-3.6 7.8-8 7.8-7.6-3.5-7.6-7.8 3.5-7.8 7.7-7.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m483 212.8.8-.2c.5-3.7 2-7 4.3-9.6a14.7 14.7 0 0 0-5 9.8z"
            }),
            /* @__PURE__ */ jsx208("use", {
              xlinkHref: "#rs_svg__b",
              width: 1350,
              height: 900,
              transform: "matrix(-1 0 0 1 964.3 0)"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M577 293.6c2 .3 3 1.5 3 2.8 0 1.3-1 2.6-3 3a8.7 8.7 0 0 1-1.6.2c-60.8 5.2-125.7 5.2-186.5 0a8.7 8.7 0 0 1-1.6-.3c-2-.3-3-1.6-3-3 0-1.2 1-2.4 3-2.7a8.6 8.6 0 0 1 1.5-.3c60.7-5.2 125.6-5.2 186.4 0 .6 0 1 .2 1.5.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M412 298.4h-.2v-.2h-.2v-1h.4v-.2.2-.2h2.3l.7-.2h3l.7-.2h3l.7-.2h3l.8-.2h3.3l.7-.2h3.8l.7-.2h.8v1.2h-2.9l-.7.2H428l-.7.2h-2.7l-.8.2H421l.7.2h3.7l.7.2h2.9l.7.2h3.7l.7.2h1.5v1.2h-3.7l-.7-.2h-3.8l-.7-.2h-2.9l-.7-.2H420l-.6-.2h-2.9l-.7-.2H413zv-.2zm46.8-3.3v1.3H453l-.7.2h-6.6l-.7.2h-5l-1 .2h-3.5v-1.2h3.5l.8-.2h5.2l.7-.2h5.9l.7-.2h6.8zm23.3 0v1h-13.7l-.7.2h-8.8v-1h1.4l.8-.2H482zm23.5 0v1.3h-11.1l-.7-.2H482v-1zm23.3 1v1h-5.2l-.8-.2h-5.2l-.7-.2h-6.5l-.8-.2h-4.3V295h.7l.7.2h7.5l.8.2h5l.8.2h5.1l.6.2h2.3zm23.4 1v.2h.4v1h-.2l-.2.2h-3l-.7.2h-2.2l-.7.2h-3.8l-.8.2h-2.8l-.7.2H534l-.8.2h-3.6l-.8.2v-1.2h2.2l.7-.2h3.7l.8-.2h3.7l.7-.2h1.8-1.4l-.8-.2h-2.7l-.7-.2H533l-.6-.2h-3.6V296h6.5l.7.2h3l.8.2h2.8l.7.2h3l.7.2h3l.7.2h1.5zm-116.7 1.4h.2l.2.2v.8h-.2v.2h-.2zm93.3 1.2h-.2l-.2-.2v-.2h-.2v-.8h.2v-.2h.4v1.2zm-50.3-36.2v-1h3.8v1h-4zm-1.2-1h1.2v1h-1.2zm-.6 0h.6v1h-.6zm-1 0h1v1h-1zm-.8 0h.6v1h-.7v-1zm-.5 0h.4v1h-.5v-1zm-.8 0h.8v1h-.8zm-1.2 0h1.2v1h-1.2zm-1 0h1v1h-1zm-.2 0h.2v1h-.2zm-1 0h1v1h-1zm-2.5 1v-1h2.6v1zm-.3-1h.2v1h-.2zm-.2 0h.2v1h-.2zm-1 0h1v1h-1zm-.5 0h.4v1h-.4zm-.4 0h.4v1h-.4zm-1.2 0h1.2v1h-1.2zm0 0v1zm0 1h-.2zm-1.2-1h1.2v1l-1.2.2v-1zm-.4 0h.4v1.2h-.4v-1zm-.8.2h.8v1h-.8zm0 0h.3-.2zm-.3 0h.3v1h-.3zm0 1h-.5zm-1-1h1v1h-1zm-1 0h1v1h-1zm-.2 0v1zm-1 0h1v1h-1zm-.6 0h.5v1h-.4v-1zm0 0v1zm-4.2 1.2v-1h3.5v-.2h.4v1h-2.7l-.2.2h-.8zm-.6-1h.5v1h-.6v-1zm-1.7 0h1.6v1h-1.7zm-.2 0h.3v1h-.2v-1zm-1.3 0h1.4v1h-1.3zm-1 0h1v1h-1zm-.6 0h.7v1h-.6zm0 0v1.2-1zm-1.6.2h1.5v1h-1.5zm0 0v1zm-1.2 0h1.2v1h-1.2zm0 0v1zm-1.2 0h1l.2 1H444v-1zm-.8 0h.8v1h-.7zm-1.6.2h1.6v1h-1.5zm0 0v1zm-6.2 1.3v-1h1.7l.2-.2h3.9v1H436l-.2.2zm-.4-1h.3v1h-.2zm-9 1.4v-1h1.3l.3-.2h3.2l.3-.2h3.5v1h-5.1l-.3.2H426zm-.3-1h.2v1h-.3v-1zm-.5 0h.5v1h-.4zm-18.2 2.2v-1h1.8l.5-.2h1.7l.5-.2h2.4l.6-.2h2.6l.6-.2h2.2l.6-.2h2.8l.6-.2h1.2v1h-2.1l-.6.2h-2.7l-.6.2h-2.3l-.6.2h-2.8l-.6.2h-2.2l-.5.2H408l-.6.2h-.6zm-.3-1h.3v1h-.2zm0 0v1zm-26.3 3.4v-1h.7l1-.2h.8l.8-.2h1.6l.8-.2h1l.7-.2h1.6l.8-.2h1.8l.8-.2h.8l1-.2h1.7l.7-.2h1.7l.8-.2h1.8l.7-.2h1.6l1-.2h1.5l1-.2v1H405l-.7.2h-1.7l-.8.2H400l-.7.2h-.8l-1 .2H396l-.8.2h-1.7l-.8.2H391l-.8.2h-.8l-.8.2H387l-1 .2h-.7l-.8.2H383l-1 .2h-.8l-.8.2zm0-7v1h-.5l-.5.2h-.5l-.3.2-.4.2-.3.2h-.2l-.3.3-.2.2-.3.3v.5l-.2.2v1.1h.2v.3l.2.2.2.2.3.3.3.2h.2l.3.2h.3l.4.2h1v1h-1.6l-.4-.2-.4-.2-.3-.2-.3-.2-.3-.2-.4-.2-.2-.3-.2-.2v-.3l-.3-.3-.2-.3v-1.6l.2-.3.2-.3.2-.4.2-.3.2-.3.4-.3.3-.2.4-.2.3-.2h.4l.5-.2h.6l.5-.2zm26.3-2.3v1H405l-.7.2h-1.7l-.8.2H400l-.7.2H396l-.8.2h-1l-.7.2H392l-1 .2h-1.6l-.8.2h-.8l-.8.2h-1.7l-.8.2h-.8l-.8.2H381l-.8.2v-1h1.7l.8-.2h.8l.8-.2h.8l.8-.2h1.7l.8-.2h1.6l1-.2h.8l.8-.2h1.8l.7-.2h1.7l1-.2h.7l.8-.2h1.8l.7-.2h1.6l1-.2h2.5zm0 1v-1zm37-3.2v1.2H439l-1 .2h-2.3l-1.3.2H431l-1.2.2h-2.2l-1.3.2H424l-1.2.2h-2.3l-1 .2H417l-1.2.2h-1.2l-1 .2h-2.3l-1.3.2h-1l-1.2.2h-1.2v-1h2.2l1.2-.2h1l1.2-.2h2.2l1.3-.2h1l1.2-.2h2.3l1-.2h2.3l1.3-.2h2.4l1.2-.2h2.3l1-.2h3.5l1.2-.2h3.5l1-.2h2.5zm1 1-1 .2v-1h1v1zm.2 0h-.3v-1l.2 1zm.2 0h-.3l-.2-1h.4v1zm1.2 0h-1.2v-1h1.2zm0 0v-1zm15.4-1.4v1h-5.5l-.5.2h-6.5l-.4.2h-2.6v-1h5l.5-.2h7.7l.5-.2zm.8 1h-.8v-1h.8zm0 0v-1zm1.4 0h-1.4v-1h1.4zm.2 0h-.2v-1h.2zm0 0h-.2zm0 0v-1zm1.2 0h-1.2v-1h1.2zm.5 0h-.6v-1h.4v1zm.6 0h-.7l-.2-1h.8zm1 0h-1v-1h1zm.2 0h-.3v-1h.2v1zm.4 0h-.4v-1h.4zm3-1 .2 1H468v-1h3.3zm1.2 1h-1v-1l1-.2v1zm0 0v-1.2 1zm1.3-.2h-1.2v-1h1.2zm3.5-1v1h-3.5v-1zm0 1v-1zm1.3 0h-1.2v-1h1.2zm3.6-1v1h-3.5v-1h3.7zm3.8 0v1H482v-1zm1 1h-1v-1h1.2v1zm.2 0v-1zm3.6-1v1H487v-1h4zm1 1h-1v-1h1.2v1zm.2 0v-1zm1 0h-1v-1h1zm3.3-1v1H493v-1h3zm.5 1h-.4v-1h.5zm.3 0h-.3v-1h.3zm1 0h-1v-1h1zm.6 0h-.7v-1h.8zm.5.2h-.6v-1h.5v1zm1 0h-1v-1h1zm0 0v-1zm0 0h.3zm.3 0h-.2v-1h.3zm1.3 0h-1.3v-1h1.4zm0 0v-1zm0 0h.2zm1 0h-1v-1h1zm15.2-.6v1h-6l-.4-.2H504l-.6-.2h-.9v-1h6l.4.2h6.6l.4.2h1.7zm0 1v-1zm1.3 0h-1v-1h1zm.4 0h-.3v-1h.5v1zm.2 0h-.2v-1h.2zm1 .2h-1v-1h1zm37 1v1h-2.3l-1.2-.2h-1l-1.2-.2h-2.2l-1.3-.2H546l-1-.2h-1.3l-1-.2h-2.3l-1.3-.2H537l-1-.2h-4l-1-.2h-2.6l-1-.2H524l-1-.2h-2.4v-1h4.7l1.2.2h3.3l1.3.2h2.3l1.3.2h2.3l1 .2h2.4l1 .2h2.3l1.3.2h2.3l1 .2h2.3l1.2.2h1.2l1 .2h1.3l1 .2h1.3zm0 1v-1zm26.4 1.4v1H582l-.8-.2h-.8l-.8-.2H578l-.7-.2h-.8l-.8-.2H574l-.8-.2h-.8l-.8-.2h-1.8l-.7-.2h-1.5l-.8-.2H565l-.8-.2h-1.7l-.8-.2H560l-.8-.2h-1.6v-1h3.5l.8.2h1.6l1 .2h1.7l.7.2h1.7l.8.2h1.8l.7.2h.8l.8.2h1.8l.8.2h.8l.8.2h1.8l.7.2h.7l.8.2h1.8zm0 7v-1h1.6l.3-.2h.3l.3-.2.2-.2.2-.2h.2v-.3l.2-.2v-.2h.2v-1.4l-.2-.3v-.2h-.3l-.2-.3-.3-.2h-.2l-.3-.3-.4-.2h-.4l-.4-.2h-.4l-.5-.2v-1h.5l.6.2h.5l.5.3.4.3.4.2.3.2.4.3.3.3.2.3v.3l.3.2v.3l.2.3v1.3l-.3.3v.3l-.3.3-.3.4-.3.2-.3.2-.2.2-.3.2-.4.2h-.3l-.4.2H584zm-26.5-2.4v-1h1.8l.8.2h1.8l.8.2h1.8l.7.2h1.7l1 .2h.7l.8.2h1.8l.7.2h1.6l.8.2h1l.8.2h1.6l.8.2h1l.7.2h1.5l.8.2h1l.7.2v1h-1l-.8-.2h-1.6l-.8-.2h-.8l-.8-.2h-1.7l-.8-.2h-.8l-1-.2h-1.6l-.8-.2h-.8l-1-.2h-1.4l-.8-.2H566l-.7-.2h-1.6l-1-.2H561l-1-.2h-1.6zm0-1v1zm-.2 0h.3v1h-.4v-1zM539 265v-1h2.9l.5.2h3l.5.2h2.3l.6.2h2.2l.6.2h2.3l.5.2h2.4l.5.2v1h-1.7l-.5-.2h-2.3l-.6-.2H550l-.7-.2H547l-.6-.2h-2.9l-.6-.2H540l-.6-.2h-.6zm-.4-1h.5v1h-.4v-1zm-.2 0h.2v1h-.2zm-9.2.5v-1h4l.3.2h3.2l.3.2h1.3v1h-1.6l-.3-.2H533l-.4-.2h-3.3zm-.3-1h.2v1h-.3zm-6.4.7v-1h4.5l.2.2h1.7v1h-4.4l-.2-.2h-1.7zm0-1v1zm-1.5 0h1.7v1H521zm-.7 0h.8v1h-.7zm-1-.2h1v1H519zm-.2 0h.2v1-1zm-1 0h1v1h-1zm-.2 0v1zm-1.4 0h1.4v1h-1.4zm-.2 0h.2v1h-.2zm-.6 0h.6v1h-.7v-1zm-1 0h1v1h-1zm-1.4-.2h1.4v1h-1.4zm-.2 0h.2v1h-.2zm-1.6 0h1.6v1h-1.6zm-.6 0h.6v1h-.6zm-4.2 1v-1.2h3.3l.2.2h.8v1zm0-1.2v1zm-.5 0h.6v1h-.5zm-1 0h1v1h-1zm0 0v1zm-1.3 0h1.2v1h-1.3v-1zm-1 0h1v1h-1zm0 1h.6zm-.2-1h.3v1h-.3zm0 0h-.3zm-.8 0h.8v1h-.8zm-.4 0h.4v1h-.4zm-1.2 0h1.3v1H500v-1zm0 1h.2zm0-1v1zm-1 0h1v1h-1zm-.5 0h.4v1h-.6v-1zm-.4 0h.5v1h-.4zm-1 0h1v1h-1zm-.2 0h.2v1h-.2zm-.3 0h.3v1h-.3zm-2.6.8v-1h2.3v1H494zm-1-1h1v1h-1zm-.2 0h.2v1h-.2zm-1 0h1v1h-1zm-1.2 0h1.2v1h-1.3v-1zm-.8 0h.8v1h-.8zm-.4 0h.4v1h-.5v-1zm-.7 0h.7v1h-.7zm-1 0h1v1h-1zm-.7 0h.6v1h-.6zm-1.2 0h1.2v1H486v-1zm-3.7 1v-1h3.9v1h-4.1zm.4 1.8L460 276.6l-.4-1 22.7-11.3h.4v1zm-.5-1h.4-.5zm22.7 12.4-23-11.4.4-1 22.7 11.5v1h-.3zm.4-1 1 .6-1 .4zm-23 11.6 22.7-11.5.4 1-22.6 11.4h-.5v-.8zm.4 1h-.3zM460 275.7l22.8 11.5-.5 1-22.8-11.6v-1h.4zm-.4 1-1-.5 1-.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#0c4076",
              d: "M482 269c5.8 0 10.4 3.2 10.4 7s-4.6 7-10.3 7-10-3.2-10-7 4.5-7 10-7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M493 276h-1v-.3l-.2-.3v-.5l-.2-.3v-.3l-.3-.3-.2-.4v-.3l-.3-.2-.2-.2-.2-.3-.3-.2-.3-.3-.3-.2-.3-.2-.2-.2-.4-.2-.4-.2-.3-.2-.4-.2h-.5l-.4-.3h-.4l-.5-.2h-.8l-.5-.2h-1.9v-1.2h1.7l.6.2h.5l.5.2h.5l.5.2h.4l.5.3.4.2.5.2h.5l.4.3.3.2.4.2.3.3.4.3.3.2.3.3.3.3.2.4.3.3.2.4.2.4.2.4v.3l.2.5v.4l.2.2v.8zm-11 7.4v-1h1.6l.5-.2h1.1l.5-.2h.5l.4-.3h.4l.5-.3h.4l.3-.3h.4l.4-.3.3-.2.4-.3.3-.2.3-.2.3-.3.2-.3.2-.2.3-.3v-.3l.3-.3h.2v-.4l.2-.3v-.7l.2-.3v-.3h1v.4l-.2.4v.4l-.2.4v.3l-.2.3-.2.3-.2.4-.2.3-.3.3-.2.3-.3.2-.3.3-.3.3-.4.3-.3.3-.4.2-.4.3-.5.2-.4.2-.4.2h-.4l-.5.3h-.4l-.5.3h-.5l-.5.2h-1.1l-.5.2zm-10.6-7.4h1v1l.2.3v.3l.2.2.2.3v.4l.3.3.2.3.3.2.2.3.3.3.3.2.3.2.2.3.3.2.4.2h.2l.4.3h.4l.4.3h.5l.3.3h.9l.5.2h1.5l.6.2h.5v1h-1.9l-.5-.2h-.5l-.5-.2-.5-.2h-.4l-.5-.3h-.4l-.4-.3-.4-.2-.4-.2-.4-.3-.4-.2-.3-.2-.4-.2-.4-.3-.3-.3-.3-.3-.2-.4-.3-.3-.2-.3-.2-.4v-.3l-.2-.4-.2-.4v-.8l-.2-.4v-.4zm10.7-7.4v1h-1.3l-.5.2h-.3l-.5.2h-.5l-.4.2h-.4l-.6.3h-.4l-.4.3-.4.2-.3.2-.5.2-.3.2-.3.2-.4.2-.3.3-.3.2-.2.3-.3.3-.2.3-.2.3v.3l-.2.2v.3l-.2.3v.7l-.2.3v.3h-1V275l.2-.5.2-.4v-.2l.3-.4.3-.3.2-.3.3-.3.2-.3.3-.2.3-.3.3-.2.3-.3.3-.3.4-.2.4-.2.4-.2h.4l.4-.3.5-.2.5-.2h.5l.5-.2h1l.5-.2h1.1l.6-.2h.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M482 211.7c4.4 0 8 3.4 8 7.7s-3.6 7.8-8 7.8-7.6-3.5-7.6-7.8 3.5-7.8 7.7-7.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M490.4 219.4h-1v-1l-.2-.3v-.4l-.2-.3v-.4l-.2-.4v-.3l-.3-.3-.2-.3-.2-.3v-.3l-.3-.2-.2-.3-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.4-.2h-.3l-.3-.3h-.4l-.3-.2h-.4l-.4-.2H482V211l.6.2h1.2l.4.2h.4l.4.2.3.2.4.2h.4l.4.3.3.3.4.2.4.2.3.3.3.3.2.3.3.2.2.3.3.3.2.3.2.5.2.3v.4l.3.4v.8l.2.4v.8l.2.4zm-8.3 8.3v-1h1.5l.3-.2h.3l.3-.2.4-.2h.3l.3-.2h.3l.2-.3.3-.2.2-.2.3-.2.3-.2.2-.3.2-.2.2-.2v-.3l.3-.3.2-.3.2-.4v-.3l.2-.4v-.7l.2-.4v-.8l.2-.4v-.4h1v1.2l-.2.4v.5l-.2.4v.3l-.3.4v.3l-.3.4-.2.3-.2.4-.3.4-.2.3-.3.3-.2.3-.3.3-.3.2-.3.3-.3.3-.3.2-.3.2-.3.2h-.4l-.3.2-.4.2h-.4l-.4.2H482zm-8-8.3h1v1.8l.2.3.2.3v.3l.2.3.2.3.2.2.2.3.2.3.2.3.2.3.2.3.3.2.2.3.3.3.3.2.4.2h.3l.3.3h.3l.4.3h.3l.3.2h.7l.4.2h.7v1h-1.6l-.4-.2h-.3l-.4-.3h-.4l-.4-.3-.4-.3-.3-.2-.5-.2-.3-.2-.3-.2-.4-.2-.3-.3-.3-.3-.2-.3-.3-.3-.2-.3-.2-.3v-.3l-.3-.4v-.3l-.3-.4v-.4l-.2-.5v-.4l-.2-.3zm8-8.3v1.2h-1.3l-.4.2h-.3l-.3.2h-.4l-.3.3h-.3l-.3.2-.3.2-.2.2-.3.2-.2.3-.3.3-.2.2-.2.3-.2.3-.2.4-.2.3-.2.3-.2.3v.3l-.2.3-.2.3v.7l-.2.3v1.1h-1v-1.6l.2-.4v-.4l.2-.4.2-.4v-.4l.3-.3v-.4l.3-.2.2-.3.3-.3.2-.3.3-.4.3-.3.3-.3.2-.2.3-.2.4-.3.2-.2h.4l.3-.2.3-.2h.4l.4-.2h.5l.4-.2h1.1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M482 213.7c3.3 0 5.8 2.6 5.8 5.7 0 3.2-2.5 5.8-5.7 5.8-3 0-5.5-2.6-5.5-5.8 0-3 2.5-5.7 5.6-5.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M488.3 219.4h-1V218h-.2v-.7l-.2-.2v-.2l-.2-.3-.2-.2v-.2l-.3-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.3h-.4l-.2-.3h-.2l-.3-.2h-.6l-.2-.2H482v-1h1.8l.3.2h.3l.2.2h.3l.3.3h.4l.2.3h.2l.3.3.3.2.2.2.2.2.2.3v.2l.3.3v.2l.3.3v.2l.2.3.2.3v.6l.2.2v1.3zm-6.2 6.3v-1h1.1l.2-.2h.3l.2-.2h.2l.2-.2h.4l.2-.2.2-.2h.2l.2-.3.2-.2h.2v-.2l.3-.2v-.2l.3-.3.2-.3v-.2l.2-.3v-.2l.2-.3v-1.3h1v2l-.2.3-.2.3-.2.4-.2.3v.2l-.3.2v.2l-.3.2-.2.3h-.2l-.2.3h-.2l-.2.3-.3.2h-.2l-.2.3-.3.2h-.2l-.3.2h-.3l-.3.2h-1.4zm-6-6.3h1v1.3l.2.3v.2l.2.3v.2l.2.2.2.4.2.2v.2h.3l.2.3.2.3v.2h.3l.2.3h.3l.2.2h.2v.2h.4l.2.2h.2l.3.2h.9v1h-1.5l-.3-.2h-.3l-.3-.2h-.2l-.3-.3-.3-.2-.3-.2-.3-.2h-.2l-.2-.3h-.2l-.2-.4-.2-.2-.2-.2-.2-.3-.2-.3v-.3l-.2-.3h-.2v-.4l-.2-.3v-.6l-.2-.3v-.9zm6-6.2v1H481l-.2.2h-.4l-.3.2-.3.3h-.5l-.2.3h-.2v.3l-.3.2h-.2l-.2.3v.3l-.2.2v.2l-.2.3v.2l-.2.2v.2l-.2.3v.4l-.2.2v.7h-1V218l.2-.4v-.3l.2-.3.2-.3v-.2l.2-.3.2-.2.2-.3.2-.2.2-.3.2-.2.2-.2.2-.2.2-.2h.3l.2-.3h.2l.3-.2h.2l.3-.2h.3l.3-.2h.5l.3-.2h.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#0c4076",
              d: "M482 215.8c2 0 3.7 1.6 3.7 3.6S484 223 482 223c-1.8 0-3.4-1.6-3.4-3.6s1.6-3.6 3.5-3.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M486.2 219.4h-1v-.8h-.2v-.3l-.2-.2v-.2l-.2-.2-.2-.2-.2-.3h-.2l-.3-.2h-.2l-.2-.2h-.2v-.2H482v-1h1.4v.2h.5v.2h.3v.2h.3v.3h.3v.2l.2.2.2.3.2.3v.2l.2.2.2.3v.4l.2.2v.6zm-4 4.2v-1h.6v-.2h.5l.3-.2h.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.4h.2v-1h1v1l-.2.2v.2l-.2.2v.2l-.2.2-.2.3-.2.2-.2.2-.3.2-.3.3h-.3l-.3.2-.3.2h-1l-.3.2zm-4-4.2h1v1.3l.2.2v.2l.2.2.2.2.2.2.2.2.2.2h.2v.2h.4l.2.2h.8v1.2h-.7l-.2-.2h-.3v-.2h-.5l-.2-.2-.3-.3h-.2v-.2l-.2-.2h-.2v-.2l-.2-.3-.2-.3v-.2l-.2-.2-.2-.3v-1.4zm4-4v1h-1l-.2.2h-.2l-.2.2h-.2v.2h-.2l-.2.3-.2.2-.2.2-.2.3v.4h-.2v1h-1V218l.2-.2.2-.3v-.2l.2-.2.2-.2.3-.3.2-.2.2-.2h.2l.2-.2h.2l.2-.2h.3l.3-.2h.9z"
            })
          ]
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#c6363c",
          d: "M314.6 301.2v271.3c0 48.5 18.8 92.6 49.2 124.6A162.9 162.9 0 0 0 482 749a163 163 0 0 0 118.5-51.7c30.4-32 49.2-76 49.2-124.5V301.2h-335z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#fff",
          d: "M313.4 300v277l.2 4.6.3 4.5.3 4.6.5 4.4.5 4.5.7 4.3.8 4.4 1 4.3 1 4.2 1 4.3 1.2 4.2 1.3 4 1.4 4.2 1.4 4 1.7 4 1.6 4 1.8 4 2 3.8 1.8 3.8 2 3.7 2 3.7 2.2 3.6 2.2 3.6 2.4 3.5 2.4 3.6 2.4 3.4 2.6 3.3 2.6 3.2 2.7 3.2 2.8 3 3 3.2 1.6-1.7-2.8-3-2.7-3-2.6-3.3-2.5-3.2-2.7-3.3-2.4-3.3-2.5-3.4-2.2-3.5-2.3-3.5-2-3.6-2-3.6-2-3.7-2-4-1.8-3.7-1.7-3.8-1.6-4-1.7-4-1.4-4-1.5-4-1.2-4-1.2-4.2-1-4-1-4.3-.8-4.3-.8-4.3-.7-4.3-.6-4.2-.4-4.5-.4-4.4-.2-4.5-.2-4.5V302.5h332.7V577l-.2 4.5-.3 4.4-.3 4.3-.5 4.5-.6 4.3-.7 4.4-1 4.3-.8 4.3-1 4.2-1 4-1.2 4.3-1.3 4-1.3 4-1.4 4-1.6 4-1.6 4-1.7 3.8-1.7 3.8-2 4-2 3.6-2 3.6-2 3.6-2.3 3.5-2.3 3.5-2.3 3.4-2.5 3.3-2.6 3.3-2.6 3.2-2.6 3.2-2.7 3-2.8 3-3 3-2.8 3-3 2.7-3 2.6-3.3 2.6-3 2.6-3.4 2.4-3.3 2.5-3.3 2.3-3.4 2.2-3.5 2.2-3.5 2-3.5 2-3.6 2-3.7 1.7-3.7 1.8-3.8 1.7-3.8 1.5-3.8 1.4-4 1.3-3.8 1.3-4 1-4 1-4 1-4 1-4.2.6-4 .6-4.3.5-4 .4-4.3.4-4.3.2H482v2.4h4.5l4.3-.2 4.3-.3 4.4-.4 4.2-.4 4.2-.6 4.2-.8 4-.8 4.2-1 4-1 4-1.2 4-1.2 4-1.4 4-1.4 3.8-1.6 3.7-1.6 3.8-1.7 3.7-2 3.7-1.8 3.5-2 3.5-2 3.6-2.3 3.4-2.2 3.4-2.4 3.3-2.5 3.3-2.4 3.2-2.6 3.2-2.7 3-2.7 3-2.8 3-3 3-3 2.8-3 2.8-3 2.7-3.3 2.6-3.2 2.5-3.3 2.5-3.4 2.4-3.5 2.3-3.4 2.3-3.6 2-3.6 2.2-3.7 2-3.7 2-3.8 1.7-4 1.8-3.8 1.6-4 1.6-4 1.4-4 1.4-4 1.3-4.2 1.2-4.2 1-4.3 1-4.2 1-4.3.7-4.4.7-4.3.5-4.5.5-4.4.4-4.5.3-4.4V577l.2-4.5V300z"
        }),
        /* @__PURE__ */ jsxs201("g", {
          fill: "#fff",
          stroke: "#21231e",
          children: [
            /* @__PURE__ */ jsx208("path", {
              d: "M483.7 734.8c1.4-.2 4 0 5.7-1.4 2.5-2 1.5-9.8 1.3-14.8-1-25.3-2.2-68-3.5-128-2-.2-3.6 0-5 .2a12 12 0 0 0-5 0c-1.4 59.8-2.5 102.5-3.6 127.8-.2 5-1.2 13 1.3 14.8 1.7 1.5 4.2 1 5.6 1.4h3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M499.6 734c-1.5 0-4 .5-6-.8-2.6-1.7-2.8-9.7-3-14.7a6148 6148 0 0 0-7.6-127.6c2-.6 3.6-.6 5-.5.3 0 .5 0 .7-.2 9.6 59.2 13.2 101.2 19.7 126.5 1 3.5 2.8 12.2-.2 15-1.7 1.7-4.2 1.6-5.6 2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M518.2 731.4c-1.5 0-3.8.8-6-.3-2.7-1.4-2.6-9.4-3.8-14.2-6.6-25.3-10.2-67.3-19.7-126.5 2-.7 3.6-.8 5-1h.2c15 57.6 19.6 98.2 31.4 123.2 1 3.5 4 12.7 1.2 16-1.5 1.7-4 1.8-5.4 2.3l-3 .6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M537 726c-1.5.3-4 1.6-6 .7-3-1.2-3.5-9.7-5.6-14.2-11.8-25-16.3-66-31.7-124 2-.8 3.5-1 5-1.3 1.3-.6 1-1 3-1.2 18 57.3 23.7 97 40.5 121.8 2.7 4 4.7 12 3 14.5-1.5 2-4 2.3-5.3 3zm-72.2 8c1.4 0 3.8.5 5.8-.8 2.7-1.7 3-9.7 3-14.7a7227 7227 0 0 1 7.7-127.6c-2-.6-3.6-.6-5-.5a25.4 25.4 0 0 0-.7-.2c-9.6 59.2-13.2 101.2-19.7 126.5-1 3.5-3 12.2 0 15 1.8 1.7 4.3 1.6 5.7 2l3 .3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M446 731.4c1.6 0 4 .8 6-.3 2.8-1.4 2.7-9.4 4-14.2 6.4-25.3 10-67.3 19.6-126.5-2-.7-3.6-.8-5-1h-.3c-15 57.6-19.6 98.2-31.4 123.2-1.2 3.5-4.2 12.7-1.3 16 1.5 1.7 4 1.8 5.4 2.3l3 .6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M427.3 726c1.5.3 4 1.6 6 .7 3-1.2 3.5-9.7 5.6-14.2 11.7-25 16.2-66 31.6-124-2-.8-3.5-1-5-1.3-1.3-.6-1-1-3-1.2-18 57.3-23.7 97-40.5 121.8-2.6 4-4.6 12-2.8 14.5 1.4 2 4 2.3 5.2 3l3 .8zm99.7-43c-1.3 0-3.3 1-5.4 0-2.8-1.4-4.6-9-6-14-12-23.5-23-65.3-40.8-123.4 1.8-.7 3-1 4.5-1 1-.5 2.4-1 4.3-1.2 19.3 57.5 28 99 46.7 122 3 3.8 5.4 12 4 14.4-1.2 1.8-3.4 2-4.6 2.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M512 685.8c-1.5 0-3.6.6-5.6-.5-2.6-1.6-3.5-9.4-4.5-14.3-5-25-13.7-67-26.3-126 1.8-.7 3.2-.8 4.5-.8 1.2-.4 2.6-.8 4.5-.8 15 58.7 18.3 102.6 32.4 125 2.6 4.2 4 12.5 2.3 14.8-1.3 1.7-3.5 1.7-4.8 2.2l-2.7.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M496.4 687.6c-1.4-.2-3.5.3-5.4-1-2.4-1.7-2.4-9.6-2.8-14.6-2-25.3-6-68-11.6-127.6 2-.5 3.3-.4 4.6-.3 1.2-.2 2.6-.5 4.5-.4 8 59.6 12.8 102.8 18 127.2 1 5 2.4 12.6.4 14.8-1.4 1.5-3.6 1.4-5 1.8l-2.6.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M437.2 682.8c1.4 0 3.4 1 5.5 0 2.8-1.4 4.6-9 6-14 12-23.5 23-65.3 40.8-123.4-1.8-.7-3-1-4.5-1-1-.5-2.4-1-4.3-1.2-19.3 57.5-28 99-46.7 122-3 3.8-5.4 12-4 14.4 1.2 1.8 3.4 2 4.6 2.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M452.4 685.8c1.4 0 3.5.6 5.5-.5 2.5-1.6 3.4-9.4 4.4-14.3 4.8-25 13.6-67 26.2-126-1.8-.7-3.2-.8-4.5-.8a12 12 0 0 0-4.4-.8c-15 58.7-18.3 102.6-32.4 125-2.5 4.2-4 12.5-2.2 14.8 1.3 1.7 3.5 1.7 4.7 2.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M468 687.6c1.3-.2 3.4.3 5.3-1 2.4-1.7 2.4-9.6 2.8-14.6 2-25.3 6-68 11.7-127.6-2-.5-3.3-.4-4.6-.3-1-.2-2.5-.5-4.4-.4-8 59.6-12.8 102.8-18 127.2-1 5-2.4 12.6-.4 14.8 1.5 1.5 3.7 1.4 5 1.8l2.7.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M483.5 688c1.3 0 3.5.2 5.2-1.3 2.3-2 1.4-9.8 1.2-14.8-1.2-25.4-2-68-3.3-128a14 14 0 0 0-4.6 0c-1.2-.2-2.5-.3-4.4 0-1.2 60-2 102.6-3.2 128-.2 5-1 12.8 1.2 14.7 1.6 1.5 4 1 5.2 1.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M516.5 648c-1 0-2.5 1-4 0-2.3-1.5-3.7-9.2-4.8-14-9.2-23.5-17.5-65.4-31.2-123.5 1.4-.7 2.4-1 3.4-1 .8-.5 1.8-1 3.3-1 14.7 57.4 21.3 99 35.7 121.8 2.4 3.8 4 12 3 14.5-.8 1.8-2.5 2-3.4 2.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M505 651c-1 0-2.7.6-4.3-.6-2-1.5-2.7-9.4-3.4-14.3-3.7-25-10.5-67-20-126 1.3-.6 2.3-.7 3.4-.7 1-.4 2-.7 3.4-.8 11.5 58.7 14 102.6 25 125.2 2 4 3 12.4 1.6 14.6-1 1.7-2.7 1.8-3.6 2.2l-2 .5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M493 652.7c-1 0-2.6.4-4-1-2-1.7-2-9.6-2.2-14.5-1.5-25.4-4.5-68-9-127.7 1.5-.4 2.6-.4 3.6-.3 1-.3 2-.6 3.5-.4 6 59.6 9.7 102.7 13.6 127 .7 5 2 12.8.4 15-1.2 1.5-3 1.4-4 1.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M447.8 648c1 0 2.5 1 4 0 2.3-1.5 3.7-9.2 4.8-14 9.2-23.5 17.5-65.4 31-123.5-1.2-.7-2.2-1-3.2-1-1-.5-2-1-3.4-1-14.7 57.4-21.3 99-35.7 121.8-2.4 3.8-4.2 12-3 14.5.8 1.8 2.5 2 3.4 2.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M459.4 651c1 0 2.6.6 4-.6 2.2-1.5 3-9.4 3.6-14.3 3.7-25 10.5-67 20-126a7.7 7.7 0 0 0-3.4-.7c-1-.4-2-.7-3.4-.8-11.4 58.7-14 102.6-24.8 125.2-2 4-3 12.4-1.7 14.6 1 1.7 2.7 1.8 3.6 2.2l2 .5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M471.3 652.7c1 0 2.6.4 4-1 2-1.7 2-9.6 2.2-14.5 1.5-25.4 4.5-68 9-127.7a9.5 9.5 0 0 0-3.6-.3c-1-.3-2-.6-3.6-.4-6.2 59.6-9.8 102.7-13.7 127-.7 5-2 12.8-.4 15 1.2 1.5 3 1.4 4 1.7l2 .2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M483.2 653.2c1-.2 2.7 0 4-1.4 1.7-2 1-9.7 1-14.7-1-25.3-1.6-68-2.5-128-1.5-.2-2.6 0-3.6.2-.8-.2-2-.4-3.4 0-1 59.8-1.6 102.5-2.4 128 0 5-.8 12.7 1 14.6 1.2 1.5 3 1.2 4 1.4h2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              d: "M475 559c-.2 4.4-.3 9-.3 14l-10.6 2.3c0 4.8 12 55.4 18 55.4 6.3 0 18.2-50.6 18.2-55.5l-10.6-2v-.2c0-5 0-9.6-.2-14-2.2 2-4.7 5.2-7.3 8-2.4-2.8-5-6-7-8z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs201("g", {
          id: "rs_svg__d",
          children: [
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M412 584.5c-3 .2-7 2-18.5 12-5 10.2-10 20.5-17 29.4-2.4 1.4-4.2 2.5-6 3.2a84 84 0 0 1-17-.5c-4.4-4-11.3-1.2-9 3.2-1.8 1.6 2.2 7.8 5.3 5.2 3-2.4 13-.2 16.4-1.4-1.3 3-10.4 5-16.8 5.5-5.8.2-5.4 6-3 10.5 2.7 1.8.5-.4 1.4.8 2.6 4 8.2 3.4 8.4-.4.2-4 13.8-9 15.8-12-2.5 6-8.2 11.5-11 17.3-3 3-5 3.7-1 10 4.4-.6 4.6-1.7 7.3.8 6-.6 7-2.4 6-7.2-1-5 3.2-14 4.6-16.6 1.2-2.4 1.5-4.8 2.8-6.3 2.2-2.5 12.6-7.7 15.2-6.3 5 2.7 8.7 1 9.3-3.7-1.6-1.2-.4-8-3.8-8.2-2.8-.3-4.4.6-7 2.7-4 3.2-6 5-7.4 4.6-3-.7 5.8-5 13.8-15.6 11-14.5 11.8-22 11.3-27z"
            }),
            /* @__PURE__ */ jsx208("use", {
              xlinkHref: "#rs_svg__c",
              width: 1350,
              height: 900,
              transform: "matrix(-1 0 0 1 801.6 0)"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M345.2 634.5c-4-2.3-6.3-2.2-8-.5-.7 1-1.8.5-1.2-1 2.7-6.3 7-7 10.7-4.2l2.8 2.7c-.6 1-3.8 2.3-4.3 3zm57.4-5.6c4.3-3 8.3-3.6 10.5-2 1.3 1 2.5.3 1.4-1.2-4.4-6.2-9.6-6.5-13.5-3-1.2 1-2 2-2.8 3 1.3 1.6 4.3 3.2 4.4 3zM369 664.4c.2-.2-1-5.4-2.6-7-1.4 1-3 2-4.3 3.5-4.2 4.5-4 11 2.5 16.7 1.6 1.5 2.4 0 1.7-1.7-1-2.7.3-6.3 3-11.5zM352.6 651c-4 1.6-5.4 3.7-5.2 6.4 0 1.5-1 2-1.5.3-4.8-11.2.2-13.3 7.5-13 .4 2-.7 6.2-.8 6.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m384 621.3 1 .6h-.2v1.8h.2v.4h.2v.2h.2l.2.3.3.2v.2h.4l.2.3h.2l-.6 1h-.2l-.3-.2h-.2l-.2-.2-.2-.2-.3-.3-.3-.3v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.2l-.2-.2V622l.2-.3v-.2zm6.5.8-.8 1-.2-.2-.3-.2-.2-.2-.2-.2h-.3l-.2-.3-.2-.3-.3-.2-.2-.2-.3-.2h-.7l-.2-.2h-.7v.2h-.2l-.2.2v.2h-.2v.3l-.2.2-1-.7v-.3l.2-.2.2-.2.2-.2.3-.3h.3l.2-.2h.4v-.2h.8l.2.2h.4l.2.2h.2l.2.2h.2l.2.3h.2l.2.3h.2l.3.3.2.3.2.2.3.2.2.2h.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m387.3 617.6 1 .6v.4h-.2v.8l.2.2v.2l.2.2v.2l.2.2.2.3.3.2h.2l.2.2h.2l.2.2.2.2h.2l-.6 1h-.2l-.3-.2-.3-.3h-.2l-.2-.2-.2-.2-.2-.3v-.2h-.2l-.2-.2v-.2h-.2v-.5h-.2V618h.2v-.3zm6.5.8-.7 1-.2-.3h-.2l-.2-.3-.3-.2-.3-.3h-.2l-.2-.3-.2-.2-.3-.2-.3-.2h-.3v-.2h-.8l-.2.2-.2.2-.2.2v.2l-.3.2-1-.6.2-.3v-.2h.3v-.3h.3l.3-.3h.2l.2-.2h.2v-.2h1.4l.2.2h.2v.2h.3l.3.3h.2l.2.2h.2l.2.3h.2l.3.3v.2l.3.2.3.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m391 612.8 1 .6-.2.2v.6h-.2v1l.2.3v.3h.2v.4h.2l.2.3v.2h.2l.2.2.2.2.3.3.3.2h.2l.2.2-.6 1-.3-.2-.2-.2-.2-.2-.3-.2-.2-.2v-.2l-.3-.2v-.2l-.3-.2v-.2l-.3-.2v-.4l-.2-.3v-.2h-.2v-.7h-.2v-1l.2-.3v-.4l.2-.3zm7 1-.8 1-.3-.3-.3-.2-.3-.3-.3-.2v-.2l-.3-.2-.3-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.7l-.2.2-.2.2-.3.3v.2h-.2v.4l-1-.6v-.3l.2-.2.2-.3v-.2l.3-.2.2-.2v-.2h.3l.2-.2h.3l.2-.2h1.2l.2.2h.2l.2.2.3.2h.3l.2.3.2.2h.3l.2.3.3.2.2.2.3.2.2.2.3.2.2.3.3.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m394.8 607.7 1 .5v.5l-.2.3v1.7l.2.2v.3l.2.2v.2l.2.2.3.3v.2l.3.2.2.2h.2l.2.3.2.2.3.2v.2l-.6.8-.3-.2v-.2l-.4-.2-.2-.3-.3-.3v-.2l-.3-.3-.2-.2v-.2l-.3-.3v-.2l-.3-.2-.2-.2v-.2l-.2-.2v-.3l-.2-.3v-2.1l.2-.2v-.2l.2-.3zm7.6 1.3-1 .8-.2-.3-.3-.3-.3-.2-.3-.3-.3-.3v-.2l-.4-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.2h-.2l-.2-.2h-.3v-.2h-.7v.2l-.3.2-.2.3-.2.2v.2l-.3.2v.2l-1.2-.5.2-.3.2-.3v-.2l.3-.3.2-.2.2-.2.3-.2.3-.2h.5l.3-.2h.8l.3.2h.2l.3.2h.2l.2.3.3.3.2.2.3.2.2.2h.3l.2.3.3.3.2.2.3.3.3.4.3.3.4.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m399 602.6 1.2.6v.2l-.2.2-.2.3v2.1l.2.2v.2l.2.2.2.2v.2l.2.2.2.2.2.2v.2l.3.2.2.2.2.2.3.2.2.2.3.2-.8 1-.3-.3-.2-.3-.3-.2-.3-.3-.2-.2-.3-.2-.2-.3v-.2l-.3-.2-.2-.2v-.2l-.3-.2v-.3h-.2v-.4l-.2-.2v-.2l-.2-.3v-2.6l.2-.2v-.2l.2-.2v-.2zm7.7 1.4-1 .8-.2-.3-.3-.3-.2-.3-.3-.3-.3-.3-.2-.2-.2-.3-.3-.3-.2-.2h-.2l-.2-.3-.2-.2h-.2v-.2h-1.3l-.3.2v.2h-.2v.3l-.3.2-.2.3v.2l-1.2-.6.3-.3.2-.3.2-.2.2-.3v-.2l.4-.2h.2l.2-.2h.2l.2-.2h1.7l.2.2.2.2h.2l.2.3h.3l.3.3.2.3h.3l.2.3.3.3.2.2.3.3.3.4.4.3.3.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              stroke: "#21231e",
              d: "m462.6 580.6-9.5-5.4c-4 3-6.8 13.5 0 22.2 8.5 11 12 18.7 14 27.5 6.2-8 8.3-16.3 4.4-24.5-5.3-11-8.7-17-8.8-20z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              stroke: "#21231e",
              d: "m470.4 573-9.5-5.4c-4 3-12.5 13.2-5.6 22 8.5 10.8 17.3 19 19.4 27.7 6.2-8 8.8-16.2 5-24.4-5.4-11-9.4-17.2-9.4-20z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              stroke: "#21231e",
              d: "m449.4 569.2-9.5-5.4c-4 3-7 13.5-.2 22.2a65 65 0 0 1 14 27.5c6.2-8 8.4-16.3 4.4-24.4-5.3-11-8.7-17-8.8-19.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M405.5 469c.2 8.7-1.4 66.5-1.8 74.7-.5 8.2-4 13.7-8 17-3.5-5-5.6-11.5-6-19.3-.4-4 .4-58.7.7-70 6.4-17 11.2-17.8 15-2.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M404 543.8h-1l.2-1v-2.6l.2-1.7v-4l.2-2.3v-5l.2-2.7v-2.8l.2-3v-3l.2-3v-6.2l.2-3v-6.2l.2-3v-5.8l.2-2.7v-7.4l.2-2V469h1v11.7l-.2 2.5v8.3l-.2 2.8v6l-.2 3.2v3l-.2 3.2v6l-.2 3v3l-.2 2.8v5.3l-.2 2.5v2.3l-.2 2v3.6l-.2 1.5v2zm-8.7 17 .8-.5h-.6l.3-.4.4-.4.4-.3.4-.3.3-.4.5-.4.3-.3.3-.5.4-.4.4-.4.3-.4.4-.5.3-.4.2-.5.2-.5.3-.5.3-.5.2-.6.2-.5.3-.6.2-.5.2-.5v-.7l.3-.6v-.6l.3-.7v-.7l.2-.7v-.7l.2-.8v-1.5h1v2.3l-.2.7v.8l-.3.6v.8l-.3.7-.2.6-.2.8-.2.6-.2.6-.2.6-.3.6-.4.5-.2.6-.3.5-.2.5-.3.5-.3.5-.3.5-.4.4-.4.5-.3.4-.5.5-.3.4-.4.3-.3.4-.4.3-.2.4-.4.3-.4.3h-.7zm.7.2-.4.3-.3-.4h.7zm-7-19.5h1v.6l.2.8v1.4l.2.7v.6l.2.7v.6l.3.6v1.5l.3.5v.7l.3.6.2.6.2.6.2.6.2.5.2.7.2.6.2.5.3.6.2.5.3.4.2.6.3.5.3.5.3.5.2.4.3.4.3.5.3.3-.7.6-.3-.6-.4-.4-.3-.5-.3-.5-.3-.5-.3-.6-.2-.6-.3-.5-.4-.7-.2-.5-.3-.6v-.6l-.3-.5-.3-.5-.2-.6-.2-.7-.2-.6v-.7l-.3-.6-.2-.6v-.7l-.3-.5v-.7l-.2-.7-.2-.6v-.6l-.2-.7v-1l-.2-.8v-1.5zm1-70.2.8.3v8l-.2 2.3V492l-.2 2.7v11.6l-.2 3v19l-.2 2.2v11h-1v-20.9l.2-2.7v-14.6l.2-2.8V489l.2-2.6v-8.9l.2-2v-4.2zm16-2.3h-1l-.4-1.3-.3-1.3-.4-1-.5-1.2-.4-1-.2-1-.4-.7-.4-.8-.4-.6-.4-.4-.4-.4-.4-.3-.3-.3h-.3l-.4-.2h-.7l-.4.3-.4.3-.5.5-.5.4-.5.5-.5.7-.5.7-.5.8-.5 1-.6 1-.5 1.2-.6 1.3-.6 1.3-.6 1.5-.6 1.6-1-.3.7-1.6.6-1.5.7-1.3.6-1.4.5-1.2.6-1 .5-1 .5-1 .5-.8.6-.7.5-.7.6-.6.6-.4.5-.4.6-.3.5-.2h1.1l.5.3.5.3.5.5.5.5.4.6.4.6.5.8.4.8.4 1 .5 1 .3 1 .4 1.4.4 1.3.4 1.4zm0 0"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m368 454.8-2.6 79.6c-.8 7 8.4 49 13.5 57.4 12.3-5.3 15-33.8 12.6-61.6-2.4-27.8.4-51.8 2.3-56.8 0-6.3-1-12.8-1-19.3-8 .5-17.2.4-25 .8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m365 534.4 2.4-79.6h1l-2.5 79.6h-1zm13.7 57 .3.8-.6-.2-.5-1-.6-1-.5-1.2-.7-1.4-.5-1.6-.6-1.6-.6-1.8-.6-2-.5-2-.6-2-.7-2.2-.6-2.2-.6-2.3-.4-2.3-.6-2.3-.5-2.3-.6-2.3-.6-2.3-.4-2.2-.5-2.2-.4-2.2-.3-2-.4-2.2-.3-2-.3-1.8-.3-1.7-.2-1.6v-1.4l-.3-1.3v-2.8h1v4.1l.2 1.5.2 1.6.3 1.7.3 1.8.3 2 .4 2 .4 2.2.5 2.2.4 2.2.4 2.3.5 2.2.4 2.3.6 2.3.5 2.4.6 2.3.7 2.2.5 2.2.6 2 .6 2.2.6 2 .6 2 .5 1.7.7 1.5.6 1.5.5 1.4.5 1.2.5 1 .5 1-.6-.3zm.3.8-.4.2-.2-.4zm12-62h1l.3 2.5v2.7l.3 2.6v2.6l.2 2.6v12.5l-.3 2.4-.2 2.5-.2 2.3v2.3l-.4 2.3-.4 2.2-.3 2-.6 2-.4 2-.6 2-.5 1.7-.8 1.7-.6 1.5-.7 1.5-1 1.5-.7 1.3-1 1.2-1 1-1 1-1 1-1 .6-1.3.6-.3-1 1-.4 1-.7 1-.7 1-1 1-1 .7-1 .8-1.3.8-1.4.7-1.5.6-1.5.6-1.6.5-2 .5-1.7.5-2 .4-2 .3-2 .3-2 .3-2.3v-2.3l.4-2.3V558l.3-2.3V538l-.2-2.6-.2-2.6-.2-2.6zm2.4-56.8h1v.2l-.2.5-.2.7-.2.7-.2 1-.2.8-.2 1-.2 1.2v1.2l-.3 1.3-.2 1.3-.2 1.4v1.6l-.3 1.6v1.7l-.3 1.7v2l-.2 1.8v2l-.2 2V520l.2 2.5.2 2.5.2 2.6v2.5l-1 .2v-2.6l-.3-2.5-.2-2.5V520l-.2-2.5v-20.1l.2-2v-2l.3-2v-1.7l.2-1.7.2-1.8.2-1.6v-1.4l.3-1.5.2-1.3v-1.2l.3-1V477l.3-1 .2-.8.2-.7.2-.7.2-.5zm1 0v.2zm-1.5-18.8v-1l.4.4v3.7l.2.6v2.5l.2.6v1.8l.2.6v2.4l.2.6v3.6l.2.6v2.4h-1V468l-.2-.5V465l-.2-.5v-1.9l-.2-.6v-1.7l-.2-.6v-3l-.2-.6V454l.5.6zm0-1h.4v.4l-.5-.4zm-24.6 1.2h-1l.4-.5h3.9l.8-.2h12.8l.8-.2h4.7l.8-.2h1.7v1h-4.1l-.7.2h-8l-.8.2h-7.1l-.8.2h-3.9l.4-.4zm-1 0v-.4h.4zm.5 0h.4-.5zm-.6 0v-.4h.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m353 468 1.8 79.5c-.4 7 11 48.5 16.4 56.5 12.6-9.8 10-49.8 8.2-62-4-24-3.2-52-2-56.5 0-6.3-.2-13.8-.6-20.4-8 1-15.8 2-23.7 2.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m354.3 547.5-1.7-79.6 1-.2 1.7 79.6h-1zm16.6 56 .5 1-.7-.2-.5-1-.6-1-.6-1.2-.5-1.2-.7-1.6-.6-1.6-.7-1.8-.7-1.8-.7-2-.5-2-.7-2.2-.7-2.2-.6-2.2-.7-2.3-.7-2.2-.7-2.3-.6-2.3-.6-2.3-.5-2.3-.6-2.2-.6-2.2-.5-2-.6-2-.4-2-.4-2-.4-1.6-.3-1.6-.3-1.3-.2-1.3v-1.2l-.2-1v-.8h1v1.8l.2 1 .2 1.3.2 1.5.2 1.5.3 1.7.4 2 .4 1.8.4 2 .5 2 .6 2.2.4 2.2.6 2.3.7 2.3.6 2.3.7 2.2.6 2.3.7 2.3.7 2.3.7 2.2.7 2 .7 2.2.8 2 .7 1.8.6 1.7.8 1.7.6 1.4.6 1.3.6 1.2.5 1 .6.7h-.7zm.5 1-.4.2-.2-.4h.7zM379 542l1-.2v1.2l.2 1.4.2 1.5.2 1.8.2 1.7v2l.3 2 .2 2v2l.2 2.3v12l-.2 2.4v2.3l-.3 2.4-.4 2.4-.3 2.4-.3 2.2-.4 2.2-.5 2.2-.4 2-.6 2-.7 2-.8 1.6-.8 1.7-1 1.5-1 1.3-1 1.4-1.2 1-.6-.8 1-1 1-1 1-1.4.8-1.4.8-1.6.8-1.7.6-1.8.6-2 .5-2 .6-2 .4-2.2.4-2.3.3-2.3.2-2.4v-2.3l.3-2.4V569l.2-2.2V560l-.2-2.3v-2.2l-.2-2v-2l-.2-2-.2-1.6-.2-1.8-.2-1.5v-1.3l-.3-1.2zm-2-56.7h1v.6l-.2.7-.2.7v1l-.2.8v2.4l-.2 1.3v2.8l-.2 1.6v15.2l.2 2v2.3l.3 2v2.4l.3 2.3v2.2l.3 2.2.4 2.3.2 2.4.3 2.2.2 2.3.3 2.2.4 2.3-1 .2-.5-2.3-.3-2.4-.3-2.3-.4-2.3-.2-2.4-.2-2.3-.2-2.3-.2-2.3-.2-2.2v-2.3l-.3-2.2V512l-.2-2v-16l.2-1.4v-1.3l.2-1.2v-2l.3-1v-.8l.2-.6v-.7.2zm-.2-20v-1l.5.6v3.4l.2.7v3.8l.2.6v6l.2.6v5.3h-1V480l-.2-.7v-5.7l-.2-.6v-4.5l-.2-.7v-2.4l.4.4zm0-1h.4v.6l-.5-.4zm-23.7 4v-1l.8-.2h.8l.7-.2h2.2l.7-.2h.8l.7-.2h.8l.7-.2h1.4l.7-.2h.8l.7-.2h.6l.8-.2h1.7l.6-.2h.7l.8-.2h.8l.7-.2h1.5l.8-.2h.7l.7-.2h.8l.7-.2v1h-.6l-.6.2h-.8l-.7.2h-1.6l-.7.2h-.8l-.8.2h-.8l-.7.2h-1.5l-.7.2h-.8l-.7.2h-.7l-.8.2H362l-.7.2h-.7l-.8.2h-.7l-.6.2H357l-1 .2h-.6l-.7.2h-.8zm.2-1v1l-.6-.6.5-.6zm-.6.4v-.6h.5l-.4.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m342.2 486.7 21-.5c-2 8.6-.5 35.6 3.2 56.2 3.3 19.3 8 69.3-12 81.3-12.5-26.4-3-52-9.2-75-5-24.3-6-44.6-3-62"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m363 486.7-20.8.5v-1l21-.5.4.6zm0-1h.7v.6zm3.8 56.6-1 .2-.3-2-.3-2-.3-2-.4-2-.3-2-.2-2-.2-2.2-.2-2-.2-2.2-.2-2-.2-2-.2-2-.2-2.2v-2l-.3-2v-2l-.2-2V499l-.2-1.7v-4.5l.2-1.4v-1.2l.2-1.2v-1l.3-1v-1l1 .3v.8l-.2 1v1l-.2 1.3v5.4l-.2 1.6v4.9l.2 1.8v4l.2 1.8v2l.3 2v2l.3 2 .2 2v2l.3 2.2.3 2 .2 2.2.3 2 .3 2 .3 2 .3 2.2.2 2 .3 2 .3 2zM354 624l.8-.6-.7-.2 2-1.2 1.5-1.4 1.5-1.6 1.4-1.8 1.3-2 1-2 1-2.3 1-2.6 1-2.5.6-2.8.6-2.7.4-2.8.4-3 .4-3 .3-3 .2-3v-3l.2-3v-6.2l-.2-3-.2-3v-3l-.4-3-.2-2.7-.3-2.7-.2-2.5-.4-2.5-.2-2.4-.3-2.2-.3-2-.3-2h.8l.4 1.8.3 2 .3 2.3.3 2.3.4 2.5.3 2.7.3 2.7.2 2.8.2 3 .2 2.8.2 3v15.5l-.3 3-.3 3.2-.4 3-.4 2.8-.5 3-.8 2.7-.7 2.7-.8 2.6-1 2.4-1 2.4-1.2 2.2-1.3 2-1.4 2-1.6 1.5-1.7 1.5-1.8 1.3zm.7 0-.5.4-.3-.5h.7zm-10-75.2 1-.2.5 2.2.4 2.2.4 2.2.3 2.2.3 2.2.2 2.3v2l.2 2.4v25.4l.2 2.4v2.4l.3 2.4.3 2.4.3 2.4.5 2.4.4 2.4.5 2.4.7 2.5.7 2.4.8 2.5 1 2.5 1 2.4-.8.5-1.2-2.6-1-2.5-.8-2.6-.8-2.5-.7-2.5-.5-2.5-.5-2.4-.4-2.5-.2-2.3-.3-2.5-.2-2.4V594l-.2-2.4V564l-.2-2.3-.2-2.3-.2-2.2-.4-2.2-.3-2-.5-2.3-.5-2v-.2zm-2.5-62.6v1l.5-.4-.3 1.6-.2 1.7-.2 1.7-.2 1.7-.2 1.7v1.8l-.3 1.8v3.5l-.2 2v7.3l.2 2v1.8l.2 2v2l.2 2 .2 2 .2 2 .2 2 .3 2 .2 2 .3 2.3.3 2 .3 2.2.4 2.2.4 2.2.4 2 .4 2.4.4 2.2-1 .2-.4-2.2-.4-2.3-.4-2.2-.4-2-.3-2.3-.4-2.2-.3-2-.3-2.2-.2-2-.3-2.2-.2-2-.2-2-.2-2v-2l-.2-2v-2l-.2-1.8v-13l.2-1.8v-1.8l.2-1.7.2-1.7.2-1.7.2-1.7.2-1.7.3-1.7.5-.4zm-.5.4v-.4h.5zm.5 0v-.4zm-.5 0v-.4h.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M422 454.4c0 8.7-3.2 66.5-4 74.6-.7 8-4.5 13.6-8.4 16.6-3.4-5-5.3-11.5-5.5-19.3 0-4 2.3-58.7 3-70 7-17 11.8-17.4 15-2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M418.5 529h-1v-1l.2-1v-1.5l.2-1.7v-2l.2-2v-2.3l.3-2.4v-2.5l.3-2.7.2-2.8v-3l.3-3 .2-3 .2-3v-3l.3-3.2.2-3 .2-3.2v-3l.3-3V474l.3-3v-2.5l.2-2.4V464l.2-2v-2l.2-1.8v-3.7h1v5.6l-.2 2v2l-.2 2.3v2.6l-.3 2.6-.2 2.7v2.8l-.3 3-.2 3v3l-.3 3-.2 3v3.2l-.3 3-.2 3.2-.2 3v3l-.2 2.7-.2 2.6v2.6l-.3 2.4v2.3l-.3 2v2l-.2 1.5v1.5l-.2 1.2v1zm-9.3 17 .8-.6-.7-.2.4-.2.3-.3.4-.4.3-.3.4-.3.4-.4.4-.3.3-.4.4-.4.4-.4.3-.5.4-.4.3-.6.3-.4.3-.5.3-.5.3-.5v-.5l.4-.6.2-.5.3-.7v-.6l.3-.6.2-.5.2-.7.2-.6V532l.3-.8v-.8l.2-.7v-.7h1v1.6l-.2.7-.2.7v.7l-.2.7-.2.7-.2.8-.2.6-.2.6-.2.6-.3.6-.2.6-.3.6-.3.5-.2.5-.3.5-.3.5-.5.5-.3.5-.3.4-.4.4-.4.4-.3.4-.5.4-.4.4-.2.4-.4.3-.4.4-.3.4-.4.3-.4.3h-.8zm.7 0-.5.4-.3-.5h.7zm-6.4-19.7h1v2.8l.2.8v.7l.2.7v1.2l.3.6v.8l.2.6.2.7v.7l.3.6v.6l.3.5.2.6.2.6.2.6v.6l.3.5.3.6.2.4.2.5.3.5.3.5.2.5.3.4.4.4.3.5.3.4-.8.5-.3-.6-.4-.4-.3-.5-.3-.6-.3-.6-.3-.5-.3-.6v-.6l-.4-.5-.2-.6-.2-.6-.2-.4-.2-.6-.2-.6-.2-.6-.2-.6-.2-.7-.2-.6v-.7l-.3-.7v-.6l-.2-.7v-.6l-.2-.7v-1.4l-.2-.7v-1.5l-.2-.7v-1.5zm3-70 .8.3v-.2 2.6l-.2 1.6v2l-.2 2v2l-.2 2.4v2.5l-.2 2.6v2.8l-.3 2.8v2.8l-.2 3v2.8l-.2 3v3l-.2 2.8v3l-.3 2.7v2.7l-.2 2.7v7.3l-.2 2v3.8l-.2 1.6v3.3h-1v-6.8l.2-2V513l.2-2.4V508l.2-2.6.2-2.8v-2.8l.2-3V494l.2-3 .2-2.8v-3l.2-2.8v-3l.3-2.7V474l.2-2.5V469l.2-2.4v-4.2l.2-1.8V459l.2-1.5v-1.2zm16-2h-1v.2l-.3-1.4-.3-1.2-.3-1.2-.4-1-.3-1-.4-1-.3-1-.4-.6-.5-.6-.4-.5-.2-.5-.4-.4h-.4l-.3-.2h-1.1l-.4.2-.5.2-.4.4-.5.5-.5.6-.6.7-.5.7-.5 1-.6.8-.5 1-.6 1.2-.7 1.2-.6 1.4-.6 1.4-.6 1.6-1-.4.7-1.6.8-1.4.6-1.4.6-1.2.6-1.2.6-1 .6-1 .6-1 .6-.7.5-.7.6-.6.6-.6.6-.4.5-.3h.6l.5-.3h1.2l.5.3.5.4.5.4.4.5.4.6.4.5.4.8.3 1 .4.8.3 1.2.3 1 .4 1.3.3 1.4.3 1.3zm-.5 0h.6-.5zm.6 0"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M385 407.2c-.6 18.7-1 59-.8 62.6a51 51 0 0 0 6.7 22.6c4-3 7.7-8.5 8.4-16.6.6-6.7.8-39.5 1-56-4.3-2.6-8.7-6-12.2-9.7l-3.2-2.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M384.7 469.8h-1v-23.4l.2-2.4v-19.6l.2-2.4v-9l.2-2v-3.8h1v7.8l-.2 2.4v9.4l-.2 2.5v12.5l-.2 2.4v25.4zm6 22.2.5.8h-.7l-.3-.6-.3-.5-.4-.6-.4-.4-.3-.6-.4-.6-.3-.7-.3-.6-.2-.6-.3-.7-.3-.7-.3-.7-.3-.7-.3-.8-.2-.7-.3-.7-.3-.8-.2-.8-.2-.7-.2-.8v-.8l-.3-.8v-.8l-.3-.8v-.8l-.2-.8v-.8l-.2-.8v-.7l-.2-.7v-1.5h1v2.5l.2.8v.8l.3.7v.8l.2.8.2.8.2.8v.7l.2.7.3.8.2.7.2.8v.8l.4.7.2.7.3.7v.7l.4.6.3.7.3.7.2.6.3.6.3.5.3.6.4.6.3.6.3.5.3.4h-.7zm.5.8-.4.3-.3-.3zm7.7-17h1l-.2.8v.8l-.2.7v.8l-.3.7-.2.7v.7l-.2.5-.2.7-.2.6-.3.6v.6l-.4.6-.2.6-.3.5-.2.5-.3.6-.3.5-.3.5-.4.4-.4.5-.3.4-.5.6-.3.4-.4.4-.3.4-.4.4-.3.3-.3.4-.4.2-.4.3-.4.3-.6-.8.4-.3.3-.3.4-.3.4-.2.4-.4.4-.3.3-.3.4-.4.4-.4.3-.5.4-.4.3-.3.3-.5.3-.5.3-.4.3-.5.2-.6.3-.5.2-.5.3-.6.2-.6.2-.5.2-.6.2-.8.2-.6.2-.6v-.7l.3-.7v-.7l.2-.8v-.7l.2-.8zm1-55.5.6-.8.2.4v18.8l-.2 2.2v14.6l-.2 2v8.9l-.2 1.5v4.3l-.2 1v2.6h-1V471l.2-1.5v-6.3l.2-1.8v-12l.2-2v-20.8l.2-1.7v-5.1l.2.3zm.6-.8h.2v.4l-.2-.5zm-12.4-9.8v1l.4-1 .3.4.2.5.4.3.3.3.3.5.3.3.4.3.3.4.4.4.3.3.4.4.4.3.4.3.3.3.4.3.3.4.4.3.4.3.5.3.3.2.4.2.4.3.4.3.4.3.4.3.4.3h.4l.4.4.4.3.4.2.4.2.4.3-.6.8-.4-.3-.4-.2-.4-.3-.4-.3-.4-.2-.4-.3-.4-.3-.4-.3-.4-.2-.4-.3-.4-.3-.4-.3-.4-.4-.3-.3-.4-.3-.3-.3-.4-.3-.4-.3-.5-.2-.4-.3-.2-.3-.4-.4-.4-.3-.3-.3-.4-.3-.4-.5-.4-.3-.4-.3-.3-.5-.5-.3-.3-.4-.3-.3.2-.8zm-.3.8-1-.8h1.2l-.3.8zm-2.5-3.3h-1l1-.3.2.2.2.2v.2h.3v.3h.4v.2l.3.2.3.2v.2h.3v.2h.2v.2h.3l.2.2v.2h.2v.2l-.2.8v-1l-.3 1h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2v-.2h-.2l-.2-.2-.3-.3h-.3v-.3h-.3v-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l1-.4zm-1 0v-1.4l1 1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M400 419.3c-.4 20-.2 51.7 0 54.3a34 34 0 0 0 5.4 19.3c4-3.2 8-8.8 8.8-17 .5-5 2-26.4 2-42.8-5.3-1.7-12-10.4-16.3-14z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M400.4 473.5h-1v-12.9l-.2-1.7v-33.7l.2-2v-4h1v14.5l-.2 2v37.1l.2.5v.3zm4.7 19 .7.8h-.7l-.3-.6-.3-.5-.3-.5-.2-.5-.3-.5-.3-.5-.2-.6-.3-.5-.2-.5-.3-.5-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6v-.6l-.3-.7v-.6l-.3-.8v-.6l-.2-.7v-.8l-.2-.6v-.7l-.2-.8v-1.5l-.2-.7v-1.4h1v2.8l.2.7v.7l.2.7v.7l.2.7v.7l.2.6v.7l.3.6v.6l.3.5v.6l.3.7.3.6.2.6.2.5.2.5v.6l.4.5.2.7.3.5v.5l.4.5.2.5.3.5.2.5.3.5.3.4zm.7.8-.4.3-.3-.4zm8-17.3h1v1.7l-.3.7v.7l-.3.8v.7l-.2.7-.2.7-.2.5-.3.7v.6l-.4.6-.2.6-.3.5-.2.6-.3.6-.4.6-.2.5-.3.5-.4.5-.2.4-.4.6-.3.4-.3.5-.3.4-.4.3-.4.3-.4.4-.3.3-.5.4-.4.3-.3.3-.6-.8.5-.3.3-.3.4-.4.4-.3.3-.4.3-.4.3-.4.4-.4.3-.4.4-.4.3-.5.3-.4.4-.4.3-.5.3-.3.3-.6.3-.4.2-.5.3-.5.2-.5.3-.6.2-.6.2-.6.2-.6.2-.7.2-.7.2-.7v-.7l.3-.8v-.7l.2-.7v-.8zm2.4-42.3.4-1 .3.5v7.9l-.2 1.6v5.1l-.2 1.6v1.7l-.2 1.7v4.6l-.2 1.6v2.9l-.2 1.3v1.4l-.2 1.3v2.5l-.2 1v2.2l-.2 1v1.6l-.2.7v1.1h-1v-2l.2-.8v-1.8l.2-1v-2.2l.2-1.2v-2.7l.2-1.3v-1.5l.2-1.4V457l.2-1.6v-1.6l.2-1.6V449l.2-1.6V443l.2-1.6V433l.5.5zm.4-1h.3v.5zm-16-13.4h-1l.8-.4.5.2.4.4.5.4.5.4.5.5.4.4.4.4.5.5.4.6.5.4.4.5.5.4.5.6.5.5.5.5.5.6.6.5.5.6.7.5.5.6.5.5.6.5.5.5.5.4.6.4.4.4.5.3.4.3.5.3.4.3.5.2.4.2-.3 1-.5-.2-.5-.3-.5-.2-.6-.3-.6-.4-.6-.3-.5-.4-.6-.4-.5-.4-.6-.5-.5-.5-.5-.5-.5-.5-.6-.5-.5-.5-.7-.5-.5-.6-.5-.5-.6-.5-.5-.6-.5-.4-.5-.5-.5-.5-.5-.5-.5-.5-.5-.4-.4-.4-.5-.4-.4-.5-.6-.4-.4-.3-.4-.4.8-.3zm-1 0v-1l.8.6-.8.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M387 405.6 373 385c-2.8 10.2-6.3 82.8-2.2 88.8a36 36 0 0 0 6.4 19.3c4-3 9.8-8.5 8-16.7-1.6-8.2.4-62.3 2-70.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m373.3 384.7 14.2 20.6-.8.5-14.3-20.5v-.4zm-1 .2.4-1 .5.7-.8.2zm-1.2 88.7h-1l.2.3-.5-.8-.3-1.2-.3-1.5v-1.8l-.3-2-.2-2.5v-2.6l-.2-2.8v-20.3l.2-3.7V431l.2-4 .2-3.6v-3.8l.3-3.7.2-3.7.2-3.4.3-3.5.2-3.2.3-3 .2-3 .3-2.5.3-2.4.2-2 .3-2 .3-1.3.4-1 1 .2-.3 1-.2 1.5-.3 1.8-.3 2-.2 2.4-.3 2.5-.3 2.8-.2 3-.3 3.3-.3 3.3-.2 3.4-.2 3.6-.2 3.7v3.7l-.3 3.8v3.8l-.2 3.7v3.8l-.2 3.6v19.6l.2 2.6.2 2.3.2 2v1.8l.4 1.5.3 1 .3.7zm0-.2v.2zm5.7 19.2.6.8-.7-.2-.3-.4-.3-.6-.3-.5-.3-.6-.3-.5-.2-.6-.3-.6-.3-.5-.3-.6-.4-.5-.2-.6-.3-.6v-.6l-.4-.6-.2-.6-.2-.6-.3-.6-.3-.6-.2-.7v-.6l-.3-.5-.2-.7v-.7l-.3-.6v-.6l-.2-.7v-.6l-.2-.7v-1.5l-.2-.7v-.7h1v1.4l.2.7v.6l.2.6v.7l.2.6v.7l.2.6.2.6v.6l.3.6.2.7.2.6.2.7v.6l.3.6.2.5.3.6.2.6.3.6.2.5.3.6.3.5.3.5.3.6.3.4.2.5.3.4.3.4.3.5.4.5h-.7zm.6.8-.4.3-.4-.5zm7.4-17 1-.3v.8l.2.7v3l-.2.7-.2.7v.7l-.3.7-.2.6-.2.6-.2.6-.3.6-.3.5-.4.6-.3.4-.4.5-.5.4-.3.5-.4.4-.4.4-.4.4-.5.5-.4.4-.3.5-.4.3-.4.4-.5.3-.4.3-.3.4-.4.3-.6-.8.4-.3.5-.3.4-.2.3-.4.3-.3.4-.3.4-.4.4-.3.4-.4.4-.5.4-.3.4-.4.4-.5.3-.5.5-.5.3-.5.3-.5.4-.5.3-.5.2-.6v-.6l.3-.5.2-.5.2-.7v-.6l.2-.6v-3.1l-.2-.7zM387 406v-1l.6.7-.2 1-.2 1v1.4l-.3 1.7-.2 2-.2 2v2l-.3 2.4v2.5l-.3 2.6v2.8l-.2 2.7-.2 2.8v3l-.2 2.8v3l-.2 3v8.5l-.2 2.8v13.5l.2 2v1.5l.2 1.4v1l.2 1-1 .2v-1l-.2-1v-1.5l-.2-1.7v-4l-.2-2v-15.5l.2-3V441l.2-3v-2.8l.2-3 .2-2.7v-2.8l.2-2.7.2-2.5V419l.3-2.3v-2.2l.3-2v-2l.3-1.5.3-1.4v-1.2l.3-1 .5.7zm0-1h.7v.7zm0 0v1l-.3-.2.4-.7zm0 1h-.2v-.2l.3.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M358 451.2c-.8 11.3-1.2 19-1 23 .2 7.6 2 14.2 5.5 19.2 4-3 9-8.5 8.4-16.6-2-31.5 1.4-61 5.4-89.6-3.4-2.5-9-5-12.5-7.6-6.8 38.3-9 62-6 71.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M357.4 474h-1v-7.4l.2-.7V463l.2-.7V459l.2-1v-1.8l.2-1v-3l.2-1h1v2l-.2 1v2l-.2 1v2.8l-.2.7v3.2l-.2.7v4.2l-.2.6v4.3zm4.8 19 .6.8h-.7l-.3-.6-.3-.5-.3-.5-.2-.5-.2-.5-.3-.5-.3-.6-.2-.4-.3-.6-.2-.5-.3-.6-.2-.7-.2-.6-.2-.6-.2-.5-.2-.6v-.7l-.3-.6v-.7l-.3-.6v-.7l-.2-.6-.2-.6v-.7l-.2-.7v-1.4l-.2-.7v-1.5l-.2-.7v-.7h1v2.2l.2.7v1.2l.2.7v.6l.2.6v.7l.2.5.2.7v.6l.3.6v.6l.3.6.2.6.2.6.2.6.2.6.2.5.2.6.2.6.3.6.2.5.2.5.2.5.3.5.3.5.3.5.3.5.3.4zm.6.8-.4.3-.3-.3h.8zm7.6-17h1v3.7l-.3.7v.6l-.2.7v.7l-.4.6-.2.6-.2.6-.3.6-.3.6-.3.5-.2.6-.3.5-.4.5-.2.5-.4.4-.4.5-.4.4-.3.6-.4.4-.5.4-.4.4-.3.4-.4.3-.4.3-.5.4-.4.3-.2.3-.6-.8.3-.3.4-.3.3-.3.3-.2.4-.4.4-.3.4-.3.4-.4.3-.4.4-.5.3-.4.3-.4.4-.4.3-.5.3-.5.3-.5.2-.5.3-.5.3-.5.2-.6.3-.6.2-.5.2-.6.2-.8v-.6l.2-.6v-.7l.2-.6zm5.7-89.2.7-.8.2.5-.5 2.6-.4 2.6-.3 2.7-.3 2.7-.4 2.7-.3 2.7-.3 2.7-.4 2.8-.3 2.8-.3 2.7-.3 2.8-.2 2.8-.2 2.8-.3 2.7-.2 2.8v3l-.3 2.7-.2 2.8-.2 2.8v2.8l-.2 3v8.5l-.2 3v8.6l.2 3v3l.2 2.8.2 3h-1l-.2-3v-3l-.2-2.8v-5.8l-.2-3V451l.2-2.8v-3l.2-2.7v-2.7l.3-3 .2-2.7.2-2.8V428l.3-2.7.3-2.8.3-2.8V417l.4-2.8.3-2.7.3-2.8.4-2.7.3-2.7.4-2.7.4-2.7.4-2.8.3-2.7.5-2.7.4-2.7v.6zm.7-.8.2.2v.3l-.3-.5zm-12.3-7-1-.3.8-.3.3.2.4.2.2.3h.3l.4.3.3.3.4.2.4.2.5.3.4.2.3.2.4.3.4.2.5.3.5.2.4.2.4.2.4.2.5.3.4.2.5.2.4.2.3.2.4.3h.4l.5.4.4.2.3.2.3.3.4.3.3.3.4.2-.6.8-.2-.2-.4-.3h-.3l-.3-.3-.3-.3-.4-.2-.4-.2-.4-.3-.4-.2-.4-.2-.4-.3-.4-.2-.4-.3-.5-.2-.4-.2-.4-.2-.5-.2-.5-.3-.4-.2-.4-.2-.4-.2-.4-.2-.4-.3h-.4l-.4-.4-.4-.2-.4-.2-.4-.3-.4-.3-.3-.3-.4-.2-.4-.2.8-.3zm-1-.3.2-.8.6.5zm-6 71.4.8.6-.8-.2-.3-1v-1l-.3-1-.2-1.3v-1l-.2-1.4V443l-.2-1.6v-5l.2-1.8v-2l.2-2 .2-2 .2-2.3.2-2.3.2-2.5.3-2.4.3-2.5.3-2.6.4-2.8.4-2.8.4-3 .4-2.8.5-3 .6-3.2.5-3.2.6-3.3.6-3.5.6-3.5.6-3.5 1 .2-.6 3.5-.6 3.5-.6 3.4-.5 3.3-.4 3.3-.5 3-.4 3-.4 3-.4 3-.4 2.7-.3 2.7-.3 2.7-.3 2.5-.2 2.4-.3 2.4-.3 2.3v2.2l-.3 2v2l-.2 2v9.8l.2 1.4v1.2l.3 1 .2 1.2v1l.4 1-1-.3zm.8.6-.5.6-.3-.8zm0 0-.7-.7 1 .3zm-.7-.7 1-1v1.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m343.6 471.8 4 14.7c.2 7.7 5 14 8.3 19 4-3 7.5-8 6.5-16-5.8-46.5-3.8-77.3 6-115-22 15-32.3 46.6-25 97.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m347 486.6-3.8-14.7 1-.3 3.8 14.6zm8.6 18.7.6.7h-.7l-.3-.6-.3-.5-.4-.5-.4-.5-.3-.5-.5-.6-.3-.6-.4-.5-.3-.7-.4-.5-.2-.6-.4-.5-.3-.6-.2-.5-.4-.6-.3-.7-.2-.6-.3-.6-.3-.5-.3-.7-.3-.6-.3-.7-.2-.7-.2-.6-.2-.7-.2-.7-.2-.7v-.6l-.2-.7v-.8l-.2-.8v-.7h1v1.4l.2.7v.7l.2.7.2.6v.6l.3.7v.5l.4.7.2.6.3.6v.6l.4.7.3.6.3.6.3.4.3.6.4.6.3.6.3.5.4.6.3.5.4.5.3.6.3.4.4.5.3.4.4.5.3.4.3.5.4.3h-.8zm.6.7-.4.3-.3-.4h.8zm5.8-16.5h1v5.5l-.2.6v.7l-.3.6v.4l-.3.6-.2.6-.3.5-.2.6-.2.5-.3.6-.3.5-.3.6-.3.4-.2.4-.3.4-.4.5-.2.3-.3.4-.4.4-.3.3-.3.4-.4.4-.4.3-.3.3-.7-.8.4-.3.4-.4.3-.3.4-.3.4-.3.3-.4.4-.3.4-.4.3-.4.3-.4.3-.4.3-.4.3-.4v-.5l.4-.3.2-.5.2-.5.2-.5.2-.5.2-.5.2-.6v-.6l.2-.5v-.6l.2-.7v-5.1zm6.8-114.7-.6-1 .8.7-1 3.5-.8 3.5-.8 3.4-.7 3.4-.7 3.4-.7 3.3-.6 3.5-.6 3.4-.4 3.2-.5 3.3-.3 3.4-.4 3.2-.4 3.4-.4 3.3-.2 3.3-.2 3.4-.2 3.4v3.6l-.2 3.5v14.7l.3 3.7.3 4 .2 3.8.3 4 .4 3.8.3 4 .5 4.2.4 4.3.6 4.4h-1l-.6-4.2-.4-4.3-.5-4.2-.3-4-.4-4-.3-4-.2-3.8-.2-3.8v-3.7l-.2-3.7v-14.3l.2-3.4.2-3.4.2-3.4.2-3.4.3-3.3.3-3.4.4-3.3.4-3.3.6-3.4.5-3.3.7-3.4.6-3.3.7-3.4.7-3.4.8-3.5.8-3.4.8-3.5 1-3.6.8.6zm-.6-1 1-.6-.2 1.3zm-24 98h-1l-.7-4.6-.5-4.6-.5-4.5-.3-4.3-.3-4.2-.2-4.2v-8l.2-3.8.2-3.7.3-3.7.4-3.4.5-3.4.6-3.3.8-3.3.7-3 1-3 1-3 1-2.8 1-2.8 1.2-2.5 1.3-2.5 1.4-2.4 1.5-2.3 1.4-2 1.6-2.2 1.7-2 1.7-2 2-1.6 1.8-1.7 2-1.6 2-1.5.6.8-2 1.4-2 1.6-1.8 1.6-1.8 1.7-1.8 2-1.6 2-1.6 2-1.5 2-1.4 2.3-1.4 2.4-1.4 2.4-1.2 2.6-1 2.7-1 2.7-1 3-1 3-.7 3-.7 3-.6 3.4-.5 3.3-.5 3.5-.3 3.6-.3 3.7-.2 3.8v12l.4 4.4.3 4.3.5 4.5.5 4.6.6 4.7zm-.6 0h.5-.4zm-.4 0"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m344.8 486.2-20.3-6.7c-2.5 20.2 1.4 45.6 7 79 4.6 29 2 51.6-1.5 66.2 21.6-3 30.7-30.7 20-83-3-13.7-5.8-31.3-5.2-55.5"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m324.7 479 20.2 6.7-.4 1-20.2-6.7-.3-.6zm-.6.4v-.6l.7.2zm8 79-1 .3-.6-3-.5-3.2-.6-3-.5-3-.5-3-.5-2.8-.4-3-.4-2.7-.4-2.7-.4-2.7-.4-2.7-.3-2.7-.4-2.6-.3-2.6-.3-2.4-.2-2.5-.3-2.3-.2-2.4-.2-2.4v-2.4l-.3-2.3V500l-.2-2v-10.7l.2-2 .2-2v-2l.4-2 1 .3-.2 2-.2 1.8v2l-.2 2v4l-.2 2v4.3l.2 2.3v2.3l.2 2.3.2 2.3.2 2.2.2 2.4.3 2.4.2 2.5.3 2.5.3 2.5.3 2.6.4 2.8.4 2.6.3 2.7.4 3 .6 2.7.4 2.8.4 3 .5 3 .4 2.8.5 3 .4 3 .5 3.2zm-2 65.8v1l-.5-.6.4-1.4.2-1.4.3-1.5.3-1.5.3-1.6.4-1.6.3-1.7.2-1.8.2-1.7.2-1.8.2-2 .2-1.8v-2l.3-2 .2-2v-2l.2-2v-13.4l-.2-2.3-.2-2.4-.2-2.4-.2-2.5-.3-2.5-.3-2.6-.3-2.6-.4-2.6-.4-2.7 1-.2.3 2.7.4 2.7.3 2.5.3 2.6.3 2.6.2 2.5.2 2.6v2.4l.3 2.4v6.8l.2 2.3v4.3l-.2 2v2l-.2 2v2l-.2 2-.2 2-.2 1.8-.3 1.8v1.8l-.4 1.7-.2 1.8-.3 1.6-.2 1.6-.3 1.5-.3 1.5-.4 1.5-.3 1.4-.5-.8zm0 1h-.6v-.6zm19.4-83.5 1-.2 1 5 .8 4.6.7 4.6.5 4.5.5 4.3.4 4 .3 4 .2 4v7.2l-.2 3.4-.2 3.2-.4 3-.4 3-.6 3-.6 2.6-.7 2.6-1 2.4-1 2.3-1 2.2-1 2-1.2 1.8-1.3 1.7-1.4 1.5-1.4 1.4-1.5 1.3-1.5 1-1.8 1-1.8.7-2 .7-2 .5-2 .2v-1l2-.3 1.8-.6 1.8-.6 1.7-.8 1.6-1 1.5-1 1.5-1 1.4-1.5 1.3-1.5 1.3-1.6 1-1.8 1.2-2 1-2 1-2.2.7-2.3.6-2.4.7-2.7.5-3 .4-2.8.4-3 .2-3.3v-3.5l.2-3.5v-3.7l-.3-3.8-.3-4-.3-4-.4-4.3-.7-4.4-.8-4.5-.8-4.7-1-5zm-4.8-55 .3-1 .3.5V503l.2 2 .2 1.8v2l.2 1.8v1.8l.2 1.8.2 1.7.2 1.8.2 1.7.2 1.7.2 1.6.2 1.6.2 1.6.2 1.5.3 1.5.3 1.5.3 1.5.2 1.4.3 1.4.3 1.4.3 1.4.3 1.3v1.3l.4 1.2-1 .2-.2-1.3-.3-1.3-.4-1.2-.2-1.4-.3-1.4-.2-1.4-.2-1.4-.3-1.5-.2-1.5v-1.5l-.4-1.6-.2-1.5-.2-1.6-.2-1.7-.2-1.7-.2-1.7-.2-1.8-.2-1.8v-1.7l-.3-2-.2-1.7v-2l-.3-1.8v-4l-.2-2v-13l.3.5zm.3-1 .3.2v.2l-.4-.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M343.6 584h1v.7h-.8v-.2h-.2v-.4zm-4.3-40 1-.4.4 1.2.2 1.2v1l.4 1.3.2 1.3.2 1.2.2 1.2.2 1.2.2 1.3.2 1.3.2 1.2.2 1.3.2 1.3.2 1.2.2 1.3v1.4l.3 1.3v2.6l.3 1.3v1.3l.2 1.2v2.6l.2 1.3v9.1h-1v-7.6l-.2-1.2v-2.7l-.2-1.3V570l-.2-1.3v-1.3l-.2-1.3v-1l-.3-1.4v-1.3l-.3-1.3-.2-1.3v-1.2l-.3-1.3-.2-1.3-.2-1.3-.2-1.3v-1.2l-.4-1.2-.2-1.2-.2-1.2-.2-1.2-.3-1.2-.2-1.2-.2-1.2zm-5.5-50.4h1.2v6.4l.2 1.5v3.3l.2 1.5v1.6l.2 1.5v1.6l.3 1.5v3.1l.3 1.5.2 1.7v1.5l.3 1.6.2 1.5.2 1.6.2 1.4.2 1.6.3 1.5v1.6l.4 1.6.2 1.6.3 1.6.2 1.5.3 1.6.3 1.5.3 1.5.4 1.6-1 .3-.5-1.7-.4-1.6-.3-1.6-.3-1.5-.3-1.5-.2-1.6-.3-1.6-.2-1.5-.3-1.6-.2-1.6-.2-1.4-.3-1.6-.2-1.5-.2-1.6v-1.7l-.3-1.5-.2-1.6v-1.5l-.2-1.6v-1.4l-.2-1.6-.2-1.6V508l-.2-1.7V503l-.2-1.4v-6.4l-.2-1.6zm1.2 0h-1.2v-.2h.2v-.2h.2v-.2h.8v.2h.2v.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m344 367.3 13.2 2.2-4.6 23.3c-5 24.3-8.2 53-4.5 84.2 1.5 11.7 4 21.2 7.6 28.5-14.6-1.6-24-15.8-22.7-40.6-2.6-29-1.5-52 3.2-69.4 1.4-5 5.8-24.2 7.8-28.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m357 370-13-2.3v-1l13.3 2.3.4.6zm.3-1h.5v.6zm-4.2 24-1-.3.2-.3v-.4l.2-.5v-.6l.2-.7v-.6l.3-.7v-.8l.2-.8v-1l.3-.7.2-1 .2-1v-.8l.2-1 .2-1 .2-1 .2-1 .2-1 .2-.8v-1l.3-.7.2-1v-.7l.3-.7v-.7l.3-.6v-.6l.2-.5v-.4l.2-.3v-.3l1 .2v.6l-.2.5v.5l-.3.6v.5l-.2.7-.2.8-.2.8v1l-.3.7-.2 1v.8l-.2 1-.2 1-.2 1-.2.8-.2 1-.2 1v1l-.3 1-.2.7-.2 1v.7l-.2.7v1l-.2.5-.2.6v.7l-.2.5v.7zm-4.4 84h-1l-.3-2.8-.3-3-.3-3-.2-2.8v-2.8l-.3-3V457l-.2-3v-11l.2-2.7v-2.7l.2-2.7.2-2.8.2-2.6.2-2.6.3-2.6.2-2.6.3-2.6.3-2.5.4-2.5.4-2.5.4-2.5.3-2.4.4-2.4.3-2.4.5-2.4.4-2.3.5-2.3.4-2.3 1 .2-.4 2.2-.4 2.3-.5 2.3-.4 2.4-.4 2.4-.5 2.4-.4 2.4-.2 2.4-.4 2.5-.3 2.5-.2 2.5-.3 2.6-.3 2.5-.2 2.5-.2 2.7-.2 2.6-.2 2.6v2.6l-.2 2.7v2.7l-.2 2.7v11.5l.2 3v2.7l.3 3 .2 2.7.3 3 .3 2.8.3 3zm7 29v-1l-.4.8-.4-.7-.3-.6-.3-.8-.4-.7-.3-1-.3-.6-.3-.8-.4-.8-.3-.8-.2-.8-.2-.8-.3-1-.2-.7-.3-1-.2-.8-.3-1-.2-1-.2-.8v-1l-.3-1-.2-.8-.2-1-.2-1v-1l-.3-1-.2-1v-1l-.3-1-.2-1v-1l-.2-1.2-.2-1 1-.2v1l.3 1v1.2l.2 1v1l.3 1 .2 1 .2 1v1l.2 1 .2 1 .2 1 .2 1 .3.8.3 1 .2.8.2 1 .3.7.2 1 .3.7.2.8.3 1 .3.7.3.8.3.7v.8l.4.8.4.7.3.7.4.7.3.6.3.7-.5.7zm.4-.7.4.8h-1l.6-.7zM332.4 465l1-.2v8.8l.2 2 .2 2 .3 2 .4 1.8.4 1.7.4 1.8.5 1.7.5 1.5.6 1.5.6 1.5.7 1.3.8 1.3.7 1.3.8 1 1 1 .8 1.2 1 1 1 .8 1 .8 1 .8 1 .7 1.2.6 1.2.4 1.2.5 1.2.3 1.2.3 1.3.3h1.4l-.2 1h-1.3l-1.4-.4-1.3-.4-1.3-.4-1.2-.5-1.2-.5-1.2-.7-1-.6-1.2-.8-1-.8-1-1-1-1-1-1-1-1.2-.7-1.2-.8-1.3-.8-1.2-.7-1.4-.7-1.5-.5-1.6-.6-1.6-.5-1.7-.4-1.6-.4-1.8-.3-2-.2-1.8-.2-2-.2-2v-8.9zm3.3-69.6 1 .3-.5 1.6-.4 1.7-.4 1.7-.3 1.7-.3 1.8-.3 1.8-.3 1.8-.2 2-.2 1.8-.3 2-.2 2v2l-.3 2v2l-.2 2-.2 2.3v4.3l-.2 2.2v9.6l.2 2.5v2.4l.2 2.5v2.5l.2 2.6.2 2.6.2 2.5.2 2.6.2 2.8h-1l-.2-2.6-.2-2.6-.2-2.7-.2-2.7v-2.5l-.2-2.6v-2.5l-.2-2.4v-18.5l.3-2v-2.2l.3-2v-2.2l.3-2 .3-2 .3-2 .2-1.8.3-2 .4-1.8.4-1.8.3-1.8.5-1.7.4-1.7.3-1.7.4-1.6zm8.3-28.6v1l.4-.3-.2.4-.2.4-.2.6-.2.6-.3.7-.2.8-.2 1-.2.8-.3 1-.3 1-.2 1-.3 1-.3 1-.3 1.2-.4 1-.3 1.2-.3 1-.2 1.2-.3 1-.3 1.2-.3 1-.3 1-.3 1-.2 1-.3 1-.3 1-.2.8-.2.8-.2.7v.6l-.2.6v.5l-1-.3v-.5l.2-.7.2-.6.2-.8v-1l.4-.7.2-1 .2-.8.3-1 .2-1 .3-1 .2-1.2.3-1 .3-1.2.3-1 .4-1 .2-1.2.3-1 .2-1.2.3-1 .3-1 .3-1 .4-1 .2-1 .3-1v-.8l.4-.8.2-.7.3-.7v-.6l.3-.5.2-.5.5-.2zm-.5.2.2-.3h.3zm.5.3v-.5zm-.5-.3.2-.3h.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m336 370.4 6.4 7.4c-1.8 1.4 1.3 7-.4 18-1 6.4-4.8 13.8-5.6 22-2.5 26.5-2.5 59.8 5.4 81-14.5-1.6-19.5-14.8-20-39.6-.4-20.6-.4-44.7 4.7-72.7 1-6.5 4.2-11.7 9.4-16z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m342 378.2-6.5-7.5.8-.6 6.5 7.5v.7h-.7zm.8-.7.4.4-.5.2v-.7zm-.3 18.5h-1l.2-1.2v-1l.2-1V385l-.2-.6v-1.2l-.2-.6v-1l-.2-.4v-2.8l.2-.3.3-.4v-.2l.7.8v.2h-.2v.5h-.2v2.2l.2.4v1.1l.2.6v1.1l.2.7v8.1l-.2 1v1l-.3 1zm-5.6 21.7h-1v-1.8l.2-.7.2-.7v-.7l.3-1v-.6l.3-.8.2-.7.2-.8.2-.7.2-.7.2-.7.2-.6.2-.7.2-.7.3-.7v-.7l.3-.6.2-.7.2-.7.2-.6v-.7l.3-.6.2-.6.2-.5.2-.7v-.6l.2-.6v-.6l.2-.6v-.5h1v1.2l-.3.6v.7l-.2.6v.7l-.3.7-.2.6-.2.6v.7l-.3.7-.2.6-.3.7-.2.6-.2.6-.2.7-.2.7-.2.7-.3.7-.3.7-.2.8-.2.7-.2.7v.7l-.2.6-.2.7v.7l-.3.8v.7l-.2.7v1.5zm4.8 81.6v-1l-.4.7-.8-2-.6-2-.7-2.3-.6-2.2-.5-2.3-.5-2.4-.5-2.4-.4-2.4-.4-2.5-.4-2.5-.3-2.5-.3-2.6-.2-2.7-.2-2.7-.2-2.6v-2.7l-.2-2.7V455l-.2-2.8v-10.9l.2-2.7V436l.2-2.8v-2.7l.3-2.6.3-2.7.2-2.6.2-2.6.2-2.4h1l-.3 2.6-.2 2.6-.2 2.5-.2 2.6v2.6l-.2 2.6v2.7l-.2 2.6v2.7l-.2 2.7V455l.2 2.7v2.7l.2 2.7.2 2.5.2 2.7.2 2.6.3 2.5.3 2.6.4 2.4.4 2.4.4 2.5.4 2.3.5 2.4.7 2.2.6 2.2.6 2.2.6 2 .7 2-.5.7zm.5-.6.3.7h-.8zm-21-39.5h1v2.2l.2 2.3v2l.2 2.2.2 2v2l.3 1.7.3 1.8.3 1.8.2 1.6.4 1.5.4 1.6.4 1.5.5 1.4.4 1.2.6 1.3.6 1.2.6 1 .7 1 .6 1 .8 1 .8 1 .8.6 1 .7 1 .7 1 .6 1 .5 1 .4 1 .4 1.3.3 1.3.2 1.3.2-.2 1-1.4-.2-1.3-.3-1-.4-1.3-.4-1.2-.5-1-.6-1.2-.5-1-.7-1-.7-.8-.7-1-1-.7-1-.7-1-.6-1-.7-1.2-.6-1-.5-1.4-.5-1.3-.5-1.5-.5-1.5-.4-1.5-.3-1.7-.4-1.5-.4-1.8-.3-1.8-.2-2v-2l-.3-2v-2l-.2-2.3v-2.2l-.2-2.3zm4.7-72.8 1 .2-.5 2.6-.4 2.6-.3 2.5-.4 2.6-.3 2.4-.4 2.5-.3 2.4-.3 2.4-.2 2.4-.2 2.5-.3 2.3v2.4l-.3 2.4-.2 2.3v2.4l-.2 2.2v2.3l-.2 2v4.5l-.2 2.2V459h-1v-26.9l.2-2.2v-2l.2-2.4v-2.3l.2-2.3.2-2.3.2-2.4.2-2.3.2-2.4.2-2.5.3-2.3.3-2.4.3-2.5.4-2.5.3-2.6.4-2.5.4-2.6.6-2.6.4-2.6zm10.3-16.3-.8.7h.7l-.4.5-.5.4-.5.4-.4.4-.4.5-.4.3-.4.4-.4.5-.4.4-.4.5-.3.5-.4.5-.3.5-.3.4-.3.4-.3.5-.2.4-.3.5-.2.4-.3.5-.2.4-.2.6-.2.5-.2.5-.2.6-.2.5-.2.7v.5l-.3.6v.6l-.2.6v.6l-1-.2v-.6l.2-.6.2-.6v-.6l.3-.6v-.6l.3-.5.2-.6.2-.6.2-.4.3-.6v-.5l.4-.5.2-.6.3-.5.2-.6.3-.5.3-.6.4-.5.3-.6.4-.5.2-.6.4-.4.4-.5.4-.4.4-.4.5-.4.4-.5.5-.4.4-.4.5-.6.6-.4h.7zm-.7 0 .4-.3.3.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m372.3 390-13.4-1.6c-2.6 12.7-4.5 21.7-5 26.2-1 9 1.8 17 5 23 5-3 7.2-9.4 9.2-18.6 2-9.2 2.7-19.2 4-29z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m359 388 13.3 1.5v1l-13.5-1.6-.4-.7.5-.4zm-.6.3v-.4h.5l-.6.3zm-4 26.4h-1l.2-.6v-.8l.2-.6v-1l.2-.6v-.7l.3-.6v-.7l.2-.7v-.7l.3-.7v-1l.2-.7.2-.8.2-1v-.7l.3-1 .2-.8v-1l.2-1 .2-1 .2-1 .2-1 .2-1 .3-1 .2-1 .2-1.2.2-1.2v-1l.4-1.3 1 .2-.3 1.2v1l-.3 1.3-.3 1-.2 1.2-.2 1-.2 1-.2 1-.2 1-.2 1-.2 1v1l-.3 1-.2.8-.2.8v1l-.3.7v.8l-.3.7v.8l-.2.7-.2.7v.6l-.2.7v1.3l-.2.5v1.1l-.2.5v.9zm4.3 22.6.5.8h-.7l-.3-.7-.3-.6-.4-.6-.3-.5-.3-.6-.2-.7-.3-.7-.2-.6-.3-.7-.2-.7-.3-.7-.2-.8-.2-.7v-.7l-.3-.7-.2-.7-.2-.7v-.8l-.3-.7v-.7l-.2-.8v-.8l-.2-.7v-.8l-.2-.8v-6.1h1v6.6l.2 1v1.4l.3.7v1.6l.3.8.2.7v.8l.3.7.2.7.3.7.2.6.2.7.2.6.2.6.2.6.3.7.3.5.2.6.3.7.3.6.3.6.3.5-.7-.2zm.5.8-.5.4-.2-.5h.7zm8.6-19h1l-.3 1-.2.8-.2 1v.7l-.3.8-.2.7-.2.8-.2.7v.8l-.4.7-.2.7-.3.6v.7l-.4.6-.2.7-.3.6-.2.5-.3.5-.3.6-.3.5-.4.7-.3.5-.4.5-.5.4-.3.6-.4.4-.4.4-.4.4-.5.3-.4.5-.4.3-.4.3-.5-.7.4-.3.5-.3.4-.3.3-.4.4-.3.4-.4.4-.4.4-.5.3-.4.4-.4.4-.5.3-.4.4-.5.2-.4.3-.6.2-.5.3-.6.2-.7.3-.7.2-.6.3-.7.2-.6.2-.7v-.8l.3-.7.3-.7.2-.8.2-.8.2-.8.2-.8.2-.8.2-1zm4.5-28.5v-1l.5.5v1l-.3 1v.8l-.2 1v1l-.2.8v1l-.2.8v1l-.2 1v.8l-.2 1v1l-.2.8v1l-.2.8v1l-.2.8v1l-.2 1-.2.8v1l-.2.8-.2 1v.8l-.2 1-.2.8-.2.8v1l-.3.8v1l-.3.7h-1l.3-1v-.8l.3-1 .2-.7v-1l.3-.8v-1l.3-.8.2-1v-1l.3-.8v-1l.2-.8v-1l.2-.8v-1.8l.2-1v-1l.2-.8v-1l.2-.8v-1l.3-1v-1.8l.2-1v-.8l.2-1v-.8l.3-1v-1l.6.7zm0-1h.6l-.2.5zm0 0v1zm0 1"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M407 418.6h-11.8c-.4 11-.7 18.5-.5 22.3.4 7.5 2.3 14 5.5 18.7 3.6-3 7-8.3 7.6-16.2.6-8-.6-16.5-.7-25z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M395.2 418.2h12v1h-12l-.5-.5zm-.5.5v-.5h.5zm.5 22.2h-1v-11.4l.2-.8v-4.4l.2-.8v-5h1v7.8l-.2.7v5.6l-.2.7v7.7zm4.7 18.4.6.7h-.8l-.3-.5-.3-.4-.3-.4-.4-.5-.2-.4-.3-.5v-.4l-.4-.6-.2-.5-.3-.5v-.6l-.3-.6-.2-.5-.2-.6-.2-.6v-.5l-.2-.6-.2-.7-.2-.6v-.6l-.2-.6-.2-.6v-.7l-.2-.5v-.7l-.2-.7v-.5l-.2-.7v-2.6l-.2-.7h1v1.1l.2.7v1.4l.2.7v.7l.2.6v.7l.2.6v.6l.3.6v.7l.3.6v.7l.3.5v.6l.2.6.2.5.2.5.2.5.3.6.3.5.2.6.3.5.2.6.3.5.2.6.3.5.3.6.4.4.2.5h-.7zm.6.7-.5.5-.2-.5h.8zm6.7-16.6h1v1.6l-.2.7v1.4l-.3.8v.6l-.3.7-.2.7-.2.6-.2.6-.2.5-.2.5-.3.6v.5l-.4.7-.2.5-.3.5-.2.5-.3.4-.3.5-.3.5-.4.4-.3.3-.4.4-.4.4-.3.5-.4.3-.4.4-.4.3-.3.3-.4.3-.7-.6.2-.3.4-.2.3-.3.2-.4.3-.2.4-.3.2-.4.3-.3.3-.4.3-.4.4-.5.3-.4.2-.4.2-.4.3-.5.2-.5.3-.5.2-.5.3-.5.2-.6.2-.4v-.6l.3-.6v-.6l.3-.6v-.7l.3-.6v-1.4l.2-.7V444zm0-24.3v-1l.4.6v5.6l.2 1v4.6l.2.8v2.8l.2.8v9.2h-1v-11.8l-.2-.8V429l-.2-1v-3l-.2-1v-5.3l.4.5zm0-1h.4v.6l-.5-.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m420 424.2-12 .6c0 11 0 18.4.3 22.2a37 37 0 0 0 6.2 18.6c3.5-3 6.8-8.6 7-16.5.3-8-1-16.3-1.5-24.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m408 424.3 12-.6v1l-12 .6-.4-.5.5-.5zm-.4.5v-.5h.5l-.4.5zm1.2 22.2h-1v-4l-.2-.6v-17.8h1V445l.2.4zm5.4 18.2.6.8h-.7l-.2-.5-.3-.5-.3-.5-.3-.5-.4-.5-.3-.5-.3-.5-.2-.5-.3-.5-.3-.5-.2-.6-.2-.5-.3-.7-.2-.6-.2-.6v-.4l-.3-.6-.2-.6v-.7l-.3-.6-.2-.5v-.6l-.3-.8v-.6l-.2-.7v-.8l-.2-.6v-.7l-.2-.8v-2h.8v.7l.2.7v1.4l.2.7.2.7v.7l.2.7v.6l.3.6v.7l.2.6v.5l.3.6.2.7.2.5v.6l.3.6.2.5.2.5.2.5.2.5.2.6.2.6.3.5.2.6.2.4.3.5.3.5.3.4.3.5.3.3h-.8zm.6.8-.4.4-.3-.5h.8zm6.2-17h1v2.3l-.2.7v.7l-.2.7-.2.6v.7l-.3.6v.6l-.2.5-.2.6-.2.7-.2.6-.3.5-.3.6-.3.5-.2.4-.3.5-.4.4-.3.4-.3.5-.3.4-.3.4-.3.5-.2.4-.3.3-.3.4-.4.3-.3.4-.3.3-.4.3-.6-.8.3-.3.3-.4.3-.3.4-.3.3-.4.4-.3.4-.4.2-.5.3-.4.2-.3.3-.4.3-.5.2-.4.3-.5.2-.6.3-.5.2-.6.2-.5.2-.6.2-.6.2-.6.2-.5.2-.6v-.5l.3-.7v-.6l.2-.7v-.6l.2-.8zm-1-25.3v1l.5-.5v2.4l.2.8v1.5l.2.7v3.4l.2.7v1.5l.2.8v.8l.2.8v2.5l.2.7v2.3l.2.8v5.3h-1v-7.4l-.2-.7v-1.6l-.2-.8V437l-.2-1v-1.5l-.2-.7v-1.6l-.2-.8v-1.6l-.2-.8v-1.6l-.2-.8v-2.2l.4-.6zm-.5.6v-.6h.5zm.5.4v-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m395 412.4-12-.8c-1.2 11-2 18.2-2.2 22-.2 7.7 1 14.2 4 19.3 3.8-2.8 7.7-8 8.8-15.7 1.2-8 .8-16.4 1.4-25z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m383 411 12 1v1l-12-1-.4-.5.5-.4zm-.4.5v-.5h.5l-.4.5zm-1.3 22.2h-1V431l.2-.4V429l.2-.6v-1.2l.2-.6v-2.2l.2-.7v-1.4l.2-.8v-.8l.2-.8v-1l.2-.8v-1l.2-.8v-1l.3-1v-1l.2-1v-1l1 .2v2l-.3 1v1l-.2 1v.8l-.2 1v.7l-.2 1v.8l-.2.8v.8l-.2.8v1.3l-.2.7v1.4l-.2.6v1.1l-.2.6v1.7l-.2.5v2.7zm3.2 18.8.5.8-.7-.2-.2-.4-.2-.5-.2-.4-.3-.5-.2-.4v-.5l-.3-.5-.3-.5v-.6l-.3-.5v-.7l-.3-.6v-.6l-.3-.4v-.6l-.3-.7V443l-.2-.5v-.7l-.2-.6V440l-.2-.8v-5.5h1v6.8l.2.7v.7l.2.6v.6l.2.5v.6l.2.7.2.6v.6l.3.5v.5l.3.6.2.5.2.7.2.5.2.5.2.5.2.5.3.5.2.5.2.5.2.4h-.7zm.5.8-.4.3-.3-.5.8.3zm8.2-16h1l-.2.8v.8l-.3.7v.7l-.3.7-.2.6-.2.6-.2.6-.3.6-.2.6-.3.6-.2.6-.3.5-.3.6-.3.5-.4.5-.3.5-.3.4-.3.5-.3.4-.4.6-.3.4-.4.4-.3.3-.4.4-.3.5-.4.3-.5.3-.3.4-.4.3-.4.3-.3.3-.5-.8.3-.3.4-.2.3-.3.4-.3.2-.3.4-.2.3-.4.3-.3.3-.3.3-.4.2-.4.4-.5.3-.4.2-.3.3-.5.3-.5.3-.4.4-.5.2-.5.3-.6v-.5l.4-.6.2-.5.2-.5.2-.6.2-.7.2-.7.2-.6.2-.7v-.7l.2-.7.2-.8zm1.8-24.4v-1l.5.5v1.5l-.2.8v5.6l-.2.7v9l-.2.8v2.2l-.2.8v.7l-.2.8v1l-.2.6v.8l-1-.2v-.7l.2-.8v-1.5l.2-.7V432l.2-.8V428l.2-.8V421l.2-.7v-4.8l.2-.8v-2.3l.6.5zm0-1h.5v.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m384 399.6-13.2-5.4c-2.2 8.8-5.2 37.8 0 50 4.5-3 9-8.4 10.3-17 1.6-9 2-18.2 3-27.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m371 393.7 13 5.4-.3 1-13-5.4-.4-.6zm-.7.3.2-.5.5.2zm.3 50 .6.7-.7-.2-.5-1.2-.5-1.3-.3-1.4-.4-1.5-.3-1.5-.3-1.6-.2-1.7-.2-1.7v-1.8l-.2-1.8v-3.6l-.2-2V418l.2-2v-1.8l.2-1.8.2-1.8V409l.3-1.8.2-1.7V404l.3-1.6.2-1.5.3-1.4.2-1.3.2-1.2.2-1v-1l.3-1 1 .3-.2 1v.8l-.3 1.2-.3 1.2-.2 1.3-.2 1.4-.2 1.5-.2 1.6-.2 1.6v1.7l-.3 1.7v1.7l-.2 1.8v1.8l-.2 1.8v3.8l-.2 2v5.4l.2 1.8v1.7l.2 1.8.2 1.7.2 1.6.3 1.6.3 1.5.3 1.3.5 1.4.4 1.2.4 1h-.8zm.6.7-.5.3-.2-.5zm9.4-17.7h1v1l-.3.8-.2.8v.7l-.3.8-.2.8-.3.7-.2.7-.3.7-.3.5-.3.7-.2.6-.3.6-.3.6-.3.6-.5.5-.3.7-.4.5-.4.5-.3.5-.3.4-.4.5-.4.5-.5.4-.4.3-.3.4-.4.4-.4.4-.5.4-.5.3-.4.4-.4.3-.6-.8.4-.4.4-.3.4-.3.4-.3.4-.4.4-.3.4-.4.4-.4.4-.4.3-.4.4-.4.3-.5.3-.4.4-.4.3-.5.4-.4.3-.6.3-.5.3-.6.3-.6.2-.6.3-.7.3-.5.2-.6.3-.8.2-.7.2-.7.3-.7v-.7l.3-.7.2-.8v-.8zm3-27 .4-1 .4.6v1l-.2.8v1.7l-.2 1v1l-.2.8v1.8l-.2.8v1.7l-.2 1v1.7l-.2 1v1.6l-.2 1v.7l-.2 1v.8l-.2.8v1l-.2.7v.8l-.2 1v.8l-.2 1v.7l-.3.8v.8h-1v-.8l.2-1v-1.5l.2-.8v-1l.2-.8v-1l.2-.7v-1l.2-.7v-1l.2-.7v-1.6l.2-1v-.7l.2-1V410l.2-.8v-1.8l.2-.8v-1.8l.2-1v-1.5l.2-1v-.8l.2-1zm.4-1 .4.3v.3l-.4-.5zm0 .6-.3.4.2-.4zm0-.5.4.3v.3l-.4-.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              id: "rs_svg__c",
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M387.8 701.2c8 6.3 15.2-8.3 8-27.6-5-14.2-30.6-8.7-16.4 10.5.7 1 1.6.6 1.5-.4-1-4 1.6-6.3 5.5-5.5 10.5 2 11 22-.6 17.6-2.2-.2-.4 4 1.7 5.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M400 639.2c-1 3.4-5 7.6-8 10.8-4.5 4.8-3.4 12.2-.2 16 3.5 4.4 5 9.2 5.8 13 .5 2.3 1.5 7.4.8 15.5-.4 4-2.7 6-5 7.7-1 1 .5 3 4.3 6 .4.2 1.5 1 2 3 .2.4 2 .4 2.2 0 .4-2 1.6-2.8 2-3 3.7-3 5.4-5 4.2-6-2.2-1.7-4.6-3.8-5-7.7-.6-8 .3-13.2.8-15.5.8-3.8 2.3-8.6 6-13 3-3.8 4.2-11.2-.5-16-3-3.2-7-7.4-8-10.7 0-.8-.3-1-.7-1-.3 0-.7.2-.7 1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M395 685.5h11.6c2 0 3.6 1.6 3.6 3.5 0 2-1.6 3.5-3.6 3.5H395c-2 0-3.5-1.5-3.5-3.5s1.6-3.5 3.6-3.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M406.6 686H395v-1h11.6zm4 3h-1v-1l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.3v-.2h-.2v-.2h-.3l-.2-.2h-.5v-.2h-.6v-1h1l.2.2h.4v.2h.3l.2.2h.2v.2h.2v.2l.3.2.2.2v.2l.3.2.2.3v.3l.2.3v.4l.2.2zm-1 0h1zm-3 4v-1h.8l.3-.2h.2l.2-.2.2-.2h.3v-.2l.2-.2v-.2l.2-.2.2-.3v-.3l.2-.2v-.8h1v1.2l-.2.2v.4h-.2v.3l-.2.3h-.2v.3h-.2v.3h-.3l-.3.2v.2h-.3l-.2.2h-.2l-.3.2h-.4l-.2.2h-.8zm-11.5-1h11.6v1H395v-1zm-4-3h1v1l.2.2v.3h.2v.2h.2v.2h.2v.2h.2v.2h.2l.3.2h.2l.2.2.3.2h.6v1h-1.2v-.2h-.3l-.2-.2h-.2l-.2-.2-.2-.2-.3-.2-.3-.3-.2-.3-.2-.3-.2-.2v-.2l-.2-.2v-.4l-.2-.2zm1 0h-1zm3-4v1H394v.2h-.3l-.2.2h-.2v.2h-.2v.2l-.2.2-.2.2-.2.2v.2l-.2.2v.5h-.2v.6h-1v-1.2l.2-.2v-.2h.2v-.3h.2v-.2l.2-.2v-.2h.2l.2-.2v-.2h.3v-.2h.3v-.2h.3l.3-.2h.2l.2-.2h.5l.2-.2h.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m417 579.2.5-11c-4.4-2.2-15.2 0-19.7 10.2a64.7 64.7 0 0 1-18 25.2c10 1.8 18.4-.2 23.7-7.4 7.3-9.8 11.2-15.7 13.6-17z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m418 568.3-.4 11h-1l.4-11 .7-.5zm-.3-.5.3.2v.3zm-19.5 10.8-1-.4.6-1 .5-.8.5-1 .6-.7.5-.8.5-.8.7-.7.6-.6.7-.7.7-.5.7-.6.6-.4.7-.5.8-.4.8-.4.7-.3.8-.3.7-.2.7-.3h.7l.8-.3h1.2l.7-.2h2l.7.2h.5l.6.2.5.2.4.2-.4 1-.4-.3h-.5l-.5-.2h-.5l-.5-.2h-3l-.7.2h-.6l-.7.3-.7.2-.7.2-.7.2-.8.3-.7.3-.7.4-.7.4-.5.5-.7.5-.7.6-.5.6-.6.6-.7.7-.6.6-.5.7-.6.8-.5 1-.3.7zM380 603l-.2 1-.2-.8.6-.6.6-.5.7-.5.6-.6.7-.6.6-.6.5-.6.6-.6.6-.7.6-.7.5-.6.7-.7.5-.7.6-.7.5-.7.6-.8.4-.8.5-.7.5-.8.5-1 .5-.8.6-.8.6-1 .5-.8.6-1 .6-1 .5-1 .5-1 .5-1 .6-1 .5-1.2.5-1.2 1 .4-.6 1.2-.5 1-.6 1.2-.5 1-.4 1-.6 1-.5 1-.5 1-.6 1-.5 1-.6.8-.6.8-.5.8-.5.8-.6.8-.5.8-.6.7-.4.7-.6.8-.6.6-.5.7-.7.7-.6.6-.6.7-.4.6-.6.5-.6.6-.7.7-.6.5-.5.6-.6.6-.8.5-.2-1zm-.2 1h-1l.8-.8zm23.4-8 .8.5-.6.7-.5.6-.7.6-.6.6-.6.6-.5.5-.6.6-.7.5-.7.5-.7.4-.8.3-.7.4-.7.3-.7.3-.7.2-.7.3-.8.2-.8.2h-.8l-.8.2h-.8l-1 .2h-6.1l-1-.2-.8-.2-1-.2.2-1 1 .2.8.2h1l.8.2h6.6l.8-.3h.8l.7-.3.8-.2.7-.2.7-.3.7-.2.7-.2.8-.4.6-.3.7-.3.7-.4.6-.5.6-.5.5-.5.5-.5.6-.5.5-.6.7-.6.5-.7zm13.4-16.8h1l-.2.4-.2.2h-.2l-.3.3-.2.3-.3.2-.2.3-.3.3-.3.4-.3.3-.2.4-.4.5-.3.4-.3.3-.4.5-.3.5-.4.5-.5.6-.3.5-.4.5-.5.7-.5.6-.5.7-.5.7-.5.7-.5.6-.6.8-.6.8-.5.8-.6 1-.7.7-.7 1-.6.8-.8-.6.6-1 .7-1 .6-.7.7-1 .6-.7.6-.8.5-.7.5-.7.5-.7.5-.7.5-.8.5-.6.5-.6.4-.6.4-.6.4-.6.4-.5.4-.5.3-.5.3-.4.4-.5.3-.4.3-.4.3-.3.4-.3.3-.3.2-.2.3-.3.3-.2.4-.2h.2l.3-.2zm1 0v.3h-.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m425.2 580.6-11.8-5c-5 10-8.2 16.6-9.5 20.2-2.8 7-3.5 13.8-2.3 19.5a22 22 0 0 0 14-11.6c3.8-7 6-15.3 9.5-23z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m413.6 575.2 11.7 5-.3 1-11.8-5-.3-.8.6-.2zm-.7.2v-.4l.6.2zm-8.7 20.6-1-.4.2-.3.2-.4.2-.5v-.4l.2-.3.2-.5.2-.4.2-.5.2-.5.3-.5.2-.5.3-.6.2-.5.3-.6.3-.5.3-.7.2-.6.3-.6.3-.7.4-.8.3-.7.4-.8.2-.7.4-.8.4-.8.4-.8.4-.8.4-.8.4-1 .4-.8.5-.8.4-1 .8.5-.4.8-.5 1-.5.8-.4.8-.3 1-.4.7-.4 1-.5.7-.4.7-.3.8-.3.7-.4.6-.3.7-.3.7-.3.6-.2.7-.3.6-.3.5-.3.6-.3.6-.3.6-.2.5-.3.5-.3.5-.2.5-.2.4-.2.5v.5l-.2.4-.2.3v.3l-.3.4zm-2.7 18.8.2 1-.6-.4v-.5l-.2-.7v-.6l-.2-.5v-1.7l-.2-.5v-3.7l.2-.6v-1.2l.2-.7v-.6l.2-.5v-.7l.2-.6.2-.7v-.6l.3-.8v-.6l.3-.7.2-.7.2-.7.2-.7.2-.7.2-.7 1 .4-.3.6v.7l-.4.6-.2.6-.2.6-.2.7v.5l-.3.6v.8l-.3.6v.6l-.2.7v.6l-.2.6v.5l-.2.6v1.9l-.2.5v3.5l.2.5v1.2l.2.5v.7l.2.5-.6-.4zm.2 1h-.5v-.4zm13.5-12.4 1 .5-.5.6-.3.6-.4.6-.3.6-.4.6-.4.5-.5.6-.5.6-.4.5-.4.6-.5.4-.4.5-.5.4-.5.3-.4.4-.6.4-.5.4-.5.4-.5.3-.5.4-.5.3-.4.2-.5.2-.4.2-.5.2-.4.3h-.4l-.5.2-.5.2h-.5l-.4.3h-.5l-.2-1h.9l.4-.3h.4l.4-.3h.5l.4-.3.5-.2.4-.2.5-.2.5-.2.5-.3.5-.3.4-.3.4-.4.4-.3.5-.4.4-.4.4-.4.6-.4.4-.5.4-.4.5-.6.3-.4.4-.5.4-.6.5-.6.4-.5.2-.7.4-.6.4-.6.3-.6zM425 581l.3-.8.3.6-.3.7-.3.8-.3.7-.3.7-.3.8-.2.7-.3.7-.2.7-.3.7-.3.8-.3.7-.2.6-.3.8-.4.7-.3 1-.2.6-.2.7-.3.8-.3.8-.2.7-.3.7-.3.8-.3.7-.2.7-.3.7-.3.8-.3.7-.5.7-.3.7-.3.6-.5.6-.3.7-1-.6.5-.6.3-.7.3-.6.3-.6.4-.7.3-.6.3-.7.3-.7.2-.7.3-.7.2-.7.3-1 .3-.6.3-.7.3-.7v-.8l.4-.7.3-.7.3-.8.2-.7.3-.7.3-.8.3-.7.3-.7.3-.7.3-.7.2-1 .3-.6.3-.8.3-.7.4-.8.3-.8zm.3-.8.5.2-.2.4z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m428.6 580.6-12.7-2c-2.4 10.8-4 18-4.4 22-1 7.5 0 14 2.7 19.4 4.3-2.3 8.8-7 10.7-14.7 2-7.8 2.2-16.3 3.6-24.7z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m416 578.2 12.6 2v1l-12.8-2-.4-.6zm-.6.4v-.5l.6.2-.6.4zm-3.3 22h-1l.2-.5V599l.2-.6v-.5l.2-.6v-.5l.2-.6v-.6l.2-.5v-.6l.2-.6v-.6l.2-.6.2-.7v-.6l.3-.7v-.7l.2-.8v-.8l.3-.8.2-.8v-.8l.3-1 .2-.7.2-1 .2-.8.2-1 .2-1 .2-1 .2-1 1 .3-.2 1-.2 1-.2 1-.2 1-.2.8-.2 1-.2.7-.2 1-.2.7v.8l-.3.8-.2.8v.8l-.2.7v.6l-.2.7-.2.7v.6l-.2.6-.2.7v.4l-.2.6v.6l-.2.5v1.1l-.2.6v.4l-.2.4v1.2zm2 19 .5.8-.7-.2-.2-.5-.3-.5-.2-.5v-.6l-.3-.4-.2-.5-.2-.5-.2-.6v-.6l-.2-.6v-.6l-.3-.6v-.6l-.2-.6v-.6l-.2-.6v-2.8l-.2-.6v-5.4l.2-.7v-1.5h1v3.1l-.2.7v5.1l.2.6v1.2l.2.6v.6l.2.6v.6l.3.6v.5l.2.6v.7l.3.5v.5l.3.6.2.5.2.5.2.5.3.5.2.5-.7-.2zm.5.8-.5.3-.2-.5zm10-15.2 1 .2-.2.7-.2.8v.7l-.3.7-.3.7-.2.5-.3.6-.4.7-.3.6-.3.6-.3.4-.3.6-.4.5-.3.5-.4.5-.4.5-.4.4-.4.5-.4.3-.4.4-.4.4-.4.5-.4.3-.4.4-.4.3-.4.3-.4.3-.4.4-.5.3-.4.3-.4.2-.5.2-.5-.8.4-.2.4-.3h.4l.4-.4.4-.3.4-.3.4-.3.4-.3.4-.3.4-.3.3-.3.4-.4.4-.4.5-.4.3-.4.4-.5.3-.4.4-.6.2-.5.3-.6.3-.5.3-.6.4-.6.3-.5.3-.6.2-.6.3-.5.2-.6.3-.8.2-.7.2-.6zm4-25v1l.5-.5v.8l-.2.8v.7l-.2.8v.8l-.2.8v.8l-.2.8v.7l-.2.8v.8l-.2.8v1.7l-.2.7v.8l-.2.8v.8l-.2.8v.7l-.2.8v1l-.2.6v.8l-.2.8-.2.7v.7l-.2.7-.2.8v.7l-.3.7-.2.7-1-.2.2-.8.2-.7v-.7l.2-.8v-.7l.3-.7v-.8l.2-.8v-.7l.2-.8v-1.5l.2-.8v-.7l.2-.8v-1l.2-.7v-.7l.2-.8v-1.6l.2-.8v-.8l.2-.7v-1l.2-.7v-.8l.2-.8v-.8l.2-1v-.7l.3-.8.5-.4zm-.4.3v-.4h.5l-.4.5zm.5.6v-1z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "M430.4 563.4h7.6c4.4 2 9 12.2 3.7 22a65.8 65.8 0 0 0-9.5 29.2c-7.4-6.8-10.8-14.7-8.2-23.3 3.4-11.7 6.8-25.2 6.4-28z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M438 564h-7.6v-1h7.8zm0-1h.2zm4 22.5-.8-.5.5-1 .4-.8.4-.8.3-1 .3-.8.2-1v-.7l.3-1V574l-.2-1v-.6l-.3-.8-.2-.7-.3-.8-.2-.7-.3-.6-.3-.7-.3-.6-.3-.6-.3-.4-.3-.5-.4-.3-.4-.4-.3-.4-.4-.4-.5-.3-.4-.3-.3-.2.5-1 .4.4.5.2.5.4.4.4.4.4.4.4.4.5.4.6.3.6.3.6.3.6.3.7.2.7.3.7.2.6.2.8v.7l.3 1v.8l.2.8v3.5l-.2 1v1l-.4.8-.3 1-.3 1-.4.8-.4 1-.5 1zM432 615l.5-.7-.8.3v-.8l.2-1v-2.3l.3-1v-.7l.2-.8.2-1 .2-.8v-1l.2-.7.3-1 .2-.8.2-1 .2-.7.3-1 .3-.8.3-1 .4-1 .4-.8.4-1 .4-1 .4-1 .4-1 .5-1 .4-1 .5-1 .5-1 .5-1.2.6-1 .6-1.2 1 .5-.7 1-.6 1.2-.7 1-.5 1-.5 1.2-.5 1-.4 1-.5 1-.5.8-.4 1-.3 1-.3 1-.4.8-.3 1-.3.8-.2.8-.3 1-.4.8-.2.8-.2 1-.2.7-.2 1v.7l-.3.8v1l-.3.7v.8l-.2.8v1l-.2.7v1.8l-1 .2zm.7-.3v1l-.8-.7.7-.3zm-9.2-23.6 1 .4-.3.8-.2.8v.8l-.2.7v.8l-.2.8v3l.2.8.2.8v.7l.3.7.3.7.2.8.3.7.4.7.4.6.3.7.5.7.4.7.4.7.5.6.4.7.5.7.4.6.6.7.6.6.6.7.7.6.5.7-.6.7-.8-.6-.7-.7-.6-.7-.7-.6-.6-.7-.6-.7-.4-.7-.6-.7-.4-.7-.5-.8-.3-.7-.5-.7-.3-.8-.5-.7-.3-.7-.3-.8-.4-.7-.2-.7-.2-.8-.2-.7v-.8l-.2-.8v-.8l-.2-.8v-2.5l.2-.8v-.8l.3-.8.3-1 .2-.7zm7-28v1l.4-.7v1.8l-.2.5v1.1l-.2.7-.2.7v.8l-.3.8v.8l-.2 1-.2.8-.2 1-.3 1v1l-.4 1-.2 1-.3 1-.2 1-.2 1-.3 1.2-.3 1-.3 1.2-.3 1-.3 1.2-.3 1.2-.3 1-.3 1.2-.2 1-.4 1.2-1-.3.4-1 .3-1 .5-1.2.3-1 .3-1.2.4-1.2.3-1 .3-1.2.3-1 .3-1.2.3-1 .2-1 .2-1 .3-1.2.2-1 .2-1 .2-1 .2-.8.2-1 .2-.8.2-.8v-.8l.3-.7v-.8l.2-.7v-.6l.2-.6v-2l.4-.6zm-.6.5v-.6h.4l-.5.5zm.4 0v-.6.4zm-.5 0v-.6h.4l-.5.5z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m433.8 558.2-12-4.3c-4.3 10-7.2 16.8-8.4 20.5-2.3 7.3-2.6 14-1 19.6a21.3 21.3 0 0 0 14-11.6c3.3-7.3 4.5-16.3 7.4-24.2"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m422 553.4 12 4.3-.4 1-12-4.4-.3-.6zm-.7.3.2-.4h.4l-.7.4zm-7.4 21-1-.3v-.4l.2-.4v-.4l.3-.4v-.4l.3-.5.2-.5v-.5l.3-.5.2-.5.2-.6.3-.6.2-.5.2-.6.3-.6.2-.6.2-.6.3-.7.3-.6.3-.7.4-.7.3-.8.3-.8.3-.7.4-.8.3-1 .4-.8.3-1 .4-.8.5-1 .4-.8.3-1 1 .5-.5 1-.4 1-.4.8-.3 1-.4.8-.4.8-.4.8-.3.8-.4.8-.4.8-.3.7-.3.8-.3.8-.3.7-.3.6v.8l-.4.6-.2.6-.3.6v.6l-.3.6-.2.5-.2.5-.2.5v.5l-.3.5-.2.4v.5l-.3.4v.3l-.2.3v.4zm-1.8 19 .3 1-.6-.4-.3-.6v-.5l-.2-.6v-.5l-.2-.5v-.6l-.2-.7V583l.2-.7V581l.3-.6v-.7l.2-.6v-.6l.3-.6.2-.7v-.6l.3-.7.2-.6.2-.6 1 .3-.3.6-.2.7-.2.7-.2.6v.7l-.2.6v.7l-.2.6-.2.6v.6l-.2.6v1l-.2.7v6.5l.2.6v1.1l.2.4.2.6v.5l.2.5zm.3 1h-.5v-.4l.5.3zM426 582l.8.6-.3.6-.4.7-.2.5-.4.6-.4.7-.4.6-.4.5-.4.5-.4.5-.5.5-.5.5-.5.4-.4.4-.5.4-.4.4-.4.4-.5.3-.5.5-.5.3-.5.3-.5.4-.4.2-.5.3h-.5l-.5.4-.5.2-.5.2-.5.2h-.4l-.6.3-.4.2h-.5l-.3-.8.4-.2h.5l.5-.3.5-.2h.4l.5-.3.4-.2.4-.3.5-.2.5-.2.5-.3.4-.3.5-.3.5-.4.4-.3.6-.3.4-.4.5-.3.4-.4.4-.5.4-.4.4-.4.4-.4.4-.5.4-.5.4-.5.4-.5.4-.6.3-.6.3-.6.3-.6.3-.7zm7.6-23.4.4-1 .3.7-.3.8-.3.8-.2.8-.3.7-.2.8-.2 1-.2.6-.2.8-.3.8v.8l-.3.7-.2.8-.2.8-.2.8v1l-.3.6-.2.8-.2.8-.2.8v.7l-.3.8-.2.8-.3.7-.2.8-.2.7-.3.8-.3.7-.2.7-.3.8-.3.7-.3.7-.2.6-1-.5.4-.5.3-.7.3-.7.3-.6.3-.7.3-.8.2-.8.2-.7.3-.8.2-.7.2-.8.2-.7v-.8l.4-.8.2-.8.2-.8.2-.8.2-.8.2-.7.2-.7.2-.8.2-.8.2-.8.2-1 .2-.6.2-.8.3-.8.3-.8.2-.7.3-.8.3-.8.3-.7.3.6zm.4-1 .4.3v.3zm-.2.6-.2.4zm.2-.5.4.2v.3l-.4-.6z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#fff",
              d: "m425.6 549.7-2.6-16.4c-2.8-.7-6.5 5.8-10 9.5-1 1-2 1.7-2.6 2.8a23.3 23.3 0 0 0-3.4 8 62.3 62.3 0 0 1-13 27.6c10.2-.2 18-3.8 21.8-12 5-11 7.7-17.7 9.8-19.5"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m423.4 533.3 2.7 16.4h-1l-2.5-16.3.6-.6.4.5zm-.3-.4h.4v.2l-.3-.4zm-9.7 10.2-.8-.7.4-.4.2-.2.3-.4.4-.4.2-.4.3-.4.4-.4.2-.5.3-.4.4-.5.2-.4.3-.3.4-.5.2-.4.3-.4.4-.3.2-.3.3-.4.3-.3.4-.3.3-.4.3-.2.3-.2.4-.2.4-.3h.3l.4-.3h.3l.4-.2h1.1l-.2 1h-1l-.3.2-.2.2-.3.2-.3.2-.3.2-.3.3v.4l-.5.3-.3.3-.3.3-.4.4-.3.4-.3.5-.4.4-.3.3-.3.4-.3.4-.4.5-.3.5-.3.4-.4.4-.3.4-.4.4-.3.4-.4.4-.4.4-.3.4zm-2.5 2.7-.8-.7v-.2h.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l1 .6h-.2l-.2.2v.2h-.2v.2h-.2l-.2.2v.2h-.2l-.2.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.2zm-3.3 7.7-1-.2v-.6l.2-.4v-.3l.2-.3v-.8l.2-.3v-.3l.2-.3v-.3h.2v-.4l.2-.3v-.2l.2-.2v-.2l.3-.3v-.2l.2-.2v-.2l.3-.2v-.3h.2v-.3l.3-.3v-.2l.3-.2v-.2l.2-.3.2-.2.8.6-.3.3v.2l-.2.2-.2.2v.4l-.2.2-.2.2v.3l-.2.3v.2l-.2.3-.2.2v.2l-.2.3v.2l-.2.3v.2l-.2.3v.2l-.2.3v.5l-.2.3v.2l-.2.3v.5l-.2.3v.7zm-13.4 27v1l-.3-.8.5-.8.5-.7.5-.6.5-.8.5-.7.5-.7.4-.6.6-.7.4-.7.5-.8.4-.7.4-.7.4-.8.4-.7.4-.7.4-.8.4-.8.4-.8.4-1 .4-1 .3-.8.3-1 .3-.8.4-1 .3-1 .4-1 .3-1 .3-1.2.3-1 .3-1.3.2-1.3.3-1.2 1 .2-.3 1.2-.3 1-.4 1.3-.3 1.2-.4 1-.4 1-.3 1.2-.4 1-.4 1-.4 1-.3 1-.5.8-.4 1-.3.8-.4.8-.4 1-.5.8-.4.8-.3.7-.5.8-.4.8-.5.8-.4.7-.6.7-.5.7-.5.7-.5.7-.5.8-.5.7-.5.6-.5.8-.5.7-.4-.8zm0 1h-1l.7-.8zm21.3-12.8 1 .4-.5.7-.4 1-.4.6-.4.7-.5.7-.4.6-.5.6-.5.6-.5.6-.6.5-.6.4-.6.5-.7.4-.6.4-.8.4-.7.4-.7.4-.7.3-.7.3-.8.3-.8.2-.8.2-1 .2-.7.2-1 .2-.7.2h-1l-.8.2h-1l-.8.2h-2v-1h2.8l1-.2h.8l.8-.2 1-.2h.7l1-.3.7-.2.7-.3.8-.2.7-.3.7-.3.7-.3.6-.3.7-.3.6-.4.7-.5.6-.4.6-.4.5-.4.6-.6.5-.5.5-.4.5-.6.5-.6.4-.7.5-.6.4-.6.3-.7.3-.8zm9.8-19.2h1v.3l-.3.3v.2l-.3.2-.2.2-.2.2-.2.3-.3.4-.2.2-.2.4v.4l-.4.5-.2.5-.3.5-.2.5-.3.6-.2.6-.3.6-.3.6-.4.7-.3.8-.3.8-.4.7-.3.8-.4 1-.4.7-.4 1-.4.8-.4 1-.4 1-.5.8-.3 1-.5 1-1-.4.6-1 .4-1 .5-1 .4-1 .5-1 .4-.8.3-1 .4-.7.4-.8.4-.8.4-1 .3-.6.4-.7.4-.7.3-.6.4-.7.3-.6.2-.4.2-.6.3-.5.2-.5.3-.4.2-.5.3-.3.2-.4.2-.3.2-.4.2-.3.2-.3.2-.2.3-.2.3-.2-.2.4zm1 0v.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx208("use", {
          xlinkHref: "#rs_svg__d",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 0)"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#fff",
          stroke: "#21231e",
          d: "M536.4 415a38 38 0 0 0 4.8-1.5 66.2 66.2 0 0 1-21.4-22c-7.8-12 3.3-33 8-44.3a53 53 0 0 0 21.2-31c1-7.3-19-4.7-33 2-17 8-19.3 5.7-25.4 7-2.2 10.5 2.4 11.4 6.7 11-9.4 15-13.3 29.8-15 51.4-2-21.6-6-36.5-15.3-51.5 4.3.6 9-.3 6.7-10.7-6-1.4-8.4.8-25.4-7.2-14-6.5-34-9-33-1.8 3 13.7 11.8 24 21.3 31 4.6 11.2 15.7 32.4 8 44.2a67.3 67.3 0 0 1-21.5 22c1.7.7 3.3 1.2 5 1.5-1.2 1.5-11 4.5-12.3 3.7-7.6-5.3-15-18-21.4-25.2-18.2-20.8-27.3-36.7-24-49.6 4.5-14 20.8-29.6-.8-27-21.7 2.8-39.6 32.5-45.4 68.3-2 13.2-3.3 24.4-4.7 33.5 11.8-4.3 17-8.5 20.2-13.7-1.4 5-2.5 9.7-3.2 14.2 9.7-1.7 16.7-6.4 19.2-15 1-3.6 2.3-6.5 3.6-9 3 1 7 1 11.6 0 1.7 4 15 19 22.2 30 8 12.2 20.2 21.6 24.2 22 2 .4 2.7-4 2.2-10.2 21 .2 42.3.3 63-.4 20.7.7 41.8.6 63 .4-.6 6 0 10.6 2 10.3 4-.5 16.2-10 24.3-22.2 7-10.8 20.5-25.7 22.2-30a20 20 0 0 0 11.6.2c1.3 2.5 2.5 5.4 3.5 9 2.5 8.6 9.5 13.3 19.2 15-.7-4.5-1.8-9-3.2-14 3.2 5 8.4 9.3 20.2 13.6-1.4-9-2.7-20.3-4.8-33.5-5.8-35.8-23.7-65.5-45.4-68.2-21.6-2.6-5.3 13-.7 27 3.3 12.8-5.8 28.7-24 49.5-6.5 7.3-13.8 20-21.4 25.2-1.2.8-11-2.2-12.2-3.8z"
        }),
        /* @__PURE__ */ jsxs201("g", {
          id: "rs_svg__e",
          children: [
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M440.6 356.8c-2 1.8-8.8 1.8-18 2.4-14.8.5-23.4-4-25.3-13.5 5.6 6.6 12.2 10 19.7 8 10.2-2.5 16-4.3 18.3-3.8 1.6.4 4 3.3 5.3 6.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M422.6 359.7v-1h1.8l.7-.2h2.5l.8-.2h2.8l.8-.2h3l.5-.2h1l.4-.2h.5l.4-.2h.4l.5-.2h.3l.3-.2h.4l.3-.2h.2v-.3h.3l.6.7h-.3l-.3.3-.3.2h-.2l-.3.3h-.4l-.3.2h-.4l-.4.2h-.5l-.5.2h-1l-.5.2h-1.5l-.6.2H432l-.6.2h-2.8l-.8.2h-2.3l-1 .2H423zm-25-14.3-.7.6.8-.4.2 1 .2.7.3.8.3 1 .3.6.5.7.4.7.4.6.5.6.4.6.6.6.6.5.6.4.7.5.6.3.8.5.8.4.8.3 1 .4.8.2 1 .3 1 .2 1 .2h1l1 .3h1.2l1.2.3h6.6v1H416l-1-.2h-1.3l-1-.3h-1.2l-1-.3-1-.3-1-.3-1-.2-1-.4-.8-.3-.8-.4-1-.4-.7-.5-.7-.5-.7-.5-.7-.6-.6-.5-.6-.6-.4-.8-.5-.7-.3-.7-.4-.8-.4-.7-.4-1-.3-.7-.3-1-.2-.8 1-.4zm19.3 8 .2 1h-.8l-.7.2h-1.4l-.7.2h-2.8l-.6-.2-.7-.2h-.7l-.6-.3h-.7l-.6-.3-.8-.3-.6-.3-.6-.2-.6-.3-.6-.4-.6-.3-.6-.4-.6-.4-.6-.6-.6-.4-.6-.5-.5-.6-.6-.6-.4-.6-.6-.5-.5-.6-.6-.7.7-.6.5.6.5.6.6.6.5.5.5.5.6.5.4.5.6.5.6.4.5.5.7.4.6.3.6.3.4.3.6.2.6.3.6.2.7.2h.5l.6.3.7.2h.6l.7.2h4.7l.6-.3h.7zm18.5-4-.3 1h-2.6l-.4.2h-.9l-.5.2-.5.2h-.5l-.6.2h-.5l-.6.3h-.5l-.7.3-.7.2h-.6l-.7.3-.7.2-.8.2-.8.2h-.8l-.8.3-1 .3-.8.2-1 .2-.8.3-.3-1 1-.2.8-.2 1-.2.7-.2 1-.2.7-.2.8-.2.7-.2.8-.2.7-.2.7-.2.6-.2h.6l.6-.3h.6l.6-.3h.6l.5-.2h.6l.5-.2h.6l.4-.2h.9l.3-.2zm5.4 7.8-.7-.8-.2.6v-.7l-.3-.3v-.3l-.3-.3v-.3l-.3-.2v-.3l-.2-.2-.2-.3v-.3l-.3-.2-.2-.3v-.2l-.2-.2-.2-.3v-.2l-.3-.2h-.2v-.3h-.2l-.2-.3v-.2h-.3l-.2-.2v-.2h-.2v-.2h-.4v-.2h-.2l.3-1h.2l.2.2.2.2h.2l.2.2.2.2h.2v.3l.3.2.2.2h.2l.2.3v.2l.2.2.2.2.2.2.2.2.2.3v.2l.3.2.2.3.2.3v.3l.3.4.2.3v.3l.3.3v.3l.3.3v.3l.2.3v.6zm0-.6.2.3-.3.2v-.6zm-21.5-35.4v1.5h-.4v-.4h-.2v-.7l.2-.2h.2v-.2zm15.3 4-.5 1.3-.6-.2-.5-.2h-.6l-.5-.2-.4-.2-.5-.2-.4-.2-.5-.2-.4-.2h-.5l-.4-.3-.5-.2h-.4l-.4-.3h-.5l-.4-.3h-.5l-.4-.2h-.4l-.5-.2h-.4l-.3-.2h-1.3l-.4-.2H420v-2h2.9l.5.2h1l.4.2h.5l.3.2.5.2h.5l.4.2.5.2h.5l.4.3h.6l.5.3.6.2h.5l.6.3.5.2.6.2h.5l.6.3.6.2.5.2.6.2h.5zm9 2.5v1.5H442l-.3-.2h-.4l-.3-.2h-.3l-.4-.2h-.3l-.4-.2h-.4l-.3-.2h-.5l-.3-.2-.4-.2h-.3l-.4-.2h-.2l-.3-.2h-.3l-.3-.3h-.7l-.2-.2h-.4l-.2-.2.4-1.5h.2l.2.2h.2l.2.2h.3v.2h.4l.3.2h.3l.3.2h.4l.3.2.3.2h.4l.3.2h.4l.3.2h.4l.4.2h.3l.4.2h.4l.3.2h.6l.3.2zm0 1.5v-1.5h.4v.2h.2v.2h.2v.9h-.2v.2h-.2v.2h-.2zm23.4 7.5.2-1.2h.2v.2h.2v.8h-.6zm-10-2 .4-1.2h.5l.3.2h.4l.3.2h1.1l.2.2h.6l.2.2h.6l.3.2h.7l.4.2h.8l.3.2h.9l.2.2h.9l.5.2h.8l-.2 1.3h-.9l-.4-.2h-.6l-.4-.2h-.7l-.4-.2h-1.4l-.3-.2h-.7l-.3-.2h-.6l-.3-.2h-.5l-.4-.2h-.5l-.3-.2h-.5l-.2-.2h-.5l-.2-.2zm.4-1.2-.3 1h-.2v-.8h.8z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m431.5 332-.7 1.3-.4-.3-.4-.2-.4-.3-.3-.2-.4-.3-.4-.3-.3-.3-.4-.3-.4-.2-.3-.4-.3-.3-.2-.3-.3-.3-.3-.4-.2-.3-.3-.4-.2-.3-.3-.4-.2-.4-.2-.3-.3-.5-.2-.4-.2-.2v-.4l-.3-.4-.2-.3-.2-.4-.2-.3v-.4l-.2-.3-.2-.3-.2-.4 1.4-.7.2.2.2.4v.3l.3.2.2.4.2.3v.3l.3.3.2.4.2.3.2.4v.3l.3.4.3.3.2.4.2.4.2.4.3.3.2.4.3.4.2.3.3.4.3.3.3.3.3.2.3.3.3.3.2.2.4.3.3.2.2.2.3.2zm7.6-5.3 1.5.8-.2.4-.2.3-.2.4-.2.4-.3.5-.3.4-.2.2-.3.4-.3.3-.3.2-.3.3-.3.3-.3.3-.2.4-.3.2-.3.2-.4.2-.3.2-.3.2h-.3l-.5.2h-.3l-.3.2h-2.2l-.4-.2-.3-.2h-.2l.7-1.5h.5l.2.2h1.7l.3-.2h.2l.3-.2h.2l.3-.3.2-.2.3-.2h.2l.3-.3.2-.3.3-.2.2-.3.3-.4.2-.3.3-.3.2-.4.2-.3.3-.4.2-.5.2-.4v-.3z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m429.6 331-2.2-2.3c-1-1.3-.5-3 2-5.4 1.5.7 3 1.3 4.2 2-1 3-2.2 4.8-4 5.6zm-6.3 82-.4 1h-.4v-1zm23.8-3.6 1 1-.7.5-.6.4-.7.5-.6.4-.7.5-.7.3-.7.4-.7.4-.7.4-1 .3-.6.3-.8.2-.7.2-1 .2-.7.2h-.8l-.8.2h-5l-1-.2h-.8l-.8-.3h-1l-.8-.4h-1l-.7-.3-1-.3-.8-.3.3-1 .8.2 1 .3 1 .3.7.2 1 .2.7.2h.8l1 .2h.7l.7.2h4.8l.7-.2h1l.6-.3.7-.2h.7l.7-.4.7-.3.7-.3.8-.3.6-.4.7-.4.7-.5.6-.5.6-.5.5-.5zm3-2.8 1 .8h-.2v.2h-.2l-.2.2v.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2v.2h-.2l-1-.8h.2v-.2h.2v-.2h.2l.2-.2.2-.2.2-.2v-.2h.2v-.2h.2l.2-.2.2-.2.2-.2v-.2h.2l.2-.2.2-.2v-.2zm1 .8-1-.8.2-.2h.7v.2h.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m452.2 401.3-1.2-.2v-.2h.2l.2-.2h.6v.4h.2zm-5.5 16 .3 1-.7-.8.2-.4.2-.4.2-.5v-.4l.3-.4.2-.5.2-.5v-.5l.3-.4.2-.5.2-.5v-.5l.3-.5v-.5l.3-.5v-.5l.3-.5v-.5l.3-.5v-.5l.2-.5.2-.6v-.5l.2-.6v-.5l.2-.4v-.6l.2-.6v-.5l.2-.7v-.6l.2-.6 1.2.3v.6l-.2.5v.6l-.2.6v.6l-.2.6v.5l-.2.6-.2.4v.6l-.2.5v.6l-.3.6v.5l-.3.6v.6l-.3.5v.5l-.2.5-.2.5v.5l-.3.5-.2.5v.5l-.2.4-.2.5-.2.6-.2.5-.2.6-.2.5-.2.5-.2.5-.7-.8zm-.4.2 1 .5v.2h-.2v.2h-.4l-.2-.2v-.2h-.2v-.4zm15.2-9.5 1 .7-.3.4-.4.6-.3.4-.4.4-.2.4-.4.4-.4.4-.4.4-.4.3-.4.4-.5.3-.4.4-.6.3-.4.3-.5.3-.5.3-.5.3-.5.2-.5.3-.5.3-.6.2-.5.3-.7.2-.5.3-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.3-1.2.6-.2h.6l.5-.3.6-.2.6-.2.6-.2h.6l.5-.3.6-.3.4-.2.5-.2.4-.3.5-.2.4-.3.5-.3.4-.4.5-.3.3-.3.5-.3.4-.3.4-.3.4-.2.4-.4.4-.3.4-.3.4-.3.3-.4.3-.4.3-.4.3-.4.2-.4.3-.4zm1 .7-1-.7h.2v-.2h.7v.2h.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "M461.3 400.2H460v-.2h.2v-.2h1v.4zm4.4 15.7.7 1-.8-.3-.3-.4-.3-.4-.2-.5-.3-.5-.2-.4-.3-.4-.2-.5-.3-.5-.2-.4-.2-.5v-.5l-.3-.5-.2-.5-.2-.5-.2-.5v-.5l-.2-.5-.2-.5v-.6l-.3-.5v-.5l-.3-.6v-.4l-.2-.6v-.6l-.2-.5v-.7l-.2-.6v-.6l-.2-.5v-1.2h1v.5l.2.6v.6l.2.5v1.4l.2.5.2.6v.5l.2.5v.6l.3.5v.4l.2.5.2.4v.5l.2.4.2.5.2.4.2.5.2.4.2.4.2.5.2.4.2.5.3.4.3.4.2.4.3.5.2.3.3.4.3.3h-1zm0 .7 1-.7v.8l-.2.2h-.2v.2h-.4v-.2h-.2zm7.6-12.6 1 .4v.6l-.2.5v.5l-.2.5-.2.5-.2.5-.2.5-.2.5-.2.4-.2.4-.2.4-.3.5v.4l-.4.4-.2.5-.3.4v.3l-.4.3-.3.4-.3.4-.2.3-.3.3-.3.4-.3.3-.4.3-.3.3-.3.3-.3.2-.3.3-.3.4-.3.2-.3.3-.7-1 .3-.3.3-.2.3-.3.3-.2.2-.3.3-.3.2-.2.3-.3.3-.4.3-.3.2-.4.3-.4.4-.3.2-.4.3-.4v-.4l.4-.3.2-.5.3-.4v-.3l.3-.4.2-.4.2-.6.2-.4v-.5l.3-.4.2-.4.2-.5v-.4l.3-.5v-.4zm1 .4-1-.3v-.2h.8v.2h.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#edb92e",
              d: "M406 317.8c-16.7 1.8-16 12.6-.4 28 3 3 4 3 4.6-.2 1.2-5.3 7-8.5 10.2-4.4 2 2.7 1.6 4.3 8.6 3.3 9 7.5 16.2 12.8 4.5 12.3-5-.2-9 2.8-15.7 2.5 2 4 2.3 4.3 3.4 4.6 6.5 1.2 13.3-2.8 19.8-1.6 14.3 2.6-23-38.6-22.4-40.3 1-4-9-11.5-12.7-4.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m406 345.5-.7.7-1.4-1.5-1.5-1.4-1.2-1.4-1.2-1.4-1-1.3-1-1.3-.8-1.3-.8-1.2-.8-1.2-.6-1.2-.5-1-.5-1.2-.3-1-.3-1v-1l-.2-1v-1l.2-1 .2-.8.4-.8.4-.8.6-.7.6-.7.8-.6.8-.6 1-.5 1-.5 1-.4 1.4-.4 1.3-.3 1.3-.2 1.6-.2v1l-1.5.2-1.4.2-1.2.3-1.2.3-1 .4-1 .5-1 .4-.6.5-.7.7-.6.6-.4.6-.4.6-.4.7-.2.8-.2 1v1.7l.2.8.2 1 .4 1 .4 1 .5 1 .5 1.3.7 1 .8 1.3 1 1.4.8 1.2 1 1.3 1.2 1.3 1.2 1.3 1.4 1.4 1.4 1.5zm3.8 0 1 .2v.3l-.2.3v.5l-.2.2v.2l-.2.2v.2l-.2.2-.3.3v.2h-.3l-.2.2H408l-.2-.2h-.2l-.2-.2h-.2l-.2-.3-.2-.2h-.2l-.3-.4h-.2l-.2-.3-.3-.3-.2-.2.7-.7.2.2.3.3.2.2.3.2.2.2.2.2h.2l.2.2.2.2h.3v.2h.6l.2-.2v-.2l.2-.2v-.2l.2-.4v-.4l.2-.3zm11-4.6-.8.5-.3-.4h-.3l-.3-.4-.2-.2-.3-.2h-.3l-.3-.2h-.5l-.3-.2h-1.5l-.3.2-.4.2h-.2l-.4.3-.3.2-.2.2-.4.2-.3.2-.2.3-.3.3-.2.4-.3.3-.2.4-.3.5-.2.4-.2.3v.5l-.2.4v.5l-1-.2v-.5l.2-.5.2-.5.2-.5.3-.5.2-.4.2-.4.3-.4.3-.4.3-.4.4-.3.4-.3.4-.3.4-.2.3-.2.3-.2.5-.2h.4l.4-.2h.4l.4-.2h1l.4.2h.6l.4.3.4.3.3.2.4.3.4.5.4.4zm8.6 3.2-.7.7h.4-.5l-.6.2h-4.5l-.2-.2h-.3l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2h-.2v-.3l-.3-.3v-.2l-.3-.2v-.2h-.3l-.2-.3-.2-.3v-.2l-.3-.2v-.3l-.3-.2.8-.6h.2v.4l.3.2.2.3.3.3v.2l.2.2.2.2.2.2.2.2.2.2h.2v.2h.3l.2.2h.2l.2.2h5.4zm-.4 0 .2-.2.2.2zm4.5 13v-1h4.1l.5-.2h.4l.3-.3h.2v-1l-.2-.3-.2-.4-.3-.5-.4-.4-.5-.4-.4-.4-.4-.5-.6-.5-.6-.6-.6-.6-.7-.5-.6-.6-.7-.7-.7-.7-.8-.6-.8-.7-.8-.7-1-.7.8-.8.8.7.8.5.8.7.8.7.7.5.8.6.8.7.7.6.6.6.7.4.6.6.5.5.5.5.4.5.4.4.4.4.3.4.2.4v2.3l-.4.3-.3.2-.4.3-.6.2h-.6l-.7.2h-3.6zm-15.2 2-1 .4.5-.8h3.4l.6-.2h.5l.5-.2h.5l.5-.2h.5l.4-.2h.5l.5-.2.4-.2h.6l.4-.2.5-.2h.4l.4-.2h.5l.3-.2h.5l.4-.2h.5l.5-.2h2.6v1H431l-.4.2h-.9l-.4.3h-.8l-.4.2h-.5l-.4.3h-.6l-.5.2h-.5l-.5.3h-.5l-.5.2h-.5l-.5.2h-.5l-.6.2h-.6l-.6.2h-3l.5-.7zm-1 .4-.3-.8h.8l-.4.8zm4 4-.2.8h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.3-.2-.2-.3-.3-.2-.2v-.2h-.2v-.4l-.3-.2v-.3h-.3v-.4l-.3-.3v-.4l-.3-.4 1-.5v.5l.2.3.2.3v.4l.3.3.2.2v.2l.3.2v.2l.2.2v.2h.2v.3l.2.2v.2l.2.2h.2v.2h.4v.2h.4zm19.8-1.7v1l-.7-.2h-4.7l-.6.2h-.7l-.6.2h-.7l-.6.2-.6.2h-.6l-.6.2h-.7l-.7.3-.6.2h-.6l-.6.2h-.6l-.6.2h-4.6l-.6-.2.3-1 .6.2h4.8l.6-.2h.6l.5-.2h.6l.7-.2.7-.2h.6l.6-.2.6-.2h.7l.5-.2h.6l.7-.2h.7l.6-.2h4.9zm-23-40 1 .3.3.3.5.7.6.8.8 1.2 1 1.2 1 1.3 1 1.5 1.3 1.5 1.3 1.7 1.4 1.8 1.4 1.8 1.5 1.8 1.5 2 1.5 1.8 1.4 2 1.4 2 1.3 1.7 1.3 2 1.2 1.7 1 1.7 1 1.6.8 1.5.6 1.4.4 1.3.3 1.2v2l-.6.7-.8.5H441v-1h2l.4-.3.3-.4V360l-.3-1.2-.4-1.2-.6-1.3-.8-1.5-1-1.6-1-1.7-1-1.8-1.3-1.8-1.4-2-1.4-2-1.4-1.8-1.5-2-1.4-1.8-1.5-1.8-1.4-1.8-1.3-1.8-1.3-1.6-1.2-1.6-1-1.5-1.2-1.3-1-1.2-.7-1-.6-1-.5-.7-.3-.4v-.6zm-12-3.7v-1l-.5.2.4-.6.3-.7.5-.6.5-.4.5-.3.6-.3.5-.2.5-.2h2.6l.6.2.6.2.5.3.6.2.6.3.4.4.5.2.4.4.4.4.5.5.4.4.3.4.3.4.3.5.2.5.2.5v.5l.2.5v1l-1-.3v-1l-.2-.4v-.4l-.3-.4-.2-.4-.3-.4-.3-.4-.5-.4-.3-.4-.5-.4-.4-.4-.5-.3-.4-.3-.5-.3h-.7l-.5-.3-.5-.2h-.5l-.6-.2h-2l-.4.3-.5.2-.4.3-.5.5-.4.4-.3.4-.3.6-.4.3zm.4-.3-.2.2h-.2zm-.5-.2v.5zm.4.2-.2.2h-.2z"
            }),
            /* @__PURE__ */ jsx208("path", {
              fill: "#21231e",
              d: "m407 317.2-1.3.4v-.6h.2v-.2h.8v.2h.2v.2zm7.6 10.6-.8 1-.4-.4-.3-.4-.3-.3-.3-.3-.4-.3-.3-.2-.3-.4-.3-.3-.2-.2-.3-.4-.3-.3-.3-.2-.4-.4-.3-.3-.2-.2-.2-.4-.2-.3-.3-.3-.2-.3v-.4l-.4-.3-.2-.4-.2-.4-.2-.4-.2-.4v-.4l-.3-.3-.2-.4v-.3l-.3-.3v-.4l-.3-.4 1.2-.4v.7l.3.3v.3l.3.4v.3l.3.4v.3l.3.4.2.3.2.3.2.4v.3l.3.3.2.4.3.3.2.3.3.4.2.3.3.3.3.3.4.4.2.3.3.3.2.3.3.3.4.2.2.3.3.3.4.4.2.3.4.3zm-.8 1 .8-1v.2h.2v.7h-.4v.2zm-9.5-4.6c.8 0 1.3.7 1.2 1.5s-.8 1.3-1.5 1.2c-.8-.2-1.3-.8-1.2-1.6s.8-1.3 1.5-1.2zm-45.9 38.4h.2v-.2h.4v.2h.2v.2l.2.2v.4h-.2zm-22.7 56 .2-1V416l.4-1.5.3-1.5.4-1.7.6-1.8.5-2 .7-2 .6-2 .6-2 .6-2.2.8-2.2.7-2.2 1-2 .7-2.3 1-2.3.7-2.2 1-2.2.8-2 1-2.2.8-2 1-2 .8-2 1-1.7.8-1.5 1-1.6.7-1.5 1-1.3.7-1.2.8-1 .8-.8.8-.6.7 1-.6.5-.7.8-.7 1-.8 1-1 1.3-.7 1.5-1 1.5-.7 1.7-1 1.7-.8 2-1 1.8-.8 2-1 2-.8 2.3-1 2-.7 2.3-1 2.3-.7 2.3-.8 2.2-.7 2.2-.8 2.2-.6 2-.6 2-.6 2.2-.6 2-.5 1.8-.4 1.8-.4 1.6-.5 1.6-.2 1.4-.2 1.3v1H336zm5.6 80.5-.7-2-.7-2-.7-2.2-.6-2.2-.6-2.2-.4-2.4-.4-2.3-.5-2.4-.4-2.5-.3-2.4-.3-2.5-.3-2.7-.2-2.6-.3-2.6-.2-2.5-.2-2.6v-3l-.2-2.7v-18.5l.3-2.7v-2.5l.2-2.6v-2.7l.3-2.6.2-2.5.2-2.5h1.2l-.3 2.6-.2 2.5-.2 2.6-.2 2.6v2.6l-.2 2.6v2.6l-.2 2.7v18.8l.2 2.6v2.6l.3 2.6.3 2.6.3 2.6.3 2.5.2 2.5.3 2.5.4 2.4.3 2.5.5 2.3.5 2.3.5 2.3.6 2.2.6 2 .7 2.2.7 2-1 .4zm1-.4v.8h-.8v-.2l1-.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx208("use", {
          xlinkHref: "#rs_svg__e",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 0)"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#21231e",
          d: "M473 398.4h-.2v.5h-.2v.8l.2.7v1.6l.2.8.2.8v.7l.3.8v.8l.3.7.2.8.3.7.2.7.2.7.3.7.3.8.3.7.3.7.2.7.3.6.4.6.2.7.4.5.4.7.4.7.4.5.5.6.4.8.5.6.4.6.5.6.6.6.2.2h.8v-.2l.6-.6.5-.6.5-.6.4-.6.5-.7.5-.5.4-.6.3-.8.4-.6.3-.7.4-.8.4-.6.3-.7.4-.8.3-.7.3-.7.3-.7.3-.6.2-.7.3-.7.3-.7.2-.8v-.7l.3-.7.2-.7v-.7l.3-.8v-1.4l.2-.8v-2.1h-1v.4l-.2 1v1.4l-.2.7v.7l-.2.7-.2.7v.8l-.3.7-.2.7-.2.7v.6l-.3.7-.3.7-.2.7-.3.7-.4.6-.2.7-.4.7-.3.6-.3.7-.4.6-.4.7-.3.6-.4.6-.5.6-.4.6-.4.7-.4.7-.4.6-.5.6h-.2l-.5-.7-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.3-.7-.4-.6-.4-.7-.3-.6-.3-.7-.4-.7-.2-.6-.3-.7-.2-.7-.2-.7-.2-.7-.2-.7-.2-.8-.2-.7-.2-.7v-.7l-.3-.6v-.8l-.2-.7v-2.3l-.2-.8v-.4h-.2v-.2h-.5z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#c6363c",
          d: "M549.2 422v108.6a72 72 0 0 1-19.7 49.8 65 65 0 0 1-94.7.1 72.9 72.9 0 0 1-19.7-49.8V422z"
        }),
        /* @__PURE__ */ jsx208("use", {
          xlinkHref: "#rs_svg__f",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 -90)"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#fff",
          stroke: "#21231e",
          d: "M549.2 488.6v28h-53v83a63.8 63.8 0 0 1-14 1.5 59 59 0 0 1-14-1.5v-83h-53v-28h53V422h28v66.6z"
        }),
        /* @__PURE__ */ jsx208("use", {
          xlinkHref: "#rs_svg__f",
          width: 1350,
          height: 900,
          transform: "translate(0 -90)"
        }),
        /* @__PURE__ */ jsx208("path", {
          id: "rs_svg__f",
          fill: "#fff",
          stroke: "#21231e",
          d: "M459 567.3V528c-8.4-2.3-29.3-10.6-30.3 7.6-.5 8.4 10.4 14 13.3 6.5 1.4-3.4 0-6-2-6.7-2.4-.8-4.6 1-4 3.6-8.8-4.7 8-14.6 15.5-1.7 2.2 3.7-3.7 7.6-3.7 10.4 0 2.7 5.8 7 3.7 10.3-7.7 12.8-24.3 3-15.5-1.6-.6 2.7 1.6 4.5 4 3.6 2-.8 3.4-3.3 2-6.8-3-7.5-13.8-2-13.3 6.5 1 18.2 22 10 30.4 7.6z"
        }),
        /* @__PURE__ */ jsx208("use", {
          xlinkHref: "#rs_svg__f",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 0)"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#21231e",
          d: "M414 421v113.3l.2 1.7v2l.4 1.7.2 1.8.3 1.7.4 1.8.3 1.8.4 1.7.6 1.7.5 1.7.6 1.5.6 1.7.5 1.6.7 1.6.7 1.6.7 1.6.8 1.6.8 1.5.8 1.5 1 1.5.8 1.5 1 1.4.8 1.4 1 1.4 1 1.4 1 1.3 1 1.5 1.2 1.2 1 1.3 1.2 1.2 1.2 1.2 1.2 1.2 1.2 1 1.3 1.3 1 1 1.4 1 1.3 1 1.4 1 1.5 1 1.4 1 1.3.8 1.4.8 1.5.8 1.4.8 1.6.7 1.5.6 1.5.7 1.5.6 1.6.5 1.6.5 1.5.5 1.6.5 1.8.4 1.6.4 1.7.4 1.8.2 1.7.3 1.7.2h1.7l1.6.2h8.9l1.7-.3 1.8-.3 1.7-.3 1.7-.2 1.7-.4 1.5-.4 1.7-.4 1.6-.5 1.6-.5 1.6-.5 1.5-.6 1.6-.7 1.6-.7 1.6-.7 1.5-.8 1.4-.8 1.6-.8 1.4-1 1.5-.7 1.4-1 1.2-1 1.4-1 1.3-1 1.2-1 1.3-1 1.2-1.3 1.2-1 1-1.3 1.3-1.2 1.2-1.2 1-1.3 1.2-1.2 1-1.4 1-1.2 1-1.4 1-1.4 1-1.4 1-1.4.7-1.5 1-1.5.7-1.5.8-1.5.8-1.6.7-1.6.6-1.6.6-1.6.6-1.6.5-1.7.5-1.6.5-1.8.4-1.7.6-1.7.3-1.8.2-1.8.3-1.7.3-1.8v-.9l.3-2 .2-1.7V421zm2.3 2.2H548V536l-.3 1.6-.2 1.8-.2 1.7-.3 1.8-.3 1.7-.4 1.7-.3 1.7-.5 1.5-.4 1.7-.4 1.6-.5 1.6-.5 1.6-.6 1.5-.8 1.6-.7 1.6-.7 1.5-.7 1.6-.7 1.4-.8 1.5-.8 1.4-1 1.3-.8 1.4-1 1.3-1 1.3-1 1.3-1 1.3-1 1.2-1.2 1.2-1 1.2-1.2 1-1.2 1.3-1.2 1-1.2 1-1.2 1-1.3 1-1.2 1-1.4 1-1.4 1-1.3.8-1.4 1-1.5.7-1.4.8-1.3.7-1.5.8-1.5.6-1.4.7-1.5.7-1.6.5-1.5.6-1.5.5-1.6.4-1.6.4-1.6.5-1.6.3-1.6.3-1.7.4H489l-1.8.3h-1.7l-1.6.2h-3.6l-1.6-.2H477l-1.6-.3h-1.6l-1.7-.4-1.5-.2-1.6-.3-1.7-.4-1.6-.3-1.6-.4-1.4-.5-1.6-.6-1.5-.5-1.5-.6-1.5-.6-1.4-.6-1.4-.8-1.4-.7-1.4-.8-1.4-.8-1.4-1-1.3-.7-1.4-1-1.3-1-1.2-1-1.3-1-1.2-1-1.2-1-1-1-1.3-1.3-1-1-1.2-1.3-1-1.2-1-1.3-1.2-1.4-1-1.3-1-1.3-1-1.3-.8-1.4-.8-1.4-1-1.5-.7-1.5-.8-1.4-.7-1.5-.8-1.4-.6-1.5-.6-1.5-.6-1.5-.5-1.6-.6-1.6-.5-1.6-.5-1.7-.4-1.6-.4-1.8-.4-1.7-.3-1.7-.3-1.7-.2-1.6-.2-1.8-.2-1.7v-5.4z"
        })
      ]
    })
  ]
});
var Rs_default = SvgRs;

// src/country-flag-icons/generated/Ru.tsx
import { jsx as jsx209, jsxs as jsxs202 } from "react/jsx-runtime";
var SvgRu = (props) => /* @__PURE__ */ jsxs202("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx209("path", {
      fill: "#fff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx209("path", {
      fill: "#0039a6",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx209("path", {
      fill: "#d52b1e",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Ru_default = SvgRu;

// src/country-flag-icons/generated/Rw.tsx
import { jsx as jsx210, jsxs as jsxs203 } from "react/jsx-runtime";
var SvgRw = (props) => /* @__PURE__ */ jsxs203("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx210("path", {
      fill: "#20603d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx210("path", {
      fill: "#fad201",
      d: "M0 0h640v360H0z"
    }),
    /* @__PURE__ */ jsx210("path", {
      fill: "#00a1de",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsxs203("g", {
      transform: "translate(511 125.4) scale(.66667)",
      children: [
        /* @__PURE__ */ jsxs203("g", {
          id: "rw_svg__b",
          children: [
            /* @__PURE__ */ jsx210("path", {
              id: "rw_svg__a",
              fill: "#e5be01",
              d: "M116.1 0 35.7 4.7l76.4 25.4-78.8-16.3L100.6 58l-72-36.2L82 82.1 21.9 28.6l36.2 72-44.3-67.3L30 112 4.7 35.7 0 116.1-1-1z"
            }),
            /* @__PURE__ */ jsx210("use", {
              xlinkHref: "#rw_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(1 -1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx210("use", {
          xlinkHref: "#rw_svg__b",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsx210("circle", {
          r: 34.3,
          fill: "#e5be01",
          stroke: "#00a1de",
          strokeWidth: 3.4
        })
      ]
    })
  ]
});
var Rw_default = SvgRw;

// src/country-flag-icons/generated/Sa.tsx
import { jsx as jsx211, jsxs as jsxs204 } from "react/jsx-runtime";
var SvgSa = (props) => /* @__PURE__ */ jsxs204("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx211("defs", {
      children: /* @__PURE__ */ jsx211("clipPath", {
        id: "sa_svg__a",
        children: /* @__PURE__ */ jsx211("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs204("g", {
      fillRule: "evenodd",
      clipPath: "url(#sa_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx211("path", {
          fill: "#165d31",
          d: "M-128 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M65.5 145.1c-.8 12-2 33 8.3 35.2 12.3 1.2 5.5-20.8 10-24.8.8-2 2.3-2 2.4.5v18.7c0 6 4 7.8 7 9 3.2-.2 5.4 0 6.6 3l1.6 32.3s7.4 2.2 7.8-18.1c.3-12-2.4-21.9-.8-24.2 0-2.3 3-2.4 5-1.3 3.2 2.2 4.6 5 9.6 4 7.6-2.2 12.2-5.9 12.3-11.7a47 47 0 0 0-3.5-16.6c.4-1-1.4-3.7-1-4.7 1.3 2.2 3.4 2 3.8 0-1.3-4.2-3.3-8.3-6.5-10-2.7-2.4-6.7-2-8 3-.8 5.7 2 12.4 6.1 18 .9 2.1 2.1 5.7 1.6 8.9-2.2 1.3-4.4.7-6.3-1.2 0 0-6-4.5-6-5.6 1.6-10.2.3-11.4-.6-14.3-.6-3.9-2.5-5.2-4-7.8-1.5-1.6-3.5-1.6-4.5 0-2.7 4.6-1.4 14.5.5 19 1.4 4.1 3.5 6.7 2.5 6.7-.8 2.3-2.5 1.7-3.8-1a66.6 66.6 0 0 1-2.1-17.4c-.5-4.6-1.1-14.4-4.2-17-1.8-2.4-4.5-1.2-5.5 1a82.4 82.4 0 0 0 .3 13.4c2 7.4 2.7 14 3.7 21.5.3 10.1-5.8 4.4-5.5-.7a45 45 0 0 0-.3-19.4c-1-2.6-2.1-3.2-4.6-2.8-1.9 0-6.8 5.3-8.2 14.3 0 0-1.2 4.6-1.7 8.7-.7 4.6-3.7 8-5.9-.6-1.8-6.3-3-21.6-6-18z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "m99 194.2-32 15.4c.3-7.3 15.1-20.4 25.3-20.5 6.5.1 4.9 2.5 6.6 5.1z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M93.3 204.2c-16.8 43.5 39.5 49.6 45.8 1.8.6-2 3-3.9 3.4-.7-1.3 43.3-43.6 46.2-50.8 32.6a41.9 41.9 0 0 1-2.5-14.6c-1-8.5-5.5-5.2-6.2 3.2-.7 4.7-.5 6-.5 10.5 2.2 34.2 56.7 19.5 65.6-8.7 4.7-15.6-.8-27.1 1.7-27.1 5.4 5.8 13 .8 14.7-1.2.7-1 2.5-1.7 3.7-.4 4.2 3 11.6 1.6 13.2-3.7.9-5.3 1.6-10.7 1.8-16.2-3.5 1-6 1.7-6.3 3.2l-.7 4.6c-.3 1.5-3.2 1.5-3.4-.4-1.3-6-6.7-6.7-10 2.5-2.1 1.8-6.1 2.2-6.5-.5.5-6.2-2-7-7-4.1l-4.8-36.2c2 0 4 1.5 5.9-.9-2-6.5-6.5-19.7-9-20.7-1.1-1.4-2.1-.5-3.7-.1-2.6.8-5 3-4.2 7.4 3 18.8 5 33.1 8.1 52 .5 2.1-1.3 5-3.7 4.7-4-2.7-5-8.2-12-8-5 0-10.6 5.5-11.3 10.7-.9 4.2-1.2 8.7 0 12.3 3.5 4.2 7.7 3.8 11.4 2.9 3-1.3 5.5-4.3 6.6-3.6.7.9.1 10.9-14.3 18.5-8.7 4-15.7 4.8-19.4-2.3-2.3-4.5.2-21.4-5.6-17.5"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M165 160c3.3-1.2 19.3-19.6 19.3-19.6l-2.4-2c-.9-.7-.8-1.5 0-2.2 4-2.4 2.7-7.4.7-9.8a9.7 9.7 0 0 0-8.7.1c-2.8 2.7-3.4 7-1.2 9.6 2.1 1 4.2 3.2 2.8 4.4-6.6 7-24.5 19.1-22.4 19.5.4.6 11.5.6 11.8 0zm-97 65c-6 9.6-6.5 23.9-3.2 28.2 1.8 2 4.7 2.9 6.8 2.2 3.8-1.6 5.5-9.3 4.6-12-1.3-2-2.3-2.3-3.6-.7-2.6 5.4-3.7 1.7-4-1.3a70 70 0 0 1 .8-15.2c.7-4.2 0-3-1.4-1.2m257.1-15.3c-5.8-12.6-13.9-25-16.4-29.7a557.6 557.6 0 0 0-24.8-36c-6.2-7.4 10.2 3.1-2-11.7l-8.9-7.5c-2-1.4-6.8-4-7.6.2-.4 3.8-.2 5.8.4 8.9.5 2 3.5 5.5 5 7.5a565 565 0 0 1 53.8 86.5c2.6-1.3 2-16.1.5-18.2"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M299.6 251.5c-1.2 1.3 2.8 6.8 8 6.8 8.6-1 16.2-5.8 23.2-18.6a33 33 0 0 0 5.3-14.2 317 317 0 0 0-5.8-72.4c-.3-2 0-4.4.2-5 .6-.7 2.5 0 3.5-1.7 1.5-1.5-4-14-7-18.7-1-2.2-1.5-3.6-3.3.2a27 27 0 0 0-3 13.6c4.1 28.5 5.4 53.4 8 81.9.3 2.8-.1 6.8-2 8.4a80.2 80.2 0 0 1-27.1 19.7m116.5-.1c-6.2 3.6-6.2 7.7-1.2 7.8 8.6-1 18.8-1.7 25.8-12.3a41 41 0 0 0 4.2-16 303 303 0 0 0-4.7-71.4c-.2-2-1.1-6.7-.8-7.3.6-1.4 3.4.1 4.4-1.5 1.4-1.5-7.3-12.7-10.4-17.5-1-2.2-1.4-3.6-3.3.2a22.3 22.3 0 0 0-1.8 13.6c4.6 31 8 54.2 8.7 81.6-.4 2.6-.5 4-1.7 7.3-2.7 3.4-5.7 7.8-8.5 9.9-2.8 2-8.8 4-10.7 5.6"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M420.7 223.7c0-7.3.1-13.5-.1-19a34 34 0 0 0-3-13.5c-1.8-4.1-.7-7.4-1.6-11.8-.8-4.4-.6-11-1.8-16.1-.4-2-1.4-8.5-1.1-9.2.5-1.4 2.4 0 3.4-1.6 1.4-1.5-5-18-8.2-22.7-1.1-2.1-3.3-1.4-5.8 2-2.5 2.3-1.6 7.4-.6 12.3 6.1 32.3 10.8 61.6 9.8 92.3-.4 2.6 9-7.8 9-12.7m-45.7-40c-3.9-.2-12-7.7-14.4-12a8 8 0 0 1 .4-6.5c1.5-1 3.7-2 5.4-1 0 0 1.7 2.4 1.4 2.7 2 1 3 .5 3.2-.4.1-1.5-.6-2.4-.6-4 .9-4.6 6-5.3 8-2.4 1.4 1.8 2 5.5 2.1 8 0 1.3-2-.2-3.3 0-1.1.4-1.4 1.8-1.5 3-.2 3.3-.6 8.6-.7 12.5zm-71.8 48c1-9.8-.4-27.3-.5-33.1A477 477 0 0 0 299 154c-1.2-8.4 3.4.9 2.8-4-1.5-8.3-6.1-14-11.6-21.5-1.7-2.5-1.7-3-4.4.6-3 6.7-.4 11.4.4 16.7 3.9 17.2 6.2 33 7.3 48.7a393.4 393.4 0 0 1 .4 49c3 .1 7.6-4.7 9.3-11.8"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M434 216c-6.9-11.6-17.2-24-20-28.7a658 658 0 0 0-29.2-37.8c-8.5-9 4-1.5-1.6-8.5-4.7-5.1-6-6.8-10.1-9.9-2-1.3-3.2-3.8-4 .5a83 83 0 0 0-.2 11.2c0 1.7 1.8 5 3.4 7 20.7 25.5 43.4 51.5 61.6 84.2 2.6-1.3 1.7-16 0-18z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#165d31",
          d: "M122.6 194.7c-.5.9-1.6 2-1.2 3.1.7 1 1.4 1.3 2.6 1.3 1.1 0 2.7.3 3-.3.6-.7 1-2 .6-3.3-1.2-3-4.4-1.8-5-.8"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M354.2 362.5c9.2.4 15.2.5 23.3 1.4l9.6-1c10.6-1 11 15.1 11 15.1 0 9.5-3.7 10-8.4 11-2.7.4-4-1.6-5.5-3.6a14 14 0 0 1-7 .4c-3.9-.2-7.7-.2-11.5-.5-4-.3-6.2.5-10.3.1-.8 1.3-2 3.1-4.4 2.6-2-.3-4.5-6-3.8-10.5 1.5-3.2 1-2.1 1-3.5-37.6-1-75.5-2.7-112.3-2.2-28.8.1-57.2 1.3-85.7 2.5-15.2-.2-26.8-2.6-34.8-14.3.8 0 38.8 2.1 49.9 1.4 20.5-.2 39.3-1.9 60.2-2.5 41.2.7 82.1.7 123.3 3.6-4-2.7-4-9 2-10.6.5-.4.8 3.1 1.7 3 4.9-.3 2.7 6.3 1.7 7.6M188.6 135.3c-6.2 17.8 3.6 37.4 10.4 35.5 5 2 8-7.4 10-17.6 1.5-2.9 2.5-3.2 3.2-1.7-.2 13.6 1 16.7 4.5 20.8 7.8 6 14.3.8 14.8.3l6-6.1c1.4-1.5 3.2-1.5 5.1-.3 1.9 1.7 1.6 4.6 5.6 6.6 3.4 1.4 10.5.4 12.2-2.5 2.2-3.9 2.8-5.2 3.8-6.6 1.6-2.1 4.3-1.2 4.3-.5-.3 1.2-1.9 2.3-.8 4.5 2 1.4 2.4.5 3.5.2 4-2 7-10.6 7-10.6.1-3.2-1.7-3-2.9-2.2l-3.1 2.1c-2 .3-5.7 1.6-7.6-1.3-1.9-3.4-1.9-8.3-3.3-11.8 0-.2-2.6-5.5-.2-5.8 1.2.2 3.7.9 4.1-1.2 1.2-2.1-2.6-8-5.3-11-2.3-2.5-5.5-2.8-8.6-.2-2.2 2-1.9 4.2-2.3 6.3a9.8 9.8 0 0 0 2 8.7c2.2 4.2 6.1 9.7 4.8 17.5 0 0-2.3 3.6-6.3 3.1-1.7-.3-4.4-1-5.8-11.8-1.1-8 .2-19.4-3.2-24.7-1.3-3.3-2.2-6.4-5.2-.9-.8 2.2-4.3 5.5-1.8 12.2a36 36 0 0 1 2 19c-1.5 2.2-1.8 2.9-3.7 5-2.6 3-5.5 2.2-7.7 1.1-2-1.3-3.6-2-4.6-6.5.2-7 .6-18.5-.7-20.9-1.9-3.8-5-2.4-6.3-1.2a47.7 47.7 0 0 0-11.5 23.5c-1.8 5.8-3.7 4.1-5 1.8-3.2-3-3.5-26.7-7.4-22.8"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M207.4 174.1c2.9-2 1.6-3.4 5.8.8a72 72 0 0 1 9.2 31.3c-.2 2.6 1.6 4.2 2.5 3.6.4-6 15.1-14.4 28.6-15.6 2-.5 1-4.4 1.3-6.4-.8-7.5 4.2-14.3 11.2-14.8 9.6 1.4 12.8 6.5 13 14.2-1.1 15-16.7 17.5-25.4 18.7-1.3.5-1.9 1.1 0 1.8l36.6.2 1.9 1c.2 1-.6.2-2 2.6a29.5 29.5 0 0 0-3.7 11.5c-10.9 3.6-22.2 5-33.6 6.5-4 2-6 4.7-5.2 7.7 1.4 3.3 10.2 6.7 10.2 6.8 1.7 1 3.6 3.5-.5 8.6-17.8-.8-31.7-8.4-36.5-19.1-1.4-1.1-3 0-4 1.4-7 9-13.8 17-25.7 21.4-7 1.8-14.3-1.1-17.7-5.7-2.3-2.7-2.2-5.6-3-6.2-3.9 1.7-36.9 15.7-32.7 9.1 8-8.5 22-14.9 34.2-23.3.9-2.9 2.5-12.5 7.3-15.6.3 0-.7 5.6-.6 8 0 2-.2 2.7.2 2.2.9-.5 15.7-12.2 17-15.8 1.4-2 .3-7.2.3-7.4-2.8-7.2-6.7-7.8-8.1-11.4-1.3-4.7-.7-10.1 2-11.7 2.4-2.1 5.2-1.9 7.9.5 3 2.7 5.6 8 6.4 11.9-.5 1.5-4-1-5-.3a16 16 0 0 1 3.7 7.8c2 8.2 1.4 11.4-.6 16.7-6.6 13.9-15 18-22.4 23.2-.2 0-.3 3.5 2.4 5.4 1 1 4.9 1.5 9.4 0a54.5 54.5 0 0 0 22.3-23.3 51 51 0 0 0-2.4-22.2c-2.9-6.7-6.3-16.2-6.3-16.4-.1-4.2.2-5.6 2-7.7m-95.8-38.6c4.2 2 12.2 1.1 11.8-5.7l-.2-3.1c-.8-2-3.2-1.5-3.7.5-.2.7.3 1.8-.3 2.1-.4.4-1.7.2-1.7-1.7 0-.6-.4-1.2-.7-1.6-.2-.2-.4-.2-.9-.2-.6 0-.6.1-.9.6-.1.5-.3 1-.3 1.6 0 .7-.4.9-.8 1-.6 0-.5 0-1-.2-.2-.3-.5-.4-.5-1l-.3-1.6c-.2-.3-.6-.5-1-.6-2.3 0-2.5 2.7-2.3 3.7-.2.2-.3 4.9 2.8 6.2"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M235.1 187.7c4.2 2 14.3.9 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.6-.2.6.3 1.7-.4 2-.3.4-1.7.2-1.6-1.6 0-.6-.4-1.3-.7-1.7-.3-.1-.4-.2-1-.2-.5 0-.5.2-.8.7-.2.5-.3 1-.3 1.6-.1.6-.4.8-.9 1-.5 0-.4 0-.8-.3-.3-.3-.6-.4-.6-.9l-.3-1.6c-.2-.3-.6-.5-1-.6-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 5 3 6.2zm72-21.6c4.2 2 12.1 1.1 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.5-.2.7.3 1.8-.4 2.2-.3.3-1.7.1-1.6-1.8 0-.6-.4-1.2-.7-1.6-.3-.2-.4-.2-1-.2-.5 0-.5.2-.8.7l-.3 1.5c-.1.7-.4 1-.9 1s-.4 0-.8-.2c-.3-.3-.6-.4-.6-.9s-.1-1.3-.3-1.7c-.2-.3-.6-.4-1-.5-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 4.9 3 6.2zm37.3 54.3c-7.3 8.3-4.1 22-2.4 25 2.4 4.8 4.3 7.9 9 10.3 4.3 3.1 7.7 1.2 9.5-1 4.3-4.5 4.4-16 6.4-18.2 1.4-4.2 5-3.5 6.7-1.6a16.5 16.5 0 0 0 6.2 5.3c4 3.5 8.8 4.2 13.6 1 3.2-1.9 5.3-4.2 7.2-8.9 2-5.6 1-31.6.5-47l-4.2-21.5c0-.2-.5-10.2-1-12.5 0-1-.3-1.3.7-1.2 1.1 1 1.2 1 2 1.3 1 .2 2-1.7 1.3-3.3l-10-18.6c-.8-.8-1.9-1.6-3.2.2a7.3 7.3 0 0 0-2.4 5.5c.3 4.4 1 8.9 1.3 13.3l4 22.6c1.3 16 1.6 29.2 2.9 45.3-.2 6.8-2.3 12.7-4.3 13.6 0 0-3 1.7-5-.2-1.5-.6-7.4-9.9-7.4-9.9-3-2.7-5-2-7.1 0-6 5.8-8.6 16.4-12.7 23.8-1 1.7-4 3-7.2-.1-8.2-11.3-3.4-27.3-4.4-23.2M309 126.7c3.8 1.5 6.4 9.2 5.6 13-.8 4.5-2.8 9.5-4.2 8.9-1.6-.6 1-4.6-.5-8.8-.8-2.8-6-7.8-5.4-9.2-1-3.1 2.2-4.5 4.5-4z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M356.6 225c.7-9.2-.6-14.8-.8-20.2s-6.1-46.6-7.3-50.6c-1.5-7.8 5.7-1 4.9-5.6-2.5-5.6-8.6-13.9-10.5-18.8-1.2-2-.7-4-3.3-.5a42.3 42.3 0 0 0-2.3 19.2c6.2 32.3 12.5 59.1 11.5 89.8 3 0 6.3-6.7 7.8-13.3m64.4-85.3c3.5 1.7 5.5 11.3 5.1 14-.7 5-2.5 10.4-3.8 9.7-1.5-.6.3-7.4-.4-9.5-.8-3-5.5-8.4-5-10-1-3.4 2-4.8 4.1-4.2m-255.7 67.9c3.3 1.3 5.3 8.3 5 10.3-.8 3.7-2.5 7.7-3.8 7.1-1.3-.4.3-5.4-.3-7-.3-3.7-4.9-5.7-4.8-7.3-.8-3 2-3.5 4-3.1z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#165d31",
          d: "M244.9 218.2c4.2.2 6.3 3.6 2.4 5-4 1.3-7.7 2.4-7.8 8 1.5 8-2 5.2-4 4.2-2.4-1.8-9.2-6-10.2-15-.1-2.1 1.6-4 4.3-4 4 1.1 10 1.2 15.3 1.8"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#fff",
          d: "M77.4 124.4c4.8 1.4 5.1 8.6 4.8 10.7-.7 3.8-2.4 7.9-3.6 7.4-1.4-.5 0-5.7-.7-7.3-.7-2.2-4.8-6.4-4.4-7.6-.9-2.5 2-3.7 3.9-3.2m95.9 33.6c-3.8 2-5.2 8-2.9 11.6 2.2 3 5.6 1.9 6 1.9 3.7.4 5.9-6.9 5.9-6.9s.1-2-4.2 1.9c-1.9.3-2-.4-2.5-1.4a9 9 0 0 1 .5-5.7c.7-1.8-.7-2.6-2.8-1.4m28-36.4c-2 1.3-5.7 5.2-5.8 9.6-.1 2.5-.6 2.5 1 4 1.3 1.8 2.4 1.7 4.8.4a5.1 5.1 0 0 0 2.3-3.4c.6-2.8-3 1.4-3.4-1.8-.8-3 1.5-4.2 3.7-7 0-2 0-3.3-2.7-1.8zm22.4 4a59.5 59.5 0 0 0-1.6 11.1c-.6 2.8 3 4 4.5.4 2.4-6.5 2.4-9.3 2.6-12-.7-4.3-3.6-4.2-5.5.5m142 72.3c.4-.5 20-14.4 20-14.4 2-.7 1.5 7.2.6 7.1a77.8 77.8 0 0 1-20.7 14.3c-1 .7-1.9-5.3 0-7zm17.7-.2c3.5 1.7 4.9 11.8 4.5 14.5 0 5.4-3.3 9.6-4.7 9-1.4-.7.2-6.7-.5-8.8-.8-3-3.7-8.5-3.2-10.1-1-3.4 1.8-5.2 4-4.6zm-116 43.4a26 26 0 0 1 5.6-4.9c2-1 3.8.8 3.7.7.3 2-1.2 3.7-.7 6.3.4 1 .7 2.2 2.6 1.8 3.1-2.5 6-2.7 9-2.8 2.5.1 2.6 4.2 1 4.2-5.7 1.2-8.2 2.8-12.3 4.3-2 1.2-3.6-.3-3.6-.4s-1.1-1.1-.4-3.7c.2-2-.6-3.2-2.4-3-1.2.8-2.4 1.2-3-.3-.3-1-.4-1.6.5-2.2m136.6 5.4c.8 1 1.4 2-.1 3.8l-3.7 3.2c-.6 1-1 2.8 1 3.3 3.6 1 12-4.5 12-4.6 1.4-1 1-3 .8-3-.8-.9-2.6-.3-3.8-.5-.6 0-2.5-.2-1.6-2a11.4 11.4 0 0 0 1.6-2.9c.5-1.2 0-2-2-2.7-2.1-.4-3-.2-5.3 0-1.2.2-1.6.8-1.9 2.3.1 2.3 1.5 2.2 3 3z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#165d31",
          d: "M268.1 189.7c-.5 1-2.3 1-4 0s-2.7-2.6-2.1-3.5 2.3-.9 4 0 2.6 2.6 2.1 3.5m-89-53.6c-1 .3-2.4-.6-3-2s-.3-2.6.7-2.9 2.3.7 3 2 .3 2.7-.8 3zM355.2 375c9.4.4 18.2 0 27.5.5 1.7 1.5.5 5-.6 4.8l-7.8-.3c-.1-3-7.7-2.5-7.5.1-4.1.5-7.8-.1-12-.3-1.2-1.5-1-4.2.4-4.8"
        })
      ]
    })
  ]
});
var Sa_default = SvgSa;

// src/country-flag-icons/generated/Sb.tsx
import { jsx as jsx212, jsxs as jsxs205 } from "react/jsx-runtime";
var SvgSb = (props) => /* @__PURE__ */ jsxs205("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx212("defs", {
      children: /* @__PURE__ */ jsx212("clipPath", {
        id: "sb_svg__a",
        children: /* @__PURE__ */ jsx212("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs205("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#sb_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx212("path", {
          fill: "#0000d6",
          d: "M0 507.2 987.4 0H0z"
        }),
        /* @__PURE__ */ jsx212("path", {
          fill: "#006000",
          d: "M1024 0 27.2 512H1024z"
        }),
        /* @__PURE__ */ jsx212("path", {
          fill: "#fc0",
          d: "M1024 0h-54.9L0 485.4V512h54.9L1024 27.6z"
        }),
        /* @__PURE__ */ jsx212("path", {
          fill: "#fff",
          d: "m71.4 9.1 11.8 34.5h38.5L90.6 64.7l11.9 34.4L71.4 78 40.3 99.2l11.9-34.4-31.1-21.3h38.4zm191.1 0 11.9 34.5h38.5l-31.2 21.2 12 34.4L262.4 78l-31 21.3 11.9-34.4-31.2-21.3h38.5zm0 144.5 11.9 34.5h38.5l-31.2 21.2 12 34.4-31.2-21.3-31 21.3 11.9-34.4-31.2-21.3h38.5zm-95-71.4 11.9 34.4h38.4l-31 21.3 11.8 34.4-31-21.3-31.2 21.3 12-34.4-31.2-21.3h38.5zm-96.1 71.4 11.8 34.5h38.5l-31.1 21.2 11.9 34.4-31.1-21.3-31.1 21.3 12-34.4L21 188h38.4z"
        })
      ]
    })
  ]
});
var Sb_default = SvgSb;

// src/country-flag-icons/generated/Sc.tsx
import { jsx as jsx213, jsxs as jsxs206 } from "react/jsx-runtime";
var SvgSc = (props) => /* @__PURE__ */ jsxs206("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx213("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx213("path", {
      fill: "#d92223",
      d: "M0 480V0h640v160z"
    }),
    /* @__PURE__ */ jsx213("path", {
      fill: "#fcd955",
      d: "M0 480V0h426.7z"
    }),
    /* @__PURE__ */ jsx213("path", {
      fill: "#003d88",
      d: "M0 480V0h213.3z"
    }),
    /* @__PURE__ */ jsx213("path", {
      fill: "#007a39",
      d: "m0 480 640-160v160z"
    })
  ]
});
var Sc_default = SvgSc;

// src/country-flag-icons/generated/Sd.tsx
import { jsx as jsx214, jsxs as jsxs207 } from "react/jsx-runtime";
var SvgSd = (props) => /* @__PURE__ */ jsxs207("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx214("defs", {
      children: /* @__PURE__ */ jsx214("clipPath", {
        id: "sd_svg__a",
        children: /* @__PURE__ */ jsx214("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs207("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#sd_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx214("path", {
          fill: "#000001",
          d: "M0 341.3h1024V512H0z"
        }),
        /* @__PURE__ */ jsx214("path", {
          fill: "#fff",
          d: "M0 170.6h1024v170.7H0z"
        }),
        /* @__PURE__ */ jsx214("path", {
          fill: "red",
          d: "M0 0h1024.8v170.7H0z"
        }),
        /* @__PURE__ */ jsx214("path", {
          fill: "#009a00",
          d: "M0 0v512l341.3-256z"
        })
      ]
    })
  ]
});
var Sd_default = SvgSd;

// src/country-flag-icons/generated/Se.tsx
import { jsx as jsx215, jsxs as jsxs208 } from "react/jsx-runtime";
var SvgSe = (props) => /* @__PURE__ */ jsxs208("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx215("path", {
      fill: "#005293",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx215("path", {
      fill: "#fecb00",
      d: "M176 0v192H0v96h176v192h96V288h368v-96H272V0z"
    })
  ]
});
var Se_default = SvgSe;

// src/country-flag-icons/generated/Sg.tsx
import { jsx as jsx216, jsxs as jsxs209 } from "react/jsx-runtime";
var SvgSg = (props) => /* @__PURE__ */ jsxs209("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx216("defs", {
      children: /* @__PURE__ */ jsx216("clipPath", {
        id: "sg_svg__a",
        children: /* @__PURE__ */ jsx216("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs209("g", {
      fillRule: "evenodd",
      clipPath: "url(#sg_svg__a)",
      children: [
        /* @__PURE__ */ jsx216("path", {
          fill: "#fff",
          d: "M-20 0h720v480H-20z"
        }),
        /* @__PURE__ */ jsx216("path", {
          fill: "#df0000",
          d: "M-20 0h720v240H-20z"
        }),
        /* @__PURE__ */ jsx216("path", {
          fill: "#fff",
          d: "M146 40.2a84.4 84.4 0 0 0 .8 165.2 86 86 0 0 1-106.6-59 86 86 0 0 1 59-106c16-4.6 30.8-4.7 46.9-.2z"
        }),
        /* @__PURE__ */ jsx216("path", {
          fill: "#fff",
          d: "m133 110 4.9 15-13-9.2-12.8 9.4 4.7-15.2-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.5 52 5 15.1-13-9.2-12.9 9.3 4.8-15.1-12.8-9.4 15.9-.1 4.9-15.1 5 15h16zm58.5-.4 4.9 15.2-13-9.3-12.8 9.3 4.7-15.1-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.4-51.6 4.9 15.1-13-9.2-12.8 9.3 4.8-15.1-12.9-9.4 16-.1 4.8-15.1 5 15h16zm-46.3-34.3 5 15.2-13-9.3-12.9 9.4 4.8-15.2-12.8-9.4 15.8-.1 5-15.1 5 15h16z"
        })
      ]
    })
  ]
});
var Sg_default = SvgSg;

// src/country-flag-icons/generated/Sh.tsx
import { jsx as jsx217, jsxs as jsxs210 } from "react/jsx-runtime";
var SvgSh = (props) => /* @__PURE__ */ jsxs210("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx217("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx217("path", {
      fill: "#FFF",
      d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"
    }),
    /* @__PURE__ */ jsx217("path", {
      fill: "#C8102E",
      d: "m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"
    }),
    /* @__PURE__ */ jsx217("path", {
      fill: "#FFF",
      d: "M241 0v480h160V0zM0 160v160h640V160z"
    }),
    /* @__PURE__ */ jsx217("path", {
      fill: "#C8102E",
      d: "M0 193v96h640v-96zM273 0v480h96V0z"
    })
  ]
});
var Sh_default = SvgSh;

// src/country-flag-icons/generated/Si.tsx
import { jsx as jsx218, jsxs as jsxs211 } from "react/jsx-runtime";
var SvgSi = (props) => /* @__PURE__ */ jsxs211("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx218("defs", {
      children: /* @__PURE__ */ jsx218("clipPath", {
        id: "si_svg__a",
        children: /* @__PURE__ */ jsx218("path", {
          fillOpacity: 0.7,
          d: "M-15 0h682.6v512H-15.1z"
        })
      })
    }),
    /* @__PURE__ */ jsxs211("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#si_svg__a)",
      transform: "translate(14.1) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx218("path", {
          fill: "#fff",
          d: "M-62 0H962v512H-62z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#d50000",
          d: "M-62 341.3H962V512H-62z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#0000bf",
          d: "M-62 170.7H962v170.6H-62z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#d50000",
          d: "M228.4 93c-4 61.6-6.4 95.4-15.7 111-10.2 16.8-20 29.1-59.7 44-39.6-14.9-49.4-27.2-59.6-44-9.4-15.6-11.7-49.4-15.7-111l5.8-2c11.8-3.6 20.6-6.5 27.1-7.8 9.3-2 17.3-4.2 42.3-4.7 25 .4 33 2.8 42.3 4.8 6.4 1.4 15.6 4 27.3 7.7z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#0000bf",
          d: "M222.6 91c-3.8 61.5-7 89.7-12 103.2-9.6 23.2-24.8 35.9-57.6 48-32.8-12.1-48-24.8-57.7-48-5-13.6-8-41.7-11.8-103.3 11.6-3.6 20.6-6.4 27.1-7.7 9.3-2 17.3-4.3 42.3-4.7 25 .4 33 2.7 42.3 4.7a284 284 0 0 1 27.4 7.7z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#ffdf00",
          d: "m153 109.8 1.5 3.7 7 1-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.7-1z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#fff",
          d: "m208.3 179.6-3.9-3-2.7-4.6-5.4-4.7-2.9-4.7-5.4-4.9-2.6-4.7-3-2.3-1.8-1.9-5 4.3-2.6 4.7-3.3 3-3.7-2.9-2.7-4.8-10.3-18.3-10.3 18.3-2.7 4.8-3.7 2.9-3.3-3-2.7-4.7-4.9-4.3-1.9 1.8-2.9 2.4-2.6 4.7-5.4 4.9-2.9 4.7-5.4 4.7-2.7 4.6-3.9 3a65.8 65.8 0 0 0 18.6 36.3 107 107 0 0 0 36.6 20.5 104.1 104.1 0 0 0 36.8-20.5c5.8-6 16.6-19.3 18.6-36.3"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#ffdf00",
          d: "m169.4 83.9 1.6 3.7 7 1-4.6 2.7 4.4 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.6-1zm-33 0 1.6 3.7 7 .9-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.4-6-.9 4-3-4.2-2.7 6.7-1z"
        }),
        /* @__PURE__ */ jsx218("path", {
          fill: "#0000bf",
          d: "M199.7 203h-7.4l-7-.5-8.3-4h-9.4l-8.1 4-6.5.6-6.4-.6-8.1-4H129l-8.4 4-6.9.6-7.6-.1-3.6-6.2.1-.2 11.2 1.9 6.9-.5 8.3-4.1h9.4l8.2 4 6.4.6 6.5-.6 8.1-4h9.4l8.4 4 6.9.6 10.8-2 .2.4zm-86.4 9.5 7.4-.5 8.3-4h9.4l8.2 4 6.4.5 6.4-.5 8.2-4h9.4l8.3 4 7.5.5 4.8-6h-.1l-5.2 1.4-6.9-.5-8.3-4h-9.4l-8.2 4-6.4.6-6.5-.6-8.1-4H129l-8.4 4-6.9.6-5-1.3v.2l4.5 5.6z"
        })
      ]
    })
  ]
});
var Si_default = SvgSi;

// src/country-flag-icons/generated/Sj.tsx
import { jsx as jsx219, jsxs as jsxs212 } from "react/jsx-runtime";
var SvgSj = (props) => /* @__PURE__ */ jsxs212("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx219("path", {
      fill: "#ef2b2d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx219("path", {
      fill: "#fff",
      d: "M180 0h120v480H180z"
    }),
    /* @__PURE__ */ jsx219("path", {
      fill: "#fff",
      d: "M0 180h640v120H0z"
    }),
    /* @__PURE__ */ jsx219("path", {
      fill: "#002868",
      d: "M210 0h60v480h-60z"
    }),
    /* @__PURE__ */ jsx219("path", {
      fill: "#002868",
      d: "M0 210h640v60H0z"
    })
  ]
});
var Sj_default = SvgSj;

// src/country-flag-icons/generated/Sk.tsx
import { jsx as jsx220, jsxs as jsxs213 } from "react/jsx-runtime";
var SvgSk = (props) => /* @__PURE__ */ jsxs213("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx220("path", {
      fill: "#ee1c25",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#0b4ea2",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#fff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#fff",
      d: "M233 370.8c-43-20.7-104.6-61.9-104.6-143.2 0-81.4 4-118.4 4-118.4h201.3s3.9 37 3.9 118.4S276 350 233 370.8"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#ee1c25",
      d: "M233 360c-39.5-19-96-56.8-96-131.4s3.6-108.6 3.6-108.6h184.8s3.5 34 3.5 108.6C329 303.3 272.5 341 233 360"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#fff",
      d: "M241.4 209c10.7.2 31.6.6 50.1-5.6 0 0-.4 6.7-.4 14.4s.5 14.4.5 14.4c-17-5.7-38.1-5.8-50.2-5.7v41.2h-16.8v-41.2c-12-.1-33.1 0-50.1 5.7 0 0 .5-6.7.5-14.4 0-7.8-.5-14.4-.5-14.4 18.5 6.2 39.4 5.8 50 5.6v-25.9c-9.7 0-23.7.4-39.6 5.7 0 0 .5-6.6.5-14.4 0-7.7-.5-14.4-.5-14.4 15.9 5.3 29.9 5.8 39.6 5.7-.5-16.4-5.3-37-5.3-37s9.9.7 13.8.7c4 0 13.8-.7 13.8-.7s-4.8 20.6-5.3 37c9.7.1 23.7-.4 39.6-5.7 0 0-.5 6.7-.5 14.4 0 7.8.5 14.4.5 14.4a119 119 0 0 0-39.7-5.7v26z"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#0b4ea2",
      d: "M233 263.3c-19.9 0-30.5 27.5-30.5 27.5s-6-13-22.2-13c-11 0-19 9.7-24.2 18.8 20 31.7 51.9 51.3 76.9 63.4 25-12 57-31.7 76.9-63.4-5.2-9-13.2-18.8-24.2-18.8-16.2 0-22.2 13-22.2 13S253 263.3 233 263.3"
    })
  ]
});
var Sk_default = SvgSk;

// src/country-flag-icons/generated/Sl.tsx
import { jsx as jsx221, jsxs as jsxs214 } from "react/jsx-runtime";
var SvgSl = (props) => /* @__PURE__ */ jsx221("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs214("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx221("path", {
        fill: "#0000cd",
        d: "M0 320.3h640V480H0z"
      }),
      /* @__PURE__ */ jsx221("path", {
        fill: "#fff",
        d: "M0 160.7h640v159.6H0z"
      }),
      /* @__PURE__ */ jsx221("path", {
        fill: "#00cd00",
        d: "M0 0h640v160.7H0z"
      })
    ]
  })
});
var Sl_default = SvgSl;

// src/country-flag-icons/generated/Sm.tsx
import { jsx as jsx222, jsxs as jsxs215 } from "react/jsx-runtime";
var SvgSm = (props) => /* @__PURE__ */ jsxs215("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs215("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx222("path", {
          fill: "#19b6ef",
          d: "M0 240h640v240H0z"
        }),
        /* @__PURE__ */ jsx222("path", {
          fill: "#fff",
          d: "M0 0h640v240H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M317 339.2C369.6 300 426 220 359.9 177.8c-12.3-2.4-26-1.7-32.7 3.6-3.5-2-6.3-1.8-9.8 1.9-2.5-3-5-4.4-10-2.9a40.8 40.8 0 0 0-31.5-3C218 211.8 253.4 294 317 339.1z"
    }),
    /* @__PURE__ */ jsxs215("g", {
      stroke: "#3a9d4f",
      children: [
        /* @__PURE__ */ jsx222("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "M414 250.1s6-8 6.2-8c5.9-3.4 6.5-7.9 6.5-7.9 5.9-1.8 4-6.7 4.5-7.3a6.4 6.4 0 0 0 1.4-7.1c0-.8 2-8.4-.8-9.4.1-8-4.8-7.3-8.8-2-4.2 1.2-5.1 4.7-3.6 8.5-5.5 0-5.7 8-4.1 12.4-7.3-.2-3.3 8-3.5 8.4-2.4 1.2 1.9 12.8 2.3 12.4zm-46 68.2 3.6 2.2c.8 2.8 3.4 4.6 5.3 4.1 1 4.3 5.6 3.7 9 1.2 2.7 4 6 4 10.6 2.7 4 3 9.3 1.7 12.8-1.4 3.7 3 6.2.8 8.1-2.5 3 .8 5.2.3 6.3-2.6 5.7-.5 2.9-5.9-1.8-8.2 3.7-3.2 7.9-10 2-11-1.8-1.3-5.3-1-7.9.2-.7-3-4.8-3.7-9.4-.4-1.5-3.3-7-1.7-9.5.6-3.3-2.8-7.2-2.8-12.9.4zm0-8.7c.6-3.8-2-10.6 2-11.2-.7-6.3.3-13.3 7.5-12.7 1.2-5.9 1-11.4 7.8-12.2 0 0 5.5-19.1 11.2-5.9 2.2 3.9 1.8 10.2-2.7 9 .9 4.7-.7 8.9-5.9 8.7 2.3 3.4 1.6 7.9-1 10zm33.1-23.9 6-1.2c6-4 8.5-5.7 11.5-1.2 5.1-1 10-.6 9.8 3.4 6 .5 6 4.3 5.3 7.4 1 5.3-1.4 12.3-5 3.8-11.9-7.2-18.6-6.2-37.3-2zm3.1-5.9c.2-.2 17.5-4.7 15.7-10 4.9-.8 5.9-5.7 6-5.7 10.3-3.2 9.7-9.1 9.7-9.1 2.9-3.1 8-6.3 6.9-11.8.3-6.3.9-10.2-7.6-6.1-6.3-.6-8.5 3-10.3 8.5-3-3.5-7.8 2.1-8.4 7.1 0 0-7.7 7.6-7.7 7.8l-6.5 12z"
        }),
        /* @__PURE__ */ jsx222("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "M404.5 266.4c-4.1-3.1-6.4-6.9-5.7-10.6-2.7-3.7-4.6-5.9-2-9.2l-2-7.5c-5.4-2-3.1-6.5-1.7-8.1-2.5-3.5-2.6-7.2-.2-10.4 0-6.5 4.6-4 8.3 0 0 0 6.4 4.5 1.7 8.5 4.7 1.7 6 5.7 3.4 7.4 4.1 1.8 4.7 5.5 2.5 8 4.1 3.2 2.6 7.4 3.8 11.1z"
        }),
        /* @__PURE__ */ jsx222("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "M411.8 236c-.2-.1-6.9-8.7-5-9.3-.5-2.6-2.5-5.5-1.3-8.1-3.3-3.4-3.4-7.3-.8-10.4-2.2-3-1.2-7.1 1.8-9.8-1-5 2.6-6.2 5.7-7.1 2.3-8 6-6 8.2.2 3.2 2.8 2.7 7 1.6 10.2 3.8 2.5 1.5 5.7-.2 7z"
        }),
        /* @__PURE__ */ jsx222("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "m410.8 193.1-5.7-5.7c1.5-3 2.7-8.3-1.6-10.8-2.4-5.7-14.2-12.9-16.1.8-1.8-4.1-5.6-8.2-8.3-3.4-6.2-5.3-9.5-3.7-6.3 3 0 0-2.9 4.5 4.6 8 .6.6-2.4 8.1 6.6 8.3-1.7 2.6 1 6.2 4.6 6-2.5 3.1 1.8 6.5 4.5 5.2-1.1 3.5-1 5.2 3.9 5.7l5.5 6.3 4.5 6.1z"
        }),
        /* @__PURE__ */ jsx222("path", {
          fill: "none",
          strokeLinecap: "round",
          strokeWidth: 2.2,
          d: "M414.3 246.5c.3-.3 11-24.8 12.4-32.2M415.4 203s1.8 20-3.1 34.6m-29.7-54.7s21.9 21 24 29.7m-8.7-32s1.4 17.3 7.5 34.3m31 28.4S414.6 261.8 404 278m11.8 30s-28.8 4-41.4 4.3m32 8s-35.8-.8-38.4-3.4m20.5-43c0 .4-18.2 30.3-18.8 40"
        })
      ]
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#65c7ff",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M316.9 333.4c-37.8-35.6-76.5-102.4-38-136.2 6.8 3.8 14.9.4 26-4 3.4 3.7 7.7 4.6 12 1.8a9 9 0 0 0 10.7-2.1c11 6.3 24.9 9.6 28.2 3.3 37.8 36-.6 103.2-39 137.3z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#8fc753",
      fillRule: "evenodd",
      d: "M317 332.4a212.8 212.8 0 0 1-42.3-57.6c2-1.7 2.9-2.2 3.9-5 5.8.8 8.9 1 16.5-.4 1.6 5.8 1.9 10.6 5.5 15.4l7.7-15a33.6 33.6 0 0 0 16.5 0c3.2 4.2 2 10.7 7.7 15.6 3.4-10 6.7-10.6 10.1-16 5 1.8 8.2 1 12.3-.3 2 2.5 1 2.4 5 6a193.7 193.7 0 0 1-42.8 57.3z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M272.6 164.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.8 0zm-3.5-7.7a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0zm-4-7.1a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-2.8-7a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm.5-7.6a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm17.6-12.5a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M273.8 123.6a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-7.3 4.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm22.4-5.4a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.6 0zm9.4.8a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm8.2-.5a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 1.1,
      d: "M325.9 117.5a8.6 8.6 0 1 1-17.2 0 8.6 8.6 0 0 1 17.2 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M335 122.7a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.7 0zm8.6.7a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0zm8.5-.4a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm7.1-.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm8.9 1a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm7 4.4a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#e40000",
      fillRule: "evenodd",
      stroke: "#ac0000",
      strokeWidth: 2.4,
      d: "m269.4 151.7 8.6 16.5h79.2l9.2-15.9c-5.4-3.7-9-6.5-16.7-4.8-4.3-6.2-9-7.3-16-6.7-2.1-2.1-4-3.4-7.6-4l-16.6.5c-4.4.4-7.8 3.8-8 3.8-7-.9-13.5-.7-15.2 6.2-6.5-1.6-11 .2-16.9 4.4z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M378 135.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm.6 8a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-2.5 7.2a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-3 6a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.7 0zm-3.7 7.5a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-46.8-9.6a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M323.6 143a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M322.7 132a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 1.1,
      d: "M315.5 109v-4.2l-3.6-.1.2-3.2h3v-2.8h4.5v2.5h3.5l-.1 3.4h-3.6v4.5h-4z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#fd0",
      strokeWidth: 3.3,
      d: "M277.6 168.2c-7.1-12-17.6-28.4-11-35.5 8.9-10.1 29.9-1 43.3-6.8 1 11.4-2.2 30.4 2.9 34.3l-4.8 4.2c-3-3.7-8.4-8.8-15.2.2-4-3.4-8.3-2.8-10.4 1.7-2 .3-1.9 1.1-4.8 1.9zm80-.5c7.2-12 17.6-28.3 11.1-35.4-9-10.1-30-1-43.3-6.9-1 11.5 2.2 30.5-3 34.4l4.8 4.2c4.7-6.5 10.4-6.7 15.3.2 3.9-3.4 7.9-3 10.4 1.7 2 .3 1.8 1 4.8 1.8z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M277.3 177.1a437 437 0 0 1 79.3 0l3.1-9c-27.7-5-46.8-5.6-83-.6z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#c76e2e",
      fillRule: "evenodd",
      d: "m314.1 329.4.6-4.2c2.9.8 5 .5 7.4-.4l2.4-3.7-1.8-2.1c-1.6.3-3 1.8-4 3.1-1.6.1-3-.7-4.6-1l-1.5-6.4c-1.5-1.8-4.7-1.7-4 1.5l.3 2.5c.6 1.5.9 3.6 1.9 4.7v2.6zm1.2-18.3c-2 1-4.6-.8-7.3-1.9-2.5-.1-4.4 2-7.4 1.3.6-1.6 1.9-1.9 2.8-2.8-.7-4.1 1.5-5.5 2.1-5.5.6 0 3.1.6 3.1.6l2.4.3c1.5 2.7 3.5 5 4.3 8"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#ffe100",
      fillRule: "evenodd",
      stroke: "#e9bf00",
      strokeWidth: 2.4,
      d: "M300.8 366c7-11.4 56.2-34.4 102.4-84.2-47 45.3-76.4 56.4-114.8 84l12.4.3z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#9d4916",
      fillRule: "evenodd",
      stroke: "#68300e",
      strokeWidth: 1.1,
      d: "M368.4 313.2a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm34.4-34.9a4 4 0 1 1-8.1 0 4 4 0 0 1 8 0zm11.4-29.6a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zM403 210.3a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#a9a9a9",
      strokeWidth: 1.1,
      d: "M279.1 269.6v-15.2l-1.5-1.2v-3.6l2.8-.3.5-17-1.8-1-.2-2.8s2 .8 2 .3l.5-3.4s-1.3-.2-1.3-.7 1.6-1.8 1.6-1.8-.8-.8-1-1.3l-.8-2.8.8-2.9-.5-1.5-1.3-2.3 1.8-1.8-.5-2.8a10 10 0 0 1 1.5-2.9c.3-.2 2.3-3 2.3-3l4.4-1 5.1.7 2.8 1.8.5 4.6s-.5 2.8-.7 2.8l-2.3 1s-2.6.3-2.9 0 .8 3.2.8 3.2v3l-.2 3.9s0 1.8-.3 2-.8 1-.8 1l-.2 4 4 1-.2 2.3-2.8.2.5 15.7 4.1.7v4.4l-1.8 1-.5 15.7zm62.4.3v-15.2l-1.5-1.3v-3.6l2.8-.2.5-17-1.8-1-.2-2.8s2 .7 2 .2l.5-3.3s-1.3-.3-1.3-.8 1.6-1.8 1.6-1.8-.8-.7-1-1.3l-.8-2.8.8-2.8-.6-1.5-1.2-2.3 1.8-1.8-.6-2.9a10 10 0 0 1 1.6-2.8l2.3-3 4.4-1.1 5.1.8 2.8 1.8.5 4.6s-.5 2.8-.7 2.8l-2.3 1s-2.6.3-2.9 0 .8 3.1.8 3.1v3.1l-.3 3.9s0 1.7-.2 2l-.8 1-.2 3.9 4 1-.2 2.3-2.8.3.5 15.6 4.1.8v4.4l-1.8 1-.5 15.7zm-31.6.5v-15.2l-1.5-1.2v-3.7l2.8-.2.5-17-1.8-1-.2-2.8s2 .8 2 .3l.5-3.4s-1.2-.2-1.2-.7 1.5-1.9 1.5-1.9-.8-.7-1-1.2l-.8-2.9.8-2.8-.5-1.5-1.3-2.3 1.8-1.8-.5-2.9a9 9 0 0 1 1.5-2.8c.3-.2 2.3-3 2.3-3l4.4-1 5.1.7 2.8 1.8.6 4.6s-.6 2.8-.8 2.8l-2.3 1s-2.6.3-2.8 0 .7 3.1.7 3.1v3.1l-.2 3.9s0 1.8-.3 2l-.8 1-.2 3.9 4 1-.2 2.3-2.8.3.5 15.7 4.1.7v4.4l-1.8 1-.5 15.7H310z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fillRule: "evenodd",
      d: "M283 269.5v-12h6.6V270zm31.4 1 .3-12.2h6v11.9l-6.3.2zm31-.3-.4-11.5 6.5-.2v12l-6-.3zm-60.8-36h3.8v6.1h-3.8zm30.3.2h5.3v6h-5.3zm31 .5h4.6v5.7H346z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#a8a8a8",
      strokeWidth: 1.1,
      d: "M286.6 207c4 4.6 4.3 4.6 4.3 4.6m26.2-4.6c.8 1.5 2 4.8 3.6 5.1m29.3-4.4s1.3 3.6 3 4.1"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#b97700",
      fillRule: "evenodd",
      d: "M282.2 194c12-3.9-2.8-11.6-5.3 0-3.8.7-4.3 3.5-12.7 2.3-20.4 33-5.3 86.5 54.1 141.8-106.4-90.6-63.2-157.6-33.7-155 16 1 8 21-2.4 11z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M285.6 177s9.7 2.7 9.7 6.8m0-7.5s6.8 3 8.3 5.6m45.1-4.5s-8.6 1.2-10.5 3.8m-2.6-3s-5 4.1-4.5 5.3m3.4 12.7c-.8-.3-4.2-4.9-3.4-10.5m-29.8 7.5s2.3-2.6 2.3-7.5m13.5-1.9.4 11m9.4-1.6c0-.7 3-7.9-.4-11.3m-20.3-1.5s-2.6 7.2-.7 13.2m20-6.8s-4.2 1.2-6 3m-11.8-1.9c0-.3 4.6-1 6 1.6"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#c76e2e",
      fillRule: "evenodd",
      d: "M300.6 301.9c.2 0 3.8-.7 3.8-2.4 1.8-1.2.5-4.5.5-4.5l-3.4-.6-4.6-5.2c-.2-1.6.3-3.1-.7-4.8-3.2.8-5 3.5-6 6.5.7 1 .8 2 2.3 2.9 1.5.2 2.5-.7 3.9-.4.7 1.3.5 2.4.8 3.6 1.9 1.3 2.3 3.2 3.4 4.9m-4.1-22.2v-6.2l-4.4-.2c-.6 1-1.6 1.4-2.2 2.2l-3.1 1.6c1.3 1.5 2.9 2.4 3.8 3.2 2.3.6 4.1.6 5.9-.6m-13.8 9.1-2.4-4a7.2 7.2 0 0 1 4.7.3s1 2.5.3 3.4c-.4.9-2.7.5-2.6.3m36.5 4.1a4.6 4.6 0 0 0 2.7-3.3l-4.5-5.1-4-.1c-1-1-2.4-1.2-3.6-1.2 0 0 1.2 2 2.8 2.3 1.2 2.6 6.2 7.4 6.6 7.4m4.3.6c0-.1 4-1.4 6-1.3-.1-1.6 3-5.3 3-5.3l5.6 7.3c-1 .8-2.8.6-4.2.8 0 0-2.7 2.6-3 2.7s-5.2 1.3-7.6-.2c-1-2 .3-4.3.2-4m3.2-12.8a14 14 0 0 0 0-7.6h-6.4l-4.2 2s1.3 4.2 3 3.8c.7 2.1 2.9 1.6 4 2.4zm24.9-6.4c-1 2.7-1.4 5.5-.2 8 1.2.3 2.6 1 3.6.8l5.1-9.2c-3.5-1.1-6.4-1-8.6.4z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#b97700",
      fillRule: "evenodd",
      d: "M353.1 193.2c-12-3.9 2.8-11.7 5.3 0 3.9.6 4.4 3.5 12.8 2.3 20.3 33 5.2 86.5-54.2 141.8 106.5-90.6 63.2-157.6 33.7-155.1-16 1-8 21 2.4 11"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#c76e2e",
      fillRule: "evenodd",
      d: "M354.3 284.7c-.2 0-3 2-3 2l-4.2 1.7-4.4.1-1-3 3.4-3c-2.8-.5-5.7.7-8 2.8 0 0 0 3.3 2 5 1.1 1.4 4.5 4 4.5 4a7 7 0 0 0 5.4-1zm-23.2 30.1c1.4.4 11.3-12.7 11.3-12.7a10 10 0 0 0-4.9-5.4s-4.8 5.7-4.9 7.6c-.8 1.7-3 8.3-2 9.2-.1.2-.5 2.9.5 1.3"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M266.4 317.4c-14.8-12.9-34.8-20-62.7-10.3 7.5 3.2 15.6 4.3 22.5 7.9z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M223.4 308.3c29.3.6 37.8 7.9 36.3 6.7"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.2,
      d: "M267 319c-8.8 1.6-20.8 10-24.4 9.7-9.5-1.1-18.5-5-27.7-8-3.8-1.2-7.7 0-11.6 0 32.8-15.5 44-13.4 63.7-1.8z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M245.4 296s-11 1.6-15.9 1.9c-4.8-.3-12-4.8-19.8-13-4-4.6-13.4-4-13.4-4 20.6-4.4 36.7-.2 49 15.2zm-15-21.2c-14.9-1-33.5-14.3-37.7-30.2 0 .2 5.5 3.5 4.6 4.3 24.4 6.2 26 11.2 33.1 25.9zm25 25.5c2.1-13.5 2.7-22.4-3.6-30.4-5.3-6-6.6-9.7-10.4-18.3-1.1 17.8-5 32.5 14 48.7zM232 263c11-16.1 13-28.3 11.2-47.5-.3 1.5-4 11-4.2 11-16.5 10.3-9.2 26.5-7 36.5z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M222.2 185c11 16.1 9.4 31.3 7.6 50.5-.3-1.5-4-11-4.2-11-16.5-10.3-5.5-29.5-3.4-39.5z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M231.3 210c26.8-13.6 16.5-30.7 21.4-44-18.6 13.9-21 28.6-21.3 44z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M235 206.6c3.4-9.5 10-25.6 10.7-25.6M227 226.4c-.6-6.7-4-24.7-4.3-26.5"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M228.3 256.5c-15-1-31-21.3-35.3-37.1 0 .2 5.5 3.4 4.6 4.2 21.4 9.6 23.6 18.2 30.7 32.9zm-4.4-14c-11-16.1-13-28.3-11.3-47.5.3 1.5 4 11 4.3 11 16.4 10.3 9.1 26.5 7 36.5zm9.9-28.3c27.7-12.3 19.2-25.2 27.4-38.7-18.6 13.8-27.1 23.4-27.4 38.7z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M235 211.4a70.7 70.7 0 0 0 15.2-20.7"
    }),
    /* @__PURE__ */ jsxs215("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx222("path", {
          fill: "#ffe100",
          stroke: "#e9bf00",
          strokeWidth: 2.4,
          d: "m333.6 366.4 13.4.2c-44.7-42-130.5-60.2-118.6-137.4-12.3 83.7 70.1 91.5 105.2 137.2z"
        }),
        /* @__PURE__ */ jsx222("path", {
          fill: "#9d4916",
          stroke: "#68300e",
          strokeWidth: 1.1,
          d: "M235.4 212.7a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0zm-2.6 23.6a4 4 0 1 1-8.1 0 4 4 0 0 1 8 0zm3.8 33.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm31.3 37.2a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm4.5 10.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs215("g", {
      fill: "#fff",
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsxs215("g", {
          stroke: "#000",
          strokeWidth: 1.1,
          children: [
            /* @__PURE__ */ jsx222("path", {
              d: "M288.2 349a15.5 15.5 0 0 1-4.8-5.8l-14-1.5-.2 8z"
            }),
            /* @__PURE__ */ jsx222("path", {
              strokeLinejoin: "round",
              d: "M185.3 339.6c8.2 1.5 20.5-.8 24.5 4.5 4.8 5.4-15.1 13.9-12.3 18.6 6.2 6.5 12.5 3.8 19.4.2 1.7-3.5 3-9.8 3.8-11.7-2.5-5.7-9.3-8.6-7.5-17.3 11.3-4.2 33.2-3.9 35.6-2.2 1.8 3.6.1 5.2.5 8.1-1.9 3.7-6.7 9.8-6.7 13.1 12 4.2 15-.6 25.8-.4 12.6.2 20.2 3.6 23-1.4-2-4.4-13.5-.8-17.8-3.6-2.2-.7-3.6-2.5-5.5-4.4s-7.2-2-8-6.9c2.2-10.2 17-8.6 19.3-10.2l38.4 2.7c7-.2 11 12.3 1.5 16-9.4 3.8-37.1-5.5-49.2.9-.6-2.6-9.3-6.6-9.9-6.7-3.7 1-10.9.7-10.9.7-1.7 3.2-3.8 5.6-5.5 8.9-8-3.5-15.5 2.7-24.2.9l-13.6 1.5-8.6-.8-13.2 3.8 9.4-8.3z"
            }),
            /* @__PURE__ */ jsx222("path", {
              d: "M184.7 338a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-1 18a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.3 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs215("g", {
          stroke: "#000",
          strokeWidth: 1.1,
          children: [
            /* @__PURE__ */ jsx222("path", {
              d: "M346.3 349.1c2.3-2.1 3.8-3.5 4.7-5.8l14-1.6.3 8z"
            }),
            /* @__PURE__ */ jsx222("path", {
              strokeLinejoin: "round",
              d: "M449.1 339.6c-8.1 1.5-20.4-.7-24.4 4.5-4.9 5.5 15 14 12.2 18.6-6.2 6.6-12.5 3.9-19.4.3-1.6-3.5-2.9-9.8-3.8-11.7 2.6-5.8 9.3-8.6 7.6-17.3-11.4-4.3-33.3-4-35.6-2.3-1.9 3.7-.2 5.3-.6 8.2 2 3.6 6.8 9.8 6.8 13-12 4.3-15.1-.6-25.8-.3-12.6.2-20.3 3.5-23-1.5 1.9-4.3 13.4-.8 17.8-3.5 2.2-.8 3.6-2.5 5.5-4.5s7.2-2 8-6.8c-2.2-10.2-17-8.7-19.4-10.2l-38.4 2.6c-7-.2-10.9 12.3-1.5 16.1 9.4 3.8 37.2-5.6 49.2.8.7-2.6 9.3-6.5 10-6.7 3.6 1.1 10.8.7 10.8.7 1.8 3.3 3.8 5.7 5.6 9 8-3.6 15.5 2.7 24.2.8l13.5 1.5 8.7-.7 13.2 3.7-9.4-8.2 8.2-6z"
            }),
            /* @__PURE__ */ jsx222("path", {
              d: "M449.7 338a3.6 3.6 0 1 0 7.3 0 3.6 3.6 0 0 0-7.3 0zm1 18a3.6 3.6 0 1 0 7.2 0 3.6 3.6 0 0 0-7.2 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "M317 329.3c-3.2-.6-4.4-.4-6.6-.6l-5.1 15.8c8 .7 15.3.7 15.3.7-4.8-1-3.7-15.8-3.6-15.9"
        })
      ]
    }),
    /* @__PURE__ */ jsxs215("g", {
      fontFamily: "Trebuchet MS",
      fontSize: 9,
      fontWeight: "bold",
      children: [
        /* @__PURE__ */ jsx222("path", {
          d: "M283.4 340.2v-10.7h1.8v9h5v1.7z",
          "aria-label": "L"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "M291.7 340.7V330h1.9v10.7z",
          "aria-label": "I"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "M300 341.5h-3.3V331l3.2-.2q1.7 0 2.5.7 1 .8 1 2.1 0 1.2-1.3 2 2 .7 2 2.9 0 1.5-1.2 2.3-1 .8-2.8.8zm-1.3-9.1v2.5h1q1.7 0 1.7-1.4 0-1.1-1.7-1.1zm0 4v3.5h1q1.2 0 1.7-.4.7-.3.7-1.3t-.5-1.3q-.5-.5-1.9-.5z",
          "aria-label": "B"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "M308.6 333v2.7h3.4v1.7h-3.4v3.1h5v1.7h-6.9v-10.7h6.7v1.7z",
          "aria-label": "E"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "m322.2 342.4-2.8-4.5H318v4.5h-1.8v-10.7h1.2l1.6-.2q4.2 0 4.2 3.2 0 1-.5 1.7-.7.8-1.5 1.1l3.3 4.9zm-4.2-9v2.8h.9l1.6-.2q.7-.3.7-1.3 0-.8-.5-1.2-.7-.3-2-.3h-.7z",
          "aria-label": "R"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "M329.9 333v9h-2v-9h-3.4v-1.6h8.9v1.6z",
          "aria-label": "T"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "m340.7 340.5-.8-2.1h-3.7l-.7 2.1h-2.1l4.3-10.8h.8l4.4 10.8zM338 333l-1.1 4h2.5z",
          "aria-label": "A"
        }),
        /* @__PURE__ */ jsx222("path", {
          d: "m344.4 339.7.6-1.7q1.2.7 2.2.7 1.7 0 1.7-1.2l-.4-1-1.6-1.1-1.7-1-.7-1-.1-1.2q0-1.3.8-2.2 1-.6 2.3-.6 1.9 0 2.9.6l-.7 1.7q-1-.8-2.2-.8-.6 0-1 .3-.3.3-.3 1 0 .8 2 1.8 1.2.5 1.7 1l.6 1 .2 1.4q0 1.3-1 2.1t-2.7.9q-1.6 0-2.6-.9z",
          "aria-label": "S"
        })
      ]
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M231.3 318.6c10.1 1.2 24.1.3 30.2 0M216 284.2c8.6 6.7 27.1 10.7 26.8 10.7m10.7 1.8c-2.8-14-5.8-17.4-8.3-26.2m-43.5-15.8c14.3 6.4 16.5 10.6 25.6 17m5.2-14c1.2-17.3 3.6-21.9 7.9-25.9m-38.7-2c5.2 5.7 22.2 23.7 22.2 23.7m-7-39.6c6.4 4.5 6.4 21 6.4 21"
    })
  ]
});
var Sm_default = SvgSm;

// src/country-flag-icons/generated/Sn.tsx
import { jsx as jsx223, jsxs as jsxs216 } from "react/jsx-runtime";
var SvgSn = (props) => /* @__PURE__ */ jsxs216("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs216("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx223("path", {
          fill: "#0b7226",
          d: "M0 0h213.3v480H0z"
        }),
        /* @__PURE__ */ jsx223("path", {
          fill: "#ff0",
          d: "M213.3 0h213.3v480H213.3z"
        }),
        /* @__PURE__ */ jsx223("path", {
          fill: "#bc0000",
          d: "M426.6 0H640v480H426.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx223("path", {
      fill: "#0b7226",
      d: "M342 218.8h71.8l-56.6 43.6 20.7 69.3-56.6-43.6-56.6 41.6 20.7-67.3-56.6-43.6h69.8l22.7-71.3z"
    })
  ]
});
var Sn_default = SvgSn;

// src/country-flag-icons/generated/So.tsx
import { jsx as jsx224, jsxs as jsxs217 } from "react/jsx-runtime";
var SvgSo = (props) => /* @__PURE__ */ jsxs217("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx224("defs", {
      children: /* @__PURE__ */ jsx224("clipPath", {
        id: "so_svg__a",
        children: /* @__PURE__ */ jsx224("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs217("g", {
      fillRule: "evenodd",
      clipPath: "url(#so_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx224("path", {
          fill: "#40a6ff",
          d: "M-128 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx224("path", {
          fill: "#fff",
          d: "M336.5 381.2 254 327.7l-82.1 54 30.5-87.7-82-54.2L222 239l31.4-87.5 32.1 87.3 101.4.1-81.5 54.7z"
        })
      ]
    })
  ]
});
var So_default = SvgSo;

// src/country-flag-icons/generated/Sr.tsx
import { jsx as jsx225, jsxs as jsxs218 } from "react/jsx-runtime";
var SvgSr = (props) => /* @__PURE__ */ jsxs218("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx225("path", {
      fill: "#377e3f",
      d: "M.1 0h640v480H.1z"
    }),
    /* @__PURE__ */ jsx225("path", {
      fill: "#fff",
      d: "M.1 96h640v288H.1z"
    }),
    /* @__PURE__ */ jsx225("path", {
      fill: "#b40a2d",
      d: "M.1 144h640v192H.1z"
    }),
    /* @__PURE__ */ jsx225("path", {
      fill: "#ecc81d",
      d: "m320 153.2 56.4 173.6-147.7-107.3h182.6L263.6 326.8z"
    })
  ]
});
var Sr_default = SvgSr;

// src/country-flag-icons/generated/Ss.tsx
import { jsx as jsx226, jsxs as jsxs219 } from "react/jsx-runtime";
var SvgSs = (props) => /* @__PURE__ */ jsxs219("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx226("path", {
      fill: "#078930",
      d: "M0 336h640v144H0z"
    }),
    /* @__PURE__ */ jsx226("path", {
      fill: "#fff",
      d: "M0 144h640v192H0z"
    }),
    /* @__PURE__ */ jsx226("path", {
      fill: "#000001",
      d: "M0 0h640v144H0z"
    }),
    /* @__PURE__ */ jsx226("path", {
      fill: "#da121a",
      d: "M0 168h640v144H0z"
    }),
    /* @__PURE__ */ jsx226("path", {
      fill: "#0f47af",
      d: "m0 0 415.7 240L0 480z"
    }),
    /* @__PURE__ */ jsx226("path", {
      fill: "#fcdd09",
      d: "M200.7 194.8 61.7 240l139 45.1L114.9 167v146z"
    })
  ]
});
var Ss_default = SvgSs;

// src/country-flag-icons/generated/St.tsx
import { jsx as jsx227, jsxs as jsxs220 } from "react/jsx-runtime";
var SvgSt = (props) => /* @__PURE__ */ jsxs220("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx227("path", {
      fill: "#12ad2b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx227("path", {
      fill: "#ffce00",
      d: "M0 137.1h640V343H0z"
    }),
    /* @__PURE__ */ jsx227("path", {
      fill: "#d21034",
      d: "M0 0v480l240-240"
    }),
    /* @__PURE__ */ jsxs220("g", {
      id: "st_svg__c",
      transform: "translate(351.6 240) scale(.34286)",
      children: [
        /* @__PURE__ */ jsxs220("g", {
          id: "st_svg__b",
          children: [
            /* @__PURE__ */ jsx227("path", {
              id: "st_svg__a",
              fill: "#000001",
              d: "M0-200V0h100",
              transform: "rotate(18 0 -200)"
            }),
            /* @__PURE__ */ jsx227("use", {
              xlinkHref: "#st_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx227("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx227("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        }),
        /* @__PURE__ */ jsx227("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        }),
        /* @__PURE__ */ jsx227("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        })
      ]
    }),
    /* @__PURE__ */ jsx227("use", {
      xlinkHref: "#st_svg__c",
      width: "100%",
      height: "100%",
      x: 700,
      transform: "translate(-523.2)"
    })
  ]
});
var St_default = SvgSt;

// src/country-flag-icons/generated/Sv.tsx
import { jsx as jsx228, jsxs as jsxs221 } from "react/jsx-runtime";
var SvgSv = (props) => /* @__PURE__ */ jsxs221("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx228("path", {
      fill: "#0f47af",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsxs221("g", {
      transform: "matrix(.8 0 0 .8 -92.7 0)",
      children: [
        /* @__PURE__ */ jsxs221("g", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx228("path", {
              d: "M515 353.4c1.5 0 3.2 0 10.1-1.7 7-1.7 12.7-5.9 14-6.5 1.4-.6 3.3-.4 3.3-.4a8.4 8.4 0 0 0-5.8-2.8c-3 0-1.9 0-4.4 1.1-2.6 1-8 4.3-17 4.3h-.1c-9 0-14.7-3.2-17.2-4.3-2.6-1-1.4-1-4.4-1-3 0-5.1 1.9-6 2.7 0 0 2-.2 3.4.4 1.4.6 7.1 4.8 14 6.5 7 1.7 8.6 1.7 10.1 1.7z"
            }),
            /* @__PURE__ */ jsx228("path", {
              d: "M488.4 347.4c.7-.4-.2-1.6-.2-1.6l2.7-.6c-1.3-.6-3.3-.4-3.3-.4-.5.4-.4.9-.5 1.3 0 .4 0 1 .2 1.3.3.3 1 0 1 0z"
            }),
            /* @__PURE__ */ jsx228("path", {
              d: "m491 345.2-2.8.6s.9 1.2.2 1.7l4.8-1-2.3-1.3zm50.7 2.2c-.7-.4.1-1.6.1-1.6l-2.7-.6c1.4-.6 3.3-.4 3.3-.4.6.4.5.9.6 1.3 0 .4 0 1-.3 1.3-.3.3-1 0-1 0z"
            }),
            /* @__PURE__ */ jsx228("path", {
              d: "m539.1 345.2 2.7.6s-.8 1.2-.1 1.7l-4.8-1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m495.8 343.3-1.2 3 .6.3c.9.3 1.8.1 2.2-.9.4-1-.1-1.8-1-2.1zm.3.6c.8.4 1.2.9.9 1.7-.3.8-1 .8-1.7.5h-.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m497.6 347.6-.4-.1 1.4-3 .3.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M500.2 345.3c-.6 0-1.2.4-1.5 1-.4 1 0 1.9.8 2.3.8.3 1.8 0 2.2-1a1.7 1.7 0 0 0-.9-2.2 1.5 1.5 0 0 0-.6-.1m0 .5h.5c.6.3.8 1 .5 1.6-.2.6-1 1-1.5.7-.5-.3-.8-1-.5-1.6.2-.4.5-.7 1-.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "M503.8 347.4c0-.3-.1-.4-.3-.5-.3-.1-.6 0-.7.2l.2.6.3.2c.3.3.5.7.3 1.2a1 1 0 0 1-1.3.6 1 1 0 0 1-.6-1.2h.4c-.1.4 0 .7.4.9.3 0 .6-.1.7-.4.2-.4 0-.6-.2-.8l-.2-.2c-.3-.2-.5-.5-.3-1 .1-.5.7-.6 1-.5.4.2.6.4.7.8zm2.4.1-.5 1.9c-.1.5-.1 1 .4 1.2.6.1.9-.3 1-.8l.6-1.9.3.2-.5 1.9c-.2.7-.8 1.1-1.5 1-.7-.3-1-1-.7-1.6l.6-2zm4.4 4.5-1.8-3-.5 2.4h-.4l.7-3.4 1.8 3 .4-2.4h.4zm.8 0 .4-3.2h.3l-.4 3.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M514.2 348.9a1.6 1.6 0 0 0-1.7 1.6c0 1 .7 1.7 1.6 1.8.8 0 1.6-.7 1.6-1.7 0-.9-.7-1.7-1.5-1.7m0 .5c.6 0 1 .6 1 1.2a1.1 1.1 0 0 1-1.1 1.2c-.6 0-1.1-.6-1.1-1.3 0-.6.5-1.2 1.1-1.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m519 352.1-2.4-2.3.1 2.4h-.4l-.2-3.4 2.5 2.4-.2-2.4h.4zm2.1-.5-.6-3.2h.4l.6 2.8.9-.2v.4zm1.8-.3-.8-3.2h.4l.7 3.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M523.9 347.7h-.4l-.4.2.9 3.1.7-.1c.5-.2 1-.6.8-1.2-.1-.4-.4-.7-.8-.6l.1-.8c-.2-.5-.5-.6-1-.6zm0 .4c.2 0 .4 0 .5.4.2.4-.1.5-.4.6h-.1l-.3-1h.1a1 1 0 0 1 .2 0m.5 1.3c.3 0 .6 0 .6.4.2.4-.1.5-.4.6l-.3.1-.3-1h.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m527.2 348 .2.3-1.2.4.4 1.2 1.2-.5.1.4-1.5.6-1.1-3.1 1.6-.6v.3l-1.1.5.3.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M528.6 346.2c-.3 0-.5 0-.8.2l-.4.1 1.2 3h.3l-.4-1.4 1.4.9.5-.1-1.5-1c.4-.2.6-.7.4-1.1a.9.9 0 0 0-.7-.6m0 .4.3.3c.2.5-.2.7-.5.8l-.5-1h.1l.5-.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m529.2 345.8 1.7-.8.2.3-.7.3 1.2 2.7-.3.1-1.2-2.6-.7.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m532.2 344.2.2 3.7.4-.2v-.8l1.3-.7.6.6.4-.3zm.4.9 1 .8-.8.5-.1-1.3zm2.7-2.2-1 .3-.5.3 1.7 2.8.5-.3c.9-.5 1.3-1.4.7-2.3-.4-.6-.9-.8-1.4-.8m.2.5c.3 0 .6.2.8.5.4.8 0 1.3-.6 1.7l-1.3-1.9h.1z"
        }),
        /* @__PURE__ */ jsxs221("g", {
          id: "sv_svg__a",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          children: [
            /* @__PURE__ */ jsx228("path", {
              fill: "#e60000",
              fillRule: "evenodd",
              strokeWidth: 0.1,
              d: "M485 355.2c.6 0 1-.4 1-1a.9.9 0 0 0-1-.8c-.4 0-.8.4-.8.9s.4.9.9.9zm-5 6.3c.5 0 .9-.4.9-1a1 1 0 0 0-1-.8 1 1 0 0 0-.9.9c0 .5.5.9 1 .9zm-12-19.9c.5 0 1-.4 1-.9a1 1 0 0 0-1-.9.9.9 0 0 0-.8 1c0 .4.3.8.9.8zm-7.3 3.7c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 0 0-1 1c0 .6.4 1 1 1zm-1.4-22.3a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-6.2 1.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm3.2-19.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .5.4 1 1 1zm-5.5-18.3c.5 0 1-.4 1-1a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .6.4 1 1 1zm7 1.8a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm7-15.2c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 1 0 0 2zm-5.3-4.2a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm10.5-10.3a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-21.5 46.3c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 0 0-1 1c0 .6.5 1 1 1z"
            }),
            /* @__PURE__ */ jsx228("path", {
              fill: "none",
              strokeWidth: 0.3,
              d: "M486 358.9s-.8-3.2-.7-3.9l.8-.6m-1.4 5.7s-2.8.1-3.7.4l-.3.8m-13.4-15.5s-.2-3.8.6-4c0 0 .7-.4 1.2-1m-4.7 3.8s-2.1-.3-2.7 0c0 0-.2.6-.6.8m-.8-23-.7.5c-.8.3-2.3 4-2.3 4s-2.4-1.9-3.4-2h-1.1m-4.8-20.2s.6.6 1.2.3c0 0 3 2 3.1 2.7 0 0 3.2-3.2 3.8-2.9 0 0 .3.5 1-.1m-5.8-18.6s.3.5.9.8c0 0 1.4 2 1.4 3.5 0 0 2.5-2.3 3.3-2.1 0 0 .9.3 1.5 0m.3-19.5s.6.8 1 .2c0 0 1.8 2.2.8 4 0 0 2.5-.7 3.3-.3 0 0 .3 1 1.2.5"
            }),
            /* @__PURE__ */ jsxs221("g", {
              fill: "#1f601a",
              fillRule: "evenodd",
              strokeWidth: 0.3,
              children: [
                /* @__PURE__ */ jsx228("path", {
                  d: "m532.8 378.3-4.5-.3c-.6 0-2-2.7-2.6-3.1-.6-.5-10.8-5.5-17.5-6.5a95 95 0 0 1-19-6 88 88 0 0 1-26-19.2c-2.9-4.2-6-14-7.2-19.2-.7-2.5-4-12.4-4-19.2a84 84 0 0 1 2.2-19.4 111 111 0 0 1 15.3-26.8s-12 18.7-14.2 25.9a81 81 0 0 0-2.5 21.5c.1 4.2 3.6 19.6 8.7 30.9 4.1 9 7.7 10.2 14 15.2 3 2.4 8.8 6.2 13.6 8.6 4.8 2.4 15 5.5 17.8 5.9 2.7.5 16.4 4.5 18.2 5.4 1.8 1 6.5 5 7.7 6.3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M464.1 343.4c.3-1.4.4-2.4 1-2.8a14 14 0 0 0 2.2-3.5c.3-1.2 0-2.2 0-2.8l.4-2.7s-.7-2.5-1.3-3c-.6-.4-2.2-2.6-2.5-3.2 0 0 .2 1.3-.3 1.9a7 7 0 0 0-.6 3c0 .9.3 3 0 4-.3 1.2-.7 2.2-.4 3.5zm-.5-1.5s-3.4-4.4-3.4-6.2c0-1.8-.3-2.9-.6-3.3-.3-.4-2.3-2.7-.5-5.6.8-1.2 1-1 1.4-2.4.6-1.6 1.8-1.6 2-3.3 0 0 .4 2 .5 3.6.2 1.7-.1 2.3-.2 3.2-.2.9.4 2 .4 3.3 0 1.4-.2 1.9-.2 2.7 0 .4-.5 6.2.6 8zm38.6 23.5-4-.5c-.7 0-2.5-.5-3.5-.9a10 10 0 0 1-4-2.8c-2.8-3-2.5-4.5-3-4.6-1-.2 1.5-.4 2.8-.3 1.1.2 2.8 1 3.8 2 1.2 1.1 3 2.3 3.5 2.7.6.5 1 .7 1.7 1.5.7 1 .6 1.5 2.7 3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M506.2 367.5s-7.2-3.2-8-3.8a25 25 0 0 1-2.8-2.6c-.7-.8-3.8-2.4-4.3-3.4-.3-.7-2.3-3.3-3.4-5.4-.5-1 4.9.3 4.9.3 4.4 1.8 2.4.6 4.8 2.4 1.5 1.1 2.5 2 2.9 2.9.6 1.3 1.2 3.5 1.9 4.7.6 1.2 1.7 2.7 4 5z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M510.2 368.4s-6-1.5-8.8-5.2c-2-2.6-2-1.8-2.7-2.7-1-1-2.6-2.3-4-4.5.2.3-1.6-5.9-1.6-6.6 0-.4 2.3.3 4.2 1 1.5.7 2.4 2 3.8 2.8 1.6 1 1.8 3.7 2.5 4.9 1 1.8 1.2 2.7 1.2 3.5 0 1.4.8 1.8 1.2 3 .5 1.3 2.1 1 4.2 3.8zm-9.6-2-5.9-2.4c-.8-.1-1-.6-2.1-.9-.9-.2-1.7-.9-3.8-.4-.9.2-4.6 1-5.5.6-1-.5 1.3 2.5 2.3 3.1 1.1.7 2.9 1 4.4.8h4.4c.7 0 1.2.2 2.3-.1 1-.3 1.3-.8 3.9-.7z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M504 366.4s-5.7-1.4-6.7-1.4l-4.8.4c-1 .2-4.5-.2-5.5.4-1 .4-5.6 1-6.8.8-1.2-.3 2.4 3.2 3.9 3.6 4.6 1.3 3.2 1.1 6.2.4 1.8-.5 4.4-.6 5.4-.8.9-.1.7-.7 2-1.2 1.1-.5 3.2-1.8 6.3-2.2z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M508.7 368.8s-5.7-2.4-10.2-1.1l-4.2 1c-1.4.1-2.6-.6-5 .4-1.2.4-6.2 2.5-7.5 2.4-1.3-.1 4 3.3 5.4 3.1 4.6-.6 9 1 11 0l4-1.5c1-.4 1.5-1.2 2.1-1.7.6-.4 1-1.6 4.4-2.6zm-30.6-13.1s-3.3-3.6-4-4.1l-3-2.4c-.6-.6-1.3-2-3.4-2.5-1-.2-3.1-.6-3.8-1.4-.6-.8.1 3 .8 4a8.1 8.1 0 0 0 3.6 2.5c1.5.5 3.3 1.5 4 1.9.6.3 1 .6 2 .8 1.1.2 1.6 0 3.8 1.2z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M481.3 357.2s-5.7-4-6.5-4.4l-3.5-1.3c-1.1-.3-4-2.3-5-2.3-1.2 0-3.3-.1-4.3-.8-1-.8-.1 2.7 1 3.7 3.6 3.2 1.1 2.2 4.1 2.8l5.1 1.7c1 .3 1-.3 2.3-.2 1.3 0 3.8-.2 6.8.8z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M482.6 358.3s-2.3-1.6-6.9-2.4c-3-.5-3-.6-4.1-1-1.4-.4-1.7-.4-4.3-.5-1.2-.1-6.2 1.5-7.4.8-1-.6 1.3 1.5 2.6 2 2 .8 1.8 2 4 2.8 2.2.7 4.7 1.6 6 1.4 1-.2 1.8-.7 3.3-.8 1.4-.2 4-2.3 6.8-2.4zm.5-1.2s1.1-5.5.1-6.8a5.2 5.2 0 0 1-1.2-2.9 11 11 0 0 0-1.6-4.3c-.6-.8-1.8-4.2-1.5-5.1 0 0-3.2 3.1-3 5.1v2.4c-.2.9.7 3.9 1.3 4.8.6 1 .3 3.6 1 4.2.5.6 4.1 3 4.9 2.6z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M482.6 358.3c.3.1-2-1.8-3-2.3-1-.4-5.3-1.6-5.6-2.7-.3-1-3.7-4.6-3.9-5.6 0-.6-.7-2-.6-2.8.2-.7.5-2.6 1-3.6.4-1.1 1.4-3.6 2.5-4l1.2 3.8c.3 1 .6 2.3 1 2.9.5.6 2 3.4 2.1 4.5l1.1 5.3c.1.7 3 3.8 4.2 4.4zM464 343.4c.1.8-2.3-.8-3.5-.8-1.2 0-4.8.5-5.7-.4-.9-1-2.2-2.6-2.7-2.9-.5-.3-2.1-3-2.6-4.5-.4-1.5-3.6-4.2-4-4.5 0 0 4.3-.9 7 .9s3 1.4 3.5 1.6c.6.3 5.3 4.3 5.6 5.8.3 1.5 2.2 4 2.4 4.8z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M464.1 343.4s-3.9-2.7-4.8-2.6c-1 .2-5.2-3-5.4-5-.2-1-2.2-2.5-2.6-3.1-1-1.8-1.7-5.9-3.2-7l5.2 1.3c2 .3 3.6.6 4.3 2.2.8 1.7 1.4 3 2 3.2.6.2 1.5 2.3 1.8 4.4a32 32 0 0 0 2.7 6.6zm-7.4-20.5c.7 1 .6-6 .9-6.8a11.3 11.3 0 0 1 1.7-2.8c.6-.6.6-2.7.9-3.3.3-.6.1-4.7-.3-5.8L458 306c-.6.7-1.7 1-2 2-.3.8-.9.8-1.3 1.8a5.6 5.6 0 0 0-.6 3.6c.3 1.2.1 1.6.1 2.7 0 1 1.5 5.6 2.4 6.9z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M456.9 323.5s-.3-2 .4-2.7c.8-.8 1.5-.8 1.8-1.2.3-.5.2-1 .5-1.7.3-.6 1-1.6 1-2 .3-1.7 1.3-3.6.5-5.3 0 0-1.7.5-2.1.8-.5.3-1.8 1.6-2 2.8-.1 1.3-.3 1.5-.7 2.2-.5.8-1 3-.3 4.4a7.4 7.4 0 0 1 .9 2.7zm-4.4-23s-.3-4.4.9-5.8c1.2-1.3 1.5-3.9 4.2-5.3v1.9c.2.7.5 2.8 0 3.6-.4.7-2 2-2 2.7 0 .6-1 2.1-1.7 2.4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M452.5 302.8s0-3 .9-4c.9-.9 1.4-1.4 1.8-2 .5-.5 1-2 2-2.7 1-.6 2.8-2.1 3-2.7 0 0 .4 3.8-.6 5.8s-1 3-2.3 3.4c-1.2.5-1.4.8-1.8 1-.5.4-1.2.8-1.8.8-.6 0-1.2.4-1.2.4zm3.5 20.6c.1.8.7-2-2.4-2-3.2 0-5.8-1.2-6.8-2.3l-2.1-2.3a9 9 0 0 1-1.8-3.1c-.2-.9-1-4.2-1-4.8 0 0 1.7.3 2.5.9.7.6 2 .6 2.8 1 .8.5 1.4 1.7 1.9 2.1.4.5 1.7.5 2.3 1.4.6.9 1.7 2.9 1.9 3.8 0 .9 1.2 1.8 2 2.2.6.5.5 2.3.6 3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M455.6 322.1s-2-2.5-3.1-2.5c-1 0-3.8-2.7-4-4 0-1.1-1-3.4-1.6-3.9a3.6 3.6 0 0 1-1.5-3.3c.2-1.8.2-4.8.2-4.8s.6 1.8 1.5 2.3c.9.4 2.5 1 2.8 1.6.3.6 1.5.6 2 2.5.5 1.7.5 1.6.8 2.2.3.6 1 1.4 1.3 2.6.3 1.2 2 4.3 1.7 7.3zm-3-16.6c-.2.8 1.1-1.6-1.7-2.4a9.6 9.6 0 0 1-5.6-4l-1.3-2.6a9 9 0 0 1-.7-3.4c0-.9.2-4.1.5-4.6 0 0 1.4.7 2 1.4.4.8 1.7 1.2 2.3 1.8.5.6.7 1.9 1 2.5.3.5 1.5.9 1.8 1.8.3 1 .7 3.1.6 4-.1.8.6 2 1.2 2.6.5.6-.1 2.2-.2 3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M452.6 304.3s-1.3-2.9-2.2-3.2c-1-.3-2.5-2.7-2.6-3.9-.1-1.2-.3-3.4-.7-4-.5-.6-1.3-2.4-.6-4l1.6-3.7 1.3 2.1c.8 1.6 1.6 1.7 1.7 2.3.1.7 1 1 1.4 2.3.5 1.7 0 1.6 0 2.3.2.6.7 1.5.6 2.7 0 1.1.6 4.5-.5 7.1zm2.3-18.2c.1-.4 1-.9 2.1-1.2 1-.3 2.7-2.7 3.5-3.3.7-.6 1-1.6 2-2.1.9-.5 1.4-2.4 1.7-4.2l-3.3.7a7.2 7.2 0 0 0-2.8 1.8c-.6.8-1.2 2-1.9 2.3-.6.3-1.3 2.1-1.3 3.3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "m454.8 284.8-.2-2.6c0-.9-.6-3.3.7-5.3 1-1.3 4.3-3.9 5.2-4 0 0 .6 2.4.4 3.1-.1.8-1 3.8-1.6 4.1-.7.3-2.4 3.9-4.5 4.7z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M454 286.1c-.4.7-.1-2.2-1-3-1-.7-1-1.8-1-3s.2-2 .3-2.9c.2-.7 2.5-3.9 2.3-4.8l1.7 3.8c.4 1-.3 2.1-.2 3 .2.9.9 2.6.3 3.5L454 286zm8-15.5s.2-.4 1.5-.4 3.3-.1 3.9-.8c.6-.6 1.6-1.4 2.3-1.7a5.2 5.2 0 0 0 1.8-2.2c.1-.6 1.2-1.8 1.6-1.8 0 0-1.6-.2-3.4.3-1.8.5-4.4 1.4-5 2.6-.6 1.2-2.7 4-2.7 4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M462.5 270.3c.3 1 2.8-1 3.4-1.8l1.5-2 1.8-2.4c1-1.6.7-4.6.3-4.3a31 31 0 0 1-2.5 1.4c-.5 0-1.4.4-1.7 1.1-.3.8-.6 1.8-1 2.3-.5.5-3.2 2-1.8 5.7z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  d: "M461.6 270.3s2-1.5 2.8-2.3c1-.8.5-2 1-2.6.3-.6 1.4-2 1.1-3l-.9-3.4-1.8 1.8c-.8.8-.9 1.4-1.2 2.3-.3.9-1 1.5-1.2 2.2-.3.8 0 2.3.2 3.2z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs221("g", {
              fill: "none",
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx228("path", {
                  d: "M494.8 365.2s-10-.1-10.8-1.3m16.6 2.6s-6.5 1.7-10 1.3c-3.5-.4-5.1.3-5.9.3-.7 0-4.5-1.5-4.5-1.5m27 2.2-6 1.3c-1 .3-6.2 2.2-7.7 2.2h-5a18 18 0 0 1-6.3-.4m6.2-15s3.7 2.3 4.4 3c.5.8 3.8 3.5 4.5 3.5m-9-11.1s6.5 5.6 7.6 6.3c1 .8 7.4 7 8.1 7.8M493.6 350s5.1 4 5.7 5.7c.6 1.7 2.2 3.6 2.2 3.6s2 4.2 2.8 4.8c.8.6 2.3 2.2 4.1 3.4m-44-21.3s5.4 4.6 6.9 5.4m-9.1-2.5s5.4 3.7 7.8 4.6c2.4 1 4.4 1.7 9.6 2.4m2.1 2.2s-6-.3-7 0-5.8-.8-7-1.1l-6.6-1.4m11.4-17.9s-.3 3.3.2 4.7c.4 1.3 2.6 5.3 2.4 6.2-.1.9 1.2 5 2.4 5.7m1.2-16s-1 3.3-.6 4.4c.5 1 1.2 3 1.2 4.2 0 1.2.8 3 1 3.8.4.7-.1 3.3.7 4l1.6 2.2m-36.1-26.3s4.8 1.9 5.4 3c.6 1.3 1.5 1.6 2 2.2m10.3-9.7s1.3 4.9 1 6c-.3 1.2-.3 3.7-.3 4.6 0 .9-1.4 4.5-1.3 5m-1.3-19.6-.6 4c-.1 1.2 0 3.2-.3 4-.3.7-.8 4.8 0 6.6M449 326.2l4.8 4.2c.9 1 5 5.3 5.1 6.4.1 1 3 4.3 3.9 5m-20.5-32.5s4 4 4.2 4.9c.3.9 2 2.3 2.8 2.8m11.4-6s-1.5 2.3-1.5 3c0 .8-.6 2.7-1.2 3.5-.4.5-1.7 2.7-1.5 4m3-16.8-1 3.6c-.2 1.5-1 3-1.3 4-.3.8-1.5 5.2-1 7.9m-10.4-15.7s.4 2.1 1.5 3.2c1 1 2.7 2.6 2.8 3.4.2 1 1.6 5.4 3 7a5.4 5.4 0 0 1 1.7 3m-10.5-32s.4 2.6.7 3.4c.3.7 1.5 4 2.7 5.1m9.5-7.7-.9 3c-.1 1-1 2-1.2 2.4l-.7 2m5.5-5.3c-.1.9-1.8 3.6-2 4-.1.5-1 2.6-1.9 3.2-.9.6-3.6 2.6-3.4 3.4m-4.4-16.5s-.2 3.3.4 4.5a37.2 37.2 0 0 1 1.7 4c.3.9.3 2.4.4 3.4.2 1.1.6 3 1.2 3.8m11.8-25.9-3.2 3.5c-1 1-4.8 5-5 5.8m4.6-11.6s-2.1 4.7-2.6 5.4l-.9 2m-2-7.5s.2 3.6 0 4.5a7.9 7.9 0 0 0 0 2.9c.2.4-.4 3.7-.5 4.5m18-21.3s-4.8 2.9-5.5 3.6m2.7-7.3-3.3 4.8-.8 1.4m.3-6.7s-1 2.6-1.2 3.6a36 36 0 0 1-2.2 5.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  strokeWidth: 0.3,
                  d: "M469.2 258s-.4 1 1.4.7"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx228("use", {
          xlinkHref: "#sv_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1030 0)"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 370s-6.2 3.7-3 9l-2.1-1.3s-1.2 2.2-.1 3.4c0 0-4.3-3.8-1-8.3 3.4-4.6 6-4.3 6-4.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 367s-2.7-1.8-6.6-.7c0 0-1.7-5.6-1-7.4.2-.8.8-.9.8-.9s-2-1.2-1.3 4c.6 5.4 1.6 6.8 1.6 6.8s5.2.3 6.4-.3l.1-1.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 367s-5.4-9-6.8-9c0 0-1.5-.2 2-.6 1.2-.1 3.2 0 4 1.7 1 1.6 1.7 5.5 2 6.1 0 0-1 .3-1.2 1.9z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#011322",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 367s-3.6-1.6-4-2c-.5-.5-1.2-5.6-.8-5.3 0 0-1.5-1.7-2-1.7-.3 0-1.3.8-1 2.6.3 1.8.7 4.5 1.2 5.7 0 0 2.9-1.2 6.6.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M517.7 370s2 1.3 2 3.5c0 2.3.9 6.4 2.7 7.3 0 0 .5-1.7 1-2 0 0 1.9 2.1 2.5 2.1 0 0-1-2-1-2.9 0-.9-1-4.3-2-5.2-.8-1-2.6-3-5.2-3.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#011322",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "m518.5 359.5-1.7 6.5.5 1.4s.6-.2.9-1c.3-.7 1.2-6.3 1.7-6.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#011d33",
          fillRule: "evenodd",
          d: "M514.4 369.3s-3 1-4.1 3.2c0 0-.4-1.5 4-3.6v.4zm3.4 0s2 .8 2.6 2l-2.6-1.5zm-3.4-1.7s-4.6.7-5.6.5c0 0 1.3.3 5.6 0zm7.4-2.8s.5 2.3.9 2.2c.4-.2 1.2-3.9 1.2-5.6 0-1.7-.7-2.1-1.4-2-.7 0-1 1.5-1 2.2a49 49 0 0 0 .3 3.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#011d33",
          fillRule: "evenodd",
          d: "M516.8 366s1.9 4.1.5 4.4c-1.4.2.6.1-.4-2.7-.4-1.1-1-2.5-1.3-2.5 0 0 1.1.4 1.2.8"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs221("g", {
      transform: "matrix(.8 0 0 .8 -92.7 0)",
      children: [
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M509.8 255.9c-.4-1-.4-7.4-.4-8.4a68 68 0 0 1 3.8-11.2c.6-1 .5-1.2.7-1.8l.9-1.2a10.9 10.9 0 0 1 1.3 4.1s-.6 4.1-1.1 6c-.4 1.7-1.6 4.3-1.8 4.8-.6 1.2-.5 2.4-.2 2.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m515 247.3.5.6c1.3-1.5 1.4-4.5 1.4-4.5l-.9-6s-.5 4-1 6c-.4 1.7-1.6 4.3-1.8 4.8-.9 2.2-.2 2.4-.2 2.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M515.5 247.9c1.3-1.5 1.4-4.5 1.4-4.5s1 5 .4 6c-.5 1-.5.7-.4 1.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.3,
          d: "M517 250.7c-.2-.6-.2-.3.3-1.3s-.4-6-.4-6l-.9-6c0-1.3-.6-3-1.2-4.1l-.9 1.2c-.2.6 0 .8-.7 1.8-.6 1-3.6 9.5-3.8 11.2 0 1 0 7.5.4 8.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m515 234.1-.2-1.3c0-.2.6.9 1 .7.9.3 1.9 1.5 2.1 1.8-.4.5-1.3 1.6-2 1.4-.5-.2-.4-1-.5-1.5-.1-.3-.4-.6-.4-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m515 233.3.4.4c.2.2.4 0 .7.2.6.4.9.8 1.6 1.5m-2-1.4c.8.4 1.2 1 1.8 1.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m514 233.4 1.3-.6c.1 0-.7.8-.4 1.2 0 .9-.7 2.2-1 2.5-.6-.1-1.2-.1-1.8-1.1-.2-.4.4-.8.8-1.1.2-.2.7-.8 1.2-.9z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m514.9 233.2-.3.5.1.7c-.2.7-.5 1-.9 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M514.4 234c0 .9-.5 1.5-1 2.3h.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M515.4 232.8c.6-.7 1.7-1.4 2.3-1l.6.6c.2.3.2.5 0 .8-.3.8-1.4.4-2 0-.2 0-.6-.4-.8-.3l-.3.1.3.1 1.8.9c.5.2 1.5-.5 1.4-1 0-.5-.9-1.5-1.3-1.5-1 0-1.8.6-2.5 1.4.2-.2.4 0 .5 0z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M514.9 232.8c-.6-.7-1.7-1.4-2.2-1l-.6.6c-.3.3-.3.5-.1.8.3.8 1.4.4 2 0 .2 0 .6-.4.8-.3l.4.1-.4.1-1.8.9c-.5.2-1.4-.5-1.4-1 0-.6 1-1.5 1.4-1.5 1 0 1.7.6 2.4 1.4-.1-.2-.4 0-.5 0z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M515 232.4c-.2-.1-.5.1-.6.3 0 .2.1.6.4.6.3.2.8 0 .9-.3 0-.4-.3-.5-.6-.6z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          d: "M515 226.3s.4 2.4 1.6 4c1.2 1.8-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M515 226.3s.4 2.4 1.6 4c0 0-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m515 228.8.7 1.8s-.6.4-.7.7c0 0-.3-.8-.6-1 0 0 .6-.8.6-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m515 344.5-.3-.2c-.4-.2-1.2-.2-1.3-.5-1-1.1-.4-3.4 0-4.8 1-2.6 1-5 1.6-7.4.6 2.4.7 4.8 1.6 7.4.4 1.4 1.1 3.7.1 4.8-.2.3-.9.3-1.3.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M515 331.5c.6 2.5.7 5 1.6 7.6.4 1.3 1 3.4.3 4.5.4 0 .7-.1 1-.3.2 0 .3 0 .4-.2l.4-.5c.3-.2.6 0 .9-.2l.1-.2c.6-.3 1-.6 1.3-1.1.1-.4.2-.9 0-1.3 0-.3 0-.5-.2-.8l-.5-1.1-.6-1.2a2.4 2.4 0 0 0-.3-.5l-.3-.6-.4-.4-.4-.3s-.3-.1-.2-.2l-.3-.1-1-2a3 3 0 0 1-.2-1.1zm0 0c-.5 2.5-.7 5-1.6 7.6-.3 1.3-1 3.4-.2 4.5-.4 0-.7-.1-1.1-.3-.1 0-.3 0-.3-.2a1.4 1.4 0 0 0-.5-.5c-.2-.2-.5 0-.8-.2l-.2-.2c-.5-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.6-1.1.6-1.2c0-.2.1-.4.3-.5l.3-.6.4-.4.4-.3.2-.2.2-.1 1-2c.2-.2.2-.8.2-1.1z"
        }),
        /* @__PURE__ */ jsxs221("g", {
          id: "sv_svg__b",
          fill: "none",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx228("path", {
              stroke: "#011322",
              d: "M514.3 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#011d33",
              d: "M514.4 331.6s-1 4-1.6 5.1c-.6 1.1-3 3-1.4 6"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#022743",
              d: "M514.5 331.6s-1 4.1-1.6 5.2c-.6 1-2.9 3.1-1.3 6"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#033054",
              d: "M514.6 331.6s-1 4.2-1.6 5.3c-.6 1-2.9 3-1.2 6.1"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#053a65",
              d: "M514.7 331.6s-1 4.3-1.6 5.3c-.6 1-2.8 3.2-1.2 6.3"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#011d33",
              d: "M514.2 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#022743",
              d: "M514 331.6s-.9 3.8-1.6 5c-.6 1-3 3-1.4 5.9"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#033054",
              d: "M514 331.6s-1 3.7-1.7 5c-.5 1-3 3-1.4 5.9"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#053a65",
              d: "M513.8 331.6s-.8 3.6-1.6 5c-.6 1-3 3-1.4 5.9"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#00209f",
              d: "M513.8 331.6s-.9 3.4-1.7 5c-.6 1-3 2.9-1.4 5.8"
            }),
            /* @__PURE__ */ jsx228("path", {
              stroke: "#00209f",
              d: "M514.8 331.6s-1 4.3-1.6 5.4c-.6 1-2.8 3.3-1.1 6.3"
            })
          ]
        }),
        /* @__PURE__ */ jsx228("use", {
          xlinkHref: "#sv_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1030 0)"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "m518.6 335.2.5.5.3.5.3.5.6 1.2.5 1.1.3.8a2.5 2.5 0 0 1-.1 1.3c-.2.5-.8.8-1.3 1.1l-.1.2c-.3.2-.6 0-.9.2a1.9 1.9 0 0 0-.4.5l-.3.2c-.4.2-.7.3-1.1.3l-.2.3c-.2.2-1 .2-1.3.4l-.4.2-.3-.2c-.4-.2-1.2-.2-1.3-.4a.7.7 0 0 1-.2-.3l-1.2-.3s-.2 0-.3-.2a1.4 1.4 0 0 0-.4-.5c-.3-.2-.6 0-.8-.2l-.2-.2c-.6-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.5-1.1.7-1.2c0-.2.1-.4.3-.5 0-.2.1-.4.3-.5 0-.2.3-.3.4-.5"
        }),
        /* @__PURE__ */ jsxs221("g", {
          id: "sv_svg__c",
          children: [
            /* @__PURE__ */ jsxs221("g", {
              fillRule: "evenodd",
              children: [
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fff",
                  d: "M487.4 293.6c-1.5-3.7-3-11.3-3-13 .3-7.1.2-9.3.9-16.5l7.3 8.3c-.2 2.8-.2 3.7 0 5.5.1.7.5 3.9 1 5.1z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#00209f",
                  d: "M493.6 283c-.5-1.3-.9-4.5-1-5.1-.2-1.8-.2-2.7 0-5.5l4.5 5zm-18.6 7a75.6 75.6 0 0 1-.3-4.4c0-5.1-.6-8 0-13.4.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l9 10.1c-.6 7.3-.5 9.5-.8 16.6 0 1.7 1.5 9.3 3 13l-2 3.2zm6.3 13.7c-.6-1-1-3.9-1.2-4.5-.3-1.5-.3-2.3-.2-5l5 3.3zm-14.3 24a5.2 5.2 0 0 1-1.8-2.2c-.7-1.8-.5-1.7-1-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.8-6.2-.2-4.8-1.8-8-1.4-13.2.3-4 1.2-9.4.7-13.5l.1-3.6 10.3 6.7c-.4 6.8-.2 8.8-.2 15.4 0 1.6 1.3 8.1 3 11zm17 3.8c1.9 1.7 5.4 2.6 6 3 1.2 1 3 2.3 6.3 2.4 2.3.2 3.3-.4 5.7-.7 2.8-.3-.3.1 2.3-.5 1.4-.3 1.4-.5 3.2-1 1.3-.3 2.7-.6 3.5-1.8.3-.4.6-.7.6-1.4h1.8c.2.5-.3 1.5-.5 1.8l-.5.7c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.7.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#00209f",
                  d: "M497.7 331.5h14c-.1.7-.4 1-.7 1.5-.8 1-2.2 1.4-3.5 1.7-1.4.4-2.9-.4-4.4-.4-3.7-1.1-4.1-2.3-5.4-2.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fff",
                  d: "M497.7 331.5c1.3.6 2 1.7 5.4 2.8 1.3 0 2.8.6 4 .6-1.5.3-1.5.5-2.8.8-2.6.6.5.2-2.3.5-2.4.3-3.4 1-5.7.8a11 11 0 0 1-6.3-2.5c-.6-.4-4.1-1.3-6-3z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs221("g", {
              fill: "none",
              strokeMiterlimit: 2.6,
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M476.6 259.7s1.7 15 7.5 14.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M484.2 274c-3 .2-4.9-3.5-6-7a46.3 46.3 0 0 1-1.5-7.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M484.2 274c-3-.1-4.9-3.8-5.8-7a43.6 43.6 0 0 1-1.7-7.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M484.2 274c-2.9-.3-4.9-4.1-5.8-7.2a48.2 48.2 0 0 1-1.7-7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "M484.2 273.9c-2.9-.5-4.9-4.4-5.8-7.2a43 43 0 0 1-1.7-7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "M484.2 273.8c-3-.6-4.9-4.6-5.7-7.1-1.1-3.2-1.8-7.1-1.9-7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04345b",
                  d: "M484.2 273.8c-2.9-.9-4.9-4.9-5.6-7.2a46 46 0 0 1-2-7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04365e",
                  d: "M484.3 273.7c-3-1-5-5-5.7-7.3a48.7 48.7 0 0 1-1.9-7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "M484.3 273.7c-3-1.2-5-5.4-5.6-7.3a47.5 47.5 0 0 1-2-7.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "M484.3 273.6c-3-1.3-5-5.6-5.6-7.3-1-2.8-2-6.8-2-7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053d6a",
                  d: "M484.3 273.6c-3-1.6-5-6-5.5-7.4a50.3 50.3 0 0 1-2.1-7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M484.3 273.5c-3-1.7-5-6.2-5.4-7.4a45.7 45.7 0 0 1-2.2-7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M484.4 273.5c-3-2-5-6.4-5.5-7.5a66 66 0 0 1-2.2-7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M476.7 259a47 47 0 0 0 2.3 6.9c.3.8 2.4 5.4 5.4 7.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M476.9 256.3s4.8 12 8 10.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "M484.8 266.9c-1.3.5-3.3-1.8-5-4.6a65.2 65.2 0 0 1-3-6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M484.8 266.8c-1.2.5-3.2-1.8-4.9-4.6a86 86 0 0 1-3-6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M484.8 266.8c-1 .4-3.2-1.7-4.9-4.7a91.5 91.5 0 0 1-3-5.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M484.8 266.8c-.8.3-3.1-1.7-4.8-4.8-2-3.4-3-5.8-3-5.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M484.9 266.7c-.7.3-3.1-1.7-4.8-4.8l-3.1-5.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M484.9 266.7c-.6.3-3-1.7-4.8-4.9a749.5 749.5 0 0 0-3.2-5.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053d6a",
                  d: "M484.9 266.7c-.4.2-3-1.6-4.7-5a281 281 0 0 0-3.2-5.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "M484.9 266.7c-.2 0-2.9-1.6-4.7-5L477 256"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M477 255.9s1 1.4 3.3 5.7a13.6 13.6 0 0 0 4.5 5m8 12.1 3.8-.7m-4-3.1 4.1 2.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "m492.5 275 4.2 2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "m492.5 275.2 4.2 2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "m492.5 275.4 4.2 1.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "m492.6 275.6 4.2 1.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "m492.6 275.8 4.2 1.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "m492.6 276 4.3 1.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "m492.6 276.1 4.3 1.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "m492.6 276.3 4.4 1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "m492.6 276.5 4.4.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "m492.8 278.5 3.9-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "m492.8 278.3 4-.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "m492.8 278.1 4-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "m492.8 278 4-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M492.8 277.7h4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "m492.8 277.5 4.1.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "m492.8 277.3 4.2.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "m492.7 277.1 4.3.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "m492.7 276.9 4.4.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "m492.7 276.7 4.4.7m-22.1.4s.2 3.2.9 4.5c1 1.9 3.9 4.7 7.2 6.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M483.2 289.1a27.2 27.2 0 0 1-5.5-4.6 13.7 13.7 0 0 1-1.7-2.3c-.7-1.4-1-4.5-1-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M483.3 289.1a27.2 27.2 0 0 1-5.4-4.7 9.3 9.3 0 0 1-1.7-2.3c-.8-1.4-1.2-4.5-1.2-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M483.3 289.1a31.3 31.3 0 0 1-5.3-4.7 12 12 0 0 1-1.7-2.4c-.8-1.5-1.3-4.5-1.3-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "M483.4 289a31.3 31.3 0 0 1-5.3-4.7 13.6 13.6 0 0 1-1.7-2.4c-.8-1.5-1.4-4.4-1.4-4.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "M483.5 289c-2.1-1.3-4-3.5-5.3-4.8a10 10 0 0 1-1.6-2.4c-1-1.5-1.6-4.4-1.6-4.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04345b",
                  d: "M483.6 289c-2.1-1.4-4-3.6-5.3-4.9a15.1 15.1 0 0 1-1.6-2.3 21.4 21.4 0 0 1-1.7-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04365e",
                  d: "M483.6 289c-2-1.4-4-3.7-5.1-5a14 14 0 0 1-1.7-2.3c-1-1.7-1.8-4.5-1.8-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "M483.7 289c-2-1.4-4-3.8-5.1-5a15 15 0 0 1-1.6-2.4 26 26 0 0 1-2-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "M483.8 289c-2-1.5-4-4-5-5.1a13.8 13.8 0 0 1-1.7-2.4c-1.1-1.8-2-4.5-2-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053d6a",
                  d: "M483.9 289c-2-1.5-4-4-5-5.2a16.8 16.8 0 0 1-1.7-2.4c-1-1.8-2.1-4.5-2.1-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M484 289c-2-1.5-4-4.2-5-5.3a18.7 18.7 0 0 1-1.7-2.4l-2.2-4.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M484 289c-2-1.6-3.9-4.3-4.9-5.4a16.1 16.1 0 0 1-1.6-2.4l-2.4-4.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M475 276.7s3 5.3 4.3 6.8c1 1 2.8 4 4.8 5.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011d33",
                  d: "m475.2 290 10.2 6.6 2-3-1-2.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011e34",
                  d: "m475.2 289.9 10.2 6.5h.1l1.7-3s0-.3-.3-.7l-.6-1.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022037",
                  d: "M475.2 289.9c2.9 1.9 4.1 2.7 10.2 6.4l.1-.1 1.6-2.9-.2-.7a18.1 18.1 0 0 1-.6-1.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022139",
                  d: "M475.2 289.9c2.8 1.8 4.3 2.8 10.2 6.3l.1-.1 1.5-2.9-.2-.7-.5-1.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02223b",
                  d: "M475.2 289.8c2.7 1.8 4.5 2.9 10.2 6.3l.1-.2 1.4-2.8-.1-.7a8.2 8.2 0 0 1-.5-1.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02233d",
                  d: "M475.3 289.8c2.5 1.7 4.6 3 10.1 6.1h.1c0-.3 1.3-2.9 1.3-3l-.1-.5a9.6 9.6 0 0 1-.4-1.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022540",
                  d: "M475.3 289.8c2.4 1.6 4.7 3 10.2 6v-.1l1.2-2.8v-.6a5 5 0 0 1-.4-1.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022541",
                  d: "M475.3 289.8c2.3 1.6 5 3 10.2 5.9v-.2l1.1-2.8v-.5a4.8 4.8 0 0 1-.4-1.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M475.3 289.8a110 110 0 0 0 10.2 5.8v-.2l1-2.8v-.5a4.1 4.1 0 0 1-.3-1.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M475.3 289.7a92.6 92.6 0 0 0 10.2 5.8v-.2c0-.3 1-2.8 1-2.8v-.5c-.3-.3-.3-.7-.3-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "M475.3 289.7a80.5 80.5 0 0 0 10.2 5.6.3.3 0 0 0 0-.1c0-.4.8-2.8.8-2.8s.2-.1 0-.4v-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032a4a",
                  d: "M475.3 289.7a80 80 0 0 0 10.2 5.5v-.2l.7-2.7s.2-.1 0-.4v-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M475.4 289.7a67.8 67.8 0 0 0 10 5.4l.2-.2.5-2.7s.2-.1.1-.4c-.1-.3 0-.5 0-.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M475.4 289.7a62.4 62.4 0 0 0 10 5.3l.2-.2.4-2.8s.3 0 .2-.3c-.2-.3 0-.4 0-.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "M475.4 289.7c1.7 1 6 3.6 10.1 5.2v-.2l.4-2.7s.3 0 .2-.3c-.1-.3 0-.3.1-.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "M475.4 289.6a54.3 54.3 0 0 0 10.1 5.1.5.5 0 0 0 0-.2l.3-2.7.2-.2c-.1-.3 0-.3.2-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033156",
                  d: "M475.4 289.6c1.5 1 6.3 3.8 10.1 5a.5.5 0 0 0 0-.2l.2-2.7s.4 0 .3-.2c-.2-.3 0-.2.1-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "M475.4 289.6a45 45 0 0 0 10.1 4.9l.1-.2v-2.7s.4 0 .3-.2c-.1-.2.1-.1.3-.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M475.4 289.6c1.3.9 6.7 4 10.1 4.7l.1-.2-.1-2.6s.4 0 .3-.1c0-.3.2-.1.3-.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M475.4 289.6c1.2.8 6.8 4 10.1 4.6l.1-.2-.3-2.6.5-.1c-.1-.3.2 0 .3-.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04365e",
                  d: "M475.4 289.6c1.1.7 7 4 10.1 4.5l.1-.2c0-.7-.3-2.6-.4-2.6h.5c0-.3.2 0 .4-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M475.4 289.6c1 .6 7.2 4.1 10.1 4.4l.1-.3c0-.6-.4-2.5-.5-2.6 0 0 .6.2.5 0 0-.1.3.2.5-.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "M475.4 289.6c1 .5 7.3 4.2 10.1 4.3l.2-.3a12.5 12.5 0 0 0-.7-2.6s.6.2.5 0c0-.1.4.3.6 0"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M475.5 289.5c.8.5 7.4 4.3 10 4.2l.2-.2c0-.8-.7-2.6-.8-2.6s.6.2.6 0c0 0 .3.4.6 0"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "M475.5 289.5c.7.5 7.6 4.4 10 4.1l.2-.3c0-.7-.8-2.4-.9-2.5l.6.1c0-.1.5.3.7 0"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "M475.5 289.5c.6.4 7.8 4.4 10 4l.2-.3a6 6 0 0 0-1-2.5l.7.1c0-.1.4.4.7.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "M475.5 289.5c.5.3 8 4.5 10 3.9a.5.5 0 0 0 .2-.3c0-.8-1-2.5-1.1-2.5l.7.1s.5.6.8.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M475.5 289.5c.4.2 8 4.6 10 3.8l.2-.4c0-.8-1.1-2.4-1.2-2.5l.7.3s.6.6.9.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6f",
                  d: "M475.5 289.5c.3.2 8.2 4.6 10 3.6l.2-.3c0-.9-1.2-2.4-1.3-2.5l.7.3s.6.6 1 .4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "M475.5 289.4c.2.2 8.4 4.8 10 3.6a.7.7 0 0 0 .2-.3c0-1-1.3-2.4-1.4-2.5l.8.3s.6.7 1 .4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064374",
                  d: "M475.5 289.4c.1 0 8.6 4.9 10 3.5l.2-.3c0-1-1.4-2.4-1.6-2.5l1 .3s.6.8 1 .6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M475.6 289.4s9.7 5.5 10.1 3c0-1-1.6-2.4-1.6-2.4l.9.3s.6 1 1 .6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011d33",
                  d: "m474.4 315.1-7.5 12.6a5.2 5.2 0 0 1-1.8-2.2c-.6-1.7-.5-1.7-1-3.6l-.4-3.4c-.3-1.2-1.9-4.8-2-6.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011d33",
                  d: "M461.8 312.3c0 1.4 1.6 5 1.9 6 .2 1.2.2 2.4.5 3.5.4 1.9.3 1.8 1 3.6a5.2 5.2 0 0 0 1.7 2.2l7.5-12.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011e34",
                  d: "M461.8 312.3c0 1.4 1.6 5 1.8 6 .3 1.2.3 2.3.6 3.4.4 1.8.3 1.8 1 3.6.2.8 1.2 1.8 1.7 2.1l7.5-12.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011e34",
                  d: "M461.8 312.3c0 1.4 1.6 4.9 1.8 6 .3 1 .3 2.2.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.2l7.5-12.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011f36",
                  d: "M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1.1.3 2.3.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.1l7.5-12"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#011f36",
                  d: "M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.8 1.7 2.1l7.5-11.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022037",
                  d: "M461.8 312.3c0 1.3 1.5 4.7 1.8 5.8.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.7 1.7 2 .2.1 7.4-11.6 7.5-11.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022037",
                  d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7l.6 3.3c.4 1.7.4 1.7 1 3.3.2.8 1.2 1.8 1.7 2.1.2 0 7.3-11.5 7.5-11.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022139",
                  d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .2.1 7.3-11.3 7.5-11.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022139",
                  d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.6.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3a5.4 5.4 0 0 0 1.7 2c.3 0 7.3-11.2 7.5-11.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022139",
                  d: "M461.8 312.3c0 1.3 1.5 4.5 1.8 5.6.3 1 .3 2 .6 3.1.5 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .3 0 7.2-11 7.5-11.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02223b",
                  d: "M461.8 312.3c0 1.3 1.5 4.4 1.8 5.5.3 1 .3 2.1.6 3 .5 1.8.4 1.8 1 3.3a5 5 0 0 0 1.7 2c.3.1 7.2-10.9 7.5-11"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02223b",
                  d: "M461.8 312.3c0 1.2 1.5 4.4 1.8 5.4.3 1 .3 2.2.6 3.1.5 1.7.4 1.7 1 3.2a5.2 5.2 0 0 0 1.7 2c.3.1 7.2-10.8 7.5-10.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02233d",
                  d: "M461.8 312.3c0 1.2 1.5 4.3 1.8 5.4l.6 3c.5 1.7.4 1.7 1 3.2a5.1 5.1 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02233d",
                  d: "M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3.2a7 7 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02233e",
                  d: "M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3a6 6 0 0 0 1.8 2c.3.1 7-10.3 7.4-10.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#02233e",
                  d: "M461.8 312.3c0 1.1 1.4 4.2 1.8 5.2l.6 3 1 3a5 5 0 0 0 1.8 2c.4 0 7-10.3 7.4-10.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022540",
                  d: "M461.8 312.2c0 1.2 1.4 4.2 1.8 5.3l.6 2.9 1 3a5.2 5.2 0 0 0 1.8 2c.4 0 7-10.1 7.4-10.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022540",
                  d: "M461.8 312.2c0 1.2 1.4 4.2 1.8 5.2l.6 2.9 1 3c.4.7 1.3 1.5 1.8 1.8.4.2 7-9.8 7.4-10"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022540",
                  d: "M461.8 312.2c0 1.2 1.4 4.1 1.8 5.1l.7 2.9c.4 1.5.4 1.6 1 3a5 5 0 0 0 1.7 1.8c.4.1 7-9.7 7.4-9.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022541",
                  d: "M461.8 312.2c0 1.2 1.4 4 1.8 5l.7 3 1 2.9a5.2 5.2 0 0 0 1.7 1.8c.4.1 6.9-9.6 7.4-9.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022541",
                  d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.8 1 3c.3.6 1.2 1.5 1.7 1.8.5 0 6.9-9.5 7.4-9.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.7c.4 1.5.5 1.5 1 2.9a6 6 0 0 0 1.7 1.8c.5.1 6.8-9.3 7.4-9.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.6 1 3a5 5 0 0 0 1.7 1.6c.5.2 6.8-9 7.4-9.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022845",
                  d: "M461.8 312.2c0 1.1 1.4 3.9 1.8 4.8l.7 2.8 1 2.8a4.9 4.9 0 0 0 1.7 1.7c.6.2 6.8-9 7.4-9.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022845",
                  d: "M461.8 312.2c0 1.1 1.4 3.8 1.8 4.8l.7 2.7c.4 1.4.5 1.4 1 2.7a5.3 5.3 0 0 0 1.7 1.8c.6.2 6.7-8.9 7.4-9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.7l.7 2.7 1 2.7a4.8 4.8 0 0 0 1.7 1.7c.6.2 6.7-8.7 7.4-8.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.7 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.2 6.7-8.6 7.4-8.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.6 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.1 6.7-8.4 7.4-8.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "M461.8 312.2c0 1 1.3 3.6 1.8 4.6l.7 2.5 1.1 2.7c.4.6 1.1 1.3 1.7 1.6.6.2 6.6-8.2 7.3-8.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "M461.8 312.2c0 1 1.3 3.5 1.8 4.5l.7 2.5 1.1 2.6c.4.6 1.1 1.4 1.7 1.6.7.3 6.5-8 7.3-8.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032a4a",
                  d: "M461.8 312.2c0 1 1.3 3.5 1.8 4.4l.7 2.5c.5 1.3.5 1.4 1.2 2.6.3.6 1 1.4 1.6 1.6.7.2 6.5-8 7.3-8.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032a4a",
                  d: "M461.8 312.2c0 1 1.3 3.4 1.7 4.4l.8 2.4 1.2 2.6a5 5 0 0 0 1.6 1.6c.7.2 6.5-7.8 7.3-8.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M461.8 312.2c0 1 1.2 3.4 1.7 4.3.4.8.5 1.7.8 2.4l1.2 2.6c.3.6 1 1.2 1.6 1.5.7.3 6.4-7.6 7.3-8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M461.8 312.2c0 1 1.2 3.3 1.7 4.3.4.7.5 1.6.8 2.3l1.2 2.6c.3.5 1 1.2 1.6 1.5.8.2 6.4-7.5 7.3-7.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "M461.8 312.2c0 1 1.2 3.3 1.7 4.2.4.8.5 1.6.8 2.4l1.2 2.4c.3.6 1 1.3 1.6 1.6.8.2 6.4-7.4 7.3-7.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "M461.8 312.2c0 .9 1.2 3.2 1.7 4.1l.9 2.4c.4 1.2.5 1.3 1.1 2.4a5.2 5.2 0 0 0 1.6 1.5c.8.3 6.3-7.2 7.3-7.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "M461.8 312.2a13 13 0 0 0 1.7 4l.9 2.4c.4 1.2.5 1.2 1.1 2.4a4.7 4.7 0 0 0 1.6 1.4c.9.4 6.3-7 7.3-7.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M461.8 312.2c0 .9 1.2 3.1 1.7 4 .4.8.5 1.6.9 2.3.4 1.2.5 1.3 1.1 2.3.3.6 1 1.3 1.6 1.5.9.3 6.3-6.8 7.3-7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M461.8 312.2c0 .8 1.2 3 1.7 4 .4.7.5 1.5.9 2.2.4 1.2.6 1.2 1.1 2.4a5 5 0 0 0 1.6 1.4c1 .3 6.3-6.7 7.3-7.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "M461.8 312.2c0 .8 1.2 3 1.7 4 .4.6.5 1.4.9 2.1.4 1.2.6 1.2 1.1 2.3a5.4 5.4 0 0 0 1.6 1.5c1 .2 6.3-6.6 7.3-7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.8.5 1.5.9 2.2.4 1.2.6 1.3 1.1 2.3a4.8 4.8 0 0 0 1.6 1.4c1 .3 6.2-6.4 7.3-6.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.7.5 1.5.9 2.1.4 1.1.6 1.2 1.2 2.3a5 5 0 0 0 1.5 1.4c1 .3 6.2-6.3 7.3-6.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "M461.8 312.2a11 11 0 0 0 1.7 3.7c.4.7.5 1.5.9 2.2l1.2 2.1a5 5 0 0 0 1.5 1.4c1 .3 6.2-6 7.3-6.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M461.8 312.2a12 12 0 0 0 1.7 3.7c.4.6.5 1.4.9 2l1.2 2.2a5.1 5.1 0 0 0 1.6 1.4c1 .3 6-6 7.2-6.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M461.8 312.2c0 .7 1 2.7 1.7 3.6.4.7.5 1.4 1 2l1 2.2a4.5 4.5 0 0 0 1.7 1.3c1 .4 6-5.8 7.2-6.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M461.8 312.2c0 .7 1 2.7 1.7 3.6l1 2c.4 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.6 1.4c1 .3 6-5.7 7.2-6.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033156",
                  d: "M461.8 312.2c0 .7 1 2.7 1.7 3.5l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.4c1.1.3 6-5.6 7.3-6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033156",
                  d: "M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.3c1.2.3 6-5.3 7.3-5.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 1.9c.3 1 .6 1 1.2 2 .3.5 1 1 1.4 1.3 1.2.3 6-5.2 7.3-5.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "M461.8 312.2a8 8 0 0 0 1.7 3.3l1 2c.3.9.6 1 1.2 2 .3.4 1 1 1.4 1.1 1.2.4 6-5 7.3-5.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M461.8 312.2c0 .6 1 2.4 1.7 3.3l1 1.8c.4 1 .6 1.1 1.2 2 .3.5 1 1 1.4 1.2 1.3.3 6-5 7.3-5.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M461.8 312.2c0 .6 1 2.4 1.7 3.2l1 1.9c.4.8.6 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.7 7.2-5.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04345b",
                  d: "M461.8 312.2c0 .6 1 2.4 1.7 3.1l1 1.9c.4.9.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.6 7.2-5.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04345b",
                  d: "M461.8 312.2c0 .6 1 2.3 1.7 3l1 1.9c.4.8.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.3.4 5.8-4.5 7.2-5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04345b",
                  d: "M461.8 312.2c0 .6 1 2.2 1.7 3l1 1.8c.4.9.7 1 1.2 1.8.4.4 1 1 1.5 1.1 1.3.4 5.8-4.3 7.2-4.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M461.8 312.2c0 .5 1 2.2 1.7 3l1 1.7c.4.8.7 1 1.2 1.8.4.4 1 .9 1.5 1 1.3.5 5.7-4.1 7.2-4.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M461.8 312.2c0 .5 1 2.1 1.7 3l1 1.6c.4.8.7 1 1.3 1.7.3.5 1 1 1.4 1.1 1.3.5 5.7-4 7.2-4.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04365e",
                  d: "M461.8 312.2c0 .5 1 2.1 1.7 2.9l1 1.6c.4.9.7 1 1.3 1.7.3.5 1 .9 1.4 1.1 1.4.4 5.7-3.9 7.2-4.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04365e",
                  d: "M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.6c.4.8.7 1 1.3 1.7.3.4 1 .9 1.4 1 1.4.5 5.6-3.7 7.2-4.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.5c.4.8.7 1 1.3 1.7.3.4 1 .8 1.4 1 1.4.4 5.6-3.6 7.2-4.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M461.8 312.2c0 .5 1 2 1.7 2.7l1 1.6c.4.7.7.8 1.3 1.6.3.4 1 .8 1.4 1 1.5.4 5.6-3.5 7.2-4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "M461.8 312.2c0 .5 1 1.9 1.7 2.6l1 1.6c.4.7.7.9 1.3 1.5.3.4 1 .8 1.4 1 1.5.5 5.5-3.3 7.2-3.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "M461.8 312.2c0 .4 1 1.8 1.7 2.6l1 1.5c.4.7.7.9 1.3 1.5l1.4 1c1.5.4 5.5-3.2 7.2-3.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "M461.8 312.2c0 .4.9 1.8 1.7 2.5l1 1.5c.4.7.8.8 1.3 1.5l1.4 1c1.5.4 5.5-3 7.2-3.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043963",
                  d: "M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.5c.4.7.8.8 1.3 1.5l1.4.9c1.5.5 5.5-2.8 7.2-3.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043963",
                  d: "M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.4c.4.7.8.8 1.3 1.5l1.4.9c1.6.5 5.5-2.7 7.2-3.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M461.8 312.2c0 .4.9 1.6 1.7 2.3l1 1.4 1.3 1.4 1.4 1c1.6.4 5.4-2.6 7.2-3.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M461.8 312.2c0 .3.8 1.6 1.7 2.3l1 1.3c.5.7.8.8 1.4 1.4.3.4.9.7 1.4.9 1.6.5 5.3-2.4 7.1-3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "M461.8 312.2c0 .3.8 1.5 1.7 2.2l1 1.3 1.4 1.4c.4.3.9.7 1.4.8 1.6.5 5.3-2.2 7.1-2.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "M461.8 312.2c0 .3.8 1.5 1.7 2.1.3.5.6 1 1 1.3.5.7.8.8 1.4 1.4l1.4.8c1.6.5 5.2-2 7.1-2.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "M461.8 312.2c0 .3.8 1.4 1.7 2.1l1 1.3 1.4 1.3c.4.3.9.6 1.4.7 1.7.6 5.2-1.9 7.1-2.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "M461.8 312.2c0 .3.8 1.4 1.7 2l1 1.3 1.4 1.2 1.4.8c1.7.5 5.2-1.8 7.1-2.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "M461.8 312.2a6 6 0 0 0 1.7 2l1 1.2 1.4 1.2a6 6 0 0 0 1.4.8c1.7.5 5.1-1.7 7.1-2.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053d6a",
                  d: "M461.8 312.2c0 .2.8 1.2 1.7 2l1 1 1.4 1.3a6 6 0 0 0 1.4.8c1.8.5 5.1-1.5 7.1-2.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053d6a",
                  d: "M461.8 312.2a6 6 0 0 0 1.7 1.9l1 1.1 1.4 1.1 1.4.8c1.8.5 5.1-1.3 7.1-2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "M461.8 312.2c0 .2.7 1.1 1.7 1.8l1 1.1c.5.5 1 .7 1.5 1.1l1.3.8c1.8.5 5.1-1.2 7.1-2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "M461.8 312.2c0 .2.7 1.1 1.6 1.8l1.1 1c.5.5 1 .7 1.5 1.1l1.3.7c1.8.6 5-1 7.1-1.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M461.8 312.2c0 .1.7 1 1.6 1.7l1.1 1c.5.5 1 .7 1.5 1 .4.4.8.6 1.3.8 1.8.6 5-1 7.1-1.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M461.8 312.2c0 .1.7 1 1.6 1.6a14.2 14.2 0 0 0 1.2 1c.4.5.9.7 1.4 1 .4.3.9.6 1.3.7 1.9.6 5-.7 7.1-1.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6f",
                  d: "M461.8 312.2c0 .1.7 1 1.6 1.6l1.2 1 1.4 1 1.3.6c2 .5 5-.6 7.1-1.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6f",
                  d: "M461.8 312.2c0 .1.7.9 1.6 1.5l1.2 1 1.4 1 1.3.6c2 .5 5-.5 7.1-1.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6f",
                  d: "M461.8 312.2c0 .1.7.8 1.6 1.5l1.2.9 1.4 1 1.3.5c2 .6 5-.3 7.1-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "M461.8 312.2s.7.8 1.6 1.4l1.2.9 1.5.9 1.2.6c2 .6 4.9-.2 7.1-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "m461.8 312.2 1.6 1.4 1.2.8 1.5.9 1.3.5c2 .6 4.8 0 7-.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M461.8 312.2s.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.2 7-.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M461.8 312.1c0 .1.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.3 7-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064374",
                  d: "M461.8 312.1c0 .1.6.7 1.6 1.3l1.2.7a12.7 12.7 0 0 0 2.8 1.3c2 .6 4.7.5 7-.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064374",
                  d: "M461.8 312.1s.6.6 1.6 1.2l1.2.7a15.7 15.7 0 0 0 2.8 1.3c2 .6 4.7.6 7-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "m461.8 312.1 1.6 1.2 1.2.7 1.5.6a12 12 0 0 0 8.3.4m-12.6-2.9s6.5 5.1 12.6 3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M461.6 292.2s1.2 8 1.7 9.3c.4 1 3 5.6 6.9 6.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "M461.6 292.2s1.3 8 1.8 9.2c.5 1 2.8 5.4 6.8 6.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M461.6 292.1s1.4 8 1.9 9.2a14 14 0 0 0 6.7 6.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "M461.6 292.1s1.5 8 2 9.1c.5 1 2.5 5 6.6 7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M461.6 292.1s1.6 7.9 2 9a15.2 15.2 0 0 0 6.7 7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M461.6 292.1s1.6 7.8 2.2 9a15.8 15.8 0 0 0 6.5 7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M461.6 292s1.7 7.8 2.3 9c.5 1.1 2 4.3 6.4 7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M461.7 292s1.7 7.8 2.3 9c.5 1 1.9 4 6.3 7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M461.7 292s1.8 7.7 2.4 8.9c.5 1 1.7 3.8 6.2 7.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "M461.7 292s1.9 7.7 2.5 8.8c.6 1.1 1.6 3.5 6.1 7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M461.7 292s2 7.6 2.6 8.8c.5 1 1.4 3.2 6 7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M461.8 292s2 7.5 2.6 8.7c.6 1.1 1.3 3 6 7.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M461.8 292s2.1 7.5 2.7 8.6c.6 1.1 1.1 2.8 5.9 7.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M462 287.2s1.1 11.4 9.3 14.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "M462 287.2c.1 0 .5 3.7 2.2 7.2 1.3 2.8 3.5 5.9 7 7.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "M462.1 287.2s.5 3.8 2.2 7.2a15 15 0 0 0 7 7.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "M462.1 287.2s.7 3.9 2.3 7.1c1.1 2.3 3.3 5.7 6.9 7.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M462.2 287.2s.7 4 2.3 7c1 2.2 3.2 5.7 6.8 7.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M462.2 287.2c0 .1.8 4 2.4 7 1 2 3.1 5.6 6.7 7.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M462.2 287.2c0 .1 1 4.2 2.5 7a18 18 0 0 0 6.6 7.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M462.2 287.1c0 .3 1 4.4 2.6 7 .8 1.5 3 5.4 6.5 7.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M462.2 287.1a30 30 0 0 0 2.6 6.9c.8 1.4 3 5.4 6.5 7.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "M462.3 287.1c0 .3 1.2 4.5 2.6 6.8.7 1.3 2.8 5.4 6.4 7.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "M462.3 287.1a30 30 0 0 0 2.8 6.8c.6 1 2.6 5.2 6.2 7.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M462.3 287.1a31 31 0 0 0 2.9 6.7c.5.8 2.5 5.2 6 7.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M462.3 287.1c0 .3 1.6 4.9 3 6.6.4.7 2.4 5.2 6 7.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "M462.2 284s2.4 9.2 9 11.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022847",
                  d: "M462.2 284s.9 3.3 3 6.4c1.5 2.2 3.6 4.2 6 5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032a4a",
                  d: "M462.2 284s1 3.2 3 6.4c1.6 2.1 3.7 4.3 6 5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "M462.2 284s1 3.1 3.2 6.3c1.5 2.2 3.7 4.4 5.8 5.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "M462.2 283.9s1 3.1 3.3 6.3a15 15 0 0 0 5.7 5.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033156",
                  d: "M462.2 283.9s1 3 3.3 6.2c1.7 2.3 4 4.7 5.7 5.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M462.2 283.8s1 3 3.4 6.2a17 17 0 0 0 5.6 5.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M462.2 283.8a27.1 27.1 0 0 0 9 11.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M462.3 283.8s1 2.9 3.5 6.1a21 21 0 0 0 5.4 5.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043963",
                  d: "M462.3 283.8s1 2.8 3.5 6a23 23 0 0 0 5.4 5.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "M462.3 283.7s1.1 2.8 3.6 6a28 28 0 0 0 5.3 5.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "M462.3 283.7s1.2 2.7 3.7 6a39 39 0 0 0 5.2 5.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6f",
                  d: "M462.3 283.7s1.2 2.7 3.8 5.9a44 44 0 0 0 5.1 5.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M462.3 283.6s1.3 2.7 3.9 6c2 2.5 4.9 5.6 5 5.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M462.3 283.6s1.3 2.6 3.9 5.8c2.1 2.7 5 5.9 5 5.9m8.7 1.3 4.6.8m-4.1 2.6 4-1.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "m479.9 296.7 4.5.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "m479.9 296.9 4.6.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "m479.9 297 4.6.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "m479.9 297.2 4.7.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "M479.9 297.4h4.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "M480 297.6h4.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "m480 297.7 4.7-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "m480 297.9 4.7-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "m480 298 4.8-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "m480.3 299.8 4.2-1.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "m480.3 299.6 4.3-1.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053b67",
                  d: "m480.3 299.5 4.3-1.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "m480.3 299.3 4.3-1.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "m480.2 299.1 4.5-1.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "m480.2 299 4.5-1.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032f53",
                  d: "m480.2 298.7 4.6-.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "m480.1 298.6 4.7-.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "m480.1 298.4 4.7-.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "m480 298.2 4.9-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "m484.2 331.6-2.6.2-9.9-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "m484.3 331.6-2.7.3-9.8-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "m484.3 331.6-2.8.4c-.5.1-9.6-.3-9.6-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "m484.3 331.7-2.8.5c-.7.1-9.6-.5-9.6-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "m484.3 331.7-3 .6c-.7.2-9.3-.5-9.3-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "m484.3 331.7-3 .7c-.8.3-9.2-.6-9.2-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "m484.4 331.8-3.1.8c-1 .2-9.1-.7-9.1-.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "m484.4 331.8-3.1 1c-1.2.2-9-.8-9-.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "m484.4 331.9-3.2 1c-1.2.3-8.9-.9-8.9-.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M484.4 332s-1.8.7-3.2 1c-1.4.3-8.8-1-8.8-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M472.5 332s7.1 1.4 8.6 1.1c1.5-.3 3.3-1.1 3.3-1.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022a49",
                  d: "m486 337 4.8.7 2.7-.2 2.2-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032d4f",
                  d: "M485.8 337s4.7.7 5 .6l2.7-.1 2-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "M485.5 336.9s4.9.8 5.3.7l2.6-.2 2-.4"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "M485.3 336.7s4.9.9 5.6.8a56.9 56.9 0 0 1 2.5-.2l1.7-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "M485 336.6s5 1 5.9.8l2.5-.2 1.5-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "M484.8 336.5s5.1 1 6.1.8l2.4-.2 1.4-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053d6a",
                  d: "M484.5 336.4s5.3 1 6.4.9c.7-.2 2-.3 2.4-.3a24.4 24.4 0 0 0 1.2-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064171",
                  d: "M484.2 336.3s5.4 1.1 6.8.9c.7-.2 1.7-.3 2.2-.3h1.1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "m486.3 337.2 4.4.6 2.9-.1 2.4-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M484 336.2s5.5 1.2 7 .9c1.5-.3 3-.3 3-.3m11.8 0 4.3-1.6c2.6-1 3-3.6 3-3.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "m505.5 336 3.1-1.3c3.8-1.4 3.4-3.2 3.4-3.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "m505.2 336.1 3.4-1.3 1.8-.8c.5-.3 1.2-1 1.3-1.2.4-.5.4-1.3.4-1.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "m505 336.3 3.6-1.4 1.8-.7 1.4-1.2c.3-.5.4-1.5.4-1.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "m504.7 336.5 4-1.5 1.6-.7a6 6 0 0 0 1.5-1.2c.2-.3.5-1.6.5-1.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "m504.4 336.7 4.2-1.5 1.7-.7 1.6-1.3.6-1.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053e6c",
                  d: "m505.5 336.9 4.6-1.8c.8-.3 1.7-1 2-1.5.6-.9.9-2 .9-2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043862",
                  d: "m505.1 336.9 5-2c.6-.1 1.7-1 2-1.4.4-.6.7-2 .7-2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043258",
                  d: "m504.8 336.9 5.4-2a8.1 8.1 0 0 0 1.9-1.4c.3-.5.6-2 .6-2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032c4d",
                  d: "m504.5 336.9 5.7-2.1 1.8-1.4.7-1.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#022743",
                  d: "m504.2 336.9 6-2.3 1.7-1.2.6-1.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032b4c",
                  d: "m511.3 331.6-2.8.2-10.3-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#032e50",
                  d: "m511.3 331.6-2.8.3-10.2-.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#033054",
                  d: "m511.3 331.6-2.9.4c-.5.1-10-.3-10-.3"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043359",
                  d: "m511.3 331.7-3 .5c-.6.1-9.8-.5-9.8-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#04355c",
                  d: "m511.4 331.7-3 .6c-.9.2-9.8-.5-9.8-.5"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#043760",
                  d: "m511.4 331.7-3.1.7c-1 .3-9.7-.6-9.7-.6"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053a65",
                  d: "m511.4 331.8-3.2.8c-1 .2-9.5-.7-9.5-.7"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053c68",
                  d: "m511.4 331.8-3.3 1c-1.1.2-9.3-.8-9.3-.8"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#053f6e",
                  d: "m511.4 331.9-3.3 1c-1.3.2-9.2-.9-9.2-.9"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#064172",
                  d: "M511.4 332s-1.9.7-3.3 1c-1.5.3-9.2-1-9.2-1"
                }),
                /* @__PURE__ */ jsx228("path", {
                  stroke: "#00209f",
                  d: "M499 332s7.5 1.4 9 1.1c1.6-.3 3.5-1.1 3.5-1.1"
                })
              ]
            }),
            /* @__PURE__ */ jsx228("path", {
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 2.6,
              strokeWidth: 0.2,
              d: "M475 290a34 34 0 0 1-.2-3.3c0-5.2-.7-9-.1-14.5.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l21 23.5M467 327.7a5.2 5.2 0 0 1-1.9-2.2c-.6-1.7-.4-1.7-.9-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.9-6.2-.1-4.8-1.7-8-1.3-13.1.3-4 1.2-9.5.7-13.6l.1-3.6 23.6 15.6m28.5 33.9c.2.5-.3 1.5-.5 1.9l-.5.6c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.8.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8"
            }),
            /* @__PURE__ */ jsxs221("g", {
              stroke: "#000",
              strokeMiterlimit: 2.6,
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m484.9 297.6.6-.8-24-15.6-.4.6zm-23.7-16.7c-.2-1 0-2.1.7-2.3 0 0 .5-.1.8 0 .4 0 .5 0 .7.4.3.8-.7 1.3-1.4 1.6-.2 0-.6.1-.7.3l-.1.4.3-.3 1.7-.7c.6-.3.7-1.4.3-1.7-.4-.4-1.8-.3-2 0-.7.7-.8 1.7-.6 2.7 0-.2.3-.1.3-.4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M460.8 281.3c-1 0-2.1.4-2.2 1v.9c0 .4.2.5.6.6.8.2 1.2-.8 1.4-1.6 0-.1 0-.6.2-.7l.4-.2-.3.3-.5 1.9c-.2.6-1.3.8-1.6.4-.5-.3-.6-1.7-.3-2 .7-.7 1.7-1 2.7-1-.2.1-.2.5-.4.4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M460.6 281c-.3 0-.3.4-.1.6 0 .2.5.3.6.2.4-.2.6-.6.4-1-.2-.3-.6 0-.9.1z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M455.6 277.8s2.5 1 4.5 1c0 0 .1 1.8.5 2.3 0 0-1.8-.3-2.6 0 0 0-1.1-2.4-2.4-3.3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "none",
                  d: "M457.6 279s1 .4 1.8.4c0 0 0 .8.2 1 0 0-.7-.2-1 0 0 0-.4-1-1-1.4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m460.8 282.9.6-1.1c0-.2 0 1 .4 1 .5.8.7 2.3.7 2.7-.7.2-1.3.6-2.3.2-.3-.3 0-1 0-1.4.2-.3.3-1 .6-1.4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "none",
                  d: "M461.3 282.2v.6c0-.2.3.2.3.3.3.7.5 1.1.6 2.4m-.7-2.2c.2 1 .4 1 .4 2.4v-.1m-.5-1.4.2 1.4-.3.2"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m497.1 277.4.7-.6-21.4-23.7-.4.5z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M476.6 253c0-.9.6-2 1.2-2l.9.1c.3.1.4.3.5.6.1.9-1 1.2-1.7 1.3l-.8.1-.2.3.3-.1c.6-.2 1.2-.2 2-.3.5-.1.9-1.3.6-1.6-.3-.5-1.6-.8-2-.5-.8.5-1 1.5-1.2 2.5 0-.2.4-.1.4-.3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M476.1 253.4c-.9-.3-2.1-.2-2.3.5l-.2.8c0 .4 0 .5.4.7.7.4 1.4-.5 1.7-1.2 0-.2.2-.6.4-.7h.4l-.3.2-1 1.7c-.2.5-1.4.5-1.7 0-.3-.4 0-1.7.3-2 .8-.6 1.8-.5 2.8-.2-.2 0-.3.3-.5.2z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M476 253c-.3 0-.3.4-.3.6 0 .2.4.4.6.3.4-.1.7-.4.6-.8-.1-.4-.6-.2-.9-.1z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M472 248.7s2 1.6 4 2c0 0-.3 1.9 0 2.4 0 0-1.7-.7-2.6-.5 0 0-.4-2.6-1.5-4z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "none",
                  d: "M473.6 250.4s.8.6 1.6.9v.9s-.7-.3-1-.2c0 0-.2-1-.6-1.6z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m475.7 254.9 1-1c0-.1-.4 1 0 1.3.4.8.1 2.3 0 2.7-.7 0-1.3.3-2-.4-.4-.3 0-.9.3-1.3 0-.3.4-1 .7-1.3z"
                }),
                /* @__PURE__ */ jsx228("path", {
                  fill: "none",
                  d: "M476.4 254.4v.5l.2.7v2.2m-.3-2.5c.2.9 0 1.6-.1 2.5m0-1c-.2.4-.2.6-.2 1h-.3"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx228("use", {
          xlinkHref: "#sv_svg__c",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1030 0)"
        })
      ]
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "#fc0",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.3,
      d: "m319.3 197.9-40.2 67.3h80.5z"
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      d: "M319.3 202.3 283 263h72.7z"
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "#007e93",
      stroke: "#007e93",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.2,
      d: "M293.8 245 283 263h72.7l-10.9-18z"
    }),
    /* @__PURE__ */ jsxs221("g", {
      fill: "none",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx228("path", {
          stroke: "#086aad",
          d: "M313 212.9a9 9 0 0 1 6.2-2.2h.2c2.3 0 4.7.6 6.3 2.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0863aa",
          d: "M313 213a9 9 0 0 1 6.2-2.2h.2c2.4 0 4.8.5 6.3 2.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#095fa8",
          d: "M313 213a8.8 8.8 0 0 1 6.2-2.2h.2c2.4 0 4.9.6 6.4 2.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0a58a5",
          d: "M312.9 213.1a8.7 8.7 0 0 1 6.3-2.2h.2c2.5 0 5 .6 6.5 2.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0a52a2",
          d: "M312.8 213.2c1.6-1.7 4-2.3 6.5-2.3h.1c2.6 0 5 .7 6.5 2.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0b4d9f",
          d: "M312.8 213.3c1.6-1.7 4-2.3 6.5-2.3h.2c2.5 0 5 .6 6.5 2.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0c479d",
          d: "M312.7 213.4c1.6-1.8 4-2.4 6.6-2.4h.2c2.6 0 5 .7 6.6 2.5"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#270a7f",
          d: "M312.3 214c1.9-2 4.2-2.5 7-2.5h.2c3.1 0 5.7 1 7.3 3.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#241183",
          d: "M312.3 214c1.9-2 4.2-2.6 7-2.6h.2c3 0 5.6 1 7.2 3.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#221786",
          d: "M312.4 214c1.8-2 4.1-2.6 7-2.6 3 0 5.7 1 7.2 3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#1f1f8a",
          d: "M312.4 213.8c1.8-1.9 4.2-2.5 6.9-2.5h.1c3 0 5.6 1 7.2 3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#1a258d",
          d: "M312.5 213.7c1.7-1.8 4-2.4 6.8-2.4h.1c3 0 5.5.8 7 2.9"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#172d91",
          d: "M312.5 213.7c1.7-1.9 4.1-2.5 6.7-2.5h.2c2.9 0 5.4.8 7 2.8"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#143393",
          d: "M312.5 213.6c1.7-1.8 4-2.4 6.7-2.4h.2c2.8 0 5.3.7 7 2.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#113b97",
          d: "M312.6 213.5c1.6-1.8 4-2.4 6.6-2.4h.1c2.8 0 5.4.7 7 2.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff0a00",
          d: "M315.3 209a6.5 6.5 0 0 1 4-1.2c1.5 0 2.8.3 4 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#f10",
          d: "M315.3 209a6.6 6.6 0 0 1 4-1 7 7 0 0 1 4 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff1500",
          d: "M315.3 209a6.8 6.8 0 0 1 4-1c1.5 0 2.9.2 4 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff1a00",
          d: "M315.2 209.2a6.6 6.6 0 0 1 4.1-1.2c1.5 0 3 .3 4.1 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff2000",
          d: "M315.2 209.2a6.7 6.7 0 0 1 4.1-1.1c1.5 0 3 .3 4.1 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff2700",
          d: "M315.1 209.3a6.8 6.8 0 0 1 4.2-1.2c1.5 0 3 .3 4.2 1.1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff2f00",
          d: "M315.1 209.4a6.9 6.9 0 0 1 4.2-1.2c1.5 0 3 .3 4.2 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#f30",
          d: "M315 209.4a6.8 6.8 0 0 1 4.3-1.1 7.7 7.7 0 0 1 4.3 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff3c00",
          d: "M315 209.5a6.9 6.9 0 0 1 4.3-1.2c1.6 0 3.1.3 4.3 1.1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff4100",
          d: "M315 209.6a7 7 0 0 1 4.3-1.2 8 8 0 0 1 4.3 1.1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff4600",
          d: "M315 209.7a7 7 0 0 1 4.3-1.3 8 8 0 0 1 4.4 1.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fff500",
          d: "M314 211.2a9.7 9.7 0 0 1 10.7 0"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffeb00",
          d: "M314.1 211.1a9 9 0 0 1 5.2-1.5c2 0 4 .5 5.3 1.6"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffe000",
          d: "M314.1 211a9 9 0 0 1 5.2-1.5c1.9 0 4 .5 5.3 1.6"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffd600",
          d: "M314.2 211a9 9 0 0 1 5.1-1.6c1.9 0 3.9.5 5.2 1.6"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffcf00",
          d: "M314.2 210.9a9 9 0 0 1 5.1-1.5 9 9 0 0 1 5.2 1.5"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffc400",
          d: "M314.3 210.8c1.3-1 3.3-1.5 5-1.5a8 8 0 0 1 5.1 1.5"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffba00",
          d: "M314.3 210.7c1.4-1 3.3-1.5 5-1.5s3.7.5 5 1.5"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffb000",
          d: "M314.4 210.6a8.4 8.4 0 0 1 5-1.4c1.7 0 3.6.4 5 1.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ffa600",
          d: "M314.4 210.5a8.1 8.1 0 0 1 5-1.4 8 8 0 0 1 4.8 1.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff9c00",
          d: "M314.5 210.4a8 8 0 0 1 4.8-1.4c1.7 0 3.6.4 4.9 1.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff9100",
          d: "M314.6 210.3a8 8 0 0 1 4.7-1.4c1.7 0 3.5.5 4.8 1.4"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff8700",
          d: "M314.6 210.2a8 8 0 0 1 4.7-1.3c1.7 0 3.5.4 4.8 1.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff7d00",
          d: "M314.6 210.2a7.7 7.7 0 0 1 4.7-1.4c1.7 0 3.4.4 4.7 1.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff7500",
          d: "M314.7 210a7.6 7.6 0 0 1 4.6-1.2c1.7 0 3.4.4 4.7 1.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff6b00",
          d: "M314.8 210a7.6 7.6 0 0 1 4.5-1.3 8 8 0 0 1 4.6 1.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff6100",
          d: "M314.8 209.9a7.3 7.3 0 0 1 4.5-1.3c1.6 0 3.3.4 4.6 1.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff5700",
          d: "M314.9 209.8a7.3 7.3 0 0 1 4.4-1.3 8 8 0 0 1 4.5 1.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ebf605",
          d: "M313.9 211.4a9.5 9.5 0 0 1 5.4-1.7c2 0 4.1.6 5.5 1.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#d6ec09",
          d: "M313.8 211.5a9.1 9.1 0 0 1 5.5-1.7c2 0 4.2.6 5.6 1.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#c2e30e",
          d: "M313.8 211.6a9 9 0 0 1 5.5-1.7c2 0 4.2.5 5.6 1.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#add912",
          d: "M313.7 211.7a8.8 8.8 0 0 1 5.6-1.8c2 0 4.2.6 5.6 1.8"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#99cf16",
          d: "M313.6 211.8a8.8 8.8 0 0 1 5.7-1.8c2 0 4.3.6 5.7 1.8"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#85c61a",
          d: "M313.6 211.9a8.7 8.7 0 0 1 5.7-1.9c2 0 4.3.7 5.7 1.9"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#70bc1f",
          d: "M313.5 212a8.4 8.4 0 0 1 5.8-1.9c2 0 4.4.6 5.8 1.8"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#5cb323",
          d: "M313.5 212.1a8.4 8.4 0 0 1 5.8-2c2.1 0 4.4.7 5.8 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#47a928",
          d: "M313.4 212.2a8.4 8.4 0 0 1 5.9-2c2.1 0 4.4.7 5.9 1.9"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0d74a4",
          d: "M313.1 212.7a8.8 8.8 0 0 1 6.2-2 9 9 0 0 1 6.3 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#127a97",
          d: "M313.1 212.7a8.7 8.7 0 0 1 6.2-2.2 9 9 0 0 1 6.2 2.1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#17808b",
          d: "M313.2 212.6a8.7 8.7 0 0 1 6.2-2 9 9 0 0 1 6 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#1a847d",
          d: "M313.2 212.6a8.7 8.7 0 0 1 6.1-2.1 9 9 0 0 1 6.1 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#1e8a6d",
          d: "M313.2 212.5a8.5 8.5 0 0 1 6.1-2c2.3 0 4.6.6 6 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#238f5e",
          d: "M313.3 212.5a8.5 8.5 0 0 1 6-2.1c2.2 0 4.6.6 6 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#2b944e",
          d: "M313.3 212.4a8.3 8.3 0 0 1 6-2c2.2 0 4.6.6 6 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#2f9b3e",
          d: "M313.3 212.3c2-1.6 3.7-2 6-2 2.2 0 4.5.7 6 2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "red",
          d: "M323.2 208.8a6.8 6.8 0 0 0-3.9-1 6.6 6.6 0 0 0-4 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#2a007c",
          d: "M326.9 214.9c-1.6-2.3-4.3-3.4-7.5-3.4-3 0-5.2.7-7.2 2.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0671b0",
          d: "M325.6 212.7c-1.5-1.5-4-2-6.3-2a9 9 0 0 0-6.2 2.1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#0c419a",
          d: "M326.2 213.7c-1.6-2-4.1-2.6-6.9-2.6-2.6 0-5 .6-6.7 2.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff0",
          d: "M324.8 211.3a9.1 9.1 0 0 0-5.5-1.6c-1.8 0-4 .5-5.4 1.6"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#ff4d00",
          d: "M323.7 209.7a8.1 8.1 0 0 0-4.4-1.2 7 7 0 0 0-4.4 1.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#33a02c",
          d: "M325.2 212.2a9.5 9.5 0 0 0-5.9-2 8.3 8.3 0 0 0-6 2"
        })
      ]
    }),
    /* @__PURE__ */ jsxs221("g", {
      fill: "none",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fef2ec",
          d: "M312 214.5a16.3 16.3 0 0 1 7.3-1.8c2.6 0 5.4 1 7.6 2.1l7.7 13a15.3 15.3 0 0 1-30.6 0z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fef2ea",
          d: "M319.3 212.9c2.6 0 5.3 1 7.5 2.1l7.6 12.7c0 8.3-6.8 15.2-15 15.2-8.4 0-15.1-6.7-15.2-15.1l7.9-13a15.8 15.8 0 0 1 7.2-2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fef0e6",
          d: "M319.3 213.3c2.5 0 5.2 1 7.3 2l7.4 12.4c0 8.1-6.6 14.9-14.7 14.9a14.7 14.7 0 0 1-14.7-14.8l7.6-12.7a15.6 15.6 0 0 1 7-1.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#feede3",
          d: "M319.3 213.7c2.4 0 5 .9 7 2 .2 0 7.3 11.9 7.3 12a14.4 14.4 0 0 1-14.3 14.4c-7.9 0-14.2-6.3-14.3-14.3 0-.2 7.3-12.3 7.4-12.4a16 16 0 0 1 6.9-1.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee8dc",
          d: "M319.3 214.3c2.3 0 4.8.9 6.8 2 .2 0 6.8 11.2 6.8 11.5 0 7.5-6.1 13.7-13.6 13.7s-13.6-6-13.7-13.7c0-.3 6.9-11.7 7.1-11.8 2-1 4.2-1.7 6.6-1.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee6d5",
          d: "M319.3 214.7c2.3 0 4.7.8 6.6 1.9.2.2 6.6 10.8 6.6 11.2 0 7.3-6 13.3-13.2 13.3s-13.2-6-13.2-13.3c0-.4 6.5-11.3 6.8-11.5 2-1 4-1.6 6.4-1.6z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee3cf",
          d: "M319.3 215.3c2.2 0 4.5.8 6.2 1.8.4.2 6.4 10.2 6.4 10.7 0 7-5.7 12.7-12.6 12.7-7 0-12.6-5.6-12.7-12.7 0-.4 6.2-10.7 6.6-11a13.3 13.3 0 0 1 6-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee0cc",
          d: "M319.3 215.7c2.1 0 4.3.8 6 1.8a76 76 0 0 1 6.2 10.3c0 6.7-5.5 12.3-12.2 12.3a12.2 12.2 0 0 1-12.3-12.3c0-.5 6-10.3 6.4-10.6 1.8-1 3.7-1.5 5.9-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fedec6",
          d: "M319.3 216.1c2 0 4.2.8 5.9 1.7.4.3 6 9.4 6 10a12 12 0 0 1-12 11.9 11.8 11.8 0 0 1-11.7-11.9c0-.6 5.6-10 6-10.2a12.5 12.5 0 0 1 5.8-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdcdaa",
          d: "M319.3 218.8c1.6 0 3.2.5 4.5 1.3.9.5 4.6 6.7 4.6 7.7a9.2 9.2 0 0 1-9.1 9.2 9.2 9.2 0 0 1-9.2-9.2c0-1 3.9-7.4 4.7-8a9.6 9.6 0 0 1 4.5-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdcdaa",
          d: "M319.3 219a9 9 0 0 1 4.4 1.2c1 .6 4.5 6.6 4.5 7.6a9 9 0 1 1-17.9 0c0-1 3.7-7.2 4.6-7.7a9.2 9.2 0 0 1 4.4-1.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc59e",
          d: "M319.3 220a8 8 0 0 1 4 1.1c1 .6 4 5.5 4 6.7a8 8 0 0 1-8 8 8 8 0 0 1-8-8c0-1.2 3-6.3 4.1-6.8 1.2-.7 2.5-1 3.9-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc59e",
          d: "M319.3 220.2a7.8 7.8 0 0 1 3.9 1 16 16 0 0 1 3.8 6.6 7.8 7.8 0 0 1-7.7 7.8 7.7 7.7 0 0 1-7.8-7.7c0-1.4 3-6.1 4-6.8a7.9 7.9 0 0 1 3.8-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fef0e9",
          d: "M319.3 213c2.5 0 5.2 1 7.4 2.2l7.5 12.5a15 15 0 0 1-14.9 15 15 15 0 0 1-14.9-14.9l7.7-13a15.6 15.6 0 0 1 7.2-1.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#feede3",
          d: "M319.3 213.5c2.5 0 5.1 1 7.1 2 .2.1 7.4 12.1 7.4 12.3a14.5 14.5 0 0 1-29 0l7.5-12.6a15.1 15.1 0 0 1 7-1.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#feebdf",
          d: "M319.3 214c2.4 0 5 .8 7 1.9.1 0 7 11.6 7 11.9 0 7.7-6.3 14.1-14 14.1s-14-6.3-14-14.1c0-.2 7-12.1 7.2-12.2a14.9 14.9 0 0 1 6.8-1.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#feebdd",
          d: "M319.3 214c2.4 0 4.9 1 6.9 2 .1.2 7 11.5 7 11.8a14 14 0 0 1-14 14 14 14 0 0 1-13.8-14c0-.2 7-11.9 7.2-12 2-1 4.2-1.7 6.7-1.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee8d9",
          d: "M319.3 214.5c2.3 0 4.8.9 6.7 2 .2 0 6.7 11 6.7 11.3 0 7.4-6 13.5-13.4 13.5s-13.4-6-13.5-13.5c0-.3 6.7-11.5 7-11.7 2-1 4.1-1.6 6.5-1.6z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee6d3",
          d: "M319.3 215c2.2 0 4.6.7 6.5 1.8.3.1 6.5 10.6 6.5 11 0 7.1-5.9 13.1-13 13.1a13.1 13.1 0 0 1-13-13c0-.5 6.4-11.3 6.7-11.4a13.8 13.8 0 0 1 6.3-1.6z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee3d2",
          d: "M319.3 215.1c2.2 0 4.5.8 6.4 1.8.3.2 6.4 10.5 6.4 10.9 0 7-5.8 13-12.8 13a13 13 0 0 1-12.9-13c0-.4 6.3-11 6.7-11.1a13.8 13.8 0 0 1 6.2-1.6z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fee0cc",
          d: "M319.3 215.5c2.2 0 4.4.8 6.1 1.8.5.2 6.3 10 6.3 10.5 0 6.8-5.6 12.5-12.4 12.5a12.5 12.5 0 0 1-12.5-12.5c0-.5 6-10.6 6.5-10.8a13 13 0 0 1 6-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fedec8",
          d: "M319.3 216c2 0 4.2.7 6 1.6.4.3 6 9.6 6 10.2a12 12 0 0 1-12 12 12 12 0 0 1-12-12 88 88 0 0 1 6.2-10.4c1.7-1 3.6-1.5 5.8-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fddbc5",
          d: "M319.3 216.3c2 0 4.1.8 5.8 1.7a87 87 0 0 1 5.8 9.8c0 6.4-5.2 11.7-11.6 11.7-6.4 0-11.6-5.2-11.6-11.7 0-.6 5.5-9.7 6-10a12.1 12.1 0 0 1 5.6-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fddbc2",
          d: "M319.3 216.5c2 0 4 .8 5.7 1.7.5.3 5.7 9 5.7 9.6 0 6.3-5.1 11.5-11.4 11.5s-11.4-5.1-11.5-11.5c0-.7 5.4-9.6 6-9.9a12 12 0 0 1 5.5-1.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd9bf",
          d: "M319.3 216.7c2 0 4 .7 5.6 1.6.5.4 5.6 8.8 5.6 9.5a11.2 11.2 0 0 1-22.4 0c0-.7 5.2-9.4 5.8-9.7a11.9 11.9 0 0 1 5.4-1.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd9bf",
          d: "M319.3 217c2 0 3.9.6 5.4 1.5a55 55 0 0 1 5.6 9.3c0 6-5 11-11 11s-11-4.8-11-11c0-.7 5-9.2 5.7-9.5a11.5 11.5 0 0 1 5.3-1.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd6bc",
          d: "M319.3 217.1c1.9 0 3.8.7 5.3 1.6.7.3 5.5 8.3 5.5 9.1 0 6-4.9 10.9-10.8 10.9a10.8 10.8 0 0 1-10.8-10.9c0-.8 5-9 5.6-9.3a11 11 0 0 1 5.2-1.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd6b9",
          d: "M319.3 217.3c1.8 0 3.7.7 5.2 1.5.7.4 5.3 8.2 5.3 9 0 5.8-4.7 10.7-10.5 10.7a10.6 10.6 0 0 1-10.6-10.7c0-.8 4.8-8.8 5.5-9.2a11 11 0 0 1 5-1.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd4b8",
          d: "M319.3 217.6c1.8 0 3.7.6 5.2 1.4.6.4 5.2 8 5.2 8.8 0 5.7-4.7 10.5-10.4 10.5s-10.4-4.7-10.4-10.5c0-.8 4.6-8.6 5.3-9a10.8 10.8 0 0 1 5-1.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd4b6",
          d: "M319.3 217.7c1.8 0 3.6.7 5 1.5.8.4 5.2 7.7 5.2 8.6 0 5.6-4.6 10.3-10.2 10.3a10.2 10.2 0 0 1-10.2-10.3c0-.9 4.5-8.4 5.2-8.8a10.8 10.8 0 0 1 5-1.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd2b2",
          d: "M319.3 218c1.7 0 3.5.6 5 1.4.7.4 5 7.5 5 8.4 0 5.5-4.6 10-10 10s-10-4.4-10-10a39 39 0 0 1 5.1-8.6 10.7 10.7 0 0 1 4.9-1.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd1b0",
          d: "M319.3 218.2c1.7 0 3.5.6 4.9 1.4.7.4 4.9 7.3 4.9 8.2 0 5.4-4.5 9.9-9.8 9.9s-9.8-4.4-9.8-9.9c0-.9 4.2-8 5-8.4a9.8 9.8 0 0 1 4.8-1.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd0b0",
          d: "M319.3 218.4c1.7 0 3.4.6 4.8 1.3.8.5 4.7 7.1 4.7 8.1a9.5 9.5 0 1 1-19.1 0c0-1 4.1-7.8 5-8.3a9.8 9.8 0 0 1 4.6-1.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdd0ad",
          d: "M319.3 218.6a9.8 9.8 0 0 1 4.7 1.3c.8.5 4.6 7 4.6 8 0 5-4.2 9.3-9.3 9.3s-9.4-4.1-9.4-9.4c0-1 4-7.6 4.8-8a9.6 9.6 0 0 1 4.6-1.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdcaa6",
          d: "M319.3 219.2c1.5 0 3 .5 4.4 1.2.9.5 4.3 6.3 4.3 7.4a8.8 8.8 0 0 1-8.7 8.8 8.8 8.8 0 0 1-8.8-8.7c0-1.2 3.6-7.1 4.5-7.7a9.1 9.1 0 0 1 4.3-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdcaa4",
          d: "M319.3 219.4a9.1 9.1 0 0 1 4.3 1.2c.9.5 4.2 6 4.2 7.2a8.6 8.6 0 0 1-8.5 8.6 8.6 8.6 0 0 1-8.6-8.5c0-1.2 3.5-7 4.4-7.5a9 9 0 0 1 4.2-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc8a4",
          d: "M319.3 219.6c1.5 0 3 .5 4.2 1.2a19 19 0 0 1 4.1 7 8.4 8.4 0 0 1-16.7.1c0-1.2 3.3-6.7 4.3-7.3a8.5 8.5 0 0 1 4-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc8a1",
          d: "M319.3 219.8c1.4 0 2.9.5 4 1.1 1 .6 4.1 5.7 4.1 7a8.2 8.2 0 0 1-8.1 8.1 8.2 8.2 0 0 1-8.2-8.1c0-1.3 3.2-6.6 4.2-7.1 1.2-.6 2.5-1 4-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc39b",
          d: "M319.3 220.4c1.3 0 2.7.4 3.7 1a15 15 0 0 1 3.8 6.4 7.5 7.5 0 0 1-7.5 7.6 7.5 7.5 0 0 1-7.6-7.5c0-1.4 2.8-6 3.9-6.6a7.7 7.7 0 0 1 3.7-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc398",
          d: "M319.3 220.6c1.3 0 2.6.4 3.6 1a13 13 0 0 1 3.7 6.3c0 4-3.3 7.3-7.3 7.3a7.3 7.3 0 0 1-7.4-7.3 14 14 0 0 1 3.8-6.4 7.7 7.7 0 0 1 3.6-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc097",
          d: "M319.3 220.8a7.5 7.5 0 0 1 3.6 1 13 13 0 0 1 3.5 6c0 4-3.2 7.2-7.1 7.2a7.1 7.1 0 0 1-7.2-7.1c0-1.5 2.5-5.6 3.7-6.3a7.3 7.3 0 0 1 3.5-.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdc095",
          d: "M319.3 221a7 7 0 0 1 3.5 1c1.1.7 3.4 4.4 3.4 5.9a7 7 0 0 1-7 7 7 7 0 0 1-6.9-7c0-1.5 2.4-5.4 3.6-6a6.8 6.8 0 0 1 3.4-.9z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdbe92",
          d: "M319.3 221.2a7 7 0 0 1 3.4 1c1.1.6 3.3 4.2 3.3 5.7a6.7 6.7 0 1 1-13.5 0c0-1.5 2.3-5.2 3.5-5.9 1-.5 2-.8 3.3-.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdbe90",
          d: "M319.3 221.4c1.1 0 2.3.4 3.3 1 1.1.6 3.2 4 3.2 5.5a6.5 6.5 0 0 1-6.5 6.5 6.5 6.5 0 0 1-6.6-6.5c0-1.6 2.1-5 3.4-5.7a6.6 6.6 0 0 1 3.2-.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdbb8f",
          d: "M319.3 221.6c1.1 0 2.2.3 3.2.9 1.2.7 3 3.8 3 5.4a6.3 6.3 0 0 1-6.2 6.3 6.3 6.3 0 0 1-6.4-6.3 9 9 0 0 1 3.3-5.5c1-.5 2-.8 3-.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdbb8d",
          d: "M319.3 221.8c1 0 2.2.3 3 .9a8 8 0 0 1 3 5.2 6.1 6.1 0 0 1-6 6 6.1 6.1 0 0 1-6.1-6c0-1.6 1.8-4.6 3-5.3a6 6 0 0 1 3-.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdb98a",
          d: "M319.3 222a5.8 5.8 0 0 1 3 .8c1.2.8 2.9 3.5 2.9 5a6 6 0 0 1-6 6 6 6 0 0 1-5.8-6c0-1.6 1.6-4.3 3-5a6 6 0 0 1 2.9-.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fdb98a",
          d: "M319.3 222.2a5.8 5.8 0 0 1 2.8.8 7 7 0 0 1 2.9 4.9 5.7 5.7 0 0 1-11.4 0 7 7 0 0 1 2.9-5 5.5 5.5 0 0 1 2.8-.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fcb687",
          d: "M319.3 222.4c1 0 2 .3 2.8.8a6.5 6.5 0 0 1 2.6 4.7 5.5 5.5 0 1 1-11 0c0-1.7 1.5-4 2.9-4.8a6 6 0 0 1 2.7-.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fcb685",
          d: "M319.3 222.6c1 0 1.9.3 2.7.8a5.9 5.9 0 0 1 2.5 4.5 5.3 5.3 0 0 1-5.2 5.3 5.3 5.3 0 0 1-5.3-5.3 5.9 5.9 0 0 1 2.7-4.6 5 5 0 0 1 2.6-.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fcb485",
          d: "M319.3 222.8c1 0 1.8.3 2.6.7a5.3 5.3 0 0 1 2.4 4.4 5 5 0 1 1-10.1 0c0-1.8 1.1-3.6 2.6-4.4a5 5 0 0 1 2.5-.7z"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fcb482",
          d: "M319.3 232.8a4.9 4.9 0 0 0 4.8-4.9c0-2.7-2.2-4.9-4.8-4.9a4.9 4.9 0 0 0-5 4.9 4.9 4.9 0 0 0 5 4.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      d: "M319.3 232.8a4.9 4.9 0 0 0 4.9-4.9 4.9 4.9 0 0 0-4.9-4.8 4.9 4.9 0 0 0-4.9 4.8 4.9 4.9 0 0 0 5 4.9z"
    }),
    /* @__PURE__ */ jsxs221("g", {
      stroke: "#000",
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          d: "m320.4 223.1.5-2.6m-1 2.6.2-2.7m-.8 2.6v-2.6m-.5 2.7-.3-2.7m-.2 2.7-.6-2.6m.1 2.8-.8-2.6m.3 2.7-1-2.4m.6 2.6-1.4-2.3m1 2.6-1.6-2.1m1.2 2.5-1.9-2m1.5 2.3-2-1.8m1.7 2.2-2.2-1.5m1.8 2-2.2-1.4m2 1.8-2.4-1m2.2 1.5-2.5-.9m2.4 1.4-2.6-.6m2.5 1-2.6-.2m2.6.8h-2.7m2.7.5-2.6.3m2.7.2-2.6.6m2.7-.1-2.5.8m2.7-.3-2.4 1m2.6-.6-2.8 1.8m3.1-1.3-5.7 4m6-3.6-6.1 5.4m6.5-5-5.1 5.6m5.5-5.3-3.9 5.1m4.3-4.8-4 7m4.5-6.8-2.3 5m2.7-4.8-2.2 7m2.7-6.9-1 4.7m1.6-4.6-.7 7.2m1.7-7.2.2 2.6m.3-2.7 1.5 6.8m-1-7 1.3 4.1m-.8-4.2 3 6.7m-2.6-7 3.3 5.8m-2.8-6 4.7 6.2m-4.3-6.5 4.1 4.8m-3.8-5.2 6.2 5.7m-5.9-6 3.4 2.4m-3-2.9 2.2 1.3m-2-1.7 2.4 1m-2.2-1.5 2.5.8M324 229l2.6.5m-2.5-1 2.6.2m-2.6-.8h2.6m-2.6-.5 2.6-.2m-2.7-.3 2.6-.5m-2.7 0 2.5-.8m-2.7.4 2.4-1.1m-2.6.6 2.3-1.3m-2.6.9 2.1-1.6m-2.4 1.1 2-1.7m-2.4 1.4 1.8-2m-2.2 1.6 1.6-2m-2 1.8 1.3-2.3m-1.8 2 1.1-2.4m-1.6 2.3.9-2.5m-2.4-4v-2M317 217l-.4-2m-1.8 2.7-.8-1.8m-1.2 3-1.2-1.7m-.5 3.2-1.6-1.3m.2 3.2-1.8-1m.8 3.2-2-.7m1.5 3-2-.3m2 2.5-2 .2m2.5 2.1-2 .7m22.2 1.5 1.8 1m-.8-3.1 1.9.6m-1.5-2.9 2 .2m-2-2.5 2-.2m-2.4-2.1 2-.6m-3-1.5 1.8-1m-3.1-.9 1.5-1.4m-3.2-.2 1.2-1.6m-3.2.5.8-1.9m-3 1.1.4-2"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#e60000",
          fillRule: "evenodd",
          strokeMiterlimit: 2.6,
          d: "M322.1 230.2s-.7-.4-1-.4l-3 .1c-.5.1-.8.5-.8.5s.5.5 1.4.6c1 0 1.7 0 2.2-.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#e60000",
          fillRule: "evenodd",
          strokeMiterlimit: 2.6,
          d: "M317.4 229.5s.1-1.4 1-3l-.4.8s-.6.3-.9 0c-.3-.4-.1-.5.1-1 .2-.4.2-.8.5-1 .2-.3.4-.3 1-.3.7 0 1.2 0 1.7.8l1 1.7c.6.8.6 1.9.6 1.9l.2.8s-.7-.4-1.1-.4l-3 .1-.8.5s-.3-.6.1-1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "none",
          strokeMiterlimit: 2.6,
          d: "M317.4 229.5s.6-.3 2.3-.3c2 0 2.1.2 2.3.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          strokeMiterlimit: 2.6,
          d: "M319.2 237.1v-7.2s.2-.2.8 0v7.1s.2 5.5-.4 5.5c-.7 0-.4-1.3-.4-5.4z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs221("g", {
      fill: "#e60000",
      children: [
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m311.8 231 .1.3-1.4.6.2.5h-.2c-.1-.2-.2-.3-.6-.3v-.2zm-1.5-.5a.6.6 0 0 1-.3-.4c0-.4.1-.7.6-.8.2-.1.7-.1.9.5 0 .3 0 .7-.5.8v-.2c.2-.1.3-.3.2-.6 0-.2-.3-.3-.6-.3-.3.1-.4.3-.3.6a.5.5 0 0 0 .3.3v.2l-1.2.1-.2-1h.3l.2.8zm-.6-4c-.3 0-.5.3-.5.6 0 .2 0 .5.3.5s.3-.1.4-.2l.2-.6c0-.3.2-.5.6-.5.5 0 .6.6.5 1l-.2.6c-.2.1-.4.2-.6.1v-.2c.4 0 .6-.3.6-.6 0-.2 0-.5-.3-.6-.3 0-.3 0-.4.4l-.2.5c0 .1-.1.4-.5.4s-.7-.3-.6-.8c0-.8.5-.8.7-.8v.3zm0-1.3.5.2.4-1.1h.3l-.4 1.2.7.3.4-1.3h.2l-.4 1.6-2.1-.7.5-1.5.2.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M311 222a.7.7 0 0 0-.4.4l-.5.8 1.9 1.1.1-.2-.8-.5.4-.6c.2-.4 0-.7-.2-.9a.6.6 0 0 0-.5 0zm.2.4a.4.4 0 0 1 .1 0c.2.2.2.3.1.6l-.3.4-.6-.3.3-.5c.1-.2.2-.3.4-.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m313.6 222.1-.2.2-1.4-1.3-.5.5-.2-.1 1.2-1.3.2.2-.5.5zm.7-.6-1.3-1.7.2-.2 1.3 1.7zm0-2.3.3.6 1-.5.2.2-1 .6.2.6 1.2-.6.1.2-1.4.8-1-2 1.4-.7.1.2zm4 .6-.3-1.2v-.6l-.3 2h-.3l-1-1.6.2.5.2 1.3h-.2l-.5-2.1h.4l1 1.6.2-2h.4l.5 2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M319 217.6v2.2h.8c.5 0 .8-.2.8-.6 0-.3-.2-.4-.4-.5.3-.1.3-.3.3-.5 0-.3-.1-.5-.5-.6zm.3.3h.5c.3 0 .4.2.4.4s-.1.3-.4.2h-.5zm0 .9h.5c.2 0 .5.1.5.4 0 .2-.2.4-.5.4l-.5-.1zm2.1-1-.5 2.1.2.1.3-.9.7.2c.3.1.3.3.2.5v.5l.3.1v-.7c.1-.2 0-.3 0-.4 0 0 .3-.1.3-.4.2-.5-.1-.7-.5-.8zm.3.4.6.2c.2 0 .4 0 .3.4 0 .3-.3.3-.5.2l-.6-.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m324 219-.3.6 1 .6-.1.2-1-.5-.4.6 1.1.6-.1.2-1.4-.8 1-1.8 1.5.8-.2.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M326.6 220.7 325 222l.6.7c.4.5 1 .3 1.4 0 .5-.4.6-1 .2-1.4zm0 .4.3.4c.3.3.3.6-.1 1-.4.3-.8.3-1 0l-.3-.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m328.2 223-.7.4.6 1-.3.2-.5-1.1-.6.3.6 1.2h-.3l-.7-1.3 2-1 .7 1.4-.3.1zm-.8 4v-.3l1.5-.2-.1-.5h.2c0 .3.1.4.5.5v.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m328 227.6-.4.2a.9.9 0 0 0-.2.5c0 .5.3.8.6.8.2 0 .4 0 .6-.3 0 0 .1.2.4.2.3 0 .6 0 .6-.6 0-.5-.3-.7-.6-.7-.2 0-.3.1-.4.4 0-.3-.3-.4-.5-.5zm0 .4c.2 0 .4.1.4.4 0 .2-.1.4-.4.4-.3 0-.3-.3-.3-.5 0-.3.2-.3.4-.3zm1 0c.2 0 .3.1.3.4 0 .3-.2.4-.3.4a.4.4 0 0 1-.3-.4c0-.2.1-.3.3-.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "M328.7 229.5c.7.2.6.7.6 1-.1.3-.4.5-.8.4-.4 0-.5-.3-.6-.7v-.2c0-.4-.2-.5-.3-.5l-.3 1.1h-.3l.4-1.4c.4.1.6.3.7.7v.3c.2.2.2.4.5.5.1 0 .4 0 .5-.4 0-.3-.3-.4-.4-.5zm-2.1 2.1.1-.3 1.4.7.2-.5.2.1c-.1.4-.2.5.1.7v.2z"
        })
      ]
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.2,
      d: "M319.3 202.3 283 263h72.7z"
    }),
    /* @__PURE__ */ jsxs221("g", {
      fill: "none",
      strokeMiterlimit: 2.6,
      children: [
        /* @__PURE__ */ jsx228("path", {
          stroke: "#000",
          strokeWidth: 0.1,
          d: "M321.3 255.5a6.3 6.3 0 0 0 3.2 0c1.5-.3 3-1.2 4.8-1 1.4 0 3.2 1.2 5.3 1.2 2.2 0 3-.7 4.8-1.1 1.3-.3 2-.2 3.4.2 1.6.3 2.5 1.2 5.2 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fff",
          strokeWidth: 0.4,
          d: "M293.2 258.1c1.3-1 3.4-1.3 5-1 2.2.5 3.1 1 5.4 1 1.7 0 3.2-1.1 5-1.1 2.8 0 2.9.6 5.4 1a5.6 5.6 0 0 0 2.2 0 9.5 9.5 0 0 0 2.5-.8c.8-.4 2.8-.4 3.8-.3 1.8.2 2.6.9 3 1 1 .2 2 .4 3.2 0 1.5-.4 3-1.4 4.9-1.2 1.3.2 3 1.4 5.2 1.4s3-.8 4.8-1.2c1.4-.3 2-.2 3.4.1 1.6.4 2.5 1.5 5.2 1.2"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fff",
          strokeWidth: 0.3,
          d: "M289.1 256a7.6 7.6 0 0 1 5-.8c2.2.4 3.1 1 5.4 1 1.7-.1 3.2-1.1 5-1.1 2.8 0 2.9.5 5.4 1h2.2a9.4 9.4 0 0 0 2.5-.9c.8-.3 2.8-.3 3.8-.2 1.8.2 2.6.8 3 .9 1 .2 2 .3 3.2 0 1.5-.4 3-1.2 4.9-1 1.3 0 3.1 1.2 5.2 1.2 2.2 0 3-.8 4.8-1.1 1.4-.3 2-.1 3.4.1 1.6.4 2.5 1.3 5.2 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fff",
          strokeWidth: 0.5,
          d: "M285.4 262a6.3 6.3 0 0 1 5-1c2.1.5 3 1.1 5.4 1 1.7 0 3.2-1.3 4.9-1.3 2.9 0 3 .7 5.5 1.3a5.8 5.8 0 0 0 2.2 0 8.4 8.4 0 0 0 2.5-1c.8-.5 2.8-.4 3.8-.3 1.8.2 2.5 1 2.9 1 1 .3 2 .5 3.3.2 1.5-.6 3-1.6 4.8-1.4 1.3.1 3.1 1.6 5.3 1.6 2.1 0 3-1 4.7-1.5 1.4-.3 2-.1 3.5.2 1.6.4 2.5 1.6 5.2 1.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fff",
          strokeWidth: 0.3,
          d: "M286.4 258.6c1.2-.9 3.4-1.2 5-.9 2.1.5 3 1 5.4 1 .7 0 1.4-.3 2.2-.5"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#000",
          strokeWidth: 0.2,
          d: "M297.4 255c.3 0 1.3-.5 2.8-.5 2.9 0 1 0 3.6.5.7 0 2.5 0 3-.4m25.4 8.2c1-.2 1.8-.5 2.6-.8.7-.3 2.7-.3 3.8-.2 1.8.2 2.5.8 2.9.8a6.3 6.3 0 0 0 3.2 0c1.6-.3 3-1.2 5-1 1.2.1 3 1.3 5.2 1.3"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#fff",
          strokeWidth: 0.3,
          d: "M336.7 254.8c2.1 0 2.9-.8 4.8-1.2 1.3-.2 2 0 3.3.2 1.7.3 2.5 1.3 5.2 1"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#000",
          strokeWidth: 0.1,
          d: "M285.5 262.2a7.7 7.7 0 0 1 5-.8c2.2.4 3.1.9 5.4.9 1.7 0 3.2-1.1 5-1.1 2.8 0 2.9.6 5.4 1a7.5 7.5 0 0 0 2.2 0 9.8 9.8 0 0 0 2.5-.8c.8-.4 2.8-.3 3.8-.2 1.8.1 2.5.7 3 .8"
        }),
        /* @__PURE__ */ jsx228("path", {
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M290 259.6c1.3-.9 3.5-1.2 5.1-.9 2.2.4 3.1 1 5.4.9 1.7 0 3.1-1 4.8-1 3 0 3 .5 5.6 1a7.4 7.4 0 0 0 2.2 0 11.3 11.3 0 0 0 2.5-.9c.7-.3 2.8-.3 3.8-.2 1.8.2 2.5.8 3 .9.9.2 2 .3 3.2 0 1.5-.4 3-1.3 4.8-1 1.5 0 3.3 1.2 5.3 1.2 2.2 0 3-.8 4.8-1.2 1.3-.2 2 0 3.4.2 1.6.3 2.5 1.3 5.2 1"
        })
      ]
    }),
    /* @__PURE__ */ jsxs221("g", {
      fill: "#fc0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.2,
      children: [
        /* @__PURE__ */ jsx228("path", {
          d: "M291 249.5c.4 0 1.2-.6 1.5-.8.3-.2.5-.7.8-1l1.5-1a10.8 10.8 0 0 0 3.5-3.1 17.8 17.8 0 0 1 5.7-5.2c.8-.4 1.9-.3 2.7 0l.8.7c1 .7 2.3 1.3 3.9 1.8 1.5.4 1.9 1.4 3 2.5.7.5 1.3 1 2 1.3l.4.4 2 1.4a67 67 0 0 1 3.2 3.1l.4.7c.8.7 1.6 1.5 2.6 2l2.7 1.6c-9.2.4-17.7-.2-27 0H299l-1.8.1h-8.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m327.3 253.7-2.3-1.4c-1-.5-1.8-1.3-2.6-2l-.4-.7a67 67 0 0 0-3.2-3.1l-2-1.4-.3-.4a8.5 8.5 0 0 1-2-1.3l-1.9-2a7.5 7.5 0 0 1 1.3-.7c.6-.4 1.5-.3 2.2 0l.7.5c.8.7 1.9 1.1 3.2 1.5 1.3.4 1.6 1.2 2.6 2.1.5.5 1 .8 1.6 1.1l.3.3 1.7 1.3 2.7 2.5.3.6c.7.6 1.3 1.3 2.1 1.6l2.3 1.4h-6.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m319.1 242.4.9.3c1.3.4 1.6 1.2 2.6 2.1.5.5 1 .8 1.6 1.1l.3.3 1.7 1.3a63 63 0 0 1 2.7 2.5l.3.6c.7.6 1.3 1.3 2.1 1.6.7.3 1.3.8 2 1.2l5-.1c-.6-.4-1.2-1-2-1.3-.7-.3-1.3-1-1.9-1.5l-.3-.5-2.4-2.3-1.6-1.1-.2-.3a6.2 6.2 0 0 1-1.5-1c-1-.8-1.2-1.6-2.4-2a9 9 0 0 1-2.9-1.3c-.2-.1-.4-.4-.6-.4-.6-.3-1.5-.4-2 0a9.8 9.8 0 0 0-1.4.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m327.6 244.4.8.9 1.5 1 .2.3 1.6 1 2.4 2.4.3.5c.6.6 1.2 1.2 2 1.5l1.3.8h6c-.6-.4-1-.8-1.7-1l-1.5-1.3-.3-.4a93.8 93.8 0 0 0-2-1.9l-1.2-.9-.2-.2a5 5 0 0 1-1.2-.8c-.7-.7-1-1.3-1.9-1.6a7.3 7.3 0 0 1-2.4-1l-.4-.4c-.6-.2-1.2-.3-1.7 0a9.5 9.5 0 0 0-1.6 1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M343.3 252.5a7.4 7.4 0 0 0-1.3-.8l-1.5-1.2-.3-.4c-.6-.7-1.2-1.3-2-1.9l-1.2-.9-.2-.2a5.7 5.7 0 0 1-1.2-.8c-.6-.6-.9-1-1.5-1.4a6.3 6.3 0 0 1 1-.7c.5-.2 1 0 1.5 0l.4.4c.5.4 1.2.7 2 1 .9.2 1 .7 1.7 1.3.3.2.6.5 1 .6l.2.3 1 .7 1.7 1.6.2.4 1.3 1 1.5.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsx228("path", {
      fill: "none",
      stroke: "#00633b",
      strokeWidth: 0.1,
      d: "M303.2 239c.4 0 .2-.2.6 0m-1.5.5c.5 0 .7-.4 1 0m-1.4.3c.2 0 .3-.2 1 .2m-1.5.4h1m-1.6.4c.5-.1.7.2 1.3.1m-1.9.5h1.4m-2 .6h.7c.5 0 .4.1.8 0m-1.9.5c.7 0 1 0 1.4.2m-2.3 1.1h1.4m-11 10c1.8-.4 4 0 6-.3m3.8-10.3c.5-.2.4 0 1 0h.7m-2.4 1.1c.5-.2 1 0 1.5 0m-.3.5c-.5-.1-1 0-1.6 0m1.2.6a2.9 2.9 0 0 0-1.7 0m-.8.4c.7 0 1.4-.2 2.1 0m-2.6.6c.7-.3 1.4 0 2.2 0m-3 .4h2.3c.1 0 .4-.2.5 0m-.2.4c-1.2.2-2.3 0-3.5.1m2.8.5c-.3 0-1 .2-1.5.1h-.3a4.2 4.2 0 0 0-1.7.1m-.2.4a1 1 0 0 1 .7 0h2.1l.6.3m-3.9 0h1.6l2 .4m-4 0c.5 0 1 0 1.6.2l2.1.1m-4.4 0c.7.3 1.5 0 2.2.2l2.1.2m-4.8.2c1.1 0 2.2 0 3.4.2.3 0 .8.2 1.2.1m-5 .2c1.1.2 2.2 0 3.3.3l1.5.2m-5.2.3.3-.1h2.6c.7 0 1.5 0 2.2.2m-5.5.5c1.7-.2 3.5 0 5.2 0m-5.5.5c1.8.2 3.7 0 5.5.1m-5.8.4c.8.2 1.6 0 2.4.1.6.1 1.1.2 1.7.1h1.5m7.4-7.6h.2m-.4.2h.2m-.4.3h.4m-.5.2h.4m-.8.3.8.1m-1 .4 1-.1h-.1m-1.3.5h1.3m-1.6.4h1.4m-1.6.4h1.6m-2 .5 1 .2c.3.1.6 0 .8 0m-1.8.2 1.6.2m-2 .2c.5 0 1 0 1.4.2h.6m-2.5.4c.5-.2 1.2 0 1.8.1h.6m-2.5.4c.6-.2 1.3-.2 2 0h.3m-2.7.5c.8.1 1.7-.1 2.6.1m-2.9.2c.7.3 1.5 0 2.2.2.3.1.5.1.8 0m-3.5.4c.3-.1.7-.2 1-.1.8.2 1.6.1 2.3.2m-3.6.4c.1 0 .3.1.4 0h3.2m-4 .4c1 .3 1.8 0 2.7.3h1.2m-4.1.3c1.3 0 2.5 0 4 .2m3.3-7.5h.3m-.5.3h.5m-.6.4h.6m-.8.5h.8m-1 .5 1-.1m-1.1.4h1m-1.2.6h1.3m-1.3.4h1.4m-1.6.6h1.5m-1.7.5c.2 0 .4-.2.6-.1h1m-1.7.6c.6-.2 1.2.2 1.8-.2m-2 .8h2m-2 .5c.6-.2 1.4 0 2 0m-2.5.5 2.8-.2m-2.7.7c1-.2 2 0 3.1-.1m-3.3.7c1 .1 1.3 0 2.3-.1l1.2-.2h.6m-4 .6c1.5-.2 3 .1 4.6-.3m-11.3 0h1.2m4.7.3c.2 0 .3-.1.4 0m5.4-.1c1.3-.2 2.5.2 3.8 0m-4.4-.5c.8-.2 1.5 0 2.3.1l.1.2h2m-8.9-.3h-.8m-4.1-.2-1.7.1m12.1-11.8h.3m-.2.3h.3m-.2.6.4-.1m-.3.4h.6m0 .4h-.5m.3.6a.8.8 0 0 1 .5-.1m.3.4h-.8m.2.4.8-.1m.2.6h-.9m.2.6c.4 0 .7 0 1-.2m0 .3-.9.2m.2.6c.4-.2.9 0 1.2-.2m.1.5h-.9l-.3.1m.2.8c.3-.1.5-.3.8-.3h.6m.2.4-1.4.2m.1.6 1.6-.3m-1.5 1 1.8-.4m.4.4c-.7.1-1.4 0-2 .3m.2.6s.1.1.2 0a4 4 0 0 1 2-.3m0 .4c-.5.4-1.3.2-2 .3h-.2m.2.5 2.3-.2m.5.5h-1.8c-.3 0-.5.2-.8.3m0 .5h.4c.8-.5 1.6-.4 2.5-.4m.2.5c-.7 0-1.4-.2-2.1 0-.3.1-.5.3-.8.3m.3.5 1-.3h2.4m0 .4c-.4-.1-1-.2-1.3 0-.7.1-1.3.3-2 .3m.4.4c.5 0 1-.3 1.6-.4h1.3m-3 .7c1-.1 1.7 0 2.6-.3h.9m0-.3c1.4.1 2.8-.1 4.1.2m-3.8.3.4-.1h3.4m-.4-2.9h.2m-.1.4c.1 0 .2-.2.4 0m-.3.4h.7m-.5.6c.2-.3.6 0 .8-.2m-.6.8c.3-.3.7 0 1-.3m-1 .7c.5-.2 1 0 1.4-.3m-1.2.7c.7-.3 1.5.1 2.1-.4m-2 .7c.8-.2 1.7 0 2.6 0m.6 0h4.6m-5.3-.6c1.4.2 3.4 0 5.1.2m-12.6-10.6 1.1-.2m-.8.4 1.2-.1m-.7.6.8-.2h.4m-.9.4h1.5m.2.3-1.2.1m.8.5 1-.2m.5.4h-1.2m.6.5 1-.2m.6.5h-1m.5.5 1.2-.1m.4.2-1 .2m.5.5c.3-.2.9 0 1.3-.2m.4.5h-1l-.4.1m2.6.8-1.5.1m.5.6c.5-.2 1.1-.2 1.6-.3m-.4 1.7h.8c.8-.2 1-.4 1.7-.3m.5.4-2.2.2-.4.1m.4.4c.8-.2 2-.1 2.7-.3m.8.5-2 .1-1 .1m.7.5h.3c.6-.4 1.7-.4 2.6-.4m.5.5h-1.9l-.9.2m.8.5c.8-.2 2.3-.3 1.4-.3h1.9m.2.3a4.3 4.3 0 0 0-1.5 0c-.4.2-.3.3-1.4.3m.4.2 1.2-.1 1.5-.1m-2.4.4h2.7m-16.2-11h.7c0-.2.2 0 .3-.2h.3m-1.7-.2h.8c-.1-.2.2 0 .2-.1h.4m5.5 6c.2-.1.2-.2.6-.1-.1-.2.3 0 .4-.1h.5m0 1.5c.5 0 1.2 0 1.7-.3m.8.6c-.6.1-1.6 0-2.1.3m-8-8.4c-.6 0-.7.2-1.1.2m8 1.6 1-.2m-.7.5c.4-.1.7 0 1-.2m-.7.5.7-.1h.4m-.7.4h1.2m.3.2a4 4 0 0 0-1.2.2m.4.4 1.3-.2m.5.3-1.3.1m.4.4c.3 0 1.2 0 1.3-.2m.5.5h-1.2m.4.4 1.3-.1m.4.2c-.2.2-.9.2-1.1.3m.6.4c.3-.2.8 0 1.2-.2m.4.4h-1c0 .1-.1.2-.3.1m2.4.8-1.4.1m.5.5c.4-.2 1-.2 1.5-.3m-.3 1.7.6-.1c.8-.1.9-.3 1.6-.3m.4.4-2 .2-.4.1m.4.3c.7 0 1.8 0 2.5-.2m.7.4-1.7.1-1 .2m.6.4h.3c.6-.4 1.5-.3 2.4-.3m.5.4H332l-.9.2m.6.4 1.5-.2h1.7m.2.3h-1.4c-.2 0-.3.2-1.5.2m.4.3 1.3-.2h1.4m-2.1.4 1.7-.1h.7m-15-10.1c.3-.1.2-.2.5-.1l.5-.1h.3m-1.7 0c.2-.2.2-.3.6-.2l.4-.1h.4m5.2 5.5c.2-.1 0-.2.4-.1-.1-.2.3 0 .4-.1h.5m0 1.5 1.5-.4m.8.6c-.6.1-1.4 0-1.8.2m-7.5-7.6a2.3 2.3 0 0 0-1.4.5m8.6 2.5.9-.1m-.7.3 1-.1m-.7.4.7-.1h.3m-.7.3h1.1m.2.2h-.9m.5.4.8-.2m.4.3h-1m.3.4 1-.2m.4.4h-1m.4.3 1-.1m.3.2-.9.2m.3.3 1.1-.1m.3.3h-1m1.9.7-1.2.1m.4.3 1.2-.2m-.3 1.2h.6l1.2-.2m.3.3-1.5.2h-.4m.3.3 2-.2m.6.3H336a7.3 7.3 0 0 1-.9.2m.5.4.6-.2 1.6-.1m.3.3H337l-.9.3m.6.2 1.2-.2h1.3m.2.2h-1c-.3.1-.5.2-1.3.2m.3.2 1-.1 1.1-.1m-1.7.4h1.4l.5-.1m-11.5-7.7c.2 0 .2-.2.5-.2h.6m-1.4 0c.2-.1.2-.2.5-.2h.6m3.8 4.2.5-.1h.3c0-.1.3 0 .4 0m0 1c.3 0 .8 0 1.1-.2m.6.4c-.4.1-1 0-1.5.2m-5.6-5.9c-.4 0-.5.2-.8.4m7 .9 1-.1m-.7.3.9-.1m-.6.4.6-.1h.3m-.6.4 1-.2m.2.2c-.2 0-1 0-1 .2m.4.2s.7-.2.9-.1m.4.2-1 .1m.3.2 1-.1m.3.3-1 .1m.4.3 1-.1m.3.1-1 .2m.4.3 1-.1m.3.3h-1m1.8.6-1 .1m.2.3 1.3-.2m-.4 1.2.5-.1c.6 0 .7-.2 1.2-.1m.2.2a12.4 12.4 0 0 1-1.7.2m.2.3a36.3 36.3 0 0 1 1.9-.2m.5.3H342l-.8.2m.4.3.5-.1 1.5-.2m.4.3h-1.2l-1 .2m.6.3 1.2-.2h1.2m.2.2a3 3 0 0 0-1 0 3 3 0 0 1-1.2.2m.3.1 1-.1h1m-1.7.3h1.3l.5-.1m-10.6-7.1.4-.1h.6m-1.3-.1c.2 0 .2-.2.4-.1h.4l.2-.1m3.6 3.9h.4c0-.2.2 0 .3-.1h.3m0 1c.3 0 .8 0 1.1-.2m.6.4-1.5.1m-5-5.4c-.5 0-.6.2-.9.3"
    }),
    /* @__PURE__ */ jsxs221("g", {
      fill: "#fc0",
      children: [
        /* @__PURE__ */ jsx228("path", {
          d: "m287.6 298.6.6 4.5c-1.1-.4-2.2.2-2.7 1.2-.9 1.7-.1 3 1.5 3.7l2.1 1.2 4-7.8-1.6-.8-1.6 3.1-.4-4.1zm.6 5.9.9.3h.1l-1 2.2-.3-.1c-.7-.4-1.2-.9-.8-1.7.3-.6.7-.8 1.1-.7"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m280.7 302.7 1-1.6-2.3-1.6.8-1.2 2.3 1.6 1.4-2-2.5-1.6.9-1.3 3.8 2.7-4.8 7.2-3.9-2.6.8-1.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m279 292.5-2 2.5-.7-.6c-1.4-1.2-2.8-1.2-4 .2-1.3 1.5-.8 2.9.6 4.1l1.9 1.6 5.6-6.7-1.3-1.1zm-4.4 2.8c.3 0 .7.3 1 .6l.3.2-1.6 1.8-.2-.2c-.7-.6-1-1-.4-1.9.4-.4.6-.5 1-.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m268.4 294.6-1.2-1.3 3.6-3.3c.8-.7 1.9-1.8.9-3-1-1-2.3 0-3 .6L265 291l-1.2-1.3 3.9-3.5c1.6-1.4 3.4-1.8 5 0 1.7 1.8 1.1 3.6-.5 5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "M265.1 278.1c-.5 0-1 .1-1.5.5-.8.5-1.4 1.5-.9 2.5-.6-.3-1.3 0-1.9.3-1.4 1-1.4 2.2-.4 3.6l1.3 1.8 7.2-5-1.6-2.2c-.6-.8-1.3-1.4-2.2-1.5m0 1.9c.5 0 1 .4 1.3.9l.2.3-1.8 1.2-.2-.2c-.4-.6-.9-1.4 0-2zm-2.5 2.5c.3 0 .6.2.8.6l.1.2-1.7 1.2v-.2c-.5-.6-.6-1 .1-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m264.6 275.3-7.7 4.2-.8-1.6 6.3-3.4-1.1-2.2 1.2-.7zm-11.4-3.5 8-3.5.6 1.6-8 3.5zm-1-9.5a2.7 2.7 0 0 0-.3 2.2c.6 1.5 2.3 2 3.7 1.5 1.4-.4 2.5-1.8 2-3.4a2.8 2.8 0 0 0-1.5-1.6l1.9-.6c.5.5 1 1 1.1 1.8a4.5 4.5 0 0 1-2.9 5.6c-2.4.7-5-.3-5.8-2.8a4.7 4.7 0 0 1-.2-2.1z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m256.4 250.6-8.2 5 .2 1.3 9.4 2-.3-1.9-2-.4-.5-3.1 1.7-1zm-2.7 3.6.4 2.1-3.3-.4zm-2-19.9c-2.2 0-4 1.6-4.2 4l-.2 2.6 8.7.7.2-2.5a4.3 4.3 0 0 0-4-4.8zm-.3 2a3 3 0 0 1 .6 0c1.6.1 2.6 1 2.4 3v.2l-5.2-.4v-.3c.1-1.6.9-2.4 2.2-2.5"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m250.2 229.5 1.9.4.6-2.8 1.4.3-.6 2.8 2.3.5.6-2.9 1.5.3-1 4.6-8.5-1.8 1-4.6 1.4.3zm3.3-11.4 1.8.6 1-2.6 1.4.6-1 2.6 2.2.8 1-2.7 1.4.5-1.7 4.4-8.1-3.1 1.7-4.4 1.4.5zm8.9-2.3-7.8-4 .8-1.5 6.4 3.3 1.2-2.2 1.3.6zm1.9-15.9c-.6 0-1 .2-1.4.7a1 1 0 0 0 0 1.5c1.3.8 3-2.4 5.3-.7 1.4 1 1.7 2.7.6 4.2-.8 1-1.9 1.3-3 1.2l-.2-1.6c.7.3 1.5.1 2-.5.4-.6.2-1.3-.4-1.7-.7-.5-1.4 0-2 .4-1 .7-2 1-3.1.2a2.6 2.6 0 0 1-.6-3.6 3.9 3.9 0 0 1 2.3-1.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m268.1 192.3-1 1 4 8.7 1.3-1.4-.7-1.7 2.1-2.3 1.8.8 1.3-1.4-8.7-3.8zm1.4 2.4 2.8 1.3-1.4 1.4z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m278.3 195-5.5-6.8 1.4-1.1 4.5 5.6 2-1.6 1 1.2zm4.5-14 1.6-1 1.8 9.5-.8.5-7.8-5.7 1.6-1 5 3.8z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m290.6 176.8-1.3.6.5 9.6 1.7-.7v-2l2.8-1.4 1.4 1.4 1.7-.7zm.3 2.9 2.2 2.2-1.8.8-.3-3zm9.4-6-1.4.3-2.4.7 2.5 8.3 2.4-.6a4.3 4.3 0 0 0 3-5.5c-.6-1.9-2.1-3.1-4-3.1zm0 1.9c1 0 1.8.7 2.2 2 .4 1.4 0 2.7-2 3.2l-.2.1-1.5-5 .3-.1zm10.5-4.3h-.5a4.4 4.4 0 0 0-3.8 5.1 4.4 4.4 0 0 0 5 4 4.5 4.5 0 0 0 3.9-5.1 4.5 4.5 0 0 0-4.6-4m-.2 1.9c1.4-.2 2.5 1 2.7 2.3.2 1.1-.7 2.8-2 3-1.4.1-2.6-1.2-2.8-2.4-.1-1.3.7-2.7 2.1-2.9m7.4-2.4v8.8h1.7V176l2.2 3.5h2.1l-2.5-3.7c1.2-.1 1.9-1.2 1.9-2.4 0-1.8-1.2-2.6-3-2.6zm1.8 1.6h.3c.8 0 1.5.2 1.4 1.2 0 1-.6 1.2-1.5 1.2h-.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m336.6 174.3-.5 2 2.7.6-.3 1.4-2.8-.7-.5 2.3 2.8.8-.4 1.4-4.5-1.2 2.1-8.4 4.5 1.1-.3 1.5zm6.6 0 1.2.5 2.1 7.5 2.2-5.5 1.7.7-3.3 8.3-1.2-.5-2.2-7.5-2.2 5.5-1.6-.6zm9.3 14.3 4.7-7.4 1.5 1-3.9 6 2.1 1.4-.8 1.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m365.4 186.6-8.4 4.7 1.4 1.2 1.8-1 2.4 2-.6 2 1.5 1.1 3-9.1zm-1.3 2.5-1 3-1.6-1.3zm14.3 11.2-9.2 2.3 1 1.5 2-.4 1.8 2.5-1 1.7 1 1.5 5.3-8-.9-1.2zm-1.8 2-1.8 2.6-1.1-1.6z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m375.4 211.9-.8-1.6 8.7-2.7.6 1.1-4.1 4.6 6-.6.6 1.1-7.3 5.3-.9-1.6 4.6-3.1-6 .6-.2-.5 4-4.3zm11.6 8.3-1.8.6 1 2.7-1.5.5-.9-2.7-2.2.7 1 2.8-1.5.5-1.5-4.5 8.3-2.7 1.5 4.4-1.4.5z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m390.3 225.7-8.6 1.8.4 1.8 3.4-.8-3 3 .6 2 3-3.2a2.2 2.2 0 0 0 2.7 1.2c1.9-.3 2.4-1.7 2-3.4zm-1.1 2.1v.2c.2.9.1 1.6-.8 1.7-1 .3-1.3-.3-1.5-1.2v-.2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m392 236-8.6 1-.2-1.7 8.7-1zm-1.8 9.5a3 3 0 0 0 .8-2c0-1.7-1.5-2.7-3-2.6-1.5 0-3 1-2.9 2.6 0 .8.4 1.5 1 2h-2a4.8 4.8 0 0 1-.6-2 4.5 4.5 0 0 1 4.4-4.5c2.5 0 4.7 1.7 4.8 4.4a4.4 4.4 0 0 1-.5 2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m383.7 247.1-.2 1.9 1.8.9-.4 3.1-2 .5-.2 1.8 9.3-2.2.2-1.4zm3 3.6 2.7 1.2-3 .7.3-2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "M384 272.1a2.8 2.8 0 0 0 1.6-1.5c.7-1.6-.4-3-1.8-3.6-1.3-.5-3-.1-3.7 1.4a2.8 2.8 0 0 0 .2 2.2l-2-.7a4.9 4.9 0 0 1 .3-2.1 4.5 4.5 0 0 1 5.8-2.5c2.4.9 3.7 3.4 2.8 5.9a4.6 4.6 0 0 1-1.3 1.7zm-1.4 4.7-1.7-.9-1.3 2.5-1.3-.7 1.3-2.5-2-1.1-1.5 2.6-1.3-.7 2.3-4.2 7.6 4.2-2.2 4.1-1.3-.7zm-1.7 6.4-.7 1-7.7.3 4.7 3.5-1 1.4-7.3-5.2.8-1 7.7-.3-4.8-3.5 1.1-1.4zm-9 8.7 1.2-1.3 1 1-3.7 4-1-1 1.2-1.4-5.2-5 1.2-1.3z"
        }),
        /* @__PURE__ */ jsx228("path", {
          d: "m362.8 290.7-1.4 1.1 2.3 2.8-4-1.3-1.6 1.4 4.3 1.1c-.8 1-.6 2.2.2 3 1.1 1.5 2.6 1.3 4 .2l1.8-1.6zm1.7 5 1.5 1.8-.2.1c-.6.5-1.2.8-1.8 0-.7-.7-.3-1.3.4-1.8zm-7.1-.4-1.6 1 .3 1.9-2.7 1.6-1.5-1.1-1.6 1 7.7 5.7 1.1-.7-1.7-9.5zm-1 4.5.8 3h-.1l-2.4-2z"
        }),
        /* @__PURE__ */ jsx228("path", {
          fillRule: "evenodd",
          d: "m348.7 300.3 3.8 8-1.6.7-3-6.5-2.4 1-.6-1.3z"
        })
      ]
    })
  ]
});
var Sv_default = SvgSv;

// src/country-flag-icons/generated/Sx.tsx
import { jsx as jsx229, jsxs as jsxs222 } from "react/jsx-runtime";
var SvgSx = (props) => /* @__PURE__ */ jsxs222("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx229("defs", {
      children: /* @__PURE__ */ jsx229("clipPath", {
        id: "sx_svg__a",
        children: /* @__PURE__ */ jsx229("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs222("g", {
      clipPath: "url(#sx_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx229("path", {
          fill: "#ed2939",
          fillRule: "evenodd",
          d: "M0 0h768v256H341.3z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#002395",
          fillRule: "evenodd",
          d: "M0 512h768V256H341.3z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m0 0 341.3 256L0 512z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "m172.3 193.2.1-4s-2.1-3.4.4-7c0 0-5.3-2.8-4-7.2 0 0-4.8-1.2-4.5-6.4 0 0-5-.3-5.6-4.7 0 0-5.1.8-7.4-3.4 0 0-5 1-6.4-2.5 0 0-4.9 1.6-7.7-2.5 0 0-5.2 2.1-7.3-1.8-2.1 3.9-7.3 1.8-7.3 1.8-2.8 4.1-7.7 2.4-7.7 2.4-1.4 3.5-6.3 2.5-6.3 2.5-2.3 4.3-7.4 3.4-7.4 3.4-.5 4.4-5.6 4.8-5.6 4.8a6 6 0 0 1-4.4 6.4c1.3 4.3-4 7.1-4 7.1 2.6 3.7.5 7 .5 7l-.1 3.7z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M377.2 843.1v-3.5s-1.8-3 .4-6c0 0-4.6-2.5-3.5-6.3 0 0-4.2-1-3.9-5.6 0 0-4.5-.3-5-4.1 0 0-4.4.7-6.3-3 0 0-4.4.8-5.6-2.2 0 0-4.3 1.5-6.8-2.1 0 0-4.5 1.8-6.3-1.6-1.9 3.4-6.4 1.6-6.4 1.6-2.4 3.5-6.7 2-6.7 2-1.2 3.1-5.5 2.3-5.5 2.3-2 3.7-6.5 3-6.5 3-.4 3.7-4.9 4-4.9 4a5.1 5.1 0 0 1-3.7 5.6c1 3.8-3.5 6.2-3.5 6.2 2.2 3.2.3 6.2.3 6.2v3.2z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "red",
          d: "M170.3 188.2c-13.3-1.3-28.6-4.5-40.4 2.2-8-4.7-19-4.4-28.4-3.5-5.1 1-11.1 1-16.5 1.8l-.8.1c-9.7.7-18.5-2.2-27-6 2.8 15.2 5.7 30.7 7.2 46.6C67.6 253 53.3 272.7 59 296c3.5 11.2 15.8 17.7 27 19a214.7 214.7 0 0 1 32.2 4.5 32 32 0 0 1 5.5 1.9 19.7 19.7 0 0 1 6.6 4.7c6-6.3 15-8.1 23.7-9 15.8-1.9 35.3-.9 45-15.2v-.8c5.3-8 4.6-20 2.3-29-.2-3.1-1-5.9-1.5-8.9-9.6-25.5-1.3-54.2 2.8-80a61 61 0 0 1-16.4 5.5c-4.5.6-9.5.4-14 .1z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#80cfe1",
          d: "M190.2 261.5c0 1.6.9 3 1.2 4.5 1.9 11.2 3.6 26-7.8 32.9-12.8 8-29.4 4.6-44.1 8.9-3 .8-7 3.5-9 5.4-1.4-.9-2.7-2.2-4.4-3-12.1-6.4-27.9-4.3-41.5-7.8-6.9-2.1-14-7.5-15.8-14.5-4.4-18.4 6.2-34.1 5-52.4-.8-14-3.2-27.3-6.4-40.4 10.7 5 23 5.8 35 3.4A51.6 51.6 0 0 1 130 201c4.6-2 10-2.9 15-3.4 9.3 1 19.4 2.6 29.1 2.6 6.5-.4 12.4-2.2 18-4.7-3.3 21.6-9.8 44.2-1.9 66"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "M171 265.8v-20.4h2.4l-31-20-.1-10.5h3l-15.6-11-15.4 11h3v10.5l-30.9 20h2.5v20.3H171"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M376 906.5v-17.8h2.1l-27-17.5-.1-9h2.6l-13.6-9.8-13.5 9.7h2.6l.1 9.1-27 17.5h2.2v17.7z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "M180.6 292.5v6.3H80.5v-6.4z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M384.4 929.8v5.5H297v-5.6h87.4z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "M87.1 292.1v-21.5h4l-.2 21.7.2-21.6-5.8-.1v-4.7l89.4.2v4.5h-5.4v21.8l-.1-21.8h4l.2 21.6"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M302.8 929.4v-18.8h3.5l-.2 19 .2-18.8-5-.2v-4l78 .1v4h-4.8l.1 19-.2-19h3.6l.1 18.8",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M319.6 924.8v-13.1H309v13l10.5.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M312 914.4v7.6h4.8v-7.6h-4.9m59 10.4-.1-13h-10.4v13h10.5",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M363.2 914.5v7.6h4.8v-7.6h-4.8m7.6-11v-13h-10.5v13z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M363.1 893.2v7.6h4.8v-7.6h-4.8m-43.6 10.3v-13.1H309v13h10.5z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M311.9 893.1v7.6h4.8v-7.6h-4.8m26.6 10.4v-13.1H328v13h10.5",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M330.8 893.1v7.6h4.8v-7.6h-4.8m22.3 10.4v-13l-10.5-.1v13l10.5.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M345.4 893.1v7.6h4.9v-7.6h-4.9",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "m147.7 257.8.2 34.6H113l-.1-34.6z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "m355.7 899.5.1 30.2h-30.3l-.1-30.2zm-30.5 8.6h30.6M329 929.7v-21.4m23.1 21.4v-21.3m14.7-21.8-17-12.4h-19.3l-17 12.4h53.3M332 863.8v7.6h16.2v-7.6H332",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M336.4 865.7v3.8h7.4v-3.8h-7.4M340 855l9 6.4h-17.9l9-6.4",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "M171.4 202c2.9 0 3.6 12 3.6 18 2.6.8 8.1 4.3 10.6 7.4h-28.2c2.4-3.1 7.9-6.6 10.4-7.3 0-6 .6-18.2 3.6-18"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M376.3 850.8c2.6 0 3.2 10.5 3.2 15.8 2.2.6 7.1 3.7 9.2 6.4h-24.6c2.1-2.7 7-5.8 9.1-6.4 0-5.3.6-15.8 3.1-15.8m-49.5 49.5h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m4.5 0h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m5 0h2.1l-.6 1.2s1 1.4 0 3l.6 1h-2.1l.5-1s-1-1.8 0-3l-.6-1.2zm5.5 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2.1l.6-1s-1-1.8 0-3zm4.9 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1m4.9 0h2.2l-.7 1.2s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "M130.5 336.8c13 0 29-2.7 36.5-6.5l16.5-1.5.4 20.1c-14 7.7-46.2 9.4-53.3 9.3-7.1 0-39.7-1.6-53.8-9.3l.2-20.2 16.5 1.5a98 98 0 0 0 37 6.6"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M340.7 968.4c11.4 0 25.3-2.3 31.9-5.7l14.3-1.2.3 17.5c-12.1 6.7-40.3 8.2-46.4 8.1-6.2 0-34.7-1.4-47-8.2l.2-17.5 14.4 1.3c6.6 3.4 21 5.7 32.3 5.7",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "m34.4 251 14.5 4.6-4.4 23.5-13.7 2.2s-2.3-12.4 3.6-30.3"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m256.9 893.6 12.6 4-3.8 20.5-12 1.9s-2-10.8 3.2-26.4z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#7e7e7e",
          d: "m44.5 278.9-13.7 2.4 8.7-12.4z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m265.7 917.9-12 2 7.6-10.7 4.4 8.7",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "m25.7 268 14 1c.3 11.8 1.8 57 55.8 59.5L93.8 345c-65.7.6-70.7-55.5-68-77"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m249.3 908.4 12.2.8c.3 10.4 1.5 49.8 48.7 52l-1.5 14.4c-57.4.6-61.7-48.4-59.4-67.2zm44.8 70.1 14.4-3.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "m225.4 251.2-14.4 4.6 4.6 23.4 13.8 2.2s2.2-12.3-4-30.2"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m423.5 893.7-12.6 4 4 20.5 12 2s2-10.8-3.4-26.5z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#7e7e7e",
          d: "m215.6 279 13.7 2.5-8.8-12.4-5 9.9"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m414.9 918 12 2.1-7.7-10.7-4.3 8.6",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "m234.3 268.1-14 1c-.2 11.8-1.3 57-55.3 59.5l2 16.4c65.7.8 70.2-55.4 67.4-76.9"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m431.2 908.5-12.2.8c-.2 10.4-1 49.9-48.2 52l1.6 14.3c57.4.7 61.3-48.3 58.8-67zm-44.2 70-14.4-3",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#009fc5",
          d: "M121.8 346.7c-.4.2-1 .3-1.5.2l-2.6-.1.2-3.3 2.6.2c.5 0 1 .1 1.2.3.5.2.7.7.7 1.4 0 .6-.3 1-.7 1.3m-4.3 5 .2-3.9 3 .2c1 .1 1.8-.2 2.3-.7.5-.4.8-1 .8-1.8a2.5 2.5 0 0 0-.6-2 3.2 3.2 0 0 0-2-.9l-4.4-.3-.6 9.4zm9.4-7.7h3.2l1.1.2c.5.3.7.7.7 1.4 0 .6-.1 1-.5 1.3a2.6 2.6 0 0 1-1.4.3h-3.1zm0 8.2v-4l3 .1c.5 0 1 0 1.2.2.4.2.7.6.7 1.2v2.3l.2.3h1.6v-.2a.8.8 0 0 1-.4-.5 3.4 3.4 0 0 1-.1-.8v-1.3c0-.6-.2-1-.4-1.2a1.7 1.7 0 0 0-.8-.6c.4-.2.8-.5 1-.8.2-.4.4-.8.4-1.4 0-1-.5-1.8-1.4-2.2a4.7 4.7 0 0 0-1.8-.4h-4.5v9.4zm10-2a4.5 4.5 0 0 1-1-2.6c0-1.3.2-2.3.8-3a3.1 3.1 0 0 1 2.4-1 3 3 0 0 1 2.4.8c.7.6 1 1.5 1.1 2.6a5 5 0 0 1-.6 2.8c-.5.8-1.3 1.3-2.5 1.3s-2-.2-2.7-.9m-1.5-5.9a6 6 0 0 0-.8 3.3c.1 1.4.5 2.6 1.4 3.4a4.6 4.6 0 0 0 3.6 1.3 4.4 4.4 0 0 0 3.5-1.8 6 6 0 0 0 1-3.6 5 5 0 0 0-1.2-3.1c-.9-1-2.2-1.5-3.9-1.4-1.6 0-2.8.7-3.6 1.9m44-13.5c1-.1 1.8-.1 2.5.1 1 .4 1.7 1.1 2.2 2.3l-1.3.2a2.4 2.4 0 0 0-1.2-1.3 3.5 3.5 0 0 0-2-.2 3 3 0 0 0-2 1.3c-.5.7-.7 1.7-.5 3a4.5 4.5 0 0 0 1.2 2.6c.6.6 1.5.8 2.6.7a3.2 3.2 0 0 0 2-1.1c.6-.6.7-1.4.5-2.5l-3 .5-.1-1 4.2-.7.8 5h-.9l-.5-1-1 1c-.5.5-1.2.7-2 .9a4.3 4.3 0 0 1-3.2-.7 5 5 0 0 1-1.9-3.4 5.1 5.1 0 0 1 .7-4 4.1 4.1 0 0 1 3-1.7m9.4-.7 3-1.1c.4-.2.8-.2 1.1-.2.6 0 1 .4 1.2 1 .2.6.2 1.1 0 1.5-.3.3-.7.6-1.3.8l-2.8 1zm3 7.7-1.4-3.7 2.8-1a3 3 0 0 1 1.1-.3c.5.1.9.4 1.2 1l.6 1.4.3.7.2.3 1.5-.6v-.2c-.3 0-.5-.1-.6-.4-.2-.1-.3-.4-.4-.7l-.5-1.2c-.2-.5-.5-.8-.7-1a2.4 2.4 0 0 0-1-.2l.6-1.2c0-.4 0-.9-.2-1.4-.4-1-1-1.6-2-1.6a4.5 4.5 0 0 0-1.9.3l-4.2 1.5 3.4 8.8 1.2-.4m11-4.7-5.3-7.8 5.8-3.8.7 1-4.8 3 1.6 2.4 4.5-2.8.6.9-4.5 2.8 1.8 2.7 5-3.2.6 1zm4.7-13.8 1.5-1.7c.8-.8 1.5-1.1 2.3-1 .9 0 1.7.5 2.6 1.3a4.7 4.7 0 0 1 1.4 2c.2.6.1 1.1 0 1.6a4 4 0 0 1-.7 1l-1.5 1.6zm8.1 3.6c1.1-1.2 1.3-2.4.7-4a6.7 6.7 0 0 0-1.7-2.1 5.2 5.2 0 0 0-3.1-1.4c-1.2-.1-2.2.3-3.1 1.3l-2.6 2.8 7.2 6.3 2.6-2.8m5.6-7.3-8.3-5 .7-1 8.3 4.9zm3.3-5.6-9-3.6 2.6-6.3 1.1.4-2.1 5.2 2.7 1 2-4.7 1 .4-2 4.8 3 1.2 2.3-5.2 1 .4zm4-11-9.4-2 .4-1.5 8.7-3-7.7-1.7.3-1.1 9.4 2-.3 1.4-8.7 3 7.7 1.7zm-.8-12 .1-1.2c.6 0 1 0 1.4-.2.7-.4 1-1.1 1.2-2.1a3.7 3.7 0 0 0-.1-1.4c-.2-.7-.6-1.2-1.3-1.2-.6-.1-1 0-1.2.3-.3.3-.5.8-.7 1.5l-.5 1.2c-.2.8-.5 1.4-.8 1.7-.4.6-1 .8-1.8.7a2.8 2.8 0 0 1-2-1c-.6-.6-.8-1.5-.7-2.6.1-1 .4-1.8 1-2.4.5-.6 1.3-1 2.4-.8l-.1 1.2c-.5 0-1 0-1.2.3-.6.3-.9 1-1 1.9 0 .7 0 1.2.4 1.6.3.4.6.6 1 .6.5 0 .9 0 1.1-.4l.7-1.7.4-1.3c.2-.6.5-1 .8-1.4.5-.5 1.2-.7 2-.7 1.1.1 1.9.6 2.2 1.4.4.8.6 1.6.5 2.7a3.9 3.9 0 0 1-1.2 2.6c-.7.6-1.5.8-2.6.7M32 286.7l.3 1.2c-.6.1-1 .3-1.3.6-.5.5-.7 1.3-.5 2.4a4 4 0 0 0 .4 1.2c.4.7 1 1 1.7.9.5-.1.8-.3 1-.7l.3-1.6v-1.3c0-.8.2-1.5.3-1.8.3-.6.9-1 1.7-1.2.8-.1 1.6 0 2.2.6.7.4 1.1 1.2 1.3 2.2a4 4 0 0 1-.3 2.6c-.4.8-1 1.2-2.1 1.4l-.2-1.1a3 3 0 0 0 1-.6c.5-.5.6-1.2.5-2.1-.2-.8-.4-1.3-.8-1.5a1.5 1.5 0 0 0-1.2-.3 1 1 0 0 0-1 .7l-.1 1.8-.1 1.3a3.5 3.5 0 0 1-.4 1.6 2.2 2.2 0 0 1-1.7 1.2c-1 .2-2-.1-2.5-.8a5 5 0 0 1-1.2-2.4 3.8 3.8 0 0 1 .5-2.9 3 3 0 0 1 2.2-1.3m-.6 12.3 9.3-2.8 2.1 6.5-1.1.4-1.8-5.3-2.8.8 1.7 5-1.1.3-1.6-5-3.2 1 1.8 5.4-1 .3zm4.1 11.3 8.5-4.5 1 1.6-5.9 6.1 8.5-1.4.9 1.5-8.5 4.5-.6-1 5-2.7.9-.4 1.3-.7-8.5 1.5-.6-1.1 5.8-6.2-.3.2-1 .5a7 7 0 0 1-.9.5l-5 2.6zm15.8 12.5c-.4-.1-.8-.4-1.2-.8l-1.8-1.8 2.4-2.2 1.8 1.8a3 3 0 0 1 .7 1c.2.5 0 1-.5 1.5-.5.4-1 .6-1.4.5m-6.8.8 3-2.7 2 2.1c.8.7 1.5 1 2.2 1a3 3 0 0 0 2-.8 3 3 0 0 0 .8-2c0-.6-.3-1.3-.9-1.9l-3-3-7 6.4zm8.4 7.5 5.1-8 6 3.6-.6 1-5-3-1.5 2.5 4.5 2.7-.5 1-4.6-2.8-1.7 2.7 5 3-.6 1zm15-1.6 3.1 1 1 .5c.4.4.5.9.2 1.5-.2.6-.4 1-.9 1.1l-1.5-.1-2.9-1zm-2.6 7.9 1.3-3.8 2.8.9c.5.1 1 .3 1.1.5.3.3.4.8.3 1.4l-.5 1.5-.1.7v.3l1.5.5v-.2l-.2-.7.2-.7.4-1.2c.1-.6.2-1 0-1.2 0-.3-.3-.6-.6-.9.5 0 1-.2 1.3-.5.3-.3.6-.7.7-1.2.4-1 .2-1.9-.6-2.5a5.2 5.2 0 0 0-1.6-.9l-4.3-1.3-3 8.9z"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#bc715f",
          d: "M78.5 175.6c1-2.7 11.3-10 44.8-6.8 0 0 5.7 3.5 9 3 2-.2-1 .2-3.6-1.9-2.5-2-3-6.3 2.7-6.1 5.8.1 27.3 1.3 27.7 3.3.4 1.9-11.4 2.7-15.7 2.6-4.4-.1-4 2.1.4 2 13.7-.6 28.6-5.4 44.3 5.8 1.9 1.3-4.7 1.5-9.8-.6 0 0-14 .7-20-.3 0 0-4.5 3.8-10.6 3.4.8 2-2.2 9.2-21 3.7-3.2 1-14.5 2.9-13.3-.5-3 0-8.2 1-9-.7-.8-1.7 9.2-4.2 11-6 0 0-21.2.2-25.2-1.3 0 0-12.5 2.8-11.7.4"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#008737",
          d: "M85.3 205.2c.4-.6.6-1.8 1.6-1.7 2 .5 3.5 4.4 6 1.9 1-.2 1.3 1 2 1.2.5 2.1 2.3-.5 3.5-.3 2.8-1.2 6.1-1.5 9.4-1 0 2.2-1.6 4.5-3.6 5.7 0 2 2 3.4 1.9 5.5-.3.8 0 2-1.2 2.3-1.6-.3-3-.4-4.3-1.3-.2-.1-.3-.4-.6-.3-.2.7 1 1.4 1.4 2.1-.8 1.3-2 .1-3.1.1-.3.8 0 1.7-.8 2.2-1.3 0-1.6-1.5-2.4-2.2-.9.9.6 1.4.8 2.1-.6 2.8-.5 5.5-3.2 7.3l-1.9.9c-.5-1.4-.2-3.5-.5-5-1 1.8-2 3.4-3.5 4.9-2-.6-3-2.8-3.4-4.7a5.8 5.8 0 0 1 1.3-6.2c-.5-1-2.5-.8-2.8-2.4-3-2-4.5 3.3-6.4.6a8.6 8.6 0 0 1 2-7.6c-.5-1-1.9-.8-2.7-1.4-1.8-1.6-4.5-3.2-4.3-6a14 14 0 0 1 14.7 3.3"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "M87.9 204.9c-.1 2.3 1.5.6 2.8 2-1-.4-1.7 1.7-2.7.5l-.6.6c.4.8 1 .9.4 1.8-1 .4-1.3-1-1.8-1.5 0-.2.2-.6-.2-.8-.6.5-1.2.7-2 .6-.2-.4-.7-1-.2-1.4.8-1 2 .4 2.6-.3.1-.7-.5-1.5.3-2 .5.1 1.2-.2 1.4.5m6.2 1.9c.1.4-.2 1 .4 1.4.8-.4 1.6-.1 2 .6 0 .4.1 1-.4 1.2l-1.2-.3c.1-.2-.3-.3-.4-.6-.5-.1-.9.3-1.2.6.3.4 1 .7.8 1.2-.7.7-1-.6-1.8-.2-.6-.2.1-1.3-.7-1.7-1 0-.3 1.6-1.6 1-.4-.5-.8-1.2-.4-1.7a1.6 1.6 0 0 1 1.9.2c.8-.9.8-4.1 2.7-1.7m-7.8 3.3c.5.8-.2 1.8.5 2.6 1-2 2 .4 3.2.2.4.5.1 1.1.2 1.6-1.5.4-3.3.9-4.6-.3l-.4.4c.8.7 1.5 1.6.9 2.8-1.1.2-2.9.3-3.4-.9-.3-1 .7-1.6-.4-2.4-.7 1-.7 2.2-2.2 1.3a1.9 1.9 0 0 1-.8-2.5c1-1.6 2.8 0 3.8-.7.2-1.4-.3-2.6 1-3.3 1-.2 1.5.6 2.2 1.2"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "M90.6 211c-.5 2.3-2.2-.1-3-.2 1-2 1.7.6 3 .2m5.4 2.5c-1.2.3-1-1.2-1.6-1.8l.5-.4c.4.5.7 1.5 1.1 2.2"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#ff0",
          d: "M94.4 213c.3.8-.8 1.5.2 2l.8-.7c.9.2 1.8.4 2.4 1.2.6 1.7-1.1 1.7-2 2.2h-1c.2-.6-.5-.8-.6-1a1 1 0 0 0-1.1.3c.2 1 1.5 2 .2 2.9-1.2 0-3 .4-2.9-1.2-.4-1 1.2-2.3-.5-2.4-.6 1.3-1.2 2.4-2.7 1.3l.2-1.8c1.4 0 3.1.3 3.7-1.3.4-1.1-.7-2.2.3-3 1.5-.4 2.3.6 3 1.5"
        }),
        /* @__PURE__ */ jsx229("path", {
          d: "M93.4 215.6c.3.9-.6 1-1.1 1.4-.6 0-1-.2-1.4-.6-.3-1 .5-1.2 1-1.6.7-.3 1 .5 1.5.8"
        }),
        /* @__PURE__ */ jsx229("path", {
          fill: "#fff",
          d: "M92.5 216.2c-.1.2-.4.1-.6.2l-.2-1c.5 0 1 .1.8.8"
        })
      ]
    })
  ]
});
var Sx_default = SvgSx;

// src/country-flag-icons/generated/Sy.tsx
import { jsx as jsx230, jsxs as jsxs223 } from "react/jsx-runtime";
var SvgSy = (props) => /* @__PURE__ */ jsxs223("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx230("path", {
      fill: "#000001",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx230("path", {
      fill: "#fff",
      d: "M0 0h640v320H0Z"
    }),
    /* @__PURE__ */ jsx230("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0Z"
    }),
    /* @__PURE__ */ jsx230("path", {
      fill: "#007a3d",
      d: "m161 300 39-120 39 120-102-74.2h126M401 300l39-120 39 120-102-74.2h126"
    })
  ]
});
var Sy_default = SvgSy;

// src/country-flag-icons/generated/Sz.tsx
import { jsx as jsx231, jsxs as jsxs224 } from "react/jsx-runtime";
var SvgSz = (props) => /* @__PURE__ */ jsxs224("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx231("path", {
      fill: "#3e5eb9",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx231("path", {
      fill: "#ffd900",
      d: "M0 90h640v300H0Z"
    }),
    /* @__PURE__ */ jsx231("path", {
      fill: "#b10c0c",
      d: "M0 120h640v240H0Z"
    }),
    /* @__PURE__ */ jsxs224("g", {
      fill: "#ffd900",
      stroke: "#000",
      transform: "translate(-43.2) scale(1.2)",
      children: [
        /* @__PURE__ */ jsxs224("g", {
          id: "sz_svg__a",
          children: [
            /* @__PURE__ */ jsx231("path", {
              fill: "#fff",
              d: "m492.9 154.3-24.3 8.6 24.2 8.5 24.3-8.5z"
            }),
            /* @__PURE__ */ jsx231("rect", {
              width: 357.1,
              height: 5.7,
              x: 122.8,
              y: 160,
              rx: 3.1,
              ry: 2.9
            }),
            /* @__PURE__ */ jsx231("path", {
              d: "M471.4 165.7a3 3 0 0 0 2.9-2.8 3 3 0 0 0-2.9-2.9m-2.8 5.7a3 3 0 0 0 2.8-2.8 3 3 0 0 0-2.8-2.9m-2.9 5.7a3 3 0 0 0 2.9-2.8 3 3 0 0 0-2.9-2.9"
            })
          ]
        }),
        /* @__PURE__ */ jsx231("use", {
          xlinkHref: "#sz_svg__a",
          width: "100%",
          height: "100%",
          x: -23.3,
          y: 17.1
        }),
        /* @__PURE__ */ jsx231("rect", {
          width: 485.7,
          height: 8.6,
          x: 59.8,
          y: 195.7,
          strokeWidth: 1.1,
          rx: 4.2,
          ry: 4.3
        })
      ]
    }),
    /* @__PURE__ */ jsx231("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M488.2 240c-34.3 34.3-80 102.9-171.4 102.9-80 0-137.1-68.6-171.4-102.9 34.2-34.3 91.4-102.9 171.4-102.9 91.4 0 137.1 68.6 171.4 102.9z"
    }),
    /* @__PURE__ */ jsx231("path", {
      d: "M304.8 173c9.2 10.2 1.5 14.3 11.2 15 10.2.7 4.4 10.8 13 11.2 6 .2-.6 24.2 5.1 32 5.9 8.3 10.8 2.5 11 8.4 0 6.2-16 5.5-16.3 24.5-.5 10.9-13.6 11.6-14.2 18.6-.8 6.6 25.8 10.3 25.4 16.2-.3 6-28.7 5-30 11.7-.6 6 39 11 42.2 28.5-6 2-22.7 3.7-35.4 3.8-80 0-137.1-68.6-171.4-103 34.3-34.2 91.4-102.8 171.4-102.8 0 0-23.7 21.7-12 35.8z"
    }),
    /* @__PURE__ */ jsx231("g", {
      stroke: "#fff",
      transform: "translate(-43.2) scale(1.2)",
      children: /* @__PURE__ */ jsxs224("g", {
        id: "sz_svg__d",
        strokeWidth: 6.9,
        children: [
          /* @__PURE__ */ jsxs224("g", {
            id: "sz_svg__c",
            children: [
              /* @__PURE__ */ jsx231("path", {
                id: "sz_svg__b",
                d: "M214 192.4v-22.9m13.8 0v22.9m13.8-22.9v22.9"
              }),
              /* @__PURE__ */ jsx231("use", {
                xlinkHref: "#sz_svg__b",
                width: "100%",
                height: "100%",
                y: 38.1
              })
            ]
          }),
          /* @__PURE__ */ jsx231("use", {
            xlinkHref: "#sz_svg__c",
            width: "100%",
            height: "100%",
            x: 41.6
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx231("use", {
      xlinkHref: "#sz_svg__d",
      width: "100%",
      height: "100%",
      x: 104.8,
      stroke: "#000",
      transform: "translate(-43.2) scale(1.2)"
    }),
    /* @__PURE__ */ jsxs224("g", {
      fill: "#a70000",
      children: [
        /* @__PURE__ */ jsx231("path", {
          fill: "#333",
          stroke: "#000",
          d: "M570.4 236c-5.2 8.9 4-3 26.4 12a21.6 21.6 0 0 1 7.8 15.3c-1-.7-1.9-2.3-3-3.2-1.6 1.6 1.6 9 2 12.5-3.5-2-3.2-2.8-4.3-5.2.2 2.8-.7 10.8.8 14-2.8-.8-2.6-3-4-3.5 1 3.5-.9 7.2-.4 11.2-1.6-1.6-3.4-2.9-4.1-3.5-.2 2-3.1 6.8-3.2 8.6a4.5 4.5 0 0 1-2-3 59.2 59.2 0 0 0-8 12.4c-4.7-4-16.6-14-18.2-19.4-1.4 3-3.4 4-7.2 6.2-1.6-8.4-7.5-17.8-4.4-25.1a75.2 75.2 0 0 0-6.1 4.2 49.6 49.6 0 0 1 28-33.6z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#b3b3b3",
          d: "M551 280.5c2.2-4.3 4.2-5.7 5.6-8.5 2.4-4.8 2.8-8.8 5-8.2 2 .6 2 2.6-.7 7.4-2.7 4.8-4 5.8-9.9 9.3m14.6 10.2c-.2-3.2.7-4.6.6-6.7-.4-3.8-1.9-6.3.1-6.5 2-.1 2.9 1.1 2.9 4.8 0 3.8-.6 4.8-3.6 8.4m11.1 6.4c-.9-4.5-.2-6.5-.8-9.5-1-5.2-2.9-8.6-1-9.1 1.8-.5 3 1.2 3.7 6.5.6 5.2.3 6.7-1.9 12.2zm11.5-32c-2.7-2-4.3-2.2-6-3.5-3-2.4-4.6-4.8-5.6-3.6-1 1.2-.3 2.6 3 4.7s4.2 2.3 8.6 2.4m-1.9 15.2c-1.4-3-3-3.7-3.8-5.6-1.6-3.4-1.6-6.3-3.5-5.6-1.7.8-1.9 2.3 0 5.6 2 3.2 3 3.8 7.2 5.6z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#333",
          stroke: "#000",
          strokeWidth: 1.3,
          d: "M53.8 244.6c-.4-2.6.2-3-1.4-5 2.4 1 2.4 3.7 5.3 1.8 1-.5 1.5-.5.2-3.5 3 .2 12.7 3.5 14.3 3.6 4.1.2 11.6-4.3 16.8 1.2 5 5 3.2 10.3 3.2 17.2-2-1-1-1.3-3.2-3.9 1.6 6.2 0 17.1 0 23.6-.8-1.6-.7-.9-1.5-2.5-2 5.9-4.6 7-4.6 14.1-.8-2.8 0-2.2-.9-3.6-2 4.5-16 8.3-10.6 12.8-4.8-2.8-7-2.6-9-5-1 .5-1.8 1.7-2.6 3.2-8.5-3.8-5.5-12.2-12.1-17.9-1.2 2.4-.7 2.1-2 5.9-1.2-5.3-1.6-8.7-3.1-12.6-1.3 2.2-1.2 1.3-3.6 4.6-1-6.4-2.5-8-2-12.3-2.4 1.8-.8 1-3.3 3.2 2.4-16.5 12.6-28.8 20-25z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#b3b3b3",
          d: "M43.4 271.7c2.1-5.4 4-7 5.5-10.4 2.5-6.1 2.9-11 5-10.3 2 .8 2 3.2-.8 9.2-2.8 6-4 7.2-9.7 11.5m8.2 13.3c.8-4.8 2.2-6.4 2.8-9.6 1-5.4.5-9.4 2.4-9.2 2 .2 2.4 2.3 1.1 7.6-1.3 5.5-2.2 6.8-6.4 11.2zm9.8 9.4c.3-4.6 1.4-6.5 1.6-9.5.3-5.2-.8-9 1-9 2 0 2.6 1.9 2 7.1-.6 5.2-1.2 6.6-4.6 11.4M82.6 264c-4-4-6.4-4.8-9-7.4-4.6-4.6-6.9-8.8-8.6-7.3-1.6 1.5-.6 3.7 4.3 8 4.8 4.5 6.5 5.1 13.4 6.7zm-2.4 15.6c-2.6-4-4.6-5.1-6.3-7.8-3-4.5-4-8.4-5.7-7.5-1.7 1-1.3 3 1.9 7.5 3.3 4.4 4.5 5.2 10.1 7.8"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#333",
          stroke: "#000",
          d: "M261.4 155.4c-4.8 9.2 8.3-3 28.8 12.4a35.4 35.4 0 0 1 9.2 19.3 61.7 61.7 0 0 1-12-5.3s9 9.2 9 19.6c-3.2-2-4.8-1.7-6-4.1 0 3.3 3 5.5 3 10.7a42.4 42.4 0 0 0-6.3-4.2c3 5.3-5.5 15.5-1.2 18.8a26.6 26.6 0 0 1-18.1-11c-1.6 1-1.8 2.7-1.9 4.6.3.1-11.3-8.7-10.2-12a10.1 10.1 0 0 0-2.2 5.8 31.7 31.7 0 0 1-9.6-13.8c-1.8 2.4-2 2.4-3.9 5-1.4-8.7-1.4-8.4 1.4-15.8a69 69 0 0 0-5.6 4.3 50 50 0 0 1 25.6-34.3z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#b3b3b3",
          d: "M249.6 200.2c.8-6.3 2.4-8.6 3-12.8.8-7-.2-12.4 2.4-12.2 2.4.2 3.2 2.8 2 10-1.3 7.1-2.4 8.8-7.3 15.1zm13.3 11.6c-.5-5.2.5-7.6.1-11-.5-6-2.4-10.2-.2-10.5 2.2-.4 3.4 1.6 3.6 7.8.2 6-.3 7.7-3.5 13.7m20.8 9.6c-2.3-4.7-4.3-6-5.7-9-2.6-5.3-3.2-9.5-5.1-8.8-2 .8-1.9 3 1 8.2 2.8 5 4.1 6.1 9.7 9.6zm7.1-41.5c-5.8-3-8.7-3-12.4-5-6.5-3.4-10.3-7.1-11.6-5-1.4 2 .4 4.1 7.1 7.2 6.7 3.1 8.8 3.2 16.8 2.8zm2 17.3c-4-3.4-6.6-4-9.3-6.2-4.8-4-7.1-7.7-8.6-6.2-1.6 1.6-.6 3.6 4.4 7.3 5 3.7 6.7 4.1 13.6 5.1z"
        })
      ]
    })
  ]
});
var Sz_default = SvgSz;

// src/country-flag-icons/generated/Tc.tsx
import { jsx as jsx232, jsxs as jsxs225 } from "react/jsx-runtime";
var SvgTc = (props) => /* @__PURE__ */ jsxs225("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx232("path", {
      fill: "#002868",
      d: "M640 480V0H0v480z"
    }),
    /* @__PURE__ */ jsxs225("g", {
      fill: "none",
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx232("path", {
          fill: "#fcd116",
          strokeWidth: 8,
          d: "M590 174.6v90c0 60-30 124.6-105 159.6-75-35-105-99.6-105-159.6v-90z"
        }),
        /* @__PURE__ */ jsx232("path", {
          stroke: "#fff",
          strokeWidth: 7,
          d: "M590 174.6v90c0 60-30 124.6-105 159.6-75-35-105-99.6-105-159.6v-90z"
        }),
        /* @__PURE__ */ jsxs225("g", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2.2,
          children: [
            /* @__PURE__ */ jsx232("path", {
              fill: "#fcad56",
              strokeWidth: 0.3,
              d: "M447.1 273.7c-2.7 4.7-7.4 5.7-11 4.2-3.7-1.5-7.1-10.3-10.9-15-3.6-4.7-4.6-2.7-7-5.4a37.6 37.6 0 0 0-12-7.4c-3.3-1.5-6.7-2.9-9-8.6a9.8 9.8 0 0 1 5.2-5.1c1.9-.7 3.4-3.4 3.6-5.8.3-2.2 2.3-4.7 5-6.6-1.3.2-3.9-.3-5.1-1.1-1.1-1-3-.8-4.1 0-1.2.8-2.6 1-4.6.8.8-.6 2.2-2 2.3-3.2s1.6-1.9 4.5-1.9c2.8 0 4.6-3.2 6.9-3.2-1.6 0-1.3-2.8-.4-3-4-.7-3.5-4-1.9-4-.1-.4-.6-1-2.5-1.5-1.7-.7-.9-2.3.5-3.3-1.2-2.5-.1-4.4 1.9-6-2.8-.1.3-4 1-6.1.8-2 1.1-2.3 2-1 1 1.1 3.3 3.7 5.9 4.5 2.5.7 4 2.1 4.5 4.2.5 2.3 1.5 3.4 4.2 4.4 2.9.9 6.8 3.3 6.3 8.6a9 9 0 0 1 5.2 1.9"
            }),
            /* @__PURE__ */ jsx232("path", {
              fill: "#ffa1a1",
              strokeWidth: 0.3,
              d: "M454 206a8 8 0 0 0 3.1 6.4c1.9 1.5 3.5 2.7 3.1 4.6-.3 2 .4 3.2 2 4.5 1.8 1.2 3 2.7 2.6 5.2s-.2 4 .8 5.9 2.8 3.4 2 6.4-.4 7 .6 9c1 1.9 0 3.4-1.7 6.7-1.8 3.3-2.8 4.5-6.4 5.8-3.7 1.1-4 3.4-4 7.2 0 4-2.6 6-7.5 5.3-5 4.1-8.1-.8-9.4-6.9s-1.4-12.8-8.8-18.1c-7.3-5.5-4.4-14.8 1.7-18.5 6.1-3.6 5.4-14.4 4.6-21-.6-6.6 3.8-10.4 7.2-14 4.5 1.7 10.1 8.6 10.1 11.5"
            }),
            /* @__PURE__ */ jsx232("path", {
              fill: "#f1b2dc",
              strokeWidth: 0.3,
              d: "M443.4 248.6c-1.4-3.2-2.9-6.5.7-13.5 3.8-7.1 1.4-12.5.3-16.1-1.1-3.5-1.4-6.8 0-8.3 1.5-1.3 2.1-2.2 2.2-4.6.1-2.2 2-1.5 2.3-.4s.5 3-1.5 6.4c-2 3.5 5.6 12 2.1 21.1-2.4 6.4.8 14.5 2 20.2s2 19-6.3 21c5.7-2.7.4-20.5-1.8-25.8"
            }),
            /* @__PURE__ */ jsx232("path", {
              strokeWidth: 0.3,
              d: "M406.3 247.6c1.3.3 2-.5 2.4-1.4s.7-1.3 2-1.5c1.2 0 3.2-.3 3.7-1.3.4-1 1.9-.2 3.2-2.7 1.3-2.6 2.1-5.6 5.5-6.7m9.3-21.8c-1.3 0-4.9.2-6.4 3.4m-10.4-18.9c3 .9 1.8 2.9 3.3 4 2.7 2.2.2 4.4 2.5 5s2.1 1 1.6 3.5c-.8 2.9 2 3 1 4.9m-13 9.9c1.8-1.6 6.1-2.9 7.1-4.6m-7.2-4c2.6-.2 6.1.8 6.6-.2m-7-2.7c1.3 0 3.9-.9 4.4-2.6m-6.3-1.4c1.5 0 3.4-.1 5.3-1.5m-7.3-3.4c1.1-.9 3.1.1 5-1.1m-3.1-4.9c.9 0 2.8-.2 2.8.9"
            }),
            /* @__PURE__ */ jsxs225("g", {
              fill: "#9e540a",
              transform: "matrix(.125 0 0 .125 535 249.6)",
              children: [
                /* @__PURE__ */ jsxs225("g", {
                  id: "tc_svg__b",
                  children: [
                    /* @__PURE__ */ jsx232("path", {
                      d: "M-55-233s-70-59-128-99-128-89-128-99c11-8 70 30 151 79 82 50 128 99 128 99zm-5 40s-68-41-135-70c-70-29-175-29-186-39 0-10 122-16 209 19 89 41 135 70 135 70zm-1 68s-74-34-146-50c-70-16-170-10-182-19 0-10 124-30 217 0 94 29 134 49 134 49zm-4 69s-56-38-130-46c-70-7-163 46-175 36 0-10 81-69 182-59 99 10 146 49 146 49zm23-218s-71-65-71-109c0-39 43-99 62-99-10 20-43 60-43 99 0 40 75 89 75 89z"
                    }),
                    /* @__PURE__ */ jsx232("path", {
                      d: "M-42-274s14-65 14-109c0-59-42-113-38-128 15 15 57 59 57 128 0 60-10 89-10 89z"
                    }),
                    /* @__PURE__ */ jsxs225("g", {
                      stroke: "none",
                      children: [
                        /* @__PURE__ */ jsx232("use", {
                          xlinkHref: "#tc_svg__a",
                          width: "100%",
                          height: "100%",
                          stroke: "#fcd116",
                          strokeWidth: 12
                        }),
                        /* @__PURE__ */ jsx232("path", {
                          id: "tc_svg__a",
                          d: "M-25-295c0-19-7-36-19-49-16-19-40-25-65-21-30 5-54 23-69 51-20 37-22 77-23 116 0 135 5 190 9 323 1 39 8 119-10 182-7 27-15 52-27 78 8-33 12-50 16-75 11-65 8-126 6-186-4-123-11-186-15-335-1-45 3-79 24-115 22-37 60-64 103-64 18 0 33 3 48 12 30 16 44 49 44 82z"
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx232("path", {
                      d: "M-19 187s-28 50-49 86-38 44-54 33c-15-11-2-40 10-54s79-79 79-79z"
                    }),
                    /* @__PURE__ */ jsx232("path", {
                      d: "M-12 191s-11 57-20 98c-8 41-22 55-39 50-18-4-15-37-8-54s49-103 49-103z"
                    }),
                    /* @__PURE__ */ jsx232("path", {
                      d: "M0 193v100c0 42-10 59-29 58-18-1-22-33-18-52 3-18 28-111 28-111z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx232("use", {
                  xlinkHref: "#tc_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "scale(-1 1)"
                }),
                /* @__PURE__ */ jsxs225("g", {
                  id: "tc_svg__c",
                  children: [
                    /* @__PURE__ */ jsx232("path", {
                      d: "M0 192c-53-1-58-20-58-20s-7-24-8-39c-1-2-15-32-11-45-5-12-17-41-6-46-5-14-13-30-14-45-4-11-14-35-6-43 0 0-19-40-10-50 0 0-9-39 0-49 0 0 0-40 10-50 0 0 0-39 9-49 0 2 28-55 94-55l-1 85h1z"
                    }),
                    /* @__PURE__ */ jsx232("path", {
                      fill: "none",
                      d: "M0-26c-85-1-103-20-103-20M0-76c-85 0-113-20-113-20M0-125c-85-1-113-20-113-20M0-175c-85-1-103-20-103-20m102-19c1 0-64 0-74-10l-19-19M0 152c-25 0-53-4-66-19m66-21c-47 0-75-19-75-19s-1-2-2-5M0 63c-62-1-79-14-83-21M0 23C-85 23-94 3-94 3l-3-6"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx232("use", {
                  xlinkHref: "#tc_svg__c",
                  width: "100%",
                  height: "100%",
                  transform: "scale(-1 1)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs225("g", {
              transform: "matrix(.125 0 0 .125 485 299.6)",
              children: [
                /* @__PURE__ */ jsxs225("g", {
                  id: "tc_svg__d",
                  children: [
                    /* @__PURE__ */ jsx232("path", {
                      fill: "#009e49",
                      d: "M0 712c-43 40-126 14-152-4-27 9-99-19-118-50-52 7-70-67-61-86 14-28-11-46 7-65 25-24-14-47 10-63 24-17-6-45 18-63 25-19-13-45 13-58s-3-47 19-60-13-46 17-61c29-15 3-41 26-52 25-13 2-40 25-49 26-11 7-40 29-48 19-7 7-25 19-41H0"
                    }),
                    /* @__PURE__ */ jsx232("path", {
                      d: "M-99 18c-20 20 4 35-16 59-21 25-2 38-19 60s8 33-11 58c-19 24 4 39-17 59-20 21 4 39-17 61-20 23 4 38-16 58-21 21 3 43-17 63-20 21 4 47-19 71-22 24 4 43-14 61-19 19-2 38-15 51s-15 31-10 39M-60 25c-18 25 10 36-7 56-17 21 7 28-6 52s10 30-7 54 9 43-9 67c-19 24 9 37-8 61-16 25 8 38-7 56-15 19 11 37-8 60-18 22 8 39-7 59-15 21 6 43-7 60-13 16 9 41-10 63-18 22 4 37-7 52s-20 37-9 43"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx232("use", {
                  xlinkHref: "#tc_svg__d",
                  width: "100%",
                  height: "100%",
                  transform: "scale(-1 1)"
                }),
                /* @__PURE__ */ jsx232("path", {
                  stroke: "#009e49",
                  d: "M0 712V12"
                }),
                /* @__PURE__ */ jsx232("path", {
                  d: "M0 48c-9 39 13 73 0 106-13 32 9 45 2 71-8 26 9 45-2 73s15 50 0 87c-15 36 10 45 0 82-11 42 19 64 0 94s17 37 2 71c-15 33 9 46-2 80"
                }),
                /* @__PURE__ */ jsx232("path", {
                  fill: "#fcd116",
                  d: "M15 174c-5 11 15 37 4 57-12 19 6 49-6 73s19 54 7 82c-13 28 6 63 0 89-5 26 13 76 0 94-13 19 13 24-2 70s-25 7-16-7c19-31-21-41-2-71s-11-52 0-94c10-37-15-46 0-82 15-37-11-59 0-87s-6-47 2-73c7-26-15-39-2-71 10-32 20 9 15 20m-84 32c-7 12 12 35-5 58-12 16 8 35-9 58-11 16 11 36-4 59-10 13 7 38-5 57-12 20 6 36-15 62-12 14 9 49-4 60s-1 54-10 60c-8 7 0 38-22 45 11-15-11-30 7-52 19-22-3-47 10-63 13-17-8-39 7-60 15-20-11-37 7-59 19-23-7-41 8-60 15-18-9-31 7-56 17-24-11-37 8-61 18-24-8-43 9-67s-6-30 7-54c24 9 12 61 4 73m-50-65c-10 16 4 35-11 55-15 21 0 47-15 64-15 16 4 48-15 61s-7 52-22 65 0 50-17 69-9 58-19 67c-9 9 13 28-3 41-17 13-17 39-39 56 13-13-4-32 15-51 18-18-8-37 14-61 23-24-1-50 19-71 20-20-4-42 17-63 20-20-4-35 16-58 21-22-3-40 17-61 21-20-2-35 17-59 19-25-6-36 11-58 8-10 8-19 8-27 12-31 12 23 7 31"
                }),
                /* @__PURE__ */ jsx232("path", {
                  fill: "#ce1126",
                  d: "M-139 35c0-210 29-283 139-283s139 73 139 283z"
                }),
                /* @__PURE__ */ jsx232("path", {
                  fill: "#000001",
                  d: "M-139 35c0-210 29-283 139-283-50 0-81 39-89 65-9 26-4 24 7 14s6 12-4 24c-9 12-18 47-5 36 13-12 23 1 9 21-14 19-26 65-12 49s17 10 8 23c-8 13-7 25 0 19 8-6 7 21 0 32zm191-4C52 0 53-73 36-97c-12-19-12-39 2-17s21 11 11-11c-12-28-28-59-24-65 5-7 8-4 18 11s12-7 1-22c-11-14-10-17 13-7 41 17 61 66 61 231z"
                }),
                /* @__PURE__ */ jsx232("path", {
                  fill: "#ce1126",
                  d: "M0 65c-44 0-92-7-124-20-38-15-40-28-27-44 10-12 30-5 50 4 19 8 73 14 101 14s82-6 101-15c20-8 40-15 50-3 13 16 11 29-27 44C92 58 44 65 0 65"
                })
              ]
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx232("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx232("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx232("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx232("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx232("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    })
  ]
});
var Tc_default = SvgTc;

// src/country-flag-icons/generated/Td.tsx
import { jsx as jsx233, jsxs as jsxs226 } from "react/jsx-runtime";
var SvgTd = (props) => /* @__PURE__ */ jsx233("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs226("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx233("path", {
        fill: "#002664",
        d: "M0 0h214v480H0z"
      }),
      /* @__PURE__ */ jsx233("path", {
        fill: "#c60c30",
        d: "M426 0h214v480H426z"
      }),
      /* @__PURE__ */ jsx233("path", {
        fill: "#fecb00",
        d: "M214 0h212v480H214z"
      })
    ]
  })
});
var Td_default = SvgTd;

// src/country-flag-icons/generated/Tf.tsx
import { jsx as jsx234, jsxs as jsxs227 } from "react/jsx-runtime";
var SvgTf = (props) => /* @__PURE__ */ jsxs227("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx234("defs", {
      children: /* @__PURE__ */ jsx234("path", {
        id: "tf_svg__a",
        fill: "#fff",
        d: "m0-21 12.3 38L-20-6.5h40L-12.3 17z"
      })
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#002395",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#fff",
      d: "M0 0h292.8v196.8H0z"
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#002395",
      d: "M0 0h96v192H0z"
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#ed2939",
      d: "M192 0h96v192h-96z"
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#fff",
      d: "m426 219.6 15.4 24.6h44V330l-33-51.6-44.4 70.8h21.6l22.8-40.8 46.8 84 46.8-84 22.8 40.8h21.6L546 278.4 513 330v-47.4h19.8l14.7-23.4H513v-15h44l15.4-24.6zm51.6 105h-48v16.8h48zm91.2 0h-48v16.8h48z"
    }),
    /* @__PURE__ */ jsx234("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 416,
      y: 362,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx234("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 371,
      y: 328,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx234("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 461,
      y: 328,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx234("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 333,
      y: 227,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx234("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 499,
      y: 227,
      transform: "scale(1.2)"
    })
  ]
});
var Tf_default = SvgTf;

// src/country-flag-icons/generated/Tg.tsx
import { jsx as jsx235, jsxs as jsxs228 } from "react/jsx-runtime";
var SvgTg = (props) => /* @__PURE__ */ jsxs228("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx235("defs", {
      children: /* @__PURE__ */ jsx235("clipPath", {
        id: "tg_svg__a",
        children: /* @__PURE__ */ jsx235("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs228("g", {
      fillRule: "evenodd",
      clipPath: "url(#tg_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx235("path", {
          fill: "#ffe300",
          d: "M0 0h767.6v512H0z"
        }),
        /* @__PURE__ */ jsx235("path", {
          fill: "#118600",
          d: "M0 208.1h767.6V311H0zM0 .2h767.6v102.9H0z"
        }),
        /* @__PURE__ */ jsx235("path", {
          fill: "#d80000",
          d: "M0 .3h306.5v310.6H0z"
        }),
        /* @__PURE__ */ jsx235("path", {
          fill: "#fff",
          d: "M134.4 128.4c0-.8 18.9-53 18.9-53l17 52.2s57.4 1.7 57.4.8-45.3 34.3-45.3 34.3 21.4 60 20.5 58.2c-.8-1.7-49.6-36-49.6-36s-49.7 34.3-48.8 34.3c.8 0 18.8-56.5 18.8-56.5l-44.5-33.4z"
        }),
        /* @__PURE__ */ jsx235("path", {
          fill: "#118600",
          d: "M0 409.2h767.6V512H0z"
        })
      ]
    })
  ]
});
var Tg_default = SvgTg;

// src/country-flag-icons/generated/Th.tsx
import { jsx as jsx236, jsxs as jsxs229 } from "react/jsx-runtime";
var SvgTh = (props) => /* @__PURE__ */ jsx236("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs229("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx236("path", {
        fill: "#f4f5f8",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx236("path", {
        fill: "#2d2a4a",
        d: "M0 162.5h640v160H0z"
      }),
      /* @__PURE__ */ jsx236("path", {
        fill: "#a51931",
        d: "M0 0h640v82.5H0zm0 400h640v80H0z"
      })
    ]
  })
});
var Th_default = SvgTh;

// src/country-flag-icons/generated/Tj.tsx
import { jsx as jsx237, jsxs as jsxs230 } from "react/jsx-runtime";
var SvgTj = (props) => /* @__PURE__ */ jsxs230("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx237("path", {
      fill: "#060",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#fff",
      d: "M0 0h640v342.9H0z"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#c00",
      d: "M0 0h640v137.1H0z"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#f8c300",
      d: "M300.8 233.6a8.6 8.6 0 0 1 16 4V272h6.4v-34.3a8.6 8.6 0 0 1 16-4 20.2 20.2 0 1 0-38.4 0"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#fff",
      d: "M305.4 224.7a13.7 13.7 0 0 1 14.6 6.5 13.7 13.7 0 0 1 14.6-6.5 14.7 14.7 0 0 0-29.2 0"
    }),
    /* @__PURE__ */ jsx237("path", {
      id: "tj_svg__a",
      fill: "#f8c300",
      d: "M316.8 258.3a26 26 0 0 1-43.8 16.6 27 27 0 0 1-41 12c2.5 25 40 19.9 42.8-4.4 11.7 20.7 37.6 14.7 45.2-10.6z"
    }),
    /* @__PURE__ */ jsx237("use", {
      xlinkHref: "#tj_svg__a",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "matrix(-1 0 0 1 640 0)"
    }),
    /* @__PURE__ */ jsx237("path", {
      id: "tj_svg__b",
      fill: "#f8c300",
      d: "M291.8 302.6c-5.3 11.3-15.7 13.2-24.8 4.1 0 0 3.6-2.6 7.6-3.3-.8-3.1.7-7.5 2.9-9.8a15 15 0 0 1 6.1 8.1c5.5-.7 8.2 1 8.2 1z"
    }),
    /* @__PURE__ */ jsx237("use", {
      xlinkHref: "#tj_svg__b",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "rotate(9.4 320 551.3)"
    }),
    /* @__PURE__ */ jsx237("use", {
      xlinkHref: "#tj_svg__b",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "rotate(18.7 320 551.3)"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "none",
      stroke: "#f8c300",
      strokeWidth: 11,
      d: "M253.5 327.8a233.1 233.1 0 0 1 133 0"
    }),
    /* @__PURE__ */ jsx237("g", {
      fill: "#f8c300",
      transform: "translate(320 164.6) scale(.68571)",
      children: /* @__PURE__ */ jsx237("path", {
        id: "tj_svg__c",
        d: "m301930 415571-790463-574305h977066l-790463 574305L0-513674z",
        transform: "scale(.00005)"
      })
    }),
    /* @__PURE__ */ jsxs230("g", {
      id: "tj_svg__d",
      fill: "#f8c300",
      transform: "translate(320 260.6) scale(.68571)",
      children: [
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#tj_svg__c",
          width: "100%",
          height: "100%",
          transform: "translate(-70 -121.2)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#tj_svg__c",
          width: "100%",
          height: "100%",
          transform: "translate(-121.2 -70)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#tj_svg__c",
          width: "100%",
          height: "100%",
          transform: "translate(-140)"
        })
      ]
    }),
    /* @__PURE__ */ jsx237("use", {
      xlinkHref: "#tj_svg__d",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "matrix(-1 0 0 1 640 0)"
    })
  ]
});
var Tj_default = SvgTj;

// src/country-flag-icons/generated/Tk.tsx
import { jsx as jsx238, jsxs as jsxs231 } from "react/jsx-runtime";
var SvgTk = (props) => /* @__PURE__ */ jsxs231("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx238("path", {
      fill: "#00247d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx238("path", {
      fill: "#fed100",
      d: "M108.1 354.6c-6.7-.1 62.8-37 120.9-84.4 76.2-62.1 240.3-161.4 288.6-177.6 5-1.7-10.3 8.6-12.3 11.9-51.5 61-10.4 176 54 233.9 19.4 14.8 18.4 15.6 54.3 17v3.4zm-4.2 6.7s-4.9 3.5-4.9 6.1c0 2.9 5.5 6.7 5.5 6.7l498.5 5.5 9.2-6.1-12.8-7.9z"
    }),
    /* @__PURE__ */ jsx238("path", {
      fill: "#fff",
      d: "m106.8 109.1-4 12.2 10.4-7.5 10.3 7.5-3.9-12.2 10.3-7.5h-12.8l-3.9-12.2-4 12.2H96.4zm78.1 57.4 8.6-6.3h-10.7l-3.3-10.1-3.3 10.1h-10.6l8.6 6.3-3.3 10.1 8.6-6.3 8.7 6.3zm-145.2 13-4-12.2-3.9 12.2H19l10.3 7.5-3.9 12.2 10.3-7.5 10.4 7.5-4-12.2 10.4-7.5zm78.1 122.3-4.6-14.2-4.6 14.2h-15l12.1 8.7-4.6 14.3 12.1-8.8 12.1 8.8-4.7-14.3 12.1-8.7z"
    })
  ]
});
var Tk_default = SvgTk;

// src/country-flag-icons/generated/Tl.tsx
import { jsx as jsx239, jsxs as jsxs232 } from "react/jsx-runtime";
var SvgTl = (props) => /* @__PURE__ */ jsxs232("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx239("defs", {
      children: /* @__PURE__ */ jsx239("clipPath", {
        id: "tl_svg__a",
        children: /* @__PURE__ */ jsx239("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs232("g", {
      fillRule: "evenodd",
      clipPath: "url(#tl_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx239("path", {
          fill: "#cb000f",
          d: "M0 0h1031.2v512H0z"
        }),
        /* @__PURE__ */ jsx239("path", {
          fill: "#f8c00c",
          d: "M0 0c3.2 0 512 256.7 512 256.7L0 512z"
        }),
        /* @__PURE__ */ jsx239("path", {
          fill: "#000001",
          d: "M0 0c2.1 0 340.6 256.7 340.6 256.7L0 512z"
        }),
        /* @__PURE__ */ jsx239("path", {
          fill: "#fff",
          d: "M187.7 298.2 127 284.7l-31 52.8-5-59.7-60.7-13.3 54.9-24.9-3.3-59.3 40.2 43.4 55.4-25.3-28.9 54 39.2 45.8z"
        })
      ]
    })
  ]
});
var Tl_default = SvgTl;

// src/country-flag-icons/generated/Tm.tsx
import { jsx as jsx240, jsxs as jsxs233 } from "react/jsx-runtime";
var SvgTm = (props) => /* @__PURE__ */ jsxs233("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "M357.6 53A59.7 59.7 0 1 1 295 153.7a59.7 59.7 0 0 0 62.3-100.1ZM301 97l6.4-20.8-17.7 12.9h21.9l-17.8-12.9Zm0-30.6 6.4-20.8-17.7 12.9h21.9l-17.8-13.2ZM331.2 82l6.4-20.8-17.8 12.9h22L324 61.2Zm-61 30.3 6.9-20.8-17.8 12.8h22l-17.8-12.8Zm30.3 15.4 6.8-20.7-17.7 12.8h21.9L293.7 107z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M86.6 0h129.6v480H86.6Z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M118 0h-4.2l-8.3 7.6-3-3.4h3l-.8-3h-4.9l-10.2 9V14h5v-3l2.2 2.2-5.3 4.6L94 20l-7.5 6.8v5L99 20.3l-2.2-2.6 4.9-4.6L97.5 9l2.7-3 5.6 5.2ZM87 0v8.7L89.5 6V2.3h3L95.3 0Zm22.6 0h-3l.4 2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M117.6 0h-3.8l-8 7.6-3.7-3.8h3.4l-.8-2.7h-4.5l-9.9 9.5v3h3.8V9.8l3.4 3.4-5.3 4.6 2.3 2.2-7.6 7.6v3.8L98.3 20 96 17.8l5.3-4.6-4.5-4.1 3.8-3.4 5.2 5.3 11.4-11Zm-31 0v8.3l2.2-2.6V1.9h3.4L94.5 0Zm22.6 0h-1.8v1.5z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M86.6 55.6v4.9l7.2 6.8-2.7 2.2 5.3 5-2.3 1.8v-3h-4.5v3.8l10.2 9.5h5l.7-3.8H102l3-2.7 8.3 7.6-8.3 6.8-3-2.7h3l-.8-3.7h-4.9l-9.8 10.2v3.7h5v-3.7l2.2 2.2-5.3 4.6 2.6 2.6-7.5 6.8v4.6L99 107.7l-2.2-2.6 4.9-4.6-4.2-4.1 2.7-2.7 5.6 4.6 12.5-11.4-12.5-11.3-5.6 5.3-2.7-2.7 4.2-4.1-5-5L99 67 87 55.6zm0 22.6v18.2l2.6-3v-3.8h3l2.7-2.3-2.7-2.3h-3v-3.7zm20.8 6.5v4.9l2.6-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M86.6 56.3v3.8l7.5 7.2-2.2 2.2 5.3 5-3.4 2.6v-3.4H90v3l9.8 9.5h4.5l.8-2.7h-3.8l4.2-3.8 8.7 7.6-8.7 7.6-3.8-3.8h3.4l-.8-2.3h-4.5l-9.8 9v3.1h3.8v-3.8l3.4 3.4-5.3 4.6 2.2 2.6-7.5 7.2v3.8l11.3-11.4-2.3-2.2 5.3-4.6-4.5-4.1 3.8-3.4 5.6 5.3 11.8-11-12.1-11-5.7 5.3-3.4-3 4.5-4.1-5.3-5 2.7-2.2zm0 22.7v16.6l2.2-2.2v-3.8h3.4l2.3-2.3-2.3-1.9h-3.4v-3.8zm21.1 6.4v3.4l2-1.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M86.6 145.9v5.3l7.2 6.8-2.7 2.3 5.3 4.5-2.3 2.3v-3h-4.5v3.7l10.2 9h5l.7-3H102l3-3 8.3 7.2-8.3 7.6-3-3.4h3l-.8-3.4h-4.9l-10.2 9.4v3.8h5.3v-3l2.3 1.9-5.3 4.9L94 198l-7.5 6.9v4.9L99 198.4l-2.2-2.6 4.9-5-4.2-3.7 2.7-3 5.6 4.9 12.5-11.4-12.5-11.3-5.6 5.3-2.7-3 4.2-3.8-5-5 2.3-2.2-12-11.3zm0 22.7v17.7l2.6-2.6v-3.8h3l2.7-2.3-2.7-2.6h-3v-3.4zm20.8 6.4v5l2.6-2.7z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M86.6 146.3v3.7l7.5 7.6L92 160l5.3 4.5-3.4 3v-3.7H90v3.7l9.8 8.7h4.5l.8-2.6h-3.8l4.2-3.8 8.7 7.6-8.7 7.9-3.8-3.8h3.4l-.8-2.6h-4.5l-9.8 9.4v3h3.8v-3.7l3.4 3-5.3 4.9 2.2 2.3-7.5 7.5v3.8l11.3-11.3-2.3-2.3 5.3-5-4.5-3.7 3.8-3.8 5.6 6 11.8-11.3-12.1-10.5-5.7 5.2-3.4-3.4 4.5-3.7-5.3-5 2.7-2.2zm0 22.6v17l2.2-2.6v-3.8h3.4l2.3-1.9-2.3-2.2h-3.4v-3.8l-2.2-2.3zm21.1 6.8v3.4l2-1.8Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M86.6 236.2v4.6l7.2 6.8-2.7 2.2 5.3 5-2.3 2.2v-3h-4.5v3.8l10.2 9h5l.7-3.4H102l3-2.6 8.3 7.2-8.3 7.1-3-3h3l-.8-3.4h-4.9l-10.2 9.5v3.8h5.3v-3l2.3 1.8-5.3 5L94 288l-7.5 6.8v5L99 288.3l-2.2-2.7 4.9-4.9-4.2-3.8 2.7-3 5.6 5.3 12.5-11.3-12.5-11.4-5.6 5-2.7-2.7 4.2-3.8-5-5.3 2.3-2.2-12-11.4zm0 22.7v17.8l2.6-3v-3.5h3L95 268l-2.7-2.7h-3V262zm20.8 6.4v5l2.6-2.7z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M86.6 236.6v3.8l7.5 7.5-2.2 2 5.3 4.8-3.4 3V254H90v3.4l9.8 9h4.5l.8-2.6h-3.8l4.2-3.8 8.7 7.6-8.7 8-3.8-3.9h3.4l-.8-2.6h-4.5l-9.8 9v3.5h3.8v-3.8l3.4 3-5.3 5L94 288l-7.5 7.6v3.7L97.9 288l-2.3-2.3 5.3-4.9-4.5-3.8 3.8-3.7 5.6 5.6 11.8-11.3-12.1-10.6-5.7 5.3-3.4-3.4 4.5-3.8-5.3-5.3 2.7-2.2zm0 22.7v17l2.2-2.7V270h3.4l2.3-2-2.3-2.2h-3.4V262l-2.2-2.2zm21.1 6.8v3.4l2-2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M86.6 326.6v4.5l7.2 6.8-2.7 2.3 5.3 4.9-2.3 1.9v-3h-4.5v3.7l10.2 9.5h5l.7-3.4H102l3-3 8.3 7.5-8.3 7.2-3-3h3l-.8-3.4h-4.9l-10.2 9.4v3.8h5.3v-3.4l2.3 2.2-5.3 5 2.6 2.2-7.5 6.8v4.6L99 378.3l-2.2-2.2 4.9-5-4.2-4.1 2.7-2.7 5.6 5.3 12.5-11.3-12.5-11.3-5.6 4.9-2.7-2.7 4.2-4.1-5-5L99 338zm0 22.6V367l2.6-3v-3.4h3l2.7-2.7-2.7-2.2h-3v-3.8zm20.8 6.5v4.5l2.6-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M86.6 327v3.7L94 338l-2.2 2.3 5.3 4.9-3.4 3v-3.8H90v3.4l9.8 9h4.5l.8-2.6h-3.8l4.2-3.7 8.7 7.5-8.7 8-3.8-3.8h3.4l-.8-2.7h-4.5l-9.8 9.1v3.4h3.8v-3.8l3.4 3-5.3 5 2.2 2.2-7.5 7.6v3.4L97.9 378l-2.3-2 5.3-4.9-4.5-4.1 3.8-3.4 5.6 5.3 11.8-11-12.1-11-5.7 5.4-3.4-3 4.5-4.2-5.3-5 2.7-2.2Zm0 22.6v17l2.2-2.3v-3.7h3.4l2.3-2.3-2.3-1.9h-3.4v-3.8l-2.2-2.6zm21.1 6.4v3.8l2-1.9Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M184.5 0h4.5l7.6 7.6 3.8-3.8h-3l.7-3h4.9l10.2 9v3.8H208v-3l-2.3 2.3 5.3 4.5-2.6 2.3 7.6 6.8v4.9L203.4 20l2.2-2.6-4.9-4.5 4.2-4.2-2.7-3-5.6 5.6Zm31.7 0v8.7l-3-2.7V2.3h-3L207.5 0Zm-23.8 0h3l-.3 2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M185.2 0h3l8.8 7.6 3.7-3.8h-3.4l.8-2.7h4.5l9.9 9.5v3h-3.8V9.8l-3 3.4 4.9 4.6-2.3 2.6 7.6 7.2v3.8L204.5 20l2.3-2.2-5.3-4.6 4.5-4.1-3.8-3.4-4.9 5.6L185 0Zm31 0v8.3l-2.6-2.6V1.9h-3.4l-2-1.9Zm-23.4 0h2.3v1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M216.2 55.6v4.9l-7.5 6.8 2.6 2.2-5.3 5 2.3 1.8v-3h4.5v3.8l-10.2 9.5h-4.9l-.7-3.8h3l-3-2.7-8 7.6 7.6 6.8 3.4-2.7h-3l.7-3.7h5l10.1 9.8v3.8H208v-3.4l-2.3 2.2 5.3 4.6-2.6 2.6 7.6 6.8v4.6l-12.5-11.4 2.2-2.6-4.9-4.6 4.2-4.1-2.7-2.7-5.6 4.6L184 86.9l12.5-11.3 5.6 5.3 2.7-2.7-4.2-4.1 5-5-2.3-2.2 12.5-11.3zm0 22.6v18.2l-3-3v-3.8h-3l-2.7-2.3 2.7-2.3h3v-3.7zm-21.1 6.5.3 2.6-.3 2.3-2.7-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M216.2 56.3v3.8l-8.3 6.8 2.3 2.3-5 4.9 3 2.6v-3.4h3.9v3l-9.9 9.5h-4.5l-.7-2.7h3.7l-4.1-3.7-8.7 7.5 8.7 7.6 3.8-3.8H197l.7-2.3h4.5l9.9 9.1v3h-3.8v-3.7l-3 3.4 4.9 4.5-2.3 2.6 7.6 7.2v3.8L204 107l2.3-2.3-5.3-4.5 4.5-4.2-3.7-3.4-5.3 5.3-12.1-11 12-11 5.7 5.4 3.4-3-4.5-4.2 5.3-5-2.6-2.2zm0 22.7v16.6l-2.6-2.2v-3.8h-3.4l-2-2.3 2-1.9h3.4v-3.8zm-21.5 6.4.4 2v1.4l-2.3-1.5Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M216.2 145.9v5.3l-7.5 6.8 2.6 2.3-5.3 4.5 2.3 2.3v-3h4.5v3.7l-10.2 9h-4.9l-1.1-3h3l-3-3-7.6 6.8 7.6 7.6 3.4-3.4h-3l.7-3.4h5l10.1 9.4v3.8H208v-3l-2.3 1.9 5.3 4.9-2.6 2.3 7.6 6.8v4.9L203.4 198l2.2-2.6-4.9-5 4.2-3.7-2.7-3-5.6 5.3-12.5-11.4 12.5-11.3 5.6 5.3 2.7-3-4.2-3.8 5-5-2.3-2.2 12.5-11.3zm0 22.7v17.7l-3-2.6v-3.8h-3l-2.7-2.3 2.7-2.6h3v-3.4zm-21.1 6.4.3 2.3-.3 2.6-2.7-2.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M216.2 146.3v3.7l-8 7.6 2.4 2.3-5 4.5 3 3v-3.7h3.9v3.7l-9.9 8.7h-4.5l-.8-2.6h3.8l-4.5-3.4-8.7 7.5 8.7 8 3.8-3.8H197l.7-2.7h4.5l9.9 9.5v3h-3.8v-3.8l-3 3 4.9 5-2.3 2.2 7.6 7.6v3.8L204 198l2.3-2.2-5.3-5 4.5-3.7-3.7-3.8-5.3 5.7-12.1-11.4 12-10.5 5.7 5.2 3.4-3.4-4.5-3.7 5.3-5-2.6-2.2zm0 22.6v17l-2.6-2.6v-3.8h-3.4l-2-1.9 2-2.2h3.4v-3.8l2.6-2.3zm-21.5 6.8.4 1.6v1.8l-2.3-1.8Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M216.2 236.2v4.6l-7.5 6.8 2.6 2.2-5.3 5 2.3 2.2v-3h4.5v3.8l-10.2 9h-4.9l-.7-3.4h3l-3-2.6-8 7.2 7.6 7.1 3.4-3h-3l.7-3.4h5l10.1 9.5v3.8H208v-3l-2.3 1.8 5.3 5-2.6 2.2 7.6 6.8v5l-12.5-11.4 2.2-2.7-4.9-4.9 4.2-3.8-2.7-3-5.6 5.3L184 268l12.5-11.4 5.6 5 2.7-2.7-4.2-3.8 5-5.3-2.3-2.2 12.5-11.4zm0 22.7v17.8l-3-3v-3.5h-3l-2.7-2.2 2.7-2.7h3V262zm-21.1 6.4.3 2.3-.3 2.6-2.7-2.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M216.2 236.6v3.8l-8 7.5 2.4 2-5 4.8 3 3V254h3.9v3.4l-9.9 9h-4.5l-.8-2.6h3.8L197 260l-8.7 7.6 8.7 8 3.7-3.9h-3.4l.8-2.6h4.5l9.9 9v3.5h-3.8v-3.8l-3 3 4.9 5-2.3 2.2 7.6 7.6v3.7L204.5 288l2.3-2.3-5.3-4.9 4.5-3.8-3.8-3.7-5.2 5.6-12.1-11.3 12-10.6 5.7 5.3 3.4-3.4-4.5-3.8 5.3-5.3-2.7-2.2zm0 22.7v17l-2.6-2.7V270h-3.4l-2-2 2-2.2h3.4V262l2.6-2.2zm-21.5 6.8.4 1.5v1.9l-2.3-2Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M216.2 326.6v4.5l-7.5 6.8 2.6 2.3-5.3 4.9 2.3 1.9v-3h4.5v3.7l-10.2 9.5h-4.9l-.7-3.4h3l-3-3-8 7.5 7.6 7.2 3.4-3h-3l.7-3.4h5l10.1 9.4v3.8H208v-3.4l-2.3 2.2 5.3 5-2.6 2.2 7.6 6.8v4.6l-12.5-11.4 2.2-2.2-4.9-5 4.2-4.1-2.7-2.7-5.6 5.3-12.5-11.3 12.5-11.3 5.6 4.9 2.7-2.7-4.2-4.1 5-5-2.3-2.2zm0 22.6V367l-3-3v-3.4h-3l-2.7-2.7 2.7-2.2h3v-3.8zm-21.1 6.5.3 2.2-.3 2.3-2.7-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M216.2 327v3.7L208 338l2.3 2.3-5 4.9 3 3v-3.8h3.9v3.4l-9.9 9h-4.5l-.7-2.6h3.7l-4.1-3.7-8.7 7.5 8.7 8 3.8-3.8H197l.7-2.7h4.5l9.9 9.1v3.4h-3.8v-3.8l-3 3 4.9 5-2.3 2.2 7.6 7.6v3.4L204 378l2.3-2-5.3-4.9 4.5-4.1-3.7-3.4-5.3 5.3-12.1-11 12-11 5.7 5.4 3.4-3-4.5-4.2 5.3-5-2.6-2.2zm0 22.6v17l-2.6-2.3v-3.7h-3.4l-2-2.3 2-1.9h3.4v-3.8l2.6-2.6zm-21.5 6.4.4 2v1.8l-2.3-1.9Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M96.8 424.8c.7 2.7 3 4.6 3.8 7.6.7-3 1.5-5.7 1-8.7-.7-2.3-2.6-3.8-2.6-6.4-2.2 1.8-2.6 4.5-2.2 7.5m-.4 11.4a17.8 17.8 0 0 0 7.2 5.6c-.8-2.2 0-3.8 1.5-5.6 1.1-2 1.9-3.8.7-6.5a14.4 14.4 0 0 1-1.8 3.4 10 10 0 0 0-2.3 5.3c-1.5-1.1-1.9-2.6-2.7-4.1a12.9 12.9 0 0 0-5.2-5.3c.7 2.6 1 4.9 2.6 7.2m10.2 7.5-.8 3.8-4.1-3c-1.9-2-4.2-2.7-5.7-5a9 9 0 0 0 3.8 7.2l8 5c-.4-2.7.7-5 1.4-7.6a6.8 6.8 0 0 0-1.5-6c0 1.8-.7 3.7-1.1 5.2zm5.3 8.7 3 5.3c-2.6-.8-4.9-2.3-7.5-3.8-2.7-1.5-5.7-2.2-8.4-4.5a13 13 0 0 0 9.1 9c3.4.8 6 .4 9.8 2a26.5 26.5 0 0 0-2.6-7.6l-2.3-5.3a5.7 5.7 0 0 0-1.1 5zm9.8 7.2a12.1 12 0 0 0 3.8 3.8c-3.8 0-6.8-2-10.6-2.3-2.2 0-4.5.8-6.8.4 3 1.9 5.7 3.8 9 3.8 4.2.7 8.4 0 13.3 0a17.2 17.2 0 0 1-4.9-5.7c-1.9-3-3.8-5-7.2-5.3l3.8 5.3zm13.3 6c-6.5 1.2-12.9 2.7-19.7 2.7a30.3 30.3 0 0 0 22.3.4c3.8-1.2 7.2-2.3 10.2-2 4.5 0 9.8 2.3 15.9 8.4l2.3-1.9a36.3 36.3 0 0 0-31-7.6"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M102.8 56.3 92.2 50V34.8l10.6-6.5V20l9.5-5.6h8l15-8.7h31.8l15.1 8.7h7.6l10.6 5.6v8.3l10.2 6.5v15l-10.2 6.5v8l-9.9 6h-8l-15 8.3h-31.8l-15.1-8.3H113l-10.6-6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "m135.3 6-15 8.7h-7.6l-9.9 5.7v8l-10.2 6.4v15l10.2 6.1v8.4l9.9 5.6h7.5l15.1 8.3h31.8l15.1-8.3h7.6l9.8-5.6v-8.4l10.2-6V34.8l-10.2-6.5v-7.9l-9.8-5.7h-7.6L167.1 6Zm.8 3.4h30.2l15.2 8.4h7.5l7.6 4.1v8.3l10.2 6.5V48l-10.6 6.4v8l-7.2 4.5h-7.5l-15.2 8.3h-30.2L121 67h-7.6l-7.6-4.5v-8L95.6 48V36.7l10.6-6.5V22l7.6-4.1h7.5z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M151.2 42.3V9.4h-15.1l-14.8 8.7h-7.5l-7.6 3.8v8.3L96 36.7V42h55.2v32.8h15.1l15.2-8.3h7.5l6.8-4.1V54l10.6-6.4v-5.3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "M96 42.3v5.3l10.6 6.4v8.4l6.8 3.7h8l15 8.7h14.8V42h55.2v-5.3l-10.6-6.5v-7.5L189 18h-7.5l-15.2-8.7h-15v33Z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m118.7 21.2-2.6-2.7-2.3 1.5 2.6 2.7-3.7 1.9h7.5l6 6 2-2.3-6.1-5.6v-3.8Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m130.8 20-2.6-2.2-2.3 1.5 2.6 2.2-3.8 2h7.6l6 6 2-2.3-5.7-5.7v-3.7zm-12.9 7.6-2.6-2.3-2.6 2 2.6 2.2-3.4 1.9h7.6l6 6 1.9-2.3-6-5.6v-3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M151.2 9.4h-6.4l-3.4 3h-6.8l-4.6 2.7 1.2 2.7 4.1-2.3h2l6.7 7.6 7.2-4.2Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m116 18.9 2.3 2.3-1.9 1.1-2.2-1.9zm6.1.8v3l5.7 5.6-1.5 1.6-6-5.7h-6.1l7.5-5zm6-1.6 2.3 2-1.9 1.4-2.2-2.2Zm6.1 0V22l5.7 5.3-1.5 1.9-6-6.4h-6.1l7.5-4.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m115.3 26 2.3 2-2 1.1-2.2-1.9Zm5.7 0v4l6 5.2-1.5 1.6-6-5.7h-6Zm30.2-16.6h-6.4l-3.4 3.8H135l-4.6 2 .8 2.2L135 15h2.6l6 7.6 7.6-3.8Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m118.7 63.5-2.6 2.3-2.3-1.5 2.6-2.3-3.7-2.3h7.5l6-5.7 2 2.3L122 62v3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m130.8 64.3-2.6 2.6-2.3-1.5 2.6-2.3-3.8-2.2h7.6l6-5.7 2 1.9-5.7 5.6v3.8zm-12.9-7.6-2.6 2.3-2.6-1.6 2.6-2.2-3.4-2.3h7.6l6-5.7 1.9 2-6 5.6v3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M151.2 75.2h-6.4l-3.4-3.4h-6.8l-4.6-2.3 1.2-3 4.1 2.3h2l6.7-7.6 7.6 4.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m116 65.4 2.3-2.3-1.9-1.1-2.2 2.3zm6.1-.4v-3.4l5.7-5.7-1.5-1.5-6 5.7h-6.1l7.5 5zm6 1.5 2.3-2.2-1.9-1.2-2.2 2.3zm6.1-.4v-3.7l5.7-5.3-1.5-1.5-6 5.6h-6.1l7.5 5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m115.3 58.6 2.3-2.3-2-1.1-2.2 2.2Zm5.7-.4v-3.4l6-5.7-1.5-1.5-6 5.7h-6Zm30.2 16.6h-6.4l-3.4-3.4H135l-4.6-2.2.8-2 3.8 2h2.6l6.4-7.6 7.2 4.2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m114.5 31.7-3-1-4.1 2.6v.7l-6.5 8.3 6.5 8v.7l3.7 3 3.4-1-1.8-1.6v-2.3l.7-.7h3.4V36.3H113l-.3-.8V33Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m107.7 33.6 3.8-2.6 2.3.7-1.5 1.2v2.6l.7 1.2h3.4V48H113l-.7 1.1v2.7l1.5.7-2.3 1.2-3.8-2.7v-.7l-6.4-8 6.4-8.3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m183.7 21.2 2.7-2.7 2.2 1.5-2.2 2.7 3 1.9h-7.2l-6 6-2-2.3 6.1-5.6v-3.8Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m171.6 20 2.7-2.2 2.2 1.5-2.2 2.2 3 2H170l-6 6-2-2.3 6.1-5.7v-3.7zm12.9 7.6 2.6-2.3 2.7 2-2.7 2.2 3.4 1.9H183l-5.7 6.4-1.9-2.3 6-5.6V26z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M151.2 9.4h6.4l3.8 3h6.4l5 2.7-1.2 2.7-4.5-2.3h-1.9l-6.8 7.6-7.2-4.2Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m186.4 18.9-2.3 2.3 1.9 1.1 2.3-1.9zm-5.7.8v3l-6 5.6 1.5 1.6 6-5.7h6l-7.5-5zm-6.8-1.6-2.3 2 2 1.4 2.2-2.2Zm-5.7 0V22l-5.6 5.3 1.5 1.9 6-6.4h6l-7.5-4.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m187.1 26-2.2 2 1.8 1.1 2.3-1.9Zm-5.6 0v4l-6.1 5.2 1.5 1.6 6-5.7h6.1ZM151.2 9.5h6.4l3.4 3.8h6.5l4.5 2-.8 2.2-3.7-2.3h-2.3l-6.8 7.6-7.2-3.8Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m183.7 63.5 2.7 2.3 2.2-1.5-2.2-2.3 3-2.3h-7.2l-6-5.7-2 2.3 6.1 5.7v3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m171.6 64.3 2.7 2.6 2.2-1.5-2.2-2.3 3-2.2H170l-6-5.7-2 1.9 6.1 5.6v3.8zm12.9-7.6L187 59l2.7-1.6-2.7-2.2 3.4-2.3H183l-6-5.7-2 2 6 5.6v3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M151.2 75.2h6.4l3.8-3.4h6.4l5-2.3-1.2-3-4.5 2.3h-1.9l-6.8-7.6-7.2 4.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M186.4 65.4 184 63l2-1 2.3 2.3zm-5.7-.4v-3.4l-6-5.7 1.5-1.5 6 5.7h6zm-6.4 1.5-2.3-2.2 1.9-1.2 2.3 2.3zm-5.7-.4v-3.7l-6-5L164 56l6 5.7h6l-7.5 5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m187.1 58.6-2.2-2.3 1.8-1.1 2.3 2.2zm-5.6-.4v-3.4l-6.1-5.7 1.5-1.5 6 5.7h6.1Zm-30.3 16.6h6.4l3.4-3.4h6.5l4.5-2.2-.8-2-3.7 2h-2.3l-6.8-7.6-7.2 4.2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m187.9 31.7 3-1 4.2 2.6v.7l6.4 8.3-6.4 8v.7l-3.8 3-3.4-1 1.9-1.6v-2.3l-.8-.7h-3.4V36.3h3.8l.4-.8V33Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m194.7 33.6-3.8-2.6-2.3.7 1.5 1.2v2.6l-.7 1.2H186V48h3.4l.7 1.1v2.7l-1.5.7 2.3 1.2 3.8-2.7v-.7l6.4-8-6.4-8.3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "m108.9 49.1-1.5-1.5V47l-3.8-4.6 3.8-4.5V37l1.5-1.5 3.4 2.7h-2l2.7 2.6h6l5-3.8v-9.8h11.7l14-8.7v-2.2l-2.3-1.2-2.6 2v1l-2-2.6 3.9-3 4.1-2.7h1.5l3.8 2.7h.8l3.8 3-2 2.6-.3-1-2.7-2h-.7l-2.3 1.5V19l14 8.7h12.1v9.8l4.5 3.8h6l2.7-2.6h-1.5l3-2.7 1.6 1.5v.8l3.7 4.5-3.7 4.5v.8l-1.6 1.5-3-2.6h1.5l-2.6-2.7h-6l-4.6 3.8v9.8h-12.5l-14 8.3v2.3l2.3 1.5h.4l2.6-1.5v-1.1l2 2.6-3.5 2.7h-.4l-4.1 3H150l-3.8-3h-.8l-3.7-3 2.2-2.3v1.1l2.7 1.5h.4l2.2-1.5v-2.3l-14-8.3h-11.7V48l-4.9-3.8h-6L110 47h1.9z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "m151.2 70 1.9 1-1.9 1.2zm-4.5 1.8 3.8 3h.7v-2.2L149 71l2.3-1.6V65l-15.1-9h-11v-9.1l-5.6-4.6h-8.7l-2 2.7-2.2-2.7H104l3.7 4.2v.7l1.2 1.6 2.2-2h-1v-.3l2.6-3h6.4l5.3 3.7v9.9h11.3l14.4 8.7v2.6l-2.3 1.5h-1.1l-2.3-1.5v-.7l-1.5 1.5 3 2.6zm-37.8-31.7 1.5 1.9H107zm42.3-27.6-1.5 1.1 1.5 1.1zM192 42.7l1.5 1.5 2-1.9zm-36.3-30.2-3.7-3h-.8v2.2l2.3 2-2.3 1.4V19l15.1 9h11v9.9L183 42h8.7l1.8-2.3 2.3 2.3h2.7l-3.8-3.8V37l-1.2-1-2.2 1.8h1.1l-2.6 3.4h-6.5l-4.9-3.8V27.2h-12l-14-8.3v-2.6l2.2-1.6h1.1l2.3 1.6v.7l1.5-1.9-3-2.6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "m151.2 72.2-1.5-1.1 1.5-1.2zm-40.8-29.9-1.5 2-2-2zm45.3 29.5-3.7 3h-.8v-2.2l2.3-1.5-2.3-1.6V65l15.1-9h11v-9.1l5.7-4.6h8.7l1.8 2.7 2.3-2.7h2.7l-3.8 4.2v.7l-1.2 1.6-2.2-2h1.1v-.3l-2.6-3h-6.5l-4.9 3.7v9.9h-12L152 65.8v2.6l2.2 1.5h1.2l2.2-1.5v-.7l1.5 1.5-3 2.6zm37.8-31.7L192 42h3.4zm-46.8-27.6 3.8-3h.7v2.2l-2.3 2 2.3 1.4V19l-15.1 9h-11v9.9l-5.6 3.8h-8.7l-2-2.3-2.2 2.3H104l3.7-3.8v-1.1l1.2-1.2 2.2 2h-1l2.6 3.3h6.4l5.3-3.8v-9.8h11.3l14.8-8.3v-2.6l-2.3-1.6H147l-2.3 1.6v.7l-1.5-1.9 3-2.6h.8zm4.5 2.6 1.9-1.1-1.9-1.1z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "M151.2 42.3V19.7l-15.1 9h-10.6v9.1l-5.3 4.2h31v22.6l15.1-9H177v-8.7l5.3-4.6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "m120.2 42.3 5.3 4.6v8.7h10.6l15.1 9V42h31l-5.3-4.2v-9h-10.6l-15-9.1v22.6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "m135.3 31.4-2.6-2.7-2.3 2 2.3 2.2-3 1.9h7.1l6 6 2-2.2-6-5.7V29zm31.8 21.9 2.6 2.3 2.7-1.6-2.7-2.2 3-2.3h-6.4l-6.4-5.7-1.9 2 6 5.6v3.8zm-31.8 0-2.6 2.3-2.3-1.6 2.3-2.2-3-2.3h7.1l6-5.7 2 2-6 5.6v3.8zm31.8-22 2.6-2.6 2.7 2-2.7 2.2 3 1.9h-6.4l-6.4 6-1.9-2.2 6-5.7V29z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "m169.7 55.2-2.2-2.3 1.9-1.1 2.2 2.2zm-5.6-.4v-3.4l-6-5.7 1.4-1.5 6 5.7h6.1zm-31.8-25.3 2.3 1.9-2 1.1-2.2-1.9zm5.7 0v3.8l6 5.3-1.5 1.5-6-5.7h-6l7.5-4.5z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "m169.7 29.5-2.2 1.9 1.9 1.1 2.2-1.9zm-5.6 0v3.8l-6 5.3 1.4 1.5 6-5.7h6.1zm-31.8 26 2.3-2.2-2-1.1-2.2 2.2zm5.7-.3v-3.4l6-5.7-1.5-1.5-6 5.7h-6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M167 42.3 151.3 53l-15.9-10.6 16-10.6Z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "M151.2 32.1 136.1 42h30.2zv20l15-9.8H136l15.1 9.9z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M155.4 45.7v3h-8v-3h-5.6v-7.1h5.6v-3h7.6v3h5.7V46z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M147.4 36v3h-5.6v3h9.4v-6zm3.8 6h9.5v-3H155v-3h-3.8zm-9.4.3v3.4h5.6v2.7h3.8v-6zm9.4 6h3.8v-2.6h5.7v-3.4h-9.5z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M178.4 162.9v-4.5h12.9v-5h12.5v-41.9h-12.5v-5h-12.9V102h-12.8v-4.5h-28.8v4.5H124v4.6h-13v4.9H98.7v42H111v5.2h13v3.8h12.8v4.6h28.8v-4.6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M137.2 97.9v4.1h-12.5v4.6H112v4.9H99.4v41.6H112v4.5h12.8v5h12.9v4.5h28v-4.6h12.8V158h12.9v-5H204v-41.5h-12.8V107h-13.6v-4.6h-12.9V98zm3.8 3.4h20.8v4.5h12.8v4.6h12.9v4.9h12.9v34.4h-12.9v5.3h-12.9v3.7h-12.8v4.6h-21.2v-4.6h-12.8V155h-12.9v-5h-12.5v-34.3H115v-5h12.9v-4.9h12.8z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M128.5 158.7v-4.5h-13.2v-4.5h-12.9v-34h12.9v-5h13.2v-4.5h12.9v-4.5h20.4v4.1h12.8v4.6h12.9v4.9h12.9v34h-12.9v4.5h-13.6v5H161v4.9h-20.4v-5z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "m131.2 109.6-3.4-2.6v4.9l-3 1.9v-3l-3 3-3.1-3v3l-3.8-2v4.2l-2.6 2.3v-2.6l-3.8 2.2-3-2.2v2.6L102 116v13.3h-3.8v6.8h3.8v13.2l3.4-2.3v3l3.4-2.6 3.4 2.6v-3l2.6 2.3v4.5l3.8-2.2v3l3-3 3 3v-3.4l3 1.9v4.9l3.5-2.7v3.4l3.4-3 3 3V155l3 2.2v5.3l4.6-4.1v4.5l6-3.8 6 3.8v-4.2l4.6 3.8v-4.9l3-2.3v3.4l3-3 3.8 3V155l3 2.6v-5l3-1.8v3l3.1-3 3 3v-2.6l3.8 2.2V149l2.6-2.3v3l3.8-2.6 3 2.7v-3l3.5 2.2v-12.8h3.7v-6.5h-3.7v-13.2l-3.4 2.3V116l-3.5 2.3-3.4-2.3v2.7l-2.6-2.3v-4.1l-3.8 1.8v-3l-3 3-3-3v3l-3-1.8v-5l-3.5 2.7v-3.4l-3 3-3.8-3v3.4l-2.6-2.3v-4.9l-4.5 3.8V102l-6 3.8-6.1-3.8v3.8l-4.6-3.8v5l-3 2.2v-3.4l-3 3-3.4-3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "M105.8 119v-3l3 2.3 3.1-2.3v3l3-2.6v32.1l-3-2.2v2.6l-3-2.3-3 2.3v-2.6l-3.5 2.2v-13.2h-3.7v-5.7h3.7v-13.2zm25.8-12 3 2.6 2.6-2.6v3.4l3.4-2.7V157l-3.4-2.3v3.4l-2.6-2.7-3 2.7v-3.4l-3.4 2.6v-49.1l3.4 2.3zm39.3 0-2.7 2.6-3-2.6v3.4l-3.4-2.7V157l3.4-2.3v3.4l3-2.7 2.7 2.7v-3.4l3.4 2.6v-49.1l-3.4 2.3zm25.7 12v-3l-3 2.3-3-2.3v3l-3.1-2.6v32.1l3-2.2v2.6l3-2.3 3 2.3v-2.6l3.5 2.2v-13.2h3.8v-5.7H200v-13.2z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "m119 111.9 2.7 2.2 2.7-2.2v2.6l3.8-2.2v40.4l-3.8-2.3v3l-2.7-2.6-2.6 2.6v-3l-3.8 2.3v-40.4l3.8 2.2zm26.5-5-4.5-3.7v59l4.5-4.2v4.5l5.7-3.8 5.7 3.8v-4.9l4.5 3.8v-57.8l-4.5 3.7V102l-5.7 3.8-5.7-3.8zm37.8 5-2.6 2.2-2.6-2.2v2.6l-3.8-2.2v40.4l3.8-2.3v3l2.6-2.6 3 2.6v-3l3.4 2.3v-40.4l-3.8 2.2z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m107.4 126.6 1.5.8c.3 0 1.1 0 1.5-.8 1.1-1.1 1.1-3.4 1.1-4.9l-1.9 1.9-.7-1.9-1.2 1.9-1.5-1.9c0 1.5 0 3.8 1.2 5zm13.6-3.4-1.2-1.1v-2l-2.2 2.4 3.7 3.7 4.6-3.7-2.3-2.3v1.9l-1.1 1.1v-3.8l1.9-1.5-2.7-2.2-2.6 2.2 1.9 2zm12.4-3.8-.7-1.1V116l-2.7 2.3 4.6 4.2 3.8-3.8-2.3-2.7v2.3l-.8.8v-3.8l2-1.2-2.7-2.2-2.7 2.2 1.5 1.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "m108.9 122.5.7 1.5 1.5-1.5c0 1.8-.3 3.4-1 3.7a1.5 1.5 0 0 1-2.4 0c-.7-.3-1.1-1.9-1.1-3.7l1.5 1.5zm26-7.2v4.9l1.6-1.9v-1.1l1.5 1.5-3.8 3.8-3.8-3.8 2-1.5v1.5l1.4 1.9v-5l-1.5-1 2.3-2 1.9 2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M122.1 119.4v4.6l1.9-1.5v-1.6l1.5 1.6-3.8 3.7-3.8-3.7 1.6-1.6v1.6l1.5 1.5v-4.6l-1.5-1.5 2.2-1.5 2 1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m195 126.6-1.5.8c-.3 0-.7 0-1-.8-1.6-1.1-1.6-3.4-1.6-4.9l1.9 1.9.7-1.9 1.2 1.9 1.5-1.9c0 1.5 0 3.8-1.1 5zm-13.2-3.4.8-1.1v-2l2.3 2.4-3.8 3.7-4.6-3.7 2.3-2.3v1.9l1.1 1.1v-3.8l-1.8-1.5 2.6-2.2 2.6 2.2-1.5 2zm-12.8-3.8.7-1.1V116l2.7 2.3-4.2 4.2-4.5-3.8 2.6-2.7v2.3l.8.8v-3.8l-1.5-1.2 2.6-2.2 2.7 2.2-2 1.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "m193.5 122.5-.7 1.5-1.5-1.5c0 1.8.4 3.4 1.1 3.7a1.5 1.5 0 0 0 2.3 0c.7-.3 1.1-1.9 1.1-3.7l-1.1 1.5zm-26-7.2v4.9l-1.5-1.9v-1.1l-1.6 1.5 3.8 3.8 3.8-3.8-1.9-1.5v1.5l-1.5 1.9v-5l1.5-1-1.9-2-2.2 2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M180.3 119.4v4.6l-1.5-1.5v-1.6l-1.5 1.6 3.8 3.7 3.8-3.7-2-1.6v1.6l-1.4 1.5v-4.6l1.5-1.5-2.3-1.5-1.9 1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m156.1 121-1.1-2.3 3.4-3-3.4-2.7v1.9l-1.1 1.1v-3.7l3-2-5.7-4.5-5.7 3.8 3 2.7v3.4l-1-1.2v-1.9l-3.5 2.7 3.8 3-1.5 1.9z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m147 120.6 1.2-2-3.8-3 2.7-1.8v1.1l1.8 1.9v-4.5l-2.6-2 5-3.7 4.8 3.8-2.6 1.9v4.9l1.9-2v-1l2.6 1.8-3.8 3 1.5 2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m148.6 110.4 2.6 1.9 2.7-2-2.7-1.8Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#00843d",
          d: "m151.2 108.9 1.9 1.5-1.9 1.1-1.9-1.1z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M107.4 138.3a1.9 1.9 0 0 1 1.5-.7c.3 0 1.1 0 1.5.7 1.1 1.2 1.1 3.4 1.1 5l-1.9-1.6-.7 1.5-1.2-1.5-1.5 1.5c0-1.5 0-3.7 1.2-4.9m13.6 3.4-1.2 1.2v1.9l-2.2-2.3 3.7-3.8 4.6 3.8-2.3 2.3v-2l-1.1-1v3.7l1.9 1.5-2.7 2.3-2.6-2.3 1.9-1.9zm12.4 3.8-.7 1.1v2.3l-2.7-2.3 4.6-4.1 3.8 4.1-2.3 2.3v-2.3l-.8-.7v3.8l2 1.1-2.7 2.3-2.7-2.3 1.5-1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "m108.9 142.5.7-1.5 1.5 1.5c0-1.9-.3-3.4-1-3.8a1.5 1.5 0 0 0-2.4 0c-.7.4-1.1 1.9-1.1 3.8l1.5-1.5zm26 7.2v-5l1.6 2v1.5l1.5-1.6-3.8-3.7-3.8 3.7 2 1.6v-1.6l1.4-1.8v4.9l-1.5 1.1 2.3 1.9 1.9-1.9z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M122.1 145.5V141l1.9 1.5v1.5l1.5-1.5-3.8-3.8-3.8 3.8 1.6 1.5v-1.5l1.5-1.5v4.5l-1.5 1.5 2.2 1.5 2-1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M195 138.3a1.9 1.9 0 0 0-1.5-.7c-.3 0-.7 0-1 .7-1.6 1.2-1.6 3.4-1.6 5l1.9-1.6.7 1.5 1.2-1.5 1.5 1.5c0-1.5 0-3.7-1.1-4.9zm-13.2 3.4.8 1.2v1.9l2.3-2.3-3.8-3.8-4.6 3.8 2.3 2.3v-2l1.1-1v3.7l-1.8 1.5 2.6 2.3 2.6-2.3-1.5-1.9zm-12.8 3.8.7 1.1v2.3l2.7-2.3-4.2-4.1-4.5 4.1 2.6 2.3v-2.3l.8-.7v3.8l-1.5 1.1 2.6 2.3 2.7-2.3-2-1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "m193.5 142.5-.7-1.5-1.5 1.5c0-1.9.4-3.4 1.1-3.8a1.5 1.5 0 0 1 2.3 0c.7.4 1.1 1.9 1.1 3.8l-1.1-1.5zm-26 7.2v-5l-1.5 2v1.5l-1.6-1.6 3.8-3.7 3.8 3.7-1.9 1.6v-1.6l-1.5-1.8v4.9l1.5 1.1-1.9 1.9-2.2-1.9z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M180.3 145.5V141l-1.5 1.5v1.5l-1.5-1.5 3.8-3.8 3.8 3.8-2 1.5v-1.5l-1.4-1.5v4.5l1.5 1.5-2.3 1.5-1.9-1.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m156.1 144.4-1.1 1.9 3.4 3-3.4 2.6V150l-1.1-1v3.7l3 1.9-5.7 4.1-5.7-3.7 3-2.7V149l-1 1.1v2l-3.5-2.7 3.8-3-1.5-2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m147 144.8 1.2 1.5-3.8 3 2.7 1.9V150l1.8-1.8v4.5l-2.6 1.9 5 3.8 4.8-3.8-2.6-2v-4.4l1.9 1.8v1.2l2.6-2-3.8-3 1.5-1.4z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m148.6 155 2.6-2.3 2.7 1.9-2.7 1.9Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#00843d",
          d: "m151.2 156 1.9-1.4-1.9-1.2-1.9 1.2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M196.6 130.4h-5.3v-1.9h-17.4l-12.1-7.6h-21.2l-12 7.6H111v2.3h-5.3v3.8h5.3v2.6h17.4l12.1 7.6h21.2l12-7.6h17.5v-2.3h5.3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "m140.6 121-12 7.5h-17v2.3h-5.4v3.4h5.3v2.2h17l12.1 7.6h21.2l12-7.6H191v-2.2h5.7v-3.4H191v-2.3h-17l-12.1-7.6zm0 1h20.8l11.4 7.3v1h12v4.6h-12.4v1.2l-11 6.8H141l-11.3-6.8v-1.2h-12.1v-4.5H130v-1.1z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "m161.4 122 10.6 7.6v.8h12.5v3.8H172v1.5l-10.6 7.2H141l-10.6-7.2v-1.1H118v-3.8h12.5v-1.5L141 122z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m135.7 136.4 4.5 3.8 3-2.6-1.4-1.2-1.6.8-1-.8 17.3-13.2h-3.4zm10.2 5.3h3.4l17.4-13.2-4.5-3.8-3 2.7 1.8 1.1 1.2-.8 1.1.8zm7.6 0h3l-17.4-13.2 1.1-.8 1.6.8 1.5-1.1-3-2.3-4.6 3.4Zm9.8-5.3-1.1.8-1.2-.8-1.9 1.2 3 2.2 4.6-3.4-17.4-13.2h-3.8zm-31-3.7 3 1.9 3-2-3-2.2zm15.9-.4 3 2.3 3-2-3-2.2Zm22 0-3.1 2.3-3-2 3-2.2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "m166.3 136.4-4.1 3-2.7-1.8 1.5-.8 1.2.8 1.5-1.2-17-12.8h2.6zm-10.6 5h-2.6l-17-12.9 4.1-3 2.7 1.9-1.1.7-1.6-.7-1.5 1.1zm-6.4 0h-2.6l17-12.9-1.5-1.1-1.2.7-1.5-.7 2.7-2 3.8 3.1zm3.8-17.8h2.6l-17 12.8 1.5 1.2 1.6-.8 1 .8-2.6 1.9-3.7-3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#00843d",
          d: "m135.3 130.8 2.3 1.9-2.3 1.5-2.6-1.5zm16 0 2.6 1.9-2.7 1.5-2.6-1.5zm15.8 0-2.3 1.9 2.3 1.5 2.6-1.5z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "m96.4 219.2-1.1 1.9 2.2 1.5-2.2 1.9 1.1 1.5 2.6.4 2.3-1.9 6.4 3.8v-3l-3.7-2.7 3.7-2.3V217l-6.4 3.8-2.3-1.5zm0-11.3-1.1 1.9 2.2 1.5-2.2 1.9 1.1 1.5 2.6.4 2.3-2 6.4 3.8v-3l-3.7-2.6 3.7-2.3v-3.4l-6.4 3.8-2.3-1.5zm0 29.5-1.1-1.6 2.2-1.8-2.2-1.6 1.1-1.8H99l2.3 1.5 6.4-3.8v3.4L104 234l3.7 2.6v3l-6.4-3.8-2.3 2zM206 219.2l1.2 1.9-2.3 1.5 2.3 1.9-1.2 1.5-2.6.4-2.3-1.9-6.4 3.8v-3l3.8-2.7-3.8-2.3V217l6.4 3.8 2.3-1.5zm0-11.3 1.2 1.9-2.3 1.5 2.3 1.9-1.2 1.5-2.6.4-2.3-2-6.4 3.8v-3l3.8-2.6-3.8-2.3v-3.4l6.4 3.8 2.3-1.5zm0 29.5 1.2-1.6-2.3-1.8 2.3-1.6-1.2-1.8h-2.6L201 232l-6.4-3.8v3.4l3.8 2.3-3.8 2.6v3l6.4-3.8 2.3 2zM181.5 189v4.5h3.4v2.3h3.4V192h-3v-3Zm9.8 7.5v3.8h3.8v1.9h3v-3.8h-3v-1.9ZM121 189v4.5h-3.4v2.3h-3.4V192h3v-3Zm60.5 68v-4.5h3.4v-2h3.4v3.9h-3v3zm-60.5 0v-4.5h-3.4v-2h-3.4v3.9h3v3zm70.3-7.6V245h3.8v-2.3h3v3.8h-3v3ZM111 196.5v3.8h-3.7v1.9h-3v-3.8h3v-1.9Zm0 53.3v-4.5h-3.7V243h-3v3.8h3v3zm53-60.8-2.7-2.7-2.6 2.3 2.2 2.3-3 2.6h4.2l1.5-1.5 1.5 1.5h5L167 191l2.3-2.3-2.7-2.3zm-12.9 0-2.6-2.7-2.7 2.3 2.3 2.3-2.7 2.6h4.2l1.5-1.5 1.5 1.5h4.2l-2.7-2.6 2.3-2.3-2.6-2.3zm-12.5 0 2.7-2.7 2.3 2.3-2.3 2.3 3 2.6h-4.2l-1.5-1.5-1.5 1.5h-4.9l3-2.6-2.2-2.3 2.6-2.3 2.7 2.7zm25 68-2.3 3-2.6-2.6 2.2-1.9-3-3h4.2l1.5 1.5 1.5-1.5h5l-3.1 3 2.3 1.9-2.7 2.6zm-12.5 0-2.6 3-2.7-2.6 2.3-1.9-2.7-3h4.2l1.5 1.5 1.5-1.5h4.2l-2.7 3 2.3 1.9-2.6 2.6zm-12.5 0 2.7 3 2.3-2.6-2.3-1.9 3-3h-4.2l-1.5 1.5-1.5-1.5h-4.9l3 3-2.2 1.9 2.6 2.6 2.7-2.6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "M107.4 225.3v2.6l-6-3.8-2.4 2h-2.2l-1.2-1.6 2.3-1.9-2.3-1.5 1.2-1.5H99l2.3 1.9 6-3.8v2.3l-4.1 2.6zm0-11.4v2.7l-6-3.8-2.4 1.9h-2.2l-1.2-1.5 2.3-2-2.3-1.4 1.2-1.5H99l2.3 1.8 6-3.7v2.2l-4.1 2.7zm0 17.4V229l-6 3.8-2.4-2.2h-2.2l-1.2 1.5L98 234l-2.3 1.8 1.2 1.2H99l2.3-1.5 6 3.7v-2.6l-4.1-2.6zm87.7-6v2.6l6-3.8 2.7 2h1.8l1.2-1.6-2.3-1.9 2.3-1.5-1.2-1.5h-1.5l-2.6 1.9-6-3.8v2.3l4.1 2.6zm0-11.4v2.7l6-3.8 2.7 1.9h1.8l1.2-1.5-2.3-2 2.3-1.4-1.2-1.5h-1.5l-2.6 1.8-6-3.7v2.2l4.1 2.7zm0 17.4V229l6 3.8 2.7-2.2h1.8l1.2 1.5-2.3 1.9 2.3 1.8-1.2 1.2h-1.5l-2.6-1.5-6 3.7v-2.6l4.1-2.6zm-9.9-42.3v3h3v3h-3v-2.2h-3.7V189zm10.2 7.5v2.7h2.7v3h-2.7v-1.9H192v-3.8zm-78.2-7.5v3h-3v3h2.6v-2.2h3.8V189zm68 67.6v-3.4h3v-3h-3v1.9h-3.7v3.8zm-67.3 0v-3.4h-3v-3h2.7v1.9h3.7v3.8zm77.5-7.5v-3h2.7v-3h-2.7v2.2H192v3.8zm-87.7-52.6v3h-3v3h2.7v-2.2h3.4v-3.8zm0 53v-3h-3v-3.1h2.7v2.3h3.4v3.7zm53.7-62.8 2.3 2.7 2.6-2.7 2.3 1.9-2.3 2.3 2.7 2.2h-3.8l-1.5-1.5-1.5 1.5h-3.4l2.6-2.2-2.3-2.3zm-12.8 0 2.6 2.7 2.7-2.7 1.8 1.9-2.2 2.3 2.6 2.2h-3.4l-1.5-1.5-1.5 1.5h-3.8l3-2.2-2.2-2.3zm-7.6 0-2.3 2.7-2.6-2.7-2.3 1.9 2.3 2.3-2.3 2.2h3l2-1.5 1.4 1.5h3.5L141 191l2.3-2.3zm20.4 72.6 2.3-2.3 2.6 2.3 2.3-2-2.3-1.8 2.7-2.6h-3.8l-1.5 1.5-1.5-1.5h-3.4l2.6 2.6-2.3 1.9zm-12.8 0 2.6-2.3 2.7 2.3 1.8-2-2.2-1.8 2.6-2.6h-3.4l-1.5 1.5-1.5-1.5h-3.8l3 2.6-2.2 1.9zm-7.6 0-2.3-2.3-2.6 2.3-2.3-2 2.3-1.8-2.3-2.6h3l2 1.5 1.4-1.5h3.5l-2.7 2.6 2.3 1.9z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M117.2 245.3v7.6h68v-7.6h9.9v-45h-9.9v-7.5h-68v7.5h-9.8v45z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M117.6 193.1v7.6h-9.9v44.2h9.5v7.6h68v-7.6h9.9v-44.6h-9.9v-7.5h-68zm4.5 3h58.2v7.2l2.7 1.6h9v35.5h-9l-2.7 1.9v7.1h-58.2V242l-2.6-1.5h-9.1V205h9l2.7-1.6v-7.5z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M122.5 196.5v6.5l8.7-6.5zm49.1 0 8.3 6.5v-6.5zm-60.5 8.7v6.5l8-6zm72.2 0 8.4 6.5v-6.5zm8.4 28.8-8.4 6h8.4zm-81 0v6h8.4zm11.4 8.6v6.5h9zm57.8 0-8.7 6.5h8.7z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "m170.9 196.5 20.8 15.2v21.9l-20.8 15h-39.3l-20.8-15v-22l20.8-15.4z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "m115.7 235.8-2.3-2.6 2.3-2.6-2.3-2.7 2.3-2.6-2.3-2.7 2.3-2.6-2.3-2.7 2.3-2.6-2.3-2.3 2.3-3h71l2.3 3-2.3 2.3 2.3 2.6-2.3 2.7 2.3 2.6-2.3 2.7 2.3 2.6-2.3 2.7 2.3 2.6-2.3 2.6zm49.1-35.9-3-2.6-2.7 2.3-2.6-2.3-2.6 2.3-2.7-2.3-2.6 2.3-2.7-2.3-2.6 2.3-2.7-2.3-2.6 2.6v45.4l2.6 2.6 2.7-2.2 2.6 2.2 2.7-2.2 2.6 2.2 2.7-2.2 2.6 2.2 2.6-2.2 2.7 2.2 2.6-2.2z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#ffc72c",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m158.8 200.3-2.3-2.3-2.6 2v45.3l2.6 2.3 2.3-2.3zm-10.2 0-2.7-2.3-2.2 2v45.3l2.2 2.3 2.7-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m116 235.8-2.2-2.6 2.3-2.3h70.3l2.2 2.3-2.2 2.6zm70.4-15.5 2.2 2.3-2.2 2.7H116l-2.3-2.7 2.3-2.3zm0-5.6 2.2-2.3-2.2-2.6H116l-2.3 2.6 2.3 2.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#d22630",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m164 200.3-2.2-2.3-2.7 2v45.3l2.7 2.3 2.3-2.3zm-20.3 0L141 198l-2.3 2v45.3l2.3 2.3 2.7-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m116 230.6-2.2-2.7 2.3-2.3h70.3l2.2 2.3-2.2 2.7zm0-10.6-2.2-2.7 2.3-2.2h70.3l2.2 2.2-2.2 2.7z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m153.9 245.7-2.7 1.9-2.3-2.3v-45l2.3-1.9 2.7 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M175 200.7h-47.6v3.8H121v36.3h6v3.7h47.6v-3.7h6.9v-36.3h-6.1v-3.8z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M127.8 201v3.9h-6v35.5h6v3.8h4.5l-9.8-8.4v-26.4l9.8-8.3h-4.9zm42 0 9.8 8.8v26.4l-9.5 7.6h5V240h6v-35.5h-6v-3.8h-5z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#00843d",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "m133 201-9.8 8.8v26l9.9 8.4h36.3l9.8-8.4v-26.4l-9.8-8.3zm.8 1.6h34.8l9.5 7.5v25l-9.5 7.5h-34.8l-9.4-7.5v-24.6z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "m142.9 235.5 1.5.7.4 2-2 1.4 3.1 2.7h-3l-1.9-2-1.9 2h-3l2.6-2.7-1.9-1.5v-1.9l2-.7 1.8 1.5zm10.2 0 1.5.7.4 2-1.9 1.4 3 2.7h-3l-1.9-2-1.9 2h-2.6l2.6-2.7-1.9-1.5v-1.9l2-.7 1.8 1.5zm6.4 0-1.5.7-.4 2 2 1.4-2.7 2.7h2.6l2-2 1.8 2h3l-3-2.7 1.9-1.5v-1.9l-1.9-.7-1.9 1.5zM143 210l1.5-.7.4-1.9-2-1.9 3.1-2.6h-3l-1.9 1.9-1.9-2h-3l2.6 2.7-1.9 1.9v1.9l2 .7 1.8-1.8zm10.2 0 1.5-.7.4-1.9-1.9-1.9 3-2.6h-3l-1.9 1.9-1.9-2h-2.6l2.6 2.7-1.9 1.9v1.9l2 .7 1.8-1.8zm6.4 0-1.5-.7-.4-1.9 2-1.9-2.7-2.6h2.6l2 1.9 1.8-2h3l-3 2.7 1.9 1.9v1.9l-1.9.7-1.9-1.8zm18.2 2.7-1.5 1.5 1.5 1.1v2.3l-2.7-1.9-1.5 1.5h-1.9l-.7-1.5 1.5-1.5-1.5-1.5.7-1.5h2l1.4 1.5 2.7-1.9zm0 8.7-1.5 1.1 1.5 1.5v2l-2.7-2-1.5 1.5h-1.9l-.7-1.5 1.5-1.5-1.5-1.5.7-1.1h2l1.4 1.1 2.7-1.9Zm0 11.3-1.5-1.5 1.5-1.5v-1.9l-2.7 1.9-1.5-1.5h-1.9l-.7 1.5 1.5 1.5-1.5 1.5.7 1.2h2l1.4-1.2 2.7 2zm-53-20 2 1.5-2 1.1v2.3l2.7-1.9 1.5 1.5h1.9l.8-1.5-1.6-1.5 1.6-1.5-.8-1.5H129l-1.5 1.5-2.7-1.9Zm0 8.7 2 1.1-2 1.5v2l2.7-2 1.5 1.5h1.9l.8-1.5-1.6-1.5 1.6-1.5-.8-1.1H129l-1.5 1.1-2.7-1.9Zm0 11.3 2-1.5-2-1.5v-1.9l2.7 1.9 1.5-1.5h1.9l.8 1.5-1.6 1.5 1.6 1.5-.8 1.2H129l-1.5-1.2-2.7 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "m133.8 203-8.7 7.5 2.3 2 1.5-1.6h2.3l.7 1.9-1.5 1.5 1.5 1.5-.7 1.5h-2.7l-1.5-1.1-2.6 1.9v.7l2.6 2 1.5-1.6 2.3.4.8 1.5-1.6 1.5 1.6 1.5-.8 2h-2.3l-1.5-1.6-2.6 2.3v.3l2.6 2.3 1.5-1.5h2.3l.8 1.9-1.6 1.5 1.6 1.5-.8 1.5h-2.3l-1.5-1.1-2.3 1.9 8.7 7.5h2l3-3-2-1.5v-2.3l2.3-.7 2 1.5 1.8-1.5 2 .7.3 2.3-2 1.5 3.1 2.7 2.7-2.7-2-1.5v-2.3l2.3-.7 2 1.5 1.8-1.5 2 .7.3 2.3-1.9 1.5 2.6 2.7 3-2.7-1.8-1.5v-2.3l2.2-.7 2 1.5 1.8-1.5 2 .7.3 2.3-1.9 1.5 3 2.7h2l8.6-7.6-2.3-1.5-1.5 1.5-2.2-.4-.8-1.5 1.5-1.5-1.5-1.5.8-1.5 2.2-.4 1.5 1.5 2.7-2.3v-.3l-2.7-2.3-1.5 1.5H171l-.8-1.9 1.5-1.5-1.5-1.5.8-1.5h2.2l1.5 1.1 2.7-1.9v-.7l-2.7-2-1.5 1.6-2.2-.4-.8-1.5 1.5-1.5-1.5-1.5.8-1.5 2.2-.4 1.5 1.5 2.3-1.9-8.7-7.5h-1.9l-3 2.6 1.9 1.9v2.3l-2.3.7-1.9-1.5-1.9 1.5-1.8-.7-.4-2.3 1.9-1.9-2.7-2.6-3 2.6 1.9 1.9v2.3l-2.3.7-1.9-1.5-1.9 1.5-1.8-.7-.4-2.3 1.9-1.9-2.7-2.6-3 2.6 1.9 1.9v2.3l-2.3.7-1.9-1.5-1.9 1.5-1.9-.7-.3-2.3 1.9-1.9-3-2.6zm-9 18.9v1.8l1-1z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "m141 241.1-1.5 1.2h3zm10.2 0-1.5 1.2h3zm10.2 0-1.5 1.2h3zm-22-37.8 1.6 1.2 1.5-1.5zm10.3 0 1.5 1.2 1.5-1.5zm10.2 0 1.5 1.2 1.5-1.5zm17.8 10.2-1.2.8 1.2.8zm0 8.4-1.2.7 1.2 1.1zm0 8.7-1.2.7 1.2.8zm-53-17.4v1.9l1.2-.8zm0 8.7v1.8l1.2-1zm0 8.3v1.9l1.2-.8z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M160 220v-3h-3.1v-3.5h-11.4v3.4h-3v3h-4.1v5.7h4.1v3h3v3.5H157v-3.8h3v-2.7h4.2V220z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M151.2 214v3.3l-4.9 2.7v2.6h-7.6v-2.3h3.8v-3h3.4v-3.8zm0 17.7v-3.8l5-2.6V223h7.5v2.3h-3.8v3h-3.4v3.4z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "M156.1 222.6V220l-4.9-2.7v-3.8h5.3v3.8h3v3h4.2v2.3zm-17.4 0h7.6v2.7l5 3v3.4h-5.4v-3.8h-3v-2.6h-4.2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M146.7 223v2.3l4.5 2.6v-5Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#00843d",
          d: "m151.2 217.7-4.5 2.6v2.3h4.5Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M155.7 222.6v-2.3l-4.5-2.6v5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#00843d",
          d: "m151.2 228 4.5-2.7V223h-4.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M110 283v9.5h-8.7v8.4h-9V325h9v8.7h8.3v9.1h32.5l5.7 3.8-2.6 1.5h-11.4l-1.1-1.1h11l-3-3h-15.2l6.8 7.1h14l5-3.4 4.8 3h14l6.8-7.1h-15.1l-3 3h10.6l-.8 1.1h-11.7l-2.7-1.9 5.7-3.4h32.5v-9h8.7V325h9v-24h-9v-8.4h-8.3v-9.4h-32.5l-5.7-3.8 2.7-1.5h11.3l1.1 1.1h-11l3.1 3h15.1l-6.8-7.1h-14l-4.9 3-4.9-3h-14l-6.8 7.5h15.1l3-3.4h-10.5l.7-1.1h11.7l2.7 1.9-5.7 3.4z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M160 342.4h32v-9h8.4v-8.7h9v-23.5h-9v-8.7h-8.7v-9h-32.2L146 275h-13.6l-6 6.5h14l2.2-2.3h-10.2l1.5-1.9h11.7l15.2 9.5H189v9h9v8.7h9.2v16.7H198v8.7h-9v9.4h-27.7l-15.1 9h-12.1l-1.5-1.8h10.2l-2.3-2.3h-14l6 6.4h14zm-18.6-3h-27.6V330H105v-8.7h-9v-16.7h9V296h8.3v-8.7H141l15.1-9.4h12.1l1.5 1.9h-10.2l2.3 2.3h14L170 275h-14l-13.2 8.4h-32.5v9H102v8.7h-9v23.5h9v8.7h8.8v9h32.5l13.2 8.3h13.6l6-6.4h-14l-2.2 2.3h10.2l-1.5 1.9h-11.7z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "none",
      d: "m151.2 281.2-9.4 6h-27.6v9.5h-8.7v8.7h-9.1v15.9h9v8.7h8.8v9.4h27.6l9.4 5.7 9.5-5.7h27.6V330h9v-8.7h9.1v-16h-9v-8.6h-9.1v-9.5h-27.6zm0 2.3 9 5.6h26.2v9.5h8.7v8.3h9v12h-9v8.8h-8.7v8.7h-26.5l-8.7 6-9-6H116v-9h-8.7v-8.8h-9.1v-12h9v-8h8.8V289h26.4z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "M186 327.3v9h-25.7l-9 5.7-9.2-5.6h-25.7v-9h-8.7v-8.8h-9.4v-11.3h9v-8.7h8.8v-9h25.7l9-5.4 9.1 5.3h25.7v9h8.7v8.8h9.8v11.3h-9v8.7z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M119.8 324v8.6h14.4l-14.4-9.5zm0-22v-9h14.4l-14.4 9.4Zm62.8 22v8.6h-14.4l14.4-9.5zm0-22v-9h-14.4l14.4 9.4z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m120.2 324.3 12.9 8.3h-12.9zm0-22.7 12.9-8.3h-12.9zm62 22.7-12.8 8.3h12.8zm0-22.7-12.8-8.3h12.8z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M138 310.3v-4.2h-1.5l-7.6-4.5-7.6 4.5h-1.5v4.6h-3.7v5.3h3.7v4.5h1.5l7.6 4.5 7.6-4.5h1.5V316h5.3v-6Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m128.5 301.6 7.6 4.2h-14.4zm7.6 18.5-7.6 4.2-6.8-4.2zm-1.9-9.4v4.5h-8.7v-4.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M137.6 315.6v4.1h-8.7v-4.1zm-9 0v4.1h-8.8v-4.1zm14.3-5v4.6h-8.3v-4.5zm-17.8 0v4.6h-8.7v-4.5Zm12.5-4.5v4.2h-8.7v-3.8zm-9 0v4.2h-8.8v-3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M122.9 311.8v2.3H119v-2.3zm3.4-4.5v2.2h-3.8v-2.2zm9 0v2.2h-3.7v-2.2zm-3.7 4.5v2.3h-3.8v-2.3zm9 0v2.3h-3.8v-2.3zm-5.3 4.5v2.3h-3.7v-2.3zm-9 0v2.3h-3.8v-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "M122.5 312.2H119v1.5h3.4zm3.8-4.5h-3.8v1.5h3.8zm8.7 0h-3.4v1.5h3.4zm-3.8 4.5h-2.7v1.5h3zm9 0h-3v1.5h3zm-5.2 4.5h-3.4v1.5h3.4zm-9.1 0h-3v1.5h3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M164.4 310.3v-4.2h1.6l7.5-4.5 7.6 4.5h1.9v4.6h3.4v5.3h-3.8v4.5h-1.1l-7.6 4.5-7.6-4.5h-1.5V316h-5.3v-6Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "m173.9 301.6-7.6 4.2h14zm-7.6 18.5 6.8 4.2 7.2-4.2zm1.5-9.4v4.5h8.7v-4.5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "M164.8 315.6v4.1h8.7v-4.1zm9 0v4.1h8.8v-4.1zm-14.3-5v4.6h8.7v-4.5zm17.8 0v4.6h8.7v-4.5Zm-12.5-4.5v4.2h8.7v-3.8zm9 0v4.2h8.8v-3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M180 311.8v2.3h3.7v-2.3zm-3.8-4.5v2.2h3.7v-2.2zm-9.1 0v2.2h3.8v-2.2zm3.8 4.5v2.3h3.7v-2.3zm-9.1 0v2.3h3.8v-2.3zm5.3 4.5v2.3h3.8v-2.3zm9 0v2.3h3.8v-2.3z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "M180 312.2h3.3v1.5H180zm-3.5-4.5h3v1.5h-3zm-9 0h3.4v1.5h-3.4zm3.7 4.5h3v1.5h-3zm-9 0h3v1.5h-2.6Zm5.3 4.5h3.4v1.5h-3.4zm9 0h3v1.5h-3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M160.3 302.7v4.6h-1.5l-7.6 4.9-7.5-5H142v-4.5h-4.5v-4.9h4.5v-4.5h1.6l7.5-5 7.6 5h1.5v4.5h4.5v4.6Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "m151.2 311.8 6.8-4.5h-13.6zM158 293l-6.8-3.8-6.8 3.8z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M160 297.8v-4.5h-8.4v4.5zm-8.8 0v-4.5h-8.7v4.5zm13.2 4.6v-3.8h-8.7v3.8zm-9 0v-3.8h-8v3.8zm-8.7 0v-3.8H138v3.8zm13.2 4.5v-4.2h-8.3v4.2zm-8.7 0v-4.2h-8.7v4.2z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M148.6 294.4v2.3h-3.8v-1.9Zm9 0v2.3H154v-1.9ZM144 299v2.6h-3.8v-3Zm9.1 0v2.6h-3.8v-3Zm9 0v2.6h-3.7v-3Zm-13.5 4.9v2.2h-3.8V304zm9 0v2.2H154V304z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "M148.2 294.8h-3v1.5h3zm9 0h-3v1.5h3zm-13.5 4.5h-3v2h3Zm9 0h-3v2h3zm9.1 0h-3v2h3zm-13.6 4.6h-3v1.9h3zm9 0h-3v1.9h3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx240("path", {
          d: "M160.3 328v5h-1.5l-7.6 4.5-7.5-4.5H142v-5h-4.5v-4.9h4.5v-4.5h1.6l7.5-4.9 7.6 5h1.5v4.4h4.5v5z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#ffc72c",
          d: "m151.2 337.1 6.8-4.1h-13.6zm6.8-18.9-6.8-3.7-6.8 3.7z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#d22630",
          d: "M160 323.1V319h-8.4v4.1zm-8.8 0V319h-8.7v4.1zm13.2 4.6v-4.2h-8.7v4.2zm-9 0v-4.2h-8v4.2zm-8.7 0v-4.2H138v4.2zm13.2 4.9v-4.5h-8.3v4.5Zm-8.7 0v-4.5h-8.7v4.5Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          d: "M148.6 319.7v2.7h-3.8v-2.7zm9 0v2.7H154v-2.7ZM144 325v2.3h-3.8V325Zm9.1 0v2.3h-3.8V325Zm9 0v2.3h-3.7V325Zm-13.5 3.8v2.3h-3.8v-2.3Zm9 0v2.3H154v-2.3Z"
        }),
        /* @__PURE__ */ jsx240("path", {
          fill: "#fff",
          d: "M148.2 320.1h-3v2h3zm9 0h-3v2h3zm-13.5 5h-3v1.5h3Zm9 0h-3v1.5h3zm9.1 0h-3v1.5h3zm-13.6 4.5h-3v1.5h3zm9 0h-3v1.5h3z"
        })
      ]
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "m102 383.6 34-18.1h30.3l34 18.1v29.9l-34 17.7h-30.2l-34-17.7z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#00843d",
      d: "m136 365.9-33.6 17.7v29.5l33.7 18.1h30.2l33.7-18.1v-29.5L166.7 366zm.5 2.2h29.8l31.8 17v26.5l-31.8 17h-29.5l-31.7-17V385z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M151.2 398.4v30.2h15.1l31.4-17v-12.9h-46.5v-30.2h-15.1l-31.4 16.6v13.3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "M151.2 398.4v30.2h-15.1l-31.4-17v-12.9h46.5v-30.2h15.1l31.4 16.6v13.3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M153.9 426.7V418l-2.7 2-2.6-2v8.7h-9.1l6-4.5v-6l-9-5.7h-6v-24.2h5.6l9-5.7v-6L140 370h9v8.7l2.7-1.5 2.6 1.5v-8.3h9.1l-6 4.5v6l9 5.7h6.5v24.2h-6.5l-9 5.7v6l6 4.6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M154.2 370.4v9l-3-1.8v2.6l14 8.7h4.5v9.5h2.3V387h-6l-9.5-6v-6.8l5.3-3.8zm-23.4 28.3v11.4h5.3l9.4 6v6.5l-5.3 3.7h7.6v-9l3 1.8v-2.6l-14-8.7h-4.5v-9z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "m140.6 370.4 5.3 3.8v6.8l-9.4 5.6h-5.7V398h1.9v-8.7h4.5l14-8.7V378l-3 1.8v-9.4zm29.1 28.3v9.1h-4.5l-14 8.7v2.6l3-1.8v9h7.6l-5.3-3.7v-6.9l9.5-6h6v-11.3Z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M133 407.4h4.2l14 9.1 14-9h4.2v-18.2h-4.2l-14-8.7-14 8.7h-3.8z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M160.7 402.9h3v-1.5h-2.3v-2.7h5v6.5h-4.6v4.5h-9.5v-6.4h4.2v2.6H155v1.2h3.8v-2.3l-17.4-10.6h-3v1.1h2.2v2.7h-4.5v-6.4h4.5V387h9.5v6.4h-3.8v-2.6h1.1v-1.1h-3.7v2.2zm-1.6-11v-2.2H155v1.1h1.5v2.6h-4.2V387h9.5v4.6h4.5v6.4h-4.9v-2.7h2.3v-1.1h-3l-17 10.2v2.3h3.7v-1.2H146V403h4.2v6.4h-9.5v-4.5h-4.5v-6.4h4.9v2.6h-2.3v1.5h3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "M159.5 404.4v3H155v-1.9h1.5v-1.8h-3.4v5.6h8.7v-4.5h4.5V399h-3.7v2h1.8v2.2H161l-17.7-11.4v-2.6h4.9v1.9h-1.5v1.9h3.8v-5.7h-9.1v4.5h-4.6v5.7h3.8v-1.9h-1.9v-1.9h3.4zm1.2-10.6h3.7v2h-2.6v1.8h4.5V392h-4.5v-4.5h-8.7v5.7h3.4v-2H155v-1.8h5v3l-17.9 11h-3.4V401h2.3v-1.9h-3.8v5.7h4.2v4.5h8.7v-5.6h-3.4v1.8h1.5v2h-5v-3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#383739",
      d: "M190.5 399.9v9.4h-3.8V406h-4.1v3.4h-4.2V400h3.8v3.4h4.2V400zm-14.3 12.4v9.5h-3.8v-3.4h-4.2v3.4h-3.8v-9.5h3.8v3.4h3.8v-3.4zm14.3-15v-9.9h-3.8v3.4h-4.1v-3.4h-4.2v9.5h3.8v-3.5h4.2v3.8zm-78.6 2.6v9.4h3.8V406h4.1v3.4h4.2V400h-3.8v3.4h-4.1V400zm0-3v-9.5h3.8v3.4h4.1v-3.4h4.2v9.5h-3.8v-3.5h-4.1v3.8zm64.3-12.5v-9.5h-3.8v3.4h-4.2V375h-3.8v9.5h3.8V381h3.8v3.8zm-50 28v9.4h3.8v-3.4h4.2v3.4h4.2v-9.5h-3.8v3.4h-4.2v-3.4zm0-28v-9.5h3.8v3.4h4.2V375h4.2v9.5h-3.8V381h-4.2v3.8zm52.2-6.4v7.1h13.3zM124 419v-7.5h-13.2zm0-41.5v7.5h-13.2zm54.4 41.5v-7.5h13.3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#d22630",
      d: "M186.7 405.5v3.8h3.4v-9h-3.4v3.4h-4.5v-3.4h-3.8v8.6h3.8v-3.4zM172.4 418v3.8h3.4v-9h-3.4v3.3h-4.6v-3.4h-3.4v8.7h3.4V418zm14.3-26.8v-3.4h3.4v8.7h-3.4V393h-4.5v3.8h-3.8v-9.1h3.8v3.4zm-71 14.3v3.8h-3.4v-9h3.4v3.4h4.5v-3.4h3.8v8.6h-3.8v-3.4zm0-14.3v-3.4h-3.4v8.7h3.4V393h4.5v3.8h3.8v-9.1h-3.8v3.4zm56.7-12.5v-3.4h3.4v8.7h-3.4v-3.4h-4.6v3.8h-3.4v-9h3.4v3.3zM130 418v3.8h-3.4v-9h3.4v3.3h4.6v-3.4h3.8v8.7h-3.8V418zm0-39.3v-3.4h-3.4v8.7h3.4v-3.4h4.6v3.8h3.8v-9h-3.8v3.3z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M178.8 378.3v6.5h11.3zm-66.9 34 11.3 6v-6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#fff",
      d: "m123.6 378.3-11.3 6.5h11.3zm55.2 34v6l11.3-6z"
    }),
    /* @__PURE__ */ jsx240("path", {
      fill: "#ffc72c",
      d: "M205.6 424.8c-.7 2.7-3 4.6-3.4 7.6-1-3-1.8-5.7-1-8.7 0-2.3 2.2-3.8 2.6-6.4 1.8 1.8 2.2 4.5 1.8 7.5m.4 11.4a17.8 17.8 0 0 1-6.8 5.6c.4-2.2-.7-3.8-1.9-5.6-1.1-2-1.9-3.8-.7-6.5a14.4 14.4 0 0 0 1.9 3.4c1.1 1.5 2.2 3 2.2 5.3 1.5-1.1 2-2.6 2.7-4.1a12.9 12.9 0 0 1 5.3-5.3c-.8 2.6-1.2 4.9-2.7 7.2m-9.8 7.5.4 3.8 4.1-3c2-2 4.2-2.7 5.7-5a9.5 9.4 0 0 1-3.8 7.2l-7.5 5c0-2.7-.8-5-2-7.6a6.8 6.8 0 0 1 2-6c0 1.8.3 3.7 1.1 5.2zm-5.7 8.7-3 5.3c2.6-.8 5-2.3 7.6-3.8 2.6-1.5 5.6-2.2 8.3-4.5-1.2 4.9-4.6 7.5-9 9-3.1.8-6.1.4-10 2a26.5 26.5 0 0 1 2.7-7.6l2.7-5.3c.7 1.5 1.1 3 .7 5zm-9.8 7.2a12.1 12 0 0 1-3.8 3.8c3.8 0 6.8-2 10.6-2.3 2.3 0 4.5.8 6.8.4-2.6 1.9-5.7 3.8-9 3.8-4.2.7-8.4 0-13 0 2.3-1.6 3.5-3.8 4.6-5.7 2-3 3.8-5 7.2-5.3-1.5 1.5-2.3 3.8-3.4 5.3m-13.2 6c6.4 1.2 12.8 2.7 19.6 2.7a30.3 30.3 0 0 1-22.3.4c-3.8-1.2-7.2-2.3-10.2-2-4.1 0-9.8 2.3-15.9 8.4l-2.2-1.9c8.7-7.6 20-9.5 31-7.6"
    })
  ]
});
var Tm_default = SvgTm;

// src/country-flag-icons/generated/Tn.tsx
import { jsx as jsx241, jsxs as jsxs234 } from "react/jsx-runtime";
var SvgTn = (props) => /* @__PURE__ */ jsxs234("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx241("path", {
      fill: "#e70013",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx241("path", {
      fill: "#fff",
      d: "M320 119.2a1 1 0 0 0-1 240.3 1 1 0 0 0 1-240.3M392 293a90 90 0 1 1 0-107 72 72 0 1 0 0 107m-4.7-21.7-37.4-12.1-23.1 31.8v-39.3l-37.4-12.2 37.4-12.2V188l23.1 31.8 37.4-12.1-23.1 31.8z"
    })
  ]
});
var Tn_default = SvgTn;

// src/country-flag-icons/generated/To.tsx
import { jsx as jsx242, jsxs as jsxs235 } from "react/jsx-runtime";
var SvgTo = (props) => /* @__PURE__ */ jsx242("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs235("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx242("path", {
        fill: "#c10000",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx242("path", {
        fill: "#fff",
        d: "M0 0h250v200.3H0z"
      }),
      /* @__PURE__ */ jsxs235("g", {
        fill: "#c10000",
        children: [
          /* @__PURE__ */ jsx242("path", {
            d: "M102.8 31.2h39.9v139.6h-39.8z"
          }),
          /* @__PURE__ */ jsx242("path", {
            d: "M192.6 81v40H53V81z"
          })
        ]
      })
    ]
  })
});
var To_default = SvgTo;

// src/country-flag-icons/generated/Tr.tsx
import { jsx as jsx243, jsxs as jsxs236 } from "react/jsx-runtime";
var SvgTr = (props) => /* @__PURE__ */ jsx243("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs236("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx243("path", {
        fill: "#e30a17",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx243("path", {
        fill: "#fff",
        d: "M407 247.5c0 66.2-54.6 119.9-122 119.9s-122-53.7-122-120 54.6-119.8 122-119.8 122 53.7 122 119.9"
      }),
      /* @__PURE__ */ jsx243("path", {
        fill: "#e30a17",
        d: "M413 247.5c0 53-43.6 95.9-97.5 95.9s-97.6-43-97.6-96 43.7-95.8 97.6-95.8 97.6 42.9 97.6 95.9z"
      }),
      /* @__PURE__ */ jsx243("path", {
        fill: "#fff",
        d: "m430.7 191.5-1 44.3-41.3 11.2 40.8 14.5-1 40.7 26.5-31.8 40.2 14-23.2-34.1 28.3-33.9-43.5 12-25.8-37z"
      })
    ]
  })
});
var Tr_default = SvgTr;

// src/country-flag-icons/generated/Tt.tsx
import { jsx as jsx244, jsxs as jsxs237 } from "react/jsx-runtime";
var SvgTt = (props) => /* @__PURE__ */ jsxs237("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx244("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx244("path", {
      fill: "#e00000",
      fillRule: "evenodd",
      d: "M463.7 480 0 1v478.8zM176.3 0 640 479V.2z"
    }),
    /* @__PURE__ */ jsx244("path", {
      fill: "#000001",
      fillRule: "evenodd",
      d: "M27.7.2h118.6l468.2 479.3H492.2z"
    })
  ]
});
var Tt_default = SvgTt;

// src/country-flag-icons/generated/Tv.tsx
import { jsx as jsx245, jsxs as jsxs238 } from "react/jsx-runtime";
var SvgTv = (props) => /* @__PURE__ */ jsxs238("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx245("path", {
      fill: "#009fca",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx245("path", {
      fill: "#fff40d",
      fillRule: "evenodd",
      d: "M593.3 122.7H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zm-69.2 196.8h27.6l-22.3 15.2 8.5 24.7-22.3-15.3-22.3 15.3 8.6-24.7-22.3-15.2H507l8.5-24.7zm69.2-44.6H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zM295.8 417.7h27.6L301 432.8l8.6 24.6-22.3-15.2-22.3 15.2 8.6-24.6-22.4-15.3h27.6l8.5-24.6zm62.6-76.5h-27.6l22.3-15.3-8.5-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.3 15.3h-27.5l-8.5 24.6zm81.3-112.5H412l22.3-15.2-8.5-24.7 22.3 15.3 22.3-15.3-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm68.3-23.3h-27.6l22.4-15.3-8.6-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.4 15.3H525l-8.5 24.6zM439.7 400H412l22.3-15.2L426 360l22.3 15.2 22.3-15.2-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm-81.3 19.9h-27.6l22.3-15.2-8.5-24.7 22.3 15.2 22.3-15.2-8.6 24.6L403 420h-27.5l-8.5 24.7z"
    }),
    /* @__PURE__ */ jsx245("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx245("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx245("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx245("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx245("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Tv_default = SvgTv;

// src/country-flag-icons/generated/Tw.tsx
import { jsx as jsx246, jsxs as jsxs239 } from "react/jsx-runtime";
var SvgTw = (props) => /* @__PURE__ */ jsxs239("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx246("clipPath", {
      id: "tw_svg__a",
      children: /* @__PURE__ */ jsx246("path", {
        d: "M0 0h640v480H0z"
      })
    }),
    /* @__PURE__ */ jsxs239("g", {
      clipPath: "url(#tw_svg__a)",
      children: [
        /* @__PURE__ */ jsx246("path", {
          fill: "red",
          d: "M0 0h720v480H0z"
        }),
        /* @__PURE__ */ jsx246("path", {
          fill: "#000095",
          d: "M0 0h360v240H0z"
        }),
        /* @__PURE__ */ jsxs239("g", {
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx246("path", {
              d: "m154 126.9-2.5 9.6 9.4 2.6-1.8-7.1zm46.9 5.1-1.8 7.1 9.4-2.6-2.5-9.6zm-41.8-24-5.1 5.1 1.9 6.9z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m155.9 120-1.9 6.9 5.1 5.1z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m154 113.1-6.9 6.9 6.9 6.9 1.9-6.9zm14 27.8 5.1 5.1 6.9-1.9zm18.9 5.1 9.6 2.5 2.6-9.4-7.1 1.8z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m192 140.9 7.1-1.8 1.8-7.1zm-31.1-1.8 2.6 9.4 9.6-2.5-5.1-5.1zm19.1 5 6.9 1.9 5.1-5.1z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m173.1 146 6.9 6.9 6.9-6.9-6.9-1.9zm-12.2-45.1-9.4 2.6 2.5 9.6 5.1-5.1zm-1.8 31.1 1.8 7.1 7.1 1.8zm45-12 1.9-6.9-5.1-5.1z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m168 99.1-7.1 1.8-1.8 7.1zm32.9 8.9-1.8-7.1-7.1-1.8zm5.1 18.9 6.9-6.9-6.9-6.9-1.9 6.9z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m200.9 108-8.9-8.9-12-3.2-12 3.2-8.9 8.9-3.2 12 3.2 12 8.9 8.9 12 3.2 12-3.2 8.9-8.9 3.2-12z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m200.9 132 5.1-5.1-1.9-6.9zm5.1-18.9 2.5-9.6-9.4-2.6 1.8 7.1zm-6.9-12.2-2.6-9.4-9.6 2.5 5.1 5.1zm-26-6.9-9.6-2.5-2.6 9.4 7.1-1.8zm6.9 1.9-6.9-1.9-5.1 5.1z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m186.9 94-6.9-6.9-6.9 6.9 6.9 1.9z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m192 99.1-5.1-5.1-6.9 1.9zM173.1 146l-9.6 2.5 4.5 16.6 12-12.2zm-5.1 19.1 12 44.9 12-44.9-12-12.2zm-7.1-26-9.4-2.6-4.4 16.4 16.4-4.4z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m147.1 152.9-12 45.1 32.9-32.9-4.5-16.6zm-12-20.9L102 165.1l45.1-12.2 4.4-16.4z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m154 126.9-6.9-6.9-12 12 16.4 4.5zm0-13.8-2.5-9.6-16.4 4.5 12 12z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "M135.1 108 90 120l45.1 12 12-12zm90 24-16.6 4.5 4.4 16.4 45.1 12.2z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m199.1 139.1-2.6 9.4 16.4 4.4-4.4-16.4zm-12.2 6.9-6.9 6.9 12 12.2 4.5-16.6zm19.1-19.1 2.5 9.6 16.6-4.5-12.2-12z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m192 165.1 33.1 32.9-12.2-45.1-16.4-4.4zm7.1-64.2 9.4 2.6 4.4-16.4-16.4 4.4z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "M225.1 108 258 75.1l-45.1 12-4.4 16.4zm-12.2-20.9L225.1 42 192 75.1l4.5 16.4zm12.2 44.9 44.9-12-44.9-12-12.2 12z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m206 113.1 6.9 6.9 12.2-12-16.6-4.5zm-38-38L135.1 42l12 45.1 16.4 4.4z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m160.9 100.9 2.6-9.4-16.4-4.4 4.4 16.4z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m147.1 87.1-45.1-12 33.1 32.9 16.4-4.5zm39.8 6.9 9.6-2.5-4.5-16.4-12 12z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "M192 75.1 180 30l-12 45.1 12 12z"
            }),
            /* @__PURE__ */ jsx246("path", {
              d: "m173.1 94 6.9-6.9-12-12-4.5 16.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx246("circle", {
          cx: 180,
          cy: 120,
          r: 51.1,
          fill: "#000095"
        }),
        /* @__PURE__ */ jsx246("circle", {
          cx: 180,
          cy: 120,
          r: 45.1,
          fill: "#fff"
        })
      ]
    })
  ]
});
var Tw_default = SvgTw;

// src/country-flag-icons/generated/Tz.tsx
import { jsx as jsx247, jsxs as jsxs240 } from "react/jsx-runtime";
var SvgTz = (props) => /* @__PURE__ */ jsxs240("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx247("defs", {
      children: /* @__PURE__ */ jsx247("clipPath", {
        id: "tz_svg__a",
        children: /* @__PURE__ */ jsx247("path", {
          fillOpacity: 0.7,
          d: "M10 0h160v120H10z"
        })
      })
    }),
    /* @__PURE__ */ jsxs240("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#tz_svg__a)",
      transform: "matrix(4 0 0 4 -40 0)",
      children: [
        /* @__PURE__ */ jsx247("path", {
          fill: "#09f",
          d: "M0 0h180v120H0z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#090",
          d: "M0 0h180L0 120z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#000001",
          d: "M0 120h40l140-95V0h-40L0 95z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#ff0",
          d: "M0 91.5 137.2 0h13.5L0 100.5zM29.3 120 180 19.5v9L42.8 120z"
        })
      ]
    })
  ]
});
var Tz_default = SvgTz;

// src/country-flag-icons/generated/Ua.tsx
import { jsx as jsx248, jsxs as jsxs241 } from "react/jsx-runtime";
var SvgUa = (props) => /* @__PURE__ */ jsx248("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs241("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx248("path", {
        fill: "gold",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx248("path", {
        fill: "#0057b8",
        d: "M0 0h640v240H0z"
      })
    ]
  })
});
var Ua_default = SvgUa;

// src/country-flag-icons/generated/Ug.tsx
import { jsx as jsx249, jsxs as jsxs242 } from "react/jsx-runtime";
var SvgUg = (props) => /* @__PURE__ */ jsxs242("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx249("defs", {
      children: /* @__PURE__ */ jsx249("clipPath", {
        id: "ug_svg__a",
        children: /* @__PURE__ */ jsx249("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs242("g", {
      clipPath: "url(#ug_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx249("path", {
          fill: "#ffe700",
          fillRule: "evenodd",
          d: "M-128 341.4h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#000001",
          fillRule: "evenodd",
          d: "M-128 256h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#de3908",
          fillRule: "evenodd",
          d: "M-128 170.7h768V256h-768z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#ffe700",
          fillRule: "evenodd",
          d: "M-128 85.4h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#000001",
          fillRule: "evenodd",
          d: "M-128 0h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#fffdff",
          fillRule: "evenodd",
          stroke: "#000",
          d: "M335.7 256a79.7 79.7 0 1 1-159.4 0 79.7 79.7 0 0 1 159.4 0z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          d: "m242 194.9-5.2-9.5c2-2 5.3-3.6 10.7-3.6l-.6 10.5z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#ffe700",
          fillRule: "evenodd",
          stroke: "#000",
          d: "m247 192.3.7-10.5s10.7-.6 16.5 6.4l-5.7 8.2z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          d: "m258.6 196.3 5.3-8.2c3.5 3.7 5 6.3 5.5 10.3.1.1-8.3 2.1-8.3 2z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M244.6 331.1s9.9-11.3 29.1-8.9c-2.9-4.7-12.3-4.1-12.3-4.1s-2.8-22-.6-23.2 12 .1 12 .1c1.2 0 3.4-3.4 1.6-5.6-1.7-2.2-6.8-10.5-4.7-12.2 2.1-1.6 13.4 1 13.4 1l-32-41s-3.3-15.5 3.3-23c7.9-6.5 7-13.6 6.8-13.5-1.1-7.2-12-12.3-19.4-5.7-4.3 5.2-1.4 9.2-1.4 9.2s-11.5 3.1-11.9 5.1c-.5 2 12.9-.3 12.9-.3l-1.3 9.1s-26 23.6-6 44l.6-.8s7 8.6 14.3 10.5c7 7 6.3 6 6.3 6s1.3 11.1 0 13.3c-1.7-.5-19.3-1.2-21.9-.2-2.4.8-11.4.3-9.2 15.1l3.3-7.5s-.3 5.3 1.9 7.2c-.4-5.6 2.1-9.4 2.1-9.4s.4 6.2 1.8 7c1.4 1 1.4-10 9-9 7.4.9 12.9.6 12.9.6s2.5 21.4 1.7 23.4c-5.4-1.3-18.4.5-19.2 3.8 7.6-.5 11.1.4 11.1.4s-6.1 5.5-4.2 8.6"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#9ca69c",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M247.6 214.8s-18.9 20.8-10.7 36.7c.4-2.2.2-3.6.5-3.5-.5-.3 2.3 1.9 2.1 1.5 0-1.2-.8-3.7-.8-3.7l2.5.7-1.5-2.8 3.7.4s-1.3-3.4-.9-3.4l3 .2c-5.4-9.6-.3-17.6 2.1-26.2z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#9ca69c",
          d: "M254.2 196.9s1 7.2-3 9.2c-.5.5-3 1.3-2.6 2.8.4 2 1.5 1.6 3 1.2 4.1-.7 8.9-9.4 2.6-13.2z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M247.2 203a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          d: "M241.1 209c-1 .9-6.2 6.3-1 8.3 5.3-1.4 3.8-2.4 5-3.6 0-2.5-2.6-3.1-4-4.6z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#9ca69c",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M252.6 260.5c-.3 1.2-1.5 5.6.1 9 4.6-2 6.7-1.4 8.2-.4-3.7-3-5.2-4.3-8.3-8.6"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "m260.4 281.1.2 10.2s3.6.6 5.2 0 0-7-5.4-10.2"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#000",
          d: "M286 282.4s-6.5-15.8-23.2-19.8-14.5-21.8-13.2-22.9c.8-1.5 1.3-3.9 6.1-1.6s27 13.4 30.2 14 .4 30.7.2 30.3z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M270.2 262.5c-.3.2 22.3 13.4 15.5 24.7 6.4-4.3 4.4-11.7 4.4-11.7s5.2 13.7-7.6 20.4c1.4 1.2 2.3 1 2.3 1l-2.2 2.1s-1 1.7 7.6-2.5c-2.3 1.9-2.5 3.3-2.5 3.3s.6 1.8 6.2-3.1c-4.5 4.9-5.5 7.4-5.5 7.3 12.3-1 39-41-8.4-52.7l2.1 2.2z"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M271.2 258.6c3 2.2 4.1 3 4.5 4-2.8-.6-5.3-.4-5.3-.4s-6.1-5.8-7.2-6.3c-.8 0-5.6-3-5.6-3-2.3-1.2-4.5-9.3 4.2-7a93 93 0 0 0 10.3 4.6l10.7 3.4 6.2 6.9s-11-5.4-12.4-5.5c3 2.4 4.7 5.8 4.7 5.8-3.5-1-6.5-2-10.1-2.5"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "none",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeWidth: 0.9,
          d: "M228.4 209.9s10.5-2.6 11.8-2.2"
        }),
        /* @__PURE__ */ jsx249("path", {
          fill: "#de3908",
          fillRule: "evenodd",
          d: "M-128 426.7h768V512h-768z"
        })
      ]
    })
  ]
});
var Ug_default = SvgUg;

// src/country-flag-icons/generated/Um.tsx
import { jsx as jsx250, jsxs as jsxs243 } from "react/jsx-runtime";
var SvgUm = (props) => /* @__PURE__ */ jsxs243("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx250("path", {
      fill: "#bd3d44",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx250("path", {
      stroke: "#fff",
      strokeWidth: 37,
      d: "M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
    }),
    /* @__PURE__ */ jsx250("path", {
      fill: "#192f5d",
      d: "M0 0h364.8v258.5H0"
    }),
    /* @__PURE__ */ jsx250("marker", {
      id: "um_svg__a",
      markerHeight: 30,
      markerWidth: 30,
      children: /* @__PURE__ */ jsx250("path", {
        fill: "#fff",
        d: "m14 0 9 27L0 10h28L5 27z"
      })
    }),
    /* @__PURE__ */ jsx250("path", {
      fill: "none",
      markerMid: "url(#um_svg__a)",
      d: "m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
    })
  ]
});
var Um_default = SvgUm;

// src/country-flag-icons/generated/Us.tsx
import { jsx as jsx251, jsxs as jsxs244 } from "react/jsx-runtime";
var SvgUs = (props) => /* @__PURE__ */ jsxs244("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx251("path", {
      fill: "#bd3d44",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx251("path", {
      stroke: "#fff",
      strokeWidth: 37,
      d: "M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
    }),
    /* @__PURE__ */ jsx251("path", {
      fill: "#192f5d",
      d: "M0 0h364.8v258.5H0"
    }),
    /* @__PURE__ */ jsx251("marker", {
      id: "us_svg__a",
      markerHeight: 30,
      markerWidth: 30,
      children: /* @__PURE__ */ jsx251("path", {
        fill: "#fff",
        d: "m14 0 9 27L0 10h28L5 27z"
      })
    }),
    /* @__PURE__ */ jsx251("path", {
      fill: "none",
      markerMid: "url(#us_svg__a)",
      d: "m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
    })
  ]
});
var Us_default = SvgUs;

// src/country-flag-icons/generated/Uy.tsx
import { jsx as jsx252, jsxs as jsxs245 } from "react/jsx-runtime";
var SvgUy = (props) => /* @__PURE__ */ jsxs245("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx252("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx252("path", {
      fill: "#0038a8",
      d: "M266 53.3h374v53.4H266zm0 106.7h374v53.3H266zM0 266.7h640V320H0zm0 106.6h640v53.4H0z"
    }),
    /* @__PURE__ */ jsxs245("g", {
      fill: "#fcd116",
      stroke: "#000",
      strokeMiterlimit: 20,
      strokeWidth: 0.6,
      transform: "translate(133.3 133.3) scale(2.93333)",
      children: [
        /* @__PURE__ */ jsxs245("g", {
          id: "uy_svg__c",
          children: [
            /* @__PURE__ */ jsxs245("g", {
              id: "uy_svg__b",
              children: [
                /* @__PURE__ */ jsxs245("g", {
                  id: "uy_svg__a",
                  children: [
                    /* @__PURE__ */ jsx252("path", {
                      strokeLinecap: "square",
                      d: "m-2 8.9 3 4.5c-12.4 9-4.9 14.2-13.6 17 5.4-5.2-.9-5.7 3.7-16.8"
                    }),
                    /* @__PURE__ */ jsx252("path", {
                      fill: "none",
                      d: "M-4.2 10.2c-6.8 11.2-2.4 17.4-8.4 20.3"
                    }),
                    /* @__PURE__ */ jsx252("path", {
                      d: "M0 0h6L0 33-6 0h6v33"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx252("use", {
                  xlinkHref: "#uy_svg__a",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(45)"
                })
              ]
            }),
            /* @__PURE__ */ jsx252("use", {
              xlinkHref: "#uy_svg__b",
              width: "100%",
              height: "100%",
              transform: "rotate(90)"
            })
          ]
        }),
        /* @__PURE__ */ jsx252("use", {
          xlinkHref: "#uy_svg__c",
          width: "100%",
          height: "100%",
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsx252("circle", {
          r: 11
        })
      ]
    }),
    /* @__PURE__ */ jsxs245("g", {
      transform: "translate(133.3 133.3) scale(.29333)",
      children: [
        /* @__PURE__ */ jsxs245("g", {
          id: "uy_svg__d",
          children: [
            /* @__PURE__ */ jsx252("path", {
              d: "M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36"
            }),
            /* @__PURE__ */ jsx252("path", {
              d: "M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10"
            }),
            /* @__PURE__ */ jsx252("path", {
              d: "M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8"
            })
          ]
        }),
        /* @__PURE__ */ jsx252("use", {
          xlinkHref: "#uy_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsx252("path", {
          d: "M0 76c-5 0-18 3 0 3s5-3 0-3"
        })
      ]
    })
  ]
});
var Uy_default = SvgUy;

// src/country-flag-icons/generated/Uz.tsx
import { jsx as jsx253, jsxs as jsxs246 } from "react/jsx-runtime";
var SvgUz = (props) => /* @__PURE__ */ jsxs246("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx253("path", {
      fill: "#1eb53a",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#0099b5",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#ce1126",
      d: "M0 153.6h640v172.8H0z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#fff",
      d: "M0 163.2h640v153.6H0z"
    }),
    /* @__PURE__ */ jsx253("circle", {
      cx: 134.4,
      cy: 76.8,
      r: 57.6,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx253("circle", {
      cx: 153.6,
      cy: 76.8,
      r: 57.6,
      fill: "#0099b5"
    }),
    /* @__PURE__ */ jsxs246("g", {
      fill: "#fff",
      transform: "matrix(1.92 0 0 1.92 261.1 122.9)",
      children: [
        /* @__PURE__ */ jsxs246("g", {
          id: "uz_svg__e",
          children: [
            /* @__PURE__ */ jsxs246("g", {
              id: "uz_svg__d",
              children: [
                /* @__PURE__ */ jsxs246("g", {
                  id: "uz_svg__c",
                  children: [
                    /* @__PURE__ */ jsxs246("g", {
                      id: "uz_svg__b",
                      children: [
                        /* @__PURE__ */ jsx253("path", {
                          id: "uz_svg__a",
                          d: "M0-6-1.9-.3 1 .7"
                        }),
                        /* @__PURE__ */ jsx253("use", {
                          xlinkHref: "#uz_svg__a",
                          width: "100%",
                          height: "100%",
                          transform: "scale(-1 1)"
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx253("use", {
                      xlinkHref: "#uz_svg__b",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(72)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx253("use", {
                  xlinkHref: "#uz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(-72)"
                }),
                /* @__PURE__ */ jsx253("use", {
                  xlinkHref: "#uz_svg__c",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(144)"
                })
              ]
            }),
            /* @__PURE__ */ jsx253("use", {
              xlinkHref: "#uz_svg__d",
              width: "100%",
              height: "100%",
              y: -24
            }),
            /* @__PURE__ */ jsx253("use", {
              xlinkHref: "#uz_svg__d",
              width: "100%",
              height: "100%",
              y: -48
            })
          ]
        }),
        /* @__PURE__ */ jsx253("use", {
          xlinkHref: "#uz_svg__e",
          width: "100%",
          height: "100%",
          x: 24
        }),
        /* @__PURE__ */ jsx253("use", {
          xlinkHref: "#uz_svg__e",
          width: "100%",
          height: "100%",
          x: 48
        }),
        /* @__PURE__ */ jsx253("use", {
          xlinkHref: "#uz_svg__d",
          width: "100%",
          height: "100%",
          x: -48
        }),
        /* @__PURE__ */ jsx253("use", {
          xlinkHref: "#uz_svg__d",
          width: "100%",
          height: "100%",
          x: -24
        }),
        /* @__PURE__ */ jsx253("use", {
          xlinkHref: "#uz_svg__d",
          width: "100%",
          height: "100%",
          x: -24,
          y: -24
        })
      ]
    })
  ]
});
var Uz_default = SvgUz;

// src/country-flag-icons/generated/Va.tsx
import { jsx as jsx254, jsxs as jsxs247 } from "react/jsx-runtime";
var SvgVa = (props) => /* @__PURE__ */ jsxs247("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx254("path", {
      fill: "#fff",
      d: "M320 0h320v480H320z"
    }),
    /* @__PURE__ */ jsx254("path", {
      fill: "#ffe000",
      d: "M0 0h320v480H0z"
    }),
    /* @__PURE__ */ jsxs247("g", {
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 3.2,
      children: [
        /* @__PURE__ */ jsxs247("g", {
          fill: "#ce9d09",
          strokeLinecap: "round",
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsxs247("g", {
              id: "va_svg__a",
              children: [
                /* @__PURE__ */ jsx254("path", {
                  fill: "#fff",
                  d: "m1781 990.3 16.2 3.8 25.6 4.2 11.8 1.3-2 50s-2.9 33-7.8 48.9c-3.6 11.7-15.7 33.2-15.7 33.2l-7.7 11.7-45.4-39.3s7.8-11 10.6-17c3.5-7.5 7.7-23.8 7.7-23.8l4.4-26 2.4-32.7zm-57 151.5 41.4 36s-8.4 7.4-13.4 9.7a73.6 73.6 0 0 1-31.6 7.3 58 58 0 0 1-22.3-6.2c-15.7-7.2-33-14.7-43.2-28.7-3.6-5-5-11.6-4.9-17.7.2-7 6.3-19.9 6.3-19.9s2.4 8.7 5.1 12a49.2 49.2 0 0 0 17.6 12.4 42.5 42.5 0 0 0 36.2 1.1c3.3-1.3 8.9-6 8.9-6z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  fill: "#fff",
                  d: "M1658.7 877.7s3.2 6.6 4.2 10.1c1.8 6 3 12.3 3 18.6a78.8 78.8 0 0 1-3.2 18.6 171 171 0 0 1-10.3 26.3c-2.6 5.4-6 10.3-8.6 15.8-4.1 8.7-7 18-10.6 26.8-3 7.5-6.9 14.7-9.2 22.4-3 10.2-4.5 20.9-6 31.4a230 230 0 0 0-2.3 27.5c0 11 .3 22 2.3 32.6 2 10.6 5 21.2 9.8 31a79.1 79.1 0 0 0 31.8 34.8c5.5 3.4 11.9 5.3 18 7.8 8.3 3.3 25.4 9.3 25.4 9.3s-23.6-11.6-31.8-21.4a68.4 68.4 0 0 1-12.8-28.9 112.3 112.3 0 0 1-1.2-36.6 196 196 0 0 1 9.2-38.3c4.2-13.2 10-25.9 15.4-38.6 3.9-9.3 8.3-18.2 12-27.5 4.5-11 8.8-22 12.4-33.2 2.1-6.9 4.8-13.7 5.4-20.9a76 76 0 0 0-2.2-23.4 89 89 0 0 0-11.8-30.6 41.1 41.1 0 0 0-14.8-13.2c-5.7-2.9-12.5-5.4-18.9-4.1-2 .4-5.2 3.7-5.2 3.7"
                }),
                /* @__PURE__ */ jsx254("path", {
                  fill: "#fff",
                  d: "M1711.6 945.6s4.4-18 5.2-27.2c.6-7.9.2-15.8-.6-23.7-1-8.7-1.5-17.8-4.9-25.9a68.3 68.3 0 0 0-38.2-37 92.2 92.2 0 0 0-28-4.8 130 130 0 0 0-38 4c-4 1.4-11.7 5.7-11.7 5.7l30 49s9.3-5.6 14.5-7a54.7 54.7 0 0 1 17-1.2c5.8.4 11.7 1 17 3.3a57 57 0 0 1 17.6 13.3 73.9 73.9 0 0 1 15 22c3 7.5 3.5 16 4.6 24.2.3 1.7.5 5.3.5 5.3"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "M1717 906.7s-5.3-16.6-10.3-23.5a63.8 63.8 0 0 0-22.3-19.8c-9.4-4.7-31-6.2-31-6.2l11.4 21-20-.4-10.3-17.4-19.3 8.7-9.5-15.7 20.4-9.4-9.4-15.2 20.4-2 8.9 14.7s15.9 0 23.6 1.7a58.2 58.2 0 0 1 27.5 14.4 68 68 0 0 1 12 14.2c3 5.1 6.5 16.7 6.5 16.7z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "m1581.7 845 31.8 46.7m-18-54.8-15 8.8-14.3 11 31 47.1 13.7-10.6 14.1-8.2zm58.3 199 17.9-37 19.1 7.7 7.8-19-19-9 9.8-21.3-14-6.3-10.6 20.5-19.2-8-8.4 20 18.6 7.7-17.2 36.7zm143.2-11.1 18.1-.4v21l17.6.9-3 21.4-16.4-1s-2.7 12.5-5.1 18.4c-2.5 6.2-9.7 17.4-9.7 17.4l-19.4-4.8s7-11 9.7-17c2.4-5.4 5.7-16.6 5.7-16.6l-20-2.5 3.5-20.2 18.1 1.2z"
                })
              ]
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__a",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 3717.8 0)"
            }),
            /* @__PURE__ */ jsx254("path", {
              fill: "#fff",
              d: "m1756.7 735.6-27.5 29.4 17 51 9.6 35.8-27.7 25.8 50.7 71-17.4 19.9a12.2 12.2 0 0 0-2.1 8.6c.3 2.7 1.6 5.4 3.6 7.3 4.5 4.1 11.3 5.1 17.3 6.7 21 5.6 42.9 8 64.6 9.7 4.7.4 14 0 14 0s9.4.4 14.1 0c21.8-1.6 43.6-4.1 64.7-9.7 6-1.6 12.7-2.6 17.3-6.7a12.2 12.2 0 0 0 1.4-15.9l-16.3-36 51.8-55.4-19.7-17.9-.5-43.2 17-51-25.5-25.7-23-61.2s-4.7-17.1-8.8-25c-2.4-4.6-5.8-8.7-9.2-12.8-4-4.9-8-9.9-12.8-13.9a85 85 0 0 0-14.6-9c-5.5-2.9-11-6-16.9-7.5-6.1-1.5-19-1.5-19-1.5s-12.7 0-18.9 1.5c-6 1.6-11.4 4.6-16.8 7.5a85 85 0 0 0-14.6 9c-4.9 4-8.9 9-12.9 13.9-3.3 4-6.7 8.2-9.1 12.9-4.1 7.8-8.9 24.9-8.9 24.9z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1963.3 933.1s-3.2-2.8-5-4a64.5 64.5 0 0 0-12-6c-5.5-2.2-11.5-3.3-17.3-4.7a196.8 196.8 0 0 0-44.3-5.7c-8.6 0-25.8 1.3-25.8 1.3s-17.2-1.3-25.8-1.3a195.2 195.2 0 0 0-44.3 5.7c-5.9 1.4-11.8 2.5-17.4 4.7a64.5 64.5 0 0 0-12 6c-1.7 1.2-5 4-5 4m218.8-42.7s-5.2-5.2-8.6-5.9a9 9 0 0 0-6.6 1.5 13.1 13.1 0 0 0-4 15.2c.8 2 2 4.3 4.1 5.2 4.8 1.9 15.4-2 15.4-2zm5.1-3.6c5.8.2 8 3.2 9.5 6.5m-243.2-2.9-.3 14s10.5 3.9 15.3 2c2-.9 3.4-3.1 4.2-5.2a13.1 13.1 0 0 0-4-15.2 8.9 8.9 0 0 0-6.6-1.5c-3.5.7-8.6 6-8.6 6zm-5.2-3.6c-5.8.2-8 3.2-9.4 6.5m198.1 1.4-8.4-1m-130 1 8.4-1m76 .8c-2.9-.4-7.6-4.2-7.6-4.2m-22.8 4.2c2.8-.4 7.6-4.2 7.6-4.2m141-19.3s-4.3 3.3-7.4 3.8l-1.2.7s-2 5.7-3.6 8.2a44.7 44.7 0 0 1-6.5 6.2s-4.8-4.1-7.7-5c-2-.5-4.2-.5-6 .3a11 11 0 0 0-4.8 4.3c-1.4 2-2.7 4.6-2.6 7 .1 3 3.9 8.3 3.9 8.3l-2.6 4.5-3.7 2.3a90.3 90.3 0 0 1-19-7.5 18.9 18.9 0 0 1-4.4-9s4.5-2.7 5.6-5c1.2-2.5 1.6-6 .2-8.4-1.6-2.6-5.3-4-8.4-4a8.8 8.8 0 0 0-6.3 2.7c-1.6 1.8-3 4.5-2.5 7 .4 2.4 4.7 5.7 4.7 5.7s-1.8 4.6-3.8 5.5c-6 2.5-10 4-15.3 4.8a39 39 0 0 1-16.3 0 17 17 0 0 1-9-5.5c-.6-.9-.8-3-.8-3s6.5-1.7 9-3.7c2.6-2 5.3-4.6 5.9-7.8.5-3.2-1.2-6.6-3-9.2a18 18 0 0 0-7.6-6c-1.3-.6-4.3-.7-4.3-.7l-1 .9a14.6 14.6 0 0 1-4.7 3.8h-.1l-.2.1-1.1.6-.8.1-2.4.8s3.8 1.2 5 2.8c.6.9.9 2 1 3.3l.2 2c0 1.2-.3 2.3-.7 3.4a9 9 0 0 1-1.7 3.5c-.4.6-1 1-1.6 1.4 0 0 0 0 0 0l-.2.1c-1 .7-2.2 1.2-3.3 1.5-1.4.4-4.2.1-4.3.1 0 0 5.5 0 7.6-1.6l.2-.1a10.7 10.7 0 0 0 3.8-7.2v-3c-.3-1.6-1-3.2-2.2-4.2-2.4-2.1-9.3-2.4-9.4-2.4-.1 0-7 .3-9.4 2.4a7.6 7.6 0 0 0-2.3 4.2v3.1l.5 2.3c.7 2 1.8 3.7 3.3 4.9l.2.1c2.2 1.6 7.6 1.6 7.7 1.6-.1 0-3 .3-4.3 0-1.2-.4-2.4-.9-3.4-1.6h-.1v-.1c-.7-.4-1.2-.8-1.7-1.4a9 9 0 0 1-1.7-3.5c-.3-1-.6-2.2-.7-3.3l.2-2.1c.2-1.2.5-2.4 1.1-3.3 1.1-1.6 5-2.8 5-2.8l-2.5-.8-.7-.1-1.2-.6h-.1l-.1-.1a15 15 0 0 1-4.8-3.8l-1-.9s-3 0-4.2.7a18 18 0 0 0-7.6 6c-1.8 2.6-3.5 6-3 9.2.5 3.2 3.3 5.8 5.8 7.8 2.6 2 9 3.7 9 3.7s-.2 2.1-.8 3a17 17 0 0 1-9 5.5 39 39 0 0 1-16.3 0 59 59 0 0 1-15.2-4.8c-2-1-3.9-5.5-3.9-5.5s4.4-3.3 4.8-5.8c.4-2.4-1-5-2.6-6.9a8.8 8.8 0 0 0-6.2-2.8c-3.1 0-6.8 1.5-8.4 4.1-1.5 2.4-1 5.9.2 8.4 1 2.3 5.6 5 5.6 5a18.9 18.9 0 0 1-4.5 9 88.5 88.5 0 0 1-19 7.5l-3.6-2.3-2.6-4.5s3.7-5.2 3.8-8.2c.2-2.5-1.1-5-2.5-7.1a11.2 11.2 0 0 0-4.8-4.3c-1.8-.8-4-.8-6-.2-3 .8-7.7 4.9-7.7 4.9s-4.8-3.8-6.5-6.2a48.7 48.7 0 0 1-3.7-8.2l-1.2-.7c-3-.5-7.3-3.8-7.3-3.8l-4.4 1s-4.1 2.1-4.2 4c0 2.8 3.8 4 5.5 6 1.4 1.9 2.8 3.7 4.1 5.7 1.2 1.8 2.9 3.4 3.5 5.5.6 2.3-1 5 0 7.2 1.2 2.7 3.7 5.4 6.7 6 2.6.5 7.6-2.6 7.6-2.6l-.2 19.9 10.3 9.3 9.7 20.3-3.8 5.2 1.1 10c7.5-9.6 20.5-13.8 32.2-17.2 15.7-4.5 44.6-4.8 58-4.7l7.3.1s44.3-1.4 65.2 4.6c11.7 3.4 24.7 7.6 32.2 17.2l1.2-10-3.9-5.2 9.7-20.3 10.3-9.3-.1-19.9s5 3.1 7.6 2.6c3-.6 5.5-3.3 6.7-6 1-2.2-.7-4.9 0-7.2.6-2 2.2-3.7 3.4-5.5 1.3-2 2.7-3.8 4.2-5.6 1.7-2.1 5.5-3.3 5.4-6 0-2-4.1-4.2-4.1-4.2zm-148.4-2.6c1 1 3 2.8 4.8 3.8l.2.1c.5.3 1.2.5 2 .7 2.8.8 7.8.3 8 .3h0c.1 0 5.1.5 8-.3l2-.7.2-.1c1.7-1 3.7-2.9 4.8-3.8.5-.7 1-1.4 1.3-2.2 1.1-2.7 1-6.1-.2-8.7-1.6-3-5.2-4.5-8.1-6.3-2.5-1.5-8-3.7-8-3.7a69 69 0 0 0-8 3.7c-3 1.8-6.6 3.3-8.1 6.3-1.3 2.6-1.4 6-.2 8.7.3.8.8 1.5 1.3 2.2"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1980.8 829.8s-11-5-16.6-6.9c-10.4-3.3-21.3-5.2-32-7.3-12.5-2.4-25.2-3-37.6-6-3.9-.8-7.5-2.7-11.5-3.5-5.4-1.1-11-2.9-16.4-1.7-3 .6-7.8 4.6-7.8 4.6s-4.9-4-7.8-4.6c-5.4-1.2-11.1.6-16.5 1.7-4 .8-7.6 2.7-11.4 3.6-12.4 2.9-25.2 3.5-37.7 6-10.7 2-21.5 3.9-32 7.2-5.6 1.8-16.5 6.9-16.5 6.9m197.4-45.1s5.4-2.9 7.3-5a9.5 9.5 0 0 0 2.7-5.3 9 9 0 0 0-2.3-6.5 9 9 0 0 0-6.2-2.2c-1.9 0-3.9.6-5.3 1.8a9.1 9.1 0 0 0-3 5.6c-.3 1.8.5 3.7 1.3 5.3a33 33 0 0 0 5.5 6.3m-151 0s4.1-3.8 5.4-6.3a9.4 9.4 0 0 0 1.4-5.3 9.1 9.1 0 0 0-3-5.6 8.2 8.2 0 0 0-5.3-1.8 9 9 0 0 0-6.3 2.2 8.7 8.7 0 0 0-2.2 6.5c.1 2 1.3 3.7 2.6 5.2 2 2.2 7.3 5 7.3 5zm-41.2 18-11.9 15.6s0 4 .8 5.8a24 24 0 0 0 5.9 5.7l.8 21.4-11.3 19.6-1 .2 7.3 3.8 1 .1c4.4-.3 7-5.2 10.9-7.4 4.8-2.8 10-5 15.2-7.2a239.8 239.8 0 0 1 50-15.1 141.8 141.8 0 0 1 29.5-1.2c6.6.5 19.4 3.4 19.5 3.4 0 0 12.9-3 19.5-3.4a140.7 140.7 0 0 1 57.8 8.3 239.8 239.8 0 0 1 36.9 15.2c3.8 2.2 6.5 7 10.8 7.4h1l7.3-4-1-.1-11.3-19.6.9-21.4s4.6-3.3 5.8-5.7c1-1.7.8-5.8.8-5.8l-11.9-15.6s-6 6-9.9 7.3c-2 .6-4.4.6-6.5 0-2.5-.8-4.4-2.9-6.5-4.5a84 84 0 0 1-12.9-12.1 70.2 70.2 0 0 1-5.3-8.7s-12.9 10.1-20.6 12.1c-7.6 2-16 1.6-23.5-.6-1.9-.6-5-3-5-3a42 42 0 0 0-26.4-8 42 42 0 0 0-26.4 8s-3.2 2.4-5 3a44.8 44.8 0 0 1-23.6.6 82.4 82.4 0 0 1-20.6-12.1s-3.1 6-5.3 8.7a84 84 0 0 1-12.9 12.1c-2 1.6-4 3.7-6.5 4.5-2 .6-4.4.6-6.4 0a37 37 0 0 1-10-7.3"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1985.9 796.4s.4-5.7-.2-8.5a21 21 0 0 0-3.1-7c-1.5-2.3-5.7-6-5.7-6m-1.4 27.8s3.4.1 4.9-.6c2.6-1.3 6-6.3 6-6.3s6.7 4.6 10.4 4c1.8-.2 3.2-1.8 4.2-3.4a8 8 0 0 0 1.2-5.7c-.3-1.5-1.6-2.6-2.8-3.6-2.3-2-6.4-1.7-7.9-4.2-1.2-2-.5-4.9.2-7.1 1.4-4.8 4.7-8.7 7.5-12.8 1.7-2.6 5.3-4.4 5.6-7.5.2-1.6-2-4.6-2-4.6s-5.2-.1-7.7.6c-4 1.2-8.3 3-11.2 6.1-2.4 2.6-3 6.4-4.3 9.7-1 2.5-2.5 7.7-2.5 7.7s-6 0-8.7 1.2a17.1 17.1 0 0 0-8.7 7.7c-1.2 2.7-1 6.2 0 9 1.1 3 3.5 5.3 6.1 7 2.9 1.8 9.7 2.8 9.7 2.8M1740.8 775s-4.1 3.6-5.6 5.8a21 21 0 0 0-3.2 7.1c-.6 2.8-.1 8.5-.1 8.5m-17-45.5s-2.2 3-2 4.6c.4 3.1 4 5 5.7 7.5 2.7 4.1 6 8 7.5 12.8.6 2.2 1.3 5 .1 7-1.4 2.6-5.6 2.4-7.8 4.3-1.2 1-2.5 2.1-2.9 3.6a8 8 0 0 0 1.2 5.7c1 1.6 2.5 3.2 4.3 3.4 3.6.6 10.3-4 10.3-4s3.5 5 6 6.3c1.5.7 5 .6 5 .6s6.8-1 9.7-2.9c2.5-1.6 5-4 6-6.8 1-2.9 1.3-6.4 0-9.1a16.8 16.8 0 0 0-8.7-7.7c-2.6-1.3-8.7-1.2-8.7-1.2s-1.4-5.2-2.4-7.7c-1.3-3.3-2-7.1-4.4-9.7a24.7 24.7 0 0 0-11.2-6.1c-2.5-.7-7.7-.6-7.7-.6m135.6 14.3 8.4-2.4 8.3 2.4m-14.5 20s-6.5-5.8-7.7-9.8a8 8 0 0 1 .4-5.5c1.2-2.2 5.9-4.7 5.9-4.7s-7.1-3.4-9-6.6a8.6 8.6 0 0 1-.5-6.3 17 17 0 0 1 5.8-8c3.2-2.7 11.3-5.4 11.3-5.4s8 2.7 11.2 5.3a17 17 0 0 1 5.9 8.1c.5 2 .4 4.4-.6 6.3-1.9 3.2-9 6.6-9 6.6s4.8 2.5 6 4.7c.8 1.6.9 3.7.3 5.5-1.2 4-7.7 9.9-7.7 9.9l-6.1.4zm22.7-26.8s13.4 5.7 18 11.1c1.2 1.5 2.3 3.5 2.2 5.5-.5 7-10.3 18.2-10.3 18.2l-20-8.3h-12.9l-20 8.3s-9.8-11.3-10.2-18.2c-.2-2 1-4 2.2-5.5 4.5-5.4 18-11.1 18-11.1"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "m1844.4 669.2 8-6.2 6.5.2-6.6-.2s-3.6-2.4-4.6-4.2a9 9 0 0 1-1-6c.5-2.7 2-5.5 4.4-6.9 2.3-1.3 7.8-.5 7.8-.5s5.5-.8 7.7.5c2.4 1.4 3.9 4.2 4.5 6.8.4 2 0 4.3-1 6-1 1.9-4.6 4.3-4.6 4.3l-6.7.2 6.5-.2 8 6.2m52.7 5.1-2.7 4.7m32.6-20-7.5 1m8.5 8.8-11.5.6m-1.5-13.8c1.5 1 4.2 2.9 4.6 4.6a10 10 0 0 1-3.1 9.2c-2.4 2-9.3 1.5-9.3 1.5m-181.7 33.6 17-4.2c8-2 16-4.2 24.2-5.7 9.3-1.6 18.7-2.8 28-3.5 11.8-.9 35.3-.6 35.3-.6s23.5-.3 35.2.6c9.4.7 18.7 1.9 28 3.5 8.2 1.5 16.2 3.8 24.3 5.7l17 4.2m-171.6-30.2 2.7 4.7m-32.7-20 7.5 1m-8.5 8.8 11.5.6m-6.4 16s12.5-3.2 18.8-4.5c7-1.4 14-2.8 21-3.7 8-1 16.1-1.5 24.3-2 9.6-.4 28.9-.3 28.9-.3s19.2 0 28.9.4a284.2 284.2 0 0 1 45.2 5.6c6.3 1.3 18.9 4.5 18.9 4.5M1781.6 671s-6.8.5-9.2-1.5c-2.5-2-4-6-3.2-9.2.7-2.4 5.6-5.2 5.6-5.2m63.1 74c-12 .8-24 1.5-35.8 3.7a220.2 220.2 0 0 0-36.2 9.7c-11.1 4-22.9 22.6-32 15.2-2-1.6.7-5 1.6-7.4a43 43 0 0 1 7.8-12.6c2.4-2.7 8-3 8.5-6.6.5-2.6-3.4-4-4.3-6.6a17 17 0 0 1-.5-10c1.2-4.1 6.5-6.2 7.7-10.3 1-3.6-2.5-7.8-.9-11.2 2.2-4.2 11.4-2.7 12-7.4.4-2.3-3.8-3-4.5-5.1-.6-1.6.3-3.3.3-5 0-2.1.4-4.5-.6-6.5-.9-1.7-3.7-2.1-4.3-4a5.5 5.5 0 0 1 1.1-5.4c1-1 3.7.4 4.3-.9 1.4-2.6-2.5-5.3-3.7-8-1.4-3.2-3.2-6.3-4-9.7-.6-2.7-3-7-.6-8.3 2.8-1.6 5.5 3.2 8 5.1 3.4 2.5 7.2 4.8 9.5 8.3 1.7 2.5.7 6.5 3 8.6 2.6 2.5 7.7.5 10.4 2.9 2.4 2 4.5 5.5 3.8 8.5-.7 3-7.6 2.9-7 5.8.9 3.4 7 3.2 10.4 2.5 2-.3 3.5-2.2 5.1-3.4 1.4-1 2.4-2.2 4-2.8 1.6-.8 5.3-1 5.3-1l-2.1-.5s-3.2-2.5-3.5-4.3a6 6 0 0 1 1.6-5 7.7 7.7 0 0 1 5.5-2.2c1.7 0 3.5.7 4.6 1.9a6.3 6.3 0 0 1 1.7 4.8 6 6 0 0 1-2.3 3.7 13 13 0 0 1-4.6 1.5l2.3.6 6.1 8.5 26.6-1.5s3.3-3.3 2.6-5.2c-.7-1.9-2.5-2.6-5.7-2.5-8.5.4-10.3-6.8-10-12 .3-4.4 5.5-7.3 9.5-9 4-1.5 10.8 3.7 12.6-.1 1.5-3.3-5.8-5-7-8.5-.5-1.5-.5-3.4.2-4.8 1.8-3.6 5.7-6 9.4-7.7 1.6-.7 5-.8 5-.8s3.6.1 5.1.8c3.7 1.7 7.6 4.1 9.4 7.7.7 1.4.7 3.3.2 4.8-1.1 3.5-8.5 5.2-7 8.5 1.8 3.8 8.7-1.4 12.6.2 4 1.6 9.2 4.5 9.5 8.9.3 5.2-1.4 12.4-10 12-3.2-.1-5 .6-5.7 2.5-.6 1.9 2.7 5.2 2.7 5.2l26.5 1.5 6.1-8.5 2.3-.6s-3.3-.5-4.5-1.5a6 6 0 0 1-2.3-3.7c-.2-1.7.5-3.6 1.6-4.8 1.1-1.2 3-1.9 4.6-1.9 2 0 4.1.7 5.5 2.2 1.2 1.2 2 3.2 1.6 5-.3 1.8-3.5 4.3-3.5 4.3l-2.1.5s3.7.2 5.4 1c1.5.6 2.6 1.9 3.9 2.8 1.7 1.2 3.1 3 5.1 3.4 3.5.7 9.6 1 10.3-2.5.7-3-6.1-2.9-6.8-5.8-.7-3 1.3-6.5 3.7-8.5 2.7-2.4 7.9-.4 10.5-2.9 2.2-2 1.3-6 3-8.6 2.3-3.5 6-5.8 9.4-8.3 2.5-1.9 5.3-6.7 8-5.1 2.4 1.4 0 5.6-.6 8.3-.8 3.4-2.6 6.5-4 9.7-1.2 2.7-5 5.4-3.7 8 .7 1.3 3.3-.2 4.3.9a5.5 5.5 0 0 1 1.1 5.4c-.6 1.9-3.4 2.3-4.3 4-1 2-.5 4.4-.5 6.6 0 1.6.8 3.3.3 4.9-.8 2.1-5 2.8-4.6 5.1.7 4.7 9.9 3.2 12 7.4 1.7 3.4-1.9 7.6-.9 11.2 1.2 4.1 6.5 6.2 7.8 10.3 1 3.2.4 6.8-.6 10-.8 2.5-4.7 4-4.3 6.6.6 3.6 6.2 3.9 8.6 6.6 3.3 3.6 5.8 8 7.7 12.6 1 2.3 3.7 5.8 1.7 7.4-9.2 7.4-21-11.1-32-15.2a220.2 220.2 0 0 0-72-13.4c-7-.4-21-.4-21-.4s-14 0-21 .4m31.1-133.7-10.1.1-10.2-.1m17-33.9c2.6-5.6-2-9.7-6.8-13.8-4.8 4-9.4 8.2-6.8 13.8m14.1 46.8c3.9.2 8.6 4.2 11.6 1.7 1.3-1.2.7-3.7 0-5.3-1.6-3.8-8.4-4.7-8.7-8.8-.3-3.5 5.1-5.2 6.3-8.5.5-1.7.6-3.7 0-5.3-2.8-6.6-14.5-7-16.6-13.7-.9-3 6-6.5 6.8-6.9 4.4-1.9 9.7 2.7 14 .8 3-1.2 6.1-4.1 6-7.3 0-3.4-3.6-6.3-6.8-7.7-6.1-2.6-16.2 6-20 .5-3.4-5.1 8.7-11.1 7-17-.7-2.9-7-5.3-7-5.3s-6.1 2.4-6.9 5.3c-1.6 5.9 10.5 11.9 7 17-3.7 5.5-13.8-3.1-20-.5-3.1 1.4-6.8 4.3-6.8 7.7 0 3.2 3.1 6 6 7.3 4.3 1.9 9.7-2.7 14-.8.9.4 7.7 4 6.8 6.9-2 6.7-13.7 7-16.5 13.7a7.8 7.8 0 0 0 0 5.3c1.1 3.3 6.6 5 6.3 8.5-.3 4.1-7.2 5-8.7 8.8-.7 1.6-1.4 4.1 0 5.3 3 2.5 7.7-1.5 11.6-1.7 2.4-.2 7.3 0 7.3 0s4.8-.2 7.3 0"
            }),
            /* @__PURE__ */ jsx254("path", {
              fill: "none",
              d: "M1953.7 953.5s-7.1-3-10.8-4.3a258 258 0 0 0-20-6.5c-6.6-1.8-13.2-3.7-20-4.5-14.6-1.6-44-.2-44-.2s-29.4-1.4-44 .2c-6.8.8-13.5 2.7-20 4.5a258 258 0 0 0-30.9 10.8M1966 731s-12-4.8-18.1-6.9c-5.1-1.7-10.2-3.5-15.5-4.8-6.4-1.6-12.9-2.6-19.4-3.5a387.1 387.1 0 0 0-54.1-3.4s-17.2.1-25.8.6a376.5 376.5 0 0 0-47.8 6.3c-5.2 1.3-10.3 3-15.4 4.8-6.1 2.1-18 6.9-18 6.9m-14.2 120.4s17.5-6 26.4-8.7c9.1-2.8 18.2-6 27.5-8 11.2-2.5 22.6-3.7 34-5 11-1.1 33.3-2.3 33.3-2.3s22.2 1.2 33.3 2.4c11.3 1.2 22.8 2.4 34 4.8 9.3 2 18.3 5.3 27.5 8.1l26.4 8.7"
            })
          ]
        }),
        /* @__PURE__ */ jsxs247("g", {
          fill: "#ccc",
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsxs247("g", {
              id: "va_svg__b",
              children: [
                /* @__PURE__ */ jsx254("path", {
                  d: "m1533.3 904 101.2 86.8s-5.2 11.2-7.3 17a142.6 142.6 0 0 0-9.3 41l-118-108c1.7-24.7 15.6-33.5 33.4-36.8z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "m1519 958.2-24.3 27.2 15.2 14.6-23.5 22.8-15.2-15.1-25.5 27.2-.2 33.7 58 45.5 20.1-14.9-1.1-32.3 15.4 8.6 15.5-9.4.8 29.1-12.6-9.1-13.7 18-1.4 32 43.7 39 53-47.1-4-14.1-2.2-12.7-1.3-25.1 2-27.5z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "m1494.7 985.4-.6 30 15.6-15.3z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  fill: "none",
                  d: "m1572 1140.4-1.9 34.3m-18.6-139.7.6 31.8m-14.8-17.3.9 25.8m-14.5-36.3.6 29m-21.4 15.2.3 30.6m24.7-9.7 44 37 45.1-39.6m-171-66.9 57.6 49.2 18.9-16.9-15-12.6 16.7-15.7 12.9 11.1 14.5-14.8 19 18.3-17.2 13.4 16 14.6-15.2 14"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "m1901.3 1229.3 48.7 44.6 10.7 31.5-62.6-6.7-35.7-35.3-38-35.2-164-142.1s3.5-13.1 5.6-19.5c3.2-9.3 6.9-18.4 10.6-27.5l3-6.8 183 162.3z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "M1942.7 1236c27 38 72.7 73.7 86.5 90.9 13.9 17.2 22.8 33.5 2.6 55.5s-43 9.5-61.1-2.6c-18.1-12-49.6-51.3-94.8-81.3z"
                }),
                /* @__PURE__ */ jsx254("path", {
                  d: "m1926.7 1299.8-35.2-16m41-38.2c2.4 8 .5 16.8 3.6 24.4 3 7.6 14 20 14 20s-7 1-10.3 2.2c-4.7 1.9-12 2.7-13.1 7.7-1 4.3 4 8 7 11.2 3 3.1 6.7 5.4 10.4 7.6 6.1 3.6 12.4 7.6 19.4 8.9 8.7 1.6 25.1-10.8 26.6-2 .6 3.6-7.4 1.3-10.7 3-7.8 3.8-11.6 12-4.8 17.8 4.4 3.7 11.3 2.4 17 2.9 5.5.4 11.7-2.8 16.5 0 5.6 3.2 12.7 11 9.7 16.8-3 6-14.5 5.8-20 2-4-3-2.9-9.5-3.5-14.4v-4.4"
                }),
                /* @__PURE__ */ jsx254("circle", {
                  cx: 2154.7,
                  cy: 1480.1,
                  r: 129.7
                }),
                /* @__PURE__ */ jsx254("path", {
                  fill: "#fff",
                  d: "M2106.1 1485.7a40.5 40.5 0 1 0 40.5 40.4l14-.6a40.5 40.5 0 1 0 40.5-40.5l.6-7.9a40.5 40.5 0 1 0-40.5-40.5l-14-1.2a40.5 40.5 0 1 0-40.5 40.5z"
                }),
                /* @__PURE__ */ jsx254("circle", {
                  cx: 2154.7,
                  cy: 1446.1,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx254("circle", {
                  cx: 2189.4,
                  cy: 1480.1,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx254("circle", {
                  cx: 2155.3,
                  cy: 1511.2,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx254("circle", {
                  cx: 2119.3,
                  cy: 1480.1,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx254("path", {
                  fill: "#fff",
                  d: "M2152.2 1558.4c-5.3 11-12.6 16-21.9 22a63.2 63.2 0 0 0 43.8 0 54 54 0 0 1-21.9-22zm-76.5-80.2c-11-5.3-16-12.6-22-22a63.2 63.2 0 0 0 0 44 53 53 0 0 1 22-22zm159.2 3.6c11-5.3 16-12.6 22-21.9a63.2 63.2 0 0 1 0 43.9c-4.7-9.3-12-16-22-22zm-78.4-80.8c-5.3-11-12.6-16-22-22a63.2 63.2 0 0 1 44 0 53 53 0 0 0-22 22z"
                })
              ]
            }),
            /* @__PURE__ */ jsx254("g", {
              fill: "#ce9d09",
              children: /* @__PURE__ */ jsxs247("g", {
                id: "va_svg__c",
                children: [
                  /* @__PURE__ */ jsx254("path", {
                    d: "M1533.5 903.8s.7-5 0-7.4a22.6 22.6 0 0 0-6.6-10.2 19.6 19.6 0 0 0-9.2-4.6 24.5 24.5 0 0 0-17.7 4.2l-15 6.2-5.5 17.7s-3.2 5.6-4 8.7a23 23 0 0 0-.5 10.1c1 3.9 3.2 7.6 6.3 10.2a19 19 0 0 0 10.3 4 28 28 0 0 0 8.3-1.9c1.6-18.6 9.9-32.8 33.5-36.9z"
                  }),
                  /* @__PURE__ */ jsx254("path", {
                    d: "m1500.3 885.6-38.8-17-3.1 3 21 38.2s6-8.7 9.4-12.7c3.6-4.1 11.5-11.5 11.5-11.5z"
                  }),
                  /* @__PURE__ */ jsx254("circle", {
                    cx: 1457.3,
                    cy: 865.3,
                    r: 16
                  }),
                  /* @__PURE__ */ jsx254("path", {
                    d: "M1566.2 932.3c3.4 28 7.3 55.9 16 83.8l31 28.5c-6.5-29.3-18.4-58.5-18.3-87.7z"
                  }),
                  /* @__PURE__ */ jsx254("path", {
                    d: "m1613 972.4-85.4-6.4 27.2 25 78 3.3 1.2-4zm105.4 94.6a61.9 61.9 0 0 0-37.9 37c-6.4.7-12.3.7-14.4-4a58.5 58.5 0 0 1 35.7-47.8c15-2.8 12.2 8.9 16.6 14.7zm27.5 25.8a61.9 61.9 0 0 0-37.9 37.2c-6.3.5-12.3.6-14.4-4.1a58.5 58.5 0 0 1 35.8-47.8c15-2.8 12.1 8.9 16.5 14.7zm312.8 261.9a72 72 0 0 0-15.1 1.5c.3 8-3 16.6-11.8 26.2a33.4 33.4 0 0 1-23.7 12s-2.8 17.7 2.6 23.3c6.3 6.6 27.1 3.9 27.1 3.9l1.8-1.1a129.7 129.7 0 0 1 31.9-39.8l.3-1.3s3-16.5-2.1-21.5c-2.4-2.3-6.6-3-11 0z"
                  }),
                  /* @__PURE__ */ jsx254("circle", {
                    cx: 2254.5,
                    cy: 1375.4,
                    r: 17.7
                  }),
                  /* @__PURE__ */ jsx254("circle", {
                    cx: 2260.6,
                    cy: 1580,
                    r: 17.7
                  }),
                  /* @__PURE__ */ jsx254("circle", {
                    cx: 2062.1,
                    cy: 1591.6,
                    r: 17.7
                  })
                ]
              })
            })
          ]
        }),
        /* @__PURE__ */ jsxs247("g", {
          fill: "#ce9d09",
          transform: "matrix(-.192 0 0 .192 837 0)",
          children: [
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__b",
              width: "100%",
              height: "100%"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__c",
              width: "100%",
              height: "100%",
              fill: "#ccc"
            })
          ]
        }),
        /* @__PURE__ */ jsxs247("g", {
          fill: "#fa0204",
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__d",
              d: "M1869.2 1175.8c0 5.4-4.5 7.4-13.3 7.4-8.7 0-12.7-2.5-12.7-7.9s4-6.7 12.7-6.7c8.8 0 13.3 1.8 13.3 7.2z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__d",
              width: "100%",
              height: "100%",
              x: 6.4,
              y: 14.3
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1877.3 1208.7c-1.7 5-6.7 5.6-15 2.7-8.2-3-11.2-6.6-9.4-11.7 1.8-5 6-5 14.3-2.1 8.2 2.9 12 6 10.1 11z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__e",
              d: "M1877.5 1222.5c-1 5.3-5.9 6.4-14.4 4.7-8.6-1.7-12-5-11-10.3 1-5.3 5.3-5.8 13.8-4 8.6 1.7 12.7 4.3 11.6 9.6z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__e",
              width: "100%",
              height: "100%",
              x: 4,
              y: 16.1
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1921.7 1216.2c-2.6-.7-2.3-5.3-1.6-7.9 1.2-4 8.4-9.1 8.4-9.1s1.8 5.6 1 8.2c-1.2 3.7-4 9.8-7.8 8.8z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1912.3 1224.4c-2.8-.6-3.2-5.5-2.5-8.3 1.2-4.3 9.7-9.3 9.7-9.3s1.5 6 .5 8.8c-1.3 3.7-3.9 9.7-7.7 8.8zm-10.8 15.6c-4.3-1.1-3.8-8.8-2.6-13 1-3.6 3.7-9.2 7.2-8.3 4.2 1 4.2 8.3 3.1 12.5-.9 3.8-4 9.8-7.7 8.8z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1888.7 1252.2c-4.2-1-6-7.6-5.1-11.9.9-4.4 5.3-10.4 9.7-9.4 4.5 1 6 8.3 5 12.8-1 4.1-5.4 9.4-9.6 8.5zm-2.2 7.4c-1 5-7.5 6.8-11.5 5.5-4.1-1.3-9.5-7.1-8.4-12.5 1.2-5.4 8.2-6.8 12.3-5.2 3.9 1.5 8.7 7.2 7.6 12.2zm-85-49.3s5.1 2.5 7.3 4.8c2.3 2.4 5.1 3.3 3.7 6.9-1.4 3.6-5.8 2.4-8.1-.2-2.1-2.3-3-11.5-3-11.5zm25.3 8.7c5.3 1.1 5.1 7.2 2.5 11-2.8 3.8-10.9 8.9-16.4 7.8-5.5-1.1-4.8-7.8-1.8-11.7 2.9-3.6 10.6-8 15.7-7z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__f",
              d: "M1844.3 1230.5c4.8 2.2 3.4 8.1 0 11.2-3.6 3.2-12.6 6.3-17.7 4-5.2-2.2-3-8.6.8-11.7 3.6-3 12-5.6 16.9-3.5z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__f",
              width: "100%",
              height: "100%",
              x: 14,
              y: 10.7
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1863 1250.7c4.8.7 6 7.4 4.6 11.7-1.6 4.5-7.5 10.6-12.5 9.8-5.1-.8-6-8-4.2-12.6 1.6-4.2 7.3-9.7 12-9z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1875.1 1265.3c4 2.3 3 9.6.4 13.6-2.7 4.1-9.8 8.6-14 6.2-4.2-2.5-2.7-10.3.2-14.4 2.8-3.8 9.5-7.6 13.4-5.4zm-86.1-39.9c4.3-.3 7.2 6 7.1 10.6 0 4.9-3.3 12.4-7.7 12.8-4.5.4-7.3-6.7-7-11.6.1-4.6 3.4-11.4 7.6-11.8z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1803 1237.7c4 .9 5 7.8 3.5 12.2-1.6 4.6-7 10.8-11.3 9.8-4.4-1-5-8.6-3.2-13.2 1.6-4.3 6.8-9.8 11-8.9z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1815.8 1246.2c5 1.2 6 9.8 4.2 15.3-1.8 5.7-8.2 13.4-13.4 12.2-5.2-1.3-5.8-10.7-3.7-16.5 1.9-5.3 8-12.1 12.9-11z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1826.2 1256.8c5-.6 9 7 9.3 12.8.3 6-3 15.4-8.2 16-5.3.7-9.2-7.9-9.3-14-.1-5.6 3.3-14.2 8.2-14.8z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__g",
              d: "M1838.6 1265.7c4.5-.6 8.2 5.8 8.4 10.5.3 5-2.7 12.8-7.4 13.4-4.9.6-8.4-6.6-8.5-11.6 0-4.7 3-11.8 7.5-12.3z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__g",
              width: "100%",
              height: "100%",
              x: 12.8,
              y: 10.4
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__h",
              d: "M1929.3 1250.9c-3.3 2.8-9.7.3-12.6-2.9-3.1-3.3-5.3-10.5-1.8-13.5 3.4-3 10.2.2 13.2 3.6 2.7 3.3 4.4 10 1.2 12.8z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__h",
              width: "100%",
              height: "100%",
              x: -7,
              y: 12.8
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__h",
              width: "100%",
              height: "100%",
              x: -19.5,
              y: 23.5
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1905.2 1281.2c-1.1 4.1-8 5.6-12.1 4.5-4.4-1-10.2-5.8-9-10.2 1.3-4.4 8.7-5.6 13-4.3 4.2 1.2 9.2 5.9 8 10z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1887.2 1278.2c3.6 2.5 2.8 10.5.4 14.9-2.6 4.5-9 9.5-12.9 6.8-3.9-2.7-2.5-11.3.2-15.8 2.5-4.2 8.7-8.4 12.3-6z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1869.6 1287.5c4 2.4 3 9.6.4 13.6-2.7 4.1-9.8 8.6-14 6.2-4.2-2.5-2.7-10.3.2-14.4 2.8-3.8 9.5-7.6 13.4-5.4z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__i",
              d: "M1831.3 1313c-3.4 3.1-.7 11.2 2.8 15.2 3.7 4.2 11.8 8.1 15.4 4.7 3.5-3.4.3-12-3.6-16.1-3.7-3.9-11.2-7-14.6-3.9z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: -7.3,
              y: 13.8
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__j",
              d: "M1820.8 1339.5c-4.3 1.8-4.8 10.2-3 15.3 1.8 5.3 7.9 11.9 12.5 10 4.6-1.8 4.7-11 2.6-16.3-2-4.9-7.8-10.7-12-9z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__j",
              width: "100%",
              height: "100%",
              x: -10.5,
              y: 14.9
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__k",
              d: "M1802.7 1371c-4.6 1-6.5 9.3-5.5 14.6 1 5.5 6 13 10.8 11.9 4.8-1.1 6.4-10.2 5.2-15.7-1.2-5.1-6-11.8-10.5-10.8z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__k",
              width: "100%",
              height: "100%",
              x: -10.1,
              y: 15.9
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__l",
              d: "M1784 1403.3c-4.6.2-8 8-8 13.3 0 5.6 3.5 13.9 8.4 13.7 5-.2 8.2-8.8 8-14.5-.2-5.3-3.7-12.7-8.3-12.5z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -10.3,
              y: 19.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -22.4,
              y: 37
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -34.9,
              y: 52.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -47.8,
              y: 66.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -62,
              y: 78.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -75.6,
              y: 90.6
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "m1692.8 1500.2-5.3 20.6s3 7.3 6 7c5.5-.6 7-9 8-14.5 1-8.4-8.7-13.1-8.7-13.1zm324.4 13.1c1.6 6 15.3 11.3 15.3 11.3l-6.7-27.8c-5.7.2-9.5 12.4-8.6 16.4z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M2016 1491c-4.3-1.8-10.5 4-12.7 8.9-2.3 5.1-2.4 14 2.2 15.9 4.6 1.8 11-4.8 13.1-10 2-5 1.7-13.1-2.6-14.9z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__m",
              d: "M2000.8 1478.7c-4.7-.3-8.7 7.2-9.2 12.5-.5 5.6 2.2 14.1 7.1 14.4 5 .2 9-8 9.3-13.7.3-5.3-2.6-13-7.2-13.2z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -13.4,
              y: -13.7
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -25.9,
              y: -29.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -38.7,
              y: -42.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -49,
              y: -60.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -60.3,
              y: -76.4
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -70.6,
              y: -93.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -79.8,
              y: -113.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -89.8,
              y: -131.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -98,
              y: -152.5
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1883.8 1304.6s-1.6 26.6 8 28.3c6.1 1.1 10.9-14.9 10.9-14.9z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__n",
              d: "M1862 1610.8c-2.9 3.6 1 11.2 5 14.7 4.3 3.6 12.9 6.2 15.9 2.3 3-3.9-1.5-11.9-6-15.4-4-3.2-12-5.3-14.9-1.6z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__n",
              width: "100%",
              height: "100%",
              x: 18.3,
              y: -2.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__n",
              width: "100%",
              height: "100%",
              x: 36.8,
              y: -5.8
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__o",
              d: "M1916.2 1603.8c-2.3 4 2.6 11 7.1 13.8 4.8 3 13.7 4.3 16 0 2.5-4.4-3.2-11.6-8.1-14.4-4.6-2.6-12.8-3.4-15 .6z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__o",
              width: "100%",
              height: "100%",
              x: 20,
              y: -3.2
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__p",
              d: "M1953.5 1595.4c-2 4.3 3.6 10.7 8.4 13.1 5 2.5 14 3 16-1.5s-4.4-11.2-9.5-13.5c-4.8-2.2-13-2.3-15 2z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__p",
              width: "100%",
              height: "100%",
              x: 18.9,
              y: -5.6
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__q",
              d: "M1991.3 1583.9c-1.7 4.4 4.2 10.5 9.1 12.5 5.2 2.2 14.2 2.2 15.9-2.4 1.7-4.7-5-11-10.3-13-5-1.8-13.1-1.4-14.7 2.9z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 19.2,
              y: -6.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 37.7,
              y: -14
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 57.5,
              y: -22.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 77.5,
              y: -28.6
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 79.9,
              y: -44.3
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M2066.7 1534.9s13.6 2 14.8-2.9c1.6-6.5-15.4-12.7-15.4-12.7z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__r",
              d: "M1701.6 1575.6c-4 2.5-3 10.9-.4 15.5 2.7 4.9 9.8 10.4 14 7.8 4.2-2.6 2.8-11.7-.2-16.5-2.7-4.5-9.4-9.2-13.4-6.8z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 18.9,
              y: 7.8
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 37,
              y: 10.6
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 56.8,
              y: 15.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 74.7,
              y: 18.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 92.3,
              y: 21.7
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 110.4,
              y: 26.7
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 128.3,
              y: 29.9
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 146.6,
              y: 32.7
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1648.2 1517.5c-4.2-2.1-11 3-13.6 7.6-2.7 5-3.8 13.8.6 16 4.4 2.3 11.5-3.6 14-8.6 2.5-4.7 3-12.9-1-15z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1642 1534.4c-4.4-1.6-10.4 4.4-12.4 9.4-2 5.2-2 14.1 2.7 15.8 4.7 1.6 10.9-5.2 12.8-10.5 1.8-5 1.3-13.1-3-14.7z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1647.7 1550c-4.5-1.2-10 5.3-11.5 10.4-1.6 5.4-.6 14.3 4.2 15.5 4.8 1.2 10.3-6.1 11.8-11.6 1.3-5.1 0-13.2-4.5-14.4z"
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1662.4 1556.3c-4.5-1.3-10.2 5-11.9 10-1.7 5.4-1 14.3 3.7 15.7 4.7 1.4 10.5-5.8 12.1-11.2 1.5-5 .5-13.2-4-14.5z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__s",
              d: "M1672 1558.8c-4.6 1.1-6.3 9.4-5.2 14.7 1.1 5.5 6.2 12.8 11 11.6 4.8-1.2 6.2-10.3 4.8-15.8-1.2-5-6.2-11.6-10.7-10.5z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__s",
              width: "100%",
              height: "100%",
              x: 16.8,
              y: 6.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 8.6,
              y: -11.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 6.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.9,
              y: 26.7
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 47.9
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 5.6,
              y: 68.6
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.2,
              y: 87.7
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 109.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.2,
              y: 126.4
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 143.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 163.9
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 3.4,
              y: 183.9
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 3.7,
              y: 203.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.4,
              y: 223.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.4,
              y: 243.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 3.7,
              y: 263.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.5,
              y: 283.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.5,
              y: 305.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.9,
              y: 327.9
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.9,
              y: 349.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.9,
              y: 369
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.3,
              y: 391.3
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__t",
              d: "M1882.2 1303.2c2.5 3.7-1.3 10.8-5.1 14-4 3.2-12 5.4-14.5 1.5-2.6-4 1.9-11.4 6-14.6 4-3 11.2-4.6 13.6-1z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.7,
              y: 16.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.4,
              y: 34.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.1,
              y: 52.4
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 1.8,
              y: 69.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.7,
              y: 87.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 1.5,
              y: 104.4
            }),
            /* @__PURE__ */ jsx254("path", {
              d: "M1883.3 1426c2.6 3.9-1.5 11.3-5.7 14.5-4.5 3.4-13.2 5.7-16 1.6-2.9-4 2-11.8 6.6-15 4.4-3.1 12.4-4.8 15-1z"
            }),
            /* @__PURE__ */ jsx254("path", {
              id: "va_svg__u",
              d: "M1882 1443.6c3.5 3.2.8 11.3-2.7 15.3-3.7 4.2-11.8 8-15.3 4.7-3.6-3.5-.3-12 3.6-16.2 3.6-3.8 11.1-7 14.5-3.8z"
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.6,
              y: 20.4
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 40.5
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 62.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 82.2
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 102.6
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.6,
              y: 123
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.6,
              y: 143.7
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: -0.3,
              y: 164.4
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 183.3
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 203.1
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 224.4
            }),
            /* @__PURE__ */ jsx254("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 245.4
            })
          ]
        }),
        /* @__PURE__ */ jsxs247("g", {
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsx254("path", {
              fill: "#fa0204",
              d: "M1849.6 1848.3a77 77 0 0 0 48.3.4l-17.5-28"
            }),
            /* @__PURE__ */ jsx254("path", {
              fill: "#ce9d09",
              d: "m1888.3 1776.2-31.7-8.2s.4-35.2 20.4-32.1c16.6 2.5 12 40.3 11.3 40.3z"
            }),
            /* @__PURE__ */ jsx254("circle", {
              cx: 1872.9,
              cy: 1723,
              r: 12.9,
              fill: "#ce9d09"
            }),
            /* @__PURE__ */ jsx254("path", {
              fill: "#fa0204",
              d: "M1885.4 1791.9c7 17.8 11.3 33.2 4.7 53.3m7.6 3.5c-10.2-8.3-36.6-5.9-48-.4-4.4 0-16.4-83.2 25.7-81.2 38.8 2 25 82 22.3 81.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs247("g", {
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsx254("path", {
              fill: "#fa0204",
              d: "M1815.2 1866.3a47 47 0 0 0 54.2.5l-40.2-42"
            }),
            /* @__PURE__ */ jsx254("circle", {
              cx: 1843.4,
              cy: 1738.3,
              r: 12.9,
              fill: "#ce9d09"
            }),
            /* @__PURE__ */ jsx254("path", {
              fill: "#ce9d09",
              d: "m1859.3 1780-32.7-.6s-4.2-26.6 16.2-27.8c16.9-1 17.2 28.4 16.5 28.4z"
            }),
            /* @__PURE__ */ jsx254("path", {
              fill: "#fa0204",
              d: "M1843.6 1860.7c-6.3-13.9-6.9-31-5.2-49.5m-9.4 50.4c-7.7-13.2-9.1-30-3-51.2m43.4 56.6c-5-6.2-40.3-8.8-54.1-.4-5 0-18.6-93.8 29-91.5 43.6 2.1 28 92.3 25 91.9z"
            })
          ]
        })
      ]
    })
  ]
});
var Va_default = SvgVa;

// src/country-flag-icons/generated/Vc.tsx
import { jsx as jsx255, jsxs as jsxs248 } from "react/jsx-runtime";
var SvgVc = (props) => /* @__PURE__ */ jsx255("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs248("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx255("path", {
        fill: "#f4f100",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx255("path", {
        fill: "#199a00",
        d: "M490 0h150v480H490z"
      }),
      /* @__PURE__ */ jsx255("path", {
        fill: "#0058aa",
        d: "M0 0h150v480H0z"
      }),
      /* @__PURE__ */ jsx255("path", {
        fill: "#199a00",
        d: "m259.3 130-46.4 71.3 44.7 74.4 43.8-73.7zm121.2 0-46.3 71.3 44.7 74.4 43.8-73.7zm-61.2 97.3-46.4 71.4 44.8 74.4 43.8-73.7-42.2-72z"
      })
    ]
  })
});
var Vc_default = SvgVc;

// src/country-flag-icons/generated/Ve.tsx
import { jsx as jsx256, jsxs as jsxs249 } from "react/jsx-runtime";
var SvgVe = (props) => /* @__PURE__ */ jsxs249("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx256("defs", {
      children: /* @__PURE__ */ jsxs249("g", {
        id: "ve_svg__d",
        transform: "translate(0 -36)",
        children: [
          /* @__PURE__ */ jsxs249("g", {
            id: "ve_svg__c",
            children: [
              /* @__PURE__ */ jsxs249("g", {
                id: "ve_svg__b",
                children: [
                  /* @__PURE__ */ jsx256("path", {
                    id: "ve_svg__a",
                    fill: "#fff",
                    d: "M0-5-1.5-.2l2.8.9z"
                  }),
                  /* @__PURE__ */ jsx256("use", {
                    xlinkHref: "#ve_svg__a",
                    width: 180,
                    height: 120,
                    transform: "scale(-1 1)"
                  })
                ]
              }),
              /* @__PURE__ */ jsx256("use", {
                xlinkHref: "#ve_svg__b",
                width: 180,
                height: 120,
                transform: "rotate(72)"
              })
            ]
          }),
          /* @__PURE__ */ jsx256("use", {
            xlinkHref: "#ve_svg__b",
            width: 180,
            height: 120,
            transform: "rotate(-72)"
          }),
          /* @__PURE__ */ jsx256("use", {
            xlinkHref: "#ve_svg__c",
            width: 180,
            height: 120,
            transform: "rotate(144)"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx256("path", {
      fill: "#cf142b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx256("path", {
      fill: "#00247d",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx256("path", {
      fill: "#fc0",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsxs249("g", {
      id: "ve_svg__f",
      transform: "matrix(4 0 0 4 320 336)",
      children: [
        /* @__PURE__ */ jsxs249("g", {
          id: "ve_svg__e",
          children: [
            /* @__PURE__ */ jsx256("use", {
              xlinkHref: "#ve_svg__d",
              width: 180,
              height: 120,
              transform: "rotate(10)"
            }),
            /* @__PURE__ */ jsx256("use", {
              xlinkHref: "#ve_svg__d",
              width: 180,
              height: 120,
              transform: "rotate(30)"
            })
          ]
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#ve_svg__e",
          width: 180,
          height: 120,
          transform: "rotate(40)"
        })
      ]
    }),
    /* @__PURE__ */ jsx256("use", {
      xlinkHref: "#ve_svg__f",
      width: 180,
      height: 120,
      transform: "rotate(-80 320 336)"
    })
  ]
});
var Ve_default = SvgVe;

// src/country-flag-icons/generated/Vg.tsx
import { jsx as jsx257, jsxs as jsxs250 } from "react/jsx-runtime";
var SvgVg = (props) => /* @__PURE__ */ jsxs250("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx257("defs", {
      children: /* @__PURE__ */ jsxs250("linearGradient", {
        id: "vg_svg__a",
        x1: 103.1,
        x2: 92.6,
        y1: 111.3,
        y2: 107.8,
        gradientTransform: "matrix(.99614 0 0 2.25255 703.8 -75)",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx257("stop", {
            offset: 0,
            stopColor: "red"
          }),
          /* @__PURE__ */ jsx257("stop", {
            offset: 1,
            stopColor: "#ff0"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx257("path", {
      fill: "#006",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx257("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx257("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx257("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx257("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx257("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    }),
    /* @__PURE__ */ jsxs250("g", {
      transform: "translate(-217.5 -9.4) scale(.77497)",
      children: [
        /* @__PURE__ */ jsx257("path", {
          fill: "#fff",
          d: "m776.3 144 250.4-.9-.5 223s8.8 34-105 85.5c40.9-4.2 85.5-47.8 85.5-47.8s18.1-23.3 27-10.3c8.8 13 17.1 19.6 23.6 24.7 6.5 5 11.6 19 1.9 29.2-9.8 10.3-25.1 11.6-29.3-.9-6.5 3.3-46.4 51.6-128.2 53.9C818.5 499 773 446 773 446s-11.1 17.7-27 3.8c-15.3-18.2-3.7-29.8-3.7-29.8s13-7.4 16.8-12.5c6-7 7.9-16.3 18-16.3 12.2 1 16.8 10.7 16.8 10.7s41.8 44.1 86.9 49.7c-101.7-48.8-105.5-79-105-86.4z"
        }),
        /* @__PURE__ */ jsx257("path", {
          fill: "#006129",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "m782.3 150.1 238.8-1.4v214.6c.5 28-46.5 56.3-119.9 92.5-75.7-39-119.4-62.7-119.8-93z"
        }),
        /* @__PURE__ */ jsxs250("g", {
          id: "vg_svg__b",
          fill: "#ffc72c",
          stroke: "#000",
          strokeWidth: 0.9,
          children: [
            /* @__PURE__ */ jsx257("path", {
              fill: "none",
              stroke: "#ffc72c",
              strokeWidth: 1.9,
              d: "m814.8 181.8 14-20.7 14.3 20.8"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M831.7 174a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0z"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M817.4 197.1h21.9s.3-2.8-2.3-4.5c11.5-1.6 8.5-11.6 18-12.2 2 .3-5 4.3-5 4.3s-5.7 4-3 6.1c2 1.7 3-1 3.2-3 .3-2 9.3-3.3 8-9-2.1-4.7-14.7 3.2-14.7 3.2l-9-.1c-.6-1-3-5-5.6-5-3 0-5.2 5-5.2 5h-20.3s-.7 5.3 9.6 6.3c2.3 3 4.1 3.8 6.2 4.6-1.4 1.1-1.8 2.5-1.8 4.3zm1.6-4.4h18.2"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M810.7 182s1.4 8.5 8.2 10.5"
            }),
            /* @__PURE__ */ jsx257("path", {
              fill: "url(#vg_svg__a)",
              d: "M809.6 181.8c.6-3.2 1.9-3.8 3.2-8 .2-4-3.2-3.5-2.2-6 1.8-2.9.9-5.6-2.5-7.7.7 3.7-4.4 7.2-4.4 10.2 0 3 2.6 2.4 2.3 7 .2 2.6-.7 2-1 4.5z"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M831.5 161.7a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -0.8,
          y: 41.3
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -1.1,
          y: 82
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 25.6,
          y: 126.1
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -4.6,
          y: 162.2
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -3.8,
          y: 204.8
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 146.3,
          y: 0.7
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 144.9,
          y: 41.2
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 143.1,
          y: 82.7
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 145.2,
          y: 123.4
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 144.7,
          y: 164.2
        }),
        /* @__PURE__ */ jsx257("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 144.9,
          y: 205.2
        }),
        /* @__PURE__ */ jsxs250("g", {
          fill: "#ffc6b5",
          stroke: "#000",
          strokeWidth: 0.9,
          children: [
            /* @__PURE__ */ jsx257("path", {
              fill: "#ffc72c",
              d: "M915.8 406.3s5.7 13.2 12.2 5c6.5-8 4.2-11.5 4.2-11.5l-14.6-7.9-4.3 9z"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M928.4 404.6s1 .1 1.7-1.3c.8-1.4-1.7-2-2.9-3.6l-1.2 2.5zm-33-3.6-12.8 7s-6.4 1.3-6.8 0c-.5-1.2.1-2.3 3.5-2.5 3.3-.1 12.3-8.4 12.3-8.4l3.8 4zm.2-227.9.4 4.6c.2 1.6-2.5 5-2.6 4.8-.2-.2-1.5.2-1.3 1.1.1 1 2 1.3 2 1.3s-.7 3.3 0 3.5c.8.1-2 4.2 0 5.3 2.1 1.1 5.6 2.6 7.2 2.3 1.6-.4 0 6.1 0 6.1l-4.5 9.5 24.4-2.5-5-8s-2.4-1.7-1.8-6.3c.7-4.5-.3-25.3-.3-25.3l-17.4-2.4zm-4.5 36.2s-7.9 3.6-7.6 13.4c-2 9.5-3.1 19-3.1 19s-9.4 10.6-12.2 14.5c-2.9 3.8-7.2 11.5-8.7 13.6-1.6 2-7.8 8.8-7.7 11.4.2 2.5-1.4 13.8 4.8 15 1.6.7 6.7-13 6.7-13s.3-5.8-1.5-7c-1.7-1 3.8-4.8 3.8-4.8l13-9.7c2.4-2 8.9-9.2 8.9-9.2z"
            }),
            /* @__PURE__ */ jsx257("path", {
              fill: "#fff",
              d: "M900.2 201.8s2 5.6 6.6 4.6 10-5.2 10-5.2 4.3-.2 4.9.5c.6.6 11.6 11.2 11.2 14.5-.3 3.4-5 2.4-6.8 4.6-1.7 2.2-4.6 7.8-3.8 12 .8 4 3.2 9.4 2.9 11.5-.3 2-2 2.7-2 3.8 0 1 1.4 3 1.4 5 0 2.1-2 5.1-1.6 7.2.3 2 .4 8 .4 8l-.4 28s1.6.9 1.7 2.5c.2 1.5 10.8 47.6 10.8 47.6s-.5 1.5-1.6 1.3c-1.1-.2 4.3 7.1 4.4 9.2.2 2 5.6 18.2 5.4 20.4-.1 2.2-1 7.2-1.4 7.3-.5.2 3.5 10.2 2.8 11.7-.6 1.6-7 1.5-7 1.5l-1.8-.4s.1 2.1-1.1 2.3c-1.3.1-10.6-.5-10.6-.5s-2.7 4.1-4.3 4c-1.6-.2-3.7-3-4.1-2.6-.5.5 1.4 3.2 1 4-.6.8-8.6 2.5-10.2-1.3-1.6-3.8 1-2.8.4-3.6-.4-.8-4-2.9-5.2-2.3-1 .7 2.9 1.6 2.7 3.2-.1 1.6-3.5 4-4.7 4-1.3 0-4.3-5.9-8.8-5.3-4.4.7-7.2 1.8-7.2 1.8s-5.3 2.2-7.5 1.7c-2.2-.4-3.2-2.2-3.2-3.1 0-1 1.6-5.1 1.5-6.4-.2-1.2-1.5-2.5-1.5-4.4 0-2 3.7-8.4 3.7-8.4l-.2-29.2s-3.3 0-3.5-2c-.1-2 5.1-46.1 6-49l2.8-13s-2.4 1.2-2.6 0c-.1-1 7.2-26.2 7.2-26.2s1.2-12.6 1.2-15.9c0-3.3-.6-7.9-.6-7.9s-6.5-2.8-6.7-7c-.6-6.7 6.2-10.4 7-12.6l3.2-9s3.5-6 9.2-6.9z"
            }),
            /* @__PURE__ */ jsx257("path", {
              fill: "#ffc72c",
              d: "M897.8 403s-15.4 8-17.6 8.7c-2.2.6-3.6-2.7-1.4-3.3 2.2-.7 5.7-1 5.7-1s-5.2-4.1-5-4.3l7.2-2.6c.2 0 2.2 4 3.6 3.8a31 31 0 0 0 5.6-3.5z"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M919.4 407.4c1.5 1.9 2 5.1 5.4 3.2 3.3-1.9-1.7-5.4-1.7-5.4z"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M925.5 407.1s1.6 1.3 3-.2c1.4-1.4-2.8-4.4-2.8-4.4l-2.1 2.4zm6.8-190.1c.2 0 5.2 15.6 5.9 19.6.6 4 2.7 19.8 1.9 22-.8 2.2-8.9 12.8-9.8 15.5-1 2.7-6.7 13-6.7 13s-1.4 10.2-2 10.6c-.7.5 1.6 3 1.4 3.8-.3 1-4.6 5.4-6.5 5-2-.5-5-2.7-5-4.8-.3-2 0-8.9 1.5-10.6 1.4-1.8 8.9-19.3 9.3-20.4.5-1.2 6.8-15 7-17.3.2-2.4-2-7.9-4.2-9.9-5-14.7-3-23.5 7.2-26.5z"
            }),
            /* @__PURE__ */ jsx257("path", {
              fill: "#9c5100",
              d: "M895 172.2s3.6.5 5.5-.6 4.1-1.6 5.7.6c1.6 2.2 2.7 2 2.7 2s-2.4 6 0 6.6c2.3.6 3.5.6 3.6 1.4.2.8-2 2.5-1.4 3.3.6.8 1.7 1.7 1.9 2.4.1.6-1.4 3.3-1 4 .5.6 2 3.1 2.9 3.1 1 0 .3 4 3.2 3 2.8-1 2.7-3.5 2.7-3.5s3-.4 3.8-3.1c.7-2.7 2.6-3.4 2.6-3.4s3.8-2-1.2-5.2c0-22.2-14.6-19.8-14.6-19.8s-1.7-4-4.6-3.5c-2.8.5-3 3.8-5 3.5-2.1-.3-2.6-1.7-2.7-1.6-.2.2-2 3.4-2 4.1 0 .8-5.5-1-5 3 .5 4.2 3.2 4 3 3.7z"
            }),
            /* @__PURE__ */ jsxs250("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx257("path", {
                  d: "M920.8 208s-14.1 9-13.8 12.2m17-10.6s-3.2 3.5-3.4 3.5m7.6.3s-7 5.7-5.9 9.3m-27-15.5s-2.1 4.3-1.6 5.7c.4 1.4 4 6.8 4.4 10.1.5 3.4 0 5.7 0 5.7m-6.5-13.6s.6 5 1.6 6 3.5 5.3 3.8 7m-6.7 8.1s4.2 2 8-5.9m6.1-5.5c-.1 0-3 7.7 2.1 10.6 5 2.9 8.9 2.5 11 1.7 2.3-.7 4.7-2.2 4.7-2.2m-20-.6s.3 10.4 15.7 20.7m-15-10.9s-.2 9.2 5.8 13.3m-9-24.1s-4.6 13.7-8.3 15m6.9-5s-.2 9.8-1.5 13.3m-1.2 2.4s3.1 4 6.6 3.6c3.5-.3 5-4.4 7.3-3.8 2.4.7 4.6 2.6 10.1 2.1m-7.9 4.1s0 8.1 1.5 8.9c1.4.8.7 8.2.7 8.2m-21.5-20.9s-.2 7.6-1.1 10.3c-1 2.7-2.9 7.3-2.5 11.3m-6.1 4.4c.8-.3 3.5-2.7 3.5-2.7m1.4 1.7s-6.8 29.2-4.9 46.6m6.5-45.1s-3.5 21.8-1.9 26m.2-26.7 13.3 1m1.9-1.8s3.6 2 8.7 1.6m-10.3 9.1s-.6 37.3-1.6 45.6m21.1-37.1s4.1 32.8 6.5 35.8m-14.4-31.7s2.5 29 4 31.6m-40 10.1s5-1.6 9.4-6.3c5 6.8 12.8.3 12.8.3s12 8.2 17.4-1c8.3 5.4 12.4-.8 12.4-.8s3 4.6 5.2 4.1m-13.1 3.2s6.1 29 15.3 37.2"
                }),
                /* @__PURE__ */ jsx257("path", {
                  d: "M889 347.7s.7 24.2 2.1 41.3m-3.3-13.9s-.8 15.8-1.7 17m-7.6 1.5s1.7 6.9 10.4.5c8.7-6.3 8.9 2.4 9.2 3.3.3 1 1.7 7.8 5 2.1m7-9.3s-1.4 14 11.1 3.8c12.5-10.3 14.6-.2 15 3m-25.9-230.2s-1.1 7 6.3 6.3c-1 3.9 2 5.1 2 5.1m5.4 4.3c.2 0 3.4 2 0 4.6m-10.7.9s1.6 2 3.3 1.5c1.8-.5 4.6 1.7 4.6 1.7s2.4.8 2.7.3m-20.3 2.5s5.4 2.1 9-6.4m-18.9-2.6 3.1.2M858.5 285l.3 6.9m-6.8-7.5s4.5 7.5 4 11.4"
                }),
                /* @__PURE__ */ jsx257("path", {
                  strokeLinejoin: "round",
                  d: "M894.1 188.2h2.9l-2.5 1.1M911.7 300s3.3-.4 3.2 5.2c2.1-7 6.4-7.1 6.4-7.1"
                }),
                /* @__PURE__ */ jsx257("path", {
                  strokeLinejoin: "round",
                  strokeWidth: 1.7,
                  d: "M898.1 179.3c.5 0 2.2-.6 2.5-.1.4.4-1.9.8-2.5.1z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs250("g", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.9,
          children: [
            /* @__PURE__ */ jsx257("path", {
              fill: "#ffc72c",
              d: "M900.3 458.6a160.4 160.4 0 0 0 109.6-50.7c-.4-.4 8.9-13.4 16.3-11.6 7.4 1.9 18.1 23.7 31.1 28.4 6.5 10.2-1.8 19.5-4.6 21.3-2.8 1.9-15.4 7-17.2-.4-1.9-7.5-5.6-6-5.6-6s-59.5 58-128.2 55.7c-71 .4-129.6-55.8-129.6-55.8l-5.1 5.6s-5.6 6-8.4 5.6c-2.8-.5-14.9-8.4-15.8-16.3-1-7.9 7.4-13 7.4-13s20.5-15.8 22.8-24.1c4.7-4.7 13.5 3.2 13.5 3.2s53.9 61.8 113.8 58z"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "M748.9 422.6s5.5-1.4 7.5.9 16 16 16 16"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "m761.5 429.1-5.6 4.1s14 2.8 10.8 12m285.6-23s-2.7-1.5-7 1.7c-4.4 3.3-15.3 15.5-15.3 15.5"
            }),
            /* @__PURE__ */ jsx257("path", {
              d: "m1039.9 428.7 6 4.6s-12.5.9-9.8 12.7"
            })
          ]
        }),
        /* @__PURE__ */ jsx257("path", {
          d: "M819.7 437.4c-.4 1-1.4 0-2.2.2-2 0-3.8 1.4-5.6 2.4l-18.4 10.7c-.6-.2-.5-.7-.3-1.2l5-23c.2-1.3.6-3-.7-4-.5-.4.3-1.1.7-.4l9.4 6.7c-.3.9-.9.2-1.4-.1-1.3-1.3-2.9-.1-2.8 1.5l-3.4 15.1c4.2-2.4 8.4-4.8 12.6-7.4 1.4-.6 2.5-2.6 1-3.8-.6-.4-1.6-1.3-.6-1.5zm6.6 32c-.2.6-.5.7-1 .3l-11-6c.1-.7.4-.8.9-.4 1 .7 2.6 1 3.4-.2l4-7.3 5.6-10.2c.8-1.3-.1-2.8-1.3-3.3-.4-.2-1-.4-.5-.8.2-.3.8.3 1.1.4l10.6 5.8c-.1.6-.4.7-.9.3-1-.7-2.6-1-3.4.2l-4 7.3-5.6 10.2c-.8 1.2.1 2.8 1.3 3.3zm42.6-10-3 8.4c-1.3-.1-.4-1.7-.8-2.5a9.5 9.5 0 0 0-7-8.2c-3-.8-6 .7-7.8 3.1a22.9 22.9 0 0 0-4.4 12.2 7 7 0 0 0 3.2 6.4 10 10 0 0 0 5.9 1.5l2.1-6.3c.3-1.4-1.2-2.3-2.3-2.6-.2-.4.2-1 .7-.5l11 4c0 1.3-1.6-.2-2.5.4-1.3.5-1.4 2.1-2 3.3l-1.3 3.8c-5 .3-10-.7-14.4-3.2-4.1-2.6-7-7.7-6.1-12.7.6-4.3 3.3-8.3 7.2-10.2 3.6-2 8-1.9 11.8-.4 2 .7 3.8 2 5.4 3.4 1 1.3 2.8 1.3 3.6-.1zm17.9 28.8c0 .4 0 .9-.6.6l-12.6-1.9c0-.5 0-.9.6-.6 1 .2 2.6.2 3-1 .6-1.7.7-3.5 1-5.2l2.2-14.6c.3-1 0-2.2-1.1-2.6-.7-.3-1.3-.3-2-.5 0-.4 0-.8.6-.6l12.6 2c0 .4 0 .8-.6.6-1-.3-2.5-.2-3 1-.6 1.6-.7 3.4-1 5.1l-2.2 14.6c-.3 1 0 2.3 1.2 2.7l2 .4zM921 480l-.5 8.9-22.6 1.1c-.1-.5 0-.8.6-.7 1.1 0 2.6-.5 2.8-1.8l-.3-6.6-.7-13.4c.1-1.3-1-2.3-2.3-2.2-.4-.2-1.5.4-1.4-.3-.2-.6.7-.3 1-.4l12.6-.7c0 .6 0 .9-.7.8-1.1 0-2.6.2-3 1.6-.1 1.9.1 3.8.2 5.7l.7 14c0 1.1 1 2.2 2.2 2 1.8-.1 3.7 0 5.5-.5 2.5-.7 3.8-3.2 4.5-5.5.5-.6 0-2.2 1-2zm17.5-21.8c-.6 0-.3.8-.5 1.2-1 7.5-1.9 15-3 22.4-.2 1.7-.6 3.6-2.2 4.4-.6.3-.1 1.2.5.7l7.5-2.3c-.1-1.2-1.6 0-2.4-.3-1.7 0-2-2.1-1.7-3.4 0-1 .2-1.8.3-2.7l8.6-2.6c1.1 1.4 2.3 2.7 3.3 4.2.8 1.4-1 2-2 2.3-.6 0-.2 1 .3.6l11.3-3.4c0-1.3-1.6 0-2.3-1-2.2-1.5-3.7-3.7-5.4-5.7zm0 9 6 7.3-7.3 2.2zm38.6-25.8 3.3 6c-1 1-1.6-1.1-2.5-1.4a4.7 4.7 0 0 0-5.5-.5l-2 1.1 9.8 18.3c.5 1.5 2.4 1.8 3.7 1 .4-.4.9-.6 1 .1-1.6 1-3.5 1.9-5.2 2.8l-6.5 3.5c-.5-.5-.2-.8.4-1a2.4 2.4 0 0 0 1.1-3.7l-9.7-18c-1.8 1-4 1.8-4.5 4-.5 1.5.2 3.2.2 4.4-.5.6-.7-.2-1-.6l-2.7-5.2zm15.3-9.1 6.2 8.3c1.4-1 2.6-2.6 2.2-4.4.2-1.4-1.8-3-1.1-4 .4-.2.7.8 1 1.1l7.2 9.5c-1 1-1.6-1.1-2.6-1.4-1.4-1-3.3-1.5-4.8-.4-1.1.4-1 1-.3 1.7 1.6 2.1 3.2 4.4 5 6.5 1 1 2.4 0 3.3-.8 2.4-1.6 4.5-4.2 4.4-7.2.2-1.4-.7-2.8-.7-4 .6-.7.7.4 1 .8l3.4 6-17.6 13.3c-.7-.5 0-.9.5-1.2 1.6-1 1.1-3.1 0-4.2L988.1 437c-1-1.3-2.8-.6-3.7.3-.5.6-1-.5-.3-.6l16.5-12.5 4.5 6c-1 1-2-1.3-3.1-1.4-2.2-1.2-4.8-.3-6.6 1.2l-3.1 2.3"
        })
      ]
    })
  ]
});
var Vg_default = SvgVg;

// src/country-flag-icons/generated/Vi.tsx
import { jsx as jsx258, jsxs as jsxs251 } from "react/jsx-runtime";
var SvgVi = (props) => /* @__PURE__ */ jsxs251("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx258("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#369443",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "M204.3 315s-.5-3.6 6.2-6.1c6.6-2.6 7.2-12.2 5.8-18.6 0 0-3.4 6-7.7 8.1 0 0-6.8 3.6-7.2 10.4 0 0 0 2.5-.5 4.5-.3 1-3.4-8.6 2.4-15.8 6-7.3 7.6-13.3 2.9-25 0 0-.5 7-5.1 11.1-4.7 4-5.3 4.4-5.2 14 0 0 0 3.4-1.7 4.5 0 0-3.6-5.3-4.6-8.8-1-3.5-1.4-5 2.8-9 0 0 13.2-8.7 3.7-27.4 0 0-.3 6.4-5 10.2-4.5 3.9-4.2 6.4-4.4 13-.2 6.7-.6 6.2-1.1 7.2 0 0-8.5-15.6-2-23.8 6.5-8.3 10.2-10 3-25.4 0 0 .3 8-5.5 11.8-5.7 4-4.4 13-4.4 13s.4 3.5-.8 6c0 0-8.1-15.9-.4-24.4 6.6-7.3 7-12.4 3.5-22.6 0 0-.4 4.7-4 7.3-3.7 2.6-6.6 5.1-5.9 15 0 0 .3 7-.6 9 0 0-3.4-6.4-4.4-10.5-1-4.2-1.3-6.6 1.2-10.7s12.5-16 .6-33c0 0-.3 5.5-3.4 10.5-3 5-1.6 10.9-1 15.4.7 4.5-1.5 8.9-1.5 8.9s-5.2-9.5-4-20.4c1-11-3.4-20-13.5-26.4 0 0-7.3 17 2.7 25.7 0 0 8.5 8.4 10.7 18.6 0 0-6.5-.6-12.3-12-5.9-11.4-18-9.6-18.8-9.7 0 0 2 17.6 20.6 22.6 0 0 12 2 14.2 10.8 0 0 2 6 2.8 9.2 0 0-3.8-1.5-7.3-6.7-3.5-5-3-5.7-14.8-6.9 0 0-4.7-.5-7.2-3.9 0 0 5 18.6 17.7 18.5 0 0 11.6-1.3 18 14l-2.9-2c-1.7-1.1-6-3.3-14.5-2.3s-10.9-.4-13-1c0 0 8.6 15.7 20.7 11 12.2-4.7 18 12.4 18.2 12.7 0 0-1.7-1.2-3.8-3.3-2.2-2.1-6.6-4.7-15-2 0 0-6.1 2.3-12.3.4 0 0 6 11.5 19.8 9.5a15.1 15.1 0 0 1 17.3 10.2s-1.8-1-3-2c-1.3-1-6-3.7-16-.8-10 3-13.6-.4-13.6-.4s5.5 10 16.2 11.3c0 0 6-.1 8.4-1 2.5-1 9.2-2.5 13.8 4.2 0 0-1.3.2-3.2-.7 0 0-7-2.5-12.5 2 0 0-4.8 4.9-11.6 4 0 0 8.8 8.5 22.8 1.3 0 0 4.7-3.4 8.2-.8 3.5 2.7 11.5-2.6 11.5-2.6z"
    }),
    /* @__PURE__ */ jsxs251("g", {
      fill: "#f4c53d",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      children: [
        /* @__PURE__ */ jsx258("path", {
          d: "M282.2 103.7s-1.6-14.5 10-16a38 38 0 0 1 18 1.2l5.5 10.6-2 7.2-7.4 3.4s1.3-11-8.8-11.2c-2.6 0-4 1-8.1.3s-6.3 3.8-7.2 4.5z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M363.8 139.6c-1.8 2.2-8.7 3-8.7 3s7.1 5.5 10.2 13.3c3 7.7-82.4 0-82.4 0s3.8-2.6 6.3-7.6c0 0-3.8 1.4-7.6-2.4 0 0 2.8 1 6.5-4.6 0 0 5.5-7 9.4-9 0 0-1.8 1.2-6.1-1.2 0 0 7.4-1 10-13.5 0 0 .5-2.8 3.3-7 2.8-4 2.2.9 7.4-5.4 0 0 2.4-4.4.3-7-2-2.8-4.3-1.8-8.6-4.4-4.4-2.6-6.3-4-4.8-8s5.3-3.4 5.9-3.4.8-3.5 5.5-5.9 17.4-1.3 19.2-.3c2 1 9.5 3.3 14 14.5 4.4 11.2-1.2 15.4 10.8 32.4 0 0-4.8 1-7.9 0 0 0 6.3 11.2 17.3 16.5z"
        }),
        /* @__PURE__ */ jsx258("path", {
          fill: "none",
          d: "M311 92.2c-10-.5-6.1-9.8-6.1-9.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M328 93.5s-1.7-.8-3.2-2.8c-2-2.7-6.7-4-9.1-1.4 0 0-2.5 2.8-4.8 3 0 0 2.6.7 4.3 2.3 1.7 1.6 3.5 2.8 6.1 2.4 2.6-.3 3-1.7 4.2-2.5 1.3-.8 2.5-1 2.5-1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#369443",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "M202.8 336.5s-.2-6.4 7.8-6.8l23.5 32.7s-.9 2.1-11.5 1.9c0 0-1.2 0-1.8 1.2-.9 2-18-29-18-29z"
    }),
    /* @__PURE__ */ jsxs251("g", {
      id: "vi_svg__a",
      fill: "#f4c53d",
      stroke: "#010002",
      strokeWidth: 10,
      transform: "translate(3.6 26.2) scale(.15055)",
      children: [
        /* @__PURE__ */ jsx258("path", {
          d: "M1495 1807.9s-49.9 85.6-110.2 87c0 0-103.7-12.6-133 14.5-20.5 18.9-41.4 34.5-50 82.8-8.4 48.3 16.5 58.7 22.4 60.8 0 0 4.6 34.5 38.7 25.5 0 0 2 36 62.2 18.7 60.3-17.3 85.3-11.8 97-71.8 11.9-60.1 22.8-59.1 33.5-66.3 14.4-9.7 41.5-18.8 61.6-30.4 18-10.4 87.2-45.6 110.8-48.3 23.6-2.8 18.4-82.2 18.4-82.2h-61l-29.5-43.5zm192-429.4s-61 49.7-112.2 0c0 0-20.6 24.8-62 17.6-41.2-7.3-48.1-29-52-41.4 0 0-35.8 20.8-66 4.3-30-16.4-30-41.3-30-41.3s-52.5 10.4-79.4-25.2c-26.9-35.5-10.5-70.7 4-74.9 0 0-56.7 14.9-72.2-33.8a56 56 0 0 1 16.4-62.8s-119.4-.6-168.4-38c0 0-40.7-25.6-16.4-52.5 0 0-107.5-17.2-134.4-60 0 0-11.8-11.8-7.9-32.5 0 0 .7-11.7 12.5-12.4 0 0-122.6-19-158-59.4 0 0-17-18.6-8.5-43.5 0 0 1.8-6.5 4.7-11 0 0-111.6-23.5-166.6-73.2 0 0-31.8-28.3-15.4-66.3 0 0-186.5-51-143.3-133.2 0 0-87.2-28.3-59.6-107 0 0-72.1-36.6-40.7-94.6 30.1-55.5 122.6 9.7 232 40 0 0 296.4 93.2 442.3 118l414.6 617.3 241.9 93.2z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M1689.9 923.9s-38.9-29.2-108.2 5.1c0 0-23.3 16.1-41.7-1.5a37.3 37.3 0 0 1 4.3-57.5c51.7-38.3 70.8-153.2-7.8-200.9 0 0-114-67.6-532.3-174 0 0-35-9.8-53.8-5.1a52 52 0 0 0-37.6 37.8S894 581.1 957 611.6c0 0 28.4 13 57.7 21.4 0 0-32.2-7-46 24.8-13 30.4 6 61.5 65 81.5 0 0 16 6.2 38.7 11.7 0 0-50.5 14.5-26.2 55.3 0 0 21.6 42.8 98 50.4 0 0-57 6.2-16.8 60.4 0 0 17.7 29.7 73.4 40.7 0 0-42.2 1.4-21 39.3 21.4 38 71.5 59.4 120.9 62.9 0 0 26.7 1.4 45.4-2.8 0 0-47 23.5-19.4 62.8 0 0 20.3 28 71.1 26.6 0 0-13.1 44 24.1 60.6 29 13 53.1-7.8 53.1-7.8s-9.8 47.1 32.5 63.7c0 0 21.1 10.9 52.6 0 0 0 24 53.9 109.6 16 85.6-37.7 20.2-355.1 20.2-355.1zm5 489.4s-12.5 67.4-112 152.2c0 0-76.8 67.7-74.9 145.7 2 79.5-13.7 88.4-43.9 115.3 0 0 62.3 4.9 92.4-36.6 0 0-1.3 69-10.5 75.3 0 0 19.6 1.2 47.9-29.7 0 0 17-18 32.8-24.9 0 0-18.4 47.7-4 91.9 0 0 4.6-17.3 28.9-24.9 0 0 44-9 61-72.5 0 0 11.1-42 80-79.4 0 0 78-29.4 76-67.8-2-38.5-173.6-244.6-173.6-244.6z"
        }),
        /* @__PURE__ */ jsx258("path", {
          strokeMiterlimit: 10,
          d: "M2056.5 2282.2s-17.9 78.8-80 72.5c0 0-43.9-4.2-40.6-77.4 0 0-64.9 34.6-75.4-51 0 0-59 13.7-58.3-66.3 0 0-55 9.6-48.5-61.5 0 0-59.7 16-59.7-51 0 0-139.6-23.2 151.4-288.6l259.6 154.6z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M2085.4 1928.3s-43.3 38.4-74.1-19c0 0-42-2-48.5-33.8 0 0-34.1-3.4-40.7-35.9 0 0-46.5-4.8-45.2-44.1 0 0-84.6-6.6 0-102.4 84.6-95.8 228.1 159 228.1 159zm48.2-23.8c42 0 89.5 262 77.2 419.9-4.5 57.3-35.2 104.1-77.2 104.1s-72.6-46.8-77-104.1c-12.4-157.9 35.1-419.9 77-419.9"
        }),
        /* @__PURE__ */ jsx258("ellipse", {
          cx: 2133.6,
          cy: 1902.5,
          rx: 58,
          ry: 86
        }),
        /* @__PURE__ */ jsx258("path", {
          fill: "none",
          strokeMiterlimit: 10,
          d: "M1935.9 2277.3s6.6-138.7 126.8-337.6m-202.2 286.6s-18.7-80.1 150.8-317c0 0-19.7-56.5 40.6-92.8M1802.2 2160s-5.3-86.7 160.6-284.5c0 0-14.7-51 45.4-91.8m-254.5 314.8s6.2-87.6 168.4-258.9c0 0-8-52.4 50-84.9m-278 292.8s11.7-100.1 182.8-252c0 0-5.9-39.4 51.1-79.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          fill: "none",
          d: "M372.3 432s134.3 77.8 552.9 155.6M431.9 539S795.6 657.6 965 672.2m-389.9 0s213.4 67 463.3 109.3m-281.2 30.3s241 57.9 356.2 67.5M919 925.6s203.9 42.5 255.5 47.6m-125.7 57.3s148.8 22.6 208 21.4m-23.2 69s60.2-2.8 89.1-7.6m-33.4 104.3s51.2-13.8 81.3-33.1m-5.9 133.2s39.4-15.2 58.4-56.6m37.7 93.6s30.4-27.3 32.4-57.7m81.6 81.5s-11.4-9.9-3.6-52.7m-11.1-62.8s-6-12.2-4-31.6m-211-581.3s68.8 27.6 91.7 65.6c23 38 7.9 74.9 0 96-3.9 10.7-52.4 104.2 4.6 171.9M1346 1057s.4-.3 24.6-8m-169.8-91.4s41 8.2 81.3 8.6m-138-109.8s48.2 4.9 93.5 4.2m-165.2-109.8s69.5 13.8 106.8 14.5M1014.7 633s85.7 24.4 149.4 33.1m141.6 50.4s-61.6 57.3 12.5 110.5c0 0-30.8 48.3 30.8 98.7m-16.4 23.8s-9.2 92.2 103.6 92.2c0 0-21.7 82.1 87.2 79.4 0 0 12.4 65.6 91 52.4M1441.3 1895s-17.9 4-56.6 0m-108.8 48.3s-54.4-8.3-51.8 109.8m84.6-82.9s-49.2-6.2-46 108.4m520.7-384.5s-23.6 4.8-40 23.5c-16.3 18.6-47.8 15.1-47.8 15.1s17-13.8 23-48.3c5.8-34.5 24.9-44.9 24.9-44.9m-56.3-32.6s-23.6 4.8-40 23.4c-16.4 18.7-47.9 15.2-47.9 15.2s17-13.8 23-48.3c5.9-34.5 24.9-44.9 24.9-44.9m23.7 188.5s-20.6 4.3-34.9 20.5c-14.3 16.3-41.8 13.3-41.8 13.3s15-12 20-42.2c5.2-30.1 21.8-39.2 21.8-39.2"
        })
      ]
    }),
    /* @__PURE__ */ jsx258("use", {
      xlinkHref: "#vi_svg__a",
      width: "100%",
      height: "100%",
      stroke: "#010002",
      strokeWidth: 10,
      transform: "matrix(-1 0 0 1 647.2 0)"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m466 256-14.3 61.7-5.9-4.2 14-59.2-9.8.2 23.1-42.3 1.5 48.7zm37 13-43 50.8-4.6-5.2 42.8-50.2-8.7-4.6 39.2-26-20.3 43.8z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m492.6 242-38.5 74-5.9-3.5 38.7-73.8-9.4-2.4 32.7-34.6-10.5 47.5zm-48 96.6-2.9 11.7 8 8-11.2 47-10-13.3-14.6 6.8 11.1-47 10.4-3 2.6-11.7s3.2-1.2 6.6 1.5z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m447.3 330.8-5.7 10.6 5.7 9.7-22.4 42.5-6.3-15.6-15.9 2.6 22.4-42.4h10.7l5.5-10.6s4 0 6 3.2z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m448.2 333.9-15 19.2 3.4 10.8-30.9 36-2.8-16.6-16-1.2 30.8-36 10.4 2.5 16-20.4s4.4 2.2 4.1 5.7zm-382.7-45c3.6-1.5 6.2-2.9 6.2-6.7 0-1-.5-3-1.5-6.1L46 202a59 59 0 0 0-3-7.9c-1.1-2-3.2-2.9-6.1-4h30.7c-3.3 1.5-6.4 2.7-6.3 6.3 0 1.3.4 3.2 1.1 5.7l18.6 58 18.5-58a20 20 0 0 0 1.1-5.7c0-3.7-3.2-5-6.3-6.4h29.8c-2.7 1.1-5 2-6 4.1a63 63 0 0 0-3.1 8L90.8 276a37.9 37.9 0 0 0-1.5 6.1s-1.1 4.7 6.2 6.7zm515.3-7.6v-83.7c0-1.4-.3-2.5-.8-3.3s-2.5-3-5.5-4.2h27.7a11.5 11.5 0 0 0-5.5 4.2c-.5.8-.7 1.9-.7 3.3v83.7c0 1.5.2 2.6.7 3.4.5.8 2.5 2.8 5.5 4.2h-27.7c3-1.4 5-3.4 5.5-4.2.5-.8.8-1.9.8-3.4z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#fff",
      stroke: "#010002",
      strokeWidth: 1.5,
      d: "M324.8 309.8S399 276.9 399.1 201H250.5c.2 76 74.3 108.8 74.3 108.8z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#a60032",
      stroke: "#010002",
      strokeWidth: 1.5,
      d: "M262 201v48.5s5.6 11.3 11.4 18.3V201zm22.8 0v80s7.2 7 11.4 10.4V201zm22.9 0v98.9s8.1 5.2 11.4 7v-106h-11.4zm80 0v48.5s-5.7 11.3-11.5 18.3V201zm-22.9 0v80s-7.1 7-11.4 10.4V201zm-22.8 0v98.9s-8.2 5.2-11.5 7v-106H342z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#162667",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "M399.1 145.8s-36.4 19-74.3-1.6c-37.9 20.6-74.3 1.6-74.3 1.6V201h148.6z"
    })
  ]
});
var Vi_default = SvgVi;

// src/country-flag-icons/generated/Vn.tsx
import { jsx as jsx259, jsxs as jsxs252 } from "react/jsx-runtime";
var SvgVn = (props) => /* @__PURE__ */ jsxs252("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx259("defs", {
      children: /* @__PURE__ */ jsx259("clipPath", {
        id: "vn_svg__a",
        children: /* @__PURE__ */ jsx259("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs252("g", {
      fillRule: "evenodd",
      clipPath: "url(#vn_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx259("path", {
          fill: "#da251d",
          d: "M-128 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx259("path", {
          fill: "#ff0",
          d: "M349.6 381 260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"
        })
      ]
    })
  ]
});
var Vn_default = SvgVn;

// src/country-flag-icons/generated/Vu.tsx
import { jsx as jsx260, jsxs as jsxs253 } from "react/jsx-runtime";
var SvgVu = (props) => /* @__PURE__ */ jsxs253("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx260("defs", {
      children: /* @__PURE__ */ jsx260("clipPath", {
        id: "vu_svg__a",
        children: /* @__PURE__ */ jsx260("path", {
          d: "M0 0v475l420-195h480v-85H420Z"
        })
      })
    }),
    /* @__PURE__ */ jsx260("path", {
      fill: "#009543",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx260("path", {
      fill: "#d21034",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsxs253("g", {
      clipPath: "url(#vu_svg__a)",
      transform: "scale(.71111 1.01053)",
      children: [
        /* @__PURE__ */ jsx260("path", {
          stroke: "#fdce12",
          strokeWidth: 110,
          d: "m0 0 420 195h480v85H420L0 475"
        }),
        /* @__PURE__ */ jsx260("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 60,
          d: "m0 0 420 195h480m0 85H420L0 475"
        })
      ]
    }),
    /* @__PURE__ */ jsxs253("g", {
      fill: "#fdce12",
      transform: "translate(-22) scale(1.01053)",
      children: [
        /* @__PURE__ */ jsx260("path", {
          d: "M106.9 283v27c23.5 0 69.7-18 69.7-76.1 0-58.1-49.3-68.9-64-68.9-14.8 0-60.3 10.6-60.3 58 0 47.6 44.7 52 53.5 52 8.8 0 41.8-8 38-43.6a35.5 35.5 0 0 1-35.4 31.5c-24 0-39-17.8-39-35.4 0-17.6 14.6-41.2 39.9-41.2 25.3 0 43.8 22.5 43.8 45.1 0 22.7-17.8 51.5-46.2 51.5z"
        }),
        /* @__PURE__ */ jsxs253("g", {
          id: "vu_svg__b",
          children: [
            /* @__PURE__ */ jsx260("path", {
              stroke: "#fdce12",
              strokeWidth: 0.8,
              d: "m86.2 247.7 1.4 1s11.2-25.5 41.1-43.6c-3.8 2-23.8 12-42.5 42.6z"
            }),
            /* @__PURE__ */ jsx260("path", {
              d: "M89.1 243.3s-3.4-7-.4-10.2c3-3.1 1.7 8.3 1.7 8.3l1.3-1.9s-2-8.6.2-10.4c2.3-1.9 1.2 8.3 1.2 8.3l1.4-1.8s-1.5-8.4.7-10c2.3-1.6.9 8 .9 8l1.6-2s-1.2-8 1.5-9.9c2.7-1.9.3 7.6.3 7.6l1.8-2s-.8-7.3 1.5-9c2.3-1.6.4 7 .4 7l1.6-1.8s-.5-6.8 1.7-8.4c2.3-1.6.2 6.5.2 6.5l1.7-1.6s-.4-6.9 2.4-8.2c2.8-1.3-.5 6.4-.5 6.4l2-1.6s.5-8 2.9-8.7c2.4-.8-1 7-1 7l1.7-1.4s.9-6.8 3.5-7.6c2.7-.9-1.6 6.2-1.6 6.2l1.7-1.3s1.9-6.8 4.4-7.6c2.4-.7-2.6 6.5-2.6 6.5l1.7-1.2s2.7-6.2 5-6.6c2.1-.4-2.6 5.1-2.6 5.1l2.1-1.2s3.5-6.4 4.8-4.5c1.2 2-5 4.9-5 4.9l-2 1.2s7.5-3.6 8.4-1.8c.9 1.8-10.3 3-10.3 3l-1.8 1.2s7.5-2 6.6-.1c-1 1.9-8.4 1.5-8.4 1.5l-1.7 1.2s7.5-1.8 6.5 0c-1 1.6-8.3 1.5-8.3 1.5l-1.8 1.5s7.3-2 6.2.3c-1 2.2-9.4 2.1-9.4 2.1l-2 2s7.7-2.7 7-.6c-.6 2-9.4 3-9.4 3l-2 2s8.3-2.7 5.8-.2c-2.4 2.6-8.5 3.2-8.5 3.2l-2.3 3s8.2-5 7-2.2c-1.1 2.8-9.2 4.7-9.2 4.7l-1.6 2s7.4-4.3 6.6-2c-.7 2.5-8.6 5-8.6 5l-1.3 1.8s8.7-5.2 8-2.5c-.8 2.6-9.1 4.5-9.1 4.5l-1 1.7s8-4.7 8-2.4c.2 2.2-9.4 4.4-9.4 4.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx260("use", {
          xlinkHref: "#vu_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 220 0)"
        })
      ]
    })
  ]
});
var Vu_default = SvgVu;

// src/country-flag-icons/generated/Wf.tsx
import { jsx as jsx261, jsxs as jsxs254 } from "react/jsx-runtime";
var SvgWf = (props) => /* @__PURE__ */ jsxs254("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx261("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx261("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx261("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Wf_default = SvgWf;

// src/country-flag-icons/generated/Ws.tsx
import { jsx as jsx262, jsxs as jsxs255 } from "react/jsx-runtime";
var SvgWs = (props) => /* @__PURE__ */ jsx262("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs255("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx262("path", {
        fill: "#ce1126",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx262("path", {
        fill: "#002b7f",
        d: "M0 0h320v240H0z"
      }),
      /* @__PURE__ */ jsx262("path", {
        fill: "#fff",
        d: "m180 229.3-20.7-14-19.9 14.1 6.5-24.9-19-15.2 24.5-1.5 8.1-23.6 8.8 24 24 .7-19 16.3zm-3.6-165.6L159.8 53l-16 10.4 4.4-20-14.6-12.7 19.4-1.6 7.2-18.6 7.4 18.7 19.1 1.7L172 44.3zm-73 59.5-16-11-16.7 11 5.2-19.4L60.8 91 80 90l7-19 6.8 18.9 19.6 1.1-15 12.5zM250 110l-15.4-10-15 10 4.4-18.3-14-11.8 18.3-1.5 6.3-17.2 7 17.4 17.7 1-13.7 12.3zm-43.1 43.4-10.3-6.4-10.3 6.6 2.7-12.3-9.2-8.3 12-1 4.6-11.6 4.9 11.6 11.9 1-9.1 8.3z"
      })
    ]
  })
});
var Ws_default = SvgWs;

// src/country-flag-icons/generated/Ye.tsx
import { jsx as jsx263, jsxs as jsxs256 } from "react/jsx-runtime";
var SvgYe = (props) => /* @__PURE__ */ jsx263("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs256("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx263("path", {
        fill: "#fff",
        d: "M0 0h640v472.8H0z"
      }),
      /* @__PURE__ */ jsx263("path", {
        fill: "#f10600",
        d: "M0 0h640v157.4H0z"
      }),
      /* @__PURE__ */ jsx263("path", {
        fill: "#000001",
        d: "M0 322.6h640V480H0z"
      })
    ]
  })
});
var Ye_default = SvgYe;

// src/country-flag-icons/generated/Yt.tsx
import { jsx as jsx264, jsxs as jsxs257 } from "react/jsx-runtime";
var SvgYt = (props) => /* @__PURE__ */ jsxs257("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx264("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx264("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx264("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Yt_default = SvgYt;

// src/country-flag-icons/generated/Za.tsx
import { jsx as jsx265, jsxs as jsxs258 } from "react/jsx-runtime";
var SvgZa = (props) => /* @__PURE__ */ jsxs258("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx265("defs", {
      children: /* @__PURE__ */ jsx265("clipPath", {
        id: "za_svg__a",
        children: /* @__PURE__ */ jsx265("path", {
          fillOpacity: 0.7,
          d: "M-71.9 0h682.7v512H-71.9z"
        })
      })
    }),
    /* @__PURE__ */ jsx265("g", {
      clipPath: "url(#za_svg__a)",
      transform: "translate(67.4) scale(.93748)",
      children: /* @__PURE__ */ jsxs258("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx265("path", {
            fill: "#000001",
            d: "M-71.9 407.8V104.4L154 256.1z"
          }),
          /* @__PURE__ */ jsx265("path", {
            fill: "#000c8a",
            d: "m82.2 512.1 253.6-170.6H696V512H82.2z"
          }),
          /* @__PURE__ */ jsx265("path", {
            fill: "#e1392d",
            d: "M66 0h630v170.8H335.7S69.3-1.7 66 0"
          }),
          /* @__PURE__ */ jsx265("path", {
            fill: "#ffb915",
            d: "M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192z"
          }),
          /* @__PURE__ */ jsx265("path", {
            fill: "#007847",
            d: "M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
          }),
          /* @__PURE__ */ jsx265("path", {
            fill: "#fff",
            d: "M23 0h59.2l253.6 170.7H696V204H324.3zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
          })
        ]
      })
    })
  ]
});
var Za_default = SvgZa;

// src/country-flag-icons/generated/Zm.tsx
import { jsx as jsx266, jsxs as jsxs259 } from "react/jsx-runtime";
var SvgZm = (props) => /* @__PURE__ */ jsxs259("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx266("defs", {
      children: /* @__PURE__ */ jsx266("clipPath", {
        id: "zm_svg__a",
        children: /* @__PURE__ */ jsx266("path", {
          fillOpacity: 0.7,
          d: "M-170.7 0H512v512h-682.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs259("g", {
      fillRule: "evenodd",
      clipPath: "url(#zm_svg__a)",
      transform: "translate(160) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx266("path", {
          fill: "#198a00",
          d: "M-256 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx266("path", {
          fill: "#ef7d00",
          d: "M421.9 184H512v328h-90.1z"
        }),
        /* @__PURE__ */ jsx266("path", {
          fill: "#000001",
          d: "M331.9 183.8h90v328h-90z"
        }),
        /* @__PURE__ */ jsx266("path", {
          fill: "#de2010",
          d: "M240 184h91.9v328h-92z"
        }),
        /* @__PURE__ */ jsxs259("g", {
          fill: "#ef7d00",
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx266("path", {
              strokeLinejoin: "round",
              d: "M451.6 65.6s34-14.5 37.2-17.5c1.5 1.8-13.6 20-42.9 26.7 26.6-6.2 49.3-26 54-25.4 1.3.3 1 19.3-60 35.8 42.2-11 66.7-31.4 66.4-29.2.3.5-4.2 16-41.1 28.1 10.3-2.4 38.3-19.4 38-16.1.9 1.3-27 37.2-77.6 25.5 40.4 10.5 66.5-14.8 70.2-14.3.8.1-7.4 22-58.2 23.4 24.3-2.5 17.3-.1 17.3-.1s-14.3 11.2-31.7 3.6c13.6 3.7 15.1 3.9 15.4 5-.9 1.6-12 3.8-22.9-2 8.7 3.6 16.5 4.2 16.6 5.5-.1.4-5.6 3.6-10.6 1.3-4.9-2.2-50.3-30.1-50.3-30.1l77.4-21.3 2.8 1zm-91 75.6c-6.8 0-7 6-7 6s-.5.5-.2 3.4l1.7-2.6c.8.1 3.9 1 8.8-2.8-4.5 4.7-1.8 6.4-1.8 6.4s-1 3.7 2.4 4.4c-1-1.5-.4-2.8-.4-2.8s4.8-.5 4.5-6.3c.1 5.3 3 6.6 3 6.6s0 2.9 3.1 3.2c-1.6-1.5-1.3-3.8-1.3-3.8s4-3 .7-8c2-1.2 3.7-4.5 3.7-4.5s-2.8-1.2-4.1-2.2c-.6-1.3 0-8.5 0-8.5l-1.8-9.3-4.8 14.5c.2-2 .3 6.3-6.5 6.3z"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinejoin: "round",
              d: "M394.2 120.3c.2.1 5.1 5.6 9.9 5.3 1.8-1.5-3.7-4.7-3.7-5.5 2 1.8 10.1 8.8 15.4 6.3 2-3-3.8-2.5-10.2-10.6 4.5 3 15.7 9.5 21 7 2.1-2.4-11.7-9.9-16.4-15.7l-12-6.1-16.2 13.3 12.3 6z"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M375.9 74.8s5.5-3.2 27.6-1.6c2.4.3 15-4.3 19.1-5.7 6.4-1.2 27-5.6 32.4-9.8 4-.5-1 7.1-6 9-5.2 2.3-24.1 8.9-30.9 8 8.1.1 3.6 6.7-9.8 3.6 6.4 3.6 4 4.2 4 4.2s-11.3.6-14.3-2c7.6 2.9 4.4 4 4.4 4s-7.7.7-11.3-1c5.5 1.7 2.7 2.7 2.7 2.7s-4.5.8-8.2-.6c-3.8-1.3-9.4-10.7-9.7-10.7z"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinejoin: "round",
              d: "m384.7 123.4.8 14.6-.8 1.2c-.3.4-10.3-1.6-9 6 0 3.2 0 4 2.2 5.7-.5-2-.4-3.5-.4-3.5s2.9 1.7 5.6-3c-1.9 4.6-.6 6.3-.1 6.4.4.8-.8 4.5 3 4.4-1.5-1.4-.8-3.4-.8-3.4s4-.6 2.6-7.7c1.4-1.4 2 0 2 0s.4 4.2 3.9 3.3c1.5.9-.3 3.2-.3 3.2s2.5 0 3.3-2c.7-2.2 1.6-6-2.5-7.6-.5-1.5 1.6-1.6 1.6-1.6s2.6.9 3.4 2.2.5-3.4-2.8-4c-4 0-4.2-.9-4.2-1l-1-13.7z"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M398.6 135.8c0-.7-6.8-9.9-5-11 1.7.3 4.5 4.5 6.9 3.1-.7-1.6-2.8-.7-5.1-4.9-2.4-4.8-2.7-11.9-11-19.6 5.4 8.2 17.4 13 18 10.6s-10.7-11.4-10.1-13.6c2.2 4.4 13.4 14.4 21.6 13.6.6-2-6.7-5.8-8.6-9.4-5.3-3.6-19.4-15.7-19.6-18.5a33.3 33.3 0 0 0-9.9-10.6 5 5 0 0 1-.8-1.7c-3.2-7.5 1-10 3.5-10.3 2-.3 2.6 0 4-.7l-5.1-2c2.3 1.7 8 .2 6.8 5 2.5-1 7.9-7.4-6.1-8.8-4.6-5.2-23.3-8.2-28 14.6.4.3.6.6 1.8 1.4-6-2.8-21.9-5-27.6-6-15.6-4.4-31.7-15.2-33.2-13.9-2 1 9.4 11.6 8.8 11.8a263 263 0 0 0-27.5-13.6c-6-2.2-11.9-7.4-12.5-6.4-2.2 4.5 9.5 15.9 11.7 17.2 2.2 1.3 19.3 9.3 19 9.4-25.8-11.7-30-13.9-31.4-15.2-2.3-.5-7.8-8-9.3-7.5-.9.8.8 12.6 13.1 18 2 1.4 26.4 10.1 26.2 10.8 0 .2-28-11.5-29-12-5.4-2-12-9.4-13.2-8.6-1.2.8 3 8.8 8.4 11.3 2.9 1.2 13.8 6.6 23.6 10 .6.3-17.7-6.9-26.5-10.5-4-2.2-5.8-5-6.4-4.4-1 .6 1.4 12.4 29.7 19 .7.4 10-2.1 9.5-1.8a113.3 113.3 0 0 1-15.8 2.8c-.3.8 1.8 5 16.4 4.2 1.8-.1 12-3.7 11.1-3a174 174 0 0 1-14.8 4.9c-.9 0-5.6.6-5.8 1-.2.8 3.5 3.8 11.3 4.2 7 .4 20.2-4.2 20-3.9-.4.3-12.8 4.6-13.1 4.8-.5.3-5 .5-5.2.9-.4.9 6.6 7.4 27.1.4-2 2.8-12 4.7-12 5.2 0 .4 2.2 2.5 5.7 3.3 1.7.4 4.1.3 6.3 0 4-.8 8-2.3 13.3-7.2.6 1.5-13.1 8.5-12.5 9.1 3 2.8 12.9-.3 13.5-.7.7-.3 19-10.7 19-12 .3 1.6-23.7 14.7-23.4 15.2 1.5 2.4 9.7-.1 10-.4l10.8-5.8c.3-.1-11.8 7-10.8 8.2-.5 4.7 19-3.2 20.5-4.2.7-.5-9.4 4.4-9.4 6.7 3.3 5.5 13.7 3.8 15.3 2.6.8-.6-1 4-.4 3.6a16 16 0 0 0 3-4.3c-.2 1.6-1.4 4-2 6.8-.7 2.7-.9 5.9-1.8 9.2-.2 1.4 6.4-2.9 5.4-13.2.6 5.4-2 15.4-1.3 16 1.3 1 5.2-5 5.6-9.1 1.1 2 3.5 6.3 5.6 7.3-.2-3.1 0-3-1-6 .6-4.1.7-9.7.8-16.1 5.6 10.7 7.9 15.3 6.3 23.5 1.7.7 4.3-5.8 4.1-9a13.3 13.3 0 0 0 11.5 10.2"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M305.4 67.7s-3.9 2.9-8.6 2.7c1.2 4.8 11 1.1 11 1.1s-4.7 5.3-8.1 6.1c2 1.7 10.6 1.1 12 .3 1.4-.9 4-4.2 4-4.2s-8.8 10.2-10 10.1c-.3 1.2 9.1.8 11-1 2-1.8 7-4.4 7-4.4s-13 9-13.5 9c4.8 1.2 14.5-1.6 20.7-5.4-9.2 6.1-10 7.2-14.7 9.3 4.2.9 6.3 3.7 20.3-2.4 8-3.8 12.6-10.8 12.6-10.8a81.7 81.7 0 0 1-21.6 18c-.5 1 9.4 5.2 21.9-7.9"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeWidth: 1.1,
              d: "M373.4 96s.9 4 4.3 7 3.6 6 3.6 6m-9.5-39s1.1 3.7 4.6 6c3.6 2.2 9 9.4 9.3 10.7.4 1.5 2.5 12.6 2.3 13.8m-37.8-25c.2 1.5-5 8.3 2.2 16.4-6.6 8-6.6 9-6.6 9s3.7 2 10.2-3.6c10.8 13.2 7.2 19.2 7.2 19.2"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M362.3 107.2s-1-1.4.8-6.7c1.6 2 3.4 2.3 4.1 3 .8.9 9 2 9.4 7.5"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeWidth: 1.1,
              d: "M371.9 57.5c0-.4-1.7-4-7.8.4 3.3.2 6.5 2.1 7.8-.4z"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M430.1 73.5c.3.2 18.2 4 24.2 2.1-7.6 10.2-22.9 3.3-22.9 3.3 7.5 2.2 7.8 2 10.2 4.2.8 2-13.8 1-18.5-1.7 13.3 4.2 13.6 4 14 5.5.6 2.3-21.8-.6-23.7-3.5 6 4.6 9.2 5.5 12.5 7.6-4 1.8-11.5 3.6-25.2-6.1 18 16.4 34.3 15.4 36.9 18.3-6.3 9.3-30.7-5.5-41.9-13s24.5 18.1 27.8 17.7c-1.6 2.5-13.4.3-14.2-1"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeWidth: 1.1,
              d: "M434.7 90.7c-2 .3-8.3.3-9.2.1"
            }),
            /* @__PURE__ */ jsx266("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M300.1 65s13.6 7.2 19.4 6.7a10 10 0 0 1-3.8 2c1.4.6 5.4 2.7 11.4 1.4l-3.3 3s5.2 2 11-1a46.4 46.4 0 0 0-2.8 3.7l4.1.3"
            })
          ]
        })
      ]
    })
  ]
});
var Zm_default = SvgZm;

// src/country-flag-icons/generated/Zw.tsx
import { jsx as jsx267, jsxs as jsxs260 } from "react/jsx-runtime";
var SvgZw = (props) => /* @__PURE__ */ jsxs260("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx267("defs", {
      children: /* @__PURE__ */ jsx267("clipPath", {
        id: "zw_svg__a",
        children: /* @__PURE__ */ jsx267("rect", {
          width: 546,
          height: 420.1,
          x: 1.9,
          y: 0.1,
          fill: "#00f",
          fillRule: "evenodd",
          ry: 0
        })
      })
    }),
    /* @__PURE__ */ jsxs260("g", {
      clipPath: "url(#zw_svg__a)",
      transform: "matrix(1.1722 0 0 1.1426 -2.3 -.1)",
      children: [
        /* @__PURE__ */ jsx267("path", {
          fill: "#006400",
          d: "M0 0h840v420H0z"
        }),
        /* @__PURE__ */ jsx267("path", {
          fill: "#ffd200",
          d: "M0 60h840v300H0z"
        }),
        /* @__PURE__ */ jsx267("path", {
          fill: "#d40000",
          d: "M0 120h840v180H0z"
        }),
        /* @__PURE__ */ jsx267("path", {
          fill: "#000001",
          d: "M0 180h840v60H0z"
        }),
        /* @__PURE__ */ jsx267("path", {
          stroke: "#000",
          strokeWidth: 20,
          d: "M0 0v420l280-210z"
        }),
        /* @__PURE__ */ jsx267("path", {
          fill: "#fff",
          d: "M0 0v420l280-210z"
        }),
        /* @__PURE__ */ jsx267("path", {
          fill: "#d40000",
          d: "M106.5 104.4 162 275.1 16.8 169.6h179.5L51 275.1z"
        }),
        /* @__PURE__ */ jsx267("path", {
          fill: "#fc0",
          d: "m82.8 253.7 9.8-1.8 18.1-.7 6.7.6 15 2.5 1.1-1.5V242l1.8-9.3 3-9.4 3.3-7.5 4.2-7.8 6.8 1.7h1.8l.2-1.3-14.4-12.3-15-11.5-21.7-16.2-2-.5-2.3-17-1.7-5.1-2.3-2-4.3-1.4-4.8.2-2.2 1.2-4.6 1-2.4.4-1.6 1.9-.2 2.4 6.7.2 1.7.7-.2.7-3.8.5-1.8.6 2.1 1.6 2.2.8 2.8 1 .6 2 .2 25.8-1.5 4-.5 7.5 2.2 9-5.6 6.4L77 216l-.6 3.5-1.7 3.5-.2 2.2 1.1 2.4 4.3 14.2 2.2 11.7z"
        }),
        /* @__PURE__ */ jsx267("path", {
          d: "M88 142c-1.8 0-2.6.2-4.3 1.1a10.8 10.8 0 0 1-4.6 1.4c-2.5 0-4.5 1.8-4.5 4.1v1.5l3.6-.1c10.6.3 1 1.3.2 1.4-2.6.5.6 2.6 3.7 3.7 3.3 1 3.1.4 3.1 15 0 11.9 0 13.6-1 16.3-1.3 4-1.3 10 0 14 .6 1.6 1 3 1 3.3 0 .2-1.6 2.1-3.5 4.3-3.5 4-5.6 8.1-5.6 11a6 6 0 0 1-1 2.6c-1.3 1.7-1.3 4.6-.1 5.7 1.3 1.2 6.6 21.8 6.7 25.7 0 1.4.2 1.4 8.3-.2 6.6-1.3 22.1-1.6 30-.6 3.6.5 7.8 1.3 9.3 1.6 4.8 1.3 4.6 1.5 4.6-4.3a74 74 0 0 1 5.1-26.7 94.7 94.7 0 0 1 6.9-14s1.8.2 4 .8c4.1 1 5.3.9 5.3-1 0-1-4.3-4.6-25.4-21a432.2 432.2 0 0 0-26.3-19.9c-.6 0-1.2-.3-1.3-.7l-1.5-9.5c-.7-4.9-1.7-9.7-2.1-10.7-1.4-3-4.1-4.5-8.6-4.8a31.2 31.2 0 0 0-2 0m.1 1h2c6.6.4 7.8 2.2 9.6 14a173 173 0 0 1 1.2 9.4c0 .8-.9 1.8-3.2 3.3a46.8 46.8 0 0 0-10 9.5l-1.3 1.8-.3-4.2V165c.3-8.7 0-9.5-2.8-10.5-2.3-.8-5.3-1.6-4.5-2.1 1-.6 2-.2 4.4-.9 1-.2.9-.1.7-.9-.2-1.3-1.6-2-5.3-1.8-3 .2-3.3.1-3.1-.7.4-1.6 2-2.6 4.5-2.9a13.4 13.4 0 0 0 4.4-1.3 7 7 0 0 1 3.7-1zm14.9 25.8h.4c1.7.3 50.8 38.7 50.8 39.8 0 .4-.4.7-1 .7-.4 0-12.9-3.5-27.7-7.8-23.6-7-27-8-28-9.3a5.1 5.1 0 0 1-.1-6.2 5 5 0 0 0 1-2c0-1.2-2.5 1.8-3 3.5-.5 2 .5 5.4 2 6.5.6.5 5.1 2 10 3.5 8.4 2.4 9 2.7 9.4 4.1 1 3.3-2.5 7.2-7.5 8.3a14.6 14.6 0 0 0-5.2 2.4 68.2 68.2 0 0 1-17.2 10.4c-.4.3-.9 1.9-1.2 3.4-.6 3.3-.8 3.8-1.8 3.8-.5 0-.6-.3-.2-1.4.7-2 .6-4.4-.1-4.4-.5 0-.7.7-.7 1.8 0 1-.3 2.2-.7 2.5-.5.6-.6.2-.4-2.3.2-1.7.1-3-.1-3-.5 0-1.4 2.5-1.7 4.7-.2 1.3-.2 1.3-.6-.3-.3-1.2-.2-2 .7-3.5a9 9 0 0 0 1-3.5c0-1.3 1-2.6 5.7-7.3 3-3.1 6.7-7 8-8.7 2.3-2.8 2.4-3 2.3-5.9 0-1.6-.2-3.1-.4-3.3-.6-.6-1.4 2.6-1 4.3.2 1.6 0 2.1-3.3 6a113.2 113.2 0 0 1-7.5 7.8c-3.9 3.6-5.3 5.6-5.3 7.4 0 .6-.4 2-1 3.3s-.8 2.6-.6 2.9c.2.3 0 .3-.3 0-.5-.5-.5-1.3-.1-3a7 7 0 0 0 .2-2.6c-.5-1-1.2.2-1.5 2.7-.2 1.4-.5 2.5-.8 2.3-.7-.4-.5-3 .4-4.4.5-.7 1-2.3 1.3-3.6.7-3.7 2.3-6.7 5.8-10.7a57.5 57.5 0 0 0 3.2-3.8l-1-3.3a25 25 0 0 1-.2-13.7c1.3-3.8 3.9-7.6 8-11.7 4-3.9 7.9-6.3 10-6.4m15 32.2a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.5.3a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.6.5a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.4.5a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m-6.3.6a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.4.4a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m5.2.2a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m-2.7 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m5 .6c.1 0 3.7.8 8 2l7.9 2.3-1.5 2.7a96.2 96.2 0 0 0-2.4 4.4c-1 2-1.2 2-6 .9-5.2-1.2-13.4-2.3-21.8-3l-8-.7 3-1.1a50.4 50.4 0 0 0 5.3-2.4c2-1.1 2.8-1.3 5.9-1 4.5.3 7.5-.6 8.7-2.4l1-1.7zm-8.8.6a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m5.6 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.6 0 .9.6 0 0 1 .7-.6zm-8 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5zm5.3.2a.9.6 0 0 1 1 .5.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5m-6.6 1.1a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.5 0a.9.6 0 0 1 1 .7.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.6.2a.9.6 0 0 1 1 .5.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5m2.8 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m-20.3 8.1a191.2 191.2 0 0 1 35.1 4.2c.1.1-.6 2.5-1.7 5.4l-2 6c-.1.5-.8.5-2.5.3-8.3-1.3-32.3-1.2-41.5.2-5.3.8-6 .7-5.6-.4l1-3.5.6-2.7L93 221a63.4 63.4 0 0 0 10.2-6.5h.9zm-27 14.2c.3 0 .9.3 1.6.8 1 .6 2.2 1.1 2.7 1.1 2.6 0 4 3.7 6.2 16l.8 4.4c.2 1 0 1.2-2.3 1.7-2.8.6-3.5.7-3.5.3 0-1-2.8-13.7-4-18.2a96.9 96.9 0 0 1-1.6-6 .1.1 0 0 1 .1 0zm28.6 2h2.9l-1 1c-1.7 2-2.5 2.1-3.7.8a5 5 0 0 1-1-1.5c0-.2 1.3-.4 2.8-.4zm6.1 0h5.4l-1.2 1.2c-1.4 1.6-1.5 1.6-3 0l-1.2-1.3zm8.2 0h1.3c.7 0 2 0 2.8.2l1.5.3-1.4 1.3c-.8.7-1.5 1.3-1.6 1.2l-1.4-1.6zm8.5.3 1.2.3c.7.2 2.2.3 3.3.4h2l-1.5 1.3a8.9 8.9 0 0 1-1.8 1.3c-.1 0-1-.8-1.7-1.7zm-30.2.1h.2c.1.2-.3 1-1 1.7l-1 1.4-1.5-1.2-1.5-1.3 2.4-.3zm2.3.2 1.6 1.4 1.6 1.5-3 .2-3 .1 1.4-1.5zm18 0c.3 0 .5.1.8.3a6.6 6.6 0 0 1 1.3 1.7c.4.8.3 1-1 1l-2.5-.5-1.2-.3 1.3-1.3c.6-.6 1-1 1.4-1zm-8.3 0c.5 0 1 .3 1.6 1.3.7 1.1.7 1.1-2 1.1h-2.7l1.4-1.3c.7-.7 1.3-1 1.7-1zm17 .2 1.2 1.2c1.4 1.3 1.6 2.1.6 2l-2.8-.3-2.2-.2 1.6-1.3zm-35.2.7c.2 0 1 .5 1.6 1.2l1.2 1.3-2.5.4-3.5.5c-.7.2-.5-.3 1-1.6 1-1 2-1.8 2.2-1.8m-3.7 0h.4c.8.2.8.4-.6 1.8l-1.5 1.5-.5-1.3c-.4-1-.3-1.3.6-1.7a4.8 4.8 0 0 1 1.6-.3m46 1.8c.2 0 .2.2 0 .6-.2.8-1.1 1-1.1.2 0-.2.3-.5.7-.7zm-21.4 1.6c7.7 0 15.5.2 17.4.4 3.1.4 3.4.5 3.4 1.7 0 1.4-.4 1.5-4.6.8-1.2-.3-6.3-.7-11.2-1.1a149.6 149.6 0 0 0-28.5 1c-1.9.2-2.4 0-2.4-.6 0-1.3 10.2-2.2 25.9-2.2m-10.3 2.9h5.4l-1.2 1.3c-1.5 1.6-1.6 1.6-3 0zm7 0 1.4 1.4 1.4 1.6-2.9.1h-2.9l1.5-1.6zm2.1 0h5.4l-1.2 1.3c-1.4 1.6-1.5 1.6-3 0zm-12.8 0c.2 0 0 .5-.7 1.5-.7.9-1.4 1.6-1.5 1.6-.2 0-.9-.6-1.5-1.3l-1.2-1.3H96a9 9 0 0 0 2.7-.4 1 1 0 0 1 .4 0zm2 .5 1.3 1.2 1.5 1.3-2.6.2-2.9.2 1.4-1.5zm17.4 0 1.4 1.6c1.6 1.7 1.5 1.8-2.1 1.1l-1.7-.3 1.2-1.2zm2 0h2.4c2.6 0 2.9.4 1.4 1.8-1.2 1-1.2 1-2.6-.5zm-30.6.5c1.2 0 1.1.1-.4 1.6-1.1 1.1-1.2 1.1-1.6.3-.3-1 .6-1.8 2-1.9m38.8.2c.4 0 1.2 0 2 .2l2.3.4-1.3 1.2-1.2 1.2-1.1-1.4-1-1.6zm-36 .5c.3 0 .6.2 1.1.7 1 1 1 1 .2 1.4a8 8 0 0 1-2.4.4H90l1.3-1.4c.7-.7 1-1 1.3-1.1zm34.1.3c.4 0 .7.2 1.2 1l.9 1.2h-2.1c-1.4 0-2-.2-2-.6.2-.4.7-1 1.3-1.3zm6.4 1.3c.2 0 .2.2.2.5 0 1-.9 1.7-1.3 1-.1-.3.1-.8.5-1.1zm-25.9 1.2c8.7 0 18.3.6 24 1.6l1.6.3v4.4c0 3.3-.2 4.4-.7 4.4l-5-1a126 126 0 0 0-35-1l-2.3.3-.6-3.7a21 21 0 0 1-.4-3.8s2.3-.5 5-.8c3.3-.5 8.2-.7 13.4-.7"
        }),
        /* @__PURE__ */ jsx267("path", {
          id: "zw_svg__b",
          d: "M124.8 217.8c-3 0-5.1 2.1-5.1 5.2 0 4.8 5.4 7.2 8.6 3.8s1-9-3.5-9m0 1.2a4 4 0 0 1 4 4c0 3-3.3 5-6 3.7-2.7-1.5-2.5-6.1.4-7.3a4.3 4.3 0 0 1 1.5-.4z"
        }),
        /* @__PURE__ */ jsx267("use", {
          xlinkHref: "#zw_svg__b",
          width: "100%",
          height: "100%",
          x: -20.1,
          y: -0.6
        }),
        /* @__PURE__ */ jsx267("path", {
          d: "M88 145.3a1.7 1.8 0 0 0-1.6 1.7 1.7 1.8 0 1 0 3.5 0 1.7 1.8 0 0 0-1.9-1.7m.1.6a1.2 1.1 0 0 1 1.2 1.1 1.2 1.1 0 1 1-2.4 0 1.2 1.1 0 0 1 1.2-1.1"
        })
      ]
    })
  ]
});
var Zw_default = SvgZw;

// src/uds/components/IconCountryFlag/IconCountryFlag.tsx
import { jsx as jsx268 } from "react/jsx-runtime";
function modSize3(sizeName = 16) {
  return css15`
  & > svg {
    height: ${sizeName}px;
    width: ${sizeName}px;
  }
`;
}
var IconWrapper3 = styled20.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize3($size)}
`;
function IconCountryFlag({ className, glyph, size, ...attrs }) {
  const GlyphComponent = generated_exports[glyph];
  if (GlyphComponent === void 0) {
    console.error(`Icon: No icon found for glyph "${glyph}"`);
    return null;
  }
  return /* @__PURE__ */ jsx268(IconWrapper3, {
    className,
    $size: size,
    children: /* @__PURE__ */ jsx268(GlyphComponent, {
      ...attrs
    })
  });
}
IconCountryFlag.displayName = "IconCountryFlag";
var IconCountryFlag_default = withStyleModifiers(styled20(IconCountryFlag)``, {
  modSize: modSize3
});

// src/uds/components/Menu/Menu.tsx
var Menu_exports = {};
__export(Menu_exports, {
  Content: () => Content5,
  Item: () => Item5,
  LinkItem: () => LinkItem,
  Root: () => Root8,
  Trigger: () => Trigger3
});
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { styled as styled22 } from "styled-components";

// src/uds/components/Menu/MenuItem.tsx
import React3 from "react";
import { styled as styled21 } from "styled-components";
import { Fragment, jsx as jsx269, jsxs as jsxs261 } from "react/jsx-runtime";
var ItemWrapper2 = styled21.button`
  width: 100%;
  min-height: ${tokPx("semantics_controls_m_min_height")};
  padding: ${space("primitives_space_8")};
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
  border-radius: ${radius("primitives_corner_radius_l")};
  position: relative;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    color: inherit;
    background-color: ${tok("primitives_color_neutral_100")};
  }

  ${focusOutline()}


  &:focus-visible:hover {
    outline: none;
  }
`;
styled21(ItemWrapper2)`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
var RightSlot = styled21(Typography_default)`
  margin: 0 0 0 auto;
  color: ${tok("semantics_content_secondary_color")};
`;
var TextCell = styled21.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  text-align: left;
`;
var SupportingText = styled21(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
`;
function Content3({ children, glyph, rightSlot, supportingText }) {
  return /* @__PURE__ */ jsxs261(Fragment, {
    children: [
      glyph ? /* @__PURE__ */ jsx269(IconCell_default, {
        glyph,
        size: "sm"
      }) : /* @__PURE__ */ jsx269(IconCell_default, {
        glyph: "QuestionMarkInCircle",
        size: "sm",
        hidden: true
      }),
      /* @__PURE__ */ jsxs261(TextCell, {
        children: [
          /* @__PURE__ */ jsx269(Typography_default, {
            $variant: "body-m-regular-tight",
            children
          }),
          supportingText && /* @__PURE__ */ jsx269(SupportingText, {
            $variant: "body-s-regular-tight",
            children: supportingText
          })
        ]
      }),
      rightSlot && /* @__PURE__ */ jsx269(RightSlot, {
        $variant: "body-m-regular-tight",
        children: rightSlot
      })
    ]
  });
}
var MenuItem = React3.forwardRef(({ children, glyph, rightSlot, supportingText, ...rest }, forwardedRef) => {
  return /* @__PURE__ */ jsx269(ItemWrapper2, {
    ref: forwardedRef,
    ...rest,
    children: /* @__PURE__ */ jsx269(Content3, {
      glyph,
      children,
      rightSlot,
      supportingText
    })
  });
});
var MenuLinkItem = React3.forwardRef(({
  children,
  glyph,
  rightSlot,
  ...rest
}, forwardedRef) => {
  return /* @__PURE__ */ jsx269(ItemWrapper2, {
    as: "a",
    ref: forwardedRef,
    ...rest,
    children: /* @__PURE__ */ jsx269(Content3, {
      glyph,
      children,
      rightSlot
    })
  });
});

// src/uds/components/Menu/Menu.tsx
import { jsx as jsx270 } from "react/jsx-runtime";
var PositionMap = {
  "top": { side: "top", align: "center" },
  "bottom": { side: "bottom", align: "center" },
  "left": { side: "left", align: "center" },
  "right": { side: "right", align: "center" },
  "top-left": { side: "top", align: "end" },
  "top-right": { side: "top", align: "start" },
  "bottom-left": { side: "bottom", align: "end" },
  "bottom-right": { side: "bottom", align: "start" }
};
var ContentWrapper = styled22(DropdownMenu.Content)`
  background-color: ${tok("semantics_views_background_color")};
  padding: ${space("primitives_space_8")};
  border-radius: ${tokPx("semantics_overlays_corner_radius")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};
  min-width: 280px;
  display: flex;
  flex-direction: column;
`;
var DropDownMenuItem = styled22(DropdownMenu.Item)`
  &:focus-visible {
    border-radius:  ${radius("primitives_corner_radius_l")};
    background: ${tok("primitives_color_neutral_100")};
  }
`;
var Root8 = DropdownMenu.Root;
function MenuContent({ children, position = "bottom", ...rest }) {
  const { side, align } = PositionMap[position];
  return /* @__PURE__ */ jsx270(DropdownMenu.Portal, {
    children: /* @__PURE__ */ jsx270(ContentWrapper, {
      align,
      side,
      collisionPadding: 8,
      ...rest,
      children
    })
  });
}
var Content5 = styled22(MenuContent)``;
function Item5({ children, glyph, asChild, onSelect, ...rest }) {
  return /* @__PURE__ */ jsx270(DropDownMenuItem, {
    asChild: asChild != null ? asChild : true,
    onSelect,
    children: /* @__PURE__ */ jsx270(MenuItem, {
      glyph,
      ...rest,
      children
    })
  });
}
function LinkItem({
  children,
  glyph,
  ...rest
}) {
  return /* @__PURE__ */ jsx270(DropdownMenu.Item, {
    asChild: true,
    children: /* @__PURE__ */ jsx270(MenuLinkItem, {
      glyph,
      ...rest,
      children
    })
  });
}
function Trigger3({ children, ...rest }) {
  return /* @__PURE__ */ jsx270(DropdownMenu.Trigger, {
    ...rest,
    asChild: true,
    children
  });
}

// src/uds/components/Fields/PhoneField/PhoneField.tsx
import { jsx as jsx271, jsxs as jsxs262 } from "react/jsx-runtime";
var BaseFieldStyled2 = styled23(BaseField)`
  padding-right: ${space("primitives_space_12")};
  cursor: auto;
  &:has(div:focus) {
    outline: none;
  }
`;
var PhoneFieldCountry = styled23.div`
  display: flex;
  height: ${space("primitives_space_40")};
  padding: 0px ${space("primitives_space_4")} 0px ${space("primitives_space_8")};
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: ${tok("primitives_color_neutral_50")};
  border-radius: ${radius("primitives_corner_radius_m")} 0px 0px ${radius("primitives_corner_radius_m")};
  border-right: 1px solid ${tok("semantics_dividers_color")};
  ${focusWithinOutline(-4)};
`;
var IconCountryFlagWrapper = styled23(IconCountryFlag_default)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${space("primitives_space_4")};
`;
var IconArrowWrapper = styled23(Icon_default)`
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
`;
var CountryCodeText = styled23(Typography_default)`
  gap: ${space("primitives_space_8")};
`;
var OverFlowMenu = styled23(Menu_exports.Content)`
  width: ${tokPx("primitives_area_size_240")};
  max-height: calc((${space("primitives_space_40")} * 5) + (${space("primitives_space_40")} * 0.25));
  overflow-y: hidden;
  padding: ${space("primitives_space_0")};
  border-radius: ${radius("primitives_corner_radius_l")};
  background: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};
`;
var PhoneField = forwardRef3(
  ({
    children,
    countries,
    id,
    hintMessage,
    errorMessage,
    label,
    placeholder,
    $horizontalLabel,
    $disabled,
    value,
    countryCode,
    status = "default",
    onPhoneChange,
    onCountryChange,
    ...rest
  }, ref) => {
    var _a;
    const [open, setOpen] = React4.useState(false);
    const [selectedCountry, setSelectedCountry] = React4.useState(
      (_a = countries.find(({ code }) => code === countryCode)) != null ? _a : countries[0]
    );
    const [isCountryChanging, setIsCountryChanging] = React4.useState(false);
    const [visiblePhoneValue, setVisiblePhoneValue] = React4.useState(
      typeof value === "string" ? value.replace(`+${selectedCountry.code} `, "").trim() : ""
    );
    React4.useEffect(() => {
      if (isCountryChanging) {
        const currentPhoneWithoutCode = visiblePhoneValue.trim();
        onPhoneChange && onPhoneChange({
          phoneNumber: currentPhoneWithoutCode,
          countryCode: selectedCountry.code
        });
        setIsCountryChanging(false);
      }
    }, [selectedCountry, isCountryChanging, onPhoneChange, visiblePhoneValue]);
    React4.useEffect(() => {
      if (value) {
        setVisiblePhoneValue(value.replace(`+${selectedCountry.code} `, "").trim());
      }
    }, [value, selectedCountry]);
    const handleCountryClick = (country) => {
      setIsCountryChanging(true);
      setSelectedCountry(country);
      onCountryChange && onCountryChange(country);
      setOpen(false);
    };
    const handleChange = (event) => {
      const newPhoneValue = event.target.value;
      setVisiblePhoneValue(newPhoneValue);
      if (!isCountryChanging) {
        onPhoneChange && onPhoneChange({
          phoneNumber: newPhoneValue,
          countryCode: selectedCountry.code
        });
      }
    };
    return /* @__PURE__ */ jsxs262(BaseFieldStyled2, {
      ...rest,
      status,
      tabIndex: -1,
      children: [
        /* @__PURE__ */ jsxs262(Menu_exports.Root, {
          onOpenChange: setOpen,
          open,
          children: [
            /* @__PURE__ */ jsx271(Menu_exports.Trigger, {
              "data-country-selector": true,
              children: /* @__PURE__ */ jsxs262(PhoneFieldCountry, {
                tabIndex: 0,
                children: [
                  /* @__PURE__ */ jsx271(IconCountryFlagWrapper, {
                    glyph: selectedCountry.icon,
                    size: 16
                  }),
                  /* @__PURE__ */ jsxs262(CountryCodeText, {
                    $variant: "body-s-regular-tight",
                    children: [
                      "+",
                      selectedCountry.code
                    ]
                  }),
                  /* @__PURE__ */ jsx271(IconArrowWrapper, {
                    size: 16,
                    glyph: open ? "ChevronUpExtraSmall" : "ChevronDownExtraSmall"
                  })
                ]
              })
            }),
            /* @__PURE__ */ jsx271(OverFlowMenu, {
              position: "bottom-right",
              children: /* @__PURE__ */ jsx271("div", {
                style: { overflowY: "auto", padding: "8px" },
                children: countries == null ? void 0 : countries.map((item) => /* @__PURE__ */ jsxs262(Menu_exports.Item, {
                  asChild: false,
                  onSelect: () => handleCountryClick(item),
                  glyph: item.code === selectedCountry.code ? "CheckMarkSmall" : void 0,
                  children: [
                    item.name,
                    " ",
                    "(+",
                    item.code,
                    ")"
                  ]
                }, item.code))
              })
            })
          ]
        }),
        /* @__PURE__ */ jsx271(Input, {
          tabIndex: 0,
          ref,
          name: rest.name,
          disabled: $disabled,
          value: visiblePhoneValue,
          type: "tel",
          onChange: handleChange,
          onBlur: rest.onBlur
        }),
        /* @__PURE__ */ jsx271(StyledValidationIcon, {
          status
        })
      ]
    });
  }
);
PhoneField.displayName = "PhoneField";
var PhoneField_default = styled23(PhoneField)``;

// src/uds/components/Fields/RadioButtonField.tsx
import { jsx as jsx272 } from "react/jsx-runtime";
function RadioButtonField({
  label,
  id,
  disabled,
  className,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsx272(SelectionField, {
    label,
    disabled,
    className,
    variant,
    select: "radio",
    ...rest
  });
}

// src/uds/components/Fields/SearchField.tsx
import * as React5 from "react";
import { styled as styled24 } from "styled-components";
import { jsx as jsx273, jsxs as jsxs263 } from "react/jsx-runtime";
var IconWrapper4 = styled24(Icon_default)`
  padding-left: ${space("primitives_space_8")};
  padding-right: ${space("primitives_space_8")};
  color: ${tok("semantics_content_secondary_color")};
`;
var IconClear = styled24(Icon_default)`
  border-radius: ${tokPx("primitives_corner_radius_full")};
  background-color: ${tok("primitives_color_neutral_100")};
  padding: ${space("primitives_space_2")};
`;
var SearchInput = styled24(Input)`
  padding-left: 0;
`;
var ClearButton = styled24.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space("primitives_space_48")};

  ${focusOutline()}
`;
function SearchField(props) {
  var _a;
  const [internalValue, setInternalValue] = React5.useState(props.defaultValue || "");
  const inputRef = React5.useRef(null);
  const handleOnChange = (e) => {
    var _a2;
    setInternalValue(e.target.value);
    (_a2 = props.onChange) == null ? void 0 : _a2.call(props, e);
  };
  const handleOnClear = () => {
    var _a2;
    if (!(inputRef == null ? void 0 : inputRef.current))
      return;
    inputRef.current.value = "";
    setInternalValue("");
    (_a2 = props.onChange) == null ? void 0 : _a2.call(props, { target: { value: "" } });
  };
  React5.useEffect(() => {
    if (inputRef.current) {
      setInternalValue(inputRef.current.value);
    }
  }, [(_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.value]);
  return /* @__PURE__ */ jsxs263(BaseField, {
    ...props,
    children: [
      /* @__PURE__ */ jsx273(IconWrapper4, {
        glyph: "Magnifier",
        size: 20
      }),
      /* @__PURE__ */ jsx273(SearchInput, {
        defaultValue: props.defaultValue,
        name: props.name,
        disabled: props.disabled,
        onChange: handleOnChange,
        onBlur: props.onBlur,
        placeholder: props.placeholder,
        ref: inputRef,
        autoFocus: true
      }),
      internalValue.length > 0 && /* @__PURE__ */ jsx273(ClearButton, {
        onClick: handleOnClear,
        children: /* @__PURE__ */ jsx273(IconClear, {
          glyph: "DismissSmall",
          size: 16
        })
      })
    ]
  });
}
var SearchField_default = styled24(SearchField)``;

// src/uds/components/Fields/TextArea.tsx
import { forwardRef as forwardRef4 } from "react";
import { styled as styled25 } from "styled-components";
import { jsx as jsx274, jsxs as jsxs264 } from "react/jsx-runtime";
var BaseFieldTextArea = styled25(BaseField)`
  height: ${space("primitives_space_96")};
  padding-right: ${space("primitives_space_12")};

  ${StyledValidationIcon} {
    align-self: flex-start;
    padding-top: ${space("primitives_space_12")};
  }

  & > textarea {
    width: 100%;
    height: 100%;
    resize: none;
    cursor: text;
  }
`;
var TextAreaElement = styled25.textarea`
  ${inputStyles()}
`;
var TextArea = forwardRef4(
  (props, ref) => {
    var _a;
    return /* @__PURE__ */ jsxs264(BaseFieldTextArea, {
      ...props,
      children: [
        /* @__PURE__ */ jsx274(TextAreaElement, {
          ref,
          name: props.name,
          disabled: props.disabled,
          onChange: props.onChange,
          onBlur: props.onBlur,
          value: props.value,
          placeholder: props.placeholder,
          children: Boolean(!props.value) && props.children
        }),
        /* @__PURE__ */ jsx274(StyledValidationIcon, {
          status: (_a = props.status) != null ? _a : "default"
        })
      ]
    });
  }
);
TextArea.displayName = "TextArea";
var TextArea_default = styled25(TextArea)``;

// src/uds/components/Fields/TextField.tsx
import { forwardRef as forwardRef5 } from "react";
import { styled as styled26 } from "styled-components";
import { jsx as jsx275, jsxs as jsxs265 } from "react/jsx-runtime";
var BaseFieldStyled3 = styled26(BaseField)`
  padding-right: ${space("primitives_space_12")};
  ${Input} {
    cursor: auto;
  }
`;
var TextField = forwardRef5((props, ref) => {
  var _a;
  return /* @__PURE__ */ jsxs265(BaseFieldStyled3, {
    ...props,
    children: [
      /* @__PURE__ */ jsx275(Input, {
        ref,
        name: props.name,
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onBlur: props.onBlur,
        placeholder: props.placeholder
      }),
      /* @__PURE__ */ jsx275(StyledValidationIcon, {
        status: (_a = props.status) != null ? _a : "default"
      })
    ]
  });
});
TextField.displayName = "TextField";
var TextField_default = styled26(TextField)``;

// src/uds/components/IndeterminateProgressCircle/IndeterminateProgressCircle.tsx
import { keyframes as keyframes2, styled as styled27 } from "styled-components";
import { jsx as jsx276 } from "react/jsx-runtime";
var loadingIconSpinningAnimation = keyframes2`
  to {
    transform: rotate(360deg);
  }
`;
var IndeterminateProgressCircle = styled27(({ className }) => /* @__PURE__ */ jsx276(Icon_default, {
  className,
  glyph: "Spinner"
}))`
  animation: ${loadingIconSpinningAnimation} 1s linear infinite;
`;
var IndeterminateProgressCircle_default = IndeterminateProgressCircle;

// src/uds/components/InputStepper/InputStepper.tsx
import * as React25 from "react";
import { css as css53, styled as styled85 } from "styled-components";

// src/components/Accordion/Accordion.tsx
import { styled as styled30 } from "styled-components";

// src/components/Icon/Icon.tsx
import { css as css16, styled as styled28 } from "styled-components";

// src/icons/generated/index.ts
var generated_exports2 = {};
__export(generated_exports2, {
  IconAirplane: () => Airplane_default,
  IconAirplaneAndroid: () => AirplaneAndroid_default,
  IconAirplaneApple: () => AirplaneApple_default,
  IconAirplaneDeparture: () => AirplaneDeparture_default,
  IconAirplaneFlexible: () => AirplaneFlexible_default,
  IconAirplaneLeft: () => AirplaneLeft_default,
  IconAirplaneReturn: () => AirplaneReturn_default,
  IconAirplaneRight: () => AirplaneRight_default,
  IconAirplaneTopLeft: () => AirplaneTopLeft_default,
  IconAirplaneTopRight: () => AirplaneTopRight_default,
  IconAmenities: () => Amenities_default,
  IconApps: () => Apps_default,
  IconArrowDown: () => ArrowDown_default,
  IconArrowDownSmall: () => ArrowDownSmall_default,
  IconArrowLeft: () => ArrowLeft_default,
  IconArrowLeftSmall: () => ArrowLeftSmall_default,
  IconArrowRight: () => ArrowRight_default,
  IconArrowRightSmall: () => ArrowRightSmall_default,
  IconArrowUp: () => ArrowUp_default,
  IconArrowUpSmall: () => ArrowUpSmall_default,
  IconAttachment: () => Attachment_default,
  IconBaby: () => Baby_default,
  IconBabyPool: () => BabyPool_default,
  IconBackpack: () => Backpack_default,
  IconBackpackCheck: () => BackpackCheck_default,
  IconBeach: () => Beach_default,
  IconBed: () => Bed_default,
  IconBed2Persons: () => Bed2Persons_default,
  IconBell: () => Bell_default,
  IconBin: () => Bin_default,
  IconBow: () => Bow_default,
  IconBubble: () => Bubble_default,
  IconBuilding: () => Building_default,
  IconBusFront: () => BusFront_default,
  IconBusLeft: () => BusLeft_default,
  IconBusRight: () => BusRight_default,
  IconCake: () => Cake_default,
  IconCalendar: () => Calendar_default,
  IconCalendarCheck: () => CalendarCheck_default,
  IconCamping: () => Camping_default,
  IconCancelled: () => Cancelled_default,
  IconCar: () => Car_default,
  IconCarDoor: () => CarDoor_default,
  IconCarFront: () => CarFront_default,
  IconCertificate: () => Certificate_default,
  IconCheckbox: () => Checkbox_default,
  IconCheckboxCheck: () => CheckboxCheck_default,
  IconChecklist: () => Checklist_default,
  IconChecklistInfo: () => ChecklistInfo_default,
  IconCheckmark: () => Checkmark_default,
  IconCheckmarkCircle: () => CheckmarkCircle_default,
  IconCheckmarkMedium: () => CheckmarkMedium_default,
  IconCheckmarkSmall: () => CheckmarkSmall_default,
  IconChevronDoubleSmall: () => ChevronDoubleSmall_default,
  IconChevronDown: () => ChevronDown_default,
  IconChevronDownSmall: () => ChevronDownSmall_default,
  IconChevronLeft: () => ChevronLeft_default,
  IconChevronLeftSmall: () => ChevronLeftSmall_default,
  IconChevronRight: () => ChevronRight_default,
  IconChevronRightSmall: () => ChevronRightSmall_default,
  IconChevronUp: () => ChevronUp_default,
  IconChevronUpSmall: () => ChevronUpSmall_default,
  IconChild: () => Child_default,
  IconChildSeatHighChair: () => ChildSeatHighChair_default,
  IconChildrenPlaySpace: () => ChildrenPlaySpace_default,
  IconChildrenPlayground: () => ChildrenPlayground_default,
  IconClock: () => Clock_default,
  IconCloud: () => Cloud_default,
  IconClown: () => Clown_default,
  IconCocktail: () => Cocktail_default,
  IconCogwheel: () => Cogwheel_default,
  IconCopy: () => Copy_default,
  IconCreditcard: () => Creditcard_default,
  IconCreditcardCheck: () => CreditcardCheck_default,
  IconCross: () => Cross_default,
  IconCrossCountrySkiing: () => CrossCountrySkiing_default,
  IconCrossMedium: () => CrossMedium_default,
  IconCrossSmall: () => CrossSmall_default,
  IconCrossSquare: () => CrossSquare_default,
  IconCulinary: () => Culinary_default,
  IconCutlery: () => Cutlery_default,
  IconDeleteAccount: () => DeleteAccount_default,
  IconDeposit: () => Deposit_default,
  IconDogPaw: () => DogPaw_default,
  IconDowngrade: () => Downgrade_default,
  IconDownloadCircle: () => DownloadCircle_default,
  IconDownloadFile: () => DownloadFile_default,
  IconDumbbell: () => Dumbbell_default,
  IconDuration: () => Duration_default,
  IconEarth: () => Earth_default,
  IconElevator: () => Elevator_default,
  IconEmergencyPhone: () => EmergencyPhone_default,
  IconEuro: () => Euro_default,
  IconEye: () => Eye_default,
  IconEyeOff: () => EyeOff_default,
  IconFaceSad: () => FaceSad_default,
  IconFacebook: () => Facebook_default,
  IconFamily: () => Family_default,
  IconFile: () => File_default,
  IconFiles: () => Files_default,
  IconFilter: () => Filter_default,
  IconFilterSquare: () => FilterSquare_default,
  IconFire: () => Fire_default,
  IconFlag: () => Flag_default,
  IconFlamingo: () => Flamingo_default,
  IconFunpark: () => Funpark_default,
  IconGift: () => Gift_default,
  IconGolfCart: () => GolfCart_default,
  IconGolfClub: () => GolfClub_default,
  IconGroup: () => Group_default,
  IconHamam: () => Hamam_default,
  IconHeadset: () => Headset_default,
  IconHealth: () => Health_default,
  IconHealthAndSafety: () => HealthAndSafety_default,
  IconHeart: () => Heart_default,
  IconHeartFill: () => HeartFill_default,
  IconHeartsLoveRomance: () => HeartsLoveRomance_default,
  IconHolidayVillage: () => HolidayVillage_default,
  IconHome: () => Home_default,
  IconHoneymoon: () => Honeymoon_default,
  IconHourglass: () => Hourglass_default,
  IconImage: () => Image_default,
  IconInfoComposition: () => InfoComposition_default,
  IconInformationCircle: () => InformationCircle_default,
  IconInformationCircleFill: () => InformationCircleFill_default,
  IconInstagram: () => Instagram_default,
  IconInvoice: () => Invoice_default,
  IconKids: () => Kids_default,
  IconLanguage: () => Language_default,
  IconLesson: () => Lesson_default,
  IconLiftCabinBig: () => LiftCabinBig_default,
  IconLiftCabinSmall: () => LiftCabinSmall_default,
  IconLiftChairFront: () => LiftChairFront_default,
  IconLiftChairSide: () => LiftChairSide_default,
  IconLiftDrag: () => LiftDrag_default,
  IconLink: () => Link_default,
  IconList: () => List_default,
  IconLoader: () => Loader_default,
  IconLock: () => Lock_default,
  IconLockBadge: () => LockBadge_default,
  IconLogout: () => Logout_default,
  IconLuggage: () => Luggage_default,
  IconLuggageCheck: () => LuggageCheck_default,
  IconMagazine: () => Magazine_default,
  IconMail: () => Mail_default,
  IconMandatoryCosts: () => MandatoryCosts_default,
  IconMap: () => Map_default,
  IconMedal: () => Medal_default,
  IconMenuHamburger: () => MenuHamburger_default,
  IconMenuHamburgerSquare: () => MenuHamburgerSquare_default,
  IconMenuKebab: () => MenuKebab_default,
  IconMenuMeatballs: () => MenuMeatballs_default,
  IconMinus: () => Minus_default,
  IconMinusSmall: () => MinusSmall_default,
  IconMinusSquare: () => MinusSquare_default,
  IconMobilePhone: () => MobilePhone_default,
  IconMoney: () => Money_default,
  IconMoodSmileHappy: () => MoodSmileHappy_default,
  IconMountains: () => Mountains_default,
  IconMountainsDown: () => MountainsDown_default,
  IconMountainsGlacier: () => MountainsGlacier_default,
  IconMountainsSlope: () => MountainsSlope_default,
  IconMountainsUp: () => MountainsUp_default,
  IconMute: () => Mute_default,
  IconNoImage: () => NoImage_default,
  IconOnePerson: () => OnePerson_default,
  IconOnePersonCircle: () => OnePersonCircle_default,
  IconOnePersonTravelling: () => OnePersonTravelling_default,
  IconOptionalFacilities: () => OptionalFacilities_default,
  IconOrder: () => Order_default,
  IconParking: () => Parking_default,
  IconPause: () => Pause_default,
  IconPdfFile: () => PdfFile_default,
  IconPearl: () => Pearl_default,
  IconPencil: () => Pencil_default,
  IconPhone: () => Phone_default,
  IconPigMoney: () => PigMoney_default,
  IconPin: () => Pin_default,
  IconPinGroup: () => PinGroup_default,
  IconPinInfo: () => PinInfo_default,
  IconPinMap: () => PinMap_default,
  IconPinterest: () => Pinterest_default,
  IconPlaneEarth: () => PlaneEarth_default,
  IconPlay: () => Play_default,
  IconPlus: () => Plus_default,
  IconPlusMinus: () => PlusMinus_default,
  IconPlusSmall: () => PlusSmall_default,
  IconPlusSquare: () => PlusSquare_default,
  IconPoolSlide: () => PoolSlide_default,
  IconPopularVillage: () => PopularVillage_default,
  IconQuestionCircle: () => QuestionCircle_default,
  IconQuestionSquare: () => QuestionSquare_default,
  IconQuotation: () => Quotation_default,
  IconRadioButton: () => RadioButton_default2,
  IconRadioButtonCheck: () => RadioButtonCheck_default,
  IconReceipt: () => Receipt_default,
  IconReception: () => Reception_default,
  IconRefresh: () => Refresh_default,
  IconRoomservice: () => Roomservice_default,
  IconSauna: () => Sauna_default,
  IconSchool: () => School_default,
  IconSearch: () => Search_default,
  IconShare: () => Share_default,
  IconShareIos: () => ShareIos_default,
  IconShieldCheck: () => ShieldCheck_default,
  IconShieldWithDismiss: () => ShieldWithDismiss_default,
  IconShip: () => Ship_default,
  IconSkiBoots: () => SkiBoots_default,
  IconSkiHelmet: () => SkiHelmet_default,
  IconSkiMaterial: () => SkiMaterial_default,
  IconSkiPass: () => SkiPass_default,
  IconSkier: () => Skier_default,
  IconSlippers: () => Slippers_default,
  IconSnowboardMaterial: () => SnowboardMaterial_default,
  IconSnowboarder: () => Snowboarder_default,
  IconSnowflake: () => Snowflake_default,
  IconSnowheight: () => Snowheight_default,
  IconSpade: () => Spade_default,
  IconSparkAtlantis: () => SparkAtlantis_default,
  IconSparkEliza: () => SparkEliza_default,
  IconSparkGogo: () => SparkGogo_default,
  IconSparkHeart: () => SparkHeart_default,
  IconSparkPrimavera: () => SparkPrimavera_default,
  IconSparkSunweb: () => SparkSunweb_default,
  IconSparkTotally: () => SparkTotally_default,
  IconSparkles: () => Sparkles_default,
  IconSportsLeisure: () => SportsLeisure_default,
  IconSportsRun: () => SportsRun_default,
  IconSpotify: () => Spotify_default,
  IconSpray: () => Spray_default,
  IconStar: () => Star_default,
  IconStarFullFill: () => StarFullFill_default,
  IconStarHalf: () => StarHalf_default,
  IconStarHalfFill: () => StarHalfFill_default,
  IconSteeringWheel: () => SteeringWheel_default,
  IconStroller: () => Stroller_default,
  IconSuitcase: () => Suitcase_default,
  IconSun: () => Sun_default,
  IconSustainable: () => Sustainable_default,
  IconSwap: () => Swap_default,
  IconSweater: () => Sweater_default,
  IconSwimmingPool: () => SwimmingPool_default,
  IconSynchronise: () => Synchronise_default,
  IconTShirt: () => TShirt_default,
  IconTag: () => Tag_default,
  IconTarget: () => Target_default,
  IconTaxi: () => Taxi_default,
  IconTennisball: () => Tennisball_default,
  IconThumbsDown: () => ThumbsDown_default,
  IconThumbsUp: () => ThumbsUp_default,
  IconTicketFlight: () => TicketFlight_default,
  IconTicketGeneral: () => TicketGeneral_default,
  IconTimeline: () => Timeline_default,
  IconTinyHouseBungalow: () => TinyHouseBungalow_default,
  IconToast: () => Toast_default,
  IconTomorrowland: () => Tomorrowland_default,
  IconTowel: () => Towel_default,
  IconTrain: () => Train_default,
  IconTrainFront: () => TrainFront_default,
  IconTransmissionAutomatic: () => TransmissionAutomatic_default,
  IconTransmissionManual: () => TransmissionManual_default,
  IconTv: () => Tv_default2,
  IconTwitter: () => Twitter_default,
  IconTwoPersons: () => TwoPersons_default,
  IconUmbrella: () => Umbrella_default,
  IconUpgrade: () => Upgrade_default,
  IconVilla: () => Villa_default,
  IconVolume: () => Volume_default,
  IconVoucher: () => Voucher_default,
  IconWallet: () => Wallet_default,
  IconWarningCircle: () => WarningCircle_default,
  IconWarningSquare: () => WarningSquare_default,
  IconWarningTriangle: () => WarningTriangle_default,
  IconWashingMachine: () => WashingMachine_default,
  IconWeather: () => Weather_default,
  IconWellness: () => Wellness_default,
  IconWhatsapp: () => Whatsapp_default,
  IconWheelchair: () => Wheelchair_default,
  IconWifi: () => Wifi_default,
  IconYoutube: () => Youtube_default,
  IconZoomIn: () => ZoomIn_default,
  IconZoomOut: () => ZoomOut_default
});

// src/icons/generated/Tv.tsx
import { jsx as jsx277 } from "react/jsx-runtime";
var SvgTv2 = (props) => /* @__PURE__ */ jsx277("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx277("path", {
    fill: "currentColor",
    d: "M19.78 3H4.22C2.45 3 1 4.35 1 6v9c0 1.65 1.45 3 3.22 3H11v1H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-1h6.78c1.78 0 3.22-1.35 3.22-3V6c0-1.65-1.45-3-3.22-3ZM21 15c0 .55-.55 1-1.22 1H4.22C3.55 16 3 15.55 3 15V6c0-.55.55-1 1.22-1h15.56c.67 0 1.22.45 1.22 1v9Z"
  })
});
var Tv_default2 = SvgTv2;

// src/icons/generated/AirplaneAndroid.tsx
import { jsx as jsx278, jsxs as jsxs266 } from "react/jsx-runtime";
var SvgAirplaneAndroid = (props) => /* @__PURE__ */ jsxs266("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs266("g", {
      fill: "currentColor",
      clipPath: "url(#airplane-android_svg__a)",
      children: [
        /* @__PURE__ */ jsx278("path", {
          d: "M7 11a1 1 0 0 1-.89-.55l-2-4a1 1 0 0 1 1.78-.9l2 4a1 1 0 0 1-.44 1.34A.93.93 0 0 1 7 11ZM17 11a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 1 1 1.78.9l-2 4A1 1 0 0 1 17 11Z"
        }),
        /* @__PURE__ */ jsx278("path", {
          d: "M21 19H3a1 1 0 0 1-1-1 10 10 0 0 1 20 0 1 1 0 0 1-1 1ZM4.06 17h15.88a8 8 0 0 0-15.88 0Z"
        }),
        /* @__PURE__ */ jsx278("path", {
          d: "M15 15h-.19a.603.603 0 0 1-.19-.06.9.9 0 0 1-.54-.54A1.001 1.001 0 0 1 14 14a1 1 0 0 1 .29-.71l.16-.12a.561.561 0 0 1 .17-.09.6.6 0 0 1 .19-.06.859.859 0 0 1 .39 0l.18.06.18.09.15.12a1 1 0 0 1 .21 1.09 1 1 0 0 1-.21.33l-.15.12-.18.09-.18.08H15ZM9 15h-.19a.602.602 0 0 1-.19-.06.56.56 0 0 1-.17-.09 1.006 1.006 0 0 1-.16-.12 1 1 0 0 1-.21-.33A1 1 0 0 1 8 14a1.05 1.05 0 0 1 .29-.71A1 1 0 0 1 9.2 13l.18.06.18.09.15.12A1 1 0 0 1 10 14a1 1 0 0 1-.08.38.9.9 0 0 1-.54.54L9.2 15H9Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx278("defs", {
      children: /* @__PURE__ */ jsx278("clipPath", {
        id: "airplane-android_svg__a",
        children: /* @__PURE__ */ jsx278("path", {
          fill: "#fff",
          d: "M2 5h20v14H2z"
        })
      })
    })
  ]
});
var AirplaneAndroid_default = SvgAirplaneAndroid;

// src/icons/generated/AirplaneApple.tsx
import { jsx as jsx279, jsxs as jsxs267 } from "react/jsx-runtime";
var SvgAirplaneApple = (props) => /* @__PURE__ */ jsxs267("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx279("g", {
      fill: "currentColor",
      clipPath: "url(#airplane-apple_svg__a)",
      children: /* @__PURE__ */ jsx279("path", {
        d: "M15 22a5.62 5.62 0 0 1-1.91-.31A3.13 3.13 0 0 0 12 21.5a5.18 5.18 0 0 0-1.45.23A7 7 0 0 1 9 22c-2.89 0-5-5.16-5-8.5C4 10.5 5.31 7 9 7a5.39 5.39 0 0 1 2.28.69c.23.125.471.23.72.31l.63-.28A6.15 6.15 0 0 1 15.58 7a6.27 6.27 0 0 1 4.24 2.43 1 1 0 0 1-.026 1.177.999.999 0 0 1-.314.273l-.17.07c-.68.27-1.82.89-1.81 2a2 2 0 0 0 1.69 2h.14A1 1 0 0 1 20 16c0 2.52-2.9 6-5 6Zm-3-2.5a5.102 5.102 0 0 1 1.69.28c.42.152.864.226 1.31.22.66 0 2.43-1.77 2.89-3.31A3.91 3.91 0 0 1 15.5 13a3.86 3.86 0 0 1 1.83-3.27 4.6 4.6 0 0 0-1.9-.73 4.21 4.21 0 0 0-1.95.55A3.79 3.79 0 0 1 12 10a3.89 3.89 0 0 1-1.59-.51A4 4 0 0 0 9 9c-2.86 0-3 3.75-3 4.5 0 3 2 6.5 3 6.5.34-.032.674-.1 1-.2a7 7 0 0 1 2-.3ZM14 4.996c.957-.957 1.287-2.179.736-2.73-.55-.55-1.773-.22-2.73.736-.956.957-1.285 2.179-.735 2.73.551.55 1.773.22 2.73-.736Z"
      })
    }),
    /* @__PURE__ */ jsx279("defs", {
      children: /* @__PURE__ */ jsx279("clipPath", {
        id: "airplane-apple_svg__a",
        children: /* @__PURE__ */ jsx279("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var AirplaneApple_default = SvgAirplaneApple;

// src/icons/generated/AirplaneDeparture.tsx
import { jsx as jsx280, jsxs as jsxs268 } from "react/jsx-runtime";
var SvgAirplaneDeparture = (props) => /* @__PURE__ */ jsxs268("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx280("g", {
      fill: "currentColor",
      clipPath: "url(#airplane-departure_svg__a)",
      children: /* @__PURE__ */ jsx280("path", {
        d: "M21 22H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1ZM5.97 16.64a.97.97 0 0 1-.78-.38L2.59 13c-.54-.69-.73-1.6-.49-2.44.24-.84.87-1.52 1.69-1.82.69-.25 1.43-.22 2.09.09l1.64.76.32-.12-2.39-3.29c-.49-.68-.63-1.52-.39-2.32.25-.8.83-1.42 1.62-1.7a2.66 2.66 0 0 1 2.6.46l5.22 4.42 3.36-1.22c.77-.28 1.61-.24 2.35.1.75.35 1.31.96 1.59 1.74s.25 1.61-.1 2.35c-.35.75-.96 1.31-1.74 1.59L6.31 16.58c-.11.04-.23.06-.34.06Zm-1.24-6.07a.714.714 0 0 0-.7.53.72.72 0 0 0 .13.65l2.14 2.7 12.99-4.73c.56-.2.85-.82.64-1.38-.2-.56-.82-.85-1.38-.64l-3.9 1.42c-.34.12-.71.05-.99-.18L7.99 4.15a.628.628 0 0 0-.63-.11c-.26.09-.36.3-.39.41-.04.11-.07.34.09.56l3.17 4.37c.18.25.24.58.15.88-.09.3-.32.54-.61.65l-1.95.71a1 1 0 0 1-.76-.03l-2.01-.94a.67.67 0 0 0-.31-.07l-.01-.01Z"
      })
    }),
    /* @__PURE__ */ jsx280("defs", {
      children: /* @__PURE__ */ jsx280("clipPath", {
        id: "airplane-departure_svg__a",
        children: /* @__PURE__ */ jsx280("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var AirplaneDeparture_default = SvgAirplaneDeparture;

// src/icons/generated/AirplaneFlexible.tsx
import { jsx as jsx281, jsxs as jsxs269 } from "react/jsx-runtime";
var SvgAirplaneFlexible = (props) => /* @__PURE__ */ jsxs269("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx281("g", {
      clipPath: "url(#airplane-flexible_svg__a)",
      children: /* @__PURE__ */ jsxs269("g", {
        fill: "currentColor",
        clipPath: "url(#airplane-flexible_svg__b)",
        children: [
          /* @__PURE__ */ jsx281("path", {
            d: "M16.02 6.96c.51-.38 1.26-.28 1.66.23.4.51.31 1.23-.2 1.61l-2.21 1.64c-.19.14-.3.35-.32.57l-.46 5.5c-.08 1-1.57 1.02-1.72.02l-.59-3.8-1.6 1.19a.34.34 0 0 0-.13.3l.19 1.89c.06.65-.78.96-1.19.44L6.2 12.43c-.41-.52.12-1.22.74-1l1.84.67c.11.04.24.02.33-.05l1.61-1.18-3.63-1.54c-.95-.4-.55-1.79.47-1.61l5.59 1.01c.23.04.47-.01.66-.15l2.21-1.64v.02Z"
          }),
          /* @__PURE__ */ jsx281("path", {
            d: "M12.29 24C5.57 24 .17 18.74 0 12.03c-.01-.55.42-1.01.97-1.03.53.02 1.01.42 1.03.97C2.14 17.5 6.75 22 12.29 22c2.84 0 5.48-1.13 7.45-3.19a.996.996 0 1 1 1.44 1.38c-2.34 2.45-5.5 3.81-8.89 3.81Z"
          }),
          /* @__PURE__ */ jsx281("path", {
            d: "M21 24c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Z"
          }),
          /* @__PURE__ */ jsx281("path", {
            d: "M21 20h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1ZM22.99 13c-.54 0-.99-.43-1-.97A10.234 10.234 0 0 0 11.7 2C8.86 2 6.22 3.13 4.26 5.19c-.38.4-1.01.42-1.41.03a.996.996 0 0 1-.03-1.41C5.16 1.35 8.31 0 11.71 0 18.43 0 23.83 5.26 24 11.97c.01.55-.42 1.01-.97 1.03h-.04Z"
          }),
          /* @__PURE__ */ jsx281("path", {
            d: "M3 6c-.55 0-1-.45-1-1V1c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Z"
          }),
          /* @__PURE__ */ jsx281("path", {
            d: "M7 6H3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1Z"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsxs269("defs", {
      children: [
        /* @__PURE__ */ jsx281("clipPath", {
          id: "airplane-flexible_svg__a",
          children: /* @__PURE__ */ jsx281("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        }),
        /* @__PURE__ */ jsx281("clipPath", {
          id: "airplane-flexible_svg__b",
          children: /* @__PURE__ */ jsx281("path", {
            fill: "#fff",
            d: "M0 0h23.99v24H0z"
          })
        })
      ]
    })
  ]
});
var AirplaneFlexible_default = SvgAirplaneFlexible;

// src/icons/generated/AirplaneLeft.tsx
import { jsx as jsx282, jsxs as jsxs270 } from "react/jsx-runtime";
var SvgAirplaneLeft = (props) => /* @__PURE__ */ jsxs270("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx282("g", {
      clipPath: "url(#airplane-left_svg__a)",
      children: /* @__PURE__ */ jsx282("path", {
        fill: "currentColor",
        d: "M12.35 22A2.65 2.65 0 0 0 15 19.35V15h1.68l.07.37a2.65 2.65 0 0 0 5.25-.52v-5.7a2.65 2.65 0 0 0-5.25-.52l-.07.37H15V4.65a2.53 2.53 0 0 0-.75-1.86 2.63 2.63 0 0 0-4.46 1.34L8.81 9H5a3 3 0 1 0 0 6h3.81l.95 4.86A2.64 2.64 0 0 0 12.35 22Zm5.15-9H14a1 1 0 0 0-1 1v5.35a.65.65 0 0 1-1.28.13l-1.11-5.67a1 1 0 0 0-1-.81H5a1 1 0 0 1 0-2h4.63a1 1 0 0 0 1-.81l1.09-5.68a.65.65 0 0 1 1.07-.32.59.59 0 0 1 .18.45L13 10a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-.8l.22-1.2a.65.65 0 0 1 1.28.15v5.7a.65.65 0 0 1-1.28.15l-.24-1.18a1 1 0 0 0-.98-.82Z"
      })
    }),
    /* @__PURE__ */ jsx282("defs", {
      children: /* @__PURE__ */ jsx282("clipPath", {
        id: "airplane-left_svg__a",
        children: /* @__PURE__ */ jsx282("path", {
          fill: "#fff",
          d: "M22 2H2v20h20z"
        })
      })
    })
  ]
});
var AirplaneLeft_default = SvgAirplaneLeft;

// src/icons/generated/AirplaneReturn.tsx
import { jsx as jsx283, jsxs as jsxs271 } from "react/jsx-runtime";
var SvgAirplaneReturn = (props) => /* @__PURE__ */ jsxs271("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx283("g", {
      clipPath: "url(#airplane-return_svg__a)",
      children: /* @__PURE__ */ jsx283("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.917 4.023a.65.65 0 0 1 .281.054.66.66 0 0 1 .366.53l.61 7.375a1 1 0 0 0 .573.824l3.772 1.76a1.068 1.068 0 0 1 .517 1.427l-.003.006a1.068 1.068 0 0 1-1.427.516l-12.53-5.837.397-3.434a.73.73 0 0 1 1.025-.582.78.78 0 0 1 .38.433l.762 2.097a1 1 0 0 0 .516.564l1.88.88a1 1 0 0 0 1.412-.749l.849-5.325a.65.65 0 0 1 .62-.54Zm1.117-1.763.016.007a2.66 2.66 0 0 1 1.506 2.163v.008l.563 6.801 3.243 1.514a3.071 3.071 0 0 1 1.484 4.09 3.071 3.071 0 0 1-4.09 1.483l-.003-.002-13.175-6.138a1 1 0 0 1-.571-1.02l.48-4.15a2.73 2.73 0 0 1 3.866-2.162l.02.01A2.78 2.78 0 0 1 8.76 6.42l.617 1.699.304.141.642-4.026a2.65 2.65 0 0 1 3.71-1.975ZM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z",
        clipRule: "evenodd"
      })
    }),
    /* @__PURE__ */ jsx283("defs", {
      children: /* @__PURE__ */ jsx283("clipPath", {
        id: "airplane-return_svg__a",
        children: /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var AirplaneReturn_default = SvgAirplaneReturn;

// src/icons/generated/AirplaneRight.tsx
import { jsx as jsx284, jsxs as jsxs272 } from "react/jsx-runtime";
var SvgAirplaneRight = (props) => /* @__PURE__ */ jsxs272("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx284("g", {
      clipPath: "url(#airplane-right_svg__a)",
      children: /* @__PURE__ */ jsx284("path", {
        fill: "currentColor",
        d: "M11.65 22A2.65 2.65 0 0 1 9 19.35V15H7.32l-.07.37A2.65 2.65 0 0 1 2 14.85v-5.7a2.65 2.65 0 0 1 5.25-.52l.07.37H9V4.65a2.53 2.53 0 0 1 .75-1.86 2.63 2.63 0 0 1 4.46 1.34L15.19 9H19a3 3 0 1 1 0 6h-3.81l-.95 4.86A2.64 2.64 0 0 1 11.65 22ZM6.5 13H10a1 1 0 0 1 1 1v5.35a.65.65 0 0 0 1.28.13l1.11-5.67a1 1 0 0 1 1-.81H19a1 1 0 0 0 0-2h-4.63a1 1 0 0 1-1-.81l-1.09-5.68a.65.65 0 0 0-1.07-.32.59.59 0 0 0-.18.45L11 10a1 1 0 0 1-1 1H6.5a1 1 0 0 1-1-.8L5.28 9A.65.65 0 0 0 4 9.15v5.7a.65.65 0 0 0 1.28.15l.24-1.18A1 1 0 0 1 6.5 13Z"
      })
    }),
    /* @__PURE__ */ jsx284("defs", {
      children: /* @__PURE__ */ jsx284("clipPath", {
        id: "airplane-right_svg__a",
        children: /* @__PURE__ */ jsx284("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var AirplaneRight_default = SvgAirplaneRight;

// src/icons/generated/AirplaneTopLeft.tsx
import { jsx as jsx285 } from "react/jsx-runtime";
var SvgAirplaneTopLeft = (props) => /* @__PURE__ */ jsx285("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx285("path", {
    fill: "currentColor",
    d: "M14.13 20.82a2.642 2.642 0 0 0 1.87-.78l4-4a2.65 2.65 0 0 0-3.31-4.13l-.32.21-1.19-1.21 3.06-3a2.59 2.59 0 0 0 .79-1.9 2.68 2.68 0 0 0-.77-1.89 2.65 2.65 0 0 0-3.36-.32l-4.12 2.78-2.67-2.67A3 3 0 1 0 3.9 8.12l2.7 2.7-2.8 4.09a2.654 2.654 0 0 0 4.1 3.37l3-3.08 1.19 1.18-.21.32a2.65 2.65 0 0 0 2.21 4.12h.04Zm4-7.33a.65.65 0 0 1 .65.645.64.64 0 0 1-.19.455l-4 4a.65.65 0 0 1-1.1-.395.64.64 0 0 1 .11-.425l.66-1a1 1 0 0 0-.12-1.26l-2.48-2.47a1 1 0 0 0-1.41 0l-3.8 3.87a.65.65 0 0 1-1-.82l3.22-4.79a1 1 0 0 0-.12-1.26L5.29 6.71A1 1 0 1 1 6.7 5.3l3.28 3.27a1 1 0 0 0 1.26.12l4.8-3.23a.65.65 0 0 1 .8.08.63.63 0 0 1 0 .9l-3.78 3.81a1 1 0 0 0 0 1.41l2.48 2.48a1 1 0 0 0 1.26.12l1-.66a.59.59 0 0 1 .36-.11h-.03Z"
  })
});
var AirplaneTopLeft_default = SvgAirplaneTopLeft;

// src/icons/generated/AirplaneTopRight.tsx
import { jsx as jsx286 } from "react/jsx-runtime";
var SvgAirplaneTopRight = (props) => /* @__PURE__ */ jsx286("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx286("path", {
    fill: "currentColor",
    d: "M9.68 20.82a2.642 2.642 0 0 1-1.87-.78l-4-4a2.65 2.65 0 0 1 3.31-4.13l.32.21 1.19-1.21-3.06-3a2.59 2.59 0 0 1-.79-1.9 2.68 2.68 0 0 1 .77-1.89 2.65 2.65 0 0 1 3.36-.32l4.12 2.78 2.67-2.67a3 3 0 1 1 4.21 4.21l-2.7 2.7 2.8 4.09a2.653 2.653 0 1 1-4.1 3.37l-3-3.08-1.19 1.18.21.32a2.65 2.65 0 0 1-2.21 4.12h-.04Zm-4-7.33a.65.65 0 0 0-.65.645.64.64 0 0 0 .19.455l4 4a.65.65 0 0 0 1.1-.395.64.64 0 0 0-.11-.425l-.66-1a1 1 0 0 1 .12-1.26l2.48-2.47a1 1 0 0 1 1.41 0l3.8 3.87a.65.65 0 0 0 1-.82l-3.22-4.79a1 1 0 0 1 .12-1.26l3.26-3.33a1 1 0 1 0-1.41-1.41l-3.28 3.27a1 1 0 0 1-1.26.12l-4.8-3.23a.65.65 0 0 0-.8.08.63.63 0 0 0 0 .9l3.78 3.81a1 1 0 0 1 0 1.41l-2.48 2.48a1 1 0 0 1-1.26.12l-1-.66a.59.59 0 0 0-.36-.11h.03Z"
  })
});
var AirplaneTopRight_default = SvgAirplaneTopRight;

// src/icons/generated/Airplane.tsx
import { jsx as jsx287, jsxs as jsxs273 } from "react/jsx-runtime";
var SvgAirplane = (props) => /* @__PURE__ */ jsxs273("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx287("g", {
      clipPath: "url(#airplane_svg__a)",
      children: /* @__PURE__ */ jsx287("path", {
        fill: "currentColor",
        d: "M14.85 22h-5.7c-1.46 0-2.65-1.19-2.65-2.65 0-1.26.9-2.35 2.13-2.6l.37-.07v-1.69l-4.35-.02c-.7.01-1.36-.26-1.87-.76s-.79-1.16-.79-1.87c0-1.26.89-2.34 2.13-2.58l4.87-.95V5c0-1.65 1.35-3 3-3s3 1.35 3 3v3.81l4.86.95c1.24.24 2.14 1.33 2.14 2.6 0 1.46-1.19 2.65-2.65 2.65h-4.35v1.68l.37.07c1.23.25 2.13 1.34 2.13 2.6 0 1.46-1.19 2.65-2.65 2.65l.01-.01ZM4.64 12.98 10 13c.55 0 1 .45 1 1v3.5c0 .48-.34.89-.8.98l-1.17.23c-.3.06-.52.33-.52.64 0 .36.29.65.65.65h5.7c.36 0 .65-.29.65-.65 0-.31-.22-.58-.52-.64l-1.17-.23c-.47-.09-.8-.5-.8-.98V14c0-.55.45-1 1-1h5.35c.36 0 .65-.29.65-.65 0-.31-.22-.57-.52-.63l-5.67-1.11a.997.997 0 0 1-.81-.98V5c0-.55-.45-1-1-1s-1 .45-1 1v4.63c0 .48-.34.89-.81.98l-5.68 1.11c-.29.06-.51.32-.51.62 0 .17.07.33.19.45s.28.18.44.18l-.01.01Z"
      })
    }),
    /* @__PURE__ */ jsx287("defs", {
      children: /* @__PURE__ */ jsx287("clipPath", {
        id: "airplane_svg__a",
        children: /* @__PURE__ */ jsx287("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Airplane_default = SvgAirplane;

// src/icons/generated/Amenities.tsx
import { jsx as jsx288 } from "react/jsx-runtime";
var SvgAmenities = (props) => /* @__PURE__ */ jsx288("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx288("path", {
    fill: "#362F2F",
    fillRule: "evenodd",
    d: "M17.5 1C20.53 1 23 3.47 23 6.5c0 1.7-.78 3.23-2 4.24V21c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-5h-2v5c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.31.15-.61.4-.8l8-6a.99.99 0 0 1 1.2 0l.83.62C14.43 1.71 15.88 1 17.5 1ZM15 20h4v-8.21c-.48.13-.98.21-1.5.21A5.51 5.51 0 0 1 12 6.5c0-.69.13-1.36.37-1.97L12 4.25 5 9.5V20h4v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5ZM14 6.5c0 1.93 1.57 3.5 3.5 3.5S21 8.43 21 6.5 19.43 3 17.5 3 14 4.57 14 6.5Zm4.5-1h.5c.55 0 1 .45 1 1s-.45 1-1 1h-.5V8c0 .55-.45 1-1 1s-1-.45-1-1v-.5H16c-.55 0-1-.45-1-1s.45-1 1-1h.5V5c0-.55.45-1 1-1s1 .45 1 1v.5Z",
    clipRule: "evenodd"
  })
});
var Amenities_default = SvgAmenities;

// src/icons/generated/Apps.tsx
import { jsx as jsx289, jsxs as jsxs274 } from "react/jsx-runtime";
var SvgApps = (props) => /* @__PURE__ */ jsxs274("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx289("g", {
      fill: "currentColor",
      clipPath: "url(#apps_svg__a)",
      children: /* @__PURE__ */ jsx289("path", {
        d: "M20 11h-6c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1Zm-5-2h4V5h-4v4ZM10 11H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1ZM5 9h4V5H5v4ZM20 21h-6c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1Zm-5-2h4v-4h-4v4ZM10 21H4c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1Zm-5-2h4v-4H5v4Z"
      })
    }),
    /* @__PURE__ */ jsx289("defs", {
      children: /* @__PURE__ */ jsx289("clipPath", {
        id: "apps_svg__a",
        children: /* @__PURE__ */ jsx289("path", {
          fill: "#fff",
          d: "M3 3h18v18H3z"
        })
      })
    })
  ]
});
var Apps_default = SvgApps;

// src/icons/generated/ArrowDownSmall.tsx
import { jsx as jsx290, jsxs as jsxs275 } from "react/jsx-runtime";
var SvgArrowDownSmall = (props) => /* @__PURE__ */ jsxs275("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx290("path", {
      fill: "currentColor",
      d: "M11.5 17a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1Z"
    }),
    /* @__PURE__ */ jsx290("path", {
      fill: "currentColor",
      d: "M11.5 17a1 1 0 0 1-.71-.29l-2.5-2.5a1 1 0 0 1 .325-1.639 1 1 0 0 1 1.095.219l1.79 1.8 1.79-1.8a1.001 1.001 0 0 1 1.639.325 1 1 0 0 1-.22 1.095l-2.5 2.5a1 1 0 0 1-.71.29Z"
    })
  ]
});
var ArrowDownSmall_default = SvgArrowDownSmall;

// src/icons/generated/ArrowDown.tsx
import { jsx as jsx291, jsxs as jsxs276 } from "react/jsx-runtime";
var SvgArrowDown = (props) => /* @__PURE__ */ jsxs276("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs276("g", {
      fill: "currentColor",
      clipPath: "url(#arrow-down_svg__a)",
      children: [
        /* @__PURE__ */ jsx291("path", {
          d: "M12 24a1 1 0 0 1-.71-.29l-9-9a1.004 1.004 0 0 1 1.42-1.42l8.29 8.3 8.29-8.3a1.004 1.004 0 1 1 1.42 1.42l-9 9A1 1 0 0 1 12 24Z"
        }),
        /* @__PURE__ */ jsx291("path", {
          d: "M12 24a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v22a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx291("defs", {
      children: /* @__PURE__ */ jsx291("clipPath", {
        id: "arrow-down_svg__a",
        children: /* @__PURE__ */ jsx291("path", {
          fill: "#fff",
          d: "M2 0h20v24H2z"
        })
      })
    })
  ]
});
var ArrowDown_default = SvgArrowDown;

// src/icons/generated/ArrowLeftSmall.tsx
import { jsx as jsx292, jsxs as jsxs277 } from "react/jsx-runtime";
var SvgArrowLeftSmall = (props) => /* @__PURE__ */ jsxs277("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx292("path", {
      fill: "currentColor",
      d: "M16 13.5H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Z"
    }),
    /* @__PURE__ */ jsx292("path", {
      fill: "currentColor",
      d: "M10.5 16a1 1 0 0 1-.71-.29l-2.5-2.5a1 1 0 0 1 0-1.42l2.5-2.5a1.004 1.004 0 1 1 1.42 1.42l-1.8 1.79 1.8 1.79A.999.999 0 0 1 10.5 16Z"
    })
  ]
});
var ArrowLeftSmall_default = SvgArrowLeftSmall;

// src/icons/generated/ArrowLeft.tsx
import { jsx as jsx293, jsxs as jsxs278 } from "react/jsx-runtime";
var SvgArrowLeft = (props) => /* @__PURE__ */ jsxs278("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx293("g", {
      clipPath: "url(#arrow-left_svg__a)",
      children: /* @__PURE__ */ jsx293("path", {
        fill: "currentColor",
        d: "M23 11H3.41l7.3-7.29A.996.996 0 1 0 9.3 2.3L.29 11.29a1 1 0 0 0 0 1.42l9 9c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41L3.41 13H23c.55 0 1-.45 1-1s-.45-1-1-1Z"
      })
    }),
    /* @__PURE__ */ jsx293("defs", {
      children: /* @__PURE__ */ jsx293("clipPath", {
        id: "arrow-left_svg__a",
        children: /* @__PURE__ */ jsx293("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })
  ]
});
var ArrowLeft_default = SvgArrowLeft;

// src/icons/generated/ArrowRightSmall.tsx
import { jsx as jsx294, jsxs as jsxs279 } from "react/jsx-runtime";
var SvgArrowRightSmall = (props) => /* @__PURE__ */ jsxs279("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx294("path", {
      fill: "currentColor",
      d: "M8 13.5h8a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2Z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "currentColor",
      d: "M13.5 16a1 1 0 0 0 .71-.29l2.5-2.5a1.002 1.002 0 0 0 0-1.42l-2.5-2.5a1.004 1.004 0 0 0-1.42 1.42l1.8 1.79-1.8 1.79A.999.999 0 0 0 13.5 16Z"
    })
  ]
});
var ArrowRightSmall_default = SvgArrowRightSmall;

// src/icons/generated/ArrowRight.tsx
import { jsx as jsx295 } from "react/jsx-runtime";
var SvgArrowRight = (props) => /* @__PURE__ */ jsx295("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx295("path", {
    fill: "currentColor",
    d: "M23.92 12.38a1 1 0 0 0-.22-1.09l-8.99-9A.996.996 0 1 0 13.3 3.7l7.29 7.29H1c-.55 0-1 .45-1 1s.45 1 1 1h19.59l-7.29 7.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l9-9c.09-.09.17-.2.22-.33l-.02.02Z"
  })
});
var ArrowRight_default = SvgArrowRight;

// src/icons/generated/ArrowUpSmall.tsx
import { jsx as jsx296, jsxs as jsxs280 } from "react/jsx-runtime";
var SvgArrowUpSmall = (props) => /* @__PURE__ */ jsxs280("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx296("path", {
      fill: "currentColor",
      d: "M11.5 17a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1Z"
    }),
    /* @__PURE__ */ jsx296("path", {
      fill: "currentColor",
      d: "M14 11.5a1 1 0 0 1-.71-.29l-1.79-1.8-1.79 1.8a1.004 1.004 0 1 1-1.42-1.42l2.5-2.5a1 1 0 0 1 1.42 0l2.5 2.5a.998.998 0 0 1 0 1.42 1 1 0 0 1-.71.29Z"
    })
  ]
});
var ArrowUpSmall_default = SvgArrowUpSmall;

// src/icons/generated/ArrowUp.tsx
import { jsx as jsx297, jsxs as jsxs281 } from "react/jsx-runtime";
var SvgArrowUp = (props) => /* @__PURE__ */ jsxs281("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs281("g", {
      fill: "currentColor",
      clipPath: "url(#arrow-up_svg__a)",
      children: [
        /* @__PURE__ */ jsx297("path", {
          d: "M21 11a1 1 0 0 1-.71-.29L12 2.41l-8.29 8.3a1.004 1.004 0 1 1-1.42-1.42l9-9a1 1 0 0 1 1.42 0l9 9a.998.998 0 0 1 0 1.42A1 1 0 0 1 21 11Z"
        }),
        /* @__PURE__ */ jsx297("path", {
          d: "M12 24a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v22a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx297("defs", {
      children: /* @__PURE__ */ jsx297("clipPath", {
        id: "arrow-up_svg__a",
        children: /* @__PURE__ */ jsx297("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })
  ]
});
var ArrowUp_default = SvgArrowUp;

// src/icons/generated/Attachment.tsx
import { jsx as jsx298 } from "react/jsx-runtime";
var SvgAttachment = (props) => /* @__PURE__ */ jsx298("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx298("path", {
    fill: "currentColor",
    d: "M9.36 22.6a7.37 7.37 0 0 1-5.21-12.57l6.5-6.5a5.25 5.25 0 0 1 7.42 7.42l-6.5 6.5a3.2 3.2 0 0 1-4.42 0 3.14 3.14 0 0 1 0-4.42l6.5-6.5a1.004 1.004 0 1 1 1.42 1.42l-6.5 6.5a1.11 1.11 0 0 0 .79 1.902c.295 0 .579-.116.79-.322l6.5-6.5a3.24 3.24 0 0 0-4.58-4.58l-6.5 6.5a5.36 5.36 0 0 0 7.58 7.58l6.5-6.5a1.004 1.004 0 1 1 1.42 1.42l-6.5 6.5a7.31 7.31 0 0 1-5.21 2.15Z"
  })
});
var Attachment_default = SvgAttachment;

// src/icons/generated/BabyPool.tsx
import { jsx as jsx299 } from "react/jsx-runtime";
var SvgBabyPool = (props) => /* @__PURE__ */ jsx299("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx299("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 17c4.14 0 7.5-3.36 7.5-7.5C19.5 5.36 16.14 2 12 2 7.86 2 4.5 5.36 4.5 9.5c0 4.14 3.36 7.5 7.5 7.5ZM9.57 4.57A2.436 2.436 0 0 0 12 6.88c.55 0 1-.45 1-1s-.45-1-1-1c-.25 0-.44-.2-.44-.44S11.76 4 12 4c3.03 0 5.5 2.47 5.5 5.5S15.03 15 12 15a5.51 5.51 0 0 1-5.5-5.5c0-2.16 1.25-4.03 3.07-4.93Zm2.41 8.84c.89 0 1.78-.33 2.49-.99.007 0 .013-.009.02-.018l.01-.012c.06-.06.11-.12.15-.19.25-.39.2-.91-.14-1.25-.39-.38-1.02-.38-1.41 0-.61.59-1.61.6-2.18 0a.996.996 0 1 0-1.42 1.4c.68.69 1.58 1.04 2.5 1.04l-.02.02Zm-.42-3.91c0 .55-.45 1-1 1s-1-.45-1-1v-.72c0-.55.45-1 1-1s1 .45 1 1v.72Zm1.88 1c.55 0 1-.45 1-1v-.72c0-.55-.45-1-1-1s-1 .45-1 1v.72c0 .55.45 1 1 1Zm7.74 8.92c.33-.45.95-.55 1.4-.23h-.02c.45.33.55.95.23 1.4-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.73-.6-1.17-.58-.5-.01-.94.2-1.21.58a3.34 3.34 0 0 1-2.83 1.42c-1.08-.01-2.14-.51-2.79-1.42-.27-.37-.71-.6-1.17-.58-.51-.01-.94.2-1.21.58-.65.92-1.71 1.45-2.83 1.42-1.06-.01-2.14-.51-2.79-1.42-.32-.45-.22-1.08.23-1.4.45-.32 1.08-.22 1.4.23.27.37.7.56 1.17.58.49 0 .94-.2 1.21-.58.65-.91 1.71-1.42 2.83-1.42 1.08 0 2.14.51 2.79 1.42.27.37.71.56 1.17.58.5 0 .94-.2 1.21-.58.65-.91 1.72-1.42 2.83-1.42 1.09 0 2.14.51 2.79 1.42.27.37.7.56 1.17.58.5 0 .94-.2 1.21-.58Z",
    clipRule: "evenodd"
  })
});
var BabyPool_default = SvgBabyPool;

// src/icons/generated/Baby.tsx
import { jsx as jsx300, jsxs as jsxs282 } from "react/jsx-runtime";
var SvgBaby = (props) => /* @__PURE__ */ jsxs282("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs282("g", {
      fill: "currentColor",
      clipPath: "url(#baby_svg__a)",
      children: [
        /* @__PURE__ */ jsx300("path", {
          d: "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
        }),
        /* @__PURE__ */ jsx300("path", {
          d: "M12 17a4.43 4.43 0 0 1-3.21-1.3 1 1 0 0 1 1.42-1.4 2.52 2.52 0 0 0 3.54 0 1 1 0 1 1 1.44 1.39A4.62 4.62 0 0 1 12 17ZM12 8a3 3 0 0 1 0-6 1 1 0 1 1 0 2 1 1 0 1 0 0 2 1 1 0 1 1 0 2ZM10 13a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1ZM14 13a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx300("defs", {
      children: /* @__PURE__ */ jsx300("clipPath", {
        id: "baby_svg__a",
        children: /* @__PURE__ */ jsx300("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Baby_default = SvgBaby;

// src/icons/generated/BackpackCheck.tsx
import { jsx as jsx301, jsxs as jsxs283 } from "react/jsx-runtime";
var SvgBackpackCheck = (props) => /* @__PURE__ */ jsxs283("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs283("g", {
      fill: "currentColor",
      clipPath: "url(#backpack-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx301("path", {
          d: "M20.93 10.88a1.007 1.007 0 1 0-2 .25c.039.289.062.579.07.87v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a7 7 0 0 1 9.62-6.49A1 1 0 0 0 15.93 5c.077-.217.07-.67.07-.67s-.003-.217 0-.33V3a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1a9 9 0 0 0-5 8v9a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9a8.422 8.422 0 0 0-.07-1.12ZM10 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h-4Z"
        }),
        /* @__PURE__ */ jsx301("path", {
          d: "M7 11a1 1 0 0 0-1 1v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-4a1 1 0 0 0-2 0v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-6a1 1 0 0 0-1-1Z"
        }),
        /* @__PURE__ */ jsx301("path", {
          d: "M10.83 11.45a1 1 0 0 0-1.66 1.1l2 3A1 1 0 0 0 12 16a1 1 0 0 0 .82-.43l7-10a1 1 0 0 0-1.64-1.14L12 13.23l-1.17-1.78Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx301("defs", {
      children: /* @__PURE__ */ jsx301("clipPath", {
        id: "backpack-check_svg__a",
        children: /* @__PURE__ */ jsx301("path", {
          fill: "#fff",
          d: "M3 0h18v24H3z"
        })
      })
    })
  ]
});
var BackpackCheck_default = SvgBackpackCheck;

// src/icons/generated/Backpack.tsx
import { jsx as jsx302, jsxs as jsxs284 } from "react/jsx-runtime";
var SvgBackpack = (props) => /* @__PURE__ */ jsxs284("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs284("g", {
      fill: "currentColor",
      clipPath: "url(#backpack_svg__a)",
      children: [
        /* @__PURE__ */ jsx302("path", {
          d: "M16 4V3a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1a9 9 0 0 0-5 8v9a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9a9 9 0 0 0-5-8Zm-6-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h-4Zm9 18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a7 7 0 0 1 14 0v9Z"
        }),
        /* @__PURE__ */ jsx302("path", {
          d: "M9 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H9Zm6 10H9a1 1 0 0 1-1-1v-3h8v3a1 1 0 0 1-1 1Zm1-7v1H8v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx302("defs", {
      children: /* @__PURE__ */ jsx302("clipPath", {
        id: "backpack_svg__a",
        children: /* @__PURE__ */ jsx302("path", {
          fill: "#fff",
          d: "M3 0h18v24H3z"
        })
      })
    })
  ]
});
var Backpack_default = SvgBackpack;

// src/icons/generated/Beach.tsx
import { jsx as jsx303, jsxs as jsxs285 } from "react/jsx-runtime";
var SvgBeach = (props) => /* @__PURE__ */ jsxs285("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs285("g", {
      fill: "currentColor",
      clipPath: "url(#beach_svg__a)",
      children: [
        /* @__PURE__ */ jsx303("path", {
          d: "M22.2 19c-.17 0-.35-.05-.5-.13l-10.39-6a.998.998 0 0 1-.37-1.37c1.93-3.34 6.22-4.49 9.56-2.56 3.34 1.93 4.49 6.22 2.56 9.56-.13.23-.35.4-.61.47-.08.02-.17.03-.26.03h.01Zm-8.94-7.32 8.49 4.9c.74-2.21-.15-4.71-2.24-5.91-2.09-1.2-4.7-.73-6.24 1.01h-.01Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M18.73 17c-.17 0-.34-.04-.5-.13a1.01 1.01 0 0 1-.37-1.37c1.38-2.39 1.67-4.16 1.59-4.75-.55.22-1.94 1.36-3.32 3.75-.28.48-.89.64-1.37.37a1.01 1.01 0 0 1-.37-1.37c1.74-3.02 4.3-5.6 6.1-4.56.61.35 1.25 1.21.83 3.3-.26 1.27-.87 2.79-1.73 4.27-.19.32-.52.5-.87.5l.01-.01Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M14 21.2c-.17 0-.34-.04-.5-.13a1.01 1.01 0 0 1-.37-1.37l3-5.2c.28-.48.89-.64 1.37-.37.48.28.64.89.37 1.37l-3 5.2c-.19.32-.52.5-.87.5Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M21 22H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M9 22h-.14a.995.995 0 0 1-.85-1.13c.98-6.88-.02-9.54-2.81-13.26-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2 3.01 4.02 4.26 7.25 3.19 14.74a1 1 0 0 1-.99.86V22Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M12 8c-.19 0-.38-.05-.55-.17-2.42-1.61-4.87-.02-4.89 0a1.001 1.001 0 1 1-1.11-1.67c.15-.1 3.59-2.34 7.11 0 .46.31.58.93.28 1.39-.19.29-.51.45-.83.45H12Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M5 14c-.55 0-1-.45-1-1 0-3.13 1.01-6.19 1.05-6.32.17-.52.75-.81 1.26-.63.52.17.81.74.63 1.26 0 .03-.95 2.89-.95 5.68 0 .55-.45 1-1 1L5 14Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M6 7.99a.96.96 0 0 1-.33-.06.996.996 0 0 1-.62-1.25c.05-.15 1.27-3.58 7.78-4.67.55-.1 1.06.28 1.15.82.09.54-.28 1.06-.82 1.15-5.22.87-6.21 3.32-6.22 3.35-.15.4-.54.65-.94.65v.01Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M6 8c-.42 0-.81-.26-.95-.68C5 7.17 3.88 3.71 6.29 1.3A.996.996 0 1 1 7.7 2.71c-1.53 1.53-.76 3.96-.76 3.98A1.006 1.006 0 0 1 5.99 8H6Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M1 13c-.1 0-.21-.02-.32-.05a.992.992 0 0 1-.63-1.26c1.12-3.35 5.32-5.49 5.5-5.58a.993.993 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34-.04.02-3.65 1.86-4.5 4.42-.14.42-.53.68-.95.68H1Z"
        }),
        /* @__PURE__ */ jsx303("path", {
          d: "M1 8c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34c2.34-1.17 5.62-.1 5.76-.05.52.17.81.74.63 1.26-.18.52-.74.81-1.26.63-.73-.24-2.91-.72-4.24-.05-.14.07-.3.11-.45.11L1 8Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx303("defs", {
      children: /* @__PURE__ */ jsx303("clipPath", {
        id: "beach_svg__a",
        children: /* @__PURE__ */ jsx303("path", {
          fill: "#fff",
          d: "M0 1h24v21H0z"
        })
      })
    })
  ]
});
var Beach_default = SvgBeach;

// src/icons/generated/Bed2Persons.tsx
import { jsx as jsx304 } from "react/jsx-runtime";
var SvgBed2Persons = (props) => /* @__PURE__ */ jsx304("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx304("path", {
    fill: "#362F2F",
    d: "M22 10.18V4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v6.18c-1.16.41-2 1.51-2 2.82v7c0 .55.45 1 1 1s1-.45 1-1v-2h20v2c0 .55.45 1 1 1s1-.45 1-1v-7c0-1.3-.84-2.4-2-2.82ZM10 10H6V9c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1Zm8 0h-4V9c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1ZM4 5h16v4c0-1.65-1.35-3-3-3h-2c-1.65 0-3 1.35-3 3 0-1.65-1.35-3-3-3H7C5.35 6 4 7.35 4 9V5Zm-2 8c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v3H2v-3Z"
  })
});
var Bed2Persons_default = SvgBed2Persons;

// src/icons/generated/Bed.tsx
import { jsx as jsx305, jsxs as jsxs286 } from "react/jsx-runtime";
var SvgBed = (props) => /* @__PURE__ */ jsxs286("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs286("g", {
      fill: "currentColor",
      clipPath: "url(#bed_svg__a)",
      children: [
        /* @__PURE__ */ jsx305("path", {
          d: "M23 20c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1ZM1 20c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx305("path", {
          d: "M23 18H1c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h20c1.65 0 3 1.35 3 3v4c0 .55-.45 1-1 1ZM2 16h20v-3c0-.55-.45-1-1-1H2v4Z"
        }),
        /* @__PURE__ */ jsx305("path", {
          d: "M7 12H3c-1.65 0-3-1.35-3-3s1.35-3 3-3h4c1.65 0 3 1.35 3 3s-1.35 3-3 3ZM3 8c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1H3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx305("defs", {
      children: /* @__PURE__ */ jsx305("clipPath", {
        id: "bed_svg__a",
        children: /* @__PURE__ */ jsx305("path", {
          fill: "#fff",
          d: "M0 4h24v16H0z"
        })
      })
    })
  ]
});
var Bed_default = SvgBed;

// src/icons/generated/Bell.tsx
import { jsx as jsx306 } from "react/jsx-runtime";
var SvgBell = (props) => /* @__PURE__ */ jsx306("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx306("path", {
    d: "M15.879 17.89h3.86a.99.99 0 0 0 .94-.73.956.956 0 0 0-.456-1.086 2.917 2.917 0 0 1-1.446-2.12v-2.892a7.734 7.734 0 0 0-3.945-6.398 2.92 2.92 0 0 0-2.84-2.289 2.92 2.92 0 0 0-2.844 2.29C6.82 5.96 5.328 8.366 5.203 11.101v2.851a2.922 2.922 0 0 1-1.445 2.121.96.96 0 0 0-.457 1.086c.117.43.504.73.941.73h3.88a3.878 3.878 0 1 0 7.757 0Zm-1.941 0A1.942 1.942 0 0 1 12 19.829a1.942 1.942 0 0 1-1.938-1.937Zm3.523-1.94a4.746 4.746 0 0 1-.602-1.825v-3.023c-.097-2.106-1.379-4.024-3.328-4.946a.97.97 0 0 1-.55-.875.974.974 0 0 0-.973-.968.974.974 0 0 0-.969.968c0 .38-.21.719-.55.875a5.825 5.825 0 0 0-3.329 4.985v2.976a4.929 4.929 0 0 1-.601 1.824l-.02.008Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#180f04",
      fillOpacity: 1
    }
  })
});
var Bell_default = SvgBell;

// src/icons/generated/Bin.tsx
import { jsx as jsx307, jsxs as jsxs287 } from "react/jsx-runtime";
var SvgBin = (props) => /* @__PURE__ */ jsxs287("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs287("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipPath: "url(#bin_svg__a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx307("path", {
          d: "M2 7a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM10 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1ZM14 10a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z"
        }),
        /* @__PURE__ */ jsx307("path", {
          d: "M7.586 2.586A2 2 0 0 1 9 2h6a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a2 2 0 0 1 .586-1.414ZM15 4H9v2h6V4Z"
        }),
        /* @__PURE__ */ jsx307("path", {
          d: "M4.264 6.323A1 1 0 0 1 5 6h14a1 1 0 0 1 .997 1.083L19 19.046A3 3 0 0 1 16 22H8a3 3 0 0 1-3-2.954L4.003 7.083a1 1 0 0 1 .261-.76ZM6.087 8l.91 10.917A1 1 0 0 1 7 19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 1 1 0 0 1 .003-.083L17.913 8H6.087Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx307("defs", {
      children: /* @__PURE__ */ jsx307("clipPath", {
        id: "bin_svg__a",
        children: /* @__PURE__ */ jsx307("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Bin_default = SvgBin;

// src/icons/generated/Bow.tsx
import { jsx as jsx308, jsxs as jsxs288 } from "react/jsx-runtime";
var SvgBow = (props) => /* @__PURE__ */ jsxs288("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx308("path", {
      fill: "currentColor",
      d: "M9.14 15.79a1 1 0 0 1-.7-.29 1 1 0 0 1 0-1.41l7.82-7.84a1.004 1.004 0 0 1 1.42 1.42L9.85 15.5a1 1 0 0 1-.71.29Z"
    }),
    /* @__PURE__ */ jsx308("path", {
      fill: "currentColor",
      d: "M19.21 9.32a2.58 2.58 0 0 1-1.83-.74 2.43 2.43 0 0 1-.68-1.35 2.47 2.47 0 0 1-1.37-.67 2.541 2.541 0 0 1-.76-1.83 2.701 2.701 0 0 1 .81-1.92 2.74 2.74 0 0 1 1.85-.79l3.75-.05a1 1 0 0 1 .71.3 1 1 0 0 1 .29.7v3.37a2.67 2.67 0 0 1-.8 2.15 2.72 2.72 0 0 1-1.97.83Zm-1.43-4.17a1 1 0 0 1 .94 1.33.74.74 0 0 0 .06.68.701.701 0 0 0 1-.05.68.68 0 0 0 .2-.57V3.97h-2.69a.72.72 0 0 0-.51.22.67.67 0 0 0-.21.49.6.6 0 0 0 .16.41.76.76 0 0 0 .72.06c.11-.014.22-.014.33 0ZM10.09 14.85a1 1 0 0 1-.91-.59L5.4 5.77a1 1 0 0 1 .5-1.32 1 1 0 0 1 1.32.52l3.76 8.48a1 1 0 0 1-.5 1.32c-.123.053-.256.08-.39.08Z"
    }),
    /* @__PURE__ */ jsx308("path", {
      fill: "currentColor",
      d: "M14.34 10.61a1 1 0 0 1-.94-.64c-.54-1.58-1.22-3.56-5.78-3.7-2.57-.08-4-.63-4.55-1.73a2.06 2.06 0 0 1 .24-2.13 1 1 0 0 1 1.4-.2 1 1 0 0 1 .21 1.38.16.16 0 0 0 0 .09s.43.48 2.79.55c5.49.17 6.81 2.7 7.61 5.06a1 1 0 0 1-.62 1.27 1.26 1.26 0 0 1-.36.05ZM18.6 18.63c-.142 0-.281-.031-.41-.09l-8.5-3.77a1 1 0 1 1 .81-1.8l8.48 3.74a1.001 1.001 0 0 1 .152 1.75 1 1 0 0 1-.532.17Z"
    }),
    /* @__PURE__ */ jsx308("path", {
      fill: "currentColor",
      d: "M20.29 21.05a2 2 0 0 1-.83-.19c-1.1-.53-1.65-2-1.73-4.54-.14-4.55-2.12-5.22-3.75-5.76a1.005 1.005 0 1 1 .65-1.9c2.36.8 4.89 2.12 5.06 7.6.07 2.27.54 2.75.6 2.79 0 0 .06.04 0 0a1 1 0 0 1 1.38.26 1 1 0 0 1-.2 1.36 2.17 2.17 0 0 1-1.18.38ZM6.31 21.97a1 1 0 0 1-1-1v-2.3H2.98a1 1 0 0 1-.9-.7 1 1 0 0 1 .22-1l2.83-2.83a1 1 0 0 1 .71-.29h3.31a1 1 0 0 1 1 1v3.3a1.001 1.001 0 0 1-.3.71l-2.87 2.78a1 1 0 0 1-.67.33Zm-.89-5.3h.89a1 1 0 0 1 1 1v.89l.84-.84V15.8h-1.9l-.83.87Z"
    })
  ]
});
var Bow_default = SvgBow;

// src/icons/generated/Bubble.tsx
import { jsx as jsx309, jsxs as jsxs289 } from "react/jsx-runtime";
var SvgBubble = (props) => /* @__PURE__ */ jsxs289("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs289("g", {
      fill: "currentColor",
      clipPath: "url(#bubble_svg__a)",
      children: [
        /* @__PURE__ */ jsx309("path", {
          d: "M3 22a.98.98 0 0 1-.74-.33c-.28-.3-.34-.75-.16-1.12l1.73-3.5A9.29 9.29 0 0 1 2 11.55C2 6.28 6.49 2 12 2s10 4.28 10 9.55c0 5.27-4.49 9.55-10 9.55-1.46 0-2.87-.3-4.19-.88l-4.45 1.71c-.12.04-.24.07-.36.07Zm9-18c-4.41 0-8 3.39-8 7.55 0 1.74.61 3.37 1.77 4.73.26.3.31.73.14 1.09l-.88 1.78 2.46-.95c.26-.1.55-.09.8.04 1.16.57 2.41.87 3.71.87 4.41 0 8-3.39 8-7.55S16.41 4 12 4Z"
        }),
        /* @__PURE__ */ jsx309("path", {
          d: "M9 13c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.2-.16.33-.21.36-.15.81-.07 1.09.21.19.19.29.45.29.71 0 .26-.1.52-.29.71-.19.18-.45.29-.71.29ZM12 13c-.26 0-.52-.11-.71-.29l-.12-.15a.757.757 0 0 1-.09-.18.636.636 0 0 1-.06-.18c0-.07-.02-.13-.02-.2 0-.06 0-.13.02-.19.01-.07.03-.13.06-.19.02-.06.05-.12.09-.18l.12-.15c.37-.37 1.05-.37 1.42 0 .04.05.09.1.12.15.04.06.07.12.09.18.03.06.05.12.06.19.01.06.02.13.02.19 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18-.02.06-.05.12-.09.18-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29ZM15 13c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.37-.37 1.05-.37 1.42 0 .19.19.29.45.29.71 0 .26-.1.52-.29.71-.19.18-.45.29-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx309("defs", {
      children: /* @__PURE__ */ jsx309("clipPath", {
        id: "bubble_svg__a",
        children: /* @__PURE__ */ jsx309("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Bubble_default = SvgBubble;

// src/icons/generated/Building.tsx
import { jsx as jsx310, jsxs as jsxs290 } from "react/jsx-runtime";
var SvgBuilding = (props) => /* @__PURE__ */ jsxs290("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs290("g", {
      fill: "currentColor",
      clipPath: "url(#building_svg__a)",
      children: [
        /* @__PURE__ */ jsx310("path", {
          d: "M19 22h-5c-.55 0-1-.45-1-1v-3h-2v3c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1Zm-4-2h3V4H6v16h3v-3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v3Z"
        }),
        /* @__PURE__ */ jsx310("path", {
          d: "M10 8H9c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM15 8h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM10 11H9c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM15 11h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM10 14H9c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM15 14h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx310("defs", {
      children: /* @__PURE__ */ jsx310("clipPath", {
        id: "building_svg__a",
        children: /* @__PURE__ */ jsx310("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Building_default = SvgBuilding;

// src/icons/generated/BusFront.tsx
import { jsx as jsx311, jsxs as jsxs291 } from "react/jsx-runtime";
var SvgBusFront = (props) => /* @__PURE__ */ jsxs291("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs291("g", {
      fill: "currentColor",
      clipPath: "url(#bus-front_svg__a)",
      children: [
        /* @__PURE__ */ jsx311("path", {
          d: "M19 20H5c-.55 0-1-.45-1-1V6c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v13c0 .55-.45 1-1 1ZM6 18h12V6c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12Z"
        }),
        /* @__PURE__ */ jsx311("path", {
          d: "M7.49 22H6.5c-.83 0-1.51-.68-1.51-1.51v-1.27c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1.27c0 .83-.68 1.51-1.51 1.51h.01ZM17.49 22h-.99c-.83 0-1.51-.68-1.51-1.51V19c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1.49c0 .83-.68 1.51-1.51 1.51h.01ZM12.1 14H12c-3.47-.01-5.55-.51-7.29-1.04a.997.997 0 0 1-.66-1.25.99.99 0 0 1 1.25-.66c1.59.49 3.5.95 6.71.96 3.29.01 5.12-.47 6.7-.96a.997.997 0 0 1 1.25.66.997.997 0 0 1-.66 1.25c-1.72.53-3.68 1.04-7.19 1.04h-.01ZM22 12c-.55 0-1-.45-1-1V8c0-.55-.45-1-1-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.65 0 3 1.35 3 3v3c0 .55-.45 1-1 1ZM2 12c-.55 0-1-.45-1-1V8c0-1.65 1.35-3 3-3h1c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1 .45-1 1v3c0 .55-.45 1-1 1ZM9 17H8c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM16 17h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx311("path", {
          d: "M20 7H5c-.55 0-1-.45-1-1s.45-1 1-1h15c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx311("defs", {
      children: /* @__PURE__ */ jsx311("clipPath", {
        id: "bus-front_svg__a",
        children: /* @__PURE__ */ jsx311("path", {
          fill: "#fff",
          d: "M1 2h22v20H1z"
        })
      })
    })
  ]
});
var BusFront_default = SvgBusFront;

// src/icons/generated/BusLeft.tsx
import { jsx as jsx312, jsxs as jsxs292 } from "react/jsx-runtime";
var SvgBusLeft = (props) => /* @__PURE__ */ jsxs292("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs292("g", {
      fill: "currentColor",
      clipPath: "url(#bus-left_svg__a)",
      children: [
        /* @__PURE__ */ jsx312("path", {
          d: "M18.5 18.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM4.5 18.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M23 17h-3a1 1 0 0 1 0-2h2V9a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v5h1a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-6a4 4 0 0 1 4-4h17a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M16 17H7a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M12 16a1 1 0 0 1-1-1V7.5a1 1 0 0 1 2 0V15a1 1 0 0 1-1 1ZM8 16a1 1 0 0 1-1-1V7.67a1 1 0 0 1 2 0V15a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M3.59 13H1a1 1 0 0 1 0-2h2.59l.41-.41A2 2 0 0 1 5.41 10H23a1 1 0 0 1 0 2H5.41l-.41.41a2 2 0 0 1-1.41.59Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx312("defs", {
      children: /* @__PURE__ */ jsx312("clipPath", {
        id: "bus-left_svg__a",
        children: /* @__PURE__ */ jsx312("path", {
          fill: "#fff",
          d: "M0 6h24v12.5H0z"
        })
      })
    })
  ]
});
var BusLeft_default = SvgBusLeft;

// src/icons/generated/BusRight.tsx
import { jsx as jsx313, jsxs as jsxs293 } from "react/jsx-runtime";
var SvgBusRight = (props) => /* @__PURE__ */ jsxs293("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs293("g", {
      fill: "currentColor",
      clipPath: "url(#bus-right_svg__a)",
      children: [
        /* @__PURE__ */ jsx313("path", {
          d: "M5.5 18.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Zm0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5ZM19.5 18.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Zm0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5Z"
        }),
        /* @__PURE__ */ jsx313("path", {
          d: "M23 17h-2c-.55 0-1-.45-1-1s.45-1 1-1h1v-5c0-1.1-.9-2-2-2H3c-.55 0-1 .45-1 1v6h2c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1V9c0-1.65 1.35-3 3-3h17c2.21 0 4 1.79 4 4v6c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx313("path", {
          d: "M17 17H8c-.55 0-1-.45-1-1s.45-1 1-1h9c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx313("path", {
          d: "M12 16c-.55 0-1-.45-1-1V7.5c0-.55.45-1 1-1s1 .45 1 1V15c0 .55-.45 1-1 1ZM16 16c-.55 0-1-.45-1-1V7.67c0-.55.45-1 1-1s1 .45 1 1V15c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx313("path", {
          d: "M22.97 13h-2.56c-.53 0-1.04-.21-1.41-.59l-.41-.41H1c-.55 0-1-.45-1-1s.45-1 1-1h17.59c.53 0 1.04.21 1.41.59l.41.41h2.56c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx313("defs", {
      children: /* @__PURE__ */ jsx313("clipPath", {
        id: "bus-right_svg__a",
        children: /* @__PURE__ */ jsx313("path", {
          fill: "#fff",
          d: "M0 6h24v12.5H0z"
        })
      })
    })
  ]
});
var BusRight_default = SvgBusRight;

// src/icons/generated/Cake.tsx
import { jsx as jsx314, jsxs as jsxs294 } from "react/jsx-runtime";
var SvgCake = (props) => /* @__PURE__ */ jsxs294("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx314("g", {
      clipPath: "url(#cake_svg__a)",
      children: /* @__PURE__ */ jsx314("path", {
        fill: "currentColor",
        d: "M18 9h-5v-.18a2.91 2.91 0 0 0 1-.62 3 3 0 0 0 .21-4.2l-1.46-1.67A1 1 0 0 0 12 2a1 1 0 0 0-.75.33L9.67 4.11A3 3 0 0 0 9.8 8a2.91 2.91 0 0 0 1.2.81V9H6a4 4 0 0 0-4 4v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a4 4 0 0 0-4-4Zm-6.8-3.6.8-.9.73.82A1 1 0 0 1 13 6a1 1 0 0 1-.32.69A.93.93 0 0 1 12 7a1 1 0 0 1-.69-.32 1 1 0 0 1-.11-1.28ZM4 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a3 3 0 0 1-3-3 1 1 0 0 0-2 0 3 3 0 0 1-6 0 1 1 0 0 0-2 0 3 3 0 0 1-3 3v-3Zm16 7H4v-2a5 5 0 0 0 4-2 5 5 0 0 0 8 0 5 5 0 0 0 4 2v2Z"
      })
    }),
    /* @__PURE__ */ jsx314("defs", {
      children: /* @__PURE__ */ jsx314("clipPath", {
        id: "cake_svg__a",
        children: /* @__PURE__ */ jsx314("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Cake_default = SvgCake;

// src/icons/generated/CalendarCheck.tsx
import { jsx as jsx315, jsxs as jsxs295 } from "react/jsx-runtime";
var SvgCalendarCheck = (props) => /* @__PURE__ */ jsxs295("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs295("g", {
      fill: "currentColor",
      clipPath: "url(#calendar-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx315("path", {
          d: "M19.99 21H4.01C2.9 21 2 20.1 2 18.99V6.01C2 4.9 2.9 4 4.01 4h15.98C21.1 4 22 4.9 22 6.01v12.98c0 1.11-.9 2.01-2.01 2.01ZM4.01 6v12.99H20V6.01H4.01V6Z"
        }),
        /* @__PURE__ */ jsx315("path", {
          d: "M7 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM17 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM11 18c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47H11Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx315("defs", {
      children: /* @__PURE__ */ jsx315("clipPath", {
        id: "calendar-check_svg__a",
        children: /* @__PURE__ */ jsx315("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var CalendarCheck_default = SvgCalendarCheck;

// src/icons/generated/Calendar.tsx
import { jsx as jsx316, jsxs as jsxs296 } from "react/jsx-runtime";
var SvgCalendar = (props) => /* @__PURE__ */ jsxs296("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs296("g", {
      fill: "currentColor",
      clipPath: "url(#calendar_svg__a)",
      children: [
        /* @__PURE__ */ jsx316("path", {
          d: "M19.99 21H4.01C2.9 21 2 20.1 2 18.99V6.01C2 4.9 2.9 4 4.01 4h15.98C21.1 4 22 4.9 22 6.01v12.98c0 1.11-.9 2.01-2.01 2.01ZM4.01 6v12.99H20V6.01H4.01V6Z"
        }),
        /* @__PURE__ */ jsx316("path", {
          d: "M20.86 10H3.1c-.55 0-1-.45-1-1s.45-1 1-1h17.76c.55 0 1 .45 1 1s-.45 1-1 1ZM7 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM17 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx316("defs", {
      children: /* @__PURE__ */ jsx316("clipPath", {
        id: "calendar_svg__a",
        children: /* @__PURE__ */ jsx316("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var Calendar_default = SvgCalendar;

// src/icons/generated/Camping.tsx
import { jsx as jsx317 } from "react/jsx-runtime";
var SvgCamping = (props) => /* @__PURE__ */ jsx317("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx317("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.5 21 14 3m6.5 18L10 3m5.5 18L12 15l-3.5 6M2 21h20"
  })
});
var Camping_default = SvgCamping;

// src/icons/generated/Cancelled.tsx
import { jsx as jsx318, jsxs as jsxs297 } from "react/jsx-runtime";
var SvgCancelled = (props) => /* @__PURE__ */ jsxs297("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs297("g", {
      fill: "currentColor",
      clipPath: "url(#cancelled_svg__a)",
      children: [
        /* @__PURE__ */ jsx318("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx318("path", {
          d: "M18.3 19.3c-.26 0-.51-.1-.71-.29L4.99 6.41A.996.996 0 1 1 6.4 5L19 17.6a.996.996 0 0 1-.71 1.7h.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx318("defs", {
      children: /* @__PURE__ */ jsx318("clipPath", {
        id: "cancelled_svg__a",
        children: /* @__PURE__ */ jsx318("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Cancelled_default = SvgCancelled;

// src/icons/generated/CarDoor.tsx
import { jsx as jsx319, jsxs as jsxs298 } from "react/jsx-runtime";
var SvgCarDoor = (props) => /* @__PURE__ */ jsxs298("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs298("g", {
      fill: "currentColor",
      clipPath: "url(#car-door_svg__a)",
      children: [
        /* @__PURE__ */ jsx319("path", {
          d: "M19 22H9c-.46 0-.86-.31-.97-.76l-.25-1a7.006 7.006 0 0 0-2.91-4.13l-.43-.28c-.28-.19-.45-.5-.45-.83v-5c0-.27.11-.52.29-.71l5.84-5.83c.94-.94 2.2-1.46 3.54-1.46H19c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1Zm-9.22-2H18V4h-4.34c-.8 0-1.56.31-2.12.88L6 10.41v4.05a8.966 8.966 0 0 1 3.72 5.29l.06.24V20Z"
        }),
        /* @__PURE__ */ jsx319("path", {
          d: "M19 11H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM16 14h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx319("defs", {
      children: /* @__PURE__ */ jsx319("clipPath", {
        id: "car-door_svg__a",
        children: /* @__PURE__ */ jsx319("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var CarDoor_default = SvgCarDoor;

// src/icons/generated/CarFront.tsx
import { jsx as jsx320, jsxs as jsxs299 } from "react/jsx-runtime";
var SvgCarFront = (props) => /* @__PURE__ */ jsxs299("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs299("g", {
      fill: "currentColor",
      clipPath: "url(#car-front_svg__a)",
      children: [
        /* @__PURE__ */ jsx320("path", {
          d: "M20 19H4a1 1 0 0 1-.89-.55l-.79-1.58A3 3 0 0 1 2 15.53v-3.06a3 3 0 0 1 .32-1.34l.75-1.51 1.3-3.89A4 4 0 0 1 8.16 3h7.68a4 4 0 0 1 3.79 2.74l1.3 3.88.75 1.51a3 3 0 0 1 .32 1.34v3.06a3 3 0 0 1-.32 1.34l-.79 1.58A1 1 0 0 1 20 19ZM4.62 17h14.76l.51-1a1 1 0 0 0 .11-.45v-3.06a.999.999 0 0 0-.11-.45l-.78-1.57a1.403 1.403 0 0 1-.06-.13l-1.32-4a2 2 0 0 0-1.89-1.37H8.16a2 2 0 0 0-1.89 1.37l-1.32 4a1.387 1.387 0 0 1-.06.13l-.78 1.57a1 1 0 0 0-.11.45v3.06a1 1 0 0 0 .11.45l.51 1Z"
        }),
        /* @__PURE__ */ jsx320("path", {
          d: "M7.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V18a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.49A1.52 1.52 0 0 1 7.49 21ZM18.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V18a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.49A1.52 1.52 0 0 1 18.49 21ZM12.12 12H12a29.721 29.721 0 0 1-8.26-1 1 1 0 0 1-.71-1.23 1 1 0 0 1 1.23-.71 27.64 27.64 0 0 0 7.74 1h.11c2.579.042 5.15-.294 7.63-1a1 1 0 0 1 1.23.71 1.001 1.001 0 0 1-.71 1.23 28.352 28.352 0 0 1-8.14 1ZM7 15H6a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2ZM18 15h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2ZM12 16.25a9.414 9.414 0 0 1-2.24-.28 1 1 0 0 1 .48-1.94 7.23 7.23 0 0 0 3.52 0 1 1 0 0 1 1.095 1.486 1 1 0 0 1-.615.454 9.415 9.415 0 0 1-2.24.28Z"
        }),
        /* @__PURE__ */ jsx320("path", {
          d: "M20 11a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l1-2a1 1 0 0 1 1.34-.44 1 1 0 0 1 .44 1.34l-1 2A1 1 0 0 1 20 11Z"
        }),
        /* @__PURE__ */ jsx320("path", {
          d: "M23 9h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM4 11a1 1 0 0 1-.89-.55l-1-2a1 1 0 0 1 .44-1.34 1 1 0 0 1 1.34.44l1 2a1 1 0 0 1-.44 1.34A.93.93 0 0 1 4 11Z"
        }),
        /* @__PURE__ */ jsx320("path", {
          d: "M3 9H1a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx320("defs", {
      children: /* @__PURE__ */ jsx320("clipPath", {
        id: "car-front_svg__a",
        children: /* @__PURE__ */ jsx320("path", {
          fill: "#fff",
          d: "M0 3h24v18H0z"
        })
      })
    })
  ]
});
var CarFront_default = SvgCarFront;

// src/icons/generated/Car.tsx
import { jsx as jsx321, jsxs as jsxs300 } from "react/jsx-runtime";
var SvgCar = (props) => /* @__PURE__ */ jsxs300("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx321("g", {
      clipPath: "url(#car_svg__a)",
      children: /* @__PURE__ */ jsxs300("g", {
        fill: "currentColor",
        clipPath: "url(#car_svg__b)",
        children: [
          /* @__PURE__ */ jsx321("path", {
            d: "M18.01 19.02c-1.65 0-3-1.35-3-3.02s1.35-3.02 3-3.02 3 1.35 3 3.02-1.35 3.02-3 3.02Zm0-4.04c-.55 0-1 .46-1 1.02s.45 1.02 1 1.02 1-.46 1-1.02-.45-1.02-1-1.02ZM6.01 19c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
          }),
          /* @__PURE__ */ jsx321("path", {
            d: "M23.01 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h2v-1c-.03-.38-1.07-2.66-5.31-4.05a.936.936 0 0 1-.4-.25c-.49-.49-.97-.9-1.88-1.4-1.15-.63-2.91-1.3-4.41-1.3h-4c-.34 0-1.18.42-1.41.71l-1.32 1.4c-.18.19-.27.43-.27.69v2.21c0 .27-.11.52-.29.71l-.71.71c.02.42.12 1.05.43 1.38.09.1.24.21.57.21.55 0 1 .45 1 1s-.45 1-1 1c-.81 0-1.51-.29-2.03-.85C-.1 15.01 0 13.14 0 12.93c.02-.24.12-.47.29-.64l.71-.71V9.79c0-.77.29-1.5.82-2.06l1.27-1.34C3.67 5.67 5.05 5 6.01 5h4c1.6 0 3.61.58 5.38 1.55 1.01.55 1.61 1.04 2.16 1.57 4.7 1.61 6.46 4.44 6.46 5.87v2c0 .55-.45 1-1 1V17Z"
          }),
          /* @__PURE__ */ jsx321("path", {
            d: "M15.01 17h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1ZM13.01 12c-.05 0-.11 0-.17-.01l-6-1a.999.999 0 0 1 .33-1.97l6 1c.54.09.91.61.82 1.15a1 1 0 0 1-.99.84l.01-.01Z"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsxs300("defs", {
      children: [
        /* @__PURE__ */ jsx321("clipPath", {
          id: "car_svg__a",
          children: /* @__PURE__ */ jsx321("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        }),
        /* @__PURE__ */ jsx321("clipPath", {
          id: "car_svg__b",
          children: /* @__PURE__ */ jsx321("path", {
            fill: "#fff",
            d: "M0 5h24.01v14.02H0z"
          })
        })
      ]
    })
  ]
});
var Car_default = SvgCar;

// src/icons/generated/Certificate.tsx
import { jsx as jsx322, jsxs as jsxs301 } from "react/jsx-runtime";
var SvgCertificate = (props) => /* @__PURE__ */ jsxs301("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs301("g", {
      fill: "currentColor",
      clipPath: "url(#certificate_svg__a)",
      children: [
        /* @__PURE__ */ jsx322("path", {
          d: "M15 18c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
        }),
        /* @__PURE__ */ jsx322("path", {
          d: "M17 22c-.21 0-.42-.07-.6-.2L15 20.75l-1.4 1.05c-.3.23-.71.26-1.05.09A1 1 0 0 1 12 21v-4.5c0-.55.45-1 1-1s1 .45 1 1V19l.4-.3a.99.99 0 0 1 1.2 0l.4.3v-2.5c0-.55.45-1 1-1s1 .45 1 1V21c0 .38-.21.72-.55.89-.14.07-.29.11-.45.11Z"
        }),
        /* @__PURE__ */ jsx322("path", {
          d: "M10 19H5c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v10c0 1.07-.58 2.06-1.5 2.6-.48.28-1.09.11-1.37-.36-.28-.48-.11-1.09.36-1.37.31-.18.5-.51.5-.87V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h5c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx322("path", {
          d: "M18 9H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1ZM9 12H6c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1ZM8 15H6c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx322("defs", {
      children: /* @__PURE__ */ jsx322("clipPath", {
        id: "certificate_svg__a",
        children: /* @__PURE__ */ jsx322("path", {
          fill: "#fff",
          d: "M2 3h20v19H2z"
        })
      })
    })
  ]
});
var Certificate_default = SvgCertificate;

// src/icons/generated/CheckboxCheck.tsx
import { jsx as jsx323, jsxs as jsxs302 } from "react/jsx-runtime";
var SvgCheckboxCheck = (props) => /* @__PURE__ */ jsxs302("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs302("g", {
      fill: "currentColor",
      clipPath: "url(#checkbox-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx323("path", {
          d: "M18.16 22H5.84C3.72 22 2 20.28 2 18.16V5.84C2 3.72 3.72 2 5.84 2h12.32C20.28 2 22 3.72 22 5.84v12.32c0 2.12-1.72 3.84-3.84 3.84ZM5.84 4C4.82 4 4 4.83 4 5.84v12.32C4 19.18 4.83 20 5.84 20h12.32c1.02 0 1.84-.83 1.84-1.84V5.84C20 4.82 19.17 4 18.16 4H5.84Z"
        }),
        /* @__PURE__ */ jsx323("path", {
          d: "M11 17c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47H11Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx323("defs", {
      children: /* @__PURE__ */ jsx323("clipPath", {
        id: "checkbox-check_svg__a",
        children: /* @__PURE__ */ jsx323("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var CheckboxCheck_default = SvgCheckboxCheck;

// src/icons/generated/Checkbox.tsx
import { jsx as jsx324, jsxs as jsxs303 } from "react/jsx-runtime";
var SvgCheckbox = (props) => /* @__PURE__ */ jsxs303("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx324("g", {
      clipPath: "url(#checkbox_svg__a)",
      children: /* @__PURE__ */ jsx324("path", {
        fill: "currentColor",
        d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
      })
    }),
    /* @__PURE__ */ jsx324("defs", {
      children: /* @__PURE__ */ jsx324("clipPath", {
        id: "checkbox_svg__a",
        children: /* @__PURE__ */ jsx324("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Checkbox_default = SvgCheckbox;

// src/icons/generated/ChecklistInfo.tsx
import { jsx as jsx325, jsxs as jsxs304 } from "react/jsx-runtime";
var SvgChecklistInfo = (props) => /* @__PURE__ */ jsxs304("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs304("g", {
      fill: "currentColor",
      clipPath: "url(#checklist-info_svg__a)",
      children: [
        /* @__PURE__ */ jsx325("path", {
          d: "M19 22H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1H6v14h12V6h-3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx325("path", {
          d: "M12 18c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx325("path", {
          d: "M12 13h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1ZM14 18h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1ZM12 10c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.09-.1-.16-.21-.21-.33A.995.995 0 0 1 11 9c0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.37-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .13-.02.26-.08.38-.05.12-.12.23-.21.33-.19.18-.45.29-.71.29ZM15 7c-.55 0-1-.45-1-1 0-1.1-.9-2-2-2s-2 .9-2 2c0 .55-.45 1-1 1s-1-.45-1-1c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx325("path", {
          d: "M15 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx325("defs", {
      children: /* @__PURE__ */ jsx325("clipPath", {
        id: "checklist-info_svg__a",
        children: /* @__PURE__ */ jsx325("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var ChecklistInfo_default = SvgChecklistInfo;

// src/icons/generated/Checklist.tsx
import { jsx as jsx326, jsxs as jsxs305 } from "react/jsx-runtime";
var SvgChecklist = (props) => /* @__PURE__ */ jsxs305("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs305("g", {
      fill: "currentColor",
      clipPath: "url(#checklist_svg__a)",
      children: [
        /* @__PURE__ */ jsx326("path", {
          d: "M11 17h-.01c-.32 0-.62-.16-.8-.42l-2.5-3.5c-.32-.45-.22-1.07.23-1.4a.994.994 0 0 1 1.39.23l1.71 2.39 3.68-4.91c.33-.44.96-.53 1.4-.2.44.33.53.96.2 1.4l-4.5 6c-.19.25-.49.4-.8.4V17Z"
        }),
        /* @__PURE__ */ jsx326("path", {
          d: "M19 22H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1H6v14h12V6h-3c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1v16c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx326("path", {
          d: "M15 7c-.55 0-1-.45-1-1 0-1.1-.9-2-2-2s-2 .9-2 2c0 .55-.45 1-1 1s-1-.45-1-1c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx326("path", {
          d: "M15 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx326("defs", {
      children: /* @__PURE__ */ jsx326("clipPath", {
        id: "checklist_svg__a",
        children: /* @__PURE__ */ jsx326("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Checklist_default = SvgChecklist;

// src/icons/generated/CheckmarkCircle.tsx
import { jsx as jsx327, jsxs as jsxs306 } from "react/jsx-runtime";
var SvgCheckmarkCircle = (props) => /* @__PURE__ */ jsxs306("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx327("path", {
      fill: "currentColor",
      d: "M11 17c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47H11Z"
    }),
    /* @__PURE__ */ jsx327("path", {
      fill: "currentColor",
      d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
    })
  ]
});
var CheckmarkCircle_default = SvgCheckmarkCircle;

// src/icons/generated/CheckmarkMedium.tsx
import { jsx as jsx328 } from "react/jsx-runtime";
var SvgCheckmarkMedium = (props) => /* @__PURE__ */ jsx328("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx328("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.537 5.156a1 1 0 0 1 .307 1.38l-7.637 12a1 1 0 0 1-1.624.089L5.219 13.17a1 1 0 0 1 1.562-1.25l3.49 4.363 6.885-10.82a1 1 0 0 1 1.38-.307Z",
    clipRule: "evenodd"
  })
});
var CheckmarkMedium_default = SvgCheckmarkMedium;

// src/icons/generated/CheckmarkSmall.tsx
import { jsx as jsx329 } from "react/jsx-runtime";
var SvgCheckmarkSmall = (props) => /* @__PURE__ */ jsx329("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx329("path", {
    fill: "currentColor",
    d: "M11 17c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47H11Z"
  })
});
var CheckmarkSmall_default = SvgCheckmarkSmall;

// src/icons/generated/Checkmark.tsx
import { jsx as jsx330 } from "react/jsx-runtime";
var SvgCheckmark = (props) => /* @__PURE__ */ jsx330("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx330("path", {
    fill: "currentColor",
    d: "M9.16 22c-.33 0-.64-.16-.83-.44l-6.16-8.99a.997.997 0 0 1 .26-1.39c.46-.31 1.08-.19 1.39.26l5.32 7.77L20.16 2.45a1 1 0 0 1 1.38-.29 1 1 0 0 1 .29 1.38L9.99 21.55c-.18.28-.49.45-.83.45Z"
  })
});
var Checkmark_default = SvgCheckmark;

// src/icons/generated/ChevronDoubleSmall.tsx
import { jsx as jsx331 } from "react/jsx-runtime";
var SvgChevronDoubleSmall = (props) => /* @__PURE__ */ jsx331("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx331("path", {
    fill: "currentColor",
    d: "M8.753 17a1.003 1.003 0 0 1-.78-.369l-3.25-3.984a.994.994 0 0 1 0-1.255l3.25-3.985a.999.999 0 0 1 1.08-.369 1.001 1.001 0 0 1 .724.88.993.993 0 0 1-.254.744l-2.74 3.357 2.74 3.357A.994.994 0 0 1 8.753 17ZM14.806 17a1.003 1.003 0 0 1-.897-.57.992.992 0 0 1 .127-1.054l2.74-3.357-2.74-3.357a.996.996 0 0 1 .113-1.439 1.002 1.002 0 0 1 1.437.184l3.25 3.985a.994.994 0 0 1 0 1.255l-3.25 3.984a1 1 0 0 1-.78.369Z"
  })
});
var ChevronDoubleSmall_default = SvgChevronDoubleSmall;

// src/icons/generated/ChevronDownSmall.tsx
import { jsx as jsx332 } from "react/jsx-runtime";
var SvgChevronDownSmall = (props) => /* @__PURE__ */ jsx332("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx332("path", {
    fill: "currentColor",
    d: "M12 14.25a1 1 0 0 1-.63-.22l-4-3.25a.999.999 0 0 1 .913-1.753 1 1 0 0 1 .347.203L12 11.97l3.37-2.74a1 1 0 1 1 1.26 1.55l-4 3.25a1 1 0 0 1-.63.22Z"
  })
});
var ChevronDownSmall_default = SvgChevronDownSmall;

// src/icons/generated/ChevronDown.tsx
import { jsx as jsx333 } from "react/jsx-runtime";
var SvgChevronDown = (props) => /* @__PURE__ */ jsx333("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx333("path", {
    fill: "currentColor",
    d: "M12 18a1 1 0 0 1-.71-.29l-9-9a1.004 1.004 0 0 1 1.42-1.42l8.29 8.3 8.29-8.3a1.005 1.005 0 0 1 1.42 1.42l-9 9A1 1 0 0 1 12 18Z"
  })
});
var ChevronDown_default = SvgChevronDown;

// src/icons/generated/ChevronLeftSmall.tsx
import { jsx as jsx334 } from "react/jsx-runtime";
var SvgChevronLeftSmall = (props) => /* @__PURE__ */ jsx334("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx334("path", {
    fill: "currentColor",
    d: "M13.25 17a1 1 0 0 1-.78-.37l-3.25-4a1 1 0 0 1 0-1.26l3.25-4a.999.999 0 0 1 1.753.913 1 1 0 0 1-.203.347L11.28 12l2.74 3.37a1 1 0 0 1-.77 1.63Z"
  })
});
var ChevronLeftSmall_default = SvgChevronLeftSmall;

// src/icons/generated/ChevronLeft.tsx
import { jsx as jsx335, jsxs as jsxs307 } from "react/jsx-runtime";
var SvgChevronLeft = (props) => /* @__PURE__ */ jsxs307("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx335("g", {
      clipPath: "url(#chevron-left_svg__a)",
      children: /* @__PURE__ */ jsx335("path", {
        fill: "currentColor",
        d: "M16 22c-.26 0-.51-.1-.71-.29l-9-9a.996.996 0 0 1 0-1.41l9-9.01A.996.996 0 1 1 16.7 3.7L8.41 12l8.29 8.29a.996.996 0 0 1-.71 1.7L16 22Z"
      })
    }),
    /* @__PURE__ */ jsx335("defs", {
      children: /* @__PURE__ */ jsx335("clipPath", {
        id: "chevron-left_svg__a",
        children: /* @__PURE__ */ jsx335("path", {
          fill: "#fff",
          d: "M6 2h11v20H6z"
        })
      })
    })
  ]
});
var ChevronLeft_default = SvgChevronLeft;

// src/icons/generated/ChevronRightSmall.tsx
import { jsx as jsx336 } from "react/jsx-runtime";
var SvgChevronRightSmall = (props) => /* @__PURE__ */ jsx336("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx336("path", {
    fill: "currentColor",
    d: "M10 17a1 1 0 0 1-.77-1.63L11.97 12 9.23 8.63a1 1 0 1 1 1.55-1.26l3.25 4a1 1 0 0 1 0 1.26l-3.25 4A1 1 0 0 1 10 17Z"
  })
});
var ChevronRightSmall_default = SvgChevronRightSmall;

// src/icons/generated/ChevronRight.tsx
import { jsx as jsx337 } from "react/jsx-runtime";
var SvgChevronRight = (props) => /* @__PURE__ */ jsx337("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx337("path", {
    fill: "currentColor",
    d: "M8 22a1 1 0 0 1-.71-1.71l8.3-8.29-8.3-8.29a1.004 1.004 0 0 1 1.42-1.42l9 9a.999.999 0 0 1 0 1.42l-9 9A1 1 0 0 1 8 22Z"
  })
});
var ChevronRight_default = SvgChevronRight;

// src/icons/generated/ChevronUpSmall.tsx
import { jsx as jsx338 } from "react/jsx-runtime";
var SvgChevronUpSmall = (props) => /* @__PURE__ */ jsx338("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx338("path", {
    fill: "currentColor",
    d: "M16 14.25a1 1 0 0 1-.63-.22L12 11.29l-3.37 2.74a1 1 0 1 1-1.26-1.55l4-3.25a1 1 0 0 1 1.26 0l4 3.25a1 1 0 0 1-.63 1.77Z"
  })
});
var ChevronUpSmall_default = SvgChevronUpSmall;

// src/icons/generated/ChevronUp.tsx
import { jsx as jsx339 } from "react/jsx-runtime";
var SvgChevronUp = (props) => /* @__PURE__ */ jsx339("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx339("path", {
    fill: "currentColor",
    d: "M2 16a1 1 0 0 1 .29-.71l9-9a.999.999 0 0 1 1.42 0l9 9a1.003 1.003 0 1 1-1.42 1.42L12 8.41l-8.29 8.3A1.001 1.001 0 0 1 2 16Z"
  })
});
var ChevronUp_default = SvgChevronUp;

// src/icons/generated/ChildSeatHighChair.tsx
import { jsx as jsx340 } from "react/jsx-runtime";
var SvgChildSeatHighChair = (props) => /* @__PURE__ */ jsx340("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx340("path", {
    fill: "currentColor",
    d: "M15.96 11.71s-.02-.03-.03-.05c-.02-.07-.06-.12-.1-.18-.03-.05-.06-.1-.1-.15-.04-.05-.1-.08-.15-.12a.784.784 0 0 0-.15-.1c-.06-.03-.12-.04-.19-.06-.06-.02-.12-.03-.19-.04-.02 0-.04-.01-.06-.01h-1V9h4c.55 0 1-.45 1-1s-.45-1-1-1H7.72l-.73-5.14a1 1 0 0 0-1.98.28l1 7v.02c.05 1.34.77 2.52 1.83 3.2l-2.8 9.35c-.16.53.14 1.09.67 1.25a1.005 1.005 0 0 0 1.25-.67l.99-3.3s.03.01.05.01h8s.03 0 .05-.01l.99 3.3a1.005 1.005 0 0 0 1.25.67c.53-.16.83-.72.67-1.25l-3-10ZM12 9v2h-2c-1.1 0-2-.9-2-2h4Zm-3.46 8 1.21-4.03c.08 0 .16.03.25.03h4.26l1.2 4H8.54Z"
  })
});
var ChildSeatHighChair_default = SvgChildSeatHighChair;

// src/icons/generated/Child.tsx
import { jsx as jsx341, jsxs as jsxs308 } from "react/jsx-runtime";
var SvgChild = (props) => /* @__PURE__ */ jsxs308("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs308("g", {
      fill: "currentColor",
      clipPath: "url(#child_svg__a)",
      children: [
        /* @__PURE__ */ jsx341("path", {
          d: "M12 23a10.002 10.002 0 0 1-9.4-6.56A3.51 3.51 0 0 1 1.33 12a3.4 3.4 0 0 1 .91-1.18 10 10 0 0 1 4.08-6.06 1 1 0 0 1 1.39.25 1 1 0 0 1-.26 1.39 8.11 8.11 0 0 0-3.33 5.17.94.94 0 0 1-.44.66 1.54 1.54 0 0 0-.54.62 1.51 1.51 0 0 0 .72 2 .94.94 0 0 1 .52.6 8 8 0 0 0 5.17 5.16 8 8 0 0 0 10.07-5.16 1.002 1.002 0 0 1 .52-.6 1.5 1.5 0 0 0 .62-.55 1.47 1.47 0 0 0-.026-1.66 1.509 1.509 0 0 0-.424-.41 1.001 1.001 0 0 1-.44-.66 8 8 0 0 0-3.43-5.24 1 1 0 0 1 .748-1.81 1 1 0 0 1 .362.15 10.07 10.07 0 0 1 4.21 6.15 3.45 3.45 0 0 1 1.16 1.94 3.44 3.44 0 0 1-.48 2.63 3.499 3.499 0 0 1-1 1.05 10 10 0 0 1-4.82 5.45A9.93 9.93 0 0 1 12 23Z"
        }),
        /* @__PURE__ */ jsx341("path", {
          d: "M12 19.05a4.49 4.49 0 0 1-3.22-1.35 1 1 0 1 1 1.42-1.41 2.5 2.5 0 0 0 3.53 0 1 1 0 1 1 1.44 1.39l-.07.07a4.46 4.46 0 0 1-3.1 1.3ZM11 9a1 1 0 0 1-1-1 6 6 0 0 0-2-4.17 1 1 0 0 1 .357-1.809 1 1 0 0 1 .753.149A7.88 7.88 0 0 1 12 8a1 1 0 0 1-1 1ZM14.49 9a1 1 0 0 1-1-1 7.15 7.15 0 0 0-1.8-4.4 1 1 0 0 1 1.6-1.2 9.15 9.15 0 0 1 2.2 5.6 1 1 0 0 1-1 1ZM10 15a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1ZM14 15a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx341("defs", {
      children: /* @__PURE__ */ jsx341("clipPath", {
        id: "child_svg__a",
        children: /* @__PURE__ */ jsx341("path", {
          fill: "#fff",
          d: "M1 2h22v21H1z"
        })
      })
    })
  ]
});
var Child_default = SvgChild;

// src/icons/generated/ChildrenPlaySpace.tsx
import { jsx as jsx342 } from "react/jsx-runtime";
var SvgChildrenPlaySpace = (props) => /* @__PURE__ */ jsx342("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx342("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.29 1.04 10 3c.53.16.83.72.67 1.25a1.005 1.005 0 0 1-1.25.67L12 3.05 2.29 5.96a1.003 1.003 0 0 1-.58-1.92l10.01-3c.18-.06.38-.06.57 0Zm4.91 5.97c.38-.05.74.18.92.51l.02-.02 1.94 3.5c.21.39.15.87-.17 1.19l-1.17 1.17a.99.99 0 0 1-1.15.19l-.66-.33-.17.34 1.15 4.88c.42-.26.97-.19 1.29.2a1 1 0 0 1-.14 1.41c-2.41 1.98-4.83 2.97-7.25 2.97s-4.85-.99-7.25-2.97a1 1 0 0 1-.14-1.41c.31-.38.84-.45 1.26-.21l.98-4.66c-.5.2-.86.69-.86 1.24s-.45 1-1 1-1-.45-1-1c0-1.83 1.49-3.33 3.33-3.33h3.96c.77-2.12 1.94-4.49 6.11-4.67Zm-6.28 11.33-.96 2.41c1.23.32 2.45.32 3.68 0l-.96-2.41h-1.76Zm6.903-6.883L16.92 11a.96.96 0 0 0-.76-.05c-.25.08-.46.26-.58.5l-.78 1.56c-.1.21-.13.45-.08.68l1.41 6-.167.096c-.151.088-.3.173-.453.254l-1.23-3.06a1 1 0 0 0-.93-.63h-3.11a1 1 0 0 0-.93.63l-1.23 3.06c-.21-.11-.42-.23-.63-.36l1.26-6h3.08c.42 0 .8-.27.94-.67l.04-.11c.71-2.03 1.24-3.53 3.9-3.84l1.27 2.28-.117.117Z",
    clipRule: "evenodd"
  })
});
var ChildrenPlaySpace_default = SvgChildrenPlaySpace;

// src/icons/generated/ChildrenPlayground.tsx
import { jsx as jsx343 } from "react/jsx-runtime";
var SvgChildrenPlayground = (props) => /* @__PURE__ */ jsx343("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx343("path", {
    fill: "currentColor",
    d: "M21 18c-3.31 0-6-2.69-6-6 0-.55-.45-1-1-1h-2V7c0-.27-.11-.52-.29-.71l-4-4a.996.996 0 0 0-1.41 0l-4.01 4A.99.99 0 0 0 2 7v14c0 .55.45 1 1 1s1-.45 1-1v-8h2v8c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-8h1.07A8.002 8.002 0 0 0 20 19.93V21c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1ZM8 16h2v1H8v-1Zm0 3h2v1H8v-1ZM4 7.41l3-3 3 3V11H4V7.41ZM10 13v1H8v-1h2Z"
  })
});
var ChildrenPlayground_default = SvgChildrenPlayground;

// src/icons/generated/Clock.tsx
import { jsx as jsx344, jsxs as jsxs309 } from "react/jsx-runtime";
var SvgClock = (props) => /* @__PURE__ */ jsxs309("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs309("g", {
      fill: "currentColor",
      clipPath: "url(#clock_svg__a)",
      children: [
        /* @__PURE__ */ jsx344("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx344("path", {
          d: "M15.01 16.05c-.26 0-.52-.1-.71-.3l-3.01-3.05A.984.984 0 0 1 11 12V6.48c0-.55.45-1 1-1s1 .45 1 1v5.11l2.73 2.76c.39.39.38 1.03 0 1.41-.2.19-.45.29-.7.29h-.02Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx344("defs", {
      children: /* @__PURE__ */ jsx344("clipPath", {
        id: "clock_svg__a",
        children: /* @__PURE__ */ jsx344("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Clock_default = SvgClock;

// src/icons/generated/Cloud.tsx
import { jsx as jsx345, jsxs as jsxs310 } from "react/jsx-runtime";
var SvgCloud = (props) => /* @__PURE__ */ jsxs310("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx345("g", {
      clipPath: "url(#cloud_svg__a)",
      children: /* @__PURE__ */ jsx345("path", {
        fill: "currentColor",
        d: "M17 20H6.5C4.02 20 2 17.98 2 15.5c0-1.75 1.02-3.31 2.54-4.05-.02-.15-.04-.3-.04-.45a3.009 3.009 0 0 1 3.65-2.93A5.002 5.002 0 0 1 12.5 5.5c2.6 0 4.74 1.99 4.98 4.52A5.002 5.002 0 0 1 17 20ZM7.5 10c-.55 0-1 .45-1 1 0 .19.05.37.16.53.18.28.2.63.07.93-.13.3-.4.52-.72.59A2.506 2.506 0 0 0 4 15.5 2.5 2.5 0 0 0 6.5 18H17c1.65 0 3-1.35 3-3s-1.35-3-3-3c-.12 0-.23.02-.35.04-.31.04-.66-.05-.88-.28-.22-.23-.36-.53-.32-.84.03-.19.05-.3.05-.42 0-1.65-1.35-3-3-3-1.34 0-2.49.87-2.86 2.17-.09.31-.33.56-.64.67-.31.1-.65.05-.91-.14a.978.978 0 0 0-.59-.2Z"
      })
    }),
    /* @__PURE__ */ jsx345("defs", {
      children: /* @__PURE__ */ jsx345("clipPath", {
        id: "cloud_svg__a",
        children: /* @__PURE__ */ jsx345("path", {
          fill: "#fff",
          d: "M2 5.5h20V20H2z"
        })
      })
    })
  ]
});
var Cloud_default = SvgCloud;

// src/icons/generated/Clown.tsx
import { jsx as jsx346 } from "react/jsx-runtime";
var SvgClown = (props) => /* @__PURE__ */ jsx346("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx346("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23 7c0 .32-.04.64-.12.95A3.45 3.45 0 0 1 24 10.5c0 1.93-1.57 3.5-3.5 3.5h-.03c.003.058.008.115.013.172.008.109.017.216.017.328 0 4.69-3.81 8.5-8.5 8.5-4.69 0-8.5-3.81-8.5-8.5 0-.085.007-.168.015-.25A2.74 2.74 0 0 0 3.53 14H3.5C1.57 14 0 12.43 0 10.5c0-.98.42-1.9 1.12-2.55C1.04 7.64 1 7.32 1 7c0-2.21 1.79-4 4-4 .32 0 .64.04.95.12A3.45 3.45 0 0 1 8.5 2C10.43 2 12 3.57 12 5.5c0 .125-.016.244-.033.366A7.335 7.335 0 0 0 11.95 6h.1c-.03-.16-.05-.33-.05-.5C12 3.57 13.57 2 15.5 2c.98 0 1.9.41 2.55 1.12.31-.08.63-.12.95-.12 2.21 0 4 1.79 4 4ZM2.79 9.19A1.5 1.5 0 0 0 2 10.5h-.01c0 .96.95 1.72 1.9 1.44.14-.43.31-.83.51-1.23l.015-.035a.49.49 0 0 1 .015-.035c.2-.39.43-.76.68-1.11.01-.01.03-.04.03-.04.025-.025.047-.055.069-.085.013-.018.026-.037.041-.055.33-.51.87-1.01 1.27-1.34a2.64 2.64 0 0 0 .055-.047c.038-.034.074-.066.115-.093.16-.13.33-.25.33-.25a8.51 8.51 0 0 1 2.73-1.31c.16-.24.25-.52.25-.81C10 4.67 9.33 4 8.5 4c-.54 0-1.04.3-1.31.79a1 1 0 0 1-1.32.42C5.58 5.07 5.29 5 5 5c-1.1 0-2 .9-2 2 0 .29.07.58.21.87a1 1 0 0 1-.42 1.32ZM5.5 14.5c0 3.58 2.92 6.5 6.5 6.5h.03c3.58 0 6.5-2.92 6.5-6.5 0-.55-.08-1.08-.21-1.59-.1-.4-.24-.79-.41-1.16-.01-.01-.01-.02-.01-.03-.18-.37-.38-.71-.62-1.04-.025-.03-.05-.063-.075-.095-.025-.033-.05-.065-.075-.095-.27-.3-.94-.97-1.27-1.22-.07-.06-.14-.11-.21-.16-.42-.25-1.67-.82-2.17-.94-.47-.11-.96-.17-1.46-.17s-.99.06-1.46.17c-.5.12-1.75.7-2.17.94-.035.025-.07.053-.105.08-.035.027-.07.055-.105.08-.33.24-1 .92-1.27 1.22-.05.06-.1.12-.15.19-.24.33-.45.68-.62 1.04-.01.01-.02.02-.02.03-.17.37-.31.76-.41 1.16-.13.51-.21 1.04-.21 1.59Zm14.09-3.79c.2.39.37.8.51 1.23h-.01c.95.28 1.9-.48 1.9-1.44 0-.54-.3-1.04-.79-1.31a1 1 0 0 1-.42-1.32c.14-.29.21-.58.21-.87 0-1.4-1.5-2.46-2.87-1.79a1 1 0 0 1-1.32-.42A1.5 1.5 0 0 0 15.49 4c-.83 0-1.5.67-1.5 1.5 0 .29.09.57.25.81 1 .27 1.92.72 2.73 1.31.05.03.17.12.33.25l.064.051c.038.03.074.057.106.089.4.34.94.83 1.27 1.34a17.445 17.445 0 0 1 .125.16l.015.02c.25.35.48.72.68 1.11a.49.49 0 0 1 .015.035.49.49 0 0 0 .015.035ZM9.45 12.3c.25.48.85.67 1.33.43.49-.25.69-.85.45-1.34-.36-.73-1.19-1.18-2.14-1.18-.96 0-1.78.45-2.14 1.18a1.007 1.007 0 0 0 .89 1.46c.36 0 .71-.2.88-.54.02-.03.16-.09.37-.09.2 0 .33.06.36.09v-.01Zm5.47-2.09c-.96 0-1.78.45-2.14 1.18-.25.49-.05 1.1.44 1.35.15.07.3.11.45.11.36 0 .71-.2.88-.54.02-.02.16-.09.37-.09.2 0 .33.06.36.09a1 1 0 0 0 1.33.43c.49-.25.69-.85.45-1.34-.36-.73-1.18-1.18-2.14-1.18v-.01Zm-2.9 7.67c.51-.01.99-.21 1.35-.58h.01a.996.996 0 0 1 1.41-.01c.39.38.4 1.02.01 1.41-.73.74-1.71 1.16-2.76 1.17H12c-1.03 0-2-.4-2.74-1.12a.996.996 0 0 1-.01-1.41.996.996 0 0 1 1.41-.01c.36.36.82.6 1.36.55ZM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    clipRule: "evenodd"
  })
});
var Clown_default = SvgClown;

// src/icons/generated/Cocktail.tsx
import { jsx as jsx347, jsxs as jsxs311 } from "react/jsx-runtime";
var SvgCocktail = (props) => /* @__PURE__ */ jsxs311("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs311("g", {
      fill: "currentColor",
      clipPath: "url(#cocktail_svg__a)",
      children: [
        /* @__PURE__ */ jsx347("path", {
          d: "M16 22H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx347("path", {
          d: "M12 22c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx347("path", {
          d: "M12 15c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l7-7a.996.996 0 1 1 1.41 1.41l-7 7c-.2.2-.45.29-.71.29H12Z"
        }),
        /* @__PURE__ */ jsx347("path", {
          d: "M12 15c-.26 0-.51-.1-.71-.29l-7-7A.996.996 0 1 1 5.7 6.3l7 7a.996.996 0 0 1-.71 1.7H12Z"
        }),
        /* @__PURE__ */ jsx347("path", {
          d: "M19 8H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx347("path", {
          d: "M11 10c-.37 0-.72-.2-.9-.55l-2.99-6a.993.993 0 0 1 .45-1.34c.5-.25 1.1-.05 1.34.45l3 6c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11V10Z"
        }),
        /* @__PURE__ */ jsx347("path", {
          d: "M8 4H3c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1ZM18 12c-.88 0-1.74-.23-2.5-.67a.998.998 0 0 1-.36-1.37c.28-.48.89-.64 1.37-.36.45.26.97.4 1.5.4 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .55-.45 1-1 1s-1-.45-1-1c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5H18Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx347("defs", {
      children: /* @__PURE__ */ jsx347("clipPath", {
        id: "cocktail_svg__a",
        children: /* @__PURE__ */ jsx347("path", {
          fill: "#fff",
          d: "M2 2h21v20H2z"
        })
      })
    })
  ]
});
var Cocktail_default = SvgCocktail;

// src/icons/generated/Cogwheel.tsx
import { jsx as jsx348, jsxs as jsxs312 } from "react/jsx-runtime";
var SvgCogwheel = (props) => /* @__PURE__ */ jsxs312("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx348("g", {
      clipPath: "url(#cogwheel_svg__a)",
      children: /* @__PURE__ */ jsx348("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.31 21.424A2.7 2.7 0 0 0 12 22a2.7 2.7 0 0 0 2.65-2.08.599.599 0 0 1 .08-.21.73.73 0 0 1 1-.24 2.72 2.72 0 0 0 3.74-3.74.599.599 0 0 1-.08-.21.71.71 0 0 1 .53-.87 2.73 2.73 0 0 0 0-5.3.599.599 0 0 1-.21-.08.74.74 0 0 1-.24-1 2.72 2.72 0 0 0-3.74-3.74 1.001 1.001 0 0 1-.21.09.72.72 0 0 1-.87-.54 2.73 2.73 0 0 0-5.3 0 .71.71 0 0 1-.756.554.73.73 0 0 1-.324-.104 2.67 2.67 0 0 0-3.34.4 2.67 2.67 0 0 0-.4 3.34.6.6 0 0 1 .08.21.71.71 0 0 1-.53.87 2.73 2.73 0 0 0 0 5.3c.074.013.146.04.21.08a.74.74 0 0 1 .24 1 2.67 2.67 0 0 0 .4 3.34 2.67 2.67 0 0 0 3.34.4c.066-.038.137-.068.21-.09a.72.72 0 0 1 .87.54 2.7 2.7 0 0 0 .96 1.504Zm.025-3.475a2.74 2.74 0 0 0-1.685-.589 2.798 2.798 0 0 0-.65.08 3.13 3.13 0 0 0-.75.32.72.72 0 0 1-1-1 2.73 2.73 0 0 0-.91-3.75 2.998 2.998 0 0 0-.78-.32.72.72 0 0 1 0-1.4 2.74 2.74 0 0 0 2-3.29 3 3 0 0 0-.33-.76.72.72 0 0 1 1-1 2.73 2.73 0 0 0 4.06-1.67.72.72 0 0 1 1.4 0 2.74 2.74 0 0 0 3.29 2 3.13 3.13 0 0 0 .78-.32.72.72 0 0 1 1 1 2.73 2.73 0 0 0 .91 3.75 3 3 0 0 0 .78.29.72.72 0 0 1 0 1.4 2.74 2.74 0 0 0-2 3.29c.07.274.177.536.32.78a.72.72 0 0 1-1 1 2.74 2.74 0 0 0-3.75.91c-.143.244-.25.506-.32.78a.72.72 0 0 1-1.4 0 2.74 2.74 0 0 0-.965-1.501Zm-.557-2.623a4 4 0 1 0 4.444-6.652 4 4 0 0 0-4.444 6.652Zm1.11-4.989a2 2 0 1 1 2.223 3.326 2 2 0 0 1-2.222-3.326Z",
        clipRule: "evenodd"
      })
    }),
    /* @__PURE__ */ jsx348("defs", {
      children: /* @__PURE__ */ jsx348("clipPath", {
        id: "cogwheel_svg__a",
        children: /* @__PURE__ */ jsx348("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Cogwheel_default = SvgCogwheel;

// src/icons/generated/Copy.tsx
import { jsx as jsx349, jsxs as jsxs313 } from "react/jsx-runtime";
var SvgCopy = (props) => /* @__PURE__ */ jsxs313("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs313("g", {
      fill: "currentColor",
      clipPath: "url(#copy_svg__a)",
      children: [
        /* @__PURE__ */ jsx349("path", {
          d: "M18 21h-8a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3ZM10 9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-8Z"
        }),
        /* @__PURE__ */ jsx349("path", {
          d: "M8 17H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2a1 1 0 0 1-2 0V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h2a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx349("defs", {
      children: /* @__PURE__ */ jsx349("clipPath", {
        id: "copy_svg__a",
        children: /* @__PURE__ */ jsx349("path", {
          fill: "#fff",
          d: "M3 3h18v18H3z"
        })
      })
    })
  ]
});
var Copy_default = SvgCopy;

// src/icons/generated/CreditcardCheck.tsx
import { jsx as jsx350, jsxs as jsxs314 } from "react/jsx-runtime";
var SvgCreditcardCheck = (props) => /* @__PURE__ */ jsxs314("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs314("g", {
      fill: "currentColor",
      clipPath: "url(#creditcard-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx350("path", {
          d: "M13.5 20h-8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v4a1 1 0 0 1-2 0V8a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx350("path", {
          d: "M20.5 11h-18a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2ZM6.5 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM12.5 16h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM18 21a.999.999 0 0 1-.8-.4l-1.5-2a1 1 0 0 1 1.6-1.2l.67.9 2.71-3.87a1 1 0 0 1 1.64 1.14l-3.5 5a1 1 0 0 1-.8.43H18Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx350("defs", {
      children: /* @__PURE__ */ jsx350("clipPath", {
        id: "creditcard-check_svg__a",
        children: /* @__PURE__ */ jsx350("path", {
          fill: "#fff",
          d: "M1.5 4h21v17h-21z"
        })
      })
    })
  ]
});
var CreditcardCheck_default = SvgCreditcardCheck;

// src/icons/generated/Creditcard.tsx
import { jsx as jsx351, jsxs as jsxs315 } from "react/jsx-runtime";
var SvgCreditcard = (props) => /* @__PURE__ */ jsxs315("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs315("g", {
      fill: "currentColor",
      clipPath: "url(#creditcard_svg__a)",
      children: [
        /* @__PURE__ */ jsx351("path", {
          d: "M18 20H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4ZM6 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6Z"
        }),
        /* @__PURE__ */ jsx351("path", {
          d: "M21 11H3a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2ZM7 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM13 16h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx351("defs", {
      children: /* @__PURE__ */ jsx351("clipPath", {
        id: "creditcard_svg__a",
        children: /* @__PURE__ */ jsx351("path", {
          fill: "#fff",
          d: "M2 4h20v16H2z"
        })
      })
    })
  ]
});
var Creditcard_default = SvgCreditcard;

// src/icons/generated/CrossCountrySkiing.tsx
import { jsx as jsx352, jsxs as jsxs316 } from "react/jsx-runtime";
var SvgCrossCountrySkiing = (props) => /* @__PURE__ */ jsxs316("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs316("g", {
      fill: "currentColor",
      clipPath: "url(#cross-country-skiing_svg__a)",
      children: [
        /* @__PURE__ */ jsx352("path", {
          d: "M20 13c-.1 0-.21-.02-.32-.05a.992.992 0 0 1-.63-1.26l1-3c.17-.52.74-.81 1.26-.63.52.17.81.74.63 1.26l-1 3c-.14.42-.53.68-.95.68H20Z"
        }),
        /* @__PURE__ */ jsx352("path", {
          d: "M20 13c-.08 0-.16 0-.24-.03l-.43-.11a8.998 8.998 0 0 1-5.87-4.71l-.35-.71a.993.993 0 0 1 .45-1.34.993.993 0 0 1 1.34.45l.35.71a6.996 6.996 0 0 0 4.56 3.66l.43.11A1 1 0 0 1 20 13Z"
        }),
        /* @__PURE__ */ jsx352("path", {
          d: "M6 18c-.22 0-.44-.07-.62-.22-.43-.35-.5-.97-.16-1.41l8-9.99c.35-.43.97-.5 1.41-.16.43.35.5.97.16 1.41l-8.01 10c-.2.25-.49.38-.78.38V18Z"
        }),
        /* @__PURE__ */ jsx352("path", {
          d: "M14 16c-.3 0-.6-.14-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2l3 4c.33.44.24 1.07-.2 1.4-.18.13-.39.2-.6.2Z"
        }),
        /* @__PURE__ */ jsx352("path", {
          d: "M12 20a1.01 1.01 0 0 1-.9-1.45l2-4c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-2 4c-.18.35-.53.55-.9.55L12 20Z"
        }),
        /* @__PURE__ */ jsx352("path", {
          d: "M21 22h-1.99c-2.1 0-4.17-.31-6.18-.93L2.71 17.96a.997.997 0 0 1-.66-1.25c.16-.53.72-.82 1.25-.66l10.13 3.12c1.81.56 3.69.84 5.59.84h1.99c.55 0 1 .45 1 1s-.45 1-1 1L21 22Z"
        }),
        /* @__PURE__ */ jsx352("path", {
          d: "M17.33 21.02c-.1 0-.21-.02-.32-.05a.992.992 0 0 1-.63-1.26l1.67-5.02c.17-.52.74-.81 1.26-.63.52.17.81.74.63 1.26l-1.67 5.02c-.14.42-.53.68-.95.68h.01ZM17.68 7.42c-.25 0-.5-.04-.75-.12-.6-.2-1.09-.62-1.37-1.19s-.33-1.21-.13-1.81l.23-.69a2.37 2.37 0 0 1 2.99-1.5 2.373 2.373 0 0 1 1.5 3l-.23.69c-.33.99-1.25 1.62-2.25 1.62h.01ZM17.91 4c-.15 0-.3.1-.35.25l-.23.69c-.04.12 0 .23.02.28.02.05.09.14.21.18.2.06.4-.04.46-.23l.23-.69c.04-.12 0-.23-.02-.28a.353.353 0 0 0-.21-.18S17.94 4 17.91 4Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx352("defs", {
      children: /* @__PURE__ */ jsx352("clipPath", {
        id: "cross-country-skiing_svg__a",
        children: /* @__PURE__ */ jsx352("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var CrossCountrySkiing_default = SvgCrossCountrySkiing;

// src/icons/generated/CrossMedium.tsx
import { jsx as jsx353 } from "react/jsx-runtime";
var SvgCrossMedium = (props) => /* @__PURE__ */ jsx353("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx353("path", {
    fill: "currentColor",
    d: "M5.29 18.71c.2.19.45.29.71.29.26 0 .51-.09.71-.29l5.285-5.295 5.295 5.295c.2.19.45.29.71.29v-.01a.996.996 0 0 0 .71-1.7l-5.295-5.295L18.7 6.7a.996.996 0 1 0-1.41-1.41l-5.288 5.292L6.71 5.29c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.03 0 1.42l5.293 5.293L5.29 17.3a.996.996 0 0 0 0 1.41Z"
  })
});
var CrossMedium_default = SvgCrossMedium;

// src/icons/generated/CrossSmall.tsx
import { jsx as jsx354, jsxs as jsxs317 } from "react/jsx-runtime";
var SvgCrossSmall = (props) => /* @__PURE__ */ jsxs317("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs317("g", {
      fill: "currentColor",
      clipPath: "url(#cross-small_svg__a)",
      children: [
        /* @__PURE__ */ jsx354("path", {
          d: "M14.66 15.66a1 1 0 0 1-.71-.29L8.29 9.71a1.004 1.004 0 0 1 1.42-1.42l5.66 5.66a.999.999 0 0 1-.71 1.71Z"
        }),
        /* @__PURE__ */ jsx354("path", {
          d: "M9 15.66a1 1 0 0 1-.71-1.71l5.66-5.66a1.004 1.004 0 0 1 1.42 1.42l-5.66 5.66a1 1 0 0 1-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx354("defs", {
      children: /* @__PURE__ */ jsx354("clipPath", {
        id: "cross-small_svg__a",
        children: /* @__PURE__ */ jsx354("path", {
          fill: "#fff",
          d: "M8 8h7.66v7.66H8z"
        })
      })
    })
  ]
});
var CrossSmall_default = SvgCrossSmall;

// src/icons/generated/CrossSquare.tsx
import { jsx as jsx355, jsxs as jsxs318 } from "react/jsx-runtime";
var SvgCrossSquare = (props) => /* @__PURE__ */ jsxs318("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs318("g", {
      fill: "currentColor",
      clipPath: "url(#cross-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx355("path", {
          d: "M16.74 17.74c-.26 0-.51-.1-.71-.29L6.56 7.97a.996.996 0 1 1 1.41-1.41l9.47 9.47a.996.996 0 0 1-.71 1.7l.01.01Z"
        }),
        /* @__PURE__ */ jsx355("path", {
          d: "M7.26 17.74c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l9.48-9.48a.996.996 0 1 1 1.41 1.41l-9.47 9.47c-.2.2-.45.29-.71.29v.01Z"
        }),
        /* @__PURE__ */ jsx355("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx355("defs", {
      children: /* @__PURE__ */ jsx355("clipPath", {
        id: "cross-square_svg__a",
        children: /* @__PURE__ */ jsx355("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var CrossSquare_default = SvgCrossSquare;

// src/icons/generated/Cross.tsx
import { jsx as jsx356, jsxs as jsxs319 } from "react/jsx-runtime";
var SvgCross = (props) => /* @__PURE__ */ jsxs319("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs319("g", {
      fill: "currentColor",
      clipPath: "url(#cross_svg__a)",
      children: [
        /* @__PURE__ */ jsx356("path", {
          d: "M3 22c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l18-18.01A.996.996 0 1 1 21.7 3.7L3.71 21.71c-.2.2-.45.29-.71.29Z"
        }),
        /* @__PURE__ */ jsx356("path", {
          d: "M21 22c-.26 0-.51-.1-.71-.29l-18-18c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l18 18a.996.996 0 0 1-.71 1.7V22Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx356("defs", {
      children: /* @__PURE__ */ jsx356("clipPath", {
        id: "cross_svg__a",
        children: /* @__PURE__ */ jsx356("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Cross_default = SvgCross;

// src/icons/generated/Culinary.tsx
import { jsx as jsx357, jsxs as jsxs320 } from "react/jsx-runtime";
var SvgCulinary = (props) => /* @__PURE__ */ jsxs320("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs320("g", {
      fill: "currentColor",
      clipPath: "url(#culinary_svg__a)",
      children: [
        /* @__PURE__ */ jsx357("path", {
          d: "M18.06 22h-12a1 1 0 0 1-1-1v-6.41a5 5 0 0 1-2.33-2 5 5 0 0 1-.58-3.79A5 5 0 0 1 7.48 5a5 5 0 0 1 4.58-3 5 5 0 0 1 4.59 3 5 5 0 0 1 2.85.66 5 5 0 0 1 2.34 3 5 5 0 0 1-2.78 5.87V21a1 1 0 0 1-1 1Zm-11-2h10v-6.13a1 1 0 0 1 .74-1 3 3 0 0 0 1.591-4.73 3 3 0 0 0-.881-.77 3 3 0 0 0-2.28-.29 1 1 0 0 1-.78-.11 1.05 1.05 0 0 1-.46-.65A3 3 0 0 0 12.06 4a3 3 0 0 0-2.93 2.36 1 1 0 0 1-.47.65 1 1 0 0 1-.8.1h-.15a3 3 0 0 0-1.41 5.83 1 1 0 0 1 .76 1V20Z"
        }),
        /* @__PURE__ */ jsx357("path", {
          d: "M6.22 18a1 1 0 0 1 0-2h11.84a1 1 0 0 1 0 2H6.22Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx357("defs", {
      children: /* @__PURE__ */ jsx357("clipPath", {
        id: "culinary_svg__a",
        children: /* @__PURE__ */ jsx357("path", {
          fill: "#fff",
          d: "M2 2h20.01v20H2z"
        })
      })
    })
  ]
});
var Culinary_default = SvgCulinary;

// src/icons/generated/Cutlery.tsx
import { jsx as jsx358, jsxs as jsxs321 } from "react/jsx-runtime";
var SvgCutlery = (props) => /* @__PURE__ */ jsxs321("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs321("g", {
      fill: "currentColor",
      clipPath: "url(#cutlery_svg__a)",
      children: [
        /* @__PURE__ */ jsx358("path", {
          d: "M19 22c-.55 0-1-.45-1-1v-5h-3c-.55 0-1-.45-1-1 0-3.15 0-8.41 4.29-12.71a1.002 1.002 0 0 1 1.71.7V21c0 .55-.45 1-1 1Zm-3-8h2V5.86c-1.73 2.81-1.96 5.87-2 8.14Zm-8 8c-.55 0-1-.45-1-1V10.87C5.28 10.43 4 8.86 4 7V3c0-.55.45-1 1-1s1 .45 1 1v4c0 1.1.9 2 2 2s2-.9 2-2V3c0-.55.45-1 1-1s1 .45 1 1v4c0 1.86-1.28 3.43-3 3.87V21c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx358("path", {
          d: "M8 8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx358("defs", {
      children: /* @__PURE__ */ jsx358("clipPath", {
        id: "cutlery_svg__a",
        children: /* @__PURE__ */ jsx358("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Cutlery_default = SvgCutlery;

// src/icons/generated/DeleteAccount.tsx
import { jsx as jsx359, jsxs as jsxs322 } from "react/jsx-runtime";
var SvgDeleteAccount = (props) => /* @__PURE__ */ jsxs322("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs322("g", {
      fill: "currentColor",
      clipPath: "url(#delete-account_svg__a)",
      children: [
        /* @__PURE__ */ jsx359("path", {
          d: "M12 22a10 10 0 1 1 9.94-8.89 1.006 1.006 0 1 1-2-.22c.035-.295.055-.593.06-.89a8 8 0 1 0-6.22 7.8 1 1 0 1 1 .44 1.95A9.688 9.688 0 0 1 12 22Z"
        }),
        /* @__PURE__ */ jsx359("path", {
          d: "M5.84 19a1 1 0 0 1-1-1c0-2.18 2.05-4 4.56-4H14a1 1 0 0 1 0 2H9.4a2.33 2.33 0 0 0-2.56 2 1 1 0 0 1-1 1ZM12.5 13.25A3.43 3.43 0 0 1 9.1 10L9 8.29a3.47 3.47 0 0 1 3.43-3.54h.14A3.46 3.46 0 0 1 16 8.24L15.9 10a3.43 3.43 0 0 1-3.4 3.25Zm-.07-6.5A1.46 1.46 0 0 0 11 8.24l.09 1.63a1.41 1.41 0 1 0 2.82 0L14 8.18a1.45 1.45 0 0 0-1.43-1.43h-.14ZM17 21a1 1 0 0 1-.71-1.71l4-4a1.004 1.004 0 1 1 1.42 1.42l-4 4A1 1 0 0 1 17 21Z"
        }),
        /* @__PURE__ */ jsx359("path", {
          d: "M21 21a1 1 0 0 1-.71-.29l-4-4a1.004 1.004 0 1 1 1.42-1.42l4 4A.999.999 0 0 1 21 21Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx359("defs", {
      children: /* @__PURE__ */ jsx359("clipPath", {
        id: "delete-account_svg__a",
        children: /* @__PURE__ */ jsx359("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var DeleteAccount_default = SvgDeleteAccount;

// src/icons/generated/Deposit.tsx
import { jsx as jsx360, jsxs as jsxs323 } from "react/jsx-runtime";
var SvgDeposit = (props) => /* @__PURE__ */ jsxs323("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs323("g", {
      fill: "currentColor",
      clipPath: "url(#deposit_svg__a)",
      children: [
        /* @__PURE__ */ jsx360("path", {
          d: "M22 20H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1.87a1 1 0 0 1 0 2H3v1h18v-1h-1.32a1 1 0 0 1 0-2H22a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx360("path", {
          d: "M17.29 20a1 1 0 0 1-.66-1.75 7 7 0 1 0-9.26 0 1 1 0 1 1-1.32 1.5 9 9 0 1 1 11.9 0 1 1 0 0 1-.66.25Z"
        }),
        /* @__PURE__ */ jsx360("path", {
          d: "M11.74 18c-2.32 0-4.2-2.24-4.2-5s1.88-5 4.2-5a3.8 3.8 0 0 1 2.6 1.07A1 1 0 0 1 13 10.53a1.84 1.84 0 0 0-1.26-.53c-1.19 0-2.2 1.37-2.2 3s1 3 2.2 3a1.84 1.84 0 0 0 1.26-.53 1 1 0 0 1 1.36 1.46A3.8 3.8 0 0 1 11.74 18Z"
        }),
        /* @__PURE__ */ jsx360("path", {
          d: "M10.94 12.8h-3.2a1 1 0 0 1 0-2h3.2a1 1 0 1 1 0 2ZM10.94 15.2h-3.2a1 1 0 1 1 0-2h3.2a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx360("defs", {
      children: /* @__PURE__ */ jsx360("clipPath", {
        id: "deposit_svg__a",
        children: /* @__PURE__ */ jsx360("path", {
          fill: "#fff",
          d: "M1 4h22v16H1z"
        })
      })
    })
  ]
});
var Deposit_default = SvgDeposit;

// src/icons/generated/DogPaw.tsx
import { jsx as jsx361 } from "react/jsx-runtime";
var SvgDogPaw = (props) => /* @__PURE__ */ jsx361("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx361("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.773 9.98c-.06.02-.18.02-.3.02v.01c-1.408 0-2.637-1.31-2.917-3.11-.17-1.11.05-2.17.61-2.92.4-.54.949-.88 1.558-.96.06-.02.18-.02.3-.02 1.409 0 2.638 1.31 2.917 3.11.033.209.05.416.055.62a4.75 4.75 0 0 1 .055-.62c.3-1.92 1.719-3.28 3.207-3.09.62.09 1.17.43 1.57.96.559.75.779 1.81.609 2.91-.28 1.8-1.51 3.11-2.918 3.11a2.56 2.56 0 0 1-.265-.017l-.025-.003c-.62-.09-1.169-.43-1.568-.96-.419-.56-.647-1.295-.665-2.09-.017.795-.246 1.53-.664 2.09-.4.54-.95.88-1.559.96ZM9.023 5c-.129.01-.209.1-.259.17h.01c-.18.24-.34.74-.24 1.41.13.87.65 1.42.94 1.42h.03c.09-.01.17-.1.22-.17.18-.24.339-.74.24-1.41-.13-.87-.65-1.42-.94-1.42Zm11.55 2.16c-.249-.11-.519-.16-.828-.16-1.17.02-2.338 1.03-2.908 2.5-.74 1.89-.27 3.75 1.08 4.33.249.11.519.16.798.16 1.18 0 2.358-1.01 2.938-2.51.73-1.89.27-3.75-1.08-4.33v.01Zm-.788 3.61c-.33.86-.84 1.2-1.09 1.23-.15-.06-.38-.79 0-1.77.33-.85.87-1.22 1.08-1.23h.01c.15.08.38.8 0 1.77Zm-2.648 3.75-.07-.051c-.595-.431-1.162-.843-1.499-1.449C14.5 11.07 13.91 10 11.991 10c-1.912 0-2.623 1.291-3.696 3.24l-.01.02c-.347.624-.89.984-1.474 1.37l-.015.01-.015.01c-.726.477-1.546 1.017-1.884 2.05-.15.42-.21.97-.2 1.3 0 1.71 1.2 3 2.798 3 .751 0 1.522-.245 2.331-.502l.027-.008.003-.001c.739-.24 1.507-.489 2.135-.489.61 0 1.341.235 2.068.467l.07.023.086.027c.797.25 1.54.483 2.273.483 1.598 0 2.797-1.29 2.797-3 0-.34-.05-.89-.2-1.27-.334-1.034-1.173-1.642-1.924-2.185l-.034-.025h.01Zm-2.388 4.06c.667.22 1.293.418 1.743.42.477-.002.795-.402.795-1 0-.23-.04-.51-.08-.62-.15-.46-.65-.82-1.23-1.23l-.039-.028c-.702-.505-1.56-1.121-2.118-2.142C12.73 12 12.64 12 12 12c-.6 0-.839.19-1.958 2.23-.578 1.04-1.416 1.598-2.098 2.053l-.04.027c-.63.41-.99.66-1.11 1.04-.05.14-.09.42-.09.64 0 .61.32 1.01.8 1.01.413 0 1.003-.186 1.628-.382l.12-.038.042-.013c.84-.267 1.783-.567 2.706-.567.924 0 1.867.3 2.706.567l.042.013Zm-.73-12.16c.13-.87.65-1.42.97-1.42.09.01.18.1.23.17.18.25.34.74.24 1.41-.14.93-.69 1.42-.97 1.42-.09-.01-.18-.1-.23-.17-.18-.25-.34-.74-.24-1.41ZM7.147 9.51c.739 1.89.28 3.75-1.07 4.33h.01c-.26.11-.53.16-.799.16-1.179 0-2.358-1-2.937-2.5-.74-1.89-.28-3.76 1.059-4.33 1.369-.58 3.017.49 3.737 2.34ZM4.218 9c-.16.06-.39.79-.01 1.77.34.86.88 1.23 1.08 1.23h.01c.149-.06.379-.79 0-1.77-.34-.86-.88-1.23-1.08-1.23Z",
    clipRule: "evenodd"
  })
});
var DogPaw_default = SvgDogPaw;

// src/icons/generated/Downgrade.tsx
import { jsx as jsx362, jsxs as jsxs324 } from "react/jsx-runtime";
var SvgDowngrade = (props) => /* @__PURE__ */ jsxs324("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs324("g", {
      fill: "currentColor",
      clipPath: "url(#downgrade_svg__a)",
      children: [
        /* @__PURE__ */ jsx362("path", {
          d: "M19 4H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM12 22c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx362("path", {
          d: "M12 22c-.26 0-.51-.1-.71-.29l-5-5A.996.996 0 1 1 7.7 15.3l4.29 4.29 4.29-4.29a.996.996 0 1 1 1.41 1.41l-5 5c-.2.2-.45.29-.71.29H12Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx362("defs", {
      children: /* @__PURE__ */ jsx362("clipPath", {
        id: "downgrade_svg__a",
        children: /* @__PURE__ */ jsx362("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Downgrade_default = SvgDowngrade;

// src/icons/generated/DownloadCircle.tsx
import { jsx as jsx363, jsxs as jsxs325 } from "react/jsx-runtime";
var SvgDownloadCircle = (props) => /* @__PURE__ */ jsxs325("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs325("g", {
      fill: "currentColor",
      clipPath: "url(#download-circle_svg__a)",
      children: [
        /* @__PURE__ */ jsx363("path", {
          d: "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
        }),
        /* @__PURE__ */ jsx363("path", {
          d: "M12 15.5a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx363("path", {
          d: "M12 16.5a1 1 0 0 1-.71-.29l-3-3a1.004 1.004 0 0 1 1.42-1.42l2.29 2.3 2.29-2.3a1.004 1.004 0 1 1 1.42 1.42l-3 3a1 1 0 0 1-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx363("defs", {
      children: /* @__PURE__ */ jsx363("clipPath", {
        id: "download-circle_svg__a",
        children: /* @__PURE__ */ jsx363("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var DownloadCircle_default = SvgDownloadCircle;

// src/icons/generated/DownloadFile.tsx
import { jsx as jsx364, jsxs as jsxs326 } from "react/jsx-runtime";
var SvgDownloadFile = (props) => /* @__PURE__ */ jsxs326("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs326("g", {
      fill: "currentColor",
      clipPath: "url(#download-file_svg__a)",
      children: [
        /* @__PURE__ */ jsx364("path", {
          d: "M12 14c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx364("path", {
          d: "M12 15c-.26 0-.51-.1-.71-.29l-3-3A.996.996 0 1 1 9.7 10.3l2.29 2.29 2.29-2.29a.996.996 0 1 1 1.41 1.41l-3 3c-.2.2-.45.29-.71.29H12ZM15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx364("path", {
          d: "M20 22H4c-.55 0-1-.45-1-1V7c0-.27.11-.52.29-.71l4-4A.99.99 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1ZM5 20h14V4H8.41L5 7.41V20Z"
        }),
        /* @__PURE__ */ jsx364("path", {
          d: "M8 8H4c-.55 0-1-.45-1-1s.45-1 1-1h3V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx364("defs", {
      children: /* @__PURE__ */ jsx364("clipPath", {
        id: "download-file_svg__a",
        children: /* @__PURE__ */ jsx364("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var DownloadFile_default = SvgDownloadFile;

// src/icons/generated/Dumbbell.tsx
import { jsx as jsx365 } from "react/jsx-runtime";
var SvgDumbbell = (props) => /* @__PURE__ */ jsx365("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx365("path", {
    fill: "currentColor",
    d: "M22 11V9c0-1.1-.9-2-2-2h-1c0-1.1-.9-2-2-2h-1c-1.1 0-2 .9-2 2v4h-4V7c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2H4c-1.1 0-2 .9-2 2v2c-.55 0-1 .45-1 1s.45 1 1 1v2c0 1.1.9 2 2 2h1c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-4h4v4c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2h1c1.1 0 2-.9 2-2v-2c.55 0 1-.45 1-1s-.45-1-1-1ZM4 15V9h1v6H4Zm4 2H7V7h1v10Zm9 0h-1V7h1v10Zm3-2h-1V9h1v6Z"
  })
});
var Dumbbell_default = SvgDumbbell;

// src/icons/generated/Duration.tsx
import { jsx as jsx366, jsxs as jsxs327 } from "react/jsx-runtime";
var SvgDuration = (props) => /* @__PURE__ */ jsxs327("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs327("g", {
      fill: "currentColor",
      clipPath: "url(#duration_svg__a)",
      children: [
        /* @__PURE__ */ jsx366("path", {
          d: "M4.58 16.03a1 1 0 0 1-.93-.63 9 9 0 0 1 15.38-9.08V4.03a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h2.78a7 7 0 0 0-12.3 6.63 1 1 0 0 1-.93 1.37ZM7.2 19.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM11.03 20.97a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM15.14 20.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM18.41 17.87a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM20.03 14.03a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx366("path", {
          d: "M14.03 16.03a1 1 0 0 1-.66-.25l-2-1.76a1.002 1.002 0 0 1-.34-.75V7.75a1 1 0 0 1 2 0v5.06l1.67 1.47a1 1 0 0 1-.67 1.75Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx366("defs", {
      children: /* @__PURE__ */ jsx366("clipPath", {
        id: "duration_svg__a",
        children: /* @__PURE__ */ jsx366("path", {
          fill: "#fff",
          d: "M3 3h18.03v17.97H3z"
        })
      })
    })
  ]
});
var Duration_default = SvgDuration;

// src/icons/generated/Earth.tsx
import { jsx as jsx367, jsxs as jsxs328 } from "react/jsx-runtime";
var SvgEarth = (props) => /* @__PURE__ */ jsxs328("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs328("g", {
      fill: "currentColor",
      clipPath: "url(#earth_svg__a)",
      children: [
        /* @__PURE__ */ jsx367("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx367("path", {
          d: "M16.96 15.83h-1.35c-.46 0-.86-.31-.97-.76l-1.15-4.6h-.02c-.54.02-1.02-.4-1.04-.96-.02-.55.41-1.02.96-1.04l.84-.04c.51-.01.9.3 1.01.76l1.14 4.55.45-.94-.76-1.59c-.16-.34-.12-.75.12-1.05l.96-1.23c.17-.21.41-.35.68-.38.28-.03.54.05.75.23l3.08 2.58c.42.35.48.98.12 1.41a1 1 0 0 1-1.41.12l-2.14-1.79.61 1.27c.13.27.13.59 0 .86l-.96 2.02c-.17.35-.52.57-.9.57l-.02.01Z"
        }),
        /* @__PURE__ */ jsx367("path", {
          d: "M11.53 13.63c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l.22-.22-.36-1.32-1.11 1.11a.99.99 0 0 1-.71.29h-2.7a.98.98 0 0 1-.75-.34.98.98 0 0 1-.24-.79l.34-2.7c.06-.5.49-.88.99-.88h.58l.38-.41c.12-.13.27-.22.44-.28l1.45-.44.25-1.26a.999.999 0 0 1 1.96.38l-.36 1.85a.99.99 0 0 1-.69.76l-1.76.54-.49.53c-.19.2-.46.32-.73.32H7.4l-.09.7h1.15l1.06-1.06c.1-.1.21-.17.34-.22l1.12-.45c.26-.11.56-.09.82.03.25.13.44.36.52.63l.82 3.01c.09.35 0 .72-.26.97l-.63.63c-.2.2-.45.29-.71.29l-.01.03Z"
        }),
        /* @__PURE__ */ jsx367("path", {
          d: "M17.46 19.88h-3.2a1 1 0 0 1-.95-.68l-1.13-3.33h-.23l-1.03 1.01a.99.99 0 0 1-.8.29.984.984 0 0 1-.73-.43l-1.17-1.71-1.93-.49-2.36 1.18a.99.99 0 0 1-1.34-.45.993.993 0 0 1 .45-1.34l2.7-1.35c.21-.11.46-.13.69-.07l2.66.67c.24.06.44.2.58.4l.71 1.03.5-.5c.2-.2.49-.31.77-.29l1.35.09a1 1 0 0 1 .88.68L15 17.87h2.48c.55 0 1 .45 1 1s-.45 1-1 1l-.02.01ZM10.58 5.89c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l1.89-1.89a.996.996 0 1 1 1.41 1.41L11.28 5.6c-.2.2-.45.29-.71.29h.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx367("defs", {
      children: /* @__PURE__ */ jsx367("clipPath", {
        id: "earth_svg__a",
        children: /* @__PURE__ */ jsx367("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Earth_default = SvgEarth;

// src/icons/generated/Elevator.tsx
import { jsx as jsx368 } from "react/jsx-runtime";
var SvgElevator = (props) => /* @__PURE__ */ jsx368("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx368("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.62 5.93a.955.955 0 0 1-.33-.22h.02l-2-2a.996.996 0 1 1 1.41-1.41l.29.29V1c0-.55.45-1 1-1s1 .45 1 1v1.59l.29-.29a.996.996 0 1 1 1.41 1.41l-2 2c-.1.1-.21.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08ZM6.71 3.71 7 3.42v1.59c0 .55.45 1 1 1s1-.45 1-1V3.42l.29.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-2-2a1 1 0 0 0-1.42 0l-2 2A.996.996 0 1 0 6.7 3.71h.01ZM3 7h18c.55 0 1 .45 1 1v15c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1Zm1 2v13h16V9H4Zm13 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-1 5.41V20c0 .55.45 1 1 1s1-.45 1-1v-1.59l.71-.71a.99.99 0 0 0 .29-.71v-1.5c0-1.1-.9-2-2-2s-2 .9-2 2v1.5c0 .27.11.52.29.71l.71.71ZM11 20v-1.59l-.71-.71c-.18-.19-.29-.44-.29-.71v-1.5c0-1.1.9-2 2-2s2 .9 2 2v1.5c0 .27-.1.52-.29.71l-.71.71V20c0 .55-.45 1-1 1s-1-.45-1-1Zm1-7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-6 7v-1.59l-.71-.71c-.18-.19-.29-.44-.29-.71v-1.5c0-1.1.9-2 2-2s2 .9 2 2v1.5c0 .27-.1.52-.29.71l-.71.71V20c0 .55-.45 1-1 1s-1-.45-1-1Zm1-7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    clipRule: "evenodd"
  })
});
var Elevator_default = SvgElevator;

// src/icons/generated/EmergencyPhone.tsx
import { jsx as jsx369, jsxs as jsxs329 } from "react/jsx-runtime";
var SvgEmergencyPhone = (props) => /* @__PURE__ */ jsxs329("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs329("g", {
      fill: "currentColor",
      clipPath: "url(#emergency-phone_svg__a)",
      children: [
        /* @__PURE__ */ jsx369("path", {
          d: "M19 1h-2v10h2V1Z"
        }),
        /* @__PURE__ */ jsx369("path", {
          d: "m14.167 2.631-1 1.732 8.66 5 1-1.732-8.66-5Z"
        }),
        /* @__PURE__ */ jsx369("path", {
          d: "m21.805 2.646-8.66 4.999.999 1.732 8.661-4.999-1-1.732Z"
        }),
        /* @__PURE__ */ jsx369("path", {
          d: "M17.88 23A18 18 0 0 1 1 6.18 3.14 3.14 0 0 1 4.12 3h4.23a1 1 0 0 1 .93.63l2.12 5.29a1 1 0 0 1-.41 1.23l-1.83 1.1a10.81 10.81 0 0 0 3.59 3.59l1.1-1.83a1 1 0 0 1 1.23-.41l5.29 2.12a1 1 0 0 1 .63.93v4.23A3.12 3.12 0 0 1 17.88 23ZM4.12 5A1.12 1.12 0 0 0 3 6.12 16 16 0 0 0 17.94 21 1.11 1.11 0 0 0 19 19.88v-3.56l-3.88-1.55L14 16.69a1 1 0 0 1-1.3.38 12.66 12.66 0 0 1-5.74-5.74 1 1 0 0 1 .38-1.3l1.92-1.15L7.68 5H4.12Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx369("defs", {
      children: /* @__PURE__ */ jsx369("clipPath", {
        id: "emergency-phone_svg__a",
        children: /* @__PURE__ */ jsx369("path", {
          fill: "#fff",
          d: "M1 1h21.83v22H1z"
        })
      })
    })
  ]
});
var EmergencyPhone_default = SvgEmergencyPhone;

// src/icons/generated/Euro.tsx
import { jsx as jsx370, jsxs as jsxs330 } from "react/jsx-runtime";
var SvgEuro = (props) => /* @__PURE__ */ jsxs330("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs330("g", {
      fill: "currentColor",
      clipPath: "url(#euro_svg__a)",
      children: [
        /* @__PURE__ */ jsx370("path", {
          d: "M13 20a6.54 6.54 0 0 1-4.95-2.34A8.9 8.9 0 0 1 8 6.46 6.56 6.56 0 0 1 13 4a6.42 6.42 0 0 1 5 2.34 1 1 0 1 1-1.5 1.32A4.58 4.58 0 0 0 13 6a4.59 4.59 0 0 0-3.52 1.74 6.83 6.83 0 0 0 .07 8.6A4.58 4.58 0 0 0 13 18a4.58 4.58 0 0 0 3.45-1.66A1.018 1.018 0 0 1 18 17.66 6.54 6.54 0 0 1 13 20Z"
        }),
        /* @__PURE__ */ jsx370("path", {
          d: "M13 15H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx370("defs", {
      children: /* @__PURE__ */ jsx370("clipPath", {
        id: "euro_svg__a",
        children: /* @__PURE__ */ jsx370("path", {
          fill: "#fff",
          d: "M4 4h14.2v16H4z"
        })
      })
    })
  ]
});
var Euro_default = SvgEuro;

// src/icons/generated/EyeOff.tsx
import { jsx as jsx371, jsxs as jsxs331 } from "react/jsx-runtime";
var SvgEyeOff = (props) => /* @__PURE__ */ jsxs331("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx371("g", {
      fill: "currentColor",
      clipPath: "url(#eye-off_svg__a)",
      children: /* @__PURE__ */ jsx371("path", {
        d: "M21.87 11.5a15.5 15.5 0 0 0-2.93-3.61l-1.43 1.42A13.078 13.078 0 0 1 19.83 12c-1.56 2.41-4.42 5-7.83 5a6.999 6.999 0 0 1-1.9-.27l-1.58 1.58A9.35 9.35 0 0 0 12 19c4.5 0 8.05-3.36 9.87-6.5a1 1 0 0 0 0-1ZM10.71 14.7l4-4 2-2 1.43-1.44 1.55-1.54a1.004 1.004 0 1 0-1.42-1.42l-1.82 1.84c-.32-.16-.64-.31-1-.45A9.35 9.35 0 0 0 12 5c-4.5 0-8 3.36-9.87 6.5a1 1 0 0 0 0 1 15.5 15.5 0 0 0 2.93 3.61c.25.22.51.44.78.64l-1.55 1.54a1 1 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l1.84-1.85 1.51-1.5 1.65-1.66Zm-4.22 0A13.081 13.081 0 0 1 4.17 12C5.73 9.59 8.59 7 12 7a7 7 0 0 1 1.9.27c.34.104.674.227 1 .37L13.29 9.3a3.08 3.08 0 0 0-1.13-.3H12a3 3 0 0 0-3 3 .998.998 0 0 0 0 .16c.02.391.116.775.28 1.13l-2 2a9.23 9.23 0 0 1-.79-.6v.01Z"
      })
    }),
    /* @__PURE__ */ jsx371("defs", {
      children: /* @__PURE__ */ jsx371("clipPath", {
        id: "eye-off_svg__a",
        children: /* @__PURE__ */ jsx371("path", {
          fill: "#fff",
          d: "M2 4h20v16H2z"
        })
      })
    })
  ]
});
var EyeOff_default = SvgEyeOff;

// src/icons/generated/Eye.tsx
import { jsx as jsx372, jsxs as jsxs332 } from "react/jsx-runtime";
var SvgEye = (props) => /* @__PURE__ */ jsxs332("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs332("g", {
      fill: "currentColor",
      clipPath: "url(#eye_svg__a)",
      children: [
        /* @__PURE__ */ jsx372("path", {
          d: "M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
        }),
        /* @__PURE__ */ jsx372("path", {
          d: "M12 19c-4.5 0-8-3.36-9.87-6.5a1 1 0 0 1 0-1C4 8.36 7.5 5 12 5c4.5 0 8.05 3.36 9.87 6.5a1 1 0 0 1 0 1C20.05 15.64 16.5 19 12 19Zm-7.83-7c1.56 2.41 4.42 5 7.83 5s6.27-2.59 7.83-5C18.27 9.59 15.41 7 12 7s-6.27 2.59-7.83 5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx372("defs", {
      children: /* @__PURE__ */ jsx372("clipPath", {
        id: "eye_svg__a",
        children: /* @__PURE__ */ jsx372("path", {
          fill: "#fff",
          d: "M2 5h20v14H2z"
        })
      })
    })
  ]
});
var Eye_default = SvgEye;

// src/icons/generated/FaceSad.tsx
import { jsx as jsx373, jsxs as jsxs333 } from "react/jsx-runtime";
var SvgFaceSad = (props) => /* @__PURE__ */ jsxs333("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs333("g", {
      fill: "currentColor",
      clipPath: "url(#face-sad_svg__a)",
      children: [
        /* @__PURE__ */ jsx373("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx373("path", {
          d: "M10 11c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1ZM14 11c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1ZM14.5 15.5c-.13 0-.27-.03-.4-.08 0 0-.99-.42-2.1-.42s-2.09.41-2.1.42c-.5.21-1.09-.02-1.31-.52a.99.99 0 0 1 .52-1.31c.05-.02 1.36-.58 2.9-.58 1.54 0 2.84.56 2.9.58.51.22.74.81.52 1.32-.16.38-.53.6-.92.6l-.01-.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx373("defs", {
      children: /* @__PURE__ */ jsx373("clipPath", {
        id: "face-sad_svg__a",
        children: /* @__PURE__ */ jsx373("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var FaceSad_default = SvgFaceSad;

// src/icons/generated/Facebook.tsx
import { jsx as jsx374, jsxs as jsxs334 } from "react/jsx-runtime";
var SvgFacebook = (props) => /* @__PURE__ */ jsxs334("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx374("g", {
      clipPath: "url(#facebook_svg__a)",
      children: /* @__PURE__ */ jsx374("path", {
        fill: "currentColor",
        d: "M13 22H9a1 1 0 0 1-1-1v-6H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2V8a6 6 0 0 1 6-6h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3v1h3a1 1 0 0 1 .79.38 1 1 0 0 1 .18.86l-1 4A1 1 0 0 1 16 15h-2v6a1 1 0 0 1-1 1Zm-3-2h2v-6a1 1 0 0 1 1-1h2.22l.5-2H13a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2h2V4h-2a4 4 0 0 0-4 4v2a1 1 0 0 1-1 1H7v2h2a1 1 0 0 1 1 1v6Z"
      })
    }),
    /* @__PURE__ */ jsx374("defs", {
      children: /* @__PURE__ */ jsx374("clipPath", {
        id: "facebook_svg__a",
        children: /* @__PURE__ */ jsx374("path", {
          fill: "#fff",
          d: "M5 2h13v20H5z"
        })
      })
    })
  ]
});
var Facebook_default = SvgFacebook;

// src/icons/generated/Family.tsx
import { jsx as jsx375, jsxs as jsxs335 } from "react/jsx-runtime";
var SvgFamily = (props) => /* @__PURE__ */ jsxs335("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs335("g", {
      fill: "currentColor",
      clipPath: "url(#family_svg__a)",
      children: [
        /* @__PURE__ */ jsx375("path", {
          d: "M6 22a1 1 0 0 1-1-1v-5a1 1 0 0 1 .29-.71l.71-.7V11H3v3.59l.71.7A1 1 0 0 1 4 16v5a1 1 0 1 1-2 0v-4.59l-.71-.7A1 1 0 0 1 1 15v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4a1 1 0 0 1-.29.71l-.71.7V21a1 1 0 0 1-1 1ZM20 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.61l-1.56-4.68A1.188 1.188 0 0 1 19 11h-2a1 1 0 0 1-2 0 2 2 0 0 1 2-2h2a2 2 0 0 1 2 1.81l2 5.87a1 1 0 0 1-.14.9A1 1 0 0 1 22 18h-1v3a1 1 0 0 1-1 1ZM4.5 8A2.51 2.51 0 0 1 2 5.62l-.06-1A2.53 2.53 0 0 1 4.45 2a2.56 2.56 0 0 1 2.63 2.53L7 5.62A2.51 2.51 0 0 1 4.5 8Zm.05-4a.56.56 0 0 0-.63.53l.06 1A.52.52 0 0 0 4.5 6a.52.52 0 0 0 .5-.49l.06-1A.53.53 0 0 0 4.55 4Z"
        }),
        /* @__PURE__ */ jsx375("path", {
          d: "M14 22a1 1 0 0 1-1-1v-3a1.002 1.002 0 0 1 .29-.71l.71-.7V14h-3v2.59l.71.7A1 1 0 0 1 12 18v3a1 1 0 1 1-2 0v-2.59l-.71-.7A1 1 0 0 1 9 17v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a.998.998 0 0 1-.29.71l-.71.7V21a1 1 0 0 1-1 1ZM12.5 11A2.51 2.51 0 0 1 10 8.62l-.06-1A2.53 2.53 0 0 1 12.45 5a2.56 2.56 0 0 1 2.63 2.53L15 8.62A2.51 2.51 0 0 1 12.5 11Zm.05-4a.56.56 0 0 0-.63.53l.06 1a.52.52 0 0 0 .52.47.52.52 0 0 0 .5-.49l.06-1a.53.53 0 0 0-.51-.51ZM18 8a2.51 2.51 0 0 1-2.51-2.38l-.06-1A2.529 2.529 0 0 1 18 2a2.56 2.56 0 0 1 2.63 2.53l-.07 1.09A2.51 2.51 0 0 1 18 8Zm.05-4a.56.56 0 0 0-.63.53l.06 1A.52.52 0 0 0 18 6a.52.52 0 0 0 .52-.49l.06-1a.53.53 0 0 0-.53-.51Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx375("defs", {
      children: /* @__PURE__ */ jsx375("clipPath", {
        id: "family_svg__a",
        children: /* @__PURE__ */ jsx375("path", {
          fill: "#fff",
          d: "M1 2h22v20H1z"
        })
      })
    })
  ]
});
var Family_default = SvgFamily;

// src/icons/generated/File.tsx
import { jsx as jsx376, jsxs as jsxs336 } from "react/jsx-runtime";
var SvgFile = (props) => /* @__PURE__ */ jsxs336("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs336("g", {
      fill: "currentColor",
      clipPath: "url(#file_svg__a)",
      children: [
        /* @__PURE__ */ jsx376("path", {
          d: "M20 22H4c-.55 0-1-.45-1-1V7c0-.27.11-.52.29-.71l4-4A.99.99 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1ZM5 20h14V4H8.41L5 7.41V20Z"
        }),
        /* @__PURE__ */ jsx376("path", {
          d: "M8 8H4c-.55 0-1-.45-1-1s.45-1 1-1h3V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1ZM16 8h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1ZM16 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1ZM16 14H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1ZM16 17H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx376("defs", {
      children: /* @__PURE__ */ jsx376("clipPath", {
        id: "file_svg__a",
        children: /* @__PURE__ */ jsx376("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var File_default = SvgFile;

// src/icons/generated/Files.tsx
import { jsx as jsx377, jsxs as jsxs337 } from "react/jsx-runtime";
var SvgFiles = (props) => /* @__PURE__ */ jsxs337("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs337("g", {
      fill: "currentColor",
      clipPath: "url(#files_svg__a)",
      children: [
        /* @__PURE__ */ jsx377("path", {
          d: "M19.5 9h-4a2 2 0 0 1-2-2V3a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx377("path", {
          d: "M17.5 18h-7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h4a1 1 0 0 1 .71.29l5 5a1 1 0 0 1 .29.71v7a3 3 0 0 1-3 3Zm-7-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V8.41L14.09 4H10.5Z"
        }),
        /* @__PURE__ */ jsx377("path", {
          d: "M13.5 22h-7a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2h-2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2a1 1 0 0 1 2 0v2a3 3 0 0 1-3 3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx377("defs", {
      children: /* @__PURE__ */ jsx377("clipPath", {
        id: "files_svg__a",
        children: /* @__PURE__ */ jsx377("path", {
          fill: "#fff",
          d: "M3.5 2h17v20h-17z"
        })
      })
    })
  ]
});
var Files_default = SvgFiles;

// src/icons/generated/FilterSquare.tsx
import { jsx as jsx378, jsxs as jsxs338 } from "react/jsx-runtime";
var SvgFilterSquare = (props) => /* @__PURE__ */ jsxs338("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs338("g", {
      fill: "currentColor",
      clipPath: "url(#filter-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx378("path", {
          d: "M12 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1ZM16 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1ZM8 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx378("path", {
          d: "M17 12h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1ZM9 11H7c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1ZM13 16h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx378("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx378("defs", {
      children: /* @__PURE__ */ jsx378("clipPath", {
        id: "filter-square_svg__a",
        children: /* @__PURE__ */ jsx378("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var FilterSquare_default = SvgFilterSquare;

// src/icons/generated/Filter.tsx
import { jsx as jsx379, jsxs as jsxs339 } from "react/jsx-runtime";
var SvgFilter = (props) => /* @__PURE__ */ jsxs339("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs339("g", {
      fill: "currentColor",
      clipPath: "url(#filter_svg__a)",
      children: [
        /* @__PURE__ */ jsx379("path", {
          d: "M5 22c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1ZM5 14c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1ZM19 14c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1ZM12 22c-.55 0-1-.45-1-1V11c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1ZM12 8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1ZM19 22c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx379("path", {
          d: "M5 18c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM19 18c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM12 12c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx379("defs", {
      children: /* @__PURE__ */ jsx379("clipPath", {
        id: "filter_svg__a",
        children: /* @__PURE__ */ jsx379("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Filter_default = SvgFilter;

// src/icons/generated/Fire.tsx
import { jsx as jsx380, jsxs as jsxs340 } from "react/jsx-runtime";
var SvgFire = (props) => /* @__PURE__ */ jsxs340("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx380("g", {
      clipPath: "url(#fire_svg__a)",
      children: /* @__PURE__ */ jsx380("path", {
        fill: "currentColor",
        d: "M12 21c-3.86 0-7-3.14-7-7 0-2.04.9-4.27 2.28-5.7l.13-.14c1.15-1.18 2.58-2.64 2.58-5.17 0-.4.24-.77.62-.92.37-.16.8-.07 1.09.22 1.18 1.18 3.07 5.01 1.65 8.3.18-.05.73-.34 1.78-2.1a.997.997 0 0 1 1.6-.15c1.07 1.2 2.25 3.82 2.25 5.67 0 3.86-3.14 7-7 7L12 21Zm-.53-15.13c-.65 1.67-1.78 2.83-2.63 3.69l-.13.13c-1.03 1.05-1.72 2.78-1.72 4.3 0 2.76 2.24 5 5 5s5-2.24 5-5c0-.88-.45-2.18-.99-3.19-.8 1.08-1.54 1.62-2.33 1.76-1.01.17-1.8-.37-2.31-.79-.4-.33-.48-.9-.19-1.33.95-1.41.77-3.18.3-4.57Z"
      })
    }),
    /* @__PURE__ */ jsx380("defs", {
      children: /* @__PURE__ */ jsx380("clipPath", {
        id: "fire_svg__a",
        children: /* @__PURE__ */ jsx380("path", {
          fill: "#fff",
          d: "M5 2h14v19H5z"
        })
      })
    })
  ]
});
var Fire_default = SvgFire;

// src/icons/generated/Flag.tsx
import { jsx as jsx381, jsxs as jsxs341 } from "react/jsx-runtime";
var SvgFlag = (props) => /* @__PURE__ */ jsxs341("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs341("g", {
      fill: "currentColor",
      clipPath: "url(#flag_svg__a)",
      children: [
        /* @__PURE__ */ jsx381("path", {
          d: "M5 4H3c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx381("path", {
          d: "M4 22c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx381("path", {
          d: "M17.41 17.96c-1.81 0-3.56-.52-5.19-1-2.7-.79-5.24-1.54-7.71-.1a.998.998 0 0 1-1.37-.36.998.998 0 0 1 .36-1.37c3.22-1.89 6.44-.93 9.29-.1 2.44.72 4.76 1.4 7.01.45-.3-1.04-.74-2.9-.74-4.91 0-1.61.17-2.9.37-3.86-2.51.63-4.97-.1-7.2-.76-2.7-.79-5.24-1.54-7.71-.1a.998.998 0 0 1-1.37-.36.998.998 0 0 1 .36-1.37c3.22-1.89 6.44-.94 9.29-.1 2.7.79 5.24 1.54 7.71.1.39-.23.87-.17 1.2.14.33.31.4.79.19 1.19 0 0-.83 1.67-.83 5.11 0 2.62.88 5.05.89 5.08.17.45-.02.96-.43 1.21-1.37.81-2.75 1.09-4.1 1.09l-.02.02Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx381("defs", {
      children: /* @__PURE__ */ jsx381("clipPath", {
        id: "flag_svg__a",
        children: /* @__PURE__ */ jsx381("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Flag_default = SvgFlag;

// src/icons/generated/Flamingo.tsx
import { jsx as jsx382, jsxs as jsxs342 } from "react/jsx-runtime";
var SvgFlamingo = (props) => /* @__PURE__ */ jsxs342("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx382("path", {
      fill: "currentColor",
      d: "M18.76 22H5.24A3.24 3.24 0 0 1 2 18.76v-.52A3.24 3.24 0 0 1 5.24 15h13.52A3.24 3.24 0 0 1 22 18.24v.52A3.24 3.24 0 0 1 18.76 22ZM5.24 17A1.23 1.23 0 0 0 4 18.24v.52A1.23 1.23 0 0 0 5.24 20h13.52A1.23 1.23 0 0 0 20 18.76v-.52A1.23 1.23 0 0 0 18.76 17H5.24Z"
    }),
    /* @__PURE__ */ jsx382("path", {
      fill: "currentColor",
      d: "M21 19a1 1 0 0 1-1-1c0-2.33-1.87-4.65-3.38-6.51a21.176 21.176 0 0 1-1.47-2 2.25 2.25 0 0 1-.15-2.3 2.82 2.82 0 0 1 2.5-1.32A3.18 3.18 0 0 1 19.9 7c.065-.33.098-.664.1-1 0-.56-.72-2-4-2a2.72 2.72 0 0 0-3 3 7.2 7.2 0 0 0 1.21 3.35A11.12 11.12 0 0 1 16 16a1 1 0 0 1-2 0 9.37 9.37 0 0 0-1.54-4.69A8.87 8.87 0 0 1 11 7a4.699 4.699 0 0 1 5-5c4.75 0 6 2.62 6 4a9.07 9.07 0 0 1-1.23 4.28 1 1 0 0 1-1.84-.66 1.76 1.76 0 0 0-.46-1.25 1.3 1.3 0 0 0-.93-.5.9.9 0 0 0-.75.29s-.06.11.06.32c.413.61.857 1.197 1.33 1.76C19.79 12.23 22 15 22 18a1 1 0 0 1-1 1Z"
    }),
    /* @__PURE__ */ jsx382("path", {
      fill: "currentColor",
      d: "M17.5 7.5a1 1 0 0 1-1-1 5 5 0 0 1 1.86-3.57 1.001 1.001 0 1 1 1.28 1.54 3.12 3.12 0 0 0-1.14 2 1 1 0 0 1-1 1v.03Z"
    })
  ]
});
var Flamingo_default = SvgFlamingo;

// src/icons/generated/Funpark.tsx
import { jsx as jsx383, jsxs as jsxs343 } from "react/jsx-runtime";
var SvgFunpark = (props) => /* @__PURE__ */ jsxs343("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs343("g", {
      fill: "currentColor",
      clipPath: "url(#funpark_svg__a)",
      children: [
        /* @__PURE__ */ jsx383("path", {
          d: "M21 22c-.55 0-1-.45-1-1v-7h-.06c-.46 4.05-3.72 7-7.94 7-4.22 0-7.48-2.95-7.94-7H4v7c0 .55-.45 1-1 1s-1-.45-1-1v-8c0-.55.45-1 1-1h2c.55 0 1 .45 1 1 0 3.42 2.58 6 6 6s6-2.58 6-6c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx383("path", {
          d: "M13.71 17.27c-.08 0-.15 0-.23-.03-.65-.15-1.37-.55-1.83-1.02l-5.79-5.8c-.48-.48-.79-1.09-.91-1.77-.09-.54.27-1.06.81-1.16.54-.1 1.06.27 1.16.81.05.28.17.51.36.7l5.78 5.8c.2.2.6.42.88.49.54.13.87.67.75 1.2-.11.46-.52.77-.97.77l-.01.01Z"
        }),
        /* @__PURE__ */ jsx383("path", {
          d: "M11.05 14.89c-.19 0-.38-.05-.55-.17a1.01 1.01 0 0 1-.28-1.39l1.89-2.84c.3-.44.89-.58 1.35-.3l.12.07c.22.13.41.05.48 0 .07-.04.24-.17.24-.42V7.48a1 1 0 0 1 .38-.78c.24-.19.55-.26.85-.19l1.65.38 1.11-1.11a.996.996 0 1 1 1.41 1.41l-1.5 1.5c-.24.24-.6.34-.93.27l-.96-.22v1.1c0 .91-.47 1.71-1.26 2.16a2.4 2.4 0 0 1-1.73.27l-1.44 2.16c-.19.29-.51.45-.83.45v.01ZM12.5 7.5H11c-.11 0-.21-.02-.32-.05l-1.5-.5a.999.999 0 0 1-.63-1.27c.17-.52.74-.81 1.26-.63l1.35.45h1.34c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx383("path", {
          d: "M8.55 12.43c-.21 0-.42-.06-.59-.2-.44-.33-.54-.95-.21-1.4l2.03-2.74c.29-.39.82-.52 1.25-.3l1.89.95c.49.25.69.85.45 1.34-.25.49-.85.69-1.34.45l-1.14-.57-1.53 2.07c-.2.27-.5.41-.8.41l-.01-.01ZM14.37 6.84c-1.2 0-2.18-.98-2.18-2.18v-.47c0-1.2.98-2.18 2.18-2.18 1.2 0 2.18.98 2.18 2.18v.47c0 1.2-.98 2.18-2.18 2.18Zm0-2.84c-.1 0-.18.08-.18.18v.47c0 .2.37.2.37 0v-.47c0-.1-.08-.18-.18-.18h-.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx383("defs", {
      children: /* @__PURE__ */ jsx383("clipPath", {
        id: "funpark_svg__a",
        children: /* @__PURE__ */ jsx383("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Funpark_default = SvgFunpark;

// src/icons/generated/Gift.tsx
import { jsx as jsx384, jsxs as jsxs344 } from "react/jsx-runtime";
var SvgGift = (props) => /* @__PURE__ */ jsxs344("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs344("g", {
      fill: "currentColor",
      clipPath: "url(#gift_svg__a)",
      children: [
        /* @__PURE__ */ jsx384("path", {
          d: "M21 14H3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1ZM4 12h16v-2H4v2Z"
        }),
        /* @__PURE__ */ jsx384("path", {
          d: "M19 22H5c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1s1 .45 1 1v7h12v-7c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1ZM12 10H8.92C6.76 10 5 8.24 5 6.08v-.16C5 3.76 6.76 2 8.92 2h.16C11.24 2 13 3.76 13 5.92V9c0 .55-.45 1-1 1ZM8.92 4C7.86 4 7 4.86 7 5.92v.16C7 7.14 7.86 8 8.92 8H11V5.92C11 4.86 10.14 4 9.08 4h-.16Z"
        }),
        /* @__PURE__ */ jsx384("path", {
          d: "M14.27 10H12c-.55 0-1-.45-1-1V6.73c0-1.81 1.47-3.27 3.27-3.27s3.27 1.47 3.27 3.27S16.07 10 14.27 10ZM13 8h1.27c.7 0 1.27-.57 1.27-1.27 0-.7-.57-1.27-1.27-1.27-.7 0-1.27.57-1.27 1.27V8Z"
        }),
        /* @__PURE__ */ jsx384("path", {
          d: "M12 22c-.55 0-1-.45-1-1V8.68c0-.55.45-1 1-1s1 .45 1 1V21c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx384("defs", {
      children: /* @__PURE__ */ jsx384("clipPath", {
        id: "gift_svg__a",
        children: /* @__PURE__ */ jsx384("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Gift_default = SvgGift;

// src/icons/generated/GolfCart.tsx
import { jsx as jsx385, jsxs as jsxs345 } from "react/jsx-runtime";
var SvgGolfCart = (props) => /* @__PURE__ */ jsxs345("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs345("g", {
      fill: "currentColor",
      clipPath: "url(#golf-cart_svg__a)",
      children: [
        /* @__PURE__ */ jsx385("path", {
          d: "M6 21.99a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM18 21.99a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M21 17.99H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3.76a10.46 10.46 0 0 1 4.47 1h4.15l1.73-3.45a1 1 0 0 1 .63-.52 1 1 0 0 1 .81.14l3 2a1 1 0 0 1 .45.83v5a1 1 0 0 1-1 1Zm-17-2h16v-3.46l-1.61-1.08-1.5 3a1 1 0 0 1-.89.54h-5a1 1 0 0 1-.45-.11 8.581 8.581 0 0 0-3.79-.89H4v2Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M17 11.99a.93.93 0 0 1-.45-.11l-2-1a1 1 0 0 1-.44-1.34 1 1 0 0 1 1.34-.44l2 1a1 1 0 0 1-.45 1.89Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M13 11.99a.94.94 0 0 1-.55-.17 1 1 0 0 1-.28-1.38l2-3a1 1 0 0 1 1.38-.28 1 1 0 0 1 .28 1.38l-2 3a1 1 0 0 1-.83.45ZM20 11.99a1 1 0 0 1-1-.73l-2-7a1 1 0 0 1 .69-1.23 1 1 0 0 1 1.23.69l2 7a1 1 0 0 1-.69 1.23.84.84 0 0 1-.23.04Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M3 5.08a1 1 0 0 1-.27-1.97 37.9 37.9 0 0 1 16.52-.39l1.92.38a1 1 0 0 1 .78 1.18 1 1 0 0 1-1.18.79l-1.91-.39a35.94 35.94 0 0 0-15.65.37L3 5.08Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M5 13.99a1 1 0 0 1-1-1v-9a1 1 0 0 1 2 0v9a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M8 13.99a1 1 0 0 1-1-.76l-1-4a1 1 0 0 1 1.94-.48l1 4a1 1 0 0 1-.73 1.21l-.21.03Z"
        }),
        /* @__PURE__ */ jsx385("path", {
          d: "M7 9.99H3a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx385("defs", {
      children: /* @__PURE__ */ jsx385("clipPath", {
        id: "golf-cart_svg__a",
        children: /* @__PURE__ */ jsx385("path", {
          fill: "#fff",
          d: "M2 2h20v19.99H2z"
        })
      })
    })
  ]
});
var GolfCart_default = SvgGolfCart;

// src/icons/generated/GolfClub.tsx
import { jsx as jsx386, jsxs as jsxs346 } from "react/jsx-runtime";
var SvgGolfClub = (props) => /* @__PURE__ */ jsxs346("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs346("g", {
      fill: "currentColor",
      clipPath: "url(#golf-club_svg__a)",
      children: [
        /* @__PURE__ */ jsx386("path", {
          d: "M10.57 15h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2ZM14.57 18h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx386("path", {
          d: "M14.39 22H4.57a4.67 4.67 0 0 1-3.33-1.38 4.7 4.7 0 0 1-1.1-4.41l.93-3.86A5 5 0 0 1 6.7 8.58l8 1.23a.42.42 0 0 0 .47-.36v-.12l1.92-6.61A.999.999 0 0 1 18.32 2 1 1 0 0 1 19 3.24l-1.9 6.55a2.42 2.42 0 0 1-2.73 2l-8-1.24A3 3 0 0 0 3 12.81l-.93 3.87a2.68 2.68 0 0 0 .61 2.53 2.69 2.69 0 0 0 1.89.79h9.78a3.11 3.11 0 0 0 3.05-2.62.3.3 0 0 1 0-.1l3.77-14.53a1 1 0 1 1 1.94.5l-3.7 14.48A5 5 0 0 1 14.39 22Z"
        }),
        /* @__PURE__ */ jsx386("path", {
          d: "M20.49 8.9a1 1 0 0 1-.24 0L16.66 8a1.03 1.03 0 0 1 .49-2l3.58.9a1 1 0 0 1 .73 1.21 1 1 0 0 1-.97.79Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx386("defs", {
      children: /* @__PURE__ */ jsx386("clipPath", {
        id: "golf-club_svg__a",
        children: /* @__PURE__ */ jsx386("path", {
          fill: "#fff",
          d: "M0 2h23.14v20H0z"
        })
      })
    })
  ]
});
var GolfClub_default = SvgGolfClub;

// src/icons/generated/Group.tsx
import { jsx as jsx387, jsxs as jsxs347 } from "react/jsx-runtime";
var SvgGroup = (props) => /* @__PURE__ */ jsxs347("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs347("g", {
      fill: "currentColor",
      clipPath: "url(#group_svg__a)",
      children: [
        /* @__PURE__ */ jsx387("path", {
          d: "M12 13.41c-1.82 0-3.33-1.42-3.43-3.24l-.09-1.66C8.48 6.55 10.03 5 11.93 5h.15c1.9 0 3.45 1.55 3.45 3.45l-.1 1.72A3.433 3.433 0 0 1 12 13.41ZM11.93 7c-.8 0-1.45.65-1.45 1.45l.09 1.61c.04.76.67 1.35 1.43 1.35.76 0 1.39-.59 1.43-1.35l.09-1.66c0-.74-.65-1.39-1.45-1.39h-.15l.01-.01Z"
        }),
        /* @__PURE__ */ jsx387("path", {
          d: "M19 22H5c-.55 0-1-.45-1-1v-2.64C4 15.41 6.55 13 9.68 13h4.64c3.13 0 5.68 2.4 5.68 5.36V21c0 .55-.45 1-1 1ZM6 20h12v-1.64c0-1.85-1.65-3.36-3.68-3.36H9.68C7.65 15 6 16.51 6 18.36V20ZM16 10.41c-.48 0-.94-.1-1.38-.29a.989.989 0 0 1-.51-1.32c.22-.51.81-.74 1.32-.51a1.428 1.428 0 0 0 2-1.23l.09-1.66c0-.74-.65-1.39-1.45-1.39h-.15c-.8 0-1.45.65-1.45 1.45l.04.7a.996.996 0 0 1-.94 1.05.99.99 0 0 1-1.05-.94l-.04-.75c0-1.96 1.55-3.51 3.45-3.51h.15c1.9 0 3.45 1.55 3.45 3.45l-.1 1.72A3.433 3.433 0 0 1 16 10.42v-.01Z"
        }),
        /* @__PURE__ */ jsx387("path", {
          d: "M21 16h-3.5c-.55 0-1-.45-1-1s.45-1 1-1H20v-.89c0-1.16-1.05-2.11-2.34-2.11h-1.88c-.33 0-.64.06-.94.17-.51.2-1.09-.05-1.3-.57-.2-.51.05-1.09.57-1.3a4.5 4.5 0 0 1 1.67-.31h1.88c2.4 0 4.34 1.84 4.34 4.11v1.89c0 .55-.45 1-1 1V16ZM9 22c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1ZM15 22c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1ZM8 10.41c-1.82 0-3.33-1.42-3.43-3.24l-.09-1.66C4.48 3.55 6.03 2 7.93 2h.15c1.9 0 3.45 1.55 3.45 3.45l-.04.81a.996.996 0 1 1-1.99-.11l.04-.75c0-.74-.65-1.39-1.45-1.39h-.15c-.8 0-1.45.65-1.45 1.45l.09 1.61a1.428 1.428 0 0 0 2 1.23c.51-.22 1.1 0 1.32.51.22.51 0 1.1-.51 1.32-.44.19-.9.29-1.38.29L8 10.41Z"
        }),
        /* @__PURE__ */ jsx387("path", {
          d: "M6.5 16H3c-.55 0-1-.45-1-1v-1.89C2 10.84 3.95 9 6.34 9h1.88c.58 0 1.14.11 1.67.31.51.2.77.78.57 1.3a1 1 0 0 1-1.3.57c-.3-.12-.61-.17-.94-.17H6.34c-1.29 0-2.34.95-2.34 2.11v.89h2.5c.55 0 1 .45 1 1s-.45 1-1 1V16Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx387("defs", {
      children: /* @__PURE__ */ jsx387("clipPath", {
        id: "group_svg__a",
        children: /* @__PURE__ */ jsx387("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Group_default = SvgGroup;

// src/icons/generated/Hamam.tsx
import { jsx as jsx388 } from "react/jsx-runtime";
var SvgHamam = (props) => /* @__PURE__ */ jsx388("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx388("path", {
    fill: "currentColor",
    d: "M21 20v-9c0-.28-.12-.55-.32-.74l-.42-.38c.5-.79.74-1.67.74-2.68 0-2.56-1.89-4.63-3.72-5.16-.18-.05-.37-.05-.55 0-1.83.53-3.72 2.6-3.72 5.16 0 1.01.24 1.89.74 2.68l-.42.38c-.21.19-.32.46-.32.74v2h-2v-2c0-.28-.12-.55-.32-.74l-.42-.38c.5-.79.74-1.67.74-2.68-.01-2.56-1.9-4.63-3.73-5.16-.18-.05-.37-.05-.55 0C4.89 2.57 3 4.64 3 7.2c0 1.01.24 1.89.74 2.68l-.42.38c-.21.19-.32.46-.32.74v9c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1Zm-6-8.56.77-.7c.2-.18.31-.43.32-.7a.995.995 0 0 0-.27-.72c-.56-.6-.82-1.27-.82-2.12 0-1.46.99-2.7 2-3.14 1.01.44 2 1.68 2 3.14 0 .84-.26 1.52-.82 2.12-.18.2-.28.46-.27.72 0 .27.13.52.32.7l.77.7V20h-1v-3c0-.55-.45-1-1-1v-2c0-.55-.45-1-1-1h-1v-1.56ZM9 15h6v1H9v-1Zm-1 3h8v2H8v-2Zm-3-6.56.77-.7c.2-.18.31-.43.32-.7a.995.995 0 0 0-.27-.72C5.26 8.72 5 8.05 5 7.2c0-1.46.99-2.7 2-3.14 1.01.44 2 1.68 2 3.14 0 .84-.26 1.52-.82 2.12-.18.2-.28.46-.27.72 0 .27.13.52.32.7l.77.7V13H8c-.55 0-1 .45-1 1v2c-.55 0-1 .45-1 1v3H5v-8.56Z"
  })
});
var Hamam_default = SvgHamam;

// src/icons/generated/Headset.tsx
import { jsx as jsx389, jsxs as jsxs348 } from "react/jsx-runtime";
var SvgHeadset = (props) => /* @__PURE__ */ jsxs348("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs348("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      clipPath: "url(#headset_svg__a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx389("path", {
          d: "M6 13c-.548 0-1 .452-1 1v2c0 .548.452 1 1 1s1-.452 1-1v-2c0-.548-.452-1-1-1Zm-3 1c0-1.652 1.348-3 3-3s3 1.348 3 3v2c0 1.652-1.348 3-3 3s-3-1.348-3-3v-2ZM18 13c-.548 0-1 .452-1 1v2c0 .548.452 1 1 1s1-.452 1-1v-2c0-.548-.452-1-1-1Zm-3 1c0-1.652 1.348-3 3-3s3 1.348 3 3v2c0 1.652-1.348 3-3 3s-3-1.348-3-3v-2Z"
        }),
        /* @__PURE__ */ jsx389("path", {
          d: "M12 4c-3.868 0-7 3.132-7 7v3a1 1 0 1 1-2 0v-3c0-4.972 4.028-9 9-9s9 4.028 9 9v3a1 1 0 1 1-2 0v-3c0-3.868-3.132-7-7-7ZM18 17a1 1 0 0 1 1 1c0 1.413-1.12 2.422-2.312 3.017-1.252.626-2.912.983-4.688.983a1 1 0 1 1 0-2c1.534 0 2.874-.313 3.794-.772.98-.49 1.206-.981 1.206-1.228a1 1 0 0 1 1-1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx389("defs", {
      children: /* @__PURE__ */ jsx389("clipPath", {
        id: "headset_svg__a",
        children: /* @__PURE__ */ jsx389("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var Headset_default = SvgHeadset;

// src/icons/generated/HealthAndSafety.tsx
import { jsx as jsx390, jsxs as jsxs349 } from "react/jsx-runtime";
var SvgHealthAndSafety = (props) => /* @__PURE__ */ jsxs349("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs349("g", {
      fill: "currentColor",
      clipPath: "url(#health-and-safety_svg__a)",
      children: [
        /* @__PURE__ */ jsx390("path", {
          d: "M12 16c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx390("path", {
          d: "M16 12H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx390("path", {
          d: "M12 22c-.17 0-.34-.04-.49-.13-.12-.06-2.83-1.58-4.21-2.74-2.61-2.2-4.28-5.38-4.3-8.12V7.5c0-1.23.01-2.45 0-3.49 0-.42.25-.79.64-.94 1.65-.63 4.63-1.02 8.2-1.07 3.32-.04 6.66.37 8.51 1.06.39.14.65.52.65.93v7c.02 3.28-2.11 6.31-4.12 8.04-1.42 1.22-4.29 2.78-4.41 2.85-.15.08-.31.12-.48.12H12ZM5.01 4.73V11c.01 2.15 1.44 4.79 3.55 6.57.94.79 2.63 1.81 3.46 2.29.85-.48 2.62-1.52 3.52-2.29 2.14-1.85 3.48-4.41 3.47-6.55V4.75c-1.52-.42-4.11-.77-7.14-.73-2.8.03-5.33.31-6.86.72v-.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx390("defs", {
      children: /* @__PURE__ */ jsx390("clipPath", {
        id: "health-and-safety_svg__a",
        children: /* @__PURE__ */ jsx390("path", {
          fill: "#fff",
          d: "M3 2h18.01v20H3z"
        })
      })
    })
  ]
});
var HealthAndSafety_default = SvgHealthAndSafety;

// src/icons/generated/Health.tsx
import { jsx as jsx391, jsxs as jsxs350 } from "react/jsx-runtime";
var SvgHealth = (props) => /* @__PURE__ */ jsxs350("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs350("g", {
      fill: "currentColor",
      clipPath: "url(#health_svg__a)",
      children: [
        /* @__PURE__ */ jsx391("path", {
          d: "M8.5 16C4.92 16 2 13.08 2 9.5V6c0-1.65 1.35-3 3-3h1c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1 .45-1 1v3.5C4 11.98 6.02 14 8.5 14S13 11.98 13 9.5V6c0-.55-.45-1-1-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.65 0 3 1.35 3 3v3.5c0 3.58-2.92 6.5-6.5 6.5Z"
        }),
        /* @__PURE__ */ jsx391("path", {
          d: "M14 22c-3.86 0-7-3.14-7-7 0-.55.45-1 1-1s1 .45 1 1c0 2.76 2.24 5 5 5s5-2.24 5-5v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 3.86-3.14 7-7 7ZM11 6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM6 6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx391("path", {
          d: "M20 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx391("defs", {
      children: /* @__PURE__ */ jsx391("clipPath", {
        id: "health_svg__a",
        children: /* @__PURE__ */ jsx391("path", {
          fill: "#fff",
          d: "M2 2h21v20H2z"
        })
      })
    })
  ]
});
var Health_default = SvgHealth;

// src/icons/generated/HeartFill.tsx
import { jsx as jsx392, jsxs as jsxs351 } from "react/jsx-runtime";
var SvgHeartFill = (props) => /* @__PURE__ */ jsxs351("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx392("g", {
      clipPath: "url(#heart-fill_svg__a)",
      children: /* @__PURE__ */ jsx392("path", {
        fill: "currentColor",
        d: "M12 21a1 1 0 0 1-.7-.29L3.81 13.3A6 6 0 0 1 12 4.54a6 6 0 0 1 8.79 8.09 6.375 6.375 0 0 1-.6.67.231.231 0 0 1-.07.07l-7.42 7.35a1 1 0 0 1-.7.28Z"
      })
    }),
    /* @__PURE__ */ jsx392("defs", {
      children: /* @__PURE__ */ jsx392("clipPath", {
        id: "heart-fill_svg__a",
        children: /* @__PURE__ */ jsx392("path", {
          fill: "#fff",
          d: "M2 3h20v18.01H2z"
        })
      })
    })
  ]
});
var HeartFill_default = SvgHeartFill;

// src/icons/generated/Heart.tsx
import { jsx as jsx393, jsxs as jsxs352 } from "react/jsx-runtime";
var SvgHeart = (props) => /* @__PURE__ */ jsxs352("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx393("g", {
      clipPath: "url(#heart_svg__a)",
      children: /* @__PURE__ */ jsx393("path", {
        fill: "currentColor",
        d: "M12 21a1 1 0 0 1-.7-.29L3.81 13.3A6 6 0 0 1 12 4.54a6 6 0 0 1 8.79 8.09 6.375 6.375 0 0 1-.6.67.231.231 0 0 1-.07.07l-7.42 7.35a1 1 0 0 1-.7.28Zm-6.79-9.13L12 18.6l6.8-6.73.07-.06c.12-.12.23-.251.33-.39a4 4 0 0 0-6.4-4.8A1.131 1.131 0 0 1 12 7a1 1 0 0 1-.8-.41c-.13-.17-.27-.33-.42-.48a4.006 4.006 0 0 0-5.57 5.76Z"
      })
    }),
    /* @__PURE__ */ jsx393("defs", {
      children: /* @__PURE__ */ jsx393("clipPath", {
        id: "heart_svg__a",
        children: /* @__PURE__ */ jsx393("path", {
          fill: "#fff",
          d: "M2 3h20v18.01H2z"
        })
      })
    })
  ]
});
var Heart_default = SvgHeart;

// src/icons/generated/HeartsLoveRomance.tsx
import { jsx as jsx394 } from "react/jsx-runtime";
var SvgHeartsLoveRomance = (props) => /* @__PURE__ */ jsx394("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx394("path", {
    fill: "currentColor",
    d: "M19.61 4.22c-2.32-1.75-5.51-1.54-7.6.32a6.001 6.001 0 0 0-8.31.27c-2.31 2.37-2.25 6.18.11 8.48l7.5 7.43c.19.19.45.29.7.29.25 0 .51-.1.7-.29l1.3-1.29 1.27 1.28a1 1 0 0 0 1.42.01l4.2-4.23a3.817 3.817 0 0 0 .44-4.8c1.28-2.56.6-5.71-1.74-7.47h.01Zm-7.6 14.38-6.8-6.74a4.008 4.008 0 0 1-.08-5.66 4.017 4.017 0 0 1 5.66-.08c.15.15.29.31.42.48a1 1 0 0 0 1.6 0 4.012 4.012 0 0 1 5.6-.8 3.989 3.989 0 0 1 1.36 4.53c-.47-.21-.97-.33-1.5-.33-.84.01-1.59.25-2.26.74-1.46-1.09-3.54-.98-4.91.37-1.46 1.47-1.46 3.87 0 5.35l1.51 1.53-.6.6v.01Zm7.48-3.52L16 18.59l-1.25-1.26s0-.02-.01-.02c0 0-.02 0-.02-.01l-2.19-2.22c-.69-.7-.69-1.84.02-2.56.34-.33.78-.5 1.23-.5.45 0 .9.17 1.25.52l.28.28a1 1 0 0 0 .71.3c.24-.02.52-.11.71-.29l.3-.3c.33-.33.79-.47 1.24-.5.47 0 .9.19 1.23.52.69.7.69 1.84 0 2.54l-.01-.01Z"
  })
});
var HeartsLoveRomance_default = SvgHeartsLoveRomance;

// src/icons/generated/HolidayVillage.tsx
import { jsx as jsx395 } from "react/jsx-runtime";
var SvgHolidayVillage = (props) => /* @__PURE__ */ jsx395("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx395("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.71 2.29a.996.996 0 0 0-1.41 0l-7.01 7A.99.99 0 0 0 0 10v11c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-5h2v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V10c0-.27-.11-.52-.29-.71l-7-7ZM14 20h-3v-5c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v5H2v-9.59l6-6 6 6V20ZM12.71 2.29A.996.996 0 1 0 11.3 3.7l6.71 6.71V21c0 .55.45 1 1 1s1-.45 1-1V10c0-.27-.11-.52-.29-.71l-7.01-7Zm4 0 7 7h.01c.18.19.29.44.29.71v11c0 .55-.45 1-1 1s-1-.45-1-1V10.41L15.3 3.7a.996.996 0 1 1 1.41-1.41Z",
    clipRule: "evenodd"
  })
});
var HolidayVillage_default = SvgHolidayVillage;

// src/icons/generated/Home.tsx
import { jsx as jsx396, jsxs as jsxs353 } from "react/jsx-runtime";
var SvgHome = (props) => /* @__PURE__ */ jsxs353("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx396("g", {
      clipPath: "url(#home_svg__a)",
      children: /* @__PURE__ */ jsx396("path", {
        fill: "currentColor",
        d: "M20 22h-6c-.55 0-1-.45-1-1v-5h-2v5c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.31.15-.61.4-.8l8-6a.99.99 0 0 1 1.2 0l8 6c.25.19.4.49.4.8v12c0 .55-.45 1-1 1Zm-5-2h4V9.5l-7-5.25L5 9.5V20h4v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5Z"
      })
    }),
    /* @__PURE__ */ jsx396("defs", {
      children: /* @__PURE__ */ jsx396("clipPath", {
        id: "home_svg__a",
        children: /* @__PURE__ */ jsx396("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var Home_default = SvgHome;

// src/icons/generated/Honeymoon.tsx
import { jsx as jsx397, jsxs as jsxs354 } from "react/jsx-runtime";
var SvgHoneymoon = (props) => /* @__PURE__ */ jsxs354("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs354("g", {
      fill: "currentColor",
      clipPath: "url(#honeymoon_svg__a)",
      children: [
        /* @__PURE__ */ jsx397("path", {
          d: "M9 20a7 7 0 0 1-7-7 7 7 0 0 1 5-6.72 1 1 0 0 1 .56 1.92A5 5 0 0 0 4 13a5 5 0 1 0 9.004-2.998A5 5 0 0 0 10.41 8.2a1 1 0 1 1 .56-1.92 7 7 0 0 1 5 6.72A7 7 0 0 1 9 20Z"
        }),
        /* @__PURE__ */ jsx397("path", {
          d: "M15.5 22A6.51 6.51 0 0 1 9 15.5 6.51 6.51 0 0 1 15.5 9a6.51 6.51 0 0 1 6.5 6.5 6.51 6.51 0 0 1-6.5 6.5Zm0-11a4.51 4.51 0 0 0-4.5 4.5 4.51 4.51 0 0 0 4.5 4.5 4.51 4.51 0 0 0 4.5-4.5 4.51 4.51 0 0 0-4.5-4.5ZM9 10a1 1 0 0 1-.8-.4L4.6 4.8a1 1 0 0 1 .09-1.31l1.2-1.2A1 1 0 0 1 6.6 2h4.8a1 1 0 0 1 .71.29l1.2 1.2a1 1 0 0 1 .09 1.31L9.8 9.6a1 1 0 0 1-.8.4ZM6.72 4.29l2.28 3 2.28-3L11 4H7l-.28.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx397("defs", {
      children: /* @__PURE__ */ jsx397("clipPath", {
        id: "honeymoon_svg__a",
        children: /* @__PURE__ */ jsx397("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Honeymoon_default = SvgHoneymoon;

// src/icons/generated/Hourglass.tsx
import { jsx as jsx398, jsxs as jsxs355 } from "react/jsx-runtime";
var SvgHourglass = (props) => /* @__PURE__ */ jsxs355("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs355("g", {
      fill: "currentColor",
      clipPath: "url(#hourglass_svg__a)",
      children: [
        /* @__PURE__ */ jsx398("path", {
          d: "M17.5 8h-11a1 1 0 0 1 0-2h11a1 1 0 1 1 0 2ZM17.5 18h-11a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx398("path", {
          d: "M17 22H7a2 2 0 0 1-2-2v-2a7 7 0 1 1 14 0v2a2 2 0 0 1-2 2Zm-5-9a5 5 0 0 0-5 5v2h10v-2a5 5 0 0 0-5-5Z"
        }),
        /* @__PURE__ */ jsx398("path", {
          d: "M12 13a7 7 0 0 1-7-7V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2a7 7 0 0 1-7 7ZM7 4v2a5 5 0 1 0 10 0V4H7Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx398("defs", {
      children: /* @__PURE__ */ jsx398("clipPath", {
        id: "hourglass_svg__a",
        children: /* @__PURE__ */ jsx398("path", {
          fill: "#fff",
          d: "M5 2h14v20H5z"
        })
      })
    })
  ]
});
var Hourglass_default = SvgHourglass;

// src/icons/generated/Image.tsx
import { jsx as jsx399, jsxs as jsxs356 } from "react/jsx-runtime";
var SvgImage = (props) => /* @__PURE__ */ jsxs356("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs356("g", {
      fill: "currentColor",
      clipPath: "url(#image_svg__a)",
      children: [
        /* @__PURE__ */ jsx399("path", {
          d: "M16 18c-.26 0-.51-.1-.71-.29l-5-5c-.53-.51-1.05-.51-1.6.01l-4.98 4.99A.996.996 0 1 1 2.3 16.3l5-5c1.32-1.28 3.09-1.28 4.4-.01l5.01 5.01A.996.996 0 0 1 16 18Z"
        }),
        /* @__PURE__ */ jsx399("path", {
          d: "M21 18c-.26 0-.51-.1-.71-.29l-3-3c-.53-.51-1.05-.51-1.6.01l-.99.99a.996.996 0 1 1-1.41-1.41l1-1c1.33-1.28 3.09-1.28 4.4-.01l3.01 3.01a.996.996 0 0 1-.71 1.7H21ZM16 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        }),
        /* @__PURE__ */ jsx399("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx399("defs", {
      children: /* @__PURE__ */ jsx399("clipPath", {
        id: "image_svg__a",
        children: /* @__PURE__ */ jsx399("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Image_default = SvgImage;

// src/icons/generated/InfoComposition.tsx
import { jsx as jsx400, jsxs as jsxs357 } from "react/jsx-runtime";
var SvgInfoComposition = (props) => /* @__PURE__ */ jsxs357("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs357("g", {
      fill: "currentColor",
      clipPath: "url(#info-composition_svg__a)",
      children: [
        /* @__PURE__ */ jsx400("path", {
          d: "M6 18A6 6 0 1 1 6 6a6 6 0 0 1 0 12ZM6 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM18 24a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
        }),
        /* @__PURE__ */ jsx400("path", {
          d: "M18 12a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
        }),
        /* @__PURE__ */ jsx400("path", {
          d: "M10.5 10.75a1.001 1.001 0 0 1-.946-1.31 1 1 0 0 1 .496-.58l3-1.5A1.009 1.009 0 0 1 14 9.14l-3 1.5a.93.93 0 0 1-.5.11ZM13.5 16.75a.93.93 0 0 1-.45-.11l-3-1.5a.999.999 0 1 1 .9-1.78l3 1.5a1 1 0 0 1-.45 1.89ZM6 14.8a1 1 0 0 1-1-1v-1.2a1 1 0 1 1 2 0v1.2a1 1 0 0 1-1 1ZM6 11.2a1.001 1.001 0 0 1-.38-.08 1.152 1.152 0 0 1-.33-.21 1.15 1.15 0 0 1-.21-.33.94.94 0 0 1 0-.76 1.15 1.15 0 0 1 .21-.33 1.15 1.15 0 0 1 .33-.21 1 1 0 0 1 .76 0c.121.05.233.122.33.21.088.097.16.209.21.33a.94.94 0 0 1 0 .76 1.15 1.15 0 0 1-.21.33c-.097.088-.209.16-.33.21-.12.051-.25.078-.38.08ZM15.69 19.66l1.41 1.16a.519.519 0 0 0 .74-.07.53.53 0 0 0 0-.67l-.24-.29.72-.87L19.64 20a.53.53 0 0 0 .74-.07.53.53 0 0 0 0-.67l-1.17-1.43.94-1.15a.64.64 0 0 0-.08-.9.65.65 0 0 0-.9.09l-1 1.14-1.63-.88a.52.52 0 0 0-.65.12.52.52 0 0 0 .11.75l1.31 1.1-.71.86-.34-.18a.52.52 0 0 0-.756.316.528.528 0 0 0 .186.564ZM15.75 5 18 3.27 20.25 5v3.33h-1.69V6.64h-1.12v1.69h-1.69V5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx400("defs", {
      children: /* @__PURE__ */ jsx400("clipPath", {
        id: "info-composition_svg__a",
        children: /* @__PURE__ */ jsx400("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })
  ]
});
var InfoComposition_default = SvgInfoComposition;

// src/icons/generated/InformationCircleFill.tsx
import { jsx as jsx401, jsxs as jsxs358 } from "react/jsx-runtime";
var SvgInformationCircleFill = (props) => /* @__PURE__ */ jsxs358("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx401("g", {
      clipPath: "url(#information-circle-fill_svg__a)",
      children: /* @__PURE__ */ jsx401("path", {
        fill: "currentColor",
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-.71 5.29a1.032 1.032 0 0 1 1.42 0c.09.1.16.21.21.33.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.09.09-.2.16-.33.21-.12.05-.25.08-.38.08s-.26-.03-.38-.08c-.13-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71ZM14 17h-4c-.55 0-1-.45-1-1s.45-1 1-1h1v-3h-1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1v4h1c.55 0 1 .45 1 1s-.45 1-1 1Z"
      })
    }),
    /* @__PURE__ */ jsx401("defs", {
      children: /* @__PURE__ */ jsx401("clipPath", {
        id: "information-circle-fill_svg__a",
        children: /* @__PURE__ */ jsx401("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var InformationCircleFill_default = SvgInformationCircleFill;

// src/icons/generated/InformationCircle.tsx
import { jsx as jsx402, jsxs as jsxs359 } from "react/jsx-runtime";
var SvgInformationCircle = (props) => /* @__PURE__ */ jsxs359("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs359("g", {
      fill: "currentColor",
      clipPath: "url(#information-circle_svg__a)",
      children: [
        /* @__PURE__ */ jsx402("path", {
          d: "M12 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx402("path", {
          d: "M12 12h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1ZM14 17h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1ZM12 9c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.21c-.09-.1-.16-.21-.21-.33A.838.838 0 0 1 11 8c0-.06 0-.13.02-.19.01-.07.03-.13.06-.19.02-.06.05-.12.09-.18.03-.05.08-.1.12-.15.1-.09.21-.16.33-.21.36-.16.81-.07 1.09.21.04.05.09.1.12.15.04.06.07.12.09.18.03.06.05.12.06.19.01.06.02.13.02.19 0 .13-.02.26-.08.38-.05.12-.12.23-.21.33-.19.18-.45.29-.71.29Z"
        }),
        /* @__PURE__ */ jsx402("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx402("defs", {
      children: /* @__PURE__ */ jsx402("clipPath", {
        id: "information-circle_svg__a",
        children: /* @__PURE__ */ jsx402("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var InformationCircle_default = SvgInformationCircle;

// src/icons/generated/Instagram.tsx
import { jsx as jsx403, jsxs as jsxs360 } from "react/jsx-runtime";
var SvgInstagram = (props) => /* @__PURE__ */ jsxs360("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs360("g", {
      fill: "currentColor",
      clipPath: "url(#instagram_svg__a)",
      children: [
        /* @__PURE__ */ jsx403("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        }),
        /* @__PURE__ */ jsx403("path", {
          d: "M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3ZM17 8c-.06 0-.13-.01-.19-.02a.603.603 0 0 1-.19-.06.556.556 0 0 1-.17-.09c-.06-.03-.11-.08-.16-.12-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.05-.04.1-.08.16-.12.05-.04.11-.07.17-.09.06-.03.12-.05.19-.06.33-.06.67.04.9.27.04.05.09.1.12.16.04.05.07.11.09.17.03.06.05.12.06.18.01.07.02.13.02.2 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx403("defs", {
      children: /* @__PURE__ */ jsx403("clipPath", {
        id: "instagram_svg__a",
        children: /* @__PURE__ */ jsx403("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Instagram_default = SvgInstagram;

// src/icons/generated/Invoice.tsx
import { jsx as jsx404, jsxs as jsxs361 } from "react/jsx-runtime";
var SvgInvoice = (props) => /* @__PURE__ */ jsxs361("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs361("g", {
      fill: "currentColor",
      clipPath: "url(#invoice_svg__a)",
      children: [
        /* @__PURE__ */ jsx404("path", {
          d: "M14.53 18c-2.29 0-4.27-1.44-5.17-3.5h-.85c-.55 0-1-.45-1-1s.45-1 1-1h.36c-.01-.17-.02-.33-.02-.5h-.34c-.55 0-1-.45-1-1s.45-1 1-1h.66c.78-2.33 2.89-4 5.37-4 .55 0 1 .45 1 1s-.45 1-1 1c-1.36 0-2.56.81-3.2 2h2.17c.55 0 1 .45 1 1s-.45 1-1 1h-2.66c0 .17 0 .34.03.5h2.64c.55 0 1 .45 1 1s-.45 1-1 1h-1.85c.68.91 1.72 1.5 2.88 1.5.55 0 1 .45 1 1s-.45 1-1 1h-.02Z"
        }),
        /* @__PURE__ */ jsx404("path", {
          d: "M20 22H4c-.55 0-1-.45-1-1V7c0-.27.11-.52.29-.71l4-4A.99.99 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1ZM5 20h14V4H8.41L5 7.41V20Z"
        }),
        /* @__PURE__ */ jsx404("path", {
          d: "M8 8H4c-.55 0-1-.45-1-1s.45-1 1-1h3V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx404("defs", {
      children: /* @__PURE__ */ jsx404("clipPath", {
        id: "invoice_svg__a",
        children: /* @__PURE__ */ jsx404("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var Invoice_default = SvgInvoice;

// src/icons/generated/Kids.tsx
import { jsx as jsx405, jsxs as jsxs362 } from "react/jsx-runtime";
var SvgKids = (props) => /* @__PURE__ */ jsxs362("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs362("g", {
      fill: "currentColor",
      clipPath: "url(#kids_svg__a)",
      children: [
        /* @__PURE__ */ jsx405("path", {
          d: "M6.95 18.3A6.21 6.21 0 0 1 5 17.99a6.32 6.32 0 0 1-4-3.74 2.48 2.48 0 0 1-.79-3.07 2.47 2.47 0 0 1 .54-.75 6.34 6.34 0 0 1 2.56-3.72 1 1 0 0 1 1.39.26 1 1 0 0 1-.25 1.39 4.4 4.4 0 0 0-1.82 2.81 1 1 0 0 1-.44.66.49.49 0 0 0 .06.85 1 1 0 0 1 .52.6 4.37 4.37 0 0 0 6.14 2.54 4.33 4.33 0 0 0 2.15-2.54 1 1 0 0 1 .53-.6.49.49 0 0 0 .262-.546.49.49 0 0 0-.212-.304 1 1 0 0 1-.44-.66 4.372 4.372 0 0 0-1.87-2.85 1 1 0 0 1 .364-1.809 1 1 0 0 1 .746.149 6.41 6.41 0 0 1 2.65 3.77 2.5 2.5 0 0 1 .38 3.16c-.167.257-.38.481-.63.66a6.38 6.38 0 0 1-3 3.35 6.41 6.41 0 0 1-2.89.7Z"
        }),
        /* @__PURE__ */ jsx405("path", {
          d: "M6.95 15.59a3.09 3.09 0 0 1-2.21-.93 1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0 1.08 1.08 0 0 0 1.53 0 1 1 0 0 1 1.41 0 1 1 0 0 1 .06 1.38l-.07.07a3.1 3.1 0 0 1-2.13.89ZM7.2 10a1 1 0 0 1-1-1 3.22 3.22 0 0 0-1-2.14 1 1 0 0 1 .357-1.809 1 1 0 0 1 .753.149A5.07 5.07 0 0 1 8.24 9a1 1 0 0 1-1.04 1ZM5.76 12.64a1 1 0 0 1-1-1v-.3a1 1 0 1 1 2 0v.3a1 1 0 0 1-1 1ZM8.14 12.64a1 1 0 0 1-1-1v-.3a1 1 0 1 1 2 0v.3a1 1 0 0 1-1 1ZM13.37 9a1 1 0 0 1-.74-.34 1 1 0 0 1 .07-1.41c.205-.178.418-.345.64-.5a1 1 0 0 1 1.39.26 1 1 0 0 1-.25 1.39 3.668 3.668 0 0 0-.44.34 1 1 0 0 1-.67.26ZM16.95 18.3a6.21 6.21 0 0 1-1.95-.31 6.33 6.33 0 0 1-1.69-.83 1 1 0 0 1 .393-1.802 1 1 0 0 1 .747.162c.356.247.747.44 1.16.57a4.36 4.36 0 0 0 3.32-.27 4.332 4.332 0 0 0 2.15-2.54 1 1 0 0 1 .53-.6.49.49 0 0 0 .262-.546.49.49 0 0 0-.212-.304 1 1 0 0 1-.44-.66 4.372 4.372 0 0 0-1.87-2.85 1 1 0 0 1-.27-1.39 1 1 0 0 1 1.38-.27 6.41 6.41 0 0 1 2.65 3.77 2.5 2.5 0 0 1 .38 3.16 2.47 2.47 0 0 1-.63.66 6.38 6.38 0 0 1-3 3.35 6.41 6.41 0 0 1-2.91.7Z"
        }),
        /* @__PURE__ */ jsx405("path", {
          d: "M16.95 15.59a3.09 3.09 0 0 1-2.21-.93 1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0 1.08 1.08 0 0 0 1.53 0 1 1 0 0 1 1.41 0 1 1 0 0 1 .06 1.38l-.07.07a3.1 3.1 0 0 1-2.13.89ZM17.2 10a1 1 0 0 1-1-1 3.22 3.22 0 0 0-1-2.14 1 1 0 0 1 .748-1.81 1 1 0 0 1 .362.15A5.07 5.07 0 0 1 18.24 9a1 1 0 0 1-1.04 1ZM15.76 12.64a1 1 0 0 1-1-1v-.3a1 1 0 1 1 2 0v.3a1 1 0 0 1-1 1ZM18.14 12.64a1 1 0 0 1-1-1v-.3a1 1 0 1 1 2 0v.3a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx405("defs", {
      children: /* @__PURE__ */ jsx405("clipPath", {
        id: "kids_svg__a",
        children: /* @__PURE__ */ jsx405("path", {
          fill: "#fff",
          d: "M0 5h23.9v13.3H0z"
        })
      })
    })
  ]
});
var Kids_default = SvgKids;

// src/icons/generated/Language.tsx
import { jsx as jsx406, jsxs as jsxs363 } from "react/jsx-runtime";
var SvgLanguage = (props) => /* @__PURE__ */ jsxs363("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs363("g", {
      fill: "currentColor",
      clipPath: "url(#language_svg__a)",
      children: [
        /* @__PURE__ */ jsx406("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx406("path", {
          d: "M12 22c-3.11 0-4.79-5.15-4.79-10S8.89 2 12 2c3.11 0 4.79 5.15 4.79 10S15.11 22 12 22Zm0-18c-1.14 0-2.79 3.12-2.79 8s1.65 8 2.79 8c1.14 0 2.79-3.12 2.79-8S13.14 4 12 4Z"
        }),
        /* @__PURE__ */ jsx406("path", {
          d: "M21 13H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1ZM12 9c-1 0-4.46-.12-7.27-1.7a1 1 0 0 1 .98-1.74C7.6 6.62 10.2 7 12 7c1.8 0 4.4-.38 6.29-1.44a1 1 0 0 1 .98 1.74C16.47 8.88 13 9 12 9ZM18.78 18.57c-.17 0-.33-.04-.49-.13C16.4 17.38 13.8 17 12 17c-1.8 0-4.4.38-6.29 1.44a1 1 0 0 1-.98-1.74C7.53 15.12 11 15 12 15s4.46.12 7.27 1.7a1 1 0 0 1 .38 1.36c-.18.33-.52.51-.87.51Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx406("defs", {
      children: /* @__PURE__ */ jsx406("clipPath", {
        id: "language_svg__a",
        children: /* @__PURE__ */ jsx406("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Language_default = SvgLanguage;

// src/icons/generated/Lesson.tsx
import { jsx as jsx407, jsxs as jsxs364 } from "react/jsx-runtime";
var SvgLesson = (props) => /* @__PURE__ */ jsxs364("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs364("g", {
      fill: "currentColor",
      clipPath: "url(#lesson_svg__a)",
      children: [
        /* @__PURE__ */ jsx407("path", {
          d: "M15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx407("path", {
          d: "M9 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx407("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx407("defs", {
      children: /* @__PURE__ */ jsx407("clipPath", {
        id: "lesson_svg__a",
        children: /* @__PURE__ */ jsx407("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Lesson_default = SvgLesson;

// src/icons/generated/LiftCabinBig.tsx
import { jsx as jsx408, jsxs as jsxs365 } from "react/jsx-runtime";
var SvgLiftCabinBig = (props) => /* @__PURE__ */ jsxs365("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs365("g", {
      fill: "currentColor",
      clipPath: "url(#lift-cabin-big_svg__a)",
      children: [
        /* @__PURE__ */ jsx408("path", {
          d: "M18.71 22H5.29c-1.27 0-2.36-.89-2.66-2.16l-.21-.88c-.62-2.61-.56-5.34.17-7.92C2.93 9.84 4.02 9 5.23 9h13.52c1.21 0 2.3.84 2.64 2.04.73 2.58.79 5.31.17 7.92l-.21.88c-.3 1.27-1.4 2.16-2.66 2.16h.02ZM5.24 11c-.33 0-.62.24-.72.59-.64 2.25-.69 4.64-.15 6.91l.21.88c.09.36.38.62.72.62h13.41c.33 0 .63-.26.72-.62l.21-.88c.54-2.27.49-4.66-.15-6.91-.1-.35-.39-.59-.72-.59H5.24Z"
        }),
        /* @__PURE__ */ jsx408("path", {
          d: "M12 10.58c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4.58c0 .55-.45 1-1 1ZM20.53 16.5H3.47c-.55 0-1-.45-1-1s.45-1 1-1h17.06c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx408("path", {
          d: "M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3C8.23 6.98 8.12 7 8 7ZM13.02 22h-2.05c-1.81 0-3.29-1.48-3.29-3.29v-6.42C7.68 10.48 9.16 9 10.97 9h2.05c1.81 0 3.29 1.48 3.29 3.29v6.42c0 1.81-1.48 3.29-3.29 3.29Zm-2.05-11c-.71 0-1.29.58-1.29 1.29v6.42c0 .71.58 1.29 1.29 1.29h2.05c.71 0 1.29-.58 1.29-1.29v-6.42c0-.71-.58-1.29-1.29-1.29h-2.05Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx408("defs", {
      children: /* @__PURE__ */ jsx408("clipPath", {
        id: "lift-cabin-big_svg__a",
        children: /* @__PURE__ */ jsx408("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var LiftCabinBig_default = SvgLiftCabinBig;

// src/icons/generated/LiftCabinSmall.tsx
import { jsx as jsx409, jsxs as jsxs366 } from "react/jsx-runtime";
var SvgLiftCabinSmall = (props) => /* @__PURE__ */ jsxs366("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs366("g", {
      fill: "currentColor",
      clipPath: "url(#lift-cabin-small_svg__a)",
      children: [
        /* @__PURE__ */ jsx409("path", {
          d: "M17.13 22H7.75c-.97 0-1.88-.7-2.13-1.62-.83-3.19-.83-6.56 0-9.74.25-.93 1.17-1.63 2.13-1.63h9.38c.97 0 1.89.7 2.13 1.62.83 3.19.83 6.56 0 9.74-.25.92-1.18 1.63-2.13 1.63Zm0-11H7.76c-.06 0-.18.09-.2.15-.74 2.85-.74 5.86 0 8.72.02.04.14.13.2.13h9.37c.06 0 .18-.09.2-.15.74-2.84.74-5.86 0-8.72-.02-.04-.14-.13-.2-.13Z"
        }),
        /* @__PURE__ */ jsx409("path", {
          d: "M12.44 22c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v16c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx409("path", {
          d: "M18.72 18H6.17c-.55 0-1-.45-1-1s.45-1 1-1h12.55c.55 0 1 .45 1 1s-.45 1-1 1ZM8.44 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3c-.12.04-.23.06-.35.06Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx409("defs", {
      children: /* @__PURE__ */ jsx409("clipPath", {
        id: "lift-cabin-small_svg__a",
        children: /* @__PURE__ */ jsx409("path", {
          fill: "#fff",
          d: "M5 2h14.88v20H5z"
        })
      })
    })
  ]
});
var LiftCabinSmall_default = SvgLiftCabinSmall;

// src/icons/generated/LiftChairFront.tsx
import { jsx as jsx410, jsxs as jsxs367 } from "react/jsx-runtime";
var SvgLiftChairFront = (props) => /* @__PURE__ */ jsxs367("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs367("g", {
      fill: "currentColor",
      clipPath: "url(#lift-chair-front_svg__a)",
      children: [
        /* @__PURE__ */ jsx410("path", {
          d: "M12 10.14c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4.14c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx410("path", {
          d: "M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3C8.23 6.98 8.12 7 8 7ZM18.5 19c-.55 0-1-.45-1-1v-2H6.51v1.83c0 .55-.45 1-1.01 1s-1-.45-1-1v-1.85c0-1.09.84-1.98 1.87-1.98h11.26c1.03 0 1.87.89 1.87 1.98V18c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx410("path", {
          d: "M18.07 22H5.94C4.87 22 4 21.13 4 20.06V18c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v2.06c0 1.07-.87 1.94-1.94 1.94h.01ZM6.01 19v1.06L18.07 20l-.03-1H6h.01Z"
        }),
        /* @__PURE__ */ jsx410("path", {
          d: "M19.53 19c-.55 0-1-.45-1-1s.45-1 1-1c.17 0 .28-.1.34-.18.11-.14.15-.33.11-.52l-1.07-4.55c-.1-.44-.46-.75-.87-.75H5.95c-.41 0-.76.31-.87.75L4.01 16.3c-.04.19 0 .38.11.52.06.08.18.18.34.18.55 0 1 .45 1 1s-.45 1-1 1c-.75 0-1.44-.34-1.91-.94-.5-.63-.67-1.44-.49-2.22l1.07-4.55C3.45 9.94 4.6 9 5.94 9h12.09c1.34 0 2.5.94 2.81 2.29l1.07 4.55c.18.79 0 1.6-.49 2.22-.47.59-1.17.94-1.91.94h.02Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx410("defs", {
      children: /* @__PURE__ */ jsx410("clipPath", {
        id: "lift-chair-front_svg__a",
        children: /* @__PURE__ */ jsx410("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var LiftChairFront_default = SvgLiftChairFront;

// src/icons/generated/LiftChairSide.tsx
import { jsx as jsx411, jsxs as jsxs368 } from "react/jsx-runtime";
var SvgLiftChairSide = (props) => /* @__PURE__ */ jsxs368("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs368("g", {
      fill: "currentColor",
      clipPath: "url(#lift-chair-side_svg__a)",
      children: [
        /* @__PURE__ */ jsx411("path", {
          d: "M12 19.5h-1.42c-1.61 0-3.08-1.43-3.08-3V12c0-2.11 1.84-3.96 3.96-4l-.04-3.09c0-.55.44-1 .99-1.01a.984.984 0 0 1 1.01.99L13.47 9c0 .27-.1.52-.29.71a1 1 0 0 1-.71.3h-.95c-1.02 0-2.03.99-2.03 2v4.5c0 .48.56 1 1.08 1h1.42c.55 0 1 .45 1 1s-.45 1-1 1l.01-.01Z"
        }),
        /* @__PURE__ */ jsx411("path", {
          d: "M8 6.5c-.43 0-.83-.28-.96-.72a.994.994 0 0 1 .68-1.24l8.5-2.5a.994.994 0 0 1 1.24.68.994.994 0 0 1-.68 1.24l-8.5 2.5c-.09.03-.19.04-.28.04ZM14 19.5h-2.5c-1.08 0-2-.92-2-2V14c0-.55.45-1 1-1s1 .45 1 1v3.5H14c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx411("path", {
          d: "M15.5 22H14c-.55 0-1-.45-1-1v-4.5H8.5c-.55 0-1-.45-1-1s.45-1 1-1H14c.55 0 1 .45 1 1V20h.5c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx411("defs", {
      children: /* @__PURE__ */ jsx411("clipPath", {
        id: "lift-chair-side_svg__a",
        children: /* @__PURE__ */ jsx411("path", {
          fill: "#fff",
          d: "M7 2h10.5v20H7z"
        })
      })
    })
  ]
});
var LiftChairSide_default = SvgLiftChairSide;

// src/icons/generated/LiftDrag.tsx
import { jsx as jsx412, jsxs as jsxs369 } from "react/jsx-runtime";
var SvgLiftDrag = (props) => /* @__PURE__ */ jsxs369("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs369("g", {
      fill: "currentColor",
      clipPath: "url(#lift-drag_svg__a)",
      children: [
        /* @__PURE__ */ jsx412("path", {
          d: "M12 22c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v16c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx412("path", {
          d: "M15 22H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1ZM8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3C8.23 6.98 8.12 7 8 7Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx412("defs", {
      children: /* @__PURE__ */ jsx412("clipPath", {
        id: "lift-drag_svg__a",
        children: /* @__PURE__ */ jsx412("path", {
          fill: "#fff",
          d: "M7 2h10v20H7z"
        })
      })
    })
  ]
});
var LiftDrag_default = SvgLiftDrag;

// src/icons/generated/Link.tsx
import { jsx as jsx413, jsxs as jsxs370 } from "react/jsx-runtime";
var SvgLink = (props) => /* @__PURE__ */ jsxs370("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs370("g", {
      fill: "currentColor",
      clipPath: "url(#link_svg__a)",
      children: [
        /* @__PURE__ */ jsx413("path", {
          d: "M12.53 16.08h-.05a4.44 4.44 0 0 1-3.16-1.35 1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0 2.5 2.5 0 0 0 1.76.75 2.48 2.48 0 0 0 1.75-.71l4-4a2.511 2.511 0 0 0 .04-3.62 2.53 2.53 0 0 0-3.58 0l-.5.5a1 1 0 0 1-1.42 0 .998.998 0 0 1 0-1.42l.5-.5a4.54 4.54 0 0 1 6.42 6.42l-4 4-.07.07a4.46 4.46 0 0 1-3.1 1.27Z"
        }),
        /* @__PURE__ */ jsx413("path", {
          d: "M7.53 21.03a4.55 4.55 0 0 1-3.21-1.32 4.54 4.54 0 0 1 0-6.42l4-4 .07-.07a4.55 4.55 0 0 1 3.19-1.19 4.44 4.44 0 0 1 3.16 1.35 1 1 0 0 1 0 1.41 1 1 0 0 1-1.41 0 2.5 2.5 0 0 0-1.76-.75 2.48 2.48 0 0 0-1.75.71l-4 4a2.51 2.51 0 0 0-.79 1.78 2.51 2.51 0 0 0 .75 1.79 2.529 2.529 0 0 0 3.58 0l.5-.5a1 1 0 0 1 1.639.325 1 1 0 0 1-.22 1.095l-.5.5a4.55 4.55 0 0 1-3.249 1.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx413("defs", {
      children: /* @__PURE__ */ jsx413("clipPath", {
        id: "link_svg__a",
        children: /* @__PURE__ */ jsx413("path", {
          fill: "#fff",
          d: "M3 3h18.07v18.07H3z"
        })
      })
    })
  ]
});
var Link_default = SvgLink;

// src/icons/generated/List.tsx
import { jsx as jsx414, jsxs as jsxs371 } from "react/jsx-runtime";
var SvgList = (props) => /* @__PURE__ */ jsxs371("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx414("g", {
      fill: "currentColor",
      clipPath: "url(#list_svg__a)",
      children: /* @__PURE__ */ jsx414("path", {
        d: "M21 7H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM21 13H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM21 19H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM3 7c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.838.838 0 0 1 2 6c0-.13.02-.26.08-.38.05-.12.12-.23.21-.33.24-.23.58-.34.91-.27.06.01.12.03.18.06.06.02.12.05.18.09l.15.12c.09.1.16.21.21.33.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.05.04-.1.09-.15.12-.06.04-.12.07-.18.09-.06.03-.12.05-.18.06-.07.01-.13.02-.2.02ZM3 13c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.838.838 0 0 1 2 12c0-.13.02-.26.08-.38.05-.12.12-.23.21-.33.24-.23.58-.34.91-.27.06.01.12.03.18.06.06.02.12.05.18.09l.15.12c.09.1.16.21.21.33.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.05.04-.1.09-.15.12-.06.04-.12.07-.18.09-.06.03-.12.05-.18.06-.07.01-.13.02-.2.02ZM3 19c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.838.838 0 0 1 2 18c0-.13.02-.26.08-.38.05-.12.12-.23.21-.33.24-.23.58-.34.91-.27.06.01.12.03.18.06.06.02.12.05.18.09l.15.12c.09.1.16.21.21.33.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.05.04-.1.09-.15.12-.06.04-.12.07-.18.09-.06.03-.12.05-.18.06-.07.01-.13.02-.2.02Z"
      })
    }),
    /* @__PURE__ */ jsx414("defs", {
      children: /* @__PURE__ */ jsx414("clipPath", {
        id: "list_svg__a",
        children: /* @__PURE__ */ jsx414("path", {
          fill: "#fff",
          d: "M2 5h20v14H2z"
        })
      })
    })
  ]
});
var List_default = SvgList;

// src/icons/generated/Loader.tsx
import { jsx as jsx415, jsxs as jsxs372 } from "react/jsx-runtime";
var SvgLoader = (props) => /* @__PURE__ */ jsxs372("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx415("g", {
      clipPath: "url(#loader_svg__a)",
      children: /* @__PURE__ */ jsx415("path", {
        fill: "currentColor",
        d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c.55 0 1 .45 1 1s-.45 1-1 1c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8c0-.55.45-1 1-1s1 .45 1 1c0 5.51-4.49 10-10 10Z"
      })
    }),
    /* @__PURE__ */ jsx415("defs", {
      children: /* @__PURE__ */ jsx415("clipPath", {
        id: "loader_svg__a",
        children: /* @__PURE__ */ jsx415("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Loader_default = SvgLoader;

// src/icons/generated/LockBadge.tsx
import { jsx as jsx416, jsxs as jsxs373 } from "react/jsx-runtime";
var SvgLockBadge = (props) => /* @__PURE__ */ jsxs373("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs373("g", {
      fill: "currentColor",
      clipPath: "url(#lock-badge_svg__a)",
      children: [
        /* @__PURE__ */ jsx416("path", {
          d: "M15 16H9c-.55 0-1-.45-1-1V9.6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1V15c0 .55-.45 1-1 1Zm-5-2h4v-3.4h-4V14Z"
        }),
        /* @__PURE__ */ jsx416("path", {
          d: "M14 10.6c-.55 0-1-.44-1-.99V7.85c-.01-.47-.46-.84-1.01-.84s-.99.38-.99.84v1.76c0 .55-.45 1-1 1s-1-.45-1-1V7.85c0-1.56 1.34-2.84 2.99-2.84 1.65 0 2.99 1.27 2.99 2.84v1.76c.02.55-.43 1-.98 1.01v-.02Z"
        }),
        /* @__PURE__ */ jsx416("path", {
          d: "M12 22c-.17 0-.34-.04-.49-.13-.12-.06-2.83-1.58-4.21-2.74-2.61-2.2-4.28-5.38-4.3-8.12V7.5c0-1.23.01-2.45 0-3.49 0-.42.25-.79.64-.94 1.65-.63 4.64-1.02 8.2-1.07 3.32-.05 6.66.38 8.51 1.06.39.14.65.51.65.93v7c.02 3.28-2.11 6.31-4.12 8.04-1.42 1.22-4.29 2.78-4.41 2.85-.15.08-.31.12-.48.12H12ZM5.01 4.73V11c.01 2.15 1.44 4.79 3.55 6.57.94.79 2.63 1.81 3.46 2.29.85-.48 2.62-1.52 3.52-2.29 2.14-1.85 3.48-4.41 3.47-6.55V4.75c-1.52-.42-4.13-.77-7.14-.73-2.8.03-5.33.31-6.86.72v-.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx416("defs", {
      children: /* @__PURE__ */ jsx416("clipPath", {
        id: "lock-badge_svg__a",
        children: /* @__PURE__ */ jsx416("path", {
          fill: "#fff",
          d: "M3 2h18.01v20H3z"
        })
      })
    })
  ]
});
var LockBadge_default = SvgLockBadge;

// src/icons/generated/Lock.tsx
import { jsx as jsx417, jsxs as jsxs374 } from "react/jsx-runtime";
var SvgLock = (props) => /* @__PURE__ */ jsxs374("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs374("g", {
      fill: "currentColor",
      clipPath: "url(#lock_svg__a)",
      children: [
        /* @__PURE__ */ jsx417("path", {
          d: "M17 22H7c-1.65 0-3-1.35-3-3v-7c0-1.65 1.35-3 3-3h10c1.65 0 3 1.35 3 3v7c0 1.65-1.35 3-3 3ZM7 11c-.55 0-1 .45-1 1v7c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-7c0-.55-.45-1-1-1H7Z"
        }),
        /* @__PURE__ */ jsx417("path", {
          d: "M16 11c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3S9 5.35 9 7v3c0 .55-.45 1-1 1s-1-.45-1-1V7c0-2.76 2.24-5 5-5s5 2.24 5 5v3c0 .55-.45 1-1 1ZM12 19c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx417("defs", {
      children: /* @__PURE__ */ jsx417("clipPath", {
        id: "lock_svg__a",
        children: /* @__PURE__ */ jsx417("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Lock_default = SvgLock;

// src/icons/generated/Logout.tsx
import { jsx as jsx418, jsxs as jsxs375 } from "react/jsx-runtime";
var SvgLogout = (props) => /* @__PURE__ */ jsxs375("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs375("g", {
      fill: "currentColor",
      clipPath: "url(#logout_svg__a)",
      children: [
        /* @__PURE__ */ jsx418("path", {
          d: "M18.16 15.84c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41L19.58 12l-2.13-2.14a.996.996 0 1 1 1.41-1.41l2.84 2.84c.39.39.39 1.02 0 1.41l-2.84 2.84c-.2.2-.45.29-.71.29l.01.01ZM12 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v2c0 .55-.45 1-1 1s-1-.45-1-1V6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 2.21-1.79 4-4 4Z"
        }),
        /* @__PURE__ */ jsx418("path", {
          d: "M21 13H9.63c-.55 0-1-.45-1-1s.45-1 1-1H21c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx418("defs", {
      children: /* @__PURE__ */ jsx418("clipPath", {
        id: "logout_svg__a",
        children: /* @__PURE__ */ jsx418("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Logout_default = SvgLogout;

// src/icons/generated/LuggageCheck.tsx
import { jsx as jsx419, jsxs as jsxs376 } from "react/jsx-runtime";
var SvgLuggageCheck = (props) => /* @__PURE__ */ jsxs376("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs376("g", {
      fill: "currentColor",
      clipPath: "url(#luggage-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx419("path", {
          d: "M11 16h-.01c-.33 0-.64-.17-.82-.45l-2-3a1.001 1.001 0 1 1 1.67-1.11l1.19 1.78 6.15-8.79c.32-.45.94-.56 1.39-.25.45.31.56.94.25 1.39l-7 10c-.19.27-.49.43-.82.43Z"
        }),
        /* @__PURE__ */ jsx419("path", {
          d: "M15.34 22H6.66C5.2 22 4 20.81 4 19.34V8.66C4 7.2 5.19 6 6.66 6H13c.55 0 1 .45 1 1s-.45 1-1 1H6.66a.66.66 0 0 0-.66.66v10.69c0 .36.29.66.66.66h8.68c.36 0 .66-.29.66-.66v-7.36c0-.55.45-1 1-1s1 .45 1 1v7.36c0 1.46-1.19 2.66-2.66 2.66V22Z"
        }),
        /* @__PURE__ */ jsx419("path", {
          d: "M13 7.79c-.55 0-1-.45-1-1V2h-2v4.79c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5.79c0 .55-.45 1-1 1ZM8 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1ZM14 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx419("defs", {
      children: /* @__PURE__ */ jsx419("clipPath", {
        id: "luggage-check_svg__a",
        children: /* @__PURE__ */ jsx419("path", {
          fill: "#fff",
          d: "M4 0h15v24H4z"
        })
      })
    })
  ]
});
var LuggageCheck_default = SvgLuggageCheck;

// src/icons/generated/Luggage.tsx
import { jsx as jsx420, jsxs as jsxs377 } from "react/jsx-runtime";
var SvgLuggage = (props) => /* @__PURE__ */ jsxs377("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs377("g", {
      fill: "currentColor",
      clipPath: "url(#luggage_svg__a)",
      children: [
        /* @__PURE__ */ jsx420("path", {
          d: "M16.34 22H7.66C6.2 22 5 20.81 5 19.34V8.66C5 7.19 6.19 6 7.66 6h8.68C17.8 6 19 7.19 19 8.66v10.69c0 1.47-1.19 2.66-2.66 2.66V22ZM7.66 8a.66.66 0 0 0-.66.66v10.69c0 .36.29.66.66.66h8.68c.36 0 .66-.29.66-.66V8.66a.66.66 0 0 0-.66-.66H7.66Z"
        }),
        /* @__PURE__ */ jsx420("path", {
          d: "M14 7.79c-.55 0-1-.45-1-1V2h-2v4.79c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5.79c0 .55-.45 1-1 1ZM9 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1ZM15 24c-.55 0-1-.45-1-1v-1.22c0-.55.45-1 1-1s1 .45 1 1V23c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx420("defs", {
      children: /* @__PURE__ */ jsx420("clipPath", {
        id: "luggage_svg__a",
        children: /* @__PURE__ */ jsx420("path", {
          fill: "#fff",
          d: "M5 0h14v24H5z"
        })
      })
    })
  ]
});
var Luggage_default = SvgLuggage;

// src/icons/generated/Magazine.tsx
import { jsx as jsx421, jsxs as jsxs378 } from "react/jsx-runtime";
var SvgMagazine = (props) => /* @__PURE__ */ jsxs378("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs378("g", {
      fill: "currentColor",
      clipPath: "url(#magazine_svg__a)",
      children: [
        /* @__PURE__ */ jsx421("path", {
          d: "M12 22c-.12 0-.25-.02-.37-.07-2.66-1.06-5.6-1.06-8.26 0-.31.12-.66.08-.93-.1-.27-.19-.44-.5-.44-.83V7a1 1 0 0 1 .63-.93c.59-.24 1.17-.36 1.73-.47l.38-.08a1.003 1.003 0 0 1 .42 1.96l-.4.08c-.26.05-.51.11-.76.17v11.88a13 13 0 0 1 7 0V7c0-.55.45-1 1-1s1 .45 1 1v14a.999.999 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx421("path", {
          d: "M12 22c-.26 0-.51-.1-.7-.29-2.45-2.42-4.69-3.88-6.49-4.23A.997.997 0 0 1 4 16.5V3a.992.992 0 0 1 1.19-.98c2.37.46 5.04 2.06 7.51 4.51a1 1 0 0 1 .3.71V21c0 .4-.24.77-.62.92-.12.05-.25.08-.38.08Zm-6-6.28c1.54.48 3.21 1.48 5 3V7.66c-1.68-1.6-3.41-2.75-5-3.34v11.4Z"
        }),
        /* @__PURE__ */ jsx421("path", {
          d: "M21 22c-.12 0-.25-.02-.37-.07-2.66-1.06-5.6-1.06-8.26 0-.31.12-.66.08-.93-.1-.27-.19-.44-.5-.44-.83V7c0-.55.45-1 1-1s1 .45 1 1v12.61a13 13 0 0 1 7 0V7.73c-.24-.06-.5-.11-.76-.17l-.4-.08a1.01 1.01 0 0 1-.77-1.19c.12-.54.65-.88 1.19-.77l.38.08c.56.11 1.13.23 1.73.47A1 1 0 0 1 22 7v14a.999.999 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx421("path", {
          d: "M12 22a1.013 1.013 0 0 1-1-1V7.24a1 1 0 0 1 .3-.71c2.47-2.45 5.14-4.06 7.51-4.51A.992.992 0 0 1 20 3v13.5c0 .48-.34.89-.81.98-1.8.35-4.04 1.81-6.49 4.23-.19.19-.45.29-.7.29Zm1-14.34v11.06c1.79-1.52 3.46-2.52 5-3V4.32c-1.59.59-3.32 1.74-5 3.34Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx421("defs", {
      children: /* @__PURE__ */ jsx421("clipPath", {
        id: "magazine_svg__a",
        children: /* @__PURE__ */ jsx421("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Magazine_default = SvgMagazine;

// src/icons/generated/Mail.tsx
import { jsx as jsx422, jsxs as jsxs379 } from "react/jsx-runtime";
var SvgMail = (props) => /* @__PURE__ */ jsxs379("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs379("g", {
      fill: "currentColor",
      clipPath: "url(#mail_svg__a)",
      children: [
        /* @__PURE__ */ jsx422("path", {
          d: "M19 20H5c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v10c0 1.65-1.35 3-3 3ZM5 6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H5Z"
        }),
        /* @__PURE__ */ jsx422("path", {
          d: "M12 14c-.24 0-.47-.08-.66-.25l-8-7c-.42-.36-.46-1-.09-1.41.36-.42 1-.46 1.41-.09L12 11.67l7.34-6.42c.41-.36 1.04-.32 1.41.09.36.42.32 1.05-.09 1.41l-8 7c-.19.17-.42.25-.66.25Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx422("defs", {
      children: /* @__PURE__ */ jsx422("clipPath", {
        id: "mail_svg__a",
        children: /* @__PURE__ */ jsx422("path", {
          fill: "#fff",
          d: "M2 4h20v16H2z"
        })
      })
    })
  ]
});
var Mail_default = SvgMail;

// src/icons/generated/MandatoryCosts.tsx
import { jsx as jsx423, jsxs as jsxs380 } from "react/jsx-runtime";
var SvgMandatoryCosts = (props) => /* @__PURE__ */ jsxs380("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs380("g", {
      fill: "currentColor",
      clipPath: "url(#mandatory-costs_svg__a)",
      children: [
        /* @__PURE__ */ jsx423("path", {
          d: "M11 20a6.54 6.54 0 0 1-5-2.34 8.9 8.9 0 0 1 0-11.2A6.56 6.56 0 0 1 11 4a6.53 6.53 0 0 1 5 2.34 1 1 0 1 1-1.5 1.32A4.58 4.58 0 0 0 11 6a4.59 4.59 0 0 0-3.48 1.74 6.83 6.83 0 0 0 .07 8.6 4.42 4.42 0 0 0 6.9 0A1.002 1.002 0 1 1 16 17.66 6.54 6.54 0 0 1 11 20Z"
        }),
        /* @__PURE__ */ jsx423("path", {
          d: "M11 15H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H3a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2ZM21 15a1 1 0 0 1-1-1V7a1 1 0 0 1 2 0v7a1 1 0 0 1-1 1ZM21 18a1.05 1.05 0 0 1-.71-.29 1 1 0 0 1-.21-.33.94.94 0 0 1 0-.76 1.15 1.15 0 0 1 .21-.33 1 1 0 0 1 .91-.29l.18.06a.76.76 0 0 1 .18.09l.15.12c.088.097.16.209.21.33a.94.94 0 0 1 0 .76c-.05.121-.122.233-.21.33l-.15.12a.764.764 0 0 1-.18.09l-.18.1H21Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx423("defs", {
      children: /* @__PURE__ */ jsx423("clipPath", {
        id: "mandatory-costs_svg__a",
        children: /* @__PURE__ */ jsx423("path", {
          fill: "#fff",
          d: "M2 4h20v16H2z"
        })
      })
    })
  ]
});
var MandatoryCosts_default = SvgMandatoryCosts;

// src/icons/generated/Map.tsx
import { jsx as jsx424, jsxs as jsxs381 } from "react/jsx-runtime";
var SvgMap = (props) => /* @__PURE__ */ jsxs381("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs381("g", {
      fill: "currentColor",
      clipPath: "url(#map_svg__a)",
      children: [
        /* @__PURE__ */ jsx424("path", {
          d: "M3 21a.999.999 0 0 1-1-1V7c0-.38.21-.72.55-.89l6-3c.28-.14.61-.14.89 0l5.55 2.78 5.56-2.78c.31-.15.68-.14.97.04.29.18.47.5.47.85v13c0 .38-.21.72-.55.89l-6 3c-.28.14-.61.14-.89 0L9 18.11l-5.55 2.78c-.14.07-.29.11-.45.11Zm6-5c.15 0 .31.04.45.11L15 18.89l5-2.5V5.62L15.45 7.9c-.28.14-.61.14-.89 0L9 5.12l-5 2.5v10.76l4.55-2.28c.14-.07.29-.11.45-.11V16Z"
        }),
        /* @__PURE__ */ jsx424("path", {
          d: "M9 18c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v13c0 .55-.45 1-1 1ZM15 21c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v13c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx424("defs", {
      children: /* @__PURE__ */ jsx424("clipPath", {
        id: "map_svg__a",
        children: /* @__PURE__ */ jsx424("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var Map_default = SvgMap;

// src/icons/generated/Medal.tsx
import { jsx as jsx425, jsxs as jsxs382 } from "react/jsx-runtime";
var SvgMedal = (props) => /* @__PURE__ */ jsxs382("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs382("g", {
      fill: "currentColor",
      clipPath: "url(#medal_svg__a)",
      children: [
        /* @__PURE__ */ jsx425("path", {
          d: "M12 18c-.77 0-1.26-.56-1.61-.97-.07-.08-.16-.18-.23-.25-.06.03-.21.08-.31.12-.5.17-1.19.41-1.85.03-.66-.38-.8-1.1-.9-1.63-.02-.1-.04-.23-.07-.33-.1-.02-.23-.05-.33-.07-.53-.1-1.25-.24-1.63-.9-.38-.65-.14-1.35.03-1.85.03-.1.08-.23.11-.33-.07-.07-.17-.15-.24-.21C4.56 11.26 4 10.77 4 10c0-.77.56-1.26.97-1.61.08-.07.18-.16.25-.23-.03-.06-.08-.21-.12-.31-.17-.5-.41-1.2-.03-1.85.38-.66 1.1-.8 1.63-.9.1-.02.23-.04.33-.07.02-.1.05-.23.07-.32.1-.53.24-1.25.9-1.63.66-.38 1.35-.14 1.85.03.1.03.23.08.33.1.07-.07.15-.17.21-.24.35-.41.84-.97 1.61-.97.77 0 1.26.56 1.61.97.07.08.16.18.23.25.06-.03.21-.08.31-.12.5-.17 1.19-.41 1.85-.03.66.38.8 1.1.9 1.63.02.1.04.23.07.33.1.02.23.05.33.07.53.1 1.25.24 1.63.9.38.65.14 1.35-.03 1.85-.03.1-.08.23-.11.33.07.07.17.15.24.21.41.35.97.84.97 1.61 0 .77-.56 1.26-.97 1.61-.08.07-.18.16-.25.23.03.06.08.21.12.31.17.5.41 1.2.03 1.85-.38.66-1.1.8-1.63.9-.1.02-.23.04-.33.07-.02.1-.05.23-.07.32-.1.53-.24 1.25-.9 1.63-.66.38-1.35.14-1.85-.03-.1-.03-.23-.08-.33-.1-.07.07-.15.17-.21.24-.35.41-.84.97-1.61.97Zm-1.72-3.23c.14 0 .28.02.43.06.54.14.9.56 1.19.9.03.04.06.08.1.12.04-.04.07-.08.1-.12.29-.34.65-.75 1.19-.9.55-.15 1.08.03 1.51.18.03.01.07.02.11.04 0-.04.02-.09.02-.12.08-.44.19-.99.59-1.39.4-.4.95-.51 1.39-.59.04 0 .08-.02.12-.02-.01-.04-.03-.08-.04-.11-.15-.43-.33-.96-.18-1.51.14-.54.56-.9.9-1.19l.12-.1-.12-.1c-.33-.29-.75-.65-.9-1.19-.15-.55.03-1.08.18-1.51.01-.03.02-.07.04-.11-.04 0-.08-.02-.12-.02-.44-.08-.99-.19-1.39-.59-.4-.4-.51-.95-.59-1.39 0-.04-.02-.08-.02-.12-.04.01-.08.03-.11.04-.43.15-.96.33-1.51.18-.54-.14-.9-.56-1.19-.9a1.06 1.06 0 0 0-.1-.12c-.04.04-.07.08-.1.12-.29.34-.65.75-1.19.9-.55.15-1.08-.04-1.51-.18-.03-.01-.07-.02-.11-.04 0 .04-.02.09-.02.12-.08.44-.19.99-.59 1.39-.4.4-.95.51-1.39.59-.04 0-.08.02-.12.02.01.04.03.08.04.11.15.43.33.96.18 1.51-.14.54-.56.9-.9 1.19l-.12.1.12.1c.33.29.75.65.9 1.19.15.55-.03 1.08-.18 1.51-.01.03-.02.07-.04.11.04 0 .08.02.12.02.44.08.99.19 1.39.59.4.4.51.95.59 1.39 0 .04.02.08.02.12.04-.01.08-.03.11-.04.31-.11.69-.24 1.08-.24Z"
        }),
        /* @__PURE__ */ jsx425("path", {
          d: "M12 14c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM8.42 22c-.34 0-.65-.17-.84-.46l-1.29-1.98-2.36-.17a.983.983 0 0 1-.81-.54c-.16-.31-.15-.68.03-.98L5.5 14c.29-.47.9-.62 1.37-.33.47.29.62.9.33 1.37l-1.5 2.47 1.23.09c.31.02.59.19.76.45l.7 1.07 1.29-2.11a.996.996 0 1 1 1.7 1.04l-2.11 3.46c-.18.29-.5.47-.84.48h-.01V22ZM15.58 22h-.02c-.35 0-.66-.19-.84-.49l-2.04-3.46c-.28-.48-.12-1.09.35-1.37s1.09-.12 1.37.35l1.22 2.07.68-1.05c.17-.26.45-.43.76-.45l1.25-.09-1.46-2.48c-.28-.48-.12-1.09.35-1.37s1.09-.12 1.37.35l2.28 3.87c.18.3.18.67.02.97a.98.98 0 0 1-.81.53l-2.36.17-1.29 1.98c-.18.28-.5.46-.84.46l.01.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx425("defs", {
      children: /* @__PURE__ */ jsx425("clipPath", {
        id: "medal_svg__a",
        children: /* @__PURE__ */ jsx425("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var Medal_default = SvgMedal;

// src/icons/generated/MenuHamburgerSquare.tsx
import { jsx as jsx426, jsxs as jsxs383 } from "react/jsx-runtime";
var SvgMenuHamburgerSquare = (props) => /* @__PURE__ */ jsxs383("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs383("g", {
      fill: "currentColor",
      clipPath: "url(#menu-hamburger-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx426("path", {
          d: "M17 13H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1ZM17 9H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1ZM17 17H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx426("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx426("defs", {
      children: /* @__PURE__ */ jsx426("clipPath", {
        id: "menu-hamburger-square_svg__a",
        children: /* @__PURE__ */ jsx426("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var MenuHamburgerSquare_default = SvgMenuHamburgerSquare;

// src/icons/generated/MenuHamburger.tsx
import { jsx as jsx427, jsxs as jsxs384 } from "react/jsx-runtime";
var SvgMenuHamburger = (props) => /* @__PURE__ */ jsxs384("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx427("g", {
      fill: "currentColor",
      clipPath: "url(#menu-hamburger_svg__a)",
      children: /* @__PURE__ */ jsx427("path", {
        d: "M21 19H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1ZM21 7H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1ZM21 13H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1Z"
      })
    }),
    /* @__PURE__ */ jsx427("defs", {
      children: /* @__PURE__ */ jsx427("clipPath", {
        id: "menu-hamburger_svg__a",
        children: /* @__PURE__ */ jsx427("path", {
          fill: "#fff",
          d: "M2 5h20v14H2z"
        })
      })
    })
  ]
});
var MenuHamburger_default = SvgMenuHamburger;

// src/icons/generated/MenuKebab.tsx
import { jsx as jsx428, jsxs as jsxs385 } from "react/jsx-runtime";
var SvgMenuKebab = (props) => /* @__PURE__ */ jsxs385("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx428("g", {
      fill: "currentColor",
      clipPath: "url(#menu-kebab_svg__a)",
      children: /* @__PURE__ */ jsx428("path", {
        d: "M12 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2ZM5 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2ZM19 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
      })
    }),
    /* @__PURE__ */ jsx428("defs", {
      children: /* @__PURE__ */ jsx428("clipPath", {
        id: "menu-kebab_svg__a",
        children: /* @__PURE__ */ jsx428("path", {
          fill: "#fff",
          d: "M3 10h18v4H3z"
        })
      })
    })
  ]
});
var MenuKebab_default = SvgMenuKebab;

// src/icons/generated/MenuMeatballs.tsx
import { jsx as jsx429, jsxs as jsxs386 } from "react/jsx-runtime";
var SvgMenuMeatballs = (props) => /* @__PURE__ */ jsxs386("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx429("g", {
      fill: "currentColor",
      clipPath: "url(#menu-meatballs_svg__a)",
      children: /* @__PURE__ */ jsx429("path", {
        d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      })
    }),
    /* @__PURE__ */ jsx429("defs", {
      children: /* @__PURE__ */ jsx429("clipPath", {
        id: "menu-meatballs_svg__a",
        children: /* @__PURE__ */ jsx429("path", {
          fill: "#fff",
          d: "M10 3h4v18h-4z"
        })
      })
    })
  ]
});
var MenuMeatballs_default = SvgMenuMeatballs;

// src/icons/generated/MinusSmall.tsx
import { jsx as jsx430, jsxs as jsxs387 } from "react/jsx-runtime";
var SvgMinusSmall = (props) => /* @__PURE__ */ jsxs387("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx430("g", {
      clipPath: "url(#minus-small_svg__a)",
      children: /* @__PURE__ */ jsx430("path", {
        fill: "currentColor",
        d: "M16 13H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Z"
      })
    }),
    /* @__PURE__ */ jsx430("defs", {
      children: /* @__PURE__ */ jsx430("clipPath", {
        id: "minus-small_svg__a",
        children: /* @__PURE__ */ jsx430("path", {
          fill: "#fff",
          d: "M7 11h10v2H7z"
        })
      })
    })
  ]
});
var MinusSmall_default = SvgMinusSmall;

// src/icons/generated/MinusSquare.tsx
import { jsx as jsx431, jsxs as jsxs388 } from "react/jsx-runtime";
var SvgMinusSquare = (props) => /* @__PURE__ */ jsxs388("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs388("g", {
      fill: "currentColor",
      clipPath: "url(#minus-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx431("path", {
          d: "M17 13H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx431("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx431("defs", {
      children: /* @__PURE__ */ jsx431("clipPath", {
        id: "minus-square_svg__a",
        children: /* @__PURE__ */ jsx431("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var MinusSquare_default = SvgMinusSquare;

// src/icons/generated/Minus.tsx
import { jsx as jsx432, jsxs as jsxs389 } from "react/jsx-runtime";
var SvgMinus = (props) => /* @__PURE__ */ jsxs389("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx432("g", {
      clipPath: "url(#minus_svg__a)",
      children: /* @__PURE__ */ jsx432("path", {
        fill: "currentColor",
        d: "M21 13H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1Z"
      })
    }),
    /* @__PURE__ */ jsx432("defs", {
      children: /* @__PURE__ */ jsx432("clipPath", {
        id: "minus_svg__a",
        children: /* @__PURE__ */ jsx432("path", {
          fill: "#fff",
          d: "M2 11h20v2H2z"
        })
      })
    })
  ]
});
var Minus_default = SvgMinus;

// src/icons/generated/MobilePhone.tsx
import { jsx as jsx433, jsxs as jsxs390 } from "react/jsx-runtime";
var SvgMobilePhone = (props) => /* @__PURE__ */ jsxs390("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs390("g", {
      fill: "currentColor",
      clipPath: "url(#mobile-phone_svg__a)",
      children: [
        /* @__PURE__ */ jsx433("path", {
          d: "M16 22H8c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v14c0 1.65-1.35 3-3 3ZM8 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H8Z"
        }),
        /* @__PURE__ */ jsx433("path", {
          d: "M14 5h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1ZM12 18c-.13 0-.26-.02-.38-.08-.13-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.2-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.1.09-.2.16-.33.21-.12.06-.25.08-.38.08Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx433("defs", {
      children: /* @__PURE__ */ jsx433("clipPath", {
        id: "mobile-phone_svg__a",
        children: /* @__PURE__ */ jsx433("path", {
          fill: "#fff",
          d: "M5 2h14v20H5z"
        })
      })
    })
  ]
});
var MobilePhone_default = SvgMobilePhone;

// src/icons/generated/Money.tsx
import { jsx as jsx434, jsxs as jsxs391 } from "react/jsx-runtime";
var SvgMoney = (props) => /* @__PURE__ */ jsxs391("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs391("g", {
      fill: "currentColor",
      clipPath: "url(#money_svg__a)",
      children: [
        /* @__PURE__ */ jsx434("path", {
          d: "M6.28 16.11c-1.22 0-2.34-.82-2.68-2.05L2.1 8.44c-.2-.71-.1-1.46.27-2.1.37-.64.97-1.1 1.68-1.29L15.08 2.1c1.48-.4 3 .48 3.39 1.96l1.5 5.61c.4 1.47-.48 3-1.96 3.39L6.98 16.02c-.24.06-.48.09-.72.09h.02ZM15.8 4c-.07 0-.13 0-.2.03L4.57 6.98a.77.77 0 0 0-.47.36.79.79 0 0 0-.08.58l1.5 5.61c.11.41.54.65.94.54l11.03-2.96c.2-.05.36-.18.47-.36.1-.18.13-.39.08-.58l-1.5-5.61a.768.768 0 0 0-.74-.57V4Z"
        }),
        /* @__PURE__ */ jsx434("path", {
          d: "M3.58 11.1c-.44 0-.85-.29-.96-.74a.994.994 0 0 1 .71-1.22l14.44-3.87a.994.994 0 0 1 1.22.71.994.994 0 0 1-.71 1.22L3.84 11.07c-.09.02-.17.03-.26.03ZM19 22c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        }),
        /* @__PURE__ */ jsx434("path", {
          d: "M14 20c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM7.5 21a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5Zm0-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx434("defs", {
      children: /* @__PURE__ */ jsx434("clipPath", {
        id: "money_svg__a",
        children: /* @__PURE__ */ jsx434("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Money_default = SvgMoney;

// src/icons/generated/MoodSmileHappy.tsx
import { jsx as jsx435 } from "react/jsx-runtime";
var SvgMoodSmileHappy = (props) => /* @__PURE__ */ jsx435("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx435("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12C2 6.49 6.49 2 12 2s10 4.49 10 10-4.49 10-10 10S2 17.51 2 12Zm2 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Zm6.45-1.11c-.15.08-.3.11-.45.11l.03-.01c-.37 0-.72-.2-.9-.55-.04-.07-.25-.2-.61-.2s-.58.13-.61.2c-.25.5-.85.7-1.34.45-.5-.25-.7-.85-.45-1.34.4-.8 1.32-1.3 2.39-1.3s1.99.5 2.39 1.3c.24.49.04 1.09-.45 1.34Zm7.44-1.34c-.4-.8-1.32-1.3-2.39-1.3s-1.99.5-2.39 1.3a.993.993 0 0 0 .45 1.34c.49.25 1.09.05 1.34-.45.03-.07.25-.2.61-.2s.57.13.61.2a1.007 1.007 0 0 0 1.35.44c.49-.25.69-.85.45-1.34l-.03.01Zm-7.63 4.79c.98.96 2.57.95 3.53-.04.39-.39 1.02-.4 1.42-.01.39.39.4 1.03.01 1.42a4.46 4.46 0 0 1-3.17 1.35H12c-1.19 0-2.3-.46-3.15-1.29-.39-.39-.4-1.03-.01-1.42.39-.39 1.02-.4 1.42-.01Z",
    clipRule: "evenodd"
  })
});
var MoodSmileHappy_default = SvgMoodSmileHappy;

// src/icons/generated/MountainsDown.tsx
import { jsx as jsx436, jsxs as jsxs392 } from "react/jsx-runtime";
var SvgMountainsDown = (props) => /* @__PURE__ */ jsxs392("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs392("g", {
      fill: "currentColor",
      clipPath: "url(#mountains-down_svg__a)",
      children: [
        /* @__PURE__ */ jsx436("path", {
          d: "M12 18a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx436("path", {
          d: "M12 18a1 1 0 0 1-.71-.29l-2.5-2.5a1.004 1.004 0 0 1 1.42-1.42l1.79 1.8 1.79-1.8a1.004 1.004 0 1 1 1.42 1.42l-2.5 2.5A1 1 0 0 1 12 18Z"
        }),
        /* @__PURE__ */ jsx436("path", {
          d: "M21 21H3a1 1 0 0 1-.93-1.37L6.69 8a2.38 2.38 0 0 1 2.05-1.53A2.2 2.2 0 0 1 10.2 7l1.22-2.54A2.42 2.42 0 0 1 13.55 3a2.36 2.36 0 0 1 2.1 1.5l6.27 15.12a1 1 0 0 1-.09.94.999.999 0 0 1-.83.44ZM4.47 19h15L13.82 5.28c-.09-.2-.22-.28-.3-.28-.1 0-.21.11-.29.28l-2 4.07a1 1 0 0 1-.88.56 1 1 0 0 1-.9-.52l-.38-.68c-.08-.15-.21-.25-.27-.24-.06.01-.21.09-.31.31L4.47 19Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx436("defs", {
      children: /* @__PURE__ */ jsx436("clipPath", {
        id: "mountains-down_svg__a",
        children: /* @__PURE__ */ jsx436("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var MountainsDown_default = SvgMountainsDown;

// src/icons/generated/MountainsGlacier.tsx
import { jsx as jsx437, jsxs as jsxs393 } from "react/jsx-runtime";
var SvgMountainsGlacier = (props) => /* @__PURE__ */ jsxs393("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx437("g", {
      clipPath: "url(#mountains-glacier_svg__a)",
      children: /* @__PURE__ */ jsx437("path", {
        fill: "currentColor",
        d: "M21 21h-7a1 1 0 0 1-1-.74l-.23-.87a3.26 3.26 0 0 1 .53-2.8 1.32 1.32 0 0 0 .15-1.39l-.1-.2h-2.86a3.239 3.239 0 0 1-.49 2.73 1.32 1.32 0 0 0-.22 1.09l.24.94a1 1 0 0 1-.554 1.153A1 1 0 0 1 9 21H3a1 1 0 0 1-.93-1.37L6.69 8a2.38 2.38 0 0 1 2-1.54A2.18 2.18 0 0 1 10.2 7l1.22-2.54A2.43 2.43 0 0 1 13.55 3a2.36 2.36 0 0 1 2.1 1.5l6.26 15.1a1 1 0 0 1-.09.94.999.999 0 0 1-.82.46Zm-6.23-2h4.73L13.82 5.3c-.1-.22-.22-.3-.3-.3-.1 0-.21.11-.29.28l-2 4.07a1 1 0 0 1-.88.56 1 1 0 0 1-.9-.52l-.38-.68c-.08-.15-.2-.25-.27-.24-.07.01-.21.09-.31.31L4.47 19h3.26a3.32 3.32 0 0 1 .62-2.47 1.27 1.27 0 0 0 .12-1.35l-.36-.73a1 1 0 0 1 0-1A1 1 0 0 1 9 13h5a1 1 0 0 1 .89.55l.38.75a3.3 3.3 0 0 1-.27 3.42 1.341 1.341 0 0 0-.25 1.15l.02.13Z"
      })
    }),
    /* @__PURE__ */ jsx437("defs", {
      children: /* @__PURE__ */ jsx437("clipPath", {
        id: "mountains-glacier_svg__a",
        children: /* @__PURE__ */ jsx437("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var MountainsGlacier_default = SvgMountainsGlacier;

// src/icons/generated/MountainsSlope.tsx
import { jsx as jsx438, jsxs as jsxs394 } from "react/jsx-runtime";
var SvgMountainsSlope = (props) => /* @__PURE__ */ jsxs394("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs394("g", {
      fill: "currentColor",
      clipPath: "url(#mountains-slope_svg__a)",
      children: [
        /* @__PURE__ */ jsx438("path", {
          d: "M21 21H3c-.34 0-.65-.17-.84-.45a.976.976 0 0 1-.08-.95L6.7 8.98c.39-.91 1.16-1.48 2.05-1.52.55-.01 1.04.15 1.46.48l1.22-2.53C11.85 4.53 12.7 4 13.55 4c.89.01 1.7.59 2.1 1.5l6.26 14.1c.14.31.11.67-.08.95-.18.28-.5.46-.84.46L21 21ZM4.53 19h14.94L13.83 6.31c-.1-.23-.23-.31-.3-.31-.1 0-.21.11-.29.28l-1.96 4.06c-.16.34-.5.56-.87.57-.38 0-.72-.19-.9-.52l-.37-.68c-.08-.15-.18-.25-.28-.24-.08 0-.21.09-.3.31L4.53 19Z"
        }),
        /* @__PURE__ */ jsx438("path", {
          d: "M17.56 21c-.55 0-1-.45-1-1 0-1.03-2.72-1.5-4.53-1.81-2.33-.41-4.35-.76-4.35-2.41 0-1.32 1.54-1.57 3.68-1.92l.83-.14c-.38-.1-.81-.2-1.22-.26a.996.996 0 0 1-.83-1.14.99.99 0 0 1 1.14-.83c2.71.42 4.09 1.24 4.09 2.43 0 1.32-1.54 1.57-3.68 1.92-.21.04-.47.08-.73.12.47.1.99.19 1.41.26 2.75.48 6.18 1.08 6.18 3.79 0 .55-.45 1-1 1l.01-.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx438("defs", {
      children: /* @__PURE__ */ jsx438("clipPath", {
        id: "mountains-slope_svg__a",
        children: /* @__PURE__ */ jsx438("path", {
          fill: "#fff",
          d: "M2 4h20v17H2z"
        })
      })
    })
  ]
});
var MountainsSlope_default = SvgMountainsSlope;

// src/icons/generated/MountainsUp.tsx
import { jsx as jsx439, jsxs as jsxs395 } from "react/jsx-runtime";
var SvgMountainsUp = (props) => /* @__PURE__ */ jsxs395("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs395("g", {
      fill: "currentColor",
      clipPath: "url(#mountains-up_svg__a)",
      children: [
        /* @__PURE__ */ jsx439("path", {
          d: "M12 18a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx439("path", {
          d: "M14.5 14.5a1 1 0 0 1-.71-.29L12 12.41l-1.79 1.8a1.004 1.004 0 1 1-1.42-1.42l2.5-2.5a1.001 1.001 0 0 1 1.42 0l2.5 2.5a.999.999 0 0 1-.71 1.71Z"
        }),
        /* @__PURE__ */ jsx439("path", {
          d: "M21 21H3a1 1 0 0 1-.93-1.37L6.69 8a2.38 2.38 0 0 1 2.05-1.54A2.16 2.16 0 0 1 10.2 7l1.22-2.54A2.41 2.41 0 0 1 13.55 3a2.36 2.36 0 0 1 2.1 1.5l6.27 15.12a1 1 0 0 1-.09.94A1 1 0 0 1 21 21ZM4.47 19h15L13.82 5.28c-.09-.2-.22-.28-.3-.28-.1 0-.21.11-.29.28l-2 4.07a1 1 0 0 1-.88.56 1 1 0 0 1-.9-.52l-.38-.68c-.08-.15-.22-.25-.27-.24-.05.01-.21.09-.31.31L4.47 19Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx439("defs", {
      children: /* @__PURE__ */ jsx439("clipPath", {
        id: "mountains-up_svg__a",
        children: /* @__PURE__ */ jsx439("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var MountainsUp_default = SvgMountainsUp;

// src/icons/generated/Mountains.tsx
import { jsx as jsx440, jsxs as jsxs396 } from "react/jsx-runtime";
var SvgMountains = (props) => /* @__PURE__ */ jsxs396("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx440("g", {
      clipPath: "url(#mountains_svg__a)",
      children: /* @__PURE__ */ jsx440("path", {
        fill: "currentColor",
        d: "M21 21H3c-.34 0-.65-.17-.84-.45a.976.976 0 0 1-.08-.95L6.7 8.98c.39-.91 1.16-1.47 2.05-1.52.53-.02 1.04.15 1.46.48l1.22-2.53C11.85 4.54 12.65 4 13.52 4h.03c.89.01 1.7.59 2.1 1.5l6.26 14.1c.14.31.11.67-.08.95-.18.28-.5.46-.84.46L21 21ZM4.53 19h14.94L13.83 6.31c-.1-.23-.23-.31-.3-.31-.06 0-.21.11-.3.28l-1.96 4.06c-.16.34-.5.56-.88.56-.34.02-.72-.19-.9-.52l-.37-.68c-.08-.15-.18-.24-.28-.24-.08 0-.21.09-.3.31L4.53 19Z"
      })
    }),
    /* @__PURE__ */ jsx440("defs", {
      children: /* @__PURE__ */ jsx440("clipPath", {
        id: "mountains_svg__a",
        children: /* @__PURE__ */ jsx440("path", {
          fill: "#fff",
          d: "M2 4h20v17H2z"
        })
      })
    })
  ]
});
var Mountains_default = SvgMountains;

// src/icons/generated/Mute.tsx
import { jsx as jsx441, jsxs as jsxs397 } from "react/jsx-runtime";
var SvgMute = (props) => /* @__PURE__ */ jsxs397("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx441("g", {
      fill: "currentColor",
      clipPath: "url(#mute_svg__a)",
      children: /* @__PURE__ */ jsx441("path", {
        d: "M10.21 20.86a1.81 1.81 0 0 1-1.55-.88l-3.15-4.05H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.51l3.16-4A1.84 1.84 0 0 1 11 3.2 1.79 1.79 0 0 1 12 5v13.86a1.79 1.79 0 0 1-1.49 1.98c-.1.017-.2.023-.3.02ZM4 9.93v4h2a1 1 0 0 1 .79.39L10 18.44v-13l-3.21 4.1a1 1 0 0 1-.79.39H4ZM20 14.93a1 1 0 0 1-.71-.29L18 13.34l-1.29 1.3a1.004 1.004 0 1 1-1.42-1.42l1.3-1.29-1.3-1.29a1.003 1.003 0 0 1 .326-1.638 1.004 1.004 0 0 1 1.094.218l1.29 1.3 1.29-1.3a1.004 1.004 0 0 1 1.42 1.42l-1.3 1.29 1.3 1.29a.999.999 0 0 1-.71 1.71Z"
      })
    }),
    /* @__PURE__ */ jsx441("defs", {
      children: /* @__PURE__ */ jsx441("clipPath", {
        id: "mute_svg__a",
        children: /* @__PURE__ */ jsx441("path", {
          fill: "#fff",
          d: "M2 3h19v17.87H2z"
        })
      })
    })
  ]
});
var Mute_default = SvgMute;

// src/icons/generated/NoImage.tsx
import { jsx as jsx442 } from "react/jsx-runtime";
var SvgNoImage = (props) => /* @__PURE__ */ jsx442("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx442("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.94 19.52s-.05-.1-.1-.14a.268.268 0 0 0-.076-.05c-.019-.008-.037-.017-.054-.03L4.74 3.33c-.016-.024-.029-.048-.042-.072a.598.598 0 0 0-.068-.108.902.902 0 0 0-.2-.14l-.72-.72c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.03 0 1.42l.27.27c-.36.61-.57 1.29-.57 2.02v12c0 2.21 1.79 4 4 4h12c.71 0 1.41-.21 2.01-.57l.27.27c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-.77-.77h.02ZM18 20H6c-1.1 0-2-.9-2-2v-.59l4.36-4.36a.996.996 0 1 0-1.41-1.41L4 14.59V6c0-.18.03-.35.07-.51l14.44 14.44c-.17.04-.34.08-.51.08V20Zm0-18H7c-.55 0-1 .45-1 1s.45 1 1 1h11c1.1 0 2 .9 2 2v8.59l-1.31-1.31c-.37-.35-.77-.61-1.2-.77a1 1 0 0 0-1.28.59c-.19.51.08 1.09.59 1.28.17.06.34.17.49.32l3 3c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08A1.019 1.019 0 0 0 22 17V6c0-2.21-1.79-4-4-4Zm-2 3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3Zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z",
    clipRule: "evenodd"
  })
});
var NoImage_default = SvgNoImage;

// src/icons/generated/OnePersonCircle.tsx
import { jsx as jsx443, jsxs as jsxs398 } from "react/jsx-runtime";
var SvgOnePersonCircle = (props) => /* @__PURE__ */ jsxs398("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs398("g", {
      fill: "currentColor",
      clipPath: "url(#one-person-circle_svg__a)",
      children: [
        /* @__PURE__ */ jsx443("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx443("path", {
          d: "M18.16 18.96c-.55 0-1-.45-1-1 0-1.08-1.15-1.96-2.56-1.96H9.4c-1.41 0-2.56.88-2.56 1.96 0 .55-.45 1-1 1s-1-.45-1-1C4.84 15.78 6.88 14 9.4 14h5.2c2.51 0 4.56 1.78 4.56 3.96 0 .55-.45 1-1 1ZM12 13.5c-1.81 0-3.3-1.44-3.4-3.27l-.09-1.69C8.51 6.56 10.05 5 11.93 5h.15c1.89 0 3.43 1.56 3.43 3.49l-.1 1.74c-.1 1.83-1.6 3.27-3.4 3.27H12ZM11.93 7c-.79 0-1.43.67-1.43 1.49l.09 1.63c.04.78.66 1.38 1.41 1.38.75 0 1.37-.61 1.41-1.38l.09-1.69c0-.76-.64-1.43-1.43-1.43h-.15.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx443("defs", {
      children: /* @__PURE__ */ jsx443("clipPath", {
        id: "one-person-circle_svg__a",
        children: /* @__PURE__ */ jsx443("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var OnePersonCircle_default = SvgOnePersonCircle;

// src/icons/generated/OnePersonTravelling.tsx
import { jsx as jsx444, jsxs as jsxs399 } from "react/jsx-runtime";
var SvgOnePersonTravelling = (props) => /* @__PURE__ */ jsxs399("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs399("g", {
      fill: "currentColor",
      clipPath: "url(#one-person-travelling_svg__a)",
      children: [
        /* @__PURE__ */ jsx444("path", {
          d: "M8 22a1 1 0 0 1-1-1v-5a1 1 0 0 1 .29-.71l.71-.71V11H5v3.58l.71.71A1 1 0 0 1 6 16v5a1 1 0 1 1-2 0v-4.59l-.71-.71A1 1 0 0 1 3 15v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4a1 1 0 0 1-.29.7l-.71.71V21a1 1 0 0 1-1 1ZM6.5 8A2.54 2.54 0 0 1 4 5.62v-1a2.53 2.53 0 0 1 3.444-2.452A2.55 2.55 0 0 1 9.08 4.52L9 5.62A2.54 2.54 0 0 1 6.5 8Zm0-4c-.39 0-.63.23-.63.52l.06 1a.52.52 0 0 0 1 0l.06-1A.52.52 0 0 0 6.55 4H6.5ZM18.34 21.1h-4.68A2.66 2.66 0 0 1 11 18.44v-3.68a2.66 2.66 0 0 1 2.66-2.66h4.68A2.66 2.66 0 0 1 21 14.76v3.68a2.66 2.66 0 0 1-2.66 2.66Zm-4.68-7a.651.651 0 0 0-.66.66v3.68a.65.65 0 0 0 .66.66h4.68a.65.65 0 0 0 .66-.66v-3.68a.651.651 0 0 0-.66-.66h-4.68Z"
        }),
        /* @__PURE__ */ jsx444("path", {
          d: "M14 22.1a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1ZM18 22.1a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1ZM16 13.1a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx444("path", {
          d: "M18 11.1h-4a1 1 0 0 1 0-2h4a1 1 0 1 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx444("defs", {
      children: /* @__PURE__ */ jsx444("clipPath", {
        id: "one-person-travelling_svg__a",
        children: /* @__PURE__ */ jsx444("path", {
          fill: "#fff",
          d: "M3 2h18v20.1H3z"
        })
      })
    })
  ]
});
var OnePersonTravelling_default = SvgOnePersonTravelling;

// src/icons/generated/OnePerson.tsx
import { jsx as jsx445, jsxs as jsxs400 } from "react/jsx-runtime";
var SvgOnePerson = (props) => /* @__PURE__ */ jsxs400("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs400("g", {
      fill: "currentColor",
      clipPath: "url(#one-person_svg__a)",
      children: [
        /* @__PURE__ */ jsx445("path", {
          d: "M12 12.41c-2.22 0-4.06-1.74-4.19-3.96l-.12-2.18C7.69 3.89 9.58 2 11.9 2h.19c2.32 0 4.21 1.89 4.21 4.22l-.13 2.24a4.192 4.192 0 0 1-4.19 3.96l.02-.01ZM11.9 4c-1.22 0-2.21.99-2.21 2.22l.12 2.12A2.2 2.2 0 0 0 12 10.41a2.2 2.2 0 0 0 2.19-2.07l.12-2.18c0-1.17-1-2.16-2.22-2.16h-.19Z"
        }),
        /* @__PURE__ */ jsx445("path", {
          d: "M21 22H3c-.55 0-1-.45-1-1v-4c0-2.76 2.24-5 5-5h10c2.76 0 5 2.24 5 5v4c0 .55-.45 1-1 1ZM4 20h16v-3c0-1.65-1.35-3-3-3H7c-1.65 0-3 1.35-3 3v3Z"
        }),
        /* @__PURE__ */ jsx445("path", {
          d: "M7 22c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1ZM17 22c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx445("defs", {
      children: /* @__PURE__ */ jsx445("clipPath", {
        id: "one-person_svg__a",
        children: /* @__PURE__ */ jsx445("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var OnePerson_default = SvgOnePerson;

// src/icons/generated/OptionalFacilities.tsx
import { jsx as jsx446, jsxs as jsxs401 } from "react/jsx-runtime";
var SvgOptionalFacilities = (props) => /* @__PURE__ */ jsxs401("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs401("g", {
      fill: "currentColor",
      clipPath: "url(#optional-facilities_svg__a)",
      children: [
        /* @__PURE__ */ jsx446("path", {
          d: "M13.64 22a3 3 0 0 1-2.14-.89L3.39 13a3 3 0 0 1-.89-2.14V7a4 4 0 0 1 4-4h3.86a3 3 0 0 1 2.14.88L20.61 12a3 3 0 0 1 0 4.28l-4.83 4.83a3 3 0 0 1-2.14.89ZM6.5 5a2 2 0 0 0-2 2v3.86a1 1 0 0 0 .3.72l8.12 8.12a1 1 0 0 0 1.45 0l4.83-4.83a1.002 1.002 0 0 0 0-1.45L11.08 5.3a1 1 0 0 0-.72-.3H6.5Z"
        }),
        /* @__PURE__ */ jsx446("path", {
          d: "M13.41 16.54h-.44a4.8 4.8 0 0 1-2.83-1.4c-1.7-1.7-1.91-4.25-.47-5.69a3.35 3.35 0 0 1 2.29-1 1 1 0 1 1 0 2 1.38 1.38 0 0 0-.94.37c-.65.65-.43 2 .48 2.86a2.83 2.83 0 0 0 1.63.84 1.55 1.55 0 0 0 1.23-.36 1.42 1.42 0 0 0 .37-.94 1 1 0 0 1 2 0 3.279 3.279 0 0 1-3.38 3.25l.06.07Z"
        }),
        /* @__PURE__ */ jsx446("path", {
          d: "M9.66 15.16a1 1 0 0 1-.71-1.71l1.9-1.9A1.015 1.015 0 0 1 12.27 13l-1.9 1.9a1 1 0 0 1-.71.26Z"
        }),
        /* @__PURE__ */ jsx446("path", {
          d: "M11.09 16.59a.998.998 0 0 1-.71-.3 1 1 0 0 1 0-1.41l1.9-1.9a1 1 0 0 1 1.41 1.41l-1.9 1.9a1 1 0 0 1-.7.3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx446("defs", {
      children: /* @__PURE__ */ jsx446("clipPath", {
        id: "optional-facilities_svg__a",
        children: /* @__PURE__ */ jsx446("path", {
          fill: "#fff",
          d: "M2.5 3h19v19h-19z"
        })
      })
    })
  ]
});
var OptionalFacilities_default = SvgOptionalFacilities;

// src/icons/generated/Order.tsx
import { jsx as jsx447, jsxs as jsxs402 } from "react/jsx-runtime";
var SvgOrder = (props) => /* @__PURE__ */ jsxs402("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs402("g", {
      fill: "currentColor",
      clipPath: "url(#order_svg__a)",
      children: [
        /* @__PURE__ */ jsx447("path", {
          d: "M7 22a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v17a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx447("path", {
          d: "M10 7a1 1 0 0 1-.71-.29L7 4.41l-2.29 2.3a1.004 1.004 0 0 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0l3 3a.998.998 0 0 1 0 1.42A.999.999 0 0 1 10 7ZM17 21a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v17a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx447("path", {
          d: "M17 22a1 1 0 0 1-.71-.29l-3-3a1.004 1.004 0 1 1 1.42-1.42l2.29 2.3 2.29-2.3a1.007 1.007 0 0 1 1.42 0 1.003 1.003 0 0 1 0 1.42l-3 3A1 1 0 0 1 17 22Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx447("defs", {
      children: /* @__PURE__ */ jsx447("clipPath", {
        id: "order_svg__a",
        children: /* @__PURE__ */ jsx447("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var Order_default = SvgOrder;

// src/icons/generated/Parking.tsx
import { jsx as jsx448, jsxs as jsxs403 } from "react/jsx-runtime";
var SvgParking = (props) => /* @__PURE__ */ jsxs403("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs403("g", {
      fill: "currentColor",
      clipPath: "url(#parking_svg__a)",
      children: [
        /* @__PURE__ */ jsx448("path", {
          d: "M13 8H9c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1ZM13 13H9c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx448("path", {
          d: "M9 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx448("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        }),
        /* @__PURE__ */ jsx448("path", {
          d: "M13 13c-.55 0-1-.45-1-1s.45-1 1-1 1-.45 1-1V9c0-.55-.45-1-1-1s-1-.45-1-1 .45-1 1-1c1.65 0 3 1.35 3 3v1c0 1.65-1.35 3-3 3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx448("defs", {
      children: /* @__PURE__ */ jsx448("clipPath", {
        id: "parking_svg__a",
        children: /* @__PURE__ */ jsx448("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Parking_default = SvgParking;

// src/icons/generated/Pause.tsx
import { jsx as jsx449, jsxs as jsxs404 } from "react/jsx-runtime";
var SvgPause = (props) => /* @__PURE__ */ jsxs404("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx449("g", {
      fill: "currentColor",
      clipPath: "url(#pause_svg__a)",
      children: /* @__PURE__ */ jsx449("path", {
        d: "M9 20H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2ZM7 6v12h2V6H7ZM17 20h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2ZM15 6v12h2V6h-2Z"
      })
    }),
    /* @__PURE__ */ jsx449("defs", {
      children: /* @__PURE__ */ jsx449("clipPath", {
        id: "pause_svg__a",
        children: /* @__PURE__ */ jsx449("path", {
          fill: "#fff",
          d: "M5 4h14v16H5z"
        })
      })
    })
  ]
});
var Pause_default = SvgPause;

// src/icons/generated/PdfFile.tsx
import { jsx as jsx450, jsxs as jsxs405 } from "react/jsx-runtime";
var SvgPdfFile = (props) => /* @__PURE__ */ jsxs405("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs405("g", {
      fill: "currentColor",
      clipPath: "url(#pdf-file_svg__a)",
      children: [
        /* @__PURE__ */ jsx450("path", {
          d: "M20 22H4a1 1 0 0 1-1-1V7a1 1 0 0 1 .29-.71l4-4A1 1 0 0 1 8 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM5 20h14V4H8.41L5 7.41V20Z"
        }),
        /* @__PURE__ */ jsx450("path", {
          d: "M8 8H4a1 1 0 0 1 0-2h3V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1ZM5.91 10.62H8.1c1.28 0 1.86.76 1.86 2v.49c0 1.36-.53 2.09-1.89 2.09h-.41V18H5.91v-7.38Zm1.75 3.17h.14c.29 0 .39-.14.39-.58v-.79c0-.4-.15-.5-.4-.5h-.13v1.87ZM10.46 10.62h1.92c1.44 0 2.13.56 2.13 2.27v2.69c0 1.53-.39 2.37-1.88 2.37h-2.17v-7.33Zm1.75 6h.16c.27 0 .37-.15.37-.48v-3.73c0-.39-.14-.48-.38-.48h-.15v4.69ZM15.06 10.62h3.23v1.44h-1.48v1.43h1.36v1.45h-1.36v3h-1.75v-7.32Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx450("defs", {
      children: /* @__PURE__ */ jsx450("clipPath", {
        id: "pdf-file_svg__a",
        children: /* @__PURE__ */ jsx450("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var PdfFile_default = SvgPdfFile;

// src/icons/generated/Pearl.tsx
import { jsx as jsx451, jsxs as jsxs406 } from "react/jsx-runtime";
var SvgPearl = (props) => /* @__PURE__ */ jsxs406("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs406("g", {
      fill: "currentColor",
      clipPath: "url(#pearl_svg__a)",
      children: [
        /* @__PURE__ */ jsx451("path", {
          d: "M12 19a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
        }),
        /* @__PURE__ */ jsx451("path", {
          d: "M12 23a4 4 0 0 1-2.83-1.18A3.86 3.86 0 0 1 8 22a4 4 0 0 1-3.45-2H4.5A3.5 3.5 0 0 1 1 16.5a3.57 3.57 0 0 1 .12-.88l.06-.18c.37-.88 3.76-2.2 5.55-2.69a1 1 0 0 1 1.23.7 1 1 0 0 1-.69 1.22c-1.488.406-2.922.99-4.27 1.74v.09A1.5 1.5 0 0 0 4.5 18c.132-.003.263-.023.39-.06a1 1 0 0 1 1.22.66 2 2 0 0 0 2.87 1.13 1 1 0 0 1 1.34.34A2 2 0 0 0 12 21a2 2 0 0 0 1.68-.93 1 1 0 0 1 1.34-.34 2 2 0 0 0 2.87-1.13 1 1 0 0 1 1.22-.66c.127.037.258.057.39.06a1.5 1.5 0 0 0 1.5-1.5v-.09a19.15 19.15 0 0 0-4.27-1.74 1 1 0 0 1-.515-1.57.999.999 0 0 1 1.055-.35c1.79.49 5.18 1.81 5.55 2.69l.06.18c.076.287.117.583.12.88a3.5 3.5 0 0 1-3.5 3.5h-.05A4 4 0 0 1 16 22a3.86 3.86 0 0 1-1.17-.18A3.998 3.998 0 0 1 12 23Z"
        }),
        /* @__PURE__ */ jsx451("path", {
          d: "M7 14.41a1.06 1.06 0 0 1-.51-.14c-1-.57-1.83-1.19-2.53-1.69-.44-.34-.9-.65-1.38-.93a2.76 2.76 0 0 1-1.437-2.83 2.6 2.6 0 0 1 .387-1.01 4.38 4.38 0 0 1 .57-.7 3.4 3.4 0 0 1 2-1.08 4 4 0 0 1 3.88-3 3.15 3.15 0 0 1 .53 0 4 4 0 0 1 3.47-2 4 4 0 0 1 3.47 2 3.15 3.15 0 0 1 .53 0 4 4 0 0 1 3.88 3 3.28 3.28 0 0 1 1.88.94c.21.205.404.425.58.66a2.72 2.72 0 0 1-.04 3.28 2.75 2.75 0 0 1-.89.75c-.33.18-.82.53-1.39.93s-1.56 1.13-2.51 1.69a.998.998 0 0 1-1.37-.36 1 1 0 0 1 .35-1.37 27.543 27.543 0 0 0 2.36-1.58 15.57 15.57 0 0 1 1.63-1.08.71.71 0 0 0 .37-.48.73.73 0 0 0-.12-.6 4.27 4.27 0 0 0-.37-.41 1.27 1.27 0 0 0-.72-.38 1.36 1.36 0 0 0-.45 0 1 1 0 0 1-.83-.2 1 1 0 0 1-.36-.78V7a2 2 0 0 0-2-2 1.92 1.92 0 0 0-.74.15 1.06 1.06 0 0 1-.82 0 1 1 0 0 1-.52-.64A2 2 0 0 0 12 3a2 2 0 0 0-1.92 1.48 1 1 0 0 1-.52.64 1.06 1.06 0 0 1-.82 0A1.92 1.92 0 0 0 8 5a2 2 0 0 0-2 2v.09a1 1 0 0 1-.36.78 1 1 0 0 1-.84.2 1.24 1.24 0 0 0-.27 0 1.44 1.44 0 0 0-1 .5 2.24 2.24 0 0 0-.33.4.63.63 0 0 0-.08.5.83.83 0 0 0 .38.48c.564.32 1.105.677 1.62 1.07.765.574 1.56 1.108 2.38 1.6a1 1 0 0 1 .35 1.37 1 1 0 0 1-.85.42Z"
        }),
        /* @__PURE__ */ jsx451("path", {
          d: "M17 14.71a1 1 0 0 1-1-1v-.3a1 1 0 0 1 2 0v.3a1 1 0 0 1-1 1ZM7 14.71a1 1 0 0 1-1-1v-.3a1 1 0 0 1 2 0v.3a1 1 0 0 1-1 1ZM10 14a1 1 0 0 1-1-1 3 3 0 0 1 3-3 1 1 0 0 1 0 2 1 1 0 0 0-1 1 1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx451("defs", {
      children: /* @__PURE__ */ jsx451("clipPath", {
        id: "pearl_svg__a",
        children: /* @__PURE__ */ jsx451("path", {
          fill: "#fff",
          d: "M1 1h22v22H1z"
        })
      })
    })
  ]
});
var Pearl_default = SvgPearl;

// src/icons/generated/Pencil.tsx
import { jsx as jsx452, jsxs as jsxs407 } from "react/jsx-runtime";
var SvgPencil = (props) => /* @__PURE__ */ jsxs407("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx452("g", {
      clipPath: "url(#pencil_svg__a)",
      children: /* @__PURE__ */ jsx452("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.497 3.737a3.83 3.83 0 0 0-2.704 1.056l-.999.999-.001.001-.001.001-9.5 9.499A1 1 0 0 0 3 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l9.5-9.5 1-1a3.83 3.83 0 0 0-2.71-6.47ZM17.5 9.086l.28-.28a1.83 1.83 0 0 0-2.586-2.586l-.28.28L17.5 9.086Zm-4-1.172 2.586 2.586-8.5 8.5H5v-2.586l8.5-8.5Z",
        clipRule: "evenodd"
      })
    }),
    /* @__PURE__ */ jsx452("defs", {
      children: /* @__PURE__ */ jsx452("clipPath", {
        id: "pencil_svg__a",
        children: /* @__PURE__ */ jsx452("path", {
          fill: "#fff",
          d: "M3 3.67h17.33V21H3z"
        })
      })
    })
  ]
});
var Pencil_default = SvgPencil;

// src/icons/generated/Phone.tsx
import { jsx as jsx453, jsxs as jsxs408 } from "react/jsx-runtime";
var SvgPhone = (props) => /* @__PURE__ */ jsxs408("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx453("g", {
      clipPath: "url(#phone_svg__a)",
      children: /* @__PURE__ */ jsx453("path", {
        fill: "currentColor",
        d: "M18.88 22A18 18 0 0 1 2 5.18 3.14 3.14 0 0 1 5.12 2h4.23a1 1 0 0 1 .93.63l2.12 5.29a1 1 0 0 1-.4 1.23l-1.84 1.1a10.81 10.81 0 0 0 3.59 3.59l1.1-1.84a1 1 0 0 1 1.23-.41l5.29 2.12a1 1 0 0 1 .63.93v4.23A3.12 3.12 0 0 1 18.88 22ZM5.12 4A1.12 1.12 0 0 0 4 5.12 15.94 15.94 0 0 0 18.94 20 1.11 1.11 0 0 0 20 18.88v-3.56l-3.88-1.55L15 15.69a1 1 0 0 1-1.3.38 12.73 12.73 0 0 1-5.78-5.74A1 1 0 0 1 8.31 9l1.91-1.12L8.67 4H5.12Z"
      })
    }),
    /* @__PURE__ */ jsx453("defs", {
      children: /* @__PURE__ */ jsx453("clipPath", {
        id: "phone_svg__a",
        children: /* @__PURE__ */ jsx453("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Phone_default = SvgPhone;

// src/icons/generated/PigMoney.tsx
import { jsx as jsx454 } from "react/jsx-runtime";
var SvgPigMoney = (props) => /* @__PURE__ */ jsx454("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx454("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.33 10H20v.01c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-.67c-.34.7-.79 1.34-1.33 1.9v1.6a2.5 2.5 0 0 1-4.95.5h-4.1a2.5 2.5 0 0 1-4.95-.5v-1.6c-2.56-2.6-2.69-6.8-.22-9.56-.39-.53-.65-1.15-.74-1.82a3.98 3.98 0 0 1 .79-2.96 3.96 3.96 0 0 1 2.65-1.53c1.06-.15 2.11.14 2.96.79C10.45 3.6 11 4.78 11 6h.2l4.25-2.83c.31-.2.71-.22 1.03-.05.33.17.53.51.53.88v3.26c.99.69 1.8 1.64 2.32 2.74ZM8.21 4.41c-.87-.67-2.13-.5-2.8.37h.01c-.33.43-.47.95-.4 1.48.04.29.14.56.29.8A6.952 6.952 0 0 1 8.99 6c0-.61-.28-1.2-.78-1.59Zm9.51 10.26c.14-.4.52-.67.94-.67H20l.02.01v-2h-1.34c-.42 0-.8-.27-.94-.67a5.036 5.036 0 0 0-2.22-2.67c-.31-.18-.5-.51-.5-.87V5.86l-2.95 1.96c-.16.11-.35.17-.55.17h-2.5c-1.42 0-2.78.61-3.73 1.67a5.009 5.009 0 0 0 .4 7.06c.21.19.33.47.33.75v2.03c0 .28.22.5.5.5s.5-.22.5-.5v-.58c0-.29.12-.57.35-.76.22-.19.52-.27.81-.22.203.036.396.046.598.057.075.003.153.008.232.013h4c.28.01.55-.02.83-.07.06-.01.11-.01.17-.01.24 0 .47.09.65.24.22.19.35.47.35.76v.58c0 .28.22.5.5.5s.5-.22.5-.5v-2.03c0-.29.12-.56.33-.75a5.07 5.07 0 0 0 1.38-2.06ZM14 11.02c0-.56.45-1.01 1-1.01a1.005 1.005 0 0 1 0 2.01c-.55 0-1-.44-1-1Z",
    clipRule: "evenodd"
  })
});
var PigMoney_default = SvgPigMoney;

// src/icons/generated/PinGroup.tsx
import { jsx as jsx455, jsxs as jsxs409 } from "react/jsx-runtime";
var SvgPinGroup = (props) => /* @__PURE__ */ jsxs409("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs409("g", {
      fill: "currentColor",
      clipPath: "url(#pin-group_svg__a)",
      children: [
        /* @__PURE__ */ jsx455("path", {
          d: "M6 12c-.24 0-.49-.09-.68-.26C4.98 11.43 2 8.6 2 6c0-2.13 1.87-4 4-4s4 1.87 4 4c0 2.6-2.98 5.42-3.32 5.74-.19.18-.43.26-.68.26Zm0-8C4.86 4 4 5.06 4 6c0 1.12 1.15 2.63 2 3.57C6.95 8.53 8 7.04 8 6c0-.94-.86-2-2-2Z"
        }),
        /* @__PURE__ */ jsx455("path", {
          d: "M6 7c-.13 0-.26-.03-.38-.08-.13-.05-.23-.12-.33-.21C5.11 6.52 5 6.26 5 6c0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.19.19.29.45.29.71 0 .26-.1.52-.29.71-.09.09-.2.16-.33.21-.12.05-.25.08-.38.08ZM18 15c-.24 0-.49-.09-.68-.26C16.98 14.43 14 11.6 14 9c0-2.13 1.87-4 4-4s4 1.87 4 4c0 2.6-2.98 5.42-3.32 5.74-.19.18-.43.26-.68.26Zm0-8c-1.14 0-2 1.06-2 2 0 1.12 1.15 2.63 2 3.57.95-1.04 2-2.53 2-3.57 0-.94-.86-2-2-2Z"
        }),
        /* @__PURE__ */ jsx455("path", {
          d: "M18 10c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.12.05.23.12.33.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.1.09-.21.16-.33.21-.12.05-.25.08-.38.08ZM9 22c-.24 0-.49-.09-.68-.26C7.98 21.43 5 18.6 5 16c0-2.13 1.87-4 4-4s4 1.87 4 4c0 2.6-2.98 5.42-3.32 5.74-.19.18-.43.26-.68.26Zm0-8c-1.14 0-2 1.06-2 2 0 1.12 1.15 2.63 2 3.57.95-1.04 2-2.53 2-3.57 0-.94-.86-2-2-2Z"
        }),
        /* @__PURE__ */ jsx455("path", {
          d: "M9 17c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.21c-.04-.05-.08-.1-.12-.16a.556.556 0 0 1-.09-.17.636.636 0 0 1-.06-.18c0-.07-.02-.13-.02-.2 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.09.1.16.21.21.33.06.12.08.25.08.38 0 .26-.11.52-.29.71-.1.09-.2.16-.33.21-.12.05-.25.08-.38.08ZM11 10c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.06 0-.13.02-.19.01-.07.03-.13.06-.19.02-.06.05-.12.09-.17.04-.06.08-.11.12-.16.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.04.05.09.1.12.16.04.05.07.11.09.17.03.06.05.12.06.19.02.06.02.13.02.19 0 .26-.1.52-.29.71-.1.09-.2.16-.33.21-.12.06-.25.08-.38.08ZM13 12c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.21c-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.36-.15.81-.06 1.09.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29ZM14 22c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.36-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29ZM18 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21a1 1 0 0 1 .76 0c.13.05.23.12.33.21.18.19.29.45.29.71 0 .26-.11.52-.29.71-.1.09-.21.16-.33.21-.12.06-.25.08-.38.08ZM16 20c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.37-.16.81-.07 1.09.21.19.19.29.45.29.71 0 .26-.1.52-.29.71-.19.18-.45.29-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx455("defs", {
      children: /* @__PURE__ */ jsx455("clipPath", {
        id: "pin-group_svg__a",
        children: /* @__PURE__ */ jsx455("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var PinGroup_default = SvgPinGroup;

// src/icons/generated/PinInfo.tsx
import { jsx as jsx456, jsxs as jsxs410 } from "react/jsx-runtime";
var SvgPinInfo = (props) => /* @__PURE__ */ jsxs410("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs410("g", {
      fill: "currentColor",
      clipPath: "url(#pin-info_svg__a)",
      children: [
        /* @__PURE__ */ jsx456("path", {
          d: "M12 22a1 1 0 0 1-.72-.3C10.54 20.93 4 14.07 4 10a8 8 0 0 1 16 0c0 4.12-6.54 11-7.28 11.75A1 1 0 0 1 12 22Zm0-18a6 6 0 0 0-6 6c0 2.5 3.84 7.22 6 9.59 2.16-2.37 6-7.09 6-9.59a6 6 0 0 0-6-6Z"
        }),
        /* @__PURE__ */ jsx456("path", {
          d: "M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx456("path", {
          d: "M12 10h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2ZM14 15h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2ZM12 7h-.2a.64.64 0 0 1-.18-.06.761.761 0 0 1-.18-.09 1.59 1.59 0 0 1-.15-.12 1.152 1.152 0 0 1-.21-.33A1.001 1.001 0 0 1 11 6a1.05 1.05 0 0 1 .29-.71l.15-.12a.761.761 0 0 1 .18-.09.64.64 0 0 1 .18-.08.9.9 0 0 1 .4 0 .64.64 0 0 1 .18.06.758.758 0 0 1 .18.09l.15.12a1 1 0 0 1 .21.33 1 1 0 0 1 0 .78 1 1 0 0 1-.21.33 1.575 1.575 0 0 1-.15.12.758.758 0 0 1-.18.09.64.64 0 0 1-.18.06L12 7Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx456("defs", {
      children: /* @__PURE__ */ jsx456("clipPath", {
        id: "pin-info_svg__a",
        children: /* @__PURE__ */ jsx456("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var PinInfo_default = SvgPinInfo;

// src/icons/generated/PinMap.tsx
import { jsx as jsx457, jsxs as jsxs411 } from "react/jsx-runtime";
var SvgPinMap = (props) => /* @__PURE__ */ jsxs411("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs411("g", {
      fill: "currentColor",
      clipPath: "url(#pin-map_svg__a)",
      children: [
        /* @__PURE__ */ jsx457("path", {
          d: "M12 18c-.3 0-.58-.13-.77-.36C10.69 17 6 11.27 6 8c0-3.53 2.47-6 6-6s6 2.47 6 6c0 3.27-4.7 9-5.23 9.64-.19.23-.47.36-.77.36Zm0-14C9.57 4 8 5.57 8 8c0 1.67 2.21 5.08 4 7.4 1.79-2.32 4-5.73 4-7.4 0-2.43-1.57-4-4-4Z"
        }),
        /* @__PURE__ */ jsx457("path", {
          d: "M12 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        }),
        /* @__PURE__ */ jsx457("path", {
          d: "M21 22c-.13 0-.26-.03-.39-.08l-4.11-1.73-4.11 1.73c-.25.1-.53.1-.78 0L7.5 20.19l-4.11 1.73a1.004 1.004 0 0 1-1.34-1.24l2.84-8.52c.08-.25.26-.46.5-.58l1.9-.95a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-1.53.76-2.01 6.04 2.47-1.04c.25-.1.53-.1.78 0L12 19.91l4.11-1.73c.25-.1.53-.1.78 0l2.47 1.04-2.01-6.04-1.53-.76a1.01 1.01 0 0 1-.45-1.34c.25-.49.85-.7 1.34-.45l1.9.95c.24.12.42.33.5.58l2.84 8.53a1.008 1.008 0 0 1-.95 1.32V22Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx457("defs", {
      children: /* @__PURE__ */ jsx457("clipPath", {
        id: "pin-map_svg__a",
        children: /* @__PURE__ */ jsx457("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var PinMap_default = SvgPinMap;

// src/icons/generated/Pin.tsx
import { jsx as jsx458, jsxs as jsxs412 } from "react/jsx-runtime";
var SvgPin = (props) => /* @__PURE__ */ jsxs412("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs412("g", {
      fill: "currentColor",
      clipPath: "url(#pin_svg__a)",
      children: [
        /* @__PURE__ */ jsx458("path", {
          d: "M12 22c-.27 0-.53-.11-.72-.3C10.53 20.93 4 14.07 4 9.95 4 5.57 7.59 2 12 2s8 3.57 8 7.95c0 4.12-6.54 10.98-7.28 11.75-.19.19-.45.3-.72.3Zm0-18C8.69 4 6 6.67 6 9.95c0 2.5 3.84 7.22 6 9.59 2.16-2.37 6-7.09 6-9.59C18 6.67 15.31 4 12 4Z"
        }),
        /* @__PURE__ */ jsx458("path", {
          d: "M12 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx458("defs", {
      children: /* @__PURE__ */ jsx458("clipPath", {
        id: "pin_svg__a",
        children: /* @__PURE__ */ jsx458("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Pin_default = SvgPin;

// src/icons/generated/Pinterest.tsx
import { jsx as jsx459, jsxs as jsxs413 } from "react/jsx-runtime";
var SvgPinterest = (props) => /* @__PURE__ */ jsxs413("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs413("g", {
      fill: "currentColor",
      clipPath: "url(#pinterest_svg__a)",
      children: [
        /* @__PURE__ */ jsx459("path", {
          d: "M8 21a1.002 1.002 0 0 1-.91-1.41l4-9a.998.998 0 0 1 1.674-.32 1 1 0 0 1 .146 1.14l-4 9A1 1 0 0 1 8 21Z"
        }),
        /* @__PURE__ */ jsx459("path", {
          d: "M13.25 17a3.71 3.71 0 0 1-3.5-2.67 1.006 1.006 0 1 1 1.9-.66 1.74 1.74 0 0 0 1.6 1.33A2.76 2.76 0 0 0 16 12a4 4 0 0 0-2.469-3.697 4 4 0 0 0-3.38.149A4 4 0 0 0 8.24 13.37a1 1 0 1 1-1.88.63A6 6 0 0 1 12 6a6 6 0 0 1 6 6 4.721 4.721 0 0 1-4.75 5Z"
        }),
        /* @__PURE__ */ jsx459("path", {
          d: "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx459("defs", {
      children: /* @__PURE__ */ jsx459("clipPath", {
        id: "pinterest_svg__a",
        children: /* @__PURE__ */ jsx459("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Pinterest_default = SvgPinterest;

// src/icons/generated/PlaneEarth.tsx
import { jsx as jsx460, jsxs as jsxs414 } from "react/jsx-runtime";
var SvgPlaneEarth = (props) => /* @__PURE__ */ jsxs414("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs414("g", {
      fill: "currentColor",
      clipPath: "url(#plane-earth_svg__a)",
      children: [
        /* @__PURE__ */ jsx460("path", {
          d: "M11 22a10 10 0 1 1 10-10 1 1 0 0 1-2 0 8 8 0 1 0-8 8 1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx460("path", {
          d: "M19.4 10H2.6a1 1 0 1 1 0-2h16.8a1 1 0 0 1 0 2ZM11 16H2.6a1 1 0 0 1 0-2H11a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx460("path", {
          d: "M10.58 22a1 1 0 0 1-.85-.47 17.92 17.92 0 0 1-.09-18.92 1 1 0 0 1 1.71 1.04 15.91 15.91 0 0 0 .08 16.82 1 1 0 0 1-.85 1.53Z"
        }),
        /* @__PURE__ */ jsx460("path", {
          d: "M14 13a1 1 0 0 1-1-1 16 16 0 0 0-2.31-8.4 1 1 0 0 1 .697-1.517 1 1 0 0 1 1.013.467A18 18 0 0 1 15 12a1 1 0 0 1-1 1ZM18.24 16.09l2.16-1.25a1.26 1.26 0 0 1 1.71.46 1.25 1.25 0 0 1-.46 1.7l-7.56 4.36-1.87-1.66a1 1 0 0 1 .17-1.67 1 1 0 0 1 .79-.11l1.29.35 1.08-.62-2.33-2.25a.999.999 0 0 1 .19-1.56 1 1 0 0 1 1 0l3.83 2.25Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx460("defs", {
      children: /* @__PURE__ */ jsx460("clipPath", {
        id: "plane-earth_svg__a",
        children: /* @__PURE__ */ jsx460("path", {
          fill: "#fff",
          d: "M1 2h21.27v20H1z"
        })
      })
    })
  ]
});
var PlaneEarth_default = SvgPlaneEarth;

// src/icons/generated/Play.tsx
import { jsx as jsx461, jsxs as jsxs415 } from "react/jsx-runtime";
var SvgPlay = (props) => /* @__PURE__ */ jsxs415("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx461("g", {
      clipPath: "url(#play_svg__a)",
      children: /* @__PURE__ */ jsx461("path", {
        fill: "currentColor",
        d: "M5.5 21a1 1 0 0 1-.863-.496A1 1 0 0 1 4.5 20V4a1 1 0 0 1 .51-.87 1 1 0 0 1 1 0l13 8a1 1 0 0 1 0 1.7l-13 8a1 1 0 0 1-.51.17Zm1-15.21v12.42L16.59 12 6.5 5.79Z"
      })
    }),
    /* @__PURE__ */ jsx461("defs", {
      children: /* @__PURE__ */ jsx461("clipPath", {
        id: "play_svg__a",
        children: /* @__PURE__ */ jsx461("path", {
          fill: "#fff",
          d: "M4.5 3h15v18h-15z"
        })
      })
    })
  ]
});
var Play_default = SvgPlay;

// src/icons/generated/PlusMinus.tsx
import { jsx as jsx462, jsxs as jsxs416 } from "react/jsx-runtime";
var SvgPlusMinus = (props) => /* @__PURE__ */ jsxs416("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx462("path", {
      fill: "currentColor",
      d: "M19 10H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM19 23H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1Z"
    }),
    /* @__PURE__ */ jsx462("path", {
      fill: "currentColor",
      d: "M12 17c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1Z"
    })
  ]
});
var PlusMinus_default = SvgPlusMinus;

// src/icons/generated/PlusSmall.tsx
import { jsx as jsx463, jsxs as jsxs417 } from "react/jsx-runtime";
var SvgPlusSmall = (props) => /* @__PURE__ */ jsxs417("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs417("g", {
      fill: "currentColor",
      clipPath: "url(#plus-small_svg__a)",
      children: [
        /* @__PURE__ */ jsx463("path", {
          d: "M16 13H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Z"
        }),
        /* @__PURE__ */ jsx463("path", {
          d: "M12 17a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx463("defs", {
      children: /* @__PURE__ */ jsx463("clipPath", {
        id: "plus-small_svg__a",
        children: /* @__PURE__ */ jsx463("path", {
          fill: "#fff",
          d: "M7 7h10v10H7z"
        })
      })
    })
  ]
});
var PlusSmall_default = SvgPlusSmall;

// src/icons/generated/PlusSquare.tsx
import { jsx as jsx464, jsxs as jsxs418 } from "react/jsx-runtime";
var SvgPlusSquare = (props) => /* @__PURE__ */ jsxs418("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs418("g", {
      fill: "currentColor",
      clipPath: "url(#plus-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx464("path", {
          d: "M17 13H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx464("path", {
          d: "M12 18c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v10c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx464("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx464("defs", {
      children: /* @__PURE__ */ jsx464("clipPath", {
        id: "plus-square_svg__a",
        children: /* @__PURE__ */ jsx464("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var PlusSquare_default = SvgPlusSquare;

// src/icons/generated/Plus.tsx
import { jsx as jsx465, jsxs as jsxs419 } from "react/jsx-runtime";
var SvgPlus = (props) => /* @__PURE__ */ jsxs419("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx465("g", {
      clipPath: "url(#plus_svg__a)",
      children: /* @__PURE__ */ jsx465("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 21c0 .55.45 1 1 1s1-.45 1-1v-8h8c.55 0 1-.45 1-1s-.45-1-1-1h-8V3c0-.55-.45-1-1-1s-1 .45-1 1v8H3c-.55 0-1 .45-1 1s.45 1 1 1h8v8Z",
        clipRule: "evenodd"
      })
    }),
    /* @__PURE__ */ jsx465("defs", {
      children: /* @__PURE__ */ jsx465("clipPath", {
        id: "plus_svg__a",
        children: /* @__PURE__ */ jsx465("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Plus_default = SvgPlus;

// src/icons/generated/PoolSlide.tsx
import { jsx as jsx466 } from "react/jsx-runtime";
var SvgPoolSlide = (props) => /* @__PURE__ */ jsx466("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx466("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.5 9.292a1.476 1.476 0 0 1-.1-.122v.01c-.38-.55-.53-1.21-.41-1.87.08-.46.29-.86.57-1.19-.06-.06-.11-.11-.16-.18-.38-.55-.53-1.21-.41-1.87.24-1.36 1.53-2.28 2.89-2.03l6.88 1.21c1.36.24 2.27 1.54 2.03 2.9-.08.45-.28.85-.57 1.19.47.55.7 1.29.57 2.05-.04.23-.12.44-.22.65l6.31 1.11c.5.09.96.33 1.32.69.5.47.79 1.13.79 1.81v1.85a2.5 2.5 0 0 1-4.99.22l-4.01-.71V17c0 .55-.45 1-1 1s-1-.45-1-1v-2.34l-5-.88V17c0 .55-.45 1-1 1s-1-.45-1-1v-3.58a2.499 2.499 0 0 1-2.01-2.89c.08-.45.29-.85.57-1.18l-.05-.058Zm8.92-.842L4.53 7.24l.01-.02a.5.5 0 0 0-.58.41c-.03.17.04.31.08.37.04.07.14.18.32.21l6.89 1.22c.17.03.31-.03.37-.08a.45.45 0 0 0 .21-.32.514.514 0 0 0-.41-.58Zm8.41 4.84-.03-.03a.585.585 0 0 0-.27-.14L4.52 10.47h-.09c-.23 0-.45.17-.49.41-.04.27.14.53.41.58l13.81 2.44c.48.08.83.49.83.98v.62c0 .28.22.5.5.5s.5-.22.5-.5v-1.85c0-.18-.1-.3-.16-.36Zm-8.4-8.07L4.54 4.01 4.55 4a.5.5 0 0 0-.58.41c-.03.17.04.31.08.37.04.07.14.18.32.21l6.89 1.22c.26.04.53-.14.58-.41a.514.514 0 0 0-.41-.58Zm9.75 14.2c.33-.45.95-.55 1.4-.23h-.02c.45.33.55.95.23 1.4-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.68-.58-1.17-.58-.5 0-.94.2-1.21.58-.65.92-1.75 1.42-2.83 1.42h-.07c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.68-.58-1.17-.58-.5 0-.94.2-1.21.58-.65.92-1.76 1.42-2.83 1.42h-.07c-1.05 0-2.08-.53-2.72-1.42-.32-.45-.22-1.08.23-1.4.45-.32 1.08-.22 1.4.23.27.37.66.58 1.17.58.5 0 .94-.2 1.21-.58.64-.89 1.67-1.42 2.76-1.42h.14c1.05 0 2.08.53 2.72 1.42.27.36.69.58 1.14.58H12c.49 0 .92-.21 1.18-.58.64-.89 1.67-1.42 2.76-1.42h.14c1.05 0 2.08.53 2.72 1.42.27.36.69.58 1.14.58H20c.49 0 .92-.21 1.18-.58Z",
    clipRule: "evenodd"
  })
});
var PoolSlide_default = SvgPoolSlide;

// src/icons/generated/PopularVillage.tsx
import { jsx as jsx467, jsxs as jsxs420 } from "react/jsx-runtime";
var SvgPopularVillage = (props) => /* @__PURE__ */ jsxs420("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs420("g", {
      fill: "currentColor",
      clipPath: "url(#popular-village_svg__a)",
      children: [
        /* @__PURE__ */ jsx467("path", {
          d: "M9 22H3a1 1 0 0 1-1-1V9a1 1 0 0 1 .4-.8l8-6a1 1 0 0 1 1.2 0l8 6a1 1 0 0 1 .4.8v3a1 1 0 0 1-2 0V9.5l-7-5.25L4 9.5V20h4v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-1v5a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx467("path", {
          d: "M17.5 22a1 1 0 0 1-.7-.29l-2.91-2.88a2.94 2.94 0 0 1 3.62-4.6 2.94 2.94 0 0 1 3.61 4.6l-2.87 2.85a1.001 1.001 0 0 1-.75.32Zm-2.21-4.6 2.21 2.19 2.21-2.19a.13.13 0 0 0 .06-.07.9.9 0 0 0 .19-.7.879.879 0 0 0-.37-.62.939.939 0 0 0-1.32.18 1 1 0 0 1-1.6 0L16.6 16a.943.943 0 1 0-1.31 1.36v.04Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx467("defs", {
      children: /* @__PURE__ */ jsx467("clipPath", {
        id: "popular-village_svg__a",
        children: /* @__PURE__ */ jsx467("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var PopularVillage_default = SvgPopularVillage;

// src/icons/generated/QuestionCircle.tsx
import { jsx as jsx468, jsxs as jsxs421 } from "react/jsx-runtime";
var SvgQuestionCircle = (props) => /* @__PURE__ */ jsxs421("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs421("g", {
      fill: "currentColor",
      clipPath: "url(#question-circle_svg__a)",
      children: [
        /* @__PURE__ */ jsx468("path", {
          d: "M11.99 15c-.55 0-1-.45-1-1v-1.32c0-.55.46-1 1.01-1 .49 0 .95-.19 1.3-.54.35-.35.54-.81.54-1.3s-.19-.95-.54-1.3c-.7-.7-1.91-.69-2.6 0a.996.996 0 1 1-1.41-1.41c1.45-1.45 3.98-1.45 5.43 0 .73.73 1.12 1.69 1.12 2.72 0 1.03-.4 1.99-1.12 2.72-.48.48-1.07.82-1.71 1v.45c0 .55-.45 1-1 1l-.02-.02ZM12 18c-.26 0-.52-.11-.71-.29l-.12-.15a.757.757 0 0 1-.09-.18.636.636 0 0 1-.06-.18c0-.07-.02-.13-.02-.2 0-.13.03-.26.08-.38s.12-.23.21-.33c.37-.37 1.05-.37 1.42 0 .09.1.16.21.21.33.06.12.08.25.08.38 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18-.02.06-.05.12-.09.18-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29Z"
        }),
        /* @__PURE__ */ jsx468("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx468("defs", {
      children: /* @__PURE__ */ jsx468("clipPath", {
        id: "question-circle_svg__a",
        children: /* @__PURE__ */ jsx468("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var QuestionCircle_default = SvgQuestionCircle;

// src/icons/generated/QuestionSquare.tsx
import { jsx as jsx469, jsxs as jsxs422 } from "react/jsx-runtime";
var SvgQuestionSquare = (props) => /* @__PURE__ */ jsxs422("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs422("g", {
      fill: "currentColor",
      clipPath: "url(#question-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx469("path", {
          d: "M11.99 15c-.55 0-1-.45-1-1v-1.32c0-.55.46-1 1.01-1 .49 0 .95-.19 1.3-.54.35-.35.54-.81.54-1.3s-.19-.95-.54-1.3c-.7-.7-1.91-.69-2.6 0a.996.996 0 1 1-1.41-1.41c1.45-1.45 3.98-1.45 5.43 0 .73.73 1.12 1.69 1.12 2.72 0 1.03-.4 1.99-1.12 2.72-.48.48-1.07.82-1.71 1v.45c0 .55-.45 1-1 1l-.02-.02ZM12 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.44-.29-.71 0-.27.11-.52.29-.71a1.037 1.037 0 0 1 1.42 0c.18.19.29.45.29.71 0 .07 0 .13-.02.2 0 .06-.03.12-.06.18-.02.06-.05.12-.09.18-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29Z"
        }),
        /* @__PURE__ */ jsx469("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx469("defs", {
      children: /* @__PURE__ */ jsx469("clipPath", {
        id: "question-square_svg__a",
        children: /* @__PURE__ */ jsx469("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var QuestionSquare_default = SvgQuestionSquare;

// src/icons/generated/Quotation.tsx
import { jsx as jsx470, jsxs as jsxs423 } from "react/jsx-runtime";
var SvgQuotation = (props) => /* @__PURE__ */ jsxs423("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx470("g", {
      fill: "currentColor",
      clipPath: "url(#quotation_svg__a)",
      children: /* @__PURE__ */ jsx470("path", {
        d: "M6 19a1 1 0 0 1-.27-1.97A3.75 3.75 0 0 0 9 13v-1H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a5.72 5.72 0 0 1-4.76 6H6ZM6 7v3h3V7H6ZM15 19a1 1 0 0 1-.27-1.97A3.75 3.75 0 0 0 18 13v-1h-3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a5.72 5.72 0 0 1-4.76 6H15Zm0-12v3h3V7h-3Z"
      })
    }),
    /* @__PURE__ */ jsx470("defs", {
      children: /* @__PURE__ */ jsx470("clipPath", {
        id: "quotation_svg__a",
        children: /* @__PURE__ */ jsx470("path", {
          fill: "#fff",
          d: "M4 5h16v14H4z"
        })
      })
    })
  ]
});
var Quotation_default = SvgQuotation;

// src/icons/generated/RadioButtonCheck.tsx
import { jsx as jsx471, jsxs as jsxs424 } from "react/jsx-runtime";
var SvgRadioButtonCheck = (props) => /* @__PURE__ */ jsxs424("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs424("g", {
      fill: "currentColor",
      clipPath: "url(#radio-button-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx471("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx471("path", {
          d: "M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx471("defs", {
      children: /* @__PURE__ */ jsx471("clipPath", {
        id: "radio-button-check_svg__a",
        children: /* @__PURE__ */ jsx471("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var RadioButtonCheck_default = SvgRadioButtonCheck;

// src/icons/generated/RadioButton.tsx
import { jsx as jsx472, jsxs as jsxs425 } from "react/jsx-runtime";
var SvgRadioButton = (props) => /* @__PURE__ */ jsxs425("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx472("g", {
      clipPath: "url(#radio-button_svg__a)",
      children: /* @__PURE__ */ jsx472("path", {
        fill: "currentColor",
        d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
      })
    }),
    /* @__PURE__ */ jsx472("defs", {
      children: /* @__PURE__ */ jsx472("clipPath", {
        id: "radio-button_svg__a",
        children: /* @__PURE__ */ jsx472("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var RadioButton_default2 = SvgRadioButton;

// src/icons/generated/Receipt.tsx
import { jsx as jsx473, jsxs as jsxs426 } from "react/jsx-runtime";
var SvgReceipt = (props) => /* @__PURE__ */ jsxs426("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs426("g", {
      fill: "currentColor",
      clipPath: "url(#receipt_svg__a)",
      children: [
        /* @__PURE__ */ jsx473("path", {
          d: "M14 22a1 1 0 0 1-.71-.29L12 20.41l-1.29 1.3a1.002 1.002 0 0 1-1.42 0l-1.42-1.42-2.32 1.54a1 1 0 0 1-1 .05A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-.53.88 1 1 0 0 1-1-.05l-2.32-1.54-1.42 1.42A1.002 1.002 0 0 1 14 22Zm-2-4a1 1 0 0 1 .71.29l1.29 1.3 1.29-1.3a1 1 0 0 1 1.26-.12l1.45 1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14.13l1.45-1a1 1 0 0 1 1.26.12l1.29 1.3 1.29-1.3A1 1 0 0 1 12 18Z"
        }),
        /* @__PURE__ */ jsx473("path", {
          d: "M12.53 16.28a4 4 0 0 1-3-1.42 5.21 5.21 0 0 1-.06-6.65 4 4 0 0 1 3-1.49 4 4 0 0 1 3.06 1.42 1 1 0 0 1-.1 1.41A1 1 0 0 1 14 9.46a2 2 0 0 0-1.51-.74A2 2 0 0 0 11 9.5a3.25 3.25 0 0 0 0 4 2.001 2.001 0 0 0 3 0 1 1 0 0 1 1.41-.09 1 1 0 0 1 .1 1.41 4 4 0 0 1-2.98 1.46Z"
        }),
        /* @__PURE__ */ jsx473("path", {
          d: "M12.53 13.58H8.21a1 1 0 1 1 0-2h4.32a1 1 0 0 1 0 2Zm0-2.16H8.21a1 1 0 1 1 0-2h4.32a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx473("defs", {
      children: /* @__PURE__ */ jsx473("clipPath", {
        id: "receipt_svg__a",
        children: /* @__PURE__ */ jsx473("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Receipt_default = SvgReceipt;

// src/icons/generated/Reception.tsx
import { jsx as jsx474 } from "react/jsx-runtime";
var SvgReception = (props) => /* @__PURE__ */ jsx474("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx474("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 8c1.33 0 2.44-1.04 2.51-2.38l.06-1.09C10.07 3.13 8.94 2 7.45 2 6.06 2 4.92 3.13 4.92 4.59l.06 1.04a2.527 2.527 0 0 0 2.51 2.38L7.5 8Zm.05-4c.29 0 .53.24.53.47l-.06 1.04C8 5.78 7.78 6 7.5 6s-.5-.21-.52-.49l-.06-.98c0-.29.24-.53.62-.53h.01Zm8.95 4c1.33 0 2.44-1.04 2.51-2.38l.06-1.09c0-1.4-1.13-2.53-2.62-2.53-1.39 0-2.53 1.13-2.53 2.59l.06 1.04a2.527 2.527 0 0 0 2.51 2.38L16.5 8Zm.05-4c.29 0 .53.24.53.47l-.06 1.04c-.02.27-.24.49-.52.49s-.5-.21-.52-.49l-.06-.98c0-.29.24-.53.62-.53h.01ZM20 12.92h2c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1s-1-.45-1-1v-6H11V15c0 .27-.1.52-.29.71l-.71.71v4.59c0 .55-.45 1-1 1s-1-.45-1-1v-5c0-.27.1-.52.29-.71l.71-.71V11H6v3.59l.71.71c.18.19.29.44.29.71v5c0 .55-.45 1-1 1s-1-.45-1-1v-4.59l-.71-.71C4.11 15.52 4 15.27 4 15v-.08H3v6c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55.45-1 1-1h2V11c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v1.92h2V11c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v1.92Zm-2 0V11h-3v1.92h3Z",
    clipRule: "evenodd"
  })
});
var Reception_default = SvgReception;

// src/icons/generated/Refresh.tsx
import { jsx as jsx475, jsxs as jsxs427 } from "react/jsx-runtime";
var SvgRefresh = (props) => /* @__PURE__ */ jsxs427("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs427("g", {
      fill: "currentColor",
      clipPath: "url(#refresh_svg__a)",
      children: [
        /* @__PURE__ */ jsx475("path", {
          d: "M20.05 8.74h-4.74c-.55 0-1-.45-1-1s.45-1 1-1h3.74V3c0-.55.45-1 1-1s1 .45 1 1v4.74c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx475("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c3.63 0 6.98 1.97 8.75 5.15.27.48.09 1.09-.39 1.36s-1.09.09-1.36-.39A8.008 8.008 0 0 0 12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8c0-.55.45-1 1-1s1 .45 1 1c0 5.51-4.49 10-10 10Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx475("defs", {
      children: /* @__PURE__ */ jsx475("clipPath", {
        id: "refresh_svg__a",
        children: /* @__PURE__ */ jsx475("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Refresh_default = SvgRefresh;

// src/icons/generated/Roomservice.tsx
import { jsx as jsx476 } from "react/jsx-runtime";
var SvgRoomservice = (props) => /* @__PURE__ */ jsx476("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx476("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.93 11H21c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1h1.07A8.002 8.002 0 0 1 11 4.07V3c0-.55.45-1 1-1s1 .45 1 1v1.07c3.61.45 6.48 3.32 6.93 6.93Zm-2.02 0c-.48-2.83-2.94-5-5.91-5s-5.43 2.17-5.91 5h11.82ZM16 16H19.16c.86 0 1.61.53 1.89 1.34.28.81.03 1.68-.64 2.22-.04.03-.12.08-.12.08l-3.3 1.94c-.46.27-.99.41-1.52.41h-5.13c-.32 0-.64-.05-.95-.15l-1.45-.48c-.15.37-.51.64-.93.64h-3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v.13l.94-.63c.49-.33 1.07-.5 1.66-.5H14c1.1 0 2 .9 2 2ZM5 20h1v-4H5v4Zm10.45 0c.18 0 .36-.05.51-.14h-.01L19.12 18h-4.98c-.01 0-.018-.003-.025-.005a.074.074 0 0 0-.025-.005c-.03.01-.07.01-.1.01-.55 0-1-.45-1-1s.45-1 1-1H10.6c-.2 0-.39.06-.56.17l-2.05 1.37v1.74l2.01.67c.11.03.21.05.32.05h5.13Z",
    clipRule: "evenodd"
  })
});
var Roomservice_default = SvgRoomservice;

// src/icons/generated/Sauna.tsx
import { jsx as jsx477 } from "react/jsx-runtime";
var SvgSauna = (props) => /* @__PURE__ */ jsx477("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx477("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.6 2.2 8 6c.25.19.4.49.4.8v12c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.31.15-.61.4-.8l8-6a.99.99 0 0 1 1.2 0ZM5 9.5V20h14V9.5l-7-5.25L5 9.5Zm2.44.67c.46-.3 1.08-.18 1.39.28h-.01c1.32 1.98.59 3.44.06 4.5-.48.96-.74 1.48-.06 2.5.3.46.18 1.08-.28 1.39-.17.12-.36.17-.55.17-.32 0-.64-.16-.83-.45-1.32-1.98-.59-3.44-.06-4.5.48-.96.74-1.48.06-2.5-.3-.46-.18-1.09.28-1.39Zm4.06-1.03c-.48.28-.64.89-.36 1.37.74 1.28.43 2-.05 3.1-.54 1.23-1.2 2.75.05 4.9.19.32.52.5.87.5.17 0 .34-.04.5-.14.48-.28.64-.89.36-1.37-.74-1.28-.43-2 .05-3.1.54-1.23 1.2-2.75-.05-4.9a.998.998 0 0 0-1.37-.36Zm4.5 9.87c-.32 0-.64-.16-.83-.45h-.01c-1.32-1.98-.59-3.44-.06-4.5.48-.96.74-1.48.06-2.5-.3-.46-.18-1.09.28-1.39.46-.3 1.08-.18 1.39.28 1.32 1.98.59 3.44.06 4.5-.48.96-.74 1.48-.06 2.5.3.46.18 1.08-.28 1.39-.17.12-.36.17-.55.17Z",
    clipRule: "evenodd"
  })
});
var Sauna_default = SvgSauna;

// src/icons/generated/School.tsx
import { jsx as jsx478, jsxs as jsxs428 } from "react/jsx-runtime";
var SvgSchool = (props) => /* @__PURE__ */ jsxs428("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs428("g", {
      fill: "currentColor",
      clipPath: "url(#school_svg__a)",
      children: [
        /* @__PURE__ */ jsx478("path", {
          d: "M22 16c-.55 0-1-.45-1-1v-4.52l-8.63 3.45c-.24.1-.5.1-.74 0l-10-4a1 1 0 0 1 0-1.86l10-4c.24-.1.5-.1.74 0l10 4s.03.01.04.02a.995.995 0 0 1 .53.56c.04.12.07.24.06.37V15c0 .55-.45 1-1 1ZM4.69 9 12 11.92 19.31 9 12 6.08 4.69 9Z"
        }),
        /* @__PURE__ */ jsx478("path", {
          d: "M12 20c-3.99 0-7-1.72-7-4v-5.4c0-.55.45-1 1-1s1 .45 1 1V16c0 .82 1.95 2 5 2s5-1.18 5-2v-5.4c0-.55.45-1 1-1s1 .45 1 1V16c0 2.28-3.01 4-7 4Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx478("defs", {
      children: /* @__PURE__ */ jsx478("clipPath", {
        id: "school_svg__a",
        children: /* @__PURE__ */ jsx478("path", {
          fill: "#fff",
          d: "M1 4h22v16H1z"
        })
      })
    })
  ]
});
var School_default = SvgSchool;

// src/icons/generated/Search.tsx
import { jsx as jsx479, jsxs as jsxs429 } from "react/jsx-runtime";
var SvgSearch = (props) => /* @__PURE__ */ jsxs429("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs429("g", {
      fill: "currentColor",
      clipPath: "url(#search_svg__a)",
      children: [
        /* @__PURE__ */ jsx479("path", {
          d: "M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Z"
        }),
        /* @__PURE__ */ jsx479("path", {
          d: "M21 22c-.26 0-.51-.1-.71-.29l-6-6a.996.996 0 1 1 1.41-1.41l6 6a.996.996 0 0 1-.71 1.7H21Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx479("defs", {
      children: /* @__PURE__ */ jsx479("clipPath", {
        id: "search_svg__a",
        children: /* @__PURE__ */ jsx479("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Search_default = SvgSearch;

// src/icons/generated/ShareIos.tsx
import { jsx as jsx480, jsxs as jsxs430 } from "react/jsx-runtime";
var SvgShareIos = (props) => /* @__PURE__ */ jsxs430("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs430("g", {
      fill: "currentColor",
      clipPath: "url(#share-ios_svg__a)",
      children: [
        /* @__PURE__ */ jsx480("path", {
          d: "M19 22H5c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1H6v11h12V9h-1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1v13c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx480("path", {
          d: "M12 15c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v11c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx480("path", {
          d: "M15 6c-.19 0-.38-.05-.55-.17l-3-2a1.01 1.01 0 0 1-.28-1.39c.31-.46.92-.58 1.39-.28l3 2c.46.31.58.93.28 1.39-.19.29-.51.45-.83.45H15Z"
        }),
        /* @__PURE__ */ jsx480("path", {
          d: "M9 6c-.32 0-.64-.16-.83-.45-.31-.46-.18-1.08.28-1.39l3-1.99a1.001 1.001 0 1 1 1.11 1.67l-3 2c-.17.11-.36.17-.55.17L9 6Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx480("defs", {
      children: /* @__PURE__ */ jsx480("clipPath", {
        id: "share-ios_svg__a",
        children: /* @__PURE__ */ jsx480("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var ShareIos_default = SvgShareIos;

// src/icons/generated/Share.tsx
import { jsx as jsx481, jsxs as jsxs431 } from "react/jsx-runtime";
var SvgShare = (props) => /* @__PURE__ */ jsxs431("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs431("g", {
      fill: "currentColor",
      clipPath: "url(#share_svg__a)",
      children: [
        /* @__PURE__ */ jsx481("path", {
          d: "M6 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM18 22c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM18 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
        }),
        /* @__PURE__ */ jsx481("path", {
          d: "M9 11.5c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34l6-3a.993.993 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-6 3c-.14.07-.3.11-.45.11L9 11.5ZM15 17.5c-.15 0-.3-.03-.45-.11l-6-3a1.01 1.01 0 0 1-.45-1.34c.25-.49.85-.69 1.34-.45l6 3c.49.25.69.85.45 1.34-.18.35-.53.55-.9.55l.01.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx481("defs", {
      children: /* @__PURE__ */ jsx481("clipPath", {
        id: "share_svg__a",
        children: /* @__PURE__ */ jsx481("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Share_default = SvgShare;

// src/icons/generated/ShieldCheck.tsx
import { jsx as jsx482, jsxs as jsxs432 } from "react/jsx-runtime";
var SvgShieldCheck = (props) => /* @__PURE__ */ jsxs432("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs432("g", {
      fill: "currentColor",
      clipPath: "url(#shield-check_svg__a)",
      children: [
        /* @__PURE__ */ jsx482("path", {
          d: "M12 21.99c-.17 0-.34-.04-.49-.13-.11-.06-2.83-1.58-4.2-2.74C4.69 16.92 3.02 13.75 3 11V7.47c0-1.21.01-2.43 0-3.46 0-.42.25-.79.64-.94 1.65-.63 4.63-1.02 8.2-1.07 3.32-.05 6.66.38 8.51 1.06.39.14.65.51.65.93v7c.02 3.28-2.11 6.3-4.12 8.04-1.41 1.22-4.28 2.78-4.4 2.85-.15.08-.31.12-.48.12v-.01ZM5.01 4.73v6.26c.01 2.15 1.44 4.79 3.55 6.57.94.79 2.63 1.8 3.45 2.28.85-.48 2.62-1.52 3.52-2.29 2.14-1.85 3.48-4.4 3.47-6.55V4.73c-1.72-.47-4.51-.77-7.14-.73-2.8.03-5.32.31-6.85.72v.01Z"
        }),
        /* @__PURE__ */ jsx482("path", {
          d: "M11 16c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4.44-.33 1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47H11Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx482("defs", {
      children: /* @__PURE__ */ jsx482("clipPath", {
        id: "shield-check_svg__a",
        children: /* @__PURE__ */ jsx482("path", {
          fill: "#fff",
          d: "M3 2h18v19.99H3z"
        })
      })
    })
  ]
});
var ShieldCheck_default = SvgShieldCheck;

// src/icons/generated/ShieldWithDismiss.tsx
import { jsx as jsx483, jsxs as jsxs433 } from "react/jsx-runtime";
var SvgShieldWithDismiss = (props) => /* @__PURE__ */ jsxs433("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx483("path", {
      fill: "currentColor",
      d: "M15.7 8.46a1 1 0 0 0-1.4-1.42L12 9.34l-2.3-2.3a1 1 0 0 0-1.4 1.42l2.29 2.29-2.3 2.3a1 1 0 1 0 1.42 1.4L12 12.17l2.3 2.3a1 1 0 0 0 1.4-1.42l-2.29-2.29 2.3-2.3Z"
    }),
    /* @__PURE__ */ jsx483("path", {
      fill: "currentColor",
      d: "M11.5 21.88a1.1 1.1 0 0 0 1 0c.12-.07 2.96-1.63 4.38-2.85C18.89 17.3 21 14 21 11V4c0-.4-.25-.75-.65-.9C18.7 2.4 15 2 12 2s-6.7.4-8.35 1.1c-.4.15-.65.5-.65.9v7c0 3 1.69 5.93 4.3 8.13a34.33 34.33 0 0 0 4.2 2.75ZM5 4.74C6.5 4.3 9 4 12 4s5.5.3 7 .75V11c0 2.15-1.31 4.7-3.45 6.55-.9.77-2.7 1.97-3.55 2.45a31.53 31.53 0 0 1-3.45-2.45C6.44 15.75 5 13.15 5 11V4.74Z"
    })
  ]
});
var ShieldWithDismiss_default = SvgShieldWithDismiss;

// src/icons/generated/Ship.tsx
import { jsx as jsx484 } from "react/jsx-runtime";
var SvgShip = (props) => /* @__PURE__ */ jsx484("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx484("path", {
    fill: "#352F28",
    fillRule: "evenodd",
    d: "M5 4a1 1 0 0 0-1 1v5H3a1 1 0 0 0-.98 1.196l1 5a1 1 0 1 0 1.96-.392L4.22 12H19.382l-1.276 2.553a1 1 0 1 0 1.788.894l2-4A1 1 0 0 0 21 10h-3.465l-3.703-5.555A1 1 0 0 0 13 4H5Zm10.132 6-2.667-4H6v4h9.132Zm-7.157 8a1.397 1.397 0 0 0-1.163.584A3.397 3.397 0 0 1 4 20a3.397 3.397 0 0 1-2.812-1.416 1 1 0 1 1 1.624-1.168A1.397 1.397 0 0 0 4.025 18c.454.012.893-.207 1.163-.584A3.397 3.397 0 0 1 8 16a3.397 3.397 0 0 1 2.812 1.416 1.397 1.397 0 0 0 1.213.584c.454.012.893-.207 1.163-.584A3.397 3.397 0 0 1 16 16a3.397 3.397 0 0 1 2.812 1.416 1.397 1.397 0 0 0 1.213.584c.454.012.893-.207 1.163-.584a1 1 0 1 1 1.624 1.168A3.397 3.397 0 0 1 20 20a3.397 3.397 0 0 1-2.812-1.416A1.397 1.397 0 0 0 15.975 18a1.397 1.397 0 0 0-1.163.584A3.397 3.397 0 0 1 12 20a3.397 3.397 0 0 1-2.812-1.416A1.397 1.397 0 0 0 7.975 18Z",
    clipRule: "evenodd"
  })
});
var Ship_default = SvgShip;

// src/icons/generated/SkiBoots.tsx
import { jsx as jsx485, jsxs as jsxs434 } from "react/jsx-runtime";
var SvgSkiBoots = (props) => /* @__PURE__ */ jsxs434("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs434("g", {
      fill: "currentColor",
      clipPath: "url(#ski-boots_svg__a)",
      children: [
        /* @__PURE__ */ jsx485("path", {
          d: "M20 22H4c-1.1 0-2-.9-2-2V3c0-.55.45-1 1-1h7c.55 0 1 .45 1 1v5.34c0 .86.37 1.66 1.01 2.2 2.78 2.37 5.86 2.3 5.89 2.3.09 0 .18 0 .27.03 2.26.54 3.84 2.54 3.84 4.86V20c0 1.1-.9 2-2 2H20ZM4 4v16h16v-2.27c0-1.36-.9-2.53-2.19-2.89-.77 0-4.05-.18-7.1-2.77A4.859 4.859 0 0 1 9 8.34V4H4Z"
        }),
        /* @__PURE__ */ jsx485("path", {
          d: "M14 17a1.01 1.01 0 0 1-.9-1.45l1-2c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-1 2c-.18.35-.53.55-.9.55L14 17ZM8 22c-.55 0-1-.45-1-1v-1c0-1.65-1.35-3-3-3H3c-.55 0-1-.45-1-1s.45-1 1-1h1c2.76 0 5 2.24 5 5v1c0 .55-.45 1-1 1ZM10 16a1.01 1.01 0 0 1-.9-1.45l1.5-3c.25-.5.85-.69 1.34-.45.49.25.69.85.45 1.34l-1.5 3c-.18.35-.53.55-.9.55L10 16ZM7 12c-.42 0-.81-.26-.95-.68a1 1 0 0 1 .63-1.26l3-1a.988.988 0 0 1 1.26.63 1 1 0 0 1-.63 1.26l-3 1c-.11.04-.21.05-.32.05H7ZM10 8H7c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx485("defs", {
      children: /* @__PURE__ */ jsx485("clipPath", {
        id: "ski-boots_svg__a",
        children: /* @__PURE__ */ jsx485("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var SkiBoots_default = SvgSkiBoots;

// src/icons/generated/SkiHelmet.tsx
import { jsx as jsx486, jsxs as jsxs435 } from "react/jsx-runtime";
var SvgSkiHelmet = (props) => /* @__PURE__ */ jsxs435("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs435("g", {
      fill: "currentColor",
      clipPath: "url(#ski-helmet_svg__a)",
      children: [
        /* @__PURE__ */ jsx486("path", {
          d: "M15.19 12c1.2 0 2.39.19 3.53.57l.59.2c.41.14.69.52.69.95v1.55a1 1 0 0 1-.69.95l-4.59 1.53c-.1.03-.21.05-.32.05-.33 0-.64-.16-.83-.44l-.53-.8a1.245 1.245 0 0 0-2.08 0l-.53.8c-.19.28-.5.44-.83.44-.11 0-.21-.02-.32-.05l-4.59-1.53a1 1 0 0 1-.68-.95v-1.56c0-.43.28-.81.68-.95l.6-.2c1.14-.38 2.33-.57 3.53-.57h6.37m0-2H8.81c-1.42 0-2.82.23-4.17.68l-.6.2a2.99 2.99 0 0 0-2.05 2.85v1.56a3 3 0 0 0 2.05 2.85l4.59 1.53a3.012 3.012 0 0 0 3.36-1.06c.56.76 1.45 1.21 2.41 1.21.32 0 .64-.05.95-.15l4.59-1.53a2.99 2.99 0 0 0 2.05-2.85v-1.55c0-1.29-.83-2.44-2.05-2.85l-.59-.2C18 10.23 16.6 10 15.18 10l.01-.01Z"
        }),
        /* @__PURE__ */ jsx486("path", {
          d: "M22 14h-2v-2c0-4.41-3.59-8-8-8s-8 3.59-8 8v2H2v-2C2 6.49 6.49 2 12 2s10 4.49 10 10v2Z"
        }),
        /* @__PURE__ */ jsx486("path", {
          d: "M8 9c-.37 0-.72-.2-.9-.55a.993.993 0 0 1 .45-1.34l2-1a.99.99 0 0 1 1.34.45c.25.49.05 1.09-.45 1.34l-2 1c-.14.07-.3.11-.45.11L8 9ZM16 9c-.15 0-.3-.03-.45-.11l-2-1a1.01 1.01 0 0 1-.45-1.34c.25-.49.85-.69 1.34-.45l2 1c.49.25.69.85.45 1.34-.18.35-.53.55-.9.55L16 9ZM8 22H5c-.46 0-.86-.31-.97-.76l-1-4a.995.995 0 0 1 .73-1.21.987.987 0 0 1 1.21.73L5.78 20h1.6l.72-1.45c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-1 2a1 1 0 0 1-.89.55V22ZM19 22h-3c-.38 0-.72-.21-.89-.55l-1-2a.993.993 0 0 1 .45-1.34.993.993 0 0 1 1.34.45l.72 1.45h1.6l.81-3.24c.13-.54.68-.87 1.21-.73a1 1 0 0 1 .73 1.21l-1 4c-.11.45-.51.76-.97.76V22Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx486("defs", {
      children: /* @__PURE__ */ jsx486("clipPath", {
        id: "ski-helmet_svg__a",
        children: /* @__PURE__ */ jsx486("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var SkiHelmet_default = SvgSkiHelmet;

// src/icons/generated/SkiMaterial.tsx
import { jsx as jsx487, jsxs as jsxs436 } from "react/jsx-runtime";
var SvgSkiMaterial = (props) => /* @__PURE__ */ jsxs436("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx487("g", {
      clipPath: "url(#ski-material_svg__a)",
      children: /* @__PURE__ */ jsxs436("g", {
        fill: "currentColor",
        clipPath: "url(#ski-material_svg__b)",
        children: [
          /* @__PURE__ */ jsx487("path", {
            d: "M21 22a.999.999 0 0 1-.71-.29l-4-4a1.003 1.003 0 1 1 1.42-1.42l4 4a.998.998 0 0 1-.326 1.636A.998.998 0 0 1 21 22ZM7 8a1 1 0 0 1-.71-.29l-4-4a1.004 1.004 0 0 1 1.42-1.42l4 4A1 1 0 0 1 7 8Z"
          }),
          /* @__PURE__ */ jsx487("path", {
            d: "M18.17 22a1.002 1.002 0 0 1-1.006-1 1 1 0 0 1 .296-.71l2.83-2.83a1.004 1.004 0 1 1 1.42 1.42l-2.83 2.83a1.001 1.001 0 0 1-.71.29ZM13 14a.999.999 0 0 1-.71-.29l-2-2a1.004 1.004 0 0 1 1.42-1.42l2 2a.998.998 0 0 1-.326 1.636A.998.998 0 0 1 13 14Z"
          }),
          /* @__PURE__ */ jsx487("path", {
            d: "M16.27 2A5.879 5.879 0 0 1 15 4.68L3.71 16a1.001 1.001 0 0 1-1.639-.325 1 1 0 0 1 .219-1.095L13.61 3.27A5.78 5.78 0 0 1 16.27 2Zm.28-2a7.42 7.42 0 0 0-4.36 1.85L.88 13.17a3 3 0 0 0 0 4.24 3 3 0 0 0 4.24 0L16.44 6.1C17.61 4.92 19 1.61 17.85.44a1.789 1.789 0 0 0-1.3-.44Z"
          }),
          /* @__PURE__ */ jsx487("path", {
            d: "M11.49 9.22a1 1 0 0 1-.71-.3L9.36 7.51a1 1 0 1 1 1.42-1.41l1.41 1.41a1 1 0 0 1 0 1.41 1 1 0 0 1-.7.3ZM8.66 12.05a.999.999 0 0 1-.71-.3l-1.41-1.41a.999.999 0 0 1 0-1.42 1 1 0 0 1 1.46 0l1.41 1.42a1 1 0 0 1 0 1.41.998.998 0 0 1-.75.3ZM21.93 7.68a6 6 0 0 1-1.25 2.66L9.36 21.65a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.41L19.26 8.92a5.91 5.91 0 0 1 2.67-1.24Zm.27-2a7.41 7.41 0 0 0-4.35 1.85L6.54 18.82a3 3 0 0 0 0 4.25 3.001 3.001 0 0 0 2.12.93 3 3 0 0 0 2.12-.88l11.31-11.37c1.17-1.17 2.59-4.48 1.42-5.65a1.8 1.8 0 0 0-1.31-.44v.02Z"
          }),
          /* @__PURE__ */ jsx487("path", {
            d: "M17.14 14.87a1 1 0 0 1-.7-.29L15 13.17a1.004 1.004 0 1 1 1.42-1.42l1.41 1.42a1 1 0 0 1 0 1.41 1 1 0 0 1-.69.29ZM14.31 17.7a1 1 0 0 1-.7-.29L12.19 16a1.004 1.004 0 1 1 1.42-1.42L15 16a1 1 0 0 1 0 1.41 1 1 0 0 1-.69.29Z"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsxs436("defs", {
      children: [
        /* @__PURE__ */ jsx487("clipPath", {
          id: "ski-material_svg__a",
          children: /* @__PURE__ */ jsx487("path", {
            fill: "#fff",
            d: "M0 0h24v24H0z"
          })
        }),
        /* @__PURE__ */ jsx487("clipPath", {
          id: "ski-material_svg__b",
          children: /* @__PURE__ */ jsx487("path", {
            fill: "#fff",
            d: "M0 0h23.95v23.95H0z"
          })
        })
      ]
    })
  ]
});
var SkiMaterial_default = SvgSkiMaterial;

// src/icons/generated/SkiPass.tsx
import { jsx as jsx488, jsxs as jsxs437 } from "react/jsx-runtime";
var SvgSkiPass = (props) => /* @__PURE__ */ jsxs437("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs437("g", {
      fill: "currentColor",
      clipPath: "url(#ski-pass_svg__a)",
      children: [
        /* @__PURE__ */ jsx488("path", {
          d: "M18 0h-4a1 1 0 0 0-1 1 1 1 0 0 1-2 0 1 1 0 0 0-1-1H6a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h4a1 1 0 0 0 1-1 1 1 0 0 1 2 0 1 1 0 0 0 1 1h4a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3Zm1 21a1 1 0 0 1-1 1h-3.17a3 3 0 0 0-5.66 0H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3.17a3 3 0 0 0 5.66 0H18a1 1 0 0 1 1 1v18Z"
        }),
        /* @__PURE__ */ jsx488("path", {
          d: "M7.11 12.45A1 1 0 0 0 8 13a.93.93 0 0 0 .45-.11L11 11.62V14a1 1 0 0 0 2 0v-2.38l2.55 1.27A.93.93 0 0 0 16 13a1 1 0 0 0 .45-1.89L14.24 10l2.21-1.11a1 1 0 1 0-.9-1.78L13 8.38V6a1 1 0 1 0-2 0v2.38L8.45 7.11a1 1 0 0 0-.9 1.78L9.76 10l-2.21 1.11a1 1 0 0 0-.44 1.34ZM16 16H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx488("defs", {
      children: /* @__PURE__ */ jsx488("clipPath", {
        id: "ski-pass_svg__a",
        children: /* @__PURE__ */ jsx488("path", {
          fill: "#fff",
          d: "M3 0h18v24H3z"
        })
      })
    })
  ]
});
var SkiPass_default = SvgSkiPass;

// src/icons/generated/Skier.tsx
import { jsx as jsx489, jsxs as jsxs438 } from "react/jsx-runtime";
var SvgSkier = (props) => /* @__PURE__ */ jsxs438("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs438("g", {
      fill: "currentColor",
      clipPath: "url(#skier_svg__a)",
      children: [
        /* @__PURE__ */ jsx489("path", {
          d: "M17.68 7.39a2.45 2.45 0 0 1-.75-.12 2.34 2.34 0 0 1-1.37-1.19 2.37 2.37 0 0 1-.13-1.81l.22-.65a2.342 2.342 0 0 1 1.19-1.37 2.37 2.37 0 0 1 1.81-.13 2.38 2.38 0 0 1 1.5 3l-.22.65a2.339 2.339 0 0 1-1.19 1.37 2.3 2.3 0 0 1-1.06.25ZM17.9 4a.39.39 0 0 0-.17 0 .39.39 0 0 0-.18.21l-.22.66a.36.36 0 0 0 0 .28.44.44 0 0 0 .21.19.37.37 0 0 0 .29 0 .32.32 0 0 0 .18-.21l.22-.65A.37.37 0 0 0 18 4a.27.27 0 0 0-.1 0ZM11 12a1 1 0 0 1-.8-1.6l3-4a1 1 0 1 1 1.6 1.2l-3 4a.999.999 0 0 1-.8.4Z"
        }),
        /* @__PURE__ */ jsx489("path", {
          d: "M20 13c-.08.01-.16.01-.24 0l-.43-.11a9 9 0 0 1-5.87-4.7l-.35-.71a1 1 0 0 1 .44-1.34 1 1 0 0 1 1.34.44l.36.71a7 7 0 0 0 4.56 3.66l.43.11a1 1 0 0 1 .73 1.21A1 1 0 0 1 20 13ZM21 22h-2a20.853 20.853 0 0 1-6.18-.93L2.71 18a1 1 0 0 1-.487-1.596 1 1 0 0 1 1.067-.324l10.13 3.12c1.81.544 3.69.814 5.58.8h2a1 1 0 1 1 0 2ZM14 16a.999.999 0 0 1-.8-.4l-3-4a1 1 0 0 1 1.6-1.2l3 4A1 1 0 0 1 14 16Z"
        }),
        /* @__PURE__ */ jsx489("path", {
          d: "M12 20a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 0 1 1.34-.44 1 1 0 0 1 .44 1.34l-2 4A1 1 0 0 1 12 20ZM20 13H3a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx489("defs", {
      children: /* @__PURE__ */ jsx489("clipPath", {
        id: "skier_svg__a",
        children: /* @__PURE__ */ jsx489("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Skier_default = SvgSkier;

// src/icons/generated/Slippers.tsx
import { jsx as jsx490, jsxs as jsxs439 } from "react/jsx-runtime";
var SvgSlippers = (props) => /* @__PURE__ */ jsxs439("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs439("g", {
      fill: "currentColor",
      clipPath: "url(#slippers_svg__a)",
      children: [
        /* @__PURE__ */ jsx490("path", {
          d: "M16.39 21.1a4.88 4.88 0 0 1-.92-.1 4.27 4.27 0 0 1-2.82-2.13 4.291 4.291 0 0 1-.24-3.52 17.33 17.33 0 0 0 1.12-6.09v-5a3.83 3.83 0 0 1 1.56-2.59 3.75 3.75 0 0 1 3-.59l1 .21a5 5 0 0 1 3.13 2.2 4.999 4.999 0 0 1 .67 3.77 53.393 53.393 0 0 0-2.21 9.67l-.09.74a4.3 4.3 0 0 1-4.2 3.43Zm-.83-16.63v4.8a19.348 19.348 0 0 1-1.25 6.78 2.27 2.27 0 0 0 .13 1.87A2.261 2.261 0 0 0 15.9 19a2.26 2.26 0 0 0 2.69-1.71l.08-.65a55.466 55.466 0 0 1 2.31-9.9 3 3 0 0 0-.42-2.17 3 3 0 0 0-1.88-1.31l-1-.22a1.7 1.7 0 0 0-1.38.28 1.68 1.68 0 0 0-.74 1.15Z"
        }),
        /* @__PURE__ */ jsx490("path", {
          d: "M17.76 8.16a.75.75 0 0 1-.21 0 1 1 0 0 1-.76-1.19l.43-2a1 1 0 1 1 1.95.44l-.43 1.95a1 1 0 0 1-.98.8Z"
        }),
        /* @__PURE__ */ jsx490("path", {
          d: "M14.98 11.64a1.003 1.003 0 0 1-.72-.31 1 1 0 0 1 0-1.41 14.199 14.199 0 0 0 2.54-3 1 1 0 0 1 1.95.44c-.25 1.15-2.25 3.16-3.1 4a1 1 0 0 1-.67.28Z"
        }),
        /* @__PURE__ */ jsx490("path", {
          d: "M19.83 12.72a1 1 0 0 1-.84-.47c-1.15-1.79-2.46-4.16-2.2-5.3a1 1 0 0 1 1.816-.322 1 1 0 0 1 .134.752 16.654 16.654 0 0 0 1.93 3.8 1 1 0 0 1-.84 1.54ZM7.11 23a4.22 4.22 0 0 1-2.43-.77 4.22 4.22 0 0 1-1.7-2.74l-.07-.83A52.841 52.841 0 0 0 1.08 9a5 5 0 0 1 4-5.89l1-.17a3.71 3.71 0 0 1 2.93.71 3.74 3.74 0 0 1 1.45 2.65v.06l-.19 4.93a17.68 17.68 0 0 0 .87 6.13 4.282 4.282 0 0 1-.39 3.51 4.231 4.231 0 0 1-2.91 2c-.24.047-.485.07-.73.07ZM6.75 4.88h-.31l-1 .17a3 3 0 0 0-2.43 3.48 54.1 54.1 0 0 1 1.82 9.92l.06.75a2.25 2.25 0 0 0 .92 1.36 2.18 2.18 0 0 0 1.68.37 2.21 2.21 0 0 0 1.54-1.06 2.25 2.25 0 0 0 .21-1.86 19.23 19.23 0 0 1-1-6.82l.17-4.8a1.73 1.73 0 0 0-.66-1.18 1.72 1.72 0 0 0-1-.33Z"
        }),
        /* @__PURE__ */ jsx490("path", {
          d: "M6.15 10a1 1 0 0 1-1-.83l-.35-2a1 1 0 1 1 1.97-.35l.35 2a1 1 0 0 1-.81 1.16l-.16.02Z"
        }),
        /* @__PURE__ */ jsx490("path", {
          d: "M8.82 13.61a1.001 1.001 0 0 1-.72-.31c-.81-.85-2.72-3-2.93-4.11A1 1 0 0 1 5.98 8a1 1 0 0 1 1.16.81 13.911 13.911 0 0 0 2.41 3.08 1 1 0 0 1 0 1.41 1.002 1.002 0 0 1-.73.31Z"
        }),
        /* @__PURE__ */ jsx490("path", {
          d: "M3.9 14.48a1 1 0 0 1-.82-1.57 14.32 14.32 0 0 0 2.08-3.79 1 1 0 0 1 1.98-.28c.2 1.16-1.2 3.47-2.42 5.21a.999.999 0 0 1-.82.43Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx490("defs", {
      children: /* @__PURE__ */ jsx490("clipPath", {
        id: "slippers_svg__a",
        children: /* @__PURE__ */ jsx490("path", {
          fill: "#fff",
          d: "M1 1h21.99v22H1z"
        })
      })
    })
  ]
});
var Slippers_default = SvgSlippers;

// src/icons/generated/SnowboardMaterial.tsx
import { jsx as jsx491, jsxs as jsxs440 } from "react/jsx-runtime";
var SvgSnowboardMaterial = (props) => /* @__PURE__ */ jsxs440("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs440("g", {
      fill: "currentColor",
      clipPath: "url(#snowboard-material_svg__a)",
      children: [
        /* @__PURE__ */ jsx491("path", {
          d: "M5.31 22.94a4.31 4.31 0 0 1-2.9-7.5l5.29-4.83c1-.93 2-1.9 2.91-2.91l4.83-5.29a4.31 4.31 0 0 1 7.5 3 4.22 4.22 0 0 1-1.4 3.08l-5.3 4.84c-1 .91-2 1.89-2.9 2.9l-4.83 5.3a4.328 4.328 0 0 1-3.09 1.4l-.11.01ZM18.63 3h-.06a2.28 2.28 0 0 0-1.65.75l-4.84 5.3c-1 1-2 2.07-3 3l-5.32 4.86A2.29 2.29 0 0 0 3 18.57a2.32 2.32 0 0 0 .68 1.69 2.22 2.22 0 0 0 1.69.68A2.279 2.279 0 0 0 7 20.19l4.83-5.29c1-1.06 2-2.08 3-3L20.19 7a2.28 2.28 0 0 0 .58-2.552A2.318 2.318 0 0 0 18.63 3Z"
        }),
        /* @__PURE__ */ jsx491("path", {
          d: "M16 10a1 1 0 0 1-.71-.29l-1-1a1.004 1.004 0 1 1 1.42-1.42l1 1a.998.998 0 0 1 0 1.42.999.999 0 0 1-.71.29ZM9 17a.999.999 0 0 1-.71-.29l-1-1a1.004 1.004 0 0 1 1.42-1.42l1 1A1 1 0 0 1 9 17Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx491("defs", {
      children: /* @__PURE__ */ jsx491("clipPath", {
        id: "snowboard-material_svg__a",
        children: /* @__PURE__ */ jsx491("path", {
          fill: "#fff",
          d: "M1 1h21.94v21.94H1z"
        })
      })
    })
  ]
});
var SnowboardMaterial_default = SvgSnowboardMaterial;

// src/icons/generated/Snowboarder.tsx
import { jsx as jsx492, jsxs as jsxs441 } from "react/jsx-runtime";
var SvgSnowboarder = (props) => /* @__PURE__ */ jsxs441("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs441("g", {
      fill: "currentColor",
      clipPath: "url(#snowboarder_svg__a)",
      children: [
        /* @__PURE__ */ jsx492("path", {
          d: "M13.66 22.95h-.23a5.59 5.59 0 0 1-2.51-1.4l-8.67-8.7a4.28 4.28 0 0 1-1.23-2.39 1 1 0 0 1 1.97-.34c.078.5.313.962.67 1.32l8.68 8.7c.44.41.97.71 1.55.87a1 1 0 0 1 .74 1.2 1 1 0 0 1-.97.74Z"
        }),
        /* @__PURE__ */ jsx492("path", {
          d: "M9.68 19.34a1 1 0 0 1-.56-.17 1 1 0 0 1-.27-1.38l2.84-4.26a1 1 0 0 1 1.35-.31l.18.12a1.21 1.21 0 0 0 1.23 0 1.2 1.2 0 0 0 .62-1.06V8.74a1 1 0 0 1 1.23-.97l2.73.62 1.86-1.86a1 1 0 0 1 1.639.325 1.001 1.001 0 0 1-.219 1.095l-2.25 2.25a1 1 0 0 1-.93.27L17.07 10v2.28a3.19 3.19 0 0 1-1.63 2.8 3.19 3.19 0 0 1-2.57.27l-2.36 3.6a1 1 0 0 1-.83.39ZM11.85 8.25H9.6a1.13 1.13 0 0 1-.32 0L7.03 7.5a1 1 0 0 1 .63-1.9l2.1.7h2.09a1 1 0 0 1 1 1 1 1 0 0 1-1 .95Z"
        }),
        /* @__PURE__ */ jsx492("path", {
          d: "M5.92 15.64a1 1 0 0 1-.59-.19 1 1 0 0 1-.21-1.4l3-4.12a1 1 0 0 1 1.25-.3l2.85 1.42a1 1 0 0 1 .44 1.35 1 1 0 0 1-1.34.44l-2.09-1-2.54 3.44a1 1 0 0 1-.77.36ZM14.65 7.26a2.78 2.78 0 0 1-2.78-2.77v-.71A2.79 2.79 0 0 1 14.65 1a2.79 2.79 0 0 1 2.78 2.78v.71a2.78 2.78 0 0 1-2.78 2.77Zm0-4.26a.78.78 0 0 0-.78.78v.71a.769.769 0 0 0 .78.77.77.77 0 0 0 .78-.77v-.71a.78.78 0 0 0-.78-.78Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx492("defs", {
      children: /* @__PURE__ */ jsx492("clipPath", {
        id: "snowboarder_svg__a",
        children: /* @__PURE__ */ jsx492("path", {
          fill: "#fff",
          d: "M1 1h21.6v21.9H1z"
        })
      })
    })
  ]
});
var Snowboarder_default = SvgSnowboarder;

// src/icons/generated/Snowflake.tsx
import { jsx as jsx493, jsxs as jsxs442 } from "react/jsx-runtime";
var SvgSnowflake = (props) => /* @__PURE__ */ jsxs442("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs442("g", {
      fill: "currentColor",
      clipPath: "url(#snowflake_svg__a)",
      children: [
        /* @__PURE__ */ jsx493("path", {
          d: "M12.39 7.79c-.26 0-.51-.1-.71-.29L8.84 4.66a.996.996 0 1 1 1.41-1.41l2.13 2.13 2.13-2.13a.996.996 0 1 1 1.41 1.41L13.08 7.5c-.2.2-.45.29-.71.29h.02ZM15.24 21.05c-.26 0-.51-.1-.71-.29l-2.13-2.13-2.13 2.13a.996.996 0 1 1-1.41-1.41l2.84-2.84a.996.996 0 0 1 1.41 0l2.84 2.84a.996.996 0 0 1-.71 1.7Z"
        }),
        /* @__PURE__ */ jsx493("path", {
          d: "M12.39 22c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v18c0 .55-.45 1-1 1ZM6.84 19.49c-.09 0-.17-.01-.26-.03-.53-.14-.85-.69-.71-1.22l.78-2.92-2.92-.78c-.53-.14-.85-.69-.71-1.22s.69-.85 1.22-.71l3.88 1.04c.53.14.85.69.71 1.22l-1.04 3.88a.99.99 0 0 1-.96.74h.01ZM20.79 11.43c-.09 0-.17-.01-.26-.03l-3.88-1.04c-.53-.14-.85-.69-.71-1.22l1.04-3.88c.14-.53.69-.85 1.22-.71s.85.69.71 1.22l-.78 2.92 2.92.78c.53.14.85.69.71 1.22a.99.99 0 0 1-.96.74h-.01Z"
        }),
        /* @__PURE__ */ jsx493("path", {
          d: "M4.6 17.5a1.002 1.002 0 0 1-.5-1.87l15.59-9c.48-.28 1.09-.11 1.37.37s.11 1.09-.37 1.37l-15.59 9c-.16.09-.33.13-.5.13ZM17.95 19.49c-.44 0-.85-.29-.96-.74l-1.04-3.88a.994.994 0 0 1 .71-1.22l3.88-1.04a.99.99 0 0 1 1.22.71.994.994 0 0 1-.71 1.22l-2.92.78.78 2.92a.994.994 0 0 1-.97 1.25h.01ZM4 11.43c-.44 0-.85-.29-.96-.74a.994.994 0 0 1 .71-1.22l2.92-.78-.78-2.92a.994.994 0 0 1 .71-1.22.99.99 0 0 1 1.22.71l1.04 3.88a.994.994 0 0 1-.71 1.22L4.27 11.4c-.09.02-.17.03-.26.03H4Z"
        }),
        /* @__PURE__ */ jsx493("path", {
          d: "M20.19 17.5c-.17 0-.34-.04-.5-.13l-15.59-9A1.01 1.01 0 0 1 3.73 7c.28-.48.89-.64 1.37-.37l15.59 9c.48.28.64.89.37 1.37-.19.32-.52.5-.87.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx493("defs", {
      children: /* @__PURE__ */ jsx493("clipPath", {
        id: "snowflake_svg__a",
        children: /* @__PURE__ */ jsx493("path", {
          fill: "#fff",
          d: "M3 2h18.79v20H3z"
        })
      })
    })
  ]
});
var Snowflake_default = SvgSnowflake;

// src/icons/generated/Snowheight.tsx
import { jsx as jsx494, jsxs as jsxs443 } from "react/jsx-runtime";
var SvgSnowheight = (props) => /* @__PURE__ */ jsxs443("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs443("g", {
      fill: "currentColor",
      clipPath: "url(#snowheight_svg__a)",
      children: [
        /* @__PURE__ */ jsx494("path", {
          d: "M16.47 9a1 1 0 0 1-.71-.3l-2.21-2.21a1 1 0 0 1 0-1.41A1 1 0 0 1 15 5l1.5 1.5L18 5a1 1 0 1 1 1.42 1.41l-2.21 2.21a1 1 0 0 1-.74.38ZM18.68 19.26A1 1 0 0 1 18 19l-1.5-1.5L15 19a.999.999 0 0 1-1.42 0 1 1 0 0 1 0-1.41l2.21-2.21a1 1 0 0 1 1.42 0l2.21 2.21a1 1 0 0 1 0 1.41 1 1 0 0 1-.74.26Z"
        }),
        /* @__PURE__ */ jsx494("path", {
          d: "M16.47 20a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v14a1 1 0 0 1-1 1ZM12.15 18.05a.816.816 0 0 1-.26 0 1 1 0 0 1-.7-1.22l.55-2.06-2.06-.55A1 1 0 0 1 9 13a1 1 0 0 1 1.22-.71l3 .81a1.002 1.002 0 0 1 .71 1.23l-.81 3a1 1 0 0 1-.97.72ZM23 11.78h-.26l-3-.81a1.002 1.002 0 0 1-.71-1.23l.81-3a.999.999 0 1 1 1.93.51l-.54 2.06 2 .55A1 1 0 0 1 24 11a1 1 0 0 1-1 .78Z"
        }),
        /* @__PURE__ */ jsx494("path", {
          d: "M10.41 16.5a1 1 0 0 1-.5-1.87l12.12-7A1 1 0 0 1 23.4 8a1 1 0 0 1-.37 1.37l-12.12 7a1 1 0 0 1-.5.13ZM20.79 18.05a1 1 0 0 1-1-.75l-.81-3a1 1 0 0 1 .71-1.23l3-.81A1 1 0 0 1 24 13a1 1 0 0 1-.71 1.22l-2 .55.54 2.06a1 1 0 0 1-.7 1.22.822.822 0 0 1-.34 0ZM9.94 11.78a1 1 0 0 1-.9-1.494 1 1 0 0 1 .6-.466l2.06-.55-.55-2.06a1 1 0 0 1 1.463-1.121 1 1 0 0 1 .467.611l.81 3a1 1 0 0 1-.71 1.23l-3 .81a1.149 1.149 0 0 1-.24.04Z"
        }),
        /* @__PURE__ */ jsx494("path", {
          d: "M22.53 16.5a1 1 0 0 1-.5-.13l-12.12-7a1 1 0 0 1-.113-1.666 1 1 0 0 1 1.113-.074l12.12 7a1 1 0 0 1-.5 1.87ZM1 8a1 1 0 0 1-.71-1.71l3-3a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.42l-3 3A1 1 0 0 1 1 8Z"
        }),
        /* @__PURE__ */ jsx494("path", {
          d: "M7 8a1 1 0 0 1-.71-.29l-3-3a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0l3 3A1 1 0 0 1 7 8ZM4 21a.999.999 0 0 1-.71-1.71l3-3a1 1 0 0 1 1.639.325 1 1 0 0 1-.22 1.095l-3 3A1 1 0 0 1 4 21Z"
        }),
        /* @__PURE__ */ jsx494("path", {
          d: "M4 21a.999.999 0 0 1-.71-.29l-3-3a.999.999 0 0 1 0-1.42 1.001 1.001 0 0 1 1.42 0l3 3A1 1 0 0 1 4 21Z"
        }),
        /* @__PURE__ */ jsx494("path", {
          d: "M4 19a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v12a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx494("defs", {
      children: /* @__PURE__ */ jsx494("clipPath", {
        id: "snowheight_svg__a",
        children: /* @__PURE__ */ jsx494("path", {
          fill: "#fff",
          d: "M0 3h24v18H0z"
        })
      })
    })
  ]
});
var Snowheight_default = SvgSnowheight;

// src/icons/generated/Spade.tsx
import { jsx as jsx495, jsxs as jsxs444 } from "react/jsx-runtime";
var SvgSpade = (props) => /* @__PURE__ */ jsxs444("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx495("g", {
      clipPath: "url(#spade_svg__a)",
      children: /* @__PURE__ */ jsx495("path", {
        fill: "currentColor",
        d: "M14.99 22h-6a1 1 0 0 1-.81-.42 1 1 0 0 1-.14-.9l.71-2.12a4.57 4.57 0 0 1-4.44-1.71 6.54 6.54 0 0 1 .31-8.24C5.18 8 5.77 7.36 6.38 6.78c1.65-1.52 3.29-3 4.94-4.52a1 1 0 0 1 1.34 0l4.92 4.5c.65.62 1.24 1.24 1.78 1.85a6.54 6.54 0 0 1 .31 8.24 4.5 4.5 0 0 1-4.42 1.78l.74 2.05a.999.999 0 0 1-.14.9.999.999 0 0 1-.86.42Zm-4.61-2h3.22l-.56-1.68a1.193 1.193 0 0 1-.05-.32v-1a1 1 0 0 1 .55-.9 1 1 0 0 1 1 .1 2.479 2.479 0 0 0 3.49-.55 4.55 4.55 0 0 0-.22-5.72c-.5-.57-1.06-1.14-1.64-1.71l-4.18-3.87-4.24 3.89c-.56.53-1.11 1.11-1.63 1.69a4.55 4.55 0 0 0-.22 5.72 2.6 2.6 0 0 0 3.52.53 1 1 0 0 1 1-.07 1 1 0 0 1 .57.89v1a1.19 1.19 0 0 1-.05.32L10.38 20Z"
      })
    }),
    /* @__PURE__ */ jsx495("defs", {
      children: /* @__PURE__ */ jsx495("clipPath", {
        id: "spade_svg__a",
        children: /* @__PURE__ */ jsx495("path", {
          fill: "#fff",
          d: "M3 2h17.99v20H3z"
        })
      })
    })
  ]
});
var Spade_default = SvgSpade;

// src/icons/generated/SparkAtlantis.tsx
import { jsx as jsx496, jsxs as jsxs445 } from "react/jsx-runtime";
var SvgSparkAtlantis = (props) => /* @__PURE__ */ jsxs445("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 500,
  height: 500,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx496("path", {
      fill: "currentColor",
      d: "m450.065 102.166-32.762-19.36s-49.144-20.85-62.547-22.338L321.993 56l-31.273 2.978a193.603 193.603 0 0 0-55.101 16.382l-25.316 8.935-28.295 11.914s-23.828 8.935-38.72 11.913l-41.698 4.468-55.1 2.978v29.785h35.74a478.081 478.081 0 0 0 81.907-8.936l28.295-8.935 26.806-10.424L252 102.166s23.828-8.936 44.677-11.914c22.338-2.979 35.741-1.49 44.676 0l29.784 7.446c17.871 4.468 52.123 22.338 55.101 23.827l23.827 14.892v-35.741 1.49Z"
    }),
    /* @__PURE__ */ jsx496("path", {
      fill: "currentColor",
      d: "M408.367 218.324a259.132 259.132 0 0 1-46.165 14.892l-14.892 4.468a44.767 44.767 0 0 1-10.425 0h1.489a119.206 119.206 0 0 0 11.914-10.425c11.914-8.935 19.36-23.827 19.36-41.698v-1.489s0-4.468 2.978-2.978l7.446 7.446 17.871 14.892c2.978 2.978 8.935 7.446 11.914 7.446 1.489 1.489 0 4.467-1.49 7.446Zm-122.115 20.849-14.892-2.979c-1.489 0-7.446 0-10.425-2.978l-17.87-4.468-19.36-8.935c-7.446-4.468-20.849-14.892-19.359-17.87 0-2.979 20.848-13.403 20.848-13.403l10.425-5.957 22.338-13.403c1.489 0 2.978-1.489 2.978 0l-2.978 16.381c0 16.382 7.446 31.274 17.871 41.698l13.402 8.935-1.489 2.979m144.454-37.23c-4.468 0-7.446-2.979-8.936-4.468a59.513 59.513 0 0 1-7.446-4.468l-40.208-35.741s-16.382-17.87-26.806-22.338a89.365 89.365 0 0 0-26.806-8.935c-35.741-2.979-67.014 19.36-67.014 19.36-1.49 0-53.612 32.762-69.993 40.208-17.871 7.446-13.403 7.446-34.252 11.914-22.338 2.978-89.353 1.489-101.266 1.489v26.806h25.316l84.885 1.489 10.425 1.489 19.359 5.957 67.015 19.36 22.338 5.957-59.568 78.928a372.276 372.276 0 0 1-78.929 72.971c-4.467 0-10.424 0-8.935-2.978a44.678 44.678 0 0 0 2.979-17.871 44.676 44.676 0 0 0-89.353 0v4.468c0 10.424 5.957 19.36 11.914 26.806l4.467 4.467a78.929 78.929 0 0 0 43.187 16.382c8.936 0 29.785 0 44.677-5.957 17.87-5.957 29.784-16.381 40.208-23.828l26.806-28.295 8.935-11.913 37.231-46.166 25.316-35.741 5.957-8.935 10.425-11.914s7.446-7.446 7.446-2.978v163.813c0 2.978 1.489 10.424 13.403 10.424 2.978 0 13.402.001 13.402-10.424v-86.374c0-4.468 0-14.892 4.468-23.828 4.468-8.935 14.892-17.87 14.892-20.849 0-2.978-4.467-4.467-10.424-7.446-5.957-4.467-7.446-8.935-8.936-11.913a59.586 59.586 0 0 1-2.978-19.36l20.849-7.446 16.381-5.957 19.36-7.446 23.827-5.957c8.936-1.489 28.295 1.489 34.252-2.978 5.957-5.957 5.957-17.871 2.979-22.338-2.979-4.468-16.382-5.957-20.849-7.446Z"
    })
  ]
});
var SparkAtlantis_default = SvgSparkAtlantis;

// src/icons/generated/SparkEliza.tsx
import { jsx as jsx497, jsxs as jsxs446 } from "react/jsx-runtime";
var SvgSparkEliza = (props) => /* @__PURE__ */ jsxs446("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx497("g", {
      clipPath: "url(#spark-eliza_svg__a)",
      children: /* @__PURE__ */ jsx497("path", {
        fill: "currentColor",
        d: "m19.91 15.74-.2-.17-2.46-1.9 2.26-.22a3.17 3.17 0 0 0 2.21-1 1.83 1.83 0 0 0 .23-1.71s-.39-1.34-.87-1.24c-.476.088-.957.151-1.44.19l-.74.09-4.2.4.87-2.13 1-2.52a1.74 1.74 0 0 0 .08-1.34 1.73 1.73 0 0 0-1-.87l-.33-.13a1.52 1.52 0 0 0-2.2 1c-.36.93-.67 1.69-1 2.45-.33.76-.64 1.57-1 2.52L7.7 6.56a11.63 11.63 0 0 1-1-.83l-.61-.54a1.83 1.83 0 0 0-1.49-.52 1.59 1.59 0 0 0-1 .81l-.17.28a2.13 2.13 0 0 0-.4 1.12 1.47 1.47 0 0 0 .63 1.11l.54.48c.33.3.7.64 1.12 1l2.07 1.54-3.81.58a1.88 1.88 0 0 0-1.42.83 1.39 1.39 0 0 0 0 1.34l.13.3c.15.377.378.718.67 1a1.3 1.3 0 0 0 1.18.13l1.07-.16 3.9-.55a27.792 27.792 0 0 0-1 3.46 3.13 3.13 0 0 0 .2 2.44 2.08 2.08 0 0 0 1.41.9c.198.039.399.06.6.06.42 0 .87-.09.93-.36.387-2.04.932-4.045 1.63-6l3.3 2.44c.208.158.429.298.66.42l.37.2h.07l.17.09.27.1a2.2 2.2 0 0 0 1 .06 1.14 1.14 0 0 0 .79-.5.88.88 0 0 0 .14-.44v-.31a.243.243 0 0 1 0-.09v-.09c.19-.32.06-.72.28-.64.22.08.61-.05 0-.52l-.02.04Z"
      })
    }),
    /* @__PURE__ */ jsx497("defs", {
      children: /* @__PURE__ */ jsx497("clipPath", {
        id: "spark-eliza_svg__a",
        children: /* @__PURE__ */ jsx497("path", {
          fill: "#fff",
          d: "M2 3h20.05v18.37H2z"
        })
      })
    })
  ]
});
var SparkEliza_default = SvgSparkEliza;

// src/icons/generated/SparkGogo.tsx
import { jsx as jsx498 } from "react/jsx-runtime";
var SvgSparkGogo = (props) => /* @__PURE__ */ jsx498("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx498("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.649 10.074c.172 0 .305.115.344.287.038.171-.077.324-.23.381-1.374.458-2.328 1.451-2.538 2.634-.21 1.184.343 2.425 1.47 3.34.133.096.152.287.076.44-.076.153-.267.21-.42.153-1.336-.516-2.71-.382-3.627.4-.935.764-1.317 2.081-1.03 3.494.019.171-.077.343-.23.4-.152.058-.343 0-.42-.152-.706-1.26-1.851-2.024-3.053-2.024-1.222 0-2.348.764-3.055 2.024-.076.152-.267.21-.42.152a.342.342 0 0 1-.229-.4c.287-1.413-.114-2.71-1.03-3.494-.917-.782-2.272-.916-3.627-.4-.153.057-.344 0-.42-.153-.095-.153-.057-.325.076-.44 1.126-.896 1.68-2.156 1.47-3.34-.19-1.183-1.145-2.176-2.52-2.634a.328.328 0 0 1-.229-.381c.02-.172.172-.287.344-.287 1.45.02 2.672-.572 3.283-1.622.61-1.05.516-2.405-.229-3.646-.076-.134-.057-.325.076-.42a.348.348 0 0 1 .459 0c1.088.954 2.424 1.279 3.55.859 1.145-.42 1.947-1.527 2.176-2.959.019-.152.172-.286.343-.286.172 0 .306.134.344.286.21 1.432 1.03 2.539 2.157 2.959 1.145.4 2.462.076 3.55-.878a.348.348 0 0 1 .459 0 .325.325 0 0 1 .076.439c-.744 1.24-.84 2.596-.23 3.646.612 1.05 1.833 1.66 3.284 1.622ZM7.18 12.403c-.19-2.787 1.928-5.211 4.734-5.402a5.087 5.087 0 0 1 5.421 4.734 5.125 5.125 0 0 1-.515 2.577c-1.146-.344-2.806-.573-4.639-.573-1.756 0-3.36.21-4.504.535a4.772 4.772 0 0 1-.497-1.871Z",
    clipRule: "evenodd"
  })
});
var SparkGogo_default = SvgSparkGogo;

// src/icons/generated/SparkHeart.tsx
import { jsx as jsx499 } from "react/jsx-runtime";
var SvgSparkHeart = (props) => /* @__PURE__ */ jsx499("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx499("path", {
    fill: "currentColor",
    d: "M10.546 5.455a.66.66 0 0 1-.658-.66V2.58a.659.659 0 1 1 1.317 0v2.214a.66.66 0 0 1-.659.66ZM5.344 6.683 3.936 4.798a.663.663 0 0 1 .133-.923.655.655 0 0 1 .92.13L6.395 5.89a.663.663 0 0 1-.13.926.656.656 0 0 1-.922-.133ZM2.675 11.095l-2.274-.97a.663.663 0 0 1-.35-.867.656.656 0 0 1 .863-.35l2.275.97c.334.144.49.53.349.867a.658.658 0 0 1-.863.35ZM13.239 21.69c.738.518 1.72.518 2.459 0C18.058 20.035 23 16.13 23 12.415c0-1.298-.364-2.617-1.428-3.51-.926-.777-2.2-1.126-3.408-1.002-2.014.208-3 1.592-3.425 2.45a.302.302 0 0 1-.543 0c-.423-.858-1.41-2.242-3.423-2.45-1.207-.124-2.484.225-3.408 1.001-1.066.894-1.43 2.213-1.43 3.511 0 3.715 4.941 7.62 7.304 9.275Z"
  })
});
var SparkHeart_default = SvgSparkHeart;

// src/icons/generated/SparkPrimavera.tsx
import { jsx as jsx500, jsxs as jsxs447 } from "react/jsx-runtime";
var SvgSparkPrimavera = (props) => /* @__PURE__ */ jsxs447("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx500("g", {
      clipPath: "url(#spark-primavera_svg__a)",
      children: /* @__PURE__ */ jsx500("path", {
        fill: "currentColor",
        d: "M16.26 3.3a9.12 9.12 0 0 0-5-1.3c-1.57 0-3.58 0-4.48.11A1.71 1.71 0 0 0 5.1 3.39a60.265 60.265 0 0 0 0 6.16c0 4 0 7.45-.06 11.11 0 .82.58 1.34 1.63 1.34 1.05 0 1.69-.4 1.69-1.46C8.36 18.48 8.3 7 8.3 4.9h2.8a6.22 6.22 0 0 1 2.93.55 3 3 0 0 1 1.63 2.94 3.57 3.57 0 0 1-2.5 3.52c-.744.148-1.502.215-2.26.2h-.24c-.72 0-1.21.51-1.21 1.43 0 .92.36 1.46 1.29 1.46a26.985 26.985 0 0 0 3.32-.26 6.48 6.48 0 0 0 4.78-6.2 5.8 5.8 0 0 0-2.58-5.24Z"
      })
    }),
    /* @__PURE__ */ jsx500("defs", {
      children: /* @__PURE__ */ jsx500("clipPath", {
        id: "spark-primavera_svg__a",
        children: /* @__PURE__ */ jsx500("path", {
          fill: "#fff",
          d: "M5 2h13.83v20H5z"
        })
      })
    })
  ]
});
var SparkPrimavera_default = SvgSparkPrimavera;

// src/icons/generated/SparkSunweb.tsx
import { jsx as jsx501, jsxs as jsxs448 } from "react/jsx-runtime";
var SvgSparkSunweb = (props) => /* @__PURE__ */ jsxs448("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs448("g", {
      fill: "currentColor",
      clipPath: "url(#spark-sunweb_svg__a)",
      children: [
        /* @__PURE__ */ jsx501("path", {
          fillRule: "evenodd",
          d: "M14.1 7.01c.99.03 1.77.21 2.34.44.44.18 1.01.46 1.2.66.3.31.32.62.16.96-.3.63-.54 1.16-1.21 1.1-.3-.02-.56-.18-.83-.3-.41-.17-.93-.39-1.88-.43-1.26-.05-1.96.4-2 1.26-.04.97.99 1.36 2.28 1.85 1.76.66 3.95 1.49 3.84 4.32-.05 1.28-.58 2.33-1.52 3.06-.99.76-2.42 1.12-4.14 1.06-1.93-.07-2.96-.63-3.59-.98-.5-.28-.62-.72-.4-1.12.32-.61.53-1.26 1.22-1.18.28.03.55.21.82.33.43.19 1.01.44 2.19.49 1.39.05 2.21-.48 2.25-1.46.04-1.09-1.09-1.52-2.4-2.03-1.7-.66-3.82-1.47-3.71-4.13.04-1.19.55-2.19 1.46-2.89.95-.73 2.31-1.08 3.94-1.02l-.02.01Z",
          clipRule: "evenodd"
        }),
        /* @__PURE__ */ jsx501("path", {
          d: "M13 6c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM8.81 6.99c-.32 0-.62-.15-.82-.43L6.84 4.92a.988.988 0 0 1 .25-1.39.988.988 0 0 1 1.39.25l1.15 1.64c.32.45.21 1.08-.25 1.39-.17.12-.38.18-.57.18ZM6.42 10.51c-.11 0-.23-.02-.34-.06L4.2 9.77a.998.998 0 0 1-.6-1.28c.19-.52.76-.78 1.28-.6l1.88.68c.52.19.79.76.6 1.28-.15.41-.53.66-.94.66Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx501("defs", {
      children: /* @__PURE__ */ jsx501("clipPath", {
        id: "spark-sunweb_svg__a",
        children: /* @__PURE__ */ jsx501("path", {
          fill: "#fff",
          d: "M3.54 2H18v19H3.54z"
        })
      })
    })
  ]
});
var SparkSunweb_default = SvgSparkSunweb;

// src/icons/generated/SparkTotally.tsx
import { jsx as jsx502 } from "react/jsx-runtime";
var SvgSparkTotally = (props) => /* @__PURE__ */ jsx502("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx502("path", {
    d: "M11 119.518c0 35.816 33.128 40.803 40.064 40.803 6.41 0 12.936-.678 16.936-1.585v-29.924c-3 .454-6.005.906-8.523.906-10.075 0-14.477-4.081-14.477-15.19v-40.96h21v-30H0v30h11v45.95ZM45 34V0H11l34 34Z",
    style: {
      fill: "#fff"
    }
  })
});
var SparkTotally_default = SvgSparkTotally;

// src/icons/generated/Sparkles.tsx
import { jsx as jsx503, jsxs as jsxs449 } from "react/jsx-runtime";
var SvgSparkles = (props) => /* @__PURE__ */ jsxs449("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx503("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.503.833a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.667a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z",
      clipRule: "evenodd"
    }),
    /* @__PURE__ */ jsx503("path", {
      fill: "currentColor",
      d: "M15.503 14a1 1 0 0 1 1 1v.667h.666l.103.005a1 1 0 0 1 0 1.99l-.103.005h-.666v.666a1 1 0 0 1-2 0v-.666h-.667a1 1 0 0 1 0-2h.667V15a1 1 0 0 1 1-1ZM7.934 2.943c.49.039.815.352.968.529.188.216.334.477.449.716.233.485.435 1.094.596 1.655.165.57.3 1.137.395 1.557l.01.053c.355.08.82.197 1.292.348.483.155 1.03.364 1.474.637.222.137.464.316.66.55.199.24.388.587.388 1.022 0 .435-.19.781-.389 1.021a2.67 2.67 0 0 1-.659.551c-.444.273-.991.483-1.474.638-.472.15-.937.266-1.292.346l-.01.054c-.094.42-.23.986-.395 1.557-.161.56-.363 1.17-.596 1.656a3.26 3.26 0 0 1-.449.715c-.163.188-.522.533-1.069.533-.547 0-.906-.345-1.07-.533a3.256 3.256 0 0 1-.448-.715c-.233-.485-.435-1.095-.596-1.656-.165-.571-.3-1.137-.395-1.557l-.011-.055c-.355-.08-.82-.194-1.29-.345-.484-.155-1.03-.365-1.475-.638a2.67 2.67 0 0 1-.66-.55 1.625 1.625 0 0 1-.38-.863l-.008-.16.009-.158c.039-.361.205-.653.38-.863.195-.234.437-.413.659-.55.444-.273.991-.482 1.474-.637.471-.151.936-.268 1.29-.348l.012-.053c.094-.42.23-.986.395-1.557.161-.561.363-1.17.596-1.655.115-.239.261-.5.449-.716.163-.189.522-.533 1.069-.533l.1.004ZM7.64 6.396a25.466 25.466 0 0 0-.468 1.918c-.012.057-.02.103-.027.132l-.006.033-.001.008-.001.001v.001a.999.999 0 0 1-.81.795v.002l-.007.001-.025.004-.106.02a14.829 14.829 0 0 0-1.556.394c-.302.097-.572.2-.79.305.218.104.488.209.79.305a13.65 13.65 0 0 0 1.556.394l.106.02.025.004.006.001.15.039a1 1 0 0 1 .66.758l.002.002v.008c.002.007.005.018.007.033l.027.132a28.28 28.28 0 0 0 .468 1.917c.062.215.126.422.191.614.065-.192.131-.399.193-.614a25.352 25.352 0 0 0 .467-1.917l.028-.132.005-.033.002-.008v-.002l.041-.148a1 1 0 0 1 .77-.649h.006l.132-.025a14.815 14.815 0 0 0 1.556-.394c.301-.096.57-.201.788-.305a6.442 6.442 0 0 0-.788-.305 13.671 13.671 0 0 0-1.556-.393L9.37 9.29l-.026-.004h-.005l-.001-.002a1 1 0 0 1-.77-.647l-.04-.149v-.002l-.003-.008-.005-.033-.028-.132a28.236 28.236 0 0 0-.467-1.918 14.368 14.368 0 0 0-.193-.615c-.065.193-.13.4-.191.615Z"
    })
  ]
});
var Sparkles_default = SvgSparkles;

// src/icons/generated/SportsLeisure.tsx
import { jsx as jsx504, jsxs as jsxs450 } from "react/jsx-runtime";
var SvgSportsLeisure = (props) => /* @__PURE__ */ jsxs450("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs450("g", {
      fill: "currentColor",
      clipPath: "url(#sports-leisure_svg__a)",
      children: [
        /* @__PURE__ */ jsx504("path", {
          d: "M8 22H4a1 1 0 1 1 0-2h3.38l1.23-2.45a1 1 0 1 1 1.78.9l-1.5 3A1 1 0 0 1 8 22ZM17 22a1 1 0 0 1-1-.8l-.82-4.2H11a.998.998 0 0 1-.77-.37.999.999 0 0 1-.23-.83l1-5a1.02 1.02 0 1 1 2 .4l-.78 3.8H16a1 1 0 0 1 1 .8l1 5a1.002 1.002 0 0 1-.8 1.2H17Z"
        }),
        /* @__PURE__ */ jsx504("path", {
          d: "M20 15a.996.996 0 0 1-.35-.06l-7.71-2.89L4.24 14a1.028 1.028 0 1 1-.48-2l8-2a1 1 0 0 1 .59 0l8 3a1.015 1.015 0 0 1-.35 2ZM12 9.26a2.78 2.78 0 0 1-2.78-2.77v-.71a2.78 2.78 0 0 1 5.56 0v.71A2.78 2.78 0 0 1 12 9.26ZM12 5a.78.78 0 0 0-.78.78v.71a.78.78 0 1 0 1.56 0v-.71A.78.78 0 0 0 12 5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx504("defs", {
      children: /* @__PURE__ */ jsx504("clipPath", {
        id: "sports-leisure_svg__a",
        children: /* @__PURE__ */ jsx504("path", {
          fill: "#fff",
          d: "M3 3h18v19H3z"
        })
      })
    })
  ]
});
var SportsLeisure_default = SvgSportsLeisure;

// src/icons/generated/SportsRun.tsx
import { jsx as jsx505, jsxs as jsxs451 } from "react/jsx-runtime";
var SvgSportsRun = (props) => /* @__PURE__ */ jsxs451("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs451("g", {
      fill: "currentColor",
      clipPath: "url(#sports-run_svg__a)",
      children: [
        /* @__PURE__ */ jsx505("path", {
          d: "M14 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM11.2 15.61a.994.994 0 0 0-1.34.45l-.41.82-4.25-.85c-.54-.11-1.07.24-1.18.78-.11.54.24 1.07.78 1.18l5 1c.07.01.13.02.2.02a1 1 0 0 0 .89-.55l.75-1.5a.993.993 0 0 0-.45-1.34l.01-.01Z"
        }),
        /* @__PURE__ */ jsx505("path", {
          d: "m19.32 11.05-2.78-.93-2.83-2.83s-.1-.08-.15-.11c-.01 0-.02-.02-.04-.03-.1-.06-.21-.1-.32-.12-.02 0-.03-.01-.04-.02h-.04c-.1-.01-.21-.02-.32 0h-.04L7.8 8c-.47.09-.8.5-.8.98v3c0 .55.45 1 1 1s1-.45 1-1V9.8l2.78-.55-.76 4.57c-.06.37.09.74.39.96l3.6 2.7v3.5c0 .55.45 1 1 1s1-.45 1-1v-4c0-.31-.15-.61-.4-.8l-3.51-2.64.58-3.48 1.63 1.63c.11.11.24.19.39.24l3 1c.11.04.21.05.32.05.42 0 .81-.26.95-.68a1 1 0 0 0-.63-1.26l-.02.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx505("defs", {
      children: /* @__PURE__ */ jsx505("clipPath", {
        id: "sports-run_svg__a",
        children: /* @__PURE__ */ jsx505("path", {
          fill: "currentColor",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var SportsRun_default = SvgSportsRun;

// src/icons/generated/Spotify.tsx
import { jsx as jsx506, jsxs as jsxs452 } from "react/jsx-runtime";
var SvgSpotify = (props) => /* @__PURE__ */ jsxs452("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs452("g", {
      fill: "currentColor",
      clipPath: "url(#spotify_svg__a)",
      children: [
        /* @__PURE__ */ jsx506("path", {
          d: "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
        }),
        /* @__PURE__ */ jsx506("path", {
          d: "M15.5 13.5a1 1 0 0 1-.6-.2 5.87 5.87 0 0 0-6.39-.47 1 1 0 0 1-1-1.72 7.89 7.89 0 0 1 8.61.59 1 1 0 0 1-.62 1.8Z"
        }),
        /* @__PURE__ */ jsx506("path", {
          d: "M14 16.5a1 1 0 0 1-.83-.45c-.66-1-2.53-.94-3.62-.22a1 1 0 1 1-1.1-1.66c1.91-1.28 5-1.22 6.38.78a1 1 0 0 1-.28 1.38.94.94 0 0 1-.55.17ZM17 10.5a1 1 0 0 1-.53-.15 9.23 9.23 0 0 0-9-.46 1 1 0 0 1-.9-1.78 11.23 11.23 0 0 1 11 .54 1 1 0 0 1 .28 1.35 1 1 0 0 1-.85.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx506("defs", {
      children: /* @__PURE__ */ jsx506("clipPath", {
        id: "spotify_svg__a",
        children: /* @__PURE__ */ jsx506("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Spotify_default = SvgSpotify;

// src/icons/generated/Spray.tsx
import { jsx as jsx507 } from "react/jsx-runtime";
var SvgSpray = (props) => /* @__PURE__ */ jsx507("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx507("path", {
    fill: "#362F2F",
    fillRule: "evenodd",
    d: "M22.01 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1ZM11 9.18V8c.55 0 1-.45 1-1s-.45-1-1-1c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v3.18c-1.16.41-2 1.51-2 2.82v7c0 1.65 1.35 3 3 3h4c1.65 0 3-1.35 3-3v-7c0-1.3-.84-2.4-2-2.82ZM9 6v3H7V6h2Zm2 13c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v7Zm4.01-13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm2 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1Zm1-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm3 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Zm-1 5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1Z",
    clipRule: "evenodd"
  })
});
var Spray_default = SvgSpray;

// src/icons/generated/StarFullFill.tsx
import { jsx as jsx508 } from "react/jsx-runtime";
var SvgStarFullFill = (props) => /* @__PURE__ */ jsx508("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx508("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.22 21.65c.32.23.69.35 1.06.35.37 0 .75-.12 1.07-.36.62-.47.87-1.24.62-1.98l-1.79-5.21 4.01-2.59c.66-.43.96-1.22.74-1.97-.23-.76-.92-1.27-1.72-1.27h-4.65l-1.87-5.43c-.25-.73-.91-1.2-1.69-1.2-.78 0-1.44.47-1.69 1.2L8.44 8.62H3.79c-.81 0-1.5.51-1.72 1.27-.22.75.08 1.54.74 1.97l4.01 2.6-1.79 5.21c-.25.74-.01 1.51.62 1.98a1.8 1.8 0 0 0 2.13 0L12 18.58l4.22 3.07Z",
    clipRule: "evenodd"
  })
});
var StarFullFill_default = SvgStarFullFill;

// src/icons/generated/StarHalfFill.tsx
import { jsx as jsx509, jsxs as jsxs453 } from "react/jsx-runtime";
var SvgStarHalfFill = (props) => /* @__PURE__ */ jsxs453("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs453("g", {
      fill: "currentColor",
      clipPath: "url(#star-half-fill_svg__a)",
      children: [
        /* @__PURE__ */ jsx509("path", {
          d: "M17.28 22a1.82 1.82 0 0 1-1.06-.35L12 18.58l-4.22 3.07a1.8 1.8 0 0 1-2.14 0 1.72 1.72 0 0 1-.62-2l1.8-5.22-4-2.59a1.75 1.75 0 0 1-.74-2 1.78 1.78 0 0 1 1.71-1.22h4.65l1.87-5.42a1.79 1.79 0 0 1 3.38 0l1.87 5.42h4.65a1.78 1.78 0 0 1 1.72 1.27 1.75 1.75 0 0 1-.74 2l-4 2.59L19 19.67a1.72 1.72 0 0 1-.62 2 1.8 1.8 0 0 1-1.1.33ZM4.58 10.62l3.48 2.25a1.75 1.75 0 0 1 .71 2l-1.62 4.77 3.79-2.76a1.8 1.8 0 0 1 2.12 0l3.79 2.76-1.62-4.72a1.76 1.76 0 0 1 .71-2.05l3.48-2.25h-4a1.79 1.79 0 0 1-1.69-1.19L12 4.42l-1.72 5a1.79 1.79 0 0 1-1.69 1.19l-4.01.01Z"
        }),
        /* @__PURE__ */ jsx509("path", {
          d: "M12 3.13v14.41L7 21l-1.03-1.01 2.04-5.66L3 10.66l.52-.99 5.62-.27L12 3.13Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx509("defs", {
      children: /* @__PURE__ */ jsx509("clipPath", {
        id: "star-half-fill_svg__a",
        children: /* @__PURE__ */ jsx509("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var StarHalfFill_default = SvgStarHalfFill;

// src/icons/generated/StarHalf.tsx
import { jsx as jsx510 } from "react/jsx-runtime";
var SvgStarHalf = (props) => /* @__PURE__ */ jsx510("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx510("path", {
    fill: "currentColor",
    d: "M12 1.99c-.78 0-1.44.47-1.69 1.2L8.44 8.62H3.79c-.81 0-1.5.51-1.72 1.27-.22.75.08 1.54.74 1.97l4.01 2.6-1.79 5.21c-.25.74-.01 1.51.62 1.98a1.8 1.8 0 0 0 2.13 0L12 18.58V1.99Z"
  })
});
var StarHalf_default = SvgStarHalf;

// src/icons/generated/Star.tsx
import { jsx as jsx511, jsxs as jsxs454 } from "react/jsx-runtime";
var SvgStar = (props) => /* @__PURE__ */ jsxs454("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx511("g", {
      clipPath: "url(#star_svg__a)",
      children: /* @__PURE__ */ jsx511("path", {
        fill: "currentColor",
        d: "M17.28 22c-.37 0-.74-.12-1.06-.35L12 18.58l-4.22 3.07a1.8 1.8 0 0 1-2.13 0c-.63-.47-.87-1.24-.62-1.98l1.79-5.21-4.01-2.6c-.66-.43-.96-1.22-.74-1.97.22-.76.91-1.27 1.72-1.27h4.65l1.87-5.43c.25-.73.92-1.2 1.69-1.2.77 0 1.44.47 1.69 1.2l1.87 5.43h4.65c.8 0 1.49.51 1.72 1.27.22.75-.08 1.54-.74 1.97l-4 2.59 1.79 5.21c.25.74.01 1.51-.62 1.98-.32.24-.7.36-1.07.36h-.01ZM12 16.54c.37 0 .74.12 1.06.35l3.79 2.75-1.62-4.72c-.26-.76.03-1.6.71-2.04l3.48-2.25h-4.01c-.77 0-1.45-.48-1.69-1.2l-1.72-5-1.72 5c-.25.72-.93 1.2-1.69 1.2H4.58l3.48 2.25c.68.44.98 1.28.71 2.04l-1.62 4.72 3.79-2.75c.32-.23.69-.35 1.06-.35Z"
      })
    }),
    /* @__PURE__ */ jsx511("defs", {
      children: /* @__PURE__ */ jsx511("clipPath", {
        id: "star_svg__a",
        children: /* @__PURE__ */ jsx511("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Star_default = SvgStar;

// src/icons/generated/SteeringWheel.tsx
import { jsx as jsx512, jsxs as jsxs455 } from "react/jsx-runtime";
var SvgSteeringWheel = (props) => /* @__PURE__ */ jsxs455("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs455("g", {
      fill: "currentColor",
      clipPath: "url(#steering-wheel_svg__a)",
      children: [
        /* @__PURE__ */ jsx512("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        }),
        /* @__PURE__ */ jsx512("path", {
          d: "M12 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        }),
        /* @__PURE__ */ jsx512("path", {
          d: "M12 22c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1ZM10 13c-.09 0-.19-.01-.28-.04l-6.75-2a.997.997 0 0 1 .57-1.91l6.75 2c.53.16.83.71.67 1.24-.13.43-.53.72-.96.72V13ZM14 13a1.002 1.002 0 0 1-.29-1.96l6.75-2a.996.996 0 1 1 .57 1.91l-6.75 2c-.09.03-.19.04-.28.04V13Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx512("defs", {
      children: /* @__PURE__ */ jsx512("clipPath", {
        id: "steering-wheel_svg__a",
        children: /* @__PURE__ */ jsx512("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var SteeringWheel_default = SvgSteeringWheel;

// src/icons/generated/Stroller.tsx
import { jsx as jsx513, jsxs as jsxs456 } from "react/jsx-runtime";
var SvgStroller = (props) => /* @__PURE__ */ jsxs456("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs456("g", {
      fill: "currentColor",
      clipPath: "url(#stroller_svg__a)",
      children: [
        /* @__PURE__ */ jsx513("path", {
          d: "M9 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM19 22a3 3 0 1 1 0-5.999A3 3 0 0 1 19 22Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15.5 15h-2.67a7 7 0 0 1-6.65-4.79L4.78 6H3a1 1 0 0 1 0-2h2.5a1 1 0 0 1 1 .68l1.63 4.9a5 5 0 0 0 4.7 3.42h2.67a4.507 4.507 0 1 0 .5-9v5a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1h.5a6.5 6.5 0 0 1 0 13Z"
        }),
        /* @__PURE__ */ jsx513("path", {
          d: "M21 10H7a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2ZM10 18a1.251 1.251 0 0 1-.32 0 1.001 1.001 0 0 1-.63-1.27l1-3a1.002 1.002 0 1 1 1.9.64l-1 3A1 1 0 0 1 10 18ZM18 18a1 1 0 0 1-.95-.68l-1-3a1.001 1.001 0 1 1 1.9-.64l1 3a1.001 1.001 0 0 1-.63 1.32 1.25 1.25 0 0 1-.32 0Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx513("defs", {
      children: /* @__PURE__ */ jsx513("clipPath", {
        id: "stroller_svg__a",
        children: /* @__PURE__ */ jsx513("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Stroller_default = SvgStroller;

// src/icons/generated/Suitcase.tsx
import { jsx as jsx514, jsxs as jsxs457 } from "react/jsx-runtime";
var SvgSuitcase = (props) => /* @__PURE__ */ jsxs457("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs457("g", {
      fill: "currentColor",
      clipPath: "url(#suitcase_svg__a)",
      children: [
        /* @__PURE__ */ jsx514("path", {
          d: "M20.04 20H3.96C2.88 20 2 19.12 2 18.04V7.96C2 6.88 2.88 6 3.96 6h16.08C21.12 6 22 6.88 22 7.96v10.08c0 1.08-.88 1.96-1.96 1.96ZM20 7.96 3.96 8 4 18.04 20 18V7.96Z"
        }),
        /* @__PURE__ */ jsx514("path", {
          d: "M15 8c-.55 0-1-.45-1-1V5h-4v2c0 .55-.45 1-1 1s-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1ZM7 20c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v12c0 .55-.45 1-1 1ZM17 20c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v12c0 .55-.45 1-1 1ZM4.89 21c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1ZM19.11 21c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx514("defs", {
      children: /* @__PURE__ */ jsx514("clipPath", {
        id: "suitcase_svg__a",
        children: /* @__PURE__ */ jsx514("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var Suitcase_default = SvgSuitcase;

// src/icons/generated/Sun.tsx
import { jsx as jsx515, jsxs as jsxs458 } from "react/jsx-runtime";
var SvgSun = (props) => /* @__PURE__ */ jsxs458("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx515("g", {
      fill: "currentColor",
      clipPath: "url(#sun_svg__a)",
      children: /* @__PURE__ */ jsx515("path", {
        d: "M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM12 7a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1ZM12 22a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1ZM6 13H3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2ZM21 13h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2ZM5.64 19.36a.999.999 0 0 1-.71-.29 1 1 0 0 1 0-1.41l2.12-2.12a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41l-2.12 2.12a1 1 0 0 1-.7.29ZM16.24 8.76a1 1 0 0 1-.7-.3 1 1 0 0 1 0-1.41l2.12-2.12a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41L17 8.46a1 1 0 0 1-.76.3ZM18.36 19.36a1 1 0 0 1-.7-.29L15.54 17a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l2.12 2.12a1 1 0 0 1 0 1.41 1 1 0 0 1-.71.24ZM7.76 8.76a1 1 0 0 1-.71-.3L4.93 6.34a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l2.12 2.12a1 1 0 0 1 0 1.41 1 1 0 0 1-.7.3Z"
      })
    }),
    /* @__PURE__ */ jsx515("defs", {
      children: /* @__PURE__ */ jsx515("clipPath", {
        id: "sun_svg__a",
        children: /* @__PURE__ */ jsx515("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Sun_default = SvgSun;

// src/icons/generated/Sustainable.tsx
import { jsx as jsx516 } from "react/jsx-runtime";
var SvgSustainable = (props) => /* @__PURE__ */ jsx516("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx516("path", {
    fill: "#352F28",
    fillRule: "evenodd",
    d: "M6.069 16.345c1.085-2.695 3.024-5.096 5.945-6.72a1 1 0 0 1 .972 1.75c-2.643 1.467-4.356 3.688-5.246 6.2 2.179.916 5.379.394 7.978-2.206 1.895-1.895 2.853-4.618 3.166-7.129.145-1.161.189-2.37-.015-3.528-5.606-.224-8.534-.134-11.238 2.57-3.076 3.075-3.243 6.992-1.562 9.063Zm-.673 2.142a6.323 6.323 0 0 1-.463-.42c-3.015-3.014-2.44-8.476 1.284-12.2 3.552-3.551 7.6-3.377 13.608-3.118l.408.018c1.198 1.198 1.531 9.385-3.1 14.016-2.909 2.909-6.878 3.896-9.913 2.752C7.072 20.345 7 21.171 7 22a1 1 0 0 1-2 0c0-1.177.13-2.36.396-3.513Z",
    clipRule: "evenodd"
  })
});
var Sustainable_default = SvgSustainable;

// src/icons/generated/Swap.tsx
import { jsx as jsx517, jsxs as jsxs459 } from "react/jsx-runtime";
var SvgSwap = (props) => /* @__PURE__ */ jsxs459("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx517("g", {
      fill: "currentColor",
      clipPath: "url(#swap_svg__a)",
      children: /* @__PURE__ */ jsx517("path", {
        d: "M12 21H9c-2.21 0-4-1.79-4-4V6.41L3.71 7.7a.996.996 0 0 1-1.41 0 .996.996 0 0 1-.01-1.41l3-3c.1-.1.21-.17.33-.22.12-.05.24-.08.38-.08.13 0 .26.03.38.08s.23.12.33.22l3 3A.996.996 0 1 1 8.3 7.7L7.01 6.41V17c0 1.1.9 2 2 2h3c.55 0 1 .45 1 1s-.45 1-1 1H12ZM18 21c-.13 0-.26-.03-.38-.08s-.23-.12-.33-.22l-3-3a.996.996 0 1 1 1.41-1.41l1.29 1.29V7c0-1.1-.9-2-2-2h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c2.21 0 4 1.79 4 4v10.59l1.29-1.29a.996.996 0 1 1 1.41 1.41l-3 3c-.1.1-.21.17-.33.22-.12.05-.24.08-.38.08L18 21Z"
      })
    }),
    /* @__PURE__ */ jsx517("defs", {
      children: /* @__PURE__ */ jsx517("clipPath", {
        id: "swap_svg__a",
        children: /* @__PURE__ */ jsx517("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var Swap_default = SvgSwap;

// src/icons/generated/Sweater.tsx
import { jsx as jsx518 } from "react/jsx-runtime";
var SvgSweater = (props) => /* @__PURE__ */ jsx518("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx518("path", {
    fill: "#352F28",
    fillRule: "evenodd",
    d: "M10 6.167c.879 0 1.652-.454 2.098-1.14.192-.296.496-.527.85-.527h1.219c2.3 0 4.166 1.867 4.166 4.167v7.5A.836.836 0 0 1 17.5 17H15v1.667c0 .46-.373.833-.833.833H5.833A.833.833 0 0 1 5 18.667V17H2.5a.836.836 0 0 1-.833-.833v-7.5c0-2.3 1.866-4.167 4.166-4.167h1.22c.353 0 .657.231.85.527A2.498 2.498 0 0 0 10 6.167Zm-3.334 0h-.833a2.507 2.507 0 0 0-2.5 2.5v6.666H5V9.5c0-.458.375-.833.833-.833.459 0 .834.375.834.833v8.333h6.666V9.5c0-.458.375-.833.834-.833.458 0 .833.375.833.833v5.833h1.667V8.667c0-1.375-1.125-2.5-2.5-2.5h-.833A4.16 4.16 0 0 1 10 7.833a4.16 4.16 0 0 1-3.334-1.666Z",
    clipRule: "evenodd"
  })
});
var Sweater_default = SvgSweater;

// src/icons/generated/SwimmingPool.tsx
import { jsx as jsx519, jsxs as jsxs460 } from "react/jsx-runtime";
var SvgSwimmingPool = (props) => /* @__PURE__ */ jsxs460("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs460("g", {
      fill: "currentColor",
      clipPath: "url(#swimming-pool_svg__a)",
      children: [
        /* @__PURE__ */ jsx519("path", {
          d: "M20.05 22h-.14a3.38 3.38 0 0 1-2.72-1.42A1.49 1.49 0 0 0 16 20a1.4 1.4 0 0 0-1.21.58A3.44 3.44 0 0 1 12 22a3.4 3.4 0 0 1-2.79-1.42A1.469 1.469 0 0 0 8 20a1.41 1.41 0 0 0-1.21.58A3.46 3.46 0 0 1 4 22a3.381 3.381 0 0 1-2.79-1.42 1 1 0 0 1 .23-1.39 1 1 0 0 1 1.39.23A1.39 1.39 0 0 0 4 20a1.539 1.539 0 0 0 1.21-.58A3.52 3.52 0 0 1 8 18a3.49 3.49 0 0 1 2.79 1.42A1.42 1.42 0 0 0 12 20a1.519 1.519 0 0 0 1.21-.58A3.542 3.542 0 0 1 16 18a3.49 3.49 0 0 1 2.79 1.42A1.39 1.39 0 0 0 20 20a1.539 1.539 0 0 0 1.21-.58 1 1 0 0 1 1.39-.23 1 1 0 0 1 .23 1.39A3.39 3.39 0 0 1 20.05 22Z"
        }),
        /* @__PURE__ */ jsx519("path", {
          d: "M20.05 18h-.14a3.38 3.38 0 0 1-2.72-1.42A1.49 1.49 0 0 0 16 16a1.401 1.401 0 0 0-1.21.58A3.359 3.359 0 0 1 12 18a3.4 3.4 0 0 1-2.79-1.42A1.471 1.471 0 0 0 8 16a1.41 1.41 0 0 0-1.21.58A3.379 3.379 0 0 1 4 18a3.379 3.379 0 0 1-2.79-1.42 1 1 0 0 1 .23-1.39 1 1 0 0 1 1.39.23A1.39 1.39 0 0 0 4 16a1.54 1.54 0 0 0 1.21-.58A3.5 3.5 0 0 1 8 14a3.41 3.41 0 0 1 2.79 1.42A1.42 1.42 0 0 0 12 16a1.52 1.52 0 0 0 1.21-.58A3.51 3.51 0 0 1 16 14a3.41 3.41 0 0 1 2.79 1.42A1.39 1.39 0 0 0 20 16a1.54 1.54 0 0 0 1.21-.58 1 1 0 0 1 1.39-.23 1 1 0 0 1 .23 1.39A3.39 3.39 0 0 1 20.05 18ZM15 13a1 1 0 0 1-1-1V4.5A2.5 2.5 0 0 1 16.5 2a1 1 0 1 1 0 2 .5.5 0 0 0-.5.5V12a1 1 0 0 1-1 1ZM9 13a1 1 0 0 1-1-1V4.5A2.5 2.5 0 0 1 10.5 2a1 1 0 1 1 0 2 .5.5 0 0 0-.5.5V12a1 1 0 0 1-1 1Z"
        }),
        /* @__PURE__ */ jsx519("path", {
          d: "M15 7H9a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2ZM15 11H9a1 1 0 0 1 0-2h6a1 1 0 1 1 0 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx519("defs", {
      children: /* @__PURE__ */ jsx519("clipPath", {
        id: "swimming-pool_svg__a",
        children: /* @__PURE__ */ jsx519("path", {
          fill: "#fff",
          d: "M1 2h22v20H1z"
        })
      })
    })
  ]
});
var SwimmingPool_default = SvgSwimmingPool;

// src/icons/generated/Synchronise.tsx
import { jsx as jsx520, jsxs as jsxs461 } from "react/jsx-runtime";
var SvgSynchronise = (props) => /* @__PURE__ */ jsxs461("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx520("g", {
      fill: "currentColor",
      clipPath: "url(#synchronise_svg__a)",
      children: /* @__PURE__ */ jsx520("path", {
        d: "M20 11.99a1 1 0 0 1-.99-.86c-.54-3.88-4.13-6.59-8.01-6.06a7.134 7.134 0 0 0-4.81 2.92H8c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.56.45-1 1-1s1 .45 1 1v1.28a9.106 9.106 0 0 1 5.72-3.18c4.98-.69 9.58 2.79 10.27 7.76.08.55-.31 1.05-.85 1.13H20v.01ZM12.02 21C7.55 21 3.64 17.7 3 13.15c-.08-.55.31-1.05.85-1.13.55-.08 1.05.31 1.13.85.54 3.88 4.13 6.59 8.01 6.06a7.134 7.134 0 0 0 4.81-2.92h-1.81c-.55 0-1-.45-1-1s.45-1 1-1H20c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-1.28A9.152 9.152 0 0 1 12.02 21Z"
      })
    }),
    /* @__PURE__ */ jsx520("defs", {
      children: /* @__PURE__ */ jsx520("clipPath", {
        id: "synchronise_svg__a",
        children: /* @__PURE__ */ jsx520("path", {
          fill: "#fff",
          d: "M3 3h18v18H3z"
        })
      })
    })
  ]
});
var Synchronise_default = SvgSynchronise;

// src/icons/generated/TShirt.tsx
import { jsx as jsx521 } from "react/jsx-runtime";
var SvgTShirt = (props) => /* @__PURE__ */ jsx521("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx521("path", {
    fill: "#352F28",
    fillRule: "evenodd",
    d: "M9 2.167c.879 0 1.652-.454 2.098-1.14.192-.296.496-.527.85-.527h1.219c2.3 0 4.166 1.867 4.166 4.167V8a.836.836 0 0 1-.833.833H14v5.834c0 .46-.373.833-.833.833H4.833A.833.833 0 0 1 4 14.667V8.833H1.5A.836.836 0 0 1 .667 8V4.667C.667 2.367 2.533.5 4.833.5h1.22c.353 0 .657.231.85.527A2.498 2.498 0 0 0 9 2.167Zm-3.334 0h-.833a2.507 2.507 0 0 0-2.5 2.5v2.5H4V5.5c0-.458.375-.833.833-.833.459 0 .834.375.834.833v8.333h6.666V5.5c0-.458.375-.833.834-.833.458 0 .833.375.833.833v1.667h1.667v-2.5c0-1.375-1.125-2.5-2.5-2.5h-.833A4.16 4.16 0 0 1 9 3.833a4.16 4.16 0 0 1-3.334-1.666Z",
    clipRule: "evenodd"
  })
});
var TShirt_default = SvgTShirt;

// src/icons/generated/Tag.tsx
import { jsx as jsx522, jsxs as jsxs462 } from "react/jsx-runtime";
var SvgTag = (props) => /* @__PURE__ */ jsxs462("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs462("g", {
      fill: "currentColor",
      clipPath: "url(#tag_svg__a)",
      children: [
        /* @__PURE__ */ jsx522("path", {
          d: "M8 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        }),
        /* @__PURE__ */ jsx522("path", {
          d: "M8 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        }),
        /* @__PURE__ */ jsx522("path", {
          d: "M13.64 22a3.001 3.001 0 0 1-2.14-.89L3.39 13a2.999 2.999 0 0 1-.89-2.14V7a4 4 0 0 1 4-4h3.86a3 3 0 0 1 2.14.88L20.61 12a3 3 0 0 1 0 4.28l-4.83 4.83a3 3 0 0 1-2.14.89ZM6.5 5a2 2 0 0 0-2 2v3.86a1 1 0 0 0 .3.72l8.12 8.12a1 1 0 0 0 1.45 0l4.83-4.83a1.001 1.001 0 0 0 0-1.45L11.08 5.3a1 1 0 0 0-.72-.3H6.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx522("defs", {
      children: /* @__PURE__ */ jsx522("clipPath", {
        id: "tag_svg__a",
        children: /* @__PURE__ */ jsx522("path", {
          fill: "#fff",
          d: "M2.5 3h19v19h-19z"
        })
      })
    })
  ]
});
var Tag_default = SvgTag;

// src/icons/generated/Target.tsx
import { jsx as jsx523, jsxs as jsxs463 } from "react/jsx-runtime";
var SvgTarget = (props) => /* @__PURE__ */ jsxs463("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs463("g", {
      fill: "currentColor",
      clipPath: "url(#target_svg__a)",
      children: [
        /* @__PURE__ */ jsx523("path", {
          d: "M19.29 9.68h-3.98c-.55 0-1-.45-1-1V4.71c0-1.49 1.21-2.71 2.71-2.71 1.36 0 2.48 1 2.68 2.3C21 4.5 22 5.62 22 6.98c0 1.49-1.21 2.71-2.71 2.71v-.01Zm-2.98-2h2.98c.39 0 .71-.32.71-.71 0-.39-.32-.71-.71-.71h-.57c-.55 0-1-.45-1-1v-.57c0-.39-.32-.71-.71-.71-.39 0-.71.32-.71.71v2.98l.01.01Z"
        }),
        /* @__PURE__ */ jsx523("path", {
          d: "M12 13c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l8-8.01A.996.996 0 1 1 20.7 4.7l-7.99 8.01c-.2.2-.45.29-.71.29Z"
        }),
        /* @__PURE__ */ jsx523("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c1.38 0 2.72.28 3.98.82.51.22.74.81.52 1.31-.22.51-.81.74-1.31.52A7.925 7.925 0 0 0 12 3.99C7.59 4 4 7.59 4 12s3.59 8 8 8 8-3.59 8-8c0-1.11-.22-2.19-.67-3.2-.22-.51 0-1.09.52-1.32.5-.22 1.1 0 1.32.52.55 1.26.83 2.61.83 4 0 5.51-4.49 10-10 10Z"
        }),
        /* @__PURE__ */ jsx523("path", {
          d: "M12 17.5A5.51 5.51 0 0 1 6.5 12c0-3.03 2.47-5.5 5.5-5.5 1.16 0 2.27.36 3.2 1.03.28.2.42.52.42.84.33 0 .64.13.84.42.68.94 1.04 2.05 1.04 3.22 0 3.03-2.47 5.5-5.5 5.5v-.01Zm0-9c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5a3.504 3.504 0 0 0 2.84-5.55c-.13-.18-.19-.4-.19-.61-.18 0-.43-.05-.61-.19-.6-.43-1.3-.65-2.04-.65Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx523("defs", {
      children: /* @__PURE__ */ jsx523("clipPath", {
        id: "target_svg__a",
        children: /* @__PURE__ */ jsx523("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Target_default = SvgTarget;

// src/icons/generated/Taxi.tsx
import { jsx as jsx524, jsxs as jsxs464 } from "react/jsx-runtime";
var SvgTaxi = (props) => /* @__PURE__ */ jsxs464("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs464("g", {
      fill: "currentColor",
      clipPath: "url(#taxi_svg__a)",
      children: [
        /* @__PURE__ */ jsx524("path", {
          d: "M20 21H4c-.38 0-.73-.21-.89-.55l-.79-1.58c-.21-.41-.32-.88-.32-1.34v-3.06c0-.46.11-.93.32-1.34l.76-1.51 1.29-3.88A3.987 3.987 0 0 1 8.16 5h7.68c1.72 0 3.25 1.1 3.79 2.74l1.29 3.88.76 1.51c.21.41.32.88.32 1.34v3.06c0 .46-.11.93-.32 1.34l-.79 1.58A1 1 0 0 1 20 21ZM4.62 19h14.76l.51-1.03c.07-.14.11-.29.11-.45v-3.06c0-.15-.04-.31-.11-.45l-.79-1.58s-.04-.09-.05-.13l-1.32-3.95a1.99 1.99 0 0 0-1.9-1.37H8.15c-.86 0-1.62.55-1.9 1.37L4.93 12.3s-.03.09-.05.13l-.79 1.58c-.07.14-.11.29-.11.45v3.06c0 .15.04.31.11.45L4.6 19h.02Z"
        }),
        /* @__PURE__ */ jsx524("path", {
          d: "M7.49 23H5.5c-.83 0-1.51-.68-1.51-1.51V20c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1.49c0 .83-.68 1.51-1.51 1.51h.01ZM18.49 23H16.5c-.83 0-1.51-.68-1.51-1.51V20c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1.49c0 .83-.68 1.51-1.51 1.51h.01ZM12.12 14H12c-3.93 0-6.29-.5-8.26-1.03a.994.994 0 0 1-.7-1.23c.14-.53.69-.85 1.23-.71 1.84.5 4.04.96 7.74.97h.11c3.73 0 5.81-.48 7.62-.97a1.005 1.005 0 0 1 .53 1.94c-1.94.52-4.17 1.03-8.15 1.03ZM7 17H6c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM18 17h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM12 18.25c-.75 0-1.51-.09-2.24-.28a1 1 0 0 1-.73-1.21c.13-.53.68-.86 1.21-.73 1.15.29 2.37.29 3.51 0a.995.995 0 0 1 1.21.73.995.995 0 0 1-.73 1.21c-.73.18-1.49.28-2.24.28H12Z"
        }),
        /* @__PURE__ */ jsx524("path", {
          d: "M20 13a1.01 1.01 0 0 1-.9-1.45l1-2c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-1 2c-.18.35-.53.55-.9.55L20 13Z"
        }),
        /* @__PURE__ */ jsx524("path", {
          d: "M23 11h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1ZM4 13c-.37 0-.72-.2-.9-.55l-1-2a.993.993 0 0 1 .45-1.34c.5-.25 1.1-.05 1.34.45l1 2c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11L4 13Z"
        }),
        /* @__PURE__ */ jsx524("path", {
          d: "M3 11H1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1ZM16 7H8c-.31 0-.6-.14-.79-.38a.982.982 0 0 1-.18-.86l1-4C8.14 1.31 8.54 1 9 1h6c.46 0 .86.31.97.76l1 4c.07.3 0 .62-.18.86-.19.24-.48.38-.79.38ZM9.28 5h5.44l-.5-2H9.78l-.5 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx524("defs", {
      children: /* @__PURE__ */ jsx524("clipPath", {
        id: "taxi_svg__a",
        children: /* @__PURE__ */ jsx524("path", {
          fill: "#fff",
          d: "M0 1h24v22H0z"
        })
      })
    })
  ]
});
var Taxi_default = SvgTaxi;

// src/icons/generated/Tennisball.tsx
import { jsx as jsx525, jsxs as jsxs465 } from "react/jsx-runtime";
var SvgTennisball = (props) => /* @__PURE__ */ jsxs465("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx525("g", {
      clipPath: "url(#tennisball_svg__a)",
      children: /* @__PURE__ */ jsx525("path", {
        fill: "currentColor",
        d: "M20 10c0-2.91-1.26-5.53-3.25-7.35v-.01c-.01-.01-.03-.02-.04-.03C14.93 1 12.59.01 10.01.01S5.07.99 3.29 2.6c-.01.01-.03.02-.04.03v.01C1.26 4.47 0 7.09 0 10s1.26 5.53 3.25 7.35v.01c.01.01.02.01.04.03C5.07 19 7.42 20 10 20s4.93-.99 6.71-2.61c.01-.01.03-.01.04-.03v-.01C18.74 15.52 20 12.91 20 10Zm-2 0c0 2.02-.76 3.86-2 5.27-2.67-3.04-2.62-7.57 0-10.55 1.24 1.41 2 3.25 2 5.27V10ZM2 10c0-2.02.76-3.86 2-5.27 2.61 2.98 2.67 7.5 0 10.55-1.24-1.41-2-3.25-2-5.27V10Zm3.49 6.6c3.35-3.81 3.28-9.48 0-13.21 1.28-.88 2.84-1.4 4.51-1.4s3.22.52 4.51 1.4c-3.28 3.73-3.35 9.4 0 13.21-1.28.88-2.84 1.4-4.51 1.4s-3.22-.52-4.51-1.4Z"
      })
    }),
    /* @__PURE__ */ jsx525("defs", {
      children: /* @__PURE__ */ jsx525("clipPath", {
        id: "tennisball_svg__a",
        children: /* @__PURE__ */ jsx525("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      })
    })
  ]
});
var Tennisball_default = SvgTennisball;

// src/icons/generated/ThumbsDown.tsx
import { jsx as jsx526, jsxs as jsxs466 } from "react/jsx-runtime";
var SvgThumbsDown = (props) => /* @__PURE__ */ jsxs466("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx526("g", {
      clipPath: "url(#thumbs-down_svg__a)",
      children: /* @__PURE__ */ jsx526("path", {
        fill: "currentColor",
        d: "M13 21.01a3 3 0 0 1-3-3v-1a3 3 0 0 0-3-3H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h2a2 2 0 0 1 1.6.8 4 4 0 0 1 2.4-.8h7c1.31-.12 2.56 1 3 2.77l1 5a1.23 1.23 0 0 1 0 .19 3 3 0 0 1-3 3h-2v4a3 3 0 0 1-3 3.04Zm-5-8.9a5 5 0 0 1 4 4.9v1a1 1 0 0 0 2 0v-5a1 1 0 0 1 1-1h3a1 1 0 0 0 1-.92l-1-4.88c-.16-.77-.6-1.2-.92-1.2H10a2 2 0 0 0-2 2v5.1Zm-4-7.1v7h2v-7H4Z"
      })
    }),
    /* @__PURE__ */ jsx526("defs", {
      children: /* @__PURE__ */ jsx526("clipPath", {
        id: "thumbs-down_svg__a",
        children: /* @__PURE__ */ jsx526("path", {
          fill: "#fff",
          d: "M2 3h19v18.01H2z"
        })
      })
    })
  ]
});
var ThumbsDown_default = SvgThumbsDown;

// src/icons/generated/ThumbsUp.tsx
import { jsx as jsx527, jsxs as jsxs467 } from "react/jsx-runtime";
var SvgThumbsUp = (props) => /* @__PURE__ */ jsxs467("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsx527("g", {
      clipPath: "url(#thumbs-up_svg__a)",
      children: /* @__PURE__ */ jsx527("path", {
        fill: "currentColor",
        d: "M17.11 21H10a4 4 0 0 1-2.4-.8A2 2 0 0 1 6 21H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3a3 3 0 0 0 3-3V6a3 3 0 0 1 6 0v4h2a3 3 0 0 1 3 3c.005.067.005.133 0 .2l-1 5c-.42 1.69-1.58 2.8-2.89 2.8ZM8 17a2 2 0 0 0 2 2h7c.42 0 .84-.43 1-1.23l1-4.85a1 1 0 0 0-1-.92h-3a1 1 0 0 1-1-1V6a1 1 0 0 0-2 0v1a5 5 0 0 1-4 4.9V17Zm-4-5v7h2v-7H4Z"
      })
    }),
    /* @__PURE__ */ jsx527("defs", {
      children: /* @__PURE__ */ jsx527("clipPath", {
        id: "thumbs-up_svg__a",
        children: /* @__PURE__ */ jsx527("path", {
          fill: "#fff",
          d: "M2 3h19v18H2z"
        })
      })
    })
  ]
});
var ThumbsUp_default = SvgThumbsUp;

// src/icons/generated/TicketFlight.tsx
import { jsx as jsx528, jsxs as jsxs468 } from "react/jsx-runtime";
var SvgTicketFlight = (props) => /* @__PURE__ */ jsxs468("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs468("g", {
      fill: "currentColor",
      clipPath: "url(#ticket-flight_svg__a)",
      children: [
        /* @__PURE__ */ jsx528("path", {
          d: "M21 21H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2 1 1 0 0 1-1-1V6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1v4a3 3 0 0 1-3 3ZM2 14.83V18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3.17a3 3 0 0 1-1.45-4.563A3 3 0 0 1 22 9.17V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.17a3 3 0 0 1 1.45 4.563A3 3 0 0 1 2 14.83Z"
        }),
        /* @__PURE__ */ jsx528("path", {
          d: "M16 7a1.2 1.2 0 0 1 1.65.23 1.11 1.11 0 0 1-.2 1.61l-2.21 1.64a.832.832 0 0 0-.32.58l-.45 5.49a.87.87 0 0 1-1.73 0l-.58-3.79-1.6 1.19a.33.33 0 0 0-.13.3l.18 1.9a.65.65 0 0 1-1.18.43l-3.25-4.12a.64.64 0 0 1 .74-1l1.84.67a.35.35 0 0 0 .33 0l1.61-1.18-3.63-1.54a.84.84 0 0 1 .47-1.61l5.59 1a.9.9 0 0 0 .66-.15L16 7Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx528("defs", {
      children: /* @__PURE__ */ jsx528("clipPath", {
        id: "ticket-flight_svg__a",
        children: /* @__PURE__ */ jsx528("path", {
          fill: "#fff",
          d: "M0 3h24v18H0z"
        })
      })
    })
  ]
});
var TicketFlight_default = SvgTicketFlight;

// src/icons/generated/TicketGeneral.tsx
import { jsx as jsx529, jsxs as jsxs469 } from "react/jsx-runtime";
var SvgTicketGeneral = (props) => /* @__PURE__ */ jsxs469("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs469("g", {
      fill: "currentColor",
      clipPath: "url(#ticket-general_svg__a)",
      children: [
        /* @__PURE__ */ jsx529("path", {
          d: "M21 21H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2 1 1 0 0 1-1-1V6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1v4a3 3 0 0 1-3 3ZM2 14.83V18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3.17a3 3 0 0 1 0-5.66V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.17a3 3 0 0 1 0 5.66Z"
        }),
        /* @__PURE__ */ jsx529("path", {
          d: "M15 8a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1ZM15 14a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1ZM15 20a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx529("defs", {
      children: /* @__PURE__ */ jsx529("clipPath", {
        id: "ticket-general_svg__a",
        children: /* @__PURE__ */ jsx529("path", {
          fill: "#fff",
          d: "M0 3h24v18H0z"
        })
      })
    })
  ]
});
var TicketGeneral_default = SvgTicketGeneral;

// src/icons/generated/Timeline.tsx
import { jsx as jsx530, jsxs as jsxs470 } from "react/jsx-runtime";
var SvgTimeline = (props) => /* @__PURE__ */ jsxs470("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs470("g", {
      fill: "currentColor",
      clipPath: "url(#timeline_svg__a)",
      children: [
        /* @__PURE__ */ jsx530("path", {
          d: "M12 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Zm0-12C9.24 4 7 6.24 7 9s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Z"
        }),
        /* @__PURE__ */ jsx530("path", {
          d: "M13 11c-.26 0-.51-.1-.71-.29l-1-1A.99.99 0 0 1 11 9V6c0-.55.45-1 1-1s1 .45 1 1v2.59l.71.71A.996.996 0 0 1 13 11ZM21 21H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx530("path", {
          d: "M19 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM15 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM11 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM7 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1ZM3 22c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx530("defs", {
      children: /* @__PURE__ */ jsx530("clipPath", {
        id: "timeline_svg__a",
        children: /* @__PURE__ */ jsx530("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Timeline_default = SvgTimeline;

// src/icons/generated/TinyHouseBungalow.tsx
import { jsx as jsx531 } from "react/jsx-runtime";
var SvgTinyHouseBungalow = (props) => /* @__PURE__ */ jsx531("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx531("path", {
    fill: "currentColor",
    d: "M20.57 2.18a.974.974 0 0 0-.92-.11L7 6.81V5c0-.55-.45-1-1-1s-1 .45-1 1v2.56l-1.35.51c-.39.15-.65.52-.65.94v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5h2v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V3c0-.33-.16-.63-.43-.82ZM19 20h-4v-5c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H5V9.69l14-5.25V20Z"
  })
});
var TinyHouseBungalow_default = SvgTinyHouseBungalow;

// src/icons/generated/Toast.tsx
import { jsx as jsx532, jsxs as jsxs471 } from "react/jsx-runtime";
var SvgToast = (props) => /* @__PURE__ */ jsxs471("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs471("g", {
      fill: "currentColor",
      clipPath: "url(#toast_svg__a)",
      children: [
        /* @__PURE__ */ jsx532("path", {
          d: "M7.61 22.54h-.18l-5.51-1a1.002 1.002 0 0 1-.81-1.16 1 1 0 0 1 1.15-.81l5.52 1a1 1 0 0 1 .81 1.2 1 1 0 0 1-.98.77Z"
        }),
        /* @__PURE__ */ jsx532("path", {
          d: "M4.85 22.06h-.18a1 1 0 0 1-.81-1.16l.73-4.13a1 1 0 0 1 1.15-.83 1 1 0 0 1 .81 1.15l-.73 4.14a1 1 0 0 1-.97.83Z"
        }),
        /* @__PURE__ */ jsx532("path", {
          d: "M6.53 18.01a6.265 6.265 0 0 1-1.13-.11 5.69 5.69 0 0 1-3.33-1.78 4.21 4.21 0 0 1-1-3.55.74.74 0 0 1 0-.14l1.57-4.66a1 1 0 0 1 1.1-.71l6.9 1.21a1 1 0 0 1 .82 1l-.16 4.94v.15a4.21 4.21 0 0 1-2.16 3c-.802.432-1.7.656-2.61.65Zm-3.51-5a2.24 2.24 0 0 0 .55 1.76 3.77 3.77 0 0 0 2.17 1.17 3.78 3.78 0 0 0 2.44-.32 2.179 2.179 0 0 0 1.13-1.53l.14-4-5.19-.91-1.24 3.83Z"
        }),
        /* @__PURE__ */ jsx532("path", {
          d: "M8.74 15.58a4.52 4.52 0 0 1-3.29-1.42 2.51 2.51 0 0 0-3-.52 1 1 0 0 1-1.401-1.207 1 1 0 0 1 .501-.583 4.53 4.53 0 0 1 5.32.94 2.5 2.5 0 0 0 3 .52 1 1 0 0 1 1.34.44 1 1 0 0 1-.47 1.34 4.389 4.389 0 0 1-2 .49ZM15.87 22.54a1 1 0 0 1-1-.82 1 1 0 0 1 .87-1.16l5.52-1a1 1 0 0 1 .34 1.97l-5.51 1-.22.01Z"
        }),
        /* @__PURE__ */ jsx532("path", {
          d: "M18.63 22.06a1 1 0 0 1-1-.83l-.73-4.14a1 1 0 0 1 .84-1.15 1 1 0 0 1 1.16.81l.73 4.13a1.002 1.002 0 0 1-.81 1.16l-.19.02Z"
        }),
        /* @__PURE__ */ jsx532("path", {
          d: "M16.95 18.01a5.43 5.43 0 0 1-2.62-.64 4.21 4.21 0 0 1-2.16-3v-.15l-.16-4.94a1 1 0 0 1 .82-1l6.9-1.21a1 1 0 0 1 1.11.7l1.54 4.7a.744.744 0 0 1 0 .14 4.21 4.21 0 0 1-1 3.55 5.69 5.69 0 0 1-3.33 1.78 6.268 6.268 0 0 1-1.1.07Zm-2.79-3.92a2.179 2.179 0 0 0 1.13 1.53 3.78 3.78 0 0 0 2.44.32 3.769 3.769 0 0 0 2.18-1.17 2.238 2.238 0 0 0 .55-1.82l-1.25-3.8-5.19.91.14 4.03Z"
        }),
        /* @__PURE__ */ jsx532("path", {
          d: "M13.16 15.2a1 1 0 0 1-.69-.27 1 1 0 0 1 0-1.41 4.52 4.52 0 0 1 5.27-.94 2.5 2.5 0 0 0 3-.52 1 1 0 0 1 1.41 0 1 1 0 0 1 .05 1.41 4.54 4.54 0 0 1-5.32.94 2.5 2.5 0 0 0-3 .52 1 1 0 0 1-.72.27ZM15.92 6.59a1 1 0 0 1-.844-.462A1 1 0 0 1 15.1 5.01l1.15-1.64a1 1 0 0 1 1.64 1.15l-1.15 1.64a1 1 0 0 1-.82.43ZM11.92 5a1 1 0 0 1-1-1V2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1ZM7.95 6.51a1 1 0 0 1-.82-.43L5.98 4.44a1 1 0 0 1 .995-1.557 1 1 0 0 1 .645.407l1.12 1.64a1 1 0 0 1-.25 1.39.93.93 0 0 1-.54.19Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx532("defs", {
      children: /* @__PURE__ */ jsx532("clipPath", {
        id: "toast_svg__a",
        children: /* @__PURE__ */ jsx532("path", {
          fill: "#fff",
          d: "M1 1h21.49v21.55H1z"
        })
      })
    })
  ]
});
var Toast_default = SvgToast;

// src/icons/generated/Tomorrowland.tsx
import { jsx as jsx533, jsxs as jsxs472 } from "react/jsx-runtime";
var SvgTomorrowland = (props) => /* @__PURE__ */ jsxs472("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs472("g", {
      fill: "currentColor",
      clipPath: "url(#tomorrowland_svg__a)",
      children: [
        /* @__PURE__ */ jsx533("path", {
          d: "M11.63 4.14a4.08 4.08 0 0 0-3.74 2.09s.21.69 1.74 1.7a4.09 4.09 0 0 1 2 2.43 4.14 4.14 0 0 1 2-2.43c1.53-1 1.74-1.7 1.74-1.7a4.08 4.08 0 0 0-3.74-2.09Zm0 3.65a4.66 4.66 0 0 1-3-1.56 3.65 3.65 0 0 1 3-1.55 3.67 3.67 0 0 1 3 1.55 4.7 4.7 0 0 1-3 1.56Z"
        }),
        /* @__PURE__ */ jsx533("path", {
          d: "M11.63 4.91a1.34 1.34 0 1 0 .04 2.68 1.34 1.34 0 0 0-.04-2.68Zm-.3 1.53a.48.48 0 0 1-.47-.44.469.469 0 0 1 .46-.48.46.46 0 0 1 .46.48.471.471 0 0 1-.46.49"
        }),
        /* @__PURE__ */ jsx533("path", {
          d: "M5.96 5.74a8.66 8.66 0 0 1 11.33 0c.2-.184.387-.381.56-.59a3.34 3.34 0 0 1-.75-1.92 2.65 2.65 0 0 1-2.3.11l-.28-.09A6.14 6.14 0 0 1 11.63 1a6 6 0 0 1-2.95 2.26l-.15.05a2.72 2.72 0 0 1-2.39-.08 3.29 3.29 0 0 1-.74 1.91c.17.215.358.415.56.6ZM20.29 12.17v.13a8.67 8.67 0 0 1-17.33 0v-.14a5.606 5.606 0 0 1-.72-.89c-.064.488-.097.978-.1 1.47 0 7.54 9.49 10.26 9.49 10.26s9.49-2.93 9.49-10.26a11.803 11.803 0 0 0-.1-1.46c-.209.32-.45.619-.72.89"
        }),
        /* @__PURE__ */ jsx533("path", {
          d: "M9.43 8.73c-1.67-1.08-4.88-2.84-5-4.55-6.94 7.22 3.1 10 3.1 10s-2.21.47-2.21 2C5.33 18.86 9.15 20 9.15 20s2.22-.72 2.22-6.41c0-2.5-.39-3.87-1.94-4.86ZM13.82 8.73c1.68-1.08 4.88-2.84 5-4.55 6.94 7.22-3.09 10-3.09 10s2.21.47 2.21 2c0 2.64-3.83 3.78-3.83 3.78s-2.22-.72-2.22-6.41c0-2.5.4-3.87 1.94-4.86"
        })
      ]
    }),
    /* @__PURE__ */ jsx533("defs", {
      children: /* @__PURE__ */ jsx533("clipPath", {
        id: "tomorrowland_svg__a",
        children: /* @__PURE__ */ jsx533("path", {
          fill: "#fff",
          d: "M2 1h19.26v22H2z"
        })
      })
    })
  ]
});
var Tomorrowland_default = SvgTomorrowland;

// src/icons/generated/Towel.tsx
import { jsx as jsx534 } from "react/jsx-runtime";
var SvgTowel = (props) => /* @__PURE__ */ jsx534("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx534("path", {
    fill: "currentColor",
    d: "M22.69 12.95A1.007 1.007 0 0 0 24 11.88l-.64-5.38C23.1 3.93 20.96 2 18.38 2H5.73C3.12 2 .93 4.04.75 6.62L0 13.9v2.6C0 19.53 2.47 22 5.5 22h13c3.03 0 5.5-2.47 5.5-5.5 0-1.35-.49-2.59-1.31-3.55Zm-1.32-6.23.64 5.4c0 .08.04.14.07.21A5.45 5.45 0 0 0 18.5 11H18V4h.38c1.55 0 2.83 1.16 2.99 2.72ZM14 4h2v7h-2V4Zm4.5 16h-13C3.57 20 2 18.43 2 16.5v-2.45l.74-7.26A3.002 3.002 0 0 1 5.73 4H12v7H6.5c-2.21 0-4 1.79-4 4s1.79 4 4 4H18a2.5 2.5 0 0 0 0-5H7c-.55 0-1 .45-1 1s.45 1 1 1h11c.28 0 .5.22.5.5s-.22.5-.5.5H6.5c-1.1 0-2-.9-2-2s.9-2 2-2h12c1.93 0 3.5 1.57 3.5 3.5S20.43 20 18.5 20Z"
  })
});
var Towel_default = SvgTowel;

// src/icons/generated/TrainFront.tsx
import { jsx as jsx535, jsxs as jsxs473 } from "react/jsx-runtime";
var SvgTrainFront = (props) => /* @__PURE__ */ jsxs473("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs473("g", {
      fill: "currentColor",
      clipPath: "url(#train-front_svg__a)",
      children: [
        /* @__PURE__ */ jsx535("path", {
          d: "M17 18H7c-1.65 0-3-1.35-3-3V6c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v9c0 1.65-1.35 3-3 3ZM8 4c-1.1 0-2 .9-2 2v9c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-1.1-.9-2-2-2H8Z"
        }),
        /* @__PURE__ */ jsx535("path", {
          d: "M12.1 12H12c-3.47 0-5.55-.51-7.29-1.04a.998.998 0 0 1-.66-1.25.99.99 0 0 1 1.25-.66c1.59.49 3.5.95 6.71.96h.1c3.23 0 5.04-.47 6.61-.96a.997.997 0 0 1 1.25.66.998.998 0 0 1-.66 1.25c-1.72.53-3.68 1.04-7.19 1.04h-.02ZM9 15H8c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1ZM16 15h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx535("path", {
          d: "M12 12c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1ZM6 22a1.01 1.01 0 0 1-.9-1.45l2-4c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-2 4c-.18.35-.53.55-.9.55L6 22ZM18 22c-.37 0-.72-.2-.9-.55l-2-4a.993.993 0 0 1 .45-1.34.99.99 0 0 1 1.34.45l2 4c.25.49.05 1.09-.45 1.34-.14.07-.3.11-.45.11L18 22Z"
        }),
        /* @__PURE__ */ jsx535("path", {
          d: "M17 21H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx535("defs", {
      children: /* @__PURE__ */ jsx535("clipPath", {
        id: "train-front_svg__a",
        children: /* @__PURE__ */ jsx535("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var TrainFront_default = SvgTrainFront;

// src/icons/generated/Train.tsx
import { jsx as jsx536, jsxs as jsxs474 } from "react/jsx-runtime";
var SvgTrain = (props) => /* @__PURE__ */ jsxs474("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs474("g", {
      fill: "currentColor",
      clipPath: "url(#train_svg__a)",
      children: [
        /* @__PURE__ */ jsx536("path", {
          d: "M13.51 18h-3.03C7.46 18 5 15.83 5 13.17v-6.4c0-1.36 1.02-3.24 2.64-3.92 2.72-1.11 6.01-1.1 8.71 0 1.63.69 2.64 2.57 2.65 3.92v6.41c0 2.67-2.46 4.84-5.49 4.84V18ZM12 4c-1.24 0-2.48.24-3.6.69C7.59 5.03 7 6.17 7 6.76v6.4C7 14.73 8.56 16 10.49 16h3.03c1.92 0 3.49-1.27 3.49-2.84V6.77c0-.59-.6-1.73-1.42-2.07-1.1-.45-2.35-.69-3.58-.69L12 4Z"
        }),
        /* @__PURE__ */ jsx536("path", {
          d: "M12 12.06a18.7 18.7 0 0 1-4.17-.46C6.25 11.19 5.01 9.93 5 8.72V7.39c0-1.1 1.1-2.05 2.58-2.21 2.94-.23 5.89-.23 8.81 0 1.51.15 2.62 1.11 2.61 2.22v1.32c-.01 1.22-1.25 2.48-2.81 2.88h-.02c-1.34.31-2.75.47-4.17.47v-.01ZM7 7.48v1.23c.03.17.52.74 1.3.94 2.37.54 5.01.55 7.4 0 .78-.2 1.26-.77 1.29-.96v-1.2c-.09-.09-.37-.27-.79-.31-2.79-.21-5.64-.22-8.45 0-.4.04-.67.22-.76.31L7 7.48ZM8 22c-.16 0-.32-.04-.47-.12a.996.996 0 0 1-.42-1.35l2-3.79c.26-.49.86-.67 1.35-.42.49.26.68.86.42 1.35l-2 3.79c-.18.34-.53.53-.89.53L8 22ZM16 22c-.36 0-.71-.19-.89-.53l-2-3.79a.996.996 0 0 1 .42-1.35.996.996 0 0 1 1.35.42l2 3.79c.26.49.07 1.09-.42 1.35-.15.08-.31.12-.47.12L16 22Z"
        }),
        /* @__PURE__ */ jsx536("path", {
          d: "M15 21H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1ZM14 15c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.18-.19-.29-.45-.29-.71 0-.13.03-.26.08-.38s.12-.23.21-.33c.1-.09.21-.16.33-.21.36-.16.81-.07 1.09.21.09.1.16.21.21.33.06.12.08.25.08.38 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29ZM10 15c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.28-.28.72-.37 1.09-.21.13.05.23.12.33.21.19.19.29.45.29.71 0 .26-.1.52-.29.71-.19.18-.45.29-.71.29ZM12 11.58c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1v4.58c0 .55-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx536("defs", {
      children: /* @__PURE__ */ jsx536("clipPath", {
        id: "train_svg__a",
        children: /* @__PURE__ */ jsx536("path", {
          fill: "#fff",
          d: "M5 2.02h14V22H5z"
        })
      })
    })
  ]
});
var Train_default = SvgTrain;

// src/icons/generated/TransmissionAutomatic.tsx
import { jsx as jsx537, jsxs as jsxs475 } from "react/jsx-runtime";
var SvgTransmissionAutomatic = (props) => /* @__PURE__ */ jsxs475("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs475("g", {
      fill: "currentColor",
      clipPath: "url(#transmission-automatic_svg__a)",
      children: [
        /* @__PURE__ */ jsx537("path", {
          d: "M9 22c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1ZM9 13c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v9c0 .55-.45 1-1 1ZM20 4h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1ZM20 10h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1ZM20 16h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1ZM20 22h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx537("path", {
          d: "M13 18H5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm-7-2h6v-2H6v2Z"
        }),
        /* @__PURE__ */ jsx537("path", {
          d: "M5 13H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx537("defs", {
      children: /* @__PURE__ */ jsx537("clipPath", {
        id: "transmission-automatic_svg__a",
        children: /* @__PURE__ */ jsx537("path", {
          fill: "#fff",
          d: "M3 2h18v20H3z"
        })
      })
    })
  ]
});
var TransmissionAutomatic_default = SvgTransmissionAutomatic;

// src/icons/generated/TransmissionManual.tsx
import { jsx as jsx538, jsxs as jsxs476 } from "react/jsx-runtime";
var SvgTransmissionManual = (props) => /* @__PURE__ */ jsxs476("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs476("g", {
      fill: "currentColor",
      clipPath: "url(#transmission-manual_svg__a)",
      children: [
        /* @__PURE__ */ jsx538("path", {
          d: "M5 9C3.35 9 2 7.65 2 6s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM12 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM19 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM5 21c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1ZM12 21c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
        }),
        /* @__PURE__ */ jsx538("path", {
          d: "M5 17c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1ZM12 17c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx538("path", {
          d: "M17 13H5c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1-.45 1-1V8c0-.55.45-1 1-1s1 .45 1 1v2c0 1.65-1.35 3-3 3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx538("defs", {
      children: /* @__PURE__ */ jsx538("clipPath", {
        id: "transmission-manual_svg__a",
        children: /* @__PURE__ */ jsx538("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var TransmissionManual_default = SvgTransmissionManual;

// src/icons/generated/Twitter.tsx
import { jsx as jsx539 } from "react/jsx-runtime";
var SvgTwitter = (props) => /* @__PURE__ */ jsx539("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx539("path", {
    fill: "currentColor",
    d: "M9.03 21.02a15.82 15.82 0 0 1-7.51-2 1 1 0 0 1 .52-1.87 7.6 7.6 0 0 0 3.91-.95 8.1 8.1 0 0 1-3.62-4.32 9.8 9.8 0 0 1 .8-7.23 1 1 0 0 1 1.302-.404 1 1 0 0 1 .378.314A8.43 8.43 0 0 0 11 8.12a4.9 4.9 0 0 1 3.27-4.65 4.86 4.86 0 0 1 5 .56l.19-.05a11.463 11.463 0 0 0 2.09-.72 1 1 0 0 1 1.07.12 1 1 0 0 1 .34 1 17.893 17.893 0 0 1-1.38 3.13c-.15.28-.33.63-.41.8a14.79 14.79 0 0 1-.53 3.86 12.001 12.001 0 0 1-8.34 8.43 11.548 11.548 0 0 1-3.27.42Zm-3.47-2.5a11 11 0 0 0 6.2.14 10.001 10.001 0 0 0 7-7.05c.313-1.133.468-2.304.46-3.48 0-.34.13-.6.63-1.56l.39-.76h-.2l-.72.2a1 1 0 0 1-1-.29 2.85 2.85 0 0 0-3.28-.46 2.92 2.92 0 0 0-2 2.78v1a1 1 0 0 1-1 1A10.43 10.43 0 0 1 4.3 7.02a7 7 0 0 0-.07 4.21 7 7 0 0 0 4.17 4 1 1 0 0 1 .16 1.75 14.996 14.996 0 0 1-3 1.54Z"
  })
});
var Twitter_default = SvgTwitter;

// src/icons/generated/TwoPersons.tsx
import { jsx as jsx540, jsxs as jsxs477 } from "react/jsx-runtime";
var SvgTwoPersons = (props) => /* @__PURE__ */ jsxs477("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs477("g", {
      fill: "currentColor",
      clipPath: "url(#two-persons_svg__a)",
      children: [
        /* @__PURE__ */ jsx540("path", {
          d: "M7.495 13a3.3 3.3 0 0 1-2.34-1.007A3.788 3.788 0 0 1 4.093 9.54L4 7.73c-.005-.486.08-.969.25-1.42.169-.45.42-.861.738-1.208a3.44 3.44 0 0 1 1.114-.812A3.24 3.24 0 0 1 7.42 4h.149a3.22 3.22 0 0 1 1.312.277c.416.183.794.453 1.113.794.318.341.571.746.744 1.192.172.446.261.924.261 1.407l-.065 1.87a3.787 3.787 0 0 1-1.076 2.467c-.64.644-1.486 1-2.364.993Zm-.074-7c-.413 0-.809.176-1.1.49a1.734 1.734 0 0 0-.457 1.18l.094 1.76c0 .443.164.868.455 1.18.292.314.688.49 1.101.49.413 0 .809-.176 1.1-.49.293-.312.457-.737.457-1.18l.065-1.81a1.728 1.728 0 0 0-.476-1.152A1.502 1.502 0 0 0 7.57 6h-.15Z"
        }),
        /* @__PURE__ */ jsx540("path", {
          d: "M12 21H3a.986.986 0 0 1-.707-.302A1.045 1.045 0 0 1 2 19.97V17.15c0-1.366.527-2.675 1.464-3.641A4.928 4.928 0 0 1 7 12h1c1.326 0 2.598.543 3.536 1.508A5.228 5.228 0 0 1 13 17.148v2.822c0 .273-.105.535-.293.728A.986.986 0 0 1 12 21Zm-8-2.06h7V17.15c0-.82-.316-1.605-.879-2.185A2.957 2.957 0 0 0 8 14.06H7c-.796 0-1.559.326-2.121.905A3.137 3.137 0 0 0 4 17.15v1.791ZM16.533 13a3.297 3.297 0 0 1-2.364-.993 3.787 3.787 0 0 1-1.076-2.467L13 7.73a3.93 3.93 0 0 1 .25-1.422c.17-.452.422-.863.741-1.21a3.439 3.439 0 0 1 1.117-.81A3.24 3.24 0 0 1 16.43 4h.15c.449 0 .893.095 1.308.28.415.184.792.454 1.11.795.318.34.57.745.742 1.19.172.446.26.923.26 1.405l-.093 1.87a3.79 3.79 0 0 1-1.052 2.443A3.303 3.303 0 0 1 16.533 13Zm-.075-7c-.413 0-.81.176-1.104.489-.293.312-.46.737-.462 1.181l.066 1.76c.03.417.205.806.491 1.09.286.284.661.441 1.051.441.39 0 .765-.157 1.05-.441a1.71 1.71 0 0 0 .493-1.09l.12-1.81a1.719 1.719 0 0 0-.469-1.152A1.494 1.494 0 0 0 16.607 6h-.149Z"
        }),
        /* @__PURE__ */ jsx540("path", {
          d: "M21 21h-9a.986.986 0 0 1-.707-.302A1.046 1.046 0 0 1 11 19.97V17.15c0-1.366.527-2.675 1.464-3.641A4.928 4.928 0 0 1 16 12h1c1.326 0 2.598.543 3.535 1.508A5.228 5.228 0 0 1 22 17.148v2.822c0 .273-.105.535-.293.728A.986.986 0 0 1 21 21Zm-8-2.06h7V17.15c0-.82-.316-1.605-.879-2.185A2.957 2.957 0 0 0 17 14.06h-1c-.796 0-1.559.326-2.121.905A3.137 3.137 0 0 0 13 17.15v1.791Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx540("defs", {
      children: /* @__PURE__ */ jsx540("clipPath", {
        id: "two-persons_svg__a",
        children: /* @__PURE__ */ jsx540("path", {
          fill: "#fff",
          d: "M2 3h20v18H2z"
        })
      })
    })
  ]
});
var TwoPersons_default = SvgTwoPersons;

// src/icons/generated/Umbrella.tsx
import { jsx as jsx541, jsxs as jsxs478 } from "react/jsx-runtime";
var SvgUmbrella = (props) => /* @__PURE__ */ jsxs478("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs478("g", {
      fill: "currentColor",
      clipPath: "url(#umbrella_svg__a)",
      children: [
        /* @__PURE__ */ jsx541("path", {
          d: "M21 22H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1ZM8.73 14.9c-.36 0-.71-.19-.89-.54-2.11-4.04-3.2-9.07-.58-10.58 2.62-1.51 6.44 1.95 8.88 5.81.3.47.16 1.08-.31 1.38-.46.3-1.08.16-1.38-.31-2.5-3.96-5.3-5.67-6.19-5.15-.9.52-.82 3.79 1.36 7.93.26.49.07 1.09-.42 1.35-.15.08-.31.11-.46.11h-.01Z"
        }),
        /* @__PURE__ */ jsx541("path", {
          d: "M3.81 17.75c-.39 0-.75-.23-.91-.59C.73 12.32 2.65 6.44 7.26 3.78s10.65-1.39 13.76 2.9c.24.32.27.76.06 1.11-.23.39-.7.58-1.14.45-.5-.15-1.48-.32-2.34.17-.3.17-1.02.7-1.32 1.95a.99.99 0 0 1-1.15.75c-.53-.09-1.91-.23-3.3.57-1.27.74-1.87 1.8-2.15 2.57-.18.5-.72.77-1.22.62-.51-.15-1.49-.33-2.35.16-.37.21-1.04.75-1.32 1.94a.99.99 0 0 1-.88.76h-.09l-.01.02Zm8.68-13.37c-1.45 0-2.91.36-4.23 1.12-3.05 1.77-4.65 5.27-4.17 8.63.37-.4.74-.65 1.02-.82.88-.51 1.94-.69 3.04-.54.6-1.18 1.51-2.14 2.68-2.81 1.42-.82 2.83-.95 3.78-.9.58-1.42 1.55-2.12 1.99-2.37.4-.23.82-.39 1.21-.48a8.65 8.65 0 0 0-5.32-1.82v-.01Z"
        }),
        /* @__PURE__ */ jsx541("path", {
          d: "M7.76 5.64c-.35 0-.68-.18-.87-.5L5.94 3.5c-.28-.48-.11-1.09.37-1.37s1.09-.11 1.37.37l.95 1.64a1.002 1.002 0 0 1-.87 1.5ZM17.16 21.92c-.35 0-.68-.18-.87-.5l-5.61-9.71c-.28-.48-.11-1.09.37-1.37s1.09-.11 1.37.37l5.61 9.71a1.002 1.002 0 0 1-.87 1.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx541("defs", {
      children: /* @__PURE__ */ jsx541("clipPath", {
        id: "umbrella_svg__a",
        children: /* @__PURE__ */ jsx541("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Umbrella_default = SvgUmbrella;

// src/icons/generated/Upgrade.tsx
import { jsx as jsx542, jsxs as jsxs479 } from "react/jsx-runtime";
var SvgUpgrade = (props) => /* @__PURE__ */ jsxs479("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs479("g", {
      fill: "currentColor",
      clipPath: "url(#upgrade_svg__a)",
      children: [
        /* @__PURE__ */ jsx542("path", {
          d: "M19 22H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1ZM12 18c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx542("path", {
          d: "M17 9c-.26 0-.51-.1-.71-.29L12 4.41l-4.29 4.3A.996.996 0 1 1 6.3 7.3l4.99-5.01a.996.996 0 0 1 1.41 0l5 5a.996.996 0 0 1-.71 1.7L17 9Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx542("defs", {
      children: /* @__PURE__ */ jsx542("clipPath", {
        id: "upgrade_svg__a",
        children: /* @__PURE__ */ jsx542("path", {
          fill: "#fff",
          d: "M4 2h16v20H4z"
        })
      })
    })
  ]
});
var Upgrade_default = SvgUpgrade;

// src/icons/generated/Villa.tsx
import { jsx as jsx543 } from "react/jsx-runtime";
var SvgVilla = (props) => /* @__PURE__ */ jsx543("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx543("path", {
    fill: "currentColor",
    d: "M21 11h-7V3s-.01-.04-.01-.07c0-.07-.02-.13-.04-.2s-.04-.13-.07-.19c-.01-.02-.01-.04-.02-.06-.02-.03-.05-.05-.08-.09a.502.502 0 0 0-.14-.15c-.05-.04-.1-.07-.16-.11-.06-.03-.11-.06-.17-.08-.07-.02-.13-.03-.2-.04-.04 0-.07-.02-.11-.02-.02 0-.04.01-.07.01-.07 0-.13.02-.19.04-.07.02-.13.04-.19.07-.02.01-.04.01-.06.02l-10 6.01c-.3.18-.49.51-.49.86v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1Zm-9-6.23V11H8c-.55 0-1 .45-1 1v8H4V9.57l8-4.8ZM14 20v-2h1v2h-1Zm6 0h-3v-3c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v3H9v-7h11v7Z"
  })
});
var Villa_default = SvgVilla;

// src/icons/generated/Volume.tsx
import { jsx as jsx544, jsxs as jsxs480 } from "react/jsx-runtime";
var SvgVolume = (props) => /* @__PURE__ */ jsxs480("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs480("g", {
      fill: "currentColor",
      clipPath: "url(#volume_svg__a)",
      children: [
        /* @__PURE__ */ jsx544("path", {
          d: "M15 16.93a1 1 0 0 1-.6-1.8c.3-.23.57-.5.8-.8a4 4 0 0 0-.8-5.6 1 1 0 1 1 1.2-1.6 6 6 0 0 1 0 9.6 1 1 0 0 1-.6.2Z"
        }),
        /* @__PURE__ */ jsx544("path", {
          d: "M17.7 19.93a1 1 0 0 1-.96-.718 1 1 0 0 1 .34-1.062c.439-.36.835-.77 1.18-1.22a8 8 0 0 0-1.18-11.22 1.002 1.002 0 1 1 1.26-1.56 10 10 0 0 1 1.49 14.07 10.996 10.996 0 0 1-1.49 1.49 1 1 0 0 1-.64.22ZM10.21 20.86a1.82 1.82 0 0 1-1.55-.87l-3.15-4.06H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.51l3.15-4A1.8 1.8 0 0 1 12 5.05v13.81a1.86 1.86 0 0 1-.32 1.25 1.81 1.81 0 0 1-1.17.73c-.1.017-.2.023-.3.02ZM4 9.93v4h2a1 1 0 0 1 .79.39L10 18.44v-13l-3.21 4.1a1 1 0 0 1-.79.39H4Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx544("defs", {
      children: /* @__PURE__ */ jsx544("clipPath", {
        id: "volume_svg__a",
        children: /* @__PURE__ */ jsx544("path", {
          fill: "#fff",
          d: "M2 3h20.04v17.87H2z"
        })
      })
    })
  ]
});
var Volume_default = SvgVolume;

// src/icons/generated/Voucher.tsx
import { jsx as jsx545, jsxs as jsxs481 } from "react/jsx-runtime";
var SvgVoucher = (props) => /* @__PURE__ */ jsxs481("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs481("g", {
      fill: "currentColor",
      clipPath: "url(#voucher_svg__a)",
      children: [
        /* @__PURE__ */ jsx545("path", {
          d: "M21 21H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2 1 1 0 0 1-1-1V6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1v4a3 3 0 0 1-3 3ZM2 14.83V18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3.17a3 3 0 0 1 0-5.66V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.17a3 3 0 0 1 0 5.66Z"
        }),
        /* @__PURE__ */ jsx545("path", {
          d: "M10 17a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l4-8a1 1 0 0 1 1.78.9l-4 8A1 1 0 0 1 10 17ZM16 17a3 3 0 1 1 0-5.999A3 3 0 0 1 16 17Zm0-4a1 1 0 1 0 0 2.002A1 1 0 0 0 16 13ZM8 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx545("defs", {
      children: /* @__PURE__ */ jsx545("clipPath", {
        id: "voucher_svg__a",
        children: /* @__PURE__ */ jsx545("path", {
          fill: "#fff",
          d: "M0 3h24v18H0z"
        })
      })
    })
  ]
});
var Voucher_default = SvgVoucher;

// src/icons/generated/Wallet.tsx
import { jsx as jsx546, jsxs as jsxs482 } from "react/jsx-runtime";
var SvgWallet = (props) => /* @__PURE__ */ jsxs482("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs482("g", {
      fill: "currentColor",
      clipPath: "url(#wallet_svg__a)",
      children: [
        /* @__PURE__ */ jsx546("path", {
          d: "M6.31 10.04c-.21 0-.43-.07-.61-.21a.992.992 0 0 1-.18-1.4l4.93-6.42c.87-1.13 2.5-1.35 3.63-.48l4.14 3.18c.55.42.9 1.03.99 1.72.09.69-.09 1.37-.51 1.91l-.96 1.25a.99.99 0 0 1-1.4.18.992.992 0 0 1-.18-1.4l.96-1.24c.1-.12.14-.28.12-.44a.57.57 0 0 0-.23-.39l-4.14-3.18a.592.592 0 0 0-.83.11L7.11 9.65c-.2.26-.49.39-.79.39h-.01Z"
        }),
        /* @__PURE__ */ jsx546("path", {
          d: "M10.8 9.75c-.21 0-.43-.07-.61-.21a.992.992 0 0 1-.18-1.4l3.88-5.05c.34-.44.96-.52 1.4-.18.44.34.52.96.18 1.4l-3.88 5.05c-.2.26-.49.39-.79.39Z"
        }),
        /* @__PURE__ */ jsx546("path", {
          d: "M18 22H3.96C2.88 22 2 21.12 2 20.04V9.94C2 8.87 2.87 8 3.94 8H18c1.1 0 2 .9 2 2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H3.94L4 20.04 18 20v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 1.1-.9 2-2 2Z"
        }),
        /* @__PURE__ */ jsx546("path", {
          d: "M20 19h-3c-1.65 0-3-1.35-3-3v-2c0-1.65 1.35-3 3-3h3c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2Zm-3-6c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h3v-4h-3Z"
        }),
        /* @__PURE__ */ jsx546("path", {
          d: "M18 16c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.09-.1-.16-.2-.21-.33A.995.995 0 0 1 17 15c0-.26.11-.52.29-.71.1-.09.21-.16.33-.21.37-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .13-.02.26-.08.38-.05.13-.12.23-.21.33-.19.18-.45.29-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx546("defs", {
      children: /* @__PURE__ */ jsx546("clipPath", {
        id: "wallet_svg__a",
        children: /* @__PURE__ */ jsx546("path", {
          fill: "#fff",
          d: "M2 1h20v21H2z"
        })
      })
    })
  ]
});
var Wallet_default = SvgWallet;

// src/icons/generated/WarningCircle.tsx
import { jsx as jsx547, jsxs as jsxs483 } from "react/jsx-runtime";
var SvgWarningCircle = (props) => /* @__PURE__ */ jsxs483("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs483("g", {
      fill: "currentColor",
      clipPath: "url(#warning-circle_svg__a)",
      children: [
        /* @__PURE__ */ jsx547("path", {
          d: "M12 15c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1ZM12 18c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71 0-.26.11-.52.29-.71.28-.28.72-.37 1.09-.21.13.05.23.12.33.21.19.19.29.45.29.71 0 .26-.1.52-.29.71-.1.09-.2.16-.33.21-.12.06-.25.08-.38.08Z"
        }),
        /* @__PURE__ */ jsx547("path", {
          d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10Zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx547("defs", {
      children: /* @__PURE__ */ jsx547("clipPath", {
        id: "warning-circle_svg__a",
        children: /* @__PURE__ */ jsx547("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var WarningCircle_default = SvgWarningCircle;

// src/icons/generated/WarningSquare.tsx
import { jsx as jsx548, jsxs as jsxs484 } from "react/jsx-runtime";
var SvgWarningSquare = (props) => /* @__PURE__ */ jsxs484("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs484("g", {
      fill: "currentColor",
      clipPath: "url(#warning-square_svg__a)",
      children: [
        /* @__PURE__ */ jsx548("path", {
          d: "M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
        }),
        /* @__PURE__ */ jsx548("path", {
          d: "M12 15c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1ZM12 18c-.13 0-.26-.02-.38-.08-.12-.05-.23-.12-.33-.21-.04-.05-.09-.1-.12-.15a.757.757 0 0 1-.09-.18.636.636 0 0 1-.06-.18c0-.07-.02-.14-.02-.2 0-.07 0-.13.02-.2.01-.06.03-.12.06-.18.02-.06.05-.12.09-.17.03-.06.08-.11.12-.16.1-.09.21-.16.33-.21.36-.16.81-.07 1.09.21.04.05.09.1.12.16.04.05.07.11.09.17.03.06.05.12.06.18.01.07.02.13.02.2 0 .06 0 .13-.02.2 0 .06-.03.12-.06.18-.02.06-.05.12-.09.18-.03.05-.08.1-.12.15-.19.18-.45.29-.71.29Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx548("defs", {
      children: /* @__PURE__ */ jsx548("clipPath", {
        id: "warning-square_svg__a",
        children: /* @__PURE__ */ jsx548("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var WarningSquare_default = SvgWarningSquare;

// src/icons/generated/WarningTriangle.tsx
import { jsx as jsx549, jsxs as jsxs485 } from "react/jsx-runtime";
var SvgWarningTriangle = (props) => /* @__PURE__ */ jsxs485("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs485("g", {
      fill: "currentColor",
      clipPath: "url(#warning-triangle_svg__a)",
      children: [
        /* @__PURE__ */ jsx549("path", {
          d: "M12 15.96a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1ZM12 18.96a.84.84 0 0 1-.38-.08 1.001 1.001 0 0 1-.33-.21 1.152 1.152 0 0 1-.21-.33 1.001 1.001 0 0 1-.08-.38 1.23 1.23 0 0 1 0-.19c.01-.066.03-.13.06-.19a.559.559 0 0 1 .09-.17c.035-.057.075-.11.12-.16a1 1 0 0 1 .33-.21 1 1 0 0 1 1.09.21c.045.05.085.103.12.16.04.051.07.108.09.17.03.06.05.124.06.19.023.06.037.125.04.19a.84.84 0 0 1-.08.38 1.15 1.15 0 0 1-.21.33 1.05 1.05 0 0 1-.71.29Z"
        }),
        /* @__PURE__ */ jsx549("path", {
          d: "M22 21.96H2a1 1 0 0 1-.86-.49 1 1 0 0 1 0-1l10-18a1 1 0 0 1 1.74 0l10 18a1 1 0 0 1 0 1 1 1 0 0 1-.88.49Zm-18.3-2h16.6L12 5.02 3.7 19.96Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx549("defs", {
      children: /* @__PURE__ */ jsx549("clipPath", {
        id: "warning-triangle_svg__a",
        children: /* @__PURE__ */ jsx549("path", {
          fill: "#fff",
          d: "M1 2h22v19.96H1z"
        })
      })
    })
  ]
});
var WarningTriangle_default = SvgWarningTriangle;

// src/icons/generated/WashingMachine.tsx
import { jsx as jsx550 } from "react/jsx-runtime";
var SvgWashingMachine = (props) => /* @__PURE__ */ jsx550("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx550("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 2H7C5.35 2 4 3.35 4 5v14c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3Zm1 17c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v14ZM8.01 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm4-1c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1ZM16 5h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1Zm-4 4c2.72 0 4.94 2.2 4.99 4.91V14c0 2.76-2.28 5-5 5S7.05 16.8 7 14.09V14c0-2.76 2.28-5 5-5Zm2.92 4.34A2.992 2.992 0 0 0 12 11h-.01c-1.12 0-2.08.62-2.6 1.53 1.02-.13 2.04.06 3.05.57.84.42 1.65.49 2.48.24Zm-5.84 1.32C9.38 16 10.57 17 12 17h.01c1.12 0 2.08-.62 2.6-1.53-.2.03-.4.04-.6.04-.82 0-1.64-.2-2.45-.61-.84-.42-1.65-.49-2.48-.24Z",
    clipRule: "evenodd"
  })
});
var WashingMachine_default = SvgWashingMachine;

// src/icons/generated/Weather.tsx
import { jsx as jsx551, jsxs as jsxs486 } from "react/jsx-runtime";
var SvgWeather = (props) => /* @__PURE__ */ jsxs486("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs486("g", {
      fill: "currentColor",
      clipPath: "url(#weather_svg__a)",
      children: [
        /* @__PURE__ */ jsx551("path", {
          d: "M15.09 13.77c-.2 0-.4-.06-.58-.19a.994.994 0 0 1-.23-1.39c.34-.47.51-1.03.51-1.61a2.791 2.791 0 1 0-5.23 1.36 1 1 0 0 1-1.74.98 4.74 4.74 0 0 1-.61-2.33C7.21 7.95 9.36 5.8 12 5.8s4.79 2.15 4.79 4.79c0 1-.31 1.96-.88 2.77a1 1 0 0 1-.82.42v-.01Z"
        }),
        /* @__PURE__ */ jsx551("path", {
          d: "M12 7.79c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3.79c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx551("path", {
          d: "M12 7.79c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3.79c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx551("path", {
          d: "M12 7.79c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3.79c0 .55-.45 1-1 1ZM19.58 11.58h-3.79c-.55 0-1-.45-1-1s.45-1 1-1h3.79c.55 0 1 .45 1 1s-.45 1-1 1ZM8.21 11.58H4.42c-.55 0-1-.45-1-1s.45-1 1-1h3.79c.55 0 1 .45 1 1s-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx551("path", {
          d: "M7.9 16.86c-.42 0-.82-.27-.95-.7-.14-.43-.21-.87-.21-1.32 0-2.38 1.94-4.32 4.32-4.32 1.58 0 3.04.87 3.79 2.26.26.49.08 1.09-.4 1.36-.49.26-1.09.08-1.36-.4a2.322 2.322 0 0 0-4.25 1.82.999.999 0 0 1-.65 1.26c-.1.03-.2.05-.3.05l.01-.01Z"
        }),
        /* @__PURE__ */ jsx551("path", {
          d: "M16.74 22H6.32C3.94 22 2 20.06 2 17.68c0-2.38 1.94-4.32 4.32-4.32.65 0 1.27.14 1.85.42.5.24.71.83.47 1.33-.24.5-.83.71-1.33.47A2.322 2.322 0 0 0 4 17.68C4 18.96 5.04 20 6.32 20h10.42a3.26 3.26 0 0 0 0-6.52c-1.06 0-2.05.52-2.67 1.38-.32.45-.94.56-1.39.24a.996.996 0 0 1-.24-1.39 5.29 5.29 0 0 1 4.3-2.23c2.9 0 5.26 2.36 5.26 5.26S19.64 22 16.74 22ZM14.68 8.9c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.68-2.68a.996.996 0 1 1 1.41 1.41l-2.68 2.68c-.2.2-.45.29-.71.29h.01ZM9.32 8.9c-.26 0-.51-.1-.71-.29L5.93 5.93a.996.996 0 1 1 1.41-1.41l2.68 2.68a.996.996 0 0 1-.71 1.7h.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx551("defs", {
      children: /* @__PURE__ */ jsx551("clipPath", {
        id: "weather_svg__a",
        children: /* @__PURE__ */ jsx551("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Weather_default = SvgWeather;

// src/icons/generated/Wellness.tsx
import { jsx as jsx552, jsxs as jsxs487 } from "react/jsx-runtime";
var SvgWellness = (props) => /* @__PURE__ */ jsxs487("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs487("g", {
      fill: "currentColor",
      clipPath: "url(#wellness_svg__a)",
      children: [
        /* @__PURE__ */ jsx552("path", {
          d: "M15 20h-3a1 1 0 0 1-1-1v-2a7 7 0 0 1 7-7h3a1 1 0 0 1 1 1v2a7 7 0 0 1-7 7Zm-2-2h2a5 5 0 0 0 5-5v-1h-2a5 5 0 0 0-5 5v1Z"
        }),
        /* @__PURE__ */ jsx552("path", {
          d: "M12 20H9a7 7 0 0 1-7-7v-2a1 1 0 0 1 1-1h3a7 7 0 0 1 7 7v2a1 1 0 0 1-1 1Zm-8-8v1a5 5 0 0 0 5 5h2v-1a5 5 0 0 0-5-5H4Z"
        }),
        /* @__PURE__ */ jsx552("path", {
          d: "M7.57 12h-.14a1 1 0 0 1-.85-1.13l.08-.55a6.92 6.92 0 0 1 2.73-4.61l2-1.51a1 1 0 0 1 1.2 0l2 1.51a6.92 6.92 0 0 1 2.73 4.61l.08.54a1.01 1.01 0 1 1-2 .28l-.08-.54a5 5 0 0 0-1.95-3.29L12 6.25l-1.41 1.06a5 5 0 0 0-1.95 3.29l-.08.55a1 1 0 0 1-.99.85Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx552("defs", {
      children: /* @__PURE__ */ jsx552("clipPath", {
        id: "wellness_svg__a",
        children: /* @__PURE__ */ jsx552("path", {
          fill: "#fff",
          d: "M2 4h20v16H2z"
        })
      })
    })
  ]
});
var Wellness_default = SvgWellness;

// src/icons/generated/Whatsapp.tsx
import { jsx as jsx553, jsxs as jsxs488 } from "react/jsx-runtime";
var SvgWhatsapp = (props) => /* @__PURE__ */ jsxs488("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs488("g", {
      fill: "currentColor",
      clipPath: "url(#whatsapp_svg__a)",
      children: [
        /* @__PURE__ */ jsx553("path", {
          d: "M12.01 22c-1.39 0-2.79-.29-4.09-.88l-4.74.84c-.36.07-.73-.08-.96-.36a.989.989 0 0 1-.13-1.02l1.43-3.3a9.913 9.913 0 0 1-1.37-6.99 9.948 9.948 0 0 1 4.1-6.47C10.76.64 17.01 1.73 20.18 6.24S22.27 17 17.76 20.17A9.996 9.996 0 0 1 12 22h.01Zm-3.96-2.92c.15 0 .3.03.44.1a7.98 7.98 0 0 0 8.12-.64C20.22 16 21.08 11 18.54 7.39a7.966 7.966 0 0 0-5.17-3.28c-2.11-.37-4.23.11-5.97 1.34a7.966 7.966 0 0 0-3.28 5.17c-.37 2.1.11 4.23 1.34 5.97.2.29.24.65.1.97l-.91 2.09 3.21-.57c.06-.01.12-.02.18-.02l.01.02Z"
        }),
        /* @__PURE__ */ jsx553("path", {
          d: "M15 15.98h-1c-3.31 0-6-2.69-6-6v-1c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v1c0 .57-.31 1.06-.78 1.31.4 1.15 1.31 2.06 2.46 2.46.25-.46.75-.78 1.31-.78h1c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5l.01.01Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx553("defs", {
      children: /* @__PURE__ */ jsx553("clipPath", {
        id: "whatsapp_svg__a",
        children: /* @__PURE__ */ jsx553("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var Whatsapp_default = SvgWhatsapp;

// src/icons/generated/Wheelchair.tsx
import { jsx as jsx554, jsxs as jsxs489 } from "react/jsx-runtime";
var SvgWheelchair = (props) => /* @__PURE__ */ jsx554("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsxs489("g", {
    fill: "currentColor",
    children: [
      /* @__PURE__ */ jsx554("path", {
        fillRule: "evenodd",
        d: "M8.09 6.858a3 3 0 1 1 2.004-.065L10.34 9H16.5a1 1 0 1 1 0 2h-5.938l.326 2.939 6.545-.437a1 1 0 0 1 1.032.735L19.764 19h.736a1 1 0 0 1 0 2H19a1 1 0 0 1-.965-.737l-1.285-4.71-6.684.445a1 1 0 0 1-1.06-.887L8.09 6.857Zm.203-3.565a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414Z",
        clipRule: "evenodd"
      }),
      /* @__PURE__ */ jsx554("path", {
        d: "M7.409 10.127a1 1 0 0 1-.492 1.326 5.001 5.001 0 1 0 6.926 5.798 1 1 0 1 1 1.936.498A7.002 7.002 0 0 1 2 16a7.001 7.001 0 0 1 4.083-6.365 1 1 0 0 1 1.326.492Z"
      })
    ]
  })
});
var Wheelchair_default = SvgWheelchair;

// src/icons/generated/Wifi.tsx
import { jsx as jsx555 } from "react/jsx-runtime";
var SvgWifi = (props) => /* @__PURE__ */ jsx555("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /* @__PURE__ */ jsx555("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.3 8.79c5.06-5.06 13.32-5.06 18.41 0h.01a.996.996 0 1 1-1.41 1.41C15 5.92 8 5.92 3.72 10.2c-.2.19-.45.29-.71.29a.996.996 0 0 1-.71-1.7Zm2.82 2.83a.996.996 0 1 0 1.41 1.41 7.007 7.007 0 0 1 9.9 0c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41c-3.51-3.51-9.22-3.51-12.73 0Zm2.83 4.24a.996.996 0 0 1 0-1.41 5.003 5.003 0 0 1 7.07 0c.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29-.26 0-.51-.09-.71-.29a3 3 0 0 0-4.24 0 .996.996 0 0 1-1.41 0Zm3.54 1.13h.01c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .44-1 .99-1Z",
    clipRule: "evenodd"
  })
});
var Wifi_default = SvgWifi;

// src/icons/generated/Youtube.tsx
import { jsx as jsx556, jsxs as jsxs490 } from "react/jsx-runtime";
var SvgYoutube = (props) => /* @__PURE__ */ jsxs490("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs490("g", {
      fill: "currentColor",
      clipPath: "url(#youtube_svg__a)",
      children: [
        /* @__PURE__ */ jsx556("path", {
          d: "M17 20H7a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5ZM7 6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3H7Z"
        }),
        /* @__PURE__ */ jsx556("path", {
          d: "M10 16a1 1 0 0 1-.863-.496A1 1 0 0 1 9 15V9a1 1 0 0 1 1.51-.86l5 3a1 1 0 0 1 0 1.72l-5 3A1 1 0 0 1 10 16Zm1-5.23v2.46L13.06 12 11 10.77Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx556("defs", {
      children: /* @__PURE__ */ jsx556("clipPath", {
        id: "youtube_svg__a",
        children: /* @__PURE__ */ jsx556("path", {
          fill: "#fff",
          d: "M2 4h20v16H2z"
        })
      })
    })
  ]
});
var Youtube_default = SvgYoutube;

// src/icons/generated/ZoomIn.tsx
import { jsx as jsx557, jsxs as jsxs491 } from "react/jsx-runtime";
var SvgZoomIn = (props) => /* @__PURE__ */ jsxs491("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs491("g", {
      fill: "currentColor",
      clipPath: "url(#zoom-in_svg__a)",
      children: [
        /* @__PURE__ */ jsx557("path", {
          d: "M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Z"
        }),
        /* @__PURE__ */ jsx557("path", {
          d: "M21 22c-.26 0-.51-.1-.71-.29l-6-6a.996.996 0 1 1 1.41-1.41l6 6a.996.996 0 0 1-.71 1.7H21ZM10 14.5c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1Z"
        }),
        /* @__PURE__ */ jsx557("path", {
          d: "M13.5 11h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx557("defs", {
      children: /* @__PURE__ */ jsx557("clipPath", {
        id: "zoom-in_svg__a",
        children: /* @__PURE__ */ jsx557("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var ZoomIn_default = SvgZoomIn;

// src/icons/generated/ZoomOut.tsx
import { jsx as jsx558, jsxs as jsxs492 } from "react/jsx-runtime";
var SvgZoomOut = (props) => /* @__PURE__ */ jsxs492("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: [
    /* @__PURE__ */ jsxs492("g", {
      fill: "currentColor",
      clipPath: "url(#zoom-out_svg__a)",
      children: [
        /* @__PURE__ */ jsx558("path", {
          d: "M10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Z"
        }),
        /* @__PURE__ */ jsx558("path", {
          d: "M21 22c-.26 0-.51-.1-.71-.29l-6-6a.996.996 0 1 1 1.41-1.41l6 6a.996.996 0 0 1-.71 1.7H21ZM13.5 11h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx558("defs", {
      children: /* @__PURE__ */ jsx558("clipPath", {
        id: "zoom-out_svg__a",
        children: /* @__PURE__ */ jsx558("path", {
          fill: "#fff",
          d: "M2 2h20v20H2z"
        })
      })
    })
  ]
});
var ZoomOut_default = SvgZoomOut;

// src/components/Icon/Icon.tsx
import { jsx as jsx559 } from "react/jsx-runtime";
var iconSizes = {
  xs: "12px",
  sm: "16px",
  md: "24px",
  lg: "32px",
  xl: "40px",
  "2xl": "48px"
};
function Icon2({ className, glyph, size, ...attrs }) {
  const GlyphComponent = generated_exports2[glyph];
  if (GlyphComponent === void 0) {
    console.error(`Icon: No icon found for glyph "${glyph}"`);
    return null;
  }
  return /* @__PURE__ */ jsx559(IconWrapper5, {
    className,
    $size: size,
    children: /* @__PURE__ */ jsx559(GlyphComponent, {
      ...attrs
    })
  });
}
var IconWrapper5 = styled28.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize4($size)}
`;
Icon2.displayName = "Icon";
var modSize4 = (sizeName = "sm") => css16`
  & > svg {
    height: ${iconSizes[sizeName]};
    width: ${iconSizes[sizeName]};
  }
`;
var Icon_default2 = withStyleModifiers(styled28(Icon2)``, {
  modSize: modSize4
});

// src/components/Typography/Typography.tsx
import { css as css17, styled as styled29 } from "styled-components";
var Typography2 = styled29.span`
  margin: 0;

  ${({ $variant }) => modVariant2($variant)}
`;
Typography2.displayName = "Typography";
function modVariant2(variantName = "body-md") {
  return {
    "body-xs": css17`
      font-family: ${tk("typography_body_xs_typeface")};
      font-size: ${tk("typography_body_xs_size")};
      line-height: ${tk("typography_body_xs_line_height")};
      font-weight: ${tk("typography_body_xs_weight")};
      letter-spacing: ${tk("typography_body_xs_letter_spacing")};
    `,
    "body-xs-bold": css17`
      font-family: ${tk("typography_body_xs_bold_typeface")};
      font-size: ${tk("typography_body_xs_bold_size")};
      line-height: ${tk("typography_body_xs_bold_line_height")};
      font-weight: ${tk("typography_body_xs_bold_weight")};
      letter-spacing: ${tk("typography_body_xs_bold_letter_spacing")};
    `,
    "body-sm": css17`
      font-family: ${tk("typography_body_sm_typeface")};
      font-size: ${tk("typography_body_sm_size")};
      line-height: ${tk("typography_body_sm_line_height")};
      font-weight: ${tk("typography_body_sm_weight")};
      letter-spacing: ${tk("typography_body_sm_letter_spacing")};
    `,
    "body-sm-bold": css17`
      font-family: ${tk("typography_body_sm_bold_typeface")};
      font-size: ${tk("typography_body_sm_bold_size")};
      line-height: ${tk("typography_body_sm_bold_line_height")};
      font-weight: ${tk("typography_body_sm_bold_weight")};
      letter-spacing: ${tk("typography_body_sm_bold_letter_spacing")};
    `,
    "body-md": css17`
      font-family: ${tk("typography_body_md_typeface")};
      font-size: ${tk("typography_body_md_size")};
      line-height: ${tk("typography_body_md_line_height")};
      font-weight: ${tk("typography_body_md_weight")};
      letter-spacing: ${tk("typography_body_md_letter_spacing")};
    `,
    "body-md-bold": css17`
      font-family: ${tk("typography_body_md_bold_typeface")};
      font-size: ${tk("typography_body_md_bold_size")};
      line-height: ${tk("typography_body_md_bold_line_height")};
      font-weight: ${tk("typography_body_md_bold_weight")};
      letter-spacing: ${tk("typography_body_md_bold_letter_spacing")};
    `,
    "body-md-caption": css17`
      font-family: ${tk("typography_body_md_caption_typeface")};
      font-size: ${tk("typography_body_md_caption_size")};
      line-height: ${tk("typography_body_md_caption_line_height")};
      font-weight: ${tk("typography_body_md_caption_weight")};
      letter-spacing: ${tk("typography_body_md_caption_letter_spacing")};
    `,
    "body-lg": css17`
      font-family: ${tk("typography_body_lg_typeface")};
      font-size: ${tk("typography_body_lg_size")};
      line-height: ${tk("typography_body_lg_line_height")};
      font-weight: ${tk("typography_body_lg_weight")};
      letter-spacing: ${tk("typography_body_lg_letter_spacing")};
    `,
    "body-lg-bold": css17`
      font-family: ${tk("typography_body_lg_bold_typeface")};
      font-size: ${tk("typography_body_lg_bold_size")};
      line-height: ${tk("typography_body_lg_bold_line_height")};
      font-weight: ${tk("typography_body_lg_bold_weight")};
      letter-spacing: ${tk("typography_body_lg_bold_letter_spacing")};
    `,
    "heading-md": css17`
      font-family: ${tk("typography_heading_md_typeface")};
      font-size: ${tk("typography_heading_md_size")};
      line-height: ${tk("typography_heading_md_line_height")};
      font-weight: ${tk("typography_heading_md_weight")};
      letter-spacing: ${tk("typography_heading_md_letter_spacing")};
    `,
    "heading-lg": css17`
      font-family: ${tk("typography_heading_lg_typeface")};
      font-size: ${tk("typography_heading_lg_size")};
      line-height: ${tk("typography_heading_lg_line_height")};
      font-weight: ${tk("typography_heading_lg_weight")};
      letter-spacing: ${tk("typography_heading_lg_letter_spacing")};
    `,
    "heading-xl": css17`
      font-family: ${tk("typography_heading_xl_typeface")};
      font-size: ${tk("typography_heading_xl_size")};
      line-height: ${tk("typography_heading_xl_line_height")};
      font-weight: ${tk("typography_heading_xl_weight")};
      letter-spacing: ${tk("typography_heading_xl_letter_spacing")};
    `,
    "heading-2xl": css17`
      font-family: ${tk("typography_heading_2xl_typeface")};
      font-size: ${tk("typography_heading_2xl_size")};
      line-height: ${tk("typography_heading_2xl_line_height")};
      font-weight: ${tk("typography_heading_2xl_weight")};
      letter-spacing: ${tk("typography_heading_2xl_letter_spacing")};
    `,
    "label-thin": css17`
      font-family: ${tk("typography_label_thin_typeface")};
      font-size: ${tk("typography_label_thin_size")};
      line-height: ${tk("typography_label_thin_line_height")};
      font-weight: ${tk("typography_label_thin_weight")};
      letter-spacing: ${tk("typography_label_thin_letter_spacing")};
    `,
    "label": css17`
      font-family: ${tk("typography_label_typeface")};
      font-size: ${tk("typography_label_size")};
      line-height: ${tk("typography_label_line_height")};
      font-weight: ${tk("typography_label_weight")};
      letter-spacing: ${tk("typography_label_letter_spacing")};
    `
  }[variantName];
}
var Typography_default2 = withStyleModifiers(Typography2, {
  modVariant: modVariant2
});

// src/components/Accordion/clone-children-with-icon.tsx
import { Children as Children2, cloneElement, isValidElement as isValidElement2 } from "react";
var cloneChildrenWithIconProps = (children, $icon, $iconSize) => Children2.map(
  children,
  (child) => {
    var _a, _b;
    return isValidElement2(child) && cloneElement(child, {
      icon: (_a = child.props.icon) != null ? _a : $icon,
      iconSize: (_b = child.props.iconSize) != null ? _b : $iconSize
    });
  }
);

// src/components/Accordion/Accordion.tsx
import { jsx as jsx560, jsxs as jsxs493 } from "react/jsx-runtime";
var Wrapper4 = styled30.div`
  padding: ${tk("spacing_lg")} 0;

  &:last-of-type {
    border-bottom: 2px solid ${tk("color_semantic_border_subdued")};
  }

  ${Collapsible} {
    padding-top: ${tk("spacing_lg")};

    @media ${tk("mq_tablet")} {
      padding-right: ${tk("spacing_3xl")};
    }
  }

  ${CollapsibleTrigger} {
    width: 100%;
    text-align: left;

    ${Icon_default2}:last-of-type {
      transition: transform 200ms ease-out;
      margin-left: auto !important;
    }

    &[data-state='open'] {
      ${Icon_default2}:last-of-type {
        transform: rotate(180deg);
      }
    }
  }
`;
var StyledSpaceBetween2 = styled30(SpaceBetween)`
  padding: ${tk("spacing_2xs")} 0;
`;
var StyledSubtitle = styled30(Typography_default2)`
  color: ${tk("color_semantic_text_strong")};
`;
function Item6({
  children,
  title,
  subTitle,
  icon,
  iconSize = "small",
  iconIndicatorSize = "large",
  defaultOpen,
  onOpenChange,
  disabled,
  ...rest
}) {
  return /* @__PURE__ */ jsx560(Wrapper4, {
    ...rest,
    children: /* @__PURE__ */ jsxs493(CollapsibleRoot, {
      defaultOpen,
      onOpenChange,
      disabled,
      children: [
        /* @__PURE__ */ jsx560(CollapsibleTrigger, {
          children: /* @__PURE__ */ jsxs493(SpaceBetween, {
            alignItems: "center",
            direction: "x",
            children: [
              /* @__PURE__ */ jsxs493("div", {
                children: [
                  /* @__PURE__ */ jsxs493(StyledSpaceBetween2, {
                    direction: "x",
                    alignItems: "center",
                    spacing: tk("spacing_xs"),
                    children: [
                      icon && /* @__PURE__ */ jsx560(Icon_default2, {
                        glyph: icon,
                        size: iconSize === "small" ? "sm" : "md",
                        "aria-hidden": true
                      }),
                      /* @__PURE__ */ jsx560(Typography_default2, {
                        $variant: "body-md-caption",
                        children: title
                      })
                    ]
                  }),
                  subTitle && /* @__PURE__ */ jsx560(StyledSubtitle, {
                    $variant: "body-md",
                    children: subTitle
                  })
                ]
              }),
              /* @__PURE__ */ jsx560(Icon_default2, {
                glyph: "IconChevronDown",
                size: iconIndicatorSize === "small" ? "sm" : "md",
                "aria-hidden": true
              })
            ]
          })
        }),
        /* @__PURE__ */ jsx560(Collapsible, {
          children: /* @__PURE__ */ jsx560(Typography_default2, {
            children
          })
        })
      ]
    })
  });
}
Item6.displayName = "Accordion.Item";
var Root9 = styled30.article.attrs(({ children, $icon, $iconSize }) => ({
  children: cloneChildrenWithIconProps(children, $icon, $iconSize)
}))`
  padding: 0;
  margin: 0;
`;
Root9.displayName = "Accordion.Root";

// src/components/AirlineIcon/AirlineIcon.tsx
import { css as css18, styled as styled31 } from "styled-components";

// src/airline-logos/generated/index.ts
var generated_exports3 = {};
__export(generated_exports3, {
  IconAegeanAirlines: () => AegeanAirlines_default,
  IconAirBaltic: () => AirBaltic_default,
  IconAirCairo: () => AirCairo_default,
  IconAirEuropa: () => AirEuropa_default,
  IconAirSeven: () => AirSeven_default,
  IconArkefly: () => Arkefly_default,
  IconAtlanticAirways: () => AtlanticAirways_default,
  IconAustrianAirlines: () => AustrianAirlines_default,
  IconBrusselsAirlines: () => BrusselsAirlines_default,
  IconBulAir: () => BulAir_default,
  IconBulgariaAir: () => BulgariaAir_default,
  IconCityjet: () => Cityjet_default,
  IconCondor: () => Condor_default,
  IconCorendonAirlines: () => CorendonAirlines_default,
  IconDanishAirTransport: () => DanishAirTransport_default,
  IconEasyjet: () => Easyjet_default,
  IconEdelweiss: () => Edelweiss_default,
  IconEgyptair: () => Egyptair_default,
  IconEurowings: () => Eurowings_default,
  IconFlyegypt: () => Flyegypt_default,
  IconFreebirdAirlines: () => FreebirdAirlines_default,
  IconJet2: () => Jet2_default,
  IconJetTime: () => JetTime_default,
  IconLufthansa: () => Lufthansa_default,
  IconLuxair: () => Luxair_default,
  IconNesmaAirlines: () => NesmaAirlines_default,
  IconNorwegian: () => Norwegian_default,
  IconPegasus: () => Pegasus_default,
  IconRoyalAirMaroc: () => RoyalAirMaroc_default,
  IconRyanair: () => Ryanair_default,
  IconSas: () => Sas_default,
  IconSkyExpress: () => SkyExpress_default,
  IconSmartwings: () => Smartwings_default,
  IconSunExpress: () => SunExpress_default,
  IconSunclass: () => Sunclass_default,
  IconSundair: () => Sundair_default,
  IconSwiss: () => Swiss_default,
  IconTailwindAirlines: () => TailwindAirlines_default,
  IconTailwindAirlinesCopy: () => TailwindAirlinesCopy_default,
  IconTransavia: () => Transavia_default,
  IconTunisair: () => Tunisair_default,
  IconVolotea: () => Volotea_default,
  IconVueling: () => Vueling_default,
  IconWizzAir: () => WizzAir_default
});

// src/airline-logos/generated/AegeanAirlines.tsx
import { jsx as jsx561, jsxs as jsxs494 } from "react/jsx-runtime";
var SvgAegeanAirlines = (props) => /* @__PURE__ */ jsxs494("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx561("path", {
      fill: "#88A8D8",
      d: "M32.822 25H42a25.872 25.872 0 0 1-11.24-11.354C26.84 5.625 19.105.937 9 0l.206.73c6.91 2.812 11.756 7.29 14.54 13.645 2.063 4.27 5.157 8.02 9.076 10.625Z"
    }),
    /* @__PURE__ */ jsx561("path", {
      fill: "#1C4093",
      d: "M32.822 25H42a25.872 25.872 0 0 0-11.24 11.354C26.84 44.48 19.105 49.063 9 50l.206-.73c6.91-2.812 11.756-7.29 14.54-13.645 2.063-4.27 5.157-8.02 9.076-10.625Z"
    }),
    /* @__PURE__ */ jsx561("path", {
      fill: "#88A8D8",
      d: "M9 8.125c1.65 6.25 3.919 11.354 5.878 13.854 1.031 1.354 2.372 2.396 3.816 3.021h7.219a15.36 15.36 0 0 1-7.632-7.708C16.528 13.125 13.125 9.896 9 8.125Z"
    }),
    /* @__PURE__ */ jsx561("path", {
      fill: "#1C4093",
      d: "M9 41.875c1.65-6.25 3.919-11.354 5.878-13.854 1.031-1.354 2.372-2.396 3.816-3.021h7.219a15.36 15.36 0 0 0-7.632 7.708c-1.753 4.167-5.156 7.5-9.281 9.167Z"
    })
  ]
});
var AegeanAirlines_default = SvgAegeanAirlines;

// src/airline-logos/generated/AirBaltic.tsx
import { jsx as jsx562, jsxs as jsxs495 } from "react/jsx-runtime";
var SvgAirBaltic = (props) => /* @__PURE__ */ jsxs495("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx562("path", {
      fill: "#bfd730",
      d: "M0 5h50v40H0z"
    }),
    /* @__PURE__ */ jsx562("g", {
      fill: "#11175e",
      children: /* @__PURE__ */ jsx562("path", {
        d: "M12.834 28.934h1.42v-5.957h-1.42zm0-6.514h1.42V21h-1.42zM16.314 28.934h-1.42v-5.957h1.392v1.113c.446-.64 1.086-1.225 1.949-1.225.167 0 .25 0 .334.028v1.336c-.111-.027-.334-.027-.418-.027-.64 0-1.81.612-1.81 1.81v2.922zM18.93 28.934V21h2.562c.668 0 2.951 0 2.951 1.949 0 1.336-1.03 1.698-1.587 1.865.613.167 1.754.473 1.754 1.949 0 1.197-.918 2.171-2.95 2.171zm1.504-4.705h1.058c1.364 0 1.476-.807 1.476-1.085 0-1.003-1.03-1.003-1.337-1.003h-1.169v2.088zm0 3.536h.947c1.002 0 1.726-.334 1.726-1.17 0-.556-.306-1.196-1.615-1.196h-1.03v2.366zM28.647 28.934l-.167-.64c-.362.306-.919.752-1.81.752-1.058 0-1.837-.696-1.837-1.643 0-.612.223-1.336 1.531-1.782l1.726-.584c.25-.084.25-.084.25-.25v-.251c0-.501-.445-.64-1.001-.64-.947 0-1.81.584-2.144.807v-1.225c.39-.223 1.113-.613 2.366-.613 1.865 0 2.227.919 2.227 2.06v4.037h-1.141zm-1.559-2.533c-.613.223-.807.501-.807.919 0 .584.529.723.78.723.222 0 .723-.083 1.308-.668V25.9c-.084.056-.112.083-.362.167zM11.024 28.934l-.167-.612c-.361.306-.918.752-1.81.752-1.057 0-1.837-.697-1.837-1.643 0-.613.223-1.336 1.532-1.782l1.726-.584c.25-.084.278-.084.278-.251v-.25c0-.502-.445-.64-1.03-.64-.947 0-1.81.584-2.144.807v-1.225c.39-.223 1.114-.613 2.367-.613 1.865 0 2.227.919 2.227 2.06v4.037h-1.141zm-1.559-2.533c-.612.223-.807.501-.807.919 0 .584.53.723.78.723.222 0 .724-.083 1.308-.668V25.9c-.083.056-.111.083-.362.167zM30.345 21h1.42v7.934h-1.42zM33.018 24.062h-.891v-1.085h.89V21h1.42v1.977h1.086v1.085h-1.085v3.09c0 .446.055.836.724.836.167 0 .306-.028.417-.056v1.086c-.195.028-.39.055-.668.055-1.587 0-1.893-.807-1.893-1.837zM36.08 21h1.42v1.42h-1.42zm0 1.977h1.42v5.985h-1.42zM42.65 24.591c-.278-.25-.751-.612-1.559-.612-1.225 0-1.726 1.03-1.726 2.004 0 .418.111 2.005 1.67 2.005.808 0 1.337-.362 1.727-.64V28.6c-.279.14-.92.473-1.95.473-2.031 0-2.894-1.53-2.894-3.118 0-1.67.918-3.118 2.95-3.118.975 0 1.504.307 1.754.446v1.308z"
      })
    })
  ]
});
var AirBaltic_default = SvgAirBaltic;

// src/airline-logos/generated/AirCairo.tsx
import { jsx as jsx563, jsxs as jsxs496 } from "react/jsx-runtime";
var SvgAirCairo = (props) => /* @__PURE__ */ jsxs496("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx563("path", {
      fill: "#3d1063",
      d: "M4.293 21c-.545.015-1.09.012-1.635.02C1.77 23.58.888 26.141 0 28.701v.01h2.357c.552-1.54 1.068-3.092 1.613-4.634.048.095.087.194.118.296.347.998.682 2 1.037 2.996.181.445.35.896.53 1.341H8.12C7.226 26.143 6.342 23.571 5.45 21zm1.789 0c.895 2.569 1.776 5.143 2.67 7.711h2.556c-.843-2.421-1.677-4.847-2.517-7.27-.054-.148-.09-.305-.174-.441zm4.95 0c-.585.021-1.17.01-1.753.019.885 2.565 1.77 5.13 2.66 7.692h2.15c-.133-.364-.258-.732-.387-1.098.469-.005.937.007 1.406-.006.131 0 .268-.04.397-.012.426.364.834.749 1.258 1.116h3.334c-.865-.778-1.725-1.563-2.587-2.345a2.404 2.404 0 0 0 .356-1.586c-.115-1.03-.71-1.958-1.498-2.61A4.897 4.897 0 0 0 13.52 21zm14.745 0c-.59 1.683-1.173 3.367-1.767 5.048-.23.652-.498 1.296-.868 1.882a3.14 3.14 0 0 1-.677.781h2.085c.55-.242 1.054-.657 1.281-1.226l.602-1.517c.206-.543.373-1.1.583-1.641.52 1.458 1.018 2.924 1.536 4.384h2.5c-.895-2.569-1.776-5.142-2.67-7.711zm3.237 0c.895 2.569 1.775 5.143 2.67 7.711h2.556c-.893-2.569-1.772-5.142-2.665-7.711zm3.186 0c.895 2.569 1.776 5.143 2.67 7.711h2.15c-.125-.36-.245-.722-.367-1.083.648-.011 1.297.027 1.944-.033.422.372.843.747 1.268 1.116h3.382c-.871-.777-1.738-1.559-2.606-2.338a2.39 2.39 0 0 0 .353-.93c.086-.613-.06-1.238-.318-1.793-.37-.791-1.008-1.43-1.734-1.903A4.867 4.867 0 0 0 36.909 21zm4.683 2.35a1.4 1.4 0 0 1 1.207.722c.122.23.154.526.018.758-.135.238-.414.36-.68.362-.543.002-1.085.001-1.627 0l-.635-1.842c.572-.003 1.145-.002 1.717 0zm-24.645.014c.522 0 1.044-.002 1.566.001a1.38 1.38 0 0 1 1.19.714c.125.236.154.542.006.775-.145.239-.436.347-.706.342-.476 0-.952.003-1.428-.002-.208-.61-.418-1.22-.628-1.83z"
    }),
    /* @__PURE__ */ jsx563("path", {
      fill: "#f58220",
      d: "M22.224 21c-1.699.23-3.15 1.69-3.365 3.39-.127.926.034 1.905.537 2.7a4.352 4.352 0 0 0 1.833 1.621h1.236a3.14 3.14 0 0 0 .677-.781c.37-.586.638-1.23.868-1.882-.09.196-.26.342-.447.444-.663.38-1.552.17-2.047-.39-.356-.372-.42-.93-.347-1.419.067-.437.344-.814.694-1.072.66-.48 1.661-.376 2.207.232l.804-2.321A2.873 2.873 0 0 0 23.531 21zm21.673 0c-.69.097-1.365.38-1.864.875-.486.466-.822 1.1-.872 1.777-.065.82.185 1.642.603 2.34.502.823 1.246 1.48 2.077 1.957a5.443 5.443 0 0 0 2.72.746c.774.006 1.573-.168 2.209-.627.696-.491 1.18-1.288 1.23-2.146v-.369a4.358 4.358 0 0 0-.767-2.118c-.459-.664-1.086-1.195-1.766-1.621a5.607 5.607 0 0 0-2.23-.814zm1.272 2.215c.51.004 1.01.199 1.414.508.49.338.842.896.85 1.5.011.69-.652 1.22-1.31 1.223-.83.054-1.663-.383-2.117-1.076-.245-.394-.383-.902-.212-1.351.183-.466.663-.768 1.155-.794.073-.008.147-.011.22-.01z"
    })
  ]
});
var AirCairo_default = SvgAirCairo;

// src/airline-logos/generated/AirEuropa.tsx
import { jsx as jsx564 } from "react/jsx-runtime";
var SvgAirEuropa = (props) => /* @__PURE__ */ jsx564("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx564("path", {
    fill: "#006fde",
    d: "M9.515 43a9.07 9.07 0 0 1-2.923-.464c-1.777-.573-4.128-3.124-5.025-5.455a22.349 22.349 0 0 1-1.063-7.228c.004-2.578.409-5.14 1.2-7.596A27.538 27.538 0 0 1 6.64 13.54a21.978 21.978 0 0 1 3.289-3.203 14.136 14.136 0 0 1 3.496-2.044 15.74 15.74 0 0 1 5.653-1.038 13.94 13.94 0 0 1 5.07.914 12.035 12.035 0 0 1 4.576 3.136 15.253 15.253 0 0 1 5.709-3.34 17.512 17.512 0 0 1 5.331-.941h.157C40.267 7.008 40.6 7 40.934 7c3.11 0 5.508.684 7.133 2.033a7.184 7.184 0 0 1 1.885 2.627 7.118 7.118 0 0 1 .534 3.178 7.374 7.374 0 0 1-.918 3.207 9.092 9.092 0 0 1-2.192 2.826c-1.038.852-4.776 3.315-8.016 5.38a72.352 72.352 0 0 1-6.968 4.149l-.032-3.72 3.658-2.617c4.718-3.373 6.315-5.123 6.838-7.487.198-.82.235-1.67.11-2.503a3.894 3.894 0 0 0-.777-1.81 3.702 3.702 0 0 0-1.338-1.008 3.739 3.739 0 0 0-1.65-.319c-1.125.084-2.22.4-3.215.928A8.073 8.073 0 0 0 33.426 14a17.06 17.06 0 0 0-2.888 4.768 25.845 25.845 0 0 0-1.634 5.821 23.012 23.012 0 0 0-.215 5.813c.12 1.658.586 3.273 1.37 4.743.372.741.951 1.36 1.668 1.785a4.402 4.402 0 0 0 2.377.612c2.28 0 5.331-1.222 9.885-3.96l2.752-1.789 1.941 2.743a71.155 71.155 0 0 1-8.507 6.349 15.484 15.484 0 0 1-7.983 2.093 15.983 15.983 0 0 1-6.723-1.28 7.647 7.647 0 0 1-3.828-4.09 5.911 5.911 0 0 0-.953.66c-.532.397-1.26.941-2.066 1.488A16.888 16.888 0 0 1 9.515 43zM20.44 10.6c-1.02.043-2.02.3-2.934.752a11.672 11.672 0 0 0-3.094 2.523 17.765 17.765 0 0 0-2.696 3.724 22.25 22.25 0 0 0-2.276 9.319 15.015 15.015 0 0 0 1.535 7.79c.266.558.677 1.035 1.19 1.385s1.111.557 1.733.604c1.545-.06 3.475-1.28 5.518-2.571a94.012 94.012 0 0 1 1.548-.962 23.048 23.048 0 0 1 .144-7.065 40.91 40.91 0 0 1 1.51-6.063 14.997 14.997 0 0 0 1.08-4.669 5.804 5.804 0 0 0-.752-3.518 2.83 2.83 0 0 0-1.086-.953c-.44-.22-.929-.32-1.42-.296z"
  })
});
var AirEuropa_default = SvgAirEuropa;

// src/airline-logos/generated/AirSeven.tsx
import { jsx as jsx565, jsxs as jsxs497 } from "react/jsx-runtime";
var SvgAirSeven = (props) => /* @__PURE__ */ jsxs497("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx565("path", {
      d: "M38.602 5.578c-.098-.137-.282-.21-.54-.21H7.875c-.602 0-.797.343-.797.788v1.227c0 .441.207.785.797.785h26.637c.43 0 .664.285.55.75l-9.667 40.098c-.122.492 0 .886.601.886h1.305c.453 0 .808-.172.933-.613L38.652 6.168c.059-.285.035-.469-.05-.59Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    }),
    /* @__PURE__ */ jsx565("path", {
      d: "M45.95.207C45.851.074 45.663 0 45.405 0H4.965c-.602 0-.797.344-.797.785v1.23c0 .442.195.786.797.786h36.89c.43 0 .665.281.555.75L31.477 49.004c-.125.492 0 .887.601.887h1.3c.458 0 .813-.172.934-.618L45.996.785c.074-.27.05-.453-.047-.578Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    }),
    /* @__PURE__ */ jsx565("path", {
      d: "m19.902 33.488 4.008-16.597c.059-.27.035-.442-.05-.575-.098-.136-.258-.21-.516-.21h-9.645c-.601 0-.785.343-.785.785v1.23c0 .442.184.785.785.785h6.621c.075 0 .114.012.137.051.023.035.035.086.023.16L17.066 33.22c-.125.492 0 .883.602.883h1.316c.453 0 .809-.157.918-.614Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    }),
    /* @__PURE__ */ jsx565("path", {
      d: "M31.242 10.945c-.097-.133-.281-.207-.539-.207H10.79c-.601 0-.785.344-.785.785v1.227c0 .445.184.79.785.79h16.363c.43 0 .664.28.551.75l-8.375 34.702c-.125.492 0 .887.602.887h1.3c.454 0 .813-.172.934-.617l9.129-37.739c.059-.27.035-.453-.05-.578Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    })
  ]
});
var AirSeven_default = SvgAirSeven;

// src/airline-logos/generated/Arkefly.tsx
import { jsx as jsx566 } from "react/jsx-runtime";
var SvgArkefly = (props) => /* @__PURE__ */ jsx566("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx566("g", {
    fill: "#e41917",
    children: /* @__PURE__ */ jsx566("path", {
      d: "M2.375 16.143h11.886c1.165 0 2.043.368 2.389 2.023.384 1.84.226 3.12-1.845 3.267l-3.732.267c2.747 17.353 18.805 23.009 27.547 4.32 1.447-3.094 1.92-3.658 3.506-3.264 2.149.533 2.442 1.638 1.418 4.757-7.559 23.04-32.964 25.35-37.949-5.42l-3.032.22C.097 22.49 0 20.408 0 19.251c0-2.288.85-3.108 2.375-3.108zM45.589 5a4.411 4.411 0 1 1 0 8.823 4.411 4.411 0 0 1 0-8.823z"
    })
  })
});
var Arkefly_default = SvgArkefly;

// src/airline-logos/generated/AtlanticAirways.tsx
import { jsx as jsx567, jsxs as jsxs498 } from "react/jsx-runtime";
var SvgAtlanticAirways = (props) => /* @__PURE__ */ jsxs498("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx567("clipPath", {
      id: "atlantic-airways_svg__a",
      children: /* @__PURE__ */ jsx567("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs498("g", {
      fillRule: "evenodd",
      clipPath: "url(#atlantic-airways_svg__a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx567("path", {
          fill: "#00529b",
          d: "M17.544 27.553s-4.503-2.057-4.417-3.183a.45.45 0 0 1 .176-.308s2.346-2.585 6.893-4.405c3.67-1.472 4.537-1.37 4.537-1.37-.063 1.684 1.027 3.011 2.778 3.624 0 0 6.878-2.192 10.76-2.505 4.684-.38 6.385 1.365 6.385 1.365s3.894.224 5.185 1.022c0 0 .166.131.159.2-.003.023-.024.035-.078.035-.215.004-.932-.153-1.975-.04-2.494.267-6.992.82-8.32 1.557 0 0-7.216 11.44-39.627 11.275 0 0 10.03-2.186 17.544-7.267z"
        }),
        /* @__PURE__ */ jsx567("path", {
          fill: "#df3127",
          d: "M25.368 16.352c.285-.016.96.099 1.102.485 0 0-1.053-.633-14.373 3.597C7.922 21.757 1.627 17.371.015 16c0 0 5.037 1.326 25.353.35"
        })
      ]
    })
  ]
});
var AtlanticAirways_default = SvgAtlanticAirways;

// src/airline-logos/generated/AustrianAirlines.tsx
import { jsx as jsx568, jsxs as jsxs499 } from "react/jsx-runtime";
var SvgAustrianAirlines = (props) => /* @__PURE__ */ jsxs499("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx568("clipPath", {
      id: "austrian-airlines_svg__a",
      children: /* @__PURE__ */ jsx568("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs499("g", {
      fill: "#d81e05",
      fillRule: "evenodd",
      clipPath: "url(#austrian-airlines_svg__a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx568("path", {
          d: "M5.465 33.294c6.619-5.363 11.345-9.959 12.753-12.45.599-.961.79-1.88.458-2.629-.617-1.393-2.797-1.816-5.486-1.293A209.116 209.116 0 0 1 49.771 12a.222.222 0 0 1 .076.433C34.261 17.498 20.074 25.706 8.02 36.323a.11.11 0 0 1-.052.026L.123 37.725c-.11.02-.168-.123-.08-.192a208.677 208.677 0 0 0 5.422-4.239z"
        }),
        /* @__PURE__ */ jsx568("path", {
          d: "M4.414 19.011c-.174.048-.348.095-.524.146-.103.027-.094.18.014.195l2.972.425 5.191.742c.02.002.041-.002.06-.01 3.654-1.744 6.09-2.416 6.626-1.656.166.236.137.597-.057 1.066a5.266 5.266 0 0 1-.253.508c.57-.908.753-1.777.438-2.485-.59-1.318-2.672-1.718-5.248-1.221-3.09.69-6.164 1.454-9.218 2.29"
        })
      ]
    })
  ]
});
var AustrianAirlines_default = SvgAustrianAirlines;

// src/airline-logos/generated/BrusselsAirlines.tsx
import { jsx as jsx569 } from "react/jsx-runtime";
var SvgBrusselsAirlines = (props) => /* @__PURE__ */ jsx569("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx569("g", {
    fill: "#e5002b",
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: /* @__PURE__ */ jsx569("path", {
      d: "M12.007 40.225c0-1.6-1.306-2.897-2.92-2.897-1.612 0-2.92 1.297-2.92 2.897 0 1.6 1.308 2.896 2.92 2.896 1.614 0 2.92-1.296 2.92-2.896zM43.074 40.225c0-1.566-1.28-2.835-2.857-2.835s-2.857 1.27-2.857 2.835 1.28 2.834 2.857 2.834 2.857-1.27 2.857-2.834zM29.466 40.225c0-2.638-2.155-4.775-4.814-4.775-2.658 0-4.813 2.137-4.813 4.775S21.994 45 24.652 45c2.659 0 4.814-2.138 4.814-4.775zM13.175 24.784c0-2.24-1.83-4.056-4.088-4.056C6.83 20.728 5 22.544 5 24.784s1.83 4.055 4.087 4.055c2.258 0 4.088-1.816 4.088-4.055zM45 24.784c0-2.62-2.142-4.745-4.783-4.745-2.641 0-4.782 2.124-4.782 4.745 0 2.62 2.14 4.744 4.782 4.744 2.641 0 4.783-2.124 4.783-4.744zM30.162 24.784c0-3.019-2.467-5.466-5.51-5.466-3.042 0-5.509 2.447-5.509 5.466 0 3.018 2.467 5.465 5.51 5.465 3.042 0 5.509-2.447 5.509-5.465zM44.595 9.342c0-2.398-1.96-4.342-4.378-4.342C37.8 5 35.84 6.944 35.84 9.342c0 2.399 1.96 4.343 4.377 4.343 2.418 0 4.378-1.944 4.378-4.343zM27.837 9.342c0-1.744-1.426-3.158-3.185-3.158s-3.184 1.414-3.184 3.158c0 1.745 1.426 3.16 3.184 3.16s3.184-1.415 3.184-3.16zM9.088 12.177c-1.578 0-2.858-1.269-2.858-2.835 0-1.565 1.28-2.834 2.858-2.834s2.857 1.27 2.857 2.834c0 1.566-1.28 2.835-2.857 2.835z"
    })
  })
});
var BrusselsAirlines_default = SvgBrusselsAirlines;

// src/airline-logos/generated/BulAir.tsx
import { jsx as jsx570, jsxs as jsxs500 } from "react/jsx-runtime";
var SvgBulAir = (props) => /* @__PURE__ */ jsxs500("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsxs500("linearGradient", {
      id: "bul-air_svg__b",
      x1: 38.514,
      x2: 3.712,
      y1: 30.427,
      y2: 15.855,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx570("stop", {
          offset: 0,
          stopColor: "#e5e5e5"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.119,
          stopColor: "#eee"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.264,
          stopColor: "#fff"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.455,
          stopColor: "#fbfbfb"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.635,
          stopColor: "#f0f0f0"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.81,
          stopColor: "#ddd"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.981,
          stopColor: "#c2c2c2"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 1,
          stopColor: "#bfbfbf"
        })
      ]
    }),
    /* @__PURE__ */ jsxs500("linearGradient", {
      id: "bul-air_svg__c",
      x1: 18.988,
      x2: 25.154,
      y1: 11.509,
      y2: 41.029,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.093,
          stopColor: "#7fbb85"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.167,
          stopColor: "#73b874"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.338,
          stopColor: "#5aaf53"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.486,
          stopColor: "#45a73d"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.604,
          stopColor: "#38a231"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.676,
          stopColor: "#33a02c"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.885,
          stopColor: "#00742f"
        })
      ]
    }),
    /* @__PURE__ */ jsxs500("linearGradient", {
      id: "bul-air_svg__a",
      children: [
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.066,
          stopColor: "#e36853"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.352,
          stopColor: "red"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.533,
          stopColor: "#fd0002"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.628,
          stopColor: "#f40006"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.702,
          stopColor: "#e70009"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.766,
          stopColor: "#d3000c"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.823,
          stopColor: "#ba0010"
        }),
        /* @__PURE__ */ jsx570("stop", {
          offset: 0.85,
          stopColor: "#ab0012"
        })
      ]
    }),
    /* @__PURE__ */ jsx570("linearGradient", {
      xlinkHref: "#bul-air_svg__a",
      id: "bul-air_svg__d",
      x1: 24.81,
      x2: 24.862,
      y1: 20.59,
      y2: 38.545,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx570("linearGradient", {
      xlinkHref: "#bul-air_svg__a",
      id: "bul-air_svg__e",
      x1: 38.803,
      x2: 46.507,
      y1: 45.872,
      y2: 32.703,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx570("path", {
      fill: "url(#bul-air_svg__b)",
      d: "M48.507 31.893c-1.611-4.263-5.612-7.419-11.557-10.132C22.836 15.284 2.945 10.191 1 1c1 16.498 23.726 18.879 36.95 25.08 3.223 1.55 6 3.986 7.612 5.647 2.612 2.657 1.334 9.024-1.445 11.681 5.668-4.097 5.223-9.3 4.39-11.515z"
    }),
    /* @__PURE__ */ jsx570("path", {
      fill: "url(#bul-air_svg__c)",
      d: "M43.284 28.792c-9.946-6.92-35.45-11.681-38.061-16 5.167 13.177 29.504 12.513 38.394 20.65 6.724 6.146-.722 10.908-2.5 12.015 6.39-3.488 10.446-10.907 2.167-16.665z"
    }),
    /* @__PURE__ */ jsx570("path", {
      fill: "url(#bul-air_svg__d)",
      d: "M46.729 37.872c-.333-10.408-30.616-12.568-37.394-18.104C17.39 32.945 44.006 32.17 45.84 39.09c.389 1.495-.5 2.934-1.611 3.986 1.5-1.495 2.555-2.768 2.5-5.204z"
    }),
    /* @__PURE__ */ jsx570("path", {
      fill: "url(#bul-air_svg__e)",
      d: "M32.894 49c9.168-3.045 13.446-10.464 8.223-12.9 9.78 2.99 2.778 9.634-8.223 12.9z"
    })
  ]
});
var BulAir_default = SvgBulAir;

// src/airline-logos/generated/BulgariaAir.tsx
import { jsx as jsx571, jsxs as jsxs501 } from "react/jsx-runtime";
var SvgBulgariaAir = (props) => /* @__PURE__ */ jsxs501("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsxs501("linearGradient", {
      id: "bulgaria-air_svg__b",
      x1: 38.514,
      x2: 3.712,
      y1: 30.427,
      y2: 15.855,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx571("stop", {
          offset: 0,
          stopColor: "#e5e5e5"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.119,
          stopColor: "#eee"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.264,
          stopColor: "#fff"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.455,
          stopColor: "#fbfbfb"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.635,
          stopColor: "#f0f0f0"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.81,
          stopColor: "#ddd"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.981,
          stopColor: "#c2c2c2"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 1,
          stopColor: "#bfbfbf"
        })
      ]
    }),
    /* @__PURE__ */ jsxs501("linearGradient", {
      id: "bulgaria-air_svg__c",
      x1: 18.988,
      x2: 25.154,
      y1: 11.509,
      y2: 41.029,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.093,
          stopColor: "#7fbb85"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.167,
          stopColor: "#73b874"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.338,
          stopColor: "#5aaf53"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.486,
          stopColor: "#45a73d"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.604,
          stopColor: "#38a231"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.676,
          stopColor: "#33a02c"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.885,
          stopColor: "#00742f"
        })
      ]
    }),
    /* @__PURE__ */ jsxs501("linearGradient", {
      id: "bulgaria-air_svg__a",
      children: [
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.066,
          stopColor: "#e36853"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.352,
          stopColor: "red"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.533,
          stopColor: "#fd0002"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.628,
          stopColor: "#f40006"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.702,
          stopColor: "#e70009"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.766,
          stopColor: "#d3000c"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.823,
          stopColor: "#ba0010"
        }),
        /* @__PURE__ */ jsx571("stop", {
          offset: 0.85,
          stopColor: "#ab0012"
        })
      ]
    }),
    /* @__PURE__ */ jsx571("linearGradient", {
      xlinkHref: "#bulgaria-air_svg__a",
      id: "bulgaria-air_svg__d",
      x1: 24.81,
      x2: 24.862,
      y1: 20.59,
      y2: 38.545,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx571("linearGradient", {
      xlinkHref: "#bulgaria-air_svg__a",
      id: "bulgaria-air_svg__e",
      x1: 38.803,
      x2: 46.507,
      y1: 45.872,
      y2: 32.703,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx571("path", {
      fill: "url(#bulgaria-air_svg__b)",
      d: "M48.507 31.893c-1.611-4.263-5.612-7.419-11.557-10.132C22.836 15.284 2.945 10.191 1 1c1 16.498 23.726 18.879 36.95 25.08 3.223 1.55 6 3.986 7.612 5.647 2.612 2.657 1.334 9.024-1.445 11.681 5.668-4.097 5.223-9.3 4.39-11.515z"
    }),
    /* @__PURE__ */ jsx571("path", {
      fill: "url(#bulgaria-air_svg__c)",
      d: "M43.284 28.792c-9.946-6.92-35.45-11.681-38.061-16 5.167 13.177 29.504 12.513 38.394 20.65 6.724 6.146-.722 10.908-2.5 12.015 6.39-3.488 10.446-10.907 2.167-16.665z"
    }),
    /* @__PURE__ */ jsx571("path", {
      fill: "url(#bulgaria-air_svg__d)",
      d: "M46.729 37.872c-.333-10.408-30.616-12.568-37.394-18.104C17.39 32.945 44.006 32.17 45.84 39.09c.389 1.495-.5 2.934-1.611 3.986 1.5-1.495 2.555-2.768 2.5-5.204z"
    }),
    /* @__PURE__ */ jsx571("path", {
      fill: "url(#bulgaria-air_svg__e)",
      d: "M32.894 49c9.168-3.045 13.446-10.464 8.223-12.9 9.78 2.99 2.778 9.634-8.223 12.9z"
    })
  ]
});
var BulgariaAir_default = SvgBulgariaAir;

// src/airline-logos/generated/Cityjet.tsx
import { jsx as jsx572 } from "react/jsx-runtime";
var SvgCityjet = (props) => /* @__PURE__ */ jsx572("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx572("path", {
    fill: "#781520",
    d: "M47.955 6H19.02L2 17.902h28.091l.01-.005L18.892 44l17.548-11.082L48 6h-.045Z"
  })
});
var Cityjet_default = SvgCityjet;

// src/airline-logos/generated/Condor.tsx
import { jsx as jsx573 } from "react/jsx-runtime";
var SvgCondor = (props) => /* @__PURE__ */ jsx573("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx573("path", {
    fill: "currentColor",
    d: "M3.004 24.5C2.778 12.238 12.726 2.113 25.049 2h.452C37.824 1.889 47.886 11.789 48 24.05v.45c.113 12.262-9.723 22.274-21.932 22.499H25.5c-12.322.112-22.384-9.675-22.497-21.937V24.5zm2.148.113c-.113 11.137 8.705 20.249 19.897 20.474h.452c11.193.112 20.35-8.775 20.463-19.912v-.45c.226-11.137-8.818-20.362-20.01-20.474H25.5C14.31 4.138 5.151 13.138 5.04 24.388c.113-.113.113 0 .113.225zm2.6-6.75h10.853v1.912l-2.148.563 7.01 4.5s-3.731-3.263-2.488-5.738c.565-.9 1.583-1.35 2.714-1.237h19.784L31.607 27.2l-1.357-1.35 5.765-5.512H25.05c-.113 0-.678 0-.791.337-.792 1.688 5.653 8.1 11.984 12.375l2.713 1.8V38z"
  })
});
var Condor_default = SvgCondor;

// src/airline-logos/generated/CorendonAirlines.tsx
import { jsx as jsx574 } from "react/jsx-runtime";
var SvgCorendonAirlines = (props) => /* @__PURE__ */ jsx574("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx574("path", {
    fill: "#cf2a2b",
    fillRule: "evenodd",
    d: "M41.46 12.275c-2.161.062-4.301-.982-4.768-3.239-.281-1.358-.161-2.819.521-4.045.745-1.344 2.49-2.25 3.97-2.447 2.572-.344 4.98 1.358 5.378 4.021.435 2.94-2.299 5.41-5.05 5.71zM9.203 24.825c.308-2.74-1.691-4.004-3.55-4.48-1.623-.396-2.971-.586-2.587-1.857l.058-.131c.594-1.258 2.058-1.92 4.017-2.447l.84-.206c1.853-.428 4.024-.59 6.127-.965a17.71 17.71 0 0 0 2.686-.669c1.948-.861 3.203-2.75 3.996-4.669.336-.785.59-1.578.775-2.308.285-1.155.511-2.164.868-2.916.36-.668.85-1.12 1.65-1.233 1.56-.172 2.181 1.533 2.689 4 .576 2.84.494 6.833 1.87 9.28.737.996 2.133 1.354 3.82 1.347 1.993-.007 4.35-.524 6.466-1.15 2.649-.786 4.954-1.5 6.415-1.369.761.07 1.303.369 1.567 1.01.063.172.094.354.09.538-.309 1.54-2.967 3.335-6.377 5.402-4.291 2.595-9.725 4.928-11.934 7.578a3.684 3.684 0 0 0-.696 1.664c-.617 2.605 1.5 6.01 3.914 8.78 2.326 2.64 4.48 4.9 4.39 6.381-.114.33-.343.606-.644.78a2.174 2.174 0 0 1-1.287.31c-1.927-.063-4.792-1.903-7.95-4.232-3.963-2.922-7.695-6.902-10.682-8.129a2.843 2.843 0 0 0-.817-.148c-2.202-.069-4.137 2.584-5.361 5.182-1.118 2.392-1.938 4.463-2.895 4.28a1.128 1.128 0 0 1-.587-.403c-.525-.606-.7-1.654-.651-3.005.068-1.32.35-2.908.727-4.648.72-3.267 2.058-6.823 2.703-9.714a16.11 16.11 0 0 0 .35-1.854z",
    clipRule: "evenodd"
  })
});
var CorendonAirlines_default = SvgCorendonAirlines;

// src/airline-logos/generated/DanishAirTransport.tsx
import { jsx as jsx575, jsxs as jsxs502 } from "react/jsx-runtime";
var SvgDanishAirTransport = (props) => /* @__PURE__ */ jsxs502("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx575("path", {
      fill: "#fff",
      d: "M48 25c0 12.426-10.074 22.5-22.5 22.5C13.073 47.5 3 37.426 3 25S13.073 2.5 25.5 2.5C37.926 2.5 48 12.574 48 25z"
    }),
    /* @__PURE__ */ jsx575("path", {
      stroke: "#fff",
      strokeWidth: 0.63,
      d: "M48 25c0 12.426-10.074 22.5-22.5 22.5C13.073 47.5 3 37.426 3 25S13.073 2.5 25.5 2.5C37.926 2.5 48 12.574 48 25z"
    }),
    /* @__PURE__ */ jsx575("path", {
      fill: "#f9a91f",
      d: "M32.019 24.334c3.023 2.381 5.57 4.694 7.414 6.703 1.708-.718 5.146-2.04 8.124-2.516.688-4.33.076-8.775-1.73-12.75z"
    }),
    /* @__PURE__ */ jsx575("path", {
      fill: "#fcd213",
      d: "M40.022 41.98a22.106 22.106 0 0 0 3.77-4.163 22.409 22.409 0 0 0 2.624-4.965l-4.474 3.673z"
    }),
    /* @__PURE__ */ jsx575("path", {
      fill: "#1f4fa2",
      d: "M35.926 36.04c-2.517-1.042-5.563-2.644-8.836-4.67l-3.31 15.886c4.346.34 8.73-.605 12.561-2.728-.566-2.948-.498-6.636-.415-8.487z"
    }),
    /* @__PURE__ */ jsx575("path", {
      fill: "#d22027",
      d: "M19.117 45.911c-.62-.763.008-15.969.174-19.907-7.61-5.774-12.516-11.948-12.176-13.597-6.907 10.075-4.428 23.869 5.608 30.881a22.246 22.246 0 0 0 7.18 3.326c-.355-.272-.635-.514-.786-.703z"
    }),
    /* @__PURE__ */ jsx575("path", {
      fill: "#009a68",
      d: "M24.316 18.832c3.628-1.504 17.717-7.3 18.646-6.976.227.076.56.264.93.498a22.234 22.234 0 0 0-5.578-5.615C28.277-.282 14.477 2.1 7.373 12.038c1.427-.877 8.917 1.61 16.943 6.794z"
    })
  ]
});
var DanishAirTransport_default = SvgDanishAirTransport;

// src/airline-logos/generated/Easyjet.tsx
import { jsx as jsx576, jsxs as jsxs503 } from "react/jsx-runtime";
var SvgEasyjet = (props) => /* @__PURE__ */ jsxs503("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx576("path", {
      fill: "#ff6801",
      d: "M3 3h44v44H3z"
    }),
    /* @__PURE__ */ jsx576("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M37.998 26.104H23.911c-.638 0-.928.29-.928.828 0 1.278.697 2.498 2.09 3.66 1.394 1.17 2.908 1.756 4.544 1.756.93 0 2.034-.176 3.196-.524 1.163-.363 2.15-.826 2.904-1.35.697-.465 1.233-.696 1.64-.696.524 0 1.045.29 1.51.928.525.64.756 1.294.756 1.99 0 1.452-.873 2.787-2.673 4.125-3.15 2.395-6.81 3.557-10.949 3.557-4.18 0-7.681-1.22-10.527-3.674a14.47 14.47 0 0 1-3.384-4.297c-1.162-2.281-1.742-4.605-1.742-7.117 0-3.311.987-6.344 3.021-9.017 1.757-2.339 3.964-4.022 6.692-5.184 2.05-.887 4.257-1.294 6.581-1.294 3.789 0 6.982 1.062 9.655 3.211 1.353 1.045 2.398 2.322 3.209 3.847.93 1.684 1.396 3.316 1.396 4.895 0 1.276-.293 2.324-.814 3.193-.582.756-1.28 1.163-2.09 1.163zm-13.273-5.592h3.021c1.286 0 1.93-.58 1.93-1.742 0-1.045-.29-1.976-.943-2.614-.639-.711-1.394-1.001-2.442-1.001-1.104 0-1.973.465-2.611 1.35-.583.813-.873 1.627-.873 2.497 0 .582.117.99.407 1.279.29.117.756.231 1.51.231z",
      clipRule: "evenodd"
    })
  ]
});
var Easyjet_default = SvgEasyjet;

// src/airline-logos/generated/Edelweiss.tsx
import { jsx as jsx577, jsxs as jsxs504 } from "react/jsx-runtime";
var SvgEdelweiss = (props) => /* @__PURE__ */ jsx577("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs504("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx577("path", {
        fill: "#e40421",
        d: "M3 47h23.338c8.35 0 12.948-3.7 14.472-11.666L47 3H23.664c-8.352 0-12.95 3.7-14.472 11.666z"
      }),
      /* @__PURE__ */ jsx577("path", {
        fill: "#0e4194",
        d: "M39.135 20.868c-.316-.036-.663.002-1.02 0-.66-.01-1.298-.059-1.69-.095-1.578-.149-3.19-.418-4.756-.048.563-.702 1.938-2.995.566-3.661-.92-.447-2.88.634-4.138 1.803.088-1.587.072-4.744-.967-6.787-.432-.844-1.261-1.854-1.992-1.854-1.62 0-1.412 2.01-1.417 2.963-.008.915.005 1.852-.087 2.731a15.039 15.039 0 0 1-.554 2.706c-.964-.986-3.648-3.512-5.057-2.915-.662.28-.794.881-.476 1.511.226.453.616 1.04.956 1.545.41.607.707 1.154.885 1.476-1.037-.369-1.868-.197-2.805-.023-.624.12-1.191.24-1.773.356-.609.125-1.505.311-2.322.529-.577.148-1.15.278-1.47.594-.552.545-.588 1.355.03 1.829.393.301 1.154.54 1.652.623 1.998.337 3.556 1.156 5.392 1.505-.99.386-3.173 1.431-2.635 2.793.23.577.845.767 1.531.861a8.937 8.937 0 0 0 2.187-.007 9.65 9.65 0 0 0-.786 1.417c-.455 1.04-.686 2.105-1.252 3.146-.128.24-.323.635-.586 1.03-.203.298-.464.62-.632.924-.253.46-.004 1.116.453 1.3.607.249 1.271.009 1.959-.35.569-.294 1.17-.653 1.552-.907 1.496-1.003 2.713-2.277 3.838-3.665.169.951.537 2.434 1.815 2.033.188-.057.387-.236.514-.38.27-.297.523-.951.64-1.48.895 1.468 3.879 4.504 6.769 4.781.32.034 1.03-.093 1.284-.33.648-.607.459-1.407.163-1.883-.299-.483-.742-.906-1.046-1.269-1.051-1.248-2.01-2.466-2.743-3.991 1.113.471 2.698.54 3.346-.308.195-.254.3-.668.16-1.153-.23-.793-1.243-1.678-2.015-2.084 1.101-.124 3.077-.451 5.461-1.74 1.274-.692 2.227-1.618 2.14-2.55-.042-.527-.576-.922-1.074-.976z"
      }),
      /* @__PURE__ */ jsx577("path", {
        fill: "#fff",
        d: "M17.23 24.657c-.747-.203-1.481-.478-2.227-.726-.31-.105-1.146-.319-1.949-.505-.847-.204-1.665-.387-1.665-.8 0-.413.524-.552 1.293-.744a77.14 77.14 0 0 1 3.305-.73c.807-.164 1.687-.397 2.49-.3a2.35 2.35 0 0 1 1.47.707c.18.185.464.429.694.25a.42.42 0 0 0 .155-.216c.038-.13-.02-.266-.112-.483a8.864 8.864 0 0 0-.298-.656l-.285-.548c-.42-.81-.932-1.573-1.431-2.338-.283-.435-.544-.822-.498-1.002.037-.152.332-.186.607-.122.206.048.396.13.678.274.475.24.913.571 1.345.902.558.427 1.09.891 1.545 1.39.48.529.631.544.957.479.372-.072.441-.452.545-.762.075-.254.178-.58.25-.922.126-.59.224-.938.308-1.6.04-.349.086-1.035.1-1.422.017-.641.017-1.323.017-1.929.001-.935-.057-1.503.344-1.783.163-.115.415.004.487.049.995.657 1.497 2.227 1.666 3.05.284 1.392.372 2.81.316 4.228-.02.562-.09 1.068-.098 1.412-1.049-.045-1.622.445-1.908.988-.343-1.07-1.563-1.196-2.542-.678-.95.501-1.7 1.674-1.237 2.642-1.252-.1-1.872 1.252-1.768 2.344-.881-.096-1.72-.224-2.554-.45zM39.017 22.724c-.22.29-.632.55-1.02.791-.608.372-1.205.611-1.406.705a13.51 13.51 0 0 1-3.17.996c-.366.066-.944.125-1.431.191-.3.042-.607.127-.805.181-.17.049-.244.197-.272.295-.047.164.049.365.213.441.257.117.74.226 1.725.908.652.452 1.102 1.077 1.035 1.496-.03.21-.16.339-.543.44-.558.156-1.107.053-1.647-.105a7.672 7.672 0 0 1-.755-.32c-.209-.1-.393-.26-.583-.278-.294-.032-.568.22-.387.616.7 1.638 1.61 3.088 2.748 4.446.199.23.584.7.964 1.155.193.231.308.351.492.588.319.42.283.893-.12 1.019-1.25.387-3.337-.97-4.121-1.607-.73-.601-1.425-1.225-2.016-1.97a15.43 15.43 0 0 1-.7-.998c-.163-.247-.342-.885-.66-.935-.26-.045-.443.186-.484.532-.055.315-.128.939-.33 1.478-.163.428-.379.786-.65.734-.214-.044-.371-.467-.454-.837-.021-.094-.128-.565-.183-.936-.039-.299-.066-.579-.133-.763-.054-.145-.27-.257-.45-.19-.198.068-.427.437-.595.668-.77 1.056-1.795 2.245-3.192 3.273-.87.645-1.831 1.209-2.536 1.536-.42.192-.744.231-.893.098-.127-.12.023-.275.18-.513.218-.335.557-.769.702-1.03a14.55 14.55 0 0 0 1.014-2.252c.14-.39.258-.8.408-1.178.16-.41.362-.805.579-1.199.075-.128.458-.72.956-1.243.265-.283.036-.82-.439-.663-.699.235-1.958.378-2.993.25-.42-.052-.762-.083-.884-.447-.122-.363.53-.883 1.1-1.201.89-.49 1.869-.797 2.689-.992.502 1.028 1.138 1.194 1.401 1.238-.505.866-.022 1.902.752 2.483.963.723 2.515.765 3.26-.347.538.734 1.339.856 2.059.638 1.135-.344 2.08-1.577 1.556-2.885 1-.388 1.564-1.606 1.434-2.725-.09-.776-.498-1.571-1.323-1.808.294-.73.05-1.494-.457-2.018a2.31 2.31 0 0 0-.616-.445c.192-.196.774-.82 1.64-1.399.363-.244.816-.514 1.254-.684.492-.19.92-.267 1.052-.104.11.134.04.544-.101.93-.135.369-.335.704-.412.832-.32.543-.688.973-1.12 1.37a4.16 4.16 0 0 1-.346.293c-.213.158-.312.304-.195.566.041.099.231.283.473.195.582-.208 1.07-.44 1.607-.557.788-.167 1.647-.16 2.558-.099.354.022 1.526.178 2.669.233.553.027 1.03.047 1.406.034.556-.015.784.013.888.239.081.163-.118.477-.392.84z"
      }),
      /* @__PURE__ */ jsx577("path", {
        fill: "#ffde43",
        d: "M26.795 22.606c.722.31 1.357.05 1.564-.39.27-.574-.115-1.242-.754-1.502-.643-.26-1.351-.09-1.57.493-.195.526.126 1.128.76 1.399zm1.977.648c-.48-.04-1.08.586-1.155 1.44-.075.851.174 1.523.832 1.618.478.068 1.083-.54 1.191-1.39.117-.952-.293-1.625-.868-1.668zm-2.238 3.894c-.62.394-.837 1.238-.463 1.7.371.455 1.063.486 1.66.055.583-.424.797-1.131.508-1.612-.312-.52-1.041-.57-1.705-.143zm.412-2.36c0-1.07-.837-1.942-1.872-1.942-1.038 0-1.876.872-1.876 1.941 0 1.07.74 1.97 1.876 1.936.96-.024 1.872-.866 1.872-1.936zm-3.055 2.471c-.687-.316-1.565-.279-1.843.335-.278.62.194 1.274.83 1.57.766.361 1.529.17 1.793-.244.4-.635-.095-1.344-.78-1.66zm.019-4.902c.605-.443.84-1.172.613-1.48-.309-.423-1.162-.314-1.712.167-.632.555-.727 1.162-.52 1.426.327.417 1.06.299 1.619-.113zm-1.546 2.53c-.07-.797-.563-1.359-.987-1.341-.51.023-.844.717-.805 1.49.04.781.613 1.347.985 1.32.585-.05.867-.777.807-1.469z"
      })
    ]
  })
});
var Edelweiss_default = SvgEdelweiss;

// src/airline-logos/generated/Egyptair.tsx
import { jsx as jsx578 } from "react/jsx-runtime";
var SvgEgyptair = (props) => /* @__PURE__ */ jsx578("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx578("path", {
    fill: "#00265d",
    fillRule: "evenodd",
    d: "M32.967 12.706c1.193 1.413 2.936 1.916 4.05 1.104.698-.513.956-1.443.804-2.46.662.1 1.306.301 2.074.61.38.128.832-1.458.243-1.513-6.327-.91-9.84 4.19-9.754 4.109.977-.734 1.785-1.356 2.583-1.85zm3.61.582c-.835.676-2.229.255-3.21-.824 1.321-.816 2.442-1.201 3.647-1.186.246.776.033 1.637-.437 2.01zm-31.522 2.25a24.736 24.736 0 0 1 5.453-9.48C21.41 1.463 35.466 1.497 46 9.964 39.39 6.6 19.846 3.02 5.055 15.538zM4.424 27.21a24.402 24.402 0 0 1-.198-7.835c7.715-7.831 19.26-12.985 31.38-10.454-6.634.015-22.536 4.554-31.182 18.289zm4.126 9.644a24.383 24.383 0 0 1-3.1-5.876c4.59-9.705 13.44-18.158 25.334-19.998-5.92 2.228-18.257 11.297-22.234 25.874zm7.486 6.91a24.6 24.6 0 0 1-4.96-3.887c1.584-10.26 7.86-20.984 17.896-26.55-.738 1.085-1.078 2.356-1.017 3.708-5.85 5.924-11.661 15.123-11.919 26.729zM25.32 47a25.618 25.618 0 0 1-5.705-1.461c.067-9.287 3.082-20.314 8.555-27.075.304 1.185.88 2.401 1.813 3.62 4.332-5.09 9.329-8.69 15.534-10.281C37.057 15.01 23.887 25.243 25.32 47z",
    clipRule: "evenodd"
  })
});
var Egyptair_default = SvgEgyptair;

// src/airline-logos/generated/Eurowings.tsx
import { jsx as jsx579, jsxs as jsxs505 } from "react/jsx-runtime";
var SvgEurowings = (props) => /* @__PURE__ */ jsxs505("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx579("path", {
      fill: "#7bcbe2",
      d: "M18.444 11.084c-4.007-.548-6.042 1.682-8.848 3.733L.003 22.35 0 22.35l1.847.977c.003.003.008.004.012.007 2.403 1.181 5.744.778 8.02-.908l4.05-3.218 1.549-1.233 7.72-6.133z"
    }),
    /* @__PURE__ */ jsx579("path", {
      fill: "#089bc9",
      d: "m.003 22.35 1.844.98c.004 0 .008.004.012.005 2.403 1.183 5.746.78 8.02-.908l4.05-3.217 1.55-1.232z"
    }),
    /* @__PURE__ */ jsx579("path", {
      fill: "#8f174f",
      d: "m34.825 15.737-5.15-.927s-3.585-.852-6.58 1.469c0 0-2.212 1.645-3.843 2.917l-3.627 2.873-8.39 6.674-.07.055 2.533 1.34c2.404 1.187 5.753.785 8.032-.903l7.502-5.943 6.05-4.765z"
    }),
    /* @__PURE__ */ jsx579("g", {
      fill: "#c8c4c3",
      children: /* @__PURE__ */ jsx579("path", {
        d: "M19.254 19.196c1.628-1.272 3.84-2.917 3.84-2.917a7.45 7.45 0 0 1 1.734-1.003l-9.347 2.702-1.55 1.23-4.048 3.22c-2.275 1.687-5.618 2.09-8.02.907 2.048 1.228 5.23 1.51 10.022.081l3.273-.974.47-.373zM32.44 22.058c1.544-1.209 2.709-2.084 3.868-2.604l-10.463 3.355-.615.484-7.502 5.942c-2.278 1.688-5.627 2.092-8.031.903 3.693 2.028 9.381.537 14.165-1.164l.285-.231s8.007-6.478 8.292-6.685zM44.743 28.798c-4.2-1.22-5.46-.448-10.407 1.04h-.002l-.413.343v-.001l-.004.004.004-.003-.012.008-7.974 6.323c-2.272 1.684-5.823 2.008-8.225.831 2.964 1.546 6.029 1.168 11.273-.468L50 30.423z"
      })
    }),
    /* @__PURE__ */ jsx579("path", {
      fill: "#8f174f",
      d: "m46.137 20.08-5.56-1.012c-3.33-.618-4.905.459-8.14 2.99-.285.208-8.292 6.684-8.292 6.684l-8.989 7.253 2.532 1.34c2.405 1.188 5.972.865 8.248-.823l7.974-6.323.011-.008-.004.003z"
    }),
    /* @__PURE__ */ jsx579("path", {
      fill: "#b4175e",
      d: "m15.156 22.442 17.778-5.218-7.09 5.585-18.68 5.99zM23.86 28.972l19.36-6.48-8.884 7.346-19.178 6.157z"
    })
  ]
});
var Eurowings_default = SvgEurowings;

// src/airline-logos/generated/Flyegypt.tsx
import { jsx as jsx580, jsxs as jsxs506 } from "react/jsx-runtime";
var SvgFlyegypt = (props) => /* @__PURE__ */ jsxs506("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx580("path", {
      fill: "#216092",
      d: "M16.521 13.042c-.07.004-.139.013-.208.013-1.616 0-3.232-.011-4.848.004-1.339.013-2.343.609-2.995 1.764-.23.41-.32.858-.322 1.324-.002.497.006.994-.005 1.49-.004.158.04.203.2.198 1.1-.034 2.177.1 3.223.447 1.506.502 2.792 1.338 3.886 2.47.088.09.078.143-.004.226-1.685 1.72-3.712 2.736-6.154 2.895-.312.02-.626.027-.938.019-.167-.005-.214.037-.213.206.007 1.484.004 2.968.004 4.452 0 1.722-.002 3.445.003 5.168 0 .162-.02.207-.192.137-3.19-1.294-5.112-3.607-5.772-6.939-.07-.358-.112-.72-.147-1.083-.004-.04.014-.09-.039-.116V15.302c.056-.023.038-.074.042-.114.04-.343.091-.685.17-1.022.839-3.61 3.812-6.384 7.518-7.023.298-.051.604-.054.895-.143h8.97c-.287.335-.628.62-.919.953A9.807 9.807 0 0 0 17.37 9.84a7.378 7.378 0 0 0-.848 3.202z"
    }),
    /* @__PURE__ */ jsx580("path", {
      fill: "#eb7204",
      d: "M35.385 25.228c.136.473.313.926.62 1.323 1.515 1.96 4.152 1.49 5.203.174.427-.535.624-1.148.632-1.821.01-.94.113-1.867.398-2.77.487-1.542 1.4-2.808 2.59-3.897.087-.08.133-.051.203.015 1.232 1.157 2.101 2.533 2.586 4.142.17.562.276 1.136.34 1.718.005.046-.018.104.043.133v10.906c-.083.032-.048.107-.054.162a8.937 8.937 0 0 1-1.136 3.494c-1.084 1.887-2.647 3.25-4.682 4.083-.054.022-.143.016-.146.11h-.192c.075-.042.042-.113.042-.17.002-3.08.002-6.16.002-9.24 0-.217-.011-.225-.231-.153-1.934.628-3.875.655-5.819.06a9.024 9.024 0 0 1-3.472-1.966h.002c.009-.083.078-.125.13-.179.27-.282.562-.547.81-.848a9.561 9.561 0 0 0 1.314-2.051c.366-.787.595-1.6.713-2.453.036-.257-.023-.528.104-.772z"
    }),
    /* @__PURE__ */ jsx580("path", {
      fill: "#0d2060",
      d: "M16.521 13.042c.04-1.13.322-2.199.849-3.202a9.812 9.812 0 0 1 1.306-1.887c.29-.334.632-.618.919-.953h.038c.966.884 1.783 1.879 2.352 3.058a6.93 6.93 0 0 1 .712 2.79c.002.068-.005.137-.007.205-.032-.003-.064-.009-.096-.009l-5.896.001c-.05 0-.1.012-.15.018a.04.04 0 0 1-.026-.021z"
    }),
    /* @__PURE__ */ jsx580("path", {
      fill: "#c20e2f",
      d: "M16.548 13.063c.05-.006.1-.018.15-.018h5.897c.031 0 .063.005.095.008.002.195.007.39.007.585 0 3.666.024 7.332-.011 10.997-.016 1.627 1.12 2.827 2.505 3.145 1.464.336 2.962-.38 3.658-1.743.162-.318.257-.655.33-1 .056.05.037.117.036.177-.007.572.086 1.132.22 1.685a8.364 8.364 0 0 0 1.346 2.94c.403.561.845 1.093 1.374 1.547.043.037.088.075.092.138-1.256 1.126-2.72 1.85-4.378 2.205-4.509.963-9.205-1.583-10.779-5.847a8.37 8.37 0 0 1-.542-2.897c-.007-3.942-.004-7.885-.004-11.827 0-.032.002-.063.004-.095z"
    }),
    /* @__PURE__ */ jsx580("path", {
      fill: "#d5441d",
      d: "M32.247 31.524c-.004-.063-.049-.101-.092-.138-.53-.454-.97-.986-1.374-1.548a8.366 8.366 0 0 1-1.346-2.94c-.134-.552-.227-1.112-.22-1.684 0-.06.02-.127-.037-.177.002-1.676.34-3.266 1.241-4.713.48-.772 1.07-1.453 1.736-2.073.071-.066.121-.103.218-.015 1.339 1.23 2.296 2.682 2.717 4.454.166.7.246 1.409.265 2.126.003.137.02.275.03.412-.127.244-.068.515-.104.772a8.545 8.545 0 0 1-.713 2.453 9.565 9.565 0 0 1-1.314 2.051c-.248.3-.54.566-.81.848-.052.054-.121.096-.13.18v.002l-.067-.01z"
    }),
    /* @__PURE__ */ jsx580("path", {
      fill: "#c20e2f",
      d: "m32.315 31.534-.001-.002h-.002l.003.002z"
    })
  ]
});
var Flyegypt_default = SvgFlyegypt;

// src/airline-logos/generated/FreebirdAirlines.tsx
import { jsx as jsx581, jsxs as jsxs507 } from "react/jsx-runtime";
var SvgFreebirdAirlines = (props) => /* @__PURE__ */ jsx581("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs507("g", {
    fill: "#0055a4",
    children: [
      /* @__PURE__ */ jsx581("path", {
        d: "M2 33.175c2.367 2.781 4.894 9.844 13.191 11.378 3.676.682 7.456-.537 10.458-1.692 3.47-1.338 6.158-3.686 8.326-5.744 7.896-7.48 9.355-13.89 14.025-10.938-1.014-1.578-2.146-3.796-3.44-5.091-2.394-2.025-5.178-1.305-8.617 2.196-6.063 6.106-12.325 12.672-17.74 15.624C12.919 41.775 6.676 37.966 2 33.176z"
      }),
      /* @__PURE__ */ jsx581("path", {
        d: "M11.91 5.25c-1.318 1.951-5.972 4.877-4.58 10.1.611 2.255 1.818 3.812 3.293 5.097 1.802 1.595 3.968 2.717 5.674 3.656 6.193 3.417 9.78 4.399 8.839 7.765.79-.9 1.8-2.198 2.588-3.1 1.566-1.554 1.157-4.897-1.693-6.342-4.975-2.557-10.283-5.157-13.171-7.9-2.824-2.694-2.987-5.645-.95-9.276z"
      })
    ]
  })
});
var FreebirdAirlines_default = SvgFreebirdAirlines;

// src/airline-logos/generated/JetTime.tsx
import { jsx as jsx582, jsxs as jsxs508 } from "react/jsx-runtime";
var SvgJetTime = (props) => /* @__PURE__ */ jsxs508("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx582("path", {
      fill: "#034ea1",
      d: "m46.5 9.181-1.286 5.556h-5.905l-3.098 15.03a9.012 9.012 0 0 0-.175.847 4.125 4.125 0 0 0-.059.555c0 .547.088.966.263 1.258.176.292.4.517.673.673.272.156.575.243.906.262.321.02.643.03.965.03a25 25 0 0 0 2.981-.176l-1.403 6.375c-.858.077-1.715.146-2.573.204-.857.059-1.734.088-2.63.088-.975 0-1.94-.088-2.894-.263a7.786 7.786 0 0 1-2.573-.936 4.964 4.964 0 0 1-1.811-1.842c-.45-.78-.653-1.793-.615-3.04 0-.39.04-.829.117-1.317a30.39 30.39 0 0 1 .293-1.55l3.39-16.198H25.63l1.286-5.556h5.32L34.106 0h8.302l-1.87 9.181z"
    }),
    /* @__PURE__ */ jsx582("path", {
      fill: "#ffa000",
      d: "M18.875 0 11.04 37.778c-.117.39-.233.887-.35 1.491a9.84 9.84 0 0 1-.527 1.784 5.3 5.3 0 0 1-.876 1.49c-.352.41-.82.615-1.404.615a37.665 37.665 0 0 1-2.981-.117L3.5 49.708c.674.04 1.346.098 2.017.175.682.078 1.355.117 2.016.117 1.872 0 3.43-.195 4.678-.585 1.246-.39 2.299-.975 3.156-1.754.858-.78 1.54-1.775 2.047-2.983.506-1.209.935-2.612 1.286-4.21L27.177 0z"
    })
  ]
});
var JetTime_default = SvgJetTime;

// src/airline-logos/generated/Jet2.tsx
import { jsx as jsx583 } from "react/jsx-runtime";
var SvgJet2 = (props) => /* @__PURE__ */ jsx583("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx583("path", {
    fill: "#ee3123",
    d: "m36.917 14.4 3.122 7.423-1.434-.042-5.358-7.38s-1.434-.042-1.982-.042c-.254 0-.549 0-.929-.084a275.312 275.312 0 0 1-1.982 11.07c-1.646 8.26-1.519 14.13-8.69 14.13-2.279 0-4.43-1.048-4.43-2.725 0-3.02.464-8.26.464-8.26l-12.15-.042S3 33.479 3 38.846C3 43.71 8.358 50.042 18.904 50c8.058-.042 13.415-1.887 18.056-8.47 2.32-3.27 3.459-11.07 5.273-19.582.506-2.474 1.055-4.99 1.56-7.337l-.463-.546zM40.587.02c-2.362.042-5.188.503-6.749 2.39-1.603 1.887-2.447 5.535-2.869 7.799-.084.587-.21 1.3-.337 2.138.253-.042.464-.042.633-.042.548 0 1.982-.042 1.982-.042l5.358-7.38 1.434-.041-3.122 7.38 6.455.377 1.181-1.384L47 .02s-4.05-.042-6.412 0z"
  })
});
var Jet2_default = SvgJet2;

// src/airline-logos/generated/Lufthansa.tsx
import { jsx as jsx584 } from "react/jsx-runtime";
var SvgLufthansa = (props) => /* @__PURE__ */ jsx584("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx584("path", {
    fill: "#0a1d3d",
    d: "M33.918 20.427c-.175 0-.322.004-.405.013-.096.175-.239.41-.45.736 3.293 0 6.282.272 9.59.865l-.934.901c-2.985-.529-5.464-.74-8.624-.74-.46 0-.557 0-.667.004-.11.166-.359.488-.607.787.28-.018.823-.028 1.573-.028 2.599 0 5.027.193 7.663.617l-.934.906c-2.006-.313-4.457-.492-6.656-.492-.781 0-1.67.027-2.465.073-.18.207-.648.713-.79.87 1.052-.11 2.211-.162 3.591-.162 1.964 0 3.84.13 5.616.391l-.934.897a35.83 35.83 0 0 0-4.157-.248c-3.5 0-6.26.759-9.112 2.502 2.718 2.916 7.17 4.76 11.485 4.76h.405l-1.509 1.459c-6.223-1.169-12.773-3.906-18.305-7.654-5.322-3.592-7.185-4.655-11.338-6.49l-.028-1.067 2.81 1.205.957-.759 9.176 4.204-.598.478-4.71-2.046-.464.363 2.447 1.366c2.065 1.15 3.638 1.665 5.091 1.665 3.178 0 6.03-2.254 7.87-6.214 1.384-.179 2.86-.262 4.636-.262 3.643 0 7.18.35 11.186 1.1l-.975.942c-2.493-.52-6.73-.943-9.434-.943zM25 46.62C13.063 46.62 3.38 36.937 3.38 25S13.063 3.38 25 3.38 46.62 13.063 46.62 25 36.937 46.62 25 46.62zM25 2C12.281 2 2 12.281 2 25s10.281 23 23 23 23-10.281 23-23S37.719 2 25 2z"
  })
});
var Lufthansa_default = SvgLufthansa;

// src/airline-logos/generated/Luxair.tsx
import { jsx as jsx585, jsxs as jsxs509 } from "react/jsx-runtime";
var SvgLuxair = (props) => /* @__PURE__ */ jsx585("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs509("g", {
    fill: "#00abbf",
    children: [
      /* @__PURE__ */ jsx585("path", {
        d: "M29.267 7.035 8.11 32.482c-.218.24-.3.528-.202.751.098.24.316.387.62.387l32.695.005c.294 0 .5-.25.5-.528 0-.289-.135-.457-.424-.523-1.176-.277-7.595-1.666-12.206-3.06-2.859-.865-3.975-3.32-3.23-6.598.823-3.631 4.308-15.304 4.318-15.337.082-.24.028-.544-.223-.664-.277-.153-.517-.082-.691.12z"
      }),
      /* @__PURE__ */ jsx585("path", {
        d: "M25.04 2C37.7 2 48 12.306 48 25.063c0 12.642-10.3 22.959-22.96 22.959C12.3 48.022 2 37.705 2 25.062 2 12.313 12.3 2 25.04 2zm0 2.815c-11.171 0-20.23 9.06-20.23 20.253 0 11.161 9.059 20.22 20.23 20.22 11.173 0 20.238-9.059 20.238-20.22A20.187 20.187 0 0 0 25.04 4.815z"
      })
    ]
  })
});
var Luxair_default = SvgLuxair;

// src/airline-logos/generated/NesmaAirlines.tsx
import { jsx as jsx586 } from "react/jsx-runtime";
var SvgNesmaAirlines = (props) => /* @__PURE__ */ jsx586("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx586("g", {
    fill: "#646263",
    children: /* @__PURE__ */ jsx586("path", {
      d: "M23.11 31.494c0 1.256-.594 1.888-1.791 1.888-.545 0-1.166-.268-1.86-.797L4.267 20.605v11.604c0 .54-.233.869-.705 1.006-.247.054-.717.085-1.414.085C1.38 33.3 1 32.942 1 32.222v-13.83c0-1.2.56-1.798 1.672-1.798.705 0 1.427.287 2.165.865L19.84 29.303V17.789c0-.527.232-.857.707-.986.24-.059.71-.088 1.405-.088.77 0 1.158.353 1.158 1.063zM41.192 26.534l-4.881-7.202-4.915 7.202zM49 32.637c0 .44-.152.811-.452 1.11-.294.3-.665.448-1.114.448-.617 0-1.116-.285-1.507-.867l-2.854-4.133H29.52l-2.862 4.133c-.309.45-.637.684-.995.684-.356 0-.7-.121-1.027-.35-.372-.248-.552-.548-.552-.885 0-.106.028-.202.082-.288l10.167-15.537c.42-.637 1.138-.952 2.15-.952.753 0 1.254.21 1.507.637.021.027.04.065.067.12.016.057.057.121.113.195l10.777 15.246c.033.075.054.212.054.439z"
    })
  })
});
var NesmaAirlines_default = SvgNesmaAirlines;

// src/airline-logos/generated/Norwegian.tsx
import { jsx as jsx587 } from "react/jsx-runtime";
var SvgNorwegian = (props) => /* @__PURE__ */ jsx587("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx587("path", {
    fill: "currentColor",
    d: "m41.965 19.172-6.138 5.397-.065.058 7.646 13.65a1.322 1.322 0 0 1-.193 1.54L42.096 41l-12.553-8.43 2.265-3.634-.534-.358-5.544 4.874c-6.07 5.32-12.883 8.389-17.783 8.018-1.979-.153-3.511-.849-4.549-2.08-2.893-3.388-1.203-10.112 4.2-16.745l.635.424c-2.86 4.013-3.614 7.857-1.91 9.814.67.791 1.624 1.24 2.835 1.335 3.001.231 7.236-1.759 11.33-5.327l1.528-1.372L3.178 14.866l1.18-1.038a3.123 3.123 0 0 1 3.052-.614l26.425 8.936.726-.634-.118-.078c-1.972-1.323-3.808-3.741-3.21-5.937l4.505-3.96a12.044 12.044 0 0 1 4.648-2.546 11.952 11.952 0 0 1 4.321-.457c1.384.115 2.54.515 2.948 1.013.238.293.7 1.17-.13 3.024-.842 1.88-2.712 4.1-5.555 6.6z"
  })
});
var Norwegian_default = SvgNorwegian;

// src/airline-logos/generated/Pegasus.tsx
import { jsx as jsx588 } from "react/jsx-runtime";
var SvgPegasus = (props) => /* @__PURE__ */ jsx588("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx588("path", {
    fill: "#e31f26",
    fillRule: "evenodd",
    d: "m3 42.5 13.708-31.635a.75.75 0 0 0 .047-.209c.009-.453-.342-.687-.563-.783-.515-.199-.845-.621-.845-1.125 0-.689.678-1.248 1.514-1.248h14.914l8.538.026c2.599 0 4.896 1.519 5.853 3.748.548 1.356.834 2.822.834 4.376 0 2.443-.758 4.712-2.042 6.591-2.751 4.048-7.26 6.473-12.13 6.473H22.522l-4.56 10.634c-.022.06-.06.137-.06.21 0 .253.182.473.399.57.519.195.845.62.845 1.12 0 .693-.676 1.252-1.512 1.252zm21.373-17.92 5.782-13.334s.922-.024 1.232.024c.634.1 1.118.247 1.619.537 2.315 1.351 2.492 5.187.395 8.57-1.59 2.569-3.9 4.17-6.772 4.19z",
    clipRule: "evenodd"
  })
});
var Pegasus_default = SvgPegasus;

// src/airline-logos/generated/RoyalAirMaroc.tsx
import { jsx as jsx589, jsxs as jsxs510 } from "react/jsx-runtime";
var SvgRoyalAirMaroc = (props) => /* @__PURE__ */ jsxs510("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx589("clipPath", {
      id: "royal-air-maroc_svg__a",
      children: /* @__PURE__ */ jsx589("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsx589("g", {
      clipPath: "url(#royal-air-maroc_svg__a)",
      children: /* @__PURE__ */ jsx589("path", {
        fill: "#c20831",
        d: "M19.847 37.247v.005l7.184-5.221-.293-.904-5.175 3.76.873-2.684-.769-.557-1.525 4.69a7.851 7.851 0 0 1-2.826-7.854l-.792-.574c-.931 3.5.39 7.213 3.323 9.34zm4.77-5.136-5.18-3.76h2.822l.293-.904h-4.935a7.884 7.884 0 0 1 6.598-5.116l.305-.929a8.782 8.782 0 0 0-7.858 6.045l7.184 5.221zm-4.797-11.63h.051c-.034-.395-.172-.63-.42-.722-.894-.337-1.374-1.074-1.374-1.898 0-.938.6-1.522 1.355-1.522 1.07 0 1.457 1.248 2.679 1.248.438 0 .8-.26.8-.48v-.13h-.23c-1.535 0-1.77-1.545-3.249-1.545-1.26 0-2.261.999-2.261 2.429 0 1.442 1.115 2.618 2.65 2.618M5.661 30.55h5.505v-.046a3.642 3.642 0 0 1-1.452-.858H5.662c-2.063 0-2.67-.19-3.691-1.294h13.986c.06-.306.138-.609.227-.902H0l.625.742c1.641 1.943 2.255 2.358 5.04 2.358M22.59 16.47c.783 0 1.267-.652 1.267-1.254 0-.615-.28-.862-.574-.862a.464.464 0 0 0-.463.46c0 .274.247.458.431.458-.237.361-.596.485-1.059.451a.459.459 0 0 0-.376-.725c-.225 0-.455.218-.455.49.002.514.485.982 1.229.982zm-4.514 19.774h-6.631c-1.823 0-2.512-.153-3.355-.955H6.843c1.338 1.515 2.082 1.859 4.605 1.859h7.546a9.494 9.494 0 0 1-.917-.904zm-3.051-1.297v-.046a3.62 3.62 0 0 1-1.455-.858h-4.05c-1.825 0-2.511-.15-3.355-.95H4.918c1.338 1.51 2.08 1.854 4.605 1.854zm-1.927-2.199v-.05a3.67 3.67 0 0 1-1.452-.851H7.592c-1.823 0-2.512-.153-3.355-.955H2.989c1.338 1.515 2.082 1.856 4.605 1.856zm13.748-14.977c-.45 0-.907.55-1.074 1.353.276.02.555.05.827.092.18-.7.492-1.025.751-1.069-.092-.213-.269-.376-.504-.376zm-1.85 3.617-2.743 8.45.768.557 1.973-6.082.875 2.681h.95l-1.522-4.693a7.872 7.872 0 0 1 6.903 4.693h.975a8.782 8.782 0 0 0-8.174-5.606m4.894.455v-.923A10.212 10.212 0 0 0 25 19.582a10.228 10.228 0 0 0-4.901 1.335v.926c1.44-.848 3.112-1.36 4.901-1.36s3.459.512 4.896 1.36zM20.54 20.08c.233-.107.468-.209.708-.3-.117-.35-.337-.75-.75-.75-.208 0-.37.167-.438.359.192.073.347.238.48.69zm.494 16.868-.79.574a8.728 8.728 0 0 0 9.904-.269h.005l-2.744-8.45h-.952l1.975 6.082-2.28-1.656-.769.56 3.99 2.9a7.822 7.822 0 0 1-8.339.259zM23.4 19.213c.274-.043.55-.07.83-.09-.17-.8-.626-1.352-1.075-1.352-.237 0-.412.163-.506.376.262.046.574.368.751 1.066zm-1.636-.838a.537.537 0 0 0-.485.356c.194.027.458.187.65.815.252-.076.509-.143.768-.2-.184-.622-.518-.974-.933-.974m21.39 16.917h-1.247c-.841.8-1.53.955-3.353.955h-6.631a9.16 9.16 0 0 1-.914.901h7.545c2.521 0 3.26-.341 4.6-1.856zm-18.697-7.842-.296.905h6.397l-2.28 1.657.292.902 3.997-2.901a7.84 7.84 0 0 1-2.336 8.01l.303.93a8.753 8.753 0 0 0 2.804-9.507zm23.57.905c-1.023 1.1-1.629 1.294-3.692 1.294h-4.052c-.46.42-.9.688-1.455.858v.05h5.507c2.783 0 3.399-.419 5.037-2.36L50 27.45H33.816c.09.296.164.599.225.904h13.986zM24.108 14.749l.892-.65.894.65-.339-1.05.892-.65h-1.105L25 12l-.34 1.05h-1.107l.897.65zM45.079 33.09h-1.248c-.84.8-1.527.953-3.352.953h-4.055c-.458.42-.9.688-1.452.858v.05h5.507c2.523-.002 3.265-.35 4.6-1.86zm1.93-2.198H45.76c-.844.8-1.53.955-3.355.955h-4.053c-.458.414-.9.686-1.454.853v.05h5.507c2.523 0 3.265-.343 4.603-1.858zM29.939 19.39c-.067-.191-.23-.356-.435-.356-.413 0-.636.398-.75.75.24.091.476.19.706.3.128-.458.288-.626.48-.694zm-5.509-1.699c.25.289.398.507.555.866l.013.017.012-.017a3.17 3.17 0 0 1 .557-.866 3.22 3.22 0 0 0-.567-.887c-.19.182-.475.638-.57.887zm2.662-.712v.13c0 .221.359.476.8.476 1.221 0 1.61-1.244 2.678-1.244.754 0 1.357.584 1.357 1.525 0 .824-.484 1.558-1.374 1.895-.25.092-.388.325-.424.723h.056c1.534 0 2.649-1.176 2.649-2.618 0-1.43-.999-2.429-2.261-2.429-1.48 0-1.714 1.544-3.248 1.544zm-.95-1.767c0 .598.484 1.253 1.267 1.253.745 0 1.227-.468 1.227-.984 0-.274-.228-.49-.458-.49a.458.458 0 0 0-.374.725c-.462.034-.819-.09-1.056-.451a.466.466 0 0 0 .431-.458c0-.25-.208-.46-.465-.46-.291.004-.572.254-.572.865zm-1.144-.35a.725.725 0 1 0 0 1.451.725.725 0 0 0 0-1.45zm3.723 3.872a.533.533 0 0 0-.485-.357c-.415 0-.75.35-.933.975.26.055.516.123.768.198.192-.63.453-.79.65-.816z"
      })
    })
  ]
});
var RoyalAirMaroc_default = SvgRoyalAirMaroc;

// src/airline-logos/generated/Ryanair.tsx
import { jsx as jsx590, jsxs as jsxs511 } from "react/jsx-runtime";
var SvgRyanair = (props) => /* @__PURE__ */ jsx590("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs511("g", {
    fill: "#073590",
    children: [
      /* @__PURE__ */ jsx590("path", {
        d: "M32.907 4.254c3 .816 6 1.721 9.001 2.174h2.182c1.273 0 2.182-.453 3.455-.815H48c0 .453 0 .453-.455.815-1.727 1.268-3.455 2.174-5.182 2.536-.455 0-1.273.453-1.728.453-2.182.815-4.728.815-6.91.815-4.273-.453-8.183-1.72-12.456-1.72-3.819-.363-7.637 1.358-9.82 4.347-.454 1.72-1.272 3.441-1.272 5.162s2.545 2.174 3.455 3.442l1.273 2.536c.454 1.72 1.272 3.442 2.545 5.162.819.815 1.728 2.174 3 2.536 1.728 1.268 3.001 2.536 3.91 4.257.819 1.72 1.728 2.989 2.183 4.71.454.815.818 1.72.818 2.989v.452c.454.816.454 1.721.818 2.174v.453c0 .453.455 1.268 0 1.268-.818-.815-1.273-1.72-1.727-2.536-.455-1.72-1.728-3.442-3-5.163-.819-.815-1.728-2.173-2.547-2.988-3.455-3.895-8.637-6.43-12.456-9.873 0 0 0-.452-.454-.815-.455-.815-.819-1.268-1.273-2.173-.819-1.721-2.182-3.442-3-5.525 0-.815-.455-1.721-.455-2.536v-.453c0-.815-2.182-1.268-.819-2.989.819-.815 3.455-1.72 4.274-3.442v-.905s0-.453-.455-.453c-.454 0-1.727.815-1.727-.453V6.428c.454-.815.454-1.72.454-2.536 0-.453.455-.453.819-.453s1.272-.453 1.727-.453c1.273 0 3 0 3.91.816.454.815 0 1.72 0 2.536 0 .815-.91 1.358-.455 1.81h.818c1.728-1.267 3.455-2.988 5.183-4.709 1.273-1.268 3.455-1.72 5.182-1.268 3.91 0 6.91 1.268 10.73 2.083z"
      }),
      /* @__PURE__ */ jsx590("path", {
        d: "M23.088 11.138c.454.815 0 1.268-.455 2.173-2.182 2.99-3 6.884-4.273 10.326h-.455c-.455 0-.455-.453-.455-.816 0-3.894 1.273-7.245 3-10.687.455-.453.82-1.268 1.728-.815.455-.634.455-.181.91-.181zm6 .906c.455 1.267-.454 2.173-.818 3.441-2.182 4.257-4.728 8.604-6 13.314 0 0 0 .453-.455.453h-.455c-.455-1.721 0-3.895.455-5.525 1.273-3.895 2.546-7.698 4.728-11.593.454 0 .454-.453.454-.453.818-.09 1.637-.09 2.091.363zm6.001.362c.455.453.455 1.268 0 1.72-2.546 5.525-6.455 10.326-8.183 16.303l-1.273 3.895c0 .453-.454.453-.454 0-.455-.453 0-1.268 0-1.721.454-4.71 1.727-9.42 3.91-13.314.818-2.174 2.182-3.894 3-5.978.454-.452.818-1.267 1.727-1.267.455 0 .819 0 1.273.362zm6.91.453c.455.815 0 1.268 0 2.173-1.727 4.257-4.728 8.152-6.91 12.409-2.182 3.441-3.455 7.245-4.728 10.687-.454 1.268-.818 2.174-1.273 3.442h-.454c-.455-.453-.455-.816-.455-1.269.455-4.71 2.182-8.604 3.91-12.86 2.182-4.71 4.728-8.967 6.91-13.677.454-.453.818-1.268 1.727-1.72.364 0 .819 0 1.273.815z"
      })
    ]
  })
});
var Ryanair_default = SvgRyanair;

// src/airline-logos/generated/Sas.tsx
import { jsx as jsx591, jsxs as jsxs512 } from "react/jsx-runtime";
var SvgSas = (props) => /* @__PURE__ */ jsx591("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs512("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx591("path", {
        fill: "#0858a5",
        d: "M2.063 46.603c0 .762.572 1.397 1.333 1.397h43.208c.761 0 1.396-.634 1.396-1.397V3.335C48 2.572 47.365 2 46.604 2H3.396A1.41 1.41 0 0 0 2 3.398z"
      }),
      /* @__PURE__ */ jsx591("path", {
        fill: "#fefefe",
        d: "M24.334 32.497h-3.047v-.063l3.997-5.146h.127l-1.015 5.21zm6.535-9.085h-3.87c-.191 0-.253.063-.253.063L16.022 36.818c-.064.064-.064.127.063.127h1.587c.126 0 .126 0 .19-.063l2.284-2.923s0-.064.063-.064h3.807s.063 0 .063.064c0 .063-.57 2.86-.57 2.86 0 .063 0 .126.19.126h4.568c.127 0 .127 0 .127-.063l2.601-13.344s.064-.126-.126-.126zM5.68 35.294c-.063.126 0 .253.317.508.508.444 2.157 1.398 4.695 1.398 4.568 0 6.282-2.987 5.711-5.465-.19-.698-1.08-4.192-1.143-4.638-.38-1.461.318-2.478 1.65-2.478 1.206 0 1.904.444 2.539.826.126.063.19.126.253 0 0-.064.19-1.207.19-1.207s.063-.19-.19-.317c-.443-.255-1.46-.827-3.68-.827-4.123 0-5.9 2.67-5.139 5.528.19.89 1.142 4.32 1.142 5.019 0 .255.127 1.97-1.968 1.97-1.966 0-3.362-1.334-3.806-1.779-.064-.063-.19 0-.19.127-.063.126-.38 1.335-.38 1.335zm24.364.063c-.063.127 0 .253.317.508.571.444 2.03 1.335 4.569 1.335 4.631 0 6.281-2.987 5.71-5.465-.19-.7-1.016-4.193-1.142-4.638-.38-1.461.316-2.478 1.649-2.478 1.206 0 1.903.445 2.538.826.127.063.19.127.253 0 0-.127.191-1.207.191-1.207s.063-.19-.19-.317c-.445-.255-1.46-.827-3.68-.827-4.124 0-5.9 2.668-5.14 5.528.19.89 1.143 4.32 1.143 5.019 0 .255.126 1.97-1.967 1.97-1.967 0-3.3-1.271-3.744-1.716-.126-.126-.253-.063-.253.064s-.254 1.398-.254 1.398z"
      })
    ]
  })
});
var Sas_default = SvgSas;

// src/airline-logos/generated/SkyExpress.tsx
import { jsx as jsx592 } from "react/jsx-runtime";
var SvgSkyExpress = (props) => /* @__PURE__ */ jsx592("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx592("g", {
    fill: "#2b4077",
    children: /* @__PURE__ */ jsx592("path", {
      d: "M14.674 23.172v-.051c0-3.194-2.118-4.535-5.881-5.502-3.208-.813-4-1.201-4-2.41v-.051c0-.894.822-1.598 2.385-1.598s3.178.682 4.822 1.81l2.119-3.04C12.237 10.835 9.933 10 7.229 10 3.445 10 .742 12.198.742 15.524v.051c0 3.641 2.407 4.66 6.14 5.604 3.097.784 3.734 1.312 3.734 2.33v.051c0 1.077-1.008 1.73-2.674 1.73-2.119 0-3.867-.865-5.534-2.228L0 25.92c2.222 1.964 5.06 2.93 7.867 2.93 4 .008 6.807-2.036 6.807-5.677zM20.97 22.989l2.149-2.198 5.748 7.802h4.896l-7.889-10.556 6.496-6.689 6.423 10.015v7.23h4.081V21.29L50 10.256h-4.637l-4.504 7.363-4.422-7.363h-7.941l-7.526 8.015v-8.015h-4.074v18.337h4.074zM4.178 30.696c-1.904 0-3.341 1.612-3.341 3.626v.03c0 2.168 1.6 3.626 3.444 3.626 1.349 0 2.193-.542 2.911-1.311l-.466-.41c-.578.615-1.326 1.091-2.415 1.091-1.378 0-2.637-1.011-2.756-2.74h5.83c.015-.11.015-.147.015-.242v-.029c.007-2.059-1.252-3.641-3.222-3.641zm-2.623 3.311c.126-1.538 1.2-2.703 2.593-2.703 1.615 0 2.43 1.297 2.526 2.703zM14.63 30.857h-.808l-2.377 2.945-2.37-2.945h-.838l2.77 3.407-2.881 3.545h.815l2.481-3.091 2.482 3.091h.837l-2.882-3.553zM20.037 30.696c-1.393 0-2.289.806-2.896 1.722v-1.553h-.674V40h.674v-3.685c.577.872 1.489 1.663 2.896 1.663 1.696 0 3.422-1.377 3.422-3.641v-.03c0-2.263-1.726-3.611-3.422-3.611zm2.689 3.67c0 1.868-1.23 2.975-2.756 2.975-1.459 0-2.866-1.202-2.866-2.99v-.029c0-1.772 1.407-2.989 2.866-2.989 1.474 0 2.756 1.173 2.756 3.004zM26.067 32.835v-1.978h-.674v6.952h.674v-2.85c0-2.263 1.422-3.48 3.044-3.48h.067v-.74c-1.385-.043-2.556.858-3.111 2.096zM33.245 30.696c-1.904 0-3.341 1.612-3.341 3.626v.03c0 2.168 1.6 3.626 3.444 3.626 1.348 0 2.193-.542 2.911-1.311l-.466-.41c-.578.615-1.326 1.091-2.415 1.091-1.378 0-2.637-1.011-2.756-2.74h5.83c.015-.11.015-.147.015-.242v-.029c0-2.059-1.252-3.641-3.222-3.641zm-2.623 3.311c.126-1.538 1.2-2.703 2.593-2.703 1.615 0 2.43 1.297 2.526 2.703zM40.652 33.941c-1.008-.285-1.956-.571-1.956-1.348v-.029c0-.696.637-1.216 1.6-1.216.748 0 1.519.271 2.163.696l.356-.557c-.704-.461-1.652-.762-2.496-.762-1.363 0-2.319.806-2.319 1.927v.03c0 1.237 1.267 1.582 2.415 1.911.978.271 1.86.572 1.86 1.392v.03c0 .806-.75 1.326-1.697 1.326-.897 0-1.748-.33-2.526-.916l-.4.535c.748.6 1.86 1.01 2.881 1.01 1.348 0 2.43-.79 2.43-2.029v-.029c0-1.253-1.185-1.656-2.311-1.97zM47.185 33.941c-1.007-.285-1.955-.571-1.955-1.348v-.029c0-.696.637-1.216 1.6-1.216.748 0 1.518.271 2.163.696l.355-.557c-.703-.461-1.652-.762-2.496-.762-1.363 0-2.318.806-2.318 1.927v.03c0 1.237 1.266 1.582 2.414 1.911.978.271 1.86.572 1.86 1.392v.03c0 .806-.749 1.326-1.697 1.326-.896 0-1.748-.33-2.526-.916l-.4.535c.748.6 1.86 1.01 2.882 1.01 1.348 0 2.43-.79 2.43-2.029v-.029c.007-1.253-1.178-1.656-2.312-1.97z"
    })
  })
});
var SkyExpress_default = SvgSkyExpress;

// src/airline-logos/generated/Smartwings.tsx
import { jsx as jsx593, jsxs as jsxs513 } from "react/jsx-runtime";
var SvgSmartwings = (props) => /* @__PURE__ */ jsxs513("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx593("clipPath", {
      id: "smartwings_svg__a",
      children: /* @__PURE__ */ jsx593("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsx593("g", {
      clipPath: "url(#smartwings_svg__a)",
      children: /* @__PURE__ */ jsx593("path", {
        fill: "#ff8c00",
        d: "M13.528 9.942c2.378-.308 8.284-1.156 10.432-1.619 2.07-.463 13.883-2.236 19.867-2.314 6.06-.077 5.753.309 5.83 1.466.153 1.156.69 1.542 0 2.622-.768 1.08-1.995 1.542-3.836 2.236-3.375 1.311-18.18 5.321-20.174 6.324 3.069-.154 7.518-.926 11.966-1.157 2.992-.077 3.375.54 3.606 1.928.306 1.31.383 2.005-1.611 2.776-1.995.771-4.296 1.62-8.975 3.008-6.52 1.928-10.432 2.776-15.264 4.935 2.685.309 7.057-.154 10.585 0 5.293.155 5.523.771 5.753 2.39.077 1.543.307 2.006-1.918 3.086-2.224.925-6.136 2.005-8.284 2.467a882.813 882.813 0 0 0-12.12 2.7c-1.457.385-2.684 2.004-4.908 2.776-2.455.848-3.529.462-4.373-1.234-.537-1.311 1.074-2.468 3.069-3.085 1.994-.54 8.13-1.928 10.738-2.622 2.608-.694 7.748-2.082 9.435-2.776-2.301 0-7.9.077-12.273.154-2.608.077-3.528-.077-3.912-2.005-.383-1.928.384-2.622 2.685-3.239 2.301-.771 5.753-2.313 7.9-3.085 2.148-.77 8.438-3.007 10.126-3.393-4.219-.077-13.654 2.005-16.032 2.468-1.917.386-2.07-.308-2.838-1.542-.767-1.311.154-2.237 1.304-2.468 1.458-.386 4.219-1.697 8.131-3.239 3.145-1.234 7.517-2.622 10.816-3.624 3.068-1.08 8.284-2.854 10.048-3.548-1.304 0-7.517.848-11.66 1.465-3.988.54-10.968 2.005-12.042 2.39s-2.301.31-2.992-1.31c-.69-1.62-.076-2.468.92-2.622"
      })
    })
  ]
});
var Smartwings_default = SvgSmartwings;

// src/airline-logos/generated/SunExpress.tsx
import { jsx as jsx594, jsxs as jsxs514 } from "react/jsx-runtime";
var SvgSunExpress = (props) => /* @__PURE__ */ jsxs514("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx594("g", {
      fill: "#1a428a",
      children: /* @__PURE__ */ jsx594("path", {
        d: "M30.936 33.193c-7.899.584-18.836 2.313-26.665 1.893.818 1.682 1.87 3.248 3.085 4.697a25.568 25.568 0 0 0 2.22 2.29 23.047 23.047 0 0 0 15.447 5.936c5.726 0 11.218-2.08 15.424-5.842 1.753-1.566 3.155-3.225 4.277-5.048.77-1.239 1.378-2.547 1.893-3.973-3.366-.678-9.161-.42-15.681.047zM12.32 5.929a.542.542 0 0 0-.42.093c-.421.28-.842.608-1.24.912a.54.54 0 0 0-.14.677l3.903 6.777.21.28v.024l-.28-.21-6.777-3.926c-.21-.14-.514-.07-.678.14a15.31 15.31 0 0 0-.911 1.239.453.453 0 0 0-.07.42c.023.14.117.257.257.35L17.74 19.39l.258.07c.14 0 .28-.07.397-.187a7.14 7.14 0 0 1 .841-.842.537.537 0 0 0 .117-.654L12.67 6.209c-.093-.163-.21-.257-.35-.28zM44.053 12.33c.023-.14 0-.28-.07-.421-.28-.42-.608-.841-.912-1.238a.54.54 0 0 0-.677-.14l-6.777 3.902-.28.21.21-.28 3.926-6.777a.514.514 0 0 0-.14-.678 15.31 15.31 0 0 0-1.24-.911c-.116-.094-.256-.117-.42-.07-.14.023-.257.116-.35.257L30.639 17.75l-.07.257c0 .14.07.28.187.398.304.257.584.537.841.841a.537.537 0 0 0 .654.117L43.82 12.68a.59.59 0 0 0 .234-.35zM35.16 4.49a.553.553 0 0 0-.28-.326c-.467-.21-.934-.42-1.425-.608a.537.537 0 0 0-.654.234l-3.927 6.777-.14.304h-.023l.047-.327v-7.83c0-.256-.187-.49-.444-.513-.514-.07-1.029-.14-1.543-.164-.14 0-.28.047-.397.14a.465.465 0 0 0-.164.374V15.92l.07.257c.07.116.21.21.351.257.397.07.771.187 1.145.303.234.07.49-.023.631-.233l6.684-11.568a.454.454 0 0 0 .07-.444zM47.86 23.571a.634.634 0 0 0 .14-.397 17.326 17.326 0 0 0-.187-1.542.525.525 0 0 0-.514-.444H39.47l-.327.046v-.023l.304-.14 6.777-3.926a.528.528 0 0 0 .234-.655 25.33 25.33 0 0 0-.608-1.402.536.536 0 0 0-.748-.234l-11.59 6.708-.188.186a.57.57 0 0 0-.047.444c.14.374.234.748.304 1.145.047.258.257.421.514.421h13.368c.14-.023.28-.07.397-.187zM4.454 14.821a.552.552 0 0 0-.327.28c-.21.468-.421.935-.608 1.426a.538.538 0 0 0 .234.654l6.777 3.903.304.14v.024l-.328-.047H2.678c-.257 0-.491.187-.514.444-.07.514-.14 1.028-.164 1.542 0 .14.047.28.14.397a.551.551 0 0 0 .374.164h13.367l.257-.07c.117-.07.21-.21.257-.35.07-.398.164-.772.304-1.146.094-.233-.023-.49-.233-.63L4.874 14.867a.525.525 0 0 0-.42-.047zM23.535 2.14a.634.634 0 0 0-.397-.14 17.35 17.35 0 0 0-1.543.187.525.525 0 0 0-.444.514v7.829l.047.327h-.024l-.14-.304-3.926-6.777a.495.495 0 0 0-.654-.21c-.467.187-.958.397-1.402.607a.535.535 0 0 0-.234.748l6.684 11.568.187.187c.14.07.28.093.42.047.374-.117.748-.234 1.145-.304a.505.505 0 0 0 .42-.514V2.537c.048-.14-.022-.28-.14-.397z"
      })
    }),
    /* @__PURE__ */ jsx594("path", {
      fill: "#ee5f2a",
      d: "M46.535 26.63c-4.814 0-8.53 1.169-18.111 3.202-13.555 2.874-23.183.49-25.38.21-.327-.047-.537.117-.443.49.233 1.1 1.051 3.46 1.659 4.534 7.852.421 18.789-1.308 26.664-1.892 6.52-.468 12.292-.725 15.68-.047a26.484 26.484 0 0 0 1.216-4.954c.187-1.005.047-1.543-1.285-1.543z"
    }),
    /* @__PURE__ */ jsx594("path", {
      fill: "#ee5f2a",
      d: "M2.463 28.27c.444.187 6.73 2.314 16.452 2.454 2.757.047 6.286-.374 8.39-.818-1.1.164-3.46.537-6.357.514-5.609-.023-14.115-1.986-18.135-3.786a.519.519 0 0 0-.514.07c-.14.117-.234.28-.21.468l.07.77c0 .118.047.235.304.328z"
    })
  ]
});
var SunExpress_default = SvgSunExpress;

// src/airline-logos/generated/Sunclass.tsx
import { jsx as jsx595 } from "react/jsx-runtime";
var SvgSunclass = (props) => /* @__PURE__ */ jsx595("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx595("path", {
    d: "M25 50c13.809 0 25-11.191 25-25S38.809 0 25 0 0 11.191 0 25s11.191 25 25 25Zm1.863-17.906c.578.379 1.262.55 1.946.613 1.43.133 2.882-.14 4.27-.46 1.644-.376 3.226-.985 4.796-1.59.145-.06.29-.114.43-.169.28-.105.558-.21.84-.32.457-.172.91-.348 1.367-.523.246-.098.46-.188.476-.2.012-.011.356-.883.762-1.93.406-1.046.742-1.921.746-1.94.008-.032.004-.036-.027-.028-.02.004-.426.164-.91.36-1.5.6-3.016 1.175-4.532 1.75l-.043.015c-1.554.59-3.12 1.16-4.75 1.5-.582.125-1.172.234-1.761.3-.504.06-1.008.079-1.516.067a7.388 7.388 0 0 1-.695-.031c-.809-.098-1.68-.344-2.211-1a2.254 2.254 0 0 1-.438-.992 3.615 3.615 0 0 1-.039-.618c-.004-.214-.004-.43-.043-.64a3.01 3.01 0 0 0-.766-1.492 2.955 2.955 0 0 0-1.1-.704 5.249 5.249 0 0 0-1.532-.3c-1.113-.075-2.238.101-3.324.32-2.262.457-4.47 1.184-6.637 1.973a113.212 113.212 0 0 0-5.961 2.367c-.375.16-.457.2-.469.23-.008.02-.012.715-.012 1.63 0 .874.004 1.609.008 1.628.008.027.016.031.047.027.02-.003.332-.132.695-.289a127.05 127.05 0 0 1 2.614-1.09c2.875-1.163 5.8-2.253 8.812-3.007.88-.219 1.77-.41 2.668-.524.742-.093 1.504-.136 2.25-.058.258.027.516.066.766.129.41.105.816.261 1.16.52.293.218.523.527.66.87.07.18.117.371.14.563.009.078.016.262.016.41a3.312 3.312 0 0 0 .137 1.02c.063.214.149.425.258.62.105.196.234.38.383.551.148.172.328.32.52.442Zm.305-5.864c.191.098.387.18.59.243.844.257 1.754.273 2.625.187a20.154 20.154 0 0 0 3.722-.719c2.676-.777 5.27-1.84 7.848-2.898.387-.16.77-.316 1.156-.473.348-.144.641-.265.653-.273.011-.012.39-.895.808-1.965.418-1.074.735-1.969.739-1.992.007-.043.007-.043-.036-.035-.023.004-.28.11-.574.238-2.566 1.133-5.187 2.133-7.808 3.125-2.09.793-4.246 1.523-6.477 1.773-.785.086-1.617.118-2.402-.007-.25-.04-.5-.098-.739-.176-.207-.07-.41-.16-.601-.266a2.195 2.195 0 0 1-.41-.297 2.113 2.113 0 0 1-.668-1.437 9.698 9.698 0 0 1-.02-.535 3.374 3.374 0 0 0-.09-.711 2.991 2.991 0 0 0-.27-.668 2.863 2.863 0 0 0-.843-.953c-.398-.286-.887-.457-1.363-.555-.91-.188-1.899-.14-2.813-.023-1.367.175-2.71.507-4.03.89-3.427.985-6.755 2.309-10.028 3.711-.29.125-.375.168-.39.195-.013.028-.017.395-.017 1.645 0 1.351 0 1.61.02 1.633.02.027.04.02.492-.172 2.73-1.176 5.496-2.29 8.32-3.219a44.684 44.684 0 0 1 3.192-.945c1.156-.293 2.336-.551 3.531-.63.695-.046 1.406-.05 2.09.09.457.094.906.255 1.297.512.2.13.394.325.527.524.106.16.196.34.254.523.078.23.098.461.106.703.003.301.02.602.078.899a3.165 3.165 0 0 0 .558 1.258c.125.172.282.336.45.468.16.133.34.239.523.332Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fc8b00",
      fillOpacity: 1
    }
  })
});
var Sunclass_default = SvgSunclass;

// src/airline-logos/generated/Sundair.tsx
import { jsx as jsx596, jsxs as jsxs515 } from "react/jsx-runtime";
var SvgSundair = (props) => /* @__PURE__ */ jsxs515("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx596("clipPath", {
      id: "sundair_svg__a",
      children: /* @__PURE__ */ jsx596("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs515("g", {
      clipPath: "url(#sundair_svg__a)",
      children: [
        /* @__PURE__ */ jsx596("path", {
          fill: "#fff",
          d: "M25 48c12.703 0 23-10.298 23-23C48 12.296 37.703 2 25 2S2 12.297 2 25c0 12.702 10.297 23 23 23z"
        }),
        /* @__PURE__ */ jsx596("path", {
          stroke: "#0b1213",
          strokeWidth: 2.446,
          d: "M25 48c12.703 0 23-10.298 23-23C48 12.296 37.703 2 25 2S2 12.297 2 25c0 12.702 10.297 23 23 23z"
        }),
        /* @__PURE__ */ jsx596("g", {
          fill: "#0b1213",
          children: /* @__PURE__ */ jsx596("path", {
            d: "M34.729 30.684v-1.291a4.39 4.39 0 0 0-.775-.068c-.39 0-.784.062-1.18.189-.395.126-.754.31-1.076.55a2.777 2.777 0 0 0-.783.922c-.201.372-.302.812-.302 1.317v6.112h1.378v-6.112c0-.276.054-.517.164-.723.109-.207.255-.382.439-.526.183-.143.396-.25.636-.318.242-.069.5-.104.776-.104.126 0 .246.004.361.01s.235.02.362.042zM22.487 38.46c.62-.098 1.24-.256 1.86-.474v-5.786c0-.482-.095-.903-.285-1.265a2.611 2.611 0 0 0-.758-.895 3.415 3.415 0 0 0-1.084-.534 4.393 4.393 0 0 0-1.248-.18 4.41 4.41 0 0 0-1.696.352 4.041 4.041 0 0 0-1.472 1.042l.86.843a2.312 2.312 0 0 1 1-.731 3.31 3.31 0 0 1 1.205-.233c.263 0 .522.034.774.104.252.068.476.172.672.31.195.137.353.306.473.508.121.2.181.427.181.68v1.188a5.42 5.42 0 0 0-2.135-.431c-.436 0-.855.057-1.257.172a3.298 3.298 0 0 0-1.068.517c-.31.23-.559.522-.748.878-.19.356-.284.78-.284 1.274 0 .482.083.895.25 1.24.165.344.39.631.67.86.282.23.617.403 1.008.517.39.115.809.172 1.257.172.597.012 1.205-.032 1.825-.128zm.482-1.215c-.368.08-.743.133-1.128.155-.385.023-.766.03-1.145.018-.528-.011-.97-.14-1.326-.388-.356-.246-.533-.657-.533-1.231 0-.32.06-.594.18-.818.121-.224.279-.404.474-.542a1.99 1.99 0 0 1 .68-.301c.259-.063.525-.095.8-.095.368 0 .724.034 1.068.103.345.069.654.15.93.241zm3.788-6.871v8.042h1.377v-8.044a3.349 3.349 0 0 1-.703.074c-.235 0-.459-.025-.674-.072zM7.078 25.768c.474.629 1.017 1.068 1.626 1.318.61.25 1.26.376 1.954.376.462 0 .91-.067 1.347-.202s.82-.34 1.154-.616c.333-.275.6-.62.799-1.03.199-.41.298-.885.298-1.423 0-.475-.09-.88-.27-1.213a2.678 2.678 0 0 0-.692-.837 3.97 3.97 0 0 0-.924-.549 6.358 6.358 0 0 0-.982-.327 2.323 2.323 0 0 1-.846-.356 1.562 1.562 0 0 1-.356-.327.568.568 0 0 1-.125-.414c.026-.295.128-.503.308-.625a1.04 1.04 0 0 1 .596-.183c.296 0 .597.061.905.183.308.122.545.266.712.433l1.328-1.828a4.225 4.225 0 0 0-1.636-.828c-.577-.14-1.09-.212-1.54-.212-.551 0-1.039.087-1.462.26a3.22 3.22 0 0 0-1.068.693 2.905 2.905 0 0 0-.654.99c-.148.374-.222.752-.222 1.137 0 .359.067.711.202 1.058.135.346.337.667.607.962.269.295.606.552 1.01.77.404.218.888.372 1.453.462.449.064.753.218.914.461.16.244.176.514.048.809-.141.295-.41.442-.808.442-.347 0-.741-.096-1.184-.288a4.108 4.108 0 0 1-1.222-.828zM38.681 13.664h-2.695v3.79a3.853 3.853 0 0 0-1.635-.346c-.462 0-.914.08-1.357.241-.442.16-.837.385-1.183.674a3.315 3.315 0 0 0-.837 1.058 3.082 3.082 0 0 0-.318 1.414v3.522c.052.642.196 1.184.433 1.626s.546.799.924 1.068c.378.27.805.462 1.28.577.474.116.975.174 1.5.174.63 0 1.28-.068 1.954-.202a12.47 12.47 0 0 0 1.934-.55zm-2.695 11.604c-.23.115-.497.182-.798.202-.302.02-.586-.01-.856-.087a1.61 1.61 0 0 1-.693-.394 1.02 1.02 0 0 1-.308-.722v-3.906a1.06 1.06 0 0 1 .356-.683c.199-.174.433-.295.702-.366.27-.07.55-.086.838-.048.289.038.542.115.76.23zM28.888 24.66v-7.013c0-.655-.122-1.213-.366-1.674a3.194 3.194 0 0 0-.971-1.126 4.167 4.167 0 0 0-1.386-.635 6.45 6.45 0 0 0-1.626-.202c-.616 0-1.231.077-1.847.23-.616.155-1.2.366-1.752.636v2.275h-.005v7.775a2.717 2.717 0 0 1-.962.173 1.9 1.9 0 0 1-1.174-.375c-.334-.25-.5-.67-.5-1.26V17.15h-2.675v6.467c0 .706.116 1.295.346 1.77.231.475.539.853.924 1.136.385.282.83.484 1.337.605a6.738 6.738 0 0 0 1.588.183c.693 0 1.36-.073 2.001-.22a15.67 15.67 0 0 0 1.77-.511v-2.41h.002v-7.486c.32-.18.71-.27 1.12-.27.385 0 .734.107 1.049.318.314.212.471.548.471 1.01v6.814a3.074 3.074 0 0 1 1.2-.233c.54 0 1.026.113 1.456.337z"
          })
        }),
        /* @__PURE__ */ jsx596("path", {
          fill: "#c0046b",
          d: "M29.168 26.977a1.785 1.785 0 0 0-3.524.408 1.785 1.785 0 0 0 3.516.435c-.15.065-.307.117-.476.138-.52.063-1.044-.06-1.402-.388-.045.007-.163.026-.241.032.046-.078.078-.137.13-.231a2.294 2.294 0 0 0 1.996-.393z"
        })
      ]
    })
  ]
});
var Sundair_default = SvgSundair;

// src/airline-logos/generated/Swiss.tsx
import { jsx as jsx597, jsxs as jsxs516 } from "react/jsx-runtime";
var SvgSwiss = (props) => /* @__PURE__ */ jsxs516("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx597("path", {
      fill: "#cf0a2c",
      d: "M40.182 43H1L29.706 7H49z"
    }),
    /* @__PURE__ */ jsx597("path", {
      fill: "#fff",
      d: "M34.178 21.683v-7.766H27.58v7.766h-7.724v6.634h7.692v7.734h6.63v-7.734h7.692v-6.634z"
    })
  ]
});
var Swiss_default = SvgSwiss;

// src/airline-logos/generated/TailwindAirlinesCopy.tsx
import { jsx as jsx598, jsxs as jsxs517 } from "react/jsx-runtime";
var SvgTailwindAirlinesCopy = (props) => /* @__PURE__ */ jsxs517("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx598("path", {
      fill: "#00acc8",
      d: "M4.5 38.439c3.384-4.25 7.552-10.73 13.144-14.271 8.264-5.241 14 2.797 17.74 9.667C38.34 39.29 41.51 45.31 45.5 48c-10.045-3.01-14.035-19.477-28.105-16.679-5.2 1.062-9.226 4.816-12.895 7.118z"
    }),
    /* @__PURE__ */ jsx598("path", {
      fill: "#575656",
      d: "M42.401 47.61c-5.308-2.939-14.39-6.48-18.915-11.615-1.21-1.38-1.959-2.726-2.422-4.037 10.33.921 14.07 11.722 21.337 15.653zM24.27 21.76c2.03-2.337 4.702-4.497 7.267-6.41 5.45-4.143 9.902-8.144 11.719-13.35.712 8.995-9.368 15.546-12.147 23.761-1.995-2.16-4.239-3.683-6.84-4.001z"
    })
  ]
});
var TailwindAirlinesCopy_default = SvgTailwindAirlinesCopy;

// src/airline-logos/generated/TailwindAirlines.tsx
import { jsx as jsx599, jsxs as jsxs518 } from "react/jsx-runtime";
var SvgTailwindAirlines = (props) => /* @__PURE__ */ jsxs518("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx599("path", {
      fill: "#00acc8",
      d: "M4.5 38.439c3.384-4.25 7.552-10.73 13.144-14.271 8.264-5.241 14 2.797 17.74 9.667C38.34 39.29 41.51 45.31 45.5 48c-10.045-3.01-14.035-19.477-28.105-16.679-5.2 1.062-9.226 4.816-12.895 7.118z"
    }),
    /* @__PURE__ */ jsx599("path", {
      fill: "#575656",
      d: "M42.401 47.61c-5.308-2.939-14.39-6.48-18.915-11.615-1.21-1.38-1.959-2.726-2.422-4.037 10.33.921 14.07 11.722 21.337 15.653zM24.27 21.76c2.03-2.337 4.702-4.497 7.267-6.41 5.45-4.143 9.902-8.144 11.719-13.35.712 8.995-9.368 15.546-12.147 23.761-1.995-2.16-4.239-3.683-6.84-4.001z"
    })
  ]
});
var TailwindAirlines_default = SvgTailwindAirlines;

// src/airline-logos/generated/Transavia.tsx
import { jsx as jsx600, jsxs as jsxs519 } from "react/jsx-runtime";
var SvgTransavia = (props) => /* @__PURE__ */ jsx600("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs519("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx600("path", {
        fill: "#00d66c",
        d: "M47.996 25.004C47.996 12.191 37.84 2 25 2 12.158 2 2 12.193 2 25.006 2 37.817 12.163 48 25 48c12.839.002 22.996-10.182 22.996-22.994l.004-.002h-.002z"
      }),
      /* @__PURE__ */ jsx600("path", {
        fill: "#fff",
        d: "M35.1 28.073h-1.294c-1.293 0-1.845.69-2.033 2.024-.327 2.446-2.263 4.1-4.805 4.1-2.953 0-4.844-2.163-4.844-5.3v-7.371c0-.295-.043-.556-.116-.787.278.125.61.19.991.19h6.788c1.297 0 2.033-.74 2.033-2.026v-.598c0-1.293-.736-2.03-2.033-2.03h-3.83v-4.153c0-1.288-.74-2.027-2.03-2.027h-.928c-1.29 0-2.03.74-2.03 2.027V18.9c0 .292.038.552.116.787a2.442 2.442 0 0 0-.994-.189h-6.787c-1.292 0-2.033.738-2.033 2.027v.602c0 1.29.74 2.028 2.033 2.028h3.833v4.74c0 5.946 3.834 10.095 9.837 10.095 5.59 0 9.283-3.551 9.976-8.895.182-1.337-.695-2.023-1.852-2.023z"
      })
    ]
  })
});
var Transavia_default = SvgTransavia;

// src/airline-logos/generated/Tunisair.tsx
import { jsx as jsx601 } from "react/jsx-runtime";
var SvgTunisair = (props) => /* @__PURE__ */ jsx601("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx601("g", {
    fill: "#e52725",
    children: /* @__PURE__ */ jsx601("path", {
      d: "m12.714 11.5-.764.775h11.289l-.764-.775zM8.13 12.663l-.552.56h16.595l-.595-.56zM7.536 13.61l.764.775h7.851l.722-.775zM26.21 15.332l-.552-.56H10.676c.128.087.552.56.552.56zM1.764 28.294 1 29.07h29.963l.764-.775zM1.17 29.457l.552.56h38.96l-.552-.56zM45.265 35.356l-.764-.775H31.048a6.196 6.196 0 0 0 1.867.775zM2.103 30.404l.764.732h2.165l-.764-.732zM4.14 32.471l.765.775H7.11l-.763-.775zM3.207 31.524l.594.56h2.165l-.552-.56zM5.287 33.634l.551.56h2.207l-.551-.56zM6.22 34.581l.764.775H9.15l-.722-.775zM7.366 35.744l.552.56h2.207l-.595-.56zM8.3 36.691l.764.775h1.018v-.775zM9.446 37.811l.551.603.085.086v-.689zM24.555 26.184l-.764.775h5.432l-.764-.775zM10.889 17.4c.17-.216.34-.388.467-.56h16.382l.551.56zM9.403 18.95c-.17.172-.34.387-.467.56H30.37l-.552-.56zM7.663 21.62c.085-.216.17-.388.255-.56h23.936l.552.56zM7.196 23.127c-.042.172-.042.387-.085.56h27.375l-.552-.56zM7.07 25.237c0 .172.042.387.042.56h29.453l-.552-.56zM7.62 27.907c-.042-.173-.127-.388-.17-.56h30.643l.552.56zM14.75 15.677c-.211.215-.424.474-.678.775H11.44c.043-.172 0-.646-.042-.775zM12.968 17.787l-.51.775H9.744l.764-.775zM11.61 20.672c.043-.258.127-.517.212-.775H8.64c-.17.259-.34.474-.509.775zM11.525 22.007l.128.775H7.28c.085-.258.128-.516.212-.775zM12.926 24.85c-.255-.26-.424-.518-.637-.776H7.07v.775zM14.496 26.184c.382.259.806.517 1.273.775H7.324c-.043-.258-.128-.516-.17-.775zM9.7 31.136a6.229 6.229 0 0 1-.679-.775h23.597l.764.775zM10.804 32.084a8.151 8.151 0 0 1-.722-.56H42.21l.551.56zM13.138 33.246c-.51-.172-1.103-.43-1.74-.775h8.7s-1.358.775-1.655.775zM29.223 33.246c-.297-.301-.51-.56-.637-.775h6.07l.763.775zM30.453 34.194a11.964 11.964 0 0 1-.763-.56h14.6l.55.56zM42.337 36.304c-.722-.258-1.4-.43-2.037-.56h6.026l.552.56zM43.356 36.691c.636.259 1.23.517 1.825.775h2.164l-.764-.775zM45.944 37.811c.382.215.722.388 1.019.56H49l-.552-.56z"
    })
  })
});
var Tunisair_default = SvgTunisair;

// src/airline-logos/generated/Volotea.tsx
import { jsx as jsx602, jsxs as jsxs520 } from "react/jsx-runtime";
var SvgVolotea = (props) => /* @__PURE__ */ jsx602("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs520("g", {
    fill: "#ed164a",
    children: [
      /* @__PURE__ */ jsx602("path", {
        d: "m17.333 40.337 7.67-7.673 7.664 7.673L25.002 48zM17.333 9.668 25.003 2l7.664 7.668-7.665 7.668zM32.666 25l7.67-7.665L48 25l-7.665 7.666zM2 25l7.67-7.665L17.333 25l-7.665 7.666z"
      }),
      /* @__PURE__ */ jsx602("path", {
        d: "M11.37 34.37v-3.407l-1.7 1.702zm1.706 1.704 1.706 1.703v-10.22l-1.706 1.705zm3.409-10.218v13.63l.85.851.848-.852v-13.63L17.334 25zm6.808 5.107v3.407l1.71-1.705zm-3.404 6.814 1.706-1.703v-6.812l-1.706-1.705zM26.703 19.034v-3.402l-1.705 1.705zm1.703 1.705 1.706 1.704V12.22l-1.706 1.708zm3.407-10.218V24.15l.854.851.85-.851V10.52l-.85-.854zm6.813 5.11v3.403l1.705-1.697zm-3.406 6.812 1.707-1.704v-6.811L35.22 12.22z"
      }),
      /* @__PURE__ */ jsx602("path", {
        d: "M26.703 34.37v-3.407l-1.705 1.702zm1.703 1.704 1.706 1.703v-10.22l-1.706 1.705zm3.407-10.218v13.63l.854.851.85-.852v-13.63l-.85-.856zm6.813 5.107v3.407l1.705-1.705zm-3.406 6.814 1.707-1.703v-6.812l-1.708-1.705zM11.37 19.034v-3.402l-1.7 1.705zm1.706 1.705 1.706 1.704V12.22l-1.706 1.708zm3.409-10.218V24.15l.85.851.848-.851V10.52l-.849-.854zm6.808 5.11v3.403l1.71-1.697zm-3.404 6.812 1.706-1.704v-6.811l-1.706-1.708z"
      })
    ]
  })
});
var Volotea_default = SvgVolotea;

// src/airline-logos/generated/Vueling.tsx
import { jsx as jsx603, jsxs as jsxs521 } from "react/jsx-runtime";
var SvgVueling = (props) => /* @__PURE__ */ jsxs521("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx603("clipPath", {
      id: "vueling_svg__a",
      children: /* @__PURE__ */ jsx603("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs521("g", {
      clipPath: "url(#vueling_svg__a)",
      children: [
        /* @__PURE__ */ jsx603("path", {
          fill: "#ffd300",
          d: "M0 0h50v50H0z"
        }),
        /* @__PURE__ */ jsx603("path", {
          fill: "#504f4f",
          d: "m24.885 29.796-4.699-15.248a3.317 3.317 0 0 0-3.27-2.487A3.547 3.547 0 0 0 13 15.47c.017.7.174 1.388.46 2.026l6.081 16.768c1.198 3.27 2.257 4.377 5.344 4.377h.507c3.132 0 3.823-1.106 5.02-4.33l6.127-16.814c.283-.64.44-1.328.461-2.027a3.548 3.548 0 0 0-3.87-3.455 3.316 3.316 0 0 0-3.316 2.533l-4.607 15.478z"
        })
      ]
    })
  ]
});
var Vueling_default = SvgVueling;

// src/airline-logos/generated/WizzAir.tsx
import { jsx as jsx604, jsxs as jsxs522 } from "react/jsx-runtime";
var SvgWizzAir = (props) => /* @__PURE__ */ jsxs522("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsxs522("linearGradient", {
      id: "wizz-air_svg__a",
      x1: 25,
      x2: 25,
      y1: 36.5,
      y2: 13.5,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx604("stop", {
          offset: 0,
          stopColor: "#161998"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 0.129,
          stopColor: "#441e93"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 0.266,
          stopColor: "#6e228f"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 0.407,
          stopColor: "#90258c"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 0.549,
          stopColor: "#ab2889"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 0.694,
          stopColor: "#be2a87"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 0.842,
          stopColor: "#c92b86"
        }),
        /* @__PURE__ */ jsx604("stop", {
          offset: 1,
          stopColor: "#cd2b86"
        })
      ]
    }),
    /* @__PURE__ */ jsx604("path", {
      fill: "url(#wizz-air_svg__a)",
      d: "M36.743 21.664h4.83l-5.72 7.456H31.02zm-.363-.728-6.08 7.928a.59.59 0 0 0-.064.639.62.62 0 0 0 .551.344h5.428l6.13-7.988a.583.583 0 0 0 .058-.608.577.577 0 0 0-.523-.315zM19.014 17.06a.18.18 0 0 1 .155-.087h3.167l.455-2.605a.171.171 0 0 1 .171-.138l2.965-.003c.054 0 .099.017.13.052.032.04.048.094.04.141l-.295 1.686 13.938.01c.075 0 .13.046.156.09.016.031.038.097-.008.159l-1.258 1.638L48.96 18c.06 0 .102.037.12.071a.11.11 0 0 1-.002.121l-8.585 11.2c-.098.121-.093.431-.025.564.07.133.315.323.469.323l6.039.006a.168.168 0 0 1 .169.194l-.46 2.617a.171.171 0 0 1-.171.137H23.54l-.377-.002a2.135 2.135 0 0 1-2.101 2.533 2.136 2.136 0 0 1-2.141-2.132c0-1.177.958-2.13 2.14-2.13.808 0 1.512.445 1.878 1.103l9.363-12.23c.15-.316.075-.43-.006-.615-.06-.14-.286-.285-.532-.283H25.21l-1.675 9.529a.17.17 0 0 1-.168.127H20.4a.175.175 0 0 1-.131-.059.162.162 0 0 1-.038-.136l1.819-10.343-7.4 14.452a.378.378 0 0 1-.328.191l-2.52.012c-.09 0-.163-.063-.172-.14l-.695-10.499L5.47 33.05a.379.379 0 0 1-.327.19l-2.556-.002a.167.167 0 0 1-.17-.147L.75 17.153a.182.182 0 0 1 .043-.132.179.179 0 0 1 .13-.048h3.436c.094 0 .172.076.172.176l.516 10.397 5.053-10.483a.172.172 0 0 1 .153-.09l3.132-.013c.087 0 .164.065.17.141l.508 10.478zm3.803-3.56a.729.729 0 0 0-.718.601l-.378 2.143h-2.664a.738.738 0 0 0-.653.4l-3.75 7.97-.373-7.706a.73.73 0 0 0-.728-.664h-3.41a.736.736 0 0 0-.653.4l-3.857 8.002-.38-7.676c0-.4-.328-.725-.73-.725H.73c-.207 0-.4.08-.539.226a.763.763 0 0 0-.19.567l1.701 16.277c.041.368.353.646.726.646l2.82.001a.93.93 0 0 0 .824-.494l4.306-8.22.531 8.067a.73.73 0 0 0 .725.646l2.799.001c.344 0 .662-.19.825-.498l5.233-10.223-1.013 5.765a.733.733 0 0 0 .158.596.73.73 0 0 0 .559.259h3.317c.344 0 .637-.24.714-.583l1.596-9.074h5.698l-8.61 11.23a2.876 2.876 0 0 0-1.843-.664 2.876 2.876 0 0 0-2.876 2.865 2.876 2.876 0 0 0 2.876 2.865 2.894 2.894 0 0 0 2.861-2.538l22.733-.002a.722.722 0 0 0 .718-.602l.52-2.949a.726.726 0 0 0-.72-.849l-5.895-.005 8.596-11.207a.672.672 0 0 0 .038-.705.69.69 0 0 0-.613-.371h-9.198l.583-.759a.714.714 0 0 0 .04-.747.734.734 0 0 0-.644-.389H26.67l.184-1.028a.747.747 0 0 0-.17-.598.71.71 0 0 0-.552-.251z"
    })
  ]
});
var WizzAir_default = SvgWizzAir;

// src/components/AirlineIcon/AirlineIcon.tsx
import { jsx as jsx605 } from "react/jsx-runtime";
var iconSizes2 = {
  "xs": "12px",
  "sm": "16px",
  "md": "24px",
  "lg": "32px",
  "xl": "40px",
  "2xl": "48px"
};
var IconWrapper6 = styled31.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize5($size)}
`;
function AirlineIcon({ className, glyph, size, ...attrs }) {
  const GlyphComponent = generated_exports3[glyph];
  if (GlyphComponent === void 0) {
    console.error(`Icon: No icon found for glyph "${glyph}"`);
    return null;
  }
  return /* @__PURE__ */ jsx605(IconWrapper6, {
    className,
    $size: size,
    children: /* @__PURE__ */ jsx605(GlyphComponent, {
      ...attrs
    })
  });
}
AirlineIcon.displayName = "AirlineIcon";
function modSize5(sizeName = "sm") {
  return css18`
  & > svg {
    height: ${iconSizes2[sizeName]};
    width: ${iconSizes2[sizeName]};
  }
`;
}
var AirlineIcon_default = withStyleModifiers(styled31(AirlineIcon)``, {
  modSize: modSize5
});

// src/components/Banner/Banner.tsx
import { css as css19, styled as styled32 } from "styled-components";
import { jsx as jsx606, jsxs as jsxs523 } from "react/jsx-runtime";
var iconMapping2 = {
  "neutral-light": void 0,
  "neutral-dark": void 0,
  "info": void 0,
  "success": "IconCheckmarkCircle",
  "warning": "IconWarningTriangle",
  "error": "IconWarningCircle"
};
var StyledBanner2 = styled32(SpaceBetween)`
  border-radius: ${tk("radius_large")};
  border: 2px solid;
  color: ${tk("color_semantic_text")};
  padding: ${tk("spacing_md")};

  ${({ $type }) => modType4($type)}

  ${({ $withoutBorder }) => $withoutBorder && css19`
      border: none;
    `}
`;
function Banner2({ $type, children, $withoutBorder = false }) {
  const icon = iconMapping2[$type];
  return /* @__PURE__ */ jsxs523(StyledBanner2, {
    forwardedAs: "aside",
    $type,
    direction: "x",
    spacing: tk("spacing_sm"),
    alignItems: "center",
    role: "alert",
    "aria-live": "polite",
    $withoutBorder,
    children: [
      icon !== void 0 && /* @__PURE__ */ jsx606(Icon_default2, {
        size: "md",
        glyph: icon
      }),
      children
    ]
  });
}
function modType4(typeName) {
  return {
    "neutral-light": css19`
      background: ${tk("color_semantic_bg_subdued")};
      border-color: ${tk("color_semantic_bg_strong")};
    `,
    "neutral-dark": css19`
      background: ${tk("color_semantic_bg_strong")};
      border-color: ${tk("color_semantic_border_strong")};
    `,
    "info": css19`
      background: ${tk("color_semantic_bg_info_subdued")};
      border-color: ${tk("color_semantic_border_info")};
    `,
    "success": css19`
      background: ${tk("color_semantic_bg_success_subdued")};
      border-color: ${tk("color_semantic_border_success")};
    `,
    "warning": css19`
      background: ${tk("color_semantic_bg_warning_subdued")};
      border-color: ${tk("color_semantic_border_warning")};
    `,
    "error": css19`
      background: ${tk("color_semantic_bg_error_subdued")};
      border-color: ${tk("color_semantic_border_error")};
    `
  }[typeName];
}
Banner2.displayName = "Banner";

// src/components/BaseInput/BaseInput.tsx
var BaseInput_exports = {};
__export(BaseInput_exports, {
  Box: () => Box,
  ChevronDown: () => ChevronDown2,
  Content: () => Content6,
  Root: () => Root10,
  modDisabled: () => modDisabled6
});
import { css as css20, styled as styled33 } from "styled-components";
import { jsx as jsx607 } from "react/jsx-runtime";
var Root10 = styled33.div`
  position: relative;
  display: flex;
  width: 100%;
`;
var Box = styled33.div`
  display: flex;
  align-items: center;

  width: 100%;
  padding: ${tk("spacing_sm")} ${tk("spacing_md")};
  outline: none;
  cursor: pointer;
  box-sizing: border-box;

  border: 2px solid ${tk("color_semantic_border")};
  border-radius: ${tk("radius_large")};
  box-shadow: ${tk("shadow_input")};
  background: ${tk("color_semantic_bg")};

  font-family: ${tk("typography_body_md_typeface")};
  line-height: ${tk("typography_body_md_line_height")};
  font-weight: ${tk("typography_body_md_weight")};
  letter-spacing: ${tk("typography_body_md_letter_spacing")};

  height: 48px;

  /**
    Force iOS to not zoom in on inputs when they are focused.
    https://css-tricks.com/16px-or-larger-text-prevents-ios-form-zoom/
  */
  font-size: 16px;

  &:focus {
    box-shadow: ${tk("shadow_input_focus_grey")};
  }
`;
var Content6 = styled33.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  &::after {
    position: absolute;
    content: '';
    height: 100%;
    right: 0;
    top: 0;
    width: 32px;
    background: linear-gradient(
      270deg,
      ${tk("color_semantic_bg")} 0%,
      ${tk("color_semantic_bg")} 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;
var ChevronDownWrapper = styled33.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  justify-content: center;

  pointer-events: none;

  height: 48px;
  width: 48px;

  border-radius: 0 ${tk("radius_large")} ${tk("radius_large")} 0;

  border: 2px solid ${tk("color_semantic_border")};
  border-left: none;

  > ${Icon_default2} {
    ${Icon_default2.modSize("sm")}
  }
`;
function ChevronDown2() {
  return /* @__PURE__ */ jsx607(ChevronDownWrapper, {
    children: /* @__PURE__ */ jsx607(Icon_default2, {
      glyph: "IconChevronDown"
    })
  });
}
function modDisabled6() {
  return css20`
  ${Box} {
    color: ${tk("color_semantic_text_disabled")};
    border-color: ${tk("color_semantic_border_disabled")};
    background: ${tk("color_semantic_bg_disabled")};
    cursor: default;
  }

  ${Content6}::after {
    background: linear-gradient(
      270deg,
      ${tk("color_semantic_bg_disabled")} 0%,
      ${tk("color_semantic_bg_disabled")} 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  ${ChevronDownWrapper} {
    color: ${tk("color_semantic_text_disabled")};
  }
`;
}

// src/components/BulletList/BulletList.tsx
import { css as css21, styled as styled34 } from "styled-components";

// src/components/BulletList/clone-children-with-size.tsx
import { Children as Children3, cloneElement as cloneElement2, isValidElement as isValidElement3 } from "react";
var cloneChildrenWithSizeProp = (children, $size) => Children3.map(
  children,
  (child) => {
    var _a, _b;
    return isValidElement3(child) && cloneElement2(child, {
      $size: (_b = (_a = child.props.$size) != null ? _a : $size) != null ? _b : "default"
    });
  }
);

// src/components/BulletList/BulletList.tsx
import { Fragment as Fragment2, jsx as jsx608, jsxs as jsxs524 } from "react/jsx-runtime";
var Item7 = styled34.li.attrs(({ $icon, $size, children }) => ({
  children: /* @__PURE__ */ jsxs524(Fragment2, {
    children: [
      /* @__PURE__ */ jsx608(Icon_default2, {
        glyph: $icon != null ? $icon : $size === "default" ? "IconCheckmarkMedium" : "IconCheckmarkSmall",
        "aria-hidden": true
      }),
      /* @__PURE__ */ jsx608(Typography_default2, {
        children
      })
    ]
  })
}))`
  color: ${({ $themed }) => $themed ? tk("theme_color_neutral_500") : "inherit"};
  list-style-type: none;

  ${Icon_default2} {
    margin-right: ${tk("spacing_2xs")};
    vertical-align: text-top;
  }
`;
Item7.displayName = "BulletList.Item";
var Root11 = styled34.ul.attrs(({ children, $size }) => ({
  children: cloneChildrenWithSizeProp(children, $size)
}))`
  padding: 0;
  margin: 0;

  ${({ $variant }) => modVariant3($variant)}
  ${({ $size }) => modSize6($size)}
  ${({ $type }) => modType5($type)}
`;
Root11.displayName = "BulletList.Root";
function modSize6(sizeName = "default") {
  return {
    small: css21`
      ${Typography_default2} {
        ${Typography_default2.modVariant("body-sm")}
      }

      ${Item7} {
        ${Icon_default2} {
          margin-top: -1px;
        }
      }
    `,
    default: css21`
      ${Typography_default2} {
        ${Typography_default2.modVariant("body-md")}
      }
    `
  }[sizeName];
}
function modType5(typeName = "vertical") {
  return {
    vertical: css21`
      ${Item7} {
        &:not(:last-child) {
          margin-bottom: ${tk("spacing_xs")};
        }
      }
    `,
    inline: css21`
      display: flex;

      ${Item7} {
        display: flex;
        align-items: center;
      }

      ${Item7} + ${Item7} {
        margin-left: ${tk("spacing_md")};
      }
    `
  }[typeName];
}
function modVariant3(variantName = "default") {
  return {
    default: css21`
      ${Item7} {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: list-item;
        list-style-position: inside;
      }
    `,
    multiline: css21`
      ${Item7} {
        display: flex;

        ${Icon_default2} {
          margin-top: 2px;
        }
      }
    `
  }[variantName];
}

// src/components/Button/Button.tsx
import { Children as Children5, isValidElement as isValidElement5 } from "react";
import { css as css22, keyframes as keyframes3, styled as styled35 } from "styled-components";

// src/components/Typography/wrap-text-children-with-typography.tsx
import { Children as Children4, isValidElement as isValidElement4 } from "react";
import { jsx as jsx609 } from "react/jsx-runtime";
var wrapTextChildrenWithTypography2 = (children) => Children4.map(children, (child) => isValidElement4(child) ? child : /* @__PURE__ */ jsx609(Typography_default2, {
  as: "span",
  children: child
}));

// src/components/Button/Button.tsx
import { jsx as jsx610 } from "react/jsx-runtime";
function isChildOfType(type) {
  return (child) => isValidElement5(child) && child.type === type;
}
function hasChildrenOfType(children, type) {
  return Boolean(Children5.toArray(children).find(isChildOfType(type)));
}
function childrenHasOnlyIcon(children) {
  return hasChildrenOfType(children, Icon_default2) && Children5.count(children) === 1;
}
var Button2 = styled35.button.attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography2(children)
}))`
  border: none;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tk("radius_rounded")};
  ${Typography_default2} {
    line-height: ${tk("font_line_height_md")};
  }

  ${({ $withoutColor }) => modWithoutColor($withoutColor)}
  ${({ $size }) => modSize7($size)}
  ${({ $hierarchy }) => modHierarchy($hierarchy)}
  ${({ $fullSize }) => $fullSize && modFullSize()}
  ${({ children }) => childrenHasOnlyIcon(children) && modIconOnly()}
`;
Button2.displayName = "Button";
function modWithoutColor(withoutColor = false) {
  return withoutColor ? css22`
        --button-primary-background-color: ${tk("color_semantic_bg_inverse")};
        --button-primary-background-color-hover: ${tk("color_semantic_bg_inverse_hover")};
        --button-primary-background-color-disabled: ${tk("color_semantic_bg_inverse_disabled")};
        --button-primary-text-color-disabled: ${tk("color_semantic_text_disabled")};

        --button-border-color: ${tk("color_semantic_border")};
        --button-border-color-hover: ${tk("color_semantic_border_hover")};

        --button-secondary-text-color-disabled: ${tk("color_semantic_text_disabled")};

        --button-tertiary-text-color: ${tk("color_semantic_text")};
        --button-tertiary-text-color-disabled: ${tk("color_semantic_text_disabled")};

        --button-focus-shadow: ${tk("shadow_focus_grey")};
      ` : css22`
        --button-primary-background-color: ${tk("color_semantic_bg_primary")};
        --button-primary-background-color-hover: ${tk("color_semantic_bg_primary_hover")};
        --button-primary-background-color-disabled: ${tk("color_semantic_bg_primary_disabled")};
        --button-primary-text-color-disabled: ${tk("color_semantic_text_on_color")};

        --button-border-color: ${tk("color_semantic_border_primary")};
        --button-border-color-hover: ${tk("color_semantic_border_hover")};
        --button-border-color-disabled: ${tk("color_semantic_border_primary_disabled")};

        --button-secondary-border-color-hover: ${tk("color_semantic_border_primary_hover")};
        --button-secondary-text-color: ${tk("color_semantic_text_primary")};
        --button-secondary-text-color-hover: ${tk("color_semantic_text_primary_hover")};
        --button-secondary-text-color-disabled: ${tk("color_semantic_text_primary_disabled")};

        --button-tertiary-text-color: ${tk("color_semantic_text_primary")};
        --button-tertiary-text-color-hover: ${tk("color_semantic_text_primary_hover")};
        --button-tertiary-text-color-disabled: ${tk("color_semantic_text_primary_disabled")};

        --button-focus-shadow: ${tk("shadow_focus_red")};
      `;
}
function modSize7(sizeName = "default") {
  return {
    small: css22`
      padding: ${tk("spacing_xs")};
      min-height: 32px;
      min-width: 32px;

      ${Icon_default2} {
        ${Icon_default2.modSize("sm")}
      }

      ${Typography_default2} {
        ${Typography_default2.modVariant("body-sm-bold")}
      }

      > * + * {
        margin-left: ${tk("spacing_2xs")};
      }
    `,
    default: css22`
      padding: ${tk("spacing_sm")} ${tk("spacing_lg")};
      min-height: 48px;
      min-width: 48px;

      ${Icon_default2} {
        ${Icon_default2.modSize("md")}
      }

      ${Typography_default2} {
        ${Typography_default2.modVariant("label")}
        line-height: ${tk("font_line_height_md")};
      }

      > * + * {
        margin-left: ${tk("spacing_xs")};
      }
    `
  }[sizeName];
}
function modHierarchy(hierarchyName = "primary") {
  return {
    primary: css22`
      background: var(--button-primary-background-color);
      color: ${tk("color_semantic_text_on_color")};

      &:hover&:not(:disabled) {
        background: var(--button-primary-background-color-hover);
      }

      &:focus {
        box-shadow: var(--button-focus-shadow);
        background: var(--button-primary-background-color);
      }

      &:disabled {
        background: var(--button-primary-background-color-disabled);
        color: var(--button-primary-text-color-disabled);
      }
    `,
    secondary: css22`
      background: ${tk("color_semantic_bg")};

      border: 2px solid;
      border-color: var(--button-border-color);
      color: var(--button-secondary-text-color);

      &:hover&:not(:disabled) {
        border-color: var(--button-secondary-border-color-hover);
        color: var(--button-secondary-text-color-hover);
      }

      &:focus {
        box-shadow: var(--button-focus-shadow);
        border-color: var(--button-border-color);
      }

      &:disabled {
        border-color: var(--button-border-color-disabled);
        color: var(--button-secondary-text-color-disabled);
      }
    `,
    tertiary: css22`
      // TODO: This hierarchy has a padding that is inconsistent with Figma design.

      color: var(--button-tertiary-text-color);
      background: none;

      &:hover&:not(:disabled) {
        color: var(--button-tertiary-text-color-hover);
      }

      &:disabled {
        color: var(--button-tertiary-text-color-disabled);
      }
    `
  }[hierarchyName];
}
function modIconOnly() {
  return css22`
  padding: ${tk("spacing_xs")} !important;

  /** Make the size collapse, so it occupies the minimum allowed by the size modifier **/
  width: 0 !important;
  height: 0 !important;
`;
}
function modFullSize() {
  return css22`
  width: 100%;
`;
}
var loadingIconSpinningAnimation2 = keyframes3`
  to {
    transform: rotate(360deg);
  }
`;
var ButtonLoaderIcon = styled35(({ className }) => /* @__PURE__ */ jsx610(Icon_default2, {
  className,
  glyph: "IconLoader"
}))`
  animation: ${loadingIconSpinningAnimation2} 1s linear infinite;
`;
var Button_default2 = withStyleModifiers(Button2, {
  modSize: modSize7
});

// src/components/Checkbox/Checkbox.tsx
import * as RadixCheckbox2 from "@radix-ui/react-checkbox";
import * as React6 from "react";
import { styled as styled36 } from "styled-components";
import { jsx as jsx611, jsxs as jsxs525 } from "react/jsx-runtime";
var SupportText = styled36(Typography_default2)`
  color: inherit;
`;
var StyledWrapper = styled36.label`
  color: ${tk("color_semantic_text")};
  display: block;

  &[aria-invalid='true'] {
    color: ${tk("color_semantic_text_error")};
  }
  &:not([data-disabled='true']) {
    cursor: pointer;

    ${SupportText} {
      color: ${tk("color_semantic_text_subdued")};
    }
  }
`;
var StyledText = styled36.div`
  display: flex;
  flex-direction: column;
  user-select: none;
`;
var CheckboxElement2 = styled36(RadixCheckbox2.Root)`
  all: unset;
  background: ${tk("color_semantic_bg_success")};
  border: 2px solid;
  border-color: transparent;
  border-radius: ${tk("radius_medium")};
  flex-shrink: 0;
  height: 18px;
  width: 18px;
  box-sizing: border-box;
  margin: 3px;

  &[aria-invalid='true'] {
    background: ${tk("color_semantic_bg_error")};
    &[data-state='unchecked'] {
      background: ${tk("color_semantic_bg")};
      border-color: ${tk("color_semantic_border_error")};
      &:not(:disabled):hover {
        background: ${tk("color_semantic_bg")};
        border-color: ${tk("color_semantic_border_error_hover")};
      }
    }
    &:not(:disabled):hover {
      background: ${tk("color_semantic_bg_error_hover")};
    }
  }
  &[data-state='unchecked'] {
    background: ${tk("color_semantic_bg")};
    border-color: ${tk("color_semantic_border_strong")};
    &:disabled {
      background: ${tk("color_semantic_bg_disabled")};
      border-color: ${tk("color_semantic_border_strong_disabled")};
    }
    &:not(:disabled):hover {
      background: ${tk("color_semantic_bg")};
      border-color: ${tk("color_semantic_border_strong_hover")};
    }
  }
  &:disabled {
    background: ${tk("color_semantic_bg_success_disabled")};
    border-color: transparent;
    & ~ * {
      color: ${tk("color_semantic_text_disabled")};
    }
  }
  &:focus-visible {
    box-shadow: ${tk("shadow_focus_grey")};
  }
  &:not(:disabled):hover {
    background: ${tk("color_semantic_bg_success_hover")};
  }
`;
var StyledIndicator = styled36(RadixCheckbox2.Indicator)`
  align-items: center;
  color: ${tk("color_semantic_text_on_color")};
  display: flex;
  justify-content: center;
  max-height: 100%;
  max-width: 100%;
`;
var SrOnlyLabel = styled36(Typography_default2)`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
function CheckboxBase({ id, halfChecked, onCheckedChange, ...attributes }) {
  const [checked, setChecked] = React6.useState("indeterminate");
  const handleCheckedChange = (state) => {
    if (halfChecked) {
      setChecked(state);
    }
    onCheckedChange == null ? void 0 : onCheckedChange({
      checked: state,
      name: attributes.name,
      value: attributes.value
    });
  };
  React6.useEffect(() => {
    var _a;
    setChecked((_a = attributes.checked) != null ? _a : "indeterminate");
  }, [attributes.checked, halfChecked]);
  return /* @__PURE__ */ jsx611(CheckboxElement2, {
    id,
    checked: halfChecked ? checked : void 0,
    onCheckedChange: handleCheckedChange,
    ...attributes,
    children: /* @__PURE__ */ jsxs525(StyledIndicator, {
      children: [
        halfChecked && checked === "indeterminate" && /* @__PURE__ */ jsx611(Icon_default2, {
          glyph: "IconMinusSmall",
          size: "md"
        }),
        (!halfChecked || checked === true) && /* @__PURE__ */ jsx611(Icon_default2, {
          glyph: "IconCheckmarkSmall",
          size: "md"
        })
      ]
    })
  });
}

// src/components/CheckboxElement/CheckboxElement.tsx
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { forwardRef as forwardRef6 } from "react";
import { css as css23, styled as styled37 } from "styled-components";
import { jsx as jsx612 } from "react/jsx-runtime";
var Wrapper5 = styled37(CheckboxPrimitive.Root)`
  all: unset;
  background: ${tk("color_semantic_bg")};
  border: 2px solid ${tk("color_semantic_border_strong")};
  border-radius: ${tk("radius_medium")};
  flex-shrink: 0;
  height: 18px;
  width: 18px;
  box-sizing: border-box;
  margin: 3px;
  overflow: hidden;

  &:hover {
    border-color: ${tk("color_semantic_border_strong_hover")};
  }

  &[data-state='checked'] {
    background: ${tk("color_semantic_bg_success")};
    border-color: ${tk("color_semantic_border_success")};
    &:hover {
      background: ${tk("color_semantic_bg_success_hover")};
      border-color: ${tk("color_semantic_border_success_hover")};
    }
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_grey")};
  }

  ${({ disabled }) => disabled && modDisabled7()}
  ${({ error }) => error && modError2()}
`;
var Indicator5 = styled37(CheckboxPrimitive.Indicator)`
  align-items: center;
  color: ${tk("color_semantic_text_on_color")};
  display: flex;
  justify-content: center;
  max-height: 100%;
  max-width: 100%;
`;
var BaseCheckbox = forwardRef6((props, ref) => /* @__PURE__ */ jsx612(Wrapper5, {
  ref,
  ...props,
  children: /* @__PURE__ */ jsx612(Indicator5, {
    children: /* @__PURE__ */ jsx612(Icon_default2, {
      glyph: "IconCheckmarkSmall",
      size: "md"
    })
  })
}));
BaseCheckbox.displayName = "Checkbox";
function modDisabled7() {
  return css23`
  pointer-events: none;
  background: ${tk("color_semantic_bg_disabled")};
  border-color: ${tk("color_semantic_border_strong_disabled")};
  &[data-state='checked'] {
    background: ${tk("color_semantic_bg_success_disabled")};
    border-color: ${tk("color_semantic_border_success_disabled")};
  }
`;
}
function modError2() {
  return css23`
  border-color: ${tk("color_semantic_border_error")};

  &:hover {
    border-color: ${tk("color_semantic_border_error_hover")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_red")};
  }

  &[data-state='checked'] {
    background: ${tk("color_semantic_bg_error")};
    border-color: ${tk("color_semantic_border_error")};
    &:hover {
      background: ${tk("color_semantic_bg_error_hover")};
      border-color: ${tk("color_semantic_border_error_hover")};
    }
  }
`;
}
var CheckboxElement3 = withStyleModifiers(styled37(BaseCheckbox)``, {
  modError: modError2,
  modDisabled: modDisabled7
});

// src/components/Chip/Chip.tsx
import { css as css24, styled as styled38 } from "styled-components";
import { jsx as jsx613, jsxs as jsxs526 } from "react/jsx-runtime";
var Wrapper6 = styled38.div`
  display: inline-flex;
  align-items: center;
  ${horizontalGap("spacing_xs")};

  padding: ${tk("spacing_xs")} ${tk("spacing_md")};
  white-space: nowrap;

  border-radius: ${tk("radius_rounded")};

  user-select: none;
  outline: none;

  --chip-background-color: ${tk("color_semantic_bg_strong")};
  --chip-background-color-hover: ${tk("color_semantic_bg_strong_hover")};
  --chip-background-color-disabled: ${tk("color_semantic_bg_strong_disabled")};

  --chip-text-color: ${tk("color_semantic_text")};
  --chip-text-color-hover: ${tk("color_semantic_text_on_color")};
  --chip-text-color-disabled: ${tk("color_semantic_text_subdued")};

  --chip-icon-color: ${tk("color_semantic_icon_strong")};
  --chip-icon-color-hover: ${tk("color_semantic_icon_on_color")};
  --chip-icon-color-disabled: ${tk("color_semantic_icon_subdued")};

  background: var(--chip-background-color);
  color: var(--chip-text-color);

  ${Icon_default2} {
    cursor: pointer;
    color: var(--chip-icon-color);
  }

  &:hover {
    background: var(--chip-background-color-hover);
    color: var(--chip-text-color-hover);

    ${Icon_default2} {
      color: var(--chip-icon-color-hover);
    }
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_grey")};
  }

  ${({ $active }) => $active && modActive()}
  ${({ disabled }) => disabled && modDisabled8()}
`;
var CrossIcon = styled38(Icon_default2)`
  ${Icon_default2.modSize("xs")};
`;
function Chip({ active, children, value, removable, onRemoveClick, ...rest }) {
  const { disabled } = rest;
  return /* @__PURE__ */ jsxs526(Wrapper6, {
    ...rest,
    $active: active,
    tabIndex: !disabled ? 0 : void 0,
    children: [
      /* @__PURE__ */ jsx613(Typography_default2, {
        $variant: "body-sm",
        children
      }),
      removable && value && /* @__PURE__ */ jsx613(CrossIcon, {
        glyph: "IconCross",
        onClick: () => onRemoveClick == null ? void 0 : onRemoveClick(value)
      })
    ]
  });
}
function modActive() {
  return css24`
  --chip-background-color: ${tk("color_semantic_bg_inverse")};
  --chip-background-color-hover: ${tk("color_semantic_bg_inverse_hover")};
  --chip-background-color-disabled: ${tk("color_semantic_bg_inverse_disabled")};

  --chip-text-color: ${tk("color_semantic_text_on_color")};
  --chip-text-color-hover: ${tk("color_semantic_text_on_color")};
  --chip-text-color-disabled: ${tk("color_semantic_text_disabled")};

  --chip-icon-color: ${tk("color_semantic_text_on_color")};
  --chip-icon-color-hover: ${tk("color_semantic_text_on_color")};
  --chip-icon-color-disabled: ${tk("color_semantic_text_disabled")};
`;
}
function modDisabled8() {
  return css24`
  pointer-events: none;

  background: var(--chip-background-color-disabled);
  color: var(--chip-text-color-disabled);

  ${Icon_default2} {
    color: var(--chip-icon-color-disabled);
  }

  ${CrossIcon} {
    pointer-events: none;
  }
`;
}
function modNotFocusable() {
  return css24`
  &:focus {
    box-shadow: none;
  }
`;
}
var Chip_default = withStyleModifiers(styled38(Chip)``, { modDisabled: modDisabled8, modNotFocusable });

// src/components/ChoiceItem/ChoiceItem.tsx
import { css as css26, styled as styled40 } from "styled-components";

// src/components/RadioGroup/RadioGroup.tsx
var RadioGroup_exports = {};
__export(RadioGroup_exports, {
  Item: () => Item9,
  List: () => List3,
  Root: () => Root15
});
import * as RadioGroupPrimitive2 from "@radix-ui/react-radio-group";
import { forwardRef as forwardRef7 } from "react";
import { css as css25, styled as styled39 } from "styled-components";
import { jsx as jsx614 } from "react/jsx-runtime";
var Root15 = ({ value, defaultValue, ...props }) => /* @__PURE__ */ jsx614(RadioGroupPrimitive2.Root, {
  value,
  defaultValue,
  ...props
});
Root15.displayName = "RadioGroup.Root";
var List3 = styled39.div`
  display: flex;
  flex-direction: column;

  ${verticalGap("spacing_md")}
`;
var ItemRadio2 = styled39(RadioGroupPrimitive2.Item)`
  width: 20px;
  height: 20px;
  margin: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tk("radius_rounded")};
  outline: none;

  background: ${tk("color_semantic_bg")};
  border: 2px solid ${tk("color_semantic_border_strong")};
  border-radius: ${tk("radius_rounded")};

  &:hover {
    border-color: ${tk("color_semantic_border_strong_hover")};
  }

  &[data-state='checked'] {
    border-color: ${tk("color_semantic_border_strong_active")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_grey")};
  }

  ${({ error }) => error && modError3()}
  ${({ disabled }) => disabled && modDisabled9()}
`;
var ItemIndicator2 = styled39(RadioGroupPrimitive2.Indicator)`
  width: 10px;
  height: 10px;
  border-radius: ${tk("radius_rounded")};
  background: ${tk("color_semantic_border_strong_active")};
`;
var BaseItem = forwardRef7(({ className, ...rest }, ref) => /* @__PURE__ */ jsx614(ItemRadio2, {
  className,
  ref,
  ...rest,
  children: /* @__PURE__ */ jsx614(ItemIndicator2, {})
}));
BaseItem.displayName = "RadioGroup.Item";
function modError3() {
  return css25`
  border-color: ${tk("color_semantic_border_error")};

  &[data-state='checked'] {
    border-color: ${tk("color_semantic_border_error")};
  }

  &:hover {
    border-color: ${tk("color_semantic_border_error_hover")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_red")};
  }

  ${ItemIndicator2},
  &[data-state="checked"] > ${ItemIndicator2} {
    background: ${tk("color_semantic_border_error")};
  }

  &:hover > ${ItemIndicator2} {
    background: ${tk("color_semantic_border_error_hover")};
  }
`;
}
function modDisabled9() {
  return css25`
  pointer-events: none;

  background: ${tk("color_semantic_bg_disabled")};
  border-color: ${tk("color_semantic_border_strong_disabled")};

  &[data-state='checked'] {
    border-color: ${tk("color_semantic_border_strong_disabled")};
  }

  ${ItemIndicator2},
  &[data-state="checked"] > ${ItemIndicator2} {
    background: ${tk("color_semantic_border_strong_disabled")};
  }
`;
}
var Item9 = withStyleModifiers(styled39(BaseItem)``, {
  modError: modError3,
  modDisabled: modDisabled9
});

// src/components/ChoiceItem/ChoiceItem.tsx
var Root16 = styled40.label`
  display: grid;
  justify-content: start;
  grid-template-columns: repeat(2, auto);

  ${({ error }) => error && modError4()}
  ${({ disabled }) => disabled && modDisabled10()}
`;
var Control = styled40.div`
  grid-row: 1 / 3;
  align-self: center;
  margin-right: ${tk("spacing_sm")};
`;
var Label2 = styled40(Typography_default2)`
  grid-column-start: 2;
  grid-column-end: 2;
  ${Typography_default2.modVariant("label")}
`;
var SupportingText2 = styled40(Typography_default2)`
  grid-column-start: 2;
  grid-column-end: 2;
  color: ${tk("color_semantic_text_subdued")};
  ${Typography_default2.modVariant("body-md")}
`;
function modError4() {
  return css26`
  ${Label2},
  ${SupportingText2} {
    color: ${tk("color_semantic_text_error")};
  }
  ${RadioGroup_exports.Item} {
    ${RadioGroup_exports.Item.modError()}
  }

  ${CheckboxElement3} {
    ${CheckboxElement3.modError()}
  }
`;
}
function modDisabled10() {
  return css26`
  ${Label2},
  ${SupportingText2} {
    color: ${tk("color_semantic_text_disabled")};
  }

  ${RadioGroup_exports.Item} {
    ${RadioGroup_exports.Item.modDisabled()}
  }

  ${CheckboxElement3} {
    ${CheckboxElement3.modDisabled()}
  }
`;
}

// src/components/CountryFlagIcon/CountryFlagIcon.tsx
import { css as css27, styled as styled41 } from "styled-components";
import { jsx as jsx615 } from "react/jsx-runtime";
var iconSizes3 = {
  "xs": "12px",
  "sm": "18px",
  "md": "24px",
  "lg": "32px",
  "xl": "40px",
  "2xl": "48px"
};
function modSize8(sizeName = "sm") {
  return css27`
  & > svg {
    height: ${iconSizes3[sizeName]};
    width: ${iconSizes3[sizeName]};
  }
`;
}
var IconWrapper7 = styled41.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize8($size)}
`;
function CountryFlagIcon({ className, glyph, size, ...attrs }) {
  const GlyphComponent = generated_exports[glyph];
  if (GlyphComponent === void 0) {
    console.error(`Icon: No icon found for glyph "${glyph}"`);
    return null;
  }
  return /* @__PURE__ */ jsx615(IconWrapper7, {
    className,
    $size: size,
    children: /* @__PURE__ */ jsx615(GlyphComponent, {
      ...attrs
    })
  });
}
CountryFlagIcon.displayName = "CountryFlagIcon";
var CountryFlagIcon_default = withStyleModifiers(styled41(CountryFlagIcon)``, {
  modSize: modSize8
});

// src/components/DatePicker/DatePicker.tsx
import { da, de, enGB, fr, nl, sv } from "date-fns/locale";
import * as RDP from "react-datepicker";
import { css as css28, styled as styled42 } from "styled-components";
import { jsx as jsx616, jsxs as jsxs527 } from "react/jsx-runtime";
var ReactDatePicker = RDP.default.default || RDP.default || RDP;
var map = {
  "nl-NL": nl,
  "da-DK": da,
  "sv-SE": sv,
  "fr-FR": fr,
  "de-DE": de,
  "en-GB": enGB,
  "nl-BE": nl,
  "fr-BE": fr
};
var BREAKPOINT_DATEPICKER_SMALL = "max-width: 375px";
var StyledDatePickerHeader = styled42.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${tk("spacing_lg")};
  text-transform: capitalize;

  ${Button_default2} {
    display: inline-flex;
    position: absolute;
    left: 0;
  }

  ${Typography_default2} + ${Button_default2} {
    left: auto;
    right: 0;
  }
`;
var StyledDatePicker = styled42.div`
  .react-datepicker {
    display: flex;
    flex-wrap: wrap;
    gap: ${tk("spacing_3xl")};
    justify-content: center;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }

  .react-datepicker__day-names {
    display: flex;
    gap: ${tk("spacing_xs")};
    margin-bottom: ${tk("spacing_md")};
    text-transform: capitalize;
    white-space: nowrap;

    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      gap: ${tk("spacing_2xs")};
    }
  }

  .react-datepicker__day-name {
    flex: 1;
    min-width: 40px;
    height: 24px;
    line-height: 24px;
    margin: 0;
    color: ${tk("color_semantic_text_subdued")};
    font-family: ${tk("typography_body_sm_bold_typeface")};
    font-size: ${tk("typography_body_sm_bold_size")};
    font-weight: ${tk("typography_body_sm_bold_weight")};
    letter-spacing: ${tk("typography_body_sm_bold_letter_spacing")};
    text-align: center;

    ${({ $showWeekNumbers }) => $showWeekNumbers && css28`
        &:first-child {
          position: relative;

          &::after {
            content: '';
            border-right: 1px solid ${tk("color_semantic_border_subdued")};
            height: 100%;
            position: absolute;
            right: 0;
          }
        }
      `}
  }

  .react-datepicker__month {
    display: flex;
    flex-direction: column;
    gap: ${tk("spacing_xs")};

    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      gap: ${tk("spacing_2xs")};
    }
  }

  .react-datepicker__week {
    display: flex;
    gap: ${tk("spacing_xs")};

    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      gap: ${tk("spacing_2xs")};
    }
  }

  .react-datepicker__week-number {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0;
    color: ${tk("color_semantic_text_strong")};
    pointer-events: none;
    font-size: ${tk("typography_body_sm_size")};
    font-weight: ${tk("typography_body_sm_weight")};
    font-family: ${tk("typography_body_sm_typeface")};
    position: relative;

    &::after {
      content: '';
      border-right: 1px solid ${tk("color_semantic_border_subdued")};
      height: calc(100% + ${tk("spacing_md")});
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &:last-child::after {
      height: 100%;
    }
  }

  .react-datepicker__day {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0;
    border: 2px solid;
    border-radius: ${tk("radius_rounded")};
    border-color: transparent;
    cursor: pointer;

    &.react-datepicker__day--keyboard-selected {
      background-color: transparent;
      border-color: transparent;
    }

    &:hover,
    &:hover.react-datepicker__day--keyboard-selected {
      background-color: transparent;
      border-color: ${tk("color_semantic_border_hover")};
    }

    &:focus,
    &:focus.react-datepicker__day--keyboard-selected,
    &:focus-visible,
    &:focus-visible.react-datepicker__day--keyboard-selected {
      background-color: transparent;
      border-color: ${tk("color_semantic_border")};
      box-shadow: ${tk("shadow_focus_grey")};
      outline: none;
    }

    &.react-datepicker__day--outside-month {
      pointer-events: none;
      opacity: 0;
    }

    &.react-datepicker__day--disabled {
      cursor: default;
      color: ${tk("color_semantic_text_disabled")};

      ${Typography_default2} {
        text-decoration: line-through;
      }

      &:hover,
      &:focus,
      &:focus-visible,
      &.react-datepicker__day--keyboard-selected {
        border-color: transparent;
        box-shadow: none;
      }
    }

    &.react-datepicker__day--selected,
    &.react-datepicker__day--in-range {
      color: ${tk("color_semantic_text_on_color")};
      background-color: ${tk("color_semantic_bg_primary")};
      border-color: ${tk("color_semantic_bg_primary")};

      &:hover {
        background-color: ${tk("color_semantic_bg_primary_hover")};
        border-color: ${tk("color_semantic_bg_primary_hover")};
      }

      &:focus,
      &:focus-visible,
      &.react-datepicker__day--keyboard-selected {
        background-color: ${tk("color_semantic_bg_primary")};
      }
    }
  }
`;
function DatePickerHeader(props) {
  const isFirstShownMonth = props.customHeaderCount === 0;
  return /* @__PURE__ */ jsxs527(StyledDatePickerHeader, {
    children: [
      isFirstShownMonth && /* @__PURE__ */ jsx616(Button_default2, {
        $hierarchy: "secondary",
        $size: "small",
        $withoutColor: true,
        onClick: () => props.decreaseMonth(),
        disabled: props.prevMonthButtonDisabled,
        "aria-label": props.previousMonthAriaLabel,
        children: /* @__PURE__ */ jsx616(Icon_default2, {
          glyph: "IconChevronLeft"
        })
      }),
      /* @__PURE__ */ jsx616(Typography_default2, {
        $variant: "body-md-bold",
        as: "p",
        children: props.monthDate.toLocaleDateString(props.localeString, { month: "long", year: "numeric" })
      }),
      (!isFirstShownMonth || props.monthsShown === 1) && /* @__PURE__ */ jsx616(Button_default2, {
        $hierarchy: "secondary",
        $size: "small",
        $withoutColor: true,
        onClick: () => props.increaseMonth(),
        disabled: props.nextMonthButtonDisabled,
        "aria-label": props.nextMonthAriaLabel,
        children: /* @__PURE__ */ jsx616(Icon_default2, {
          glyph: "IconChevronRight"
        })
      })
    ]
  });
}
function DatePickerDay({ dayOfMonth }) {
  return /* @__PURE__ */ jsx616(Typography_default2, {
    $variant: "body-md",
    children: dayOfMonth
  });
}
function DatePicker({
  availableDates,
  selectedDate,
  locale,
  setSelectedDate,
  nextMonthAriaLabel,
  previousMonthAriaLabel,
  startDate,
  endDate,
  numberOfMonths = 2,
  showWeekNumbers,
  weekLabel = "Wk",
  ...attributes
}) {
  RDP.registerLocale(locale, map[locale]);
  const onChange = (date) => {
    setSelectedDate(getLocaleDateString(date));
  };
  return /* @__PURE__ */ jsx616(StyledDatePicker, {
    ...attributes,
    $showWeekNumbers: showWeekNumbers,
    children: /* @__PURE__ */ jsx616(ReactDatePicker, {
      selected: selectedDate ? new Date(selectedDate) : void 0,
      startDate: startDate ? new Date(startDate) : void 0,
      endDate: endDate ? new Date(endDate) : void 0,
      includeDates: availableDates.map((date) => new Date(date)),
      onChange,
      monthsShown: numberOfMonths,
      inline: true,
      showWeekNumbers: Boolean(showWeekNumbers),
      renderCustomHeader: (props) => /* @__PURE__ */ jsx616(DatePickerHeader, {
        ...props,
        monthsShown: numberOfMonths,
        localeString: locale,
        nextMonthAriaLabel,
        previousMonthAriaLabel
      }),
      renderDayContents: (dayOfMonth) => /* @__PURE__ */ jsx616(DatePickerDay, {
        dayOfMonth
      }),
      locale,
      weekLabel
    })
  });
}
DatePicker.modSize = (minWidth) => {
  switch (minWidth) {
    case "desktop":
      return css28`
        .react-datepicker__month {
          width: auto;
        }
      `;
    case "tablet":
      return css28`
        .react-datepicker__month {
          width: 424px;
        }
      `;
    default:
      return css28``;
  }
};

// src/components/DatePicker/MonthPicker.tsx
import { isAfter as isAfter2, isBefore as isBefore2, isFirstDayOfMonth, isLastDayOfMonth } from "date-fns";
import { styled as styled43 } from "styled-components";
import { jsx as jsx617, jsxs as jsxs528 } from "react/jsx-runtime";
var StyledWrapper2 = styled43.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${tk("spacing_xs")};
  @media ${tk("mq_tablet")} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${tk("mq_desktop_sm")} {
    grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));
  }
`;
var ContentWrapper2 = styled43.div`
  position: relative;
`;
var StyledLabel = styled43.label`
  align-items: center;
  background-color: ${tk("color_semantic_bg")};
  border: 2px solid ${tk("color_semantic_border")};
  border-radius: ${tk("radius_large")};
  display: flex;
  flex: 1 0 0;
  height: 8rem;
  justify-content: center;
  padding: ${tk("spacing_lg")} ${tk("spacing_xs")};
  text-align: center;
`;
var StyledYear = styled43(Typography_default2)`
  color: ${tk("color_semantic_text_subdued")};
`;
var HiddenRadio = styled43.input`
  left: 0;
  opacity: 0 !important; // override styles from legacy bundle
  position: absolute;
  top: 0;

  &:checked + ${StyledLabel} {
    background-color: ${tk("color_semantic_bg_strong")};
    border-color: ${tk("color_semantic_border_active")};
  }

  &:disabled + ${StyledLabel} {
    background-color: ${tk("color_semantic_bg_disabled")};
    border-color: ${tk("color_semantic_border_disabled")};
    color: ${tk("color_semantic_text_disabled")};

    ${StyledYear} {
      color: inherit;
    }
  }

  &:not(:disabled) + ${StyledLabel} {
    cursor: pointer;

    &:hover {
      border-color: ${tk("color_semantic_border_hover")};
    }
  }
`;

// src/components/Dot/Dot.tsx
import { styled as styled44 } from "styled-components";
var Dot = styled44.div`
  width: ${tk("spacing_sm")};
  height: ${tk("spacing_sm")};
  background-color: ${({ $color }) => $color};
  border-radius: ${tk("radius_rounded")};
`;

// src/components/Dropdown/Dropdown.tsx
import { css as css29, styled as styled45 } from "styled-components";
import { jsx as jsx618, jsxs as jsxs529 } from "react/jsx-runtime";
var Wrapper7 = styled45.div`
  position: relative;
  display: flex;
  width: 100%;
  ${({ $error }) => $error && modError5()}
  ${({ $withIcon }) => $withIcon && modWithIcon()}
`;
var Select = styled45.select`
  width: 100%;
  padding-top: ${tk("spacing_sm")};
  padding-bottom: ${tk("spacing_sm")};
  padding-right: ${tk("spacing_2xl")};
  padding-left: ${tk("spacing_md")};
  text-overflow: ellipsis;
  outline: none;
  cursor: pointer;
  box-sizing: border-box;

  border: 2px solid ${tk("color_semantic_border")};
  border-radius: ${tk("radius_large")};
  box-shadow: ${tk("shadow_input")};

  font-family: ${tk("typography_body_md_typeface")};
  line-height: ${tk("typography_body_md_line_height")};
  font-weight: ${tk("typography_body_md_weight")};
  letter-spacing: ${tk("typography_body_md_letter_spacing")};
  /**
    Force iOS to not zoom in on inputs when they are focused.
    https://css-tricks.com/16px-or-larger-text-prevents-ios-form-zoom/
  */
  font-size: 16px;

  &:disabled {
    color: ${tk("color_semantic_text_disabled")};
    border-color: ${tk("color_semantic_border_disabled")};
  }

  &:focus {
    box-shadow: ${tk("shadow_input_focus_grey")};
  }

  &:invalid {
    color: ${tk("color_semantic_text_placeholder")};
  }
`;
var ArrowDownIcon = styled45(Icon_default2)`
  position: absolute;
  right: ${tk("spacing_md")};
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;

  ${Select}:disabled + & {
    color: ${tk("color_semantic_text_disabled")};
  }
`;
var DropdownIcon = styled45(Icon_default2)`
  position: absolute;
  left: ${tk("spacing_md")};
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
`;
var DropdownOption = styled45.option`
  background: ${tk("color_semantic_bg")};
  color: ${tk("color_semantic_text")};
`;
function Dropdown({
  className,
  children,
  placeholder,
  value,
  defaultValue,
  usePlaceholder = true,
  error,
  disablePlaceholder,
  icon,
  onChange,
  onValueChange,
  ...rest
}) {
  const handleChange = (e) => {
    onValueChange == null ? void 0 : onValueChange(e.target.value || void 0);
    onChange == null ? void 0 : onChange(e);
  };
  return /* @__PURE__ */ jsxs529(Wrapper7, {
    $error: error,
    className,
    $withIcon: Boolean(icon),
    children: [
      icon && /* @__PURE__ */ jsx618(DropdownIcon, {
        glyph: icon,
        size: "sm"
      }),
      /* @__PURE__ */ jsxs529(Select, {
        ...rest,
        value: value != null ? value : "",
        defaultValue: defaultValue != null ? defaultValue : void 0,
        required: true,
        onChange: handleChange,
        children: [
          usePlaceholder && /* @__PURE__ */ jsx618(DropdownOption, {
            value: "",
            disabled: disablePlaceholder,
            children: placeholder
          }),
          children
        ]
      }),
      /* @__PURE__ */ jsx618(ArrowDownIcon, {
        glyph: "IconChevronDown",
        size: "sm"
      })
    ]
  });
}
function modError5() {
  return css29`
  ${Select} {
    border-color: ${tk("color_semantic_border_error")};
  }
`;
}
function modWithIcon() {
  return css29`
  ${Select} {
    padding-left: ${tk("spacing_xl")};
  }
`;
}
function modDisabled11() {
  return css29`
  ${DropdownIcon}, ${ArrowDownIcon} {
    color: ${tk("color_semantic_text_disabled")};
  }
  ${Select} {
    color: ${tk("color_semantic_text_disabled")};
    border-color: ${tk("color_semantic_border_disabled")};
    background: ${tk("color_semantic_bg_disabled")};
  }
`;
}
var Dropdown_default = withStyleModifiers(styled45(Dropdown)``, {
  modError: modError5,
  modDisabled: modDisabled11
});

// src/components/Dropdown/DropdownGroup.tsx
import { styled as styled46 } from "styled-components";
var DropdownGroup = styled46.div`
  display: flex;
  flex-direction: row;
  gap: 0;

  ${Dropdown_default} {
    select:focus {
      z-index: 1;
    }

    &:not(:first-child):not(:last-child) {
      select {
        border-radius: 0;
      }
    }
    &:not(:first-child) > select {
      border-left: 0;
    }
    &:first-child > select {
      border-radius: ${tk("radius_large")} 0 0 ${tk("radius_large")};
    }
    &:last-child > select {
      border-radius: 0 ${tk("radius_large")} ${tk("radius_large")} 0;
    }
  }
`;

// src/components/DropdownMultiselect/DropdownMultiselect.tsx
import * as Dialog2 from "@radix-ui/react-dialog";
import * as Popover2 from "@radix-ui/react-popover";
import { equals, reject } from "ramda";
import * as React11 from "react";
import { css as css31, styled as styled48 } from "styled-components";

// src/components/DropdownMultiselect/context.tsx
import * as React9 from "react";
import { identity } from "ramda";
var DropdownMultiselectContext = React9.createContext({
  selectedValues: [],
  removeOption: identity,
  addOption: identity,
  removeOptions: identity,
  addOptions: identity
});

// src/components/DropdownMultiselect/Selection.tsx
import * as React10 from "react";
import { css as css30, styled as styled47 } from "styled-components";
import * as Popover from "@radix-ui/react-popover";
import * as Dialog from "@radix-ui/react-dialog";
import { Fragment as Fragment3, jsx as jsx619, jsxs as jsxs530 } from "react/jsx-runtime";
var SelectionIcon = styled47(Icon_default2)`
  margin-right: ${tk("spacing_2xs")};
`;
function SelectionPrimitive({
  children,
  className,
  icon
}) {
  const { selectedValues, disabled, placeholder, asDialog } = React10.useContext(DropdownMultiselectContext);
  const content = /* @__PURE__ */ jsxs530(BaseInput_exports.Root, {
    className,
    children: [
      /* @__PURE__ */ jsx619(BaseInput_exports.Box, {
        tabIndex: disabled ? void 0 : 0,
        children: selectedValues.length > 0 ? /* @__PURE__ */ jsxs530(Fragment3, {
          children: [
            icon && /* @__PURE__ */ jsx619(SelectionIcon, {
              glyph: icon,
              size: "sm"
            }),
            /* @__PURE__ */ jsx619(BaseInput_exports.Content, {
              children: /* @__PURE__ */ jsx619(Chips, {
                $disabled: disabled,
                children
              })
            })
          ]
        }) : /* @__PURE__ */ jsxs530(Fragment3, {
          children: [
            icon && /* @__PURE__ */ jsx619(SelectionIcon, {
              glyph: icon,
              size: "sm"
            }),
            /* @__PURE__ */ jsx619(Placeholder2, {
              $variant: "body-md",
              children: placeholder
            })
          ]
        })
      }),
      /* @__PURE__ */ jsx619(BaseInput_exports.ChevronDown, {})
    ]
  });
  return asDialog ? /* @__PURE__ */ jsx619(Dialog.Trigger, {
    asChild: true,
    children: content
  }) : /* @__PURE__ */ jsx619(Popover.Trigger, {
    asChild: true,
    children: content
  });
}
var Chips = styled47.div`
  align-items: center;
  display: flex;
  min-width: 0;
  position: relative;

  > * {
    margin-right: ${tk("spacing_2xs")};

    &:last-child {
      margin-right: 0;
    }
  }

  ${Chip_default} {
    ${Chip_default.modNotFocusable()}
  }

  ${({ $disabled }) => $disabled && css30`
      pointer-events: none;
      ${Chip_default} {
        ${Chip_default.modDisabled()}
      }
    `}
`;
var Placeholder2 = styled47(Typography_default2)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: none;

  margin-right: ${tk("spacing_lg")};

  color: ${tk("color_semantic_text_placeholder")};
`;
var modDisabled12 = () => css30`
  ${BaseInput_exports.modDisabled()}

  ${Chip_default} {
    ${Chip_default.modDisabled()}
  }
`;
var Selection = withStyleModifiers(styled47(SelectionPrimitive)``, { modDisabled: modDisabled12 });

// src/components/DropdownMultiselect/DropdownMultiselect.tsx
import { jsx as jsx620 } from "react/jsx-runtime";
var Wrapper8 = styled48.div`
  ${({ $disabled }) => $disabled && modDisabled13()}
`;
function modDisabled13() {
  return css31`
  ${Selection} {
    ${Selection.modDisabled()}
  }

  ${Chip_default} {
    ${Chip_default.modDisabled()}
  }
`;
}

// src/components/DropdownMultiselect/Popover.tsx
import { styled as styled49 } from "styled-components";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { jsx as jsx621 } from "react/jsx-runtime";
var Content8 = styled49.div`
  background: ${tk("color_semantic_bg")};
  border-radius: ${tk("radius_large")};
  border: 2px solid ${tk("color_semantic_border")};
  box-shadow: ${tk("shadow_md_bottom")};
  display: flex;
  flex-direction: column;
  margin-top: ${tk("spacing_2xs")};
  max-height: 400px;
  max-width: 400px;
  outline: none;
  width: var(--radix-popover-trigger-width);
  z-index: ${zIndex.modalOrMobilePopover};
  @media ${tk("mq_desktop_lg")} {
    z-index: ${zIndex.popover};
  }
`;

// src/components/DropdownMultiselect/Options.tsx
import { styled as styled50, css as css32 } from "styled-components";
import * as React12 from "react";
import { jsx as jsx622 } from "react/jsx-runtime";
var Wrapper9 = styled50.div`
  overflow-y: auto;
  min-height: 0;

  padding: ${tk("spacing_lg")};

  ${({ $asDialog }) => $asDialog && css32`
      padding: 0;
    `}
`;

// src/components/DropdownMultiselect/SelectedValue.tsx
import * as React13 from "react";
import { jsx as jsx623 } from "react/jsx-runtime";

// src/components/DropdownMultiselect/CheckBoxWithExtra.tsx
import { styled as styled51 } from "styled-components";
import * as React14 from "react";
import { jsx as jsx624, jsxs as jsxs531 } from "react/jsx-runtime";
var Wrapper10 = styled51.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${tk("spacing_lg")};

  &:last-of-type {
    margin-bottom: 0;
  }

  > ${Typography_default2} {
    color: ${tk("color_semantic_text_subdued")};
  }
`;

// src/components/DropdownMultiselect/ConfirmButton.tsx
import * as React15 from "react";
import { css as css33, styled as styled52 } from "styled-components";
import * as Popover3 from "@radix-ui/react-popover";
import * as Dialog3 from "@radix-ui/react-dialog";
import { jsx as jsx625, jsxs as jsxs532 } from "react/jsx-runtime";
function ConfirmButton({ children, className, ...rest }) {
  const { asDialog } = React15.useContext(DropdownMultiselectContext);
  const content = /* @__PURE__ */ jsx625(Button_default2, {
    $fullSize: true,
    ...rest,
    children
  });
  return /* @__PURE__ */ jsxs532(Wrapper11, {
    className,
    children: [
      asDialog && /* @__PURE__ */ jsx625(Dialog3.Close, {
        asChild: true,
        children: content
      }),
      !asDialog && /* @__PURE__ */ jsx625(Popover3.Close, {
        asChild: true,
        children: content
      })
    ]
  });
}
var Wrapper11 = styled52.div`
  padding: ${tk("spacing_md")} ${tk("spacing_lg")};
  box-shadow: ${tk("shadow_md_top")};
`;
var modNoShadow = () => css33`
  padding: 0;
  box-shadow: none;
`;
var ConfirmButton_default = withStyleModifiers(styled52(ConfirmButton)``, {
  modNoShadow
});

// src/components/DropdownMultiselect/Dialog.tsx
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { styled as styled53 } from "styled-components";
import { jsx as jsx626 } from "react/jsx-runtime";
var Content10 = styled53.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${tk("color_semantic_bg")};
  z-index: ${zIndex.modalOrMobilePopover};
  @media ${tk("mq_desktop_lg")} {
    z-index: ${zIndex.popover};
  }
`;

// src/components/DropdownMultiselect/Footer.tsx
import { styled as styled54 } from "styled-components";
var Footer = styled54.div`
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  background-color: ${tk("color_semantic_bg")};
  z-index: 1;
`;

// src/components/DropdownMultiselect/useEditableDropdownMultiselect.tsx
import * as React16 from "react";
import { equals as equals2 } from "ramda";

// src/components/Filters/ChoiceListItem.tsx
import { useId as useId3 } from "react";
import { css as css35, styled as styled56 } from "styled-components";

// src/components/RadioInput/RadioInput.tsx
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import { useId as useId2 } from "react";
import { css as css34, styled as styled55 } from "styled-components";
import { Fragment as Fragment4, jsx as jsx627, jsxs as jsxs533 } from "react/jsx-runtime";
var RadioBaseInnerCircle = styled55.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: ${tk("color_semantic_bg")};
  border: 2px solid ${tk("color_semantic_border_strong")};
  border-radius: ${tk("radius_rounded")};

  ${({ $disabled }) => modDisabledInnerCircle($disabled)}
`;
var StyledRadioBase = styled55(RadixRadioGroup.Item)`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tk("radius_rounded")};
  outline: none;

  &:focus-visible {
    background: ${tk("color_palette_grey_300")};
  }

  &:not(:disabled):hover {
    ${RadioBaseInnerCircle} {
      border-color: ${tk("color_semantic_border_strong_hover")};
    }
  }
`;
var RadioBaseChecked = styled55(RadixRadioGroup.Indicator)`
  width: 10px;
  height: 10px;
  border-radius: ${tk("radius_rounded")};
  background: ${tk("color_semantic_border_strong_active")};
`;
var Wrapper12 = styled55(SpaceBetween)`
  width: 100%;

  @media ${tk("mq_tablet")} {
    max-width: 340px;
  }

  ${({ $disabled }) => modDisabled14($disabled)}
`;
var Texts = styled55(SpaceBetween)`
  flex: 1;
`;
var Label3 = styled55.label`
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: ${tk("spacing_sm")};

  ${Icon_default2} {
    margin-right: ${tk("spacing_2xs")};
  }

  ${({ $disabled }) => !$disabled && css34`
      cursor: pointer;
    `}
`;
function RadioInput({
  count,
  icon,
  label,
  supportingText,
  disabled = false,
  ...attributes
}) {
  const id = useId2();
  const hasLabelContent = () => {
    return icon || label || supportingText || count;
  };
  return /* @__PURE__ */ jsx627(Wrapper12, {
    direction: "x",
    alignItems: "center",
    $disabled: disabled,
    children: /* @__PURE__ */ jsxs533(Fragment4, {
      children: [
        /* @__PURE__ */ jsx627(RadioBase, {
          id,
          disabled,
          ...attributes
        }),
        hasLabelContent() && /* @__PURE__ */ jsxs533(Label3, {
          htmlFor: id,
          $disabled: disabled,
          children: [
            icon && /* @__PURE__ */ jsx627(Icon_default2, {
              size: "md",
              glyph: icon
            }),
            /* @__PURE__ */ jsxs533(Texts, {
              direction: "y",
              children: [
                label && /* @__PURE__ */ jsx627(Typography_default2, {
                  $variant: "label",
                  children: label
                }),
                supportingText && /* @__PURE__ */ jsx627(Typography_default2, {
                  $variant: "body-md",
                  children: supportingText
                })
              ]
            }),
            count && /* @__PURE__ */ jsx627(Typography_default2, {
              $variant: "body-md",
              children: count
            })
          ]
        })
      ]
    })
  });
}
function RadioBase({ id, disabled = false, ...attributes }) {
  return /* @__PURE__ */ jsx627(StyledRadioBase, {
    id,
    disabled,
    ...attributes,
    children: /* @__PURE__ */ jsx627(RadioBaseInnerCircle, {
      $disabled: disabled,
      children: /* @__PURE__ */ jsx627(RadioBaseChecked, {})
    })
  });
}
function modDisabled14($disabled) {
  const disabledTextColorCSS = css34`
    ${Typography_default2} {
      color: ${tk("color_semantic_text_disabled")} !important;
    }
  `;
  return $disabled ? disabledTextColorCSS : css34``;
}
function modDisabledInnerCircle($disabled) {
  const disabledCSS = css34`
    background: ${tk("color_semantic_bg_disabled")};
    border-color: ${tk("color_semantic_border_strong_disabled")};

    ${RadioBaseChecked} {
      background: ${tk("color_semantic_border_strong_disabled")};
    }
  `;
  return $disabled ? disabledCSS : css34``;
}
RadioInput.displayName = "RadioInput";

// src/components/Filters/ChoiceListItem.tsx
import { jsx as jsx628, jsxs as jsxs534 } from "react/jsx-runtime";
var ContentWrapper3 = styled56.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding-left: ${tk("spacing_sm")};

  ${Icon_default2} {
    margin-right: ${tk("spacing_xs")};
  }
`;
var Wrapper13 = styled56.label`
  position: relative;
  cursor: pointer;
  margin-bottom: ${tk("spacing_xs")};
  align-items: center;
  background: ${tk("color_semantic_bg")};
  border: solid 2px ${tk("color_semantic_border")};
  border-radius: ${tk("radius_large")};
  box-shadow: ${tk("shadow_md_bottom")};
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  padding: ${tk("spacing_md")};
  user-select: none;

  &:hover {
    border-color: ${tk("color_semantic_border_hover")};
  }

  ${({ $disabled }) => !$disabled && css35`
      &:has([data-state='checked'])&:not(:disabled) {
        border-color: ${tk("color_semantic_border_active")};
      }
    `}

  ${({ $disabled }) => $disabled && modDisabled15()}
`;
var Name = styled56(Typography_default2)`
  color: ${tk("color_semantic_text")};
`;
var QuantityLabel = styled56(Typography_default2)`
  color: ${tk("color_semantic_text_subdued")};
  margin-left: auto;
`;
function ChoiceListItem(props) {
  var _a;
  const generatedId = useId3();
  const id = (_a = props.id) != null ? _a : generatedId;
  if (props.choiceListItemType === "radio") {
    const { choiceListItemType: choiceListItemType2, icon: icon2, label: label2, disabled: disabled2, quantity: quantity2, ...rest2 } = props;
    return /* @__PURE__ */ jsxs534(Wrapper13, {
      $disabled: disabled2,
      "aria-label": label2,
      htmlFor: id,
      children: [
        /* @__PURE__ */ jsx628(RadioBase, {
          id,
          disabled: disabled2,
          ...rest2
        }),
        /* @__PURE__ */ jsx628(Content11, {
          label: label2,
          quantity: quantity2,
          icon: icon2
        })
      ]
    });
  }
  const { choiceListItemType, icon, label, disabled, quantity, ...rest } = props;
  return /* @__PURE__ */ jsxs534(Wrapper13, {
    $disabled: disabled,
    "aria-label": label,
    htmlFor: id,
    children: [
      /* @__PURE__ */ jsx628(CheckboxBase, {
        id,
        disabled,
        ...rest
      }),
      /* @__PURE__ */ jsx628(Content11, {
        label,
        quantity,
        icon
      })
    ]
  });
}
function Content11({ icon, label, quantity }) {
  return /* @__PURE__ */ jsxs534(ContentWrapper3, {
    children: [
      icon && /* @__PURE__ */ jsx628(Icon_default2, {
        glyph: icon,
        size: "md",
        "aria-hidden": true
      }),
      /* @__PURE__ */ jsx628(Name, {
        $variant: "body-md",
        "aria-hidden": true,
        children: label
      }),
      /* @__PURE__ */ jsx628(QuantityLabel, {
        $variant: "body-md",
        children: quantity
      })
    ]
  });
}
ChoiceListItem.displayName = "ChoiceListItem";
function modDisabled15() {
  return css35`
  pointer-events: none;
  background: ${tk("color_semantic_bg_disabled")};
  border-color: ${tk("color_semantic_border_disabled")};

  ${Typography_default2},
  ${ContentWrapper3} > ${Icon_default2} {
    color: ${tk("color_semantic_text_disabled")};
  }
`;
}

// src/components/FormField/FormField.tsx
import { css as css37, styled as styled58 } from "styled-components";

// src/components/TextField/TextField.tsx
var TextField_exports = {};
__export(TextField_exports, {
  Content: () => Content12,
  Input: () => Input2,
  Leading: () => Leading,
  Root: () => Root21,
  Trailing: () => Trailing
});
import { css as css36, styled as styled57 } from "styled-components";
var Input2 = styled57.input`
  border-color: transparent;
  width: 100%;
  cursor: pointer;
  background: transparent;
  ${Typography_default2.modVariant("body-md")}
  color: ${tk("color_semantic_text")};
  height: ${tk("spacing_lg")};
  margin: 0;
  border: none;
  text-overflow: ellipsis;

  &:focus {
    border-color: transparent;
    outline: none;
  }
  ::placeholder {
    color: ${tk("color_semantic_text_placeholder")};
  }
`;
Input2.displayName = "TextField.Input";
var BaseRoot = styled57.label.attrs(() => ({
  tabIndex: void 0
}))`
  display: flex;
  align-items: center;

  padding: ${tk("spacing_sm")} ${tk("spacing_md")};

  background: ${tk("color_semantic_bg")};
  border: solid 2px ${tk("color_semantic_border")};
  border-radius: ${tk("radius_large")};
  box-shadow: ${tk("shadow_md_bottom")};

  overflow: hidden;
  cursor: pointer;
  outline: none;

  &:hover {
    border-color: ${tk("color_semantic_border_hover")};
  }

  &:focus-within,
  &:focus {
    box-shadow: ${tk("shadow_focus_grey")};
  }

  ${Icon_default2} {
    color: ${tk("color_semantic_icon")};
  }
  ${({ error }) => error && modError6()}
  ${({ disabled }) => disabled && modDisabled16()}
`;
var Leading = styled57.div`
  justify-self: start;
  display: flex;
  margin-right: ${tk("spacing_xs")};
  margin-left: 0;
`;
var Trailing = styled57.div`
  justify-self: end;
  display: flex;
  margin-left: ${tk("spacing_xs")};
  margin-right: 0;
`;
var Content12 = styled57.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
function modError6() {
  return css36`
  border-color: ${tk("color_semantic_border_error")};

  &:hover {
    border-color: ${tk("color_semantic_border_error_hover")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_red")};
  }
`;
}
function modDisabled16() {
  return css36`
  background: ${tk("color_semantic_bg_disabled")};
  border-color: ${tk("color_semantic_border_disabled")};
  box-shadow: none;
  pointer-events: none;
  cursor: default;

  ${Trailing} > ${Typography_default2} {
    color: ${tk("color_semantic_text_disabled")};
  }

  ${Icon_default2} {
    color: ${tk("color_semantic_text_disabled")};
  }

  ${Input2} {
    color: ${tk("color_semantic_text_disabled")};
    &::placeholder {
      color: ${tk("color_semantic_text_disabled")};
    }
  }
`;
}
var shouldForwardProp = (prop) => !["error", "disabled"].includes(prop);
var Root21 = withStyleModifiers(styled57(BaseRoot).withConfig({ shouldForwardProp })``, {
  modError: modError6,
  modDisabled: modDisabled16
});

// src/components/FormField/FormField.tsx
var FormField = styled58.div.attrs(({ as = "label" }) => ({
  as
}))`
  display: flex;
  flex-direction: column;
  ${verticalGap("spacing_xs")}

  user-select: none;
  ${({ $error }) => $error && modError7()}
  ${({ $horizontalLabel }) => $horizontalLabel && modHorizontalLabel()}
`;
var FormFieldLabel = styled58(Typography_default2).attrs({
  $variant: "body-sm"
})`
  color: ${tk("color_semantic_text_strong")};

  ${({ as }) => as === "label" && `
    cursor: pointer;
  `}
`;
var FormFieldControl = styled58.div``;
var FormFieldMessageBase = styled58(Typography_default2).attrs({
  $variant: "body-sm"
})`
  display: block;
`;
var FormFieldHint = styled58(FormFieldMessageBase)`
  color: ${tk("color_semantic_text_subdued")};
`;
var FormFieldError = styled58(FormFieldMessageBase)`
  color: ${tk("color_semantic_text_error")};
`;
var FormFieldMessageContainer = styled58.div`
  @media ${tk("mq_tablet")} {
    margin-top: ${tk("spacing_xs")};
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    ${verticalGap("spacing_xs")};
  }
`;
function modError7() {
  return css37`
  ${Dropdown_default} {
    ${Dropdown_default.modError()}
  }
  ${TextField_exports.Root} {
    ${TextField_exports.Root.modError()}
  }
`;
}
function modHorizontalLabel() {
  return css37`
  @media ${tk("mq_tablet")} {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    column-gap: ${tk("spacing_sm")};
    ${verticalGap("spacing_none")};

    ${FormFieldLabel} {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: right;
    }
  }
`;
}

// src/components/Image/Image.tsx
import { reverse } from "ramda";
import * as React17 from "react";
import { css as css38, styled as styled59 } from "styled-components";
import { jsx as jsx629, jsxs as jsxs535 } from "react/jsx-runtime";
var Wrapper14 = styled59.div`
  position: relative;
  background: ${tk("color_semantic_bg_strong")};
  overflow: hidden;

  ${({ $width, $height }) => modSize9($width, $height)}
  ${({ $sources }) => modResponsiveSizes($sources)}
`;
var Picture = styled59.picture`
  width: 100%;
  height: 100%;
  display: flex;
`;
var Image = styled59.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;

  opacity: 0;
  transition: opacity 300ms ease-in;

  ${({ $hasLoaded }) => $hasLoaded && css38`
      opacity: 1;
    `}
`;
var Loader = styled59.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center;

  filter: blur(12px);
  transition: opacity 300ms ease-out;

  ${({ $hasLoaded, $hasLoadError }) => ($hasLoaded || $hasLoadError) && css38`
      opacity: 0;
    `}
`;
function modSize9(width, height) {
  return css38`
  width: ${width}px;
  height: ${height}px;
`;
}
function modResponsiveSizes(responsiveSizes) {
  return reverse(responsiveSizes).map(
    ({ breakpoint, width, height }) => css38`
      @media screen and (min-width: ${tk(breakpoint)}) {
        ${modSize9(width, height)}
      }
    `
  );
}
var Error2 = styled59.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;
  width: 100%;

  padding: 0 ${tk("spacing_md")};

  color: ${tk("color_semantic_text_strong")};
  text-align: center;

  > ${Typography_default2} {
    margin-top: ${tk("spacing_xs")};
    max-width: 11rem;
  }
`;

// src/components/Label/Label.tsx
import { css as css39, styled as styled60 } from "styled-components";
var Label4 = styled60.div.attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography2(children)
}))`
  align-items: center;
  display: inline-flex;
  justify-content: center;

  & > * ~ * {
    margin-left: ${tk("spacing_2xs")};
  }

  ${({ $state }) => modState($state)}
  ${({ $size }) => modSize10($size)}
  ${({ $variant }) => modVariant4($variant)};
`;
Label4.displayName = "Label";
function modVariant4(variantName = "default") {
  return {
    corner: css39`
      border-radius: 0 0 ${tk("radius_large")};
    `,
    default: css39`
      border-radius: ${tk("radius_medium")};
    `
  }[variantName];
}
function modState(stateName = "brand") {
  return {
    brand: css39`
      background-color: ${tk("color_semantic_bg_primary")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    canceled: css39`
      background-color: ${tk("color_semantic_bg_inverse")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    discount: css39`
      background-color: ${tk("color_semantic_bg_error_subdued")};
      color: ${tk("color_semantic_text_error")};
    `,
    error: css39`
      background-color: ${tk("color_semantic_bg_error")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    success: css39`
      background-color: ${tk("color_semantic_bg_success")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    warning: css39`
      background-color: ${tk("color_semantic_bg_warning")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    info: css39`
      background-color: ${tk("color_semantic_bg_strong")};
      color: ${tk("color_semantic_text_strong")};
    `
  }[stateName];
}
function modSize10(sizeName = "default") {
  return {
    small: css39`
      padding: 2px ${tk("spacing_2xs")};

      ${Icon_default2} {
        display: none;
      }

      ${Typography_default2} {
        ${Typography_default2.modVariant("body-xs-bold")}
      }
    `,
    default: css39`
      padding: ${tk("spacing_2xs")} ${tk("spacing_xs")};

      ${Icon_default2} {
        ${Icon_default2.modSize("sm")}
      }

      ${Typography_default2} {
        ${Typography_default2.modVariant("body-sm-bold")}
      }
    `
  }[sizeName];
}
var Label_default = withStyleModifiers(Label4, {
  modSize: modSize10
});

// src/components/Label/CollectionLabel.tsx
import { css as css40, styled as styled61 } from "styled-components";
var CollectionLabel = styled61.div.attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography2(children)
}))`
  align-items: center;
  display: inline-flex;
  justify-content: center;

  & > * ~ * {
    margin-left: ${tk("spacing_2xs")};
  }

  ${({ $type }) => modType6($type)}

  padding: ${tk("spacing_2xs")} ${tk("spacing_xs")};

  ${Typography_default2} {
    ${Typography_default2.modVariant("body-sm-bold")}
  }

  ${({ $variant }) => modVariant5($variant)}
`;
CollectionLabel.displayName = "CollectionLabel";
function modVariant5(variantName = "default") {
  return {
    corner: css40`
      border-radius: 0 0 ${tk("radius_large")};
    `,
    default: css40`
      border-radius: ${tk("radius_medium")};
    `
  }[variantName];
}
function modType6(typeName = "default") {
  return {
    boutique: css40`
      background-color: ${tk("color_collection_boutique")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    cycling: css40`
      background-color: ${tk("color_collection_cycling")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    excellent: css40`
      background-color: ${tk("color_collection_excellent")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    famfun: css40`
      background-color: ${tk("color_collection_fam_fun")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    primavera: css40`
      background-color: ${tk("color_collection_primavera")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    secrets: css40`
      background-color: ${tk("color_collection_secrets")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    selections: css40`
      background-color: ${tk("color_collection_selections")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    villages: css40`
      background-color: ${tk("color_collection_villages")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    xperience: css40`
      background-color: ${tk("color_collection_xperience")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    atlantis: css40`
      background-color: ${tk("color_collection_atlantis")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    totally: css40`
      background-color: ${tk("color_collection_totally")};
      color: ${tk("color_semantic_text_on_color")};
    `,
    default: css40`
      background-color: ${tk("color_semantic_bg_primary")};
      color: ${tk("color_semantic_text_on_color")};
    `
  }[typeName];
}

// src/components/LazyLoader/LazyLoader.tsx
import * as React18 from "react";
import { styled as styled62 } from "styled-components";
import { jsx as jsx630 } from "react/jsx-runtime";
var Wrapper15 = styled62.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

// src/components/ListItem/ListItem.tsx
import { css as css41, styled as styled63 } from "styled-components";
var Root22 = styled63.label.attrs(({ disabled }) => ({
  tabIndex: !disabled ? 0 : void 0
}))`
  display: flex;
  align-items: center;

  padding: ${tk("spacing_sm")};

  background: ${tk("color_semantic_bg")};
  border: solid 2px ${tk("color_semantic_border")};
  border-radius: ${tk("radius_large")};
  box-shadow: ${tk("shadow_md_bottom")};

  overflow: hidden;
  cursor: pointer;
  outline: none;
  user-select: none;

  &:has(${RadioGroup_exports.Item}[data-state='checked']),
  &:has(${CheckboxElement3}[data-state='checked']) {
    border-color: ${tk("color_semantic_border_active")};
  }

  &:hover {
    border-color: ${tk("color_semantic_border_hover")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_grey")};
  }

  @media ${tk("mq_desktop_sm")} {
    padding: ${tk("spacing_md")};
  }

  ${({ error }) => error && modError8()}
  ${({ disabled }) => disabled && modDisabled17()}
`;
var Control2 = styled63.div`
  display: flex;
  margin-right: ${tk("spacing_sm")};
`;
var Icon3 = styled63(Icon_default2)`
  margin-right: ${tk("spacing_xs")};

  &:first-child {
    margin-right: ${tk("spacing_md")};
  }

  ${Icon_default2.modSize("md")}
`;
var Trailing2 = styled63.div`
  justify-self: end;
  margin-left: ${tk("spacing_xs")};
  margin-right: 0;
`;
var Content13 = styled63.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
var Badge2 = styled63(Label_default)`
  margin-bottom: ${tk("spacing_2xs")};
`;
var Label5 = styled63(Typography_default2)`
  ${Typography_default2.modVariant("label")}
`;
var Description = styled63(Typography_default2)`
  color: ${tk("color_semantic_text_strong")};
  ${Typography_default2.modVariant("body-md")}
`;
function modError8() {
  return css41`
  border-color: ${tk("color_semantic_border_error")};

  &:hover {
    border-color: ${tk("color_semantic_border_error_hover")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_red")};
  }

  &:has(${RadioGroup_exports.Item}[data-state='checked']),
  &:has(${CheckboxElement3}[data-state='checked']) {
    border-color: ${tk("color_semantic_border_error")};
  }

  ${RadioGroup_exports.Item} {
    ${RadioGroup_exports.Item.modError()}
  }

  ${CheckboxElement3} {
    ${CheckboxElement3.modError()}
  }
`;
}
function modDisabled17() {
  return css41`
  background: ${tk("color_semantic_bg_disabled")};
  border-color: ${tk("color_semantic_border_disabled")};
  box-shadow: none;
  pointer-events: none;
  cursor: default;

  ${Icon3},
  ${Label5},
  ${Description},
  ${Trailing2} > ${Typography_default2} {
    color: ${tk("color_semantic_text_disabled")};
  }

  &:has(${RadioGroup_exports.Item}[data-state='checked']),
  &:has(${CheckboxElement3}[data-state='checked']) {
    border-color: ${tk("color_semantic_border_disabled")};
  }

  ${RadioGroup_exports.Item} {
    ${RadioGroup_exports.Item.modDisabled()}
  }

  ${CheckboxElement3} {
    ${CheckboxElement3.modDisabled()}
  }
`;
}

// src/components/LoadingSpinner/LoadingSpinner.tsx
import { keyframes as keyframes4, styled as styled64 } from "styled-components";
import { jsx as jsx631, jsxs as jsxs536 } from "react/jsx-runtime";
var rotateLogoAnimation = keyframes4`
  80% { transform: rotate(6deg); }
  92% { transform: rotate(-3deg); }
  97% { transform: rotate(1.5deg); }
  100% { transform: rotate(0); }
`;
var scaleSparksAnimation = keyframes4`
  0% { transform: scale3d(0, 0, 0); }
  80% { transform: scale3d(0, 0, 0); }
  100% { transform: scale3d(1, 1.2, 1); }
`;
var scaleSparksBrandAnimation = keyframes4`
  0% {
    transform: scale3d(0, 0, 0);
  }
  40% {
    transform: scale3d(1, 1.2, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
`;
var Wrapper16 = styled64.div`
  --loader-size: 100px;

  --loader-logo-size: calc(var(--loader-size) / 2);

  --loader-spark-width: calc(var(--loader-size) / 15);
  --loader-spark-height: calc(var(--loader-size) / 6.2);
  --loader-spark-rotation: 30deg;

  --loader-spark-animation-duration: 3;
  --loader-spark-rotation: 30deg;
  --loader-spark-animation-delay: 0.03s;

  position: relative;
  display: flex;
  width: var(--loader-size);
  height: var(--loader-size);
`;
var Logo = styled64.div`
  align-self: center;
  background-image: url("data:image/svg+xml,%3Csvg id='sundio' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 246.8 352.24'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23ed2924;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Es-loader%3C/title%3E%3Cpath class='cls-1' d='M149.63,139.92C116.88,127.6,91,117.88,92,93.45c.87-21.59,18.8-32.85,50.49-31.67,24,.89,37,6.36,47.41,10.76,7.12,3,13.7,7,21.14,7.52,17.08,1.27,23-11.91,30.66-27.81,4.21-8.71,3.53-16.52-3.95-24.25-4.8-5-19.35-12.24-30.44-16.69-14.38-5.78-34-10.25-59-11.18C107.15-1.4,72.72,7.45,48.71,25.7c-23,17.44-35.75,42.63-37,72.8-2.69,66.7,50.85,87.26,93.86,103.77,33.11,12.72,61.71,23.7,60.6,51.07-1,24.67-21.69,38.08-56.79,36.79-29.72-1.11-44.52-7.57-55.33-12.3-6.82-3-13.43-7.37-20.61-8.18-17.35-2-22.76,14.27-30.85,29.6C-2.8,309.5,0,320.43,12.76,327.48c16,8.84,42,22.73,90.86,24.53,43.36,1.61,79.5-7.59,104.49-26.6,23.94-18.21,37.29-44.8,38.58-76.87C249.56,177.48,194.15,156.66,149.63,139.92Z' transform='translate(0 0.04)'/%3E%3C/svg%3E");
  background-position: 50%;
  background-repeat: no-repeat;
  height: 50px;
  left: 3%;
  margin: 0 auto;
  position: relative;
  width: 50px;

  animation-delay: 0.36s;
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
  animation-name: ${rotateLogoAnimation};
  animation-timing-function: ease-in-out;
`;
var Spark = styled64.div`
  position: absolute;
  left: 50%;
  width: var(--loader-spark-width);
  height: 100%;
  transform-origin: center;

  &:before {
    content: '';

    animation-direction: alternate;
    animation-duration: 0.9s;
    animation-iteration-count: infinite;
    animation-name: ${scaleSparksAnimation};
    animation-timing-function: cubic-bezier(0, 0, 0.42, 1);
    background-color: ${tk("color_semantic_bg_primary")};
    border-radius: 50px;

    display: block;

    position: absolute;
    transform: scale(0);
    width: var(--loader-spark-width);
    height: var(--loader-spark-height);
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: var(--loader-spark-width);
    height: var(--loader-spark-height);
    border-radius: 50px;
    background-color: ${tk("color_semantic_bg_primary")};
    transform: scale(0);

    animation-name: ${scaleSparksAnimation};
    animation-duration: 0.9s;
    animation-timing-function: cubic-bezier(0, 0, 0.42, 1);
    animation-direction: alternate;
    animation-iteration-count: infinite;
  }

  &:after {
    bottom: 0;
    transform-origin: top;
  }
`;
var Sparks = styled64.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;

  ${Spark}:nth-child(1) {
    transform: rotate(var(--loader-spark-rotation));

    &:after {
      animation-delay: calc(var(--loader-spark-animation-delay) * 7);
    }

    &:before {
      animation-delay: var(--loader-spark-animation-delay);
    }
  }

  ${Spark}:nth-child(2) {
    transform: rotate(calc(var(--loader-spark-rotation) * 2));

    &:after {
      animation-delay: calc(var(--loader-spark-animation-delay) * 8);
    }

    &:before {
      animation-delay: calc(var(--loader-spark-animation-delay) * 2);
    }
  }

  ${Spark}:nth-child(3) {
    transform: rotate(calc(var(--loader-spark-rotation) * 3));

    &:after {
      animation-delay: calc(var(--loader-spark-animation-delay) * 9);
    }

    &:before {
      animation-delay: calc(var(--loader-spark-animation-delay) * 3);
    }
  }

  ${Spark}:nth-child(4) {
    transform: rotate(calc(var(--loader-spark-rotation) * -2));

    &:after {
      animation-delay: calc(var(--loader-spark-animation-delay) * 4);
    }

    &:before {
      animation-delay: calc(var(--loader-spark-animation-delay) * 12);
      animation-direction: alternate-reverse;
      animation-name: ${scaleSparksBrandAnimation};
    }
  }

  ${Spark}:nth-child(5) {
    transform: rotate(calc(var(--loader-spark-rotation) * -1));

    &:after {
      animation-delay: calc(var(--loader-spark-animation-delay) * 5);
    }

    &:before {
      animation-name: ${scaleSparksBrandAnimation};
      animation-direction: alternate-reverse;
      animation-delay: calc(var(--loader-spark-animation-delay) * 14);
    }
  }

  ${Spark}:nth-child(6) {
    &:after {
      animation-delay: calc(var(--loader-spark-animation-delay) * 6);
    }

    &:before {
      animation-name: ${scaleSparksBrandAnimation};
      animation-direction: alternate-reverse;
      animation-delay: calc(var(--loader-spark-animation-delay) * 16);
    }
  }
`;

// src/components/Modal/Modal.tsx
import * as Dialog5 from "@radix-ui/react-dialog";
import { css as css42, styled as styled65 } from "styled-components";
import { jsx as jsx632, jsxs as jsxs537 } from "react/jsx-runtime";
var SpinnerWrapper = styled65.div`
  display: flex;
  min-height: 300px;
  justify-content: center;
  align-items: center;
`;
var StyledHeader = styled65(SpaceBetween)`
  box-shadow: ${tk("shadow_md_bottom")};
  background-color: ${tk("color_palette_grey_50")};
  box-shadow: ${tk("shadow_md_bottom")};
  color: ${tk("color_semantic_text")};
  flex-shrink: 0; // needed for Safari 11/12
`;
var StyledHeaderTitle = styled65(Typography_default2)`
  color: ${tk("color_semantic_text")};
  flex: 1;
  margin-left: 48px; // needed to center the title
  text-align: center;
`;
var StyledFooter = styled65(SpaceBetween)`
  padding: ${tk("spacing_sm")} ${tk("spacing_md")};
  box-shadow: ${tk("shadow_md_top")};
  background-color: ${tk("color_palette_grey_50")};
  flex-shrink: 0; // needed for Safari 11/12

  > * {
    flex-grow: 1;
  }
`;
var Backdrop = styled65.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex.modalOrMobilePopover}!important;
`;
function Wrapper17({ onClose, open, children }) {
  const onOpenChangeHandler = (newOpen) => {
    if (!newOpen) {
      onClose();
    }
  };
  return /* @__PURE__ */ jsx632(Dialog5.Root, {
    open,
    onOpenChange: onOpenChangeHandler,
    children: /* @__PURE__ */ jsxs537(Dialog5.Portal, {
      children: [
        /* @__PURE__ */ jsx632(Backdrop, {}),
        /* @__PURE__ */ jsx632(Dialog5.Content, {
          asChild: true,
          children
        })
      ]
    })
  });
}
var Root24 = styled65(Wrapper17)``;
var Content15 = styled65.div`
  background-color: ${tk("color_palette_grey_100")};
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${zIndex.modalOrMobilePopover} !important;

  ${({ $size }) => $size !== "fullscreen" && css42`
      @media ${tk("mq_tablet")} {
        top: 50%;
        left: 50%;
        bottom: auto;
        right: auto;
        transform: translate(-50%, -50%);
        border-radius: ${tk("radius_large")};
        max-height: calc(100% - ${tk("spacing_4xl")});
        overflow: hidden;
        max-width: calc(100% - ${tk("spacing_lg")});
        width: ${() => {
  switch ($size) {
    case "md":
      return "640px";
    case "lg":
      return "864px";
    case "xl":
      return "1088px";
    default:
      return "418px";
  }
}};
      }
    `}
`;
var Body = styled65.div`
  flex: 1;
  overflow-y: auto;
  @media (prefers-reduced-motion: no-preference) {
    scroll-behavior: smooth;
  }
`;
function RawFooter({ children, className }) {
  return /* @__PURE__ */ jsx632(StyledFooter, {
    className,
    direction: "x",
    spacing: tk("spacing_xs"),
    alignItems: "center",
    justifyContent: "center",
    children
  });
}
var Footer2 = styled65(RawFooter)``;

// src/components/PhoneField/PhoneField.tsx
import * as Popover5 from "@radix-ui/react-popover";
import * as React19 from "react";
import { styled as styled66 } from "styled-components";
import { jsx as jsx633, jsxs as jsxs538 } from "react/jsx-runtime";
var PhoneFormField = styled66(FormField)``;
var PhoneFieldRoot = styled66(TextField_exports.Root)`
  padding: ${tk("spacing_none")};
  cursor: auto;
`;
var PhoneFieldInput = styled66(TextField_exports.Input)`
  height: 50px;
`;
var PhoneFieldCountryButton = styled66.div`
  border-radius: ${tk("radius_medium")};
  border: 1px solid ${tk("color_palette_grey_200")};
  padding: 6px;
  margin: ${tk("spacing_none")} ${tk("spacing_xs")};
  display: flex;
  align-items: center;
  gap: ${tk("spacing_xs")};
  background-color: ${tk("color_palette_grey_100")};
  cursor: pointer;
`;
var PhoneFieldCountryButtonIcon = styled66(Icon_default2)`
  pointer-events: none;
`;
var PhoneFieldCountryCode = styled66.div`
  ${Typography_default2.modVariant("body-sm")}
  color: ${tk("color_semantic_text")};
  display: flex;
  align-items: center;
`;
var PopoverContent = styled66(Popover5.Content)`
  --height-phone-list-content: 240px;
  --vertical-padding-phone-list-content: ${tk("spacing_md")};
  --height-phone-list-scroll-content: calc(
    var(--height-phone-list-content) - (var(--vertical-padding-phone-list-content) * 2)
  );

  ${Typography_default2.modVariant("body-md")}
  box-sizing: content-box;
  color: ${tk("color_semantic_text")};
  padding: var(--vertical-padding-phone-list-content) ${tk("spacing_xs")};
  padding-right: ${tk("spacing_none")};
  background: ${tk("color_semantic_bg")};
  border-radius: ${tk("radius_large")};
  border: 2px solid ${tk("color_semantic_border")};
  box-shadow: ${tk("shadow_md_bottom")};
  margin-top: ${tk("spacing_2xs")};
  max-height: var(--height-phone-list-content);
`;
var PhoneFieldPhoneList = styled66.ul`
  padding: ${tk("spacing_none")};
  margin: ${tk("spacing_none")};
  list-style: none;
  overflow-y: auto;
  height: var(--height-phone-list-scroll-content);
`;
var PhoneFieldListItem = styled66.li`
  position: relative;
  padding: ${tk("spacing_xs")} ${tk("spacing_4xl")} ${tk("spacing_xs")} ${tk("spacing_lg")};
  cursor: pointer;
`;
var PhoneFieldListItemIcon = styled66(Icon_default2)`
  left: ${tk("spacing_2xs")};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

// src/components/Popover/Popover.tsx
import * as RadixPopover from "@radix-ui/react-popover";
import { keyframes as keyframes5, styled as styled67 } from "styled-components";
import { jsx as jsx634, jsxs as jsxs539 } from "react/jsx-runtime";
var slideUp2 = keyframes5`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
var PopoverContent2 = styled67(RadixPopover.Content)``;
var StyledPopover = styled67.aside`
  display: block;
  background: ${tk("color_semantic_bg")};
  color: ${tk("color_semantic_text")};
  border-top-left-radius: ${tk("radius_extra_large")};
  border-top-right-radius: ${tk("radius_extra_large")};
  box-shadow: ${tk("shadow_lg_bottom")};
`;
var StyledHeader2 = styled67.div`
  display: flex;
  padding: ${tk("spacing_md")} ${tk("spacing_md")} ${tk("spacing_xs")} ${tk("spacing_lg")};
`;
var StyledTitle = styled67(Typography_default2)`
  margin-right: auto;
  padding-top: ${tk("spacing_xs")};
`;
var StyledPopoverClose = styled67(RadixPopover.Close)`
  margin-left: ${tk("spacing_2xs")};
  width: 24px;
  height: 24px;
`;
var StyledContent = styled67(Typography_default2)`
  padding: ${tk("spacing_xs")} ${tk("spacing_lg")} ${tk("spacing_lg")} ${tk("spacing_lg")};

  a {
    color: inherit;
    display: block;
  }
`;
var Backdrop2 = styled67(RadixPopover.Close)`
  cursor: default;
  position: fixed;
  background: ${tk("color_palette_transparent_black_80")};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${zIndex.modalOrMobilePopover};
  @media ${tk("mq_desktop_lg")} {
    z-index: ${zIndex.popover};
  }
`;
var StyledPopoverWrapper = styled67.div`
  [data-radix-popper-content-wrapper] {
    z-index: ${zIndex.modalOrMobilePopover} !important;
    @media ${tk("mq_desktop_lg")} {
      z-index: ${zIndex.popover} !important;
    }
  }

  @media ${tk("mq_tablet")} {
    ${PopoverContent2} {
      width: 340px;
    }

    ${StyledPopover} {
      border-bottom-left-radius: ${tk("radius_extra_large")};
      border-bottom-right-radius: ${tk("radius_extra_large")};
    }

    ${Backdrop2} {
      opacity: 0;
    }
  }

  @media (max-width: calc(${tk("breakpoint_tablet")} - 1px)) {
    [data-radix-popper-content-wrapper] {
      position: fixed !important;
      top: auto !important;
      bottom: 0 !important;
      right: 0 !important;
      transform: translate(0, 0) !important;
      min-width: auto !important;
    }

    ${PopoverContent2} {
      animation-duration: 0.6s;
      animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

      &[data-side='bottom'] {
        animation-name: ${slideUp2};
      }
    }
  }
`;
function Popover6({
  title,
  content,
  readMoreLink,
  readMoreLinkText,
  align = "end",
  avoidCollisions,
  side
}) {
  return /* @__PURE__ */ jsx634(RadixPopover.Portal, {
    children: /* @__PURE__ */ jsxs539(StyledPopoverWrapper, {
      children: [
        /* @__PURE__ */ jsx634(Backdrop2, {}),
        /* @__PURE__ */ jsx634(PopoverContent2, {
          sideOffset: 8,
          align,
          avoidCollisions,
          side,
          children: /* @__PURE__ */ jsxs539(StyledPopover, {
            children: [
              /* @__PURE__ */ jsxs539(StyledHeader2, {
                children: [
                  /* @__PURE__ */ jsx634(StyledTitle, {
                    $variant: "heading-md",
                    children: title
                  }),
                  /* @__PURE__ */ jsx634(StyledPopoverClose, {
                    children: /* @__PURE__ */ jsx634(Icon_default2, {
                      glyph: "IconCrossMedium",
                      size: "md"
                    })
                  })
                ]
              }),
              /* @__PURE__ */ jsxs539(StyledContent, {
                $variant: "body-md",
                as: "p",
                children: [
                  content,
                  readMoreLink && readMoreLinkText && /* @__PURE__ */ jsx634("a", {
                    href: readMoreLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: readMoreLinkText
                  })
                ]
              })
            ]
          })
        })
      ]
    })
  });
}
Popover6.displayName = "Popover";

// src/components/PriceBox/PriceBox.tsx
import { css as css43, styled as styled68 } from "styled-components";
import { jsx as jsx635, jsxs as jsxs540 } from "react/jsx-runtime";
var Wrapper18 = styled68.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${Label_default} {
    order: -1;
  }

  & > *:first-child {
    display: flex;
    margin-top: ${tk("spacing_xs")};

    & > *:last-child {
      color: ${tk("color_semantic_text_strong")};
      margin-right: ${({ $type }) => $type === "box" ? 0 : tk("spacing_xs")};
      order: -1;
    }
  }

  ${({ $size }) => modSize11($size)}
  ${({ $type }) => modType7($type)}
  ${({ $align }) => modAlign2($align)}
`;
var PreviousPriceText = styled68.span`
  color: ${tk("color_semantic_text_primary")};
  font-family: ${tk("font_family_primary")};
  font-size: ${tk("font_size_xs")};
  line-height: inherit;
  text-decoration: line-through;
`;
var Price = styled68(Typography_default2)``;
var DiscountLabel = styled68(Label_default).attrs({ $state: "discount" })``;
function PriceBox({
  children,
  price,
  priceBoxText,
  priceDiscounts,
  type,
  align,
  size,
  className
}) {
  const hasDiscount = priceDiscounts && priceDiscounts.discountPercentage > 0 && "originalPrice" in priceDiscounts;
  return /* @__PURE__ */ jsxs540(Wrapper18, {
    $type: type,
    $align: align,
    $size: size,
    className,
    children: [
      /* @__PURE__ */ jsxs540("div", {
        children: [
          /* @__PURE__ */ jsxs540(SpaceBetween, {
            direction: "x",
            spacing: tk("spacing_2xs"),
            children: [
              /* @__PURE__ */ jsx635(Price, {
                "data-qa-price-value": price,
                children: price
              }),
              children
            ]
          }),
          /* @__PURE__ */ jsxs540(Typography_default2, {
            $variant: "body-xs",
            children: [
              priceBoxText,
              hasDiscount && /* @__PURE__ */ jsx635(PreviousPriceText, {
                children: priceDiscounts.originalPrice
              })
            ]
          })
        ]
      }),
      hasDiscount && /* @__PURE__ */ jsx635(DiscountLabel, {
        "data-ab-discount-label": "true",
        children: `-${priceDiscounts.discountPercentage}%`
      })
    ]
  });
}
PriceBox.displayName = "PriceBox";
function modSize11(sizeName = "small") {
  return {
    small: css43`
      ${Price} {
        ${Typography_default2.modVariant("heading-md")}
      }

      ${DiscountLabel} {
        ${Label_default.modSize("small")}
      }
    `,
    medium: css43`
      ${Price} {
        ${Typography_default2.modVariant("heading-lg")}
      }

      ${DiscountLabel} {
        ${Label_default.modSize("small")}
      }
    `,
    large: css43`
      ${Price} {
        ${Typography_default2.modVariant("heading-2xl")}
      }

      ${DiscountLabel} {
        ${Label_default.modSize("default")}
      }
    `
  }[sizeName];
}
function modType7(typeName = "inline") {
  return {
    box: css43`
      & > *:first-child {
        align-items: flex-end;
        flex-direction: column;
      }
    `,
    inline: css43`
      & > *:first-child {
        align-items: baseline;
        justify-content: space-between;
        width: 100%;
      }
    `
  }[typeName];
}
function modAlign2(align = "end") {
  return {
    start: css43`
      align-items: flex-start;
      & > *:first-child {
        display: flex;
        align-items: start;
      }
    `,
    center: css43`
      align-items: center;
      & > *:first-child {
        display: flex;
        align-items: center;
      }
    `,
    end: css43`
      align-items: flex-end;
      * {
        text-align: right;
      }
    `
  }[align];
}
var PriceBox_default = withStyleModifiers(styled68(PriceBox)``, { modAlign: modAlign2 });

// src/components/RadioInputList/RadioInputList.tsx
import { styled as styled69 } from "styled-components";
import { jsx as jsx636, jsxs as jsxs541 } from "react/jsx-runtime";
var Label6 = styled69(Typography_default2)`
  color: ${tk("color_semantic_text_strong")};
  padding-left: ${tk("spacing_2xs")};
`;

// src/components/ReadMore/ReadMore.tsx
import { useCallback as useCallback3, useEffect as useEffect6, useMemo, useRef as useRef5, useState as useState7 } from "react";
import { styled as styled70 } from "styled-components";
import { jsx as jsx637, jsxs as jsxs542 } from "react/jsx-runtime";
var Wrapper19 = styled70.div``;
var UnfoldButton = styled70.button`
  text-decoration: underline;
`;
var ShortContent = styled70.div`
  overflow: hidden;
`;
var CompleteContent = styled70.div`
  overflow: hidden;

  will-change: height;
  transition: height 500ms;
`;

// src/components/ScorePill/ScorePill.tsx
import { css as css44, styled as styled71 } from "styled-components";
var ScorePill = styled71(Typography_default2).attrs({
  $variant: "body-md-bold",
  as: "span"
})`
  align-items: center;
  background: ${tk("color_semantic_bg_subdued_hover")};
  border-radius: ${tk("radius_rounded")};
  color: ${tk("color_semantic_text")};
  display: inline-flex;
  justify-content: center;
  padding: ${tk("spacing_xs")} ${tk("spacing_sm")};

  ${({ $size }) => modSize12($size)}
`;
ScorePill.displayName = "ScorePill";
function modSize12(size = "md") {
  return {
    sm: css44`
      height: 1.75rem;
    `,
    md: css44`
      height: 1.875rem;
    `
  }[size];
}
var ScorePill_default = withStyleModifiers(ScorePill, {
  modSize: modSize12
});

// src/components/SegmentedControls/SegmentedControls.tsx
import * as React20 from "react";
import { css as css46, styled as styled73 } from "styled-components";

// src/components/SegmentedControls/Segment.tsx
import { css as css45, styled as styled72 } from "styled-components";
import { jsx as jsx638 } from "react/jsx-runtime";
var StyledSegment = styled72.button`
  border-radius: ${tk("radius_rounded")};
  border: none;
  padding: ${tk("spacing_xs")} ${tk("spacing_md")};
  text-decoration: none;

  ${({ $active }) => $active ? css45`
          background-color: ${tk("color_semantic_bg_primary")};
          color: ${tk("color_semantic_text_on_color")};
          &:disabled {
            background-color: ${tk("color_semantic_bg_primary_disabled")};
            color: ${tk("color_semantic_text_subdued")};
          }
          &:focus-visible {
            box-shadow: ${tk("shadow_focus_red")};
            outline: none;
          }
          &:hover&:not(:disabled) {
            background: ${tk("color_semantic_bg_primary_hover")};
          }
        ` : css45`
          color: ${tk("color_semantic_text")};
          background-color: ${tk("color_semantic_bg_subdued")};
          &:disabled {
            color: ${tk("color_semantic_text_disabled")};
          }
          &:focus-visible {
            box-shadow: ${tk("shadow_focus_grey")};
            outline: none;
          }
          &:hover&:not(:disabled) {
            background: ${tk("color_semantic_bg_subdued_hover")};
          }
        `}
`;
function SegmentComponent({ active, children, onClick, value, ...attributes }) {
  const onClickHandler = () => {
    onClick == null ? void 0 : onClick(value);
  };
  return /* @__PURE__ */ jsx638(StyledSegment, {
    $active: active,
    onClick: onClickHandler,
    ...attributes,
    children: /* @__PURE__ */ jsx638(SpaceBetween, {
      alignItems: "center",
      justifyContent: "center",
      direction: "x",
      spacing: tk("spacing_2xs"),
      children: wrapTextChildrenWithTypography2(children)
    })
  });
}
var Segment = styled72(SegmentComponent)``;

// src/components/SegmentedControls/SegmentedControls.tsx
import { jsx as jsx639 } from "react/jsx-runtime";
function SegmentedControls({
  children,
  defaultActive,
  disabled,
  fixed,
  onActiveChange,
  ...attributes
}) {
  const [active, setActive] = React20.useState(defaultActive != null ? defaultActive : 0);
  const onClickHandler = (index, value) => {
    setActive(index);
    onActiveChange == null ? void 0 : onActiveChange({ index, value });
  };
  return /* @__PURE__ */ jsx639(StyledWrapper3, {
    $fixed: fixed,
    ...attributes,
    children: React20.Children.map(children, (child, index) => {
      if (React20.isValidElement(child)) {
        const { disabled: childDisabled, name, value } = child.props;
        return React20.cloneElement(child, {
          active: [name, value].includes(active) || index === active,
          onClick: () => onClickHandler(index, value),
          disabled: disabled || childDisabled
        });
      }
    })
  });
}
SegmentedControls.Segment = Segment;
var StyledWrapper3 = styled73.div`
  align-items: center;
  background-color: ${tk("color_semantic_bg_subdued")};
  border-radius: ${tk("radius_rounded")};
  display: inline-flex;
  gap: ${tk("spacing_2xs")};
  padding: ${tk("spacing_2xs")};

  ${({ $fixed }) => $fixed && css46`
      max-width: 36rem;
      width: 100%;

      ${Segment} {
        flex: 1 0 0;
      }
    `}
`;

// src/components/Sheet/Sheet.tsx
import * as DialogPrimitive2 from "@radix-ui/react-dialog";
import * as React21 from "react";
import { css as css47, keyframes as keyframes6, styled as styled74 } from "styled-components";
import { jsx as jsx640 } from "react/jsx-runtime";
var slideInFromRight = keyframes6`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
var slideOutToRight = keyframes6`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
var slideInFromBottom = keyframes6`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;
var slideOutToBottom = keyframes6`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;
var slideInFromLeft = keyframes6`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;
var slideOutToLeft = keyframes6`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;
var SheetCloseStyled = styled74(DialogPrimitive2.Close)`
  ${Typography_default2.modVariant("body-md-bold")}
  line-height: unset;
  color: ${tk("color_semantic_text_error")};
  height: 100%;
  padding-right: ${tk("spacing_md")};
  margin-left: auto;
  grid-column-start: 3;
`;
var SheetDescriptionStyled = styled74(DialogPrimitive2.Description)`
  margin-top: ${tk("spacing_none")};
  margin-bottom: ${tk("spacing_none")};
`;
var SheetHeaderStyled = styled74.div`
  position: sticky;
  top: 0;
  flex-direction: row;
  width: 100%;
  min-height: ${tk("spacing_3xl")};
  left: 0;
  border-bottom: 1px solid ${tk("color_semantic_border")};
  background-color: ${tk("color_semantic_bg")};
  border-top-left-radius: ${tk("radius_extra_large")};
  border-top-right-radius: ${tk("radius_extra_large")};
  align-items: center;
  z-index: 2;

  ${Typography_default2} {
    margin: 0 auto;
    color: ${tk("color_semantic_text")};
  }

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  justify-content: center;
  grid-column-gap: ${tk("spacing_md")};
`;
var fadeIn = keyframes6`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
var fadeOut = keyframes6`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
var SheetOverlayStyled = styled74(DialogPrimitive2.Overlay)`
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: ${zIndex.modalOrMobilePopover};
  margin-top: 0px !important;

  &[data-state='open'] {
    animation: ${fadeIn} 150ms ease-in-out;
  }

  &[data-state='closed'] {
    animation: ${fadeOut} 150ms ease-in-out;
  }
`;
var SheetOverlay = React21.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx640(SheetOverlayStyled, {
  ...props,
  ref
}));
SheetOverlay.displayName = DialogPrimitive2.Overlay.displayName;
var SheetContentWrapper = styled74.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
`;
SheetContentWrapper.displayName = "ContentWrapper";
var SheetContentStyled = styled74(DialogPrimitive2.Content)`
  background: ${tk("color_semantic_bg")};
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
  z-index: ${zIndex.modalOrMobilePopover + 50} !important;
  position: fixed;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  ${({ $side }) => modSide($side)}
`;
function modSide(sideName = "right") {
  return {
    right: css47`
      top: ${tk("spacing_md")};
      right: ${tk("spacing_md")};
      max-height: calc(100% - (2 * ${tk("spacing_md")}));
      width: calc(100% - (2 * ${tk("spacing_md")}));
      border-radius: ${tk("radius_extra_large")};

      @media ${tk("mq_tablet")} {
        width: 480px;
      }

      &[data-state='closed'] {
        animation: ${slideOutToRight} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromRight} 0.3s forwards;
      }
    `,
    left: css47`
      left: ${tk("spacing_md")};
      right: unset;
      top: ${tk("spacing_md")};
      max-height: calc(100% - (2 * ${tk("spacing_md")}));
      width: calc(100% - (2 * ${tk("spacing_md")}));
      border-radius: ${tk("radius_extra_large")};

      @media ${tk("mq_desktop_sm")} {
        width: 480px;
      }

      &[data-state='closed'] {
        animation: ${slideOutToLeft} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromLeft} 0.3s forwards;
      }
    `,
    bottom: css47`
      width: 100%;
      height: calc(100% - 56px);
      bottom: 0;
      top: unset;
      right: unset;

      border-top-left-radius: ${tk("radius_extra_large")};
      border-top-right-radius: ${tk("radius_extra_large")};

      @media ${tk("mq_tablet")} {
        left: ${tk("spacing_3xl")};
        right: ${tk("spacing_3xl")};
        width: auto;
      }

      @media ${tk("mq_desktop_md")} {
        left: calc(max(${tk("spacing_5xl")}, calc((100vw - 1280px) / 2)));
        right: calc(max(${tk("spacing_5xl")}, calc((100vw - 1280px) / 2)));
        width: auto;
      }

      &[data-state='closed'] {
        animation: ${slideOutToBottom} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromBottom} 0.3s forwards;
      }
    `
  }[sideName];
}
var SheetContent = withStyleModifiers(SheetContentStyled, {
  modSide
});
var SheetHeader = ({ ...props }) => /* @__PURE__ */ jsx640(SheetHeaderStyled, {
  ...props
});
SheetHeader.displayName = "Header";
var SheetFooterStyled = styled74.div`
  position: sticky;
  bottom: ${tk("spacing_md")};
  display: flex;
  flex-direction: column;
  padding: ${tk("spacing_md")};
  width: 100%;
  background: ${tk("color_semantic_bg")};
  min-height: 80px;
  border-bottom-left-radius: ${tk("radius_extra_large")};
  border-bottom-right-radius: ${tk("radius_extra_large")};

  ${({ $isFixed }) => $isFixed && modFixed()}
`;
var SheetFooter = withStyleModifiers(SheetFooterStyled, {
  modFixed
});
SheetFooter.displayName = "Footer";
function modFixed() {
  return css47`
    bottom: 0;
    border-top: 1px solid ${tk("color_semantic_border")};
  `;
}
var SheetTitleStyled = styled74(DialogPrimitive2.Title)`
  ${Typography_default2.modVariant("body-md-bold")}
  font-size: ${tk("font_size_md")};
  margin: 0 auto;
  text-align: center;
  grid-column-start: 2;
`;
var SheetTitle = React21.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx640(SheetTitleStyled, {
  ref,
  ...props
}));
SheetTitle.displayName = DialogPrimitive2.Title.displayName;
var SheetDescription = React21.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx640(SheetDescriptionStyled, {
  ref,
  ...props
}));
SheetDescription.displayName = DialogPrimitive2.Description.displayName;

// src/components/Skeleton/Skeleton.tsx
import { keyframes as keyframes7, styled as styled75 } from "styled-components";
import { jsx as jsx641 } from "react/jsx-runtime";
var opacityAnimation = keyframes7`
  50% {
    opacity: 0.3;
  }
`;
var StyledSkeleton = styled75.div`
  animation-name: ${opacityAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background: ${tk("color_semantic_bg_disabled")};
`;

// src/components/Slider/Slider.tsx
import * as SliderPrimitive from "@radix-ui/react-slider";
import { css as css48, styled as styled77 } from "styled-components";
import { useEffect as useEffect7, useRef as useRef6, useState as useState9 } from "react";

// src/components/Slider/Tooltip.tsx
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { styled as styled76 } from "styled-components";
import { jsx as jsx642, jsxs as jsxs543 } from "react/jsx-runtime";
function Tooltip({
  children,
  defaultOpen,
  open,
  onOpenChange,
  tooltipText,
  tooltipValue,
  radixContentProps
}) {
  return /* @__PURE__ */ jsx642(RadixTooltip.Provider, {
    delayDuration: 800,
    skipDelayDuration: 500,
    children: /* @__PURE__ */ jsxs543(RadixTooltip.Root, {
      open,
      defaultOpen,
      onOpenChange,
      children: [
        /* @__PURE__ */ jsx642(RadixTooltip.Trigger, {
          asChild: true,
          children
        }),
        /* @__PURE__ */ jsxs543(StyledTooltipContent, {
          ...radixContentProps,
          children: [
            /* @__PURE__ */ jsxs543(Typography_default2, {
              $variant: "body-xs",
              children: [
                tooltipValue && /* @__PURE__ */ jsx642(Typography_default2, {
                  $variant: "body-sm-bold",
                  children: tooltipValue
                }),
                tooltipText
              ]
            }),
            /* @__PURE__ */ jsx642(StyledTooltipArrow, {
              width: "11px",
              height: "6px"
            })
          ]
        })
      ]
    })
  });
}
var StyledTooltipContent = styled76(RadixTooltip.Content)`
  position: relative;
  height: ${tk("spacing_xl")};
  border-radius: ${tk("radius_large")};
  padding: ${tk("spacing_xs")};
  top: -${tk("spacing_xs")};
  display: flex;
  align-items: center;
  box-shadow: ${tk("shadow_md_bottom")};
  background-color: ${tk("color_palette_grey_50")};

  ${Typography_default2} {
    color: ${tk("color_semantic_text")};
  }
`;
var StyledTooltipArrow = styled76(RadixTooltip.Arrow)`
  fill: ${tk("color_palette_grey_50")};
`;

// src/components/Slider/Slider.tsx
import { jsx as jsx643, jsxs as jsxs544 } from "react/jsx-runtime";
var SLIDER_SIZE = tk("font_size_3xl");
var SLIDER_HEIGHT_WITH_TOOLTIP = "74px";
function Slider({
  ariaLabel,
  value,
  description,
  disabled = false,
  glyph = "IconChevronDoubleSmall",
  inverted = false,
  max = 10,
  min = 0,
  onValueChange,
  onValueCommit,
  step = 1,
  tooltipText,
  tooltipValue,
  valueText,
  withoutIcon
}) {
  const isSliderWithTooltip = value.length === 1 && Boolean(tooltipText) && !description;
  const collisionBoundaryElement = useRef6(null);
  const [, forceUpdate] = useState9(0);
  useEffect7(() => {
    forceUpdate(1);
  }, []);
  const addIcon = () => {
    return !withoutIcon && /* @__PURE__ */ jsx643(Icon_default2, {
      glyph
    });
  };
  return /* @__PURE__ */ jsxs544(StyledSliderWrapper, {
    direction: "y",
    spacing: tk("spacing_sm"),
    $isSliderWithTooltip: isSliderWithTooltip,
    children: [
      description && /* @__PURE__ */ jsxs544(StyledSliderDescription, {
        $variant: "body-sm",
        as: "p",
        $disabled: disabled,
        children: [
          description,
          valueText && /* @__PURE__ */ jsxs544(Typography_default2, {
            $variant: "body-md-bold",
            children: [
              " ",
              valueText
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsxs544(StyledSliderRoot, {
        value,
        disabled,
        max,
        min,
        minStepsBetweenThumbs: 1,
        onValueChange,
        onValueCommit,
        step,
        ref: collisionBoundaryElement,
        children: [
          /* @__PURE__ */ jsx643(StyledSliderTrack, {
            $inverted: inverted,
            children: /* @__PURE__ */ jsx643(StyledSliderRange, {
              $inverted: inverted
            })
          }),
          value.map((_, i) => /* @__PURE__ */ jsx643(StyledSliderThumb, {
            "aria-label": ariaLabel,
            children: isSliderWithTooltip ? /* @__PURE__ */ jsx643(Tooltip, {
              open: true,
              defaultOpen: true,
              tooltipText,
              tooltipValue,
              radixContentProps: { collisionBoundary: collisionBoundaryElement.current },
              children: addIcon()
            }, i) : addIcon()
          }, i))
        ]
      })
    ]
  });
}
Slider.displayName = "Slider";
var StyledSliderWrapper = styled77(SpaceBetween)`
  width: 100%;
  padding-bottom: ${tk("spacing_sm")};
  ${({ $isSliderWithTooltip }) => modHeight($isSliderWithTooltip)}
`;
var StyledSliderDescription = styled77(Typography_default2)`
  ${({ $disabled }) => modDisabled18($disabled)}
`;
var StyledSliderRoot = styled77(SliderPrimitive.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  height: ${SLIDER_SIZE};
  width: 100%;
  margin-top: auto;
`;
var StyledSliderTrack = styled77(SliderPrimitive.Track)`
  position: relative;
  flex-grow: 1;
  border-radius: ${tk("radius_rounded")};
  height: 4px;

  ${({ $inverted }) => modInverted($inverted, "track")}
`;
var StyledSliderRange = styled77(SliderPrimitive.Range)`
  position: absolute;
  border-radius: ${tk("radius_rounded")};
  height: 100%;

  ${({ $inverted }) => modInverted($inverted, "range")}
`;
var StyledSliderThumb = styled77(SliderPrimitive.Thumb)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${SLIDER_SIZE};
  height: ${SLIDER_SIZE};
  box-shadow: ${tk("shadow_lg_bottom")};
  border-radius: ${tk("radius_rounded")};
  background-color: ${tk("color_semantic_bg_primary")};

  &[data-disabled] {
    background-color: ${tk("color_semantic_bg_primary_disabled")};
  }

  &:hover:not([data-disabled]) {
    background-color: ${tk("color_semantic_bg_primary_hover")};
    cursor: pointer;
  }

  &:focus {
    outline: none;
    background-color: ${tk("color_semantic_bg_primary")};
    box-shadow: ${tk("shadow_focus_red")};
  }

  ${Icon_default2} {
    ${Icon_default2.modSize("md")}
    color: ${tk("color_semantic_icon_on_color")};
  }
`;
var modInverted = ($inverted, sliderEl) => {
  const bgColorPrimaryCSS = css48`
    background-color: ${tk("color_semantic_bg_primary")};
    &[data-disabled] {
      background-color: ${tk("color_semantic_bg_primary_disabled")};
    }
  `;
  const bgColorSecondaryCSS = css48`
    background-color: ${tk("color_semantic_bg_strong")};
    &[data-disabled] {
      background-color: ${tk("color_semantic_bg_strong_disabled")};
    }
  `;
  switch (sliderEl) {
    case "track":
      return $inverted ? bgColorPrimaryCSS : bgColorSecondaryCSS;
    case "range":
      return $inverted ? bgColorSecondaryCSS : bgColorPrimaryCSS;
  }
};
var modDisabled18 = ($disabled) => {
  const disabledTextColorCSS = css48`
    color: ${tk("color_semantic_bg_primary_disabled")};
  `;
  const textColorCSS = css48`
    color: ${tk("color_semantic_text_strong")};
    > span {
      color: ${tk("color_semantic_text")};
    }
  `;
  return $disabled ? disabledTextColorCSS : textColorCSS;
};
var modHeight = ($isSliderWithTooltip) => {
  return css48`
    height: ${$isSliderWithTooltip ? SLIDER_HEIGHT_WITH_TOOLTIP : "auto"};
  `;
};

// src/components/Spacer/Spacer.tsx
import { css as css49, styled as styled78 } from "styled-components";
var Spacer = styled78.div`
  display: block;
  width: ${({ $size }) => css49`
    ${$size}px;
  `};
  height: ${({ $size }) => css49`
    ${$size}px;
  `};
`;

// src/components/Switch/Switch.tsx
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React22 from "react";
import { css as css50, styled as styled79 } from "styled-components";
import { jsx as jsx644 } from "react/jsx-runtime";
var Wrapper20 = styled79(SwitchPrimitives.Root)`
  width: 44px;
  height: 24px;
  background-color: ${tk("color_semantic_bg_input_strong")};
  border-radius: ${tk("radius_rounded")};
  padding: 2px;

  &[data-state='checked'] {
    background-color: ${tk("color_semantic_bg_success")};
  }

  &:hover {
    background-color: ${tk("color_semantic_bg_input_strong_hover")};
  }

  &[data-state='checked']:hover {
    background-color: ${tk("color_semantic_bg_success_hover")};
  }

  &:focus {
    box-shadow: ${tk("shadow_focus_grey")};
  }

  ${({ disabled }) => disabled && modDisabled19()}
`;
var Thumb3 = styled79(SwitchPrimitives.Thumb)`
  width: 20px;
  height: 20px;
  border-radius: ${tk("radius_rounded")};
  background: ${tk("color_semantic_bg")};
  display: block;
  transition: transform 300ms;

  &[data-state='checked'] {
    transform: translateX(100%);
  }
`;
function modDisabled19() {
  return css50`
  background: ${tk("color_semantic_bg_input_strong_disabled")};
  pointer-events: none;
  &[data-state='checked'] {
    background-color: ${tk("color_semantic_bg_success_disabled")};
  }
`;
}
var Switch = React22.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx644(Wrapper20, {
  ...props,
  ref,
  children: /* @__PURE__ */ jsx644(Thumb3, {})
}));
Switch.displayName = SwitchPrimitives.Root.displayName;
var Switch_default = styled79(Switch)``;

// src/components/TabBar/TabBar.tsx
import * as React23 from "react";
import { styled as styled81 } from "styled-components";

// src/components/TabBar/Tab.tsx
import { css as css51, styled as styled80 } from "styled-components";
import { jsx as jsx645 } from "react/jsx-runtime";
function TabComponent({ active, children, onClick, value, ...attributes }) {
  const onClickHandler = () => {
    onClick == null ? void 0 : onClick(value);
  };
  return /* @__PURE__ */ jsx645(StyledTab, {
    $active: active,
    onClick: onClickHandler,
    ...attributes,
    children: /* @__PURE__ */ jsx645(StyledSpaceBetween3, {
      alignItems: "center",
      justifyContent: "center",
      direction: "x",
      spacing: tk("spacing_2xs"),
      children: wrapTextChildrenWithTypography2(children)
    })
  });
}
var Tab = styled80(TabComponent)``;
var StyledTab = styled80.button`
  ${({ $active }) => $active ? css51`
          --tab-color: ${tk("color_semantic_text_on_color")};
          --tab-background-color: ${tk("color_semantic_bg_inverse")};
          --tab-background-color-hover: ${tk("color_semantic_bg_inverse_hover")};
          --tab-background-color-disabled: ${tk("color_semantic_bg_inverse_disabled")};
        ` : css51`
          --tab-color: ${tk("color_semantic_text")};
          --tab-background-color: ${tk("color_semantic_bg_subdued")};
          --tab-background-color-hover: ${tk("color_semantic_bg_subdued_hover")};
          --tab-background-color-disabled: unset;
        `}

  border-radius: ${tk("radius_rounded")};
  border: none;
  padding: ${tk("spacing_xs")} ${tk("spacing_md")};
  text-decoration: none;

  @media (max-width: ${tk("breakpoint_desktop_sm")}) {
    border-radius: ${tk("radius_large")};
    padding: ${tk("spacing_xs")} 2px;
    flex-basis: 0;
    flex-grow: 1;
  }

  background-color: var(--tab-background-color);
  color: var(--tab-color);

  &:disabled {
    background-color: var(--tab-background-color-disabled);
    color: ${tk("color_semantic_text_disabled")};
  }

  &:focus-visible {
    box-shadow: ${tk("shadow_focus_grey")};
    outline: none;
  }

  &:hover&:not(:disabled) {
    background: var(--tab-background-color-hover);
  }
`;
var StyledSpaceBetween3 = styled80(SpaceBetween)`
  @media (max-width: ${tk("breakpoint_desktop_sm")}) {
    flex-direction: column;
    ${SpaceBetween.modAlignment(tk("spacing_none"))}

    ${Icon_default2} {
      ${Icon_default2.modSize("md")}
    }

    ${Typography_default2} {
      ${Typography_default2.modVariant("body-xs")}
    }
  }
`;

// src/components/TabBar/TabBar.tsx
import { jsx as jsx646 } from "react/jsx-runtime";
var StyledWrapper4 = styled81.div`
  align-items: center;
  background-color: ${tk("color_semantic_bg_subdued")};
  border-radius: ${tk("radius_large")};
  display: inline-flex;
  gap: ${tk("spacing_2xs")};
  padding: ${tk("spacing_2xs")};
  width: 100%;
  border: 2px solid ${tk("color_semantic_border")};

  @media ${tk("mq_desktop_sm")} {
    border-radius: ${tk("radius_rounded")};
    width: auto;
  }
`;
function TabBar({ children, defaultActive, disabled, onActiveChange, ...attributes }) {
  const [active, setActive] = React23.useState(defaultActive != null ? defaultActive : 0);
  const onClickHandler = (index, value) => {
    setActive(index);
    onActiveChange == null ? void 0 : onActiveChange({ index, value });
  };
  return /* @__PURE__ */ jsx646(StyledWrapper4, {
    ...attributes,
    children: React23.Children.map(children, (child, index) => {
      if (React23.isValidElement(child)) {
        const { disabled: childDisabled, name, value } = child.props;
        return React23.cloneElement(child, {
          active: [name, value].includes(active) || index === active,
          onClick: () => onClickHandler(index, value),
          disabled: disabled || childDisabled
        });
      }
    })
  });
}
TabBar.Tab = Tab;

// src/components/Table/Table.tsx
import { styled as styled82 } from "styled-components";
var Cell = styled82.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98px;
  height: ${tk("spacing_3xl")};
  background-color: ${tk("color_semantic_bg")};
  border-color: ${tk("color_semantic_border")};
  text-align: center;
  padding: ${tk("spacing_xs")};
  border-width: 0 1px 1px 0;
  border-style: solid;
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: -1px;
    top: -1px;
    height: 49px;
    width: 99px;
  }
`;
var Header2 = styled82(Cell)`
  border-top-width: 1px;
  background-color: ${tk("color_semantic_bg_subdued")};
  &:before {
    height: 48px;
  }
`;
var Col = styled82.div`
  display: flex;
  flex-direction: column;
`;
var HeaderColumn = styled82(Header2)`
  border-left-width: 1px;
  border-top-width: 0px;
  &:before {
    height: 49px;
    width: 98px;
  }
  &:last-child {
    border-radius: 0px 0px 0px 4px;
  }
`;
var TopLeftHeader = styled82(HeaderColumn)`
  background-color: ${tk("color_semantic_bg_subdued_hover")};
  border-top-width: 1px;
  border-radius: 4px 0px 0px 0px;
`;
var Body2 = styled82.div`
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  ${Col}:last-child {
    border-radius: 0px 4px 4px 0px;
    ${Header2} {
      border-radius: 0px 4px 0px 0px;
    }
    ${Cell}:last-child {
      border-radius: 0px 0px 4px 0px;
    }
  }
`;
var Root31 = styled82.div`
  display: flex;
  font-family: ${tk("typography_body_md_typeface")};
`;

// src/components/ToggleGroup/ToggleGroup.tsx
import * as ToggleGroupPrimitives from "@radix-ui/react-toggle-group";
import * as React24 from "react";
import { css as css52, styled as styled83 } from "styled-components";
import { jsx as jsx647 } from "react/jsx-runtime";
var colorStyles = {
  selected: createColorStyles("color_palette_green_500", "color_palette_green_700"),
  neutral: createColorStyles("color_palette_grey_800", "color_palette_grey_900")
};
var StyledToggleGroupItems = styled83.div`
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  gap: ${tk("spacing_2xs")};
`;
var StyledToggleItem = styled83(ToggleGroupPrimitives.Item)`
  padding: ${tk("spacing_sm")} ${tk("spacing_md")};
  border-radius: ${tk("radius_large")};
  color: ${tk("color_palette_grey_800")};
  background-color: ${tk("color_semantic_bg_subdued")};
  border: 2px solid ${tk("color_semantic_border")};
  min-height: 48px;

  ${Typography_default2} {
    ${Typography_default2.modVariant("label-thin")}
    line-height: ${tk("font_line_height_xs")};
  }

  &:not(:disabled):hover {
    background-color: ${tk("color_semantic_bg_subdued_hover")};
  }

  &[data-state='on'] {
    ${({ color = "selected" }) => colorStyles[color]}
  }

  &:not([data-state='on'])[disabled] {
    opacity: 0.38;
  }
`;
function createColorStyles(baseColor, hoverColor) {
  return css52`
  color: ${tk("color_palette_grey_50")};
  background-color: ${tk(baseColor)};
  border-color: ${tk(baseColor)};

  &:not(:disabled):hover {
    background-color: ${tk(hoverColor)};
    border-color: ${tk(hoverColor)};
  }
`;
}
var ToggleGroupItem = ({ children, ...props }) => /* @__PURE__ */ jsx647(StyledToggleItem, {
  ...props,
  children: wrapTextChildrenWithTypography2(children)
});
var ToggleGroup = ({ children, color, ...props }) => /* @__PURE__ */ jsx647(ToggleGroupPrimitives.Root, {
  ...props,
  children: /* @__PURE__ */ jsx647(StyledToggleGroupItems, {
    children: React24.Children.map(children, (child) => React24.isValidElement(child) ? React24.cloneElement(child, { color }) : child)
  })
});
ToggleGroup.Item = ToggleGroupItem;

// src/components/UnavailableContentDialog/UnavailableContentDialog.tsx
import { styled as styled84 } from "styled-components";
import { jsx as jsx648, jsxs as jsxs545 } from "react/jsx-runtime";
var Wrapper21 = styled84.div`
  display: flex;
  width: 100%;
  padding: ${tk("spacing_lg")};
  justify-content: center;
`;
var Content20 = styled84(SpaceBetween)`
  max-width: 480px; //waiting for new tokens being added
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: ${tk("spacing_sm")};
  align-items: center;
  text-align: center;
`;
var UnavailableContentDialog = ({ icon, title, message, children, className }) => {
  return /* @__PURE__ */ jsx648(Wrapper21, {
    className,
    children: /* @__PURE__ */ jsxs545(Content20, {
      direction: "y",
      spacing: tk("spacing_xs"),
      children: [
        icon != null ? icon : /* @__PURE__ */ jsx648(Icon_default2, {
          glyph: "IconWarningTriangle",
          size: "lg",
          color: "#d77600"
        }),
        /* @__PURE__ */ jsx648(Typography_default2, {
          $variant: "body-md-bold",
          children: title
        }),
        /* @__PURE__ */ jsx648(Typography_default2, {
          $variant: "body-sm",
          children: message
        }),
        children
      ]
    })
  });
};
var UnavailableContentDialog_default = styled84(UnavailableContentDialog)``;

// src/uds/components/InputStepper/InputStepper.tsx
import { jsx as jsx649, jsxs as jsxs546 } from "react/jsx-runtime";
var INITIAL_VALUE = 0;
var STEP_VALUE = 1;
var Button3 = styled85.button`
  height: 100%;
  background-color: ${tok("primitives_color_neutral_100")};
  border-radius: ${radius("primitives_corner_radius_xs")};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  outline: 0;

  &:hover {
    background-color: ${tok("primitives_color_neutral_150")};
  }

  ${focusOutline()}

  ${Icon_default} {
    :focus {
      outline: 0;
    }
    color: ${tok("semantics_content_color")};
  }

  ${({ disabled }) => disabled && modDisabled20()}
}`;
function modDisabled20() {
  return css53`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
function modSize13(sizeName = "M") {
  return {
    S: css53`
      height: ${tok("semantics_controls_s_min_height")}px;
      width: 100px;
      ${Button3} {
        width: 24px;
      }
      ${Icon_default} {
        ${Icon_default.modSize(16)}
      }
    `,
    M: css53`
      height: ${tok("semantics_controls_m_min_height")}px;
      width: 124px;
      ${Button3} {
        width: 36px;
      }
      ${Icon_default} {
        ${Icon_default.modSize(24)}
      }
    `
  }[sizeName];
}
var Wrapper22 = styled85.div`
  display: flex;
  border: 2px solid ${tok("semantics_input_fields_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  padding: ${space("primitives_space_2")};
  justify-content: space-between;
  align-items: center;
  background-color: ${tok("semantics_views_background_color")};
  &:hover {
    border-color: ${tok("semantics_input_fields_hover_border_color")};
  }
  ${({ $size }) => modSize13($size)}
  ${({ $disabled }) => $disabled && modDisabled20()}
`;
var Value = styled85.input`
  border: transparent;
  text-align: center;
  background: transparent;
  margin: 0;
  padding: 0;
  min-width: 0;
  width: 36px;
  height: calc(100% - ${space("primitives_space_4")});
  border-radius: ${radius("primitives_corner_radius_xs")};
  ${Typography_default2.modVariant("body-lg")};
  font-size: ${tokPx("primitives_font_size_body_l")};
  line-height: 125%;

  ${focusOutline(0)}

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;
function InputStepper({
  initialValue = INITIAL_VALUE,
  minimumValue = 0,
  maximumValue = Number.MAX_SAFE_INTEGER,
  stepValue = STEP_VALUE,
  decrementButtonAriaLabel = "decrement",
  incrementButtonAriaLabel = "increment",
  valueAriaLabel = "value",
  size = "M",
  disabled = false,
  onChange = (val) => val
}) {
  const [value, setValue] = React25.useState(initialValue);
  const canBeDecreased = value - stepValue >= minimumValue;
  const canBeIncreased = value + stepValue <= maximumValue;
  const handleChangeValue = (itemValue) => {
    setValue(itemValue);
    onChange(itemValue);
  };
  const decreaseValueHandler = () => {
    if (!canBeDecreased)
      return;
    const newValue = value - stepValue;
    handleChangeValue(newValue);
  };
  const increaseValueHandler = () => {
    if (!canBeIncreased)
      return;
    const newValue = value + stepValue;
    handleChangeValue(newValue);
  };
  return /* @__PURE__ */ jsxs546(Wrapper22, {
    $size: size,
    $disabled: disabled,
    children: [
      /* @__PURE__ */ jsx649(Button3, {
        onClick: decreaseValueHandler,
        "aria-disabled": disabled || !canBeDecreased,
        "aria-label": decrementButtonAriaLabel,
        disabled: disabled || !canBeDecreased,
        children: /* @__PURE__ */ jsx649(Icon_default, {
          glyph: "Minus",
          "aria-hidden": "true"
        })
      }),
      /* @__PURE__ */ jsx649(Value, {
        type: "number",
        "aria-label": valueAriaLabel,
        value,
        disabled,
        onChange: (e) => handleChangeValue(Number(e.target.value))
      }),
      /* @__PURE__ */ jsx649(Button3, {
        onClick: increaseValueHandler,
        "aria-disabled": disabled || !canBeIncreased,
        "aria-label": incrementButtonAriaLabel,
        disabled: disabled || !canBeIncreased,
        children: /* @__PURE__ */ jsx649(Icon_default, {
          glyph: "Plus",
          "aria-hidden": "true"
        })
      })
    ]
  });
}
InputStepper.displayName = "InputStepper";
var InputStepper_default = withStyleModifiers(styled85(InputStepper)``, {
  modSize: modSize13
});

// src/uds/components/Popover/Popover.tsx
var Popover_exports = {};
__export(Popover_exports, {
  Body: () => Body3,
  Content: () => Content22,
  PopContent: () => PopContent,
  Root: () => Root35,
  Trigger: () => Trigger11
});
import * as RadixPopover2 from "@radix-ui/react-popover";
import { css as css54, keyframes as keyframes8, styled as styled87 } from "styled-components";

// src/uds/components/TopTitleBar/TopTitleBar.tsx
import React26 from "react";
import { styled as styled86 } from "styled-components";

// src/uds/components/TopTitleBar/constants.ts
var TOP_TITLE_BAR_HEIGHT = "48px";

// src/uds/components/TopTitleBar/TopTitleBar.tsx
import { jsx as jsx650, jsxs as jsxs547 } from "react/jsx-runtime";
var SIDE_AREA_WIDTH = "83px";
var Wrapper23 = styled86.div`
  width: 100%;
  display: flex;
  align-items: center;
  min-height: ${TOP_TITLE_BAR_HEIGHT};
  height: ${TOP_TITLE_BAR_HEIGHT};
  border-bottom: 1px solid ${tok("primitives_color_neutral_100")};
  background-color: ${tok("semantics_views_background_color")};
`;
var LeftAreaWrapper = styled86.div`
  flex: 0 0 ${SIDE_AREA_WIDTH};
  width: ${SIDE_AREA_WIDTH};
`;
var CenterAreaWrapper = styled86.div`
  display: flex;
  padding: 0 ${space("primitives_space_6")};
  justify-content: center;
  align-items: center;
  flex: 1 1 0%;
  align-self: stretch;
  overflow: hidden;
  text-wrap: nowrap;
`;
var RightAreaWrapper = styled86.div`
  flex: 0 0 ${SIDE_AREA_WIDTH};
  display: flex;
  width: ${SIDE_AREA_WIDTH};
  justify-content: flex-end;

  & > button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${space("primitives_space_12")} ${space("primitives_space_16")};
    color: ${tok("semantics_buttons_transparent_primary_content_color")};

    ${focusOutline()}
  }
`;
var Title3 = styled86(Typography_default)`
  text-overflow: ellipsis;
  overflow: hidden;
`;
function Root33({ children, ...rest }) {
  let left = null;
  let titleLabel = "";
  let right = null;
  React26.Children.forEach(children, (child) => {
    if (!React26.isValidElement(child))
      return;
    const element = child;
    if (element.type === LeftArea)
      left = child.props.children;
    if (element.type === CenterArea)
      titleLabel = child.props.title;
    if (element.type === RightArea)
      right = child.props.children;
  });
  return /* @__PURE__ */ jsxs547(Wrapper23, {
    ...rest,
    children: [
      /* @__PURE__ */ jsx650(LeftArea, {
        children: left
      }),
      /* @__PURE__ */ jsx650(CenterArea, {
        title: titleLabel
      }),
      /* @__PURE__ */ jsx650(RightArea, {
        children: right
      })
    ]
  });
}
function LeftArea({ children }) {
  return /* @__PURE__ */ jsx650(LeftAreaWrapper, {
    children
  });
}
function CenterArea({ title }) {
  return /* @__PURE__ */ jsx650(CenterAreaWrapper, {
    children: title && /* @__PURE__ */ jsx650(Title3, {
      $variant: "body-m-bold-tight",
      children: title
    })
  });
}
function RightArea({ children }) {
  return /* @__PURE__ */ jsx650(RightAreaWrapper, {
    children
  });
}
var TopTitleBar = {
  Root: Root33,
  LeftArea,
  CenterArea,
  RightArea
};

// src/uds/components/Popover/Popover.tsx
import { jsx as jsx651, jsxs as jsxs548 } from "react/jsx-runtime";
var POPOVER_UPPER_SPACING = space("primitives_space_48");
var PositionMap2 = {
  "top": { side: "top", align: "center" },
  "bottom": { side: "bottom", align: "center" },
  "left": { side: "left", align: "center" },
  "right": { side: "right", align: "center" },
  "top-left": { side: "top", align: "end" },
  "top-right": { side: "top", align: "start" },
  "bottom-left": { side: "bottom", align: "end" },
  "bottom-right": { side: "bottom", align: "start" }
};
var slideUp3 = keyframes8`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
var PopoverContent3 = styled87(RadixPopover2.Content)`
  max-height: calc(100vh - ${POPOVER_UPPER_SPACING});
  z-index: ${zIndex.modalOrMobilePopover};
  @media (min-width: ${tokPx("primitives_breakpoint_l_min")}) {
    z-index: ${zIndex.popover};
  }

  ${focusOutline()}
`;
var StyledPopover2 = styled87.aside`
  display: flex;
  flex-direction: column;
  background: ${tok("semantics_views_background_color")};
  color: ${tok("semantics_content_color")};
  border-top-left-radius: ${radius("primitives_corner_radius_xxl")};
  border-top-right-radius: ${radius("primitives_corner_radius_xxl")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};
`;
var Body3 = styled87.div`
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: calc(100vh - (${POPOVER_UPPER_SPACING} + ${TOP_TITLE_BAR_HEIGHT}));

  ${({ $hasPadding }) => $hasPadding && css54`
      padding: ${space("primitives_space_16")};
    `}
`;
var Backdrop3 = styled87(RadixPopover2.Close)`
  cursor: default;
  position: fixed;
  background: ${tok("components_backdrop_color")};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${zIndex.modalOrMobilePopover};
  @media (min-width: ${tokPx("primitives_breakpoint_s_max")}) {
    z-index: ${zIndex.popover};
  }
`;
var StyledPopoverWrapper2 = styled87.div`
  @media (min-width: ${tokPx("primitives_breakpoint_s_max")}) {
    ${PopoverContent3} {
      width: 340px;
    }

    ${StyledPopover2} {
      border-bottom-left-radius: ${radius("primitives_corner_radius_xxl")};
      border-bottom-right-radius: ${radius("primitives_corner_radius_xxl")};
    }

    ${Backdrop3} {
      opacity: 0;
    }
  }

  [data-radix-popper-content-wrapper] {
    z-index: 99 !important;

    ${({ $fullHeight }) => $fullHeight && css54`
        @media (max-width: ${tokPx("primitives_breakpoint_s_max")}) {
          &, ${PopoverContent3}, ${StyledPopover2} {
            height: 100%;
          }
          ${PopoverContent3} {
            bottom: 0;
            position: fixed;
            width: 100%;
          }
        }
      `}
  }

  @media (max-width: calc(${tokPx("primitives_breakpoint_s_max")} - 1px)) {
    [data-radix-popper-content-wrapper] {
      position: fixed !important;
      top: auto !important;
      bottom: 0 !important;
      right: 0 !important;
      transform: translate(0, 0) !important;
      min-width: auto !important;
      z-index: ${zIndex.modalOrMobilePopover} !important;
    }

    ${PopoverContent3} {
      animation-duration: 0.6s;
      animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

      &[data-side='bottom'] {
        animation-name: ${slideUp3};
      }
    }
  }
`;
var TopTitleBarRoot = styled87(TopTitleBar.Root)`
  border-top-left-radius: ${radius("primitives_corner_radius_xxl")};
  border-top-right-radius: ${radius("primitives_corner_radius_xxl")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
  ${({ $showOnDesktop }) => !$showOnDesktop && css54`
        display: none;
      `}
  }
`;
var Root35 = RadixPopover2.Root;
function Trigger11({ children }) {
  return /* @__PURE__ */ jsx651(RadixPopover2.Trigger, {
    asChild: true,
    children
  });
}
function PopContent({
  children,
  showTitleOnDesktop = false,
  title,
  hasPadding = true,
  position = "bottom",
  fullHeight = false,
  className,
  closeText,
  ...rest
}) {
  const { side, align } = PositionMap2[position];
  return /* @__PURE__ */ jsx651(RadixPopover2.Portal, {
    children: /* @__PURE__ */ jsxs548(StyledPopoverWrapper2, {
      $fullHeight: fullHeight,
      children: [
        /* @__PURE__ */ jsx651(Backdrop3, {}),
        /* @__PURE__ */ jsx651(PopoverContent3, {
          side,
          align,
          collisionPadding: 8,
          ...rest,
          className,
          children: /* @__PURE__ */ jsxs548(StyledPopover2, {
            children: [
              /* @__PURE__ */ jsxs548(TopTitleBarRoot, {
                $showOnDesktop: showTitleOnDesktop,
                children: [
                  /* @__PURE__ */ jsx651(TopTitleBar.CenterArea, {
                    title
                  }),
                  /* @__PURE__ */ jsx651(TopTitleBar.RightArea, {
                    children: /* @__PURE__ */ jsx651(RadixPopover2.Close, {
                      children: /* @__PURE__ */ jsx651(Typography_default, {
                        children: closeText
                      })
                    })
                  })
                ]
              }),
              /* @__PURE__ */ jsx651(Body3, {
                $hasPadding: hasPadding,
                children
              })
            ]
          })
        })
      ]
    })
  });
}
var Content22 = styled87(PopContent)``;

// src/uds/components/PriceArea/PriceArea.tsx
import { css as css56, styled as styled89 } from "styled-components";

// src/uds/components/Tag/Tag.tsx
import { css as css55, styled as styled88 } from "styled-components";
import { jsx as jsx652, jsxs as jsxs549 } from "react/jsx-runtime";
var Wrapper24 = styled88.div`
  flex-direction: row;
  align-items: center;
  display: inline-flex;
  justify-content: center;

  ${Icon_default} {
    margin-right: ${space("primitives_space_2")};
  }

  ${({ $size }) => modSize14($size)}
  ${({ $variant }) => modVariant6($variant)};
`;
function Tag2({ children, size, variant, icon, className }) {
  return /* @__PURE__ */ jsxs549(Wrapper24, {
    $size: size,
    $variant: variant,
    className,
    children: [
      icon && /* @__PURE__ */ jsx652(Icon_default, {
        glyph: icon,
        size: 16
      }),
      /* @__PURE__ */ jsx652(Typography_default, {
        children
      })
    ]
  });
}
function modVariant6(variantName = "primary") {
  return {
    "primary-tinted": css55`
      background-color: ${tok("primitives_color_primary_150")};
      color: ${tok("primitives_color_primary_700")};
    `,
    "primary": css55`
      background-color: ${tok("primitives_color_primary_500")};
      color: ${tok("primitives_color_neutral_0")};
    `
  }[variantName];
}
function modSize14(sizeName = "M") {
  return {
    M: css55`
      padding-top: ${tokPx("components_tag_m_padding_top")};
      padding-right: ${tokPx("components_tag_m_padding_right")};
      padding-bottom: ${tokPx("components_tag_m_padding_bottom")};
      padding-left: ${tokPx("components_tag_m_padding_left")};

      border-radius: ${tokPx("components_tag_m_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-s-bold-tight")}
      }
    `,
    S: css55`
      padding-top: ${tokPx("components_tag_s_padding_top")};
      padding-right: ${tokPx("components_tag_s_padding_right")};
      padding-bottom: ${tokPx("components_tag_s_padding_bottom")};
      padding-left: ${tokPx("components_tag_s_padding_left")};

      border-radius: ${tokPx("components_tag_s_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-xs-bold-tight")}
      }

      ${Icon_default} {
        display: none;
      }
    `
  }[sizeName];
}
var Tag_default2 = withStyleModifiers(styled88(Tag2)``, {
  modSize: modSize14
});

// src/uds/components/PriceArea/PriceArea.tsx
import { jsx as jsx653, jsxs as jsxs550 } from "react/jsx-runtime";
var Price2 = styled89(Typography_default)``;
function modSize15(sizeName = "S") {
  return {
    S: css56`
      ${Price2} {
        ${Typography_default.modVariant("display-g-regular")}
      }

      ${Tag_default2} {
        ${Tag_default2.modSize("S")}
      }
    `,
    M: css56`
      ${Price2} {
        ${Typography_default.modVariant("display-f-regular")}
      }

      ${Tag_default2} {
        ${Tag_default2.modSize("S")}
      }
    `,
    L: css56`
      ${Price2} {
        ${Typography_default.modVariant("display-c-regular")}
      }

      ${Tag_default2} {
        ${Tag_default2.modSize("M")}
      }
    `
  }[sizeName];
}
var Wrapper25 = styled89.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ $size }) => modSize15($size)}
`;
var PriceBox2 = styled89.div`
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_4")};
`;
var PreviousPriceText2 = styled89(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
  ${Typography_default} {
    text-decoration: line-through;
    color: ${tok("primitives_color_primary_500")};
  }
`;
var SupportingText3 = styled89(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
`;
function PriceArea({
  children,
  price,
  areaText,
  discounts,
  supportingText,
  size,
  className
}) {
  const hasDiscount = discounts && discounts.discountPercentage > 0 && "originalPrice" in discounts;
  return /* @__PURE__ */ jsxs550(Wrapper25, {
    $size: size,
    className,
    children: [
      hasDiscount && /* @__PURE__ */ jsx653(Tag_default2, {
        "data-ab-discount-label": "true",
        variant: "primary-tinted",
        children: `-${discounts.discountPercentage}%`
      }),
      /* @__PURE__ */ jsxs550(PreviousPriceText2, {
        $variant: "body-xs-regular-snug",
        children: [
          areaText,
          hasDiscount && /* @__PURE__ */ jsx653(Typography_default, {
            $variant: "body-s-regular-snug",
            children: discounts.originalPrice
          })
        ]
      }),
      /* @__PURE__ */ jsxs550(PriceBox2, {
        children: [
          /* @__PURE__ */ jsx653(Price2, {
            "data-qa-price-value": price,
            children: price
          }),
          children
        ]
      }),
      supportingText && /* @__PURE__ */ jsx653(SupportingText3, {
        $variant: "body-xs-regular-tight",
        children: supportingText
      })
    ]
  });
}
PriceArea.displayName = "PriceArea";
var PriceArea_default = withStyleModifiers(styled89(PriceArea)``, { modSize: modSize15 });

// src/uds/components/Rating/Rating.tsx
import { styled as styled90 } from "styled-components";
import { jsx as jsx654, jsxs as jsxs551 } from "react/jsx-runtime";
var StyledRating = styled90.div`
  svg {
    color: ${tok("primitives_color_neutral_500")};
  }
  min-width: fit-content;
`;
var S_SIZE = 16;
function Rating({ rating, ...attributes }) {
  const validValues = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
  const isRatingValid = validValues.includes(rating);
  if (!isRatingValid) {
    return null;
  }
  const fullStars = Math.floor(rating);
  const halfStars = rating - fullStars;
  return /* @__PURE__ */ jsxs551(StyledRating, {
    ...attributes,
    children: [
      Array.from({ length: fullStars }).map((_, index) => /* @__PURE__ */ jsx654(Icon_default, {
        glyph: "StarFilled",
        size: S_SIZE
      }, `full-${index}`)),
      halfStars > 0 && /* @__PURE__ */ jsx654(Icon_default, {
        glyph: "StarHalfFilled",
        size: S_SIZE
      })
    ]
  });
}
Rating.displayName = "Rating";

// src/uds/components/Sheet/Animations.tsx
import { keyframes as keyframes9 } from "styled-components";
var slideInFromRight2 = keyframes9`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
var slideOutToRight2 = keyframes9`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
var slideInFromBottom2 = keyframes9`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;
var slideOutToBottom2 = keyframes9`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;
var slideInFromLeft2 = keyframes9`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;
var slideOutToLeft2 = keyframes9`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

// src/uds/components/Sheet/Sheet.tsx
import * as DialogPrimitive3 from "@radix-ui/react-dialog";
import { css as css57, styled as styled91 } from "styled-components";
import { jsx as jsx655, jsxs as jsxs552 } from "react/jsx-runtime";
var Backdrop4 = styled91(DialogPrimitive3.Overlay)`
  position: fixed;
  background: ${tok("components_backdrop_color")};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${zIndex.backdrop};
`;
var BodyWrapper = styled91.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
`;
var FooterWrapper = styled91.div`
  margin-top: auto;
  position: sticky;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${tok("semantics_views_background_color")};

  ${({ $isFixed }) => $isFixed && modFixed2()}
`;
var ContentWrapper4 = styled91(DialogPrimitive3.Content)`
  background-color: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_5")};
  z-index: ${zIndex.sheet};
  position: fixed;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: ${tokPx("semantics_overlays_corner_radius")};

  ${({ $side, $bottomSideInMobile }) => modSide2($side, $bottomSideInMobile)}

  ${({ $hasPadding }) => $hasPadding && css57`
      ${BodyWrapper} {
        padding: ${space("primitives_space_16")};

        @media ${mqMin("primitives_breakpoint_m_min")} {
          padding: ${space("primitives_space_24")};
        }

        @media ${mqMin("primitives_breakpoint_l_min")} {
          padding: ${space("primitives_space_32")};
        }
      }

      ${FooterWrapper} {
        padding: ${space("primitives_space_12")} ${space("primitives_space_16")};

        @media ${mqMin("primitives_breakpoint_m_min")} {
          padding: ${space("primitives_space_16")} ${space("primitives_space_24")};
        }

        @media ${mqMin("primitives_breakpoint_l_min")} {
          padding: ${space("primitives_space_24")} ${space("primitives_space_32")};
        }
      }
    `}
`;
function modSide2(sideName = "right", bottomInMobile = true) {
  return {
    right: css57`
      width: 360px;
      max-width: calc(100vw - (2 * ${space("primitives_space_16")}));

      &[data-state='closed'] {
        animation: ${slideOutToRight2} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromRight2} 0.3s forwards;
      }

      @media ${mqMax("primitives_breakpoint_s_max")} {
        ${!bottomInMobile && css57`
          border-radius: initial;
        `}
        ${bottomInMobile && applyMobileBottomSideStyles()}
      }

      @media ${mqMin("primitives_breakpoint_m_min")} {
        top: ${space("primitives_space_16")};
        right: ${space("primitives_space_16")};
        max-height: calc(100vh - (2 * ${space("primitives_space_16")}));
        width: 480px;
      }
    `,
    left: css57`
      left: 0;
      right: initial;
      width: 360px;
      max-width: calc(100vw - (2 * ${space("primitives_space_16")}));

      &[data-state='closed'] {
        animation: ${slideOutToLeft2} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromLeft2} 0.3s forwards;
      }

      @media ${mqMax("primitives_breakpoint_s_max")} {
        ${!bottomInMobile && css57`
          border-radius: initial;
        `}
        ${bottomInMobile && applyMobileBottomSideStyles()}
      }

      @media ${mqMin("primitives_breakpoint_m_min")} {
        left: ${space("primitives_space_16")};
        top: ${space("primitives_space_16")};
        max-height: calc(100vh - (2 * ${space("primitives_space_16")}));
        width: 480px;
      }
    `,
    bottom: css57`
      ${applyMobileBottomSideStyles()}

      @media ${mqMin("primitives_breakpoint_m_min")} {
        width: 1280px;
        max-width: calc(100vw - (2 * ${space("primitives_space_48")}));
        height: calc(100vh - ${space("primitives_space_48")});
      }

      @media ${mqMin("primitives_breakpoint_l_min")} {
        max-width: calc(100vw - (2 * ${space("primitives_space_80")}));
        height: calc(100vh - ${space("primitives_space_80")});
      }
    `
  }[sideName];
}
function applyMobileBottomSideStyles() {
  return css57`
    width: 100%;
    height: calc(100vh - ${space("primitives_space_48")});
    bottom: 0;
    top: unset;
    left: 0;
    right: 0;
    margin: auto;
    max-width: initial;

    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;

    &[data-state='closed'] {
      animation: ${slideOutToBottom2} 0.3s forwards;
    }

    &[data-state='open'] {
      animation: ${slideInFromBottom2} 0.3s forwards;
    }
  `;
}
function modFixed2() {
  return css57`
    bottom: 0;
    border-top: 1px solid ${tok("primitives_color_neutral_100")};
  `;
}
var Root37 = DialogPrimitive3.Root;
function Trigger13({ children }) {
  return /* @__PURE__ */ jsx655(DialogPrimitive3.Trigger, {
    asChild: true,
    children
  });
}
function Footer3({ isFixed = true, children }) {
  return /* @__PURE__ */ jsx655(FooterWrapper, {
    $isFixed: isFixed,
    children
  });
}
function Header3({ titleLabel, closeLabel, children }) {
  return /* @__PURE__ */ jsxs552(TopTitleBar.Root, {
    children: [
      /* @__PURE__ */ jsx655(TopTitleBar.LeftArea, {
        children
      }),
      /* @__PURE__ */ jsx655(TopTitleBar.CenterArea, {
        title: titleLabel
      }),
      /* @__PURE__ */ jsx655(TopTitleBar.RightArea, {
        children: /* @__PURE__ */ jsx655(DialogPrimitive3.Close, {
          asChild: true,
          children: /* @__PURE__ */ jsx655(Button_default, {
            $type: "transparentPrimary",
            children: closeLabel
          })
        })
      })
    ]
  });
}
function Body4({
  side = "right",
  hasPadding = true,
  bottomSideInMobile = true,
  onChange,
  children
}) {
  return /* @__PURE__ */ jsxs552(DialogPrimitive3.Portal, {
    children: [
      /* @__PURE__ */ jsx655(Backdrop4, {}),
      /* @__PURE__ */ jsx655(ContentWrapper4, {
        $side: side,
        $hasPadding: hasPadding,
        $bottomSideInMobile: bottomSideInMobile,
        onChange,
        children
      })
    ]
  });
}
function Content24({ children }) {
  return /* @__PURE__ */ jsx655(BodyWrapper, {
    children
  });
}
var Sheet = {
  Root: Root37,
  Trigger: Trigger13,
  Body: Body4,
  Content: Content24,
  Footer: Footer3,
  Header: Header3
};

// src/uds/components/Slider/Slider.tsx
import * as SliderPrimitive2 from "@radix-ui/react-slider";
import { css as css58, styled as styled92 } from "styled-components";
import { jsx as jsx656, jsxs as jsxs553 } from "react/jsx-runtime";
var Root39 = styled92(SliderPrimitive2.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
`;
var IconContainer = styled92.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var Wrapper26 = styled92.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${tokPx("semantics_controls_m_min_height")};
  padding: ${space("primitives_space_6")} ${space("primitives_space_2")};
  background: ${tok("semantics_selectors_background_color")};
  border: ${tokPx("semantics_selectors_border_width")} solid ${tok("semantics_selectors_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};

  ${({ $disabled }) => $disabled && css58` opacity: ${tok("primitives_opacity_disabled")}%;`}
`;
var Track3 = styled92(SliderPrimitive2.Track)`
  position: relative;
  flex-grow: 1;
  border-radius: ${radius("primitives_corner_radius_s")};
  height: ${space("primitives_space_6")};
  background-color: ${tok("primitives_color_neutral_150")};
`;
var Range3 = styled92(SliderPrimitive2.Range)`
  position: absolute;
  border-radius: ${tk("radius_rounded")};
  height: 100%;
  background-color: ${tok("primitives_color_neutral_600")};
`;
var Thumb5 = styled92(SliderPrimitive2.Thumb)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokPx("components_slider_thumb_corner_radius")};
  background-color: ${tok("primitives_color_neutral_600")};

  &:hover:not([data-disabled]) {
    background-color: ${tok("primitives_color_neutral_700")};
    cursor: pointer;
  }

  ${focusOutline()}

  &:not([data-disabled]):active {
    outline: none;
    background-color: ${tok("primitives_color_neutral_700")};
  }

  &:not([data-disabled]):active:after {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: ${tokPx("components_slider_thumb_corner_radius")};
    box-shadow: 0 0 0 6px ${tok("primitives_color_neutral_600")}26;
  }

  ${Icon_default} {
    color: ${tok("semantics_content_white_color")};
    padding: ${space("primitives_space_4")} ${space("primitives_space_6")};
  }
`;
function Slider2({
  ariaLabel,
  value,
  defaultValue,
  disabled = false,
  max = 100,
  min = 0,
  minStepsBetweenThumbs = 0,
  onValueChange,
  onValueCommit,
  step = 1,
  className
}) {
  const thumbValues = defaultValue || value;
  return /* @__PURE__ */ jsxs553(Wrapper26, {
    className,
    $disabled: disabled,
    children: [
      /* @__PURE__ */ jsx656(IconContainer, {
        children: /* @__PURE__ */ jsx656(Icon_default, {
          glyph: "MinusExtraSmall"
        })
      }),
      /* @__PURE__ */ jsxs553(Root39, {
        value,
        defaultValue,
        disabled,
        max,
        min,
        minStepsBetweenThumbs,
        onValueChange,
        onValueCommit,
        step,
        children: [
          /* @__PURE__ */ jsx656(Track3, {
            children: /* @__PURE__ */ jsx656(Range3, {})
          }),
          thumbValues == null ? void 0 : thumbValues.map((_, i) => /* @__PURE__ */ jsx656(Thumb5, {
            "aria-label": ariaLabel,
            children: /* @__PURE__ */ jsx656(Icon_default, {
              glyph: "ChevronDoubleSmall",
              size: 20
            })
          }, `${i}${ariaLabel}`))
        ]
      }),
      /* @__PURE__ */ jsx656(IconContainer, {
        children: /* @__PURE__ */ jsx656(Icon_default, {
          glyph: "PlusExtraSmall"
        })
      })
    ]
  });
}
Slider2.displayName = "Slider";

// src/uds/components/Switch/Switch.tsx
import * as SwitchPrimitives2 from "@radix-ui/react-switch";
import * as React27 from "react";
import { css as css59, styled as styled93 } from "styled-components";
import { jsx as jsx657 } from "react/jsx-runtime";
var Thumb7 = styled93(SwitchPrimitives2.Thumb)`
  width: 16px;
  height: 16px;
  color: ${tok("semantics_selectors_shape_color")};
  background: ${tok("semantics_selectors_shape_color")};
  border-radius: ${radius("primitives_corner_radius_full")};
  display: block;
  transition-property: transform, background, color;
  transition-duration: 300ms;

  &[data-state='checked'] {
    transform: translateX(20px) scale(1.25);
    background: ${tok("semantics_selectors_selected_content_color")};
    color: ${tok("semantics_selectors_selected_background_color")};
  }
`;
var Wrapper27 = styled93(SwitchPrimitives2.Root)`
  width: 44px;
  height: 24px;
  background-color: ${tok("semantics_selectors_background_color")};
  border-radius: ${radius("primitives_corner_radius_full")};
  padding: ${space("primitives_space_2")};
  border-width: ${tokPx("semantics_selectors_border_width")};
  border-style: solid;
  border-color: ${tok("semantics_selectors_shape_color")};
  transition-property: background, border-color;
  transition-duration: 300ms;
  position: relative;

  &[data-state='checked'] {
    background-color: ${tok("semantics_selectors_selected_background_color")};
    border-color: ${tok("semantics_selectors_selected_background_color")};
  }

  &:hover {
    background-color: ${tok("semantics_selectors_hover_background_color")};
    border-color: ${tok("semantics_selectors_hover_shape_color")};
  }

  &[data-state='checked']:hover {
    background-color: ${tok("semantics_selectors_selected_hover_background_color")};
    border-color: ${tok("semantics_selectors_selected_hover_background_color")};

    ${Thumb7} {
      color: ${tok("semantics_selectors_selected_hover_background_color")};
    }
  }

  ${focusOutline()}
  ${({ disabled }) => disabled && modDisabled21()}
`;
function modDisabled21() {
  return css59`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
var Switch2 = React27.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx657(Wrapper27, {
  ...props,
  ref,
  children: /* @__PURE__ */ jsx657(Thumb7, {
    children: /* @__PURE__ */ jsx657(Icon_default, {
      size: 16,
      glyph: "CheckMarkExtraSmall"
    })
  })
}));
var Switch_default2 = styled93(Switch2)``;
Switch2.displayName = SwitchPrimitives2.Root.displayName;

// src/uds/components/Token/Token.tsx
import * as React28 from "react";
import { css as css60, styled as styled94 } from "styled-components";
import { jsx as jsx658, jsxs as jsxs554 } from "react/jsx-runtime";
var Text = styled94(Typography_default)``;
var RightIcon = styled94(Icon_default)`
  cursor: pointer;
  color: ${tok("semantics_content_color")};
  margin-right: -${space("primitives_space_2")};
`;
var LeftIcon = styled94(Icon_default)`
  position: absolute;
  cursor: pointer;
  color: ${tok("semantics_content_color")};
  margin-left: -${space("primitives_space_2")};
`;
var Wrapper28 = styled94.button`
  display: inline-flex;
  position: relative;
  align-items: center;

  height: 32px;
  gap: ${space("primitives_space_2")};
  padding-left: calc(${space("primitives_space_8")} + ${space("primitives_space_2")});
  padding-right: calc(${space("primitives_space_8")} + ${space("primitives_space_2")});
  white-space: nowrap;

  border-radius: ${tokPx("components_token_corner_radius")};

  user-select: none;
  outline: none;

  background: ${tok("primitives_color_neutral_100")};
  color: ${tok("semantics_content_color")};

  &:hover {
    background: ${tok("primitives_color_neutral_150")};
    color: ${tok("semantics_content_color")};
  }

  cursor: pointer;

  ${focusOutline()}

  ${({ $disabled }) => $disabled && modDisabled($disabled)}
  ${({ $hasIcon }) => $hasIcon && css60`
      ${Text} {
        margin-left: ${space("primitives_space_20")};
      }
    `}
`;
function Token({
  children,
  value,
  dismissible,
  onDismissClick,
  disabled,
  icon,
  type = "button",
  ...rest
}) {
  const [visibleDisabled, setVisibleDisabled] = React28.useState(false);
  React28.useEffect(() => {
    if (disabled) {
      const t = setTimeout(() => setVisibleDisabled(true), 0);
      return () => clearTimeout(t);
    } else {
      setVisibleDisabled(false);
    }
  }, [disabled]);
  const handleClick = React28.useCallback(
    (e) => {
      if (!disabled && dismissible && value && onDismissClick) {
        onDismissClick(value, e);
      }
    },
    [disabled, dismissible, value, onDismissClick]
  );
  return /* @__PURE__ */ jsxs554(Wrapper28, {
    type,
    $disabled: visibleDisabled,
    ...rest,
    tabIndex: !disabled ? 0 : void 0,
    onClick: handleClick,
    $hasIcon: Boolean(icon),
    children: [
      icon && /* @__PURE__ */ jsx658(LeftIcon, {
        glyph: icon,
        size: 20
      }),
      /* @__PURE__ */ jsx658(Text, {
        $variant: "body-m-regular-tight",
        children
      }),
      dismissible && value && /* @__PURE__ */ jsx658(RightIcon, {
        glyph: "DismissSmall",
        size: 20
      })
    ]
  });
}
var Token_default = styled94(Token)``;

// src/uds/index.ts
var allIconGlyphNames = Object.keys(glyphs_exports);
export {
  Accordion_exports as Accordion,
  Badge_default as Badge,
  Banner_default as Banner,
  Benefits_exports as Benefits,
  Body4 as Body,
  Breadcrumbs_default as Breadcrumbs,
  Button_default as Button,
  Checkbox,
  CheckboxField,
  Content24 as Content,
  ContentUnavailable_default as ContentUnavailable,
  DateField_default as DateField,
  Footer3 as Footer,
  Header3 as Header,
  Icon_default as Icon,
  IconCell_default as IconCell,
  IconCountryFlag_default as IconCountryFlag,
  IndeterminateProgressCircle_default as IndeterminateProgressCircle,
  InputStepper_default as InputStepper,
  Menu_exports as Menu,
  MenuItem,
  MenuLinkItem,
  PasswordField_default as PasswordField,
  PhoneField_default as PhoneField,
  Popover_exports as Popover,
  PriceArea_default as PriceArea,
  RadioButton_default as RadioButton,
  RadioButtonField,
  RadioButtonGroup,
  Rating,
  Root37 as Root,
  SearchField_default as SearchField,
  Sheet,
  Slider2 as Slider,
  Switch_default2 as Switch,
  Tag_default2 as Tag,
  TextArea_default as TextArea,
  TextField_default as TextField,
  Token_default as Token,
  TopTitleBar,
  Trigger13 as Trigger,
  Typography_default as Typography,
  allIconGlyphNames,
  countryData,
  focusOutline,
  focusWithinOutline,
  modDisabled,
  modFixed2 as modFixed,
  resetFocusOutline,
  slideInFromBottom2 as slideInFromBottom,
  slideInFromLeft2 as slideInFromLeft,
  slideInFromRight2 as slideInFromRight,
  slideOutToBottom2 as slideOutToBottom,
  slideOutToLeft2 as slideOutToLeft,
  slideOutToRight2 as slideOutToRight
};
